(function () {
  'use strict';
  angular.module('mbplus', [
    'ui.router', 'mbplus.filters', 'mbplus.utilitiesService', 'mbplus.navConstantsSvc', 'mbplus.MessagingService',
    'mbplus.safeApply', 'mbplus.userService', 'mbplus.dashBoardSearch', 'mbplus.fastrackService',
    'mbplus.governmentService', 'mbplus.newAdmissionFormService', 'mbplus.fileUploadService', 'mbplus.claimActionService', 'mbplus.profileService', 'mbplus.dateService', 'mbplus.opdCashlessService',
    'mbplus.sharedDataService', 'mbplus.plusUtilitiesService', 'mbplus.directives', 'ngTable', 'ngCookies', 'ui.calendar',
    'ui.bootstrap', 'angular-md5', 'ngAnimate', 'angulartics', 'ngSanitize', 'ngCsv', 'angulartics.google.analytics',
    'angular-loading-bar', 'blockUI', 'jkuri.gallery', 'google.places', 'uiGmapgoogle-maps',
    'angularjs-dropdown-multiselect', 'geolocation', 'gm', 'nvd3', 'ngDialog', 'ngFileUpload', 'ui-notification'
  ])
})();

angular.module('mbplus')
  .controller('otherDischargeCtrl', ['$scope', '$rootScope', '$location', '$state', '$timeout', 'UserService', 'UtilitiesService', 'filterFilter', '$uibModal', 'FastrackService', 'GovernmentService', 'FileUploadService', 'ClaimActionService', '$analytics', '$q', 'blockUI', 'Upload', function (scope, rootScope, $location, state, timeout, UserService, UtilitiesService, filterFilter, $uibModal, FastrackService, GovernmentService, FileUploadService, ClaimActionService, $analytics, $q, blockUI, Upload) {
    scope.ctrlName = 'otherDischargeCtrl';
    
    if (!UserService.isActive()) {
      UserService.destroyUserObj();
      return false;
    }
    scope.file = [];
    
    scope.discharge = {
      doa:null,
      dod:null,
      roomrent:null,
      investigation:null,
      consultation:null,
      pharmacy:null,
      others:null,
      total:null,
      claimNo: null,
      statusId: null,
      remarks: null,
      attachment: []
    }

    if (scope.ngDialogData) {
      scope.updateClaimInfo.claimNo = scope.ngDialogData.claimId;
      scope.updateClaimInfo.claimedAmount = scope.ngDialogData.claimedAmount;
      scope.updateClaimInfo.approvedamount = scope.ngDialogData.paApprovedAmount;
      scope.updateClaimInfo.statusId= String(scope.ngDialogData.otherTPAStatusId);
    }

    scope.RemoveEmail = function (index) {
      if (scope.file[index] != undefined && scope.file[index] != null) {
        scope.file.splice(index, 1);
      };
    };
    scope.startLoading = function (message, element) {
      var myBlockUI = blockUI.instances.get(element);
      myBlockUI.start({
        message: message
      });
      blockUI.noOpen = true;
    };
    scope.stopLoading = function (element) {
      var myBlockUI = blockUI.instances.get(element);
      myBlockUI.stop();
    }

    scope.uploadAllFiles=function(file)
    {
      if(file && file.files)
      {
        if(!scope.file)
        {
          scope.file=[];
        }
        
        angular.forEach(file.files,function(data){
          var i=scope.file.length+1;
          scope.file.push({fileName:data.name,fileObject:data,progressBar:null,progressDivId:'progressDiv'+i,docPath:''});
        })

        angular.forEach(scope.file,function(object){
          if(!object.docPath)
            scope.UploadFileToDMS(object.fileObject,object);
        })
       
      }
    }


    scope.UploadFileToDMS = function (file,object) {
      Upload.upload({
        url: UtilitiesService.getUrlPrefix() + '/hosp/file/DMS/upload',
        file: file
      }).then(function (res) {
          if (res.data.isSuccess) {
            uploadResponse = res.data.uploadResponseDetails;
            object.docPath= UtilitiesService.getDMSHostUrl() + "/" + uploadResponse[0].downloadURL
          
          }
        },
        function (error) {},
        function (evt) {
          // var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
          // console.log('progress: ' + progressPercentage + '% ');
          var element = angular.element(document.querySelector('#'+object.progressDivId));
          // console.log(evt);

          object.progressBar = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
          element.html('<div style="width: ' + object.progressBar + '%">' + object.progressBar + '%</div>');
          // console.log(evt.loaded);
          // console.log(evt.total);
        })
      // if(file.files && typeof(file.files)=="object")
      // {
      //   scope.startLoading('Uploading files','AttachmentArray')
      //   FileUploadService.uploadFileToUrl(file.files).onProgress(function(res){
      //     if(res)
      //     {
      //
      //     }
      //   }).then(function(res){
      //     if(res.data.isSuccess)
      //     {
      //       uploadResponse=res.data.uploadResponseDetails;
      //       if(!scope.file)
      //       {
      //         scope.file=[];
      //       }

      //       angular.forEach(uploadResponse,function(value){
      //         scope.file.push({"fileName":value.fileName,"docPath":UtilitiesService.getDMSHostUrl()+"/"+ value.downloadURL});
      //       });

      //       scope.stopLoading('AttachmentArray');
      //     }
      //   },function(error){}, function (evt) {
      //     ;
      //     var element = angular.element(document.querySelector('#dvProgress'));
      //     scope.Progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      //     element.html('<div style="width: ' + scope.Progress + '%">' + scope.Progress + '%</div>');
      // })
      // }
    }


    scope.uploadFiles = function () {
      var fileBlobArray = [];
      var filesUploadingArray = [];
      Object.keys(scope.file).forEach(function (ele) {
        if (typeof (scope.file[ele].model) == "object" || typeof (scope.file[ele]) == "object") {
          filesUploadingArray.push(scope.file[ele].model ? scope.file[ele].model : scope.file[ele]);
        }
      });
      if (filesUploadingArray.length > 0) {
        fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));

        $q.all(fileBlobArray).then(function (result) {
          result.forEach(function (element) {
            if (element.data.isSuccess) {
              angular.forEach(element.data.uploadResponseDetails, function (e, i) {
                scope.updateClaimInfo.attachment.push({
                  "fileName": e.fileName,
                  "docPath": e.downloadURL
                });
              });
              scope.updateDetails();
            }
            scope.file = [];
          });
        })
      } else {
        scope.updateDetails();
      }


    }

    scope.updateDetails = function () {
      var data = {
        "parentId": scope.ngDialogData.tableId,
        "claimAmount": scope.updateClaimInfo.claimedAmount,
        "tpaclaimno": scope.updateClaimInfo.claimNo,
        "appAmt": scope.updateClaimInfo.approvedamount,
        "status": scope.updateClaimInfo.statusId,
        "remarks": scope.updateClaimInfo.remarks,
        "actionBy": 820107,
        "attachedFiles": scope.updateClaimInfo.attachment
      }
      ClaimActionService.updateClaimInfo(data).then(function (res) {
        if (res.data.isSuccess) {
          alert("Data updated successfully");
          scope.closeModal();
        }
      });
    }

    scope.closeModal = function () {
      rootScope.$broadcast('closeUpateClaimInfoDialog', '');
    }

  }]);

angular.module('mbplus')
    .controller('walkInCashlessCtrl', ['$scope', 'OpdCashlessService', 'UtilitiesService', '$analytics', 'UserService', function (scope, OpdCashlessService, UtilitiesService, $analytics, UserService) {

        scope.customerDetailsObj = {
            search_btn: false,
            otpSent: false,
            otpVerified: false,
            sendingOtpError: false,
            otpError: false,
            enteredOtp: null,
            dob: null,
            maid: 0,
            name: null,
            mobileNo: null,
            emailId: null,
            employeeCode: null,
            corporateName: null
        }

        scope.verified = {
            'entityRelationId': UserService.getHospitalObj().entityRealtion ? (UserService.getHospitalObj().entityRealtion[0] ? UserService.getHospitalObj().entityRealtion[0].eR_ID : '') :'',
            'providerId': UserService.getHospitalObj().hospId,
            'providername': UserService.getHospitalObj().hospName,
            'userDetail': '',
            'isEmail': false,
            'otp': '',
            'accessToken': '',
            'benefDetails': [],
            'patientSelected': false
        };

        scope.hospDetails = {
            'entityRelId': UserService.getHospitalObj().entityRealtion ? (UserService.getHospitalObj().entityRealtion[0] ? UserService.getHospitalObj().entityRealtion[0].eR_ID : '') :'',
            'pincode': UserService.getHospitalObj().pinCode,
            'hospName': UserService.getHospitalObj().hospName,
            'hospUserID': UserService.getUserObj().userId,
            'hospAddress': UserService.getHospitalObj().address,
            'hospId': UserService.getHospitalObj().hospId,
            'hospCity': UserService.getHospitalObj().city,
            'accessToken': UserService.getAccessToken(),
            'services': false,
            'availableServices': {
                'healthChecks': false,
                'consultation': false,
                'labTest': false
            },
            'hcPackages': null,
            'consultPackages': null
        }

        scope.serviceCallFinish = false;
        scope.cashless = true;
        scope.sentOtpValue = null;
        scope.userValidated = false;
        scope.showSearchAgain = false;
        scope.numberCheck = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
        scope.emailCheck = /^(([^<>()[\]\\.,;:\s@\']+(\.[^<>()[\]\\.,;:\s@\']+)*)|(\'.+\'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        scope.identity = 'phone';
        scope.patientDetails = null;
        scope.serviceSelected = '';
        scope.choosePacakageSelected = false;
        scope.trackFirstSelectService = 0;
        scope.timer = 00;
        scope.viewPackDetails = false;
        scope.otherPatientClickedBool = false;
        scope.providerServicesCalled = false;
        scope.selectedLabTestPackages = [];

        // initialise the customer obj
        scope.radioBtnClicked = function () {
            scope.customerDetailsObj = {
                search_btn: false,
                otpSent: false,
                otpVerified: false,
                sendingOtpError: false,
                otpError: false,
                enteredOtp: null,
                dob: null,
                maid: 0,
                name: null,
                mobileNo: null,
                emailId: null,
                employeeCode: null,
                corporateName: null
            }
            scope.showSearchAgain = false;
        }

        scope.currentPage = 1;
        scope.itemsPerPage = 10;
        scope.maxSize = 5;
        scope.pageChange = function(val){
            scope.currentPage = val;
        }

        // to validate input
        scope.inputValidate = function () {
            if ((scope.customerDetailsObj.name) && ((scope.customerDetailsObj.mobileNo && scope.customerDetailsObj.mobileNo.match(scope.numberCheck))
                || (scope.customerDetailsObj.emailId && scope.customerDetailsObj.emailId.match(scope.emailCheck)))) {
                scope.customerDetailsObj.search_btn = true;
            }
            else if (scope.customerDetailsObj.employeeCode && scope.customerDetailsObj.corporateName && scope.customerDetailsObj.dob) {
                scope.customerDetailsObj.search_btn = true;
            }
            else scope.customerDetailsObj.search_btn = false;
        }

        // POST Call for verification of user
        scope.userValidate = function () {
            scope.verified.serviceType = scope.serviceSelected,
            scope.verified.serviceName = scope.serviceSelected == 'health_check' ? scope.packageSelected.packageValue.packageName : scope.packageSelected.packageValue.packageName + ' (' + scope.packageSelected.packageValue.doctorName + ')';
            OpdCashlessService.userVerification(scope.customerDetailsObj).then(function (response) {
                if (response.status == 200 && response.data.isSuccess) {
                    scope.verified.userDetail = (response.data.userDetail);
                    scope.userValidated = true;
                    scope.showSearchAgain = false;
                    scope.sendOtp();
                }
                else {
                    scope.showSearchAgain = true;
                    scope.userValidated = false;
                    scope.verified.userDetail = {};
                    scope.customerDetailsObj = {
                        dob: null,
                        name: null,
                        mobileNo: null,
                        employeeCode: null,
                        corporateName: null
                    }
                }
            });
        }

        // POST call for getting provider services & respective packages -------------- HOSPITAL SERVICES AND CARDS
        scope.providerServices = function () {
            scope.track = {
                event : 'Services Called',
                hospName : scope.hospDetails.hospName,
                hospId: scope.hospDetails.hospId,
                selectedService : '',
                selectedServicePrice : 0
            }
            var trackLabel = JSON.stringify(scope.track)
            $analytics.eventTrack('OPDcashless-click', {
                category: 'OPD-Cashless', label: trackLabel
              });
            UtilitiesService.startLoading('fetching services...', 'walkInCashlessService');
            OpdCashlessService.providerAvailableServices(scope.hospDetails).then(function (response) {
                UtilitiesService.stopLoading('walkInCashlessService');
                scope.serviceCallFinish = true;
                if (response.status == 200 && response.data.isSuccess) {
                    scope.providerServicesCalled = true;
                    (response.data.services).forEach(function (element) {
                        if (element.categoryItemTypeName == "HealthChecks") {
                            scope.hospDetails.availableServices.healthChecks = true;
                            scope.hospDetails.hcPackages = element;
                            (scope.hospDetails.hcPackages.categoryItems).forEach(function (singlePack) {
                                singlePack.packageFilters.forEach(function (elem) {
                                    if (elem.substring(0, 6).toLowerCase() === 'gender') {
                                        singlePack.gender = elem.split(':')[1];
                                    }
                                    else if (elem.substring(0, 6).toLowerCase() === 'maxage') {
                                        singlePack.maxAge = elem.split(':')[1];
                                    }
                                    else if (elem.substring(0, 6).toLowerCase() === 'minage') {
                                        singlePack.minAge = elem.split(':')[1];
                                    }
                                })
                            })
                        }
                        else if (element.categoryItemTypeName == 'Consultation') {
                            scope.hospDetails.availableServices.consultation = true;
                            scope.hospDetails.consultPackages = element;
                            scope.hospDetails.consultPackages.distinctTypes =
                                (scope.hospDetails.consultPackages.categoryItems).map(function (element) {
                                    return element.doctorSpecialization;
                                })
                            scope.hospDetails.consultPackages.distinctTypes = Array.from(new Set(scope.hospDetails.consultPackages.distinctTypes));
                        }
                        else if (element.categoryItemTypeName == 'Investigation') {
                            scope.hospDetails.availableServices.labTest = true;
                            scope.hospDetails.labTestPackages = element;
                            scope.hospDetails.labTestPackages.displayCards = JSON.parse(JSON.stringify(element.categoryItems));
                            scope.totalItems = element.categoryItems.length;
                        }
                    })
                    if (scope.hospDetails.hcPackages) {
                        scope.hcPackGender = "N"
                        scope.searchCardsHealth(scope.hcPackGender);
                    }
                    if (scope.hospDetails.consultPackages) {
                        var firstSpeciality = scope.hospDetails.consultPackages.distinctTypes[0];
                        scope.selectedConsultationCategory = firstSpeciality;
                        scope.searchCardsConsultation(firstSpeciality);
                    }

                    if (scope.hospDetails.availableServices.healthChecks) {
                        scope.selectService('health_check');
                    }
                    else if (scope.hospDetails.availableServices.consultation) {
                        scope.selectService('consultation');
                    }
                    else if (scope.hospDetails.availableServices.labTest) {
                        scope.selectService('labTest');
                    }
                }
            })
        }

        window.onload = scope.providerServices();

        // consultation packages
        scope.searchCardsConsultation = function (value) {
            scope.selectedConsultationCategory = value;
            scope.hospDetails.consultPackages.displayCards = (scope.hospDetails.consultPackages.categoryItems).filter(function (element) {
                return (element.doctorSpecialization == value ? element : "");
            });
        }

        // health check packages
        scope.searchCardsHealth = function (value) {
            if (value == 'N') {
                scope.hospDetails.hcPackages.displayCards = scope.hospDetails.hcPackages.categoryItems;
            }
            else {
                scope.hospDetails.hcPackages.displayCards = (scope.hospDetails.hcPackages.categoryItems).filter(function (element) {
                    if ((element.gender != "M") && (element.gender != "F")) {
                        return (element);
                    }
                    else {
                        return (element.gender == (value) ? element : "");
                    }
                });
            }
        }

        // tracking selected service and in consult displaying cards based on specialization
        scope.selectService = function (value) {
            
            scope.serviceSelected = value;
            if(scope.hospDetails.availableServices.labTest) {
                scope.labTestPackageClear();
            }
        }

        // after clicking choose on a package card
        scope.packageClicked = function (value) {

            scope.track = {
                event : 'Package Selected',
                selectedService  : value.packageName,
                selectedServicePrice  : value.price
            }
            var trackLabel = JSON.stringify(scope.track)
            $analytics.eventTrack('OPDcashless-click', {
                category: 'OPD-Cashless', label: trackLabel
              });

            scope.packageSelected = {
                packageValue: null,
                details: null,
                maxAge: null,
                minAge: null,
                dayTimeSlotArr: null,
                availableSlots: null,
                date: null,
                time: null
            };
            scope.daySelected = false;
            scope.timeSelected = false;
            scope.choosePacakageSelected = true;
            scope.openDateTime = true;

            scope.nextSevenDays = OpdCashlessService.getNextSevenDays();
            scope.packageSelected.packageValue = value;
            
            if(scope.serviceSelected == 'labTest') {
                scope.totalAmount = 0;
                scope.selectedLabTestPackages.forEach(function(elem){
                    scope.totalAmount = scope.totalAmount + elem.price;
                })
            }

            scope.packageSelected.availableSlots = [];
            (scope.packageSelected.packageValue.availableSlots).forEach(function (element) {
                if (!element.slots) {
                    scope.packageSelected.availableSlots[element.day] = { 'day': element.day, 'dayOfWeek': element.dayOfWeek, 'slots': [] };
                }
                else {
                    var arr = [];
                    for (var i = 0; i < (element.slots).length; i++) {
                        var start = OpdCashlessService.getTimeFormat(element.slots[i].slotStartTime);
                        var end = OpdCashlessService.getTimeFormat(element.slots[i].slotEndTime);
                        var slotsNumber = (element.slots[i].slotEndTime - element.slots[i].slotStartTime) / 30;
                        arr[i] = { 'startTime': start, 'endTime': end, 'numberOfSlots': slotsNumber };
                    }
                    scope.packageSelected.availableSlots[element.day] = { 'day': element.day, 'dayOfWeek': element.dayOfWeek, 'slots': arr };
                };
            })

            if ((scope.packageSelected.packageValue.availableSlots).length < 7) {
                for (var i = 0; i < 7; i++) {
                    if (!(scope.packageSelected.availableSlots[i])) {
                        scope.packageSelected.availableSlots[i] = { 'day': i, 'dayOfWeek': null, 'slots': [] };
                    }
                }
            }

            scope.firstAvail = scope.nextSevenDays.find(function (elem) {
                if ((scope.packageSelected.availableSlots[elem.dayCount].slots).length) {
                    return elem;
                }
            })

            scope.daySlotClicked(scope.packageSelected.availableSlots[scope.firstAvail.dayCount], scope.firstAvail.fullDate);
        }

        //lab test package adding
        scope.labTestPackageClicked = function(value,index) {
            value.selected = true;
            scope.selectedLabTestPackages.push(value);
        }

        scope.removeLabTestPack = function(val) {
            scope.selectedLabTestPackages[val].selected = false;
            scope.selectedLabTestPackages.splice(val,1);
        }

        scope.labTestPackageClear = function(){
            scope.selectedLabTestPackages = [];
            scope.hospDetails.labTestPackages.displayCards = JSON.parse(JSON.stringify(scope.hospDetails.labTestPackages.categoryItems));
            scope.totalItems = scope.hospDetails.labTestPackages.displayCards.length;
        }

        // on change package/doctor
        scope.selectedPackageClickedAgain = function () {
            scope.packageSelected = null;
            scope.choosePacakageSelected = false;
            scope.timeSelected = false;
            scope.daySelected = false;
            scope.timeSelectedShow = false;
        }

        // on details click of health check pack
        scope.detailsClicked = function (value) {
            if (scope.details && value.packageId == scope.details.selectedCard.packageId && scope.viewPackDetails == true) {
                scope.viewPackDetails = false;
            }
            else {
                scope.viewPackDetails = true;
            }

            OpdCashlessService.packageDetail(value.packageId).then(function (response) {
                if (response.status == 200 && response.data.isSuccess) {
                    scope.details = response.data;
                    scope.details.tests = [];
                    scope.details.consults = [];
                    (scope.details.packageTestGroupDetails).forEach(function (element) {
                        if (element.name != "Consultation") {
                            scope.details.tests.push(element);
                        }
                        else {
                            scope.details.consults.push(element);
                        }
                    })
                }
                scope.details.selectedCard = value;
            })
        }

        // on day selection calculate real time slots
        scope.daySlotClicked = function (value, dateVal) {
            scope.timeSelected = false;
            scope.packageSelected.time = null;
            if ((value.slots).length) {
                scope.daySelected = true;
                scope.packageSelected.date = dateVal;
                scope.packageSelected.dayTimeSlotArr = [];
                for (var x = 0; x < (value.slots).length; x++) {
                    var start = value.slots[x].startTime;
                    var end = value.slots[x].endTime;
                    var startTimeArr = start.split(" ");
                    startTimeArr[0] = startTimeArr[0] + ':' + '00';
                    var startTime = startTimeArr[0] + ' ' + startTimeArr[1];
                    var endTimeArr = end.split(" ");

                    var currentDate = new Date();
                    var currentDayString = currentDate.toDateString();
                    if (currentDayString == scope.packageSelected.date) {
                        var currentTime = moment(new Date()).format("hh:mm:ss A");
                        var currentSecs = OpdCashlessService.convertToSecs(currentTime);
                        var compareSecs = OpdCashlessService.convertToSecs(startTime);
                        if (currentSecs < compareSecs) {
                            var convertedTime = moment(startTime, 'hh:mm:ss A').format("hh:mm A");
                            scope.packageSelected.dayTimeSlotArr.push(convertedTime);
                        }
                    }
                    else {
                        var convertedTime = moment(startTime, 'hh:mm:ss A').format("hh:mm A");
                        scope.packageSelected.dayTimeSlotArr.push(convertedTime);
                    }

                    for (var i = 0; i < value.slots[x].numberOfSlots; i++) {
                        var time = moment(startTime, 'hh:mm:ss A')
                            .add(00, 'seconds')
                            .add(30, 'minutes')
                            .format('LTS');
                        if (currentDayString == scope.packageSelected.date) {
                            var compareSecs = OpdCashlessService.convertToSecs(time);
                            if (currentSecs < compareSecs) {
                                var convertedTime = moment(time, 'hh:mm:ss A').format("hh:mm A");
                                scope.packageSelected.dayTimeSlotArr.push(convertedTime);
                            }
                        }
                        else {
                            var convertedTime = moment(time, 'hh:mm:ss A').format("hh:mm A");
                            scope.packageSelected.dayTimeSlotArr.push(convertedTime);
                        }
                        startTime = time;
                    }
                }
            }
            else {
                scope.daySelected = false;
                scope.packageSelected.date = null;
                scope.packageSelected.dayTimeSlotArr = null;
            }
        }

        // on time selection for a particular day
        scope.timeSlotClicked = function (value, index) {
            scope.timeSelectedIndex = index;
            scope.timeSelected = true;
            scope.packageSelected.time = value;
            scope.timeSelectedShow = true;
            scope.openDateTime = false;
            // scope.radioBtnClicked();
        }

        // on change timings
        scope.appointmentCardClicked = function () {
            scope.timeSelected = false;
            scope.daySelected = false;
            scope.packageSelected.time = null;
            scope.packageSelected.date = null;
            scope.timeSelectedShow = false;
            scope.openDateTime = true;
            scope.daySlotClicked(scope.packageSelected.availableSlots[scope.firstAvail.dayCount], scope.firstAvail.fullDate);
        }

        // POST call to send otp for user 
        scope.sendOtp = function () {
            scope.track = {
                event : 'OTP Sent',
                user : scope.verified.userdetail
            }
            var trackLabel = JSON.stringify(scope.track)
            $analytics.eventTrack('OPDcashless-click', {
                category: 'OPD-Cashless', label: trackLabel
              });

            OpdCashlessService.sendOtpRequest(scope.verified).then(function (response) {
                if (response.status == 200) {
                    scope.customerDetailsObj.sendingOtpError = false;
                    scope.verified.accessToken = response.data.accessToken;
                    scope.customerDetailsObj.otpSent = true;
                    scope.customerDetailsObj.enteredOtp = null;
                    scope.customerDetailsObj.otpError = false;
                }
                else {
                    scope.customerDetailsObj.otpSent = false;
                    scope.customerDetailsObj.sendingOtpError = true;
                }
            })
        }

        // POST call to verify otp enetered
        scope.verifyOtp = function () {
            scope.track = {
                event : 'Customer Verified'
            }
            var trackLabel = JSON.stringify(scope.track)
            $analytics.eventTrack('OPDcashless-click', {
                category: 'OPD-Cashless', label: trackLabel
              });

            scope.verified.otp = scope.customerDetailsObj.enteredOtp;
            OpdCashlessService.verifyOtpRequest(scope.verified).then(function (response) {
                if (response.status == 200 && response.data.isSuccess) {
                    scope.customerDetailsObj.otpVerified = true;
                    scope.customerDetailsObj.otpError = false;
                    scope.verified.benefDetails = response.data.benefDetails ? response.data.benefDetails : [];
                    if ((scope.verified.benefDetails).length) {
                        (scope.verified.benefDetails).forEach(function (element) {
                            element.isSelected = true;
                        })
                    }
                    scope.verified.userDetail.minifiedToken = response.data.minifiedAccessToken;
                    scope.verified.userDetail.accessToken = response.data.accessToken;
                }
                else {
                    scope.customerDetailsObj.otpVerified = false;
                    scope.customerDetailsObj.otpError = true;
                    scope.verified.otp = null;
                    scope.customerDetailsObj.enteredOtp = null;
                }
            })
        }

        //to validate other patient input fields
        scope.othersInputValidate = function () {
            if ((scope.otherPatient.patientName) && (scope.otherPatient.dob) && (scope.otherPatient.gender) && (scope.otherPatient.relation)) {
                scope.otherPatient.submitBtn = true;
            }
            else scope.otherPatient.submitBtn = false;
        }

        //on other patients add click
        scope.otherCardClicked = function () {
            
            scope.otherPatientClickedBool = (!(scope.otherPatientClickedBool));
            scope.otherPatient = {
                patientName: null,
                isSelected: true,
                dob: null,
                age: null,
                gender: null,
                maid: 0,
                relation: null,
                submitBtn: false
            }
            scope.verified.patientSelected = false;
            scope.patientDetails = null;
        }

        //on adding new patient fields and submit
        scope.addPatientManual = function () {
            scope.track = {
                event : 'Other Patient Addded'
            }
            var trackLabel = JSON.stringify(scope.track)
            $analytics.eventTrack('OPDcashless-click', {
                category: 'OPD-Cashless', label: trackLabel
              });

            scope.otherPatientClickedBool = false;
            scope.otherPatient.age = OpdCashlessService.getAge(scope.otherPatient.dob);
            scope.verified.benefDetails[(scope.verified.benefDetails).length] = JSON.parse(JSON.stringify(scope.otherPatient));
        }

        //tracking patient card selection
        scope.updatePatientObj = function (value, typ) {

            scope.track = {
                event : 'Patient Selected',
                selectedPatient : value 
            }
            var trackLabel = JSON.stringify(scope.track)
            $analytics.eventTrack('OPDcashless-click', {
                category: 'OPD-Cashless', label: trackLabel
              });

            var clickedValue = value;
            scope.otherPatientClickedBool = false;

            if (scope.verified.benefDetails) {
                (scope.verified.benefDetails).forEach(function (element) {
                    if (element.patientName != clickedValue.patientName) {
                        element.isSelected = (!(element.isSelected));
                    }
                })
            }
            scope.verified.patientSelected = true;
            scope.patientDetails = value;
        }

        //POST call for checkout
        scope.checkout = function () {

            scope.track = {
                event : 'Patient Confirmed - Checkout Called'
            }
            var trackLabel = JSON.stringify(scope.track)
            $analytics.eventTrack('OPDcashless-click', {
                category: 'OPD-Cashless', label: trackLabel
            });

            scope.packageSelected.prefDateTime = new Date(scope.packageSelected.date + ' ' + scope.packageSelected.time);
            var cart = [];
            if(scope.serviceSelected == 'labTest'){
                scope.selectedLabTestPackages.forEach(function(elem,indx){
                    cart[indx] = {
                        "patientName": scope.patientDetails.patientName ? scope.patientDetails.patientName : scope.patientDetails.userName,
                        "email": scope.verified.userDetail.encryptedEmailId,
                        "phone": scope.verified.userDetail.encryptedMobileNo,
                        "emergencyPhone": null,
                        "dateOfBirth": scope.patientDetails.dob ? scope.patientDetails.dob : null,
                        "gender": scope.patientDetails.gender ? scope.patientDetails.gender : null,
                        "packageId": elem.packageId,
                        "packageName": elem.packageName,
                        "dcId": elem.dcId,
                        "dcName": elem.dcName,
                        "prefDateTime": scope.packageSelected.prefDateTime,
                        "isSponsored": false,
                        "visitType": "DiagnosticCenter",
                        "addressLine1": null,
                        "addressLine2": null,
                        "couponCode": null,
                        "citySelected": elem.dcCity,
                        "totalPrice": elem.price,
                        "discount": 0,
                        "finalPrice": elem.price,
                        "relation": scope.patientDetails.relation ? scope.patientDetails.relation : null,
                        "pincode": scope.hospDetails.pincode,
                        "remark": null,
                        "doctorId": elem.doctorUniqueId,
                        "uploadedFiles": [],
                        "addressType": null,
                        "hospitalRegistrationNo": null,
                        "docName": elem.doctorName,
                        "maid": scope.patientDetails.maid ? scope.patientDetails.maid : 0,
                        "isCashless": false,
                        "isPickupFromStore": false,
                        "pickupStoreID": null,
                        "behalfOfUserId": scope.hospDetails.hospUserID
                    }
                })
            }
            else {
                cart[0] = {
                    "patientName": scope.patientDetails.patientName ? scope.patientDetails.patientName : scope.patientDetails.userName,
                    "email": scope.verified.userDetail.encryptedEmailId,
                    "phone": scope.verified.userDetail.encryptedMobileNo,
                    "emergencyPhone": null,
                    "dateOfBirth": scope.patientDetails.dob ? scope.patientDetails.dob : null,
                    "gender": scope.patientDetails.gender ? scope.patientDetails.gender : null,
                    "packageId": scope.packageSelected.packageValue.packageId,
                    "packageName": scope.packageSelected.packageValue.packageName,
                    "dcId": scope.packageSelected.packageValue.dcId,
                    "dcName": scope.packageSelected.packageValue.dcName,
                    "prefDateTime": scope.packageSelected.prefDateTime,
                    "isSponsored": false,
                    "visitType": "DiagnosticCenter",
                    "addressLine1": null,
                    "addressLine2": null,
                    "couponCode": null,
                    "citySelected": scope.packageSelected.packageValue.dcCity,
                    "totalPrice": scope.packageSelected.packageValue.price,
                    "discount": 0,
                    "finalPrice": scope.packageSelected.packageValue.price,
                    "relation": scope.patientDetails.relation ? scope.patientDetails.relation : null,
                    "pincode": scope.hospDetails.pincode,
                    "remark": null,
                    "doctorId": scope.packageSelected.packageValue.doctorUniqueId,
                    "uploadedFiles": [],
                    "addressType": null,
                    "hospitalRegistrationNo": null,
                    "docName": scope.packageSelected.packageValue.doctorName,
                    "maid": scope.patientDetails.maid ? scope.patientDetails.maid : 0,
                    "isCashless": false,
                    "isPickupFromStore": false,
                    "pickupStoreID": null,
                    "behalfOfUserId": scope.hospDetails.hospUserID
                }
            }

            scope.checkoutObj = {
                'cartItems': cart,
                'userDetail': scope.verified.userDetail
            };

            OpdCashlessService.checkoutCall(scope.checkoutObj).then(function (response) {
                if (response.status == 200 && response.data.isSuccess) {
                    scope.checkoutCalled = true;
                    scope.paymentObj = response.data;
                    if (scope.paymentObj.paymentOptions) {
                        scope.paymentObj.payment = [];
                        (scope.paymentObj.paymentOptions).forEach(function (elem) {
                            if (elem.walletName && (elem.walletName == ("MAWallet") || ("MBWallet")) && elem.walletAmount > 0) {
                                scope.paymentObj.payment.push(elem.paymentMethod);
                                scope.paymentObj.totalAmt = elem.totalAmount;
                                scope.paymentObj.walletAmt = elem.walletAmount;
                                scope.paymentObj.customerPayableAmt = scope.paymentObj.totalAmt - scope.paymentObj.walletAmt;
                            }
                        })
                    }
                    if (!scope.paymentObj.payment.length) {
                        scope.paymentObj.payment.push('PG');
                        scope.paymentObj.totalAmt = scope.paymentObj.paymentOptions ? scope.paymentObj.paymentOptions[0].totalAmount : 0;
                        scope.paymentObj.walletAmt = 0;
                        scope.paymentObj.customerPayableAmt = scope.paymentObj.totalAmt - scope.paymentObj.walletAmt;
                    }
                }
            })
        }

        //POST call for payment
        scope.paymentCalled = function () {
            var serviceName;
            if(scope.serviceSelected == ('health_check')) {
                serviceName = scope.packageSelected.packageValue.packageName;
            }
            else if (scope.serviceSelected == ('labTest')) {
                serviceName = [];
                scope.checkoutObj.cartItems.forEach(function(elem,ind){
                    serviceName[ind] =  elem.packageName;
                })
                serviceName = serviceName.join(",");
            }
            else if (scope.serviceSelected == ('consultation')) {
                serviceName = scope.packageSelected.packageValue.packageName + ' (' + scope.packageSelected.packageValue.doctorName + ')';
            }

            scope.paymentObject = {
                'serviceType': scope.serviceSelected,
                'serviceName': serviceName,
                'appointmentDatetime': scope.packageSelected.date + ' ' + scope.packageSelected.time,
                'packageAmount': scope.paymentObj.totalAmt,
                'walletAmount': scope.paymentObj.walletAmt,
                'balanceAmount': scope.paymentObj.customerPayableAmt,
                'hospname': scope.verified.providername,
                "paymentMethods": scope.paymentObj.payment,
                "userAccessToken": scope.verified.userDetail.accessToken,
                "minifiedToken": scope.verified.userDetail.minifiedToken,
                "userDetail": scope.verified.userDetail,
                "accessToken": scope.hospDetails.accessToken
            };

            scope.track = {
                event : 'Payment Called',
                paymentObj : scope.paymentObject
            }
            var trackLabel = JSON.stringify(scope.track)
            $analytics.eventTrack('OPDcashless-click', {
                category: 'OPD-Cashless', label: trackLabel
              });

            OpdCashlessService.paymentCall(scope.paymentObject).then(function (response) {
                if (response.status == 200 && response.data.isSuccess) {
                    scope.createdOrder = response.data;
                    scope.isOrderCreated = true;

                    scope.track = {
                        event : 'OrderId - Payment response',
                        orderId : scope.createdOrder.orderNumber
                    }
                    var trackLabel = JSON.stringify(scope.track)
                    $analytics.eventTrack('OPDcashless-click', {
                        category: 'OPD-Cashless', label: trackLabel
                      });

                }
                else {
                    scope.isOrderCreated = false;
                }

            });
        }

        // to print the payment receipt
        scope.print = function () {
            window.print();
        }
    }]);
angular.module('mbplus')
.controller('userManageCtrl', ['$rootScope', '$scope', '$location', '$window','UserService', 'UtilitiesService', 'filterFilter', function ($rootScope, scope, $location, $window, UserService, UtilitiesService, filterFilter) {
    UserService.checkForSession();
    scope.isAddUser = false;
    scope.resetObje = function(){
        scope.update = {
              userEmail : '',
                updateUserRole : '',
                updateStatus : ''
            };
            scope.isError = false;
            scope.newuser = {
                emailid:'',
                firstname:'',
                lastname:'',
                password:'',
                confirmpassword:''
            };
    };
    scope.resetObje();
    scope.selectedRolesForAdd = [];
    scope.user = UserService.getUserObj();

    //Combined role id's
    scope.combinedRoleIds = function (roles) {
        var selectedRoleIds = [];
        if (roles && roles.length > 0) {
            angular.forEach(roles, function (value, index) {
                selectedRoleIds.push(value.id)
            });
        }
        return selectedRoleIds;
    };

    if (UserService.checkForAdminUser()) {
        scope.isAddUser = true;
        var data = { accessToken: UserService.getAccessToken(), applicationID: '5385' };
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/user/RolesToMap/', data, 'POST').then(function (response) {
            if (response.data.isSuccess) {
                scope.newRoles = response.data.roles
                var roleData = [];
                angular.forEach(scope.newRoles, function (e1, i1) {
                    var result = { id: e1.id, label: e1.name };
                    roleData.push(result)
                });
                scope.newRoles = roleData;
            }
        })
    }
    scope.numberOfAdmin = [];
    //Get all user details
    scope.getAllUsers = function (hospId) {
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/user/entityusers.json?hospId=' + hospId, '', 'GET').then(function (response) {
            if (response.data.isSuccess) {
                scope.data = response.data;
                scope.numberOfAdmin = scope.data.users.filter(function(role) {
                    if(role.role === "Admin"){
                        return role;
                    }
                })
                angular.forEach(scope.data.users, function (e, i) {
                    var roleData = [];
                    scope.data.users[i].editing = false;
                    angular.forEach(e.userRoles, function (e1, i1) {
                        var result = { id: e1.id, label: e1.name };
                        roleData.push(result)
                    });
                    scope.data.users[i].newRolesData = roleData;

                });
                if (scope.data && scope.data.users) {
                    scope.userCount = scope.data.users.length;
                }
            }
            else {
                scope.errorMsg = 'Unable to find users.';
            }
        });
    };

    //Update user details
    scope.updateUser = function (userName, event) {
        if (UserService.checkForAdminUser()) {
            if (scope.combinedRoleIds(userName.userRoles).length > 0) {
                var data = {
                    userId: userName.userId,
                    roleIds: scope.combinedRoleIds(userName.userRoles),
                    emailId: scope.update.userEmail,
                    isActive: scope.update.updateStatus,
                    hospId: userName.entityId,
                    updatedBy: scope.user.userId,
                    accessToken: UserService.getAccessToken()
                }
                UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/user/edit', data, 'POST').then(function (response) {
                    if (response) {
                        scope.resetObje();
                        scope.editing = false;
                        UtilitiesService.showAlertMessage('User updated successfully!', true);
                        scope.getAllUsers(scope.user.entityId);
                    }
                });
            } else {
                UtilitiesService.showAlertMessage('Please select role.');
            }
        }
        else {
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        }
    };

    //Create new User
    scope.addUser = function () {
      scope.isError = false;
        if (UserService.checkForAdminUser()) {
            if ((scope.newuser.password === scope.newuser.confirmpassword) && scope.combinedRoleIds(scope.selectedRolesForAdd).length > 0) {
                if (scope.newuser.firstname && scope.newuser.lastname && scope.newuser.emailid && scope.newuser.password && scope.selectedRolesForAdd) {
                    var data = {
                        userId: 0,
                        userName: scope.newuser.emailid,
                        firstName: scope.newuser.firstname,
                        lastName: scope.newuser.lastname,
                        email: scope.newuser.emailid,
                        password: scope.newuser.password,
                        roleIds: scope.combinedRoleIds(scope.selectedRolesForAdd),
                        hospId: scope.user.entityId,
                        createdBy: scope.user.userId
                    }
                    UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/user/add', data, 'POST').then(function (response) {
                            if (response.data.isSuccess) {
                                scope.resetObje();
                                angular.element("#addUserModal").modal('hide');
                                UtilitiesService.showAlertMessage('User created successfully!', true);
                                scope.getAllUsers(scope.user.entityId);
                            }else{
                                scope.isError = true;
                                scope.errorText = 'Unable to create user, please try again.';
                            }
                        },function (error) {
                            scope.isError = true;
                            scope.errorText = 'oops! something went wrong, please try again later.';
                    });
                }
                else {
                    scope.isError = true;
                    scope.errorText = 'All fields should be filled.';
                }
            }
            else {
                scope.isError = true;
                scope.errorText = 'Passwords didn\'t match.';
            }
        }
        else {
            scope.isError = true;
            cope.errorText = 'You don\'t have sufficient privileges';
        }
    };

    //Close edit button
    scope.closeEdit = function(row,index){
        angular.forEach(scope.data.users, function(k,v){
            if(k.userId === row.userId){
                scope.data.users[v].editing = false;
            }
        });
        scope.resetObje();
    };

    //Edit user details
    scope.editUser = function (row,index) {
        scope.data.users[index].editing = !scope.data.users[index].editing;
        angular.forEach(scope.data.users, function(value, i){
            if(value.userId === row.userId){
               scope.data.users[i].editing = true;
            }else{
               scope.data.users[i].editing = false;
            }
        })
        scope.update.userEmail = row.userEmail;
        scope.update.updateUserRole = row.roleId;
        scope.update.updateStatus = row.isActive ? 'true' : 'false';
    };

    if (scope.user && scope.user.isActive) {
        scope.getAllUsers(scope.user.entityId);
    }

}]);
angular.module("mbplus")
.controller('UnapprovedNewAdmissionController', ['$scope', '$rootScope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics', 'PlusUtilitiesService', function (scope, $rootScope, $location, UserService, UtilitiesService, filterFilter, $analytics, PlusUtilitiesService) {
  $analytics.pageTrack('/appointments');
  if (!UserService.isActive()) {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }
  $rootScope.plusAppointmentsSearch = '';
  $rootScope.dcInvestigations = '';
  $rootScope.dcInvestigationsMap = '';
  $rootScope.eSaleQueue = '';
  scope.ctrlName = "UnapprovedNewAdmissionController";
  scope.user = UserService.getUserObj();
  scope.formatTime = UtilitiesService.formatTime;
  scope.compareDate = UtilitiesService.compareDate;

    scope.popupQc ={
        opened: false,
        actualDate: ''
    }

    scope.openQcDate = function(){
        scope.popupQc.opened = true;
    };
  scope.loadAppointments = function (id, name) {
    var providerId = null;
    scope.providerName = "";
    if (id && name) {
      providerId = id;
      scope.providerName = name;
    }
    var data = {
      "requestType": "Appointment",
      "ProviderId": providerId,
      "hashtagFilters": {},
      "requestAccessToken": UserService.getAccessToken(),
      "userAgent": "String",
      "ipAddress": "String"
    }
    scope.statusColors = {
      22: "btn-success",
      42: "btn-danger"
    }
    var url = UtilitiesService.getPlusUrlPrefix() + "/unapprovedAppointments/";
    scope.appointmentsCount = 0;
    UserService.makeRestCall(url, data, "POST", UserService.getAccessToken()).then(function (response) {
      if (response.data.isSuccess) {
        scope.activeAppointments = response.data;

        UserService.activeAppointmentsDummyData = response.data;

        scope.appointments = new Array();
        $.each(response.data.orderItems, function (key, value) {
          value.requestId = key;
          scope.appointments.push(value);
        });
        scope.activeAppointments = scope.appointments;
        UserService.activeAppointmentsDummyDataCollection = scope.appointments;
      }
      else {
        scope.hasNoResults = true;
        scope.loading = false;
      }
    })
  };

  scope.setOrderItemId = function (id) {
    scope.orderItemId = id;
  };

  scope.unApprovedActionRequest = function (isapprove, id, managerComnt) {
    var data = {
      "orderItemId": scope.orderItemId ? scope.orderItemId : (id ? id : ""),
      "isApproved": isapprove
    };
    data.managerComment = managerComnt ? managerComnt : "";
    UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/unapprovedOrderItemAction", data, "POST", UserService.getAccessToken()).then(function (response) {
      if (response.data.isSuccess) {
        scope.loadAppointments();
      }
      else {
          UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
      }
    });
  };

  scope.$watch('plusAppointmentsSearch', function (current, old) {
    if (current) {
      scope.activeAppointments = UserService.GetFilteredAppointmentUnapprovedNewAppointments(current);
    } else {
      if (old) {
        scope.activeAppointments = UserService.activeAppointmentsDummyDataCollection;
      }
    }
  });

  angular.element(document).ready(function () {
    scope.loadAppointments();
  });
}]);

angular.module("mbplus")
.controller('unconfirmedorderController', ['$scope', '$rootScope', 'UserService', 'PlusUtilitiesService', 'UtilitiesService', function (scope, rootScope, UserService, PlusUtilitiesService, UtilitiesService) {

  rootScope.plusAppointmentsSearch = '';
  rootScope.dcInvestigations = '';
  rootScope.dcInvestigationsMap = '';
  rootScope.eSaleQueue = '';
  UserService.checkForSession();

  //Load unconfirmed order list
  scope.loadUnconfirmedOrder = function () {
    UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/cartOrders/', { requestAccessToken: UserService.getAccessToken() }, 'POST', UserService.getAccessToken()).then(function (response) {
      if (response.data.isSuccess) {
        scope.activeAppointments = response.data;
        UserService.activeAppointmentsDummyData = response.data;
        UserService.activeAppointmentsDummyDataCollection = response.data.cartOrders;
      }
    })
  };

  //Called from tab controller for open action model popup
  scope.actionRequest = function (id, approve) {
    scope.actionRequestId = id
    scope.actionRequestApprove = approve;
    if (approve) {
      angular.element('#ApproveModal').appendTo('body');
      angular.element('#ApproveModal').modal('show');
    }
    else {
      angular.element('#CancelModal').appendTo('body');
      angular.element('#CancelModal').modal('show');
    }
  };

  //Update request
  scope.actionRequestModal = function (flag, modalType) {
    if (flag) {
      var data = {
        cartId: scope.actionRequestId,
        isApproved: scope.actionRequestApprove
      };
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'cartOrderAction', data, 'POST', UserService.getAccessToken()).then(function (response) {
        angular.element('#CancelModal').modal('hide');
        angular.element('#ApproveModal').modal('hide');
        if (response.data.isSuccess) {
          if (modalType == 'ApproveModal') {
            UtilitiesService.showAlertMessage('Successfully approved request.', true);
          }
          if (modalType == 'CancelModal') {
            UtilitiesService.showAlertMessage('Successfully raised cancellation request.',true);
          }
          scope.loadUnconfirmedOrder();
        }
        else {
          angular.element('#CancelModal').modal('hide');
          angular.element('#ApproveModal').modal('hide');
          UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        }
      });
    }
  };

  //Search filter using header inputs
  scope.$watch('plusAppointmentsSearch', function (current, old) {
    if (current) {
      scope.activeAppointments = UserService.GetFilteredAppointmentUnConfirmedOrder(current);
    } else {
      if (old) {
        UserService.activeAppointmentsDummyData.cartOrders = UserService.activeAppointmentsDummyDataCollection;
        scope.activeAppointments = UserService.activeAppointmentsDummyData;
      }
    }
  });
  
  //Call load unconfirmed order
  scope.loadUnconfirmedOrder();
}]);

angular.module("mbplus")
.controller('unApprovedPPController', ['$scope', '$rootScope', 'UserService', 'UtilitiesService','PlusUtilitiesService','orderByFilter', function (scope, $rootScope, UserService, UtilitiesService, PlusUtilitiesService,orderByFilter ) {

    scope.remarks = '';
    $rootScope.plusAppointmentsSearch = '';
    $rootScope.dcInvestigations = '';
    $rootScope.dcInvestigationsMap = '';
    $rootScope.eSaleQueue = '';
    if (!UserService.isActive()) {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    scope.isPhotoAvailble = {
        value: 'false'
    }
        // Disable weekend selection
    function disabled(data) {
        var date = data.date,
          mode = data.mode;
        return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    }
    scope.open1 = function () {
        scope.popup1.opened = true;
    };
    scope.open2 = function () {
        scope.popup2.opened = true;
    };
    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];
    scope.popup1 = {
        opened: false
    };
    scope.popup2 = {
        opened: false
    };
    scope.contractsData = [{ id: '0', entityName: 'All Corporate' }];
    scope.serverSearch ={
        sortBy: '',
        fromDate: '',
        toDate:'',
        employeeId: '',
        requestId: '',
        branch: '',
        contractType: { id: '0', entityName: 'All Appointment Type' },
        corporateId: { id: '0', entityName: 'All Corporate' } 
    }

    scope.clearSearch = function(){
        scope.serverSearch.sortBy = '';
        scope.serverSearch.fromDate=  '';
        scope.serverSearch.toDate ='';
        scope.serverSearch.employeeId = '';
        scope.serverSearch.requestId=  '';
        scope.serverSearch.branch ='';
        scope.contractsData = [{ id: '0', entityName: 'All Corporate' }];
        scope.serverSearch.contractType=  { id: '0', entityName: 'All Appointment Type' };
        scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };
        scope.loadAppointments();
    };

    //Load Appointments Data
    scope.loadAppointments = function (page) {
        var data = {
            pageNo: page ? page : 0,
            rowNo: 10,
            sortBy: scope.serverSearch.sortBy,
            fromDate: scope.serverSearch.fromDate,
            toDate: scope.serverSearch.toDate,
            searchBy: {
                requestid : scope.serverSearch.requestId ? scope.serverSearch.requestId : '',
                employeeid: scope.serverSearch.employeeId ?  scope.serverSearch.employeeId : '',
                branchID : scope.serverSearch.branch ? scope.serverSearch.branch : '',
                entityrelationid: scope.serverSearch.corporateId.id > 0 ? scope.serverSearch.corporateId.id :''
            } 
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/qcApprovedAppointments', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
            if (response.data.isSuccess) {
                scope.appointmentsData = response.data;
                UserService.activeAppointmentsDummyData = response.data;
                UserService.activeAppointmentsDummyDataCollection = response.data.requests;
            }
        });
    };

    scope.searchAppointmentsGroupCtrl = function(count){
        scope.loadAppointments(count);
    };

    //Load Appointments Data
    scope.loadAppointments();    
    scope.closeModel = function () {
        scope.popupQc.actualDate = '';
        scope.remarks = '';
    };

    scope.popupQc ={
        opened: false,
        actualDate: ''
    }

    scope.contracts = PlusUtilitiesService.getContracts();
    scope.contracts = UtilitiesService.getContracts() === null ? [] : UtilitiesService.getContracts();
    scope.contracts.push({ id: '0', entityName: 'All Appointment Type' });
    if (scope.contracts.length > 0) {
        scope.contracts = orderByFilter(scope.contracts, 'entityName', false);
    }

    scope.openQcDate = function(){
        scope.popupQc.opened = true;
    };
    scope.doctorQualificatio = '';
    //Action Request call
    scope.unapprovedRequestAction = function (type) {
        if (type) {
            var requestData = {
                request: {
                    requestId: scope.unapprovedPPData.requestId,
                    currentStatusId: scope.unapprovedPPData.currentStatusId,
                    remarks: scope.remarks,
                    ScheduledAppointmentDate: scope.unapprovedPPData.fulfillmentDate,
                    requestedNextActionId: type === 'QCApprove' ? 48 : type === 'Raise_IA' ? 33 : '',
                    attachFiles: scope.attachFiles,
                    providerId: '',
                    providerName: '',
                    additionalParameters: {
                        'doctorQualification': scope.doctorQualificatio ? scope.doctorQualificatio : '',
                        'isPhotographAvailable': scope.isPhotoAvailble.value,
                        'ActualApptDate' : scope.popupQc.actualDate ? scope.popupQc.actualDate : ''
                    }
                },
                requestAccessToken: UserService.getAccessToken(),
                userAgent: '',
                ipAddress: ''
            }
            scope.remarks = "";
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/request', requestData, 'POST', UserService.getAccessToken(), true).then(function (response) {
                scope.popupQc.actualDate = '';
                if (response) {
                    scope.doctorQualificatio = '';
                    scope.loadAppointments();
                    scope.closeModel();
                    if (type == 'QCApprove') {
                        $('#QCApproveModal').modal('hide');
                    }
                    if (type == 'Raise_IA') {
                        $('#Raise_IAModal').modal('hide');
                    }
                }
            });
        }
    };

    
    //Get corporate Packages data
    scope.getCorporatePackages = function (CorporateSelected) {
        if (CorporateSelected && CorporateSelected !== '0') {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/EntityRelationcache/Search/' + CorporateSelected, {}, 'GET').then(function (response) {
                scope.contractsData = [];
                scope.isCorporate = response.data.length > 0 ? true : false
                if (response.data.length > 0) {
                    scope.contractsData = response.data;
                    scope.contractsData.push({ id: '0', entityName: 'All Corporate' });
                    scope.contractsData = orderByFilter(scope.contractsData, 'entityName', false);
                    scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };

                }
            })
        } else {
            scope.isCorporate = false;
        }
    };
    //Visible Date
    $rootScope.$on('unapprovedPP', function (key, value) {
        scope.unapprovedPPData = value;
        scope.visibleDate = UtilitiesService.compareDate(scope.unapprovedPPData.fulfillmentDate) + '- ' + UtilitiesService.formatTime(scope.unapprovedPPData.fulfillmentDate);
    });

    //Show Model Popup
    scope.openRespectiveActionModal = function (action, currentStatusId, nextActionStatusId, requestId, appointmentDate) {
        scope.apptDate = appointmentDate;
        scope.requestId = requestId;
        scope.remarks = '';
        scope.nextActionStatusId = nextActionStatusId;
        scope.currentStatusId = currentStatusId;
        if (action == "Raise_IA") {
            $('#Raise_IAModal').modal('show');
        }
        if (action == "QCApprove") {
            scope.doctorQualificatio = '';
            $('#QCApproveModal').modal('show');
        }
    };
    scope.openRespectiveActionModal = function () {

    };
    //Client site filter request
    scope.$watch('plusAppointmentsSearch', function (current, old) {
        if (current) {
            scope.appointmentsData = UserService.GetFilteredAppointmentUnapprovedNewAppointments(current);
        } else {
            if (old) {
                UserService.activeAppointmentsDummyData = UserService.activeAppointmentsDummyDataCollection;
                scope.appointmentsData = UserService.activeAppointmentsDummyData;
            }
        }
    });
}]);

angular.module("mbplus")
.controller('unApprovedQCController', ['$scope', '$rootScope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', 'PlusUtilitiesService', '$filter', 'navConstantsSvc', function (scope, rootScope, $location, UserService, UtilitiesService, filterFilter, PlusUtilitiesService, $filter, navConstantsSvc) {
    UserService.checkForSession();
    rootScope.plusAppointmentsSearch = '';
    rootScope.dcInvestigations = '';
    rootScope.dcInvestigationsMap = '';
    rootScope.eSaleQueue = '';
    scope.formatTime = UtilitiesService.formatTime;
    scope.compareDate = UtilitiesService.compareDate;
    scope.user = UserService.getUserObj();
    scope.InsurerRole = [9207, 9211, 9214];
    scope.isPolicyBazar = UserService.isPolicyBazar;

    scope.dateSearch = {
        fromDate: '',
        toDate: '',
        dateWiseSearch: 'apptdate'
    }

    //time/........................
    scope.formats = navConstantsSvc.dateFormate;
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];

    scope.dateFilterDate = {
        fromDate: '',
        toDate: ''
    };

    scope.dateDefautOptions = {
        formatYear: 'yy',
        minDate: scope.dateFilterDate.fromDate,
        startingDay: 1
    };

    scope.setMinDate = function (fromDate) {
        scope.mindate = '';
        var setMinDate = fromDate;
        setMinDate.setDate(fromDate.getDate());
        scope.mindate = setMinDate;
    };

    scope.popup5 = {
        opened: false
    };

    scope.popup6 = {
        opened: false
    };

    scope.open5 = function () {
        scope.popup5.opened = true;
        scope.dateFilterDate.toDate = '';
    };

    scope.open6 = function () {
        scope.popup6.opened = true;
    };

    scope.setMinDate = function (fromDate) {
        scope.mindate = '';
        var setMinDate = fromDate;
        setMinDate.setDate(fromDate.getDate());
        scope.mindate = setMinDate;
        scope.dateSearch.toDate = '';
    };
    //time/........................


    scope.hstep = 1;
    scope.mstep = 10;
    scope.times = {
        startPrefTime: '',
        endPrefTime: ''
    }
    scope.showWarning = false;



    //Load unapproved QC request
    scope.loadUnapprovedQCRequests = function (id, name, dateSearchObj) {
        if (!(UserService.getUserObj().entityType == "DC")) {
            scope.showdcselectcheckbox = true;
        }
        var providerId = null;
        scope.providerName = "";
        if (id && name) {
            providerId = id;
            scope.providerName = name;
        } else if (scope.user.rolesFeatures.roles[0].roleId == 5432) {
        }
        if (!scope.daysOfAppointment || scope.daysOfAppointment === '' || scope.daysOfAppointment <= -1) {
            scope.daysOfAppointment = -1;
        }
        scope.providerName = scope.user.entityName;


        var dateType = scope.dateSearch.dateWiseSearch == 'apptdate' ? true : false;

        if (dateSearchObj && dateSearchObj.fromDate && dateSearchObj.toDate) {
            var yesterdayDate = dateSearchObj.toDate.getDate() + '-' + (dateSearchObj.toDate.getMonth() + 1) + '-' + dateSearchObj.toDate.getFullYear();
            var todayDate = (dateSearchObj.fromDate.getDate()) + '-' + (dateSearchObj.fromDate.getMonth() + 1) + '-' + dateSearchObj.fromDate.getFullYear();
            var url = UtilitiesService.getPlusUrlPrefix() + '/getOrderByERId' + '/' + scope.er_id + '/0/0/' + todayDate + '/' + yesterdayDate + '/' + dateType + '.json';

        } else {
            var today = new Date();
            var yesterday = new Date(); // today!
            yesterday.setDate(yesterday.getDate() - 1);

            scope.dateSearch.fromDate = yesterday;
            scope.dateSearch.toDate = today;

            var yesterdayDate = (today.getDate() - 1) + '-' + (today.getMonth() + 1) + '-' + today.getFullYear();
            var todayDate = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear();

            var url = UtilitiesService.getPlusUrlPrefix() + '/getOrderByERId' + '/' + scope.er_id + '/0/0/' + yesterdayDate + '/' + todayDate + '/' + dateType + '.json';
        }
        UserService.makeRestCall(url, "", "GET", UserService.getAccessToken(), true).then(function (response) {
            if (response) {
                scope.qcAppointments = response;
                UserService.activeAppointmentsDummyData = response.data;
                UserService.activeAppointmentsDummyDataCollection = response.data;
            } else if (!(response.isSuccess)) {

            }
        });
    };

    //Get QC filter data
    scope.getQcFilterData = function (filterValue) {
        if (filterValue.id) {
            var checkContract = UtilitiesService.isChildForContract(parseInt(filterValue.id));
            if (checkContract && checkContract.length > 0) {
                scope.er_id = checkContract[0].id;
            }
            scope.loadUnapprovedQCRequests();
        }
    };
    scope.client = {
        startdate: '',
        enddate: ''
    }


    scope.dt = new Date();

    scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 1
    };
    scope.dateOptionsSt = {
        formatYear: 'yy',
        startingDay: 1
    };
    scope.dateOptions.minDate = scope.client.startdate;

    scope.popup2 = {
        opened: false
    }
    scope.popup1 = {
        opened: false
    }
    scope.open1 = function () {
        scope.popup1.opened = true;
    };

    scope.open2 = function () {
        scope.popup2.opened = true;
    };
    scope.PrefcallStartDateTime = '';
    scope.PrefcallEndDateTime = '';

    scope.getdateLimit = function (dateLimit) {
        scope.client.enddate = '';
        scope.dateOptions.minDate = scope.client.startdate;
    }

    scope.format = 'dd-MM-yyyy';
    scope.altInputFormats = ['M!/d!/yyyy'];

    scope.downloadBulkReports = function () {
        if (scope.client.startdate && scope.client.enddate) {   
            var filename = "test";
            if (scope.client.startdate && scope.times.startPrefTime) {
                scope.PrefcallStartDateTime = UtilitiesService.mergeDateTimeObj(scope.client.startdate, scope.times.startPrefTime);
            } else {
                scope.PrefcallStartDateTime = $filter('date')(scope.client.startdate, 'dd-MM-yyyy');
            }
            if (scope.client.enddate && scope.times.endPrefTime) {
                scope.PrefcallEndDateTime = UtilitiesService.mergeDateTimeObj(scope.client.enddate, scope.times.endPrefTime);
            } else {
                scope.PrefcallEndDateTime = $filter('date')(scope.client.enddate, 'dd-MM-yyyy');
            }

            //convering date time to milisecond
            var stDate = new Date(scope.PrefcallStartDateTime);
            var stMilliseconds = stDate.getTime();
            var endDate = new Date(scope.PrefcallEndDateTime);
            var endMilliseconds = endDate.getTime();

            if (scope.er_id === 313667) {
                // Extracting the formatted date and time for the filename
                var startDateFormatted = $filter('date')(scope.PrefcallStartDateTime, 'dd-MM-yyyy HH:mm:ss');
                var endDateFormatted = $filter('date')(scope.PrefcallEndDateTime, 'dd-MM-yyyy HH:mm:ss');

                // Creating the filename
                filename = 'From' + startDateFormatted + 'To' + endDateFormatted + '.zip';

                if (stMilliseconds && endMilliseconds) {
                    var requestData = {
                        "zipFileName": "",
                        "requestId": null,
                        "orderId": 0,
                        "entityRelationId": [
                            scope.er_id
                        ],
                        "approvalStartDate": "",
                        "approvalEndDate": "",
                        "approvalStartTimeInUnix": stMilliseconds,
                        "approvalEndTimeInUnix": endMilliseconds
                    }
                    var url = UtilitiesService.getPlusUrlPrefix('integration') + "/DownloadFile";

                    UserService.makeRestCall(url, requestData, 'post', UserService.getAccessToken(), true, true)
                        .then(function (response) {
                            if (response.data.type != 'application/json') {
                                var downloadUrl = window.URL.createObjectURL(response.data);
                                var a = document.createElement('a');
                                a.href = downloadUrl;
                                a.download = filename; 
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                window.URL.revokeObjectURL(downloadUrl);
                            } else {
                                scope.showWarning = true;
                                scope.warningMsz = 'No reports were available for specified Time';
                            }
                        })
                        .catch(function (error) {
                            console.error('Download failed:', error);
                        });

                } else {
                    scope.showWarning = true;
                    scope.warningMsz = 'Unable to download, Kindly refresh and try again.';
                }
            } else {
                if (stMilliseconds && endMilliseconds) {
                    var url = UtilitiesService.getPlusUrlPrefix('integration-plus-plus') + "/DownloadFile/" + scope.er_id + "/" + stMilliseconds + "/" + endMilliseconds + "/" + filename;
                    window.open(url, '_blank');
                } else {
                    scope.showWarning = true;
                    scope.warningMsz = 'Unable to download, Kindly refresh and try again.';
                }
            }

        } else {
            scope.showWarning = true;
            scope.warningMsz = 'Select dates before downloading';
        }
    }


    scope.clrModel = function () {
        scope.client = {
            startdate: '',
            enddate: ''
        }
        scope.times = {
            startPrefTime: '',
            endPrefTime: ''
        }
        scope.dateOptions.minDate = '';
        scope.showWarning = false;
    }

    scope.action = {
        cancelComments: '',
        statusId: '',
        nextStatusId: '',
        requestId: '',
        spocname: '',
        spocphone: '',
        date: '',
        remarks: '',
        secondPreferredTime: '',
        dcPrice: '',
        visibleDate: '',
        visibleTime: '',
        partnerOrderId: '',
        showdcselection: false
    };
    scope.closeModel = function () {
        scope.action.cancelComments = '';
        scope.action.statusId = '';
        scope.action.nextStatusId = '';
        scope.action.requestId = '';
        scope.action.spocname = '';
        scope.action.spocphone = '';
        scope.action.date = '';
        scope.action.remarks = '';
        scope.action.secondPreferredTime = '';
        scope.action.dcPrice = '';
        scope.action.visibleDate = '';
        scope.action.visibleTime = '';
        scope.action.partnerOrderId = '';
        scope.action.showdcselection = false;
    };

    scope.openRespectiveActionModal = function (actionName, currentStatusId, actionStatusId, requestId, appointmentDate, secondAppointmentDate, orderItemProductId) {
        scope.actionName = actionName;
        scope.action.statusId = currentStatusId;
        scope.action.nextStatusId = actionStatusId;
        scope.action.requestId = requestId;
        scope.action.date = appointmentDate;
        scope.action.visibleDate = scope.compareDate(appointmentDate);
        scope.action.visibleTime = scope.action.visibleDate + " " + scope.formatTime(appointmentDate);
        scope.action.secondPreferredTime = secondAppointmentDate;
        scope.secondPreferredVTime = scope.compareDate(secondAppointmentDate) + " " + scope.formatTime(secondAppointmentDate);
        scope.action.productId = orderItemProductId;
        //empty all modals

        if (scope.actionName == '"InsurerApprove"') {
        }
        if (scope.actionName == 'Raise_IA') {
        }
    };
    scope.actionRequest = function (actionType, event) {
        scope.createRequest("Appointment", scope.action.statusId, scope.action.nextStatusId, scope.action.requestId, actionType, scope.action.spocname, scope.action.spocphone, event);
    }
    scope.createRequest = function (requestType, statusId, nextStatusId, requestId, actionType, spocname, spocphone, event) {
        var url = UtilitiesService.getPlusUrlPrefix() + "/request";
        var appDate = scope.action.date;
        var providerId = null;
        var providerName = "";
        switch (actionType) {
            case "Reschedule":
                appDate = scope.form.dod;
                if ($("#dcId").val() && scope.showdcselection && !(UserService.getUserObj().entityType == "DC")) {
                    providerId = $("#dcId").val();
                    providerName = $("#dcId option:selected").text();
                }
                break;
            default:
                appDate = scope.action.date;
                break;
        }
        var rejectionComments = scope.action.cancelCategory ? scope.action.cancelCategory + '-' + scope.action.remarks : scope.action.remarks;
        var requestData = {
            "request": {
                "requestId": requestId,
                "currentStatusId": statusId,
                "remarks": rejectionComments,
                "ScheduledAppointmentDate": appDate,
                "requestedNextActionId": nextStatusId,
                "attachFiles": scope.attachFiles,
                "providerId": providerId,
                "providerName": providerName,
                "spocName": spocname,
                "spocContactNo": spocphone
            },
            "requestAccessToken": UserService.getAccessToken(),
            "userAgent": "String",
            "ipAddress": "String"
        }
        UserService.makeRestCall(url, requestData, "post", UserService.getAccessToken(), true).then(function (response) {
            var targetModal = event.target.parentNode;
            while (!targetModal.classList.contains("modal")) {
                targetModal = targetModal.parentNode;
            }
            $("#" + actionType + "Modal").modal("hide");
            scope.loadUnapprovedQCRequests();
            if (scope.attachFiles) {
                if (scope.attachFiles.reports) {
                    scope.attachFiles.reports = {};
                }
                if (scope.attachFiles.bills) {
                    scope.attachFiles.bills = {};
                }
            }
            $location.path($location.path());
            scope.action = {};
            $("textarea").val("");
            scope.form.dod = "";
        });
    };

    scope.$watch('plusAppointmentsSearch', function (current, old) {
        if (current) {
            var data = UserService.GetFilteredAppointmentQc(current);
            var value = {
                data: data
            }
            scope.qcAppointments = value;
        } else {
            if (old) {
                UserService.activeAppointmentsDummyData.data = UserService.activeAppointmentsDummyDataCollection;
                var value = {
                    data: UserService.activeAppointmentsDummyData.data
                }
                scope.qcAppointments = value;
            }
        }
    });
    scope.er_id = '';
    if (!scope.opsuser) {
        var childrens = UtilitiesService.getAllChildren();
        scope.isGroupLogin = childrens && childrens != null && childrens.length > 1;
        if (scope.isGroupLogin) {
            scope.diagnosticCentres = childrens;
        } else {
            scope.er_id = _.first(childrens).id;
        }
        if (!scope.isGroupLogin) {
            if (filterFilter(scope.user.rolesFeatures.roles, { 'roleId': 9211 }, true).length > 0 || filterFilter(scope.user.rolesFeatures.roles, { 'roleId': 9207 }, true).length > 0) {
                var checkContract = UtilitiesService.getChildForContract([9782, 4625]);// 4625 prepolicy contract
                if (checkContract && checkContract.length > 0) {
                    scope.er_id = checkContract[0].id;
                }
            }
            if (filterFilter(scope.user.rolesFeatures.roles, { 'roleId': [5432, 5433, 5434] }, function (actual, expected) {
                return filterFilter(expected, actual, true);
            }).length > 0) {
                var checkContract = UtilitiesService.isChildForContract(5290);// 5290 dc contract
                if (checkContract && checkContract.length > 0) {
                    scope.er_id = checkContract[0].id;
                }
            }
        }
    }
    scope.contractList = UtilitiesService.getContracts() === null ? [] : UtilitiesService.getContracts();
    if (scope.user) {
        var isInsurer = filterFilter(scope.user.rolesFeatures.roles, { 'roleId': scope.InsurerRole }, function (actual, expected) {
            return filterFilter(expected, actual).length > 0;
        }).length > 0;
        if (isInsurer) {
            //var checkContract = UtilitiesService.isChildForContract(4625);// 4625 prepolicy contract 9782
            var checkContract = UtilitiesService.getChildForContract([9782, 4625]);// 4625 prepolicy contract

            if (checkContract && checkContract.length > 0) {
                scope.er_id = checkContract[0].id;
            }
            scope.children = UtilitiesService.getAllChildren() === null ? [] : UtilitiesService.getAllChildren();
            scope.contracts = UtilitiesService.getContracts() === null ? [] : UtilitiesService.getContracts();
            if (scope.children.length > 1) {
                scope.availableContracts = filterFilter(scope.contracts, {
                    "id": scope.children
                }, function (actual, expected) {
                    return filterFilter(expected, {
                        'erTypeId': parseInt(actual)
                    }).length > 0;
                });
            } else {
                scope.availableContracts = filterFilter(scope.contracts, {
                    "id": scope.children
                }, function (actual, expected) {
                    return filterFilter(expected, {
                        'erTypeId': parseInt(actual)
                    }).length > 0;
                });

            }
            scope.selectFilter = _.first(scope.availableContracts);
        }
    }
    if (scope.availableContracts && scope.availableContracts.length > 0) {
        scope.getQcFilterData(_.first(scope.availableContracts))
    }
}]);
angular.module("mbplus")
.controller('UnapprovedCancelController', ['$scope', '$rootScope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics', 'PlusUtilitiesService', function (scope, $rootScope, $location, UserService, UtilitiesService, filterFilter, $analytics, PlusUtilitiesService) {

  $analytics.pageTrack('/appointments');
  if (!UserService.isActive()) {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }
  $rootScope.plusAppointmentsSearch = '';
  $rootScope.dcInvestigations = '';
  $rootScope.dcInvestigationsMap = '';
  $rootScope.eSaleQueue = '';
  scope.selectedDcs = [];
  scope.ctrlName = "UnapprovedCancelController";
  scope.user = UserService.getUserObj();
  scope.formatTime = UtilitiesService.formatTime;
  scope.compareDate = UtilitiesService.compareDate;
  scope.form = {};
  scope.action = {
    cancelComments: '',
    statusId: '',
    nextStatusId: '',
    requestId: '',
    spocname: '',
    spocphone: '',
    date: '',
    remarks: '',
    secondPreferredTime: '',
    dcPrice: '',
    visibleDate: '',
    visibleTime: '',
    partnerOrderId: '',
    showdcselection: false
  };
  scope.testData = {};
  scope.originalDcDetails = {};
  scope.reasonOfCancel = UtilitiesService.reasonOfCancel();

  scope.client = {
    prefDate: new Date()
  }
  //Date Object
  scope.today = function () {
    scope.client.prefDate = new Date();
    scope.dt = new Date();
  };
  scope.today();

  scope.dateOptions = {
    formatYear: 'yy',
    startingDay: 1
  };

  scope.popup1 = {
    opened: false
  };

  scope.open1 = function () {
    scope.popup1.opened = true;
  };

  scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
  scope.format = scope.formats[0];
  scope.altInputFormats = ['M!/d!/yyyy'];

  //Set Time Object
  scope.resetTime = function () {
    var first = new Date();
    var dd = new Date(first).getDate();
    var mm = new Date(first).getMonth() + 1;
    var yy = new Date(first).getFullYear();
    var hh = 8;
    var ms = 0;
    var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
    scope.client.prefTime = new Date(x);
  };
  scope.resetTime();
  scope.hstep = 1;
  scope.mstep = 30;

  scope.ismeridian = false;

  //First time limit
  var maxFirst = new Date();
  maxFirst.setHours(18);
  maxFirst.setMinutes(0);
  scope.maxFirst = maxFirst;

  var minFirst = new Date();
  minFirst.setHours(8);
  minFirst.setMinutes(0);
  scope.minFirst = minFirst;
  scope.isUserCancel = true;

  scope.closeModel = function () {
    scope.action.cancelComments = '';
    scope.action.statusId = '';
    scope.action.nextStatusId = '';
    scope.action.requestId = '';
    scope.action.spocname = '';
    scope.action.spocphone = '';
    scope.action.date = '';
    scope.action.remarks = '';
    scope.action.secondPreferredTime = '';
    scope.action.dcPrice = '';
    scope.action.visibleDate = '';
    scope.action.visibleTime = '';
    scope.action.partnerOrderId = '';
    scope.action.showdcselection = false;
  };

  scope.useSecondPref = function (value) {
    
  };
  //Reset reasons text or comment text
  scope.resetDependencies = function (reasonForCancel) {
    if (reasonForCancel) {
      scope.action.cancelComment = reasonForCancel == 'Other' ? '' : reasonForCancel != 'Other' ? '' : reasonForCancel == 'reset' ? '' : scope.action.cancelComment;
      scope.cancelReason = reasonForCancel == 'reset' ? '' : scope.cancelReason;
    } else {
      scope.isUserCancel = true;
    }
  };

  scope.loadAppointments = function (id, name) {
    if (!UserService.getUserObj().entityType == 'DC') {
      scope.showdcselectcheckbox = true;
    }
    var providerId = null;
    scope.providerName = "";
    if (id && name) {
      providerId = id;
      scope.providerName = name;
    }
    else if (UserService.getUserObj().rolesFeatures.roles[0].roleId == 5432) {
      providerId = UserService.getUserObj().eR_Id;
    }
    scope.providerName = UserService.getUserObj().entityName;
    var data = {
      'requestType': "",
      'ProviderId': providerId,
      'hashtagFilters': {},
      'requestAccessToken': UserService.getAccessToken(),
      'userAgent': 'String',
      'ipAddress': 'String'
    }

    var url = UtilitiesService.getPlusUrlPrefix() + "/unApprovedCancelledAppointments/";
    scope.appointmentsCount = 0;

    UserService.makeRestCall(url, data, "POST", UserService.getAccessToken()).then(function (response) {
      if (response.data.isSuccess) {
        scope.activeAppointments = response.data;
        UserService.activeAppointmentsDummyData = response.data;
        UserService.activeAppointmentsDummyDataCollection = response.data.requests;
      }
      else {
        scope.hasNoResults = true;
        scope.loading = false;
      }
    })
  };

  scope.changeDc = function (value) {
    scope.selectedDcs = filterFilter(scope.diagnosticCentres, value);
  };

  scope.createRequest = function (requestType, statusId, nextStatusId, requestId, actionType, spocname, spocphone, event) {
    var patientname = scope.selectedPatientName;
    var id = requestId; //scope.selectedRequestId;
    var appDate = scope.action.date;
    scope.client.prefDate = UtilitiesService.mergeDateTimeObj(scope.client.prefDate, scope.client.prefTime);
    var providerId = null;
    var providerName = "";
    var remarksComment = scope.action.remarks;
    var additionalParams = {};
    switch (actionType) {
      case "Reschedule":
        appDate = scope.client.prefDate;
        if (scope.selectedDcs.length > 0 && !(UserService.getUserObj().entitytype == "dc")) {
          providerId = scope.selectedDcs[0].id;
          providerName = scope.selectedDcs[0].entityName;
        }
        break;
      case "Cancel":
        appDate = scope.action.date;
        remarksComment = scope.action.cancelReason == 'Other' ? scope.action.cancelComments : scope.action.cancelReason;
        break;
      case "MACancel":
        appDate = scope.action.date;
        remarksComment = scope.action.cancelReason == 'Other' ? scope.action.cancelComments : scope.action.cancelReason;
        break;
      case "Confirm":
        additionalParams.Price = scope.action.dcPrice;
        break;
      case "Fit":
        additionalParams.bloodGroup = scope.selectedBloodGrp;
        break;
      case "UnFit":
        additionalParams.bloodGroup = scope.selectedBloodGrp;
        break;
      default:
        appDate = scope.action.date;
        break;
    }
    var requestData = {
      "request": {
        "requestId": requestId,
        "currentStatusId": statusId,
        "remarks": remarksComment,
        "ScheduledAppointmentDate": appDate,
        "requestedNextActionId": nextStatusId,
        "attachFiles": scope.attachFiles,
        "providerId": providerId,
        "providerName": providerName,
        "spocName": spocname,
        "spocContactNo": spocphone,
        "additionalParameters": additionalParams
      },
      "requestAccessToken": UserService.getAccessToken(),
      "userAgent": "String",
      "ipAddress": "String"
    }
    scope.selectedDcs = [];
    UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/request", requestData, "post").then(function (response) {
      var targetModal = event.target.parentNode;
      scope.resetTime();
      scope.today();
      while (!targetModal.classList.contains("modal")) {
        targetModal = targetModal.parentNode;
      }
      $("#" + actionType + "Modal").modal("hide");
      scope.loadAppointments();
      if (scope.attachFiles) {
        if (scope.attachFiles.reports) {
          scope.attachFiles.reports = {};
        }
        if (scope.attachFiles.bills) {
          scope.attachFiles.bills = {};
        }
      }
      scope.action = {};
      scope.loadAppointments();
    });
  };

  scope.actionOnRequestMethods = (function () {
    return {
      actionRequest: function (actionType, event) {
        scope.createRequest("Appointment", scope.action.statusId, scope.action.nextStatusId, scope.action.requestId, actionType, scope.action.spocname, scope.action.spocphone, event);
      }
    }
  })();

  scope.$watch('plusAppointmentsSearch', function (current, old) {
    if (current) {
      scope.activeAppointments = UserService.GetFilteredAppointment(current);
    } else {
      if (old) {
        UserService.activeAppointmentsDummyData.requests = UserService.activeAppointmentsDummyDataCollection;
        scope.activeAppointments = UserService.activeAppointmentsDummyData;
      }
    }
  });
  //Reset time
  scope.resetTime = function () {
    scope.maxFirst = '';
    scope.minFirst = '';
    scope.client.prefTime = '';
    var maxFirst = new Date();
    maxFirst.setHours(18);
    maxFirst.setMinutes(0);
    scope.maxFirst = maxFirst;
    var minFirst = new Date();
    minFirst.setHours(8);
    minFirst.setMinutes(0);
    scope.minFirst = minFirst;
    scope.client.prefTime = minFirst;
  };

  scope.openRespectiveActionModal = function (actionName, currentStatusId, actionStatusId, requestId, appointmentDate, secondAppointmentDate, orderItemProductId) {
    scope.resetTime();
    scope.actionName = actionName;
    scope.action.statusId = currentStatusId;
    scope.actionId = actionStatusId;
    scope.action.nextStatusId = actionStatusId;
    scope.action.requestId = requestId;
    scope.action.date = appointmentDate;
    scope.action.visibleDate = scope.compareDate(appointmentDate);
    scope.action.visibleTime = scope.action.visibleDate + " " + scope.formatTime(appointmentDate);
    scope.action.secondPreferredTime = UtilitiesService.getDateObj(secondAppointmentDate);
    scope.secondPreferredVTime = scope.compareDate(secondAppointmentDate) + " " + scope.formatTime(secondAppointmentDate);
    scope.action.productId = orderItemProductId;
    //empty all modals
    if (scope.actionName == 'Fit' || scope.actionName == 'UnFit') {
      if (scope.action.remarks) {
        scope.action.remarks.fit = "";
        scope.selectedBloodGrp = "";
      }
    }
    if (scope.actionName == 'Reschedule') {
      scope.form.dod = "";
      scope.action.showdcselection = false;
      scope.testData.testStateId = "";
      scope.testData.testCityId = "";
      scope.testData.testLocalityId = "";
    }
    if (scope.actionName == 'Confirm') {
      scope.action.spocname = "";
      scope.action.spocphone = "";
      scope.action.dcPrice = "";

    }
    if (scope.actionName == 'Cancel') {
    }
    if (scope.actionName == 'Approve' || scope.actionName == 'NotAttended' || scope.actionName == 'Raise_IA') {
      scope.action.remarks = "";
    }
    if (scope.actionName == 'Attended') {
      scope.actualdate = "";
      scope.action.remarks = "";
    }
    if (scope.actionName == 'Submit') {
      scope.attachFiles.reports = {};
      scope.attachFiles.bills = {};
      scope.action.remarks = "";
    }
    if (scope.actionName == 'Create') {
      scope.partnerOrderId = "";
    }
  }

  scope.medicalTestMethods = (function () {
    scope.relatedTests = [];
    scope.tempBucket = [];
    scope.groups = [[]];
    return {
      splitRequests: function () {
        var dataObj = [];
        var restObj = [];
        angular.forEach(scope.relatedTests, function (ind, val) {
          val.groupId = 0
          val.providerId = scope.originalDcDetails.providerId
          val.providerName = scope.originalDcDetails.providerName
          val.appointmentDate = scope.originalDcDetails.appointmentDate
          val.visitType = scope.originalDcDetails.visitType
          scope.groups[0].push(val)

        })
        angular.forEach(scope.groups, function (i, buckets) {
          angular.forEach(buckets, function (ib, test) {
            var obj = {};
            if (i == 0) {
              obj = {
                "productId": test.id,
                "providerId": test.providerId,
                "providerName": test.providerName,
                "appointmentDate": test.appointmentDate,
                "visitType": test.visitType,
                "groupId": 0

              }
            }
            else {
              obj = {
                "productId": test.id,
                "providerId": test.providerId,
                "providerName": test.providerName,
                "appointmentDate": test.appointmentDate,
                "visitType": test.visitType,
                "groupId": i
              }
            }
            dataObj.push(obj)
          })
        })
        var data = {
          "requestId": scope.requestId,
          "details": dataObj
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/SplitRequest/", data, "POST", UserService.getAccessToken()).then(function (response) {
          scope.relatedTests = [];
          scope.tempBucket = [];
          scope.groups = [[]];
          scope.originalDcDetails = {};
        });
      },
      addTestToPermanentBucket: function () {
        scope.disableTempCreate = false;
        scope.desableLocation = true;
        $(scope.tempBucket).each(function (i, v) {
          v.groupId = scope.groups.length;
        })
        scope.groups.push(scope.tempBucket);
        scope.tempBucket = [];
      },
      removeFromGroups: function (removeItem) {
        removeItem.checkTest = false;
        $.each(scope.groups, function (i, val) {
          if (val.indexOf(removeItem) != -1) {
            scope.relatedTests.push(removeItem);
            val.splice(val.indexOf(removeItem), 1);
            return true;
          }
        })
      },
      addTestToTempBucket: function (checkedItem) {
        checkedItem.checkTest = true;
        scope.tempBucket.push(checkedItem);
        scope.relatedTests.splice(scope.relatedTests.indexOf(checkedItem), 1)
      },
      removeBucketFromGroup: function (index) {
        $(scope.groups[index]).each(function (i, v) {
          v.groupId = 0;
          v.checkTest = false;
          scope.relatedTests.push(v);
        })
        scope.groups.splice(index, 1)
      },
      getTestsForPackage: function (productId, reqtId, providerId, providerName, appointmentDate, visitType) {
        scope.originalDcDetails.providerId = providerId;
        scope.originalDcDetails.providerName = providerName;
        scope.originalDcDetails.appointmentDate = appointmentDate;
        scope.originalDcDetails.visitType = visitType;
        scope.groups = [[]];
        scope.testData.testStateId = "";
        scope.cities = {};
        scope.locations = {};
        scope.sublocations = {};
        scope.allDCs = {};

        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/PackageEntityRelation/" + productId + ".json", "", "GET", UserService.getAccessToken()).then(function (response) {
          if (response.data) {
            scope.requestId = reqtId;
            scope.relatedTests = {};
            if (scope.tempBucket.length > 0) {
              scope.tempBucket = [];
            }
            scope.relatedTests = response.data.allowedInvestigations;
            scope.testsObj = {};
            $(scope.relatedTests).each(function (i, v) {
              scope.testsObj[v.id] = v;
            })
          }
        });
      },
      removeFromBucket: function (checkedItem) {
        checkedItem.checkTest = false;
        scope.relatedTests.push(checkedItem);
        scope.tempBucket.splice(scope.tempBucket.indexOf(checkedItem), 1)
      }
    };
  })();
  scope.resendEmailDetails = {
    emailID: '',
    statusID: ''
  };
  scope.ResendEmail = function () {
    var resendMailRequest = {
      "requestID": $rootScope.requestIdForActiveAppointmnents,
      "statusID": $("#emailType").val(),
      "emailID": scope.resendEmailDetails.emailID
    }
    UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/resendEmailForAppointment/" + ".json", resendMailRequest, "post").then(function (response) {
      if (response.data.isSuccess == true) {
        $("#ResendEmailModal").modal("hide");
        $("#email").val('');
        $("#emailType").val('');
      }
    });
  }
  scope.getPackageTestDetails = function (productId, noProductId) {
    if (noProductId) {
      scope.investigationList = [];
      return;
    } else {
      var pId = productId ? productId : '';
      scope.investigationList = [];
      if (pId) {
        var url = UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/' + pId;
        UserService.makeRestCall(url, '', 'GET', UserService.getAccessToken()).then(function (response) {
          if (response.data) {
            var investigation = response.data.allowedInvestigations;
            var investigationGroup = [];
            angular.forEach(investigation, function (v, i) {
              investigationGroup.push(v.groupName);
            })
            var listOfUniqeInvestigations = investigationGroup.filter(function (val, index, allArr) {
              return index == allArr.indexOf(val);
            })
            angular.forEach(listOfUniqeInvestigations, function (val, ind) {
              var investigationWiseTests = filterFilter(investigation, val);
              var testObj = investigationWiseTests;
              scope.testDetails = [];
              angular.forEach(testObj, function (v, i) {
                scope.testDetails.push({
                  groupName: v.groupName,
                  testName: v.name,
                  testId: v.id,
                  groupId: v.groupId,
                  isActive: v.isActive,
                  duplicateCheck: v.duplicateCheck,
                  quantity: v.quantity
                })
              })
              scope.investigationList.push({
                investigationName: val,
                testDetails: scope.testDetails
              })
            })
            // console.log(scope.investigationList);
          } else {
              UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          }
        })
      } else {
          UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
      }
    }
  }
  angular.element(document).ready(function () {
    scope.loadAppointments();
  });
}]);

angular.module('mbplus')
  .controller('trackCtrl', ['$rootScope', '$scope', 'UserService', 'UtilitiesService', 'PlusUtilitiesService', 'DateService', 'navConstantsSvc', 'filterFilter', 'orderByFilter', function (rootScope, scope, UserService, UtilitiesService, PlusUtilitiesService, DateService, navConstantsSvc, filterFilter, orderByFilter) {
    scope.$root.title = 'Change password | Medibuddy Hospital Portal';

    scope.compareDate = UtilitiesService.compareDate;
    scope.formatTime = UtilitiesService.formatTime;
    scope.getDateObj = UtilitiesService.getDateObj;
    scope.isError = false;
    rootScope.showMenu = false;
    scope.isData = false;
    scope.isMessage = false;
    scope.isMarkerArray = false;
    scope.errorMessage = '';
    scope.isScheduleAppointment = false;
    scope.errorMessage = '';
    scope.languages = ["English", "Hindi", "Kannada", "Telugu", "Malayalam", "Tamil", "Punjabi", "Bengali", "Marathi", "Gujarati", "Others"]
    scope.languageDropdownMenu = false
    scope.prefLang = null
    rootScope.isRestLogin = {
      'display': 'none'
    };
    scope.distanceJsonObj = {
      distance: ''
    };
    scope.distances = navConstantsSvc.distances;
    scope.radious = {
      distance: 2,
      lat: '',
      lng: ''
    };
    scope.packageIds = null;
    scope.distanceJsonObj.distance = {
      id: 3,
      value: 10
    };
    scope.visitTypeValue = 0;
    scope.isFlag = {
      requestId: false,
      mobileNumber: false,
      name: false,
      radio_empid: false,
      radio_dob: false
    }
    scope.search = {
      requestId: '',
      mobileNumber: '',
      name: '',
      radio_empid: '',
      companyName: '',
      radio_dob: '',
      customerName: '',
      emailAddress: ''
    }
    scope.client = {
      prefTime: '',
      prefDate: '',
      reportDate: new Date(),
      preferredDC1: ''
    }
    scope.popup1 = {
      opened: false
    };
    scope.reschedule = {
      opened: true
    };

    scope.format = navConstantsSvc.dateFormate[0];
    scope.altInputFormats = navConstantsSvc.altInputFormats;
    var tomorrow = DateService.tomorrow;
    var today = DateService.today;
    if(today.getHours() >= 15) {
      tomorrow.setDate(tomorrow.getDate() + 1)
    }
    if(today.getDay() == 6 || tomorrow.getDay() == 0) {
      tomorrow.setDate(tomorrow.getDate() + 1)
    }
    scope.client.prefDate = tomorrow;
    scope.dateOptions = {
      formatYear: 'yy',
      minDate: tomorrow,
      startingDay: 1
    };
    scope.dateOptionsForPickup = {
      formatYear: 'yy',
      // maxDate: new Date(2020, 5, 22),
      // minDate: tomorrow,
      startingDay: 1
    };
    scope.dateOptionsSearch = {
      formatYear: 'yy',
      maxDate: new Date(),
      startingDay: 1
    };
    //Time JSON
    scope.client.prefTime = UtilitiesService.resetTime();
    scope.ismeridian = false;
    var maxFirst = new Date();
    maxFirst.setHours(18);
    maxFirst.setMinutes(0);
    scope.maxFirst = maxFirst;
    var minFirst = new Date();
    minFirst.setHours(8);
    minFirst.setMinutes(0);
    scope.minFirst = minFirst;
    scope.mindate = navConstantsSvc.newDate;
    scope.hstep = navConstantsSvc.hstep;
    scope.mstep = navConstantsSvc.mstep;

    scope.open1 = function () {
      scope.popup1.opened = true;
    };

    scope.disabled = function (date, mode) {
      return (mode === 'day' && (date.getDay() === 0));
    };

    scope.resetDefault = function () {
      scope.rescheduleJson = {
        dateTime: '',
        dcName: '',
        dcAddress: '',
        addressline1: '',
        addressline2: '',
        visitType: true,
        visitTypeHome: false,
        visitTypeDC: false,
        reason: '',
        isDisable: false,
        distance: '',
        notAttendedReason: '',
        AdditionalPhoneNumber: '',
        AdditionalName: '',
        AdditionalMailAddress: '',
        city: '',
        state: '',
        employeeId: '',
      }
    };

    scope.changeLocationSelection = function (type) {
      switch (type) {
        case 'state':
          scope.manualSelectedDC.newCityId = 0;
          scope.manualSelectedDC.newSubLocationId = 0;
          scope.client.preferredDC1 = '';
          break;
        case 'city':
          scope.manualSelectedDC.newSubLocationId = 0;
          scope.client.preferredDC1 = '';
          break;
        case 'location':
          scope.client.preferredDC1 = '';
      }
    }

    scope.location = {};
    scope.loadCitiesNew = function (selectedState) {
      scope.selectedState = selectedState;
      scope.changeLocationSelection('state');
      if (selectedState) {
        if (selectedState.lookUpId) {
          scope.location.state = selectedState.lookUpId
          var url = UtilitiesService.getPlusUrlPrefix('integration') + "masterdata/lookuplevel/" + selectedState.lookUpId + "/2";
          UserService.makeRestCall(url, "", "get").then(function (response) {
            if (response.data.isSuccess) {
              scope.cities = response.data.lookUpData;
              scope.citiesObj = {}
              $(scope.cities).each(function (i, v) {
                scope.citiesObj[v.lookUpId] = v;
              })
              scope.cities = orderByFilter(scope.cities, 'lookUpValue', scope.reverse);
            }
          });
        }
      }
    };

    scope.loadLocationsNew = function (selectedLocation) {
      scope.selectedLocation = selectedLocation;
      scope.changeLocationSelection('city');
      if (scope.selectedLocation) {
        if (scope.selectedLocation.lookUpId) {
          scope.location.location = scope.selectedLocation.lookUpId;
          var url = UtilitiesService.getPlusUrlPrefix('integration') + "masterdata/lookup/location/" + scope.selectedLocation.lookUpId + ".json";
          UserService.makeRestCall(url, "", "get").then(function (response) {
            if (response.data.isSuccess) {
              scope.sublocations = response.data.lookUpData;
              scope.sublocations = orderByFilter(scope.sublocations, 'lookUpValue', scope.reverse);
            }
          });
        }
      }
    };

    scope.loadDcForAllPackages = function (newSubLocationId) {
      scope.changeLocationSelection('location');
      var perIdsList = [];
      scope.diagnosticCentres = {};
      perIdsList = scope.packageIds ? scope.packageIds : [];
      // scope.statusDetails.trackAppointments.map(function(item){
      //     if (item.pacakgeIDs) {
      //         perIdsList = item.packageIds;
      //     }
      // })
      // perIdsList = scope.statusDetails.trackAppointments[0].pacakgeIDs;
      // angular.forEach(scope.selectedPackageForAdvance, function (e, i) {
      //     perIdsList.push(e.peR_Id);
      // });
      if (scope.location.state && scope.location.location && newSubLocationId) {
        var data = {
          packageIds: perIdsList ? perIdsList : [],
          stateId: scope.location.state,
          cityId: scope.location.location,
          locationId: newSubLocationId
        };
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + 'AllEligibleDCByPackageIdsAndByLocation', data, 'POST').then(function (response) {
          if (response.data.length > 0) {
            scope.diagnosticCentres = response.data;
          } else {
            UtilitiesService.showAlertMessage('No Diagnostic Centre found.');
          }
        }, function (error) {
          UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
        });
      }
    };

    scope.langSelected = function (l) {
      scope.languageDropdownMenu = false;
      scope.prefLang = l;
    }

    scope.selectedDcFromMap = function (markerObj, $event) {
      if (markerObj) {
        scope.selectedDcFromDavanceSearch = markerObj;
        scope.windowParams.list = scope.selectedDcFromDavanceSearch;
      } else {
        scope.selectedDcFromDavanceSearch = '';
        scope.windowParams.list = scope.selectedDcFromDavanceSearch;
      }
    };


    scope.resetDefault();

    //Get Date Time
    scope.getDateTime = function (date, time) {
      scope.PrefcallDateTime = UtilitiesService.mergeDateTimeObj(date, time);
    }

    scope.changePage = function (data) {
      scope.search.customerName = '';
      scope.search.mobileNumber = '';
      scope.search.emailAddress = '';
    }

    scope.searchby = 'Name';

    //Get test details
    scope.getTestDetails = function (test) {
      scope.investigationList = [];
      if (test.testID) {
        var url = "https://integration-plus-plus.medibuddy.in/PlusAPI/" + 'PackageEntityRelation/' + test.testID;
        UserService.makeRestCall(url, '', 'GET', UserService.getAccessToken()).then(function (response) {
          if (response.data) {
            var investigation = response.data.allowedInvestigations;
            var investigationGroup = [];
            angular.forEach(investigation, function (v, i) {
              investigationGroup.push(v.groupName);
            })
            var listOfUniqeInvestigations = investigationGroup.filter(function (val, index, allArr) {
              return index == allArr.indexOf(val);
            })
            angular.forEach(listOfUniqeInvestigations, function (val, ind) {
              var investigationWiseTests = filterFilter(investigation, val);
              var testObj = investigationWiseTests;
              scope.testDetails = [];
              angular.forEach(testObj, function (v, i) {
                scope.testDetails.push({
                  groupName: v.groupName,
                  testName: v.name,
                  testId: v.id,
                  groupId: v.groupId,
                  isActive: v.isActive,
                  duplicateCheck: v.duplicateCheck,
                  quantity: v.quantity
                })
              })
              scope.investigationList.push({
                investigationName: val,
                testDetails: scope.testDetails
              })
            })
          } else {
            alert('No Investigations found.');
          }
        })
      } else {
        alert('Product Id is unavailable.');
      }
    };
    scope.map = {
      center: {
        latitude: 20.5937,
        longitude: 78.9629
      },
      stroke: {
        color: '#08B21F',
        weight: 2,
        opacity: 1
      },
      fill: {
        color: '#08B21F',
        opacity: 0.5
      },
      radius: 10,
      geodesic: true,
      visible: true,
      zoom: 12
    }

    //Get Decript Data With Lat Long
    scope.getDecriptDataWithLatLong = function (lati, logi) {
      scope.markerArrayData = [];
      scope.markerArray = [];
      var ajaxData = {
        encryptedDetails: scope.encryptedDetails,
        latitude: lati,
        longitude: logi,
        distance: scope.distanceJsonObj.distance ? scope.distanceJsonObj.distance.value : 2,
        isRequestUpdate: scope.IsRequestUpdate ? scope.IsRequestUpdate : false,
        IsVisitTypeChanged: scope.rescheduleJson.visitTypeDC === true ? true : false
      }
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + 'getDcafterDecryption', ajaxData, 'POST').then(function (response) {
        scope.isMarkerArray = false;
        scope.advanceDcListData = response.data;
        scope.packageIds = scope.advanceDcListData.packageID ? (scope.advanceDcListData.packageID.length ? scope.advanceDcListData.packageID : scope.packageIds) : scope.pacakgeIDs;
        if (scope.advanceDcListData && scope.advanceDcListData.packageProviders && scope.advanceDcListData.packageProviders.length > 0) {
          angular.forEach(scope.advanceDcListData.packageProviders, function (data, index) {
            scope.markerArrayData.push({
              id: data.id,
              entityAddress: data.entityAddress,
              pinCode: data.pinCode,
              coords: {
                latitude: data.latitude,
                longitude: data.longitude,
              },
              entityName: data.entityName,
              marker: false
            });
          });
          scope.map = {
            center: {
              latitude: scope.lat,
              longitude: scope.lng
            },
            stroke: {
              color: '#08B21F',
              weight: 2,
              opacity: 1
            },
            fill: {
              color: '#08B21F',
              opacity: 0.5
            },
            markersEvents: {
              click: function (marker, eventName, model, arguments) {
                angular.forEach(scope.markerArrayData, function (data, index) {
                  if (parseInt(data.id) === parseInt(marker.key)) {
                    scope.markerArrayData[index].visible = true;
                  } else {
                    scope.markerArrayData[index].visible = false;
                  }
                })
              }
            },
            window: {
              marker: {},
              show: false,
              closeClick: function (value) {
                this.show = false;
              },
              options: {},
              title: ''
            },
            radius: 10,
            geodesic: true,
            visible: true,
            zoom: 12
          }
        } else {
          scope.isMarkerArray = true;
          scope.markerArrayData = [];
          scope.markerArray = [];
          scope.errorMessage = 'No diagnostic centre found, please search for different location.';
        }
      }, function (error) {
        scope.isMarkerArray = true;
        scope.markerArray = [];
        scope.markerArrayData = [];
        scope.errorMessage = 'oops! something went wrong, please try again later.';
      })
    };

    scope.flags = {
      manual: true,
      advance: false
    };

    scope.loadStates = function () {
      var url = UtilitiesService.getPlusUrlPrefix('integration') + "masterdata/lookup/state.json";
      UserService.makeRestCall(url, "", "get").then(function (response) {
        if (response.data.isSuccess) {
          scope.states = response.data.lookUpData;
        }
      });
    };

    $(function () {
      scope.loadStates();
    });

    scope.DCSelection = function (type) {
      scope.rescheduleJson.isDisable = true;
      if (type === 'advance') {
        scope.flags.advance = true;
        scope.flags.manual = false;
        scope.client.preferredDC1 = null;
        scope.manualSelectedDC = {
          newStateId: '',
          newCityId: '',
          newSubLocationId: ''
        };
      } else if (type === 'manual') {
        scope.flags.manual = true;
        scope.flags.advance = false;
        scope.markerDetails = null;
      }
    }

    //Change Visit Type
    scope.changeVisitType = function (data, type) {
      scope.markerDetails = '';
      scope.markerArray = [];
      scope.isMarkerArray = false;
      scope.markerArrayData = [];
      scope.rescheduleJson.addressline1 = '';
      scope.rescheduleJson.addressline2 = '';
      if (data === 'dc') {
        scope.rescheduleJson.visitTypeDC = !!scope.rescheduleJson.visitTypeDC;
        scope.rescheduleJson.isDisable = scope.rescheduleJson.visitTypeDC;
        scope.rescheduleJson.visitTypeHome = false;
      } else if (data === 'home') {
        scope.rescheduleJson.visitTypeDC = false;
        scope.rescheduleJson.visitTypeHome = !!scope.rescheduleJson.visitTypeHome;
        scope.rescheduleJson.isDisable = scope.rescheduleJson.visitTypeHome;
      } else {
        scope.rescheduleJson.isDisable = false;
        scope.rescheduleJson.visitTypeHome = false;
        scope.rescheduleJson.visitTypeDC = false;
      }
      if (type === 'scheduleAppointment') {
        scope.rescheduleJson.isDisable = true;
      }
    };

    scope.reschedule = function () {
      scope.reschedule.opened = true;
    };

    //Reset Fields
    scope.resetFields = function () {
      scope.search.requestId = '';
      scope.search.mobileNumber = '';
      scope.search.name = '';
      scope.search.radio_empid = '';
      scope.search.radio_dob = '';
      scope.search.companyName = '';
    }

    //Change dc obj
    scope.changeDC = function () {
      scope.markerDetails = '';
      scope.rescheduleJson.isDisable = true;
      scope.radious = {
        distance: 2,
        lat: '',
        lng: ''
      };
      scope.distanceJsonObj.distance = {
        id: 1,
        value: 2
      };
    };

    //Schedule Appointment
    scope.scheduleAppointment = function (request) {
      if (scope.client.prefTime && scope.client.prefDate && scope.encryptedDetails) {
        var state = scope.rescheduleJson.city + '' + scope.rescheduleJson.state;
        var bookAppointmentRequest = {
          packageIds: scope.advanceDcListData ? scope.advanceDcListData.packageID : '',
          appointmentDateFirstPref: UtilitiesService.mergeDateTimeObj(scope.client.prefDate, scope.client.prefTime),
          appointmentDateSecondPref: UtilitiesService.mergeDateTimeObj(scope.client.prefDate, scope.client.prefTime),
          DCId: scope.markerDetails ? scope.markerDetails.id : scope.client.preferredDC1.id ? scope.client.preferredDC1.id : 0,
          DCName: scope.markerDetails ? scope.markerDetails.entityName : scope.client.preferredDC1.entityName ? scope.client.preferredDC1.entityName : '',
          homeVisit: scope.rescheduleJson.visitTypeHome ? true : scope.rescheduleJson.visitTypeDC ? false : request.isHomeVisit,
          addressLine1: scope.rescheduleJson.addressline1 ? scope.rescheduleJson.addressline1 : '',
          addressLine2: scope.rescheduleJson.addressline2 ? scope.rescheduleJson.addressline2 : '',
          isRequestUpdate: false,
          encryptedDetails: scope.encryptedDetails,
          isFromTrack: true,
          allocationAdditionalInfo: {
            SalesOrAgentName: scope.rescheduleJson.AdditionalName,
            SalesOrAgentPhoneNumber: scope.rescheduleJson.AdditionalPhoneNumber,
            SalesOrAgentMailAddress: scope.rescheduleJson.AdditionalMailAddress,
            DNDCustomer: scope.dndCustomer === true ? true : false
          }
        }
        bookAppointmentRequest.addressline2 = bookAppointmentRequest.addressline2 + '' + state;
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + 'updateDCForPBRequest', bookAppointmentRequest, 'POST').then(function (response) {
          if (response.data.isSuccess) {
            scope.searchStatus(scope.searchStaatus);
            angular.element('#scheduleAppointment').modal('hide');
            scope.resetDefault();
            UtilitiesService.showAlertMessage('Your appointment has been successfully booked. You can contact us @ 080-67617571 for assistant.', true);
          } else {
            scope.searchStatus(scope.searchStaatus);
            angular.element('#scheduleAppointment').modal('hide');
            scope.resetDefault();
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          }
        })
      } else {
        alert('Kindly choose date time.');
      }
    };

    //Get DC details after decrypting
    scope.requestUpdateCall = function () {
      var ajaxData = {
        encryptedDetails: scope.encryptedDetails,
        latitude: '',
        longitude: '',
        distance: 2,
        isRequestUpdate: scope.IsRequestUpdate ? scope.IsRequestUpdate : false,
        IsVisitTypeChanged: scope.rescheduleJson.visitTypeDC === true ? true : false
      }
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + 'getDcafterDecryption', ajaxData, 'POST').then(function (response) {
        scope.advanceDcListData = response.data;
        scope.packageIds = scope.advanceDcListData.packageID ? (scope.advanceDcListData.packageID.length ? scope.advanceDcListData.packageID : scope.packageIds) : scope.pacakgeIDs;
      });
    };


    //Reschedule Appointment Employee Details
    scope.loadEmployeeDetails = function () {
      if (scope.encryptedDetails) {
        var data = {
          encryptedDetails: scope.encryptedDetails
        }
        UserService.makeRestCall("https://integration-plus-plus.medibuddy.in/PlusAPI/" + 'getPBRequestByReqId', data, 'POST').then(function (response) {
          if (response.data) {
            scope.requestUpdateCall();
            scope.customer = response.data;
            var testdetail = JSON.parse(scope.customer.requestJSON);
            scope.testnames = testdetail.testDetails;
            angular.element('#scheduleAppointment').appendTo('body');
            angular.element('#scheduleAppointment').modal('show');
          }
        })
      }
    };

    //Get Decript Data
    scope.getDecriptData = function (data, value) {
      scope.encryptedDetails = data;
      scope.isScheduleAppointment = true;
      scope.scheduleAppointmentRequest = value;
      scope.resetDefault();
      scope.markerArray = [];
      scope.markerArrayData = [];
      scope.markerDetails = '';
      scope.rescheduleJson.isDisable = true;
      scope.visitTypeValue = 0;
      scope.loadEmployeeDetails();
    };
    scope.manualSelectedDC = {
      newStateId: '',
      newCityId: '',
      newSubLocationId: ''
    };
    //Reschedule Appointment
    scope.rescheduleAppointment = function (status, request, markerDetails) {
      var req = request;
      scope.isScheduleAppointment = false;
      scope.flags.advance = false;
      scope.flags.manual = true;
      scope.manualSelectedDC = {
        newStateId: '',
        newCityId: '',
        newSubLocationId: ''
      };
      scope.isTU = request.contractId == 12719 ? true : false

      if (status === 'close' && request) {
        var requestData = {
          request: {
            contractId: req.contractId,
            requestId: request.requestId,
            currentStatusId: request.currentStatusId,
            remarks: scope.rescheduleJson.reason ? scope.rescheduleJson.reason : '',
            providerId: markerDetails ? markerDetails.id : scope.client.preferredDC1.id ? scope.client.preferredDC1.id : '',
            providerName: markerDetails ? markerDetails.entityName : scope.client.preferredDC1.entityName ? scope.client.preferredDC1.entityName : '',
            addressLine1: scope.rescheduleJson.addressline1 ? scope.rescheduleJson.addressline1 : '',
            addressLine2: scope.rescheduleJson.addressline2 ? scope.rescheduleJson.addressline2 : '',
            ScheduledAppointmentDate: UtilitiesService.mergeDateTimeObj(scope.client.prefDate, scope.client.prefTime),
            requestedNextActionId: 117,
            isHomeVisit: scope.rescheduleJson.visitTypeHome ? true : scope.rescheduleJson.visitTypeDC ? false : request.isHomeVisit,
            additionalParameters: {
              PreferredLanguage: scope.prefLang ? scope.prefLang : null,
              'SalesOrAgentName': scope.rescheduleJson.AdditionalName,
              'SalesOrAgentPhoneNumber': scope.rescheduleJson.AdditionalPhoneNumber,
              'SalesOrAgentMailAddress': scope.rescheduleJson.AdditionalMailAddress
              // additionals: {
              // }
            }
          }
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + 'trackRequest', requestData, 'POST').then(function (response) {
          if (response.data.isSuccess) {
            scope.searchStatus(scope.searchStaatus);
            angular.element('#rescheduleAppointment').modal('hide');
            UtilitiesService.showAlertMessage('Reschedule appointment successfully. You can contact us @ 08067617571 for assistant.', true);
            scope.resetDefault();
          } else {
            angular.element('#rescheduleAppointment').modal('hide');
            scope.resetDefault();
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          }
        }, function error() {
          angular.element('#rescheduleAppointment').modal('hide');
          scope.resetDefault();
          UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        });
      } else {
        scope.resetDefault();
        scope.markerArray = [];
        scope.markerArrayData = [];
        scope.markerDetails = '';
        scope.visitTypeValue = 0;
        scope.rescheduleAppointmentRequest = request;
        scope.packageIds = request.pacakgeIDs || [];
        scope.prefLang = scope.rescheduleAppointmentRequest.preferredLanguage ? scope.rescheduleAppointmentRequest.preferredLanguage : null
        angular.element('#rescheduleAppointment').appendTo('body');
        angular.element('#rescheduleAppointment').modal('show');
      }
    };
    scope.reportPickedupDetails = '';
    //reportPickedup
    scope.reportPickedup = function (item, type) {
      if (item && type === 'open') {
        scope.reportPickedupDetails = item;
        scope.actualDate = UtilitiesService.getDateObj(item.appointmentDate);
        angular.element('#reportPickedup').appendTo('body');
        angular.element('#reportPickedup').modal('show');
      } else {
        if (type === 'close') {
          var data = {
            requestId: scope.reportPickedupDetails.requestId,
            currentDateOfAppointment: scope.client.reportDate,
            actualDateOfAppointment: scope.client.reportDate,
            additionals: {
              'SalesOrAgentName': scope.rescheduleJson.AdditionalName,
              'SalesOrAgentPhoneNumber': scope.rescheduleJson.AdditionalPhoneNumber,
              'SalesOrAgentMailAddress': scope.rescheduleJson.AdditionalMailAddress
            }
          }
          UserService.makeRestCall("https://integration-plus-plus.medibuddy.in/PlusAPI/" + 'ReportPickUp', data, 'POST').then(function (response) {
            angular.element('#reportPickedup').modal('hide');
            scope.rescheduleJson.AdditionalName = '';
            scope.rescheduleJson.AdditionalPhoneNumber = '';
            scope.rescheduleJson.AdditionalMailAddress = '';
            scope.client.reportDate = new Date();
            if (response.data.isSuccess) {
              scope.searchStatus(scope.searchStaatus);
              UtilitiesService.showAlertMessage('Request updated successfully.', true);
            } else {
              UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            }
          }, function (error) {
            angular.element('#reportPickedup').modal('hide');
            scope.rescheduleJson.reason = '';
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          });
        }
      }
    };

    //Set Flag For Validation
    scope.setFlagForValidation = function () {
      if (scope.rescheduleJson.visitTypeHome && scope.rescheduleJson.state && scope.rescheduleJson.city && scope.rescheduleJson.addressline1 && scope.rescheduleJson.addressline2) {
        scope.rescheduleJson.isDisable = false;
      } else {
        scope.rescheduleJson.isDisable = true;
      }
    };
    //Window Params
    scope.windowParams = {
      list: scope.selectedDcFromDavanceSearch,
      doIt: function (markerDetails, type) {
        scope.markerDetails = markerDetails;
        if (scope.client.prefDate && type === 'reschedule') {
          scope.markerArray = [];
          scope.markerArrayData = [];
          if (scope.rescheduleJson.visitTypeHome && scope.rescheduleJson.addressline1 && scope.rescheduleJson.addressline2) {
            scope.rescheduleJson.isDisable = false;
          } else if (scope.rescheduleJson.visitTypeDC) {
            scope.rescheduleJson.isDisable = false;
          }
        } else if (scope.client.prefDate && type === 'schedule') {
          scope.rescheduleJson.isDisable = false;
          scope.markerArray = [];
          scope.markerArrayData = [];
        }
      }
    };

    //Selected DC From Map
    scope.selectedDcFromDropdown = function (markerObj, $event) {
      if (markerObj) {
        scope.selectedDcFromDavanceSearch = markerObj;
        scope.windowParams.list = scope.selectedDcFromDavanceSearch;
      } else {
        scope.selectedDcFromDavanceSearch = '';
        scope.windowParams.list = scope.selectedDcFromDavanceSearch;
      }
      if (scope.client.preferredDC1) {
        scope.rescheduleJson.isDisable = false;
        scope.client.preferredDC1.id = markerObj.id;
        scope.client.preferredDC1.entityName = markerObj.entityName;
      } else {
        scope.rescheduleJson.isDisable = true;
      }
    };

    //Get DC list
    scope.loadDcList = function (lat, lng) {
      scope.markerArray = [];
      scope.markerArrayData = [];
      if (lat && lng) {
        scope.radious.lat = lat;
        scope.radious.lng = lng;
        var data = {
          packageIds: scope.rescheduleAppointmentRequest ? scope.rescheduleAppointmentRequest.pacakgeIDs : [],
          latitude: lat,
          longitude: lng,
          distance: scope.radious.distance,
        };
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + 'AllEligibleDCByPackageIdsAndByLocation', data, 'POST').then(function (response) {
          if (response.data.length > 0) {
            scope.isMarkerArray = false;
            scope.advanceDcList = response.data;
            angular.forEach(scope.advanceDcList, function (data, index) {
              scope.markerArray.push({
                id: scope.advanceDcList[index].id,
                entityAddress: scope.advanceDcList[index].entityAddress,
                pinCode: scope.advanceDcList[index].pinCode,
                coords: {
                  latitude: scope.advanceDcList[index].latitude,
                  longitude: scope.advanceDcList[index].longitude,
                },
                entityName: scope.advanceDcList[index].entityName,
                marker: false
              });
            });
            scope.map = {
              center: {
                latitude: scope.lat,
                longitude: scope.lng
              },
              stroke: {
                color: '#08B21F',
                weight: 2,
                opacity: 1
              },
              fill: {
                color: '#08B21F',
                opacity: 0.5
              },
              markersEvents: {
                click: function (marker, eventName, model, arguments) {
                  angular.forEach(scope.markerArray, function (data, index) {
                    if (parseInt(data.id) === parseInt(marker.key)) {
                      scope.markerArray[index].visible = true;
                    } else {
                      scope.markerArray[index].visible = false;
                    }
                  })
                }
              },
              window: {
                marker: {},
                show: false,
                closeClick: function (value) {
                  this.show = false;
                },
                options: {},
                title: ''
              },
              radius: 10,
              geodesic: true,
              visible: true,
              zoom: 12
            }
          } else {
            scope.isMarkerArray = true;
            scope.markerArray = [];
            scope.markerArrayData = [];
            scope.errorMessage = 'No diagnostic centre found, please search for different location.';
          }
        }, function (error) {
          scope.isMarkerArray = true;
          scope.markerArray = [];
          scope.markerArrayData = [];
          scope.errorMessage = 'oops! something went wrong, please try again later.';
        });
      }
    };
    scope.correspondencData = null;
    scope.getCorrespondenceData = function (item) {
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + 'RequestCorrespondence/153/' + item.requestId + '/' + item.esalesId, '', 'Get').then(function (response) {
        if (response.data.length > 0) {
          scope.correspondencData = response.data;
        }
      });
    }

    //Get user search location
    scope.$on('gmPlacesAutocomplete::placeChanged', function (key, value) {
      var data = angular.element('#scheduleAppointmentInTrack').length;
      if (value && value._api) {
        var location = value._api.getPlace().geometry.location;
        scope.lat = location.lat();
        scope.lng = location.lng();
        scope.$apply();
        scope.markerDetails = '';
        scope.errorMessage = '';
        scope.rescheduleJson.isDisable = true;
        if (data > 0 && scope.encryptedDetails) {
          scope.getDecriptDataWithLatLong(scope.lat, scope.lng);
        } else {
          scope.loadDcList(scope.lat, scope.lng);
        }
      }
    });

    //Capture change distance
    scope.changeDistance = function (data, type) {
      if (type === 'Schedule' && scope.lat && scope.lng) {
        scope.distanceJsonObj.distance = data;
        scope.getDecriptDataWithLatLong(scope.lat, scope.lng);
      } else if (type === 'Reschedule' && scope.lat && scope.lng) {
        scope.radious.distance = data.value;
        scope.loadDcList(scope.lat, scope.lng);
      }

    };

    //Mark DND for All and customer
    scope.dnd = function (status, request, type) {
      scope.dndObj = request;
      if (status === 'close') {
        var data = {
          requestID: request.requestId,
          dndInfo: {
            DNDReason: scope.rescheduleJson.reason,
            DND: scope.dandType === 'All' ? !request.isDNDMarked : request.isDNDMarked, // !request.isDNDMarked,
            DNDCustomer: scope.dandType === 'Customer' ? !request.isDNDCustomerMarked : request.isDNDCustomerMarked
          },
          EsalesId : request.esalesId
        }


        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + 'MarkDNDForRequest', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
          angular.element('#dndReason').modal('hide');
          if (response.data.isSuccess) {
            scope.searchStatus(scope.searchStaatus);
            if (!scope.dndObj.isDNDMarked || !scope.dndObj.isDNDCustomerMarked) {
              UtilitiesService.showAlertMessage('DND service activated successfully.', true);
            } else {
              UtilitiesService.showAlertMessage('DND service deactivated successfully.', true);
            }
          } else {
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          }
        }, function (error) {
          angular.element('#dndReason').modal('hide');
          scope.rescheduleJson.reason = '';
          UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        });
      } else {
        scope.rescheduleJson.reason = '';
        scope.dndRequest = request;
        scope.dandType = type;
        angular.element('#dndReason').appendTo('body');
        angular.element('#dndReason').modal('show');
      }
    };

    //Change Search type
    scope.changeType = function (type) {
      scope.isData = false;
      scope.isMessage = false;
      scope.statusDetails = {};
      scope.resetFields();
      scope.isFlag.requestId = false;
      scope.isFlag.mobileNumber = false;
      scope.isFlag.name = false;
      scope.isFlag.radio_dob = false;
      scope.isFlag.radio_empid = false;
      scope.isParentSel = true;
      if (type === 'requestId') {
        scope.isFlag.requestId = true;
      } else if (type === 'radio_empid') {
        scope.isFlag.radio_empid = true;
      } else if (type === 'radio_dob') {
        scope.isFlag.radio_dob = true;
      } else if (type === 'radio_MobileNo') {
        scope.isFlag.mobileNumber = true;
      }
    };

    //Animated Html
    $(function () {
      $('.radioBtns input').each(function () {
        $(this).click(function () {
          $('.errormsg').hide();
          $('.formSection input').val('');
          $('#benef_rel').val('0');
          $(this).parent().parent().find('label').removeClass('sel');
          $('.formSection').hide();

          if ($(this).is(":checked")) {
            if (!$(this).parent().parent().hasClass('sel')) {
              $('body').animate({
                scrollTop: $(window).height() + 100
              }, 600);
            }
            $(this).next('label').addClass('sel');
            $(this).parent().parent().addClass('sel');
            $(this).parent().parent().parent().addClass('sel');
            $('.formSection').show('slow', function () {
              var searchBoxHeight = $(this).parent().innerHeight();
              $(this).parent().css({
                'height': searchBoxHeight
              })
            });
          }
        });
      });
    });

    //Post call for not attended request
    scope.postNotattended = function (request) {
      if (request) {
        var requestData = {
          request: {
            requestId: request.requestId,
            currentStatusId: request.currentStatusId,
            remarks: scope.rescheduleJson.reason !== 'Other' ? scope.rescheduleJson.reason : scope.rescheduleJson.notAttendedReason,
            requestedNextActionId: 118,
            additionalParameters: {
              additionals: {
                'SalesOrAgentName': scope.rescheduleJson.AdditionalName,
                'SalesOrAgentPhoneNumber': scope.rescheduleJson.AdditionalPhoneNumber,
                'SalesOrAgentMailAddress': scope.rescheduleJson.AdditionalMailAddress
              }
            }
          }
        }
        UserService.makeRestCall("https://integration-plus-plus.medibuddy.in/PlusAPI/" + '/trackRequest', requestData, 'POST').then(function (response) {
          scope.searchStatus(scope.searchStaatus);
          angular.element('#notAttended').modal('hide');
          UtilitiesService.showAlertMessage('Request updated successfully. You can contact us @ 080-67617571 for assistant.', true);
          scope.resetDefault();
        }, function error() {
          angular.element('#notAttended').modal('hide');
          scope.resetDefault();
          UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        });
      }
    };

    //Calculate width
    scope.widthCalculation = function (itemLength) {
      var withValue = 100 / itemLength;
      return {
        width: '' + withValue + '' + '%'
      }
    };

    //Open not attended popup
    scope.openNotAttended = function (item) {
      scope.notAttendedRequest = item;
      angular.element('#notAttended').appendTo('body');
      angular.element('#notAttended').modal('show');
    };
    scope.UpdateSearchFields= function()
    {
      if(scope.search.select=== 'DOB')
      {
        scope.search.mobileNumber='';
      }
      else if(scope.search.select==='MobileNo')
      {
        scope.search.dob='';
      }
    };

    //Get search result 
    scope.searchStatus = function (status) {
      scope.isData = false;
      if (status) {
        var data = {
          requestId: 0,
          name: '',
          empCode: '',
          mobileNo: '',
          emailId: '',
          radio_dob: '',
          corporateName: '',
          dob:''
        }
        scope.searchStaatus = status;
        var erIDs;
        var paramValue;
        var searchParams = new URLSearchParams(window.location.search);
        paramValue = searchParams.get('insurer');
        if (paramValue) {
          paramValue = paramValue.slice(0, -1);
          if (paramValue === 'TATA') {
            erIDs = [313630, 776141];
          }
          if(paramValue === 'KOTAK'){
            erIDs = [61662, 455026, 422532, 158837];
          }
        }
        
        if (status === 'requestId') {
          data.requestId = scope.search.requestId ? scope.search.requestId : 0;
        } else if (status === 'radio_empid') {
          data.empCode = scope.search.radio_empid ? scope.search.radio_empid : '';
          data.mobileNo = scope.search.mobileNumber ? scope.search.mobileNumber : '';
          data.emailId = scope.search.emailAddress ? scope.search.emailAddress : '';
          data.name = scope.search.customerName ? scope.search.customerName : '';
          data.dob=scope.search.dob?scope.search.dob:'';
        } else if (status === 'radio_MobileNo') {
          data.mobileNo = scope.search.mobileNumber;
        }

        function getPackageIds(response) {
          var items = response && response.data && response.data.trackAppointmentResponseItems;
          var firstItem = items && items[0];
          var firstAppt = firstItem && firstItem.trackAppointments && firstItem.trackAppointments[0];
          var pkgIDs = firstAppt && firstAppt.pacakgeIDs;
          return (pkgIDs && pkgIDs.length) ? pkgIDs : scope.packageIds;
        }

        function handleResponse(response) {
          var respData = response && response.data;
          scope.packageIds = getPackageIds(response);
          if (!(respData && respData.trackAppointmentResponseItems)) {
            scope.isMessage = true;
            scope.isData = false;
          } else {
            scope.isData = true;
            scope.isMessage = false;
            scope.statusDetails = respData;
            scope.statusDetails.trackAppointments = respData.trackAppointmentResponseItems && respData.trackAppointmentResponseItems.trackAppointments;
          }
        }

        if(paramValue === 'TATA' || paramValue === 'KOTAK') {
          var found = false;
          var index = 0;
          function tryNextErId() {
            if (index >= erIDs.length || found) {
              if (!found) {
                scope.isData = false;
                UtilitiesService.showAlertMessage('No Status found, Please check the detail you have entered.');
              }
              return;
            }
            data.ErId = erIDs[index];
            index++;
            UserService.makeRestCall('https://ins-integration.medibuddy.in/' + 'TrackAppointmentDetails', data, 'POST').then(function (response) {
              var respData = response && response.data;
              var items = respData && respData.trackAppointmentResponseItems;
              if (respData && respData.isSuccess && items && items.length !== 0) {
                found = true;
                handleResponse(response);
              } else {
                tryNextErId();
              }
            }, function (error) {
              UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
              tryNextErId();
            });
          }
          tryNextErId();
        }

        else {
          UserService.makeRestCall('https://ins-integration.medibuddy.in/' + 'TrackAppointmentDetails', data, 'POST').then(function (response) {
            if (response.data.isSuccess && response.data.trackAppointmentResponseItems && response.data.trackAppointmentResponseItems.length !== 0) {
              handleResponse(response);
            } else {
              scope.isData = false;
              UtilitiesService.showAlertMessage('No Status found, Please check the detail you have entered.');
            }
          }, function (error) {
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          });
        }
      } else {
        UtilitiesService.showAlertMessage('Please field missing fields.');
      }
    }

    scope.rescheduleAppointmentFromSAL = function (item) {
      var bookAppointmentRequest = {
        requestId: item.requestId ? item.requestId : item.esalesId
      };
      UserService.makeRestCall(UtilitiesService.getProviderMediBuddyUrl() + 'v1/crons/GetSchedulingLink', bookAppointmentRequest, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          var rescheduleAppointmentPage = response.data.SAL;          
          window.open(rescheduleAppointmentPage, '_blank');
        } else {
          UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        }
      }, function (error) {
        UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
      });
    }
  }]);

angular.module("mbplus")
.controller('UnapprovedController', ['$scope', '$rootScope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', 'PlusUtilitiesService','$state','navConstantsSvc', function (scope, rootScope, $location, UserService, UtilitiesService, filterFilter, PlusUtilitiesService,state,navConstantsSvc) {

  UserService.checkForSession();
  rootScope.plusAppointmentsSearch = '';
  rootScope.dcInvestigations = '';
  rootScope.dcInvestigationsMap = '';
  rootScope.eSaleQueue = '';


  scope.selectedDcs = [];
  scope.resendEmailDetails = {
    emailID: '',
    statusID: ''
  };

  scope.user = UserService.getUserObj();
  scope.formatTime = UtilitiesService.formatTime;
  scope.compareDate = UtilitiesService.compareDate;

  scope.form = {};

  scope.resetObjects = function(){
    scope.action = {
      cancelComments: '',
      statusId: '',
      nextStatusId: '',
      requestId: '',
      spocname: '',
      spocphone: '',
      date: '',
      remarks: '',
      secondPreferredTime: '',
      dcPrice: '',
      visibleDate: '',
      visibleTime: '',
      partnerOrderId: '',
      showdcselection: false
    };
  }
  scope.resetObjects();
  scope.testData = {};
  scope.originalDcDetails = {};
  scope.reasonOfCancel = UtilitiesService.reasonOfCancel();

  scope.client = {
    prefDate: new Date()
  }
  //Date Object
  scope.today = function () {
    scope.client.prefDate = new Date();
    scope.dt = new Date();
  };
  scope.today();

  scope.dateOptions = {
    formatYear: 'yy',
    startingDay: 1
  };

  scope.popup1 = {
    opened: false
  };

  scope.open1 = function () {
    scope.popup1.opened = true;
  };

  scope.formats = navConstantsSvc.dateFormate;
  scope.format = scope.formats[0];
  scope.altInputFormats = ['M!/d!/yyyy'];

  //Set Time Object
  scope.resetTime = function () {
    var first = new Date();
    var dd = new Date(first).getDate();
    var mm = new Date(first).getMonth() + 1;
    var yy = new Date(first).getFullYear();
    var hh = 8;
    var ms = 0;
    var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
    scope.client.prefTime = new Date(x);
  };
  scope.resetTime();
  scope.hstep = 1;
  scope.mstep = 30;

  scope.ismeridian = false;

  //First time limit
  var maxFirst = new Date();
  maxFirst.setHours(18);
  maxFirst.setMinutes(0);
  scope.maxFirst = maxFirst;

  var minFirst = new Date();
  minFirst.setHours(8);
  minFirst.setMinutes(0);
  scope.minFirst = minFirst;
  scope.isUserCancel = true;

  scope.closeModel = function () {
    scope.resetObjects()
  };

  //Load unconfirmed order list
  scope.loadUnconfirmedOrder = function () {
    UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/cartOrders/', { requestAccessToken: UserService.getAccessToken() }, 'POST', UserService.getAccessToken()).then(function (response) {
      if (response.data.isSuccess) {
        scope.activeAppointments = response.data;
        UserService.activeAppointmentsDummyData = response.data;
        UserService.activeAppointmentsDummyDataCollection = response.data.cartOrders;
      }
    })
  };

  //Called from tab controller for open action model popup
  scope.actionRequest = function (id, approve) {
    scope.actionRequestId = id
    scope.actionRequestApprove = approve;
    if (approve) {
      angular.element('#ApproveModal').appendTo('body');
      angular.element('#ApproveModal').modal('show');
    }
    else {
      angular.element('#CancelModal').appendTo('body');
      angular.element('#CancelModal').modal('show');
    }
  };

    //Update request
  scope.actionRequestModal = function (flag, modalType) {
    if (flag) {
      var data = {
        cartId: scope.actionRequestId,
        isApproved: scope.actionRequestApprove
      };
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'cartOrderAction', data, 'POST', UserService.getAccessToken()).then(function (response) {
        angular.element('#CancelModal').modal('hide');
        angular.element('#ApproveModal').modal('hide');
        if (response.data.isSuccess) {
          if (modalType == 'ApproveModal') {
            UtilitiesService.showAlertMessage('Successfully approved request.', true);
          }
          if (modalType == 'CancelModal') {
            UtilitiesService.showAlertMessage('Successfully raised cancellation request.',true);
          }
          scope.loadUnconfirmedOrder();
        }
        else {
          angular.element('#CancelModal').modal('hide');
          angular.element('#ApproveModal').modal('hide');
          UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        }
      });
    }
  };


  //Reset reasons text or comment text
  scope.resetDependencies = function (reasonForCancel) {
    if (reasonForCancel) {
      scope.action.cancelComment = reasonForCancel == 'Other' ? '' : reasonForCancel != 'Other' ? '' : reasonForCancel == 'reset' ? '' : scope.action.cancelComment;
      scope.cancelReason = reasonForCancel == 'reset' ? '' : scope.cancelReason;
    } else {
      scope.isUserCancel = true;
    }
  };

  scope.loadAppointments = function (id, name) {
    if (!UserService.getUserObj().entityType == 'DC') {
      scope.showdcselectcheckbox = true;
    }
    var providerId = null;
    scope.providerName = "";
    if (id && name) {
      providerId = id;
      scope.providerName = name;
    }
    else if (UserService.getUserObj().rolesFeatures.roles[0].roleId == 5432) {
      providerId = UserService.getUserObj().eR_Id;
    }
    scope.providerName = UserService.getUserObj().entityName;
    var data = {
      requestType: '',
      ProviderId: providerId,
      hashtagFilters: {},
      requestAccessToken: UserService.getAccessToken()
    }
    scope.appointmentsCount = 0;
    UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/unApprovedCancelledAppointments/', data, 'POST', UserService.getAccessToken()).then(function (response) {
      if (response.data.isSuccess) {
        scope.activeAppointments = response.data;
        UserService.activeAppointmentsDummyData = response.data;
        UserService.activeAppointmentsDummyDataCollection = response.data.requests;
      }
      else {
        scope.hasNoResults = true;
        scope.loading = false;
      }
    })
  };

  scope.changeDc = function (value) {
    scope.selectedDcs = filterFilter(scope.diagnosticCentres, value);
  };

  scope.createRequest = function (requestType, statusId, nextStatusId, requestId, actionType, spocname, spocphone, event) {
    var patientname = scope.selectedPatientName;
    var id = requestId; //scope.selectedRequestId;
    var appDate = scope.action.date;
    scope.client.prefDate = UtilitiesService.mergeDateTimeObj(scope.client.prefDate, scope.client.prefTime);
    var providerId = null;
    var providerName = "";
    var remarksComment = scope.action.remarks;
    var additionalParams = {};
    switch (actionType) {
      case 'Reschedule':
        appDate = scope.client.prefDate;
        if (scope.selectedDcs.length > 0 && !(UserService.getUserObj().entitytype == 'dc')) {
          providerId = scope.selectedDcs[0].id;
          providerName = scope.selectedDcs[0].entityName;
        }
        break;
      case 'Cancel':
        appDate = scope.action.date;
        remarksComment = scope.action.cancelReason == 'Other' ? scope.action.cancelComments : scope.action.cancelReason;
        break;
      case 'MACancel':
        appDate = scope.action.date;
        remarksComment = scope.action.cancelReason == 'Other' ? scope.action.cancelComments : scope.action.cancelReason;
        break;
      case 'Confirm':
        additionalParams.Price = scope.action.dcPrice;
        break;
      case 'Fit':
        additionalParams.bloodGroup = scope.selectedBloodGrp;
        break;
      case 'UnFit':
        additionalParams.bloodGroup = scope.selectedBloodGrp;
        break;
      default:
        appDate = scope.action.date;
        break;
    }
    var requestData = {
      request: {
        requestId: requestId,
        currentStatusId: statusId,
        remarks: remarksComment,
        ScheduledAppointmentDate: appDate,
        requestedNextActionId: nextStatusId,
        attachFiles: scope.attachFiles,
        providerId: providerId,
        providerName: providerName,
        spocName: spocname,
        spocContactNo: spocphone,
        additionalParameters: additionalParams
      },
      requestAccessToken: UserService.getAccessToken()
    }
    scope.selectedDcs = [];
    UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/request', requestData, 'POST').then(function (response) {
      var targetModal = event.target.parentNode;
      scope.resetTime();
      scope.today();
      while (!targetModal.classList.contains("modal")) {
        targetModal = targetModal.parentNode;
      }
      $("#" + actionType + "Modal").modal('hide');
      scope.loadAppointments();
      if (scope.attachFiles) {
        if (scope.attachFiles.reports) {
          scope.attachFiles.reports = {};
        }
        if (scope.attachFiles.bills) {
          scope.attachFiles.bills = {};
        }
      }
      scope.action = {};
      scope.loadAppointments();
    });
  };

scope.ctrlFn = function (nextpage) {
        scope.startIndex = nextpage;
        scope.getClosedClaims();
    };

  scope.actionRequestData = function (actionType, event) {
        scope.createRequest('Appointment', scope.action.statusId, scope.action.nextStatusId, scope.action.requestId, actionType, scope.action.spocname, scope.action.spocphone, event);
  };

  scope.$watch('plusAppointmentsSearch', function (current, old) {
    if (current) {
      scope.activeAppointments = UserService.GetFilteredAppointment(current);
    } else {
      if (old) {
        UserService.activeAppointmentsDummyData.requests = UserService.activeAppointmentsDummyDataCollection;
        scope.activeAppointments = UserService.activeAppointmentsDummyData;
      }
    }
  });
  //Reset time
  scope.resetTime = function () {
    scope.maxFirst = '';
    scope.minFirst = '';
    scope.client.prefTime = '';
    var maxFirst = new Date();
    maxFirst.setHours(18);
    maxFirst.setMinutes(0);
    scope.maxFirst = maxFirst;
    var minFirst = new Date();
    minFirst.setHours(8);
    minFirst.setMinutes(0);
    scope.minFirst = minFirst;
    scope.client.prefTime = minFirst;
  };
  // scope.ctrlFn = function (actionName, currentStatusId, actionStatusId, requestId, appointmentDate, secondAppointmentDate, orderItemProductId) {
  // };
  scope.ctrlFn = function (actionName, currentStatusId, actionStatusId, requestId, appointmentDate, secondAppointmentDate, orderItemProductId) {
    scope.resetTime();
    scope.actionName = actionName;
    scope.action.statusId = currentStatusId;
    scope.actionId = actionStatusId;
    scope.action.nextStatusId = actionStatusId;
    scope.action.requestId = requestId;
    scope.action.date = appointmentDate;
    scope.action.visibleDate = scope.compareDate(appointmentDate);
    scope.action.visibleTime = scope.action.visibleDate + ' ' + scope.formatTime(appointmentDate);
    scope.action.secondPreferredTime = UtilitiesService.getDateObj(secondAppointmentDate);
    scope.secondPreferredVTime = scope.compareDate(secondAppointmentDate) + ' ' + scope.formatTime(secondAppointmentDate);
    scope.action.productId = orderItemProductId;
    //empty all modals
    if (scope.actionName == 'Fit' || scope.actionName == 'UnFit') {
      if (scope.action.remarks) {
        scope.action.remarks.fit = '';
        scope.selectedBloodGrp = '';
      }
    }
    if (scope.actionName == 'Reschedule') {
      scope.form.dod = '';
      scope.action.showdcselection = false;
      scope.testData.testStateId = '';
      scope.testData.testCityId = '';
      scope.testData.testLocalityId = '';
    }
    if (scope.actionName == 'Confirm') {
      scope.action.spocname = '';
      scope.action.spocphone = '';
      scope.action.dcPrice = '';

    }
    if (scope.actionName == 'Cancel') {
    }
    if (scope.actionName == 'Approve' || scope.actionName == 'NotAttended' || scope.actionName == 'Raise_IA') {
      scope.action.remarks = '';
    }
    if (scope.actionName == 'Attended') {
      scope.actualdate = '';
      scope.action.remarks = '';
    }
    if (scope.actionName == 'Submit') {
      scope.attachFiles.reports = {};
      scope.attachFiles.bills = {};
      scope.action.remarks = '';
    }
    if (scope.actionName == 'Create') {
      scope.partnerOrderId = '';
    }
  }

  scope.medicalTestMethods = (function () {
    scope.relatedTests = [];
    scope.tempBucket = [];
    scope.groups = [[]];
    return {
      splitRequests: function () {
        var dataObj = [];
        var restObj = [];
        angular.forEach(scope.relatedTests, function (ind, val) {
          val.groupId = 0
          val.providerId = scope.originalDcDetails.providerId
          val.providerName = scope.originalDcDetails.providerName
          val.appointmentDate = scope.originalDcDetails.appointmentDate
          val.visitType = scope.originalDcDetails.visitType
          scope.groups[0].push(val)

        })
        angular.forEach(scope.groups, function (i, buckets) {
          angular.forEach(buckets, function (ib, test) {
            var obj = {};
            if (i == 0) {
              obj = {
                productId: test.id,
                providerId: test.providerId,
                providerName: test.providerName,
                appointmentDate: test.appointmentDate,
                visitType: test.visitType,
                groupId: 0

              }
            }
            else {
              obj = {
                productId: test.id,
                providerId: test.providerId,
                providerName: test.providerName,
                appointmentDate: test.appointmentDate,
                visitType: test.visitType,
                groupId: i
              }
            }
            dataObj.push(obj)
          })
        })
        var data = {
          requestId: scope.requestId,
          details: dataObj
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/SplitRequest/', data, 'POST', UserService.getAccessToken()).then(function (response) {
          scope.relatedTests = [];
          scope.tempBucket = [];
          scope.groups = [[]];
          scope.originalDcDetails = {};
        });
      },
      addTestToPermanentBucket: function () {
        scope.disableTempCreate = false;
        scope.desableLocation = true;
        $(scope.tempBucket).each(function (i, v) {
          v.groupId = scope.groups.length;
        })
        scope.groups.push(scope.tempBucket);
        scope.tempBucket = [];
      },
      removeFromGroups: function (removeItem) {
        removeItem.checkTest = false;
        $.each(scope.groups, function (i, val) {
          if (val.indexOf(removeItem) != -1) {
            scope.relatedTests.push(removeItem);
            val.splice(val.indexOf(removeItem), 1);
            return true;
          }
        })
      },
      addTestToTempBucket: function (checkedItem) {
        checkedItem.checkTest = true;
        scope.tempBucket.push(checkedItem);
        scope.relatedTests.splice(scope.relatedTests.indexOf(checkedItem), 1)
      },
      removeBucketFromGroup: function (index) {
        $(scope.groups[index]).each(function (i, v) {
          v.groupId = 0;
          v.checkTest = false;
          scope.relatedTests.push(v);
        })
        scope.groups.splice(index, 1)
      },
      getTestsForPackage: function (productId, reqtId, providerId, providerName, appointmentDate, visitType) {
        scope.originalDcDetails.providerId = providerId;
        scope.originalDcDetails.providerName = providerName;
        scope.originalDcDetails.appointmentDate = appointmentDate;
        scope.originalDcDetails.visitType = visitType;
        scope.groups = [[]];
        scope.testData.testStateId = "";
        scope.cities = {};
        scope.locations = {};
        scope.sublocations = {};
        scope.allDCs = {};

        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/' + productId, '', 'GET', UserService.getAccessToken()).then(function (response) {
          if (response.data) {
            scope.requestId = reqtId;
            scope.relatedTests = {};
            if (scope.tempBucket.length > 0) {
              scope.tempBucket = [];
            }
            scope.relatedTests = response.data.allowedInvestigations;
            scope.testsObj = {};
            $(scope.relatedTests).each(function (i, v) {
              scope.testsObj[v.id] = v;
            })
          }
        });
      },
      removeFromBucket: function (checkedItem) {
        checkedItem.checkTest = false;
        scope.relatedTests.push(checkedItem);
        scope.tempBucket.splice(scope.tempBucket.indexOf(checkedItem), 1)
      }
    };
  })();
  

  //Resend Maill
  scope.ResendEmail = function () {
    var resendMailRequest = {
      requestID: rootScope.requestIdForActiveAppointmnents,
      statusID: $('#emailType').val(),
      emailID: scope.resendEmailDetails.emailID
    }
    UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/resendEmailForAppointment/', resendMailRequest, 'POST').then(function (response) {
      if (response.data.isSuccess == true) {
        $('#ResendEmailModal').modal('hide');
        $('#email').val('');
        $('#emailType').val('');
      }
    });
  };

  scope.getPackageTestDetails = function (productId, noProductId) {
    if (noProductId) {
      scope.investigationList = [];
      return;
    } else {
      var pId = productId ? productId : '';
      scope.investigationList = [];
      if (pId) {
        var url = UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/' + pId;
        UserService.makeRestCall(url, '', 'GET', UserService.getAccessToken()).then(function (response) {
          if (response.data) {
            var investigation = response.data.allowedInvestigations;
            var investigationGroup = [];
            angular.forEach(investigation, function (v, i) {
              investigationGroup.push(v.groupName);
            })
            var listOfUniqeInvestigations = investigationGroup.filter(function (val, index, allArr) {
              return index == allArr.indexOf(val);
            })
            angular.forEach(listOfUniqeInvestigations, function (val, ind) {
              var investigationWiseTests = filterFilter(investigation, val);
              var testObj = investigationWiseTests;
              scope.testDetails = [];
              angular.forEach(testObj, function (v, i) {
                scope.testDetails.push({
                  groupName: v.groupName,
                  testName: v.name,
                  testId: v.id,
                  groupId: v.groupId,
                  isActive: v.isActive,
                  duplicateCheck: v.duplicateCheck,
                  quantity: v.quantity
                })
              })
              scope.investigationList.push({
                investigationName: val,
                testDetails: scope.testDetails
              })
            })
            // console.log(scope.investigationList);
          } else {
              UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          }
        })
      } else {
          UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
      }
    }
  };

  if(state.current.name ==='unconfirmedorder'){
      //Call load unconfirmed order
      scope.loadUnconfirmedOrder();
  }else if(state.current.name ==='unapprovedcancel'){

    scope.loadAppointments();
  }

    
}]);

angular.module('mbplus')
  .controller('tpaConfigurationCtrl', ['$rootScope','$scope', '$timeout', 'UserService', 'UtilitiesService', '$state', '$location', '$window','ngDialog', function (rootScope,scope, $timeout, UserService, UtilitiesService, state, $location, $window,ngDialog) {

    UserService.checkForSession();
    scope.maxSize = 5;
    scope.currentPage = 1;
    scope.mailConfigurationList = [{
        mailBoxType: "GMAIL",
        mailServerAddress: "pop.gmail.com",
        mailServerPort: 995,
        outGoingServerAddress: "smtp.gmail.com",
        outGoingServerPort: 587
      },
      {
        mailBoxType: "YAHOO",
        mailServerAddress: "pop.mail.yahoo.com",
        mailServerPort: 995,
        outGoingServerAddress: "smtp.mail.yahoo.com",
        outGoingServerPort: 587
      },
      {
        mailBoxType: "HOTMAIL",
        mailServerAddress: " pop-mail.outlook.com",
        mailServerPort: 995,
        outGoingServerAddress: "smtp-mail.outlook.com",
        outGoingServerPort: 587
      }
    ]
  
    scope.isSuccess = false;
    scope.isError = false;
    scope.resetAlertMessage = function () {
      $timeout(function () {
        scope.$apply(function () {
          scope.isSuccess = false;
          scope.isError = false;
        });
      }, 6000)
    };

    scope.closeConfigModal = function () {
      $timeout(function () {
        angular.element("#addAndUpdateTPA").modal('hide');
      }, 4000)
    }

    scope.tpaFormReset = function () {
      scope.tpaForm = {
        name: {
          id: 0,
          value: '--Select TPA Name--'
        },
        mailServerAddress: '',
        mailServerPort: '',
        useSSl: '',
        hospMailId: '',
        hospPassword: '',
        tpaMailId: '',
        outGoingServerPort: '',
        tpaHospId: '',
        outGoingServerAddress: '',
        tpaId: 0,
        hospTPAId: 0,
        tpamailsIds: '',
        additionMails: '',
        additionMailsCollection: [],
      }
      scope.isEmailConfigSuccess=false;
    };
    scope.isEdit = false;
    scope.tpaFormReset();
    scope.addTpa = function (type) {

      scope.tpaFormReset();
      if (scope.mailConfiguration) {
        scope.tpaForm.mailServerAddress = scope.mailConfiguration.mailServerAddress;
        scope.tpaForm.mailServerPort = scope.mailConfiguration.mailServerPort;
        scope.tpaForm.useSSl = true;
        scope.tpaForm.hospMailId = scope.mailConfiguration.hospMailId;
        scope.tpaForm.hospPassword = scope.mailConfiguration.hospPassword;
        scope.tpaForm.outGoingServerPort = scope.mailConfiguration.outGoingServerPort;
        scope.tpaForm.outGoingServerAddress = scope.mailConfiguration.outGoingServerAddress;
        scope.tpaForm.tpaId = scope.mailConfiguration;
      }
      angular.element("#addAndUpdateTPA").modal('show');
      scope.isEdit = false;
    };

    scope.getTPAList = function () {
      scope.TPAListData = [];
      var ajaxData = {
        LookUpType: 'TPA'
      };
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'Master/getPayerMaster', ajaxData, 'GET').then(function (response) {
        if (response.data) {
          scope.TPAListData = response.data.filter(function(data){
            return data.id!=UtilitiesService.getMaTpaId();
          });

          scope.TPAListData.push({
            id: 0,
            value: '--Select Payer Name--'
          });
          scope.TPAListData = _.sortBy(scope.TPAListData, function (num) {
            return num.value;
          });
          scope.tpaForm.name = {
            id: 0,
            value: '--Select Payer Name--'
          };
        }
      }, function (error) {
        scope.TPAListData = [];
      });
    };
    if (scope.user && scope.user.isActive) {
      scope.getTPAList();
    }

    scope.getMailConfiguration = function (mailType) {
      var mailConfig = scope.mailConfigurationList.find(function (data) {
        return data.mailBoxType == mailType
      })

      if (mailConfig) {
        scope.tpaForm.mailServerAddress = mailConfig.mailServerAddress;
        scope.tpaForm.mailServerPort = mailConfig.mailServerPort;
        scope.tpaForm.outGoingServerAddress = mailConfig.outGoingServerAddress;
        scope.tpaForm.outGoingServerPort = mailConfig.outGoingServerPort;
      }
    }



    // scope.getTpaList = function () {
    //     if (UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId) {
    //         UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/' + UserService.getHospitalObj().cmsHospId + '/tpas', '', 'GET').then(function (response) {
    //             if (response.data.isSucces) {
    //                 scope.tpaList = response.data.tpaList;
    //                 scope.totalItems = scope.tpaList.length;
    //             }
    //         }, function (error) {
    //             scope.tpaList = [];
    //             scope.totalItems = scope.tpaList.length;
    //         });
    //     }
    // };
    // scope.getTpaList();

    scope.tpaList = UtilitiesService.getConfiguredTpa();

    if (scope.tpaList && scope.tpaList.length > 0) {
      scope.mailConfiguration = scope.tpaList[scope.tpaList.length - 1];
    }

    scope.tpaErrorMsg = '';
    scope.saveTpaDetails = function (tpaForm) {
      var method = scope.isEdit === false ? 'POST' : 'PUT';
      if (UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId && tpaForm.name.id !== 0) {
        var data = {
          hospTPAId: tpaForm.hospTPAId,
          hospId: UserService.getHospitalObj().cmsHospId,
          tpaName: tpaForm.name.value,
          tpaId: tpaForm.name.id,
          mailServerAddress: tpaForm.mailServerAddress,
          mailServerPort: tpaForm.mailServerPort,
          useSSl: true,
          hospMailId: tpaForm.hospMailId,
          hospPassword: tpaForm.hospPassword,
          tpaMailId: tpaForm.tpaMailId,
          outGoingServerPort: tpaForm.outGoingServerPort,
          tpaHospId: tpaForm.tpaHospId,
          outGoingServerAddress: tpaForm.outGoingServerAddress,
          tpaMailIdCSV: scope.additionMailsCollection && scope.additionMailsCollection.length > 0 ? scope.additionMailsCollection.join(',') : null
        }
        //UtilitiesService.getUrlPrefix() + '/hosp/tpa
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tpa', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
          if (response.data.isSuccess) {
            scope.isSuccessMsg = scope.tpaForm.hospTPAId > 0 ? 'TPA has been updated successfully!.' : 'TPA has been added successfully!.';

            if (scope.tpaForm.hospTPAId > 0) {

            } else {
              scope.tpaFormReset();
            }
            scope.isSuccess = true;
            scope.isEmailConfigSuccess=false;
            scope.isEmailConfigFailed=false;
            UtilitiesService.setConfiguredTpa(response.data.tpaList);
            scope.closeConfigModal();
            scope.resetAlertMessage();
            $window.location.reload();

          } else {
            scope.isError = true;
            scope.tpaErrorMsg = 'oops! something went wrong, please try again later.';
            scope.resetAlertMessage();
          }
        }, function (error) {
          scope.isError = true;
          scope.tpaErrorMsg = 'oops! something went wrong, please try again later.';
          scope.resetAlertMessage();
        });
      } else {
        scope.isError = true;
        scope.tpaErrorMsg = 'Please select TPA name.';
        scope.resetAlertMessage();
      }
    };
    scope.addTpaMails = function (value) {
      if (value) {
        scope.tpaForm.tpamailsIds = '';
        if (!scope.additionMailsCollection) {
          scope.additionMailsCollection = [];
        }
        scope.additionMailsCollection.push(value);
        //scope.tpaForm.additionMails = scope.additionMailsCollection.join(',');
        scope.tpaForm.tpaMailId = '';
      }
    };

    scope.RemoveEmail = function (index) {
      if (scope.additionMailsCollection[index] != undefined && scope.additionMailsCollection[index] != null) {
        scope.additionMailsCollection.splice(index, 1);
      };
    };

    scope.editTPA = function (item) {
      scope.tpaForm.name = {
        id: item.tpaId,
        value: item.tpaName
      };
      scope.additionMailsCollection=[];
      if(item.tpaMailId)
        scope.additionMailsCollection.push(item.tpaMailId);
      var emailIds=item.tpaMailIdCSV.split(',');
      angular.forEach(emailIds,function(data){
        scope.additionMailsCollection.push(data);
      })
      
      scope.tpaForm.mailServerAddress = item.mailServerAddress;
      scope.tpaForm.mailServerPort = item.mailServerPort;
      scope.tpaForm.useSSl = true;
      scope.tpaForm.hospMailId = item.hospMailId;
      scope.tpaForm.hospPassword = item.hospPassword;
      //scope.tpaForm.tpaMailId = item.tpaMailId;
      scope.tpaForm.outGoingServerPort = item.outGoingServerPort;
      scope.tpaForm.tpaHospId = item.tpaHospId;
      scope.tpaForm.outGoingServerAddress = item.outGoingServerAddress;
      scope.tpaForm.tpaId = item;
      scope.isEdit = true;
      scope.tpaForm.hospTPAId = item.hospTPAId;      
      angular.element("#addAndUpdateTPA").modal('show');
    };

 
 
    scope.enableAddTpa = function () {
      scope.isEmailConfigFailed=false;
      var data = {
        hospTPAId: scope.tpaForm.hospTPAId,
        hospId: UserService.getHospitalObj().cmsHospId,
        tpaName: scope.tpaForm.name.value,
        tpaId: scope.tpaForm.name.id,
        mailServerAddress: scope.tpaForm.mailServerAddress,
        mailServerPort: scope.tpaForm.mailServerPort,
        useSSl: true,
        hospMailId: scope.tpaForm.hospMailId,
        hospPassword: scope.tpaForm.hospPassword,
        tpaMailId: scope.tpaForm.tpaMailId,
        outGoingServerPort: scope.tpaForm.outGoingServerPort,
        tpaHospId: scope.tpaForm.tpaHospId,
        outGoingServerAddress: scope.tpaForm.outGoingServerAddress,
        tpaMailIdCSV: scope.additionMailsCollection && scope.additionMailsCollection.length > 0 ? scope.additionMailsCollection.join(',') : null,
        message: "Mail Configuration done successfully",
        testEmail: scope.tpaForm.hospMailId
      };
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/PayerTestEmail', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
        if (response.data.isSuccess) {
          scope.isEmailConfigSuccess = true;
          scope.isEmailConfigFailed=false;
        } else {
          scope.isEmailConfigSuccess = false;
          scope.isEmailConfigFailed= true;
        }
      });
    }
    scope.$on('PayerData', function (key, value) {      
        var item=scope.tpaList[0];
        if(scope.tpaList.length>0) 
        {
         scope.editTPA(item);
        }  
    });
  }
]);

angular.module('mbplus')
.controller('tpaNewAdmissionCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$stateParams', '$analytics', function (scope, $location, UserService, UtilitiesService, filterFilter, $stateParams, $analytics) {
    $analytics.pageTrack('/newAdmission');
    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() === 'insurer') {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    scope.user = UserService.getUserObj();
}]);
angular.module('mbplus')
.controller('signupCtrl', ['$rootScope', '$scope', '$state', '$analytics', 'UtilitiesService', 'UserService', 'FileUploadService', '$q', '$http', function ($rootScope, scope, state, analytics, UtilitiesService, UserService, FileUploadService, $q, $http) {

    analytics.pageTrack('/signup');
    analytics.pageTrack('/');
    scope.ctrlName = 'signupCtrl';
    scope.isNewCertificationName = false;
    //
    scope.signupForm = {
        basicInformation: {
            certification: {}
        },
        contact: {
            address: {},
            contactDetails: {},
            chiefExecutive: {},
            operations: {},
            finance: {}
        },
        services: {
            clinical: {},
            emergency: {},
            radiology: {},
            laboratory: {},
        },
        rooms: {},
        documents: {
            inPatient: {},
            outPatient: {}
        }
    }
    scope.emailchk = /^(([^<>()[\]\\.,;:\s@\']+(\.[^<>()[\]\\.,;:\s@\']+)*)|(\'.+\'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    scope.numberCheck = '^(\+[\d]{1,3}|0)?[7-9]\d{9}$';
    scope.dynamicFields = {
        newCertificationName: '',
        rooms: {
            name: '',
            noOfRooms: '',
            bedsPerRooms: ''
        }
    }

    scope.signupTab = [{ name: 'Basic Information', href: 'receiving/#details__patent', icon: 'glyphicon-tasks', classType: 'active' },
        { name: 'Contact Details', href: 'receiving/#details__aliment', icon: 'glyphicon-record', classType: '' },
        { name: 'Services', href: 'receiving/#details__hospital', icon: 'glyphicon-record', classType: '' },
        { name: 'Rooms', href: 'receiving/#details__admission', icon: 'glyphicon-record', classType: '' },
        { name: 'Documents', href: 'receiving/#submit', icon: 'glyphicon-record', classType: '' }
    ];
    scope.tab = {
        isFirstTab: true,
        isSecondTab: false,
        isThirdTab: false,
        isFourthTab: false,
        isFifthTab: false
    }

    scope.certificationData = [{ name: 'ISO', isSelected: false }, { name: 'NABH', isSelected: false }, { name: 'NABL', isSelected: false }, { name: 'JCI', isSelected: false }, { name: 'JCI', isSelected: false }];
    scope.clinicalServicesData = [
        { name: 'Aerospace medicine', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Alternative therapy', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Anaesthesiology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Andrology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Audiology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Bariatric surgery', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Cardiac surgery', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Cardio thoracic surgery', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Cardiology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Dentistry', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Dermatology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Diabetology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Dietetics', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Emergency medicine', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Endocrinology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'ENT', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Fetal medicine', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Gastroenterology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'General medicine', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'General surgery', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Geriatrics', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Immunology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Infertility medicine', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Intensivist', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Neonatology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Nephrology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Neuro surgery', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Neurology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Obstetrics & gynaecology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Onco surgery', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Oncology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Ophthalmology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Orthopaedics', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Paediatrics', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Pain management', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Physiotherapy', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Plastic surgery / Cosmetic surgery', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Podiatrist', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Psychiatry', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Psychology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Pulmonology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Radiation oncology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Rheumatology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Spine surgeon', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Sports medicine', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Surgical oncology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Transplant surgery', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Urology', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] },
        { name: 'Vascular surgery', selectedService: '', servicename: [{ name: 'InPatient' }, { name: 'OutPatient' }, { name: 'Both' }] }
    ]

    scope.radiologyServices = [
      { name: 'X-ray unit (digital)', selectedRadiologyService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
      { name: 'X-ray unit (non-digital))', selectedRadiologyService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
      { name: 'Mammography', selectedRadiologyService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
      { name: 'Ultrasound (non-doppler)', selectedRadiologyService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
      { name: 'Colour doppler ultrasound', selectedRadiologyService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
      { name: 'Fluoroscopy', selectedRadiologyService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
      { name: 'CT scanner', selectedRadiologyService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
      { name: 'MRI scanner', selectedRadiologyService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
      { name: 'PET scanner', selectedRadiologyService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
      { name: 'Image intensifier', selectedRadiologyService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
      { name: 'Mobile x-ray', selectedRadiologyService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
      { name: 'Nuclear medicine', selectedRadiologyService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] }
    ]

    scope.laboratoryServices = [
         { name: 'Blood biochemistry', selectedLaboratoryService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
          { name: 'Haematology', selectedLaboratoryService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
           { name: 'Microbiology', selectedLaboratoryService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
           { name: 'Cytology', selectedLaboratoryService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
           { name: 'Immunology', selectedLaboratoryService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] },
           { name: 'Blood bank & Transfusion services', selectedLaboratoryService: '', servicename: [{ name: 'Yes' }, { name: 'No' }] }
    ]

    scope.roomsData = [
        { name: 'Day-care unit', noOfRooms: '', bedsPerRoom: '' },
        { name: 'General ward', noOfRooms: '', bedsPerRoom: '' },
        { name: 'Semi private rooms', noOfRooms: '', bedsPerRoom: '' },
        { name: 'Private rooms', noOfRooms: '', bedsPerRoom: '' },
        { name: 'Consulting rooms', noOfRooms: '', bedsPerRoom: '' },
        { name: 'Treatment rooms', noOfRooms: '', bedsPerRoom: '' },
        { name: 'Intensive care unit (ICU)', noOfRooms: '', bedsPerRoom: '' },
        { name: 'High dependency unity (HDU)', noOfRooms: '', bedsPerRoom: '' },
        { name: 'Coronary care unit (CCU)', noOfRooms: '', bedsPerRoom: '' },
        { name: 'Neonatal intensive care unit (NICU)', noOfRooms: '', bedsPerRoom: '' },
        { name: 'Paediatric intensive care unit (PICU', noOfRooms: '', bedsPerRoom: '' },
        { name: 'Isolation rooms', noOfRooms: '', bedsPerRoom: '' },
        { name: 'Total number of imaging rooms', noOfRooms: '', bedsPerRoom: '' },
    ]

    scope.inPatientDocuments = [
       { name: 'Tariff : Excel upload*', filePath: '', isRequired: true },
       { name: 'Hospital brochure', filePath: '', isRequired: false },
       { name: 'Hospital registration certificate*', filePath: '', isRequired: true },
       { name: 'PAN card*', filePath: '', isRequired: true },
       { name: 'Cancelled cheque', filePath: '', isRequired: false },
       { name: 'Certification for organ transplant', filePath: '', isRequired: false },
       { name: 'Pollution control board certificate', filePath: '', isRequired: true },
       { name: 'Other certificates', filePath: '', isRequired: false },
       { name: '17/2 tax exemption', filePath: '', isRequired: false },
       { name: 'TDS exemption certificate', filePath: '', isRequired: false },
       { name: 'Service tax registration certificate', filePath: '', isRequired: false },
       { name: 'Accreditation certificate', filePath: '', isRequired: false },
       { name: 'Hospital packages', filePath: '', isRequired: false },
    ]

    scope.outPatientDocuments = [
         { name: 'OP Tariff : Excel upload*', filePath: '', isRequired: true },
         { name: 'Centre brochure', filePath: '', isRequired: false },
         { name: 'PAN card*', filePath: '', isRequired: true },
         { name: 'Cancelled cheque', filePath: '', isRequired: false },
         { name: 'Pollution control board certificate*', filePath: '', isRequired: true },
         { name: 'Other certificates', filePath: '', isRequired: false },
         { name: '17/2 tax exemption', filePath: '', isRequired: false },
         { name: 'TDS exemption certificate', filePath: '', isRequired: false },
         { name: 'Service tax registration certificate', filePath: '', isRequired: false },
         { name: 'Accreditation certificate', filePath: '', isRequired: false },
         { name: 'Health Check Packages', filePath: '', isRequired: false },
    ]

    scope.tabCss = function (tabData) {
        angular.forEach(scope.signupTab, function (data, index) {
            scope.signupTab[index].classType = '';
            if (data.name === tabData) {
                scope.signupTab[index].classType = 'active';
            }
        });
    };

    scope.validateBasicInformation = function () {
        var status = false;
        if (scope.signupForm.basicInformation && scope.signupForm.basicInformation.providerType && scope.signupForm.basicInformation.servicesOffered && scope.signupForm.basicInformation.ProviderTypeName && scope.signupForm.basicInformation.ownership && scope.signupForm.basicInformation.registrationNumber) {
            status = true
        }
        return status
    };

    scope.validateContactInformation = function () {
        var status = false;
        if (scope.signupForm.contact
            && scope.signupForm.contact.address.Building && scope.signupForm.contact.address.streetOrArea
            && scope.signupForm.contact.address.location && scope.signupForm.contact.address.city
            && scope.signupForm.contact.address.state && scope.signupForm.contact.address.pincode
            && scope.signupForm.contact.contactDetails.landlineNumber && scope.signupForm.contact.contactDetails.emailAddress
            && scope.signupForm.contact.chiefExecutive.name && scope.signupForm.contact.chiefExecutive.mobileNumber
            && scope.signupForm.contact.chiefExecutive.emailAddress && scope.signupForm.contact.operations.name
            && scope.signupForm.contact.operations.mobileNumber && scope.signupForm.contact.operations.emailAddress
            && scope.signupForm.contact.finance.name && scope.signupForm.contact.finance.mobileNumber
            && scope.signupForm.contact.finance.emailAddress) {
            status = true
        }
        return status
    };

    scope.validateDocuments = function () {
        var status = false;
        if (scope.signupForm && scope.signupForm.basicInformation.servicesOffered === 'Out-Patient Services') {
            status = _.where(scope.signupForm.documents.outPatient, { isRequired: true }).length >= 3 ? true : false;
        } else if (scope.signupForm && scope.signupForm.basicInformation.servicesOffered === 'In-patient Services') {
            status=  _.where(scope.signupForm.documents.inPatient, { isRequired: true }).length >= 3 ? true : false;
        } else if (scope.signupForm && scope.signupForm.basicInformation.servicesOffered === 'Both') {
            if (_.where(scope.signupForm.documents.inPatient, { isRequired: true }).length >= 3 && _.where(scope.signupForm.documents.outPatient, { isRequired: true }).length >= 3) {
                status = true;
            }
        }
        return status
    };

    scope.goMain = function () {
        state.go('home', {}, { reload: true });
    };

    scope.saveEmpanelmentForm = function () {
        var data = {
            hospObj: JSON.stringify(scope.signupForm)
        }
        if (scope.validateDocuments() && scope.validateContactInformation() && scope.validateBasicInformation()) {
            var url = UtilitiesService.getUrlPrefix() + '/Hosp/HospEmpanalement';
            UserService.makeRestCall(url, data, 'POST').then(function (response) {
                if (response.data.IsSuccess) {
                    UtilitiesService.showAlertMessage('Thanks! You for registration, will contact you soon.', true);
                    scope.goMain();
                } else {
                    UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
                }
            },
            function (error) {
                UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            });
        } else {
            UtilitiesService.showAlertMessage('Please fill required fileds.');
        }
    };

    scope.tabCssDefalut = function (name) {
        scope.tab.isFirstTab = name === 'Basic Information' ? true : false;
        scope.tab.isSecondTab = name === 'Contact Details' ? true : false;
        scope.tab.isThirdTab = name === 'Services' ? true : false;
        scope.tab.isFourthTab = name === 'Rooms' ? true : false;
        scope.tab.isFifthTab = name === 'Documents' ? true : false;
    };

    scope.tabValidation = function (tabData) {
        if ((tabData && scope.validateBasicInformation()) || tabData.name === 'Basic Information') {
            if (tabData.name === 'Services' || tabData.name === 'Rooms' || tabData.name === 'Documents') {
                if (scope.validateBasicInformation() && scope.validateContactInformation()) {
                    scope.tabCssDefalut(tabData.name);
                    scope.tabCss(tabData.name);
                } else {
                    UtilitiesService.showAlertMessage('Please fill missing fileds.');
                }
            } else {
                scope.tabCssDefalut(tabData.name);
                scope.tabCss(tabData.name);
            }

        } else {
            UtilitiesService.showAlertMessage('Please fill missing fileds.');
        }
    };

    scope.goBack = function (next, previous) {
        if (next && scope.validateBasicInformation()) {
            if (next === 'Services' || next === 'Rooms' || next === 'Documents') {
                if (scope.validateBasicInformation() && scope.validateContactInformation()) {
                    scope.tabCssDefalut(next);
                    scope.tabCss(next);
                } else {
                    UtilitiesService.showAlertMessage('Please fill missing fileds.');
                }
            } else {
                scope.tabCssDefalut(next);
                scope.tabCss(next);
            }


        } else {
            UtilitiesService.showAlertMessage('Please fill missing fileds.');
        }
    };

    scope.goNext = function (next, previous) {
        if (next && scope.validateBasicInformation()) {
            if (next === 'Services' || next === 'Rooms' || next === 'Documents') {
                if (scope.validateBasicInformation() && scope.validateContactInformation()) {
                    scope.tabCssDefalut(next);
                    scope.tabCss(next);
                } else {
                    UtilitiesService.showAlertMessage('Please fill missing fileds.');
                }
            } else {
                scope.tabCssDefalut(next);
                scope.tabCss(next);
            }


        } else {
            UtilitiesService.showAlertMessage('Please fill missing fileds.');
        }
    };

    scope.uploadFileMethod = function (docsSata, type) {
        scope.fileDocData = {
            type: type,
            docsSata: docsSata
        }
        var fileBlobArray = [];
        var file = UtilitiesService.uploadFileData;
        if (file) {
            var fd = new FormData();
            fd.append('file', file);
            $http.post(UtilitiesService.getUrlPrefix() + '/hosp/file/DMS/upload', fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            })
            .success(function (data) {
                UtilitiesService.uploadFileData = '';
                if (data.isSuccess) {
                    scope.uploadedFileData = data.uploadResponseDetails;
                    UtilitiesService.showAlertMessage('File uploaded successfully.', true);
                    if (scope.fileDocData.type === 'outPatientDocs') {
                        angular.forEach(scope.outPatientDocuments, function (data, index) {
                            if (data.name === scope.fileDocData.docsSata.name) {
                                scope.outPatientDocuments[index].files = scope.uploadedFileData;
                            }
                        });
                    } else if (scope.fileDocData.type === 'inPatientDocs') {
                        angular.forEach(scope.inPatientDocuments, function (data, index) {
                            if (data.name === scope.fileDocData.docsSata.name) {
                                scope.inPatientDocuments[index].files = scope.uploadedFileData;
                            }
                        });
                    }
                } else {
                    UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
                }
            })
            .error(function (error) {
                UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            });
        } else {
            UtilitiesService.showAlertMessage('Please attach document');
        }
    };

    scope.addNewCertification = function (falg, data) {
        if (falg) {
            var value = _.filter(scope.certificationData, function (item) { return item.name.toLowerCase() === data.toLowerCase() }).length;
            if (value === 0) {
                scope.certificationData.push({ name: data, isSelected: false });
                scope.dynamicFields.newCertificationName = '';
            } else {
                UtilitiesService.showAlertMessage('Duplicate value is not allowed.');
            }
        } else {
            scope.isNewCertificationName = true;
        }
    };

    scope.addMoreRooms = function (falg, data) {
        if (falg) {
            var value = _.filter(scope.roomsData, function (item) { return item.name.toLowerCase() === data.name.toLowerCase() }).length;
            if (value === 0) {
                scope.roomsData.push({ name: data.name, noOfRooms: data.noOfRooms, bedsPerRoom: data.bedsPerRooms });
                scope.dynamicFields.rooms.name = '';
                scope.dynamicFields.rooms.noOfRooms = '';
                scope.dynamicFields.rooms.bedsPerRooms = '';
            } else {
                UtilitiesService.showAlertMessage('Duplicate value is not allowed.');
            }
        } else {
            scope.isNewRooms = true;
        }
    };

    scope.closeButton = function () {
        scope.isNewCertificationName = false;
        scope.isNewRooms = false;
        scope.dynamicFields.newCertificationName = '';
        scope.dynamicFields.rooms.name = '';
        scope.dynamicFields.rooms.noOfRooms = '';
        scope.dynamicFields.rooms.bedsPerRooms = '';
    };

    scope.goSingup = function () {
        if (scope.validateBasicInformation() && scope.validateContactInformation()) {
            var clinicalServicesData = [], certificationDataSet = [], radiologyServices = [], laboratoryServices = [], roomsData = [], inPatientDocuments = [], outPatientDocuments = [];
            angular.forEach(scope.certificationData, function (item, index) {
                if (item.isSelected) {
                    certificationDataSet.push(scope.certificationData[index])
                }
            });
            angular.forEach(scope.clinicalServicesData, function (item, index) {
                if (item.selectedService) {
                    clinicalServicesData.push(scope.clinicalServicesData[index])
                }
            });
            angular.forEach(scope.radiologyServices, function (item, index) {
                if (item.selectedRadiologyService === 'Yes') {
                    radiologyServices.push(scope.radiologyServices[index])
                }
            });
            angular.forEach(scope.laboratoryServices, function (item, index) {
                if (item.selectedLaboratoryService === 'Yes') {
                    laboratoryServices.push(scope.laboratoryServices[index])
                }
            });
            angular.forEach(scope.roomsData, function (item, index) {
                if (item.noOfRooms || item.bedsPerRoom) {
                    roomsData.push(scope.roomsData[index]);
                }
            });
            angular.forEach(scope.inPatientDocuments, function (item, index) {
                if (item.files && item.files.length > 0) {
                    _.first(scope.inPatientDocuments[index].files).downloadURL = UtilitiesService.getDMSHostUrl() + _.first(item.files).downloadURL;
                    inPatientDocuments.push(scope.inPatientDocuments[index]);
                }
            });
            angular.forEach(scope.outPatientDocuments, function (item, index) {
                if (item.files && item.files.length > 0) {
                    _.first(scope.outPatientDocuments[index].files).downloadURL = UtilitiesService.getDMSHostUrl() + _.first(item.files).downloadURL;
                    outPatientDocuments.push(scope.outPatientDocuments[index]);
                }
            });
            scope.signupForm.basicInformation.certification = certificationDataSet;
            scope.signupForm.services.clinical = clinicalServicesData;
            scope.signupForm.services.radiology = radiologyServices;
            scope.signupForm.services.laboratory = laboratoryServices;
            scope.signupForm.rooms = roomsData;
            scope.signupForm.documents.inPatient = inPatientDocuments;
            scope.signupForm.documents.outPatient = outPatientDocuments;
            scope.saveEmpanelmentForm();
        } else {
            UtilitiesService.showAlertMessage('Please fill required fileds.');
        }
    }

    

}]);

angular.module('mbplus')
.controller('SharedCtrl', ['$scope', '$rootScope', '$location', '$http', 'UserService', 'UtilitiesService', 'PlusUtilitiesService','$interval','$cookieStore', function (scope, rootScope, $location, $http, UserService, UtilitiesService, PlusUtilitiesService,$interval, $cookieStore) {
    rootScope.dynmaicClass = 'content-wrap';

    scope.getCSSClass = function() {
        if($location && $location.$$path){
            if($location.$$path === '/trackstatus/hdfc'){
                return 'content-wrap1';
            }else if($location.$$path === '/trackstatus/birla'){
                return 'content-wrap2';
            }else if($location.$$path === '/trackstatus/pnb'){
                 return 'content-wrap3';
            }else{
                return 'content-wrap';
            }
        }else{
            return 'content-wrap';
        } 
    };

    var path = $location.path();
    if ($location.search()) {
        var resetAccessToken = $location.search().token;
        var accessToken = $location.search().access_token;
        UtilitiesService.resetAccessToken = '';
        if(accessToken){
            $cookieStore.put('one_MediAssist', accessToken);
        }else{
            if ($location.$$path === '/bookappointment') {
                UserService.dcUrl = $location.search().details;
                UserService.IsRequestUpdate = $location.search().IsRequestUpdate == "true" ? true : false;
            } else if ($location.$$path === '/medicalprocess') {
                UserService.dcUrl = $location.search().details;
            }
            else if ($location.$$path === '/rescheduleAppointment') {
                UserService.dcUrl = $location.search().data;
            }
            else if ($location.$$path === '/provideraction') {
                
                var reqId = $location.search().RequestId;
                var providerId = $location.search().ProviderId;
                var currentStatusId = $location.search().CurrentStatus;
                var nextStatusId = $location.search().NextStatus;
                var emailId = $location.search().ProviderEmail;
                UserService.dcUrl = { reqId: reqId, currentStatusId: currentStatusId, nextStatusId: nextStatusId, emailId: emailId, providerId: providerId }
            }
            else if ($location.$$path === '/signup') {
            }
            else if ($location.$$path === '/markAutoAttendence') {
            }
            else if ($location.$$path === '/plannedCheck') {
                UtilitiesService.IsPlannedCheck = $location.search().isEcashless;
            }
            else if(accessToken){
            }else if (resetAccessToken) {
                if ($location.$$path === '/resetpassword') {
                    UtilitiesService.resetAccessToken = resetAccessToken;
                } else {
                    if (!UserService.getUserObj()) {
                        UserService.destroyUserObj();
                        return false;
                    }
                }
            } else {
                var pathData = $location.$$path.split('/');
                var plannedCheck = _.find(pathData, function (num) { return num === 'plannedCheck'; });
                if (plannedCheck === 'plannedCheck') {
                    UtilitiesService.IsPlannedCheck = pathData[2];
                }
                else {
                    if (!UserService.getUserObj()) {
                        UserService.destroyUserObj();
                        return false;
                    }
                }
            }
        }
    }
    
    scope.setupForSignalR = function (accessToken, data, cmsHospId) {
        if (data) {
            if($.connection && $.connection.hub){
                $.connection.hub.url = UtilitiesService.getUrlPrefixForSignalR();
                var chat = $.connection.notificationHub;
                $.connection.hub.start().done(function () {
                    chat.server.send(accessToken, $.connection.hub.id, cmsHospId);
                }).fail( function(error){
                });
                $interval(function () {
                    var cmsHospId ='';
                    if(UserService.getUserObj()){
                        if(UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId){
                            cmsHospId = UserService.getHospitalObj().cmsHospId;
                        }
                        $.connection.hub.url = UtilitiesService.getUrlPrefixForSignalR();
                        var chat = $.connection.notificationHub;
                        $.connection.hub.start().done(function () {
                            chat.server.send(UserService.getUserObj().accessToken, $.connection.hub.id, cmsHospId);
                        }).fail( function(error){
                        });
                    }
                }, 1000 * 60 * 5);
            }
        }
    };

    if(UserService.getUserObj() && UserService.getUserObj().accessToken){
        var cmsHospId = '';
        if(UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId){
            var cmsHospId = UserService.getHospitalObj().cmsHospId;
        }
        scope.setupForSignalR(UserService.getUserObj().accessToken, UserService.getUserObj(), cmsHospId)
    }
    
    scope.agreeTerms = function () {
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/user/termsacceptance', { userId: UserService.getUserObj().userId, accessToken: UserService.getAccessToken(), hospId: UserService.getUserObj().entityId, isAccepted: true }, 'POST')
        .then(function (response) {
          if (response.data.isSuccess) {
            var userObj = UserService.getUserObj();
            userObj.isTermsAccepted = true;
            UserService.setUserObj(userObj);
            scope.getUserDefaultRoute = UserService.getUserDefaultRoute(PlusUtilitiesService.getMenuDetails());
            $location.path(scope.getUserDefaultRoute).replace();
          }
          else {
              UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          }
        });
    };

}]);
angular.module('mbplus')
  .controller('signinCtrl', ['$rootScope', '$scope', '$state', '$location', '$window', 'UserService', 'UtilitiesService', 'md5', '$http', '$analytics', 'PlusUtilitiesService', 'filterFilter', '$timeout', 'GovernmentService', '$interval', '$cookieStore', 'ngDialog', "$uibModal", function (rootScope, scope, state, $location, $window, UserService, UtilitiesService, md5, $http, analytics, PlusUtilitiesService, filterFilter, timeout, GovernmentService, interval, $cookieStore, ngDialog, $uibModal) {

    analytics.pageTrack('/signin');


    scope.flagStatus = {
      isUserCheck: false
    };

    // scope.$watch('user.username', function(data,v){
    //     if(data){
    //         if(data.toLowerCase().match('mahs.i') || data.toLowerCase().match('mediassistindia.c')){
    //             scope.flagStatus.isUserCheck = true;
    //         }else{
    //             scope.flagStatus.isUserCheck = false;
    //         }
    //     }
    // }, true);

    
    scope.isToggleMenuApplicable = function () {
      scope.toggleMenuObj = {
        isMultiRole : false,
        dcRolePresent : false,
        dcRoleValue : null,
        isDcRoleActive : false,
        normalRolePresent : false,
        normalRoleValue : null,
        isNormalRoleActive : false
      }
      var DC_roles = ['DC_Admin','DC_Finance','DC_Operations'];
      var normal_roles = ['Admin','Finance','Operations'];

      if (scope.user && scope.user.rolesFeatures && scope.user.rolesFeatures.roles) {
        angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
          if(DC_roles.includes(v.roleName)){
            scope.toggleMenuObj.dcRolePresent =  true;
            scope.toggleMenuObj.dcRoleValue = v.roleName;
          }
          else if (normal_roles.includes(v.roleName)){
            scope.toggleMenuObj.normalRolePresent = true;
            scope.toggleMenuObj.normalRoleValue = v.roleName;
          }
        });
      }
      if (scope.toggleMenuObj.dcRolePresent && scope.toggleMenuObj.normalRolePresent) {
        scope.toggleMenuObj.isMultiRole = true;
        scope.toggleMenuObj.isNormalRoleActive = true;
        scope.toggleMenuObj.isDcRoleActive = false;
      }
    }

    //create feature List
    scope.reroute = function () {
      scope.getUserDefaultRoute = UserService.getUserDefaultRoute(PlusUtilitiesService.getMenuDetails());
      $location.path(scope.getUserDefaultRoute).replace()
    };
    
    scope.loadContracts = function () {
      var contracts = UtilitiesService.getContracts();
      if (contracts === null || contracts.length === 0) {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + '/contractlookup/contracts', '', 'GET').then(function (response) {
          if (scope.user.properties && scope.user.properties['assigned Contracts']) {
            response.data = filterFilter(response.data, {
              id: scope.user.properties['assigned Contracts'].split(',')
            }, function (actual, expected) {
              return filterFilter(expected, actual).length > 0;
            });
          } else if (scope.user.properties && scope.user.properties['Assigned Contracts']) {
            response.data = filterFilter(response.data, {
              id: scope.user.properties['Assigned Contracts'].split(',')
            }, function (actual, expected) {
              return filterFilter(expected, actual).length > 0;
            });
          }
          UtilitiesService.setContracts(response.data);
        },
          function (error) {
            if (error.status === -1) { } else {
              UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            }
          });
      }
    };

    scope.getProviderData = function () {
      if (UserService.getUserObj()) {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + '/Providers/' + UserService.getUserObj().entityId, '', 'GET').then(function (response) {
          if (response.data) {
            UtilitiesService.setProviderData(response.data);
            scope.reroute();
            scope.$emit('signedin', true);
            scope.$emit('utilazation', true);
          }
        },
          function (error) {
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          });
      }
    };

    scope.getConfiguredTpa = function () {
      if (UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId) {
        // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/' + UserService.getHospitalObj().hospId + '/tpas', '', 'GET').then(function (response) {
        // // UserService.makeRestCall(UtilitiesService.getPlusUrl() + '/Provider/PayerConfiguraion', {ProviderId:UserService.getHospitalObj().hospId}, 'POST',PlusUtilitiesService.getAccessToken()).then(function (response) {
        //   if (response.data.isSucces) {
        //     UtilitiesService.deleteConfiguredTpa();
        //     UtilitiesService.deletePayerExtensionFields();
        //     scope.configuredTpaList = _.sortBy(response.data.tpaList, function (data) {
        //       return data.tpaName;
        //     });

        //     scope.configuredPayerExtensionFields = response.data.fieldsConfig;
        //     if (scope.configuredPayerExtensionFields && scope.configuredPayerExtensionFields.length > 0) {
        //       UtilitiesService.setPayerExtensionFields(scope.configuredPayerExtensionFields);
        //     }
        //     UtilitiesService.setConfiguredTpa(scope.configuredTpaList)
        //     scope.enableTpaVerification();

        //   }
        // }, function (error) { });
      }
    };
    scope.enableTpaVerification = function () {            
      scope.isEmailConfigFailed=false;
      for(i=0;i<scope.configuredTpaList.length;i++) 
      {
          if(scope.configuredTpaList[i].isVerified)
          {
            scope.isEmailConfigSuccess = true;
            scope.isEmailConfigFailed=false;
          }else{            
            scope.OpenPayerPopup();
            scope.isEmailConfigSuccess = false;
            scope.isEmailConfigFailed= true;  
            break;      
          } 
        };
      }
    scope.OpenPayerPopup = function () {
      scope.payerInfoDialog = ngDialog.open({
        template: 'app/modules/signin/payerPopup.html',
        data: null,
        controller: 'payerPopupCtrl',
        width: 840,
        className: 'ngdialog-theme-default'
      });
    }
    scope.openAlertPopup = function (value) {

      var role = _.findWhere(value.roles, {
        roleId: 9216
      });
      if (role && role.roleId === 9216) { } else {
        angular.forEach(value.features, function (data, index) {
          if (data.featureName === 'activeclaims') {
            //scope.getPendingDocumentData();
            // scope.OpenPendingDocPopup();
          }
        });
      }

    };

    scope.getPendingDocumentData = function () {

      if (UserService.getHospitalObj()) {
        var ajxData = {
          hospitalId: UserService.getHospitalObj().cmsHospId,
          startIndexInclusive: scope.startIndex,
          toNoOfDays: 0,
          fromNoOfDays: 30,
          isAllPending: true
        };

        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/search/pdaclaims/', ajxData, 'POST').then(function (response) {
          if (response.data.isSuccess) {
            scope.allRecordCount = response.data.allRecordCount;
            if (scope.allRecordCount > 0) {
              scope.OpenPendingDocPopup(scope.allRecordCount);
            }
          }
        });
      }
    };

    scope.$on('closeSignInPopUpInfoDialog', function (key, value) {
      scope.updateClaimInfoDialog.close();
    });

    scope.OpenPendingDocPopup = function (value) {
      scope.updateClaimInfoDialog = ngDialog.open({
        template: 'app/modules/signin/signInPopup.html',
        data: {
          'pendingCount': value,
          'hospName': UserService.getHospitalObj().hospName
        },
        controller: 'signInPopupCtrl',
        width: 840,
        className: 'ngdialog-theme-default'
      });
    }

    // scope.closeMessageModal = function ( path ) {
    //     ;
    //     angular.element('#mediAssistAlert').modal('hide');
    //     $location.path( path );
    //   };

    scope.getUserProperties = function () {
      if (UserService.getUserObj()) {
        scope.openAlertPopup(UserService.getUserObj().rolesFeatures);
        var data = {
          accessToken: PlusUtilitiesService.getAccessToken()
        }
        // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/user/userproperty/', data, 'POST').then(function (response) {
        //   if (response.data) {
        //     UtilitiesService.setUserProperties(response.data);
        //   }
        // }, function (error) {
        //   UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        // });
      }
    };

    scope.returnFlag = function (data) {
      var result = false;
      angular.forEach(data, function (data, index) {
        if (data.roleId === 9203 || data.roleId === 9204) {
          result = true;
        }
      })
      return result;
    };

    scope.setupForSignalR = function (accessToken, data, cmsHospId) {
      if (data) {
        if ($.connection && $.connection.hub) {
          $.connection.hub.url = UtilitiesService.getUrlPrefixForSignalR();
          var chat = $.connection.notificationHub;
          $.connection.hub.start().done(function () {
            chat.server.send(accessToken, $.connection.hub.id, cmsHospId);
          }).fail(function (error) { });
          interval(function () {
            if (UserService.getUserObj()) {
              var cmsHospId = '';
              if (UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId) {
                cmsHospId = UserService.getHospitalObj().cmsHospId;
              }
              $.connection.hub.url = UtilitiesService.getUrlPrefixForSignalR();
              var chat = $.connection.notificationHub;
              $.connection.hub.start().done(function () {
                chat.server.send(UserService.getUserObj().accessToken, $.connection.hub.id, cmsHospId);
              }).fail(function (error) { });
            }
          }, 1000 * 60 * 5);
        }
      }
    };

    scope.getUserSystemInfo = function () {
      $.getJSON('//freegeoip.net/json/?callback=?', function (data) { });
    };


    function getGovtPackageListSuccess(resData) {
      if (resData && resData.data.isSuccess && resData.data.packages && resData.data.packages.length > 0) {
        scope.govtPackageList = resData.data.packages;
        UserService.setGovtPackageList(scope.govtPackageList);
      } else {
        if (resData.data.isSuccess === false) {
          scope.govtPackageList = [];
          UserService.setGovtPackageList(scope.govtPackageList);
        }
      }
    };

    function getGovtPackageListError(data) {

    }


    scope.checkUser = function(userName) {
      var arr = userName.split('@');
      if(arr.includes('policybazaar.com')) {
        UserService.isPolicyBazar = true;
      }
      else {
        UserService.isPolicyBazar = false;
      }
    }

    scope.signin = function () {
     
      scope.isErorMessageLogin = false;
      scope.isErorMessage = false;
      if (scope.user == null || scope.user == undefined || (
          scope.user.username === null || scope.user.username == undefined || 
          scope.user.password === null || scope.user.password == undefined || 
          scope.user.username.trim() === '' || scope.user.password.trim() === ''
        )
      ) {
        return false;
      }

      if($location.path() == '/masterLogin') {
        if (scope.user == null || scope.user == undefined || (
            scope.user.masterUsername === null || scope.user.masterUsername == undefined || 
            scope.user.masterPassword === null || scope.user.masterPassword == undefined || 
            scope.user.masterUsername.trim() === '' || scope.user.masterPassword.trim() === ''
          )
        ) {
          return false;
        }
      }

      scope.errorMessage = '';
      var data = {
        userName: scope.user.username,
        applicationId: 5385,
        password: scope.user.password
      };

      if($location.path() == '/masterLogin') {
        data['masterUserName'] = scope.user.masterUsername,
        data['masterUserPassword'] = scope.user.masterPassword
      }

      // UtilitiesService.startLoading('fetching user...', 'signinBox');
      UserService.makeRestCall(UtilitiesService.getProviderCoreUrl() + 'provider/Authenticate', data, 'POST').then(function (response) {
        if (response.data.isAuthenticated) {

          if(response.data.isOtpNeeded === undefined){
            scope.isErorMessageLogin = true;
            scope.errorMessage = "Something went wrong please try again!";
          } else if(response.data.isOtpNeeded) {
            if(!response.data.isSuccess) {

              scope.isErorMessageLogin = true;
              scope.errorMessage = "You dont have access to Login!";
            } else{

              var date = new Date();
              var modalInstance = $uibModal.open({
                keyboard: false,
                backdrop: 'static',
                templateUrl: '/app/components/plusModals/signInModal.html?version=22' + date,
                controller: ['$scope', '$rootScope', '$uibModalInstance',
                  function ($scope, $rootScope, $uibModalInstance, element) {

                    $scope.otp = '';
                    $scope.isWrongOTP = false;
                    $scope.errorMessage = null;
                    $scope.isSubmitting = false;
                    $scope.userId = scope.user.username;
                    $scope.otpValues = ['', '', '', '', ''];
                    $scope.encryptionToken = response.data.accessToken ? response.data.accessToken : '';
                    $scope.userEmail = response.data.otpSentOn ? response.data.otpSentOn : 'Registered EmailId';

                    $scope.handleOTPChange = function (index, value) {
                      $scope.numericPattern = /^[0-9]*$/;
                      if (value.length > 1 || !$scope.numericPattern.test(value)) {
                        return;
                      }

                      if ($scope.isWrongOTP) {
                        $scope.isWrongOTP = false;
                        $scope.errorMessage = null;
                      }

                      if (value.length === 1 && index < $scope.otpValues.length - 1) {
                        timeout(function () {
                          $scope.setFocus(index + 1);
                        }, 0);
                      }
                    };

                    $scope.handleBackspace = function (index) {
                      if ($scope.isWrongOTP) {
                        $scope.isWrongOTP = false;
                        $scope.errorMessage = null;
                      }

                      // if ($scope.otpValues[index] !== '') {
                      //   var newOtpValues = angular.copy($scope.otpValues);
                      //   newOtpValues[index] = '';

                      //   // $scope.otp = newOtpValues.join('');
                      //   // $scope.otpValues = newOtpValues;
                      // } 
                      
                      if (index > 0) {
                        timeout(function () {
                          $scope.setFocus(index - 1);
                        }, 0);
                      }
                    };

                    $scope.handleKeydown = function (event, index) {
                      if (event.key === 'Backspace') {
                        $scope.handleBackspace(index);
                      } else if (event.key.match(/^[0-9]$/)) {
                        $scope.handleOTPChange(index, event.key);                   
                      }
                    };
                
                    $scope.setFocus = function (index) {
                      angular.element('input[type="text"]')[index].focus();
                    };

                    $scope.isButtonDisabled = function () {
                      return (
                        $scope.otpValues.some(function (value) {
                          return value === '';
                        }) ||
                        $scope.isWrongOTP ||
                        $scope.isSubmitting
                      );
                    };

                    $scope.verifyOTP = function () {
                      $scope.isSubmitting = true;
                      var verifyOTPAPIRequestBody = {
                        otp: $scope.otpValues.join(''),
                        applicationId: 5385,
                        userId: $scope.userId,
                        encryptedToken: $scope.encryptionToken,
                      };

                      UserService.makeRestCall(UtilitiesService.getProviderCoreUrl() + 'provider/verifyOTP', verifyOTPAPIRequestBody, 'POST').then(function (response) {
                        if (response.data.success) {
                          localStorage.setItem('isHospUser', true);
                          if (response.data.hospDetails && response.data.hospDetails.isRemedinetAssociated && response.data.userDetails.role != 'CMS') {
                            response.data.userDetails.role = 'operations';
                          }

                          if (response.data.relatedEntities) {
                            $.grep(response.data.relatedEntities, function (e, i) {
                              if (e.relatedEntityId == response.data.userDetails.entityId) {
                                response.data.hospDetails.isHospAarogya = true;
                                return false;
                              }
                            });
                          }

                          var cmsHospId = response.data ? response.data.hospDetails ? response.data.hospDetails.cmsHospId : '' : '';
                          scope.setupForSignalR(response.data.accessToken, true, cmsHospId);
                          if (
                            response.data.userDetails.rolesFeatures && 
                            response.data.userDetails.rolesFeatures.features && 
                            response.data.userDetails.rolesFeatures.features.length > 0 && 
                            response.data.userDetails.rolesFeatures.roles && 
                            response.data.userDetails.rolesFeatures.roles.length > 0
                          ) {
                            scope.user = response.data.userDetails;
                            scope.loadContracts();
                            response.data.userDetails.accessTokenObj = undefined;
                            response.data.userDetails.accessToken = response.data.accessToken;
                            UserService.setUserObj(response.data.userDetails);
                            scope.checkUser(response.data.userDetails.userName);
                            UserService.setHospitalObj(response.data.hospDetails);
                            UserService.setAarogyaObj(response.data.relatedEntities);
                            scope.isToggleMenuApplicable();
                            UserService.setUserMenuToggle(scope.toggleMenuObj);
                            scope.getProviderData();
                            scope.getUserProperties();
                            scope.getConfiguredTpa();
                            if (response.data.userDetails.properties["Assigned Corporates"]) {
                              var properties = response.data.userDetails.properties["Assigned Corporates"];
                            } else {
                              var properties = response.data.userDetails.properties["assigned Corporates"];
                            }
                            UtilitiesService.setCorporates(properties);
                            scope.isErorMessageLogin = false;
                            scope.errorMessage = '';
                          } else {
                            scope.isErorMessageLogin = true;
                            scope.errorMessage = 'Unable to find role for current user.';
                          }
                          $scope.closeModal();
                          GovernmentService.getGovtPackageList().then(getGovtPackageListSuccess, getGovtPackageListError);
                          UtilitiesService.stopLoading('signinBox');  
                        } else{
                          timeout(function () {
                            $scope.isWrongOTP = true;
                            $scope.errorMessage = 'Something went wrong please try again!'
                          }, 0);
                        }
                      }, function (error) {
                        timeout(function () {
                          $scope.isWrongOTP = true;
                          $scope.errorMessage = error.data && error.data.error ? error.data.error : 'Something went wrong please try again!'
                        }, 0);
                      });
                      $scope.isSubmitting = false;
                    };

                    $scope.closeModal = function () {
                      $uibModalInstance.dismiss();
                    };
                    
                  }
                ]
              });
            }
          } else if(!response.data.isOtpNeeded) {

            localStorage.setItem('isHospUser', true);
            if (response.data.hospDetails && response.data.hospDetails.isRemedinetAssociated && response.data.userDetails.role != 'CMS') {
              response.data.userDetails.role = 'operations';
            }

            if (response.data.relatedEntities) {
              $.grep(response.data.relatedEntities, function (e, i) {
                if (e.relatedEntityId == response.data.userDetails.entityId) {
                  response.data.hospDetails.isHospAarogya = true;
                  return false;
                }
              });
            }

            var cmsHospId = response.data ? response.data.hospDetails ? response.data.hospDetails.cmsHospId : '' : '';
            scope.setupForSignalR(response.data.accessToken, true, cmsHospId);
            if (response.data.userDetails.rolesFeatures && 
              response.data.userDetails.rolesFeatures.features && 
              response.data.userDetails.rolesFeatures.features.length > 0 && 
              response.data.userDetails.rolesFeatures.roles && 
              response.data.userDetails.rolesFeatures.roles.length > 0
            ) {
              scope.user = response.data.userDetails;
              scope.loadContracts();
              response.data.userDetails.accessTokenObj = undefined;
              response.data.userDetails.accessToken = response.data.accessToken;
              UserService.setUserObj(response.data.userDetails);
              scope.checkUser(response.data.userDetails.userName);
              UserService.setHospitalObj(response.data.hospDetails);
              UserService.setAarogyaObj(response.data.relatedEntities);
              scope.isToggleMenuApplicable();
              UserService.setUserMenuToggle(scope.toggleMenuObj);
              scope.getProviderData();
              scope.getUserProperties();
              scope.getConfiguredTpa();
              if (response.data.userDetails.properties["Assigned Corporates"]) {
                var properties = response.data.userDetails.properties["Assigned Corporates"];
              } else {
                var properties = response.data.userDetails.properties["assigned Corporates"];
              }
              UtilitiesService.setCorporates(properties);
              scope.isErorMessageLogin = false;
              scope.errorMessage = '';
            } else {
              scope.isErorMessageLogin = true;
              scope.errorMessage = 'Unable to find role for current user.';
            }
            GovernmentService.getGovtPackageList().then(getGovtPackageListSuccess, getGovtPackageListError);
            UtilitiesService.stopLoading('signinBox');  
          }
        } else {
          scope.isErorMessageLogin = true;
          scope.errorMessage = response.data.errorMessage ? response.data.errorMessage : "Invalid request user not found!";
        }
      }, function (error) {
        scope.isErorMessageLogin = true;
        scope.errorMessage = 'Not able to log in!, please check your network connection.';
      });
    };

    scope.signinWithSSO = function (one_MediAssist) {
      scope.isErorMessageLogin = false;
      scope.isErorMessage = false;
      if (!one_MediAssist) {
        return false;
      }
      scope.errorMessage = '';
      var data = {
        accessToken: JSON.parse(one_MediAssist).access_token
      };
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'authenticate', data, 'POST').then(function (response) {
        if (response.data.isAuthenticated) {
          localStorage.setItem('isHospUser', true);
          if (response.data.hospDetails && response.data.hospDetails.isRemedinetAssociated && response.data.userDetails.role != 'CMS') {
            response.data.userDetails.role = 'operations';
          }
          if (response.data.relatedEntities) {
            $.grep(response.data.relatedEntities, function (e, i) {
              if (e.relatedEntityId == response.data.userDetails.entityId) {
                response.data.hospDetails.isHospAarogya = true;
                return false;
              }
            });
          }
          var cmsHospId = response.data ? response.data.hospDetails ? response.data.hospDetails.cmsHospId : '' : '';
          scope.setupForSignalR(response.data.accessToken, true, cmsHospId);
          if (response.data.userDetails.rolesFeatures && response.data.userDetails.rolesFeatures.features && response.data.userDetails.rolesFeatures.features.length > 0 && response.data.userDetails.rolesFeatures.roles && response.data.userDetails.rolesFeatures.roles.length > 0) {
            scope.user = response.data.userDetails;
            scope.loadContracts();
            response.data.userDetails.accessTokenObj = undefined;
            response.data.userDetails.accessToken = response.data.accessToken;
            UserService.setUserObj(response.data.userDetails);
            UserService.setHospitalObj(response.data.hospDetails);
            UserService.setAarogyaObj(response.data.relatedEntities);
            scope.getProviderData();
            scope.getUserProperties();
            scope.isErorMessageLogin = false;
            scope.errorMessage = '';
          } else {
            scope.isErorMessageLogin = true;
            scope.errorMessage = 'Unable to find role for current user.';
          }
          $cookieStore.put('one_MediAssist', null);
          GovernmentService.getGovtPackageList().then(getGovtPackageListSuccess, getGovtPackageListError)
        } else {
          scope.isErorMessageLogin = true;
          scope.errorMessage = response.data.errorMessage;
        }
      }, function (error) {
        scope.isErorMessageLogin = true;
        scope.errorMessage = 'Not able to log in!, please check your network connection.';
      });
    };

    // scope.one_MediAssist = '';
    scope.signout = function () {
      var one_MediAssist = $cookieStore.get('one_MediAssist');
      if (!one_MediAssist) {
        UserService.destroyUserObj();
        rootScope.$emit('signedin', false);
        scope.user = null;
      } else {
        scope.signinWithSSO(one_MediAssist);
      }
    };

    // if ($location.search()) {
    //   var accessToken = $location.search().access_token;
    //   if (accessToken) {
    //     $location.$$search = {};
    //   } else {
    //     $location.$$search = {};
    //     $location.path('/');
    //   }
    // }

    scope.resetData = function () {
      scope.reset = {};
      scope.esubmitted = false;
      scope.isErorMessage = false;
    };

    scope.resetPassword = function () {
      var data = {};
      data[scope.resetKeyName] = scope.reset.userid;
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/user/resetpassword', data, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          scope.reset.userid = '';
          scope.esubmitted = true;
          scope.userFirstName = response.data.userFirstName;
          scope.userName = response.data.userName;
          scope.userEmail = response.data.userEmail;
          scope.isErorMessage = false;
          scope.reset.userName = response.data.userName;
          scope.reset.userEmail = response.data.userEmail;
          scope.reset.userFirstName = response.data.userFirstName;
        } else {
          scope.errorMessage = response.data.errorMessage;
          scope.isErorMessage = true;
          scope.resetFail = true;
        }
      }, function (error) {
        scope.errorMessage = 'Server Issue';
        scope.isErorMessage = true;
        scope.resetFail = true;
      });
    };

    scope.Initialize = function () {
      scope.user = {
        username: null,
        password: null
      };
      scope.reset = {
        userFirstName: null,
        userName: null,
        userEmail: null
      };
      scope.planned = {
        claimid: null,
        hospid: null,
        otp: null,
        OtpRemarks: null
      };
      scope.errorMessage = '';
    };

    angular.element(document).ready(function () {
      if (!UserService.isActive()) {
        if (rootScope.planned && rootScope.planned.length > 0) {
          $window.location.href = rootScope.planned;
        } else {
          if ($location.search().access_token) {

          } else {
            scope.signout();
            return false;
          }
        }
      } else {
        scope.reroute();
      }
      scope.Initialize();
    });

    scope.signup = function () {
      state.go('signup', {}, {
        reload: true
      });
    };

    scope.eCashlessRelatedMethods = function () {
      scope.planned = {};
      return {
        getOtpConfirmed: function (claimId) {
          var data = {
            claimNo: scope.planned.claimid,
            otpNo: String(scope.planned.otp)
          }
          $.ajax({
            url: UtilitiesService.getUrlPrefix() + '/hosp/Claim/OtpVerfication',
            data: data,
            type: 'POST',
            success: function (resData) {
              if (resData.isSuccess) {
                UtilitiesService.showAlertMessage('OTP number matched.', true);
                scope.eCashlessRelatedMethods.getclaimDetails();
              } else {
                UtilitiesService.showAlertMessage('oops! OTP number did not match.');
              }
              scope.$apply();
            },
            error: function () {
              scope.planned.enabledPreauthForm = true
              scope.planned.enabledSettlementLatter = true
            }
          })
        },
        getclaimDetails: function () {
          var externalappcheck = 'noLoginPlanned';
          var secclaimnumber = 0;
          var url = UtilitiesService.getUrlPrefix() + '/hosp/claim/claimdetails/' + scope.planned.hospid + '/' + scope.planned.claimid + '/' + secclaimnumber + '/' + externalappcheck;
          $http.get(url).
            success(function (resData) {
              if (resData.isSuccess) {
                scope.eCashlessRelatedMethods.getPreauthApprovedLetters(resData);
              } else {
                UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
              }
            })
            .error(function () {
              UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            })
        },
        getPreauthApprovedLetters: function (claimDetails) {
          if (claimDetails.claimDetails.claimAuditDetails.length > 0 && claimDetails.claimDetails.claimIntimationDetails.isOTPVerified) {
            $.each(claimDetails.claimDetails.claimAuditDetails, function (i, v) {
              if (v.auditStatus == 'Pre-Auth Approved') {
                var newWin = window.open(v.letterDownloadLink, 'Download');
                if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
                  UtilitiesService.showAlertMessage('Please unblock the popup and download again.');
                }
              }
            });
            scope.planned = {};
          }
        }
      }
    }();
  }]);

angular.module('mbplus')
  .controller('signInPopupCtrl', ['$rootScope', '$scope', '$state', '$location', '$window', 'UserService', 'UtilitiesService', 'md5', '$http', '$analytics', 'PlusUtilitiesService', 'filterFilter', '$timeout', 'GovernmentService', '$interval', '$cookieStore', 'ngDialog', function (rootScope, scope, state, $location, $window, UserService, UtilitiesService, md5, $http, analytics, PlusUtilitiesService, filterFilter, timeout, GovernmentService, interval, $cookieStore, ngDialog) {
    scope.popUpdata = {
      hospName: '',
      pendingCount: 0
    }

    scope.remainingNoOfDays = moment('1-Aug-2018').diff(moment(), 'days')

    if (scope.ngDialogData) {
      scope.popUpdata.hospName = scope.ngDialogData.hospName
      scope.popUpdata.pendingCount = scope.ngDialogData.pendingCount;
    }

    scope.closePopUp=function(path)
    {
      if(path)
      {
        $location.path(path);
      }
      scope.closeThisDialog();
    }

  }]);

angular.module('mbplus')
  .controller('payerPopupCtrl', ['$rootScope', '$scope', '$state', '$location', '$window', 'UserService', 'UtilitiesService', 'md5', '$http', '$analytics', 'PlusUtilitiesService', 'filterFilter', '$timeout', 'GovernmentService', '$interval', '$cookieStore', 'ngDialog', function (rootScope, scope, state, $location, $window, UserService, UtilitiesService, md5, $http, analytics, PlusUtilitiesService, filterFilter, timeout, GovernmentService, interval, $cookieStore, ngDialog) {

    scope.closePopUp=function(path)
    {
      if(path)
      {
        $location.path(path);
      }
      scope.closeThisDialog();
    }

    scope.openTpaPayer=function()
    {     
      ngDialog.closeAll(); 
      $location.path("/tpaConfig");
      timeout(function () {
      rootScope.$broadcast("PayerData",'');
      }, 1000);
        
    }    
  }]);

angular.module('mbplus')
.controller('sentCtrl', ['$rootScope', '$scope', 'UserService', function ($rootScope, scope, UserService) {
  scope.isActive = UserService.isActive();
  $rootScope.showAll = false;
  if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }
}]);
angular.module('mbplus')
  .controller('roomsCtrl', ['$scope', '$location', 'UserService', 'ProfileService', 'UtilitiesService', '$analytics', 'FileUploadService', '$q', function (scope, $location, UserService, ProfileService, UtilitiesService, $analytics, FileUploadService, $q) {
    $analytics.pageTrack('/rooms');
    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
      UserService.destroyUserObj();
      $location.path('/');
      return false;
    }
    scope.addRoom = false;
    scope.editRoom = false;
    scope.file = [];
    scope.imgs = [];
    scope.newlyUploadedImages = [];
    scope.dmslink = UtilitiesService.getDMSHostUrl();
    scope.roomsMethods = (function () {
      return {
        // loadRooms: function () {
        //     scope.rooms = [];
        //     UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/hospProfileDetails/rooms/true.json", { hospId: UserService.getHospitalObj().hospId }, "POST").then(function (response) {
        //         if (response.data.isSuccess) {
        //             scope.hospRoomDetails = response.data.hospRoomDetails;
        //             angular.forEach(response.data.hospRoomDetails, function (e, i) {
        //                 var tempImgs = [];
        //                 tempImgs = scope.imagesMethods.getImagesForRoom(e.roomImages);
        //                 var tempObj = {
        //                     createdBy: e.createdBy,
        //                     createdOn: e.createdOn,
        //                     hospID: e.hospID,
        //                     hospName: e.hospName,
        //                     hospitalRoomType: e.hospitalRoomType,
        //                     id: e.id,
        //                     isActive: e.isActive,
        //                     isDelete: e.isDelete,
        //                     isVerified: e.isVerified,
        //                     modifiedBy: e.modifiedBy,
        //                     modifiedOn: e.modifiedOn,
        //                     noOfBedsAvailable: e.noOfBedsAvailable,
        //                     noOfBedsPerRoom: e.noOfBedsPerRoom,
        //                     noOfRoomsAvailable: e.noOfRoomsAvailable,
        //                     noOfTotalRooms: e.noOfTotalRooms,
        //                     roomFacilities: e.roomFacilities,
        //                     roomFacilitiesString: e.roomFacilitiesString,
        //                     roomImages: tempImgs,
        //                     roomOtherFacilities: e.roomOtherFacilities,
        //                     roomTypeID: e.roomTypeID,
        //                     roomChargesPerDay: e.roomChargesPerDay
        //                 }
        //                 scope.rooms.push(tempObj);
        //             });
        //         }
        //     })
        // },
        loadRooms: function () {
          scope.rooms = [];
          ProfileService.loadProviderProfileDataByKey('room',{getProviderRoomDetail:true}).then(function (response) {
            if (response) {
              scope.hospRoomDetails = response;
              angular.forEach(response, function (e, i) {
                var tempImgs = [];
                tempImgs = scope.imagesMethods.getImagesForRoom(e.roomImages);
                var tempObj = {
                  createdBy: e.createdBy,
                  createdOn: e.createdOn,
                  hospID: e.hospitalID,
                  hospitalRoomType: e.hospitalRoomType,
                  id: e.id,
                  isActive: e.isActive,
                  isDelete: e.isDelete,
                  isVerified: e.isVerified,
                  modifiedBy: e.modifiedBy,
                  modifiedOn: e.modifiedOn,
                  noOfBedsAvailable: e.noOfBedsAvailable,
                  noOfBedsPerRoom: e.noOfBedsPerRoom,
                  noOfRoomsAvailable: e.noOfRoomsAvailable,
                  noOfTotalRooms: e.noOfTotalRooms,
                  roomFacilities: e.facilities,
                  roomImages: tempImgs,
                  roomOtherFacilities: e.otherFacilities,
                  roomTypeID: e.roomType,
                  roomChargesPerDay: e.roomChargesPerDay
                }
                scope.rooms.push(tempObj);
              });
            }
          })
        },
        editHospRoomModal: function (roomDet) {
          scope.addRoom = false;
          scope.editRoom = true;
          scope.roomDetails = {
            roomType: roomDet.hospitalRoomType,
            roomChargesPerDay: roomDet.roomChargesPerDay,
            noOfBedsPerRoom: roomDet.noOfBedsPerRoom,
            noOfTotalRooms: roomDet.noOfTotalRooms,
            roomImages: roomDet.roomImages,
            id: roomDet.id,
          }
          scope.addListOfFacility = [];
          // UserService.loadMasterByKeyName("Hospital_Room_Amenities")
          ProfileService.loadProviderMasterByKey({columnNames: ["Hospital_Room_Amenities"]})
            .then(function (res) {
              angular.forEach(res.lookupData, function (e, i) {
                var t = roomDet.roomFacilities.filter(function (el) {
                  return el.facilityID == e.masterLookUpID;
                });
                var tempObj = {
                  facilityID: e.masterLookUpID,
                  facilityName: e.masterLookUpColumnValue,
                  isFacilityAvailable: t && t.length > 0 ? true : false
                }
                scope.addListOfFacility.push(tempObj);
              });
            });
        },
        openHospRoomModal: function () {
          scope.addRoom = true;
          scope.editRoom = false;
          scope.roomDetails = {};
          scope.addListOfFacility = [];
          // UserService.loadMasterByKeyName("Hospital_Room_Amenities")
          ProfileService.loadProviderMasterByKey({columnNames: ["Hospital_Room_Amenities"]})
            .then(function (res) {
              angular.forEach(res.lookupData, function (e, i) {
                var tempObj = {
                  facilityID: e.masterLookUpID,
                  facilityName: e.masterLookUpColumnValue,
                  isFacilityAvailable: false
                }
                scope.addListOfFacility.push(tempObj);
              });
            });
        },
        closeEditWindow: function () {
          scope.addRoom = false;
          scope.editRoom = false;
          scope.imagesMethods.clearFileModels();
          scope.addListOfFacility = [];
          scope.roomDetails = {};
        },
        addNewRoom: function () {
          var saveListOfFacility = [];
          angular.forEach(scope.addListOfFacility, function (e, i) {
            var addFacilityList = {
              facilityID: e.facilityID,
              facilityName: e.facilityName,
              isFacilityAvailable: e.isFacilityAvailable
            }
            saveListOfFacility.push(addFacilityList);
          });
          var uploadedImages = [];
          scope.newlyUploadedImages.forEach(function (e) {
            var temp = {
              "hospId": UserService.getHospitalObj().hospId,
              "imageLink": e.imageLink,
              "imageThumbNailLink": e.imageThumbNailLink,
              "imageDescription": e.imageDescription,
              "isImageVerified": false,
              "isActive": true,
              "createdBy": UserService.getUserObj().userId,
              "modifiedBy": UserService.getUserObj().userId,
              "isDelete": false,
              "lockedBy": ""
            };
            uploadedImages.push(temp);
          });
          var singleRoom = {
            "hospitalID": UserService.getHospitalObj().hospId,
            "hospitalRoomType": scope.roomDetails.roomType,
            "noOfBedsPerRoom": scope.roomDetails.noOfBedsPerRoom,
            "noOfTotalRooms": scope.roomDetails.noOfTotalRooms,
            "roomChargesPerDay": scope.roomDetails.roomChargesPerDay,
            "facilities": saveListOfFacility,
            "otherFacilities": [],
            "createdBy": UserService.getUserObj().userId,
            "isActive": true,
            "roomImages": uploadedImages,
            "modifiedBy": UserService.getUserObj().userId
          }
          var data = {
            "roomDetailsList": []
          }
          data.roomDetailsList.push(singleRoom)
          ProfileService.updateProviderProfileDataByKey('room',data).then(function (response) {
            if (response) {
              scope.roomsMethods.closeEditWindow();
              scope.roomsMethods.loadRooms();
            }
          })
          // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/addHospRoom.json", data, "POST").then(function (response) {
          //     if (response.data.isSuccess) {
          //         scope.roomsMethods.closeEditWindow();
          //         scope.roomsMethods.loadRooms();
          //     }
          // }, function (error) {
          //     UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          // });
        },
        updateRoom: function (isDelete) {
          var saveListOfFacility = [];
          angular.forEach(scope.addListOfFacility, function (e, i) {
            var addFacilityList = {
              facilityID: e.facilityID,
              facilityName: e.facilityName,
              isFacilityAvailable: e.isFacilityAvailable
            }
            saveListOfFacility.push(addFacilityList);
          });
          var singleRoom = {
            "id": scope.roomDetails.id,
            "hospitalID": UserService.getHospitalObj().hospId,
            "hospitalRoomType": scope.roomDetails.roomType,
            "noOfBedsPerRoom": scope.roomDetails.noOfBedsPerRoom,
            "noOfTotalRooms": scope.roomDetails.noOfTotalRooms,
            "roomChargesPerDay": scope.roomDetails.roomChargesPerDay,
            "facilities": saveListOfFacility,
            "otherFacilities": [],
            "isActive": true,
            "createdBy": UserService.getUserObj().userId,
            "modifiedBy": UserService.getUserObj().userId,
            "isDelete": isDelete ? true : false
          }
          var data = {
            "roomDetailsList": []
          }
          data.roomDetailsList.push(singleRoom)
        //   var data = {
        //     "hospRoomDetails": {
        //       "id": scope.roomDetails.id,
        //       "hospitalID": UserService.getHospitalObj().hospId,
        //       "hospitalRoomType": scope.roomDetails.roomType,
        //       "noOfBedsPerRoom": scope.roomDetails.noOfBedsPerRoom,
        //       "noOfTotalRooms": scope.roomDetails.noOfTotalRooms,
        //       "roomChargesPerDay": scope.roomDetails.roomChargesPerDay,
        //       "roomFacilities": saveListOfFacility,
        //       "isActive": true,
        //       "createdBy": UserService.getUserObj().userId,
        //       "modifiedBy": UserService.getUserObj().userId,
        //       "isDelete": isDelete ? true : false
        //     }
        //   }
          ProfileService.updateProviderProfileDataByKey('room',data).then(function (response) {
            if (response) {
              scope.roomsMethods.closeEditWindow();
              scope.roomsMethods.loadRooms();
            }
          })
          // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/updateHospRoom.json", data, "POST").then(function (response) {
          //     if (response.data.isSuccess) {
          //         scope.roomsMethods.closeEditWindow();
          //         scope.roomsMethods.loadRooms();
          //     }
          // }, function (error) {
          //     UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          // });
        },
        deleteRoom: function () {
          scope.roomsMethods.updateRoom(true);
        }
      };
    })();
    scope.imagesMethods = (function () {
      return {
        getImagesForRoom: function (images) {
          var tempImgs = [];
          angular.forEach(images, function (e, i) {
            var tempObjImg = {
              // thumb: e.imageThumbNailLink ? e.imageThumbNailLink.indexOf("http") > -1 ? e.imageThumbNailLink : scope.dmslink + e.imageThumbNailLink : '',
              thumb: e.downloadLink,
              // img: e.documentLink ? e.documentLink.indexOf("http") > -1 ? e.documentLink : scope.dmslink + e.documentLink : '',
              img: e.downloadLink,
              description: e.documentDescription,
              imageId: e.id,
              imageTypeId: e.documentTypeID,
              isDelete: e.isDelete,
              isImageVerified: e.isImageVerified
            }
            tempImgs.push(tempObjImg);
          });
          return tempImgs;
        },
        uploadNewHospImages: function () {
          var fileBlobArray = [];
          var filesUploadingArray = [];
          Object.keys(scope.file).forEach(function (ele) {
            if (typeof (scope.file[ele].model) == "object") {
              filesUploadingArray.push(scope.file[ele].model);
            }
          });
          if (filesUploadingArray.length > 0) {
            fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrl() + '/Provider/Profile/DocumentUpload'));
          } else {
            UtilitiesService.showAlertMessage('Please attach atleast one document');
            return false;
          }
          $q.all(fileBlobArray).then(function (result) {
              result.forEach(function (element) {
                if (element.data.isSuccess) {
                  scope.newlyUploadedImages = element.data.uploadedDetails;
                } else {
                  UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
                  return false;
                }
              });
            },
            function (error) {
              UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            });
        },
        clearFileModels: function () {
          scope.newlyUploadedImages = [];
          scope.file = [];
          scope.fileUploadMethods.addFileToUpload();
        },
        setImages: function () {
          scope.roomDetails.roomImages = scope.imagesMethods.getImagesForRoom(scope.newlyUploadedImages);
        },
        // removeHospImage: function (index) {
        //   if (scope.roomDetails.roomImages[index]) {
        //     var arr = [];
        //     arr.push(scope.roomDetails.roomImages[index]);
        //     arr[0].hospID = UserService.getHospitalObj().hospId;
        //     arr[0].isDelete = true;
        //     arr[0].isActive = true;
        //     arr[0].modifiedBy = UserService.getUserObj().userId;
        //     var data = {
        //       hospImages: arr
        //     }
        //     UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/updateHospImages.json", data, "POST").then(function (response) {
        //       if (response.data.isSuccess) {
        //         UtilitiesService.showAlertMessage('Removed image successfully', true);
        //         scope.roomDetails.roomImages = scope.imagesMethods.getImagesForRoom(response.data.hospImages);
        //       }
        //     }, function (error) {
        //       UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        //     })
        //   } else {
        //     UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        //   }
        // },
        saveNewHospImages: function () {
          var updateImageArr = JSON.parse(JSON.stringify(scope.newlyUploadedImages));
          angular.forEach(updateImageArr, function (e, i) {
            delete e.downloadLink;
            e.documentLink = e.fileGuid;
            e.hospitalId = UserService.getHospitalObj().hospId;
            e.createdBy = UserService.getUserObj().userId;
            e.modifiedBy = UserService.getUserObj().userId;
            e.documentDescription = e.imageDescription.value;
            e.documentStartDate = moment().format();
            e.documentEndDate = moment({date:20, year:2020, month:06}).format();
            e.parentId = scope.roomDetails.id;
          });
          var data = {
            "documentsList": updateImageArr,
          }
          UserService.makeRestCall(UtilitiesService.getPlusUrl() + '/Provider/Profile/AddUpdateHospitalRoomImage', data, "POST" , UserService.getAccessToken()).then(function (response) {
            if (response.data.isSuccess) {
              UtilitiesService.showAlertMessage('Images Saved Successfully', true);
              scope.imagesMethods.clearFileModels();
              $('#hospitalImages').modal('hide');
              var room = {};
              response.data.hospitalsRoomDetails.forEach(function(e){
                if (data.documentsList[0].parentId == e.id) {
                  room = JSON.parse(JSON.stringify(e));
                }
              })
              scope.roomDetails.roomImages = scope.imagesMethods.getImagesForRoom(room.roomImages);
            }
          }, function (error) {
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          });
        }
      };
    })();
    scope.fileUploadMethods = (function () {
      return {
        addFileToUpload: function (flag) {
          var newItemNo = scope.file.length + 1;
          scope.file.push({
            'model': ''
          });
        },
        removeFileToUpload: function (index) {
          scope.file.splice(index, 1);
        }
      };
    })();
    angular.element(document).ready(function () {
      scope.roomsMethods.loadRooms();
      scope.fileUploadMethods.addFileToUpload();
    });
  }]);

angular.module('mbplus')
  .controller('rescheduleAppointmentController', ['$scope', 'UserService', 'UtilitiesService', 'DateService', 'navConstantsSvc', 'UserService', function (scope, UserService, UtilitiesService, DateService, navConstantsSvc, UserService) {

    var encryptedUrlData = UserService.dcUrl;
    var holidayList = navConstantsSvc.holidayList;
    scope.appointmentData = null;
    scope.appointmentBooked = false;
    scope.isSubmitCalled = false;
    scope.format = navConstantsSvc.dateFormate[0];
    scope.altInputFormats = navConstantsSvc.altInputFormats;
    scope.datePicker = {
      opened: false
    }
    scope.dateOptions = {
      formatYear: 'yy',
      minDate: DateService.today,
      startingDay: 1
    };

    scope.hstep = navConstantsSvc.hstep;
    scope.mstep = navConstantsSvc.mstep;

    scope.preferredDateTime = DateService.validateToday();
    scope.maxFirst = DateService.maxFirst;
    scope.minFirst = scope.preferredDateTime.prefTime;

    scope.languages = ["English", "Hindi", "Kannada", "Telugu", "Malayalam", "Tamil", "Punjabi", "Bengali", "Marathi", "Gujarati", "Others"]
    scope.prefLang = null;
    scope.languageDropdownMenu = false;

    if (encryptedUrlData) {
      var payload = {
        "encryptedData": encryptedUrlData
      }
      UtilitiesService.startLoading('fetching data...Please wait', 'scheduleAppointmentForm');
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'fetchRequestByEncryptedId', payload, 'POST').then(function (response) {
        scope.fetchDecryptedData = true;
        if (response.data.isSuccess) {
          scope.appointmentData = response.data;
          scope.allow = response.data.currentStatusId == 22 ? true : false
        }
        UtilitiesService.stopLoading('scheduleAppointmentForm');
      })
    } else {
      scope.fetchDecryptedData = true;
    }

    scope.reschedule = function () {
      scope.datePicker.opened = !scope.datePicker.opened;
    };

    scope.disabled = function (date, mode) {
      return (mode === 'day' && ((date.getDay() === 0) || holidayList.includes(date.toLocaleDateString())));
    };

    scope.dateChange = function () {
      var preferredDateTime = DateService.dateChanged(scope.preferredDateTime.prefDate);
      scope.preferredDateTime = preferredDateTime;
      scope.minFirst = preferredDateTime.prefTime;
    }

    scope.langSelected = function (l) {
      scope.prefLang = l;
      scope.languageDropdownMenu = false;
    }

    scope.submitData = function () {
      var date = moment(scope.preferredDateTime.prefDate).format('DD-MMM-YYYY');
      var time = moment(scope.preferredDateTime.prefTime).format('hh:mm a');
      scope.prefferedTime = date + ' ' + time;
      var payload = {
        "request": {
          "contractId" : scope.appointmentData.contractId,
          "requestId": scope.appointmentData.requestId,
          "currentStatusId": scope.appointmentData.currentStatusId,
          "ScheduledAppointmentDate": new Date(scope.prefferedTime),
          "requestedNextActionId": 117,
          "additionalParameters": {
            "PreferredLanguage": scope.prefLang,
          }
        }
      }
      UtilitiesService.startLoading('Please wait..', 'scheduleAppointmentForm');
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/trackRequest', payload, 'POST').then(function (response) {
        UtilitiesService.stopLoading('scheduleAppointmentForm');
        scope.isSubmitCalled = true;
        if (response.data) {
          scope.appointmentBooked = true;
        }
      })
    }
  }])

angular.module('mbplus')
.controller('resetPasswordCtrl', ['$rootScope', '$scope', '$location', '$window', '$http', 'UserService','UtilitiesService', 'PlusUtilitiesService', 'md5', function ($rootScope, scope, $location, $window, $http, UserService, UtilitiesService, PlusUtilitiesService, md5) {
  scope.$root.title = 'Change password | Medibuddy Hospital Portal';

  scope.user = {
    password: ''
  };
  scope.isError = false;

  if (UtilitiesService.resetAccessToken) {
    scope.resetAccessToken = UtilitiesService.resetAccessToken
    if (scope.resetAccessToken) {
      $location.search('token', null);
      $rootScope.showMenu = true;
      $rootScope.isRestLogin = { 'display': 'none' }
    }
  }else{
      UserService.destroyUserObj();
      $location.path('/');
  }

  scope.resetPassword = function () {
    var data = {
      token: scope.resetAccessToken,
      newPassword: scope.user.password,
      tokenAvailable: true,
    }
    UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/user/resetpassword', data, 'POST').then(function (response) {
      if (response.data.isSuccess) {
        scope.isError = false;
        scope.user.password = '';
        scope.confirmPassword = '';
        UserService.destroyUserObj();
        UtilitiesService.showAlertMessage('Password changed successfully.', true);
        $location.path('/');
      }
      else {
        scope.user.password = '';
        scope.confirmPassword = '';
        scope.isError = true;
      }
    }, function (error) {
      scope.user.password = '';
      scope.confirmPassword = '';
      scope.isError = true;
    });
  }
}]);
angular.module('mbplus')
.controller('reimbursementClaimsCtrl', ['$rootScope', '$scope', '$location', '$timeout', '$filter', '$http', 'UserService', 'UtilitiesService', '$analytics', function ($rootScope, scope, $location, $timeout, $filter, $http, UserService, UtilitiesService, $analytics) {
    
    $analytics.pageTrack('/reimbursement');
    // check for logged in
    if (!UserService.isActive() || (UserService.getUserObj() && UserService.getUserObj().role && UserService.getUserObj().role.toLowerCase() == 'insurer')) {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }

    scope.mbAlert = {
        type: 'type',
        text: '<strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.',
        config: { timeOut: 1000 }
    }
    scope.startIndex = 1;
    scope.searchTPA = '';
    scope.hospitalNotification = [];
    scope.preauthClaims = [];

    scope.ctrlFn = function (nextpage) {
        scope.startIndex = nextpage;
        scope.getReimbursementClaims();
    };
  
    scope.isGetUnprocessedClaims = true;
    
    //Fetch Reimbursement Claims List
    scope.getReimbursementClaims = function () {
        if(scope.isGetUnprocessedClaims){
            if (UserService.getHospitalObj()) {
                var ajxData = {
                    hospitalId: UserService.getHospitalObj().cmsHospId,
                    startIndexInclusive: scope.startIndex,
                    isReimbursement: true
                };
                UtilitiesService.startLoading('fetching reimbursement claim data...', 'ReimbursementClaims');
                UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/search/openclaims', ajxData, 'POST').then(function (response) {
                    UtilitiesService.stopLoading('ReimbursementClaims');
                    if (response.data.isSuccess) {
                        scope.preauthClaims = UtilitiesService.renderClaimsList(response.data, 'preauth');
                        scope.preauthClaims.allRecordCount = response.data.allRecordCount;
                    }
                });
            }
        }
    };
    
    scope.getUnprocessedClaims = function (page) {
        scope.isGetUnprocessedClaims =  false;
        if (UserService.getHospitalObj()) {
            var ajxData = {
                hospitalId: UserService.getHospitalObj().cmsHospId,
                startIndexInclusive: page ? page : 1
            };
            UtilitiesService.startLoading('fetching pending claim data...','activeClaims');
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/search/unprocessedclaims/', ajxData, 'POST').then(function (response) {
                UtilitiesService.stopLoading('activeClaims');
                scope.isGetUnprocessedClaims =  true;
                if (response.data.isSuccess) {
                    scope.preauthClaims = UtilitiesService.renderClaimsList(response.data, 'preauth');
                    scope.preauthClaims.allRecordCount = response.data.allRecordCount;
                }
            });
        }
    };

    scope.callbackSecond = function(data, value, page){
        if(data === 'Active claim'){
            scope.getReimbursementClaims();
        }else if(data === 'InProgress'){
            scope.getUnprocessedClaims(page);
        }
    };

    $rootScope.$on('signedin', function (event, args) {
        if (args && args === false) {
            $timeout.cancel(promise);
        }
    });

    scope.getReimbursementClaims();
    var promise = null;

}]);
angular.module("mbplus")
.controller('queueController', ['$rootScope', '$scope', 'UserService', 'UtilitiesService', 'filterFilter', '$filter', 'PlusUtilitiesService', 'sharedDataService', '$state', 'orderByFilter', 'FileUploadService', '$timeout', 'navConstantsSvc', function (rootScope, scope, UserService, UtilitiesService, filterFilter, $filter, PlusUtilitiesService, sharedDataSvc, state, orderByFilter, FileUploadSvc, timeout, constant) {
    UserService.checkForSession();
    scope.showCalender = false;
    scope.packages = [];
    scope.brokers = [
        {
            name : 'Policy Bazar Health',
            value : 1019337
        },
        {
            name : 'N/A',
            value : 0
        }
    ];
    scope.selectedBrokerObj = {};
    scope.selectedPackageForAdvance = [];
    scope.sumassuredetail = {
        sumAssured: '',
        paidSpons: 'sponsored',
        grpIndv: 'individual'
    }
    scope.uicDetail = {
        uicNumber: ''
    }
    //date time
    scope.callDateTime = {
        prefDate: '',
        prefTime: ''
    }
    scope.field = {
        fieldName: '',
        fieldValue: ''
    }
    scope.additionalFieldList = ['AgentEmailId', 'AgentName', 'AgentContactNo',
    'Entity', 'CostType', 'CaseType', 'Aadhar', 'PAN', 'SMName', 'SM_Email', 'SMPhoneNumber'];    
	scope.popup6 = {
        opened: false
    };
    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];
    scope.open6 = function () {
        scope.popup6.opened = true;
    };
    scope.dateOptions = {
        dateDisabled: disabled,
        formatYear: 'yy',
        minDate: new Date(),
        startingDay: 1
    };
    scope.mindate = new Date();
    scope.hstep = 1;
    scope.mstep = 1;
    //date time

    scope.open6 = function () {
        scope.popup6.opened = true;
    };
    scope.client = {
        visitType: ''
    }
    scope.genderList = {
        gender: 'NA'
    }

    scope.locationName = {
        autocomplete: ''
    }
    scope.client = {
        preferredDC1: ''
    }
    scope.manual = {
        firstDate: '',
        secondDate: ''
    }
    scope.serverSearch = {
        fromDate: '',
        toDate: '',
        statusSearch: '',
        contractType: '',
        corporateId: '',
        state: ''
    };
    scope.isFlage = {
        isDownload: false,
        autoDcSelection: false,
        autDcSection: ''
    };
    scope.additionalInfo = {};
    scope.IsMaUser = false;
    scope.contract = {};
    scope.getDateTime = function (date, time) {
        scope.PrefcallDateTime = UtilitiesService.mergeDateTimeObj(date, time);
    }
    scope.user = UserService.getUserObj();
    scope.user.entityType = scope.user.entityType ? scope.user.entityType.trim() : null;
    angular.forEach(scope.user && scope.user.rolesFeatures.roles, function (v, i) {
        if (v.roleId === 9211 || v.roleId === 9214 || v.roleId === 9204) {
            scope.isDdlVisible = false;
            scope.isFlage.isDownload = false;
            scope.IsMaUser = true;
        }
    });
    if (scope.user && scope.user.entityId) {
        if (scope.user.entityId === 1000042) {
            scope.isDdlVisible = false;
            scope.isFlage.isDownload = false;
            scope.IsMaUser = true;
        }
    }
    scope.childrenData = UtilitiesService.getAllChildren() === null ? [] : UtilitiesService.getAllChildren();
    scope.contractList = UtilitiesService.getContracts() === null ? [] : UtilitiesService.getContracts();
    scope.contractList1 = filterFilter(scope.contractList, {
        "id": scope.childrenData
    }, function (actual, expected) {
        return filterFilter(expected, {
            'erTypeId': parseInt(actual)
        }).length > 0;
    });
    scope.contractList = scope.contractList1;
    scope.getSelectedErId = function (selectedContract) {
        if (selectedContract == null) {
            scope.isFlage.isDownload = false;
            scope.isDdlVisible = true;
        }
        if (selectedContract && selectedContract.id) {
            if (selectedContract) {
                //scope.contract = selectedContract.id;
                scope.contract = {};
                scope.contract.id = selectedContract.id
                scope.setContractIdForUpload = scope.contract.id
                scope.templateUrl = "https://ch-api-procheck.medibuddy.in/DownloadExcelFormatForContract/" + scope.contract.id;
                scope.isFlage.isDownload = true;
            } else {
                scope.isFlage.isDownload = false;
            }
        }//function call
        else if (scope.contractList.length === 1) {
            scope.contract.id = _.first(scope.contractList).id;
            scope.setContractIdForUpload = scope.contract.id
            scope.templateUrl = "https://ch-api-procheck.medibuddy.in/DownloadExcelFormatForContract/" + scope.contract.id;
            scope.isFlage.isDownload = true;
        } else {
            scope.isDdlVisible = true;
        }
    };

    scope.getSelectedErId();
    scope.contractsData = [];
    // scope.contractsData.push({ id: '0', entityName: 'All Corporate' });
    // scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };
    scope.downloadFailedFile = function () {
        if (scope.failedFileName) {
            var url = UtilitiesService.getUrlPrefix() + '/DownloadExcelWithErrors/' + scope.failedFileName + ".json";
            window.open(url, "_blank");
        }
    };
    scope.brokerSelected = function (a) {
        scope.selectedBrokerObj.value = a.value || 0 ;
        scope.selectedBrokerObj.name = a.name  || '';
    }
    scope.getCorporate = function(){
        var children = JSON.parse(localStorage.getItem("children"));
        var userAssignedRole = UserService.getUserObj().properties["Assigned Contracts"] ? UserService.getUserObj().properties["Assigned Contracts"] : scope.contract.id
        for (var key in children) {
            if(children[key].erTypeId == userAssignedRole){
                console.log(children[key])
                return children[key]
            }
        }
    }
    scope.packageList=[];
    scope.getPackages = function(){
        UserService.makeRestCall("https://ch-api-procheck.medibuddy.in/PackageEntityRelationList", {EntityRelationIds: [scope.getCorporate().id], contractId: scope.setContractIdForUpload}, 'post', UserService.getAccessToken(), true)
        .then(function (res) {
            if (res.data.isSuccess) {
                // alert("sdjcgj")
                scope.packageList = res.data.packagesTests
            }
        });
        return false;
    };
    scope.packageSelected={};
    if(scope.setContractIdForUpload == 12719){ scope.getPackages();}
    scope.setPackageSelected = function(data){
        scope.packageSelected = data;
    }
    scope.setFilesUpload = function (element) {
        UtilitiesService.startLoading('Uploading file...', 'UploadingFile');
        var sourceId = UserService.getUserObj().entityId;
        $("#uploadTemplates").attr("disabled", "disabled");
        if (window.FormData) {
            formdata = new FormData();
        }
        file = element.files[0];
        if (scope.setContractIdForUpload == constant.contractId.esales && scope.selectedBrokerObj && scope.selectedBrokerObj.value) {
            sourceId = scope.selectedBrokerObj.value;
        }
        if (formdata) {
            formdata.append("entityRelationId", (scope.getCorporate()).id);
            formdata.append("entityName", (scope.getCorporate()).entityName);
            formdata.append("contractId", scope.setContractIdForUpload);
            formdata.append("sourceId", sourceId);
            formdata.append("excel_file", file);
            formdata.append("userName", UserService.getUserObj().firstName);

            if (scope.setContractIdForUpload == 12719) {
                formdata.append('teleUnderwritingProductId', '' + scope.packageSelected.productEntityRelationId);
                formdata.append('teleUnderwritingProductName', scope.packageSelected.packageAliasName);
            }

            if (scope.setContractIdForUpload == 9782 || scope.setContractIdForUpload == 4625) {
                formdata.append('uploadedSourceId', '' + parseInt(sourceId));
            }
        }
        $.ajax({
            url: "https://providercore.medibuddy.in/insurance/UploadExcelOrders",
            type: "POST",
            data: formdata,
            headers: {
                "AccessToken": UserService.getAccessToken()
            },
            processData: false,
            contentType: false,
            success: function (res) {
                UtilitiesService.stopLoading('UploadingFile');
                if (res.isSuccess) {
                    if (res.errorMessage) {
                        UtilitiesService.showAlertMessage(res.errorMessage);
                    } else {
                        UtilitiesService.showAlertMessage('Appointments created Successfully! You will be able to see in active appointments, once it is approved by our operations person.', true);
                    }
                }
                else {
                    if (res && res.fileBytes) {
                        window.open('data:application/vnd.ms-excel;base64,' + res.fileBytes);
                    }
                    UtilitiesService.showAlertMessage('Appointment creation failed.');
                    scope.failedFileName = res.fileName;
                    scope.downloadFailedFile();
                }
                $("input#uploadTemplates").val("");
                $("#uploadTemplates").removeAttr("disabled");
                $("#uploadTemplates").attr('value', '');
                scope.$apply();
            },
            error: function () {
                UtilitiesService.stopLoading('UploadingFile');
                UtilitiesService.showAlertMessage('Failed to create appointment.');
            }
        });
        return false;
    }

    scope.templateUrlPreEmp = "https://ch-api-procheck.medibuddy.in/DownloadExcelFormatForContract/9717";
    scope.setPreEmpFilesUpload = function (element) {
        UtilitiesService.startLoading('Uploading file...', 'UploadingFile');

        var sourceId = UserService.getUserObj().entityId;
        $("#uploadTemplatesPreEmp").attr("disabled", "disabled");
        if (window.FormData) {
            formdata = new FormData();
        }
        file = element.files[0];
        
        if (formdata) {
            formdata.append("sourceId", sourceId);
            formdata.append("contractId", scope.serverSearch.contractType);
            formdata.append("entityRelationId", scope.serverSearch.corporateId.id);
            formdata.append("entityName", scope.serverSearch.corporateId.entityName);
            formdata.append("excel_file", file);
            formdata.append("userName", UserService.getUserObj().firstName);
        }

        $.ajax({
            url: 'https://providercore.medibuddy.in/insurance/UploadExcelOrders',
            type: "POST",
            data: formdata,
            headers: {
                "AccessToken": UserService.getAccessToken()
            },
            processData: false,
            contentType: false,
            success: function (res) {
                UtilitiesService.stopLoading('UploadingFile');
                if (res.isSuccess) {
                    if (res.errorMessage) {
                        UtilitiesService.showAlertMessage(res.errorMessage);
                    } else {
                        UtilitiesService.showAlertMessage('Appointments created Successfully! You will be able to see in active appointments, once it is approved by our operations person.', true);
                    }
                }
                else {
                    if (res && res.fileBytes) {
                        window.open('data:application/vnd.ms-excel;base64,' + res.fileBytes);
                    }
                    UtilitiesService.showAlertMessage('Appointment creation failed.');
                    scope.failedFileName = res.fileName;
                    scope.downloadFailedFile();
                }
                $("input#uploadTemplatesPreEmp").val("");
                $("#uploadTemplatesPreEmp").removeAttr("disabled");
                $("#uploadTemplatesPreEmp").attr('value', '');
                scope.$apply();
            },
            error: function () {
                UtilitiesService.stopLoading('UploadingFile');
                UtilitiesService.showAlertMessage('Failed to create appointment.');
            }
        });
        return false;
    }

    //Get corporate Packages data
    scope.getCorporatePackages = function (CorporateSelected,boolVal) {
        scope.contractsData = [];
        //scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };
        if (CorporateSelected && CorporateSelected !== '0') {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/EntityRelationcache/Search/' + CorporateSelected, {}, 'get').then(function (response) {
                scope.contractsData = [];
                scope.isCorporate = response.data.length > 0 ? true : false
                if (response.data.length > 0) {
                    scope.contractsData = response.data;
                    // scope.contractsData.push({ id: '0', entityName: 'All Corporate' });
                    scope.contractsData = orderByFilter(scope.contractsData, 'entityName', false);
                    //scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };
                    if (boolVal) {
                        scope.serverSearch.corporateId.id = scope.isSearchDataAvailableOnLoad.corporateId.id;
                        scope.serverSearch.corporateId.entityName = scope.isSearchDataAvailableOnLoad.corporateId.entityName;
                    } else {
                        // scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };
                    }

                }
            })
        } else {
            scope.isCorporate = false;
            scope.serverSearch.contractType = '';
            // scope.contractsData.push({ id: '0', entityName: 'All Corporate' });
        }
    };

    scope.contracts = PlusUtilitiesService.getContracts();
    var first = new Date();
    var dd = new Date(first).getDate();
    var mm = new Date(first).getMonth() + 1;
    var yy = new Date(first).getFullYear();
    var hh = 7;
    var ms = 0;
    var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
    scope.secondTime = new Date(x);
    scope.firstTime = new Date(x);
    scope.manual.secondTime = new Date(x);
    scope.manual.firstTime = new Date(x);
    var maxFirstValue = new Date();
    maxFirstValue.setHours(18);
    maxFirstValue.setMinutes(0);
    scope.maxFirstValue = maxFirstValue;
    var minFirstValue = new Date();
    minFirstValue.setHours(7);
    minFirstValue.setMinutes(0);
    scope.minFirstValue = minFirstValue;
    var maxFirst = new Date();
    maxFirst.setHours(18);
    maxFirst.setMinutes(0);
    scope.maxFirst = maxFirst;
    var minFirst = new Date();
    minFirst.setHours(7);
    minFirst.setMinutes(0);
    scope.minFirst = minFirst;
    scope.corres = {
        corrremarks: '',
        calltype: '',
        callstatus: '',
        workStatus: ''
    };

    scope.ctrlName = "UnapprovedCancelController";

    scope.formatTime = UtilitiesService.formatTime;
    scope.compareDate = UtilitiesService.compareDate;
    scope.getDateObj = UtilitiesService.getDateObj;
    scope.showList = true;
    scope.showDetailView = false;
    scope.showData = {};
    scope.showAddTestBox = false;
    scope.ContractAsSales = false;
    scope.prePolicyERId = 51162;
    scope.policyBazaarRequestsContractId = PlusUtilitiesService.getSpecificContract("E_SALES")[0];
    scope.contracts = PlusUtilitiesService.getContracts();
    scope.createresult = false;
    scope.totalPrice = 0;
    scope.orderObj = new Object();
    scope.orderItemObj = new Object();
    scope.showPaid = false;
    scope.paid = true;
    scope.txn = {};
    scope.correspondencData = [];
    scope.location = {};
    scope.employee = new Object();
    scope.cartEmpty = true;
    scope.CartAppointments = [];
    scope.benefMAID = 0;
    scope.pkgSelected = 0;
    scope.client = {};
    scope.client.visitType = '';
    scope.empContract = "";
    scope.empCorporate = "";
    scope.testName = null;
    scope.showSuccessMessage = false;
    scope.contracts = PlusUtilitiesService.getContracts();
    scope.filter = {};
    scope.isDownload = false;
    scope.defaultSet = true;
    scope.isInsurer = true;
    scope.isHrLogin = true;
    if (scope.user && scope.user.rolesFeatures) {
        angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
            if (v.roleId == 9212) {
                scope.isDownload = true;
            }
        });
        angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
            if (v.roleId == 9207 || v.roleId == 9211 || v.roleId == 9214) {
                scope.isInsurer = false;
            }
            if (v.roleId === 9209) {
                scope.isHrLogin = false;
            }
        });
    }
    scope.open1 = function () {
        scope.popup1.opened = true;
    };
    scope.open2 = function () {
        scope.popup2.opened = true;
    };

    scope.open5 = function () {
        scope.popup5.opened = true;
    };
    scope.open6 = function () {
        scope.popup6.opened = true;
    };

    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];
    scope.popup4 = {
        opened: false
    };
    scope.popup1 = {
        opened: false
    };
    scope.open4 = function () {
        scope.popup4.opened = true;
    };
    scope.popup2 = {
        opened: false
    };

    scope.getSources = function () {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + "/contractlookup/" + PlusUtilitiesService.getSpecificContract("E_SALES")[0] + ".json", "", "GET").then(function (response) {
            scope.sources = response.data;
            $(scope.sources).each(function (i, v) {
                if (v.entityName.indexOf("Coverfox") != -1) {
                    scope.coverfox_id = v.id;
                }
                else if (v.entityName.indexOf("PolicyBazaar") != -1) {
                    scope.policybazaar_id = v.id;
                }
            })
        });
    };


    scope.checkContract = function (contract_id) {
        scope.ContractAsSales = (contract_id == "9782");
        scope.filter.contract = contract_id;
        scope.selectedSource = "";
        scope.filterAppointment();
    }

    scope.filterQueue = function (selectedSource) {
        scope.$watch('selectedSource', function (term) {
            scope.filter.source = term;
            scope.filterAppointment();
        });
    }
    scope.changeSource = function (contractId, selectedSource, selectedId) {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "contractlookup/" + contractId + "|" + selectedSource + ".json", "", "GET").then(function (response) {
            scope.selectedInsurers = response.data;
            var selectedInsurersKeys = Object.keys(response.data);
            if(selectedInsurersKeys.length > 1){
                angular.forEach(selectedInsurersKeys, function(key) {
                    if(response.data[key]['id'] == selectedId){
                        var insurerObj = response.data[key];
                        scope.selectedInsurers = {};
                        scope.selectedInsurers[key] = insurerObj;
                    }
                })
            }
        });
    };

    scope.setSource = function (selectedInsurer) {
        scope.selectedInsurer = selectedInsurer;
        if (scope.selectedInsurer && scope.selectedInsurer.id){
            scope.loadEsalesPackages(scope.selectedInsurer.id);
        }else{
            scope.loadEsalesPackages('0');
        }
    };
    scope.esalesPackagePostData = { searchType: {} };

    scope.searchAppointment = function(value) {
        scope.esalesPackagePostData = { searchType: {} };
        scope.esalesPackagePostData.searchType[value.selectedOrderType] = value.value;
        scope.esalesPostRequest(scope.esalesPackagePostData);      
    }
    scope.fetchFromInitial = true; 
    scope.esalesPostRequest = function (data) {
        data["pageNo"] = scope.currentPageNo;
        data["rows"] = scope.totalNoOfItemsToFetch;
        data['RequestFrom'] = 'Esales';
        var url = UtilitiesService.getPlusUrlPrefix() + '/policyBazaarRequests';
        UserService.makeRestCall(url, data, 'post', UserService.getAccessToken(), true).then(function (response) {
            if (response.data.isSuccess) {
                scope.pbqueue = response.data;
                scope.status.isFirstOpen = false;
                scope.filterDateData = response.data.pendingRequestQueueData;
                UserService.saleQueueDataCollection = response.data.pendingRequestQueueData;
                scope.$watch('search', function (term) {
                    scope.filter.text = term;
                    scope.filterAppointment();
                });
                scope.getInsurerList();
                scope.filterAppointment();
                scope.equoteData = {};
                $(scope.pbqueue.pendingRequestQueueData).each(function (i, v) {
                    if (v.id) {
                        v.originaleQuote = v.id;
                        // v.id = v.id.split("_")[0];
                    }
                    scope.equoteData[v.id] = JSON.parse(v.requestJSON);
                    if (scope.equoteData[v.id] && scope.equoteData[v.id].employeeId) {
                        scope.equoteData[v.id].originaleQuote = scope.equoteData[v.id].employeeId;
                        scope.equoteData[v.id].employeeId = scope.equoteData[v.id].employeeId.split("_")[0]
                    }
                    scope.equoteData[v.id]['pbrequestId'] = v.id;
                    scope.equoteData[v.id]['source'] = v.source;
                })
            } else {
                UtilitiesService.showAlertMessage(response.errorMessage, false);
            }   
        });
    }

    rootScope.$on('eSalesSearch', function (key, value) {
        scope.searchAppointment(value);
        scope.fetchFromInitial = true;
        this.currentPageNo = 0;
    });

    scope.status = {
        isFirstOpen: true
    };
    scope.isEmpty =  function(obj) { for(var key in obj) { if(obj.hasOwnProperty(key)) return false; } return true; }

    if (scope.user) {
        scope.isActive = true;

        scope.filterAppointment = function () {
            scope.pbqueueFiltered = scope.pbqueue.pendingRequestQueueData;
            if (scope.filter.text)
                scope.pbqueueFiltered = filterFilter(scope.pbqueueFiltered, scope.filter.text);
            if (scope.filter.contract)
                scope.pbqueueFiltered = filterFilter(scope.pbqueueFiltered, { 'contractID': scope.filter.contract });
            if (scope.filter.source)
                scope.pbqueueFiltered = filterFilter(scope.pbqueueFiltered, { 'source': scope.filter.source });

            // scope.noOfPages = scope.pbqueueFiltered.length;
             // Math.ceil(scope.pbqueueFiltered.length / scope.entryLimit);
            scope.pbqueueCount = scope.pbqueueFiltered.length;
        }
        scope.currentPageNo = 0;
        scope.totalNoOfItemsToFetch = 10;
        scope.searchAppointmentsGroupCtrl = function (pageNo){
            if (scope.fetchFromInitial && pageNo > 0) {
                scope.currentPageNo = 0;           
                scope.fetchFromInitial = false;
            }       
            scope.currentPageNo = pageNo;   
            if (!scope.isEmpty(scope.esalesPackagePostData.searchType)) {
                scope.esalesPostRequest(scope.esalesPackagePostData);
            } else {
                var id = scope.serverSearch.corporateId ? scope.serverSearch.corporateId ? scope.serverSearch.corporateId.id : 0 : 0;            
                scope.getXMLRequests(scope.serverSearch.fromDate, scope.serverSearch.toDate, id, scope.serverSearch.state);
            }
        }
        scope.getXMLRequests = function (fromDate, toDate, ErId, state) {
                
            if (scope.esalesPackagePostData.searchType) {
                scope.esalesPackagePostData.searchType = {};
            }
            fromDate = scope.serverSearch.fromDate ? $filter('date')(scope.serverSearch.fromDate, 'yyyy-MM-dd') : '';
            toDate = scope.serverSearch.toDate ? $filter('date')(scope.serverSearch.toDate, 'yyyy-MM-dd') : '';
            var id = scope.serverSearch.corporateId ? scope.serverSearch.corporateId ? scope.serverSearch.corporateId.id : 0 : 0;
            // var contractID = contractId ? contractId : 0;
            var state = scope.serverSearch.state;
            //store search detail
            UtilitiesService.setQueueSearchDetail(scope.serverSearch);
            var url = UtilitiesService.getPlusUrlPrefix() + '/policyBazaarRequests/0/' + id + '/' + state + '/' + fromDate + '/' + toDate + '/' + scope.currentPageNo + '/' + scope.totalNoOfItemsToFetch;
            UserService.makeRestCall(url, '', 'GET', UserService.getAccessToken(), true).then(function (response) {
                if (response.data.isSuccess) {
                scope.pbqueue = response.data;
                scope.status.isFirstOpen = false;
                scope.filterDateData = response.data.pendingRequestQueueData;
                UserService.saleQueueDataCollection = response.data.pendingRequestQueueData;
                scope.entryLimit = 10;
                scope.currentPage = 1; //current page
                scope.maxSize = 5; //pagination max size
                scope.noOfPages = response.data.totalCount; // Math.ceil(scope.pbqueue.length / scope.entryLimit);
                scope.$watch('search', function (term) {
                    scope.filter.text = term;
                    scope.filterAppointment();
                });
                scope.getInsurerList();
                scope.filterAppointment();
                scope.equoteData = {};
                $(scope.pbqueue.pendingRequestQueueData).each(function (i, v) {
                    if (v.id) {
                        v.originaleQuote = v.id;
                        // v.eQuote = v.eQuote.split("_")[0];
                    }
                    scope.equoteData[v.id] = JSON.parse(v.requestJSON);
                    if (scope.equoteData[v.id] && scope.equoteData[v.id].employeeId) {
                        scope.equoteData[v.id].originaleQuote = scope.equoteData[v.id].employeeId;
                        scope.equoteData[v.id].employeeId = scope.equoteData[v.id].employeeId.split("_")[0]
                    }
                    scope.equoteData[v.id]['pbrequestId'] = v.id;
                    scope.equoteData[v.id]['source'] = v.source;
                })
            } else {
                UtilitiesService.showAlertMessage(response.errorMessage, false);
            }   
            });
        };
        //Clear Search data
        scope.clearSearch = function () {
            scope.serverSearch.fromDate = '';
            scope.serverSearch.toDate = '';
            scope.serverSearch.contractType = '';
            scope.serverSearch.corporateId = '';
            scope.serverSearch.statusSearch = { id: '0', name: 'All Status' };
            scope.contractsData = [];
            // scope.contractsData.push({ id: '0', entityName: 'All Corporate' });
            scope.status.isFirstOpen = false;
            scope.serverSearch.state = '';
            
        };
        scope.compareDate = UtilitiesService.compareDate;
        scope.showFirst = function () {
            scope.defaultSet = true;
            scope.showList = true;
            scope.serverSearch = {
                fromDate: '',
                toDate: '',
                statusSearch: '',
                contractType: '',
                corporateId: '',
                state: ''
            };
            
            

            scope.contractsData = [];
            // scope.contractsData.push({ id: '0', entityName: 'All Corporate' });
            // scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };
            //scope.getXMLRequests();
            //get search detail
            scope.isSearchDataAvailable = UtilitiesService.getQueueSearchDetail();
            if (scope.isSearchDataAvailable) {
                //set last search values
                scope.serverSearch.fromDate = scope.isSearchDataAvailable.fromDate;
                scope.serverSearch.toDate = scope.isSearchDataAvailable.toDate;
                scope.serverSearch.contractType = scope.isSearchDataAvailable.contractType;
                scope.serverSearch.state = scope.isSearchDataAvailable.state;
                if (scope.isSearchDataAvailable.contractType) {
                    var contractTypeId = scope.isSearchDataAvailable.contractType ? (scope.isSearchDataAvailable.contractType.id ? scope.isSearchDataAvailable.contractType.id : scope.isSearchDataAvailable.contractType) : '0';
                    scope.getCorporatePackages(scope.isSearchDataAvailable.contractType.id, true);
                }
                scope.getXMLRequests(scope.isSearchDataAvailable.fromDate, scope.isSearchDataAvailable.toDate, scope.isSearchDataAvailable);
            } else {
                scope.getXMLRequests();
            }

            scope.showDetailView = false;
            scope.showData = {};
        }
        scope.autoMapDc = function () {
            if (scope.additionalInfo.ProviderId && scope.additionalInfo.ProviderName && scope.additionalInfo.AppointmentDateTime) {
                scope.selectedDcFromDavanceSearch = { name: scope.additionalInfo.ProviderName }
                scope.isFlage.autoDcSelection = true;
                scope.isFlage.autDcSection = 'auto';
            } else {
                scope.isFlage.autoDcSelection = false;
                scope.isFlage.autDcSection = 'auto';
            }
        };
        scope.isSelectedpackage = false;
        scope.loadEsalesPackages = function (id) {
            scope.isSelectedpackage = false;
            scope.loading = true;
            scope.benefMAID = '0';
            var data = {
                ruleEngineVariable: {
                    entityRelationId: id,
                    employeeId: scope.showData.EmployeeId ? scope.showData.EmployeeId : 'PB Emp',
                    maid: scope.benefMAID,
                    loadRetailPackages: false,
                    ruleParams: { 'String': 'String' }
                },
                cartAppointment: []
            }
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/ruleengine', data, 'POST').then(function (response) {
                response.data.isSuccess = true;//Remove this once included in service
                scope.packages = [];
                scope.tests = [];
                if (response.data.isSuccess) {
                    if (response.data.ruleEnginePackages.length > 0) {
                        scope.packages = response.data.ruleEnginePackages;
                        scope.packagesObj = {};
                        scope.testsObj = {};
                        $(scope.packages).each(function (i, v) {
                            scope.packagesObj[v.peR_Id] = v;
                        })
                        $(scope.tests).each(function (i, v) {
                            scope.testsObj[v.peR_Id] = v;
                        })
                        //var mappedPackages = [{ "peR_Id": 3707756, "packageName": "Cat 4_ Non Premium - Female", "isPaid": false, "packagePrice": 2850, "serviceTax": 399, "primaryCessTax": 0, "secondaryCessTax": 0, "swachhBharatCess": 0, "krishiKalyanCess": 0, "mahsCharge": 0, "contract": { "contractId": 9782, "contractName": "E_SALES" }, "isInvestigation": false }];
                        var mappedPackages = [];

                        if (scope.displayTestDetails && scope.displayTestDetails.testDetails && scope.displayTestDetails.testDetails.length > 0) {
                            angular.forEach(scope.packages, function (index, key) {
                                angular.forEach(scope.displayTestDetails.testDetails, function (index1, key1) {
                                    //if (3707756 === index.peR_Id) {
                                    if (index1.testName === index.packageName) {
                                        mappedPackages.push(index);
                                    }
                                })
                            })
                            scope.isSelectedpackage = true;
                            scope.selectedPackageForAdvance = mappedPackages;
                            if (mappedPackages.length !== scope.displayTestDetails.testDetails.length) {
                                scope.isSelectedpackage = false;
                                var d1 = [], d2 = [];
                                scope.notMappedTest = [];
                                angular.forEach(scope.displayTestDetails.testDetails, function (index, key) {
                                    angular.forEach(mappedPackages, function (index1, key1) {
                                        if (index.testName !== index1.packageName) {
                                            d1.push(index);
                                        } else {
                                            d2.push(index);
                                        }
                                    });
                                    if (mappedPackages.length === 0) {
                                        scope.notMappedTest = scope.displayTestDetails.testDetails;
                                    } else {
                                        scope.notMappedTest = _.difference(_.uniq(d1), _.uniq(d2))
                                    }
                                });
                                UtilitiesService.showAlertMessage('All test is not matching with database, please add it manually before adding to cart.');
                            }
                            //scope.autoMapDc();
                        }
                    }
                }
                else {
                    UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                }
            });
        };

        scope.getPriceList = function (id) {
            if(id){
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'EntityProperties' + '/' + id, '', 'GET').then(function (response) {
                    if(response.data){
                        scope.entityProperties = response.data.entityProperties;
                        if(scope.entityProperties  && scope.entityProperties.length >0){
                            angular.forEach(scope.entityProperties, function(v, i){
                                if(v.propertyName ==='HVByDoctor'){
                                    scope.entityProperties[i].name = 'home visit by doctor';
                                }else if(v.propertyName ==='HVByTechnician'){
                                    scope.entityProperties[i].name = 'home visit by Technician';
                                }else if(v.propertyName ==='HVByECGTechnician'){
                                    scope.entityProperties[i].name = 'home visit by ECG Technician';
                                }
                            });
                        }
                        scope.entityPropertiesDummy = response.data.entityProperties;
                    }
                });

            }
        };

        scope.addToAdditionDetails = function () {
            var tempIndex = scope.additionalFieldList.indexOf(scope.field.fieldName);
            this.additionalFieldList.splice(tempIndex, 1);
            scope.additionalInfo[scope.field.fieldName] = scope.field.fieldValue;
            this.field.fieldName = '';
            this.field.fieldValue = '';
        }

        scope.orderObjForUpdate = { requestId: '' };
        scope.showData = { contractID: '', source: '' };

        scope.showDndBell = false;
        scope.showDndCustomerBell = false;
        scope.parseAdditionalInfo = function(data) {
            data.requestJSON.additionalInfo = JSON.parse(data.requestJSON.additionalInfo)
            data.requestJSON.additionalInfo.DND = 
            data.requestJSON.additionalInfo.hasOwnProperty('DND') ?  JSON
            .parse(data.requestJSON.additionalInfo.DND) : false;
            data.requestJSON.additionalInfo.DNDCustomer = data.requestJSON.additionalInfo.hasOwnProperty('DNDCustomer') ? JSON.parse(data.requestJSON.additionalInfo.DNDCustomer) : false;
        }
        scope.checkForDNDFlags = function(requestData) {
            requestData.requestJSON = JSON.parse(requestData.requestJSON);
            if (requestData.requestJSON && requestData.requestJSON.additionalInfo) {
                scope.parseAdditionalInfo(requestData);
                    scope.showDndBell = requestData.requestJSON.additionalInfo.DND;
                    scope.showDndCustomerBell = requestData.requestJSON.additionalInfo.DNDCustomer 
            } else {
                requestData.requestJSON['additionalInfo'] = { DND: false, DNDCustomer: false };
                scope.showDndBell = requestData.requestJSON.additionalInfo.DND;
                scope.showDndCustomerBell = requestData.requestJSON.additionalInfo.DNDCustomer;                
            }            
        }
        scope.showDetails = function (data) {
            scope.selectedAppointmentData = data;
            scope.defaultSet = false;
            scope.isDownload = false;
            scope.notMappedTest = [];
            if (data.contractID == PlusUtilitiesService.getSpecificContract("E_SALES")[0]) {
                scope.requestDataForDND = JSON.parse(JSON.stringify(data));
                scope.checkForDNDFlags(scope.requestDataForDND);
                scope.getPriceList(data.eR_ID);
                scope.displayTestDetails = data;
                scope.selectedPackageForAdvance = [];
                scope.packages = [];
                scope.markerArray = [];
                scope.isPackageSelectionAdvance = false;
                var getRequestJSON = JSON.parse(data.requestJSON);
                if (getRequestJSON.additionalInfo) {
                    var getAdditionalInfo = JSON.parse(getRequestJSON.additionalInfo);
                    scope.additionalInfo = getAdditionalInfo;
                }
                var newAdditionalInfo = {};
                angular.forEach(scope.additionalInfo, function (key, value) {
                    var tempIndex = scope.additionalFieldList.indexOf(key);
                    if(tempIndex > -1) {
                        scope.additionalFieldList.splice(tempIndex, 1);
                    }
                    newAdditionalInfo[value] = key;
                })
                scope.additionalInfo = newAdditionalInfo;                              
                if (data.eQuote) {
                    scope.showList = false;
                    scope.showDetailView = true;
                    scope.showData = scope.equoteData[data.id];
                    scope.orderObjForUpdate.requestId = scope.showData.pbrequestId;
                    scope.showData.contractID = data.contractID;
                    if (scope.showData.source == scope.coverfox_id) {
                        scope.readOnlyView = true;
                        scope.addDataToCart(data);
                    }
                    scope.changeSource(scope.showData.contractID, data.source, data.eR_ID);
                } else {
                    UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                }
                sharedDataSvc.setLocalStorageDataObj(data);
                scope.client.visitType = '';
            }
            else if (data.contractID == PlusUtilitiesService.getSpecificContract("Pre-Employment")[0]) {
                sharedDataSvc.setLocalStorageDataObj(data);

                UtilitiesService.setApptpath('queue');
                state.go('create.preemp');
            }
            else if (data.contractID == PlusUtilitiesService.getSpecificContract("Pre-Policy")[0]) {
                scope.getPriceList(data.eR_ID);
                sharedDataSvc.setLocalStorageDataObj(data);
                UtilitiesService.setApptpath('queue');
                state.go('create.prepolicy');
            }
        };

        scope.checkDuplicacy = function () {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/CheckEsalesOrderDuplicacy', scope.orderObj, 'POST').then(function (response) {
                if (response.data.isSuccess) {
                    if (response.data.isDuplicate) {
                        scope.isCart = false;
                        UtilitiesService.showAlertMessage('We already have appointment similar to this request, please check before you proceed.');
                    } else {
                        scope.createAppointment();
                    }
                }
                else {
                    UtilitiesService.showAlertMessage('Unable to proceed in booking order');
                }
            });
        };

        scope.loadStates = function () {
            var url = UtilitiesService.getPlusUrlPrefix('integration') + "masterdata/lookup/state.json";
            UserService.makeRestCall(url, "", "get").then(function (response) {
                if (response.data.isSuccess) {
                    scope.states = response.data.lookUpData;
                }
            });
        };

        scope.loadData = function (type, id) {
            switch (type) {
                case "city":
                    loadCities(id);
                    break;
                case "locality":
                    loadLocations(id);
                    break;
                case "sublocality":
                    loadSubLocations(id);
                    break;
                case "dc":
                    loadDCs(id);
                    break;
                default:
                    loadCities(id);
                    break;
            }
        };

        $(function () {
            UtilitiesService.queueSearchData = {};            
            scope.loadStates();
            scope.getSources();
            if (scope.isInsurer === false) {                
                scope.getXMLRequests();
            }
            /*scope.isSearchDataAvailableOnLoad = UtilitiesService.getQueueSearchDetail();
            if (!(_.isEmpty(scope.isSearchDataAvailableOnLoad))) {
                //set last search values
                scope.serverSearch.fromDate = scope.isSearchDataAvailableOnLoad.fromDate;
                scope.serverSearch.toDate = scope.isSearchDataAvailableOnLoad.toDate;
                if (scope.isSearchDataAvailableOnLoad.contractType) {
                    if (typeof (scope.isSearchDataAvailableOnLoad.contractType) === 'object') {
                        var contractVal = scope.isSearchDataAvailableOnLoad.contractType.id;
                    } else {
                        var contractVal = scope.isSearchDataAvailableOnLoad.contractType;
                    }
                    scope.getCorporatePackages(contractVal, true);
                }
                scope.serverSearch.contractType = scope.isSearchDataAvailableOnLoad.contractType;
                scope.getXMLRequests(scope.isSearchDataAvailableOnLoad.fromDate, scope.isSearchDataAvailableOnLoad.toDate, scope.isSearchDataAvailableOnLoad);
            } */
        });

        scope.validation = function () {
            var data;
            if (scope.pkgDcId || scope.testDcId) {
                data = true;
            } else {
                data = false;
            }
            return data;
        };

        scope.validateFinance = function () {
            var valid = true;
            $(".required").removeClass("required");
            if ((!scope.txn.txnNumber || scope.txn.txnNumber == "") && scope.paid) {
                valid = false;
                $("#txnNumber").addClass("required");
            }
            else {
                scope.orderObj.transactionId = scope.txn.txnNumber;
            }
            return valid;
        };

        function loadStates() {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + "masterdata/lookup/state.json", "", "get").then(function (response) {
                if (response.data.isSuccess) {
                    scope.states = response.data.lookUpData;
                    scope.states = orderByFilter(scope.states, 'lookUpValue', scope.reverse);
                }
            });
        };

        function loadCities(newstateId) {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "masterdata/lookup/district/" + newstateId + ".json", "", "get").then(function (response) {
                if (response.data.isSuccess) {
                    scope.cities = response.data.lookUpData;
                    scope.cities = orderByFilter(scope.cities, 'lookUpValue', scope.reverse);
                }
            });
        };

        function loadLocations(newcityId) {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "masterdata/lookup/city/" + newcityId + ".json", "", "get").then(function (response) {
                if (response.data.isSuccess) {
                    scope.locations = response.data.lookUpData;
                    scope.locations = orderByFilter(scope.locations, 'lookUpValue', scope.reverse);
                }
            });
        };

        function loadSubLocations(newlocationId) {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "masterdata/lookup/location/" + newlocationId + ".json", "", "get").then(function (response) {
                if (response.data.isSuccess) {
                    scope.sublocations = response.data.lookUpData;
                    scope.sublocations = orderByFilter(scope.sublocations, 'lookUpValue', scope.reverse);
                }
            });
        };

        scope.calculatePrice = function(){
            var totalPrice =0;
            if(scope.entityProperties){
                angular.forEach(scope.entityProperties, function(v,i){
                    if(v.propertySelected){
                        totalPrice = totalPrice + parseInt(v.propertyValue);
                    }
                });
            }
            return totalPrice;
        };
        scope.calculatePriceData = function(){
            var totalPriceData = {};
            if(scope.entityProperties){
                angular.forEach(scope.entityProperties, function(v,i){
                    if(v.propertySelected){
                        totalPriceData[v.propertyName] = v.propertyValue;
                    }
                });
            }
            return totalPriceData;
        };

        scope.isShowPriceList = false;
        scope.visitTypeChange = function (value) {
            scope.client.visitType = value;
            scope.entityProperties = [];
            if(value ==='Home_Visit'){
                scope.entityProperties = scope.entityPropertiesDummy;
                scope.isShowPriceList = true;
            }else{
                scope.isShowPriceList = false;
            }
        };

        scope.loadCities = function (selectedState) {
            scope.selectedState = selectedState;
            if (scope.selectedState) {
                if (scope.selectedState.lookUpId) {
                    scope.location.state = scope.selectedState.lookUpId
                    var url = UtilitiesService.getPlusUrlPrefix() + "masterdata/lookup/district/" + scope.selectedState.lookUpId + ".json";
                    UserService.makeRestCall(url, "", "get").then(function (response) {
                        if (response.data.isSuccess) {
                            scope.cities = response.data.lookUpData;
                            scope.citiesObj = {}
                            $(scope.cities).each(function (i, v) {
                                scope.citiesObj[v.lookUpId] = v;
                            })
                            scope.cities = orderByFilter(scope.cities, 'lookUpValue', scope.reverse);
                        }
                    });
                }
            }
        };
        
        scope.loadLocations = function (selectedCity) {
            scope.selectedCity = selectedCity;
            if (scope.selectedCity) {
                if (scope.selectedCity.lookUpId) {
                    scope.location.city = scope.selectedCity.lookUpId;
                    var url = UtilitiesService.getPlusUrlPrefix() + "masterdata/lookup/city/" + scope.selectedCity.lookUpId + ".json";
                    UserService.makeRestCall(url, "", "get").then(function (response) {
                        if (response.data.isSuccess) {
                            scope.locations = response.data.lookUpData;
                            scope.locations = orderByFilter(scope.locations, 'lookUpValue', scope.reverse);
                        }
                    });
                }
            }
        };
        scope.loadSubLocations = function (selectedLocation) {
            scope.selectedLocation = selectedLocation;
            if (scope.selectedLocation) {
                if (scope.selectedLocation.lookUpId) {
                    scope.location.location = scope.selectedLocation.lookUpId;
                    var url = UtilitiesService.getPlusUrlPrefix() + "masterdata/lookup/location/" + scope.selectedLocation.lookUpId + ".json";
                    UserService.makeRestCall(url, "", "get").then(function (response) {
                        if (response.data.isSuccess) {
                            scope.sublocations = response.data.lookUpData;
                            scope.sublocations = orderByFilter(scope.sublocations, 'lookUpValue', scope.reverse);
                        }
                    });
                }
            }
        };

        scope.loadCitiesNew = function (selectedState) {
            scope.selectedState = selectedState;
            if (scope.selectedState) {
                if (scope.selectedState.lookUpId) {
                    scope.location.state = scope.selectedState.lookUpId
                    var url = UtilitiesService.getPlusUrlPrefix() + "masterdata/lookuplevel/" + scope.selectedState.lookUpId + "/2";
                    UserService.makeRestCall(url, "", "get").then(function (response) {
                        if (response.data.isSuccess) {
                            scope.cities = response.data.lookUpData;
                            scope.citiesObj = {}
                            $(scope.cities).each(function (i, v) {
                                scope.citiesObj[v.lookUpId] = v;
                            })
                            scope.cities = orderByFilter(scope.cities, 'lookUpValue', scope.reverse);
                        }
                    });
                }
            }
        };

        scope.loadLocationsNew = function (selectedLocation) {
            scope.selectedLocation = selectedLocation;
            if (scope.selectedLocation) {
                if (scope.selectedLocation.lookUpId) {
                    scope.location.location = scope.selectedLocation.lookUpId;
                    var url = UtilitiesService.getPlusUrlPrefix() + "masterdata/lookup/location/" + scope.selectedLocation.lookUpId + ".json";
                    UserService.makeRestCall(url, "", "get").then(function (response) {
                        if (response.data.isSuccess) {
                            scope.sublocations = response.data.lookUpData;
                            scope.sublocations = orderByFilter(scope.sublocations, 'lookUpValue', scope.reverse);
                        }
                    });
                }
            }
        };

        scope.loadDCs = function (sublocationId) {
            if (sublocationId) {
                var erTypeName = "DC_MediAssist"
                var ERTypeId = PlusUtilitiesService.getDC_MA_ContractID(); // DC_mediassist
                var serviceBrokerId = "1000042"; //mediassist
                var serviceBrokerName = "Medi Assist";
                var Entity_Type = "4653"; //lookup call Entity_Type
                var PM_TypeId = PlusUtilitiesService.getDC_Inv_PmTypeId(); // pm type id for investigations
                scope.location.sublocation = sublocationId;
                var url = UtilitiesService.getPlusUrlPrefix() + "EntityRelation/Search/EntitySearch/" + ERTypeId + "/" + serviceBrokerId + "/" + 0 + "/" + scope.location.state + "/" + scope.location.city + "/" + scope.location.location + "/" + scope.location.sublocation + ".json";
                UserService.makeRestCall(url, "", "get").then(function (response) {
                    if (response.statusText == "OK") {
                        if (scope.allowedPackages) {
                            scope.diagnosticCentres = $.map(response.data, function (i) {
                                if (scope.allowedPackages && scope.allowedPackages.indexOf(i.id) != -1) {
                                    return i
                                }
                            });
                            scope.dcObj = scope.diagnosticCentres;
                            scope.dcObj = orderByFilter(scope.dcObj, 'lookUpValue', scope.reverse);
                        } else {
                            UtilitiesService.showAlertMessage('Please select package.');
                        }
                    }
                });
            }
        };

        scope.isDone = false;
        scope.orderIdNumber = '';
        scope.cancelPopup = function () {
            scope.orderDetails = '';
        };
        scope.deleteOrderEueue = function (flag, value) {
            scope.orderDetails = value;
            if (flag) {
                scope.orderIdNumber = scope.orderDetails.id;
                var data = { "requestId": scope.orderDetails.id };
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/InActivePolicyBazaar", data, "PUT", UserService.getAccessToken(), true).then(function (list) {
                    scope.isDone = true;
                    $("#deleteRequest").modal("hide");
                    scope.orderDetails = '';
                    timeout(function () {
                        scope.isDone = false;
                        scope.orderIdNumber = '';
                    }, 1000);
                    scope.getXMLRequests();
                });
            } else {
                scope.actionName1 = 'deleteRequest';
            }
        };

        scope.changePackage = function (peR_Id) {
            if (peR_Id) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/CorporatePackageProvider/" + peR_Id + "/false.json", "", "GET").then(function (list) {
                    scope.allowedPackages = list.data;
                });
            }
            else {
                // console.log("peR_Id not provided");
            }
        };

        var erTypeName = 'DC_MediAssist';
        var ERTypeId = PlusUtilitiesService.getDC_MA_ContractID(); // DC_mediassist
        var serviceBrokerId = '1000042';//mediassist
        var serviceBrokerName = 'Medi Assist';
        var Entity_Type = '4653'; //lookup call Entity_Type
        var PM_TypeId = PlusUtilitiesService.getDC_Inv_PmTypeId(); // pm type id for investigations
        function loadDCs(type) {
            if (type == "package") {
                var url = UtilitiesService.getPlusUrlPrefix() + "EntityRelation/Search/EntitySearch/" + ERTypeId + "/" + serviceBrokerId + "/" + 0 + "/" + scope.pkgStateId + "/" + scope.pkgCityId + "/" + scope.pkgLocalityId + "/" + scope.pkgSubLocalityId + ".json";
            }
            else if (type == "test") {
                var url = UtilitiesService.getPlusUrlPrefix() + "EntityRelation/Search/EntitySearch/" + ERTypeId + "/" + serviceBrokerId + "/" + 0 + "/" + scope.testStateId + "/" + scope.testCityId + "/" + scope.testLocalityId + "/" + scope.testSubLocalityId + ".json";
            }
            UserService.makeRestCall(url, "", "get").then(function (response) {
                if (response.statusText == "OK") {
                    scope.allDCs = response.data;
                    if (type == "package") {
                        scope.diagnosticCentres = $.map(response.data, function (i) { if (scope.allowedPackages.indexOf(i.id) != -1) { return i } })
                    }
                    else {
                        scope.diagnosticCentres = response.data
                    }
                    scope.dcObj = {};
                    $(scope.diagnosticCentres).each(function (i, v) {
                        scope.dcObj[v.id] = v;
                    })
                    scope.dcObj = orderByFilter(scope.dcObj, 'lookUpValue', scope.reverse);
                }
            });
        };

        scope.getFormattedDateTime = function (xdate, xtime) {
            var ydate = new Date(parseInt(xdate.replace("/Date(", "").replace(")/", ""), 10))
            var formattedDate = ydate.getFullYear() + "/" + (ydate.getMonth() + 1) + "/" + ydate.getDate() + " " + xtime.trim().split(" ")[0];
            return formattedDate;
        };

        scope.addDataToCart = function (data) {
            var jsonData = JSON.parse(data.requestJSON);
            var data = data;
            var selectedPackageData = {};
            scope.loading = true;
            var data = {
                ruleEngineVariable: {
                    entityRelationId: data.eR_ID,
                    employeeId: jsonData.EmployeeId ? jsonData.EmployeeId : 'PB Emp',
                    maid: 0,
                    loadRetailPackages: false,
                    ruleParams: { 'String': 'String' }
                },
                cartAppointment: []
            }
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/ruleengine', data, 'post').then(function (response) {
                response.data.isSuccess = true;//Remove this once included in service
                if (response.data.isSuccess) {
                    if (response.data.ruleEnginePackages.length > 0) {
                        var packageData = response.data.ruleEnginePackages;
                        $(jsonData.TestDetails).each(function (i, v) {
                            $(packageData).each(function (i1, v1) {
                                if (v1.peR_Id == v.TestID) {
                                    selectedPackageData = v1;
                                }
                            });
                            //console.log(selectedPackageData)                      
                        });
                    }
                }
                else {
                    UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                }
            });
        };

        scope.selectDc = function (id) {
            scope.pkgDcId = _.where(scope.dcObj, { id: parseInt(id) });
        };

        scope.selectDcIdFortest = function (id) {
            scope.testDcId = _.where(scope.dcObj, { id: parseInt(id) });
        };

        scope.removeOrderItem = function (item, event) {
            scope.totalPrice -= item.amount;
            var index = scope.orderObj.orderItems.indexOf(item);
            scope.CartAppointments.splice(index, 1);
            scope.packages = [];
            scope.selectedPackage = {};
            scope.orderObj.orderItems.splice(index, 1);
            var flag = 0;
            if (scope.orderObj.orderItems.length > 0) {
                $(scope.orderObj.orderItems).each(function (i, v) {
                    if (v.isPaid) {
                        flag++;
                    }
                })
                if (flag != 0) {
                    scope.showPaid = true;
                } else {
                    scope.showPaid = false;
                }
            } else {
                scope.cartEmpty = true;
                scope.showPaid = false;
            }
        };

        scope.getDob = function(input){
            var dateofbirth = '01/01/1000 00:00:00';
            if(input && input.additionalInfo){
                var additionalInfo = JSON.parse(input.additionalInfo);
                if(additionalInfo.DOB || additionalInfo.dob){
                    if(additionalInfo.DOB){
                        var dateofbirth = new Date(additionalInfo.DOB);
                    }else if(additionalInfo.dob){
                      var dateofbirth =  new Date(additionalInfo.dob);
                    }
                }else{
                    var dateofbirth =  new Date(dateofbirth);
                }
            }else{
                var dateofbirth =  new Date(dateofbirth);
            }
            return dateofbirth;
        };

        scope.addToCart = function (type, SelectedPeRId) {
            scope.totalPrice = 0;
            scope.pkgSelectedTime = UtilitiesService.mergeDateTimeObj(scope.client.secondPrefTime, scope.userTime.secondAppointmentTime);
            scope.testSelectedTime = UtilitiesService.mergeDateTimeObj(scope.client.TestPrefTime, scope.userTime.testAppointmentTime);
            switch (type) {
                case "package":
                    if (!scope.packagesObj) {
                        UtilitiesService.showAlertMessage('Please select package.');
                        return;
                    }
                    scope.selectedPackage = scope.packagesObj[SelectedPeRId];
                    scope.selectedDCId = _.first(scope.pkgDcId).id;
                    scope.selectedDcName = _.first(scope.pkgDcId).entityName;
                    scope.selectedDcCity = _.first(scope.pkgDcId).city.cityName;
                    scope.selectedDcLocation = _.first(scope.pkgDcId).location.locationName;
                    scope.selectedTime = scope.pkgSelectedTime;
                    break;
                case "test":
                    scope.selectedPackage = scope.testsObj[SelectedPeRId];
                    scope.selectedDCId = _.first(scope.testDcId).id;
                    scope.selectedDcName = _.first(scope.testDcId).entityName;
                    scope.selectedDcCity = _.first(scope.pkgDcId).city.cityName;
                    scope.selectedDcLocation = _.first(scope.pkgDcId).location.locationName;
                    scope.selectedTime = scope.testSelectedTime;
                    break;
                case 'auto':
                    scope.selectedDCId = scope.additionalInfo.ProviderId;
                    scope.selectedDcName = scope.additionalInfo.ProviderName;
                    scope.selectedDcCity = 'Auto Booked';
                    scope.selectedDcLocation = 'Auto Booked';
                    scope.selectedTime = scope.additionalInfo ? scope.additionalInfo.AppointmentDateTime ? new Date(scope.additionalInfo.AppointmentDateTime) : new Date() : new Date();
                    break;
                default:
                    break
            }
            if (scope.additionalInfo) {
                scope.additionalInfo.annualPremium = scope.annualPremium ? scope.annualPremium : ''
                scope.additionalInfo.sumAssured = scope.sumassuredetail.sumAssured ? scope.sumassuredetail.sumAssured : '';
                scope.additionalInfo.paidSpons = scope.sumassuredetail.paidSpons ? scope.sumassuredetail.paidSpons : '';
                scope.additionalInfo.policyType = scope.sumassuredetail.grpIndv ? scope.sumassuredetail.grpIndv : '';
                scope.additionalInfo.DNDCustomer =  scope.dndCustomer === true ? true : false;
                scope.additionalInfo['id'] = scope.requestDataForDND && scope.requestDataForDND.id ? scope.requestDataForDND.id : null;

            } else {
                scope.additionalInfo = {
                    annualPremium: scope.annualPremium ? scope.annualPremium : '',
                    sumAssured: scope.sumassuredetail.sumAssured ? scope.sumassuredetail.sumAssured : '',
                    paidSpons: scope.sumassuredetail.paidSpons ? scope.sumassuredetail.paidSpons : '',
                    policyType : scope.sumassuredetail.grpIndv ? scope.sumassuredetail.grpIndv : '',
                    DNDCustomer :  scope.dndCustomer === true ? true : false,
                    id: scope.requestDataForDND && scope.requestDataForDND.id ? scope.requestDataForDND.id : null
                }
            }
            if (scope.validation()) {
                if (!scope.selectedPackage) {
                    UtilitiesService.showAlertMessage('Please select package.');
                    return;
                }
                if (scope.selectedPackage.isPaid === true) {
                    scope.totalPrice += Math.round((scope.selectedPackage.packagePrice +
                                          scope.selectedPackage.serviceTax +
                                          scope.selectedPackage.primaryCessTax +
                                          scope.selectedPackage.secondaryCessTax +
                                          scope.selectedPackage.mahsCharge) * 100) / 100;
                }
                scope.orderItemObj = {
                    productId: scope.selectedPackage.peR_Id,
                    productName: scope.selectedPackage.packageName,
                    productType: scope.selectedPackage.contract.contractId,
                    preferredDC: [
                        {
                            id: scope.selectedDCId,
                            name: scope.selectedDcName,
                            ProviderCity: scope.selectedDcCity,
                            ProviderLocation: scope.selectedDcLocation,
                            firstPrefTime: scope.selectedTime
                        }
                    ],
                    priEntityId: 0,
                    secEntityId: 0,
                    firstName: scope.showData.name,
                    contactNum: scope.showData.mobileNumber,
                    isPaid: false,
                    isSponsored: true,
                    amount: Math.round((scope.selectedPackage.packagePrice +
                                scope.selectedPackage.serviceTax +
                                scope.selectedPackage.primaryCessTax +
                                scope.selectedPackage.secondaryCessTax +
                                scope.selectedPackage.mahsCharge) * 100) / 100,
                    MAID: scope.showData.employeeId ? scope.showData.employeeId : 0,
                    relation: 'NA',
                    city: scope.showData.city,
                    dob: scope.getDob(scope.showData),
                    gender: scope.genderList.gender ? scope.genderList.gender : 'NA',
                    employeeId: scope.additionalInfo.ProposalNumber ? scope.additionalInfo.ProposalNumber : scope.showData.employeeId,
                    source: scope.showData.source,
                    invoiceTo: scope.showData.invoiceTo,
                    visitType: scope.client.visitType ? scope.client.visitType : 'Appointment',
                    emailId: scope.showData.emailId,
                    additionalProperties: scope.additionalInfo ? scope.additionalInfo : '',
                    addressLine1: scope.client.visitType == "Home_Visit" ? scope.client.addressline1 : '',
                    addressLine2: scope.client.visitType == "Home_Visit" ? scope.client.addressline2 : ''
                }
                if (Object.keys(scope.orderObj).length == 0) {
                    scope.orderObj = {
                        createdByApp: 'DCPortal| Policy Bazaar',
                        amountAfterDiscount: scope.totalPrice + scope.calculatePrice(),
                        actualAmount: scope.totalPrice,
                        paymentMode: 'IndividualPaid',
                        aymentState: 'Unpaid',
                        accountNumber: scope.txn.accnumber,
                        bankIfscCode: scope.txn.ifsccode,
                        transactionId: scope.txn.txnNumber,
                        employeeId: scope.additionalInfo.ProposalNumber ? scope.additionalInfo.ProposalNumber : scope.showData.employeeId,
                        entityId: scope.selectedInsurer.id,
                        entityName: scope.selectedInsurer.entityName,
                        employeeName: scope.showData.name,
                        contractId: scope.policyBazaarRequestsContractId,
                        employeeEmail: scope.showData.emailId,
                        employeeContactNo: scope.showData.mobileNumber,
                        source: scope.showData.source,
                        orderItems: [
                            scope.orderItemObj
                        ],
                        paymentSuccessUrl: 'www.mahs.in',
                        paymentFailureUrl: 'www.mediassistindia.com',
                        requestAccessToken: UserService.getAccessToken(),
                        additionals: scope.calculatePriceData()
                    }
                    scope.cartEmpty = false;
                }
                else {
                    scope.orderObj.actualAmount = scope.totalPrice;
                    scope.orderObj.orderItems.push(scope.orderItemObj);
                }
                angular.forEach(scope.orderObj.orderItems, function (item, index) {
                    if (item.isPaid) {
                        scope.showPaid = true;
                    }
                });
                scope.cartEmpty = false;
                $("select").val('');
            }
            else {
                if (scope.selectedPackageForAdvance.length > 0) {
                    scope.orderItemList = [];
                    angular.forEach(scope.selectedPackageForAdvance, function (data, index) {
                        scope.totalPrice += Math.round((parseInt(data.packagePrice) +
                        parseInt(data.serviceTax) +
                        parseInt(data.primaryCessTax) +
                        parseInt(data.secondaryCessTax) +
                        parseInt(data.mahsCharge)) * 100) / 100;
                        scope.orderItemList.push({
                            productId: data.peR_Id,
                            productName: data.packageName,
                            productType: data.contract.contractId,
                            preferredDC: [
                                {
                                    id: scope.isFlage.autDcSection === 'auto' ? scope.selectedDCId : scope.selectedDcFromDavanceSearch.id,
                                    name: scope.isFlage.autDcSection === 'auto' ? scope.selectedDcName : scope.selectedDcFromDavanceSearch.entityName,
                                    ProviderCity: scope.isFlage.autDcSection === 'auto' ? scope.selectedDcCity : scope.selectedDcFromDavanceSearch.city.cityName,
                                    ProviderLocation: scope.isFlage.autDcSection === 'auto' ? scope.selectedDcLocation : scope.selectedDcFromDavanceSearch.location.locationName,
                                    firstPrefTime: scope.isFlage.autDcSection === 'auto' ? scope.selectedTime : scope.firstPrefTime,
                                    secondPrefTime: scope.isFlage.autDcSection === 'auto' ? scope.selectedTime : scope.secondPrefTime,
                                }
                            ],
                            priEntityId: 0,
                            secEntityId: 0,
                            firstName: scope.showData.name,
                            contactNum: scope.showData.mobileNumber,
                            isPaid: false,
                            isSponsored: true,
                            amount: Math.round((data.packagePrice +
                                        data.serviceTax +
                                        data.primaryCessTax +
                                        data.secondaryCessTax +
                                        data.mahsCharge) * 100) / 100,
                            MAID: scope.showData.employeeId ? scope.showData.employeeId : 0,
                            relation: 'NA',
                            city: scope.showData.city,
                            dob: scope.getDob(scope.showData),
                            gender: scope.genderList.gender ? scope.genderList.gender : 'NA',
                            employeeId: scope.additionalInfo.ProposalNumber ? scope.additionalInfo.ProposalNumber : scope.showData.employeeId,
                            source: scope.showData.source,
                            invoiceTo: scope.showData.invoiceTo,
                            visitType: scope.client.visitType ? scope.client.visitType : 'Appointment',
                            emailId: scope.showData.emailId,
                            additionalProperties: scope.additionalInfo ? scope.additionalInfo : '',
                            addressLine1: scope.client.visitType == "Home_Visit" ? scope.client.addressline1 : '',
                            addressLine2: scope.client.visitType == "Home_Visit" ? scope.client.addressline2 : ''
                        })
                    });
                    if (scope.showData.name) {
                        scope.orderObj = {
                            createdByApp: 'DCPortal| Policy Bazaar',
                            amountAfterDiscount: scope.totalPrice + scope.calculatePrice(),
                            actualAmount: scope.totalPrice,
                            paymentMode: 'IndividualPaid',
                            paymentState: 'Unpaid',
                            accountNumber: scope.txn.accnumber,
                            bankIfscCode: scope.txn.ifsccode,
                            transactionId: scope.txn.txnNumber,
                            employeeId: scope.additionalInfo.ProposalNumber ? scope.additionalInfo.ProposalNumber : scope.showData.employeeId,
                            entityId: scope.selectedInsurer.id,
                            entityName: scope.selectedInsurer.entityName,
                            employeeName: scope.showData.name,
                            contractId: scope.policyBazaarRequestsContractId,
                            employeeEmail: scope.showData.emailId,
                            employeeContactNo: scope.showData.mobileNumber,
                            source: scope.showData.source,
                            orderItems: scope.orderItemList,
                            paymentSuccessUrl: 'www.mahs.in',
                            paymentFailureUrl: 'www.mediassistindia.com',
                            requestAccessToken: UserService.getAccessToken(),
                            additionals: scope.calculatePriceData()
                        }
                        if (scope.isFlage.autDcSection === 'auto') {
                            scope.cartEmpty = false;
                            scope.isCart = true;
                        } else {
                            scope.cartEmpty = false;
                            scope.isCart = false;
                        }

                    } else {
                        UtilitiesService.showAlertMessage('Please fill customer details.');
                    }
                }
            }
        };
        scope.updateProcessedStatus = function (requestId, orderId) {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/IsProcessedPolicyBazaar/" + requestId + "/" + orderId, "", "GET", UserService.getAccessToken(), true).then(function (response) {
                scope.showFirst();
                scope.showSuccessMessage = true;
                scope.orderObj = {};
                scope.orderItemObj = {};
                scope.totalPrice = 0;
                scope.cartEmpty = true;
                scope.showAddTestBox = false;
            }, function (error) {
                UtilitiesService.showAlertMessage('PolicyBazaar request could not be updated.');
            })
        };
        scope.isOrderCreated = false;

        scope.createAppointment = function () {
            scope.isCart = false;
            if ((!scope.showPaid || scope.validateFinance()) && scope.paid) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/order', scope.orderObj, 'POST').then(function (response) {
                    scope.entityProperties = [];
                    scope.client = {};
                    if (response.data.isSuccess) {
                        scope.orderData = response.data;
                        if (scope.orderObjForUpdate.requestId) {
                            scope.updateProcessedStatus(scope.orderObjForUpdate.requestId, scope.orderData.orderId);
                            scope.isOrderCreated = true;
                            var html = 'Order created successfully. ' + scope.orderData.orderId + '.';
                            window.scrollTo(0, 0);
                            timeout(function () {
                                scope.isOrderCreated = false;
                            }, 6000);
                            UtilitiesService.showAlertMessage(html, true);
                        }
                        else {
                            scope.showFirst();
                            scope.showSuccessMessage = true;
                            scope.orderObj = {};
                            scope.orderItemObj = {};
                            scope.totalPrice = 0;
                            scope.cartEmpty = true;
                            scope.showAddTestBox = false;
                        }
                    }
                    else {
                        scope.isOrderCreated = false;
                        UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                    }
                });
            }
            else if ((!scope.showPaid || scope.validateFinance()) && !scope.paid) {
                scope.cart_order = {}
                scope.cart_order = { 'order': scope.orderObj }
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/cart', scope.cart_order, 'POST').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.orderData = response.data;
                        if (scope.showData.pbrequestId) {
                            scope.updateProcessedStatus(scope.showData.pbrequestId, scope.orderData.orderId);
                        }
                        else {
                            scope.showFirst();
                            scope.showSuccessMessage = true;
                            scope.orderObj = {};
                            scope.orderItemObj = {};
                            scope.totalPrice = 0;
                            scope.cartEmpty = true;
                            scope.showAddTestBox = false;
                        }
                    }
                    else {
                        UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                    }
                });
            }
            else {
                UtilitiesService.showAlertMessage('Transaction details are mandatory as order contains paid packages.');
                //console.log("Transaction details are mandatory as order contains paid packages");
            }
        };
    };

    scope.loadDcForAllPackages = function (newSubLocationId) {
        var perIdsList = [];
        angular.forEach(scope.selectedPackageForAdvance, function (e, i) {
            perIdsList.push(e.peR_Id);
        });
        if (scope.location.state && scope.location.location && newSubLocationId) {
            var data = {
                packageIds: perIdsList,
                stateId: scope.location.state,
                cityId: scope.location.location,
                locationId: newSubLocationId
            };
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'AllEligibleDCByPackageIdsAndByLocation', data, 'POST').then(function (response) {
                if (response.data.length > 0) {
                    scope.diagnosticCentres = response.data;
                } else {
                    UtilitiesService.showAlertMessage('No Diagnostic Centre found.');
                }
            }, function (error) {
                UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
            });
        }
    };

    scope.distances = constant.distances;
    scope.windowOptions = {};
    scope.radious = {
        distance: 2,
        lat: '',
        lng: ''
    };

    scope.loadDcList = function (lat, lng) {
        var perIdsList = [];
        angular.forEach(scope.selectedPackageForAdvance, function (e, i) {
            perIdsList.push(e.peR_Id);
        });
        scope.markerArray = [];
        if (lat && lng) {
            scope.radious.lat = lat;
            scope.radious.lng = lng;
            var data = {
                packageIds: perIdsList,
                latitude: lat,
                longitude: lng,
                distance: scope.radious.distance,
            };
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'AllEligibleDCByPackageIdsAndByLocation', data, 'POST').then(function (response) {
                if (response.data.length > 0) {
                    scope.isMarkerArray = false;
                    scope.advanceDcList = response.data;
                    angular.forEach(scope.advanceDcList, function (data, index) {
                        scope.markerArray.push({
                            id: scope.advanceDcList[index].id,
                            entityAddress: scope.advanceDcList[index].entityAddress,
                            pinCode: scope.advanceDcList[index].pinCode,
                            coords: {
                                latitude: scope.advanceDcList[index].latitude,
                                longitude: scope.advanceDcList[index].longitude,
                            },
                            entityName: scope.advanceDcList[index].entityName,
                            marker: false
                        });
                        scope.windowOptions[scope.advanceDcList[index].id] = {
                            visible: false,
                        }
                    })
                    scope.map = {
                        center: {
                            latitude: scope.lat,
                            longitude: scope.lng
                        },
                        stroke: {
                            color: '#08B21F',
                            weight: 2,
                            opacity: 1
                        },
                        fill: {
                            color: '#08B21F',
                            opacity: 0.5
                        },
                        markersEvents: {
                            click: function (marker, eventName, model, arguments) {
                                angular.forEach(scope.markerArray, function (data, index) {
                                    if (parseInt(data.id) === parseInt(marker.key)) {
                                        scope.markerArray[index].visible = true;
                                    } else {
                                        scope.markerArray[index].visible = false;
                                    }
                                })
                            }
                        },
                        window: {
                            marker: {},
                            show: false,
                            closeClick: function (value) {
                                this.show = false;
                            },
                            options: {},
                            title: ''
                        },
                        radius: 10,
                        geodesic: true,
                        visible: true,
                        zoom: 12
                    }
                } else {
                    scope.isMarkerArray = true;
                    scope.markerArray = [];
                    UtilitiesService.showAlertMessage('No Diagnostic Centre found.');
                }
            }, function (error) {
                UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            });
        }
    };

    scope.selectedDcFromMap = function (markerObj, $event) {
        if (markerObj) {
            scope.selectedDcFromDavanceSearch = markerObj;
            scope.windowParams.list = scope.selectedDcFromDavanceSearch;
        } else {
            scope.selectedDcFromDavanceSearch = '';
            scope.windowParams.list = scope.selectedDcFromDavanceSearch;
        }
    };
    scope.rajasthanStateList = ['Andaman and Nicobar Islands','Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chandigarh','Chhattisgarh','Dadra and Nagar Haveli','Daman and Diu','Delhi','Goa','Gujarat','Haryana','Himachal Pradesh','Jammu and Kashmir','Jharkhand','Karnataka','Kerala','Lakshadweep','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Orissa','Pondicherry','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttaranchal','Uttar Pradesh','West Bengal']

    scope.closeCart = function () {
        scope.isCart = !scope.isCart;
    };

    scope.$on('gmPlacesAutocomplete::placeChanged', function (key, value) {
        if (value && value._api) {
            var location = value._api.getPlace().geometry.location;
            scope.lat = location.lat();
            scope.lng = location.lng();
            scope.$apply();
            scope.loadDcList(scope.lat, scope.lng);
        }
    });


    scope.DCSelection = function (vlaue) {
        scope.isPackageSelectionManual = vlaue === 'manula' ? true : false;
        scope.isPackageSelectionAdvance = vlaue === 'advance' ? true : false;
        scope.isFlage.autDcSection = '';
        scope.locationName.autocomplete = '';
        scope.markerArray = [];
        scope.advanceDcList = [];
        scope.diagnosticCentres = [];
        scope.client.preferredDC1 = '';
        scope.manual.firstDate = '';
        scope.manual.secondDate = '';
    };

    scope.bookAppointmentDate = function (firstDate, secondDate, firstTime, secondTime) {
        if(!scope.manual.firstDate) {
            UtilitiesService.showAlertMessage('Please select appointment date.'); 
        }
        if (scope.showData.name) {
            scope.firstPrefTime = UtilitiesService.mergeDateTimeObj(scope.manual.firstDate, scope.manual.firstTime);
            scope.secondPrefTime = UtilitiesService.mergeDateTimeObj(scope.manual.secondDate, scope.manual.secondDate);
            scope.addToCart(firstDate, firstTime, secondDate, secondTime);
            scope.isCart = !scope.isCart;
        } else {
            UtilitiesService.showAlertMessage('Please fill customer details.');
        }
    };

    scope.autoDCSelection = function () {
        scope.isPackageSelectionManual = false;
        scope.isPackageSelectionAdvance = false;
        scope.isFlage.autDcSection = 'auto';
        scope.addToCart('auto');
    };
    //Event Listner for close marker in google map
    scope.windowParams = {
        list: scope.selectedDcFromDavanceSearch,
        doIt: function (markerDetails) {
            if (scope.manual.firstDate) {
                scope.bookAppointmentDate(scope.manual.firstDate, scope.manual.secondDate, scope.manual.firstTime, scope.manual.secondTime);
            } else {
                UtilitiesService.showAlertMessage('Please select appointment date.');
            }
        }
    }
    UserService.saleQueueDataCollection = [];
    scope.$watch('eSaleQueue', function (current, old) {
        if (current) {
            scope.pbqueue = UserService.GeteSaleQuebe(current);
        } else {
            if (old) {
                scope.pbqueue = UserService.saleQueueDataCollection;
            }
        }
    });

    scope.filterDate = function (fromDateFilterValue, toDateFilterValue) {
        if ((fromDateFilterValue && !toDateFilterValue) || (!fromDateFilterValue && toDateFilterValue)) {
            UtilitiesService.showAlertMessage('You missed start or end date!');
            return false;
        }
        if (fromDateFilterValue && toDateFilterValue) {
            scope.tempPb = [];
            scope.pbqueueCompare = scope.filterDateData;

            scope.fromDateFilterValue = fromDateFilterValue;
            var getfullfromDate = fromDateFilterValue.getFullYear() + '-' + fromDateFilterValue.getMonth() + 1 + '-' + fromDateFilterValue.getDate();
            var date = moment(getfullfromDate)
            scope.filter.dateFilterFrom = date;

            scope.toDateFilterValue = toDateFilterValue;
            var getfullToDate = toDateFilterValue.getFullYear() + '-' + toDateFilterValue.getMonth() + 1 + '-' + toDateFilterValue.getDate();
            var dateTo = moment(getfullToDate)
            scope.filter.dateFilterTo = dateTo;

            if (scope.filter.dateFilterFrom && scope.filter.dateFilterTo) {
                angular.forEach(scope.pbqueueCompare, function (item) {
                    var objDate = '';
                    var num = item.dateTimeCreated.match(/\d+/g); //regex to extract numbers 
                    var date = new Date(parseFloat(num)); //converting to date
                    var objDate = date.getFullYear() + '-' + date.getMonth() + 1 + "-" + date.getDate();
                    var objDateFormat = moment(objDate)

                    if ((scope.filter.dateFilterFrom <= objDateFormat) && (objDateFormat <= scope.filter.dateFilterTo)) {
                        scope.tempPb.push(item);
                    }
                });
                // console.log(scope.tempPb.length);
                scope.pbqueue = scope.tempPb;
            }
        }
    }

    scope.dateFilterDate = {
        fromDateFilter: '',
        toDateFilter: ''
    }

    //Date Object
    scope.today = function () {
        scope.client.secondPrefTime = new Date();
        scope.client.firstPrefTime = new Date();
        scope.dt = new Date();
    };
    scope.today();

    // Disable weekend selection
    function disabled(data) {
        var date = data.date,
          mode = data.mode;
        return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    }

    scope.dateOptions = {
        // dateDisabled: disabled,
        formatYear: 'yy',
        // minDate: new Date(),
        startingDay: 1
    };
    scope.dateOption = {
         dateDisabled: disabled,
         formatYear: 'yy',
         minDate: new Date(),
         startingDay: 1
    }
    scope.dateOptionsDob = {
        //dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(),
        //minDate: new Date(),
        startingDay: 1
    };
    scope.dateDefautOptions = {
        formatYear: 'yy',
        minDate: scope.dateFilterDate.fromDateFilter,
        startingDay: 1
    };

    scope.open1 = function () {
        scope.popup1.opened = true;
    };

    scope.open2 = function () {
        scope.popup2.opened = true;
    };

    scope.open5 = function () {
        scope.popup5.opened = true;
    };

    scope.open6 = function () {
        scope.popup6.opened = true;
    };
    //prePolicy
    scope.popup3 = {
        opened: ''
    }
    scope.open = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();

        scope.popup3.opened = true;
    };

    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];

    scope.popup1 = {
        opened: false
    };

    scope.popup2 = {
        opened: false
    };

    scope.popup5 = {
        opened: false
    };

    scope.popup6 = {
        opened: false
    };

    scope.userTime = {
        firstAppointmentTime: '',
        secondAppointmentTime: '',
        testAppointmentTime: ''
    }
    //Set Time Object
    var first = new Date();
    var dd = new Date(first).getDate();
    var mm = new Date(first).getMonth() + 1;
    var yy = new Date(first).getFullYear();
    var hh = 8;
    var ms = 0;
    var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
    scope.userTime.firstAppointmentTime = new Date(x);
    scope.userTime.secondAppointmentTime = new Date(x);
    scope.userTime.testAppointmentTime = new Date(x);

    scope.hstep = 1;
    scope.mstep = 30;

    scope.ismeridian = false;

    //First time limit
    var maxFirst = new Date();
    maxFirst.setHours(18);
    maxFirst.setMinutes(0);
    scope.maxFirst = maxFirst;

    var minFirst = new Date();
    minFirst.setHours(8);
    minFirst.setMinutes(0);
    scope.minFirst = minFirst;

    //Second time limit
    var maxSecond = new Date();
    maxSecond.setHours(18);
    maxSecond.setMinutes(0);
    scope.maxSecond = maxSecond;

    //Download eQueue data
    scope.downloadQueue = function (frmDt, toDt, insurerId) {
        scope.downloadUrl = '';
        if (insurerId && frmDt && toDt) {
            scope.downloadUrl = UtilitiesService.getPlusUrlPrefix() + '/ESales/Download/' + $filter('date')(frmDt, 'dd-MM-yyyy') + "/" + $filter('date')(toDt, 'dd-MM-yyyy') + '/' + insurerId;
        } else {
            UtilitiesService.showAlertMessage('Select date and insurer name.');
        }
    };

    //Get and add Correspondence
    scope.getAddCorrespondence = function (reqDetails, action) {
        if (reqDetails) {
            scope.requestDataForCorrespondence = Object.assign({}, reqDetails);
            scope.checkForDNDFlags(scope.requestDataForCorrespondence);
            scope.reqDetails = reqDetails;
            if (action === 'add') {               
                scope.clearAddCorrespondenceData();
                scope.getCallTypes();
            } else if (action === 'show' && reqDetails.id) {
                scope.correspondencError = '';
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/RequestCorrespondence/153/0/' + reqDetails.id, '', 'GET').then(function (response) {
                    if (response.data.length > 0) {
                        scope.correspondencData = response.data;
                    } else {
                        $('#ViewCorresponddenceModal').modal('hide');
                        UtilitiesService.showAlertMessage('No correspondence record found!!');
                        scope.correspondencData = [];
                    }
                });
            }
        }
        else {
            UtilitiesService.showAlertMessage('Id not found.');
        }
    };

    scope.getCallTypes = function () {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "MediMarketLookUp/calltype.json", "", "GET").then(function (response) {
            if (response.data.isSuccess) {
                scope.calltypes = response.data.results;
                scope.getCallStatuses();
            }
        });
    };
    scope.getCallStatuses = function () {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "MediMarketLookUp/callstatus.json", "", "GET").then(function (response) {
            if (response.data.isSuccess) {
                scope.callstatuses = response.data.results;
            }
        });
    };
    scope.callStatusTemplate = function (callStatus) {
        scope.getCallStatus = callStatus;
        if (callStatus != "") {
            if (callStatus == "124") {
                scope.apolloDetails = scope.customerDetails.requestHistory.additionalInformation;
                var patientName = scope.apolloDetails.patientName;
                var appointmentDate = scope.getAuditDate(scope.apolloDetails.appointmentDate);
                var appointmentTime = scope.getAuditTime(scope.apolloDetails.appointmentDate);
                var employeeId = scope.apolloDetails.employeeID;
                scope.apolloMailTemplate = "Dear " + scope.reqDetails.name ? scope.reqDetails.name : 'NA' + ", Pre- Insurance Medicals for the Cashless Apollo Munich Product, " + scope.reqDetails.id + " is scheduled through Home Visit on " + scope.formatTime(scope.reqDetails.dateTimeCreated) + " | " + scope.compareDate(scope.reqDetails.dateTimeCreated) + "  at your residence. For queries pls contact 080-67617571. No payment has to be made to Medical Centre for this Check up, however, Home Visit charges are payable, as applicable. Please keep the printout of the Email sent on your registered Email ID or SMS sent by MediAssist handy with you to avail the CASHLESS FACILITY with a copy of valid Identification (ID) Proof. In absence of SMS/E Mail Print out, PPC will not be conducted.";
            }
            if (callStatus === '73' || callStatus === '74' || callStatus === '86' || callStatus === '96' || callStatus === '144' || callStatus === '187') {
                scope.showCalender = true;
            } else {
                scope.showCalender = false;
                scope.callDateTime = {
                    prefDate: '',
                    prefTime: ''
                }
            }
        }
    }
    scope.clearAddCorrespondenceData = function() {
        scope.corres.corrremarks = '';
        scope.corres.calltype = '';
        scope.corres.callstatus = '';
        scope.corres.workStatus = 'workable';
        scope.uicDetail.uicNumber = null;
        scope.callDateTime.prefTime = null;
        scope.callDateTime.prefDate = null;
    }
    scope.addCorrespondence = function (fileUploadData) {

        var data = {
            requestId: scope.reqDetails.id,
            requestFlowId: scope.reqDetails.id,
            comment: scope.corres.corrremarks,
            workStatus: scope.corres.workStatus,
            correspondenceType: 153,
            callType: scope.corres.calltype,
            callStatus: scope.corres.callstatus,
            createdOn: new Date().toISOString(),
            attachFiles: {
                correspondencereports: fileUploadData
            },
            additionalInfo: {
                callbackdate: scope.PrefcallDateTime,
                uicnumber: scope.uicDetail.uicNumber,
                DND: scope.requestDataForCorrespondence.requestJSON.additionalInfo.hasOwnProperty('DND') ? scope.requestDataForCorrespondence.requestJSON.additionalInfo.DND : null,
                DNDCustomer: scope.requestDataForCorrespondence.requestJSON.additionalInfo.hasOwnProperty('DNDCustomer') ? scope.requestDataForCorrespondence.requestJSON.additionalInfo.DNDCustomer : null
            },
            createdBy: UserService.getUserObj().userId
        }
        data.additionalInfo.From = 'Esales';
        UserService.makeRestCall('https://ch-api-procheck.medibuddy.in/' + 'AddCorrespondence', data, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data.isSuccess) {
                UtilitiesService.showAlertMessage('Correspondence added successfuly.', true);
                $('#AddCorresponddenceModal').modal('hide');                
            }
            else {
                UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                $('#AddCorresponddenceModal').modal('hide');
            }
        });
    };
    scope.addCorrespond = function () {
        scope.uploadMethods.upload(scope.addCorrespondence);
    };
    scope.uploadMethods = (function () {
        return {
            upload: function (callback) {
                var fileBlobArray = [];
                var filesUploadingArray = [];
                Object.keys(scope.file).forEach(function (ele) {
                    if (typeof (scope.file[ele].model) == "object") {
                        filesUploadingArray.push(scope.file[ele].model);
                    }
                });
                if (filesUploadingArray.length > 0) {
                    fileBlobArray.push(FileUploadSvc.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrlPrefix() + '/File'));
                }
                else {
                    callback.call(scope.addCorrespondence);
                    return false;
                }
                $q.all(fileBlobArray).then(function (result) {
                    scope.newlyUploadedDocs = [];
                    if (typeof result == "object" && typeof result[0].data == "object") {
                        for (var property in result[0].data) {
                            if (result[0].data.hasOwnProperty(property)) {
                                var obj = {};
                                obj.fileName = result[0].data[property];
                                obj.filePath = UtilitiesService.getDownloadURL(true) + property;
                                scope.newlyUploadedDocs.push(obj);
                            }
                        }
                        if (result && scope.newlyUploadedDocs && scope.newlyUploadedDocs.length > 0)
                            callback.call(scope.addCorrespondence, result[0].data);
                    }
                    else {
                        UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                        return false;
                    }
                },
                function (error) {
                    UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                });
            },
            clearFileModels: function (isShow) {
                if (!isShow)
                    scope.newlyUploadedDocs = [];
                scope.file = [];
                scope.fileUploadMethods.addFileToUpload();
            }
        };
    })();

    scope.file = [];
    scope.fileUploadMethods = (function () {
        return {
            addFileToUpload: function (flag) {
                var newItemNo = scope.file.length + 1;
                scope.file.push({
                    'model': ''
                });
            },
            removeFileToUpload: function (index) {
                scope.file.splice(index, 1);
            }
        };
    })();
    scope.changeDistance = function (distance) {
        if (distance) {
            scope.radious.distance = distance.value;
            scope.loadDcList(scope.radious.lat, scope.radious.lng);
        } else {
            scope.radious.distance = 5;
            scope.loadDcList(scope.radious.lat, scope.radious.lng);
        }
    }
    scope.example2settings = {
        idProp: 'peR_Id',
        displayProp: 'packageName',
        styleActive: true,
        enableSearch: true,
        externalIdProp: '',
        scrollableHeight: '300px',
        scrollable: true,
        showCheckAll: false,
        showUncheckAll: true,
        keyboardControls: true,
        smartButtonMaxItems: 1
    };
    scope.example5customTexts = {
        buttonDefaultText: 'Select packages',
        smartButtonMaxItems: 1
    };

    scope.setMinDate = function (fromDate) {
        scope.mindate = '';
        var setMinDate = fromDate;
        setMinDate.setDate(fromDate.getDate());
        scope.mindate = setMinDate;
        scope.mindate = scope.dateFilterDate.fromDateFilter;
    }

    scope.getInsurerList = function () {
        scope.insurerList = scope.pbqueue;
        scope.allInsurer = [];
        angular.forEach(scope.insurerList, function (v, i) {
            if (v.corporateName && v.eR_ID) {
                scope.allInsurer.push({ corporateName: v.corporateName, eRID: v.eR_ID });
            }
        })
        scope.finalInsurerList = [];
        scope.allInsurer.forEach(function (itm) {
            var unique = true;
            scope.finalInsurerList.forEach(function (itm2) {
                if (_.isEqual(itm, itm2)) unique = false;
            });
            if (unique) scope.finalInsurerList.push(itm);
        });
        return scope.finalInsurerList;
    }

    scope.reset = function () {
        scope.dateFilterDate = {
            fromDateFilter: '',
            toDateFilter: ''
        }
        scope.fromDateFilterValue = '';
        scope.pbqueue = scope.filterDateData;
    }
}]);

angular.module('mbplus')
.controller('providerActionCtrl', ['$rootScope', '$scope', 'UserService', 'UtilitiesService', '$location', '$state', function (rootScope, scope, UserService, UtilitiesService, $location, $state) {
    scope.$root.title = 'Provider Action | Medibuddy Hospital Portal';
    rootScope.showMenu = false;
    scope.encryptedKey = {};
    scope.show = { upload: false, message: false, contactDetails: false };
    scope.displayMessage = '';
    scope.contactNumber = null;
    scope.uploadedFileData = { reports: {} };
    scope.storeFiles = [];
    scope.messageContentRef = document.getElementById('messageContent');
    scope.encryptedKey = UserService.dcUrl;
    scope.reqId = null;
    scope.providerId = null;
    scope.emailId = null;
    scope.nextStatusId = null;
    scope.currentStatusId = null;

    scope.changeMessageColor = function (color) {
        scope.messageContentRef.style.color = color;
    }

    scope.changeShowFlags = function (type) {
        switch (type) {
            case 'upload': 
                scope.show.upload = true;
                scope.show.contactDetails = false;
                scope.show.message = false;
                break;
            case 'error':
                scope.show.upload = false;
                scope.show.contactDetails = false;
                scope.show.message = true;
                break;
            case 'contact':
                scope.show.upload = false;
                scope.show.contactDetails = true;
                scope.show.message = false;
        }
    }


    scope.reInitializeData = function() {
        scope.uploadedFileData = { reports: {} };
        scope.storeFiles = [];
        scope.contactNumber = null;
        scope.reqId = null;
        scope.providerId = null;
        scope.emailId = null;
        scope.currentStatusId = null;
        scope.nextStatusId = null;
    }

    scope.makeRequestCall = function () {
        var data = { requestId: scope.reqId, contactNo: scope.contactNumber, providerId: scope.providerId, currentStatusId: scope.currentStatusId, attachFiles: scope.uploadedFileData, emailId: scope.emailId, requestedNextActionId: scope.nextStatusId };

        var url = UtilitiesService.getPlusUrlPrefix();
        UserService.makeRestCall(url + 'StatusUpdationByProivder', data, 'POST').then(function (response) {
            if (response.data && response.data.isSuccess) {
                if (response.data.isReportUpload) {
                    scope.changeShowFlags('upload');
                } else {
                    scope.changeMessageColor('green');
                    scope.changeShowFlags('error');
                    scope.displayMessage = response.data.message;
                    scope.reInitializeData();
                }
            } else {  
                scope.changeMessageColor('red');
                scope.changeShowFlags('error');
                scope.displayMessage = response.data.errorMessage;
            }           
        }); 
    }

    scope.$watch('encryptedKey', function (value, flag) {
        if (value) {
            scope.reqId = scope.encryptedKey.reqId ? parseInt(scope.encryptedKey.reqId) : null;
            scope.providerId = scope.encryptedKey.providerId ? parseInt(scope.encryptedKey.providerId) : null;
            scope.currentStatusId = scope.encryptedKey.currentStatusId ? parseInt(scope.encryptedKey.currentStatusId) : null;
            scope.nextStatusId = scope.encryptedKey.nextStatusId ? parseInt(scope.encryptedKey.nextStatusId) : null;
            scope.emailId = scope.encryptedKey.emailId ? scope.encryptedKey.emailId : null;
            scope.makeRequestCall();
        }
      }, true);
    

    
    if (!scope.reqId || !scope.providerId || !scope.currentStatusId || !scope.nextStatusId) {
        scope.changeMessageColor('red');        
        scope.changeShowFlags('error');                                      
        scope.displayMessage = 'Details missing'; 
    }
    
    scope.fileFn = function (data) {
        if (data) {
            for (var key in data){
                scope.uploadedFileData.reports[key] = data[key];
            }
            angular.forEach(data, function (value, index) {
                scope.storeFiles.push({ fileName: value, filePath: index });
            });
        }
    };

    scope.downloadAttachment = function (obj) {
        if (obj) {
            window.open(
              UtilitiesService.getDownloadURL(true) + obj,
              '_blank'
            );
        }
    };

    scope.removeFiles = function (item) {
        if (item) {
            delete scope.uploadedFileData.reports[item.filePath];
            angular.forEach(scope.storeFiles, function (value, index) {
                 if (value.fileName === item.fileName) {
                    scope.storeFiles.splice(index, 1);
                }
            });
        }
    };
}]);
angular.module("mbplus")
.controller('plusContactController', ['$scope', '$rootScope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics','PlusUtilitiesService', function (scope, $rootScope, $location, UserService, UtilitiesService, filterFilter, $analytics, PlusUtilitiesService) {
  $analytics.pageTrack('/plusContact');
  if (!UserService.isActive()) {
    UserService.destroyUserObj();
   $location.path('/');
    return false;
  }
  scope.ctrlName = "plusContactController";
  scope.test = {};
  scope.message = "";
  scope.branchName = "";
  scope.subjectName = "General query";
  scope.isActive = UserService.isActive();
  scope.showSuccessMessage = false;

  if (scope.isActive) {
    scope.user = UserService.getUserObj();
    scope.fromEmail = "";
    scope.hospId = "";
    scope.address = {};
    scope.hasAddress = false;

    if (true) {
      scope.dcDetails = {
        "id": 1000042,
        "entityTypeId": 6,
        "entityType": "Insurer",
        "hierarchy_Group": 0,
        "hierarchy_Sub_Group": 0,
        "fullName": "Medi Assist",
        "primaryAddress": "India",
        "countryId": 0,
        "stateId": 0,
        "state": "Chikmagalore",
        "cityId": 3536,
        "city": "Chikmagalore",
        "districtId": 0,
        "isLegal": false,
        "cmsid": false
      }
      scope.fromEmail = scope.dcDetails.emailAddress;
      scope.hospId = scope.dcDetails.id;
    }
    else {
      var url = UtilitiesService.getPlusUrlPrefix() + "/provider/entity/details.json?entityId=" + UserService.getUserObj().entityId
      UserService.makeRestCall(url, "", "GET").then(function (response) {
        if (response.data.isSuccess) {
          UserService.setHospitalObj(response.data.entity);
          scope.dcDetails = UserService.getUserObj();
          scope.fromEmail = scope.dcDetails.emailAddress;
          scope.hospId = scope.dcDetails.id;
        }
        else {

        }
      });
    }
    scope.sendMessage = function () {
      var data = {
        "fromEmail": scope.fromEmail,
        "subject": scope.subject,
        "message": scope.message
      }
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/SendmailFromhospital", data, "POST").then(function (response) {
        if (response.data.isSuccess) {
          scope.showSuccessMessage = true;
          scope.showErrorMessage = false;
        }
        else {
          scope.showSuccessMessage = false;
          scope.showErrorMessage = true;
        }
      }, function (error) {
        scope.showSuccessMessage = false;
        scope.showErrorMessage = true;
      });
    }
  }
  else {
    //$location.path('/');
  }
}]);
angular.module("mbplus")
.controller('plusProfileController', ['$scope','$location', 'UserService', 'UtilitiesService',
 '$analytics', function (scope, location, UserService, UtilitiesService, 
  analytics) {
  analytics.pageTrack('/plusProfile');

  if (!UserService.isActive()) {
    UserService.destroyUserObj();
    location.path('/');
    return false;
  }

  scope.dcDetails = {};
  if (scope.isActive) {
    if (UserService.getHospitalObj() && UserService.getHospitalObj().id) {
    }
    else {
      var url = UtilitiesService.getPlusUrlPrefix() + '/provider/entity/details.json?entityId=' + 1026675
      UserService.makeRestCall(url, '', 'GET').then(function (response) {
        if (response.data.isSuccess) {
        }
      });
    }
  }
}]);

angular.module('mbplus')
.controller('plannedCheckCtrl', ['$rootScope', '$scope', '$location', '$window', '$http', 'UserService', 'NewAdmissionFormService', 'UtilitiesService', '$stateParams', 'FileUploadService', '$q', function ($rootScope, scope, $location, $window, $http, UserService, NewAdmissionFormService, UtilitiesService, $stateParams, FileUploadService, $q) {
    scope.ctrlName = 'plannedCheckCtrl';
    scope.DMSUrl = UtilitiesService.getDMSHostUrl();
    scope.renderingRelatedMethods = (function () {
        return {
            validatLink: function () {
                if (UtilitiesService.IsPlannedCheck) {
                    scope.loading = true;
                    scope.validPage = true;
                    this.populatePreauthForm();
                }
                else {
                    scope.validPage = false;
                }
            },
            populatePreauthForm: function () {
                var data = {
                    plannedHospId: UtilitiesService.IsPlannedCheck
                };
                NewAdmissionFormService.getExtPlannedRequestDetail(data)
                .then(populatePreauthFormSuccess, populatePreauthFormError);
            },
            getPlannedHospAttachment: function (plannedHospId) {
                scope.plannedAttachment = {};
                NewAdmissionFormService.getPlannedHospAttachments(plannedHospId)
                    .then(getPlannedHospAttachmentSuccess, getPlannedHospAttachmentError);
            }
        };
        function populatePreauthFormSuccess(response) {
            scope.loading = false;
            if (response.data.isSuccess && response.data.plannedHospDet.currentStatus.toLowerCase() == 'submitted') {
                scope.request = response.data.plannedHospDet;
                scope.request.doa = UtilitiesService.getDateObj(scope.request.doa);
                scope.request.dod = UtilitiesService.getDateObj(scope.request.dod);
                scope.renderingRelatedMethods.getPlannedHospAttachment(scope.request.id);
            }
            else {
                if (response.data.isSuccess) {
                    scope.loading = true;
                    scope.errorMessage = 'Your have already submitted.';
                }
                else {
                    scope.loading = true;
                    scope.errorMessage = 'Error: Contact MediAssist/Get valid submission link.';
                }

            }
        }
        function populatePreauthFormError(response) {
            scope.loading = true;
            scope.errorMessage = 'Error: Network Issue/Get valid submission link.';
        }
        function getPlannedHospAttachmentSuccess(resData) {
            if (resData.data.isSuccess) {
                scope.plannedAttachment = resData.data.plannedHospAttachment;
            }
            else {
                scope.errorMessage = resData.data.errorMessage;
                scope.resetFail = true;
            }
        }
        function getPlannedHospAttachmentError(response) {
            scope.errorMessage = 'Server Issue.';
        }
    })();

    scope.submissionRelatedMethods = (function () {
        return {
            submitPlannedHosp: function () {
                if(scope.file) {
                    scope.fileUploadRelatedMethods.uploadFiles(function () {
                        NewAdmissionFormService.submitAarogyaPreauthForm(this.getPreauthFormData(scope.request)).
                                      then(submitPreauthFormSuccess, submitPreauthFormError);
                    });
                }
                else {
                    NewAdmissionFormService.submitAarogyaPreauthForm(this.getPreauthFormData(scope.request)).
                                      then(submitPreauthFormSuccess, submitPreauthFormError);
                }
            },
            getPreauthFormData: function (request) {
                var data = {
                    applicationName: 'Hospital Portal',
                    fileNames: scope.form.fileNames || null,
                    filePath: scope.form.fileUploadFolderPath || null,
                    fileUploadFolderPath: 'String',
                    plannedHospId: request.id,
                    patientFirstName: request.patientName,
                    contactNum: request.mobileNumber,
                    empId: request.employeeId,
                    employer: request.corporateName,
                    maid: request.maid,
                    doa: request.doa,
                    approxClaimedAmnt: request.clmamount,
                    docName: request.doctorName,
                    diagnosis: request.diagnosis,
                    roomType: request.roomtype,
                    admissionType: 'planned',
                    ipNumber: request.ipnumber,
                    procedure: request.procedure,
                    tentativeDOD: request.dod,
                    hospId: request.hospitalId,
                    hospName: request.hospitalName,
                    reasonForChoosing: 'planned-Hospitlization',
                    externalAppCheck: 'noLoginPlanned'
                };
                return data;
            }

        };
        function submitPreauthFormSuccess(successData) {
            if (successData.data.isSuccess) {
                scope.msubsuccess = true;
            }
            else {
                scope.msubsuccess = false;
            }
        }
        function submitPreauthFormError(ErrorData) {
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        }
    })();

    scope.fileUploadRelatedMethods = (function () {
        scope.form = {};
        scope.form.fileNames = [];
        scope.form.fileUploadFolderPath = [];
        return {
            uploadFiles: function (callback) {
                //--new code
                scope.form.fileNames = [];
                scope.form.fileUploadFolderPath = [];
                //-----------new code
                var fileBlobArray = [];
                var filesUploadingArray = [];
                Object.keys(scope.file).forEach(function (ele) {
                    if (typeof (scope.file[ele]) == "object") {
                        filesUploadingArray.push(scope.file[ele]);
                        // fileBlobArray.push(FileUploadService.uploadFileToUrl(scope.file[ele]));
                    }
                });
                if (filesUploadingArray.length > 0) {
                    fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
                  } else {
                    UtilitiesService.showAlertMessage('Please attach atleast one document.');
                    return false;
                  }
                $q.all(fileBlobArray).then(function (result) {
                    result.forEach(function (element) {
                        if (element.data.isSuccess) {
                            scope.form.fileNames.push(element.data.uploadResponseDetails[0].fileName);
                            scope.form.fileUploadFolderPath.push(element.data.uploadResponseDetails[0].downloadURL);
                        }
                        else {
                            scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                            return false;
                        }
                    });
                    if (scope.form.fileNames.length == result.length)
                        callback.call(scope.submissionRelatedMethods);
                },
                function (error) {
                    scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                });
            }
        };
        function fileUploadSuccess(successData) {
            if (successData.data.isSuccess) {
                scope.form.fileNames.push(successData.data.uploadResponseDetails[0].fileName);
                scope.form.fileUploadFolderPath.push(successData.data.uploadResponseDetails[0].downloadURL);
                UtilitiesService.showAlertMessage('file uploaded successfully.', true);
            }
        }
        function fileUploadError(errordata) {
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        }
    })();

    $(function () {
        scope.renderingRelatedMethods.validatLink();
    });
}]);


angular.module('mbplus')
.controller('plannedCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', 'NewAdmissionFormService', 'FileUploadService', '$analytics', '$q', function (scope, $location, UserService, UtilitiesService, NewAdmissionFormService, FileUploadService, $analytics, $q) {
  $analytics.pageTrack('/planned');
  if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }
  scope.form = {};
  scope.form.preauthSuccess = false;
  scope.fileNames = [];
  scope.fileUploadFolderPath = [];
  scope.formatCurrency = UtilitiesService.formatCurrency;
  //Fetch Planned Claims List
  scope.getPlannedList = function (hospId) {
    UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/Claim/PlannedHospClaims.json?HospId=" + UserService.getUserObj().entityId, "", "GET").then(function (response) {
      if (response.data.isSuccess) {
        scope.plannedRequests = UtilitiesService.renderPlannedRequests(response.data.plannedHospClaims, "preauth");
      }
    }, function (error) {
      // console.log("Error : " + error);
    });
  };
  angular.element(document).ready(function () {
    scope.getPlannedList();
  });

    scope.selectedMappedpackagesObj = function (data) {
        if (data) {
            scope.availableBillsFinalData = [];
            angular.forEach(data, function(v , index){
                if(v.packageAmount){
                    var packagesList ={
                            packageName: v.hospitaL_CHARGE_HEAD ? v.hospitaL_CHARGE_HEAD : '',
                            packageId: v.packageId,
                            packageAmount: v.packageAmount ? parseInt(v.packageAmount) : 0,
                            packageCappedAmount: 0,
                            cmS_CHARGE_TYPE_ID: v.cmS_CHARGE_TYPE_ID ? v.cmS_CHARGE_TYPE_ID : '' ,
                            cmS_CHARGE_TYPE_DESC: v.cmS_SUBCHARGE_TYPE_DESC ? v.cmS_SUBCHARGE_TYPE_DESC : '',
                            cmS_SUBCHARGE_TYPE_ID: v.cmS_SUBCHARGE_TYPE_ID ? v.cmS_SUBCHARGE_TYPE_ID : '',
                            cmS_SUBCHARGE_TYPE_DESC: v.cmS_SUBCHARGE_TYPE_DESC ? v.cmS_SUBCHARGE_TYPE_DESC : '',
                            hospitaL_CHARGE_HEAD: v.hospitaL_CHARGE_HEAD ? v.hospitaL_CHARGE_HEAD : ''
                    }
                    scope.availableBillsFinalData.push(packagesList);
                }
                    
            });
            return scope.availableBillsFinalData;
        }
    };
  scope.preauthFormAction = (function () {
    function submitPreauthFormSuccess(successData) {
      if (successData.data.isSuccess) {
        scope.form.preauthSuccess = true;
      }
      else {
        UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        scope.form.preauthError = true;
      }
    }
    function submitPreauthFormError(ErrorData) {
        UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
    }
    function fileUploadSuccess(successData) {
      if (successData.data.isSuccess) {
        scope.fileNames.push(successData.data.uploadResponseDetails[0].fileName);
        scope.fileUploadFolderPath.push(successData.data.uploadResponseDetails[0].downloadURL);
        UtilitiesService.showAlertMessage('file uploaded successfully.', true);
      }
    }
    function fileUploadError(errordata) {
      UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
    }
    return {
      validatePreauthForm: function () { },
      getPreauthFormData: function (form) {
        var data = {
          packagesList: scope.selectedMappedpackagesObj(form.packagesList),
          plannedHospId: form.plannedHospId,
          reasonForChoosing: 'planned-Hospitlization',
          applicationName: 'Hospital Portal',
          filePath: scope.form.fileUploadFolderPath,
          FileNames: form.fileNames,
          fileUploadFolderPath: form.fileUploadFolderPath,
          patientFirstName: form.fullname,
          ContactNum: form.mobile,
          EmpId: form.source === 'Infiniti' ? '' : form.empid,
          Employer: form.source === 'Infiniti' ? '' : form.employer,
          Maid: form.maid,
          Doa: form.doa,
          ApproxClaimedAmnt: form.ApproxClaimedAmnt,
          DocName: form.docname,
          Diagnosis: form.diagnosis,
          AdmissionType: form.admissiontype,
          RoomType: form.roomtype,
          TentativeDOD: form.dod,
          HospId: UserService.getHospitalObj().hospId,
          HospName: UserService.getHospitalObj().hospName,
          createdBy: UserService.getUserObj().userId,
        };
        return data;
      },
      uploadFiles: function (file, callback) {
        scope.file = file;
        scope.form.fileNames = [];
        scope.form.fileUploadFolderPath = [];
        var fileBlobArray = [];
        var filesUploadingArray = [];
        Object.keys(scope.file).forEach(function (ele) {
          if (typeof (scope.file[ele].model) == "object") {
            filesUploadingArray.push(scope.file[ele].model);
          }
        });
        if (filesUploadingArray.length > 0) {
          fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
        }
        $q.all(fileBlobArray).then(function (result) {
          result.forEach(function (element) {
            if (element.data.isSuccess) {
              angular.forEach(element.data.uploadResponseDetails, function (e, i) {
                scope.form.fileNames.push(e.fileName);
                scope.form.fileUploadFolderPath.push(e.downloadURL);
              });
            }
            else {
              scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
              return false;
            }
          });
          if (result && (filesUploadingArray.length == 0 || scope.form.fileNames.length == result[0].data.uploadResponseDetails.length))
            callback.call(scope.preauthFormAction);
        },
        function (error) {
          scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
        })
      },
      submitPreauthForm: function (form, file) {
        this.uploadFiles(file, function () {
          NewAdmissionFormService.submitAarogyaPreauthForm(this.getPreauthFormData(form)).
                         then(submitPreauthFormSuccess, submitPreauthFormError);
        });
      },
      closePreauthForm: function () {
        scope.form = {};
      },
    };
  })();
}]);
angular.module("mbplus")
.controller('pharmaDashboardController', ['$scope', '$rootScope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics','PlusUtilitiesService', function (scope, $rootScope, $location, UserService, UtilitiesService, filterFilter, $analytics, PlusUtilitiesService) {
  $analytics.pageTrack('/appointments');
  if (!UserService.isActive()) {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }
  scope.ctrlName = "appointmentsController";
  scope.user = UserService.getUserObj();
  scope.formatTime = UtilitiesService.formatTime;
  scope.compareDate = UtilitiesService.compareDate;
  scope.dispayInDdl = "Search by";
  scope.medibizProviderId = 158749;
  scope.pharmaProviderId = 72326;
  scope.loadOrders = function () {
    var data = {
      "contractTypes": [10307, 10390],
      "daysOfAppointment": -1,
      "RequestAccessToken": UserService.getAccessToken()
    }
    var url = UtilitiesService.getPlusUrlPrefix() + "/contractBasedAllAppointments/";
    UserService.makeRestCall(url, data, "POST", UserService.getAccessToken()).then(function (response) {
      if (response.data) {
        scope.totalOrders = response.data.statusGroupWiseRequest;

        scope.newOrderDetails = scope.totalOrders[0];
        scope.openOrderDetails = scope.totalOrders[1];
        scope.closeOrderDetails = scope.totalOrders[2];

        scope.newOrderproviderWiseRequest = scope.newOrderDetails.providerWiseRequest;
        scope.openOrderproviderWiseRequest = scope.openOrderDetails.providerWiseRequest;
        scope.closeOrderproviderWiseRequest = scope.closeOrderDetails.providerWiseRequest;
      }
    })
  }

  scope.getOrderType = function (orderType) {
    scope.selectedOrderType = orderType;
    if (orderType == 1) {
      scope.dispayInDdl = "By Order Id";
    }
    if (orderType == 2) {
      scope.dispayInDdl = "By Contact No.";
    }
    if (orderType == 3) {
      scope.dispayInDdl = "By Name";
    }
  }

  scope.splitOrders = function (source) {
    var citiesOfnewOrderMB = [];
    var citiesOfnewOrderPE = [];
    var citiesOfopenOrderMB = [];
    var citiesOfopenOrderPE = [];
    var citiesOfcloseOrderMB = [];
    var citiesOfcloseOrderPE = [];
    scope.cityNameCountMB = [];
    scope.cityNameCountPE = [];
    scope.OrderDetails = [];
    scope.age = [];
    var newOrderMB = [];
    scope.dayOneMB = [];
    scope.dayTwoMB = [];
    scope.dayThreeMB = [];
    scope.dayOnePE = [];
    scope.dayTwoPE = [];
    scope.dayThreePE = [];
    scope.countOnDayMB = 0;
    scope.countOnTwoMB = 0;
    scope.countOnThreeMB = 0;
    scope.countOnDayPE = 0;
    scope.countOnTwoPE = 0;
    scope.countOnThreePE = 0;
    switch (source) {
      case "newOrders":
        scope.displayStatusName = scope.newOrderDetails.statusGroupName;
        if (scope.newOrderDetails.statusGroupName == "New Orders") {
          var newOrderProviderWise = scope.newOrderDetails.providerWiseRequest;
          $.each(newOrderProviderWise, function (i, val) {
            if (val.providerId == scope.medibizProviderId) { //check for medebiz
              newOrderMB = val.cityWiseRequests;
              $.each(newOrderMB, function (i, v) {
                citiesOfnewOrderMB.push({
                  "cityName": v.cityname,
                  "cityCount": v.count,
                  "request": v.requests
                });
              })
              scope.cityNameCountMB = citiesOfnewOrderMB;
              scope.aging = citiesOfnewOrderMB;
              var now = moment(new Date()); //todays date
              $.each(scope.aging, function (i, val) {
                $.each(val.request, function (i, v) {
                  var end = moment(v.createdOn); // another date
                  var duration = moment.duration(now.diff(end));
                  var diffOfHours = duration.asHours();
                  if (diffOfHours < 24) {
                    scope.dayOneMB.push(v);
                  } else if (diffOfHours > 24 && diffOfHours < 48) {
                    scope.dayTwoMB.push(v);
                  } else if (diffOfHours > 48) {
                    scope.dayThreeMB.push(v);
                  }
                })
              })
              scope.countOnDayMB = scope.dayOneMB.length;
              scope.countOnTwoMB = scope.dayTwoMB.length;
              scope.countOnThreeMB = scope.dayThreeMB.length;

            }
            if (val.providerId == scope.pharmaProviderId) { //check for Pharma
              var newOrderPE = val.cityWiseRequests;
              $.each(newOrderPE, function (i, v) {
                citiesOfnewOrderPE.push({
                  "cityName": v.cityname,
                  "cityCount": v.count,
                  "request": v.requests
                });
              })
              scope.cityNameCountPE = citiesOfnewOrderPE;
              scope.aging = citiesOfnewOrderPE;
              var now = moment(new Date()); //todays date
              $.each(scope.aging, function (i, val) {
                $.each(val.request, function (i, v) {
                  var end = moment(v.createdOn); // another date
                  var duration = moment.duration(now.diff(end));
                  var diffOfHours = duration.asHours();
                  if (diffOfHours < 24) {
                    scope.dayOnePE.push(v);
                  } else if (diffOfHours > 24 && diffOfHours < 48) {
                    scope.dayTwoPE.push(v);
                  } else if (diffOfHours > 48) {
                    scope.dayThreePE.push(v);
                  }
                })
              })
              scope.countOnDayPE = scope.dayOnePE.length;
              scope.countOnTwoPE = scope.dayTwoPE.length;
              scope.countOnThreePE = scope.dayThreePE.length;
            }
          })
        }
        break;

      case "openOrders":
        scope.displayStatusName = scope.openOrderDetails.statusGroupName;
        if (scope.openOrderDetails.statusGroupName == "Open Orders") {
          var openOrderProviderWise = scope.openOrderDetails.providerWiseRequest;
          $.each(openOrderProviderWise, function (i, val) {
            if (val.providerId == scope.medibizProviderId) { //check for medebiz
              var openOrderMB = val.cityWiseRequests;
              $.each(openOrderMB, function (i, v) {
                citiesOfopenOrderMB.push({
                  "cityName": v.cityname,
                  "cityCount": v.count,
                  "request": v.requests
                });
              })
              scope.cityNameCountMB = citiesOfopenOrderMB;
              scope.aging = citiesOfopenOrderMB;
              var now = moment(new Date()); //todays date
              $.each(scope.aging, function (i, val) {
                $.each(val.request, function (i, v) {
                  var end = moment(v.createdOn); // another date
                  var duration = moment.duration(now.diff(end));
                  var diffOfHours = duration.asHours();
                  if (diffOfHours < 24) {
                    scope.dayOneMB.push(v);
                  } else if (diffOfHours > 24 && diffOfHours < 48) {
                    scope.dayTwoMB.push(v);
                  } else if (diffOfHours > 48) {
                    scope.dayThreeMB.push(v);
                  }
                })
              })
              scope.countOnDayMB = scope.dayOneMB.length;
              scope.countOnTwoMB = scope.dayTwoMB.length;
              scope.countOnThreeMB = scope.dayThreeMB.length;
            }
            if (val.providerId == scope.pharmaProviderId) { //check for Pharma
              var openOrderPE = val.cityWiseRequests;
              $.each(openOrderPE, function (i, v) {
                citiesOfopenOrderPE.push({
                  "cityName": v.cityname,
                  "cityCount": v.count,
                  "request": v.requests
                });
              })
              scope.cityNameCountPE = citiesOfopenOrderPE;
              scope.aging = citiesOfopenOrderPE;
              var now = moment(new Date()); //todays date
              $.each(scope.aging, function (i, val) {
                $.each(val.request, function (i, v) {
                  var end = moment(v.createdOn); // another date
                  var duration = moment.duration(now.diff(end));
                  var diffOfHours = duration.asHours();
                  if (diffOfHours < 24) {
                    scope.dayOnePE.push(v);
                  } else if (diffOfHours > 24 && diffOfHours < 48) {
                    scope.dayTwoPE.push(v);
                  } else if (diffOfHours > 48) {
                    scope.dayThreePE.push(v);
                  }
                })
              })
              scope.countOnDayPE = scope.dayOnePE.length;
              scope.countOnTwoPE = scope.dayTwoPE.length;
              scope.countOnThreePE = scope.dayThreePE.length;
            }
          })
        }
        break;

      case "closeOrders":
        scope.displayStatusName = scope.closeOrderDetails.statusGroupName;
        if (scope.closeOrderDetails.statusGroupName == "Closed Orders") {
          var closeOrderProviderWise = scope.closeOrderDetails.providerWiseRequest;
          $.each(closeOrderProviderWise, function (i, val) {
            if (val.providerId == scope.medibizProviderId) { //check for medebiz
              var closeOrderMB = val.cityWiseRequests;
              $.each(closeOrderMB, function (i, v) {
                citiesOfcloseOrderMB.push({
                  "cityName": v.cityname,
                  "cityCount": v.count,
                  "request": v.requests
                });
              })
              scope.cityNameCountMB = citiesOfcloseOrderMB;
              scope.aging = citiesOfcloseOrderMB;
              var now = moment(new Date()); //todays date
              $.each(scope.aging, function (i, val) {
                $.each(val.request, function (i, v) {
                  var end = moment(v.createdOn); // another date
                  var duration = moment.duration(now.diff(end));
                  var diffOfHours = duration.asHours();
                  if (diffOfHours < 24) {
                    scope.dayOneMB.push(v);
                  } else if (diffOfHours > 24 && diffOfHours < 48) {
                    scope.dayTwoMB.push(v);
                  } else if (diffOfHours > 48) {
                    scope.dayThreeMB.push(v);
                  }
                })
              })
              scope.countOnDayMB = scope.dayOneMB.length;
              scope.countOnTwoMB = scope.dayTwoMB.length;
              scope.countOnThreeMB = scope.dayThreeMB.length;
            }
            if (val.providerId == scope.pharmaProviderId) {
              var closeOrderPE = val.cityWiseRequests;
              $.each(closeOrderPE, function (i, v) {
                citiesOfcloseOrderPE.push({
                  "cityName": v.cityname,
                  "cityCount": v.count,
                  "request": v.requests
                });
              })
              scope.cityNameCountPE = citiesOfcloseOrderPE;
              scope.aging = citiesOfcloseOrderPE;
              var now = moment(new Date()); //todays date
              $.each(scope.aging, function (i, val) {
                $.each(val.request, function (i, v) {
                  var end = moment(v.createdOn); // another date
                  var duration = moment.duration(now.diff(end));
                  var diffOfHours = duration.asHours();
                  if (diffOfHours < 24) {
                    scope.dayOnePE.push(v);
                  } else if (diffOfHours > 24 && diffOfHours < 48) {
                    scope.dayTwoPE.push(v);
                  } else if (diffOfHours > 48) {
                    scope.dayThreePE.push(v);
                  }
                })
              })
              scope.countOnDayPE = scope.dayOnePE.length;
              scope.countOnTwoPE = scope.dayTwoPE.length;
              scope.countOnThreePE = scope.dayThreePE.length;
            }
          })
        }
        break;

      default:
        break;
    }
  }

  scope.getOrderDetails = function (provider, source, selectedEntity) {
    scope.OrderDetails = [];
    switch (provider) {
      case "medibiz":
        if (source == 'city') {
          scope.OrderDetails = selectedEntity.request;
          scope.countOrderDetails = scope.OrderDetails.length;
        }
        if (source == 'age1day') {
          scope.OrderDetails = scope.dayOneMB;
          scope.countOrderDetails = scope.dayOneMB.length;
        }
        if (source == 'age2day') {
          scope.OrderDetails = scope.dayTwoMB;
          scope.countOrderDetails = scope.dayTwoMB.length;
        }
        if (source == 'age3day') {
          scope.OrderDetails = scope.dayThreeMB;
          scope.countOrderDetails = scope.dayThreeMB.length;
        }
        break;

      case "Pharmeasy":
        if (source == 'city') {
          scope.OrderDetails = selectedEntity.request;
          scope.countOrderDetails = scope.OrderDetails.length;
        }
        if (source == 'age1day') {
          scope.OrderDetails = scope.dayOnePE;
          scope.countOrderDetails = scope.dayOnePE.length;
        }
        if (source == 'age2day') {
          scope.OrderDetails = scope.dayTwoPE;
          scope.countOrderDetails = scope.dayTwoPE.length;
        }
        if (source == 'age3day') {
          scope.OrderDetails = scope.dayThreePE;
          scope.countOrderDetails = scope.dayThreePE.length;
        }
        break;
      default:
        break;
    }
  }

  scope.collectedMedicines = [];
  scope.addMedicines = function () {
      scope.MediName = scope.selectedMediName;
      scope.MediId = scope.selectedMediId;
      scope.MediQuantity = scope.noOfMedicine;
      scope.collectedMedicines.push({
          'nameOfMedicine': scope.selectedMediName,
          'idOfMedicine': scope.selectedMediId,
          'quantityOfMedicine': scope.MediQuantity
      })
      scope.mediname = "";
      scope.noOfMedicine = "";
  }

  angular.element(document).ready(function () {
    scope.loadOrders();
  });
}]);

angular.module("mbplus")
.controller('settlePaymentController', ['$scope', '$rootScope', '$location', '$window', '$filter', '$http', '$stateParams',
    '$compile', 'UserService', 'UtilitiesService', 'ngTableParams', 'filterFilter', '$analytics',
    'PlusUtilitiesService', 'orderByFilter', '$timeout', function (scope, $rootScope, $location, $window, $filter, $http, $stateParams, $compile, UserService, UtilitiesService, ngTableParams, filterFilter, $analytics, PlusUtilitiesService, orderByFilter, $timeout) {
    if (!UserService.isActive()) {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    scope.$root.title = 'Active Appointments | Medibuddy Hospital Portal';
    scope.isActive = UserService.isActive();
    scope.getAuditDate = UtilitiesService.getAuditDate;
    scope.getAuditTime = UtilitiesService.getAuditTime;
    scope.user = UserService.getUserObj();
    scope.downloadPrefix = UtilitiesService.getPlusUrlPrefix('medibuddy');
   
    scope.fetchdc = true;
    scope.opsuser = false;
    scope.corporates = [];
    scope.isGroupLogin = false;
    scope.fulfilledtransactionsDummy = [];
    scope.ERTypeId = 5290;
    scope.serviceBrokerId = '1000042';
    scope.address = {}
    scope.status = {
        isFirstOpen: true,
    };
    scope.search = {
        type: '',
        sponsered: '',
        entityId: '',
        entityIdSearch: '',
        entityRelationSelected: '',
        dcId: ''
    }
    scope.serverSearch = {
        fromDate: '',
        toDate: ''
    };

    scope.downloadDate = {
        sap: ''
    };

    scope.downloadDate.sap = new Date();

    //Set today's date
    scope.today = function () {
        scope.serverSearch.fromDate = moment(Date()).format("DD-MMM-YYYY");
        scope.serverSearch.fromDate = new Date(scope.serverSearch.fromDate);
        scope.serverSearch.toDate = moment(Date()).add(7, 'd').format("DD-MMM-YYYY");
        scope.serverSearch.toDate = new Date(scope.serverSearch.toDate);
        scope.dt = new Date();
    };
    scope.today();
    scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 1
    };
    scope.open1 = function () {
        scope.popup1.opened = true;
    };
    scope.open2 = function () {
        scope.popup2.opened = true;
    };
    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];
    scope.popup1 = {
        opened: false
    };
    scope.popup2 = {
        opened: false
    };
    scope.invoiceType = [{ id: 0, name: '-- Select invoice type --', value: false }, { id: 1, name: 'Paid', value: true }, { id: 2, name: 'Sponsored', value: false }]
    scope.search.sponsered = scope.invoiceType[0];
    scope.financialType = [{ id: 3, name: '-- Select finance type --', value: '' }, { id: 1, name: 'Diagnostic Centre', value: 'dc' }, { id: 2, name: 'Corporate', value: 'corporate' }];
    scope.opsuser = UserService.getUserObj().entityId === 1000042;
    if (!scope.opsuser) {
        if (scope.user.entityType == 'DC') {
            scope.financialType = [{ id: 3, name: '-- Select finance type --', value: '' }, { id: 1, name: 'Diagnostic Centre', value: 'dc' }];
        } else {
            scope.financialType = [{ id: 3, name: '-- Select finance type --', value: '' }, { id: 2, name: 'Corporate', value: 'corporate' }];
        }
        scope.search.type = scope.financialType[0];
    }
    scope.search.type = scope.financialType[0];
    scope.changeType = function (type) {
        scope.clientFilterType = type.value === 'dc' ? 'dc' : (type.value === 'corporate' ? 'corp' : '');
        switch (type.value) {
            case "dc":
                scope.isSponsered = false;
                scope.isInvoiceType = false;
                scope.isSelectedPaid = false;
                scope.search.sponsered = scope.invoiceType[0];
                break;
            case "corporate":
                scope.isInvoiceType = false;
                scope.isSponsered = true;
                scope.search.sponsered = scope.invoiceType[0];
                $("#corpsearchbox").show();
                break;
            default:
                scope.fetchdc = false;
                scope.isSelectedPaid = false;
                scope.search.sponsered = scope.invoiceType[0];
                scope.fetchcop = false;
                scope.isSponsered = false;
                scope.isInvoiceType = false;
                break;
        }
    };
    scope.isFinanceData = false;
    scope.clientFilterType = '';
    scope.clearSearch = function () {
        scope.isSponsered = false;
        scope.search.type = scope.financialType[0];
        scope.search.sponsered = scope.invoiceType[0];
        scope.search.entityId = '';
        scope.search.entityIdSearch = '';
        scope.serverSearch.fromDate = '';
        scope.search.dcId = '';
        scope.serverSearch.toDate = '';
        scope.search.entityRelationSelected = { id: '0', entityName: '-- Contract Type --' };
        scope.isInvoiceType = false;
        scope.detailsfetched = false;
        scope.outstanding = 0;
        scope.isFinanceData = false;
        scope.fulfilledtransactions = [];
        scope.transactions = [];
        scope.clientFilterType = '';
        scope.testData = {};
        scope.address.dc;
        scope.citiesList = [];
        scope.locationsList = [];
        scope.sublocationsList = [];
        scope.diagnosticCentresList = [];
        scope.testData.testCityId = '';
        scope.testData.testLocalityId = '';
        scope.testData.testSubLocalityId = '';
    };
   
    scope.isSelectedPaid = false;

    scope.filterFroSponsered = function (data) {
        scope.search.entityIdSearch = '';
        scope.search.entityRelationSelectedSearch = { id: '0', entityName: '-- Contract Type --' };
    };

    var er_id = "";
    scope.EntityRelation = UtilitiesService.getContracts() === null ? [] : UtilitiesService.getContracts();
    scope.EntityRelation.push({ id: '0', entityName: '-- Contract Type --' });
    scope.search.entityRelationSelected = { id: '0', entityName: '-- Contract Type --' };
    scope.search.entityRelationSelectedSearch = { id: '0', entityName: '-- Contract Type --' };
    scope.EntityRelation = orderByFilter(scope.EntityRelation, 'entityName', false);
    if (scope.EntityRelation) {
        scope.entityRelationSelected = scope.EntityRelation[0].entityName;
    }

    scope.downloadSettledOrder = function (invoiceNumber) {
        var url = "";
        if (scope.entityId) {
            var entityId = scope.entityId;
        } else {
            var entityId = scope.search.entityId.id ? scope.search.entityId.id : scope.search.entityIdSearch.id ? scope.search.entityIdSearch.id : scope.address.dc.entityId;
        }

        if (invoiceNumber && entityId) {
            var splitInvoiceNo = invoiceNumber.split('/')
            if (splitInvoiceNo.length > 0) {
                var finalInvoice = invoiceNumber.replace(/\//g, '^')
            }
            var finalInvoiceNumber = finalInvoice ? finalInvoice : invoiceNumber
            url = UtilitiesService.getPlusUrlPrefix() + "/InvoiceSettlement/" + entityId + "/" + finalInvoiceNumber;
        }
        else {
            url = UtilitiesService.getPlusUrlPrefix() + "/InvoiceSettlement/" + entityId;
        }
        UserService.makeRestCall(url, "", "GET", UserService.getAccessToken(), true).then(function (response) {
            var element = $('<a/>');
            element.attr({
                href: 'data:attachment/csv;charset=utf-8,' + encodeURI(response.data),
                target: '_blank',
                download: 'Mahs_Settled_Invoices.xls'
            })[0].click();
        });
    };

    //pass corporate erId
    scope.loadSettledInvoice = function (item, model, label) {
        if (item) {
            var url = UtilitiesService.getPlusUrlPrefix() + 'Invoice/GetAllInvoice.json';
            var data = {
                'invoiceNumber': scope.paymentSetteledData.invoiceNumber,
                'transactionId': '',
                'entityRelationId': item ? item : 0,
                'startDate': scope.serverSearch.fromDate,
                'endDate': scope.serverSearch.toDate
            }
            UserService.makeRestCall(url, data, "POST", UserService.getAccessToken(), true).then(function (response) {
                scope.transactionsSettelInvoice = response.data;
                scope.transactions = response.data;
                scope.currentPage1 = 1;
                scope.entryLimit1 = 10;
                scope.maxSize1 = 5; //pagination max size
                scope.noOfPages1 = scope.transactions.length;
            });
        }
    };
    scope.paymentSetteledData={
        invoiceNumber:''
    }
    scope.paymentSetteledData = UserService.serverSearch ? UserService.serverSearch : scope.paymentSetteledData;
    scope.isSuccessMsg = false;
    if (scope.paymentSetteledData && scope.paymentSetteledData.invoiceNumber) {
        scope.isSuccessMsg = true;
        $timeout(function () {
            scope.isSuccessMsg = false;
        }, 5000);
        scope.loadSettledInvoice(scope.paymentSetteledData.entityRelationId);
    }
    
    scope.loadFinancials = function (er_id, startDate, endDate) {
        if (!er_id) {
            er_id = scope.selectedErId;
        }
        scope.selectedEntity = er_id;
        scope.loadSettledInvoice(scope.selectedEntity, startDate, endDate);
        var ajaxData = {
            entityId: scope.selectedEntity,
        }
        if (startDate) {
            ajaxData.startDate = startDate;
        }
        if (endDate) {
            ajaxData.endDate = endDate;
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/financialDetail', ajaxData, 'POST', UserService.getAccessToken()).then(function (response) {
            scope.detailsfetched = true;
            scope.outstanding = response.data.totalAmount.toFixed(2);
        });
    }

    if (scope.isActive) {
        $(".no-login").removeClass("no-login").addClass("login");
        $("#sidebar li").removeClass("active");
        $("#sidebar li#" + $location.path().split("/")[1]).addClass("active");
        scope.transactionsSettelInvoice = [];
        scope.paid = 0;
        scope.balance = 0;
        if (UserService.getUserObj().entityId == 1000042) {
            scope.opsuser = true;
        }
        if (!scope.opsuser) {
            var childrens = JSON.parse(localStorage.getItem('children'));
            scope.isGroupLogin = childrens && childrens != null && childrens.length > 1;
            if (scope.isGroupLogin) {
                scope.diagnosticCentres = childrens;
            }
            if (er_id == '' && scope.user.eR_Id)
                er_id = scope.user.eR_Id;
            if (!scope.isGroupLogin) {
                if (filterFilter(scope.user.rolesFeatures.roles, { 'roleId': 9211 }, true).length > 0 || filterFilter(scope.user.rolesFeatures.roles, { 'roleId': 9207 }, true).length > 0) {
                    var checkContract = UtilitiesService.isChildForContract(4625);// 4625 prepolicy contract
                    if (checkContract && checkContract.length > 0) {
                        er_id = checkContract[0].id;
                    }
                }
                if (filterFilter(scope.user.rolesFeatures.roles, { 'roleId': [5432, 5433, 5434] }, function (actual, expected) {
                    return filterFilter(expected, actual, true);
                }).length > 0) {
                    var checkContract = UtilitiesService.isChildForContract(5290);// 5290 dc contract
                    if (checkContract && checkContract.length > 0) {
                        er_id = checkContract[0].id;
                    }
                }
            }
            if (er_id != "")
                scope.loadFinancials(er_id);
            $(".cart").addClass("form-create-first");
            $(".transactions").addClass("form-create-first");
        }
        scope.setCorporateId = function (corpId, corpName) {
            scope.loadFinancials(corpId);
        }
        $(function () {
            //Upload updated excel sheet
            $("input#reports").change(function (event) {
                if (window.FormData) {
                    formdata = new FormData();
                }
                var i = 0,
                      len = this.files.length,
                      img, reader, file;
                for (; i < len; i++) {
                    file = this.files[i];
                    if (formdata) {
                        formdata.append("reports[]", file);
                        formdata.append("type", "reports");
                    }
                }
                scope.attachFiles = {};
                if (formdata) {
                    $.ajax({
                        url: UtilitiesService.getPlusUrlPrefix() + "/InvoiceSettlement.json",
                        type: "POST",
                        data: formdata,
                        processData: false,
                        contentType: false,
                        headers: { 'AccessToken': UserService.getAccessToken() },
                        success: function (res) {
                            $("input#reports").val("");
                            scope.$apply();
                        }
                    });
                }
                return false;
            })
           
            $(document).on("click", ".showUploadModal", function () {
                scope.action.invid = $(this).data("invid");
            })
            $("#corpsearchbox").hide();
            scope.getCorporate = function (value) {
                if (value && parseInt(value.id) > 0) {
                    scope.search.entityId = '';
                    scope.loadCorporates(parseInt(value.id));
                } else {
                    scope.fulfilledtransactions = scope.fulfilledtransactionsDummy;
                    scope.noOfPages = scope.fulfilledtransactions.length;
                }
            };

            scope.loadCorporates = function (id) {
                if (id) {
                    UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + '/EntityRelation/Search/' + id, '', 'GET').then(function (response) {
                        scope.corporatesinit = response.data;
                        scope.corporates = [];
                        $(scope.corporatesinit).each(function (i, v) {
                            if (v.isActive) {
                                scope.corporates.push(v);
                            }
                        })
                        $("#corpsearchbox").show();
                        getMatchingCorporates(scope.corporates);
                    });
                }
            };
            var corporateNames = [];
            var corporateIds = {};
            function getMatchingCorporates(corporates) {
                $.each(corporates, function (index, corporate) {
                    corporateNames.push(corporate.entityName);
                    corporateIds[corporate.entityName] = corporate.id;
                });
                $('#corp-search').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 3
                },
                  {
                      name: 'corporatenames',
                      displayKey: 'value',
                      source: substringMatcher(corporateNames)
                  });
            };
            function substringMatcher(strs) {
                return function findMatches(q, cb) {
                    var matches, substrRegex;
                    matches = [];
                    substrRegex = new RegExp(q, 'i');
                    $.each(strs, function (i, str) {
                        if (substrRegex.test(str)) {
                            matches.push({ value: str });
                        }
                    });
                    cb(matches);
                };
            };
            $('#corp-search').on('typeahead:selected', function (e, datum) {
                scope.setCorporateId(corporateIds[datum.value], datum.value.split(",")[0]);
            });
            $("#includeall").change(function () {
                $("#waitingSettled input:checkbox").prop("checked", $("#includeall").prop("checked"));
            })
        })
    }

    //Get location
    scope.locationMethods = (function () {
        scope.testData = {};
        return {
            loadStates: function () {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + '/masterdata/lookup/state.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.statesList = response.data.lookUpData;
                    }
                });
            },
            loadCities: function (stateId) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/masterdata/lookup/district/' + stateId + '.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.citiesList = response.data.lookUpData;
                    }
                });
            },
            loadLocations: function (cityId) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/masterdata/lookup/city/" + cityId + '.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.locationsList = response.data.lookUpData;
                    }
                });
            },
            loadSubLocations: function (locationId) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/masterdata/lookup/location/' + locationId + '.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.sublocationsList = response.data.lookUpData;
                    }
                });
            },
            loadDCForTests: function (id, obj) {
                scope.testData.testSubLocalityId = id;
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'EntityRelation/Search/EntitySearch/' + scope.ERTypeId + '/' + scope.serviceBrokerId + '/' + 0 + '/' + scope.testData.testStateId + '/' + scope.testData.testCityId + '/' + scope.testData.testLocalityId + '/' + scope.testData.testSubLocalityId + '.json', '', 'get').then(function (response) {
                    if (response.statusText == 'OK') {
                        scope.diagnosticCentresList = response.data;
                    }
                });
            }
        }
    })();

    //Load Location based ontype
    scope.loadLocationData = function (type, id) {
        if (id) {
            switch (type) {
                case 'city':
                    scope.citiesList = [];
                    scope.locationsList = [];
                    scope.sublocationsList = [];
                    scope.diagnosticCentresList = [];
                    scope.testData.testCityId = '';
                    scope.testData.testLocalityId = '';
                    scope.testData.testSubLocalityId = '';
                    scope.address.dc = '';

                    scope.locationMethods.loadCities(id);
                    break;
                case 'locality':
                    scope.locationMethods.loadLocations(id);
                    break;
                case 'sublocality':
                    scope.locationMethods.loadSubLocations(id);
                    break;
                case 'dc':
                    scope.locationMethods.loadDCForTests(id);
                    break;
                default:
                    scope.locationMethods.loadCities(id);
                    break;
            }
        } else {
            switch (type) {
                case 'city':
                    scope.citiesList = [];
                    scope.locationsList = [];
                    scope.sublocationsList = [];
                    scope.diagnosticCentresList = [];
                    scope.testData.testCityId = '';
                    scope.testData.testLocalityId = '';
                    scope.testData.testSubLocalityId = '';
                    scope.address.dc = '';
                    break;
                case 'locality':
                    scope.locationsList = [];
                    scope.sublocationsList = [];
                    scope.diagnosticCentresList = [];
                    scope.testData.testLocalityId = '';
                    scope.testData.testSubLocalityId = '';
                    scope.address.dc = '';
                    break;
                case 'sublocality':
                    scope.diagnosticCentresList = [];
                    scope.sublocationsList = [];
                    scope.address.dc = '';
                    scope.testData.testSubLocalityId = '';
                    break;
                case 'dc':
                    scope.diagnosticCentresList = [];
                    scope.address.dc = '';
                    break;
                default:
                    break;
            }
        }
    };

    scope.settlePaymentMethod = function (isCoprDc, dcCorpObj) {
        scope.entityId = '';
        if (isCoprDc === 'corporate' && dcCorpObj) {
            scope.entityId = dcCorpObj.id
            if (scope.entityId) {
                scope.loadSettledInvoice(scope.entityId);
            }
        } else if (isCoprDc === 'dc' && dcCorpObj) {
            scope.entityId = dcCorpObj.id
            if (scope.entityId) {
                scope.loadSettledInvoice(scope.entityId);
            }
        } else {
            //alert('Select search criteria.');
            UtilitiesService.showAlertMessage('Select search criteria.');
        }
    };

    scope.locationMethods.loadStates();

}]);
angular.module("mbplus")
.controller('paymentsController', ['$scope', '$rootScope', '$location', '$window', '$filter', '$http', '$stateParams', '$compile', 'UserService', 'UtilitiesService', 'ngTableParams', 'filterFilter', '$analytics', 'PlusUtilitiesService', 'orderByFilter', '$state','$timeout', function (scope, $rootScope, $location, $window, $filter, $http, $stateParams, $compile, UserService, UtilitiesService, ngTableParams, filterFilter, $analytics, PlusUtilitiesService, orderByFilter, $state,$timeout) {
    if (!UserService.isActive()) {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    scope.user = UserService.getUserObj();
    if(UserService.getUserObj() && UserService.getUserObj().entityType && (UserService.getUserObj().entityType.toLowerCase() ==='dc')){
            scope.isSAPDownload = false;
    }else{
        scope.isSAPDownload = true;
    }
    scope.financeLoginAcess = true;
    scope.getAcess = function(){
        if (scope.user && scope.user.rolesFeatures && scope.user.rolesFeatures.roles && scope.user.rolesFeatures.roles.length > 1) {
            angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
                if (v.roleId === 9205) {
                    scope.financeLoginAcess = false;
                }
            })
        }
        return scope.financeLoginAcess;
    };

    scope.isOffline = scope.getAcess();

    $analytics.pageTrack('/appointments');
    scope.$root.title = 'Active Appointments | Medibuddy Hospital Portal';
    scope.isActive = UserService.isActive();
    scope.formatCurrency = UtilitiesService.formatCurrency;
    scope.formatTime = UtilitiesService.formatTime;
    scope.compareDate = UtilitiesService.compareDate;
    scope.getAuditDate = UtilitiesService.getAuditDate;
    scope.getAuditTime = UtilitiesService.getAuditTime;
    
    scope.hasNoResults = true;
    scope.loading = true;
    scope.dummySearchData = '';
    scope.searchResults = false;
    scope.fetchdc = true;
    scope.detailsfetched = false;
    scope.opsuser = false;
    scope.selectedErId = '';
    scope.corporates = [];
    scope.selectedEntity = null;
    scope.transaction = {};
    scope.neft = true;
    scope.cheque = false;
    scope.txn = {};
    scope.action = {};
    scope.urlPrefix = UtilitiesService.getPlusUrlPrefix();
    scope.isEmployeePaid = false;
    scope.showEmployeePaidOptions = false;
    scope.isGroupLogin = false;
    scope.fulfilledtransactionsForSponsered = [];
    scope.fulfilledtransactionsDummy = [];
    scope.isFilteredWithSponsered = false;
    scope.dummyValue = '';
    scope.dummyType = '';
    scope.gstState = [  { "StateName" : "-- Select state --", "StateId" : "0"},
                        {"StateName":"Andaman Nicobar","StateId":"48"},
                        {"StateName":"Andhra Pradesh","StateId":"49"},
                        {"StateName":"Arunachal Pradesh","StateId":"50"},
                        {"StateName":"Assam","StateId":"51"},
                        {"StateName":"Bihar","StateId":"52"},
                        {"StateName":"Chandigarh","StateId":"53"},
                        {"StateName":"Chattisgarh","StateId":"54"},
                        {"StateName":"Dadra and Nagar Haveli","StateId":"55"},
                        {"StateName":"Delhi","StateId":"56"},
                        {"StateName":"Daman Diu","StateId":"57"},
                        {"StateName":"Goa","StateId":"58"},
                        {"StateName":"Gujarat","StateId":"59"},
                        {"StateName":"Haryana","StateId":"60"},
                        {"StateName":"Himachal Pradesh","StateId":"61"},
                        {"StateName":"Jammu Kashmir","StateId":"62"},
                        {"StateName":"Jharkhand","StateId":"63"},
                        {"StateName":"Karnataka","StateId":"64"},
                        {"StateName":"Kerala","StateId":"65"},
                        {"StateName":"Lakshwadeep","StateId":"66"},
                        {"StateName":"Madhya Pradesh","StateId":"67"},
                        {"StateName":"Maharashtra","StateId":"68"},
                        {"StateName":"Manipur","StateId":"69"},
                        {"StateName":"MEGHALAYA","StateId":"70"},
                        {"StateName":"Mizoram","StateId":"71"},
                        {"StateName":"Nagaland","StateId":"72"},
                        {"StateName":"Odisha","StateId":"74"},
                        {"StateName":"Puducherry","StateId":"76"},
                        {"StateName":"Punjab","StateId":"77"},
                        {"StateName":"Rajasthan","StateId":"78"},
                        {"StateName":"Sikkim","StateId":"79"},
                        {"StateName":"Tamil Nadu","StateId":"80"},
                        {"StateName":"Tripura","StateId":"81"},
                        {"StateName":"Uttar Pradesh","StateId":"82"},
                        {"StateName":"Uttaranchal","StateId":"83"},
                        {"StateName":"West Bengal","StateId":"84"},
                        {"StateName":"Telangana","StateId":"9727"},
                        {"StateName":"Uttarakhand","StateId":"10581"}];
    scope.address = {
        state: { lookUpValue: '-- Select state --', lookUpId: 0 },
        city: { cityName: '-- Select city --', cityId: 0 },
        location: { locationName: '-- Select location --', locationId: 0 },
        dc: { entityName: '-- Select diagnostic centre --', entityId: 0 }
    }
    scope.cities = [{ cityName: '-- Select city --', cityId: 0 }];
    scope.sublocations = [{ locationName: '-- Select location --', locationId: 0 }];
    scope.diagnosticCentres = [{ entityName: '-- Select diagnostic centre --', entityId: 0 }];
    scope.checkboxModel = {
        isSelected: false
    };
    scope.status = {
        isFirstOpen: true,
    };
    scope.search = {
        type: '',
        sponsered: '',
        entityId: '',
        entityIdSearch: '',
        entityRelationSelected: '',
        dcId: ''
    }
    scope.serverSearch = {
        fromDate: '',
        toDate: ''

    };
    scope.downloadDate = {
        sap: ''
    };
    scope.downloadDate.sap = new Date();
    //Set today's date
    scope.today = function () {
        scope.serverSearch.fromDate = moment(Date()).format("DD-MMM-YYYY");
        scope.serverSearch.fromDate = new Date(scope.serverSearch.fromDate);
        scope.serverSearch.toDate = moment(Date()).add(7, 'd').format("DD-MMM-YYYY");
        scope.serverSearch.toDate = new Date(scope.serverSearch.toDate);
        scope.dt = new Date();
    };
    scope.today();
    scope.serverSearch.fromDate = '';
    scope.serverSearch.toDate = '';
    scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 1
    };

    scope.open1 = function () {
        scope.popup1.opened = true;
    };
    scope.open3 = function () {
        scope.popup3.opened = true;
    };
    scope.open2 = function () {
        scope.popup2.opened = true;
    };
    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];
    scope.popup1 = {
        opened: false
    };
    scope.popup3 = {
        opened: false
    };
    scope.popup2 = {
        opened: false
    };
    scope.invoiceType = [{ id: 0, name: '-- Select invoice type --', value: false }, { id: 1, name: 'Paid', value: true }, { id: 2, name: 'Sponsored', value: false }]
    scope.search.sponsered = scope.invoiceType[0];
    scope.financialType = [{ id: 3, name: '-- Select finance type --', value: '' }, { id: 1, name: 'Diagnostic Centre', value: 'dc' }, { id: 2, name: 'Corporate', value: 'corporate' }];
    scope.opsuser = UserService.getUserObj().entityId === 1000042;
    if (!scope.opsuser) {
        if (scope.user.entityType == 'DC') {
            scope.financialType = [{ id: 3, name: '-- Select finance type --', value: '' }, { id: 1, name: 'Diagnostic Centre', value: 'dc' }];
        } else {
            scope.financialType = [{ id: 3, name: '-- Select finance type --', value: '' }, { id: 2, name: 'Corporate', value: 'corporate' }];
        }
        scope.search.type = scope.financialType[0];
    }
    scope.search.type = scope.financialType[0];
    scope.changeType = function (type) {
        scope.fulfilledtransactions = [];
        scope.fulfilledtransactionsDummyObj = [];
        scope.clientFilterType = '';
        scope.corporates = [];
        scope.isFinanceData = false;
        scope.search.entityIdSearch = '';
        scope.isInvoiceType = false;
        scope.search.entityRelationSelectedSearch = { id: '0', entityName: 'All Contract' };
        scope.search.sponsered = scope.invoiceType[0];
        switch (type.value) {
            case 'dc':
                scope.isSponsered = false;
                scope.isSelectedPaid = false;
                break;
            case 'corporate':
                scope.isSponsered = true;
                scope.isSelectedPaid = true;
                $("#corpsearchbox").show();
                break;
            default:
                scope.fetchdc = false;
                scope.isSelectedPaid = false;
                scope.fetchcop = false;
                scope.isSponsered = false;
                break;
        }
    };
    scope.resetToDefault = function () {
        scope.transactions = [];
        scope.detailsfetched = false;
        scope.outstanding = 0;
    };
    scope.setDefaultResult = function () {
        scope.fulfilledtransactions = scope.fulfilledtransactionsDummy.length > 0 ? scope.fulfilledtransactionsDummy : [];
        scope.noOfPages = scope.fulfilledtransactions.length;
        if (scope.fulfilledtransactions.length > 0) {
            $(scope.fulfilledtransactions).each(function (i, v) {
                v.isIncluded = false;
            });
        }
    };
    scope.isFinanceData = false;
    scope.clientFilterType = '';
    scope.clearSearch = function () {
        scope.isSelectedPaid = false;
        scope.search.entityRelationSelectedSearch = '';
        scope.search.type = scope.financialType[0];
        scope.search.sponsered = scope.invoiceType[0];
        scope.search.entityId = '';
        scope.search.entityIdSearch = '';
        scope.serverSearch.fromDate = '';
        scope.search.dcId = '';
        scope.serverSearch.toDate = '';
        scope.search.entityRelationSelectedSearch = { id: '0', entityName: 'All Contract' };
        scope.isInvoiceType = false;
        scope.isSponsered = false;
        scope.detailsfetched = false;
        scope.outstanding = 0;
        scope.isFinanceData = false;
        scope.fulfilledtransactions = [];
        scope.transactions = [];
        scope.clientFilterType = '';

    };
    scope.loadState = function () {
        scope.states = scope.statesData;
    }
    scope.clearSearchClientFilter = function () {
        scope.search.entityId = '';
        scope.search.entityIdSearch = '';
        scope.search.entityRelationSelected = { id: '0', entityName: 'All Contract' };
        scope.outstanding = 0;
        //scope.search.sponsered = scope.invoiceType[0];
        scope.detailsfetched = false;
        scope.transactions = [];
        scope.clientSiteFilterForFinance('', '');
        scope.address.state = { lookUpValue: '-- Select state --', lookUpId: 0 };
        scope.address.city = { cityName: '-- Select city --', cityId: 0 };
        scope.address.location = { locationName: '-- Select location --', locationId: 0 };
        scope.address.dc = { entityName: '-- Select diagnostic centre --', entityId: 0 };
        scope.cities = [{ cityName: '-- Select city --', cityId: 0 }];
        scope.sublocations = [{ locationName: '-- Select location --', locationId: 0 }];
        scope.diagnosticCentres = [{ entityName: '-- Select diagnostic centre --', entityId: 0 }];
        scope.setDefaultResult();
        scope.resetToDefault();
    };

    scope.getFinancialData = function (searchData, type, value) {
        if (searchData) {
            if (type) {
                scope.resetToDefault();
                scope.clearSearchClientFilter();
            }
            if(UserService.getUserObj() && UserService.getUserObj().entityType && (UserService.getUserObj().entityType.toLowerCase() ==='dc')){
                searchData.entityId = UserService.getUserObj().entityId;
            }
            scope.search.entityId = searchData.entityId;
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'Invoice/UnInvoiced', searchData, 'POST', UserService.getAccessToken()).then(function (response) {
                scope.fulfilledtransactionsDummyObj = response.data;
                scope.fulfilledtransactions = response.data;
                angular.forEach(scope.fulfilledtransactions, function (data, index) {
                    scope.fulfilledtransactions[index].appointmentDate = UtilitiesService.getDateObj(data.appointmentDate);
                });
                scope.fulfilledtransactionsDummy = response.data;
                scope.fulfilledtransactionsCount = scope.fulfilledtransactions.length;
                scope.states = [{ lookUpValue: '-- Select state --', lookUpId: 0 }];
                scope.cityData = [];
                scope.sublocationData = [];
                scope.dcData = [];
                if (value === 'dc') {
                    _.each(scope.fulfilledtransactionsDummy, function (key, value) {
                        var states = { entityId: key.entityId, entityName: key.entityName, locationId: key.locationId, locationName: key.locationName, lookUpId: key.stateId, lookUpValue: key.stateName, cityName: key.cityName, cityId: key.cityId, districtId: key.districtId, districtName: key.districtName };
                        scope.states.push(states);
                        var city = { cityId: key.cityId, cityName: key.cityName, lookUpId: key.stateId, lookUpValue: key.stateName };
                        scope.cityData.push(city);
                        var sublocation = { locationId: key.locationId, locationName: key.locationName, cityId: key.cityId, cityName: key.cityName };
                        scope.sublocationData.push(sublocation);
                        var dc = { locationId: key.locationId, locationName: key.locationName, entityId: key.entityId, entityName: key.entityName };
                        scope.dcData.push(dc);
                    });
                    scope.states = _.uniq(scope.states, function (id) { return id.lookUpId; });
                    scope.cityData = _.uniq(scope.cityData, function (id) { return id.cityId; });
                    scope.sublocationData = _.uniq(scope.sublocationData, function (id) { return id.locationId; });
                    scope.dcData = _.uniq(scope.dcData, function (id) { return id.entityId; });
                    scope.states = _.sortBy(scope.states, function (name) { return name.lookUpValue; });
                    scope.cityData = _.sortBy(scope.cityData, function (name) { return name.cityName; });
                    scope.sublocationData = _.sortBy(scope.sublocationData, function (name) { return name.locationName; });
                    scope.dcData = _.sortBy(scope.dcData, function (name) { return name.entityName; });
                    scope.statesData = scope.states;
                } else if (value === 'crop') {
                    scope.fulfilledtransactions = _.filter(scope.fulfilledtransactions, function (id) { return id.contractId > 0 });
                    scope.fulfilledtransactionsDummy = scope.fulfilledtransactions;
                    scope.fulfilledtransactionsCount = scope.fulfilledtransactions.length;
                }
                scope.clientFilterType = scope.fulfilledtransactionsCount > 0 ? value === 'dc' ? 'dc' : 'corp' : '';
                scope.entryLimit = 10;
                scope.currentPage = 1; //current page
                scope.maxSize = 5; //pagination max size
                scope.noOfPages = scope.fulfilledtransactionsCount;
                scope.paymentTransectionDetails = [];
                scope.status.isFirstOpen = false;
                angular.forEach(response.data, function (i, v) {
                    scope.paymentTransectionDetails.push({
                        id: i.id,
                        isSell: i.isSell,
                        price: i.price,
                        opuser: scope.opsuser ? scope.opsuser : false,
                        request: i.request
                    })
                })
                if (type === false) {
                    scope.isSelectedOrder = true;
                    scope.clientSiteFilterForFinance(scope.dummyValue, scope.dummyType);
                }
                scope.isFinanceData = true;
            });
        }
    };

    scope.isEmployeePaidInvoice = false;
    scope.searchFor = false;



    scope.searchFinanceDetails = function (start, end, financeType, isponsered, entityId) {
        scope.checkboxModel.isSelected = false;
        scope.financeTypeSearchValue = financeType;
        scope.waitingstartdate = start;
        scope.waitingenddate = end;
        scope.isFinanceData = false;
        scope.searchFor = isponsered.value;
        scope.fulfilledtransactions = [];
        scope.transactions = [];
        scope.detailsfetched = false;
        scope.outstanding = 0;
        scope.clientFilterType = '';
        scope.searchFor = financeType === 'dc' ? false : scope.searchFor;
        if (start && end) {
            var searchData = {
                entityId: entityId ? entityId.id : 0,
                startDate: start,
                endDate: end,
                isPaidInvoice: isponsered.value ? isponsered.value : false,
                employeeId: '',
                entityType: financeType
            }
            scope.dummySearchData = searchData;
            scope.getFinancialData(searchData, true, financeType);
        }
        else {
            UtilitiesService.showAlertMessage('Select search criteria.');
        }
    };

    scope.selectState = function (value) {
        scope.setDefaultResult();
        scope.resetToDefault();
        scope.isSelectedOrder = true;
        if (value && value.lookUpId > 0) {
            scope.cities = _.filter(scope.cityData, function (num) { return num.lookUpId === value.lookUpId; });
            scope.cities.push({ cityName: '-- Select city --', cityId: 0 });
            scope.cities = _.sortBy(scope.cities, function (name) { return name.cityName; });
            scope.address.city = { cityName: '-- Select city --', cityId: 0 };
            scope.diagnosticCentres = [{ entityName: '-- Select diagnostic centre --', entityId: 0 }];
            scope.address.dc = { entityName: '-- Select diagnostic centre --', entityId: 0 };
            scope.sublocations = [{ locationName: '-- Select location --', locationId: 0 }];
            scope.address.location = { locationName: '-- Select location --', locationId: 0 };
        } else {
            scope.cities = [{ cityName: '-- Select city --', cityId: 0 }];
            scope.address.city = { cityName: '-- Select city --', cityId: 0 };
            scope.sublocations = [{ locationName: '-- Select location --', locationId: 0 }];
            scope.address.location = { locationName: '-- Select location --', locationId: 0 };
            scope.diagnosticCentres = [{ entityName: '-- Select diagnostic centre --', entityId: 0 }];
            scope.address.dc = { entityName: '-- Select diagnostic centre --', entityId: 0 };
        }
    };

    scope.selectCity = function (value) {
        scope.setDefaultResult();
        scope.resetToDefault();
        scope.isSelectedOrder = true;
        if (value && value.cityId) {
            scope.sublocations = _.filter(scope.sublocationData, function (num) { return num.cityId === value.cityId; });
            scope.sublocations.push({ locationName: '-- Select location --', locationId: 0 });
            scope.sublocations = _.sortBy(scope.sublocations, function (name) { return name.locationName; });
            scope.address.location = { locationName: '-- Select location --', locationId: 0 };
            scope.diagnosticCentres = [{ entityName: '-- Select diagnostic centre --', entityId: 0 }];
            scope.address.dc = { entityName: '-- Select diagnostic centre --', entityId: 0 };
        } else {
            scope.sublocations = [{ locationName: '-- Select location --', locationId: 0 }];
            scope.address.location = { locationName: '-- Select location --', locationId: 0 };
            scope.diagnosticCentres = [{ entityName: '-- Select diagnostic centre --', entityId: 0 }];
            scope.address.dc = { entityName: '-- Select diagnostic centre --', entityId: 0 };
        }
    };

    scope.selectSubLocation = function (value) {
        scope.setDefaultResult();
        scope.isSelectedOrder = true;
        scope.resetToDefault();
        if (value && value.locationId) {
            scope.diagnosticCentres = _.filter(scope.dcData, function (num) { return num.locationId === value.locationId; });
            scope.diagnosticCentres.push({ entityName: '-- Select diagnostic centre --', entityId: 0 });
            scope.diagnosticCentres = _.sortBy(scope.diagnosticCentres, function (name) { return name.entityName; });
            scope.address.dc = { entityName: '-- Select diagnostic centre --', entityId: 0 };
        } else {
            scope.diagnosticCentres = [{ entityName: '-- Select diagnostic centre --', entityId: 0 }];
            scope.address.dc = { entityName: '-- Select diagnostic centre --', entityId: 0 };
        }
    };


    scope.isSelectedPaid = false;
    scope.filterFroSponsered = function (data) {
        scope.search.entityIdSearch = '';
        scope.search.entityRelationSelectedSearch = { id: '0', entityName: 'All Contract' };
    };
    scope.isSelectType = true;

    scope.clientSiteFilterForFinance = function (value, type) {
        if (value) {
            scope.isSelectedOrder = true;
            $(scope.fulfilledtransactionsDummy).each(function (i, v) {
                v.isIncluded = false;
            });
            scope.dummyValue = value;
            scope.dummyType = type;
            var filterData = scope.fulfilledtransactionsDummy;
            if (type === 'corp' && value) {
                scope.isSelectType = false;
                filterData = scope.isFilteredWithSponsered === true ? scope.fulfilledtransactionsForSponsered : filterData;
                var filteredData = _.filter(filterData, function (num) { return num.request.primaryEntityId === value; });
                scope.fulfilledtransactions = filteredData;
                scope.noOfPages = scope.fulfilledtransactions.length;
                scope.loadSettledInvoice(value, '', '');
                if (scope.fulfilledtransactions.length > 0) {
                    scope.loadFinancials(value, '', '');
                }
            } else if (type === 'dc' && value.entityId > 0) {
                scope.isSelectType = false;
                var filteredData = _.filter(filterData, function (num) { return num.entityId === value.entityId; });
                scope.fulfilledtransactions = filteredData;
                scope.noOfPages = scope.fulfilledtransactions.length;
                scope.loadSettledInvoice(value.entityId, '', '');
                if (scope.fulfilledtransactions.length > 0) {
                    scope.loadFinancials(value.entityId, '', '');
                }
            } else {
                scope.isSelectType = true;
                scope.resetToDefault();
                scope.setDefaultResult();
            }
        } else {
            scope.isSelectType = true;
            scope.resetToDefault();
            scope.setDefaultResult();
        }
    };

    var er_id = "";
    scope.EntityRelation = UtilitiesService.getContracts() === null ? [] : UtilitiesService.getContracts();
    scope.EntityRelation.push({ id: '0', entityName: 'All Contract' });
    scope.search.entityRelationSelected = { id: '0', entityName: 'All Contract' };
    scope.search.entityRelationSelectedSearch = { id: '0', entityName: 'All Contract' };
    scope.EntityRelation = orderByFilter(scope.EntityRelation, 'entityName', false);
    if (scope.EntityRelation) {
        scope.entityRelationSelected = scope.EntityRelation[0].entityName;

    } else {
    }

    scope.selectPendingInvoice = function () {
        $(scope.fulfilledtransactions).each(function (i, v) {
            v.isIncluded = scope.checkboxModel.isSelected;
        });
        var isSelectedOrder = _.filter(scope.fulfilledtransactions, function (orderValue) { return orderValue.isIncluded === true; });
        scope.isSelectedOrder = isSelectedOrder.length > 0 ? false : true;
    };
    scope.setEmployeePaid = function (isEmployeePaid) {
        scope.isEmployeePaid = isEmployeePaid.value;
    }
    scope.uploadSettledOrder = function (invoiceNumber) {

    }
    scope.downloadSettledOrder = function (invoiceNumber) {
        var url = "";
        var entityId = scope.search.entityId ? scope.search.entityId : scope.search.entityIdSearch.id ? scope.search.entityIdSearch.id : scope.address.dc.entityId;
        if (invoiceNumber && entityId) {
            url = UtilitiesService.getPlusUrlPrefix() + "/InvoiceSettlement/" + entityId + "/" + invoiceNumber;
        }
        else {
            url = UtilitiesService.getPlusUrlPrefix() + "/InvoiceSettlement/" + entityId;
        }
        UserService.makeRestCall(url, "", "GET", UserService.getAccessToken(), true).then(function (response) {
            var element = $('<a/>');
            element.attr({
                href: 'data:attachment/csv;charset=utf-8,' + encodeURI(response.data),
                target: '_blank',
                download: 'Mahs_Settled_Invoices.xls'
            })[0].click();
        });
    }
    scope.settleInvoice = function () {
        var data = {
            InvoiceNumber: scope.txn.invoiceNumber,
            TransactionId: scope.txn.txnNumber,
            IsNEFT: scope.neft,
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() +'/Invoice/MarkPaid', data, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data.isSuccess) {
                $("#InvoiceModal").modal("hide");
                scope.loadSettledInvoice(scope.selectedEntity);
                scope.loadFinancials(scope.selectedEntity);
            }
            else {
                $("#InvoiceModal").modal("hide")
            }
        });
    };
    scope.searchFor = false;

    scope.downloadOrders = function (flag, type) {
        var selectedPackages = [];
        angular.forEach(scope.fulfilledtransactions, function (data, index) {
            if (data.isIncluded) {
                selectedPackages.push({ id: data.id });
            }
        });
        if (selectedPackages.length > 0) {
            var url = UtilitiesService.getPlusUrlPrefix() + 'Invoice';
            var data = {
                orderDetails: selectedPackages,
                createInvoice: flag,
                entityRelationId: type === 'corp' ? scope.search.entityId ? scope.search.entityId : scope.search.entityIdSearch.id : scope.address.dc.entityId,
                IsPaidInvoice: scope.searchFor,
                startDate: scope.waitingstartdate,
                endDate: scope.waitingenddate,
                entityType: scope.financeTypeSearchValue
            }
            UserService.makeRestCall(url, data, 'POST', UserService.getAccessToken(), true).then(function (response) {
                if (!flag) {
                    var element = $('<a/>');
                    element.attr({
                        href: 'data:attachment/csv;charset=utf-8,' + encodeURI(response.data),
                        target: '_blank',
                        download: 'Mahs_WaitingSettlement.xls'
                    })[0].click();
                }
            });
        } else {
            UtilitiesService.showAlertMessage('Please order item.');
        }
    };
    scope.gst ={
        cgst:'',
        sgst:'',
        igst:'',
        mail:'',
        gstNumber:'',
        state: { "StateName" : "-- Select state --", "StateId" : "0"}
    };
    scope.openGSTPopup = function(flag, type){
        var selectedPackages = [];
        angular.forEach(scope.fulfilledtransactions, function (data, index) {
            if (data.isIncluded) {
                selectedPackages.push({ id: data.id });
            }
        });
        if(scope.search && scope.search.sponsered && scope.search.sponsered.name === 'Sponsored'){
            scope.gst.cgst= '';
            scope.gst.sgst= '';
            scope.gst.igst= '';
            scope.gst.mail= '';
            scope.gst.gstNumber ='';
            scope.gst.state =  { "StateName" : "-- Select state --", "StateId" : "0"};
            scope.isGst = true;
            angular.element('#openGSTModel').append('body');
            angular.element('#openGSTModel').modal('show');
        }else if(selectedPackages.length === 1){
                scope.gst.cgst= '';
                scope.gst.sgst= '';
                scope.gst.igst= '';
                scope.gst.mail= '';
                scope.gst.gstNumber ='';
                scope.gst.state =  { "StateName" : "-- Select state --", "StateId" : "0"};
                scope.isGst = true;
                angular.element('#openGSTModel').append('body');
                angular.element('#openGSTModel').modal('show');
        }else{
            UtilitiesService.showAlertMessage('Please select one order at a time.');
        }
    };
    scope.isOther= true;

    scope.closePdf = function(flag){
        if(flag){
            scope.isGst = true;
            angular.element('#openGSTModel').append('body');
            angular.element('#openGSTModel').modal('show');
        }
        scope.isOther = true;
    };

    function setOutputMsg(msg) {
        $("#outputMsg").html("Result : " + msg);
    }
    function createShiftArr(step) {

        var space = '    ';
        
        if ( isNaN(parseInt(step)) ) {  // argument is string
            space = step;
        } else { // argument is integer
            step = parseInt(step);
            switch(step) {
                case 1: space = ' '; break;
                case 2: space = '  '; break;
                case 3: space = '   '; break;
                case 4: space = '    '; break;
                case 5: space = '     '; break;
                case 6: space = '      '; break;
                case 7: space = '       '; break;
                case 8: space = '        '; break;
                case 9: space = '         '; break;
                case 10: space = '          '; break;
                case 11: space = '           '; break;
                case 12: space = '            '; break;
            }
        }

        var shift = ['\n']; // array of shifts
        for(ix=0;ix<100;ix++){
            shift.push(shift[ix]+space); 
        }
        return shift;
    }
    function vkbeautify(text,step) {
        var ar = text.replace(/>\s{0,}</g,"><")
                     .replace(/</g,"~::~<")
                     .replace(/\s*xmlns\:/g,"~::~xmlns:")
                     .replace(/\s*xmlns\=/g,"~::~xmlns=")
                     .split('~::~'),
            len = ar.length,
            inComment = false,
            deep = 0,
            str = '',
            ix = 0,
            shift = step ? createShiftArr(step) : this.shift;

            for(ix=0;ix<len;ix++) {
                // start comment or <![CDATA[...]]> or <!DOCTYPE //
                if(ar[ix].search(/<!/) > -1) { 
                    str += shift[deep]+ar[ix];
                    inComment = true; 
                    // end comment  or <![CDATA[...]]> //
                    if(ar[ix].search(/-->/) > -1 || ar[ix].search(/\]>/) > -1 || ar[ix].search(/!DOCTYPE/) > -1 ) { 
                        inComment = false; 
                    }
                } else 
                // end comment  or <![CDATA[...]]> //
                if(ar[ix].search(/-->/) > -1 || ar[ix].search(/\]>/) > -1) { 
                    str += ar[ix];
                    inComment = false; 
                } else 
                // <elm></elm> //
                if( /^<\w/.exec(ar[ix-1]) && /^<\/\w/.exec(ar[ix]) &&
                    /^<[\w:\-\.\,]+/.exec(ar[ix-1]) == /^<\/[\w:\-\.\,]+/.exec(ar[ix])[0].replace('/','')) { 
                    str += ar[ix];
                    if(!inComment) deep--;
                } else
                 // <elm> //
                if(ar[ix].search(/<\w/) > -1 && ar[ix].search(/<\//) == -1 && ar[ix].search(/\/>/) == -1 ) {
                    str = !inComment ? str += shift[deep++]+ar[ix] : str += ar[ix];
                } else 
                 // <elm>...</elm> //
                if(ar[ix].search(/<\w/) > -1 && ar[ix].search(/<\//) > -1) {
                    str = !inComment ? str += shift[deep]+ar[ix] : str += ar[ix];
                } else 
                // </elm> //
                if(ar[ix].search(/<\//) > -1) { 
                    str = !inComment ? str += shift[--deep]+ar[ix] : str += ar[ix];
                } else 
                // <elm/> //
                if(ar[ix].search(/\/>/) > -1 ) { 
                    str = !inComment ? str += shift[deep]+ar[ix] : str += ar[ix];
                } else 
                // <? xml ... ?> //
                if(ar[ix].search(/<\?/) > -1) { 
                    str += shift[deep]+ar[ix];
                } else 
                // xmlns //
                if( ar[ix].search(/xmlns\:/) > -1  || ar[ix].search(/xmlns\=/) > -1) { 
                    str += shift[deep]+ar[ix];
                } 
                
                else {
                    str += ar[ix];
                }
            }
            scope.printData = (str[0] == '\n') ? str.slice(1) : str;
        return  (str[0] == '\n') ? str.slice(1) : str;
    };

    scope.print = function(id){
        var frm = document.getElementById(id).contentWindow;
        frm.focus();// focus on contentWindow is needed on some ie versions
        frm.print();
        return false;
    };

    scope.htmlOutput = function(content) {
        angular.forEach(scope.previewInvoiceData, function(key, value){
            if(content.id === key.id){
                scope.previewInvoiceData[value].isOpen = true;
            }else{
                scope.previewInvoiceData[value].isOpen = false;
            }
        });
        var step = '\t';
        $("#excelToHtmlData").text("");
        var data = content.html;
        var old = '';
        var viewname = "htmlviewer";
        if (viewname == "htmlviewer") {
            $("#result").hide();
            $("#resultDiv1").show();
            data = content.html;
        }

        if (data.trim().length > 0) {
            var result1 = document.getElementById("result1");
            var d = result1.contentWindow.document;
            if (old != data) {
                var htmlString = "<!DOCTYPE html><html>\n";
                    htmlString = htmlString + '<head><meta charset="UTF-8"><title>Excel To HTML using codebeautify.org</title></head>\n';
                    htmlString = htmlString + "<body>\n";
                    htmlString = htmlString +  data;
                    htmlString = htmlString + "\n</body>\n";
                    htmlString = htmlString + "</html>";
                    if (viewname != "htmlviewer") {
                        $("#excelToHtmlData").text(vkbeautify(htmlString, step));
                    }
                    else{
                        $("#excelToHtmlData").text(vkbeautify(data, step));
                    }
                old = data;
                d.open();
                if (viewname == "htmlviewer") {
                    d.write(old);
                } else {
                    d.write("<center>" + old + "</center>");
                }
                d.close();
            }
            $("html, body").animate({
                scrollTop : 0
            }, 10);
        }
    };

    scope.previewInvoice = function(type, gstValue){
        var selectedPackages = [];
        scope.isOpenEditGstPdf = false;
        if(gstValue){
            scope.isOpenEditGstPdf = true;
            var gstData = {};
            angular.element('#openGSTModel').modal('hide');
            if(gstValue.gstNumber){
                gstData.GSTIN  = gstValue.gstNumber;
            }
            if(gstValue.state){
                gstData.BillStateId  = gstValue.state.StateId;
            }
            if(gstValue.mail){
                gstData.BillAddress = gstValue.mail;
            }
        }
        angular.forEach(scope.fulfilledtransactions, function (data, index) {
            if (data.isIncluded) {
                selectedPackages.push({ id: data.id });
            }
        });
        if ((scope.address.dc && scope.address.dc.entityId || scope.search.entityId) && selectedPackages.length > 0) {
            if (scope.searchFor === true) {
                var data = {
                    orderDetails: selectedPackages,
                    createInvoice: true,
                    entityRelationId: type === 'corp' ? scope.search.entityId ? scope.search.entityId : scope.search.entityIdSearch.id : scope.address.dc.entityId,
                    IsPaidInvoice: scope.searchFor,
                    startDate: scope.waitingstartdate,
                    endDate: scope.waitingenddate,
                    entityType: scope.financeTypeSearchValue,
                    isPreview:true,
                    TaxDetails: gstData
                }
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'Invoice', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
                    scope.isOther= false;
                    if(response.data){
                        scope.previewInvoiceData =[] ;
                        angular.forEach(response.data, function(key, value){
                            var data ={id : value+1, name: 'Invoice pdf',html: key, isOpen :  false};
                            scope.previewInvoiceData.push(data);
                        });
                        if(scope.previewInvoiceData.length > 0){
                            scope.htmlOutput(scope.previewInvoiceData[0])
                            scope.isShowPDF = true;
                        }
                    }
                });
            } else if (scope.searchFor === false) {
                var data = {
                    orderDetails: selectedPackages,
                    createInvoice: true,
                    entityRelationId: type === 'corp' ? scope.search.entityId ? scope.search.entityId : scope.search.entityIdSearch.id : scope.address.dc.entityId,
                    IsPaidInvoice: scope.searchFor,
                    startDate: scope.waitingstartdate,
                    endDate: scope.waitingenddate,
                    entityType: scope.financeTypeSearchValue,
                    isPreview:true,
                    TaxDetails: gstData
                }
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'Invoice', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
                    scope.isOther= false;
                    if(response.data){
                        scope.previewInvoiceData =[] ;
                        angular.forEach(response.data, function(key, value){
                            var data ={id : value+1, name: 'Invoice pdf', html: key, isOpen :  false};
                            scope.previewInvoiceData.push(data);
                        });
                        if(scope.previewInvoiceData.length > 0){
                            scope.htmlOutput(scope.previewInvoiceData[0])
                            scope.isShowPDF = true;
                        }
                    }
                });
            } else {

            }
        } else {
            UtilitiesService.showAlertMessage('Please select order with dc/corporate');
        }
    };

    scope.openconfrm = function(flag, type, gstData){
        scope.flagStatus = flag;
        scope.invoiceGenrationType = type;
        scope.invoiceGstData = gstData;
        scope.isGst = false;
         $timeout(function() {
            angular.element('#openGSTModel').append('body');
            angular.element('#openGSTModel').modal('show');
        }, 1000);

    };
    scope.downloadPrefix = UtilitiesService.getPlusUrlPrefix('medibuddy');
    scope.downloadSelectedOrders = function (flag, type, gstData) {
        angular.element('#confirmationModelPopupfinance').modal('hide');
        var selectedPackages = [];
        angular.forEach(scope.fulfilledtransactions, function (data, index) {
            if (data.isIncluded) {
                selectedPackages.push({ id: data.id });
            }
        });
        if ((scope.address.dc && scope.address.dc.entityId || scope.search.entityId) && selectedPackages.length > 0) {
            if (scope.searchFor === true) {
                var data = {
                    orderDetails: selectedPackages,
                    createInvoice: flag,
                    entityRelationId: type === 'corp' ? scope.search.entityId ? scope.search.entityId : scope.search.entityIdSearch.id : scope.address.dc.entityId,
                    IsPaidInvoice: scope.searchFor,
                    startDate: scope.waitingstartdate,
                    endDate: scope.waitingenddate,
                    entityType: scope.financeTypeSearchValue,
                    TaxDetails: gstData
                }
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'Invoice', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
                    if (!flag) {
                        var element = $('<a/>');
                        element.attr({
                            href: 'data:attachment/csv;charset=utf-8,' + encodeURI(response.data),
                            target: '_blank',
                            download: 'Mahs_WaitingSettlement.xls'
                        })[0].click();
                    }
                    else {
                        var url = UtilitiesService.getPlusUrlPrefix('medibuddy') + '/WAPI/GetFile/' + _.first(response.data).dmsDocId;
                        window.open(url, "_blank");
                        UtilitiesService.showAlertMessage('Invoice has been generated successfully.', true);
                        scope.getFinancialData(scope.dummySearchData, false, scope.dummySearchData.entityType);
                        scope.selectedEntity = scope.selectedEntity ? scope.selectedEntity : scope.dummySearchData.entityId;
                        scope.loadSettledInvoice(scope.selectedEntity);
                        scope.loadFinancials(scope.selectedEntity);
                    }
                });
            } else if (scope.searchFor === false) {
                var data = {
                    orderDetails: selectedPackages,
                    createInvoice: flag,
                    entityRelationId: type === 'corp' ? scope.search.entityId ? scope.search.entityId : scope.search.entityIdSearch.id : scope.address.dc.entityId,
                    IsPaidInvoice: scope.searchFor,
                    startDate: scope.waitingstartdate,
                    endDate: scope.waitingenddate,
                    entityType: scope.financeTypeSearchValue,
                    TaxDetails: gstData
                }
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'Invoice', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
                    if (!flag) {
                        var element = $('<a/>');
                        element.attr({
                            href: 'data:attachment/csv;charset=utf-8,' + encodeURI(response.data),
                            target: '_blank',
                            download: 'Mahs_WaitingSettlement.xls'
                        })[0].click();
                    }
                    else {
                        var url = UtilitiesService.getPlusUrlPrefix('medibuddy') + '/WAPI/GetFile/' + _.first(response.data).dmsDocId;
                        window.open(url, "_blank");
                        UtilitiesService.showAlertMessage('Invoice has been generated successfully.', true);
                        scope.getFinancialData(scope.dummySearchData, false, scope.dummySearchData.entityType);
                        scope.selectedEntity = scope.selectedEntity ? scope.selectedEntity : scope.dummySearchData.entityId;
                        scope.loadSettledInvoice(scope.selectedEntity);
                        scope.loadFinancials(scope.selectedEntity);
                    }
                });
            } else {

            }
        } else {
            UtilitiesService.showAlertMessage('Please select order with dc/corporate');
        }
    };

    scope.searchResult = function(value){
        if(value){
            scope.fulfilledtransactions = filterFilter(scope.fulfilledtransactions, value);
        }else{
            scope.fulfilledtransactions = scope.fulfilledtransactionsDummyObj;
        }
    };

    scope.settleInvoiceWithGST = function(value, type){
        if(value){
            var gstData = {};
            angular.element('#openGSTModel').modal('hide');
            $timeout(function() {
                if(value.gstNumber){
                    gstData.GSTIN  = value.gstNumber;
                }
                if(value.state){
                    gstData.BillStateId  = value.state.StateId;
                }
                if(value.mail){
                    gstData.BillAddress = value.mail;
                }
                scope.downloadSelectedOrders(true, type, gstData);
        }, 2000);
           
        }
    };

    scope.loadSettledInvoice = function (item, model, label) {
        var data = {
            startDate: scope.serverSearch.fromDate,
            endDate: scope.serverSearch.toDate
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'Invoice/GetAllInvoice/' + item, data, 'GET').then(function (response) {
            scope.transactionsSettelInvoice = response.data;
            scope.transactions = response.data;
            scope.currentPage1 = 1;
            scope.entryLimit1 = 10;
            scope.maxSize1 = 5;
            scope.noOfPages1 = scope.transactions.length;
        });
    };

    scope.downloadSAPFile = function (fromDate, toDate, entityType, isPaidInvoice) {
        var selectedPackages = [], selectedIds = [];
        angular.forEach(scope.fulfilledtransactions, function (data, index) {
            if (data.isIncluded) {
                selectedPackages.push({ id: data.id });
            }
        });
        selectedIds.push(selectedPackages.join(', '));
        if (selectedIds.length > 0) {
            var ajaxData = { financialEventIds: selectedPackages, sapDate: scope.downloadDate.sap };
            angular.element("#SAPfile").modal("hide");
            $("#SAPfile").hide();
            var element = $('<form/>').attr({
                method: 'POST',
                id: "sapdownload",
                action: UtilitiesService.getPlusUrlPrefix() + '/Finance/SAP'
            });
            $('<input/>').attr({
                id: 'financialEventIds',
                name: 'financialEventIds',
                value: selectedIds,
                type: "hidden"
            }).appendTo(element);
            $('<input/>').attr({
                id: 'isPaidInvoice',
                name: 'isPaidInvoice',
                value: isPaidInvoice ? isPaidInvoice.value : false,
                type: "hidden"
            }).appendTo(element);
            $('<input/>').attr({
                id: 'fromDate',
                name: 'fromDate',
                value: fromDate.toJSON(),
                type: "hidden"
            }).appendTo(element);
            $('<input/>').attr({
                id: 'toDate',
                name: 'toDate',
                value: toDate.toJSON(),
                type: "hidden"
            }).appendTo(element);
            $('<input/>').attr({
                id: 'entityType',
                name: 'entityType',
                value: entityType,
                type: "hidden"
            }).appendTo(element);
            $('<input/>').attr({
                id: 'sapDate',
                name: 'sapDate',
                value: scope.downloadDate.sap.toJSON(),
                type: "hidden"
            }).appendTo(element);
            $('<input/>').attr({
                id: 'accessToken',
                name: 'accessToken',
                value: UserService.getAccessToken(),
                type: "hidden"
            }).appendTo(element);
            $('<script>document.getElementById("sapdownload").submit() </script>').appendTo(element);
            var childwindow = window.open("", "_blank");
            childwindow.document.write($(element).get(0).outerHTML);
            scope.downloadDate.sap = new Date();
        }
    };

    scope.offlineInvoiceDTO = {
        remarks: '',
        invoiceNumber: '',
        invoiceDocId:''
    }

    scope.postOffline = function(){
        scope.isFileError = false;
        var data ={
            entityRelationId: 0,
            invoiceNumber: scope.offlineInvoiceDTO.invoiceNumber,
            invoiceDocId: scope.fileUploadDataObj.length > 0 ? _.first(scope.fileUploadDataObj).filePath :'',
            remarks: scope.offlineInvoiceDTO.remarks
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'InvoiceOffline', data, 'POST' , UserService.getAccessToken(), true).then(function (response) {
            if(response.data.isSuccess){
                var msg = '"'+ scope.offlineInvoiceDTO.invoiceNumber + '" ' + 'offline invoice generated successfully.';
                scope.offlineInvoiceDTO.invoiceNumber = '';
                scope.offlineInvoiceDTO.remarks = '';
                scope.fileUploadDataObj = [];
                angular.element('#offlineInvoice').modal('hide');
                alert(msg);
            }else{
                scope.isFileError = true;
                scope.isFileErrormsg = 'Something went wrong, please try again later.';
            }
        });
    };

    scope.getOfflineInvoiceNumber = function(){
        scope.isFileError = false;
        scope.offlineInvoiceNumber = [];
        scope.offlineInvoiceDTO.invoiceNumber = '';
        scope.offlineInvoiceDTO.remarks = '';
        scope.fileUploadDataObj = [];
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'InvoiceOfflineNumber','', 'get').then(function (response) {
            if(response.data.isSuccess){
                scope.offlineInvoiceNumber = response.data.invoiceNumbers;
            }
        });
    };

    scope.downloadAttachment = function(data){
        var url = UtilitiesService.getPlusUrlPrefix('medibuddy') + '/WAPI/GetFile/';
        if (data) {
            window.open(
              url + data,
              '_blank'
            );
        }
    };

    scope.removeFiles = function(item){
        angular.forEach(scope.fileUploadDataObj , function(key, value){
            if(key.fileName === item.fileName){
                scope.fileUploadDataObj.splice(value, 1)
            }
        });
    };

    scope.fileUploadDataObj = [];
    scope.fileFn = function(data){
        angular.forEach(data, function(value, index){
            scope.fileUploadDataObj.push({ fileName: value, filePath: index});
        });
        if(scope.fileUploadDataObj.length >1){
            scope.isFileError = true;
            scope.isFileErrormsg = 'Upload only one file.'
        }else{
            scope.isFileError = false;
        }
    };

    scope.loadFinancials = function (er_id, startDate, endDate) {
        if (!er_id) {
            er_id = scope.selectedErId;
        }
        scope.selectedEntity = er_id;
        scope.loadSettledInvoice(scope.selectedEntity, startDate, endDate);
        var ajaxData = {
            entityId: scope.selectedEntity,
        }
        if (startDate) {
            ajaxData.startDate = startDate;
        }
        if (endDate) {
            ajaxData.endDate = endDate;
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/financialDetail', ajaxData, 'POST', UserService.getAccessToken()).then(function (response) {
            scope.detailsfetched = true;
            scope.outstanding = response.data.totalAmount.toFixed(2);
        });
    }
    if (scope.isActive) {
        $(".no-login").removeClass("no-login").addClass("login");
        $("#sidebar li").removeClass("active");
        $("#sidebar li#" + $location.path().split("/")[1]).addClass("active");
        scope.transactionsSettelInvoice = [];
        scope.paid = 0;
        scope.balance = 0;
        if (UserService.getUserObj().entityId == 1000042) {
            scope.opsuser = true;
        }
        if (!scope.opsuser) {
            var childrens = JSON.parse(localStorage.getItem('children'));
            scope.isGroupLogin = childrens && childrens != null && childrens.length > 1;
            if (scope.isGroupLogin) {

                scope.diagnosticCentres = childrens;
            }
            if (er_id == '' && scope.user.eR_Id)
                er_id = scope.user.eR_Id;

            if (!scope.isGroupLogin) {
                if (filterFilter(scope.user.rolesFeatures.roles, { 'roleId': 9211 }, true).length > 0 || filterFilter(scope.user.rolesFeatures.roles, { 'roleId': 9207 }, true).length > 0) {
                    var checkContract = UtilitiesService.isChildForContract(4625);// 4625 prepolicy contract
                    if (checkContract && checkContract.length > 0) {
                        er_id = checkContract[0].id;
                    }
                }
                if (filterFilter(scope.user.rolesFeatures.roles, { 'roleId': [5432, 5433, 5434] }, function (actual, expected) {
                    return filterFilter(expected, actual, true);
                }).length > 0) {
                    var checkContract = UtilitiesService.isChildForContract(5290);// 5290 dc contract
                    if (checkContract && checkContract.length > 0) {
                        er_id = checkContract[0].id;
                    }
                }
            }
            if (er_id != "")
                scope.loadFinancials(er_id);
            $(".cart").addClass("form-create-first");
            $(".transactions").addClass("form-create-first");
        }
        scope.setCorporateId = function (corpId, corpName) {
            scope.loadFinancials(corpId);
        }
        $(function () {
            $("input#reports").change(function (event) {
                if (window.FormData) {
                    formdata = new FormData();
                }
                var i = 0,
                      len = this.files.length,
                      img, reader, file;
                for (; i < len; i++) {
                    file = this.files[i];
                    if (formdata) {
                        formdata.append("reports[]", file);
                        formdata.append("type", "reports");
                    }
                }
                scope.attachFiles = {};
                if (formdata) {
                    $.ajax({
                        url: UtilitiesService.getPlusUrlPrefix() + "/InvoiceSettlement.json",
                        type: "POST",
                        data: formdata,
                        processData: false,
                        contentType: false,
                        headers: { 'AccessToken': UserService.getAccessToken() },
                        success: function (res) {
                            $("input#reports").val("");
                            scope.$apply();
                        }
                    });
                }
                return false;
            })
            $(document).on("click", ".settleInvoice", function (event) {
                scope.txn.invoiceNumber = $(this).data('invoice');
            })
            $(document).on("click", ".showUploadModal", function () {
                scope.action.invid = $(this).data("invid");
            })
            $("#corpsearchbox").hide();

            scope.getCorporate = function (value) {
                if (value && parseInt(value.id) > 0) {
                    scope.search.entityId = '';
                    scope.loadCorporates(parseInt(value.id));
                    if (PlusUtilitiesService.getSpecificContract("Annual")[0] == value.id) {
                        scope.showEmployeePaidOptions = true;
                        scope.isEmployeePaid = false;
                    }
                    else {
                        scope.showEmployeePaidOptions = false;
                        scope.isEmployeePaid = false;
                    }
                } else {
                    scope.fulfilledtransactions = scope.fulfilledtransactionsDummy;
                    scope.noOfPages = scope.fulfilledtransactions.length;
                }
            };
            scope.isSelectedOrder = true;
            scope.selectParticularOrder = function (value) {
                var isSelectedOrder = _.filter(scope.fulfilledtransactions, function (orderValue) { return orderValue.isIncluded === true; });
                scope.isSelectedOrder = isSelectedOrder.length > 0 ? false : true;
                if (scope.address.dc && scope.address.dc.entityId || scope.search.entityId && scope.search.entityId || scope.search.entityIdSearch && scope.search.entityIdSearch.id) {
                    scope.isSelectType = false;
                } else {
                    scope.isSelectType = true;
                }
            };
            scope.loadCorporates = function (id) {
                if (id) {
                    UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + "/EntityRelation/Search/" + id + ".json", "", "get").then(function (response) {
                        scope.corporatesinit = response.data;
                        scope.corporates = [];
                        $(scope.corporatesinit).each(function (i, v) {
                            if (v.isActive) {
                                scope.corporates.push(v);
                            }
                        })
                        $("#corpsearchbox").show();
                        getMatchingCorporates(scope.corporates);
                    });
                }
            }
            var corporateNames = [];
            var corporateIds = {};
            function getMatchingCorporates(corporates) {
                $.each(corporates, function (index, corporate) {
                    corporateNames.push(corporate.entityName);
                    corporateIds[corporate.entityName] = corporate.id;
                });
                $('#corp-search').typeahead({
                    hint: true,
                    highlight: true,
                    minLength: 3
                },
                  {
                      name: 'corporatenames',
                      displayKey: 'value',
                      source: substringMatcher(corporateNames)
                  });
            }
            function substringMatcher(strs) {
                return function findMatches(q, cb) {
                    var matches, substrRegex;
                    matches = [];
                    substrRegex = new RegExp(q, 'i');
                    $.each(strs, function (i, str) {
                        if (substrRegex.test(str)) {
                            matches.push({ value: str });
                        }
                    });
                    cb(matches);
                };
            }
            $('#corp-search').on('typeahead:selected', function (e, datum) {
                scope.setCorporateId(corporateIds[datum.value], datum.value.split(",")[0]);
            });
            $("#includeall").change(function () {
                $("#waitingSettled input:checkbox").prop("checked", $("#includeall").prop("checked"));
            })

            $("#employeePaidDropdown").change(function () {
                $("#corp-search").val("");
                scope.isEmployeePaid = JSON.parse(this.value.toLowerCase());
                scope.outstanding = 0;
                scope.fulfilledtransactions = [];
                scope.$apply();
            })
        })
    }
    else {
    }
}]);
angular.module("mbplus")
.controller('pharmacyDashboardController', ['$scope', '$rootScope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics', 'PlusUtilitiesService', 'navConstantsSvc', '$uibModal', function (scope, $rootScope, $location, UserService, UtilitiesService, filterFilter, $analytics, PlusUtilitiesService, navConstantsSvc, $uibModal) {
    $analytics.pageTrack('/appointments');
    if (!UserService.isActive()) {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    };
    scope.contracts = [];
    scope.contracts = PlusUtilitiesService.getContracts();
    scope.dashboardSearch = {
        contractType: ''
    };

    scope.selectedDcs = [];
    scope.compareDate = UtilitiesService.compareDate;
    scope.formatTime = UtilitiesService.formatTime;
    scope.reasonOfCancel = UtilitiesService.reasonOfCancel();
    scope.dataError = '';
    scope.chartType = {
        type: 'pie'
    };
    scope.attachFiles = {
        reports: {},
        bills: {}
    };
    scope.action = {
        cancelComments: '',
        statusId: '',
        nextStatusId: '',
        requestId: '',
        spocname: '',
        spocphone: '',
        date: '',
        remarks: '',
        secondPreferredTime: '',
        dcPrice: '',
        visibleDate: '',
        visibleTime: '',
        partnerOrderId: '',
        showdcselection: false,
        feedback: ''
    };
    scope.feedbackList = ['Satisfied', 'Dissatisfied', 'Pacifistic'];    
    scope.pharmaData = {
        cashlessAmt: '',
        CODAmt: ''
    };
    scope.testData = {
        testStateId: '',
        testSubLocalityId: '',
        testCityId: '',
        testLocalityId: '',
        dcValue: ''
    };
    scope.homeVisit = {
        addressLineOne: '',
        addressLinTwo: ''
    };
    scope.serverSearch = {
        fromDate: '',
        toDate: '',
        statusSearch: '',
        contractType: '',
        corporateId: ''
    };
    scope.originalDcDetails = {
        providerId: '',
        providerName: '',
        appointmentDate: '',
        visitType: ''
    };
    scope.form = {
        dod: ''
    };

    //Set Time Object
    scope.resetTime = function () {
        var first = new Date();
        var dd = new Date(first).getDate();
        var mm = new Date(first).getMonth() + 1;
        var yy = new Date(first).getFullYear();
        var hh = 8;
        var ms = 0;
        var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
        scope.client.prefTime = new Date(x);
    };
    scope.client = {
        prefDate: new Date()
    };
    scope.user = UserService.getUserObj();
    //Set today's date

    //Set Time Object
    scope.resetTime = function () {
        var first = new Date();
        var dd = new Date(first).getDate();
        var mm = new Date(first).getMonth() + 1;
        var yy = new Date(first).getFullYear();
        var hh = 8;
        var ms = 0;
        var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
        scope.client.prefTime = new Date(x);
    };
    scope.resetTime();
    scope.hstep = 1;
    scope.mstep = 30;
    scope.ismeridian = false;
    //First time limit
    var maxFirst = new Date();
    maxFirst.setHours(18);
    maxFirst.setMinutes(0);
    scope.maxFirst = maxFirst;

    var minFirst = new Date();
    minFirst.setHours(8);
    minFirst.setMinutes(0);
    scope.minFirst = minFirst;

    scope.today = function () {
        scope.serverSearch.fromDate = moment(Date()).format("DD-MMM-YYYY");
        scope.serverSearch.fromDate = new Date(scope.serverSearch.fromDate);
        scope.serverSearch.toDate = moment(Date()).add(7, 'd').format("DD-MMM-YYYY");
        scope.serverSearch.toDate = new Date(scope.serverSearch.toDate);
        scope.dt = new Date();
    };

    scope.showCard = true;
    scope.showTemplatePopUp = false;
    scope.contract = {};
    scope.isDdlVisible = false;
    scope.isDownload = false;
    scope.childrenData = UtilitiesService.getAllChildren() === null ? [] : UtilitiesService.getAllChildren();
    scope.contractList = UtilitiesService.getContracts() === null ? [] : UtilitiesService.getContracts();
    scope.contractList1 = filterFilter(scope.contractList, {
        id: scope.childrenData
    }, function (actual, expected) {
        return filterFilter(expected, {
            'erTypeId': parseInt(actual)
        }).length > 0;
    });
    scope.contractList = scope.contractList1;

    angular.forEach(scope.user && scope.user.rolesFeatures.roles, function (v, i) {
        if (v.roleId === 9211 || v.roleId === 9214 || v.roleId === 9204) {
            scope.isDdlVisible = false;
            scope.isDownload = false;
        }
    });
    if (scope.user && scope.user.entityId) {
        if (scope.user.entityId === 1000042) {
            scope.isDdlVisible = false;
            scope.isDownload = false;
        }
    };

    //time/........................
    scope.formats = navConstantsSvc.dateFormate;
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];

    var currDate = new Date();
    var priorDate = new Date(new Date().setDate(currDate.getDate() - 90));

    scope.dateFilterDate = {
        fromDateFilter: priorDate,
        toDateFilter: currDate
    };

    scope.dateDefautOptions = {
        formatYear: 'yy',
        minDate: scope.dateFilterDate.fromDateFilter,
        startingDay: 1
    };

    scope.setMinDate = function (fromDate) {
        scope.mindate = '';
        var setMinDate = fromDate;
        setMinDate.setDate(fromDate.getDate());
        scope.mindate = setMinDate;
        scope.mindate = scope.dateFilterDate.fromDateFilter;
    };

    scope.popup5 = {
        opened: false
    };

    scope.popup6 = {
        opened: false
    };

    scope.open5 = function () {
        scope.popup5.opened = true;
        scope.dateFilterDate.toDateFilter = '';
    };

    scope.open6 = function () {
        scope.popup6.opened = true;
    };

    scope.setMinDate = function (fromDate) {
        scope.mindate = '';
        var setMinDate = fromDate;
        setMinDate.setDate(fromDate.getDate());
        scope.mindate = setMinDate;
        scope.mindate = scope.dateFilterDate.fromDateFilter;
    };
    //time/........................

    var tooltip = nv.models.tooltip();
    tooltip.duration(0);


    scope.changeChart = function (chartType) {
        if (chartType === 'pie') {
            scope.chartType.type = 'pie';
            scope.parentChart();
            scope.childChart();
        }
        else if (chartType === 'donut') {
            scope.chartType.type = 'donut';
            scope.parentChart();
            scope.childChart();
        }
        else if (chartType === 'discrete') {
            scope.chartType.type = 'discrete';
            scope.parentChart();
            scope.childChart();
        }
    };

    scope.parentChart = function () {
        //parentChart piechart
        if (scope.chartType.type === 'pie' || scope.chartType.type === 'donut') {
            scope.masterData = [];
            angular.forEach(scope.masterChartData, function (v, i) {
                var tempData = {
                    statusID: v.statusID,
                    statusCount: v.appointmentCount,
                    statusName: v.statusName
                }
                scope.masterData.push(tempData);
            })

            scope.masterOptions = {
                chart: {
                    pie: {
                        dispatch: {
                            elementClick: function (e) {
                                scope.loadChildChart(e);
                            }
                        }
                    },
                    type: 'pieChart',
                    pieSliceBorderColor: 'transparent',
                    height: 350,
                    donut: scope.chartType.type === 'pie' ? false : true,
                    x: function (d) { return d.statusName; },
                    y: function (d) { return d.statusCount; },
                    showLabels: true,
                    transitionDuration: 500,
                    duration: 500,
                    labelThreshold: 0.01,
                    labelSunbeamLayout: true,
                    legend: {
                        dispatch: {
                            legendMouseover: function (o) {
                                if (tooltip.hidden()) {
                                    var data = {
                                        series: {
                                            key: o.statusName,
                                            value: o.statusCount + ' Appointments',
                                            color: o.color
                                        }
                                    };
                                    tooltip.data(data)
                                      .hidden(false);
                                }
                            },
                            legendMouseout: function (o) {
                                tooltip.hidden(true);
                            }
                        },
                    },
                    valueFormat: function (d) {
                        return d + ' Appointments';
                    },
                    labelType: function (d) {
                        var percent = (d.endAngle - d.startAngle) / (2 * Math.PI);
                        return d3.format('%')(percent);
                    }
                }
            };
        }

        //parentChart discreate
        if (scope.chartType.type === 'discrete') {
            scope.masterData = [{
                values: []
            }];
            angular.forEach(scope.masterChartData, function (v, i) {
                var tempData = {
                    //id: '',
                    id: v.statusID,
                    statusCount: v.appointmentCount,
                    statusName: v.statusName
                }
                scope.masterData[0].values.push(tempData);
            })
            scope.masterOptions = {
                chart: {
                    discretebar: {
                        dispatch: {
                            elementClick: function (e) {
                                scope.loadChildChart(e);
                            }
                        }
                    },
                    type: 'discreteBarChart',
                    height: 350,
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 60,
                        left: 55
                    },
                    x: function (d) { return d.statusName; },
                    y: function (d) { return d.statusCount; },
                    showValues: true,
                    valueFormat: function (d) {
                        return d + ' Appointments';
                    },
                    transitionDuration: 500,
                    xAxis: {
                        axisLabel: 'X Axis'
                    },
                    yAxis: {
                        axisLabel: 'Y Axis',
                        axisLabelDistance: 30
                    }
                }
            };
        }

    };

    scope.childChart = function () {
        //childChart pie
        if (scope.chartType.type === 'pie' || scope.chartType.type === 'donut') {
            scope.childData = [];
            angular.forEach(scope.childChartData, function (v, i) {
                var tempData = {
                    id: v.statusID,
                    statusCount: v.appointmentCount,
                    statusName: v.statusName
                }
                scope.childData.push(tempData);
            })
            scope.childOptions = {
                chart: {
                    pie: {
                        dispatch: {
                            elementClick: function (e) {
                                scope.category(e);
                            }
                        }
                    },
                    type: 'pieChart',
                    height: 350,
                    donut: scope.chartType.type === 'pie' ? false : true,
                    x: function (d) { return d.statusName; },
                    y: function (d) { return d.statusCount; },
                    showLabels: true,
                    transitionDuration: 500,
                    duration: 500,
                    labelThreshold: 0.01,
                    labelSunbeamLayout: true,
                    legendPosition: 'right',
                    legend: {
                        //margin: {
                        //    top: 105,
                        //    right: 0,
                        //    bottom: 0,
                        //    left: 0
                        //},
                        dispatch: {
                            legendMouseover: function (o) {
                                if (tooltip.hidden()) {
                                    var data = {
                                        series: {
                                            key: o.statusName,
                                            value: o.statusCount + ' Appointments',
                                            color: o.color
                                        }
                                    };
                                    tooltip.data(data)
                                      .hidden(false);
                                }
                            },
                            legendMouseout: function (o) {
                                tooltip.hidden(true);
                            }
                        }
                    },
                    valueFormat: function (d) {
                        return d + ' Appointments';
                    },
                    labelType: function (d) {
                        var percent = (d.endAngle - d.startAngle) / (2 * Math.PI);
                        return d3.format('%')(percent);
                    }
                }
            };
        }

        //childChart discreate
        if (scope.chartType.type === 'discrete') {
            scope.childData = [{
                values: []
            }];
            angular.forEach(scope.childChartData, function (v, i) {
                var tempData = {
                    id: v.statusID,
                    statusCount: v.appointmentCount,
                    statusName: v.statusName
                }
                scope.childData[0].values.push(tempData);
            })
            scope.childOptions = {
                chart: {
                    discretebar: {
                        dispatch: {
                            elementClick: function (e) {
                                scope.category(e);
                            }
                        }
                    },
                    type: 'discreteBarChart',
                    height: 350,
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 60,
                        left: 55
                    },
                    x: function (d) { return d.statusName; },
                    y: function (d) { return d.statusCount; },
                    showValues: true,
                    valueFormat: function (d) {
                        return d + ' Appointments';
                    },
                    transitionDuration: 500,
                    xAxis: {
                        axisLabel: 'X Axis'
                    },
                    yAxis: {
                        axisLabel: 'Y Axis',
                        axisLabelDistance: 30
                    }
                }
            };
        }
    };

    scope.loadMasterChart = function (fromDate, toDate, getChildData, source) {
        scope.providerDetail = getChildData;
        var chartData = {};
        if (source === 'fromFilter') {
            scope.activeAppointments = [];
            scope.tabtype = '';
            scope.childParticularStatusData = '';
            scope.showHashDetails = false;
            if (fromDate || toDate) {
                if (fromDate && !toDate || !fromDate && toDate) {
                    UtilitiesService.showAlertMessage('You missed FROM or TO date kindly choose date and try again.');
                    return false;
                } else {
                    scope.fromDt = fromDate;
                    scope.toDate = toDate;
                }
            }
        }
        var childData = '';
        if (getChildData) {
            var childData = getChildData;
        }
        var contractId = scope.dashboardSearch.contractType ? (scope.dashboardSearch.contractType.id ? scope.dashboardSearch.contractType.id : '') : '';
        if (contractId) {
            chartData.searchCriteria = {
                'ContractId': contractId
            }
        }
        // var currDate = new Date();
        // var priorDate = new Date(new Date().setDate(currDate.getDate() - 90));
        currDate = currDate.toLocaleDateString('en-IN').split('/').reverse().join('-');
        priorDate = priorDate.toLocaleDateString('en-IN').split('/').reverse().join('-');
        chartData.fromDate = scope.fromDt ? scope.fromDt : priorDate,
        chartData.toDate = scope.toDate ? scope.toDate : currDate,
        chartData.dashboardType = {
            'PharmacyDashboard': childData ? childData : 'PharmacyDashboard'
        },
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/FetchDashboardAppointments', chartData, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data && response.data.dbStatusWiseApptCount && response.data.dbStatusWiseApptCount.length > 0) {
                scope.chartName = response.data.dashboardName;
                scope.chartStatusName = response.data.dbStatusWiseApptCount ? (response.data.dbStatusWiseApptCount[0] ? response.data.dbStatusWiseApptCount[0].statusName : '') : '';
                scope.dataError = '';
                if (!getChildData) {
                    scope.masterData = [];
                    scope.childData = [];
                    scope.masterChartData = [];
                    scope.totalChildStatusRecord = '';
                    scope.activeAppointments = [];
                    var masterData = response.data.dbStatusWiseApptCount;
                    scope.masterChartData = response.data.dbStatusWiseApptCount;
                    var noOfMasterStatus = masterData.length;
                    var totalMasterRecords = 0;
                    angular.forEach(masterData, function (v, i) {
                        var tempData = {
                            id: '',
                            statusCount: v.appointmentCount,
                            statusName: v.statusName
                        }
                        totalMasterRecords = totalMasterRecords + v.appointmentCount;
                        scope.masterData.push(tempData);
                    })
                    scope.totalMasterStatusRecord = 'Total ' + noOfMasterStatus + ' master status consists of ' + totalMasterRecords + ' appointments';
                    scope.masterData = [];
                    scope.masterDataPresent = true;

                    scope.parentChart();
                }
                if (getChildData) {
                    scope.childData = [];
                    scope.childChartData = [];
                    var childData = response.data.dbStatusWiseApptCount;
                    scope.childChartData = response.data.dbStatusWiseApptCount;
                    var noOfStatus = childData.length;
                    var totalChildRecord = 0;
                    angular.forEach(childData, function (v, i) {
                        var tempChildData = {
                            id: v.statusID,
                            statusCount: v.appointmentCount,
                            statusName: v.statusName
                        }
                        scope.childData.push(tempChildData);
                        totalChildRecord = totalChildRecord + v.appointmentCount;
                    })
                    scope.totalChildStatusRecord = 'Total ' + noOfStatus + ' status in ' + scope.selectedStatusName + ' consists of ' + totalChildRecord + ' appointments';
                    scope.childData = [];

                    scope.childChart();
                }
            } else {
                scope.dataError = 'No data available';
                scope.activeAppointments = [];
                scope.childData = [];
                scope.masterData = [];
                if (getChildData) {
                    scope.childData = [];
                }
                if (!getChildData) {
                    scope.masterData = [];
                }
            }
        },
        function (error) {
        });
    };

    //Get location
    scope.locationMethods = (function () {
        return {
            loadStates: function () {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + '/masterdata/lookup/state.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.states = response.data.lookUpData;
                    }
                });
            },
            loadCities: function (stateId) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/masterdata/lookup/district/' + stateId + '.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.cities = response.data.lookUpData;
                    }
                });
            },
            loadLocations: function (cityId) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/masterdata/lookup/city/" + cityId + '.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.locations = response.data.lookUpData;
                    }
                });
            },
            loadSubLocations: function (locationId) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/masterdata/lookup/location/' + locationId + '.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.sublocations = response.data.lookUpData;
                    }
                });
            },
            loadDCForTests: function (id, obj) {
                scope.testData.testSubLocalityId = id;
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'EntityRelation/Search/EntitySearch/' + scope.ERTypeId + '/' + scope.serviceBrokerId + '/' + 0 + '/' + scope.testData.testStateId + '/' + scope.testData.testCityId + '/' + scope.testData.testLocalityId + '/' + scope.testData.testSubLocalityId + '.json', '', 'get').then(function (response) {
                    if (response.statusText == 'OK') {
                        scope.allDCs = response.data;
                        scope.tempDiagnosticCentres = response.data;
                        scope.loadFilteredDc();
                    }
                });
            }
        }
    })();

    //Load Location based on type
    scope.loadLocationData = function (type, id) {
        switch (type) {
            case 'city':
                scope.locationMethods.loadCities(id);
                break;
            case 'locality':
                scope.locationMethods.loadLocations(id);
                break;
            case 'sublocality':
                scope.locationMethods.loadSubLocations(id);
                break;
            case 'dc':
                scope.locationMethods.loadDCForTests(id);
                break;
            default:
                scope.locationMethods.loadCities(id);
                break;
        }
    };

    scope.loadAppointments = function (selectedStatus, rowNo) {
        if (!selectedStatus) {
            return false;
        }
        var statusId = selectedStatus.data.id;
        var providerId, isInsurer, getid, status;
        scope.providerName = '';
        scope.providerName = scope.user.entityName;
        if (!(scope.user.entityType == 'DC')) {
            scope.showChkedOnDcLogin = true;
        }
        if (scope.providerDetail) {
            providerId = scope.providerDetail;
            scope.providerName = '';
        }
        if (!scope.daysOfAppointment || scope.daysOfAppointment == '' || scope.daysOfAppointment <= -1) {
            scope.daysOfAppointment = -1;
        }
        $rootScope.$broadcast('newCountChange', 10);
        var data = {
            providerId: providerId,
            requestType: '',
            daysOfAppointment: scope.daysOfAppointment,
            pageNo: 0,
            rows: rowNo ? rowNo : 10,
            statusId: statusId,
            contractId: '',
            fromDateOfAppointment: scope.dateFilterDate ? (scope.dateFilterDate.fromDateFilter ? scope.dateFilterDate.fromDateFilter : '') : '',
            toDateOfAppointment: scope.dateFilterDate ? (scope.dateFilterDate.toDateFilter ? scope.dateFilterDate.toDateFilter : '') : '',
            loadFullDetails: false,
            hashtagFilters: {},
            requestAccessToken: UserService.getAccessToken(),
            searchType: 0,
            userAgent: 'String',
            ipAddress: 'String'
        };
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/Appointments/', data, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data.isSuccess) {
                scope.isOpenAccordian = true;
                scope.activeAppointments = response.data;
                UserService.activeAppointmentsDummyData = response.data;
                scope.totalRows = response.data.totalRows;
                scope.isTotalRows = response.data.requests.length > 20 ? true : false;
                UserService.activeAppointmentsDummyDataCollection = response.data.requests;
                scope.childParticularStatusData = 'You have selected ' + scope.selectedStatusName + ', ( for status - ' + scope.childStatusName + ') ' + ' consists of ' + scope.activeAppointments.totalRows + ' records';
            }
        });
    };

    scope.openVarifyPresModal = function (PharmaPrescriptionData, source) {
        scope.PharmaPrescriptionList = [];
        if (source != 'reload') {
            scope.PharmaPrescriptionData = PharmaPrescriptionData;
            PharmaPrescriptionData.map(function (val) {
                scope.PharmaPrescriptionList.push({
                    filePath: val.filePath,
                    fileName: val.fileName
                });
            });
        }
        if (source == 'reload') {
            scope.PharmaPrescriptionData.map(function (val) {
                scope.PharmaPrescriptionList.push({
                    filePath: val.filePath,
                    fileName: val.fileName
                });
            });
        }
    };

    scope.searchAppointmentsGroupCtrl = function (currentRecordPerPage) {
        var fromDateOfAppoint = scope.dateFilterDate ? (scope.dateFilterDate.fromDateFilter ? scope.dateFilterDate.fromDateFilter : '') : '';
        var toDateOfAppoint = scope.dateFilterDate ? (scope.dateFilterDate.toDateFilter ? scope.dateFilterDate.toDateFilter : '') : '';
        var getStatusDetail = scope.selectedDetails.data;
        scope.searchAppointmentsGroup(getStatusDetail, '', '', fromDateOfAppoint, toDateOfAppoint, currentRecordPerPage);
    };

    scope.searchAppointmentsGroup = function (getStatus, getContract, corporateId, frmDt, toDt, rowNo, searchValue) {
        scope.showHashDetails = false;
        scope.hashData = '';
        if (frmDt && !toDt) {
            UtilitiesService.showAlertMessage('You have missed end date!');
            return false;
        }
        scope.hashtagFilters = {};
        scope.searchSource = searchValue.value;
        scope.selectedOrderType = searchValue.selectedOrderType;
        if (scope.selectedOrderType) {
            scope.showHashDetails = true;
            scope.providerDetail = '';
            if (scope.selectedOrderType == 'reqId') {
                scope.hashtagFilters = { requestid: scope.searchSource }
            } if (scope.selectedOrderType == 'email') {
                scope.hashtagFilters = { emailid: scope.searchSource }
            } if (scope.selectedOrderType == 'empId') {
                scope.hashtagFilters = { empid: scope.searchSource }
            } if (scope.selectedOrderType == 'contact') {
                scope.hashtagFilters = { contactno: scope.searchSource }
            } if (scope.selectedOrderType == 'name') {
                scope.hashtagFilters = { name: scope.searchSource }
            } if (scope.selectedOrderType == 'partnerOrderId') {
                scope.hashtagFilters = { partnerorderid: scope.searchSource }
            }
        }
        scope.rowNoFromDdl = rowNo ? rowNo : 0;
        var providerId = null;
        if (scope.providerDetail) {
            providerId = scope.providerDetail;
            scope.providerName = '';
        }
        var ajaxData = {
            providerId: providerId ? providerId : '',
            requestType: '',
            daysOfAppointment: scope.daysOfAppointment,
            pageNo: 0,
            rows: scope.rowNoFromDdl,
            statusId: getStatus ? (getStatus.id === '0' ? 0 : getStatus.id) : '',
            contractId: getContract ? (getContract.id !== '0' ? getContract.id : '') : '',
            fromDateOfAppointment: frmDt ? frmDt : '',
            toDateOfAppointment: toDt ? toDt : '',
            loadFullDetails: false,
            hashtagFilters: scope.hashtagFilters,
            requestAccessToken: UserService.getAccessToken(),
            userAgent: 'String',
            searchType: 1,
            ipAddress: 'String'
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/Appointments/', ajaxData, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data.isSuccess) {
                scope.isOpenAccordian = true;
                scope.tabtype = 'Active Appointments';
                scope.activeAppointments = response.data;
                UserService.activeAppointmentsDummyData = response.data;
                scope.totalRows = response.data.totalRows;
                scope.isTotalRows = response.data.requests.length > 20 ? true : false;
                UserService.activeAppointmentsDummyDataCollection = response.data.requests;
                if (!scope.showHashDetails) {
                    scope.childParticularStatusData = 'You have selected ' + scope.selectedStatusName + ', ( for status - ' + scope.childStatusName + ') ' + ' consists of ' + scope.activeAppointments.totalRows + ' records';
                }
                if (scope.showHashDetails) {
                    if (scope.hashtagFilters && Object.keys(scope.hashtagFilters).length > 0) {
                        var keyData = Object.keys(scope.hashtagFilters);
                        var valueData = scope.hashtagFilters[keyData];
                        scope.showHashDetails = true;
                        scope.hashDetails = 'Results for ' + keyData[0] + ' - ' + valueData;
                    }
                }
            }
        });
    };

    scope.removePrescriptions = function (indx) {
        scope.PharmaPrescriptionList.splice(indx, 1);
    };

    //verify presription before final submittion
    scope.verifyPrescription = function (urls) {
        scope.UrlList = urls;
        if (scope.UrlList) {
            scope.finalUrl = [];
            angular.forEach(urls, function (v, i) {
                var setUrl = v.filePath;
                scope.finalUrl.push(setUrl);
            })
            var data = {
                "requestId": $rootScope.requestIdForActiveAppointmnents,
                "updatePrescriptionURLs": scope.finalUrl,
                "isReplace": true
            }
            var url = UtilitiesService.getPlusUrlPrefix() + "UploadPharmaCashlessPrescription/";
            UserService.makeRestCall(url, data, "POST", UserService.getAccessToken()).then(function (response) {
                if (response.data) {
                    scope.uploadedIsSuccess = response.data
                    UtilitiesService.showAlertMessage('Files updated Successfully', true);
                    $('#openVarifyPres').modal("hide");
                }
            },
            function (error) {
                UtilitiesService.showAlertMessage('issue in verify url.');
            })
        }
    };

    scope.category = function (selectedStatus) {
        scope.showCard = false;
        scope.selectedDetails = selectedStatus;
        scope.childStatusName = selectedStatus.data.statusName;
        scope.statusName = scope.selectedStatusName;
        if (selectedStatus && selectedStatus.data.statusName !== '') {
            scope.printStatusName = scope.childStatusName;
            scope.tabtype = 'Active Appointments';
            scope.loadAppointments(scope.selectedDetails);
        }
    };

    scope.loadChildChart = function (selectedStatus) {
        scope.selectedStatusName = selectedStatus.data.statusName;
        var selectedStatusChild = selectedStatus.data.statusID ? selectedStatus.data.statusID : selectedStatus.data.id;
        //var selectedStatusChild = selectedStatus.data.id;
        //scope.allAppointments = [];
        scope.activeAppointments = [];
        //scope.pbqueue = [];
        scope.tabtype = '';
        scope.childParticularStatusData = '';
        scope.showHashDetails = false;
        if (scope.fromDt && scope.toDate) {
            scope.loadMasterChart(scope.fromDt, scope.toDate, selectedStatusChild);
        } else {
            scope.loadMasterChart('', '', selectedStatusChild);
        }
    };

    //display wallet balance
    scope.showWalletBalance = function (balance, isSuccess) {
        scope.isSuccess = isSuccess;
        scope.showWalletBalanceMsz = isSuccess === true ? 'Rs. ' + balance + '/-' : balance;
        var modalInstance = $uibModal.open({
            animation: scope.animationsEnabled,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: "walletModal.html",
            controller: 'appointmentsController',
            scope: scope,
        });
    };

    //Open Action popup
    scope.openRespectiveActionModal = function (actionName, currentStatusId, actionStatusId, requestId, appointmentDate, secondAppointmentDate, orderItemProductId, requestData) {
        //First time limit
        scope.requestData = requestData;
        scope.action.partnerOrderId = '';
        scope.pharmaData.cashlessAmt = '';
        scope.pharmaData.CODAmt = '';
        scope.resetTime();
        scope.showDcSelection();
        scope.actionId = actionStatusId;
        scope.client.prefDate = UtilitiesService.getDateObj(appointmentDate);
        scope.actionName = actionName;
        scope.action.showdcselection = false;
        scope.action.remarks = '';
        scope.action.feedback = '';
        scope.action.statusId = currentStatusId;
        scope.action.nextStatusId = actionStatusId;
        scope.action.requestId = requestId;
        scope.action.date = appointmentDate;
        scope.action.visibleDate = scope.compareDate(appointmentDate);
        scope.action.visibleTime = scope.action.visibleDate + " " + scope.formatTime(appointmentDate);
        scope.action.secondPreferredTime = secondAppointmentDate;
        scope.secondPreferredVTime = scope.compareDate(secondAppointmentDate) + " " + scope.formatTime(secondAppointmentDate);
        scope.action.productId = orderItemProductId;
        //empty all modals

        if (scope.actionName == 'Fit' || scope.actionName == 'UnFit') {
            if (scope.action.remarks) {
                scope.action.remarks.fit = '';
                scope.selectedBloodGrp = '';
            }
        }
        if (scope.actionName == 'Reschedule') {
            scope.locationMethods.loadStates();
            scope.form.dod = '';
            scope.action.showdcselection = false;
            scope.testData.testStateId = '';
            scope.testData.testCityId = '';
            scope.testData.testLocalityId = '';
        }
        if (scope.actionName == 'Confirm') {
            scope.action.spocname = '';
            scope.action.spocphone = '';
            scope.action.dcPrice = '';
        }
        if (scope.actionName == 'Cancel') {
            scope.action.visibleTime = scope.action.visibleDate + ' ' + scope.compareDate(scope.action.date);
        }
        if (scope.actionName == 'Approve' || scope.actionName == 'NotAttended' || scope.actionName == 'Raise_IA') {
            scope.action.remarks = "";
        }
        if (scope.actionName == 'Attended') {
            scope.actualdate = '';
            scope.action.remarks = '';
            scope.action.feedback = '';
        }
        if (scope.actionName == 'Submit') {
            scope.reports = [];
            scope.bills = [];
            scope.attachFiles.reports = {};
            scope.attachFiles.bills = {};
            scope.action.remarks = '';
        }
        if (scope.actionName == 'PlaceWithPartner') {
            scope.partnerOrderId = '';
        }
        if (scope.actionName == 'Delivered') {
            scope.pharmaData.cashlessAmt = '';
            scope.pharmaData.CODAmt = '';
        }
    };

    scope.reload = function () {
        scope.pageNo = 0;
        scope.rowCount = 10;
        scope.statusData = '';
        scope.dateFilterDate = {};
        scope.fromDt = '';
        scope.toDate = '';
        scope.activeAppointments = [];
        scope.childParticularStatusData = '';
        scope.tabtype = '';
        scope.childChartData = [];
        scope.hashDetails = '';
        scope.childParticularStatusData = '';
        scope.dashboardSearch.contractType = '';
        scope.loadMasterChart();
        $rootScope.$emit('reloadSearchPharma');
    };

    scope.showDcSelection = function (value, source) {
        scope.action.showdcselection = !!value;
        if (source === 'dcVisit') {
            scope.action.showHomeVisitSelection = false;
            scope.homeVisit = [];
            if (scope.action.showdcselection === false) {
                scope.testData.testStateId = '';
                scope.testData.testCityId = '';
                scope.testData.testLocalityId = '';
                scope.testData.testSubLocalityId = '';
                scope.testData.dcValue = '';
                scope.selectedDcs = [];
            }
        }
        if (source === 'homeVisit') {
            scope.action.showdcselection = false;
            scope.testData.testStateId = '';

            scope.cities = [];
            scope.testData.testCityId = '';

            scope.locations = [];
            scope.testData.testLocalityId = '';

            scope.sublocations = [];
            scope.testData.testSubLocalityId = '';

            scope.diagnosticCentres = [];
            scope.testData.dcValue = '';
        }
    };

    scope.setFilesUpload = function (element) {
        $("#uploadTemplates").attr("disabled", "disabled");
        if (window.FormData) {
            formdata = new FormData();
        }
        file = element.files[0];
        if (formdata) {
            formdata.append("reports[]", file);
            formdata.append("userEntityId", UserService.getUserObj().entityId);
            formdata.append("contractId", scope.setContractIdForUpload);
        }

        $.ajax({
            url: UtilitiesService.getPlusUrlPrefix() + "UploadExcelOrders.json",
            type: "POST",
            data: formdata,
            headers: {
                "AccessToken": UserService.getAccessToken()
            },
            processData: false,
            contentType: false,
            success: function (res) {
                if (res.isSuccess) {
                    if(res.errorMessage){
                        UtilitiesService.showAlertMessage(res.errorMessage);
                    }else{
                        UtilitiesService.showAlertMessage('Appointments created Successfully! You will be able to see in active appointments, once it is approved by our operations person.', true);
                    }
                }
                else {
                    UtilitiesService.showAlertMessage('Appointment creation failed.');
                    scope.failedFileName = res.fileName;
                }
                $("input#uploadTemplates").val("");
                $("#uploadTemplates").removeAttr("disabled");
                $("#uploadTemplates").attr('value', '');
                scope.$apply();
            }

        });
        return false;
    };

    scope.actionRequest = function (actionType, event) {
        if ((scope.requestData.productType === 10307 || scope.requestData.productType === 10390) && scope.requestData.providerId === 177324) {
            scope.createRequestForPharma(actionType, scope.action.nextStatusId, scope.action.requestId, scope.action.statusId, scope.requestData);
        } else if (scope.requestData && scope.requestData.additionalInformation) {
            if ((scope.requestData.additionalInformation.productType === 10307 || scope.requestData.additionalInformation.productType === 10390) && scope.requestData.additionalInformation.providerId === 177324) {
                scope.createRequestForPharma(actionType, scope.action.nextStatusId, scope.action.requestId, scope.action.statusId, scope.requestData.additionalInformation);
            } else {
                scope.createRequest('Appointment', scope.action.statusId, scope.action.nextStatusId, scope.action.requestId, actionType, scope.action.spocname, scope.action.spocphone, event);
            }
        } else {
            scope.createRequest('Appointment', scope.action.statusId, scope.action.nextStatusId, scope.action.requestId, actionType, scope.action.spocname, scope.action.spocphone, event);
        }
    };

    //Next possible action for request call
    scope.createRequest = function (requestType, statusId, nextStatusId, requestId, actionType, spocname, spocphone, event) {
        var patientname = scope.selectedPatientName;
        var id = requestId; //scope.selectedRequestId;
        var appDate = scope.action.date;
        scope.client.prefDate = UtilitiesService.mergeDateTimeObj(scope.client.prefDate, scope.client.prefTime);
        var providerId = null;
        var providerName = "";
        var remarksComment = scope.action.remarks;
        var additionalParams = {};
        switch (actionType) {
            case 'Reschedule':
                appDate = scope.client.prefDate;
                if (scope.selectedDcs.length > 0 && !(scope.user.entitytype == 'dc')) {
                    providerId = _.first(scope.selectedDcs).id;
                    providerName = _.first(scope.selectedDcs).entityName;
                }
                break;
            case 'Cancel':
                appDate = scope.action.date;
                remarksComment = scope.action.cancelReason == 'Other' ? scope.action.cancelComments : scope.action.cancelReason;
                break;
            case 'Confirm':
                additionalParams.Price = scope.action.dcPrice;
                break;
            case 'Fit':
                additionalParams.bloodGroup = scope.selectedBloodGrp;
                break;
            case 'UnFit':
                additionalParams.bloodGroup = scope.selectedBloodGrp;
                break;
            case 'Delivered':
                break;
            case 'OutForDelivery':
                break;
            case 'ConfirmByRetailer':
                break;
            default:
                appDate = scope.action.date;
                break;
        }
        scope.selectedDcs = [];
        var requestData = {
            request: {
                requestId: requestId,
                currentStatusId: statusId,
                remarks: remarksComment,
                ScheduledAppointmentDate: appDate,
                requestedNextActionId: nextStatusId,
                attachFiles: scope.attachFiles,
                providerId: providerId,
                providerName: providerName,
                spocName: spocname,
                spocContactNo: spocphone,
                additionalParameters: additionalParams,
                addressLine1: scope.homeVisit.addressLineOne ? scope.homeVisit.addressLineOne : '',
                addressLine2: scope.homeVisit.addressLinTwo ? scope.homeVisit.addressLinTwo : '',
                isHomeVisit: scope.action.showHomeVisitSelection === true ? true : false,
                userFeedback: scope.action.feedback ? scope.action.feedback : ''
                
            },
            requestAccessToken: UserService.getAccessToken(),
            userAgent: 'String',
            ipAddress: 'String'
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/request", requestData, "post").then(function (response) {
            var targetModal = event.target.parentNode;
            scope.resetTime();
            scope.testData.testStateId = '';
            scope.testData.testCityId = '';
            scope.testData.testLocalityId = '';
            scope.testData.testSubLocalityId = '';
            scope.dcValue = '';
            scope.selectedDcs = [];
            scope.selectedBloodGrp = '';
            scope.newlyUploadedReports = [];
            scope.newlyUploadedBills = [];
            scope.today();
            while (!targetModal.classList.contains("modal")) {
                targetModal = targetModal.parentNode;
            }
            $("#" + actionType + "Modal").modal("hide");
            scope.loadAppointments();
            if (scope.attachFiles) {
                if (scope.attachFiles.reports) {
                    scope.attachFiles.reports = {};
                }
                if (scope.attachFiles.bills) {
                    scope.attachFiles.bills = {};
                }
            }
            scope.action = {};
        });
    };

    scope.medicalTestMethods = (function () {
        scope.relatedTests = [];
        scope.tempBucket = [];
        scope.groups = [[]];
        return {
            splitRequests: function (getGrps) {
                var dataObj = [];
                var restObj = [];
                angular.forEach(scope.relatedTests, function (ind, val) {
                    var obj = [];
                    ind.providerId = scope.originalDcDetails.providerId,
                    ind.providerName = scope.originalDcDetails.providerName,
                    ind.appointmentDate = scope.originalDcDetails.providerAppointmentDate,
                    ind.visitType = scope.originalDcDetails.providerVisitType
                    scope.groups[0].push(ind)
                })
                angular.forEach(scope.groups, function (buckets, i) {
                    angular.forEach(buckets, function (test, ib) {
                        var obj = {};
                        if (i == 0) {
                            obj = {
                                productId: test.id,
                                providerId: test.providerId,
                                providerName: test.providerName,
                                appointmentDate: test.appointmentDate,
                                visitType: test.visitType,
                                groupId: 0
                            }
                        }
                        else {
                            obj = {
                                productId: test.id,
                                providerId: parseInt($("#dcid_" + i).val()),
                                providerName: $("#dcid_" + i + " option:selected").text(),
                                appointmentDate: $("#datetime_" + i).val(),
                                visitType: $("#visittype_" + i + " option:selected").text(),
                                groupId: i
                            }
                        }
                        dataObj.push(obj)
                    })
                })
                var data = {
                    requestId: $rootScope.requestIdForActiveAppointmnents,
                    details: dataObj
                }
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/SplitRequest/', data, 'POST', UserService.getAccessToken()).then(function (response) {
                    scope.relatedTests = [];
                    scope.tempBucket = [];
                    scope.groups = [[]];
                    scope.originalDcDetails = {};
                });
            },
            addTestToPermanentBucket: function () {
                scope.disableTempCreate = false;
                scope.desableLocation = true;
                $(scope.tempBucket).each(function (i, v) {
                    v.groupId = scope.groups.length;
                })
                scope.groups.push(scope.tempBucket);
                scope.tempBucket = [];
            },
            removeFromGroups: function (removeItem) {
                removeItem.checkTest = false;
                $.each(scope.groups, function (i, val) {
                    if (val.indexOf(removeItem) != -1) {
                        scope.relatedTests.push(removeItem);
                        val.splice(val.indexOf(removeItem), 1);
                        return true;
                    }
                })
            },
            addTestToTempBucket: function (checkedItem) {
                checkedItem.checkTest = true;
                scope.tempBucket.push(checkedItem);
                scope.relatedTests.splice(scope.relatedTests.indexOf(checkedItem), 1)
            },
            removeBucketFromGroup: function (index) {

                $(scope.groups[index]).each(function (i, v) {
                    v.groupId = 0;
                    v.checkTest = false;
                    scope.relatedTests.push(v);
                });
                scope.groups.splice(index, 1)
            },
            getTestsForPackage: function (productId, reqtId, providerId, providerName, appointmentDate, visitType) {
                scope.action.productId = productId;
                scope.originalDcDetails.providerId = providerId;
                scope.originalDcDetails.providerName = providerName;
                scope.originalDcDetails.appointmentDate = appointmentDate;
                scope.originalDcDetails.visitType = visitType;
                scope.groups = [[]];
                scope.testData.testStateId = "";
                scope.cities = {};
                scope.locations = {};
                scope.sublocations = {};
                scope.allDCs = {}
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/' + productId, '', 'GET', UserService.getAccessToken()).then(function (response) {
                    if (response.data) {
                        scope.requestId = reqtId;
                        scope.relatedTests = {};
                        if (scope.tempBucket.length > 0) {
                            scope.tempBucket = [];
                        }
                        scope.relatedTests = response.data.allowedInvestigations;
                        scope.testsObj = {};
                        angular.forEach(scope.relatedTests, function (i, v) {
                            scope.testsObj[v.id] = v;
                        })
                    }
                });
            },
            removeFromBucket: function (checkedItem) {
                checkedItem.checkTest = false;
                scope.relatedTests.push(checkedItem);
                scope.tempBucket.splice(scope.tempBucket.indexOf(checkedItem), 1)
            }
        };
    })();

    scope.placeWithPartner = function () {
        var data = {
            RequestId: scope.action.requestId,
            PartnerOrderId: scope.action.partnerOrderId
        };
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/requestPharmaOrder', data, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data == true) {
                UtilitiesService.showAlertMessage('Order has been placed Successfully.', true);
                $('#PlaceWithPartnerModal').modal('hide');
            }
            if (response.data == false) {
                UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to place order.');
                $('#PlaceWithPartnerModal').modal('hide');
            }
        })
    };

    //Search by
    $rootScope.$on('searchBy', function (key, value) {
        scope.showCard = false;
        scope.childData = [];
        scope.searchAppointmentsGroup('', '', '', '', '', '', value);
    });

    scope.loadMasterChart();

}]);

angular.module('mbplus')
  .controller('opPackagesCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', '$analytics', '$anchorScroll', 'ProfileService', '$sce', '$http', function (scope, $location, UserService, UtilitiesService, $analytics, $anchorScroll, ProfileService, $sce, $http) {
    $analytics.pageTrack('/opPackages');
    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
      UserService.destroyUserObj();
      $location.path('/');
      return false;
    }
    scope.age = {
      max: 60,
      min: 0
    };
    scope.minAge = [];
    scope.maxAge = [];
    scope.minAge.push({
      id: '0',
      entityName: 'All Appointment Type'
    });
    scope.maxAge = [];
    scope.quoteData = JSON.parse(JSON.stringify(ProfileService.quoteData));
    scope.isChangeView = false;
    scope.changeView = function () {
      scope.isChangeView = !scope.isChangeView
    };
    scope.ismeridian = false;
    scope.hstep = 1;
    scope.mstep = 1;
    scope.profile = {
      firstTime: '',
      secondTime: ''
    }

    scope.daysName = JSON.parse(JSON.stringify(ProfileService.daysName));
    scope.showSync = ProfileService.checkRole(9202);

    scope.loadHospitalProfile = function () {
      ProfileService.loadProviderProfileDataByKey('profile',{}).then(function (response) {
        if (response) {
          scope.hospProfile = response;
          var splitDays = scope.hospProfile.hospPackageAvailableDays ? scope.hospProfile.hospPackageAvailableDays.split(',') : '';
          var MinTimeHr = Math.floor(parseInt(scope.hospProfile.hospPackageAvailableMinTime) / 60);
          var MinTimeMin = parseInt(scope.hospProfile.hospPackageAvailableMinTime) % 60;
          var MaxTimeHr = Math.round(parseInt(scope.hospProfile.hospPackageAvailableMaxTime) / 60);
          var MaxTimeMin = parseInt(scope.hospProfile.hospPackageAvailableMaxTime) % 60;
          scope.profile.firstTime = new Date();
          scope.profile.firstTime.setHours(07);
          scope.profile.firstTime.setMinutes(00);
          scope.profile.secondTime = new Date();
          scope.profile.secondTime.setHours(11);
          scope.profile.secondTime.setMinutes(00);
          if (MinTimeHr && MinTimeMin) {
            scope.profile.firstTime.setHours(MinTimeHr);
            scope.profile.firstTime.setMinutes(MinTimeMin);
          }
          if (MaxTimeHr && MaxTimeMin) {
            scope.profile.secondTime.setHours(MaxTimeHr);
            scope.profile.secondTime.setMinutes(MaxTimeMin);
          }
          scope.quoteData = scope.hospProfile.hospAutoQuotaForMA ? scope.hospProfile.hospAutoQuotaForMA : scope.quoteData;
          angular.forEach(splitDays, function (key, value) {
            angular.forEach(scope.daysName, function (key1, value1) {
              if (key === key1.name) {
                scope.daysName[value1].checked = true;
              }
            });
          });
        }
      });
    };
    scope.loadHospitalProfile();
    scope.currentPage = 1;
    scope.itemsPerPage = 10;
    scope.maxSize = 5;
    scope.pageChange = function (val) {
      scope.currentPage = val;
      scope.packagesMethods.loadPackages();
    }
    scope.updateHospitalProfileDetails = function () {
      var selectedDays = '';
      angular.forEach(scope.daysName, function (key, value) {
        if (key.checked === true) {
          selectedDays = selectedDays + key.name + ',';
        }
      });
      selectedDays = selectedDays.substring(0, selectedDays.lastIndexOf(','));
      var data = {
        "hospitals": {
          "id": scope.hospProfile.id,
          "hospitalId": UserService.getHospitalObj().hospId,
          "hospitalName": scope.hospProfile.hospitalName,
          "hospitalAddress": scope.hospProfile.hospitalAddress,
          "hospitalLandmark": scope.hospProfile.hospitalLandmark,
          "hospitalPinCode": parseInt(scope.hospProfile.hospitalPinCode),
          "hospitalLandlineNumber": scope.hospProfile.hospitalLandlineNumber,
          "hospitalFaxNumber": parseInt(scope.hospProfile.hospitalFaxNumber),
          "hospitalMobileNumber": parseInt(scope.hospProfile.hospitalMobileNumber),
          "hospitalEmailAddress": scope.hospProfile.hospitalEmailAddress,
          "hospitalPrimaryContactName": scope.hospProfile.hospitalPrimaryContactName,
          "hospitalPrimaryContactNumber": scope.hospProfile.hospitalPrimaryContactNumber,
          "hospitalPrimaryContactEmail": scope.hospProfile.hospitalPrimaryContactEmail,
          "hospitalSecondaryContactName": scope.hospProfile.hospitalSecondaryContactName,
          "hospitalSecondaryContactNumber": scope.hospProfile.hospitalSecondaryContactNumber,
          "hospitalSecondaryContactEmail": scope.hospProfile.hospitalSecondaryContactEmail,
          "hospitalWebsite": scope.hospProfile.hospitalWebsite,
          "wavedoffDays": scope.hospProfile.wavedoffDays.Value,
          "rohiniID": scope.hospProfile.rohiniID,
          "hospRegtFee": scope.hospProfile.hospRegtFee,
          "hospAccreditations": '',
          "modifiedBy": UserService.getUserObj().userId,
          "hospPackageAvailableDays": selectedDays,
          'hospPackageAvailableMinTime': scope.profile.firstTime,
          'hospPackageAvailableMaxTime': scope.profile.secondTime,
          'hospAutoQuotaForMA': scope.quoteData,
          'isActive' : true
        }
      }
      ProfileService.updateProviderProfileDataByKey('profile',data).then(function(response) {
        if(response){}
      })
    };
    scope.addPackage = false;
    scope.editPackage = false;
    scope.profileMethods = UtilitiesService.scrollTo();
    scope.isRequired = true;
    scope.selectedTest = function () {
      var testsTobeIncluded = [];
      var abc = [];
      abc = scope.testProfiles.map(function (item) {
        if (item.inclusions && item.inclusions.length > 0)
          return item.inclusions.map(function (e) {
            return e.toString()
          });
      }).filter(function (el) {
        return el
      });
      abc.forEach(function (e) {
        testsTobeIncluded = testsTobeIncluded.concat(e);
      });
      scope.isRequired = testsTobeIncluded.length === 0 ? true : false;
    };
    scope.onSelectConsultation = function (key) {
      if (key) {

      }
    };
    scope.onFocusConsultation = function () {
      scope.placeholderText = 'type';
      scope.searchCondition = [];
    };
    scope.selectedTestToShow = [];
    scope.totalItem = 0;
    scope.currentPage = 1;
    scope.$watch('example15model', function (key, value) {
      if (key && key.length > 0) {
        scope.selectedTestToShow = _.filter(scope.example15data, function (a) {
          return _.find(key, function (b) {
            return b.id === a.id;
          });
        });
        scope.selectedTestToShow = _.uniq(scope.selectedTestToShow);
        scope.totalItem = scope.selectedTestToShow.length;
      } else {
        scope.selectedTestToShow = [];
        scope.totalItem = 0;
      }
    }, true);
    scope.getconsultation = function (val) {
      scope.example15data = [];
      var url = UtilitiesService.getUrlPrefix() + "/provider/GetInvestigationsByGroupId.json";
      var data = {
        "groupId": 0,
        "testName": ''
      };
      // UserService.makeRestCall(url, data, 'POST').then(function (response) {
      //   if (response.data.investigations.length !== 0) {
      //     scope.example15data = response.data.investigations;
      //   }
      // });
    };


    //
    // JavaScript
    scope.getconsultation();
    scope.example15model = [];
    //scope.example15data = scope.getconsultation();
    scope.example15settings = {
      enableSearch: true,
      displayProp: 'name',
      scrollable: true,
      scrollableHeight: 400,
      showCheckAll: false
    };

    scope.customFilter = '';

    //
    scope.editPack = {
      minAge: '',
      maxAge: ''
    }

    scope.selectedData = [];
    scope.onSelectResult = function ($item, $model, $label) {
      scope.selectedData.push($item);
      scope.asyncSelected = '';
    };

    scope.ageCalculater = function (value, type, inValidValue) {
      if (value) {
        if (type === 'max') {
          scope.maxAgeValue = value;

        } else if (type === 'min') {
          scope.minAgeValue = value;
        }
      }
    };


    scope.packagesMethods = (function () {
      return {
        loadPackages: function () {
          scope.packages = [];
          ProfileService.loadProviderPackagesByKey('OP',{"pageNumber"	:	scope.currentPage ,"range"	:	10}).then(function (response) {
            if (response.packagesDetails) {
              angular.forEach(response.packagesDetails, function (e, i) {
                var tempObj = {
                  id: e.id,
                  packageNo: e.packageNo,
                  packageName: e.packageName,
                  packagePrice: parseInt(e.packagePrice),
                  packageMADiscount: e.packageMADiscount,
                  packageMAPrice: parseInt(e.packageMAPrice),
                  inclusions: e.hospInclusions,
                  description: e.description,
                  // packageContents: UtilitiesService.groupBy(e.packageContents, "groupName"),
                  packageAddedOn: new Date(UtilitiesService.getDateObj(e.createdOn)),
                  packageLastUpdated: new Date(UtilitiesService.getDateObj(e.modifiedOn)),
                  isVerified: e.isVerified,
                  instructions: e.hospInstructions,
                  gender: e.gender,
                  ages: e.packageAges,
                  maxAge: Math.max.apply(null, e.packageAges.map(function (item) {
                    return item.maxAge;
                  })),
                  minAge: Math.min.apply(null, e.packageAges.map(function (item) {
                    return item.minAge;
                  }))

                }
                angular.forEach(tempObj.packageContents, function (ele, itr) {
                  ele.inclusionHtml = $sce.trustAsHtml(ele.map(function (elem) {
                    return elem.name;
                  }).join("<span> | </span>"));
                });
                scope.packages.push(tempObj);
              });
              scope.totalItems = response.totalCount;
              scope.packages.sort(UtilitiesService.dynamicSort("packageName"));
            }
          })
        },
        openAddPackageModal: function (isEdit) {
          scope.example15model = [];
          scope.addPackage = false;
          scope.editPackage = false;
          scope.editPack = {};
          scope.testProfiles = [];
          scope.categories = [];
          scope.instructions = JSON.parse(JSON.stringify(ProfileService.instructions));
          scope.checkModel = {
            ageZeroToThirty: true,
            ageThirtyOneToFortyFive: true,
            ageFortySixToFiftyFive: true,
            ageFiftySixToSixtyFive: false,
            ageSixtySixToHundred: false
          };
          scope.radioModel = 'BOTH';
          var promise = UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/GetOpInvestigationsByCount.json", "", "POST").then(function (response) {
            if (response.data.isSuccess) {
              var testProfiles = response.data.opInvestigations;
              angular.forEach(testProfiles, function (e, i) {
                var temp = {
                  profileId: e.groupId,
                  profileName: e.groupName,
                  profileNameCount: e.count
                }
                scope.testProfiles.push(temp);
                scope.categories.push({});
              });
              scope.testProfiles.sort(UtilitiesService.dynamicSort("profileName"));
              if (!isEdit) {
                scope.addPackage = true;
                //scope.packagesMethods.addNewInstruction();
                UtilitiesService.scrollTo('addPackage');
              } else {
                scope.editPackage = true;
              }
            }
          }, function (error) {
            // console.log("Error : " + error);
          });
          promise.catch(function (error) {
            if (error.status == 403 && error.statusText == "Forbidden") {
              alert('No Access');
            }
          })
          return promise;
        },
        openPkgDetailsModal: function (e) {
          scope.indvidualPackage = e;
        },
        openPackageDetails: function (e) {
          scope.packagesMethods.openAddPackageModal(true)
            .then(function () {
              scope.testProfiles.map(function (ele) {
                angular.forEach(e.packageContents, function (el, i) {
                  if (ele.profileId == el[0].groupId) {
                    ele.count = el.length;
                    ele.inclusionHtml = $sce.trustAsHtml(el.map(function (item) {
                      return item.name;
                    }).join("<span> | </span>"));
                    ele.inclusions = el.map(function (item) {
                      return parseInt(item.id);
                    });
                  }
                });
              });
              scope.packageName = e.packageName;
              scope.editPack = {
                id : e.id,
                packageName: e.packageName,
                packageNo: e.packageNo,
                price: e.packagePrice,
                discount: e.packageMADiscount,
                maPrice: e.packageMAPrice,
                description: e.description,
                inclusions: e.inclusions,
                packageNo: e.packageNo,
                packageContents: e.packageContents,
                instructions: e.hospInstructions,
                maxAge: e.maxAge,
                minAge: e.minAge
              };
              scope.radioModel = e.gender.trim();
              e.ages.forEach(function (elem) {
                if (elem.minAge == "0")
                  scope.checkModel.ageZeroToThirty = true;
                if (elem.minAge == "19")
                  scope.checkModel.ageThirtyOneToFortyFive = true;
                if (elem.minAge == "31")
                  scope.checkModel.ageFortySixToFiftyFive = true;
                if (elem.minAge == "41")
                  scope.checkModel.ageFiftySixToSixtyFive = true;
                if (elem.minAge == "66")
                  scope.checkModel.ageSixtySixToHundred = true;
              });
              scope.showPackage = true;
              UtilitiesService.scrollTo('openPackageDetails');
              // scope.instructions = JSON.parse(JSON.stringify(ProfileService.instructions));
              scope.example15model = [];
              angular.forEach(e.inclusions, function (key, value) {
                var data = {
                  id: parseInt(key)
                };
                scope.example15model.push(data);
              });
              if (e.instructions && e.instructions.length > 0 && !(e.instructions.length == 1 && e.instructions[0] == ""))
              scope.instructions = [];
                e.instructions.forEach(function (elem) {
                  var temp = {
                    instruction: elem
                  };
                  scope.instructions.push(temp);
                });
            });
        },
        closeEditPackageModal: function () {
          scope.showPackage = false;
          scope.addPackage = false;
          scope.editPackage = false;
        },
        isSyncValid: function (e) {
          if (e && e.inclusions.length && !e.isVerified && e.packagePrice && e.packageMAPrice && e.maxAge && e.minAge && e.packageName && e.gender) {
            return true
          }
          else return false
        },
        syncHealthChkData: function (e) {
          var data = JSON.parse(JSON.stringify(e)) ;
          data.hospitalID = UserService.getHospitalObj().hospId;
          data.hospInclusions = e.inclusions;
          data.hospInstructions = e.instructions;
          data.packageAges = e.ages;

          UserService.makeRestCall(UtilitiesService.getPlusUrl() + "/Provider/Profile/HospitalPackageSync", data, "POST", UserService.getAccessToken()).then(function (response) {
            if (response.data.isSuccess) {
              e.isVerified = true;
              scope.packagesMethods.loadPackages();
            }
          })
        },
        showSyncPending: function () {
          var p = JSON.parse(JSON.stringify(scope.packages));
          scope.packages = [];
          p.forEach(function (e) {
            if (scope.packagesMethods.isSyncValid(e)) {
              scope.packages.push(e);
            }
          })
          scope.totalItems = scope.packages.length;
          scope.currentPage = 1;
        },
        getInvestigationsForProfile: function (index, isEdit) {
          var profileId = scope.testProfiles[index].profileId;
          scope.indexOfTests = index;
          scope.profileName = scope.testProfiles[index].profileName;
          if (!scope.categories[index].length) {
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/provider/GetInvestigationsByGroupId/" + profileId + ".json", "", "GET").then(function (response) {
              if (response.data) {
                scope.categories[index] = response.data.investigations;
                scope.categories[index].map(function (e) {
                  e.descriptionHTML = $sce.trustAsHtml(e.description);
                  if (isEdit) {
                    scope.editPack.inclusions.filter(function (elem) {
                      if (e.id == parseInt(elem)) {
                        e.isIncluded = true;
                      }
                    });
                  }
                });
                scope.categories[index].sort(UtilitiesService.dynamicSort("name"));
              }
            }, function (error) {
              // console.log("Error : " + error);
            });
          }
        },
        closeSelectTests: function () {
          scope.categories[scope.indexOfTests].map(function (obj) {
            obj.isIncluded = false;
            return obj;
          });
          scope.testProfiles[scope.indexOfTests].count = 0;
          scope.testProfiles[scope.indexOfTests].inclusionHtml = undefined;
          scope.testProfiles[scope.indexOfTests].inclusions = undefined;
          scope.selectedTest();
        },
        selectTests: function () {
          var selectedArr = scope.categories[scope.indexOfTests].filter(function (item) {
            return item.isIncluded == true;
          });
          scope.testProfiles[scope.indexOfTests].count = selectedArr.length;
          scope.testProfiles[scope.indexOfTests].inclusions = selectedArr.map(function (item) {
            return item.id;
          });
          scope.testProfiles[scope.indexOfTests].inclusionHtml = $sce.trustAsHtml(selectedArr.map(function (item) {
            return item.name;
          }).join("<span> | </span>"));
          scope.selectedTest();
        },
        calculateDiscount: function () {
          if (scope.editPack.price && scope.editPack.maPrice) {
            if (scope.editPack.maPrice >= scope.editPack.price) {
              scope.editPack.discount = 0;
            } else {
              scope.editPack.discount = parseFloat(((scope.editPack.price - scope.editPack.maPrice) / scope.editPack.price) * 100).toFixed(2);
            }
          } else {
            scope.editPack.discount = 0;
          }
        },
        addNewInstruction: function () {
          var temp = {
            instruction: ''
          }
          scope.instructions.push(temp);
        },
        removeInstruction: function ($index) {
          scope.instructions.splice($index, 1);
        },
        setGender: function (value) {
          scope.radioModel = value;
        },
        restoreOriginal: function () {
          scope.categories[scope.indexOfTests].map(function (ele) {
            ele.isIncluded = undefined;
            if (scope.testProfiles[scope.indexOfTests].inclusions) {
              scope.testProfiles[scope.indexOfTests].inclusions.filter(function (e) {
                if (ele.id == e) {
                  ele.isIncluded = true;
                }
              });
            }
          });
          scope.selectedTest();
        },
        addNewPackage: function (isUpdate) {
          // var testsTobeIncluded = [];
          // var abc = [];
          // abc = scope.testProfiles.map(function (item) {
          //   if (item.inclusions && item.inclusions.length > 0)
          //     return item.inclusions.map(function (e) {
          //       return e.toString()
          //     });
          // }).filter(function (el) {
          //   return el
          // });
          // abc.forEach(function (e) {
          //   testsTobeIncluded = testsTobeIncluded.concat(e);
          // });

          // var aaaaaaaa = scope.example15model;
          // var selectedTests = '';
          // angular.forEach(scope.example15model, function (key, value) {
          //   selectedTests = selectedTests + key.id + '|';
          // });
          // selectedTests = selectedTests.substring(0, selectedTests.lastIndexOf('|'));
          // scope.testsTobeIncluded = [];
          // scope.testsTobeIncluded.push(selectedTests);

          // if (scope.testsTobeIncluded.length > 0) {
            if ((scope.example15model.length > 0) && (scope.editPack.minAge <=scope.editPack.maxAge) && (scope.editPack.price >= scope.editPack.maPrice)) {
            scope.editPack.minAge = scope.editPack.minAge || 0;
            scope.editPack.maxAge = scope.editPack.maxAge || 0;
            var ages = [{
              "minAge": scope.editPack.minAge,
              "maxAge": scope.editPack.maxAge
            }];
            var includedTestsArr = [], inst = [];
            angular.forEach(scope.example15model, function(e,i){
              includedTestsArr.push(e.id)
            })
            angular.forEach(scope.instructions, function (e, i) {
              inst.push(e.instruction);
            });
            console.log(scope.instructions)
            var singlePackage = {
                "id": isUpdate ? scope.editPack.id : 0,
                "hospitalID": UserService.getHospitalObj().hospId,
                "packageNo": scope.editPack.packageNo,
                "packageName": scope.editPack.packageName,
                "packagePrice": scope.editPack.price,
                "packageMADiscount": scope.editPack.discount,
                "packageMAPrice": scope.editPack.maPrice,
                "hospInclusions": includedTestsArr,
                "packageAges": ages,
                "gender": scope.radioModel,
                "hospInstructions": inst,
                "description": scope.editPack.description,
                "isVerified": false,
                "isDelete": false,
            }
            var data = {'packageDetail' : [singlePackage]};

            ProfileService.updateProviderProfileDataByKey('opPackages',data).then(function (response) {
              if (response.packagesDetails) {
                scope.packagesMethods.closeEditPackageModal();
                scope.packagesMethods.loadPackages();
              }
            });
          } else {
              if(scope.example15model.length <= 0) {
                alert("Please select at least one test.");
              }
              else if((scope.editPack.price < scope.editPack.maPrice)) {
                alert("Medi Assist price cannot be more than package price");
              }
              else if (scope.editPack.minAge > scope.editPack.maxAge) {
                alert("Miniumun age cannot be more than maximum age");
              }
          }
        }
      };
    })();
    angular.element(document).ready(function () {
      scope.packagesMethods.loadPackages();
      UtilitiesService.scrollTo('packages');
    });
  }]);

angular.module('mbplus')
.controller('ipPackagesCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', '$analytics', function (scope, $location, UserService, UtilitiesService, $analytics) {
  $analytics.pageTrack('/ipPackages');
  if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }
  scope.packagesMethods = (function () {
    return {
      loadPackages: function () {
        scope.packages = [];
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/hospProfileDetails/ipPackages/true', { hospId: UserService.getHospitalObj().hospId }, 'POST').then(function (response) {
          if (response.data.isSuccess) {
            angular.forEach(response.data.hospOpPackages, function (e, i) {
              var tempObj = {
                packageNo: e.packageNo,
                packageName: e.packageName,
                packagePrice: e.packagePrice,
                packageMADiscount: e.packageMADiscount,
                packageMAPrice: e.packageMAPrice,
                inclusions: e.inclusions,
                description: e.description,
                packageContents: e.packageContents,
                packageAddedOn: new Date(UtilitiesService.getDateObj(e.createdOn)),
                packageLastUpdated: new Date(UtilitiesService.getDateObj(e.modifiedOn)),
                isVerified: e.isVerified
              }
              scope.packages.push(tempObj);
            })
          }
        })
      },
      openPackageDetails: function (e) {
        scope.editPack = {
          packageName: e.packageName,
          price: e.packagePrice,
          discount: e.packageMADiscount,
          maPrice: e.packageMAPrice,
          description: e.description,
          inclusions: e.inclusions,
          packageNo: e.packageNo,
          packageContents: e.packageContents
        };
        scope.investigations = scope.profileMethods.groupBy(scope.editPack.packageContents, "groupName");
      },
      newItem: function (type) {
        if (type == 'inc') {
          scope.editPack.inclusions.push('included item' + (scope.editPack.inclusions.length + 1));
        } else {
          scope.editPack.exclusions.push('excluded item' + (scope.editPack.exclusions.length + 1));
        }
      },
      removeItem: function (type, index) {
        if (type == 'inc') {
          scope.editPack.inclusions.splice(index, 1);
        } else {
          scope.editPack.exclusions.splice(index, 1);
        }
      },
      openAddPackageModal: function () {
        scope.testProfiles = [];
        scope.testProfilesArray = [];
        scope.investigations = [];
        scope.newcategory = [];
        scope.editPack = [];
        scope.instructions = [];
        scope.checkModel = {
          ageZeroToThirty: true,
          ageThirtyOneToFortyFive: true,
          ageFortySixToFiftyFive: true,
          ageFiftySixToSixtyFive: false,
          ageSixtySixToHundred: false
        };
        scope.radioModel = 'BOTH';
        UserService.makeRestCall(UtilitiesService.getPlusApi() + "/masterdata/lookup/test_profile.json", "", "GET").then(function (response) {
          if (response.data.isSuccess) {
            var testProfiles = response.data.lookUpData;
            angular.forEach(testProfiles, function (e, i) {
              var temp = {
                profileId: e.lookUpId,
                profileName: e.lookUpValue
              }
              scope.testProfiles.push(temp);
              scope.newcategory.push(e.lookUpId);
              //scope.investigations.push({});
            });
            scope.testProfilesArray.push(scope.testProfiles);
            scope.packagesMethods.addNewInstruction();
          }
        }, function (error) {
          // console.log("Error : " + error);
        })
      },
      addNewTestProfile: function () {
        scope.testProfilesArray = [];
        scope.testProfilesArray.push(scope.testProfiles);
        scope.newcategory.push(0);
      },
      removeTestProfile: function (index) {
        scope.testProfilesArray.splice(index, 1);
        scope.newcategory.splice(index, 1);
        scope.investigations.splice(index, 1);
      },
      getInvestigationsForProfile: function (index, name) {
        scope.indexOfInvestigation = index;
        if (scope.investigations[index] && scope.investigations[index].length > 0) {
          scope.somThingSom = scope.investigations[index];
          scope.somThingSom.name = name;
          return;
        }
        var profileId = scope.newcategory[index];
        UserService.makeRestCall(UtilitiesService.getPlusApi() + "/DCInvestigationsByGroupId/" + profileId + ".json", "", "GET").then(function (response) {
          if (response.data) {
            scope.somThingSom = response.data;
            scope.somThingSom.name = name;
          }
        }, function (error) {
          // console.log("Error : " + error);
        });
      },
      calculateDiscount: function () {
        if (scope.editPack.price && scope.editPack.discount) {
          if (scope.editPack.discount > 100) {
            scope.editPack.maPrice = 0;
          } else {
            scope.editPack.maPrice = scope.editPack.price * ((100 - scope.editPack.discount) / 100);
          }
        } else {
          scope.editPack.maPrice = scope.editPack.price;
        }
      },
      addNewPackage: function () {
        var testsTobeIncluded = [];
        angular.forEach(scope.investigations, function (ele, itr) {
          angular.forEach(ele, function (e, i) {
            if (e.isTestIncluded) {
              testsTobeIncluded.push(e.id.toString());
            }
          });
        });
        var ages = [];
        if (scope.checkModel) {
          if (scope.checkModel.ageZeroToThirty) {
            ages.push({
              "minAge": "0",
              "maxAge": "30"
            })
          }
          if (scope.checkModel.ageThirtyOneToFortyFive) {
            ages.push({
              "minAge": "31",
              "maxAge": "45"
            })
          }
          if (scope.checkModel.ageFortySixToFiftyFive) {
            ages.push({
              "minAge": "46",
              "maxAge": "55"
            })
          }
          if (scope.checkModel.ageFiftySixToSixtyFive) {
            ages.push({
              "minAge": "56",
              "maxAge": "65"
            })
          }
          if (scope.checkModel.ageSixtySixToHundred) {
            ages.push({
              "minAge": "66",
              "maxAge": "100"
            })
          }
        }
        var inst = [];
        angular.forEach(scope.instructions, function (e, i) {
          inst.push(e.instruction);
        });
        var data = {
          "hospPackages": {
            "hid": UserService.getHospitalObj().hospId,
            "packageName": scope.editPack.packageName,
            "packagePrice": scope.editPack.price,
            "packageMADiscount": scope.editPack.discount,
            "packageMAPrice": scope.editPack.maPrice,
            "inclusions": testsTobeIncluded,
            "ages": ages,
            "gender": scope.radioModel,
            "instructions": inst,
            "description": scope.editPack.description,
            "isActive": true,
            "createdBy": UserService.getUserObj().userId,
            "modifiedBy": UserService.getUserObj().userId,
            "isVerified": false,
            "isDelete": false,
          }
        }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/addHospPackages.json", data, "POST").then(function (response) {
          if (response.data.isSuccess) {
            $('#addPackage').modal('hide');
            scope.hospProfile.hospPackages = response.data.hospPackages;
            scope.packagesMethods.loadPackages();
          }
        }, function (error) {
          // console.log("Error : " + error);
        });
      },
      editTestItem: function (obj) {
        if (!obj || obj.length <= 0) {
          return null;
        }
        UserService.makeRestCall(UtilitiesService.getPlusApi() + "/DCInvestigationsByGroupId/" + obj[0].groupId + ".json", "", "GET").then(function (response) {
          if (response.data) {
            //scope.investigations[index] = response.data;
          }
        }, function (error) {
          // console.log("Error : " + error);
        });
      },
      updateHospPackage: function () {

      },
      cancelSomThingSom: function () {
        scope.investigations[scope.indexOfInvestigation] = scope.somThingSom;
        var cnt = 0;
        angular.forEach(scope.somThingSom, function (e, i) {
          if (e.isTestIncluded) {
            cnt += 1;
          }
        });
        scope.investigations[scope.indexOfInvestigation].count = cnt;
        scope.somThingSom = [];
      },
      getTotalTests: function (index) {
        return scope.investigations[index].length;
      },
      addNewInstruction: function () {
        var temp = {
          instruction: ''
        }
        scope.instructions.push(temp);
      },
      removeInstruction: function ($index) {
        scope.instructions.splice($index, 1);
      },
      setGender: function (value) {
        scope.radioModel = value;
      }
    };
  })();
  angular.element(document).ready(function () {
    scope.packagesMethods.loadPackages();
  });
}]);
angular.module('mbplus')
.controller('orderPunchingCtrl', ['$rootScope', '$scope', '$location', '$window', '$http', 'UserService','UtilitiesService', '$analytics', '$timeout','PlusUtilitiesService','$anchorScroll' ,function ($rootScope, scope, $location, $window, $http, UserService, UtilitiesService, $analytics, $timeout,plusUtilitiesService,$anchorScroll) {

  scope.filter = {};
  scope.userInfo = {};
  scope.packageList = {};

  scope.displayOrderForm = false;
  scope.displayDetails = false;
  scope.verified = true;
  scope.showMessage = false;
  scope.waiting = false;
  scope.editing = false;
 
  var packageListMain;
  scope.selectedCity = '';
  scope.productsArray = [];

  var user = UserService.getUserObj(),hospitalObj = UserService.getHospitalObj();
  
  var keywordselect, city = hospitalObj && hospitalObj.city;

  if(user && user.firstName){
    if(user.firstName.toLowerCase().indexOf("lifecare") > -1)
    {
      keywordselect = "lifecare";
    } else if(user.firstName.toLowerCase().indexOf("diagright") > -1) {
      keywordselect = "diagright";
    }
  }

  scope.verifyUser = function($valid){
    scope.userInfo.Email = scope.userInfo.Check? scope.userInfo.Phone+"@mbretailuser.com": scope.userInfo.Email;
    if($valid){
      var req = {
        method: 'POST',
        url: UtilitiesService.getPlusUrl() + 'CheckUser',
        headers: {

        },
        data: {
          Phone: scope.userInfo.Phone,
          Email: scope.userInfo.Email
        }
      };

      $http(req).then(function(response){
        if(!response.data.isPresent) scope.showMessage=false;
        else scope.showMessage=true;
        scope.verified = false;
        }, function(){

      });    
    }
  }



  scope.eligibleContracts = [{
    categoryItemTypeId: 'c920aa2144b9e51184af002219349965',
    value: 'Health Check'
  },{
    categoryItemTypeId: 'f4a83a18cec74f1786b8fd2b9aff4c0c',
    value: 'Lab Test'
  }]

  scope.genderList = [{
    value: 'M',
    title: 'Male'
  },{
    value: 'F',
    title: 'Female'
  }]
  

  scope.today = moment().format('YYYY-MM-DD');

  scope.onContractSelect = function(){
    var req = {
    method: 'POST',
    url: UtilitiesService.getPlusUrl()  +  "GetAvailableCities",
    headers: {
      
    },
    data: { 
      CategoryItemTypeId: scope.filter.contractId,
      }
    };
    $http(req).then(function(response){
      if(response.data.cities != null) {
        scope.filter.citylist = true;
      }
      scope.cities = response.data.cities;
      }, function(){

    });

    if(scope.filter.city) scope.onSelectCity();

  }

  

  scope.onSelectCity = function(){
    var req = {
      method: 'POST',
      url: UtilitiesService.getPlusUrl()  +  'GetPackages',
      data: { 
        CategoryItemTypeId: scope.filter.contractId,
        city: scope.filter.city,
        keyword: keywordselect
        }
      };
      $http(req).then(function(response){
        if(response.data.categoryItemTypeResponse.length != 0) {
          scope.filter.contract = true;
        } else {
          scope.filter.contract = false;
        }
        packageListMain = response.data.categoryItemTypeResponse;
        scope.packageList = packageListMain.map(function(each){
          if(each.packagePrice){
            each.packageName += (' - ₹' + each.packagePrice)
          }
          each.isAdded = false;
          return each
        });
        }, function(err){
  
      });
  }


  scope.addProducts = function(){
    scope.editing = false;
    if(scope.updateIdx > -1){
      scope.productsArray[scope.updateIdx].packageDetail.selectedPackage = scope.filter.packageId;
      scope.productsArray[scope.updateIdx].packageDetail.packageName = scope.packageList.filter(function(x) {if(x.packageId==scope.filter.packageId) {x.isAdded=true; return x.packageId}}).map(function(x){return x.packageName})[0];
      scope.productsArray[scope.updateIdx].packageDetail.IsPastBooking = scope.filter.IsPastBooking?scope.filter.IsPastBooking:false;
    } else {
        scope.productsArray.push({
          categoryItemTypeId: scope.filter.contractId,
          packageDetail: {
            selectedPackage: scope.filter.packageId,
            packageName: scope.packageList.filter(function(x) {if(x.packageId==scope.filter.packageId) {x.isAdded=true; return x.packageId}}).map(function(x){return x.packageName})[0],
            City: scope.filter.city,
            IsPastBooking: scope.filter.IsPastBooking?scope.filter.IsPastBooking:false
          }
      });
    }

    scope.filter.packageId = '';
    scope.filter.IsPastBooking = false;
    scope.updateIdx = -1;
    
    $timeout(function(){
      $location.hash('page-down');
      $anchorScroll();
    },0)
  }


  scope.updateDetails = function(idx){
    scope.editing = true;
    var request = scope.productsArray[idx];
    scope.packageList.forEach(function(x){if(x.packageId==request.packageDetail.selectedPackage) x.isAdded=false});
    scope.updateIdx = idx;
    scope.filter.packageId = request.packageDetail.selectedPackage;
    scope.filter.IsPastBooking =  request.packageDetail.IsPastBooking; 
  }


  scope.deleteDetails = function(obj){
    scope.packageList.forEach(function(x){if(x.packageId==obj.packageDetail.selectedPackage) x.isAdded=false});
    var idx = scope.productsArray.indexOf(obj);
    if(idx>-1) scope.productsArray.splice(idx,1);
  }


  
  scope.createOrder = function(){
    scope.waiting = true;
    scope.formDetails = {
      packageWithContract  : [],
      Keyword : keywordselect
    }
    scope.formDetails.packageWithContract = scope.productsArray;
    
    _.extend(scope.formDetails, scope.userInfo)

    var req = {
      method: 'POST',
      url: UtilitiesService.getPlusUrl()  + 'CreateFinalOrder',
      headers: {
        AccessToken: plusUtilitiesService.getAccessToken()
      },
      data: scope.formDetails
      };      
    console.log(req);

      $http(req).then(function(response){
          if(response.data.isSuccess) {
            UtilitiesService.showAlertMessage(response.data.message, true);
            scope.waiting = false;
            scope.showMessage=false;
            scope.verified = true;
            scope.displayOrderForm = false;
          } else {
            UtilitiesService.showAlertMessage(response.data.errorMessage);
            scope.waiting = false;
          }
          scope.filter = {};
          scope.userInfo = {};
          scope.productsArray = [];
        }, function(err){
          alert(err.responseStatus.errorCode=='UnauthorizedAccessException'?'please Sign Out and Sign In again':err.responseStatus.errorCode);
          scope.waiting = false;
      });
  }
  
  $analytics.pageTrack('/orderPunching');
  
}]);
angular.module('mbplus')
.controller('otherClaimsCtrl', ['$rootScope', '$scope', '$location', '$timeout', '$filter', '$http', 'UserService', 'UtilitiesService', '$analytics', function ($rootScope, scope, $location, $timeout, $filter, $http, UserService, UtilitiesService, $analytics) {
    $analytics.pageTrack('/claims');
    scope.ctrlName = 'claimsCtrl';
    if (!UserService.isActive() || (UserService.getUserObj() && UserService.getUserObj().role && UserService.getUserObj().role.toLowerCase() == 'insurer')) {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }

    scope.startIndex = 1;
    scope.ctrlFn = function (nextpage) {
        scope.startIndex = nextpage;
        scope.getPreAuthClaimsList();
    };

    //Fetch Active Claims List
    scope.getPreAuthClaimsList = function () {
        scope.preauthClaims1 = [];
        if (UserService.getHospitalObj()) {
            var ajxData = {
                hospitalId: UserService.getHospitalObj().cmsHospId
            };
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/GetClaimForOtherTpa', ajxData, 'POST').then(function (response) {
                if (response.data.isSuccess) {
                    angular.forEach(response.data.claimData, function (data, index) {
                        var obj = {
                            actionAt: data.actionAt,
                            patientName: data.patientName,
                            diagnosis: data.diagnosis,
                            id: data.id,
                            claimedAmount: data.claimedAmount,
                            doctorName: data.doctorName,
                            dateOfAdmission: UtilitiesService.compareDate(data.doa),
                            dateOfDischarge: UtilitiesService.compareDate(data.dod),
                            employer: data.employer,
                            insurerName: data.insurerName,
                            patientAge: data.patientAge,
                            patientGender: data.patientGender,
                            tpaName: data.tpaName,
                            documentsAttached: data.documentsAttached,
                            status: data.status,
                            statusId:data.statusId,
                            uniqueId: data.uniqueId,
                            approvedAmount: data.clmApprovedAmt ? data.clmApprovedAmt : 0,
                        };
                        scope.preauthClaims1.push(obj);
                    });
                    scope.preauthClaims = scope.preauthClaims1;
                } else {
                    scope.preauthClaims == [];
                }
            });
        }
    };
    scope.getPreAuthClaimsList();
}]);
angular.module("mbplus")
  .controller('newAppointmentController', ['$scope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics', 'PlusUtilitiesService', 'sharedDataService', '$stateParams', '$state', 'orderByFilter', 'navConstantsSvc', function (scope, $location, UserService, UtilitiesService, filterFilter, $analytics, PlusUtilitiesService, sharedDataService, $stateParams, $state, orderByFilter, navConstantsSvc) {
    $analytics.pageTrack('/allappointments');
    if (!UserService.isActive()) {
      UserService.destroyUserObj();
      $location.path('/');
      return false;
    }
    scope.choosedCorporates = [];
    scope.agentEmailAddress = '';
    scope.emailchk = /^(([^<>()[\]\\.,;:\s@\']+(\.[^<>()[\]\\.,;:\s@\']+)*)|(\'.+\'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    scope.distances = navConstantsSvc.distances;
    scope.user = UserService.getUserObj();
    scope.isActive = UserService.isActive();
    scope.formatCurrency = UtilitiesService.formatCurrency;
    scope.contracts = PlusUtilitiesService.getContracts();
    scope.formatTime = UtilitiesService.formatTime;
    scope.compareDate = UtilitiesService.compareDate;
    $('.showPaid').hide();
    scope.pbrequestid = null;
    scope.selectedPackageForAdvance = [];
    scope.createresult = false;
    scope.totalPrice = 0;
    scope.totalPriceData = 0;
    scope.orderObj = new Object();
    scope.orderItemObj = new Object();
    scope.showPaid = false;
    scope.priceToShow = 0;
    scope.priceToShowFlag = false;
    scope.paid = true;
    scope.txn = {};
    scope.employee = {};
    scope.cartEmpty = true;
    scope.CartAppointments = new Array();
    scope.benefMAID = 0;
    scope.manual = {
      secondDate: '',
      firstDate: '',
      secondTime: '',
      firstTime: ''
    }
    scope.sumassuredetail = {
      sumAssured: '',
      paidSpons: 'sponsored',
      grpIndv: 'individual'
    };
    scope.additionalinfo = {};
    scope.additionalFieldList = ['hrLocation', 'hrMobileNumber', 'hrName', 'AgentEmailId', 'AgentName', 'AgentContactNo', 'ProposalNumber',
      'Entity', 'CaseType', 'Aadhar', 'PAN', 'packageOrGrade', 'lifeno', 'clientLocation', 'SMName', 'SM_Email', 'SMPhoneNumber'
    ];
    scope.remarks = null;
    scope.altMobile = null;
    scope.empContract = '';
    scope.empCorporate = '';
    scope.preEmployment = false;
    scope.preEmploymentDiv = false;
    scope.prepolicyContract = false;
    scope.agentDetails = {};
    scope.agentDetails.search = true;
    scope.insurersList = [];
    scope.showFirstScreen = true;
    scope.prePolicyERId = 42671;
    scope.policyBazaarRequestsContractId = 9251;
    scope.location = {};
    scope.selectedCorporate = {};
    scope.selectedInsurer = {};
    scope.preferredDC = [];
    scope.prePolicy = {}
    scope.preEmployment = {};
    scope.esales = {};
    scope.others = {};
    scope.client = {};
    scope.notpaidByCoverFox = true;
    scope.preffered_DC_Name = '';
    scope.stateName = "";
    scope.loadRetailPackagesForCorporates = [48371, 69175];
    scope.checkAvailability = '';
    scope.FileDetails = [];
    scope.hr = [];
    scope.showMap = false;
    scope.customersDND = false;
    scope.agentCustomersDND = false;
    scope.isMappedDc = false;
    scope.windowOptions = {};
    scope.locationName = {
      autocomplete: ''
    };
    scope.windowOptions = {};
    var first = new Date();
    var dd = new Date(first).getDate();
    var mm = new Date(first).getMonth() + 1;
    var yy = new Date(first).getFullYear();
    var hh = 7;
    var ms = 0;
    var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
    scope.secondTime = new Date(x);
    scope.firstTime = new Date(x);
    scope.manual.secondTime = new Date(x);
    scope.manual.firstTime = new Date(x);
    var maxFirstValue = new Date();
    maxFirstValue.setHours(18);
    maxFirstValue.setMinutes(0);
    scope.maxFirstValue = maxFirstValue;
    var minFirstValue = new Date();
    minFirstValue.setHours(7);
    minFirstValue.setMinutes(0);
    scope.minFirstValue = minFirstValue;
    var maxFirst = new Date();
    maxFirst.setHours(18);
    maxFirst.setMinutes(0);
    scope.maxFirst = maxFirst;
    var minFirst = new Date();
    minFirst.setHours(7);
    minFirst.setMinutes(0);
    scope.minFirst = minFirst;
    scope.benifDetail = false;
    scope.employeeFound = false;
    scope.field = {
      fieldName: null,
      fieldValue: null
    }
    scope.selectAll = function (flag) {
      if (scope.corporates) {
        scope.corporates.map(function (e) {
          e.isSelected = flag;
        });
        if (!flag) {
          scope.choosedCorporates = [];
        }
        scope.filterchoosedCorporates();
      }
    };

    scope.groupSelectedCorporate = function (flag) {
      if (scope.corporates) {
        scope.corporates.map(function (item) {
          scope.choosedCorporates.map(function (e) {
            if (item.id === e) {
              item.isSelected = true;
            }
          })
        })
      }
    };

    scope.filterchoosedCorporates = function (corporate) {
      if (corporate && corporate.isSelected === false) {
        var index = scope.choosedCorporates.indexOf(corporate.id);
        if (index > -1) {
          scope.choosedCorporates.splice(index, 1);
        }
      }
      if (scope.corporates.length > 0) {
        var selected = scope.corporates.filter(function (e) {
          return e.isSelected == true;
        }).map(function (el) {
          return parseInt(el.id);
        });
        selected.map(function (item) {
          if (scope.choosedCorporates.indexOf(item) === -1) {
            scope.choosedCorporates.push(item);
          } else {
            scope.choosedCorporates.splice(item);
          }
        });
      }
    }

    var role = null
    scope.isInsurer_CallCentre = false;
    if (scope.user && scope.user.rolesFeatures && scope.user.rolesFeatures.roles) {
      role = scope.user.rolesFeatures.roles.find(function (elem) {
        return ((elem.roleName) == 'Insurer_CallCentre')
      })
    }
    scope.isInsurer_CallCentre = role ? true : false

    scope.markingDND = function (val, active) {
      val == "customer" ? (scope.customersDND = active ? true : false) : val == "both" ? (scope.agentCustomersDND = active ? true : false) : ''
    }
    scope.onSelect = function ($item, $model, $label) {
      $scope.$item = $item;
      $scope.$model = $model;
      $scope.$label = $label;
    };
    scope.loadStates = function () {
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'masterdata/lookup/state', '', 'GET').then(function (response) {
        if (response.data.isSuccess) {
          scope.states = response.data.lookUpData;
          scope.states = orderByFilter(scope.states, 'lookUpValue', scope.reverse);
        }
      });
    };
    scope.loadCities = function (selectedState) {
      scope.selectedState = selectedState;
      if (scope.selectedState) {
        if (scope.selectedState.lookUpId) {
          scope.location.state = scope.selectedState.lookUpId
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'masterdata/lookup/district/' + scope.selectedState.lookUpId, '', 'GET').then(function (response) {
            if (response.data.isSuccess) {
              scope.cities = response.data.lookUpData;
              scope.citiesObj = {}
              $(scope.cities).each(function (i, v) {
                scope.citiesObj[i.lookUpId] = i;
              })
              scope.cities = orderByFilter(scope.cities, 'lookUpValue', scope.reverse);
            }
          });
        }
      }
    };
    scope.loadLocations = function (selectedCity) {
      scope.selectedCity = selectedCity;
      if (scope.selectedCity) {
        if (scope.selectedCity.lookUpId) {
          scope.location.city = scope.selectedCity.lookUpId;
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'masterdata/lookup/city/' + scope.selectedCity.lookUpId, '', 'GET').then(function (response) {
            if (response.data.isSuccess) {
              scope.locations = response.data.lookUpData;
              scope.locations = orderByFilter(scope.locations, 'lookUpValue', scope.reverse);
            }
          });
        }
      }
    };
    scope.loadSubLocations = function (selectedLocation) {
      scope.selectedLocation = selectedLocation;
      if (scope.selectedLocation) {
        if (scope.selectedLocation.lookUpId) {
          scope.location.location = scope.selectedLocation.lookUpId;
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'masterdata/lookup/location/' + scope.selectedLocation.lookUpId, '', 'GET').then(function (response) {
            if (response.data.isSuccess) {
              scope.sublocations = response.data.lookUpData;
              scope.sublocations = orderByFilter(scope.sublocations, 'lookUpValue', scope.reverse);
            }
          });
        }
      }
    };


    scope.loadCitiesNew = function (selectedState) {
      scope.selectedState = selectedState;
      if (scope.selectedState) {
        if (scope.selectedState.lookUpId) {
          scope.location.state = scope.selectedState.lookUpId
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'masterdata/lookuplevel/' + scope.selectedState.lookUpId + '/2', '', 'GET').then(function (response) {
            if (response.data.isSuccess) {
              scope.cities = response.data.lookUpData;
              scope.citiesObj = {}
              $(scope.cities).each(function (i, v) {
                scope.citiesObj[v.lookUpId] = v;
              })
              scope.cities = orderByFilter(scope.cities, 'lookUpValue', scope.reverse);
            }
          },
            function (error) {
              UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            });
        }
      }
    };
    scope.loadLocationsNew = function (selectedLocation) {
      scope.selectedLocation = selectedLocation;
      if (scope.selectedLocation) {
        if (scope.selectedLocation.lookUpId) {
          scope.location.location = scope.selectedLocation.lookUpId;
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'masterdata/lookup/location/' + scope.selectedLocation.lookUpId, '', 'GET').then(function (response) {
            if (response.data.isSuccess) {
              scope.sublocations = response.data.lookUpData;
              scope.sublocations = orderByFilter(scope.sublocations, 'lookUpValue', scope.reverse);
            }
          },
            function (error) {
              UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            });
        }
      }
    };


    scope.loadDCs = function (sublocationId) {
      if (sublocationId) {
        var erTypeName = 'DC_MediAssist';
        var ERTypeId = PlusUtilitiesService.getDC_MA_ContractID();
        var serviceBrokerId = '1000042';
        var serviceBrokerName = 'Medi Assist';
        var Entity_Type = '4653';
        var PM_TypeId = PlusUtilitiesService.getDC_Inv_PmTypeId();
        scope.location.sublocation = sublocationId;
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'EntityRelation/Search/EntitySearch/' + ERTypeId + '/' + serviceBrokerId + '/' + 0 + '/' + scope.location.state + '/' + scope.location.city + '/' + scope.location.location + '/' + scope.location.sublocation, '', 'GET').then(function (response) {
          if (response.statusText == 'OK') {
            scope.isGoogleMap = true;
            if (scope.allowedPackages) {
              scope.diagnosticCentres = $.map(response.data, function (i) {
                if (scope.allowedPackages && scope.allowedPackages.indexOf(i.id) != -1) {
                  return i
                }
              })
              if (scope.diagnosticCentres.length > 0) {
                scope.isMappedDc = false;
                scope.$broadcast('eventDcList', {
                  dcList: scope.diagnosticCentres,
                });
              } else {
                scope.$broadcast('eventDcList', {
                  dcList: '',
                });
                scope.isMappedDc = true;
              }
            } else {
              UtilitiesService.showAlertMessage('Please Select Package.');
            }
          }
        });
      } else {
        scope.isMappedDc = true;
      }
    };


    scope.example2settings = {
      idProp: 'peR_Id',
      displayProp: 'packageName',
      styleActive: true,
      enableSearch: true,
      externalIdProp: '',
      scrollableHeight: '300px',
      scrollable: true,
      showCheckAll: false,
      showUncheckAll: true,
      keyboardControls: true,
      smartButtonMaxItems: 2
    };
    scope.example5customTexts = {
      buttonDefaultText: 'Select packages',
      smartButtonMaxItems: 3
    };

    scope.getTotalAge = function (dob) {
      scope.birthdate = dob;
      scope.birthYr = scope.birthdate.getFullYear().toString();
      scope.birthMonth = (scope.birthdate.getMonth() + 1);
      scope.birthDay = scope.birthdate.getDate().toString();
      scope.currentDate = new Date();
      scope.currentYr = scope.currentDate.getFullYear().toString();
      scope.currentMonth = (scope.currentDate.getMonth() + 1);
      scope.currentDay = scope.currentDate.getDate().toString();
      var age = scope.currentYr - scope.birthYr;
      if (scope.currentMonth < scope.birthMonth) {
        age--;
      }
      if (scope.currentMonth == scope.birthMonth) {
        if (scope.currentDay < scope.birthDay) {
          age--;
        }
      }
      return scope.employee.age = age + ' years';
    };

    scope.isContractEsales = function () {
      if (scope.selectedContract)
        return (scope.selectedContract == PlusUtilitiesService.getSpecificContract('E_SALES')[0]);
      else {
        return false;
      }
    };
    scope.isContractPrePolicy = function () {
      if (scope.selectedContract)
        return (scope.selectedContract == PlusUtilitiesService.getSpecificContract('Pre-Policy')[0]);
      else {
        return false;
      }
    };
    scope.isContractPreEmployment = function () {
      if (scope.selectedContract)
        return (scope.selectedContract == PlusUtilitiesService.getSpecificContract('Pre-Employment')[0]);
      else {
        return false;
      }
    };
    scope.isContractDrugTest = function () {
      if (scope.selectedContract == PlusUtilitiesService.getSpecificContract('Drug Test')[0])
        return (scope.selectedContract == PlusUtilitiesService.getSpecificContract('Drug Test')[0]);
      else {
        return false;
      }
    };
    scope.isContractPharmacy = function () {
      if (scope.selectedContract == PlusUtilitiesService.getSpecificContract('PharmaContract')[0])
        return (scope.selectedContract == PlusUtilitiesService.getSpecificContract('PharmaContract')[0]);
      else {
        return false;
      }
    };

    scope.getPriceList = function (id) {
      if (id) {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'EntityProperties' + '/' + id, '', 'GET').then(function (response) {
          if (response.data) {
            scope.entityProperties = response.data.entityProperties;
            angular.forEach(scope.entityProperties, function (v, i) {
              if (v.propertyName === 'HVByDoctor') {
                scope.entityProperties[i].name = 'home visit by doctor';
              } else if (v.propertyName === 'HVByTechnician') {
                scope.entityProperties[i].name = 'home visit by Technician';
              } else if (v.propertyName === 'HVByECGTechnician') {
                scope.entityProperties[i].name = 'home visit by ECG Technician';
              }
            })
            scope.entityPropertiesDummy = response.data.entityProperties;
          }
        });
      }
    };

    scope.calculatePrice = function () {
      var totalPrice = 0;
      if (scope.entityProperties) {
        angular.forEach(scope.entityProperties, function (v, i) {
          if (v.propertySelected) {
            totalPrice = totalPrice + parseInt(v.propertyValue);
          }
        });
      }
      return totalPrice;
    };

    scope.calculatePriceData = function () {
      var totalPriceData = {};
      if (scope.entityProperties) {
        angular.forEach(scope.entityProperties, function (v, i) {
          if (v.propertySelected) {
            totalPriceData[v.propertyName] = v.propertyValue;
          }
        });
      }
      return totalPriceData;
    };
    scope.isShowPriceList = false;
    scope.visitTypeChange = function (value) {
      scope.client.visitType = value;
      if (scope.client.visitType === 'Appointment') {
        scope.client.addressline1 = '';
        scope.client.addressline2 = '';
        scope.preferredDC = [];
        scope.entityProperties = scope.entityPropertiesDummy;
        scope.isShowPriceList = true;
      } else {
        scope.isShowPriceList = false;
      }
      scope.entityProperties = [];
      scope.manual.firstDate = null;
      scope.manual.secondDate = null;
    };
    scope.showNextStep = function (source) {
      scope.isShowPriceList = false;
      if (scope.selectedContract == '4625' || scope.selectedContract == '9717') {
        // getPriceDetails(scope.selectedContract);
      }
      scope.CartAppointments = [];
      scope.showFirstScreen = false;
      scope.cartEmpty = false;
      scope.showPaid = false;
      scope.priceToShowFlag = false;
      var valid = true;
      $('.required').removeClass('required');
      switch (source) {
        case 'others':
          sharedDataService.destroyLocalStorageDataObj();
          scope.packages = [];
          scope.loadEmployeeDetailsPost();
          break;
        case 'esales':
          scope.packages = [];
          scope.tests = [];
          scope.selectedPackageForAdvance = [];
          scope.packages = [];
          scope.markerArray = [];
          var reId = scope.selectedCorporate;
          scope.isPackageSelectionAdvance = false;
          $state.go('create.esales');
          break;
        case 'preemp':
          $state.go('create.preemp');
          scope.loadPreEmpPackages();
          break;
        case 'drugTest':
          $state.go('create.drugTest');
          scope.loadPreEmpPackages();
          break;
        case 'prepolicy':
          scope.selectedPackageForAdvance = [];
          scope.packages = [];
          scope.markerArray = [];
          scope.isPackageSelectionAdvance = false;
          if (scope.agentDetails.id) {
            scope.employee.sourceId = scope.agentDetails.id;
            scope.employee.insurer = scope.selectedCorporate.entityName = scope.agentDetails.insuranceCompanyName;
            scope.agentInsurerId = scope.agentDetails.insuranceCompanyId;
            scope.selectedCorporate.id = $.map(scope.corporates, function (i) {
              if (i.entityId == scope.agentInsurerId) {
                return i.id
              }
            })[0];
          }
          if (scope.selectedCorporate.id) {
            scope.getPriceList(scope.selectedCorporate);
            $state.go('create.prepolicy');
            scope.loadPrePolicyPackages();
          } else {
            UtilitiesService.showAlertMessage('Insurer not registered.');
            scope.showFirstScreen = true;
          }
          break;
        case 'Pharmacy':
          $state.go('create.pharmacy');
          scope.PharmacyPackage = {
            peR_Id: 1289447,
            packageName: 'Pharmacy',
            isPaid: false,
            packagePrice: 0,
            serviceTax: 0,
            primaryCessTax: 0,
            secondaryCessTax: 0,
            mahsCharge: 0,
            contract: {
              contractId: PlusUtilitiesService.getPharmaContract('PharmaContract'),
              contractName: 'Pharmacy_mediassist'
            },
            isInvestigation: false
          };
          scope.selectedPackage = scope.PharmacyPackage;
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/CorporatePackageProvider/' + scope.selectedPackage.peR_Id + '/false', '', 'GET').then(function (list) {
            scope.allowedPackages = list.data;
            scope.changeProviders(scope.allowedPackages);
          });
          break;
        default:
          $state.go('create.others');
          break;
      }
      scope.$broadcast('eventDcList', {
        dcList: '',
      });
      scope.isMappedDc = false;

    }
    scope.showFirst = function () {
      if (UtilitiesService.getApptpath() === 'queue') {
        UtilitiesService.setApptpath('');
        $state.go('queue', {}, {
          reload: true
        });
      } else {
        $state.go('create', {}, {
          reload: true
        });
      }
      scope.showFirstScreen = true;
      scope.createresult = false;
      scope.orderObj = {};
      scope.orderItemObj = {};
      scope.employee = {};
      scope.client = {};
      scope.current = {
        newStateId: ''
      };
      scope.cities = '';
      scope.locations = '';
      scope.sublocations = '';
      scope.diagnosticCentres = '';
      scope.cartEmpty = false;
      scope.showPaid = false;
      scope.totalPrice = 0;
      scope.totalPriceData = 0;
      scope.selectedCity = {};
      scope.selectedLocation = {};
      scope.diagnosticCentres = [];
      scope.cities = [];
      scope.locations = [];
      scope.sublocations = [];

    }
    scope.selectedInsurers = [];
    scope.changeContract = function () {
      scope.isSelectedInsurers = true;
      scope.agentDetails = {};
      scope.agentDetails.search = true;
      scope.prepolicyContract = false;
      scope.loadCorporates(scope.selectedContract, scope.chosenCorporate);
      if (scope.selectedContract == PlusUtilitiesService.getDC_MA_PRE_EMP_ContractID() || scope.selectedContract == PlusUtilitiesService.get_Drug_Test('Drug Test') || scope.selectedContract == PlusUtilitiesService.getPharmaContract('PharmaContract')) {
        scope.preEmployment = true;
      } else if (scope.selectedContract == PlusUtilitiesService.getSpecificContract('Pre-Policy')) {
        scope.prepolicyContract = true;
      } else {
        scope.preEmployment = false;
        scope.preEmploymentDiv = false;
      }
    };
    scope.changeProviders = function (providerIds) {
      if (providerId != null && providerId != undefined) {
        var ajaxData = {
          erIds: providerIds
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'PharmaPinCode', ajaxData, 'POST').then(function (response) {
          if (response.data.isSuccess == true) {
            scope.matchedPinsWithProvider = response.data.providerCitiesWithPinCodes;
          }
        });
      }
    };
    scope.acceptOnlyNumbers = function ($event) {
      if (isNaN(String.fromCharCode($event.keyCode))) {
        $event.preventDefault();
      }
    };
    scope.checkPinAvailability = function (expectedPin) {
      scope.pinEntered = expectedPin;
      if (expectedPin) {
        if (expectedPin.length > 5) {
          var ServingProviders = [];
          $.each(scope.matchedPinsWithProvider, function (i, n) {
            scope.actualPins = i.citiesWithPinCodes;
            var pinWithCity = Object.keys(scope.actualPins);
            for (var j = 0; j < pinWithCity.length; j++) {
              var cityName = pinWithCity[j];
              scope.pinByCity = scope.actualPins[cityName];
              if (filterFilter(scope.pinByCity, expectedPin.toString()).length > 0) {
                scope.checkAvailability = 'Available';
                scope.clientCity = cityName;
                ServingProviders.push(i.entityRelatioId);
              }
            }
          });
          if (ServingProviders.length > 0) {
            var ajaxData = {
              eR_Ids: ServingProviders
            };
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'EntityRelation/GetByIds/', ajaxData, 'POST').then(function (response) {
              scope.diagnosticCentres = response.data;
            });
          } else {
            scope.checkAvailability = 'Not Available';
          }
        } else {
          scope.checkAvailability = 'Enter six digits pin';
        }
      } else {
        scope.checkAvailability = 'Please Type Pin';
      }
    };
    scope.changeCorporate = function (selectedCorporate) {
      if (selectedCorporate) {
        scope.selectedCorporate = selectedCorporate;
        if (selectedCorporate.id) {
          scope.employee.sourceId = selectedCorporate.id;
        } else {
          scope.employee.sourceId = '';
        }
      }
    };
    scope.getCorporatesData = UtilitiesService.getCorporatesData();
    scope.changeSource = function (selectedSource) {
      scope.isSelectedInsurers = true;
      if (selectedSource) {
        scope.employee.sourceId = selectedSource.id;
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'contractlookup/' + scope.selectedContract + '|' + selectedSource.id, '', 'GET').then(function (response) {
          if (scope.getCorporatesData) {
            response.data = filterFilter(response.data, {
              id: scope.getCorporatesData.split(',')
            }, function (actual, expected) {
              return filterFilter(expected, actual).length > 0;
            });
          }
          scope.selectedInsurers = response.data;
          if (scope.selectedInsurers.length > 0) {
            scope.isSelectedInsurers = false;
          } else {
            scope.isSelectedInsurers = true;
          }
        });
      }
    };
    scope.setSource = function (selectedInsurer) {
      if (selectedInsurer) {
        scope.selectedInsurer = selectedInsurer;
        scope.selectedCorporate = selectedInsurer;
        scope.loadEsalesPackages();
        scope.getPriceList(scope.selectedInsurer.id);
      } else {
        scope.packages = [];
      }
    };
    scope.changePaidOption = function ($event) {
      scope.notpaidByCoverFox = $event.target.checked;
      if (!scope.notpaidByCoverFox) {
        scope.selectedInsurer.id = PlusUtilitiesService.getCoverFoxId(); //default;
      }
    };

    scope.selectBeneficiary = function (beneficiary) {
      if (scope.client.beneficiary) {
        scope.benifDetail = true;
      } else {
        scope.benifDetail = false;
      }
      scope.packages = [];
      scope.priceToShowFlag = false;
      scope.priceToShow = 0;
      scope.diagnosticCentres = [];
      scope.cities = [];
      scope.locations = [];
      scope.sublocations = [];
      scope.selectedBeneficiary = beneficiary;
      if (scope.selectedBeneficiary && scope.selectedBeneficiary.dob) {

        scope.benifAge = UtilitiesService.getAge(scope.selectedBeneficiary.dob);
      }
      if (scope.selectedBeneficiary && scope.selectedBeneficiary.maid != "") {
        scope.loadAHCPackages(scope.selectedBeneficiary.maid)
      }
    };
    scope.state = {};
    scope.isGoogleMap = true;
    scope.changePackage = function (selectedPackage) {
      scope.priceToShowFlag = false;
      scope.isGoogleMap = false;
      scope.diagnosticCentres = [];
      scope.cities = [];
      scope.state.lookUpValue = scope.state ? scope.state.lookUpValue : [];
      scope.current = {
        newStateId: ""
      };
      scope.locations = [];
      scope.sublocations = [];
      if (selectedPackage) {
        if (Object.keys(selectedPackage).length > 0) {
          scope.selectedPackage = selectedPackage;
          if (scope.selectedPackage.isPaid) {
            scope.priceToShowFlag = true;
            scope.priceToShow = Math.round((scope.selectedPackage.packagePrice + scope.selectedPackage.serviceTax +
              scope.selectedPackage.primaryCessTax + scope.selectedPackage.secondaryCessTax +
              scope.selectedPackage.krishiKalyanCess + scope.selectedPackage.swachhBharatCess +
              scope.selectedPackage.mahsCharge) * 100) / 100;
          } else {
            scope.priceToShowFlag = false;
          }
          if (scope.isContractPrePolicy()) {
            scope.peR_Id = scope.selectedPackage.peR_Id;
            if (scope.peR_Id != undefined) {
              UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/' + scope.peR_Id, '', 'GET').then(function (response) {
                scope.allowedInvestigations = response.data.allowedInvestigations;
              });
            }
          }
          if (scope.selectedPackage.peR_ID) {
            scope.selectedPackage.peR_Id = scope.selectedPackage.peR_ID;
          }
          if (scope.selectedPackage.pM_Name) {
            scope.selectedPackage.packageName = scope.selectedPackage.pM_Name;
          }
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/CorporatePackageProvider/' + scope.selectedPackage.peR_Id + '/false', '', 'GET').then(function (list) {
            scope.allowedPackages = list.data;
          });
        }
      }
    };
    scope.selectTest = function (testSelected) {
      if (Object.keys(testSelected).length > 0) {
        scope.selectedPackage = testSelected;
        if (scope.selectedPackage.peR_ID) {
          scope.selectedPackage.peR_Id = scope.selectedPackage.peR_ID;
        }
        if (scope.selectedPackage.pM_Name) {
          scope.selectedPackage.packageName = scope.selectedPackage.pM_Name;
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/CorporatePackageProvider/' + scope.selectedPackage.peR_Id + '/false', '', 'GET').then(function (list) {
          scope.allowedPackages = list.data;
        });
      }
    };


    scope.showSuccess = function () {
      scope.showFirstScreen = false;
      scope.preEmploymentDiv = false;
      scope.createresult = true;
      scope.orderObj = {};
      scope.orderItemObj = {};
      scope.employee = {};
      scope.client = {};
      scope.showPaid = false;
      scope.priceToShowFlag = false;
      scope.priceToShow = 0;
      $('#txnNumber').val('');
      scope.paid = true;
      $('#paid').prop('checked', true);
    };
    scope.loadAHCPackages = function (benefMAID) {
      scope.loading = true;
      scope.benefMAID = benefMAID;
      scope.packages = [];
      var data = {
        RuleEngineVariable: {
          EntityRelationId: scope.selectedCorporate.id,
          EmployeeId: scope.client.clientCode,
          MAID: scope.benefMAID,
          loadRetailPackages: (filterFilter(scope.loadRetailPackagesForCorporates, scope.selectedCorporate.id, true).length > 0)
        },
        CartAppointment: scope.CartAppointments
      }
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/ruleengine', data, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          if (response.data.ruleEnginePackages.length > 0) {
            scope.packages = response.data.ruleEnginePackages;

          }
        } else {
          UtilitiesService.showAlertMessage('Something went wrong while fetching packages.');
        }
      });
    };
    scope.showData = {};
    scope.loadEsalesPackages = function () {
      scope.loading = true;
      scope.benefMAID = '0';
      var data = {
        ruleEngineVariable: {
          entityRelationId: scope.selectedInsurer.id,
          employeeId: scope.showData.EmployeeId ? scope.showData.EmployeeId : 'PB Emp',
          maid: scope.benefMAID,
          loadRetailPackages: false,
          ruleParams: {
            String: 'String'
          }
        },
        cartAppointment: []
      }
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/ruleengine', data, 'POST').then(function (response) {
        response.data.isSuccess = true;
        if (response.data.isSuccess) {
          if (response.data.ruleEnginePackages.length > 0) {
            scope.packages = response.data.ruleEnginePackages;
          }
        } else {
          UtilitiesService.showAlertMessage('Something went wrong while fetching packages');
        }
      });
    };
    scope.loadPreEmpPackages = function () {
      scope.loading = true;
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/SearchMappedPackages/' + scope.selectedCorporate.id, '', 'GET').then(function (response) {
        if (response.data.length > 0) {
          scope.packages = response.data;
        } else {
          UtilitiesService.showAlertMessage('Something went wrong while fetching packages');
        }
      });
    };

    scope.loadPrePolicyPackages = function () {
      scope.loading = true;
      var data = {
        RuleEngineVariable: {
          EntityRelationId: scope.selectedCorporate.id,
          EmployeeId: '123',
          MAID: '123'
        },
      }
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/ruleengine', data, 'POST').then(function (response) {
        response.data.isSuccess = true;
        if (response.data.isSuccess) {
          if (response.data.ruleEnginePackages.length > 0) {
            scope.packages = response.data.ruleEnginePackages;
          }
        } else {
          UtilitiesService.showAlertMessage('Something went wrong while fetching packages.');
        }
      });
    };
    scope.changeContracts = function () {
      scope.employeeFound = false;
    }

    scope.fetchContractData = function () {
      if (scope.chosenCorporate && scope.chosenCorporate.length > 1 || scope.selectedSource && scope.selectedSource.length > 1 || scope.agentCode && scope.agentCode.length > 0) {
        scope.changeContract();
      };
    }
    scope.fetchPrePolicyDataCall = function () {
      if (scope.agentCode && scope.agentCode.length > 1) {
        scope.fetchContractData();
      }
    }
    scope.loadCorporates = function (contractId, loadCorporates) {
      var url = '';
      if (contractId) {
        if (contractId == PlusUtilitiesService.getSpecificContract('E_SALES')) {
          url = UtilitiesService.getPlusUrlPrefix('integration') + '/contractlookup/' + contractId;
        } else if (contractId == PlusUtilitiesService.getSpecificContract('Pre-Policy')) {
          url = UtilitiesService.getPlusUrlPrefix() + '/EntityRelationCache/Search/' + contractId
        } else {
          url = UtilitiesService.getPlusUrlPrefix() + '/EntityRelationCache/Search/' + contractId + '/' + loadCorporates;
        }
        UserService.makeRestCall(url, '', 'GET').then(function (response) {
          scope.corporates = response.data;
          scope.groupSelectedCorporate(true);

        });
      }
    };
    scope.loadEmployeeDetails = function () {
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'employee/' + scope.choosedCorporates + '/' + scope.client.clientCode, '', 'GET').then(function (response) {
        if (response.data) {
          scope.employee = response.data;
          scope.dispGrade = scope.employee.iwpBeneficiaries[0].grade ? scope.employee.iwpBeneficiaries[0].grade : '-';
          switch (scope.employee.gender) {
            case 'M':
              scope.employee.gender = 'Male';
              break;
            case 'F':
              scope.employee.gender = 'Female';
              break;
          }
          //var dob = new Date(parseInt(scope.employee.dob.replace('/Date(', '').replace(')/', ''), 10));
          //var today = new Date(Date.now());
          //scope.employee.age = today.getFullYear() - dob.getFullYear();

          var age = moment().diff(scope.employee.dob, 'years', true);
          scope.employee.age = parseInt(age);


          scope.beneficiaries = scope.employee.beneficiaries;
        } else {
          UtilitiesService.showAlertMessage('Unable to fetch employee details');
        }
      });
    };

    scope.loadEmployeeDetailsPost = function () {
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'employee/', {
        'EmployeeId': scope.client.clientCode,
        'EntityRelationIds': scope.choosedCorporates
      }, 'POST').then(function (response) {
        if (response.data) {
          scope.employee = response.data.employeeDetails[0];
          scope.selectedCorporate.entityName = response.data.corporateName;
          scope.selectedCorporate.id = response.data.corporateErId;
          if (scope.employee && scope.employee.id) {
            if (scope.employee.iwpBeneficiaries && scope.employee.iwpBeneficiaries.length > 0) {
              scope.dispGrade = scope.employee.iwpBeneficiaries[0].grade ? scope.employee.iwpBeneficiaries[0].grade : '-';
            }
            switch (scope.employee.gender) {
              case 'M':
                scope.employee.gender = 'Male';
                break;
              case 'F':
                scope.employee.gender = 'Female';
                break;
            }
            var age = moment().diff(scope.employee.dob, 'years', true);
            scope.employee.age = parseInt(age);

            if (scope.employee.beneficiaries && scope.employee.beneficiaries.length > 0) {
              scope.beneficiaries = scope.employee.beneficiaries;
              $state.go('create.others');
              scope.employeeFound = false;
            } else {
              scope.showFirstScreen = true;
              scope.createresult = false;
              scope.employeeFound = true;
            }
          } else {
            scope.showFirstScreen = true;
            scope.createresult = false;
            scope.employeeFound = true;
          }
          //var dob = new Date(parseInt(scope.employee.dob.replace('/Date(', '').replace(')/', ''), 10));
          //var today = new Date(Date.now());
          //scope.employee.age = today.getFullYear() - dob.getFullYear();


        } else {
          UtilitiesService.showAlertMessage('Unable to fetch employee details');
          scope.showFirstScreen = true;
          scope.createresult = false;
        }
      });
    };

    scope.userTime = {
      firstAppointmentTime: '',
      secondAppointmentTime: ''
    }

    scope.addToAdditionDetails = function () {
      var tempIndex = scope.additionalFieldList.indexOf(scope.field.fieldName);
      this.additionalFieldList.splice(tempIndex, 1);
      scope.additionalinfo[scope.field.fieldName] = scope.field.fieldValue;
      this.field.fieldName = '';
      this.field.fieldValue = '';
    }

    scope.addToCart = function (firstPrefTime, firstAppointmentTime, secondPrefTime, secondAppointmentTime) {

      scope.client.firstPrefTime = firstPrefTime ? firstPrefTime : scope.client.firstPrefTime;
      scope.client.secondPrefTime = secondPrefTime ? secondPrefTime : scope.client.secondPrefTime;
      scope.userTime.firstAppointmentTime = firstAppointmentTime ? firstAppointmentTime : scope.userTime.firstAppointmentTime;
      scope.userTime.secondAppointmentTime = secondAppointmentTime ? secondAppointmentTime : scope.userTime.secondAppointmentTime;

      if (scope.client.firstPrefTime) {
        scope.client.firstPrefTime = UtilitiesService.mergeDateTimeObj(scope.client.firstPrefTime, scope.userTime.firstAppointmentTime);
      }
      if (scope.client.secondPrefTime) {
        scope.client.secondPrefTime = UtilitiesService.mergeDateTimeObj(scope.client.secondPrefTime, scope.userTime.secondAppointmentTime);
      }
      if (scope.isContractPreEmployment() || scope.isContractEsales() || scope.isContractPrePolicy() || scope.isContractDrugTest() || scope.isContractPharmacy()) {
        scope.selectedBeneficiary = {};
        scope.selectedBeneficiary.maid = 0;
        scope.selectedBeneficiary.relationName = 'Self';
        scope.selectedBeneficiary.dob = scope.employee.dob;
        scope.selectedBeneficiary.gender = scope.employee.gender;
        if (scope.selectedPackage) {
          scope.selectedPackage.isPaid = false;
        }
        if (scope.isContractPreEmployment() || scope.isContractPrePolicy() || scope.isContractDrugTest()) {
          if (scope.selectedPackage) {
            scope.selectedPackage.packagePrice = scope.selectedPackage.corporateRate;
            scope.selectedPackage.mahsCharge = 0;
          }
        }
        if (scope.isContractPharmacy()) {
          scope.selectedCity = {};
          scope.selectedCity.lookUpValue = scope.clientCity;
          scope.preferredDC[1] = scope.preferredDC[0];
          var priscriptionPaths = [];
          $(scope.FileDetails).each(function (i, v) {
            var priscriptionPath = UtilitiesService.getPlusUrlPrefix() + 'File/true/' + v.fileuploadid;
            priscriptionPaths.push(priscriptionPath);
          })
          scope.allPrescriptionsPath = JSON.stringify(priscriptionPaths);
        }
      }
      if (UserService.getUserObj().entityType === 'Insurer') {

        scope.additionalinfo['insurerRemark'] = scope.remarks ? scope.remarks : null;
        scope.additionalinfo['alternateMobile'] = scope.altMobile ? scope.altMobile : null;
        scope.additionalinfo.sumAssured = scope.sumassuredetail.sumAssured ? scope.sumassuredetail.sumAssured : '';
        scope.additionalinfo.paidSpons = scope.sumassuredetail.paidSpons ? scope.sumassuredetail.paidSpons : '';
        scope.additionalinfo.policyType = scope.sumassuredetail.grpIndv ? scope.sumassuredetail.grpIndv : '';
        scope.additionalinfo.annualPremium = scope.employee.annualPremium ? scope.employee.annualPremium : '';
        scope.additionalinfo['id'] = scope.requestDataForDND && scope.requestDataForDND.id ? scope.requestDataForDND.id : null;
        scope.additionalinfo.DND = scope.isInsurer_CallCentre ? scope.agentCustomersDND : null;
        scope.additionalinfo.DNDCustomer = scope.isInsurer_CallCentre ? scope.customersDND : null;
      } else {
        scope.additionalinfo = scope.employee.additionalInfo ? JSON.parse(scope.employee.additionalInfo) : {};
        scope.additionalinfo['insurerRemark'] = scope.remarks ? scope.remarks : null;
        scope.additionalinfo['alternateMobile'] = scope.altMobile ? scope.altMobile : null;
        scope.additionalinfo.lifeno = scope.employee.lifeno ? scope.employee.lifeno : '';
        scope.additionalinfo.casetype = scope.employee.casetype ? scope.employee.casetype : '';
        scope.additionalinfo.clientLocation = scope.employee.city ? scope.employee.city : '';
        scope.additionalinfo.hrLocation = scope.employee.hrLocation ? scope.employee.hrLocation : '';
        scope.additionalinfo.packageOrGrade = scope.employee.packageOrGrade ? scope.employee.packageOrGrade : '';
        scope.additionalinfo.hrMobileNumber = scope.employee.hrMobileNumber ? scope.employee.hrMobileNumber : '';
        scope.additionalinfo.annualPremium = scope.employee.annualPremium ? scope.employee.annualPremium : '';
        scope.additionalinfo.AgentEmailId = scope.additionalinfo.AgentEmailId ? scope.additionalinfo.AgentEmailId : scope.employee.agentEmailAddress ? scope.employee.agentEmailAddress : '';
        scope.additionalinfo.sumAssured = scope.sumassuredetail.sumAssured ? scope.sumassuredetail.sumAssured : '';
        scope.additionalinfo.paidSpons = scope.sumassuredetail.paidSpons ? scope.sumassuredetail.paidSpons : '';
        scope.additionalinfo.policyType = scope.sumassuredetail.grpIndv ? scope.sumassuredetail.grpIndv : '';
        scope.additionalinfo['id'] = scope.requestDataForDND && scope.requestDataForDND.id ? scope.requestDataForDND.id : null;
      }
      if (scope.selectedPackage && scope.selectedPackage.peR_Id) {
        if (scope.selectedPackage.isPaid) {
          scope.totalPrice += Math.round((scope.selectedPackage.packagePrice + scope.selectedPackage.serviceTax +
            scope.selectedPackage.primaryCessTax + scope.selectedPackage.secondaryCessTax +
            scope.selectedPackage.mahsCharge + scope.selectedPackage.krishiKalyanCess +
            scope.selectedPackage.swachhBharatCess) * 100) / 100;
        }
        // var preferredDCOther;
        // 
        // if (scope.user.entityType === 'Insurer') {
        //     preferredDCOther = scope.client.visitType === 'Appointment' ? {
        //         id: scope.selectedDcFromDavanceSearch ? scope.selectedDcFromDavanceSearch.id : null,
        //         name: scope.selectedDcFromDavanceSearch ? scope.selectedDcFromDavanceSearch.entityName : '',
        //         firstPrefTime: scope.firstPrefTime ? scope.firstPrefTime : null,
        //         secPrefTime: scope.secondPrefTime ? scope.secondPrefTime : null
        //     } : { id: 62053, name: 'MAHS',firstPrefTime: scope.client.firstPrefTime ? scope.client.firstPrefTime : null,
        //     secPrefTime: scope.isContractPrePolicy() ? "" : scope.client.secondPrefTime}
        // } else if (scope.user.entityType !== 'Insurer'){
        //     preferredDCOther = scope.selectedDcFromDavanceSearch ? {
        //         id: scope.selectedDcFromDavanceSearch ? scope.selectedDcFromDavanceSearch.id : null,
        //         name: scope.selectedDcFromDavanceSearch ? scope.selectedDcFromDavanceSearch.entityName : '',
        //         firstPrefTime: scope.firstPrefTime ? scope.firstPrefTime : null,
        //         secPrefTime: scope.secondPrefTime ? scope.secondPrefTime : null
        //     } : {}
        // }
        scope.orderItemObj = {
          productId: scope.selectedPackage.peR_Id,
          productName: scope.selectedPackage.packageName,
          productType: scope.selectedContract,
          preferredDC: [scope.preferredDC[0] ? {
            id: scope.preferredDC[0] ? (scope.preferredDC[0][0] ? scope.preferredDC[0][0].id : scope.preferredDC[0].id) : scope.preferredDC[0].id,
            name: scope.preferredDC[0] ? (scope.preferredDC[0][0] ? scope.preferredDC[0][0].entityName : scope.preferredDC[0].entityName) : scope.preferredDC[0].entityName,
            ProviderCity: scope.preferredDC[0] ? (scope.preferredDC[0][0] ? scope.preferredDC[0][0].city.cityName : scope.preferredDC[0].city.cityName) : scope.preferredDC[0].city.cityName,
            ProviderLocation: scope.preferredDC[0] ? (scope.preferredDC[0][0] ? scope.preferredDC[0][0].location.locationName : scope.preferredDC[0].location.locationName) : scope.preferredDC[0].location.locationName,
            firstPrefTime: scope.client.firstPrefTime ? scope.client.firstPrefTime : null,
            secPrefTime: scope.isContractPrePolicy() ? "" : scope.client.secondPrefTime
          } : {
            id: 62053,
            name: 'MAHS',
            firstPrefTime: scope.client.firstPrefTime ? scope.client.firstPrefTime : null,
            secPrefTime: scope.isContractPrePolicy() ? "" : scope.client.secondPrefTime
          }],
          firstName: scope.selectedBeneficiary.name ? scope.selectedBeneficiary.name : scope.employee.name,
          contactNum: scope.employee.mobileNumber,
          isPaid: scope.selectedPackage.isPaid,
          isSponsored: !scope.selectedPackage.isPaid,
          amount: Math.round((scope.selectedPackage.packagePrice + scope.selectedPackage.serviceTax +
            scope.selectedPackage.primaryCessTax + scope.selectedPackage.secondaryCessTax +
            scope.selectedPackage.mahsCharge + scope.selectedPackage.krishiKalyanCess +
            scope.selectedPackage.swachhBharatCess) * 100) / 100,
          MAID: scope.selectedBeneficiary.maid != 0 ? scope.selectedBeneficiary.maid : scope.client.clientCode,
          relation: scope.selectedBeneficiary.relationName,
          city: scope.selectedCity.lookUpValue,
          dob: scope.selectedBeneficiary.dob,
          gender: scope.selectedBeneficiary.gender ? scope.selectedBeneficiary.gender : scope.employee.gender,
          employeeId: scope.client.clientCode,
          emailId: scope.employee.email,
          visitType: scope.client.visitType ? scope.client.visitType : 'Appointment',
          source: scope.employee.sourceId,
          invoiceTo: scope.selectedInsurer ? (scope.selectedInsurer.id ? scope.selectedInsurer.id : 0) : 0,
          alternateEmail: scope.employee.alternateEmail,
          additionalProperties: scope.additionalinfo ? scope.additionalinfo : '',
          addressLine1: scope.client.visitType == 'Home_Visit' ? scope.client.addressline1 : '',
          addressLine2: scope.client.visitType == 'Home_Visit' ? scope.client.addressline2 : '',
          grade: scope.selectedBeneficiary.grade ? scope.selectedBeneficiary.grade : ''
        }
        $('#BookAppointmentBlock').modal('hide');
        if (scope.isContractPharmacy()) {
          scope.orderItemObj.additionalProperties.PharmaOrderPrescriptionFiles = scope.allPrescriptionsPath;
          scope.orderItemObj.additionalProperties.PinCode = scope.pinEntered;
        }
        scope.CartAppointments.push({
          EmployeeId: scope.client.clientCode,
          EntityRelationId: scope.selectedCorporate.id,
          MAID: scope.selectedBeneficiary.maid,
          AppointmentId: 0,
          AppointmentDate: scope.client.firstPrefTime,
          AppointmentStatus: 0
        })
        if (Object.keys(scope.orderObj).length == 0) {
          scope.orderObj = {
            createdByApp: 'Medibuddy Plus',
            amountAfterDiscount: scope.totalPrice,
            actualAmount: scope.totalPrice,
            paymentMode: scope.isContractPharmacy() ? 'COD' : 'IndividualPaid',
            paymentState: 'Unpaid',
            accountNumber: scope.txn.accnumber,
            bankIfscCode: scope.txn.ifsccode,
            transactionId: scope.txn.txnNumber,
            employeeId: scope.client.clientCode,
            entityId: scope.selectedCorporate.id,
            entityName: scope.selectedCorporate.entityName,
            employeeName: scope.employee.name,
            gender: scope.employee.gender,
            contractId: scope.selectedContract,
            employeeEmail: scope.employee.email,
            employeeContactNo: scope.employee.mobileNumber,
            source: scope.employee.sourceId,
            orderItems: [scope.orderItemObj],
            paymentSuccessUrl: 'www.mahs.in',
            paymentFailureUrl: 'www.mediassistindia.com',
            requestAccessToken: UserService.getAccessToken()
          }
          scope.cartEmpty = false;
        } else {
          scope.orderObj.actualAmount = scope.totalPrice;
          scope.orderObj.amountAfterDiscount = scope.totalPrice;
          scope.orderObj.orderItems.push(scope.orderItemObj);
        }
        angular.forEach(scope.orderObj.orderItems, function (item, index) {
          if (item.isPaid) {
            scope.showPaid = true;
          }
        });
        scope.selectedPackage = {};
        if (scope.isContractPharmacy()) {
          scope.selectedPackage = scope.PharmacyPackage;
          scope.pinEntered = '';
          scope.FileDetails = [];
        }
        if (scope.isContractEsales()) {
          scope.tests = [];
          scope.loadEsalesPackages();
        }
        if (scope.isContractPreEmployment()) {
          scope.loadPreEmpPackages();
        }
        if (scope.isContractPrePolicy()) {
          scope.loadPrePolicyPackages();
        }
        scope.selectedBeneficiary = {};
        scope.cartEmpty = false;
      } else {
        if (scope.selectedPackageForAdvance.length > 0) {
          scope.totalPriceData = 0;
          scope.orderItemList = [];
          angular.forEach(scope.selectedPackageForAdvance, function (data, index) {
            scope.totalPriceData += Math.round((data.packagePrice + data.serviceTax + data.primaryCessTax +
              data.secondaryCessTax + data.mahsCharge + data.krishiKalyanCess + data.swachhBharatCess) * 100) / 100;
            if (data.isPaid === true) {
              scope.totalPrice += Math.round((data.packagePrice + data.serviceTax + data.primaryCessTax +
                data.secondaryCessTax + data.mahsCharge + data.krishiKalyanCess + data.swachhBharatCess) * 100) / 100;
            } else {
              scope.totalPrice = 0;
            }
            var preferredDC = null;
            if (scope.user.entityType) {
              if (scope.user.entityType === 'Insurer') {
                preferredDC = scope.client.visitType === 'Appointment' ? {
                  id: scope.selectedDcFromDavanceSearch ? scope.selectedDcFromDavanceSearch.id : null,
                  name: scope.selectedDcFromDavanceSearch ? scope.selectedDcFromDavanceSearch.entityName : '',
                  ProviderCity: scope.selectedDcFromDavanceSearch ? (scope.selectedDcFromDavanceSearch.city ? scope.selectedDcFromDavanceSearch.city.cityName : '') : '',
                  ProviderLocation: scope.selectedDcFromDavanceSearch ? (scope.selectedDcFromDavanceSearch.location ? scope.selectedDcFromDavanceSearch.location.locationName : '') : '',
                  firstPrefTime: scope.firstPrefTime ? scope.firstPrefTime : null,
                  secPrefTime: scope.secondPrefTime ? scope.secondPrefTime : null
                } : {
                  id: 62053,
                  name: 'MAHS',
                  firstPrefTime: scope.client.firstPrefTime ? scope.client.firstPrefTime : null,
                  secPrefTime: scope.isContractPrePolicy() ? "" : scope.client.secondPrefTime
                }
              } else if (scope.user.entityType !== 'Insurer') {
                preferredDC = scope.selectedDcFromDavanceSearch ? {
                  id: scope.selectedDcFromDavanceSearch ? scope.selectedDcFromDavanceSearch.id : null,
                  name: scope.selectedDcFromDavanceSearch ? scope.selectedDcFromDavanceSearch.entityName : '',
                  ProviderCity: scope.selectedDcFromDavanceSearch ? (scope.selectedDcFromDavanceSearch.city ? scope.selectedDcFromDavanceSearch.city.cityName : '') : '',
                  ProviderLocation: scope.selectedDcFromDavanceSearch ? (scope.selectedDcFromDavanceSearch.location ? scope.selectedDcFromDavanceSearch.location.locationName : '') : '',
                  firstPrefTime: scope.firstPrefTime ? scope.firstPrefTime : null,
                  secPrefTime: scope.secondPrefTime ? scope.secondPrefTime : null
                } : {}
              }
            } else {
              preferredDC = {
                id: scope.selectedDcFromDavanceSearch ? scope.selectedDcFromDavanceSearch.id : null,
                name: scope.selectedDcFromDavanceSearch ? scope.selectedDcFromDavanceSearch.entityName : '',
                ProviderCity: scope.selectedDcFromDavanceSearch ? (scope.selectedDcFromDavanceSearch.city ? scope.selectedDcFromDavanceSearch.city.cityName : '') : '',
                ProviderLocation: scope.selectedDcFromDavanceSearch ? (scope.selectedDcFromDavanceSearch.location ? scope.selectedDcFromDavanceSearch.location.locationName : '') : '',
                firstPrefTime: scope.firstPrefTime ? scope.firstPrefTime : null,
                secPrefTime: scope.secondPrefTime ? scope.secondPrefTime : null
              }
            }
            scope.orderItemList.push({
              productId: data.peR_Id,
              productName: data.packageName,
              productType: scope.selectedContract,
              preferredDC: preferredDC,
              firstName: scope.selectedBeneficiary.name ? scope.selectedBeneficiary.name : scope.employee.name,
              contactNum: scope.employee.mobileNumber,
              isPaid: data.isPaid,
              isSponsored: !data.isPaid,
              amount: Math.round((data.packagePrice + data.serviceTax + data.primaryCessTax + data.secondaryCessTax +
                data.mahsCharge + data.krishiKalyanCess + data.swachhBharatCess) * 100) / 100,
              MAID: scope.selectedBeneficiary.maid != 0 ? scope.selectedBeneficiary.maid : scope.client.clientCode,
              relation: scope.selectedBeneficiary.relationName,
              city: scope.selectedCity ? scope.selectedCity.lookUpValue : '',
              dob: scope.selectedBeneficiary.dob,
              gender: scope.selectedBeneficiary.gender ? scope.selectedBeneficiary.gender : scope.employee.gender,
              employeeId: scope.client.clientCode,
              emailId: scope.employee.email,
              visitType: scope.client.visitType ? scope.client.visitType : 'Appointment',
              source: scope.employee.sourceId,
              invoiceTo: scope.selectedInsurer ? (scope.selectedInsurer.id ? scope.selectedInsurer.id : 0) : 0,
              alternateEmail: scope.employee.alternateEmail,
              additionalProperties: scope.additionalinfo ? scope.additionalinfo : '',
              addressLine1: scope.client.visitType === 'Home_Visit' ? scope.client.addressline1 : '',
              addressLine2: scope.client.visitType === 'Home_Visit' ? scope.client.addressline2 : '',
              grade: scope.selectedBeneficiary.grade ? scope.selectedBeneficiary.grade : ''
            })
          });
          if (scope.employee.name) {
            scope.orderObj = {
              createdByApp: 'Medibuddy Plus',
              amountAfterDiscount: scope.totalPrice,
              actualAmount: scope.totalPrice,
              paymentMode: scope.isContractPharmacy() ? 'COD' : 'IndividualPaid',
              paymentState: 'Unpaid',
              accountNumber: scope.txn.accnumber,
              bankIfscCode: scope.txn.ifsccode,
              transactionId: scope.txn.txnNumber,
              employeeId: scope.client.clientCode,
              entityId: scope.selectedCorporate.id,
              entityName: scope.selectedCorporate.entityName,
              employeeName: scope.employee.name,
              gender: scope.employee.gender,
              contractId: scope.selectedContract,
              employeeEmail: scope.employee.email,
              employeeContactNo: scope.employee.mobileNumber,
              source: scope.employee.sourceId,
              orderItems: scope.orderItemList,
              paymentSuccessUrl: 'www.mahs.in',
              paymentFailureUrl: 'www.mediassistindia.com',
              requestAccessToken: UserService.getAccessToken()
            }
          } else {
            UtilitiesService.showAlertMessage('Please fill customer details.');
          }
          scope.cartEmpty = false;
          if (scope.isContractPreEmployment()) {
            scope.loadPreEmpPackages();
          }
          if (scope.isContractPrePolicy()) {
            scope.loadPrePolicyPackages();
          }
          scope.selectedBeneficiary = {};
        } else {
          $("#BookAppointmentBlock").modal('hide');
          UtilitiesService.showAlertMessage('Select a package.');
        }
      }
      scope.isGoogleMap = false;
      scope.client.selectedPackage = '';
      scope.client.beneficiary = '';
      //scope.current.newStateId = '';
    }
    scope.updateProcessedStatus = function (requestId, orderId) {
      var url = UtilitiesService.getPlusUrlPrefix() + '/IsProcessedPolicyBazaar/' + requestId + '/' + orderId;
      UserService.makeRestCall(url, '', 'GET', UserService.getAccessToken()).then(function (response) {
        scope.showFirst();
        scope.showSuccessMessage = true;
        scope.orderObj = {};
        scope.orderItemObj = {};
        scope.totalPrice = 0;
        scope.cartEmpty = true;
        scope.showAddTestBox = false;
      }, function (error) {
        // console.log(error);
        UtilitiesService.showAlertMessage('PolicyBazaar request could not be updated.');
      })
    }

    scope.checkDuplicacy = function () {
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/CheckEsalesOrderDuplicacy', scope.orderObj, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          if (response.data.isDuplicate) {
            scope.isCart = false;
            UtilitiesService.showAlertMessage('We already have appointment similar to this request, please check before you proceed.');
          } else {
            scope.createAppointment();
          }
        } else {
          UtilitiesService.showAlertMessage('Unable to proceed in booking order');
        }
      });
    }


    scope.createAppointment = function () {
      scope.isCart = !scope.isCart;
      if ((!scope.showPaid || scope.validateFinance()) && scope.paid) {
        scope.cartEmpty = true;
        scope.orderObj.amountAfterDiscount = scope.orderObj.amountAfterDiscount + scope.calculatePrice();
        scope.orderObj.additionals = scope.calculatePriceData();

        var urlForOrder = "https://fuser.medibuddy.in/api/v1/request/generic/createAppointmentapiplus"
        // if (scope.user.entityType != "Insurer") {
        //   urlForOrder = UtilitiesService.getPlusUrlPrefix() + "/order";
        // }

        UserService.makeRestCall(urlForOrder, scope.orderObj, 'POST').then(function (response) {
          // UserService.makeRestCall(UtilitiesService.getPlusUrl() + '/BookOrder', scope.orderObj, 'POST', UserService.getAccessToken()).then(function (response) {
          scope.entityProperties = [];
          scope.entityPropertiesDummy = [];
          if (response.data.isSuccess) {
            scope.additionalinfo = {};
            scope.additionalFieldList = ['hrLocation', 'hrMobileNumber', 'hrName', 'AgentEmailId', 'AgentName', 'AgentContactNo',
              'Entity', 'CaseType', 'Aadhar', 'PAN', 'packageOrGrade', 'lifeno', 'clientLocation', 'SMName', 'SM_Email', 'SMPhoneNumber'
            ];
            scope.orderData = response.data;
            if (scope.pbrequestid) {
              scope.updateProcessedStatus(scope.pbrequestid, scope.orderData.orderId);
            }

            if ($state && $state.current.name === 'esales') {
              scope.isPackageSelectionManual = false;
              scope.isPackageSelectionAdvance = false;
              scope.selectedPackageForAdvance = [];
              scope.sumassuredetail.sumAssured = '';
              UtilitiesService.showAlertMessage('Your appointment request is taken and customer will get the confirmation shortly via SMS/Email.', true);
            }
            scope.showSuccess();
          } else {
            var errorMsg = 'Appointment creation failed';
            if (response && response.data && response.data.errorMessage) {
              errorMsg = errorMsg + ' - ' + response.data.errorMessage;
            }
            UtilitiesService.showAlertMessage(errorMsg);
          }
        }, function (error) {
          scope.orderObj = {
            orderItems: []
          };
          UtilitiesService.showAlertMessage('Something went wrong, please try again.');
        });
      } else if ((!scope.showPaid || scope.validateFinance()) && !scope.paid) {
        scope.cartEmpty = true;
        scope.cart_order = {}
        scope.cart_order = {
          order: scope.orderObj
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/cart', scope.cart_order, 'POST').then(function (response) {
          if (response.data.isSuccess) {
            scope.orderData = response.data;
            if ($state && $state.current.name === 'esales') {
              scope.isPackageSelectionManual = false;
              scope.isPackageSelectionAdvance = false;
              scope.selectedPackageForAdvance = [];
              scope.sumassuredetail.sumAssured = '';
              UtilitiesService.showAlertMessage('Appointment created successfully.', true);
            }

            scope.showSuccess();
          } else {
            var errorMsg = 'Appointment creation failed';
            if (response && response.data && response.data.errorMessage) {
              errorMsg = errorMsg + ' - ' + response.data.errorMessage;
            }
            UtilitiesService.showAlertMessage(errorMsg);
          }
        }, function (error) {
          UtilitiesService.showAlertMessage('Something went wrong, please try again.');
        });
      } else {
        UtilitiesService.showAlertMessage('Transaction details are mandatory as order contains paid packages');
      }
    }
    scope.validation = function () {
      return true;
      var valid = true;
      $(".required").removeClass("required");
      if (!$("#mobilenumber").val() || $("#mobilenumber").val() == "") {
        valid = false;
        $("#mobilenumber").addClass("required");
      }
      if (!$("#benefId").val() || $("#benefId").val() == "") {
        valid = false;
        $("#benefId").addClass("required");
      }
      if (!$("#packageId").val() || $("#packageId").val() == "") {
        valid = false;
        $("#packageId").addClass("required");
      }
      if (!$("#firstDCId").val() || $("#firstDCId").val() == "") {
        valid = false;
        $("#firstDCId").addClass("required");
      }
      if (!$("#secondDCId").val() || $("#secondDCId").val() == "") {
        valid = false;
        $("#secondDCId").addClass("required");
      }
      if (!$("#datetimeFirst").val() || $("#datetimeFirst").val() == "") {
        valid = false;
        $("#datetimeFirst").addClass("required");
      }
      if (!$("#datetimeSecond").val() || $("#datetimeSecond").val() == "") {
        valid = false;
        $("#datetimeSecond").addClass("required");
      }
      return valid;
    }
    scope.validateFinance = function () {
      var valid = true;
      $(".required").removeClass("required");
      if ((!scope.txn.txnNumber || scope.txn.txnNumber == "") && scope.paid) {
        valid = false;
        $("#txnNumber").addClass("required");
      } else {
        scope.orderObj.transactionId = scope.txn.txnNumber;
      }
      return valid;
    }
    scope.removeOrderItem = function (item, event) {
      scope.totalPrice -= item.amount;
      var index = scope.orderObj.orderItems.indexOf(item);
      scope.CartAppointments.splice(index, 1);
      scope.packages = [];
      scope.selectedPackage = {};
      scope.orderObj.orderItems.splice(index, 1);
      var flag = 0;
      if (scope.orderObj.orderItems.length > 0) {
        angular.forEach(scope.orderObj.orderItems, function (data, index) {
          if (data.isPaid) {
            flag++;
          }
        });
        scope.showPaid = flag !== 0 ? true : false;
        //if (flag !== 0) {
        //    scope.showPaid = true;
        //} else {
        //    scope.showPaid = false;
        //}
      } else {
        scope.cartEmpty = true;
        scope.showPaid = false;
      }
    }
    scope.fetchAgent = function () {
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/getAgent/' + scope.agentCode, '', 'GET').then(function (response) {
        scope.agentDetails.search = false;
        scope.agentDetails.agentFound = response.data.isSuccess;
        if (response.data.isSuccess) {
          scope.agentDetails = response.data.agentDetails;
          if (scope.agentDetails) {
            scope.agentDetails.agentFound = response.data.isSuccess
          }
        }
      });
    }
    scope.createAgent = function () {
      scope.agentDetails.created = false;
      scope.agentDetails.failed = false;
      var data = {
        agentDetails: scope.agentDetails
      };
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/createAgent', data, 'POST', UserService.getAccessToken()).then(function (response) {
        if (response.data.isSuccess) {
          scope.agentDetails = {};
          scope.agentDetails.created = true;
        } else {
          scope.agentDetails = {};
          scope.agentDetails.failed = true;
        }
      });
    };

    scope.uploadPrescriptions = function ($files, errFile) {
      if (window.FormData) {
        formdata = new FormData();
      }
      for (var i = 0; i < $files.length; i++) {
        scope.file = $files[i];
        scope.allImg = [];
        scope.allImg.push($files);
        scope.nameOfAllImg = scope.allImg[0];
        if (formdata) {
          formdata.append('prescription[]', scope.file);
          formdata.append('type', 'prescription');
        }
      }
      UserService.uploadImgCalls(UtilitiesService.getPlusUrlPrefix() + '/File', formdata, 'POST').then(function (response) {
        if (response) {
          for (var key in response.data) {
            scope.FileDetails.push({
              name: response.data[key],
              fileuploadid: key
            })
          }
        }
      })
    };
    scope.removePres = function (index) {
      scope.FileDetails.splice(index, 1);
      // console.log(scope.nameOfAllImg);
    };

    scope.getAllowedPackage = function (id) {
      if (id) {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/CorporatePackageProvider/' + id + '/false', '', 'GET').then(function (list) {
          scope.allowedPackages = list.data;
        });
      }
    };
    scope.isPackageSelectionManual = false;
    scope.isPackageSelectionAdvance = false;
    scope.collapsed = false;
    scope.DCSelection = function (vlaue) {
      scope.isPackageSelectionManual = vlaue === 'manula' ? true : false;
      scope.isPackageSelectionAdvance = vlaue === 'advance' ? true : false;
      scope.locationName.autocomplete = '';
      scope.markerArray = [];
      scope.advanceDcList = [];
      scope.diagnosticCentres = [];
      scope.client.preferredDC = [];
      scope.manual.firstDate = '';
      scope.manual.secondDate = '';
    };

    scope.loadDcForAllPackages = function (newSubLocationId) {
      var perIdsList = [];
      angular.forEach(scope.selectedPackageForAdvance, function (e, i) {
        perIdsList.push(e.peR_Id);
      });
      if (scope.location.state && scope.location.location && newSubLocationId) {
        var data = {
          packageIds: perIdsList,
          stateId: scope.location.state,
          cityId: scope.location.location,
          locationId: newSubLocationId
        };
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'AllEligibleDCByPackageIdsAndByLocation', data, 'POST').then(function (response) {
          if (response.data.length > 0) {
            scope.diagnosticCentres = response.data;
          } else {
            UtilitiesService.showAlertMessage('No Diagnostic Centre found.');
          }
        }, function (error) {
          UtilitiesService.showAlertMessage('Something went wrong, please try again.');
        });
      }
    };
    scope.radious = {
      distance: 2,
      lat: '',
      lng: ''
    };


    scope.isMarkerArray = false;
    scope.loadDcList = function (lat, lng) {
      var perIdsList = [];
      angular.forEach(scope.selectedPackageForAdvance, function (e, i) {
        perIdsList.push(e.peR_Id);
      });
      scope.markerArray = [];
      if (lat && lng) {
        scope.radious.lat = lat;
        scope.radious.lng = lng;
        var data = {
          packageIds: perIdsList,
          latitude: lat,
          longitude: lng,
          distance: scope.radious.distance,
        };

        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'AllEligibleDCByPackageIdsAndByLocation', data, 'POST').then(function (response) {
          if (response.data.length > 0) {
            scope.isMarkerArray = false;
            scope.advanceDcList = response.data;
            angular.forEach(scope.advanceDcList, function (data, index) {
              scope.markerArray.push({
                id: scope.advanceDcList[index].id,
                entityAddress: scope.advanceDcList[index].entityAddress,
                pinCode: scope.advanceDcList[index].pinCode,
                coords: {
                  latitude: scope.advanceDcList[index].latitude,
                  longitude: scope.advanceDcList[index].longitude,
                },
                entityName: scope.advanceDcList[index].entityName,
                marker: false
              });
              scope.windowOptions[scope.advanceDcList[index].id] = {
                visible: false,
              }
            })
            scope.map = {
              center: {
                latitude: scope.lat,
                longitude: scope.lng
              },
              stroke: {
                color: '#08B21F',
                weight: 2,
                opacity: 1
              },
              fill: {
                color: '#08B21F',
                opacity: 0.5
              },
              markersEvents: {
                click: function (marker, eventName, model, arguments) {
                  angular.forEach(scope.markerArray, function (data, index) {
                    if (parseInt(data.id) === parseInt(marker.key)) {
                      scope.markerArray[index].visible = true;
                    } else {
                      scope.markerArray[index].visible = false;
                    }
                  })
                }
              },
              window: {
                marker: {},
                show: false,
                closeClick: function (value) {
                  this.show = false;
                },
                options: {},
                title: ''
              },
              radius: 10,
              geodesic: true,
              visible: true,
              zoom: 12
            }
          } else {
            scope.isMarkerArray = true;
            scope.markerArray = [];
            UtilitiesService.showAlertMessage('No Diagnostic Centre found.');
          }
        }, function (error) {
          UtilitiesService.showAlertMessage('Something went wrong, please try again.');
        });
      }
    };

    scope.changeDistance = function (distance) {
      if (distance) {
        scope.radious.distance = distance.value;
        scope.loadDcList(scope.radious.lat, scope.radious.lng);
      } else {
        scope.radious.distance = 5;
        scope.loadDcList(scope.radious.lat, scope.radious.lng);
      }
    }

    scope.changeDC = function (selectedDC, pref) {
      scope.preferredDC[pref - 1] = selectedDC;
    };

    scope.selectedDcFromMap = function (markerObj, $event) {
      if (markerObj) {
        scope.selectedDcFromDavanceSearch = markerObj;
        scope.windowParams.list = scope.selectedDcFromDavanceSearch;
      } else {
        scope.selectedDcFromDavanceSearch = '';
        scope.windowParams.list = scope.selectedDcFromDavanceSearch;
      }
    };

    scope.showMarkerInfo = function (markerObj, $event) {
      if (markerObj) {
        var getSelectedDc = filterFilter(scope.diagnosticCentres, {
          'entityId': markerObj.entityId
        }, true);
        scope.changeDC(getSelectedDc, 1)
      }
    };

    scope.client.visitType = '';
    scope.bookAppointmentDate = function (firstDate, firstTime) {
      if (scope.employee.name) {
        scope.firstPrefTime = UtilitiesService.mergeDateTimeObj(scope.manual.firstDate, scope.manual.firstTime);
        scope.secondPrefTime = UtilitiesService.mergeDateTimeObj(scope.manual.secondDate, scope.manual.secondTime);
        scope.addToCart(scope.manual.firstDate, scope.manual.firstTime, scope.manual.secondDate, scope.manual.secondTime);
        scope.isCart = !scope.isCart;
      } else {
        UtilitiesService.showAlertMessage('Please fill customer details.');
      }
    };
    scope.closeCart = function () {
      scope.isCart = !scope.isCart;
    };

    scope.closeClick = function (id, $event) {
      scope.windowOptions[id].visible = false;
    };

    scope.$on('gmPlacesAutocomplete::placeChanged', function (key, value) {
      if (value && value._api) {
        var location = value._api.getPlace().geometry.location;
        scope.lat = location.lat();
        scope.lng = location.lng();
        scope.$apply();
        scope.loadDcList(scope.lat, scope.lng);
      }
    });

    scope.showDndBell = false;
    scope.showDndCustomerBell = false;
    scope.parseAdditionalInfo = function () {
      scope.requestDataForDND.requestJSON.additionalInfo = scope.requestDataForDND.requestJSON.additionalInfo instanceof Object ? scope.requestDataForDND.requestJSON.additionalInfo : JSON.parse(scope.requestDataForDND.requestJSON.additionalInfo)
      scope.requestDataForDND.requestJSON.additionalInfo.DND =
        scope.requestDataForDND.requestJSON.additionalInfo.hasOwnProperty('DND') ? JSON
          .parse(scope.requestDataForDND.requestJSON.additionalInfo.DND) : false;
      scope.requestDataForDND.requestJSON.additionalInfo.DNDCustomer = scope.requestDataForDND.requestJSON.additionalInfo.hasOwnProperty('DNDCustomer') ? JSON.parse(scope.requestDataForDND.requestJSON.additionalInfo.DNDCustomer) : false;
    }
    scope.checkForDNDFlags = function () {
      scope.requestDataForDND.requestJSON = JSON.parse(scope.requestDataForDND.requestJSON);
      if (scope.requestDataForDND.requestJSON && scope.requestDataForDND.requestJSON.additionalInfo) {
        scope.parseAdditionalInfo();

        scope.showDndBell = scope.requestDataForDND.requestJSON.additionalInfo.DND;
        scope.showDndCustomerBell = scope.requestDataForDND.requestJSON.additionalInfo.DNDCustomer
      } else {
        scope.requestDataForDND.requestJSON['additionalInfo'] = {
          DND: false,
          DNDCustomer: false
        };
        scope.showDndBell = scope.requestDataForDND.requestJSON.additionalInfo.DND;
        scope.showDndCustomerBell = scope.requestDataForDND.requestJSON.additionalInfo.DNDCustomer;
      }

    }

    scope.showDndDiv = false;

    scope.loadStates();
    if (sharedDataService.getLocalStorageDataObj() && sharedDataService.getLocalStorageDataObj().contractID) {
      scope.showDndDiv = true;
      scope.showData = {
        TestDetails: ''
      };
      var args = sharedDataService.getLocalStorageDataObj();
      scope.requestDataForDND = JSON.parse(JSON.stringify(args));
      scope.checkForDNDFlags();
      scope.selectedContract = args.contractID;
      scope.selectedCorporate.id = args.eR_ID;
      var data = args.requestJSON ? JSON.parse(args.requestJSON) : args;
      scope.getDetailsHelp = data;
      scope.getDetailsHelpTestDetails = scope.getDetailsHelp ? scope.getDetailsHelp.testDetails : [];
      angular.forEach(scope.getDetailsHelpTestDetails, function (e, i) {
        e.appointmentDate = e.appointmentDate == '/Date(-62135596800000-0000)/' ? null : e.appointmentDate;
      });
      scope.preffered_DC_Name = data.prefferedDCName;
      scope.stateName = data.state;
      scope.additional_Info = data.additionalInfo;
      if (scope.additional_Info) {
        var getAdditionalInfo = scope.additional_Info instanceof Object ? scope.additional_Info : JSON.parse(scope.additional_Info);
        var newAdditionalInfo = [];
        angular.forEach(getAdditionalInfo, function (key, index) {
          newAdditionalInfo.push({
            index: index,
            key: key
          });
        })
        scope.newAdditionalInfo = newAdditionalInfo;
      }
      scope.showData.TestDetails = data.testDetails;
      scope.employee = {
        name: data.name ? data.name : (data.Name ? data.Name : ''),
        age: args.age,
        gender: args.gender,
        email: data.emailId,
        mobileNumber: data.mobileNumber,
        city: data.city,
        division: data.division,
        hrName: data.hrName,
        lifeno: data.lifeNo,
        additionalInfo: data.additionalInfo, // ? JSON.parse(data.additionalInfo) : data.additionalInfo,
        casetype: data.caseType,
        hrLocation: data.hrLocation,
        packageOrGrade: data.packageOrGrade,
        hrMobileNumber: data.hrMobileNumber
      }
      if (args.id) {
        scope.pbrequestid = args.id;
      }
      // scope.additionalDetails = false;

      // scope.showAdditionalDetails = function() {
      //     scope.additionalDetails = !scope.additionalDetails
      // }
      scope.selectedCorporate.entityName = data.corporateName ? data.corporateName : sharedDataService.getLocalStorageDataObj().corporateName;
      scope.selectedInsurer.id = data.invoiceTo;
      scope.client.clientCode = data.offerID;

      scope.client.clientCode = data.employeeId;
      scope.agentDetails.agentName = args.agentName;
      scope.agentDetails.agentCode = args.agentCode;
      scope.agentDetails.agentMobileNo = args.agentPhoneNo;
      scope.agentDetails.insuranceCompanyName = args.corporateName;

      sharedDataService.destroyLocalStorageDataObj();
      if (scope.selectedContract == 9717) {
        scope.showNextStep('preemp');
      }
      if (scope.selectedContract == 4625) {
        scope.showNextStep('prepolicy');
      }
      if (scope.selectedContract == 9782) {
        scope.showNextStep('esales');
      }
    }
    //Date Object
    scope.today = function () {
      scope.client.secondPrefTime = new Date();
      scope.client.firstPrefTime = new Date();
      scope.dt = new Date();
    };
    scope.today();


    //DOB
    scope.dateOptionsDob = {
      //dateDisabled: disabled,
      formatYear: 'yy',
      maxDate: new Date(),
      //minDate: new Date(),
      startingDay: 1
    };
    // Disable weekend selection
    function disabled(data) {
      var date = data.date,
        mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    }

    scope.dateOptions = {
      dateDisabled: disabled,
      formatYear: 'yy',
      minDate: new Date(),
      startingDay: 1
    };

    scope.disabled1 = function (date, mode) {
      return (mode === 'day' && (date.getDay() === 0));
    };
    scope.open1 = function () {
      scope.popup1.opened = true;
    };

    scope.open2 = function () {
      scope.popup2.opened = true;
    };
    //prePolicy
    scope.popup3 = {
      opened: ''
    }
    scope.open = function ($event) {
      $event.preventDefault();
      $event.stopPropagation();

      scope.popup3.opened = true;
    };

    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];

    scope.popup1 = {
      opened: false
    };

    scope.popup2 = {
      opened: false
    };

    //Set Time Object
    var first = new Date();
    var dd = new Date(first).getDate();
    var mm = new Date(first).getMonth() + 1;
    var yy = new Date(first).getFullYear();
    var hh = 8;
    var ms = 0;
    var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
    scope.userTime.firstAppointmentTime = new Date(x);
    scope.userTime.secondAppointmentTime = new Date(x);

    scope.hstep = 1;
    scope.mstep = 30;

    scope.ismeridian = false;

    //First time limit
    var maxFirst = new Date();
    maxFirst.setHours(18);
    maxFirst.setMinutes(0);
    scope.maxFirst = maxFirst;

    var minFirst = new Date();
    minFirst.setHours(8);
    minFirst.setMinutes(0);
    scope.minFirst = minFirst;

    //Second time limit
    var maxSecond = new Date();
    maxSecond.setHours(18);
    maxSecond.setMinutes(0);
    scope.maxSecond = maxSecond;

    var minSecond = new Date();
    minSecond.setHours(8);
    minSecond.setMinutes(0);
    scope.minSecond = minSecond;
    scope.userTime.secondAppointmentTime = scope.minSecond;

    //Event Listner for close marker in google map
    scope.windowParams = {
      list: scope.selectedDcFromDavanceSearch,
      doIt: function (markerDetails) {
        if (scope.manual.firstDate) {
          scope.bookAppointmentDate(scope.manual.firstDate, scope.manual.firstTime);
        } else {
          UtilitiesService.showAlertMessage('Please select appointment date.');
        }
      }
    }

    if ($state && $state.current.name === 'esales') {
      scope.packages = [];
      scope.tests = [];
      scope.selectedPackageForAdvance = [];
      scope.packages = [];
      scope.markerArray = [];
      var reId = scope.selectedCorporate;
      scope.isPackageSelectionAdvance = false;
      scope.selectedBeneficiary = {};
      scope.totalPriceData = 0;

      var data = {};
      if (scope.user.entityId === 1039391) {
        data = {
          entityName: 'ADITYA BIRLA Wellness',
          id: '238781'
        }
        scope.selectedContract = 4625;
        scope.setSource(data);
        scope.getPriceList(238781);
      } else if (scope.user.entityId === 1005309) {
        data = {
          entityName: 'Aditya Birla Sun life Insurance Company',
          id: '313667'
        }
        scope.selectedContract = 9782;
        scope.setSource(data);
        scope.getPriceList(313667);
      } else {
        data = {
          entityName: 'Aditya Birla Health Insurance Company',
          id: '177310'
        }
        scope.selectedContract = 9782;
        scope.setSource(data);
        scope.getPriceList(177310);
      }


    }
  }]);

angular.module('mbplus')
.controller('notificationCtrl', ['$rootScope', '$scope', '$timeout', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$stateParams', '$analytics', function ($rootScope, scope, $timeout, $location, UserService, UtilitiesService, filterFilter, $stateParams, $analytics) {
  $analytics.pageTrack('/notification');
  if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }
  scope.formatCurrency = UtilitiesService.formatCurrency;
  scope.compareDate = UtilitiesService.compareDate;
  scope.user = UserService.getUserObj();
  scope.user = { role: '' };
  if (UserService.getUserObj()) {
    scope.userRoles = UserService.getUserObj().rolesFeatures.roles;
    if (scope.userRoles.length > 1) {
      angular.forEach(scope.userRoles, function (value, key) {
        if (value.roleName === 'cms') {
          scope.user.role = 'CMS';
        }
      });
    } else {
      scope.user.role = scope.userRoles[0].roleName === 'cms' ? 'CMS' : '';
    }
  }
  scope.formatTime = UtilitiesService.formatTime;
  scope.totalItems = 0;
  scope.currentPage = 1;
  scope.itemsPerPage = 10;
  scope.maxSize = 5;
  //Fetch Notification List
  scope.getNotificationList = function (type, pageNumber, pageSize) {
    UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hospital/notifications/details/" + UserService.getHospitalObj().cmsHospId + "/" + type + "/" + pageNumber + "/" + pageSize, "", "GET").then(function (response) {
      if (response.data.isSuccess) {
        scope.hospitalNotifcations = response.data.hospitalNotifcations;
        angular.forEach(scope.hospitalNotifcations, function (e, i) {
          e.notificationData = JSON.parse(e.actionBody);
          e.isHighlighted = true;
        });
      }
    }, function (error) {
      // console.log("Error : " + error);
    });
  };
  scope.showDetail = function (notification) {
    scope.claimSearhByClaimIdResults = undefined;
    scope.notify = notification;
    scope.notify.claimAction = UserService.toTitleCase(scope.notify.claimAction);
    if (scope.user.role != 'CMS')
      scope.markAsRead(false, notification.notificationId);
  };
  scope.markAsRead = function (all, notificationId) {
    if (all && all == true) {
      angular.forEach(scope.hospitalNotifcations, function (e, i) {
        e.isHighlighted = false;
      });
    }
    var data = {
      "hospitalId": UserService.getHospitalObj().cmsHospId,
      "notificationId": notificationId,
      "notificationType": scope.param,
      "markAllAsRead": all,
      "readByUser": UserService.getUserObj().userName ? UserService.getUserObj().userName : UserService.getUserObj().firstName
    };
    UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hospital/notifications/markread/", data, "POST").then(function (response) {
      if (response.data.isSuccess) {
        $rootScope.$emit('readNotification', notificationId);
      }
    }, function (error) {
      // console.log("Error : " + error);
    });
  };
  scope.getClaimDetails = function (claimId) {
    UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/claim/claimdetails/" + UserService.getHospitalObj().hospId + "/" + claimId, "", "GET").then(function (response) {
      if (response.data.isSuccess) {
        scope.claimSearhByClaimIdResults = response.data.claimDetails;
      } else {
        alert(response.data.errorMessage);
      }
    }, function (error) {
      // console.log("Error : " + error);
      alert(response.data.errorMessage);
    });
  };
  angular.element(document).ready(function () {
    if ($stateParams.type) {
      scope.param = $stateParams.type.split('-')[0];
      scope.totalItems = $stateParams.type.split('-')[1];
      switch (scope.param) {
        case 'APPROVED':
          scope.notificationType = 'Approved Claims';
          break;
        case 'IN_PROGRESS':
          scope.notificationType = 'Claims Under Process';
          break;
        case 'INFO_REQUIRED':
          scope.notificationType = 'Information Required';
          break;
        case 'PAYMENT':
          scope.notificationType = 'Settled Claims';
          break;
        case 'CANCELLED':
          scope.notificationType = 'Cancelled Claims';
          break;
        case 'DENIED':
          scope.notificationType = 'Denied Claims';
          break;
      }
      scope.getNotificationList(scope.param, 1, scope.itemsPerPage);
    }
  });
}]);
angular.module('mbplus')
.controller('maNotificationCtrl', ['$rootScope', '$scope', 'UtilitiesService', 'UserService', function (rootScope, scope, UtilitiesService, UserService) {

    if (UserService.getUserObj()) {
        if (UserService.getUserObj().rolesFeatures) {
            scope.userRolesFeatures = UserService.getUserObj().rolesFeatures.roles;
        } else {
            UserService.destroyUserObj();
        }
    }
    scope.notificationData = [];
    scope.formatTime = UtilitiesService.formatTime;
    scope.compareDate = UtilitiesService.compareDate;
    scope.notificationData = UtilitiesService.maNotificationData ? UtilitiesService.maNotificationData : [];
    rootScope.$on('notificationData', function (event, args) {
        if (args) {
            scope.notificationData = args ? args : [];
        }
    });

    scope.user = UserService.getUserObj();
    scope.markAsComplet = function (data, index) {
        if (data && scope.user) {
            var id = [];
            id.push(data.Id)
            var data = {
                notificationID: id,
                accessToken: scope.user.accessToken
            }
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'UpdateNotification', data, 'POST').then(function (response) {
                if (response.data) {
                    UtilitiesService.showAlertMessage('Mark as completed successfully.', true);
                }
            }, function (error) {
            });
        }
    };
}]);
angular.module('mbplus')
.controller('newAdmissionCtrlCataract', ['$scope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$stateParams', '$analytics', 'navConstantsSvc', function (scope, $location, UserService, UtilitiesService, filterFilter, $stateParams, $analytics, navConstantsSvc) {
    $analytics.pageTrack('/newAdmission');
    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() === 'insurer') {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    scope.user = UserService.getUserObj();
    scope.hospitalObj = UserService.getHospitalObj();
    var erIDs = navConstantsSvc.erIDs;
    // var hosp = [50610,51022,50212,50274,51140,50658,50584,59321,55809,54105,81021,50354,50517,94864,77100,89027,50242,50859,51755,84724,60220];

    // scope.isNewAdmission = function(){
    //     scope.isNewAdmissionForm = false;
    //     var hospobj =_.filter(hosp, function(num){ return num === parseInt(scope.hospitalObj.cmsHospId); });
    //     if(hospobj.length >0){
    //         scope.isNewAdmissionForm = true;
    //     }
    //     if(scope.user && scope.user.entityId ===1001510){
    //         scope.isNewAdmissionForm = true;
    //     }
    //     return scope.isNewAdmissionForm;
    // };

    switch ($stateParams.scheme) {
        case 'aarogya':
            scope.showAarogya = true;
            break;
        case '':
            scope.newadmission = true;
            break;
        default:
            scope.newadmission = true;
    }
}]);
angular.module('mbplus')
.controller('newAdmissionCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$stateParams', '$analytics', 'navConstantsSvc', function (scope, $location, UserService, UtilitiesService, filterFilter, $stateParams, $analytics, navConstantsSvc) {
    $analytics.pageTrack('/newAdmission');
    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() === 'insurer') {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    scope.user = UserService.getUserObj();
    scope.hospitalObj = UserService.getHospitalObj();
    var erIDs = navConstantsSvc.erIDs;
    // var hosp = [50610,51022,50212,50274,51140,50658,50584,59321,55809,54105,81021,50354,50517,94864,77100,89027,50242,50859,51755,84724,60220];

    // scope.isNewAdmission = function(){
    //     scope.isNewAdmissionForm = false;
    //     var hospobj =_.filter(hosp, function(num){ return num === parseInt(scope.hospitalObj.cmsHospId); });
    //     if(hospobj.length >0){
    //         scope.isNewAdmissionForm = true;
    //     }
    //     if(scope.user && scope.user.entityId ===1001510){
    //         scope.isNewAdmissionForm = true;
    //     }
    //     return scope.isNewAdmissionForm;
    // };

    switch ($stateParams.scheme) {
        case 'aarogya':
            scope.showAarogya = true;
            break;
        case '':
            scope.newadmission = true;
            break;
        default:
            scope.newadmission = true;
    }
}]);
angular.module("mbplus")
  .controller('misreportsController', ['$scope', '$rootScope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics', 'PlusUtilitiesService', 'orderByFilter', function (scope, $rootScope, $location, UserService, UtilitiesService, filterFilter, $analytics, PlusUtilitiesService, orderByFilter, navConstantsSvc) {
    $analytics.pageTrack('/allappointments');
    if (!UserService.isActive()) {
      UserService.destroyUserObj();
      $location.path('/');
      return false;
    }
    scope.ctrlName = "appointmentsController";
    scope.user = UserService.getUserObj();
    scope.formatTime = UtilitiesService.formatTime;
    scope.compareDate = UtilitiesService.compareDate;
    scope.contracts = PlusUtilitiesService.getContracts();
    scope.corporatesForStatus = [];
    scope.isInsurer = false;
    scope.isDownload = false;
    var visitType, dcId, agentName, agentCode, agentMobileNumber, fitUnfit, fitUnfitRemarks, bloodGroup, referenceRequestId = null
    scope.statusList = [
      { id: -1, entityName: "WIP" },
      { id: 22, entityName: "New Appointment Request" },
      { id: 23, entityName: "Confirmed by Medical Center" },
      { id: 24, entityName: "Confirmed by Ops" },
      { id: 25, entityName: "Confirmed by User" },
      { id: 26, entityName: "Cancelled by Medical Center" },
      { id: 27, entityName: "Cancelled by Ops" },
      { id: 28, entityName: "Cancelled by User" },
      { id: 29, entityName: "Rescheduled by Medical Center" },
      { id: 30, entityName: "Rescheduled by Ops" },
      { id: 31, entityName: "Rescheduled by User" },
      { id: 32, entityName: "Attended" },
      { id: 33, entityName: "Information Awaited" },
      { id: 34, entityName: "Approved" },
      { id: 35, entityName: "Rejected" },
      { id: 36, entityName: "Settled" },
      { id: 37, entityName: "Info submitted" },
      { id: 38, entityName: "Processing" },
      { id: 39, entityName: "Not Attended" },
      { id: 40, entityName: "Customer awaited at DC" },
      { id: 41, entityName: "Un-Approved New Appointment" },
      { id: 42, entityName: "Cancelled" },
      { id: 43, entityName: "User Cancelled" },
      { id: 45, entityName: "Unscheduled Appointment" },
      { id: 48, entityName: "QCApproved" },
      { id: 49, entityName: "InsurerApproved" },
      { id: 82, entityName: "Incorrect Prescription Provided" },
      { id: 83, entityName: "On Hold" },
      { id: 84, entityName: "Delivery Executive Assigned" },
      { id: 85, entityName: "Delivery attempt failed" },
      { id: 86, entityName: "Delivered Partial" },
      { id: 87, entityName: "Delivered" },
      { id: 88, entityName: "Out for Delivery" },
      { id: 89, entityName: "Confirmed by Retailer" },
      { id: 90, entityName: "Rejected by Retailer" },
      { id: 91, entityName: "Placed with Partner" },
      { id: 92, entityName: "Invoice Pending" },
      { id: 93, entityName: "Invoice Generated" },
      { id: 94, entityName: "Callback Required" },
      { id: 96, entityName: "Rejected by Moderator" },
      { id: 97, entityName: "UnFit" },
      { id: 98, entityName: "Fit" },
      { id: 110, entityName: "Prescription PickUp Dispatched ToCollect" },
      { id: 111, entityName: "Prescription PickUp Postponed" },
      { id: 112, entityName: "Prescription PickUp Collected" },
      { id: 113, entityName: "Prescription PickUp Dispatched To Return" },
      { id: 114, entityName: "Prescription Returned To Customer" },
      { id: 115, entityName: "New Cashless Request" },
      { id: 116, entityName: "Partially Attended" },
      { id: 117, entityName: "Rescheduled by Others" },
      { id: 118, entityName: "NotAttended by Others" },
      { id: 119, entityName: "CancelledByInsurer" },
      { id: 120, entityName: "ClosedByInsurer" },
      { id: 121, entityName: "TU Completed" },
      { id: 122, entityName: "TU Scheduled" },
      { id: 123, entityName: "TU Information Awaited" },
      { id: 126, entityName: "FitWithRecommendation" },
      { id: 127, entityName: "FitnessOnHold" },
      { id: 128, entityName: "TemporaryUnfit" },
      { id: 129, entityName: "System Confirmed" },
      { id: 130, entityName: "Non Workable" },
      { id: 134, entityName: "Digitization Pending" },
      { id: 135, entityName: "Digitization Reject" }
    ]

    angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
      if (v.roleId == 9207 || v.roleId == 9211 || v.roleId == 9214 || v.roleId == 9217) {  //insurer admin -- insurer-agent -- insurer branch  -- insurer-ma-report
        scope.isInsurer = true;
      }
    });

    scope.tab1Data = {
      statusContracts: "",
      statusStartDate: "",
      statusEndDate: ""
    };
    scope.tab2Data = {
      dateWiseContracts: "",
      ms: "",
      misstartdate: "",
      misenddate: ""
    };
    scope.dateOptions = {
      formatYear: 'yy',
      maxDate: null,
      startingDay: 1
    };

    scope.open1 = function () {
      scope.popup1.opened = true;
    };
    scope.open2 = function () {
      scope.popup2.opened = true;
    };
    scope.popup1 = {
      opened: false
    };
    scope.popup2 = {
      opened: false
    };

    scope.open1Tab1 = function () {
      scope.open11.opened = true;
    };
    scope.open2Tab1 = function () {
      scope.open22.opened = true;
    };
    scope.open11 = {
      opened: false
    };
    scope.open22 = {
      opened: false
    };
    scope.formats = ['dd-MMM-yyyy'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];
    scope.contracts = [];
    var erIdForAHC = "";
    var erIdForPrePol = "";
    var er_id = [];
    scope.preConfigPofilecheck = false;
    scope.manualSelectCheck = false;
    scope.createProfile = false;
    scope.editProfile = false;
    scope.showDownloadWithProfile = false;
    scope.profilerErID = null;
    scope.preConfigProfile = [];
    scope.selectedProfile = {};

    scope.downloadOptionSelected = function (option) {
      if (option == 'configured') {
        scope.preConfigPofilecheck = true;
        scope.manualSelectCheck = false;
      }
      else if (option == 'manual') {
        scope.manualSelectCheck = true;
        scope.preConfigPofilecheck = false;
      }
    }
    scope.getProfilerMISreports = function () {
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + "ProfilerMISReports/" + scope.profilerErID, "", "GET").then(function (response) {
        scope.createProfile = false;
        scope.editProfile = false;
        if (response.status == 200 && response.statusText == "OK") {
          if (response.data.length) {
            scope.preConfigProfile = response.data;
            scope.preConfigProfile.forEach(function (elem) {
              var options = JSON.parse(JSON.stringify(scope.listToDownload));
              elem.optArr = [];
              options.forEach(function (element) {
                if (elem.profilerFilterData.includes(element.name)) {
                  element.selectedRecord = true;
                  elem.optArr.push(element);
                }
              })
              elem.allOptArr = options
              elem.selectedRecord = false
            })
            scope.selectedProfile = {};
            scope.profileUpdateErrMsg = null
          }
          else {
            scope.preConfigProfile = [];
          }
        }
        else {
          scope.preConfigProfile = [];
        }
      })
    }
    scope.profileSelected = function (profile) {
      scope.selectedProfile = {};
      for (var i = 0; i < scope.preConfigProfile.length; i++) {
        if (scope.preConfigProfile[i].profilename == profile.profilename) {
          scope.preConfigProfile[i].selectedRecord = !scope.preConfigProfile[i].selectedRecord;
          if (scope.preConfigProfile[i].selectedRecord == true) {
            scope.selectedProfile = scope.preConfigProfile[i];
          }
          else {
            scope.selectedProfile = {}
          }
        }
        else {
          scope.preConfigProfile[i].selectedRecord = false
        }
      }
      scope.selectedProfile.selectedRecord ? scope.downloadFinalReportsFrmProfile() : '';
    }
    scope.createEditProfile = function () {
      if (scope.preConfigProfile.length && scope.selectedProfile.selectedRecord) {
        scope.editProfile = true;
        scope.editProfileObj = scope.selectedProfile;
        scope.createProfileObj = {}
        scope.createProfile = false
      }
      else {
        scope.editProfile = false
        scope.editProfileObj = {}
        scope.createProfile = true
        scope.createProfileObj = {}
        scope.createProfileObj.allOptArr = JSON.parse(JSON.stringify(scope.listToDownload));
        scope.createProfileObj.profilerId = 0;
      }
    }
    scope.updateDownloadProfile = function () {
      scope.profileUpdateErrMsg = null
      var call = false;
      var namesArr = [];
      var selectedNamesObj = [];
      if (scope.editProfile) {
        scope.editProfileObj.allOptArr.forEach(function (elem) {
          if (elem.selectedRecord) {
            var el = JSON.parse(JSON.stringify(elem));
            namesArr.push(el.name);
            selectedNamesObj.push(el);
          }
        })
      }
      else if (scope.createProfile) {
        scope.createProfileObj.allOptArr.forEach(function (elem) {
          if (elem.selectedRecord) {
            var el = JSON.parse(JSON.stringify(elem));
            namesArr.push(el.name);
            selectedNamesObj.push(el);
          }
        })
        if (scope.preConfigProfile.length) {
          for (var i = 0; i < scope.preConfigProfile.length; i++) {
            if (scope.preConfigProfile[i].profilename == scope.createProfileObj.profilename) {
              call = false;
              break;
            }
            else {
              call = true;
            }
          }
        }
        else {
          call = true;
        }
      }
      if (scope.editProfile || (scope.createProfile && call)) {
        var data = {
          "profilerID": scope.editProfile ? scope.editProfileObj.profilerId : scope.createProfileObj.profilerId,
          "entityRelationID": scope.profilerErID,
          "profilerFilterData": namesArr,
          "ProfileName": scope.editProfile ? scope.editProfileObj.profilename : scope.createProfileObj.profilename,
          "isActive": true
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + "ProfilerMISReports", data, "POST", UserService.getAccessToken()).then(function (response) {
          if (response.data.isSuccess) {
            scope.getProfilerMISreports();
          }
          else {
            scope.profileUpdateErrMsg = "Something went wrong.Please try again!"
          }
        })
      }
      else if (scope.createProfile && !call) {
        scope.profileUpdateErrMsg = "Please ty again with a unique profile name!"
      }
    }
    scope.deleteProfile = function () {
      var data = {
        "profilerID": scope.selectedProfile.profilerId,
        "ProfileName": scope.selectedProfile.profilename,
        "entityRelationID": scope.profilerErID,
        "isActive": false
      }
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + "ProfilerMISReports", data, "POST", UserService.getAccessToken()).then(function (response) {
        if (response.data.isSuccess) {
          scope.getProfilerMISreports();
        }
      })
    }

    scope.cancelUpdateProfile = function () {
      if (scope.editProfile) {
        scope.editProfile = false;
        scope.editProfileObj = {};
      }
      else {
        scope.createProfile = false;
        scope.createProfileObj = {};
      }
    }
    scope.LoadRelatedContracts = function () {
      if (scope.user) {
        scope.isActive = true;
        if (scope.user.entityId != 1000042) {
          scope.contracts = UtilitiesService.getContracts() === null ? [] : UtilitiesService.getContracts();
          scope.childrenData = UtilitiesService.getAllChildren() === null ? [] : UtilitiesService.getAllChildren();
          scope.contracts = filterFilter(scope.contracts, {
            "id": scope.childrenData
          }, function (actual, expected) {
            return filterFilter(expected, {
              'erTypeId': actual
            }).length > 0;
          });
          var checkContract = UtilitiesService.isChildForContract(9716); // 9716 AHC
          if (checkContract && checkContract.length > 0) {
            erIdForAHC = checkContract[0].id;
          }
          var checkContract = UtilitiesService.isChildForContract(9717); // 9716 AHC
          if (checkContract && checkContract.length > 0) {
            erIdForPrePol = checkContract[0].id;
          }
          $.each(scope.contracts, function (contract) {
            er_id.push(contract.id);
          });
          scope.contracts = orderByFilter(scope.contracts, 'entityName', scope.reverse);
        } else {
          scope.contracts = UtilitiesService.getContracts() === null ? [] : UtilitiesService.getContracts();
          scope.contracts = orderByFilter(scope.contracts, 'entityName', scope.reverse);
        }
      }

    };

    scope.loadContracts = function () {
      if (scope.contracts.length === 0) {
        scope.LoadRelatedContracts();

      }
      scope.showTimeAdd = false;
    };

    scope.loadContractData = function () {
      if (scope.contracts.length === 0) {
        scope.LoadRelatedContracts();
      }
      scope.showTimeAdd = false;
    };
    scope.selectedContractId = { id: 0 };
    scope.loadContractData();
    scope.loadContracts();
    scope.getMis = function () {
      scope.statusDetails = [];
      scope.allCorporateId = [];
      if (scope.corporatesForStatus.length > 0) {
        var selected = scope.corporatesForStatus.filter(function (e) {
          return e.isSelected == true;
        }).map(function (el) {
          return parseInt(el.id);
        });
        scope.allCorporateId = selected;
        var stDt = UtilitiesService.getDDMMYYYY(scope.tab1Data.statusStartDate);
        var endDt = UtilitiesService.getDDMMYYYY(scope.tab1Data.statusEndDate);
      }
      if (stDt && !endDt) {
        UtilitiesService.showAlertMessage('You have missed end date!');
        return false;
      }
      if (scope.user && scope.user.properties && scope.user.properties["assigned Corporates"]) {
        scope.allCorporateId = scope.allCorporateId.length !== 0 ? scope.allCorporateId : scope.user.properties["assigned Corporates"].split(',');
      }
      var data = {
        "ERIds": scope.allCorporateId,
        "appointmentFromDate": stDt ? stDt : "",
        "appointmentToDate": endDt ? endDt : "",
        "contractId": scope.selectedContractId.id,
        "fetchByDate": scope.tab2Data.dateType
      };
      scope.data = data;
      if (scope.data != undefined && !(Object.keys(scope.data).length === 0)) {
        UserService.makeRestCall("https://integration-plus-plus.medibuddy.in/PlusAPI/" + "getApptCountByStatus.json", data, "POST", UserService.getAccessToken()).then(function (response) {
          if (response.data.isSuccess) {
            if (scope.selectedContract) {
              scope.contractName = scope.selectedContract;
            }
            scope.totalStatus = response.data.statusWiseCount;
            scope.impStatus = [];
            scope.otherStatus = [];
            scope.totalNoOfImpStatus = [];
            scope.totalNoOfOtherStatus = [];
            scope.totalCountStatus = 0;
            if (scope.totalStatus) {
              $.each(scope.totalStatus, function (i, v) {
                if (v.statusId == 22 | v.statusId == 32 | v.statusId == 39 | v.statusId == 30) {
                  scope.impStatus.push(v);
                } else {
                  scope.otherStatus.push(v);
                }
                scope.totalCountStatus += v.apptCount;
              })
            }
          }
          else {
            if(response.data.isSuccess == false && response.data.errorMessage && response.data.errorMessage == "You are not authorized."){
              UtilitiesService.showAlertMessage('Welcome to the MIS Service. Be Cautious and Select Less then 2 Months Data', true, true);
            } else {
              UtilitiesService.showAlertMessage('No records found!');
            }
            
          }
        });
      }
    };
    var list = [10386, 10389, 10390, 10401, 10845, 10846, 10847, 10861]
    scope.changeContract = function (selectedContract, contractFor) {
      scope.isEsale = false;
      if (selectedContract && selectedContract.entityName === 'E_SALES') {
        scope.isEsale = true;
      }
      scope.selectedResult = filterFilter(list, parseInt(selectedContract.id), true).length > 0 ? false : true;
      scope.selectedContractId = selectedContract;
      if (selectedContract && selectedContract.id) {
        UtilitiesService.getEntitiesForContract(selectedContract.id).then(function (response) {
          if (response && response.data && response.data.length > 0) {
            scope.entitiesForContract = response.data;
            var newCorporates = UtilitiesService.getCorporates(response.data);
            scope.corporatesForStatus = newCorporates;
            scope.selectedContract = selectedContract.entityName;
            scope.childrenData = UtilitiesService.getAllChildren() === null ? [] : UtilitiesService.getAllChildren();
            if (scope.user.entityId != 1000042) {
              if (scope.isEsale === false) {
                scope.corporatesForStatus = filterFilter(scope.corporatesForStatus, {
                  "entityId": scope.childrenData
                }, function (actual, expected) {
                  return filterFilter(expected, {
                    'entityId': actual
                  }).length > 0;
                });
              } else if (scope.isEsale === true) {
                scope.corporatesForStatus = filterFilter(scope.corporatesForStatus, {
                  "id": scope.childrenData
                }, function (actual, expected) {
                  return filterFilter(expected, {
                    'entityId': actual
                  }).length > 0;
                });
              }
            } else {
              scope.corporatesForStatus = newCorporates;
            }
          }
        });
      }
    };
    scope.filename = "Mahs_MIS";
    var getAdditionalInfo = function (requestProperties) {
      visitType = requestProperties.visitType ? requestProperties.visitType : null;
      dcId = requestProperties.providerId ? requestProperties.providerId : null;
      agentName = requestProperties.agentName ? requestProperties.agentName : null;
      agentCode = requestProperties.agentCode ? requestProperties.agentCode : null;
      agentMobileNumber = requestProperties.agentMobileNumber ? requestProperties.agentMobileNumber : null;
      if (requestProperties.additionals) {
        fitUnfit = requestProperties.additionals.FITUNFIT ? requestProperties.additionals.FITUNFIT : null;
        fitUnfitRemarks = requestProperties.additionals.FITUNFITREMARKS ? requestProperties.additionals.FITUNFITREMARKS : null;
        bloodGroup = requestProperties.additionals.bloodGroup ? requestProperties.additionals.bloodGroup : null;
        referenceRequestId = requestProperties.additionals.referenceRequestId ? requestProperties.additionals.referenceRequestId : null;
      } else if (requestProperties.AdditionalInfo && _.isObject(JSON.parse(requestProperties.AdditionalInfo))) {
        requestProperties.additionals = JSON.parse(requestProperties.AdditionalInfo)
      } else if (requestProperties.additionalInfo && _.isObject(JSON.parse(requestProperties.additionalInfo))){
        requestProperties.additionals = JSON.parse(requestProperties.additionalInfo)
      }
    }
    scope.getStatusDetails = function (obj) {
      scope.obj = obj;
      scope.selectedErId = [];
      scope.statusName = obj.statusName;
      if (scope.allCorporateId.length > 0) {
        scope.selectedErId = scope.allCorporateId;
      }
      if (obj.statusId)
        scope.displayStatus = true;

      var ajaxData = {
        "ERIds": scope.selectedErId,
        "StatusId": obj.statusId,
        "appointmentFromDate": scope.tab1Data.statusStartDate ? scope.tab1Data.statusStartDate : "",
        "appointmentToDate": scope.tab1Data.statusEndDate ? scope.tab1Data.statusEndDate : "",
        "contractId": scope.selectedContractId.id,
        "fetchByDate": scope.tab2Data.dateType
      }
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + "GetMISReports.json", ajaxData, "POST", UserService.getAccessToken()).then(function (response) {
        if (response.data.isSuccess) {
          scope.statusDetails = response.data.misReports;
          scope.dnldStatusData = [];
          if (scope.statusDetails) {
            $.each(scope.statusDetails, function (index, val) {
              var requestProperties = val.properties != undefined ? $.parseJSON(val.properties) : null;
              if (requestProperties) {
                getAdditionalInfo(requestProperties);
              }
              var tempObj = {
                CorporateName: val.corporateName,
                RequestDate: val.requestDate,
                ContractName: val.contractName,
                PatientName: val.patientName,
                EmployeeId: val.employeeId,
                Age: val.age,
                Gender: val.gender,
                RelationShip: val.relationShip,
                EmailId: val.emailId,
                ContactNo: val.contactNo,
                PackageName: val.packageName,
                packageInvestigations: val.packageInvestigations,
                ApptCreatedDate: val.apptCreatedDate,
                AppointmentDate: val.appointmentDateAndTime,
                ApptTime: val.apptTime,
                VisitType: visitType,
                ProviderName: val.providerName,
                ProviderState: val.providerState,
                ProviderCity: val.providerCity,
                ProviderLocation: val.providerLocation,
                DcId: dcId,
                DcVisitReason: val.dcVisitReason,
                AppointmentId: val.appointmentId,
                OrderID: val.orderID,
                AppointmentStatus: val.appointmentStatus,
                NoteRemarks: val.noteRemarks,
                DoctorQualification: val.doctorQualification,
                ReportUploaded: val.reportUploaded == true ? 'Yes' : 'No',
                ReportUploadDate: val.reportUploadDate,
                QcApprovedDate: val.qcApprovedDate,
                LifeNo: val.lifeNo,
                CaseType: val.caseType,
                PolicyType: val.policyType,
                AnnualPremium: val.annualPremium,
                SumInsured: val.sumInsured,
                ClientCity: val.clientCity,
                ClientAddress: val.clientAddress,
                AgentName: agentName,
                AgentCode: agentCode,
                AgentMobileNumber: agentMobileNumber,
                MaBranch: val.maBranch,
                StatusTakenBy: val.statusTakenBy,
                StatusReceivedFrom: val.statusReceivedFrom,
                StatusGivenBy: val.statusGivenBy,
                PackageType: val.packageType,
                PaymentRecieved: val.paymentRecieved == true ? 'Yes' : 'No',
                TATConfirmed: val.tatConfirmed,
                TATUploaded: val.tatUploaded,
                TATApproved: val.tatApproved,
                FitUnfit: fitUnfit,
                FitUnfitRemarks: fitUnfitRemarks,
                BloodGroup: bloodGroup,
                ReferenceRequestId: referenceRequestId,
                FitnessDate: val.fitnessDate,
                HRName: val.hrName,
                HREmail: val.hrEmail,
                RescheduleDate1: val.rescheduleDate1,
                RescheduleDate2: val.rescheduleDate2,
                RescheduleDate3: val.rescheduleDate3,
                ActualAppointmentDate: val.actualAppointmentDate,
                Month: val.month,
                InOutStation: val.inOutStation,
                Equote: val.equote,
                EsalesID: val.esalesID,
                EQFirstCallDate: val.eqFirstCallDate,
                EQFirstCallRemark: val.eqFirstCallRemark,
                EQFirstCallComment: val.eqFirstCallComment,
                EQFirstCallCalledBy: val.eqFirstCallCalledBy,
                EQSecondCallDate: val.eqSecondCallDate,
                EQSecondCallRemark: val.eqSecondCallRemark,
                EQSecondCallComment: val.eqSecondCallComment,
                EQSecondCallCalledBy: val.eqSecondCallCalledBy,
                EQThirdCallDate: val.eqThirdCallDate,
                EQThirdCallRemark: val.eqThirdCallRemark,
                EQThirdCallComment: val.eqThirdCallComment,
                EQThirdCallCalledBy: val.eqThirdCallCalledBy,
                EQFourthCallDate: val.eqFourthCallDate,
                EQFourthCallRemark: val.eqFourthCallRemark,
                EQFourthCallComment: val.eqFourthCallComment,
                EQFourthCallCalledBy: val.eqFourthCallCalledBy,
                EQFifthCallDate: val.eqFifthCallDate,
                EQFifthCallRemark: val.eqFifthCallRemark,
                EQFifthCallComment: val.eqFifthCallComment,
                EQFifthCallCalledBy: val.eqFifthCallCalledBy,
                EQSixthCallDate: val.eqSixthCallDate,
                EQSixthCallRemark: val.eqSixthCallRemark,
                EQSixthCallComment: val.eqSixthCallComment,
                EQSixthCallCalledBy: val.eqSixthCallCalledBy,
                EQSeventhCallDate: val.eqSeventhCallDate,
                EQSeventhCallRemark: val.eqSeventhCallRemark,
                EQSeventhCallComment: val.eqSeventhCallComment,
                EQSeventhCallCalledBy: val.eqSeventhCallCalledBy,
                EQEighthCallDate: val.eqEighthCallDate,
                EQEighthCallRemark: val.eqEighthCallRemark,
                EQEighthCallComment: val.eqEighthCallComment,
                EQEighthCallCalledBy: val.eqEighthCallCalledBy,
                EQNinthCallDate: val.eqNinthCallDate,
                EQNinthCallRemark: val.eqNinthCallRemark,
                EQNinthCallComment: val.eqNinthCallComment,
                EQNinthCallCalledBy: val.eqNinthCallCalledBy,
                EQTenthCallDate: val.eqTenthCallDate,
                EQTenthCallRemark: val.eqTenthCallRemark,
                EQTenthCallComment: val.eqTenthCallComment,
                EQTenthCallCalledBy: val.eqTenthCallCalledBy,
                EQEleventhCallDate: val.eqEleventhCallDate,
                EQEleventhCallRemark: val.eqEleventhCallRemark,
                EQEleventhCallComment: val.eqEleventhCallComment,
                EQEleventhCallCalledBy: val.eqEleventhCallCalledBy,
                EQTwelfthCallDate: val.eqTwelfthCallDate,
                EQTwelfthCallRemark: val.eqTwelfthCallRemark,
                EQTwelfthCallComment: val.eqTwelfthCallComment,
                EQTwelfthCallCalledBy: val.eqTwelfthCallCalledBy,
                EQLastCallDate: val.eqLastCallDate,
                EQLastCallRemark: val.eqLastCallRemark,
                EQLastCallCalledBy: val.eqLastCallCalledBy,
                EQNumberofAttempts: val.eqNumberofAttempts,
                EQLastCallComment: val.eqLastCallComment,
                FirstCallDate: val.firstCallDate,
                FirstCallRemark: val.firstCallRemark,
                FirstCallComment: val.firstCallComment,
                FirstCallCalledBy: val.firstCallCalledBy,
                SecondCallDate: val.secondCallDate,
                SecondCallRemark: val.secondCallRemark,
                SecondCallComment: val.secondCallComment,
                SecondCallCalledBy: val.secondCallCalledBy,
                ThirdCallDate: val.thirdCallDate,
                ThirdCallRemark: val.thirdCallRemark,
                ThirdCallComment: val.thirdCallComment,
                ThirdCallCalledBy: val.thirdCallCalledBy,
                FourthCallDate: val.fourthCallDate,
                FourthCallRemark: val.fourthCallRemark,
                FourthCallComment: val.fourthCallComment,
                FourthCallCalledBy: val.fourthCallCalledBy,
                FifthCallDate: val.fifthCallDate,
                FifthCallRemark: val.fifthCallRemark,
                FifthCallComment: val.fifthCallComment,
                FifthCallCalledBy: val.fifthCallCalledBy,
                SixthCallDate: val.sixthCallDate,
                SixthCallRemark: val.sixthCallRemark,
                SixthCallComment: val.sixthCallComment,
                SixthCallCalledBy: val.sixthCallCalledBy,
                SeventhCallDate: val.seventhCallDate,
                SeventhCallRemark: val.seventhCallRemark,
                SeventhCallComment: val.seventhCallComment,
                SeventhCallCalledBy: val.seventhCallCalledBy,
                EighthCallDate: val.eighthCallDate,
                EighthCallRemark: val.eighthCallRemark,
                EighthCallComment: val.eighthCallComment,
                EighthCallCalledBy: val.eighthCallCalledBy,
                NinthCallDate: val.ninthCallDate,
                NinthCallRemark: val.ninthCallRemark,
                NinthCallComment: val.ninthCallComment,
                NinthCallCalledBy: val.ninthCallCalledBy,
                TenthCallDate: val.tenthCallDate,
                TenthCallRemark: val.tenthCallRemark,
                TenthCallComment: val.tenthCallComment,
                TenthCallCalledBy: val.tenthCallCalledBy,
                EleventhCallDate: val.eleventhCallDate,
                EleventhCallRemark: val.eleventhCallRemark,
                EleventhCallComment: val.eleventhCallComment,
                EleventhCallCalledBy: val.eleventhCallCalledBy,
                TwelfthCallDate: val.twelfthCallDate,
                TwelfthCallRemark: val.twelfthCallRemark,
                TwelfthCallComment: val.twelfthCallComment,
                TwelfthCallCalledBy: val.twelfthCallCalledBy,
                LastCallDate: val.lastCallDate,
                LastCallRemark: val.lastCallRemark,
                LastCallCalledBy: val.lastCallCalledBy,
                LastCallComment: val.lastCallComment,
                NumberofAttempts: val.numberofAttempts,
                Remarks: val.remarks,
                MedicalPendingRemark: val.medicalPendingRemark,
                PriorityAssigned: val.priorityAssigned ? val.priorityAssigned : null,
                OtherInfo: val.otherInfo ? val.otherInfo : '',
                ApptCreatedBySelfAllocation: val.isApptCreatedBySelfAllc,
                ReportDigitizationDate: val.reportDigitizationDate,
                MemberId: val.maid,
                DirectCase: val.directCase,
                RequestSource: val.requestSource,
                RequestCreatedBy: val.requestCreatedBy,
                RequestSourceName: val.requestSourceName,
                Feedback: val.feedBack,
                DND: scope.checkDND(requestProperties, 'DND'),
                DNDCustomer: scope.checkDND(requestProperties, 'DNDCustomer'),
                IsCreatedViaAPI: requestProperties && requestProperties.additionals && requestProperties.additionals.ProposedAppointment_Format ? true : false,
                fbsRbsResult: requestProperties && requestProperties.additionals && requestProperties.additionals.fbsRbsResult ? requestProperties.additionals.fbsRbsResult : '',
                HALiteId: requestProperties && requestProperties.additionals && requestProperties.additionals.HALiteId ? requestProperties.additionals.HALiteId : '',
                SourceDescription: requestProperties && requestProperties.additionals && requestProperties.additionals.SourceDescription ? requestProperties.additionals.SourceDescription : '',
                NoOfWhatsAppMessagesCustomer: requestProperties && requestProperties.additionals && requestProperties.additionals.NoOfWhatsAppMessagesCustomer ? requestProperties.additionals.NoOfWhatsAppMessagesCustomer : '',
                NoOfWhatsAppMessagesSales: requestProperties && requestProperties.additionals && requestProperties.additionals.NoOfWhatsAppMessagesSales ? requestProperties.additionals.NoOfWhatsAppMessagesSales : '',
                NoOfIVRCallsCustomer: requestProperties && requestProperties.additionals && requestProperties.additionals.NoOfIVRCallsCustomer ? requestProperties.additionals.NoOfIVRCallsCustomer : '',
                NoOfIVRCallsSales: requestProperties && requestProperties.additionals && requestProperties.additionals.NoOfIVRCallsSales ? requestProperties.additionals.NoOfIVRCallsSales : '',
                // State: requestProperties && requestProperties.additionals && requestProperties.additionals.State ? requestProperties.additionals.State : '',
                // City: requestProperties && requestProperties.additionals && requestProperties.additionals.City ? requestProperties.additionals.City : '',
                // ClientMABranch: requestProperties && requestProperties.additionals && requestProperties.additionals.ClientMABranch ? requestProperties.additionals.ClientMABranch : '',
                // dcVisitReason: requestProperties && requestProperties.additionals && requestProperties.additionals.dcVisitReason ? requestProperties.additionals.dcVisitReason : '',
              }
              scope.dnldStatusData.push(tempObj);
            });
            var selectedFeilds = []
            var tempStusData = scope.dnldStatusData[0];
            for (var i = 0; i < Object.keys(tempStusData).length; i++) {
              var tempKey = {
                name: Object.keys(tempStusData)[i]
              }
              selectedFeilds.push(tempKey);
            }
            scope.selectedFeilds = selectedFeilds;
            scope.listToDownload = [];
            angular.forEach(scope.selectedFeilds, function (v, i) {
              var totalList = {
                name: v.name,
                selectedRecord: false
              }
              scope.listToDownload.push(totalList);
              
            })
            scope.totalRecords = scope.listToDownload.length;
          }
        }
      });
    };
    scope.checkDND = function(requestProperties, key){
      var value = false;
      if (requestProperties) {
        if (requestProperties.additionals) {
          if (typeof requestProperties.additionals === "object")
            value =
              requestProperties &&
              requestProperties.additionals &&
              requestProperties.additionals[key]
                ? requestProperties.additionals[key]
                : false;
          else {
            var jsonreqProp = JSON.parse(requestProperties.additionals);
            value = jsonreqProp && jsonreqProp[key] ? jsonreqProp[key] : false;
          }
        } else if (requestProperties.additionalInfo) {
          if (typeof requestProperties.additionalInfo === "object")
            value =
              requestProperties &&
              requestProperties.additionalInfo &&
              requestProperties.additionalInfo[key]
                ? requestProperties.additionalInfo[key]
                : false;
          else {
            var jsonreqProp = JSON.parse(requestProperties.additionalInfo);
            value = jsonreqProp && jsonreqProp[key] ? jsonreqProp[key] : false;
          }
        }
      }
      return value;
    };
    scope.refreshMIS = function () {
      scope.statusStartDate = null;
      scope.statusEndDate = null;
      scope.statusContracts = undefined;
      scope.dateWiseContracts = undefined;
      scope.corporatesForStatus = [];
      scope.tab2Data.dateType = null;
      scope.openTab1();
      scope.getMis();
    };
    scope.openTab1 = function () {
      scope.tab1Data = {
        statusContracts: "",
        statusStartDate: "",
        statusEndDate: ""
      };
      scope.corporatesForStatus = [];
      scope.loadContracts();
    };
    scope.openTab2 = function () {
      scope.tab2Data = {
        dateWiseContracts: "",
        ms: "",
        statusStartDate: "",
        statusEndDate: "",
        dateType: ""
      };
      scope.corporatesForStatus = [];
      scope.loadContractData();
    };
    scope.getCount = function () {
      var count = 0;
      scope.corporatesForStatus.map(function (e) {
        if (e.isSelected)
          count++;
      });
      return count;
    };
    scope.selectAll = function (flag) {
      scope.corporatesForStatus.map(function (e) {
        e.isSelected = flag;
      });
    };
    scope.corporateStatusDetails = function () {
      var startDate = UtilitiesService.getDDMMYYYY(scope.tab2Data.misstartdate);
      var endDate = UtilitiesService.getDDMMYYYY(scope.tab2Data.misenddate);
      var StatusId = scope.tab2Data.ms;
      if (startDate && !endDate) {
        UtilitiesService.showAlertMessage('You have missed end date!');
        return false;
      }
      if (scope.corporatesForStatus.length > 0) {
        var selected = scope.corporatesForStatus.filter(function (e) {
          return e.isSelected == true;
        }).map(function (el) {
          return parseInt(el.id);
        });
        
        if (Array.isArray(selected) && selected.length > 0) {
          scope.allCorporateId = selected;
        } else {
          scope.allCorporateId = scope.user.corporateIDs;
        }
      }
      if (!scope.allCorporateId) {
        scope.allCorporateId = scope.user.corporateIDs;
      }
      if (scope.allCorporateId) {
        var ajaxData = {
          "ERIds": scope.allCorporateId ? scope.allCorporateId : [],
          "StatusId": StatusId ? StatusId : "",
          "AppointmentFromDate": startDate ? startDate : "",
          "AppointmentToDate": endDate ? endDate : "",
          "exporttoExcel": false,
          "contractId": scope.selectedContractId.id,
          "fetchByDate": scope.tab2Data.dateType ? scope.tab2Data.dateType : ''
        }
      }
      scope.ajaxData = ajaxData;
      if (scope.ajaxData != undefined && !(Object.keys(scope.ajaxData).length === 0)) {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + "GetMISReports.json", ajaxData, "POST", UserService.getAccessToken()).then(function (response) {
          if (response.data.misReports) {
            scope.dateDetails = [];
            scope.statusDetails = response.data.misReports;
            scope.dnldStatusData = [];
            if (scope.statusDetails) {
              $.each(scope.statusDetails, function (index, val) {
                var requestProperties = null;
                try {
                  requestProperties = val.properties != undefined ? JSON.parse(val.properties) : null;
                } catch (e) {
                  console.info("Request ID >> ", val.employeeId, " ", val.appointmentId);
                  console.error("Error in Parsing >> ", e);
                }

                if (requestProperties) {
                  getAdditionalInfo(requestProperties);
                }

                var VMER_Tag = 'NA';
                var additionals = requestProperties ? requestProperties.additionals : null;

                if(additionals) {
                  if (additionals.InternalTelemer === 'true') {
                    VMER_Tag = 'Medibuddy';
                  } else if (additionals.Xangars === 'true') {
                    VMER_Tag = 'Xangars';
                  } else if (additionals.Ecure === 'true') {
                    VMER_Tag = 'Ecure';
                  }
                }

                var tempObj = {
                  CorporateName: val.corporateName,
                  RequestDate: val.requestDate,
                  ContractName: val.contractName,
                  PatientName: val.patientName,
                  EmployeeId: val.employeeId,
                  Age: val.age,
                  Gender: val.gender,
                  RelationShip: val.relationShip,
                  EmailId: val.emailId,
                  ContactNo: val.contactNo,
                  PackageName: val.packageName,
                  packageInvestigations: val.packageInvestigations,
                  ApptCreatedDate: val.apptCreatedDate,
                  AppointmentDate: val.appointmentDateAndTime,
                  ApptTime: val.apptTime,
                  VisitType: visitType,
                  ProviderName: val.providerName,
                  ProviderState: val.providerState,
                  ProviderCity: val.providerCity,
                  ProviderLocation: val.providerLocation,
                  DcId: dcId,
                  DcVisitReason: val.dcVisitReason,
                  AppointmentId: val.appointmentId,
                  OrderID: val.orderID,
                  AppointmentStatus: val.appointmentStatus,
                  NoteRemarks: val.noteRemarks,
                  DoctorQualification: val.doctorQualification,
                  ReportUploaded: val.reportUploaded == true ? 'Yes' : 'No',
                  ReportUploadDate: val.reportUploadDate,
                  QcApprovedDate: val.qcApprovedDate,
                  LifeNo: val.lifeNo,
                  CaseType: val.caseType,
                  PolicyType: val.policyType,
                  AnnualPremium: val.annualPremium,
                  SumInsured: val.sumInsured,
                  ClientCity: val.clientCity,
                  ClientAddress: val.clientAddress,
                  AgentName: agentName,
                  AgentCode: agentCode,
                  AgentMobileNumber: agentMobileNumber,
                  MaBranch: val.maBranch,
                  StatusTakenBy: val.statusTakenBy,
                  StatusReceivedFrom: val.statusReceivedFrom,
                  StatusGivenBy: val.statusGivenBy,
                  PackageType: val.packageType,
                  PaymentRecieved: val.paymentRecieved == true ? 'Yes' : 'No',
                  TATConfirmed: val.tatConfirmed,
                  TATUploaded: val.tatUploaded,
                  TATApproved: val.tatApproved,
                  FitUnfit: fitUnfit,
                  FitUnfitRemarks: fitUnfitRemarks,
                  BloodGroup: bloodGroup,
                  ReferenceRequestId: referenceRequestId,
                  FitnessDate: val.fitnessDate,
                  HRName: val.hrName,
                  HREmail: val.hrEmail,
                  RescheduleDate1: val.rescheduleDate1,
                  RescheduleDate2: val.rescheduleDate2,
                  RescheduleDate3: val.rescheduleDate3,
                  ActualAppointmentDate: val.actualAppointmentDate,
                  Month: val.month,
                  InOutStation: val.inOutStation,
                  Equote: val.equote,
                  EsalesID: val.esalesID,
                  EQFirstCallDate: val.eqFirstCallDate,
                  EQFirstCallRemark: val.eqFirstCallRemark,
                  EQFirstCallComment: val.eqFirstCallComment,
                  EQFirstCallCalledBy: val.eqFirstCallCalledBy,
                  EQSecondCallDate: val.eqSecondCallDate,
                  EQSecondCallRemark: val.eqSecondCallRemark,
                  EQSecondCallComment: val.eqSecondCallComment,
                  EQSecondCallCalledBy: val.eqSecondCallCalledBy,
                  EQThirdCallDate: val.eqThirdCallDate,
                  EQThirdCallRemark: val.eqThirdCallRemark,
                  EQThirdCallComment: val.eqThirdCallComment,
                  EQThirdCallCalledBy: val.eqThirdCallCalledBy,
                  EQFourthCallDate: val.eqFourthCallDate,
                  EQFourthCallRemark: val.eqFourthCallRemark,
                  EQFourthCallComment: val.eqFourthCallComment,
                  EQFourthCallCalledBy: val.eqFourthCallCalledBy,
                  EQFifthCallDate: val.eqFifthCallDate,
                  EQFifthCallRemark: val.eqFifthCallRemark,
                  EQFifthCallComment: val.eqFifthCallComment,
                  EQFifthCallCalledBy: val.eqFifthCallCalledBy,
                  EQSixthCallDate: val.eqSixthCallDate,
                  EQSixthCallRemark: val.eqSixthCallRemark,
                  EQSixthCallComment: val.eqSixthCallComment,
                  EQSixthCallCalledBy: val.eqSixthCallCalledBy,
                  EQSeventhCallDate: val.eqSeventhCallDate,
                  EQSeventhCallRemark: val.eqSeventhCallRemark,
                  EQSeventhCallComment: val.eqSeventhCallComment,
                  EQSeventhCallCalledBy: val.eqSeventhCallCalledBy,
                  EQEighthCallDate: val.eqEighthCallDate,
                  EQEighthCallRemark: val.eqEighthCallRemark,
                  EQEighthCallComment: val.eqEighthCallComment,
                  EQEighthCallCalledBy: val.eqEighthCallCalledBy,
                  EQNinthCallDate: val.eqNinthCallDate,
                  EQNinthCallRemark: val.eqNinthCallRemark,
                  EQNinthCallComment: val.eqNinthCallComment,
                  EQNinthCallCalledBy: val.eqNinthCallCalledBy,
                  EQTenthCallDate: val.eqTenthCallDate,
                  EQTenthCallRemark: val.eqTenthCallRemark,
                  EQTenthCallComment: val.eqTenthCallComment,
                  EQTenthCallCalledBy: val.eqTenthCallCalledBy,
                  EQEleventhCallDate: val.eqEleventhCallDate,
                  EQEleventhCallRemark: val.eqEleventhCallRemark,
                  EQEleventhCallComment: val.eqEleventhCallComment,
                  EQEleventhCallCalledBy: val.eqEleventhCallCalledBy,
                  EQTwelfthCallDate: val.eqTwelfthCallDate,
                  EQTwelfthCallRemark: val.eqTwelfthCallRemark,
                  EQTwelfthCallComment: val.eqTwelfthCallComment,
                  EQTwelfthCallCalledBy: val.eqTwelfthCallCalledBy,
                  EQLastCallDate: val.eqLastCallDate,
                  EQLastCallRemark: val.eqLastCallRemark,
                  EQLastCallCalledBy: val.eqLastCallCalledBy,
                  EQNumberofAttempts: val.eqNumberofAttempts,
                  EQLastCallComment: val.eqLastCallComment,
                  FirstCallDate: val.firstCallDate,
                  FirstCallRemark: val.firstCallRemark,
                  FirstCallComment: val.firstCallComment,
                  FirstCallCalledBy: val.firstCallCalledBy,
                  SecondCallDate: val.secondCallDate,
                  SecondCallRemark: val.secondCallRemark,
                  SecondCallComment: val.secondCallComment,
                  SecondCallCalledBy: val.secondCallCalledBy,
                  ThirdCallDate: val.thirdCallDate,
                  ThirdCallRemark: val.thirdCallRemark,
                  ThirdCallComment: val.thirdCallComment,
                  ThirdCallCalledBy: val.thirdCallCalledBy,
                  FourthCallDate: val.fourthCallDate,
                  FourthCallRemark: val.fourthCallRemark,
                  FourthCallComment: val.fourthCallComment,
                  FourthCallCalledBy: val.fourthCallCalledBy,
                  FifthCallDate: val.fifthCallDate,
                  FifthCallRemark: val.fifthCallRemark,
                  FifthCallComment: val.fifthCallComment,
                  FifthCallCalledBy: val.fifthCallCalledBy,
                  SixthCallDate: val.sixthCallDate,
                  SixthCallRemark: val.sixthCallRemark,
                  SixthCallComment: val.sixthCallComment,
                  SixthCallCalledBy: val.sixthCallCalledBy,
                  SeventhCallDate: val.seventhCallDate,
                  SeventhCallRemark: val.seventhCallRemark,
                  SeventhCallComment: val.seventhCallComment,
                  SeventhCallCalledBy: val.seventhCallCalledBy,
                  EighthCallDate: val.eighthCallDate,
                  EighthCallRemark: val.eighthCallRemark,
                  EighthCallComment: val.eighthCallComment,
                  EighthCallCalledBy: val.eighthCallCalledBy,
                  NinthCallDate: val.ninthCallDate,
                  NinthCallRemark: val.ninthCallRemark,
                  NinthCallComment: val.ninthCallComment,
                  NinthCallCalledBy: val.ninthCallCalledBy,
                  TenthCallDate: val.tenthCallDate,
                  TenthCallRemark: val.tenthCallRemark,
                  TenthCallComment: val.tenthCallComment,
                  TenthCallCalledBy: val.tenthCallCalledBy,
                  EleventhCallDate: val.eleventhCallDate,
                  EleventhCallRemark: val.eleventhCallRemark,
                  EleventhCallComment: val.eleventhCallComment,
                  EleventhCallCalledBy: val.eleventhCallCalledBy,
                  TwelfthCallDate: val.twelfthCallDate,
                  TwelfthCallRemark: val.twelfthCallRemark,
                  TwelfthCallComment: val.twelfthCallComment,
                  TwelfthCallCalledBy: val.twelfthCallCalledBy,
                  LastCallDate: val.lastCallDate,
                  LastCallRemark: val.lastCallRemark,
                  LastCallComment: val.lastCallComment,
                  LastCallCalledBy: val.lastCallCalledBy,
                  NumberofAttempts: val.numberofAttempts,
                  Remarks: val.remarks,
                  MedicalPendingRemark: val.medicalPendingRemark,
                  PriorityAssigned: val.priorityAssigned ? val.priorityAssigned : null,
                  OtherInfo: val.otherInfo ? val.otherInfo : '',
                  ApptCreatedBySelfAllocation: val.isApptCreatedBySelfAllc,
                  ReportDigitizationDate: val.reportDigitizationDate,
                  MemberId: val.maid,
                  DirectCase: val.directCase,
                  RequestSource: val.requestSource,
                  RequestCreatedBy: val.requestCreatedBy,
                  RequestSourceName: val.requestSourceName,
                  Feedback: val.feedBack,
                  DND: scope.checkDND(requestProperties, 'DND'),
                  DNDCustomer: scope.checkDND(requestProperties, 'DNDCustomer'),
                  IsCreatedViaAPI: requestProperties && requestProperties.additionals && requestProperties.additionals.ProposedAppointment_Format ? true : false,
                  fbsRbsResult: requestProperties && requestProperties.additionals && requestProperties.additionals.fbsRbsResult ? requestProperties.additionals.fbsRbsResult : '',
                  HALiteId: requestProperties && requestProperties.additionals && requestProperties.additionals.HALiteId ? requestProperties.additionals.HALiteId : '',
                  SourceDescription: requestProperties && requestProperties.additionals && requestProperties.additionals.SourceDescription ? requestProperties.additionals.SourceDescription : '',
                  NoOfWhatsAppMessagesCustomer: requestProperties && requestProperties.additionals && requestProperties.additionals.NoOfWhatsAppMessagesCustomer ? requestProperties.additionals.NoOfWhatsAppMessagesCustomer : '',
                  NoOfWhatsAppMessagesSales: requestProperties && requestProperties.additionals && requestProperties.additionals.NoOfWhatsAppMessagesSales ? requestProperties.additionals.NoOfWhatsAppMessagesSales : '',
                  NoOfIVRCallsCustomer: requestProperties && requestProperties.additionals && requestProperties.additionals.NoOfIVRCallsCustomer ? requestProperties.additionals.NoOfIVRCallsCustomer : '',
                  NoOfIVRCallsSales: requestProperties && requestProperties.additionals && requestProperties.additionals.NoOfIVRCallsSales ? requestProperties.additionals.NoOfIVRCallsSales : '',
                  State: requestProperties && requestProperties.additionals && requestProperties.additionals.State ? requestProperties.additionals.State : '',
                  City: requestProperties && requestProperties.additionals && requestProperties.additionals.City ? requestProperties.additionals.City : '',
                  ClientMABranch: requestProperties && requestProperties.additionals && requestProperties.additionals.ClientMABranch ? requestProperties.additionals.ClientMABranch : '',
                  dcVisitReason: requestProperties && requestProperties.additionals && requestProperties.additionals.dcVisitReason ? requestProperties.additionals.dcVisitReason : '', 
                  Pincode: requestProperties && requestProperties.additionals && requestProperties.additionals.pincode ? requestProperties.additionals.pincode : '', 
                  "VMER Tagging": VMER_Tag, 
                  ChannelName: requestProperties && requestProperties.additionals && requestProperties.additionals.channelName ? requestProperties.additionals.channelName : '',
                  NotAttendedReason: requestProperties && requestProperties.additionals && requestProperties.additionals.NotAttendedReason ? requestProperties.additionals.NotAttendedReason : '',
                  CorporatePackageIds: '"' + val.corporatePackageIds + '"',
                  ProviderPackageIds: '"' + val.providerPackageIds + '"',
                  customerDistanceToProvider: requestProperties && requestProperties.additionals && requestProperties.additionals.customerDistanceToProvider ? requestProperties.additionals.customerDistanceToProvider : '',
                  pendingTestIds: requestProperties && requestProperties.additionals && requestProperties.additionals.pendingTestIds ? requestProperties.additionals.pendingTestIds : '',
                  pendingTestNames: requestProperties && requestProperties.additionals && requestProperties.additionals.pendingTestNames ? requestProperties.additionals.pendingTestNames : ''
                }
                scope.dnldStatusData.push(tempObj);
              });
              var selectedFeilds = []
              var tempStusData = scope.dnldStatusData[0];
              for (var i = 0; i < Object.keys(tempStusData).length; i++) {
                var tempKey = {
                  name: Object.keys(tempStusData)[i]
                }
                selectedFeilds.push(tempKey);
              }
              scope.selectedFeilds = selectedFeilds;
              scope.listToDownload = [];
              angular.forEach(scope.selectedFeilds, function (v, i) {
                var totalList = {
                  name: v.name,
                  selectedRecord: false
                }
                scope.listToDownload.push(totalList);

              })
              scope.totalRecords = scope.listToDownload.length;
            }
          }
          else {
            UtilitiesService.showAlertMessage('No records found!');
            scope.statusDetails = [];
          }
        });
      }
    };

    scope.isCheckAll = 'Check All';
    scope.maincheck = {
      searchRecord: ''
    };

    scope.count = 0;
    scope.checkAllRecords = function (isChecked) {
      scope.isDownload = false;
      scope.showDone = true;
      scope.maincheck.searchRecord = '';
      var finalList = [];
      scope.finalDownloadList = [];
      scope.count = 0;
      scope.totalRecords = scope.listToDownload.length;
      if (isChecked) {
        scope.isCheckAll = 'Uncheck All';
        angular.forEach(scope.listToDownload, function (v, i) {
          v.selectedRecord = true;
          if (v.selectedRecord) {
            scope.count = scope.count + 1;
          }
        })

      } if (isChecked === false) {
        scope.isCheckAll = 'Check All';
        scope.maincheck.isCheckbox = false;
        angular.forEach(scope.listToDownload, function (v, i) {
          v.selectedRecord = false;
        })
      }

      if (scope.isInsurer && scope.entitiesForContract) {
        scope.hospName = UserService.getHospitalObj().hospName;
        scope.entitiesForContract.forEach(function (elem) {
          if (elem.entityName == scope.hospName) {
            scope.profilerErID = elem.id
          }
        })
        scope.showDownloadWithProfile = true;
      }
      else if (!scope.isInsurer) {
        scope.showDownloadWithProfile = false;
        if (scope.allCorporateId.length == 1) {
          scope.profilerErID = scope.allCorporateId[0];
          scope.showDownloadWithProfile = true;
        }
      }
      else {
        scope.showDownloadWithProfile = false;
      }

      if (scope.showDownloadWithProfile) {
        scope.profilerErID = scope.profilerErID.toString();
        scope.getProfilerMISreports();
      }
    };

    scope.checkAIndvRecords = function (sr) {
      scope.isDownload = false;
      if (sr) {
        scope.showDone = true;
        scope.count = 0;
        angular.forEach(scope.listToDownload, function (v, i) {
          if (v.name === sr.name) {
            scope.listToDownload[i].selectedRecord = sr.selectedRecord === true ? true : false;
          }
          if (v.selectedRecord) {
            scope.count = scope.count + 1;
          }
        });
      }
    };

    scope.downloadselected = [];
    scope.showDone = true;
    scope.downloadFinalReports = function () {
      scope.showDone = false;
      scope.downloadselected = [];
      var finalList = [];
      //geting selected feilds names
      angular.forEach(scope.listToDownload, function (v, i) {
        if (v.selectedRecord) {
          finalList.push(v.name);
        }
      });
      scope.feildsTitles = finalList;
      //creating objects for selected feilds
      angular.forEach(scope.dnldStatusData, function (val, ind) {
        var tempObj = {};
        for (var i = 0; i < finalList.length; i++) {
          var keys = finalList[i];
          var value = val[finalList[i]];
          tempObj[keys] = value;
        }
        scope.downloadselected.push(tempObj);
      })
      scope.isDownload = true;
    };

    scope.downloadFinalReportsFrmProfile = function () {
      scope.downloadselectedFrmProfile = [];
      var finalList = [];
      scope.selectedProfile.optArr.forEach(function (elem) {
        var el = JSON.parse(JSON.stringify(elem))
        finalList.push(el.name);
      })
      scope.feildsTitlesFrmProfile = finalList;
      var compareObj = JSON.parse(JSON.stringify(scope.dnldStatusData));
      compareObj.forEach(function (elem) {
        var tempObj = {};
        for (var i = 0; i < finalList.length; i++) {
          var keys = finalList[i];
          var value = elem[finalList[i]];
          tempObj[keys] = value;
        }
        scope.downloadselectedFrmProfile.push(tempObj);
      })
    }

    scope.clearSearchRecord = function () {
      scope.maincheck.searchRecord = '';
    };

  }]);
angular.module('mbplus')
.controller('medicalProcessCtrl', ['$rootScope', '$scope', 'UserService', 'UtilitiesService', '$location', '$state', function (rootScope, scope, UserService, UtilitiesService, $location, $state) {
    // scope.$root.title = 'Change password | Medibuddy Hospital Portal';
    rootScope.showMenu = false;
    // rootScope.isRestLogin = { 'display': 'none' };
    scope.OTP = null;
    
    scope.encryptedKey = UserService.dcUrl;
    if (!scope.encryptedKey) {
        
        $state.go('misreports', {}, { reload: true });                                
    }
    scope.submitOTPData = function () {
        //http://stg-plus.medibuddy.in/#/medicalprocess?details=Crc34z8CnbTUuBLfrE+sKQ==
        //localhost:3000/#/medicalprocess?details=Crc34z8CnbTUuBLfrE+sKQ==        
        var data = {
            encryptedKey: UserService.dcUrl,
            otp: scope.OTP,
            // accessToken: UserService.getAccessToken() ? UserService.getAccessToken() : ''
        }
        var url = UtilitiesService.getPlusUrlPrefix();
        UserService.makeRestCall(url + 'RequestMedicalProcess', data, 'POST').then(function (response) {
            scope.OTP = null;           
            if (response.data.isSuccess) {
                UtilitiesService.showAlertMessage('Status updated successfully', true);
                $state.go('misreports', {}, { reload: true }) ;                       
            } else                 
            UtilitiesService.showAlertMessage(response.data.errorMessage);           
        });
    }
}]);
angular.module('mbplus')
    .controller('markAutoAttendenceCtrl', ['$rootScope', '$scope', 'UserService', 'UtilitiesService', '$state', '$location', function (rootScope, scope, UserService, UtilitiesService, $state, $location) {
        rootScope.showMenu = false;
        scope.selectedChoice = '';
        scope.showThankYou = false;
        scope.feedback = "";
        scope.encryptedKey = $state.params.id;

        if (!scope.encryptedKey) {
            $state.go('appointments', {}, { reload: true });
        }

        var ratingDiv = document.getElementById("rating");
        var stars = ratingDiv.querySelectorAll(".star");
        stars.forEach(function (elem) {
            elem.addEventListener("mouseover", function (event) {
                var onStar = parseInt(elem.getAttribute("data-value"));
                stars.forEach(function (ele) {
                    if (parseInt(ele.getAttribute("data-value")) <= onStar) {
                        ele.classList.add('rated');
                    } else {
                        ele.classList.remove('rated');
                        ele.classList.add('not-rated');
                    }
                });

            });
        });

        //Page landed event
        UserService.makeRestCall(UtilitiesService.getProviderMediBuddyUrl()+"v1/events/provider/capture", {
            eventType: "Landed_on_attendance_page",
            type: "WhatsApp_Attendance",
            scope: scope.encryptedKey
        }, "post");

        // Attended selected event
        scope.attendenceYesClicked = function () {
            UserService.makeRestCall(UtilitiesService.getProviderMediBuddyUrl()+"v1/events/provider/capture", {
                eventType: "Attended_selected_on_attendance_page",
                type: "WhatsApp_Attendance",
                scope: scope.encryptedKey
            }, "post");
        };

        //Not attended selected event
        scope.attendenceNoClicked = function () {
            UserService.makeRestCall(UtilitiesService.getProviderMediBuddyUrl()+"v1/events/provider/capture", {
                eventType: "Not_attended_selected_on_attendance_page",
                type: "WhatsApp_Attendance",
                scope: scope.encryptedKey
            }, "post");
        };

        scope.submitAutoAttendenceData = function () {
            var starRating = ratingDiv.querySelectorAll(".star.rated").length;
            var data = {
                encryptedKey: scope.encryptedKey,
                nextStatusId: scope.selectedChoice === 'yes' ? 32 : 39
            }
            var url = UtilitiesService.getPlusUrlPrefix();

            UserService.makeRestCall(url + 'AutoMarkAttendence', data, 'POST').then(function (response) {

                // Submitted event
                UserService.makeRestCall(UtilitiesService.getProviderMediBuddyUrl()+"v1/events/provider/capture", {
                    eventType: "Submitted_on_attendance_page",
                    type: "WhatsApp_Attendance",
                    scope: scope.encryptedKey
                }, "post");

                UserService.makeRestCall(UtilitiesService.getProviderMediBuddyUrl()+"v1/events/provider/capture", {
                    eventType: "Star_Rating_on_attendance_page",
                    type: "WhatsApp_Attendance",
                    starRating:starRating,
                    scope: scope.encryptedKey
                }, "post");

                UserService.makeRestCall(UtilitiesService.getProviderMediBuddyUrl()+"v1/events/provider/capture", {
                    eventType: "Feedback_on_attendance_page",
                    type: "WhatsApp_Attendance",
                    feedback:scope.feedback,
                    scope: scope.encryptedKey
                }, "post");

                scope.selectedChoice = null;
                if (response.data.isSuccess) {
                    UtilitiesService.showAlertMessage('Status updated successfully', true);
                    scope.showThankYou = true;
                } else {
                    UtilitiesService.showAlertMessage(response.data.errorMessage, false);
                    scope.showThankYou = false;
                }
            });
        }
    }]);
angular.module('mbplus')
.controller('insurerDashboardController', ['$scope', '$analytics', 'navConstantsSvc', 'UserService', 'UtilitiesService', '$rootScope', 'PlusUtilitiesService', 'filterFilter', function (scope, $analytics, navConstantsSvc, UserService, UtilitiesService, $rootScope, PlusUtilitiesService, filterFilter) {
    $analytics.pageTrack('/appointments');
    if (!UserService.isActive()) {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    scope.dataError = '';
    scope.chartType = {
        type: 'pie'
    };

    scope.showCard = true;
    scope.showTemplatePopUp = false;
    scope.contract = {};
    scope.isDdlVisible = false;
    scope.isDownload = false;
    scope.childrenData = UtilitiesService.getAllChildren() === null ? [] : UtilitiesService.getAllChildren();
    scope.contractList = UtilitiesService.getContracts() === null ? [] : UtilitiesService.getContracts();
    scope.contractList1 = filterFilter(scope.contractList, {
        id: scope.childrenData
    }, function (actual, expected) {
        return filterFilter(expected, {
            'erTypeId': parseInt(actual)
        }).length > 0;
    });
    scope.contractList = scope.contractList1;

    angular.forEach(scope.user && scope.user.rolesFeatures.roles, function (v, i) {
        if (v.roleId === 9211 || v.roleId === 9214 || v.roleId === 9204) {
            scope.isDdlVisible = false;
            scope.isDownload = false;
        }
    });
    if (scope.user && scope.user.entityId) {
        if (scope.user.entityId === 1000042) {
            scope.isDdlVisible = false;
            scope.isDownload = false;
        }
    };

    //time/........................
    scope.formats = navConstantsSvc.dateFormate;
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];

    var currDate = new Date();
    var priorDate = new Date(new Date().setDate(currDate.getDate() - 90));

    scope.dateFilterDate = {
        fromDateFilter: priorDate,
        toDateFilter: currDate
    };

    scope.dateDefautOptions = {
        formatYear: 'yy',
        minDate: scope.dateFilterDate.fromDateFilter,
        startingDay: 1
    };

    scope.setMinDate = function (fromDate) {
        scope.mindate = '';
        var setMinDate = fromDate;
        setMinDate.setDate(fromDate.getDate());
        scope.mindate = setMinDate;
        scope.mindate = scope.dateFilterDate.fromDateFilter;
    };

    scope.popup5 = {
        opened: false
    };

    scope.popup6 = {
        opened: false
    };

    scope.open5 = function () {
        scope.popup5.opened = true;
        scope.dateFilterDate.toDateFilter = '';
    };

    scope.open6 = function () {
        scope.popup6.opened = true;
    };

    scope.setMinDate = function (fromDate) {
        scope.mindate = '';
        var setMinDate = fromDate;
        setMinDate.setDate(fromDate.getDate());
        scope.mindate = setMinDate;
        scope.mindate = scope.dateFilterDate.fromDateFilter;
    };
    //time/........................

    var tooltip = nv.models.tooltip();
    tooltip.duration(0);

    scope.changeChart = function (chartType) {
        if (chartType === 'pie') {
            scope.chartType.type = 'pie';
            scope.parentChart();
            scope.childChart();
        }
        else if (chartType === 'donut') {
            scope.chartType.type = 'donut';
            scope.parentChart();
            scope.childChart();
        }
        else if (chartType === 'discrete') {
            scope.chartType.type = 'discrete';
            scope.parentChart();
            scope.childChart();
        }
    };

    scope.parentChart = function () {
        //parentChart piechart
        if (scope.chartType.type === 'pie' || scope.chartType.type === 'donut') {
            scope.masterData = [];
            angular.forEach(scope.masterChartData, function (v, i) {
                var tempData = {
                    id: '',
                    statusCount: v.appointmentCount,
                    statusName: v.statusName
                }
                scope.masterData.push(tempData);
            })

            scope.masterOptions = {
                chart: {
                    pie: {
                        dispatch: {
                            elementClick: function (e) {
                                scope.loadChildChart(e);
                            }
                        }
                    },
                    type: 'pieChart',
                    pieSliceBorderColor: 'transparent',
                    height: 350,
                    donut: scope.chartType.type === 'pie' ? false : true,
                    x: function (d) { return d.statusName; },
                    y: function (d) { return d.statusCount; },
                    showLabels: true,
                    transitionDuration: 500,
                    duration: 500,
                    labelThreshold: 0.01,
                    labelSunbeamLayout: true,
                    legend: {
                        dispatch: {
                            legendMouseover: function (o) {
                                if (tooltip.hidden()) {
                                    var data = {
                                        series: {
                                            key: o.statusName,
                                            value: o.statusCount + ' Appointments',
                                            color: o.color
                                        }
                                    };
                                    tooltip.data(data)
                                      .hidden(false);
                                }
                            },
                            legendMouseout: function (o) {
                                tooltip.hidden(true);
                            }
                        },
                    },
                    valueFormat: function (d) {
                        return d + ' Appointments';
                    },
                    labelType: function (d) {
                        var percent = (d.endAngle - d.startAngle) / (2 * Math.PI);
                        return d3.format('%')(percent);
                    }
                }
            };
        }

        //parentChart discreate
        if (scope.chartType.type === 'discrete') {
            scope.masterData = [{
                values: []
            }];
            angular.forEach(scope.masterChartData, function (v, i) {
                var tempData = {
                    id: '',
                    statusCount: v.appointmentCount,
                    statusName: v.statusName
                }
                scope.masterData[0].values.push(tempData);
            })
            scope.masterOptions = {
                chart: {
                    discretebar: {
                        dispatch: {
                            elementClick: function (e) {
                                scope.loadChildChart(e);
                            }
                        }
                    },
                    type: 'discreteBarChart',
                    height: 350,
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 60,
                        left: 55
                    },
                    x: function (d) { return d.statusName; },
                    y: function (d) { return d.statusCount; },
                    showValues: true,
                    valueFormat: function (d) {
                        return d + ' Appointments';
                    },
                    transitionDuration: 500,
                    xAxis: {
                        axisLabel: 'X Axis'
                    },
                    yAxis: {
                        axisLabel: 'Y Axis',
                        axisLabelDistance: 30
                    }
                }
            };
        }

    };

    scope.childChart = function () {
        //childChart pie
        if (scope.chartType.type === 'pie' || scope.chartType.type === 'donut') {
            scope.childData = [];
            angular.forEach(scope.childChartData, function (v, i) {
                var tempData = {
                    id: v.statusID,
                    statusCount: v.appointmentCount,
                    statusName: v.statusName
                }
                scope.childData.push(tempData);
            })
            scope.childOptions = {
                chart: {
                    pie: {
                        dispatch: {
                            elementClick: function (e) {
                                scope.category(e);
                            }
                        }
                    },
                    type: 'pieChart',
                    height: 350,
                    donut: scope.chartType.type === 'pie' ? false : true,
                    x: function (d) { return d.statusName; },
                    y: function (d) { return d.statusCount; },
                    showLabels: true,
                    transitionDuration: 500,
                    duration: 500,
                    labelThreshold: 0.01,
                    labelSunbeamLayout: true,
                    legend: {
                        dispatch: {
                            legendMouseover: function (o) {
                                if (tooltip.hidden()) {
                                    var data = {
                                        series: {
                                            key: o.statusName,
                                            value: o.statusCount + ' Appointments',
                                            color: o.color
                                        }
                                    };
                                    tooltip.data(data)
                                      .hidden(false);
                                }
                            },
                            legendMouseout: function (o) {
                                tooltip.hidden(true);
                            }
                        }
                    },
                    valueFormat: function (d) {
                        return d + ' Appointments';
                    },
                    labelType: function (d) {
                        var percent = (d.endAngle - d.startAngle) / (2 * Math.PI);
                        return d3.format('%')(percent);
                    }
                }
            };
        }

        //childChart discreate
        if (scope.chartType.type === 'discrete') {
            scope.childData = [{
                values: []
            }];
            angular.forEach(scope.childChartData, function (v, i) {
                var tempData = {
                    id: v.statusID,
                    statusCount: v.appointmentCount,
                    statusName: v.statusName
                }
                scope.childData[0].values.push(tempData);
            })
            scope.childOptions = {
                chart: {
                    discretebar: {
                        dispatch: {
                            elementClick: function (e) {
                                scope.category(e);
                            }
                        }
                    },
                    type: 'discreteBarChart',
                    height: 350,
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 60,
                        left: 55
                    },
                    x: function (d) { return d.statusName; },
                    y: function (d) { return d.statusCount; },
                    showValues: true,
                    valueFormat: function (d) {
                        return d + ' Appointments';
                    },
                    transitionDuration: 500,
                    xAxis: {
                        axisLabel: 'X Axis'
                    },
                    yAxis: {
                        axisLabel: 'Y Axis',
                        axisLabelDistance: 30
                    }
                }
            };
        }
    };

    scope.loadMasterChart = function (fromDate, toDate, getChildData, source) {
        if (source === 'fromFilter') {
            scope.allAppointments = [];
            scope.pbqueue = [];
            scope.tabtype = '';
            scope.childParticularStatusData = '';
            scope.showHashDetails = false;
            if (fromDate || toDate) {
                if (fromDate && !toDate || !fromDate && toDate) {
                    UtilitiesService.showAlertMessage('You missed FROM or TO date kindly choose date and try again.');
                    return false;
                } else {
                    scope.fromDt = fromDate;
                    scope.toDate = toDate;
                }
            } else {
                UtilitiesService.showAlertMessage('You missed FROM or TO date kindly choose date and try again.');
                return false;
            }
        }
        var childData = '';
        if (getChildData) {
            var childData = getChildData;
        }
        // var currDate = new Date();
        // var priorDate = new Date(new Date().setDate(currDate.getDate() - 90));
        currDate = currDate.toLocaleDateString('en-IN').split('/').reverse().join('-');
        priorDate = priorDate.toLocaleDateString('en-IN').split('/').reverse().join('-');
        var chartData = {
            searchCriteria: {
                'String': 'String'
            },
            fromDate: scope.fromDt ? scope.fromDt : priorDate,
            toDate: scope.toDate ? scope.toDate : currDate,
            dashboardType: {
                'InsurerDashboard': childData ? childData : 'InsurerDashboard'
            },
            accessToken: UserService.getAccessToken()
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/FetchDashboardAppointments', chartData, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data.dbStatusWiseApptCount.length > 0) {
                scope.chartName = response.data.dashboardName;
                scope.chartStatusName = response.data.dbStatusWiseApptCount ? (response.data.dbStatusWiseApptCount[0] ? response.data.dbStatusWiseApptCount[0].statusName : '') : '';
                scope.dataError = '';
                if (!getChildData) {
                    scope.masterData = [];
                    scope.childData = [];
                    scope.masterChartData = [];
                    scope.totalChildStatusRecord = '';
                    scope.allAppointments = [];
                    scope.pbqueue = [];
                    var masterData = response.data.dbStatusWiseApptCount;
                    scope.masterChartData = response.data.dbStatusWiseApptCount;
                    var noOfMasterStatus = masterData.length;
                    var totalMasterRecords = 0;
                    angular.forEach(masterData, function (v, i) {
                        var tempData = {
                            id: '',
                            statusCount: v.appointmentCount,
                            statusName: v.statusName
                        }
                        totalMasterRecords = totalMasterRecords + v.appointmentCount;
                        scope.masterData.push(tempData);
                    })
                    scope.totalMasterStatusRecord = 'Total ' + noOfMasterStatus + ' master status consists of ' + totalMasterRecords + ' appointments';
                    scope.masterData = [];
                    scope.masterDataPresent = true;

                    scope.parentChart();
                }
                if (getChildData) {
                    scope.childData = [];
                    scope.childChartData = [];
                    var childData = response.data.dbStatusWiseApptCount;
                    scope.childChartData = response.data.dbStatusWiseApptCount;
                    var noOfStatus = childData.length;
                    var totalChildRecord = 0;
                    angular.forEach(childData, function (v, i) {
                        var tempChildData = {
                            id: v.statusID,
                            statusCount: v.appointmentCount,
                            statusName: v.statusName
                        }
                        scope.childData.push(tempChildData);
                        totalChildRecord = totalChildRecord + v.appointmentCount;
                    })
                    scope.totalChildStatusRecord = 'Total ' + noOfStatus + ' status in ' + getChildData + ' consists of ' + totalChildRecord + ' appointments';
                    scope.childData = [];

                    scope.childChart();
                }
            } else {
                scope.dataError = 'No data available';
                scope.allAppointments = [];
                scope.pbqueue = [];

                scope.childData = [];
                scope.masterData = [];
                if (getChildData) {
                    scope.childData = [];
                }
                if (!getChildData) {
                    scope.masterData = [];
                }
            }
        },
        function (error) {
        });
    };
    scope.currentPageNo = 0;
    esalesItemCount = 10;
    scope.searchAppointmentsGroupCtrl = function (pageNo){
        scope.currentPageNo = pageNo;
        scope.loadEsales();
    }
    scope.loadEsales = function (searchValue) {
        scope.searchSource = searchValue ? (searchValue.value ? searchValue.value : '') : '';
        scope.selectedOrderType = searchValue ? (searchValue.selectedOrderType ? searchValue.selectedOrderType : '') : '';
        if (scope.selectedOrderType) {
            if (scope.selectedOrderType == 'reqId') {
                scope.hashtagFilters = { requestid: scope.searchSource }
            } if (scope.selectedOrderType == 'email') {
                scope.hashtagFilters = { emailid: scope.searchSource }
            } if (scope.selectedOrderType == 'empId' || scope.selectedOrderType == 'Application no') {
                scope.hashtagFilters = { empid: scope.searchSource }
            } if (scope.selectedOrderType == 'contact') {
                scope.hashtagFilters = { contactno: scope.searchSource }
            } if (scope.selectedOrderType == 'name') {
                scope.hashtagFilters = { name: scope.searchSource }
            } if (scope.selectedOrderType == 'EQuote') {
                scope.hashtagFilters = { Equote: scope.searchSource }
            }
        }
        var data = {
            'sourceId': 0,
            'entityRelationId': 0,
            'fromDate': scope.dateFilterDate.fromDateFilter ? scope.dateFilterDate.fromDateFilter : '',
            'toDate': scope.dateFilterDate.toDateFilter ? scope.dateFilterDate.toDateFilter : '',
            'searchType': scope.hashtagFilters,
            'statusID': scope.esaleStatusId ? scope.esaleStatusId : '',
            'pageNo': scope.currentPageNo,
            'rows': scope.esalesItemCount,
            'RequestFrom': 'Dashboard'
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/policyBazaarRequests/', data, 'POST', UserService.getAccessToken()).then(function (response) {
            scope.pbqueue = response.data;
            scope.filterDateData = response.data.pendingRequestQueueData;
            UserService.saleQueueDataCollection = response.data.pendingRequestQueueData;
            scope.statusName = scope.statusName ? scope.statusName : 'no status';
            scope.childParticularStatusData = 'You have selected ' + scope.statusName + ', ( for status - ' + scope.childStatusName + ') ' + ' consists of ' + scope.filterDateData.length + ' records';
            scope.showHashDetails = false;
            if (scope.hashtagFilters && Object.keys(scope.hashtagFilters).length > 0) {
                var keyData = Object.keys(scope.hashtagFilters);
                var valueData = scope.hashtagFilters[keyData];
                scope.showHashDetails = true;
                scope.hashDetails = 'Results for ' + keyData[0] + ' - ' + valueData;
            }
            scope.equoteData = {};
            scope.allAppointments = [];
            angular.forEach(scope.pbqueue.pendingRequestQueueData, function (v, i) {
                if (v.eQuote) {
                    v.originaleQuote = v.eQuote;
                    v.eQuote = v.eQuote.split('_')[0];
                }
                scope.equoteData[v.eQuote] = JSON.parse(v.requestJSON);
                if (scope.equoteData[v.eQuote] && scope.equoteData[v.eQuote].employeeId) {
                    scope.equoteData[v.eQuote].originaleQuote = scope.equoteData[v.eQuote].employeeId;
                    scope.equoteData[v.eQuote].employeeId = scope.equoteData[v.eQuote].employeeId.split('_')[0]
                }
                scope.equoteData[v.eQuote]['pbrequestId'] = v.id;
                scope.equoteData[v.eQuote]['source'] = v.source;
            })
        });
    };

    //Get and add Correspondence
    scope.getAddCorrespondence = function (reqDetails, action) {
        if (reqDetails) {
            scope.reqDetails = reqDetails;
            if (action === 'add') {
                scope.corres.corrremarks = '';
                scope.corres.calltype = '';
                scope.corres.callstatus = '';
                scope.getCallTypes();
            } else if (action === 'show' && reqDetails.id) {
                scope.correspondencError = '';
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/RequestCorrespondence/153/0/' + reqDetails.id, '', 'GET').then(function (response) {
                    if (response.data.length > 0) {
                        scope.correspondencData = response.data;
                    } else {
                        scope.correspondencError = 'No correspondence available.';
                        scope.correspondencData = [];
                    }
                });
            }
        }
        else {
            UtilitiesService.showAlertMessage('Id not found.');
        }
    };

    scope.category = function (selectedStatus) {
        scope.showCard = false;
        scope.childStatusName = selectedStatus.data.statusName;
        scope.statusName = scope.selectedStatusName;
        if (scope.statusName && scope.statusName !== 'PendingCases') {
            scope.printStatusName = (scope.statusName == 'ScheduleCases') ? 'Schedule Cases' : ((scope.statusName === 'ClosedCases') ? 'Closed Cases' : (scope.statusName === 'ClosedCases' ? 'Closed Cases' : scope.statusName));
            scope.tabtype = 'insurerDashboard';
            scope.getStatusRecordAllAppt(selectedStatus);
        }
        if (scope.statusName && scope.statusName === 'PendingCases') {
            scope.tabtype = 'eSalesRequests';
            scope.esaleStatusId = selectedStatus.data.id;
            scope.loadEsales();
        }
    };

    scope.loadChildChart = function (selectedStatus) {
        scope.selectedStatusName = selectedStatus.data.statusName;
        var selectedStatusChild = selectedStatus.data.statusName;
        scope.allAppointments = [];
        scope.pbqueue = [];
        scope.tabtype = '';
        scope.childParticularStatusData = '';
        scope.showHashDetails = false;
        if (scope.fromDt && scope.toDate) {
            scope.loadMasterChart(scope.fromDt, scope.toDate, selectedStatusChild);
        } else {
            scope.loadMasterChart('', '', selectedStatusChild);
        }
    };

    scope.ctrlFn = function (nextpage) {
        scope.pageNo = nextpage;
        scope.pageNo = scope.pageNo - 1;
        scope.getStatusRecordAllAppt(scope.statusData);
    };

    scope.pageNo = 0;
    scope.rowCount = 10;
    scope.getStatusRecordAllAppt = function (statusDetails, searchValue) {
        var providerId = null;
        scope.statusData = statusDetails;
        scope.searchSource = searchValue ? (searchValue.value ? searchValue.value : '') : '';
        scope.selectedOrderType = searchValue ? (searchValue.selectedOrderType ? searchValue.selectedOrderType : '') : '';
        if (scope.selectedOrderType) {
            var abc = scope.abc;
            if (scope.selectedOrderType == 'reqId') {
                scope.hashtagFilters = { requestid: scope.searchSource }
            } if (scope.selectedOrderType == 'email') {
                scope.hashtagFilters = { emailid: scope.searchSource }
            } if (scope.selectedOrderType == 'empId') {
                scope.hashtagFilters = { empid: scope.searchSource }
            } if (scope.selectedOrderType == 'contact') {
                scope.hashtagFilters = { contactno: scope.searchSource }
            } if (scope.selectedOrderType == 'name') {
                scope.hashtagFilters = { name: scope.searchSource }
            } if (scope.selectedOrderType == 'partnerOrderId') {
                scope.hashtagFilters = { partnerorderid: scope.searchSource }
            }
        }
        if (!scope.daysOfAppointment || scope.daysOfAppointment == '' || scope.daysOfAppointment <= -1) {
            scope.daysOfAppointment = -1;
        }
        var data = {
            daysOfAppointment: scope.daysOfAppointment,
            ProviderId: providerId,
            hashtagFilters: scope.hashtagFilters,
            requestAccessToken: UserService.getAccessToken(),

            statusId: scope.statusData ? (scope.statusData.data ? (scope.statusData.data.id ? scope.statusData.data.id : '') : '') : '',

            //statusId: scope.statusData.data.id,
            fromDate: scope.fromDt ? scope.fromDt : '',
            toDate: scope.toDate ? scope.toDate : '',
            pageNo: scope.pageNo,
            rows: scope.rowCount,
            searchType: 1
        };
        scope.appointmentsCount = 0;

        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + '/allAppointments', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
            if (response.data.isSuccess) {
                scope.pbqueue = [];
                scope.allAppointments = response.data;
                UserService.activeAppointmentsDummyData = response.data;
                UserService.activeAppointmentsDummyDataCollection = response.data.requests;
                scope.childParticularStatusData = 'You have selected ' + scope.printStatusName + ', ( for status - ' + scope.childStatusName + ') ' + ' consists of ' + scope.allAppointments.totalRows + ' records';

                scope.showHashDetails = false;
                if (scope.hashtagFilters && Object.keys(scope.hashtagFilters).length > 0) {
                    var keyData = Object.keys(scope.hashtagFilters);
                    var valueData = scope.hashtagFilters[keyData];
                    scope.showHashDetails = true;
                    scope.hashDetails = 'Results for ' + keyData[0] + ' - ' + valueData;
                }
            } else {
            }
        },
        function (error) {
        });
    };

    scope.getRecordInBoth = function (searchValue) {
        //scope.statusData = statusDetails;
        scope.searchSource = searchValue ? (searchValue.value ? searchValue.value : '') : '';
        //scope.selectedOrderType = searchValue ? (searchValue.selectedOrderType ? searchValue.selectedOrderType : '') : '';
        var data = {
            applicationNo: scope.searchSource,
            accessToken: UserService.getAccessToken()
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/SearchApplicationNoOfInsurer', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
            if (response.data.isSuccess) {
                if (response.data.fetchedFrom === 'Esales') {
                    scope.tabtype = 'eSalesRequests';
                    //code for esales
                    scope.pbqueue = response.data.reqObject;
                    scope.filterDateData = response.data.reqObject;
                    UserService.saleQueueDataCollection = response.data.reqObject;
                    scope.equoteData = {};
                    scope.allAppointments = [];
                    angular.forEach(scope.pbqueue, function (v, i) {
                        if (v.eQuote) {
                            v.originaleQuote = v.eQuote;
                            v.eQuote = v.eQuote.split('_')[0];
                        }
                        scope.equoteData[v.eQuote] = JSON.parse(v.requestJSON);
                        if (scope.equoteData[v.eQuote] && scope.equoteData[v.eQuote].employeeId) {
                            scope.equoteData[v.eQuote].originaleQuote = scope.equoteData[v.eQuote].employeeId;
                            scope.equoteData[v.eQuote].employeeId = scope.equoteData[v.eQuote].employeeId.split('_')[0]
                        }
                        scope.equoteData[v.eQuote]['pbrequestId'] = v.id;
                        scope.equoteData[v.eQuote]['source'] = v.source;
                    })
                } else if (response.data.fetchedFrom === 'Allappointments') {
                    scope.tabtype = 'insurerDashboard';
                    //code for all appt
                    scope.pbqueue = [];
                    scope.allAppointments = response.data.reqObject;
                    UserService.activeAppointmentsDummyData = response.data.reqObject;
                    UserService.activeAppointmentsDummyDataCollection = response.data.reqObject;
                }
                scope.showHashDetails = true;
                scope.childParticularStatusData = '';
                scope.hashDetails = 'Results for ' + 'Application no/Employee Id' + ' - ' + scope.searchSource;
            }
            else {
                scope.showHashDetails = true;
                scope.hashDetails = 'Sorry no record found for ' + 'Application no/Employee Id' + ' - ' + scope.searchSource;
            }
        },
        function (error) {
        });
    };

    //Search by
    $rootScope.$on('searchByAllInsurer', function (key, value, source) {
        var statusData = scope.statusData ? scope.statusData : '';
        scope.dateFilterDate = [];
        scope.pbqueue = [];
        scope.allAppointments = [];
        scope.showHashDetails = '';
        scope.childParticularStatusData = '';
        scope.tabtype = '';
        scope.showCard = false;
        if (source === 'Esales') {
            scope.tabtype = 'eSalesRequests';
            scope.esaleStatusId = '';
            scope.loadEsales(value);
        }
        else if (source === 'Allappt') {
            scope.tabtype = 'insurerDashboard';
            // scope.statusData.data.id = scope.statusData ? (scope.statusData.data ? (scope.statusData.data.id?'':'') : '') : '';
            //scope.statusData ? (scope.statusData.data ? (scope.statusData.data.id ? '' : '') : '') : '';
            scope.getStatusRecordAllAppt(statusData, value);
        }
        else if (source === 'both') {
            //scope.tabtype = 'insurerDashboard';
            //scope.statusData.data.id = '';
            //scope.statusData ? (scope.statusData.data ? (scope.statusData.data.id ? '' : '') : '') : '';
            scope.getRecordInBoth(value);
        }
    });

    $rootScope.$on('searchByClear', function (key, value) {
        scope.hashtagFilters = [];
    });

    scope.reload = function () {
        scope.pageNo = 0;
        scope.rowCount = 10;
        scope.statusData = {};
        scope.dateFilterDate = {};
        scope.fromDt = '';
        scope.toDate = '';
        scope.allAppointments = [];
        scope.childParticularStatusData = '';
        scope.pbqueue = [];
        scope.tabtype = '';
        scope.showHashDetails = '';
        scope.childChartData = [];
        scope.loadMasterChart();
        $rootScope.$emit('reloadInsurer');
    };

    scope.checkContract = function () {
        if (scope.contractList.length !== 0) {
            if (scope.contractList.length > 1) {
                scope.isDdlVisible = true;
                scope.isDownload = false;
            }
            else {
                scope.isDdlVisible = false;
                scope.isDownload = true;
                scope.contract.id = scope.contractList[0].id;
                scope.setContractIdForUpload = scope.contract.id
                scope.templateUrl = UtilitiesService.getPlusUrlPrefix() + '/DownloadAllSampleExcelFormat/' + scope.contract.id;
            }
        } else {
            scope.isDdlVisible = false;
            scope.isDownload = false;
        }
    };

    scope.getSelectedErId = function (selectedContract) {
        //selected from ddl
        if (selectedContract == null) {
            scope.isDownload = false;
            scope.isDdlVisible = true;
        }
        if (selectedContract && selectedContract.id) {
            if (selectedContract) {
                scope.contract = {};
                scope.contract.id = selectedContract.id
                scope.setContractIdForUpload = scope.contract.id
                scope.templateUrl = UtilitiesService.getPlusUrlPrefix() + '/DownloadAllSampleExcelFormat/' + scope.contract.id;
                scope.isDownload = true;
            } else {
                scope.isDownload = false;
            }
        }
        else if (!scope.contractList.length > 1) {
            scope.contract.id = selectedContract;
            scope.setContractIdForUpload = scope.contract.id
            scope.templateUrl = UtilitiesService.getPlusUrlPrefix() + '/DownloadAllSampleExcelFormat/' + scope.contract.id;
            scope.isDownload = true;
        } else {
            scope.isDdlVisible = true;
        }
    };

    scope.setFilesUpload = function (element) {
        $("#uploadTemplates").attr("disabled", "disabled");
        if (window.FormData) {
            formdata = new FormData();
        }
        file = element.files[0];
        if (formdata) {
            formdata.append("reports[]", file);
            formdata.append("userEntityId", UserService.getUserObj().entityId);
            formdata.append("contractId", scope.setContractIdForUpload);
        }

        $.ajax({
            url: UtilitiesService.getPlusUrlPrefix() + "UploadExcelOrders.json",
            type: "POST",
            data: formdata,
            headers: {
                "AccessToken": UserService.getAccessToken()
            },
            processData: false,
            contentType: false,
            success: function (res) {
                if (res.isSuccess) {
                    if(res.errorMessage){
                        UtilitiesService.showAlertMessage(res.errorMessage);
                    }else{
                        UtilitiesService.showAlertMessage('Appointments created Successfully! You will be able to see in active appointments, once it is approved by our operations person.', true);
                    }
                }
                else {
                    UtilitiesService.showAlertMessage('Appointment creation failed.');
                    scope.failedFileName = res.fileName;
                }
                $("input#uploadTemplates").val('');
                $("#uploadTemplates").removeAttr('disabled');
                $("#uploadTemplates").attr('value', '');
                scope.$apply();
            }

        });
        return false;
    };

    scope.loadMasterChart();
    scope.checkContract();
}]);
angular.module('mbplus')
.controller('inforequiredCtrl', ['$rootScope', '$scope', '$location', '$window', '$http', 'UserService', 'UtilitiesService', '$stateParams', function ($rootScope, scope, $location, $window, $http, UserService, UtilitiesService, $stateParams) {
  $rootScope.showAll = false;
  scope.$root.title = 'Submit IR | Medibuddy Hospital Portal';
  $("#sidebar li").removeClass("active");
  $("#sidebar li#approved").addClass("active");
  if (!UserService.isActive()) {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }
  
  if ($stateParams.claimId) {
  }

  var secid;
  var event;
  scope.name = "Information Required"
  scope.hospId = parseInt($stateParams.hospid, 16);
  scope.claimId = parseInt($stateParams.claimId, 16);
  scope.currentTab = {}

  $(function () {
    $('#missingForm').submit(function () {
      $("#missingbutton").prop("disabled", true);
      // submit the form 
      $(this).ajaxSubmit(function (data) {
        var missingData = $.parseJSON(data);
        scope.$apply(function () {
          scope.msubmitted = true;
          $("#missingForm").resetForm();
          $("#missingdocs").html('<input type="file" name="enhance-files" id="">');
          if (missingData && missingData.IsSuccess) {
            scope.msubsuccess = true;
          }
          else {
            scope.msubsuccess = false;
          }
        })
        $("#missingbutton").prop("disabled", false);
        return false;
      })
      // return false to prevent normal browser submit and page navigation 
      return false;
    });

    $("#myTabContent").on('click', "button#closeButton", function () {
      scope.$apply(function () {
        //$location.path('/');
      });
    })

  });
  scope.openTab = function (name, id, secid, event, type) {
    if (id != "In Progress") {
      var url = "";
      if (secid) {
        url = UtilitiesService.getUrlPrefix() + "/hosp/claim/claimdetails/" + scope.hospId + "/" + id + "/" + secid;
      }
      else {
        url = UtilitiesService.getUrlPrefix() + "/hosp/claim/claimdetails/" + scope.hospId + "/" + id;
      }
      $http.get(url).
      success(function (resData) {
        if (resData.isSuccess == true) {
          scope.name = resData.claimDetails.patientDetails.patientName;
          scope.currentTab[id] = {};
          var maxClaimed = 0;
          var maxApproved = 0;
          for (var i = 0; i < resData.claimDetails.claimAuditDetails.length; i++) {
            if (resData.claimDetails.claimAuditDetails[i].claimedApprovedAmt > maxApproved) {
              maxApproved = resData.claimDetails.claimAuditDetails[i].claimedApprovedAmt;
            }
            if (resData.claimDetails.claimAuditDetails[i].claimedAmt > maxClaimed) {
              maxClaimed = resData.claimDetails.claimAuditDetails[i].claimedAmt;
            }
          };
          if (maxApproved == 0) {
            scope.currentTab[id]["paApprovedAmt"] = UtilitiesService.formatCurrency(maxClaimed);
          }
          else {
            scope.currentTab[id]["paApprovedAmt"] = UtilitiesService.formatCurrency(maxApproved);
          }

          if (scope.currentTab[id])
            scope.ePaApproved = scope.currentTab[id]["paApprovedAmt"];
          $("#ePaApproved").text(scope.ePaApproved);
          var chatHistory = "";
          var footerHTML = "";
          var deductionDetails = "";
          var nmeDetails = "";
          var missingDocuments = "";
          var attachments = "";
          switch (type) {
            case "preauth":
              if (resData.claimDetails.claimDetails.claimStatus.toLowerCase().indexOf("in progress") == -1 && scope.myRole != 'guest' && scope.myRole != 'cms') {
                footerHTML = '<div class="panel-footer">' +
                 '    <div class="row">' +
                 '        <div class="col-md-2">' +
                 '        </div>' +
                 '        <div class="col-md-8">' +
                 '            <button class="btn btn-danger pull-right" id="closeButton">' +
                 '              Close Tab' +
                 '            </button>' +
                 '        </div>' +
                 '        <div class="col-md-2">' +
                 '        </div>' +
                 '    </div>' +
                 '</div>';
              }
              else if (scope.myRole != 'guest' && scope.myRole != 'cms') {
                footerHTML = '<div class="panel-footer">' +
                '    <div class="row">' +
                '        <div class="col-md-2">' +
                '        </div>' +
                '        <div class="col-md-8">' +
                '            <button class="btn btn-danger pull-right" id="closeButton">' +
                '              Close Tab' +
                '            </button>' +
                '        </div>' +
                '        <div class="col-md-2">' +
                '        </div>' +
                '    </div>' +
                '</div>';
              }
              else {
                footerHTML = '<div class="panel-footer">' +
                      '    <div class="row">' +
                      '        <div class="col-md-2">' +
                      '        </div>' +
                      '        <div class="col-md-8">' +
                      '            <button class="btn btn-danger pull-right" id="closeButton">' +
                      '              Close Tab' +
                      '            </button>' +
                      '        </div>' +
                      '        <div class="col-md-2">' +
                      '        </div>' +
                      '    </div>' +
                      '</div>';
              }
              break;
            case "cashless":
              footerHTML = '<div class="panel-footer">' +
                          '    <div class="row">' +
                          '        <div class="col-md-2">' +
                          '        </div>' +
                          '        <div class="col-md-8">' +
                          '            <button class="btn btn-danger pull-right" id="closeButton">' +
                          '              Close Tab' +
                          '            </button>' +
                          '        </div>' +
                          '        <div class="col-md-2">' +
                          '        </div>' +
                          '    </div>' +
                          '</div>';
              break;
            default:
              footerHTML = "";
          }
          if (resData.claimDetails.attachments && resData.claimDetails.attachments.length > 0) {
            attachments += '<div class="row chat-ma">' +
                        '    <div class="col-md-2">' +
                        '    </div>' +
                        '    <div class="col-md-8">' +
                        '        <div class="chat-content_wrap chat-ma">' +
                        '            <h5 class="chat-status"><strong>Attachments</strong></h5>' +
                        '<table class="table table-striped">' +
                            '<thead><tr>' +
                            '    <td><strong>Attachments list</strong></td>' +
                            // '    <td><strong>Download Link</strong></td>'+
                            '</tr></thead>                         ';
            for (var i = 0; i < resData.claimDetails.attachments.length; i++) {
              attachments += '            <tr><td><a href="' + resData.claimDetails.attachments[i].downloadURL + '" target="_blank"> Download ' + resData.claimDetails.attachments[i].originalFileName + '</a></td></tr>'
              // '            <td><a href="'+resData.claimDetails.attachments[i].downloadURL+'" target="_blank">Download</a></td></tr>'
            };
            attachments += '        </table></div>' +
                        '    </div>' +
                        '    <div class="col-md-2">' +
                        '    </div>' +
                        '</div>'
          }
          if (resData.claimDetails.deductionDetails && resData.claimDetails.deductionDetails.length > 0) {
            deductionDetails += '<div class="row chat-ma">' +
                            '    <div class="col-md-2">' +
                            '    </div>' +
                            '    <div class="col-md-8">' +
                            '        <div class="chat-content_wrap chat-ma">' +
                            '            <h5 class="chat-status"><strong>Deduction Details</strong></h5>' +
                            '<table class="table table-striped">' +
                            '<thead><tr>' +
                            '    <td><strong>Deduction amount</strong></td>' +
                            '    <td><strong>Deduction reason</strong></td>' +
                            '</tr></thead>                         ';
            for (var i = 0; i < resData.claimDetails.deductionDetails.length; i++) {
              deductionDetails += '<tr><td>Rs. ' + UtilitiesService.formatCurrency(resData.claimDetails.deductionDetails[i].deductionAmount) + '</td>' +
                              '            <td>' + resData.claimDetails.deductionDetails[i].deductionReason + '</td><tr>'
            };
            deductionDetails += '</table></div>' +
                            '    </div>' +
                            '    <div class="col-md-2">' +
                            '    </div>' +
                            '</div>';
          }
          if (resData.claimDetails.nmeDetails && resData.claimDetails.nmeDetails.length > 0) {
            nmeDetails += '<div class="row chat-ma">' +
                        '    <div class="col-md-2">' +
                        '    </div>' +
                        '    <div class="col-md-8">' +
                        '        <div class="chat-content_wrap chat-ma">' +
                        '            <h5 class="chat-status"><strong>Non payable amount</strong></h5>' +
                        '<table class="table table-striped">' +
                            '<thead><tr>' +
                            '    <td><strong>Non payable amount</strong></td>' +
                            '    <td><strong>Non payable reason</strong></td>' +
                            '</tr></thead>                         ';
            for (var i = 0; i < resData.claimDetails.nmeDetails.length; i++) {
              nmeDetails += '            <tr><td>Rs. ' + UtilitiesService.formatCurrency(resData.claimDetails.nmeDetails[i].nonPayableAmt) + '</td>' +
                          '            <td>' + resData.claimDetails.nmeDetails[i].nonPayableReason + '</td></tr>'
            };
            nmeDetails += '        </table></div>' +
                        '    </div>' +
                        '    <div class="col-md-2">' +
                        '    </div>' +
                        '</div>'
          }
          if (resData.claimDetails.claimDetails.missingDocuments) {
            missingDocuments = "<br><br><strong>Missing Documents</strong><table class='table table-default'><tbody>"
            for (var i = 0; i < resData.claimDetails.claimDetails.missingDocuments.length; i++) {
              missingDocuments += "<tr><td>" + resData.claimDetails.claimDetails.missingDocuments[i]; +"</td></tr>";
            };
            missingDocuments += "</tbody></table>";
            if (scope.myRole != 'guest') {
              missingDocuments += '<button class="btn btn-primary" data-toggle="modal" data-target="#submitMissing">' +
                          '              Submit Missing Documents' +
                          '            </button>';
            }
          }
          for (var i = 0; i < resData.claimDetails.claimAuditDetails.length; i++) {
            var thisData = resData.claimDetails.claimAuditDetails[i];
            if (!thisData.isFromHospital) {
              chatHistory += '<div class="row chat-ma">' +
                          '    <div class="col-md-2">' +
                          '    </div>' +
                          '    <div class="col-md-8">' +
                          '        <div class="chat-content_wrap chat-ma">' +
                          '            <h5 class="chat-status text-right">' + thisData.auditStatus + '  <span class="chat-user">by Medi Assist</span></h5>';
              if (thisData.claimedAmt && thisData.claimedAmt > 0)
                chatHistory += '<p class="chat-content">Claimed Amount: Rs.' + UtilitiesService.formatCurrency(thisData.claimedAmt) + '</p>';
              if (thisData.claimedApprovedAmt && thisData.claimedApprovedAmt > 0)
                chatHistory += '<p class="chat-content">Approved Amount: Rs.' + UtilitiesService.formatCurrency(thisData.claimedApprovedAmt) + '</p>';
              if (thisData.letterDownloadLink && thisData.letterDownloadLink != "")
                chatHistory += '<a class="chat-content btn-primary btn-sm download" href="' + thisData.letterDownloadLink + '">Click here to download ' + thisData.auditStatus + ' letter </a>';
              if (resData.claimDetails.claimDetails.missingDocuments && thisData.auditStatus == "Information Awaited" && i == resData.claimDetails.claimAuditDetails.length - 1)
                chatHistory += missingDocuments;
              chatHistory += '</div>' +
                      '    </div>' +
                      '    <div class="col-md-2">' +
                      '        <span class="chat-date">' + UtilitiesService.getAuditDate(thisData.auditDate) + '</span>' +
                      '        <span class="chat-date_time">' + UtilitiesService.getAuditTime(thisData.auditDate) + ' </span>' +
                      '    </div>' +
                      '</div>'
            }
            else {
              chatHistory += '<div class="row">' +
                          '    <div class="col-md-2">' +
                          '        <span class="chat-date">' + UtilitiesService.getAuditDate(thisData.auditDate) + '</span>' +
                          '        <span class="chat-date_time">' + UtilitiesService.getAuditTime(thisData.auditDate) + ' </span>' +
                          '    </div>' +
                          '    <div class="col-md-8">' +
                          '        <div class="chat-content_wrap">' +
                          '            <h5 class="chat-status">' + thisData.auditStatus + '  <span class="chat-user">by Hospital</span></h5>' +
                          '        </div>' +
                          '    </div>' +
                          '    <div class="col-md-2">' +
                          '    </div>' +
                          '</div>'
            }
          };
          var content = $("<div>").addClass("panel panel-default").append(
                          $("<div>").addClass("panel-body chat").append(
                              $("<div>").addClass("row").append(
                                      '<div class="col-md-2"></div>' +
                                          '<div class="col-md-8">' +
                                              '<div class="claim-info">' +
                                                  '<table class="table">' +
                                                      '<tr>' +
                                                          '<td>Customer</td>' +
                                                          '<td><strong>' + resData.claimDetails.patientDetails.patientName + '</strong></td>' +
                                                          '<td>Claim No.</td>' +
                                                          '<td><strong>' + resData.claimNumber + '</strong></td>' +
                                                      '</tr>' +
                                                      '<tr>' +
                                                          '<td>Age: </td>' +
                                                          '<td><strong>' + resData.claimDetails.patientDetails.patientAge + '</strong></td>' +
                                                          '<td>Contact Number: </td>' +
                                                          '<td><strong>' + resData.claimDetails.patientDetails.patientContactNumber + '</strong></td>' +
                                                      '</tr>                                                                    ' +
                                                  '</table>' +
                                              '</div>' +
                                          '</div>' +
                                          '<div class="col-md-2"></div>'
                              ),
                              chatHistory,
                              deductionDetails,
                              nmeDetails,
                              attachments
                          ),
                          footerHTML
                      );
          if ($("#tab" + resData.claimNumber).length == 0) {
            $("#myTabContent").append(
                $("<div>").addClass("tab-pane fade").attr("id", "tab" + resData.claimNumber).append(
                    content
                )
            )
          }
          else {
            $("#tab" + resData.claimNumber).empty();
            $("#tab" + resData.claimNumber).append(
                    content
                )
          }
          UtilitiesService.openNewTab(scope.name, id, event);
          scope.currentTab.claimId = id;
          $("#eClaimId").val(scope.currentTab.claimId);
          $("#dClaimId").val(scope.currentTab.claimId);
          $("#mClaimId").val(scope.currentTab.claimId);
        }
        else {
          var id1 = 123;
          var name = "Error";
          $("#myTab").append(
               $("<li>").html('<a href="/#tab' + id1 + '" id="' + id1 + '" role="tab" data-toggle="tab" class="customer-tab">' + name + '<i class="close">×</i></a>')
             );

          //$('#myTab a#' + id1).tab('show');
          $("#" + id1).css("width", $("#" + id1).width() + 50 + "px");
        }

      })
      .error(function () {
        // alert("Unable to fetch claim details");
        var id = 123;
        var name = "Error";
        $("#myTab").append(
             $("<li>").html('<a href="/#tab' + id + '" id="' + id + '" role="tab" data-toggle="tab" class="customer-tab">' + name + '<i class="close">×</i></a>')
           );
        $("#" + id).css("width", $("#" + id).width() + 50 + "px");
      })
    }
    else {
      alert("Can't check the details of a claim with status 'New Admission'");
    }
  }
  scope.openTab(scope.name, scope.claimId, secid, event, "preauth")
}]);
angular.module('mbplus')
.controller('hospitalProfileCtrl', ['$scope', '$location', '$window', '$http', 'UserService', 'ProfileService', 'UtilitiesService', '$analytics', '$timeout', 'FileUploadService', '$q', '$anchorScroll', function (scope, $location, $window, $http, UserService, ProfileService, UtilitiesService, $analytics, $timeout, FileUploadService, $q, $anchorScroll) {
    var hospitalProfileCtrl = this;
    $analytics.pageTrack('/provider-profile');
    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    $("#sidebar li").removeClass("active");
    $("#sidebar li#hospprofile").addClass("active");
    var input;
    var types;
    scope.hideEdit = false;
    scope.map = {
        isInitialised : false,
        value : ''
    }
    var radioButton;
    scope.hei = ($(window).height() - 180) + 'px';
    scope.dmslink = UtilitiesService.getDMSHostUrl();
    scope.editContact = false;
    scope.management = false;
    scope.insuranceCoordinator = false;
    scope.financeCoordinator = false;
    scope.marketing = false;
    scope.imgs = [];
    scope.addEditHospImages = [];
    scope.facilities = [];
    scope.otherFacilities = [];
    scope.file = [];
    scope.hospContactSource = '';
    scope.AllFacCount = 0;
    scope.imageTypes = [];
    scope.viewCorporate = UserService.getHospitalObj().hospId;
    scope.abc = {
        hospDesc: '',
        hospDesc1:''
    }
    scope.about = {
        disc: '',
        disc1: ''
    }
    hospitalProfileCtrl.isSundayOpen = false;
    scope.startCenterTime = new Date();
    scope.endCenterTime = new Date();
    scope.ismeridian = false;
    scope.hstep = 1;
    scope.mstep = 1;
    scope.profile = {
        firstTime: new Date(),
        secondTime: new Date()
    }
    // scope.contractDetails = {
    //     NABH: { regNo: null, startDate: null, endDate: null },
    //     MCI: { regNo: null, startDate: null, endDate: null }
    // }
    scope.edithospitalLandLineValue = true;    
    scope.edithospitalLandLine = function() {
        scope.edithospitalLandLineValue = false;
    }

    scope.addEditHospContact = { wavedoffDays: { 'id': 0, 'Value': '0' } };
    scope.wavedOffDays = [{ 'id': 0, 'Value': '0' }, { 'id': 1, 'Value': '1' }, { 'id': 2, 'Value': '2' }, { 'id': 3, 'Value': '3' }, { 'id': 4, 'Value': '4' }, { 'id': 5, 'Value': '5' }, { 'id': 6, 'Value': '6' }, { 'id': 7, 'Value': '7' }, { 'id': 8, 'Value': '8' }, { 'id': 9, 'Value': '9' }, { 'id': 10, 'Value': '10' }];
    //Load Hospital Profile
    scope.loadHospitalProfile = function () {
        var payload = {
            "getProviderDoctorDetail":true,
            "getProviderRoomDetail":true,
            "getProviderContactDetail":true,
            "getProviderDocumentDetail":true,
            "getProviderPackageDetail":true,
            "getProviderDiscountDetail":true
        }
        ProfileService.loadProviderProfileDataByKey('profile',payload).then(function (response) {
            if (response) {
                scope.hospProfile = {
                    hospDetails: response,
                    hospContactDetails:response.hospitalsContactDetails,
                    hospDiscounts: response.hospitalDiscountDetails,
                    hospDoctorDetails: response.hospitalsDoctorDetails,
                    hospDocuments:response.hospitalsDocumentDetails,
                    hospPackages: response.hospitalPakageDetails,
                    hospRoomDetails:response.hospitalsRoomDetails
                }
                scope.mapMethods.plotMapOnLoad();
                scope.addressMethods.getHospitalAddress(scope.hospProfile.hospDetails);
                scope.loadHospitalContactDetails();
                scope.imagesMethods.loadHospitalImages();
                scope.facilitiesMethods.loadFacilities();
            }
            else {
                scope.hospProfile = {
                    hospDetails: {}
                }
            }
        });
    };

    scope.isAbout ={
        edit: false
    }

    scope.editAbout = function(value){
        if(value === 'Edit'){
            scope.about.disc = scope.abc.hospDesc ? scope.abc.hospDesc : '';
            scope.isAbout.edit = true;
        }else if(value === 'close'){
            scope.about.disc = scope.abc.hospDesc ? scope.abc.hospDesc : '';
            scope.isAbout.edit = false;
        }
    };

    scope.masterMethods = (function () {
        return {
            loadMasterByKeyName: function (keyName) {
                var data = {
                    lookUpName: keyName
                }
                UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/getMasterLookUp', data, 'POST').then(function (response) {
                    if (response.data.isSuccess) {
                        data = response.data.lookUpResponse;
                        var response = [];
                        angular.forEach(data, function (e, i) {
                            var temp = {
                                id: i,
                                value: e
                            };
                            response.push(temp);
                        });
                        return response;
                    }
                });
            },
            getFromSessionStorage: function (keyName) {
                if (keyName) {
                    return JSON.parse(window.sessionStorage.getItem(keyName));
                }
            },
            setToSessionStorage: function (keyName, data) {
                if (keyName && data) {
                    window.sessionStorage.setItem(keyName, data);
                }
            },
            removeFromSessionStorage: function (keyName) {
                if (keyName) {
                    window.sessionStorage.setItem(keyName, null);
                }
            },
            getIdFromMaster: function (keyName, valueName) {

            }
        };
    })();
    scope.profileMethods = (function () {
        return {
            scrollTo: function (id) {
                $location.hash(id);
                $anchorScroll();
            },
            groupBy: function (collection, property) {
                var i = 0, val, index,
                values = [], result = [];
                for (; i < collection.length; i++) {
                    val = collection[i][property];
                    index = values.indexOf(val);
                    if (index > -1)
                        result[index].push(collection[i]);
                    else {
                        values.push(val);
                        result.push([collection[i]]);
                    }
                }
                return result;
            }
        };
    })();
    scope.mapMethods = (function () {
        var editMap;
        var newPositionMarker;
        return {
            displayPosition: function (pos) {
                var lng = pos.lng();
                var lati = pos.lat();
                //console.log('location by draging marker ' + lng + ' ' + lati);
                scope.latitude = lati;
                scope.longitude = lng;
            },
            plotMapOnLoad: function () {
                var myLatLng = new google.maps.LatLng(
                    scope.hospProfile.hospDetails.hospitalLatitude,
                    scope.hospProfile.hospDetails.hospitalLongitude
                );
                var map = new google.maps.Map(document.getElementById('map-canvas'), {
                    zoom: 17,
                    center: myLatLng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    panControl: false,
                    disableDefaultUI: true
                });
                map.setOptions({ draggable: false, zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true });
                var marker = new google.maps.Marker({
                    position: myLatLng,
                    map: map,
                    icon: "app/resources/images/pin.png",
                    title: scope.hospProfile.hospDetails.hospitalName
                });
            },
            getEditMap: function () {
                angular.element('#pac-input').val('');
                //initialize map location
                var editableLatLng = new google.maps.LatLng(
                    scope.hospProfile.hospDetails.hospitalLatitude,
                    scope.hospProfile.hospDetails.hospitalLongitude
                );
                //initialize map
                editMap = new google.maps.Map(document.getElementById('map'), {
                    center: editableLatLng,
                    zoom: 17,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                });
                scope.map = {
                    isInitialised : true,
                    value : editMap
                }
                //initialize marker
                var editMarker = new google.maps.Marker({
                    position: editableLatLng,
                    map: editMap,
                    icon: "app/resources/images/pin.png",
                    title: scope.hospProfile.hospDetails.hospitalName
                });
                //set map with marker
                editMarker.setMap(editMap);
                //resize map
                $("#hospitalMap").on("shown.bs.modal", function () {
                    google.maps.event.trigger(editMap, "resize");
                    editMap.setCenter(editableLatLng);
                });
                //Restricting India only search for locations
                var option = {
                    componentRestrictions: {
                        country: "IN"
                    }
                };
                editMap.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
                editMap.controls[google.maps.ControlPosition.TOP_LEFT].push(types);
                //take autocomplete and bind to map
                // var autocomplete = new google.maps.places.Autocomplete(input, option);
                // autocomplete.bindTo('bounds', editMap);
                // var infowindow = new google.maps.InfoWindow();
                // var infowindowOldLocation = new google.maps.InfoWindow();
                newPositionMarker = new google.maps.Marker({
                    draggable: true,
                    map: editMap,
                    anchorPoint: new google.maps.Point(0, -29),
                    title: 'you chose this as your new location'
                });
                //get coordinates after dragging
                google.maps.event.addListener(newPositionMarker, 'dragend', function (e) {
                    scope.mapMethods.displayPosition(newPositionMarker.getPosition())
                });
                //get coordinates on click
                google.maps.event.addListener(newPositionMarker, 'click', function (e) {
                    scope.mapMethods.displayPosition(newPositionMarker.getPosition())
                });
                // autocomplete.addListener('place_changed', function () {
                //     // infowindow.close();
                //     // infowindowOldLocation.close();
                //     newPositionMarker.setVisible(false);
                //     var place = autocomplete.getPlace();
                //     if (!place.geometry) {
                //         window.alert("No Place found");
                //         return;
                //     }
                //     // If the place has a geometry, then present it on a map.
                //     if (place.geometry.viewport) {
                //         editMap.fitBounds(place.geometry.viewport);
                //         editMap.setCenter(place.geometry.location);
                //     } else {
                //         editMap.setCenter(place.geometry.location);
                //         editMap.setZoom(17);
                //     }
                //     newPositionMarker.setIcon(/** @type {google.maps.Icon} */({
                //         url: 'app/resources/images/edit-pin.png',
                //         size: new google.maps.Size(71, 71),
                //         origin: new google.maps.Point(0, 0),
                //         anchor: new google.maps.Point(17, 34),
                //         scaledSize: new google.maps.Size(35, 35)
                //     }));
                //     newPositionMarker.setPosition(place.geometry.location);
                //     newPositionMarker.setVisible(true);
                //     scope.mapMethods.displayPosition(newPositionMarker.getPosition());
                //     var address = '';
                //     if (place.address_components) {
                //         address = [
                //           (place.address_components[0] && place.address_components[0].short_name || ''),
                //           (place.address_components[1] && place.address_components[1].short_name || ''),
                //           (place.address_components[2] && place.address_components[2].short_name || '')
                //         ].join(' ');
                //     }
                //     // infowindowOldLocation.setContent('<div><strong>Old Location</strong><br>');
                //     // infowindowOldLocation.open(editMap, editMarker);
                //     // infowindow.setContent('<div><strong>New Location</strong><br>');
                //     // infowindow.open(editMap, newPositionMarker);
                // });
            },
            placeChanged : function (place) {
                newPositionMarker.setVisible(false);
                if (!place.geometry) {
                    window.alert("No Place found");
                    return;
                }
                // If the place has a geometry, then present it on a map.
                if (place.geometry.viewport) {
                    editMap.fitBounds(place.geometry.viewport);
                    editMap.setCenter(place.geometry.location);
                } else {
                    editMap.setCenter(place.geometry.location);
                    editMap.setZoom(17);
                }
                newPositionMarker.setIcon(/** @type {google.maps.Icon} */({
                    url: 'app/resources/images/edit-pin.png',
                    size: new google.maps.Size(71, 71),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(17, 34),
                    scaledSize: new google.maps.Size(35, 35)
                }));
                newPositionMarker.setPosition(place.geometry.location);
                newPositionMarker.setVisible(true);
                scope.mapMethods.displayPosition(newPositionMarker.getPosition());
                var address = '';
                if (place.address_components) {
                    address = [
                      (place.address_components[0] && place.address_components[0].short_name || ''),
                      (place.address_components[1] && place.address_components[1].short_name || ''),
                      (place.address_components[2] && place.address_components[2].short_name || '')
                    ].join(' ');
                }
            },
            updateLocation: function () {
                var data = {
                    "hospitals": {
                        "id": scope.hospProfile.hospDetails.id,
                        "hospitalId": UserService.getHospitalObj().hospId,
                        "hospitalLatitude": scope.latitude,
                        "hospitalLongitude": scope.longitude,
                        "modifiedBy": UserService.getUserObj().userId,
                        'isActive' : true
                    }
                }
                ProfileService.updateProviderProfileDataByKey('profile',data).then(function(response) {
                    $('#hospitalMap').modal('hide');
                    if(response){
                        scope.addressMethods.getHospitalAddress(response.hospitals);
                        scope.hospProfile.hospDetails.hospitalLatitude = response.hospitals.hospitalLatitude;
                        scope.hospProfile.hospDetails.hospitalLongitude = response.hospitals.hospitalLongitude;
                        scope.mapMethods.plotMapOnLoad();
                    }
                })
            }
        };
    })();
    
    scope.addNew = {
        contactNumber: ''
    }

    scope.choices = [{ id: 'choice1' }, { id: 'choice2' }];
    scope.appendConditional = function (s, n) {
        var re = new RegExp('(^|\\b)' + ' ' + n + ' ' + '(\\b|$)');
        return s + (re.test(s) ? '' : ('' + s ? ',' : '') + ' ' + n);
    };
    scope.addNewChoiceContact = function (value) {
        if (value) {
            scope.addEditHospContact.hospitalLandLine;
            scope.addEditHospContact.hospitalLandLine = scope.appendConditional(scope.addEditHospContact.hospitalLandLine, value);
            scope.addNew.contactNumber = '';
            scope.edithospitalLandLineValue = true;
        } else {
            alert('Please enter valid number.')
            scope.addNew.contactNumber = '';
        }
    };
    scope.removeChoice = function () {
        var lastItem = scope.choices.length - 1;
        scope.choices.splice(lastItem);
    };
    scope.removeChoice();
    scope.addressMethods = (function () {
        return {
            getHospitalAddress: function (obj) {
                var workingHour = null;
                if (obj.hospitalWorkerHours && obj.hospitalWorkerHours.length > 0) {
                    
                    workingHour = obj.hospitalWorkerHours.split('-');
                }
                if (obj && obj.hospAccreditations && obj.hospAccreditations.length > 0) {
                    obj.hospAccreditations.forEach(function(item) {
                        item.startDate = new Date(item.startDate);
                        item.endDate = new Date(item.endDate);
                    });
                }
                scope.hospitalName = obj.hospitalName;
                scope.hospitalAddress = obj.hospitalAddress;
                scope.hospitalLandmark = obj.hospitalLandmark;
                scope.hospitalCity = obj.hospCity;
                scope.hospitalDistrict = obj.hospDistrict;
                scope.hospitalState = obj.hospState;
                scope.hospitalPin = parseInt(obj.hospitalPinCode);
                scope.hospitalEmail = obj.hospitalEmailAddress;
                scope.hospitalSTDCode = obj.hospitalContactSTDCode;
                scope.hospitalLandLine = obj.hospitalLandlineNumber;
                scope.hospitalFaxNumber = parseInt(obj.hospitalFaxNumber);
                scope.hospitalMobile = parseInt(obj.hospitalMobileNumber);
                scope.hospitalWebsite = obj.hospitalWebsite;
                scope.hospitalPrimaryContactName = obj.hospitalPrimaryContactName;
                scope.hospitalPrimaryContactEmail = obj.hospitalPrimaryContactEmail;
                scope.hospitalPrimaryContactNumber = obj.hospitalPrimaryContactNumber;
                scope.hospitalSecondaryContactName = obj.hospitalSecondaryContactName;
                scope.hospitalSecondaryContactEmail = obj.hospitalSecondaryContactEmail;
                scope.hospitalSecondaryContactNumber = obj.hospitalSecondaryContactNumber;
                scope.hospAccrediations = obj.hospAccreditations ? obj.hospAccreditations : [];
                hospitalProfileCtrl.isSundayOpen = obj.isSundayAvailable ? obj.isSundayAvailable : false;
                scope.profile.firstTime = workingHour && workingHour[0] ? workingHour[0] : null;
                scope.profile.secondTime = workingHour && workingHour[1] ? workingHour[1] : null;
                scope.abc.hospDesc = obj.hospitalDescription;
                scope.abc.hospDesc1 = obj.hospitalDescription;
                scope.hospLogo = obj.hospitalLogoLink ? obj.hospitalLogoLink : '';
                if (obj.hospAccreditations && obj.hospAccreditations.length > 0)
                    scope.hospDispAccrediations = obj.hospAccreditations.filter(function (obj) {
                        return obj.isAccrediationAvailable == true;
                    });
                scope.isVerified = obj.isVerified;
            },
            editHospitalContact: function () {
                scope.addEditHospContact = {
                    id: scope.hospProfile.hospDetails.id,
                    hospitalName: scope.hospitalName,
                    hospitalAddress: scope.hospitalAddress,
                    hospitalLandmark: scope.hospitalLandmark,
                    hospitalCity: scope.hospitalCity,
                    hospitalDistrict: scope.hospitalDistrict,
                    hospitalState: scope.hospitalState,
                    hospitalPin: parseInt(scope.hospitalPin),
                    hospitalEmail: scope.hospitalEmail,
                    hospitalSTDCode: parseInt(scope.hospitalSTDCode),
                    hospitalLandLine: scope.hospitalLandLine,
                    hospitalFaxNumber: parseInt(scope.hospitalFaxNumber),
                    hospitalMobile: parseInt(scope.hospitalMobile),
                    hospitalWebsite: scope.hospitalWebsite,
                    hospitalPrimaryContactName: scope.hospitalPrimaryContactName,
                    hospitalPrimaryContactNumber: scope.hospitalPrimaryContactNumber,
                    hospitalPrimaryContactEmail: scope.hospitalPrimaryContactEmail,
                    hospitalSecondaryContactName: scope.hospitalSecondaryContactName,
                    hospitalSecondaryContactNumber: scope.hospitalSecondaryContactNumber,
                    hospitalSecondaryContactEmail: scope.hospitalSecondaryContactEmail,
                    hospRegtFee: scope.hospProfile && scope.hospProfile.hospDetails && scope.hospProfile.hospDetails.hospRegtFee ? scope.hospProfile.hospDetails.hospRegtFee : 0,
                    rohiniID: scope.hospProfile.hospDetails.rohiniID,
                    wavedoffDays: scope.hospProfile.hospDetails.wavedoffDays ?scope.hospProfile.hospDetails.wavedoffDays :{'id':0, 'Value':'0'}
                };
                //var val = scope.addEditHospContact.wavedoffDays;
                scope.addEditHospContact.wavedoffDays = { 'id': scope.addEditHospContact.wavedoffDays, 'Value': JSON.stringify(scope.addEditHospContact.wavedoffDays) };
                scope.editContact = true;
            },
            closeEditContact: function () {
                scope.editContact = false;
                scope.addressMethods.getHospitalAddress(scope.hospProfile.hospDetails);
            },
            updateHospitalDetails: function () {
                var workingHours = scope.profile.firstTime + '-' + scope.profile.secondTime;
                scope.hospAccrediations.forEach(function(item) {
                    if (!item.isAccrediationAvailable) {
                        item.certNumber = '';
                        item.startDate = '';
                        item.endDate = '';
                    }
                })
                var data = {
                    "hospitals": {
                        "id": scope.addEditHospContact.id,
                        "hospitalId": UserService.getHospitalObj().hospId,
                        "hospitalName": scope.addEditHospContact.hospitalName,
                        "hospitalAddress": scope.addEditHospContact.hospitalAddress,
                        "hospitalLandmark": scope.addEditHospContact.hospitalLandmark,
                        "hospitalPinCode": parseInt(scope.addEditHospContact.hospitalPin),
                        //"hospContactSTDCode": scope.addEditHospContact.hospitalSTDCode,
                        "hospitalLandlineNumber": scope.addEditHospContact.hospitalLandLine,
                        "hospitalFaxNumber": parseInt(scope.addEditHospContact.hospitalFaxNumber),
                        "hospitalMobileNumber": parseInt(scope.addEditHospContact.hospitalMobile),
                        "hospitalEmailAddress": scope.addEditHospContact.hospitalEmail,
                        "hospitalPrimaryContactName": scope.addEditHospContact.hospitalPrimaryContactName,
                        "hospitalPrimaryContactNumber": scope.addEditHospContact.hospitalPrimaryContactNumber,
                        "hospitalPrimaryContactEmail": scope.addEditHospContact.hospitalPrimaryContactEmail,
                        "hospitalSecondaryContactName": scope.addEditHospContact.hospitalSecondaryContactName,
                        "hospitalSecondaryContactNumber": scope.addEditHospContact.hospitalSecondaryContactNumber,
                        "hospitalSecondaryContactEmail": scope.addEditHospContact.hospitalSecondaryContactEmail,
                        "hospitalWebsite": scope.addEditHospContact.hospitalWebsite,
                        "wavedoffDays": scope.addEditHospContact.wavedoffDays.Value,
                        "rohiniID": scope.addEditHospContact.rohiniID,
                        "hospRegtFee": scope.addEditHospContact.hospRegtFee,
                        "hospAccreditations": scope.hospAccrediations,
                        "isSundayAvailable": hospitalProfileCtrl.isSundayOpen,
                        "hospitalWorkerHours": workingHours,
                        "modifiedBy": UserService.getUserObj().userId,
                        'isActive' : true
                    }
                }
                ProfileService.updateProviderProfileDataByKey('profile',data).then(function(response) {
                    $('#editHospital').modal('hide');
                    if(response){
                        scope.editContact = false;
                        scope.loadHospitalProfile();
                    }
                })
            },
            updateHospitalDescription: function (data) {
                var data = {
                    "hospitals": {
                        "id": scope.hospProfile.hospDetails.id,
                        "hospitalDescription": $('#aboutTypeText').val(),
                        "hospitalId": UserService.getHospitalObj().hospId,
                        "modifiedBy": UserService.getUserObj().userId,
                        'isActive' : true
                    }
                };
                ProfileService.updateProviderProfileDataByKey('profile',data).then(function(response) {
                    if(response){
                        scope.addressMethods.getHospitalAddress(response.hospitals);
                    }
                })
            }
        };
    })();
    scope.mgmtContact  =[];

    scope.addContactPerson = function(){
         scope.isDeleteValue = false;
        scope.addEditHospContact  ={};
        scope.isAdd = true;
    };

    scope.editContactPerson = function(value){
        scope.isDeleteValue = false;
        scope.isAdd = false;
        scope.addEditHospContact = JSON.parse(JSON.stringify(value));
        scope.addEditHospContact.contactType = value.hospitalContactDetailContactPersonDepartment.toLowerCase() ==='health check spoc' ?'healthcheckspoc' : value.hospitalContactDetailContactPersonDepartment.toLowerCase() === 'insurance cordinator' ? 'insurance' : value.hospitalContactDetailContactPersonDepartment.toLowerCase() === 'finance cordinator' ?'finance': value.hospitalContactDetailContactPersonDepartment.toLowerCase() === 'consultations spoc'?'consultationsspoc':value.hospitalContactDetailContactPersonDepartment.toLowerCase();
    };

    scope.deleteContactPerson = function(value){
        scope.isDeleteValue = true;
        scope.addEditHospContact = value;
        scope.addEditHospContact.contactType = value.hospitalContactDetailContactPersonDepartment.toLowerCase() ==='health check spoc' ?'healthcheckspoc' : value.hospitalContactDetailContactPersonDepartment.toLowerCase() === 'insurance cordinator' ? 'insurance' : value.hospitalContactDetailContactPersonDepartment.toLowerCase() === 'finance cordinator' ?'finance': value.hospitalContactDetailContactPersonDepartment.toLowerCase() === 'consultations spoc'?'consultationsspoc':value.hospitalContactDetailContactPersonDepartment.toLowerCase();
    };

    scope.loadHospitalContactDetails = function(){
         scope.isDeleteValue = false;
    };

    scope.addHospitalContact = function () {
        var data = {
            contactList: [{
                hospitalContactDetailID	:0,
                hospitalContactDetailHospitalID: UserService.getHospitalObj().hospId,
                hospitalContactDetailContactPersonName: scope.addEditHospContact.hospitalContactDetailContactPersonName,
                hospitalContactDetailContactPersonDesignation: scope.addEditHospContact.hospitalContactDetailContactPersonDesignation,
                hospitalContactDetailContactPersonMobileNo: scope.addEditHospContact.hospitalContactDetailContactPersonMobileNo,
                hospitalContactDetailContactPersonEmail: scope.addEditHospContact.hospitalContactDetailContactPersonEmail,
                hospitalContactDetailContactPersonDepartment: scope.addEditHospContact.contactType,
                isActive: true,
                hospitalContactDetailCreatedBy: UserService.getUserObj().userId,
                hospitalContactDetailModifiedBy: UserService.getUserObj().userId,
                isVerified: false,
                isDelete: false,
            }]
        };
        ProfileService.updateProviderProfileDataByKey('contact',data).then(function(response) {
            $('#hospitalContact').modal('hide');
            if(response){
                scope.hospProfile.hospContactDetails = response.hospitalsContactDetails;
                scope.loadHospitalContactDetails();
            }
        })
    };

    scope.updateHospitalContact = function (isDelete) {
        var data = {
            contactList: [{
                hospitalContactDetailID	: scope.addEditHospContact.hospitalContactDetailID,
                hospitalContactDetailHospitalID: UserService.getHospitalObj().hospId,
                hospitalContactDetailContactPersonName: scope.addEditHospContact.hospitalContactDetailContactPersonName,
                hospitalContactDetailContactPersonDesignation: scope.addEditHospContact.hospitalContactDetailContactPersonDesignation,
                hospitalContactDetailContactPersonMobileNo: scope.addEditHospContact.hospitalContactDetailContactPersonMobileNo,
                hospitalContactDetailContactPersonEmail: scope.addEditHospContact.hospitalContactDetailContactPersonEmail,
                hospitalContactDetailContactPersonDepartment: scope.addEditHospContact.contactType,
                isActive: true,
                hospitalContactDetailCreatedBy: UserService.getUserObj().userId,
                hospitalContactDetailModifiedBy: UserService.getUserObj().userId,
                isVerified: false,
                isDelete: isDelete ? true : false,
            }]
        };
        ProfileService.updateProviderProfileDataByKey('contact',data).then(function(response) {
            $('#hospitalContact').modal('hide');
            $('#deleteContact').modal('hide');
            if(response){
                scope.hospProfile.hospContactDetails = response.hospitalsContactDetails;
                scope.loadHospitalContactDetails();
            }
        })
    };
    
    scope.imagesMethods = (function () {
        return {
            loadHospitalImages: function () {
                scope.imgs = [];
                angular.forEach(scope.hospProfile.hospDetails.hospitalImages, function (e, i) {
                    var tempObj = {
                        // thumb: scope.dmslink + e.imageThumbNailLink,
                        thumb: e.downloadLink,
                        // img: scope.dmslink + e.documentLink,
                        img: e.downloadLink,
                        description: e.documentDescription,
                        isDelete: e.isDelete,
                        isVerified: e.isVerified
                    }
                    scope.imgs.push(tempObj);
                });
            },
            // addEditHospitalImages: function () {
            //     scope.addEditHospImages = [];
            //     scope.newlyUploadedImages = [];
            //     angular.forEach(scope.hospProfile.hospDetails.hospitalImages, function (e, i) {
            //         var tempObj = {
            //             imageThumbNailLink: e.imageThumbNailLink,
            //             imageDescription: e.imageDescription,
            //             imageId: e.imageId,
            //             hospId: e.hospId,
            //             isImageVerified: e.isImageVerified,
            //             isDelete: e.isDelete,
            //         }
            //         scope.addEditHospImages.push(tempObj);
            //     });
            // },
            uploadNewHospImages: function () {
                var fileBlobArray = [];
                var filesUploadingArray = [];
                Object.keys(scope.file).forEach(function (ele) {
                    if (typeof (scope.file[ele].model) == "object") {
                        filesUploadingArray.push(scope.file[ele].model);
                    }
                });
                if (filesUploadingArray.length > 0) {
                    fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrl() + '/Provider/Profile/DocumentUpload'));
                }
                else {
                    alert('Please attach atleast one document');
                    return false;
                }
                $q.all(fileBlobArray).then(function (result) {
                    result.forEach(function (element) {
                        if (element.data.isSuccess) {
                            scope.newlyUploadedImages = element.data.uploadedDetails;
                            if (!scope.imageTypes || scope.imageTypes.length <= 0) {
                                scope.imageTypes = [];
                                ProfileService.loadProviderMasterByKey({columnNames: ["Hospital_Picture_Type"]})
                                // UserService.loadMasterByKeyName("Hospital_Picture_Type")
                                .then(function (res) {
                                    // res.lookupData.map(function (el) {
                                    //     el.id = parseInt(el.id);
                                    // });
                                    scope.imageTypes = res.lookupData;
                                });
                            }
                        }
                        else {
                            alert('upload fail');
                            return false;
                        }
                    });
                },
                function (error) {
                    alert('upload fail');
                });
            },
            // submitImgDetails: function () {
            //     scope.EditedHospImg = [];
            //     angular.forEach(scope.addEditHospImages, function (e, i) {
            //         var tempObj = {
            //             hospId: UserService.getHospitalObj().hospId,
            //             imageId: e.imageId,
            //             imageDescription: e.imageDescription,
            //             modifiedBy: UserService.getUserObj().userId
            //         }
            //         scope.EditedHospImg.push(tempObj);
            //     });
            //     var data = {
            //         "hospImages": [scope.EditedHospImg]
            //     }
            //     UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/updateHospImages.json", data, "POST").then(function (response) {
            //         if (response.data.isSuccess) {


            //         }
            //     }, function (error) {
            //         // console.log("Error : " + error);
            //     });
            // },
            saveNewHospImages: function () {
                var updateImageArr = JSON.parse(JSON.stringify(scope.newlyUploadedImages));
                angular.forEach(updateImageArr, function (e, i) {
                    delete e.downloadLink;
                    e.documentLink = e.fileGuid;
                    e.hospitalId = UserService.getHospitalObj().hospId;
                    e.createdBy = UserService.getUserObj().userId;
                    e.modifiedBy = UserService.getUserObj().userId;
                    e.documentTypeID = e.imageDescription.masterLookUpID;
                    e.documentDescription = e.imageDescription.masterLookUpColumnValue;
                    e.documentStartDate = moment().format();
                    e.documentEndDate = moment({date:20, year:2020, month:06}).format();
                });
                var data = {
                    "documentsList": updateImageArr
                }
                UserService.makeRestCall(UtilitiesService.getPlusUrl() + '/Provider/Profile/AddUpdateHospitalDocuments', data, "POST" , UserService.getAccessToken()).then(function (response) {
                    if (response.data.isSuccess) {
                        alert('Images Saved Successfully');
                        scope.imagesMethods.clearFileModels();
                        $('#hospitalImages').modal('hide');
                        scope.hospProfile.hospDetails.hospitalImages = response.data.hospitalsDocumentDetails;
                        scope.imagesMethods.loadHospitalImages();
                    }
                }, function (error) {
                    // console.log("Error : " + error);
                });
            },
            // removeHospImage: function (index) {
            //     if (scope.hospProfile.hospDetails.hospitalImages[index]) {
            //         var arr = [];
            //         arr.push(scope.hospProfile.hospDetails.hospitalImages[index]);
            //         arr[0].isDelete = true;
            //         arr[0].isActive = true;
            //         arr[0].modifiedBy = UserService.getUserObj().userId;
            //         var data = {
            //             hospImages: arr
            //         }
            //         UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/updateHospImages.json", data, "POST").then(function (response) {
            //             if (response.data.isSuccess) {
            //                 alert('Removed image successfully');
            //                 scope.hospProfile.hospDetails.hospitalImages = response.data.hospImages;
            //                 scope.imagesMethods.loadHospitalImages();
            //             }
            //         }, function (error) {
            //             // console.log("Error : " + error);
            //         })
            //     }
            //     else {
            //         alert('Cannot remove image, please try after some time...');
            //     }
            // },
            clearFileModels: function () {
                scope.newlyUploadedImages = [];
                scope.file = [];
                scope.fileUploadMethods.addFileToUpload();
            },
            uploadHospLogo: function () {
                var fileBlobArray = [];
                var filesUploadingArray = [];
                Object.keys(scope.file).forEach(function (ele) {
                    if (typeof (scope.file[ele].model) == "object") {
                        filesUploadingArray.push(scope.file[ele].model);
                    }
                });
                if (filesUploadingArray.length > 0) {
                    fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrl() + '/Provider/Profile/DocumentUpload'));
                }
                else {
                    alert('Please attach atleast one document');
                    return false;
                }
                $q.all(fileBlobArray).then(function (result) {
                    result.forEach(function (element) {
                        if (element.data.isSuccess) {
                            scope.newlyUploadedImages = element.data.uploadedDetails;
                            scope.hospLogo = element.data.uploadedDetails[0].downloadLink;
                            scope.hospLogoGuid = element.data.uploadedDetails[0].fileGuid;
                        }
                        else {
                            alert('upload fail');
                            return false;
                        }
                    });
                },
                function (error) {
                    alert('upload fail');
                });
            },
            updateHospLogo: function () {
                var data = {
                    "hospitals":{
                        "id": scope.hospProfile.hospDetails.id,
                        "hospitalLogo": scope.hospLogoGuid,
                        "hospitalId": UserService.getHospitalObj().hospId,
                        "modifiedBy": UserService.getUserObj().userId,
                        'isActive' : true
                    }
                };
                ProfileService.updateProviderProfileDataByKey('profile',data).then(function(response) {
                    $('#hospitalLogo').modal('hide');
                    if(response){
                        scope.addressMethods.getHospitalAddress(response.hospitals);
                    }
                })
            }
        };
    })();
    scope.facilitiesMethods = (function () {
        return {
            loadFacilities: function () {
                scope.facilitiesMethods.emptyHospFacilities();
                angular.forEach(scope.hospProfile.hospDetails.hospFacilities, function (e, i) {
                    var tempObj = {
                        facilityID: e.facilityID,
                        facilityName: e.facilityName,
                        isFacilityAvailable: e.isFacilityAvailable
                    }
                    scope.facilities.push(tempObj);
                });
                angular.forEach(scope.hospProfile.hospDetails.otherFacilities, function (e, i) {
                    scope.otherFacilities.push(e);
                });
                scope.AllFacCount = 0;
                angular.forEach(scope.facilities, function (fac) {
                    scope.AllFacCount += fac.isFacilityAvailable ? 1 : 0;
                });
                scope.AllFacCount += scope.otherFacilities.length;
            },
            openModalHospFacity: function () {
                scope.listOfMedicalFacilities = [];
                // UserService.loadMasterByKeyName("Hospital_Facilities_Medical")
                ProfileService.loadProviderMasterByKey({columnNames: ["Hospital_Facilities_Medical"]})
                .then(function (res) {
                    angular.forEach(res.lookupData, function (e, i) {
                        var t = scope.facilities.filter(function (el) {
                            return el.facilityID == e.masterLookUpID;
                        });
                        var tempObj = {
                            facilityID: e.masterLookUpID,
                            facilityName: e.masterLookUpColumnValue,
                            isFacilityAvailable: t && t.length > 0 ? true : false
                        }
                        scope.listOfMedicalFacilities.push(tempObj);
                    });
                });
                scope.listOfGeneralFacilities = [];
                // UserService.loadMasterByKeyName("Hospital_Facilities_General")
                ProfileService.loadProviderMasterByKey({columnNames: ["Hospital_Facilities_General"]})
                .then(function (res) {
                    angular.forEach(res.lookupData, function (e, i) {
                        var t = scope.facilities.filter(function (el) {
                            return el.facilityID == e.masterLookUpID;
                        });
                        var tempObj = {
                            facilityID: e.masterLookUpID,
                            facilityName: e.masterLookUpColumnValue,
                            isFacilityAvailable: t && t.length > 0 ? true : false
                        }
                        scope.listOfGeneralFacilities.push(tempObj);
                    });
                });
                scope.listOfOtherFacilities = [];
                scope.displayOtherFacilitiesModal = [];
                angular.forEach(scope.hospProfile.hospDetails.otherFacilities, function (e, i) {
                    scope.listOfOtherFacilities.push(e);
                });
                angular.forEach(scope.listOfOtherFacilities, function (e, i) {
                    var tempObj = {
                        facilityID: i + 1,
                        facilityName: e,
                        isFacilityAvailable: true
                    }
                    scope.displayOtherFacilitiesModal.push(tempObj);
                });
            },
            addNewChoice: function () {
                scope.listOfOtherFacilitiesText.push("");
            },
            removeChoice: function (index) {
                if (scope.listOfOtherFacilitiesText[index] != undefined && scope.listOfOtherFacilitiesText[index] != null) {
                    scope.listOfOtherFacilitiesText.splice(index, 1);
                };
            },
            emptyHospFacilities: function () {
                scope.listOfMedicalFacilities = [];
                scope.listOfGeneralFacilities = [];
                scope.listOfOtherFacilities = [];
                scope.displayOtherFacilitiesModal = [];
                scope.listOfOtherFacilitiesText = [];
                scope.facilities = [];
                scope.otherFacilities = [];
            },
            updateHospitalFacility: function (isDelete, isFromDisplay) {
                var otherFac = [];
                if (isFromDisplay) {
                    otherFac = scope.otherFacilities;
                } else {
                    if(isDelete && scope.listOfOtherFacilities) {
                        otherFac = scope.listOfOtherFacilities;
                    }
                    else if (scope.listOfOtherFacilitiesText && scope.listOfOtherFacilitiesText.length > 0) {
                        otherFac = scope.listOfOtherFacilitiesText;
                    }
                    angular.forEach(scope.displayOtherFacilitiesModal, function (e, i) {
                        if (e.isFacilityAvailable) { otherFac.push(e.facilityName) };
                    });
                }
                var hospFac = [];
                if (isDelete) {
                    hospFac = scope.facilities
                } else {
                    hospFac = scope.listOfMedicalFacilities.concat(scope.listOfGeneralFacilities);
                }
                var data = {
                    "hospitals": {
                        "id": scope.hospProfile.hospDetails.id,
                        "hospitalId": UserService.getHospitalObj().hospId,
                        "hospFacilities": hospFac,
                        "otherFacilities": otherFac,
                        "modifiedBy": UserService.getUserObj().userId,
                        'isActive' : true
                    }
                }
                ProfileService.updateProviderProfileDataByKey('profile',data).then(function(response) {
                    $('#openHospFacilities').modal('hide');
                    if(response){
                        scope.facilitiesMethods.emptyHospFacilities();
                        scope.hospProfile.hospDetails.hospFacilities = response.hospitals ? response.hospitals.hospFacilities : null;
                        scope.hospProfile.hospDetails.otherFacilities = response.hospitals ? response.hospitals.otherFacilities : null;
                        scope.facilitiesMethods.loadFacilities();
                    }
                })
            },
            removeFacFromDisplay: function (index) {
                if (scope.facilities[index] != undefined && scope.facilities[index] != null) {
                    scope.facilities[index].isFacilityAvailable = false;
                    scope.listOfOtherFacilities = scope.otherFacilities;
                    scope.facilitiesMethods.updateHospitalFacility(true);
                };
            },
            removeOtherFacFromDisplay: function (index) {
                if (scope.otherFacilities[index] != undefined && scope.otherFacilities[index] != null) {
                    scope.otherFacilities.splice(index, 1);
                    scope.facilitiesMethods.updateHospitalFacility(true, true);
                };
            }
        };
    })();
    scope.fileUploadMethods = (function () {
        return {
            addFileToUpload: function (flag) {
                var newItemNo = scope.file.length + 1;
                scope.file.push({
                    'model': ''
                });
            },
            removeFileToUpload: function (index) {
                scope.file.splice(index, 1);
            }
        };
    })();
    $(function () {
        input = /** @type {!HTMLInputElement} */(document.getElementById('pac-input'));
        // types = document.getElementById('type-selector');
        // function setupClickListener(id, types) {
        //     radioButton = document.getElementById(id);
        //     radioButton.addEventListener('click', function () {
        //         autocomplete.setTypes(types);
        //     });
        // }
        // setupClickListener('changetype-all', []);
        // setupClickListener('changetype-address', ['address']);
        // setupClickListener('changetype-establishment', ['establishment']);
        // setupClickListener('changetype-geocode', ['geocode']);
        scope.loadHospitalProfile();
        scope.fileUploadMethods.addFileToUpload();
        scope.profileMethods.scrollTo('hospHeader');
        $('.content-wrap .scrolable').scroll(function () {
            if ($(this).scrollTop() > 100) {
                $('#scroll').fadeIn();
            } else {
                $('#scroll').fadeOut();
            }
        });
        $('#scroll').click(function () {
            $("html, body").animate({ scrollTop: 0 }, 600);
            return false;
        });
    });
}]);
angular.module('mbplus')
.controller('guidelinesCtrl', ['$scope', '$location', 'UserService', '$analytics', function ($scope, $location, UserService, $analytics) {
  $analytics.pageTrack('/guidelines');
  if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }
  $scope.showPanel = function (item) {
    if (item == 1) {
      if (angular.element('#collapseOne').hasClass('show')) {
        angular.element('#collapseOne').addClass('hide').removeClass('show');
      } else {
        angular.element('#collapseOne').addClass('show').removeClass('hide');
        angular.element('#collapseTwo').addClass('hide').removeClass('show');
        angular.element('#collapseThree').addClass('hide').removeClass('show');
        angular.element('#collapseFour').addClass('hide').removeClass('show');
        angular.element('#collapseFive').addClass('hide').removeClass('show');
        angular.element('#collapseSix').addClass('hide').removeClass('show');
        angular.element('#collapseSeven').addClass('hide').removeClass('show');
        angular.element('#collapseEight').addClass('hide').removeClass('show');
        angular.element('#collapseNine').addClass('hide').removeClass('show');
      }
    } else if (item == 2) {
      if (angular.element('#collapseTwo').hasClass('show')) {
        angular.element('#collapseTwo').addClass('hide').removeClass('show');
      } else {
        angular.element('#collapseOne').addClass('hide').removeClass('show');
        angular.element('#collapseTwo').addClass('show').removeClass('hide');
        angular.element('#collapseThree').addClass('hide').removeClass('show');
        angular.element('#collapseFour').addClass('hide').removeClass('show');
        angular.element('#collapseFive').addClass('hide').removeClass('show');
        angular.element('#collapseSix').addClass('hide').removeClass('show');
        angular.element('#collapseSeven').addClass('hide').removeClass('show');
        angular.element('#collapseEight').addClass('hide').removeClass('show');
        angular.element('#collapseNine').addClass('hide').removeClass('show');
      }
    } else if (item == 3) {
      if (angular.element('#collapseThree').hasClass('show')) {
        angular.element('#collapseThree').addClass('hide').removeClass('show');
      } else {
        angular.element('#collapseOne').addClass('hide').removeClass('show');
        angular.element('#collapseTwo').addClass('hide').removeClass('show');
        angular.element('#collapseThree').addClass('show').removeClass('hide');
        angular.element('#collapseFour').addClass('hide').removeClass('show');
        angular.element('#collapseFive').addClass('hide').removeClass('show');
        angular.element('#collapseSix').addClass('hide').removeClass('show');
        angular.element('#collapseSeven').addClass('hide').removeClass('show');
        angular.element('#collapseEight').addClass('hide').removeClass('show');
        angular.element('#collapseNine').addClass('hide').removeClass('show');
      }
    } else if (item == 4) {
      if (angular.element('#collapseFour').hasClass('show')) {
        angular.element('#collapseFour').addClass('hide').removeClass('show');
      } else {
        angular.element('#collapseOne').addClass('hide').removeClass('show');
        angular.element('#collapseTwo').addClass('hide').removeClass('show');
        angular.element('#collapseThree').addClass('hide').removeClass('show');
        angular.element('#collapseFour').addClass('show').removeClass('hide');
        angular.element('#collapseFive').addClass('hide').removeClass('show');
        angular.element('#collapseSix').addClass('hide').removeClass('show');
        angular.element('#collapseSeven').addClass('hide').removeClass('show');
        angular.element('#collapseEight').addClass('hide').removeClass('show');
        angular.element('#collapseNine').addClass('hide').removeClass('show');
      }
    } else if (item == 5) {
      if (angular.element('#collapseFive').hasClass('show')) {
        angular.element('#collapseFive').addClass('hide').removeClass('show');
      } else {
        angular.element('#collapseOne').addClass('hide').removeClass('show');
        angular.element('#collapseTwo').addClass('hide').removeClass('show');
        angular.element('#collapseThree').addClass('hide').removeClass('show');
        angular.element('#collapseFour').addClass('hide').removeClass('show');
        angular.element('#collapseFive').addClass('show').removeClass('hide');
        angular.element('#collapseSix').addClass('hide').removeClass('show');
        angular.element('#collapseSeven').addClass('hide').removeClass('show');
        angular.element('#collapseEight').addClass('hide').removeClass('show');
        angular.element('#collapseNine').addClass('hide').removeClass('show');
      }
    } else if (item == 6) {
      if (angular.element('#collapseSix').hasClass('show')) {
        angular.element('#collapseSix').addClass('hide').removeClass('show');
      } else {
        angular.element('#collapseOne').addClass('hide').removeClass('show');
        angular.element('#collapseTwo').addClass('hide').removeClass('show');
        angular.element('#collapseThree').addClass('hide').removeClass('show');
        angular.element('#collapseFour').addClass('hide').removeClass('show');
        angular.element('#collapseFive').addClass('hide').removeClass('show');
        angular.element('#collapseSix').addClass('show').removeClass('hide');
        angular.element('#collapseSeven').addClass('hide').removeClass('show');
        angular.element('#collapseEight').addClass('hide').removeClass('show');
        angular.element('#collapseNine').addClass('hide').removeClass('show');
      }
    }
    else if (item == 7) {
      if (angular.element('#collapseSeven').hasClass('show')) {
        angular.element('#collapseSeven').addClass('hide').removeClass('show');
      } else {
        angular.element('#collapseOne').addClass('hide').removeClass('show');
        angular.element('#collapseTwo').addClass('hide').removeClass('show');
        angular.element('#collapseThree').addClass('hide').removeClass('show');
        angular.element('#collapseFour').addClass('hide').removeClass('show');
        angular.element('#collapseFive').addClass('hide').removeClass('show');
        angular.element('#collapseSix').addClass('hide').removeClass('show');
        angular.element('#collapseSeven').addClass('show').removeClass('hide');
        angular.element('#collapseEight').addClass('hide').removeClass('show');
        angular.element('#collapseNine').addClass('hide').removeClass('show');
      }
    }
    else if (item == 8) {
      if (angular.element('#collapseEight').hasClass('show')) {
        angular.element('#collapseEight').addClass('hide').removeClass('show');
      } else {
        angular.element('#collapseOne').addClass('hide').removeClass('show');
        angular.element('#collapseTwo').addClass('hide').removeClass('show');
        angular.element('#collapseThree').addClass('hide').removeClass('show');
        angular.element('#collapseFour').addClass('hide').removeClass('show');
        angular.element('#collapseFive').addClass('hide').removeClass('show');
        angular.element('#collapseSix').addClass('hide').removeClass('show');
        angular.element('#collapseSeven').addClass('hide').removeClass('show');
        angular.element('#collapseEight').addClass('show').removeClass('hide');
        angular.element('#collapseNine').addClass('hide').removeClass('show');
      }
    }
    else if (item == 9) {
      if (angular.element('#collapseNine').hasClass('show')) {
        angular.element('#collapseNine').addClass('hide').removeClass('show');
      } else {
        angular.element('#collapseOne').addClass('hide').removeClass('show');
        angular.element('#collapseTwo').addClass('hide').removeClass('show');
        angular.element('#collapseThree').addClass('hide').removeClass('show');
        angular.element('#collapseFour').addClass('hide').removeClass('show');
        angular.element('#collapseFive').addClass('hide').removeClass('show');
        angular.element('#collapseSix').addClass('hide').removeClass('show');
        angular.element('#collapseSeven').addClass('hide').removeClass('show');
        angular.element('#collapseEight').addClass('hide').removeClass('show');
        angular.element('#collapseNine').addClass('show').removeClass('hide');
      }
    }
  };

  $scope.show = false;
  $scope.togg = function () {
    $scope.show = !$scope.show;
  }
}]);
angular.module("mbplus")
.controller('hospPackageController', ['$scope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics', 'PlusUtilitiesService', 'sharedDataService', '$stateParams', '$state', 'orderByFilter','navConstantsSvc', function (scope, $location, UserService, UtilitiesService, filterFilter, $analytics, PlusUtilitiesService, sharedDataService, $stateParams, $state, orderByFilter,navConstantsSvc) {
    $analytics.pageTrack('/package');
    if (!UserService.isActive()) {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    scope.hospitalPackages = [];
    scope.getHospitalPackages = function (hospId) {
        var data = { 
            hospitalId: hospId,
            insurerShortName: 'All',
            perP_PER_ID: 0
        }
      scope.isCall = true;
	    UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/packagestoedit', data, 'POST').then(function (response) {
        scope.isCall = false;
	      if (response.data.isSuccess) {
	        scope.hospitalPackages = response.data.mappedpackages;
	      }
	    }, function (error) {
	    //   console.log("Error : " + error);
	    });
    };

    scope.ctrlFn = function(packageData){
        if(packageData){
            var data ={
                insurer: packageData.packageType,
                package_Name: packageData.package_Name,
                packageId: packageData.packageId,
                perP_PER_ID: packageData.perP_PER_ID,
                general_Ward: packageData.general_Ward,
                private_Ward: packageData.private_Ward,
                semi_Private_Ward: packageData.semi_Private_Ward,
                deluxe_Other: packageData.deluxe_Other,
                remarks: packageData.remarks,
                hospId: UserService.getHospitalObj().cmsHospId,
                createdBy: UserService.getUserObj().userId,
                package_Expiry_date: packageData.package_Expiry_date,
                package_Start_date: packageData.package_Start_date,
                uploadedFiles: packageData.filePath
            }
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/package/edit', data, 'POST').then(function (response) {
                angular.element('#updateHospPackageModal').modal('hide');
              if (response.data.isSuccess) {
                  scope.getHospitalPackages(UserService.getHospitalObj().cmsHospId);
                  UtilitiesService.showAlertMessage('Your request for package updattion has been captured Successfully.', true);
              }else{
                  UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to process your request.');
              }
            }, function (error) {
              UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to process your request.');
            });
        }
    };

    scope.getCMSHospitalPackages = function(hospId){
         var data = { 
            hospId: parseInt(hospId) ? parseInt(hospId) : 0
        }
	    UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/package/verify', data, 'POST').then(function (response) {
	      if (response.data.isSuccess) {
	        scope.hospitalPackages = response.data.packagestobeVerify;
	      }else{
              UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to process your request.');
          }
	    }, function (error) {
            UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to process your request.');
	    });
       
    };
    
    scope.ctrlFn2= function(value, flag){
         var data = {
             perP_PER_ID: value.perP_PER_ID,
             user_Id: UserService.getUserObj().userId,
             isApproved: flag
            }
	    UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/package/approvechanges', data, 'POST').then(function (response) {
	      if (response.data.isSuccess) {
              UtilitiesService.showAlertMessage('Action updated Successfully.', true);

	          scope.getCMSHospitalPackages(UserService.getHospitalObj().cmsHospId);
	      }else{
              UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to process your request.');
          }
	    }, function (error) {
              UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to process your request.');
	    });
    };

    if(UserService.getUserObj()){
        var role = _.filter(UserService.getUserObj().rolesFeatures.roles, function(val){return val.roleId === 9216});
        if(role.length === 0 && UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId && UserService.getHospitalObj().hospId !== 1000042){
            scope.getHospitalPackages(UserService.getHospitalObj().cmsHospId);
        }else if(role.length > 0){
            scope.getCMSHospitalPackages(UserService.getHospitalObj().cmsHospId);
        }
    }
}]);
angular.module('mbplus')
.controller('hospSelectCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', function (scope, location, UserService, UtilitiesService) {
    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() === 'insurer') {
        UserService.destroyUserObj();
        location.path('/');
        return false;
    }
    scope.formatCurrency = UtilitiesService.formatCurrency;
    //Fetch Hospitals List
    scope.getHospitalList = function () {
        scope.user = {};
        scope.hospitalName = '';
        scope.hospitalId = '';
        scope.hospitalList = UserService.getHospitalList();
        if (scope.hospitalList != undefined && scope.hospitalList != null && scope.hospitalList.length > 0) {
            return scope.hospitalList;
        } else {
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/list.json', '', 'GET').then(function (response) {
                if (response.data.isSuccess) {
                    scope.hospitalList = response.data.entities;
                    UserService.setHospitalList(scope.hospitalList);
                    return scope.hospitalList;
                }
            });
        }
    };
    scope.openNextWizardTab = function () {
        angular.element("#collapseOne").addClass('hide').removeClass('show');
        angular.element("#collapseTwo").addClass('show').removeClass('hide');
    };
    scope.captureUserInfo = function () {
        if (scope.user.firstname && scope.user.firstname != '') {
            scope.user.username = scope.user.firstname.replace(/ /g, '') + scope.hospitalId + '@medibuddy.in';
            angular.element("#collapseTwo").addClass('hide').removeClass('show');
            angular.element("#collapseThree").addClass('show').removeClass('hide');
        }
        else {
            alert('First name is not entered properly.');
        }
    };
    scope.addNewUser = function () {
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/user/createadmin.json', {
            'firstName': scope.user.firstname,
            'lastName': scope.user.lastname,
            'userEmail': scope.user.email,
            'userPhone': scope.user.telephone,
            'userName': scope.user.username,
            'hospPrimaryEmail': scope.user.hospemail,
            'insCoorName': scope.user.icname,
            'insCoorPhone': scope.user.icphone,
            'insCoorEmail': scope.user.icemailid,
            'finCoorName': scope.user.fcname,
            'finCoorPhone': scope.user.fcphone,
            'finCoorEmail': scope.user.fcemailid,
            'hospId': scope.hospitalId,
            'createdBy': UserService.getUserObj().userId
        }, 'POST').then(function (response) {
            if (response.data.isSuccess) {
                scope.user = {};
                scope.hospitalId = '';
                scope.hospitalName = '';
                angular.element("#addUserErrorMessage").hide();
                angular.element("#addUserErrorMessage").text("");
                angular.element("#collapseThree").addClass('hide').removeClass('show');
                angular.element("#collapseOne").addClass('show').removeClass('hide');
                UtilitiesService.showAlertMessage("User created successfully.",response.data.isSuccess);
            } else {
                UtilitiesService.showAlertMessage(response.data.errorMessage);
            }
        });
    };
    scope.getHospitalList();
}]);
angular.module('mbplus')
.controller('governmentClaimsCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics', function (scope, $location, UserService, UtilitiesService, filterFilter, $analytics) {
        $analytics.pageTrack('/government');
        if (!UserService.isActive()) {
            UserService.destroyUserObj();
            $location.path('/');
            return false;
        }
        scope.user = { role: '' };
        scope.user = UserService.getUserObj();
        if (scope.user) {
            scope.userRoles = scope.user.rolesFeatures.roles;
            if (scope.userRoles.length > 1) {
                angular.forEach(scope.userRoles, function (value, key) {
                    if (value.roleName === 'cms') {
                        scope.user.role = 'CMS';
                    }
                });
            } else {
                if (scope.user && scope.user.rolesFeatures.roles.length > 0) {
                    angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {

                        if (v.roleName === 'cms' || v.roleName === 'CMS') {
                            scope.user.role = 'CMS';
                        }
                    })
                }
            }
        }

        scope.getCmsUserCheck= function(){
            scope.isCmsUserCheck = false;
            if (scope.user && scope.user.rolesFeatures && scope.user.rolesFeatures.roles && scope.user.rolesFeatures.roles.length >0) {
                angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
                    if (v.roleId === 9216) {
                        scope.isCmsUserCheck = true;
                    }
                })
            }
            return scope.isCmsUserCheck;
        };
        scope.ctrlFn = function (nextpage) {
            scope.startIndex = nextpage;
            scope.getGovtClaimsList();
        };
        scope.clarSearch = function(){
            scope.searchObj ={
                urn: '',
                status: '',
                patientName: '',
                claimId : 0,
                hospitalName: '',
                schemeName:''
            }
        };
        scope.clarSearch();

        scope.callbackSecond = function(data, value, page){
            if(page){
                scope.searchObj.urn = page.urn;
                scope.searchObj.status = page.status;
                scope.searchObj.patientName = page.patientName;
                scope.searchObj.hospitalName = page.hospitalName;
                scope.searchObj.claimId = page.claimId === '' ? 0 : parseInt(page.claimId);
                scope.searchObj.schemeName = page.schemeName;
            }
            scope.startIndex =1;
            scope.getGovtClaimsList();
        };

        scope.startIndex = 1;
        scope.isSuccess = false;
        scope.isLoading = true;
        scope.govtClaims =[];

        scope.getGovtClaimsList = function (hospId) {
            if(hospId){
                scope.clarSearch();
            }
            var ajxData = {
                hospId: hospId ? hospId: UserService.getHospitalObj().hospId,
                roleName: scope.user.role,
                startIndexInclusive: scope.startIndex,
                urn: scope.searchObj.urn ? scope.searchObj.urn : '',
                status: scope.searchObj.status ? scope.searchObj.status : '',
                claimId: scope.searchObj.claimId ? scope.searchObj.claimId : 0,
                hospitalName : scope.searchObj.hospitalName ? scope.searchObj.hospitalName : '',
                patientName : scope.searchObj.patientName ? scope.searchObj.patientName : '',
                schemeName : scope.searchObj.schemeName ? scope.searchObj.schemeName : ''
            };
            scope.isLoading = true;
            scope.isSuccess = false;
            UtilitiesService.startLoading('fetching government claim data...', 'governmentClaims');
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/govtclaim/getclaims', ajxData, "POST").then(function (response) {
                UtilitiesService.stopLoading('governmentClaims');
                if (response.data.isSuccess) {
                    scope.isSuccess = true;
                    scope.govtClaims = UtilitiesService.renderClaimsList(response.data, 'govt');
                    if(scope.govtClaims.length ===0){
                        scope.isLoading = false;
                    }
                    scope.govtClaims.allRecordCount = response.data.allRecordCount;
                }
            });
        };
        //scope.getGovtClaimsList();
    }]);
angular.module('mbplus')
    .controller('fuserUpsellCtrl', ['$rootScope', '$scope', '$location', '$window', '$http', 'UserService', 'UtilitiesService', '$analytics', '$timeout', 'PlusUtilitiesService', '$sce', function ($rootScope, scope, $location, $window, $http, UserService, UtilitiesService, $analytics, $timeout, plusUtilitiesService, $sce) {
        scope.user = UserService.getUserObj();
        scope.fuserURL = $sce.trustAsResourceUrl("https://fuser-upsell.medibuddy.in/sso?access_token=" + scope.user.accessToken);
    }]);
angular.module('mbplus')
 .controller('faqsCtrl', ['$scope', '$location', 'UserService', '$analytics', function ($scope, $location, UserService, $analytics) {
   $analytics.pageTrack('/faqs');
   if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
     UserService.destroyUserObj();
     $location.path('/');
     return false;
   }
 }]);
angular.module('mbplus')
.controller('errorCtrl', ['$rootScope', '$scope', function ($rootScope, $scope) {
  if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }
}]);
angular.module('mbplus')
.controller('freshdeskController', ['$scope','$rootScope', 'UserService', 'UtilitiesService','$timeout','FileUploadService','$q','$http', function (scope,rootScope, UserService, UtilitiesService,$timeout,FileUploadService,$q,$http) {
    
    rootScope.showAll = false;
    scope.$root.title = 'Contact Us | Medibuddy Hospital Portal';
    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    $("#sidebar li").removeClass('active');
    $("#sidebar li#contact").addClass('active');

    scope.test = {};
    scope.message = '';
    scope.branchName = '';
    scope.subjectName = 'General query';
    scope.isActive = UserService.isActive();

    if(UserService.getUserObj()){
        scope.userInMailBox = UserService.getUserObj().userEmail;
    }

    scope.getUserRole = function () {
        if (UserService.getUserObj())
            return UserService.getUserObj().role.toLowerCase();
    };

    if (scope.isActive) {
        scope.user = UserService.getUserObj();
        scope.hospitalDetails = UserService.getHospitalObj();
        scope.address = '';
        scope.hasAddress = false;
        if (scope.hospitalDetails) {
            scope.fromEmail = scope.hospitalDetails.emailAddress;
            scope.hospId = scope.hospitalDetails.hospId;
            var url = UtilitiesService.getUrlPrefix() + '/hosp/relatedentity.json?relationType=TPA&primary=' + UserService.getHospitalObj().hospId;
            $http.get(url).
            success(function (data) {
                if (data.isSuccess) {
                    scope.address = data.relatedEntities[0];
                    scope.hasAddress = true;
                    scope.branchName = scope.address.entityShortName.split(' ')[1];
                }
                else {
                    scope.hasAddress = false;
                }
            });
        }

        scope.sendMessage = function () {
          if(UserService.getHospitalObj().hospId && scope.test && scope.test.subject){
            var data = {
              hospId: UserService.getHospitalObj().hospId,
              claimServicingBranch: scope.branchName,
              grievanceType: scope.test.subject,
              content: scope.message,
              hospEmailId: scope.fromEmail
            };
            UtilitiesService.startLoading('Sendind query...', 'freshDesksendMail');
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/grievance',data, 'POST').then(function (response) {
            UtilitiesService.stopLoading('freshDesksendMail');
              if (response.data.isSuccess) {
               scope.message ='';
               scope.test.subject ='';
               UtilitiesService.showAlertMessage('Request has been sent successfully.' , true);
              }
            });
          }
        };

        scope.clearAllCookies = function () {
          var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
          }
          $rootScope.$broadcast('signedin', false);
          $location.path('/');
        };
    }

    scope.compareDateNew = UtilitiesService.compareDateNew;
    scope.user = UserService.getUserObj();
    scope.compareDateNew = UtilitiesService.compareDateNew;
    scope.file = 'file';
    scope.tickets = [];
    scope.fileCollection =[];
    scope.isFileUploading = false;
    // scope.currentPage = 1;
    
    //Get Inbox
    scope.getInbox = function (pagenumber) {
        var data = {
            emailid: scope.userInMailBox,
            pagenumber: pagenumber
        }
        UtilitiesService.startLoading('fetching tickets data...', 'freshDesk');
        scope.isCall = true;
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tickets', data, 'POST').then(function (response) {
            scope.isCall = false;
            UtilitiesService.stopLoading('freshDesk');
            if (response.data.isSuccess) {
                scope.tickets = response.data;
                scope.currentPage = scope.tickets.currentPageNumber;
                scope.nextPageNumber = scope.tickets.nextPageNumber;
            }
        });
    };

    //Get Inbox Details
    scope.getInbox(1);

    scope.usersData = [];

    //Get all user details
    scope.getAllUsers = function (hospId) {
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/user/entityusers.json?hospId=' + hospId, '', 'GET').then(function (response) {
            if (response.data.isSuccess) {
                angular.forEach(response.data.users , function(v,i){
                    if(v.userEmail){
                        scope.usersData.push(v);
                    }
                })
            }
        });
    };

    if (scope.user && scope.user.isActive) {
        scope.getAllUsers(scope.user.entityId);
    }

    scope.userbasedOnTicket = function(item){
        if(item){
            scope.userInMailBox = item;
            scope.getInbox(1);
        }else{
            scope.userInMailBox = UserService.getUserObj().userEmail;
            scope.getInbox(1);
        }
    };

    //Return File Collection
    var getFiles = function(){
        var files =[];
        if(scope.fileCollection.length >0){
            angular.forEach(scope.fileCollection, function(key, value){
                var a = { fileName: key.fileName,docPath: key.downloadURL };
                files.push(a);
            })
        }
        return files;
    };

    //Reply Mail
    scope.reply =  function(value){
        if(value && scope.ticketData){
            var data = {
                ticketId: scope.ticketData.id,
                userEmailId: UserService.getUserObj().userEmail,
                replymessage: value,
                uploadedfiles: getFiles()
            }
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/reply/ticket', data, 'POST').then(function (response) {
                if (response.data.isSuccess) {
                    scope.replyMessageByUser = '';
                    scope.file = '';
                    scope.ticketDetails.id = 0;
                    angular.element('#mailReplyModal').modal('hide');
                    UtilitiesService.showAlertMessage('Message sent successfully.', true);
                }
            });
        }
    };
    scope.test.subject = '';
    scope.message = '';
    //Remove Files
    scope.removeFiles = function(item){
        scope.file = '';
        angular.forEach(scope.fileCollection , function(key, value){
            if(key.fileName === item.fileName){
                scope.fileCollection.splice(value, 1)
            }
        });
        scope.file = 'file';
    };

    //New mail request
    scope.newMailRequest = function(subject, msg){
        if(subject && msg){
            var data = {
                emailId: UserService.getUserObj().userEmail,
                description: msg,
                subject: subject,
                uploadedfiles: ''
            }
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/new/ticket', data, 'POST').then(function (response) {
                scope.test.subject = '';
                scope.message = '';
                angular.element('#NewMail').modal('hide');
                scope.replyMessageByUser = '';
                scope.subject = '';
                scope.fileCollection = [];
                if (response.data.isSuccess) {
                    scope.getInbox(1);
                    scope.file = '';
                    UtilitiesService.showAlertMessage('Ticket created successfully.', true);
                }else{
                    UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
                }
            });
        }
    };

    //Upload files
    scope.uploadImage = function(value){
        var filesUploadingArray = [], fileBlobArray = [];
        angular.forEach(value.files, function(key, value){
            filesUploadingArray.push(key);
        });
        scope.filesUploadingArray = filesUploadingArray;
        scope.isFileUploading = true;
        scope.fileCollection = [];
        (function calculateCss() {
            scope.dynamicCss = function (value) {
                scope.dynamicWidth = value + '%';
                if (scope.isFileUploading) {
                    $timeout(function () {
                        scope.dynamicCss(80);
                    }, 600);
                }
            };
        })();
        scope.file = '';
        scope.dynamicCss(40);
        fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
        $q.all(fileBlobArray).then(function (result) {
            result.forEach(function (element) {
                scope.isFileUploading = false;
                scope.dynamicCss(100);
                scope.filesUploadingArray = [];
                scope.file = 'file';
                if (element.data.isSuccess) {
                    scope.fileCollection = element.data.uploadResponseDetails;
                }
                else {
                    UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to upload files.');
                }
            });
        });
    };

    //Get mail Details
    scope.getMailDetails = function(value, index){
        var data = {
            userEmailId: UserService.getUserObj().userEmail,
            ticketId: value.id
        }
        scope.ticketDetails = {};
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/ticketdetail', data, 'POST').then(function (response) {
              if (response.data.isSuccess) {
                scope.ticketDetails = response.data.ticketDetails;
              }
        });
    };

    scope.mailReply = function(item){
        scope.ticketData = item;
        scope.replyMessageByUser ='';
        scope.file = 'file';
        scope.fileCollection = [];
        scope.filesUploadingArray = [];
        angular.element('#mailReplyModal').appendTo('body');
        angular.element('#mailReplyModal').modal('show');
    };

}]);
angular.module('mbplus')
  .controller('documentsReceivedCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', '$analytics', function (scope, $location, UserService, UtilitiesService, $analytics) {

    $analytics.pageTrack('/documentsReceived');
    // check for logged in
    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
      UserService.destroyUserObj();
      $location.path('/');
      return false;
    }
    scope.MaTPAId = UtilitiesService.getMaTpaId();
    scope.MaTpaName = UtilitiesService.getMaTpaName();

    scope.startIndex = 1;
    scope.searchTPA = '';
    scope.isSuccess = false;
    scope.isLoading = true;
    scope.configuredTpaList = [];
    scope.ctrlFn = function (nextpage) {
      scope.startIndex = nextpage;
      scope.getPDRClaimsList();
    };

    scope.hospitalDetails = UserService.getHospitalObj();

    scope.tpaName = {
      id: scope.MaTPAId,
      value: scope.MaTpaName
    };
    //Fetch PDR Claims List
    scope.getPDRClaimsList = function (tpaId) {
      if (UserService.getHospitalObj()) {
        var ajxData = {
          hospitalId: UserService.getHospitalObj().cmsHospId,
          startIndexInclusive: scope.startIndex,
          ProviderId: UserService.getHospitalObj().hospId,
          hospTPAId: tpaId ? tpaId.id : (scope.tpaName ? scope.tpaName.id : 0),
          schemeType: tpaId && tpaId.isGovtScheme ? tpaId.value : null
        };
        scope.isLoading = true;
        UtilitiesService.startLoading('fetching document received claim data...', 'documentReceivedClaims');
        scope.isSuccess = false;
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/search/inprogressclaims", ajxData, "POST").then(function (response) {
          UtilitiesService.stopLoading('documentReceivedClaims');
          if (response.data.isSuccess) {
            scope.isSuccess = true;
            scope.pdrClaims = UtilitiesService.renderClaimsList(response.data, "cashless");
            if (scope.pdrClaims.length === 0) {
              scope.isLoading = false;
            }
            scope.pdrClaims.allRecordCount = response.data.allRecordCount;
          }
        }, function (error) {});
      }
    };
    scope.getPDRClaimsList();

    var configuredTpaList = UtilitiesService.getConfiguredTpa();
    if ((configuredTpaList && configuredTpaList.length > 0) || (scope.hospitalDetails.configuredSchemes &&
        scope.hospitalDetails.configuredSchemes.length > 0)) {
      scope.configuredTpaList.push({
        id: scope.MaTPAId,
        value: scope.MaTpaName,
        isGovtScheme: false
      })
      angular.forEach(configuredTpaList, function (element) {
        scope.configuredTpaList.push({
          id: element.tpaId,
          value: element.tpaName,
          isGovtScheme: false
        })
      });
      angular.forEach(scope.hospitalDetails.configuredSchemes, function (element) {
        scope.configuredTpaList.push({
          id: scope.MaTPAId,
          value: element,
          isGovtScheme: true
        })
      })
    }
  }]);

angular.module('mbplus')
  .controller('documentsAwaitedCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', '$analytics', '$stateParams', function (scope, $location, UserService, UtilitiesService, $analytics, $stateParams) {
    $analytics.pageTrack('/documentsAwaited');
    scope.configuredTpaList = [];
    scope.hospitalDetails = UserService.getHospitalObj();
    if (UserService.getHospitalObj().configuredPayers) {
      angular.forEach(UserService.getHospitalObj().configuredPayers, function (e) {
        scope.configuredTpaList.push({
          hospTPAId: 0,
          isBenefSearchConfigured: e.isBenefSearchEnabled,
          isClaimCreationBlockedWithoutBenef: e.isClaimCreationBlockedWithoutBenef,
          value: e.name,
          id: e.id,
          configuredFields: e.configuredFields
        })
      })

    }
    var configuredTpaList = UtilitiesService.getConfiguredTpa();
    if ((configuredTpaList && configuredTpaList.length > 0) || (scope.hospitalDetails.configuredSchemes &&
      scope.hospitalDetails.configuredSchemes.length > 0)) {

      if (scope.user.userName == '1003736@medibuddy.in' && window.location.hostname === 'uat-plus.medibuddy.in') {
        tempObj = {
          id: 9999,
          value: "Select Payer Name",
          isGovtScheme: false
        }
        scope.configuredTpaList.push(tempObj);
        scope.tpaName = tempObj;
      } else {
        scope.configuredTpaList.push({
          id: scope.MaTPAId,
          value: scope.MaTpaName,
          isGovtScheme: false
        });

        angular.forEach(scope.hospitalDetails.configuredSchemes, function (element) {
          scope.configuredTpaList.push({
            id: scope.MaTPAId,
            value: element,
            isGovtScheme: true
          })
        })
      }
      angular.forEach(configuredTpaList, function (element) {
        scope.configuredTpaList.push({
          id: element.tpaId,
          value: element.tpaName,
          isGovtScheme: false
        })
      });

    }


    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
      UserService.destroyUserObj();
      $location.path('/');
      return false;
    }
    if (!scope.pendingFromNoOfDays) {
      scope.pendingFromNoOfDays = '0';
    }
    if (!scope.pendingDoc) {
      scope.pendingDoc = 'all';
    }

    if ($stateParams.noofdays == '30') {
      scope.pendingDoc = 'pending';
      scope.pendingFromNoOfDays = '30-0';
    }

    scope.pdaClaims = [];
    // UtilitiesService.startLoading('fetching documents pending claim data...','documentPending');
    scope.startIndex = 1;
    scope.ctrlFn = function (nextpage) {
      if (nextpage && nextpage.text === 'action') {
        //scope.pdaClaims = [];
        scope.startIndex = 1;
      } else {
        scope.startIndex = nextpage.value;
      }
      scope.getPDAClaimsList(nextpage.noofDaysForPendingDoc);
    };
    scope.isDataCheck = false;
    scope.searchTPA = '';
    scope.mailID = UserService.getHospitalObj().emailAddress;

    scope.emailchk = /^(([^<>()[\]\\.,;:\s@\']+(\.[^<>()[\]\\.,;:\s@\']+)*)|(\'.+\'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    scope.remindMe = function (falg, mailID) {
      if (UserService.getHospitalObj() && mailID && falg) {
        var ajxData = {
          hospitalId: UserService.getHospitalObj().cmsHospId,
          userId: UserService.getUserObj().userId,
          emailId: mailID,
          hospitalEmailId: UserService.getHospitalObj().emailAddress
        };
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/HospDocumentAwaitedReminder', ajxData, 'POST').then(function (response) {
          angular.element('#remindMe').modal('hide');
          UtilitiesService.showAlertMessage('We have received your request, the same data will be available in mail box.', true);

        });
      } else {
        angular.element('#remindMe').append('body');
        angular.element('#remindMe').modal('show');
      }
    };
    scope.isLoading = true;

    //Fetch PDA Claims List
    scope.getPDAClaimsList = function (data, tpaName) {
      if (UserService.getHospitalObj()) {
        var NoOfDays = data ? data.split('-') : (scope.pendingFromNoOfDays ? scope.pendingFromNoOfDays.split('-') : []);
        var ajxData = {
          hospitalId: UserService.getHospitalObj().cmsHospId,
          startIndexInclusive: scope.startIndex,
          toNoOfDays: NoOfDays && NoOfDays.length > 1 ? NoOfDays[1] : 0,
          fromNoOfDays: NoOfDays && NoOfDays.length > 1 ? NoOfDays[0] : 0,
          isAllUpdated: data === 'updated' ? true : false,
          IsAllPending: data === 'pending' || NoOfDays && NoOfDays.length > 1 ? true : false,
          providerId: UserService.getHospitalObj().hospId,
          hospTPAId: tpaName ? tpaName.id : 0,
          schemeName: tpaName && tpaName.isGovtScheme ? tpaName.value : null
          //   noOfDays: data ? data.pendingFromNoOfDays : (scope.pendingFromNoOfDays ? scope.pendingFromNoOfDays : 0)
        };
        scope.isDataCheck = false;
        scope.isLoading = true;
        UtilitiesService.startLoading('fetching documents pending claim data...', 'documentPending');
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/search/pdaclaims/', ajxData, 'POST').then(function (response) {
          UtilitiesService.stopLoading('documentPending');
          if (response.data.isSuccess) {
            scope.isDataCheck = true;
            scope.pdaClaims = UtilitiesService.renderClaimsList(response.data, 'cashless');
            scope.pdaClaims.sort(function (a, b) {
              return b.TATinClaim - a.TATinClaim
            });
            angular.forEach(scope.pdaClaims, function (e, i) {
              e.isFlagRed = scope.getDateDiff(e.dateOfDischarge);
            });
            if (scope.pdaClaims.length === 0) {
              scope.isLoading = false;
            }
            scope.pdaClaims.allRecordCount = response.data.allRecordCount;
            // scope.$apply();
          }
        });
      }
    };

    scope.getDateDiff = function (dateOfDischarge) {
      if (dateOfDischarge) {
        if (dateOfDischarge.split(' ').length == 2)
          dateOfDischarge = dateOfDischarge + ' 2016';
        var dt = new Date(dateOfDischarge);
        var dtNow = new Date();
        var timeDiff = Math.abs(dtNow.getTime() - dt.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if (diffDays > 10) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    };
    scope.getPDAClaimsList();
  }]);

angular.module('mbplus')
.controller('deniedCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', '$analytics', function (scope, $location, UserService, UtilitiesService, analytics) {

    analytics.pageTrack('/denied');
    scope.startIndex = 1;
    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == 'insurer') {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    scope.ctrlFn = function (nextpage) {
        scope.startIndex = nextpage;
        scope.getDeniedClaims();
    };
    
    scope.isSuccess = false;
    scope.getDeniedClaims = function () {
        var ajxData = {
            hospitalId: UserService.getHospitalObj().cmsHospId,
            startIndexInclusive: scope.startIndex
        };
        UtilitiesService.startLoading('fetching denied claim data...', 'deniedClaims');
        scope.isSuccess = false;
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/search/deniedclaimsV2', ajxData , 'POST').then(function (response) {
            UtilitiesService.stopLoading('deniedClaims');
            if (response.data.isSuccess) {
                scope.isSuccess = true;
                scope.deniedClaims = UtilitiesService.renderClaimsList(response.data, 'all');
                scope.deniedClaims.allRecordCount = response.data.allRecordCount;
            }
        });
    };
    scope.getDeniedClaims();
}]);
angular.module('mbplus')
  .controller('doctorsCtrl', ['$scope', '$location', 'UserService', 'ProfileService', 'UtilitiesService', '$analytics', 'FileUploadService', '$q', function (scope, $location, UserService, ProfileService, UtilitiesService, $analytics, FileUploadService, $q) {
    $analytics.pageTrack('/doctors');
    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
      UserService.destroyUserObj();
      $location.path('/');
      return false;
    }
    scope.doctorTypes = [];
    scope.departmentTypes = [];
    scope.awards = [];
    scope.file = [];
    scope.newlyUploadedImages = [];
    scope.number = 67;
    scope.dmslink = UtilitiesService.getDMSHostUrl();
    scope.showYearAdd = false;
    scope.editdoc = {};
    scope.InOutTime = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]; //, "13", "15", "16", "17", "18", "19", "20", "21", "22", "23"];
    scope.InOutTimeQuater = ["00", "15", "30", "45"];
    scope.daysOfWeek = JSON.parse(JSON.stringify(ProfileService.daysName));
    scope.timmingsOfWeek = [];
    scope.hstep = 1;
    scope.mstep = 15;
    scope.ismeridian = true;
    scope.mytime = new Date();
    scope.showSync = ProfileService.checkRole(9202);
    scope.daysOfWeek.map(function (day) {
      var temp = {
        dayName: day.name,
        timeSlots: []
      }
      scope.timmingsOfWeek.push(temp);
    });
    scope.registration = {};
    scope.isChangeView = false;
    scope.isRequired = false;
    scope.degreeSelection = null
    scope.changeView = function () {
      scope.isChangeView = !scope.isChangeView
    };

    scope.onSpecializationSelect = function ($item) {
      scope.departmentTypes.forEach(function (elem) {
        if (elem.departmentName == $item.departmentName) {
          elem.isDepartmentApplicable = true;
        } else {
          elem.isDepartmentApplicable = false;
        }
      })
      scope.department()
    }
    scope.department = function () {
      var dpTypes = [];
      scope.departmentTypes.map(function (e) {
        if (e.isDepartmentApplicable) {
          var temp = {
            departmentId: parseInt(e.departmentID),
            departmentName: e.departmentName
          }
          dpTypes.push(temp);
        }
      });
      scope.isRequired = dpTypes.length === 0 ? false : true;
    };

    scope.educationList = JSON.parse(JSON.stringify(ProfileService.educationList))
    scope.qualificationNameArray = [];
    scope.isDegreeSelected = false;
    scope.qualificationDropdownOpen = false;
    scope.categoryDropdownOpen = false;
    scope.selectedDegreeCategory = [];
    scope.qualificationSelected = function (edu, i) {
      scope.qualificationDropdownOpen = false
      scope.degreeSelection = edu;
      scope.isDegreeSelected = true;
      scope.selectedDegreeCategory = scope.educationList[i].category;
      scope.categoryDropdownOpen = true
    }
    scope.categorySelected = function (cat) {
      scope.categoryDropdownOpen = false
      scope.catSelection = cat;
      scope.qualificationNameArray.push(scope.degreeSelection + "-" + scope.catSelection)
      scope.editDoc.docQualification = scope.qualificationNameArray.join();
      scope.degreeSelection = null;
      scope.isDegreeSelected = false;
    }
    scope.qualificationUpdate = function (i) {
      scope.qualificationNameArray.splice(i, 1)
    }
    scope.saveQualification = function () {
      scope.editDoc.docQualification = scope.qualificationNameArray.join();
    }
    scope.closeQualificationModal = function () {
      scope.qualificationNameArray = scope.editDoc.docQualification ? scope.editDoc.docQualification.split(",") : [];
    }
    scope.editDoc = {
      gender: '',
      languages: []
    }
    scope.editDoc.gender = 'MALE';
    scope.setGender = function (value) {
      scope.editDoc.gender = value;
    };
    scope.editDoc.prefix = 'Dr';
    scope.addEditHospContact = {
      wavedoffDays: {
        'id': 0,
        'Value': '0'
      }
    };
    scope.addEditHospContactOuter = {
      wavedoffDays: {
        'id': 0,
        'Value': '0'
      }
    };
    scope.languages = JSON.parse(JSON.stringify(ProfileService.languages))
    scope.editDoc.languages = [];
    scope.wavedOffDays = [{
      'id': 0,
      'Value': '0'
    }, {
      'id': 1,
      'Value': '1'
    }, {
      'id': 2,
      'Value': '2'
    }, {
      'id': 3,
      'Value': '3'
    }, {
      'id': 4,
      'Value': '4'
    }, {
      'id': 5,
      'Value': '5'
    }, {
      'id': 6,
      'Value': '6'
    }, {
      'id': 7,
      'Value': '7'
    }, {
      'id': 8,
      'Value': '8'
    }, {
      'id': 9,
      'Value': '9'
    }, {
      'id': 10,
      'Value': '10'
    }];
    scope.wavedOffDaysOuter = [{
      'id': 0,
      'Value': '0'
    }, {
      'id': 1,
      'Value': '1'
    }, {
      'id': 2,
      'Value': '2'
    }, {
      'id': 3,
      'Value': '3'
    }, {
      'id': 4,
      'Value': '4'
    }, {
      'id': 5,
      'Value': '5'
    }, {
      'id': 6,
      'Value': '6'
    }, {
      'id': 7,
      'Value': '7'
    }, {
      'id': 8,
      'Value': '8'
    }, {
      'id': 9,
      'Value': '9'
    }, {
      'id': 10,
      'Value': '10'
    }];

    scope.profile = {
      hospRegtFee: 0
    }
    scope.loadHospitalProfile = function () {
      ProfileService.loadProviderProfileDataByKey('profile',{}).then(function (response) {
        if (response) {
          scope.hospProfile = response;
          scope.profile.hospRegtFee = scope.hospProfile.hospRegtFee;
          scope.addEditHospContact.wavedoffDays = {
            'id': parseInt(scope.hospProfile.wavedoffDays),
            'Value': scope.hospProfile.wavedoffDays
          }
        }
      });
    };
    scope.loadHospitalProfile();
    scope.currentPage = 1;
    scope.itemsPerPage = 10;
    scope.maxSize = 5;
    scope.pageChange = function (val) {
      scope.currentPage = val;
      scope.doctorsMethods.loadDoctors();
    }

    scope.updateHospitalProfileDetails = function () {
      var data = {
        "hospitals": {
          "id": scope.hospProfile.id,
          "hospitalId": UserService.getHospitalObj().hospId,
          "hospitalName": scope.hospProfile.hospitalName,
          "hospitalAddress": scope.hospProfile.hospitalAddress,
          "hospitalLandmark": scope.hospProfile.hospitalLandmark,
          "hospitalPinCode": parseInt(scope.hospProfile.hospitalPinCode),
          "hospitalLandlineNumber": scope.hospProfile.hospitalLandlineNumber,
          "hospitalFaxNumber": parseInt(scope.hospProfile.hospitalFaxNumber),
          "hospitalMobileNumber": parseInt(scope.hospProfile.hospitalMobileNumber),
          "hospitalEmailAddress": scope.hospProfile.hospitalEmailAddress,
          "hospitalPrimaryContactName": scope.hospProfile.hospitalPrimaryContactName,
          "hospitalPrimaryContactNumber": scope.hospProfile.hospitalPrimaryContactNumber,
          "hospitalPrimaryContactEmail": scope.hospProfile.hospitalPrimaryContactEmail,
          "hospitalSecondaryContactName": scope.hospProfile.hospitalSecondaryContactName,
          "hospitalSecondaryContactNumber": scope.hospProfile.hospitalSecondaryContactNumber,
          "hospitalSecondaryContactEmail": scope.hospProfile.hospitalSecondaryContactEmail,
          "hospitalWebsite": scope.hospProfile.hospitalWebsite,
          "wavedoffDays": scope.addEditHospContact.wavedoffDays.Value,
          "rohiniID": scope.hospProfile.rohiniID,
          "hospRegtFee": parseInt(scope.profile.hospRegtFee),
          "hospAccreditations": '',
          "modifiedBy": UserService.getUserObj().userId,
          "hospPackageAvailableDays": scope.hospProfile.hospPackageAvailableDays,
          'hospPackageAvailableMinTime': scope.hospProfile.hospPackageAvailableMinTime,
          'hospPackageAvailableMaxTime': scope.hospProfile.hospPackageAvailableMaxTime,
          'isActive' : true
        }
      }
      ProfileService.updateProviderProfileDataByKey('profile',data).then(function(response) {
        if(response){}
      })
    };

    scope.doctorsMethods = (function () {
      return {
        loadDoctors: function () {
          scope.doctors = [];
          ProfileService.loadProviderDoctorData({"pageNumber"	:	scope.currentPage ,"range"	:	10}).then(function (response) {
            if (response.hospitalsDoctorDetails) {
              angular.forEach(response.hospitalsDoctorDetails, function (e, i) {
                var tempObj = {
                  id: e.id,
                  docName: e.doctorName,
                  docDepartmentIds: e.departmentIDs,
                  docDepartments: e.departments,
                  docDep: e.departments && e.departments.length > 0 ? e.departments.map(function (a) {
                    return a.departmentName;
                  }).join(", ") : '',
                  docQualification: e.doctorQualification,
                  docPracticingSince: e.doctorPracticingSince,
                  docExper: scope.doctorsMethods.getDocExpr(e.doctorPracticingSince),
                  docRegNo: e.doctorRegNo,
                  discountedFees : e.doctorDiscountedFee ? e.doctorDiscountedFee : 0,
                  docTypeID: parseInt(e.doctorTypeID),
                  docType: e.doctorType,
                  docTimings: e.docTimings,
                  docDays: scope.doctorsMethods.getDocDays(e.docTimings),
                  isVerified: e.isVerified,
                  isDelete: e.isDelete,
                  // docImage: e.doctorImage || '',
                  // docThumbnailImage: e.doctorImageThumbnail,
                  docThumbnailImage: e.doctorImageThumbnail || '',
                  docFees: e.doctorFees,
                  docAwards: e.awards,
                  gender: e.gender,
                  languages: e.languages ? JSON.parse(e.languages) : [],
                  wavedoffDays: e.wavedoffDays,
                  isHod: e.isHod,
                  modifiedOn: new Date(UtilitiesService.getDateObj(e.modifiedOn)),
                  docImageToShow: e.doctorImageThumbnail ? e.downloadLink : 'app/resources/images/doc.png'
                }
                scope.doctors.push(tempObj);
                scope.totalItems = response.totalCount;

              })
            }
          })
        },
        isSyncValid: function (e) {
          var docDays = e.docDays.some(function (isValidDay) {
            return (isValidDay ? true : false)
          })
          if (docDays && e.docRegNo && e.docName && e.docExper && e.docDep && e.docFees && !e.isVerified) {
            return true
          } else return false
        },
        syncDocData: function (e) {
          var data = {
              "id": e.id ,
              "hospitalID": UserService.getHospitalObj().hospId,
              "hospitalName" : UserService.getHospitalObj().hospName,
              "doctorName": e.docName,
              "departmentIDs": e.docDepartmentIds,
              "departments" : e.docDepartments,
              "doctorQualification": e.docQualification,
              "doctorPracticingSince": e.docPracticingSince,
              "doctorRegNo": e.docRegNo,
              "doctorTypeID": e.docTypeID,
              "docTimings": e.docTimings,
              "doctorFees": e.docFees,
              "doctorDiscountedFee": e.discountedFees,
              "awards": e.docAwards,
              "languages": JSON.stringify(e.languages),
              "wavedoffDays": e.wavedoffDays.Value,
              "gender": e.gender,
              "isHod": e.isHod,
          };
          UserService.makeRestCall(UtilitiesService.getPlusUrl() + "/Provider/Profile/SyncDoctorData", data, "POST", UserService.getAccessToken()).then(function (response) {
            if (response.data.isSuccess) {
              e.isVerified = true;
              scope.doctorsMethods.showSyncPending();
            }
          })
        },
        showSyncPending: function () {
          var doc = JSON.parse(JSON.stringify(scope.doctors));
          scope.doctors = [];
          doc.forEach(function (el) {
            if (scope.doctorsMethods.isSyncValid(el)) {
              scope.doctors.push(el);
            }
          })
          scope.totalItems = scope.doctors.length;
          scope.currentPage = 1;
        },
        openDoctorDetails: function (e) {
          if (e) {
            scope.doctorTypes = [];
            scope.addDoc = false;
            scope.editDoctor = true;
            scope.editDocName = e.docName;
            scope.departmentTypes = scope.doctorsMethods.getDocDeps(e.doctorDepartments);
            ProfileService.loadProviderMasterByKey({columnNames: ["Doctor_Type"]})
              .then(function (res) {
                angular.forEach(res.lookupData, function (e, i) {
                  $('#docName').focus();
                  var tempObj = {
                    doctorTypeId: e.masterLookUpID,
                    doctorType: e.masterLookUpColumnValue
                  }
                  scope.doctorTypes.push(tempObj);
                });
                scope.editDoc = {
                  id: e.id,
                  docDepartmentIds: e.docDepartmentIds,
                  docName: e.docName,
                  docQualification: e.docQualification,
                  docRegNo: e.docRegNo,
                  docType: parseInt(e.docTypeID),
                  docExper: scope.doctorsMethods.getDocExpr(e.docPracticingSince),
                  practicingSinceMonth: scope.doctorsMethods.getPracticeMonths(e.docPracticingSince),
                  practicingSince: scope.doctorsMethods.getPracticeSince(e.docPracticingSince),
                  isVerified: e.isVerified,
                  isDelete: e.isDelete,
                  // docImage: e.docImage,
                  discountedFees : e.discountedFees,
                  // docThumbnailImage: e.docThumbnailImage,
                  docThumbnailImage: e.docThumbnailImage,
                  docFees: e.docFees,
                  gender: e.gender,
                  languages: e.languages,
                  wavedoffDays: e.wavedoffDays,
                  isHod: e.isHod,
                  docImageToShow: e.docImageToShow
                };
                scope.qualificationNameArray = scope.editDoc.docQualification ? scope.editDoc.docQualification.split(",") : [];
                scope.editDoc.wavedoffDays = {
                  'id': scope.editDoc.wavedoffDays,
                  'Value': JSON.stringify(scope.editDoc.wavedoffDays)
                }
                scope.departmentTypes = [];
                if (e.docDepartments && e.docDepartments.length > 0)
                  e.docDepartments.forEach(function (ele) {
                    var temp = {
                      departmentName: ele.departmentName,
                      isDepartmentApplicable: true,
                      departmentID: ele.departmentId
                    }
                    scope.departmentTypes.push(temp);
                  });
                scope.awards = [];
                if (e.docAwards && e.docAwards.length > 0 && !(e.docAwards.length == 1 && e.docAwards[0] == ""))
                  e.docAwards.forEach(function (ele) {
                    var temp = {
                      reco: ele
                    }
                    scope.awards.push(temp);
                  });
                scope.doctorsMethods.getTimeCollection(e.docTimings);
                scope.doctorsMethods.getDocExperience();
                scope.doctorsMethods.openDocDepartmentsModal(scope.editDoc.docDepartmentIds)
              });
          }
        },
        openAddDoctor: function () {
          scope.doctorTypes = [];
          scope.departmentTypes = [];
          scope.awards = [];
          scope.docDetails = {};
          scope.doctorsMethods.clearTime();
          scope.doctorsMethods.openDocDepartmentsModal();
          scope.addDoc = true;
          scope.editDoctor = false;
          scope.editDoc = {
            "practicingSinceMonth": "1"
          };
          scope.editDoc.languages = [];
          ProfileService.loadProviderMasterByKey({columnNames: ["Doctor_Type"]})
            .then(function (res) {
              scope.editDoc.wavedoffDays = {
                'id': 0,
                'Value': '0'
              };
              angular.forEach(res.lookupData, function (e, i) {
                $('#docName').focus();
                var tempObj = {
                  doctorTypeId: e.masterLookUpID,
                  doctorType: e.masterLookUpColumnValue
                }
                scope.doctorTypes.push(tempObj);
              });
            });
        },
        openDocDepartmentsModal: function (departments) {
          if (departments) {
            var d = [];
            departments.forEach(function (elem) {
              d.push(elem);
            });
          }
          scope.departmentTypes = [];
          ProfileService.loadProviderMasterByKey({columnNames: ["Hospital_Department_Type"]})
            .then(function (result) {
              angular.forEach(result.lookupData, function (e, i) {
                var tempObj = {
                  departmentID: e.masterLookUpID,
                  departmentName: e.masterLookUpColumnValue,
                  isDepartmentApplicable: d && d.indexOf(e.masterLookUpID) > -1 ? true : false
                }
                scope.departmentTypes.push(tempObj);
              });
              for (var i = 0; i < scope.departmentTypes.length; i++) {
                scope.specializedIn = '';
                if (scope.departmentTypes[i].isDepartmentApplicable) {
                  scope.specializedIn = scope.departmentTypes[i].departmentName;
                  break;
                }
              }
            });
        },
        removeSpecialization: function (index) {
          scope.departmentTypes.splice(index, 1);
          scope.department();
        },
        addNewAward: function () {
          var temp = {
            award: ''
          }
          scope.awards.push(temp);
        },
        removeAward: function ($index) {
          scope.awards.splice($index, 1);
        },
        addTime: function (day, startTimeHrs, startTimeMins, endTimeHrs, endTimeMins, startPM, endPM, obj) {
          var pickDay = scope.timmingsOfWeek.filter(function (ele) {
            return ele.dayName == day;
          })[0];
          if (!pickDay.timeSlots) {
            pickDay.timeSlots = [];
          }
          pickDay.timeSlots.push({
            startTimeHrs: startPM && startTimeHrs != "12" ? (parseInt(startTimeHrs) + 12).toString() : startTimeHrs,
            startTimeMins: startTimeMins,
            endTimeHrs: endPM && endTimeHrs != "12" ? (parseInt(endTimeHrs) + 12).toString() : endTimeHrs,
            endTimeMins: endTimeMins
          });
          startTimeHrs = "";
          startTimeMins = "";
          endTimeHrs = "";
          endTimeMins = "";
          obj.startTimeHrs = "";
          obj.startTimeMins = "";
          obj.endTimeHrs = "";
          obj.endTimeMins = "";
          obj.startAM = true;
          obj.startPM = false;
          obj.endAM = true;
          obj.endPM = false;
        },
        removeTime: function (day, index, parentIndex) {
          var pickDay = scope.timmingsOfWeek.filter(function (ele) {
            return ele.dayName == day;
          })[0];
          pickDay.timeSlots.splice(index, 1);
          if (!pickDay.timeSlots) {
            pickDay.timeSlots = [];
          }
        },
        copyTime: function (day) {
          var ts = scope.timmingsOfWeek.filter(function (ele) {
            return ele.dayName == day;
          })[0].timeSlots;
          scope.timmingsOfWeek.map(function (ele) {
            ele.timeSlots = [];
            ts.map(function (el) {
              ele.timeSlots.push({
                startTimeHrs: el.startTimeHrs,
                startTimeMins: el.startTimeMins,
                endTimeHrs: el.endTimeHrs,
                endTimeMins: el.endTimeMins
              });
            });
          });
        },
        clearTime: function () {
          scope.timmingsOfWeek.map(function (ele) {
            ele.timeSlots = [];
          });
        },
        timeSlotAdded: function () {
          var added = false;
          if (scope.timmingsOfWeek.length) {
            for (var i = 0; i < scope.timmingsOfWeek.length; i++) {
              if (scope.timmingsOfWeek[i].timeSlots.length) {
                added = true;
                break
              }
            }
          }
          return added ? true : false
        },
        uploadDoctorImage: function () {
          var fileBlobArray = [];
          var filesUploadingArray = [];
          Object.keys(scope.file).forEach(function (ele) {
            if (typeof (scope.file[ele].model) == "object") {
              filesUploadingArray.push(scope.file[ele].model);
            }
          });
          if (filesUploadingArray.length > 0) {
            fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrl() + '/Provider/Profile/DocumentUpload'));
          } else {
            alert('Please attach atleast one document');
            return false;
          }
          $q.all(fileBlobArray).then(function (result) {
              result.forEach(function (element) {
                if (element.data.isSuccess) {
                  scope.newlyUploadedImages = element.data.uploadedDetails;
                  scope.editDoc.docImageToShow = scope.newlyUploadedImages[0].downloadLink;
                  scope.editDoc.docThumbnailImage = scope.newlyUploadedImages[0].fileGuid;
                  // scope.editDoc.docImage = scope.newlyUploadedImages[0].fileGuid;
                  // scope.editDoc.docThumbnailImage = scope.newlyUploadedImages[0].imageThumbNailLink;
                } else {
                  alert('upload fail');
                  return false;
                }
              });
            },
            function (error) {
              alert('upload fail');
            });
        },
        getNumber: function (num) {
          return new Array(num);
        },
        setYear: function (year) {
          scope.editDoc.practicingSince = parseInt(year);
          scope.showYearAdd = false;
          scope.doctorsMethods.getDocExperience();
        },
        getDocExperience: function () {
          if (!scope.editDoc.practicingSince) {
            return false;
          }
          var abc = parseInt(scope.editDoc.practicingSince) * 12;
          if (scope.editDoc.practicingSinceMonth && scope.editDoc.practicingSinceMonth.length > 0) {
            abc += parseInt(scope.editDoc.practicingSinceMonth);
          }
          scope.ps = abc;
          var d1 = (scope.editDoc.practicingSinceMonth ? scope.editDoc.practicingSinceMonth : 0) + '-01-' + scope.editDoc.practicingSince;
          var date1 = new Date(d1);
          var monthsDiff = UtilitiesService.monthDiff(date1, new Date());
          var mnths = monthsDiff % 12;
          var yrs = parseInt(monthsDiff / 12);
          scope.editDoc.docExper = yrs + ' years ' + mnths + ' months ';
        },
        addNewDoctor: function (isEdit, isDelete) {
          var dpTypes = [];
          scope.departmentTypes.map(function (e) {
            if (e.isDepartmentApplicable) {
            dpTypes.push(parseInt(e.departmentID))
            }
          });

          var timings = [];
          scope.timmingsOfWeek.map(function (e) {
            var slots = [];
            if (!e.timeSlots) {
              e.timeSlots = [];
            }
            e.timeSlots.map(function (s) {
              var t = {
                slotStartTime: (parseInt(s.startTimeHrs) * 60) + parseInt(s.startTimeMins),
                slotEndTime: (parseInt(s.endTimeHrs) * 60) + parseInt(s.endTimeMins)
              }
              slots.push(t);
            });
            var temp = {
              "dayOfWeek": e.dayName,
              "slots": slots
            };
            timings.push(temp);
          });
          var recog = [];
          scope.awards.map(function (e) {
            recog.push(e.reco);
          });
          var singleDoctor = {
            "id": isEdit ? scope.editDoc.id : 0,
            "hospitalID": UserService.getHospitalObj().hospId,
            "doctorName": scope.editDoc.docName,
            "departmentIDs": dpTypes,
            "doctorQualification": scope.editDoc.docQualification,
            "doctorPracticingSince": scope.ps,
            "doctorRegNo": scope.editDoc.docRegNo,
            "doctorTypeID": scope.editDoc.docType ? parseInt(scope.editDoc.docType) : 0,
            "docTimings": timings,
            "isActive": true,
            "doctorDiscountedFee": scope.editDoc.discountedFees,
            "isVerified": false,
            "isDelete": isEdit ? isDelete : false,
            "createdBy": UserService.getUserObj().userId,
            "modifiedBy": UserService.getUserObj().userId,
            // "doctorImage": scope.editDoc.docImage,
            // "doctorImageThumbnail": scope.editDoc.docThumbnailImage,
            "doctorImageThumbnail": scope.editDoc.docThumbnailImage,
            "doctorFees": scope.editDoc.docFees,
            "awards": recog,
            "languages": JSON.stringify(scope.editDoc.languages),
            "wavedoffDays": scope.editDoc.wavedoffDays.Value,
            "gender": scope.editDoc.gender,
            "isHod": scope.editDoc.isHod,
          }
          var data = {
            "doctorDetail": []
          }
          data.doctorDetail.push(singleDoctor);
          ProfileService.updateProviderProfileDataByKey('doctor',data).then(function (response) {
            if (response) {
              scope.doctorsMethods.loadDoctors();
              scope.fileUploadMethods.clearFileModels();
              scope.addDoc = false;
              scope.editDoctor = false;
            }
          })
        },
        closeDoctor: function () {
          scope.addDoc = false;
          scope.editDoctor = false;
          scope.timmingsOfWeek = [];
          scope.daysOfWeek.map(function (day) {
            var temp = {
              dayName: day.name,
              timeSlots: []
            }
            scope.timmingsOfWeek.push(temp);
          });
        },
        getDocExpr: function (pracSince) {
          var exprY = parseInt(pracSince / 12);
          var nowY = (new Date()).getFullYear();
          return (nowY - exprY - 1) > 100 ? 0 : (nowY - exprY - 1) + ' years ' + pracSince % 12 + ' months ';
        },
        getDocDeps: function (deps) {
          if (!deps || deps.length <= 0) {
            return null;
          }
          var res = [];
          deps.map(function (e) {
            var temp = {
              departmentId: e.departmentId,
              departmentName: e.departmentName,
              isDepartmentApplicable: true
            }
            res.push(temp);
          });
          return res;
        },
        getTimeCollection: function (docTim) {
          scope.timmingsOfWeek = [];
          if (docTim) {
            docTim.forEach(function (e) {
              var temp = {
                dayName: e.dayOfWeek,
                timeSlots: scope.doctorsMethods.getSlots(e.slots)
              };
              scope.timmingsOfWeek.push(temp);
            });
          } else {
            scope.daysOfWeek.map(function (day) {
              var temp = {
                dayName: day.name,
                timeSlots: []
              }
              scope.timmingsOfWeek.push(temp);
            });
          }
        },
        getSlots: function (slots) {
          if (!slots || slots.length <= 0)
            return [];
          var res = [];
          slots.forEach(function (e) {
            var tmp = {
              startTimeHrs: parseInt(e.slotStartTime / 60).toString().length == 1 ? "0" + parseInt(e.slotStartTime / 60) : parseInt(e.slotStartTime / 60).toString(),
              startTimeMins: parseInt(e.slotStartTime % 60).toString().length == 1 ? "0" + parseInt(e.slotStartTime % 60) : parseInt(e.slotStartTime % 60).toString(),
              endTimeHrs: parseInt(e.slotEndTime / 60).toString().length == 1 ? "0" + parseInt(e.slotEndTime / 60) : parseInt(e.slotEndTime / 60).toString(),
              endTimeMins: parseInt(e.slotEndTime % 60).toString().length == 1 ? "0" + parseInt(e.slotEndTime % 60) : parseInt(e.slotEndTime % 60).toString()
            };
            res.push(tmp);
          });
          return res;
        },
        getDocDays: function (timings) {
          if (timings) {
            var res = [];
            timings.forEach(function (e) {
              if (e && e.slots && e.slots.length > 0) {
                res.push(true);
              } else {
                res.push(false);
              }
            });
            return res;
          }
        },
        getPracticeMonths: function (pracSince) {
          if (!pracSince)
            return;
          return (pracSince % 12).toString();
        },
        getPracticeSince: function (pracSince) {
          if (!pracSince)
            return;
          return parseInt(pracSince / 12);
        },
        editDocName: function (docName) {
          if (docName && docName.toLowerCase().indexOf('dr') > -1) {
            return false;
          } else {
            return true;
          }
        }
      };
    })();

    scope.fileUploadMethods = (function () {
      return {
        addFileToUpload: function (flag) {
          var newItemNo = scope.file.length + 1;
          scope.file.push({
            'model': ''
          });
        },
        removeFileToUpload: function (index) {
          scope.file.splice(index, 1);
          scope.fileUploadMethods.addFileToUpload();
        },
        clearFileModels: function () {
          scope.newlyUploadedImages = [];
          scope.file = [];
          scope.fileUploadMethods.addFileToUpload();
        },
      };
    })();
    angular.element(document).ready(function () {
      scope.doctorsMethods.loadDoctors();
      scope.fileUploadMethods.addFileToUpload();
    });
  }]);

angular.module("mbplus")
.controller('dcInvestigationsMapController', ['$rootScope', '$scope', '$timeout', '$anchorScroll', '$location', 'UserService', 'UtilitiesService', 'PlusUtilitiesService', function (rootScope, scope, $timeout, anchorScroll, location, UserService, UtilitiesService, PlusUtilitiesService) {
    if (!UserService.isActive()) {
        UserService.destroyUserObj();
        location.path('/');
        return false;
    }
    scope.status = {
        isFirstOpen: true
    }
    scope.map = {
        isInitialised : false,
        value : ''
    }
    scope.changedValue = [];
    scope.user = UserService.getUserObj();
    scope.isActive = UserService.isActive();
    scope.isCollapsedHorizontal = true;
    $('.no-login').removeClass('no-login').addClass('login');
    $('#sidebar li').removeClass('active');
    $('#sidebar li#dcInvestigationsMap').addClass('active');
    $('#dctable').on('click', 'tr', function () {
        $('tr').removeClass('  info bs-callout bs-callout-info');
        $(this).toggleClass(' info bs-callout bs-callout-info');
    });
    scope.ctrlName = 'dcInvestigationsMap';
    scope.internalDDnFlag = 1
    var erTypeName = 'DC_MediAssist', ERTypeId = PlusUtilitiesService.getDC_MA_ContractID(), serviceBrokerId = '1000042', serviceBrokerName = 'Medi Assist',
    Entity_Type = '4653', PM_TypeId = PlusUtilitiesService.getDC_Inv_PmTypeId(), map;
    scope.onlyNumbers = /^\d+$/;
    scope.activeCls = '';
    scope.propvalue = 0;
    scope.urlPrefix = UtilitiesService.getPlusUrlPrefix('medibuddy');
    scope.showMappedInvestigations = false;
    scope.mappedInvestigationPanel = false;
    scope.showAddNewInvestigation = false;
    scope.btnAddNewInvestigationShow = false;
    scope.btnAddNewDcShow = true;
    scope.btnMappedInvestigationsShow = false;
    scope.btnDcDetailsShow = false;
    scope.DcDetailsPanel = false;
    scope.showDcList = false;
    scope.showUserMessage = false;
    scope.flag = 1;
    scope.stateSelected;
    scope.citySelected;
    scope.updateDc = {};
    scope.dcList = {};
    scope.mappedInvestigations = {};
    scope.mappedPackagesObj = {};
    scope.selectedPackage = {};
    scope.selectedDc;
    scope.selectedDcErId;
    scope.MappedDcId;
    scope.updatedInvestigationList = [];
    scope.mapLoaded = false;
    scope.mapData = null;
    scope.allInvestigations = {};
    scope.chkAll = {};


    //Get DC List
    scope.loadDCs = function (stateId, cityId, locationId, minorLocationId) {
        var url = '';
        if (stateId && cityId && locationId && minorLocationId) {
            url = UtilitiesService.getPlusUrlPrefix() + 'EntityRelation/Search/EntitySearch/' +
                ERTypeId + '/' + serviceBrokerId + '/0/' + stateId + '/' + cityId + '/' + locationId + '/' + minorLocationId + '.json';
        }
        else {
            if (stateId && cityId && locationId) {
                minorLocationId = 0;
                url = UtilitiesService.getPlusUrlPrefix() + 'EntityRelation/Search/EntitySearch/' +
                    ERTypeId + '/' + serviceBrokerId + '/0/' + stateId + '/' + cityId + '/' + locationId + '/0.json';
            }
        }
        if (url) {
            UserService.makeRestCall(url, '', 'GET').then(function (response) {
                scope.showDcList = true;
                scope.status.isFirstOpen = false;
                scope.diagnosticCentresFiltered = {};
                if (response.data.length !== 0) {
                    scope.DcDetailsPanel = false;
                    scope.btnMappedInvestigationsShow = false;
                    scope.btnDcDetailsShow = false;
                    scope.showUserMessage = false;
                    scope.diagnosticCentres = response.data;
                    UserService.diagnosticCentresCollectionForSearch = response.data;
                    UserService.diagnosticCentresCollection = response.data;
                    scope.dcObj = {};
                    //scope.loadMapForDcList();
                } else {
                    scope.DcDetailsPanel = false;
                    scope.diagnosticCentresFiltered = {};
                    window.scrollTo(0, 0);
                    scope.showUserMessage = true;
                    scope.addClass = 'alert alert-danger';
                    scope.usermessage = 'No data found';
                }
                scope.diagnosticCentres.entityName = response.data.errorMessage;
            },
            function (error) {
                UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
                scope.showUserMessage = true;
                scope.addClass = 'alert alert-danger';
                scope.usermessage = error.data.responseStatus.message;
            })
        } else {
            UtilitiesService.showAlertMessage('Please select search filter values.');
        }
    };

    scope.search = {
        stateSelected: '',
        locationSelected: '',
        citySelected: '',
        minorLocationSelected: ''
    }

    //Clear Search Data
    scope.clearSearch = function () {
        scope.search.stateSelected = '';
        scope.search.citySelected = '';
        scope.search.locationSelected = '';
        scope.search.minorLocationSelected = '';
    };

    scope.loadMappedDcInvestigations = function () {
        scope.DcDetailsPanel = false;
        scope.mappedInvestigationPanel = true;
        var data = {};
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/SearchMappedPackages/' + scope.selectedDcErId + '/' + PM_TypeId + '.json', data, "get").then(function (response) {
            scope.initialMappedInvestigations = [];
            scope.initialMappedInvestigations = response.data;
            var arr = [], trueIndex;
            arr = $.map(response.data, function (item) { return item; });
            angular.forEach(scope.allInvestigations, function (val, index) {
                val.cost = 0;
                trueIndex = arr.map(function (e) {
                    if (e.isActive) {
                        return e.pM_ID;
                    }
                }).indexOf(val.id);
                if (trueIndex !== -1) {
                    val.selected = true;
                    val.dcRate = parseInt(arr[trueIndex].dcRate);
                    val.perId = arr[trueIndex].id;
                } else {
                    val.dcRate = 0;
                    val.selected = false;
                    val.perId = 0;
                }
            });
            scope.mappedInvestigations = UtilitiesService.getInvestigationByGroup(scope.allInvestigations);
            scope.keys = Object.keys(scope.mappedInvestigations);
            scope.countChecked(scope.mappedInvestigations);
            angular.forEach(scope.keys, function (value, index) { scope.calculateTotalCost(value); });
        },
        function (error) {
            window.scrollTo(0, 0);
            scope.showUserMessage = true;
            scope.addClass = 'alert alert-danger';
            scope.usermessage = error.data.responseStatus.message;
        });
    };
    scope.saveMappedInvestigations = function () {
        var investigation = {};
        scope.updatedInvestigationList = [];
        angular.forEach(scope.changedValue, function(value, index){
            var investigation = {
                id: value.perId,
                eR_Id: scope.selectedDcErId,
                pM_ID: value.id,
                pM_Name: value.name,
                isActive: value.isActive,
                pM_TypeId: PM_TypeId,
                dcRate: value.dcRate,
                requestAccessToken: UserService.getAccessToken()
            }
            scope.updatedInvestigationList.push(investigation);
        });
        
        var arrToRemove = [];
        var updatedInvestigation_pM_ID = $.map(scope.updatedInvestigationList, function (item) {
            return item.pM_ID
        })
        angular.forEach(scope.initialMappedInvestigations, function (val, index) {
            if (updatedInvestigation_pM_ID.indexOf(val.pM_ID) === -1) {
                val.isActive = false;
                arrToRemove.push(val);
            }
        });
        scope.updatedInvestigationList = scope.updatedInvestigationList.concat(arrToRemove);
        //creating final investigation list to be pushed
        var data = {
            packageEntityRelations: scope.updatedInvestigationList,
            requestAccessToken: UserService.getAccessToken(),
            userAgent: 'user',
            ipAddress: 'String'
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/BulkInsertPackageEntityRelation.json', data, 'POST', UserService.getAccessToken()).then(function (response) {
            scope.loadMappedDcInvestigations;
            scope.submitUserMessage = true;
            scope.addClass = 'alert alert-success';
            scope.usermessage = 'success';
            $('.pull-left:checked').each(function () {
                $(this).prop('checked', false);
            });
            scope.showDcList = false;
            $('#parentDCDetailsPanel').hide();
        },
        function (error) {
            scope.submitUserMessage = true;
            scope.addClass = 'alert alert-danger';
            scope.usermessage = error.data.responseStatus.message;
            // console.log(error.data.responseStatus.message)
        })
    };
    scope.timeOutFun = function () {
        $timeout(function () {
            scope.submitUserMessage = false;
        }, 5000);
    };

    scope.updateDcSubmit = function () {
        if ($('#stateId').val() === '' || $('#stateId').val() === 'null' || $('#stateId').val() === null ||
            $('#districtId').val() === '' || $('#districtId').val() === 'null' || $('#districtId').val() === null ||
            $('#cityId').val() === '' || $('#cityId').val() == "null" || $('#cityId').val() === null ||
            $('#locationId').val() === '' || $('#locationId').val() === 'null' || $('#locationId').val() === null) {
            UtilitiesService.showAlertMessage('Please select State,district,city,location values correctly');
            return false;
        }

        var type = 'GET';
        var url = '';
        if (scope.flag === 0) {
            url = UtilitiesService.getPlusUrlPrefix() + 'providers/' + scope.updateDc.id + '.json';
            type = 'PUT';
        } else {
            scope.updateDc.attachDocIds = [];
            if ($('#reports').val() === '' && scope.updateDc.attachDocIds.length === 0) {
                UtilitiesService.showAlertMessage('Please select a file for contract Details with Bank');
                return false;
            }
            url = UtilitiesService.getPlusUrlPrefix() + 'diagnosticCenters.json';
            type = 'POST';
        }
        scope.updateDc.stateId = $('#stateId').val();
        scope.updateDc.districtId = $('#districtId').val();
        scope.updateDc.cityId = $('#cityId').val();
        scope.updateDc.locationId = $('#locationId').val();
        scope.updateDc.requestAccessToken = UserService.getAccessToken();
        scope.updateDc.userAgent = 'user';
        scope.updateDc.ipAddress = 'string';
        var submitData = scope.updateDc;
        var ErActiveFlag = $('#dcActive').is(':checked');
        submitData.isactive = true; // DC is always active assumption
        UserService.makeRestCall(url, submitData, type, UserService.getAccessToken()).then(function (response) {
            var resdata = response.data;
            scope.mapDcToServiceBroker = {
                entityId: resdata.id,
                erTypeId: ERTypeId,
                erTypeName: erTypeName,
                serviceBrokerId: serviceBrokerId,
                serviceBrokerName: serviceBrokerName,
                entityName: resdata.fullName,
                startDate: scope.updateDc.startDate,
                endDate: scope.updateDc.endDate,
                documentType: 0,
                isActive: ErActiveFlag,
                accountNumber: scope.updateDc.accountNumber,
                accountHolderName: scope.updateDc.accountHolderName,
                bankName: scope.updateDc.bankName,
                branchCode: scope.updateDc.branchCode,
                ifscCode: scope.updateDc.ifscCode,
                branchAddress: scope.updateDc.branchAddress,
                tds: scope.updateDc.tds,
                outSourcingDetail: scope.updateDc.primaryLocationoutSourcingDetail,
                micrCode: scope.updateDc.micrCode,
                attachDocIds: scope.updateDc.attachDocIdsNew,
                serviceTaxRegNo: scope.updateDc.serviceTaxRegNo
            }
            var innerAjaxData = scope.mapDcToServiceBroker;
            if (resdata !== null && scope.flag === 1) {
                var innerUrl = UtilitiesService.getPlusUrlPrefix() + '/EntityRelation.json';
                var type = 'POST';
            } else {
                var innerUrl = UtilitiesService.getPlusUrlPrefix() + '/EntityRelation/' + scope.updateDc.er_Id + '.json';
                var type = 'PUT';
            }
            UserService.makeRestCall(innerUrl, innerAjaxData, type, UserService.getAccessToken()).then(function (response) {
                window.scrollTo(0, 0);
                scope.submitUserMessage = true;
                scope.timeOutFun();
                scope.addClass = 'alert alert-success';
                scope.usermessage = 'updated successfully.';
                $('#parentDCDetailsPanel').hide();
                scope.showDcList = false;
            },
            function (error) {
                scope.submitUserMessage = true;
                scope.timeOutFun();
                scope.addClass = 'alert alert-danger';
                scope.usermessage = 'Something went wrong please try again later.';
            })
            scope.usermessage = 'updated successfully.';
            scope.submitUserMessage = true;
            scope.timeOutFun();
            scope.addClass = 'alert alert-success';
        },
        function (error) {
            window.scrollTo(0, 0);
            scope.addClass = 'alert alert-danger';
            scope.submitUserMessage = true;
            scope.timeOutFun();
            if (error.data && error.data.responseStatus) {
                scope.usermessage = error.data.responseStatus.message;
            } else {
                scope.usermessage = 'Some error occur while updating !';
            }
        })
    };
    //minor methods
    scope.btnDcEdit = function (dc) {
        scope.mappedPackages = {};
        window.scrollTo(0, 0);
        scope.showDcList = true;
        scope.btnAddNewInvestigationShow = false;
        scope.showUserMessage = false;
        scope.MappedDcId = dc.id;
        scope.loadMappedDcPackages();
    }
    scope.btnClose = function () {
        scope.showMappedInvestigations = false;
        scope.showUserMessage = false;
        scope.showDcList = true;
        scope.showAddNewInvestigation = false;
    }
    scope.btnMappedPackageEdit = function (pkg) {
        scope.flag = 0;
        scope.selectedPackage = jQuery.extend({}, pkg)
        scope.showAddNewInvestigation = true;
        $("input[name=pkgChk]").attr('checked', false);
        scope.showUserMessage = false;
    }
    scope.btnAddNewInvestigation = function () {
        scope.flag = 1;
        $("input[name=pkgChk]").attr('checked', false);
        scope.showAddNewInvestigation = true;
        scope.selectedPackage = {};
        scope.showUserMessage = false;
    }
    scope.mapNewInvestigation = function (investigation) {
        scope.selectedPackage.eR_Id = scope.MappedDcId;
        scope.selectedPackage.pM_ID = investigation.id;
        scope.selectedPackage.pM_Name = investigation.name;
    }
    scope.btnDcDetails = function (dcID, erId) {
        $('#parentDCDetailsPanel').show();
        scope.DcDetailsPanel = true;
        scope.mappedInvestigationPanel = false;
        scope.submitMessage = false;
        scope.submitUserMessage = false;
        scope.flag = 0;
        scope.selectedDc = dcID;
        scope.selectedDcErId = erId;
        var data = {};
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/providers/' + dcID + '.json', data, 'GET').then(function (response) {
            scope.btnMappedInvestigationsShow = true;
            scope.btnDcDetailsShow = true;
            scope.DcDetailsPanel = true;
            scope.activeCls = 'active';
            var html = '';
            scope.updateDc = response.data;
            if (!scope.mapLoaded) {
                scope.initialize();
            } else {
                if (scope.mapData) {
                } else {
                    placeMarker(new google.maps.LatLng(scope.updateDc.primaryLocationLatitude, scope.updateDc.primaryLocationLongitude));
                }
            }
            scope.loadBankDetails(serviceBrokerId, ERTypeId, scope.updateDc.id);
            scope.reloadDropdownsState();
            scope.reloadDropdownsCity();
            scope.reloadDropdownsLocation();
            scope.reloadDropdownsMinorLocation();
        },
        function (error) {
            window.scrollTo(0, 0);
            scope.showUserMessage = true;
            scope.addClass = 'alert alert-danger';
            scope.usermessage = error.data.responseStatus.message;
        })
        $('#myTab a[data-target="#dcDetails"]').tab('show')
    };
    scope.btnAddNewDc = function () {
        $('#stateId').empty();
        $('#districtId').empty();
        $('#cityId').empty();
        $('#locationId').empty();
        $('#stateId').append('<option value="' + null + '">Select State</option>');
        $('#districtId').append('<option value="' + null + '">Select City</option>');
        $('#cityId').append('<option value="' + null + '">Select Location</option>');
        $('#locationId').append('<option value="' + null + '">Select Minor Location</option>');
        scope.diagnosticCentres = [];
        scope.status.isFirstOpen = false;
        if (!scope.mapLoaded) {
            scope.initialize();
        }
        scope.showUserMessage = false;
        scope.submitUserMessage = false;
        scope.flag = 1;
        scope.activeCls = "";
        scope.DcDetailsPanel = true;
        scope.updateDc = {};
        scope.reloadDropdownsState();
        scope.showDcList = false;
        scope.btnMappedInvestigationsShow = false;
        //document.getElementById('reports').value = '';
        $('#parentDCDetailsPanel').show();
        $('#myTab a[data-target="#dcDetails"]').tab('show')
        scope.dcForm.$setPristine(true)
    };

    scope.loadStates = function () {
        scope.diagnosticCentres = {};
        if (scope.internalDDnFlag === 1) {
            $('#parentDCDetailsPanel').hide();
            scope.showDcList = false;
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + 'masterdata/lookup/state.json', '', 'GET').then(function (response) {
            if (response.data.isSuccess) {
                scope.states = response.data.lookUpData;
            }
        });
    };

    scope.loadCities = function (stateId, isFlag) {
        scope.diagnosticCentres = [];
        scope.search.citySelected = '';
        scope.search.locationSelected = '';
        scope.search.minorLocationSelected = '';
        scope.cities = [];
        if (isFlag) {
            $('#parentDCDetailsPanel').hide();
            scope.showDcList = false;
        }
        if (stateId && stateId !== 'null') {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'masterdata/lookup/district/' + stateId + '.json', '', 'GET').then(function (response) {
                if (response.data.isSuccess) {
                    scope.cities = response.data.lookUpData;
                    scope.reloadDropdownsCity();
                }
            });
        }
    };
    scope.loadLocations = function (cityId, isFlag) {
        scope.search.minorLocationSelected = '';
        scope.search.locationSelected = '';
        scope.locations = [];
        if (isFlag) {
            $('#parentDCDetailsPanel').hide();
            scope.showDcList = false;
        }
        if (cityId && cityId !== 'null') {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'masterdata/lookup/city/' + cityId + '.json', '', 'GET').then(function (response) {
                if (response.data.isSuccess) {
                    scope.locations = response.data.lookUpData;
                    scope.reloadDropdownsLocation();
                }
            });
        }
    };

    scope.loadMinorLocations = function (locationId, isFlag) {
        scope.search.minorLocationSelected = '';
        scope.minorLocations = [];
        if (isFlag) {
            $('#parentDCDetailsPanel').hide();
            scope.showDcList = false;
        }
        if (locationId && locationId !== 'null') {

            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'masterdata/lookup/location/' + locationId + '.json', '', 'GET').then(function (response) {
                if (response.data.isSuccess) {
                    scope.minorLocations = response.data.lookUpData;
                    scope.reloadDropdownsMinorLocation();
                }
            });
        }
    };

    scope.loadAllInvestigations = function () {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'DCInvestigations.json', {}, 'GET').then(function (response) {
            scope.allInvestigations = response.data;
        })
    };
    scope.reloadDropdownsState = function () {
        for (i = 0; i < scope.states.length; i++) {
            $('#stateId').append('<option value="' + scope.states[i].lookUpId + '">' + scope.states[i].lookUpValue + '</option>');
        }
        $("#stateId option[value=" + scope.updateDc.stateId + "]").attr("selected", "selected");
    };
    scope.reloadDropdownsCity = function () {
        $("#districtId").empty();
        $("#districtId").append('<option value="' + null + '">Select City</option>');
        for (i = 0; i < scope.cities.length; i++) {
            $("#districtId").append('<option value="' + scope.cities[i].lookUpId + '">' + scope.cities[i].lookUpValue + '</option>');
        }
        $("#districtId option[value=" + scope.updateDc.districtId + "]").attr("selected", "selected");
    };
    scope.reloadDropdownsLocation = function () {
        $("#cityId").empty();
        $("#cityId").append('<option value="' + null + '">Select Location</option>');
        for (i = 0; i < scope.locations.length; i++) {
            $('#cityId').append('<option value="' + scope.locations[i].lookUpId + '">' + scope.locations[i].lookUpValue + '</option>');
        }
        $("#cityId option[value=" + scope.updateDc.cityId + "]").attr("selected", "selected");
    };
    scope.reloadDropdownsMinorLocation = function () {
        $("#locationId").empty();
        $('#locationId').append('<option value="' + null + '">Select Minor Location</option>');
        for (i = 0; i < scope.minorLocations.length; i++) {
            $('#locationId').append('<option value="' + scope.minorLocations[i].lookUpId + '">' + scope.minorLocations[i].lookUpValue + '</option>');
        }
        $("#locationId option[value=" + scope.updateDc.locationId + "]").attr("selected", "selected");
    };

    scope.selectAll = function (groupType, selected) {
        scope.propvalue = 0;
        if (selected) {
            $('.' + groupType).each(function () {
                this.checked = true;
                scope.propvalue = scope.propvalue + 1;
            });
            $(scope.mappedInvestigations[groupType]).each(function (v) {
                this.selected = true;
                
            });
            if(scope.changedValue && scope.changedValue.length >0){
                angular.forEach(scope.changedValue, function(data, index){
                    if(data.groupName === groupType){
                        scope.changedValue.splice(index, 1);
                    }
                })
            }
            angular.forEach(scope.mappedInvestigations[groupType], function(data, index){
                scope.changedValue.push(data);
            });
        } else {
            $('.' + groupType).each(function () {
                this.checked = false;
            });
            scope.propvalue = 0;
            $(scope.mappedInvestigations[groupType]).each(function (v) {
                this.selected = false;
                scope.changedValue.push(i);
            });
            if(scope.changedValue && scope.changedValue.length >0){
                angular.forEach(scope.changedValue, function(data, index){
                    if(data.groupName === groupType){
                        scope.changedValue.splice(index, 1);
                    }
                })
            }
            angular.forEach(scope.mappedInvestigations[groupType], function(data, index){
                scope.changedValue.push(data);
            });
        }
        scope.selectedItems[groupType] = scope.propvalue;
    };
    scope.loadBankDetails = function (serviceBrokerId, ERTypeId, EntityId) {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'EntityRelation/Search/' + ERTypeId + '/ServiceBroker/' + serviceBrokerId + '/Entity/' + EntityId + '.json', '', 'GET').then(function (response) {
            var data = _.first(response.data);
            scope.updateDc.accountNumber = data.accountNumber;
            scope.updateDc.accountHolderName = data.accountHolderName;
            scope.updateDc.bankName = data.bankName;
            scope.updateDc.branchCode = data.branchCode;
            scope.updateDc.ifscCode = data.ifscCode;
            scope.updateDc.branchAddress = data.branchAddress;
            scope.updateDc.micrCode = data.micrCode;
            scope.updateDc.attachDocIds = data.attachDocIds;
            scope.updateDc.er_Id = data.id;
            scope.updateDc.startDate = scope.ConvertDate(data.startDate);
            scope.updateDc.endDate = scope.ConvertDate(data.endDate);
            scope.updateDc.primaryLocationoutSourcingDetail = data.outSourcing;
            scope.updateDc.tds = data.tds;
        },
            function (error) {
                scope.showUserMessage = true;
                scope.addClass = 'alert alert-danger';
                scope.usermessage = error.data.responseStatus.message;
            })
    };
    scope.ConvertDate = function (input) {
        var date = new Date(parseInt(input.match(/\d+/g)[0]))
        var d = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
        return d;
    };
    scope.countChecked = function (allInvestigationsGrouped, value) {
        scope.selectedItems = {};
        $.each(allInvestigationsGrouped, function (index, val) {
            scope.propvalue = 0;
            $.each(val, function (i, v) {
                if (v.selected) {
                    scope.propvalue = scope.propvalue + 1;
                    scope.selectedItems[index] = scope.propvalue
                } else {
                    v.dcRate = 0;
                    scope.propvalue = scope.propvalue + 0;
                    scope.selectedItems[index] = scope.propvalue
                    scope.chkAll[index] = false;
                }
            })
        });
        if(value){
            scope.changedValue.push(value);
        }
    };
    scope.minorLocation = false;
    scope.minorLocationChange = function () {
        if (scope.internalDDnFlag === 1) {
            $('#parentDCDetailsPanel').hide();
            scope.showDcList = false;
            scope.minorLocation = true;
        }
    };
    scope.initialize = function () {
        scope.mapLoaded = true;
        if (scope.updateDc.primaryLocationLatitude && scope.updateDc.primaryLocationLongitude) {
            var myLatLng = new google.maps.LatLng(scope.updateDc.primaryLocationLatitude, scope.updateDc.primaryLocationLongitude);
        } else {
            var myLatLng = new google.maps.LatLng(21.2949788, 78.2748286);
        }
        map = new google.maps.Map(document.getElementById('map-canvas'), {
            zoom: 17,
            center: myLatLng,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        scope.map = {
            isInitialised : true,
            value : map
        }
        var input = (document.getElementById('pac-input'));
        var types = document.getElementById('type-selector');
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(types);
        // var autocomplete = new google.maps.places.Autocomplete(input);
        // autocomplete.bindTo('bounds', map);
        var infowindow = new google.maps.InfoWindow();
        var marker = new google.maps.Marker({
            map: map,
            anchorPoint: new google.maps.Point(0, -29)
        });
        if (scope.updateDc.primaryLocationLatitude) {
            placeMarker(new google.maps.LatLng(scope.updateDc.primaryLocationLatitude, scope.updateDc.primaryLocationLongitude));
        }
        google.maps.event.addListener(map, "click", function (event) {
            scope.showChange = true;
            placeMarker(event.latLng);
            scope.updateDc.primaryLocationLatitude = event.latLng.lat().toFixed(6);
            scope.updateDc.primaryLocationLongitude = event.latLng.lng().toFixed(6);
            scope.mapLoaded.lat = event.latLng.lat().toFixed(6);
            scope.mapLoaded.lon = event.latLng.lng().toFixed(6);
            scope.$apply();
        })
        // autocomplete.addListener('place_changed', function () {
        //     var place = autocomplete.getPlace();
        //     if (!place.geometry) {
        //         window.alert("Autocomplete's returned place contains no geometry");
        //         return;
        //     }
        //     placeMarker(place.geometry.location);
        //     scope.mapData = place.geometry.location;
        //     scope.updateDc.primaryLocationLatitude = place.geometry.location.lat();
        //     scope.updateDc.primaryLocationLongitude = place.geometry.location.lng();
        //     scope.$apply();
        //     map.setCenter(place.geometry.location);
        //     map.setZoom(17);
        //     scope.mapData = null;
        //     document.getElementById('pac-input').value = '';
        // });

        // function setupClickListener(id, types) {
        //     var radioButton = document.getElementById(id);
        //     radioButton.addEventListener('click', function () {
        //         autocomplete.setTypes(types);
        //     });
        // }
        // setupClickListener('changetype-all', []);
    };

    scope.placeChanged = function (place) {
        if (!place.geometry) {
            window.alert("Autocomplete's returned place contains no geometry");
            return;
        }
        placeMarker(place.geometry.location);
        scope.mapData = place.geometry.location;
        scope.updateDc.primaryLocationLatitude = place.geometry.location.lat();
        scope.updateDc.primaryLocationLongitude = place.geometry.location.lng();
        scope.$apply();
        map.setCenter(place.geometry.location);
        map.setZoom(17);
        scope.mapData = null;
        document.getElementById('pac-input').value = '';
    }


    scope.calculateTotalCost = function (groupname) {
        var cost = 0;
        angular.forEach(scope.mappedInvestigations[groupname], function (val, index) {
            if (val.dcRate != null && val.dcRate != undefined && !(isNaN(val.dcRate))) {
                cost += parseInt(val.dcRate);
            } else {
                cost += 0;
            }

        });
        scope.mappedInvestigations[groupname].cost = parseInt(cost);
    };

    function placeMarker(location) {
        deleteOverlays();
        google.maps.event.trigger(map, 'resize');
        map.setZoom(map.getZoom());
        map.setCenter(location);
        var marker = new google.maps.Marker({
            position: location,
            map: map
        });
        markersArray.push(marker);
    };

    function deleteOverlays() {
        if (markersArray) {
            for (var i in markersArray) {
                markersArray[i].setMap(null);
            }
            markersArray.length = 0;
        }
    };
    $(function () {
        var formdata = false;
        $('input#reports').change(function (event) {
            $("#btnChooseFile").attr('disabled', true);
            if (window.FormData) {
                formdata = new FormData();
            }
            var i = 0,
                len = this.files.length,
                img, reader, file;
            for (; i < len; i++) {
                file = this.files[i];
                if (formdata) {
                    formdata.append('reports[]', file);
                    formdata.append('type', 'reports');
                }
            }
            if (formdata) {
                $.ajax({
                    url: UtilitiesService.getPlusUrlPrefix() + '/File.json',
                    type: 'POST',
                    data: formdata,
                    processData: false,
                    contentType: false,
                    success: function (res) {
                        scope.updateDc.attachDocIdsNew = Object.keys(res);
                        $("#btnChooseFile").attr('disabled', false);
                    },
                    error: function () {
                        document.getElementById('reports').value = '';
                        UtilitiesService.showAlertMessage('File upload failed. Please upload again.');
                    }
                });
            }
            return false;
        })
        $('#missingForm').submit(function () {
            $('#missingbutton').prop('disabled', true);
            $(this).ajaxSubmit(function (data) {
                return false;
            })
            return false;
        });
        $("#stateId").change(function (e) {
            scope.internalDDnFlag = 0;
            scope.loadCities($(this).val(), false);
        })
        $('#districtId').change(function (e) {
            scope.internalDDnFlag = 0;
            scope.loadLocations($(this).val(), false);
        })
        $('#cityId').change(function (e) {
            scope.internalDDnFlag = 0;
            scope.loadMinorLocations($(this).val(), false);
        })
    })

    scope.$watch('dcInvestigationsMap', function (current, old) {
        if (current) {
            scope.diagnosticCentres = UserService.GetDcInvestigationMap(current);
        } else {
            if (old && UserService.diagnosticCentresCollection) {
                scope.diagnosticCentres = UserService.diagnosticCentresCollection;
            } else {
                scope.diagnosticCentres = [];
            }
        }
    });
    scope.ctrlFn = function (entityId, Id) {
        if (entityId && Id) {
            scope.btnDcDetails(entityId, Id);
            location.hash('parentDCDetailsPanel');
            location.hash('dcDetails');
            anchorScroll();
        }
    };
    //Search by
    rootScope.$on('searchDc', function (key, value) {
    });

    if (scope.user) {
        var map;
        var markersArray = [];
        scope.loadStates();
        scope.loadAllInvestigations();
        scope.isActive = true;
    } else {
        scope.isActive = false;
        location.path('/')
    }
}]);
angular.module('mbplus')
.controller('dcInvestigationsController', ['$scope', 'UserService', '$analytics', 'PlusUtilitiesService', 'UtilitiesService',
    function (scope, UserService, $analytics, PlusUtilitiesService, UtilitiesService) {
        $analytics.pageTrack('/dcInvestigations');

        if (!UserService.isActive()) {
            UserService.destroyUserObj();
            $location.path('/');
            return false;
        }
        scope.isEdit = false;
        scope.dcInvestigation = {};

        scope.loadInvestigations = function () {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/DCInvestigations', '', 'GET', UserService.getAccessToken()).then(function (response) {
                if (response.data) {
                    scope.investigations = response.data;
                    UserService.investigationsDataCollection = response.data;
                }
            });
        };

        scope.loadInvestigationGroup = function () {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/masterdata/lookup/Test_Profile', '', 'GET').then(function (response) {
                scope.investigationGroup = response.data;
            });
        };

        scope.showAddInvestigation = function () {
            scope.isEdit = false;
            scope.dcInvestigation = {
                groupId: 0,
                groupName: ''
            };
        };

        scope.showDCInvestigationDataToUpdate = function (id) {
            scope.isEdit = true;
            var item = scope.investigations.filter(function (e) {
                return e.id == id;
            });
            scope.dcInvestigation = {
                name: item[0].name,
                description: item[0].description,
                shortName: item[0].shortName,
                isActive: item[0].isActive,
                lookUpId: item[0].groupId,
                lookUpValue: item[0].groupName,
                invId: id
            };
            scope.editInvestigationName = item[0].name;
            $('#dcInvestigationAddEdit').modal('show');
        };
        scope.createUpdateInvestigations = function () {
            var url;
            scope.type = '';
            if (scope.isEdit && scope.dcInvestigation && scope.dcInvestigation.invId) {
                url = UtilitiesService.getPlusUrlPrefix() + 'DCInvestigations/' + scope.dcInvestigation.invId;
                scope.type = 'PUT';
            } else {
                url = UtilitiesService.getPlusUrlPrefix() + 'DCInvestigations';
                scope.type = 'POST';
            }
            var data = {
                requestAccessToken: UserService.getAccessToken(),
                userAgent: 'user',
                ipAddress: 'String',
                id: scope.isEdit ? scope.dcInvestigation.invId : 0,
                name: scope.dcInvestigation.name,
                description: scope.dcInvestigation.description,
                shortName: scope.dcInvestigation.shortName,
                isActive: scope.dcInvestigation.isActive,
                groupId: scope.dcInvestigation.lookUpId,
                groupName: scope.dcInvestigation.lookUpValue
            }
            UserService.makeRestCall(url, data, scope.type, UserService.getAccessToken()).then(function (response) {
                if (response.data) {
                    if (scope.type === 'PUT') {
                        UtilitiesService.showAlertMessage('Investigation updated successfully.', true);
                    } else if (scope.type === 'POST') {
                        UtilitiesService.showAlertMessage('Investigation added successfully.', true);
                    }
                    $('#dcInvestigationAddEdit').modal('hide');
                    scope.loadInvestigations();
                }
            });
        };

        scope.$watch('dcInvestigations', function (current, old) {
            if (current) {
                scope.investigations = UserService.GetDcInvestigation(current);
            } else {
                if (old && UserService.investigationsDataCollection) {
                    scope.investigations = UserService.investigationsDataCollection;
                } else {
                    scope.investigations = [];
                }
            }
        });
        scope.loadInvestigations();
        scope.loadInvestigationGroup();
    }]);
angular.module("mbplus")
.controller('corpPackageMapController', ['$scope', '$rootScope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics', 'PlusUtilitiesService', 'FileUploadService', '$q', 'orderByFilter', function (scope, $rootScope, $location, UserService, UtilitiesService, filterFilter, $analytics, PlusUtilitiesService, FileUploadService, $q, orderByFilter) {
    $analytics.pageTrack('/appointments');
    if (!UserService.isActive()) {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    scope.user = UserService.getUserObj();
    scope.formatTime = UtilitiesService.formatTime;
    scope.compareDate = UtilitiesService.compareDate;
    scope.contracts = PlusUtilitiesService.getContracts();
    scope.contracts = orderByFilter(scope.contracts, 'entityName', false);
    scope.entityRelationSelected = "";
    scope.btnAddNewPackageShow = false;
    scope.addPackageTab = false;
    scope.showDropdown = true;
    scope.showEditInvestigation = false;
    scope.isCollapsedHorizontal = true;
    var ERTypeId = PlusUtilitiesService.getDC_MA_ContractID();
    var serviceBrokerId = '1000042';
    var serviceBrokerName = 'Medi Assist';
    var Entity_Type = '4653';
    scope.mappedDcList = {};
    scope.status = { isFirstOpen: false };
    scope.search = {
        CorporateSelected: '',
        entityRelationSelected: ''
    }
    scope.addNewPackage = {
        CorporateSelected: '',
        entityRelationSelected: ''
    }
    scope.dcSearch = {
        stateSelected: '',
        citySelected: '',
        locationSelected: '',

    };
    scope.current = { stateSelected: '' };
    scope.addnew = { entityRelationSelected: '' };
    scope.selectedCorpPackage = {};
    scope.mappedDcList.primaryCessTax = 500;

    scope.acessValidation = function(id){
        var result = false;
        if(scope.user && scope.user.rolesFeatures && scope.user.rolesFeatures.roles){
            angular.forEach(scope.user.rolesFeatures.roles, function(value, index){
                if(value.roleId === id){
                    result = true;
                }
            });
        }
        return result;
    };

    scope.collapsedHorizonta = function () {
        scope.isCollapsedHorizontal = !scope.isCollapsedHorizontal;
    };
    scope.txtSearchDc = '';
    scope.clearSearch = function () {
        scope.search.CorporateSelected = '';
        scope.search.entityRelationSelected = '';
        scope.btnAddNewPackageShow = false;
        scope.CorporatePackages = [];
        scope.addPackageTab = false;
        scope.dcmappingTab = false;
    };

    scope.isCorpData = false;
    scope.filterDc = function (value) {
        if (value) {
            scope.diagnosticCentres = filterFilter(UserService.diagnosticCentresData, { 'entityName': value });
        } else {
            scope.diagnosticCentres = UserService.diagnosticCentresData;
        }
    };
    scope.managerLogin = false;
    angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
        if (v.roleId == 9204) {
            scope.managerLogin = true;
        }
    })
    scope.selectAll = function (groupType, selected) {
        scope.propvalue = 0;
        var flg = '';
        var flg = $('#btn' + groupType).prop('checked');
        if (selected) {
            $(scope.allInvestigationsGrouped[groupType]).each(function () {
                this.selected = true;
            })
            scope.propvalue = scope.allInvestigationsGrouped[groupType].length;
        }
        else {
            $('.' + groupType).each(function () {
                this.checked = false;
            });
            scope.propvalue = 0;

            $(scope.allInvestigationsGrouped[groupType]).each(function () {
                this.selected = false;
            })
        }
        scope.selectedItems[groupType] = scope.propvalue;
    };
    scope.loadAllInvestigations = function (packagedata) {
        if (packagedata !== null) {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'DCInvestigations', {}, 'GET').then(function (response) {
                scope.allInvestigations = response.data;
                scope.allInvestigations = filterFilter(scope.allInvestigations, { 'isActive': true });
                var arr;
                if (packagedata === undefined) {
                    scope.selectedPackage = {};
                    scope.selectedPackage.allowedInvestigations = {
                        duplicateCheck: false,
                        groupId: 0,
                        id: 51699,
                        isActive: false,
                        name: 'Doctor visit',
                        quantity: 0
                    };
                    arr = $.map(scope.selectedPackage.allowedInvestigations, function (item) { return item.id });
                }
                else {
                    if (packagedata && packagedata.allowedInvestigations) {
                        arr = $.map(packagedata.allowedInvestigations, function (item) { return item.id });
                    }
                }
                if (arr) {
                    $.each(scope.allInvestigations, function (index, val) {
                        if (arr.indexOf(val.id) !== -1) {
                            val.selected = true;
                        }
                        else {
                            val.selected = false;
                        }
                    });
                }
                scope.allInvestigationsGrouped = UtilitiesService.getInvestigationByGroup(scope.allInvestigations);
                scope.keys = Object.keys(scope.allInvestigationsGrouped);
                for (var i = 0; i < scope.keys.length; i++) {
                    scope.keys[i].toString();
                }
                scope.editPackageTabMethod.countChecked(scope.allInvestigationsGrouped);
            });
        }
    };
    scope.clearData = function () {
        scope.addNewPackage.CorporateSelected = '';
        scope.addNewPackage.entityRelationSelected = '';
    };

    // GET Corporate data
    scope.getCorporate = function (selectedContract) {
        scope.btnAddNewPackageShow = false;
        scope.search.CorporateSelected = '';
        scope.addNewPackage.CorporateSelected = '';
        scope.addPackageTab = false;
        scope.packageType = '';
        scope.isDefault = false;
        scope.isCorpData = false;
        scope.dcmappingTab = false;
        scope.packageDetailsPanel = false;
        scope.emptyPackagePanel = false;
        scope.CorporatePackages = [];
        scope.entityRelationSelected = selectedContract;
        if (selectedContract) {
            scope.isMahsDC = (selectedContract.id == 5290);
            if (scope.entityRelationSelected !== null) {
                switch (scope.entityRelationSelected.entityName) {
                    case 'Annual Health Check':
                        scope.packageType = 'AHCPackages';
                        break;
                    case 'Pre-Employment':
                        scope.packageType = 'PreEmploymentPackages';
                        break;
                    case 'E_SALES':
                        scope.packageType = 'PrePolicyPackages';
                        break;
                    case 'Pre-Policy':
                        scope.packageType = 'PrePolicyPackages';
                        break;
                    default:
                        scope.packageType = 'AHCPackages';
                        scope.isDefault = true;
                        break;
                }
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/EntityRelationcache/Search/' + scope.entityRelationSelected.id + '.json', {}, 'GET').then(function (response) {
                    scope.btnAddPackageShow = false;
                    scope.Corporate = response.data;
                })
            }
        } else {
            scope.Corporate = [];
        }
    };

    //Called When corporate changes
    scope.corporateChange = function () {
        scope.btnAddNewPackageShow = false;
        scope.addPackageTab = false;
        scope.dcmappingTab = false;
        scope.packageListPanel = false;
        scope.showUserMessage = false;
        scope.isCorpData = false;
    };

    //GET Corporate Packages List
    scope.getCorporatePackages = function (CorporateSelected) {
        scope.CorporateSelected = CorporateSelected;
        scope.addPackageTab = false;
        scope.emptyPackagePanel = false;
        scope.isCorpData = false;
        scope.dcmappingTab = false;
        scope.packageDetailsPanel = false;
        scope.status.isFirstOpen = false;
        if (scope.CorporateSelected) {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/SearchMappedPackages/' + scope.CorporateSelected.id, {}, 'GET').then(function (response) {
                if (response.data.length > 0) {
                    scope.isCorpData = true;
                    window.scrollTo(0, 0);
                    $('#myTab a[data-target="#corporate"]').tab('show');
                    scope.CorporatePackages = response.data;
                }
                else {
                    scope.isCorpData = false;
                    scope.CorporatePackages = [];
                }
            })
        }
    };

    //Get AllPackages
    scope.getAllPackages = function () {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + scope.packageType, {}, 'GET').then(function (response) {
            scope.allPackages = response.data;
            scope.allPackages = orderByFilter(scope.allPackages, 'name', false);
        },
        function (error) {
            window.scrollTo(0, 0);
            scope.showUserMessage = true;
            scope.addClass = 'alert alert-danger';
            scope.usermessage = error.data.responseStatus.message;
            // console.log(error.data.responseStatus.message)
        })
    };

    scope.btnAddNewPAckage = function (value) {
        if (value && value.entityRelationSelected && value.CorporateSelected && value.CorporateSelected.id) {
            scope.CorporateSelected = value.CorporateSelected;
            scope.addNewPackage.CorporateSelected = '';
            scope.addNewPackage.entityRelationSelected = '';
            $('#addNewPackage').modal('hide');
            scope.packageDetails();
            if (!scope.isDefault) {
            }
            scope.allPackages = [];
            scope.status.isFirstOpen = false;
            scope.dcmappingTab = false;
            scope.tabName = 'Add new package';
            scope.isMessageFlag = false;
            scope.flag = 1;
            scope.newCorpPackage = {};
            scope.newCorpPackage.krishiKalyanCess = 0.00;
            scope.newCorpPackage.swachhBharatCess = 0.00;
            $('.selectedinvestigations input[type=checkbox]:checked').each(function () {
                $(this).attr('checked', false);
            })
            scope.packageDetailsPanel = false;
            scope.emptyPackagePanel = true;
            scope.isCorpData = false;
            scope.newCorpPackage.serviceTax = 18;
            scope.newCorpPackage.primaryCessTax = 0;
            scope.newCorpPackage.secondaryCessTax = 0;
            scope.newCorpPackage.mahsCoOrdinationCharges = 0;
        }
    };
    scope.packageDetails = function (selectedPackage) {
        scope.isFinance = scope.acessValidation(9205);
        scope.current = { stateSelected: '' };
        scope.cities = [];
        scope.locations = [];
        scope.diagnosticCentres = [];
        scope.newCorpPackage = selectedPackage;
        scope.isMessageFlag = false;
        scope.showEditInvestigation = true;
        scope.addPackageTab = true;
        scope.tabName = 'Edit package';
        $('#myTab a[data-target="#addpackage"]').tab('show');
        scope.emptyPackagePanel = false;
        scope.packageDetailsPanel = true;
        scope.flag = selectedPackage ? 0 : 1;
        scope.dcmappingTab = true;
        scope.editPackageTabMethod.getPackageTestDetails();
        scope.selectedCorpPackage = selectedPackage;
    };

    scope.tabAddPackage = function () {
        scope.isMessageFlag = false;
        scope.showEditInvestigation = false;
    };
    scope.editPackageTabMethod = (function () {
        return {
            selectAll: function (groupType, event, indexValue) {
                scope.propvalue = 0;
                if (!groupType.checked) {
                    scope.keys[indexValue].selectedItems = scope.keys[indexValue].data.length;
                    angular.forEach(scope.keys[indexValue].data, function (val, index) {
                        scope.keys[indexValue].data[index].selected = true;
                    });
                }
                else {
                    scope.keys[indexValue].selectedItems = 0;
                    angular.forEach(scope.keys[indexValue].data, function (val, index) {
                        scope.keys[indexValue].data[index].selected = false;
                    });
                    angular.forEach(scope.allInvestigationsGrouped[groupType.name], function (value, index) {
                        scope.allInvestigationsGrouped[groupType.name].selected = false;
                    });
                }
                scope.selectedItems[groupType] = scope.propvalue;
                event.stopPropagation();
            },
            countChecked: function () {
                scope.selectedItems = {};
                if (scope.allInvestigationsGrouped) {
                    $.each(scope.allInvestigationsGrouped, function (index, val) {
                        scope.propvalue = 0;
                        $.each(val, function (i, v) {
                            if (v.selected) {
                                scope.propvalue = scope.propvalue + 1;
                                scope.selectedItems[index] = scope.propvalue;
                            }
                            else {
                                scope.propvalue = scope.propvalue + 0;
                                scope.selectedItems[index] = scope.propvalue;
                            }
                        })
                    });
                }
            },
            saveNewCorpPackage: function () {
                scope.updatedInvestigationList = [];
                $('.selectedinvestigations input[name=checkAll]:checked').each(function (index, data) {
                    var invst = {
                        id: $(this).data('id'),
                        name: $(this).data('value'),
                        description: $(this).data('description'),
                        isActive: $(this).data('isactive'),
                        quantity: $(this).data('quantity'),

                    }
                    scope.updatedInvestigationList.push(invst);
                });
                var uniqueList = _.uniq(scope.updatedInvestigationList, function (item, key, id) {
                    return item.id;
                });
                scope.updatedInvestigationList = uniqueList;
                if (scope.flag === 1) {
                    var url = UtilitiesService.getPlusUrlPrefix() + scope.packageType;
                    var type = 'POST';
                }
                else {
                    var url = UtilitiesService.getPlusUrlPrefix() + scope.packageType + '/' + scope.newCorpPackage.pM_ID;
                    var type = 'PUT';
                }
                var data = {
                    id: scope.newCorpPackage.id,
                    name: scope.newCorpPackage.pM_AliasName,
                    description: scope.newCorpPackage.description,
                    shortName: scope.newCorpPackage.shortName,
                    allowedInvestigations: scope.updatedInvestigationList,
                    isActive: scope.newCorpPackage.isActive,
                    isFinanceApproved: scope.newCorpPackage.financialApproval
                };
                if (data != null) {
                    UserService.makeRestCall(url, data, type, UserService.getAccessToken()).then(function (response) {
                        var resData = response.data;
                        var innerUrl;
                        var innerType;
                        var innerData;
                        scope.isMessageFlag = true;
                        scope.addClass = 'alert alert-success';
                        scope.usermessage = 'Investigatins Successfully Mapped';
                        if (scope.flag == 0) {
                            innerUrl = UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/' + scope.newCorpPackage.id;
                            innerType = 'PUT';
                            innerData = scope.newCorpPackage;
                        }
                        else {
                            innerUrl = UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation';
                            innerType = 'POST';
                            innerData = {
                                eR_Id: scope.CorporateSelected ? scope.CorporateSelected.id : '',
                                isActive: resData.isActive,
                                pM_ID: resData.id,
                                pM_Name: resData.name,
                                pM_AliasName: resData.name,
                                pM_TypeId: 0,
                                minAge: scope.newCorpPackage.minAge,
                                maxAge: scope.newCorpPackage.maxAge,
                                minService: scope.newCorpPackage.minService,
                                maxService: scope.newCorpPackage.maxService,
                                gender: scope.newCorpPackage.gender,
                                years: scope.newCorpPackage.years,
                                serviceTax: scope.newCorpPackage.serviceTax,
                                corporateRate: scope.newCorpPackage.corporateRate,
                                isSponsered: scope.newCorpPackage.isSponsered,
                                primaryCessTax: scope.newCorpPackage.primaryCessTax,
                                secondaryCessTax: scope.newCorpPackage.secondaryCessTax,
                                mahsCoOrdinationCharges: scope.newCorpPackage.mahsCoOrdinationCharges,
                                swachhBharatCess: scope.newCorpPackage.swachhBharatCess,
                                krishiKalyanCess: scope.newCorpPackage.krishiKalyanCess
                            }
                        }
                        if (scope.isMahsDC) {
                            innerData.MAHSRate = scope.newCorpPackage.mahsRate;
                            innerData.ImageLink = scope.newCorpPackage.imgLink;
                        }
                        UserService.makeRestCall(innerUrl, innerData, innerType, UserService.getAccessToken()).then(function (response) {
                            scope.getCorporatePackages(response.data);
                            window.scrollTo(0, 0);
                            scope.isMessageFlag = true;
                            scope.addClass = 'alert alert-success';
                            scope.usermessage = 'Package successfully mapped to corporate.';
                            $('.pull-left:checked').each(function () {
                                $(this).prop('checked', false);
                            });
                        },
                        function (error) {
                            window.scrollTo(0, 0);
                            scope.isMessageFlag = true;
                            scope.addClass = 'alert alert-danger';
                            scope.usermessage = 'Something went wrong, please try again.';
                        })
                    },
                    function (error) {
                        window.scrollTo(0, 0);
                        scope.isMessageFlag = true;
                        scope.addClass = 'alert alert-danger';
                        scope.usermessage = 'Something went wrong, please try again.';
                    })
                }
                else {
                    UtilitiesService.showAlertMessage('Something went wrong with package id.');
                }
            },
            saveCorpPackage: function () {
                if (scope.flag == 0) {
                    var url = UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/' + scope.selectedCorpPackage.id;
                    var type = 'PUT';
                    var data = scope.selectedCorpPackage;
                }
                else {
                    var url = UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation';
                    var type = 'POST';
                    var data = scope.selectedCorpPackage;
                }
                UserService.makeRestCall(url, data, type, UserService.getAccessToken()).then(function (response) {
                    scope.showUpdatePackage = false;
                    scope.showCorpPackage = true;
                    window.scrollTo(0, 0);
                    scope.submitUserMessage = true;
                    scope.addClass = 'alert alert-success';
                    scope.usermessage = 'Package Saved';
                    scope.getCorporatePackages();
                },
                function (error) {
                    window.scrollTo(0, 0);
                    scope.submitUserMessage = true;
                    scope.addClass = 'alert alert-danger';
                    scope.usermessage = 'Something went wrong, please try again.';
                    // console.log(error.data.responseStatus.message)
                })
            },
            getPackageTestDetails: function () {
                scope.investigationList = [];
                scope.errorMsz = '';
                scope.showEditInvestigation = false;
                if (scope.newCorpPackage) {
                    scope.packageId = scope.newCorpPackage.peR_Id ? scope.newCorpPackage.peR_Id : '';
                    var packageId = scope.newCorpPackage.peR_Id ? scope.newCorpPackage.peR_Id : '';
                }
                if (packageId) {
                    var url = UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/' + packageId;
                    UserService.makeRestCall(url, '', 'GET', UserService.getAccessToken()).then(function (response) {
                        if (response.data) {
                            var investigation = response.data.allowedInvestigations;
                            var investigationGroup = [];
                            angular.forEach(investigation, function (v, i) {
                                investigationGroup.push(v.groupName);
                            })
                            var listOfUniqeInvestigations = investigationGroup.filter(function (val, index, allArr) {
                                return index == allArr.indexOf(val);
                            })
                            scope.investigationList = [];
                            angular.forEach(listOfUniqeInvestigations, function (val, ind) {
                                var investigationWiseTests = filterFilter(investigation, val);
                                var testObj = investigationWiseTests;
                                scope.testDetails = [];
                                angular.forEach(testObj, function (v, i) {
                                    scope.testDetails.push({
                                        groupName: v.groupName,
                                        testName: v.name,
                                        testId: v.id,
                                        groupId: v.groupId,
                                        isActive: v.isActive,
                                        duplicateCheck: v.duplicateCheck,
                                        quantity: v.quantity
                                    })
                                })
                                scope.investigationList.push({
                                    investigationName: val,
                                    testDetails: scope.testDetails
                                })
                            });
                            //scope.editInvestigation();
                        } else {
                            scope.errorMsz = 'No Test Found';
                        }
                    })
                }
                else {
                    scope.errorMsz = 'Select a package to get details.';
                }
            }
        }
    })();

    scope.searchDc = false;
    scope.dcMappingTabMethod = (function () {
        return {
            tabMapDC: function () {
                scope.dcSearch.stateSelected = '';
                scope.dcSearch.citySelected = '';
                scope.dcSearch.locationSelected = '';
                scope.dcSearch.location = '';
                scope.mappedDCs = {};
                scope.searchDc = false;
                scope.diagnosticCentres = [];
                scope.dcMappingTabMethod.getMappedDCsForLocation();
                scope.saveMappedDCsShow = false;
            },
            getMappedDCsForLocation: function () {
                scope.showDCMapUserMessage = false;
                if (scope.selectedCorpPackage && scope.selectedCorpPackage.pM_ID) {
                    UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/GetEligibleDCsForPackage/' + scope.selectedCorpPackage.pM_ID, {}, 'GET').then(function (response) {
                        scope.mappedDcList = {};
                        scope.mappedDcListTemp = {};
                        if (response.data.length > 0) {
                            scope.showDropdown = true;
                            scope.showDCMapUserMessage = false;
                            scope.mappedDcListTemp = response.data;
                            scope.dcMappingTabMethod.getMappedDCsForPackage();
                        }
                        else {
                            scope.showDropdown = false;
                            scope.saveMappedDCsShow = false;
                            scope.mappedDcList = {};
                            scope.mappedDcListTemp = {};
                            window.scrollTo(0, 0);
                            scope.showDCMapUserMessage = true;
                            scope.addClass = 'alert alert-info';
                            scope.usermessage = 'No Eligible DCs for this package found.';
                        }
                    },
                    function (error) {
                        scope.showDropdown = false;
                        scope.saveMappedDCsShow = false;
                        window.scrollTo(0, 0);
                        scope.showDCMapUserMessage = true;
                        scope.addClass = 'alert alert-danger';
                        scope.usermessage = 'Please Select a package to see corresponding mapped DCs';
                    })
                }
            },
            getMappedDCsForPackage: function () {
                scope.mappedDcListForPackage = {};
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'CorporatePackageProvider/' + scope.selectedCorpPackage.id + '/true', {}, 'GET').then(function (response) {
                    scope.showDCMapUserMessage = false;
                    scope.mappedDcListForPackage = response.data;
                },
                function (error) {
                    window.scrollTo(0, 0);
                    scope.showDCMapUserMessage = true;
                    scope.addClass = 'alert alert-danger';
                    scope.usermessage = 'Something went wrong, please try again.';
                })
            },
            loadStates: function () {
                scope.diagnosticCentres = {};
                scope.btnMappedInvestigationsShow = false;
                scope.btnDcDetailsShow = false;
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + 'masterdata/lookup/state', '', 'GET').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.states = response.data.lookUpData;
                    }
                });
            },
            loadCities: function (stateId) {
                if (stateId !== undefined) {
                    scope.searchDc = true;
                    scope.dcSearch.citySelected = '';
                    scope.dcSearch.locations = '';
                    scope.dcMappingTabMethod.loadDCs(stateId, 0, 0);
                    scope.btnMappedInvestigationsShow = false;
                    scope.btnDcDetailsShow = false;
                }
            },
            loadLocations: function (cityId) {
                if (cityId !== undefined) {
                    var cityId = cityId;
                    var matchedDc = [];
                    var dcByCity = scope.responceDiagnosticCentres;
                    angular.forEach(dcByCity, function (val) {
                        if (val.city.cityId == cityId) {
                            matchedDc.push(val);
                        }
                    })
                    scope.dcMappingTabMethod.mappedPackageDc(matchedDc);
                    var locationList = [];
                    angular.forEach(scope.diagnosticCentres, function (v, i) {
                        if (cityId == v.cityId) {
                            var locList = {
                                lookUpId: v.locationId,
                                lookUpValue: v.locationName
                            }
                            locationList.push(locList);
                        };
                    })
                    scope.locations = [];
                    var unique = {};
                    angular.forEach(locationList, function (item) {
                        if (!unique[item.lookUpId]) {
                            scope.locations.push(item);
                            unique[item.lookUpId] = item;
                        }
                    });
                    scope.locations = orderByFilter(scope.locations, 'lookUpValue', false);
                }
            },
            loadDCs: function (stateId, cityId, locationId) {
                scope.showDCMapUserMessage = false;
                var recivedLoc = (stateId ? stateId : (cityId ? cityId : (locationId ? locationId : '')));
                if (recivedLoc !== '') {
                    scope.mappedDcList = {};
                    scope.dcObj = [];
                    scope.diagnosticCentres = [];
                    scope.originalMappedArrayForLocation = [];
                    UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'EntityRelation/Search/EntitySearch/' + ERTypeId + '/' + serviceBrokerId + '/' + 0 + '/' + stateId + '/' + cityId + '/' + locationId + '/0', '', 'GET').then(function (response) {
                        if (response.data.length > 0) {
                            scope.saveMappedDCsShow = true;
                            scope.diagnosticCentres = response.data;
                            UserService.diagnosticCentresData = response.data;
                            scope.responceDiagnosticCentres = scope.diagnosticCentres;
                            var citiList = [];
                            angular.forEach(scope.diagnosticCentres, function (val, ind) {
                                scope.diagnosticCentres[ind].isFinance = scope.isFinance;
                                var cityList = {
                                    lookUpId: val.city.cityId,
                                    lookUpValue: val.city.cityName,
                                    dc: val
                                }
                                citiList.push(cityList);
                            })
                            scope.cities = [];
                            scope.availableCityDc = [];
                            var unique = {};
                            angular.forEach(citiList, function (item) {
                                if (!unique[item.lookUpId]) {
                                    scope.cities.push(item);
                                    unique[item.lookUpId] = item;
                                }
                            });
                            scope.cities = orderByFilter(scope.cities, 'lookUpValue', false);
                            scope.dcMappingTabMethod.mappedPackageDc(scope.diagnosticCentres);
                        }
                        else {
                            scope.saveMappedDCsShow = false;
                            scope.mappedDcList = {};
                            scope.dcObj = [];
                            window.scrollTo(0, 0);
                            scope.showDCMapUserMessage = true;
                            scope.addClass = 'alert alert-danger';
                            scope.usermessage = 'No data found';
                        }
                    },
                    function (error) {
                        scope.saveMappedDCsShow = false;
                        scope.mappedDcList = {};
                        scope.dcObj = [];
                        window.scrollTo(0, 0);
                        scope.showDCMapUserMessage = true;
                        scope.addClass = 'alert alert-danger';
                        scope.usermessage = 'Something went wrong, please try again.';
                    })
                }
            },
            saveCheckedMapDC: function (getChekedVal, isChecked) {
                var selectedDC = getChekedVal;
                var saveMappedDCs = {};
                var dcObj = {};
                saveMappedDCs.peR_Id = scope.selectedCorpPackage.id;
                saveMappedDCs.isActive = isChecked,
                saveMappedDCs.providerEntities = [];
                scope.ajaxData = {};
                ajaxData = {
                    peR_Id: scope.selectedCorpPackage.id,
                    isActive: saveMappedDCs.isActive,
                    lstPackageDetail: [
                        {
                            eR_ID: selectedDC.id,
                            pM_ID: scope.selectedCorpPackage.pM_ID,
                            packageName: scope.selectedCorpPackage.pM_Name,
                            startDate: selectedDC.startDate,
                            endDate: selectedDC.endDate,
                            //serviceTax: selectedDC.serviceTax,
                            dcRate: selectedDC.dcRate,
                            dcWiseCorporatePrice: selectedDC.dcWiseCorporatePrice,
                            primaryCessTax: selectedDC.primaryCessTax,
                            secondaryCessTax: selectedDC.secondaryCessTax,
                            //mahsRate: selectedDC.mahsRateForDC ? selectedDC.mahsRateForDC : 0,
                            providerWorkingSlots: [
                                {
                                    dayOfWeek: 'Sunday',
                                    slots: [
                                        {
                                            'slotStartTime': 0,
                                            'slotEndTime': 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
                saveMappedDCs.providerEntities.push(dcObj);
                var data = saveMappedDCs;
                UtilitiesService.makeAjaxCalls(UtilitiesService.getPlusUrlPrefix() + '/savePackageProviderDetails', ajaxData, 'POST', UserService.getAccessToken()).then(function (response) {

                    scope.dcSearch.stateSelected = '';
                    scope.cities = [];
                    scope.getMappedDCsForLocation();

                    window.scrollTo(0, 0);
                    scope.showDCMapUserMessage = true;
                    scope.addClass = 'alert alert-success';
                    scope.usermessage = 'Success Data Updated';
                },
                function (error) {
                    window.scrollTo(0, 0);
                    scope.showDCMapUserMessage = true;
                    scope.addClass = 'alert alert-danger';
                    scope.usermessage = 'Something went wrong, please try again.';
                })
            },
            loadDcByLoction: function (locId) {
                var dcByCity = scope.responceDiagnosticCentres;
                var matchedDcbyLoc = [];
                if (locId !== undefined) {
                    angular.forEach(dcByCity, function (val) {
                        if (val.location && val.location.locID && val.location.locID == locId) {
                            matchedDcbyLoc.push(val);
                        }
                    })
                    scope.dcMappingTabMethod.mappedPackageDc(matchedDcbyLoc);
                }
            },
            //method for mapping DC for corresponding location selected with that package
            mappedPackageDc: function (diagnosticCentres) {
                if (diagnosticCentres) {
                    scope.diagnosticCentres = {};
                    scope.diagnosticCentres = diagnosticCentres;
                    UserService.diagnosticCentresData = scope.diagnosticCentres;
                }
                //mapping DC for corresponding location selected with that package
                scope.dcObj = [];
                scope.originalMappedArrayForLocation = [];
                $(scope.diagnosticCentres).each(function (i, v) {
                    if (scope.mappedDcListTemp.indexOf(v.id) !== -1) {
                        scope.dcObj.push(v);
                    }
                });
                //mapping dc list mapped to the packages to be displayed on UI
                var mappedDcListForPackageTemp = [];
                mappedDcListForPackageTemp = $.map(scope.mappedDcListForPackage.providerEntities, function (item) { return item.eR_ID });
                if (scope.dcObj.length !== 0) {
                    scope.mappedDcList = scope.dcObj;
                    scope.mappedDcListCount = scope.mappedDcList.length;
                    scope.noOfPages = scope.mappedDcListCount;
                    var index = '';
                    $(scope.mappedDcList).each(function (i, v) {
                        var index = mappedDcListForPackageTemp.indexOf(v.id);
                        
                        if (index !== -1) {
                            scope.originalMappedArrayForLocation.push(v.id)
                            v.toBeSelected = true;
                            v.primaryCessTax = scope.mappedDcListForPackage.providerEntities[index].primaryCessTax;
                            v.isFinanceApproved = scope.mappedDcListForPackage.providerEntities[index].isFinanceApproved;
                            v.secondaryCessTax = scope.mappedDcListForPackage.providerEntities[index].secondaryCessTax;
                            v.dcRate = scope.mappedDcListForPackage.providerEntities[index].dcRate;
                            v.dcWiseCorporatePrice = scope.mappedDcListForPackage.providerEntities[index].dcWiseCorporatePrice;
                            v.startDate = scope.compareDate(scope.mappedDcListForPackage.providerEntities[index].startDate);
                            v.endDate = scope.compareDate(scope.mappedDcListForPackage.providerEntities[index].endDate);
                        }
                        else {
                            v.toBeSelected = false;
                            v.primaryCessTax = 0;
                            v.secondaryCessTax = 0;
                            v.serviceTax = 0;
                            v.dcWiseCorporatePrice = 0.00;
                            v.dcRate = 0.00;
                            v.isFinanceApproved = false;
                            v.startDate = scope.compareDate('/Date(253402194600000-0000)/');
                            v.endDate = scope.compareDate('/Date(253402194600000-0000)/');
                        }
                    })
                    //angular.forEach()
                }
            }
        }
    })();

    scope.reload = function () {
        scope.dcSearch.stateSelected = '';
        scope.dcSearch.citySelected = '';
        scope.dcSearch.location = '';
        $("#state option[value='']").attr("selected", "selected");
        $("#city option[value='']").attr("selected", "selected");
        $("#state option[value='']").attr("selected", "selected");
        scope.mappedDCs = {};
        scope.dcMappingTabMethod.getMappedDCsForLocation();
        scope.saveMappedDCsShow = false;
        scope.mappedDcList = {};
    };

    scope.downloadExcel = function () {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'PackageEntityRelation/GetEligibleDCsForPackageExcel/' + scope.selectedCorpPackage.pM_ID + '/' + scope.selectedCorpPackage.id, '', 'GET', UserService.getAccessToken(), true).then(function (response) {
            var element = $('<a/>');
            element.attr({
                href: 'data:attachment/csv;charset=utf-8,' + encodeURI(response.data),
                target: '_blank',
                download: 'PackageDC.xls'
            })[0].click();
        });
    };

    scope.InOutTime = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "15", "16", "17", "18", "19", "20", "21", "22", "23"];
    scope.InOutTimeQuater = ["00", "15", "30", "45"];
    scope.daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    scope.timmingsOfWeek = [];
    scope.daysOfWeek.map(function (day) {
        var temp = {
            dayName: day,
            timeSlots: []
        }
        scope.timmingsOfWeek.push(temp);
    });

    scope.doctors = [
        { "docName": "doctor1", "docId": "01" },
        { "docName": "doctor2", "docId": "02" },
        { "docName": "doctor3", "docId": "03" },
        { "docName": "doctor4", "docId": "04" },
        { "docName": "doctor5", "docId": "05" }
    ];
    scope.docCollection = [];

    scope.getDoc = function () {
        scope.docCollection = [];
        scope.doctors.forEach(function (e) {
            var times = [];
            scope.daysOfWeek.map(function (el) {
                var t = {
                    dayName: el,
                    timeSlots: []
                };
                times.push(t);
            });
            var temp = {
                docName: e.docName,
                docId: e.docId,
                timmingsOfWeek: times
            };
            scope.docCollection.push(temp);
        });
    };

    scope.doctorsMethods = (function () {
        return {
            addTime: function (day, startTimeHrs, startTimeMins, endTimeHrs, endTimeMins, item) {
                var pickDay = item.timmingsOfWeek.filter(function (ele) {
                    return ele.dayName == day;
                })[0];
                if (pickDay.timeSlots) {
                    pickDay.timeSlots.push({
                        startTimeHrs: startTimeHrs,
                        startTimeMins: startTimeMins,
                        endTimeHrs: endTimeHrs,
                        endTimeMins: endTimeMins
                    });
                }
                scope.docWiseTime = scope.docCollection;
                //console.log(scope.docWiseTime);
            },
            removeTime: function (day, index, item) {
                var pickDay = item.timmingsOfWeek.filter(function (ele) {
                    return ele.dayName == day;
                })[0];
                pickDay.timeSlots.splice(index, 1);
            },
            copyTime: function (day, item) {
                var ts = item.timmingsOfWeek.filter(function (ele) {
                    return ele.dayName == day;
                })[0].timeSlots;
                item.timmingsOfWeek.map(function (ele) {
                    ele.timeSlots = [];
                    ts.map(function (el) {
                        ele.timeSlots.push({
                            startTimeHrs: el.startTimeHrs,
                            startTimeMins: el.startTimeMins,
                            endTimeHrs: el.endTimeHrs,
                            endTimeMins: el.endTimeMins
                        });
                    });
                });
            },
            clearTime: function () {
                scope.timmingsOfWeek.map(function (ele) {
                    ele.timeSlots = [];
                });
            },
            saveDayTimeOfDoctor: function () {
                scope.docDetailsCollection = scope.docWiseTime;
                scope.storeDoctorDetails = [];
                scope.storeDocTime = [];
                scope.storOnlyTime = [];
                scope.docDetailsCollection.map(function (val) {
                    scope.storeDocTime = [];
                    scope.storeDoctorDetails.push({
                        doctorId: val.docId,
                        docName: val.docName,
                        providerPackageId: 0,
                        lstAllSlots: scope.storeDocTime
                    })
                    scope.timmingsOfWeek = [];
                    scope.timmingsOfWeek = val.timmingsOfWeek;
                    scope.timmingsOfWeek.map(function (d) {
                        scope.storOnlyTime = [];
                        scope.weekDays = {
                            dayOfWeek: d.dayName,
                            slots: scope.storOnlyTime
                        }
                        scope.storeDocTime.push(scope.weekDays);
                        scope.timeSlots = [];
                        scope.timeSlots = d.timeSlots;
                        scope.timeSlots.map(function (t) {
                            scope.dayTimeSlots = {
                                slotStartTime: t.startTimeHrs + ':' + t.startTimeMins,
                                slotEndTime: t.endTimeHrs + ':' + t.endTimeMins
                            }
                            scope.storOnlyTime.push(scope.dayTimeSlots);
                        })
                    })
                })
                // console.log(scope.storeDoctorDetails);
                var data = saveMappedDCs;
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/ProviderDoctorSlotDetails', ajaxData, 'POST', UserService.getAccessToken()).then(function (response) {
                    if (response.isSuccess) {
                    }
                })
            }
        };
    })();

    scope.roleCheck = filterFilter(UserService.getUserObj().rolesFeatures.roles, { 'roleId': 9202 }).length > 0;
    scope.toggle = true;
    scope.toggleText = 'Copy DC';
    scope.copyPasteToggle = function (toggleValue) {
        scope.toggle = toggleValue;
        scope.toggleText = scope.toggle ? 'Copy DC' : 'Paste DC';
        if (scope.selectedCorpPackage.id) {
            if (scope.toggleText == 'Copy DC') {
                scope.destinationPerId = scope.selectedCorpPackage.id;
                var ajaxData = {
                    SorucePERID: scope.SorucePerID,
                    TargetPERID: [scope.destinationPerId]
                }
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'CorporatePackageDCMapping', ajaxData, 'POST', UserService.getAccessToken()).then(function (response) {
                    if (response.data) {
                        UtilitiesService.showAlertMessage('Mapped successfully.', true);
                    }
                    else {
                        UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
                    }
                });
            }
        }
        if (scope.toggleText == 'Paste DC') {
            scope.SorucePerID = scope.selectedCorpPackage.id;
        }
    }

    scope.editInvestigation = function () {
        scope.showEditInvestigation = true;
        if (scope.newCorpPackage) {
            scope.loadAllInvestigations(scope.newCorpPackage);
        }
        else {
            UtilitiesService.showAlertMessage('Choose package.');
        }
    }
    scope.setEditInvestigation = function () {
        scope.showEditInvestigation = false
    }

    scope.saveCheckedMapDC = function (getSelectedVal, isChecked, source) {
        var selectedDC = getSelectedVal;
        var saveMappedDCs = {};
        var dcObj = {};
        saveMappedDCs.peR_Id = scope.selectedCorpPackage.id;
        saveMappedDCs.providerEntities = [];
        scope.ajaxData = {};
        if (source == 'checkbox') {
            scope.IsActiveData = isChecked;
        }
        if (source == 'updateBtn') {
            scope.IsActiveData = 1;
        }

        ajaxData = {
            peR_Id: scope.selectedCorpPackage.id,
            isActive: scope.IsActiveData,
            packageDetail: {
                eR_ID: selectedDC.id,
                pM_ID: scope.selectedCorpPackage.pM_ID,
                packageName: scope.selectedCorpPackage.pM_Name,
                startDate: selectedDC.startDate,
                endDate: selectedDC.endDate,
                serviceTax: selectedDC.serviceTax,
                dcRate: selectedDC.dcRate,
                dcWiseCorporatePrice: selectedDC.dcWiseCorporatePrice,
                primaryCessTax: selectedDC.primaryCessTax,
                secondaryCessTax: selectedDC.secondaryCessTax,
                isFinanceApproved: selectedDC.isFinanceApproved,
                providerWorkingSlots: [
                    {
                        dayOfWeek: 'Sunday',
                        slots: [
                            {
                                slotStartTime: 0,
                                slotEndTime: 0
                            }
                        ]
                    }
                ],
                attachFiles: {
                    FinancialDocuments: scope.attachFiles
                }
            }
        }

        saveMappedDCs.providerEntities.push(dcObj);
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/savePackageProviderDetails', ajaxData, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response) {
                scope.dcMappingTabMethod.getMappedDCsForLocation();

                window.scrollTo(0, 0);
                scope.showDCMapUserMessage = true;
                scope.addClass = 'alert alert-success';
                scope.usermessage = 'Success Data Updated';
            };

        },
        function (error) {
            window.scrollTo(0, 0);
            scope.showDCMapUserMessage = true;
            scope.addClass = 'alert alert-danger';
            scope.usermessage = error.data.responseStatus.message;
            // console.log(error.data.responseStatus.message)
        })
    }

    scope.mappedDcAllPackg = function (selectedDcMapping, mapping) {
        scope.isMapping = mapping;
        if (scope.isMapping == true) {
            selectedDcMapping.disabledMapDC = true;
        }
        else if (scope.isMapping == false) {
            selectedDcMapping.disabledUnMapDC = true;
        }
        var data = {
            CorporateERId: scope.CorporateSelected.id,
            dcName: selectedDcMapping.entityName,
            isActive: scope.isMapping,
            packageDetail: {
                eR_ID: selectedDcMapping.id,
                pM_ID: 0,
                packageName: scope.selectedCorpPackage.pM_Name,
                dcWiseCorporatePrice: selectedDcMapping.dcWiseCorporatePrice,
                startDate: selectedDcMapping.startDate,
                endDate: selectedDcMapping.endDate,
                serviceTax: selectedDcMapping.serviceTax,
                dcRate: selectedDcMapping.dcRate,
                primaryCessTax: selectedDcMapping.primaryCessTax,
                secondaryCessTax: selectedDcMapping.secondaryCessTax,
                providerWorkingSlots: [
                    {
                        dayOfWeek: 'Sunday',
                        slots: [
                            {
                                slotStartTime: 0,
                                slotEndTime: 0
                            }
                        ]
                    }
                ]
            }
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/saveAllPackageProviderDetails', data, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data) {
                if (scope.isMapping == true) {
                    UtilitiesService.showAlertMessage('Mapped successfully.', true);
                }
                if (scope.isMapping == false) {
                    UtilitiesService.showAlertMessage('Un-mapped successfully.', true);
                }
            }
            else {
                UtilitiesService.showAlertMessage('Maping/Un-mapping failed.');
            }
        })
    }

    scope.file = [];
    scope.addFileToUpload = function (flag) {
        var newItemNo = scope.file.length + 1;
        scope.file.push({
            'model': ''
        });
    };
    scope.removeFileToUpload = function (index) {
        scope.file.splice(index, 1);
    };

    scope.uploadDocMap = function (uploadedFileName) {
        scope.attachFiles = uploadedFileName;
    }

    scope.upload = function (callback) {
        var fileBlobArray = [];
        var filesUploadingArray = [];
        Object.keys(scope.file).forEach(function (ele) {
            if (typeof (scope.file[ele].model) == "object") {
                filesUploadingArray.push(scope.file[ele].model);
            }
        });
        if (filesUploadingArray.length > 0) {
            fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrlPrefix() + '/File'));
        }
        else {
            UtilitiesService.showAlertMessage('Please attach atleast one document.');
            return false;
        }

        $q.all(fileBlobArray).then(function (result) {
            scope.newlyUploadedDocs = [];
            $('#uploadDocModal').modal('hide');
            if (typeof result == "object" && typeof result[0].data == "object") {
                scope.uploadDocMap(result[0].data);
                for (var property in result[0].data) {
                    if (result[0].data.hasOwnProperty(property)) {
                        var obj = {};
                        obj.fileName = result[0].data[property];
                        obj.filePath = UtilitiesService.getDownloadURL(true) + property;
                        scope.newlyUploadedDocs.push(obj);
                    }
                }
                if (result && scope.newlyUploadedDocs && scope.newlyUploadedDocs.length > 0)
                    UtilitiesService.showAlertMessage('File upload successfully', true);

            }
            else {
                UtilitiesService.showAlertMessage('upload fail.');
                return false;
            }
        },
        function (error) {
            UtilitiesService.showAlertMessage('upload fail.');
        });
    };
    scope.clearFileModels = function (isShow) {
        if (!isShow)
            scope.newlyUploadedDocs = [];
        scope.file = [];
        scope.addFileToUpload();
    };

    scope.dcMappingTabMethod.loadStates();
}]);




angular.module('mbplus')
    .controller('dcDashboardCtrl', ['$rootScope', '$scope', '$location', '$window', '$http', 'UserService', '$state',
        'UtilitiesService', '$analytics', '$filter', '$timeout', '$sce',
        function (rootScope, scope, location, $window, http, UserService,
            state, UtilitiesService, analytics, filter, timeout, $sce) {
            analytics.pageTrack('/dcDashboard');
            scope.$root.title = 'DC Dashboard | Medibuddy Portal';
            // scope.isDC = false;
            scope.EntityId = null;
            scope.totalStatus = [];
            scope.currentSelectedStatus = null;
            scope.statusName = null;
            scope.impStatus = [];
            scope.totalCountStatus = 0;
            scope.statusDetails = [];
            scope.formatCurrency = UtilitiesService.formatCurrency;
            scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
            scope.format = scope.formats[0];
            scope.altInputFormats = ['M!/d!/yyyy'];
            scope.popup1 = {
                opened: false
            };
            scope.popup2 = {
                opened: false
            };
            scope.open1 = function () {
                scope.popup1.opened = true;
            };
            scope.open2 = function () {
                scope.popup2.opened = true;
            };
            scope.reportDownloadPopOver = {
                opened: false,
                selectedDate: new Date()
            };
            scope.openReportDownloadPopOver = function () {
                scope.reportDownloadPopOver.opened = true;
            };
            scope.filtere = {
                fromDate: '',
                toDate: ''
            };
            scope.resetDateValues = function () {
                scope.filtere.fromDate = '';
                scope.filtere.toDate = '';
                scope.reportDownloadPopOver.selectedDate = new Date();
            }

            if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() === 'insurer') {
                UserService.destroyUserObj();
                location.path('/');
                return false;
            }

            scope.reInitializeValues = function () {
                scope.totalStatus = [];
                scope.impStatus = [];
                scope.totalCountStatus = 0;
                scope.statusDetails = [];
                scope.currentSelectedStatus = null;
                scope.statusName = null;
            }
            // if (scope.user && scope.user.rolesFeatures && scope.user.rolesFeatures.roles) {
            //     angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
            //         if (v.roleId == 5432 || v.roleId == 5433 || v.roleId == 5434) {  
            //             scope.isDC = true;
            //         }
            //     });
            // }

            // get data for all status and their count
            scope.checkIfDcDashboard = function () {
                var dcRole = null;
                var result = false;
                if (scope.user && scope.user.rolesFeatures && scope.user.rolesFeatures.roles) {
                    dcRole = scope.user.rolesFeatures.roles.find(function (elem) {
                        return ((elem.roleName.substring(0, 2)) == 'DC')
                    })
                    result = dcRole ? true : false;
                    if (result && rootScope.toggleMenuObj && rootScope.toggleMenuObj.isMultiRole) {
                        return (rootScope.toggleMenuObj.isDcRoleActive ? true : false);
                    }
                    else {
                        return result;
                    }
                }
            }
            scope.getDashboardItems = function () {
                //debugger
                scope.reInitializeValues();
                scope.providerProfileState = null;
                scope.userDetails = null;
                // if (scope.user && scope.user.properties && scope.user.properties.EntityType === "DC") {
                if (scope.user && scope.user.properties && scope.checkIfDcDashboard()) {
                    if (scope.user && scope.user.entityId) {
                        scope.EntityId = scope.user.entityId;
                    }
                }

                var stDt, endDt;
                if (scope.EntityId) {
                    var fromDate = scope.filtere.fromDate ? moment(scope.filtere.fromDate).format('DD/MMM/YYYY') : null;
                    var toDate = scope.filtere.toDate ? moment(scope.filtere.toDate).format('DD/MMM/YYYY') : null;
                    var data = {
                        "entityId": scope.EntityId,
                        //"ERId": [UserService.getHospitalObj().entityRealtion ? (UserService.getHospitalObj().entityRealtion[0] ? UserService.getHospitalObj().entityRealtion[0].eR_ID : null) : ''],
                        "ERIds": [UserService.getHospitalObj().entityRealtion ? (UserService.getHospitalObj().entityRealtion[0] ? UserService.getHospitalObj().entityRealtion[0].eR_ID : null) : ''],
                        "StartDate": fromDate,
                        "EndDate": toDate,
                        "contractId": "",
                        "fetchByDate": ""
                    };
                    var claimsData = {
                        hospitalId: UserService.getHospitalObj().hospId,
                        startDateInclusive: scope.filtere.fromDate ? scope.filtere.fromDate : "",
                        endDateExclusive: scope.filtere.toDate ? scope.filtere.toDate : ""
                    }
                    UtilitiesService.startLoading('fetching dashboard data...', 'dcDashboardUI');
                    UserService.makeRestCall(UtilitiesService.getPlusUrl() + "Provider/DcDashboard", data, "POST", UserService.getAccessToken()).then(function (response) {

                        // UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/DcDashboardAppointments", data, "POST", UserService.getAccessToken()).then(function (response) {
                        // UserService.makeRestCall("http://localhost:63029/" + "/Provider/DcDashboard", data, "POST", UserService.getAccessToken()).then(function (response) {
                        // debugger
                        if (response.data && response.data.isSuccess) {
                            UtilitiesService.stopLoading('dcDashboardUI');
                            // if (response.data.statusWiseCount) {
                            //     debugger
                            //     // if (response.data.appointmentStatuswiseCount) {
                            //     // var resultArr = response.data.statusWiseCount.filter(function(elem){
                            //     //     return (elem.statusId == (22) || (40) || (32) || (37) || (48));
                            //     // })
                            //     // scope.totalStatus = resultArr;
                            //     // scope.totalStatus = response.data.appointmentStatuswiseCount;
                            //     scope.totalStatus = response.data.statusWiseCount;
                            //     $.each(scope.totalStatus, function (i, v) {
                            //         scope.impStatus.push(v);
                            //         scope.totalCountStatus += v.apptCount;
                            //     });
                            // };
                            if (response.data.appointmentStatuswiseCount) {
                                // debugger
                                scope.totalStatus = response.data.appointmentStatuswiseCount;
                                $.each(scope.totalStatus, function (i, v) {
                                    if(!v.toDate){
                                        v.toDate = new Date()
                                    }
                                    scope.impStatus.push(v);
                                    scope.totalCountStatus += v.apptCount;
                                });
                            };
                        } else {
                            UtilitiesService.showAlertMessage('No records found!', false);
                        }
                    });

                    // UtilitiesService.startLoading('fetching dashboard data...', 'dcDashboardUI');
                    // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/search/claimscount/", claimsData, "POST", true).then(function (response) {
                    //     UtilitiesService.stopLoading('dcDashboardUI');
                    //     if (response.data && response.data.isSuccess) {
                    //         scope.userDetails = response.data;
                    //         scope.totalRating = 0;
                    //         scope.rating = 0;
                    //         if (response.data.hospProfileCompletionRating) {
                    //             scope.totalRating = response.data.hospProfileCompletionRating.totalRating;
                    //             scope.rating = response.data.hospProfileCompletionRating.hospCurrentRating;
                    //         }
                    //         scope.totalAmount = response.data.settledClaimsAmount + response.data.reimbursementAppAmount;
                    //         scope.totalPercentage = (scope.rating / scope.totalRating) * 100;
                    //         scope.providerProfileState = response.data.hospProfileCompletionRating;
                    //     }
                    // })
                } else {
                    UtilitiesService.showAlertMessage('EntityId does not exist');
                }
            };

            scope.downloadDashBoardReport = function (statusId) {
                if (scope.EntityId) {
                    var fromDate = scope.filtere.fromDate ? moment(scope.filtere.fromDate).format('DD/MMM/YYYY') : null;
                    var toDate = scope.filtere.toDate ? moment(scope.filtere.toDate).format('DD/MMM/YYYY') : null;
                    var selectedMonth, selectedYear = null;
                    // If Date is selected consider the selected Month and Year Else set it to current
                    if (scope.reportDownloadPopOver.selectedDate) {
                        selectedMonth = scope.reportDownloadPopOver.selectedDate.getMonth() + 1;
                        selectedYear = scope.reportDownloadPopOver.selectedDate.getFullYear();
                    } else {
                        selectedMonth = new Date().getMonth() + 1;
                        selectedYear = new Date().getFullYear();
                    }

                    var data = {
                        "entityId": scope.EntityId,
                        "ERId": [UserService.getHospitalObj().entityRealtion ? (UserService.getHospitalObj().entityRealtion[0] ? UserService.getHospitalObj().entityRealtion[0].eR_ID : null) : ''],
                        "StartDate": fromDate,
                        "EndDate": toDate,
                        "StatusId": statusId,
                        "SelectedMonth": selectedMonth,
                        "SelectedYear": selectedYear
                    };
                    UtilitiesService.startLoading('fetching dashboard data...', 'dcDashboardUI');
                    var responseContentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                    UserService.viewFile(UtilitiesService.getPlusUrl() + "/Provider/DownloadClaimDetails", data, responseContentType).then(function success(response) {
                        // UserService.viewFile(UtilitiesService.getPlusUrl() + "Provider/DownloadClaimDetails", data, responseContentType).then(function success(response) {
                        UtilitiesService.stopLoading('dcDashboardUI')
                    }, function error(errorData) {
                        UtilitiesService.stopLoading('dcDashboardUI')
                    });
                } else {
                    UtilitiesService.showAlertMessage('EntityId does not exist');
                }
            }

            // Assign data for particular status selected fom the status category
            scope.getApptDetails = function (currentItem) {
                scope.statusDetails = [];
                scope.currentSelectedStatus = currentItem;
                scope.statusName = currentItem.statusName;
                if (scope.totalStatus && scope.totalStatus.length > 0) {
                    var tempdata = _.where(scope.totalStatus, { statusName: scope.statusName });
                    scope.statusDetails = tempdata[0].pendingApptItems;
                }
            };

            scope.viewDetailsTab = function (route, value, status, fromDate, toDate) {
                // if (scope.filtere.fromDate && scope.filtere.toDate && value && status) {
                //     var r = '/' + route + '/withDate' + '/' + value + '/' + status + '/' + scope.filtere.fromDate + '/' + scope.filtere.toDate;
                // }
                if (fromDate && value && status) {
                    fromDate = moment(fromDate).toDate();
                    toDate = toDate ? moment(toDate).toDate() : "";
                    var r = '/' + route + '/withDate' + '/' + value + '/' + status + '/' + fromDate + '/' + toDate;
                }
                else if (value && status) {
                    var r = '/' + route + '/' + value + '/' + status;
                }
                else {
                    var r = '/' + route;
                }
                location.path(r);
            }

            scope.getDashboardItems();

            scope.reportRequestPopOverHandler = {
                content: 'Hello, World!',
                templateUrl: 'reportDownloadPopover.html',
                title: $sce.trustAsHtml('<strong>See All Notifications</strong>')
            }
        }
    ]);
angular.module('mbplus')
  .controller('dashboardCtrl', ['$rootScope', '$scope', '$location', '$window', '$http', 'UserService', '$state',
    'UtilitiesService', '$analytics', '$filter', '$timeout', '$sce',
    function (rootScope, scope, location, $window, http, UserService,
      state, UtilitiesService, analytics, filter, timeout, $sce) {
      analytics.pageTrack('/dashboard');
      scope.$root.title = 'Dashboard | Medibuddy Hospital Portal';
      if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() === 'insurer') {
        UserService.destroyUserObj();
        location.path('/');
        return false;
      }
      scope.status = {
        isFirstOpen: false
      }
      scope.MaTPAId = UtilitiesService.getMaTpaId();
      scope.MaTpaName = UtilitiesService.getMaTpaName();

      scope.dashboardType = 'MA';
      scope.data = '';
      scope.user = UserService.getUserObj();
      scope.isCmsUser = true;
      if (scope.user && scope.user.rolesFeatures.roles.length == 1) {
        angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
          if (v.roleId == 9216) {
            scope.isCmsUser = false;
          }
        })
      }
      scope.displayThis = UserService.displayThis;
      scope.isActive = UserService.isActive();
      scope.hospitalDetails = UserService.getHospitalObj();
      scope.formatCurrency = UtilitiesService.formatCurrency;
      rootScope.showAll = false;
      scope.filtere = {
        fromDate: '',
        toDate: ''
      };
      scope.userProperties = UtilitiesService.getUserProperties();

      scope.convertToString = function () {
        var data1 = [];
        var count = _.where(scope.totalDashboardPresent, {
          isSelected: true
        });
        angular.forEach(count, function (data, index) {
          data1.push(data.name.toLowerCase());
        });
        return data1.toString();
      };
      scope.customizeDashboardName = function () {
        angular.forEach(scope.totalDashboardPresent, function (data, index) {
          if (data.name === 'Query') {
            scope.totalDashboardPresent[index].fullName = 'Claims pending query response';
          } else if (data.name === 'Upcoming') {
            scope.totalDashboardPresent[index].fullName = 'Planned hospitalization/eCashless';
          } else if (data.name === 'Active') {
            scope.totalDashboardPresent[index].fullName = 'Active claims';
          } else if (data.name === 'Denied') {
            scope.totalDashboardPresent[index].fullName = 'Denied claims';
          } else if (data.name === 'Discharge') {
            scope.totalDashboardPresent[index].fullName = 'Awaiting Discharge Today';
          } else if (data.name === 'Totalos') {
            scope.totalDashboardPresent[index].fullName = 'Outstanding cashless claims amount';
          } else if (data.name === 'Clsettled') {
            scope.totalDashboardPresent[index].fullName = 'Cashless claims settled';
          } else if (data.name === 'Risettled') {
            scope.totalDashboardPresent[index].fullName = 'Reimbursement claims settled';
          } else if (data.name === 'Totalsettled') {
            scope.totalDashboardPresent[index].fullName = 'Total claims settled';
          } else if (data.name === 'Profile') {
            scope.totalDashboardPresent[index].fullName = 'Profile completion';
          } else if (data.name === 'Users') {
            scope.totalDashboardPresent[index].fullName = 'Users';
          } else if (data.name === 'Cda') {
            scope.totalDashboardPresent[index].fullName = 'Claims pending document submission';
          }
        });
      };
      scope.UiImplimentation = [];
      scope.dashBoardData = function () {
        if (scope.userProperties && scope.userProperties.TotalDashboardPresent && scope.userProperties.PreferedHospDashBoard !== '') {
          var totalDashboardPresent = scope.userProperties.TotalDashboardPresent.split(',');
          var PreferedHospDashBoard = scope.userProperties.PreferedHospDashBoard.split(',');

          scope.totalDashboardPresent = [];
          angular.forEach(totalDashboardPresent, function (data, index) {
            scope.totalDashboardPresent.push({
              name: data.substr(0, 1).toUpperCase() + data.substr(1).toLowerCase(),
              isSelected: false
            })
          });
          scope.customizeDashboardName();

          if (PreferedHospDashBoard.length > 0) {
            angular.forEach(scope.totalDashboardPresent, function (data, index) {
              angular.forEach(PreferedHospDashBoard, function (data1, index1) {
                if (data.name.toLowerCase() === data1.toLowerCase()) {
                  scope.totalDashboardPresent[index].isSelected = true;
                }
              })
            });
          }
          scope.UiImplimentation = scope.totalDashboardPresent;
          var count = _.where(scope.totalDashboardPresent, {
            isSelected: true
          });
          scope.isDisable = (count.length > 3) === true ? false : true;
        } else if (scope.userProperties && scope.userProperties.PreferedHospDashBoard === '') {
          var totalDashboardPresent = scope.userProperties.TotalDashboardPresent.split(',');
          var PreferedHospDashBoard = scope.userProperties.PreferedHospDashBoard.split(',');
          scope.totalDashboardPresent = [];
          angular.forEach(totalDashboardPresent, function (data, index) {
            scope.totalDashboardPresent.push({
              name: data.substr(0, 1).toUpperCase() + data.substr(1).toLowerCase(),
              isSelected: false
            })
          });
          scope.customizeDashboardName();
          if (totalDashboardPresent.length > 0) {
            angular.forEach(scope.totalDashboardPresent, function (data, index) {
              angular.forEach(totalDashboardPresent, function (data1, index1) {
                if (data.name.toLowerCase() === data1.toLowerCase()) {
                  scope.totalDashboardPresent[index].isSelected = true;
                }
              })
            });
          }
          scope.UiImplimentation = scope.totalDashboardPresent;
          var count = _.where(scope.totalDashboardPresent, {
            isSelected: true
          });
          scope.isDisable = (count.length > 3) === true ? false : true;
        }
      };
      scope.dashBoardData();
      scope.validateCount = function () {
        var count = _.where(scope.totalDashboardPresent, {
          isSelected: true
        });
        scope.isDisable = (count.length > 3) === true ? false : true;

      };

      scope.closeModel = function () {
        scope.dashBoardData();
        scope.isDisable = false;
      };

      scope.open1 = function () {
        scope.popup1.opened = true;
      };
      scope.open2 = function () {
        scope.popup2.opened = true;
      };
      scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
      scope.format = scope.formats[0];
      scope.altInputFormats = ['M!/d!/yyyy'];
      scope.popup1 = {
        opened: false
      };
      scope.popup2 = {
        opened: false
      };

      scope.tpaType = {
        dashboardType: {
          id: scope.MaTPAId,
          value: scope.MaTpaName
        }
      }

      // scope.dashboardType = 'MediAssist';
      scope.changeDashboard = function (type) {
        if (type && type.id == 9999) {
          scope.showGovtDashboard(type.value)
        } else if (type && type.id) {
          scope.getAllCounts(parseInt(type.id));
        } else {
          scope.getAllCounts();
        }
      };

      scope.downloadAttachment = function () {
        var data = {
          filePath: "http://192.168.1.183/HN/PACKAGE%20TARIFF/GIPSA%20PPN/DELHI/ArtemishealthInst%20110831%2031july17up%20GurgoanHaryPPNpack.pdf"
        }

        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/downloadFile', data, 'POST', true).then(
          function (response) {
            if (response) {
            }
          }
        );
      }

      scope.showGovtDashboard = function (schemeCode) {
        var startDate = filter('date')(scope.filtere.fromDate, 'yyyy-MM-dd');
        var endDate = filter('date')(scope.filtere.toDate, 'yyyy-MM-dd');
        var data = {
          "hospId": UserService.getHospitalObj().hospId,
          "schemeCode": schemeCode,
          "dateFrom": startDate ? startDate : null,
          "dateTo": endDate ? endDate : null
        }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/Dashboard/RequestEncryption', data, 'POST', true).then(function (response) {
          if (response.data.encryptedData) {
            scope.dashboardURL = $sce.trustAsResourceUrl(UtilitiesService.getPublicHealthPortalUrl() + "/UI/Hospitals/HospitalSummary.aspx?Request=" + response.data.encryptedData);
            // document.getElementById('govtDashboardURL')[0].src = scope.dashboardURL;
            // scope.dashboardURL="http://stg-publichealth.medibuddy.in/UI/Hospitals/HospitalSummary.aspx? Request="+response.data.encryptedData;
          }
        })
      }


      scope.getAllCounts = function (searchType) {
        if (searchType != 9999) {
          if (searchType) {
            scope.searchType = searchType;
          } else {
            scope.searchType = 0;
          }
          scope.startDate = filter('date')(scope.filtere.fromDate, 'yyyy-MM-dd');
          scope.endDate = filter('date')(scope.filtere.toDate, 'yyyy-MM-dd');
          var data = {
            hospitalId: UserService.getHospitalObj().hospId,
            startDateInclusive: scope.startDate,
            endDateExclusive: scope.endDate,
            preferedDashBoard: scope.convertToString(),
            polTPAId: scope.searchType
          };
          // UtilitiesService.startLoading('fetching dashboard data...', 'dashboardUI');
          // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/search/claimscount/', data, 'POST', true).then(function (response) {
          //   UtilitiesService.stopLoading('dashboardUI');
          //   if (response.data.isSuccess) {
          //     scope.userDetails = response.data;
          //     scope.maDashBoard = response.data.maDashBoard;
          //     scope.dhsDashBoard = response.data.dhsDashBoard;
          //     if (scope.searchType === 0 || scope.searchType === scope.MaTPAId) {
          //       scope.data = scope.maDashBoard;
          //     }
          //     // else if (scope.searchType === 114) {
          //     //   scope.data = scope.dhsDashBoard;
          //     // }
          //     else if (scope.searchType) {
          //       scope.data = response.data.payarDashBoard;
          //     }
          //     scope.totalRating = 0;
          //     scope.rating = 0;
          //     if (response.data.hospProfileCompletionRating) {
          //       scope.totalRating = response.data.hospProfileCompletionRating.totalRating;
          //       scope.rating = response.data.hospProfileCompletionRating.hospCurrentRating;
          //     }
          //     scope.totalAmount = response.data.settledClaimsAmount + response.data.reimbursementAppAmount;
          //     scope.totalPercentage = (scope.rating / scope.totalRating) * 100;
          //   } else {
          //     scope.data = '';
          //   }
          // });
        } else {
          scope.showGovtDashboard(scope.tpaType.dashboardType.value);
        }
      };
      scope.combinedRoleIds = function (roles) {
        scope.selectedRoleIds = [];
        if (roles && roles.length > 0) {
          angular.forEach(roles, function (value, index) {
            scope.selectedRoleIds.push(value.id)

          });
        }
        return scope.selectedRoleIds;
      };

      scope.getUserProperties = function () {
        if (UserService.getUserObj()) {
          var data = {
            accessToken: UserService.getAccessToken()
          }
          // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/user/userproperty/', data, 'POST').then(function (response) {
          //   if (response.data) {
          //     UtilitiesService.deleteUserProperties();
          //     UtilitiesService.setUserProperties(response.data);
          //     scope.userProperties = UtilitiesService.getUserProperties();
          //     scope.dashBoardData();
          //   }
          // });
        }
      };

      scope.saveDashboardChanges = function () {
        var data = {
          userId: scope.user.userId,
          roleIds: scope.combinedRoleIds(scope.user.userRoles),
          emailId: scope.user.userEmail,
          isActive: true,
          hospId: UserService.getHospitalObj().hospId,
          updatedBy: scope.user.userId,
          accessToken: UserService.getAccessToken(),
          preferedHospDashBoard: scope.convertToString()
        };
        UtilitiesService.startLoading('Saving dashboard configuration...', 'dashboardUI');
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/user/edit', data, 'POST', true).then(function (response) {
          UtilitiesService.stopLoading('dashboardUI');
          if (response.data.isSuccess) {
            scope.getUserProperties();
            UtilitiesService.showAlertMessage('Your dashboard setting has been saved successfully.', true);
          }
        });
      };

      scope.saveDashboard = function () {
        scope.UiImplimentation = _.where(scope.totalDashboardPresent, {
          isSelected: true
        });
        scope.getAllCounts();
        scope.saveDashboardChanges();
        angular.element('#customizeDashboard').modal('hide');
      };

      if (scope.isActive) {
        $("#sidebar li").removeClass('active');
        $("#sidebar li#dashboard").addClass('active');
        scope.filtere.fromDate = '';
        scope.filtere.toDate = '';
        scope.getAllCounts();
      }
      scope.goState = function (value) {
        if (value) {
          state.go(value.replace('/', ''), {}, { reload: true });
        }
      };

      scope.startIndex = 1;
      scope.getDateObj = UtilitiesService.getDateObj;
      scope.currentPage = 1;
      scope.itemsPerPage = 10;
      scope.hospitalClaimSearchResults = [];
      scope.isResult = false;
      scope.getConfiguredTpaList = function () {
        var configuredTpaList = UtilitiesService.getConfiguredTpa();
        scope.configuredTpaList = [];
        scope.configuredTpaList.push({
          id: scope.MaTPAId,
          value: scope.MaTpaName
        })
        if (configuredTpaList && configuredTpaList.length > 0) {
          angular.forEach(configuredTpaList, function (element) {
            scope.configuredTpaList.push({
              id: element.tpaId,
              value: element.tpaName
            })
          });
        }
        // For Govt Scheme
        if (scope.hospitalDetails.configuredSchemes && scope.hospitalDetails.configuredSchemes.length > 0) {
          angular.forEach(scope.hospitalDetails.configuredSchemes, function (element) {
            scope.configuredTpaList.push({
              id: 9999,
              value: element
            })
          })
        }

        //Temp fix
        scope.configuredTpaList.push({
          id: 9999,
          value: 'CMHT'
        })

        // For Govt Scheme
        if (scope.hospitalDetails.configuredSchemes && scope.hospitalDetails.configuredSchemes.length > 0) {
          angular.forEach(scope.hospitalDetails.configuredSchemes, function (element) {
            scope.configuredTpaList.push({
              id: 9999,
              value: element
            })
          })
        }

      }
      scope.getConfiguredTpaList();

      scope.getUpcomingHospitalization = function () {
        scope.isResult = false;
        scope.hospitalClaimSearchResults = [];
        if (UserService.getHospitalObj()) {
          var ajxData = {
            hospitalId: UserService.getHospitalObj().hospId,
            startIndexInclusive: scope.startIndex
          };
          UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/claim/upcomingclaimlist', ajxData, 'POST').then(function (response) {
            if (response.data.isSuccess) {
              scope.isResult = true;
              scope.hospitalClaimSearchResults = response.data.hospitalClaimSearchResults ? response.data.hospitalClaimSearchResults : []; //UtilitiesService.renderClaimsList(response.data, "preauth");
              scope.totalItem = response.data.allRecordCount;
            }
          }, function (error) {
            UtilitiesService.showAlertMessage('Something went wrong, please try again later.');
          });
        }
      };
      scope.ctrlFn = function (nextpage) {
        if (nextpage) {
          scope.startIndex = nextpage;
          scope.getUpcomingHospitalization();
        }
      };

      scope.resetDateValues = function () {
        scope.filtere.fromDate = '';
        scope.filtere.toDate = '';
        scope.getAllCounts();
      }

      scope.redirect = function (val) {
        rootScope.startD = scope.startDate;
        rootScope.endD = scope.endDate;
        switch (val) {
          case 'claimsOperations':
            rootScope.FlagOperations = (!!scope.startD && !!scope.endD) === true ? true : false;
            location.path("/claims");
            break;
          case 'claimsPayments':
            rootScope.FlagPayments = (!!scope.startD && !!scope.endD) === true ? true : false;
            location.path('/documentsReceived');
            break;
          case 'claimsApproved':
            rootScope.FlagApproved = (!!scope.startD && !!scope.endD) === true ? true : false;
            location.path('/approved');
            break;
          case 'claimsDenied':
            rootScope.FlagDenied = (!!scope.startD && !!scope.endD) === true ? true : false;
            location.path('/denied');
            break;
          case 'discharge':
            rootScope.FlagDischarge = true;
            location.path('/claims');
            break;
          case 'documents':
            rootScope.FlagDocuments = true;
            location.path('/documentsAwaited');
            break;
          case 'cashResponse':
            if (scope.startD || scope.endD) {
              UserService.dateCollection = {
                startDate: scope.startD,
                endDate: scope.endD
              };
            } else {
              UserService.dateCollection = 'No date';
            }
            location.path('documentsReceived');
            break;
          case 'usermgmt':
            state.go('usermgmt');
            break;
          default:
            rootScope.FlagOperations = (!!scope.startD && !!scope.endD) === true ? true : false;
            location.path('/claims');
            break;
        }
      };

      scope.getReportAjxData = function () {
        var ajxData = {
          hospitalId: UserService.getHospitalObj().hospId,
          userId: scope.user.userId,
          startDateInclusive: scope.startDate,
          endDateExclusive: scope.endDate,
          emailId: scope.report.mailId
        }
        return ajxData;
      };
      scope.emailchk = /^(([^<>()[\]\\.,;:\s@\']+(\.[^<>()[\]\\.,;:\s@\']+)*)|(\'.+\'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      scope.report = {
        mailId: ''
      };
      scope.resetMailData = function () {
        scope.report.mailId = '';
      };
      scope.isSent = true;
      scope.isClaimsDenied = false;
      scope.isCashless = false;
      scope.isOutstanding = false;
      scope.setModelData = function (value) {
        scope.isSent = true;
        if (value === 'Cashless Settled Claims') {
          scope.isCashless = true;
          scope.isOutstanding = false;
          scope.isClaimsDenied = false;
          scope.modelValue = value;
        } else if (value === 'Total outstanding amount') {
          scope.isOutstanding = true;
          scope.isClaimsDenied = false;
          scope.isCashless = false;
          scope.modelValue = value;
        } else if (value === 'Denied Claims') {
          scope.isClaimsDenied = true;
          scope.isCashless = false;
          scope.isOutstanding = false;
          scope.modelValue = value;
        }
      };

      scope.downloadReport = function (reportType, mail) {
        if (reportType && UserService.getHospitalObj() && UserService.getHospitalObj().hospId && mail) {
          var ajxData = {
            hospitalId: UserService.getHospitalObj().hospId,
            userId: scope.user.userId,
            startDateInclusive: scope.startDate,
            endDateExclusive: scope.endDate,
            emailId: mail,
            tpaId: scope.tpaType.dashboardType === 'DHS' ? 114 : 0,
            hospitalEmailId: scope.user.userEmail
          }
          var today = new Date();
          scope.dateObj = new Date(today.setDate(today.getDate() + 1))
          scope.isSent = false;
          var url = reportType === 'downloadSettlementReport' ? '/hosp/HospSettlementReport' : (reportType === 'downloadDeniedReport' ? '/hosp/HospDeniedExcelReport' : (reportType === 'downloadOutstandingReport' ? '/hosp/HospOutstandingExcelReportRequest' : ''));
          if (url) {
            timeout(function () {
              angular.element('#downloadData').modal('hide');
            }, 2000);
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + url, ajxData, 'POST', UserService.getAccessToken(), true).then(function (response) {});
          }
        } else {
          UtilitiesService.showAlertMessage('Something went wrong, please try again later.');
        }
      };
    }
  ]);

angular.module('mbplus')
  .controller('dcDocumentsCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', '$analytics', 'FileUploadService', '$q', function (scope, $location, UserService, UtilitiesService, $analytics, FileUploadService, $q) {
    if (!UserService.isActive()) {
      UserService.destroyUserObj();
      $location.path('/');
      return false;
    }
    var stateId, cityId , locationId, dcId;
    var hospUrl = UtilitiesService.getUrlPrefix();
    scope.status = {
      open: true
    }
    scope.cityList = [];
    scope.locationList = [];
    scope.stateList = [];
    scope.dcList = [];
    scope.isDcSearch = false;

    UserService.makeRestCall(UtilitiesService.getPlusApi('integration') + "/masterdata/lookup/state" , '' , 'GET').then(function(response) {
      if(response.data.isSuccess) {
        scope.stateList = response.data.lookUpData;
      }
    }) 

    scope.loadListByKey = function (key, value) {
      var api;
      if (key == 'state') {
        stateId = value.lookUpId
        api = UtilitiesService.getPlusApi() + "/masterdata/lookuplevel/" + stateId + '/2';
        UserService.makeRestCall(api , '' , 'GET').then(function(response) {
          if(response.data.isSuccess) {
            scope.cityList =  response.data.lookUpData;
          }
        })
      } 
      else if (key == 'city') {
        cityId = value.lookUpId;
        cityParentId =  value.lookUpParent;
        api = UtilitiesService.getPlusApi() + '/masterdata/lookup/location/' + cityId;
        UserService.makeRestCall(api , '' , 'GET').then(function(response) {
          if(response.data.isSuccess) {
            scope.locationList =  response.data.lookUpData;
          }
        })
      } 
      else if (key == 'location') {
        locationId = value.lookUpId;
        api = UtilitiesService.getPlusApi() + '/EntityRelation/Search/EntitySearch/' + '5290/1000042/0/' + stateId +'/'+ cityParentId +'/'+ cityId +'/'+ locationId ;
        UserService.makeRestCall(api , '' , 'GET').then(function(response) {
          if(response.status == 200 && response.statusText == "OK" ) {
            scope.dcList =  response.data;
          }
        })
      }
    }

    scope.onDcSelection = function (value) {
      scope.selectedDcName = value.entityName;
      dcId = value.entityId;
      UtilitiesService.startLoading('fetching documents...', 'documentsLoading');
      UserService.makeRestCall(UtilitiesService.getPlusUrl() + 'EntityProperty/' + dcId, '', 'GET', UserService.getAccessToken()).then(function (response) {
        scope.isDcSearch = true;
        if (response.status == 200 && response.statusText == 'OK') {
          UtilitiesService.stopLoading('documentsLoading');
          if (response.data.entityProperties.length) {
            scope.noData = false;
            scope.status.open = false;
            scope.docs = []
            var propArr = response.data.entityProperties;
            var downloadUrl = "https://www.medibuddy.in/WAPI/GetFile/";
            propArr.forEach(function (e) {
              e.entityPropertyJson.docDetails.forEach(function (el) {
                var tempObj = {
                  propName: e.propName,
                  docId: el.docId,
                  docName: el.docName,
                  link: downloadUrl + el.docId
                }
                scope.docs.push(tempObj);
              })
            })
          }
          else{
            scope.noData =  true;
          }
        }
      }, function(error) {
        scope.isDcSearch = true;
        scope.noData = true;
        UtilitiesService.stopLoading('documentsLoading');
      })
    }

  }])

angular.module('mbplus')
  .controller('contractsHospCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', 'ProfileService', '$analytics', 'FileUploadService', '$q', function (scope, $location, UserService, UtilitiesService, ProfileService, $analytics, FileUploadService, $q) {
    $analytics.pageTrack('/contracts');
    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
      UserService.destroyUserObj();
      $location.path('/');
      return false;
    }
    scope.dmslink = UtilitiesService.getDMSHostUrl();
    scope.documentTypes = [];
    scope.editDocument = false;
    scope.addDocument = false;
    scope.document = {};
    scope.file = [];
    scope.newlyUploadedImages = [];
    scope.isDocumentsOpen = false;
    scope.isPackagesOpen = false;
    scope.isDiscountsOpen = false;
    scope.switchTabs = function (tab) {
      if (tab == 'documents') {
        scope.isDocumentsOpen = true;
        scope.isPackagesOpen = false;
        scope.isDiscountsOpen = false;
        scope.contractMethods.loadContracts();
      }
      if (tab == 'packages') {
        scope.isDocumentsOpen = false;
        scope.isPackagesOpen = true;
        scope.isDiscountsOpen = false;
        scope.selectedPackage = {};
        scope.ipPackageMethods.loadIpPacakages();
      }
      if (tab == 'discounts') {
        scope.isDocumentsOpen = false;
        scope.isPackagesOpen = false;
        scope.isDiscountsOpen = true;
        scope.discountMethods.loadDiscounts();
      }
    }
    scope.contractMethods = (function () {
      return {
        loadContracts: function () {
          scope.contracts = [];
          ProfileService.loadProviderContracts({}).then(function (response) {
            if (response.hospitalsDocumentDetails) {
              angular.forEach(response.hospitalsDocumentDetails, function (e, i) {
                e.documentEndDate = UtilitiesService.formatDateNumber(e.documentEndDate).toString().split(' ')[0];
                e.documentStartDate = UtilitiesService.formatDateNumber(e.documentStartDate).toString().split(' ')[0];
                e.downloadLink = e.documentLink ? e.downloadLink : '';
                // e.documentLink = e.documentLink ? e.documentLink : '';

              });
              scope.documents = response.hospitalsDocumentDetails;
            }
          })
        },
        openDocumentModal: function (entry, isEdit) {
          if (!scope.documentTypes || scope.documentTypes.length <= 0) {
            scope.documentTypes = [];
            ProfileService.loadProviderMasterByKey({
                columnNames: ["Hospital_Document_Type"]
              })
              .then(function (res) {
                // res.lookupData.map(function (el) {
                //   el.id = el.masterLookUpID;
                // });
                scope.documentTypes = res.lookupData;
              });
          }
          if (isEdit) {
            scope.editDocument = true;
            scope.addDocument = false;
            scope.document = {
              docStartDate: new Date(entry.documentStartDate),
              docEndDate: new Date(entry.documentEndDate),
              docDescription: entry.documentDescription,
              docType: entry.documentTypeID,
              downloadLink: entry.downloadLink,
              docLink: entry.documentLink,
              docId: entry.id
            };
          } else {
            scope.addDocument = true;
            scope.editDocument = false;
            scope.document = {};
            scope.contractMethods.clearFileModels();
          }
        },
        updateDocuments: function (isDelete) {
          var data = {
            "documentsList": [{
              "id": scope.document.docId,
              "hospitalId": UserService.getHospitalObj().hospId,
              "documentTypeID": scope.document.docType,
              "documentDescription": scope.document.docDescription,
              "documentStartDate": scope.document.docStartDate,
              "documentEndDate": scope.document.docEndDate,
              "documentLink": scope.document.docLink,
              "isActive": true,
              "modifiedBy": UserService.getUserObj().userId,
              "isVerified": false,
              "isDelete": isDelete,
            }]
          };

          ProfileService.updateProviderProfileDataByKey('contract', data).then(function (response) {
            if (response.hospitalsDocumentDetails) {
              scope.contractMethods.loadContracts();
            }
          });
        },
        clearFileModels: function () {
          scope.newlyUploadedImages = [];
          scope.file = [];
          scope.fileUploadMethods.addFileToUpload();
        },
        addDocuments: function () {
          var fileBlobArray = [];
          var filesUploadingArray = [];
          var fileURL = '';
          Object.keys(scope.file).forEach(function (ele) {
            if (typeof (scope.file[ele].model) == "object") {
              filesUploadingArray.push(scope.file[ele].model);
            }
          });
          if (filesUploadingArray.length > 0) {
            fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrl() + '/Provider/Profile/DocumentUpload'));
            // fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
          } else {
            UtilitiesService.showAlertMessage('Please attach atleast one document.');
            return false;
          }
          $q.all(fileBlobArray).then(function (result) {
              result.forEach(function (element) {
                if (element.data.isSuccess) {
                  angular.forEach(element.data.uploadedDetails, function (e, i) {
                    fileURL = e.fileGuid;
                  });
                  var data = {
                    "documentsList": [{
                      "hospitalId": UserService.getHospitalObj().hospId,
                      "documentTypeID": scope.document.docType,
                      "documentLink": fileURL,
                      "documentDescription": scope.document.docDescription,
                      "documentStartDate": scope.document.docStartDate,
                      "documentEndDate": scope.document.docEndDate,
                      "isActive": true,
                      "createdBy": UserService.getUserObj().userId,
                      "modifiedBy": UserService.getUserObj().userId,
                      "isVerified": false,
                      "isDelete": false
                    }]
                  }
                  ProfileService.updateProviderProfileDataByKey('contract', data).then(function (response) {
                    if (response.hospitalsDocumentDetails) {
                      scope.contractMethods.loadContracts();
                      $('#documentDetails').modal('hide');
                    }
                  }, function (error) {
                    // console.log("Error : " + error);
                  })
                } else {
                  scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                  return false;
                }
                scope.file = [];
              });
            },
            function (error) {
              scope.file = [];
            });
        },
      };
    })();

    scope.ipPackageMethods = (function () {
      return {
        loadIpPacakages: function () {
          ProfileService.loadProviderPackagesByKey('IP', {}).then(function (response) {
            if (response.ipPackagesDetails) {
              angular.forEach(response.ipPackagesDetails, function (e, i) {
                e.toDate = UtilitiesService.formatDateNumber(e.packageEndDate).toString().split(' ')[0];
                e.fromDate = UtilitiesService.formatDateNumber(e.packageStartDate).toString().split(' ')[0];
              });
              scope.ipPackageList = response.ipPackagesDetails;
            }
          })
        },
        openPkgDetailsModal: function (e) {
          scope.indvidualPackage = e;
        },
        updatePackageDetails: function(e) {
          if(e) {
            scope.editPackage = true;
            scope.selectedPackage = JSON.parse(JSON.stringify(e));
            scope.selectedPackage.endDate = new Date(scope.selectedPackage.toDate);
            scope.selectedPackage.startDate = new Date(scope.selectedPackage.fromDate);
          }
          else {
            scope.editPackage = false;
            scope.selectedPackage = {hospitalID : UserService.getHospitalObj().hospId};
            scope.selectedPackage.packageAges = [{'minAge':'','maxAge':''}];
          }

          ProfileService.loadProviderMasterByKey({columnNames: ["Hospital_Room_Type"]}).then(function (response) {
            if(response.lookupData){
              scope.roomTypeMaster = response.lookupData;
            }
          })
        },
        savePackageDetails: function() {
          var minAge,maxAge,packagePrice,maPrice;
          minAge = parseInt(scope.selectedPackage.packageAges[0].minAge);
          maxAge = parseInt(scope.selectedPackage.packageAges[0].maxAge);
          packagePrice = parseInt(scope.selectedPackage.packagePrice);
          maPrice = parseInt(scope.selectedPackage.packageMAPrice);
          if( (minAge <= maxAge) && ( packagePrice >= maPrice) ) {
            scope.selectedPackage.packageEndDate = scope.selectedPackage.endDate
            scope.selectedPackage.packageStartDate = scope.selectedPackage.startDate
            var data = {"packagesList" : [scope.selectedPackage]}
            ProfileService.updateProviderProfileDataByKey('ipPackages', data).then(function(response) {
              if(response) {
                angular.element("#updateIpPackage").modal("hide");
                scope.ipPackageMethods.loadIpPacakages();
              }
            })
          }
          else {
            if (minAge > maxAge) {
              alert("Miniumun age cannot be more than maximum age")
            }
            else if (packagePrice < maPrice) {
              alert("Medi Assist price cannot be more than Package Price")
            }
          }
        }
      }
    })();

    scope.discountMethods = (function () {
      return {
        loadDiscounts: function () {
          ProfileService.loadProviderDiscounts({}).then(function (response) {
            if (response.discountDetails) {
              angular.forEach(response.discountDetails, function (e, i) {
                e.documentEndDate = UtilitiesService.formatDateNumber(e.endDate).toString().split(' ')[0];
                e.documentStartDate = UtilitiesService.formatDateNumber(e.startDate).toString().split(' ')[0];
              });
              scope.discountList = response.discountDetails;
            }
          })
        }
      }
    })();

    scope.fileUploadMethods = (function () {
      return {
        addFileToUpload: function (flag) {
          var newItemNo = scope.file.length + 1;
          scope.file.push({
            'model': ''
          });
        },
        removeFileToUpload: function (index) {
          scope.file.splice(index, 1);
          scope.fileUploadMethods.addFileToUpload();
        }
      };
    })();
    angular.element(document).ready(function () {
      scope.contractMethods.loadContracts();
      scope.fileUploadMethods.addFileToUpload();
    });
  }]);

angular.module('mbplus')
.controller('contactCtrl', ['$rootScope', '$scope', '$location', '$window', '$http', 'UserService','UtilitiesService', '$analytics', function ($rootScope, scope, $location, $window, $http, UserService, UtilitiesService, $analytics) {
  $analytics.pageTrack('/contact');
  $rootScope.showAll = false;
  scope.$root.title = 'Contact Us | Medibuddy Hospital Portal';
  if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }
  $("#sidebar li").removeClass("active");
  $("#sidebar li#contact").addClass("active");
  scope.test = {};
  scope.message = "";
  scope.branchName = "";
  scope.subjectName = "General query";
  scope.isActive = UserService.isActive();
  scope.getUserRole = function () {
    if (UserService.getUserObj())
      return UserService.getUserObj().role.toLowerCase();
  };
  if (scope.isActive) {
    scope.user = UserService.getUserObj();
    scope.hospitalDetails = UserService.getHospitalObj();
    scope.address = '';
    scope.hasAddress = false;
    if (scope.hospitalDetails) {
        scope.fromEmail = scope.hospitalDetails.emailAddress;
        scope.hospId = scope.hospitalDetails.hospId;
        var url = UtilitiesService.getUrlPrefix() + "/hosp/relatedentity.json?relationType=TPA&primary=" + UserService.getHospitalObj().hospId;
        $http.get(url).
        success(function (data) {
            if (data.isSuccess) {
                scope.address = data.relatedEntities[0];
                scope.hasAddress = true;
                scope.branchName = scope.address.entityShortName.split(" ")[1];
            }
            else {
                scope.hasAddress = false;
            }
        }).
        error(function () {
        });
    }
    scope.sendMessage = function () {
      if(UserService.getHospitalObj().hospId && scope.test && scope.test.subject){
        var data = {
          hospId: UserService.getHospitalObj().hospId,
          claimServicingBranch: scope.branchName,
          grievanceType: scope.test.subject,
          content: scope.message,
          hospEmailId: scope.fromEmail
        };
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/grievance',data, 'POST').then(function (response) {
          if (response.data.isSuccess) {
           scope.message ='';
           scope.test.subject ='';
           UtilitiesService.showAlertMessage('Request has been sent successfully.' , true);
          }
        },function (error) {
             UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        });
      }else{
      }
    };
    scope.clearAllCookies = function () {
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      }
      $rootScope.$broadcast('signedin', false);
      $location.path('/');
    };
  }
  else {
  }
}]);
angular.module('mbplus')
.controller('clinicAppointmentCtrl', ['$rootScope', '$scope', '$compile', '$timeout', 'uiCalendarConfig', 'UserService', function ($rootScope, scope, $compile, $timeout, uiCalendarConfig, UserService) {
    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() === 'insurer') {
        UserService.destroyUserObj();
        location.path('/');
        return false;
    }
    scope.day = moment();
    var date = new Date();
    var d = date.getDate();
    var m = date.getMonth();
    var y = date.getFullYear();

    var todayDate = moment().startOf('day');
    var YM = todayDate.format('YYYY-MM');
    var YESTERDAY = todayDate.clone().subtract(1, 'day').format('YYYY-MM-DD');
    var TODAY = todayDate.format('YYYY-MM-DD');
    var TOMORROW = todayDate.clone().add(1, 'day').format('YYYY-MM-DD');

    scope.changeTo = 'Hungarian';
    /* event source that pulls from google.com */
    scope.eventSource = {
        url: "http://www.google.com/calendar/feeds/usa__en%40holiday.calendar.google.com/public/basic",
        className: 'gcal-event',           // an option!
        currentTimezone: 'America/Chicago' // an option!
    };
    /* event source that contains custom events on the scope */
    scope.events = [
      { title: 'All Day Event', start: new Date(y, m, 1) },
      { title: 'Long Event', start: new Date(y, m, d - 5), end: new Date(y, m, d - 2) },
      { id: 999, title: 'Repeating Event', start: new Date(y, m, d - 3, 16, 0), allDay: false },
      { id: 999, title: 'Repeating Event', start: new Date(y, m, d + 4, 16, 0), allDay: false },
      { title: 'Birthday Party', start: new Date(y, m, d + 1, 19, 0), end: new Date(y, m, d + 1, 22, 30), allDay: false },
      { title: 'Click for Google', start: new Date(y, m, 28), end: new Date(y, m, 29) },
      {
          title: '',
          start: new Date(y, 2, 28),
          end: new Date(y, 2, d + 1, 22, 30),
          allDay: false,
          editable: true
      }, {
          title: 'All Day Event',
          start: YM + '-01'
      },
			{
			    title: 'Long Event',
			    start: YM + '-07',
			    end: YM + '-10',
			    constraint: 'availableForMeeting', // defined below
			    color: '#257e4a'
			},
			{
			    id: 999,
			    title: 'Repeating Event',
			    start: YM + '-09T16:00:00',
			    constraint: 'availableForMeeting', // defined below
			    color: '#257e4a'
			},
			{
			    id: 999,
			    title: 'Repeating Event',
			    start: YM + '-16T16:00:00',
			    constraint: 'availableForMeeting', // defined below
			    color: '#257e4a'
			},
			{
			    title: 'Conference',
			    start: YESTERDAY,
			    end: TOMORROW
			},
			{
			    title: 'Meeting',
			    start: TODAY + 'T10:30:00',
			    end: TODAY + 'T12:30:00'
			},
			{
			    title: 'Lunch',
			    start: TODAY + 'T12:00:00'
			},
			{
			    title: 'Meeting',
			    start: TODAY + 'T14:30:00'
			},
			{
			    title: 'Happy Hour',
			    start: TODAY + 'T17:30:00'
			},
			{
			    title: 'Dinner',
			    start: TODAY + 'T20:00:00'
			},
			{
			    title: 'Birthday Party',
			    start: TOMORROW + 'T07:00:00'
			},
			{
			    title: 'Click for Google',
			    url: 'http://google.com/',
			    start: YM + '-28'
			},// areas where "Meeting" must be dropped
				{
				    id: 'availableForMeeting',
				    start: '2017-02-11T10:00:00',
				    end: '2017-02-11T16:00:00',
				    rendering: 'background'
				},
				{
				    id: 'availableForMeeting',
				    start: '2017-02-13T10:00:00',
				    end: '2017-02-13T16:00:00',
				    rendering: 'background'
				},
            // red areas where no events can be dropped
				{
				    start: '2017-02-24',
				    end: '2017-02-28',
				    overlap: false,
				    rendering: 'background',
				    color: '#ff9f89'
				},
				{
				    start: '2017-02-06',
				    end: '2017-02-08',
				    overlap: false,
				    rendering: 'background',
				    color: '#ff9f89'
				}
    ];
    /* event source that calls a function on every view switch */
    scope.eventsF = function (start, end, timezone, callback) {
        var s = new Date(start).getTime() / 1000;
        var e = new Date(end).getTime() / 1000;
        var m = new Date(start).getMonth();
        var events = [{ title: 'Feed Me ' + m, start: s + (50000), end: s + (100000), allDay: false, className: ['customFeed'] }];
        callback(events);
    };

    scope.calEventsExt = {
        color: '#f00',
        textColor: 'yellow',
        events: [
           { type: 'party', title: 'Lunch', start: new Date(y, m, d, 12, 0), end: new Date(y, m, d, 14, 0), allDay: false },
           { type: 'party', title: 'Lunch 2', start: new Date(y, m, d, 12, 0), end: new Date(y, m, d, 14, 0), allDay: false },
           { type: 'party', title: 'Click for Google', start: new Date(y, m, 28), end: new Date(y, m, 29), url: 'http://google.com/' }
        ]
    };
    /* alert on eventClick */
    scope.alertOnEventClick = function (date, jsEvent, view) {
        $(this).css('border-color', 'white');
        //scope.alertMessage = (date.title + ' was clicked ');
        $(this).css('border-color', 'red');
        angular.element('#updateSlot').modal('show');
    };
    /* alert on Drop */
    scope.alertOnDrop = function (event, delta, revertFunc, jsEvent, ui, view) {
        scope.alertMessage = ('Event Droped to make dayDelta ' + delta);
    };
    /* alert on Resize */
    scope.alertOnResize = function (event, delta, revertFunc, jsEvent, ui, view) {
        scope.alertMessage = ('Event Resized to make dayDelta ' + delta);
    };
    /* add and removes an event source of choice */
    scope.addRemoveEventSource = function (sources, source) {
        var canAdd = 0;
        angular.forEach(sources, function (value, key) {
            if (sources[key] === source) {
                sources.splice(key, 1);
                canAdd = 1;
            }
        });
        if (canAdd === 0) {
            sources.push(source);
        }
    };
    /* add custom event*/
    scope.addEvent = function () {
        scope.events.push({
            title: 'Open Sesame',
            start: new Date(y, m, 28),
            end: new Date(y, m, 29),
            className: ['openSesame']
        });
    };
    /* remove event */
    scope.remove = function (index) {
        scope.events.splice(index, 1);
    };
    /* Change View */
    scope.changeView = function (view, calendar) {
        uiCalendarConfig.calendars[calendar].fullCalendar('changeView', view);
    };
    /* Change View */
    scope.renderCalender = function (calendar) {
        $timeout(function () {
            if (uiCalendarConfig.calendars[calendar]) {
                uiCalendarConfig.calendars[calendar].fullCalendar('render');
            }
        });
    };
    /* Render Tooltip */
    scope.eventRender = function (event, element, view) {
        element.attr({
            'tooltip': event.title,
            'tooltip-append-to-body': true
        });
        $compile(element)(scope);
    };

    //
    scope.dayClick = function (date, jsEvent, view) {
        $(this).css('border-color', 'white');
        angular.element('#addSlot').modal('show');
    };

    scope.addEvent = function () {
        $(this).css('border-color', 'white');
        angular.element('#addSlot').modal('hide');
    };

    scope.updateEvent = function () {
        angular.element('#updateSlot').modal('hide');
    };

    scope.eventMouseover = function (event, jsEvent, view) {
        //angular.element.attr({
        //     'tooltip': event.title,
        //     'tooltip-append-to-body': true
        // });
        //$compile(angular.element)(scope);
    };
    $(document).ready(function () {
        $('#external-events .fc-event').each(function () {

            // store data so the calendar knows to render an event upon drop
            $(this).data('event', {
                title: $.trim($(this).text()), // use the element's text as the event title
                stick: true // maintain when user navigates (see docs on the renderEvent method)
            });

            // make the event draggable using jQuery UI
            //$(this).draggable({
            //    zIndex: 999,
            //    revert: true,      // will cause the event to go back to its
            //    revertDuration: 0  //  original position after the drag
            //});

        });
    });
    /* config object */
    scope.uiConfig = {
        calendar: {
            height: 500,
            contentHeight: 600,
            //theme: true,
            aspectRatio: 2,
            editable: true,
            eventLimit: true,
            customButtons: {
                myCustomButton: {
                    text: 'custom!',
                    click: function () {
                        alert('clicked the custom button!');
                    }
                }
            },
            agendaFourDay: {
                type: 'agenda',
                duration: { days: 4 },
                buttonText: '4 day',
                className: ['openSesame']
            },
            selectable: true,
            selectOverlap: function(event) {
                return event.rendering === 'background';
            },
            nowIndicator: true,
            isRTL: false,
            weekNumbers: true,
            navLinks: true,
            droppable: true, // this allows things to be dropped onto the calendar
            drop: function () {
                // is the "remove after drop" checkbox checked?
                if ($('#drop-remove').is(':checked')) {
                    // if so, remove the element from the "Draggable Events" list
                    $(this).remove();
                }
            },
            weekNumbersWithinDays: false,
            businessHours: {
                dow: [0, 1, 2, 3, 4, 5, 6],

                start: '07:00', // a start time (10am in this example)
                end: '20:00', // an end time (6pm in this example)
            },
            header: {
                left: 'listMonth, listWeek listDay,  myCustomButton',
                center: 'title',
                right: 'today prevYear,prev,next,nextYear'
            },
            views: {
                listDay: { buttonText: 'list day' },
                listWeek: { buttonText: 'list week' }
            },
            //defaultView: 'listWeek',
            //footer :true,
            allDayText: 'all-day',
            listDayAltFormat: true,
            listDayFormat: true,
            nowIndicator: true,
            eventClick: scope.alertOnEventClick,
            eventDrop: scope.alertOnDrop,
            eventResize: scope.alertOnResize,
            eventRender: scope.eventRender,
            dayClick: scope.dayClick,
            dayPopoverFormat: '',
            eventMouseover: scope.eventMouseover,
            navLinkWeekClick: function (weekStart, jsEvent) {
                // console.log('week start', weekStart.format()); // weekStart is a moment
                // console.log('coords', jsEvent.pageX, jsEvent.pageY);
            },
        }
    };

    scope.changeLang = function () {
        if (scope.changeTo === 'Hungarian') {
            scope.uiConfig.calendar.dayNames = ["Vasárnap", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat"];
            scope.uiConfig.calendar.dayNamesShort = ["Vas", "Hét", "Kedd", "Sze", "Csüt", "Pén", "Szo"];
            scope.changeTo = 'English';
        } else {
            scope.uiConfig.calendar.dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            //scope.uiConfig.calendar.dayNamesShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
            scope.changeTo = 'Hungarian';
        }
    };
    /* event sources array*/
    scope.eventSources = [scope.events, scope.eventSource, scope.eventsF];
    scope.eventSources2 = [scope.calEventsExt, scope.eventsF, scope.events];
}]);
angular.module('mbplus')
.controller('communicationHistoryController', ['$scope', '$analytics', 'UserService', 'UtilitiesService', '$rootScope', 'PlusUtilitiesService', 'navConstantsSvc', '$location', 'filterFilter', function (scope, $analytics, UserService, UtilitiesService, $rootScope, PlusUtilitiesService, navConstantsSvc, $location, filterFilter) {
    $analytics.pageTrack('/appointments');
    if (!UserService.isActive()) {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    scope.compareDate = UtilitiesService.compareDate;
    scope.formatTime = UtilitiesService.formatTime;


    scope.isOpenAccordian = true;
    scope.status = {
        isFirstOpen: true,
    };
    scope.ddlCommunicationType = 'All';

    //date time/........................
    scope.formats = navConstantsSvc.dateFormate;
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];

    scope.dateFilterDate = {
        fromDateFilter: '',
        toDateFilter: ''
    };

    scope.dateDefautOptions = {
        formatYear: 'yy',
        minDate: scope.dateFilterDate.fromDateFilter,
        startingDay: 1
    };

    scope.setMinDate = function (fromDate) {
        scope.mindate = '';
        var setMinDate = fromDate;
        setMinDate.setDate(fromDate.getDate());
        scope.mindate = setMinDate;
        scope.mindate = scope.dateFilterDate.fromDateFilter;
    };

    scope.popup1 = {
        opened: false
    };

    scope.popup2 = {
        opened: false
    };

    scope.open1 = function () {
        scope.popup1.opened = true;
        scope.dateFilterDate.toDateFilter = '';
    };

    scope.open2 = function () {
        scope.popup2.opened = true;
    };

    scope.setMinDate = function (fromDate) {
        scope.mindate = '';
        var setMinDate = fromDate;
        setMinDate.setDate(fromDate.getDate());
        scope.mindate = setMinDate;
        scope.mindate = scope.dateFilterDate.fromDateFilter;
    };
    // date time/........................



    scope.loadCommunicationHistory = function (fromDate, toDate, commType, selectedStatus) {
        if (fromDate || toDate) {
            if (fromDate && !toDate || !fromDate && toDate) {
                UtilitiesService.showAlertMessage('You missed FROM or TO date kindly choose date and try again.');
                return false;
            } else {
                scope.fromDt = fromDate;
                scope.toDate = toDate;
            }
        } else {
            UtilitiesService.showAlertMessage('You missed FROM or TO date kindly choose date and try again.');
            return false;
        }
        scope.ddlCommunicationType = commType;
        scope.statusType = selectedStatus ? selectedStatus : '';
        var data = {
            "fromDate": scope.fromDt,
            "toDate": scope.toDate,
            "requestAccessToken": UserService.getAccessToken(),
            "communicationType": scope.ddlCommunicationType,
            "statusId": scope.statusType ? (scope.statusType.id ? scope.statusType.id : 0) : 0,
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/communicationHistory/', data, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data) {
                scope.dataMsz1 = '';
                scope.dataMsz2 = '';
                var communicationType = '';
                scope.communicationHistoryList = [];
                scope.communicationHistoryList = response.data;
                communicationType = scope.ddlCommunicationType ? (scope.ddlCommunicationType === 'All' ? 'both sms and email' : (scope.ddlCommunicationType === 'Email' ? 'email' : (scope.ddlCommunicationType === 'SMS ALERT' ? 'SMS' : ''))) : '';
                scope.status.isFirstOpen = false;

                scope.dataMsz1 = 'You have selected communication type as ' + ' " ' + communicationType + ' " ';
                scope.stsMsz = scope.statusType ? (scope.statusType.statusName ? scope.statusType.statusName : '') : ''
                scope.statusMsz = ' for status ' + ' " ' + scope.stsMsz + ' " ';
                scope.dataMsz2 = ' consists of ' + scope.communicationHistoryList.length + ' records';


                //downloading part
                scope.downloadCommunicationData = [];
                scope.filename = "Communication_History";
                if (scope.communicationHistoryList) {
                    angular.forEach(scope.communicationHistoryList, function (val, i) {
                        var tempObj = {
                            Name: val.name,
                            Request_Id: val.requestId,
                            ApplicationNo: val.applicationNo,
                            Reciever: val.reciever,
                            Current_Status: val.currentStatus,
                            Date: scope.compareDate(val.communicationSentDate),
                            Time: scope.formatTime(val.communicationSentDate),
                            Delivered_not_delivered: val.isDelivered == true ? 'Delivered' : 'Not Delivered',
                        }
                        scope.downloadCommunicationData.push(tempObj);
                    })
                }
                //downloading part
            }
        },
        function (error) {
        });
    };

    scope.fetchStatus = function () {
        var data = { requestAccessToken: UserService.getAccessToken() };
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + '/allAppointments', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
            if (response.data.isSuccess) {
                scope.statusList = [];
                angular.forEach(response.data.appointmentStatusMaster, function (value, key) {
                    var tempObj = {
                        id: key,
                        statusName: value
                    }
                    scope.statusList.push(tempObj);
                })
            } else {
            }
        },
        function (error) {
        });
    }
    scope.communnicationFilter = {
        statusSearch: { id: '0', statusName: 'All Status' }
    };

    //scope.fetchStatus();

}]);

angular.module('mbplus')
  .controller('claimsCtrl', ['$rootScope', '$scope', '$location', '$timeout', '$filter', '$http', 'UserService', 'UtilitiesService', '$analytics', function ($rootScope, scope, $location, $timeout, $filter, $http, UserService, UtilitiesService, $analytics) {

    $analytics.pageTrack('/claims');
    scope.ctrlName = 'claimsCtrl';
    scope.MaTPAId = UtilitiesService.getMaTpaId();
    scope.MaTpaName = UtilitiesService.getMaTpaName();


    scope.tpaName = {
      id: scope.MaTPAId,
      value: scope.MaTpaName
    };

    scope.hospitalDetails = UserService.getHospitalObj();

    scope.configuredTpaList = [];
    // check for logged in
    if (!UserService.isActive() || (UserService.getUserObj() && UserService.getUserObj().role && UserService.getUserObj().role.toLowerCase() == 'insurer')) {
      UserService.destroyUserObj();
      $location.path('/');
      return false;
    }

    scope.mbAlert = {
      type: 'type',
      text: '<strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.',
      config: {
        timeOut: 1000
      }
    }
    scope.startIndex = 1;
    scope.searchTPA = '';
    scope.hospitalNotification = [];
    scope.preauthClaims = [];

    scope.ctrlFn = function (nextpage) {
      scope.startIndex = nextpage;
      scope.getPreAuthClaimsList();
    };

    (function tick() {
      scope.getNotificatoinCount = function () {
        scope.hospitalNotification = UtilitiesService.hospitalNotification;
        $timeout(function () {
          scope.getNotificatoinCount();
        }, 100);
      };
      scope.getNotificatoinCount();
    })();
    scope.isGetUnprocessedClaims = true;

    //Fetch Active Claims List
    scope.getPreAuthClaimsList = function (tpaId, isDischarge) {

      if (scope.isGetUnprocessedClaims) {
        if (UserService.getHospitalObj()) {
          var ajxData = {
            hospitalId: UserService.getHospitalObj().cmsHospId,
            providerId: UserService.getHospitalObj().hospId,
            startIndexInclusive: scope.startIndex,
            isReimbursement: false,
            hospTPAId: tpaId ? tpaId.id : (scope.tpaName ? scope.tpaName.id : 0),
            schemeType: tpaId && tpaId.isGovtScheme ? tpaId.value : null,
            onlyDischarge: isDischarge
          };
          UtilitiesService.startLoading('fetching active claim data...', 'activeClaims');
          UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/search/openclaims', ajxData, 'POST').then(function (response) {
            UtilitiesService.stopLoading('activeClaims');
            if (response.data.isSuccess) {
              scope.preauthClaims = UtilitiesService.renderClaimsList(response.data, 'preauth');
              scope.preauthClaims.allRecordCount = response.data.allRecordCount;
            } else {
              scope.preauthClaims = null;
              // scope.preauthClaims.allRecordCount = 0;
            }
          });
        }
      }
    };

    if (UserService.getHospitalObj().configuredPayers) {
      // var objArray = Object.entries(UserService.getHospitalObj().configuredPayers);

      angular.forEach(UserService.getHospitalObj().configuredPayers, function (e) {
        scope.configuredTpaList.push({
          hospTPAId: 0,
          isBenefSearchConfigured: e.isBenefSearchEnabled,
          isClaimCreationBlockedWithoutBenef: e.isClaimCreationBlockedWithoutBenef,
          value: e.name,
          id: e.id,
          configuredFields: e.configuredFields
        })
      })

    }

    var configuredTpaList = UtilitiesService.getConfiguredTpa();
    if ((configuredTpaList && configuredTpaList.length > 0) || (scope.hospitalDetails.configuredSchemes &&
        scope.hospitalDetails.configuredSchemes.length > 0)) {

      if (scope.user.userName == '1003736@medibuddy.in' && window.location.hostname === 'uat-plus.medibuddy.in') {
        tempObj = {
          id: 9999,
          value: "Select Payer Name",
          isGovtScheme: false
        }
        scope.configuredTpaList.push(tempObj);

        scope.tpaName = tempObj;
      } else {
        scope.configuredTpaList.push({
          id: scope.MaTPAId,
          value: scope.MaTpaName,
          isGovtScheme: false
        });

        angular.forEach(scope.hospitalDetails.configuredSchemes, function (element) {
          scope.configuredTpaList.push({
            id: scope.MaTPAId,
            value: element,
            isGovtScheme: true
          })
        })
      }
      angular.forEach(configuredTpaList, function (element) {
        scope.configuredTpaList.push({
          id: element.tpaId,
          value: element.tpaName,
          isGovtScheme: false
        })
      });

    }


    // scope.getConfiguredTpaList = function () {

    //   var data = UtilitiesService.getConfiguredTpa();
    //   scope.configuredTpaList = data ? data : [];
    // }

    // scope.getConfiguredTpaList();

    scope.getUnprocessedClaims = function (page) {
      scope.isGetUnprocessedClaims = false;
      if (UserService.getHospitalObj()) {
        var ajxData = {
          hospitalId: UserService.getHospitalObj().cmsHospId,
          startIndexInclusive: page ? page : 1
        };
        UtilitiesService.startLoading('fetching pending claim data...', 'activeClaims');
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/search/unprocessedclaims/', ajxData, 'POST').then(function (response) {
          UtilitiesService.stopLoading('activeClaims');
          scope.isGetUnprocessedClaims = true;
          if (response.data.isSuccess) {
            scope.preauthClaims = UtilitiesService.renderClaimsList(response.data, 'preauth');
            scope.preauthClaims.allRecordCount = response.data.allRecordCount;
          }
        });
      }
    };

    scope.callbackSecond = function (data, value, page, tpaId) {
      if (data === 'Active claim') {
        if (tpaId) {
          scope.startIndex = page ? page : 1;
          scope.getPreAuthClaimsList(tpaId);
        } else {
          scope.getPreAuthClaimsList();
        }

      } else if (data === 'InProgress') {
        scope.getUnprocessedClaims(page);
      }
    };

    $rootScope.$on('signedin', function (event, args) {
      if (args && args === false) {
        $timeout.cancel(promise);
      }
    });

    scope.getPreAuthClaimsList();
    var promise = null;

  }]);

angular.module('mbplus')
.controller('changePwdCtrl', ['$rootScope', '$scope', '$location', '$window', '$http', 'UserService', 'UtilitiesService', 'PlusUtilitiesService', 'md5', function ($rootScope, scope, $location, $window, $http, UserService, UtilitiesService, PlusUtilitiesService, md5) {
  scope.user = {};
  UserService.checkForSession();

  scope.changepwdsuccess = false;

  scope.gotoClaims = function () {
    if (UserService.isActive()) {
      scope.getUserDefaultRoute = UserService.getUserDefaultRoute(PlusUtilitiesService.getMenuDetails());
      $location.path(scope.getUserDefaultRoute).replace()
    }
    else {
      UserService.destroyUserObj();
      $location.path('/');
    }
  };
  scope.changePassword = function () {
    if (scope.user.oldpassword === scope.user.newpassword) {
      $('#pwdMessage').show();
      $('#pwdMessage').text('New password and old password cannot be same.');
    }
    else if (scope.user.newpassword != scope.user.confirmpassword) {
      $('#pwdMessage').show();
      $('#pwdMessage').text('New password and confirm password should match.');
    }
    else {
      $('#pwdMessage').hide();
      var data ={
        userId: UserService.getUserObj().userId,
        logonName: UserService.getUserObj().userName,
        oldPassword: scope.user.oldpassword,
        newPassword: scope.user.newpassword,
        accessToken: UserService.getAccessToken()
      };
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/user/changepassword', data, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          scope.changepwdsuccess = true;
          UserService.destroyUserObj();
          $rootScope.$emit('signedin', false);
          scope.user = null;
        }
        else {
          UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        }
      }, function (error) {
          UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
      });
    }
  }
}]);
angular.module('mbplus')
.controller('cancelledCtrl', ['$rootScope', '$scope', '$location', '$window', '$http', 'UserService', 'UtilitiesService', function ($rootScope, scope, $location, $window, $http, UserService, UtilitiesService) {
  //$analytics.pageTrack('/cancelled');
  scope.$root.title = 'Cancelled Claims | Medibuddy Hospital Portal';
  scope.isActive = UserService.isActive();
  if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == "insurer") {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }
  scope.formatCurrency = UtilitiesService.formatCurrency;
  scope.compareDate = UtilitiesService.compareDate;
  $("#sidebar li").removeClass("active");
  $("#sidebar li#cancelled").addClass("active");
  $rootScope.showAll = false;
  scope.hasNoResults = true;
  scope.cancelledClaims = [];
  scope.preauthfiltered = [{
    approvedAmount: 0,
    claimId: "91821055",
    claimRefNo: "MA6166396161",
    claimedAmount: 10000,
    conversationCount: 3,
    dateOfAdmission: "/Date(1453141800000+0530)/",
    dateOfDischarge: "/Date(1609439400000+0530)/",
    id: 4003406688,
    paApprovedAmount: 0,
    patientName: "Shruthi Murali",
    procedure: "Cashless",
    scheme: 0,
    secClaimId: undefined,
    status: "Pre-Auth In Progress",
  }]

  if (scope.isActive) {
    var user = UserService.getUserObj();
    var hospId = user.entityId;
    $http.get(UtilitiesService.getUrlPrefix() + "/hosp/search/cancelledclaims.json?hospId=" + UserService.getHospitalObj().hospId).
    success(function (data) {
      if (data.isSuccess) {
        if (data.cancelledClaims.length > 0) {
          scope.hasNoResults = false;
        }
        else {
          scope.hasNoResults = true;
        }
        scope.cancelledClaims = data.cancelledClaims;
      }
      else {
        scope.hasNoResults = true;
      }
    }).
    error(function () {
      // console.log("Ajax call failed");
    });
  }
  else {
  }
}]);
angular.module("mbplus")
.controller('bookappointmentController', ['$scope', 'UserService', 'UtilitiesService', 'geolocation', 'filterFilter', 'PlusUtilitiesService', function (scope, UserService, UtilitiesService, geolocation, filterFilter, PlusUtilitiesService) {
        scope.points = [];
        scope.btnClicked = false;
        scope.markerArray = [];
        scope.showHomeVisit = false;
        scope.isMap = true;
        scope.dcName = "";
        scope.bookToday = false;
        scope.successMessage = false;
        scope.failedMessage = false;
        scope.alreadyBookMsz = false;
        scope.showMap = false;
        scope.isLocationOn = false;
        scope.dcSearchDC = true;
        scope.selectDist = false;
        scope.firstPage = true;
        scope.selfAlloHomeVisit = false;
        scope.package_Id = '';
        scope.apptId = '';
        $('#DcMap').modal('show');
        scope.windowOptions = {};
        scope.noUrlData = false;
        scope.noUrlDataTxt = '';
        scope.isAllowCurrentLoc = true;
        scope.requestUpdate = false;
        scope.getDateObj = UtilitiesService.getDateObj;
        scope.compareDate = UtilitiesService.compareDate;

        scope.displayMonth = function (noOfMonth) {
            scope.monthName = '';
            if (noOfMonth) {
                switch (noOfMonth) {
                    case 1:
                        scope.monthName = 'Jan';
                        break;
                    case 2:
                        scope.monthName = 'Feb';
                        break;
                    case 3:
                        scope.monthName = 'Mar';
                        break;
                    case 4:
                        scope.monthName = 'Apr';
                        break;
                    case 5:
                        scope.monthName = 'May';
                        break;
                    case 6:
                        scope.monthName = 'Jun';
                        break;
                    case 7:
                        scope.monthName = 'Jul';
                        break;
                    case 8:
                        scope.monthName = 'Aug';
                        break;
                    case 9:
                        scope.monthName = 'Sep';
                        break;
                    case 10:
                        scope.monthName = 'Oct';
                        break;
                    case 11:
                        scope.monthName = 'Nov';
                        break;
                    case 12:
                        scope.monthName = 'Dec';
                        break;
                    default:
                        scope.monthName = 'No Month';
                        break;
                }
            }
        }
        //Time limit
        var d = new Date();
        d.setHours(7);
        d.setMinutes(30);
        scope.min = d;
        var types = 'changetype-all';
        var d = new Date();
        d.setHours(12);
        d.setMinutes(1);
        scope.max = d;
        scope.mindate = '';
        scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0));
        };
        scope.popup1 = {
            opened: false
        };
        scope.popup2 = {
            opened: false
        };
        scope.open1 = function () {
            scope.popup1.opened = true;
        };
        scope.open2 = function () {
            scope.popup2.opened = true;
        };
        scope.options = {
            draggable: false
        };
        scope.ismeridian = false;
        scope.hstep = 1;
        scope.mstep = 30;

        scope.mindate = new Date();
        var first = new Date();
        var dd = new Date(first).getDate();
        var mm = new Date(first).getMonth() + 1;
        var yy = new Date(first).getFullYear();
        var hh = 7;
        var ms = 0;
        var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
        scope.secondTime = new Date(x);
        scope.secondTime.setHours(8)
        scope.secondTime.setMinutes(30)
        scope.firstTime = new Date(x);
        scope.firstTime.setHours(8)
        scope.firstTime.setMinutes(30)
        var maxFirstValue = new Date();
        maxFirstValue.setHours(18);
        maxFirstValue.setMinutes(0);
        scope.maxFirstValue = maxFirstValue;
        var minFirstValue = new Date();
        minFirstValue.setHours(8);
        minFirstValue.setMinutes(30);
        scope.minFirstValue = minFirstValue;
        var maxFirst = new Date();
        maxFirst.setHours(18);
        maxFirst.setMinutes(0);
        scope.maxFirst = maxFirst;
        var minFirst = new Date();
        minFirst.setHours(8);
        minFirst.setMinutes(30);
        scope.minFirst = minFirst;

        scope.dist = { data: '' };

        scope.distanceData = [{ 'id': 2, 'Value': '2 KM' }, { 'id': 5, 'Value': '5 KM' }, { 'id': 10, 'Value': '10 KM' }, { 'id': 15, 'Value': '15 KM' }, { 'id': 20, 'Value': '20 KM' }];
        scope.dist = { data: { 'id': 2, 'Value': '2 KM' } };

        scope.$watch('myScopeVar', function (term) {

            // TODO: Event on Page Landing
            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_PAGE_LOAD",
                scope : scope.idFromUrl
            }, "post")

            if (term) {
                scope.selectDist = false;
                scope.dcSearchDC = false;
                //scope.isMap = true;
                scope.selectDist = true;
                points = term;
                if (scope.dist.data.id) {
                    scope.getLatLongAddr(points, scope.dist.data.id, 'searchFromSearchBox');
                } else {
                    scope.getLatLongAddr(points, 'searchFromSearchBox');
                }
            }
        }, true);

        scope.setDateAfterOneDay = function () {

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_DATE_AFTER_ONE_DAY",
                scope : scope.idFromUrl
            }, "post");

            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            var afterTomorrow = new Date();
            afterTomorrow.setDate(tomorrow.getDate());
            scope.mindate = afterTomorrow;
            scope.displayMonth((scope.mindate.getMonth() + 1));
            scope.displayMinDate = scope.mindate.getDate() + '-' + scope.monthName + '-' + scope.mindate.getFullYear();
        };
        scope.setDateAfterTwoDay = function () {

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_SET_DATE_AFTER_TWO_DAY",
                scope : scope.idFromUrl
            }, "post");

            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            var afterTomorrow = new Date();
            afterTomorrow.setDate(tomorrow.getDate() + 1);
            scope.mindate = afterTomorrow;
            scope.displayMonth((scope.mindate.getMonth() + 1));
            scope.displayMinDate = scope.mindate.getDate() + '-' + scope.monthName + '-' + scope.mindate.getFullYear();
        };
        scope.setDateAfterThreeDay = function () {

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_SET_DATE_AFTER_THREE_DAY",
                scope : scope.idFromUrl
            }, "post");

            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            var afterTomorrow = new Date();
            afterTomorrow.setDate(tomorrow.getDate() + 2);
            scope.mindate = afterTomorrow;
            scope.displayMonth((scope.mindate.getMonth() + 1));
            scope.displayMinDate = scope.mindate.getDate() + '-' + scope.monthName + '-' + scope.mindate.getFullYear();
        };

        scope.checkDate = function () {

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_CHECK_DATE",
                scope : scope.idFromUrl
            }, "post");

            var currentTime = new Date();
            scope.checkTime = currentTime.getHours();
            if (scope.checkTime && scope.checkTime < 15 && scope.checkTime > 0) {
                scope.bookToday = true;
                scope.setDateAfterOneDay();
            }
            else{
                if(scope.checkTime && scope.checkTime > 15 && currentTime.getDay() === 6)
                {
                    scope.bookToday = false;
                    scope.setDateAfterThreeDay();
                }
                else {
                    scope.bookToday = false;
                    scope.setDateAfterTwoDay();
                }
            }

        };

        scope.searchMap = function (value) {

            // TODO: Map Search value>> 
            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_SEARCH_MAP",
                scope : scope.idFromUrl
            }, "post");

            if (value) {
                scope.getLatLongAddr(value, scope.dist.data.id, 'searchFromSearchBox');
            }
        };
        scope.showMarkerInfo = function (markerObj, $event) {

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_SHOW_MARKER_INFO",
                scope : scope.idFromUrl
            }, "post");

            scope.firstDate = '';
            scope.secondDate = '';
            if (scope.currentId) {
                scope.windowOptions[scope.currentId].visible = false;
            }
            scope.dcName = markerObj.name;
            scope.currentId = markerObj.id;
            scope.dcAddressPin = markerObj.entityAddress + ' - ' + markerObj.pinCode;
            scope.windowOptions[markerObj.id].visible = true;
            scope.loadEmployeeDetails();
            scope.checkDate();

        };

        scope.closeClick = function (id, $event) {

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_CLOSE_CLICK",
                scope : scope.idFromUrl
            }, "post");

            scope.windowOptions[id].visible = false;
        };

        scope.requestUpdateCall = function () {
            if (scope.IsRequestUpdate && scope.idFromUrl) {
                var ajaxData = { "encryptedDetails": scope.idFromUrl }
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "EncryptedRequest.json", ajaxData, "POST").then(function (response) {
                    scope.customerDetails = response.data;
                    scope.requestUpdate = true;
                    scope.checkDate();
                })
            }
        }

        scope.getLatLongAddr = function (points, dist, searchFromSearchBox, isreqDdl) {
            console.log("Scope on Radius Change >> ", scope);

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_GET_LAT_LONG_ADDR",
                scope : scope.idFromUrl
            }, "post");

            // TODO: Add Event on Change of Distance from DC

            scope.distanceForDc = dist ? dist : 2;
            scope.zoom = (scope.distanceForDc == 2 ? scope.zoom = 12 : scope.distanceForDc == 5 ? scope.zoom = 10 : scope.distanceForDc == 10 ? scope.zoom = 8 : scope.distanceForDc == 10 ? scope.zoom = 6 : scope.zoom = 12);
            scope.radius = scope.distanceForDc * 1000;

            if (points && points.geometry && points.geometry.location) {
                scope.lati = points.geometry.location.lat();
                scope.logi = points.geometry.location.lng();
            } if (points && points.latitude && points.longitude) {
                scope.lati = points.latitude;
                scope.logi = points.longitude;
            }
            if (!points) {
                scope.lati = 12.952;
                scope.logi = 77.6;
            }
            if (scope.lati && scope.logi) {
                scope.map = {
                    center: {
                        latitude: scope.lati,
                        longitude: scope.logi
                    },
                    stroke: {
                        color: '#08B21F',
                        weight: 2,
                        opacity: 1
                    },
                    fill: {
                        color: '#08B21F',
                        opacity: 0.5
                    },
                    radius: scope.radius,
                    visible: true,
                    zoom: 12
                }
            }

            scope.idFromUrl = UserService.dcUrl;
            scope.IsRequestUpdate = UserService.IsRequestUpdate;
            if (scope.idFromUrl) {
                var ajaxData = {
                    "encryptedDetails": scope.idFromUrl,
                    "latitude": scope.lati,
                    "longitude": scope.logi,
                    "distance": scope.distanceForDc,
                    "isRequestUpdate": scope.IsRequestUpdate ? scope.IsRequestUpdate : false,
                    "IsVisitTypeChanged": scope.isSelectedVisitType
                }
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "getDcafterDecryption.json", ajaxData, "POST").then(function (response) {
                    scope.dcDetails = response.data;
                    //if (scope.dcDetails && searchFromSearchBox != 'searchFromSearchBox') {
                    //    scope.isMap = false;
                    //}
                    if (isreqDdl && isreqDdl !== 'requestByDdl') {
                        if (searchFromSearchBox != 'searchFromSearchBox' && scope.IsRequestUpdate) {
                            scope.requestUpdate = true;
                            scope.showHomeVisit = false;
                            scope.checkDate();
                        }
                        if (searchFromSearchBox != 'searchFromSearchBox' && !scope.IsRequestUpdate) {
                            scope.requestUpdate = false;
                            scope.showHomeVisit = true;
                        }
                    }
                    if ((!scope.dcDetails.isBookAppointment && scope.dcDetails.packageProviders) || (scope.IsRequestUpdate)) {
                        scope.package_Id = scope.dcDetails.packageID;
                        scope.markerArray = [];
                        for (i = 0; i < scope.dcDetails.packageProviders.length; i++) {

                            scope.markerArray.push({
                                id: scope.dcDetails.packageProviders[i].id,
                                entityAddress: scope.dcDetails.packageProviders[i].entityAddress,
                                pinCode: scope.dcDetails.packageProviders[i].pinCode,
                                coords: {
                                    latitude: scope.dcDetails.packageProviders[i].latitude,
                                    longitude: scope.dcDetails.packageProviders[i].longitude,
                                },
                                name: scope.dcDetails.packageProviders[i].entityName,
                            });

                            scope.windowOptions[scope.dcDetails.packageProviders[i].id] = {
                                visible: false,
                            }
                            if (scope.dcDetails.packageProviders.length <= 10) {

                                scope.markerArray[i].options = {
                                    labelClass: 'marker_labels',
                                    labelAnchor: '12 60',
                                    labelColor: 'red',
                                    labelContent: scope.dcDetails.packageProviders[i].entityName
                                }
                            }

                        }
                    }
                    else {
                        scope.showMap = false;
                        scope.alreadyBookMsz = true;
                        scope.isMap = false;
                        scope.firstPage = false;
                    }
                })
                scope.map = {
                    center: {
                        latitude: scope.lati,
                        longitude: scope.logi
                    },
                    stroke: {
                        color: '#08B21F',
                        weight: 2,
                        opacity: 1
                    },
                    fill: {
                        color: '#08B21F',
                        opacity: 0.5
                    },
                    radius: scope.radius,
                    geodesic: true, // optional: defaults to false
                    visible: true,
                    zoom: 12
                }
            } else {
                scope.dcSearchDC = false;
                scope.noUrlData = true;
                scope.isMap = false;
            }
        };



        scope.getTestDetails = function (test) {

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_GET_TEST_DETAILS",
                scope : scope.idFromUrl
            }, "post");

            scope.investigationList = [];
            if (test.testID) {
                var url = UtilitiesService.getPlusUrlPrefix() + 'PackageEntityRelation/' + test.testID;
                UserService.makeRestCall(url, '', 'GET', UserService.getAccessToken()).then(function (response) {
                    if (response.data) {
                        var investigation = response.data.allowedInvestigations;
                        var investigationGroup = [];
                        angular.forEach(investigation, function (v, i) {
                            investigationGroup.push(v.groupName);
                        })
                        var listOfUniqeInvestigations = investigationGroup.filter(function (val, index, allArr) {
                            return index == allArr.indexOf(val);
                        })
                        angular.forEach(listOfUniqeInvestigations, function (val, ind) {
                            var investigationWiseTests = filterFilter(investigation, val);
                            var testObj = investigationWiseTests;
                            scope.testDetails = [];
                            angular.forEach(testObj, function (v, i) {
                                scope.testDetails.push({
                                    groupName: v.groupName,
                                    testName: v.name,
                                    testId: v.id,
                                    groupId: v.groupId,
                                    isActive: v.isActive,
                                    duplicateCheck: v.duplicateCheck,
                                    quantity: v.quantity
                                })
                            })
                            scope.investigationList.push({
                                investigationName: val,
                                testDetails: scope.testDetails
                            })
                        })
                    } else {
                        alert('No Investigations found.');
                    }
                })
            } else {
                alert('Product Id is unavailable.');
            }
        };

        scope.loadEmployeeDetails = function () {

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_LOAD_EMPLOYEE_DETAILS",
                scope : scope.idFromUrl
            }, "post");

            if (scope.IsRequestUpdate) {
                scope.customer = scope.customerDetails;
                return false;
            }
            if (scope.idFromUrl && !scope.IsRequestUpdate) {
                var data = { "encryptedDetails": scope.idFromUrl }
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "getPBRequestByReqId.json", data, "POST").then(function (response) {
                    if (response.data) {
                        scope.customer = response.data;
                        var testdetail = JSON.parse(scope.customer.requestJSON);
                        scope.testnames = testdetail.testDetails;
                        scope.employeeid = testdetail.employeeId;
                        scope.nameOfTest = [];
                        $.each(scope.testnames, function (i, val) {
                            scope.nameOfTest.push(val.testName)
                        })
                    } else {
                        UtilitiesService.showAlertMessage('Unable to fetch user details.');
                    }
                })
            } else {
                UtilitiesService.showAlertMessage('Request id not available.');
            }
        };

        scope.getMap = function (dist) {

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_GET_MAP",
                scope : scope.idFromUrl
            }, "post");

            if (dist.data.id > 0) {
                scope.distError = '';
                scope.selectDist = true;
                if (scope.map && scope.map.center) {
                    scope.showMap = true;
                    scope.selectDist = true;
                    scope.getLatLongAddr(scope.map.center, dist.data.id, '', 'requestByDdl');
                }
                if (scope.lati && scope.logi) {
                    points = {
                        latitude: scope.lati,
                        longitude: scope.logi
                    }
                }
                else {
                    scope.getLatLongAddr();
                    scope.distError = 'Please Try After Some time by clicking on the link again';
                }
            }
        };


        scope.bookAppointment = function (homeVisit, date, time) {

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_BOOK_APPOINTMENT",
                scope : scope.idFromUrl
            }, "post");

            scope.btnClicked = true;
            var homeVisitValue = homeVisit;
            date ? scope.firstDate = date : '';
            time ? scope.firstTime = time : '';
            scope.idFromUrl = UserService.dcUrl;
            scope.IsRequestUpdate = UserService.IsRequestUpdate;
            if (scope.firstDate && scope.firstTime && scope.idFromUrl) {
                if (homeVisit) {
                    if (!scope.addressLineOne) {
                        alert('Kindly fill address Line 1 ');
                        scope.btnClicked = false;
                        return false;
                    }
                }
                if (!homeVisit) {
                    var homeVisitValue = homeVisitValue ? homeVisitValue : (scope.customerDetails ? scope.customerDetails.isHomeVisit : '');
                }
                var firstHrSec = scope.firstTime.getHours() + '.' + scope.firstTime.getMinutes();
                var SecondHrSec = scope.secondTime.getHours() + '.' + scope.secondTime.getMinutes();
                var finalFirstHrSec = parseFloat(firstHrSec);
                var finalSecondHrSec = parseFloat(SecondHrSec);
                scope.firstPrefTime = UtilitiesService.mergeDateTimeObj(scope.firstDate, scope.firstTime);
                scope.secondPrefTime = UtilitiesService.mergeDateTimeObj(scope.secondDate, scope.secondTime);

                var bookAppointmentRequest = {
                    "packageIds": scope.package_Id ? scope.package_Id : '',
                    "appointmentDateFirstPref": scope.firstPrefTime ? scope.firstPrefTime : (scope.customerDetails ? (scope.customerDetails.appointmentDate ? scope.customerDetails.appointmentDate : '') : ''),
                    "appointmentDateSecondPref": scope.secondPrefTime,
                    "DCId": scope.currentId ? scope.currentId : 0,
                    "DCName": scope.dcName ? scope.dcName : '',
                    "homeVisit": homeVisitValue,
                    "addressLine1": scope.addressLineOne ? scope.addressLineOne : '',
                    "addressLine2": scope.addressLineTwo ? scope.addressLineTwo : '',
                    "isRequestUpdate": scope.IsRequestUpdate,
                    "encryptedDetails": scope.idFromUrl
                }

                UtilitiesService.startLoading('Please Wait...', 'BookAppointmentTab');
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "updateDCForPBRequest.json", bookAppointmentRequest, "post").then(function (response) {
                    if (!homeVisit && !scope.IsRequestUpdate) {
                        scope.closeClick(scope.currentId);
                    }
                    if (response.data.isSuccess == true) {
                        scope.isRequestUpdate = (response.data.isRequestUpdate === true) ? true : false;
                        if (!homeVisit) {
                            $("#BookAppointmentBlock").modal("hide");
                        }
                        scope.requestUpdate = false;
                        scope.dcSearchDC = false;
                        scope.showMap = false;
                        scope.successMessage = true;
                        scope.apptId = response.data.orderId
                    } else {
                        scope.btnClicked = false;
                        if (!homeVisit) {
                            $("#BookAppointmentBlock").modal("hide");
                        }
                        scope.requestUpdate = false;
                        scope.dcSearchDC = false;
                        scope.showMap = false;
                        scope.failedMessage = true;
                    }
                    scope.map.visible = false;
                    scope.isMap = false;
                    scope.markerArray = [];
                    UtilitiesService.stopLoading('BookAppointmentTab');
                })
            } else {
                scope.btnClicked = false;
                UtilitiesService.showAlertMessage('Kindly choose date time ');
                return false;
            }
        };
        var input = /** @type {!HTMLInputElement} */(document.getElementById('searchInput'));
        scope.loadMap = function (currLat, currLon) {

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_LOAD_MAP",
                scope : scope.idFromUrl
            }, "post");

            scope.map = {
                center: {
                    latitude: currLat,
                    longitude: currLon
                },
                stroke: {
                    color: '#08B21F',
                    weight: 2,
                    opacity: 1
                },
                fill: {
                    color: '#08B21F',
                    opacity: 0.5
                },
                bounds: {},
                options: {
                    streetViewControl: false,
                    panControl: false,
                    maxZoom: 20,
                    minZoom: 3,
                    autocomplete: true,
                    types: ['cities'],
                    componentRestrictions: {
                        country: 'IN'
                    }
                },
                radius: 10000,
                geodesic: true, // optional: defaults to false
                clickable: true, // optional: defaults to true
                editable: true, // optional: defaults to false
                visible: true,
                zoom: 12,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            points = {
                latitude: currLat,
                longitude: currLon
            }
            scope.getLatLongAddr(points);
            angular.element('#searchInput').val('');
            var editableLatLng = new google.maps.LatLng(
                     scope.map.latitude,
                    scope.map.longitude
                );
        };

        scope.isSelectedVisitType = false;
        scope.getHomeDcVisit = function (ishomeOrDcvisit) {

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_GET_HOME_DC_VISIT",
                scope : scope.idFromUrl
            }, "post");

            if (ishomeOrDcvisit != "") {
                if (ishomeOrDcvisit === "homeVisit") {
                    scope.isSelectedVisitType = false;
                    scope.showHomeVisitElem = true;
                    scope.selfAlloHomeVisit = true;
                    scope.loadEmployeeDetails();
                    scope.minFirstValue.setHours(7);
                    scope.minFirstValue.setMinutes(0);
                    scope.minFirst.setHours(7);
                    scope.minFirst.setMinutes(0);
                }
                if (ishomeOrDcvisit === "dcVisit") {
                    scope.isSelectedVisitType = true;
                    scope.showHomeVisitElem = false;
                }
            }
            scope.checkDate();
        }

        scope.changeDc = function (dcCheck) {

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_CHANGE_DC",
                scope : scope.idFromUrl
            }, "post");

            if (dcCheck) {
                if (scope.requestUpdate) {
                    var customerDetail = scope.customerDetails
                    points = {
                        latitude: customerDetail.latitude,
                        longitude: customerDetail.longitude
                    }
                    scope.requestUpdate = false;
                    scope.selectDist = true;
                    scope.isMap = true;
                    scope.dcSearchDC = false;
                    scope.getLatLongAddr(points, '', 'searchFromSearchBox');
                }
            }
        }

        scope.loadCurrentLocation = function (value) {

            UserService.makeRestCall("https://fuser.medibuddy.in/api/v1/events/provider/capture", {
                eventType : "SAL_LOAD_CURRENT_LOCATION",
                scope : scope.idFromUrl
            }, "post");

            var input = /** @type {!HTMLInputElement} */(document.getElementById('searchInput'));
            if (value === 'close') {
                scope.dcSearchDC = false;
                scope.selectDist = true;
                scope.loadMap(scope.currLat, scope.currLon);
            }
            angular.element(document).ready(function () {
                geolocation.getLocation().then(function (position) {
                    scope.position = position;
                    scope.isLocationOn = false;
                    scope.currLat = position.coords.latitude
                    scope.currLon = position.coords.longitude;
                    scope.getLatLongAddr();
                }, function (reason) {
                    if (reason === 'You have rejected access to your location') {
                        scope.getLatLongAddr();
                        scope.isLocationOn = true;
                        scope.isAllowCurrentLoc = false;
                        scope.idFromUrl = UserService.dcUrl;
                        scope.IsRequestUpdate = UserService.IsRequestUpdate;

                    }
                    var options = {
                        enableHighAccuracy: true,
                        timeout: 5000,
                        maximumAge: 0
                    };
                    function success(pos) {
                        var crd = pos.coords;
                    };
                    function error(err) {
                        notification.onclick = function (x) {

                        };
                    };
                });
            });
            scope.idFromUrl = UserService.dcUrl;
            scope.IsRequestUpdate = UserService.IsRequestUpdate;
            if (scope.IsRequestUpdate) {
                scope.requestUpdate = true;
                scope.requestUpdateCall();
                return false;
            }
        };
        scope.loadCurrentLocation();
    }]);
angular.module('mbplus')
.controller('atalAmritAbhiyanCtrl', ['$scope', '$location', '$state', '$timeout', 'UserService', 'UtilitiesService', 'filterFilter', '$uibModal', 'FastrackService', 'GovernmentService', 'FileUploadService', 'NewAdmissionFormService', '$analytics', '$q', function (scope, $location, state, timeout, UserService, UtilitiesService, filterFilter, $uibModal, FastrackService, GovernmentService, FileUploadService, NewAdmissionFormService, $analytics, $q) {
    $analytics.pageTrack('/newAdmission/');
    scope.ctrlName = 'newAdmissionFormCtrl';
    if (!UserService.isActive()) {
        UserService.destroyUserObj();
        return false;
    }
    scope.checkPhoneNumber = '^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$';
    scope.govType = 'B';

    scope.numberValidation = '((?:1){8}|(?:2){8}|(?:3){8}|(?:4){8}|(?:5){8}|(?:6){8}|(?:7){8}|(?:8){8}|(?:9){8}|(?:0){8})';
    scope.mobileValidation = function (number) {
        if (number) {
        } else {
        }
    };
    scope.isShowMaid = true;
    scope.isEBill = UtilitiesService.checkEBillHospital(UserService.getHospitalObj().hospId);
    scope.tpaFormReset = function () {
        scope.tpaForm = {
            name: { id: 0, value: '--Select TPA Name--' },
            mailServerAddress: '',
            mailServerPort: '',
            useSSl: '',
            hospMailId: '',
            hospPassword: '',
            tpaMailId: '',
            outGoingServerPort: '',
            tpaHospId: '',
            outGoingServerAddress: '',
            tpaId: 0
        }
    };
    scope.tpaFormReset();
    scope.tpaForm.name = { id: 0, value: '--Select TPA Name--' };
    scope.resetFormData = function () {
        scope.form = {
            roomtype: '',
            fileNames: [],
            tpaId: 0,
            fileUploadFolderPath: [],
            doa: null,
            dod: null,
            packageAmount: '',
            clmamount: 0,
            procedure1: '',
            mPackageTotalAmount: '',
            mPackageFullName: '',
            packageName: '',
            cappedAmount: '',
            packageUniqueId: '',
            fullname: '',
            memberId: '',
            URNNum: '',
            adFolderPath: [],
            employer: '',
            empid: '',
            maid: '',
            policyno: '',
            age: '',
            gender: '',
            preauthSuccess: false,
            preauthError: false,
            insurername: '',
            isgovtscheme: '',
            mobile: '',
            diagnosis: '',
            procedure: '',
            admissiontype: '',
            docname: '',
            ipnumber: '',
            IsGovtClaim: true,
            memberDist: '',
            reasonOnline: '',
            memberGender: '',
            memberAge: '',
            uidno: '',
            tpaName: '',
            uniqueId: '',
            hospTPAId: 0
        }
    };
    scope.resetFormData();
    scope.fileUploaName = [];
    scope.getDateObj = UtilitiesService.getDateObj;
    scope.isProcessing = false;
    scope.doctorDetails = [];
    scope.roomsDetails = [];
    scope.isSearchButton = true;
    scope.userObject = UserService.getUserObj();

    scope.getDoctorDetails = function () {
        var ajaxData = { hospId: UserService.getHospitalObj().hospId, getDoctors: true, getRooms: true, getOpPackages: false, getContracts: false };
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/hospProfileDetails', ajaxData, 'POST').then(function (response) {
            if (response.data.isSuccess) {
                scope.doctorDetails = response.data.hospDoctorDetails;
            }
        }, function (error) {
            scope.doctorDetails = [];
        });
    };
    scope.getDoctorDetails();

    scope.selectedMappedpackages = [];
    scope.packageCalcAmount = 0;
    scope.calculatePrice = function () {
        scope.packageCalcAmount = 0;
        angular.forEach(scope.selectedMappedpackages, function (data, index) {
            if (data.general_Ward1 || data.private_Ward1 || data.semi_Private_Ward1) {
                var price = data.general_Ward1 === true ? 'general_Ward' : data.private_Ward1 === true ? 'private_Ward' : data.semi_Private_Ward1 === true ? 'semi_Private_Ward' : ''
                scope.packageCalcAmount = scope.packageCalcAmount + scope.selectedMappedpackages[index][price];
            }
        });
        scope.form.clmamount = scope.packageCalcAmount;
    };
    scope.reasonOnlineField = 'procedure';
    scope.changePackageField = function (value) {
        scope.form.procedure1 = '';
        scope.form.mPackageTotalAmount = '';
        scope.form.mPackageFullName = '';
        scope.reasonOnlineField = value;
    };

    scope.changeGovtPolicyType = function (type) {
        scope.form.packageAmount = '';
        scope.form.mPackageAmount = '';
        scope.form.packageName = '';
        scope.form.packageUniqueId = '';
        scope.form.cappedAmount = '';
        scope.text = '';
        if (type) {
            if (type === 'Basic') {
                var obje = [];
                angular.forEach(scope.govtPackageListDummy, function (value, key) {
                    if (type === value.type) {
                        obje.push(value);
                    }
                });
                scope.govtPackageList = obje;
            } else if (type === 'Critical') {
                var obje = [];
                angular.forEach(scope.govtPackageListDummy, function (value, key) {
                    if (type === value.type) {
                        obje.push(value);
                    }
                });
                scope.govtPackageList = obje;
            }
        }
    };
    scope.preauthFormAction = (function () {
        scope.insuranceCompanyList = UtilitiesService.getInsuranceCompanyName();
        scope.username = UserService.getUserObj().userName;
        scope.showAutoPackages = true;
        function submitPreauthFormSuccess(successData) {
            scope.isProcessing = false;
            if (successData.data.isSuccess) {
                scope.form.preauthSuccess = true;
            }
            else {
                scope.form.preauthError = true;
            }
        }
        function submitPreauthFormError(ErrorData) {
            scope.isProcessing = false;
            scope.form.preauthError = true;
        }
        function fileUploadError(errordata) {
            scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'File Upload Error', 'Error', true);
        }
        return {
            validatePreauthForm: function () { },
            getPreauthFormData: function (form) {
                var data = {
                    "IsGovtClaim": false,
                    "MemberGender": form.gender == undefined ? '' : form.gender,
                    "Age": form.age == undefined ? '' : form.age,
                    "ApplicationName": "Hospital Portal",
                    "PatientFirstName": form.fullname,
                    "ContactNum": form.mobile,
                    "EmpId": form.empid,
                    "Employer": form.employer,
                    "Maid": form.maid,
                    "Doa": form.doa,
                    "ApproxClaimedAmnt": form.clmamount,
                    "DocName": form.docname,
                    "DocRegNo": "String",
                    "Diagnosis": form.diagnosis,
                    "AdmissionType": form.admissiontype,
                    "RoomType": form.roomtype,
                    "TentativeDOD": form.dod,
                    "HospId": UserService.getHospitalObj().hospId,
                    "HospName": UserService.getHospitalObj().hospName,
                    "CreatedBy": UserService.getUserObj().userId,
                    "IpNumber": form.ipnumber,
                    "Procedure": form.procedure,
                    "IpAddress": "String",
                    "PolicyNumber": form.policyno,
                    "InsurerName": form.insurername,
                    "FileNames": form.fileNames,
                    "FileUploadFolderPath": form.fileUploadFolderPath.join(),
                    "uiD_NO": form.uidno
                };
                return data;

            },
            uploadFiles: function (callback) {
                scope.form.fileNames = [];
                scope.form.fileUploadFolderPath = [];
                var fileBlobArray = [];
                if (scope.preAuthFile) {
                    Object.keys(scope.preAuthFile).forEach(function (e) {
                        if (typeof (scope.preAuthFile[e]) == 'object') {
                            scope.file.push({
                                'model': scope.preAuthFile[e]
                            });
                        }
                    });
                }
                var filesUploadingArray = [];
                Object.keys(scope.file).forEach(function (ele) {
                    if (typeof (scope.file[ele].model) == "object") {
                        filesUploadingArray.push(scope.file[ele].model);
                    }
                });
                if (filesUploadingArray.length > 0) {
                    fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
                }
                else {
                    scope.isProcessing = false;
                    UtilitiesService.showAlertMessage('Please attach atleast one document.');
                    return false;
                }
                $q.all(fileBlobArray).then(function (result) {
                    result.forEach(function (element) {
                        if (element.data.isSuccess) {
                            angular.forEach(element.data.uploadResponseDetails, function (e, i) {
                                scope.form.fileNames.push(e.fileName);
                                scope.form.fileUploadFolderPath.push(e.downloadURL);
                            });
                        }
                        else {
                            scope.isProcessing = false;
                            scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                            return false;
                        }
                    });
                    if (result && (filesUploadingArray.length == 0 || scope.form.fileNames.length == result[0].data.uploadResponseDetails.length))
                        callback.call(scope.preauthFormAction);
                },
                function (error) {
                    scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                    scope.isProcessing = false;
                });
            },
            submitPreauthForm: function () {
                scope.isProcessing = true;
                this.uploadFiles(function () {
                    if (!scope.form.isgovtscheme) {
                        NewAdmissionFormService.submitPreauthForm(this.getPreauthFormData(scope.form)).then(submitPreauthFormSuccess, submitPreauthFormError)
                    }
                    else {
                        if (scope.selectedPackages.length !== 0) {
                            scope.govtSchemeMethods.submitPreauthForm();
                        } else {
                            UtilitiesService.showAlertMessage('Please add atleast one government package.')
                        }
                    }
                });
            },
            closePreauthForm: function () {
                scope.form = {};
                //$location.path('/');
                $location.path('/claims');
            },
            downloadPrefilledPreauthForm: function (source) {
                var PreauthFormDataObj = {
                    HospitalID: UserService.getHospitalObj().cmsHospId,
                    HospitalEmail: UserService.getHospitalObj().emailAddress,
                    HospitalName: UserService.getHospitalObj().hospName,
                    HospitalPhoneNo: UserService.getHospitalObj().primaryContactNumber,
                    HospitalAddress: (UserService.getHospitalObj().address + UserService.getHospitalObj().city).replace(/[^a-zA-Z0-9 ]/g, ""),

                    PatientName: scope.form.fullname,
                    PatientPhoneNo: scope.form.mobile,
                    CorporateName: scope.form.employer,
                    EmployeeID: scope.form.empid,
                    MAID: scope.form.maid,
                    DOA: scope.form.doa.getFullYear() + '-' + (scope.form.doa.getMonth() + 1) + '-' + scope.form.doa.getDate(),
                    DOD: scope.form.dod.getFullYear() + '-' + (scope.form.dod.getMonth() + 1) + '-' + scope.form.dod.getDate(),
                    Ailment: scope.form.diagnosis,
                    Treatment: scope.form.procedure,
                    AdmissionType: scope.form.admissiontype,
                    ClaimedAmount: scope.form.clmamount,
                    DocName: scope.form.docname,
                    RoomType: scope.form.roomtype
                };
                NewAdmissionFormService.downloadPrefilledPreauthForm(source, PreauthFormDataObj)
            }
        };
    })();
    scope.fastrackPreauthGovSeaarch = function (type) {
        angular.element("#newMSBYSearch").modal('show');
        scope.fastrack = {};
        scope.fastrack.displaySubmit = true;
        switch (type) {
            case 'gov':
                scope.fastrack.title = 'Gov Search';
                scope.aarogyachecked = false;
                scope.govSearch = true;
                scope.isGov = true;
                scope.govtBenefList = [];
                scope.epic = '';
                scope.urn = '';
                scope.fastrack.showCorpName = false;
                scope.fastrack.employerSearchTitle = 'Employee ID';
                break;
        }
    };
    scope.fastrackPreauth = function (type) {
        angular.element("#newPreauthModal").modal("show");
        scope.fastrack = {};
        scope.fastrack.displaySubmit = true;
        switch (type) {
            case 'aarogya':
                scope.fastrack.title = 'Aarogya Scheme';
                scope.aarogyachecked = true;
                scope.govSearch = false;
                scope.isGov = false;
                scope.fastrack.showCorpName = false;
                scope.fastrack.employerSearchTitle = 'Family Number';
                break;
            case 'generic':
                scope.fastrack.title = 'Member Search';
                scope.aarogyachecked = false;
                scope.govSearch = false;
                scope.isGov = false;
                scope.fastrack.showCorpName = true;
                scope.fastrack.employerSearchTitle = 'Employee ID';
                break;
            case 'gov':
                scope.fastrack.title = 'Gov Search';
                scope.aarogyachecked = false;
                scope.govSearch = true;
                scope.isGov = true;
                scope.govtBenefList = [];
                scope.epic = '';
                scope.urn = '';
                scope.fastrack.showCorpName = false;
                scope.fastrack.employerSearchTitle = 'Employee ID';
                break;
        }
        if (scope.aarogyachecked) {
            scope.fastrack.corporateName = 'Manipal';
        }
    };
    scope.searchGov = function (type) {
        if (type === 'URN') {
            scope.isURN = true;
            scope.isEpic = false;
            scope.epic = '';
            scope.govtBenefList = [];
        } else if (type === 'Epic') {
            scope.isURN = false;
            scope.isEpic = true;
            scope.urn = '';
            scope.govtBenefList = [];
        } else {
            scope.isURN = false;
            scope.epic = '';
            scope.urn = '';
            scope.isEpic = false;
        }
    };
    scope.getDetailsWithGov = function (id, type) {
        var data = {
            urn: id ? id : ''
        }
        if (data.urn) {
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/AAAY/benefSearch', data, 'POST').then(function (response) {
                if (response.data.isSuccess) {
                    scope.isSearch = false;
                    scope.fastrack.error = false;
                    scope.govtBenefList = response.data.relations;
                    scope.benefsDetails = response.data.benefs
                } else {
                    scope.fastrack.error = true;
                    scope.fastrack.errorMessage = response.data.errorMessage;
                    scope.benefsDetails = '';
                }
            }, function (error) {
                scope.fastrack.error = true;
                scope.benefsDetails = '';
                scope.fastrack.errorMessage = 'No data found';
            });

            //FastrackService.getDetailsWithGov(data).
            //    then(function (response) {
            //        if (response.data.isSuccess) {
            //            scope.isSearch = false;
            //            scope.fastrack.error = false;
            //            scope.govtBenefList = response.data.govtBenefList;
            //        }
            //        else {
            //            scope.fastrack.error = true;
            //            scope.fastrack.errorMessage = response.data.errorMessage;
            //        }
            //    },
            //       function (response) {
            //           scope.fastrack.error = true;
            //           scope.fastrack.errorMessage = 'No data found';
            //       });
        } else {

        }
    };
    scope.getDetailsWithMaid = function (maid, benefName) {
        if (maid && benefName) {
            var data = { hospId: UserService.getHospitalObj().hospId, maid: maid, beneficiaryName: benefName }
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails.json', data, 'POST').
                then(function (response) {
                    if (response.data.isSuccess) {
                        scope.fastrack.displaySubmit = false;
                        scope.fastrack.error = false;
                        scope.fastrack.name = response.data.benefs.name;
                        scope.fastrack.relations = response.data.relations;
                        scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
                    }
                    else {
                        scope.fastrack.error = true;
                        scope.fastrack.errorMessage = response.data.errorMessage;
                    }
                }, function (error) {
                    scope.fastrack.error = true;
                    scope.fastrack.errorMessage = 'No data found';
                });
        }
    };
    scope.getDetailsWithEmpId = function (empid, corpname, benefname) {
        if (empid && corpname && benefname && UserService.getHospitalObj()) {
            var data = { hospId: UserService.getHospitalObj().hospId, employeeId: empid, corporateName: corpname, BeneficiaryName: benefname }
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails.json', data, 'POST').
                then(function (response) {
                    if (response.data.isSuccess) {
                        scope.fastrack.displaySubmit = false;
                        scope.fastrack.error = false;
                        scope.fastrack.name = response.data.benefs.benefName;
                        scope.fastrack.relations = response.data.relations;
                        scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
                    }
                    else {
                        scope.fastrack.error = true;
                        scope.fastrack.errorMessage = response.data.errorMessage;
                    }
                }, function (error) {
                    scope.fastrack.error = true;
                    scope.fastrack.errorMessage = 'No data found';
                });
        } else {

        }
    };
    scope.getDetailsWithPolicy = function (policyno, benefname) {

        if (policyno && benefname) {
            var data = {
                hospId: UserService.getHospitalObj().hospId,
                PolicyNo: policyno,
                BeneficiaryName: benefname
            }
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getEcardWithPolicyNo.json', data, 'POST').
                then(function (response) {
                    if (response.data.isSuccess) {
                        scope.fastrack.displaySubmit = false;
                        scope.fastrack.error = false;
                        scope.fastrack.name = response.data.benefs.benefName;
                        scope.fastrack.relations = response.data.relations;
                        scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
                    }
                    else {
                        scope.fastrack.error = true;
                        scope.fastrack.errorMessage = response.data.errorMessage;
                    }
                }, function (error) {
                    scope.fastrack.error = true;
                    scope.fastrack.errorMessage = 'No data found';
                });
        }
    };
    scope.fastrackPopulateNewAdmissionGov = function (data) {
        scope.form.fullname = data.name;
        scope.form.memberId = parseInt(scope.benefsDetails.familyId) ? parseInt(scope.benefsDetails.familyId) : '';
        scope.form.URNNum = scope.benefsDetails.urn ? scope.benefsDetails.urn : '';
        scope.removeModal();
    };

    scope.removeData = [];
    scope.removePackageFromList = function (item) {
        if (item) {
            angular.forEach(scope.selectedMappedpackages, function (data, index) {
                if (item.uniqueIds === data.uniqueIds) {
                    scope.selectedMappedpackages.splice(index, 1);
                }
            })
            scope.removeData = item;
            //scope.$broadcast('removeData', item);
            //scope.calculatePrice();
        }
    };

    scope.ctrlFn = function (nextpage) {
        scope.selectedMappedpackages = [];
        scope.selectedMappedpackages = nextpage;
        scope.calculatePrice();
    };
    scope.isECashLess = false;
    scope.eCashLessMessage = '';
    scope.newPackageListData = [];
    scope.getMappedpackages = function (details) {
        scope.mappedpackages = [];
        scope.selectedMappedpackages = [];
        scope.isPriceOne = false;
        scope.isPriceTow = false;
        scope.isPriceThree = false;
        if (UserService.getHospitalObj()) {
            var data = {
                hospitalId: UserService.getHospitalObj().cmsHospId,
                insurerShortName: details
                //--details
                //'NIA'
            }
            scope.newPackageListData = [];
            // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/mappedpackages', data, 'POST', UserService.getAccessToken()).then(function (response) {
            //     if (response.data.isSuccess) {
            //         scope.mappedpackages = response.data.mappedpackages;
            //         angular.forEach(scope.mappedpackages, function (data, index) {
            //             var testObje = [];
            //             angular.forEach(data.distinctPrices, function (data1, index1) {
            //                 testObje.push({
            //                     isSelected: false,
            //                     price: data1,
            //                     packageId: scope.mappedpackages[index].packageId
            //                 })
            //             });
            //             scope.newPackageListData.push(testObje);
            //             scope.mappedpackages[index].newPriceObj = testObje;
            //         });
            //         angular.forEach(scope.mappedpackages, function (data, index) {
            //             scope.mappedpackages[index].general_Ward1 = false;
            //             scope.mappedpackages[index].private_Ward1 = false;
            //             scope.mappedpackages[index].semi_Private_Ward1 = false;
            //         })
            //     }
            //     else {
            //         scope.mappedpackages = [];
            //     }
            // });
        }
    };

    scope.getPackagesListForInsurer = function (data) {
        var selectedShoertName = '';
        scope.mappedpackages = [];
        if (data) {
            selectedShoertName = _.findWhere(scope.insurerList, { insurerFullName: data });
            scope.getMappedpackages(selectedShoertName.insurerShortName);
        }
    };

    //scope.getMappedpackages('NIA');
    scope.fastrackPopulateNewAdmission = function (maid, relationid, name, eCashLess) {
        if (eCashLess.eCashlessReqId === 0) {
            scope.insurerFullName = eCashLess.insurerFullName;
            scope.form.insurername = scope.insurerFullName;
            scope.insurerShortName = eCashLess.insurerShortName;
            FastrackService.fastrackPopulateNewAdmission(maid, relationid, name).
                then(function (response) {
                    if (response.data.isSuccess) {
                        scope.getMappedpackages(scope.insurerShortName);
                        scope.$parent.tempData = response.data.benefs;
                        scope.resetFormData();
                        scope.fileUploaName = [];
                        scope.form.fileNames = [];
                        scope.form.fileUploadFolderPath = [];
                        scope.form.fullname = response.data.benefs.benefName;   //generic
                        scope.form.roomtype = '';
                        scope.form.employer = response.data.benefs.benefPolHldrName;
                        scope.form.empid = response.data.benefs.priBenefEmpCode;
                        scope.form.maid = response.data.benefs.benefMediAssistID;
                        scope.form.policyno = scope.fastrack.PolicyNo;
                        scope.form.age = response.data.benefs.benefAge;
                        scope.form.gender = response.data.benefs.benefSex;
                        scope.form.insurername = scope.insurerFullName;
                        angular.element("#newPreauthModal").modal('hide');
                    }
                    else {
                        scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network issue', 'Error', true);
                    }
                }, function (response) {
                    scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network issue', 'Error', true);
                });
        } else {
            UtilitiesService.eCashlessReqData = eCashLess;
            scope.isECashLess = true;
            scope.eCashLessMessage = 'There is already a pre-approved request that exists for the patient. Redirecting you to the request. Click yes to continue.';
            timeout(function () {
                scope.$apply(function () {
                    scope.isECashLess = false;
                    scope.eCashLessMessage = '';
                });
            }, 10000)
        }
    };
    scope.opened = true;
    scope.reDirect = function (value) {

        if (value) {
            angular.element("#newPreauthModal").modal('hide');
            state.go(value, { reload: false });
        }
    };
    scope.clearfastrack = function () {
        scope.fastrack = {};
        scope.fastrack.displaySubmit = true;
        scope.fastrack.title = 'Member Search';
        scope.aarogyachecked = false;
        scope.fastrack.showCorpName = true;
        scope.fastrack.employerSearchTitle = 'Employee ID';
    };
    scope.removeModal = function () {
        scope.clearfastrack();
        angular.element("#newMSBYSearch").modal('hide');
    };
    scope.packageCheck = function (data) {
        var isCheck = true;
        angular.forEach(data, function (data, index) {
            if (!data.general_Ward1 && !data.private_Ward1 && !data.semi_Private_Ward1) {
                isCheck = false
            }
        });
        return isCheck;
    };
    scope.getPackagesForPreAuthForm = function () {
        var packagesForPreAuthForm = scope.selectedMappedpackagesObj(scope.selectedMappedpackages);
        scope.packagesForPreAuthForm = [];
        if (packagesForPreAuthForm) {
            angular.forEach(packagesForPreAuthForm, function (data, index) {
                scope.packagesForPreAuthForm.push(data.packageName);
            });
        }
        return scope.packagesForPreAuthForm.join();
    };
    scope.selectedMappedpackagesObj = function (data) {
        scope.objSelected = [];
        if (data) {
            angular.forEach(data, function (data, index) {
                var obj;
                if (data.general_Ward1) {
                    obj = {
                        packageName: data.package_Name,
                        packageId: data.packageId,
                        packageAmount: data.general_Ward,
                        packageCappedAmount: 0
                    }
                } else if (data.private_Ward1) {
                    obj = {
                        packageName: data.package_Name,
                        packageId: data.packageId,
                        packageAmount: data.private_Ward,
                        packageCappedAmount: 0
                    }
                } else if (data.semi_Private_Ward1) {
                    obj = {
                        packageName: data.package_Name,
                        packageId: data.packageId,
                        packageAmount: data.semi_Private_Ward,
                        packageCappedAmount: 0
                    }
                } else {
                    obj = {};
                }
                scope.objSelected.push(obj);
            });
            return scope.objSelected;
        }
    };


    scope.calculatePrice1 = function () {
        scope.packageCalcAmount = 0;
        angular.forEach(scope.selectedPackages, function (data, index) {
            if (data.amount) {
                scope.packageCalcAmount = scope.packageCalcAmount + scope.selectedPackages[index].amount;
            }
        });
        scope.form.clmamount = scope.packageCalcAmount;
    };
    scope.isCalimCreated = true;
    scope.govtSchemeMethods = (function () {
        scope.selectedPackages = new Array();
        function submitPreauthFormSuccess(successData) {
            scope.fileUploaName = [];
            scope.isProcessing = false;
            scope.isCalimCreated = false;
            if (successData.data.isSuccess) {
                
                scope.form.preauthSuccess = true;
            }
            else {
                scope.form.preauthError = true;
            }
        }
        function submitPreauthFormError(ErrorData) {
            scope.isProcessing = false;
            scope.form.preauthError = true;
        }
        function getGovtPackageListSuccess(resData) {
            scope.govtPackageList1 = [];
            if (resData && resData.data.isSuccess && resData.data.packages && resData.data.packages.length > 0) {
                scope.govtPackageList1 = resData.data.packages;
                scope.govtPackageListDummy = scope.govtPackageList1;
                scope.changeGovtPolicyType('Basic');
                scope.changeGovtPolicyType('Basic');
                UserService.setGovtPackageList(scope.govtPackageList1);
                scope.showGovtPackages = true;
            }
            else {
                if (resData.data.isSuccess === false) {
                    scope.govtPackageList1 = [];
                    scope.govtPackageListDummy = scope.govtPackageList1;
                    scope.changeGovtPolicyType('Basic');
                    UserService.setGovtPackageList(scope.govtPackageList1);
                    scope.showGovtPackages = false;
                }

            }
        }
        function getGovtPackageListError(resData) {
            scope.govtPackageList1 = [];
            scope.govtPackageListDummy = scope.govtPackageList1;
            scope.changeGovtPolicyType('Basic');
            UtilitiesService.showAlertMessage('Error while fetching govt packages list');
        }
        return {
            getGovtPackageList: function () {
                var govtPackageList1 = UserService.getGovtPackageList();
                scope.govtPackageList1 = [];
                if (govtPackageList1 != undefined && govtPackageList1 != null) {
                    scope.govtPackageList1 = govtPackageList1;
                    scope.govtPackageListDummy = scope.govtPackageList1;
                    scope.changeGovtPolicyType('Basic');
                    scope.changeGovtPolicyType('Basic');
                    scope.showGovtPackages = true;
                }
                else {
                    GovernmentService.getGovtPackageListDummyCall('1037410').then(getGovtPackageListSuccess, getGovtPackageListError)
                }
            },
            setGovtPackageId: function (packageObj) {
                scope.form.packageAmount = packageObj.packageCost;
                scope.form.packageName = packageObj.packageName;
                scope.form.packageUniqueId = packageObj.packageId;
                scope.form.cappedAmount = packageObj.cappedAmount;
            },
            addPackageButton: function () {
                if (scope.form.packageAmount || scope.form.mPackageAmount) {
                    if (scope.selectedPackages.length < 3) {
                        scope.showAutoPackages = true;
                        if (scope.showAutoPackages) {
                            scope.selectedPackages.push({
                                id: scope.selectedPackages.length,
                                uniqueId: scope.form.packageUniqueId,
                                name: scope.form.packageName,
                                amount: scope.form.packageAmount
                            });
                            scope.calculatePrice1();
                            $("#packagesHolder").val($("#packagesHolder").val() + ", " + scope.form.packageUniqueId);
                        }
                        else {
                            scope.selectedPackages.push({
                                id: scope.selectedPackages.length,
                                uniqueId: 0,
                                name: scope.form.mPackageName,
                                amount: scope.form.mPackageAmount
                            });
                            $("#packagesHolder").val($("#packagesHolder").val() + ", 0");
                        }
                        scope.packageCalcAmount = 0;
                        for (var i = 0; i < scope.selectedPackages.length; i++) {
                            scope.packageCalcAmount = scope.packageCalcAmount + ((25 * (4 - i)) / 100) * scope.selectedPackages[i].amount;
                        }
                        $("#packageAmountHolder").val(scope.packageCalcAmount);
                    }
                    else {
                        UtilitiesService.showAlertMessage('Maximum of 3 packages allowed.');
                    }
                }
            },
            removePackage: function (id) {
                //$("#packagesHolder").val($("#packagesHolder").val().replace(", " + scope.selectedPackages[id].uniqueId, ""));
                for (var i = id; i < scope.selectedPackages.length - 1; i++) {
                    scope.selectedPackages[i] = scope.selectedPackages[i + 1];
                    scope.selectedPackages[i].id--;
                }
                scope.selectedPackages.pop(scope.selectedPackages.length - 1);
                scope.packageCalcAmount = 0;
                for (var i = 0; i < scope.selectedPackages.length; i++) {
                    scope.packageCalcAmount = scope.packageCalcAmount + ((25 * (4 - i)) / 100) * scope.selectedPackages[i].amount;
                }
                $("#packageAmountHolder").val(scope.packageCalcAmount);
                scope.calculatePrice1();
            },

            getPreauthFormData: function (form) {
                var data = {
                    IsGovtClaim: true,
                    urnNumber: form.URNNum,
                    memberId: form.memberId,
                    memberDistrict: form.memberDist,
                    reasonForChoosing: form.reasonOnline ? form.reasonOnline.join() : '',
                    packages: scope.selectedPackages.map(function (item) { return item.uniqueId }),
                    MemberGender: form.memberGender,
                    Age: form.memberAge,
                    ApplicationName: 'Hospital Portal',
                    PatientFirstName: form.fullname,
                    ContactNum: form.mobile,
                    Doa: form.doa,
                    DocName: form.docname,
                    Diagnosis: form.diagnosis,
                    TentativeDOD: form.dod,
                    HospId: UserService.getHospitalObj().hospId,
                    HospName: UserService.getHospitalObj().hospName,
                    CreatedBy: UserService.getUserObj().userId,
                    IpNumber: form.ipnumber,
                    FileNames: form.fileNames,//form.fileUploadFolderPath,// form.fileNames,
                    FileUploadFolderPath: form.fileUploadFolderPath.join(),
                    ApproxClaimedAmnt: scope.packageCalcAmount,
                    uiD_NO: form.uidno,
                    GovScheme: 'AAAY',
                    attachedFiles: scope.fileUploaName,
                    tpaid: form.tpaId ? form.tpaId : 0,
                    tpaConfigId: form.hospTPAId ? form.hospTPAId : 0,
                    uniqueId: form.uniqueId ? form.uniqueId : ''
                };
                return data;
            },
            submitPreauthForm: function () {
                scope.isProcessing = true;
                NewAdmissionFormService.submitPreauthForm(this.getPreauthFormData(scope.form)).
                then(submitPreauthFormSuccess, submitPreauthFormError)
            },
            changePackageField: function () {
                if (scope.form.reasonOnline == 'others') {
                    scope.showAutoPackages = false;
                }
                else {
                    scope.showAutoPackages = true;
                }
            }
        };
    })();

    scope.preClaimInfoRelatedMethods = (function () {
        function submitPreauthFormSuccess(successData) {
            scope.isProcessing = false;
            if (successData.data.isSuccess) {
                scope.form.preauthSuccess = true;
            }
            else {
                scope.form.preauthError = true;
            }
        }
        function submitPreauthFormError(ErrorData) {
            scope.isProcessing = false;
            scope.form.preauthError = true;
        }
        return {
            prefillPreauthForm: function (claimRefNo) {
                NewAdmissionFormService.getPreauthDataByMARefNo(claimRefNo).then(function (resData) {
                    scope.form = {};
                    scope.signup = {};
                    if (resData.data.detailslist.length > 0) {
                        if (resData.data.detailslist[0].admissioN_DATE.indexOf('T') > -1) {
                            resData.data.detailslist[0].admissioN_DATE = new Date(resData.data.detailslist[0].admissioN_DATE);
                            resData.data.detailslist[0].dischargE_DATE = new Date(resData.data.detailslist[0].dischargE_DATE);
                        }
                        else {
                            var formattedDoa = resData.data.detailslist[0].admissioN_DATE.split('-')
                            resData.data.detailslist[0].admissioN_DATE = new Date(formattedDoa[1] + '/' + formattedDoa[0] + '/' + formattedDoa[2])

                            var formattedDod = resData.data.detailslist[0].dischargE_DATE.split('-');
                            resData.data.detailslist[0].dischargE_DATE = new Date(formattedDod[1] + '/' + formattedDod[0] + '/' + formattedDod[2])
                        }
                        scope.form.fullname = resData.data.detailslist[0].patienT_FIRSTNAME;
                        scope.form.mobile = parseInt(resData.data.detailslist[0].mobilE_NO);
                        scope.form.employer = resData.data.detailslist[0].corporatE_NAME;
                        scope.form.empid = resData.data.detailslist[0].employeE_ID;
                        scope.form.maid = resData.data.detailslist[0].maid;
                        // scope.form.ipnumber = resData.data.detailslist[0].patienT_FIRSTNAME;
                        scope.form.doa = (resData.data.detailslist[0].admissioN_DATE);
                        scope.form.dod = (resData.data.detailslist[0].dischargE_DATE);
                        scope.form.diagnosis = resData.data.detailslist[0].presenT_AILMENT;
                        scope.form.procedure = resData.data.detailslist[0].provisionaL_TREATMENT;
                        scope.form.admissiontype = resData.data.detailslist[0].admissioN_TYPE;
                        scope.form.clmamount = parseInt(resData.data.detailslist[0].preautH_AMOUNT);
                        scope.form.docname = resData.data.detailslist[0].firsT_NAME;
                        scope.form.roomtype = resData.data.detailslist[0].provideR_ROOM_TYPE;
                        scope.PreAuthForIRRemarks = resData.data.detailslist[0].remarks;
                    }
                }, function (error) {
                    // console.log("Error while fetching data by ClaimRefNumber");
                });
            },
            getPreauthFormData1: function (form) {
                var data = {
                    "IsGovtClaim": true,
                    "MemberGender": form.gender == undefined ? '' : form.gender,
                    "Age": form.age == undefined ? '' : form.age,
                    "ApplicationName": "Hospital Portal",
                    "PatientFirstName": form.fullname,
                    "ContactNum": form.mobile,
                    "EmpId": form.empid,
                    "Employer": form.employer,
                    "Maid": form.maid,
                    "Doa": form.doa,
                    "ApproxClaimedAmnt": form.clmamount,
                    "DocName": form.docname,
                    "DocRegNo": "String",
                    "Diagnosis": form.diagnosis,
                    "AdmissionType": form.admissiontype,
                    "RoomType": form.roomtype,
                    "TentativeDOD": form.dod,
                    "HospId": UserService.getHospitalObj().hospId,
                    "HospName": UserService.getHospitalObj().hospName,
                    "CreatedBy": UserService.getUserObj().userId,
                    "IpNumber": form.ipnumber,
                    "Procedure": form.procedure,
                    "IpAddress": "String",
                    "PolicyNumber": form.policyno,
                    "InsurerName": form.insurername,
                    "FileNames": form.fileNames,
                    "FileUploadFolderPath": form.fileUploadFolderPath.join(),
                    "uiD_NO": form.uidno
                };
                return data;
            },
            uploadFiles: function (callback) {
                scope.form.fileNames = [];
                scope.form.fileUploadFolderPath = [];
                var fileBlobArray = [];
                if (scope.preAuthFile) {
                    Object.keys(scope.preAuthFile).forEach(function (e) {
                        if (typeof (scope.preAuthFile[e]) == 'object') {
                            scope.file.push({
                                'model': scope.preAuthFile[e]
                            });
                        }
                    });
                }
                var filesUploadingArray = [];
                Object.keys(scope.file).forEach(function (ele) {
                    if (typeof (scope.file[ele].model) == "object") {
                        filesUploadingArray.push(scope.file[ele].model);
                    }
                });
                if (filesUploadingArray.length > 0) {
                    fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
                }
                else {
                    scope.isProcessing = false;
                    UtilitiesService.showAlertMessage('Please attach atleast one document.');
                    return false;
                }
                $q.all(fileBlobArray).then(function (result) {
                    result.forEach(function (element) {
                        if (element.data.isSuccess) {
                            angular.forEach(element.data.uploadResponseDetails, function (e, i) {
                                scope.form.fileNames.push(e.fileName);
                                scope.form.fileUploadFolderPath.push(e.downloadURL);
                            });
                        }
                        else {
                            scope.isProcessing = false;
                            scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                            return false;
                        }
                    });
                    if (result && (filesUploadingArray.length == 0 || scope.form.fileNames.length == result[0].data.uploadResponseDetails.length))
                        callback.call(scope.preClaimInfoRelatedMethods);
                },
                function (error) {
                    scope.isProcessing = false;
                    scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                });
            },
            submitPreClaimPreauthForm: function () {
                scope.isProcessing = true;
                if (scope.selectedPackages.length > 0) {
                    this.uploadFiles(function () {
                        if (!scope.form.IsGovtClaim) {
                            NewAdmissionFormService.submitPreClaimPreauthForm(this.getPreauthFormData1(scope.form)).
                                            then(submitPreauthFormSuccess, submitPreauthFormError);
                        }
                        else {
                            scope.govtSchemeMethods.submitPreauthForm();
                        }
                    });
                } else {
                    UtilitiesService.showAlertMessage('Please select package.');
                }
            },
            closePreauthForm: function () {
                scope.form = {};
                //$location.path('/');
                $location.path('/government');
            },
        };
    })();


    scope.govtSchemeMethods.getGovtPackageList();

    scope.todaysDate = new Date();
    scope.todaysDate = scope.todaysDate.setMonth(scope.todaysDate.getMonth() - 1);
    scope.todaysDate = new Date(scope.todaysDate);
    scope.isFormDisable = true;
    scope.dateOfAdmission = function (date, type) {
        scope.isFormDisable = false;
        if (type === 'doa') {
            var currentMonth = scope.todaysDate.getMonth() + 2;
            var selectedMonth = scope.form.doa.getMonth();
            if (currentMonth < selectedMonth) {
                scope.isdoa = true;
                scope.isFormDisable = true;
                if (scope.form.dod) {
                    scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
                }
            }
            else {
                scope.isdoa = scope.todaysDate <= scope.form.doa ? false : true;
                scope.isFormDisable = scope.isdoa;
                if (scope.form.dod) {
                    scope.isdod = scope.form.dod >= scope.form.doa ? false : true;
                }
            }
        } else if (type === 'dod') {
            var currentMonth = scope.todaysDate.getMonth() + 2;
            var selectedMonth = scope.form.doa.getMonth();
            if (currentMonth < selectedMonth) {
                scope.isdoa = true;
                scope.isFormDisable = true;
                scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
            }
            else {
                scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
                if (scope.form.doa) {
                    scope.isdoa = scope.todaysDate <= scope.form.doa ? false : true;
                    if (!scope.isdoa) {
                        scope.isdoa = scope.form.dod < scope.form.doa ? true : false;
                    }
                }
            }
        }
    };

    scope.file = [];
    scope.addFileToUpload = function (flag) {
        var newItemNo = scope.file.length + 1;
        scope.file.push({
            'model': ''
        });
    };
    scope.removeFileToUpload = function () {
        var lastItem = scope.file.length - 1;
        scope.file.splice(lastItem);
        scope.validLargeDoc = false;
    };
    scope.addFileToUpload();
}]);
angular.module("mbplus")
.controller('approvedCancelController', ['$scope', '$rootScope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics', 'PlusUtilitiesService', function (scope, $rootScope, $location, UserService, UtilitiesService, filterFilter, $analytics, PlusUtilitiesService) {
  $analytics.pageTrack('/appointments');
  if (!UserService.isActive()) {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }
  scope.ctrlName = 'UnapprovedNewAdmissionController';
  scope.user = UserService.getUserObj();
  scope.formatTime = UtilitiesService.formatTime;
  scope.compareDate = UtilitiesService.compareDate;

  scope.loadAppointments = function (id, name) {
    var providerId = null;
    scope.providerName = "";
    if (id && name) {
      providerId = id;
      scope.providerName = name;
    }
    var data = {
      requestType: 'Appointment',
      ProviderId: providerId,
      hashtagFilters: {},
      requestAccessToken: UserService.getAccessToken()
    }
    var url = UtilitiesService.getPlusUrlPrefix() + '/approvedCancelledAppointments/';
    scope.appointmentsCount = 0;

    UserService.makeRestCall(url, data, 'POST', UserService.getAccessToken()).then(function (response) {
      if (response.data.isSuccess) {
        scope.unApprrovedCancelAppointments = response.data;
        UserService.activeAppointmentsDummyData = response.data;
        UserService.activeAppointmentsDummyDataCollection = response.data.requests;
        scope.hasNoResults = false;
        scope.loading = false;
      }
      else {
        scope.hasNoResults = true;
        scope.loading = false;
      }
    });
  };
  
  scope.getPackageTestDetails = function (productId, noProductId) {
    if (noProductId) {
      scope.investigationList = [];
      return;
    } else {
      var pId = productId ? productId : '';
      scope.investigationList = [];
      if (pId) {
        var url = UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/' + pId;
        UserService.makeRestCall(url, '', 'GET', UserService.getAccessToken()).then(function (response) {
          if (response.data) {
            var investigation = response.data.allowedInvestigations;
            var investigationGroup = [];
            angular.forEach(investigation, function (v, i) {
              investigationGroup.push(v.groupName);
            })
            var listOfUniqeInvestigations = investigationGroup.filter(function (val, index, allArr) {
              return index == allArr.indexOf(val);
            })
            angular.forEach(listOfUniqeInvestigations, function (val, ind) {
              var investigationWiseTests = filterFilter(investigation, val);
              var testObj = investigationWiseTests;
              scope.testDetails = [];
              angular.forEach(testObj, function (v, i) {
                scope.testDetails.push({
                  groupName: v.groupName,
                  testName: v.name,
                  testId: v.id,
                  groupId: v.groupId,
                  isActive: v.isActive,
                  duplicateCheck: v.duplicateCheck,
                  quantity: v.quantity
                })
              })
              scope.investigationList.push({
                investigationName: val,
                testDetails: scope.testDetails
              })
            })
            // console.log(scope.investigationList);
          } else {
              //alert('No Investigations found.');
              UtilitiesService.showAlertMessage('No Investigations found.');
          }
        })
      } else {
          //alert('Product Id is unavailable.');
          UtilitiesService.showAlertMessage('Product Id is unavailable.');
      }
    }
  }

  scope.$watch('plusAppointmentsSearch', function (current, old) {
    if (current) {
      scope.activeAppointments = UserService.GetFilteredAppointment(current);
    } else {
      if (old) {
        UserService.activeAppointmentsDummyData.requests = UserService.activeAppointmentsDummyDataCollection;
        scope.activeAppointments = UserService.activeAppointmentsDummyData;
      }
    }
  });
  angular.element(document).ready(function () {
    scope.loadAppointments();
  });
}]);

angular.module('mbplus')
.controller('approvedCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', '$analytics', function (scope, $location, UserService, UtilitiesService, analytics) {
    analytics.pageTrack('/approved');
    if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() == 'insurer') {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    scope.startIndex = 1;
    scope.ctrlFn = function (nextpage) {
        scope.startIndex = nextpage;
        scope.getClosedClaims();
    };

    scope.getClosedClaims = function (startIndex, claimsPerPage) {
        var ajxData = {
            hospitalId: UserService.getHospitalObj().cmsHospId,
            startIndexInclusive: scope.startIndex
        };
        UtilitiesService.startLoading('fetching settled claim data...', 'approvedClaimsData');
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/HospSettledClaimList', ajxData, 'POST').then(function (response) {
            UtilitiesService.stopLoading('approvedClaimsData');
            if (response.data.isSuccess) {
                scope.approvedClaims = UtilitiesService.renderClaimsList(response.data, 'all');
                scope.approvedClaims.allRecordCount = response.data.allRecordCount;
            }
        });
    };
    scope.getClosedClaims();
}]);
angular.module("mbplus")
  .controller('newAppointmentRequestCtrl', ['$scope', '$rootScope', '$location', '$stateParams', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics', 'PlusUtilitiesService', 'orderByFilter', '$timeout', function (scope, $rootScope, $location, $stateParams, UserService, UtilitiesService, filterFilter, $analytics, PlusUtilitiesService, orderByFilter, $timeout) {

    scope.pageNo = 0;
    scope.rowCount = 10;

    if (!UserService.isActive()) {
      UserService.destroyUserObj();
      $location.path('/');
      return false;
    }

    scope.status = {
      isFirstOpen: false,
    };
    scope.bloodGrp = {
      selectedBloodGrp: ''
    };
    scope.grive = {
      griveComment: ''
    };
    scope.isPhotoAvailble = {
      value: 'false'
    };
    scope.day = moment();
    scope.doctorQualificatio = '';
    scope.isOpenAccordian = false;
    $rootScope.dcInvestigations = '';
    $rootScope.dcInvestigationsMap = '';
    $rootScope.eSaleQueue = '';
    $analytics.pageTrack('/allappointmentsSearchStatus');
    scope.ctrlName = 'newAppointmentRequestCtrl';
    scope.user = UserService.getUserObj();
    scope.formatTime = UtilitiesService.formatTime;
    scope.compareDate = UtilitiesService.compareDate;
    scope.pharmaData = {
      cashlessAmt: '',
      CODAmt: ''
    }
    scope.isCorporate = false;
    scope.showChkedOnDcLogin = false;
    scope.contracts = [];
    scope.selectedDcs = [];
    scope.reports = [];
    scope.bills = [];
    scope.newlyUploadedReports = [];
    scope.newlyUploadedBills = [];
    scope.corporateSelectedID = '';
    scope.daysOfAppointment = '';
    scope.ERTypeId = 5290;
    scope.rowNo = 10;
    scope.Role = [5432, 5433, 5434];
    scope.serviceBrokerId = '1000042';
    scope.Entity_Type = '4653';
    scope.testData = {
      testStateId: '',
      testSubLocalityId: '',
      testCityId: '',
      testLocalityId: '',
      dcValue: ''
    };
    scope.homeVisit = {
      addressLineOne: '',
      addressLinTwo: ''
    }
    scope.resendEmailDetails = {
      emailID: '',
      statusID: ''
    };
    scope.client = {
      prefDate: new Date()
    }
    scope.originalDcDetails = {
      providerId: '',
      providerName: '',
      appointmentDate: '',
      visitType: ''
    };
    scope.dispayInDdl = "Search by";
    scope.serverSearch = {
      fromDate: '',
      toDate: '',
      statusSearch: '',
      contractType: '',
      corporateId: '',
      dateWiseSearch: 'apptdate'
    };
    scope.form = {
      dod: ''
    };

    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];
    scope.popup1 = {
      opened: false
    };
    scope.popup2 = {
      opened: false
    };
    scope.open1 = function () {
      scope.popup1.opened = true;
    };
    scope.open2 = function () {
      scope.popup2.opened = true;
    };
    scope.filtere = {
      fromDate: '',
      toDate: ''
    };
    scope.resetDateValues = function () {
      scope.filtere.fromDate = '';
      scope.filtere.toDate = '';
    };
    scope.action = {
      cancelComments: '',
      statusId: '',
      nextStatusId: '',
      requestId: '',
      spocname: '',
      spocphone: '',
      date: '',
      remarks: '',
      secondPreferredTime: '',
      dcPrice: '',
      visibleDate: '',
      visibleTime: '',
      partnerOrderId: '',
      showdcselection: false,
      feedback: '',
      homeVisitType: [],
      requestContractType: '',
    };
    scope.attachFiles = {
      reports: {},
      bills: {}
    };
    scope.feedbackList = ['Satisfied', 'Dissatisfied', 'Pacifistic'];
    scope.getDateObj = UtilitiesService.getDateObj;
    scope.file = [];
    scope.newlyUploadedDocs = [];
    scope.contracts = PlusUtilitiesService.getContracts();
    scope.contracts = UtilitiesService.getContracts() === null ? [] : UtilitiesService.getContracts();
    scope.childrenData = UtilitiesService.getAllChildren() === null ? [] : UtilitiesService.getAllChildren();
    scope.otp = false;
    angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
      if (v.roleId == 5432 || v.roleId == 5433 || v.roleId == 5434) { //opt enable for dc login
        scope.otp = true;
      }
    });

    if (scope.user) {
      scope.isSearchToShow = scope.user.entityType == 'DC' ? false : true;
    }
    scope.contracts.push({
      id: '0',
      entityName: 'All Appointment Type'
    });
    if (scope.contracts.length > 0) {
      scope.contracts = orderByFilter(scope.contracts, 'entityName', false);
    }
    scope.contractsData = [];
    scope.contractsData.push({
      id: '0',
      entityName: 'All Corporate'
    });
    scope.serverSearch.statusSearch = {
      id: '22',
      name: 'New Appointment Request'
    };
    scope.serverSearch.contractType = {
      id: '0',
      entityName: 'All Appointment Type'
    };
    scope.serverSearch.corporateId = {
      id: '0',
      entityName: 'All Corporate'
    };
    scope.showTextBtn = false;
    scope.activeAppointments = [];

    scope.rowPerPage = [{
      id: 1,
      count: 10
    }, {
      id: 2,
      count: 25
    }, {
      id: 3,
      count: 50
    }, {
      id: 4,
      count: 100
    }, {
      id: 5,
      count: 300
    }, {
      id: 6,
      count: 500
    }, {
      id: 7,
      count: 700
    }, {
      id: 8,
      count: 900
    }, {
      id: 9,
      count: 1000
    },];
    scope.rowNo = scope.rowPerPage[0];
    scope.reasonOfCancel = UtilitiesService.reasonOfCancel();

    function statusTransform(requests){
      _.each(requests, function(val){
          if(val.remarks && val.remarks.replace(/[\s-]/g, '').toLowerCase() == 'confirmedfromprovider'){
              val.currentStatus = 'Confirmed by Labwise';
          }
      })
      return requests;
    }

    scope.closeModel = function () {
      scope.popupQc.actualDate = '';
      scope.storeFiles = [];
      scope.storedBill = [];
      scope.action.cancelComments = '';
      scope.action.statusId = '';
      scope.action.nextStatusId = '';
      scope.action.requestId = '';
      scope.action.spocname = '';
      scope.action.spocphone = '';
      scope.action.date = '';
      scope.action.remarks = '';
      scope.action.secondPreferredTime = '';
      scope.action.dcPrice = '';
      scope.action.visibleDate = '';
      scope.action.visibleTime = '';
      scope.action.partnerOrderId = '';
      scope.action.showdcselection = false;
      scope.action.feedback = '';
      scope.action.homeVisitType = [];
      scope.uploadedFileData.reports = {};
      scope.uploadedFileData.bills = {};
      scope.action.requestContractType = '';
      scope.resetTime();
    };

    //To check if Dc
    scope.checkIfDc = function () {
      var dcRole = null;
      var result = false;
      if (scope.user && scope.user.rolesFeatures && scope.user.rolesFeatures.roles) {
        dcRole = scope.user.rolesFeatures.roles.find(function (elem) {
          return ((elem.roleName.substring(0, 2)) == 'DC')
        })
        result = dcRole ? true : false;
        if (result && $rootScope.toggleMenuObj && $rootScope.toggleMenuObj.isMultiRole) {
          return ($rootScope.toggleMenuObj.isDcRoleActive ? true : false);
        } else {
          return result;
        }
      }
    }

    //set maxFirst : end time for reschedule appt
    scope.setMaxFirst = function (t) {
      var maxFirst = new Date();
      maxFirst.setHours(t);
      maxFirst.setMinutes(0);
      scope.maxFirst = maxFirst;
    }

    //Set today's date
    scope.today = function () {
      scope.serverSearch.fromDate = moment(Date()).format("DD-MMM-YYYY");
      scope.serverSearch.fromDate = new Date(scope.serverSearch.fromDate);
      scope.serverSearch.toDate = moment(Date()).add(7, 'd').format("DD-MMM-YYYY");
      scope.serverSearch.toDate = new Date(scope.serverSearch.toDate);
      scope.dt = new Date();
    };
    scope.today();
    scope.serverSearch.fromDate = '';
    scope.serverSearch.toDate = '';
    scope.dateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    scope.dateOptionsReschedule = {
      formatYear: 'yy',
      minDate: new Date()
    };

    // Disable weekend selection
    function disabled(data) {
      var date = data.date,
        mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    }

    scope.popupQc = {
      opened: false,
      actualDate: ''
    }

    scope.openQcDate = function () {
      scope.popupQc.opened = true;
    };

    scope.reschedule = function () {
      scope.reschedule.opened = true;
    };

    //Date Object
    scope.today = function () {
      scope.client.prefDate = new Date();
      scope.dt = new Date();
    };
    scope.today();

    scope.dateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };
    scope.popup1 = {
      opened: false
    };
    scope.attended = {
      opened: false
    }
    scope.attended = function () {
      scope.attended.opened = true;
    };
    //Set Time Object
    scope.resetTime = function () {
      var first = new Date();
      var dd = new Date(first).getDate();
      var mm = new Date(first).getMonth() + 1;
      var yy = new Date(first).getFullYear();
      var hh = 8;
      var ms = 0;
      var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
      scope.client.prefTime = new Date(x);
    };
    scope.resetTime();
    scope.hstep = 1;
    scope.mstep = 30;
    scope.ismeridian = false;
    //First time limit
    var maxFirst = new Date();
    maxFirst.setHours(18);
    maxFirst.setMinutes(0);
    scope.maxFirst = maxFirst;

    var minFirst = new Date();
    minFirst.setHours(8);
    minFirst.setMinutes(0);
    scope.minFirst = minFirst;

    //Get All Appointments
    // scope.loadAppointments = function () {
    //   var providerId = null;
    //   scope.providerName = '';

    //   if (!scope.daysOfAppointment || scope.daysOfAppointment === '' || scope.daysOfAppointment <= -1) {
    //     scope.daysOfAppointment = -1;
    //   }

    //   var data = {
    //     "providerId": null,
    //     "requestType": "",
    //     "daysOfAppointment": 0,
    //     "pageNo": 0,
    //     "rows": 0,
    //     "statusId": $stateParams.searchValue,
    //     "contractId": 0,
    //     "fromDateOfAppointment": null,
    //     "toDateOfAppointment": null,
    //     "loadFullDetails": false,
    //     "hashtagFilters": {
    //       "String": "String"
    //     },
    //     "searchType": 0,
    //     "fetchByDate": "",
    //     "requestAccessToken": UserService.getAccessToken(),
    //     "userAgent": "String",
    //     "ipAddress": "String"
    //   }

    //   scope.appointmentsCount = 0;

    //   UtilitiesService.startLoading('fetching appointments data...', 'appointmentsData');
    //   UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/Appointments/', data, 'POST', UserService.getAccessToken()).then(function (response) {
    //     UtilitiesService.stopLoading('appointmentsData');
    //     if (response.data.isSuccess) {
    //       scope.isOpenAccordian = true;
    //       console.log('appoint reloaded')
    //       scope.activeAppointments = response.data;
    //       UserService.activeAppointmentsDummyData = response.data;
    //       scope.totalRows = response.data.totalRows;
    //       scope.isTotalRows = response.data.requests.length > 20 ? true : false;
    //       UserService.activeAppointmentsDummyDataCollection = response.data.requests;
    //     } else {
    //     }
    //   }, function (error) {
    //   });
    // };
    // scope.loadAppointments();

    //Clear Search data
    scope.clearSearch = function () {
      scope.serverSearch.fromDate = '';
      scope.serverSearch.toDate = '';
      scope.serverSearch.contractType = {
        id: '0',
        entityName: 'All Appointment Type'
      };
      scope.serverSearch.corporateId = {
        id: '0',
        entityName: 'All Corporate'
      };
      scope.serverSearch.statusSearch = {
        id: '0',
        name: 'All Status'
      };
      scope.serverSearch.dateWiseSearch = 'apptdate';
      scope.isCorporate = false;
      scope.contractsData = [];
      scope.contractsData.push({
        id: '0',
        entityName: 'All Corporate'
      });
      // scope.loadAppointments();
      scope.status.isFirstOpen = false;
    };

    //Get corporate Packages data
    scope.getCorporatePackages = function (CorporateSelected) {
      if (CorporateSelected && CorporateSelected !== '0') {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/EntityRelationcache/Search/' + CorporateSelected, {}, 'GET').then(function (response) {
          scope.contractsData = [];
          scope.isCorporate = response.data.length > 0 ? true : false
          if (response.data.length > 0) {
            scope.contractsData = response.data;
            scope.contractsData.push({
              id: '0',
              entityName: 'All Corporate'
            });
            scope.contractsData = orderByFilter(scope.contractsData, 'entityName', false);
            scope.serverSearch.corporateId = {
              id: '0',
              entityName: 'All Corporate'
            };

          }
        })
      } else {
        scope.isCorporate = false;
      }
    };

    //Reset reasons text or comment text
    scope.resetDependencies = function (reasonForCancel) {
      if (reasonForCancel) {
        scope.action.cancelComments = reasonForCancel == 'Other' ? '' : reasonForCancel != 'Other' ? '' : reasonForCancel == 'reset' ? '' : scope.action.cancelComments;
        scope.cancelReason = reasonForCancel == 'reset' ? '' : scope.cancelReason;
      }
    };

    //Search Appointment search by 
    scope.searchAppointment = function (searchValue) {
      var providerId = null; //provider id will be changed when dc is selected, In this case we have not provided anything like that.
      scope.searchSource = searchValue.value;
      scope.selectedOrderType = searchValue.selectedOrderType;
      if (scope.selectedOrderType) {
        if (scope.selectedOrderType == 'reqId') {
          scope.hashtagFilters = {
            requestid: scope.searchSource
          }
        }
        if (scope.selectedOrderType == 'email') {
          scope.hashtagFilters = {
            emailid: scope.searchSource
          }
        }
        if (scope.selectedOrderType == 'empId') {
          scope.hashtagFilters = {
            empid: scope.searchSource
          }
        }
        if (scope.selectedOrderType == 'contact') {
          scope.hashtagFilters = {
            contactno: scope.searchSource
          }
        }
        if (scope.selectedOrderType == 'name') {
          scope.hashtagFilters = {
            name: scope.searchSource
          }
        }
        if (scope.selectedOrderType == 'partnerOrderId') {
          scope.hashtagFilters = {
            partnerorderid: scope.searchSource
          }
        }
        if (scope.selectedOrderType == 'MAID') {
          scope.hashtagFilters = {
            MAID: scope.searchSource
          }
        }
      }
      var ajaxData = {
        requestType: '',
        daysOfAppointment: scope.daysOfAppointment,
        ProviderId: providerId,
        hashtagFilters: scope.hashtagFilters,
        requestAccessToken: UserService.getAccessToken(),
        userAgent: 'String',
        ipAddress: 'String',
        pageNo: 0,
        rows: 25,
        statusId: '',
        contractId: '',
        searchType: 1,
        fetchByDate: 'apptdate'
      }
      if($.fn.DataTable){
        $.fn.DataTable().destroy()
        scope.refreshData = false;
      }
      UtilitiesService.stopLoading('appointmentsData');
      UtilitiesService.startLoading('fetching appointments data...', 'appointmentsData');
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/Appointments/', ajaxData, 'POST', UserService.getAccessToken()).then(function (response) {
        UtilitiesService.stopLoading('appointmentsData');
        if (response.data) {
          scope.loading = false;
          scope.activeAppointments = response.data;
          scope.totalRows = response.data.totalRows;
          scope.isTotalRows = response.data.requests && response.data.requests.length > 20 ? true : false;
          UserService.activeAppointmentsDummyData = response.data;
          UserService.activeAppointmentsDummyDataCollection = statusTransform(response.data.requests);
          scope.refreshData = true;
        } else {
          UtilitiesService.showAlertMessage('No Record Found.');
        }
      })
    };

    //Search by
    $rootScope.$on('searchBy', function (key, value) {
      scope.searchAppointment(value);
      scope.status.isFirstOpen = false;
    });

    var createNextImmediateActions = function(status) {
      var appointmentArr =  scope.activeAppointments.requests
      if(status == 22) {
        appointmentArr.forEach(function(elem) {
          if(elem.nextPossibleActions) {
            elem.nextImmediateActions = [];
            elem.nextPossibleActions.forEach(function(singleAction) {
              if(singleAction.action == "Confirm" || singleAction.action == "Attended") {
                elem.nextImmediateActions.push(singleAction)
              }
            })
          }
        })
      }
      else if(status == 23) {
        appointmentArr.forEach(function(elem) {
          if(elem.nextPossibleActions) {
            elem.nextImmediateActions = [];
            elem.nextPossibleActions.forEach(function(singleAction) {
              if(singleAction.action == "Reschedule") {
                elem.nextImmediateActions.push(singleAction)
              }
            })
          }
        })
      }
      else if(status == 32) {
        appointmentArr.forEach(function(elem) {
          if(elem.nextPossibleActions) {
            elem.nextImmediateActions = [];
            elem.nextPossibleActions.forEach(function(singleAction) {
              if(singleAction.action == "Submit") {
                elem.nextImmediateActions.push(singleAction)
              }
            })
          }
        })
      }
      else if(status == 40) {
        appointmentArr.forEach(function(elem) {
          if(elem.nextPossibleActions) {
            elem.nextImmediateActions = [];
            elem.nextPossibleActions.forEach(function(singleAction) {
              if(singleAction.action == "Attended") {
                elem.nextImmediateActions.push(singleAction)
              }
            })
          }
        })
      }
      scope.activeAppointments.requests = appointmentArr
    }

    scope.searchAppointmentsGroup = function (getStatus, getContract, corporateId, frmDt, toDt, rowNo) {
      scope.currentPage = rowNo + 1;
      scope.status.isFirstOpen = false;
      // if (frmDt && !toDt) {
      //   //alert("You have missed end date!");
      //   UtilitiesService.showAlertMessage('You have missed end date!');
      //   return false;
      // }
      scope.hashtagFilters = {};
      if (corporateId) {
        if (corporateId.id !== '0') {
          scope.serverSearch.corporateId = corporateId;
          scope.hashtagFilters = {
            corporateid: corporateId.id
          }
        }
      }
      scope.rowNoFromDdl = rowNo ? rowNo : 0
      scope.serverSearch.fromDate = frmDt ? frmDt : '';
      scope.serverSearch.toDate = toDt ? toDt : ''; 
      var providerId = null;

      var ajaxData = {
        providerId: scope.user.providerId,
        requestType: '',
        daysOfAppointment: 0,
        pageNo: rowNo,
        rows: 25,
        statusId: scope.passedStatuses[0],
        contractId: 0,
        fromDateOfAppointment: scope.serverSearch.fromDate,
        toDateOfAppointment: scope.serverSearch.toDate,
        loadFullDetails: false,
        hashtagFilters: scope.hashtagFilters,
        requestAccessToken: UserService.getAccessToken(),
        userAgent: 'String',
        searchType: 1,
        ipAddress: 'String',
        fetchByDate: "apptdate",
        isCountRequired: !rowNo
      }
      if($.fn.DataTable){
        $.fn.DataTable().destroy()
        scope.refreshData = false;
      }
      UtilitiesService.startLoading('Searching...', 'searchAppointmentsData');
      UtilitiesService.stopLoading('appointmentsData');
      UtilitiesService.startLoading('fetching appointments data...', 'appointmentsData');
      UserService.makeRestCall(UtilitiesService.getProviderCoreUrl() + 'provider/Appointments/', ajaxData, 'POST', UserService.getAccessToken()).then(function (response) {
        UtilitiesService.stopLoading('searchAppointmentsData');
        UtilitiesService.stopLoading('appointmentsData');
        if (response.data) {
          if(ajaxData.pageNo != 0) response.data.totalRows = scope.totalRows;
          scope.loading = false;
          scope.activeAppointments = response.data;
          if(!_.isEmpty(scope.activeAppointments.requests)){
            createNextImmediateActions(ajaxData.statusId)
          }
          UserService.activeAppointmentsDummyData = response.data;
          UserService.activeAppointmentsDummyDataCollection = statusTransform(response.data.requests);
          scope.refreshData = true;
          scope.totalRows = response.data.totalRows;
          scope.isTotalRows = response.data.requests && response.data.requests.length > 20 ? true : false;
          var distPage = Math.ceil(scope.totalRows / 25);
          scope.noOfPageDdl = [];
          for (var i = 25; i <= scope.totalRows; i = i + 25) {
            var j = i;
            scope.noOfPageDdl.push(j);
          }
          var diff = scope.totalRows - j;
          if (diff < 0) {
            scope.noOfPageDdl.push(scope.noOfPageDdl[scope.noOfPageDdl.length - 1] + Math.abs(diff));
          } else {
            if (!isNaN(diff)) {
              scope.noOfPageDdl.push(scope.noOfPageDdl[scope.noOfPageDdl.length - 1] + diff);
            }
          }
        } else {
          UtilitiesService.showAlertMessage('No Record Found.');
        }
      })
    };

    scope.loadPageData = function () {
      if (($stateParams.statusId == 'newAppointments') || ($stateParams.statusId == 'attendanceConfirmation') || ($stateParams.statusId == 'documentsPending') || ($stateParams.statusId == 'documentsReceived') || ($stateParams.statusId == 'settled') || ($stateParams.statusId == 'cancelled')) {
        scope.passedStatuses = $stateParams.searchValue.split(" ");
        scope.passedStatuses.forEach(function (elem, ind) {
          scope.passedStatuses[ind] = parseInt(elem);
        })
        var fromDate = scope.filtere.fromDate ? moment(scope.filtere.fromDate).format('DD/MMM/YYYY') : null;
        var toDate = scope.filtere.toDate ? moment(scope.filtere.toDate).format('DD/MMM/YYYY') : null;
        if (scope.passedStatuses[0] == 22) {
          scope.tabHeading = 'New Appointments';
        } else if ((scope.passedStatuses[0] == 24) || (scope.passedStatuses[0] == 23) || (scope.passedStatuses[0] == 89) || (scope.passedStatuses[0] == 129)) {
          scope.tabHeading = 'Confirmed';
        } else if (scope.passedStatuses[0] == 32) {
          scope.tabHeading = 'Pending Report Upload';
        } else if (scope.passedStatuses[0] == 37) {
          scope.tabHeading = 'Outstanding';
        } else if (scope.passedStatuses[0] == 48) {
          scope.tabHeading = 'Settled';
        } else if ((scope.passedStatuses[0] == 28) || (scope.passedStatuses[0] == 42) || (scope.passedStatuses[0] == 26) || (scope.passedStatuses[0] == 43) || (scope.passedStatuses[0] == 27) || (scope.passedStatuses[0] == 119)) {
          scope.tabHeading = 'Cancelled';
        }
        scope.searchAppointmentsGroup(scope.serverSearch.statusSearch, scope.serverSearch.contractType, scope.serverSearch.corporateId, fromDate, toDate, 0);
      } else if (($stateParams.statusId == "New Appointments") || ($stateParams.statusId == "Today's Appointments") || ($stateParams.statusId == "Pending Report Upload") || ($stateParams.statusId == "Outstanding") || ($stateParams.statusId == "Settled") || ($stateParams.statusId == "Attendance Confirmation")) {
        scope.tabHeading = $stateParams.statusId;
        scope.passedStatuses = [];
        scope.passedStatuses.push(parseInt($stateParams.searchValue))
        var searchWord = $stateParams.statusId.split(" ");
        var fromDate = moment(scope.filtere.fromDate ? scope.filtere.fromDate : $stateParams.frmDate).format('DD/MMM/YYYY');
        var toDate = moment(scope.filtere.toDate ? scope.filtere.toDate : $stateParams.toDate).format('DD/MMM/YYYY');

        if (searchWord[0] == "Today's") {
          var today = moment(new Date());
          var tomorrow = moment(new Date()).add(1, 'days');
          today = moment(today).format('DD/MMM/YYYY');
          tomorrow = moment(tomorrow).format('DD/MMM/YYYY');
          scope.searchAppointmentsGroup(scope.serverSearch.statusSearch, scope.serverSearch.contractType, scope.serverSearch.corporateId, today, tomorrow, 0);
        } else if (fromDate || toDate) {
          scope.filtere.fromDate = moment(scope.filtere.fromDate ? scope.filtere.fromDate : $stateParams.frmDate).toDate();
          scope.filtere.toDate = moment(scope.filtere.toDate ? scope.filtere.toDate : $stateParams.toDate).toDate();
          scope.searchAppointmentsGroup(scope.serverSearch.statusSearch, scope.serverSearch.contractType, scope.serverSearch.corporateId, scope.filtere.fromDate, scope.filtere.toDate, 0);
        } else {
          scope.searchAppointmentsGroup(scope.serverSearch.statusSearch, scope.serverSearch.contractType, scope.serverSearch.corporateId, '', '', 0);
        }
      } else {
        var data = {
          selectedOrderType: $stateParams.statusId,
          value: $stateParams.searchValue
        }
        scope.tabHeading = 'Searched by ' + $stateParams.statusId + ': ' + $stateParams.searchValue;
        scope.searchAppointment(data);
      }
    }

    scope.loadPageData();

    scope.searchAppointmentsGroupCtrl = function (currentRecordPerPage) {
      var fromDate = scope.filtere.fromDate ? moment(scope.filtere.fromDate).format('DD/MMM/YYYY') : "";
      var toDate =  scope.filtere.toDate ? moment(scope.filtere.toDate).format('DD/MMM/YYYY') : "";
      scope.searchAppointmentsGroup(scope.serverSearch.statusSearch, scope.serverSearch.contractType, scope.serverSearch.corporateId, fromDate, toDate, currentRecordPerPage);
    };

    scope.filterPage = function (rowNo) {
      scope.rowNo = parseInt(rowNo.count);
      $rootScope.$broadcast('newCount', rowNo.count);
    };

    scope.reloadAppointments = function () {
      scope.pageNo = 0;
      scope.rowCount = 10;
      scope.searchAppointmentsGroup(scope.serverSearch.statusSearch, scope.serverSearch.contractType, scope.serverSearch.corporateId, scope.filtere.fromDate, scope.filtere.toDate, 0)
      // scope.loadAppointments();
    };
    scope.reCreateTestData = function () {
      scope.testData.testStateId = '';
      scope.testData.testSubLocalityId = '';
      scope.testData.testCityId = '';
      scope.testData.testLocalityId = '';
      scope.testData.dcValue = '';
    }
    scope.medicalTestMethods = (function () {
      scope.relatedTests = [];
      scope.tempBucket = [];
      scope.groups = [
        []
      ];
      return {
        splitRequests: function (getGrps) {
          var dataObj = [];
          var restObj = [];
          scope.reCreateTestData();
          angular.forEach(scope.relatedTests, function (ind, val) {
            var obj = [];
            ind.providerId = scope.originalDcDetails.providerId;
            ind.providerName = scope.originalDcDetails.providerName;
            ind.appointmentDate = scope.originalDcDetails.appointmentDate;
            ind.visitType = scope.originalDcDetails.providerVisitType;
            scope.groups[0].push(ind)
          })
          angular.forEach(scope.groups, function (buckets, i) {
            angular.forEach(buckets, function (test, ib) {
              var obj = {};
              if (i == 0) {
                obj = {
                  productId: test.id,
                  providerId: test.providerId,
                  providerName: test.providerName,
                  appointmentDate: test.appointmentDate,
                  visitType: test.visitType,
                  groupId: 0
                }
              } else {
                obj = {
                  productId: test.id,
                  providerId: parseInt($("#dcid_" + i).val()),
                  providerName: $("#dcid_" + i + " option:selected").text(),
                  appointmentDate: $("#datetime_" + i).val(),
                  visitType: $("#visittype_" + i + " option:selected").text(),
                  groupId: i
                }
              }
              dataObj.push(obj)
            })
          })
          var data = {
            requestId: $rootScope.requestIdForActiveAppointmnents,
            details: dataObj
          }
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/SplitRequest/', data, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data.isSuccess === true) {
              scope.relatedTests = [];
              scope.tempBucket = [];
              scope.groups = [
                []
              ];
              scope.originalDcDetails = {};
              UtilitiesService.showAlertMessage("Request splited successfully", true)
            } else {
              UtilitiesService.showAlertMessage(response.data.errorMessage, false);
            }
          });
        },
        addTestToPermanentBucket: function () {
          scope.disableTempCreate = false;
          scope.desableLocation = true;
          $(scope.tempBucket).each(function (i, v) {
            v.groupId = scope.groups.length;
          })
          scope.groups.push(scope.tempBucket);
          scope.tempBucket = [];
        },
        removeFromGroups: function (removeItem) {
          removeItem.checkTest = false;
          $.each(scope.groups, function (i, val) {
            if (val.indexOf(removeItem) != -1) {
              scope.relatedTests.push(removeItem);
              val.splice(val.indexOf(removeItem), 1);
              return true;
            }
          })
        },
        addTestToTempBucket: function (checkedItem) {
          checkedItem.checkTest = true;
          scope.tempBucket.push(checkedItem);
          scope.relatedTests.splice(scope.relatedTests.indexOf(checkedItem), 1)
        },
        removeBucketFromGroup: function (index) {

          $(scope.groups[index]).each(function (i, v) {
            v.groupId = 0;
            v.checkTest = false;
            scope.relatedTests.push(v);
          });
          scope.groups.splice(index, 1)
        },
        getTestsForPackage: function (productId, reqtId, providerId, providerName, appointmentDate, visitType) {
          var allProductIds = [];
          scope.action.productId = productId;
          scope.originalDcDetails.providerId = providerId;
          scope.originalDcDetails.providerName = providerName;
          scope.originalDcDetails.appointmentDate = appointmentDate;
          scope.originalDcDetails.visitType = visitType;
          scope.groups = [
            []
          ];
          scope.testData.testStateId = "";
          scope.cities = {};
          scope.locations = {};
          scope.sublocations = {};
          scope.allDCs = {};
          if (typeof (productId) === 'object') {
            angular.forEach(productId, function (key, value) {
              allProductIds.push(parseInt(value));
            });
            var data = {
              'packageIDs': allProductIds
            };
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelationWithIds/', data, 'POST', UserService.getAccessToken()).then(function (response) {
              if (response.data) {
                if (response.data.length > 0) {
                  var temp = []
                  scope.requestId = reqtId;
                  scope.relatedTests = [];
                  scope.testsObj = {};
                  if (scope.tempBucket.length > 0) {
                    scope.tempBucket = [];
                  }
                  response.data.map(function (item) {
                    temp.push(item.allowedInvestigations);
                  })
                  temp.map(function (v) {
                    v.map(function (value) {
                      scope.relatedTests.push(value);
                      scope.testsObj[value.id] = value;
                    })
                  })
                } else {
                  UtilitiesService.showAlertMessage("No matching test can be found", false);
                }
              }
            });
          } else {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/' + productId, '', 'Get', UserService.getAccessToken()).then(function (response) {
              if (response.data) {
                scope.requestId = reqtId;
                scope.relatedTests = [];
                scope.testsObj = {};
                if (scope.tempBucket.length > 0) {
                  scope.tempBucket = [];
                }
                scope.relatedTests = response.data.allowedInvestigations;
                scope.relatedTests.map(function (v) {
                  scope.testsObj[v.id] = v;
                })
              }
            });
          }
        },
        removeFromBucket: function (checkedItem) {
          checkedItem.checkTest = false;
          scope.relatedTests.push(checkedItem);
          scope.tempBucket.splice(scope.tempBucket.indexOf(checkedItem), 1)
        }
      };
    })();

    scope.actionRequest = function (actionType, event) {
      if ((scope.requestData.productType === 10307 || scope.requestData.productType === 10390) && scope.requestData.providerId === 177324) {
        scope.createRequestForPharma(actionType, scope.action.nextStatusId, scope.action.requestId, scope.action.statusId, scope.requestData);
      } else if (scope.requestData && scope.requestData.additionalInformation) {
        if ((scope.requestData.additionalInformation.productType === 10307 || scope.requestData.additionalInformation.productType === 10390) && scope.requestData.additionalInformation.providerId === 177324) {
          scope.createRequestForPharma(actionType, scope.action.nextStatusId, scope.action.requestId, scope.action.statusId, scope.requestData.additionalInformation);
        } else {
          scope.createRequest('Appointment', scope.action.statusId, scope.action.nextStatusId, scope.action.requestId, actionType, scope.action.spocname, scope.action.spocphone, event);
        }
      } else {
        scope.createRequest('Appointment', scope.action.statusId, scope.action.nextStatusId, scope.action.requestId, actionType, scope.action.spocname, scope.action.spocphone, event);
      }
      scope.action.remarks = null;
    };

    scope.createRequestForPharma = function (actionType, nextStatusId, requestId, statusId, requestData) {
      var invoiceDetails = null;
      var remark = actionType;
      switch (actionType) {
        case 'Delivered':
          invoiceDetails = [];
          if (scope.pharmaData.cashlessAmt && scope.pharmaData.cashlessAmt >= 0 && scope.pharmaData.CODAmt && scope.pharmaData.CODAmt >= 0) {
            var cashlessAmt = {
              order_value: scope.pharmaData.cashlessAmt,
              discounted_value: scope.pharmaData.cashlessAmt,
              invoice_number: '',
              payment_mode: 0
            }
            var CODAmt = {
              order_value: scope.pharmaData.CODAmt,
              discounted_value: scope.pharmaData.CODAmt,
              invoice_number: '',
              payment_mode: 1
            }
            invoiceDetails.push(CODAmt);
            invoiceDetails.push(cashlessAmt);
          } else {
            if (scope.pharmaData.cashlessAmt && scope.pharmaData.cashlessAmt >= 0) {
              var cashlessAmt = {
                order_value: scope.pharmaData.cashlessAmt,
                discounted_value: scope.pharmaData.cashlessAmt,
                invoice_number: '',
                payment_mode: 0
              }
              invoiceDetails.push(cashlessAmt);
            } else if (scope.pharmaData.CODAmt && scope.pharmaData.CODAmt >= 0) {
              var CODAmt = {
                order_value: scope.pharmaData.CODAmt,
                discounted_value: scope.pharmaData.CODAmt,
                invoice_number: '',
                payment_mode: 1
              }
              invoiceDetails.push(CODAmt);
            }
          }
          break;
        case 'OutForDelivery':
          invoiceDetails = null;
          break;
        case 'Cancel':
          invoiceDetails = null;
          remark = scope.action.cancelReason == 'Other' ? scope.action.cancelComments : scope.action.cancelReason;
          break;
        case 'ConfirmByRetailer':
          invoiceDetails = null
          break;
        default:
          invoiceDetails = null
          break;
      }
      var data = {
        key: requestData.providerId,
        response: {
          requestID: requestId,
          status: nextStatusId,
          remarks: remark,
          invoiceDetails: invoiceDetails,
          requestAccessToken: UserService.getAccessToken()
        }
      }
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/ProviderOrderUpdate', data, 'POST').then(function (response) {
        $("#" + actionType + "Modal").modal('hide');
        // scope.loadAppointments();
        scope.searchAppointmentsGroup(scope.serverSearch.statusSearch, scope.serverSearch.contractType, scope.serverSearch.corporateId, scope.filtere.fromDate, scope.filtere.toDate, 0)
        scope.action = {};
      });
    }
    scope.changeDc = function (value) {
      scope.selectedDcs = filterFilter(scope.diagnosticCentres, value);
    };

    //Set user secondary pref date and time
    scope.useSecondPref = function () {
      scope.form.dod = UtilitiesService.getDateObj(scope.action.secondPreferredTime);
      scope.client.prefDate = scope.form.dod;
      scope.client.prefTime = scope.form.dod;
    };

    scope.changeBloodGrp = function (value) {
      scope.selectedBloodGrp = value;
    };
    scope.action.showdcselection = false;
    scope.showDcSelection = function (value, source) {
      scope.action.showdcselection = !!value;

      scope.testData.testStateId = '';
      scope.cities = [];
      scope.testData.testCityId = '';

      scope.locations = [];
      scope.testData.testLocalityId = '';

      scope.sublocations = [];
      scope.testData.testSubLocalityId = '';

      scope.diagnosticCentres = [];
      scope.testData.dcValue = '';

      if (source === 'dcVisit') {
        scope.action.showHomeVisitSelection = false;
        scope.homeVisit = [];
        if (scope.action.showdcselection === false) {
          scope.testData.testStateId = '';
          scope.testData.testCityId = '';
          scope.testData.testLocalityId = '';
          scope.testData.testSubLocalityId = '';
          scope.testData.dcValue = '';
          scope.selectedDcs = [];
        }
      }
      if (source === 'homeVisit') {
        scope.action.showdcselection = false;
        scope.testData.testStateId = '';
      }
    };

    scope.uploadedFileData = {
      reports: {},
      bills: {}
    };

    scope.storeFiles = [];
    scope.storedBill = [];

    scope.downloadAttachment = function (obj) {
      if (obj) {
        window.open(
          UtilitiesService.getDownloadURL(true) + obj,
          '_blank'
        );
      }
    };

    scope.removeBillFiles = function (item) {
      if (item) {
        delete scope.uploadedFileData.bills[item.filePath];
        angular.forEach(scope.storedBill, function (value, index) {
          if (value.fileName === item.fileName) {
            scope.storedBill.splice(value, 1);
          }
        });
      }
    };

    scope.removeFiles = function (item) {
      if (item) {
        delete scope.uploadedFileData.reports[item.filePath];
        angular.forEach(scope.storeFiles, function (value, index) {
          if (value.fileName === item.fileName) {
            scope.storeFiles.splice(value, 1);
          }
        });
      }
    };

    scope.fileFn = function (data, type) {
      if (data) {
        if (type === 'report') {
          for (var key in data) {
            scope.uploadedFileData.reports[key] = data[key];
          }
          angular.forEach(data, function (value, index) {
            scope.storeFiles.push({
              fileName: value,
              filePath: index
            });
          });
        } else if (type === 'bill') {
          for (var key in data) {
            scope.uploadedFileData.bills[key] = data[key];
          }
          angular.forEach(data, function (value, index) {
            scope.storedBill.push({
              fileName: value,
              filePath: index
            });
          });
        }
      }
    };

    //Next possible action for request call
    scope.createRequest = function (requestType, statusId, nextStatusId, requestId, actionType, spocname, spocphone, event) {
      var patientname = scope.selectedPatientName;
      var id = requestId; //scope.selectedRequestId;
      var appDate = scope.action.date;
      scope.client.prefDate = UtilitiesService.mergeDateTimeObj(scope.client.prefDate, scope.client.prefTime);
      var providerId = null;
      var providerName = "";
      var remarksComment = scope.action.remarks;
      scope.action.remarks = "";
      var additionalParams = {};
      switch (actionType) {
        case 'Reschedule':
          appDate = scope.client.prefDate;
          if (scope.selectedDcs.length > 0 && !(scope.user.entitytype == 'dc')) {
            providerId = _.first(scope.selectedDcs).id;
            providerName = _.first(scope.selectedDcs).entityName;
          }
          var dcActive = scope.checkIfDc();
          if (dcActive) {
            scope.setMaxFirst(20)
          }
          break;
        case 'Cancel':
          appDate = scope.action.date;
          remarksComment = scope.action.cancelReason == 'Other' ? scope.action.cancelComments : scope.action.cancelReason;
          break;
        case 'QCApprove':
          additionalParams.doctorQualification = scope.doctorQualificatio ? scope.doctorQualificatio : '';
          additionalParams.isPhotographAvailable = scope.isPhotoAvailble.value;
          additionalParams.ActualApptDate = scope.popupQc.actualDate;
          break;
        case 'Confirm':
          additionalParams.Price = scope.action.dcPrice;
          if (scope.homeVisitCheck) {
            additionalParams.sampleCollectionBy = JSON.stringify(scope.action.homeVisitType)
          }
          break;
        case 'Fit':
          additionalParams.bloodGroup = scope.bloodGrp.selectedBloodGrp;
          break;
        case 'UnFit':
          additionalParams.bloodGroup = scope.bloodGrp.selectedBloodGrp;
          break;
        case 'Delivered':
          break;
        case 'OutForDelivery':
          break;
        case 'ConfirmByRetailer':
          break;
        case 'InsurerAction':
          // var remarksComment = scope.action.remarks;
          break;
        case 'UTC':
          // var remarksComment = scope.action.remarks;
          scope.attachFiles = scope.uploadedFileData;
          break;
        case 'UTCAwaited':
          // var remarksComment = scope.action.remarks;
          scope.attachFiles = [];
          break;
        case 'Submit':
          // var remarksComment = scope.action.remarks;
          scope.attachFiles = scope.uploadedFileData;
          break;
        default:
          appDate = scope.action.date;
          break;
      }
      scope.selectedDcs = [];
      var requestData = {
        request: {
          requestId: requestId,
          currentStatusId: statusId,
          remarks: remarksComment,
          ScheduledAppointmentDate: appDate,
          requestedNextActionId: nextStatusId,
          attachFiles: scope.attachFiles,
          providerId: providerId,
          providerName: providerName,
          spocName: spocname,
          spocContactNo: spocphone,
          additionalParameters: additionalParams,
          addressLine1: scope.homeVisit.addressLineOne ? scope.homeVisit.addressLineOne : '',
          addressLine2: scope.homeVisit.addressLinTwo ? scope.homeVisit.addressLinTwo : '',
          userFeedback: scope.action.feedback ? scope.action.feedback : ''
          //isHomeVisit: scope.action.showHomeVisitSelection === true ? true : (scope.visitTypeDcHome === 'Appointment' ? false : (scope.visitTypeDcHome === 'Home_Visit' ? true : false))
        },
        requestAccessToken: UserService.getAccessToken()
      }
      if (scope.action.showHomeVisitSelection === true) {
        requestData.request.isHomeVisit = true;
        scope.visitTypeDcHome = '';
      } else if (scope.action.showHomeVisitSelection === false) {
        requestData.request.isHomeVisit = false
        scope.visitTypeDcHome = '';
      } else if (scope.visitTypeDcHome === 'Appointment') {
        requestData.request.isHomeVisit = false
      } else if (scope.visitTypeDcHome === 'Home_Visit') {
        requestData.request.isHomeVisit = true
      }
      
      UserService.makeRestCall(UtilitiesService.getProviderCoreUrl() + 'provider/updateRequest', requestData, "post").then(function (response) {
        var targetModal = event.target.parentNode;
        scope.popupQc.actualDate = '';
        scope.resetTime();
        scope.testData.testStateId = '';
        scope.testData.testCityId = '';
        scope.testData.testLocalityId = '';
        scope.testData.testSubLocalityId = '';
        scope.dcValue = '';
        scope.selectedDcs = [];
        scope.selectedBloodGrp = '';
        scope.newlyUploadedReports = [];
        scope.newlyUploadedBills = [];
        scope.storeFiles = [];
        scope.storedBill = [];
        scope.uploadedFileData.reports = {};
        scope.uploadedFileData.bills = {};
        scope.today();
        while (!targetModal.classList.contains('modal')) {
          targetModal = targetModal.parentNode;
        }
        $('#' + actionType + 'Modal').modal('hide');
        // scope.loadAppointments();
        scope.searchAppointmentsGroup(scope.serverSearch.statusSearch, scope.serverSearch.contractType, scope.serverSearch.corporateId, scope.filtere.fromDate, scope.filtere.toDate, 0)
        if (scope.attachFiles) {
          if (scope.attachFiles.reports) {
            scope.attachFiles.reports = {};
          }
          if (scope.attachFiles.bills) {
            scope.attachFiles.bills = {};
          }
        }
        scope.action = {};
      });
    }

    scope.updateRemarks = function (actualDate) {
      scope.action.remarks = "Actual attended date is :" + actualDate;
    };
    scope.dynamicPopover = {
      content: 'Hello, World!',
      templateUrl: 'myPopoverTemplate.html',
      title: 'Title'
    };
    scope.loadFilteredDc = function () {
      var url = UtilitiesService.getPlusUrlPrefix() + "CorporatePackageProvider/" + scope.action.productId + "/false.json";
      UserService.makeRestCall(url, "", "get").then(function (response) {
        if (response.data.length > 0) {
          scope.filteredDc = response.data;
          var arr = [];
          scope.diagnosticCentres = [];
          $(scope.tempDiagnosticCentres).each(function (i, v) {
            if (scope.filteredDc.indexOf(v.id) !== -1) {
              arr.push(v);
            }
          });
          scope.diagnosticCentres = arr;
        }
      });
    };

    //Get location
    scope.locationMethods = (function () {
      return {
        loadStates: function () {
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + '/masterdata/lookup/state.json', '', 'get').then(function (response) {
            if (response.data.isSuccess) {
              scope.states = response.data.lookUpData;
            }
          });
        },
        loadCities: function (stateId) {
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/masterdata/lookup/district/' + stateId + '.json', '', 'get').then(function (response) {
            if (response.data.isSuccess) {
              scope.cities = response.data.lookUpData;
            }
          });
        },
        loadLocations: function (cityId) {
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/masterdata/lookup/city/" + cityId + '.json', '', 'get').then(function (response) {
            if (response.data.isSuccess) {
              scope.locations = response.data.lookUpData;
            }
          });
        },
        loadSubLocations: function (locationId) {
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/masterdata/lookup/location/' + locationId + '.json', '', 'get').then(function (response) {
            if (response.data.isSuccess) {
              scope.sublocations = response.data.lookUpData;
            }
          });
        },
        loadDCForTests: function (id, obj) {
          scope.testData.testSubLocalityId = id;
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'EntityRelation/Search/EntitySearch/' + scope.ERTypeId + '/' + scope.serviceBrokerId + '/' + 0 + '/' + scope.testData.testStateId + '/' + scope.testData.testCityId + '/' + scope.testData.testLocalityId + '/' + scope.testData.testSubLocalityId + '.json', '', 'get').then(function (response) {
            if (response.statusText == 'OK') {
              scope.allDCs = response.data;
              scope.tempDiagnosticCentres = response.data;
              scope.loadFilteredDc();
            }
          });
        }
      }
    })();

    //Load Location based ontype
    scope.loadLocationData = function (type, id) {
      switch (type) {
        case 'city':
          scope.locationMethods.loadCities(id);
          break;
        case 'locality':
          scope.locationMethods.loadLocations(id);
          break;
        case 'sublocality':
          scope.locationMethods.loadSubLocations(id);
          break;
        case 'dc':
          scope.locationMethods.loadDCForTests(id);
          break;
        default:
          scope.locationMethods.loadCities(id);
          break;
      }
    };

    //Reset time
    scope.resetTime = function () {
      scope.maxFirst = '';
      scope.minFirst = '';
      scope.client.prefTime = '';
      var maxFirst = new Date();
      maxFirst.setHours(18);
      maxFirst.setMinutes(0);
      scope.maxFirst = maxFirst;
      var minFirst = new Date();
      minFirst.setHours(8);
      minFirst.setMinutes(0);
      scope.minFirst = minFirst;
      scope.client.prefTime = minFirst;
    };
    scope.pharmaData = {
      cashlessAmt: '',
      CODAmt: ''
    }
    //Open Action popup
    scope.openRespectiveActionModal = function (actionName, currentStatusId, actionStatusId, requestId, appointmentDate, secondAppointmentDate, orderItemProductId, requestData) {
      $timeout(function(){
        var modalName = '#' + actionName + 'Modal';
        $(modalName).modal('show');
      })
      scope.requestData = requestData;
      scope.homeVisitCheck = false;
      scope.visitTypeDcHome = requestData ? (requestData.additionalInformation ?
        (requestData.additionalInformation.visitType ? requestData.additionalInformation.visitType : '') : (requestData.visitType ? requestData.visitType : '')) : '';
      scope.action.partnerOrderId = '';
      scope.pharmaData.cashlessAmt = '';
      scope.pharmaData.CODAmt = '';
      scope.resetTime();
      scope.showDcSelection();
      scope.actionId = actionStatusId;
      scope.client.prefDate = UtilitiesService.getDateObj(appointmentDate);
      if (actionStatusId === 121) {
        $('#UTC').modal('show');
        scope.tuModel = 'Completed';
      } else if (actionStatusId === 122) {
        $('#UTC').modal('show');
        scope.tuModel = 'Scheduled';
      } else if (actionStatusId === 123) {
        $('#UTCAwaited').modal('show');
        scope.tuModel = 'Awaited';
      } else if (actionStatusId !== 122 || actionStatusId !== 122) {
        scope.actionName = actionName;
      }
      scope.storeFiles = [];
      scope.storedBill = [];
      scope.uploadedFileData.reports = {};
      scope.uploadedFileData.bills = {};
      scope.action.showdcselection = false;
      scope.action.remarks = '';
      scope.action.statusId = currentStatusId;
      scope.action.nextStatusId = actionStatusId;
      scope.action.requestId = requestId;
      scope.action.date = appointmentDate;
      scope.action.visibleDate = scope.compareDate(appointmentDate);
      scope.action.visibleTime = scope.action.visibleDate + " " + scope.formatTime(appointmentDate);
      scope.action.secondPreferredTime = secondAppointmentDate;
      scope.secondPreferredVTime = scope.compareDate(secondAppointmentDate) + " " + scope.formatTime(secondAppointmentDate);
      scope.action.productId = orderItemProductId;
      scope.action.requestContractType = requestData && requestData.requestContractType;
      //empty all modals

      if (scope.actionName == 'Fit' || scope.actionName == 'UnFit') {
        if (scope.action.remarks) {
          scope.action.remarks.fit = '';
          scope.selectedBloodGrp = '';
        }
      }
      if (scope.actionName == 'Reschedule') {
        scope.locationMethods.loadStates();
        scope.form.dod = '';
        scope.action.showdcselection = false;
        scope.testData.testStateId = '';
        scope.testData.testCityId = '';
        scope.testData.testLocalityId = '';
        var dcActive = scope.checkIfDc();
        if (dcActive) {
          scope.setMaxFirst(20);
        }
      }
      if (scope.actionName == 'Confirm') {
        scope.action.spocname = '';
        scope.action.spocphone = '';
        scope.action.dcPrice = '';
        if (scope.visitTypeDcHome == 'Home_Visit') {
          scope.homeVisitTypeArray = [
            { id: 'HOME_VISIT_BY_DOCTOR', name: 'DOCTOR' },
            { id: 'HOME_VISIT_BY_LAB_TECHNICIAN', name: 'LAB TECHNICIAN' },
            { id: 'HOME_VISIT_BY_ECG_TECHNICIAN', name: 'ECG TECHNICIAN' },
            { id: 'HOME_VISIT_BY_MBBS_DOCTOR', name: 'MBBS DOCTOR' },
            { id: 'HOME_VISIT_BY_MD_DOCTOR', name: 'MD DOCTOR' },
          ];
          scope.homeVisitCheck = true;
        }
      }
      if (scope.actionName == 'Cancel') {
        scope.action.visibleTime = scope.action.visibleDate + ' ' + scope.compareDate(scope.action.date);
      }
      if (scope.actionName == 'Approve' || scope.actionName == 'NotAttended' || scope.actionName == 'Raise_IA') {
        scope.action.remarks = "";
      }
      if (scope.actionName == 'Attended') {
        scope.actualdate = '';
        scope.action.remarks = '';
        scope.action.feedback = '';
      }
      if (scope.actionName == 'Submit') {
        scope.reports = [];
        scope.bills = [];
        scope.attachFiles.reports = {};
        scope.attachFiles.bills = {};
        scope.storeFiles = [];
        scope.storedBill = [];
        scope.uploadedFileData.reports = {};
        scope.uploadedFileData.bills = {};
        scope.action.remarks = '';
      }
      if (scope.actionName == 'PlaceWithPartner') {
        scope.partnerOrderId = '';
      }
      if (scope.actionName == 'Delivered') {
        scope.pharmaData.cashlessAmt = '';
        scope.pharmaData.CODAmt = '';
      }
    }

    scope.homeVisitBy = function (checkedItem,event) {
      var ifItemExist = scope.action.homeVisitType.includes(checkedItem.id);
      if(event.currentTarget.checked){
        if(!ifItemExist){
          scope.action.homeVisitType.push(checkedItem.id)
        }
      }else{
        if(ifItemExist){
          var index = scope.action.homeVisitType.indexOf(checkedItem.id);
            if (index > -1) {
              scope.action.homeVisitType.splice(index, 1);
            }
        }
      }
      console.log("items::", scope.action.homeVisitType)
    }

    scope.placeWithPartner = function () {
      var data = {
        RequestId: scope.action.requestId,
        PartnerOrderId: scope.action.partnerOrderId
      };
      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/requestPharmaOrder', data, 'POST', UserService.getAccessToken()).then(function (response) {
        if (response.data == true) {
          UtilitiesService.showAlertMessage('Order has been placed Successfully.', true);
          $('#PlaceWithPartnerModal').modal('hide');
        }
        if (response.data == false) {
          UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to place order.');
          $('#PlaceWithPartnerModal').modal('hide');
        }
      })
    };

    //display wallet balance
    scope.showWalletBalance = function (balance, isSuccess) {
      scope.isSuccess = isSuccess;
      scope.showWalletBalanceMsz = isSuccess === true ? 'Rs. ' + balance + '/-' : balance;
      var modalInstance = $uibModal.open({
        animation: scope.animationsEnabled,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: "walletModal.html",
        controller: 'appointmentsController',
        scope: scope,
      });
    };

    //Appointment Search
    scope.$watch('plusAppointmentsSearch', function (current, old) {
      if (current) {
        scope.activeAppointments = UserService.GetFilteredAppointment(current);
      } else {
        if (old) {
          UserService.activeAppointmentsDummyData.requests = UserService.activeAppointmentsDummyDataCollection;
          scope.activeAppointments = UserService.activeAppointmentsDummyData;
        }
      }
    });

    scope.addFileToUpload = function (source) {
      if (source == 'reports' && source) {
        var newItemNo = scope.reports.length + 1;
        scope.reports.push({
          'model': ''
        });
      }
      if (source == 'bills') {
        var newItemNo = scope.bills.length + 1;
        scope.bills.push({
          'model': ''
        });
      }
    };

    scope.removeFileToUpload = function (index, source) {
      if (source == 'reports' && source) {
        scope.reports.splice(index, 1);
      }
      if (source == 'bills') {
        scope.bills.splice(index, 1);
      }
    };

    scope.uploadMethodFile = function (source) {
      if (source) {
        scope.IsFileGrter = false;
        var fileBlobArray = [];
        var filesUploadingArray = [];
        if (source == 'reports') {
          Object.keys(scope.reports).forEach(function (ele) {
            if (typeof (scope.reports[ele].model) == 'object') {
              filesUploadingArray.push(scope.reports[ele].model);
            }
          });
          angular.forEach(filesUploadingArray, function (v, i) {
            var fileSize = v.size;
            if (fileSize > 10485760) {
              scope.IsFileGrter = true;
            }
          })
        }
        if (source == 'bills') {
          Object.keys(scope.bills).forEach(function (ele) {
            if (typeof (scope.bills[ele].model) == 'object') {
              filesUploadingArray.push(scope.bills[ele].model);
            }
          });
          angular.forEach(filesUploadingArray, function (v, i) {
            var fileSize = v.size;
            if (fileSize > 10485760) {
              scope.IsFileGrter = true;
            }
          })
        }
        if (filesUploadingArray.length > 0) {
          if (!scope.IsFileGrter) {
            fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrlPrefix() + "/File.json"));
          } else {
            alert('File size is greater then 10 MB');
            return false;
          }
        } else {
          alert('Please attach atleast one document.');
        }

        if (fileBlobArray.length > 0) {
          $q.all(fileBlobArray).then(function (result) {
            if (typeof result == "object" && typeof result[0].data == 'object') {
              for (var property in result[0].data) {
                if (result[0].data.hasOwnProperty(property)) {
                  var obj = {};
                  obj.fileName = result[0].data[property].split('.')[0] + new Date().getTime() + '.' + result[0].data[property].split('.')[1];
                  obj.filePath = UtilitiesService.getDownloadURL(true) + property;
                  obj.key = property;
                  if (source == 'reports') {
                    scope.newlyUploadedReports.push(obj);
                    angular.extend(scope.attachFiles.reports, result[0].data)
                    // console.log(scope.attachFiles.reports);
                    scope.reports = [];
                  }
                  if (source == 'bills') {
                    scope.newlyUploadedBills.push(obj);
                    angular.extend(scope.attachFiles.bills, result[0].data)
                    // console.log(scope.attachFiles.bills);
                    scope.bills = [];
                  }
                }
              }
            } else {
              alert('upload fail');
            }
          },
            function (error) {
              alert('upload fail');
            });
        }
      } else {
        alert('Please attach atleast one document.');
      }
    }

    scope.removeReports = function (indx, reportBill) {
      if (reportBill === 'report') {
        scope.tempUploadedReports = scope.newlyUploadedReports;
        var removedReportKey = scope.tempUploadedReports[indx];

        scope.tempUploadedReports.splice(indx, 1);
        scope.newlyUploadedReports = scope.tempUploadedReports;

        angular.forEach(scope.attachFiles.reports, function (v, i) {
          if (removedReportKey.key === i) {
            delete scope.attachFiles.reports[i];
          }
        })
        // console.log(scope.attachFiles.reports);
      }
      if (reportBill === 'bills') {
        scope.tempUploadedBill = scope.newlyUploadedBills;
        var removedBillKey = scope.tempUploadedBill[indx];

        scope.tempUploadedBill.splice(indx, 1);
        scope.newlyUploadedBills = scope.tempUploadedBill;

        angular.forEach(scope.attachFiles.bills, function (v, i) {
          if (removedBillKey.key === i) {
            delete scope.attachFiles.bills[i];
          }
        })
        // console.log(scope.attachFiles.bills);
      }
    };

    scope.removePrescriptions = function (indx) {
      scope.PharmaPrescriptionList.splice(indx, 1);
    }

    scope.openVarifyPresModal = function (PharmaPrescriptionData, source) {
      scope.PharmaPrescriptionList = [];
      if (source != 'reload') {
        scope.PharmaPrescriptionData = PharmaPrescriptionData;
        PharmaPrescriptionData.map(function (val) {
          scope.PharmaPrescriptionList.push({
            filePath: val.filePath,
            fileName: val.fileName
          });
        });
      }
      if (source == 'reload') {
        scope.PharmaPrescriptionData.map(function (val) {
          scope.PharmaPrescriptionList.push({
            filePath: val.filePath,
            fileName: val.fileName
          });
        });
      }
    };

    scope.verifyPrescription = function (urls) {
      scope.UrlList = urls;
      if (scope.UrlList) {
        scope.finalUrl = [];
        angular.forEach(urls, function (v, i) {
          var setUrl = v.filePath;
          scope.finalUrl.push(setUrl);
        })
        var data = {
          "requestId": $rootScope.requestIdForActiveAppointmnents,
          "updatePrescriptionURLs": scope.finalUrl,
          "isReplace": true
        }
        var url = UtilitiesService.getPlusUrlPrefix() + "UploadPharmaCashlessPrescription/";
        UserService.makeRestCall(url, data, "POST", UserService.getAccessToken()).then(function (response) {
          if (response.data) {
            scope.uploadedIsSuccess = response.data
            UtilitiesService.showAlertMessage('Files updated Successfully', true);
            $('#openVarifyPres').modal("hide");
          }
        },
          function (error) {
            UtilitiesService.showAlertMessage('issue in verify url.');
          })
      }
    };

    //closing uib bootstrap modals
    scope.closeModal = function () {
      scope.$dismiss('cancel');
    };


    scope.fileUploadMethods = (function () {
      return {
        addFileToUpload: function (flag) {
          var newItemNo = scope.file.length + 1;
          scope.file.push({
            'model': ''
          });
        },
        removeFileToUpload: function (index) {
          scope.file.splice(index, 1);
        }
      };
    })();

    scope.addGrievance = function (fileUploadData) {
      if (fileUploadData) {
        var finalGrieveReportComment = '';
        var grievImgComments = {};
        var tempPrevGrieve = [];

        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var currentDate = new Date();
        var currentMonth = currentDate.getMonth();

        var finalCurrentDate = (monthNames[currentDate.getMonth()]) + '-' + currentDate.getDate() + '-' + currentDate.getFullYear();

        if (scope.previousGrievancesComments) {
          tempPrevGrieve = scope.previousGrievancesComments;

          tempPrevGrieve.push({
            'grievanceReport': fileUploadData,
            'grievanceComment': scope.grive.griveComment,
            'grievDate': finalCurrentDate
          });
          finalGrieveReportComment = JSON.stringify(tempPrevGrieve);
        } else {
          grievImgComments.grievanceReport = fileUploadData;
          grievImgComments.grievanceComment = scope.grive.griveComment;
          grievImgComments.grievDate = finalCurrentDate;

          finalGrieveReportComment = JSON.stringify(grievImgComments); //to be sent to api
        }

        var data = {
          "requestId": $rootScope.requestIdForActiveAppointmnents,
          "additionalInfo": {
            "grievanceReportComment": finalGrieveReportComment,
          }
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'UpdateRequestAdditionalInfo', data, 'POST', UserService.getAccessToken()).then(function (response) {
          if (response.data) {
            $('#grievanceModal').modal('hide');
            UtilitiesService.showAlertMessage('Grievance raised successfully.', true);
          } else {
            UtilitiesService.showAlertMessage('oops! Error occur while raising grievance, please try again later.');
          }
        });
      }
    };

    scope.clearGrievanceModal = function (prevGrieve) {
      scope.file = [];
      scope.grive.griveComment = '';
      scope.previousGrievancesComments1 = '';
      scope.previousGrievancesComments = [];
      if (prevGrieve && prevGrieve.grievanceReportComment) {
        var tempObj = JSON.parse(prevGrieve.grievanceReportComment);
        var prevGrvObj = {};
        if (tempObj.grievanceReport) {
          angular.forEach(tempObj, function (key, val) {
            prevGrvObj[val] = key;
          })
          scope.previousGrievancesComments1 = prevGrvObj;
        } else {
          scope.previousGrievancesComments1 = tempObj;
        }
      }
      if (scope.previousGrievancesComments1 && scope.previousGrievancesComments1.grievanceReport) {
        scope.previousGrievancesComments.push({
          'grievanceReport': scope.previousGrievancesComments1.grievanceReport,
          'grievanceComment': scope.previousGrievancesComments1.grievanceComment,
          'grievDate': scope.previousGrievancesComments1.grievDate ? scope.previousGrievancesComments1.grievDate : '--'
        })
      } else {
        scope.previousGrievancesComments = scope.previousGrievancesComments1;
      }
    }
    scope.addGrive = function () {
      scope.uploadMethods.upload(scope.addGrievance);
    };

    scope.uploadMethods = (function () {
      return {
        upload: function (callback) {
          var fileBlobArray = [];
          var filesUploadingArray = [];
          Object.keys(scope.file).forEach(function (ele) {
            if (typeof (scope.file[ele].model) == "object") {
              filesUploadingArray.push(scope.file[ele].model);
            }
          });
          if (filesUploadingArray.length > 0) {
            fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrlPrefix() + "/File.json"));
          } else {
            $('#grievanceModal').modal('hide');
            UtilitiesService.showAlertMessage('Kindly upload atleast one file.');
            return false;
          }
          $q.all(fileBlobArray).then(function (result) {
            if (typeof result == "object" && typeof result[0].data == "object") {
              var objSentAjax = {};
              for (var property in result[0].data) {
                if (result[0].data.hasOwnProperty(property)) {
                  var obj = {};
                  obj.fileName = result[0].data[property];
                  obj.filePath = UtilitiesService.getDownloadURL(true) + property;
                  scope.newlyUploadedDocs.push(obj);
                  objSentAjax[(UtilitiesService.getDownloadURL(true) + property)] = result[0].data[property];
                }
              }
              if (result && scope.newlyUploadedDocs && scope.newlyUploadedDocs.length > 0)
                callback.call(scope.addGrievance, objSentAjax);
            } else {
              UtilitiesService.showAlertMessage('Upload fail.');
              return false;
            }
          },
            function (error) {
              UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            });
        },
        clearFileModels: function (isShow) {
          if (!isShow)
            scope.newlyUploadedDocs = [];
          scope.file = [];
          scope.fileUploadMethods.addFileToUpload();
        }
      };
    })();
    scope.locationMethods.loadStates();

    scope.ctrlFn = function (nextpage) {
      scope.pageNo = nextpage;
      scope.pageNo = scope.pageNo - 1;
      // scope.loadAppointments();
      scope.searchAppointmentsGroup(scope.serverSearch.statusSearch, scope.serverSearch.contractType, scope.serverSearch.corporateId, scope.filtere.fromDate, scope.filtere.toDate, ((scope.pageNo + 1) * 10))
    };
    if (scope.user && scope.user.properties) {
      if (scope.user && scope.user.entityId) {
          scope.EntityId = scope.user.entityId;
      }
    }
    scope.downloadDashBoardReport = function () {
      if (scope.EntityId) {
          var fromDate = scope.filtere.fromDate ? moment(scope.filtere.fromDate).format('DD/MMM/YYYY') : null;
          var toDate = scope.filtere.toDate ? moment(scope.filtere.toDate).format('DD/MMM/YYYY') : null;
          var selectedMonth, selectedYear = null;

          var data = {
              "entityId": scope.EntityId,
              "ERId": [UserService.getHospitalObj().entityRealtion ? (UserService.getHospitalObj().entityRealtion[0] ? UserService.getHospitalObj().entityRealtion[0].eR_ID : null) : ''],
              "StartDate": fromDate,
              "providerId":scope.user.providerId,
              "EndDate": toDate,
              "StatusId": $stateParams.searchValue,
              "SelectedMonth": selectedMonth,
              "SelectedYear": selectedYear
          };
          UtilitiesService.stopLoading('appointmentsData');
          UtilitiesService.startLoading('fetching appointments data...', 'appointmentsData');
          var responseContentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          UserService.viewFile(UtilitiesService.getProviderCoreUrl() + "provider/DownloadFile", data, responseContentType).then(function success(response) {
              // UserService.viewFile(UtilitiesService.getPlusUrl() + "Provider/DownloadClaimDetails", data, responseContentType).then(function success(response) {
              UtilitiesService.stopLoading('appointmentsData')
          }, function error(errorData) {
              UtilitiesService.stopLoading('appointmentsData')
          });
      } else {
          UtilitiesService.showAlertMessage('EntityId does not exist');
      }
    };
  }])

angular.module("mbplus")
.controller('appointmentsController', ['$scope', '$rootScope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics', 'PlusUtilitiesService', 'FileUploadService', '$q', 'orderByFilter', '$uibModal', '$timeout', function (scope, $rootScope, $location, UserService, UtilitiesService, filterFilter, $analytics, PlusUtilitiesService, FileUploadService, $q, orderByFilter, $uibModal, $timeout) {

    if (!UserService.isActive()) {
        UserService.destroyUserObj();
        $location.path('/');
        return false;
    }
    scope.status = {
        isFirstOpen: false,
    };
    scope.bloodGrp = {
        selectedBloodGrp: ''
    };
    scope.grive = {
        griveComment: ''
    };
    scope.isPhotoAvailble = {
        value: 'false'
    };
    scope.day = moment();
    scope.doctorQualificatio = '';
    scope.isOpenAccordian = false;
    $rootScope.plusAppointmentsSearch = '';
    $rootScope.dcInvestigations = '';
    $rootScope.dcInvestigationsMap = '';
    $rootScope.eSaleQueue = '';
    $analytics.pageTrack('/appointments');
    scope.ctrlName = 'appointmentsController';
    scope.user = UserService.getUserObj();
    scope.formatTime = UtilitiesService.formatTime;
    scope.compareDate = UtilitiesService.compareDate;
    scope.pharmaData = {
        cashlessAmt: '',
        CODAmt: ''
    }
    scope.isCorporate = false;
    scope.showChkedOnDcLogin = false;
    scope.contracts = [];
    scope.selectedDcs = [];
    scope.reports = [];
    scope.bills = [];
    scope.newlyUploadedReports = [];
    scope.newlyUploadedBills = [];
    scope.corporateSelectedID = '';
    scope.daysOfAppointment = '';
    scope.ERTypeId = 5290;
    scope.rowNo = 10;
    scope.Role = [5432, 5433, 5434];
    scope.serviceBrokerId = '1000042';
    scope.Entity_Type = '4653';
    scope.testData = {
        testStateId: '',
        testSubLocalityId: '',
        testCityId: '',
        testLocalityId: '',
        dcValue: ''
    };
    scope.homeVisit = {
        addressLineOne: '',
        addressLinTwo: ''
    }
    scope.resendEmailDetails = {
        emailID: '',
        statusID: ''
    };
    scope.client = {
        prefDate: new Date()
    }
    scope.originalDcDetails = {
        providerId: '',
        providerName: '',
        appointmentDate: '',
        visitType: ''
    };
    scope.dispayInDdl = "Search by";
    scope.serverSearch = {
        fromDate: '',
        toDate: '',
        statusSearch: '',
        contractType: '',
        corporateId: '',
        dateWiseSearch: 'apptdate'
    };
    scope.form = {
        dod: ''
    };
    scope.action = {
        cancelComments: '',
        statusId: '',
        nextStatusId: '',
        requestId: '',
        spocname: '',
        spocphone: '',
        date: '',
        remarks: '',
        secondPreferredTime: '',
        dcPrice: '',
        visibleDate: '',
        visibleTime: '',
        partnerOrderId: '',
        showdcselection: false,
        feedback: '' ,
        homeVisitType: []       
    };
    scope.attachFiles = {
        reports: {},
        bills: {}
    };
    scope.feedbackList = ['Satisfied', 'Dissatisfied', 'Pacifistic'];    
    scope.getDateObj = UtilitiesService.getDateObj;
    scope.file = [];
    scope.newlyUploadedDocs = [];
    scope.contracts = PlusUtilitiesService.getContracts();
    scope.contracts = UtilitiesService.getContracts() === null ? [] : UtilitiesService.getContracts();
    scope.childrenData = UtilitiesService.getAllChildren() === null ? [] : UtilitiesService.getAllChildren();
    scope.otp = false;
    angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
        if (v.roleId == 5432 || v.roleId == 5433 || v.roleId == 5434) { //opt enable for dc login
            scope.otp = true;
        }
    });

    if (scope.user) {
        scope.isSearchToShow = scope.user.entityType == 'DC' ? false : true;
    }
    scope.contracts.push({ id: '0', entityName: 'All Appointment Type' });
    if (scope.contracts.length > 0) {
        scope.contracts = orderByFilter(scope.contracts, 'entityName', false);
    }
    scope.contractsData = [];
    scope.contractsData.push({ id: '0', entityName: 'All Corporate' });
    scope.serverSearch.statusSearch = { id: '22', name: 'New Appointment Request' };
    scope.serverSearch.contractType = { id: '0', entityName: 'All Appointment Type' };
    scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };
    scope.showTextBtn = false;
    scope.activeAppointments = [];

    scope.rowPerPage = [{ id: 1, count: 10 }, { id: 2, count: 25 }, { id: 3, count: 50 }, { id: 4, count: 100 }, { id: 5, count: 300 }, { id: 6, count: 500 }, { id: 7, count: 700 }, { id: 8, count: 900 }, { id: 9, count: 1000 }, ];
    scope.rowNo = scope.rowPerPage[0];
    scope.reasonOfCancel = UtilitiesService.reasonOfCancel();

    scope.closeModel = function () {
        scope.popupQc.actualDate = '';
        scope.storeFiles =[];
        scope.storedBill =[];
        scope.action.cancelComments = '';
        scope.action.statusId = '';
        scope.action.nextStatusId = '';
        scope.action.requestId = '';
        scope.action.spocname = '';
        scope.action.spocphone = '';
        scope.action.date = '';
        scope.action.remarks = '';
        scope.action.secondPreferredTime = '';
        scope.action.dcPrice = '';
        scope.action.visibleDate = '';
        scope.action.visibleTime = '';
        scope.action.partnerOrderId = '';
        scope.action.showdcselection = false;
        scope.action.feedback = '',
        scope.uploadedFileData.reports = {};
        scope.uploadedFileData.bills = {};
        scope.resetTime();
    };

    //Set today's date
    scope.today = function () {
        scope.serverSearch.fromDate = moment(Date()).format("DD-MMM-YYYY");
        scope.serverSearch.fromDate = new Date(scope.serverSearch.fromDate);
        scope.serverSearch.toDate = moment(Date()).add(7, 'd').format("DD-MMM-YYYY");
        scope.serverSearch.toDate = new Date(scope.serverSearch.toDate);
        scope.dt = new Date();
    };
    scope.today();
    scope.serverSearch.fromDate = '';
    scope.serverSearch.toDate = '';
    scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 1
    };

    scope.dateOptionsReschedule = {
        formatYear: 'yy',
        minDate: new Date()
    };

    // Disable weekend selection
    function disabled(data) {
        var date = data.date,
          mode = data.mode;
        return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    }
    scope.open1 = function () {
        scope.popup1.opened = true;
    };
    scope.open2 = function () {
        scope.popup2.opened = true;
    };

    scope.popupQc ={
        opened: false,
        actualDate: ''
    }

    scope.openQcDate = function(){
        scope.popupQc.opened = true;
    };

    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];
    scope.popup1 = {
        opened: false
    };
    scope.popup2 = {
        opened: false
    };
    scope.reschedule = function () {
        scope.reschedule.opened = true;
    };

    //Date Object
    scope.today = function () {
        scope.client.prefDate = new Date();
        scope.dt = new Date();
    };
    scope.today();

    scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 1
    };
    scope.popup1 = {
        opened: false
    };

    scope.open1 = function () {
        scope.popup1.opened = true;
    };
    scope.attended = {
        opened: false
    }
    scope.attended = function () {
        scope.attended.opened = true;
    };
    //Set Time Object
    scope.resetTime = function () {
        var first = new Date();
        var dd = new Date(first).getDate();
        var mm = new Date(first).getMonth() + 1;
        var yy = new Date(first).getFullYear();
        var hh = 8;
        var ms = 0;
        var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
        scope.client.prefTime = new Date(x);
    };
    scope.resetTime();
    scope.hstep = 1;
    scope.mstep = 30;
    scope.ismeridian = false;
    //First time limit
    var maxFirst = new Date();
    maxFirst.setHours(18);
    maxFirst.setMinutes(0);
    scope.maxFirst = maxFirst;

    var minFirst = new Date();
    minFirst.setHours(8);
    minFirst.setMinutes(0);
    scope.minFirst = minFirst;

    function statusTransform(requests){
        _.each(requests, function(val){
            if(val.remarks && val.remarks.replace(/[\s-]/g, '').toLowerCase() == 'confirmedfromprovider'){
                val.currentStatus = 'Confirmed by Labwise';
            }
        })
        return requests;
    }

    //Get All Appointments
    scope.loadAppointments = function (id, name) {
        var statusId = scope.serverSearch.statusSearch.id ? scope.serverSearch.statusSearch.id : '0';
        var providerId, isInsurer, getid, status;
        scope.providerName = '';
        scope.providerName = scope.user.entityName;
        if (!(scope.user.entityType == 'DC')) {
            scope.showChkedOnDcLogin = true;
        }
        if (scope.user.eR_Id) {
            providerId = scope.user.eR_Id;
            scope.providerName = '';
        }
        if (scope.user == 'DC') {
            isInsurer = filterFilter(scope.user.rolesFeatures.roles, { 'roleId': scope.Role }, function (actual, expected) {
                return filterFilter(expected, actual)
            })
            getid = JSON.parse(localStorage.children).filter(function (n) {
                return n.erTypeId == 5290;
            });
            if (scope.selectedEntity && scope.selectedEntity.id)
                providerId = scope.selectedEntity.id;
        }
        if (!scope.daysOfAppointment || scope.daysOfAppointment == '' || scope.daysOfAppointment <= -1) {
            scope.daysOfAppointment = -1;
        }
        status = scope.dataStatusSearch == undefined ? '' : scope.dataStatusSearch;
        if (scope.dataStatusSearch == undefined)
            scope.dataStatusSearch = '';
        $rootScope.$broadcast('newCountChange', 10);
        var data = {
            providerId: providerId,
            requestType: '',
            daysOfAppointment: scope.daysOfAppointment,
            pageNo: 0,
            rows: 25,
            statusId: statusId,
            contractId: '',
            fromDateOfAppointment: scope.serverSearch.fromDate,
            toDateOfAppointment: scope.serverSearch.toDate,
            loadFullDetails: false,
            hashtagFilters: {},
            requestAccessToken: UserService.getAccessToken(),
            searchType: 0,
            userAgent: 'String',
            ipAddress: 'String',
            fetchByDate: scope.serverSearch.dateWiseSearch
        };
        UtilitiesService.stopLoading('appointmentsData');
        UtilitiesService.startLoading('fetching appointments data...', 'appointmentsData');
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/Appointments/', data, 'POST', UserService.getAccessToken()).then(function (response) {
            UtilitiesService.stopLoading('appointmentsData');
            if (response.data.isSuccess) {
                scope.isOpenAccordian = true;;
                scope.activeAppointments = response.data;
                UserService.activeAppointmentsDummyData = response.data;
                scope.totalRows = response.data.totalRows;
                scope.isTotalRows = response.data.requests.length > 20 ? true : false;
                UserService.activeAppointmentsDummyDataCollection = statusTransform(response.data.requests);
                scope.activeStatuses = response.data.appointmentStatusMaster;
                scope.activeStatusesData = [];
                scope.activeStatusesData.push({ id: '0', name: 'All Status' });
                if (scope.user.properties && scope.user.properties.statusId) {
                    var statusIds = []
                    statusIds = scope.user.properties.statusId.split(',');
                }
                angular.forEach(scope.activeStatuses, function (data, key) {
                    if (!statusIds || filterFilter(statusIds, key, true).length > 0) {
                        var result = {
                            id: key,
                            name: data
                        }
                        scope.activeStatusesData.push(result);
                    }
                });
                scope.activeStatusesData = orderByFilter(scope.activeStatusesData, 'name', false);
            }
        });
    };

    scope.loadAppointments();

    //Clear Search data
    scope.clearSearch = function () {
        scope.serverSearch.fromDate = '';
        scope.serverSearch.toDate = '';
        scope.serverSearch.contractType = { id: '0', entityName: 'All Appointment Type' };
        scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };
        scope.serverSearch.statusSearch = { id: '0', name: 'All Status' };
        scope.serverSearch.dateWiseSearch = 'apptdate';
        scope.isCorporate = false;
        scope.contractsData = [];
        scope.contractsData.push({ id: '0', entityName: 'All Corporate' });
        scope.loadAppointments();
        scope.status.isFirstOpen = false;
    };

    //Get corporate Packages data
    scope.getCorporatePackages = function (CorporateSelected) {
        if (CorporateSelected && CorporateSelected !== '0') {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/EntityRelationcache/Search/' + CorporateSelected, {}, 'GET').then(function (response) {
                scope.contractsData = [];
                scope.isCorporate = response.data.length > 0 ? true : false
                if (response.data.length > 0) {
                    scope.contractsData = response.data;
                    scope.contractsData.push({ id: '0', entityName: 'All Corporate' });
                    scope.contractsData = orderByFilter(scope.contractsData, 'entityName', false);
                    scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };

                }
            })
        } else {
            scope.isCorporate = false;
        }
    };

    //Reset reasons text or comment text
    scope.resetDependencies = function (reasonForCancel) {
        if (reasonForCancel) {
            scope.action.cancelComments = reasonForCancel == 'Other' ? '' : reasonForCancel != 'Other' ? '' : reasonForCancel == 'reset' ? '' : scope.action.cancelComments;
            scope.cancelReason = reasonForCancel == 'reset' ? '' : scope.cancelReason;
        }
    };

    //Search Appointment search by 
    scope.searchAppointment = function (searchValue) {
        var providerId = null;//provider id will be changed when dc is selected, In this case we have not provided anything like that.
        scope.searchSource = searchValue.value;
        scope.selectedOrderType = searchValue.selectedOrderType;
        if (scope.selectedOrderType) {
            if (scope.selectedOrderType == 'reqId') {
                scope.hashtagFilters = { requestid: scope.searchSource }
            } if (scope.selectedOrderType == 'email') {
                scope.hashtagFilters = { emailid: scope.searchSource }
            } if (scope.selectedOrderType == 'empId') {
                scope.hashtagFilters = { empid: scope.searchSource }
            } if (scope.selectedOrderType == 'contact') {
                scope.hashtagFilters = { contactno: scope.searchSource }
            } if (scope.selectedOrderType == 'name') {
                scope.hashtagFilters = { name: scope.searchSource }
            } if (scope.selectedOrderType == 'partnerOrderId') {
                scope.hashtagFilters = { partnerorderid: scope.searchSource }
            } if (scope.selectedOrderType == 'MAID') {
                scope.hashtagFilters = { MAID: scope.searchSource }
            }
        }
        var ajaxData = {
            requestType: '',
            daysOfAppointment: scope.daysOfAppointment,
            ProviderId: providerId,
            hashtagFilters: scope.hashtagFilters,
            requestAccessToken: UserService.getAccessToken(),
            userAgent: 'String',
            ipAddress: 'String',
            pageNo: 0,
            rows: 25,
            statusId: '',
            contractId: '',
            searchType: 1,
            fetchByDate: scope.serverSearch.dateWiseSearch
        }
        UtilitiesService.stopLoading('appointmentsData');
        UtilitiesService.startLoading('fetching appointments data...', 'appointmentsData');
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/Appointments/', ajaxData, 'POST', UserService.getAccessToken()).then(function (response) {
            UtilitiesService.stopLoading('appointmentsData');
            if (response.data) {
                scope.loading = false;
                scope.activeAppointments = response.data;
                scope.totalRows = response.data.totalRows;
                scope.isTotalRows = response.data.requests.length > 20 ? true : false;
                UserService.activeAppointmentsDummyData = response.data;
                UserService.activeAppointmentsDummyDataCollection = statusTransform(response.data.requests);
            } else {
                UtilitiesService.showAlertMessage('No Record Found.');
            }
        })
    };

    //Search by
    $rootScope.$on('searchBy', function (key, value) {
        scope.searchAppointment(value);
        scope.status.isFirstOpen = false;
    });

    scope.searchAppointmentsGroup = function (getStatus, getContract, corporateId, frmDt, toDt, rowNo) {
        scope.status.isFirstOpen = false;
        if (frmDt && !toDt) {
            //alert("You have missed end date!");
            UtilitiesService.showAlertMessage('You have missed end date!');
            return false;
        }
        scope.hashtagFilters = {};
        if (corporateId) {
            if (corporateId.id !== '0') {
                scope.serverSearch.corporateId = corporateId;
                scope.hashtagFilters = {
                    corporateid: corporateId.id
                }
            }
        }
        scope.rowNoFromDdl = rowNo ? rowNo : 0
        scope.serverSearch.fromDate = frmDt ? frmDt : '';
        scope.serverSearch.toDate = toDt ? toDt : '';
        var providerId = null;
        var ajaxData = {
            providerId: providerId,
            requestType: '',
            daysOfAppointment: scope.daysOfAppointment,
            pageNo: rowNo,
            rows: 25,
            statusId: getStatus.id === '0' ? 0 : getStatus.id,
            contractId: getContract.id !== '0' ? getContract.id : '',
            fromDateOfAppointment: scope.serverSearch.fromDate,
            toDateOfAppointment: scope.serverSearch.toDate,
            loadFullDetails: false,
            hashtagFilters: scope.hashtagFilters,
            requestAccessToken: UserService.getAccessToken(),
            userAgent: 'String',
            searchType: 1,
            ipAddress: 'String',
            fetchByDate: scope.serverSearch.dateWiseSearch,
            isCountRequired: !rowNo
        }
        UtilitiesService.startLoading('Searching...', 'searchAppointmentsData');
        UtilitiesService.stopLoading('appointmentsData');
        UtilitiesService.startLoading('fetching appointments data...', 'appointmentsData');
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/Appointments/', ajaxData, 'POST', UserService.getAccessToken()).then(function (response) {
            UtilitiesService.stopLoading('searchAppointmentsData');
            UtilitiesService.stopLoading('appointmentsData');
            if (response.data) {
                scope.loading = false;
                if(ajaxData.pageNo != 0 ) response.data.totalRows= scope.totalRows;
                scope.activeAppointments = response.data;
                UserService.activeAppointmentsDummyData = response.data;
                UserService.activeAppointmentsDummyDataCollection = statusTransform(response.data.requests);
                scope.totalRows = response.data.totalRows;
                scope.isTotalRows = response.data.requests.length > 20 ? true : false;
                var distPage = Math.ceil(scope.totalRows / 25);
                scope.noOfPageDdl = [];
                for (var i = 25; i <= scope.totalRows; i = i + 25) {
                    var j = i;
                    scope.noOfPageDdl.push(j);
                }
                var diff = scope.totalRows - j;
                if (diff < 0) {
                    scope.noOfPageDdl.push(scope.noOfPageDdl[scope.noOfPageDdl.length - 1] + Math.abs(diff));
                } else {
                    if (!isNaN(diff)) {
                        scope.noOfPageDdl.push(scope.noOfPageDdl[scope.noOfPageDdl.length - 1] + diff);
                    }
                }
            }
            else {
                UtilitiesService.showAlertMessage('No Record Found.');
            }
        })
    };

    scope.searchAppointmentsGroupCtrl = function (currentRecordPerPage) {
        scope.searchAppointmentsGroup(scope.serverSearch.statusSearch, scope.serverSearch.contractType, scope.serverSearch.corporateId, scope.serverSearch.fromDate, scope.serverSearch.toDate, currentRecordPerPage);
    };

    scope.filterPage = function (rowNo) {
        scope.rowNo = parseInt(rowNo.count);
        $rootScope.$broadcast('newCount', rowNo.count);
    };

    scope.reloadAppointments = function () {
        scope.dispayInDdl = 'Search by';
        scope.searchSource = '';
        scope.selectedOrderType = '';
        scope.today();
        scope.serverSearch.contractType = { id: '0', entityName: 'All Appointment Type' };
        scope.serverSearch.statusSearch = { id: '22', name: 'New Appointment Request' };
        scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };
        scope.totalRows = 0;
        scope.noOfPageDdl = [];
        scope.loadAppointments();
    };
    scope.reCreateTestData = function () {
        scope.testData.testStateId = '';
        scope.testData.testSubLocalityId = '';
        scope.testData.testCityId = '';
        scope.testData.testLocalityId = '';
        scope.testData.dcValue = ''; 
    }
    scope.medicalTestMethods = (function () {
        scope.relatedTests = [];
        scope.tempBucket = [];
        scope.groups = [[]];
        return {
            splitRequests: function (getGrps) {
                var dataObj = [];
                var restObj = [];
                scope.reCreateTestData();
                angular.forEach(scope.relatedTests, function (ind, val) {
                    var obj = [];
                    ind.providerId = scope.originalDcDetails.providerId;
                    ind.providerName = scope.originalDcDetails.providerName;
                    ind.appointmentDate = scope.originalDcDetails.appointmentDate;
                    ind.visitType = scope.originalDcDetails.providerVisitType;
                    scope.groups[0].push(ind)
                })
                angular.forEach(scope.groups, function (buckets, i) {
                    angular.forEach(buckets, function (test, ib) {
                        var obj = {};
                        if (i == 0) {
                            obj = {
                                productId: test.id,
                                providerId: test.providerId,
                                providerName: test.providerName,
                                appointmentDate: test.appointmentDate,
                                visitType: test.visitType,
                                groupId: 0
                            }
                        }
                        else {
                            obj = {
                                productId: test.id,
                                providerId: parseInt($("#dcid_" + i).val()),
                                providerName: $("#dcid_" + i + " option:selected").text(),
                                appointmentDate: $("#datetime_" + i).val(),
                                visitType: $("#visittype_" + i + " option:selected").text(),
                                groupId: i
                            }
                        }
                        dataObj.push(obj)
                    })
                })
                var data = {
                    requestId: $rootScope.requestIdForActiveAppointmnents,
                    details: dataObj
                }
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/SplitRequest/', data, 'POST', UserService.getAccessToken()).then(function (response) {
                    if(response.data.isSuccess === true) {
                        scope.relatedTests = [];
                        scope.tempBucket = [];
                        scope.groups = [[]];
                        scope.originalDcDetails = {};
                        UtilitiesService.showAlertMessage("Request splited successfully", true)
                    } 
                    else {
                        UtilitiesService.showAlertMessage(response.data.errorMessage, false); }
                });
            },
            addTestToPermanentBucket: function () {
                scope.disableTempCreate = false;
                scope.desableLocation = true;
                $(scope.tempBucket).each(function (i, v) {
                    v.groupId = scope.groups.length;
                })
                scope.groups.push(scope.tempBucket);
                scope.tempBucket = [];
            },
            removeFromGroups: function (removeItem) {
                removeItem.checkTest = false;
                $.each(scope.groups, function (i, val) {
                    if (val.indexOf(removeItem) != -1) {
                        scope.relatedTests.push(removeItem);
                        val.splice(val.indexOf(removeItem), 1);
                        return true;
                    }
                })
            },
            addTestToTempBucket: function (checkedItem) {
                checkedItem.checkTest = true;
                scope.tempBucket.push(checkedItem);
                scope.relatedTests.splice(scope.relatedTests.indexOf(checkedItem), 1)
            },
            removeBucketFromGroup: function (index) {

                $(scope.groups[index]).each(function (i, v) {
                    v.groupId = 0;
                    v.checkTest = false;
                    scope.relatedTests.push(v);
                });
                scope.groups.splice(index, 1)
            },
            getTestsForPackage: function (productId, reqtId, providerId, providerName, appointmentDate, visitType) {
                var allProductIds = [];
                scope.action.productId = productId;
                scope.originalDcDetails.providerId = providerId;
                scope.originalDcDetails.providerName = providerName;
                scope.originalDcDetails.appointmentDate = appointmentDate;
                scope.originalDcDetails.visitType = visitType;
                scope.groups = [[]];
                scope.testData.testStateId = "";
                scope.cities = {};
                scope.locations = {};
                scope.sublocations = {};
                scope.allDCs = {};
                if(typeof(productId) === 'object') {
                    angular.forEach(productId,function(key,value) {
                    allProductIds.push(parseInt(value));                    
                });
                var data = {'packageIDs': allProductIds};                
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelationWithIds/', data, 'POST', UserService.getAccessToken()).then(function (response) {
                    if (response.data) {
                        if(response.data.length > 0) {
                        var temp = []
                        scope.requestId = reqtId;
                        scope.relatedTests = [];
                        scope.testsObj = {};                        
                        if (scope.tempBucket.length > 0) {
                            scope.tempBucket = [];
                        }
                        response.data.map(function(item) {
                            temp.push(item.allowedInvestigations);
                        })
                        temp.map(function(v) {
                            v.map(function(value){
                                scope.relatedTests.push(value);
                                scope.testsObj[value.id] = value;                                
                            })
                        })
                     } else {
                         UtilitiesService.showAlertMessage("No matching test can be found",false);
                     }
                    }
                });               
            } else {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/' + productId, '', 'Get', UserService.getAccessToken()).then(function (response) {
                    if (response.data) {
                        scope.requestId = reqtId;
                        scope.relatedTests = [];
                        scope.testsObj = {};                        
                        if (scope.tempBucket.length > 0) {
                            scope.tempBucket = [];
                        }
                        scope.relatedTests = response.data.allowedInvestigations;
                        scope.relatedTests.map(function(v) {
                            scope.testsObj[v.id] = v;                            
                        })
                    }
                });
            }
            },
            removeFromBucket: function (checkedItem) {
                checkedItem.checkTest = false;
                scope.relatedTests.push(checkedItem);
                scope.tempBucket.splice(scope.tempBucket.indexOf(checkedItem), 1)
            }
        };
    })();

    scope.actionRequest = function (actionType, event) {
        if ((scope.requestData.productType === 10307 || scope.requestData.productType === 10390) && scope.requestData.providerId === 177324) {
            scope.createRequestForPharma(actionType, scope.action.nextStatusId, scope.action.requestId, scope.action.statusId, scope.requestData);
        } else if (scope.requestData && scope.requestData.additionalInformation) {
            if ((scope.requestData.additionalInformation.productType === 10307 || scope.requestData.additionalInformation.productType === 10390) && scope.requestData.additionalInformation.providerId === 177324) {
                scope.createRequestForPharma(actionType, scope.action.nextStatusId, scope.action.requestId, scope.action.statusId, scope.requestData.additionalInformation);
            } else {
                scope.createRequest('Appointment', scope.action.statusId, scope.action.nextStatusId, scope.action.requestId, actionType, scope.action.spocname, scope.action.spocphone, event);
            }
        } else {
            scope.createRequest('Appointment', scope.action.statusId, scope.action.nextStatusId, scope.action.requestId, actionType, scope.action.spocname, scope.action.spocphone, event);
        }
        scope.action.remarks = null;
    };

    scope.createRequestForPharma = function (actionType, nextStatusId, requestId, statusId, requestData) {
        var invoiceDetails = null;
        var remark = actionType;
        switch (actionType) {
            case 'Delivered':
                invoiceDetails = [];
                if (scope.pharmaData.cashlessAmt && scope.pharmaData.cashlessAmt >= 0 && scope.pharmaData.CODAmt && scope.pharmaData.CODAmt >= 0) {
                    var cashlessAmt = {
                        order_value: scope.pharmaData.cashlessAmt,
                        discounted_value: scope.pharmaData.cashlessAmt,
                        invoice_number: '',
                        payment_mode: 0
                    }
                    var CODAmt = {
                        order_value: scope.pharmaData.CODAmt,
                        discounted_value: scope.pharmaData.CODAmt,
                        invoice_number: '',
                        payment_mode: 1
                    }
                    invoiceDetails.push(CODAmt);
                    invoiceDetails.push(cashlessAmt);
                } else {
                    if (scope.pharmaData.cashlessAmt && scope.pharmaData.cashlessAmt >= 0) {
                        var cashlessAmt = {
                            order_value: scope.pharmaData.cashlessAmt,
                            discounted_value: scope.pharmaData.cashlessAmt,
                            invoice_number: '',
                            payment_mode: 0
                        }
                        invoiceDetails.push(cashlessAmt);
                    } else if (scope.pharmaData.CODAmt && scope.pharmaData.CODAmt >= 0) {
                        var CODAmt = {
                            order_value: scope.pharmaData.CODAmt,
                            discounted_value: scope.pharmaData.CODAmt,
                            invoice_number: '',
                            payment_mode: 1
                        }
                        invoiceDetails.push(CODAmt);
                    }
                }
                break;
            case 'OutForDelivery':
                invoiceDetails = null;
                break;
            case 'Cancel':
                invoiceDetails = null;
                remark = scope.action.cancelReason == 'Other' ? scope.action.cancelComments : scope.action.cancelReason;
                break;
            case 'ConfirmByRetailer':
                invoiceDetails = null
                break;
            default:
                invoiceDetails = null
                break;
        }
        var data = {
            key: requestData.providerId,
            response: {
                requestID: requestId,
                status: nextStatusId,
                remarks: remark,
                invoiceDetails: invoiceDetails,
                requestAccessToken: UserService.getAccessToken()
            }
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/ProviderOrderUpdate', data,'POST').then(function (response) {
            $("#" + actionType + "Modal").modal('hide');
            scope.loadAppointments();
            scope.action = {};
        });
    }
    scope.changeDc = function (value) {
        scope.selectedDcs = filterFilter(scope.diagnosticCentres, value);
    };

    //Set user secondary pref date and time
    scope.useSecondPref = function () {
        scope.form.dod = UtilitiesService.getDateObj(scope.action.secondPreferredTime);
        scope.client.prefDate = scope.form.dod;
        scope.client.prefTime = scope.form.dod;
    };

    scope.changeBloodGrp = function (value) {
        scope.selectedBloodGrp = value;
    };
    scope.action.showdcselection = false;
    scope.showDcSelection = function (value, source) {
        scope.action.showdcselection = !!value;

        scope.testData.testStateId = '';
        scope.cities = [];
        scope.testData.testCityId = '';

        scope.locations = [];
        scope.testData.testLocalityId = '';

        scope.sublocations = [];
        scope.testData.testSubLocalityId = '';

        scope.diagnosticCentres = [];
        scope.testData.dcValue = '';

        if (source === 'dcVisit') {
            scope.action.showHomeVisitSelection = false;
            scope.homeVisit = [];
            if (scope.action.showdcselection === false) {
                scope.testData.testStateId = '';
                scope.testData.testCityId = '';
                scope.testData.testLocalityId = '';
                scope.testData.testSubLocalityId = '';
                scope.testData.dcValue = '';
                scope.selectedDcs = [];
            }
        }
        if (source === 'homeVisit') {
            scope.action.showdcselection = false;
            scope.testData.testStateId = '';
        }
    };

    scope.uploadedFileData = { 
        reports: {},
        bills:{} 
    };

    scope.storeFiles =[];
    scope.storedBill =[];

    scope.downloadAttachment = function (obj) {
        if (obj) {
            window.open(
              UtilitiesService.getDownloadURL(true) + obj,
              '_blank'
            );
        }
    };

    scope.removeBillFiles = function(item){
        if(item){
            delete scope.uploadedFileData.bills[item.filePath];
            angular.forEach(scope.storedBill, function(value, index){
                 if(value.fileName === item.fileName){
                    scope.storedBill.splice(value, 1);
                }
            });
        }
    };

    scope.removeFiles = function(item){
        if(item){
            delete scope.uploadedFileData.reports[item.filePath];
            angular.forEach(scope.storeFiles, function(value, index){
                 if(value.fileName === item.fileName){
                    scope.storeFiles.splice(value, 1);
                }
            });
        }
    };

    scope.fileFn = function(data, type){
        if (data) {
            if(type === 'report'){
                for (var key in data){
                    scope.uploadedFileData.reports[key] = data[key];
                }
                angular.forEach(data, function(value, index){
                    scope.storeFiles.push({ fileName: value, filePath: index});
                });
            }else if(type === 'bill'){
                for (var key in data){
                    scope.uploadedFileData.bills[key] = data[key];
                }
                angular.forEach(data, function(value, index){
                    scope.storedBill.push({ fileName: value, filePath: index});
                });
            }
        }
    };

    //Next possible action for request call
    scope.createRequest = function (requestType, statusId, nextStatusId, requestId, actionType, spocname, spocphone, event) {
        var patientname = scope.selectedPatientName;
        var id = requestId; //scope.selectedRequestId;
        var appDate = scope.action.date;
        scope.client.prefDate = UtilitiesService.mergeDateTimeObj(scope.client.prefDate, scope.client.prefTime);
        var providerId = null;
        var providerName = "";
        var remarksComment = scope.action.remarks;
        scope.action.remarks = "";
        var additionalParams = {};
        switch (actionType) {
            case 'Reschedule':
                appDate = scope.client.prefDate;
                if (scope.selectedDcs.length > 0 && !(scope.user.entitytype == 'dc')) {
                    providerId = _.first(scope.selectedDcs).id;
                    providerName = _.first(scope.selectedDcs).entityName;
                }
                break;
            case 'Cancel':
                appDate = scope.action.date;
                remarksComment = scope.action.cancelReason == 'Other' ? scope.action.cancelComments : scope.action.cancelReason;
                break;
            case 'QCApprove':
                additionalParams.doctorQualification = scope.doctorQualificatio ? scope.doctorQualificatio : '';
                additionalParams.isPhotographAvailable = scope.isPhotoAvailble.value;
                additionalParams.ActualApptDate = scope.popupQc.actualDate;
                break;
            case 'Confirm':
                additionalParams.Price = scope.action.dcPrice;
                additionalParams.sampleCollectionBy = JSON.stringify(scope.action.homeVisitType);
                break;
            case 'Fit':
                additionalParams.bloodGroup = scope.bloodGrp.selectedBloodGrp;
                break;
            case 'UnFit':
                additionalParams.bloodGroup = scope.bloodGrp.selectedBloodGrp;
                break;
            case 'Delivered':
                break;
            case 'OutForDelivery':
                break;
            case 'ConfirmByRetailer':
                break;
            case 'InsurerAction':
            // var remarksComment = scope.action.remarks;
                break;
            case 'UTC':
                // var remarksComment = scope.action.remarks;
                scope.attachFiles = scope.uploadedFileData;
                break;
            case 'UTCAwaited':
                // var remarksComment = scope.action.remarks;
                scope.attachFiles = [];
                break;
            case 'Submit':
                // var remarksComment = scope.action.remarks;
                scope.attachFiles = scope.uploadedFileData;
                break;
            default:
                appDate = scope.action.date;
                break;
        }
        scope.selectedDcs = [];
        var requestData = {
            request: {
                requestId: requestId,
                currentStatusId: statusId,
                remarks: remarksComment,
                ScheduledAppointmentDate: appDate,
                requestedNextActionId: nextStatusId,
                attachFiles: scope.attachFiles,
                providerId: providerId,
                providerName: providerName,
                spocName: spocname,
                spocContactNo: spocphone,
                additionalParameters: additionalParams,
                addressLine1: scope.homeVisit.addressLineOne ? scope.homeVisit.addressLineOne : '',
                addressLine2: scope.homeVisit.addressLinTwo ? scope.homeVisit.addressLinTwo : '',
                userFeedback: scope.action.feedback ? scope.action.feedback : ''                
                //isHomeVisit: scope.action.showHomeVisitSelection === true ? true : (scope.visitTypeDcHome === 'Appointment' ? false : (scope.visitTypeDcHome === 'Home_Visit' ? true : false))
            },
            requestAccessToken: UserService.getAccessToken()
        }
        if (scope.action.showHomeVisitSelection === true) {
            requestData.request.isHomeVisit = true;
            scope.visitTypeDcHome = '';
        }
        else if (scope.action.showHomeVisitSelection === false) {
            requestData.request.isHomeVisit = false
            scope.visitTypeDcHome = '';
        }
        else if (scope.visitTypeDcHome === 'Appointment') {
            requestData.request.isHomeVisit = false
        }
        else if (scope.visitTypeDcHome === 'Home_Visit') {
            requestData.request.isHomeVisit = true
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/request', requestData, "post").then(function (response) {
            var targetModal = event.target.parentNode;
            scope.popupQc.actualDate = '';
            scope.resetTime();
            scope.testData.testStateId = '';
            scope.testData.testCityId = '';
            scope.testData.testLocalityId = '';
            scope.testData.testSubLocalityId = '';
            scope.dcValue = '';
            scope.selectedDcs = [];
            scope.selectedBloodGrp = '';
            scope.newlyUploadedReports = [];
            scope.newlyUploadedBills = [];
            scope.storeFiles =[];
            scope.storedBill =[];
            scope.uploadedFileData.reports = {};
            scope.uploadedFileData.bills = {};
            scope.today();
            while (!targetModal.classList.contains('modal')) {
                targetModal = targetModal.parentNode;
            }
            $('#' + actionType + 'Modal').modal('hide');
            scope.loadAppointments();
            if (scope.attachFiles) {
                if (scope.attachFiles.reports) {
                    scope.attachFiles.reports = {};
                }
                if (scope.attachFiles.bills) {
                    scope.attachFiles.bills = {};
                }
            }
            scope.action = {};
        });
    }

    scope.updateRemarks = function (actualDate) {
        scope.action.remarks = "Actual attended date is :" + actualDate;
    };
    scope.dynamicPopover = {
        content: 'Hello, World!',
        templateUrl: 'myPopoverTemplate.html',
        title: 'Title'
    };
    scope.loadFilteredDc = function () {
        var url = UtilitiesService.getPlusUrlPrefix() + "CorporatePackageProvider/" + scope.action.productId + "/false.json";
        UserService.makeRestCall(url, "", "get").then(function (response) {
            if (response.data.length > 0) {
                scope.filteredDc = response.data;
                var arr = [];
                scope.diagnosticCentres = [];
                $(scope.tempDiagnosticCentres).each(function (i, v) {
                    if (scope.filteredDc.indexOf(v.id) !== -1) {
                        arr.push(v);
                    }
                });
                scope.diagnosticCentres = arr;
            }
        });
    };

    //Get location
    scope.locationMethods = (function () {
        return {
            loadStates: function () {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + '/masterdata/lookup/state.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.states = response.data.lookUpData;
                    }
                });
            },
            loadCities: function (stateId) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/masterdata/lookup/district/' + stateId + '.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.cities = response.data.lookUpData;
                    }
                });
            },
            loadLocations: function (cityId) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/masterdata/lookup/city/" + cityId + '.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.locations = response.data.lookUpData;
                    }
                });
            },
            loadSubLocations: function (locationId) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/masterdata/lookup/location/' + locationId + '.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.sublocations = response.data.lookUpData;
                    }
                });
            },
            loadDCForTests: function (id, obj) {
                scope.testData.testSubLocalityId = id;
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'EntityRelation/Search/EntitySearch/' + scope.ERTypeId + '/' + scope.serviceBrokerId + '/' + 0 + '/' + scope.testData.testStateId + '/' + scope.testData.testCityId + '/' + scope.testData.testLocalityId + '/' + scope.testData.testSubLocalityId + '.json', '', 'get').then(function (response) {
                    if (response.statusText == 'OK') {
                        scope.allDCs = response.data;
                        scope.tempDiagnosticCentres = response.data;
                        scope.loadFilteredDc();
                    }
                });
            }
        }
    })();

    //Load Location based ontype
    scope.loadLocationData = function (type, id) {
        switch (type) {
            case 'city':
                scope.locationMethods.loadCities(id);
                break;
            case 'locality':
                scope.locationMethods.loadLocations(id);
                break;
            case 'sublocality':
                scope.locationMethods.loadSubLocations(id);
                break;
            case 'dc':
                scope.locationMethods.loadDCForTests(id);
                break;
            default:
                scope.locationMethods.loadCities(id);
                break;
        }
    };

    //Reset time
    scope.resetTime = function () {
        scope.maxFirst = '';
        scope.minFirst = '';
        scope.client.prefTime = '';
        var maxFirst = new Date();
        maxFirst.setHours(18);
        maxFirst.setMinutes(0);
        scope.maxFirst = maxFirst;
        var minFirst = new Date();
        minFirst.setHours(8);
        minFirst.setMinutes(0);
        scope.minFirst = minFirst;
        scope.client.prefTime = minFirst;
    };
    scope.pharmaData = {
        cashlessAmt: '',
        CODAmt: ''
    }
    //Open Action popup
    scope.openRespectiveActionModal = function (actionName, currentStatusId, actionStatusId, requestId, appointmentDate, secondAppointmentDate, orderItemProductId, requestData) {
        $timeout(function(){
            var modalName = '#' + actionName + 'Modal';
            $(modalName).modal('show');
        })
        
        scope.requestData = requestData;
        scope.homeVisitCheck = false;
        scope.visitTypeDcHome = requestData ? (requestData.additionalInformation ?
            (requestData.additionalInformation.visitType ? requestData.additionalInformation.visitType : ''
            ) : (requestData.visitType ? requestData.visitType : '')) : '';
        scope.action.partnerOrderId = '';
        scope.pharmaData.cashlessAmt = '';
        scope.pharmaData.CODAmt = '';
        scope.resetTime();
        scope.showDcSelection();
        scope.actionId = actionStatusId;
        scope.client.prefDate = UtilitiesService.getDateObj(appointmentDate);
        if(actionStatusId === 121){
            $('#UTC').modal('show');
            scope.tuModel = 'Completed';
        }else if(actionStatusId === 122){
            $('#UTC').modal('show');
            scope.tuModel = 'Scheduled';
        }else if(actionStatusId === 123){
            $('#UTCAwaited').modal('show');
            scope.tuModel = 'Awaited';
        }else if(actionStatusId !== 122 || actionStatusId !== 122){
            scope.actionName = actionName;
        }
        scope.storeFiles =[];
        scope.storedBill =[];
        scope.uploadedFileData.reports = {};
        scope.uploadedFileData.bills = {};
        scope.action.showdcselection = false;
        scope.action.remarks = '';
        scope.action.statusId = currentStatusId;
        scope.action.nextStatusId = actionStatusId;
        scope.action.requestId = requestId;
        scope.action.date = appointmentDate;
        scope.action.visibleDate = scope.compareDate(appointmentDate);
        scope.action.visibleTime = scope.action.visibleDate + " " + scope.formatTime(appointmentDate);
        scope.action.secondPreferredTime = secondAppointmentDate;
        scope.secondPreferredVTime = scope.compareDate(secondAppointmentDate) + " " + scope.formatTime(secondAppointmentDate);
        scope.action.productId = orderItemProductId;
        //empty all modals

        if (scope.actionName == 'Fit' || scope.actionName == 'UnFit') {
            if (scope.action.remarks) {
                scope.action.remarks.fit = '';
                scope.selectedBloodGrp = '';
            }
        }
        if (scope.actionName == 'Reschedule') {
            scope.locationMethods.loadStates();
            scope.form.dod = '';
            scope.action.showdcselection = false;
            scope.testData.testStateId = '';
            scope.testData.testCityId = '';
            scope.testData.testLocalityId = '';
        }
        if (scope.actionName == 'Confirm') {
            if(scope.visitTypeDcHome == 'Home_Visit') {
                scope.homeVisitTypeArray = [
                    {id: 'HOME_VISIT_BY_DOCTOR', name: 'DOCTOR'},
                    {id: 'HOME_VISIT_BY_LAB_TECHNICIAN', name: 'LAB TECHNICIAN'},
                    {id: 'HOME_VISIT_BY_ECG_TECHNICIAN', name: 'ECG TECHNICIAN'},
                    {id: 'HOME_VISIT_BY_MBBS_DOCTOR', name: 'MBBS DOCTOR'},
                    {id: 'HOME_VISIT_BY_MD_DOCTOR', name: 'MD DOCTOR'},
                  ];
                scope.homeVisitCheck = true;
            }

            scope.action.spocname = '';
            scope.action.spocphone = '';
            scope.action.dcPrice = '';
        }
        if (scope.actionName == 'Cancel') {
            scope.action.visibleTime = scope.action.visibleDate + ' ' + scope.compareDate(scope.action.date);
        }
        if (scope.actionName == 'Approve' || scope.actionName == 'NotAttended' || scope.actionName == 'Raise_IA') {
            scope.action.remarks = "";
        }
        if (scope.actionName == 'Attended') {
            scope.actualdate = '';
            scope.action.remarks = '';
            scope.action.feedback = '';
        }
        if (scope.actionName == 'Submit') {
            scope.reports = [];
            scope.bills = [];
            scope.attachFiles.reports = {};
            scope.attachFiles.bills = {};
            scope.storeFiles =[];
            scope.storedBill =[];
            scope.uploadedFileData.reports = {};
            scope.uploadedFileData.bills = {};
            scope.action.remarks = '';
        }
        if (scope.actionName == 'PlaceWithPartner') {
            scope.partnerOrderId = '';
        }
        if (scope.actionName == 'Delivered') {
            scope.pharmaData.cashlessAmt = '';
            scope.pharmaData.CODAmt = '';
        }
    }
    scope.toggleHomeVisitType = function(checkedItem) {
        var check = scope.action.homeVisitType.indexOf(checkedItem.id);
        check >= 0 ? scope.action.homeVisitType.splice(check,1) : scope.action.homeVisitType.push(checkedItem.id);
    }
    scope.getPackageTestDetails = function (productId, noProductId) {
        if (noProductId) {
            scope.investigationList = [];
            return;
        } else {
            var pId = productId ? productId : '';
            scope.investigationList = [];
            if (pId) {
                var url = UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/' + pId;
                UserService.makeRestCall(url, '', 'GET', UserService.getAccessToken()).then(function (response) {
                    if (response.data) {
                        var investigation = response.data.allowedInvestigations;
                        var investigationGroup = [];
                        angular.forEach(investigation, function (v, i) {
                            investigationGroup.push(v.groupName);
                        })
                        var listOfUniqeInvestigations = investigationGroup.filter(function (val, index, allArr) {
                            return index == allArr.indexOf(val);
                        })
                        angular.forEach(listOfUniqeInvestigations, function (val, ind) {
                            var investigationWiseTests = filterFilter(investigation, val);
                            var testObj = investigationWiseTests;
                            scope.testDetails = [];
                            angular.forEach(testObj, function (v, i) {
                                scope.testDetails.push({
                                    groupName: v.groupName,
                                    testName: v.name,
                                    testId: v.id,
                                    groupId: v.groupId,
                                    isActive: v.isActive,
                                    duplicateCheck: v.duplicateCheck,
                                    quantity: v.quantity
                                })
                            })
                            scope.investigationList.push({
                                investigationName: val,
                                testDetails: scope.testDetails
                            })
                        })
                        // console.log(scope.investigationList);
                    } else {
                        UtilitiesService.showAlertMessage('No Investigations found.');
                    }
                })
            } else {
                UtilitiesService.showAlertMessage('Product Id is unavailable.');
            }
        }
    }

    scope.placeWithPartner = function () {
        var data = {
            RequestId: scope.action.requestId,
            PartnerOrderId: scope.action.partnerOrderId
        };
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/requestPharmaOrder', data, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data == true) {
                UtilitiesService.showAlertMessage('Order has been placed Successfully.', true);
                $('#PlaceWithPartnerModal').modal('hide');
            }
            if (response.data == false) {
                UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to place order.');
                $('#PlaceWithPartnerModal').modal('hide');
            }
        })
    };

    //display wallet balance
    scope.showWalletBalance = function (balance, isSuccess) {
        scope.isSuccess = isSuccess;
        scope.showWalletBalanceMsz = isSuccess === true ? 'Rs. ' + balance + '/-' : balance;
        var modalInstance = $uibModal.open({
            animation: scope.animationsEnabled,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: "walletModal.html",
            controller: 'appointmentsController',
            scope: scope,
        });
    };

    //Appointment Search
    scope.$watch('plusAppointmentsSearch', function (current, old) {
        if (current) {
            scope.activeAppointments = UserService.GetFilteredAppointment(current);
        } else {
            if (old) {
                UserService.activeAppointmentsDummyData.requests = UserService.activeAppointmentsDummyDataCollection;
                scope.activeAppointments = UserService.activeAppointmentsDummyData;
            }
        }
    });

    scope.addFileToUpload = function (source) {
        if (source == 'reports' && source) {
            var newItemNo = scope.reports.length + 1;
            scope.reports.push({
                'model': ''
            });
        }
        if (source == 'bills') {
            var newItemNo = scope.bills.length + 1;
            scope.bills.push({
                'model': ''
            });
        }
    };

    scope.removeFileToUpload = function (index, source) {
        if (source == 'reports' && source) {
            scope.reports.splice(index, 1);
        }
        if (source == 'bills') {
            scope.bills.splice(index, 1);
        }
    };

    scope.uploadMethodFile = function (source) {
        if (source) {
            scope.IsFileGrter = false;
            var fileBlobArray = [];
            var filesUploadingArray = [];
            if (source == 'reports') {
                Object.keys(scope.reports).forEach(function (ele) {
                    if (typeof (scope.reports[ele].model) == 'object') {
                        filesUploadingArray.push(scope.reports[ele].model);
                    }
                });
                angular.forEach(filesUploadingArray, function (v, i) {
                    var fileSize = v.size;
                    if (fileSize > 10485760) {
                        scope.IsFileGrter = true;
                    }
                })
            }
            if (source == 'bills') {
                Object.keys(scope.bills).forEach(function (ele) {
                    if (typeof (scope.bills[ele].model) == 'object') {
                        filesUploadingArray.push(scope.bills[ele].model);
                    }
                });
                angular.forEach(filesUploadingArray, function (v, i) {
                    var fileSize = v.size;
                    if (fileSize > 10485760) {
                        scope.IsFileGrter = true;
                    }
                })
            }
            if (filesUploadingArray.length > 0) {
                if (!scope.IsFileGrter) {
                    fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrlPrefix() + "/File.json"));
                } else {
                    alert('File size is greater then 10 MB');
                    return false;
                }
            }
            else {
                alert('Please attach atleast one document.');
            }

            if (fileBlobArray.length > 0) {
                $q.all(fileBlobArray).then(function (result) {
                    if (typeof result == "object" && typeof result[0].data == 'object') {
                        for (var property in result[0].data) {
                            if (result[0].data.hasOwnProperty(property)) {
                                var obj = {};
                                obj.fileName = result[0].data[property].split('.')[0] + new Date().getTime() + '.' + result[0].data[property].split('.')[1];
                                obj.filePath = UtilitiesService.getDownloadURL(true) + property;
                                obj.key = property;
                                if (source == 'reports') {
                                    scope.newlyUploadedReports.push(obj);
                                    angular.extend(scope.attachFiles.reports, result[0].data)
                                    // console.log(scope.attachFiles.reports);
                                    scope.reports = [];
                                }
                                if (source == 'bills') {
                                    scope.newlyUploadedBills.push(obj);
                                    angular.extend(scope.attachFiles.bills, result[0].data)
                                    // console.log(scope.attachFiles.bills);
                                    scope.bills = [];
                                }
                            }
                        }
                    }
                    else {
                        alert('upload fail');
                    }
                },
                function (error) {
                    alert('upload fail');
                });
            }
        } else {
            alert('Please attach atleast one document.');
        }
    }

    scope.removeReports = function (indx, reportBill) {
        if (reportBill === 'report') {
            scope.tempUploadedReports = scope.newlyUploadedReports;
            var removedReportKey = scope.tempUploadedReports[indx];

            scope.tempUploadedReports.splice(indx, 1);
            scope.newlyUploadedReports = scope.tempUploadedReports;

            angular.forEach(scope.attachFiles.reports, function (v, i) {
                if (removedReportKey.key === i) {
                    delete scope.attachFiles.reports[i];
                }
            })
            // console.log(scope.attachFiles.reports);
        }
        if (reportBill === 'bills') {
            scope.tempUploadedBill = scope.newlyUploadedBills;
            var removedBillKey = scope.tempUploadedBill[indx];

            scope.tempUploadedBill.splice(indx, 1);
            scope.newlyUploadedBills = scope.tempUploadedBill;

            angular.forEach(scope.attachFiles.bills, function (v, i) {
                if (removedBillKey.key === i) {
                    delete scope.attachFiles.bills[i];
                }
            })
            // console.log(scope.attachFiles.bills);
        }
    };

    scope.removePrescriptions = function (indx) {
        scope.PharmaPrescriptionList.splice(indx, 1);
    }

    scope.openVarifyPresModal = function (PharmaPrescriptionData, source) {
        scope.PharmaPrescriptionList = [];
        if (source != 'reload') {
            scope.PharmaPrescriptionData = PharmaPrescriptionData;
            PharmaPrescriptionData.map(function (val) {
                scope.PharmaPrescriptionList.push({
                    filePath: val.filePath,
                    fileName: val.fileName
                });
            });
        }
        if (source == 'reload') {
            scope.PharmaPrescriptionData.map(function (val) {
                scope.PharmaPrescriptionList.push({
                    filePath: val.filePath,
                    fileName: val.fileName
                });
            });
        }
    };

    scope.verifyPrescription = function (urls) {
        scope.UrlList = urls;
        if (scope.UrlList) {
            scope.finalUrl = [];
            angular.forEach(urls, function (v, i) {
                var setUrl = v.filePath;
                scope.finalUrl.push(setUrl);
            })
            var data = {
                "requestId": $rootScope.requestIdForActiveAppointmnents,
                "updatePrescriptionURLs": scope.finalUrl,
                "isReplace": true
            }
            var url = UtilitiesService.getPlusUrlPrefix() + "UploadPharmaCashlessPrescription/";
            UserService.makeRestCall(url, data, "POST", UserService.getAccessToken()).then(function (response) {
                if (response.data) {
                    scope.uploadedIsSuccess = response.data
                    UtilitiesService.showAlertMessage('Files updated Successfully', true);
                    $('#openVarifyPres').modal("hide");
                }
            },
            function (error) {
                UtilitiesService.showAlertMessage('issue in verify url.');
            })
        }
    };

    //closing uib bootstrap modals
    scope.closeModal = function () {
        scope.$dismiss('cancel');
    };


    scope.fileUploadMethods = (function () {
        return {
            addFileToUpload: function (flag) {
                var newItemNo = scope.file.length + 1;
                scope.file.push({
                    'model': ''
                });
            },
            removeFileToUpload: function (index) {
                scope.file.splice(index, 1);
            }
        };
    })();

    scope.addGrievance = function (fileUploadData) {
        if (fileUploadData) {
            var finalGrieveReportComment = '';
            var grievImgComments = {};
            var tempPrevGrieve = [];

            var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var currentDate = new Date();
            var currentMonth = currentDate.getMonth();

            var finalCurrentDate = (monthNames[currentDate.getMonth()]) + '-' + currentDate.getDate() + '-' + currentDate.getFullYear();

            if (scope.previousGrievancesComments) {
                tempPrevGrieve = scope.previousGrievancesComments;

                tempPrevGrieve.push({ 'grievanceReport': fileUploadData, 'grievanceComment': scope.grive.griveComment, 'grievDate': finalCurrentDate });
                finalGrieveReportComment = JSON.stringify(tempPrevGrieve);
            } else {
                grievImgComments.grievanceReport = fileUploadData;
                grievImgComments.grievanceComment = scope.grive.griveComment;
                grievImgComments.grievDate = finalCurrentDate;

                finalGrieveReportComment = JSON.stringify(grievImgComments);  //to be sent to api
            }

            var data = {
                "requestId": $rootScope.requestIdForActiveAppointmnents,
                "additionalInfo": {
                    "grievanceReportComment": finalGrieveReportComment,
                }
            }
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'UpdateRequestAdditionalInfo', data, 'POST', UserService.getAccessToken()).then(function (response) {
                if (response.data) {
                    $('#grievanceModal').modal('hide');
                    UtilitiesService.showAlertMessage('Grievance raised successfully.', true);
                }
                else {
                    UtilitiesService.showAlertMessage('oops! Error occur while raising grievance, please try again later.');
                }
            });
        }
    };

    scope.clearGrievanceModal = function (prevGrieve) {
        scope.file = [];
        scope.grive.griveComment = '';
        scope.previousGrievancesComments1 = '';
        scope.previousGrievancesComments = [];
        if (prevGrieve && prevGrieve.grievanceReportComment) {
            var tempObj = JSON.parse(prevGrieve.grievanceReportComment);
            var prevGrvObj = {};
            if (tempObj.grievanceReport) {
                angular.forEach(tempObj, function (key, val) {
                    prevGrvObj[val] = key;
                })
                scope.previousGrievancesComments1 = prevGrvObj;
            } else {
                scope.previousGrievancesComments1 = tempObj;
            }
        }
        if (scope.previousGrievancesComments1 && scope.previousGrievancesComments1.grievanceReport) {
            scope.previousGrievancesComments.push({
                'grievanceReport': scope.previousGrievancesComments1.grievanceReport,
                'grievanceComment': scope.previousGrievancesComments1.grievanceComment,
                'grievDate': scope.previousGrievancesComments1.grievDate ? scope.previousGrievancesComments1.grievDate : '--'
            })
        } else {
            scope.previousGrievancesComments = scope.previousGrievancesComments1;
        }
    }
    scope.addGrive = function () {
        scope.uploadMethods.upload(scope.addGrievance);
    };

    scope.uploadMethods = (function () {
        return {
            upload: function (callback) {
                var fileBlobArray = [];
                var filesUploadingArray = [];
                Object.keys(scope.file).forEach(function (ele) {
                    if (typeof (scope.file[ele].model) == "object") {
                        filesUploadingArray.push(scope.file[ele].model);
                    }
                });
                if (filesUploadingArray.length > 0) {
                    fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrlPrefix() + "/File.json"));
                }
                else {
                    $('#grievanceModal').modal('hide');
                    UtilitiesService.showAlertMessage('Kindly upload atleast one file.');
                    return false;
                }
                $q.all(fileBlobArray).then(function (result) {
                    if (typeof result == "object" && typeof result[0].data == "object") {
                        var objSentAjax = {};
                        for (var property in result[0].data) {
                            if (result[0].data.hasOwnProperty(property)) {
                                var obj = {};
                                obj.fileName = result[0].data[property];
                                obj.filePath = UtilitiesService.getDownloadURL(true) + property;
                                scope.newlyUploadedDocs.push(obj);
                                objSentAjax[(UtilitiesService.getDownloadURL(true) + property)] = result[0].data[property];
                            }
                        }
                        if (result && scope.newlyUploadedDocs && scope.newlyUploadedDocs.length > 0)
                            callback.call(scope.addGrievance, objSentAjax);
                    }
                    else {
                        UtilitiesService.showAlertMessage('Upload fail.');
                        return false;
                    }
                },
                function (error) {
                    UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
                });
            },
            clearFileModels: function (isShow) {
                if (!isShow)
                    scope.newlyUploadedDocs = [];
                scope.file = [];
                scope.fileUploadMethods.addFileToUpload();
            }
        };
    })();
    scope.locationMethods.loadStates();
}]);
angular.module('mbplus')
.controller('allSearchController', ['$scope','$rootScope', 'UserService', 'UtilitiesService', 'filterFilter', '$filter', 'PlusUtilitiesService', 'sharedDataService', '$state', 'orderByFilter', 'FileUploadService', '$timeout', 'navConstantsSvc', function (scope,$rootScope, UserService, UtilitiesService, filterFilter, $filter, PlusUtilitiesService, sharedDataSvc, state, orderByFilter, FileUploadSvc, timeout, constant) {

	scope.status ={
		isFirstOpen: false,
		isSecondOpen: false
	}
	scope.serverSearch ={
		number: '',
		employeeID: '',
		requestID: ''
	}
    scope.bloodGrp = {
        selectedBloodGrp: ''
    };
    scope.grive = {
        griveComment: ''
    };
    scope.isPhotoAvailble = {
        value: 'false'
    };
    scope.day = moment();
    scope.doctorQualificatio = '';
    scope.isOpenAccordian = false;
    $rootScope.plusAppointmentsSearch = '';
    $rootScope.dcInvestigations = '';
    $rootScope.dcInvestigationsMap = '';
    $rootScope.eSaleQueue = '';
    scope.ctrlName = 'appointmentsController';
    scope.user = UserService.getUserObj();
    scope.formatTime = UtilitiesService.formatTime;
    scope.compareDate = UtilitiesService.compareDate;
    scope.pharmaData = {
        cashlessAmt: '',
        CODAmt: ''
    }
    scope.requestDataForDND = {};
    scope.isCorporate = false;
    scope.showChkedOnDcLogin = true;
    scope.contracts = [];
    scope.selectedDcs = [];
    scope.reports = [];
    scope.bills = [];
    scope.newlyUploadedReports = [];
    scope.newlyUploadedBills = [];
    scope.corporateSelectedID = '';
    scope.daysOfAppointment = '';
    scope.ERTypeId = 5290;
    scope.rowNo = 10;
    scope.Role = [5432, 5433, 5434];
    scope.serviceBrokerId = '1000042';
    scope.Entity_Type = '4653';
    scope.testData = {
        testStateId: '',
        testSubLocalityId: '',
        testCityId: '',
        testLocalityId: '',
        dcValue: ''
    };
    scope.homeVisit = {
        addressLineOne: '',
        addressLinTwo: ''
    }
    scope.resendEmailDetails = {
        emailID: '',
        statusID: ''
    };
    scope.client = {
        prefDate: new Date()
    }
    scope.originalDcDetails = {
        providerId: '',
        providerName: '',
        appointmentDate: '',
        visitType: ''
    };
    scope.dispayInDdl = "Search by";
    scope.serverSearch = {
        fromDate: '',
        toDate: '',
        statusSearch: '',
        contractType: '',
        corporateId: '',
        dateWiseSearch: 'apptdate'
    };
    scope.form = {
        dod: ''
    };
    scope.feedbackList = ['Satisfied', 'Dissatisfied', 'Pacifistic'];
    scope.action = {
        cancelComments: '',
        statusId: '',
        nextStatusId: '',
        requestId: '',
        spocname: '',
        spocphone: '',
        date: '',
        remarks: '',
        secondPreferredTime: '',
        dcPrice: '',
        visibleDate: '',
        visibleTime: '',
        partnerOrderId: '',
        showdcselection: false,
        feedback: ''
    };
    scope.attachFiles = {
        reports: {},
        bills: {}
    };
    scope.getDateObj = UtilitiesService.getDateObj;
    scope.file = [];
    scope.newlyUploadedDocs = [];
	scope.activeAppointments ={
		requests:[]
    };
    // scope.corres = {
    //     corrremarks: '',
    //     calltype: '',
    //     callstatus: '',
    //     workStatus: ''
    // };

    scope.uploadedFileData = { 
        reports: {},
        bills:{} 
    };

    scope.storeFiles =[];
    scope.storedBill =[];


	scope.clearAll = function(){
		scope.serverSearch.number = '';
		scope.serverSearch.employeeID = '';
		scope.serverSearch.requestID = '';
		scope.activeAppointments.requests = [];
		scope.eSalesQueueRequests = [];
		scope.status.isFirstOpen =  false;
        scope.status.isSecondOpen = false;
        scope.showDetailView = false;
	};

    scope.popupQc ={
        opened: false,
        actualDate: ''
    }

    scope.openQcDate = function(){
        scope.popupQc.opened = true;
    };


    scope.downloadAttachment = function (obj) {
        if (obj) {
            window.open(
              UtilitiesService.getDownloadURL(true) + obj,
              '_blank'
            );
        }
    };

    scope.removeBillFiles = function(item){
        if(item){
            delete scope.uploadedFileData.bills[item.filePath];
            angular.forEach(scope.storedBill, function(value, index){
                 if(value.fileName === item.fileName){
                    scope.storedBill.splice(value, 1);
                }
            });
        }
    };

    scope.removeFiles = function(item){
        if(item){
            delete scope.uploadedFileData.reports[item.filePath];
            angular.forEach(scope.storeFiles, function(value, index){
                 if(value.fileName === item.fileName){
                    scope.storeFiles.splice(value, 1);
                }
            });
        }
    };

    scope.fileFn = function(data, type){
        if (data) {
            if(type === 'report'){
                for (var key in data){
                    scope.uploadedFileData.reports[key] = data[key];
                }
                angular.forEach(data, function(value, index){
                    scope.storeFiles.push({ fileName: value, filePath: index});
                });
            }else if(type === 'bill'){
                for (var key in data){
                    scope.uploadedFileData.bills[key] = data[key];
                }
                angular.forEach(data, function(value, index){
                    scope.storedBill.push({ fileName: value, filePath: index});
                });
            }
        }
    };

    scope.resetTime = function () {
        var first = new Date();
        var dd = new Date(first).getDate();
        var mm = new Date(first).getMonth() + 1;
        var yy = new Date(first).getFullYear();
        var hh = 8;
        var ms = 0;
        var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
        scope.client.prefTime = new Date(x);
    };

	scope.getAllResult = function(){
	  	var ajaxData ={
	  		searchBy:{
	  		 requestid: scope.serverSearch.requestID ? scope.serverSearch.requestID : '',
	  		 empid: scope.serverSearch.employeeID ? scope.serverSearch.employeeID: '',
	  		 contactno: scope.serverSearch.number? scope.serverSearch.number:''
	  		}
	  	}
	  	UtilitiesService.startLoading('fetching search data...', 'allSearchDataResult');
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/allQueueActiveAppointments', ajaxData, 'POST', UserService.getAccessToken()).then(function (response) {
            UtilitiesService.stopLoading('allSearchDataResult');
            if (response.data) {
            	scope.activeAppointments.requests = response.data.activeRequests;
            	scope.eSalesQueueRequests = response.data.eSalesQueueRequests;
                scope.equoteData = {};
                $(scope.eSalesQueueRequests).each(function (i, v) {
                    if (v.eQuote) {
                        v.originaleQuote = v.eQuote;
                        v.eQuote = v.eQuote.split("_")[0];
                    }
                    scope.equoteData[v.eQuote] = JSON.parse(v.requestJSON);
                    if (scope.equoteData[v.eQuote] && scope.equoteData[v.eQuote].employeeId) {
                        scope.equoteData[v.eQuote].originaleQuote = scope.equoteData[v.eQuote].employeeId;
                        scope.equoteData[v.eQuote].employeeId = scope.equoteData[v.eQuote].employeeId.split("_")[0]
                    }
                    scope.equoteData[v.eQuote]['pbrequestId'] = v.id;
                    scope.equoteData[v.eQuote]['source'] = v.source;
                })
                scope.showDetailView = false;
            	scope.status.isFirstOpen = scope.activeAppointments.requests.length > 0 ? true: false;
            	scope.status.isSecondOpen = scope.eSalesQueueRequests.length > 0 ? true: false;
            } else {
            	scope.activeAppointments.length =0;
            	scope.eSalesQueueRequests.length =0;
                UtilitiesService.showAlertMessage('No Record Found.');
            }
        })
	};

    scope.showDcSelection = function (value, source) {
        scope.action.showdcselection = !!value;

        scope.testData.testStateId = '';
        scope.cities = [];
        scope.testData.testCityId = '';

        scope.locations = [];
        scope.testData.testLocalityId = '';

        scope.sublocations = [];
        scope.testData.testSubLocalityId = '';

        scope.diagnosticCentres = [];
        scope.testData.dcValue = '';

        if (source === 'dcVisit') {
            scope.action.showHomeVisitSelection = false;
            scope.homeVisit = [];
            if (scope.action.showdcselection === false) {
                scope.testData.testStateId = '';
                scope.testData.testCityId = '';
                scope.testData.testLocalityId = '';
                scope.testData.testSubLocalityId = '';
                scope.testData.dcValue = '';
                scope.selectedDcs = [];
            }
        }
        if (source === 'homeVisit') {
            scope.action.showdcselection = false;
            scope.testData.testStateId = '';
        }
    };
	//Open Action popup
    scope.openRespectiveActionModal = function (actionName, currentStatusId, actionStatusId, requestId, appointmentDate, secondAppointmentDate, orderItemProductId, requestData) {
        scope.requestData = requestData;
        scope.visitTypeDcHome = requestData ? (requestData.additionalInformation ?
            (requestData.additionalInformation.visitType ? requestData.additionalInformation.visitType : ''
            ) : (requestData.visitType ? requestData.visitType : '')) : '';
        scope.action.partnerOrderId = '';
        scope.pharmaData.cashlessAmt = '';
        scope.pharmaData.CODAmt = '';
        scope.resetTime();
        scope.showDcSelection();
        scope.actionId = actionStatusId;
        scope.client.prefDate = UtilitiesService.getDateObj(appointmentDate);
        if(actionStatusId === 121){
            $('#UTC').modal('show');
            scope.tuModel = 'Completed';
        }else if(actionStatusId === 122){
            $('#UTC').modal('show');
            scope.tuModel = 'Scheduled';
        }else if(actionStatusId === 123){
            $('#UTCAwaited').modal('show');
            scope.tuModel = 'Awaited';
        }else if(actionStatusId !== 122 || actionStatusId !== 122){
            scope.actionName = actionName;
        }
        scope.storeFiles =[];
        scope.storedBill =[];
        scope.uploadedFileData.reports = {};
        scope.uploadedFileData.bills = {};
        scope.action.showdcselection = false;
        scope.action.remarks = '';
        scope.action.statusId = currentStatusId;
        scope.action.nextStatusId = actionStatusId;
        scope.action.requestId = requestId;
        scope.action.date = appointmentDate;
        scope.action.feedback = '';
        scope.action.visibleDate = scope.compareDate(appointmentDate);
        scope.action.visibleTime = scope.action.visibleDate + " " + scope.formatTime(appointmentDate);
        scope.action.secondPreferredTime = secondAppointmentDate;
        scope.secondPreferredVTime = scope.compareDate(secondAppointmentDate) + " " + scope.formatTime(secondAppointmentDate);
        scope.action.productId = orderItemProductId;
        //empty all modals

        if (scope.actionName == 'Fit' || scope.actionName == 'UnFit') {
            if (scope.action.remarks) {
                scope.action.remarks.fit = '';
                scope.selectedBloodGrp = '';
            }
        }
        if (scope.actionName == 'Reschedule') {
            scope.locationMethods.loadStates();
            scope.form.dod = '';
            scope.action.showdcselection = false;
            scope.testData.testStateId = '';
            scope.testData.testCityId = '';
            scope.testData.testLocalityId = '';
        }
        if (scope.actionName == 'Confirm') {
            scope.action.spocname = '';
            scope.action.spocphone = '';
            scope.action.dcPrice = '';
        }
        if (scope.actionName == 'Cancel') {
            scope.action.visibleTime = scope.action.visibleDate + ' ' + scope.compareDate(scope.action.date);
        }
        if (scope.actionName == 'Approve' || scope.actionName == 'NotAttended' || scope.actionName == 'Raise_IA') {
            scope.action.remarks = "";
        }
        if (scope.actionName == 'Attended') {
            scope.actualdate = '';
            scope.action.remarks = '';
            scope.action.feedback = '';
        }
        if (scope.actionName == 'Submit') {
            scope.reports = [];
            scope.bills = [];
            scope.attachFiles.reports = {};
            scope.attachFiles.bills = {};
            scope.storeFiles =[];
            scope.storedBill =[];
            scope.uploadedFileData.reports = {};
            scope.uploadedFileData.bills = {};
            scope.action.remarks = '';
        }
        if (scope.actionName == 'PlaceWithPartner') {
            scope.partnerOrderId = '';
        }
        if (scope.actionName == 'Delivered') {
            scope.pharmaData.cashlessAmt = '';
            scope.pharmaData.CODAmt = '';
        }
    };

        //Next possible action for request call
    scope.createRequest = function (requestType, statusId, nextStatusId, requestId, actionType, spocname, spocphone, event) {
        var patientname = scope.selectedPatientName;
        var id = requestId; //scope.selectedRequestId;
        var appDate = scope.action.date;
        scope.client.prefDate = UtilitiesService.mergeDateTimeObj(scope.client.prefDate, scope.client.prefTime);
        var providerId = null;
        var providerName = "";
        var remarksComment = scope.action.remarks;
        scope.action.remarks = '';
        var additionalParams = {};
        switch (actionType) {
            case 'Reschedule':
                appDate = scope.client.prefDate;
                if (scope.selectedDcs.length > 0 && !(scope.user.entitytype == 'dc')) {
                    providerId = _.first(scope.selectedDcs).id;
                    providerName = _.first(scope.selectedDcs).entityName;
                }
                break;
            case 'Cancel':
                appDate = scope.action.date;
                remarksComment = scope.action.cancelReason == 'Other' ? scope.action.cancelComments : scope.action.cancelReason;
                break;
            case 'QCApprove':
                additionalParams.doctorQualification = scope.doctorQualificatio ? scope.doctorQualificatio : '';
                additionalParams.isPhotographAvailable = scope.isPhotoAvailble.value;
                additionalParams.ActualApptDate = scope.popupQc.actualDate; 
                break;
            case 'Confirm':
                additionalParams.Price = scope.action.dcPrice;
                break;
            case 'Fit':
                additionalParams.bloodGroup = scope.bloodGrp.selectedBloodGrp;
                break;
            case 'UnFit':
                additionalParams.bloodGroup = scope.bloodGrp.selectedBloodGrp;
                break;
            case 'Delivered':
                break;
            case 'OutForDelivery':
                break;
            case 'ConfirmByRetailer':
                break;
            case 'InsurerAction':
            // var remarksComment = scope.action.remarks;
                break;
            case 'UTC':
                // var remarksComment = scope.action.remarks;
                scope.attachFiles = scope.uploadedFileData;
                break;
            case 'UTCAwaited':
                // var remarksComment = scope.action.remarks;
                scope.attachFiles = [];
                break;
            case 'Submit':
                // var remarksComment = scope.action.remarks;
                scope.attachFiles = scope.uploadedFileData;
                break;
            default:
                appDate = scope.action.date;
                break;
        }
        scope.selectedDcs = [];
        var requestData = {
            request: {
                requestId: requestId,
                currentStatusId: statusId,
                remarks: remarksComment,
                ScheduledAppointmentDate: appDate,
                requestedNextActionId: nextStatusId,
                attachFiles: scope.attachFiles,
                providerId: providerId,
                providerName: providerName,
                spocName: spocname,
                spocContactNo: spocphone,
                additionalParameters: additionalParams,
                addressLine1: scope.homeVisit.addressLineOne ? scope.homeVisit.addressLineOne : '',
                addressLine2: scope.homeVisit.addressLinTwo ? scope.homeVisit.addressLinTwo : '',
                userFeedback: scope.action.feedback ? scope.action.feedback : ''
                //isHomeVisit: scope.action.showHomeVisitSelection === true ? true : (scope.visitTypeDcHome === 'Appointment' ? false : (scope.visitTypeDcHome === 'Home_Visit' ? true : false))
            },
            requestAccessToken: UserService.getAccessToken()
        }
        if (scope.action.showHomeVisitSelection === true) {
            requestData.request.isHomeVisit = true;
            scope.visitTypeDcHome = '';
        }
        else if (scope.action.showHomeVisitSelection === false) {
            requestData.request.isHomeVisit = false
            scope.visitTypeDcHome = '';
        }
        else if (scope.visitTypeDcHome === 'Appointment') {
            requestData.request.isHomeVisit = false
        }
        else if (scope.visitTypeDcHome === 'Home_Visit') {
            requestData.request.isHomeVisit = true
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/request', requestData, "post").then(function (response) {
            var targetModal = event.target.parentNode;
            scope.resetTime();
            scope.testData.testStateId = '';
            scope.testData.testCityId = '';
            scope.testData.testLocalityId = '';
            scope.testData.testSubLocalityId = '';
            scope.dcValue = '';
            scope.selectedDcs = [];
            scope.selectedBloodGrp = '';
            scope.newlyUploadedReports = [];
            scope.newlyUploadedBills = [];
            scope.storeFiles =[];
            scope.storedBill =[];
            scope.uploadedFileData.reports = {};
            scope.uploadedFileData.bills = {};
            scope.today();
            while (!targetModal.classList.contains('modal')) {
                targetModal = targetModal.parentNode;
            }
            $('#' + actionType + 'Modal').modal('hide');
            scope.loadAppointments();
            if (scope.attachFiles) {
                if (scope.attachFiles.reports) {
                    scope.attachFiles.reports = {};
                }
                if (scope.attachFiles.bills) {
                    scope.attachFiles.bills = {};
                }
            }
            scope.action = {};
        });
    };

    scope.updateRemarks = function (actualDate) {
        scope.action.remarks = "Actual attended date is :" + actualDate;
    };
    scope.dynamicPopover = {
        content: 'Hello, World!',
        templateUrl: 'myPopoverTemplate.html',
        title: 'Title'
    };

    scope.loadFilteredDc = function () {
        var url = UtilitiesService.getPlusUrlPrefix() + "CorporatePackageProvider/" + scope.action.productId + "/false.json";
        UserService.makeRestCall(url, "", "get").then(function (response) {
            if (response.data.length > 0) {
                scope.filteredDc = response.data;
                var arr = [];
                scope.diagnosticCentres = [];
                $(scope.tempDiagnosticCentres).each(function (i, v) {
                    if (scope.filteredDc.indexOf(v.id) !== -1) {
                        arr.push(v);
                    }
                });
                scope.diagnosticCentres = arr;
            }
        });
    };

        //Get location
    scope.locationMethods = (function () {
        return {
            loadStates: function () {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + '/masterdata/lookup/state.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.states = response.data.lookUpData;
                    }
                });
            },
            loadCities: function (stateId) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/masterdata/lookup/district/' + stateId + '.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.cities = response.data.lookUpData;
                    }
                });
            },
            loadLocations: function (cityId) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/masterdata/lookup/city/" + cityId + '.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.locations = response.data.lookUpData;
                    }
                });
            },
            loadSubLocations: function (locationId) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/masterdata/lookup/location/' + locationId + '.json', '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.sublocations = response.data.lookUpData;
                    }
                });
            },
            loadDCForTests: function (id, obj) {
                scope.testData.testSubLocalityId = id;
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'EntityRelation/Search/EntitySearch/' + scope.ERTypeId + '/' + scope.serviceBrokerId + '/' + 0 + '/' + scope.testData.testStateId + '/' + scope.testData.testCityId + '/' + scope.testData.testLocalityId + '/' + scope.testData.testSubLocalityId + '.json', '', 'get').then(function (response) {
                    if (response.statusText == 'OK') {
                        scope.allDCs = response.data;
                        scope.tempDiagnosticCentres = response.data;
                        scope.loadFilteredDc();
                    }
                });
            }
        }
    })();

        //Load Location based ontype
    scope.loadLocationData = function (type, id) {
        switch (type) {
            case 'city':
                scope.locationMethods.loadCities(id);
                break;
            case 'locality':
                scope.locationMethods.loadLocations(id);
                break;
            case 'sublocality':
                scope.locationMethods.loadSubLocations(id);
                break;
            case 'dc':
                scope.locationMethods.loadDCForTests(id);
                break;
            default:
                scope.locationMethods.loadCities(id);
                break;
        }
    };


    scope.getPackageTestDetails = function (productId, noProductId) {
        if (noProductId) {
            scope.investigationList = [];
            return;
        } else {
            var pId = productId ? productId : '';
            scope.investigationList = [];
            if (pId) {
                var url = UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/' + pId;
                UserService.makeRestCall(url, '', 'GET', UserService.getAccessToken()).then(function (response) {
                    if (response.data) {
                        var investigation = response.data.allowedInvestigations;
                        var investigationGroup = [];
                        angular.forEach(investigation, function (v, i) {
                            investigationGroup.push(v.groupName);
                        })
                        var listOfUniqeInvestigations = investigationGroup.filter(function (val, index, allArr) {
                            return index == allArr.indexOf(val);
                        })
                        angular.forEach(listOfUniqeInvestigations, function (val, ind) {
                            var investigationWiseTests = filterFilter(investigation, val);
                            var testObj = investigationWiseTests;
                            scope.testDetails = [];
                            angular.forEach(testObj, function (v, i) {
                                scope.testDetails.push({
                                    groupName: v.groupName,
                                    testName: v.name,
                                    testId: v.id,
                                    groupId: v.groupId,
                                    isActive: v.isActive,
                                    duplicateCheck: v.duplicateCheck,
                                    quantity: v.quantity
                                })
                            })
                            scope.investigationList.push({
                                investigationName: val,
                                testDetails: scope.testDetails
                            })
                        })
                        // console.log(scope.investigationList);
                    } else {
                        UtilitiesService.showAlertMessage('No Investigations found.');
                    }
                })
            } else {
                UtilitiesService.showAlertMessage('Product Id is unavailable.');
            }
        }
    };

    scope.placeWithPartner = function () {
        var data = {
            RequestId: scope.action.requestId,
            PartnerOrderId: scope.action.partnerOrderId
        };
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/requestPharmaOrder', data, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data == true) {
                UtilitiesService.showAlertMessage('Order has been placed Successfully.', true);
                $('#PlaceWithPartnerModal').modal('hide');
            }
            if (response.data == false) {
                UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to place order.');
                $('#PlaceWithPartnerModal').modal('hide');
            }
        })
    };

    scope.showWalletBalance = function (balance, isSuccess) {
        scope.isSuccess = isSuccess;
        scope.showWalletBalanceMsz = isSuccess === true ? 'Rs. ' + balance + '/-' : balance;
        var modalInstance = $uibModal.open({
            animation: scope.animationsEnabled,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: "walletModal.html",
            controller: 'appointmentsController',
            scope: scope,
        });
    };


    scope.addFileToUpload = function (source) {
        if (source == 'reports' && source) {
            var newItemNo = scope.reports.length + 1;
            scope.reports.push({
                'model': ''
            });
        }
        if (source == 'bills') {
            var newItemNo = scope.bills.length + 1;
            scope.bills.push({
                'model': ''
            });
        }
    };

    scope.removeFileToUpload = function (index, source) {
        if (source == 'reports' && source) {
            scope.reports.splice(index, 1);
        }
        if (source == 'bills') {
            scope.bills.splice(index, 1);
        }
    };

    scope.uploadMethodFile = function (source) {
        if (source) {
            scope.IsFileGrter = false;
            var fileBlobArray = [];
            var filesUploadingArray = [];
            if (source == 'reports') {
                Object.keys(scope.reports).forEach(function (ele) {
                    if (typeof (scope.reports[ele].model) == 'object') {
                        filesUploadingArray.push(scope.reports[ele].model);
                    }
                });
                angular.forEach(filesUploadingArray, function (v, i) {
                    var fileSize = v.size;
                    if (fileSize > 10485760) {
                        scope.IsFileGrter = true;
                    }
                })
            }
            if (source == 'bills') {
                Object.keys(scope.bills).forEach(function (ele) {
                    if (typeof (scope.bills[ele].model) == 'object') {
                        filesUploadingArray.push(scope.bills[ele].model);
                    }
                });
                angular.forEach(filesUploadingArray, function (v, i) {
                    var fileSize = v.size;
                    if (fileSize > 10485760) {
                        scope.IsFileGrter = true;
                    }
                })
            }
            if (filesUploadingArray.length > 0) {
                if (!scope.IsFileGrter) {
                    fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrlPrefix() + "/File.json"));
                } else {
                    alert('File size is greater then 10 MB');
                    return false;
                }
            }
            else {
                alert('Please attach atleast one document.');
            }

            if (fileBlobArray.length > 0) {
                $q.all(fileBlobArray).then(function (result) {
                    if (typeof result == "object" && typeof result[0].data == 'object') {
                        for (var property in result[0].data) {
                            if (result[0].data.hasOwnProperty(property)) {
                                var obj = {};
                                obj.fileName = result[0].data[property].split('.')[0] + new Date().getTime() + '.' + result[0].data[property].split('.')[1];
                                obj.filePath = UtilitiesService.getDownloadURL(true) + property;
                                obj.key = property;
                                if (source == 'reports') {
                                    scope.newlyUploadedReports.push(obj);
                                    angular.extend(scope.attachFiles.reports, result[0].data)
                                    // console.log(scope.attachFiles.reports);
                                    scope.reports = [];
                                }
                                if (source == 'bills') {
                                    scope.newlyUploadedBills.push(obj);
                                    angular.extend(scope.attachFiles.bills, result[0].data)
                                    // console.log(scope.attachFiles.bills);
                                    scope.bills = [];
                                }
                            }
                        }
                    }
                    else {
                        alert('upload fail');
                    }
                },
                function (error) {
                    alert('upload fail');
                });
            }
        } else {
            alert('Please attach atleast one document.');
        }
    }

    scope.removeReports = function (indx, reportBill) {
        if (reportBill === 'report') {
            scope.tempUploadedReports = scope.newlyUploadedReports;
            var removedReportKey = scope.tempUploadedReports[indx];

            scope.tempUploadedReports.splice(indx, 1);
            scope.newlyUploadedReports = scope.tempUploadedReports;

            angular.forEach(scope.attachFiles.reports, function (v, i) {
                if (removedReportKey.key === i) {
                    delete scope.attachFiles.reports[i];
                }
            })
            // console.log(scope.attachFiles.reports);
        }
        if (reportBill === 'bills') {
            scope.tempUploadedBill = scope.newlyUploadedBills;
            var removedBillKey = scope.tempUploadedBill[indx];

            scope.tempUploadedBill.splice(indx, 1);
            scope.newlyUploadedBills = scope.tempUploadedBill;

            angular.forEach(scope.attachFiles.bills, function (v, i) {
                if (removedBillKey.key === i) {
                    delete scope.attachFiles.bills[i];
                }
            })
            // console.log(scope.attachFiles.bills);
        }
    };

    scope.removePrescriptions = function (indx) {
        scope.PharmaPrescriptionList.splice(indx, 1);
    }

    scope.openVarifyPresModal = function (PharmaPrescriptionData, source) {
        scope.PharmaPrescriptionList = [];
        if (source != 'reload') {
            scope.PharmaPrescriptionData = PharmaPrescriptionData;
            PharmaPrescriptionData.map(function (val) {
                scope.PharmaPrescriptionList.push({
                    filePath: val.filePath,
                    fileName: val.fileName
                });
            });
        }
        if (source == 'reload') {
            scope.PharmaPrescriptionData.map(function (val) {
                scope.PharmaPrescriptionList.push({
                    filePath: val.filePath,
                    fileName: val.fileName
                });
            });
        }
    };

    scope.verifyPrescription = function (urls) {
        scope.UrlList = urls;
        if (scope.UrlList) {
            scope.finalUrl = [];
            angular.forEach(urls, function (v, i) {
                var setUrl = v.filePath;
                scope.finalUrl.push(setUrl);
            })
            var data = {
                "requestId": $rootScope.requestIdForActiveAppointmnents,
                "updatePrescriptionURLs": scope.finalUrl,
                "isReplace": true
            }
            var url = UtilitiesService.getPlusUrlPrefix() + "UploadPharmaCashlessPrescription/";
            UserService.makeRestCall(url, data, "POST", UserService.getAccessToken()).then(function (response) {
                if (response.data) {
                    scope.uploadedIsSuccess = response.data
                    UtilitiesService.showAlertMessage('Files updated Successfully', true);
                    $('#openVarifyPres').modal("hide");
                }
            },
            function (error) {
                UtilitiesService.showAlertMessage('issue in verify url.');
            })
        }
    };

    //closing uib bootstrap modals
    scope.closeModal = function () {
        scope.$dismiss('cancel');
    };


    scope.fileUploadMethods = (function () {
        return {
            addFileToUpload: function (flag) {
                var newItemNo = scope.file.length + 1;
                scope.file.push({
                    'model': ''
                });
            },
            removeFileToUpload: function (index) {
                scope.file.splice(index, 1);
            }
        };
    })();

    scope.addGrievance = function (fileUploadData) {
        if (fileUploadData) {
            var finalGrieveReportComment = '';
            var grievImgComments = {};
            var tempPrevGrieve = [];

            var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var currentDate = new Date();
            var currentMonth = currentDate.getMonth();

            var finalCurrentDate = (monthNames[currentDate.getMonth()]) + '-' + currentDate.getDate() + '-' + currentDate.getFullYear();

            if (scope.previousGrievancesComments) {
                tempPrevGrieve = scope.previousGrievancesComments;

                tempPrevGrieve.push({ 'grievanceReport': fileUploadData, 'grievanceComment': scope.grive.griveComment, 'grievDate': finalCurrentDate });
                finalGrieveReportComment = JSON.stringify(tempPrevGrieve);
            } else {
                grievImgComments.grievanceReport = fileUploadData;
                grievImgComments.grievanceComment = scope.grive.griveComment;
                grievImgComments.grievDate = finalCurrentDate;

                finalGrieveReportComment = JSON.stringify(grievImgComments);  //to be sent to api
            }

            var data = {
                "requestId": $rootScope.requestIdForActiveAppointmnents,
                "additionalInfo": {
                    "grievanceReportComment": finalGrieveReportComment,
                }
            }
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'UpdateRequestAdditionalInfo', data, 'POST', UserService.getAccessToken()).then(function (response) {
                if (response.data) {
                    $('#grievanceModal').modal('hide');
                    UtilitiesService.showAlertMessage('Grievance raised successfully.', true);
                }
                else {
                    UtilitiesService.showAlertMessage('oops! Error occur while raising grievance, please try again later.');
                }
            });
        }
    };

    scope.clearGrievanceModal = function (prevGrieve) {
        scope.file = [];
        scope.grive.griveComment = '';
        scope.previousGrievancesComments1 = '';
        scope.previousGrievancesComments = [];
        if (prevGrieve && prevGrieve.grievanceReportComment) {
            var tempObj = JSON.parse(prevGrieve.grievanceReportComment);
            var prevGrvObj = {};
            if (tempObj.grievanceReport) {
                angular.forEach(tempObj, function (key, val) {
                    prevGrvObj[val] = key;
                })
                scope.previousGrievancesComments1 = prevGrvObj;
            } else {
                scope.previousGrievancesComments1 = tempObj;
            }
        }
        if (scope.previousGrievancesComments1 && scope.previousGrievancesComments1.grievanceReport) {
            scope.previousGrievancesComments.push({
                'grievanceReport': scope.previousGrievancesComments1.grievanceReport,
                'grievanceComment': scope.previousGrievancesComments1.grievanceComment,
                'grievDate': scope.previousGrievancesComments1.grievDate ? scope.previousGrievancesComments1.grievDate : '--'
            })
        } else {
            scope.previousGrievancesComments = scope.previousGrievancesComments1;
        }
    }
    scope.addGrive = function () {
        scope.uploadMethods.upload(scope.addGrievance);
    };

    scope.uploadMethods = (function () {
        return {
            upload: function (callback) {
                var fileBlobArray = [];
                var filesUploadingArray = [];
                Object.keys(scope.file).forEach(function (ele) {
                    if (typeof (scope.file[ele].model) == "object") {
                        filesUploadingArray.push(scope.file[ele].model);
                    }
                });
                if (filesUploadingArray.length > 0) {
                    fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrlPrefix() + "/File.json"));
                }
                else {
                    $('#grievanceModal').modal('hide');
                    UtilitiesService.showAlertMessage('Kindly upload atleast one file.');
                    return false;
                }
                $q.all(fileBlobArray).then(function (result) {
                    if (typeof result == "object" && typeof result[0].data == "object") {
                        var objSentAjax = {};
                        for (var property in result[0].data) {
                            if (result[0].data.hasOwnProperty(property)) {
                                var obj = {};
                                obj.fileName = result[0].data[property];
                                obj.filePath = UtilitiesService.getDownloadURL(true) + property;
                                scope.newlyUploadedDocs.push(obj);
                                objSentAjax[(UtilitiesService.getDownloadURL(true) + property)] = result[0].data[property];
                            }
                        }
                        if (result && scope.newlyUploadedDocs && scope.newlyUploadedDocs.length > 0)
                            callback.call(scope.addGrievance, objSentAjax);
                    }
                    else {
                        UtilitiesService.showAlertMessage('Upload fail.');
                        return false;
                    }
                },
                function (error) {
                    UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
                });
            },
            clearFileModels: function (isShow) {
                if (!isShow)
                    scope.newlyUploadedDocs = [];
                scope.file = [];
                scope.fileUploadMethods.addFileToUpload();
            }
        };
    })();
    scope.locationMethods.loadStates();
    scope.clearAddCorrespondenceData = function() {
        scope.corres.corrremarks = '';
        scope.corres.calltype = '';
        scope.corres.callstatus = '';
        scope.corres.workStatus = 'workable';
        scope.uicDetail.uicNumber = null;
        scope.callDateTime.prefTime = null;
        scope.callDateTime.prefDate = null;
    }

        //Get and add Correspondence
    scope.getAddCorrespondence = function (reqDetails, action) {
        if (reqDetails) {
            scope.requestDataForCorrespondence = Object.assign({}, reqDetails);
            scope.checkForDNDFlags(scope.requestDataForCorrespondence);
            scope.reqDetails = reqDetails;
            if (action === 'add') {
                scope.clearAddCorrespondenceData();
                scope.getCallTypes();
            } else if (action === 'show' && reqDetails.id) {
                scope.correspondencError = '';
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/RequestCorrespondence/153/0/' + reqDetails.id, '', 'GET').then(function (response) {
                    if (response.data.length > 0) {
                        scope.correspondencData = response.data;
                    } else {
                        $('#ViewCorresponddenceModal').modal('hide');
                        UtilitiesService.showAlertMessage('No correspondence record found!!');
                        scope.correspondencData = [];
                    }
                });
            }
        }
        else {
            UtilitiesService.showAlertMessage('Id not found.');
        }
    };

        scope.showCalender = false;
    scope.packages = [];
    scope.selectedPackageForAdvance = [];
    scope.sumassuredetail = {
        sumAssured: '',
        paidSpons: 'sponsored',
        grpIndv: 'individual'
    }
    scope.uicDetail = {
        uicNumber: ''
    }
    //date time
    scope.callDateTime = {
        prefDate: '',
        prefTime: ''
    }

    scope.popup6 = {
        opened: false
    };
    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];
    scope.open6 = function () {
        scope.popup6.opened = true;
    };
    // scope.dateOptions = {
    //     formatYear: 'yy',
    //     maxDate: new Date(2020, 5, 22),
    //     startingDay: 1
    // };
    scope.mindate = new Date();
    scope.hstep = 1;
    scope.mstep = 1;
    //date time

    scope.open6 = function () {
        scope.popup6.opened = true;
    };
    scope.client = {
        visitType: ''
    }
    scope.genderList = {
        gender: 'NA'
    }

    scope.locationName = {
        autocomplete: ''
    }
    scope.client = {
        preferredDC1: ''
    }
    scope.manual = {
        firstDate: '',
        secondDate: ''
    }
    scope.serverSearch = {
        fromDate: '',
        toDate: '',
        statusSearch: '',
        contractType: '',
        corporateId: ''
    };
    scope.isFlage = {
        isDownload: false,
        autoDcSelection: false,
        autDcSection: ''
    }
    scope.IsMaUser = false;
    scope.contract = {};
    scope.getDateTime = function (date, time) {
        scope.PrefcallDateTime = UtilitiesService.mergeDateTimeObj(date, time);
    }
    scope.user = UserService.getUserObj();
    angular.forEach(scope.user && scope.user.rolesFeatures.roles, function (v, i) {
        if (v.roleId === 9211 || v.roleId === 9214 || v.roleId === 9204) {
            scope.isDdlVisible = false;
            scope.isFlage.isDownload = false;
            scope.IsMaUser = true;
        }
    });
    if (scope.user && scope.user.entityId) {
        if (scope.user.entityId === 1000042) {
            scope.isDdlVisible = false;
            scope.isFlage.isDownload = false;
            scope.IsMaUser = true;
        }
    }
    scope.childrenData = UtilitiesService.getAllChildren() === null ? [] : UtilitiesService.getAllChildren();
    scope.contractList = UtilitiesService.getContracts() === null ? [] : UtilitiesService.getContracts();
    scope.contractList1 = filterFilter(scope.contractList, {
        "id": scope.childrenData
    }, function (actual, expected) {
        return filterFilter(expected, {
            'erTypeId': parseInt(actual)
        }).length > 0;
    });
    scope.contractList = scope.contractList1;
    scope.getSelectedErId = function (selectedContract) {
        if (selectedContract == null) {
            scope.isFlage.isDownload = false;
            scope.isDdlVisible = true;
        }
        if (selectedContract && selectedContract.id) {
            if (selectedContract) {
                //scope.contract = selectedContract.id;
                scope.contract = {};
                scope.contract.id = selectedContract.id
                scope.setContractIdForUpload = scope.contract.id
                scope.templateUrl = UtilitiesService.getPlusUrlPrefix() + "/DownloadAllSampleExcelFormat/" + scope.contract.id;
                scope.isFlage.isDownload = true;
            } else {
                scope.isFlage.isDownload = false;
            }
        }//function call
        else if (scope.contractList.length === 1) {
            scope.contract.id = _.first(scope.contractList).id;
            scope.setContractIdForUpload = scope.contract.id
            scope.templateUrl = UtilitiesService.getPlusUrlPrefix() + "/DownloadAllSampleExcelFormat/" + scope.contract.id;
            scope.isFlage.isDownload = true;
        } else {
            scope.isDdlVisible = true;
        }
    };

    scope.getSelectedErId();
    scope.contractsData = [];
    scope.contractsData.push({ id: '0', entityName: 'All Corporate' });
    scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };
    scope.downloadFailedFile = function () {
        if (scope.failedFileName) {
            var url = UtilitiesService.getUrlPrefix() + '/DownloadExcelWithErrors/' + scope.failedFileName + ".json";
            window.open(url, "_blank");
        }
    };
    scope.setFilesUpload = function (element) {
        $("#uploadTemplates").attr("disabled", "disabled");
        if (window.FormData) {
            formdata = new FormData();
        }
        file = element.files[0];
        if (formdata) {
            formdata.append("reports[]", file);
            formdata.append("userEntityId", UserService.getUserObj().entityId);
            formdata.append("contractId", scope.setContractIdForUpload);
        }

        $.ajax({
            url: UtilitiesService.getPlusUrlPrefix() + "UploadExcelOrders.json",
            type: "POST",
            data: formdata,
            headers: {
                "AccessToken": UserService.getAccessToken()
            },
            processData: false,
            contentType: false,
            success: function (res) {
                if (res.isSuccess) {
                    if(res.errorMessage){
                        UtilitiesService.showAlertMessage(res.errorMessage);
                    }else{
                        UtilitiesService.showAlertMessage('Appointments created Successfully! You will be able to see in active appointments, once it is approved by our operations person.', true);
                    }
                }
                else {
                    if (res && res.fileBytes) {
                        window.open('data:application/vnd.ms-excel;base64,' + res.fileBytes);
                    }
                    UtilitiesService.showAlertMessage('Appointment creation failed.');
                    scope.failedFileName = res.fileName;
                    scope.downloadFailedFile();
                }
                $("input#uploadTemplates").val("");
                $("#uploadTemplates").removeAttr("disabled");
                $("#uploadTemplates").attr('value', '');
                scope.$apply();
            }
        });
        return false;
    }

    //Get corporate Packages data
    scope.getCorporatePackages = function (CorporateSelected,boolVal) {
        scope.contractsData = [];
        //scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };
        if (CorporateSelected && CorporateSelected !== '0') {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/EntityRelationcache/Search/' + CorporateSelected, {}, 'get').then(function (response) {
                scope.contractsData = [];
                scope.isCorporate = response.data.length > 0 ? true : false
                if (response.data.length > 0) {
                    scope.contractsData = response.data;
                    scope.contractsData.push({ id: '0', entityName: 'All Corporate' });
                    scope.contractsData = orderByFilter(scope.contractsData, 'entityName', false);
                    //scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };
                    if (boolVal) {
                        scope.serverSearch.corporateId.id = scope.isSearchDataAvailableOnLoad.corporateId.id;
                        scope.serverSearch.corporateId.entityName = scope.isSearchDataAvailableOnLoad.corporateId.entityName;
                    } else {
                        scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };
                    }

                }
            })
        } else {
            scope.isCorporate = false;
        }
    };

    scope.contracts = PlusUtilitiesService.getContracts();
    var first = new Date();
    var dd = new Date(first).getDate();
    var mm = new Date(first).getMonth() + 1;
    var yy = new Date(first).getFullYear();
    var hh = 7;
    var ms = 0;
    var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
    scope.secondTime = new Date(x);
    scope.firstTime = new Date(x);
    scope.manual.secondTime = new Date(x);
    scope.manual.firstTime = new Date(x);
    var maxFirstValue = new Date();
    maxFirstValue.setHours(18);
    maxFirstValue.setMinutes(0);
    scope.maxFirstValue = maxFirstValue;
    var minFirstValue = new Date();
    minFirstValue.setHours(7);
    minFirstValue.setMinutes(0);
    scope.minFirstValue = minFirstValue;
    var maxFirst = new Date();
    maxFirst.setHours(18);
    maxFirst.setMinutes(0);
    scope.maxFirst = maxFirst;
    var minFirst = new Date();
    minFirst.setHours(7);
    minFirst.setMinutes(0);
    scope.minFirst = minFirst;
    scope.corres = [];

    scope.ctrlName = "UnapprovedCancelController";

    scope.formatTime = UtilitiesService.formatTime;
    scope.compareDate = UtilitiesService.compareDate;
    scope.getDateObj = UtilitiesService.getDateObj;
    scope.showList = true;
    scope.showDetailView = false;
    scope.showData = {};
    scope.showAddTestBox = false;
    scope.ContractAsSales = false;
    scope.prePolicyERId = 51162;
    scope.policyBazaarRequestsContractId = PlusUtilitiesService.getSpecificContract("E_SALES")[0];
    scope.contracts = PlusUtilitiesService.getContracts();
    scope.createresult = false;
    scope.totalPrice = 0;
    scope.orderObj = new Object();
    scope.orderItemObj = new Object();
    scope.showPaid = false;
    scope.paid = true;
    scope.txn = {};
    scope.correspondencData = [];
    scope.location = {};
    scope.employee = new Object();
    scope.cartEmpty = true;
    scope.CartAppointments = [];
    scope.benefMAID = 0;
    scope.pkgSelected = 0;
    scope.client = {};
    scope.client.visitType = '';
    scope.empContract = "";
    scope.empCorporate = "";
    scope.testName = null;
    scope.showSuccessMessage = false;
    scope.contracts = PlusUtilitiesService.getContracts();
    scope.filter = {};
    scope.isDownload = false;
    scope.defaultSet = true;
    scope.isInsurer = true;
    scope.isHrLogin = true;
    scope.additionalFieldList = ['hrLocation', 'hrMobileNumber', 'hrName', 'AgentEmailId', 'AgentName', 'AgentContactNo', 'ProposalNumber', 
    'Entity', 'CaseType', 'Aadhar', 'PAN', 'packageOrGrade', 'lifeno', 'clientLocation', 'SMName', 'SM_Email', 'SMPhoneNumber'];
    if (scope.user && scope.user.rolesFeatures) {
        angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
            if (v.roleId == 9212) {
                scope.isDownload = true;
            }
        });
        angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
            if (v.roleId == 9207 || v.roleId == 9211 || v.roleId == 9214) {
                scope.isInsurer = false;
            }
            if (v.roleId === 9209) {
                scope.isHrLogin = false;
            }
        });
    }
    scope.open1 = function () {
        scope.popup1.opened = true;
    };
    scope.open2 = function () {
        scope.popup2.opened = true;
    };

    scope.open5 = function () {
        scope.popup5.opened = true;
    };
    scope.open6 = function () {
        scope.popup6.opened = true;
    };

    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];
    scope.popup4 = {
        opened: false
    };
    scope.popup1 = {
        opened: false
    };
    scope.open4 = function () {
        scope.popup4.opened = true;
    };
    scope.popup2 = {
        opened: false
    };
    scope.field = {
        fieldName: null,
        fieldValue: null
    }

    scope.getSources = function () {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + "/contractlookup/" + PlusUtilitiesService.getSpecificContract("E_SALES")[0] + ".json", "", "GET").then(function (response) {
            scope.sources = response.data;
            $(scope.sources).each(function (i, v) {
                if (v.entityName.indexOf("Coverfox") != -1) {
                    scope.coverfox_id = v.id;
                }
                else if (v.entityName.indexOf("PolicyBazaar") != -1) {
                    scope.policybazaar_id = v.id;
                }
            })
        });
    };

    scope.addToAdditionDetails = function () {
        var tempIndex = scope.additionalFieldList.indexOf(scope.field.fieldName);
        this.additionalFieldList.splice(tempIndex, 1);
        scope.additionalInfo[scope.field.fieldName] = scope.field.fieldValue;
        this.field.fieldName = '';
        this.field.fieldValue = '';
    }

    scope.checkContract = function (contract_id) {
        scope.ContractAsSales = (contract_id == "9782");
        scope.filter.contract = contract_id;
        scope.selectedSource = "";
        scope.filterAppointment();
    }

    scope.filterQueue = function (selectedSource) {
        scope.$watch('selectedSource', function (term) {
            scope.filter.source = term;
            scope.filterAppointment();
        });
    }
    scope.changeSource = function (contractId, selectedSource, selectedId) {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "contractlookup/" + contractId + "|" + selectedSource + ".json", "", "GET").then(function (response) {
            scope.selectedInsurers = response.data;
            var selectedInsurersKeys = Object.keys(response.data);
            if(selectedInsurersKeys.length > 1){
                angular.forEach(selectedInsurersKeys, function(key) {
                    if(response.data[key]['id'] == selectedId){
                        var insurerObj = response.data[key];
                        scope.selectedInsurers = {};
                        scope.selectedInsurers[key] = insurerObj;
                    }
                })
            }
        });
    };
    scope.setSource = function (selectedInsurer) {
        scope.selectedInsurer = selectedInsurer;
        if (scope.selectedInsurer && scope.selectedInsurer.id){
            scope.loadEsalesPackages(scope.selectedInsurer.id);
        }else{
            scope.loadEsalesPackages('0');
        }
    };

    scope.actionRequest = function (actionType, event) {
        if ((scope.requestData.productType === 10307 || scope.requestData.productType === 10390) && scope.requestData.providerId === 177324) {
            scope.createRequestForPharma(actionType, scope.action.nextStatusId, scope.action.requestId, scope.action.statusId, scope.requestData);
        } else if (scope.requestData && scope.requestData.additionalInformation) {
            if ((scope.requestData.additionalInformation.productType === 10307 || scope.requestData.additionalInformation.productType === 10390) && scope.requestData.additionalInformation.providerId === 177324) {
                scope.createRequestForPharma(actionType, scope.action.nextStatusId, scope.action.requestId, scope.action.statusId, scope.requestData.additionalInformation);
            } else {
                scope.createRequest('Appointment', scope.action.statusId, scope.action.nextStatusId, scope.action.requestId, actionType, scope.action.spocname, scope.action.spocphone, event);
            }
        } else {
            scope.createRequest('Appointment', scope.action.statusId, scope.action.nextStatusId, scope.action.requestId, actionType, scope.action.spocname, scope.action.spocphone, event);
        }
    };

    scope.createRequestForPharma = function (actionType, nextStatusId, requestId, statusId, requestData) {
        var invoiceDetails = null;
        var remark = actionType;
        switch (actionType) {
            case 'Delivered':
                invoiceDetails = [];
                if (scope.pharmaData.cashlessAmt && scope.pharmaData.cashlessAmt >= 0 && scope.pharmaData.CODAmt && scope.pharmaData.CODAmt >= 0) {
                    var cashlessAmt = {
                        order_value: scope.pharmaData.cashlessAmt,
                        discounted_value: scope.pharmaData.cashlessAmt,
                        invoice_number: '',
                        payment_mode: 0
                    }
                    var CODAmt = {
                        order_value: scope.pharmaData.CODAmt,
                        discounted_value: scope.pharmaData.CODAmt,
                        invoice_number: '',
                        payment_mode: 1
                    }
                    invoiceDetails.push(CODAmt);
                    invoiceDetails.push(cashlessAmt);
                } else {
                    if (scope.pharmaData.cashlessAmt && scope.pharmaData.cashlessAmt >= 0) {
                        var cashlessAmt = {
                            order_value: scope.pharmaData.cashlessAmt,
                            discounted_value: scope.pharmaData.cashlessAmt,
                            invoice_number: '',
                            payment_mode: 0
                        }
                        invoiceDetails.push(cashlessAmt);
                    } else if (scope.pharmaData.CODAmt && scope.pharmaData.CODAmt >= 0) {
                        var CODAmt = {
                            order_value: scope.pharmaData.CODAmt,
                            discounted_value: scope.pharmaData.CODAmt,
                            invoice_number: '',
                            payment_mode: 1
                        }
                        invoiceDetails.push(CODAmt);
                    }
                }
                break;
            case 'OutForDelivery':
                invoiceDetails = null;
                break;
            case 'Cancel':
                invoiceDetails = null;
                remark = scope.action.cancelReason == 'Other' ? scope.action.cancelComments : scope.action.cancelReason;
                break;
            case 'ConfirmByRetailer':
                invoiceDetails = null
                break;
            default:
                invoiceDetails = null
                break;
        }
        var data = {
            key: requestData.providerId,
            response: {
                requestID: requestId,
                status: nextStatusId,
                remarks: remark,
                invoiceDetails: invoiceDetails,
                requestAccessToken: UserService.getAccessToken()
            }
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/ProviderOrderUpdate', data, 'POST').then(function (response) {
            $("#" + actionType + "Modal").modal('hide');
            scope.loadAppointments();
            scope.action = {};
        });
    };

    if (scope.user) {
        scope.isActive = true;

        scope.filterAppointment = function () {
            scope.pbqueueFiltered = scope.pbqueue;
            if (scope.filter.text)
                scope.pbqueueFiltered = filterFilter(scope.pbqueueFiltered, scope.filter.text);
            if (scope.filter.contract)
                scope.pbqueueFiltered = filterFilter(scope.pbqueueFiltered, { 'contractID': scope.filter.contract });
            if (scope.filter.source)
                scope.pbqueueFiltered = filterFilter(scope.pbqueueFiltered, { 'source': scope.filter.source });

            scope.noOfPages = scope.pbqueueFiltered.length; // Math.ceil(scope.pbqueueFiltered.length / scope.entryLimit);
            scope.pbqueueCount = scope.pbqueueFiltered.length;
        }
        

        scope.compareDate = UtilitiesService.compareDate;
        scope.showFirst = function () {
            scope.activeAppointments.length = 0;
            scope.eSalesQueueRequests.length = 0;
            scope.showDetailView = false;
            scope.defaultSet = true;
            scope.showList = true;
            scope.serverSearch = {
                fromDate: '',
                toDate: '',
                statusSearch: '',
                contractType: '',
                corporateId: ''
            };

            scope.contractsData = [];
            scope.contractsData.push({ id: '0', entityName: 'All Corporate' });
            scope.serverSearch.corporateId = { id: '0', entityName: 'All Corporate' };
            //scope.getXMLRequests();
            //get search detail
            scope.isSearchDataAvailable = UtilitiesService.getQueueSearchDetail();
            if (scope.isSearchDataAvailable) {
                //set last search values
                scope.serverSearch.fromDate = scope.isSearchDataAvailable.fromDate;
                scope.serverSearch.toDate = scope.isSearchDataAvailable.toDate;
                scope.serverSearch.contractType = scope.isSearchDataAvailable.contractType;
                if (scope.isSearchDataAvailable.contractType) {
                    var contractTypeId = scope.isSearchDataAvailable.contractType ? (scope.isSearchDataAvailable.contractType.id ? scope.isSearchDataAvailable.contractType.id : scope.isSearchDataAvailable.contractType) : '0';
                    scope.getCorporatePackages(scope.isSearchDataAvailable.contractType.id, true);
                }
                // scope.getXMLRequests(scope.isSearchDataAvailable.fromDate, scope.isSearchDataAvailable.toDate, scope.isSearchDataAvailable);
            } else {
                // scope.getXMLRequests();
            }

            scope.showDetailView = false;
            scope.showData = {};
        }
        scope.autoMapDc = function () {
            if (scope.additionalInfo.ProviderId && scope.additionalInfo.ProviderName && scope.additionalInfo.AppointmentDateTime) {
                scope.selectedDcFromDavanceSearch = { name: scope.additionalInfo.ProviderName }
                scope.isFlage.autoDcSelection = true;
                scope.isFlage.autDcSection = 'auto';
            } else {
                scope.isFlage.autoDcSelection = false;
                scope.isFlage.autDcSection = 'auto';
            }
        };
        scope.isSelectedpackage = false;
        scope.loadEsalesPackages = function (id) {
            scope.isSelectedpackage = false;
            scope.loading = true;
            scope.benefMAID = '0';
            var data = {
                ruleEngineVariable: {
                    entityRelationId: id,
                    employeeId: scope.showData.EmployeeId ? scope.showData.EmployeeId : 'PB Emp',
                    maid: scope.benefMAID,
                    loadRetailPackages: false,
                    ruleParams: { 'String': 'String' }
                },
                cartAppointment: []
            }
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/ruleengine', data, 'POST').then(function (response) {
                response.data.isSuccess = true;//Remove this once included in service
                scope.packages = [];
                scope.tests = [];
                if (response.data.isSuccess) {
                    if (response.data.ruleEnginePackages.length > 0) {
                        scope.packages = response.data.ruleEnginePackages;
                        scope.packagesObj = {};
                        scope.testsObj = {};
                        $(scope.packages).each(function (i, v) {
                            scope.packagesObj[v.peR_Id] = v;
                        })
                        $(scope.tests).each(function (i, v) {
                            scope.testsObj[v.peR_Id] = v;
                        })
                        //var mappedPackages = [{ "peR_Id": 3707756, "packageName": "Cat 4_ Non Premium - Female", "isPaid": false, "packagePrice": 2850, "serviceTax": 399, "primaryCessTax": 0, "secondaryCessTax": 0, "swachhBharatCess": 0, "krishiKalyanCess": 0, "mahsCharge": 0, "contract": { "contractId": 9782, "contractName": "E_SALES" }, "isInvestigation": false }];
                        var mappedPackages = [];

                        if (scope.displayTestDetails && scope.displayTestDetails.testDetails && scope.displayTestDetails.testDetails.length > 0) {
                            angular.forEach(scope.packages, function (index, key) {
                                angular.forEach(scope.displayTestDetails.testDetails, function (index1, key1) {
                                    //if (3707756 === index.peR_Id) {
                                    if (index1.testName === index.packageName) {
                                        mappedPackages.push(index);
                                    }
                                })
                            })
                            scope.isSelectedpackage = true;
                            scope.selectedPackageForAdvance = mappedPackages;
                            if (mappedPackages.length !== scope.displayTestDetails.testDetails.length) {
                                scope.isSelectedpackage = false;
                                var d1 = [], d2 = [];
                                scope.notMappedTest = [];
                                angular.forEach(scope.displayTestDetails.testDetails, function (index, key) {
                                    angular.forEach(mappedPackages, function (index1, key1) {
                                        if (index.testName !== index1.packageName) {
                                            d1.push(index);
                                        } else {
                                            d2.push(index);
                                        }
                                    });
                                    if (mappedPackages.length === 0) {
                                        scope.notMappedTest = scope.displayTestDetails.testDetails;
                                    } else {
                                        scope.notMappedTest = _.difference(_.uniq(d1), _.uniq(d2))
                                    }
                                });
                                UtilitiesService.showAlertMessage('All test is not matching with database, please add it manually before adding to cart.');
                            }
                            //scope.autoMapDc();
                        }
                    }
                }
                else {
                    UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                }
            });
        };

        scope.getPriceList = function (id) {
            if(id){
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'EntityProperties' + '/' + id, '', 'GET').then(function (response) {
                    if(response.data){
                        scope.entityProperties = response.data.entityProperties;
                        if(scope.entityProperties  && scope.entityProperties.length >0){
                            angular.forEach(scope.entityProperties, function(v, i){
                                if(v.propertyName ==='HVByDoctor'){
                                    scope.entityProperties[i].name = 'home visit by doctor';
                                }else if(v.propertyName ==='HVByTechnician'){
                                    scope.entityProperties[i].name = 'home visit by Technician';
                                }else if(v.propertyName ==='HVByECGTechnician'){
                                    scope.entityProperties[i].name = 'home visit by ECG Technician';
                                }
                            });
                        }
                        scope.entityPropertiesDummy = response.data.entityProperties;
                    }
                });

            }
        };
        scope.changeDc = function (value) {
            scope.selectedDcs = filterFilter(scope.diagnosticCentres, value);
        };
        scope.orderObjForUpdate = { requestId: '' };
        scope.showData = { contractID: '', source: '' };

        scope.showDndBell = false;
        scope.showDndCustomerBell = false;
        scope.parseAdditionalInfo = function(data) {
            data.requestJSON.additionalInfo = JSON.parse(data.requestJSON.additionalInfo)
            data.requestJSON.additionalInfo.DND = 
            data.requestJSON.additionalInfo.hasOwnProperty('DND') ?  JSON
            .parse(data.requestJSON.additionalInfo.DND) : false;
            data.requestJSON.additionalInfo.DNDCustomer = data.requestJSON.additionalInfo.hasOwnProperty('DNDCustomer') ? JSON.parse(data.requestJSON.additionalInfo.DNDCustomer) : false;
        }
        scope.checkForDNDFlags = function(requestData) {
            requestData.requestJSON = JSON.parse(requestData.requestJSON);
            if (requestData.requestJSON && requestData.requestJSON.additionalInfo) {
                scope.parseAdditionalInfo(requestData);
                    scope.showDndBell = requestData.requestJSON.additionalInfo.DND;
                    scope.showDndCustomerBell = requestData.requestJSON.additionalInfo.DNDCustomer 
            } else {
                requestData.requestJSON['additionalInfo'] = { DND: false, DNDCustomer: false };
                scope.showDndBell = requestData.requestJSON.additionalInfo.DND;
                scope.showDndCustomerBell = requestData.requestJSON.additionalInfo.DNDCustomer;                
            }            
        }
        scope.showDetails = function (data) {
            scope.defaultSet = false;
            scope.isDownload = false;
            scope.notMappedTest = [];
            if (data.contractID == PlusUtilitiesService.getSpecificContract("E_SALES")[0]) {
                scope.requestDataForDND = JSON.parse(JSON.stringify(data));
                scope.checkForDNDFlags(scope.requestDataForDND);
                scope.getPriceList(data.eR_ID);
                scope.displayTestDetails = data;
                scope.selectedPackageForAdvance = [];
                scope.packages = [];
                scope.markerArray = [];
                scope.isPackageSelectionAdvance = false;
                var getRequestJSON = JSON.parse(data.requestJSON);
                if (getRequestJSON.additionalInfo) {
                    var getAdditionalInfo = JSON.parse(getRequestJSON.additionalInfo);
                    scope.additionalInfo = getAdditionalInfo
                }
                var newAdditionalInfo = {};
                angular.forEach(scope.additionalInfo, function (key, value) {
                    var tempIndex = scope.additionalFieldList.indexOf(key);
                    if(tempIndex > -1) {
                        scope.additionalFieldList.splice(tempIndex, 1);
                    }
                    newAdditionalInfo[value] = key;
                });
                scope.additionalInfo = newAdditionalInfo;
                if (data.eQuote) {
                    scope.showList = false;
                    scope.showDetailView = true;
                    scope.showData = scope.equoteData[data.eQuote];
                    scope.orderObjForUpdate.requestId = scope.showData.pbrequestId;
                    scope.showData.contractID = data.contractID;
                    if (scope.showData.source == scope.coverfox_id) {
                        scope.readOnlyView = true;
                        scope.addDataToCart(data);
                    }
                    scope.changeSource(scope.showData.contractID, data.source, data.eR_ID);
                } else {
                    UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                }
                sharedDataSvc.setLocalStorageDataObj(data);
                scope.client.visitType = '';
            }
            else if (data.contractID == PlusUtilitiesService.getSpecificContract("Pre-Employment")[0]) {
                sharedDataSvc.setLocalStorageDataObj(data);
                UtilitiesService.setApptpath('queue');
                state.go('create.preemp');
            }
            else if (data.contractID == PlusUtilitiesService.getSpecificContract("Pre-Policy")[0]) {
                scope.getPriceList(data.eR_ID);
                sharedDataSvc.setLocalStorageDataObj(data);
                UtilitiesService.setApptpath('queue');
                state.go('create.prepolicy');
            }
        };

        scope.checkDuplicacy = function () {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/CheckEsalesOrderDuplicacy', scope.orderObj, 'POST').then(function (response) {
                if (response.data.isSuccess) {
                    if (response.data.isDuplicate) {
                        scope.isCart = false;
                        scope.showDetailView = false;
                        UtilitiesService.showAlertMessage('We already have appointment similar to this request, please check before you proceed.');
                    } else {
                        scope.createAppointment();
                    }
                }
                else {
                    UtilitiesService.showAlertMessage('Unable to proceed in booking order');
                }
            });
        };

        scope.loadStates = function () {
            var url = UtilitiesService.getPlusUrlPrefix('integration') + "masterdata/lookup/state.json";
            UserService.makeRestCall(url, "", "get").then(function (response) {
                if (response.data.isSuccess) {
                    scope.states = response.data.lookUpData;
                }
            });
        };

        scope.loadData = function (type, id) {
            switch (type) {
                case "city":
                    loadCities(id);
                    break;
                case "locality":
                    loadLocations(id);
                    break;
                case "sublocality":
                    loadSubLocations(id);
                    break;
                case "dc":
                    loadDCs(id);
                    break;
                default:
                    loadCities(id);
                    break;
            }
        };

        $(function () {
            scope.loadStates();
            scope.getSources();
            if (scope.isInsurer === false) {                
                // scope.getXMLRequests();
            }
            scope.isSearchDataAvailableOnLoad = UtilitiesService.getQueueSearchDetail();
            if (!(_.isEmpty(scope.isSearchDataAvailableOnLoad))) {
                //set last search values
                scope.serverSearch.fromDate = scope.isSearchDataAvailableOnLoad.fromDate;
                scope.serverSearch.toDate = scope.isSearchDataAvailableOnLoad.toDate;
                if (scope.isSearchDataAvailableOnLoad.contractType) {
                    if (typeof (scope.isSearchDataAvailableOnLoad.contractType) === 'object') {
                        var contractVal = scope.isSearchDataAvailableOnLoad.contractType.id;
                    } else {
                        var contractVal = scope.isSearchDataAvailableOnLoad.contractType;
                    }
                    scope.getCorporatePackages(contractVal, true);
                }
                scope.serverSearch.contractType = scope.isSearchDataAvailableOnLoad.contractType;
                // scope.getXMLRequests(scope.isSearchDataAvailableOnLoad.fromDate, scope.isSearchDataAvailableOnLoad.toDate, scope.isSearchDataAvailableOnLoad);
            } 
        })

        scope.validation = function () {
            var data;
            if (scope.pkgDcId || scope.testDcId) {
                data = true;
            } else {
                data = false;
            }
            return data;
        };

        scope.validateFinance = function () {
            var valid = true;
            $(".required").removeClass("required");
            if ((!scope.txn.txnNumber || scope.txn.txnNumber == "") && scope.paid) {
                valid = false;
                $("#txnNumber").addClass("required");
            }
            else {
                scope.orderObj.transactionId = scope.txn.txnNumber;
            }
            return valid;
        };

        function loadStates() {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + "masterdata/lookup/state.json", "", "get").then(function (response) {
                if (response.data.isSuccess) {
                    scope.states = response.data.lookUpData;
                    scope.states = orderByFilter(scope.states, 'lookUpValue', scope.reverse);
                }
            });
        };

        function loadCities(newstateId) {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "masterdata/lookup/district/" + newstateId + ".json", "", "get").then(function (response) {
                if (response.data.isSuccess) {
                    scope.cities = response.data.lookUpData;
                    scope.cities = orderByFilter(scope.cities, 'lookUpValue', scope.reverse);
                }
            });
        };

        function loadLocations(newcityId) {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "masterdata/lookup/city/" + newcityId + ".json", "", "get").then(function (response) {
                if (response.data.isSuccess) {
                    scope.locations = response.data.lookUpData;
                    scope.locations = orderByFilter(scope.locations, 'lookUpValue', scope.reverse);
                }
            });
        };

        function loadSubLocations(newlocationId) {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "masterdata/lookup/location/" + newlocationId + ".json", "", "get").then(function (response) {
                if (response.data.isSuccess) {
                    scope.sublocations = response.data.lookUpData;
                    scope.sublocations = orderByFilter(scope.sublocations, 'lookUpValue', scope.reverse);
                }
            });
        };

        scope.calculatePrice = function(){
            var totalPrice =0;
            if(scope.entityProperties){
                angular.forEach(scope.entityProperties, function(v,i){
                    if(v.propertySelected){
                        totalPrice = totalPrice + parseInt(v.propertyValue);
                    }
                });
            }
            return totalPrice;
        };
        scope.calculatePriceData = function(){
            var totalPriceData = {};
            if(scope.entityProperties){
                angular.forEach(scope.entityProperties, function(v,i){
                    if(v.propertySelected){
                        totalPriceData[v.propertyName] = v.propertyValue;
                    }
                });
            }
            return totalPriceData;
        };

        scope.isShowPriceList = false;
        scope.visitTypeChange = function (value) {
            scope.client.visitType = value;
            scope.entityProperties = [];
            if(value ==='Home_Visit'){
                scope.entityProperties = scope.entityPropertiesDummy;
                scope.isShowPriceList = true;
            }else{
                scope.isShowPriceList = false;
            }
        };

        scope.loadCities = function (selectedState) {
            scope.selectedState = selectedState;
            if (scope.selectedState) {
                if (scope.selectedState.lookUpId) {
                    scope.location.state = scope.selectedState.lookUpId
                    var url = UtilitiesService.getPlusUrlPrefix() + "masterdata/lookup/district/" + scope.selectedState.lookUpId + ".json";
                    UserService.makeRestCall(url, "", "get").then(function (response) {
                        if (response.data.isSuccess) {
                            scope.cities = response.data.lookUpData;
                            scope.citiesObj = {}
                            $(scope.cities).each(function (i, v) {
                                scope.citiesObj[v.lookUpId] = v;
                            })
                            scope.cities = orderByFilter(scope.cities, 'lookUpValue', scope.reverse);
                        }
                    });
                }
            }
        };
        
        scope.loadLocations = function (selectedCity) {
            scope.selectedCity = selectedCity;
            if (scope.selectedCity) {
                if (scope.selectedCity.lookUpId) {
                    scope.location.city = scope.selectedCity.lookUpId;
                    var url = UtilitiesService.getPlusUrlPrefix() + "masterdata/lookup/city/" + scope.selectedCity.lookUpId + ".json";
                    UserService.makeRestCall(url, "", "get").then(function (response) {
                        if (response.data.isSuccess) {
                            scope.locations = response.data.lookUpData;
                            scope.locations = orderByFilter(scope.locations, 'lookUpValue', scope.reverse);
                        }
                    });
                }
            }
        };
        scope.loadSubLocations = function (selectedLocation) {
            scope.selectedLocation = selectedLocation;
            if (scope.selectedLocation) {
                if (scope.selectedLocation.lookUpId) {
                    scope.location.location = scope.selectedLocation.lookUpId;
                    var url = UtilitiesService.getPlusUrlPrefix() + "masterdata/lookup/location/" + scope.selectedLocation.lookUpId + ".json";
                    UserService.makeRestCall(url, "", "get").then(function (response) {
                        if (response.data.isSuccess) {
                            scope.sublocations = response.data.lookUpData;
                            scope.sublocations = orderByFilter(scope.sublocations, 'lookUpValue', scope.reverse);
                        }
                    });
                }
            }
        };

        scope.loadCitiesNew = function (selectedState) {
            scope.selectedState = selectedState;
            if (scope.selectedState) {
                if (scope.selectedState.lookUpId) {
                    scope.location.state = scope.selectedState.lookUpId
                    var url = UtilitiesService.getPlusUrlPrefix() + "masterdata/lookuplevel/" + scope.selectedState.lookUpId + "/2";
                    UserService.makeRestCall(url, "", "get").then(function (response) {
                        if (response.data.isSuccess) {
                            scope.cities = response.data.lookUpData;
                            scope.citiesObj = {}
                            $(scope.cities).each(function (i, v) {
                                scope.citiesObj[v.lookUpId] = v;
                            })
                            scope.cities = orderByFilter(scope.cities, 'lookUpValue', scope.reverse);
                        }
                    });
                }
            }
        };

        scope.loadLocationsNew = function (selectedLocation) {
            scope.selectedLocation = selectedLocation;
            if (scope.selectedLocation) {
                if (scope.selectedLocation.lookUpId) {
                    scope.location.location = scope.selectedLocation.lookUpId;
                    var url = UtilitiesService.getPlusUrlPrefix() + "masterdata/lookup/location/" + scope.selectedLocation.lookUpId + ".json";
                    UserService.makeRestCall(url, "", "get").then(function (response) {
                        if (response.data.isSuccess) {
                            scope.sublocations = response.data.lookUpData;
                            scope.sublocations = orderByFilter(scope.sublocations, 'lookUpValue', scope.reverse);
                        }
                    });
                }
            }
        };

        scope.loadDCs = function (sublocationId) {
            if (sublocationId) {
                var erTypeName = "DC_MediAssist"
                var ERTypeId = PlusUtilitiesService.getDC_MA_ContractID(); // DC_mediassist
                var serviceBrokerId = "1000042"; //mediassist
                var serviceBrokerName = "Medi Assist";
                var Entity_Type = "4653"; //lookup call Entity_Type
                var PM_TypeId = PlusUtilitiesService.getDC_Inv_PmTypeId(); // pm type id for investigations
                scope.location.sublocation = sublocationId;
                var url = UtilitiesService.getPlusUrlPrefix() + "EntityRelation/Search/EntitySearch/" + ERTypeId + "/" + serviceBrokerId + "/" + 0 + "/" + scope.location.state + "/" + scope.location.city + "/" + scope.location.location + "/" + scope.location.sublocation + ".json";
                UserService.makeRestCall(url, "", "get").then(function (response) {
                    if (response.statusText == "OK") {
                        if (scope.allowedPackages) {
                            scope.diagnosticCentres = $.map(response.data, function (i) {
                                if (scope.allowedPackages && scope.allowedPackages.indexOf(i.id) != -1) {
                                    return i
                                }
                            });
                            scope.dcObj = scope.diagnosticCentres;
                            scope.dcObj = orderByFilter(scope.dcObj, 'lookUpValue', scope.reverse);
                        } else {
                            UtilitiesService.showAlertMessage('Please select package.');
                        }
                    }
                });
            }
        };

        scope.isDone = false;
        scope.orderIdNumber = '';
        scope.cancelPopup = function () {
            scope.orderDetails = '';
        };
        scope.deleteOrderEueue = function (flag, value) {
            scope.orderDetails = value;
            if (flag) {
                scope.orderIdNumber = scope.orderDetails.id;
                var data = { "requestId": scope.orderDetails.id };
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/InActivePolicyBazaar", data, "PUT", UserService.getAccessToken(), true).then(function (list) {
                    scope.isDone = true;
                    $("#deleteRequest").modal("hide");
                    scope.orderDetails = '';
                    timeout(function () {
                        scope.isDone = false;
                        scope.orderIdNumber = '';
                    }, 1000);
                    // scope.getXMLRequests();
                });
            } else {
                scope.actionName1 = 'deleteRequest';
            }
        };

        scope.changePackage = function (peR_Id) {
            if (peR_Id) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/CorporatePackageProvider/" + peR_Id + "/false.json", "", "GET").then(function (list) {
                    scope.allowedPackages = list.data;
                });
            }
            else {
                // console.log("peR_Id not provided");
            }
        };

        var erTypeName = 'DC_MediAssist';
        var ERTypeId = PlusUtilitiesService.getDC_MA_ContractID(); // DC_mediassist
        var serviceBrokerId = '1000042';//mediassist
        var serviceBrokerName = 'Medi Assist';
        var Entity_Type = '4653'; //lookup call Entity_Type
        var PM_TypeId = PlusUtilitiesService.getDC_Inv_PmTypeId(); // pm type id for investigations
        function loadDCs(type) {
            if (type == "package") {
                var url = UtilitiesService.getPlusUrlPrefix() + "EntityRelation/Search/EntitySearch/" + ERTypeId + "/" + serviceBrokerId + "/" + 0 + "/" + scope.pkgStateId + "/" + scope.pkgCityId + "/" + scope.pkgLocalityId + "/" + scope.pkgSubLocalityId + ".json";
            }
            else if (type == "test") {
                var url = UtilitiesService.getPlusUrlPrefix() + "EntityRelation/Search/EntitySearch/" + ERTypeId + "/" + serviceBrokerId + "/" + 0 + "/" + scope.testStateId + "/" + scope.testCityId + "/" + scope.testLocalityId + "/" + scope.testSubLocalityId + ".json";
            }
            UserService.makeRestCall(url, "", "get").then(function (response) {
                if (response.statusText == "OK") {
                    scope.allDCs = response.data;
                    if (type == "package") {
                        scope.diagnosticCentres = $.map(response.data, function (i) { if (scope.allowedPackages.indexOf(i.id) != -1) { return i } })
                    }
                    else {
                        scope.diagnosticCentres = response.data
                    }
                    scope.dcObj = {};
                    $(scope.diagnosticCentres).each(function (i, v) {
                        scope.dcObj[v.id] = v;
                    })
                    scope.dcObj = orderByFilter(scope.dcObj, 'lookUpValue', scope.reverse);
                }
            });
        };

        scope.getFormattedDateTime = function (xdate, xtime) {
            var ydate = new Date(parseInt(xdate.replace("/Date(", "").replace(")/", ""), 10))
            var formattedDate = ydate.getFullYear() + "/" + (ydate.getMonth() + 1) + "/" + ydate.getDate() + " " + xtime.trim().split(" ")[0];
            return formattedDate;
        };

        scope.addDataToCart = function (data) {
            var jsonData = JSON.parse(data.requestJSON);
            var data = data;
            var selectedPackageData = {};
            scope.loading = true;
            var data = {
                ruleEngineVariable: {
                    entityRelationId: data.eR_ID,
                    employeeId: jsonData.EmployeeId ? jsonData.EmployeeId : 'PB Emp',
                    maid: 0,
                    loadRetailPackages: false,
                    ruleParams: { 'String': 'String' }
                },
                cartAppointment: []
            }
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/ruleengine', data, 'post').then(function (response) {
                response.data.isSuccess = true;//Remove this once included in service
                if (response.data.isSuccess) {
                    if (response.data.ruleEnginePackages.length > 0) {
                        var packageData = response.data.ruleEnginePackages;
                        $(jsonData.TestDetails).each(function (i, v) {
                            $(packageData).each(function (i1, v1) {
                                if (v1.peR_Id == v.TestID) {
                                    selectedPackageData = v1;
                                }
                            });
                            //console.log(selectedPackageData)                      
                        });
                    }
                }
                else {
                    UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                }
            });
        };

        scope.selectDc = function (id) {
            scope.pkgDcId = _.where(scope.dcObj, { id: parseInt(id) });
        };

        scope.selectDcIdFortest = function (id) {
            scope.testDcId = _.where(scope.dcObj, { id: parseInt(id) });
        };

        scope.removeOrderItem = function (item, event) {
            scope.totalPrice -= item.amount;
            var index = scope.orderObj.orderItems.indexOf(item);
            scope.CartAppointments.splice(index, 1);
            scope.packages = [];
            scope.selectedPackage = {};
            scope.orderObj.orderItems.splice(index, 1);
            var flag = 0;
            if (scope.orderObj.orderItems.length > 0) {
                $(scope.orderObj.orderItems).each(function (i, v) {
                    if (v.isPaid) {
                        flag++;
                    }
                })
                if (flag != 0) {
                    scope.showPaid = true;
                } else {
                    scope.showPaid = false;
                }
            } else {
                scope.cartEmpty = true;
                scope.showPaid = false;
            }
        };

        scope.getDob = function(input){
            var dateofbirth = '01/01/1000 00:00:00';
            if(input && input.additionalInfo){
                var additionalInfo = JSON.parse(input.additionalInfo);
                if(additionalInfo.DOB || additionalInfo.dob){
                    if(additionalInfo.DOB){
                        var dateofbirth = new Date(additionalInfo.DOB);
                    }else if(additionalInfo.dob){
                      var dateofbirth =  new Date(additionalInfo.dob);
                    }
                }else{
                    var dateofbirth =  new Date(dateofbirth);
                }
            }else{
                var dateofbirth =  new Date(dateofbirth);
            }
            return dateofbirth;
        };

        scope.addToCart = function (type, SelectedPeRId) {
            scope.totalPrice = 0;
            scope.pkgSelectedTime = UtilitiesService.mergeDateTimeObj(scope.client.secondPrefTime, scope.userTime.secondAppointmentTime);
            scope.testSelectedTime = UtilitiesService.mergeDateTimeObj(scope.client.TestPrefTime, scope.userTime.testAppointmentTime);
            switch (type) {
                case "package":
                    if (!scope.packagesObj) {
                        UtilitiesService.showAlertMessage('Please select package.');
                        return;
                    }
                    scope.selectedPackage = scope.packagesObj[SelectedPeRId];
                    scope.selectedDCId = _.first(scope.pkgDcId).id;
                    scope.selectedDcName = _.first(scope.pkgDcId).entityName;
                    scope.selectedDcCity = _.first(scope.pkgDcId).city.cityName;
                    scope.selectedDcLocation = _.first(scope.pkgDcId).location.locationName;
                    scope.selectedTime = scope.pkgSelectedTime;
                    break;
                case "test":
                    scope.selectedPackage = scope.testsObj[SelectedPeRId];
                    scope.selectedDCId = _.first(scope.testDcId).id;
                    scope.selectedDcName = _.first(scope.testDcId).entityName;
                    scope.selectedDcCity = _.first(scope.pkgDcId).city.cityName;
                    scope.selectedDcLocation = _.first(scope.pkgDcId).location.locationName;
                    scope.selectedTime = scope.testSelectedTime;
                    break;
                case 'auto':
                    scope.selectedDCId = scope.additionalInfo.ProviderId;
                    scope.selectedDcName = scope.additionalInfo.ProviderName;
                    scope.selectedDcCity =  'AUTO BOOKED';
                    scope.selectedDcLocation = 'AUTO BOOKED';
                    scope.selectedTime = scope.additionalInfo ? scope.additionalInfo.AppointmentDateTime ? new Date(scope.additionalInfo.AppointmentDateTime) : new Date() : new Date();
                    break;
                default:
                    break
            }
            if (scope.additionalInfo) {
                scope.additionalInfo.annualPremium = scope.annualPremium ? scope.annualPremium : ''
                scope.additionalInfo.sumAssured = scope.sumassuredetail.sumAssured ? scope.sumassuredetail.sumAssured : '';
                scope.additionalInfo.paidSpons = scope.sumassuredetail.paidSpons ? scope.sumassuredetail.paidSpons : '';
                scope.additionalInfo.policyType = scope.sumassuredetail.grpIndv ? scope.sumassuredetail.grpIndv : '';
                scope.additionalInfo.DNDCustomer =  scope.dndCustomer === true ? true : false;
                scope.additionalInfo['id'] = scope.requestDataForDND && scope.requestDataForDND.id ? scope.requestDataForDND.id : null;

            } else {
                scope.additionalInfo = {
                    annualPremium: scope.annualPremium ? scope.annualPremium : '',
                    sumAssured: scope.sumassuredetail.sumAssured ? scope.sumassuredetail.sumAssured : '',
                    paidSpons: scope.sumassuredetail.paidSpons ? scope.sumassuredetail.paidSpons : '',
                    policyType : scope.sumassuredetail.grpIndv ? scope.sumassuredetail.grpIndv : '',
                    DNDCustomer :  scope.dndCustomer === true ? true : false,
                    id : scope.requestDataForDND && scope.requestDataForDND.id ? scope.requestDataForDND.id : null
                }
            }
            if (scope.validation()) {
                if (!scope.selectedPackage) {
                    UtilitiesService.showAlertMessage('Please select package.');
                    return;
                }
                if (scope.selectedPackage.isPaid === true) {
                    scope.totalPrice += Math.round((scope.selectedPackage.packagePrice +
                                          scope.selectedPackage.serviceTax +
                                          scope.selectedPackage.primaryCessTax +
                                          scope.selectedPackage.secondaryCessTax +
                                          scope.selectedPackage.mahsCharge) * 100) / 100;
                }
                scope.orderItemObj = {
                    productId: scope.selectedPackage.peR_Id,
                    productName: scope.selectedPackage.packageName,
                    productType: scope.selectedPackage.contract.contractId,
                    preferredDC: [
                        {
                            id: scope.selectedDCId,
                            name: scope.selectedDcName,
                            ProviderCity: scope.selectedDcCity,
                            ProviderLocation: scope.selectedDcLocation,
                            firstPrefTime: scope.selectedTime
                        }
                    ],
                    priEntityId: 0,
                    secEntityId: 0,
                    firstName: scope.showData.name,
                    contactNum: scope.showData.mobileNumber,
                    isPaid: false,
                    isSponsored: true,
                    amount: Math.round((scope.selectedPackage.packagePrice +
                                scope.selectedPackage.serviceTax +
                                scope.selectedPackage.primaryCessTax +
                                scope.selectedPackage.secondaryCessTax +
                                scope.selectedPackage.mahsCharge) * 100) / 100,
                    MAID: scope.showData.employeeId ? scope.showData.employeeId : 0,
                    relation: 'NA',
                    city: scope.showData.city,
                    dob: scope.getDob(scope.showData),
                    gender: scope.genderList.gender ? scope.genderList.gender : 'NA',
                    employeeId: scope.additionalInfo.ProposalNumber ? scope.additionalInfo.ProposalNumber : scope.showData.employeeId,
                    source: scope.showData.source,
                    invoiceTo: scope.showData.invoiceTo,
                    visitType: scope.client.visitType ? scope.client.visitType : 'Appointment',
                    emailId: scope.showData.emailId,
                    additionalProperties: scope.additionalInfo ? scope.additionalInfo : ''
                }

                if (Object.keys(scope.orderObj).length == 0) {
                    scope.orderObj = {
                        createdByApp: 'DCPortal| Policy Bazaar',
                        amountAfterDiscount: scope.totalPrice + scope.calculatePrice(),
                        actualAmount: scope.totalPrice,
                        paymentMode: 'IndividualPaid',
                        aymentState: 'Unpaid',
                        accountNumber: scope.txn.accnumber,
                        bankIfscCode: scope.txn.ifsccode,
                        transactionId: scope.txn.txnNumber,
                        employeeId: scope.additionalInfo.ProposalNumber ? scope.additionalInfo.ProposalNumber : scope.showData.employeeId,
                        entityId: scope.selectedInsurer.id,
                        entityName: scope.selectedInsurer.entityName,
                        employeeName: scope.showData.name,
                        contractId: scope.policyBazaarRequestsContractId,
                        employeeEmail: scope.showData.emailId,
                        employeeContactNo: scope.showData.mobileNumber,
                        source: scope.showData.source,
                        orderItems: [
                            scope.orderItemObj
                        ],
                        paymentSuccessUrl: 'www.mahs.in',
                        paymentFailureUrl: 'www.mediassistindia.com',
                        requestAccessToken: UserService.getAccessToken(),
                        additionals: scope.calculatePriceData()
                    }
                    scope.cartEmpty = false;
                }
                else {
                    scope.orderObj.actualAmount = scope.totalPrice;
                    scope.orderObj.orderItems.push(scope.orderItemObj);
                }
                angular.forEach(scope.orderObj.orderItems, function (item, index) {
                    if (item.isPaid) {
                        scope.showPaid = true;
                    }
                });
                scope.cartEmpty = false;
                $("select").val('');
            }
            else {
                if (scope.selectedPackageForAdvance.length > 0) {
                    scope.orderItemList = [];
                    angular.forEach(scope.selectedPackageForAdvance, function (data, index) {
                        scope.totalPrice += Math.round((parseInt(data.packagePrice) +
                        parseInt(data.serviceTax) +
                        parseInt(data.primaryCessTax) +
                        parseInt(data.secondaryCessTax) +
                        parseInt(data.mahsCharge)) * 100) / 100;
                        scope.orderItemList.push({
                            productId: data.peR_Id,
                            productName: data.packageName,
                            productType: data.contract.contractId,
                            preferredDC: [
                                {
                                    id: scope.isFlage.autDcSection === 'auto' ? scope.selectedDCId : scope.selectedDcFromDavanceSearch.id,
                                    name: scope.isFlage.autDcSection === 'auto' ? scope.selectedDcName : scope.selectedDcFromDavanceSearch.entityName,
                                    ProviderCity: scope.isFlage.autDcSection === 'auto' ? scope.selectedDcCity : scope.selectedDcFromDavanceSearch.city.cityName,
                                    ProviderLocation: scope.isFlage.autDcSection === 'auto' ? scope.selectedDcLocation : scope.selectedDcFromDavanceSearch.location.locationName,
                                    firstPrefTime: scope.isFlage.autDcSection === 'auto' ? scope.selectedTime : scope.firstPrefTime
                                }
                            ],
                            priEntityId: 0,
                            secEntityId: 0,
                            firstName: scope.showData.name,
                            contactNum: scope.showData.mobileNumber,
                            isPaid: false,
                            isSponsored: true,
                            amount: Math.round((data.packagePrice +
                                        data.serviceTax +
                                        data.primaryCessTax +
                                        data.secondaryCessTax +
                                        data.mahsCharge) * 100) / 100,
                            MAID: scope.showData.employeeId ? scope.showData.employeeId : 0,
                            relation: 'NA',
                            city: scope.showData.city,
                            dob: scope.getDob(scope.showData),
                            gender: scope.genderList.gender ? scope.genderList.gender : 'NA',
                            employeeId: scope.additionalInfo.ProposalNumber ? scope.additionalInfo.ProposalNumber : scope.showData.employeeId,
                            source: scope.showData.source,
                            invoiceTo: scope.showData.invoiceTo,
                            visitType: scope.client.visitType ? scope.client.visitType : 'Appointment',
                            emailId: scope.showData.emailId,
                            additionalProperties: scope.additionalInfo ? scope.additionalInfo : ''
                        })
                    });
                    if (scope.showData.name) {
                        scope.orderObj = {
                            createdByApp: 'DCPortal| Policy Bazaar',
                            amountAfterDiscount: scope.totalPrice + scope.calculatePrice(),
                            actualAmount: scope.totalPrice,
                            paymentMode: 'IndividualPaid',
                            paymentState: 'Unpaid',
                            accountNumber: scope.txn.accnumber,
                            bankIfscCode: scope.txn.ifsccode,
                            transactionId: scope.txn.txnNumber,
                            employeeId: scope.additionalInfo.ProposalNumber ? scope.additionalInfo.ProposalNumber : scope.showData.employeeId,
                            entityId: scope.selectedInsurer.id,
                            entityName: scope.selectedInsurer.entityName,
                            employeeName: scope.showData.name,
                            contractId: scope.policyBazaarRequestsContractId,
                            employeeEmail: scope.showData.emailId,
                            employeeContactNo: scope.showData.mobileNumber,
                            source: scope.showData.source,
                            orderItems: scope.orderItemList,
                            paymentSuccessUrl: 'www.mahs.in',
                            paymentFailureUrl: 'www.mediassistindia.com',
                            requestAccessToken: UserService.getAccessToken(),
                            additionals: scope.calculatePriceData()
                        }
                        if (scope.isFlage.autDcSection === 'auto') {
                            scope.cartEmpty = false;
                            scope.isCart = true;
                        } else {
                            scope.cartEmpty = false;
                            scope.isCart = false;
                        }

                    } else {
                        UtilitiesService.showAlertMessage('Please fill customer details.');
                    }
                }
            }
        };
        
        scope.updateProcessedStatus = function (requestId, orderId) {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/IsProcessedPolicyBazaar/" + requestId + "/" + orderId, "", "GET", UserService.getAccessToken(), true).then(function (response) {
                scope.showFirst();
                scope.showSuccessMessage = true;
                scope.orderObj = {};
                scope.orderItemObj = {};
                scope.totalPrice = 0;
                scope.cartEmpty = true;
                scope.showAddTestBox = false;
            }, function (error) {
                UtilitiesService.showAlertMessage('PolicyBazaar request could not be updated.');
            })
        };
        scope.isOrderCreated = false;

        scope.createAppointment = function () {
            scope.isCart = false;
            if ((!scope.showPaid || scope.validateFinance()) && scope.paid) {
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/order', scope.orderObj, 'POST').then(function (response) {
                    scope.showDetailView = false;
                    scope.entityProperties = [];
                    scope.client = {};
                    if (response.data.isSuccess) {
                        scope.orderData = response.data;
                        scope.additionalFieldList = ['hrLocation', 'hrMobileNumber', 'hrName', 'AgentEmailId', 'AgentName', 'AgentContactNo',
                        'Entity', 'CaseType', 'Aadhar', 'PAN', 'packageOrGrade', 'lifeno', 'clientLocation','SMName', 'SM_Email', 'SMPhoneNumber'];
                        if (scope.orderObjForUpdate.requestId) {
                            scope.updateProcessedStatus(scope.orderObjForUpdate.requestId, scope.orderData.orderId);
                            scope.isOrderCreated = true;
                            var html = 'Order created successfully. ' + scope.orderData.orderId + '.';
                            window.scrollTo(0, 0);
                            timeout(function () {
                                scope.isOrderCreated = false;
                            }, 6000);
                            UtilitiesService.showAlertMessage(html, true);
                        }
                        else {
                            scope.showFirst();
                            scope.showSuccessMessage = true;
                            scope.orderObj = {};
                            scope.orderItemObj = {};
                            scope.totalPrice = 0;
                            scope.cartEmpty = true;
                            scope.showAddTestBox = false;
                        }
                    }
                    else {
                        scope.isOrderCreated = false;
                        UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                    }
                });
            }
            else if ((!scope.showPaid || scope.validateFinance()) && !scope.paid) {
                scope.cart_order = {}
                scope.cart_order = { 'order': scope.orderObj }
                UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/cart', scope.cart_order, 'POST').then(function (response) {
                    if (response.data.isSuccess) {
                        scope.orderData = response.data;
                        if (scope.showData.pbrequestId) {
                            scope.updateProcessedStatus(scope.showData.pbrequestId, scope.orderData.orderId);
                        }
                        else {
                            scope.showFirst();
                            scope.showSuccessMessage = true;
                            scope.orderObj = {};
                            scope.orderItemObj = {};
                            scope.totalPrice = 0;
                            scope.cartEmpty = true;
                            scope.showAddTestBox = false;
                        }
                    }
                    else {
                        UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                    }
                });
            }
            else {
                UtilitiesService.showAlertMessage('Transaction details are mandatory as order contains paid packages.');
                //console.log("Transaction details are mandatory as order contains paid packages");
            }
        };
    };

    scope.loadDcForAllPackages = function (newSubLocationId) {
        var perIdsList = [];
        angular.forEach(scope.selectedPackageForAdvance, function (e, i) {
            perIdsList.push(e.peR_Id);
        });
        if (scope.location.state && scope.location.location && newSubLocationId) {
            var data = {
                packageIds: perIdsList,
                stateId: scope.location.state,
                cityId: scope.location.location,
                locationId: newSubLocationId
            };
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'AllEligibleDCByPackageIdsAndByLocation', data, 'POST').then(function (response) {
                if (response.data.length > 0) {
                    scope.diagnosticCentres = response.data;
                } else {
                    UtilitiesService.showAlertMessage('No Diagnostic Centre found.');
                }
            }, function (error) {
                UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
            });
        }
    };

    scope.distances = constant.distances;
    scope.windowOptions = {};
    scope.radious = {
        distance: 2,
        lat: '',
        lng: ''
    };

    scope.loadDcList = function (lat, lng) {
        var perIdsList = [];
        angular.forEach(scope.selectedPackageForAdvance, function (e, i) {
            perIdsList.push(e.peR_Id);
        });
        scope.markerArray = [];
        if (lat && lng) {
            scope.radious.lat = lat;
            scope.radious.lng = lng;
            var data = {
                packageIds: perIdsList,
                latitude: lat,
                longitude: lng,
                distance: scope.radious.distance,
            };
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'AllEligibleDCByPackageIdsAndByLocation', data, 'POST').then(function (response) {
                if (response.data.length > 0) {
                    scope.isMarkerArray = false;
                    scope.advanceDcList = response.data;
                    angular.forEach(scope.advanceDcList, function (data, index) {
                        scope.markerArray.push({
                            id: scope.advanceDcList[index].id,
                            entityAddress: scope.advanceDcList[index].entityAddress,
                            pinCode: scope.advanceDcList[index].pinCode,
                            coords: {
                                latitude: scope.advanceDcList[index].latitude,
                                longitude: scope.advanceDcList[index].longitude,
                            },
                            entityName: scope.advanceDcList[index].entityName,
                            marker: false
                        });
                        scope.windowOptions[scope.advanceDcList[index].id] = {
                            visible: false,
                        }
                    })
                    scope.map = {
                        center: {
                            latitude: scope.lat,
                            longitude: scope.lng
                        },
                        stroke: {
                            color: '#08B21F',
                            weight: 2,
                            opacity: 1
                        },
                        fill: {
                            color: '#08B21F',
                            opacity: 0.5
                        },
                        markersEvents: {
                            click: function (marker, eventName, model, arguments) {
                                angular.forEach(scope.markerArray, function (data, index) {
                                    if (parseInt(data.id) === parseInt(marker.key)) {
                                        scope.markerArray[index].visible = true;
                                    } else {
                                        scope.markerArray[index].visible = false;
                                    }
                                })
                            }
                        },
                        window: {
                            marker: {},
                            show: false,
                            closeClick: function (value) {
                                this.show = false;
                            },
                            options: {},
                            title: ''
                        },
                        radius: 10,
                        geodesic: true,
                        visible: true,
                        zoom: 12
                    }
                } else {
                    scope.isMarkerArray = true;
                    scope.markerArray = [];
                    UtilitiesService.showAlertMessage('No Diagnostic Centre found.');
                }
            }, function (error) {
                UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            });
        }
    };
    // scope.showFirst = function(){
        
    // };

    scope.isShowDcNote = false;
    scope.selectedDcFromMap = function (markerObj, $event) {
        if (markerObj) {
            scope.isShowDcNote = true;
            scope.selectedDcFromDavanceSearch = markerObj;
            scope.windowParams.list = scope.selectedDcFromDavanceSearch;
        } else {
            scope.isShowDcNote = false;
            scope.selectedDcFromDavanceSearch = '';
            scope.windowParams.list = scope.selectedDcFromDavanceSearch;
        }
    };

    scope.closeCart = function () {
        scope.isCart = !scope.isCart;
    };

    scope.$on('gmPlacesAutocomplete::placeChanged', function (key, value) {
        if (value && value._api) {
            var location = value._api.getPlace().geometry.location;
            scope.lat = location.lat();
            scope.lng = location.lng();
            scope.$apply();
            scope.loadDcList(scope.lat, scope.lng);
        }
    });


    scope.DCSelection = function (vlaue) {
        scope.isPackageSelectionManual = vlaue === 'manula' ? true : false;
        scope.isPackageSelectionAdvance = vlaue === 'advance' ? true : false;
        scope.isFlage.autDcSection = '';
        scope.locationName.autocomplete = '';
        scope.markerArray = [];
        scope.advanceDcList = [];
        scope.diagnosticCentres = [];
        scope.client.preferredDC1 = '';
        scope.manual.firstDate = '';
        scope.manual.secondDate = '';
    };

    scope.bookAppointmentDate = function (firstDate, secondDate, firstTime, secondTime) {
        if (scope.showData.name) {
            scope.firstPrefTime = UtilitiesService.mergeDateTimeObj(scope.manual.firstDate, scope.manual.firstTime);
            scope.addToCart(firstDate, firstTime, secondDate, secondTime);
            scope.isCart = !scope.isCart;
        } else {
            UtilitiesService.showAlertMessage('Please fill customer details.');
        }
    };

    scope.autoDCSelection = function () {
        scope.isPackageSelectionManual = false;
        scope.isPackageSelectionAdvance = false;
        scope.isFlage.autDcSection = 'auto';
        scope.addToCart('auto');
    };
    //Event Listner for close marker in google map
    scope.windowParams = {
        list: scope.selectedDcFromDavanceSearch,
        doIt: function (markerDetails) {
            if (scope.manual.firstDate) {
                scope.bookAppointmentDate(scope.manual.firstDate, scope.manual.secondDate, scope.manual.firstTime, scope.manual.secondTime);
            } else {
                UtilitiesService.showAlertMessage('Please select appointment date.');
            }
        }
    }
    UserService.saleQueueDataCollection = [];
    scope.$watch('eSaleQueue', function (current, old) {
        if (current) {
            scope.pbqueue = UserService.GeteSaleQuebe(current);
        } else {
            if (old) {
                scope.pbqueue = UserService.saleQueueDataCollection;
            }
        }
    });

    scope.filterDate = function (fromDateFilterValue, toDateFilterValue) {
        if ((fromDateFilterValue && !toDateFilterValue) || (!fromDateFilterValue && toDateFilterValue)) {
            UtilitiesService.showAlertMessage('You missed start or end date!');
            return false;
        }
        if (fromDateFilterValue && toDateFilterValue) {
            scope.tempPb = [];
            scope.pbqueueCompare = scope.filterDateData;

            scope.fromDateFilterValue = fromDateFilterValue;
            var getfullfromDate = fromDateFilterValue.getFullYear() + '-' + fromDateFilterValue.getMonth() + 1 + '-' + fromDateFilterValue.getDate();
            var date = moment(getfullfromDate)
            scope.filter.dateFilterFrom = date;

            scope.toDateFilterValue = toDateFilterValue;
            var getfullToDate = toDateFilterValue.getFullYear() + '-' + toDateFilterValue.getMonth() + 1 + '-' + toDateFilterValue.getDate();
            var dateTo = moment(getfullToDate)
            scope.filter.dateFilterTo = dateTo;

            if (scope.filter.dateFilterFrom && scope.filter.dateFilterTo) {
                angular.forEach(scope.pbqueueCompare, function (item) {
                    var objDate = '';
                    var num = item.dateTimeCreated.match(/\d+/g); //regex to extract numbers 
                    var date = new Date(parseFloat(num)); //converting to date
                    var objDate = date.getFullYear() + '-' + date.getMonth() + 1 + "-" + date.getDate();
                    var objDateFormat = moment(objDate)

                    if ((scope.filter.dateFilterFrom <= objDateFormat) && (objDateFormat <= scope.filter.dateFilterTo)) {
                        scope.tempPb.push(item);
                    }
                });
                // console.log(scope.tempPb.length);
                scope.pbqueue = scope.tempPb;
            }
        }
    }

    scope.dateFilterDate = {
        fromDateFilter: '',
        toDateFilter: ''
    }

    //Date Object
    scope.today = function () {
        scope.client.secondPrefTime = new Date();
        scope.client.firstPrefTime = new Date();
        scope.dt = new Date();
    };
    scope.today();

    // Disable weekend selection
    function disabled(data) {
        var date = data.date,
          mode = data.mode;
        return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    }

    scope.dateOptions = {
        dateDisabled: disabled,
        formatYear: 'yy',
        minDate: new Date(),
        startingDay: 1
    };

    scope.dateOptionsDob = {
        //dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(),
        //minDate: new Date(),
        startingDay: 1
    };
    scope.dateDefautOptions = {
        formatYear: 'yy',
        minDate: scope.dateFilterDate.fromDateFilter,
        startingDay: 1
    };

    scope.open1 = function () {
        scope.popup1.opened = true;
    };

    scope.open2 = function () {
        scope.popup2.opened = true;
    };

    scope.open5 = function () {
        scope.popup5.opened = true;
    };

    scope.open6 = function () {
        scope.popup6.opened = true;
    };
    //prePolicy
    scope.popup3 = {
        opened: ''
    }
    scope.open = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();

        scope.popup3.opened = true;
    };

    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];

    scope.popup1 = {
        opened: false
    };

    scope.popup2 = {
        opened: false
    };

    scope.popup5 = {
        opened: false
    };

    scope.popup6 = {
        opened: false
    };

    scope.userTime = {
        firstAppointmentTime: '',
        secondAppointmentTime: '',
        testAppointmentTime: ''
    }
    //Set Time Object
    var first = new Date();
    var dd = new Date(first).getDate();
    var mm = new Date(first).getMonth() + 1;
    var yy = new Date(first).getFullYear();
    var hh = 8;
    var ms = 0;
    var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
    scope.userTime.firstAppointmentTime = new Date(x);
    scope.userTime.secondAppointmentTime = new Date(x);
    scope.userTime.testAppointmentTime = new Date(x);

    scope.hstep = 1;
    scope.mstep = 30;

    scope.ismeridian = false;

    //First time limit
    var maxFirst = new Date();
    maxFirst.setHours(18);
    maxFirst.setMinutes(0);
    scope.maxFirst = maxFirst;

    var minFirst = new Date();
    minFirst.setHours(8);
    minFirst.setMinutes(0);
    scope.minFirst = minFirst;

    //Second time limit
    var maxSecond = new Date();
    maxSecond.setHours(18);
    maxSecond.setMinutes(0);
    scope.maxSecond = maxSecond;

    //Download eQueue data
    scope.downloadQueue = function (frmDt, toDt, insurerId) {
        scope.downloadUrl = '';
        if (insurerId && frmDt && toDt) {
            scope.downloadUrl = UtilitiesService.getPlusUrlPrefix() + '/ESales/Download/' + $filter('date')(frmDt, 'dd-MM-yyyy') + "/" + $filter('date')(toDt, 'dd-MM-yyyy') + '/' + insurerId;
        } else {
            UtilitiesService.showAlertMessage('Select date and insurer name.');
        }
    };

    //Get and add Correspondence
    
    scope.getCallTypes = function () {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "MediMarketLookUp/calltype.json", "", "GET").then(function (response) {
            if (response.data.isSuccess) {
                scope.calltypes = response.data.results;
                scope.getCallStatuses();
            }
        });
    };
    scope.getCallStatuses = function () {
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "MediMarketLookUp/callstatus.json", "", "GET").then(function (response) {
            if (response.data.isSuccess) {
                scope.callstatuses = response.data.results;
            }
        });
    };
    scope.callStatusTemplate = function (callStatus) {
        scope.getCallStatus = callStatus;
        if (callStatus != "") {
            if (callStatus == "124") {
                scope.apolloDetails = scope.customerDetails.requestHistory.additionalInformation;
                var patientName = scope.apolloDetails.patientName;
                var appointmentDate = scope.getAuditDate(scope.apolloDetails.appointmentDate);
                var appointmentTime = scope.getAuditTime(scope.apolloDetails.appointmentDate);
                var employeeId = scope.apolloDetails.employeeID;
                scope.apolloMailTemplate = "Dear " + scope.reqDetails.name ? scope.reqDetails.name : 'NA' + ", Pre- Insurance Medicals for the Cashless Apollo Munich Product, " + scope.reqDetails.id + " is scheduled through Home Visit on " + scope.formatTime(scope.reqDetails.dateTimeCreated) + " | " + scope.compareDate(scope.reqDetails.dateTimeCreated) + "  at your residence. For queries pls contact 080-67617571. No payment has to be made to Medical Centre for this Check up, however, Home Visit charges are payable, as applicable. Please keep the printout of the Email sent on your registered Email ID or SMS sent by MediAssist handy with you to avail the CASHLESS FACILITY with a copy of valid Identification (ID) Proof. In absence of SMS/E Mail Print out, PPC will not be conducted.";
            }
            if (callStatus === '73' || callStatus === '74' || callStatus === '86' || callStatus === '96' || callStatus === '144' || callStatus === '187') {
                scope.showCalender = true;
            } else {
                scope.showCalender = false;
                scope.callDateTime = {
                    prefDate: '',
                    prefTime: ''
                }
            }
        }
    }

    scope.addCorrespondence = function (fileUploadData) {

        var data = {
            requestId: scope.reqDetails.id,
            requestFlowId: scope.reqDetails.id,
            comment: scope.corres.corrremarks,
            correspondenceType: 153,
            callType: scope.corres.calltype,
            callStatus: scope.corres.callstatus,
            workStatus: scope.corres.workStatus,            
            createdOn: Date.now(),
            attachFiles: {
                correspondencereports: fileUploadData
            },
            additionalInfo: {
                callbackdate: scope.PrefcallDateTime,
                uicnumber: scope.uicDetail.uicNumber,
                DND: scope.requestDataForCorrespondence.requestJSON.additionalInfo.hasOwnProperty('DND') ? scope.requestDataForCorrespondence.requestJSON.additionalInfo.DND : false,
                DNDCustomer: scope.requestDataForCorrespondence.requestJSON.additionalInfo.hasOwnProperty('DNDCustomer') ? scope.requestDataForCorrespondence.requestJSON.additionalInfo.DNDCustomer : false
            },
            createdBy: UserService.getUserObj().userId
        }
        data.additionalInfo.From = 'Esales';
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'RequestCorrespondence', data, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data.isSuccess) {
                UtilitiesService.showAlertMessage('Correspondence added successfuly.', true);
                $('#AddCorresponddenceModal').modal('hide');
            }
            else {
                UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                $('#AddCorresponddenceModal').modal('hide');
            }
        });
    };
    scope.addCorrespond = function () {
        scope.uploadMethods.upload(scope.addCorrespondence);
    };
    scope.uploadMethods = (function () {
        return {
            upload: function (callback) {
                var fileBlobArray = [];
                var filesUploadingArray = [];
                Object.keys(scope.file).forEach(function (ele) {
                    if (typeof (scope.file[ele].model) == "object") {
                        filesUploadingArray.push(scope.file[ele].model);
                    }
                });
                if (filesUploadingArray.length > 0) {
                    fileBlobArray.push(FileUploadSvc.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrlPrefix() + '/File'));
                }
                else {
                    callback.call(scope.addCorrespondence);
                    return false;
                }
                $q.all(fileBlobArray).then(function (result) {
                    scope.newlyUploadedDocs = [];
                    if (typeof result == "object" && typeof result[0].data == "object") {
                        for (var property in result[0].data) {
                            if (result[0].data.hasOwnProperty(property)) {
                                var obj = {};
                                obj.fileName = result[0].data[property];
                                obj.filePath = UtilitiesService.getDownloadURL(true) + property;
                                scope.newlyUploadedDocs.push(obj);
                            }
                        }
                        if (result && scope.newlyUploadedDocs && scope.newlyUploadedDocs.length > 0)
                            callback.call(scope.addCorrespondence, result[0].data);
                    }
                    else {
                        UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                        return false;
                    }
                },
                function (error) {
                    UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                });
            },
            clearFileModels: function (isShow) {
                if (!isShow)
                    scope.newlyUploadedDocs = [];
                scope.file = [];
                scope.fileUploadMethods.addFileToUpload();
            }
        };
    })();

    scope.file = [];
    scope.fileUploadMethods = (function () {
        return {
            addFileToUpload: function (flag) {
                var newItemNo = scope.file.length + 1;
                scope.file.push({
                    'model': ''
                });
            },
            removeFileToUpload: function (index) {
                scope.file.splice(index, 1);
            }
        };
    })();
    scope.changeDistance = function (distance) {
        if (distance) {
            scope.radious.distance = distance.value;
            scope.loadDcList(scope.radious.lat, scope.radious.lng);
        } else {
            scope.radious.distance = 5;
            scope.loadDcList(scope.radious.lat, scope.radious.lng);
        }
    }
    scope.example2settings = {
        idProp: 'peR_Id',
        displayProp: 'packageName',
        styleActive: true,
        enableSearch: true,
        externalIdProp: '',
        scrollableHeight: '300px',
        scrollable: true,
        showCheckAll: false,
        showUncheckAll: true,
        keyboardControls: true,
        smartButtonMaxItems: 1
    };
    scope.example5customTexts = {
        buttonDefaultText: 'Select packages',
        smartButtonMaxItems: 1
    };

    scope.setMinDate = function (fromDate) {
        scope.mindate = '';
        var setMinDate = fromDate;
        setMinDate.setDate(fromDate.getDate());
        scope.mindate = setMinDate;
        scope.mindate = scope.dateFilterDate.fromDateFilter;
    }

    scope.getInsurerList = function () {
        scope.insurerList = scope.pbqueue;
        scope.allInsurer = [];
        angular.forEach(scope.insurerList, function (v, i) {
            if (v.corporateName && v.eR_ID) {
                scope.allInsurer.push({ corporateName: v.corporateName, eRID: v.eR_ID });
            }
        })
        scope.finalInsurerList = [];
        scope.allInsurer.forEach(function (itm) {
            var unique = true;
            scope.finalInsurerList.forEach(function (itm2) {
                if (_.isEqual(itm, itm2)) unique = false;
            });
            if (unique) scope.finalInsurerList.push(itm);
        });
        return scope.finalInsurerList;
    }

    scope.reset = function () {
        scope.dateFilterDate = {
            fromDateFilter: '',
            toDateFilter: ''
        }
        scope.fromDateFilterValue = '';
        scope.pbqueue = scope.filterDateData;
    }

    scope.reschedule = function () {
        scope.reschedule.opened = true;
    };

    scope.dateOptionsReschedule = {
        formatYear: 'yy',
        minDate: new Date()
    };
}]);
angular.module("mbplus")
.controller('allAppointmentsController', ['$scope', '$rootScope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics', 'PlusUtilitiesService', function (scope, $rootScope, $location, UserService, UtilitiesService, filterFilter, $analytics, PlusUtilitiesService) {

    $analytics.pageTrack('/allappointments');
    scope.user = UserService.getUserObj();
    scope.allAppointments = [];
    scope.pageNo = 0;
    scope.rowCount = 10;
    scope.allAppointments = [];

    scope.loadAppointments = function (id, name) {
        var providerId = null;
        scope.providerName = '';
        if (id && name) {
            providerId = id;
            scope.providerName = name;
        }
        if (!scope.daysOfAppointment || scope.daysOfAppointment === '' || scope.daysOfAppointment <= -1) {
            scope.daysOfAppointment = -1;
        }
        var data = {
            requestType: '',
            pageNo: scope.pageNo,
            rows: scope.rowCount,
            daysOfAppointment: scope.daysOfAppointment,
            ProviderId: providerId,
            hashtagFilters: {},
            requestAccessToken: UserService.getAccessToken(),
            userAgent: 'String',
            ipAddress: 'String'
        };
        scope.appointmentsCount = 0;

        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + '/allAppointments', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
            if (response.data.isSuccess) {
                scope.allAppointments = response.data;
                UserService.activeAppointmentsDummyData = response.data;
                UserService.activeAppointmentsDummyDataCollection = response.data.requests;
            } else {
            }
        },function (error) {
        });
    };

    scope.ctrlFn = function (nextpage) {
        scope.pageNo = nextpage;
        scope.pageNo =scope.pageNo - 1;
        scope.loadAppointments();
    };

    //Search Appointment search by 
    scope.searchAppointment = function (searchValue) {
        var providerId = null;//provider id will be changed when dc is selected, In this case we have not provided anything like that.
        scope.searchSource = searchValue.value;
        scope.selectedOrderType = searchValue.selectedOrderType;
        if (scope.selectedOrderType) {
            var abc = scope.abc;
            if (scope.selectedOrderType == 'reqId') {
                scope.hashtagFilters = { requestid: scope.searchSource }
            } if (scope.selectedOrderType == 'email') {
                scope.hashtagFilters = { emailid: scope.searchSource }
            } if (scope.selectedOrderType == 'empId') {
                scope.hashtagFilters = { empid: scope.searchSource }
            } if (scope.selectedOrderType == 'contact') {
                scope.hashtagFilters = { contactno: scope.searchSource }
            } if (scope.selectedOrderType == 'name') {
                scope.hashtagFilters = { name: scope.searchSource }
            } if (scope.selectedOrderType == 'partnerOrderId') {
                scope.hashtagFilters = { partnerorderid: scope.searchSource }
            } if (scope.selectedOrderType == 'MAID') {
                scope.hashtagFilters = { MAID: scope.searchSource }
            }
        }
        var ajaxData = {
            requestType: "",
            daysOfAppointment: scope.daysOfAppointment,
            ProviderId: providerId,
            hashtagFilters: scope.hashtagFilters,
            requestAccessToken: UserService.getAccessToken(),
            userAgent: 'String',
            ipAddress: 'String',
            pageNo: 0,
            rows: 0,
            statusId: '',
            contractId: '',
            searchType: 1
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + '/allAppointments/', ajaxData, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data) {
                scope.allAppointments = response.data;
                UserService.activeAppointmentsDummyData = response.data;
                UserService.activeAppointmentsDummyDataCollection = response.data.requests;
            } else {
                UtilitiesService.showAlertMessage('No Record Found.');
            }
        })
    };

    //Search by
    $rootScope.$on('searchByAll', function (key, value) {
        scope.searchAppointment(value);
    });

    scope.reloadAppointments = function () {
        scope.pageNo = 0;
        scope.rowCount = 10;
        scope.loadAppointments();
    };

    scope.downloadFailedFile = function () {
        if (scope.failedFileName) {
            var url = UtilitiesService.getUrlPrefix() + '/DownloadExcelWithErrors/' + scope.failedFileName + ".json";
            window.open(url, "_blank");
        }
    };
   
    if (scope.selectFilter) {
        scope.contract = scope.selectFilter.id;
    } else {
        scope.contract = '';
    }

    scope.$watch('plusAppointmentsSearch', function (current, old) {
        if (current) {
            scope.activeAppointments = UserService.GetFilteredAppointment(current);
        } else {
            if (old) {
                UserService.activeAppointmentsDummyData.requests = UserService.activeAppointmentsDummyDataCollection;
                scope.activeAppointments = UserService.activeAppointmentsDummyData;
            }
        }
    });

    scope.loadAppointments();
}])
angular.module('mbplus')
.controller('approvalQueueCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', '$analytics', 'filterFilter', function (scope, $location, UserService, UtilitiesService, $analytics, filterFilter) {

  if (!UserService.isActive()) {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }

  $analytics.pageTrack('/approvalQueue');
  // check for logged in
  if (!UserService.isActive() || UserService.getUserObj().role.toLowerCase() != 'cms') {
    UserService.destroyUserObj();
    return false;
  }
  
  //Fetch approvalQueue
  scope.getApprovalQueue = function () {
    if (UserService.getHospitalObj()) {
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/search/pdaclaims.json?hospitalId=' + UserService.getHospitalObj().cmsHospId, '', 'GET').then(function (response) {
          if (response.data.isSuccess) {
          scope.approvalQueue = response.data.approvalQueue;
          scope.$watch('searchItems', function (term) {
            scope.requestsFiltered = filterFilter(scope.approvalQueue, term);
          });
        }
      }, function (error) {
        // console.log("Error : " + error);
      });
    }
  };
  scope.approveRequest = function (request) {

  };
  scope.rejectRequest = function (request) {

  };
  scope.getDetails = function (request) {

  }
  scope.lockItem = function (request) {

  };
  scope.unLockItem = function (request) {

  };
  angular.element(document).ready(function () {
    scope.getApprovalQueue();
  });
}]);
angular.module("mbplus")
.controller('appointmentSearchController', ['$scope', '$rootScope', '$location', 'UserService', 'UtilitiesService', 'filterFilter', '$analytics', 'PlusUtilitiesService','FileUploadService', '$q', function (scope, $rootScope, $location, UserService, UtilitiesService, filterFilter, $analytics, PlusUtilitiesService, FileUploadService, $q) {

  if (!UserService.isActive()) {
    UserService.destroyUserObj();
    $location.path('/');
    return false;
  }
  $analytics.pageTrack('/appointmentsSearch');
  scope.ctrlName = "appointmentSearchController";
  scope.formatTime = UtilitiesService.formatTime;
  scope.compareDate = UtilitiesService.compareDate;
  scope.user = UserService.getUserObj();
  scope.ServerPageRows = 500;
  scope.showdcselection = false;
  scope.daysOfAppointment = "";
  scope.showChkedOnDcLogin = true //false   // by default false, set true for testing;
  scope.contracts = PlusUtilitiesService.getContracts();
  scope.hasNoResults = true;
  scope.ERTypeId = 5290;
  scope.serviceBrokerId = "1000042";
  scope.Entity_Type = "4653";
  scope.testData = {};
  scope.originalDcDetails = {};
  scope.activeAppointments = [];
  scope.action = {
    feedback: ''
  };
  scope.feedbackList = ['Satisfied', 'Dissatisfied', 'Pacifistic'];
  scope.attachFiles = {};
  scope.attachFiles.reports = {};
  scope.attachFiles.bills = {};
  scope.searchSource = "";
  if (!UserService.isActive()) {
    UserService.destroyUserObj();
    //$location.path('/');
    return false;
  }
  scope.dispayInDdl = "Search by";

  scope.searchAppointments = function (valueToSearch) {
    var providerId = null;//provider id will be changed when dc is selected, In this case we have not provided anything like that.
    scope.searchSource = valueToSearch;
    if (scope.selectedOrderType) {
      if (scope.selectedOrderType == 'reqId') {
        scope.hashtagFilters = {
          "requestid": scope.searchSource
        }
      }
      if (scope.selectedOrderType == 'email') {
        scope.hashtagFilters = {
          "emailid": scope.searchSource
        }
      }
      if (scope.selectedOrderType == 'empId') {
        scope.hashtagFilters = {
          "empid": scope.searchSource
        }
      }
      if (scope.selectedOrderType == 'contact') {
        scope.hashtagFilters = {
          "contactno": scope.searchSource
        }
      }
      if (scope.selectedOrderType == 'name') {
        scope.hashtagFilters = {
          "name": scope.searchSource
        }
      }
      if (scope.selectedOrderType == 'date') {
      }
    }
    var ajaxData = {
      "requestType": "",
      "daysOfAppointment": scope.daysOfAppointment,
      "ProviderId": providerId,
      "hashtagFilters": scope.hashtagFilters,
      "requestAccessToken": UserService.getAccessToken(),
      "userAgent": "String",
      "ipAddress": "String",
      "pageNo": 0,
      "rows": 0,
      "statusId": "",
      "contractId": ""
    }
    var url = UtilitiesService.getPlusUrlPrefix() + "/Appointments/";
    UserService.makeRestCall(url, ajaxData, "post", UserService.getAccessToken()).then(function (response) {
      if (response.data) {
        scope.activeAppointments = response.data;
      }
    })
  }

  scope.getOrderType = function (orderType) {
    scope.selectedOrderType = orderType;
    if (scope.selectedOrderType) {
      scope.searchSource = "";
      if (orderType == 'reqId') {
        scope.dispayInDdl = "Request Id";
      }
      if (orderType == 'email') {
        scope.dispayInDdl = "Email";
      }
      if (orderType == 'empId') {
        scope.dispayInDdl = "Employee Id";
      }
      if (orderType == 'contact') {
        scope.dispayInDdl = "Contact No.";
      }
      if (orderType == 'name') {
        scope.dispayInDdl = "Name";
      }
      if (orderType == 'date') {
        scope.dispayInDdl = "date";
      }
    }
  }

  scope.reports = [];
  scope.bills = [];
  scope.fileUploadMethods = (function () {
    return {
      addFileToUpload: function (source) {
        if (source == "reports") {
          var newItemNo = scope.reports.length + 1;
          scope.reports.push({
            'model': ''
          });
        }
        if (source == "bills") {
          var newItemNo = scope.bills.length + 1;
          scope.bills.push({
            'model': ''
          });
        }

      },
      removeFileToUpload: function (index, source) {
        if (source == "reports") {
          scope.reports.splice(index, 1);
        }
        if (source == "bills") {
          scope.bills.splice(index, 1);
        }
      }
    };
  })();

  scope.newlyUploadedReports = [];
  scope.newlyUploadedBills = [];
  scope.uploadMethods = (function () {
    return {
      upload: function (source) {
        var fileBlobArray = [];
        var filesUploadingArray = [];
        if (source == 'reports') {
          Object.keys(scope.reports).forEach(function (ele) {
            if (typeof (scope.reports[ele].model) == "object") {
              filesUploadingArray.push(scope.reports[ele].model);
            }
          });
        }
        if (source == 'bills') {
          Object.keys(scope.bills).forEach(function (ele) {
            if (typeof (scope.bills[ele].model) == "object") {
              filesUploadingArray.push(scope.bills[ele].model);
            }
          });
        }

        if (filesUploadingArray.length > 0) {
          fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrlPrefix() + "/File.json"));
        }
        else {
           UtilitiesService.showAlertMessage('Please attach atleast one document');
          return false;
        }
        $q.all(fileBlobArray).then(function (result) {

          if (typeof result == "object" && typeof result[0].data == "object") {
            //scope.uploadDocMap(result[0].data);
            for (var property in result[0].data) {
              if (result[0].data.hasOwnProperty(property)) {
                var obj = {};
                obj.fileName = result[0].data[property];
                obj.filePath = UtilitiesService.getDownloadURL(true) + property;
                if (source == 'reports') {
                  scope.newlyUploadedReports.push(obj);
                  scope.attachFiles.reports = result[0].data;
                }
                if (source == 'bills') {
                  scope.newlyUploadedBills.push(obj);
                  scope.attachFiles.bills = result[0].data;
                }
              }
            }
          }
          else {
              //alert('upload fail');
              UtilitiesService.showAlertMessage('Upload fail');
            return false;
          }
        },
        function (error) {
            //alert('upload fail');
            UtilitiesService.showAlertMessage('upload fail');
        });
      }
    };
  })();

  scope.loadAppointments = function (id, name) {
    if (!(UserService.getUserObj().entityType == "DC")) {
      scope.showChkedOnDcLogin = true;
    }
    var providerId = null;
    scope.providerName = "";
    scope.providerName = UserService.getUserObj().entityName;
    if (id && name) {
      providerId = id;
      scope.providerName = name;
    }
    if (UserService.getUserObj().entityType == "DC") {
      var isInsurer = filterFilter(scope.user.rolesFeatures.roles, { 'roleId': scope.Role }, function (actual, expected) {
        return filterFilter(expected, actual)
      })
      var getid = JSON.parse(localStorage.children).filter(function (n) {
        return n.erTypeId == 5290;
      });
      if (scope.selectedEntity && scope.selectedEntity.id)
        providerId = scope.selectedEntity.id;
    }
    if (!scope.daysOfAppointment || scope.daysOfAppointment == "" || scope.daysOfAppointment <= -1) {
      scope.daysOfAppointment = -1;
    }
    scope.ServerPage = 0;
    var status = scope.dataStatusSearch == undefined ? '' : scope.dataStatusSearch;
    if (scope.dataStatusSearch == undefined)
      scope.dataStatusSearch = '';
    var data = {
      "requestType": "",
      "daysOfAppointment": scope.daysOfAppointment,
      "ProviderId": providerId,
      "hashtagFilters": {},
      "requestAccessToken": UserService.getAccessToken(),
      "userAgent": "String",
      "ipAddress": "String",
      "pageNo": scope.ServerPage,
      "rows": 500,
      "statusId": status,
      "contractId": scope.serverContractType == undefined ? 0 : scope.serverContractType
    };
    var url = UtilitiesService.getPlusUrlPrefix() + "/activeAppointments/";
    scope.appointmentsCount = 0;
    UserService.makeRestCall(url, data, "POST", UserService.getAccessToken()).then(function (response) {
      scope.activeAppointments = response.data;
      if (response.data.isSuccess) {
      } else {
        scope.hasNoResults = true;
      }

    });
  }

  scope.medicalTestMethods = (function () {
    scope.relatedTests = [];
    scope.tempBucket = [];
    scope.groups = [[]];
    return {
      splitRequests: function () {
        var dataObj = [];
        var restObj = [];
        angular.forEach(scope.relatedTests, function (ind, val) {
          val.groupId = 0
          val.providerId = scope.originalDcDetails.providerId
          val.providerName = scope.originalDcDetails.providerName
          val.appointmentDate = scope.originalDcDetails.appointmentDate
          val.visitType = scope.originalDcDetails.visitType
          scope.groups[0].push(val)

        })
        angular.forEach(scope.groups, function (i, buckets) {
          angular.forEach(buckets, function (ib, test) {
            var obj = {};
            if (i == 0) {
              obj = {
                "productId": test.id,
                "providerId": test.providerId,
                "providerName": test.providerName,
                "appointmentDate": test.appointmentDate,
                "visitType": test.visitType,
                "groupId": 0
              }
            }
            else {
              obj = {
                "productId": test.id,
                "providerId": test.providerId,
                "providerName": test.providerName,
                "appointmentDate": test.appointmentDate,
                "visitType": test.visitType,
                "groupId": i
              }
            }
            dataObj.push(obj)
          })
        })
        var data = {
          "requestId": scope.requestId,
          "details": dataObj
        }
        var url = UtilitiesService.getPlusUrlPrefix() + "/SplitRequest/";
        UserService.makeRestCall(url, data, "POST", UserService.getAccessToken()).then(function (response) {
          scope.relatedTests = [];
          scope.tempBucket = [];
          scope.groups = [[]];
          scope.originalDcDetails = {};
        });
      },
      addTestToPermanentBucket: function () {
        scope.disableTempCreate = false;
        scope.desableLocation = true;
        $(scope.tempBucket).each(function (i, v) {
          v.groupId = scope.groups.length;
        })
        scope.groups.push(scope.tempBucket);
        scope.tempBucket = [];
      },
      removeFromGroups: function (removeItem) {
        removeItem.checkTest = false;
        $.each(scope.groups, function (i, val) {
          if (val.indexOf(removeItem) != -1) {
            scope.relatedTests.push(removeItem);
            val.splice(val.indexOf(removeItem), 1);
            return true;
          }
        })
      },
      addTestToTempBucket: function (checkedItem) {
        checkedItem.checkTest = true;
        scope.tempBucket.push(checkedItem);
        scope.relatedTests.splice(scope.relatedTests.indexOf(checkedItem), 1)
      },
      removeBucketFromGroup: function (index) {
        $(scope.groups[index]).each(function (i, v) {
          v.groupId = 0;
          v.checkTest = false;
          scope.relatedTests.push(v);
        })
        scope.groups.splice(index, 1)
      },
      getTestsForPackage: function (productId, reqtId, providerId, providerName, appointmentDate, visitType) {

        scope.originalDcDetails.providerId = providerId;
        scope.originalDcDetails.providerName = providerName;
        scope.originalDcDetails.appointmentDate = appointmentDate;
        scope.originalDcDetails.visitType = visitType;
        scope.groups = [[]];
        scope.testData.testStateId = "";
        scope.cities = {};
        scope.locations = {};
        scope.sublocations = {};
        scope.allDCs = {};

        var url = UtilitiesService.getPlusUrlPrefix() + "/PackageEntityRelation/" + productId + ".json";
        UserService.makeRestCall(url, "", "GET", UserService.getAccessToken()).then(function (response) {
          if (response.data) {
            scope.requestId = reqtId;
            scope.relatedTests = {};
            if (scope.tempBucket.length > 0) {
              scope.tempBucket = [];
            }
            scope.relatedTests = response.data.allowedInvestigations;
            scope.testsObj = {};
            $(scope.relatedTests).each(function (i, v) {
              scope.testsObj[v.id] = v;
            })
          }
        },
        function (error) {
        });
      },
      removeFromBucket: function (checkedItem) {
        checkedItem.checkTest = false;
        scope.relatedTests.push(checkedItem);
        scope.tempBucket.splice(scope.tempBucket.indexOf(checkedItem), 1)
      }
    };
  })();

  scope.actionOnRequestMethods = (function () {
    return {
      actionRequest: function (actionType, event) {
        scope.createRequest("Appointment", scope.action.statusId, scope.action.nextStatusId, scope.action.requestId, actionType, scope.action.spocname, scope.action.spocphone, event);
      }
    }
  })();

  scope.createRequest = function (requestType, statusId, nextStatusId, requestId, actionType, spocname, spocphone, event) {
    var url = UtilitiesService.getPlusUrlPrefix() + "/request";
    var patientname = scope.selectedPatientName;
    var id = requestId; //scope.selectedRequestId;
    var appDate = scope.action.date;
    var providerId = null;
    var providerName = "";
    var remarksComment = scope.action.remarks;
    var additionalParams = {};
    switch (actionType) {
      case "Reschedule":
        appdate = scope.form.dod;
        if ($("#dcid").val() && scope.showdcselection && !(UserService.getUserObj().entitytype == "dc")) {
          providerid = $("#dcid").val();
          providername = $("#dcid option:selected").text();
        }
        break;
      case "Cancel":
        appDate = scope.action.date;
        remarksComment = scope.cancelComments;
        break;
      case "Confirm":
        additionalParams.Price = scope.action.dcPrice;
        break;
      case "Fit":
        additionalParams.bloodGroup = scope.selectedBloodGrp;
        break;
      case "UnFit":
        additionalParams.bloodGroup = scope.selectedBloodGrp;
        break;
      default:
        appDate = scope.action.date;
        break;
    }
    var requestData = {
      "request": {
        "requestId": requestId,
        "currentStatusId": statusId,
        "remarks": remarksComment,
        "ScheduledAppointmentDate": appDate,
        "requestedNextActionId": nextStatusId,
        "attachFiles": scope.attachFiles,
        "providerId": providerId,
        "providerName": providerName,
        "spocName": spocname,
        "spocContactNo": spocphone,
        "additionalParameters": additionalParams,
        userFeedback: scope.action.feedback ? scope.action.feedback : ''
      },
      "requestAccessToken": UserService.getAccessToken(),
      "userAgent": "String",
      "ipAddress": "String"
    }
    UserService.makeRestCall(url, requestData, "post").then(function (response) {
      var targetModal = event.target.parentNode;
      while (!targetModal.classList.contains("modal")) {
        targetModal = targetModal.parentNode;
      }
      $("#" + actionType + "Modal").modal("hide");
      scope.loadAppointments();
      if (scope.attachFiles) {
        if (scope.attachFiles.reports) {
          scope.attachFiles.reports = {};
        }
        if (scope.attachFiles.bills) {
          scope.attachFiles.bills = {};
        }
      }
      scope.action = {};
    },
    function (error) {
    });
  }

  scope.updateRemarks = function (actualDate) {
    scope.action.remarks = "Actual attended date is :" + actualDate;
  }

  scope.useSecondPref = function () {
    scope.form.dod = scope.action.secondPreferredTime; //UtilitiesService.formatDateNumber(scope.action.secondPreferredTime);
  }

  //function for location
  scope.locationMethods = (function () {
    return {
      loadStates: function () {
        var url = UtilitiesService.getPlusUrlPrefix('integration') + "/masterdata/lookup/state.json";
        UserService.makeRestCall(url, "", "get").then(function (response) {
          if (response.data.isSuccess) {
            scope.states = response.data.lookUpData;
          }
        },
        function (error) {
        });
      },
      loadCities: function (stateId) {
        var url = UtilitiesService.getPlusUrlPrefix() + "/masterdata/lookup/district/" + stateId + ".json";
        UserService.makeRestCall(url, "", "get").then(function (response) {
          if (response.data.isSuccess) {
            scope.cities = response.data.lookUpData;
          }
        },
        function (error) {
        });
      },
      loadLocations: function (cityId) {
        var url = UtilitiesService.getPlusUrlPrefix() + "/masterdata/lookup/city/" + cityId + ".json";
        UserService.makeRestCall(url, "", "get").then(function (response) {
          if (response.data.isSuccess) {
            scope.locations = response.data.lookUpData;
          }
        },
        function (error) {
        });
      },
      loadSubLocations: function (locationId) {
        var url = UtilitiesService.getPlusUrlPrefix() + "/masterdata/lookup/location/" + locationId + ".json";
        UserService.makeRestCall(url, "", "get").then(function (response) {
          if (response.data.isSuccess) {
            scope.sublocations = response.data.lookUpData;
          }
        },
        function (error) {
        });
      },
      loadDCForTests: function () {
        var url = UtilitiesService.getPlusUrlPrefix() + "EntityRelation/Search/EntitySearch/" + scope.ERTypeId + "/" + scope.serviceBrokerId + "/" + scope.Entity_Type + "/" + scope.testData.testStateId + "/" + scope.testData.testCityId + "/" + scope.testData.testLocalityId + "/" + scope.testData.testSubLocalityId + ".json";
        UserService.makeRestCall(url, "", "get").then(function (response) {
          if (response.statusText == "OK") {
            scope.allDCs = response.data;
            scope.dcObj = {};
            $(scope.diagnosticCentres).each(function (i, v) {
              scope.dcObj[v.id] = v;
            })
          }
        });
      }
    }
  })();

  //function for location
  scope.loadLocationData = function (type, id) {
    switch (type) {
      case "city":
        scope.locationMethods.loadCities(id);
        break;
      case "locality":
        scope.locationMethods.loadLocations(id);
        break;
      case "sublocality":
        scope.locationMethods.loadSubLocations(id);
        break;
      case "dc":
        scope.locationMethods.loadDCForTests();
        break;
      default:
        scope.locationMethods.loadCities(id);
        break;
    }
  }

  scope.openRespectiveActionModal = function (actionName, currentStatusId, actionStatusId, requestId, appointmentDate, secondAppointmentDate, orderItemProductId) {
    scope.actionName = actionName;
    scope.action.statusId = currentStatusId;
    scope.action.nextStatusId = actionStatusId;
    scope.actionId = actionStatusId;
    scope.action.requestId = requestId;
    scope.action.date = appointmentDate;
    scope.action.visibleDate = scope.compareDate(appointmentDate);
    scope.action.visibleTime = scope.action.visibleDate + " " + scope.formatTime(appointmentDate);
    scope.action.secondPreferredTime = secondAppointmentDate;
    scope.secondPreferredVTime = scope.compareDate(secondAppointmentDate) + " " + scope.formatTime(secondAppointmentDate);
    scope.action.productId = orderItemProductId;
    //empty all modals

    if (scope.actionName == 'Fit' || scope.actionName == 'UnFit') {
      if (scope.action.remarks) {
        scope.action.remarks.fit = "";
        scope.selectedBloodGrp = "";
      }
    }
    if (scope.actionName == 'Reschedule') {
      scope.form.dod = "";
      scope.showdcselection = false;
      scope.testData.testStateId = "";
      scope.testData.testCityId = "";
      scope.testData.testLocalityId = "";
    }
    if (scope.actionName == 'Confirm') {
      scope.action.spocname = "";
      scope.action.spocphone = "";
      scope.action.dcPrice = "";
    }
    if (scope.actionName == 'Cancel') {
    }
    if (scope.actionName == 'Approve' || scope.actionName == 'NotAttended' || scope.actionName == 'Raise_IA') {
      scope.action.remarks = "";
    }
    if (scope.actionName == 'Attended') {
      scope.actualdate = "";
      scope.action.remarks = "";
      scope.action.feedback = '';
    }
    if (scope.actionName == 'Submit') {
      scope.attachFiles.reports = {};
      scope.attachFiles.bills = {};
      scope.action.remarks = "";
    }
    if (scope.actionName == 'Create') {
      scope.partnerOrderId = "";
    }
  }

  scope.markUrgentHni = function (hni, urgent, none, resuestId) {
    if (hni) {
      var url = UtilitiesService.getPlusUrlPrefix() + "MarkPriorityForRequest/" + resuestId + '/' + "2.json";
      UserService.makeRestCall(url, "", "get", UserService.getAccessToken()).then(function (response) {
        if (response.data) {
        }
      },
      function (error) {
      });
    }
    if (urgent) {
      var url = UtilitiesService.getPlusUrlPrefix() + "MarkPriorityForRequest/" + resuestId + '/' + "1.json";
      UserService.makeRestCall(url, "", "get", UserService.getAccessToken()).then(function (response) {
        if (response.data) {
        }
      },
      function (error) {
      });
    }
    if (none) {
      var url = UtilitiesService.getPlusUrlPrefix() + "MarkPriorityForRequest/" + resuestId + '/' + "0.json";
      UserService.makeRestCall(url, "", "get", UserService.getAccessToken()).then(function (response) {
        if (response.data) {
        }
      },
      function (error) {
      });
    }
  };

  scope.placeWithPartner = function () {
    var data = {
      RequestId: scope.action.requestId,
      PartnerOrderId: scope.action.partnerOrderId
    };
    UtilitiesService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/requestPharmaOrder", data, "POST", UserService.getAccessToken()).then(function (response) {
      if (response.data) {
          //alert("Order has been placed Successfully.");
          UtilitiesService.showAlertMessage('Order has been placed Successfully.', true);
        $("#CreateModal").modal("hide");
      }
      else {
          //alert("Due to some technical issue, you are unable to place order.");
          UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to place order.');
        $("#CreateModal").modal("hide");
      }
    })
  }
  angular.element(document).ready(function () {
    scope.locationMethods.loadStates();
  });
}]);



angular.module('mbplus')
.controller('aarogyaClaimsCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', function (scope, location, UserService, UtilitiesService) {
    UserService.checkForSession();

    //Fetch Aarogya Claims List
    scope.getAarogyaClaimsList = function (hospId) {
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/search/openclaims.json?hospitalId=' + UserService.getHospitalObj().cmsHospId + '&schemeType=Aarogya', '', 'GET').then(function (response) {
            if (response.data.isSuccess) {
                scope.aarogyaClaims = UtilitiesService.renderClaimsList(response.data, 'preauth');
            }
        });
    };
    scope.getAarogyaClaimsList();
}]);
angular.module('mbplus')
.controller('activeHospCtrl', ['$scope', '$location', 'UserService', 'UtilitiesService', '$analytics',
    function (scope, location, UserService, UtilitiesService, analytics) {
        analytics.pageTrack('/activehosp');
        // check for logged in
        if (!UserService.isActive() || !UserService.getUserObj().role.toLowerCase() == "cms" || UserService.getUserObj().role.toLowerCase() == "insurer") {
            UserService.destroyUserObj();
            location.path('/');
            return false;
        }
        scope.showImg = UtilitiesService.showImg;
        scope.states = [
          { "stateName": "Andaman Nicobar", "id": "48" },
          { "stateName": "Andhra Pradesh", "id": "49" },
          { "stateName": "Arunachal Pradesh", "id": "50" },
          { "stateName": "Assam", "id": "51" },
          { "stateName": "Bihar", "id": "52" },
          { "stateName": "Chandigarh", "id": "53" },
          { "stateName": "Chattisgarh", "id": "54" },
          { "stateName": "Dadra and Nagar Haveli", "id": "55" },
          { "stateName": "Delhi", "id": "56" },
          { "stateName": "Daman Diu", "id": "57" },
          { "stateName": "Goa", "id": "58" },
          { "stateName": "Gujarat", "id": "59" },
          { "stateName": "Haryana", "id": "60" },
          { "stateName": "Himachal Pradesh", "id": "61" },
          { "stateName": "Jammu Kashmir", "id": "62" },
          { "stateName": "Jharkhand", "id": "63" },
          { "stateName": "Karnataka", "id": "64" },
          { "stateName": "Kerala", "id": "65" },
          { "stateName": "Lakshwadeep", "id": "66" },
          { "stateName": "Madhya Pradesh", "id": "67" },
          { "stateName": "Maharashtra", "id": "68" },
          { "stateName": "Manipur", "id": "69" },
          { "stateName": "MEGHALAYA", "id": "70" },
          { "stateName": "Mizoram", "id": "71" },
          { "stateName": "Nagaland", "id": "72" },
          { "stateName": "Nepal", "id": "73" },
          { "stateName": "Orissa", "id": "74" },
          { "stateName": "Overseas", "id": "75" },
          { "stateName": "Pondicherry", "id": "76" },
          { "stateName": "Punjab", "id": "77" },
          { "stateName": "Rajasthan", "id": "78" },
          { "stateName": "Sikkim", "id": "79" },
          { "stateName": "Tamil Nadu", "id": "80" },
          { "stateName": "Tripura", "id": "81" },
          { "stateName": "Uttar Pradesh", "id": "82" },
          { "stateName": "Uttaranchal", "id": "83" },
          { "stateName": "West Bengal", "id": "84" },
          { "stateName": "Telangana", "id": "9727" }
        ];
        scope.currentPage = 1;
        scope.itemsPerPage = 10;
        scope.maxSize = 5;
        scope.servicingTPABranch = '';
        scope.stateSelected = {};
        scope.hospSearchResults = {};
        scope.hospSearchResultsSpecific = {};
        scope.getActiveHospReport = function (pageNo, branchName, StateId, count) {
            scope.createdHospitals = 0;
            scope.totalEnrolledHospitals = 0;
            scope.filteredHospitals = 0;
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/hospreport.json", {
                "stateId": StateId,
                "branchName": branchName,
                "pageNo": pageNo,
                "count": count
            }, "POST").then(function (response) {
                if (response.data.isSuccess) {
                    scope.createdHospitals = response.data.report;
                    scope.totalEnrolledHospitals = response.data.totalHospitals;
                    scope.filteredHospitals = response.data.filteredHospitals;
                    scope.totalItems = scope.filteredHospitals;
                    scope.totalPgs = Math.ceil(scope.filteredHospitals / scope.itemsPerPage);
                }
            }, function (error) {
                // console.log("Error : " + error);
            });
        };
        scope.searchHosp = function (branchName, StateId) {
            scope.hospSearchResults = null;
            if (!scope.hospSearchID && !scope.hospSearchName) {
                scope.hospSearchResults = null;
                return false;
            }
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/hospreport.json", {
                "stateId": StateId,
                "branchName": branchName,
                "hospName": scope.hospSearchName,
                "hospid": scope.hospSearchID,
                "pageNo": 1,
                "count": 25
            }, "POST").then(function (response) {
                if (response.data.isSuccess) {
                    scope.hospSearchResults = response.data.report;
                    scope.hospSearchResultsCount = response.data.report.length;
                }
            }, function (error) {
                // console.log("Error : " + error);
            });
        };
        scope.destroySearchData = function () {
            scope.hospSearchResults = null;
            scope.hospSearchID = null;
            scope.hospSearchName = null;
        };
        angular.element(document).ready(function () {
            scope.getActiveHospReport(scope.currentPage);
        });
    }]);
angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.collapse","ui.bootstrap.dialog","ui.bootstrap.dropdownToggle","ui.bootstrap.modal","ui.bootstrap.pagination","ui.bootstrap.popover","ui.bootstrap.tabs","ui.bootstrap.tooltip","ui.bootstrap.transition","ui.bootstrap.typeahead"]);

angular.module("ui.bootstrap.tpls", ["template/accordion/accordion-group.html","template/accordion/accordion.html","template/alert/alert.html","template/carousel/carousel.html","template/carousel/slide.html","template/dialog/message.html","template/pagination/pagination.html","template/popover/popover.html","template/tabs/pane.html","template/tabs/tabs.html","template/tooltip/tooltip-popup.html","template/typeahead/typeahead.html"]);

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse'])

.constant('accordionConfig', {
  closeOthers: true
})

.controller('AccordionController', ['$scope', '$attrs', 'accordionConfig', function ($scope, $attrs, accordionConfig) {
  
  // This array keeps track of the accordion groups
  this.groups = [];

  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
  this.closeOthers = function(openGroup) {
    var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
    if ( closeOthers ) {
      angular.forEach(this.groups, function (group) {
        if ( group !== openGroup ) {
          group.isOpen = false;
        }
      });
    }
  };
  
  // This is called from the accordion-group directive to add itself to the accordion
  this.addGroup = function(groupScope) {
    var that = this;
    this.groups.push(groupScope);

    groupScope.$on('$destroy', function (event) {
      that.removeGroup(groupScope);
    });
  };

  // This is called from the accordion-group directive when to remove itself
  this.removeGroup = function(group) {
    var index = this.groups.indexOf(group);
    if ( index !== -1 ) {
      this.groups.splice(this.groups.indexOf(group), 1);
    }
  };

}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('accordion', function () {
  return {
    restrict:'EA',
    controller:'AccordionController',
    transclude: true,
    replace: false,
    templateUrl: 'template/accordion/accordion.html'
  };
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('accordionGroup', ['$parse', '$transition', '$timeout', function($parse, $transition, $timeout) {
  return {
    require:'^accordion',         // We need this directive to be inside an accordion
    restrict:'EA',
    transclude:true,              // It transcludes the contents of the directive into the template
    replace: true,                // The element containing the directive will be replaced with the template
    templateUrl:'template/accordion/accordion-group.html',
    scope:{ heading:'@' },        // Create an isolated scope and interpolate the heading attribute onto this scope
    controller: ['$scope', function($scope) {
      this.setHeading = function(element) {
        this.heading = element;
      };
    }],
    link: function(scope, element, attrs, accordionCtrl) {
      var getIsOpen, setIsOpen;

      accordionCtrl.addGroup(scope);

      scope.isOpen = false;
      
      if ( attrs.isOpen ) {
        getIsOpen = $parse(attrs.isOpen);
        setIsOpen = getIsOpen.assign;

        scope.$watch(
          function watchIsOpen() { return getIsOpen(scope.$parent); },
          function updateOpen(value) { scope.isOpen = value; }
        );
        
        scope.isOpen = getIsOpen ? getIsOpen(scope.$parent) : false;
      }

      scope.$watch('isOpen', function(value) {
        if ( value ) {
          accordionCtrl.closeOthers(scope);
        }
        if ( setIsOpen ) {
          setIsOpen(scope.$parent, value);
        }
      });
    }
  };
}])

// Use accordion-heading below an accordion-group to provide a heading containing HTML
// <accordion-group>
//   <accordion-heading>Heading containing HTML - <img src="..."></accordion-heading>
// </accordion-group>
.directive('accordionHeading', function() {
  return {
    restrict: 'E',
    transclude: true,   // Grab the contents to be used as the heading
    template: '',       // In effect remove this element!
    replace: true,
    require: '^accordionGroup',
    compile: function(element, attr, transclude) {
      return function link(scope, element, attr, accordionGroupCtrl) {
        // Pass the heading to the accordion-group controller
        // so that it can be transcluded into the right place in the template
        // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
        accordionGroupCtrl.setHeading(transclude(scope, function() {}));
      };
    }
  };
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
// <div class="accordion-group">
//   <div class="accordion-heading" ><a ... accordion-transclude="heading">...</a></div>
//   ...
// </div>
.directive('accordionTransclude', function() {
  return {
    require: '^accordionGroup',
    link: function(scope, element, attr, controller) {
      scope.$watch(function() { return controller[attr.accordionTransclude]; }, function(heading) {
        if ( heading ) {
          element.html('');
          element.append(heading);
        }
      });
    }
  };
});

angular.module("ui.bootstrap.alert", []).directive('alert', function () {
  return {
    restrict:'EA',
    templateUrl:'template/alert/alert.html',
    transclude:true,
    replace:true,
    scope:{
      type:'=',
      close:'&'
    }
  };
});
angular.module('ui.bootstrap.buttons', [])

  .constant('buttonConfig', {
    activeClass:'active',
    toggleEvent:'click'
  })

  .directive('btnRadio', ['buttonConfig', function (buttonConfig) {
  var activeClass = buttonConfig.activeClass || 'active';
  var toggleEvent = buttonConfig.toggleEvent || 'click';

  return {

    require:'ngModel',
    link:function (scope, element, attrs, ngModelCtrl) {

      var value = scope.$eval(attrs.btnRadio);

      //model -> UI
      scope.$watch(function () {
        return ngModelCtrl.$modelValue;
      }, function (modelValue) {
        if (angular.equals(modelValue, value)){
          element.addClass(activeClass);
        } else {
          element.removeClass(activeClass);
        }
      });

      //ui->model
      element.bind(toggleEvent, function () {
        if (!element.hasClass(activeClass)) {
          scope.$apply(function () {
            ngModelCtrl.$setViewValue(value);
          });
        }
      });
    }
  };
}])

  .directive('btnCheckbox', ['buttonConfig', function (buttonConfig) {

  var activeClass = buttonConfig.activeClass || 'active';
  var toggleEvent = buttonConfig.toggleEvent || 'click';

  return {
    require:'ngModel',
    link:function (scope, element, attrs, ngModelCtrl) {

      var trueValue = scope.$eval(attrs.btnCheckboxTrue);
      var falseValue = scope.$eval(attrs.btnCheckboxFalse);

      trueValue = angular.isDefined(trueValue) ? trueValue : true;
      falseValue = angular.isDefined(falseValue) ? falseValue : false;

      //model -> UI
      scope.$watch(function () {
        return ngModelCtrl.$modelValue;
      }, function (modelValue) {
        if (angular.equals(modelValue, trueValue)) {
          element.addClass(activeClass);
        } else {
          element.removeClass(activeClass);
        }
      });

      //ui->model
      element.bind(toggleEvent, function () {
        scope.$apply(function () {
          ngModelCtrl.$setViewValue(element.hasClass(activeClass) ? falseValue : trueValue);
        });
      });
    }
  };
}]);
/*
*
*    AngularJS Bootstrap Carousel 
*
*      A pure AngularJS carousel.
*      
*      For no interval set the interval to non-number, or milliseconds of desired interval
*      Template: <carousel interval="none"><slide>{{anything}}</slide></carousel>
*      To change the carousel's active slide set the active attribute to true
*      Template: <carousel interval="none"><slide active="someModel">{{anything}}</slide></carousel>
*/
angular.module('ui.bootstrap.carousel', ['ui.bootstrap.transition'])
.controller('CarouselController', ['$scope', '$timeout', '$transition', '$q', function ($scope, $timeout, $transition, $q) {
  var self = this,
    slides = self.slides = [],
    currentIndex = -1,
    currentTimeout, isPlaying;
  self.currentSlide = null;

  /* direction: "prev" or "next" */
  self.select = function(nextSlide, direction) {
    var nextIndex = slides.indexOf(nextSlide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > currentIndex ? "next" : "prev";
    }
    if (nextSlide && nextSlide !== self.currentSlide) {
      if ($scope.$currentTransition) {
        $scope.$currentTransition.cancel();
        //Timeout so ng-class in template has time to fix classes for finished slide
        $timeout(goNext);
      } else {
        goNext();
      }
    }
    function goNext() {
      //If we have a slide to transition from and we have a transition type and we're allowed, go
      if (self.currentSlide && angular.isString(direction) && !$scope.noTransition && nextSlide.$element) { 
        //We shouldn't do class manip in here, but it's the same weird thing bootstrap does. need to fix sometime
        nextSlide.$element.addClass(direction);
        nextSlide.$element[0].offsetWidth = nextSlide.$element[0].offsetWidth; //force reflow

        //Set all other slides to stop doing their stuff for the new transition
        angular.forEach(slides, function(slide) {
          angular.extend(slide, {direction: '', entering: false, leaving: false, active: false});
        });
        angular.extend(nextSlide, {direction: direction, active: true, entering: true});
        angular.extend(self.currentSlide||{}, {direction: direction, leaving: true});

        $scope.$currentTransition = $transition(nextSlide.$element, {});
        //We have to create new pointers inside a closure since next & current will change
        (function(next,current) {
          $scope.$currentTransition.then(
            function(){ transitionDone(next, current); },
            function(){ transitionDone(next, current); }
          );
        }(nextSlide, self.currentSlide));
      } else {
        transitionDone(nextSlide, self.currentSlide);
      }
      self.currentSlide = nextSlide;
      currentIndex = nextIndex;
      //every time you change slides, reset the timer
      restartTimer();
    }
    function transitionDone(next, current) {
      angular.extend(next, {direction: '', active: true, leaving: false, entering: false});
      angular.extend(current||{}, {direction: '', active: false, leaving: false, entering: false});
      $scope.$currentTransition = null;
    }
  };

  /* Allow outside people to call indexOf on slides array */
  self.indexOfSlide = function(slide) {
    return slides.indexOf(slide);
  };

  $scope.next = function() {
    var newIndex = (currentIndex + 1) % slides.length;
    return self.select(slides[newIndex], 'next');
  };

  $scope.prev = function() {
    var newIndex = currentIndex - 1 < 0 ? slides.length - 1 : currentIndex - 1;
    return self.select(slides[newIndex], 'prev');
  };

  $scope.select = function(slide) {
    self.select(slide);
  };

  $scope.isActive = function(slide) {
     return self.currentSlide === slide;
  };

  $scope.slides = function() {
    return slides;
  };

  $scope.$watch('interval', restartTimer);
  function restartTimer() {
    if (currentTimeout) {
      $timeout.cancel(currentTimeout);
    }
    function go() {
      if (isPlaying) {
        $scope.next();
        restartTimer();
      } else {
        $scope.pause();
      }
    }
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval>=0) {
      currentTimeout = $timeout(go, interval);
    }
  }
  $scope.play = function() {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };
  $scope.pause = function() {
    isPlaying = false;
    if (currentTimeout) {
      $timeout.cancel(currentTimeout);
    }
  };

  self.addSlide = function(slide, element) {
    slide.$element = element;
    slides.push(slide);
    //if this is the first slide or the slide is set to active, select it
    if(slides.length === 1 || slide.active) {
      self.select(slides[slides.length-1]);
      if (slides.length == 1) {
        $scope.play();
      }
    } else {
      slide.active = false;
    }
  };

  self.removeSlide = function(slide) {
    //get the index of the slide inside the carousel
    var index = slides.indexOf(slide);
    slides.splice(index, 1);
    if (slides.length > 0 && slide.active) {
      if (index >= slides.length) {
        self.select(slides[index-1]);
      } else {
        self.select(slides[index]);
      }
    }
  };
}])
.directive('carousel', [function() {
  return {
    restrict: 'EA',
    transclude: true,
    replace: true,
    controller: 'CarouselController',
    require: 'carousel',
    templateUrl: 'template/carousel/carousel.html',
    scope: {
      interval: '=',
      noTransition: '='
    }
  };
}])
.directive('slide', [function() {
  return {
    require: '^carousel',
    restrict: 'EA',
    transclude: true,
    replace: true,
    templateUrl: 'template/carousel/slide.html',
    scope: {
      active: '='
    },
    link: function (scope, element, attrs, carouselCtrl) {
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function() {
        carouselCtrl.removeSlide(scope);
      });

      scope.$watch('active', function(active) {
        if (active) {
          carouselCtrl.select(scope);
        }
      });
    }
  };
}]);

angular.module('ui.bootstrap.collapse',['ui.bootstrap.transition'])

// The collapsible directive indicates a block of html that will expand and collapse
.directive('collapse', ['$transition', function($transition) {
  // CSS transitions don't work with height: auto, so we have to manually change the height to a
  // specific value and then once the animation completes, we can reset the height to auto.
  // Unfortunately if you do this while the CSS transitions are specified (i.e. in the CSS class
  // "collapse") then you trigger a change to height 0 in between.
  // The fix is to remove the "collapse" CSS class while changing the height back to auto - phew!
  var fixUpHeight = function(scope, element, height) {
    // We remove the collapse CSS class to prevent a transition when we change to height: auto
    element.removeClass('collapse');
    element.css({ height: height });
    // It appears that  reading offsetWidth makes the browser realise that we have changed the
    // height already :-/
    var x = element[0].offsetWidth;
    element.addClass('collapse');
  };

  return {
    link: function(scope, element, attrs) {

      var isCollapsed;
      var initialAnimSkip = true;
      scope.$watch(function (){ return element[0].scrollHeight; }, function (value) {
        //The listener is called when scollHeight changes
        //It actually does on 2 scenarios: 
        // 1. Parent is set to display none
        // 2. angular bindings inside are resolved
        //When we have a change of scrollHeight we are setting again the correct height if the group is opened
        if (element[0].scrollHeight !== 0) {
          if (!isCollapsed) {
            if (initialAnimSkip) {
              fixUpHeight(scope, element, element[0].scrollHeight + 'px');
            } else {
              fixUpHeight(scope, element, 'auto');
            }
          }
        }
      });
      
      scope.$watch(attrs.collapse, function(value) {
        if (value) {
          collapse();
        } else {
          expand();
        }
      });
      

      var currentTransition;
      var doTransition = function(change) {
        if ( currentTransition ) {
          currentTransition.cancel();
        }
        currentTransition = $transition(element,change);
        currentTransition.then(
          function() { currentTransition = undefined; },
          function() { currentTransition = undefined; }
        );
        return currentTransition;
      };

      var expand = function() {
        if (initialAnimSkip) {
          initialAnimSkip = false;
          if ( !isCollapsed ) {
            fixUpHeight(scope, element, 'auto');
          }
        } else {
          doTransition({ height : element[0].scrollHeight + 'px' })
          .then(function() {
            // This check ensures that we don't accidentally update the height if the user has closed
            // the group while the animation was still running
            if ( !isCollapsed ) {
              fixUpHeight(scope, element, 'auto');
            }
          });
        }
        isCollapsed = false;
      };
      
      var collapse = function() {
        isCollapsed = true;
        if (initialAnimSkip) {
          initialAnimSkip = false;
          fixUpHeight(scope, element, 0);
        } else {
          fixUpHeight(scope, element, element[0].scrollHeight + 'px');
          doTransition({'height':'0'});
        }
      };
    }
  };
}]);

// The `$dialogProvider` can be used to configure global defaults for your
// `$dialog` service.
var dialogModule = angular.module('ui.bootstrap.dialog', ['ui.bootstrap.transition']);

dialogModule.controller('MessageBoxController', ['$scope', 'dialog', 'model', function($scope, dialog, model){
  $scope.title = model.title;
  $scope.message = model.message;
  $scope.buttons = model.buttons;
  $scope.close = function(res){
    dialog.close(res);
  };
}]);

dialogModule.provider("$dialog", function(){

  // The default options for all dialogs.
  var defaults = {
    backdrop: true,
    dialogClass: 'modal',
    backdropClass: 'modal-backdrop',
    transitionClass: 'fade',
    triggerClass: 'in',
    dialogOpenClass: 'modal-open',  
    resolve:{},
    backdropFade: false,
    dialogFade:false,
    keyboard: true, // close with esc key
    backdropClick: true // only in conjunction with backdrop=true
    /* other options: template, templateUrl, controller */
	};

	var globalOptions = {};

  var activeBackdrops = {value : 0};

  // The `options({})` allows global configuration of all dialogs in the application.
  //
  //      var app = angular.module('App', ['ui.bootstrap.dialog'], function($dialogProvider){
  //        // don't close dialog when backdrop is clicked by default
  //        $dialogProvider.options({backdropClick: false});
  //      });
	this.options = function(value){
		globalOptions = value;
	};

  // Returns the actual `$dialog` service that is injected in controllers
	this.$get = ["$http", "$document", "$compile", "$rootScope", "$controller", "$templateCache", "$q", "$transition", "$injector",
  function ($http, $document, $compile, $rootScope, $controller, $templateCache, $q, $transition, $injector) {

		var body = $document.find('body');

		function createElement(clazz) {
			var el = angular.element("<div>");
			el.addClass(clazz);
			return el;
		}

    // The `Dialog` class represents a modal dialog. The dialog class can be invoked by providing an options object
    // containing at lest template or templateUrl and controller:
    //
    //     var d = new Dialog({templateUrl: 'foo.html', controller: 'BarController'});
    //
    // Dialogs can also be created using templateUrl and controller as distinct arguments:
    //
    //     var d = new Dialog('path/to/dialog.html', MyDialogController);
		function Dialog(opts) {

      var self = this, options = this.options = angular.extend({}, defaults, globalOptions, opts);

      this.backdropEl = createElement(options.backdropClass);
      if(options.backdropFade){
        this.backdropEl.addClass(options.transitionClass);
        this.backdropEl.removeClass(options.triggerClass);
      }

      this.modalEl = createElement(options.dialogClass);
      if(options.dialogFade){
        this.modalEl.addClass(options.transitionClass);
        this.modalEl.removeClass(options.triggerClass);
      }

      this.handledEscapeKey = function(e) {
        if (e.which === 27) {
          self.close();
          e.preventDefault();
          self.$scope.$apply();
        }
      };

      this.handleBackDropClick = function(e) {
        self.close();
        e.preventDefault();
        self.$scope.$apply();
      };
    }

    // The `isOpen()` method returns wether the dialog is currently visible.
    Dialog.prototype.isOpen = function(){
      return this._open;
    };

    // The `open(templateUrl, controller)` method opens the dialog.
    // Use the `templateUrl` and `controller` arguments if specifying them at dialog creation time is not desired.
    Dialog.prototype.open = function(templateUrl, controller){
      var self = this, options = this.options;

      if(templateUrl){
        options.templateUrl = templateUrl;
      }
      if(controller){
        options.controller = controller;
      }

      if(!(options.template || options.templateUrl)) {
        throw new Error('Dialog.open expected template or templateUrl, neither found. Use options or open method to specify them.');
      }

      this._loadResolves().then(function(locals) {
        var $scope = locals.$scope = self.$scope = locals.$scope ? locals.$scope : $rootScope.$new();

        self.modalEl.html(locals.$template);

        if (self.options.controller) {
          var ctrl = $controller(self.options.controller, locals);
          self.modalEl.contents().data('ngControllerController', ctrl);
        }

        $compile(self.modalEl)($scope);
        self._addElementsToDom();
        body.addClass(self.options.dialogOpenClass);

        // trigger tranisitions
        setTimeout(function(){
          if(self.options.dialogFade){ self.modalEl.addClass(self.options.triggerClass); }
          if(self.options.backdropFade){ self.backdropEl.addClass(self.options.triggerClass); }
        });

        self._bindEvents();
      });

      this.deferred = $q.defer();
      return this.deferred.promise;
    };

    // closes the dialog and resolves the promise returned by the `open` method with the specified result.
    Dialog.prototype.close = function(result){
      var self = this;
      var fadingElements = this._getFadingElements();

      body.removeClass(self.options.dialogOpenClass);
      if(fadingElements.length > 0){
        for (var i = fadingElements.length - 1; i >= 0; i--) {
          $transition(fadingElements[i], removeTriggerClass).then(onCloseComplete);
        }
        return;
      }

      this._onCloseComplete(result);

      function removeTriggerClass(el){
        el.removeClass(self.options.triggerClass);
      }

      function onCloseComplete(){
        if(self._open){
          self._onCloseComplete(result);
        }
      }
    };

    Dialog.prototype._getFadingElements = function(){
      var elements = [];
      if(this.options.dialogFade){
        elements.push(this.modalEl);
      }
      if(this.options.backdropFade){
        elements.push(this.backdropEl);
      }

      return elements;
    };

    Dialog.prototype._bindEvents = function() {
      if(this.options.keyboard){ body.bind('keydown', this.handledEscapeKey); }
      if(this.options.backdrop && this.options.backdropClick){ this.backdropEl.bind('click', this.handleBackDropClick); }
    };

    Dialog.prototype._unbindEvents = function() {
      if(this.options.keyboard){ body.unbind('keydown', this.handledEscapeKey); }
      if(this.options.backdrop && this.options.backdropClick){ this.backdropEl.unbind('click', this.handleBackDropClick); }
    };

    Dialog.prototype._onCloseComplete = function(result) {
      this._removeElementsFromDom();
      this._unbindEvents();

      this.deferred.resolve(result);
    };

    Dialog.prototype._addElementsToDom = function(){
      body.append(this.modalEl);

      if(this.options.backdrop) { 
        if (activeBackdrops.value === 0) {
          body.append(this.backdropEl); 
        }
        activeBackdrops.value++;
      }

      this._open = true;
    };

    Dialog.prototype._removeElementsFromDom = function(){
      this.modalEl.remove();

      if(this.options.backdrop) { 
        activeBackdrops.value--;
        if (activeBackdrops.value === 0) {
          this.backdropEl.remove(); 
        }
      }
      this._open = false;
    };

    // Loads all `options.resolve` members to be used as locals for the controller associated with the dialog.
    Dialog.prototype._loadResolves = function(){
      var values = [], keys = [], templatePromise, self = this;

      if (this.options.template) {
        templatePromise = $q.when(this.options.template);
      } else if (this.options.templateUrl) {
        templatePromise = $http.get(this.options.templateUrl, {cache:$templateCache})
        .then(function(response) { return response.data; });
      }

      angular.forEach(this.options.resolve || [], function(value, key) {
        keys.push(key);
        values.push(angular.isString(value) ? $injector.get(value) : $injector.invoke(value));
      });

      keys.push('$template');
      values.push(templatePromise);

      return $q.all(values).then(function(values) {
        var locals = {};
        angular.forEach(values, function(value, index) {
          locals[keys[index]] = value;
        });
        locals.dialog = self;
        return locals;
      });
    };

    // The actual `$dialog` service that is injected in controllers.
    return {
      // Creates a new `Dialog` with the specified options.
      dialog: function(opts){
        return new Dialog(opts);
      },
      // creates a new `Dialog` tied to the default message box template and controller.
      //
      // Arguments `title` and `message` are rendered in the modal header and body sections respectively.
      // The `buttons` array holds an object with the following members for each button to include in the
      // modal footer section:
      //
      // * `result`: the result to pass to the `close` method of the dialog when the button is clicked
      // * `label`: the label of the button
      // * `cssClass`: additional css class(es) to apply to the button for styling
      messageBox: function(title, message, buttons){
        return new Dialog({templateUrl: 'template/dialog/message.html', controller: 'MessageBoxController', resolve:
          {model: function() {
            return {
              title: title,
              message: message,
              buttons: buttons
            };
          }
        }});
      }
    };
  }];
});

/*
 * dropdownToggle - Provides dropdown menu functionality in place of bootstrap js
 * @restrict class or attribute
 * @example:
   <li class="dropdown">
     <a class="dropdown-toggle">My Dropdown Menu</a>
     <ul class="dropdown-menu">
       <li ng-repeat="choice in dropChoices">
         <a ng-href="{{choice.href}}">{{choice.text}}</a>
       </li>
     </ul>
   </li>
 */

angular.module('ui.bootstrap.dropdownToggle', []).directive('dropdownToggle', 
['$document', '$location', '$window', function ($document, $location, $window) {
  var openElement = null, close;
  return {
    restrict: 'CA',
    link: function(scope, element, attrs) {
      scope.$watch(function dropdownTogglePathWatch(){return $location.path();}, function dropdownTogglePathWatchAction() {
        if (close) { close(); }
      });

      element.parent().bind('click', function(event) {
        if (close) { close(); }
      });

      element.bind('click', function(event) {
        event.preventDefault();
        event.stopPropagation();

        var iWasOpen = false;

        if (openElement) {
          iWasOpen = openElement === element;
          close();
        }

        if (!iWasOpen){
          element.parent().addClass('open');
          openElement = element;

          close = function (event) {
            if (event) {
              event.preventDefault();
              event.stopPropagation();
            }
            $document.unbind('click', close);
            element.parent().removeClass('open');
            close = null;
            openElement = null;
          };

          $document.bind('click', close);
        }
      });
    }
  };
}]);

angular.module('ui.bootstrap.modal', ['ui.bootstrap.dialog'])
.directive('modal', ['$parse', '$dialog', function($parse, $dialog) {
  var backdropEl;
  var body = angular.element(document.getElementsByTagName('body')[0]);
  return {
    restrict: 'EA',
    terminal: true,
    link: function(scope, elm, attrs) {
      var opts = angular.extend({}, scope.$eval(attrs.uiOptions || attrs.bsOptions || attrs.options));
      var shownExpr = attrs.modal || attrs.show;
      var setClosed;

      // Create a dialog with the template as the contents of the directive
      // Add the current scope as the resolve in order to make the directive scope as a dialog controller scope
      opts = angular.extend(opts, {
        template: elm.html(), 
        resolve: { $scope: function() { return scope; } }
      });
      var dialog = $dialog.dialog(opts);

      elm.remove();

      if (attrs.close) {
        setClosed = function() {
          $parse(attrs.close)(scope);
        };
      } else {
        setClosed = function() {         
          if (angular.isFunction($parse(shownExpr).assign)) {
            $parse(shownExpr).assign(scope, false); 
          }
        };
      }

      scope.$watch(shownExpr, function(isShown, oldShown) {
        if (isShown) {
          dialog.open().then(function(){
            setClosed();
          });
        } else {
          //Make sure it is not opened
          if (dialog.isOpen()){
            dialog.close();
          }
        }
      });
    }
  };
}]);
angular.module('ui.bootstrap.pagination', [])

.constant('paginationConfig', {
  boundaryLinks: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Previous',
  nextText: 'Next',
  lastText: 'Last'
})

.directive('pagination', ['paginationConfig', function(paginationConfig) {
  return {
    restrict: 'EA',
    scope: {
      numPages: '=',
      currentPage: '=',
      maxSize: '=',
      onSelectPage: '&'
    },
    templateUrl: 'template/pagination/pagination.html',
    replace: true,
    link: function(scope, element, attrs) {

      // Setup configuration parameters
      var boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
      var directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$eval(attrs.directionLinks) : paginationConfig.directionLinks;
      var firstText = angular.isDefined(attrs.firstText) ? attrs.firstText : paginationConfig.firstText;
      var previousText = angular.isDefined(attrs.previousText) ? attrs.previousText : paginationConfig.previousText;
      var nextText = angular.isDefined(attrs.nextText) ? attrs.nextText : paginationConfig.nextText;
      var lastText = angular.isDefined(attrs.lastText) ? attrs.lastText : paginationConfig.lastText;

      // Create page object used in template
      function makePage(number, text, isActive, isDisabled) {
        return {
          number: number,
          text: text,
          active: isActive,
          disabled: isDisabled
        };
      }

      scope.$watch('numPages + currentPage + maxSize', function() {
        scope.pages = [];
        
        //set the default maxSize to numPages
        var maxSize = ( scope.maxSize && scope.maxSize < scope.numPages ) ? scope.maxSize : scope.numPages;
        var startPage = scope.currentPage - Math.floor(maxSize/2);
        
        //adjust the startPage within boundary
        if(startPage < 1) {
            startPage = 1;
        }
        if ((startPage + maxSize - 1) > scope.numPages) {
            startPage = startPage - ((startPage + maxSize - 1) - scope.numPages );
        }

        // Add page number links
        for (var number = startPage, max = startPage + maxSize; number < max; number++) {
          var page = makePage(number, number, scope.isActive(number), false);
          scope.pages.push(page);
        }

        // Add previous & next links
        if (directionLinks) {
          var previousPage = makePage(scope.currentPage - 1, previousText, false, scope.noPrevious());
          scope.pages.unshift(previousPage);

          var nextPage = makePage(scope.currentPage + 1, nextText, false, scope.noNext());
          scope.pages.push(nextPage);
        }

        // Add first & last links
        if (boundaryLinks) {
          var firstPage = makePage(1, firstText, false, scope.noPrevious());
          scope.pages.unshift(firstPage);

          var lastPage = makePage(scope.numPages, lastText, false, scope.noNext());
          scope.pages.push(lastPage);
        }


        if ( scope.currentPage > scope.numPages ) {
          scope.selectPage(scope.numPages);
        }
      });
      scope.noPrevious = function() {
        return scope.currentPage === 1;
      };
      scope.noNext = function() {
        return scope.currentPage === scope.numPages;
      };
      scope.isActive = function(page) {
        return scope.currentPage === page;
      };

      scope.selectPage = function(page) {
        if ( ! scope.isActive(page) && page > 0 && page <= scope.numPages) {
          scope.currentPage = page;
          scope.onSelectPage({ page: page });
        }
      };
    }
  };
}]);
/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html popovers, and selector delegatation.
 */
angular.module( 'ui.bootstrap.popover', [] )
.directive( 'popoverPopup', function () {
  return {
    restrict: 'EA',
    replace: true,
    scope: { popoverTitle: '@', popoverContent: '@', placement: '@', animation: '&', isOpen: '&' },
    templateUrl: 'template/popover/popover.html'
  };
})
.directive( 'popover', [ '$compile', '$timeout', '$parse', '$window', function ( $compile, $timeout, $parse, $window ) {
  
  var template = 
    '<popover-popup '+
      'popover-title="{{tt_title}}" '+
      'popover-content="{{tt_popover}}" '+
      'placement="{{tt_placement}}" '+
      'animation="tt_animation()" '+
      'is-open="tt_isOpen"'+
      '>'+
    '</popover-popup>';
  
  return {
    scope: true,
    link: function ( scope, element, attr ) {
      var popover = $compile( template )( scope ), 
          transitionTimeout;

      attr.$observe( 'popover', function ( val ) {
        scope.tt_popover = val;
      });

      attr.$observe( 'popoverTitle', function ( val ) {
        scope.tt_title = val;
      });

      attr.$observe( 'popoverPlacement', function ( val ) {
        // If no placement was provided, default to 'top'.
        scope.tt_placement = val || 'top';
      });

      attr.$observe( 'popoverAnimation', function ( val ) {
        scope.tt_animation = $parse( val );
      });

      // By default, the popover is not open.
      scope.tt_isOpen = false;
      
      // Calculate the current position and size of the directive element.
      function getPosition() {
        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: element.prop( 'offsetWidth' ),
          height: element.prop( 'offsetHeight' ),
          top: boundingClientRect.top + $window.pageYOffset,
          left: boundingClientRect.left + $window.pageXOffset
        };
      }

      function show() {
        var position,
            ttWidth,
            ttHeight,
            ttPosition;
          
        // If there is a pending remove transition, we must cancel it, lest the
        // toolip be mysteriously removed.
        if ( transitionTimeout ) {
          $timeout.cancel( transitionTimeout );
        }
        
        // Set the initial positioning.
        popover.css({ top: 0, left: 0, display: 'block' });
        
        // Now we add it to the DOM because need some info about it. But it's not 
        // visible yet anyway.
        element.after( popover );
        
        // Get the position of the directive element.
        position = getPosition();
        
        // Get the height and width of the popover so we can center it.
        ttWidth = popover.prop( 'offsetWidth' );
        ttHeight = popover.prop( 'offsetHeight' );
        
        // Calculate the popover's top and left coordinates to center it with
        // this directive.
        switch ( scope.tt_placement ) {
          case 'right':
            ttPosition = {
              top: (position.top + position.height / 2 - ttHeight / 2) + 'px',
              left: (position.left + position.width) + 'px'
            };
            break;
          case 'bottom':
            ttPosition = {
              top: (position.top + position.height) + 'px',
              left: (position.left + position.width / 2 - ttWidth / 2) + 'px'
            };
            break;
          case 'left':
            ttPosition = {
              top: (position.top + position.height / 2 - ttHeight / 2) + 'px',
              left: (position.left - ttWidth) + 'px'
            };
            break;
          default:
            ttPosition = {
              top: (position.top - ttHeight) + 'px',
              left: (position.left + position.width / 2 - ttWidth / 2) + 'px'
            };
            break;
        }
        
        // Now set the calculated positioning.
        popover.css( ttPosition );
          
        // And show the popover.
        scope.tt_isOpen = true;
      }
      
      // Hide the popover popup element.
      function hide() {
        // First things first: we don't show it anymore.
        //popover.removeClass( 'in' );
        scope.tt_isOpen = false;
        
        // And now we remove it from the DOM. However, if we have animation, we 
        // need to wait for it to expire beforehand.
        // FIXME: this is a placeholder for a port of the transitions library.
        if ( angular.isDefined( scope.tt_animation ) && scope.tt_animation() ) {
          transitionTimeout = $timeout( function () { popover.remove(); }, 500 );
        } else {
          popover.remove();
        }
      }
      
      // Register the event listeners.
      element.bind( 'click', function() {
        if(scope.tt_isOpen){
            scope.$apply( hide );
        } else {
            scope.$apply( show );
        }

      });
    }
  };
}]);


angular.module('ui.bootstrap.tabs', [])
.controller('TabsController', ['$scope', '$element', function($scope, $element) {
  var panes = $scope.panes = [];

  this.select = $scope.select = function selectPane(pane) {
    angular.forEach(panes, function(pane) {
      pane.selected = false;
    });
    pane.selected = true;
  };

  this.addPane = function addPane(pane) {
    if (!panes.length) {
      $scope.select(pane);
    }
    panes.push(pane);
  };

  this.removePane = function removePane(pane) { 
    var index = panes.indexOf(pane);
    panes.splice(index, 1);
    //Select a new pane if removed pane was selected 
    if (pane.selected && panes.length > 0) {
      $scope.select(panes[index < panes.length ? index : index-1]);
    }
  };
}])
.directive('tabs', function() {
  return {
    restrict: 'EA',
    transclude: true,
    scope: {},
    controller: 'TabsController',
    templateUrl: 'template/tabs/tabs.html',
    replace: true
  };
})
.directive('pane', ['$parse', function($parse) {
  return {
    require: '^tabs',
    restrict: 'EA',
    transclude: true,
    scope:{
      heading:'@'
    },
    link: function(scope, element, attrs, tabsCtrl) {
      var getSelected, setSelected;
      scope.selected = false;
      if (attrs.active) {
        getSelected = $parse(attrs.active);
        setSelected = getSelected.assign;
        scope.$watch(
          function watchSelected() {return getSelected(scope.$parent);},
          function updateSelected(value) {scope.selected = value;}
        );
        scope.selected = getSelected ? getSelected(scope.$parent) : false;
      }
      scope.$watch('selected', function(selected) {
        if(selected) {
          tabsCtrl.select(scope);
        }
        if(setSelected) {
          setSelected(scope.$parent, selected);
        }
      });

      tabsCtrl.addPane(scope);
      scope.$on('$destroy', function() {
        tabsCtrl.removePane(scope);
      });
    },
    templateUrl: 'template/tabs/pane.html',
    replace: true
  };
}]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegatation.
 */
angular.module( 'ui.bootstrap.tooltip', [] )
.directive( 'tooltipPopup', function () {
  return {
    restrict: 'EA',
    replace: true,
    scope: { tooltipTitle: '@', placement: '@', animation: '&', isOpen: '&' },
    templateUrl: 'template/tooltip/tooltip-popup.html'
  };
})
.directive( 'tooltip', [ '$compile', '$timeout', '$parse', '$window', function ( $compile, $timeout, $parse, $window) {
  
  var template = 
    '<tooltip-popup '+
      'tooltip-title="{{tt_tooltip}}" '+
      'placement="{{tt_placement}}" '+
      'animation="tt_animation()" '+
      'is-open="tt_isOpen"'+
      '>'+
    '</tooltip-popup>';
  
  return {
    scope: true,
    link: function ( scope, element, attr ) {
      var tooltip = $compile( template )( scope ), 
          transitionTimeout;

      attr.$observe( 'tooltip', function ( val ) {
        scope.tt_tooltip = val;
      });

      attr.$observe( 'tooltipPlacement', function ( val ) {
        // If no placement was provided, default to 'top'.
        scope.tt_placement = val || 'top';
      });

      attr.$observe( 'tooltipAnimation', function ( val ) {
        scope.tt_animation = $parse( val );
      });

      // By default, the tooltip is not open.
      scope.tt_isOpen = false;
      
      // Calculate the current position and size of the directive element.
      function getPosition() {
        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: element.prop( 'offsetWidth' ),
          height: element.prop( 'offsetHeight' ),
          top: boundingClientRect.top + $window.pageYOffset,
          left: boundingClientRect.left + $window.pageXOffset
        };
      }
      
      // Show the tooltip popup element.
      function show() {
        var position,
            ttWidth,
            ttHeight,
            ttPosition;

        //don't show empty tooltips
        if (!scope.tt_tooltip) {
          return;
        }

        // If there is a pending remove transition, we must cancel it, lest the
        // toolip be mysteriously removed.
        if ( transitionTimeout ) {
          $timeout.cancel( transitionTimeout );
        }
        
        // Set the initial positioning.
        tooltip.css({ top: 0, left: 0, display: 'block' });
        
        // Now we add it to the DOM because need some info about it. But it's not 
        // visible yet anyway.
        element.after( tooltip );
        
        // Get the position of the directive element.
        position = getPosition();

        // Get the height and width of the tooltip so we can center it.
        ttWidth = tooltip.prop( 'offsetWidth' );
        ttHeight = tooltip.prop( 'offsetHeight' );
        
        // Calculate the tooltip's top and left coordinates to center it with
        // this directive.
        switch ( scope.tt_placement ) {
          case 'right':
            ttPosition = {
              top: (position.top + position.height / 2 - ttHeight / 2) + 'px',
              left: (position.left + position.width) + 'px'
            };
            break;
          case 'bottom':
            ttPosition = {
              top: (position.top + position.height) + 'px',
              left: (position.left + position.width / 2 - ttWidth / 2) + 'px'
            };
            break;
          case 'left':
            ttPosition = {
              top: (position.top + position.height / 2 - ttHeight / 2) + 'px',
              left: (position.left - ttWidth) + 'px'
            };
            break;
          default:
            ttPosition = {
              top: (position.top - ttHeight) + 'px',
              left: (position.left + position.width / 2 - ttWidth / 2) + 'px'
            };
            break;
        }
        
        // Now set the calculated positioning.
        tooltip.css( ttPosition );
          
        // And show the tooltip.
        scope.tt_isOpen = true;
      }
      
      // Hide the tooltip popup element.
      function hide() {
        // First things first: we don't show it anymore.
        //tooltip.removeClass( 'in' );
        scope.tt_isOpen = false;
        
        // And now we remove it from the DOM. However, if we have animation, we 
        // need to wait for it to expire beforehand.
        // FIXME: this is a placeholder for a port of the transitions library.
        if ( angular.isDefined( scope.tt_animation ) && scope.tt_animation() ) {
          transitionTimeout = $timeout( function () { tooltip.remove(); }, 500 );
        } else {
          tooltip.remove();
        }
      }
      
      // Register the event listeners.
      element.bind( 'mouseenter', function() {
        scope.$apply( show );
      });
      element.bind( 'mouseleave', function() {
        scope.$apply( hide );
      });
    }
  };
}]);


angular.module('ui.bootstrap.transition', [])

/**
 * $transition service provides a consistent interface to trigger CSS 3 transitions and to be informed when they complete.
 * @param  {DOMElement} element  The DOMElement that will be animated.
 * @param  {string|object|function} trigger  The thing that will cause the transition to start:
 *   - As a string, it represents the css class to be added to the element.
 *   - As an object, it represents a hash of style attributes to be applied to the element.
 *   - As a function, it represents a function to be called that will cause the transition to occur.
 * @return {Promise}  A promise that is resolved when the transition finishes.
 */
.factory('$transition', ['$q', '$timeout', '$rootScope', function($q, $timeout, $rootScope) {

  var $transition = function(element, trigger, options) {
    options = options || {};
    var deferred = $q.defer();
    var endEventName = $transition[options.animation ? "animationEndEventName" : "transitionEndEventName"];

    var transitionEndHandler = function(event) {
      $rootScope.$apply(function() {
        element.unbind(endEventName, transitionEndHandler);
        deferred.resolve(element);
      });
    };

    if (endEventName) {
      element.bind(endEventName, transitionEndHandler);
    }

    // Wrap in a timeout to allow the browser time to update the DOM before the transition is to occur
    $timeout(function() {
      if ( angular.isString(trigger) ) {
        element.addClass(trigger);
      } else if ( angular.isFunction(trigger) ) {
        trigger(element);
      } else if ( angular.isObject(trigger) ) {
        element.css(trigger);
      }
      //If browser does not support transitions, instantly resolve
      if ( !endEventName ) {
        deferred.resolve(element);
      }
    });

    // Add our custom cancel function to the promise that is returned
    // We can call this if we are about to run a new transition, which we know will prevent this transition from ending,
    // i.e. it will therefore never raise a transitionEnd event for that transition
    deferred.promise.cancel = function() {
      if ( endEventName ) {
        element.unbind(endEventName, transitionEndHandler);
      }
      deferred.reject('Transition cancelled');
    };

    return deferred.promise;
  };

  // Work out the name of the transitionEnd event
  var transElement = document.createElement('trans');
  var transitionEndEventNames = {
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'msTransition': 'MSTransitionEnd',
    'transition': 'transitionend'
  };
  var animationEndEventNames = {
    'WebkitTransition': 'webkitAnimationEnd',
    'MozTransition': 'animationend',
    'OTransition': 'oAnimationEnd',
    'msTransition': 'MSAnimationEnd',
    'transition': 'animationend'
  };
  function findEndEventName(endEventNames) {
    for (var name in endEventNames){
      if (transElement.style[name] !== undefined) {
        return endEventNames[name];
      }
    }
  }
  $transition.transitionEndEventName = findEndEventName(transitionEndEventNames);
  $transition.animationEndEventName = findEndEventName(animationEndEventNames);
  return $transition;
}]);

angular.module('ui.bootstrap.typeahead', [])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
  .factory('typeaheadParser', ['$parse', function ($parse) {

  //                      00000111000000000000022200000000000000003333333333333330000000000044000
  var TYPEAHEAD_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+(.*)$/;

  return {
    parse:function (input) {

      var match = input.match(TYPEAHEAD_REGEXP), modelMapper, viewMapper, source;
      if (!match) {
        throw new Error(
          "Expected typeahead specification in form of '_modelValue_ (as _label_)? for _item_ in _collection_'" +
            " but got '" + input + "'.");
      }

      return {
        itemName:match[3],
        source:$parse(match[4]),
        viewMapper:$parse(match[2] || match[1]),
        modelMapper:$parse(match[1])
      };
    }
  };
}])

  //options - min length
  .directive('typeahead', ['$compile', '$q', 'typeaheadParser', function ($compile, $q, typeaheadParser) {

  var HOT_KEYS = [9, 13, 27, 38, 40];

  return {
    require:'ngModel',
    link:function (originalScope, element, attrs, modelCtrl) {

      var selected = modelCtrl.$modelValue;

      //minimal no of characters that needs to be entered before typeahead kicks-in
      var minSearch = originalScope.$eval(attrs.typeaheadMinLength) || 1;

      //expressions used by typeahead
      var parserResult = typeaheadParser.parse(attrs.typeahead);

      //create a child scope for the typeahead directive so we are not polluting original scope
      //with typeahead-specific data (matches, query etc.)
      var scope = originalScope.$new();
      originalScope.$on('$destroy', function(){
        scope.$destroy();
      });

      var resetMatches = function() {
        scope.matches = [];
        scope.activeIdx = -1;
      };

      var getMatchesAsync = function(inputValue) {

        var locals = {$viewValue: inputValue};
        $q.when(parserResult.source(scope, locals)).then(function(matches) {

          //it might happen that several async queries were in progress if a user were typing fast
          //but we are interested only in responses that correspond to the current view value
          if (inputValue === modelCtrl.$viewValue) {
            if (matches.length > 0) {

              scope.activeIdx = 0;
              scope.matches.length = 0;

              //transform labels
              for(var i=0; i<matches.length; i++) {
                locals[parserResult.itemName] = matches[i];
                scope.matches.push({
                  label: parserResult.viewMapper(scope, locals),
                  model: matches[i]
                });
              }

              scope.query = inputValue;

            } else {
              resetMatches();
            }
          }
        }, resetMatches);
      };

      resetMatches();

      //we need to propagate user's query so we can higlight matches
      scope.query = undefined;

      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
      //$parsers kick-in on all the changes coming from the vview as well as manually triggered by $setViewValue
      modelCtrl.$parsers.push(function (inputValue) {

        resetMatches();
        if (selected) {
          return inputValue;
        } else {
          if (inputValue && inputValue.length >= minSearch) {
            getMatchesAsync(inputValue);
          }
        }

        return undefined;
      });

      modelCtrl.$render = function () {
        var locals = {};
        locals[parserResult.itemName] = selected;
        element.val(parserResult.viewMapper(scope, locals) || modelCtrl.$viewValue);
        selected = undefined;
      };

      scope.select = function (activeIdx) {
        //called from within the $digest() cycle
        var locals = {};
        locals[parserResult.itemName] = selected = scope.matches[activeIdx].model;

        modelCtrl.$setViewValue(parserResult.modelMapper(scope, locals));
        modelCtrl.$render();
      };

      //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(9)
      element.bind('keydown', function (evt) {

        //typeahead is open and an "interesting" key was pressed
        if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
          return;
        }

        evt.preventDefault();

        if (evt.which === 40) {
          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
          scope.$digest();

        } else if (evt.which === 38) {
          scope.activeIdx = (scope.activeIdx ? scope.activeIdx : scope.matches.length) - 1;
          scope.$digest();

        } else if (evt.which === 13 || evt.which === 9) {
          scope.$apply(function () {
            scope.select(scope.activeIdx);
          });

        } else if (evt.which === 27) {
          scope.matches = [];
          scope.$digest();
        }
      });

      var tplElCompiled = $compile("<typeahead-popup matches='matches' active='activeIdx' select='select(activeIdx)' "+
        "query='query'></typeahead-popup>")(scope);
      element.after(tplElCompiled);
    }
  };

}])

  .directive('typeaheadPopup', function () {
    return {
      restrict:'E',
      scope:{
        matches:'=',
        query:'=',
        active:'=',
        select:'&'
      },
      replace:true,
      templateUrl:'template/typeahead/typeahead.html',
      link:function (scope, element, attrs) {

        scope.isOpen = function () {
          return scope.matches.length > 0;
        };

        scope.isActive = function (matchIdx) {
          return scope.active == matchIdx;
        };

        scope.selectActive = function (matchIdx) {
          scope.active = matchIdx;
        };

        scope.selectMatch = function (activeIdx) {
          scope.select({activeIdx:activeIdx});
        };
      }
    };
  })

  .filter('typeaheadHighlight', function() {
    return function(matchItem, query) {
      return (query) ? matchItem.replace(new RegExp(query, 'gi'), '<strong>$&</strong>') : query;
    };
  });
angular.module("template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache){
  $templateCache.put("template/accordion/accordion-group.html",
    "<div class=\"accordion-group\">" +
    "  <div class=\"accordion-heading\" ><a class=\"accordion-toggle\" ng-click=\"isOpen = !isOpen\" accordion-transclude=\"heading\">{{heading}}</a></div>" +
    "  <div class=\"accordion-body\" collapse=\"!isOpen\">" +
    "    <div class=\"accordion-inner\" ng-transclude></div>  </div>" +
    "</div>");
}]);

angular.module("template/accordion/accordion.html", []).run(["$templateCache", function($templateCache){
  $templateCache.put("template/accordion/accordion.html",
    "<div class=\"accordion\" ng-transclude></div>");
}]);

angular.module("template/alert/alert.html", []).run(["$templateCache", function($templateCache){
  $templateCache.put("template/alert/alert.html",
    "<div class='alert' ng-class='type && \"alert-\" + type'>" +
    "    <button type='button' class='close' ng-click='close()'>&times;</button>" +
    "    <div ng-transclude></div>" +
    "</div>");
}]);

angular.module("template/carousel/carousel.html", []).run(["$templateCache", function($templateCache){
  $templateCache.put("template/carousel/carousel.html",
    "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\">" +
    "    <ol class=\"carousel-indicators\">" +
    "        <li ng-repeat=\"slide in slides()\" ng-class=\"{active: isActive(slide)}\" ng-click=\"select(slide)\"></li>" +
    "    </ol>" +
    "    <div class=\"carousel-inner\" ng-transclude></div>" +
    "    <a ng-click=\"prev()\" class=\"carousel-control left\">&lsaquo;</a>" +
    "    <a ng-click=\"next()\" class=\"carousel-control right\">&rsaquo;</a>" +
    "</div>" +
    "");
}]);

angular.module("template/carousel/slide.html", []).run(["$templateCache", function($templateCache){
  $templateCache.put("template/carousel/slide.html",
    "<div ng-class=\"{" +
    "    'active': leaving || (active && !entering)," +
    "    'prev': (next || active) && direction=='prev'," +
    "    'next': (next || active) && direction=='next'," +
    "    'right': direction=='prev'," +
    "    'left': direction=='next'" +
    "  }\" class=\"item\" ng-transclude></div>" +
    "");
}]);

angular.module("template/dialog/message.html", []).run(["$templateCache", function($templateCache){
  $templateCache.put("template/dialog/message.html",
    "<div class=\"modal-header\">" +
    "	<h1>{{ title }}</h1>" +
    "</div>" +
    "<div class=\"modal-body\">" +
    "	<p>{{ message }}</p>" +
    "</div>" +
    "<div class=\"modal-footer\">" +
    "	<button ng-repeat=\"btn in buttons\" ng-click=\"close(btn.result)\" class=btn ng-class=\"btn.cssClass\">{{ btn.label }}</button>" +
    "</div>" +
    "");
}]);

angular.module("template/pagination/pagination.html", []).run(["$templateCache", function($templateCache){
  $templateCache.put("template/pagination/pagination.html",
    "<div class=\"pagination\"><ul>" +
    "  <li ng-repeat=\"page in pages\" ng-class=\"{active: page.active, disabled: page.disabled}\"><a ng-click=\"selectPage(page.number)\">{{page.text}}</a></li>" +
    "  </ul>" +
    "</div>" +
    "");
}]);

angular.module("template/popover/popover.html", []).run(["$templateCache", function($templateCache){
  $templateCache.put("template/popover/popover.html",
    "<div class=\"popover {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">" +
    "  <div class=\"arrow\"></div>" +
    "" +
    "  <div class=\"popover-inner\">" +
    "      <h3 class=\"popover-title\" ng-bind=\"popoverTitle\" ng-show=\"popoverTitle\"></h3>" +
    "      <div class=\"popover-content\" ng-bind=\"popoverContent\"></div>" +
    "  </div>" +
    "</div>" +
    "");
}]);

angular.module("template/tabs/pane.html", []).run(["$templateCache", function($templateCache){
  $templateCache.put("template/tabs/pane.html",
    "<div class=\"tab-pane\" ng-class=\"{active: selected}\" ng-show=\"selected\" ng-transclude></div>" +
    "");
}]);

angular.module("template/tabs/tabs.html", []).run(["$templateCache", function($templateCache){
  $templateCache.put("template/tabs/tabs.html",
    "<div class=\"tabbable\">" +
    "  <ul class=\"nav nav-tabs\">" +
    "    <li ng-repeat=\"pane in panes\" ng-class=\"{active:pane.selected}\">" +
    "      <a href=\"\" ng-click=\"select(pane)\">{{pane.heading}}</a>" +
    "    </li>" +
    "  </ul>" +
    "  <div class=\"tab-content\" ng-transclude></div>" +
    "</div>" +
    "");
}]);

angular.module("template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache){
  $templateCache.put("template/tooltip/tooltip-popup.html",
    "<div class=\"tooltip {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">" +
    "  <div class=\"tooltip-arrow\"></div>" +
    "  <div class=\"tooltip-inner\" ng-bind=\"tooltipTitle\"></div>" +
    "</div>" +
    "");
}]);

angular.module("template/typeahead/typeahead.html", []).run(["$templateCache", function($templateCache){
  $templateCache.put("template/typeahead/typeahead.html",
    "<div class=\"dropdown clearfix\" ng-class=\"{open: isOpen()}\">" +
    "    <ul class=\"typeahead dropdown-menu\">" +
    "        <li ng-repeat=\"match in matches\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\">" +
    "            <a tabindex=\"-1\" ng-click=\"selectMatch($index)\" ng-bind-html-unsafe=\"match.label | typeaheadHighlight:query\"></a>" +
    "        </li>" +
    "    </ul>" +
    "</div>");
}]);

(function(angular, factory) {
    'use strict';

    if (typeof define === 'function' && define.amd) {
        define(['angular'], function(angular) {
            return factory(angular);
        });
    } else {
        return factory(angular);
    }
}(angular || null, function(angular) {
    'use strict';
/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc module
 * @name ngTable
 * @description ngTable: Table + Angular JS
 * @example
 <doc:example>
 <doc:source>
 <script>
 var app = angular.module('myApp', ['ngTable']);
 app.controller('MyCtrl', function($scope) {
                    $scope.users = [
                        {name: "Moroni", age: 50},
                        {name: "Tiancum", age: 43},
                        {name: "Jacob", age: 27},
                        {name: "Nephi", age: 29},
                        {name: "Enos", age: 34}
                    ];
                });
 </script>
 <table ng-table class="table">
 <tr ng-repeat="user in users">
 <td data-title="'Name'">{{user.name}}</td>
 <td data-title="'Age'">{{user.age}}</td>
 </tr>
 </table>
 </doc:source>
 </doc:example>
 */
var app = angular.module('ngTable', []);
/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc service
 * @name ngTable.factory:ngTableParams
 * @description Parameters manager for ngTable
 */
app.factory('ngTableParams', ['$q', '$log', function ($q, $log) {
    var isNumber = function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    };
    var ngTableParams = function (baseParameters, baseSettings) {
        var self = this,
            log = function () {
                if (settings.debugMode && $log.debug) {
                    $log.debug.apply(this, arguments);
                }
            };

        this.data = [];

        /**
         * @ngdoc method
         * @name ngTable.factory:ngTableParams#parameters
         * @methodOf ngTable.factory:ngTableParams
         * @description Set new parameters or get current parameters
         *
         * @param {string} newParameters      New parameters
         * @param {string} parseParamsFromUrl Flag if parse parameters like in url
         * @returns {Object} Current parameters or `this`
         */
        this.parameters = function (newParameters, parseParamsFromUrl) {
            parseParamsFromUrl = parseParamsFromUrl || false;
            if (angular.isDefined(newParameters)) {
                for (var key in newParameters) {
                    var value = newParameters[key];
                    if (parseParamsFromUrl && key.indexOf('[') >= 0) {
                        var keys = key.split(/\[(.*)\]/).reverse()
                        var lastKey = '';
                        for (var i = 0, len = keys.length; i < len; i++) {
                            var name = keys[i];
                            if (name !== '') {
                                var v = value;
                                value = {};
                                value[lastKey = name] = (isNumber(v) ? parseFloat(v) : v);
                            }
                        }
                        if (lastKey === 'sorting') {
                            params[lastKey] = {};
                        }
                        params[lastKey] = angular.extend(params[lastKey] || {}, value[lastKey]);
                    } else {
                        params[key] = (isNumber(newParameters[key]) ? parseFloat(newParameters[key]) : newParameters[key]);
                    }
                }
                log('ngTable: set parameters', params);
                return this;
            }
            return params;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:ngTableParams#settings
         * @methodOf ngTable.factory:ngTableParams
         * @description Set new settings for table
         *
         * @param {string} newSettings New settings or undefined
         * @returns {Object} Current settings or `this`
         */
        this.settings = function (newSettings) {
            if (angular.isDefined(newSettings)) {
                if (angular.isArray(newSettings.data)) {
                    //auto-set the total from passed in data
                    newSettings.total = newSettings.data.length;
                }
                settings = angular.extend(settings, newSettings);
                log('ngTable: set settings', settings);
                return this;
            }
            return settings;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:ngTableParams#page
         * @methodOf ngTable.factory:ngTableParams
         * @description If parameter page not set return current page else set current page
         *
         * @param {string} page Page number
         * @returns {Object|Number} Current page or `this`
         */
        this.page = function (page) {
            return angular.isDefined(page) ? this.parameters({'page': page}) : params.page;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:ngTableParams#total
         * @methodOf ngTable.factory:ngTableParams
         * @description If parameter total not set return current quantity else set quantity
         *
         * @param {string} total Total quantity of items
         * @returns {Object|Number} Current page or `this`
         */
        this.total = function (total) {
            return angular.isDefined(total) ? this.settings({'total': total}) : settings.total;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:ngTableParams#count
         * @methodOf ngTable.factory:ngTableParams
         * @description If parameter count not set return current count per page else set count per page
         *
         * @param {string} count Count per number
         * @returns {Object|Number} Count per page or `this`
         */
        this.count = function (count) {
            // reset to first page because can be blank page
            return angular.isDefined(count) ? this.parameters({'count': count, 'page': 1}) : params.count;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:ngTableParams#filter
         * @methodOf ngTable.factory:ngTableParams
         * @description If parameter page not set return current filter else set current filter
         *
         * @param {string} filter New filter
         * @returns {Object} Current filter or `this`
         */
        this.filter = function (filter) {
            return angular.isDefined(filter) ? this.parameters({'filter': filter}) : params.filter;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:ngTableParams#sorting
         * @methodOf ngTable.factory:ngTableParams
         * @description If 'sorting' parameter is not set, return current sorting. Otherwise set current sorting.
         *
         * @param {string} sorting New sorting
         * @returns {Object} Current sorting or `this`
         */
        this.sorting = function (sorting) {
            if (arguments.length == 2) {
                var sortArray = {};
                sortArray[sorting] = arguments[1];
                this.parameters({'sorting': sortArray});
                return this;
            }
            return angular.isDefined(sorting) ? this.parameters({'sorting': sorting}) : params.sorting;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:ngTableParams#isSortBy
         * @methodOf ngTable.factory:ngTableParams
         * @description Checks sort field
         *
         * @param {string} field     Field name
         * @param {string} direction Direction of sorting 'asc' or 'desc'
         * @returns {Array} Return true if field sorted by direction
         */
        this.isSortBy = function (field, direction) {
            return angular.isDefined(params.sorting[field]) && params.sorting[field] == direction;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:ngTableParams#orderBy
         * @methodOf ngTable.factory:ngTableParams
         * @description Return object of sorting parameters for angular filter
         *
         * @returns {Array} Array like: [ '-name', '+age' ]
         */
        this.orderBy = function () {
            var sorting = [];
            for (var column in params.sorting) {
                sorting.push((params.sorting[column] === "asc" ? "+" : "-") + column);
            }
            return sorting;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:ngTableParams#getData
         * @methodOf ngTable.factory:ngTableParams
         * @description Called when updated some of parameters for get new data
         *
         * @param {Object} $defer promise object
         * @param {Object} params New parameters
         */
        this.getData = function ($defer, params) {
            if (angular.isArray(this.data) && angular.isObject(params)) {
                $defer.resolve(this.data.slice((params.page() - 1) * params.count(), params.page() * params.count()));
            } else {
                $defer.resolve([]);
            }
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:ngTableParams#getGroups
         * @methodOf ngTable.factory:ngTableParams
         * @description Return groups for table grouping
         */
        this.getGroups = function ($defer, column) {
            var defer = $q.defer();

            defer.promise.then(function (data) {
                var groups = {};
                angular.forEach(data, function (item) {
                    var groupName = angular.isFunction(column) ? column(item) : item[column];

                    groups[groupName] = groups[groupName] || {
                        data: []
                    };
                    groups[groupName]['value'] = groupName;
                    groups[groupName].data.push(item);
                });
                var result = [];
                for (var i in groups) {
                    result.push(groups[i]);
                }
                log('ngTable: refresh groups', result);
                $defer.resolve(result);
            });
            this.getData(defer, self);
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:ngTableParams#generatePagesArray
         * @methodOf ngTable.factory:ngTableParams
         * @description Generate array of pages
         *
         * @param {boolean} currentPage which page must be active
         * @param {boolean} totalItems  Total quantity of items
         * @param {boolean} pageSize    Quantity of items on page
         * @returns {Array} Array of pages
         */
        this.generatePagesArray = function (currentPage, totalItems, pageSize) {
            var maxBlocks, maxPage, maxPivotPages, minPage, numPages, pages;
            maxBlocks = 11;
            pages = [];
            numPages = Math.ceil(totalItems / pageSize);
            if (numPages > 1) {
                pages.push({
                    type: 'prev',
                    number: Math.max(1, currentPage - 1),
                    active: currentPage > 1
                });
                pages.push({
                    type: 'first',
                    number: 1,
                    active: currentPage > 1
                });
                maxPivotPages = Math.round((maxBlocks - 5) / 2);
                minPage = Math.max(2, currentPage - maxPivotPages);
                maxPage = Math.min(numPages - 1, currentPage + maxPivotPages * 2 - (currentPage - minPage));
                minPage = Math.max(2, minPage - (maxPivotPages * 2 - (maxPage - minPage)));
                var i = minPage;
                while (i <= maxPage) {
                    if ((i === minPage && i !== 2) || (i === maxPage && i !== numPages - 1)) {
                        pages.push({
                            type: 'more',
                            active: false
                        });
                    } else {
                        pages.push({
                            type: 'page',
                            number: i,
                            active: currentPage !== i
                        });
                    }
                    i++;
                }
                pages.push({
                    type: 'last',
                    number: numPages,
                    active: currentPage !== numPages
                });
                pages.push({
                    type: 'next',
                    number: Math.min(numPages, currentPage + 1),
                    active: currentPage < numPages
                });
            }
            return pages;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:ngTableParams#url
         * @methodOf ngTable.factory:ngTableParams
         * @description Return groups for table grouping
         *
         * @param {boolean} asString flag indicates return array of string or object
         * @returns {Array} If asString = true will be return array of url string parameters else key-value object
         */
        this.url = function (asString) {
            asString = asString || false;
            var pairs = (asString ? [] : {});
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var item = params[key],
                        name = encodeURIComponent(key);
                    if (typeof item === "object") {
                        for (var subkey in item) {
                            if (!angular.isUndefined(item[subkey]) && item[subkey] !== "") {
                                var pname = name + "[" + encodeURIComponent(subkey) + "]";
                                if (asString) {
                                    pairs.push(pname + "=" + item[subkey]);
                                } else {
                                    pairs[pname] = item[subkey];
                                }
                            }
                        }
                    } else if (!angular.isFunction(item) && !angular.isUndefined(item) && item !== "") {
                        if (asString) {
                            pairs.push(name + "=" + encodeURIComponent(item));
                        } else {
                            pairs[name] = encodeURIComponent(item);
                        }
                    }
                }
            }
            return pairs;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:ngTableParams#reload
         * @methodOf ngTable.factory:ngTableParams
         * @description Reload table data
         */
        this.reload = function () {
            var $defer = $q.defer(),
                self = this;

            settings.$loading = true;
            if (settings.groupBy) {
                settings.getGroups($defer, settings.groupBy, this);
            } else {
                settings.getData($defer, this);
            }
            log('ngTable: reload data');
            $defer.promise.then(function (data) {
                settings.$loading = false;
                log('ngTable: current scope', settings.$scope);
                if (settings.groupBy) {
                    self.data = settings.$scope.$groups = data;
                } else {
                    self.data = settings.$scope.$data = data;
                }
                settings.$scope.pages = self.generatePagesArray(self.page(), self.total(), self.count());
                settings.$scope.$emit('ngTableAfterReloadData');
            });
        };

        this.reloadPages = function () {
            var self = this;
            settings.$scope.pages = self.generatePagesArray(self.page(), self.total(), self.count());
        };

        var params = this.$params = {
            page: 1,
            count: 1,
            filter: {},
            sorting: {},
            group: {},
            groupBy: null
        };
        var settings = {
            $scope: null, // set by ngTable controller
            $loading: false,
            data: null, //allows data to be set when table is initialized
            total: 0,
            defaultSort: 'desc',
            filterDelay: 750,
            counts: [10, 25, 50, 100],
            getGroups: this.getGroups,
            getData: this.getData
        };

        this.settings(baseSettings);
        this.parameters(baseParameters, true);
        return this;
    };
    return ngTableParams;
}]);

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc object
 * @name ngTable.directive:ngTable.ngTableController
 *
 * @description
 * Each {@link ngTable.directive:ngTable ngTable} directive creates an instance of `ngTableController`
 */
var ngTableController = ['$scope', 'ngTableParams', '$timeout', function ($scope, ngTableParams, $timeout) {
    $scope.$loading = false;

    if (!$scope.params) {
        $scope.params = new ngTableParams();
    }
    $scope.params.settings().$scope = $scope;

    var delayFilter = (function () {
        var timer = 0;
        return function (callback, ms) {
            $timeout.cancel(timer);
            timer = $timeout(callback, ms);
        };
    })();

    $scope.$watch('params.$params', function (newParams, oldParams) {
        $scope.params.settings().$scope = $scope;

        if (!angular.equals(newParams.filter, oldParams.filter)) {
            delayFilter(function () {
                $scope.params.$params.page = 1;
                $scope.params.reload();
            }, $scope.params.settings().filterDelay);
        } else {
            $scope.params.reload();
        }
    }, true);

    $scope.sortBy = function (column, event) {
        var parsedSortable = $scope.parse(column.sortable);
        if (!parsedSortable) {
            return;
        }
        var defaultSort = $scope.params.settings().defaultSort;
        var inverseSort = (defaultSort === 'asc' ? 'desc' : 'asc');
        var sorting = $scope.params.sorting() && $scope.params.sorting()[parsedSortable] && ($scope.params.sorting()[parsedSortable] === defaultSort);
        var sortingParams = (event.ctrlKey || event.metaKey) ? $scope.params.sorting() : {};
        sortingParams[parsedSortable] = (sorting ? inverseSort : defaultSort);
        $scope.params.parameters({
            sorting: sortingParams
        });
    };
}];
/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc directive
 * @name ngTable.directive:ngTable
 * @restrict A
 *
 * @description
 * Directive that instantiates {@link ngTable.directive:ngTable.ngTableController ngTableController}.
 */
app.directive('ngTable', ['$compile', '$q', '$parse',
    function ($compile, $q, $parse) {
        'use strict';

        return {
            restrict: 'A',
            priority: 1001,
            scope: true,
            controller: ngTableController,
            compile: function (element) {
                var columns = [], i = 0, row = null;

                // custom header
                var thead = element.find('thead');

                // IE 8 fix :not(.ng-table-group) selector
                angular.forEach(angular.element(element.find('tr')), function (tr) {
                    tr = angular.element(tr);
                    if (!tr.hasClass('ng-table-group') && !row) {
                        row = tr;
                    }
                });
                if (!row) {
                    return;
                }
                angular.forEach(row.find('td'), function (item) {
                    var el = angular.element(item);
                    if (el.attr('ignore-cell') && 'true' === el.attr('ignore-cell')) {
                        return;
                    }
                    var parsedAttribute = function (attr, defaultValue) {
                        return function (scope) {
                            return $parse(el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr))(scope, {
                                $columns: columns
                            }) || defaultValue;
                        };
                    };

                    var parsedTitle = parsedAttribute('title', ' '),
                        headerTemplateURL = parsedAttribute('header', false),
                        filter = parsedAttribute('filter', false)(),
                        filterTemplateURL = false,
                        filterName = false;

                    if (filter && filter.$$name) {
                        filterName = filter.$$name;
                        delete filter.$$name;
                    }
                    if (filter && filter.templateURL) {
                        filterTemplateURL = filter.templateURL;
                        delete filter.templateURL;
                    }

                    el.attr('data-title-text', parsedTitle()); // this used in responsive table
                    columns.push({
                        id: i++,
                        title: parsedTitle,
                        sortable: parsedAttribute('sortable', false),
                        'class': el.attr('x-data-header-class') || el.attr('data-header-class') || el.attr('header-class'),
                        filter: filter,
                        filterTemplateURL: filterTemplateURL,
                        filterName: filterName,
                        headerTemplateURL: headerTemplateURL,
                        filterData: (el.attr("filter-data") ? el.attr("filter-data") : null),
                        show: (el.attr("ng-show") ? function (scope) {
                            return $parse(el.attr("ng-show"))(scope);
                        } : function () {
                            return true;
                        })
                    });
                });
                return function (scope, element, attrs) {
                    scope.$loading = false;
                    scope.$columns = columns;

                    scope.$watch(attrs.ngTable, (function (params) {
                        if (angular.isUndefined(params)) {
                            return;
                        }
                        scope.paramsModel = $parse(attrs.ngTable);
                        scope.params = params;
                    }), true);
                    scope.parse = function (text) {
                        return angular.isDefined(text) ? text(scope) : '';
                    };
                    if (attrs.showFilter) {
                        scope.$parent.$watch(attrs.showFilter, function (value) {
                            scope.show_filter = value;
                        });
                    }
                    angular.forEach(columns, function (column) {
                        var def;
                        if (!column.filterData) {
                            return;
                        }
                        def = $parse(column.filterData)(scope, {
                            $column: column
                        });
                        if (!(angular.isObject(def) && angular.isObject(def.promise))) {
                            throw new Error('Function ' + column.filterData + ' must be instance of $q.defer()');
                        }
                        delete column.filterData;
                        return def.promise.then(function (data) {
                            if (!angular.isArray(data)) {
                                data = [];
                            }
                            data.unshift({
                                title: '-',
                                id: ''
                            });
                            column.data = data;
                        });
                    });
                    if (!element.hasClass('ng-table')) {
                        scope.templates = {
                            header: (attrs.templateHeader ? attrs.templateHeader : 'ng-table/header.html'),
                            pagination: (attrs.templatePagination ? attrs.templatePagination : 'ng-table/pager.html')
                        };
                        var headerTemplate = thead.length > 0 ? thead : angular.element(document.createElement('thead')).attr('ng-include', 'templates.header');
                        var paginationTemplate = angular.element(document.createElement('div')).attr({
                            'ng-table-pagination': 'params',
                            'template-url': 'templates.pagination'
                        });

                        element.find('thead').remove();

                        element.addClass('ng-table')
                            .prepend(headerTemplate)
                            .after(paginationTemplate);

                        $compile(headerTemplate)(scope);
                        $compile(paginationTemplate)(scope);
                    }
                };
            }
        }
    }
]);

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc directive
 * @name ngTable.directive:ngTablePagination
 * @restrict A
 */
app.directive('ngTablePagination', ['$compile',
    function ($compile) {
        'use strict';

        return {
            restrict: 'A',
            scope: {
                'params': '=ngTablePagination',
                'templateUrl': '='
            },
            replace: false,
            link: function (scope, element, attrs) {

                scope.params.settings().$scope.$on('ngTableAfterReloadData', function () {
                    scope.pages = scope.params.generatePagesArray(scope.params.page(), scope.params.total(), scope.params.count());
                }, true);

                scope.$watch('templateUrl', function(templateUrl) {
                    if (angular.isUndefined(templateUrl)) {
                        return;
                    }
                    var template = angular.element(document.createElement('div'))
                    template.attr({
                        'ng-include': 'templateUrl'
                    });
                    element.append(template);
                    $compile(template)(scope);
                });
            }
        };
    }
]);

angular.module('ngTable').run(['$templateCache', function ($templateCache) {
	$templateCache.put('ng-table/filters/select-multiple.html', '<select ng-options="data.id as data.title for data in column.data" multiple ng-multiple="true" ng-model="params.filter()[name]" ng-show="filter==\'select-multiple\'" class="filter filter-select-multiple form-control" name="{{column.filterName}}"> </select>');
	$templateCache.put('ng-table/filters/select.html', '<select ng-options="data.id as data.title for data in column.data" ng-model="params.filter()[name]" ng-show="filter==\'select\'" class="filter filter-select form-control" name="{{column.filterName}}"> </select>');
	$templateCache.put('ng-table/filters/text.html', '<input type="text" name="{{column.filterName}}" ng-model="params.filter()[name]" ng-if="filter==\'text\'" class="input-filter form-control"/>');
	$templateCache.put('ng-table/header.html', '<tr> <th ng-repeat="column in $columns" ng-class="{ \'sortable\': parse(column.sortable), \'sort-asc\': params.sorting()[parse(column.sortable)]==\'asc\', \'sort-desc\': params.sorting()[parse(column.sortable)]==\'desc\' }" ng-click="sortBy(column, $event)" ng-show="column.show(this)" ng-init="template=column.headerTemplateURL(this)" class="header {{column.class}}"> <div ng-if="!template" ng-show="!template" ng-bind="parse(column.title)"></div> <div ng-if="template" ng-show="template"><div ng-include="template"></div></div> </th> </tr> <tr ng-show="show_filter" class="ng-table-filters"> <th ng-repeat="column in $columns" ng-show="column.show(this)" class="filter"> <div ng-repeat="(name, filter) in column.filter"> <div ng-if="column.filterTemplateURL" ng-show="column.filterTemplateURL"> <div ng-include="column.filterTemplateURL"></div> </div> <div ng-if="!column.filterTemplateURL" ng-show="!column.filterTemplateURL"> <div ng-include="\'ng-table/filters/\' + filter + \'.html\'"></div> </div> </div> </th> </tr>');
	$templateCache.put('ng-table/pager.html', '<div class="ng-cloak ng-table-pager"> <div ng-if="params.settings().counts.length" class="ng-table-counts btn-group pull-right"> <button ng-repeat="count in params.settings().counts" type="button" ng-class="{\'active\':params.count()==count}" ng-click="params.count(count)" class="btn btn-default"> <span ng-bind="count"></span> </button> </div> <ul class="pagination ng-table-pagination"> <li ng-class="{\'disabled\': !page.active}" ng-repeat="page in pages" ng-switch="page.type"> <a ng-switch-when="prev" ng-click="params.page(page.number)" href="">&laquo;</a> <a ng-switch-when="first" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="page" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="more" ng-click="params.page(page.number)" href="">&#8230;</a> <a ng-switch-when="last" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="next" ng-click="params.page(page.number)" href="">&raquo;</a> </li> </ul> </div> ');
}]);
    return app;
}));
/*!
 * BootstrapValidator (http://bootstrapvalidator.com)
 * The best jQuery plugin to validate form fields. Designed to use with Bootstrap 3
 *
 * @version     v0.5.1, built on 2014-08-22 4:55:10 PM
 * @author      https://twitter.com/nghuuphuoc
 * @copyright   (c) 2013 - 2014 Nguyen Huu Phuoc
 * @license     MIT
 */
!function(a){var b=function(b,c){this.$form=a(b),this.options=a.extend({},a.fn.bootstrapValidator.DEFAULT_OPTIONS,c),this.$invalidFields=a([]),this.$submitButton=null,this.$hiddenButton=null,this.STATUS_NOT_VALIDATED="NOT_VALIDATED",this.STATUS_VALIDATING="VALIDATING",this.STATUS_INVALID="INVALID",this.STATUS_VALID="VALID";var d=function(){for(var a=3,b=document.createElement("div"),c=b.all||[];b.innerHTML="<!--[if gt IE "+ ++a+"]><br><![endif]-->",c[0];);return a>4?a:!a}(),e=document.createElement("div");this._changeEvent=9!==d&&"oninput"in e?"input":"keyup",this._submitIfValid=null,this._cacheFields={},this._init()};b.prototype={constructor:b,_init:function(){var b=this,c={excluded:this.$form.attr("data-bv-excluded"),trigger:this.$form.attr("data-bv-trigger"),message:this.$form.attr("data-bv-message"),container:this.$form.attr("data-bv-container"),group:this.$form.attr("data-bv-group"),submitButtons:this.$form.attr("data-bv-submitbuttons"),threshold:this.$form.attr("data-bv-threshold"),live:this.$form.attr("data-bv-live"),onSuccess:this.$form.attr("data-bv-onsuccess"),onError:this.$form.attr("data-bv-onerror"),fields:{},feedbackIcons:{valid:this.$form.attr("data-bv-feedbackicons-valid"),invalid:this.$form.attr("data-bv-feedbackicons-invalid"),validating:this.$form.attr("data-bv-feedbackicons-validating")},events:{formInit:this.$form.attr("data-bv-events-form-init"),formError:this.$form.attr("data-bv-events-form-error"),formSuccess:this.$form.attr("data-bv-events-form-success"),fieldAdded:this.$form.attr("data-bv-events-field-added"),fieldRemoved:this.$form.attr("data-bv-events-field-removed"),fieldInit:this.$form.attr("data-bv-events-field-init"),fieldError:this.$form.attr("data-bv-events-field-error"),fieldSuccess:this.$form.attr("data-bv-events-field-success"),fieldStatus:this.$form.attr("data-bv-events-field-status"),validatorError:this.$form.attr("data-bv-events-validator-error"),validatorSuccess:this.$form.attr("data-bv-events-validator-success")}};this.$form.attr("novalidate","novalidate").addClass(this.options.elementClass).on("submit.bv",function(a){a.preventDefault(),b.validate()}).on("click.bv",this.options.submitButtons,function(){b.$submitButton=a(this),b._submitIfValid=!0}).find("[name], [data-bv-field]").each(function(){var d=a(this),e=d.attr("name")||d.attr("data-bv-field"),f=b._parseOptions(d);f&&(d.attr("data-bv-field",e),c.fields[e]=a.extend({},f,c.fields[e]))}),this.options=a.extend(!0,this.options,c),this.$hiddenButton=a("<button/>").attr("type","submit").prependTo(this.$form).addClass("bv-hidden-submit").css({display:"none",width:0,height:0}),this.$form.on("click.bv",'[type="submit"]',function(c){var d=a(c.target).eq(0);!b.options.submitButtons||d.is(b.options.submitButtons)||d.is(b.$hiddenButton)||b.$form.off("submit.bv").submit()});for(var d in this.options.fields)this._initField(d);this.$form.trigger(a.Event(this.options.events.formInit),{bv:this,options:this.options}),this.options.onSuccess&&this.$form.on(this.options.events.formSuccess,function(c){a.fn.bootstrapValidator.helpers.call(b.options.onSuccess,[c])}),this.options.onError&&this.$form.on(this.options.events.formError,function(c){a.fn.bootstrapValidator.helpers.call(b.options.onError,[c])})},_parseOptions:function(b){var c,d,e,f,g,h,i,j=b.attr("name")||b.attr("data-bv-field"),k={};for(d in a.fn.bootstrapValidator.validators)if(c=a.fn.bootstrapValidator.validators[d],e=b.attr("data-bv-"+d.toLowerCase())+"",i="function"==typeof c.enableByHtml5?c.enableByHtml5(b):null,i&&"false"!==e||i!==!0&&(""===e||"true"===e)){c.html5Attributes=a.extend({},{message:"message",onerror:"onError",onsuccess:"onSuccess"},c.html5Attributes),k[d]=a.extend({},i===!0?{}:i,k[d]);for(h in c.html5Attributes)f=c.html5Attributes[h],g=b.attr("data-bv-"+d.toLowerCase()+"-"+h),g&&("true"===g?g=!0:"false"===g&&(g=!1),k[d][f]=g)}var l={excluded:b.attr("data-bv-excluded"),feedbackIcons:b.attr("data-bv-feedbackicons"),trigger:b.attr("data-bv-trigger"),message:b.attr("data-bv-message"),container:b.attr("data-bv-container"),group:b.attr("data-bv-group"),selector:b.attr("data-bv-selector"),threshold:b.attr("data-bv-threshold"),onStatus:b.attr("data-bv-onstatus"),onSuccess:b.attr("data-bv-onsuccess"),onError:b.attr("data-bv-onerror"),validators:k},m=a.isEmptyObject(l),n=a.isEmptyObject(k);return!n||!m&&this.options.fields&&this.options.fields[j]?(l.validators=k,l):null},_initField:function(b){var c=a([]);switch(typeof b){case"object":c=b,b=b.attr("data-bv-field");break;case"string":c=this.getFieldElements(b),c.attr("data-bv-field",b)}if(null!==this.options.fields[b]&&null!==this.options.fields[b].validators){if(0===c.length)return void delete this.options.fields[b];var d;for(d in this.options.fields[b].validators)a.fn.bootstrapValidator.validators[d]||delete this.options.fields[b].validators[d];null===this.options.fields[b].enabled&&(this.options.fields[b].enabled=!0);for(var e=this,f=c.length,g=c.attr("type"),h=1===f||"radio"===g||"checkbox"===g,i="radio"===g||"checkbox"===g||"file"===g||"SELECT"===c.eq(0).get(0).tagName?"change":this._changeEvent,j=(this.options.fields[b].trigger||this.options.trigger||i).split(" "),k=a.map(j,function(a){return a+".update.bv"}).join(" "),l=0;f>l;l++){var m=c.eq(l),n=this.options.fields[b].group||this.options.group,o=m.parents(n),p=this.options.fields[b].container||this.options.container,q=p&&"tooltip"!==p&&"popover"!==p?a(p):this._getMessageContainer(m,n);p&&"tooltip"!==p&&"popover"!==p&&q.addClass("has-error"),q.find('.help-block[data-bv-validator][data-bv-for="'+b+'"]').remove(),o.find('i[data-bv-icon-for="'+b+'"]').remove(),m.off(k).on(k,function(){e.updateStatus(a(this),e.STATUS_NOT_VALIDATED)}),m.data("bv.messages",q);for(d in this.options.fields[b].validators)m.data("bv.result."+d,this.STATUS_NOT_VALIDATED),h&&l!==f-1||a("<small/>").css("display","none").addClass("help-block").attr("data-bv-validator",d).attr("data-bv-for",b).attr("data-bv-result",this.STATUS_NOT_VALIDATED).html(this._getMessage(b,d)).appendTo(q),this.options.fields[b].validators[d].onSuccess&&m.on(this.options.events.validatorSuccess,function(c,f){a.fn.bootstrapValidator.helpers.call(e.options.fields[b].validators[d].onSuccess,[c,f])}),this.options.fields[b].validators[d].onError&&m.on(this.options.events.validatorError,function(c,f){a.fn.bootstrapValidator.helpers.call(e.options.fields[b].validators[d].onError,[c,f])});if(this.options.fields[b].feedbackIcons!==!1&&"false"!==this.options.fields[b].feedbackIcons&&this.options.feedbackIcons&&this.options.feedbackIcons.validating&&this.options.feedbackIcons.invalid&&this.options.feedbackIcons.valid&&(!h||l===f-1)){o.removeClass("has-success").removeClass("has-error").addClass("has-feedback");var r=a("<i/>").css("display","none").addClass("form-control-feedback").attr("data-bv-icon-for",b).insertAfter(m);if("checkbox"===g||"radio"===g){var s=m.parent();s.hasClass(g)?r.insertAfter(s):s.parent().hasClass(g)&&r.insertAfter(s.parent())}0===o.find("label").length&&r.css("top",0),0!==o.find(".input-group").length&&r.css({top:0,"z-index":100}).insertAfter(o.find(".input-group").eq(0))}}switch(this.options.fields[b].onSuccess&&c.on(this.options.events.fieldSuccess,function(c,d){a.fn.bootstrapValidator.helpers.call(e.options.fields[b].onSuccess,[c,d])}),this.options.fields[b].onError&&c.on(this.options.events.fieldError,function(c,d){a.fn.bootstrapValidator.helpers.call(e.options.fields[b].onError,[c,d])}),this.options.fields[b].onStatus&&c.on(this.options.events.fieldStatus,function(c,d){a.fn.bootstrapValidator.helpers.call(e.options.fields[b].onStatus,[c,d])}),k=a.map(j,function(a){return a+".live.bv"}).join(" "),this.options.live){case"submitted":break;case"disabled":c.off(k);break;case"enabled":default:c.off(k).on(k,function(){e._exceedThreshold(a(this))&&e.validateField(a(this))})}c.trigger(a.Event(this.options.events.fieldInit),{bv:this,field:b,element:c})}},_getMessage:function(b,c){if(!(this.options.fields[b]&&a.fn.bootstrapValidator.validators[c]&&this.options.fields[b].validators&&this.options.fields[b].validators[c]))return"";var d=this.options.fields[b].validators[c];switch(!0){case!!d.message:return d.message;case!!this.options.fields[b].message:return this.options.fields[b].message;case!!a.fn.bootstrapValidator.i18n[c]:return a.fn.bootstrapValidator.i18n[c]["default"];default:return this.options.message}},_getMessageContainer:function(a,b){var c=a.parent();if(c.is(b))return c;var d=c.attr("class");if(!d)return this._getMessageContainer(c,b);d=d.split(" ");for(var e=d.length,f=0;e>f;f++)if(/^col-(xs|sm|md|lg)-\d+$/.test(d[f])||/^col-(xs|sm|md|lg)-offset-\d+$/.test(d[f]))return c;return this._getMessageContainer(c,b)},_submit:function(){var b=this.isValid(),c=b?this.options.events.formSuccess:this.options.events.formError,d=a.Event(c);this.$form.trigger(d),this.$submitButton&&(b?this._onSuccess(d):this._onError(d))},_isExcluded:function(b){var c=b.attr("data-bv-excluded"),d=b.attr("data-bv-field")||b.attr("name");switch(!0){case!!d&&this.options.fields&&this.options.fields[d]&&("true"===this.options.fields[d].excluded||this.options.fields[d].excluded===!0):case"true"===c:case""===c:return!0;case!!d&&this.options.fields&&this.options.fields[d]&&("false"===this.options.fields[d].excluded||this.options.fields[d].excluded===!1):case"false"===c:return!1;default:if(this.options.excluded){"string"==typeof this.options.excluded&&(this.options.excluded=a.map(this.options.excluded.split(","),function(b){return a.trim(b)}));for(var e=this.options.excluded.length,f=0;e>f;f++)if("string"==typeof this.options.excluded[f]&&b.is(this.options.excluded[f])||"function"==typeof this.options.excluded[f]&&this.options.excluded[f].call(this,b,this)===!0)return!0}return!1}},_exceedThreshold:function(b){var c=b.attr("data-bv-field"),d=this.options.fields[c].threshold||this.options.threshold;if(!d)return!0;var e=-1!==a.inArray(b.attr("type"),["button","checkbox","file","hidden","image","radio","reset","submit"]);return e||b.val().length>=d},_onError:function(b){if(!b.isDefaultPrevented()){if("submitted"===this.options.live){this.options.live="enabled";var c=this;for(var d in this.options.fields)!function(b){var e=c.getFieldElements(b);if(e.length){var f=a(e[0]).attr("type"),g="radio"===f||"checkbox"===f||"file"===f||"SELECT"===a(e[0]).get(0).tagName?"change":c._changeEvent,h=c.options.fields[d].trigger||c.options.trigger||g,i=a.map(h.split(" "),function(a){return a+".live.bv"}).join(" ");e.off(i).on(i,function(){c._exceedThreshold(a(this))&&c.validateField(a(this))})}}(d)}var e=this.$invalidFields.eq(0);if(e){var f,g=e.parents(".tab-pane");g&&(f=g.attr("id"))&&a('a[href="#'+f+'"][data-toggle="tab"]').tab("show"),e.focus()}}},_onSuccess:function(a){a.isDefaultPrevented()||this.disableSubmitButtons(!0).defaultSubmit()},_onFieldValidated:function(b,c){var d=b.attr("data-bv-field"),e=this.options.fields[d].validators,f={},g=0,h={bv:this,field:d,element:b,validator:c};if(c)switch(b.data("bv.result."+c)){case this.STATUS_INVALID:b.trigger(a.Event(this.options.events.validatorError),h);break;case this.STATUS_VALID:b.trigger(a.Event(this.options.events.validatorSuccess),h)}f[this.STATUS_NOT_VALIDATED]=0,f[this.STATUS_VALIDATING]=0,f[this.STATUS_INVALID]=0,f[this.STATUS_VALID]=0;for(var i in e)if(e[i].enabled!==!1){g++;var j=b.data("bv.result."+i);j&&f[j]++}f[this.STATUS_VALID]===g?(this.$invalidFields=this.$invalidFields.not(b),b.trigger(a.Event(this.options.events.fieldSuccess),h)):0===f[this.STATUS_NOT_VALIDATED]&&0===f[this.STATUS_VALIDATING]&&f[this.STATUS_INVALID]>0&&(this.$invalidFields=this.$invalidFields.add(b),b.trigger(a.Event(this.options.events.fieldError),h))},getFieldElements:function(b){return this._cacheFields[b]||(this._cacheFields[b]=this.options.fields[b]&&this.options.fields[b].selector?a(this.options.fields[b].selector):this.$form.find('[name="'+b+'"]')),this._cacheFields[b]},disableSubmitButtons:function(a){return a?"disabled"!==this.options.live&&this.$form.find(this.options.submitButtons).attr("disabled","disabled"):this.$form.find(this.options.submitButtons).removeAttr("disabled"),this},validate:function(){if(!this.options.fields)return this;this.disableSubmitButtons(!0);for(var a in this.options.fields)this.validateField(a);return this._submit(),this},validateField:function(b){var c=a([]);switch(typeof b){case"object":c=b,b=b.attr("data-bv-field");break;case"string":c=this.getFieldElements(b)}if(this.options.fields[b]&&this.options.fields[b].enabled===!1)return this;for(var d,e,f=this,g=c.attr("type"),h="radio"===g||"checkbox"===g?1:c.length,i="radio"===g||"checkbox"===g,j=this.options.fields[b].validators,k=0;h>k;k++){var l=c.eq(k);if(!this._isExcluded(l))for(d in j){l.data("bv.dfs."+d)&&l.data("bv.dfs."+d).reject();var m=l.data("bv.result."+d);m!==this.STATUS_VALID&&m!==this.STATUS_INVALID&&j[d].enabled!==!1?(l.data("bv.result."+d,this.STATUS_VALIDATING),e=a.fn.bootstrapValidator.validators[d].validate(this,l,j[d]),"object"==typeof e&&e.resolve?(this.updateStatus(i?b:l,this.STATUS_VALIDATING,d),l.data("bv.dfs."+d,e),e.done(function(a,b,c,d){a.removeData("bv.dfs."+b),d&&f.updateMessage(a,b,d),f.updateStatus(i?a.attr("data-bv-field"):a,c?f.STATUS_VALID:f.STATUS_INVALID,b),c&&f._submitIfValid===!0&&f._submit()})):"object"==typeof e&&void 0!==e.valid&&void 0!==e.message?(this.updateMessage(i?b:l,d,e.message),this.updateStatus(i?b:l,e.valid?this.STATUS_VALID:this.STATUS_INVALID,d)):"boolean"==typeof e&&this.updateStatus(i?b:l,e?this.STATUS_VALID:this.STATUS_INVALID,d)):this._onFieldValidated(l,d)}}return this},updateMessage:function(b,c,d){var e=a([]);switch(typeof b){case"object":e=b,b=b.attr("data-bv-field");break;case"string":e=this.getFieldElements(b)}e.each(function(){a(this).data("bv.messages").find('.help-block[data-bv-validator="'+c+'"][data-bv-for="'+b+'"]').html(d)})},updateStatus:function(b,c,d){var e=a([]);switch(typeof b){case"object":e=b,b=b.attr("data-bv-field");break;case"string":e=this.getFieldElements(b)}c===this.STATUS_NOT_VALIDATED&&(this._submitIfValid=!1);for(var f=this,g=e.attr("type"),h=this.options.fields[b].group||this.options.group,i="radio"===g||"checkbox"===g?1:e.length,j=0;i>j;j++){var k=e.eq(j);if(!this._isExcluded(k)){var l=k.parents(h),m=k.data("bv.messages"),n=m.find('.help-block[data-bv-validator][data-bv-for="'+b+'"]'),o=d?n.filter('[data-bv-validator="'+d+'"]'):n,p=l.find('.form-control-feedback[data-bv-icon-for="'+b+'"]'),q=this.options.fields[b].container||this.options.container,r=null;if(d)k.data("bv.result."+d,c);else for(var s in this.options.fields[b].validators)k.data("bv.result."+s,c);o.attr("data-bv-result",c);var t,u,v=k.parents(".tab-pane");switch(v&&(t=v.attr("id"))&&(u=a('a[href="#'+t+'"][data-toggle="tab"]').parent()),c){case this.STATUS_VALIDATING:r=null,this.disableSubmitButtons(!0),l.removeClass("has-success").removeClass("has-error"),p&&p.removeClass(this.options.feedbackIcons.valid).removeClass(this.options.feedbackIcons.invalid).addClass(this.options.feedbackIcons.validating).show(),u&&u.removeClass("bv-tab-success").removeClass("bv-tab-error");break;case this.STATUS_INVALID:r=!1,this.disableSubmitButtons(!0),l.removeClass("has-success").addClass("has-error"),p&&p.removeClass(this.options.feedbackIcons.valid).removeClass(this.options.feedbackIcons.validating).addClass(this.options.feedbackIcons.invalid).show(),u&&u.removeClass("bv-tab-success").addClass("bv-tab-error");break;case this.STATUS_VALID:r=0===n.filter('[data-bv-result="'+this.STATUS_NOT_VALIDATED+'"]').length?n.filter('[data-bv-result="'+this.STATUS_VALID+'"]').length===n.length:null,null!==r&&(this.disableSubmitButtons(this.$submitButton?!this.isValid():!r),p&&p.removeClass(this.options.feedbackIcons.invalid).removeClass(this.options.feedbackIcons.validating).removeClass(this.options.feedbackIcons.valid).addClass(r?this.options.feedbackIcons.valid:this.options.feedbackIcons.invalid).show()),l.removeClass("has-error has-success").addClass(this.isValidContainer(l)?"has-success":"has-error"),u&&u.removeClass("bv-tab-success").removeClass("bv-tab-error").addClass(this.isValidContainer(v)?"bv-tab-success":"bv-tab-error");break;case this.STATUS_NOT_VALIDATED:default:r=null,this.disableSubmitButtons(!1),l.removeClass("has-success").removeClass("has-error"),p&&p.removeClass(this.options.feedbackIcons.valid).removeClass(this.options.feedbackIcons.invalid).removeClass(this.options.feedbackIcons.validating).hide(),u&&u.removeClass("bv-tab-success").removeClass("bv-tab-error")}switch(!0){case p&&"tooltip"===q:r===!1?p.css("cursor","pointer").tooltip("destroy").tooltip({html:!0,placement:"top",title:n.filter('[data-bv-result="'+f.STATUS_INVALID+'"]').eq(0).html()}):p.css("cursor","").tooltip("destroy");break;case p&&"popover"===q:r===!1?p.css("cursor","pointer").popover("destroy").popover({content:n.filter('[data-bv-result="'+f.STATUS_INVALID+'"]').eq(0).html(),html:!0,placement:"top",trigger:"hover click"}):p.css("cursor","").popover("destroy");break;default:c===this.STATUS_INVALID?o.show():o.hide()}k.trigger(a.Event(this.options.events.fieldStatus),{bv:this,field:b,element:k,status:c}),this._onFieldValidated(k,d)}}return this},isValid:function(){for(var a in this.options.fields)if(!this.isValidField(a))return!1;return!0},isValidField:function(b){var c=a([]);switch(typeof b){case"object":c=b,b=b.attr("data-bv-field");break;case"string":c=this.getFieldElements(b)}if(0===c.length||null===this.options.fields[b]||this.options.fields[b].enabled===!1)return!0;for(var d,e,f,g=c.attr("type"),h="radio"===g||"checkbox"===g?1:c.length,i=0;h>i;i++)if(d=c.eq(i),!this._isExcluded(d))for(e in this.options.fields[b].validators)if(this.options.fields[b].validators[e].enabled!==!1&&(f=d.data("bv.result."+e),f!==this.STATUS_VALID))return!1;return!0},isValidContainer:function(b){var c=this,d={},e="string"==typeof b?a(b):b;if(0===e.length)return!0;e.find("[data-bv-field]").each(function(){var b=a(this),e=b.attr("data-bv-field");c._isExcluded(b)||d[e]||(d[e]=b)});for(var f in d){var g=d[f];if(0!==g.data("bv.messages").find('.help-block[data-bv-validator][data-bv-for="'+f+'"]').filter(function(){var b=a(this).attr("data-bv-validator"),d=a(this).attr("data-bv-for");return c.options.fields[d].validators[b].enabled!==!1&&g.data("bv.result."+b)&&g.data("bv.result."+b)!==c.STATUS_VALID}).length)return!1}return!0},defaultSubmit:function(){this.$submitButton&&a("<input/>").attr("type","hidden").attr("data-bv-submit-hidden","").attr("name",this.$submitButton.attr("name")).val(this.$submitButton.val()).appendTo(this.$form),this.$form.off("submit.bv").submit()},getInvalidFields:function(){return this.$invalidFields},getSubmitButton:function(){return this.$submitButton},getMessages:function(b,c){var d=this,e=[],f=a([]);switch(!0){case b&&"object"==typeof b:f=b;break;case b&&"string"==typeof b:var g=this.getFieldElements(b);if(g.length>0){var h=g.attr("type");f="radio"===h||"checkbox"===h?g.eq(0):g}break;default:f=this.$invalidFields}var i=c?'[data-bv-validator="'+c+'"]':"";return f.each(function(){e=e.concat(a(this).data("bv.messages").find('.help-block[data-bv-for="'+a(this).attr("data-bv-field")+'"][data-bv-result="'+d.STATUS_INVALID+'"]'+i).map(function(){var b=a(this).attr("data-bv-validator"),c=a(this).attr("data-bv-for");return d.options.fields[c].validators[b].enabled===!1?"":a(this).html()}).get())}),e},getOptions:function(a,b,c){if(!a)return this.options;if("object"==typeof a&&(a=a.attr("data-bv-field")),!this.options.fields[a])return null;var d=this.options.fields[a];return b?d.validators&&d.validators[b]?c?d.validators[b][c]:d.validators[b]:null:d},updateOption:function(a,b,c,d){return"object"==typeof a&&(a=a.attr("data-bv-field")),this.options.fields[a]&&this.options.fields[a].validators[b]&&(this.options.fields[a].validators[b][c]=d,this.updateStatus(a,this.STATUS_NOT_VALIDATED,b)),this},addField:function(b,c){var d=a([]);switch(typeof b){case"object":d=b,b=b.attr("data-bv-field")||b.attr("name");break;case"string":delete this._cacheFields[b],d=this.getFieldElements(b)}d.attr("data-bv-field",b);for(var e=d.attr("type"),f="radio"===e||"checkbox"===e?1:d.length,g=0;f>g;g++){var h=d.eq(g),i=this._parseOptions(h);i=null===i?c:a.extend(!0,c,i),this.options.fields[b]=a.extend(!0,this.options.fields[b],i),this._cacheFields[b]=this._cacheFields[b]?this._cacheFields[b].add(h):h,this._initField("checkbox"===e||"radio"===e?b:h)}return this.disableSubmitButtons(!1),this.$form.trigger(a.Event(this.options.events.fieldAdded),{field:b,element:d,options:this.options.fields[b]}),this},removeField:function(b){var c=a([]);switch(typeof b){case"object":c=b,b=b.attr("data-bv-field")||b.attr("name"),c.attr("data-bv-field",b);break;case"string":c=this.getFieldElements(b)}if(0===c.length)return this;for(var d=c.attr("type"),e="radio"===d||"checkbox"===d?1:c.length,f=0;e>f;f++){var g=c.eq(f);this.$invalidFields=this.$invalidFields.not(g),this._cacheFields[b]=this._cacheFields[b].not(g)}return this._cacheFields[b]&&0!==this._cacheFields[b].length||delete this.options.fields[b],("checkbox"===d||"radio"===d)&&this._initField(b),this.disableSubmitButtons(!1),this.$form.trigger(a.Event(this.options.events.fieldRemoved),{field:b,element:c}),this},resetField:function(b,c){var d=a([]);switch(typeof b){case"object":d=b,b=b.attr("data-bv-field");break;case"string":d=this.getFieldElements(b)}var e=d.length;if(this.options.fields[b])for(var f=0;e>f;f++)for(var g in this.options.fields[b].validators)d.eq(f).removeData("bv.dfs."+g);if(this.updateStatus(b,this.STATUS_NOT_VALIDATED),c){var h=d.attr("type");"radio"===h||"checkbox"===h?d.removeAttr("checked").removeAttr("selected"):d.val("")}return this},resetForm:function(b){for(var c in this.options.fields)this.resetField(c,b);return this.$invalidFields=a([]),this.$submitButton=null,this.disableSubmitButtons(!1),this},revalidateField:function(a){return this.updateStatus(a,this.STATUS_NOT_VALIDATED).validateField(a),this},enableFieldValidators:function(a,b,c){var d=this.options.fields[a].validators;if(c&&d&&d[c]&&d[c].enabled!==b)this.options.fields[a].validators[c].enabled=b,this.updateStatus(a,this.STATUS_NOT_VALIDATED,c);else if(!c&&this.options.fields[a].enabled!==b){this.options.fields[a].enabled=b;for(var e in d)this.enableFieldValidators(a,b,e)}return this},getDynamicOption:function(b,c){var d="string"==typeof b?this.getFieldElements(b):b,e=d.val();if("function"==typeof c)return a.fn.bootstrapValidator.helpers.call(c,[e,this,d]);if("string"==typeof c){var f=this.getFieldElements(c);return f.length?f.val():a.fn.bootstrapValidator.helpers.call(c,[e,this,d])||c}return null},destroy:function(){var a,b,c,d,e,f,g;for(a in this.options.fields){b=this.getFieldElements(a),f=this.options.fields[a].container||this.options.container,g=this.options.fields[a].group||this.options.group;for(var h=0;h<b.length;h++){if(c=b.eq(h),c.data("bv.messages").find('.help-block[data-bv-validator][data-bv-for="'+a+'"]').remove().end().end().removeData("bv.messages").parents(g).removeClass("has-feedback has-error has-success").end().off(".bv").removeAttr("data-bv-field"),e=c.parents(g).find('i[data-bv-icon-for="'+a+'"]'))switch(f){case"tooltip":e.tooltip("destroy").remove();break;case"popover":e.popover("destroy").remove();break;default:e.remove()}for(d in this.options.fields[a].validators)c.data("bv.dfs."+d)&&c.data("bv.dfs."+d).reject(),c.removeData("bv.result."+d).removeData("bv.dfs."+d)}}this.disableSubmitButtons(!1),this.$hiddenButton.remove(),this.$form.removeClass(this.options.elementClass).off(".bv").removeData("bootstrapValidator").find("[data-bv-submit-hidden]").remove().end().find('[type="submit"]').off("click.bv")}},a.fn.bootstrapValidator=function(c){var d=arguments;return this.each(function(){var e=a(this),f=e.data("bootstrapValidator"),g="object"==typeof c&&c;f||(f=new b(this,g),e.data("bootstrapValidator",f)),"string"==typeof c&&f[c].apply(f,Array.prototype.slice.call(d,1))})},a.fn.bootstrapValidator.DEFAULT_OPTIONS={elementClass:"bv-form",message:"This value is not valid",group:".form-group",container:null,threshold:null,excluded:[":disabled",":hidden",":not(:visible)"],feedbackIcons:{valid:null,invalid:null,validating:null},submitButtons:'[type="submit"]',live:"enabled",fields:null,events:{formInit:"init.form.bv",formError:"error.form.bv",formSuccess:"success.form.bv",fieldAdded:"added.field.bv",fieldRemoved:"removed.field.bv",fieldInit:"init.field.bv",fieldError:"error.field.bv",fieldSuccess:"success.field.bv",fieldStatus:"status.field.bv",validatorError:"error.validator.bv",validatorSuccess:"success.validator.bv"}},a.fn.bootstrapValidator.validators={},a.fn.bootstrapValidator.i18n={},a.fn.bootstrapValidator.Constructor=b,a.fn.bootstrapValidator.helpers={call:function(a,b){if("function"==typeof a)return a.apply(this,b);if("string"==typeof a){"()"===a.substring(a.length-2)&&(a=a.substring(0,a.length-2));for(var c=a.split("."),d=c.pop(),e=window,f=0;f<c.length;f++)e=e[c[f]];return"undefined"==typeof e[d]?null:e[d].apply(this,b)}},format:function(b,c){a.isArray(c)||(c=[c]);for(var d in c)b=b.replace("%s",c[d]);return b},date:function(a,b,c,d){if(isNaN(a)||isNaN(b)||isNaN(c))return!1;if(c.length>2||b.length>2||a.length>4)return!1;if(c=parseInt(c,10),b=parseInt(b,10),a=parseInt(a,10),1e3>a||a>9999||0>=b||b>12)return!1;var e=[31,28,31,30,31,30,31,31,30,31,30,31];if((a%400===0||a%100!==0&&a%4===0)&&(e[1]=29),0>=c||c>e[b-1])return!1;if(d===!0){var f=new Date,g=f.getFullYear(),h=f.getMonth(),i=f.getDate();return g>a||a===g&&h>b-1||a===g&&b-1===h&&i>c}return!0},luhn:function(a){for(var b=a.length,c=0,d=[[0,1,2,3,4,5,6,7,8,9],[0,2,4,6,8,1,3,5,7,9]],e=0;b--;)e+=d[c][parseInt(a.charAt(b),10)],c^=1;return e%10===0&&e>0},mod11And10:function(a){for(var b=5,c=a.length,d=0;c>d;d++)b=(2*(b||10)%11+parseInt(a.charAt(d),10))%10;return 1===b},mod37And36:function(a,b){b=b||"0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";for(var c=b.length,d=a.length,e=Math.floor(c/2),f=0;d>f;f++)e=(2*(e||c)%(c+1)+b.indexOf(a.charAt(f)))%c;return 1===e}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.base64=a.extend(a.fn.bootstrapValidator.i18n.base64||{},{"default":"Please enter a valid base 64 encoded"}),a.fn.bootstrapValidator.validators.base64={validate:function(a,b){var c=b.val();return""===c?!0:/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$/.test(c)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.between=a.extend(a.fn.bootstrapValidator.i18n.between||{},{"default":"Please enter a value between %s and %s",notInclusive:"Please enter a value between %s and %s strictly"}),a.fn.bootstrapValidator.validators.between={html5Attributes:{message:"message",min:"min",max:"max",inclusive:"inclusive"},enableByHtml5:function(a){return"range"===a.attr("type")?{min:a.attr("min"),max:a.attr("max")}:!1},validate:function(b,c,d){var e=c.val();if(""===e)return!0;if(!a.isNumeric(e))return!1;var f=a.isNumeric(d.min)?d.min:b.getDynamicOption(c,d.min),g=a.isNumeric(d.max)?d.max:b.getDynamicOption(c,d.max);return e=parseFloat(e),d.inclusive===!0||void 0===d.inclusive?{valid:e>=f&&g>=e,message:a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.between["default"],[f,g])}:{valid:e>f&&g>e,message:a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.between.notInclusive,[f,g])}}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.callback=a.extend(a.fn.bootstrapValidator.i18n.callback||{},{"default":"Please enter a valid value"}),a.fn.bootstrapValidator.validators.callback={html5Attributes:{message:"message",callback:"callback"},validate:function(b,c,d){var e=c.val();if(d.callback){var f=new a.Deferred,g=a.fn.bootstrapValidator.helpers.call(d.callback,[e,b,c]);return f.resolve(c,"callback","boolean"==typeof g?g:g.valid,"object"==typeof g&&g.message?g.message:null),f}return!0}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.choice=a.extend(a.fn.bootstrapValidator.i18n.choice||{},{"default":"Please enter a valid value",less:"Please choose %s options at minimum",more:"Please choose %s options at maximum",between:"Please choose %s - %s options"}),a.fn.bootstrapValidator.validators.choice={html5Attributes:{message:"message",min:"min",max:"max"},validate:function(b,c,d){var e=c.is("select")?b.getFieldElements(c.attr("data-bv-field")).find("option").filter(":selected").length:b.getFieldElements(c.attr("data-bv-field")).filter(":checked").length,f=d.min?a.isNumeric(d.min)?d.min:b.getDynamicOption(c,d.min):null,g=d.max?a.isNumeric(d.max)?d.max:b.getDynamicOption(c,d.max):null,h=!0,i=d.message||a.fn.bootstrapValidator.i18n.choice["default"];switch((f&&e<parseInt(f,10)||g&&e>parseInt(g,10))&&(h=!1),!0){case!!f&&!!g:i=a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.choice.between,[parseInt(f,10),parseInt(g,10)]);break;case!!f:i=a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.choice.less,parseInt(f,10));break;case!!g:i=a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.choice.more,parseInt(g,10))}return{valid:h,message:i}}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.creditCard=a.extend(a.fn.bootstrapValidator.i18n.creditCard||{},{"default":"Please enter a valid credit card number"}),a.fn.bootstrapValidator.validators.creditCard={validate:function(b,c){var d=c.val();if(""===d)return!0;if(/[^0-9-\s]+/.test(d))return!1;if(d=d.replace(/\D/g,""),!a.fn.bootstrapValidator.helpers.luhn(d))return!1;var e,f,g={AMERICAN_EXPRESS:{length:[15],prefix:["34","37"]},DINERS_CLUB:{length:[14],prefix:["300","301","302","303","304","305","36"]},DINERS_CLUB_US:{length:[16],prefix:["54","55"]},DISCOVER:{length:[16],prefix:["6011","622126","622127","622128","622129","62213","62214","62215","62216","62217","62218","62219","6222","6223","6224","6225","6226","6227","6228","62290","62291","622920","622921","622922","622923","622924","622925","644","645","646","647","648","649","65"]},JCB:{length:[16],prefix:["3528","3529","353","354","355","356","357","358"]},LASER:{length:[16,17,18,19],prefix:["6304","6706","6771","6709"]},MAESTRO:{length:[12,13,14,15,16,17,18,19],prefix:["5018","5020","5038","6304","6759","6761","6762","6763","6764","6765","6766"]},MASTERCARD:{length:[16],prefix:["51","52","53","54","55"]},SOLO:{length:[16,18,19],prefix:["6334","6767"]},UNIONPAY:{length:[16,17,18,19],prefix:["622126","622127","622128","622129","62213","62214","62215","62216","62217","62218","62219","6222","6223","6224","6225","6226","6227","6228","62290","62291","622920","622921","622922","622923","622924","622925"]},VISA:{length:[16],prefix:["4"]}};for(e in g)for(f in g[e].prefix)if(d.substr(0,g[e].prefix[f].length)===g[e].prefix[f]&&-1!==a.inArray(d.length,g[e].length))return!0;return!1}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.cusip=a.extend(a.fn.bootstrapValidator.i18n.cusip||{},{"default":"Please enter a valid CUSIP number"}),a.fn.bootstrapValidator.validators.cusip={validate:function(b,c){var d=c.val();if(""===d)return!0;if(d=d.toUpperCase(),!/^[0-9A-Z]{9}$/.test(d))return!1;for(var e=a.map(d.split(""),function(a){var b=a.charCodeAt(0);return b>="A".charCodeAt(0)&&b<="Z".charCodeAt(0)?b-"A".charCodeAt(0)+10:a}),f=e.length,g=0,h=0;f-1>h;h++){var i=parseInt(e[h],10);h%2!==0&&(i*=2),i>9&&(i-=9),g+=i}return g=(10-g%10)%10,g===e[f-1]}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.cvv=a.extend(a.fn.bootstrapValidator.i18n.cvv||{},{"default":"Please enter a valid CVV number"}),a.fn.bootstrapValidator.validators.cvv={html5Attributes:{message:"message",ccfield:"creditCardField"},validate:function(b,c,d){var e=c.val();if(""===e)return!0;if(!/^[0-9]{3,4}$/.test(e))return!1;if(!d.creditCardField)return!0;var f=b.getFieldElements(d.creditCardField).val();if(""===f)return!0;f=f.replace(/\D/g,"");var g,h,i={AMERICAN_EXPRESS:{length:[15],prefix:["34","37"]},DINERS_CLUB:{length:[14],prefix:["300","301","302","303","304","305","36"]},DINERS_CLUB_US:{length:[16],prefix:["54","55"]},DISCOVER:{length:[16],prefix:["6011","622126","622127","622128","622129","62213","62214","62215","62216","62217","62218","62219","6222","6223","6224","6225","6226","6227","6228","62290","62291","622920","622921","622922","622923","622924","622925","644","645","646","647","648","649","65"]},JCB:{length:[16],prefix:["3528","3529","353","354","355","356","357","358"]},LASER:{length:[16,17,18,19],prefix:["6304","6706","6771","6709"]},MAESTRO:{length:[12,13,14,15,16,17,18,19],prefix:["5018","5020","5038","6304","6759","6761","6762","6763","6764","6765","6766"]},MASTERCARD:{length:[16],prefix:["51","52","53","54","55"]},SOLO:{length:[16,18,19],prefix:["6334","6767"]},UNIONPAY:{length:[16,17,18,19],prefix:["622126","622127","622128","622129","62213","62214","62215","62216","62217","62218","62219","6222","6223","6224","6225","6226","6227","6228","62290","62291","622920","622921","622922","622923","622924","622925"]},VISA:{length:[16],prefix:["4"]}},j=null;
for(g in i)for(h in i[g].prefix)if(f.substr(0,i[g].prefix[h].length)===i[g].prefix[h]&&-1!==a.inArray(f.length,i[g].length)){j=g;break}return null===j?!1:"AMERICAN_EXPRESS"===j?4===e.length:3===e.length}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.date=a.extend(a.fn.bootstrapValidator.i18n.date||{},{"default":"Please enter a valid date"}),a.fn.bootstrapValidator.validators.date={html5Attributes:{message:"message",format:"format",separator:"separator"},validate:function(b,c,d){var e=c.val();if(""===e)return!0;d.format=d.format||"MM/DD/YYYY","date"===c.attr("type")&&(d.format="YYYY-MM-DD");var f=d.format.split(" "),g=f[0],h=f.length>1?f[1]:null,i=f.length>2?f[2]:null,j=e.split(" "),k=j[0],l=j.length>1?j[1]:null;if(f.length!==j.length)return!1;var m=d.separator;if(m||(m=-1!==k.indexOf("/")?"/":-1!==k.indexOf("-")?"-":null),null===m||-1===k.indexOf(m))return!1;if(k=k.split(m),g=g.split(m),k.length!==g.length)return!1;var n=k[a.inArray("YYYY",g)],o=k[a.inArray("MM",g)],p=k[a.inArray("DD",g)];if(!n||!o||!p||4!==n.length)return!1;var q=null,r=null,s=null;if(h){if(h=h.split(":"),l=l.split(":"),h.length!==l.length)return!1;if(r=l.length>0?l[0]:null,q=l.length>1?l[1]:null,s=l.length>2?l[2]:null){if(isNaN(s)||s.length>2)return!1;if(s=parseInt(s,10),0>s||s>60)return!1}if(r){if(isNaN(r)||r.length>2)return!1;if(r=parseInt(r,10),0>r||r>=24||i&&r>12)return!1}if(q){if(isNaN(q)||q.length>2)return!1;if(q=parseInt(q,10),0>q||q>59)return!1}}return a.fn.bootstrapValidator.helpers.date(n,o,p)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.different=a.extend(a.fn.bootstrapValidator.i18n.different||{},{"default":"Please enter a different value"}),a.fn.bootstrapValidator.validators.different={html5Attributes:{message:"message",field:"field"},validate:function(a,b,c){var d=b.val();if(""===d)return!0;var e=a.getFieldElements(c.field);return null===e||0===e.length?!0:d!==e.val()?(a.updateStatus(c.field,a.STATUS_VALID,"different"),!0):!1}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.digits=a.extend(a.fn.bootstrapValidator.i18n.digits||{},{"default":"Please enter only digits"}),a.fn.bootstrapValidator.validators.digits={validate:function(a,b){var c=b.val();return""===c?!0:/^\d+$/.test(c)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.ean=a.extend(a.fn.bootstrapValidator.i18n.ean||{},{"default":"Please enter a valid EAN number"}),a.fn.bootstrapValidator.validators.ean={validate:function(a,b){var c=b.val();if(""===c)return!0;if(!/^(\d{8}|\d{12}|\d{13})$/.test(c))return!1;for(var d=c.length,e=0,f=8===d?[3,1]:[1,3],g=0;d-1>g;g++)e+=parseInt(c.charAt(g),10)*f[g%2];return e=(10-e%10)%10,e+""===c.charAt(d-1)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.emailAddress=a.extend(a.fn.bootstrapValidator.i18n.emailAddress||{},{"default":"Please enter a valid email address"}),a.fn.bootstrapValidator.validators.emailAddress={enableByHtml5:function(a){return"email"===a.attr("type")},validate:function(a,b){var c=b.val();if(""===c)return!0;var d=/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;return d.test(c)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.file=a.extend(a.fn.bootstrapValidator.i18n.file||{},{"default":"Please choose a valid file"}),a.fn.bootstrapValidator.validators.file={html5Attributes:{extension:"extension",maxsize:"maxSize",message:"message",type:"type"},validate:function(b,c,d){var e=c.val();if(""===e)return!0;var f,g=d.extension?d.extension.toLowerCase().split(","):null,h=d.type?d.type.toLowerCase().split(","):null,i=window.File&&window.FileList&&window.FileReader;if(i)for(var j=c.get(0).files,k=j.length,l=0;k>l;l++){if(d.maxSize&&j[l].size>parseInt(d.maxSize,10))return!1;if(f=j[l].name.substr(j[l].name.lastIndexOf(".")+1),g&&-1===a.inArray(f.toLowerCase(),g))return!1;if(j[l].type&&h&&-1===a.inArray(j[l].type.toLowerCase(),h))return!1}else if(f=e.substr(e.lastIndexOf(".")+1),g&&-1===a.inArray(f.toLowerCase(),g))return!1;return!0}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.greaterThan=a.extend(a.fn.bootstrapValidator.i18n.greaterThan||{},{"default":"Please enter a value greater than or equal to %s",notInclusive:"Please enter a value greater than %s"}),a.fn.bootstrapValidator.validators.greaterThan={html5Attributes:{message:"message",value:"value",inclusive:"inclusive"},enableByHtml5:function(a){var b=a.attr("type"),c=a.attr("min");return c&&"date"!==b?{value:c}:!1},validate:function(b,c,d){var e=c.val();if(""===e)return!0;if(!a.isNumeric(e))return!1;var f=a.isNumeric(d.value)?d.value:b.getDynamicOption(c,d.value);return e=parseFloat(e),d.inclusive===!0||void 0===d.inclusive?{valid:e>=f,message:a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.greaterThan["default"],f)}:{valid:e>f,message:a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.greaterThan.notInclusive,f)}}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.grid=a.extend(a.fn.bootstrapValidator.i18n.grid||{},{"default":"Please enter a valid GRId number"}),a.fn.bootstrapValidator.validators.grid={validate:function(b,c){var d=c.val();return""===d?!0:(d=d.toUpperCase(),/^[GRID:]*([0-9A-Z]{2})[-\s]*([0-9A-Z]{5})[-\s]*([0-9A-Z]{10})[-\s]*([0-9A-Z]{1})$/g.test(d)?(d=d.replace(/\s/g,"").replace(/-/g,""),"GRID:"===d.substr(0,5)&&(d=d.substr(5)),a.fn.bootstrapValidator.helpers.mod37And36(d)):!1)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.hex=a.extend(a.fn.bootstrapValidator.i18n.hex||{},{"default":"Please enter a valid hexadecimal number"}),a.fn.bootstrapValidator.validators.hex={validate:function(a,b){var c=b.val();return""===c?!0:/^[0-9a-fA-F]+$/.test(c)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.hexColor=a.extend(a.fn.bootstrapValidator.i18n.hexColor||{},{"default":"Please enter a valid hex color"}),a.fn.bootstrapValidator.validators.hexColor={enableByHtml5:function(a){return"color"===a.attr("type")},validate:function(a,b){var c=b.val();return""===c?!0:/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(c)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.iban=a.extend(a.fn.bootstrapValidator.i18n.iban||{},{"default":"Please enter a valid IBAN number",countryNotSupported:"The country code %s is not supported",country:"Please enter a valid IBAN number in %s",countries:{AD:"Andorra",AE:"United Arab Emirates",AL:"Albania",AO:"Angola",AT:"Austria",AZ:"Azerbaijan",BA:"Bosnia and Herzegovina",BE:"Belgium",BF:"Burkina Faso",BG:"Bulgaria",BH:"Bahrain",BI:"Burundi",BJ:"Benin",BR:"Brazil",CH:"Switzerland",CI:"Ivory Coast",CM:"Cameroon",CR:"Costa Rica",CV:"Cape Verde",CY:"Cyprus",CZ:"Czech Republic",DE:"Germany",DK:"Denmark",DO:"Dominican Republic",DZ:"Algeria",EE:"Estonia",ES:"Spain",FI:"Finland",FO:"Faroe Islands",FR:"France",GB:"United Kingdom",GE:"Georgia",GI:"Gibraltar",GL:"Greenland",GR:"Greece",GT:"Guatemala",HR:"Croatia",HU:"Hungary",IE:"Ireland",IL:"Israel",IR:"Iran",IS:"Iceland",IT:"Italy",JO:"Jordan",KW:"Kuwait",KZ:"Kazakhstan",LB:"Lebanon",LI:"Liechtenstein",LT:"Lithuania",LU:"Luxembourg",LV:"Latvia",MC:"Monaco",MD:"Moldova",ME:"Montenegro",MG:"Madagascar",MK:"Macedonia",ML:"Mali",MR:"Mauritania",MT:"Malta",MU:"Mauritius",MZ:"Mozambique",NL:"Netherlands",NO:"Norway",PK:"Pakistan",PL:"Poland",PS:"Palestinian",PT:"Portugal",QA:"Qatar",RO:"Romania",RS:"Serbia",SA:"Saudi Arabia",SE:"Sweden",SI:"Slovenia",SK:"Slovakia",SM:"San Marino",SN:"Senegal",TN:"Tunisia",TR:"Turkey",VG:"Virgin Islands, British"}}),a.fn.bootstrapValidator.validators.iban={html5Attributes:{message:"message",country:"country"},REGEX:{AD:"AD[0-9]{2}[0-9]{4}[0-9]{4}[A-Z0-9]{12}",AE:"AE[0-9]{2}[0-9]{3}[0-9]{16}",AL:"AL[0-9]{2}[0-9]{8}[A-Z0-9]{16}",AO:"AO[0-9]{2}[0-9]{21}",AT:"AT[0-9]{2}[0-9]{5}[0-9]{11}",AZ:"AZ[0-9]{2}[A-Z]{4}[A-Z0-9]{20}",BA:"BA[0-9]{2}[0-9]{3}[0-9]{3}[0-9]{8}[0-9]{2}",BE:"BE[0-9]{2}[0-9]{3}[0-9]{7}[0-9]{2}",BF:"BF[0-9]{2}[0-9]{23}",BG:"BG[0-9]{2}[A-Z]{4}[0-9]{4}[0-9]{2}[A-Z0-9]{8}",BH:"BH[0-9]{2}[A-Z]{4}[A-Z0-9]{14}",BI:"BI[0-9]{2}[0-9]{12}",BJ:"BJ[0-9]{2}[A-Z]{1}[0-9]{23}",BR:"BR[0-9]{2}[0-9]{8}[0-9]{5}[0-9]{10}[A-Z][A-Z0-9]",CH:"CH[0-9]{2}[0-9]{5}[A-Z0-9]{12}",CI:"CI[0-9]{2}[A-Z]{1}[0-9]{23}",CM:"CM[0-9]{2}[0-9]{23}",CR:"CR[0-9]{2}[0-9]{3}[0-9]{14}",CV:"CV[0-9]{2}[0-9]{21}",CY:"CY[0-9]{2}[0-9]{3}[0-9]{5}[A-Z0-9]{16}",CZ:"CZ[0-9]{2}[0-9]{20}",DE:"DE[0-9]{2}[0-9]{8}[0-9]{10}",DK:"DK[0-9]{2}[0-9]{14}",DO:"DO[0-9]{2}[A-Z0-9]{4}[0-9]{20}",DZ:"DZ[0-9]{2}[0-9]{20}",EE:"EE[0-9]{2}[0-9]{2}[0-9]{2}[0-9]{11}[0-9]{1}",ES:"ES[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{1}[0-9]{1}[0-9]{10}",FI:"FI[0-9]{2}[0-9]{6}[0-9]{7}[0-9]{1}",FO:"FO[0-9]{2}[0-9]{4}[0-9]{9}[0-9]{1}",FR:"FR[0-9]{2}[0-9]{5}[0-9]{5}[A-Z0-9]{11}[0-9]{2}",GB:"GB[0-9]{2}[A-Z]{4}[0-9]{6}[0-9]{8}",GE:"GE[0-9]{2}[A-Z]{2}[0-9]{16}",GI:"GI[0-9]{2}[A-Z]{4}[A-Z0-9]{15}",GL:"GL[0-9]{2}[0-9]{4}[0-9]{9}[0-9]{1}",GR:"GR[0-9]{2}[0-9]{3}[0-9]{4}[A-Z0-9]{16}",GT:"GT[0-9]{2}[A-Z0-9]{4}[A-Z0-9]{20}",HR:"HR[0-9]{2}[0-9]{7}[0-9]{10}",HU:"HU[0-9]{2}[0-9]{3}[0-9]{4}[0-9]{1}[0-9]{15}[0-9]{1}",IE:"IE[0-9]{2}[A-Z]{4}[0-9]{6}[0-9]{8}",IL:"IL[0-9]{2}[0-9]{3}[0-9]{3}[0-9]{13}",IR:"IR[0-9]{2}[0-9]{22}",IS:"IS[0-9]{2}[0-9]{4}[0-9]{2}[0-9]{6}[0-9]{10}",IT:"IT[0-9]{2}[A-Z]{1}[0-9]{5}[0-9]{5}[A-Z0-9]{12}",JO:"JO[0-9]{2}[A-Z]{4}[0-9]{4}[0]{8}[A-Z0-9]{10}",KW:"KW[0-9]{2}[A-Z]{4}[0-9]{22}",KZ:"KZ[0-9]{2}[0-9]{3}[A-Z0-9]{13}",LB:"LB[0-9]{2}[0-9]{4}[A-Z0-9]{20}",LI:"LI[0-9]{2}[0-9]{5}[A-Z0-9]{12}",LT:"LT[0-9]{2}[0-9]{5}[0-9]{11}",LU:"LU[0-9]{2}[0-9]{3}[A-Z0-9]{13}",LV:"LV[0-9]{2}[A-Z]{4}[A-Z0-9]{13}",MC:"MC[0-9]{2}[0-9]{5}[0-9]{5}[A-Z0-9]{11}[0-9]{2}",MD:"MD[0-9]{2}[A-Z0-9]{20}",ME:"ME[0-9]{2}[0-9]{3}[0-9]{13}[0-9]{2}",MG:"MG[0-9]{2}[0-9]{23}",MK:"MK[0-9]{2}[0-9]{3}[A-Z0-9]{10}[0-9]{2}",ML:"ML[0-9]{2}[A-Z]{1}[0-9]{23}",MR:"MR13[0-9]{5}[0-9]{5}[0-9]{11}[0-9]{2}",MT:"MT[0-9]{2}[A-Z]{4}[0-9]{5}[A-Z0-9]{18}",MU:"MU[0-9]{2}[A-Z]{4}[0-9]{2}[0-9]{2}[0-9]{12}[0-9]{3}[A-Z]{3}",MZ:"MZ[0-9]{2}[0-9]{21}",NL:"NL[0-9]{2}[A-Z]{4}[0-9]{10}",NO:"NO[0-9]{2}[0-9]{4}[0-9]{6}[0-9]{1}",PK:"PK[0-9]{2}[A-Z]{4}[A-Z0-9]{16}",PL:"PL[0-9]{2}[0-9]{8}[0-9]{16}",PS:"PS[0-9]{2}[A-Z]{4}[A-Z0-9]{21}",PT:"PT[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{11}[0-9]{2}",QA:"QA[0-9]{2}[A-Z]{4}[A-Z0-9]{21}",RO:"RO[0-9]{2}[A-Z]{4}[A-Z0-9]{16}",RS:"RS[0-9]{2}[0-9]{3}[0-9]{13}[0-9]{2}",SA:"SA[0-9]{2}[0-9]{2}[A-Z0-9]{18}",SE:"SE[0-9]{2}[0-9]{3}[0-9]{16}[0-9]{1}",SI:"SI[0-9]{2}[0-9]{5}[0-9]{8}[0-9]{2}",SK:"SK[0-9]{2}[0-9]{4}[0-9]{6}[0-9]{10}",SM:"SM[0-9]{2}[A-Z]{1}[0-9]{5}[0-9]{5}[A-Z0-9]{12}",SN:"SN[0-9]{2}[A-Z]{1}[0-9]{23}",TN:"TN59[0-9]{2}[0-9]{3}[0-9]{13}[0-9]{2}",TR:"TR[0-9]{2}[0-9]{5}[A-Z0-9]{1}[A-Z0-9]{16}",VG:"VG[0-9]{2}[A-Z]{4}[0-9]{16}"},validate:function(b,c,d){var e=c.val();if(""===e)return!0;e=e.replace(/[^a-zA-Z0-9]/g,"").toUpperCase();var f=d.country;if(f?"string"==typeof f&&this.REGEX[f]||(f=b.getDynamicOption(c,f)):f=e.substr(0,2),!this.REGEX[f])return{valid:!1,message:a.fn.bootstrapValidator.helpers.format(a.fn.bootstrapValidator.i18n.iban.countryNotSupported,f)};if(!new RegExp("^"+this.REGEX[f]+"$").test(e))return{valid:!1,message:a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.iban.country,a.fn.bootstrapValidator.i18n.iban.countries[f])};e=e.substr(4)+e.substr(0,4),e=a.map(e.split(""),function(a){var b=a.charCodeAt(0);return b>="A".charCodeAt(0)&&b<="Z".charCodeAt(0)?b-"A".charCodeAt(0)+10:a}),e=e.join("");for(var g=parseInt(e.substr(0,1),10),h=e.length,i=1;h>i;++i)g=(10*g+parseInt(e.substr(i,1),10))%97;return{valid:1===g,message:a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.iban.country,a.fn.bootstrapValidator.i18n.iban.countries[f])}}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.id=a.extend(a.fn.bootstrapValidator.i18n.id||{},{"default":"Please enter a valid identification number",countryNotSupported:"The country code %s is not supported",country:"Please enter a valid %s identification number",countries:{BA:"Bosnia and Herzegovina",BG:"Bulgarian",BR:"Brazilian",CH:"Swiss",CL:"Chilean",CZ:"Czech",DK:"Danish",EE:"Estonian",ES:"Spanish",FI:"Finnish",HR:"Croatian",IE:"Irish",IS:"Iceland",LT:"Lithuanian",LV:"Latvian",ME:"Montenegro",MK:"Macedonian",NL:"Dutch",RO:"Romanian",RS:"Serbian",SE:"Swedish",SI:"Slovenian",SK:"Slovak",SM:"San Marino",ZA:"South African"}}),a.fn.bootstrapValidator.validators.id={html5Attributes:{message:"message",country:"country"},COUNTRY_CODES:["BA","BG","BR","CH","CL","CZ","DK","EE","ES","FI","HR","IE","IS","LT","LV","ME","MK","NL","RO","RS","SE","SI","SK","SM","ZA"],validate:function(b,c,d){var e=c.val();if(""===e)return!0;var f=d.country;if(f?("string"!=typeof f||-1===a.inArray(f.toUpperCase(),this.COUNTRY_CODES))&&(f=b.getDynamicOption(c,f)):f=e.substr(0,2),-1===a.inArray(f,this.COUNTRY_CODES))return{valid:!1,message:a.fn.bootstrapValidator.helpers.format(a.fn.bootstrapValidator.i18n.id.countryNotSupported,f)};var g=["_",f.toLowerCase()].join("");return this[g](e)?!0:{valid:!1,message:a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.id.country,a.fn.bootstrapValidator.i18n.id.countries[f.toUpperCase()])}},_validateJMBG:function(a,b){if(!/^\d{13}$/.test(a))return!1;var c=parseInt(a.substr(0,2),10),d=parseInt(a.substr(2,2),10),e=(parseInt(a.substr(4,3),10),parseInt(a.substr(7,2),10)),f=parseInt(a.substr(12,1),10);if(c>31||d>12)return!1;for(var g=0,h=0;6>h;h++)g+=(7-h)*(parseInt(a.charAt(h),10)+parseInt(a.charAt(h+6),10));if(g=11-g%11,(10===g||11===g)&&(g=0),g!==f)return!1;switch(b.toUpperCase()){case"BA":return e>=10&&19>=e;case"MK":return e>=41&&49>=e;case"ME":return e>=20&&29>=e;case"RS":return e>=70&&99>=e;case"SI":return e>=50&&59>=e;default:return!0}},_ba:function(a){return this._validateJMBG(a,"BA")},_mk:function(a){return this._validateJMBG(a,"MK")},_me:function(a){return this._validateJMBG(a,"ME")},_rs:function(a){return this._validateJMBG(a,"RS")},_si:function(a){return this._validateJMBG(a,"SI")},_bg:function(b){if(!/^\d{10}$/.test(b)&&!/^\d{6}\s\d{3}\s\d{1}$/.test(b))return!1;b=b.replace(/\s/g,"");var c=parseInt(b.substr(0,2),10)+1900,d=parseInt(b.substr(2,2),10),e=parseInt(b.substr(4,2),10);if(d>40?(c+=100,d-=40):d>20&&(c-=100,d-=20),!a.fn.bootstrapValidator.helpers.date(c,d,e))return!1;for(var f=0,g=[2,4,8,5,10,9,7,3,6],h=0;9>h;h++)f+=parseInt(b.charAt(h),10)*g[h];return f=f%11%10,f+""===b.substr(9,1)},_br:function(a){if(/^1{11}|2{11}|3{11}|4{11}|5{11}|6{11}|7{11}|8{11}|9{11}|0{11}$/.test(a))return!1;if(!/^\d{11}$/.test(a)&&!/^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(a))return!1;a=a.replace(/\./g,"").replace(/-/g,"");for(var b=0,c=0;9>c;c++)b+=(10-c)*parseInt(a.charAt(c),10);if(b=11-b%11,(10===b||11===b)&&(b=0),b+""!==a.charAt(9))return!1;var d=0;for(c=0;10>c;c++)d+=(11-c)*parseInt(a.charAt(c),10);return d=11-d%11,(10===d||11===d)&&(d=0),d+""===a.charAt(10)},_ch:function(a){if(!/^756[\.]{0,1}[0-9]{4}[\.]{0,1}[0-9]{4}[\.]{0,1}[0-9]{2}$/.test(a))return!1;a=a.replace(/\D/g,"").substr(3);for(var b=a.length,c=0,d=8===b?[3,1]:[1,3],e=0;b-1>e;e++)c+=parseInt(a.charAt(e),10)*d[e%2];return c=10-c%10,c+""===a.charAt(b-1)},_cl:function(a){if(!/^\d{7,8}[-]{0,1}[0-9K]$/i.test(a))return!1;for(a=a.replace(/\-/g,"");a.length<9;)a="0"+a;for(var b=0,c=[3,2,7,6,5,4,3,2],d=0;8>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b=11-b%11,11===b?b=0:10===b&&(b="K"),b+""===a.charAt(8).toUpperCase()},_cz:function(b){if(!/^\d{9,10}$/.test(b))return!1;var c=1900+parseInt(b.substr(0,2),10),d=parseInt(b.substr(2,2),10)%50%20,e=parseInt(b.substr(4,2),10);if(9===b.length){if(c>=1980&&(c-=100),c>1953)return!1}else 1954>c&&(c+=100);if(!a.fn.bootstrapValidator.helpers.date(c,d,e))return!1;if(10===b.length){var f=parseInt(b.substr(0,9),10)%11;return 1985>c&&(f%=10),f+""===b.substr(9,1)}return!0},_dk:function(b){if(!/^[0-9]{6}[-]{0,1}[0-9]{4}$/.test(b))return!1;b=b.replace(/-/g,"");var c=parseInt(b.substr(0,2),10),d=parseInt(b.substr(2,2),10),e=parseInt(b.substr(4,2),10);switch(!0){case-1!=="5678".indexOf(b.charAt(6))&&e>=58:e+=1800;break;case-1!=="0123".indexOf(b.charAt(6)):case-1!=="49".indexOf(b.charAt(6))&&e>=37:e+=1900;break;default:e+=2e3}return a.fn.bootstrapValidator.helpers.date(e,d,c)},_ee:function(a){return this._lt(a)},_es:function(a){if(!/^[0-9A-Z]{8}[-]{0,1}[0-9A-Z]$/.test(a)&&!/^[XYZ][-]{0,1}[0-9]{7}[-]{0,1}[0-9A-Z]$/.test(a))return!1;a=a.replace(/-/g,"");var b="XYZ".indexOf(a.charAt(0));-1!==b&&(a=b+a.substr(1)+"");var c=parseInt(a.substr(0,8),10);return c="TRWAGMYFPDXBNJZSQVHLCKE"[c%23],c===a.substr(8,1)},_fi:function(b){if(!/^[0-9]{6}[-+A][0-9]{3}[0-9ABCDEFHJKLMNPRSTUVWXY]$/.test(b))return!1;var c=parseInt(b.substr(0,2),10),d=parseInt(b.substr(2,2),10),e=parseInt(b.substr(4,2),10),f={"+":1800,"-":1900,A:2e3};if(e=f[b.charAt(6)]+e,!a.fn.bootstrapValidator.helpers.date(e,d,c))return!1;var g=parseInt(b.substr(7,3),10);if(2>g)return!1;var h=b.substr(0,6)+b.substr(7,3)+"";return h=parseInt(h,10),"0123456789ABCDEFHJKLMNPRSTUVWXY".charAt(h%31)===b.charAt(10)},_hr:function(b){return/^[0-9]{11}$/.test(b)?a.fn.bootstrapValidator.helpers.mod11And10(b):!1},_ie:function(a){if(!/^\d{7}[A-W][AHWTX]?$/.test(a))return!1;var b=function(a){for(;a.length<7;)a="0"+a;for(var b="WABCDEFGHIJKLMNOPQRSTUV",c=0,d=0;7>d;d++)c+=parseInt(a.charAt(d),10)*(8-d);return c+=9*b.indexOf(a.substr(7)),b[c%23]};return 9!==a.length||"A"!==a.charAt(8)&&"H"!==a.charAt(8)?a.charAt(7)===b(a.substr(0,7)):a.charAt(7)===b(a.substr(0,7)+a.substr(8)+"")},_is:function(b){if(!/^[0-9]{6}[-]{0,1}[0-9]{4}$/.test(b))return!1;b=b.replace(/-/g,"");var c=parseInt(b.substr(0,2),10),d=parseInt(b.substr(2,2),10),e=parseInt(b.substr(4,2),10),f=parseInt(b.charAt(9),10);if(e=9===f?1900+e:100*(20+f)+e,!a.fn.bootstrapValidator.helpers.date(e,d,c,!0))return!1;for(var g=0,h=[3,2,7,6,5,4,3,2],i=0;8>i;i++)g+=parseInt(b.charAt(i),10)*h[i];return g=11-g%11,g+""===b.charAt(8)},_lt:function(b){if(!/^[0-9]{11}$/.test(b))return!1;var c=parseInt(b.charAt(0),10),d=parseInt(b.substr(1,2),10),e=parseInt(b.substr(3,2),10),f=parseInt(b.substr(5,2),10),g=c%2===0?17+c/2:17+(c+1)/2;if(d=100*g+d,!a.fn.bootstrapValidator.helpers.date(d,e,f,!0))return!1;for(var h=0,i=[1,2,3,4,5,6,7,8,9,1],j=0;10>j;j++)h+=parseInt(b.charAt(j),10)*i[j];if(h%=11,10!==h)return h+""===b.charAt(10);for(h=0,i=[3,4,5,6,7,8,9,1,2,3],j=0;10>j;j++)h+=parseInt(b.charAt(j),10)*i[j];return h%=11,10===h&&(h=0),h+""===b.charAt(10)},_lv:function(b){if(!/^[0-9]{6}[-]{0,1}[0-9]{5}$/.test(b))return!1;b=b.replace(/\D/g,"");var c=parseInt(b.substr(0,2),10),d=parseInt(b.substr(2,2),10),e=parseInt(b.substr(4,2),10);if(e=e+1800+100*parseInt(b.charAt(6),10),!a.fn.bootstrapValidator.helpers.date(e,d,c,!0))return!1;for(var f=0,g=[10,5,8,4,2,1,6,3,7,9],h=0;10>h;h++)f+=parseInt(b.charAt(h),10)*g[h];return f=(f+1)%11%10,f+""===b.charAt(10)},_nl:function(a){for(;a.length<9;)a="0"+a;if(!/^[0-9]{4}[.]{0,1}[0-9]{2}[.]{0,1}[0-9]{3}$/.test(a))return!1;if(a=a.replace(/\./g,""),0===parseInt(a,10))return!1;for(var b=0,c=a.length,d=0;c-1>d;d++)b+=(9-d)*parseInt(a.charAt(d),10);return b%=11,10===b&&(b=0),b+""===a.charAt(c-1)},_ro:function(b){if(!/^[0-9]{13}$/.test(b))return!1;var c=parseInt(b.charAt(0),10);if(0===c||7===c||8===c)return!1;var d=parseInt(b.substr(1,2),10),e=parseInt(b.substr(3,2),10),f=parseInt(b.substr(5,2),10),g={1:1900,2:1900,3:1800,4:1800,5:2e3,6:2e3};if(f>31&&e>12)return!1;if(9!==c&&(d=g[c+""]+d,!a.fn.bootstrapValidator.helpers.date(d,e,f)))return!1;for(var h=0,i=[2,7,9,1,4,6,3,5,8,2,7,9],j=b.length,k=0;j-1>k;k++)h+=parseInt(b.charAt(k),10)*i[k];return h%=11,10===h&&(h=1),h+""===b.charAt(j-1)},_se:function(b){if(!/^[0-9]{10}$/.test(b)&&!/^[0-9]{6}[-|+][0-9]{4}$/.test(b))return!1;b=b.replace(/[^0-9]/g,"");var c=parseInt(b.substr(0,2),10)+1900,d=parseInt(b.substr(2,2),10),e=parseInt(b.substr(4,2),10);return a.fn.bootstrapValidator.helpers.date(c,d,e)?a.fn.bootstrapValidator.helpers.luhn(b):!1},_sk:function(a){return this._cz(a)},_sm:function(a){return/^\d{5}$/.test(a)},_za:function(b){if(!/^[0-9]{10}[0|1][8|9][0-9]$/.test(b))return!1;var c=parseInt(b.substr(0,2),10),d=(new Date).getFullYear()%100,e=parseInt(b.substr(2,2),10),f=parseInt(b.substr(4,2),10);return c=c>=d?c+1900:c+2e3,a.fn.bootstrapValidator.helpers.date(c,e,f)?a.fn.bootstrapValidator.helpers.luhn(b):!1}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.identical=a.extend(a.fn.bootstrapValidator.i18n.identical||{},{"default":"Please enter the same value"}),a.fn.bootstrapValidator.validators.identical={html5Attributes:{message:"message",field:"field"},validate:function(a,b,c){var d=b.val();if(""===d)return!0;var e=a.getFieldElements(c.field);return null===e||0===e.length?!0:d===e.val()?(a.updateStatus(c.field,a.STATUS_VALID,"identical"),!0):!1}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.imei=a.extend(a.fn.bootstrapValidator.i18n.imei||{},{"default":"Please enter a valid IMEI number"}),a.fn.bootstrapValidator.validators.imei={validate:function(b,c){var d=c.val();if(""===d)return!0;switch(!0){case/^\d{15}$/.test(d):case/^\d{2}-\d{6}-\d{6}-\d{1}$/.test(d):case/^\d{2}\s\d{6}\s\d{6}\s\d{1}$/.test(d):return d=d.replace(/[^0-9]/g,""),a.fn.bootstrapValidator.helpers.luhn(d);case/^\d{14}$/.test(d):case/^\d{16}$/.test(d):case/^\d{2}-\d{6}-\d{6}(|-\d{2})$/.test(d):case/^\d{2}\s\d{6}\s\d{6}(|\s\d{2})$/.test(d):return!0;default:return!1}}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.imo=a.extend(a.fn.bootstrapValidator.i18n.imo||{},{"default":"Please enter a valid IMO number"}),a.fn.bootstrapValidator.validators.imo={validate:function(a,b){var c=b.val();if(""===c)return!0;if(!/^IMO \d{7}$/i.test(c))return!1;for(var d=0,e=c.replace(/^.*(\d{7})$/,"$1"),f=6;f>=1;f--)d+=e.slice(6-f,-f)*(f+1);return d%10===parseInt(e.charAt(6),10)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.integer=a.extend(a.fn.bootstrapValidator.i18n.integer||{},{"default":"Please enter a valid number"}),a.fn.bootstrapValidator.validators.integer={enableByHtml5:function(a){return"number"===a.attr("type")&&(void 0===a.attr("step")||a.attr("step")%1===0)},validate:function(a,b){if(this.enableByHtml5(b)&&b.get(0).validity&&b.get(0).validity.badInput===!0)return!1;var c=b.val();return""===c?!0:/^(?:-?(?:0|[1-9][0-9]*))$/.test(c)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.ip=a.extend(a.fn.bootstrapValidator.i18n.ip||{},{"default":"Please enter a valid IP address",ipv4:"Please enter a valid IPv4 address",ipv6:"Please enter a valid IPv6 address"}),a.fn.bootstrapValidator.validators.ip={html5Attributes:{message:"message",ipv4:"ipv4",ipv6:"ipv6"},validate:function(b,c,d){var e=c.val();if(""===e)return!0;d=a.extend({},{ipv4:!0,ipv6:!0},d);var f,g=/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,h=/^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/,i=!1;switch(!0){case d.ipv4&&!d.ipv6:i=g.test(e),f=d.message||a.fn.bootstrapValidator.i18n.ip.ipv4;break;case!d.ipv4&&d.ipv6:i=h.test(e),f=d.message||a.fn.bootstrapValidator.i18n.ip.ipv6;break;case d.ipv4&&d.ipv6:default:i=g.test(e)&&h.test(e),f=d.message||a.fn.bootstrapValidator.i18n.ip["default"]}return{valid:i,message:f}}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.isbn=a.extend(a.fn.bootstrapValidator.i18n.isbn||{},{"default":"Please enter a valid ISBN number"}),a.fn.bootstrapValidator.validators.isbn={validate:function(a,b){var c=b.val();if(""===c)return!0;var d;switch(!0){case/^\d{9}[\dX]$/.test(c):case 13===c.length&&/^(\d+)-(\d+)-(\d+)-([\dX])$/.test(c):case 13===c.length&&/^(\d+)\s(\d+)\s(\d+)\s([\dX])$/.test(c):d="ISBN10";break;case/^(978|979)\d{9}[\dX]$/.test(c):case 17===c.length&&/^(978|979)-(\d+)-(\d+)-(\d+)-([\dX])$/.test(c):case 17===c.length&&/^(978|979)\s(\d+)\s(\d+)\s(\d+)\s([\dX])$/.test(c):d="ISBN13";break;default:return!1}c=c.replace(/[^0-9X]/gi,"");var e,f,g=c.split(""),h=g.length,i=0;switch(d){case"ISBN10":for(i=0,e=0;h-1>e;e++)i+=parseInt(g[e],10)*(10-e);return f=11-i%11,11===f?f=0:10===f&&(f="X"),f+""===g[h-1];case"ISBN13":for(i=0,e=0;h-1>e;e++)i+=e%2===0?parseInt(g[e],10):3*parseInt(g[e],10);return f=10-i%10,10===f&&(f="0"),f+""===g[h-1];default:return!1}}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.isin=a.extend(a.fn.bootstrapValidator.i18n.isin||{},{"default":"Please enter a valid ISIN number"}),a.fn.bootstrapValidator.validators.isin={COUNTRY_CODES:"AF|AX|AL|DZ|AS|AD|AO|AI|AQ|AG|AR|AM|AW|AU|AT|AZ|BS|BH|BD|BB|BY|BE|BZ|BJ|BM|BT|BO|BQ|BA|BW|BV|BR|IO|BN|BG|BF|BI|KH|CM|CA|CV|KY|CF|TD|CL|CN|CX|CC|CO|KM|CG|CD|CK|CR|CI|HR|CU|CW|CY|CZ|DK|DJ|DM|DO|EC|EG|SV|GQ|ER|EE|ET|FK|FO|FJ|FI|FR|GF|PF|TF|GA|GM|GE|DE|GH|GI|GR|GL|GD|GP|GU|GT|GG|GN|GW|GY|HT|HM|VA|HN|HK|HU|IS|IN|ID|IR|IQ|IE|IM|IL|IT|JM|JP|JE|JO|KZ|KE|KI|KP|KR|KW|KG|LA|LV|LB|LS|LR|LY|LI|LT|LU|MO|MK|MG|MW|MY|MV|ML|MT|MH|MQ|MR|MU|YT|MX|FM|MD|MC|MN|ME|MS|MA|MZ|MM|NA|NR|NP|NL|NC|NZ|NI|NE|NG|NU|NF|MP|NO|OM|PK|PW|PS|PA|PG|PY|PE|PH|PN|PL|PT|PR|QA|RE|RO|RU|RW|BL|SH|KN|LC|MF|PM|VC|WS|SM|ST|SA|SN|RS|SC|SL|SG|SX|SK|SI|SB|SO|ZA|GS|SS|ES|LK|SD|SR|SJ|SZ|SE|CH|SY|TW|TJ|TZ|TH|TL|TG|TK|TO|TT|TN|TR|TM|TC|TV|UG|UA|AE|GB|US|UM|UY|UZ|VU|VE|VN|VG|VI|WF|EH|YE|ZM|ZW",validate:function(a,b){var c=b.val();if(""===c)return!0;c=c.toUpperCase();var d=new RegExp("^("+this.COUNTRY_CODES+")[0-9A-Z]{10}$");if(!d.test(c))return!1;for(var e="",f=c.length,g=0;f-1>g;g++){var h=c.charCodeAt(g);e+=h>57?(h-55).toString():c.charAt(g)}var i="",j=e.length,k=j%2!==0?0:1;for(g=0;j>g;g++)i+=parseInt(e[g],10)*(g%2===k?2:1)+"";var l=0;for(g=0;g<i.length;g++)l+=parseInt(i.charAt(g),10);return l=(10-l%10)%10,l+""===c.charAt(f-1)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.ismn=a.extend(a.fn.bootstrapValidator.i18n.ismn||{},{"default":"Please enter a valid ISMN number"}),a.fn.bootstrapValidator.validators.ismn={validate:function(a,b){var c=b.val();if(""===c)return!0;var d;switch(!0){case/^M\d{9}$/.test(c):case/^M-\d{4}-\d{4}-\d{1}$/.test(c):case/^M\s\d{4}\s\d{4}\s\d{1}$/.test(c):d="ISMN10";break;case/^9790\d{9}$/.test(c):case/^979-0-\d{4}-\d{4}-\d{1}$/.test(c):case/^979\s0\s\d{4}\s\d{4}\s\d{1}$/.test(c):d="ISMN13";break;default:return!1}"ISMN10"===d&&(c="9790"+c.substr(1)),c=c.replace(/[^0-9]/gi,"");for(var e=c.length,f=0,g=[1,3],h=0;e-1>h;h++)f+=parseInt(c.charAt(h),10)*g[h%2];return f=10-f%10,f+""===c.charAt(e-1)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.issn=a.extend(a.fn.bootstrapValidator.i18n.issn||{},{"default":"Please enter a valid ISSN number"}),a.fn.bootstrapValidator.validators.issn={validate:function(a,b){var c=b.val();if(""===c)return!0;if(!/^\d{4}\-\d{3}[\dX]$/.test(c))return!1;c=c.replace(/[^0-9X]/gi,"");var d=c.split(""),e=d.length,f=0;"X"===d[7]&&(d[7]=10);for(var g=0;e>g;g++)f+=parseInt(d[g],10)*(8-g);return f%11===0}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.lessThan=a.extend(a.fn.bootstrapValidator.i18n.lessThan||{},{"default":"Please enter a value less than or equal to %s",notInclusive:"Please enter a value less than %s"}),a.fn.bootstrapValidator.validators.lessThan={html5Attributes:{message:"message",value:"value",inclusive:"inclusive"},enableByHtml5:function(a){var b=a.attr("type"),c=a.attr("max");return c&&"date"!==b?{value:c}:!1},validate:function(b,c,d){var e=c.val();if(""===e)return!0;if(!a.isNumeric(e))return!1;var f=a.isNumeric(d.value)?d.value:b.getDynamicOption(c,d.value);return e=parseFloat(e),d.inclusive===!0||void 0===d.inclusive?{valid:f>=e,message:a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.lessThan["default"],f)}:{valid:f>e,message:a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.lessThan.notInclusive,f)}}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.mac=a.extend(a.fn.bootstrapValidator.i18n.mac||{},{"default":"Please enter a valid MAC address"}),a.fn.bootstrapValidator.validators.mac={validate:function(a,b){var c=b.val();return""===c?!0:/^([0-9A-F]{2}[:-]){5}([0-9A-F]{2})$/.test(c)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.meid=a.extend(a.fn.bootstrapValidator.i18n.meid||{},{"default":"Please enter a valid MEID number"}),a.fn.bootstrapValidator.validators.meid={validate:function(b,c){var d=c.val();if(""===d)return!0;switch(!0){case/^[0-9A-F]{15}$/i.test(d):case/^[0-9A-F]{2}[- ][0-9A-F]{6}[- ][0-9A-F]{6}[- ][0-9A-F]$/i.test(d):case/^\d{19}$/.test(d):case/^\d{5}[- ]\d{5}[- ]\d{4}[- ]\d{4}[- ]\d$/.test(d):var e=d.charAt(d.length-1);if(d=d.replace(/[- ]/g,""),d.match(/^\d*$/i))return a.fn.bootstrapValidator.helpers.luhn(d);d=d.slice(0,-1);for(var f="",g=1;13>=g;g+=2)f+=(2*parseInt(d.charAt(g),16)).toString(16);var h=0;for(g=0;g<f.length;g++)h+=parseInt(f.charAt(g),16);return h%10===0?"0"===e:e===(2*(10*Math.floor((h+10)/10)-h)).toString(16);case/^[0-9A-F]{14}$/i.test(d):case/^[0-9A-F]{2}[- ][0-9A-F]{6}[- ][0-9A-F]{6}$/i.test(d):case/^\d{18}$/.test(d):case/^\d{5}[- ]\d{5}[- ]\d{4}[- ]\d{4}$/.test(d):return!0;default:return!1}}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.notEmpty=a.extend(a.fn.bootstrapValidator.i18n.notEmpty||{},{"default":"Please enter a value"}),a.fn.bootstrapValidator.validators.notEmpty={enableByHtml5:function(a){var b=a.attr("required")+"";return"required"===b||"true"===b},validate:function(b,c){var d=c.attr("type");return"radio"===d||"checkbox"===d?b.getFieldElements(c.attr("data-bv-field")).filter(":checked").length>0:""!==a.trim(c.val())}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.numeric=a.extend(a.fn.bootstrapValidator.i18n.numeric||{},{"default":"Please enter a valid float number"}),a.fn.bootstrapValidator.validators.numeric={html5Attributes:{message:"message",separator:"separator"},enableByHtml5:function(a){return"number"===a.attr("type")&&void 0!==a.attr("step")&&a.attr("step")%1!==0},validate:function(a,b,c){if(this.enableByHtml5(b)&&b.get(0).validity&&b.get(0).validity.badInput===!0)return!1;var d=b.val();if(""===d)return!0;var e=c.separator||".";return"."!==e&&(d=d.replace(e,".")),!isNaN(parseFloat(d))&&isFinite(d)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.phone=a.extend(a.fn.bootstrapValidator.i18n.phone||{},{"default":"Please enter a valid phone number",countryNotSupported:"The country code %s is not supported",country:"Please enter a valid phone number in %s",countries:{BR:"Brazil",ES:"Spain",FR:"France",GB:"United Kingdom",MA:"Morocco",PK:"Pakistan",US:"USA"}}),a.fn.bootstrapValidator.validators.phone={html5Attributes:{message:"message",country:"country"},COUNTRY_CODES:["BR","ES","FR","GB","MA","PK","US"],validate:function(b,c,d){var e=c.val();if(""===e)return!0;var f=d.country;if(("string"!=typeof f||-1===a.inArray(f,this.COUNTRY_CODES))&&(f=b.getDynamicOption(c,f)),!f||-1===a.inArray(f.toUpperCase(),this.COUNTRY_CODES))return{valid:!1,message:a.fn.bootstrapValidator.helpers.format(a.fn.bootstrapValidator.i18n.phone.countryNotSupported,f)};var g=!0;switch(f.toUpperCase()){case"BR":e=a.trim(e),g=/^(([\d]{4}[-.\s]{1}[\d]{2,3}[-.\s]{1}[\d]{2}[-.\s]{1}[\d]{2})|([\d]{4}[-.\s]{1}[\d]{3}[-.\s]{1}[\d]{4})|((\(?\+?[0-9]{2}\)?\s?)?(\(?\d{2}\)?\s?)?\d{4,5}[-.\s]?\d{4}))$/.test(e);break;
case"ES":e=a.trim(e),g=/^(?:(?:(?:\+|00)34\D?))?(?:9|6)(?:\d\D?){8}$/.test(e);break;case"FR":e=a.trim(e),g=/^(?:(?:(?:\+|00)33[ ]?(?:\(0\)[ ]?)?)|0){1}[1-9]{1}([ .-]?)(?:\d{2}\1?){3}\d{2}$/.test(e);break;case"GB":e=a.trim(e),g=/^\(?(?:(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?\(?(?:0\)?[\s-]?\(?)?|0)(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}|\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4}|\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3})|\d{5}\)?[\s-]?\d{4,5}|8(?:00[\s-]?11[\s-]?11|45[\s-]?46[\s-]?4\d))(?:(?:[\s-]?(?:x|ext\.?\s?|\#)\d+)?)$/.test(e);break;case"MA":e=a.trim(e),g=/^(?:(?:(?:\+|00)212[\s]?(?:[\s]?\(0\)[\s]?)?)|0){1}(?:5[\s.-]?[2-3]|6[\s.-]?[13-9]){1}[0-9]{1}(?:[\s.-]?\d{2}){3}$/.test(e);break;case"PK":e=a.trim(e),g=/^0?3[0-9]{2}[0-9]{7}$/.test(e);break;case"US":default:e=e.replace(/\D/g,""),g=/^(?:(1\-?)|(\+1 ?))?\(?(\d{3})[\)\-\.]?(\d{3})[\-\.]?(\d{4})$/.test(e)&&10===e.length}return{valid:g,message:a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.phone.country,a.fn.bootstrapValidator.i18n.phone.countries[f])}}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.regexp=a.extend(a.fn.bootstrapValidator.i18n.regexp||{},{"default":"Please enter a value matching the pattern"}),a.fn.bootstrapValidator.validators.regexp={html5Attributes:{message:"message",regexp:"regexp"},enableByHtml5:function(a){var b=a.attr("pattern");return b?{regexp:b}:!1},validate:function(a,b,c){var d=b.val();if(""===d)return!0;var e="string"==typeof c.regexp?new RegExp(c.regexp):c.regexp;return e.test(d)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.remote=a.extend(a.fn.bootstrapValidator.i18n.remote||{},{"default":"Please enter a valid value"}),a.fn.bootstrapValidator.validators.remote={html5Attributes:{message:"message",name:"name",type:"type",url:"url"},validate:function(b,c,d){var e=c.val();if(""===e)return!0;var f=c.attr("data-bv-field"),g=d.data||{},h=d.url,i=d.type||"POST",j=d.headers||{};"function"==typeof g&&(g=g.call(this,b)),"function"==typeof h&&(h=h.call(this,b)),g[d.name||f]=e;var k=new a.Deferred,l=a.ajax({type:i,headers:j,url:h,dataType:"json",data:g});return l.then(function(a){k.resolve(c,"remote",a.valid===!0||"true"===a.valid,a.message?a.message:null)}),k.fail(function(){l.abort()}),k}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.rtn=a.extend(a.fn.bootstrapValidator.i18n.rtn||{},{"default":"Please enter a valid RTN number"}),a.fn.bootstrapValidator.validators.rtn={validate:function(a,b){var c=b.val();if(""===c)return!0;if(!/^\d{9}$/.test(c))return!1;for(var d=0,e=0;e<c.length;e+=3)d+=3*parseInt(c.charAt(e),10)+7*parseInt(c.charAt(e+1),10)+parseInt(c.charAt(e+2),10);return 0!==d&&d%10===0}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.sedol=a.extend(a.fn.bootstrapValidator.i18n.sedol||{},{"default":"Please enter a valid SEDOL number"}),a.fn.bootstrapValidator.validators.sedol={validate:function(a,b){var c=b.val();if(""===c)return!0;if(c=c.toUpperCase(),!/^[0-9A-Z]{7}$/.test(c))return!1;for(var d=0,e=[1,3,1,7,3,9,1],f=c.length,g=0;f-1>g;g++)d+=e[g]*parseInt(c.charAt(g),36);return d=(10-d%10)%10,d+""===c.charAt(f-1)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.siren=a.extend(a.fn.bootstrapValidator.i18n.siren||{},{"default":"Please enter a valid SIREN number"}),a.fn.bootstrapValidator.validators.siren={validate:function(b,c){var d=c.val();return""===d?!0:/^\d{9}$/.test(d)?a.fn.bootstrapValidator.helpers.luhn(d):!1}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.siret=a.extend(a.fn.bootstrapValidator.i18n.siret||{},{"default":"Please enter a valid SIRET number"}),a.fn.bootstrapValidator.validators.siret={validate:function(a,b){var c=b.val();if(""===c)return!0;for(var d,e=0,f=c.length,g=0;f>g;g++)d=parseInt(c.charAt(g),10),g%2===0&&(d=2*d,d>9&&(d-=9)),e+=d;return e%10===0}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.step=a.extend(a.fn.bootstrapValidator.i18n.step||{},{"default":"Please enter a valid step of %s"}),a.fn.bootstrapValidator.validators.step={html5Attributes:{message:"message",base:"baseValue",step:"step"},validate:function(b,c,d){var e=c.val();if(""===e)return!0;if(d=a.extend({},{baseValue:0,step:1},d),e=parseFloat(e),!a.isNumeric(e))return!1;var f=function(a,b){var c=Math.pow(10,b);a*=c;var d=a>0|-(0>a),e=a%1===.5*d;return e?(Math.floor(a)+(d>0))/c:Math.round(a)/c},g=function(a,b){if(0===b)return 1;var c=(a+"").split("."),d=(b+"").split("."),e=(1===c.length?0:c[1].length)+(1===d.length?0:d[1].length);return f(a-b*Math.floor(a/b),e)},h=g(e-d.baseValue,d.step);return{valid:0===h||h===d.step,message:a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.step["default"],[d.step])}}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.stringCase=a.extend(a.fn.bootstrapValidator.i18n.stringCase||{},{"default":"Please enter only lowercase characters",upper:"Please enter only uppercase characters"}),a.fn.bootstrapValidator.validators.stringCase={html5Attributes:{message:"message","case":"case"},validate:function(b,c,d){var e=c.val();if(""===e)return!0;var f=(d["case"]||"lower").toLowerCase();return{valid:"upper"===f?e===e.toUpperCase():e===e.toLowerCase(),message:d.message||("upper"===f?a.fn.bootstrapValidator.i18n.stringCase.upper:a.fn.bootstrapValidator.i18n.stringCase["default"])}}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.stringLength=a.extend(a.fn.bootstrapValidator.i18n.stringLength||{},{"default":"Please enter a value with valid length",less:"Please enter less than %s characters",more:"Please enter more than %s characters",between:"Please enter value between %s and %s characters long"}),a.fn.bootstrapValidator.validators.stringLength={html5Attributes:{message:"message",min:"min",max:"max"},enableByHtml5:function(a){var b=a.attr("maxlength");return b?{max:parseInt(b,10)}:!1},validate:function(b,c,d){var e=c.val();if(""===e)return!0;var f=a.isNumeric(d.min)?d.min:b.getDynamicOption(c,d.min),g=a.isNumeric(d.max)?d.max:b.getDynamicOption(c,d.max),h=e.length,i=!0,j=d.message||a.fn.bootstrapValidator.i18n.stringLength["default"];switch((f&&h<parseInt(f,10)||g&&h>parseInt(g,10))&&(i=!1),!0){case!!f&&!!g:j=a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.stringLength.between,[parseInt(f,10),parseInt(g,10)]);break;case!!f:j=a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.stringLength.more,parseInt(f,10));break;case!!g:j=a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.stringLength.less,parseInt(g,10))}return{valid:i,message:j}}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.uri=a.extend(a.fn.bootstrapValidator.i18n.uri||{},{"default":"Please enter a valid URI"}),a.fn.bootstrapValidator.validators.uri={html5Attributes:{message:"message",allowlocal:"allowLocal"},enableByHtml5:function(a){return"url"===a.attr("type")},validate:function(a,b,c){var d=b.val();if(""===d)return!0;var e=c.allowLocal===!0||"true"===c.allowLocal,f=new RegExp("^(?:(?:https?|ftp)://)(?:\\S+(?::\\S*)?@)?(?:"+(e?"":"(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})")+"(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))"+(e?"?":"")+")(?::\\d{2,5})?(?:/[^\\s]*)?$","i");return f.test(d)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.uuid=a.extend(a.fn.bootstrapValidator.i18n.uuid||{},{"default":"Please enter a valid UUID number",version:"Please enter a valid UUID version %s number"}),a.fn.bootstrapValidator.validators.uuid={html5Attributes:{message:"message",version:"version"},validate:function(b,c,d){var e=c.val();if(""===e)return!0;var f={3:/^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,4:/^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,5:/^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,all:/^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i},g=d.version?d.version+"":"all";return{valid:null===f[g]?!0:f[g].test(e),message:d.version?a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.uuid.version,d.version):d.message||a.fn.bootstrapValidator.i18n.uuid["default"]}}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.vat=a.extend(a.fn.bootstrapValidator.i18n.vat||{},{"default":"Please enter a valid VAT number",countryNotSupported:"The country code %s is not supported",country:"Please enter a valid %s VAT number",countries:{AT:"Austrian",BE:"Belgian",BG:"Bulgarian",BR:"Brazilian",CH:"Swiss",CY:"Cypriot",CZ:"Czech",DE:"German",DK:"Danish",EE:"Estonian",ES:"Spanish",FI:"Finnish",FR:"French",GB:"United Kingdom",GR:"Greek",EL:"Greek",HU:"Hungarian",HR:"Croatian",IE:"Irish",IS:"Iceland",IT:"Italian",LT:"Lithuanian",LU:"Luxembourg",LV:"Latvian",MT:"Maltese",NL:"Dutch",NO:"Norwegian",PL:"Polish",PT:"Portuguese",RO:"Romanian",RU:"Russian",RS:"Serbian",SE:"Swedish",SI:"Slovenian",SK:"Slovak",ZA:"South African"}}),a.fn.bootstrapValidator.validators.vat={html5Attributes:{message:"message",country:"country"},COUNTRY_CODES:["AT","BE","BG","BR","CH","CY","CZ","DE","DK","EE","EL","ES","FI","FR","GB","GR","HR","HU","IE","IS","IT","LT","LU","LV","MT","NL","NO","PL","PT","RO","RU","RS","SE","SK","SI","ZA"],validate:function(b,c,d){var e=c.val();if(""===e)return!0;var f=d.country;if(f?("string"!=typeof f||-1===a.inArray(f.toUpperCase(),this.COUNTRY_CODES))&&(f=b.getDynamicOption(c,f)):f=e.substr(0,2),-1===a.inArray(f,this.COUNTRY_CODES))return{valid:!1,message:a.fn.bootstrapValidator.helpers.format(a.fn.bootstrapValidator.i18n.vat.countryNotSupported,f)};var g=["_",f.toLowerCase()].join("");return this[g](e)?!0:{valid:!1,message:a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.vat.country,a.fn.bootstrapValidator.i18n.vat.countries[f.toUpperCase()])}},_at:function(a){if(!/^ATU[0-9]{8}$/.test(a))return!1;a=a.substr(3);for(var b=0,c=[1,2,1,2,1,2,1],d=0,e=0;7>e;e++)d=parseInt(a.charAt(e),10)*c[e],d>9&&(d=Math.floor(d/10)+d%10),b+=d;return b=10-(b+4)%10,10===b&&(b=0),b+""===a.substr(7,1)},_be:function(a){if(!/^BE[0]{0,1}[0-9]{9}$/.test(a))return!1;if(a=a.substr(2),9===a.length&&(a="0"+a),"0"===a.substr(1,1))return!1;var b=parseInt(a.substr(0,8),10)+parseInt(a.substr(8,2),10);return b%97===0},_bg:function(b){if(!/^BG[0-9]{9,10}$/.test(b))return!1;b=b.substr(2);var c=0,d=0;if(9===b.length){for(d=0;8>d;d++)c+=parseInt(b.charAt(d),10)*(d+1);if(c%=11,10===c)for(c=0,d=0;8>d;d++)c+=parseInt(b.charAt(d),10)*(d+3);return c%=10,c+""===b.substr(8)}if(10===b.length){var e=function(b){var c=parseInt(b.substr(0,2),10)+1900,d=parseInt(b.substr(2,2),10),e=parseInt(b.substr(4,2),10);if(d>40?(c+=100,d-=40):d>20&&(c-=100,d-=20),!a.fn.bootstrapValidator.helpers.date(c,d,e))return!1;for(var f=0,g=[2,4,8,5,10,9,7,3,6],h=0;9>h;h++)f+=parseInt(b.charAt(h),10)*g[h];return f=f%11%10,f+""===b.substr(9,1)},f=function(a){for(var b=0,c=[21,19,17,13,11,9,7,3,1],d=0;9>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b%=10,b+""===a.substr(9,1)},g=function(a){for(var b=0,c=[4,3,2,7,6,5,4,3,2],d=0;9>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b=11-b%11,10===b?!1:(11===b&&(b=0),b+""===a.substr(9,1))};return e(b)||f(b)||g(b)}return!1},_br:function(a){if(""===a)return!0;var b=a.replace(/[^\d]+/g,"");if(""===b||14!==b.length)return!1;if("00000000000000"===b||"11111111111111"===b||"22222222222222"===b||"33333333333333"===b||"44444444444444"===b||"55555555555555"===b||"66666666666666"===b||"77777777777777"===b||"88888888888888"===b||"99999999999999"===b)return!1;for(var c=b.length-2,d=b.substring(0,c),e=b.substring(c),f=0,g=c-7,h=c;h>=1;h--)f+=parseInt(d.charAt(c-h),10)*g--,2>g&&(g=9);var i=2>f%11?0:11-f%11;if(i!==parseInt(e.charAt(0),10))return!1;for(c+=1,d=b.substring(0,c),f=0,g=c-7,h=c;h>=1;h--)f+=parseInt(d.charAt(c-h),10)*g--,2>g&&(g=9);return i=2>f%11?0:11-f%11,i===parseInt(e.charAt(1),10)},_ch:function(a){if(!/^CHE[0-9]{9}(MWST)?$/.test(a))return!1;a=a.substr(3);for(var b=0,c=[5,4,3,2,7,6,5,4],d=0;8>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b=11-b%11,10===b?!1:(11===b&&(b=0),b+""===a.substr(8,1))},_cy:function(a){if(!/^CY[0-5|9]{1}[0-9]{7}[A-Z]{1}$/.test(a))return!1;if(a=a.substr(2),"12"===a.substr(0,2))return!1;for(var b=0,c={0:1,1:0,2:5,3:7,4:9,5:13,6:15,7:17,8:19,9:21},d=0;8>d;d++){var e=parseInt(a.charAt(d),10);d%2===0&&(e=c[e+""]),b+=e}return b="ABCDEFGHIJKLMNOPQRSTUVWXYZ"[b%26],b+""===a.substr(8,1)},_cz:function(b){if(!/^CZ[0-9]{8,10}$/.test(b))return!1;b=b.substr(2);var c=0,d=0;if(8===b.length){if(b.charAt(0)+""=="9")return!1;for(c=0,d=0;7>d;d++)c+=parseInt(b.charAt(d),10)*(8-d);return c=11-c%11,10===c&&(c=0),11===c&&(c=1),c+""===b.substr(7,1)}if(9===b.length&&b.charAt(0)+""=="6"){for(c=0,d=0;7>d;d++)c+=parseInt(b.charAt(d+1),10)*(8-d);return c=11-c%11,10===c&&(c=0),11===c&&(c=1),c=[8,7,6,5,4,3,2,1,0,9,10][c-1],c+""===b.substr(8,1)}if(9===b.length||10===b.length){var e=1900+parseInt(b.substr(0,2),10),f=parseInt(b.substr(2,2),10)%50%20,g=parseInt(b.substr(4,2),10);if(9===b.length){if(e>=1980&&(e-=100),e>1953)return!1}else 1954>e&&(e+=100);if(!a.fn.bootstrapValidator.helpers.date(e,f,g))return!1;if(10===b.length){var h=parseInt(b.substr(0,9),10)%11;return 1985>e&&(h%=10),h+""===b.substr(9,1)}return!0}return!1},_de:function(b){return/^DE[0-9]{9}$/.test(b)?(b=b.substr(2),a.fn.bootstrapValidator.helpers.mod11And10(b)):!1},_dk:function(a){if(!/^DK[0-9]{8}$/.test(a))return!1;a=a.substr(2);for(var b=0,c=[2,7,6,5,4,3,2,1],d=0;8>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b%11===0},_ee:function(a){if(!/^EE[0-9]{9}$/.test(a))return!1;a=a.substr(2);for(var b=0,c=[3,7,1,3,7,1,3,7,1],d=0;9>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b%10===0},_es:function(a){if(!/^ES[0-9A-Z][0-9]{7}[0-9A-Z]$/.test(a))return!1;a=a.substr(2);var b=function(a){var b=parseInt(a.substr(0,8),10);return b="TRWAGMYFPDXBNJZSQVHLCKE"[b%23],b+""===a.substr(8,1)},c=function(a){var b=["XYZ".indexOf(a.charAt(0)),a.substr(1)].join("");return b=parseInt(b,10),b="TRWAGMYFPDXBNJZSQVHLCKE"[b%23],b+""===a.substr(8,1)},d=function(a){var b,c=a.charAt(0);if(-1!=="KLM".indexOf(c))return b=parseInt(a.substr(1,8),10),b="TRWAGMYFPDXBNJZSQVHLCKE"[b%23],b+""===a.substr(8,1);if(-1!=="ABCDEFGHJNPQRSUVW".indexOf(c)){for(var d=0,e=[2,1,2,1,2,1,2],f=0,g=0;7>g;g++)f=parseInt(a.charAt(g+1),10)*e[g],f>9&&(f=Math.floor(f/10)+f%10),d+=f;return d=10-d%10,d+""===a.substr(8,1)||"JABCDEFGHI"[d]===a.substr(8,1)}return!1},e=a.charAt(0);return/^[0-9]$/.test(e)?b(a):/^[XYZ]$/.test(e)?c(a):d(a)},_fi:function(a){if(!/^FI[0-9]{8}$/.test(a))return!1;a=a.substr(2);for(var b=0,c=[7,9,10,5,8,4,2,1],d=0;8>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b%11===0},_fr:function(b){if(!/^FR[0-9A-Z]{2}[0-9]{9}$/.test(b))return!1;if(b=b.substr(2),!a.fn.bootstrapValidator.helpers.luhn(b.substr(2)))return!1;if(/^[0-9]{2}$/.test(b.substr(0,2)))return b.substr(0,2)===parseInt(b.substr(2)+"12",10)%97+"";var c,d="0123456789ABCDEFGHJKLMNPQRSTUVWXYZ";return c=/^[0-9]{1}$/.test(b.charAt(0))?24*d.indexOf(b.charAt(0))+d.indexOf(b.charAt(1))-10:34*d.indexOf(b.charAt(0))+d.indexOf(b.charAt(1))-100,(parseInt(b.substr(2),10)+1+Math.floor(c/11))%11===c%11},_gb:function(a){if(!(/^GB[0-9]{9}$/.test(a)||/^GB[0-9]{12}$/.test(a)||/^GBGD[0-9]{3}$/.test(a)||/^GBHA[0-9]{3}$/.test(a)||/^GB(GD|HA)8888[0-9]{5}$/.test(a)))return!1;a=a.substr(2);var b=a.length;if(5===b){var c=a.substr(0,2),d=parseInt(a.substr(2),10);return"GD"===c&&500>d||"HA"===c&&d>=500}if(11===b&&("GD8888"===a.substr(0,6)||"HA8888"===a.substr(0,6)))return"GD"===a.substr(0,2)&&parseInt(a.substr(6,3),10)>=500||"HA"===a.substr(0,2)&&parseInt(a.substr(6,3),10)<500?!1:parseInt(a.substr(6,3),10)%97===parseInt(a.substr(9,2),10);if(9===b||12===b){for(var e=0,f=[8,7,6,5,4,3,2,10,1],g=0;9>g;g++)e+=parseInt(a.charAt(g),10)*f[g];return e%=97,parseInt(a.substr(0,3),10)>=100?0===e||42===e||55===e:0===e}return!0},_gr:function(a){if(!/^GR[0-9]{9}$/.test(a))return!1;a=a.substr(2),8===a.length&&(a="0"+a);for(var b=0,c=[256,128,64,32,16,8,4,2],d=0;8>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b=b%11%10,b+""===a.substr(8,1)},_el:function(a){return/^EL[0-9]{9}$/.test(a)?(a="GR"+a.substr(2),this._gr(a)):!1},_hu:function(a){if(!/^HU[0-9]{8}$/.test(a))return!1;a=a.substr(2);for(var b=0,c=[9,7,3,1,9,7,3,1],d=0;8>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b%10===0},_hr:function(b){return/^HR[0-9]{11}$/.test(b)?(b=b.substr(2),a.fn.bootstrapValidator.helpers.mod11And10(b)):!1},_ie:function(a){if(!/^IE[0-9]{1}[0-9A-Z\*\+]{1}[0-9]{5}[A-Z]{1,2}$/.test(a))return!1;a=a.substr(2);var b=function(a){for(;a.length<7;)a="0"+a;for(var b="WABCDEFGHIJKLMNOPQRSTUV",c=0,d=0;7>d;d++)c+=parseInt(a.charAt(d),10)*(8-d);return c+=9*b.indexOf(a.substr(7)),b[c%23]};return/^[0-9]+$/.test(a.substr(0,7))?a.charAt(7)===b(a.substr(0,7)+a.substr(8)+""):-1!=="ABCDEFGHIJKLMNOPQRSTUVWXYZ+*".indexOf(a.charAt(1))?a.charAt(7)===b(a.substr(2,5)+a.substr(0,1)+""):!0},_is:function(a){return/^IS\d{5,6}$/.test(a)},_it:function(b){if(!/^IT[0-9]{11}$/.test(b))return!1;if(b=b.substr(2),0===parseInt(b.substr(0,7),10))return!1;var c=parseInt(b.substr(7,3),10);return 1>c||c>201&&999!==c&&888!==c?!1:a.fn.bootstrapValidator.helpers.luhn(b)},_lt:function(a){if(!/^LT([0-9]{7}1[0-9]{1}|[0-9]{10}1[0-9]{1})$/.test(a))return!1;a=a.substr(2);var b,c=a.length,d=0;for(b=0;c-1>b;b++)d+=parseInt(a.charAt(b),10)*(1+b%9);var e=d%11;if(10===e)for(d=0,b=0;c-1>b;b++)d+=parseInt(a.charAt(b),10)*(1+(b+2)%9);return e=e%11%10,e+""===a.charAt(c-1)},_lu:function(a){return/^LU[0-9]{8}$/.test(a)?(a=a.substr(2),parseInt(a.substr(0,6),10)%89+""===a.substr(6,2)):!1},_lv:function(b){if(!/^LV[0-9]{11}$/.test(b))return!1;b=b.substr(2);var c,d=parseInt(b.charAt(0),10),e=0,f=[],g=b.length;if(d>3){for(e=0,f=[9,1,4,8,3,10,2,5,7,6,1],c=0;g>c;c++)e+=parseInt(b.charAt(c),10)*f[c];return e%=11,3===e}var h=parseInt(b.substr(0,2),10),i=parseInt(b.substr(2,2),10),j=parseInt(b.substr(4,2),10);if(j=j+1800+100*parseInt(b.charAt(6),10),!a.fn.bootstrapValidator.helpers.date(j,i,h))return!1;for(e=0,f=[10,5,8,4,2,1,6,3,7,9],c=0;g-1>c;c++)e+=parseInt(b.charAt(c),10)*f[c];return e=(e+1)%11%10,e+""===b.charAt(g-1)},_mt:function(a){if(!/^MT[0-9]{8}$/.test(a))return!1;a=a.substr(2);for(var b=0,c=[3,4,6,7,8,9,10,1],d=0;8>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b%37===0},_nl:function(a){if(!/^NL[0-9]{9}B[0-9]{2}$/.test(a))return!1;a=a.substr(2);for(var b=0,c=[9,8,7,6,5,4,3,2],d=0;8>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b%=11,b>9&&(b=0),b+""===a.substr(8,1)},_no:function(a){if(!/^NO[0-9]{9}$/.test(a))return!1;a=a.substr(2);for(var b=0,c=[3,2,7,6,5,4,3,2],d=0;8>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b=11-b%11,11===b&&(b=0),b+""===a.substr(8,1)},_pl:function(a){if(!/^PL[0-9]{10}$/.test(a))return!1;a=a.substr(2);for(var b=0,c=[6,5,7,2,3,4,5,6,7,-1],d=0;10>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b%11===0},_pt:function(a){if(!/^PT[0-9]{9}$/.test(a))return!1;a=a.substr(2);for(var b=0,c=[9,8,7,6,5,4,3,2],d=0;8>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b=11-b%11,b>9&&(b=0),b+""===a.substr(8,1)},_ro:function(a){if(!/^RO[1-9][0-9]{1,9}$/.test(a))return!1;a=a.substr(2);for(var b=a.length,c=[7,5,3,2,1,7,5,3,2].slice(10-b),d=0,e=0;b-1>e;e++)d+=parseInt(a.charAt(e),10)*c[e];return d=10*d%11%10,d+""===a.substr(b-1,1)},_ru:function(a){if(!/^RU([0-9]{9}|[0-9]{12})$/.test(a))return!1;a=a.substr(2);var b=0;if(10===a.length){var c=0,d=[2,4,10,3,5,9,4,6,8,0];for(b=0;10>b;b++)c+=parseInt(a.charAt(b),10)*d[b];return c%=11,c>9&&(c%=10),c+""===a.substr(9,1)}if(12===a.length){var e=0,f=[7,2,4,10,3,5,9,4,6,8,0],g=0,h=[3,7,2,4,10,3,5,9,4,6,8,0];for(b=0;11>b;b++)e+=parseInt(a.charAt(b),10)*f[b],g+=parseInt(a.charAt(b),10)*h[b];return e%=11,e>9&&(e%=10),g%=11,g>9&&(g%=10),e+""===a.substr(10,1)&&g+""===a.substr(11,1)}return!1},_rs:function(a){if(!/^RS[0-9]{9}$/.test(a))return!1;a=a.substr(2);for(var b=10,c=0,d=0;8>d;d++)c=(parseInt(a.charAt(d),10)+b)%10,0===c&&(c=10),b=2*c%11;return(b+parseInt(a.substr(8,1),10))%10===1},_se:function(b){return/^SE[0-9]{10}01$/.test(b)?(b=b.substr(2,10),a.fn.bootstrapValidator.helpers.luhn(b)):!1},_si:function(a){if(!/^SI[0-9]{8}$/.test(a))return!1;a=a.substr(2);for(var b=0,c=[8,7,6,5,4,3,2],d=0;7>d;d++)b+=parseInt(a.charAt(d),10)*c[d];return b=11-b%11,10===b&&(b=0),b+""===a.substr(7,1)},_sk:function(a){return/^SK[1-9][0-9][(2-4)|(6-9)][0-9]{7}$/.test(a)?parseInt(a.substr(2),10)%11===0:!1},_za:function(a){return/^ZA4\d{9}$/.test(a)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.vin=a.extend(a.fn.bootstrapValidator.i18n.vin||{},{"default":"Please enter a valid VIN number"}),a.fn.bootstrapValidator.validators.vin={validate:function(a,b){var c=b.val();if(""===c)return!0;if(!/^[a-hj-npr-z0-9]{8}[0-9xX][a-hj-npr-z0-9]{8}$/i.test(c))return!1;c=c.toUpperCase();for(var d={A:1,B:2,C:3,D:4,E:5,F:6,G:7,H:8,J:1,K:2,L:3,M:4,N:5,P:7,R:9,S:2,T:3,U:4,V:5,W:6,X:7,Y:8,Z:9,1:1,2:2,3:3,4:4,5:5,6:6,7:7,8:8,9:9,0:0},e=[8,7,6,5,4,3,2,10,0,9,8,7,6,5,4,3,2],f=0,g=c.length,h=0;g>h;h++)f+=d[c.charAt(h)+""]*e[h];var i=f%11;return 10===i&&(i="X"),i+""===c.charAt(8)}}}(window.jQuery),function(a){a.fn.bootstrapValidator.i18n.zipCode=a.extend(a.fn.bootstrapValidator.i18n.zipCode||{},{"default":"Please enter a valid zip code",countryNotSupported:"The country code %s is not supported",country:"Please enter a valid %s",countries:{BR:"Brazilian postal code",CA:"Canadian postal code",DK:"Danish postal code",GB:"United Kingdom postal code",IT:"Italian postal code",MA:"Moroccan postal code",NL:"Dutch postal code",SE:"Swiss postal code",SG:"Singapore postal code",US:"US zip code"}}),a.fn.bootstrapValidator.validators.zipCode={html5Attributes:{message:"message",country:"country"},COUNTRY_CODES:["BR","CA","DK","GB","IT","MA","NL","SE","SG","US"],validate:function(b,c,d){var e=c.val();if(""===e||!d.country)return!0;var f=d.country;if(("string"!=typeof f||-1===a.inArray(f,this.COUNTRY_CODES))&&(f=b.getDynamicOption(c,f)),!f||-1===a.inArray(f.toUpperCase(),this.COUNTRY_CODES))return{valid:!1,message:a.fn.bootstrapValidator.helpers.format(a.fn.bootstrapValidator.i18n.zipCode.countryNotSupported,f)};var g=!1;switch(f=f.toUpperCase()){case"BR":g=/^(\d{2})([\.]?)(\d{3})([\-]?)(\d{3})$/.test(e);break;case"CA":g=/^(?:A|B|C|E|G|H|J|K|L|M|N|P|R|S|T|V|X|Y){1}[0-9]{1}(?:A|B|C|E|G|H|J|K|L|M|N|P|R|S|T|V|W|X|Y|Z){1}\s?[0-9]{1}(?:A|B|C|E|G|H|J|K|L|M|N|P|R|S|T|V|W|X|Y|Z){1}[0-9]{1}$/i.test(e);break;case"DK":g=/^(DK(-|\s)?)?\d{4}$/i.test(e);break;case"GB":g=this._gb(e);break;case"IT":g=/^(I-|IT-)?\d{5}$/i.test(e);break;case"MA":g=/^[1-9][0-9]{4}$/i.test(e);break;case"NL":g=/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i.test(e);break;case"SE":g=/^(S-)?\d{3}\s?\d{2}$/i.test(e);break;case"SG":g=/^([0][1-9]|[1-6][0-9]|[7]([0-3]|[5-9])|[8][0-2])(\d{4})$/i.test(e);break;case"US":default:g=/^\d{4,5}([\-]?\d{4})?$/.test(e)}return{valid:g,message:a.fn.bootstrapValidator.helpers.format(d.message||a.fn.bootstrapValidator.i18n.zipCode.country,a.fn.bootstrapValidator.i18n.zipCode.countries[f])}},_gb:function(a){for(var b="[ABCDEFGHIJKLMNOPRSTUWYZ]",c="[ABCDEFGHKLMNOPQRSTUVWXY]",d="[ABCDEFGHJKPMNRSTUVWXY]",e="[ABEHMNPRVWXY]",f="[ABDEFGHJLNPQRSTUWXYZ]",g=[new RegExp("^("+b+"{1}"+c+"?[0-9]{1,2})(\\s*)([0-9]{1}"+f+"{2})$","i"),new RegExp("^("+b+"{1}[0-9]{1}"+d+"{1})(\\s*)([0-9]{1}"+f+"{2})$","i"),new RegExp("^("+b+"{1}"+c+"{1}?[0-9]{1}"+e+"{1})(\\s*)([0-9]{1}"+f+"{2})$","i"),new RegExp("^(BF1)(\\s*)([0-6]{1}[ABDEFGHJLNPQRST]{1}[ABDEFGHJLNPQRSTUWZYZ]{1})$","i"),/^(GIR)(\s*)(0AA)$/i,/^(BFPO)(\s*)([0-9]{1,4})$/i,/^(BFPO)(\s*)(c\/o\s*[0-9]{1,3})$/i,/^([A-Z]{4})(\s*)(1ZZ)$/i,/^(AI-2640)$/i],h=0;h<g.length;h++)if(g[h].test(a))return!0;return!1}}}(window.jQuery);
angular.module('mbplus')
.controller('billBreakupCtrl', ['$rootScope', '$scope','UtilitiesService', function (rootScope, scope,UtilitiesService) {
        scope.availableBills = UtilitiesService.availableBills;
    scope.openPopup= false;
    scope.dischargePatient = function () {

        angular.element("#dischargeModalPopup").appendTo('body');
        angular.element("#dischargeModalPopup").modal('show');
        scope.openPopup= true;
        scope.form = {}
    };
        scope.availableBills = [];
    scope.dynamicFields = {
        name: '',
        price: ''
    }

    scope.removeCategories = function (data) {
        angular.forEach(scope.availableBills, function (key, index) {
            if (key.hospitalBillDesc === data.hospitalBillDesc) {
                scope.availableBills.splice(index, 1);
            }
        });
    };

    scope.addMoreCategories = function (flag, data) {
        scope.isDuplicate = false;
        if (flag) {
            var value = _.filter(scope.availableBills, function (item) { return item.hospitalBillDesc.toLowerCase() === data.name.toLowerCase() }).length;
            if (value === 0) {
                scope.availableBills.push({ PROVIDER_BILL_ITEM_NAME: '', BILL_ITEM_DETAIL_REF: '', DETAIL_BILL_ITEM_CLAIM_ID: '', DETAIL_BILL_ITEM_PREAUTH_NO: '', CLAIMED_AMOUNT: data.price, CMS_CHARGE_TYPE_ID: 4, CMS_CHARGE_TYPE_DESC: 'Miscellaneous Charges', CMS_SUBCHARGE_TYPE_ID: 53, CMS_SUBCHARGE_TYPE_DESC: 'Other Miscellaneous Charges', hospitaL_CHARGE_HEAD: data.name, hospitalBillDesc: data.name, isReadOnly: false });
                scope.dynamicFields.name = '';
                scope.dynamicFields.price = '';
            } else {
                scope.isDuplicate = true;
            }
        } else {
            scope.isNewCategories = true;
        }
    };

}]);



// angular.module('mbplus')
// .controller('angularTabsCtrl', ['$rootScope', '$scope', 'UserService', '$location', '$log', 'UtilitiesService', '$http', '$timeout', '$filter',
//     'FileUploadService', 'ClaimActionService', 'NewAdmissionFormService', 'filterFilter', 'blockUI', 'PlusUtilitiesService',
//     '$state', function (rootScope, scope, UserService, $location, $log, UtilitiesService, $http, $timeout, filter, FileUploadService, ClaimActionService, NewAdmissionFormService, filterFilter, blockUI, PlusUtilitiesService, state) {
//         scope.ctrlName = "tabCtrl";
//         scope.blockUIState = blockUI.state();
//         scope.tab1show = true;
//         scope.showAllAppointments = true;
//         scope.form = {};
//         scope.compareDate = UtilitiesService.compareDate;
//         scope.formatTime = UtilitiesService.formatTime;
//         scope.getDateObj = UtilitiesService.getDateObj;
//         scope.getDDMMYYYY = UtilitiesService.getDDMMYYYY;
//         scope.formatCurrency = UtilitiesService.formatCurrency;
//         scope.downloadUrl = UtilitiesService.getDMSHostUrl();
//         scope.DMSUrl = UtilitiesService.getDMSHostUrl();
//         scope.tabsData = [];

//         scope.user = UserService.getUserObj();
//         if (!scope.user) {
//             UserService.destroyUserObj();
//             $location.path('/');
//         }

//         scope.open2 = function () {
//             scope.popup2.opened = true;
//         };
//         scope.open1 = function () {
//             scope.popup1.opened = true;
//         };
//         scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
//         scope.format = scope.formats[0];
//         scope.altInputFormats = ['M!/d!/yyyy'];

//         scope.popup2 = {
//             opened: false
//         };
//         scope.popup1 = {
//             opened: false
//         };
//         scope.isCmsUser = false;
//         scope.currentStatusId = "";
//         scope.financeLogin = false;
//         scope.managerLogin = false;
//         scope.isInsurerAction = false;
//         scope.medibizProviderId = 158749;
//         scope.pharmaProviderId = 72326;

//         if (scope.user.rolesFeatures.roles.length == 1) {
//             angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
//                 if (v.roleId == 9205) {
//                     scope.financeLogin = true;
//                 } else if (v.roleId == 9204) {
//                     scope.managerLogin = true;
//                     scope.financeLogin = false;
//                     return;
//                 } else if (v.roleId == 9207 || v.roleId == 9211 || v.roleId == 9214 || v.roleId == 9217) {  //insurer admin -- insurer-agent -- insurer branch  -- insurer-ma-report
//                     scope.isInsurerAction = true;
//                 } else if (v.roleId === 9216) {
//                     scope.isCmsUser = true;
//                 }
//             })
//         }
//         scope.isInsurer = true;
//         angular.forEach(scope.user && scope.user.rolesFeatures.roles, function (v, i) {
//             if (v.roleId == 9207 || v.roleId == 9211 || v.roleId == 9214) {
//                 scope.isInsurer = false;
//             }
//         });
//         angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {

//         });
//         angular.forEach(scope.user && scope.user.rolesFeatures.roles, function (v, i) {
//             if (v.roleId == 9204) {
//                 scope.managerLogin = true;
//             }
//         });
//         scope.tabs = [{ title: scope.tabname, content: 0 }],
//         selected = null,
//         previous = null;
//         scope.selectedIndex = 0;
//         scope.selectedAppointmentsIndex = 0;
//         scope.user = UserService.getUserObj();
//         scope.user = { role: '' };
//         if (UserService.getUserObj()) {
//             scope.userRoles = UserService.getUserObj().rolesFeatures.roles;
//             if (scope.userRoles.length > 1) {
//                 angular.forEach(scope.userRoles, function (value, key) {
//                     if (value.roleName === 'cms') {
//                         scope.user.role = 'CMS';
//                     }
//                 });
//             } else {
//                 scope.user.role = scope.userRoles[0].roleName === 'cms' ? 'CMS' : '';
//             }
//         }
//         if (UserService.getUserObj()) {
//             scope.username = UserService.toTitleCase(UserService.getUserObj().userName ? UserService.getUserObj().userName : UserService.getUserObj().firstName);
//         }
//         scope.totalItems = scope.preauthfiltered == undefined ? 50 : scope.preauthfiltered.length;
//         scope.pagination = {
//             currentPage: 1
//         }
//         scope.currentPage = 1;
//         scope.pagination.currentPage = 1;
//         scope.itemsPerPage = 10;
//         scope.maxSize = 5;
//         scope.file = {};
//         scope.search = 'All';
//         scope.userRole = UserService.displayThis;
//         scope.getToUpperCase = UtilitiesService.getToUpperCase;
//         scope.getToLowerCase = UtilitiesService.getToLowerCase;
//         scope.getAge = UtilitiesService.getAge;
//         scope.contracts = PlusUtilitiesService.getContracts();

//         scope.$watch('preauthfiltered', function (current, old) {
//             if (current != old) {

//                 scope.preauthfilteredStatusFiltered1 = _.uniq(scope.preauthfiltered);
//                 scope.totalItems = scope.preauthfilteredStatusFiltered1.length;
//             }
//         });

//         //Call controller function
//         scope.pageChanged = function (value, type) {
//             if (type === true) {

//                 scope.someCtrlFn({ arg: value });
//             } else if (type === false) {
//                 scope.currentPage = value;
//                 scope.pagination.currentPage = 1;
//             }
//         };


//         scope.changeIndex = function (index) {
//             scope.selectedIndex = index;
//         };
//         scope.$watch('selectedIndex', function (current, old) {
//             if (current !== old) {
//                 if (current === 0) {
//                     scope.tab1show = true;
//                 }
//                 else {
//                     scope.tab1show = false;
//                     //scope.addTab(scope.tabs[current].content, '', scope.tabs[current].title);
//                 }
//                 previous = selected;
//                 selected = scope.tabs[current];
//             } else {
//             }
//         });
//         scope.$watch('selectedAppointmentsIndex', function (current, old) {
//             if (current != old) {
//                 if (current == 0) {
//                     scope.tab1show = true;
//                 }
//                 else {
//                     scope.tab1show = false;
//                 }
//                 previous = selected;
//                 selected = scope.tabs[current];
//             } else {
//             }
//         });
//         scope.addTab = function (claimNo, view, patientName, item) {
//             scope.claimNoData = item;
//             UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tpa/letterInfo/' + claimNo + '', '', 'GET').then(function (response) {
//                 if (response.data.isSuccess) {
//                     scope.claimSearhByClaimIdResults = response.data.tpaInfo;
//                     scope.tabsData.push(response.data.tpaInfo);
//                     scope.openTab(patientName, view, false);
//                 } else {
//                     UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
//                 }
//             }, function (error) {
//                 UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
//             });
//         };


//         scope.openTab = function (title, view, showTab) {
//             scope.tab1show = showTab;
//             view = view || title + " Content View";
//             scope.tabs.push({ title: title, content: view });
//             scope.tabs[scope.tabs.length - 1].active = true;
//             scope.selectedIndex = scope.tabs.length - 1;
//         };
//         scope.removeTab = function (tab) {
//             if (tab > 0) {
//                 scope.tabs.splice(tab, 1);
//                 scope.tabsData.splice(tab - 1, 1);
//                 scope.selectedIndex = scope.selectedIndex > 0 ? scope.selectedIndex - 1 : scope.selectedIndex;
//                 scope.tabs[scope.selectedIndex].active = true;
//             }
//         };

//         scope.getPatientDetails = function () {
//             return details = {
//                 name: scope.name,
//                 requestId: scope.id,
//                 indexNo: scope.tabs.length - 1
//             }
//         }
//         scope.res = {};
//         scope.resId = "";
//         scope.showPostToPharma = false;


//     }]);



angular.module('mbplus')
.controller('tpaNewAdmissionFormNewCtrl', ['$scope', '$location', '$state', '$timeout', 'UserService', 'UtilitiesService', 'filterFilter', '$uibModal', 'FastrackService', 'GovernmentService', 'FileUploadService', 'NewAdmissionFormService', '$analytics', '$q', 'blockUI', function (scope, $location, state, timeout, UserService, UtilitiesService, filterFilter, $uibModal, FastrackService, GovernmentService, FileUploadService, NewAdmissionFormService, $analytics, $q, blockUI) {
    $analytics.pageTrack('/newAdmission/');
    scope.ctrlName = 'newAdmissionFormCtrl';
    scope.blockUIState = blockUI.state();
    if (!UserService.isActive()) {
        UserService.destroyUserObj();
        return false;
    }
    scope.checkPhoneNumber = '^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$';
    scope.govType = 'B';
    if (UserService.getHospitalObj().entityRealtion.length > 0) {
        scope.isRsby = UserService.getHospitalObj().entityRealtion[0].contractname === 'MSBYHospitals_Mediassist' ? true : false;
    } else {
        scope.isRsby = false;
    }
    scope.numberValidation = '((?:1){8}|(?:2){8}|(?:3){8}|(?:4){8}|(?:5){8}|(?:6){8}|(?:7){8}|(?:8){8}|(?:9){8}|(?:0){8})';
    scope.mobileValidation = function (number) {
        if (number) {
        } else {
        }
    };
    scope.isShowMaid = true;
    scope.isEBill = UtilitiesService.checkEBillHospital(UserService.getHospitalObj().hospId);
    scope.tpaFormReset = function () {
        scope.additionMailsCollection = [];
        scope.tpaForm = {
            name: { id: 0, value: '--Select TPA Name--' },
            mailServerAddress: '',
            mailServerPort: '',
            useSSl: '',
            hospMailId: '',
            hospPassword: '',
            tpaMailId: '',
            outGoingServerPort: '',
            tpaHospId: '',
            outGoingServerAddress: '',
            tpaId: 0,
            tpamailsIds: '',
            additionMails: '',
            additionMailsCollection:[]
        }
    };
    scope.tpaFormReset();
    scope.additionMailsCollection = [];
    scope.addTpaMails = function (value) {
        if (value) {
            scope.tpaForm.tpamailsIds = '';
            scope.additionMailsCollection.push(value);
            scope.tpaForm.additionMails=  scope.additionMailsCollection.join(',');
        }
    };

    scope.clearAll = function () {
        scope.additionMailsCollection = [];
        scope.tpaForm.additionMails = '';
    };

    scope.tpaForm.name = { id: 0, value: '--Select TPA Name--' };
    scope.resetFormData = function () {
        scope.form = {
            roomtype: '',
            fileNames: [],
            tpaId: 0,
            fileUploadFolderPath: [],
            doa: '',
            dod: '',
            packageAmount: '',
            clmamount: 0,
            procedure1: '',
            mPackageTotalAmount: '',
            mPackageFullName: '',
            packageName: '',
            cappedAmount: '',
            packageUniqueId: '',
            fullname: '',
            memberId: '',
            URNNum: '',
            adFolderPath: [],
            employer: '',
            empid: '',
            maid: '',
            policyno: '',
            age: '',
            gender: '',
            preauthSuccess: false,
            preauthError: false,
            insurername: '',
            isgovtscheme: '',
            mobile: '',
            diagnosis: '',
            procedure: '',
            admissiontype: '',
            docname: '',
            ipnumber: '',
            IsGovtClaim: true,
            memberDist: '',
            reasonOnline: '',
            memberGender: '',
            memberAge: '',
            uidno: '',
            tpaName: '',
            uniqueId: '',
            hospTPAId: 0
        }
    };
    scope.resetFormData();
    scope.fileUploaName = [];
    scope.getDateObj = UtilitiesService.getDateObj;
    scope.isProcessing = false;
    scope.doctorDetails = [];
    scope.roomsDetails = [];
    scope.isSearchButton = true;
    scope.isSearchProcedure = true;
    scope.userObject = UserService.getUserObj();
    scope.isProcedure = false;
    scope.isTPA = false;
    scope.isTPAAndProcedure = false;

    scope.changeTpa = function (obj) {
        scope.resetFormData();
        scope.isShowMaid = true;
        if (obj) {
            if (obj === 'Medi Assist Insurance TPA Pvt. Ltd.') {
                scope.isSearchProcedure = true;
                scope.isShowMaid = true;
                scope.isSearchButton = true;
                var value = _.findWhere(scope.tpaList, { tpaName: obj });
                scope.form.tpaId = value.tpaId ? value.tpaId : 0;
                scope.form.hospTPAId = value.hospTPAId ? value.hospTPAId : 0;
                scope.form.tpaName = value.tpaName ? value.tpaName : '';
                scope.reasonOnlineField = 'procedure';
            } else {
                scope.isShowMaid = false;
                scope.isSearchButton = obj ? false : true;
                scope.isSearchProcedure = false;
                scope.reasonOnlineField = 'others';
            }
            if (!scope.isSearchButton) {
                var value = _.findWhere(scope.tpaList, { tpaName: obj });
                if (value) {
                    scope.form.tpaId = value.tpaId ? value.tpaId : 0;
                    scope.form.hospTPAId = value.hospTPAId ? value.hospTPAId : 0;
                    scope.form.tpaName = value.tpaName ? value.tpaName : '';
                }
            }
        } else {
            scope.isSearchButton = true;
            scope.form.hospTPAId = 0;
            scope.form.tpaId = 0;
        }
    };

    
    scope.getInsurersCompanyList = function () {
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/insurers', '', 'GET').then(function (response) {
            if (response.data) {
                scope.insurerList = response.data.insurerList;
                //scope.insurerList.push({ id: 0, value: '--Select TPA Name--' });
                scope.insurerList = _.sortBy(scope.insurerList, function (num) { return num.id > 0; });
            }
        }, function (error) {
            scope.insurerList = [];
        });
    };
    scope.getInsurersCompanyList();

    scope.getTPAList = function () {
        scope.TPAListData = [];
        var ajaxData = { LookUpType: 'TPA' };
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/master/MasterLookup', ajaxData, 'POST').then(function (response) {
            if (response.data) {
                scope.TPAListData = response.data;
                scope.TPAListData.push({ id: 0, value: '--Select TPA Name--' });
                scope.TPAListData = _.sortBy(scope.TPAListData, function (num) { return num.id > 0; });
                scope.tpaForm.name = { id: 0, value: '--Select TPA Name--' };
            }
        }, function (error) {
            scope.TPAListData = [];
        });
    };
    scope.getTPAList();

    scope.getRoomsDetails = function () {
        var ajaxData = { hospId: UserService.getHospitalObj().hospId, getDoctors: false, getRooms: true, getOpPackages: false, getContracts: false };
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/hospProfileDetails', ajaxData, 'POST').then(function (response) {
            if (response.data.isSuccess) {
                scope.roomsDetails = response.data.hospRoomDetails;
            }
        }, function (error) {
            scope.roomsDetails = [];
        });
    };
    scope.getDoctorDetails = function () {
        var ajaxData = { hospId: UserService.getHospitalObj().hospId, getDoctors: true, getRooms: true, getOpPackages: false, getContracts: false };
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/hospProfileDetails', ajaxData, 'POST').then(function (response) {
            if (response.data.isSuccess) {
                scope.doctorDetails = response.data.hospDoctorDetails;
                scope.getRoomsDetails();
            }
        }, function (error) {
            scope.doctorDetails = [];
            scope.getRoomsDetails();
        });
    };

    scope.tpaList = [];
    scope.getTpaList = function () {
        if (UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId) {
            // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/' + UserService.getHospitalObj().cmsHospId + '/tpas', '', 'GET').then(function (response) {
            //     if (response.data.isSucces) {
            //         scope.tpaList = response.data.tpaList;
            //     }
            // }, function (error) {
            //     scope.tpaList = [];
            // });
        }
    };

    scope.getTpaList();
    scope.getDoctorDetails();
    scope.govtChecked = function () {
        scope.form.packageAmount = '';
    };
    scope.selectedMappedpackages = [];

    scope.onSelect = function ($item, $model, $label) {
        if ($item) {
            scope.selectedMappedpackages.push($item);
            scope.selectedMappedpackages = _.uniq(scope.selectedMappedpackages);
            angular.forEach(scope.selectedMappedpackages, function (data, index) {
                scope.selectedMappedpackages[index].general_Ward1 = data.general_Ward1 === true ? true : false;
                scope.selectedMappedpackages[index].private_Ward1 = data.private_Ward1 === true ? true : false;
                scope.selectedMappedpackages[index].semi_Private_Ward1 = data.semi_Private_Ward1 === true ? true : false;
                scope.selectedMappedpackages[index].uniqueIds = index + 1;
            })
        }
    };

    scope.packageCalcAmount = 0;
    scope.calculatePrice = function () {
        scope.packageCalcAmount = 0;
        angular.forEach(scope.selectedMappedpackages, function (data, index) {
            if (data.general_Ward1 || data.private_Ward1 || data.semi_Private_Ward1) {
                var price = data.general_Ward1 === true ? 'general_Ward' : data.private_Ward1 === true ? 'private_Ward' : data.semi_Private_Ward1 === true ? 'semi_Private_Ward' : ''
                scope.packageCalcAmount = scope.packageCalcAmount + scope.selectedMappedpackages[index][price];
            }
        });
        scope.form.clmamount = scope.packageCalcAmount;
    };
    scope.reasonOnlineField = 'procedure';
    scope.changePackageField = function (value) {
        scope.form.procedure1 = '';
        scope.form.mPackageTotalAmount = '';
        scope.form.mPackageFullName = '';
        scope.reasonOnlineField = value;
    };

    scope.AddProcedure = function (name, price) {
        if (name && price) {
            var obj = {
                deluxe_Other: 0,
                general_Ward: parseInt(price),
                general_Ward1: true,
                packageId: 0,
                package_Name: name,
            }
            scope.selectedMappedpackages.push(obj);
            scope.calculatePrice()
            scope.onSelect(obj);
            scope.form.mPackageTotalAmount = '';
            scope.form.mPackageFullName = '';
        } else {
            UtilitiesService.showAlertMessage('Please enter treatment details and amount .');
        }
    };

    scope.checkService = function (value, price) {
        if (value) {
            if (price === 'general_Ward') {
                angular.forEach(scope.selectedMappedpackages, function (data, index) {
                    if (value.packageId === data.packageId) {
                        scope.selectedMappedpackages[index].general_Ward1 = !scope.selectedMappedpackages[index].general_Ward1;
                        scope.selectedMappedpackages[index].private_Ward1 = false;
                        scope.selectedMappedpackages[index].semi_Private_Ward1 = false;
                    }
                })
            } else if (price === 'semi_Private_Ward') {
                angular.forEach(scope.selectedMappedpackages, function (data, index) {
                    if (value.packageId === data.packageId) {
                        scope.selectedMappedpackages[index].general_Ward1 = false;
                        scope.selectedMappedpackages[index].private_Ward1 = false;
                        scope.selectedMappedpackages[index].semi_Private_Ward1 = !scope.selectedMappedpackages[index].semi_Private_Ward1;
                    }
                })
            } else if (price === 'private_Ward') {
                angular.forEach(scope.selectedMappedpackages, function (data, index) {
                    if (value.packageId === data.packageId) {
                        scope.selectedMappedpackages[index].general_Ward1 = false;
                        scope.selectedMappedpackages[index].private_Ward1 = !scope.selectedMappedpackages[index].private_Ward1;
                        scope.selectedMappedpackages[index].semi_Private_Ward1 = false;
                    }
                })
            }
        }
        scope.calculatePrice();
    };


    scope.changeGovtPolicyType = function (type) {
        scope.form.packageAmount = '';
        scope.form.mPackageAmount = '';
        scope.form.packageName = '';
        scope.form.packageUniqueId = '';
        scope.form.cappedAmount = '';
        scope.text = '';
        if (type) {
            if (type === 'Basic') {
                var obje = [];
                angular.forEach(scope.govtPackageListDummy, function (value, key) {
                    if (type === value.type) {
                        obje.push(value);
                    }
                });
                scope.govtPackageList = obje;
            } else if (type === 'Critical') {
                var obje = [];
                angular.forEach(scope.govtPackageListDummy, function (value, key) {
                    if (type === value.type) {
                        obje.push(value);
                    }
                });
                scope.govtPackageList = obje;
            }
        }
    };

    scope.addTpa = function (type) {
        angular.element("#addTPA").modal('show');
    };
    scope.isSuccess = false;
    scope.isError = false;
    scope.resetAlertMessage = function () {
        timeout(function () {
            scope.$apply(function () {
                scope.isSuccess = false;
                scope.isError = false;
            });
        }, 6000)
    };

    scope.tpaErrorMsg = '';
    scope.saveTpaDetails = function (tpaForm) {
        if (UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId && tpaForm.name.id !== 0) {
            var data = {
                hospId: UserService.getHospitalObj().cmsHospId,
                tpaName: tpaForm.name.value,
                tpaId: tpaForm.name.id,
                mailServerAddress: tpaForm.mailServerAddress,
                mailServerPort: tpaForm.mailServerPort,
                useSSl: true,
                hospMailId: tpaForm.hospMailId,
                hospPassword: tpaForm.hospPassword,
                tpaMailId: tpaForm.tpaMailId,
                outGoingServerPort: tpaForm.outGoingServerPort,
                tpaHospId: tpaForm.tpaHospId,
                outGoingServerAddress: tpaForm.outGoingServerAddress,
                tpaMailIdCSV: scope.tpaForm.additionMails
            }
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tpa', data, 'POST', true).then(function (response) {
                if (response.data.isSuccess) {
                    scope.tpaFormReset();
                    scope.getTpaList();
                    scope.isSuccess = true;
                    scope.isSuccessMsg = 'TPA has been Added successfully!.';
                    scope.resetAlertMessage();
                } else {
                    scope.isError = true;
                    scope.tpaErrorMsg = 'oops! something went wrong, please try again later.';
                    scope.resetAlertMessage();
                }
            }, function (error) {
                scope.isError = true;
                scope.tpaErrorMsg = 'oops! something went wrong, please try again later.';
                scope.resetAlertMessage();
            });
        } else {
            scope.isError = true;
            scope.tpaErrorMsg = 'Please select TPA name.';
            scope.resetAlertMessage();
        }
    };

    scope.fastrackPreauthGovSeaarch = function (type) {
        angular.element("#newMSBYSearch").modal('show');
        scope.fastrack = {};
        scope.fastrack.displaySubmit = true;
        switch (type) {
            case 'gov':
                scope.fastrack.title = 'Gov Search';
                scope.aarogyachecked = false;
                scope.govSearch = true;
                scope.isGov = true;
                scope.govtBenefList = [];
                scope.epic = '';
                scope.urn = '';
                scope.fastrack.showCorpName = false;
                scope.fastrack.employerSearchTitle = 'Employee ID';
                break;
        }
    };
    scope.fastrackPreauth = function (type) {
        angular.element("#newPreauthModal").modal("show");
        scope.fastrack = {};
        scope.fastrack.displaySubmit = true;
        switch (type) {
            case 'aarogya':
                scope.fastrack.title = 'Aarogya Scheme';
                scope.aarogyachecked = true;
                scope.govSearch = false;
                scope.isGov = false;
                scope.fastrack.showCorpName = false;
                scope.fastrack.employerSearchTitle = 'Family Number';
                break;
            case 'generic':
                scope.fastrack.title = 'Member Search';
                scope.aarogyachecked = false;
                scope.govSearch = false;
                scope.isGov = false;
                scope.fastrack.showCorpName = true;
                scope.fastrack.employerSearchTitle = 'Employee ID';
                break;
            case 'gov':
                scope.fastrack.title = 'Gov Search';
                scope.aarogyachecked = false;
                scope.govSearch = true;
                scope.isGov = true;
                scope.govtBenefList = [];
                scope.epic = '';
                scope.urn = '';
                scope.fastrack.showCorpName = false;
                scope.fastrack.employerSearchTitle = 'Employee ID';
                break;
        }
        if (scope.aarogyachecked) {
            scope.fastrack.corporateName = 'Manipal';
        }
    };
    scope.searchGov = function (type) {
        if (type === 'URN') {
            scope.isURN = true;
            scope.isEpic = false;
            scope.epic = '';
            scope.govtBenefList = [];
        } else if (type === 'Epic') {
            scope.isURN = false;
            scope.isEpic = true;
            scope.urn = '';
            scope.govtBenefList = [];
        } else {
            scope.isURN = false;
            scope.epic = '';
            scope.urn = '';
            scope.isEpic = false;
        }
    };
    scope.getDetailsWithGov = function (id, type) {
        var data = {
            URN: '',
            EpicNo: ''
        }
        data.URN = type === 'urn' ? id : '';
        data.EpicNo = type === 'epic' ? id : '';
        if (data.URN || data.EpicNo) {
            FastrackService.getDetailsWithGov(data).
                then(function (response) {
                    if (response.data.isSuccess) {
                        scope.isSearch = false;
                        scope.fastrack.error = false;
                        scope.govtBenefList = response.data.govtBenefList;
                    }
                    else {
                        scope.fastrack.error = true;
                        scope.fastrack.errorMessage = response.data.errorMessage;
                    }
                },
                   function (response) {
                       scope.fastrack.error = true;
                       scope.fastrack.errorMessage = 'No data found';
                   });
        } else {

        }
    };
    scope.getDetailsWithMaid = function (maid, benefName) {
        if (maid && benefName) {
            var data = { hospId: UserService.getHospitalObj().hospId, maid: maid, beneficiaryName: benefName }
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails.json', data, 'POST').
                then(function (response) {
                    if (response.data.isSuccess) {
                        scope.fastrack.displaySubmit = false;
                        scope.fastrack.error = false;
                        scope.fastrack.name = response.data.benefs.name;
                        scope.fastrack.relations = response.data.relations;
                        scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
                    }
                    else {
                        scope.fastrack.error = true;
                        scope.fastrack.errorMessage = response.data.errorMessage;
                    }
                }, function (error) {
                    scope.fastrack.error = true;
                    scope.fastrack.errorMessage = 'No data found';
                });
        }
    };
    scope.getDetailsWithEmpId = function (empid, corpname, benefname) {
        if (empid && corpname && benefname && UserService.getHospitalObj()) {
            var data = { hospId: UserService.getHospitalObj().hospId, employeeId: empid, corporateName: corpname, BeneficiaryName: benefname }
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails.json', data, 'POST').
                then(function (response) {
                    if (response.data.isSuccess) {
                        scope.fastrack.displaySubmit = false;
                        scope.fastrack.error = false;
                        scope.fastrack.name = response.data.benefs.benefName;
                        scope.fastrack.relations = response.data.relations;
                        scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
                    }
                    else {
                        scope.fastrack.error = true;
                        scope.fastrack.errorMessage = response.data.errorMessage;
                    }
                }, function (error) {
                    scope.fastrack.error = true;
                    scope.fastrack.errorMessage = 'No data found';
                });
        } else {

        }
    };
    scope.getDetailsWithPolicy = function (policyno, benefname) {

        if (policyno && benefname) {
            var data = {
                hospId: UserService.getHospitalObj().hospId,
                PolicyNo: policyno,
                BeneficiaryName: benefname
            }
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getEcardWithPolicyNo.json', data, 'POST').
                then(function (response) {
                    if (response.data.isSuccess) {
                        scope.fastrack.displaySubmit = false;
                        scope.fastrack.error = false;
                        scope.fastrack.name = response.data.benefs.benefName;
                        scope.fastrack.relations = response.data.relations;
                        scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
                    }
                    else {
                        scope.fastrack.error = true;
                        scope.fastrack.errorMessage = response.data.errorMessage;
                    }
                }, function (error) {
                    scope.fastrack.error = true;
                    scope.fastrack.errorMessage = 'No data found';
                });
        }
    };
    scope.fastrackPopulateNewAdmissionGov = function (data) {
        scope.form.fullname = data.memberName;
        scope.form.memberId = data.memberID;
        scope.form.URNNum = data.urn;
        scope.removeModal();
    };

    scope.removeData = [];
    scope.removePackageFromList = function (item) {
        if (item) {
            angular.forEach(scope.selectedMappedpackages, function (data, index) {
                if (item.uniqueIds === data.uniqueIds) {
                    scope.selectedMappedpackages.splice(index, 1);
                }
            })
            scope.removeData = item;
            //scope.$broadcast('removeData', item);
            //scope.calculatePrice();
        }
    };

    scope.ctrlFn = function (nextpage) {
        scope.selectedMappedpackages = [];
        scope.selectedMappedpackages = nextpage;
        scope.calculatePrice();
    };
    scope.isECashLess = false;
    scope.eCashLessMessage = '';
    scope.newPackageListData = [];
    scope.getMappedpackages = function (details) {
        scope.mappedpackages = [];
        scope.selectedMappedpackages = [];
        scope.isPriceOne = false;
        scope.isPriceTow = false;
        scope.isPriceThree = false;
        if (UserService.getHospitalObj()) {
            var data = {
                hospitalId: UserService.getHospitalObj().cmsHospId,
                insurerShortName: details
                //--details
                //'NIA'
            }
            scope.newPackageListData = [];
            // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/mappedpackages', data, 'POST', UserService.getAccessToken()).then(function (response) {
            //     if (response.data.isSuccess) {
            //         scope.mappedpackages = response.data.mappedpackages;
            //         angular.forEach(scope.mappedpackages, function (data, index) {
            //             var testObje = [];
            //             angular.forEach(data.distinctPrices, function (data1, index1) {
            //                 testObje.push({
            //                     isSelected: false,
            //                     price: data1,
            //                     packageId: scope.mappedpackages[index].packageId
            //                 })
            //             });
            //             scope.newPackageListData.push(testObje);
            //             scope.mappedpackages[index].newPriceObj = testObje;
            //         });
            //         angular.forEach(scope.mappedpackages, function (data, index) {
            //             scope.mappedpackages[index].general_Ward1 = false;
            //             scope.mappedpackages[index].private_Ward1 = false;
            //             scope.mappedpackages[index].semi_Private_Ward1 = false;
            //         })
            //     }
            //     else {
            //         scope.mappedpackages = [];
            //     }
            // });
        }
    };

    scope.getPackagesListForInsurer = function (data) {
        var selectedShoertName = '';
        scope.mappedpackages = [];
        if (data) {
            selectedShoertName = _.findWhere(scope.insurerList, { insurerFullName: data });
            scope.getMappedpackages(selectedShoertName.insurerShortName);
        }
    };

    //scope.getMappedpackages('NIA');
    scope.fastrackPopulateNewAdmission = function (maid, relationid, name, eCashLess) {
        if (eCashLess.eCashlessReqId === 0) {
            scope.insurerFullName = eCashLess.insurerFullName;
            scope.form.insurername = scope.insurerFullName;
            scope.insurerShortName = eCashLess.insurerShortName;
            FastrackService.fastrackPopulateNewAdmission(maid, relationid, name).
                then(function (response) {
                    if (response.data.isSuccess) {
                        scope.getMappedpackages(scope.insurerShortName);
                        scope.$parent.tempData = response.data.benefs;
                        scope.resetFormData();
                        scope.fileUploaName = [];
                        scope.form.fileNames = [];
                        scope.form.fileUploadFolderPath = [];
                        scope.form.fullname = response.data.benefs.benefName;   //generic
                        scope.form.roomtype = '';
                        scope.form.employer = response.data.benefs.benefPolHldrName;
                        scope.form.empid = response.data.benefs.priBenefEmpCode;
                        scope.form.maid = response.data.benefs.benefMediAssistID;
                        scope.form.policyno = scope.fastrack.PolicyNo;
                        scope.form.age = response.data.benefs.benefAge;
                        scope.form.gender = response.data.benefs.benefSex;
                        scope.form.insurername = scope.insurerFullName;
                        angular.element("#newPreauthModal").modal('hide');
                    }
                    else {
                        scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network issue', 'Error', true);
                    }
                }, function (response) {
                    scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network issue', 'Error', true);
                });
        } else {
            UtilitiesService.eCashlessReqData = eCashLess;
            scope.isECashLess = true;
            scope.eCashLessMessage = 'There is already a pre-approved request that exists for the patient. Redirecting you to the request. Click yes to continue.';
            timeout(function () {
                scope.$apply(function () {
                    scope.isECashLess = false;
                    scope.eCashLessMessage = '';
                });
            }, 10000)
        }
    };
    scope.opened = true;
    scope.reDirect = function (value) {

        if (value) {
            angular.element("#newPreauthModal").modal('hide');
            state.go(value, { reload: false });
        }
    };
    scope.clearfastrack = function () {
        scope.fastrack = {};
        scope.fastrack.displaySubmit = true;
        scope.fastrack.title = 'Member Search';
        scope.aarogyachecked = false;
        scope.fastrack.showCorpName = true;
        scope.fastrack.employerSearchTitle = 'Employee ID';
    };
    scope.removeModal = function () {
        scope.clearfastrack();
        angular.element("#newPreauthModal").modal('hide');
    };
    scope.packageCheck = function (data) {
        var isCheck = true;
        angular.forEach(data, function (data, index) {
            if (!data.general_Ward1 && !data.private_Ward1 && !data.semi_Private_Ward1) {
                isCheck = false
            }
        });
        return isCheck;
    };
    scope.getPackagesForPreAuthForm = function () {
        var packagesForPreAuthForm = scope.selectedMappedpackagesObj(scope.selectedMappedpackages);
        scope.packagesForPreAuthForm = [];
        if (packagesForPreAuthForm) {
            angular.forEach(packagesForPreAuthForm, function (data, index) {
                scope.packagesForPreAuthForm.push(data.packageName);
            });
        }
        return scope.packagesForPreAuthForm.join();
    };
    scope.selectedMappedpackagesObj = function (data) {
        scope.objSelected = [];
        if (data) {
            angular.forEach(data, function (data, index) {
                var obj;
                if (data.general_Ward1) {
                    obj = {
                        packageName: data.package_Name,
                        packageId: data.packageId,
                        packageAmount: data.general_Ward,
                        packageCappedAmount: 0
                    }
                } else if (data.private_Ward1) {
                    obj = {
                        packageName: data.package_Name,
                        packageId: data.packageId,
                        packageAmount: data.private_Ward,
                        packageCappedAmount: 0
                    }
                } else if (data.semi_Private_Ward1) {
                    obj = {
                        packageName: data.package_Name,
                        packageId: data.packageId,
                        packageAmount: data.semi_Private_Ward,
                        packageCappedAmount: 0
                    }
                } else {
                    obj = {};
                }
                scope.objSelected.push(obj);
            });
            return scope.objSelected;
        }
    };

    scope.preauthFormAction = (function () {
        scope.insuranceCompanyList = UtilitiesService.getInsuranceCompanyName();
        scope.username = UserService.getUserObj().userName;
        scope.showAutoPackages = true;
        function submitPreauthFormSuccess(successData) {
            scope.fileUploaName = [];
            scope.isProcessing = false;
            if (successData.data.isSuccess) {
                scope.form.preauthSuccess = true;
            }
            else {
                scope.form.preauthError = true;
            }
        }
        function submitPreauthFormError(ErrorData) {
            scope.isProcessing = false;
            scope.form.preauthError = true;
        }
        function fileUploadError(errordata) {
            scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'File Upload Error', 'Error', true);
        }
        return {
            getPreauthFormData: function (form) {
                var data = {
                    IsGovtClaim: false,
                    MemberGender: form.gender == undefined ? '' : form.gender,
                    Age: form.age == undefined ? '' : form.age,
                    ApplicationName: 'Hospital Portal',
                    PatientFirstName: form.fullname,
                    ContactNum: form.mobile,
                    EmpId: form.empid,
                    Employer: form.employer,
                    Maid: form.maid,
                    Doa: form.doa,
                    packagesList: scope.selectedMappedpackagesObj(scope.selectedMappedpackages),
                    ApproxClaimedAmnt: form.clmamount,
                    DocName: form.docname,
                    DocRegNo: 'String',
                    Diagnosis: form.diagnosis,
                    AdmissionType: form.admissiontype,
                    RoomType: form.roomtype,
                    TentativeDOD: form.dod,
                    HospId: UserService.getHospitalObj().hospId,
                    HospName: UserService.getHospitalObj().hospName,
                    CreatedBy: UserService.getUserObj().userId,
                    IpNumber: form.ipnumber,
                    Procedure: form.procedure,
                    IpAddress: 'String',
                    PolicyNumber: form.policyno,
                    InsurerName: form.insurername,
                    FileNames: form.fileNames,
                    FileUploadFolderPath: form.fileUploadFolderPath.join(),
                    uiD_NO: form.uidno,
                    attachedFiles: scope.fileUploaName,
                    tpaid: form.tpaId ? form.tpaId : 0,
                    tpaConfigId: form.hospTPAId ? form.hospTPAId : 0,
                    uniqueId: form.uniqueId ? form.uniqueId : ''
                };
                return data;

            },
            uploadFiles: function (callback) {
                scope.form.fileNames = [];
                scope.form.fileUploadFolderPath = [];
                var fileBlobArray = [];
                if (scope.preAuthFile) {
                    Object.keys(scope.preAuthFile).forEach(function (e) {
                        if (typeof (scope.preAuthFile[e]) == 'object') {
                            scope.file.push({
                                'model': scope.preAuthFile[e]
                            });
                        }
                    });
                }
                var filesUploadingArray = [];
                Object.keys(scope.file).forEach(function (ele) {
                    if (typeof (scope.file[ele].model) == "object") {
                        filesUploadingArray.push(scope.file[ele].model);
                    }
                });
                if (filesUploadingArray.length > 0) {
                    fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
                }
                else {
                    scope.isProcessing = false;
                    UtilitiesService.showAlertMessage('Please attach atleast one document.');
                    return false;
                }
                $q.all(fileBlobArray).then(function (result) {
                    result.forEach(function (element) {
                        if (element.data.isSuccess) {
                            angular.forEach(element.data.uploadResponseDetails, function (e, i) {
                                scope.form.fileNames.push(e.fileName);
                                scope.form.fileUploadFolderPath.push(e.downloadURL);
                                scope.fileUploaName.push({ fileName: e.fileName, docPath: e.downloadURL });
                            });
                        }
                        else {
                            scope.isProcessing = false;
                            scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                            return false;
                        }
                    });
                    if (result && (filesUploadingArray.length == 0 || scope.form.fileNames.length == result[0].data.uploadResponseDetails.length))
                        callback.call(scope.preauthFormAction);
                },
                function (error) {
                    scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                    scope.isProcessing = false;
                });
            },
            submitPreauthForm: function () {
                scope.isProcessing = true;
                this.uploadFiles(function () {
                    if (!scope.form.isgovtscheme) {
                        if (scope.packageCheck(scope.selectedMappedpackages)) {
                            NewAdmissionFormService.submitPreauthForm(this.getPreauthFormData(scope.form)).then(submitPreauthFormSuccess, submitPreauthFormError)
                        } else {
                            scope.isProcessing = false;
                            UtilitiesService.showAlertMessage('Please select package price.')
                        }
                    }
                    else {
                        if (scope.selectedPackages.length !== 0) {
                            scope.govtSchemeMethods.submitPreauthForm();
                        } else {
                            UtilitiesService.showAlertMessage('Please add atleast one government package.')
                        }
                    }
                });
            },
            closePreauthForm: function () {
                scope.resetFormData();
                $location.path('/otherClaims');
            },
            downloadPrefilledPreauthForm: function (source) {
                var PreauthFormDataObj = {
                    HospitalID: UserService.getHospitalObj().cmsHospId,
                    HospitalEmail: UserService.getHospitalObj().emailAddress,
                    HospitalName: UserService.getHospitalObj().hospName,
                    HospitalPhoneNo: UserService.getHospitalObj().primaryContactNumber,
                    HospitalAddress: (UserService.getHospitalObj().address + UserService.getHospitalObj().city).replace(/[^a-zA-Z0-9 ]/g, ""),

                    PatientName: scope.form.fullname,
                    PatientPhoneNo: scope.form.mobile,
                    CorporateName: scope.form.employer,
                    EmployeeID: scope.form.empid,
                    MAID: scope.form.maid ? scope.form.maid : '',
                    DOA: scope.form.doa.getFullYear() + '-' + (scope.form.doa.getMonth() + 1) + '-' + scope.form.doa.getDate(),
                    DOD: scope.form.dod.getFullYear() + '-' + (scope.form.dod.getMonth() + 1) + '-' + scope.form.dod.getDate(),
                    Ailment: scope.form.diagnosis,
                    Treatment: scope.getPackagesForPreAuthForm(),
                    AdmissionType: scope.form.admissiontype,
                    ClaimedAmount: scope.form.clmamount,
                    DocName: scope.form.docname,
                    RoomType: scope.form.roomtype,
                    TPAId: scope.form.tpaId,
                    UniqueId: scope.form.uniqueId ? scope.form.uniqueId : ''
                };
                NewAdmissionFormService.downloadPrefilledPreauthForm(source, PreauthFormDataObj)
            }
        };
    })();
    scope.govtSchemeMethods = (function () {
        scope.selectedPackages = new Array();
        function submitPreauthFormSuccess(successData) {
            scope.fileUploaName = [];
            scope.isProcessing = false;
            if (successData.data.isSuccess) {
                scope.form.preauthSuccess = true;
            }
            else {
                scope.form.preauthError = true;
            }
        }
        function submitPreauthFormError(ErrorData) {
            scope.isProcessing = false;
            scope.form.preauthError = true;
        }
        function getGovtPackageListSuccess(resData) {
            if (resData && resData.data.isSuccess && resData.data.packages && resData.data.packages.length > 0) {
                scope.govtPackageList1 = resData.data.packages;
                scope.govtPackageListDummy = scope.govtPackageList1;
                scope.changeGovtPolicyType('Basic');
                UserService.setGovtPackageList(scope.govtPackageList1);
                scope.showGovtPackages = true;
            }
            else {
                if (resData.data.isSuccess === false) {
                    scope.govtPackageList1 = [];
                    scope.govtPackageListDummy = scope.govtPackageList1;
                    UserService.setGovtPackageList(scope.govtPackageList1);
                    scope.showGovtPackages = false;
                }

            }
        }
        function getGovtPackageListError(resData) {
            scope.govtPackageList1 = [];
            scope.govtPackageListDummy = scope.govtPackageList1;
            UtilitiesService.showAlertMessage('Error while fetching govt packages list');
        }
        return {
            getGovtPackageList: function () {
                var govtPackageList1 = UserService.getGovtPackageList();
                if (govtPackageList1 != undefined && govtPackageList1 != null) {
                    scope.govtPackageList1 = govtPackageList1;
                    scope.govtPackageListDummy = scope.govtPackageList1;
                    scope.changeGovtPolicyType('Basic');
                    scope.showGovtPackages = true;
                }
                else {
                    GovernmentService.getGovtPackageList().then(getGovtPackageListSuccess, getGovtPackageListError)
                }
            },
            setGovtPackageId: function (packageObj) {
                scope.form.packageAmount = packageObj.packageCost;
                scope.form.packageName = packageObj.packageName;
                scope.form.packageUniqueId = packageObj.packageId;
                scope.form.cappedAmount = packageObj.cappedAmount;
            },
            addPackageButton: function () {
                if (scope.form.packageAmount || scope.form.mPackageAmount) {
                    if (scope.selectedPackages.length < 3) {
                        if (scope.showAutoPackages) {
                            scope.selectedPackages.push({
                                id: scope.selectedPackages.length,
                                uniqueId: scope.form.packageUniqueId,
                                name: scope.form.packageName,
                                amount: scope.form.packageAmount
                            });
                            $("#packagesHolder").val($("#packagesHolder").val() + ", " + scope.form.packageUniqueId);
                        }
                        else {
                            scope.selectedPackages.push({
                                id: scope.selectedPackages.length,
                                uniqueId: 0,
                                name: scope.form.mPackageName,
                                amount: scope.form.mPackageAmount
                            });
                            $("#packagesHolder").val($("#packagesHolder").val() + ", 0");
                        }
                        scope.packageCalcAmount = 0;
                        for (var i = 0; i < scope.selectedPackages.length; i++) {
                            scope.packageCalcAmount = scope.packageCalcAmount + ((25 * (4 - i)) / 100) * scope.selectedPackages[i].amount;
                        }
                        $("#packageAmountHolder").val(scope.packageCalcAmount);
                    }
                    else {
                        UtilitiesService.showAlertMessage('Maximum of 3 packages allowed.');
                    }
                }
            },
            removePackage: function (id) {
                $("#packagesHolder").val($("#packagesHolder").val().replace(", " + scope.selectedPackages[id].uniqueId, ""));
                for (var i = id; i < scope.selectedPackages.length - 1; i++) {
                    scope.selectedPackages[i] = scope.selectedPackages[i + 1];
                    scope.selectedPackages[i].id--;
                }
                scope.selectedPackages.pop(scope.selectedPackages.length - 1);
                scope.packageCalcAmount = 0;
                for (var i = 0; i < scope.selectedPackages.length; i++) {
                    scope.packageCalcAmount = scope.packageCalcAmount + ((25 * (4 - i)) / 100) * scope.selectedPackages[i].amount;
                }
                $("#packageAmountHolder").val(scope.packageCalcAmount);
            },

            getPreauthFormData: function (form) {
                var data = {
                    IsGovtClaim: true,
                    urnNumber: form.URNNum,
                    memberId: form.memberId,
                    memberDistrict: form.memberDist,
                    reasonForChoosing: form.reasonOnline ? form.reasonOnline.join() : '',
                    packages: scope.selectedPackages.map(function (item) { return item.uniqueId }),
                    MemberGender: form.memberGender,
                    Age: form.memberAge,
                    ApplicationName: 'Hospital Portal',
                    PatientFirstName: form.fullname,
                    ContactNum: form.mobile,
                    Doa: form.doa,
                    DocName: form.docname,
                    Diagnosis: form.diagnosis,
                    TentativeDOD: form.dod,
                    HospId: UserService.getHospitalObj().hospId,
                    HospName: UserService.getHospitalObj().hospName,
                    CreatedBy: UserService.getUserObj().userId,
                    IpNumber: form.ipnumber,
                    FileNames: form.fileNames,//form.fileUploadFolderPath,// form.fileNames,
                    FileUploadFolderPath: form.fileUploadFolderPath.join(),
                    ApproxClaimedAmnt: scope.packageCalcAmount,
                    uiD_NO: form.uidno,
                    GovScheme: UserService.getHospitalObj().entityRealtion[0].contractname,
                    attachedFiles: scope.fileUploaName,
                    tpaid: form.tpaId ? form.tpaId : 0,
                    tpaConfigId: form.hospTPAId ? form.hospTPAId : 0,
                    uniqueId: form.uniqueId ? form.uniqueId : ''
                };
                return data;
            },
            submitPreauthForm: function () {
                scope.isProcessing = true;
                NewAdmissionFormService.submitPreauthForm(this.getPreauthFormData(scope.form)).
                then(submitPreauthFormSuccess, submitPreauthFormError)
            },
            changePackageField: function () {
                if (scope.form.reasonOnline == 'others') {
                    scope.showAutoPackages = false;
                }
                else {
                    scope.showAutoPackages = true;
                }
            }
        };
    })();
    scope.govtSchemeMethods.getGovtPackageList();
    scope.preClaimInfoRelatedMethods = (function () {
        function submitPreauthFormSuccess(successData) {
            scope.isProcessing = false;
            if (successData.data.isSuccess) {
                scope.form.preauthSuccess = true;
            }
            else {
                scope.form.preauthError = true;
            }
        }
        function submitPreauthFormError(ErrorData) {
            scope.isProcessing = false;
            scope.form.preauthError = true;
        }
        return {
            prefillPreauthForm: function (claimRefNo) {
                NewAdmissionFormService.getPreauthDataByMARefNo(claimRefNo).then(function (resData) {
                    scope.resetFormData();
                    scope.signup = {};
                    if (resData.data.detailslist.length > 0) {
                        if (resData.data.detailslist[0].admissioN_DATE.indexOf('T') > -1) {
                            resData.data.detailslist[0].admissioN_DATE = new Date(resData.data.detailslist[0].admissioN_DATE);
                            resData.data.detailslist[0].dischargE_DATE = new Date(resData.data.detailslist[0].dischargE_DATE);
                        }
                        else {
                            var formattedDoa = resData.data.detailslist[0].admissioN_DATE.split('-')
                            resData.data.detailslist[0].admissioN_DATE = new Date(formattedDoa[1] + '/' + formattedDoa[0] + '/' + formattedDoa[2])
                            var formattedDod = resData.data.detailslist[0].dischargE_DATE.split('-');
                            resData.data.detailslist[0].dischargE_DATE = new Date(formattedDod[1] + '/' + formattedDod[0] + '/' + formattedDod[2])
                        }
                        scope.form.fullname = resData.data.detailslist[0].patienT_FIRSTNAME;
                        scope.form.mobile = parseInt(resData.data.detailslist[0].mobilE_NO);
                        scope.form.employer = resData.data.detailslist[0].corporatE_NAME;
                        scope.form.empid = resData.data.detailslist[0].employeE_ID;
                        scope.form.maid = resData.data.detailslist[0].maid;
                        scope.form.doa = (resData.data.detailslist[0].admissioN_DATE);
                        scope.form.dod = (resData.data.detailslist[0].dischargE_DATE);
                        scope.form.diagnosis = resData.data.detailslist[0].presenT_AILMENT;
                        scope.form.procedure = resData.data.detailslist[0].provisionaL_TREATMENT;
                        scope.form.admissiontype = resData.data.detailslist[0].admissioN_TYPE;
                        scope.form.clmamount = parseInt(resData.data.detailslist[0].preautH_AMOUNT);
                        scope.form.docname = resData.data.detailslist[0].firsT_NAME;
                        scope.form.roomtype = resData.data.detailslist[0].provideR_ROOM_TYPE;
                        scope.PreAuthForIRRemarks = resData.data.detailslist[0].remarks;
                    }
                }, function (error) {
                    UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
                });
            },
            getPreauthFormData: function (form) {
                var data = {
                    PreAuthNo: scope.dataobj.claimRefNo,
                    IsGovtClaim: false,
                    MemberGender: form.gender == undefined ? '' : form.gender,
                    Age: form.age == undefined ? '' : form.age,
                    ApplicationName: 'Hospital Portal',
                    PatientFirstName: form.fullname,
                    ContactNum: form.mobile,
                    EmpId: form.empid,
                    Employer: form.employer,
                    Maid: form.maid,
                    Doa: form.doa,
                    packagesList: scope.selectedMappedpackagesObj(scope.selectedMappedpackages),
                    ApproxClaimedAmnt: form.clmamount,
                    DocName: form.docname,
                    DocRegNo: 'String',
                    Diagnosis: form.diagnosis,
                    AdmissionType: form.admissiontype,
                    RoomType: form.roomtype,
                    TentativeDOD: form.dod,
                    HospId: UserService.getHospitalObj().hospId,
                    HospName: UserService.getHospitalObj().hospName,
                    CreatedBy: UserService.getUserObj().userId,
                    IpNumber: form.ipnumber,
                    Procedure: form.procedure,
                    IpAddress: 'String',
                    PolicyNumber: form.policyno,
                    InsurerName: form.insurername,
                    FileNames: form.fileNames,
                    FileUploadFolderPath: form.fileUploadFolderPath.join(),
                    uiD_NO: form.uidno,
                    attachedFiles: scope.fileUploaName,
                    tpaid: form.tpaId ? form.tpaId : 0,
                    tpaConfigId: form.hospTPAId ? form.hospTPAId : 0,
                    uniqueId: form.uniqueId ? form.uniqueId : ''
                };
                return data;
            },
            uploadFiles: function (callback) {
                scope.form.fileNames = [];
                scope.form.fileUploadFolderPath = [];
                var fileBlobArray = [];
                if (scope.preAuthFile) {
                    Object.keys(scope.preAuthFile).forEach(function (e) {
                        if (typeof (scope.preAuthFile[e]) == 'object') {
                            scope.file.push({
                                'model': scope.preAuthFile[e]
                            });
                        }
                    });
                }
                var filesUploadingArray = [];
                Object.keys(scope.file).forEach(function (ele) {
                    if (typeof (scope.file[ele].model) == "object") {
                        filesUploadingArray.push(scope.file[ele].model);
                    }
                });
                if (filesUploadingArray.length > 0) {
                    fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
                }
                else {
                    scope.isProcessing = false;
                    UtilitiesService.showAlertMessage('Please attach atleast one document.');
                    return false;
                }
                $q.all(fileBlobArray).then(function (result) {
                    result.forEach(function (element) {
                        if (element.data.isSuccess) {
                            angular.forEach(element.data.uploadResponseDetails, function (e, i) {
                                scope.form.fileNames.push(e.fileName);
                                scope.form.fileUploadFolderPath.push(e.downloadURL);
                            });
                        }
                        else {
                            scope.isProcessing = false;
                            scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                            return false;
                        }
                    });
                    if (result && (filesUploadingArray.length == 0 || scope.form.fileNames.length == result[0].data.uploadResponseDetails.length))
                        callback.call(scope.preClaimInfoRelatedMethods);
                },
                function (error) {
                    scope.isProcessing = false;
                    scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                });
            },
            submitPreClaimPreauthForm: function () {
                scope.isProcessing = true;
                this.uploadFiles(function () {
                    if (!scope.form.IsGovtClaim) {
                        NewAdmissionFormService.submitPreClaimPreauthForm(this.getPreauthFormData(scope.form)).
                                        then(submitPreauthFormSuccess, submitPreauthFormError);
                    }
                    else {
                        scope.govtSchemeMethods.submitPreauthForm();
                    }
                });
            },
            closePreauthForm: function () {
                scope.resetFormData();
                $location.path('/claims');
            },
        };
    })();
    if (scope.source == 'preClaim' && scope.dataobj.claimRefNo) {
        scope.preClaimInfoRelatedMethods.prefillPreauthForm(scope.dataobj.claimRefNo);
    }


    scope.todaysDate = new Date();
    scope.todaysDate = scope.todaysDate.setMonth(scope.todaysDate.getMonth() - 1);
    scope.todaysDate = new Date(scope.todaysDate);
    scope.isFormDisable = true;
    scope.dateOfAdmission = function (date, type) {
        scope.isFormDisable = false;
        if (type === 'doa') {
            var currentMonth = scope.todaysDate.getMonth() + 2;
            var selectedMonth = scope.form.doa.getMonth();
            if (currentMonth < selectedMonth) {
                scope.isdoa = true;
                scope.isFormDisable = true;
                if (scope.form.dod) {
                    scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
                }
            }
            else {
                scope.isdoa = scope.todaysDate <= scope.form.doa ? false : true;
                scope.isFormDisable = scope.isdoa;
                if (scope.form.dod) {
                    scope.isdod = scope.form.dod >= scope.form.doa ? false : true;
                }
            }
        } else if (type === 'dod') {
            var currentMonth = scope.todaysDate.getMonth() + 2;
            var selectedMonth = scope.form.doa.getMonth();
            if (currentMonth < selectedMonth) {
                scope.isdoa = true;
                scope.isFormDisable = true;
                scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
            }
            else {
                scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
                if (scope.form.doa) {
                    scope.isdoa = scope.todaysDate <= scope.form.doa ? false : true;
                    if (!scope.isdoa) {
                        scope.isdoa = scope.form.dod < scope.form.doa ? true : false;
                    }
                }
            }
        }
    };

    scope.file = [];
    scope.addFileToUpload = function (flag) {
        var newItemNo = scope.file.length + 1;
        scope.file.push({
            'model': ''
        });
    };
    scope.removeFileToUpload = function () {
        var lastItem = scope.file.length - 1;
        scope.file.splice(lastItem);
        scope.validLargeDoc = false;
    };
    scope.addFileToUpload();
}]);
angular.module('mbplus').controller('ModalInstanceCtrl', ['$scope', '$uibModalInstance', 'types', 'FastrackService', function (scope, $uibModalInstance, types, FastrackService) {
  //console.log("modal instanceCtrl")

  scope.modalinsta = "ModalInstanceCtrl-child";

  scope.ok = function () {
    $uibModalInstance.close(scope.selected.item);
  };

  scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  scope.fastrackPreauth = function (type) {
    scope.fastrack = {};
    scope.fastrack.title =
    scope.fastrack.displaySubmit = true;
    switch (type) {
      case 'aarogya':
        scope.fastrack.title = "Aarogya Scheme"
        scope.aarogyachecked = true;
        scope.fastrack.showCorpName = false;
        scope.fastrack.employerSearchTitle = "Family Number";
        break;
      case 'generic':
        scope.fastrack.title = "Member Search";
        scope.aarogyachecked = false;
        scope.fastrack.showCorpName = true;
        scope.fastrack.employerSearchTitle = "Employee ID";
        break;
    }
    if (scope.aarogyachecked) {
      scope.fastrack.corporateName = "Manipal";
    }
  }
  scope.fastrackPreauth(types);
  scope.getDetailsWithMaid = function (maid, benefName) {
    FastrackService.getDetailsWithMaid(maid, benefName).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.displaySubmit = false;
            scope.fastrack.error = false;
            scope.fastrack.name = response.data.benefs.name;
            scope.fastrack.relations = response.data.relations;
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
          }
          else {
            scope.fastrack.error = true;
            scope.fastrack.errorMessage = response.data.errorMessage;
          }
        },
           function (response) {
             scope.fastrack.error = true;
             scope.fastrack.errorMessage = "No data found"
           });
  }
  scope.getDetailsWithEmpId = function (empid, corpname, benefname) {
    FastrackService.getDetailsWithEmpId(empid, corpname, benefname).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.displaySubmit = false;
            scope.fastrack.error = false;
            scope.fastrack.name = response.data.benefs.benefName;
            scope.fastrack.relations = response.data.relations;
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
          }
          else {
            scope.fastrack.error = true;
            scope.fastrack.errorMessage = response.data.errorMessage;
          }
        },
           function (response) {
             scope.fastrack.error = true;
             scope.fastrack.errorMessage = "No data found"
           });
  }
  scope.getDetailsWithPolicy = function (policyno, benefname) {
    FastrackService.getDetailsWithPolicy(policyno, benefname).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.displaySubmit = false;
            scope.fastrack.error = false;
            scope.fastrack.name = response.data.benefs.benefName;
            scope.fastrack.relations = response.data.relations;
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;


          }
          else {
            scope.fastrack.error = true;
            scope.fastrack.errorMessage = response.data.errorMessage;
          }


        },
           function (response) {
             scope.fastrack.error = true;
             scope.fastrack.errorMessage = "No data found"
           });
  }
  scope.fastrackPopulateNewAdmission = function (maid, relationid, name) {
    FastrackService.fastrackPopulateNewAdmission(maid, relationid, name).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.$parent.tempData = response.data.benefs;
            scope.form = {};
            scope.form.fullname = response.data.benefs.benefName;   //generic
            scope.form.roomtype = "General ward";
            scope.form.employer = response.data.benefs.benefPolHldrName;
            scope.form.empid = response.data.benefs.priBenefEmpCode;
            scope.form.maid = response.data.benefs.benefMediAssistID;
            scope.form.policyno = scope.fastrack.PolicyNo;
          }
          else {
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          }
        },
           function (response) {
             UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
           });
  }
}]);
angular.module('mbplus')
  .controller('updateClaimInfoCtrl', ['$scope', '$rootScope', '$location', '$state', '$timeout', 'UserService', 'UtilitiesService', 'filterFilter', '$uibModal', 'FastrackService', 'GovernmentService', 'FileUploadService', 'ClaimActionService', '$analytics', '$q', 'blockUI', 'Upload', function (scope, rootScope, $location, state, timeout, UserService, UtilitiesService, filterFilter, $uibModal, FastrackService, GovernmentService, FileUploadService, ClaimActionService, $analytics, $q, blockUI, Upload) {
    scope.ctrlName = 'updateClaimInfoCtrl';
    scope.blockUIState = blockUI.state();
    if (!UserService.isActive()) {
      UserService.destroyUserObj();
      return false;
    }
    scope.file = [];
    scope.addFileToUpload = function () {
      var newItemNo = scope.file.length + 1;
      scope.file.push({
        'model': ''
      });
    };
    scope.removeFileToUpload = function () {
      var lastItem = scope.file.length - 1;
      scope.file.splice(lastItem);
      scope.validLargeDoc = false;
    };
    scope.datePopup = {
      doa: false,
      dod: false
    }
    scope.openDoa = function () {
      scope.datePopup.doa = true;
    };
    scope.openDod = function () {
      scope.datePopup.dod = true;
    };
    scope.updateClaimInfo = {
      claimNo: null,
      claimedAmount: null,
      approvedamount: null,
      doa:null,
      dod:null,
      statusId: null,
      remarks: null,
      attachment: []
    }
    if (scope.ngDialogData) {
      scope.updateClaimInfo.claimNo = scope.ngDialogData.claimId;
      scope.updateClaimInfo.claimedAmount = scope.ngDialogData.claimedAmount;
      scope.updateClaimInfo.approvedamount = scope.ngDialogData.approvedAmount;
      scope.updateClaimInfo.statusId= String(scope.ngDialogData.otherTPAStatusId);
      scope.updateClaimInfo.doa=new Date(moment(scope.ngDialogData.dateOfAdmission).format('YYYY-MM-DD'));
      scope.updateClaimInfo.dod=new Date(moment(scope.ngDialogData.dateOfDischarge).format('YYYY-MM-DD'));
    }
    function setDate() {
      var currentDate = scope.updateClaimInfo.doa;
      return currentDate.setMonth(currentDate.getMonth() + 3);
    }

    function getDate() {
      return scope.updateClaimInfo.doa;
    }

    function setMaxDate() {
      var currentDate = new Date();
      return currentDate.setMonth(currentDate.getMonth() + 6);
    }

    function setMinDate() {
      var currentDate = new Date();
      return currentDate.setMonth(currentDate.getMonth() - 1);
    }
    // scope.dateOptions = {
    //   formatYear: 'yyyy',
    //   maxDate: setMaxDate(),
    //   minDate: setMinDate()
    // };

    // scope.dateOptions1 = {
    //   formatYear: 'yyyy',
    //   maxDate: setDate(),
    //   minDate: getDate()
    // }
    

    scope.RemoveEmail = function (index) {
      if (scope.file[index] != undefined && scope.file[index] != null) {
        scope.file.splice(index, 1);
      };
    };
    scope.startLoading = function (message, element) {
      var myBlockUI = blockUI.instances.get(element);
      myBlockUI.start({
        message: message
      });
      blockUI.noOpen = true;
    };
    scope.stopLoading = function (element) {
      var myBlockUI = blockUI.instances.get(element);
      myBlockUI.stop();
    }

    scope.uploadAllFiles=function(file)
    {
      if(file && file.files)
      {
        if(!scope.file)
        {
          scope.file=[];
        }
        
        angular.forEach(file.files,function(data){
          var i=scope.file.length+1;
          scope.file.push({fileName:data.name,fileObject:data,progressBar:null,progressDivId:'progressDiv'+i,docPath:''});
        })

        angular.forEach(scope.file,function(object){
          if(!object.docPath)
            scope.UploadFileToDMS(object.fileObject,object);
        })
       
      }
    }


    scope.UploadFileToDMS = function (file,object) {
      Upload.upload({
        url: UtilitiesService.getUrlPrefix() + '/hosp/file/DMS/upload',
        file: file
      }).then(function (res) {
          if (res.data.isSuccess) {
            uploadResponse = res.data.uploadResponseDetails;
            object.docPath= UtilitiesService.getDMSHostUrl() + "/" + uploadResponse[0].downloadURL
          
          }
        },
        function (error) {},
        function (evt) {
          // var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
          // console.log('progress: ' + progressPercentage + '% ');
          var element = angular.element(document.querySelector('#'+object.progressDivId));
          object.progressBar = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
          element.html('<div style="width: ' + object.progressBar + '%">' + object.progressBar + '%</div>');
        })
      // if(file.files && typeof(file.files)=="object")
      // {
      //   scope.startLoading('Uploading files','AttachmentArray')
      //   FileUploadService.uploadFileToUrl(file.files).onProgress(function(res){
      //     if(res)
      //     {
      //       ;
      //     }
      //   }).then(function(res){
      //     if(res.data.isSuccess)
      //     {
      //       uploadResponse=res.data.uploadResponseDetails;
      //       if(!scope.file)
      //       {
      //         scope.file=[];
      //       }

      //       angular.forEach(uploadResponse,function(value){
      //         scope.file.push({"fileName":value.fileName,"docPath":UtilitiesService.getDMSHostUrl()+"/"+ value.downloadURL});
      //       });

      //       scope.stopLoading('AttachmentArray');
      //     }
      //   },function(error){}, function (evt) {
      //     ;
      //     var element = angular.element(document.querySelector('#dvProgress'));
      //     scope.Progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      //     element.html('<div style="width: ' + scope.Progress + '%">' + scope.Progress + '%</div>');
      // })
      // }
    }


    scope.uploadFiles = function () {
      var fileBlobArray = [];
      var filesUploadingArray = [];
      Object.keys(scope.file).forEach(function (ele) {
        if (typeof (scope.file[ele].model) == "object" || typeof (scope.file[ele]) == "object") {
          filesUploadingArray.push(scope.file[ele].model ? scope.file[ele].model : scope.file[ele]);
        }
      });
      if (filesUploadingArray.length > 0) {
        fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));

        $q.all(fileBlobArray).then(function (result) {
          result.forEach(function (element) {
            if (element.data.isSuccess) {
              angular.forEach(element.data.uploadResponseDetails, function (e, i) {
                scope.updateClaimInfo.attachment.push({
                  "fileName": e.fileName,
                  "docPath": e.downloadURL
                });
              });
              scope.updateDetails();
            }
            scope.file = [];
          });
        })
      } else {
        scope.updateDetails();
      }


    }

    scope.updateDetails = function () {
      var attachment = [];

        angular.forEach(scope.file, function (data) {
          attachment.push({
            "fileName": data.fileName,
            "docPath": data.docPath
          });
        })
      var data = {
        "parentId": scope.ngDialogData.tableId,
        "claimAmount": scope.updateClaimInfo.claimedAmount,
        "tpaclaimno": scope.updateClaimInfo.claimNo,
        "appAmt": scope.updateClaimInfo.approvedamount,
        "status": scope.updateClaimInfo.statusId,
        "remarks": scope.updateClaimInfo.remarks,
        "doa":scope.updateClaimInfo.doa,
        "dod":scope.updateClaimInfo.dod,
        "hospTPAID":scope.ngDialogData.tpaId,
        "actionBy": 820107,
        "attachedFiles": attachment
      }
      ClaimActionService.updateClaimInfo(data).then(function (res) {
        if (res.data.isSuccess) {
          alert("Data updated successfully");
          scope.closeModal();
        }
      });
    }

    scope.closeModal = function () {
      rootScope.$broadcast('closeUpateClaimInfoDialog', '');
    }

  }]);

angular.module('mbplus')
  .controller('tabCtrl', ['$rootScope', '$scope', 'UserService', '$location', '$log', '$analytics', 'ProfileService', 'UtilitiesService', '$http', '$timeout', '$filter', 'FileUploadService', 'ClaimActionService', 'NewAdmissionFormService', 'filterFilter', 'blockUI', 'PlusUtilitiesService', 'Upload', '$state', '$uibModal', '$q', function (rootScope, scope, UserService, $location, $log, $analytics, ProfileService, UtilitiesService, $http, $timeout, filter, FileUploadService, ClaimActionService, NewAdmissionFormService, filterFilter, blockUI, PlusUtilitiesService, Upload, state, $uibModal, $q) {
    scope.ctrlName = 'tabCtrl';
    scope.blockUIState = blockUI.state();
    scope.uniquePreauthStatus = ['New Admission', 'Information Awaited', 'Documents Submitted', 'Approved', 'Denied', 'Enhance Submitted', 'Enhance Approved', 'Enhance Denied', 'Enhance Info-Awaited', 'Enhance Info-Submitted', 'Claim Submitted'];
    if(UserService.getHospitalObj() && UserService.getHospitalObj().configuredSchemes)
    {
      scope.govtSchemeType=[];
      angular.forEach(UserService.getHospitalObj().configuredSchemes,function(element)
      {
        scope.govtSchemeType.push(element)
      })
    }
    // scope.govtSchemeType = ['RSBY', 'Manipur scheme (CMHT)'];
    scope.govServerSearch = {
      urn: '',
      status: '',
      patientName: '',
      claimId: '',
      hospitalName: '',
      schemeName: ''
    }
    scope.status = {
      isFirstOpen: true
    };
    scope.clearData = function () {
      scope.govServerSearch = {
        urn: '',
        status: '',
        patientName: '',
        claimId: '',
        hospitalName: '',
        schemeName: ''
      }
    };

    scope.clearData();

    scope.tab1show = true;
    scope.showAllAppointments = true;
    scope.form = {};
    scope.compareDate = UtilitiesService.compareDate;
    scope.compareDateNew = UtilitiesService.compareDateNew;
    scope.formatTime = UtilitiesService.formatTime;
    scope.getDateObj = UtilitiesService.getDateObj;
    scope.getDateObjNew = UtilitiesService.getDateObjNew;
    scope.getDDMMYYYY = UtilitiesService.getDDMMYYYY;
    scope.formatCurrency = UtilitiesService.formatCurrency;
    scope.downloadUrl = UtilitiesService.getDMSHostUrl();
    scope.DMSUrl = UtilitiesService.getDMSHostUrl();
    scope.tabsData = [];
    scope.downloadEmailBodyUrl = UtilitiesService.getPlusUrlPrefix() + '/Communication/';

    scope.user = UserService.getUserObj();
    if (!scope.user) {
      UserService.destroyUserObj();
      $location.path('/');
    }

    scope.open2 = function () {
      scope.popup2.opened = true;
    };
    scope.open1 = function () {
      scope.popup1.opened = true;
    };
    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];

    scope.popup2 = {
      opened: false
    };
    scope.popup1 = {
      opened: false
    };
    scope.isCmsUser = false;
    scope.currentStatusId = "";
    //scope.financeLogin = false;
    scope.managerLogin = false;
    scope.isInsurerAction = false;
    scope.medibizProviderId = 158749;
    scope.pharmaProviderId = 72326;
    scope.isInsurer = true;
    scope.dcLogin = false;
    scope.mahsLogin = false;
    scope.isFinanceFlag = {
      financeLogin: false
    }
    scope.user = UserService.getUserObj();
    if (scope.user && scope.user.entityId === 1000042) {
      scope.mahsLogin = true;
    }
    if (scope.user && scope.user.rolesFeatures.roles.length == 1) {
      angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
        if (v.roleId == 9205) {
          //scope.financeLogin = true;
        }
        if (v.roleId == 9204) {
          scope.managerLogin = true;
          //scope.financeLogin = false;
        }
      })
    }
    scope.reloadAppointments = function (type) {
      switch(type) {
        case 'dcDashboard':
          scope.$parent.getDashboardItems();
          break;
        case 'rescheduleAppointment':
          scope.$parent.reloadAppointments();
          break
      }
      
    }

    scope.isPPN = function () {
      return UtilitiesService.checkPPN();
    };

    scope.downloadPPNFile = function () {
      var nonPPN = 'https://document.medibuddy.in//proclaim-20170919/c6003e85-87f7-4367-bfaf-8169deb6d811.pdf';
      window.open(
        nonPPN,
        '_blank'
      );
    };

    scope.downloadNonPPNFile = function () {
      var nonPPN = 'https://document.medibuddy.in//proclaim-20170919/af23ae4b-43c3-4252-bd8b-1260c8b98393.pdf';
      window.open(
        nonPPN,
        '_blank'
      );
    };

    scope.getGovServerSearch = function (data) {
      $timeout(function () {
        scope.totalItems = 10;
        scope.currentPage = 1;
      }, 100);
      scope.callBackSecondFn({
        arg: 'Gov',
        flag: false,
        page: data
      });
    };

    scope.getCmsUserCheck = function () {
      scope.isCmsUserCheck = false;
      if (UserService.getUserObj() && UserService.getUserObj().rolesFeatures && UserService.getUserObj().rolesFeatures.roles && UserService.getUserObj().rolesFeatures.roles.length > 0) {
        angular.forEach(UserService.getUserObj().rolesFeatures.roles, function (v, i) {
          if (v.roleId === 9216) {
            scope.isCmsUserCheck = true;
          }
        })
      }
      return scope.isCmsUserCheck;
    };

    scope.getNotificationList = function (type) {
      scope.notificationTypeData = type;
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hospital/notifications/details/' + UserService.getHospitalObj().cmsHospId + '/' + type + '/' + 1 + '/' + 10 + '/' + UserService.getUserObj().userId, '', 'GET').then(function (response) {
        if (response.data.isSuccess) {
          if (scope.notificationTypeData == 'APPROVED' || scope.notificationTypeData == 'IN_PROGRESS') {
            scope.approvedNotificationCount = 0;
          }
          if (scope.notificationTypeData == 'INFO_REQUIRED') {
            scope.infoRequiredNotificationCount = 0;
          }
          if (scope.notificationTypeData == 'PAYMENT') {
            scope.paymentNotificationCount = 0;
          }
          if (scope.notificationTypeData == 'DENIED' || scope.notificationTypeData == 'CANCELLED') {
            scope.deniedNotificationCount = 0;
          }
          rootScope.$broadcast('notificationTypeData', scope.notificationTypeData);
          if (response.data && response.data.hospitalClaimSearchResults) {
            scope.hospitalNotifcations = UtilitiesService.renderClaimsList(response.data, 'preauth');
            angular.forEach(scope.hospitalNotifcations, function (data, index) {
              scope.hospitalNotifcations[index].isHighlighted = true;
            });
            angular.forEach(scope.preauthfilteredStatusFiltered, function (data, index) {
              if (scope.hospitalNotifcations.length >= (index + 1)) {
                scope.preauthfilteredStatusFiltered[index] = scope.hospitalNotifcations[index];
              }
            });
          }
        } else {
          UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        }
      });
    };

    scope.getClaimDetails = function (claimId) {
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/claim/claimdetails/' + UserService.getHospitalObj().hospId + '/' + claimId, '', 'GET').then(function (response) {
        if (response.data.isSuccess) {
          scope.claimSearhByClaimIdResults = response.data.claimDetails;
        } else {
          alert(response.data.errorMessage);
        }
      });
    };

    scope.markAsComplet = function (data, index) {
      if (data && scope.user) {
        var id = [];
        id.push(data.Id)
        var data = {
          notificationID: id,
          accessToken: scope.user.accessToken
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'UpdateNotification', data, 'POST').then(function (response) {
          if (response.data) {
            UtilitiesService.showAlertMessage('Mark as completed successfully.', true);
          }
        }, function (error) {});
      }
    };


    scope.markAsRead = function (all, notificationId) {
      if (all && all == true) {
        angular.forEach(scope.hospitalNotifcations, function (e, i) {
          e.isHighlighted = false;
        });
      }
      var data = {
        hospitalId: UserService.getHospitalObj().cmsHospId,
        notificationId: notificationId,
        notificationType: scope.param,
        markAllAsRead: all,
        readByUser: UserService.getUserObj().userName ? UserService.getUserObj().userName : UserService.getUserObj().firstName
      };
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hospital/notifications/markread/', data, "POST").then(function (response) {
        if (response.data.isSuccess) {
          $rootScope.$emit('readNotification', notificationId);
        }
      }, function (error) {
        // console.log('Error : ' + error);
      });
    };

    if (UtilitiesService.hospitalNotification) {
      scope.approvedNotificationCount = UtilitiesService.hospitalNotification.approvedNotificationCount;
      scope.infoRequiredNotificationCount = UtilitiesService.hospitalNotification.infoRequiredNotificationCount;
      scope.paymentNotificationCount = UtilitiesService.hospitalNotification.paymentNotificationCount;
      scope.deniedNotificationCount = UtilitiesService.hospitalNotification.deniedNotificationCount;
    }

    rootScope.$on('notifyCount', function (event, data) {
      if (data) {
        scope.approvedNotificationCount = data.approvedNotificationCount;
        scope.infoRequiredNotificationCount = data.infoRequiredNotificationCount;
        scope.paymentNotificationCount = data.paymentNotificationCount;
        scope.deniedNotificationCount = data.deniedNotificationCount;
      }
    });

    scope.eSaleQueueFlag = function () {
      var result = false;
      angular.forEach(UserService.getUserObj() && UserService.getUserObj().rolesFeatures.roles, function (v, i) {
        if (v.roleId == 9212) {
          // console.log('inside');
          result = true;
        }
      });
      return result;
    };

    angular.forEach(scope.user && scope.user.rolesFeatures.roles, function (v, i) {
      if (v.roleId == 9207 || v.roleId == 9211 || v.roleId == 9214) {
        scope.isInsurer = false;
      }
      if (v.roleId == 9211 || v.roleId == 9214 || v.roleId == 9217 || v.roleId === 9209) {
        scope.isInsurerAction = true;
      }
      if (v.roleId == 9204) {
        scope.managerLogin = true;
      }
      if (v.roleId === 9216) {
        scope.isCmsUser = true;
      }
      if (v.roleId == 5432 || v.roleId == 5433 || v.roleId == 5434) { //opt enable for dc login
        scope.dcLogin = true;
      }
    });

    scope.tabs = [{
        title: scope.tabname,
        content: scope.tabtype
      }],
      selected = null,
      previous = null;
    scope.selectedIndex = 0;
    scope.selectedAppointmentsIndex = 0;
    scope.user = UserService.getUserObj();
    scope.user = {
      role: ''
    };
    if (UserService.getUserObj()) {
      scope.userRoles = UserService.getUserObj().rolesFeatures.roles;
      if (scope.userRoles.length > 1) {
        angular.forEach(scope.userRoles, function (value, key) {
          if (value.roleName === 'cms') {
            scope.user.role = 'CMS';
          }
        });
      } else {
        scope.user.role = scope.userRoles[0].roleName === 'cms' ? 'CMS' : '';
      }
    }
    if (UserService.getUserObj()) {
      scope.username = UserService.toTitleCase(UserService.getUserObj().userName ? UserService.getUserObj().userName : UserService.getUserObj().firstName);
    }
    scope.totalItems = scope.preauthfiltered == undefined ? 50 : scope.preauthfiltered.length;
    scope.pagination = {
      currentPage: 1
    }
    scope.currentPage = scope.currentPage || 1;
    scope.pagination.currentPage = scope.currentPage || 1;
    scope.itemsPerPage = scope.tabtype == 'plusActiveAppointments' ? 25 : 10;
    scope.maxSize = 5;
    scope.file = {};
    scope.search = 'All';
    scope.userRole = UserService.displayThis;
    scope.getToUpperCase = UtilitiesService.getToUpperCase;
    scope.getToLowerCase = UtilitiesService.getToLowerCase;
    scope.getAge = UtilitiesService.getAge;
    scope.contracts = PlusUtilitiesService.getContracts();

    scope.resendOTP = function (claimId) {
      $('#approveOtp').modal('hide');
      if (claimId && UserService.getHospitalObj().cmsHospId) {
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'Hosp/ResendOTP/' + '/' + claimId + '/' + UserService.getHospitalObj().cmsHospId, {}, 'GET', '').then(function (response) {
          if (response.data.IsSuccess) {
            UtilitiesService.showAlertMessage('OTP send to your mobile number:-' + ' ' + response.data.SMSSentTo, true);
          } else {
            UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
          }
        }, function (error) {
          UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
        });
      } else {
        UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
      }
    };

    scope.checkPlannedRequest = function (preauthfiltered) {
      if (UtilitiesService.eCashlessReqData) {
        var selectedEcashLessRequest = _.first(filterFilter(preauthfiltered, {
          plannedHospId: UtilitiesService.eCashlessReqData.eCashlessReqId
        }));
        if (selectedEcashLessRequest) {
          scope.addTab(selectedEcashLessRequest);
        } else {
          UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
        }
      }
    };

    scope.statusFilter = function (val) {
      if (val == null)
        val = '';
      scope.preauthfilteredStatusFiltered = filterFilter(scope.preauthfiltered, val);
      scope.totalItems = scope.preauthfilteredStatusFiltered.length;
    };

    scope.$watch('listingData', function (current, old) {
      if (current !== old) {
        if (scope.tabname === 'Search Results') {
          scope.preauthfilteredStatusFiltered = scope.listingData;
          scope.isGov = false;
          scope.totalItems = scope.listingData.allRecordCount;
        }
      }
    });

    scope.$watch(function () {
      return scope.preauthfiltered;
    }, function (current, old) {
      if (current != old) {
        if (scope.tabname === 'Search Results') {
          scope.preauthfilteredStatusFiltered = scope.preauthfiltered;
          scope.isGov = false;
          scope.totalItems = 0;
          scope.currentPage = 1;
          $timeout(function () {
            scope.totalItems = scope.preauthfiltered.allRecordCount;
            scope.currentPage = 1;
          }, 100);
        } else if (scope.tabname == 'Government Schemes') {
          scope.preauthfilteredStatusFiltered = scope.preauthfiltered;
          $timeout(function () {
            scope.totalItems = scope.preauthfiltered.allRecordCount;
          }, 100);
        } else if (scope.tabname === 'Active Claims') {
          scope.preauthfilteredStatusFiltered = scope.preauthfiltered;
          scope.isGov = state.current.name === 'government' ? true : false;
          scope.totalItems = scope.preauthfiltered.allRecordCount === 'govt' ? scope.preauthfiltered.length : scope.preauthfiltered.allRecordCount;
          scope.uniquePreauthStatus = current.map(function (item) {
            return item.status
          }).filter(function (elem, idx, arr1) {
            return arr1.indexOf(elem) >= idx;
          });
          if (scope.tabname == 'Government Schemes' && scope.userRole('mediAssist', scope.user.role)) {
            scope.uniqueHospitalNames = current.map(function (item) {
              return item.hospitalName
            }).filter(function (elem, idx, arr1) {
              return arr1.indexOf(elem) >= idx;
            });
          }
          scope.checkPlannedRequest(scope.preauthfiltered);
        } else if (scope.tabname !== 'Other Claims' && scope.tabname !== 'Search Results' && scope.tabname !== 'Active Claims') {
          scope.preauthfilteredStatusFiltered = scope.preauthfiltered;
          scope.isGov = state.current.name === 'government' ? true : false;
          scope.totalItems = scope.preauthfiltered.allRecordCount === 'govt' ? scope.preauthfiltered.length : scope.preauthfiltered.allRecordCount;
          scope.noofDaysForPendingDocuments=scope.noofDaysForPendingDoc;
          scope.uniquePreauthStatus = current.map(function (item) {
            return item.status
          }).filter(function (elem, idx, arr1) {
            return arr1.indexOf(elem) >= idx;
          });
          if (scope.tabname == 'Government Schemes' && scope.userRole('mediAssist', scope.user.role)) {
            scope.uniqueHospitalNames = current.map(function (item) {
              return item.hospitalName
            }).filter(function (elem, idx, arr1) {
              return arr1.indexOf(elem) >= idx;
            });
          }
          scope.checkPlannedRequest(scope.preauthfiltered);
        } else {
          scope.preauthfilteredStatusFiltered1 = _.uniq(scope.preauthfiltered);
          scope.totalItems = scope.preauthfilteredStatusFiltered1.length;
        }
      } else {
        if (scope.tabname == 'Government Schemes') {
          if (scope.preauthfiltered.length > 0) {
            scope.preauthfilteredStatusFiltered = scope.preauthfiltered;
            $timeout(function () {
              scope.totalItems = scope.preauthfiltered.allRecordCount;
            }, 100);
          }
        }
      }
    }, true);

    scope.getUnprocessedClaims = function () {
      scope.currentPage = 1;
      scope.paginationTab = 'InProgress';
      scope.callBackSecondFn({
        arg: 'InProgress',
        flag: false,
        page: scope.currentPage
      });
    };

    //Call controller function
    scope.pageChanged = function (value, type) {
      if (type === true) {
        if (scope.tabname === 'Search Results') {
          scope.$parent.paginationFun(value, 'advanceSearch');
        } else if (scope.paginationTab === 'InProgress') {
          scope.callBackSecondFn({
            arg: 'InProgress',
            flag: false,
            page: value
          });
        } else if (scope.paginationTab === 'InProgress') {
          scope.callBackSecondFn({
            arg: 'InProgress',
            flag: false,
            page: value
          });
        } 
        else if(scope.tabname==='Documents Pending')
        {
            scope.someCtrlFn({
                arg: {'value':value,'noofDaysForPendingDoc':scope.noofdaysforpendingdoc}
              });
        }
        else {
          scope.someCtrlFn({
            arg: value
          });
        }
      } else if (type === false) {
        scope.currentPage = value;
        scope.pagination.currentPage = 1;
      }
    };

    scope.openZipFile = function (orderId, $event) {
      var url = UtilitiesService.getPlusUrlPrefix() + '/DownloadFile/ByOrderId/' + orderId;
      $event.stopPropagation();
      window.open(url, '_blank');
    };

    scope.courierData = {
      trackingNumber: '',
      acknowledgementNumber: '',
      PANotUtilized: '',
      date: '',
      hosp_PendingDocIssueRemarks: ''
    };

    scope.serverSearch = {
      contractType: ''
    };

    scope.minEndDate = new Date();
    scope.dateOptions1 = {
      maxDate: new Date(),
    };
    scope.isSelectedRadio1 = 0;
    scope.isSelectedRadio2 = 2;
    //Reset Courier Details
    scope.resetCourierDetails = function () {
      scope.courierData.trackingNumber = '';
      scope.courierData.acknowledgementNumber = '';
      scope.courierData.PANotUtilized = '';
      scope.courierData.date = '';
      scope.courierData.hosp_PendingDocIssueRemarks = '';
    };

    //Reset Flag status
    scope.resetFlagStatus = function () {
      scope.isSubmittedThroughCourier = false;
      scope.isHandDelivered = false;
      scope.isStillInHospital = false;
      scope.isPANotUtilized = false;
      scope.isDodOpen = false;
      scope.isSuccessFlag = false;
      scope.isAccept = false;
      scope.isRadioButton = true;
      scope.isOptionSelected = false;
      scope.isHosp_PendingDocIssue = true;
      scope.isPANotUtilized = false;
    };

    scope.resetFlagStatus();

    //Reset Data
    scope.resetData = function () {
      scope.isRadioButton = false;
    };

    //Selected Action Model
    scope.selectedActionModel = function (value, type) {
      if (value) {
        scope.courierData.PANotUtilized = type === true ? scope.courierData.PANotUtilized : '';
        scope.MasterLookUpOptions = _.without(scope.MasterLookUpOptionsOriginal, _.findWhere(scope.MasterLookUpOptionsOriginal, {
          id: 11520
        }));
        scope.isAccept = false;
        scope.isOptionSelected = true;
      } else {
        scope.isOptionSelected = false;
        scope.isAccept = false;
      }
    };

    //Selected Action Model Value
    scope.selectedActionModelValue = function (value) {
      if (value && value === 'I Accept') {} else {
        scope.selectedActionModel('Report an issue', true);
      }
    };

    //Get Corporate Packages
    scope.getCorporatePackages = function (selectedValue) {
      if (selectedValue) {
        scope.isHosp_PendingDocIssue = false;
        if (selectedValue.value === 'Submitted through Courier') {
          scope.resetCourierDetails();
          scope.isSubmittedThroughCourier = true;
          scope.isDodOpen = true;
          scope.isPANotUtilized = true;
          scope.isStillInHospital = false;
          scope.isHandDelivered = false;
        } else if (selectedValue.value === 'Hand Delivered') {
          scope.resetCourierDetails();
          scope.isHandDelivered = true;
          scope.isDodOpen = true;
          scope.isSubmittedThroughCourier = false;
          scope.isStillInHospital = false;
          scope.isPANotUtilized = true;
        } else if (selectedValue.value === 'Patient is still in Hospital') {
          scope.resetCourierDetails();
          scope.isStillInHospital = true;
          scope.isDodOpen = true;
          scope.isSubmittedThroughCourier = false;
          scope.isHandDelivered = false;
          scope.isPANotUtilized = true;
        } else if (selectedValue.value === 'PA not utilized') {
          scope.resetCourierDetails();
          scope.isPANotUtilized = true;
          scope.isSubmittedThroughCourier = false;
          scope.isHandDelivered = false;
          scope.isStillInHospital = false;
          scope.isDodOpen = false;
        } else if (selectedValue.value === 'PA not utilized') {
          scope.resetCourierDetails();
          scope.isPANotUtilized = true;
          scope.isSubmittedThroughCourier = false;
          scope.isHandDelivered = false;
          scope.isStillInHospital = false;
          scope.isDodOpen = false;
        }
      } else {
        scope.isPANotUtilized = false;
        scope.resetCourierDetails();
        scope.resetFlagStatus();
      }
    };

    //Get status details
    scope.getStatus = function (value, status) {
      scope.isSelectedRadio1 = 0;
      scope.isSelectedRadio2 = 0;
      scope.resetCourierDetails();
      scope.resetFlagStatus();
      scope.isHosp_PendingDocIssue = true;
      scope.claimIdValue = value.claimId;
      scope.ClaimDummyData = value;
      if (status === 'Add courier details') {
        var data = {
          'lookUpType': 'Hosp_PendingDocIssue'
        };
      } else if (status === 'Report an issue') {
        var data = {
          'lookUpType': 'HospitalIssueRemarks'
        };
      }
      scope.serverSearch.contractType = {};
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/master/MasterLookUp', data, 'POST', '', false)
        .then(function (response) {
          if (response.data) {
            scope.MasterLookUpOptions = response.data;
            scope.MasterLookUpOptionsOriginal = response.data;
            scope.MasterLookUpOptions = _.without(scope.MasterLookUpOptionsOriginal, _.findWhere(scope.MasterLookUpOptionsOriginal, {
              id: 11520
            }));
            scope.courierData.PANotUtilized = scope.ClaimDummyData.hospIssueRemarks ? scope.ClaimDummyData.hospIssueRemarks : '';
            if (scope.ClaimDummyData.hosp_PendingDocIssue > 0) {
              var data = filterFilter(scope.MasterLookUpOptions, {
                'id': scope.ClaimDummyData.hosp_PendingDocIssue
              });
              scope.serverSearch.contractType = {
                id: _.first(data).id,
                value: _.first(data).value
              };
              scope.getCorporatePackages(scope.serverSearch.contractType);
              scope.courierData.trackingNumber = scope.ClaimDummyData.hosp_TrackingNumber;
              scope.courierData.hosp_PendingDocIssueRemarks = scope.ClaimDummyData.hosp_PendingDocIssueRemarks;
              scope.courierData.date = scope.ClaimDummyData.hosp_DocSubmissiondate ? new Date(parseInt(scope.ClaimDummyData.hosp_DocSubmissiondate.replace("/Date(", "").replace(")/", ""), 10)) : '';
            } else if (scope.ClaimDummyData.hosp_IssueResponse > 0) {
              var data = filterFilter(scope.MasterLookUpOptions, {
                'id': scope.ClaimDummyData.hosp_IssueResponse
              });
              scope.serverSearch.contractType = {
                id: _.first(data).id,
                value: _.first(data).value
              };
              scope.selectedActionModelValue(scope.serverSearch.contractType.value);
            }
          }
        });
    };

    scope.isSuccessFlag = false;
    scope.saveCourierDetails = function (value, type, isType) {
      scope.isSuccessFlag = false;
      if (value && type && UserService.getHospitalObj() && UserService.getHospitalObj().hospId) {
        var data = {
          hospId: UserService.getHospitalObj().hospId,
          userId: UserService.getUserObj().userId,
          claimId: scope.claimIdValue,
          hosp_IssueResponse: isType === true ? type.id : 0,
          hospIssueRemarks: value.PANotUtilized,
          hosp_PendingDocIssue: isType === false ? type.id : 0,
          hosp_TrackingNumber: value.trackingNumber,
          Hosp_PendingDocIssueRemarks: value.hosp_PendingDocIssueRemarks,
          hosp_DocSubmissiondate: value.date
        };
      }
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/UpdateConcurrence', data, 'POST', '', true)
        .then(function (response) {
          if (response.data) {
            scope.isRadioButton = false;
            scope.isSuccessFlag = true;
            angular.element('#AddCourierDetails').modal('hide');
            angular.element('#reportAnIssue').modal('hide');
            scope.someCtrlFn({
              arg: value
            });
            $timeout(function () {
              scope.isSuccessFlag = false;
            }, 5000);
            var value = {
              text: 'action'
            };
          }
        }, function (error) {
          scope.isSuccessFlag = false;
          // console.log("Error : " + error);
        });
    };

    if (state.current.name === 'documentsAwaited') {
      scope.getStatus('', 'Add courier details');
    } else if (state.current.name === 'approved') {
      scope.getStatus('', 'Report an issue');
    }

    scope.getTextData = function (value) {
      if (value) {
        var data = _.findWhere(scope.MasterLookUpOptionsOriginal, {
          id: parseInt(value)
        });
        if (data) {
          return data.value;
        }
      }
    };

    //plus filter
    scope.getStatusFilterParam = function (val, type) {
      scope.statusType = type;
      scope.statusParam = val;
      if (scope.contractParam || scope.dateParam) {
        if (scope.contractParam) {
          scope.normalRemainingFilter(scope.statusType);
        }
        if (scope.dateParam) {
          scope.normalRemainingFilter(scope.statusType);
        }
      } else {
        scope.normalFilteredAppointments(scope.statusType);
      }
    };

    scope.getContractFilterParam = function (val, type) {
      scope.contractType = type;
      scope.contractParam = val;
      if (scope.statusParam || scope.dateParam) {
        if (scope.statusParam) {}
        if (scope.dateParam) {}
      } else {
        scope.normalFilteredAppointments(scope.contractType);
      }
    };

    scope.getDateFilterParam = function (val, type) {
      scope.stDateType = type;
      var a = val.toJSON();
      var formattedDate = moment(a).format('YYYY/MM/DD');
      scope.dateParam = formattedDate; //2016/08/20
      if (scope.statusParam || scope.contractParam) {
        if (scope.statusParam) {}
        if (scope.contractParam) {}
      } else {
        scope.normalFilteredAppointments(scope.stDateType);
      }
    };

    scope.normalFilteredAppointments = function (source) {
      if (scope.appointmentsStatusFiltered.length > 0) {
        scope.appointmentsStatusFiltered = scope.appointments.requests;
        switch (source) {
          case "contract":
            scope.appointmentsStatusFiltered = filterFilter(scope.appointmentsStatusFiltered, {
              'additionalInformation': {
                'productType': scope.contractParam
              }
            });
            scope.totalItems = scope.appointmentsStatusFiltered.length;
            break;
          case "status":
            scope.appointmentsStatusFiltered = filterFilter(scope.appointmentsStatusFiltered, {
              'currentStatus': scope.statusParam
            });
            scope.totalItems = scope.appointmentsStatusFiltered.length;
            break;
          case "date":
            scope.appointmentsStatusFiltered = filterFilter(scope.appointmentsStatusFiltered, {
              'additionalInformation': {
                'appointmentDate': scope.dateParam
              }
            });
            scope.totalItems = scope.appointmentsStatusFiltered.length;
            break;
          default:
            scope.appointmentsStatusFiltered = scope.appointments.requests;
            scope.totalItems = scope.appointmentsStatusFiltered.length;
            break;
        }
      }
    };

    //plus filter
    scope.activeClaim = function (index, tabname) {
      scope.selectedIndex = index;
      if (tabname === 'Active Claims') {
        scope.callBackSecondFn({
          arg: 'Active claim',
          flag: false
        });
      }
    };

    scope.changeIndex = function (index, tabname) {
      scope.paginationTab = tabname;
      scope.selectedIndex = index;
    };

    scope.$watch('selectedIndex', function (current, old) {
      if (current != old) {
        if (current == 0) {
          scope.tab1show = true;
        } else {
          scope.tab1show = false;
          scope.addTab(scope.tabs[current].content, '', scope.tabs[current].title);
        }
        previous = selected;
        selected = scope.tabs[current];
      } else {}
    });

    scope.$watch('selectedAppointmentsIndex', function (current, old) {
      if (current != old) {
        if (current == 0) {
          scope.tab1show = true;
        } else {
          scope.tab1show = false;
        }
        previous = selected;
        selected = scope.tabs[current];
      } else {}
    });

    scope.selectedMappedpackages = [];

    scope.addTab = function (claimNo, view, patientName) {
      if (scope.tabname !== 'Government Schemes') {
        if (scope.preauthfilteredStatusFiltered && scope.preauthfilteredStatusFiltered.length > 0) {
          angular.forEach(scope.preauthfilteredStatusFiltered, function (v, i) {
            if (v.claimId === claimNo) {
              scope.preauthfilteredStatusFiltered[i].isHighlighted = false;
            }
          })
        }
      }

      scope.claimSearhByClaimIdResults = null;
      if (scope.tabsData.length > 0) {
        if (scope.tabPlanned) {
          scope.form = {};
          scope.claimSearhByClaimIdResults = scope.getKeyUsingValue('id', scope.tabsData, parseInt(claimNo), true);
          if (scope.claimSearhByClaimIdResults != null) {
            scope.ecashlessMethods.getPlannedHospAttachment(scope.claimSearhByClaimIdResults.plannedHospId);
            scope.form.plannedHospId = scope.claimSearhByClaimIdResults.plannedHospId;
            scope.form.fullname = scope.claimSearhByClaimIdResults.patientName;
            scope.form.mobile = scope.claimSearhByClaimIdResults.mobileNumber;
            scope.form.dob = scope.claimSearhByClaimIdResults.dob;
            scope.form.gender = scope.claimSearhByClaimIdResults.gender;
            scope.form.employer = scope.claimSearhByClaimIdResults.corporateName;
            scope.form.empid = scope.claimSearhByClaimIdResults.employeeId;
            scope.form.maid = scope.claimSearhByClaimIdResults.id;
            scope.form.doa = scope.claimSearhByClaimIdResults.dateOfAdmission;
            scope.form.dod = scope.claimSearhByClaimIdResults.dateOfDischarge;
            scope.form.diagnosis = scope.claimSearhByClaimIdResults.diagnosis;
            scope.form.procedure = scope.claimSearhByClaimIdResults.procedure;
            scope.form.docname = scope.claimSearhByClaimIdResults.doctorName;
            scope.form.roomtype = scope.claimSearhByClaimIdResults.roomType;
            scope.form.source = scope.claimSearhByClaimIdResults.source;
            scope.selectedMappedpackages = scope.claimSearhByClaimIdResults.plannedHospPackage;
            scope.form.packagesList = scope.claimSearhByClaimIdResults.plannedHospPackage;
            scope.form.ApproxClaimedAmnt = 0;
            scope.form.admissiontype = 'planned';
            scope.form.fileNames = [];
            scope.form.fileUploadFolderPath = [];
            scope.totalClaimAmount();
          }
        } else {
          if (scope.tabname == 'Government Schemes')
            scope.claimSearhByClaimIdResults = scope.getKeyUsingValue('claimId', scope.tabsData, claimNo, true);
          else if ((scope.selectedIndex > 0 && scope.tabsData[scope.selectedIndex - 1].claimId == 'Pre Claim')) {
            scope.tabPlanned = false;
            scope.preClaim = true;
            scope.claimSearhByClaimIdResults = scope.getKeyUsingValue('claimRefNo', scope.tabsData, claimNo, true);
          } else {
            scope.preClaim = false;
            scope.claimSearhByClaimIdResults = scope.getKeyUsingValue('claimId', scope.tabsData, parseInt(claimNo), true);
          }
        }
        if (scope.claimSearhByClaimIdResults != null) {
          scope.tabs[scope.selectedIndex].active = true;
          return false; // scope.openTab(patientName, view, false); 
        }
      }
      if (scope.claimSearhByClaimIdResults === null && scope.tabname == 'Planned Requests' && claimNo) {
        scope.claimSearhByClaimIdResults = claimNo;
        // scope.selectedMappedpackages = claimNo.plannedHospPackage;
        scope.tabsData.push(claimNo);
        scope.openTab(claimNo.patientName, claimNo.id, false);
        scope.tabPlanned = true;
        scope.preClaim = false;
      } else if (scope.claimSearhByClaimIdResults === null) {
        scope.preClaim = false;
        if (scope.tabname == 'Government Schemes') {
          rootScope.govSchemeName = scope.govServerSearch.schemeName;
          var data = {
            hospId: UserService.getHospitalObj().hospId,
            claimId: claimNo,
            govtSchemeName: scope.govServerSearch.schemeName
          }
          UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/govtclaim/details/", data, "POST")
            .then(function (response) {
              if (response.data.isSuccess) {
                scope.claimSearhByClaimIdResults = response.data;
                scope.tabsData.push(response.data);
                scope.openTab(patientName, claimNo, false);
              } else {
                UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
              }
            }, function (error) {
              UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
            });
        } else if (claimNo == 'In Progress') {
          scope.preClaim = false;
          UtilitiesService.showAlertMessage('Dear customer,we have received your claim and have started processing it.\n\n You will see more details here shortly.', true);
          //scope.msg = UtilitiesService.getMessasgeObj('#5cb85c', 'Dear customer,we have received your claim and have started processing it.\n\n You will see more details here shortly.', 'In- Progress', true);
        } else if (claimNo == "Pre Claim") {
          scope.tabPlanned = false;
          scope.preClaim = true;
          scope.tabsData.push(view);
          scope.openTab(view.patientName, view.claimRefNo, false);
        } else {
          scope.claimDetailsValueData = view;
          scope.preClaim = false;
          var data = {
            hospitalId: UserService.getHospitalObj().hospId,
            claimNumber: claimNo,
            secClaimNumber: 0,
            externalAppCheck: '',
            dbType: view ? view.dbType : ''
          }
          UtilitiesService.startLoading('fetching claim details...', 'calimDetailsUI');
          UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/claim/claimdetails/', data, 'POST').then(function (response) {
            UtilitiesService.stopLoading('calimDetailsUI');
            if (response.data.isSuccess) {
              scope.claimSearhByClaimIdResults = response.data.claimDetails;
              scope.claimSearhByClaimIdResults.claimDetails.clmDOA = scope.getDateObj(scope.claimSearhByClaimIdResults.claimDetails.clmDOA);
              scope.claimSearhByClaimIdResults.claimDetails.clmDOD = scope.getDateObj(scope.claimSearhByClaimIdResults.claimDetails.clmDOD);
              scope.tabsData.push(response.data.claimDetails);
              scope.openTab(patientName, claimNo, false);
            } else {
              UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
            }
          }, function (error) {
            UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
          });
        }
      }
    };

    scope.openTab = function (title, view, showTab) {
      scope.tab1show = showTab;
      view = view || title + " Content View";
      scope.tabs.push({
        title: title,
        content: view
      });
      scope.tabs[scope.tabs.length - 1].active = true;
      scope.selectedIndex = scope.tabs.length - 1;
    };

    scope.removeTab = function (tab) {
      if (tab > 0) {
        scope.tabs.splice(tab, 1);
        scope.tabsData.splice(tab - 1, 1);
        scope.selectedIndex = scope.selectedIndex > 0 ? scope.selectedIndex - 1 : scope.selectedIndex;
        scope.tabs[scope.selectedIndex].active = true;
      }
    };

    scope.GetDetailsByClaimNo = function (claimid, callcount) {
      if (callcount) {
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/claim/claimdetails/' + UserService.getHospitalObj().hospId + '/' + claimid, '', 'GET').then(function (response) {
          if (response.data.isSuccess) {
            scope.claimSearhByClaimIdResults = response.data.claimDetails;
          } else {}
        });
      }
    };

    scope.getKeyUsingValue = function (keyName, collection, value, isReturnObject) {
      var res = null;
      $.grep(collection, function (e, i) {
        if (Object.keys(e).indexOf(keyName) > -1 && e[keyName] === value) {
          if (isReturnObject)
            res = e;
          else if (Object.keys(e).indexOf(keyName) > -1)
            res = e[keyName];
        }
        return 0;
      });
      return res;
    };

    scope.downloadSettledReport = function () {
      scope.claimSearhByClaimIdResults.claimAuditDetails.forEach(function (item) {
        if (item.auditStatus == 'Claim Settled') {
          window.open(item.letterDownloadLink);
        }
      })
    };

    scope.ecashlessMethods = (function () {
      scope.file = {};
      return {
        fileUpload: function () {
          scope.$parent.preauthFormAction.uploadFiles(scope.myFile);
        },
        submitPreauthForm: function () {
          scope.form.fileNames = scope.form.fileNames;
          scope.form.fileUploadFolderPath = scope.form.fileUploadFolderPath.join();
          scope.$parent.preauthFormAction.submitPreauthForm(scope.form, scope.file);
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = [];
        },
        getPlannedHospAttachment: function (plannedHospId) {
          scope.plannedAttachment = {};
          var url = UtilitiesService.getUrlPrefix() + "/Hosp/Claim/GetPlannedDocuments/?plannedHospId=" + plannedHospId;
          $http.get(url).
          success(function (resData) {
              if (resData.isSuccess) {
                scope.plannedAttachment = resData.plannedHospAttachment;
              } else {
                scope.errorMessage = resData.errorMessage;
                scope.resetFail = true;
              }
            })
            .error(function () {
              scope.errorMessage = "Server Issue";
              // console.log("Error");
            });
        },
        closeForm: function () {
          scope.form = {};
          //$location.path("/");
        }
      };
    })();

    scope.$watch('$parent.form.preauthSuccess', function (current, old) {
      scope.form.preauthSuccess = true;
    });

    scope.downloadMethods = (function () {
      scope.fileNotFound = false;
      return {
        downloadLetter: function (link) {
          link = link.replace('http:', 'https:');
          $http.get(link)
            .then(function (data) {
              var datacheck = /This file does not exist/.test(data.data);
              if (datacheck) {
                scope.fileNotFound = true;
              } else {
                var newWin = window.open(link, 'Download');
                if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
                  UtilitiesService.showAlertMessage('Please unblock the popup and download again.');
                }
              }
            }, function (data) {
              scope.fileNotFound = true;
            });
        },
        closeErrorMessage: function () {
          scope.fileNotFound = false;
        },
        downloadPrefilledPreauthForm: function (claimDetails) {
          var data = {
            hospId: UserService.getHospitalObj().hospId,
            claimId: claimDetails.claimId
          }
          NewAdmissionFormService.downloadPrefilledPreauthForm('', '', data)
        },
        getOtpModal: function (link, claimId) {
          angular.element('#approveOtp').modal('show');
          scope.selectedPlannedPreauth = {};
          scope.selectedPlannedPreauth.letterDownloadLink = link;
        },
        getOtpConfirmed: function (claimId) {
          if (claimId !== undefined) {
            var url = UtilitiesService.getUrlPrefix() + '/hosp/Claim/OtpVerfication';
            var data = {
              'claimNo': claimId,
              'otpNo': String(scope.selectedPlannedPreauth.Otp)
            }
            $http.post(url, data).then(function (resData) {
              if (resData.data.isSuccess) {
                scope.selectedPlannedPreauth.disabledPreauthForm = false
                scope.selectedPlannedPreauth.disabledSettlementLatter = false
                scope.selectedPlannedPreauth.showOtpRemarks = true;
                scope.selectedPlannedPreauth.OtpRemarks = 'OTP Matched';
                window.open(scope.selectedPlannedPreauth.letterDownloadLink);
                window.scrollTo(0, 0);
                scope.downloadMethods.clearOTPModal();
              } else {
                scope.selectedPlannedPreauth.disabledPreauthForm = true
                scope.selectedPlannedPreauth.disabledSettlementLatter = true;
                scope.selectedPlannedPreauth.showOtpRemarks = true;
                scope.selectedPlannedPreauth.OtpRemarks = 'OTP No. didnot match';
              }
            }, function (error) {
              scope.selectedPlannedPreauth.enabledPreauthForm = true
              scope.selectedPlannedPreauth.enabledSettlementLatter = true
            });
          } else {
            alert('Claim still not created.')
          }
        },
        clearOTPModal: function () {
          scope.selectedPlannedPreauth = {};
          angular.element('#approveOtp').modal('hide');
          scope.removeTab(scope.selectedIndex);
        }
      }
    })();

    scope.newDatObj = {
      clmDOD: new Date(),
      clmDOA: new Date()
    }

    scope.editClaim = function (data) {
      scope.edit = !scope.edit;
      scope.newDatObj.clmDOD = data.clmDOD;
      scope.newDatObj.clmDOA = data.clmDOA;
    };

    scope.UpdateDateRelatedMethods = (function () {
      function updateSuccess(response) {
        if (response.data.isSuccess) {
          angular.element('#updateModal').modal('hide');
          scope.msg = UtilitiesService.getMessasgeObj('#00ff99', 'DOA/DOD successfully edited', 'Updated', true);
        } else {
          angular.element('#updateModal').modal('hide');
          scope.msg = UtilitiesService.getMessasgeObj('red', 'Error while updating DOA/DOD', 'Error', true);
        }
      }

      function updateError(response) {
        UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
      }
      return {
        updateAdvanceSearchDoaDod: function (claimSearhByClaimIdResults) {
          ClaimActionService.UpdateDoaDod(this.getrelatedData(claimSearhByClaimIdResults)).then(updateSuccess, updateError);
        },
        getrelatedData: function (claimSearhByClaimIdResults, updateData) {
          if (claimSearhByClaimIdResults.claimDetails.clmDOD != '' && claimSearhByClaimIdResults.claimDetails.clmDOA != '') {
            var data = {
              HospId: UserService.getHospitalObj().hospId,
              ClaimId: claimSearhByClaimIdResults.claimId,
              DOA: scope.newDatObj.clmDOA,
              DOD: scope.newDatObj.clmDOD,
              ActionType: 'update',
              Remarks: 'Updated DOA/DOD via advance search'
            }
          }
          return data;
        },
        openUpdateModal: function (value) {
          scope.claimSearhByClaimIdResults.claimDetails.clmDOA = value.clmDOA;
          scope.claimSearhByClaimIdResults.claimDetails.clmDOD = value.clmDOD;
          scope.newDatObj.clmDOD.setHours(scope.newDatObj.clmDOD.getHours() + 5);
          scope.newDatObj.clmDOD.setMinutes(scope.newDatObj.clmDOD.getMinutes() + 30);
          scope.newDatObj.clmDOA.setHours(scope.newDatObj.clmDOA.getHours() + 5);
          scope.newDatObj.clmDOA.setMinutes(scope.newDatObj.clmDOA.getMinutes() + 30);
          scope.newDatObj.clmDOA
          angular.element('#updateModal').appendTo('body');
          angular.element('#updateModal').modal('show');
        }
      }
    })();

    scope.downloadGovtAttachment = function (obj) {
      if (obj.fileUploadFolderPath && obj.fileUploadFolderPath.indexOf('proclaim') > -1) {
        window.open(
          scope.DMSUrl + obj.fileUploadFolderPath,
          '_blank'
        );
      } else {
        window.open(
          'https://hosp.medibuddy.in/download.aspx?docId=' + obj.fileId,
          '_blank'
        );
      }
    };

    scope.getPatientDetails = function () {
      return details = {
        name: scope.name,
        requestId: scope.id,
        indexNo: scope.tabs.length - 1
      }
    };
    scope.downloadAllFiles = function () {
      window.open(
        UtilitiesService.getPlusUrlPrefix() + '/DownloadZivaAttachmentsOnOrderID/' + scope.mappingId1,
        '_blank'
      )
    };

    scope.res = {};
    scope.resId = '';
    scope.showPostToPharma = false;
    scope.zivaSerachData = {
      data: ''
    };

    scope.serachZivaRequest = function (data) {
      if (data) {
        angular.forEach(scope.relatedRequest, function (e, i) {
          if (e.data) {
            e.isOpen = true;
            scope.relatedRequest[i].data = filterFilter(e.data, {
              'pakcageName': data
            });
          }
        });
      } else {
        var data = UtilitiesService.getZivaData();
        scope.relatedRequest = JSON.parse(data) //UtilitiesService.getZivaData();
      }
    };

    scope.appointmentMethods = (function () {
      return {
        addAppointmentsTab: function (name, id, currentStatusId, orderId) {
          var tabIndex = _.findIndex(scope.tabs,function(tab){
            return tab.id == id
          })
          if(tabIndex == -1){
            $('#zivaInfoModal').modal('hide');
            scope.name = name;
            scope.id = id;
            scope.mappingId1 = orderId;
            scope.currentStatusId = currentStatusId;
            rootScope.requestIdForActiveAppointmnents = id;
            var data = {
              requestId: id,
              RequestAccessToken: UserService.getAccessToken()
            }
            UtilitiesService.stopLoading('appointmentDetails');
            UtilitiesService.startLoading('fetching appointment details...', 'appointmentDetails');
            UserService.makeRestCall(UtilitiesService.getProviderCoreUrl() + 'provider/requestFlow', data, 'POST', UserService.getAccessToken()).then(function (response) { // use for appointments
              UtilitiesService.stopLoading('appointmentDetails');
              if (response.data.isSuccess) {
                scope.visitTypeData = response.data.requestHistory.additionalInformation;
                scope.visitTypeData.dcLandlineNo = response.data.requestHistory.dcLandlineNo;
                scope.resData = response.data.requestHistory;
                response.data.requestHistory.id = id;
                scope.resId = id;
                scope.providerId = response.data.requestHistory.additionalInformation.providerId;
                scope.providerName = response.data.requestHistory.additionalInformation.providerName;
                scope.appointmentDate = response.data.requestHistory.additionalInformation.appointmentDate;
                scope.visitType = response.data.requestHistory.additionalInformation.visitType;
                scope.statusHistory = response.data.requestHistory.statusHistory;
                scope.getDetailData();
                if (response.data.requestHistory.additionalInformation) {
                  scope.productId = response.data.requestHistory.additionalInformation.orderItemProductId;
                }
                scope.ListfileName = [];
                if (response.data.requestHistory.additionalInformation.additionals && response.data.requestHistory.additionalInformation.additionals.PharmaOrderPrescriptionFiles) {
                  if (response.data.requestHistory.additionalInformation && response.data.requestHistory.additionalInformation.additionals.PharmaOrderPrescriptionFiles) {

                    if (typeof (response.data.requestHistory.additionalInformation.additionals.PharmaOrderPrescriptionFiles) === 'string') {
                      var fileList = response.data.requestHistory.additionalInformation.additionals.PharmaOrderPrescriptionFiles.split('/');
                      var fileName = fileList[fileList.length - 1];
                      scope.ListfileName.push({
                        fileName: fileName,
                        fileUrl: response.data.requestHistory.additionalInformation.additionals.PharmaOrderPrescriptionFiles
                      });
                    } else if (typeof (response.data.requestHistory.additionalInformation.additionals.PharmaOrderPrescriptionFiles) === Object) {
                      var allPrescription = JSON.parse(response.data.requestHistory.additionalInformation.additionals.PharmaOrderPrescriptionFiles);
                      angular.forEach(allPrescription, function (i, val) {
                        var fileList = allPrescription[val].split('/');
                        var fileName = fileList[fileList.length - 1];
                        scope.ListfileName.push({
                          fileName: fileName,
                          fileUrl: i
                        });
                      })
                    }
                  }
                }
                scope.tabsData.push(response.data.requestHistory);
                scope.res = scope.getKeyUsingValue('id', scope.tabsData, parseInt(id), true);
                scope.providerOrderId = scope.resData.providerOrderId ? scope.resData.providerOrderId : "";
                var test = PlusUtilitiesService.getDC_MA_PRE_EMP_ContractID();
                scope.appointmentMethods.openAppointmentTab(name, id, false);
              } else {
                UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
              }
            });
          } else{
            scope.tabs[tabIndex].active = true;
            scope.selectedAppointmentsIndex = tabIndex;
          } 
        },

        addAllAppointmentsTab: function (name, id, currentStatusId, orderId) {
          var tabIndex = _.findIndex(scope.tabs,function(tab){
            return tab.id == id
          })
          if(tabIndex == -1){
            scope.name = name;
            scope.id = id;
            scope.mappingId1 = orderId;
            scope.currentStatusId = currentStatusId;
            rootScope.requestIdForActiveAppointmnents = id;
            var data = {
              requestId: id,
              RequestAccessToken: UserService.getAccessToken()
            }
            UserService.makeRestCall(UtilitiesService.getProviderCoreUrl() + 'insurance/showHistory', data, 'POST', UserService.getAccessToken()).then(function (response) {
              if (response.data.isSuccess) {
                if (
                  response.data.requestHistory &&
                  response.data.requestHistory.statusHistory &&
                  response.data.requestHistory.statusHistory.length > 0
                ) {
                  response.data.requestHistory.statusHistory.forEach(function (
                    req
                  ) {
                    req.attachedFiles = req.attachments;
                  });
                }
                scope.resData = response.data.requestHistory;
                scope.getDetailData();
                response.data.requestHistory.id = id;
                scope.resId = id;
                scope.visitTypeData = response.data.requestHistory.additionalInformation;
                scope.visitTypeData.dcLandlineNo = response.data.requestHistory.dcLandlineNo;
                scope.providerId = response.data.requestHistory.additionalInformation.providerId;
                scope.tabsData.push(response.data.requestHistory);
                scope.res = scope.getKeyUsingValue('id', scope.tabsData, parseInt(id), true);
                scope.appointmentMethods.openAppointmentTab(name, id, false);

              } else {
                UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
              }
            });
          } else{
            scope.tabs[tabIndex].active = true;
            scope.selectedAppointmentsIndex = tabIndex;
          }
        },

        addApprovedUnApprovedCancelTab: function (name, id, currentStatusId, orderId) {
          var tabIndex = _.findIndex(scope.tabs,function(tab){
            return tab.id == id
          })
          if(tabIndex == -1){
            scope.name = name;
            scope.id = id;
            scope.mappingId1 = orderId;
            scope.currentStatusId = currentStatusId;
            rootScope.requestIdForActiveAppointmnents = id;
            var data = {
              requestId: id,
              RequestAccessToken: UserService.getAccessToken()
            }
            UserService.makeRestCall(UtilitiesService.getProviderCoreUrl() + 'insurance/showHistory', data, 'POST', UserService.getAccessToken()).then(function (response) {
              if (response.data.isSuccess) {
                if (
                  response.data.requestHistory &&
                  response.data.requestHistory.statusHistory &&
                  response.data.requestHistory.statusHistory.length > 0
                ) {
                  response.data.requestHistory.statusHistory.forEach(function (
                    request
                  ) {
                    request.AttachedFiles = request.attachments;
                  });
                }
                scope.resData = response.data.requestHistory;
                scope.getDetailData();
                scope.resId = id;
                scope.visitTypeData = response.data.requestHistory.additionalInformation;
                scope.visitTypeData.dcLandlineNo = response.data.requestHistory.dcLandlineNo;
                scope.providerId = response.data.requestHistory.additionalInformation.providerId;
                scope.providerName = response.data.requestHistory.additionalInformation.providerName;
                scope.appointmentDate = response.data.requestHistory.additionalInformation.appointmentDate;
                scope.visitType = response.data.requestHistory.additionalInformation.visitType;
                scope.statusHistory = response.data.requestHistory.statusHistory;
                if (response.data.requestHistory.additionalInformation) {
                  scope.productId = response.data.requestHistory.additionalInformation.orderItemProductId;
                }
                scope.tabsData.push(response.data.requestHistory);
                scope.res = scope.getKeyUsingValue('id', scope.tabsData, parseInt(id), true);
                scope.appointmentMethods.openAppointmentTab(name, id, false);
              } else {
                UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
              }
            });
          } else{
            scope.tabs[tabIndex].active = true;
            scope.selectedAppointmentsIndex = tabIndex;
          }
        },
        addRelatedAppointmentsTab: function (id) {
          rootScope.requestIdForActiveAppointmnents = id;
          var data = {
            orderId: scope.mappingId1
          }
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/GetRelatedRequests', data, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data.isSuccess) {
              if (response.data.requests && response.data.requests.length > 0) {
                scope.relatedrequests = '';
                scope.relatedrequests = response.data.requests;
                $('#relatedInfoModal').modal('show');
              } else {
                UtilitiesService.showAlertMessage('No related information to show.');
              }
            } else {
              UtilitiesService.showAlertMessage('No related information to show.');
            }
          });
        },
        patientDetailsAdditionals: function (data) {
          scope.patientAdditionals = data;
          $('#PatientDetailsAdditionals').modal('show');
        },
        getIdZivaReq: function () {
          scope.zivaSerachData.data = '';
          var data = {
            orderId: scope.mappingId1
          }
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/GetZivaRequests/' + scope.mappingId1, '', 'GET').then(function (response) {
            if (response.data.isSuccess) {
              scope.relatedrequests = '';
              angular.forEach(response.data.zivaResponse, function (e, i) {
                response.data.zivaResponse[i].filesData = [];
                if (e.zivaCorrespondance && e.zivaCorrespondance.length > 0) {
                  angular.forEach(e.zivaCorrespondance, function (e1, i1) {
                    if (e1.files && e1.files.correspondencereports) {
                      angular.forEach(e1.files.correspondencereports, function (e2, i2) {
                        response.data.zivaResponse[i].filesData.push({
                          fileNmae: e2,
                          downloadPath: i2
                        });
                      });
                    }
                  });
                }
              });
              scope.isFirstOpen = true;
              scope.relatedrequests = response.data.zivaResponse;
              scope.relatedRequest = {
                trimester1: {
                  header: 'Trimester one',
                  data: [],
                  isOpen: true
                },
                trimester2: {
                  header: 'Trimester two',
                  data: [],
                  isOpen: false
                },
                trimester3: {
                  header: 'Trimester three',
                  data: [],
                  isOpen: false
                },
                trimester4: {
                  header: 'Trimester four',
                  data: [],
                  isOpen: false
                }
              }
              angular.forEach(scope.relatedrequests, function (e, i) {
                if (e.trimester.toLowerCase() === 'trimester1') {
                  scope.relatedRequest.trimester1.data.push(e);
                } else if (e.trimester.toLowerCase() === 'trimester2') {
                  scope.relatedRequest.trimester2.data.push(e);
                } else if (e.trimester.toLowerCase() === 'trimester3') {
                  scope.relatedRequest.trimester3.data.push(e);
                } else if (e.trimester.toLowerCase() === 'trimester4') {
                  scope.relatedRequest.trimester4.data.push(e);
                }
              });
              UtilitiesService.setZivaData(JSON.stringify(scope.relatedRequest))
              $('#zivaInfoModal').modal('show');
            } else {
              UtilitiesService.showAlertMessage('No ziva information to show.');
            }
          });
        },
        addRelatedAppointmentsTabForQc: function (value) {
          var tabIndex = _.findIndex(scope.tabs,function(tab){
            return tab.id == id
          })
          if(tabIndex == -1){
            scope.name = 'Requests related to ' + value.id;
            scope.id = value.id;
            if (scope.id) {
              rootScope.requestIdForActiveAppointmnents = value.id;
              var data = {
                orderId: scope.id
              }
              UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/GetRelatedRequests', data, 'POST', UserService.getAccessToken()).then(function (response) {
                if (response.data.isSuccess) {
                  scope.resData = response.data.requests;
                  scope.appointmentMethods.openAppointmentTab(scope.name, scope.id, false);
                } else {
                  UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
                }
              });
            } else {
              UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            }
          } else{
            scope.tabs[tabIndex].active = true;
            scope.selectedAppointmentsIndex = tabIndex;
          } 
        },
        openAppointmentTab: function (name, id, showTab) {
          scope.tab1show = showTab;
          scope.tabs.push({
            id: id,
            title: name,
            content: name
          });
          scope.tabs[scope.tabs.length - 1].active = true;
          scope.selectedAppointmentsIndex = scope.tabs.length - 1;
        },
        removeAppointmentTab: function (tab) {
          if (tab > 0) {
            scope.tabs.splice(tab, 1);
            scope.tabsData.splice(tab - 1, 1);
            scope.selectedAppointmentsIndex = scope.selectedAppointmentsIndex > 0 ? scope.selectedAppointmentsIndex - 1 : scope.selectedAppointmentsIndex;
            scope.tabs[scope.selectedAppointmentsIndex].active = true;
          }
        },
        changeIndex: function (index) {
          scope.selectedAppointmentsIndex = index;
        }
      };
    })();

    scope.showDetails = function (data) {
      scope.$parent.showDetails(data);
    };

    scope.searchStatus = function (value) {
      scope.appointmentsStatusFiltered = filterFilter(scope.appointmentsStatusFilteredDemo, {
        'currentStatus': value
      });
      scope.totalItems = scope.appointmentsStatusFiltered.length;
    };

    scope.getSources = function (value) {
      var url = UtilitiesService.getPlusUrlPrefix('integration') + '/contractlookup/' + value;
      UserService.makeRestCall(url, '', 'GET').then(function (response) {
          scope.sources = response.data;
          $(scope.sources).each(function (i, v) {
            if (v.entityName.indexOf('Coverfox') != -1) {
              scope.coverfox_id = v.id;
            } else if (v.entityName.indexOf('PolicyBazaar') != -1) {
              scope.policybazaar_id = v.id;
            }
          })
          scope.isInsurer = false;
          scope.user = UserService.getUserObj();
          if (scope.user && scope.user.rolesFeatures) {
            angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
              if (v.roleId == 9207) {
                scope.isInsurer = true;
              }
            });
          }
          if (scope.isInsurer) {
            var entityId = [];
            entityId.push(String(scope.user.entityId));
            scope.sourcesList = filterFilter(scope.sources, {
              'id': entityId
            }, true);
            if (scope.sourcesList.length > 0) {
              scope.sources = scope.sourcesList;
              scope.ContractAsSales = true;
            } else {
              scope.ContractAsSales = false;
            }
          } else {
            scope.ContractAsSales = true;
          }
        },
        function (error) {
          UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        });
    };

    scope.ContractAsSales = false;
    scope.selectedSource = '';
    scope.filter = {
      text: '',
      contract: '',
      source: ''
    }
    scope.filterAppointment = function () {
      scope.pbqueueFiltered = scope.eSalesRequestsQueueData;
      if (scope.filter.text) {
        scope.eSalesRequestsQueue = filterFilter(scope.pbqueueFiltered, scope.filter.text);
        scope.totalItems = scope.eSalesRequestsQueue.length;
      }
      if (scope.filter.contract) {
        var data = [];
        var newData = _.where(scope.pbqueueFiltered, {
          contractID: parseInt(scope.filter.contract)
        })
        angular.forEach(scope.pbqueueFiltered, function (v, i) {
          if (parseInt(scope.filter.contract) == v.contractID) {
            data.push(v);
          }
        });
        scope.eSalesRequestsQueue = data;
        scope.totalItems = scope.eSalesRequestsQueue.length;
      }
      if (scope.filter.source) {
        scope.eSalesRequestsQueue = filterFilter(scope.pbqueueFiltered, {
          'source': scope.filter.source
        });
        scope.totalItems = scope.eSalesRequestsQueue.length;
      }
    };

    scope.checkContract = function (value) {
      scope.selectedSource = '';
      if (value) {
        if (value === '9782') {
          //scope.ContractAsSales = true;
          scope.filter.contract = value;
          scope.filterAppointment(value);
          scope.getSources(value);
        } else {
          scope.ContractAsSales = false;
          scope.filter.contract = value;
          scope.selectedSource = "";
          scope.filterAppointment();
        }
      } else if (value === null) {
        scope.ContractAsSales = false;
        scope.filter.contract = '';
        scope.filter.source = '';
        scope.filter.text = '';
        scope.selectedSource = '';
        scope.eSalesRequestsQueue = scope.eSalesRequestsQueueData;
        scope.totalItems = scope.eSalesRequestsQueue.length;
      }
    };

    scope.filterQueue = function (selectedSource) {
      if (selectedSource) {
        scope.filter.contract = '';
        scope.filter.source = selectedSource;
        scope.filterAppointment();
      } else {
        scope.filter.source = '';
        scope.filter.contract = '9782';
        scope.filterAppointment('9782');
        scope.getSources('9782');
      }
    };

    scope.getDataForNextpage = function (nextPage) {
      scope.previousPage = nextPage;
      if (scope.tabtype == 'plusActiveAppointments') {
        // var currentRecordPerPage = parseInt(scope.itemsPerPage) * nextPage;
        // if (currentRecordPerPage > scope.appointmentsStatusFiltered.length) {
        scope.$parent.searchAppointmentsGroupCtrl(nextPage - 1);
        // }
      } else if (scope.tabtype == 'ppAppointments') {
        // var currentRecordPerPage = parseInt(scope.itemsPerPage) * nextPage;
        // if (currentRecordPerPage > scope.appointmentsForPp.length) {
        scope.$parent.searchAppointmentsGroupCtrl(nextPage - 1);
        // }
      } else if (scope.tabtype == 'eSalesRequests') {
        scope.$parent.searchAppointmentsGroupCtrl(nextPage - 1);
      }
    };

    rootScope.$on('newCount', function (current, value) {
      scope.itemsPerPage = value;
    }, true);

    rootScope.$on('newCountChange', function (current, value) {
      scope.totalItems = scope.preauthfiltered == undefined ? (scope.appointmentsStatusFiltered === undefined ? 0 : scope.appointmentsStatusFiltered.length) : scope.preauthfiltered.length;
      scope.currentPage = 1;
      scope.pagination.currentPage = 1;
      scope.itemsPerPage = value;
    }, true);

    scope.$changeColor = function (value) {
      var searcItem = [10389, 10386, 10390, 10401, 10845, 10846, 10847, 10861],
        calss = '',
        isFlag = false;
      if (value.requestContractType) {
        isFlag = _.filter(searcItem, function (num) {
          return num === value.requestContractType;
        }).length > 0 ? true : false;
      }
      if (isFlag) {
        var calss = {
          'background-color': 'rgb(181, 207, 220)',
          'color': 'black',
          // 'font-size': 'medium'
        }
      }
      return calss;
    };

    scope.filename = 'Mahs_queue';
    scope.getFormattedDateTime = function (xdate, xtime) {
      var ydate = new Date(parseInt(xdate.replace("/Date(", "").replace(")/", ""), 10))
      var formattedDate = ydate.getFullYear() + "/" + (ydate.getMonth() + 1) + "/" + ydate.getDate() + " " + xtime.trim().split(" ")[0];
      return formattedDate;
    };

    scope.changePage = function (value) {
      scope.pagination.currentPage = value;
      scope.someCtrlFn({
        arg: value
      });
    };
    scope.pipeline = {};
    scope.$watch('appointments', function (current, old) {
      scope.totalItems = 0;
      if (scope.tabtype == 'plusActiveAppointments' || scope.tabtype == "plusAllAppointments" || scope.tabtype == "unApprovedCancelAppointments" || scope.tabtype == "approvedCancelAppointments" || scope.tabtype == "appointmentSearch" || scope.tabtype == "insurerDashboard") {
        if (current != old) {
          scope.appointmentsStatusFiltered = scope.appointments.requests;
          scope.appointmentsStatusFilteredDemo = scope.appointments.requests;
          scope.currentRecord = scope.appointmentsStatusFilteredDemo;
          scope.totalItems = scope.appointments.totalRows ? scope.appointments.totalRows : scope.appointments.requests.length;
          scope.statuses = scope.appointments.appointmentStatus;
        }
        else if(current == old && current && current.requests && scope.tabtype == 'plusActiveAppointments' && !scope.appointmentsStatusFiltered) {
          scope.appointmentsStatusFiltered = scope.appointments.requests;
          scope.appointmentsStatusFilteredDemo = scope.appointments.requests;
          scope.currentRecord = scope.appointmentsStatusFilteredDemo;
          scope.totalItems = scope.appointments.totalRows ? scope.appointments.totalRows : scope.appointments.requests.length;
          scope.statuses = scope.appointments.appointmentStatus;
        }
        scope.showFilters = !_.isEmpty(scope.appointmentsStatusFiltered);
        if(scope.showFilters){
          scope.statusList = _.keys(_.groupBy(scope.appointmentsStatusFiltered,'currentStatus'))
        } else{
          scope.statusList = [];
        }
      }
      scope.appointmentsNa = [];
      if (scope.tabtype == 'unapprovedNewAppointments') {
        if (current != old) {
          scope.appointmentsIds = [];
          scope.appointmentsNa = scope.appointments;
          scope.totalItems = scope.appointmentsNa.length;
        }
      }
      if (scope.tabtype == 'unConfirmedOrder') {
        if (current != old) {
          scope.appointmentsStatusFiltered = scope.appointments.cartOrders;
          scope.totalItems = scope.appointments.cartOrders.length;
        }
      }
      if (scope.tabtype == 'dcInvestigation') {
        if (current != old) {
          scope.dcInvestigation = scope.appointments;
          scope.totalItems = scope.appointments.length;
        }
      }
      if (scope.tabtype === 'hospitalPackage') {
        if (current) {
          scope.hospitalPackageData = scope.appointments;
          scope.totalItems = scope.appointments.length;
        }
      }
      if (scope.tabtype == 'eSalesRequests') {
        if (current != old) {
          scope.downloadESalesRequestsQueue = [];
          if (scope.appointments.pendingRequestQueueData) {
            scope.eSalesRequestsQueue = scope.appointments.pendingRequestQueueData;
            scope.totalEsalesItems = scope.appointments.totalCount;
          } else if (scope.appointments) {
            scope.eSalesRequestsQueue = scope.appointments;
            scope.totalEsalesItems = scope.appointments.length;
          }
          angular.forEach(scope.eSalesRequestsQueue, function (data, index) {
            var testName = '';
            var testDetails = JSON.parse(data.requestJSON).testDetails;
            if (testDetails.length > 1) {
              for (var i = 0; i < testDetails.length; i++) {
                testName = testName + testDetails[i].testName + ',';
              }
              testName = testName.substring(0, testName.length - 1);
            }
            if (testDetails.length == 1) {
              testName = testDetails[0].testName;
            }
            var tempObj = {
              corporateName: data.corporateName,
              dateTimeCreated: filter('date')(new Date(scope.getDateObj(data.dateTimeCreated)), 'yyyy-MM-dd HH:mm:ss'),
              eQuote: data.eQuote,
              name: data.name,
              mobileNumber: JSON.parse(data.requestJSON).mobileNumber,
              city: JSON.parse(data.requestJSON).city,
              state: JSON.parse(data.requestJSON).state,
              employeeId: JSON.parse(data.requestJSON).employeeId,
              testName: testName,
            }
            scope.downloadESalesRequestsQueue.push(tempObj);
          });
          angular.forEach(scope.eSalesRequestsQueue, function (v, i) {
            var location = [];
            location = JSON.parse(v.requestJSON);
            scope.eSalesRequestsQueue[i].city = location.city ? location.city : 'NA';
            scope.eSalesRequestsQueue[i].state = location.state ? location.state : 'NA';
            scope.eSalesRequestsQueue[i].testDetails = location.testDetails ? location.testDetails : [];
          })
          scope.eSalesRequestsQueueData = scope.eSalesRequestsQueue;
          // scope.totalItems = scope.eSalesRequestsQueue.length;
        }
      }
      if (scope.tabtype == 'corporatePackagesNames') {
        if (current != old) {
          scope.CorporatePackagesFiltered = scope.appointments;
          scope.packageNameLength = scope.CorporatePackagesFiltered.length;
          scope.totalItems = scope.CorporatePackagesFiltered.length;
        }
      }
      if (scope.tabtype === 'mappedDc') {
        if (current !== old) {
          scope.mappedDcLists = scope.appointments;
          angular.forEach(scope.mappedDcLists, function (item, key) {
            if (item.endDate || item.startDate) {
              scope.mappedDcLists[key].endDate = new Date(item.endDate);
              scope.mappedDcLists[key].startDate = new Date(item.startDate);
            }
          });
          scope.packageNameLength = scope.mappedDcLists.length;
        }
      }
      if (scope.tabtype == 'misReports') {
        if (current != old) {
          scope.reportOnStatusDetails = scope.appointments;
          scope.reportOnStatusDetailsCount = scope.reportOnStatusDetails.length;
        }
      }
      if (scope.tabtype === 'dcDashboardPendingAppts') {
        if (current != old) {
          scope.apptOnStatusDetails = scope.appointments;
          scope.apptOnStatusDetailsCount = scope.apptOnStatusDetails.length;
        }
      }
      if (scope.tabtype == 'qcAppointments') {
        if (current != old) {
          scope.appointmentsForQc = scope.appointments.data;
          scope.totalItems = scope.appointmentsForQc.length;
        }
      }
      if (scope.tabtype == 'ppAppointments') {
        if (current != old) {
          scope.appointmentsForPp = scope.appointments.requests;
          scope.totalItems = scope.appointments.totalRows;
        }
      }
      if (scope.tabtype == 'dcInvestigationMap') {
        if (current != old) {
          scope.appointmentsDcInvestMap = scope.appointments;
          scope.totalItems = scope.appointmentsDcInvestMap.length;
        }
      }
      if (scope.tabtype == 'pharmaDashboard') {
        if (current != old) {
          scope.appointmentsPharmaDashboard = scope.appointments;
          scope.totalItems = scope.appointmentsPharmaDashboard.length;
        }
      }
      if (scope.tabtype == 'communicationHistory') {
        if (current != old) {
          scope.communicationHist = scope.appointments;
          scope.totalItems = scope.communicationHist.length;
        }
      }
    }, true);
    var table = null, totalSelectedCount=0;
    scope.initializeDataTable = function(id) {
      if($('#'+id)){
        table = $('#'+id).DataTable({
          'paging': false,
          'columnDefs': [{
            'targets': 0,
            'searchable':false,
            'orderable':false,
            'className': 'tr-select',
            'render': function (data, type, full, meta){
                return '<input type="checkbox" id="row_select" value="1"'
                    + $('<div/>').text(data).html() + '">';
            }
          }],
          dom: 'l<"toolbar">frtip',
          initComplete: function(){
            if(scope.tabtype == 'plusActiveAppointments' && scope.tabname == 'New Appointments'){
              $("div.toolbar").html('<button type="button" class="btn btn-default" id="bluk_update">Confirm Appointments <strong></strong></button>');
            }
            if(scope.tabtype == 'plusActiveAppointments' && scope.tabname == 'Confirmed'){
              $("div.toolbar").html('<button type="button" class="btn btn-default" id="bluk_update"> Mark Attended <strong></strong></button>');
            }     
          },
          'order': [1, 'asc']
          });
          $('input[type="checkbox"]').click(function(ev){
          ev.stopPropagation();
          })
          $('input[type="checkbox"]').change(function(ev){
          if(!ev.target.checked){
            $('#select_all').prop('checked',false);
            totalSelectedCount > 0 ? --totalSelectedCount : 0;
          } 
          else if(!$('#select_all').prop('checked')){
            ++totalSelectedCount;
          }
          $('#bluk_update').attr('disabled',!totalSelectedCount);
          $('#bluk_update strong').text(totalSelectedCount ? '(' + totalSelectedCount + ')' : '');
          })
          $('#bluk_update').attr('disabled',true)
          $('#bluk_update').click(function(ev){
          bulkStatusUpdate(scope.tabname) 
        })
      }
    };
    scope.onSelectAll = function(){
      var checked = $('#select_all').prop('checked')
      var rows = table.rows({ 'search': 'applied' }).nodes();
      $('#bluk_update').attr('disabled', !totalSelectedCount);
      $('input[type="checkbox"]', rows).prop('checked', checked);
      totalSelectedCount = checked ? $('input[type="checkbox"]', rows).length : 0;
    }
    
    function bulkStatusUpdate(tabName){
      var modalInstance = $uibModal.open({
        keyboard: false,
        backdrop: 'static',
        templateUrl: '/app/components/plusModals/confirmBulkAppointmentModal.html?version=' + new Date(),
        controller: ['$scope', 'UtilitiesService', 'UserService', '$uibModalInstance', function ($scope, UtilitiesService, UserService, $uibModalInstance) {
          $scope.remarks = '';
          $scope.confirmBulkAppointments = function(){
            var requests = [];
            var rows = table.rows({ 'search': 'applied' }).nodes();
            table.$('input[type="checkbox"]').each(function(idx,node){
              if(node.checked){
                var requestId = rows[idx].querySelector('#request_id') ? parseInt(rows[idx].querySelector('#request_id').innerText) : 0
                var appointmentReq = scope.appointmentsStatusFiltered.find(function(each){return each.requestId == requestId})
                if(appointmentReq && appointmentReq.additionalInformation){
                  requests.push( {
                    "requestId": appointmentReq.requestId,
                    "statusId": appointmentReq.currentStatusId,
                    "schedule": appointmentReq.additionalInformation.appointmentDate,
                    "isHomeVisit": appointmentReq.additionalInformation.visitType == 'Home_Visit'
                  });
                  rows[idx].querySelector('.tr-select').innerHTML = '';
                  var statusBtn = rows[idx].querySelector('.next-action button');
                  if(statusBtn){
                    statusBtn.innerHTML = '<i class="glyphicon glyphicon-time"></i>&nbsp;Pending Confirmation';
                    statusBtn.classList.add('no-pointers');
                  }
                }
              }
            });
            var bulkReqObj = {
              "requestIds": requests,
              "requestedNextActionId": (tabName == 'Confirmed') ? 32 : 23,
              "remark": $scope.remarks
            }
            UserService.makeRestCall(UtilitiesService.getProviderCoreUrl() + 'provider/bulkRequestUpdate', bulkReqObj, 'POST', UserService.getAccessToken()).then(function(response){
            }, function(err){
            });
            $scope.closeModal(true);
          }
          $scope.closeModal = function (clearSelection) {
            $uibModalInstance.dismiss();
            if(clearSelection){
              var rows = table.rows({ 'search': 'applied' }).nodes();
              $('input[type="checkbox"]', rows).prop('checked', false);
              totalSelectedCount = 0;
              $('#bluk_update strong').text(totalSelectedCount ? '(' + totalSelectedCount + ')' : '');
              $('#bluk_update').attr('disabled',!totalSelectedCount);
            }
          };
        }],
        size: 'md'
      });
    };
    scope.roleForPackageUpdation = [];
    scope.isRoleForPackageUpdation = scope.roleForPackageUpdation.length > 0 ? 'cms' : 'hospital';
    if (UserService.getUserObj()) {
      scope.roleForPackageUpdation = _.filter(UserService.getUserObj().rolesFeatures.roles, function (val) {
        return val.roleId === 9216
      });
      scope.isRoleForPackageUpdation = scope.roleForPackageUpdation.length > 0 ? 'cms' : 'hospital';
    }
    scope.openUpdatePopup = function (item, user) {
      scope.hospitalPackagesExistingData = '';
      if (item && user === 'hospital') {
        if (item.isPendingForApproval === false) {
          scope.editHospPackage = item;
          if ((item.package_Expiry_date instanceof Date) === false) {
            scope.editHospPackage.package_Start_date = scope.getDateObjNew(scope.editHospPackage.package_Start_date);
            scope.editHospPackage.package_Expiry_date = scope.getDateObjNew(scope.editHospPackage.package_Expiry_date);
          }
          angular.element('#updateHospPackageModal').modal('show');
        } else {

          UtilitiesService.showAlertMessage('Pending for approval.');
        }
      } else if (item && user === 'cms') {
        scope.editHospPackage = item;
        scope.editHospPackage.package_Start_date = scope.getDateObjNew(scope.editHospPackage.package_Start_date);
        scope.editHospPackage.package_Expiry_date = scope.getDateObjNew(scope.editHospPackage.package_Expiry_date);
        angular.element('#updateHospPackageModal').modal('show');
      }
    };
    scope.hospPackageChangesRequestAction = function (value, flag) {
      if (value) {
        scope.callBackSecondFn({
          arg: scope.editHospPackage,
          flag: flag
        });
        angular.element('#updateHospPackageModal').modal('hide');
      }
    };

    scope.createObjForFile = function () {};

    var file = scope.hospPackagemyFile;
    scope.updateHospPackage = function () {
      if (scope.editHospPackage.isPendingForApproval === false) {
        scope.editHospPackage.filePath = [];
        angular.forEach(scope.fileCollection, function (key, value) {
          var obj = {
            fileName: key.fileName,
            docPath: key.downloadURL
          };
          scope.editHospPackage.filePath.push(obj);
        })
        scope.someCtrlFn({
          arg: scope.editHospPackage
        });
      } else {
        UtilitiesService.showAlertMessage('Pending for approval.');
      }
    };
    scope.hospPackageExistingDetails = function (data) {
      var data = {
        hospitalId: data.hospId,
        insurerShortName: '',
        perP_PER_ID: data.perP_PER_ID
      }
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/packagestoedit', data, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          scope.hospitalPackagesExistingData = _.first(response.data.mappedpackages);
        }
      });
    };

    scope.fileCollection = [];
    scope.removeFiles = function (item) {
      angular.forEach(scope.fileCollection, function (key, value) {
        if (key.fileName === item.fileName) {
          scope.fileCollection.splice(value, 1)
        }
      })
    };

    scope.downloadAttachment = function (obj) {
      if (obj) {
        window.open(
          UtilitiesService.getPlusUrlPrefix('medibuddy') + '/WAPI/GetFile/' + obj,
          '_blank'
        );
      }
    };

    scope.isFileUploading = false;
    scope.uploadImage = function (value) {
      var filesUploadingArray = [],
        fileBlobArray = [];
      angular.forEach(value.files, function (key, value) {
        filesUploadingArray.push(key);
      })
      scope.filesUploadingArray = filesUploadingArray;
      scope.isFileUploading = true;
      scope.fileCollection = [];
      (function calculateCss() {
        scope.dynamicCss = function (value) {
          scope.dynamicWidth = value + '%';
          if (scope.isFileUploading) {
            $timeout(function () {
              scope.dynamicCss(80);
            }, 600);
          }
        };
      })();
      scope.dynamicCss(40);
      fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
      $q.all(fileBlobArray).then(function (result) {
          result.forEach(function (element) {
            scope.isFileUploading = false;
            scope.dynamicCss(100);
            scope.filesUploadingArray = [];
            if (element.data.isSuccess) {
              scope.fileCollection = element.data.uploadResponseDetails;
            } else {
              UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to upload files.');
            }
          });
        },
        function (error) {
          UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to upload files.');
        });
    };

    scope.resetHospPackageData = function () {
      scope.editHospPackage = {};
      angular.element('#updateHospPackageModal').modal('hide');
    };

    scope.deleteOrder = function (value) {
      scope.$parent.deleteOrderEueue(false, value);
    };

    scope.unapprovedPP = function (data) {
      if (data) {
        rootScope.$broadcast('unapprovedPP', data);
      }
    };

    scope.actionColors = {
      "Create": "glyphicon glyphicon-plus",
      "MACancel": "glyphicon glyphicon-remove-sign",
      "UserCancel": "glyphicon glyphicon-minus-sign",
      "Confirm": "glyphicon glyphicon-ok",
      "Reschedule": "glyphicon glyphicon-calendar",
      "Cancel": "glyphicon glyphicon-remove",
      "Submit": "glyphicon glyphicon-paperclip",
      "Attended": "glyphicon glyphicon-ok",
      "NotAttended": "glyphicon glyphicon-remove",
      "Raise_IA": "glyphicon glyphicon-bullhorn",
      "Approve": "glyphicon glyphicon-ok",
      "notattended": "glyphicon glyphicon-glyphicon-off",
      "Fit": "glyphicon glyphicon-thumbs-up",
      "UnFit": "glyphicon glyphicon-thumbs-down",
      "SwitchDC": "glyphicon glyphicon-plus",
      "Reschedule": "glyphicon glyphicon-calendar",
      "UnApprovedNewAppointment": "glyphicon glyphicon-plus",
      "Raise_IA": "glyphicon glyphicon-bullhorn",
      "QCApprove": "glyphicon glyphicon-ok",
      "Split Request": "glyphicon glyphicon-scissors",
      "PartiallyAttended": "fa fa-hourglass-half",
      "PlaceWithPartner": "fa fa-cart-plus",
      "OutForDelivery": "fa fa-truck",
      "Delivered": "fa fa-paper-plane",
      "ConfirmByRetailer": "fa fa-check-square-o"
    };

    scope.statusTextColors = {
      22: "text-success",
      23: "text-success",
      24: "text-success",
      25: "text-success",
      26: "text-danger",
      27: "text-danger",
      28: "text-danger",
      29: "text-warning",
      30: "text-warning",
      31: "text-warning",
      32: "text-success",
      33: "text-warning",
      34: "text-success",
      35: "text-danger",
      36: "text-success",
      37: "text-success",
      38: "text-warning",
      39: "text-danger",
      40: "text-warning",
      41: "text-warning",
      42: "text-warning",
      43: "text-danger",
      49: "text-success",
      112: "text-warning",
      113: "text-danger",
      116: "text-warning",
      91: "text-warning",
      87: "text-success",
      88: "text-info",
      89: "text-success"
    }

    scope.openActionModal = function (getActionName, currentStatusId, actionStatusId, requestId, appointmentDate, secondAppointmentDate, orderItemProductId, item) {
      scope.$parent.openRespectiveActionModal(getActionName, currentStatusId, actionStatusId, requestId, appointmentDate, secondAppointmentDate, orderItemProductId, item);
    };

    scope.openSplitRequestMethod = function (productId, id, providerId, providerName, appointmentDate, visitType) {
      scope.$parent.medicalTestMethods.getTestsForPackage(productId, id, providerId, providerName, appointmentDate, visitType);
    };

    scope.plusLoadAppointments = function () {
      scope.$parent.loadAppointments();
    };


    scope.corpPackageMappingPackageName = function (selectedPackage) {
      scope.$parent.packageDetails(selectedPackage);
    };

    scope.getDocDetails = function () {
      scope.$parent.getDoc();
    };

    scope.dischargeAction = function(val) {
      scope.dischargeObj = val;
      scope.dischargeObj.fileUploadedPaths = [];
      scope.dischargeObj.fileUploadedNames = [];
      scope.fileArr = [];
      scope.isQuickDischarge = false;
      scope.dischargeObj.admitDate = val.dateOfAdmission == 'Today' ? new Date() : new Date(val.dateOfAdmission)
      scope.dischargeObj.dischargeDate = val.dateOfDischarge == 'Today' ? new Date() : new Date(val.dateOfDischarge);
    }

    scope.confirmDischarge = function(isDischarge) {
      if(isDischarge) {
        scope.isQuickDischarge = true;
        $analytics.eventTrack('Quick-Discharge-click', {
          category: 'YES', label: 'Quick Discharge Yes clicked'
        });
      }
      else {
        scope.isQuickDischarge = false;
        $analytics.eventTrack('Quick-Discharge-click', {
          category: 'NO', label: 'Quick Discharge No clicked - final discharge modal opened, '
        });
        angular.element("#dischargeData").modal('hide');
        scope.$broadcast('quickDischarge', scope.dischargeObj)
      }
    }

    scope.uploadAllFiles = function (file) {
      if (file && file.files) {
        angular.forEach(file.files, function (data) {
          var i = scope.fileArr.length + 1;
          scope.fileArr.push({
            fileName: data.name,
            fileObject: data,
            progressBar: null,
            progressDivId: 'progressDiv' + i,
            downloadPath: '',
            docPath: ''
          });
        })

        angular.forEach(scope.fileArr, function (object) {
          if (!object.docPath)
            scope.UploadFileToDMS(object.fileObject, object);
        })
      }
    }

    scope.UploadFileToDMS = function (file, object) {
      Upload.upload({
        url: UtilitiesService.getUrlPrefix() + '/hosp/file/DMS/upload',
        file: file
      }).then(function (res) {
          if (res.data.isSuccess) {
            uploadResponse = res.data.uploadResponseDetails;
            object.downloadPath = UtilitiesService.getDMSHostUrl() + "/" + uploadResponse[0].downloadURL;
            object.docPath = uploadResponse[0].downloadURL;
            scope.dischargeObj.fileUploadedPaths.push(object.docPath);
            scope.dischargeObj.fileUploadedNames.push(object.fileName);
          }
        },
        function (error) {},
        function (evt) {
          var element = angular.element(document.querySelector('#' + object.progressDivId));
          object.progressBar = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
          element.html('<div style="width: ' + object.progressBar + '%">' + object.progressBar + '%</div>');
        })
    }

    scope.removeAttachment= function (index) {
      if (scope.fileArr.length && scope.fileArr[index]) {
        scope.fileArr.splice(index, 1);
      };
    };

    scope.dischargePatient = function() {
      var data = {};
      data.hospId = UserService.getHospitalObj().hospId;
      data.claimId = scope.dischargeObj.claimId;
      data.claimedAmount = scope.dischargeObj.claimedAmount;
      data.updatedBy = UserService.getUserObj().userId;
      data.actionType = 'discharge';
      data.fileUploadFolder = scope.dischargeObj.fileUploadedPaths.join();
      data.fileNames = scope.dischargeObj.fileUploadedNames.join();
      data.doa = scope.isQuickDischarge ? moment(scope.dischargeObj.admitDate).format() : moment(scope.dischargeObj.dateOfAdmission).format();
      data.dod = scope.isQuickDischarge ? moment(scope.dischargeObj.dischargeDate).format() : moment(scope.dischargeObj.dateOfDischarge).format();
      $analytics.eventTrack('Quick-Discharge-click', {
        category: 'YES', label: 'Quick Discharge Submit called'
      });
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/claim/newAction', data, 'POST', UserService.getAccessToken()).then(function(response){
        if(response.data.isSuccess) {
          angular.element("#dischargeData").modal('hide');
        }
        else {
          window.alert('Something went wrong! Please try again.')
        }
      })
    }



    scope.saveCheckedMapDCParent = function (item, isChecked, updateBtn) {
      var itemDetails = item.toBeSelected;
      scope.item = item;
      if (isChecked) {
        var checkDcRate = (item.dcRate != undefined && (item.dcRate != '' || parseInt(item.dcRate) === 0)) ? true : false;
        if (checkDcRate) {
          scope.$parent.saveCheckedMapDC(item, isChecked, updateBtn);
        } else {
          UtilitiesService.showAlertMessage('You have missed DC Rate or corporate Rate.');
          scope.item.toBeSelected = false;
        }
      } else {
        scope.$parent.saveCheckedMapDC(item, isChecked, updateBtn);
      }
    };

    scope.mappedDcAllPackgParent = function (item, mapping) {
      var checkDcRate = (item.dcRate != undefined && (item.dcRate != '' || parseInt(item.dcRate) === 0)) ? true : false;
      if (checkDcRate) {
        scope.$parent.mappedDcAllPackg(item, mapping);
      } else {
        UtilitiesService.showAlertMessage('You have missed DC Rate or corporate Rate.');
      }
    };

    scope.setOrderItemIdParent = function (id) {
      scope.$parent.setOrderItemId(id);
    };

    scope.approvedNaActionRequest = function (isbool, mangerCmt) {
      scope.$parent.unApprovedActionRequest(isbool, mangerCmt);
    };

    scope.showDetailsParent = function (pbDetails) {
      scope.$parent.showDetails(pbDetails);
    };

    scope.btnDcDetailsParent = function (entityId, Id) {
      scope.someCtrlFn({
        arg: entityId,
        value: Id
      });
    };

    scope.getPackageTestDetails = function (productId, noproductId) {
      scope.$parent.getPackageTestDetails(productId, noproductId);
    };

    scope.unConfirmedOrderModal = function (cartId, boolValue, modalName) {
      scope.$parent.actionRequest(cartId, boolValue, modalName);
    };

    scope.editDcInvestigation = function (id) {
      if (!id || id <= 0)
        return;
      scope.$parent.showDCInvestigationDataToUpdate(id);
    };

    scope.openModalUnapprovedPP = function (action, currentStatusId, nextActionStatusId, reqId, apptDate) {
      if (!action)
        return;
      scope.$parent.showModalUnapprovedPP(action, currentStatusId, nextActionStatusId, reqId, apptDate);
    };

    scope.getRequestId = function () {
      return {
        name: scope.name,
        id: scope.id
      };
    }

    scope.getDetailData = function () {
      scope.apptEssentials = {
        packageType: (scope.resData.additionalInformation.isPaid == true) ? true : false,
        visitType: scope.resData.additionalInformation.visitType ? scope.resData.additionalInformation.visitType : '',
        productName: scope.resData.additionalInformation.productName ? scope.resData.additionalInformation.productName : '',
        productType: scope.resData.additionalInformation.productType ? scope.resData.additionalInformation.productType : '',
        id: rootScope.requestIdForActiveAppointmnents,
        additionals: scope.resData.additionalInformation.additionals ? scope.resData.additionalInformation.additionals : '',
        providerOrderId: scope.resData.providerOrderId,
        nextPosibleActions: scope.resData.nextPossibleActions,
        fitUnfit: scope.resData.fitUnfit,
        previousID: scope.resData.additionalInformation.previousID,
        priorityId: scope.resData.priorityId,
        productId: scope.resData.additionalInformation.productId,
        maid: scope.resData.additionalInformation.maid,
        secondAppointmentDate: scope.resData.additionalInformation.secondAppointmentDate,
        productId: scope.resData.additionalInformation.splittedRequestDetails === undefined ? scope.resData.additionalInformation.orderItemProductId : scope.resData.additionalInformation.splittedRequestDetails,
        grade: scope.resData.additionalInformation.grade ? scope.resData.additionalInformation.grade : ''
      }
      scope.patientDetails = {
        patientName: scope.resData.additionalInformation.patientName ? scope.resData.additionalInformation.patientName : '--',
        gender: scope.resData.additionalInformation.gender,
        age: scope.getAge ? scope.getAge(scope.resData.additionalInformation.dob) : '--',
        employeeID: scope.resData.additionalInformation.employeeID ? scope.resData.additionalInformation.employeeID : '--',
        relation: scope.resData.additionalInformation.relation ? scope.resData.additionalInformation.relation : '--',
        employeeMailID: scope.resData.additionalInformation.employeeMailID ? scope.resData.additionalInformation.employeeMailID.toLowerCase() : "--",
        contactNo: scope.resData.additionalInformation.contactNo ? scope.resData.additionalInformation.contactNo : '--',
        addressLine1: scope.resData.additionalInformation.addressLine1 ? scope.resData.additionalInformation.addressLine1 : '--',
        addressLine2: scope.resData.additionalInformation.addressLine2 ? scope.resData.additionalInformation.addressLine2 : '--',
        pharmaPrescription: scope.resData.additionalInformation.additionals ? (scope.resData.additionalInformation.additionals.PharmaOrderPrescriptionFiles ? scope.resData.additionalInformation.additionals.PharmaOrderPrescriptionFiles : '--') : '--',
        requestId: scope.id,
        additionals: scope.resData.additionalInformation.additionals ? scope.resData.additionalInformation.additionals : null
      };
      scope.apptDetails = {
        appointmentDate: scope.resData.additionalInformation.appointmentDate,
        appointmentTime: scope.resData.additionalInformation.appointmentDate,
        firstPreferredDate: scope.resData.additionalInformation.firstAppointmentDate ? scope.resData.additionalInformation.firstAppointmentDate : null,
        secondPreferredDate: scope.resData.additionalInformation.secondAppointmentDate ? scope.resData.additionalInformation.secondAppointmentDate : null,
        providerName: scope.resData.additionalInformation.providerName ? scope.resData.additionalInformation.providerName : '--',
        requestDCLocation: scope.resData.requestDCLocation ? scope.resData.requestDCLocation : '--',
        primaryContactName: scope.resData.primaryContactName ? scope.resData.primaryContactName : '--',
        primaryContactNo: scope.resData.primaryContactNo ? scope.resData.primaryContactNo : '--',
        dcLandlineNo: scope.resData.additionalInformation.dcLandlineNo ? scope.resData.additionalInformation.dcLandlineNo : '--',
        dcMobileNo: scope.resData.additionalInformation.dcMobileNo ? scope.resData.additionalInformation.dcMobileNo : '--',
        orderItemProductId: scope.resData.additionalInformation.orderItemProductId ? scope.resData.additionalInformation.orderItemProductId : '',
        primaryEmail: scope.resData.primaryEmail ? scope.resData.primaryEmail : '--',
        isHNI: scope.resData.additionalInformation.priorityForRequest && scope.resData.additionalInformation.priorityForRequest.priorityName && scope.resData.additionalInformation.priorityForRequest.priorityName.toUpperCase().indexOf("HNI") > -1 ? true: false,
        isDND: scope.resData.additionalInformation.additionals.DND === 'true' ? true : false,
        isDNDCustomer: scope.resData.additionalInformation.additionals.DNDCustomer === 'true' ? true : false,
        statusHistory: scope.resData.statusHistory.map(function (e) {
          return {
            statusId: e.statusId
          };
        }),
        additionalInformation: scope.resData.additionalInformation ? scope.resData.additionalInformation : {}
      };
      scope.pharmaDetails = {
        PharmaOrderPrescriptionFiles: scope.resData.additionalInformation.additionals ? (scope.resData.additionalInformation.additionals.PharmaOrderPrescriptionFiles ? scope.resData.additionalInformation.additionals.PharmaOrderPrescriptionFiles : '') : '',
        remarks: scope.resData.additionalInformation.additionals ? (scope.resData.additionalInformation.additionals.MedicineRemarks ? scope.resData.additionalInformation.additionals.MedicineRemarks : '') : '',
        cod: scope.resData.additionalInformation.lineAmount ? scope.resData.additionalInformation.lineAmount : '',
        cashless: scope.resData.additionalInformation.cashlessAmount ? scope.resData.additionalInformation.cashlessAmount : '',
        productType: scope.resData.additionalInformation.productType ? scope.resData.additionalInformation.productType : '',
        medicineData: scope.resData.additionalInformation.medicineData ? scope.resData.additionalInformation.medicineData : '',
        pharmacyOrderId: scope.resData.pharmacyOrderId ? scope.resData.pharmacyOrderId : ''

      }
      scope.apptHistory = {
        statusHistory: scope.resData.statusHistory,
        isPaid: scope.resData.additionalInformation.isPaid,
        cod: scope.resData.additionalInformation.lineAmount ? scope.resData.additionalInformation.lineAmount : '',
        cashless: scope.resData.additionalInformation.cashlessAmount ? scope.resData.additionalInformation.cashlessAmount : '',
        productType: scope.resData.additionalInformation.productType ? scope.resData.additionalInformation.productType : '',
        additionals: scope.resData.additionalInformation ? scope.resData.additionalInformation : ''
      };
    };

    scope.showWalletBalance = function (balance, isSuccess) {
      scope.$parent.showWalletBalance(balance, isSuccess);
    };

    scope.clearGrievanceModal = function (prevGriev) {
      scope.$parent.clearGrievanceModal(prevGriev);
    };

    scope.OrderIdDisp = false;
    scope.addMedicineBtn = false;
    if (scope.resData) {
      if (scope.resData.additionalInformation && scope.resData.additionalInformation.medicineData && scope.resData.pharmacyOrderId) {
        scope.OrderIdDisp = true;
      } else if (scope.resData.additionalInformation.providerId) {
        scope.addMedicineBtn = true;
      }
      if (scope.resData.additionalInformation && scope.resData.additionalInformation.providerId == scope.pharmaProviderId) {
        scope.addMedicineBtn = true;
      }
    }

    scope.addCorrespondence = function (requestDetail, action) {
      scope.$parent.getAddCorrespondence(requestDetail, action);
    };

    scope.serial = 1;
    scope.nextDcList = function (currentPageNo) {
      scope.serial = currentPageNo * 10 - 9;
      scope.$parent.loadMapForDcList(currentPageNo);
    };

    scope.openVarifyPresModal = function (PharmaPrescription) {
      scope.$parent.openVarifyPresModal(PharmaPrescription);
    };

    scope.doctorDetails = [];
    scope.roomsDetails = [];

    ProfileService.loadProviderProfileDataByKey('doctor',{getProviderDoctorDetail:true}).then(function(response){
        if(response){
            scope.doctorDetails = response;
        }
    });
    ProfileService.loadProviderProfileDataByKey('room',{getProviderRoomDetail:true}).then(function(response){
        if(response){
            scope.roomsDetails = response;
        }
    });
    
    scope.procedureManually = {
      name: '',
      price: ''
    };
    scope.totalClaimAmount = function () {
      scope.totalCalcAmount = 0;
      angular.forEach(scope.selectedMappedpackages, function (data, index) {
        if (data.packageAmount) {
          scope.totalCalcAmount = scope.totalCalcAmount + parseInt(data.packageAmount);
        }
      });
      //_.reduce(scope.selectedMappedpackages, function(memo, num){  return memo + parseInt(num.packageAmount);  }, 0);
      scope.CLAIMED_AMOUNT = scope.totalCalcAmount;
      scope.form.ApproxClaimedAmnt = scope.totalCalcAmount;
      scope.form.clmamount = scope.totalCalcAmount;
      return scope.totalCalcAmount;
    };
    scope.calculatePrice = function () {
      scope.packageCalcAmount = 0;
      angular.forEach(scope.selectedMappedpackages, function (data, index) {
        if (data.packageAmount) {
          scope.packageCalcAmount = scope.packageCalcAmount + data.packageAmount;
        }
      });
      scope.form.clmamount = scope.totalClaimAmount();
    };
    scope.typeProcedureName = function () {
      scope.isPriceDropDown = false;
      scope.isSelectedGov = false;
    };

    scope.downloadAttachment = function (obj) {
      if (obj) {
        window.open(
          UtilitiesService.getDMSHostUrl() + obj,
          '_blank'
        );
      }
    };
    scope.removeFiles = function (item) {
      angular.forEach(scope.storeFiles, function (key, value) {
        if (key.fileName === item.fileName) {
          scope.storeFiles.splice(value, 1)
        }
      })
      angular.forEach(scope.storeFiles, function (value, index) {
        scope.form.fileNames.push(value.fileName);
        scope.form.fileUploadFolderPath.push(value.downloadURL);
      })
    };
    scope.storeFiles = [];
    scope.fileFn = function (data) {
      if (data) {
        scope.isProcessing = false;
        angular.forEach(data, function (value, index) {
          scope.form.fileNames.push(value.fileName);
          scope.form.fileUploadFolderPath.push(value.downloadURL);
          scope.storeFiles.push({
            fileName: value.fileName,
            docPath: value.downloadURL
          });
        })
      }
    };

    scope.removePackageFromList = function (item) {
      if (item) {
        angular.forEach(scope.selectedMappedpackages, function (data, index) {
          if (data.uniqueIds > 0) {
            if (item.uniqueIds === data.uniqueIds) {
              scope.selectedMappedpackages.splice(index, 1);
            }
          } else {
            if (item.hospitaL_CHARGE_HEAD === data.hospitaL_CHARGE_HEAD) {
              scope.selectedMappedpackages.splice(index, 1);
            }
          }
        })
        if (item.uniqueIds > 0) {
          scope.removeData = item;
        }
        scope.calculateTotalAmount();
      }
    };

    scope.editPackageFromList = function () {
      scope.CLAIMED_AMOUNT = 0;
      scope.selectedMappedpackages = [];
      scope.totalClaimAmount();
    };

    scope.addManuallyProcedure = function (data, type) {
      if (data && data.name && data.price && scope.selectedPackagesData && type === true) {
        scope.isPriceDropDown = false;
        scope.priceForPackage = [];
        var selectedPackageList = [];
        //if(_.where(scope.selectedMappedpackages, {packageId: scope.selectedPackagesData.packageId}).length >=1){
        //UtilitiesService.showAlertMessage('Duplicate line item is not allowed.');
        //}else{
        scope.selectedMappedpackages.push({
          packageName: data.name,
          packageId: scope.selectedPackagesData.packageId,
          packageAmount: parseInt(data.price),
          packageCappedAmount: 0,
          cmS_CHARGE_TYPE_ID: 0,
          cmS_CHARGE_TYPE_DESC: '',
          cmS_SUBCHARGE_TYPE_ID: 0,
          cmS_SUBCHARGE_TYPE_DESC: '',
          hospitaL_CHARGE_HEAD: data.name,
          isReadOnly: scope.selectedPackagesData.packageId > 0 ? true : false,
          isPackage: scope.selectedPackagesData.packageId > 0 ? true : false
        });
        //}
        scope.selectedPackagesData = '';
        scope.procedureManually.name = '';
        scope.procedureManually.price = '';
        scope.calculatePrice();
      } else {
        if (data && data.name && data.price && type === false) {
          scope.isPriceDropDown = false;
          scope.priceForPackage = [];
          var selectedPackageList = [];
          if (_.where(scope.selectedMappedpackages, {
              packageName: data.name
            }).length >= 1) {
            UtilitiesService.showAlertMessage('Duplicate line item is not allowed.');
          } else {
            scope.selectedMappedpackages.push({
              packageName: data.name,
              packageId: 0,
              packageAmount: parseInt(data.price),
              packageCappedAmount: 0,
              cmS_CHARGE_TYPE_ID: 0,
              cmS_CHARGE_TYPE_DESC: '',
              cmS_SUBCHARGE_TYPE_ID: 0,
              cmS_SUBCHARGE_TYPE_DESC: '',
              hospitaL_CHARGE_HEAD: data.name,
              isReadOnly: false,
              isPackage: false
            });
          }
          scope.procedureManually.name = '';
          scope.procedureManually.price = '';
          scope.selectedManualData = '';
          scope.calculatePrice();
        } else {
          UtilitiesService.showAlertMessage('Please enter name and price.');
        }
      }

      scope.form.packagesList = scope.selectedMappedpackages;
    };

    scope.selectPackageFromList = function (item, model) {
      scope.priceForPackage = [];
      scope.selectedPackagesData = '';
      scope.selectedManualData = '';
      if (item && item.distinctPrices) {
        scope.selectedPackagesData = item;
        if (item.deluxe_Other > 0) {
          scope.priceForPackage.push({
            name: 'Delux room',
            price: item.deluxe_Other
          })
        }
        if (item.general_Ward > 0) {
          scope.priceForPackage.push({
            name: 'General room',
            price: item.general_Ward
          })
        }
        if (item.private_Ward > 0) {
          scope.priceForPackage.push({
            name: 'Private room',
            price: item.private_Ward
          })
        }
        if (item.semi_Private_Ward > 0) {
          scope.priceForPackage.push({
            name: 'Semi private room',
            price: item.semi_Private_Ward
          })
        }
        scope.isPriceDropDown = true;
      } else {
        scope.selectedManualData = item;
        scope.priceForPackage = [];
        scope.isPriceDropDown = false;
      }
    };

    scope.mappedpackages = [];
    scope.packageListing = [];
    scope.selectedMappedpackages = [];
    //
    scope.getMappedpackages = function (details) {
      scope.mappedpackages = [];
      scope.packageListing = [];
      scope.selectedMappedpackages = [];
      scope.calculatePrice();
      scope.isPriceOne = false;
      scope.isPriceTow = false;
      scope.isPriceThree = false;
      if (UserService.getHospitalObj()) {
        var data = {
          hospitalId: UserService.getHospitalObj().cmsHospId,
          insurerShortName: details
          //--details
          //'NIA'
        }
        scope.newPackageListData = [];
        // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/mappedpackages', data, 'POST', UserService.getAccessToken()).then(function (response) {
        //   if (response.data.isSuccess) {
        //     scope.availableBills = [];
        //     angular.forEach(response.data.availableBills, function (key, index) {
        //       if (key.isDefault) {
        //         var data = {
        //           packageName: key.hospitalBillDesc,
        //           package_Name: key.hospitalBillDesc,
        //           packageId: 0,
        //           packageAmount: 0,
        //           packageCappedAmount: 0,
        //           cmS_CHARGE_TYPE_ID: key.intermalBillTypeId,
        //           cmS_CHARGE_TYPE_DESC: key.internalBillTypeDesc,
        //           cmS_SUBCHARGE_TYPE_ID: key.internalSubBillTypeId,
        //           cmS_SUBCHARGE_TYPE_DESC: key.internalSubBillDesc,
        //           hospitaL_CHARGE_HEAD: key.hospitalBillDesc,
        //           isReadOnly: true,
        //           isPackage: false,
        //           uniqueIds: 0
        //         }
        //         scope.availableBills[index] = data;
        //       }
        //     });
        //     var packageListing = response.data.mappedpackages;
        //     if (packageListing) {
        //       scope.totalListOfPackage = packageListing.concat(scope.availableBills);
        //     }
        //   } else {
        //     scope.totalListOfPackage = [];
        //   }
        // });
      }
    };

    function setDate() {
      var currentDate = new Date(scope.form.doa);
      return currentDate.setMonth(currentDate.getMonth() + 3);
    }

    function getDate() {
      return scope.form.doa;
    }

    function setMaxDate() {
      var currentDate = new Date();
      return currentDate.setMonth(currentDate.getMonth() + 6);
    }

    function setMinDate() {
      var currentDate = new Date();
      return currentDate.setMonth(currentDate.getMonth() - 1);
    }

    scope.dateOptions = {
      formatYear: 'yyyy',
      maxDate: setMaxDate(),
      minDate: setMinDate()
    };

    scope.dateOptions1 = {
      formatYear: 'yyyy',
      maxDate: setDate(),
      minDate: getDate()
    }
    scope.datePopup = {
      doa: false,
      dod: false
    }
    scope.openDoa = function () {
      scope.datePopup.doa = true;
    };

    scope.openDod = function () {
      scope.datePopup.dod = true;
    };

    scope.todaysDate = new Date();
    scope.todaysDate = scope.todaysDate.setMonth(scope.todaysDate.getMonth() - 1);
    scope.todaysDate = new Date(scope.todaysDate);
    scope.isFormDisable = true;
    scope.dateOfAdmission = function (date, type) {
      scope.isFormDisable = false;
      if (type === 'doa') {
        var currentMonth = scope.todaysDate.getMonth() + 2;
        var selectedMonth = scope.form.doa.getMonth();
        if (currentMonth < selectedMonth) {
          scope.isdoa = true;
          scope.isFormDisable = true;
          if (scope.form.dod) {
            scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
          }
        } else {
          scope.isdoa = scope.todaysDate <= scope.form.doa ? false : true;
          scope.isFormDisable = scope.isdoa;
          if (scope.form.dod) {
            scope.isdod = scope.form.dod >= scope.form.doa ? false : true;
          }
        }
      } else if (type === 'dod') {
        var currentMonth = scope.todaysDate.getMonth() + 2;
        var selectedMonth = scope.form.doa.getMonth();
        if (currentMonth < selectedMonth) {
          scope.isdoa = true;
          scope.isFormDisable = true;
          scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
        } else {
          scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
          if (scope.form.doa) {
            scope.isdoa = scope.todaysDate <= scope.form.doa ? false : true;
            if (!scope.isdoa) {
              scope.isdoa = scope.form.dod < scope.form.doa ? true : false;
            }
          }
        }
      }
    };
    scope.lstQuestions = [];
    scope.isSelectedValue = true;
    scope.getQuestionData = function (item, action) {
      if (!action) {
        scope.updatedQuestionData = [];
      }
      scope.currentClaimData = item;
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/riclaims/getquestions', '', 'GET').then(function (response) {
        if (response.data.isSuccess) {
          angular.element('#rmQuestionModel').modal('show');
          scope.lstQuestions = response.data.lstQuestions;
          angular.forEach(scope.lstQuestions, function (v, i) {
            if (v.answersEntity) {
              angular.forEach(v.answersEntity, function (v1, i1) {
                if (scope.updatedQuestionData && scope.updatedQuestionData.length > 0) {
                  scope.lstQuestions[i].isRemarkOpen = true;
                  if (_.first(scope.updatedQuestionData).quesID === v.id && _.first(scope.updatedQuestionData).ansID === v1.answerID) {
                    scope.lstQuestions[i].answersEntity[i1].checked = true;
                    scope.lstQuestions[i].userInput = _.first(scope.updatedQuestionData).remarks;
                    scope.lstQuestions[i].update = true;
                    scope.lstQuestions[i].updateId = _.first(scope.updatedQuestionData).id;
                    scope.lstQuestions[i].claimId = _.first(scope.updatedQuestionData).referenceID;
                    scope.lstQuestions[i].isRemarkOpenText = v1.answerID === 426 ? 'IP number' : 'Remarks';
                    scope.isSelectedValue = false;
                  } else {
                    scope.lstQuestions[i].answersEntity[i1].checked = false;
                  }
                } else {
                  scope.isSelectedValue = true;
                  scope.lstQuestions[i].update = false;
                  scope.lstQuestions[i].isRemarkOpen = false;
                  if (v1.answerContent.toLowerCase() === 'yes') {
                    scope.lstQuestions[i].answersEntity[i1].checked = false;
                  } else {
                    scope.lstQuestions[i].answersEntity[i1].checked = false;
                  }
                }

              });
            }
          });
        }
      });
    };
    scope.getUpdatedQuestionData = function (adada) {
      id = [parseInt(adada.claimId)];
      var data = {
        claimIds: id,
        teamType: 'hospInvestigation'
      }
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/riclaims/ccinvestigation', data, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          scope.updatedQuestionData = response.data.lstProclaimCcInvestigation;
          scope.getQuestionData(_.first(scope.updatedQuestionData).referenceID, 'update')
        }
      });

    };
    scope.handleRadioClick = function (data, index, item) {
      scope.isSelectedValue = false;
      angular.forEach(scope.lstQuestions, function (v, i) {
        if (v.id === item.id) {
          angular.forEach(v.answersEntity, function (v1, i1) {

            scope.lstQuestions[i].isRemarkOpen = true;
            if (i1 === index) {
              scope.lstQuestions[i].isRemarkOpenText = v1.answerID === 426 ? 'IP number' : 'Remarks';
              scope.lstQuestions[i].userInput = '';
              scope.lstQuestions[i].answersEntity[i1].checked = true;
            } else {
              scope.lstQuestions[i].answersEntity[i1].checked = false;
            }
          })
        }
      });
    };

    scope.savermQuestion = function (dadad) {
      scope.dummyQuestion = [];
      angular.forEach(scope.lstQuestions, function (v, i) {
        angular.forEach(v.answersEntity, function (v1, i1) {
          if (v1.checked === true) {
            var data = {
              id: v.update === true ? v.updateId : 0,
              referenceID: v.update === true ? v.claimId : parseInt(scope.currentClaimData.claimId),
              teamtype: 21,
              teamtypeName: v.team,
              quesID: v.id,
              questext: v.questionText,
              ansID: v1.answerID,
              answer: v1.answerContent,
              isActive: true,
              remarks: v.userInput,
              loginName: UserService.getUserObj().userName
            }
            scope.dummyQuestion.push(data);
          }
        });

      });

      var data = {
        lstProclaimQueAnsDetails: scope.dummyQuestion,
        loginName: UserService.getUserObj().userName
      }
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/riclaims/updatequeansdetails', data, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          angular.forEach(scope.preauthfilteredStatusFiltered, function (v, i) {
            if (_.first(scope.dummyQuestion).referenceID === parseInt(v.claimId)) {
              scope.preauthfilteredStatusFiltered[i].isAnswerSubmitted = true;
            }
          })
          angular.element('#rmQuestionModel').modal('hide');
          UtilitiesService.showAlertMessage('Question submitted successfully.', true);
        } else {

        }
      });
    };

    scope.markDND = function () {
      var data = {
        EsalesId  : request.esalesId,
        requestID: request.id,
        dndInfo: {
          DNDReason: '',
          DND: false,
          DNDCustomer: true
        }
      };
    };

    scope.getMappedpackages();
    var dataTableTimeout = $timeout(function(){
      scope.initializeDataTable(scope.tabtype);  
    }, 1000);

    scope.$on('$destroy', function(){
      $timeout.cancel(dataTableTimeout);
    })

  }]);

angular.module('mbplus')
.controller('qcDetailsCtrl', ['$rootScope', '$scope', 'UtilitiesService', function ($rootScope, scope, UtilitiesService) {
  scope.apptDetails = scope.appointmentDetail;
  scope.compareDate = UtilitiesService.compareDate;
  scope.actionColors = {
    "Create": "plus",
    "MACancel": "remove-sign",
    "UserCancel": "minus-sign",
    "Confirm": "ok",
    "InsurerApprove": "ok",
    "Reschedule": "calendar",
    "Cancel": "remove",
    "Submit": "paperclip",
    "Attended": "ok",
    "NotAttended": "remove",
    "Raise_IA": "bullhorn",
    "Approve": "ok",
    "notattended": "glyphicon-off",
    "Fit": "thumbs-up",
    "UnFit": "thumbs-down",
    "SwitchDC": "plus",
    "Reschedule": "calendar",
    "UnApprovedNewAppointment": "plus",
    "Raise_IA": "bullhorn",
    "QCApprove": "ok",
    "Split Request": "scissors"
  };
  scope.statusColors = {
    22: "btn-success",
    23: "btn-success",
    24: "btn-success",
    25: "btn-success",
    26: "btn-danger",
    27: "btn-danger",
    28: "btn-danger",
    29: "btn-warning",
    30: "btn-warning",
    31: "btn-warning",
    32: "btn-success",
    33: "btn-warning",
    34: "btn-success",
    35: "btn-danger",
    36: "btn-success",
    37: "btn-success",
    38: "btn-warning",
    39: "btn-danger",
    40: "btn-warning",
    41: "btn-warning",
    42: "btn-warning",
    43: "btn-danger",
    49: "btn-success",
    112: "btn-warning",
    113: "btn-danger"
  }

  scope.statusTextColors = {
    22: "text-success",
    23: "text-success",
    24: "text-success",
    25: "text-success",
    26: "text-danger",
    27: "text-danger",
    28: "text-danger",
    29: "text-warning",
    30: "text-warning",
    31: "text-warning",
    32: "text-success",
    33: "text-warning",
    34: "text-success",
    35: "text-danger",
    36: "text-success",
    37: "text-success",
    38: "text-warning",
    39: "text-danger",
    40: "text-warning",
    41: "text-warning",
    42: "text-warning",
    43: "text-danger",
    49: "text-success",
    112: "text-warning",
    113: "text-danger"
  }
  scope.openActionModal = function (request, currentAction) {
    scope.$parent.openActionModal(currentAction.action, request.currentStatusId, currentAction.actionStatusId, request.requestId, request.fulfillmentDate, request.fulfillmentDate, '');
  };

}]);
angular.module('mbplus')
.controller('paginationCtrl', ['$rootScope', '$scope', function ($rootScope, $scope) {

}]);
angular.module('mbplus')
  .controller('angularTabsCtrl', ['$rootScope', '$scope', 'UserService', '$location', '$log', 'UtilitiesService', '$http', '$timeout', '$filter',
    'FileUploadService', 'ClaimActionService', 'NewAdmissionFormService', 'filterFilter', 'blockUI', 'PlusUtilitiesService',
    '$state', 'ClaimActionService', '$q', 'ngDialog', 'Upload',
    function (rootScope, scope, UserService, $location, $log, UtilitiesService, $http, $timeout, filter, FileUploadService, ClaimActionService, NewAdmissionFormService, filterFilter, blockUI, PlusUtilitiesService, state, ClaimActionService, $q, ngDialog, Upload) {
      scope.ctrlName = "tabCtrl";
      scope.blockUIState = blockUI.state();
      scope.tab1show = true;
      scope.showAllAppointments = true;
      scope.form = {};
      scope.compareDate = UtilitiesService.compareDate;
      scope.formatTime = UtilitiesService.formatTime;
      scope.getDateObj = UtilitiesService.getDateObj;
      scope.getDDMMYYYY = UtilitiesService.getDDMMYYYY;
      scope.formatCurrency = UtilitiesService.formatCurrency;
      scope.downloadUrl = UtilitiesService.getDMSHostUrl();
      scope.DMSUrl = UtilitiesService.getDMSHostUrl();
      scope.tabsData = [];    
      scope.userObject = UserService.getUserObj();
      scope.configuredPayerExtensionFields = UtilitiesService.getPayerExtensionFields();
      scope.resetDischargeObject = function () {
        scope.discharge = {
          doa: '',
          dod: '',
          roomrent: '',
          investigation: '',
          consultation: '',
          pharmacy: '',
          pkgname: '',
          pkgcost: '',
          others: '',
          total: '',
          remarks: '',
          claimId: ''
        }
      }

      scope.resetDischargeObject();
      scope.user = UserService.getUserObj();
      if (!scope.user) {
        UserService.destroyUserObj();
        $location.path('/');
      }

      scope.open2 = function () {
        scope.popup2.opened = true;
      };
      scope.open1 = function () {
        scope.popup1.opened = true;
      };
      scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
      scope.format = scope.formats[0];
      scope.altInputFormats = ['M!/d!/yyyy'];

      scope.popup2 = {
        opened: false
      };
      scope.popup1 = {
        opened: false
      };
      scope.isCmsUser = false;
      scope.currentStatusId = "";
      scope.financeLogin = false;
      scope.managerLogin = false;
      scope.isInsurerAction = false;
      scope.medibizProviderId = 158749;
      scope.pharmaProviderId = 72326;

      if (scope.user.rolesFeatures.roles.length == 1) {
        angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
          if (v.roleId == 9205) {
            scope.financeLogin = true;
          } else if (v.roleId == 9204) {
            scope.managerLogin = true;
            scope.financeLogin = false;
            return;
          } else if (v.roleId == 9207 || v.roleId == 9211 || v.roleId == 9214 || v.roleId == 9217) { //insurer admin -- insurer-agent -- insurer branch  -- insurer-ma-report
            scope.isInsurerAction = true;
          } else if (v.roleId === 9216) {
            scope.isCmsUser = true;
          }
        })
      }
      scope.isInsurer = true;
      angular.forEach(scope.user && scope.user.rolesFeatures.roles, function (v, i) {
        if (v.roleId == 9207 || v.roleId == 9211 || v.roleId == 9214) {
          scope.isInsurer = false;
        }
      });
      angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {

      });
      angular.forEach(scope.user && scope.user.rolesFeatures.roles, function (v, i) {
        if (v.roleId == 9204) {
          scope.managerLogin = true;
        }
      });
      scope.tabs = [{
          title: scope.tabname,
          content: 0
        }],
        selected = null,
        previous = null;
      scope.selectedIndex = 0;
      scope.selectedAppointmentsIndex = 0;
      scope.user = UserService.getUserObj();
      scope.user = {
        role: ''
      };
      if (UserService.getUserObj()) {
        scope.userRoles = UserService.getUserObj().rolesFeatures.roles;
        if (scope.userRoles.length > 1) {
          angular.forEach(scope.userRoles, function (value, key) {
            if (value.roleName === 'cms') {
              scope.user.role = 'CMS';
            }
          });
        } else {
          scope.user.role = scope.userRoles[0].roleName === 'cms' ? 'CMS' : '';
        }
      }
      if (UserService.getUserObj()) {
        scope.username = UserService.toTitleCase(UserService.getUserObj().userName ? UserService.getUserObj().userName : UserService.getUserObj().firstName);
      }
      scope.totalItems = scope.preauthfiltered == undefined ? 50 : scope.preauthfiltered.length;
      scope.pagination = {
        currentPage: 1
      }
      scope.currentPage = 1;
      scope.pagination.currentPage = 1;
      scope.itemsPerPage = 10;
      scope.maxSize = 5;
      scope.file = {};
      scope.search = 'All';
      scope.userRole = UserService.displayThis;
      scope.getToUpperCase = UtilitiesService.getToUpperCase;
      scope.getToLowerCase = UtilitiesService.getToLowerCase;
      scope.getAge = UtilitiesService.getAge;
      scope.contracts = PlusUtilitiesService.getContracts();

      scope.$watch('preauthfiltered', function (current, old) {
        if (current != old) {
          scope.preauthfilteredStatusFiltered = _.uniq(scope.preauthfiltered);
          // scope.totalItems = scope.preauthfilteredStatusFiltered.length;
          //scope.preauthfilteredStatusFiltered = scope.preauthfiltered;
          scope.totalItems = scope.preauthfiltered.allRecordCount === 'govt' ? scope.preauthfiltered.length : scope.preauthfiltered.allRecordCount;
          scope.uniquePreauthStatus = current.map(function (item) {
            return item.status
          }).filter(function (elem, idx, arr1) {
            return arr1.indexOf(elem) >= idx;
          });
        }
      });

      //Call controller function
      scope.pageChanged = function (value, type) {
        if (type === true) {
          scope.callBackSecondFn({
            arg: 'Active claim',
            flag: false,
            tpaId: scope.tpaid,
            page: value
          });
        } else if (type === false) {
          scope.currentPage = value;
          scope.pagination.currentPage = 1;
        }
      };

      scope.getActiveClaims = function (value, type) {
        if (type === true) {
          scope.callBackSecondFn({
            arg: 'Active claim',
            flag: false,
            tpaId: scope.tpaid,
            page: value
          });
        } else if (type === false) {
          scope.currentPage = value;
          scope.pagination.currentPage = 1;
        }
      };

      scope.calcDischargeTotal = function (term) {
        scope.discharge.total = 0;
        var inv = scope.discharge.investigation ? parseInt(scope.discharge.investigation) : 0;
        var pharmacy = scope.discharge.pharmacy ? parseInt(scope.discharge.pharmacy) : 0;
        var room = scope.discharge.roomrent ? parseInt(scope.discharge.roomrent) : 0;
        var consult = scope.discharge.consultation ? parseInt(scope.discharge.consultation) : 0;
        var others = scope.discharge.others ? parseInt(scope.discharge.others) : 0;
        var pkgcost = scope.discharge.pkgcost ? parseInt(scope.discharge.pkgcost) : 0;

        scope.discharge.total = inv + pharmacy + room + consult + others + pkgcost;
      }

      scope.changeIndex = function (index) {
        scope.selectedIndex = index;
      };
      scope.$watch('selectedIndex', function (current, old) {
        if (current !== old) {
          if (current === 0) {
            scope.tab1show = true;
          } else {
            scope.tab1show = false;
            //scope.addTab(scope.tabs[current].content, '', scope.tabs[current].title);
          }
          previous = selected;
          selected = scope.tabs[current];
        } else {}
      });
      scope.$watch('selectedAppointmentsIndex', function (current, old) {
        if (current != old) {
          if (current == 0) {
            scope.tab1show = true;
          } else {
            scope.tab1show = false;
          }
          previous = selected;
          selected = scope.tabs[current];
        } else {}
      });
      scope.form = {};
      scope.isFlag = {
        btnSubmitflag: false
      };
      scope.fileUploadRelatedMethods = (function () {
        scope.form = {}
        scope.form.fileNames = [];
        scope.form.fileUploadFolderPath = [];
        return {
          uploadFiles: function (source, callback) {
            scope.form.fileNames = [];
            scope.form.fileUploadFolderPath = [];
            var fileBlobArray = [];
            var filesUploadingArray = [];
            Object.keys(scope.file).forEach(function (ele) {
              if (typeof (scope.file[ele].model) == "object") {
                filesUploadingArray.push(scope.file[ele].model);
              }
            });
            if (filesUploadingArray.length > 0) {
              fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
              scope.btnSubmitflag = true;
              scope.isFlag.btnSubmitflag = true;
            } else if (source === 'iRrelatedMethods' || source === 'dischargeRelatedMethods' || source === 'enhancementRelatedMethods') {
              scope.btnSubmitflag = false;
              scope.isFlag.btnSubmitflag = false;
              alert('Please attach atleast one document.');
              return false;
            }
            $q.all(fileBlobArray).then(function (result) {
                scope.form.finalFilesData = [];
                result.forEach(function (element) {
                  if (element.data.isSuccess) {
                    angular.forEach(element.data.uploadResponseDetails, function (e, i) {
                      scope.form.finalFilesData.push({
                        fileName: e.fileName,
                        docPath: e.downloadURL
                      });
                      scope.form.fileNames.push(e.fileName);
                      scope.form.fileUploadFolderPath.push(e.downloadURL);
                    });
                  } else {
                    scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                    return false;
                  }
                  scope.file = [];
                });
                if (result && (filesUploadingArray.length == 0 || scope.form.fileNames.length == result[0].data.uploadResponseDetails.length))
                  switch (source) {
                    case 'iRrelatedMethods':
                      callback.call(scope.iRrelatedMethods);
                      break;
                    case 'dischargeRelatedMethods':
                      callback.call(scope.dischargeRelatedMethods);
                      break;
                    case 'enhancementRelatedMethods':
                      callback.call(scope.enhancementRelatedMethods)
                      break;
                  }
              },
              function (error) {
                scope.file = [];
                scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
              })
          },
          addFiles: function () {
            scope.fileCountObj.push({
              "name": 'myfile' + (scope.fileCountObj.length + 1)
            });
          },
          removeFiles: function (index) {
            if (scope.fileCountObj.length > 1) {
              scope.fileCountObj.splice(index, 1)
            }

          }

        }

        function fileUploadSuccess(successData) {
          if (successData.data.isSuccess) {
            scope.form.fileNames.push(successData.data.uploadResponseDetails[0].fileName);
            scope.form.fileUploadFolderPath.push(successData.data.uploadResponseDetails[0].downloadURL)
            UtilitiesService.showAlertMessage('File uploaded successfully.');
          }
        }

        function fileUploadError(errordata) {
          aUtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        }
      })();

      scope.enhance = {
        amount: '',
        remarks: '',
        comment: '',
        doa:null,
        dod:null
      }
      scope.claimSubmission={
        remarks:''
      }
      scope.openIrModal = function () {
        scope.isFlag.btnSubmitflag = false;
        scope.enhance.comment = '';
        scope.IrSubmissionClaimNo = scope.claimNoData.claimId;
        scope.actionType = 'IRSUBMISSION';
        scope.file = [];
        angular.element("#othersubmitMissing").modal('show');
      };

    scope.openEnhanceModal = function () {
      scope.govPackageData=[];    
      scope.btnSubmitflag = false;
      scope.actionType = 'ENHANCEMENT';
      scope.file = [];   
      angular.element("#otherenhanceModal").modal('show');
      
      scope.enhance.doa = scope.claimNoData.dateOfAdmission == "Today"?new Date():new Date(moment(scope.claimNoData.dateOfAdmission).format('YYYY-MM-DD'));
      scope.enhance.dod = new Date(moment(scope.claimNoData.dateOfDischarge).format('YYYY-MM-DD'));
      scope.enhance.claimId = scope.claimNoData.claimId;
      scope.enhance.amount = '';
      scope.enhance.remarks = '';
      scope.roomType=scope.claimNoData.roomType;      
      scope.getPackageList(scope.claimNoData.schemeName); 
      scope.formSchemeSelection(scope.claimNoData.schemeName,false);    
    };

    // Package Start  
    // Package list
    scope.getPackageList = function (value) {     
      var govPackage = UserService.getGovtPackageList();
      if (value) {
        var data = {
          priEntityName: '',
          priEntityId: UserService.getUserObj().entityId,
          secEntityName: 'Medi Assist',
          secEntityId: 0,
          schemeType: value
        };
        // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/packagesbtnentities/list', data, 'POST', UserService.getAccessToken()).then(function (response) {
        //   if (response.data.isSuccess) {
        //     var dataRes = response.data.packages;
        //     if (scope.roomType) {         
        //       angular.forEach(dataRes, function (e) {
        //         var key = (scope.roomType.replace(" ", "")).toLowerCase();
        //         e.packageCost = e[key];
        //         e.govPackageName = e.packageName + "," + e.packageCost;
        //       })                
        //     }
        //     angular.forEach(dataRes, function (e) {
        //       e.govPackageName = e.packageName + "," + e.packageCost;
        //     })
        //     scope.govtPackageList=dataRes;
        //   } else {
        //     scope.govtPackageList = [];
        //   }
        // });
      }      
    };
    scope.typeProcedureName = function () {
      scope.isPriceDropDown = false;
      scope.isSelectedGov = false;
    };
    scope.isSelectedGov = false;
    scope.priceForGovPackage = [];
    scope.govPackageData = [];
    scope.selectedGovPackage = '';
    scope.selectGovePackage = function (item, model) {
      scope.isSelectedGov = true;
      scope.selectedGovPackage = '';
      scope.priceForGovPackage = [];
      if (item) {
        scope.selectedGovPackage = item;
        var data = {
          price: item.packageCost
        }
        scope.priceForGovPackage.push(data);
        if (scope.priceForGovPackage.length === 1) {
          scope.govPackageManually.price = scope.priceForGovPackage[0].price;
        }
      } else {
        scope.isSelectedGov = false;
      }
    };
    scope.govPackageManually = {
      name: '',
      price: ''
    };
    //add package to list
    scope.addGovPackageManually = function (name, govPackage, flag) {
      if (scope.govPackageData.length <= 2) {
        if (flag) {        
          scope.govPackageData.push(scope.selectedGovPackage);         
          scope.isSelectedGov = false;
        } else {
          var data = {
            cappedAmount: 0,
            govPackageName: name,
            packageCost: parseInt(govPackage.price),
            packageId: 0,
            packageName: name,
            type: ''
          }
          var govtPackageList = _.where(scope.govPackageData, {
            packageName: data.packageName
          });
          if (govtPackageList.length > 0) {
            UtilitiesService.showAlertMessage('Duplicate line item is not allowed.');
          } else {
            scope.govPackageData.push(data);
          }
        }
      } else {
        UtilitiesService.showAlertMessage('Maximum of 3 packages allowed.');
      }
      scope.isSelectedGov = false;
      scope.selectedGovPackage = '';
      scope.govPackageManually.price = '';
      scope.govPackageManually.name = '';
      scope.form.govPackagesname = '';
      scope.form.clmamount = scope.totalGovClaimAmount();
      if(scope.govPackageData)
      {
        var packages=scope.govPackageData.map(function (item) {
          return item.packageName +" - "+ item.packageCost
        });
        scope.pushToProperties('Packages',packages.join());
      } 
    };
    //remove package from list
    scope.removeGovPackage = function (data) {
      if (data) {
        angular.forEach(scope.govPackageData, function (value, index) {
          if (value.packageId === data.packageId || value.packageName === data.packageName) {
            scope.govPackageData.splice(index, 1);
          }
        });
        scope.form.clmamount = scope.totalGovClaimAmount();
      }
    };
    //total amount 
    scope.noOfDays = 1;
    scope.newAdmissionFormModel = '';
    scope.totalGovClaimAmount = function () {
      scope.totalCalcAmount = 0;
      angular.forEach(scope.govPackageData, function (data, index) {
        if (data.packageCost) {
          if (data.isPerDayEligiblePackage === true) {
            var oneDay = 24 * 60 * 60 * 1000;
            var noOfDays = Math.round(Math.abs((scope.form.dod.getTime() - scope.form.doa.getTime()) / (oneDay)));
            scope.noOfDays = noOfDays;
            var isPerDayEligiblePrice = 0;
            if (noOfDays === 0) {
              isPerDayEligiblePrice = parseInt(data.packageCost)
              scope.noOfDays = 1;
            } else
              isPerDayEligiblePrice = parseInt(data.packageCost) * (noOfDays)
            scope.totalCalcAmount = scope.totalCalcAmount + isPerDayEligiblePrice;
          } else
            scope.totalCalcAmount = scope.totalCalcAmount + parseInt(data.packageCost);
        }
      });     
      return scope.totalCalcAmount;
    };
    scope.pushToProperties = function (name, value) {
      if (name && value && ((typeof value == 'object' && !Array.isArray(value)) || (value.length > 0) || typeof value != 'object')) {
        if (!scope.formProperties) {
          scope.formProperties = [];
        }
        if (scope.formProperties && scope.formProperties.length > 0) {
          scope.formProperties = scope.formProperties.filter(function (ele) {
            return ele.fieldName != name;
          });
        }
        var payerField = scope.payerExtraFileldsList.find(function (element) {
          return element.name.toLowerCase() == name.toLowerCase()
        });
        scope.formProperties.push({
          fieldName: name,
          fieldValue: value,
          isMaster: payerField ? payerField.isMaster : false
        });
        } else if (name && !value || (value && value.length == 0)) {
        if (scope.formProperties && scope.formProperties.length > 0) {
          scope.formProperties = scope.formProperties.filter(function (ele) {
            return ele.fieldName != name;
          });
        }
      }      
    };
 
    scope.formSchemeSelection = function (item, value) {
      scope.newAdmissionFormModel = item;
      angular.forEach(scope.govtSchemeType, function (value, index) {
        if (value.name === item)
          scope.govtSchemeType[index].selected = true;
        else
          scope.govtSchemeType[index].selected = false;
      });
      scope.form.isgovtscheme = true;
      scope.form.govtSchemeName = item;     
      scope.getPackageList(item)
      if (scope.configuredPayerExtensionFields && scope.configuredPayerExtensionFields.length > 0) {
        var fieldsList = scope.configuredPayerExtensionFields.filter(function (element) {
          return element.schemeCode == item;
        });
        scope.payerExtraFileldsList = fieldsList.map(function (a) {
          return {
            name: a.fieldName,
            isMaster: false
          }
        });
      }
    };  
  
    //End Package 

    scope.openClaimSubmissionModal = function () {
      
        scope.btnSubmitflag = false;
        scope.claimSubmission.remarks = '';
        scope.actionType = 'CLAIMSUBMISSION';
        scope.file = [];
        angular.element("#otherClaimSubmissionModal").modal('show');
      };
      scope.openDischargeModal = function () {
        scope.isFlag.btnSubmitflag = false;
        scope.resetDischargeObject();
        angular.element("#otherdischargeModal").modal('show');
        scope.file = [];
        scope.actionType = 'DISCHARGE';
        scope.discharge.doa = new Date(moment(scope.claimNoData.dateOfAdmission).format('YYYY-MM-DD'));
        scope.discharge.dod = new Date(moment(scope.claimNoData.dateOfDischarge).format('YYYY-MM-DD'));
        scope.discharge.claimId = scope.claimNoData.claimId;
      };
      scope.file = [];
      scope.addFileToUpload = function () {
        var newItemNo = scope.file.length + 1;
        scope.file.push({
          'model': ''
        });
      };
      scope.removeFileToUpload = function () {
        var lastItem = scope.file.length - 1;
        scope.file.splice(lastItem);
        scope.validLargeDoc = false;
      };
      //scope.addFileToUpload();

      //scope.submitDischarge = function () {
      //    scope.fileUploadRelatedMethods.uploadFiles("dischargeRelatedMethods", function () {
      //        ClaimActionService.submitDischarge(this.relatedData()).then(dischargeSubmitSuccess, dischargeSubmitError)
      //    });
      //};
      scope.RemoveEmail = function (index) {
        if (scope.file[index] != undefined && scope.file[index] != null) {
          scope.file.splice(index, 1);
        };
      };
      scope.uploadAllFiles = function (file, type) {
        if (file && file.files) {
          if (!scope.file) {
            scope.file = [];
          }

          angular.forEach(file.files, function (data) {
            var i = scope.file.length + 1;
            scope.file.push({
              fileName: data.name,
              fileObject: data,
              progressBar: null,
              progressDivId: 'progressDiv' + type + i,
              docPath: ''
            });
          })
          angular.forEach(scope.file, function (object) {
            if (!object.docPath)
              scope.UploadFileToDMS(object.fileObject, object);
          })
        }
      };      
      
      scope.UploadFileToDMS = function (file, object) {
        Upload.upload({
          url: UtilitiesService.getUrlPrefix() + '/hosp/file/DMS/upload',
          file: file
        }).then(function (res) {
            if (res.data.isSuccess) {
              uploadResponse = res.data.uploadResponseDetails;
              object.docPath = UtilitiesService.getDMSHostUrl() + "/" + uploadResponse[0].downloadURL

            }
          },
          function (error) {},
          function (evt) {
            // var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            // console.log('progress: ' + progressPercentage + '% ');
            var element = angular.element(document.querySelector('#' + object.progressDivId));
            // console.log(element);

            object.progressBar = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            element.html('<div style="width: ' + object.progressBar + '%">' + object.progressBar + '%</div>');
          })
        // if(file.files && typeof(file.files)=="object")
        // {
        //   scope.startLoading('Uploading files','AttachmentArray')
        //   FileUploadService.uploadFileToUrl(file.files).onProgress(function(res){
        //     if(res)
        //     {
        //       ;
        //     }
        //   }).then(function(res){
        //     if(res.data.isSuccess)
        //     {
        //       uploadResponse=res.data.uploadResponseDetails;
        //       if(!scope.file)
        //       {
        //         scope.file=[];
        //       }

        //       angular.forEach(uploadResponse,function(value){
        //         scope.file.push({"fileName":value.fileName,"docPath":UtilitiesService.getDMSHostUrl()+"/"+ value.downloadURL});
        //       });

        //       scope.stopLoading('AttachmentArray');
        //     }
        //   },function(error){}, function (evt) {
        //     ;
        //     var element = angular.element(document.querySelector('#dvProgress'));
        //     scope.Progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        //     element.html('<div style="width: ' + scope.Progress + '%">' + scope.Progress + '%</div>');
        // })
        // }
      };

      scope.submitIr = function () {
        var attachment = [];
        angular.forEach(scope.file, function (data) {
          attachment.push({
            "fileName": data.fileName,
            "docPath": data.docPath
          });
        })

        var ajxData = {
          parentId: scope.claimNoData.tableId,
          remarks: scope.enhance.comment,
          actionBy: UserService.getUserObj().userId,
          attachedFiles: attachment,
          tpaClaimId: scope.IrSubmissionClaimNo && scope.IrSubmissionClaimNo != scope.claimNoData.claimId ? scope.IrSubmissionClaimNo : null,
          hospTPAID: scope.claimNoData.tpaId,
          schemeName:scope.claimNoData.schemeName
        }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tpa/infosubmit', ajxData, 'POST').then(function (response) {

          if (response.data.isSuccess) {
            scope.file = [];
            angular.element("#othersubmitMissing").modal('hide');
            UtilitiesService.showAlertMessage('Your documents submitted successfully.', true);
          } else {
            UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
          }
        }, function (error) {
          UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
        });

      };

      //POST Enhancement Request
      scope.submitEnhance = function () {
        var attachment = [];
        angular.forEach(scope.file, function (data) {
          attachment.push({
            "fileName": data.fileName,
            "docPath": data.docPath
          });
        });
       
        var ajxData = {
          parentId: scope.claimNoData.tableId,
          claimAmount: scope.totalGovClaimAmount(),//scope.enhance.amount,
          remarks: scope.enhance.remarks,
          actionBy: UserService.getUserObj().userId,
          attachedFiles: attachment,
          tpaClaimId: scope.enhance.claimId && scope.enhance.claimId != scope.claimNoData.claimId ? scope.enhance.claimId : null,
          hospTPAID: scope.claimNoData.tpaId,
          dod:scope.enhance.dod,
          extensionFields: scope.formProperties && scope.formProperties.length > 0 ? scope.formProperties : null,
          packages: scope.govPackageData.map(function (item) {            
            return item.packageId
          }),
          schemeName: scope.claimNoData.schemeName
        }
        ///hosp/tpa/enhancement
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tpa/enhancement', ajxData, 'POST').then(function (response) {
          if (response.data.isSuccess) {
            scope.file = []
            angular.element("#otherenhanceModal").modal('hide');
            UtilitiesService.showAlertMessage('Your enhancement request has been submitted successfully.', true);
            scope.addTab();
          } else {
            UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
          }
        }, function (error) {
          UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
        });
      };
      scope.uploadAllFiles = function (file) {
        if (file && file.files) {
          if (!scope.file) {
            scope.file = [];
          }

          angular.forEach(file.files, function (data) {
            var i = scope.file.length + 1;
            scope.file.push({
              fileName: data.name,
              fileObject: data,
              progressBar: null,
              progressDivId: 'progressDiv' + i,
              downloadPath: '',
              docPath: ''
            });
          })

          angular.forEach(scope.file, function (object) {
            if (!object.docPath)
              scope.UploadFileToDMS(object.fileObject, object);
          })

        }
      }
      scope.getUnprocessedClaims = function () {
        scope.currentPage = 1;
        scope.paginationTab = 'InProgress';
        scope.callBackSecondFn({
          arg: 'InProgress',
          flag: false,
          tpaId: scope.tpaid,
          page: scope.currentPage
        });
      };

      
      scope.UploadFileToDMS = function (file, object) {
        Upload.upload({
          url: UtilitiesService.getUrlPrefix() + '/hosp/file/DMS/upload',
          file: file
        }).then(function (res) {
            if (res.data.isSuccess) {
              uploadResponse = res.data.uploadResponseDetails;
              object.downloadPath = UtilitiesService.getDMSHostUrl() + "/" + uploadResponse[0].downloadURL;
              object.docPath = uploadResponse[0].downloadURL;
            }
          },
          function (error) {},
          function (evt) {
            // var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            // console.log('progress: ' + progressPercentage + '% ');
            var element = angular.element(document.querySelector('#' + object.progressDivId));
            object.progressBar = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            element.html('<div style="width: ' + object.progressBar + '%">' + object.progressBar + '%</div>');
          })
        // if(file.files && typeof(file.files)=="object")
        // {
        //   scope.startLoading('Uploading files','AttachmentArray')
        //   FileUploadService.uploadFileToUrl(file.files).onProgress(function(res){
        //     if(res)
        //     {
        //       ;
        //     }
        //   }).then(function(res){
        //     if(res.data.isSuccess)
        //     {
        //       uploadResponse=res.data.uploadResponseDetails;
        //       if(!scope.file)
        //       {
        //         scope.file=[];
        //       }

        //       angular.forEach(uploadResponse,function(value){
        //         scope.file.push({"fileName":value.fileName,"docPath":UtilitiesService.getDMSHostUrl()+"/"+ value.downloadURL});
        //       });

        //       scope.stopLoading('AttachmentArray');
        //     }
        //   },function(error){}, function (evt) {
        //     ;
        //     var element = angular.element(document.querySelector('#dvProgress'));
        //     scope.Progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        //     element.html('<div style="width: ' + scope.Progress + '%">' + scope.Progress + '%</div>');
        // })
        // }
      }
      //POST Enhancement Request
      scope.submitDischarge = function () {

        var attachment = [];

        angular.forEach(scope.file, function (data) {
          attachment.push({
            "fileName": data.fileName,
            "docPath": data.docPath
          });
        })

        var ajxData = {
          parentId: scope.claimNoData.tableId,
          dischargeNotes: scope.discharge.remarks,
          actionBy: UserService.getUserObj().userId,
          attachedFiles: attachment,
          doa: scope.discharge.doa,
          dod: scope.discharge.dod,
          roomRentCharges: scope.discharge.roomrent,
          diagnosticCharges: scope.discharge.investigation,
          professionalCharges: scope.discharge.consultation,
          pharmacyCharges: scope.discharge.pharmacy,
          otherCharges: scope.discharge.others,
          finalClaimedAmount: scope.discharge.total,
          tpaClaimId: scope.discharge.claimId && scope.discharge.claimId != scope.claimNoData.claimId ? scope.discharge.claimId : null,
          hospTPAID: scope.claimNoData.tpaId
        }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tpa/dischargedocs', ajxData, 'POST').then(function (response) {

          if (response.data.isSuccess) {
            scope.file = [];
            angular.element("#otherdischargeModal").modal('hide');
            scope.resetDischargeObject();
            scope.addTab();
            UtilitiesService.showAlertMessage('Your discharge request has been submitted successfully.', true);
          } else {
            UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
          }
        }, function (error) {
          UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
        });
      };

      scope.submitClaimSubmission = function () {

        var attachment = [];
        angular.forEach(scope.file, function (data) {
          attachment.push({
            "fileName": data.fileName,
            "docPath": data.docPath
          });
        })
        var data = {
          parentId: scope.claimNoData.tableId,
          claimId: scope.claimNoData.claimId ? scope.claimNoData.claimId : null,
          fileNames: attachment,
          providerId:UserService.getUserObj().entityId,
          claimedAmount: scope.claimNoData.claimedAmount,
          createdBy: UserService.getUserObj().userId,
          schemeName: scope.claimNoData.schemeName,
          tpaId: scope.claimNoData.tpaId,
          remarks: scope.claimSubmission.remarks
        }

        // var ajxData = {
        //   parentId: scope.claimNoData.tableId,
        //   dischargeNotes: scope.discharge.remarks,
        //   actionBy: UserService.getUserObj().userId,
        //   attachedFiles: attachment,
        //   doa: scope.discharge.doa,
        //   dod: scope.discharge.dod,
        //   roomRentCharges: scope.discharge.roomrent,
        //   diagnosticCharges: scope.discharge.investigation,
        //   professionalCharges: scope.discharge.consultation,
        //   pharmacyCharges: scope.discharge.pharmacy,
        //   otherCharges: scope.discharge.others,
        //   finalClaimedAmount: scope.discharge.total,
        //   tpaClaimId: scope.discharge.claimId && scope.discharge.claimId != scope.claimNoData.claimId ? scope.discharge.claimId : null,
        //   hospTPAID: 0
        // }
        ClaimActionService.claimSubmission(data).then(function (response) {
          if (response.data.isSuccess) {
            scope.file = [];
            angular.element("#otherClaimSubmissionModal").modal('hide');
            // scope.resetDischargeObject();
            scope.addTab();
            UtilitiesService.showAlertMessage('Your discharge request has been submitted successfully.', true);
          } else {
            UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
          }
        }, function (error) {
          UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
        });
      };

      //Add new tab
      scope.addTab = function (item) {
        var claimNo
        var view
        var patientName
        if (item) {          
          scope.claimNoData = item;
          claimNo = item.tableId;
          view = item.id;
          patientName = item.patientName;
        } else {
          claimNo = scope.claimNoData.tableId;
          view = scope.claimNoData.id;
          patientName = scope.claimNoData.patientName;
        }

        // if (item.status !== 'New Admission' && item.status !== 'Denied') {
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tpa/claimaudittrail/' + claimNo + '', '', 'GET').then(function (response) {
          if (response.data.isSuccess) {
            scope.claimSearhByClaimIdResults = response.data.claimAuditTrailData;
            var length = scope.claimSearhByClaimIdResults.length;
            scope.statusData = scope.claimSearhByClaimIdResults[length - 1];
            scope.documents = [];
            angular.forEach(scope.claimSearhByClaimIdResults, function (data, index) {
              if (data.documents && data.documents.length > 0) {
                angular.forEach(data.documents, function (value, index1) {
                  scope.documents.push({
                    docPath: value.docPath,
                    fileName: value.fileName
                  });
                })
              }
            });
            scope.tabsData.push(response.data.claimAuditTrailData);
            scope.openTab(patientName, view, false);
          } else {
            UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
          }
        }, function (error) {
          UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
        });
        // } 
        // else {
        //     if (item.status === 'Denied') {

        //     } else if (item.status === 'New Admission') {
        //         UtilitiesService.showAlertMessage('Dear customer,we have received your claim and have started processing it.\n\n You will see more details here shortly.', true);
        //     }
        // }
      };


      scope.openTab = function (title, view, showTab) {
        scope.tab1show = showTab;
        view = view || title + " Content View";
        scope.tabs.push({
          title: title,
          content: view
        });
        scope.tabs[scope.tabs.length - 1].active = true;
        scope.selectedIndex = scope.tabs.length - 1;
      };

      scope.removeTab = function (tab) {
        if (tab > 0) {
          scope.tabs.splice(tab, 1);
          scope.tabsData.splice(tab - 1, 1);
          scope.selectedIndex = scope.selectedIndex > 0 ? scope.selectedIndex - 1 : scope.selectedIndex;
          scope.tabs[scope.selectedIndex].active = true;
        }
      };

      scope.getPatientDetails = function () {
        return details = {
          name: scope.name,
          requestId: scope.id,
          indexNo: scope.tabs.length - 1
        }
      }
      scope.res = {};
      scope.resId = "";
      scope.showPostToPharma = false;
      scope.activeClaim = function (index, tabname) {
        scope.selectedIndex = index;
        if (tabname === 'Active Claims') {
          scope.callBackSecondFn({
            arg: 'Active claim',
            flag: false
          });
        }
      };

      scope.$on('closeUpateClaimInfoDialog', function (key, value) {
        scope.updateClaimInfoDialog.close();
        scope.currentPage = 1;
        scope.callBackSecondFn({
          arg: 'Active claim',
          flag: false,
          tpaId: scope.tpaid
        });

      });
      scope.updateOtherTpaClaimInfo = function (value) {
        scope.updateClaimInfoDialog = ngDialog.open({
          template: 'app/components/tpaConfiguration/updateClaimInfo.html',
          
          data: value,
          controller: 'updateClaimInfoCtrl'
        });
      }




      scope.resendMail = function (item, isReminder) {
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/OtherTPAResendMail', {
          hospActionAuditId: item.hospActionAuditId,
          isReminder: isReminder ? isReminder : false
        }, 'POST').then(function (response) {
          if (response.data.isSuccess) {
            item.isCommMailSent = true;
          }
        });
      }

    }
  ]);

angular.module('mbplus')
  .controller('newAdmissionFormCtrlCataract', ['$scope', '$location', '$state', '$timeout', 'UserService', 'UtilitiesService', 'filterFilter', '$uibModal', 'FastrackService', 'GovernmentService', 'FileUploadService', 'NewAdmissionFormService', '$analytics', '$q', 'blockUI', 'navConstantsSvc', function (scope, $location, state, timeout, UserService, UtilitiesService, filterFilter, $uibModal, FastrackService, GovernmentService, FileUploadService, NewAdmissionFormService, $analytics, $q, blockUI, navConstantsSvc) {
    $analytics.pageTrack('/newAdmissionCataract/');
    scope.ctrlName = 'newAdmissionFormCtrlCataract';
    scope.blockUIState = blockUI.state();
    if (!UserService.isActive()) {
      UserService.destroyUserObj();
      return false;
    }
    scope.ailmentDetails = [{
      "AilmentID": 262,
      "AilmentCode": "H26",
      "AilmentName": "Senile cataract LE (Left Eye)"
    }, {
      "AilmentID": 347,
      "AilmentCode": "H25",
      "AilmentName": "Senile cataract RE (Rt. Eye)"
    }, {
      "AilmentID": 2609,
      "AilmentCode": "h25.1",
      "AilmentName": "Senile cataract RE (Rt. Eye)"
    }, {
      "AilmentID": 8933,
      "AilmentCode": "H25.011",
      "AilmentName": "Cortical age-related cataract, right eye"
    }, {
      "AilmentID": 8934,
      "AilmentCode": "H25.012",
      "AilmentName": "Cortical age-related cataract, left eye"
    }, {
      "AilmentID": 8935,
      "AilmentCode": "H25.013",
      "AilmentName": "Cortical age-related cataract, bilateral"
    }, {
      "AilmentID": 8936,
      "AilmentCode": "H25.019",
      "AilmentName": "Cortical age-related cataract, unspecified eye"
    }, {
      "AilmentID": 8937,
      "AilmentCode": "H25.031",
      "AilmentName": "Anterior subcapsular polar age-related cataract, right eye"
    }, {
      "AilmentID": 8938,
      "AilmentCode": "H25.032",
      "AilmentName": "Anterior subcapsular polar age-related cataract, left eye"
    }, {
      "AilmentID": 8939,
      "AilmentCode": "H25.033",
      "AilmentName": "Anterior subcapsular polar age-related cataract, bilateral"
    }, {
      "AilmentID": 8940,
      "AilmentCode": "H25.039",
      "AilmentName": "Anterior subcapsular polar age-related cataract, unspecified eye"
    }, {
      "AilmentID": 8941,
      "AilmentCode": "H25.041",
      "AilmentName": "Posterior subcapsular polar age-related cataract, right eye"
    }, {
      "AilmentID": 8942,
      "AilmentCode": "H25.042",
      "AilmentName": "Posterior subcapsular polar age-related cataract, left eye"
    }, {
      "AilmentID": 8943,
      "AilmentCode": "H25.043",
      "AilmentName": "Posterior subcapsular polar age-related cataract, bilateral"
    }, {
      "AilmentID": 8944,
      "AilmentCode": "H25.049",
      "AilmentName": "Posterior subcapsular polar age-related cataract, unspecified eye"
    }, {
      "AilmentID": 8945,
      "AilmentCode": "H25.091",
      "AilmentName": "Other age-related incipient cataract, right eye"
    }, {
      "AilmentID": 8946,
      "AilmentCode": "H25.092",
      "AilmentName": "Other age-related incipient cataract, left eye"
    }, {
      "AilmentID": 8947,
      "AilmentCode": "H25.093",
      "AilmentName": "Other age-related incipient cataract, bilateral"
    }, {
      "AilmentID": 8948,
      "AilmentCode": "H25.099",
      "AilmentName": "Other age-related incipient cataract, unspecified eye"
    }, {
      "AilmentID": 8949,
      "AilmentCode": "H25.10",
      "AilmentName": "Age-related nuclear cataract, unspecified eye"
    }, {
      "AilmentID": 8950,
      "AilmentCode": "H25.11",
      "AilmentName": "Age-related nuclear cataract, right eye"
    }, {
      "AilmentID": 8951,
      "AilmentCode": "H25.12",
      "AilmentName": "Age-related nuclear cataract, left eye"
    }, {
      "AilmentID": 8952,
      "AilmentCode": "H25.13",
      "AilmentName": "Age-related nuclear cataract, bilateral"
    }, {
      "AilmentID": 8953,
      "AilmentCode": "H25.20",
      "AilmentName": "Age-related cataract, morgagnian type, unspecified eye"
    }, {
      "AilmentID": 8954,
      "AilmentCode": "H25.21",
      "AilmentName": "Age-related cataract, morgagnian type, right eye"
    }, {
      "AilmentID": 8955,
      "AilmentCode": "H25.22",
      "AilmentName": "Age-related cataract, morgagnian type, left eye"
    }, {
      "AilmentID": 8956,
      "AilmentCode": "H25.23",
      "AilmentName": "Age-related cataract, morgagnian type, bilateral"
    }, {
      "AilmentID": 8957,
      "AilmentCode": "H25.811",
      "AilmentName": "Combined forms of age-related cataract, right eye"
    }, {
      "AilmentID": 8958,
      "AilmentCode": "H25.812",
      "AilmentName": "Combined forms of age-related cataract, left eye"
    }, {
      "AilmentID": 8959,
      "AilmentCode": "H25.813",
      "AilmentName": "Combined forms of age-related cataract, bilateral"
    }, {
      "AilmentID": 8960,
      "AilmentCode": "H25.819",
      "AilmentName": "Combined forms of age-related cataract, unspecified eye"
    }, {
      "AilmentID": 8961,
      "AilmentCode": "H25.89",
      "AilmentName": "Other age-related cataract"
    }, {
      "AilmentID": 8962,
      "AilmentCode": "H25.9",
      "AilmentName": "Unspecified age-related cataract"
    }, {
      "AilmentID": 8963,
      "AilmentCode": "H26.001",
      "AilmentName": "Unspecified infantile and juvenile cataract, right eye"
    }, {
      "AilmentID": 8964,
      "AilmentCode": "H26.002",
      "AilmentName": "Unspecified infantile and juvenile cataract, left eye"
    }, {
      "AilmentID": 8965,
      "AilmentCode": "H26.003",
      "AilmentName": "Unspecified infantile and juvenile cataract, bilateral"
    }, {
      "AilmentID": 8966,
      "AilmentCode": "H26.009",
      "AilmentName": "Unspecified infantile and juvenile cataract, unspecified eye"
    }, {
      "AilmentID": 8967,
      "AilmentCode": "H26.011",
      "AilmentName": "Infantile and juvenile cortical, lamellar, or zonular cataract, right eye"
    }, {
      "AilmentID": 8968,
      "AilmentCode": "H26.012",
      "AilmentName": "Infantile and juvenile cortical, lamellar, or zonular cataract, left eye"
    }, {
      "AilmentID": 8969,
      "AilmentCode": "H26.013",
      "AilmentName": "Infantile and juvenile cortical, lamellar, or zonular cataract, bilateral"
    }, {
      "AilmentID": 8970,
      "AilmentCode": "H26.019",
      "AilmentName": "Infantile and juvenile cortical, lamellar, or zonular cataract, unspecified eye"
    }, {
      "AilmentID": 8971,
      "AilmentCode": "H26.031",
      "AilmentName": "Infantile and juvenile nuclear cataract, right eye"
    }, {
      "AilmentID": 8972,
      "AilmentCode": "H26.032",
      "AilmentName": "Infantile and juvenile nuclear cataract, left eye"
    }, {
      "AilmentID": 8973,
      "AilmentCode": "H26.033",
      "AilmentName": "Infantile and juvenile nuclear cataract, bilateral"
    }, {
      "AilmentID": 8974,
      "AilmentCode": "H26.039",
      "AilmentName": "Infantile and juvenile nuclear cataract, unspecified eye"
    }, {
      "AilmentID": 8975,
      "AilmentCode": "H26.041",
      "AilmentName": "Anterior subcapsular polar infantile and juvenile cataract, right eye"
    }, {
      "AilmentID": 8976,
      "AilmentCode": "H26.042",
      "AilmentName": "Anterior subcapsular polar infantile and juvenile cataract, left eye"
    }, {
      "AilmentID": 8977,
      "AilmentCode": "H26.043",
      "AilmentName": "Anterior subcapsular polar infantile and juvenile cataract, bilateral"
    }, {
      "AilmentID": 8978,
      "AilmentCode": "H26.049",
      "AilmentName": "Anterior subcapsular polar infantile and juvenile cataract, unspecified eye"
    }, {
      "AilmentID": 8979,
      "AilmentCode": "H26.051",
      "AilmentName": "Posterior subcapsular polar infantile and juvenile cataract, right eye"
    }, {
      "AilmentID": 8980,
      "AilmentCode": "H26.052",
      "AilmentName": "Posterior subcapsular polar infantile and juvenile cataract, left eye"
    }, {
      "AilmentID": 8981,
      "AilmentCode": "H26.053",
      "AilmentName": "Posterior subcapsular polar infantile and juvenile cataract, bilateral"
    }, {
      "AilmentID": 8982,
      "AilmentCode": "H26.059",
      "AilmentName": "Posterior subcapsular polar infantile and juvenile cataract, unspecified eye"
    }, {
      "AilmentID": 8983,
      "AilmentCode": "H26.061",
      "AilmentName": "Combined forms of infantile and juvenile cataract, right eye"
    }, {
      "AilmentID": 8984,
      "AilmentCode": "H26.062",
      "AilmentName": "Combined forms of infantile and juvenile cataract, left eye"
    }, {
      "AilmentID": 8985,
      "AilmentCode": "H26.063",
      "AilmentName": "Combined forms of infantile and juvenile cataract, bilateral"
    }, {
      "AilmentID": 8986,
      "AilmentCode": "H26.069",
      "AilmentName": "Combined forms of infantile and juvenile cataract, unspecified eye"
    }, {
      "AilmentID": 8987,
      "AilmentCode": "H26.09",
      "AilmentName": "Other infantile and juvenile cataract"
    }, {
      "AilmentID": 8988,
      "AilmentCode": "H26.101",
      "AilmentName": "Unspecified traumatic cataract, right eye"
    }, {
      "AilmentID": 8989,
      "AilmentCode": "H26.102",
      "AilmentName": "Unspecified traumatic cataract, left eye"
    }, {
      "AilmentID": 8990,
      "AilmentCode": "H26.103",
      "AilmentName": "Unspecified traumatic cataract, bilateral"
    }, {
      "AilmentID": 8991,
      "AilmentCode": "H26.109",
      "AilmentName": "Unspecified traumatic cataract, unspecified eye"
    }, {
      "AilmentID": 8992,
      "AilmentCode": "H26.111",
      "AilmentName": "Localized traumatic opacities, right eye"
    }, {
      "AilmentID": 8993,
      "AilmentCode": "H26.112",
      "AilmentName": "Localized traumatic opacities, left eye"
    }, {
      "AilmentID": 8994,
      "AilmentCode": "H26.113",
      "AilmentName": "Localized traumatic opacities, bilateral"
    }, {
      "AilmentID": 8995,
      "AilmentCode": "H26.119",
      "AilmentName": "Localized traumatic opacities, unspecified eye"
    }, {
      "AilmentID": 8996,
      "AilmentCode": "H26.121",
      "AilmentName": "Partially resolved traumatic cataract, right eye"
    }, {
      "AilmentID": 8997,
      "AilmentCode": "H26.122",
      "AilmentName": "Partially resolved traumatic cataract, left eye"
    }, {
      "AilmentID": 8998,
      "AilmentCode": "H26.123",
      "AilmentName": "Partially resolved traumatic cataract, bilateral"
    }, {
      "AilmentID": 8999,
      "AilmentCode": "H26.129",
      "AilmentName": "Partially resolved traumatic cataract, unspecified eye"
    }, {
      "AilmentID": 9000,
      "AilmentCode": "H26.131",
      "AilmentName": "Total traumatic cataract, right eye"
    }, {
      "AilmentID": 9001,
      "AilmentCode": "H26.132",
      "AilmentName": "Total traumatic cataract, left eye"
    }, {
      "AilmentID": 9002,
      "AilmentCode": "H26.133",
      "AilmentName": "Total traumatic cataract, bilateral"
    }, {
      "AilmentID": 9003,
      "AilmentCode": "H26.139",
      "AilmentName": "Total traumatic cataract, unspecified eye"
    }, {
      "AilmentID": 9004,
      "AilmentCode": "H26.20",
      "AilmentName": "Unspecified complicated cataract"
    }, {
      "AilmentID": 9005,
      "AilmentCode": "H26.211",
      "AilmentName": "Cataract with neovascularization, right eye"
    }, {
      "AilmentID": 9006,
      "AilmentCode": "H26.212",
      "AilmentName": "Cataract with neovascularization, left eye"
    }, {
      "AilmentID": 9007,
      "AilmentCode": "H26.213",
      "AilmentName": "Cataract with neovascularization, bilateral"
    }, {
      "AilmentID": 9008,
      "AilmentCode": "H26.219",
      "AilmentName": "Cataract with neovascularization, unspecified eye"
    }, {
      "AilmentID": 9009,
      "AilmentCode": "H26.221",
      "AilmentName": "Cataract secondary to ocular disorders (degenerative) (inflammatory), right eye"
    }, {
      "AilmentID": 9010,
      "AilmentCode": "H26.222",
      "AilmentName": "Cataract secondary to ocular disorders (degenerative) (inflammatory), left eye"
    }, {
      "AilmentID": 9011,
      "AilmentCode": "H26.223",
      "AilmentName": "Cataract secondary to ocular disorders (degenerative) (inflammatory), bilateral"
    }, {
      "AilmentID": 9012,
      "AilmentCode": "H26.229",
      "AilmentName": "Cataract secondary to ocular disorders (degenerative) (inflammatory), unspecified eye"
    }, {
      "AilmentID": 9013,
      "AilmentCode": "H26.231",
      "AilmentName": "Glaucomatous flecks (subcapsular), right eye"
    }, {
      "AilmentID": 9014,
      "AilmentCode": "H26.232",
      "AilmentName": "Glaucomatous flecks (subcapsular), left eye"
    }, {
      "AilmentID": 9015,
      "AilmentCode": "H26.233",
      "AilmentName": "Glaucomatous flecks (subcapsular), bilateral"
    }, {
      "AilmentID": 9016,
      "AilmentCode": "H26.239",
      "AilmentName": "Glaucomatous flecks (subcapsular), unspecified eye"
    }, {
      "AilmentID": 9017,
      "AilmentCode": "H26.30",
      "AilmentName": "Drug-induced cataract, unspecified eye"
    }, {
      "AilmentID": 9018,
      "AilmentCode": "H26.31",
      "AilmentName": "Drug-induced cataract, right eye"
    }, {
      "AilmentID": 9019,
      "AilmentCode": "H26.32",
      "AilmentName": "Drug-induced cataract, left eye"
    }, {
      "AilmentID": 9020,
      "AilmentCode": "H26.33",
      "AilmentName": "Drug-induced cataract, bilateral"
    }, {
      "AilmentID": 9021,
      "AilmentCode": "H26.40",
      "AilmentName": "Unspecified secondary cataract"
    }, {
      "AilmentID": 9022,
      "AilmentCode": "H26.411",
      "AilmentName": "Soemmering's ring, right eye"
    }, {
      "AilmentID": 9023,
      "AilmentCode": "H26.412",
      "AilmentName": "Soemmering's ring, left eye"
    }, {
      "AilmentID": 9024,
      "AilmentCode": "H26.413",
      "AilmentName": "Soemmering's ring, bilateral"
    }, {
      "AilmentID": 9025,
      "AilmentCode": "H26.419",
      "AilmentName": "Soemmering's ring, unspecified eye"
    }, {
      "AilmentID": 9026,
      "AilmentCode": "H26.491",
      "AilmentName": "Other secondary cataract, right eye"
    }, {
      "AilmentID": 9027,
      "AilmentCode": "H26.492",
      "AilmentName": "Other secondary cataract, left eye"
    }, {
      "AilmentID": 9028,
      "AilmentCode": "H26.493",
      "AilmentName": "Other secondary cataract, bilateral"
    }, {
      "AilmentID": 9029,
      "AilmentCode": "H26.499",
      "AilmentName": "Other secondary cataract, unspecified eye"
    }, {
      "AilmentID": 9030,
      "AilmentCode": "H26.8",
      "AilmentName": "Other specified cataract"
    }, {
      "AilmentID": 9031,
      "AilmentCode": "H26.9",
      "AilmentName": "Unspecified cataract"
    }];
    scope.lenseMaster = [{
      "ID": 148,
      "LenseType": "Monofocal"
    }, {
      "ID": 149,
      "LenseType": "Aspheric"
    }, {
      "ID": 150,
      "LenseType": "Monofocal + Aspheric Toric"
    }, {
      "ID": 151,
      "LenseType": "Monofocal + Toric"
    }, {
      "ID": 152,
      "LenseType": "Multifocal"
    }];
    scope.checkboxErrorModel = {
      error: '',
      package: '',
      fingerPrint: '',
      other: '',
      isSelected: ''
    };
    scope.resetFormData = function () {
      scope.form = {
        roomtype: '',
        govPackagesname: '',
        fileNames: [],
        tpaId: 0,
        fileUploadFolderPath: [],
        doa: new Date(),
        dod: new Date(),
        packageAmount: '',
        clmamount: 0,
        procedure1: '',
        mPackageTotalAmount: '',
        mPackageFullName: '',
        packageName: '',
        cappedAmount: '',
        packageUniqueId: '',
        fullname: '',
        memberId: '',
        URNNum: '',
        adFolderPath: [],
        employer: '',
        empid: '',
        maid: '',
        policyno: '',
        age: '',
        gender: '',
        preauthSuccess: false,
        preauthError: false,
        insurername: '',
        isgovtscheme: '',
        mobile: '',
        diagnosis: '',
        procedure: '',
        admissiontype: '',
        docname: '',
        ipnumber: '',
        IsGovtClaim: true,
        memberDist: '',
        reasonOnline: '',
        memberGender: '',
        memberAge: '',
        uidno: '',
        tpaName: '',
        uniqueId: '',
        hospTPAId: 0,
        PreAuthForIRRemarks: ''
      }
    };
    scope.tpaFormReset = function () {
      scope.tpaForm = {
        name: {
          id: 0,
          value: '--Select TPA Name--'
        },
        mailServerAddress: '',
        mailServerPort: '',
        useSSl: '',
        hospMailId: '',
        hospPassword: '',
        tpaMailId: '',
        outGoingServerPort: '',
        tpaHospId: '',
        outGoingServerAddress: '',
        tpaId: 0
      }
    };
    scope.tpaFormReset();
    scope.procedureManually = {
      name: '',
      price: ''
    };

    scope.isPPN = function () {
      return UtilitiesService.checkPPN();
    };

    scope.downloadNonPPNFile = function () {
      var nonPPN = 'https://document.medibuddy.in//proclaim-20170919/c6003e85-87f7-4367-bfaf-8169deb6d811.pdf';
      window.open(
        nonPPN,
        '_blank'
      );
    };

    scope.resetFormData();

    function setDate() {
      var currentDate = new Date(scope.form.doa);
      return currentDate.setMonth(currentDate.getMonth() + 3);
    }

    function getDate() {
      return scope.form.doa;
    }

    function setMaxDate() {
      var currentDate = new Date();
      return currentDate.setMonth(currentDate.getMonth() + 6);
    }

    function setMinDate() {
      var currentDate = new Date();
      return currentDate.setMonth(currentDate.getMonth() - 1);
    }

    scope.dateOptions = {
      formatYear: 'yyyy',
      maxDate: setMaxDate(),
      minDate: setMinDate()
    };

    scope.dateOptions1 = {
      formatYear: 'yyyy',
      maxDate: setDate(),
      minDate: getDate()
    }

    scope.downloadPPNFile = function () {
      var nonPPN = 'https://document.medibuddy.in//proclaim-20170919/af23ae4b-43c3-4252-bd8b-1260c8b98393.pdf';
      window.open(
        nonPPN,
        '_blank'
      );
    };

    scope.resetFormData();
    scope.newAdmissionFormData = [];
    scope.govtSchemeType = [{
      name: 'RSBY',
      selected: false
    }, {
      name: 'Manipur scheme (CMHT)',
      selected: false
    }];
    scope.fastrack = {};
    scope.isgovtschemeForm = false;
    scope.govPackage = UserService.getGovtPackageList();
    scope.govPackageData = [];

    scope.checkPhoneNumber = '^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$';
    scope.govType = 'B';
    scope.isShowMaid = true;
    scope.isEBill = UtilitiesService.checkEBillHospital(UserService.getHospitalObj().hospId);
    if (UserService.getHospitalObj().entityRealtion.length > 0) {
      scope.isRsby = UserService.getHospitalObj().entityRealtion[0].contractname === 'MSBYHospitals_Mediassist' ? true : false;
    } else {
      scope.isRsby = false;
    }
    scope.numberValidation = '((?:1){8}|(?:2){8}|(?:3){8}|(?:4){8}|(?:5){8}|(?:6){8}|(?:7){8}|(?:8){8}|(?:9){8}|(?:0){8})';
    scope.tpaForm.name = {
      id: 0,
      value: '--Select TPA Name--'
    };
    scope.fileUploaName = [];
    scope.storeFiles = [];
    scope.getDateObj = UtilitiesService.getDateObj;
    scope.isProcessing = false;
    scope.doctorDetails = [];
    scope.roomsDetails = [];
    scope.isSearchButton = true;
    scope.isSearchProcedure = true;
    scope.userObject = UserService.getUserObj();
    scope.isProcedure = false;
    scope.isTPA = false;
    scope.isTPAAndProcedure = false;
    if (scope.userObject && scope.userObject.entityId === 1005034) {
      scope.isProcedure = true;
      scope.isTPA = false;
      scope.isTPAAndProcedure = false;
    }
    scope.dynamicFields = {
      name: '',
      price: ''
    }
    var erIDs = navConstantsSvc.erIDs;
    scope.isTPA = false;
    scope.isProcedure = true;
    scope.isTPAAndProcedure = false;
    if (scope.userObject && scope.userObject.entityId === 1026419) {
      scope.isTPA = false;
      scope.isProcedure = true;
      scope.isTPAAndProcedure = false;
    }
    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];
    scope.datePopup = {
      doa: false,
      dod: false
    }
    scope.tpaList = [];
    scope.selectedMappedpackages = [];
    scope.CLAIMED_AMOUNT = 0;
    scope.packageCalcAmount = 0;
    scope.reasonOnlineField = 'procedure';
    scope.isSuccess = false;
    scope.isError = false;
    scope.tpaErrorMsg = '';
    scope.govSearchValueInModel = {
      apbyname: '',
      urn: ''
    };
    scope.removeData = [];
    scope.objSelectedCollection = [];
    scope.selectedMappedpackages = [];
    scope.isPriceDropDown = false;
    scope.priceForPackage = [];
    scope.isECashLess = false;
    scope.eCashLessMessage = '';
    scope.newPackageListData = [];
    scope.packageListing = [];
    scope.totalListOfPackage = [];
    scope.selectTreatmentType = '';
    scope.fileUploaName = [];
    scope.storeFiles = [];
    scope.todaysDate = new Date();
    scope.todaysDate = scope.todaysDate.setMonth(scope.todaysDate.getMonth() - 1);
    scope.todaysDate = new Date(scope.todaysDate);
    scope.isFormDisable = true;
    scope.availableBills = [];
    scope.selectedMappedpackages = [];
    scope.savedBillDetails = [];
    scope.newScheme = '';

    scope.isCheckGovhosp = function () {
      var flag = true;
      if (UserService.getGovtPackageList() && UserService.getGovtPackageList().length > 0) {
        flag = false;
      }
      return flag;
    };

    scope.createObjForAdmision = function () {
      if (UserService.getGovtPackageList() && UserService.getGovtPackageList().length > 0) {
        scope.newAdmissionFormData = [{
          name: 'MAID / DHSID',
          selected: false
        }, {
          name: 'Employee ID',
          selected: false
        }, {
          name: 'Policy Number',
          selected: false
        }];

        if (_.where(scope.newAdmissionFormData, {
            name: 'Government Scheme'
          }).length > 0) {
          angular.forEach(scope.newAdmissionFormData, function (data, index) {
            if (data.name === 'Government Scheme') {
              scope.newAdmissionFormData.splice(index);
            }
            scope.newAdmissionFormData[index].selected = false;
          })
        } else {
          scope.newAdmissionFormData.push({
            name: 'Government Scheme',
            selected: false
          });
          // scope.newAdmissionFormData.push({ name:'Add Manually', selected: false});
          _.uniq(scope.newAdmissionFormData)
        }
      } else {
        scope.newAdmissionFormData = [{
          name: 'MAID / DHSID',
          selected: false
        }, {
          name: 'Employee ID',
          selected: false
        }, {
          name: 'Policy Number',
          selected: false
        }];
      }
    };

    scope.createObjForAdmision();
    scope.user = UserService.getUserObj();
    scope.redirectUrl = function (url) {
      if (scope.user && (scope.user.entityId === 1026419)) {
        state.go('newAdmissionUrl', {}, {
          reload: true
        })
      } else {
        state.go('newAdmission', {}, {
          reload: true
        })
      }
    };

    scope.resetFlag = function () {
      scope.admissionFromSearchFlag = {
        maidOrDhsid: false,
        employeeId: false,
        policyno: false,
        urnNumber: false,
        addManually: false,
        openDetailsTab: false,
        hideSomeFields: false,
        govClaim: false,
        typeGovClaim: false,
        urnNumberManipurScheme: false
      }
    };

    scope.resetData = function () {
      scope.newAdmissionSearch = {
        maidOrDhsid: '',
        benefName: '',
        benefRelationList: [],
        goveRelationList: []
      }
    };

    scope.resetData();

    scope.selectErrorType = function (value, type) {
      scope.checkboxErrorModel = {
        package: false,
        error: false,
        other: false,
        fingerPrint: false,
        isSelected: false
      }
      if (value.fingerPrint && type === 'fingerPrint') {
        scope.checkboxErrorModel.fingerPrint = true;
        scope.checkboxErrorModel.isSelected = true;
      } else if (value.package && type === 'package') {
        scope.checkboxErrorModel.package = true;
        scope.checkboxErrorModel.isSelected = true;
      } else if (value.error && type === 'error') {
        scope.checkboxErrorModel.error = true;
        scope.checkboxErrorModel.isSelected = true;
      } else if (value.other && type === 'other') {
        scope.checkboxErrorModel.other = true;
        scope.checkboxErrorModel.isSelected = true;
      } else {
        scope.checkboxErrorModel.isSelected = false;
      }
    };

    scope.formSelection = function (item, value) {
      scope.isgovtschemeForm = value;
      scope.resetFlag();
      scope.resetData();
      scope.fastrack = {};
      scope.fastrack.error = false;
      scope.fastrack.errorMessage = '';
      angular.forEach(scope.newAdmissionFormData, function (value, index) {
        if (value.name === item)
          scope.newAdmissionFormData[index].selected = true;
        else
          scope.newAdmissionFormData[index].selected = false;

      });
      scope.govtBenefList = [];
      scope.form.isgovtscheme = false;
      scope.admissionFromSearchFlag.govClaim = false;
      switch (item) {
        case 'MAID / DHSID':
          scope.admissionFromSearchFlag.maidOrDhsid = true;
          scope.admissionFromSearchFlag.hideSomeFields = false;
          break;
        case 'Employee ID':
          scope.admissionFromSearchFlag.employeeId = true;
          scope.admissionFromSearchFlag.hideSomeFields = false;
          break;
        case 'Policy Number':
          scope.admissionFromSearchFlag.policyno = true;
          scope.admissionFromSearchFlag.hideSomeFields = false;
          break;
        case 'Government Scheme':
          scope.form.isgovtscheme = true;
          scope.admissionFromSearchFlag.govClaim = true;
          scope.admissionFromSearchFlag.typeGovClaim = true;
          scope.admissionFromSearchFlag.urnNumber = false;
          scope.admissionFromSearchFlag.hideSomeFields = false;
          scope.admissionFromSearchFlag.urnNumberManipurScheme = false;
          break;
        case 'Add Manually':
          scope.admissionFromSearchFlag.openDetailsTab = true;
          scope.admissionFromSearchFlag.addManually = true;
          scope.admissionFromSearchFlag.hideSomeFields = true;
          if (scope.source && scope.source === 'preClaim') {

          } else {
            scope.newAdmissionFormData = [];
            scope.resetFormData();
            scope.createObjForAdmision();
            if (scope.isgovtschemeForm) {
              scope.form.isgovtscheme = true;
            }
          }
          break;
        default:
      }
    };

    scope.formSchemeSelection = function (item, value) {
      scope.newAdmissionFormModel = item;
      angular.forEach(scope.govtSchemeType, function (value, index) {
        if (value.name === item)
          scope.govtSchemeType[index].selected = true;
        else
          scope.govtSchemeType[index].selected = false;
      });

      scope.form.isgovtscheme = true;
      scope.admissionFromSearchFlag.govClaim = true;
      scope.admissionFromSearchFlag.typeGovClaim = true;
      scope.admissionFromSearchFlag.hideSomeFields = false;
      switch (item) {
        case 'RSBY':
          scope.admissionFromSearchFlag.urnNumber = true;
          scope.admissionFromSearchFlag.urnNumberManipurScheme = false;
          break;
        case 'Manipur scheme (CMHT)':
          scope.admissionFromSearchFlag.urnNumber = false;
          scope.admissionFromSearchFlag.urnNumberManipurScheme = true;
          break;
        default:
      }
    };

    scope.searchAgain = function () {
      scope.newAdmissionFormData = [];
      scope.createObjForAdmision();
      scope.resetFlag();
      scope.resetData();
      scope.resetFormData();
      scope.fastrack = {};
      scope.govtBenefList = [];
      scope.govSearchValueInModel.urn = '';
      scope.checkboxErrorModel.package = '';
      scope.checkboxErrorModel.error = '';
      scope.checkboxErrorModel.other = '';
      scope.checkboxErrorModel.fingerPrint = '';
      scope.checkboxErrorModel.isSelected = '';
      scope.isgovtschemeForm = false;
      scope.form.isgovtscheme = false;
    };

    scope.joinReason = function () {
      var reason = '';
      if (scope.checkboxErrorModel) {
        if (scope.checkboxErrorModel.package) {
          reason = 'Package';
        }
        if (scope.checkboxErrorModel.error) {
          if (reason === '') {
            reason = 'Erro';
          } else {
            reason = reason + ',' + 'Erro';
          }
        }
        if (scope.checkboxErrorModel.other) {
          if (reason === '') {
            reason = 'Other';
          } else {
            reason = reason + ',' + 'Other';
          }
        }
        if (scope.checkboxErrorModel.fingerPrint) {
          if (reason === '') {
            reason = 'FingerPrint';
          } else {
            reason = reason + ',' + 'FingerPrint';
          }
        }
      }
      return reason;
    };

    scope.getDetailsWithMaid = function (maid, benefName) {
      if (maid && benefName) {
        var data = {
          hospId: UserService.getHospitalObj().hospId,
          maid: maid,
          beneficiaryName: benefName
        }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails', data, 'POST').
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.name = response.data.benefs.name;
            scope.newAdmissionSearch.benefRelationList = response.data.relations;
            angular.forEach(scope.newAdmissionSearch.benefRelationList, function (value, key) {
              scope.newAdmissionSearch.benefRelationList[key].isSelected = false;
            })
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
          } else {
            scope.fastrack.error = true;
          }
        });
      }
    };

    scope.getDetailsWithEmpId = function (empid, corpname, benefname) {
      if (empid && corpname && benefname && UserService.getHospitalObj()) {
        var data = {
          hospId: UserService.getHospitalObj().hospId,
          employeeId: empid,
          corporateName: corpname,
          BeneficiaryName: benefname
        }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails.json', data, 'POST').
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.displaySubmit = false;
            scope.fastrack.error = false;
            scope.benefRelationData = response.data.benefs;
            scope.fastrack.name = response.data.benefs.benefName;
            scope.newAdmissionSearch.benefRelationList = response.data.relations;
            angular.forEach(scope.newAdmissionSearch.benefRelationList, function (value, key) {
              scope.newAdmissionSearch.benefRelationList[key].isSelected = false;
            })
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
          } else {
            scope.fastrack.error = true;
          }
        });
      } else {

      }
    };

    scope.getDetailsWithPolicy = function (policyno, benefname) {
      if (policyno && benefname) {
        var data = {
          hospId: UserService.getHospitalObj().hospId,
          PolicyNo: policyno,
          BeneficiaryName: benefname
        } //getEcardWithPolicyNo
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails.json', data, 'POST').
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.displaySubmit = false;
            scope.fastrack.error = false;
            scope.fastrack.name = response.data.benefs.benefName;
            scope.newAdmissionSearch.benefRelationList = response.data.relations;
            angular.forEach(scope.newAdmissionSearch.benefRelationList, function (value, key) {
              scope.newAdmissionSearch.benefRelationList[key].isSelected = false;
            })
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
          } else {
            scope.fastrack.error = true;
          }
        });
      }
    };

    scope.govtBenefList = [];

    scope.govReadonly = function () {
      return scope.govtBenefList.length > 0 ? true : false;
    };

    scope.getDetailsWithGov = function (id, type, govtSchemeType) {
      var data = {
        URN: id ? id : '',
        schemeType: scope.selectedSchemeForGov ? scope.selectedSchemeForGov : '',
        memberNameAPBY: type ? type : '',
        govtSchemeType: govtSchemeType ? govtSchemeType : ''
      }

      scope.govtBenefList = [];
      scope.fastrack.error = false;
      if (data.URN) {
        FastrackService.getDetailsWithGov(data).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.isSearch = false;
            scope.fastrack.error = false;
            scope.govtBenefList = response.data.govtBenefList;
            scope.govtBenefList.forEach(function (obj) {
              obj.displayName = obj.urn + " (" + obj.memberName + ")";
            });
            //if(scope.govtBenefList.length >0){
            // var govtBenefList = _.first(scope.govtBenefList);
            // scope.fastrackPopulateNewAdmissionGov(govtBenefList);
            //}
          } else {
            scope.fastrack.error = true;
          }
        }, function (response) {
          scope.fastrack.error = true;
        });
      } else {

      }
    };
    scope.noOfDays = 1;
    scope.newAdmissionFormModel = '';
    scope.totalGovClaimAmount = function () {
      scope.totalCalcAmount = 0;
      angular.forEach(scope.govPackageData, function (data, index) {
        if (data.packageCost) {
          if (data.isPerDayEligiblePackage === true) {
            var oneDay = 24 * 60 * 60 * 1000;
            var noOfDays = Math.round(Math.abs((scope.form.dod.getTime() - scope.form.doa.getTime()) / (oneDay)));
            scope.noOfDays = noOfDays;
            var isPerDayEligiblePrice = 0;
            if (noOfDays === 0) {
              isPerDayEligiblePrice = parseInt(data.packageCost)
              scope.noOfDays = 1;
            } else
              isPerDayEligiblePrice = parseInt(data.packageCost) * (noOfDays)
            scope.totalCalcAmount = scope.totalCalcAmount + isPerDayEligiblePrice;
          } else
            scope.totalCalcAmount = scope.totalCalcAmount + parseInt(data.packageCost);
        }
      });
      return scope.totalCalcAmount;
    };

    scope.isSelectedGov = false;
    scope.priceForGovPackage = [];
    scope.govPackageData = [];
    scope.selectedGovPackage = '';
    scope.selectGovePackage = function (item, model) {
      scope.isSelectedGov = true;
      scope.selectedGovPackage = '';
      scope.priceForGovPackage = [];
      if (item) {
        scope.selectedGovPackage = item;
        var data = {
          price: item.packageCost
        }
        scope.priceForGovPackage.push(data);
      } else {
        scope.isSelectedGov = false;
      }
    };
    scope.govPackageManually = {
      name: '',
      price: ''
    }

    scope.addGovPackageManually = function (name, govPackage, flag) {
      if (scope.govPackageData.length <= 2) {
        if (flag) {
          //var govtPackageList = _.where(scope.govPackageData, {packageId: scope.selectedGovPackage.packageId});
          // if(govtPackageList.length >0){
          //      scope.govPackageData.push(scope.selectedGovPackage);
          //     // UtilitiesService.showAlertMessage('Duplicate line item is not allowed.');
          // }else{
          scope.govPackageData.push(scope.selectedGovPackage);
          //}
          scope.isSelectedGov = false;
        } else {
          var data = {
            cappedAmount: 0,
            govPackageName: name,
            packageCost: parseInt(govPackage.price),
            packageId: 0,
            packageName: name,
            type: ''
          }
          var govtPackageList = _.where(scope.govPackageData, {
            packageName: data.packageName
          });
          if (govtPackageList.length > 0) {
            UtilitiesService.showAlertMessage('Duplicate line item is not allowed.');
          } else {
            scope.govPackageData.push(data);
          }
        }
      } else {
        UtilitiesService.showAlertMessage('Maximum of 3 packages allowed.');
      }
      scope.isSelectedGov = false;
      scope.selectedGovPackage = '';
      scope.govPackageManually.price = '';
      scope.govPackageManually.name = '';
      scope.form.govPackagesname = '';
      scope.form.clmamount = scope.totalGovClaimAmount();
    };

    scope.removeGovPackage = function (data) {
      if (data) {
        angular.forEach(scope.govPackageData, function (value, index) {
          if (value.packageId === data.packageId || value.packageName === data.packageName) {
            scope.govPackageData.splice(index, 1);
          }
        });
        scope.form.clmamount = scope.totalGovClaimAmount();
      }
    };

    scope.mobileValidation = function (number) {
      if (number) {} else {}
    };

    scope.openDoa = function () {
      scope.datePopup.doa = true;
    };

    scope.openDod = function () {
      scope.datePopup.dod = true;
    };

    scope.changeTpa = function (obj) {
      scope.resetFormData();
      scope.isShowMaid = true;
      if (obj) {
        if (obj === 'Medi Assist Insurance TPA Pvt. Ltd.') {
          scope.isSearchProcedure = true;
          scope.isShowMaid = true;
          scope.isSearchButton = true;
          var value = _.findWhere(scope.tpaList, {
            tpaName: obj
          });
          scope.form.tpaId = value.tpaId ? value.tpaId : 0;
          scope.form.hospTPAId = value.hospTPAId ? value.hospTPAId : 0;
          scope.form.tpaName = value.tpaName ? value.tpaName : '';
          scope.reasonOnlineField = 'procedure';
        } else {
          scope.isShowMaid = false;
          scope.isSearchButton = obj ? false : true;
          scope.isSearchProcedure = false;
          scope.reasonOnlineField = 'others';
        }
        if (!scope.isSearchButton) {
          var value = _.findWhere(scope.tpaList, {
            tpaName: obj
          });
          if (value) {
            scope.form.tpaId = value.hospTPAId ? value.hospTPAId : 0;
            scope.form.hospTPAId = value.hospTPAId ? value.hospTPAId : 0;
            scope.form.tpaName = value.tpaName ? value.tpaName : '';
          }
        }
      } else {
        scope.form.hospTPAId = 0;
        scope.form.tpaId = 0;
      }
    };

    scope.getInsurersCompanyList = function () {
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/insurers', '', 'GET').then(function (response) {
        if (response.data) {
          scope.insurerList = response.data.insurerList;
          scope.insurerList = _.sortBy(scope.insurerList, function (num) {
            return num.id > 0;
          });
        }
      }, function (error) {
        scope.insurerList = [];
      });
    };

    scope.getInsurersCompanyList();

    scope.getTPAList = function () {
      scope.TPAListData = [];
      var ajaxData = {
        LookUpType: 'TPA'
      };
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/master/MasterLookup', ajaxData, 'POST').then(function (response) {
        if (response.data) {
          scope.TPAListData = response.data;
          scope.TPAListData.push({
            id: 0,
            value: '--Select TPA Name--'
          });
          scope.TPAListData = _.sortBy(scope.TPAListData, function (num) {
            return num.id > 0;
          });
          scope.tpaForm.name = {
            id: 0,
            value: '--Select TPA Name--'
          };
        }
      }, function (error) {
        scope.TPAListData = [];
      });
    };

    scope.getTPAList();

    scope.getRoomsDetails = function () {
      var ajaxData = {
        hospId: UserService.getHospitalObj().hospId,
        getDoctors: false,
        getRooms: true,
        getOpPackages: false,
        getContracts: false
      };
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/hospProfileDetails', ajaxData, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          scope.roomsDetails = response.data.hospRoomDetails;
        }
      }, function (error) {
        scope.roomsDetails = [];
      });
    };

    scope.getDoctorDetails = function () {
      var ajaxData = {
        hospId: UserService.getHospitalObj().hospId,
        getDoctors: true,
        getRooms: true,
        getOpPackages: false,
        getContracts: false
      };
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/hospProfileDetails', ajaxData, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          scope.doctorDetails = response.data.hospDoctorDetails;
          scope.getRoomsDetails();
        }
      }, function (error) {
        scope.doctorDetails = [];
        scope.getRoomsDetails();
      });
    };

    scope.getTpaList = function () {
      if (UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId) {
        // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/' + UserService.getHospitalObj().cmsHospId + '/tpas', '', 'GET').then(function (response) {
        //   if (response.data.isSucces) {
        //     scope.tpaList = response.data.tpaList;
        //   }
        // }, function (error) {
        //   scope.tpaList = [];
        // });
      }
    };

    scope.getTpaList();
    scope.getDoctorDetails();

    scope.getPackageList = function (value) {
      var govPackage = UserService.getGovtPackageList();
      if (value) {
        var data = {
          priEntityName: '',
          priEntityId: UserService.getUserObj().entityId,
          secEntityName: 'Medi Assist',
          secEntityId: 0,
          schemeType: value
        };
        // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/packagesbtnentities/list', data, 'POST', UserService.getAccessToken()).then(function (response) {
        //   if (response.data.isSuccess) {
        //     scope.govtPackageList = response.data.packages;
        //   } else {
        //     scope.govtPackageList = [];
        //   }
        // });
      }
    };
    scope.govtChecked = function (data) {
      scope.form.packageAmount = '';
      scope.selectedSchemeForGov = 'RSBYHospitals_Mediassist';
      scope.form.isgovtscheme = !!scope.form.isgovtscheme;
      if (data) {
        scope.selectedSchemeForGov = data;
        scope.form.isgovtscheme = true;
      }
    };

    scope.onSelectPackages = function ($item, $model, $label) {
      if ($item) {
        scope.selectedMappedpackages.push($item);
        scope.selectedMappedpackages = _.uniq(scope.selectedMappedpackages);
        angular.forEach(scope.selectedMappedpackages, function (data, index) {
          scope.selectedMappedpackages[index].general_Ward1 = data.general_Ward1 === true ? true : false;
          scope.selectedMappedpackages[index].private_Ward1 = data.private_Ward1 === true ? true : false;
          scope.selectedMappedpackages[index].semi_Private_Ward1 = data.semi_Private_Ward1 === true ? true : false;
          scope.selectedMappedpackages[index].uniqueIds = index + 1;
        })
      }
    };

    scope.totalClaimAmount = function () {
      scope.totalCalcAmount = 0;
      angular.forEach(scope.selectedMappedpackages, function (data, index) {
        if (data.packageAmount) {
          scope.totalCalcAmount = scope.totalCalcAmount + parseInt(data.packageAmount);
        }
      });
      //_.reduce(scope.selectedMappedpackages, function(memo, num){  return memo + parseInt(num.packageAmount);  }, 0);
      scope.CLAIMED_AMOUNT = scope.totalCalcAmount;
      scope.form.clmamount = scope.totalCalcAmount;
      return scope.totalCalcAmount;
    };

    scope.calculatePrice = function () {
      scope.packageCalcAmount = 0;
      angular.forEach(scope.selectedMappedpackages, function (data, index) {
        if (data.packageAmount) {
          scope.packageCalcAmount = scope.packageCalcAmount + data.packageAmount;
        }
      });
      scope.form.clmamount = scope.totalClaimAmount();
    };

    scope.calculateTotalAmountValue = function () {
      scope.CLAIMED_AMOUNT1 = 0;
      angular.forEach(scope.savedBillDetails, function (data, index) {
        if (data.packageAmount) {
          scope.CLAIMED_AMOUNT1 = scope.CLAIMED_AMOUNT1 + parseInt(data.packageAmount);
        }
      });
      return scope.CLAIMED_AMOUNT1;
    };

    scope.calculateTotalAmount = function () {
      scope.packageAmount = 0;
      angular.forEach(scope.savedBillDetails, function (data, index) {
        if (data.packageAmount) {
          scope.packageAmount = scope.CLAIMED_AMOUNT + parseInt(data.packageAmount);
        }
      });
      return scope.totalClaimAmount(scope.packageAmount)
    };

    scope.changePackageField = function (value) {
      scope.form.procedure1 = '';
      scope.form.mPackageTotalAmount = '';
      scope.form.mPackageFullName = '';
      scope.reasonOnlineField = value;
    };

    scope.AddProcedure = function (name, price) {
      if (name && price) {
        var obj = {
          deluxe_Other: 0,
          general_Ward: parseInt(price),
          general_Ward1: true,
          packageId: 0,
          package_Name: name,
        }
        scope.selectedMappedpackages.push(obj);
        scope.calculatePrice();
        scope.onSelectPackages(obj);
        scope.form.mPackageTotalAmount = '';
        scope.form.mPackageFullName = '';
      } else {
        UtilitiesService.showAlertMessage('Please enter treatment details and amount .');
      }
    };

    scope.changeGovtPolicyType = function (type) {
      scope.form.packageAmount = '';
      scope.form.mPackageAmount = '';
      scope.form.packageName = '';
      scope.form.packageUniqueId = '';
      scope.form.cappedAmount = '';
      scope.text = '';
      if (type) {
        if (type === 'Basic') {
          var obje = [];
          angular.forEach(scope.govtPackageListDummy, function (value, key) {
            if (type === value.type) {
              value.govPackageName = value.packageName + ' , ' + value.packageCost;
              obje.push(value);
            }
          });
          scope.govtPackageList = obje;
        } else if (type === 'Critical') {
          var obje = [];
          angular.forEach(scope.govtPackageListDummy, function (value, key) {
            if (type === value.type) {
              value.govPackageName = value.packageName + ' , ' + value.packageCost;

              obje.push(value);
            }
          });
          scope.govtPackageList = obje;
        }
      }
    };

    scope.addTpa = function (type) {
      angular.element("#addTPA").modal('show');
    };

    scope.resetAlertMessage = function () {
      timeout(function () {
        scope.$apply(function () {
          scope.isSuccess = false;
          scope.isError = false;
        });
      }, 6000)
    };

    scope.saveTpaDetails = function (tpaForm) {
      if (UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId && tpaForm.name.id !== 0) {
        var data = {
          hospId: UserService.getHospitalObj().cmsHospId,
          tpaName: tpaForm.name.value,
          tpaId: tpaForm.name.id,
          mailServerAddress: tpaForm.mailServerAddress,
          mailServerPort: tpaForm.mailServerPort,
          useSSl: true,
          hospMailId: tpaForm.hospMailId,
          hospPassword: tpaForm.hospPassword,
          tpaMailId: tpaForm.tpaMailId,
          outGoingServerPort: tpaForm.outGoingServerPort,
          tpaHospId: tpaForm.tpaHospId,
          outGoingServerAddress: tpaForm.outGoingServerAddress
        }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tpa', data, 'POST', true).then(function (response) {
          if (response.data.isSuccess) {
            scope.tpaFormReset();
            scope.getTpaList();
            scope.isSuccess = true;
            scope.isSuccessMsg = 'TPA has been Added successfully!.';
            scope.resetAlertMessage();
          } else {
            scope.isError = true;
            scope.tpaErrorMsg = 'oops! something went wrong, please try again later.';
            scope.resetAlertMessage();
          }
        }, function (error) {
          scope.isError = true;
          scope.tpaErrorMsg = 'oops! something went wrong, please try again later.';
          scope.resetAlertMessage();
        });
      } else {
        scope.isError = true;
        scope.tpaErrorMsg = 'Please select TPA name.';
        scope.resetAlertMessage();
      }
    };

    scope.fastrackPreauthGovSeaarch = function (type) {
      scope.radioFastTrack = '';
      scope.govSearchValueInModel.apbyname = '';
      scope.govSearchValueInModel.urn = '';
      angular.element("#newMSBYSearch").modal('show');
      scope.fastrack = {};
      scope.fastrack.displaySubmit = true;
      switch (type) {
        case 'gov':
          scope.fastrack.title = 'Gov Search';
          scope.aarogyachecked = false;
          scope.govSearch = true;
          scope.isGov = true;
          scope.govtBenefList = [];
          scope.epic = '';
          scope.urn = '';
          scope.fastrack.showCorpName = false;
          scope.fastrack.employerSearchTitle = 'Employee ID';
          break;
      }
    };

    scope.fastrackPreauth = function (type) {
      angular.element("#newPreauthModal").modal("show");
      scope.fastrack = {};
      scope.fastrack.displaySubmit = true;
      switch (type) {
        case 'aarogya':
          scope.fastrack.title = 'Aarogya Scheme';
          scope.aarogyachecked = true;
          scope.govSearch = false;
          scope.isGov = false;
          scope.fastrack.showCorpName = false;
          scope.fastrack.employerSearchTitle = 'Family Number';
          break;
        case 'generic':
          scope.fastrack.title = 'Member Search';
          scope.aarogyachecked = false;
          scope.govSearch = false;
          scope.isGov = false;
          scope.fastrack.showCorpName = true;
          scope.fastrack.employerSearchTitle = 'Employee ID';
          break;
        case 'gov':
          scope.fastrack.title = 'Gov Search';
          scope.aarogyachecked = false;
          scope.govSearch = true;
          scope.isGov = true;
          scope.govtBenefList = [];
          scope.epic = '';
          scope.urn = '';
          scope.fastrack.showCorpName = false;
          scope.fastrack.employerSearchTitle = 'Employee ID';
          break;
      }
      if (scope.aarogyachecked) {
        scope.fastrack.corporateName = 'Manipal';
      }
    };

    scope.searchGov = function (type) {
      if (type === 'URN') {
        scope.isURN = true;
        scope.isEpic = false;
        scope.epic = '';
        scope.govtBenefList = [];
      } else if (type === 'Epic') {
        scope.isURN = false;
        scope.isEpic = true;
        scope.urn = '';
        scope.govtBenefList = [];
      } else if (type === 'MemberNameAPBY') {
        scope.isURN = false;
        scope.isMemberNameAPBY = true;
        scope.urn = '';
        scope.govtBenefList = [];
      } else {
        scope.isURN = false;
        scope.epic = '';
        scope.urn = '';
        scope.isEpic = false;
      }
    };

    scope.resetModel = function () {
      scope.govtBenefList = [];
      scope.fastrack.error = false;
    };

    scope.fastrackPopulateNewAdmissionGov = function (data) {
      if (data) {
        scope.form.fullname = data.memberName;
        scope.form.memberId = data.memberID;
        scope.form.URNNum = data.urn;
        scope.form.memberGender = data.gender == 'f' ? 'female' : data.gender == 'm' ? 'male' : '';
        scope.form.isgovtscheme = true;
        scope.admissionFromSearchFlag.openDetailsTab = true;
        scope.form.memberDist = data.districtName;
        scope.form.aadharNo = data.aadharCardNo;
        scope.form.memberAge = data.age;
      }
    };

    scope.removePackageFromList = function (item) {
      if (item) {
        angular.forEach(scope.selectedMappedpackages, function (data, index) {
          if (data.uniqueIds > 0) {
            if (item.uniqueIds === data.uniqueIds) {
              scope.selectedMappedpackages.splice(index, 1);
            }
          } else {
            if (item.hospitaL_CHARGE_HEAD === data.hospitaL_CHARGE_HEAD) {
              scope.selectedMappedpackages.splice(index, 1);
            }
          }
        })
        if (item.uniqueIds > 0) {
          scope.removeData = item;
        }
        scope.calculateTotalAmount();
      }
    };

    scope.closeButton = function () {
      scope.isDuplicate = false;
      scope.isNewCategories = false;
      scope.dynamicFields.name = '';
      scope.dynamicFields.price = '';
    };

    scope.addMoreCategories = function (flag, data, selectedObject) {
      scope.isDuplicate = false;
      if (flag) {
        var value = _.filter(scope.availableBills, function (item) {
          return item.hospitalBillDesc.toLowerCase() === data.name.toLowerCase()
        }).length;
        if (value === 0) {
          if (selectedObject && data.name === selectedObject.hospitaL_CHARGE_HEAD) {
            selectedObject.CLAIMED_AMOUNT = data.price;
            scope.availableBills.push(selectedObject);
            scope.selectedObject = '';
          } else {
            scope.availableBills.push({
              PROVIDER_BILL_ITEM_NAME: '',
              BILL_ITEM_DETAIL_REF: '',
              DETAIL_BILL_ITEM_CLAIM_ID: '',
              DETAIL_BILL_ITEM_PREAUTH_NO: '',
              CLAIMED_AMOUNT: data.price,
              CMS_CHARGE_TYPE_ID: 4,
              CMS_CHARGE_TYPE_DESC: 'Miscellaneous Charges',
              CMS_SUBCHARGE_TYPE_ID: 53,
              CMS_SUBCHARGE_TYPE_DESC: 'Other Miscellaneous Charges',
              hospitaL_CHARGE_HEAD: data.name,
              hospitalBillDesc: data.name,
              isReadOnly: false,
              isPackage: false,
              uniqueIds: '',
              packageId: ''
            });
          }
          angular.forEach(scope.typaheadData, function (v, index) {
            if (v.hospitalBillDesc === data.name) {
              scope.typaheadData.splice(index, 1);
            }
          });
          scope.typaheadData = _.uniq(scope.typaheadData);
          scope.typaheadData = _.reject(scope.typaheadData, function (num) {
            return num.isPackage === true;
          });
          scope.dynamicFields.name = '';
          scope.dynamicFields.price = '';
          scope.calculateTotalAmount();
        } else {
          scope.isDuplicate = true;
        }

      } else {
        scope.isNewCategories = true;
      }
    };

    scope.removeCategories = function (data) {
      angular.forEach(scope.availableBills, function (key, index) {
        if (key.hospitalBillDesc === data.hospitalBillDesc) {
          scope.availableBills.splice(index, 1);
          if (key.isPackage) {
            scope.removePackageFromList(data);
          }
        }
      });
      scope.calculateTotalAmount();
    };

    scope.saveDetails = function () {
      scope.calculateTotalAmount();
      angular.element('#addBillDetails').modal('hide');
    };

    scope.closeModal = function () {
      scope.availableBills = [];
      scope.CLAIMED_AMOUNT = 0;
      scope.calculateTotalAmount();
      angular.element('#addBillDetails').modal('hide');
    };

    scope.getBillDetailsPopup = function (modelPopup) {
      scope.modelPopup = {
        text: modelPopup
      }
      var modelPopup = '#' + scope.modelPopup.text;
      angular.element(modelPopup).appendTo('body');
      angular.element(modelPopup).modal('show');
    };

    scope.validate = function () {
      var result = true;
      angular.forEach(scope.availableBills, function (key, index) {
        if (!key.CLAIMED_AMOUNT)
          return result = false;
      });
      if (result)
        return result;
    };

    scope.typeProcedureName = function () {
      scope.isPriceDropDown = false;
      scope.isSelectedGov = false;
    };

    scope.selectPackageFromList = function (item, model) {
      scope.priceForPackage = [];
      scope.selectedPackagesData = '';
      scope.selectedManualData = '';
      if (item && item.distinctPrices) {
        scope.selectedPackagesData = item;
        if (item.deluxe_Other > 0) {
          scope.priceForPackage.push({
            name: 'Delux room',
            price: item.deluxe_Other
          })
        }
        if (item.general_Ward > 0) {
          scope.priceForPackage.push({
            name: 'General room',
            price: item.general_Ward
          })
        }
        if (item.private_Ward > 0) {
          scope.priceForPackage.push({
            name: 'Private room',
            price: item.private_Ward
          })
        }
        if (item.semi_Private_Ward > 0) {
          scope.priceForPackage.push({
            name: 'Semi private room',
            price: item.semi_Private_Ward
          })
        }
        scope.isPriceDropDown = true;
      } else {
        scope.selectedManualData = item;
        scope.priceForPackage = [];
        scope.isPriceDropDown = false;
      }
    };

    scope.addManuallyProcedure = function (data, type) {
      if (data && data.name && data.price && scope.selectedPackagesData && type === true) {
        scope.isPriceDropDown = false;
        scope.priceForPackage = [];
        var selectedPackageList = [];
        //if(_.where(scope.selectedMappedpackages, {packageId: scope.selectedPackagesData.packageId}).length >=1){
        //UtilitiesService.showAlertMessage('Duplicate line item is not allowed.');
        //}else{
        scope.selectedMappedpackages.push({
          packageName: data.name,
          packageId: scope.selectedPackagesData.packageId,
          packageAmount: parseInt(data.price),
          packageCappedAmount: 0,
          cmS_CHARGE_TYPE_ID: 0,
          cmS_CHARGE_TYPE_DESC: '',
          cmS_SUBCHARGE_TYPE_ID: 0,
          cmS_SUBCHARGE_TYPE_DESC: '',
          hospitaL_CHARGE_HEAD: data.name,
          isReadOnly: scope.selectedPackagesData.packageId > 0 ? true : false,
          isPackage: scope.selectedPackagesData.packageId > 0 ? true : false
        });
        //}
        scope.selectedPackagesData = '';
        scope.procedureManually.name = '';
        scope.procedureManually.price = '';
        scope.calculatePrice();
      } else {
        if (data && data.name && data.price && type === false) {
          scope.isPriceDropDown = false;
          scope.priceForPackage = [];
          var selectedPackageList = [];
          if (_.where(scope.selectedMappedpackages, {
              packageName: data.name
            }).length >= 1) {
            UtilitiesService.showAlertMessage('Duplicate line item is not allowed.');
          } else {
            scope.selectedMappedpackages.push({
              packageName: data.name,
              packageId: 0,
              packageAmount: parseInt(data.price),
              packageCappedAmount: 0,
              cmS_CHARGE_TYPE_ID: 0,
              cmS_CHARGE_TYPE_DESC: '',
              cmS_SUBCHARGE_TYPE_ID: 0,
              cmS_SUBCHARGE_TYPE_DESC: '',
              hospitaL_CHARGE_HEAD: data.name,
              isReadOnly: false,
              isPackage: false
            });
          }
          scope.procedureManually.name = '';
          scope.procedureManually.price = '';
          scope.selectedManualData = '';
          scope.calculatePrice();
        } else {
          UtilitiesService.showAlertMessage('Please enter name and price.');
        }
      }
    };

    scope.getMappedpackages = function (details) {
      scope.mappedpackages = [];
      scope.packageListing = [];
      scope.selectedMappedpackages = [];
      scope.calculatePrice();
      scope.isPriceOne = false;
      scope.isPriceTow = false;
      scope.isPriceThree = false;
      if (UserService.getHospitalObj()) {
        var data = {
          hospitalId: UserService.getHospitalObj().cmsHospId,
          insurerShortName: details
          //--details
          //'NIA'
        }
        scope.newPackageListData = [];
        // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/mappedpackages', data, 'POST', UserService.getAccessToken()).then(function (response) {
        //   if (response.data.isSuccess) {
        //     scope.availableBills = [];
        //     angular.forEach(response.data.availableBills, function (key, index) {
        //       if (key.isDefault) {
        //         var data = {
        //           packageName: key.hospitalBillDesc,
        //           package_Name: key.hospitalBillDesc,
        //           packageId: 0,
        //           packageAmount: 0,
        //           packageCappedAmount: 0,
        //           cmS_CHARGE_TYPE_ID: key.intermalBillTypeId,
        //           cmS_CHARGE_TYPE_DESC: key.internalBillTypeDesc,
        //           cmS_SUBCHARGE_TYPE_ID: key.internalSubBillTypeId,
        //           cmS_SUBCHARGE_TYPE_DESC: key.internalSubBillDesc,
        //           hospitaL_CHARGE_HEAD: key.hospitalBillDesc,
        //           isReadOnly: true,
        //           isPackage: false,
        //           uniqueIds: 0
        //         }
        //         scope.availableBills[index] = data;
        //       }
        //     });
        //     var packageListing = response.data.mappedpackages;
        //     if (scope.availableBills) {
        //       scope.totalListOfPackage = packageListing.concat(scope.availableBills);
        //     }

        //   } else {
        //     scope.totalListOfPackage = [];
        //   }
        // });
      }
    };

    scope.getMappedpackages();

    scope.getPackagesListForInsurer = function (data) {
      var selectedShoertName = '';
      if (data) {
        selectedShoertName = _.findWhere(scope.insurerList, {
          insurerFullName: data
        });
        scope.getMappedpackages(selectedShoertName.insurerShortName);
      }
    };

    //scope.getMappedpackages('NIA');
    scope.fastrackPopulateNewAdmission = function (maid, relationid, name, eCashLess) {
      angular.forEach(scope.newAdmissionSearch.benefRelationList, function (v, i) {
        if ((v.relationId === relationid) && (v.name === name)) {
          scope.newAdmissionSearch.benefRelationList[i].isSelected = true;
        } else {
          scope.newAdmissionSearch.benefRelationList[i].isSelected = false;
        }
      })
      scope.admissionFromSearchFlag.openDetailsTab = true;
      //scope.resetData();
      if (eCashLess.eCashlessReqId === 0) {
        scope.insurerFullName = eCashLess.insurerFullName;
        scope.form.insurername = scope.insurerFullName;
        scope.insurerShortName = eCashLess.insurerShortName;
        FastrackService.fastrackPopulateNewAdmission(maid, relationid, name).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.getMappedpackages(scope.insurerShortName);
            scope.$parent.tempData = response.data.benefs;
            scope.resetFormData();
            scope.fileUploaName = [];
            scope.storeFiles = [];
            scope.form.fileNames = [];
            scope.form.fileUploadFolderPath = [];
            scope.form.fullname = response.data.benefs.benefName; //generic
            scope.form.roomtype = '';
            scope.form.employer = response.data.benefs.benefPolHldrName;
            scope.form.empid = response.data.benefs.priBenefEmpCode;
            scope.form.maid = response.data.benefs.benefMediAssistID;
            scope.form.policyno = scope.fastrack.PolicyNo;
            scope.form.age = response.data.benefs.benefAge;
            scope.form.gender = response.data.benefs.benefSex;
            scope.form.insurername = scope.insurerFullName;
            if (eCashLess && eCashLess.mobileNo) {
              scope.form.mobile = parseInt(eCashLess.mobileNo) ? parseInt(eCashLess.mobileNo) : '';
            }
            angular.element("#newPreauthModal").modal('hide');
          } else {
            scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network issue', 'Error', true);
          }
        }, function (response) {
          scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network issue', 'Error', true);
        });
      } else {
        UtilitiesService.eCashlessReqData = eCashLess;
        scope.isECashLess = true;
        scope.eCashLessMessage = 'There is already a pre-approved request that exists for the patient. Redirecting you to the request. Click yes to continue.';
        timeout(function () {
          scope.$apply(function () {
            scope.isECashLess = false;
            scope.eCashLessMessage = '';
          });
        }, 10000)
      }
    };

    scope.opened = true;
    scope.reDirect = function (value) {
      if (value) {
        angular.element("#newPreauthModal").modal('hide');
        state.go(value, {
          reload: false
        });
      }
    };

    scope.clearfastrack = function () {
      scope.fastrack = {};
      scope.fastrack.displaySubmit = true;
      scope.fastrack.title = 'Member Search';
      scope.aarogyachecked = false;
      scope.fastrack.showCorpName = true;
      scope.fastrack.employerSearchTitle = 'Employee ID';
    };

    scope.removeModal = function () {
      scope.clearfastrack();
      angular.element("#newPreauthModal").modal('hide');
    };

    scope.packageCheck = function (data) {
      var isCheck = true;
      // angular.forEach(data, function (data, index) {
      //     if (!data.packageAmount) {
      //         isCheck = false
      //     }
      // });
      return isCheck;
    };

    scope.treatmentSelection = function (item) {
      if (item) {
        scope.selectTreatmentType = item.name;
      } else {
        scope.selectTreatmentType = '';
      }
    };

    scope.getPackagesForPreAuthForm = function () {
      var packagesForPreAuthForm = scope.selectedMappedpackagesObj(scope.selectedMappedpackages);
      scope.packagesForPreAuthForm = [];
      if (packagesForPreAuthForm) {
        angular.forEach(packagesForPreAuthForm, function (data, index) {
          scope.packagesForPreAuthForm.push(data.packageName);
        });
      }
      return scope.packagesForPreAuthForm.join();
    };

    scope.selectedMappedpackagesObj = function (data) {
      if (data) {
        scope.availableBillsFinalData = [];
        angular.forEach(data, function (v, index) {
          if (v.packageAmount) {
            var packagesList = {
              packageName: v.hospitaL_CHARGE_HEAD ? v.hospitaL_CHARGE_HEAD : '',
              packageId: v.packageId,
              packageAmount: v.packageAmount ? parseInt(v.packageAmount) : 0,
              packageCappedAmount: 0,
              cmS_CHARGE_TYPE_ID: v.cmS_CHARGE_TYPE_ID ? v.cmS_CHARGE_TYPE_ID : '',
              cmS_CHARGE_TYPE_DESC: v.cmS_SUBCHARGE_TYPE_DESC ? v.cmS_SUBCHARGE_TYPE_DESC : '',
              cmS_SUBCHARGE_TYPE_ID: v.cmS_SUBCHARGE_TYPE_ID ? v.cmS_SUBCHARGE_TYPE_ID : '',
              cmS_SUBCHARGE_TYPE_DESC: v.cmS_SUBCHARGE_TYPE_DESC ? v.cmS_SUBCHARGE_TYPE_DESC : '',
              hospitaL_CHARGE_HEAD: v.hospitaL_CHARGE_HEAD ? v.hospitaL_CHARGE_HEAD : ''
            }
            scope.availableBillsFinalData.push(packagesList);
          }

        });
        return scope.availableBillsFinalData;
      }
    };

    scope.downloadAttachment = function (obj) {
      if (obj) {
        window.open(
          UtilitiesService.getDMSHostUrl() + obj,
          '_blank'
        );
      }
    };

    scope.removeFiles = function (item) {
      angular.forEach(scope.storeFiles, function (key, value) {
        if (key.fileName === item.fileName) {
          scope.storeFiles.splice(value, 1)
        }
      })
      angular.forEach(scope.storeFiles, function (value, index) {
        scope.form.fileNames.push(value.fileName);
        scope.form.fileUploadFolderPath.push(value.downloadURL);
      })
    };

    scope.fileFn = function (data) {
      if (data) {
        scope.isProcessing = false;
        angular.forEach(data, function (value, index) {
          scope.form.fileNames.push(value.fileName);
          scope.form.fileUploadFolderPath.push(value.downloadURL);
          scope.storeFiles.push({
            fileName: value.fileName,
            docPath: value.downloadURL
          });
        })
      }
    };

    scope.preauthFormAction = (function () {
      scope.insuranceCompanyList = UtilitiesService.getInsuranceCompanyName();
      scope.username = UserService.getUserObj().userName;
      scope.showAutoPackages = true;

      function submitPreauthFormSuccess(successData) {
        scope.fileUploaName = [];
        scope.storeFiles = [];
        scope.isProcessing = false;
        // scope.resetFormData();
        scope.resetData();
        scope.govtBenefList = [];
        if (successData.data.isSuccess) {
          scope.form.preauthSuccess = true;
        } else {
          scope.form.preauthError = true;
        }
      }

      function submitPreauthFormError(ErrorData) {
        scope.isProcessing = false;
        scope.form.preauthError = true;
      }

      function fileUploadError(errordata) {
        scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'File Upload Error', 'Error', true);
      }

      function getTreatmentForAilment() {
        if (scope.form.diseaseDetails) {
          var ailment = [];
          Angular.forEach(scope.form.diseaseDetails, function (value) {
            ailment.push(value.AilmentID);
          });
          NewAdmissionFormService.getTreatmentForAilment({
            'ailmentIds': ailment
          }).then(function (res) {
            if (res && res.data.isSuccess) {
              scope.treatmentForAilment = res.data.treatmentDetails;
            }

          });
        }

      }
      return {
        getPreauthFormData: function (form) {
          var data = {
            IsGovtClaim: false,
            MemberGender: form.gender == undefined ? '' : form.gender,
            Age: form.age == undefined ? '' : form.age,
            ApplicationName: 'Hospital Portal',
            PatientFirstName: form.fullname,
            ContactNum: form.mobile,
            EmpId: form.empid,
            Employer: form.employer,
            Maid: form.maid,
            Doa: form.doa,
            packagesList: scope.selectedMappedpackagesObj(scope.selectedMappedpackages),
            ApproxClaimedAmnt: parseInt(form.clmamount),
            DocName: form.docname,
            DocRegNo: 'String',
            Diagnosis: form.diagnosis,
            AdmissionType: form.admissiontype,
            RoomType: form.roomtype,
            TentativeDOD: form.dod,
            HospId: UserService.getHospitalObj().hospId,
            HospName: UserService.getHospitalObj().hospName,
            CreatedBy: UserService.getUserObj().userId,
            IpNumber: form.ipnumber,
            Procedure: form.procedure,
            IpAddress: 'String',
            PolicyNumber: form.policyno,
            InsurerName: form.insurername,
            FileNames: form.fileNames,
            FileUploadFolderPath: form.fileUploadFolderPath.join(),
            uiD_NO: form.uidno,
            attachedFiles: scope.storeFiles,
            tpaid: form.tpaId ? form.tpaId : 0,
            tpaConfigId: form.hospTPAId ? form.hospTPAId : 0,
            uniqueId: form.uniqueId ? form.uniqueId : '',
            primaryAilment: form.diseaseDetails ? form.diseaseDetails : null,
            treatmentType: form.treatment ? form.treatment : null,
            lensId: form.lenseType
          };
          return data;
        },
        submitPreauthForm: function () {
          if (!scope.form.isgovtscheme) {
            if (scope.packageCheck(scope.selectedMappedpackages) && scope.selectedMappedpackagesObj(scope.selectedMappedpackages).length > 0) {
              scope.isProcessing = true;
              if (scope.storeFiles.length > 0) {
                NewAdmissionFormService.submitCataractPreauthForm(this.getPreauthFormData(scope.form)).then(submitPreauthFormSuccess, submitPreauthFormError);
              } else {
                UtilitiesService.showAlertMessage('Please attach atleast one document.');
              }
            } else {
              UtilitiesService.showAlertMessage('Please select procedure or add manually.')
            }
          } else {
            if (scope.govPackageData.length !== 0) {
              scope.isProcessing = true;
              if (scope.storeFiles.length > 0) {
                scope.govtSchemeMethods.submitPreauthForm();
              } else {
                UtilitiesService.showAlertMessage('Please attach atleast one document.');
              }
            } else {
              UtilitiesService.showAlertMessage('Please add atleast one government package.')
            }
          }
        },
        closePreauthForm: function () {
          scope.resetFormData();
          $location.path('/claims');
        },
        downloadPrefilledPreauthForm: function (source) {
          var PreauthFormDataObj = {
            HospitalID: UserService.getHospitalObj().cmsHospId,
            HospitalEmail: UserService.getHospitalObj().emailAddress,
            HospitalName: UserService.getHospitalObj().hospName,
            HospitalPhoneNo: UserService.getHospitalObj().primaryContactNumber,
            HospitalAddress: (UserService.getHospitalObj().address + UserService.getHospitalObj().city).replace(/[^a-zA-Z0-9 ]/g, ""),

            PatientName: scope.form.fullname,
            PatientPhoneNo: scope.form.mobile,
            CorporateName: scope.form.employer,
            EmployeeID: scope.form.empid,
            MAID: scope.form.maid ? scope.form.maid : '',
            DOA: scope.form.doa.getFullYear() + '-' + (scope.form.doa.getMonth() + 1) + '-' + scope.form.doa.getDate(),
            DOD: scope.form.dod.getFullYear() + '-' + (scope.form.dod.getMonth() + 1) + '-' + scope.form.dod.getDate(),
            Ailment: scope.form.diagnosis,
            Treatment: scope.getPackagesForPreAuthForm(),
            AdmissionType: scope.form.admissiontype,
            ClaimedAmount: scope.form.clmamount,
            DocName: scope.form.docname,
            RoomType: scope.form.roomtype,
            TPAId: scope.form.tpaId,
            UniqueId: scope.form.uniqueId ? scope.form.uniqueId : ''
          };
          NewAdmissionFormService.downloadPrefilledPreauthForm(source, PreauthFormDataObj)
        }
      };
    })();

    scope.govtSchemeMethods = (function () {
      scope.selectedPackages = new Array();

      function submitPreauthFormSuccess(successData) {
        scope.fileUploaName = [];
        scope.storeFiles = [];
        scope.isProcessing = false;
        // scope.resetFormData();
        scope.resetData();
        scope.govtBenefList = [];
        if (successData.data.isSuccess) {
          scope.form.preauthSuccess = true;
        } else {
          scope.form.preauthError = true;
        }
      }

      function submitPreauthFormError(ErrorData) {
        scope.isProcessing = false;
        scope.form.preauthError = true;
      }

      function getGovtPackageListSuccess(resData) {
        if (resData && resData.data.isSuccess && resData.data.packages && resData.data.packages.length > 0) {
          scope.govtPackageList1 = resData.data.packages;
          scope.govtPackageListDummy = scope.govtPackageList1;
          scope.changeGovtPolicyType('Basic');
          UserService.setGovtPackageList(scope.govtPackageList1);
          scope.showGovtPackages = true;
        } else {
          if (resData.data.isSuccess === false) {
            scope.govtPackageList1 = [];
            scope.govtPackageListDummy = scope.govtPackageList1;
            UserService.setGovtPackageList(scope.govtPackageList1);
            scope.showGovtPackages = false;
          }

        }
      }

      function getGovtPackageListError(resData) {
        scope.govPackage = [];
        scope.govtPackageListDummy = scope.govPackage;
        UtilitiesService.showAlertMessage('Error while fetching govt packages list');
      }
      return {
        getGovtPackageList: function () {
          var govPackage = UserService.getGovtPackageList();
          if (govPackage != undefined && govPackage != null) {
            scope.govPackage = govPackage;
            scope.govtPackageListDummy = govPackage;
            scope.changeGovtPolicyType('Basic');
            scope.showGovtPackages = true;
          } else {
            GovernmentService.getGovtPackageList().then(getGovtPackageListSuccess, getGovtPackageListError)
          }
        },
        setGovtPackageId: function (packageObj) {
          scope.form.packageAmount = packageObj.packageCost;
          scope.form.packageName = packageObj.packageName;
          scope.form.packageUniqueId = packageObj.packageId;
          scope.form.cappedAmount = packageObj.cappedAmount;
        },
        addPackageButton: function () {
          if (scope.form.packageAmount || scope.form.mPackageAmount) {
            if (scope.selectedPackages.length < 3) {
              if (scope.showAutoPackages) {
                scope.selectedPackages.push({
                  id: scope.selectedPackages.length,
                  uniqueId: scope.form.packageUniqueId,
                  name: scope.form.packageName,
                  amount: scope.form.packageAmount
                });
                $("#packagesHolder").val($("#packagesHolder").val() + ", " + scope.form.packageUniqueId);
              } else {
                scope.selectedPackages.push({
                  id: scope.selectedPackages.length,
                  uniqueId: 0,
                  name: scope.form.mPackageName,
                  amount: scope.form.mPackageAmount
                });
                $("#packagesHolder").val($("#packagesHolder").val() + ", 0");
              }
              scope.packageCalcAmount = 0;
              for (var i = 0; i < scope.selectedPackages.length; i++) {
                scope.packageCalcAmount = scope.packageCalcAmount + ((25 * (4 - i)) / 100) * scope.selectedPackages[i].amount;
              }
              $("#packageAmountHolder").val(scope.packageCalcAmount);
            } else {
              UtilitiesService.showAlertMessage('Maximum of 3 packages allowed.');
            }
          }
        },
        removePackage: function (id) {
          $("#packagesHolder").val($("#packagesHolder").val().replace(", " + scope.selectedPackages[id].uniqueId, ""));
          for (var i = id; i < scope.selectedPackages.length - 1; i++) {
            scope.selectedPackages[i] = scope.selectedPackages[i + 1];
            scope.selectedPackages[i].id--;
          }
          scope.selectedPackages.pop(scope.selectedPackages.length - 1);
          scope.packageCalcAmount = 0;
          for (var i = 0; i < scope.selectedPackages.length; i++) {
            scope.packageCalcAmount = scope.packageCalcAmount + ((25 * (4 - i)) / 100) * scope.selectedPackages[i].amount;
          }
          $("#packageAmountHolder").val(scope.packageCalcAmount);
        },

        getPreauthFormData: function (form) {
          var data = {
            IsGovtClaim: true,
            urnNumber: form.URNNum,
            memberId: form.memberId,
            memberDistrict: form.memberDist,
            reasonForChoosing: scope.joinReason(),
            packages: scope.govPackageData.map(function (item) {
              return item.packageId
            }),
            MemberGender: form.memberGender,
            Age: form.memberAge,
            ApplicationName: 'Hospital Portal',
            PatientFirstName: form.fullname,
            ContactNum: form.mobile,
            Doa: form.doa,
            DocName: form.docname,
            Diagnosis: form.diagnosis,
            TentativeDOD: form.dod,
            HospId: UserService.getHospitalObj().hospId,
            HospName: UserService.getHospitalObj().hospName,
            CreatedBy: UserService.getUserObj().userId,
            IpNumber: form.ipnumber,
            FileNames: form.fileNames, //form.fileUploadFolderPath,// form.fileNames,
            FileUploadFolderPath: form.fileUploadFolderPath.join(),
            ApproxClaimedAmnt: scope.totalGovClaimAmount(),
            uiD_NO: form.uidno,
            GovScheme: scope.selectedSchemeForGov === 'APCMUHIS_Mediassist' ? 'APCMUHIS_Mediassist' : 'RSBY',
            attachedFiles: scope.storeFiles,
            tpaid: form.tpaId ? form.tpaId : 0,
            tpaConfigId: form.hospTPAId ? form.hospTPAId : 0,
            uniqueId: form.uniqueId ? form.uniqueId : '',
            GovtSchemeManipur: scope.admissionFromSearchFlag.urnNumberManipurScheme,
            AadhaarNo: form.aadharNo,
            RoomType: form.roomtype
          };
          return data;
        },
        submitPreauthForm: function () {
          scope.isProcessing = true;
          NewAdmissionFormService.submitPreauthForm(this.getPreauthFormData(scope.form)).
          then(submitPreauthFormSuccess, submitPreauthFormError)
        },
        changePackageField: function () {
          if (scope.form.reasonOnline == 'others') {
            scope.showAutoPackages = false;
          } else {
            scope.showAutoPackages = true;
          }
        }
      };
    })();

    scope.checkForGovPackages = function () {
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/GovtSchemeAvailability.json?priEntityId=' + UserService.getUserObj().entityId + '&secEntityName=Medi%20Assist', '', 'GET', UserService.getAccessToken()).then(function (response) {
        if (response.data.isSuccess) {
          scope.showGovtPackages = true;
        } else {
          scope.showGovtPackages = false;
        }
      });
    };

    scope.govtSchemeMethods.getGovtPackageList();

    scope.preClaimInfoRelatedMethods = (function () {
      function submitPreauthFormSuccess(successData) {
        scope.isProcessing = false;
        scope.resetData();
        scope.govtBenefList = [];
        if (successData.data.isSuccess) {
          scope.form.preauthSuccess = true;
        } else {
          scope.form.preauthError = true;
        }
      }

      function submitPreauthFormError(ErrorData) {
        scope.isProcessing = false;
        scope.form.preauthError = true;
      }
      return {
        prefillPreauthForm: function (claimRefNo) {
          NewAdmissionFormService.getPreauthDataByMARefNo(claimRefNo).then(function (resData) {
            scope.resetFormData();
            scope.signup = {};
            if (resData.data.detailslist.length > 0) {
              if (resData.data.detailslist[0].admissioN_DATE.indexOf('T') > -1) {
                resData.data.detailslist[0].admissioN_DATE = new Date(resData.data.detailslist[0].admissioN_DATE);
                resData.data.detailslist[0].dischargE_DATE = new Date(resData.data.detailslist[0].dischargE_DATE);
              } else {
                var formattedDoa = resData.data.detailslist[0].admissioN_DATE.split('-')
                resData.data.detailslist[0].admissioN_DATE = new Date(formattedDoa[1] + '/' + formattedDoa[0] + '/' + formattedDoa[2])
                var formattedDod = resData.data.detailslist[0].dischargE_DATE.split('-');
                resData.data.detailslist[0].dischargE_DATE = new Date(formattedDod[1] + '/' + formattedDod[0] + '/' + formattedDod[2])
              }
              scope.form.fullname = resData.data.detailslist[0].patienT_FIRSTNAME;
              scope.form.mobile = parseInt(resData.data.detailslist[0].mobilE_NO);
              scope.form.employer = resData.data.detailslist[0].corporatE_NAME;
              scope.form.empid = resData.data.detailslist[0].employeE_ID;
              scope.form.maid = resData.data.detailslist[0].maid;
              scope.form.doa = (resData.data.detailslist[0].admissioN_DATE);
              scope.form.dod = (resData.data.detailslist[0].dischargE_DATE);
              scope.form.diagnosis = resData.data.detailslist[0].presenT_AILMENT;
              scope.form.procedure = resData.data.detailslist[0].provisionaL_TREATMENT;
              scope.form.admissiontype = resData.data.detailslist[0].admissioN_TYPE;
              scope.form.clmamount = parseInt(resData.data.detailslist[0].preautH_AMOUNT);
              scope.form.docname = resData.data.detailslist[0].firsT_NAME;
              scope.form.roomtype = resData.data.detailslist[0].provideR_ROOM_TYPE;
              scope.form.PreAuthForIRRemarks = resData.data.detailslist[0].remarks;
            }
          }, function (error) {
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          });
        },
        getPreauthFormData: function (form) {
          var data = {
            PreAuthNo: scope.dataobj.claimRefNo,
            IsGovtClaim: false,
            MemberGender: form.gender == undefined ? '' : form.gender,
            Age: form.age == undefined ? '' : form.age,
            ApplicationName: 'Hospital Portal',
            PatientFirstName: form.fullname,
            ContactNum: form.mobile,
            EmpId: form.empid,
            Employer: form.employer,
            Maid: form.maid,
            Doa: form.doa,
            packagesList: scope.selectedMappedpackagesObj(scope.selectedMappedpackages),
            ApproxClaimedAmnt: parseInt(form.clmamount),
            DocName: form.docname,
            DocRegNo: 'String',
            Diagnosis: form.diagnosis,
            AdmissionType: form.admissiontype,
            RoomType: form.roomtype,
            TentativeDOD: form.dod,
            HospId: UserService.getHospitalObj().hospId,
            HospName: UserService.getHospitalObj().hospName,
            CreatedBy: UserService.getUserObj().userId,
            IpNumber: form.ipnumber,
            Procedure: form.procedure,
            IpAddress: 'String',
            PolicyNumber: form.policyno,
            InsurerName: form.insurername,
            FileNames: form.fileNames,
            FileUploadFolderPath: form.fileUploadFolderPath.join(),
            uiD_NO: form.uidno,
            attachedFiles: scope.storeFiles,
            tpaid: form.tpaId ? form.tpaId : 0,
            tpaConfigId: form.hospTPAId ? form.hospTPAId : 0,
            uniqueId: form.uniqueId ? form.uniqueId : ''
          };
          return data;
        },
        submitPreClaimPreauthForm: function () {
          scope.isProcessing = true;
          if (scope.storeFiles.length > 0) {
            if (!scope.form.IsGovtClaim) {
              NewAdmissionFormService.submitPreClaimPreauthForm(this.getPreauthFormData(scope.form)).
              then(submitPreauthFormSuccess, submitPreauthFormError);
            } else {
              scope.govtSchemeMethods.submitPreauthForm();
            }
          } else {
            UtilitiesService.showAlertMessage('Please attach atleast one document.');
          }
        },
        closePreauthForm: function () {
          scope.resetFormData();
          $location.path('/claims');
        },
      };
    })();

    if (scope.source == 'preClaim' && scope.dataobj.claimRefNo) {
      scope.preClaimInfoRelatedMethods.prefillPreauthForm(scope.dataobj.claimRefNo);
    }

    scope.dateOfAdmission = function (date, type) {
      scope.isFormDisable = false;
      scope.totalGovClaimAmount();
      if (type === 'doa') {
        var currentMonth = scope.todaysDate.getMonth() + 2;
        var selectedMonth = scope.form.doa.getMonth();
        if (currentMonth < selectedMonth) {
          scope.isdoa = true;
          scope.isFormDisable = true;
          if (scope.form.dod) {
            scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
          }
        } else {
          scope.isdoa = scope.todaysDate <= scope.form.doa ? false : true;
          scope.isFormDisable = scope.isdoa;
          if (scope.form.dod) {
            scope.isdod = scope.form.dod >= scope.form.doa ? false : true;
          }
        }
      } else if (type === 'dod') {
        var currentMonth = scope.todaysDate.getMonth() + 2;
        var selectedMonth = scope.form.doa.getMonth();
        if (currentMonth < selectedMonth) {
          scope.isdoa = true;
          scope.isFormDisable = true;
          scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
        } else {
          scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
          if (scope.form.doa) {
            scope.isdoa = scope.todaysDate <= scope.form.doa ? false : true;
            if (!scope.isdoa) {
              scope.isdoa = scope.form.dod < scope.form.doa ? true : false;
            }
          }
        }
      }
    };

    scope.addFileToUpload = function (flag) {
      scope.file = [];
      var newItemNo = scope.file.length + 1;
      scope.file.push({
        'model': ''
      });
    };

    scope.removeFileToUpload = function () {
      var lastItem = scope.file.length - 1;
      scope.file.splice(lastItem);
      scope.validLargeDoc = false;
    };
    if (scope.source && scope.source === 'preClaim') {
      scope.formSelection('Add Manually', '');
    }
    scope.addFileToUpload();
  }]);

angular.module('mbplus')
  .controller('newAdmissionFormCtrl', ['$scope', '$location', '$state', '$timeout', 'UserService', 'UtilitiesService', 'filterFilter', '$uibModal', 'FastrackService', 'GovernmentService', 'FileUploadService', 'NewAdmissionFormService', '$analytics', '$q', 'blockUI', 'navConstantsSvc', '$rootScope', 'Notification', function (scope, $location, state, timeout, UserService, UtilitiesService, filterFilter, $uibModal, FastrackService, GovernmentService, FileUploadService, NewAdmissionFormService, $analytics, $q, blockUI, navConstantsSvc, rootScope, Notification) {
    $analytics.pageTrack('/newAdmission/');
    scope.ctrlName = 'newAdmissionFormCtrl';
    scope.blockUIState = blockUI.state();
    var selectedShortName = {
      insurerFullName: null,
      insurerShortName: null
    };
    scope.isDataPrefilled = false;
    scope.configuredPayerExtensionFields = UtilitiesService.getPayerExtensionFields();
    scope.MaTPAId = UtilitiesService.getMaTpaId();
    scope.MaTpaName = UtilitiesService.getMaTpaName();
    scope.payerExtraFileldsList = [];
    scope.applyNoFilters = false;
    scope.convertDate = function (date) {
      return moment(date).format('DD-MMM-YYYY');
    }
    if (!UserService.isActive()) {
      UserService.destroyUserObj();
      return false;
    }
    scope.relationMaster = ['Self', 'Mother', 'Brother', 'Daughter', 'Father', 'Husband', 'Sister', 'Son', 'Wife', 'Daughter-in-law', 'Father-in-law', 'Mother-in-law', 'Employee', 'GrandDaughter', 'GrandSon', 'Son-in-law', 'Spouse', 'Child', 'First Child', 'Second Child', 'Third Child', 'Fourth Child', 'Others', 'Fifth Child', 'Dependent', 'Sibling', 'Sixth Child', 'Seventh Child', 'Eighth Child', 'Aunt', 'Brother-in-law', 'Nephew', 'Niece', 'Sister-in-law', 'Uncle', 'Grand Mother', 'Grand Father', 'Partner', 'Dependent Disabled-child'];



    scope.cataractAliasName = ['Lens', 'L.E', 'L/E', 'R.E', 'R/E', 'Acrylic', 'MICS', 'M.I.C.S', 'MICS', 'LE', 'RE', 'Unifocal', 'lens', 'Aspheric', 'Foldable', 'Tecnis', 'MicroPhaco', 'Cataract', 'extraction', 'Right', 'Eye', 'Left', 'Eye', 'Hydrophobic', 'Monofocal', 'Rt', 'Eye', 'IOL', 'Toric', 'MICRO', 'INCISION', 'CATARACT', 'SURGERY', 'PHACOEMULSIFICATION', 'PHACO-EMULSIFICATION', 'GIPSA', 'Package'];

    scope.cataractAilmentCode = ['H25', 'H26'];
    scope.maternityAilmentCode = ['O80', 'O82'];
    scope.cataractType = [{
      'id': 8933,
      'code': 'H25.011',
      'packageCode': 'H25',
      'name': 'Right Eye',
      'isSelected': null,
      'ageStartLimit': 18,
      'ageEndLimit': 100,
      'treatmentType': [{
        'id': 281,
        'name': 'Femto Laser Surgery'
      },
      {
        'id': 1,
        'name': 'Surgical Management'
      }, {
        'id': 3467,
        'name': 'Phaco emulsification(PHACO)'
      }, {
        'id': 141,
        'name': 'MICS'
      }
      ]
    }, {
      'id': 8934,
      'code': 'H25.012',
      'packageCode': 'H26',
      'name': 'Left Eye',
      'isSelected': null,
      'ageStartLimit': 18,
      'ageEndLimit': 100,
      'treatmentType': [{
        'id': 1,
        'name': 'Surgical Management'
      }, {
        'id': 3467,
        'name': 'Phaco emulsification(PHACO)'
      }, {
        'id': 141,
        'name': 'MICS'
      }]
    }, {
      'id': 8967,
      'code': 'H26.011',
      'packageCode': 'H25',
      'name': 'Right Eye',
      'isSelected': null,
      'ageStartLimit': 0,
      'ageEndLimit': 17,
      'treatmentType': [{
        'id': 281,
        'name': 'Femto Laser Surgery'
      },
      {
        'id': 1,
        'name': 'Surgical Management'
      }, {
        'id': 3467,
        'name': 'Phaco emulsification(PHACO)'
      }, {
        'id': 141,
        'name': 'MICS'
      }
      ]
    }, {
      'id': 8968,
      'code': 'H26.012',
      'packageCode': 'H26',
      'name': 'Left Eye',
      'isSelected': null,
      'ageStartLimit': 0,
      'ageEndLimit': 17,
      'treatmentType': [{
        'id': 1,
        'name': 'Surgical Management'
      }, {
        'id': 3467,
        'name': 'Phaco emulsification(PHACO)'
      }, {
        'id': 141,
        'name': 'MICS'
      }]
    }]

    scope.cataractLenseType = [{
      'id': 148,
      'parentId': 0,
      'name': 'Monofocal'
    }, {
      'id': 149,
      'parentId': 0,
      'name': 'Aspheric'
    }, {
      'id': 150,
      'parentId': 0,
      'name': 'Monofocal + Aspheric Toric'
    }, {
      'id': 151,
      'parentId': 0,
      'name': 'Monofocal + Toric'
    }, {
      'id': 152,
      'parentId': 0,
      'name': 'Multifocal'
    }]

    scope.maternityType = [{
      "id": 4455,
      "parentId": 471,
      "name": "Normal",
      'code': 'O80'
    }, {
      "id": 3240,
      "parentId": 498,
      "name": "LSCS",
      'code': 'O82'
    }]

    scope.cataractTreatmentType = [{
      'id': 3467,
      'name': 'Phaco emulsification(PHACO)'
    }, {
      'id': 141,
      'name': 'MICS'
    }, {
      'id': 281,
      'name': 'Femto Laser Surgery'
    }];

    scope.hdfcAnaesthesia = [{
      name: "LA",
      isSelected: false
    }, {
      name: "GA",
      isSelected: false
    }, {
      name: "Epidural",
      isSelected: false
    }, {
      name: "Spinal",
      isSelected: false
    }, {
      name: "Regional Block",
      isSelected: false
    }, {
      name: "Other",
      isSelected: false
    }];
    // scope.hdfcIllnessdueTo = [{
    //   name: "Maternity",
    //   isSelected: false
    // }, {
    //   name: "Accident",
    //   isSelected: false
    // }, {
    //   name: "Alcohol",
    //   isSelected: false
    // }, {
    //   name: "Sterility",
    //   isSelected: false
    // }, {
    //   name: "Congenital External",
    //   isSelected: false
    // }, {
    //   name: "HIV",
    //   isSelected: false
    // }, {
    //   name: "Cosmetic",
    //   isSelected: false
    // }, {
    //   name: "None of the Above",
    //   isSelected: false
    // }, {
    //   name: "Others",
    //   isSelected: false
    // }];

    scope.hdfcConservativeManagement = [{
      name: "Antibiotics",
      value: null
    }, {
      name: "Neuromuscular drugs",
      value: null
    }, {
      name: "Cardiac Drugs",
      value: null
    }, {
      name: "Respiratory Drugs",
      value: null
    }, {
      name: "IV transfusions",
      value: null
    }, {
      name: "Chemotherapy",
      value: null
    }, {
      name: "Continuous traction",
      value: null
    }, {
      name: "Radiation",
      value: null
    }, {
      name: "other",
      value: null
    }]

    scope.hdfcPastAilmentCategory = [{
      "value": "Diabetes",
      "id": 5
    },
    {
      "value": "Dyslipidaemia",
      "id": 3
    },
    {
      "value": "H/O of any cardiac ailment",
      "id": 6
    },
    {
      "value": "H/O similar/related complaints",
      "id": 4
    },
    {
      "value": "H/O surgery",
      "id": 2
    },
    {
      "value": "Hypertension",
      "id": 9
    },
    {
      "value": "No Past Histoy applicable",
      "id": 1
    },
    {
      "value": "Other",
      "id": 8
    },
    {
      "value": "Personal H/O: Alcohol/Tobacco/Drug abuse",
      "id": 7
    }
    ];

    scope.hdfcExpenses = [{
      "value": "Anesthetist",
      "id": 7
    },
    {
      "value": "Consumables",
      "id": 8
    },
    {
      "value": "Investigations",
      "id": 2
    },
    {
      "value": "Package",
      "id": 3
    },
    {
      "value": "Pharmacy",
      "id": 4
    },
    {
      "value": "Physician Charge",
      "id": 5
    },
    {
      "value": "Total Rent",
      "id": 1
    },
    {
      "value": "Surgeon charge",
      "id": 6
    },
    {
      "value": "Others",
      "id": 9
    },
    {
      "value": "Nursing Charge",
      "id": 10
    },
    {
      "value": "OT Charge",
      "id": 11
    }
    ];

    scope.checkboxErrorModel = {
      error: '',
      package: '',
      fingerPrint: '',
      other: '',
      isSelected: ''
    };
    scope.configuredTpaList = [];
    scope.resetFormData = function () {
      scope.form = {
        roomtype: '',
        memberroomType: '',
        govPackagesname: '',
        fileNames: [],
        tpaId: 0,
        fileUploadFolderPath: [],
        doa: new Date(),
        dod: new Date(),
        packageAmount: '',
        clmamount: 0,
        procedure1: '',
        mPackageTotalAmount: '',
        mPackageFullName: '',
        packageName: '',
        cappedAmount: '',
        packageUniqueId: '',
        fullname: '',
        memberId: '',
        URNNum: '',
        adFolderPath: [],
        employer: '',
        empid: '',
        maid: '',
        policyno: '',
        age: '',
        gender: '',
        preauthSuccess: false,
        preauthError: false,
        insurername: '',
        isgovtscheme: '',
        mobile: '',
        diagnosis: '',
        procedure: '',
        admissiontype: '',
        docname: '',
        ipnumber: '',
        IsGovtClaim: true,
        memberDist: '',
        reasonOnline: '',
        memberGender: '',
        memberAge: '',
        uidno: '',
        tpaName: '',
        uniqueId: '',
        hospTPAId: 0,
        PreAuthForIRRemarks: '',
        emailId: '',
        govtSchemeName: ''
      }
    };

    scope.tpaDetailsObj = {
      hospTPAId: 0,
      tpaName: scope.MaTpaName,
      tpaId: scope.MaTPAId
    }


    scope.tpaFormReset = function () {
      scope.tpaForm = {
        name: {
          tpaId: scope.MaTPAId,
          tpaName: scope.MaTpaName
        },
        mailServerAddress: '',
        mailServerPort: '',
        useSSl: '',
        hospMailId: '',
        hospPassword: '',
        tpaMailId: '',
        outGoingServerPort: '',
        tpaHospId: '',
        outGoingServerAddress: '',
        tpaId: 0
      }
    };
    scope.tpaFormReset();
    scope.procedureManually = {
      name: '',
      price: ''
    };

    scope.isPPN = function () {
      return UtilitiesService.checkPPN();
    };

    scope.downloadNonPPNFile = function () {
      var nonPPN = 'https://document.medibuddy.in//proclaim-20170919/c6003e85-87f7-4367-bfaf-8169deb6d811.pdf';
      window.open(
        nonPPN,
        '_blank'
      );
    };

    scope.resetFormData();

    function setDate() {
      var currentDate = new Date(scope.form.doa);
      return currentDate.setMonth(currentDate.getMonth() + 3);
    }

    function getDate() {
      return scope.form.doa;
    }

    function setMaxDate() {
      var currentDate = new Date();
      return currentDate.setMonth(currentDate.getMonth() + 6);
    }

    function setMinDate() {
      var currentDate = new Date();
      return currentDate.setMonth(currentDate.getMonth() - 1);
    }

    scope.dateOptions = {
      formatYear: 'yyyy',
      maxDate: setMaxDate(),
      minDate: setMinDate()
    };

    scope.dateOptions1 = {
      formatYear: 'yyyy',
      maxDate: setDate(),
      minDate: getDate()
    }
    scope.dateOptions2 = {
      formatYear: 'yyyy'
    };

    scope.downloadPPNFile = function () {
      var nonPPN = 'https://document.medibuddy.in//proclaim-20170919/af23ae4b-43c3-4252-bd8b-1260c8b98393.pdf';
      window.open(
        nonPPN,
        '_blank'
      );
    };

    scope.resetFormData();
    scope.newAdmissionFormData = [];
    // scope.govtSchemeType = [{
    //   name: 'RSBY',
    //   selected: false
    // }, {
    //   name: 'Manipur scheme (CMHT)',
    //   selected: false
    // }];
    scope.fastrack = {};
    scope.isgovtschemeForm = false;
    scope.govPackage = UserService.getGovtPackageList();
    scope.govPackageData = [];

    scope.checkPhoneNumber = '^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$';
    scope.govType = 'B';
    scope.isShowMaid = true;
    scope.isEBill = UtilitiesService.checkEBillHospital(UserService.getHospitalObj().hospId);
    if (UserService.getHospitalObj().configuredSchemes && UserService.getHospitalObj().configuredSchemes.length > 0) {
      scope.govtSchemeType = [];
      angular.forEach(UserService.getHospitalObj().configuredSchemes, function (element) {
        scope.govtSchemeType.push({
          name: element,
          selected: false
        })
        if (element == "RSBY") {
          scope.isRsby = true;
        } else {
          scope.isRsby = false;
        }
      });
    } else {
      scope.isRsby = false;
    }
    scope.numberValidation = '((?:1){8}|(?:2){8}|(?:3){8}|(?:4){8}|(?:5){8}|(?:6){8}|(?:7){8}|(?:8){8}|(?:9){8}|(?:0){8})';
    scope.tpaForm.name = {
      id: 0,
      value: '--Select TPA Name--'
    };
    scope.fileUploaName = [];
    scope.storeFiles = [];
    scope.getDateObj = UtilitiesService.getDateObj;
    scope.isProcessing = false;
    scope.doctorDetails = [];
    scope.roomsDetails = [];
    scope.isSearchButton = true;
    scope.isSearchProcedure = true;
    scope.userObject = UserService.getUserObj();
    scope.isProcedure = false;
    scope.isTPA = false;
    scope.isTPAAndProcedure = false;
    if (scope.userObject && scope.userObject.entityId === 1005034) {
      scope.isProcedure = true;
      scope.isTPA = false;
      scope.isTPAAndProcedure = false;
    }
    scope.dynamicFields = {
      name: '',
      price: ''
    }
    var erIDs = navConstantsSvc.erIDs;
    scope.isTPA = false;
    scope.isProcedure = true;
    scope.isTPAAndProcedure = false;
    if (scope.userObject && scope.userObject.entityId === 1026419) {
      scope.isTPA = false;
      scope.isProcedure = true;
      scope.isTPAAndProcedure = false;
    }
    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['yyyy/MM/dd'];
    scope.datePopup = {
      doa: false,
      dod: false
    }
    scope.tpaList = [];
    scope.selectedMappedpackages = [];
    scope.CLAIMED_AMOUNT = 0;
    scope.packageCalcAmount = 0;
    scope.reasonOnlineField = 'procedure';
    scope.isSuccess = false;
    scope.isError = false;
    scope.tpaErrorMsg = '';
    scope.govSearchValueInModel = {
      apbyname: '',
      urn: ''
    };
    scope.removeData = [];
    scope.objSelectedCollection = [];
    scope.selectedMappedpackages = [];
    scope.isPriceDropDown = false;
    scope.priceForPackage = [];
    scope.isECashLess = false;
    scope.eCashLessMessage = '';
    scope.newPackageListData = [];
    scope.packageListing = [];
    scope.totalListOfPackage = [];
    scope.selectTreatmentType = '';
    scope.fileUploaName = [];
    scope.storeFiles = [];
    scope.todaysDate = new Date();
    scope.todaysDate = scope.todaysDate.setMonth(scope.todaysDate.getMonth() - 1);
    scope.todaysDate = new Date(scope.todaysDate);
    scope.isFormDisable = true;
    scope.availableBills = [];
    scope.selectedMappedpackages = [];
    scope.savedBillDetails = [];
    scope.newScheme = '';


    // scope.getConfiguredTpaList = function () {
    //   if (UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId) {
    //     var data = UserService.getConfiguredTpa(UserService.getHospitalObj().cmsHospId);
    //     if (data) {
    //       data.then(function (response) {
    //         if (response.data.isSucces) {
    //           scope.configuredTpaList = response.data.tpaList;
    //           scope.newAdmissionFormData.push({
    //             name: 'Other Payer',
    //             selected: false
    //           });
    //         } else {
    //           scope.configuredTpaList = [];
    //         }
    //       })

    //     } else {
    //       scope.configuredTpaList = [];
    //     }
    //   }
    // }

    // scope.getConfiguredTpaList();

    if (UserService.getHospitalObj().configuredPayers) {
      // var objArray = Object.entries(UserService.getHospitalObj().configuredPayers);

      angular.forEach(UserService.getHospitalObj().configuredPayers, function (e) {
        scope.configuredTpaList.push({
          hospTPAId: 0,
          isBenefSearchConfigured: e.isBenefSearchEnabled,
          isClaimCreationBlockedWithoutBenef: e.isClaimCreationBlockedWithoutBenef,
          tpaName: e.name,
          tpaId: e.id,
          configuredFields: e.configuredFields,
          isInsurer: e.isInsurer
        })
      })

    }


    scope.isCheckGovhosp = function () {
      var flag = true;
      if (UserService.getGovtPackageList() && UserService.getGovtPackageList().length > 0) {
        flag = false;
      }
      return flag;
    };

    scope.createObjForAdmision = function () {
      if (scope.form.tpaId && scope.form.tpaId != scope.MaTPAId) {
        scope.newAdmissionFormData = [{
          name: 'Member Id',
          selected: false
        },
        {
          name: 'Employee ID',
          selected: false
        },
        {
          name: 'Policy Number',
          selected: false
        }
        // ,
        // {
        //   name: 'Email-Id',
        //   selected: false
        // },
        // {
        //   name: 'Contact Number',
        //   selected: false
        // }
        ]
      } else if (UserService.getGovtPackageList() && UserService.getGovtPackageList().length > 0 && scope.govtSchemeType && scope.govtSchemeType.length > 0) {
        scope.newAdmissionFormData = [{
          name: 'Member Id',
          selected: false
        }, {
          name: 'Employee ID',
          selected: false
        }, {
          name: 'Policy Number',
          selected: false
        }
        // , {
        //   name: 'Email-Id',
        //   selected: false
        // }, {
        //   name: 'Contact Number',
        //   selected: false
        // }
      ];

        if (_.where(scope.newAdmissionFormData, {
          name: 'Government Scheme'
        }).length > 0) {
          angular.forEach(scope.newAdmissionFormData, function (data, index) {
            if (data.name === 'Government Scheme') {
              scope.newAdmissionFormData.splice(index);
            }
            scope.newAdmissionFormData[index].selected = false;
          })
        } else {
          if (scope.govtSchemeType && scope.govtSchemeType.length > 0) {
            scope.newAdmissionFormData.push({
              name: 'Government Scheme',
              selected: false
            });
          }

          // scope.newAdmissionFormData.push({ name:'Add Manually', selected: false});
          _.uniq(scope.newAdmissionFormData)
        }

        // if (scope.configuredTpaList && scope.configuredTpaList.length > 0) {
        //   scope.newAdmissionFormData.push({
        //     name: 'Other Payer',
        //     selected: false
        //   });
        // }

      } else {
        scope.newAdmissionFormData = [{
          name: 'Member Id',
          selected: false
        }, {
          name: 'Employee ID',
          selected: false
        }, {
          name: 'Policy Number',
          selected: false
        }
        // , {
        //   name: 'Email-Id',
        //   selected: false
        // }, {
        //   name: 'Contact Number',
        //   selected: false
        // }
      ];
        // if (scope.configuredTpaList && scope.configuredTpaList.length > 0) {
        //   scope.newAdmissionFormData.push({
        //     name: 'Other Payer',
        //     selected: false
        //   });
        // }
      }
    };

    scope.createObjForAdmision();
    scope.user = UserService.getUserObj();
    scope.redirectUrl = function (url) {
      if (scope.user && (scope.user.entityId === 1026419)) {
        state.go('newAdmissionUrl', {}, {
          reload: true
        })
      } else {
        state.go('newAdmission', {}, {
          reload: true
        })
      }
    };

    scope.resetFlag = function () {
      scope.admissionFromSearchFlag = {
        maidOrDhsid: false,
        memberId: false,
        email: false,
        phoneNo: false,
        employeeId: false,
        policyno: false,
        urnNumber: false,
        addManually: false,
        openDetailsTab: false,
        hideSomeFields: false,
        govClaim: false,
        typeGovClaim: false,
        urnNumberManipurScheme: false
      }
    };

    scope.resetData = function () {
      scope.newAdmissionSearch = {
        maidOrDhsid: '',
        benefName: '',
        benefRelationList: [],
        goveRelationList: []
      },
        scope.otherPayerBenefList = [];
    };

    scope.resetData();

    scope.selectErrorType = function (value, type) {
      scope.checkboxErrorModel = {
        package: false,
        error: false,
        other: false,
        fingerPrint: false,
        isSelected: false
      }
      if (value.fingerPrint && type === 'fingerPrint') {
        scope.checkboxErrorModel.fingerPrint = true;
        scope.checkboxErrorModel.isSelected = true;
      } else if (value.package && type === 'package') {
        scope.checkboxErrorModel.package = true;
        scope.checkboxErrorModel.isSelected = true;
      } else if (value.error && type === 'error') {
        scope.checkboxErrorModel.error = true;
        scope.checkboxErrorModel.isSelected = true;
      } else if (value.other && type === 'other') {
        scope.checkboxErrorModel.other = true;
        scope.checkboxErrorModel.isSelected = true;
      } else {
        scope.checkboxErrorModel.isSelected = false;
      }
    };

    scope.formSelection = function (item, value, isOtherTpa) {
      scope.isDataPrefilled = false
      scope.isgovtschemeForm = value;
      var schemeName = scope.form.govtSchemeName;
      scope.resetFlag();
      scope.resetData();
      scope.fastrack = {};
      scope.fastrack.error = false;
      scope.fastrack.errorMessage = '';
      angular.forEach(scope.newAdmissionFormData, function (value, index) {
        if (value.name === item)
          scope.newAdmissionFormData[index].selected = true;
        else
          scope.newAdmissionFormData[index].selected = false;

      });
      scope.govtBenefList = [];
      scope.form.isgovtscheme = false;
      scope.admissionFromSearchFlag.govClaim = false;
      if ((!scope.form.tpaId || scope.form.tpaId == 0 || scope.form.tpaId == scope.MaTPAId) && !isOtherTpa) {
        scope.getMappedpackages(selectedShortName.insurerShortName);
      }
      switch (item) {
        case 'Member Id':
          scope.admissionFromSearchFlag.maidOrDhsid = true;
          scope.admissionFromSearchFlag.hideSomeFields = false;
          break;
        case 'Member Id':
          scope.admissionFromSearchFlag.memberId = true;
          scope.admissionFromSearchFlag.hideSomeFields = true;
          break;
        case 'Employee ID':
          scope.admissionFromSearchFlag.employeeId = true;
          scope.admissionFromSearchFlag.hideSomeFields = false;
          break;
        case 'Policy Number':
          scope.admissionFromSearchFlag.policyno = true;
          scope.admissionFromSearchFlag.hideSomeFields = false;
          break;
        case 'Email-Id':
          scope.admissionFromSearchFlag.email = true;
          scope.admissionFromSearchFlag.hideSomeFields = false;
          break;
        case 'Contact Number':
          scope.admissionFromSearchFlag.mobileNo = true;
          scope.admissionFromSearchFlag.hideSomeFields = false;
          break;
        case 'Government Scheme':
          scope.form.isgovtscheme = true;
          scope.admissionFromSearchFlag.govClaim = true;
          scope.admissionFromSearchFlag.typeGovClaim = true;
          scope.admissionFromSearchFlag.urnNumber = false;
          scope.admissionFromSearchFlag.hideSomeFields = false;
          scope.admissionFromSearchFlag.urnNumberManipurScheme = false;
          break;
        case 'Other Payer':
          scope.admissionFromSearchFlag.isOthetTpa = true;
          scope.admissionFromSearchFlag.hideSomeFields = false;
          break;
        case 'Add Manually':
          scope.admissionFromSearchFlag.openDetailsTab = true;
          scope.admissionFromSearchFlag.addManually = true;
          scope.admissionFromSearchFlag.hideSomeFields = true;
          if (scope.source && scope.source === 'preClaim') {

          } else {
            scope.newAdmissionFormData = [];
            scope.resetFormData();
            scope.createObjForAdmision();
            if (scope.isgovtschemeForm) {
              scope.form.isgovtscheme = true;
              scope.form.govtSchemeName = schemeName;
            }
          }
          break;
        default:
      }
    };
    scope.checkforConfiguration = function (item) {
      if (scope.payerExtraFileldsList) {
        var data = scope.payerExtraFileldsList.find(function (element) {
          return element.name.toLowerCase() == item.toLowerCase();
        });
        if (data) {
          return true;
        } else {
          return false;
        }
      } else
        return false;
    }
    scope.formSchemeSelection = function (item, value) {
      scope.newAdmissionFormModel = item;
      angular.forEach(scope.govtSchemeType, function (value, index) {
        if (value.name === item)
          scope.govtSchemeType[index].selected = true;
        else
          scope.govtSchemeType[index].selected = false;
      });

      scope.form.isgovtscheme = true;
      scope.form.govtSchemeName = item;
      scope.govtSchemeDistrict(item);
      scope.getPackageList(item)
      scope.admissionFromSearchFlag.govClaim = true;
      scope.admissionFromSearchFlag.typeGovClaim = true;
      scope.admissionFromSearchFlag.hideSomeFields = false;
      if (scope.configuredPayerExtensionFields && scope.configuredPayerExtensionFields.length > 0) {

        var fieldsList = scope.configuredPayerExtensionFields.filter(function (element) {
          return element.schemeCode == item;
        });
        scope.payerExtraFileldsList = fieldsList.map(function (a) {
          return {
            name: a.fieldName,
            isMaster: false
          }
        });
      }

      switch (item) {
        case 'RSBY':
          scope.admissionFromSearchFlag.urnNumber = true;
          scope.admissionFromSearchFlag.urnNumberManipurScheme = false;
          break;
        case 'CMHT':
          scope.admissionFromSearchFlag.urnNumber = false;
          scope.admissionFromSearchFlag.urnNumberManipurScheme = true;
          break;
        case 'MPKAY':
          scope.admissionFromSearchFlag.urnNumber = false;
          scope.admissionFromSearchFlag.urnNumberManipurScheme = false;
          scope.govtSchemeDesignation(item);
          break;
        default:
          scope.admissionFromSearchFlag.urnNumber = false;
          scope.admissionFromSearchFlag.urnNumberManipurScheme = false;
      }
    };

    scope.searchAgain = function () {
      scope.newAdmissionFormData = [];

      if (scope.userObject.userName == '1003736@medibuddy.in' && window.location.hostname === 'uat-plus.medibuddy.in') {
        scope.tpaDetailsObj = scope.configuredTpaList ? scope.configuredTpaList[0] : {
          hospTPAId: 0,
          tpaName: scope.MaTpaName,
          tpaId: scope.MaTPAId
        };
      } else {
        scope.tpaDetailsObj = {
          hospTPAId: 0,
          tpaName: scope.MaTpaName,
          tpaId: scope.MaTPAId
        };
      }
      scope.changeTpa(scope.tpaDetailsObj);
      scope.form.tpaId = scope.MaTPAId;
      scope.createObjForAdmision();
      scope.resetFlag();
      scope.resetData();
      scope.resetFormData();
      scope.fastrack = {};
      scope.govtBenefList = [];
      scope.govSearchValueInModel.urn = '';
      scope.checkboxErrorModel.package = '';
      scope.checkboxErrorModel.error = '';
      scope.checkboxErrorModel.other = '';
      scope.checkboxErrorModel.fingerPrint = '';
      scope.checkboxErrorModel.isSelected = '';
      scope.isgovtschemeForm = false;
      scope.form.isgovtscheme = false;
      scope.isShowMaid = true;
      scope.totalListOfPackage = [];
    };

    scope.joinReason = function () {
      var reason = '';
      if (scope.checkboxErrorModel) {
        if (scope.checkboxErrorModel.package) {
          reason = 'Package';
        }
        if (scope.checkboxErrorModel.error) {
          if (reason === '') {
            reason = 'Erro';
          } else {
            reason = reason + ',' + 'Erro';
          }
        }
        if (scope.checkboxErrorModel.other) {
          if (reason === '') {
            reason = 'Other';
          } else {
            reason = reason + ',' + 'Other';
          }
        }
        if (scope.checkboxErrorModel.fingerPrint) {
          if (reason === '') {
            reason = 'FingerPrint';
          } else {
            reason = reason + ',' + 'FingerPrint';
          }
        }
      }
      return reason;
    };

    // scope.getDetailsWithMaid = function (maid, benefName, memberid) {
    //   if (maid && benefName) {
    //     var data = {
    //       hospId: UserService.getHospitalObj().hospId,
    //       maid: maid,
    //       beneficiaryName: benefName,
    //       memberId: memberid
    //     }
    //     UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails', data, 'POST').
    //     then(function (response) {
    //       debugger;
    //       ga('send', 'event', 'BeneficiarySearch', 'SearchByMaid', JSON.stringify(data));
    //       if (response.data.isSuccess) {
    //         scope.fastrack.name = response.data.benefs.name;
    //         scope.newAdmissionSearch.benefRelationList = response.data.benefList;
    //         angular.forEach(scope.newAdmissionSearch.benefRelationList, function (value, key) {
    //           scope.newAdmissionSearch.benefRelationList[key].isSelected = false;
    //         })
    //         scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
    //       } else {
    //         scope.fastrack.error = true;
    //       }
    //     });
    //   }
    // };
    scope.getBenefDetailsForOtherPayer = function () {
      var data = {
        employeeId: scope.fastrack.employeeId,
        corporateName: scope.fastrack.corporateName,
        beneficiaryName: scope.newAdmissionSearch.benefName,
        maid: 0,
        memberId: scope.newAdmissionSearch.memberId,
        policyNo: scope.fastrack.PolicyNo,
        hospId: 0,
        tpaId: scope.form.tpaId,
        emailId: scope.fastrack.emailId,
        mobileNo: scope.fastrack.mobileNo
      };

      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails', data, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          // scope.fastrack.displaySubmit = false;
          // scope.fastrack.error = false;
          // scope.benefRelationData = response.data.benefs;
          // scope.fastrack.name = response.data.benefs.benefName;
          // scope.newAdmissionSearch.benefRelationList = response.data.relations;
          // angular.forEach(scope.newAdmissionSearch.benefRelationList, function (value, key) {
          //   scope.newAdmissionSearch.benefRelationList[key].isSelected = false;
          // })
          // scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
          scope.otherPayerBenefList = response.data.benefList;

        } else {
          scope.fastrack.error = true;
        }
      });
    }
    // scope.getDetailsWithEmpId = function (empid, corpname, benefname) {
    //   if (empid && corpname && benefname && UserService.getHospitalObj()) {
    //     var data = {
    //       hospId: UserService.getHospitalObj().hospId,
    //       employeeId: empid,
    //       corporateName: corpname,
    //       BeneficiaryName: benefname
    //     }
    //     UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails.json', data, 'POST').
    //     then(function (response) {
    //       ga('send', 'event', 'BeneficiarySearch', 'SearchByEmployeeId', JSON.stringify(data));
    //       if (response.data.isSuccess) {
    //         scope.fastrack.displaySubmit = false;
    //         scope.fastrack.error = false;
    //         scope.benefRelationData = response.data.benefs;
    //         scope.fastrack.name = response.data.benefs.benefName;
    //         scope.newAdmissionSearch.benefRelationList = response.data.benefList;
    //         angular.forEach(scope.newAdmissionSearch.benefRelationList, function (value, key) {
    //           scope.newAdmissionSearch.benefRelationList[key].isSelected = false;
    //         })
    //         scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
    //       } else {
    //         scope.fastrack.error = true;
    //       }
    //     });
    //   } else {

    //   }
    // };

    // scope.getDetailsWithPolicy = function (policyno, benefname) {
    //   if (policyno && benefname) {
    //     var data = {
    //       hospId: UserService.getHospitalObj().hospId,
    //       PolicyNo: policyno,
    //       BeneficiaryName: benefname
    //     } //getEcardWithPolicyNo
    //     UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails.json', data, 'POST').
    //     then(function (response) {
    //       ga('send', 'event', 'BeneficiarySearch', 'SearchByPolicy', JSON.stringify(data));
    //       if (response.data.isSuccess) {
    //         scope.fastrack.displaySubmit = false;
    //         scope.fastrack.error = false;
    //         scope.fastrack.name = response.data.benefs.benefName;
    //         scope.newAdmissionSearch.benefRelationList = response.data.benefList;
    //         angular.forEach(scope.newAdmissionSearch.benefRelationList, function (value, key) {
    //           scope.newAdmissionSearch.benefRelationList[key].isSelected = false;
    //         })
    //         scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
    //       } else {
    //         scope.fastrack.error = true;
    //       }
    //     });
    //   }
    // };

    scope.getBenefDetails = function (payload, benefname, type) {
      var data = {};
      if (payload && benefname) {
        switch (type) {
          case 'contactNo':
            data = {
              // hospId: UserService.getHospitalObj().hospId,
              mobileNo: payload,
              patientName: benefname
            }
            break;
          case 'email':
            data = {
              // hospId: UserService.getHospitalObj().hospId,
              emailId: payload,
              patientName: benefname
            }
            break;
          case 'policy':
            data = {
              // hospId: UserService.getHospitalObj().hospId,
              policyNo: payload,
              patientName: benefname
            }
            break;
          case 'employeeID':
            data = {
              // hospId: UserService.getHospitalObj().hospId,
              employeeCode: payload.employeeId,
              policyHolderName: payload.corporateName,
              patientName: benefname
            }
            break;
          case 'maid':
            data = {
              // hospId: UserService.getHospitalObj().hospId,
              memberId: payload,
              patientName: benefname,
            }
            break;
          default:
            data = {}
        }
      }
      if (Object.keys(data).length) {
        // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails.json', data, 'POST').
        UserService.makeRestCall(UtilitiesService.getPlusUrl() + 'Provider/Beneficiary/Search', data, 'POST', UserService.getAccessToken()).
          then(function (response) {
            ga('send', 'event', 'BeneficiarySearch', 'SearchBy' + type, JSON.stringify(data));
            if (response.data.isSuccess) {
              scope.fastrack.displaySubmit = false;
              scope.fastrack.error = false;
              // scope.fastrack.name = response.data.benefs.benefName;
              scope.newAdmissionSearch.benefRelationList = response.data.benefList;
              angular.forEach(scope.newAdmissionSearch.benefRelationList, function (value, key) {
                scope.newAdmissionSearch.benefRelationList[key].isSelected = false;
              })
              // scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
            } else {
              scope.fastrack.error = true;
            }
          });
      }
    }

    scope.govtBenefList = [];

    scope.govReadonly = function () {
      return scope.govtBenefList.length > 0 ? true : false;
    };

    scope.onDesignationSelection = function (data) {
      if (data) {
        scope.form.roomtype = data.roomCategory;
        angular.forEach(scope.govtPackageList, function (e) {
          var key = (data.roomCategory.replace(" ", "")).toLowerCase();
          e.packageCost = e[key];
          e.govPackageName = e.packageName + "," + e.packageCost;
        })
        // scope.govtPackageList=scope.govtPackageList._where
      }
    }

    scope.pushToProperties = function (name, value) {
      if (name && value && ((typeof value == 'object' && !Array.isArray(value)) || (value.length > 0) || typeof value != 'object')) {
        if (!scope.formProperties) {
          scope.formProperties = [];
        }
        if (scope.formProperties && scope.formProperties.length > 0) {
          scope.formProperties = scope.formProperties.filter(function (ele) {
            return ele.fieldName != name;
          });
        }

        var payerField = scope.payerExtraFileldsList.find(function (element) {
          return element.name.toLowerCase() == name.toLowerCase()
        });
        scope.formProperties.push({
          fieldName: name,
          fieldValue: value,
          isMaster: payerField ? payerField.isMaster : false
        });
      } else if (name && !value || (value && value.length == 0)) {
        if (scope.formProperties && scope.formProperties.length > 0) {
          scope.formProperties = scope.formProperties.filter(function (ele) {
            return ele.fieldName != name;
          });
        }
      }
    }

    scope.getDetailsWithGov = function (id, type, govtSchemeType) {
      var data = {
        URN: id ? id : '',
        schemeType: scope.selectedSchemeForGov ? scope.selectedSchemeForGov : '',
        memberNameAPBY: type ? type : '',
        govtSchemeType: scope.form.govtSchemeName ? scope.form.govtSchemeName : ''
      }

      scope.govtBenefList = [];
      scope.fastrack.error = false;
      if (data.URN) {
        FastrackService.getDetailsWithGov(data).
          then(function (response) {
            if (response.data.isSuccess) {
              scope.isSearch = false;
              scope.fastrack.error = false;
              scope.govtBenefList = response.data.govtBenefList;
              scope.govtBenefList.forEach(function (obj) {
                obj.displayName = obj.urn + " (" + obj.memberName + ")";
              });
              //if(scope.govtBenefList.length >0){
              // var govtBenefList = _.first(scope.govtBenefList);
              // scope.fastrackPopulateNewAdmissionGov(govtBenefList);
              //}
            } else {
              scope.fastrack.error = true;
              scope.fastrack.errorMessage = response.data.errorMessage;
            }
          }, function (response) {
            scope.fastrack.error = true;
          });
      } else {

      }
    };
    scope.noOfDays = 1;
    scope.newAdmissionFormModel = '';
    scope.totalGovClaimAmount = function () {
      scope.totalCalcAmount = 0;
      angular.forEach(scope.govPackageData, function (data, index) {
        if (data.packageCost) {
          if (data.isPerDayEligiblePackage === true) {
            var oneDay = 24 * 60 * 60 * 1000;
            var noOfDays = Math.round(Math.abs((scope.form.dod.getTime() - scope.form.doa.getTime()) / (oneDay)));
            scope.noOfDays = noOfDays;
            var isPerDayEligiblePrice = 0;
            if (noOfDays === 0) {
              isPerDayEligiblePrice = parseInt(data.packageCost)
              scope.noOfDays = 1;
            } else
              isPerDayEligiblePrice = parseInt(data.packageCost) * (noOfDays)
            scope.totalCalcAmount = scope.totalCalcAmount + isPerDayEligiblePrice;
          } else
            scope.totalCalcAmount = scope.totalCalcAmount + parseInt(data.packageCost);
        }
      });
      return scope.totalCalcAmount;
    };

    scope.isSelectedGov = false;
    scope.priceForGovPackage = [];
    scope.govPackageData = [];
    scope.selectedGovPackage = '';
    scope.selectGovePackage = function (item, model) {
      scope.isSelectedGov = true;
      scope.selectedGovPackage = '';
      scope.priceForGovPackage = [];
      if (item) {
        scope.selectedGovPackage = item;
        var data = {
          price: item.packageCost
        }
        scope.priceForGovPackage.push(data);
        if (scope.priceForGovPackage.length === 1) {
          scope.govPackageManually.price = scope.priceForGovPackage[0].price;
        }

      } else {
        scope.isSelectedGov = false;
      }
    };
    scope.govPackageManually = {
      name: '',
      price: ''
    }

    scope.addGovPackageManually = function (name, govPackage, flag) {
      if (scope.govPackageData.length <= 2) {
        if (flag) {
          //var govtPackageList = _.where(scope.govPackageData, {packageId: scope.selectedGovPackage.packageId});
          // if(govtPackageList.length >0){
          //      scope.govPackageData.push(scope.selectedGovPackage);
          //     // UtilitiesService.showAlertMessage('Duplicate line item is not allowed.');
          // }else{
          scope.govPackageData.push(scope.selectedGovPackage);
          //}
          scope.isSelectedGov = false;
        } else {
          var data = {
            cappedAmount: 0,
            govPackageName: name,
            packageCost: parseInt(govPackage.price),
            packageId: 0,
            packageName: name,
            type: ''
          }
          var govtPackageList = _.where(scope.govPackageData, {
            packageName: data.packageName
          });
          if (govtPackageList.length > 0) {
            UtilitiesService.showAlertMessage('Duplicate line item is not allowed.');
          } else {
            scope.govPackageData.push(data);
          }
        }
      } else {
        UtilitiesService.showAlertMessage('Maximum of 3 packages allowed.');
      }
      scope.isSelectedGov = false;
      scope.selectedGovPackage = '';
      scope.govPackageManually.price = '';
      scope.govPackageManually.name = '';
      scope.form.govPackagesname = '';
      scope.form.clmamount = scope.totalGovClaimAmount();
      if (scope.govPackageData) {
        var packages = scope.govPackageData.map(function (item) {
          return item.packageName + " - " + item.packageCost
        });

        scope.pushToProperties('Packages', packages.join());
      }
    };

    scope.removeGovPackage = function (data) {
      if (data) {
        angular.forEach(scope.govPackageData, function (value, index) {
          if (value.packageId === data.packageId || value.packageName === data.packageName) {
            scope.govPackageData.splice(index, 1);
          }
        });
        scope.form.clmamount = scope.totalGovClaimAmount();
      }
    };

    scope.mobileValidation = function (number) {
      if (number) { } else { }
    };

    scope.openDoa = function () {
      scope.datePopup.doa = true;
    };

    scope.openDateOfSurgery = function () {
      scope.datePopup.surgeryDate = true;
    };

    scope.openDod = function () {
      scope.datePopup.dod = true;
    };

    scope.openDateOfDiagnosis = function () {
      scope.datePopup.dateofDiagnosis = true;
    }

    scope.openMaternityLMP = function () {
      scope.datePopup.maternityLMP = true;
    }
    scope.openMaternityEDD = function () {
      scope.datePopup.maternityEDD = true;
    }
    scope.openDateOfPastAilment = function () {
      scope.datePopup.pastAilmentDate = true;
    }

    scope.changeTpa = function (obj) {
      scope.resetFormData();
      scope.isShowMaid = true;
      scope.getPayerRoomCategories();
      scope.getPayerMasterData();
      if (obj) {
        // Check for Mediassist
        if (obj.configuredFields)
          scope.payerExtraFileldsList = obj.configuredFields;
        if (obj.tpaId === scope.MaTPAId || obj.isBenefSearchConfigured) {
          scope.isSearchProcedure = true;
          scope.isShowMaid = obj.isBenefSearchConfigured ? false : true;
          scope.isSearchButton = true;
          scope.form.tpaId = obj.tpaId ? obj.tpaId : 0;
          scope.form.hospTPAId = obj.hospTPAId ? obj.hospTPAId : 0;
          scope.form.tpaName = obj.tpaName ? obj.tpaName : '';
          scope.reasonOnlineField = 'procedure';
        } else {
          scope.isShowMaid = false;
          scope.isSearchButton = obj ? false : true;
          scope.isSearchProcedure = false;
          scope.reasonOnlineField = 'others';
          scope.formSelection('Add Manually', '', true);
          scope.form.tpaId = obj.tpaId ? obj.tpaId : 0;
          scope.form.hospTPAId = obj.hospTPAId ? obj.hospTPAId : 0;
          scope.form.tpaName = obj.tpaName ? obj.tpaName : '';
        }

      } else {
        scope.form.hospTPAId = 0;
        scope.form.tpaId = 0;
      }

      scope.createObjForAdmision();
    };

    scope.getInsurersCompanyList = function () {
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/insurers', '', 'GET').then(function (response) {
        if (response.data) {
          scope.insurerList = response.data.insurerList;
          scope.insurerList = _.sortBy(scope.insurerList, function (num) {
            return num.id > 0;
          });
        }
      }, function (error) {
        scope.insurerList = [];
      });
    };

    scope.getInsurersCompanyList();

    scope.getRoomsDetails = function () {
      var ajaxData = {
        hospId: UserService.getHospitalObj().hospId,
        getDoctors: false,
        getRooms: true,
        getOpPackages: false,
        getContracts: false
      };
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/hospProfileDetails', ajaxData, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          scope.roomsDetails = response.data.hospRoomDetails;
        }
      }, function (error) {
        scope.roomsDetails = [];
      });
    };

    scope.getDoctorDetails = function () {
      var ajaxData = {
        hospId: UserService.getHospitalObj().hospId,
        getDoctors: true,
        getRooms: true,
        getOpPackages: false,
        getContracts: false
      };
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/hospProfileDetails', ajaxData, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          scope.doctorDetails = response.data.hospDoctorDetails;
          scope.getRoomsDetails();
        }
      }, function (error) {
        scope.doctorDetails = [];
        scope.getRoomsDetails();
      });
    };

    scope.getDoctorDetails();

    scope.getPackageList = function (value) {
      var govPackage = UserService.getGovtPackageList();
      if (value) {
        var data = {
          priEntityName: '',
          priEntityId: UserService.getUserObj().entityId,
          secEntityName: 'Medi Assist',
          secEntityId: 0,
          schemeType: value
        };
        // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/packagesbtnentities/list', data, 'POST', UserService.getAccessToken()).then(function (response) {
        //   if (response.data.isSuccess) {
        //     scope.govtPackageList = response.data.packages;
        //     angular.forEach(scope.govtPackageList, function (e) {
        //       e.govPackageName = e.packageName + "," + e.packageCost;
        //     })
        //   } else {
        //     scope.govtPackageList = [];
        //   }
        // });
      }
    };
    scope.govtChecked = function (data) {
      scope.form.packageAmount = '';
      scope.selectedSchemeForGov = 'RSBYHospitals_Mediassist';
      scope.form.isgovtscheme = !!scope.form.isgovtscheme;
      if (data) {
        scope.selectedSchemeForGov = data;
        scope.form.isgovtscheme = true;
      }
    };

    scope.onSelectPackages = function ($item, $model, $label) {
      if ($item) {
        scope.selectedMappedpackages.push($item);
        scope.selectedMappedpackages = _.uniq(scope.selectedMappedpackages);
        angular.forEach(scope.selectedMappedpackages, function (data, index) {
          scope.selectedMappedpackages[index].general_Ward1 = data.general_Ward1 === true ? true : false;
          scope.selectedMappedpackages[index].private_Ward1 = data.private_Ward1 === true ? true : false;
          scope.selectedMappedpackages[index].semi_Private_Ward1 = data.semi_Private_Ward1 === true ? true : false;
          scope.selectedMappedpackages[index].uniqueIds = index + 1;
        })
      }
    };

    scope.onSelectDoctor = function ($item, $model, $label) {
      scope.form.docRegNo = $item.doctorRegNo;
      scope.form.docQualification = $item.doctorQualification;
      scope.pushToProperties('docName', $item.doctorName);
      scope.pushToProperties('docRegNo', scope.form.docRegNo);
      scope.pushToProperties('docQualification', scope.form.docQualification);
    }

    scope.totalClaimAmount = function () {
      scope.totalCalcAmount = 0;
      angular.forEach(scope.selectedMappedpackages, function (data, index) {
        if (data.packageAmount) {
          scope.totalCalcAmount = scope.totalCalcAmount + parseInt(data.packageAmount);
        }
      });
      //_.reduce(scope.selectedMappedpackages, function(memo, num){  return memo + parseInt(num.packageAmount);  }, 0);
      scope.CLAIMED_AMOUNT = scope.totalCalcAmount;
      scope.form.clmamount = scope.totalCalcAmount;
      return scope.totalCalcAmount;
    };

    scope.calculatePrice = function () {
      scope.packageCalcAmount = 0;
      angular.forEach(scope.selectedMappedpackages, function (data, index) {
        if (data.packageAmount) {
          scope.packageCalcAmount = scope.packageCalcAmount + data.packageAmount;
        }
      });
      scope.form.clmamount = scope.totalClaimAmount();
    };

    scope.calculateTotalAmountValue = function () {
      scope.CLAIMED_AMOUNT1 = 0;
      angular.forEach(scope.savedBillDetails, function (data, index) {
        if (data.packageAmount) {
          scope.CLAIMED_AMOUNT1 = scope.CLAIMED_AMOUNT1 + parseInt(data.packageAmount);
        }
      });
      return scope.CLAIMED_AMOUNT1;
    };

    scope.calculateTotalAmount = function () {
      scope.packageAmount = 0;
      angular.forEach(scope.savedBillDetails, function (data, index) {
        if (data.packageAmount) {
          scope.packageAmount = scope.CLAIMED_AMOUNT + parseInt(data.packageAmount);
        }
      });
      return scope.totalClaimAmount(scope.packageAmount)
    };

    scope.changePackageField = function (value) {
      scope.form.procedure1 = '';
      scope.form.mPackageTotalAmount = '';
      scope.form.mPackageFullName = '';
      scope.reasonOnlineField = value;
    };

    scope.AddProcedure = function (name, price) {
      if (name && price) {
        var obj = {
          deluxe_Other: 0,
          general_Ward: parseInt(price),
          general_Ward1: true,
          packageId: 0,
          package_Name: name,
        }
        scope.selectedMappedpackages.push(obj);
        scope.calculatePrice();
        scope.onSelectPackages(obj);
        scope.form.mPackageTotalAmount = '';
        scope.form.mPackageFullName = '';
      } else {
        UtilitiesService.showAlertMessage('Please enter treatment details and amount .');
      }
    };

    scope.changeGovtPolicyType = function (type) {
      scope.form.packageAmount = '';
      scope.form.mPackageAmount = '';
      scope.form.packageName = '';
      scope.form.packageUniqueId = '';
      scope.form.cappedAmount = '';
      scope.text = '';
      if (type) {
        if (type === 'Basic') {
          var obje = [];
          angular.forEach(scope.govtPackageListDummy, function (value, key) {
            if (type === value.type) {
              value.govPackageName = value.packageName + ' , ' + value.packageCost;
              obje.push(value);
            }
          });
          scope.govtPackageList = obje;
        } else if (type === 'Critical') {
          var obje = [];
          angular.forEach(scope.govtPackageListDummy, function (value, key) {
            if (type === value.type) {
              value.govPackageName = value.packageName + ' , ' + value.packageCost;

              obje.push(value);
            }
          });
          scope.govtPackageList = obje;
        }
      }
    };

    scope.addTpa = function (type) {
      angular.element("#addTPA").modal('show');
    };

    scope.resetAlertMessage = function () {
      timeout(function () {
        scope.$apply(function () {
          scope.isSuccess = false;
          scope.isError = false;
        });
      }, 6000)
    };

    scope.saveTpaDetails = function (tpaForm) {
      if (UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId && tpaForm.name.id !== 0) {
        var data = {
          hospId: UserService.getHospitalObj().cmsHospId,
          tpaName: tpaForm.name.value,
          tpaId: tpaForm.name.id,
          mailServerAddress: tpaForm.mailServerAddress,
          mailServerPort: tpaForm.mailServerPort,
          useSSl: true,
          hospMailId: tpaForm.hospMailId,
          hospPassword: tpaForm.hospPassword,
          tpaMailId: tpaForm.tpaMailId,
          outGoingServerPort: tpaForm.outGoingServerPort,
          tpaHospId: tpaForm.tpaHospId,
          outGoingServerAddress: tpaForm.outGoingServerAddress
        }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tpa', data, 'POST', true).then(function (response) {
          if (response.data.isSuccess) {
            scope.tpaFormReset();
            scope.getTpaList();
            scope.isSuccess = true;
            scope.isSuccessMsg = 'TPA has been Added successfully!.';
            scope.resetAlertMessage();
          } else {
            scope.isError = true;
            scope.tpaErrorMsg = 'oops! something went wrong, please try again later.';
            scope.resetAlertMessage();
          }
        }, function (error) {
          scope.isError = true;
          scope.tpaErrorMsg = 'oops! something went wrong, please try again later.';
          scope.resetAlertMessage();
        });
      } else {
        scope.isError = true;
        scope.tpaErrorMsg = 'Please select TPA name.';
        scope.resetAlertMessage();
      }
    };

    scope.fastrackPreauthGovSeaarch = function (type) {
      scope.radioFastTrack = '';
      scope.govSearchValueInModel.apbyname = '';
      scope.govSearchValueInModel.urn = '';
      angular.element("#newMSBYSearch").modal('show');
      scope.fastrack = {};
      scope.fastrack.displaySubmit = true;
      switch (type) {
        case 'gov':
          scope.fastrack.title = 'Gov Search';
          scope.aarogyachecked = false;
          scope.govSearch = true;
          scope.isGov = true;
          scope.govtBenefList = [];
          scope.epic = '';
          scope.urn = '';
          scope.fastrack.showCorpName = false;
          scope.fastrack.employerSearchTitle = 'Employee ID';
          break;
      }
    };

    scope.fastrackPreauth = function (type) {
      angular.element("#newPreauthModal").modal("show");
      scope.fastrack = {};
      scope.fastrack.displaySubmit = true;
      switch (type) {
        case 'aarogya':
          scope.fastrack.title = 'Aarogya Scheme';
          scope.aarogyachecked = true;
          scope.govSearch = false;
          scope.isGov = false;
          scope.fastrack.showCorpName = false;
          scope.fastrack.employerSearchTitle = 'Family Number';
          break;
        case 'generic':
          scope.fastrack.title = 'Member Search';
          scope.aarogyachecked = false;
          scope.govSearch = false;
          scope.isGov = false;
          scope.fastrack.showCorpName = true;
          scope.fastrack.employerSearchTitle = 'Employee ID';
          break;
        case 'gov':
          scope.fastrack.title = 'Gov Search';
          scope.aarogyachecked = false;
          scope.govSearch = true;
          scope.isGov = true;
          scope.govtBenefList = [];
          scope.epic = '';
          scope.urn = '';
          scope.fastrack.showCorpName = false;
          scope.fastrack.employerSearchTitle = 'Employee ID';
          break;
      }
      if (scope.aarogyachecked) {
        scope.fastrack.corporateName = 'Manipal';
      }
    };

    scope.searchGov = function (type) {
      if (type === 'URN') {
        scope.isURN = true;
        scope.isEpic = false;
        scope.epic = '';
        scope.govtBenefList = [];
      } else if (type === 'Epic') {
        scope.isURN = false;
        scope.isEpic = true;
        scope.urn = '';
        scope.govtBenefList = [];
      } else if (type === 'MemberNameAPBY') {
        scope.isURN = false;
        scope.isMemberNameAPBY = true;
        scope.urn = '';
        scope.govtBenefList = [];
      } else {
        scope.isURN = false;
        scope.epic = '';
        scope.urn = '';
        scope.isEpic = false;
      }
    };

    scope.resetModel = function () {
      scope.govtBenefList = [];
      scope.fastrack.error = false;
    };

    scope.fastrackPopulateNewAdmissionGov = function (data) {
      if (data) {
        scope.form.fullname = data.memberName;
        scope.form.memberId = data.memberID;
        scope.form.URNNum = data.urn;
        scope.form.memberGender = data.gender == 'f' ? 'female' : data.gender == 'm' ? 'male' : '';
        scope.form.isgovtscheme = true;
        scope.admissionFromSearchFlag.openDetailsTab = true;
        scope.form.memberDist = data.districtName;
        scope.form.aadharNo = data.aadharCardNo;
        scope.form.memberAge = data.age;
      }
    };

    scope.removePackageFromList = function (item) {
      if (item) {
        angular.forEach(scope.selectedMappedpackages, function (data, index) {
          if (data.uniqueIds > 0) {
            if (item.uniqueIds === data.uniqueIds) {
              scope.selectedMappedpackages.splice(index, 1);
            }
          } else {
            if (item.hospitaL_CHARGE_HEAD === data.hospitaL_CHARGE_HEAD) {
              scope.selectedMappedpackages.splice(index, 1);
            }
          }
        })
        if (item.uniqueIds > 0) {
          scope.removeData = item;
        }
        scope.calculateTotalAmount();
      }
    };

    scope.closeButton = function () {
      scope.isDuplicate = false;
      scope.isNewCategories = false;
      scope.dynamicFields.name = '';
      scope.dynamicFields.price = '';
    };

    scope.addMoreCategories = function (flag, data, selectedObject) {
      scope.isDuplicate = false;
      if (flag) {
        var value = _.filter(scope.availableBills, function (item) {
          return item.hospitalBillDesc.toLowerCase() === data.name.toLowerCase()
        }).length;
        if (value === 0) {
          if (selectedObject && data.name === selectedObject.hospitaL_CHARGE_HEAD) {
            selectedObject.CLAIMED_AMOUNT = data.price;
            scope.availableBills.push(selectedObject);
            scope.selectedObject = '';
          } else {
            scope.availableBills.push({
              PROVIDER_BILL_ITEM_NAME: '',
              BILL_ITEM_DETAIL_REF: '',
              DETAIL_BILL_ITEM_CLAIM_ID: '',
              DETAIL_BILL_ITEM_PREAUTH_NO: '',
              CLAIMED_AMOUNT: data.price,
              CMS_CHARGE_TYPE_ID: 4,
              CMS_CHARGE_TYPE_DESC: 'Miscellaneous Charges',
              CMS_SUBCHARGE_TYPE_ID: 53,
              CMS_SUBCHARGE_TYPE_DESC: 'Other Miscellaneous Charges',
              hospitaL_CHARGE_HEAD: data.name,
              hospitalBillDesc: data.name,
              isReadOnly: false,
              isPackage: false,
              uniqueIds: '',
              packageId: ''
            });
          }
          angular.forEach(scope.typaheadData, function (v, index) {
            if (v.hospitalBillDesc === data.name) {
              scope.typaheadData.splice(index, 1);
            }
          });
          scope.typaheadData = _.uniq(scope.typaheadData);
          scope.typaheadData = _.reject(scope.typaheadData, function (num) {
            return num.isPackage === true;
          });
          scope.dynamicFields.name = '';
          scope.dynamicFields.price = '';
          scope.calculateTotalAmount();
        } else {
          scope.isDuplicate = true;
        }

      } else {
        scope.isNewCategories = true;
      }
    };

    scope.removeCategories = function (data) {
      angular.forEach(scope.availableBills, function (key, index) {
        if (key.hospitalBillDesc === data.hospitalBillDesc) {
          scope.availableBills.splice(index, 1);
          if (key.isPackage) {
            scope.removePackageFromList(data);
          }
        }
      });
      scope.calculateTotalAmount();
    };

    scope.saveDetails = function () {
      scope.calculateTotalAmount();
      angular.element('#addBillDetails').modal('hide');
    };

    scope.closeModal = function () {
      scope.availableBills = [];
      scope.CLAIMED_AMOUNT = 0;
      scope.calculateTotalAmount();
      angular.element('#addBillDetails').modal('hide');
    };

    scope.getBillDetailsPopup = function (modelPopup) {
      scope.modelPopup = {
        text: modelPopup
      }
      var modelPopup = '#' + scope.modelPopup.text;
      angular.element(modelPopup).appendTo('body');
      angular.element(modelPopup).modal('show');
    };

    scope.validate = function () {
      var result = true;
      angular.forEach(scope.availableBills, function (key, index) {
        if (!key.CLAIMED_AMOUNT)
          return result = false;
      });
      if (result)
        return result;
    };

    scope.typeProcedureName = function () {
      scope.isPriceDropDown = false;
      scope.isSelectedGov = false;
    };

    scope.selectPackageFromList = function (item, model) {
      scope.priceForPackage = [];
      scope.selectedPackagesData = '';
      scope.selectedManualData = '';
      if (item && item.distinctPrices) {
        scope.selectedPackagesData = item;
        if (item.deluxe_Other > 0) {
          scope.priceForPackage.push({
            name: 'Delux room',
            price: item.deluxe_Other,
            showName: item.deluxe_Other + '(Delux room)',
            typeId: 4
          })
        }
        if (item.general_Ward > 0) {
          scope.priceForPackage.push({
            name: 'General room',
            price: item.general_Ward,
            showName: item.general_Ward + '(General room)',
            typeId: 1
          })
        }
        if (item.private_Ward > 0) {
          scope.priceForPackage.push({
            name: 'Private room',
            price: item.private_Ward,
            showName: item.private_Ward + '(Private room)',
            typeId: 3
          })
        }
        if (item.semi_Private_Ward > 0) {
          scope.priceForPackage.push({
            name: 'Semi private room',
            price: item.semi_Private_Ward,
            showName: item.semi_Private_Ward + '(Semi private room)',
            typeId: 2
          })
        }
        scope.isPriceDropDown = true;
        var uniqPrice = unique(scope.priceForPackage, 'price');
        if (uniqPrice && uniqPrice.length == 1) {
          scope.procedureManually.price = scope.priceForPackage[0];
          scope.form.roomtype = scope.procedureManually.price.name;
          scope.pushToProperties('roomcategoryid', scope.procedureManually.price.typeId);
        }
      } else {
        scope.selectedManualData = item;
        scope.priceForPackage = [];
        scope.isPriceDropDown = false;
      }
    };
    scope.selectRoomPrice = function (obj) {
      if (obj) {
        scope.form.roomtype = obj.name;
        scope.pushToProperties('roomcategoryid', obj.typeId);
      }
    }
    scope.changeDiagnosisType = function () {
      scope.getMappedpackages();
      scope.form.cataractType = null;
      scope.form.maternityType = null;
      scope.getReason = false;
      scope.isPriceDropDown = false;
      scope.procedureManually.price = null;
      scope.procedureManually.name = null;
    }

    function unique(arr, prop) {
      return arr.map(function (e) {
        return e[prop];
      }).filter(function (e, i, a) {
        return i === a.indexOf(e);
      });
    }
    scope.addManuallyProcedure = function (data, type) {
      if (data && data.name && data.price && scope.selectedPackagesData && type === true) {
        scope.isPriceDropDown = false;
        scope.priceForPackage = [];
        var selectedPackageList = [];
        //if(_.where(scope.selectedMappedpackages, {packageId: scope.selectedPackagesData.packageId}).length >=1){
        //UtilitiesService.showAlertMessage('Duplicate line item is not allowed.');
        //}else{
        scope.selectedMappedpackages.push({
          packageName: data.name,
          packageId: scope.selectedPackagesData.packageId,
          packageAmount: parseInt(data.price && data.price.price ? data.price.price : data.price),
          packageCappedAmount: 0,
          cmS_CHARGE_TYPE_ID: 0,
          cmS_CHARGE_TYPE_DESC: '',
          cmS_SUBCHARGE_TYPE_ID: 0,
          cmS_SUBCHARGE_TYPE_DESC: '',
          hospitaL_CHARGE_HEAD: data.name,
          isReadOnly: scope.selectedPackagesData.packageId > 0 ? true : false,
          isPackage: scope.selectedPackagesData.packageId > 0 ? true : false,
          mandatoryDocuments: data.mandatoryDocuments
        });
        //}
        scope.selectedPackagesData = '';
        scope.procedureManually.name = '';
        scope.procedureManually.price = '';
        scope.calculatePrice();
      } else {
        if (data && data.name && data.price && type === false) {
          scope.isPriceDropDown = false;
          scope.priceForPackage = [];
          var selectedPackageList = [];
          if (_.where(scope.selectedMappedpackages, {
            packageName: data.name
          }).length >= 1) {
            UtilitiesService.showAlertMessage('Duplicate line item is not allowed.');
          } else {
            scope.selectedMappedpackages.push({
              packageName: data.name,
              packageId: 0,
              packageAmount: parseInt(data.price),
              packageCappedAmount: 0,
              cmS_CHARGE_TYPE_ID: 0,
              cmS_CHARGE_TYPE_DESC: '',
              cmS_SUBCHARGE_TYPE_ID: 0,
              cmS_SUBCHARGE_TYPE_DESC: '',
              hospitaL_CHARGE_HEAD: data.name,
              isReadOnly: false,
              isPackage: false
            });
          }
          scope.procedureManually.name = '';
          scope.procedureManually.price = '';
          scope.selectedManualData = '';
          scope.calculatePrice();
        } else {
          UtilitiesService.showAlertMessage('Please enter name and price.');
        }
      }
    };

    scope.getMappedpackages = function (details, icdCode) {
      scope.mappedpackages = [];
      scope.packageListing = [];
      scope.selectedMappedpackages = [];
      scope.calculatePrice();
      scope.isPriceOne = false;
      scope.isPriceTow = false;
      scope.isPriceThree = false;
      if (UserService.getHospitalObj()) {
        var data = {
          hospitalId: UserService.getHospitalObj().cmsHospId,
          insurerShortName: details,
          icdCode: icdCode
          //--details
          //'NIA'
        }
        scope.newPackageListData = [];
        // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/mappedpackages', data, 'POST', UserService.getAccessToken()).then(function (response) {
        //   if (response.data.isSuccess) {
        //     scope.availableBills = [];
        //     angular.forEach(response.data.availableBills, function (key, index) {
        //       if (key.isDefault) {
        //         var data = {
        //           packageName: key.hospitalBillDesc,
        //           package_Name: key.hospitalBillDesc,
        //           packageId: 0,
        //           packageAmount: 0,
        //           packageCappedAmount: 0,
        //           cmS_CHARGE_TYPE_ID: key.intermalBillTypeId,
        //           cmS_CHARGE_TYPE_DESC: key.internalBillTypeDesc,
        //           cmS_SUBCHARGE_TYPE_ID: key.internalSubBillTypeId,
        //           cmS_SUBCHARGE_TYPE_DESC: key.internalSubBillDesc,
        //           hospitaL_CHARGE_HEAD: key.hospitalBillDesc,
        //           isReadOnly: true,
        //           isPackage: false,
        //           uniqueIds: 0
        //         }
        //         scope.availableBills[index] = data;
        //       }
        //     });
        //     var packageListing = response.data.mappedpackages;
        //     if (scope.availableBills && (scope.form.diagnosisOption == 'OTHER' || !scope.form.diagnosisOption)) {
        //       scope.totalListOfPackage = packageListing.concat(scope.availableBills);
        //     } else {
        //       scope.totalListOfPackage = response.data.mappedpackages;
        //       if (scope.form.diagnosisOption && scope.form.diagnosisOption == 'CATARACT') {
        //         angular.forEach(scope.totalListOfPackage, function (data) {
        //           data.aliasName = scope.cataractAliasName;
        //         });

        //         // angular.forEach(scope.totalListOfPackage, function (data, index) {
        //         //   var testObje = [];
        //         //   angular.forEach(data.distinctPrices, function (data1, index1) {
        //         //     testObje.push({
        //         //       isSelected: false,
        //         //       price: data1,
        //         //       packageId: scope.totalListOfPackage[index].packageId
        //         //     })
        //         //   });
        //         //   scope.newPackageListData.push(testObje);
        //         //   scope.totalListOfPackage[index].newPriceObj = testObje;
        //         // });
        //         // angular.forEach(scope.totalListOfPackage, function (data, index) {
        //         //   scope.totalListOfPackage[index].general_Ward1 = false;
        //         //   scope.totalListOfPackage[index].private_Ward1 = false;
        //         //   scope.totalListOfPackage[index].semi_Private_Ward1 = false;
        //         // });
        //       }
        //     }

        //   } else {
        //     scope.totalListOfPackage = [];
        //   }
        // });
      }
    };

    scope.checkForAutomationDiagnosis = function (data) {
      scope.form.diagnosisOptionRemarks = false;
      if (data && data.length > 1 && scope.form.allowedDiagnosisType && scope.form.allowedDiagnosisType.length > 0) {
        var res = scope.cataractAliasName.find(function (item) {
          return item.toLowerCase() == data.toLowerCase();
        })
        if (res) {
          scope.form.diagnosisOptionRemarks = true;
          // scope.form.diagnosisOption = 'CATARACT';
        }

      }
    }

    scope.addTypeAheadPackage = function (data) {

      if (data) {
        if (!scope.selectedMappedpackages)
          scope.selectedMappedpackages = [];

        if (data.packageId > 0) {
          scope.selectedMappedpackages = scope.selectedMappedpackages.filter(function (x) {
            return x.packageId != data.packageId;
          })
        } else if (data.packageName && data.price) {
          scope.selectedMappedpackages = scope.selectedMappedpackages.filter(function (x) {
            return x.packageName != data.packageName && x.price != data.price;
          })

        }

        scope.selectedMappedpackages.push({
          packageName: data.packageName,
          packageId: data.packageId,
          packageAmount: parseInt(data.price),
          packageCappedAmount: 0,
          cmS_CHARGE_TYPE_ID: data.chargeTypeId,
          cmS_SUBCHARGE_TYPE_DESC: data.subChargeType,
          hospitaL_CHARGE_HEAD: data.packageName,
          remarks: data.remarks || null,
          isReadOnly: false,
          isPackage: false
        });

        if (data.icdName && (!scope.form.diagnosisOption || (scope.form.diagnosisOption && scope.form.diagnosisOption == 'OTHER'))) {
          if (scope.cataractAilmentCode.includes(data.icdName)) {
            Notification.info({
              message: 'Selecting the agreed Package/Procedure results in faster, accurate claim processing',
              positionY: 'bottom',
              positionX: 'right'
            });
            var tempData = scope.cataractType.find(function (e) {
              return e.code.toLowerCase() == data.icdName.toLowerCase();
            });
            if (tempData) {
              scope.form.diagnosisOption = 'CATARACT';
              scope.form.cataractType = tempData.id;
              scope.getTreatmentTypeForCataract(tempData.id, true);
            }

          } else if (scope.maternityAilmentCode.includes(data.icdName)) {

            Notification.info({
              message: 'Selecting the agreed Package/Procedure results in faster, accurate claim processing',
              positionY: 'bottom',
              positionX: 'right'
            });


            var tempData = scope.maternityType.find(function (e) {
              return e.code.toLowerCase() == data.icdName.toLowerCase();
            });
            if (tempData) {
              scope.form.diagnosisOption = 'MATERNITY';
              scope.form.maternityType = tempData.id;
              scope.onChangeDeliveryType(tempData.id, true);

            }
          }
        }

        if (data.typeId > 0) {
          scope.form.roomtype = data.roomName;
          scope.pushToProperties('roomcategoryid', data.typeId);
        }
        scope.calculatePrice();

      }
    }

    scope.getPackagesListForInsurer = function (data) {
      if (data) {
        selectedShortName = _.findWhere(scope.insurerList, {
          insurerFullName: data
        });
        scope.getMappedpackages(selectedShortName.insurerShortName);
      }
    };

    //scope.getMappedpackages('NIA');
    scope.fastrackPopulateNewAdmissionForOtherPayer = function (data) {
      // angular.forEach(scope.newAdmissionSearch.benefRelationList, function (v, i) {
      //   if ((v.memberId === data.memberId) && (v.benefName === benefName)) {
      //     scope.newAdmissionSearch.benefRelationList[i].isSelected = true;
      //   } else {
      //     scope.newAdmissionSearch.benefRelationList[i].isSelected = false;
      //   }
      // })
      scope.form.fullname = data.benefName; //generic
      scope.form.employer = data.benefPolHldrName;
      scope.form.empid = data.priBenefEmpCode;
      scope.form.policyno = data.policyNo;
      scope.form.age = data.benefAge;
      scope.form.gender = data.benefSex;
      scope.admissionFromSearchFlag.openDetailsTab = true;
      scope.admissionFromSearchFlag.hideSomeFields = true;
      scope.form.uniqueId = data.memberId;
      // scope.form.insurername = scope.insurerFullName;
    };

    scope.assignBeneficiaryDetails = function (data) {
      angular.forEach(scope.newAdmissionSearch.benefRelationList, function (v, i) {
        if ((v.benefMediAssistID === data.benefMediAssistID) && (v.benefName === data.benefName)) {
          scope.newAdmissionSearch.benefRelationList[i].isSelected = true;
        } else {
          scope.newAdmissionSearch.benefRelationList[i].isSelected = false;
        }
      })
      scope.form.fullname = data.benefName; //generic
      scope.form.employer = data.benefPolHldrName;
      scope.form.empid = data.priBenefEmpCode;
      scope.form.maid = data.benefMediAssistID;
      scope.form.policyno = data.policyNo;
      scope.form.age = data.benefAge;
      scope.form.gender = data.benefSex;
      scope.admissionFromSearchFlag.openDetailsTab = true;
      scope.admissionFromSearchFlag.hideSomeFields = true;
      scope.form.insurername = data.insuranceCompanyName;
      if (data.availableAutomation && data.availableAutomation.length > 0) {
        scope.form.allowedDiagnosisType = data.availableAutomation;
        scope.form.allowedDiagnosisType.push('OTHER');
      }
      scope.isDataPrefilled = true;
      scope.getPackagesListForInsurer(data.insuranceCompanyName);
    }

    scope.fastrackPopulateNewAdmission = function (maid, relationid, name, eCashLess) {
      angular.forEach(scope.newAdmissionSearch.benefRelationList, function (v, i) {
        if ((v.relationId === relationid) && (v.name === name)) {
          scope.newAdmissionSearch.benefRelationList[i].isSelected = true;
        } else {
          scope.newAdmissionSearch.benefRelationList[i].isSelected = false;
        }
      })
      scope.admissionFromSearchFlag.openDetailsTab = true;
      //scope.resetData();
      if (eCashLess.eCashlessReqId === 0) {
        scope.insurerFullName = eCashLess.insurerFullName;
        scope.form.insurername = scope.insurerFullName;
        scope.insurerShortName = eCashLess.insurerShortName;
        FastrackService.fastrackPopulateNewAdmission(maid, relationid, name).
          then(function (response) {
            if (response.data.isSuccess) {
              scope.getMappedpackages(scope.insurerShortName);
              scope.$parent.tempData = response.data.benefs;
              scope.resetFormData();
              scope.fileUploaName = [];
              scope.storeFiles = [];
              scope.form.fileNames = [];
              scope.form.fileUploadFolderPath = [];
              scope.form.fullname = response.data.benefs.benefName; //generic
              scope.form.roomtype = '';
              scope.form.employer = response.data.benefs.benefPolHldrName;
              scope.form.empid = response.data.benefs.priBenefEmpCode;
              scope.form.maid = response.data.benefs.benefMediAssistID;
              scope.form.policyno = scope.fastrack.PolicyNo;
              scope.form.age = response.data.benefs.benefAge;
              scope.form.gender = response.data.benefs.benefSex;
              scope.form.insurername = scope.insurerFullName;
              if (eCashLess && eCashLess.mobileNo) {
                scope.form.mobile = parseInt(eCashLess.mobileNo) ? parseInt(eCashLess.mobileNo) : '';
              }
              angular.element("#newPreauthModal").modal('hide');
            } else {
              scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network issue', 'Error', true);
            }
          }, function (response) {
            scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network issue', 'Error', true);
          });
      } else {
        UtilitiesService.eCashlessReqData = eCashLess;
        scope.isECashLess = true;
        scope.eCashLessMessage = 'There is already a pre-approved request that exists for the patient. Redirecting you to the request. Click yes to continue.';
        timeout(function () {
          scope.$apply(function () {
            scope.isECashLess = false;
            scope.eCashLessMessage = '';
          });
        }, 10000)
      }
    };

    scope.opened = true;
    scope.reDirect = function (value) {
      if (value) {
        angular.element("#newPreauthModal").modal('hide');
        state.go(value, {
          reload: false
        });
      }
    };

    scope.clearfastrack = function () {
      scope.fastrack = {};
      scope.fastrack.displaySubmit = true;
      scope.fastrack.title = 'Member Search';
      scope.aarogyachecked = false;
      scope.fastrack.showCorpName = true;
      scope.fastrack.employerSearchTitle = 'Employee ID';
    };

    scope.removeModal = function () {
      scope.clearfastrack();
      angular.element("#newPreauthModal").modal('hide');
    };

    scope.packageCheck = function (data) {
      var isCheck = true;
      // angular.forEach(data, function (data, index) {
      //     if (!data.packageAmount) {
      //         isCheck = false
      //     }
      // });
      return isCheck;
    };

    scope.treatmentSelection = function (item) {
      if (item) {
        scope.selectTreatmentType = item.name;
      } else {
        scope.selectTreatmentType = '';
      }
    };

    scope.getPackagesForPreAuthForm = function () {
      var packagesForPreAuthForm = scope.selectedMappedpackagesObj(scope.selectedMappedpackages);
      scope.packagesForPreAuthForm = [];
      if (packagesForPreAuthForm) {
        angular.forEach(packagesForPreAuthForm, function (data, index) {
          scope.packagesForPreAuthForm.push(data.packageName);
        });
      }
      return scope.packagesForPreAuthForm.join();
    };

    scope.selectedMappedpackagesObj = function (data) {
      if (data) {
        scope.availableBillsFinalData = [];
        angular.forEach(data, function (v, index) {
          if (v.packageAmount) {
            var packagesList = {
              packageName: v.hospitaL_CHARGE_HEAD ? v.hospitaL_CHARGE_HEAD : '',
              packageId: v.packageId,
              packageAmount: v.packageAmount ? parseInt(v.packageAmount) : 0,
              packageCappedAmount: 0,
              cmS_CHARGE_TYPE_ID: v.cmS_CHARGE_TYPE_ID ? v.cmS_CHARGE_TYPE_ID : '',
              cmS_CHARGE_TYPE_DESC: v.cmS_SUBCHARGE_TYPE_DESC ? v.cmS_SUBCHARGE_TYPE_DESC : '',
              cmS_SUBCHARGE_TYPE_ID: v.cmS_SUBCHARGE_TYPE_ID ? v.cmS_SUBCHARGE_TYPE_ID : '',
              cmS_SUBCHARGE_TYPE_DESC: v.cmS_SUBCHARGE_TYPE_DESC ? v.cmS_SUBCHARGE_TYPE_DESC : '',
              hospitaL_CHARGE_HEAD: v.hospitaL_CHARGE_HEAD ? v.hospitaL_CHARGE_HEAD : '',
              remarks: v.remarks || null
            }
            scope.availableBillsFinalData.push(packagesList);
          }

        });
        return scope.availableBillsFinalData;
      }
    };

    scope.MapBillforOtherPayer=function(data)
    {
      var otherPayerBillData=[];
      if(data)
      {
        angular.forEach(data,function(obj){
          var temp={"billCategory":obj.cmS_CHARGE_TYPE_DESC,
          "billSubCategory":obj.cmS_SUBCHARGE_TYPE_DESC,
          "billPackageName":obj.hospitaL_CHARGE_HEAD,
          "billAmount":obj.packageAmount ? parseInt(obj.packageAmount) : 0};
          otherPayerBillData.push(temp);
        })
        // var temp={"billCategory":"String","billSubCategory":"String","billPackageName":"String","billAmount":0}
      }
      return otherPayerBillData;
    }


    scope.downloadAttachment = function (obj) {
      if (obj) {
        window.open(
          UtilitiesService.getDMSHostUrl() + obj,
          '_blank'
        );
      }
    };

    scope.removeFiles = function (item) {
      angular.forEach(scope.storeFiles, function (key, value) {
        if (key.fileName === item.fileName) {
          scope.storeFiles.splice(value, 1)
        }
      })
      angular.forEach(scope.storeFiles, function (value, index) {
        scope.form.fileNames.push(value.fileName);
        scope.form.fileUploadFolderPath.push(value.downloadURL);
      })
    };

    scope.fileFn = function (data, attachmenttype) {
      if (data) {
        scope.isProcessing = false;
        angular.forEach(data, function (value, index) {
          scope.form.fileNames.push(value.fileName);
          scope.form.fileUploadFolderPath.push(value.downloadURL);
          scope.storeFiles.push({
            fileName: value.fileName,
            docPath: value.downloadURL,
            attachmentType: attachmenttype
          });
        })
      }
    };

    scope.preauthFormAction = (function () {
      scope.insuranceCompanyList = UtilitiesService.getInsuranceCompanyName();
      scope.username = UserService.getUserObj().userName;
      scope.showAutoPackages = true;

      function submitPreauthFormSuccess(successData) {
        scope.fileUploaName = [];
        scope.storeFiles = [];
        scope.isProcessing = false;
        // scope.resetFormData();
        scope.resetData();
        scope.govtBenefList = [];
        if (successData.data.isSuccess) {
          scope.form.patientDetails = successData.data.patientDetails;
          if (scope.form.patientDetails && scope.form.patientDetails.fromHospitalEmail) {
            scope.form.successMessage = 'The claim has been successfully send to ' + scope.form.patientDetails.tpaName + ' from ' + scope.form.patientDetails.fromHospitalEmail + ' with below details';
          }
          if (scope.form.patientDetails) {
            scope.form.patientDetails.doa = moment(scope.form.patientDetails.doa).format('DD MMM YYYY');
            scope.form.patientDetails.tentativeDOD = moment(scope.form.patientDetails.tentativeDOD).format('DD MMM YYYY');
          }
          scope.form.preauthSuccess = true;
        } else {
          scope.form.preauthError = true;
        }
      }

      function submitPreauthFormError(ErrorData) {
        scope.isProcessing = false;
        scope.form.preauthError = true;
      }

      function fileUploadError(errordata) {
        scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'File Upload Error', 'Error', true);
      }
      return {
        getPreauthFormData: function (form) {
          var data = {
            IsGovtClaim: false,
            MemberGender: form.gender == undefined ? '' : form.gender,
            Age: form.age == undefined ? '' : form.age,
            ApplicationName: 'Hospital Portal',
            PatientFirstName: form.fullname,
            ContactNum: form.mobile,
            EmpId: form.empid,
            Employer: form.employer,
            Maid: form.maid,
            Doa: form.doa,
            packagesList: scope.selectedMappedpackagesObj(scope.selectedMappedpackages),
            ApproxClaimedAmnt: parseInt(form.clmamount),
            DocName: form.docname,
            DocRegNo: form.docregNo,
            Diagnosis: form.diagnosis,
            AdmissionType: form.admissiontype,
            RoomType: form.roomtype ? form.roomtype : (form.memberroomType ? form.memberroomType.value : null),
            TentativeDOD: form.dod,
            HospId: UserService.getHospitalObj().hospId,
            HospName: UserService.getHospitalObj().hospName,
            CreatedBy: UserService.getUserObj().userId,
            IpNumber: form.ipnumber,
            Procedure: form.procedure,
            IpAddress: 'String',
            PolicyNumber: form.policyno,
            InsurerName: form.insurername,
            FileNames: form.fileNames,
            FileUploadFolderPath: form.fileUploadFolderPath.join(),
            uiD_NO: form.uidno,
            attachedFiles: scope.storeFiles,
            tpaid: form.tpaId ? form.tpaId : 0,
            tpaConfigId: form.hospTPAId ? form.hospTPAId : 0,
            uniqueId: form.uniqueId ? form.uniqueId : '',
            extensionFields: scope.formProperties && scope.formProperties.length > 0 ? scope.formProperties : null,
            diagnosisType: scope.form.diagnosisOption ? form.diagnosisOption : null
          };
          return data;
        }, getPreauthOtherPayerData: function (form) {
          var data = {
            "providerId": UserService.getHospitalObj().hospId,
            "providerName": UserService.getHospitalObj().hospName,
            "patientName": form.fullname,
            "patientAge": form.age ? form.age : 0,
            "patientGender": form.gender ? form.gender : '',
            "policyHolderName": form.employer,
            "insurerName": form.insurername,
            "employeeId": form.empid,
            "policyNo": form.policyno,
            "claimedAmount": parseInt(form.clmamount),
            "doa": form.doa,
            "dod": form.dod,
            "memberId": form.uniqueId,
            "doctorName": form.docname,
            "diagnosis": form.diagnosis,
            "ipNumber": form.ipnumber,
            "roomType": form.roomtype ? form.roomtype : (form.memberroomType ? form.memberroomType.value : null),
            "mobileNo": form.mobile,
            "attachments": [],
            "claimBillDetails": scope.MapBillforOtherPayer(scope.selectedMappedpackages),
            "payerId": form.tpaId ? form.tpaId : 0,
            "schemeType": form.govtSchemeName
          };

          angular.forEach(scope.storeFiles, function (obj) {
            data.attachments.push({ "fileName": obj.fileName, 
                                    "filePath": obj.docPath, 
                                    "fileType": obj.attachmentType });
          });
          return data;
        },
        submitPreauthForm: function () {
          if (!scope.form.isgovtscheme) {
            if (scope.packageCheck(scope.selectedMappedpackages) && scope.selectedMappedpackagesObj(scope.selectedMappedpackages).length > 0) {
              scope.isProcessing = true;
              if (scope.storeFiles.length > 0) {
                // if(scope.form.tpaId>0 && scope.form.tpaId!=1063550)
                // {
                //   NewAdmissionFormService.submitPreauthFormForOther(this.getPreauthOtherPayerData(scope.form)).then(submitPreauthFormSuccess, submitPreauthFormError);
                // }
                // else
                  NewAdmissionFormService.submitPreauthForm(this.getPreauthFormData(scope.form)).then(submitPreauthFormSuccess, submitPreauthFormError);

              } else {
                UtilitiesService.showAlertMessage('Please attach atleast one document.');
              }
            } else {
              UtilitiesService.showAlertMessage('Please select procedure or add manually.')
            }
          } else {
            if (scope.govPackageData.length !== 0) {
              scope.isProcessing = true;
              if (scope.storeFiles.length > 0) {
                scope.govtSchemeMethods.submitPreauthForm();
              } else {
                UtilitiesService.showAlertMessage('Please attach atleast one document.');
              }
            } else {
              UtilitiesService.showAlertMessage('Please add atleast one government package.')
            }
          }
        },
        closePreauthForm: function () {
          scope.resetFormData();
          $location.path('/claims');
        },
        downloadPrefilledPreauthForm: function (source) {
          var PreauthFormDataObj = {
            HospitalID: UserService.getHospitalObj().cmsHospId,
            HospitalEmail: UserService.getHospitalObj().emailAddress,
            HospitalName: UserService.getHospitalObj().hospName,
            HospitalPhoneNo: UserService.getHospitalObj().primaryContactNumber,
            HospitalAddress: (UserService.getHospitalObj().address + UserService.getHospitalObj().city).replace(/[^a-zA-Z0-9 ]/g, ""),
            PatientName: scope.form.fullname,
            PatientPhoneNo: scope.form.mobile,
            CorporateName: scope.form.employer,
            EmployeeID: scope.form.empid,
            MAID: scope.form.maid ? scope.form.maid : '',
            DOA: scope.form.doa.getFullYear() + '-' + (scope.form.doa.getMonth() + 1) + '-' + scope.form.doa.getDate(),
            DOD: scope.form.dod.getFullYear() + '-' + (scope.form.dod.getMonth() + 1) + '-' + scope.form.dod.getDate(),
            Ailment: scope.form.diagnosis,
            Treatment: scope.getPackagesForPreAuthForm(),
            AdmissionType: scope.form.admissiontype,
            ClaimedAmount: scope.form.clmamount,
            DocName: scope.form.docname,
            RoomType: scope.form.roomtype,
            TPAId: scope.form.tpaId,
            UniqueId: scope.form.uniqueId ? scope.form.uniqueId : (scope.form.memberId ? scope.form.memberId : ''),
            patientGender: scope.form.memberGender,
            patientEmail: scope.form.emailId,
            insuranceCompany: scope.form.insurername,
            policyNo: scope.form.policyno,
            patientAge: scope.form.memberAge,
            memberId: scope.form.memberId,
            aadharNo: scope.form.aadharNo,
            urnNo: scope.form.URNNum,
            distictName: typeof (scope.form.memberDist) == "object" && scope.form.memberDist && scope.form.memberDist.value ? scope.form.memberDist.value : scope.form.memberDist,
            schemeName: scope.form.govtSchemeName
          };
          NewAdmissionFormService.downloadPrefilledPreauthForm(source, PreauthFormDataObj)
        }
      };
    })();



    scope.HdfcFormAction = (function () {
      scope.insuranceCompanyList = UtilitiesService.getInsuranceCompanyName();
      scope.username = UserService.getUserObj().userName;
      scope.showAutoPackages = true;

      function submitPreauthFormSuccess(successData) {
        scope.fileUploaName = [];
        scope.storeFiles = [];
        scope.isProcessing = false;
        // scope.resetFormData();
        scope.resetData();
        scope.govtBenefList = [];
        if (successData.data.isSuccess) {
          scope.form.patientDetails = successData.data.patientDetails;
          if (scope.form.patientDetails && scope.form.patientDetails.fromHospitalEmail) {
            scope.form.successMessage = 'The claim has been successfully send to ' + scope.form.patientDetails.tpaName + ' from ' + scope.form.patientDetails.fromHospitalEmail + ' with below details';
          }
          if (scope.form.patientDetails) {
            scope.form.patientDetails.doa = moment(scope.form.patientDetails.doa).format('DD MMM YYYY');
            scope.form.patientDetails.tentativeDOD = moment(scope.form.patientDetails.tentativeDOD).format('DD MMM YYYY');
          }
          scope.form.preauthSuccess = true;
        } else {
          scope.form.preauthError = true;
        }
      }

      function submitPreauthFormError(ErrorData) {
        scope.isProcessing = false;
        scope.form.preauthError = true;
      }

      function fileUploadError(errordata) {
        scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'File Upload Error', 'Error', true);
      }
      return {
        getPreauthFormData: function (form) {
          var data = {
            IsGovtClaim: false,
            MemberGender: form.gender == undefined ? '' : form.gender,
            Age: form.age == undefined ? '' : form.age,
            ApplicationName: 'Hospital Portal',
            PatientFirstName: form.fullname,
            ContactNum: form.mobile,
            EmpId: form.empid,
            Employer: form.employer,
            Maid: form.maid,
            Doa: form.doa,
            packagesList: scope.selectedMappedpackagesObj(scope.selectedMappedpackages),
            ApproxClaimedAmnt: parseInt(form.clmamount),
            DocName: form.docname,
            DocRegNo: 'String',
            Diagnosis: form.diagnosis,
            AdmissionType: form.admissiontype,
            RoomType: form.roomtype ? form.roomtype : (form.memberroomType ? form.memberroomType.value : null),
            TentativeDOD: form.dod,
            HospId: UserService.getHospitalObj().hospId,
            HospName: UserService.getHospitalObj().hospName,
            CreatedBy: UserService.getUserObj().userId,
            IpNumber: form.ipnumber,
            Procedure: form.procedure,
            IpAddress: 'String',
            PolicyNumber: form.policyno,
            InsurerName: form.insurername,
            FileNames: form.fileNames,
            FileUploadFolderPath: form.fileUploadFolderPath.join(),
            uiD_NO: form.uidno,
            attachedFiles: scope.storeFiles,
            tpaid: form.tpaId ? form.tpaId : 0,
            tpaConfigId: form.hospTPAId ? form.hospTPAId : 0,
            uniqueId: form.uniqueId ? form.uniqueId : '',
            extensionFields: scope.formProperties && scope.formProperties.length > 0 ? scope.formProperties : null,
            patientEmail: form.emailId
          };
          return data;
        },
        submitPreauthForm: function () {
          if (!scope.form.isgovtscheme) {

            scope.isProcessing = true;
            if (!scope.form.hdfcExpensesList || (scope.form.hdfcExpensesList && scope.form.hdfcExpensesList.count == 0)) {
              UtilitiesService.showAlertMessage('Add atleast one expense');
            }
            if (scope.storeFiles.length > 0) {
              NewAdmissionFormService.submitPreauthForm(this.getPreauthFormData(scope.form)).then(submitPreauthFormSuccess, submitPreauthFormError);
            } else {
              UtilitiesService.showAlertMessage('Please attach atleast one document.');
            }

          } else {
            if (scope.govPackageData.length !== 0) {
              scope.isProcessing = true;
              if (scope.storeFiles.length > 0) {
                scope.govtSchemeMethods.submitPreauthForm();
              } else {
                UtilitiesService.showAlertMessage('Please attach atleast one document.');
              }
            } else {
              UtilitiesService.showAlertMessage('Please add atleast one government package.')
            }
          }
        },
        closePreauthForm: function () {
          scope.resetFormData();
          $location.path('/claims');
        },
        downloadPrefilledPreauthForm: function (source) {
          var PreauthFormDataObj = {
            HospitalID: UserService.getHospitalObj().cmsHospId,
            HospitalEmail: UserService.getHospitalObj().emailAddress,
            HospitalName: UserService.getHospitalObj().hospName,
            HospitalPhoneNo: UserService.getHospitalObj().primaryContactNumber,
            HospitalAddress: (UserService.getHospitalObj().address + UserService.getHospitalObj().city).replace(/[^a-zA-Z0-9 ]/g, ""),

            PatientName: scope.form.fullname,
            PatientPhoneNo: scope.form.mobile,
            CorporateName: scope.form.employer,
            EmployeeID: scope.form.empid,
            MAID: scope.form.maid ? scope.form.maid : '',
            DOA: scope.form.doa.getFullYear() + '-' + (scope.form.doa.getMonth() + 1) + '-' + scope.form.doa.getDate(),
            DOD: scope.form.dod.getFullYear() + '-' + (scope.form.dod.getMonth() + 1) + '-' + scope.form.dod.getDate(),
            Ailment: scope.form.diagnosis,
            Treatment: scope.getPackagesForPreAuthForm(),
            AdmissionType: scope.form.admissiontype,
            ClaimedAmount: scope.form.clmamount,
            DocName: scope.form.docname,
            RoomType: scope.form.roomtype,
            TPAId: scope.form.tpaId,
            UniqueId: scope.form.uniqueId ? scope.form.uniqueId : (scope.form.memberId ? scope.form.memberId : ''),
            patientGender: scope.form.memberGender,
            patientEmail: scope.form.emailId,
            insuranceCompany: scope.form.insurername,
            policyNo: scope.form.policyno,
            patientAge: scope.form.memberAge,
            memberId: scope.form.memberId,
            aadharNo: scope.form.aadharNo,
            urnNo: scope.form.URNNum,
            distictName: typeof (scope.form.memberDist) == "object" && scope.form.memberDist && scope.form.memberDist.value ? scope.form.memberDist.value : scope.form.memberDist,
            schemeName: scope.form.govtSchemeName
          };
          NewAdmissionFormService.downloadPrefilledPreauthForm(source, PreauthFormDataObj)
        }
      };
    })();

    scope.govtSchemeMethods = (function () {
      scope.selectedPackages = new Array();

      function submitPreauthFormSuccess(successData) {
        scope.fileUploaName = [];
        scope.storeFiles = [];
        scope.isProcessing = false;
        // scope.resetFormData();
        scope.resetData();
        scope.govtBenefList = [];
        if (successData.data.isSuccess) {
          scope.form.preauthSuccess = true;
        } else {
          scope.form.preauthError = true;
        }
      }

      function submitPreauthFormError(ErrorData) {
        scope.isProcessing = false;
        scope.form.preauthError = true;
      }

      function getGovtPackageListSuccess(resData) {
        if (resData && resData.data.isSuccess && resData.data.packages && resData.data.packages.length > 0) {
          scope.govtPackageList1 = resData.data.packages;
          scope.govtPackageListDummy = scope.govtPackageList1;
          scope.changeGovtPolicyType('Basic');
          UserService.setGovtPackageList(scope.govtPackageList1);
          scope.showGovtPackages = true;
        } else {
          if (resData.data.isSuccess === false) {
            scope.govtPackageList1 = [];
            scope.govtPackageListDummy = scope.govtPackageList1;
            UserService.setGovtPackageList(scope.govtPackageList1);
            scope.showGovtPackages = false;
          }

        }
      }

      function getGovtPackageListError(resData) {
        scope.govPackage = [];
        scope.govtPackageListDummy = scope.govPackage;
        UtilitiesService.showAlertMessage('Error while fetching govt packages list');
      }
      return {
        getGovtPackageList: function () {
          var govPackage = UserService.getGovtPackageList();
          if (govPackage != undefined && govPackage != null) {
            scope.govPackage = govPackage;
            scope.govtPackageListDummy = govPackage;
            scope.changeGovtPolicyType('Basic');
            scope.showGovtPackages = true;
          } else {
            GovernmentService.getGovtPackageList().then(getGovtPackageListSuccess, getGovtPackageListError)
          }
        },
        setGovtPackageId: function (packageObj) {
          scope.form.packageAmount = packageObj.packageCost;
          scope.form.packageName = packageObj.packageName;
          scope.form.packageUniqueId = packageObj.packageId;
          scope.form.cappedAmount = packageObj.cappedAmount;
        },
        addPackageButton: function () {
          if (scope.form.packageAmount || scope.form.mPackageAmount) {
            if (scope.selectedPackages.length < 3) {
              if (scope.showAutoPackages) {
                scope.selectedPackages.push({
                  id: scope.selectedPackages.length,
                  uniqueId: scope.form.packageUniqueId,
                  name: scope.form.packageName,
                  amount: scope.form.packageAmount
                });
                $("#packagesHolder").val($("#packagesHolder").val() + ", " + scope.form.packageUniqueId);
              } else {
                scope.selectedPackages.push({
                  id: scope.selectedPackages.length,
                  uniqueId: 0,
                  name: scope.form.mPackageName,
                  amount: scope.form.mPackageAmount
                });
                $("#packagesHolder").val($("#packagesHolder").val() + ", 0");
              }
              scope.packageCalcAmount = 0;
              for (var i = 0; i < scope.selectedPackages.length; i++) {
                scope.packageCalcAmount = scope.packageCalcAmount + ((25 * (4 - i)) / 100) * scope.selectedPackages[i].amount;
              }
              $("#packageAmountHolder").val(scope.packageCalcAmount);
            } else {
              UtilitiesService.showAlertMessage('Maximum of 3 packages allowed.');
            }
          }
        },
        removePackage: function (id) {
          $("#packagesHolder").val($("#packagesHolder").val().replace(", " + scope.selectedPackages[id].uniqueId, ""));
          for (var i = id; i < scope.selectedPackages.length - 1; i++) {
            scope.selectedPackages[i] = scope.selectedPackages[i + 1];
            scope.selectedPackages[i].id--;
          }
          scope.selectedPackages.pop(scope.selectedPackages.length - 1);
          scope.packageCalcAmount = 0;
          for (var i = 0; i < scope.selectedPackages.length; i++) {
            scope.packageCalcAmount = scope.packageCalcAmount + ((25 * (4 - i)) / 100) * scope.selectedPackages[i].amount;
          }
          $("#packageAmountHolder").val(scope.packageCalcAmount);
        },

        getPreauthFormData: function (form) {
          var data = {
            IsGovtClaim: true,
            urnNumber: form.URNNum,
            memberId: form.memberId,
            memberDistrict: typeof (form.memberDist) == "object" && form.memberDist && form.memberDist.id ? form.memberDist.id : form.memberDist,
            reasonForChoosing: scope.joinReason(),
            packages: scope.govPackageData.map(function (item) {
              return item.packageId
            }),
            MemberGender: form.memberGender,
            Age: form.memberAge,
            ApplicationName: 'Hospital Portal',
            PatientFirstName: form.fullname,
            ContactNum: form.mobile,
            Doa: form.doa,
            DocName: form.docname,
            Diagnosis: form.diagnosis,
            TentativeDOD: form.dod,
            HospId: UserService.getHospitalObj().hospId,
            HospName: UserService.getHospitalObj().hospName,
            CreatedBy: UserService.getUserObj().userId,
            IpNumber: form.ipnumber,
            FileNames: form.fileNames, //form.fileUploadFolderPath,// form.fileNames,
            FileUploadFolderPath: form.fileUploadFolderPath.join(),
            ApproxClaimedAmnt: scope.totalGovClaimAmount(),
            uiD_NO: form.uidno,
            GovScheme: scope.selectedSchemeForGov === 'APCMUHIS_Mediassist' ? 'APCMUHIS_Mediassist' : 'RSBY',
            attachedFiles: scope.storeFiles,
            tpaid: form.tpaId ? form.tpaId : 0,
            tpaConfigId: form.hospTPAId ? form.hospTPAId : 0,
            uniqueId: form.uniqueId ? form.uniqueId : '',
            GovtSchemeManipur: scope.admissionFromSearchFlag.urnNumberManipurScheme,
            AadhaarNo: form.aadharNo,
            RoomType: form.roomtype,
            govtSchemeName: form.govtSchemeName,
            extensionFields: scope.formProperties && scope.formProperties.length > 0 ? scope.formProperties : null
          };
          return data;
        },
        submitPreauthForm: function () {
          scope.isProcessing = true;
          NewAdmissionFormService.submitPreauthForm(this.getPreauthFormData(scope.form)).
            then(submitPreauthFormSuccess, submitPreauthFormError)
        },
        changePackageField: function () {
          if (scope.form.reasonOnline == 'others') {
            scope.showAutoPackages = false;
          } else {
            scope.showAutoPackages = true;
          }
        }
      };
    })();

    scope.checkForGovPackages = function () {
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/GovtSchemeAvailability.json?priEntityId=' + UserService.getUserObj().entityId + '&secEntityName=Medi%20Assist', '', 'GET', UserService.getAccessToken()).then(function (response) {
        if (response.data.isSuccess) {
          scope.showGovtPackages = true;
        } else {
          scope.showGovtPackages = false;
        }
      });
    };

    scope.govtSchemeMethods.getGovtPackageList();

    scope.govtSchemeDistrict = function (schemeName) {
      var data = {
        'schemeCode': schemeName,
        'payerId': 1000042
      }
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/OtherPayer/Master/District', data, 'POST').then(function (res) {
        if (res.data.isSuccess) {
          scope.govtSchemeDistricts = res.data.masterDetails;
        }
      })
    }

    scope.getPayerRoomCategories = function () {
      var data = {
        'payerId': scope.tpaDetailsObj.tpaId,
        'providerId': UserService.getHospitalObj().hospId,
      }
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'OtherPayer/Master/roomtype', data, 'POST').then(function (res) {
        if (res.data.isSuccess) {
          scope.payerRoomCategories = res.data.masterDetails;
        }
      })
    }


    scope.getPayerMasterData = function () {
      var data = {
        'payerId': scope.tpaDetailsObj.tpaId,
        'providerId': UserService.getHospitalObj().hospId,
        "isPayerChargeTypeMaster": true,
        "isPayerAnathesiaType": true,
        "isPayerHospitalizationDueTO": true,
        "isPayerPastAilmentCategory": true
      }
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/OtherPayer/Master/AllMaster', data, 'POST').then(function (res) {
        if (res.data.isSuccess) {
          scope.AllPayerMaster = res.data.masterData;
          if (res.data.masterData && res.data.masterData.AnathesiaType)
            scope.hdfcAnaesthesia = res.data.masterData.AnathesiaType;
          if (res.data.masterData && res.data.masterData.PastAilmentType)
            scope.hdfcPastAilmentCategory = res.data.masterData.PastAilmentType;
          if (res.data.masterData && res.data.masterData.ChargeType)
            scope.hdfcExpenses = res.data.masterData.ChargeType;
          if (res.data.masterData && res.data.masterData.HospitalizationType) {
            scope.hdfcIllnessdueTo = res.data.masterData.HospitalizationType;
            scope.hdfcIllnessdueTo.push({
              'id': 0,
              value: 'Accident'
            });

          }

        }
      })
    }

    scope.getPayerSurgeryMaster = function (isSurgery, parentId) {
      if (isSurgery) {
        var data = {
          'payerId': scope.tpaDetailsObj.tpaId,
          'parentId': parentId
        }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/OtherPayer/Master/Surgery', data, 'POST').then(function (res) {
          if (res.data.isSuccess) {
            if (res.data.masterData && res.data.masterData.SurgeryType)
              scope.surgeryTypeMaster = res.data.masterData.SurgeryType;
            if (res.data.masterData && res.data.masterData.SurgeryName)
              scope.surgeryNameMaster = res.data.masterData.SurgeryName;
            if (res.data.masterData && res.data.masterData.SpecificSurgery)
              scope.specificSurgeryMaster = res.data.masterData.SpecificSurgery;
          }
        })
      }
    }
    scope.govtSchemeDesignation = function (schemeName) {
      var data = {
        'schemeName': schemeName
      }
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/govtclaim/Designation/', data, 'POST').then(function (res) {
        if (res.data.isSuccess) {
          scope.govtSchemeDesignationMaster = res.data.designations;
        }
      })
    }

    scope.preClaimInfoRelatedMethods = (function () {
      function submitPreauthFormSuccess(successData) {
        scope.isProcessing = false;
        scope.resetData();
        scope.govtBenefList = [];
        if (successData.data.isSuccess) {
          scope.form.preauthSuccess = true;

        } else {
          scope.form.preauthError = true;
        }
      }

      function submitPreauthFormError(ErrorData) {
        scope.isProcessing = false;
        scope.form.preauthError = true;
      }
      return {
        prefillPreauthForm: function (claimRefNo) {
          NewAdmissionFormService.getPreauthDataByMARefNo(claimRefNo).then(function (resData) {
            scope.resetFormData();
            scope.signup = {};
            if (resData.data.detailslist.length > 0) {
              if (resData.data.detailslist[0].admissioN_DATE.indexOf('T') > -1) {
                resData.data.detailslist[0].admissioN_DATE = new Date(resData.data.detailslist[0].admissioN_DATE);
                resData.data.detailslist[0].dischargE_DATE = new Date(resData.data.detailslist[0].dischargE_DATE);
              } else {
                var formattedDoa = resData.data.detailslist[0].admissioN_DATE.split('-')
                resData.data.detailslist[0].admissioN_DATE = new Date(formattedDoa[1] + '/' + formattedDoa[0] + '/' + formattedDoa[2])
                var formattedDod = resData.data.detailslist[0].dischargE_DATE.split('-');
                resData.data.detailslist[0].dischargE_DATE = new Date(formattedDod[1] + '/' + formattedDod[0] + '/' + formattedDod[2])
              }
              scope.form.fullname = resData.data.detailslist[0].patienT_FIRSTNAME;
              scope.form.mobile = parseInt(resData.data.detailslist[0].mobilE_NO);
              scope.form.employer = resData.data.detailslist[0].corporatE_NAME;
              scope.form.empid = resData.data.detailslist[0].employeE_ID;
              scope.form.maid = resData.data.detailslist[0].maid;
              scope.form.doa = (resData.data.detailslist[0].admissioN_DATE);
              scope.form.dod = (resData.data.detailslist[0].dischargE_DATE);
              scope.form.diagnosis = resData.data.detailslist[0].presenT_AILMENT;
              scope.form.procedure = resData.data.detailslist[0].provisionaL_TREATMENT;
              scope.form.admissiontype = resData.data.detailslist[0].admissioN_TYPE;
              scope.form.clmamount = parseInt(resData.data.detailslist[0].preautH_AMOUNT);
              scope.form.docname = resData.data.detailslist[0].firsT_NAME;
              scope.form.roomtype = resData.data.detailslist[0].provideR_ROOM_TYPE;
              scope.form.PreAuthForIRRemarks = resData.data.detailslist[0].remarks;
            }
          }, function (error) {
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          });
        },
        getPreauthFormData: function (form) {
          var data = {
            PreAuthNo: scope.dataobj.claimRefNo,
            IsGovtClaim: false,
            MemberGender: form.gender == undefined ? '' : form.gender,
            Age: form.age == undefined ? '' : form.age,
            ApplicationName: 'Hospital Portal',
            PatientFirstName: form.fullname,
            ContactNum: form.mobile,
            EmpId: form.empid,
            Employer: form.employer,
            Maid: form.maid,
            Doa: form.doa,
            packagesList: scope.selectedMappedpackagesObj(scope.selectedMappedpackages),
            ApproxClaimedAmnt: parseInt(form.clmamount),
            DocName: form.docname,
            DocRegNo: 'String',
            Diagnosis: form.diagnosis,
            AdmissionType: form.admissiontype,
            RoomType: form.roomtype,
            TentativeDOD: form.dod,
            HospId: UserService.getHospitalObj().hospId,
            HospName: UserService.getHospitalObj().hospName,
            CreatedBy: UserService.getUserObj().userId,
            IpNumber: form.ipnumber,
            Procedure: form.procedure,
            IpAddress: 'String',
            PolicyNumber: form.policyno,
            InsurerName: form.insurername,
            FileNames: form.fileNames,
            FileUploadFolderPath: form.fileUploadFolderPath.join(),
            uiD_NO: form.uidno,
            attachedFiles: scope.storeFiles,
            tpaid: form.tpaId ? form.tpaId : 0,
            tpaConfigId: form.hospTPAId ? form.hospTPAId : 0,
            uniqueId: form.uniqueId ? form.uniqueId : '',
            extensionFields: scope.formProperties && scope.formProperties.length > 0 ? scope.formProperties : null
          };
          return data;
        },
        submitPreClaimPreauthForm: function () {
          scope.isProcessing = true;
          if (scope.storeFiles.length > 0) {
            if (!scope.form.IsGovtClaim) {
              NewAdmissionFormService.submitPreClaimPreauthForm(this.getPreauthFormData(scope.form)).
                then(submitPreauthFormSuccess, submitPreauthFormError);
            } else {
              scope.govtSchemeMethods.submitPreauthForm();
            }
          } else {
            UtilitiesService.showAlertMessage('Please attach atleast one document.');
          }
        },
        closePreauthForm: function () {
          scope.resetFormData();
          $location.path('/claims');
        },
      };
    })();

    if (scope.source == 'preClaim' && scope.dataobj.claimRefNo) {
      scope.preClaimInfoRelatedMethods.prefillPreauthForm(scope.dataobj.claimRefNo);
    }

    scope.dateOfAdmission = function (date, type) {
      scope.isFormDisable = false;
      scope.totalGovClaimAmount();
      if (type === 'doa') {
        var currentMonth = scope.todaysDate.getMonth() + 2;
        var selectedMonth = scope.form.doa.getMonth();
        if (currentMonth < selectedMonth) {
          scope.isdoa = true;
          scope.isFormDisable = true;
          if (scope.form.dod) {
            scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
          }
        } else {
          scope.isdoa = scope.todaysDate <= scope.form.doa ? false : true;
          scope.isFormDisable = scope.isdoa;
          if (scope.form.dod) {
            scope.isdod = scope.form.dod >= scope.form.doa ? false : true;
          }
        }
      } else if (type === 'dod') {
        var currentMonth = scope.todaysDate.getMonth() + 2;
        var selectedMonth = scope.form.doa.getMonth();
        if (currentMonth < selectedMonth) {
          scope.isdoa = true;
          scope.isFormDisable = true;
          scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
        } else {
          scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
          if (scope.form.doa) {
            scope.isdoa = scope.todaysDate <= scope.form.doa ? false : true;
            if (!scope.isdoa) {
              scope.isdoa = scope.form.dod < scope.form.doa ? true : false;
            }
          }
        }
      }
    };

    scope.addFileToUpload = function (flag) {
      scope.file = [];
      var newItemNo = scope.file.length + 1;
      scope.file.push({
        'model': ''
      });
    };
    scope.getLenseMaster = function () {

    };

    scope.addHdfcAnaesthesia = function (value) {
      var data = scope.hdfcAnaesthesia.filter(function (e) {
        return e.isSelected == true;
      });

      if (data && data.length > 0) {
        var dataString = data.map(function (e) {
          return e.id
        });
        var commaSeperated = dataString.join();
        scope.pushToProperties('Anaesthesia', commaSeperated);
      } else {
        scope.pushToProperties('Anaesthesia', null);
      }
    }

    scope.addHdfcIllnessDueTo = function (value) {
      var data = scope.hdfcIllnessdueTo.filter(function (e) {
        return e.isSelected == true;
      });

      if (data && data.length > 0) {
        angular.forEach(data, function (e) {
          if (e.value.toLowerCase() == 'maternity') {
            scope.pushToProperties('IsMaternity', true);
          }
          if (e.value.toLowerCase() == 'accident') {
            scope.pushToProperties('IsAccident', true);
          }
          if (e.value.toLowerCase() == 'alcohal') {
            scope.pushToProperties('IsAlcohal', true);
          }
        })
        var dataString = data.map(function (e) {
          return e.id;
        });
        var commaSeperated = dataString.join();
        scope.pushToProperties('IllnessDueTo', commaSeperated);
      } else {
        scope.pushToProperties('IllnessDueTo', null);
      }
    }

    scope.addHdfcConservativeManagement = function (value) {
      var data = scope.hdfcConservativeManagement.filter(function (e) {
        return e.value;
      });

      if (data && data.length > 0) {
        scope.pushToProperties('ConservativeManagement', JSON.stringify(data));
      } else {
        scope.pushToProperties('ConservativeManagement', null);
      }
    }

    scope.addHdfcExpense = function (type, amount) {
      if (!scope.form.hdfcExpensesList)
        scope.form.hdfcExpensesList = [];

      if (type && type.id && type.value && amount) {
        scope.form.hdfcExpensesList.push({
          'id': type.id,
          'name': type.value,
          'amount': amount
        });
        scope.form.clmamount = scope.form.hdfcExpensesList && scope.form.hdfcExpensesList.length > 1 ? scope.form.hdfcExpensesList.reduce(function (a, b) {
          return a.amount + b.amount
        }) : scope.form.hdfcExpensesList[0].amount;
        scope.pushToProperties('ExpenseType', JSON.stringify(scope.form.hdfcExpensesList));
      }
    }

    scope.removehdfcBillExpenses = function (index) {
      if (scope.form.hdfcExpensesList && scope.form.hdfcExpensesList.length > 0) {
        scope.form.hdfcExpensesList.splice(index, 1);
        scope.pushToProperties('ExpenseType', scope.form.hdfcExpensesList);
      }
    }

    scope.findSelectedvalueInobject = function (item, object) {
      if (item) {
        if (object.find(function (e) {
          return e.value.toLowerCase() == item.toLowerCase() && e.isSelected
        }))
          return true;
        else
          return false;
      }
      return false;
    }

    scope.getTreatmentTypeForCataract = function (data1, isOthers) {
      var data = scope.cataractType.filter(function (e) {
        return e.id == data1;
      });
      if (data) {
        //var obj = JSON.parse(val);
        scope.getReason = true;
        var ailmentId = data.map(function (e) {
          return e.id;
        })
        var ailmentcode = data.map(function (e) {
          return e.code;
        })
        var packageAilmentCode = data.map(function (e) {
          return e.packageCode;
        })
        if (!isOthers)
          scope.getMappedpackages(selectedShortName.insurerShortName, packageAilmentCode.join())
        scope.pushToProperties('ailmentid', ailmentId.join());
        scope.pushToProperties('ailmentcode', ailmentcode.join());
      }
    }

    scope.onChangeDeliveryType = function (value, isOthers) {
      if (value) {
        var obj = scope.maternityType.find(function (e) {
          return e.id == value;
        });
        //var obj = JSON.parse(value);
        if (obj) {
          // scope.form.ailmentId = obj.parentId;
          // scope.treatmentType = obj.id
          scope.getReason = true;
          if (!isOthers)
            scope.getMappedpackages(null, obj.code)
          scope.pushToProperties('ailmentid', obj.parentId);
          scope.pushToProperties('ailmentcode', obj.code);
          scope.pushToProperties('treatmentId', obj.id);
        }
      }
    }

    scope.copyPatientNametoEmployee = function (relation) {
      if (relation == "Self") {
        scope.form.employeeName = scope.form.fullname ? scope.form.fullname : '';
      } else {
        scope.form.employeeName = '';
      }
    }
    scope.removeFileToUpload = function () {
      var lastItem = scope.file.length - 1;
      scope.file.splice(lastItem);
      scope.validLargeDoc = false;
    };
    if (scope.source && scope.source === 'preClaim') {
      scope.formSelection('Add Manually', '');
    }
    scope.addFileToUpload();

    var configuredTpaList = UtilitiesService.getConfiguredTpa();
    if (configuredTpaList) {
      angular.forEach(configuredTpaList, function (e) {
        scope.configuredTpaList.push({
          hospTPAId: e.hospTPAId,
          tpaName: e.tpaName,
          tpaId: e.tpaId,
          isBenefSearchConfigured: false,
          configuredFields: []
        })
      })
      if (scope.userObject.userName == '1003736@medibuddy.in' && window.location.hostname === 'uat-plus.medibuddy.in') {
        // var tempObj={
        //   hospTPAId: 0,
        //   tpaName: "Select Payer Name",
        //   tpaId: 10,
        //   isBenefSearchConfigured: false,
        //   configuredFields: []
        // }
        // scope.configuredTpaList.push(tempObj);
        scope.tpaDetailsObj = scope.configuredTpaList[0];
        scope.changeTpa(scope.tpaDetailsObj);
      } else {
        scope.configuredTpaList.push({
          hospTPAId: 0,
          tpaName: scope.MaTpaName,
          tpaId: scope.MaTPAId,
          isBenefSearchConfigured: true,
          configuredFields: []
        })
      }

      // configuredTpaList.forEach(element => {
      //   scope.configuredTpaList.push({
      //     id: element.tpaId,
      //     value: element.tpaName
      //   })
      // });
    }

  }]);

angular.module('mbplus').controller('ModalInstanceCtrl', ['$scope', '$uibModalInstance', 'types', 'FastrackService', function (scope, $uibModalInstance, types, FastrackService) {
  //console.log("modal instanceCtrl")

  scope.modalinsta = "ModalInstanceCtrl-child";

  scope.ok = function () {
    $uibModalInstance.close(scope.selected.item);
  };

  scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  scope.fastrackPreauth = function (type) {
    scope.fastrack = {};
    scope.fastrack.title =
    scope.fastrack.displaySubmit = true;
    switch (type) {
      case 'aarogya':
        scope.fastrack.title = "Aarogya Scheme"
        scope.aarogyachecked = true;
        scope.fastrack.showCorpName = false;
        scope.fastrack.employerSearchTitle = "Family Number";
        break;
      case 'generic':
        scope.fastrack.title = "Member Search";
        scope.aarogyachecked = false;
        scope.fastrack.showCorpName = true;
        scope.fastrack.employerSearchTitle = "Employee ID";
        break;
    }
    if (scope.aarogyachecked) {
      scope.fastrack.corporateName = "Manipal";
    }
  }
  scope.fastrackPreauth(types);
  scope.getDetailsWithMaid = function (maid, benefName) {
    FastrackService.getDetailsWithMaid(maid, benefName).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.displaySubmit = false;
            scope.fastrack.error = false;
            scope.fastrack.name = response.data.benefs.name;
            scope.fastrack.relations = response.data.relations;
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
          }
          else {
            scope.fastrack.error = true;
            scope.fastrack.errorMessage = response.data.errorMessage;
          }
        },
           function (response) {
             scope.fastrack.error = true;
             scope.fastrack.errorMessage = "No data found"
           });
  }
  scope.getDetailsWithEmpId = function (empid, corpname, benefname) {
    FastrackService.getDetailsWithEmpId(empid, corpname, benefname).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.displaySubmit = false;
            scope.fastrack.error = false;
            scope.fastrack.name = response.data.benefs.benefName;
            scope.fastrack.relations = response.data.relations;
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
          }
          else {
            scope.fastrack.error = true;
            scope.fastrack.errorMessage = response.data.errorMessage;
          }
        },
           function (response) {
             scope.fastrack.error = true;
             scope.fastrack.errorMessage = "No data found"
           });
  }
  scope.getDetailsWithPolicy = function (policyno, benefname) {
    FastrackService.getDetailsWithPolicy(policyno, benefname).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.displaySubmit = false;
            scope.fastrack.error = false;
            scope.fastrack.name = response.data.benefs.benefName;
            scope.fastrack.relations = response.data.relations;
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;


          }
          else {
            scope.fastrack.error = true;
            scope.fastrack.errorMessage = response.data.errorMessage;
          }


        },
           function (response) {
             scope.fastrack.error = true;
             scope.fastrack.errorMessage = "No data found"
           });
  }
  scope.fastrackPopulateNewAdmission = function (maid, relationid, name) {
    FastrackService.fastrackPopulateNewAdmission(maid, relationid, name).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.$parent.tempData = response.data.benefs;
            scope.form = {};
            scope.form.fullname = response.data.benefs.benefName;   //generic
            scope.form.roomtype = "General ward";
            scope.form.employer = response.data.benefs.benefPolHldrName;
            scope.form.empid = response.data.benefs.priBenefEmpCode;
            scope.form.maid = response.data.benefs.benefMediAssistID;
            scope.form.policyno = scope.fastrack.PolicyNo;
          }
          else {
            UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
          }
        },
           function (response) {
             UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
           });
  }
}]);
angular.module('mbplus')
  .controller('newAdmissionFormNewCtrl', ['$scope', '$location', '$state', '$timeout', 'UserService', 'UtilitiesService', 'filterFilter', '$uibModal', 'FastrackService', 'GovernmentService', 'FileUploadService', 'NewAdmissionFormService', '$analytics', '$q', 'blockUI', 'navConstantsSvc', function (scope, $location, state, timeout, UserService, UtilitiesService, filterFilter, $uibModal, FastrackService, GovernmentService, FileUploadService, NewAdmissionFormService, $analytics, $q, blockUI, navConstantsSvc) {
    $analytics.pageTrack('/newAdmission/');
    scope.ctrlName = 'newAdmissionFormCtrl';
    scope.blockUIState = blockUI.state();
    if (!UserService.isActive()) {
      UserService.destroyUserObj();
      return false;
    }
    scope.checkPhoneNumber = '^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$';
    scope.govType = 'B';
    if (UserService.getHospitalObj().configuredSchemes && UserService.getHospitalObj().configuredSchemes.length > 0) {
      angular.forEach(UserService.getHospitalObj().configuredSchemes, function (element) {
        if (element == "RSBY") {
          scope.isRsby = true;
        } else {
          scope.isRsby = false;
        }
      });
    } else {
      scope.isRsby = false;
    }
    scope.numberValidation = '((?:1){8}|(?:2){8}|(?:3){8}|(?:4){8}|(?:5){8}|(?:6){8}|(?:7){8}|(?:8){8}|(?:9){8}|(?:0){8})';
    scope.mobileValidation = function (number) {
      if (number) {} else {}
    };
    scope.isShowMaid = true;
    scope.isEBill = UtilitiesService.checkEBillHospital(UserService.getHospitalObj().hospId);
    scope.tpaFormReset = function () {
      scope.tpaForm = {
        name: {
          id: 0,
          value: '--Select TPA Name--'
        },
        mailServerAddress: '',
        mailServerPort: '',
        useSSl: '',
        hospMailId: '',
        hospPassword: '',
        tpaMailId: '',
        outGoingServerPort: '',
        tpaHospId: '',
        outGoingServerAddress: '',
        tpaId: 0
      }
    };
    scope.tpaFormReset();
    scope.tpaForm.name = {
      id: 0,
      value: '--Select TPA Name--'
    };
    scope.resetFormData = function () {
      scope.form = {
        roomtype: '',
        fileNames: [],
        tpaId: 0,
        fileUploadFolderPath: [],
        doa: '',
        dod: '',
        packageAmount: '',
        clmamount: 0,
        procedure1: '',
        mPackageTotalAmount: '',
        mPackageFullName: '',
        packageName: '',
        cappedAmount: '',
        packageUniqueId: '',
        fullname: '',
        memberId: '',
        URNNum: '',
        adFolderPath: [],
        employer: '',
        empid: '',
        maid: '',
        policyno: '',
        age: '',
        gender: '',
        preauthSuccess: false,
        preauthError: false,
        insurername: '',
        isgovtscheme: '',
        mobile: '',
        diagnosis: '',
        procedure: '',
        admissiontype: '',
        docname: '',
        ipnumber: '',
        IsGovtClaim: true,
        memberDist: '',
        reasonOnline: '',
        memberGender: '',
        memberAge: '',
        uidno: '',
        tpaName: '',
        uniqueId: '',
        hospTPAId: 0
      }
    };
    scope.resetFormData();
    scope.fileUploaName = [];
    scope.getDateObj = UtilitiesService.getDateObj;
    scope.isProcessing = false;
    scope.doctorDetails = [];
    scope.roomsDetails = [];
    scope.isSearchButton = true;
    scope.isSearchProcedure = true;
    scope.userObject = UserService.getUserObj();
    scope.isProcedure = false;
    scope.isTPA = false;
    scope.isTPAAndProcedure = false;
    if (scope.userObject && scope.userObject.entityId === 1005034) {
      scope.isProcedure = true;
      scope.isTPA = false;
      scope.isTPAAndProcedure = false;
    }
    var erIDs = navConstantsSvc.erIDs;
    //var isErId = _.find(erIDs, function (num) { return num == scope.userObject.entityId; });
    //if (isErId) {
    scope.isTPA = false;
    scope.isProcedure = true;
    scope.isTPAAndProcedure = false;
    //} else {
    //    scope.isTPA = false;
    //    scope.isProcedure = false;
    //    scope.isTPAAndProcedure = false;
    //}

    //if (scope.userObject && scope.userObject.entityId === 1003862) {
    if (scope.userObject && scope.userObject.entityId === 1026419) {
      scope.isTPA = false;
      scope.isProcedure = true;
      scope.isTPAAndProcedure = false;
    }

    scope.changeTpa = function (obj) {
      scope.resetFormData();
      scope.isShowMaid = true;
      if (obj) {
        if (obj === 'Medi Assist Insurance TPA Pvt. Ltd.') {
          scope.isSearchProcedure = true;
          scope.isShowMaid = true;
          scope.isSearchButton = true;
          var value = _.findWhere(scope.tpaList, {
            tpaName: obj
          });
          scope.form.tpaId = value.tpaId ? value.tpaId : 0;
          scope.form.hospTPAId = value.hospTPAId ? value.hospTPAId : 0;
          scope.form.tpaName = value.tpaName ? value.tpaName : '';
          scope.reasonOnlineField = 'procedure';
        } else {
          scope.isShowMaid = false;
          scope.isSearchButton = obj ? false : true;
          scope.isSearchProcedure = false;
          scope.reasonOnlineField = 'others';
        }
        if (!scope.isSearchButton) {
          var value = _.findWhere(scope.tpaList, {
            tpaName: obj
          });
          if (value) {
            scope.form.tpaId = value.hospTPAId ? value.hospTPAId : 0;
            scope.form.hospTPAId = value.hospTPAId ? value.hospTPAId : 0;
            scope.form.tpaName = value.tpaName ? value.tpaName : '';
          }
        }
      } else {
        scope.form.hospTPAId = 0;
        scope.form.tpaId = 0;
      }
    };


    scope.getInsurersCompanyList = function () {
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/insurers', '', 'GET').then(function (response) {
        if (response.data) {
          scope.insurerList = response.data.insurerList;
          //scope.insurerList.push({ id: 0, value: '--Select TPA Name--' });
          scope.insurerList = _.sortBy(scope.insurerList, function (num) {
            return num.id > 0;
          });
        }
      }, function (error) {
        scope.insurerList = [];
      });
    };
    scope.getInsurersCompanyList();

    scope.getTPAList = function () {
      scope.TPAListData = [];
      var ajaxData = {
        LookUpType: 'TPA'
      };
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/master/MasterLookup', ajaxData, 'POST').then(function (response) {
        if (response.data) {
          scope.TPAListData = response.data;
          scope.TPAListData.push({
            id: 0,
            value: '--Select TPA Name--'
          });
          scope.TPAListData = _.sortBy(scope.TPAListData, function (num) {
            return num.id > 0;
          });
          scope.tpaForm.name = {
            id: 0,
            value: '--Select TPA Name--'
          };
        }
      }, function (error) {
        scope.TPAListData = [];
      });
    };
    scope.getTPAList();

    scope.getRoomsDetails = function () {
      var ajaxData = {
        hospId: UserService.getHospitalObj().hospId,
        getDoctors: false,
        getRooms: true,
        getOpPackages: false,
        getContracts: false
      };
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/hospProfileDetails', ajaxData, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          scope.roomsDetails = response.data.hospRoomDetails;
        }
      }, function (error) {
        scope.roomsDetails = [];
      });
    };
    scope.getDoctorDetails = function () {
      var ajaxData = {
        hospId: UserService.getHospitalObj().hospId,
        getDoctors: true,
        getRooms: true,
        getOpPackages: false,
        getContracts: false
      };
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/hospProfileDetails', ajaxData, 'POST').then(function (response) {
        if (response.data.isSuccess) {
          scope.doctorDetails = response.data.hospDoctorDetails;
          scope.getRoomsDetails();
        }
      }, function (error) {
        scope.doctorDetails = [];
        scope.getRoomsDetails();
      });
    };

    scope.tpaList = [];
    scope.getTpaList = function () {
      if (UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId) {
        // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/' + UserService.getHospitalObj().cmsHospId + '/tpas', '', 'GET').then(function (response) {
        //   if (response.data.isSucces) {
        //     scope.tpaList = response.data.tpaList;
        //   }
        // }, function (error) {
        //   scope.tpaList = [];
        // });
      }
    };

    scope.getTpaList();
    scope.getDoctorDetails();


    scope.getPackageList = function (value) {
      var govPackage = UserService.getGovtPackageList();
      if (value) {
        var data = {
          priEntityName: '',
          priEntityId: UserService.getUserObj().entityId,
          secEntityName: 'Medi Assist',
          secEntityId: 0,
          schemeType: value
        };
        // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/packagesbtnentities/list', data, 'POST', UserService.getAccessToken()).then(function (response) {
        //   if (response.data.isSuccess) {
        //     scope.govtPackageList = response.data.packages;
        //   } else {
        //     scope.govtPackageList = [];
        //   }
        // });
      }
    };

    scope.govtChecked = function (data) {
      scope.form.packageAmount = '';
      scope.selectedSchemeForGov = 'RSBYHospitals_Mediassist';
      scope.form.isgovtscheme = !!scope.form.isgovtscheme;
      if (data) {
        scope.selectedSchemeForGov = data;
        scope.form.isgovtscheme = true;
        //scope.getPackageList(scope.selectedSchemeForGov);
      }

    };
    scope.selectedMappedpackages = [];

    scope.onSelectPackages = function ($item, $model, $label) {
      if ($item) {
        scope.selectedMappedpackages.push($item);
        scope.selectedMappedpackages = _.uniq(scope.selectedMappedpackages);
        angular.forEach(scope.selectedMappedpackages, function (data, index) {
          scope.selectedMappedpackages[index].general_Ward1 = data.general_Ward1 === true ? true : false;
          scope.selectedMappedpackages[index].private_Ward1 = data.private_Ward1 === true ? true : false;
          scope.selectedMappedpackages[index].semi_Private_Ward1 = data.semi_Private_Ward1 === true ? true : false;
          scope.selectedMappedpackages[index].uniqueIds = index + 1;
        })
      }
    };

    scope.packageCalcAmount = 0;
    scope.calculatePrice = function () {
      scope.packageCalcAmount = 0;
      angular.forEach(scope.selectedMappedpackages, function (data, index) {
        if (data.general_Ward1 || data.private_Ward1 || data.semi_Private_Ward1) {
          var price = data.general_Ward1 === true ? 'general_Ward' : data.private_Ward1 === true ? 'private_Ward' : data.semi_Private_Ward1 === true ? 'semi_Private_Ward' : ''
          scope.packageCalcAmount = scope.packageCalcAmount + scope.selectedMappedpackages[index][price];
        }
      });
      scope.form.clmamount = scope.packageCalcAmount;
    };
    scope.reasonOnlineField = 'procedure';
    scope.changePackageField = function (value) {
      scope.form.procedure1 = '';
      scope.form.mPackageTotalAmount = '';
      scope.form.mPackageFullName = '';
      scope.reasonOnlineField = value;
    };

    scope.AddProcedure = function (name, price) {
      if (name && price) {
        var obj = {
          deluxe_Other: 0,
          general_Ward: parseInt(price),
          general_Ward1: true,
          packageId: 0,
          package_Name: name,
        }
        scope.selectedMappedpackages.push(obj);
        scope.calculatePrice();
        scope.onSelectPackages(obj);
        scope.form.mPackageTotalAmount = '';
        scope.form.mPackageFullName = '';
      } else {
        UtilitiesService.showAlertMessage('Please enter treatment details and amount .');
      }
    };

    scope.checkService = function (value, price) {
      if (value) {
        if (price === 'general_Ward') {
          angular.forEach(scope.selectedMappedpackages, function (data, index) {
            if (value.packageId === data.packageId) {
              scope.selectedMappedpackages[index].general_Ward1 = !scope.selectedMappedpackages[index].general_Ward1;
              scope.selectedMappedpackages[index].private_Ward1 = false;
              scope.selectedMappedpackages[index].semi_Private_Ward1 = false;
            }
          })
        } else if (price === 'semi_Private_Ward') {
          angular.forEach(scope.selectedMappedpackages, function (data, index) {
            if (value.packageId === data.packageId) {
              scope.selectedMappedpackages[index].general_Ward1 = false;
              scope.selectedMappedpackages[index].private_Ward1 = false;
              scope.selectedMappedpackages[index].semi_Private_Ward1 = !scope.selectedMappedpackages[index].semi_Private_Ward1;
            }
          })
        } else if (price === 'private_Ward') {
          angular.forEach(scope.selectedMappedpackages, function (data, index) {
            if (value.packageId === data.packageId) {
              scope.selectedMappedpackages[index].general_Ward1 = false;
              scope.selectedMappedpackages[index].private_Ward1 = !scope.selectedMappedpackages[index].private_Ward1;
              scope.selectedMappedpackages[index].semi_Private_Ward1 = false;
            }
          })
        }
      }
      scope.calculatePrice();
    };


    scope.changeGovtPolicyType = function (type) {
      scope.form.packageAmount = '';
      scope.form.mPackageAmount = '';
      scope.form.packageName = '';
      scope.form.packageUniqueId = '';
      scope.form.cappedAmount = '';
      scope.text = '';
      if (type) {
        if (type === 'Basic') {
          var obje = [];
          angular.forEach(scope.govtPackageListDummy, function (value, key) {
            if (type === value.type) {
              obje.push(value);
            }
          });
          scope.govtPackageList = obje;
        } else if (type === 'Critical') {
          var obje = [];
          angular.forEach(scope.govtPackageListDummy, function (value, key) {
            if (type === value.type) {
              obje.push(value);
            }
          });
          scope.govtPackageList = obje;
        }
      }
    };

    scope.addTpa = function (type) {
      angular.element("#addTPA").modal('show');
    };
    scope.isSuccess = false;
    scope.isError = false;
    scope.resetAlertMessage = function () {
      timeout(function () {
        scope.$apply(function () {
          scope.isSuccess = false;
          scope.isError = false;
        });
      }, 6000)
    };

    scope.tpaErrorMsg = '';
    scope.saveTpaDetails = function (tpaForm) {
      if (UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId && tpaForm.name.id !== 0) {
        var data = {
          hospId: UserService.getHospitalObj().cmsHospId,
          tpaName: tpaForm.name.value,
          tpaId: tpaForm.name.id,
          mailServerAddress: tpaForm.mailServerAddress,
          mailServerPort: tpaForm.mailServerPort,
          useSSl: true,
          hospMailId: tpaForm.hospMailId,
          hospPassword: tpaForm.hospPassword,
          tpaMailId: tpaForm.tpaMailId,
          outGoingServerPort: tpaForm.outGoingServerPort,
          tpaHospId: tpaForm.tpaHospId,
          outGoingServerAddress: tpaForm.outGoingServerAddress
        }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tpa', data, 'POST', true).then(function (response) {
          if (response.data.isSuccess) {
            scope.tpaFormReset();
            scope.getTpaList();
            scope.isSuccess = true;
            scope.isSuccessMsg = 'TPA has been Added successfully!.';
            scope.resetAlertMessage();
          } else {
            scope.isError = true;
            scope.tpaErrorMsg = 'oops! something went wrong, please try again later.';
            scope.resetAlertMessage();
          }
        }, function (error) {
          scope.isError = true;
          scope.tpaErrorMsg = 'oops! something went wrong, please try again later.';
          scope.resetAlertMessage();
        });
      } else {
        scope.isError = true;
        scope.tpaErrorMsg = 'Please select TPA name.';
        scope.resetAlertMessage();
      }
    };
    scope.govSearchValueInModel = {
      apbyname: '',
      urn: ''
    }
    scope.fastrackPreauthGovSeaarch = function (type) {
      scope.radioFastTrack = '';
      scope.govSearchValueInModel.apbyname = '';
      scope.govSearchValueInModel.urn = '';
      angular.element("#newMSBYSearch").modal('show');
      scope.fastrack = {};
      scope.fastrack.displaySubmit = true;
      switch (type) {
        case 'gov':
          scope.fastrack.title = 'Gov Search';
          scope.aarogyachecked = false;
          scope.govSearch = true;
          scope.isGov = true;
          scope.govtBenefList = [];
          scope.epic = '';
          scope.urn = '';
          scope.fastrack.showCorpName = false;
          scope.fastrack.employerSearchTitle = 'Employee ID';
          break;
      }
    };
    scope.fastrackPreauth = function (type) {
      angular.element("#newPreauthModal").modal("show");
      scope.fastrack = {};
      scope.fastrack.displaySubmit = true;
      switch (type) {
        case 'aarogya':
          scope.fastrack.title = 'Aarogya Scheme';
          scope.aarogyachecked = true;
          scope.govSearch = false;
          scope.isGov = false;
          scope.fastrack.showCorpName = false;
          scope.fastrack.employerSearchTitle = 'Family Number';
          break;
        case 'generic':
          scope.fastrack.title = 'Member Search';
          scope.aarogyachecked = false;
          scope.govSearch = false;
          scope.isGov = false;
          scope.fastrack.showCorpName = true;
          scope.fastrack.employerSearchTitle = 'Employee ID';
          break;
        case 'gov':
          scope.fastrack.title = 'Gov Search';
          scope.aarogyachecked = false;
          scope.govSearch = true;
          scope.isGov = true;
          scope.govtBenefList = [];
          scope.epic = '';
          scope.urn = '';
          scope.fastrack.showCorpName = false;
          scope.fastrack.employerSearchTitle = 'Employee ID';
          break;
      }
      if (scope.aarogyachecked) {
        scope.fastrack.corporateName = 'Manipal';
      }
    };
    scope.searchGov = function (type) {
      if (type === 'URN') {
        scope.isURN = true;
        scope.isEpic = false;
        scope.epic = '';
        scope.govtBenefList = [];
      } else if (type === 'Epic') {
        scope.isURN = false;
        scope.isEpic = true;
        scope.urn = '';
        scope.govtBenefList = [];
      } else if (type === 'MemberNameAPBY') {
        scope.isURN = false;
        scope.isMemberNameAPBY = true;
        scope.urn = '';
        scope.govtBenefList = [];
      } else {
        scope.isURN = false;
        scope.epic = '';
        scope.urn = '';
        scope.isEpic = false;
      }
    };

    scope.resetModel = function () {
      scope.govtBenefList = [];
      scope.fastrack.error = false;
    };

    scope.newScheme = '';
    scope.getDetailsWithGov = function (id, type) {
      var data = {
        URN: id ? id : '',
        schemeType: scope.selectedSchemeForGov ? scope.selectedSchemeForGov : '',
        memberNameAPBY: type ? type : ''
      }
      scope.govtBenefList = [];
      scope.fastrack.error = false;
      if (data.URN) {
        FastrackService.getDetailsWithGov(data).
        then(function (response) {
            if (response.data.isSuccess) {
              scope.isSearch = false;
              scope.fastrack.error = false;
              scope.govtBenefList = response.data.govtBenefList;
            } else {
              scope.fastrack.error = true;
              scope.fastrack.errorMessage = response.data.errorMessage;
            }
          },
          function (response) {
            scope.fastrack.error = true;
            scope.fastrack.errorMessage = 'No data found';
          });
      } else {

      }
    };
    scope.getDetailsWithMaid = function (maid, benefName) {
      if (maid && benefName) {
        var data = {
          hospId: UserService.getHospitalObj().hospId,
          maid: maid,
          beneficiaryName: benefName
        }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails.json', data, 'POST').
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.displaySubmit = false;
            scope.fastrack.error = false;
            scope.fastrack.name = response.data.benefs.name;
            scope.fastrack.relations = response.data.relations;
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
          } else {
            scope.fastrack.error = true;
            scope.fastrack.errorMessage = response.data.errorMessage;
          }
        }, function (error) {
          scope.fastrack.error = true;
          scope.fastrack.errorMessage = 'No data found';
        });
      }
    };
    scope.getDetailsWithEmpId = function (empid, corpname, benefname) {
      if (empid && corpname && benefname && UserService.getHospitalObj()) {
        var data = {
          hospId: UserService.getHospitalObj().hospId,
          employeeId: empid,
          corporateName: corpname,
          BeneficiaryName: benefname
        }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails.json', data, 'POST').
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.displaySubmit = false;
            scope.fastrack.error = false;
            scope.fastrack.name = response.data.benefs.benefName;
            scope.fastrack.relations = response.data.relations;
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
          } else {
            scope.fastrack.error = true;
            scope.fastrack.errorMessage = response.data.errorMessage;
          }
        }, function (error) {
          scope.fastrack.error = true;
          scope.fastrack.errorMessage = 'No data found';
        });
      } else {

      }
    };
    scope.getDetailsWithPolicy = function (policyno, benefname) {

      if (policyno && benefname) {
        var data = {
          hospId: UserService.getHospitalObj().hospId,
          PolicyNo: policyno,
          BeneficiaryName: benefname
        }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getEcardWithPolicyNo.json', data, 'POST').
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.displaySubmit = false;
            scope.fastrack.error = false;
            scope.fastrack.name = response.data.benefs.benefName;
            scope.fastrack.relations = response.data.relations;
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
          } else {
            scope.fastrack.error = true;
            scope.fastrack.errorMessage = response.data.errorMessage;
          }
        }, function (error) {
          scope.fastrack.error = true;
          scope.fastrack.errorMessage = 'No data found';
        });
      }
    };
    scope.fastrackPopulateNewAdmissionGov = function (data) {
      //if (eCashLess.eCashlessReqId === 0) {
      //    scope.insurerFullName = eCashLess.insurerFullName;
      //    scope.form.insurername = scope.insurerFullName;
      //    scope.insurerShortName = eCashLess.insurerShortName;
      //    FastrackService.fastrackPopulateNewAdmission(maid, relationid, name).
      //        then(function (response) {
      //            if (response.data.isSuccess) {
      //                scope.getMappedpackages(scope.insurerShortName);
      //                scope.$parent.tempData = response.data.benefs;
      //                scope.resetFormData();
      //                scope.fileUploaName = [];
      //                scope.form.fileNames = [];
      //                scope.form.fileUploadFolderPath = [];
      //                scope.form.fullname = response.data.benefs.benefName;   //generic
      //                scope.form.roomtype = '';
      //                scope.form.employer = response.data.benefs.benefPolHldrName;
      //                scope.form.empid = response.data.benefs.priBenefEmpCode;
      //                scope.form.maid = response.data.benefs.benefMediAssistID;
      //                scope.form.policyno = scope.fastrack.PolicyNo;
      //                scope.form.age = response.data.benefs.benefAge;
      //                scope.form.gender = response.data.benefs.benefSex;
      //                scope.form.insurername = scope.insurerFullName;
      //                angular.element("#newPreauthModal").modal('hide');
      //            }
      //            else {
      //                scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network issue', 'Error', true);
      //            }
      //        }, function (response) {
      //            scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network issue', 'Error', true);
      //        });
      //} else {
      //    UtilitiesService.eCashlessReqData = eCashLess;
      //    scope.isECashLess = true;
      //    scope.eCashLessMessage = 'There is already a pre-approved request that exists for the patient. Redirecting you to the request. Click yes to continue.';
      //    timeout(function () {
      //        scope.$apply(function () {
      //            scope.isECashLess = false;
      //            scope.eCashLessMessage = '';
      //        });
      //    }, 10000)
      //}
      scope.form.fullname = data.memberName;
      scope.form.memberId = data.memberID;
      scope.form.URNNum = data.urn;
      scope.form.memberGender = data.gender == 'f' ? 'female' : data.gender == 'm' ? 'male' : '';
      angular.element("#newMSBYSearch").modal('hide');
    };

    scope.removeData = [];
    scope.removePackageFromList = function (item) {
      if (item) {
        angular.forEach(scope.selectedMappedpackages, function (data, index) {
          if (item.uniqueIds === data.uniqueIds) {
            scope.selectedMappedpackages.splice(index, 1);
          }
        })
        scope.removeData = item;
        //scope.$broadcast('removeData', item);
        //scope.calculatePrice();
      }
    };

    scope.ctrlFn = function (nextpage) {
      scope.selectedMappedpackages = [];
      scope.selectedMappedpackages = nextpage;
      scope.calculatePrice();
    };
    scope.isECashLess = false;
    scope.eCashLessMessage = '';
    scope.newPackageListData = [];
    scope.getMappedpackages = function (details) {
      scope.mappedpackages = [];
      scope.selectedMappedpackages = [];
      scope.isPriceOne = false;
      scope.isPriceTow = false;
      scope.isPriceThree = false;
      if (UserService.getHospitalObj()) {
        var data = {
          hospitalId: UserService.getHospitalObj().cmsHospId,
          insurerShortName: details
          //--details
          //'NIA'
        }
        scope.newPackageListData = [];
        // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/mappedpackages', data, 'POST', UserService.getAccessToken()).then(function (response) {
        //   if (response.data.isSuccess) {
        //     scope.mappedpackages = response.data.mappedpackages;
        //     angular.forEach(scope.mappedpackages, function (data, index) {
        //       var testObje = [];
        //       angular.forEach(data.distinctPrices, function (data1, index1) {
        //         testObje.push({
        //           isSelected: false,
        //           price: data1,
        //           packageId: scope.mappedpackages[index].packageId
        //         })
        //       });
        //       scope.newPackageListData.push(testObje);
        //       scope.mappedpackages[index].newPriceObj = testObje;
        //     });
        //     angular.forEach(scope.mappedpackages, function (data, index) {
        //       scope.mappedpackages[index].general_Ward1 = false;
        //       scope.mappedpackages[index].private_Ward1 = false;
        //       scope.mappedpackages[index].semi_Private_Ward1 = false;
        //     })
        //   } else {
        //     scope.mappedpackages = [];
        //   }
        // });
      }
    };

    scope.getPackagesListForInsurer = function (data) {
      var selectedShoertName = '';
      scope.mappedpackages = [];
      if (data) {
        selectedShoertName = _.findWhere(scope.insurerList, {
          insurerFullName: data
        });
        scope.getMappedpackages(selectedShoertName.insurerShortName);
      }
    };

    //scope.getMappedpackages('NIA');
    scope.fastrackPopulateNewAdmission = function (maid, relationid, name, eCashLess) {
      if (eCashLess.eCashlessReqId === 0) {
        scope.insurerFullName = eCashLess.insurerFullName;
        scope.form.insurername = scope.insurerFullName;
        scope.insurerShortName = eCashLess.insurerShortName;
        FastrackService.fastrackPopulateNewAdmission(maid, relationid, name).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.getMappedpackages(scope.insurerShortName);
            scope.$parent.tempData = response.data.benefs;
            scope.resetFormData();
            scope.fileUploaName = [];
            scope.form.fileNames = [];
            scope.form.fileUploadFolderPath = [];
            scope.form.fullname = response.data.benefs.benefName; //generic
            scope.form.roomtype = '';
            scope.form.employer = response.data.benefs.benefPolHldrName;
            scope.form.empid = response.data.benefs.priBenefEmpCode;
            scope.form.maid = response.data.benefs.benefMediAssistID;
            scope.form.policyno = scope.fastrack.PolicyNo;
            scope.form.age = response.data.benefs.benefAge;
            scope.form.gender = response.data.benefs.benefSex;
            scope.form.insurername = scope.insurerFullName;
            angular.element("#newPreauthModal").modal('hide');
          } else {
            scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network issue', 'Error', true);
          }
        }, function (response) {
          scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network issue', 'Error', true);
        });
      } else {
        UtilitiesService.eCashlessReqData = eCashLess;
        scope.isECashLess = true;
        scope.eCashLessMessage = 'There is already a pre-approved request that exists for the patient. Redirecting you to the request. Click yes to continue.';
        timeout(function () {
          scope.$apply(function () {
            scope.isECashLess = false;
            scope.eCashLessMessage = '';
          });
        }, 10000)
      }
    };
    scope.opened = true;
    scope.reDirect = function (value) {

      if (value) {
        angular.element("#newPreauthModal").modal('hide');
        state.go(value, {
          reload: false
        });
      }
    };
    scope.clearfastrack = function () {
      scope.fastrack = {};
      scope.fastrack.displaySubmit = true;
      scope.fastrack.title = 'Member Search';
      scope.aarogyachecked = false;
      scope.fastrack.showCorpName = true;
      scope.fastrack.employerSearchTitle = 'Employee ID';
    };
    scope.removeModal = function () {
      scope.clearfastrack();
      angular.element("#newPreauthModal").modal('hide');
    };
    scope.packageCheck = function (data) {
      var isCheck = true;
      angular.forEach(data, function (data, index) {
        if (!data.general_Ward1 && !data.private_Ward1 && !data.semi_Private_Ward1) {
          isCheck = false
        }
      });
      return isCheck;
    };
    scope.getPackagesForPreAuthForm = function () {
      var packagesForPreAuthForm = scope.selectedMappedpackagesObj(scope.selectedMappedpackages);
      scope.packagesForPreAuthForm = [];
      if (packagesForPreAuthForm) {
        angular.forEach(packagesForPreAuthForm, function (data, index) {
          scope.packagesForPreAuthForm.push(data.packageName);
        });
      }
      return scope.packagesForPreAuthForm.join();
    };
    scope.selectedMappedpackagesObj = function (data) {
      scope.objSelected = [];
      if (data) {
        angular.forEach(data, function (data, index) {
          var obj;
          if (data.general_Ward1) {
            obj = {
              packageName: data.package_Name,
              packageId: data.packageId,
              packageAmount: data.general_Ward,
              packageCappedAmount: 0
            }
          } else if (data.private_Ward1) {
            obj = {
              packageName: data.package_Name,
              packageId: data.packageId,
              packageAmount: data.private_Ward,
              packageCappedAmount: 0
            }
          } else if (data.semi_Private_Ward1) {
            obj = {
              packageName: data.package_Name,
              packageId: data.packageId,
              packageAmount: data.semi_Private_Ward,
              packageCappedAmount: 0
            }
          } else {
            obj = {};
          }
          scope.objSelected.push(obj);
        });
        return scope.objSelected;
      }
    };

    scope.preAuthfileCollection = [];
    scope.uploadImage = function (value) {
      var filesUploadingArray = [],
        fileBlobArray = [];
      angular.forEach(value.files, function (key, value) {
        filesUploadingArray.push(key);
      });
      fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
      $q.all(fileBlobArray).then(function (result) {
          result.forEach(function (element) {
            var filesUploadingArray = [];
            if (element.data.isSuccess) {
              scope.preAuthfileCollection = element.data.uploadResponseDetails;
            } else {
              UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to upload files.');
            }
          });
        },
        function (error) {
          UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to upload files.');
        });
    };

    scope.preauthFormAction = (function () {
      scope.insuranceCompanyList = UtilitiesService.getInsuranceCompanyName();
      scope.username = UserService.getUserObj().userName;
      scope.showAutoPackages = true;

      function submitPreauthFormSuccess(successData) {
        scope.fileUploaName = [];
        scope.isProcessing = false;
        if (successData.data.isSuccess) {
          scope.form.preauthSuccess = true;
        } else {
          scope.form.preauthError = true;
        }
      }

      function submitPreauthFormError(ErrorData) {
        scope.isProcessing = false;
        scope.form.preauthError = true;
      }

      function fileUploadError(errordata) {
        scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'File Upload Error', 'Error', true);
      }
      return {
        getPreauthFormData: function (form) {
          var data = {
            IsGovtClaim: false,
            MemberGender: form.gender == undefined ? '' : form.gender,
            Age: form.age == undefined ? '' : form.age,
            ApplicationName: 'Hospital Portal',
            PatientFirstName: form.fullname,
            ContactNum: form.mobile,
            EmpId: form.empid,
            Employer: form.employer,
            Maid: form.maid,
            Doa: form.doa,
            packagesList: scope.selectedMappedpackagesObj(scope.selectedMappedpackages),
            ApproxClaimedAmnt: parseInt(form.clmamount),
            DocName: form.docname,
            DocRegNo: 'String',
            Diagnosis: form.diagnosis,
            AdmissionType: form.admissiontype,
            RoomType: form.roomtype,
            TentativeDOD: form.dod,
            HospId: UserService.getHospitalObj().hospId,
            HospName: UserService.getHospitalObj().hospName,
            CreatedBy: UserService.getUserObj().userId,
            IpNumber: form.ipnumber,
            Procedure: form.procedure,
            IpAddress: 'String',
            PolicyNumber: form.policyno,
            InsurerName: form.insurername,
            FileNames: form.fileNames,
            FileUploadFolderPath: form.fileUploadFolderPath.join(),
            uiD_NO: form.uidno,
            attachedFiles: scope.fileUploaName,
            tpaid: form.tpaId ? form.tpaId : 0,
            tpaConfigId: form.hospTPAId ? form.hospTPAId : 0,
            uniqueId: form.uniqueId ? form.uniqueId : ''
          };
          return data;

        },
        uploadFiles: function (callback) {
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = [];
          var fileBlobArray = [];
          if (scope.preAuthFile) {
            Object.keys(scope.preAuthFile).forEach(function (e) {
              if (typeof (scope.preAuthFile[e]) == 'object') {
                scope.file.push({
                  'model': scope.preAuthFile[e]
                });
              }
            });
          }
          var filesUploadingArray = [];
          Object.keys(scope.file).forEach(function (ele) {
            if (typeof (scope.file[ele].model) == "object") {
              filesUploadingArray.push(scope.file[ele].model);
            }
          });
          if (filesUploadingArray.length > 0) {
            fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
          } else {
            scope.isProcessing = false;
            UtilitiesService.showAlertMessage('Please attach atleast one document.');
            return false;
          }
          $q.all(fileBlobArray).then(function (result) {
              result.forEach(function (element) {
                if (element.data.isSuccess) {
                  angular.forEach(element.data.uploadResponseDetails, function (e, i) {
                    scope.form.fileNames.push(e.fileName);
                    scope.form.fileUploadFolderPath.push(e.downloadURL);
                    scope.fileUploaName.push({
                      fileName: e.fileName,
                      docPath: e.downloadURL
                    });
                  });
                } else {
                  scope.isProcessing = false;
                  scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                  return false;
                }
              });
              if (result && (filesUploadingArray.length == 0 || scope.form.fileNames.length == result[0].data.uploadResponseDetails.length))
                callback.call(scope.preauthFormAction);
            },
            function (error) {
              scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
              scope.isProcessing = false;
            });
        },
        submitPreauthForm: function () {
          if (!scope.form.isgovtscheme) {
            if (scope.packageCheck(scope.selectedMappedpackages) && scope.selectedMappedpackagesObj(scope.selectedMappedpackages).length > 0) {
              this.uploadFiles(function () {
                scope.isProcessing = true;
                NewAdmissionFormService.submitPreauthForm(this.getPreauthFormData(scope.form)).then(submitPreauthFormSuccess, submitPreauthFormError);
              });
            } else {
              UtilitiesService.showAlertMessage('Please select procedure or add manually.')
            }
          } else {
            if (scope.selectedPackages.length !== 0) {
              this.uploadFiles(function () {
                scope.isProcessing = true;
                scope.govtSchemeMethods.submitPreauthForm();
              });
            } else {
              UtilitiesService.showAlertMessage('Please add atleast one government package.')
            }
          }

        },
        closePreauthForm: function () {
          scope.resetFormData();
          $location.path('/claims');
        },
        downloadPrefilledPreauthForm: function (source) {
          var PreauthFormDataObj = {
            HospitalID: UserService.getHospitalObj().cmsHospId,
            HospitalEmail: UserService.getHospitalObj().emailAddress,
            HospitalName: UserService.getHospitalObj().hospName,
            HospitalPhoneNo: UserService.getHospitalObj().primaryContactNumber,
            HospitalAddress: (UserService.getHospitalObj().address + UserService.getHospitalObj().city).replace(/[^a-zA-Z0-9 ]/g, ""),

            PatientName: scope.form.fullname,
            PatientPhoneNo: scope.form.mobile,
            CorporateName: scope.form.employer,
            EmployeeID: scope.form.empid,
            MAID: scope.form.maid ? scope.form.maid : '',
            DOA: scope.form.doa.getFullYear() + '-' + (scope.form.doa.getMonth() + 1) + '-' + scope.form.doa.getDate(),
            DOD: scope.form.dod.getFullYear() + '-' + (scope.form.dod.getMonth() + 1) + '-' + scope.form.dod.getDate(),
            Ailment: scope.form.diagnosis,
            Treatment: scope.getPackagesForPreAuthForm(),
            AdmissionType: scope.form.admissiontype,
            ClaimedAmount: scope.form.clmamount,
            DocName: scope.form.docname,
            RoomType: scope.form.roomtype,
            TPAId: scope.form.tpaId,
            UniqueId: scope.form.uniqueId ? scope.form.uniqueId : ''
          };
          NewAdmissionFormService.downloadPrefilledPreauthForm(source, PreauthFormDataObj)
        }
      };
    })();
    scope.govtSchemeMethods = (function () {
      scope.selectedPackages = new Array();

      function submitPreauthFormSuccess(successData) {
        scope.fileUploaName = [];
        scope.isProcessing = false;
        if (successData.data.isSuccess) {
          scope.form.preauthSuccess = true;
        } else {
          scope.form.preauthError = true;
        }
      }

      function submitPreauthFormError(ErrorData) {
        scope.isProcessing = false;
        scope.form.preauthError = true;
      }

      function getGovtPackageListSuccess(resData) {
        if (resData && resData.data.isSuccess && resData.data.packages && resData.data.packages.length > 0) {
          scope.govtPackageList1 = resData.data.packages;
          scope.govtPackageListDummy = scope.govtPackageList1;
          scope.changeGovtPolicyType('Basic');
          UserService.setGovtPackageList(scope.govtPackageList1);
          scope.showGovtPackages = true;
        } else {
          if (resData.data.isSuccess === false) {
            scope.govtPackageList1 = [];
            scope.govtPackageListDummy = scope.govtPackageList1;
            UserService.setGovtPackageList(scope.govtPackageList1);
            scope.showGovtPackages = false;
          }

        }
      }

      function getGovtPackageListError(resData) {
        scope.govPackage = [];
        scope.govtPackageListDummy = scope.govPackage;
        UtilitiesService.showAlertMessage('Error while fetching govt packages list');
      }
      return {
        getGovtPackageList: function () {
          var govPackage = UserService.getGovtPackageList();
          if (govPackage != undefined && govPackage != null) {
            scope.govPackage = govPackage;
            scope.govtPackageListDummy = govPackage;
            scope.changeGovtPolicyType('Basic');
            scope.showGovtPackages = true;
          } else {
            GovernmentService.getGovtPackageList().then(getGovtPackageListSuccess, getGovtPackageListError)
          }
        },
        setGovtPackageId: function (packageObj) {
          scope.form.packageAmount = packageObj.packageCost;
          scope.form.packageName = packageObj.packageName;
          scope.form.packageUniqueId = packageObj.packageId;
          scope.form.cappedAmount = packageObj.cappedAmount;
        },
        addPackageButton: function () {
          if (scope.form.packageAmount || scope.form.mPackageAmount) {
            if (scope.selectedPackages.length < 3) {
              if (scope.showAutoPackages) {
                scope.selectedPackages.push({
                  id: scope.selectedPackages.length,
                  uniqueId: scope.form.packageUniqueId,
                  name: scope.form.packageName,
                  amount: scope.form.packageAmount
                });
                $("#packagesHolder").val($("#packagesHolder").val() + ", " + scope.form.packageUniqueId);
              } else {
                scope.selectedPackages.push({
                  id: scope.selectedPackages.length,
                  uniqueId: 0,
                  name: scope.form.mPackageName,
                  amount: scope.form.mPackageAmount
                });
                $("#packagesHolder").val($("#packagesHolder").val() + ", 0");
              }
              scope.packageCalcAmount = 0;
              for (var i = 0; i < scope.selectedPackages.length; i++) {
                scope.packageCalcAmount = scope.packageCalcAmount + ((25 * (4 - i)) / 100) * scope.selectedPackages[i].amount;
              }
              $("#packageAmountHolder").val(scope.packageCalcAmount);
            } else {
              UtilitiesService.showAlertMessage('Maximum of 3 packages allowed.');
            }
          }
        },
        removePackage: function (id) {
          $("#packagesHolder").val($("#packagesHolder").val().replace(", " + scope.selectedPackages[id].uniqueId, ""));
          for (var i = id; i < scope.selectedPackages.length - 1; i++) {
            scope.selectedPackages[i] = scope.selectedPackages[i + 1];
            scope.selectedPackages[i].id--;
          }
          scope.selectedPackages.pop(scope.selectedPackages.length - 1);
          scope.packageCalcAmount = 0;
          for (var i = 0; i < scope.selectedPackages.length; i++) {
            scope.packageCalcAmount = scope.packageCalcAmount + ((25 * (4 - i)) / 100) * scope.selectedPackages[i].amount;
          }
          $("#packageAmountHolder").val(scope.packageCalcAmount);
        },

        getPreauthFormData: function (form) {
          var data = {
            IsGovtClaim: true,
            urnNumber: form.URNNum,
            memberId: form.memberId,
            memberDistrict: form.memberDist,
            reasonForChoosing: form.reasonOnline ? form.reasonOnline.join() : '',
            packages: scope.selectedPackages.map(function (item) {
              return item.uniqueId
            }),
            MemberGender: form.memberGender,
            Age: form.memberAge,
            ApplicationName: 'Hospital Portal',
            PatientFirstName: form.fullname,
            ContactNum: form.mobile,
            Doa: form.doa,
            DocName: form.docname,
            Diagnosis: form.diagnosis,
            TentativeDOD: form.dod,
            HospId: UserService.getHospitalObj().hospId,
            HospName: UserService.getHospitalObj().hospName,
            CreatedBy: UserService.getUserObj().userId,
            IpNumber: form.ipnumber,
            FileNames: form.fileNames, //form.fileUploadFolderPath,// form.fileNames,
            FileUploadFolderPath: form.fileUploadFolderPath.join(),
            ApproxClaimedAmnt: parseInt(scope.packageCalcAmount),
            uiD_NO: form.uidno,
            GovScheme: scope.selectedSchemeForGov === 'APCMUHIS_Mediassist' ? 'APCMUHIS_Mediassist' : 'RSBY',
            attachedFiles: scope.fileUploaName,
            tpaid: form.tpaId ? form.tpaId : 0,
            tpaConfigId: form.hospTPAId ? form.hospTPAId : 0,
            uniqueId: form.uniqueId ? form.uniqueId : ''
          };
          return data;
        },
        submitPreauthForm: function () {
          scope.isProcessing = true;
          NewAdmissionFormService.submitPreauthForm(this.getPreauthFormData(scope.form)).
          then(submitPreauthFormSuccess, submitPreauthFormError)
        },
        changePackageField: function () {
          if (scope.form.reasonOnline == 'others') {
            scope.showAutoPackages = false;
          } else {
            scope.showAutoPackages = true;
          }
        }
      };
    })();
    scope.checkForGovPackages = function () {
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/GovtSchemeAvailability.json?priEntityId=' + UserService.getUserObj().entityId + '&secEntityName=Medi%20Assist', '', 'GET', UserService.getAccessToken()).then(function (response) {
        if (response.data.isSuccess) {
          scope.showGovtPackages = true;
        } else {
          scope.showGovtPackages = false;
        }
      });
    };

    //scope.checkForGovPackages();

    scope.govtSchemeMethods.getGovtPackageList();
    scope.preClaimInfoRelatedMethods = (function () {
      function submitPreauthFormSuccess(successData) {
        scope.isProcessing = false;
        if (successData.data.isSuccess) {
          scope.form.preauthSuccess = true;
        } else {
          scope.form.preauthError = true;
        }
      }

      function submitPreauthFormError(ErrorData) {
        scope.isProcessing = false;
        scope.form.preauthError = true;
      }
      return {
        prefillPreauthForm: function (claimRefNo) {
          NewAdmissionFormService.getPreauthDataByMARefNo(claimRefNo).then(function (resData) {
            scope.resetFormData();
            scope.signup = {};
            if (resData.data.detailslist.length > 0) {
              if (resData.data.detailslist[0].admissioN_DATE.indexOf('T') > -1) {
                resData.data.detailslist[0].admissioN_DATE = new Date(resData.data.detailslist[0].admissioN_DATE);
                resData.data.detailslist[0].dischargE_DATE = new Date(resData.data.detailslist[0].dischargE_DATE);
              } else {
                var formattedDoa = resData.data.detailslist[0].admissioN_DATE.split('-')
                resData.data.detailslist[0].admissioN_DATE = new Date(formattedDoa[1] + '/' + formattedDoa[0] + '/' + formattedDoa[2])
                var formattedDod = resData.data.detailslist[0].dischargE_DATE.split('-');
                resData.data.detailslist[0].dischargE_DATE = new Date(formattedDod[1] + '/' + formattedDod[0] + '/' + formattedDod[2])
              }
              scope.form.fullname = resData.data.detailslist[0].patienT_FIRSTNAME;
              scope.form.mobile = parseInt(resData.data.detailslist[0].mobilE_NO);
              scope.form.employer = resData.data.detailslist[0].corporatE_NAME;
              scope.form.empid = resData.data.detailslist[0].employeE_ID;
              scope.form.maid = resData.data.detailslist[0].maid;
              scope.form.doa = (resData.data.detailslist[0].admissioN_DATE);
              scope.form.dod = (resData.data.detailslist[0].dischargE_DATE);
              scope.form.diagnosis = resData.data.detailslist[0].presenT_AILMENT;
              scope.form.procedure = resData.data.detailslist[0].provisionaL_TREATMENT;
              scope.form.admissiontype = resData.data.detailslist[0].admissioN_TYPE;
              scope.form.clmamount = parseInt(resData.data.detailslist[0].preautH_AMOUNT);
              scope.form.docname = resData.data.detailslist[0].firsT_NAME;
              scope.form.roomtype = resData.data.detailslist[0].provideR_ROOM_TYPE;
              scope.PreAuthForIRRemarks = resData.data.detailslist[0].remarks;
            }
          }, function (error) {
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          });
        },
        getPreauthFormData: function (form) {
          var data = {
            PreAuthNo: scope.dataobj.claimRefNo,
            IsGovtClaim: false,
            MemberGender: form.gender == undefined ? '' : form.gender,
            Age: form.age == undefined ? '' : form.age,
            ApplicationName: 'Hospital Portal',
            PatientFirstName: form.fullname,
            ContactNum: form.mobile,
            EmpId: form.empid,
            Employer: form.employer,
            Maid: form.maid,
            Doa: form.doa,
            packagesList: scope.selectedMappedpackagesObj(scope.selectedMappedpackages),
            ApproxClaimedAmnt: parseInt(form.clmamount),
            DocName: form.docname,
            DocRegNo: 'String',
            Diagnosis: form.diagnosis,
            AdmissionType: form.admissiontype,
            RoomType: form.roomtype,
            TentativeDOD: form.dod,
            HospId: UserService.getHospitalObj().hospId,
            HospName: UserService.getHospitalObj().hospName,
            CreatedBy: UserService.getUserObj().userId,
            IpNumber: form.ipnumber,
            Procedure: form.procedure,
            IpAddress: 'String',
            PolicyNumber: form.policyno,
            InsurerName: form.insurername,
            FileNames: form.fileNames,
            FileUploadFolderPath: form.fileUploadFolderPath.join(),
            uiD_NO: form.uidno,
            attachedFiles: scope.fileUploaName,
            tpaid: form.tpaId ? form.tpaId : 0,
            tpaConfigId: form.hospTPAId ? form.hospTPAId : 0,
            uniqueId: form.uniqueId ? form.uniqueId : ''
          };
          return data;
        },
        uploadFiles: function (callback) {
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = [];
          var fileBlobArray = [];
          if (scope.preAuthFile) {
            Object.keys(scope.preAuthFile).forEach(function (e) {
              if (typeof (scope.preAuthFile[e]) == 'object') {
                scope.file.push({
                  'model': scope.preAuthFile[e]
                });
              }
            });
          }
          var filesUploadingArray = [];
          Object.keys(scope.file).forEach(function (ele) {
            if (typeof (scope.file[ele].model) == "object") {
              filesUploadingArray.push(scope.file[ele].model);
            }
          });
          if (filesUploadingArray.length > 0) {
            fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
          } else {
            scope.isProcessing = false;
            UtilitiesService.showAlertMessage('Please attach atleast one document.');
            return false;
          }
          $q.all(fileBlobArray).then(function (result) {
              result.forEach(function (element) {
                if (element.data.isSuccess) {
                  angular.forEach(element.data.uploadResponseDetails, function (e, i) {
                    scope.form.fileNames.push(e.fileName);
                    scope.form.fileUploadFolderPath.push(e.downloadURL);
                  });
                } else {
                  scope.isProcessing = false;
                  scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                  return false;
                }
              });
              if (result && (filesUploadingArray.length == 0 || scope.form.fileNames.length == result[0].data.uploadResponseDetails.length))
                callback.call(scope.preClaimInfoRelatedMethods);
            },
            function (error) {
              scope.isProcessing = false;
              scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
            });
        },
        submitPreClaimPreauthForm: function () {
          scope.isProcessing = true;
          this.uploadFiles(function () {
            if (!scope.form.IsGovtClaim) {
              NewAdmissionFormService.submitPreClaimPreauthForm(this.getPreauthFormData(scope.form)).
              then(submitPreauthFormSuccess, submitPreauthFormError);
            } else {
              scope.govtSchemeMethods.submitPreauthForm();
            }
          });
        },
        closePreauthForm: function () {
          scope.resetFormData();
          $location.path('/claims');
        },
      };
    })();
    if (scope.source == 'preClaim' && scope.dataobj.claimRefNo) {
      scope.preClaimInfoRelatedMethods.prefillPreauthForm(scope.dataobj.claimRefNo);
    }


    scope.todaysDate = new Date();
    scope.todaysDate = scope.todaysDate.setMonth(scope.todaysDate.getMonth() - 1);
    scope.todaysDate = new Date(scope.todaysDate);
    scope.isFormDisable = true;
    scope.dateOfAdmission = function (date, type) {
      scope.isFormDisable = false;
      if (type === 'doa') {
        var currentMonth = scope.todaysDate.getMonth() + 2;
        var selectedMonth = scope.form.doa.getMonth();
        if (currentMonth < selectedMonth) {
          scope.isdoa = true;
          scope.isFormDisable = true;
          if (scope.form.dod) {
            scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
          }
        } else {
          scope.isdoa = scope.todaysDate <= scope.form.doa ? false : true;
          scope.isFormDisable = scope.isdoa;
          if (scope.form.dod) {
            scope.isdod = scope.form.dod >= scope.form.doa ? false : true;
          }
        }
      } else if (type === 'dod') {
        var currentMonth = scope.todaysDate.getMonth() + 2;
        var selectedMonth = scope.form.doa.getMonth();
        if (currentMonth < selectedMonth) {
          scope.isdoa = true;
          scope.isFormDisable = true;
          scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
        } else {
          scope.isdod = scope.form.dod >= scope.form.doa && scope.todaysDate <= scope.form.doa ? false : true;
          if (scope.form.doa) {
            scope.isdoa = scope.todaysDate <= scope.form.doa ? false : true;
            if (!scope.isdoa) {
              scope.isdoa = scope.form.dod < scope.form.doa ? true : false;
            }
          }
        }
      }
    };

    scope.file = [];
    scope.addFileToUpload = function (flag) {
      var newItemNo = scope.file.length + 1;
      scope.file.push({
        'model': ''
      });
    };
    scope.removeFileToUpload = function () {
      var lastItem = scope.file.length - 1;
      scope.file.splice(lastItem);
      scope.validLargeDoc = false;
    };
    scope.addFileToUpload();
  }]);

angular.module('mbplus').controller('ModalInstanceCtrl', ['$scope', '$uibModalInstance', 'types', 'FastrackService', function (scope, $uibModalInstance, types, FastrackService) {
  //console.log("modal instanceCtrl")

  scope.modalinsta = "ModalInstanceCtrl-child";

  scope.ok = function () {
    $uibModalInstance.close(scope.selected.item);
  };

  scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  scope.fastrackPreauth = function (type) {
    scope.fastrack = {};
    scope.fastrack.title =
    scope.fastrack.displaySubmit = true;
    switch (type) {
      case 'aarogya':
        scope.fastrack.title = "Aarogya Scheme"
        scope.aarogyachecked = true;
        scope.fastrack.showCorpName = false;
        scope.fastrack.employerSearchTitle = "Family Number";
        break;
      case 'generic':
        scope.fastrack.title = "Member Search";
        scope.aarogyachecked = false;
        scope.fastrack.showCorpName = true;
        scope.fastrack.employerSearchTitle = "Employee ID";
        break;
    }
    if (scope.aarogyachecked) {
      scope.fastrack.corporateName = "Manipal";
    }
  }
  scope.fastrackPreauth(types);
  scope.getDetailsWithMaid = function (maid, benefName) {
    FastrackService.getDetailsWithMaid(maid, benefName).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.displaySubmit = false;
            scope.fastrack.error = false;
            scope.fastrack.name = response.data.benefs.name;
            scope.fastrack.relations = response.data.relations;
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
          }
          else {
            scope.fastrack.error = true;
            scope.fastrack.errorMessage = response.data.errorMessage;
          }
        },
           function (response) {
             scope.fastrack.error = true;
             scope.fastrack.errorMessage = "No data found"
           });
  }
  scope.getDetailsWithEmpId = function (empid, corpname, benefname) {
    FastrackService.getDetailsWithEmpId(empid, corpname, benefname).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.displaySubmit = false;
            scope.fastrack.error = false;
            scope.fastrack.name = response.data.benefs.benefName;
            scope.fastrack.relations = response.data.relations;
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
          }
          else {
            scope.fastrack.error = true;
            scope.fastrack.errorMessage = response.data.errorMessage;
          }
        },
           function (response) {
             scope.fastrack.error = true;
             scope.fastrack.errorMessage = "No data found"
           });
  }
  scope.getDetailsWithPolicy = function (policyno, benefname) {
    FastrackService.getDetailsWithPolicy(policyno, benefname).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.fastrack.displaySubmit = false;
            scope.fastrack.error = false;
            scope.fastrack.name = response.data.benefs.benefName;
            scope.fastrack.relations = response.data.relations;
            scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;


          }
          else {
            scope.fastrack.error = true;
            scope.fastrack.errorMessage = response.data.errorMessage;
          }


        },
           function (response) {
             scope.fastrack.error = true;
             scope.fastrack.errorMessage = "No data found"
           });
  }
  scope.fastrackPopulateNewAdmission = function (maid, relationid, name) {
    FastrackService.fastrackPopulateNewAdmission(maid, relationid, name).
        then(function (response) {
          if (response.data.isSuccess) {
            scope.$parent.tempData = response.data.benefs;
            scope.form = {};
            scope.form.fullname = response.data.benefs.benefName;   //generic
            scope.form.roomtype = "General ward";
            scope.form.employer = response.data.benefs.benefPolHldrName;
            scope.form.empid = response.data.benefs.priBenefEmpCode;
            scope.form.maid = response.data.benefs.benefMediAssistID;
            scope.form.policyno = scope.fastrack.PolicyNo;
          }
          else {
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          }
        },
           function (response) {
             UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
           });
  }
}]);
angular.module('mbplus')
    .controller('leftMenuCtrl', ['$rootScope', '$scope', 'UserService', '$location', 'UtilitiesService', '$timeout', 'PlusUtilitiesService', '$state', 'filterFilter','$analytics', function ($rootScope, scope, UserService, $location, UtilitiesService, $timeout, PlusUtilitiesService, $state, filterFilter,$analytics) {
        scope.ctrlName = "leftMenuCtrl";
        if (UserService.getUserObj()) {
            if(UserService.getUserObj().firstName){
                scope.showOrderPunching = UserService.getUserObj().firstName.toLowerCase().indexOf("lifecare") > -1 || UserService.getUserObj().firstName.toLowerCase().indexOf("diagright") > -1;
            }
            if (UserService.getUserObj().rolesFeatures) {
                scope.userRolesFeatures = UserService.getUserObj().rolesFeatures.roles;
            } else {
                if ($location.search().access_token) {
                } else {

                    UserService.destroyUserObj();
                }
            }
        }
        scope.user = UserService.getUserObj();
        scope.fuserUpsellEnabled = false;
        if(scope.user && scope.user.isFuserUpsell) {
            scope.fuserUpsellEnabled = true;
        }

        scope.checkForInsurerAdmin = function () {
            var result = false;
            if ((scope.user && scope.user.entityId && scope.user.entityId === 1039391) || (scope.user && scope.user.entityId && (scope.user.entityId === 1031428 || scope.user.entityId === 1005309)) ) {
                if (scope.user.rolesFeatures && scope.user.rolesFeatures.roles) {
                    angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
                        if (v.roleId === 9207 || v.roleId === 9214) {
                            result = true;
                        }
                    });
                }
            }
            return result;
        };

        scope.createAppointment = function () {
            $state.go('esales');
        };
        
        scope.viewDcDocuments = function () {
            $state.go('provider-documents');
        }

        scope.checkIfPrePolicyValid = function (menuOptions) {
            if(UserService.isPolicyBazar && menuOptions.menuItem == 'Pre Policy Orders')  {
                return false;
            }
            else return true
        }

        $rootScope.toggleMenu = function () {
            $rootScope.toggleMenuObj.isNormalRoleActive = !$rootScope.toggleMenuObj.isNormalRoleActive;
            $rootScope.toggleMenuObj.isDcRoleActive = !$rootScope.toggleMenuObj.isDcRoleActive;
            $analytics.eventTrack('IP_OP_Clicked', {
                category: 'IP_OP', label: $rootScope.toggleMenuObj.isNormalRoleActive ? 'In-Patient Active' : 'Out-Patient Active'
              });
            UserService.setUserMenuToggle($rootScope.toggleMenuObj);
            $rootScope.toggleMenuObj = UserService.getUserMenuToggle();
            scope.currentPath = $location.path();
            if ($rootScope.toggleMenuObj && $rootScope.toggleMenuObj.isMultiRole) {
                if (scope.currentPath == 'changepwd' || scope.currentPath == 'terms') {

                }
                else if ($rootScope.toggleMenuObj.isDcRoleActive) {
                    $location.path('dcDashboard', {}, { reload: true });
                }
                else {
                    $location.path('claims', {}, { reload: true });
                }
            }
            scope.BuildItemCategory(PlusUtilitiesService.getMenuItems(PlusUtilitiesService.getMenuDetails()));
        }

        // scope.setDefaultUserRoute = function () {
        //     $rootScope.toggleMenuObj = UserService.getUserMenuToggle();
        //     scope.currentPath = $location.path();
        //     if ($rootScope.toggleMenuObj && $rootScope.toggleMenuObj.isMultiRole) {
        //         if (scope.currentPath == 'changepwd' || scope.currentPath == 'terms') {

        //         }
        //         else if ($rootScope.toggleMenuObj.isDcRoleActive) {
        //             $location.path('dcDashboard', {}, { reload: true });
        //         }
        //         else {
        //             $location.path('claims', {}, { reload: true });
        //         }
        //     }
        // }

        scope.myStyle = { 'background-color': '#e03f4e' };
        //Feature List
        scope.plusFeaturesToLoad = [];
        scope.plusAppointmentFeaturesToLoad = [];
        scope.plusPaymentFeatureToLoad = [];
        scope.hospFeatureNotificationToLoad = [];
        scope.hospFeaturesToLoad = [];
        scope.networkFeaturesToLoad = [];
        scope.SharedMenuToLoad = [];
        scope.featureListForPlusAppointments = [];
        scope.featureListForPlus = [5438, 5439, 9196, 9203, 9201, 9225, 9224];

        scope.featureListForNetwork = [1, 9184, 9185, 9186, 9187, 9188, 9189];
        scope.hospRolesId = [9216, 4670, 4671, 5113, 5114, 9215];
        scope.featureListForHosp = [9216, 9207, 9206, 9209, 9210, 9212, 9213, 9214, 9215, 9217, 9218, 9220, 9221, 19999];
        scope.fullFeatureList = [9216, 9207, 9225, 9224, 5436, 5438, 5439, 9194, 9196, 9203, 9201, 5435, 5443, 9190, 9197, 9191, 9192, 9193, 9195, 9199, 9206, 9209, 9210, 9212, 9213, 9214, 9215, 9217, 9218, 9220, 9221, 19999, 9184, 9185, 9186, 9187, 9188, 9189, 1, 9227];
        scope.featureNotification = [10000000];
        scope.featureNotification1 = [2];

        scope.getCmsUserCheck = function () {
            scope.isCmsUserCheck = false;
            if (scope.user && scope.user.rolesFeatures && scope.user.rolesFeatures.roles && scope.user.rolesFeatures.roles.length > 0) {
                angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
                    if (v.roleId === 9216) {
                        scope.isCmsUserCheck = true;
                    }
                })
            }
            return scope.isCmsUserCheck;
        };

        scope.notifyCount = {
            approvedNotificationCount: 0,
            infoRequiredNotificationCount: 0,
            deniedNotificationCount: 0,
            paymentNotificationCount: 0
        }

        scope.checkForInsurerHead = function () {
            var result = false;
                if (scope.user && scope.user.rolesFeatures && scope.user.rolesFeatures.roles) {
                    angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
                        if (v.roleName === "Insurer_Admin") {
                            result = true;
                        }
                    });
                }
            return result;
        };
        
        scope.hospitalNotification = 0;
        scope.setupClaimNotification = function () {
            if ($.connection && $.connection.hub) {
                $.connection.hub.url = UtilitiesService.getUrlPrefixForSignalR();
                var chat = $.connection.notificationHub;
                // Create a function that the hub can call to broadcast messages.
                chat.client.sendClaimNotification = function (obj) {
                    var notificationDetails = [];
                    if (UserService.getHospitalObj()) {
                        angular.forEach(obj, function (key, index) {
                            if (key.HospitalId === parseInt(UserService.getHospitalObj().cmsHospId)) {
                                notificationDetails.push(key);
                            }
                        });
                    }
                    if (notificationDetails.length > 0) {
                        scope.notificationCount = 0;
                        scope.notifyCount.approvedNotificationCount = 0;
                        scope.notifyCount.infoRequiredNotificationCount = 0;
                        scope.notifyCount.paymentNotificationCount = 0;
                        scope.notifyCount.deniedNotificationCount = 0;
                        angular.forEach(notificationDetails, function (e, i) {
                            if (e.NotificationType == 'APPROVED' || e.NotificationType == 'IN_PROGRESS') {
                                scope.notifyCount.approvedNotificationCount += e.Count;
                            }
                            if (e.NotificationType == 'INFO_REQUIRED') {
                                scope.notifyCount.infoRequiredNotificationCount = e.Count;
                            }
                            if (e.NotificationType == 'PAYMENT') {
                                scope.notifyCount.paymentNotificationCount = e.Count;
                            }
                            if (e.NotificationType == 'DENIED' || e.NotificationType == 'CANCELLED') {
                                scope.notifyCount.deniedNotificationCount += e.Count;
                            }
                        });
                    }
                    $rootScope.$broadcast('notifyCount', scope.notifyCount);
                    UtilitiesService.hospitalNotification = scope.notifyCount;
                    if (scope.notifyCount.approvedNotificationCount > 0 || scope.notifyCount.infoRequiredNotificationCount > 0 || scope.notifyCount.paymentNotificationCount > 0 || scope.notifyCount.deniedNotificationCount > 0) {
                        //scope.callAtTimeout();   
                    }
                }
            }
        };

        scope.setupClaimNotification();

        $rootScope.$on('notificationTypeData', function (event, data) {
            if (data) {
                if (data == 'APPROVED' || data == 'IN_PROGRESS') {
                    scope.notifyCount.approvedNotificationCount = 0;
                }
                if (data == 'INFO_REQUIRED') {
                    scope.notifyCount.infoRequiredNotificationCount = 0;
                }
                if (data == 'PAYMENT') {
                    scope.notifyCount.paymentNotificationCount = 0;
                }
                if (data == 'DENIED' || data == 'CANCELLED') {
                    scope.notifyCount.deniedNotificationCount = 0;
                }
            }
        });
        $rootScope.maNotificationCount = 0;

        scope.checkMaFlag = function () {
            var retult = false;
            if (scope.user && scope.user.rolesFeatures.roles.length > 0) {
                angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
                    if (v.roleId == 9203) {
                        retult = true;
                    }
                })
            }
            return retult;
        };

        scope.setupForSignalR = function () {
            // if (scope.checkMaFlag()) {
            if ($.connection && $.connection.hub) {
                $.connection.hub.url = UtilitiesService.getUrlPrefixForSignalR();
                var chat = $.connection.notificationHub;
                chat.client.broadcastPendingNotifications = function (name, message) {
                    var message = JSON.parse(message);
                    scope.maNotificationCount = message.NoOfNotification;
                    UtilitiesService.maNotificationData = message.notifications;
                    scope.notificationData = message.notifications;
                    $rootScope.$broadcast('notificationData', scope.notificationData);
                    //callAtTimeout(message.NoOfNotification);
                }
            }
            // }
        };

        scope.setupForSignalR();

        function NotifyDesktop(count) {
            if (!('Notification' in window)) {
                return;
            }
            Notification.requestPermission(function (permission) {
                var notification = new Notification("Medi Assist", { body: 'You have ' + count + ' new notification(s)', icon: 'app/resources/images/Plus_Logo.png', dir: 'auto' });
                var tmOut = setTimeout(function () {
                    notification.close();
                    clearInterval(tmOut);
                }, 10000);
                notification.onclick = function (x) { window.focus(); };
            });
        }

        scope.BuildChangeProvider = function () {
            if (localStorage) {
                scope.providerList = JSON.parse(localStorage.getItem('children')) ? JSON.parse(localStorage.getItem('children')) : [];
            }
        };

        scope.changeHospitalUrl = function (value) {
            if (UserService.getHospitalObj()) {
                if (value === '/newAdmission/aarogya') {
                    $location.path('/newAdmission/aarogya');
                } else {
                    $state.go(value.replace('/', ''), {}, { reload: true });
                }
            } else {
                if (value === '/changepwd' || value === '/usermgmt') {
                    $state.go(value.replace('/', ''), {}, { reload: true });
                } else {
                    UtilitiesService.showAlertMessage('Please select hospital.')
                }
            }
        };

        scope.gotoAppointments = function(routePath,statusId) {
            var r = '/'+routePath+'/'+statusId;
            $location.path(r);
            // $state.go(routePath, {statusId}, { reload: true });
        }

        scope.getAllProvidersDetails = function (callback) {
            if (UserService.getUserObj() && UserService.getAccessToken()) {
                var children = UtilitiesService.getAllChildren();
                if (children === null || children.length === 0) {
                    UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + '/GetChildEntityRelation/' + UserService.getUserObj().entityId, '', 'GET', UserService.getAccessToken()).then(function (childresponse) {
                        scope.children = [];
                        if (childresponse.data) {
                            if (childresponse.data.length > 0) {
                                childresponse.data.map(function (e) {
                                    var childData = {
                                        entityId: e.entityId,
                                        entityName: e.entityName,
                                        id: e.id,
                                        erTypeId: e.erTypeId,
                                        LoginType: 'plus'
                                    }
                                    scope.children.push(childData);
                                });
                                var data = [];
                                if (localStorage) {
                                    if (scope.user && scope.user.properties && scope.user.properties["Assigned Contracts"]) {
                                        var data = filterFilter(scope.children, { "erTypeId": scope.user.properties["Assigned Contracts"].split(',') },
                                            function (actual, expected) {
                                                return filterFilter(expected, actual).length > 0;
                                            });
                                    }
                                    if (data.length > 0) {
                                        localStorage.setItem('children', JSON.stringify(data));
                                    } else {
                                        localStorage.setItem('children', JSON.stringify(scope.children));
                                    }

                                    scope.BuildChangeProvider();
                                }
                            }
                        }
                    },
                        function (error) {
                            if (error.status === -1) {
                            } else {
                                UtilitiesService.showAlertMessage("Error while getting child entity relation details.");
                            }
                        });
                }
            }
        };

        scope.checkIfDcDashboard = function () {
            var dcRole = null;
            var result = false;
            if (scope.user && scope.user.rolesFeatures && scope.user.rolesFeatures.roles) {
                dcRole = scope.user.rolesFeatures.roles.find(function (elem) {
                    return ((elem.roleName.substring(0, 2)) == 'DC')
                })
                result = dcRole ? true : false;
                if (result && $rootScope.toggleMenuObj && $rootScope.toggleMenuObj.isMultiRole) {
                    return ($rootScope.toggleMenuObj.isDcRoleActive ? true : false);
                }
                else {
                    return result;
                }
            }
        }

        scope.checkAppointmentOptions = function(menuOptions) {
            if(menuOptions.menuItem == 'Active' && scope.checkIfDcDashboard()){
                return false;
            }
            else{
                return true;
            }
        }

        scope.isNotification = false;
        scope.BuildItemCategory = function (obj) {
            scope.hospFeaturesToLoad = [];
            if (UserService.getUserObj()) {
                scope.user = UserService.getUserObj();
                if (obj == undefined)
                    obj = scope.menuItems;
                //Plus features to load
                // alert('Host ' + window.location.hostname);
                // alert('Username ' + scope.user.userName);
                if (scope.user.userName == '1003736@medibuddy.in' && window.location.hostname == 'uat-plus.medibuddy.in') {
                    obj = scope.menuItems.filter(function (data) {
                        return data.id == 'Claims' || data.id == 'Notifications';
                    });
                    if (obj) {
                        var tempObj = obj[1].profileMenu;
                        obj[1].profileMenu = tempObj.filter(function (data) {
                            return data.name == 'Active Claims';
                        });
                        // obj.profileMenu 
                    }
                }
                $rootScope.toggleMenuObj = UserService.getUserMenuToggle();

                scope.plusFeaturesToLoad = obj.filter(function (n) {
                    return scope.featureListForPlus.indexOf(n.fId) != -1;
                });
                scope.featureListForPlusAppointments = [5435, 9193, 5443, 9190, 9197, 9191, 9192, 9195, 9199, 9194, 9227];
                scope.featureListForPlusPayment = [5436];

                //Plus appointment features to load
                //Hospital features to load
                if ($rootScope.toggleMenuObj && $rootScope.toggleMenuObj.isMultiRole) {
                    if ($rootScope.toggleMenuObj.isDcRoleActive) {
                        scope.plusAppointmentFeaturesToLoad = obj.filter(function (n) {
                            return scope.featureListForPlusAppointments.indexOf(n.fId) != -1;
                        });

                        scope.plusPaymentFeatureToLoad = obj.filter(function (n) {
                            return scope.featureListForPlusPayment.indexOf(n.fId) != -1;
                        });

                        var hospFeaturesToLoadDummy = obj.filter(function (n) {
                            return scope.featureListForHosp.indexOf(n.fId) != -1;
                        });
                        if (hospFeaturesToLoadDummy) {
                            scope.hospFeaturesToLoad = hospFeaturesToLoadDummy.filter(function (elem) {
                                return (elem.menuItem == 'Profile Settings');
                            })
                        }
                        else {
                            scope.hospFeaturesToLoad = hospFeaturesToLoadDummy;
                        }
                    }
                    else {
                        scope.hospFeaturesToLoad = obj.filter(function (n) {
                            return scope.featureListForHosp.indexOf(n.fId) != -1;
                        });
                        scope.plusAppointmentFeaturesToLoad = [];
                        scope.plusPaymentFeatureToLoad = [];
                    }
                }
                else {
                    scope.plusAppointmentFeaturesToLoad = obj.filter(function (n) {
                        return scope.featureListForPlusAppointments.indexOf(n.fId) != -1;
                    });

                    scope.plusPaymentFeatureToLoad = obj.filter(function (n) {
                        return scope.featureListForPlusPayment.indexOf(n.fId) != -1;
                    });

                    scope.hospFeaturesToLoad = obj.filter(function (n) {
                        return scope.featureListForHosp.indexOf(n.fId) != -1;
                    });
                }

                // scope.featureListForPlusPayment = [5436];
                // //
                // scope.plusPaymentFeatureToLoad = obj.filter(function (n) {
                //     return scope.featureListForPlusPayment.indexOf(n.fId) != -1;
                // });
                scope.plusPaymentFeatureToLoad = scope.plusPaymentFeatureToLoad.length === 1 ? scope.plusPaymentFeatureToLoad[0].profileMenu : [];


                //Hospital feature notification to load
                scope.hospFeatureNotificationToLoad = obj.filter(function (n) {
                    return scope.featureNotification.indexOf(n.fId) != -1;
                });
                scope.hospFeatureNotificationToLoad1 = obj.filter(function (n) {
                    return scope.featureNotification1.indexOf(n.fId) != -1;
                });
                //Notification check
                if (scope.hospFeatureNotificationToLoad.length > 0) {
                    scope.hospFeatureNotificationToLoad = scope.hospFeatureNotificationToLoad[0].profileMenu;
                    scope.isNotification = true;
                    $rootScope.isPlus = true;
                } else {
                    $rootScope.isPlus = false;
                }
                //Aarogya scheme check
                angular.forEach(scope.hospFeaturesToLoad, function (value, key) {
                    if (value.fId === 19999 || value.fId === 9216) {
                        angular.forEach(value.profileMenu, function (value1, key1) {
                            scope.aarogyaChecked = UserService.getHospAarogyaChecked();
                            if (scope.aarogyaChecked === false && value1.name === 'Aarogya Scheme') {
                                scope.hospFeaturesToLoad[key].profileMenu.splice(key1, 1);
                            }
                        });
                    }
                });
                if (scope.user && scope.user.entityId !== 1005157) {
                    angular.forEach(scope.hospFeaturesToLoad, function (data, index) {
                        if (data.fId === 19999) {
                            angular.forEach(data.profileMenu, function (value, key) {
                                if (value.menuItem === 'otherClaims' && value.name === 'Other Claims') {
                                    scope.hospFeaturesToLoad[index].profileMenu.splice(key, 1);
                                }
                            });
                        }
                    });
                }
                if (scope.user && scope.user.rolesFeatures.roles.length == 1) {
                    scope.isCmsUser = false;
                    angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
                        if (v.roleId === 9216) {
                            scope.isCmsUser = true;
                        }
                    })
                }

                var getGovtPackageList = UserService.getGovtPackageList();
                if (getGovtPackageList && getGovtPackageList.length === 0 && scope.isCmsUser === false) {
                    angular.forEach(scope.hospFeaturesToLoad, function (data, index) {
                        angular.forEach(data.profileMenu, function (value, key) {
                            if (value.href === '/government' && value.name === 'Government Scheme') {
                                scope.hospFeaturesToLoad[index].profileMenu.splice(key, 1);
                            }
                        });
                    });
                }


                if (scope.isCmsUser === true) {
                    angular.forEach(scope.hospFeaturesToLoad, function (value, key) {
                        if (value.fId === 9216) {
                            scope.hospFeaturesToLoad.splice(key, 1);
                        }
                    });
                }

                scope.providersData = UtilitiesService.getProviderData();

                //if (scope.providersData && scope.providersData.entityType !== 4) {
                //    angular.forEach(scope.hospFeaturesToLoad, function (data, index) {
                //        if (data.menuItem === 'Profile settings') {
                //            angular.forEach(data.profileMenu, function (data1, index1) {
                //                if (data1.menuItem === 'Rooms') {
                //                    scope.hospFeaturesToLoad[index].profileMenu.splice(index1, 1);
                //                }
                //            })
                //        }
                //    })
                //}
                //if (scope.user) {
                if (scope.user) {
                    angular.forEach(scope.hospFeaturesToLoad, function (data, index) {
                        if (data.menuItem === 'Profile settings') {
                            angular.forEach(data.profileMenu, function (data1, index1) {
                                if (data1.menuItem === 'Payer Configuration') {
                                    scope.hospFeaturesToLoad[index].profileMenu.splice(index1, 1);
                                }
                            })
                        }
                    })
                }

                //Network features to load
                scope.networkFeaturesToLoad = obj.filter(function (n) {
                    return scope.featureListForNetwork.indexOf(n.fId) != -1;
                });
                var isContactCheck = UtilitiesService.isReturnFlagForContact(UserService.getUserObj().rolesFeatures.roles, 9209);
                if (isContactCheck) {
                    angular.forEach(scope.networkFeaturesToLoad, function (item, key) {
                        if (item.fId === 1) {
                            scope.networkFeaturesToLoad.splice(key, 1);
                        }
                    });
                }
                //FILTER HOSPITAL USER
                scope.selectedHospRole = [];
                scope.selectedHospRole = filterFilter(UserService.getUserObj().rolesFeatures.roles, { 'roleId': scope.hospRolesId }, function (actual, expected) {
                    return filterFilter(expected, actual, true).length > 0;
                });
                scope.applicationUserName = scope.selectedHospRole.length > 0 ? scope.selectedHospRole[0].roleName : '';
                if (scope.plusAppointmentFeaturesToLoad.length > 0 || scope.plusFeaturesToLoad.length > 0) {
                    scope.getAllProvidersDetails();
                }
                if (scope.hospFeaturesToLoad.length > 0) {
                    angular.forEach(scope.networkFeaturesToLoad, function (key, value) {
                        if (key.id === 'contact' && key.menuItem === 'Contact') {
                            scope.networkFeaturesToLoad.splice(key, 1);
                        }
                    });
                }

                // if ($rootScope.toggleMenuObj && $rootScope.toggleMenuObj.isMultiRole) {
                //     $rootScope.isPlus = $rootScope.toggleMenuObj.isDcRoleActive ? false : true;
                // }

                if (scope.checkIfDcDashboard()) {
                    $rootScope.isPlus = false;
                }
            }
        };

        scope.menuItems = PlusUtilitiesService.getMenuItems(PlusUtilitiesService.getMenuDetails());
        scope.BuildItemCategory(PlusUtilitiesService.getMenuItems(PlusUtilitiesService.getMenuDetails()));

        $rootScope.$on('readNotification', function (event, args) {
            //scope.getNotificatoins(true);
        });
        scope.hospId = 0;
        scope.profilePermissionHids = [1005157, 1000257, 1005365, 1005509, 1004364, 1000945, 1000643, 1004870, 1002085, 1003182, 1003738, 1029510, 1000137];
        scope.profilePermit = false;
        if (UserService.isActive()) {
            $rootScope.showMenu = true;
            if (UserService.getHospitalObj()) {
                scope.plusUserName = UserService.getUserObj().userName;
                scope.mailId = UserService.getUserObj().userEmail;
                scope.hospName = UserService.toTitleCase(UserService.getHospitalObj().hospName);
                scope.hospCity = UserService.toTitleCase(UserService.getHospitalObj().city);
                scope.hospState = UserService.toTitleCase(UserService.getHospitalObj().state);
                scope.userName = UserService.toTitleCase(UserService.getUserObj().userName ? UserService.getUserObj().userName : UserService.getUserObj().firstName);
                scope.userRole = UserService.displayThis;
                scope.aarogyaChecked = UserService.getHospAarogyaChecked();
                scope.user = UserService.getUserObj();
                scope.hospId = UserService.getHospitalObj().hospId;
                scope.profilePermit = scope.profilePermissionHids.indexOf(scope.hospId) > -1 ? true : false;
                scope.hospErId = UserService.getHospitalObj().entityRealtion ? (UserService.getHospitalObj().entityRealtion[0] ? UserService.getHospitalObj().entityRealtion[0].eR_ID : null) :'';
                //scope.getNotificatoins();
            }
        } else {
            if (UserService.getUserObj()) {
                scope.getUserDefaultRoute = UserService.getUserDefaultRoute(PlusUtilitiesService.getMenuDetails());
                $location.path(scope.getUserDefaultRoute).replace()
            } else {
                // var accessToken = $location.search().access_token;
                if ($location.search().access_token) {
                } else {

                    UserService.destroyUserObj();
                }
                //UserService.destroyUserObj();
                //$location.path('/');
                scope.notificationCount = undefined;
            }
        }
        $rootScope.$on('signedin', function (event, args) {
            scope.menuItems = PlusUtilitiesService.getMenuItems(PlusUtilitiesService.getMenuDetails());
            scope.BuildItemCategory();
            if (UserService.getUserObj()) {
                scope.plusUserName = UserService.getUserObj().userName;
                if(UserService.getUserObj().firstName){
                    scope.showOrderPunching = UserService.getUserObj().firstName.toLowerCase().indexOf("lifecare") > -1 || UserService.getUserObj().firstName.toLowerCase().indexOf("diagright") > -1;
                }
            } else {
                scope.showOrderPunching = false;
            }

            if (scope.plusUserName == '1003736@medibuddy.in') {
                scope.menuItems = scope.menuItems[19999]
            }

            

            if (args && args === true) {
                $rootScope.showMenu = true;
                if (UserService.getHospitalObj()) {
                    scope.hospName = UserService.toTitleCase(UserService.getHospitalObj().hospName);
                    scope.hospCity = UserService.toTitleCase(UserService.getHospitalObj().city);
                    scope.hospState = UserService.toTitleCase(UserService.getHospitalObj().state);
                    scope.userName = UserService.toTitleCase(UserService.getUserObj().userName ? UserService.getUserObj().userName : UserService.getUserObj().firstName);
                    scope.userRole = UserService.displayThis;
                    scope.aarogyaChecked = UserService.getHospAarogyaChecked();
                    scope.user = UserService.getUserObj();
                    scope.hospErId = UserService.getHospitalObj().entityRealtion ? (UserService.getHospitalObj().entityRealtion[0] ? UserService.getHospitalObj().entityRealtion[0].eR_ID : null) :'';
                    //scope.getNotificatoins();
                }
            }
            else {
                scope.hospName = null;
                scope.hospCity = null;
                scope.hospState = null;
                $rootScope.showMenu = false;
                scope.notificationCount = undefined;
                // var accessToken = $location.search().access_token;
                if ($location.search().access_token) {
                } else {

                    UserService.destroyUserObj();
                }
                //UserService.destroyUserObj();
                scope.showHeader = false;
                //$location.path('/');
                scope.notificationCount = undefined;
            }
        });
        $rootScope.$on('hospChange', function (event, args) {
            if (args && args === true) {
                $rootScope.showMenu = true;
                if (UserService.getHospitalObj()) {
                    scope.hospName = UserService.toTitleCase(UserService.getHospitalObj().hospName);
                    scope.hospCity = UserService.toTitleCase(UserService.getHospitalObj().city);
                    scope.hospState = UserService.toTitleCase(UserService.getHospitalObj().state);
                    scope.aarogyaChecked = UserService.getHospAarogyaChecked();
                    scope.hospId = UserService.getHospitalObj().hospId;
                    scope.profilePermit = scope.profilePermissionHids.indexOf(scope.hospId) > -1 ? true : false;
                    scope.hospErId = UserService.getHospitalObj().entityRealtion ? (UserService.getHospitalObj().entityRealtion[0] ? UserService.getHospitalObj().entityRealtion[0].eR_ID : null) :'';
                    //scope.getNotificatoins();
                }
            }
        });
        scope.changePlusView = function (state) {
            if (state === '/dashboard') {
                if (UserService.getHospitalObj()) {
                    if (state) {
                        $state.go(state.replace('/', ''), {}, { reload: true });
                    }
                } else {
                    UtilitiesService.showAlertMessage('Please select hospital.')
                }
            } else {
                if (state) {
                    $state.go(state.replace('/', ''), {}, { reload: true });
                }
            }
        };
        scope.redirectToFuserUpsell = function () {
            window.open(
                "https://fuser-upsell.medibuddy.in/sso?access_token=" + scope.user.accessToken,
                '_blank'
            );
        }
        scope.logout = function () {
            UserService.destroyUserObj();
            localStorage.removeItem("lastCheckedDate")
            $rootScope.toggleMenuObj = null;
            scope.showHeader = false;
            $rootScope.$broadcast('signedin', false);
            $location.path('/');
            scope.notificationCount = undefined;
        };
        scope.anything = function () {
            $rootScope.$broadcast('changeHosp', true);
            scope.getHospitalList();
            angular.element('#changeHospModal').modal('show');
        };
        scope.openSwitchDC = function () {
            $rootScope.$broadcast('changeHosp', true);
            if (localStorage && localStorage.getItem('children')) {
                scope.providerList = JSON.parse(localStorage.getItem('children'));
                angular.element('#changeProvider').modal('show');
            } else {
                scope.getAllProvidersDetails(function () {
                    scope.providerList = JSON.parse(localStorage.getItem('children'));
                    angular.element('#changeProvider').modal('show');
                });
            }
        };

        function NotifyDesktop(count) {
            if (!('Notification' in window)) {
                return;
            }
            Notification.requestPermission(function (permission) {
                var notification = new Notification("Medi Assist", { body: 'You have ' + count + ' new notification(s)', icon: 'app/resources/images/Plus_Logo.png', dir: 'auto' });
                var tmOut = setTimeout(function () {
                    notification.close();
                    clearInterval(tmOut);
                }, 10000);
                notification.onclick = function (x) { window.focus(); };
            });
        }
        // hosp list --> session storage
        scope.getHospitalList = function () {
            scope.hospitalList = UserService.getHospitalList();
            if (scope.hospitalList != undefined && scope.hospitalList != null && scope.hospitalList.length > 0) {
                return scope.hospitalList;
            } else {
                UserService.makeRestCall(UtilitiesService.getUrlPrefix() + "/hosp/list.json", "", "POST").then(function (response) {
                    if (response.data.isSuccess) {
                        scope.hospitalList = response.data.entities;
                        UserService.setHospitalList(scope.hospitalList);
                        return scope.hospitalList;
                    }
                });
            }
        };
        scope.isSwitchToHospPortal = function () {
            var result = localStorage.getItem('isHospUser') === 'false' ? false : true;
            if (result) {
                $rootScope.allowedFeatureList;
                $rootScope.menuItems;

            }
            return result;
        };

        scope.checkForHospitalFeature = function () {
            var result = false;
            result = scope.hospFeatureNotificationToLoad.length > 0 ? true : false;
            return result;
        };

        scope.checkPlusAppointmentFeature = function () {
            var result = false;
            result = scope.plusAppointmentFeaturesToLoad.length > 0 ? true : false;
            return result;
        };

        scope.checkPlusPaymentFeature = function () {
            var result = false;
            result = scope.plusPaymentFeatureToLoad.length > 0 ? true : false;
            return result;
        };

        scope.checkHospFeatures = function () {
            var result = false;
            result = scope.hospFeaturesToLoad.length > 0 ? true : false;
            return result;
        };

        scope.checkIfDcDashboard = function () {
            var dcRole = null;
            var result = false;
            if (scope.user && scope.user.rolesFeatures && scope.user.rolesFeatures.roles) {
                dcRole = scope.user.rolesFeatures.roles.find(function (elem) {
                    return ((elem.roleName.substring(0, 2)) == 'DC')
                })
                result = dcRole ? true : false;
                if (result && $rootScope.toggleMenuObj && $rootScope.toggleMenuObj.isMultiRole) {
                    return ($rootScope.toggleMenuObj.isDcRoleActive ? true : false);
                }
                else {
                    return result;
                }
            }
        }

        scope.checkSubProfileMenu = function (id) {
            var result = false;
            if (id === 19999 || id === 9216 || id === 9214 || id === 9221) {
                result = true;
            }
            return result;

        }

        $(document).on('click', '.nav-primary a', function (e) {
            var $this = $(e.target), $active;
            $this.is('a') || ($this = $this.closest('a'));

            $active = $this.parent().siblings(".active");

            $active && $active.find('> a').toggleClass('active') && $active.toggleClass('active').find('> ul:visible').slideUp(200);

            ($this.hasClass('active') && $this.next().slideUp(200)) || $this.next().slideDown(200);
            $this.toggleClass('active').parent().toggleClass('active');

            $this.next().is('ul') && e.preventDefault();

            setTimeout(function () { $(document).trigger('updateNav'); }, 300);
        });

        scope.displayOldToNewLeftNav = (scope.user && ["DC", "DC_Admin"].includes( scope.user.role))?true :false;
        
        // scope.labwise =  "https://labwise-stage.medibuddy.in/#/login/" + scope.user.accessToken + '/' + scope.user.providerId ;

        $(window).on('hashchange', function(e){
            if(scope.user && ["DC", "DC_Admin"].includes( scope.user.role)){
                scope.displayOldToNewLeftNav = true;
            }else{
                scope.displayOldToNewLeftNav = false;
            }
        });

        $(window).on('load', function (e){
            if(scope.user && ["DC", "DC_Admin"].includes( scope.user.role)){
                scope.displayOldToNewLeftNav = true;
            }else{
                scope.displayOldToNewLeftNav = false;
            }
        })

        scope.oldToNewLeftNav = function(){
            var b = new Date().toLocaleDateString();
            localStorage.setItem('lastCheckedDate',b);
        }    
    }]);

angular.module('mbplus')
  .controller('hospActionCtrl', ['$rootScope', '$scope', 'UserService', '$location', '$log', 'UtilitiesService', 'ClaimActionService', 'FileUploadService', '$q', 'blockUI', 'navConstantsSvc', 'filterFilter', 'ngDialog','$analytics', function ($rootScope, scope, UserService, $location, $log, UtilitiesService, ClaimActionService, FileUploadService, $q, blockUI, navConstantsSvc, filterFilter, ngDialog,$analytics) {
    scope.ctrlName = "hospActionCtrl";
    scope.myData = [];
    scope.blockUIState = blockUI.state();
    if (UserService.isActive()) {
      scope.showHeader = true;
      if (UserService.getUserObj()) {
        scope.userName = UserService.toTitleCase(UserService.getUserObj().userName ? UserService.getUserObj().userName : UserService.getUserObj().firstName);
      }
    } else {
      UserService.destroyUserObj();
      //$location.path('/');
    }

    scope.user = UserService.getUserObj();
    scope.availableBills = [];
    scope.typaheadData = [];
    scope.removeData = [];
    scope.dynamicFields = {
      name: '',
      price: '',
      addtionalNmae: ''
    }
    scope.billCsvFile = [];
    scope.isPPN = function () {
      return UtilitiesService.checkPPN();
    };

    scope.$on('quickDischarge',function(event,args){
      scope.dataobj = args;
      scope.modalRenderingMethods.openDischargeModal();
    })

    scope.downloadNonPPNFile = function () {
      var nonPPN = 'https://document.medibuddy.in//proclaim-20170919/c6003e85-87f7-4367-bfaf-8169deb6d811.pdf';
      window.open(
        nonPPN,
        '_blank'
      );
    };

    scope.downloadPPNFile = function () {
      var nonPPN = 'https://document.medibuddy.in//proclaim-20170919/af23ae4b-43c3-4252-bd8b-1260c8b98393.pdf';
      window.open(
        nonPPN,
        '_blank'
      );
    };

    scope.showDiscountEdit = function () {
      scope.editDiscount = scope.editDiscount ? false : true;
    }

    scope.checkForManipal = function () {
      var result = false;
      //    if (scope.user && (scope.user.entityId === 1005157 || scope.user.entityId ===1001510)) {
      if (scope.user && (scope.user.entityId === 1005157)) {
        result = true;
      }
      return result;
    };
    scope.discharge = {
      doa: '',
      dod: ''
    };
    scope.formats = navConstantsSvc.dateFormate;
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];

    scope.datePickerPopup = {
      doa: false,
      dod: false
    }

    scope.openDOAPopup = function () {
      scope.datePickerPopup.doa = true;
    };

    scope.openDODPopup = function () {
      scope.datePickerPopup.dod = true;
    };

    scope.closeModel = function () {
      scope.isDischargePopup = false;
      scope.isEnhanceRaised = false;
      scope.discharge.doa = '';
      scope.discharge.dod = '';
    };

    scope.flagCheck = {
      isPackage: 'nonpackaged'
    };

    scope.dischargeRadioButton = function (value) {
      scope.flagCheck.isPackage = '';
      if (value && value === 'packaged') {
        scope.flagCheck.isPackage = 'packaged';
        scope.availableBills = scope.availableBillsCollection;
      } else if (value && value === 'nonpackaged') {
        scope.flagCheck.isPackage = 'nonpackaged';
        scope.availableBills = scope.availableBillsCollection;
      }
    };

    scope.getMappedpackages = function (details) {
      scope.mappedpackages = [];
      scope.selectedMappedpackages = [];
      scope.isPriceOne = false;
      scope.isPriceTow = false;
      scope.isPriceThree = false;
      if (UserService.getHospitalObj()) {
        var data = {
          hospitalId: UserService.getHospitalObj().cmsHospId,
          insurerShortName: details
          //'NIA'
        }
        scope.newPackageListData = [];
        // UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/mappedpackages', data, 'POST', UserService.getAccessToken()).then(function (response) {
        //   if (response.data.isSuccess) {
        //     scope.mappedpackages = response.data.mappedpackages;
        //     angular.forEach(scope.mappedpackages, function (data, index) {
        //       var testObje = [];
        //       angular.forEach(data.distinctPrices, function (data1, index1) {
        //         testObje.push({
        //           isSelected: false,
        //           price: data1,
        //           packageId: scope.mappedpackages[index].packageId
        //         })
        //       });
        //       scope.newPackageListData.push(testObje);
        //       scope.mappedpackages[index].newPriceObj = testObje;
        //     });
        //     angular.forEach(scope.mappedpackages, function (data, index) {
        //       scope.mappedpackages[index].general_Ward1 = false;
        //       scope.mappedpackages[index].private_Ward1 = false;
        //       scope.mappedpackages[index].semi_Private_Ward1 = false;
        //     });
        //     scope.mappedpackagesData = scope.mappedpackages;
        //   } else {
        //     scope.mappedpackages = [];
        //   }
        // });
      }
    };


    scope.calculateTotalAmount = function () {
      scope.CLAIMED_AMOUNT = 0;
      angular.forEach(scope.availableBills, function (data, index) {
        if (data.CLAIMED_AMOUNT) {
          scope.CLAIMED_AMOUNT = scope.CLAIMED_AMOUNT + parseInt(data.CLAIMED_AMOUNT);
        }
      });
      return scope.CLAIMED_AMOUNT;
    };

    scope.getPrefilledBills = function (details) {
      if (UserService.getHospitalObj() && details) {
        var data = {
          hospitalId: UserService.getHospitalObj().cmsHospId,
          claimId: details
        }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/claim/GetPrefilledBills', data, 'POST', UserService.getAccessToken()).then(function (response) {
          if (response.data.isSuccess) {
            scope.dummyAvailableBills = [];
            angular.forEach(scope.availableBills, function (key, index1) {
              angular.forEach(response.data.bills, function (data, index2) {
                if (key.hospitaL_CHARGE_HEAD === data.hospitaL_CHARGE_HEAD) {
                  scope.availableBills[index1].CLAIMED_AMOUNT = data.packageAmount;
                } else if (key.hospitaL_CHARGE_HEAD !== data.hospitaL_CHARGE_HEAD) {
                  var obj = {
                    PROVIDER_BILL_ITEM_NAME: '',
                    BILL_ITEM_DETAIL_REF: '',
                    DETAIL_BILL_ITEM_CLAIM_ID: '',
                    DETAIL_BILL_ITEM_PREAUTH_NO: '',
                    CLAIMED_AMOUNT: data.packageAmount,
                    CMS_CHARGE_TYPE_ID: data.cmS_CHARGE_TYPE_ID,
                    CMS_CHARGE_TYPE_DESC: data.cmS_SUBCHARGE_TYPE_DESC,
                    CMS_SUBCHARGE_TYPE_ID: data.cmS_SUBCHARGE_TYPE_ID,
                    CMS_SUBCHARGE_TYPE_DESC: data.cmS_SUBCHARGE_TYPE_DESC,
                    hospitaL_CHARGE_HEAD: data.hospitaL_CHARGE_HEAD,
                    hospitalBillDesc: data.hospitaL_CHARGE_HEAD,
                    isReadOnly: true,
                    isPackage: data.packageId > 0 ? true : false,
                    uniqueIds: '',
                    packageId: data.packageId,
                    packageName: data.hospitaL_CHARGE_HEAD
                  }
                  scope.dummyAvailableBills.push(obj);
                }
              })
            });
            scope.dummyAvailableBills = UtilitiesService.UniqueArrayby(scope.dummyAvailableBills, 'hospitaL_CHARGE_HEAD');
            scope.availableBills = UtilitiesService.UniqueArrayby(scope.availableBills, 'hospitaL_CHARGE_HEAD');
            angular.forEach(scope.dummyAvailableBills, function (key, index) {
              scope.availableBills.push(key);
            });
            scope.availableBills = UtilitiesService.UniqueArrayby(scope.availableBills, 'hospitaL_CHARGE_HEAD');
            scope.calculateTotalAmount();
          }
        });
      }
    };

    scope.getBillDetails = function (modelPopup) {
      scope.modelPopup = {
        text1: modelPopup === 'dischargeModalPopup' ? 'dischargeModalPopup' : '',
        text: modelPopup === 'enhancementModle' ? 'enhancementModle' : ''
      }
      scope.isAddPackageName = false;
      scope.dynamicFields.addtionalNmae = '';
      scope.availableBills = [];
      scope.CLAIMED_AMOUNT = 0;
      var data = {
        hospId: UserService.getHospitalObj().cmsHospId
      };
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/claim/HospDischargeBills/', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
        if (response.data.isSuccess) {
          scope.availableBillsFilterData = [];
          scope.availableBillsFilterData1 = [];
          angular.forEach(response.data.availableBills, function (key, index) {
            var data = {
              PROVIDER_BILL_ITEM_NAME: '',
              BILL_ITEM_DETAIL_REF: '',
              DETAIL_BILL_ITEM_CLAIM_ID: '',
              DETAIL_BILL_ITEM_PREAUTH_NO: '',
              CLAIMED_AMOUNT: '',
              CMS_CHARGE_TYPE_ID: key.intermalBillTypeId,
              CMS_CHARGE_TYPE_DESC: key.internalBillTypeDesc,
              CMS_SUBCHARGE_TYPE_ID: key.internalSubBillTypeId,
              CMS_SUBCHARGE_TYPE_DESC: key.internalSubBillDesc,
              hospitaL_CHARGE_HEAD: key.hospitalBillDesc,
              hospitalBillDesc: key.hospitalBillDesc,
              isReadOnly: false,
              isPackage: false,
              uniqueIds: '',
              packageId: '',
              packageName: ''
            }
            scope.typaheadData.push(data);

          });
          scope.availableBills = scope.availableBillsFilterData;
          scope.availableBillsCollection = scope.availableBills;
          scope.mappedpackages = scope.mappedpackagesData;
          if (scope.modelPopup.text === 'enhancementModle') {
            var modelPopup = '#' + scope.modelPopup.text;
            angular.element(modelPopup).appendTo('body');
            angular.element(modelPopup).modal('show');
          } else if (scope.modelPopup.text1 === 'dischargeModalPopup') {
            var modelPopup = '#' + scope.modelPopup.text1;
            angular.element(modelPopup).appendTo('body');
            angular.element(modelPopup).modal('show');
          }
        }
      });
    };
    scope.modelOptions = {
      debounce: {
        default: 500,
        blur: 250
      }
    };

    scope.onChangeFunction = function (data) {
      var dataString = 'Package';
      if (data && data.toLowerCase() === dataString.toLowerCase()) {
        scope.isAddPackageName = true;
      } else {
        scope.isAddPackageName = false;
      }
    };

    scope.onSelect = function (data) {
      scope.selectedObject = data;
      var dataString = 'Package';
      if (data && data.hospitaL_CHARGE_HEAD.toLowerCase() === dataString.toLowerCase()) {
        scope.isAddPackageName = true;
      } else {
        scope.isAddPackageName = false;
      }
    };

    scope.billBrekup = {
      availableBills: [],
      availableBillsCollection: []
    }

    scope.dischargePatient = function () {
      scope.form = {}
      scope.form.fileNames = [];
      scope.form.fileUploadFolderPath = [];
      scope.availableBills = scope.availableBillsCollection;
      var value = scope.dataobj ? scope.dataobj.patientDetails ? scope.dataobj.patientDetails.insCompShortName : '' : '';
      if (value) {
        scope.getMappedpackages(value);
      }
      scope.getBillDetails('dischargeModalPopup');
      scope.isDischargePopup = true;
      scope.discharge.doa=new Date(moment(scope.claimNoData.dateOfAdmission).format('YYYY-MM-DD'));
      scope.discharge.dod=new Date(moment(scope.claimNoData.dateOfDischarge).format('YYYY-MM-DD'));
      // scope.discharge.doa = new Date(scope.dataobj.claimDetails.clmDOA);
      // scope.discharge.dod = new Date(scope.dataobj.claimDetails.clmDOD);
    };

    scope.enhanceRequest = function () {
      scope.isEnhanceRaised = true;
      var value = scope.dataobj ? scope.dataobj.patientDetails ? scope.dataobj.patientDetails.insCompShortName : '' : '';
      if (value) {
        scope.getMappedpackages(value);
      }
      scope.getBillDetails('enhancementModle');
    };



    //Add New Package
    scope.ctrlFn = function (nextpage) {
      scope.selectedMappedpackages = [];
      if (nextpage.length > 0) {
        var nextpageDuplicate = _.filter(scope.availableBills, function (v) {
          return v.packageId === nextpage[0].packageId;
        });
        if (nextpageDuplicate.length === 0) {
          angular.forEach(nextpage, function (data, index) {
            scope.availableBills.push({
              PROVIDER_BILL_ITEM_NAME: '',
              BILL_ITEM_DETAIL_REF: '',
              DETAIL_BILL_ITEM_CLAIM_ID: '',
              DETAIL_BILL_ITEM_PREAUTH_NO: '',
              CLAIMED_AMOUNT: data.general_Ward,
              CMS_CHARGE_TYPE_ID: 4,
              CMS_CHARGE_TYPE_DESC: 'Miscellaneous Charges',
              CMS_SUBCHARGE_TYPE_ID: 53,
              CMS_SUBCHARGE_TYPE_DESC: 'Other Miscellaneous Charges',
              hospitaL_CHARGE_HEAD: data.package_Name,
              hospitalBillDesc: data.package_Name,
              isReadOnly: true,
              isPackage: true,
              uniqueIds: data.uniqueIds,
              packageId: data.packageId,
              packageName: data.package_Name
            });
          })
        }
        scope.calculateTotalAmount();
      }
    };


    scope.isNewCategories = false;
    scope.isDuplicate = false;
    scope.closeButton = function () {
      scope.isDuplicate = false;
      scope.isNewCategories = false;
      scope.dynamicFields.name = '';
      scope.dynamicFields.price = '';
      scope.dynamicFields.addtionalNmae = '';
    };

    scope.addMoreCategories = function (flag, data, selectedObject) {
      scope.isDuplicate = false;
      if (flag) {
        if (scope.isAddPackageName && data.addtionalNmae) {
          data.name = data.name + ' - ' + data.addtionalNmae;
        }
        var value = _.filter(scope.availableBills, function (item) {
          return item.hospitalBillDesc.toLowerCase() === data.name.toLowerCase()
        }).length;
        if (value === 0) {
          if (selectedObject && data.name === selectedObject.hospitaL_CHARGE_HEAD) {
            selectedObject.CLAIMED_AMOUNT = data.price;
            scope.availableBills.push(selectedObject);
            scope.selectedObject = '';
          } else {
            scope.availableBills.push({
              PROVIDER_BILL_ITEM_NAME: '',
              BILL_ITEM_DETAIL_REF: '',
              DETAIL_BILL_ITEM_CLAIM_ID: '',
              DETAIL_BILL_ITEM_PREAUTH_NO: '',
              CLAIMED_AMOUNT: data.price,
              CMS_CHARGE_TYPE_ID: 4,
              CMS_CHARGE_TYPE_DESC: 'Miscellaneous Charges',
              CMS_SUBCHARGE_TYPE_ID: 53,
              CMS_SUBCHARGE_TYPE_DESC: 'Other Miscellaneous Charges',
              hospitaL_CHARGE_HEAD: data.name,
              hospitalBillDesc: data.name,
              isReadOnly: false,
              isPackage: false,
              uniqueIds: '',
              packageId: '',
              packageName: ''
            });
          }
          angular.forEach(scope.typaheadData, function (v, index) {
            if (v.hospitalBillDesc === data.name) {
              scope.typaheadData.splice(index, 1);
            }
          });
          scope.typaheadData = _.uniq(scope.typaheadData);
          scope.typaheadData = _.reject(scope.typaheadData, function (num) {
            return num.isPackage === true;
          });
          scope.dynamicFields.name = '';
          scope.dynamicFields.price = '';
          scope.dynamicFields.addtionalNmae = '';
          scope.isAddPackageName = false;
          scope.calculateTotalAmount();
        } else {
          scope.isDuplicate = true;
        }
        scope.isAddPackageName = false;
      } else {
        scope.isAddPackageName = false;
        scope.isNewCategories = true;
      }
    };

    scope.validate = function () {
      var result = true;
      if (scope.availableBills && scope.availableBills.length > 0) {
        angular.forEach(scope.availableBills, function (key, index) {
          if (!key.CLAIMED_AMOUNT)
            return result = false;
        });
      } else {
        return result = false;
      }

      if (result)
        return result;
    };
    scope.AddNewBill = function () {
      scope.isNewCategories = true;
    }
    scope.isBillCheck = function (value) {
      var result = true;
      if (scope.isEBill && value === 'submitDischargeDetails') {
        if (scope.discharge.patientIPNumber && scope.discharge.uidno) {
          result = true;
        } else {
          result = false;
        }
      } else if (scope.isEBill && value === 'submitEnhanceDetails') {
        if (scope.enhance.patientIPNumber && scope.enhance.uidno) {
          result = true;
        } else {
          result = false;
        }
      }
      return result;
    };

    scope.submitEnhanceDetails = function () {
      if (scope.validate() && scope.isBillCheck('submitEnhanceDetails')) {
        scope.fileUploadRelatedMethods.uploadFiles('enhancementRelatedMethods', function () {
          var data = {
            hospId: UserService.getHospitalObj().hospId,
            claimId: scope.dataobj.claimId,
            claimedAmount: scope.calculateTotalAmount(scope.availableBills) ? scope.calculateTotalAmount(scope.availableBills) : scope.CLAIMED_AMOUNT,
            remarks: scope.enhance.remarks,
            updatedBy: UserService.getUserObj().userId,
            actionType: 'enhance',
            fileUploadFolder: scope.form.fileUploadFolderPath.join(),
            fileNames: scope.form.fileNames.join(),
            dischargeList: scope.availableBills,
            uiD_NO: scope.enhance.uidno,
            patientIPNumber: scope.enhance.patientIPNumber,
            hospitalDiscount: scope.csvBillDiscount > 0 ? scope.csvBillDiscount : (scope.item && scope.item.hospitalDiscount? scope.item.hospitalDiscount:0),
            hospitalDiscountRemarks: scope.csvBillDiscountRemarks ? scope.csvBillDiscountRemarks : null
          }
          ClaimActionService.submitEnhance(data).then(function (response) {
            angular.element("#enhancementModle").modal('hide');
            ga('send', 'event', 'Enhancement', 'Click', 'EnhancementSubmission',0,data);
            if (response.data.isSuccess) {
              UtilitiesService.showAlertMessage('Your enhancement have been submitted successfully.', true);
            } else {
              UtilitiesService.showAlertMessage('Something went wrong! Your enhancement is not submitted. Please try again.');
            }
          }, function (error) {
            UtilitiesService.showAlertMessage('Something went wrong! Your discharge summary is not submitted. Please try again.');
          });
        });
      } else {
        alert('Please fill required fileds.');
      }
    };

    scope.submitDischargeDetails = function () {
      if (scope.validate() && scope.isBillCheck('submitDischargeDetails')) {
        scope.fileUploadRelatedMethods.uploadFiles('dischargeRelatedMethods', function () {
          var data = {
            hospId: UserService.getHospitalObj().hospId,
            claimId: scope.dataobj.claimId,
            claimedAmount: scope.calculateTotalAmount() ? scope.calculateTotalAmount(scope.availableBills) : scope.CLAIMED_AMOUNT,
            remarks: scope.discharge.remarks,
            updatedBy: UserService.getUserObj().userId,
            actionType: 'discharge',
            fileUploadFolder: scope.form.fileUploadFolderPath.join(),
            fileNames: scope.form.fileNames.join(),
            doa: scope.discharge.doa,
            dod: scope.discharge.dod,
            dischargeList: scope.availableBills,
            uiD_NO: scope.discharge.uidno,
            patientIPNumber: scope.discharge.patientIPNumber,
            hospitalDiscount: scope.csvBillDiscount > 0 ? scope.csvBillDiscount :(scope.item && scope.item.hospitalDiscount?scope.item.hospitalDiscount:0),
            hospitalDiscountRemarks: scope.csvBillDiscountRemarks ? scope.csvBillDiscountRemarks : null
          }
          ClaimActionService.ClaimActionNewReq(data).then(function (response) {
            angular.element("#dischargeModalPopup").modal('hide');
            if (response.data.isSuccess) {
              UtilitiesService.showAlertMessage('Your discharge documents have been submitted successfully.', true);
            } else {
              UtilitiesService.showAlertMessage('Something went wrong! Your discharge summary is not submitted. Please try again.');
            }
          }, function (error) {
            UtilitiesService.showAlertMessage('Something went wrong! Your discharge summary is not submitted. Please try again.');
          })
        });
      } else {
        alert('Please fill required fileds.');
        scope.btnSubmitflag = false;
      }
    };


    scope.removePackageFromList = function (item) {
      scope.removeData = item;
    };

    scope.removeCategories = function (data) {
      if (data.isReadOnly) {
        scope.typaheadData.push(data);
        scope.typaheadData = _.uniq(scope.typaheadData);
        scope.typaheadData = _.reject(scope.typaheadData, function (num) {
          return num.isPackage === true;
        });
      } else {
        scope.typaheadData.push(data);
        scope.typaheadData = _.uniq(scope.typaheadData);
        scope.typaheadData = _.reject(scope.typaheadData, function (num) {
          return num.isPackage === true;
        });
      }
      angular.forEach(scope.availableBills, function (key, index) {
        if (key.hospitalBillDesc === data.hospitalBillDesc) {
          scope.availableBills.splice(index, 1);
          if (key.isPackage) {
            scope.removePackageFromList(data);
          }
        }
      });
      scope.calculateTotalAmount();
    };

    //scope.availableBills =[{ "intermalBillTypeId": 1, "internalBillTypeDesc": "Hospital Charges", "internalSubBillTypeId": 1, "internalSubBillDesc": "Room Rent", "hospitalBillDesc": "Admission Charge" }, { "intermalBillTypeId": 1, "internalBillTypeDesc": "Hospital Charges", "internalSubBillTypeId": 1, "internalSubBillDesc": "Room Rent", "hospitalBillDesc": "Room" }, { "intermalBillTypeId": 1, "internalBillTypeDesc": "Hospital Charges", "internalSubBillTypeId": 6, "internalSubBillDesc": "Consultant/Specialist", "hospitalBillDesc": "Doctor charge" }, { "intermalBillTypeId": 2, "internalBillTypeDesc": "Investigation & Lab Charges", "internalSubBillTypeId": 11, "internalSubBillDesc": "ECG", "hospitalBillDesc": "Test" }, { "intermalBillTypeId": 4, "internalBillTypeDesc": "Miscellaneous Charges", "internalSubBillTypeId": 53, "internalSubBillDesc": "Other Miscellaneous Charges", "hospitalBillDesc": "Other Charges" }];
    scope.UploadCsvBill = function () {
      var hospId, inscompId, claimId;
      hospId = scope.dataobj.hospitalId;
      inscompId = scope.dataobj.patientDetails ? scope.dataobj.patientDetails.insCompId : 0;
      claimId = scope.dataobj.claimId;
      if (scope.billCsvFile) {
        ClaimActionService.getBillsFromCsv(scope.billCsvFile, hospId, inscompId, claimId).then(
          function (response) {
            if (response.data.isSuccess) {
              scope.csvBillDetails = response.data.claimBill;
              scope.csvBillDiscount = response.data.discountAmount;
              scope.csvBillDiscountRemarks = response.data.discountRemarks;
              //  scope.item.hospitalDiscount=response.data.discountAmount;
              scope.totalBillAmount = 0;
              angular.forEach(scope.csvBillDetails, function (data) {
                var obj = {
                  PROVIDER_BILL_ITEM_NAME: '',
                  BILL_ITEM_DETAIL_REF: '',
                  DETAIL_BILL_ITEM_CLAIM_ID: '',
                  DETAIL_BILL_ITEM_PREAUTH_NO: '',
                  CLAIMED_AMOUNT: data.clmBillAmt,
                  CMS_CHARGE_TYPE_ID: data.clmBillCtype,
                  CMS_CHARGE_TYPE_DESC: null,
                  CMS_SUBCHARGE_TYPE_ID: null,
                  CMS_SUBCHARGE_TYPE_DESC: data.clmBillFor,
                  hospitaL_CHARGE_HEAD: data.hospchargeHeadCategory,
                  hospitalBillDesc: data.hospchargeHeadCategory ? data.hospchargeHeadCategory : data.clmBillFor,
                  isReadOnly: true,
                  isPackage: false,
                  uniqueIds: '',
                  packageId: 0,
                  packageName: null,
                  hospData: data.hospData
                }
                scope.availableBills.push(obj);
                scope.CLAIMED_AMOUNT += data.clmBillAmt > 0 ? data.clmBillAmt : 0;
              })
              scope.file.push(scope.billCsvFile)

            }
            else{
              alert('Invalid file or data');
              scope.billCsvFile=null;
            }
          }
        );
      } else {
        alert('select csv bill to upload');
      }

      // var fileBlobArray = [];
      //         var filesUploadingArray = [];
      //         Object.keys(scope.billCsvFile).forEach(function (ele) {
      //             if (typeof (scope.file[ele].model) == "object") {
      //                 filesUploadingArray.push(scope.file[ele].model);
      //             }
      //         });
      //         if (filesUploadingArray.length > 0) {
      //             fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
      //         }

    }

    // scope.getHospdataPopoverHtml=function(data)
    // {
    //     var table="<table class='table table-bordered'><th><td>Item Name</td><td>Amount</td></th><table>"
    //     var ngRepeatHtml="<tr ng-repeat='list in '></tr>";
    // }
    scope.isEBill = UtilitiesService.checkEBillHospital(UserService.getHospitalObj().hospId);
    scope.getDateObj = UtilitiesService.getDateObj;
    scope.discharge = {};
    scope.modalRenderingMethods = (function () {
      return {
        openEnhanceModal: function () {
          $analytics.eventTrack('EnhancementClick', {
            category: 'Claim', label: 'Enhancement'
          });

          angular.element('#enhanceModal').appendTo('body');
          angular.element('#enhanceModal').modal('show');
          scope.form = {}
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = [];
        },
        openClaimBillHospDataModal: function (val) {

          scope.myData = [];
          angular.forEach(val, function (elm) {
            scope.myData.push({
              'billNo': elm.clmBillNo,
              'hospChargeHead': elm.hospChargeHead,
              'billAmount': elm.clmBillAmt
            });
          });
          ngDialog.open({
            template: 'templateId',
            scope: scope
          });
          // angular.element('#claimbillhospdata').modal('hide');
          // angular.element('#claimbillhospdata').appendTo('body');
          // angular.element('#claimbillhospdata').modal('show');

        },
        openDiscounRemarks: function () {

          ngDialog.open({
            template: 'DiscountRemarks',
            scope: scope
          });
          // angular.element('#claimbillhospdata').modal('hide');
          // angular.element('#claimbillhospdata').appendTo('body');
          // angular.element('#claimbillhospdata').modal('show');

        },
        openDischargeModal: function () {

          $analytics.eventTrack('DischargeClick', {
            category: 'Claim', label: 'Discharge'
          });

          angular.element('#dischargeModal').appendTo('body');
          angular.element('#dischargeModal').modal('show');
          scope.form = {}
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = [];
          //scope.discharge = {};
          if(scope.dataobj.claimDetails) {
            scope.discharge.doa = new Date(scope.dataobj.claimDetails.clmDOA) ;
            scope.discharge.dod = new Date(scope.dataobj.claimDetails.clmDOD) ;
          }
          else {
            scope.discharge.doa = new Date (scope.dataobj.dateOfAdmission);
            scope.discharge.dod = new Date (scope.dataobj.dateOfDischarge);
          }
        },
        openIrModal: function () {
          angular.element('#submitMissing').appendTo('body');
          angular.element('#submitMissing').modal('show');
          scope.form = {}
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = [];
        },
        close: function () {
          angular.element('.modal').modal('hide');
          //$location.path('/');
        }
      }
    })();



    scope.enhancementRelatedMethods = (function () {
      scope.enhance = {};
      return {
        relatedData: function () {
          var data = {
            hospId: UserService.getHospitalObj().hospId,
            claimId: scope.dataobj.claimId,
            claimedAmount: scope.enhance.amount,
            remarks: scope.enhance.remarks,
            updatedBy: UserService.getUserObj().userId,
            actionType: "enhance",
            fileUploadFolder: scope.form.fileUploadFolderPath.join(),
            fileNames: scope.form.fileNames.join(),
            uiD_NO: scope.enhance.uidno,
            patientIPNumber: scope.enhance.patientIPNumber,
            isDeathCase:scope.enhance.isDeathCase
          }
          return data;
        },
        submitEnhance: function () {
          scope.fileUploadRelatedMethods.uploadFiles("enhancementRelatedMethods", function () {
            ClaimActionService.submitEnhance(this.relatedData())
              .then(submitEnhanceSuccess, submitEnhanceError);
          });
        }
      }

      function submitEnhanceSuccess() {
        
        scope.esubmitted = true;
        scope.esubsuccess = true;
      }

      function submitEnhanceError() {
        scope.esubmitted = true;
        scope.esubsuccess = false;
      }
    })();
    scope.fileUploadRelatedMethods = (function () {
      scope.form = {}
      scope.form.fileNames = [];
      scope.form.fileUploadFolderPath = [];
      return {
        uploadFiles: function (source, callback) {
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = [];
          //-----------new code
          var fileBlobArray = [];
          var filesUploadingArray = [];
          Object.keys(scope.file).forEach(function (ele) {
            if (typeof (scope.file[ele].model) == "object" || typeof (scope.file[ele]) == "object") {
              filesUploadingArray.push(scope.file[ele].model ? scope.file[ele].model : scope.file[ele]);
            }
          });
          if (filesUploadingArray.length > 0) {
            fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
          } else if (source == 'iRrelatedMethods' || source == 'dischargeRelatedMethods') {
            scope.btnSubmitflag = false;
            alert('Please attach atleast one document.');
            return false;
          }
          $q.all(fileBlobArray).then(function (result) {
              result.forEach(function (element) {
                if (element.data.isSuccess) {
                  angular.forEach(element.data.uploadResponseDetails, function (e, i) {
                    scope.form.fileNames.push(e.fileName);
                    scope.form.fileUploadFolderPath.push(e.downloadURL);
                  });
                } else {
                  scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                  return false;
                }
                scope.file = [];
              });
              if (result && (filesUploadingArray.length == 0 || scope.form.fileNames.length == result[0].data.uploadResponseDetails.length))
                switch (source) {
                  case "iRrelatedMethods":
                    callback.call(scope.iRrelatedMethods);
                    break;
                  case "dischargeRelatedMethods":
                    callback.call(scope.dischargeRelatedMethods);
                    break;
                  case "enhancementRelatedMethods":
                    callback.call(scope.enhancementRelatedMethods);
                    break;
                }
            },
            function (error) {
              scope.file = [];
              scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
            })
        },
        addFiles: function () {
          scope.fileCountObj.push({
            "name": 'myfile' + (scope.fileCountObj.length + 1)
          });
        },
        removeFiles: function (index) {
          if (scope.fileCountObj.length > 1) {
            scope.fileCountObj.splice(index, 1)
          }

        }

      }

      function fileUploadSuccess(successData) {
        if (successData.data.isSuccess) {
          scope.form.fileNames.push(successData.data.uploadResponseDetails[0].fileName);
          scope.form.fileUploadFolderPath.push(successData.data.uploadResponseDetails[0].downloadURL)
          UtilitiesService.showAlertMessage('File uploaded successfully.');
        }
      }

      function fileUploadError(errordata) {
        aUtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
      }
    })();
    
    scope.getHospitalDiscountforBill=function()
    {
      var object=[{
        clmBillCtype:2,
        clmBillFor:"Haematology (Blood count)",
        clmBillAmt:scope.discharge.investigation
      },
      {
        clmBillCtype:3,
        clmBillFor:"Medicines/Drugs",
        clmBillAmt:scope.discharge.pharmacy
      },
      {
        clmBillCtype:1,
        clmBillFor:"Room Rent",
        clmBillAmt:scope.discharge.roomrent
      },{
        clmBillCtype:10,
        clmBillFor:"Consultation / Visit",
        clmBillAmt:scope.discharge.consultation
      },{
        clmBillCtype:4,
        clmBillFor:"Other Miscellaneous Charges",
        clmBillAmt:scope.discharge.others
      },{
        clmBillCtype:15,
        clmBillFor:"Package",
        clmBillAmt:scope.discharge.pkgcost
      }];
      hospId = scope.dataobj.hospitalId;
      inscompId = scope.dataobj.patientDetails ? scope.dataobj.patientDetails.insCompId : 0;
      var data={
        "HospId":hospId,
        "InscompId":inscompId,
        "DiscountBills":object
      }
      ClaimActionService.getHospitalDiscount(data)
                        .then(function(res){
                          if(res && res.data.isSuccess)
                          {
                            scope.dischargeBillDiscount=res.data.discountAmount;
                            scope.dischargeBillDiscountRemarks=res.data.discountRemarks;
                          }
                        })
    }

    scope.dischargeRelatedMethods = (function () {

     
      function Discharge(PROVIDER_BILL_ITEM_NAME, BILL_ITEM_DETAIL_REF, DETAIL_BILL_ITEM_CLAIM_ID, DETAIL_BILL_ITEM_PREAUTH_NO, CLAIMED_AMOUNT, CMS_CHARGE_TYPE_ID, CMS_CHARGE_TYPE_DESC, CMS_SUBCHARGE_TYPE_ID, CMS_SUBCHARGE_TYPE_DESC) {
        return {
          PROVIDER_BILL_ITEM_NAME: PROVIDER_BILL_ITEM_NAME,
          BILL_ITEM_DETAIL_REF: BILL_ITEM_DETAIL_REF,
          DETAIL_BILL_ITEM_CLAIM_ID: DETAIL_BILL_ITEM_CLAIM_ID,
          DETAIL_BILL_ITEM_PREAUTH_NO: DETAIL_BILL_ITEM_PREAUTH_NO,
          CLAIMED_AMOUNT: CLAIMED_AMOUNT,
          CMS_CHARGE_TYPE_ID: CMS_CHARGE_TYPE_ID,
          CMS_CHARGE_TYPE_DESC: CMS_CHARGE_TYPE_DESC,
          CMS_SUBCHARGE_TYPE_ID: CMS_SUBCHARGE_TYPE_ID,
          CMS_SUBCHARGE_TYPE_DESC: CMS_SUBCHARGE_TYPE_DESC,
        }
      }
      return {
        relatedData: function () {
          var dischargeList = [];
          var InvestigationObj = Discharge("", "", "", "", scope.discharge.investigation, 2, "Investigation & Lab Charges", 2, "Haematology (Blood count)");
          var PharmacyObj = Discharge("", "", "", "", scope.discharge.pharmacy, 14,"Pharmacy & Medicine Charges", 23, "Medicines/Drugs");
          var Roomrent = Discharge("", "", "", "", scope.discharge.roomrent, 1, "Hospital Charges", 1, "Room Rent");
          var Consultation = Discharge("", "", "", "", scope.discharge.consultation, 10, "Consultation Charges", 59, "Consultation / Visit");
          var OthersObj = Discharge("", "", "", "", scope.discharge.others, 4, "Miscellaneous Charges", 53, "Other Miscellaneous Charges");
          var packageObj = Discharge(scope.discharge.pkgname, "", "", "", scope.discharge.pkgcost, 15, "Package", "", "Package");

          dischargeList.push(InvestigationObj, PharmacyObj, Roomrent, Consultation, OthersObj, packageObj)

          var data = {
            hospId: UserService.getHospitalObj().hospId,
            claimId: scope.dataobj.claimId,
            claimedAmount: scope.discharge.total,
            remarks: scope.discharge.remarks,
            updatedBy: UserService.getUserObj().userId,
            actionType: "discharge",
            fileUploadFolder: scope.form.fileUploadFolderPath.join(),
            fileNames: scope.form.fileNames.join(),
            doa: scope.discharge.doa,
            dod: scope.discharge.dod,
            dischargeList: dischargeList,
            uiD_NO: scope.discharge.uidno,
            patientIPNumber: scope.discharge.patientIPNumber,
            hospitalDiscount:scope.dischargeBillDiscount?scope.dischargeBillDiscount:0,
            hospitalDiscountRemarks:scope.dischargeBillDiscountRemarks?scope.dischargeBillDiscountRemarks:null,
            isDeathCase:scope.discharge.isDeathCase
          }
          return data;
        },
        submitDischarge: function () {
          scope.fileUploadRelatedMethods.uploadFiles("dischargeRelatedMethods", function () {
            ClaimActionService.submitDischarge(this.relatedData()).then(dischargeSubmitSuccess, dischargeSubmitError)
          });
        },
        validateData: function () {},
        calcDischargeTotal: function (term) {
          scope.discharge.total = 0;
          var inv = scope.discharge.investigation == undefined ? 0 : parseInt(scope.discharge.investigation);
          var pharmacy = scope.discharge.pharmacy == undefined ? 0 : parseInt(scope.discharge.pharmacy);
          var room = scope.discharge.roomrent == undefined ? 0 : parseInt(scope.discharge.roomrent);
          var consult = scope.discharge.consultation == undefined ? 0 : parseInt(scope.discharge.consultation);
          var others = scope.discharge.others == undefined ? 0 : parseInt(scope.discharge.others);
          var pkgcost = scope.discharge.pkgcost == undefined ? 0 : parseInt(scope.discharge.pkgcost);

          scope.discharge.total = inv + pharmacy + room + consult + others + pkgcost;
          if(scope.discharge.investigation!=undefined && scope.discharge.investigation!=null && scope.discharge.pharmacy!=undefined  
            && scope.discharge.pharmacy!=null && scope.discharge.roomrent!=undefined && scope.discharge.roomrent!=null && scope.discharge.consultation!=undefined && scope.discharge.consultation!=null)
          {
            scope.getHospitalDiscountforBill();
          }
        },
        clearDischargeTotal: function (changetype) {
          scope.discharge.investigation = 0;
          scope.discharge.pharmacy = 0;
          scope.discharge.roomrent = 0;
          scope.discharge.consultation = 0;
          scope.discharge.others = 0;
          scope.discharge.pkgcost = 0;
          scope.discharge.total = 0;
        }
      }

      function dischargeSubmitSuccess() {
        scope.dsubmitted = true;
        scope.dsubsuccess = true;
      }

      function dischargeSubmitError() {
        scope.dsubmitted = true;
        scope.dsubsuccess = false;
      }
    })();
    scope.iRrelatedMethods = (function () {
      scope.ir = {};
      return {
        submitIr: function () {
          scope.fileUploadRelatedMethods.uploadFiles("iRrelatedMethods", function () {
            ClaimActionService.submitIr(this.relatedData())
              .then(submitIrSuccess, submitIrError);
          });
        },
        relatedData: function () {
          var data = {
            hospId: UserService.getHospitalObj().hospId,
            claimId: scope.dataobj.claimId,
            claimedAmount: scope.enhance.amount,
            remarks: scope.ir.remarks,
            updatedBy: UserService.getUserObj().userId,
            actionType: "reply",
            fileUploadFolder: scope.form.fileUploadFolderPath.join(),
            fileNames: scope.form.fileNames.join(),
          };
          return data;
        },
      }

      function submitIrSuccess() {
        scope.msubmitted = true;
        scope.msubsuccess = true;
      }

      function submitIrError() {
        scope.msubmitted = true;
        scope.msubsuccess = false;
      }



    })();
    angular.element(document).ready(function () {});
    scope.file = [];
    scope.addFileToUpload = function () {
      var newItemNo = scope.file.length + 1;
      scope.file.push({
        'model': ''
      });
    };
    scope.removeFileToUpload = function () {
      var lastItem = scope.file.length - 1;
      scope.file.splice(lastItem);
      scope.validLargeDoc = false;
    };
    scope.addFileToUpload();
  }]);

angular.module('mbplus')
  .controller('headerCtrl', ['$rootScope', '$scope', '$interval', 'UserService', '$location', '$log', 'UtilitiesService', 'PlusUtilitiesService', 'filterFilter', '$timeout', 'filterFilter', '$state', '$sce', 'navConstantsSvc', function (rootScope, scope, $interval, UserService, $location, $log, UtilitiesService, PlusUtilitiesService, filterFilter, $timeout, filterFilter, $state, $sce, constant) {
    scope.mediBuddyPlusUtilization = 0;
    scope.ClaimbyEmailCount = 0;
    scope.user = UserService.getUserObj();
    scope.MaTPAId = UtilitiesService.getMaTpaId();
    scope.MaTpaName = UtilitiesService.getMaTpaName();
    scope.tpaName = {
      id: UtilitiesService.getMaTpaId(),
      value: UtilitiesService.getMaTpaName()
    };
    if (UserService.isActive()) {
      scope.showHeader = true;
      scope.userRole = UserService.displayThis;
      if (UserService.getUserObj()) {
        scope.userName = UserService.toTitleCase(UserService.getUserObj().userName ? UserService.getUserObj().userName : UserService.getUserObj().firstName);
      }
    } else {
      if (UserService.getUserObj()) {
        scope.getUserDefaultRoute = UserService.getUserDefaultRoute(PlusUtilitiesService.getMenuDetails());
        $location.path(scope.getUserDefaultRoute).replace();
      } else {
        if (UtilitiesService.access_token) {

        } else {
          UserService.destroyUserObj();
        }
      }
    }
    scope.search = {
      searchData: ''
    };

    scope.insurer = {
      dsearchOption: ''
    };
    scope.formatTime = UtilitiesService.formatTime;
    scope.compareDate = UtilitiesService.compareDate;
    scope.notificationAllData = [];
    scope.formats = constant.dateFormate;
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];
    scope.dateOptions = {
      formatYear: 'yy',
      // maxDate: new Date(2020, 5, 22),
      startingDay: 1
    };
    scope.datePopup = {
      opened: false
    };
    scope.openDatePopup = function () {
      scope.datePopup.opened = true;
    };
    scope.notificationCount1 = 0;
    var callAtTimeoutMA = function (count) {
      // var l = 8;
      // for (var i = 0; i < 30; i++)
      //     angular.element("#bellNotify1").animate({
      //         'margin-left': "+=" + (l = -l) + 'px',
      //         'margin-right': "-=" + l + 'px'
      //     }, 70);
      var audio = new Audio('app/resources/alert-tome.mp3');
      audio.play();
      // NotifyDesktop(count);
    };

    scope.goBack = function () {
      scope.ischangePage = false;
      if (scope.backURL) {
        $location.path(scope.backURL);
      } else {
        $location.path('/claims');
      }
    };

    scope.changeFilterForClaimSearch = function () {
      $state.go('advanceSearch', {}, {
        reload: true
      });
    };

    scope.checkRoleFlag = function () {
      return (rootScope.toggleMenuObj.isDcRoleActive ? true : false);
    }

    scope.dynamicPopover = {
      content: 'Hello, World!',
      templateUrl: 'notificationPopover.html',
      title: $sce.trustAsHtml('<strong>See All Notifications</strong>')
    }

    scope.markAsComplet = function (data, index) {
      scope.notificationData = '';
      if (data && scope.user) {
        scope.notificationData = data;
        var id = [];
        id.push(data.Id)
        var data = {
          notificationID: id,
          accessToken: scope.user.accessToken
        }
        UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'UpdateNotification', data, 'POST').then(function (response) {
          if (response.data) {
            angular.forEach(scope.notificationAllData, function (v, i) {
              if (scope.notificationData && (v.Id === scope.notificationData.Id)) {
                scope.notificationAllData.splice(i);
              }
            });
          }
        });
      }
    };


    scope.enabledTpaConfiguration = function () {
      var retult = false;
      if (scope.tpaList && scope.tpaList.length > 0) {
        return retult = true;
      }
      return retult;
    };
    scope.newAdmissionType = 'NA';

    scope.changeNewAdmissionType = function (type) {
      if (type && type === 'tpaNewAdmission') {
        $state.go('tpa', {}, {
          reload: true
        })
      } else if (type && type === 'newAdmission') {
        $state.go('newAdmissionUrl', {}, {
          reload: true
        })
      } else {
        $state.go('claims', {}, {
          reload: true
        })
      }
    };

    scope.checkMaFlag = function () {
      var retult = false;
      if (scope.user && scope.user.rolesFeatures.roles.length > 0) {
        angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
          if (v.roleId == 9203) {
            retult = true;
          }
        })
      }
      return retult;
    };

    scope.changeTpa = function (tpaName) {
      scope.tpaName = tpaName;
    }

    scope.setupForSignalR = function () {
      // Declare a proxy to reference the hub.
      if ($.connection && $.connection.hub) {
        $.connection.hub.url = UtilitiesService.getUrlPrefixForSignalR();
        var chat = $.connection.notificationHub;
        // Create a function that the hub can call to broadcast messages.
        chat.client.broadcastUserNotifications = function (name, message) {
          var message = JSON.parse(message);
          scope.notificationCount1 = message.NoOfNotification;
          scope.notificationAllData = message.notifications;
        };
      }
    };

    scope.setupForSignalR();

    function NotifyDesktop(count) {
      if (!('Notification' in window)) {
        return;
      }
      Notification.requestPermission(function (permission) {
        var notification = new Notification("Medi Assist", {
          body: 'You have ' + count + ' new notification(s)',
          icon: 'app/resources/images/Plus_Logo.png',
          dir: 'auto'
        });
        var tmOut = setTimeout(function () {
          notification.close();
          clearInterval(tmOut);
        }, 10000);
        notification.onclick = function (x) {
          window.focus();
        };
      });
    }

    scope.isInsurer = true;
    if (scope.user && scope.user.entityType === 'Insurer') {
      scope.isInsurer = false;
    }
    scope.getMediBuddyPlusUtilization = function () {
      if (UserService.getHospitalObj()) {
        scope.ClaimbyEmailCount = UserService.getHospitalObj().ClaimbyEmailCount ? UserService.getHospitalObj().ClaimbyEmailCount : 0;
        scope.mediBuddyPlusUtilization = UserService.getHospitalObj().mediBuddyPlusUtilization;
        scope.isMediBuddyPlusUtilization = UserService.getHospitalObj().mediBuddyPlusUtilization ? true : false;
      }
    };

    scope.$on('utilazation', function (key, value) {
      if (value === true) {
        scope.getMediBuddyPlusUtilization();
      }
    });

    scope.redirectUrl = function (url) {
      //Enable New Admission form(with package + TPA)
      if (scope.user && (scope.user.entityId === 1026419)) {
        //if (scope.user && (scope.user.entityId === 1003862 || scope.user.entityId === 1005157 || scope.user.entityId === 1005034)) {
        $state.go('newAdmissionUrl', {}, {
          reload: true
        })
      } else if (url == 'newAdmissionCataract') {
        $state.go('newAdmissionCataract', {}, {
          reload: true
        })
      } else if (url == 'walkInCashless') {
        $state.go('walkInCashless', {}, {
          reload: true
        })
      } else {
        $state.go('newAdmission', {}, {
          reload: true
        })
      }
    };

    scope.getMediBuddyPlusUtilization();

    rootScope.$on('reloadSearchPharma', function (key, value) {
      //clear dropdown and textbox
      scope.search = {
        searchData: ''
      };
      scope.data.singleSelect = '';
    });

    scope.clearSearchData = function () {
      scope.search.searchData = '';
      scope.insurerSearch.searchData = '';
      rootScope.$broadcast('searchByClear', '');
    };
    scope.eSalesFilter = function (value) {
      if (value) {
        scope.search.searchData = '';
        scope.selectedOrderType = '';
        scope.showTextBtn = true;
        scope.isSearchSelected = true;
        switch (value) {
          case "1":
            scope.selectedOrderType = 'Equote';
            scope.placeHolderValue = "Enter equote id";
            break;
          case "2":
            scope.selectedOrderType = 'emailid';
            scope.placeHolderValue = "Enter email id";
            break;
          case "3":
            scope.selectedOrderType = 'contactno';
            scope.placeHolderValue = "Enter contact number";
            break;
          case "4":
            scope.selectedOrderType = 'name';
            scope.placeHolderValue = "Enter name";
            break;
          case "5":
            scope.selectedOrderType = 'proposalNumber';
            scope.placeHolderValue = "Enter proposal number";
            break;
        }
      } else {
        rootScope.$broadcast('searchByClear', '');
        scope.search.searchData = '';
        scope.selectedOrderType = '';
        scope.showTextBtn = false;
        scope.isSearchSelected = false;
      }
    }

    scope.isSearchSelected = false;
    scope.statuses = [{
      id: 1,
      name: 'Request Id'
    }, {
      id: 2,
      name: 'Employee Id'
    }, {
      id: 3,
      name: 'Email'
    }, {
      id: 4,
      name: 'Contact no.'
    }, {
      id: 5,
      name: 'Name'
    }];
    scope.statusFilter = function (value) {
      if (value) {
        scope.search.searchData = '';
        scope.selectedOrderType = '';
        scope.showTextBtn = true;
        scope.isSearchSelected = true;
        if (value == 1) {
          scope.selectedOrderType = 'reqId';
          scope.placeHolderValue = 'Enter request id';
        } else if (value == 2) {
          scope.selectedOrderType = 'empId';
          scope.placeHolderValue = 'Enter employee id';
        } else if (value == 3) {
          scope.selectedOrderType = 'email';
          scope.placeHolderValue = 'Enter email id';
        } else if (value == 4) {
          scope.selectedOrderType = 'contact';
          scope.placeHolderValue = 'Enter contact number';
        } else if (value == 5) {
          scope.selectedOrderType = 'name';
          scope.placeHolderValue = 'Enter name';
        } else if (value == 6) {
          scope.selectedOrderType = 'partnerOrderId';
          scope.placeHolderValue = 'Enter partner order id';
        } else if (value == 7) {
          scope.selectedOrderType = 'Equote';
          scope.placeHolderValue = 'Enter Equote';
        } else if (value == 8) {
          scope.selectedOrderType = 'MAID';
          scope.placeHolderValue = 'Enter maid';
        }
      } else {
        rootScope.$broadcast('searchByClear', '');
        scope.search.searchData = '';
        scope.selectedOrderType = '';
        scope.showTextBtn = false;
        scope.isSearchSelected = false;
      }

    };

    scope.$watch('dcInvestigationsMap', function (value, flag) {
      if (value) {
        rootScope.$broadcast('searchDc', value);
      }
    }, true);

    rootScope.$on('reloadInsurer', function (key, value) {
      //clear dropdown
      scope.showEsalesDdl = false;
      scope.showAllApptDdl = false;
      scope.txtInsurerSearch = false;
      scope.bothContrSearch = false;
      scope.insurer = {
        dsearchOption: ''
      }
    });

    scope.eSalesAppointmentParticular = function () {
      var data = {
        value: scope.search.searchData,
        selectedOrderType: scope.selectedOrderType
      };
      if ($location.$$path === '/queue') {
        rootScope.$broadcast('eSalesSearch', data);
      }
    }

    scope.searchAppointmentsParticular = function (value, isFlag, source) {
      var urlLocation = $location.$$path.split('/');
      if (isFlag === true) {
        var value = value.searchData !== '' ? value.searchData : '';
        if (value) {
          var data = {
            value: value,
            selectedOrderType: scope.selectedOrderType
          };
          if ($location.$$path === '/appointments') {
            rootScope.$broadcast('searchBy', data);
          } else if ($location.$$path === '/allappointments') {
            rootScope.$broadcast('searchByAll', data);
          } else if ($location.$$path === '/inDashboard') {
            rootScope.$broadcast('searchByAllInsurer', data, source);
          } else if ($location.$$path === '/dcDashboard' || urlLocation[1] === 'allappointmentsSearchStatus') {
            $location.path('/allappointmentsSearchStatus/' + data.selectedOrderType + '/' + data.value);
            // rootScope.$broadcast('searchBy', data);
          }
        }
      }
    };

    rootScope.plusAppointmentsSearch = '';
    rootScope.dcInvestigations = '';
    rootScope.dcInvestigationsMap = '';
    rootScope.eSaleQueue = '';
    scope.headerFlag = {
      plusSearch: false
    }

    scope.checkForSearchFilter = function (url) {
      var urlSplit = url.split("/")
      scope.clearSearchData();
      rootScope.plusAppointmentsSearch = '';
      rootScope.dcInvestigations = '';
      rootScope.dcInvestigationsMap = '';
      scope.featureListForPlusAppointments = [5435, 9190, 9191, 9192, 9193, 9199, 9194];
      scope.menuItems = PlusUtilitiesService.getMenuItems(PlusUtilitiesService.getMenuDetails());
      scope.plusAppointmentFeatures = scope.menuItems.filter(function (n) {
        return scope.featureListForPlusAppointments.indexOf(n.fId) != -1;
      });
      var newCollection = filterFilter(scope.plusAppointmentFeatures, {
        'href': url
      });
      if (newCollection.length > 0 && url !== '/appointments') {
        scope.headerFlag.plusSearch = true;
        scope.isDcInvestigationsMap = false;
        scope.plusActiveAppointmentsSearch = false;
        scope.isDcInvestigations = false;
        scope.isQueue = false;
        scope.plusinsurerDashboardSearch = false;
        if (url === '/allappointments') {
          scope.plusActiveAppointmentsSearch = true;
          scope.plusinsurerDashboardSearch = false;
          scope.headerFlag.plusSearch = false;
          scope.isDcInvestigations = false;
          scope.isDcInvestigationsMap = false;
          scope.isQueue = false;
        }
      } else {
        scope.headerFlag.plusSearch = false;
        if (url === '/dcInvestigationsMap') {
          scope.isDcInvestigationsMap = true;
          scope.isDcInvestigations = false;
          scope.plusActiveAppointmentsSearch = false;
          scope.plusinsurerDashboardSearch = false;
          scope.isQueue = false;
        } else if (url === '/dcInvestigations') {
          scope.isDcInvestigations = true;
          scope.isDcInvestigationsMap = false;
          scope.isQueue = false;
          scope.plusActiveAppointmentsSearch = false;
          scope.plusinsurerDashboardSearch = false;
        } else if (url === '/appointments' || url === '/allappointments' || url === '/dcDashboard' || urlSplit[1] === 'allappointmentsSearchStatus') {
          scope.plusActiveAppointmentsSearch = true;
          scope.plusinsurerDashboardSearch = false;
          scope.isDcInvestigations = false;
          scope.isDcInvestigationsMap = false;
          scope.isQueue = false;
        } else if (url === '/queue') {
          scope.isQueue = true;
          scope.plusActiveAppointmentsSearch = false;
          scope.plusinsurerDashboardSearch = false;
          scope.isDcInvestigationsMap = false;
          scope.isDcInvestigations = false;
        } else if (url === '/inDashboard') {
          scope.plusinsurerDashboardSearch = true;
          scope.plusActiveAppointmentsSearch = false;
          scope.isDcInvestigations = false;
          scope.isDcInvestigationsMap = false;
          scope.isQueue = false;
        } else {
          scope.plusActiveAppointmentsSearch = false;
          scope.isDcInvestigations = false;
          scope.headerFlag.plusSearch = false;
          scope.isDcInvestigationsMap = false;
          scope.isQueue = false;
          scope.plusinsurerDashboardSearch = false;
        }
      }
    };

    //insurer dashboard search
    scope.insurerDashSearchDdl = {
      esalesDdl: '',
      allApptDdl: ''
    };
    scope.insurerSearch = {
      searchData: ''
    };
    scope.showBtnSearch = false;

    scope.showInsurerSearchDdl = function (searchOption) {
      scope.showEsalesDdl = false;
      scope.showAllApptDdl = false;
      scope.txtInsurerSearch = false;
      scope.bothContrSearch = false;
      scope.insurerDashSearchDdl = {};
      if (searchOption === '1' && searchOption !== '2' && searchOption !== '3') {
        scope.showEsalesDdl = true;
        scope.showAllApptDdl = false;
      } else if (searchOption !== '1' && searchOption !== '3' && searchOption === '2') {
        scope.showEsalesDdl = false;
        scope.showAllApptDdl = true;
      } else if (searchOption !== '1' && searchOption !== '2' && searchOption === '3') {
        scope.showEsalesDdl = false;
        scope.showAllApptDdl = false;
        scope.txtInsurerSearch = true;
        scope.bothContrSearch = true;
        scope.selectedOrderType = 'Application no';
        scope.placeHolderValue = 'Enter Application no';
        scope.insurerSearch.searchData = '';
      } else {
        scope.showEsalesDdl = false;
        scope.showAllApptDdl = false;
      }
    }

    scope.insurerDashSearch = function (value, source) {
      scope.selectedOrderType = '';
      scope.txtInsurerSearch = false;
      if (source === 'esales') {
        if (value) {
          scope.showBtnSearch = true;
          scope.insurerSearch.searchData = '';
          if (value == 1) {
            scope.txtInsurerSearch = true;
            scope.selectedOrderType = 'email';
            scope.placeHolderValue = 'Enter email id';
          } else if (value == 2) {
            scope.txtInsurerSearch = true;
            scope.selectedOrderType = 'contact';
            scope.placeHolderValue = 'Enter contact number';
          } else if (value == 3) {
            scope.txtInsurerSearch = true;
            scope.selectedOrderType = 'name';
            scope.placeHolderValue = 'Enter name';
          } else if (value == 4) {
            scope.txtInsurerSearch = true;
            scope.selectedOrderType = 'EQuote';
            scope.placeHolderValue = 'Enter EQuote';
          } else if (value == 5) {
            scope.txtInsurerSearch = true;
            scope.selectedOrderType = 'Application no';
            scope.placeHolderValue = 'Enter Application no';
          }
        } else {
          scope.txtInsurerSearch = false;
          scope.showBtnSearch = false;
        }
      } else if (source === 'allAppt') {
        if (value) {
          scope.showBtnSearch = true;
          scope.insurerSearch.searchData = '';
          if (value == 1) {
            scope.txtInsurerSearch = true;
            scope.selectedOrderType = 'reqId';
            scope.placeHolderValue = 'Enter request id';
          } else if (value == 2) {
            scope.txtInsurerSearch = true;
            scope.selectedOrderType = 'empId';
            scope.placeHolderValue = 'Enter employee id';
          } else if (value == 3) {
            scope.txtInsurerSearch = true;
            scope.selectedOrderType = 'email';
            scope.placeHolderValue = 'Enter email id';
          } else if (value == 4) {
            scope.txtInsurerSearch = true;
            scope.selectedOrderType = 'contact';
            scope.placeHolderValue = 'Enter contact number';
          } else if (value == 5) {
            scope.txtInsurerSearch = true;
            scope.selectedOrderType = 'name';
            scope.placeHolderValue = 'Enter name';
          }
        } else {
          scope.txtInsurerSearch = false;
          scope.showBtnSearch = false;
        }
      }
    }
    //insurer dashboard search

    if ($location.url($location.path())) {
      var url = $location.url($location.path()).$$path;
      scope.checkForSearchFilter(url);
    }

    rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      if ($location.search()) {

        rootScope.isRestLogin = {};
        var resetAccessToken = $location.search().token;
        if (resetAccessToken) {
          if ($location.$$path === '/resetpassword') {
            //Do nothing
          } else {
            $location.path('/');
          }
        } else if (UserService.isActive()) {
          scope.showHeader = true;

          scope.userRole = UserService.displayThis;
          if (UserService.getUserObj()) {
            scope.userName = UserService.toTitleCase(UserService.getUserObj().userName ? UserService.getUserObj().userName : UserService.getUserObj().firstName);
          } else {
            if (UserService.getUserObj()) {
              scope.getUserDefaultRoute = UserService.getUserDefaultRoute(PlusUtilitiesService.getMenuDetails());
              $location.path(scope.getUserDefaultRoute).replace()
            } else {

              UserService.destroyUserObj();
              $location.path('/');
            }
          }
        }
      }
      scope.checkForSearchFilter(toState.url);
    });

    rootScope.$on('signedin', function (event, args) {
      if (args && args === true) {
        scope.showHeader = true;
        if (UserService.getUserObj()) {
          scope.userName = UserService.toTitleCase(UserService.getUserObj().userName ? UserService.getUserObj().userName : UserService.getUserObj().firstName);
        }
        if (UserService.getHospitalObj()) {
          scope.hospErId = UserService.getHospitalObj().entityRealtion ? (UserService.getHospitalObj().entityRealtion[0] ? UserService.getHospitalObj().entityRealtion[0].eR_ID : null) : '';
          scope.isWalkInCashlessConfigured = UserService.getHospitalObj().isWalkInCashlessConfigured ? UserService.getHospitalObj().isWalkInCashlessConfigured : false;
        }
      } else {
        scope.showHeader = false;
        scope.userName = '';
      }
    });

    scope.fetchHospitals = function () {
      if (UserService.isActive()) {
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/list', '', 'POST').then(function (response) {
          if (response.data.isSuccess) {
            scope.hospitals = response.data.entities;
          }
        });
      }
    };

    scope.ischangePage = false;
    scope.resetSearchFields = function () {
      scope.claimSearch = {
        claimNo: '',
        NEFTUTRNumber: '',
        patientIPNumber: '',
        patientName: '',
        status: '',
        fromDate: new Date(),
        memberId:null
      };
    };
    scope.configuredTpaList = [];
    scope.resetSearchFields();
    scope.changePage = function (type) {
      // ;
      scope.ischangePage = true;
      scope.isNoDataFound = false;
      //scope.getConfiguredTpaList();
      scope.resetSearchFields();
      if (type) {
        if ($state.current.name !== 'advanceSearch') {
          $state.go('advanceSearch', {}, {
            reload: true
          });
        }
      } else {
        scope.goBack();
      }
    };

    scope.getText = function () {
      var dat = new Date();
      dat = dat.getDay();
      scope.textData = dat === 1 ? 'In the past 24 hours, you have sent ' + scope.ClaimbyEmailCount + ' mails and your MediBuddy+ adoption is ' + scope.mediBuddyPlusUtilization + ' %.' : dat === 2 ? constant.tuesdayText : dat === 3 ? constant.wednesdayText : dat === 4 ? constant.thursdayText : dat === 5 ? constant.fridayText : dat === 6 ? constant.saturdayText : '';
    };

    scope.isFlip = false;
    scope.intervalMethod = function (value) {
      scope.getText();
      var stop;
      if (angular.isDefined(stop)) return;
      stop = $interval(function () {
        if (value) {
          var dat = new Date();
          dat = dat.getDay();
          if (dat !== 7) {
            scope.isFlip = !scope.isFlip;
            scope.className = scope.isFlip === true ? 'flip' : '';
          }
        } else {
          scope.stopFight();
        }
      }, 5000);
    };
    scope.stopFight = function () {
      if (angular.isDefined(stop)) {
        $interval.cancel(stop);
        stop = undefined;
      }
    };
    scope.intervalMethod('ada');
    $(document).on('click', '.search-toggle', function (e) {
      $('.search-claims').slideDown();
    });

    scope.backURL = '';

    scope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
      if ($state.current.name !== 'advanceSearch') {
        scope.resetSearchFields();
        scope.searchby = '';
      }
      if (to.url == $location.path() && from && from.url)
        if (from && from.url && from.url.toString().indexOf('notification') < 0)
          scope.backURL = from.url;
        else
          scope.backURL = '/notification/' + fromParams.type;
    });

    // scope.getTPAList = function () {
    //   scope.TPAListData = [];
    //   var ajaxData = {
    //     LookUpType: 'TPA'
    //   };
    //   UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/master/MasterLookup', ajaxData, 'POST').then(function (response) {
    //     if (response.data) {
    //       scope.TPAListData = response.data;
    //       scope.TPAListData.push({
    //         id: 0,
    //         value: '--Select Payer Name--'
    //       });
    //       scope.TPAListData.push({
    //         id: 999,
    //         value: 'All other payers'
    //       });
    //       scope.TPAListData = _.sortBy(scope.TPAListData, function (num) {
    //         return num.id > 0;
    //       });

    //       rootScope.$broadcast('AllTPALIST', scope.TPAListData);

    //     }
    //   }, function (error) {
    //     scope.TPAListData = [];
    //   });
    // };

    // scope.getConfiguredTpaList = function () {

    //     if (UserService.getHospitalObj() && UserService.getHospitalObj().cmsHospId) {
    //         UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'hosp/' + UserService.getHospitalObj().cmsHospId + '/tpas', '', 'GET').then(function (response) {
    //             if (response.data.isSucces) {
    //                 scope.tpaList = response.data.tpaList;
    //                 rootScope.$broadcast('ConfiguredTPAList', scope.tpaList);
    //             }
    //         }, function (error) {
    //             scope.tpaList = [];
    //         });
    //     }
    // };
    // scope.getConfiguredTpaList();



    scope.getConfiguredTpaList = function () {
      var configuredTpaList = UtilitiesService.getConfiguredTpa();
      if (configuredTpaList && configuredTpaList.length > 0) {
        if (!scope.configuredTpaList)
          scope.configuredTpaList = [];
        scope.configuredTpaList.push({
          id: UtilitiesService.getMaTpaId(),
          value: UtilitiesService.getMaTpaName()
        })
        scope.configuredTpaList.push({
          id: 999,
          value: 'All other payer'
        })
        if (!scope.tpaName || scope.tpaName && !scope.tpaName.id) {
          scope.tpaName = {
            id: UtilitiesService.getMaTpaId(),
            value: UtilitiesService.getMaTpaName()
          }
        }
        angular.forEach(configuredTpaList, function (element) {
          scope.configuredTpaList.push({
            id: element.tpaId,
            value: element.tpaName
          })
        });
      }

      if (UserService.getHospitalObj() && UserService.getHospitalObj().configuredPayers) {
        // var objArray = Object.entries(UserService.getHospitalObj().configuredPayers);
        if (!scope.configuredTpaList) {
          scope.configuredTpaList = [];
          scope.configuredTpaList.push({
            id: UtilitiesService.getMaTpaId(),
            value: UtilitiesService.getMaTpaName()
          })
        }

        angular.forEach(UserService.getHospitalObj().configuredPayers, function (e) {
          scope.configuredTpaList.push({
            value: e.name,
            id: e.id
          })
        })

      }

      if (UserService.getHospitalObj() && UserService.getHospitalObj().configuredSchemes && UserService.getHospitalObj().configuredSchemes.length > 0) {
          if (!scope.configuredTpaList || (scope.configuredTpaList && scope.configuredTpaList.length == 0)) {
          scope.configuredTpaList = [];
          scope.configuredTpaList.push({
            id: UtilitiesService.getMaTpaId(),
            value: UtilitiesService.getMaTpaName()
          })
        }
        angular.forEach(UserService.getHospitalObj().configuredSchemes, function (element) {
          scope.configuredTpaList.push({
            value: element,
            id: UtilitiesService.getMaTpaId(),
            isGovtScheme: true
          })

        });
      }
    }
    scope.getConfiguredTpaList();
    // scope.getTPAList();


    scope.changeModel = function () {
      scope.claimSearchResults = [];
    };

    scope.searchClaims = function (data, type, index) {
      scope.searchBegin = false;
      scope.searchType = type;
      scope.serachModel = data;
      if (UserService.getHospitalObj().hospId)
        var searchData = {
          hospitalId: UserService.getHospitalObj().hospId,
          claimNumber: type === 'ClaimNumber' ? data : '',
          patientName: type === 'claimSearchFormPatientName' ? data : '',
          neftutrNumber: type === 'NEFTUTRNumber' ? data : '',
          patientIPNumber: type === 'patientIPNumber' ? data : '',
          status: type === 'claimStatus' ? data : '',
          dateOfAdmission: type === 'claimSearchFormPatientName' ? scope.claimSearch.fromDate : '',
          employeeId:type === 'employeeId' ? data : '',
          startIndexInclusive: index ? index : 1,
          hospTPAId: scope.tpaName && scope.tpaName.id ? scope.tpaName.id : null,
          schemeName: scope.tpaName && scope.tpaName.isGovtScheme && scope.tpaName.value ? scope.tpaName.value : null
        }
      UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/search/claimswithparams', searchData, 'POST').then(function (response) {
        scope.searchBegin = true;
        if (response.data.isSuccess) {
          scope.isNoDataFound = false;
          $timeout(function () {

          }, 300, true);
          scope.claimSearchResults = UtilitiesService.renderClaimsList(response.data);
          scope.claimSearchResults.allRecordCount = response.data.allRecordCount;
          if (scope.claimSearchResults && scope.claimSearchResults.length === 0) {
            scope.isNoDataFound = true;
          }
        } else {
          scope.isNoDataFound = true;
          scope.claimSearchResults = []
        }
      });
    };
    scope.paginationFun = function (value, advanceSearch) {
      if (advanceSearch === 'advanceSearch' && value) {
        if (UserService.getHospitalObj().hospId)
          var searchData = {
            hospitalId: UserService.getHospitalObj().hospId,
            claimNumber: '',
            patientName: '',
            neftutrNumber: '',
            patientIPNumber: '',
            status: scope.serachModel,
            dateOfAdmission: '',
            startIndexInclusive: value ? value : 1
          }
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/search/claimswithparams', searchData, 'POST').then(function (response) {
          if (response.data.isSuccess) {
            scope.isNoDataFound = false;
            scope.searchBegin = true;
            scope.alternativeData = UtilitiesService.renderClaimsList(response.data);
            scope.alternativeData.allRecordCount = response.data.allRecordCount;
          }
        });
      };
    }
    
    
    scope.displayOldToNew = false;
    $(window).on('hashchange', function(e){
      if( (scope.user && ["DC", "DC_Admin"].includes( scope.user.role)) ? true : false){
        var d = new Date();
        d.setDate(d.getDate() - 3); 
        var a = new Date(d.toLocaleDateString())
        var b = localStorage.getItem('lastCheckedDate');
        if(b == undefined || b ==  null){
          scope.displayOldToNew = true
          var b = new Date().toLocaleDateString();
          if(!["https://provider.medibuddy.in/#/","https://provider-test.medibuddy.in/#/"].includes(e.originalEvent.newURL)){
            localStorage.setItem('lastCheckedDate',b);
          }
        }
        else{
          var c = new Date(b)
          if(c < a) scope.displayOldToNew = true;
          else scope.displayOldToNew = false;
        }
      }
      else{
        scope.displayOldToNew = false;
      }
    });
    
    $(window).on('load',function(e){
      if( (scope.user && ["DC", "DC_Admin"].includes( scope.user.role))?true :false ){
        var d = new Date();
        d.setDate(d.getDate() - 3); 
        var a = new Date(d.toLocaleDateString())
        var b = localStorage.getItem('lastCheckedDate');
        if(b == undefined || b ==  null){
          scope.displayOldToNew = true
          var b = new Date().toLocaleDateString();
          localStorage.setItem('lastCheckedDate',b);
        }
        else{
          var c = new Date(b)
          if(c < a) scope.displayOldToNew = true;
          else scope.displayOldToNew = false;
        }
      }
      else{
        scope.displayOldToNew = false;
      }
    })

    
    scope.routeNewPortal =  (scope.user && ["DC", "DC_Admin"].includes( scope.user.role)) ?  "https://labwise-stage.medibuddy.in/#/login/"+scope.user.accessToken +'/'+scope.user.providerId : '';
    scope.oldToNew = function(choice){
      // var d = new Date();
      // d.setDate(d.getDate() - 3); 
      // var a = d.toLocaleDateString()
      var b = new Date().toLocaleDateString();
        localStorage.setItem('lastCheckedDate',b);
      // if(choice== "away"){
      // }
      // else {
        scope.displayOldToNew = false;
      //  }
    }
    
  }]);

angular.module('mbplus')
  .controller('govtHospActionCtrl', ['$rootScope', '$scope', 'UserService', '$location', '$state', '$log', 'UtilitiesService', 'ClaimActionService', 'FileUploadService', '$http', 'blockUI', '$q', 'safeApply', function ($rootScope, scope, UserService, $location, $state, $log, UtilitiesService, ClaimActionService, FileUploadService, $http, blockUI, $q, safeApply) {
    scope.ctrlName = "govtHospActionCtrl";
    if (UserService.isActive()) {
      scope.showHeader = true;
      if (UserService.getUserObj()) {
        scope.userName = UserService.toTitleCase(UserService.getUserObj().userName ? UserService.getUserObj().userName : UserService.getUserObj().firstName);
      }
    } else {
      // UserService.destroyUserObj();
      // //$location.path('/');
    }
    scope.user = {
      role: ''
    };
    if (UserService.getUserObj()) {
      scope.userRoles = UserService.getUserObj().rolesFeatures.roles;
      if (scope.userRoles.length > 1) {
        angular.forEach(scope.userRoles, function (value, key) {
          if (value.roleName === 'cms') {
            scope.user.role = 'CMS';
          }
        });
      } else {
        scope.user.role = scope.userRoles[0].roleName === 'cms' ? 'CMS' : '';
      }
    }

    scope.blockUIState = blockUI.state();
    scope.IsManipurScheme = $rootScope.govSchemeName == 'Manipur scheme (CMHT)' ? true : false;
    scope.enhance = {    
      doa:null,
      dod:null
    };
    scope.modalRenderingMethods = (function () {
      return {
        openApproveGovtModal: function () {
          angular.element("#approveGovt").appendTo("body");
          angular.element("#approveGovt").modal("show");
          scope.form = {};
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = [];
        },
        openRejectGovtModal: function () {
          angular.element("#rejectGovt").appendTo("body");
          angular.element("#rejectGovt").modal("show");
          scope.form = {};
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = [];
        },
        openSubmitMissingModal: function () {
          angular.element("#submitMissing").appendTo("body");
          angular.element("#submitMissing").modal("show");
          scope.form = {};
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = []; //
        },
        openSubmissionClaimModal: function () {
          scope.btnSubmitflag = false;
          angular.element("#submissionClaim").appendTo("body");
          angular.element("#submissionClaim").modal("show");
          scope.form = {};
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = []; //
        },
        openEnhanceClaimModal: function () {
          scope.enhance.doa = scope.dataobj.doa == "Today"?new Date():new Date(moment(scope.dataobj.doa).format('YYYY-MM-DD'));
          scope.enhance.dod = new Date(moment(scope.dataobj.tentativeDOD).format('YYYY-MM-DD'));  
          scope.btnSubmitflag = false;
          angular.element("#EnhanceClaim").appendTo("body");
          angular.element("#EnhanceClaim").modal("show");                
          scope.form = {};
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = []; //
        },
        openEnhanceIAModal: function () {
          angular.element("#EnhanceIA").appendTo("body");
          angular.element("#EnhanceIA").modal("show");
          scope.form = {};
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = []; //
        },
        openSubmitIAModal: function () {
          angular.element("#submitIA").appendTo("body");
          angular.element("#submitIA").modal("show");
          scope.form = {};
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = []; //submitIA
        },
        close: function () {
          scope.$parent.$parent.$parent.$parent.$parent.$parent.$parent.removeTab(scope.tabid);
          angular.element(".modal").modal("hide");
          $state.go($state.current, {}, {
            reload: true
          });
        }
      };
    })();
    scope.fileUploadRelatedMethods = (function () {
      scope.form = {};
      scope.form.fileNames = [];
      scope.form.fileUploadFolderPath = [];
      return {
        uploadFiles: function (callback) {
          scope.form.fileNames = [];
          scope.form.fileUploadFolderPath = [];
          var fileBlobArray = [];
          var filesUploadingArray = [];
          Object.keys(scope.file).forEach(function (ele) {
            if (typeof (scope.file[ele].model) == "object") {
              filesUploadingArray.push(scope.file[ele].model);
            }
          });
          if (filesUploadingArray.length > 0) {
            fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
          } else {
            UtilitiesService.showAlertMessage('Please attach atleast one document.');
            return false;
          }
          $q.all(fileBlobArray).then(function (result) {
              result.forEach(function (element) {
                if (element.data.isSuccess) {
                  angular.forEach(element.data.uploadResponseDetails, function (e, i) {
                    var obj = {};
                    obj.fileName = e.fileName;
                    obj.filePath = e.downloadURL;
                    scope.form.fileNames.push(obj);
                  });
                } else {
                  scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                  return false;
                }
                scope.file = [];
              });
              if (result && (filesUploadingArray.length == 0 || scope.form.fileNames.length == result[0].data.uploadResponseDetails.length))
                callback.call(scope.submitMissingRelatedMethods, result);
            },
            function (error) {
              UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
            });
        }
      };
    })();
    //govt actions
    scope.rejectRelatedMethods = (function () {
      return {
        relatedData: function () {
          var data = {
            "claimId": scope.dataobj.claimId,
            "status": scope.dataobj.status === 'Enhance Submitted' ? 'Enhance Denied' : 'Denied',
            "comments": scope.reject.comments,
            "createdBy": UserService.getUserObj().userId,
            "schemeName":scope.dataobj.schemeName
          };
          return data;
        },
        submitRejectRequest: function () {
          ClaimActionService.govtClaimAction(this.relatedData()).then(RejectRequestSuccess, RejectRequestError)
        },
        validateData: function () {},
        calcDischargeTotal: function (term) {
          scope.discharge.total = 0;
          var inv = scope.discharge.investigation == undefined ? 0 : parseInt(scope.discharge.investigation);
          var pharmacy = scope.discharge.pharmacy == undefined ? 0 : parseInt(scope.discharge.pharmacy);
          var room = scope.discharge.roomrent == undefined ? 0 : parseInt(scope.discharge.roomrent);
          var consult = scope.discharge.consultation == undefined ? 0 : parseInt(scope.discharge.consultation);
          var others = scope.discharge.others == undefined ? 0 : parseInt(scope.discharge.others);
          var pkgcost = scope.discharge.pkgcost == undefined ? 0 : parseInt(scope.discharge.pkgcost);

          scope.discharge.total = inv + pharmacy + room + consult + others + pkgcost;
        },
        clearDischargeTotal: function (changetype) {
          scope.discharge.investigation = 0;
          scope.discharge.pharmacy = 0;
          scope.discharge.roomrent = 0;
          scope.discharge.consultation = 0;
          scope.discharge.others = 0;
          scope.discharge.pkgcost = 0;
          scope.discharge.total = 0;
        }
      };

      function RejectRequestSuccess(resData) {
        scope.rsubmitted = true;
        scope.rsubsuccess = true;
      }

      function RejectRequestError(resData) {
        scope.rsubmitted = true;
        scope.rsubsuccess = false;
      }
    })();
    scope.govtPackageList = UserService.getGovtPackageList();
    scope.isSelectedGov = false;
    scope.newClmamount = '';
    scope.totalCalcAmount = '';
    scope.selectGovePackage = function (item, model) {
      scope.isSelectedGov = true;
      scope.selectedGovPackage = '';
      scope.priceForGovPackage = [];
      if (item) {
        scope.selectedGovPackage = item;
        var data = {
          price: item.packageCost
        }
        scope.priceForGovPackage.push(data);
        if (scope.priceForGovPackage.length === 1) {
          scope.govPackageManually.price = scope.priceForGovPackage[0].price;
        }
      } else {
        scope.isSelectedGov = false;
      }
    };
    scope.govPackageManually = {
      name: '',
      price: ''
    }
    scope.govPackageData = [];
    scope.addGovPackageManually = function (name, govPackage, flag) {
      if (scope.govPackageData.length <= 2) {
        if (flag) {
          scope.govPackageData.push(scope.selectedGovPackage);
          scope.isSelectedGov = false;
          scope.govPackagename = '';
        } else {
          var data = {
            cappedAmount: 0,
            govPackageName: name,
            packageCost: parseInt(govPackage.price),
            packageName: name,
            type: '',
            packageId: ''
          }
          var govtPackageList = _.where(scope.govPackageData, {
            packageName: data.packageName
          });
          if (govtPackageList.length > 0) {
            UtilitiesService.showAlertMessage('Duplicate line item is not allowed.');
          } else {
            scope.govPackageData.push(data);
          }
        }
      } else {
        UtilitiesService.showAlertMessage('Maximum of 3 packages allowed.');
      }
      scope.isSelectedGov = false;
      scope.selectedGovPackage = '';
      scope.govPackageManually.price = '';
      scope.govPackageManually.name = '';
      scope.form.govPackagename = '';
      scope.newClmamount = scope.totalGovClaimAmount();
      scope.govPackagename = '';
    };
    scope.eraseData = function () {
      scope.govPackageData = [];
      scope.newClmamount = 0;
      if (scope.file[0].model != '') {
        scope.file[0].model = '';
      }
    }
    scope.typeProcedureName = function () {
      scope.isPriceDropDown = false;
      scope.isSelectedGov = false;
    };
    scope.removeGovPackage = function (data) {
      if (data) {
        angular.forEach(scope.govPackageData, function (value, index) {
          if (value.packageId === data.packageId || value.packageName === data.packageName) {
            scope.govPackageData.splice(index, 1);
          }
        });

        scope.newClmamount = scope.totalGovClaimAmount();
      }
    };
    scope.noOfDays = 1;
    scope.totalGovClaimAmount = function () {
      scope.totalCalcAmount = 0;
      angular.forEach(scope.govPackageData, function (data, index) {
        if (data.packageCost) {
          if (data.isPerDayEligiblePackage === true) {
            var oneDay = 24 * 60 * 60 * 1000;
            var noOfDays = Math.round(Math.abs((UtilitiesService.getDateObjNew(scope.dataobj.tentativeDOD).getTime() - UtilitiesService.getDateObjNew(scope.dataobj.doa).getTime()) / (oneDay)));
            scope.noOfDays = noOfDays;
            var isPerDayEligiblePrice = 0;
            if (noOfDays === 0) {
              isPerDayEligiblePrice = parseInt(data.packageCost)
              scope.noOfDays = 1;
            } else
              isPerDayEligiblePrice = parseInt(data.packageCost) * (noOfDays)
            scope.totalCalcAmount = scope.totalCalcAmount + isPerDayEligiblePrice;
          } else
            scope.totalCalcAmount = scope.totalCalcAmount + parseInt(data.packageCost);
        }
      });
      return scope.totalCalcAmount;
    };
    scope.ApprovalRelatedMethods = (function () {
      //scope.approve.approvedAmount = parseInt(scope.dataobj.claimedAmnt);
      return {
        relatedData: function () {
          var data = {
            "claimId": scope.dataobj.claimId,
            "status": scope.dataobj.status === 'Enhance Submitted' ? 'Enhance Approved' : scope.dataobj.status === 'Enhance Info-Submitted' ? 'Enhance Approved' : 'Approved',
            "approvedAmount": parseInt(scope.approve.approvedAmount),
            "comments": scope.approve.comments,
            "createdBy": UserService.getUserObj().userId,
            "BCPcode": scope.approve.BCPcode,
            "schemeName":scope.dataobj.schemeName
          };
          return data;
        },
        submitApproval: function () {
          ClaimActionService.govtClaimAction(this.relatedData())
            .then(submitApprovalSuccess, submitApprovalError);
        },
        cancelApproval: function () {
          safeApply(scope);
          scope.govActionApproalForm.$setPristine();
          // if (scope.approve) {
          //   angular.forEach(Object.keys(scope.approve), function (e, i) {
          //     scope.approve[e] = null;
          //   });
          // }
          scope.approve = {};
        }
      };

      function submitApprovalSuccess(resData) {
        if (resData && resData.data && resData.data.isSuccess) {
          scope.asubmitted = true;
          scope.asubsuccess = true;
          //scope.$apply();
        }
      }

      function submitApprovalError() {
        scope.esubmitted = true;
        scope.esubsuccess = false;
      }
    })();
    scope.IARelatedMethods = (function () {
      scope.ia = {};
      return {
        relatedData: function () {
          var data = {
            "claimId": scope.dataobj.claimId,
            "status": scope.dataobj.status === 'Enhance Submitted' ? 'Enhance Info-Awaited' : 'Information Awaited',
            "comments": scope.ia.comments,
            "fileNames": scope.ia.missingfiles,
            "createdBy": UserService.getUserObj().userId,
            "schemeName":scope.dataobj.schemeName
          };
          return data;
        },
        submitIA: function () {
          ClaimActionService.govtClaimAction(this.relatedData())
            .then(submitIASuccess, submitIAError);
        }
      };

      function submitIASuccess(resData) {
        scope.iasubmitted = true;
        scope.iasubsuccess = true;
      }

      function submitIAError() {
        scope.iasubmitted = true;
        scope.iasubsuccess = false;
      }
    })();
    // documents submitted by hospital in response to IA
    scope.submitMissingRelatedMethods = (function () {
      scope.ir = {};
      return {
        submitIr: function () {
          scope.fileUploadRelatedMethods.uploadFiles(function (fileUploadData) {
            if (fileUploadData[0].data.isSuccess) {
              
              ClaimActionService.govtClaimActionIr(this.relatedData())
                .then(submitIrSuccess, submitIrError);
            } else {
              scope.msg = UtilitiesService.getMessasgeObj('red', 'Files could not be uploaded please try again', 'Error', true);
            }
          });
        },
        submitSc: function () {
          scope.btnSubmitflag = true;
          scope.fileUploadRelatedMethods.uploadFiles(function (fileUploadData) {
            if (fileUploadData[0].data.isSuccess) {
              ClaimActionService.govtClaimActionSc(this.relatedDataForSc())
                .then(submitIrSuccess, submitIrError);
            } else {
              scope.msg = UtilitiesService.getMessasgeObj('red', 'Files could not be uploaded please try again', 'Error', true);
            }
          });

        },
        submitEa: function () {
          if (scope.newClmamount) {
            scope.btnSubmitflag = true;
            scope.fileUploadRelatedMethods.uploadFiles(function (fileUploadData) {
              if (fileUploadData[0].data.isSuccess) {
                ClaimActionService.govtClaimActionEa(this.relatedDataForEa())
                  .then(submitIrSuccess, submitIrError);
              } else {
                scope.msg = UtilitiesService.getMessasgeObj('red', 'Files could not be uploaded please try again', 'Error', true);
              }
            });
          } else {
            scope.msg = UtilitiesService.getMessasgeObj('red', 'Please enter amount.', 'Error', true);
          }
        },
        submitEIA: function () {
          scope.fileUploadRelatedMethods.uploadFiles(function (fileUploadData) {
            if (fileUploadData[0].data.isSuccess) {
              ClaimActionService.govtClaimActionEIA(this.relatedDataForEIA())
                .then(submitIrSuccess, submitIrError);
            } else {
              scope.msg = UtilitiesService.getMessasgeObj('red', 'Files could not be uploaded please try again', 'Error', true);
            }
          });
        },
        relatedData: function () {
          var data = {
            hospId: UserService.getHospitalObj().hospId,
            claimId: scope.dataobj.claimId,
            CreatedBy: UserService.getUserObj().userId,
            fileNames: scope.form.fileNames,
            govtSchemeType: $rootScope.govSchemeName,
            statusId: scope.dataobj.statusId,
            schemeName:scope.dataobj.schemeName
          };
          return data;
        },
        relatedDataForSc: function () {
          var data = {
            hospId: UserService.getUserObj().entityId,
            claimId: scope.dataobj.claimId,
            CreatedBy: UserService.getUserObj().userId,
            clmamount: 0,
            fileUploadFolderPath: scope.form.fileUploadFolderPath.join(),
            fileNames: scope.form.fileNames,
            govtSchemeType: $rootScope.govSchemeName,
            schemeName:scope.dataobj.schemeName
          };
          return data;
        },
        relatedDataForEa: function () {
          scope.packageIDs = [];
          scope.govPackageData.map(function (item) {
            if (item.packageId != '') {
              scope.packageIDs.push(item.packageId);
            }
          })
          var data = {
            dod:scope.enhance.dod,
            doa:scope.enhance.doa,
            hospId: UserService.getUserObj().entityId,
            claimId: scope.dataobj.claimId,
            CreatedBy: UserService.getUserObj().userId,
            clmamount: scope.newClmamount,
            fileNames: scope.form.fileNames,
            packageIds: scope.packageIDs,
            schemeName:scope.dataobj.schemeName
          };
          return data;
        },
        relatedDataForEIA: function () {
          var data = {
            hospId: UserService.getUserObj().entityId,
            claimId: scope.dataobj.claimId,
            CreatedBy: UserService.getUserObj().userId,
            status: 'Enhance Info-Submitted',
            fileNames: scope.form.fileNames,
            govtSchemeName:scope.dataobj.schemeName
          };
          return data;
        }
      };

      function submitIrSuccess() {
        scope.msubmitted = true;
        scope.msubsuccess = true;
      }

      function submitIrError() {
        scope.msubmitted = true;
        scope.msubsuccess = false;
      }
    })();
    //test
    scope.test = function () {
      var url = UtilitiesService + '/hosp/file/DMSupload';
      var data = {
        "file": scope.myFile
      };
      $http.post(url, data).then(function (success) {
        UtilitiesService.showAlertMessage("Success", true);
      }, function (error) {
        UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
      });
    };
    scope.file = [];
    scope.addFileToUpload = function () {
      var newItemNo = scope.file.length + 1;
      scope.file.push({
        'model': ''
      });
    };
    scope.removeFileToUpload = function () {
      var lastItem = scope.file.length - 1;
      scope.file.splice(lastItem);
      scope.validLargeDoc = false;
    };
    scope.getInt = function (value) {
      return parseInt(value);
    };
    scope.addFileToUpload();
    angular.element(document).ready(function () {});
  }]);

angular.module('mbplus')
.controller('footerCtrl', ['$rootScope', '$scope', function ($rootScope, scope) {
    scope.ctrlName = "footerCtrl";
  $rootScope.$on('signedin', function (event, args) {
    if (args && args === true) {
      scope.showFooter = true;
    } else {
      scope.showFooter = false;
    }
  });
}]);
// angular.module('mbplus')
// .controller('angularTabsCtrl', ['$rootScope', '$scope', 'UserService', '$location', '$log', 'UtilitiesService', '$http', '$timeout', '$filter',
//     'FileUploadService', 'ClaimActionService', 'NewAdmissionFormService', 'filterFilter', 'blockUI', 'PlusUtilitiesService',
//     '$state', 'ClaimActionService', '$q', function (rootScope, scope, UserService, $location, $log, UtilitiesService, $http, $timeout, filter, FileUploadService, ClaimActionService, NewAdmissionFormService, filterFilter, blockUI, PlusUtilitiesService, state, ClaimActionService, $q) {
//         scope.ctrlName = "tabCtrl";
//         scope.blockUIState = blockUI.state();
//         scope.tab1show = true;
//         scope.showAllAppointments = true;
//         scope.form = {};
//         scope.compareDate = UtilitiesService.compareDate;
//         scope.formatTime = UtilitiesService.formatTime;
//         scope.getDateObj = UtilitiesService.getDateObj;
//         scope.getDDMMYYYY = UtilitiesService.getDDMMYYYY;
//         scope.formatCurrency = UtilitiesService.formatCurrency;
//         scope.downloadUrl = UtilitiesService.getDMSHostUrl();
//         scope.DMSUrl = UtilitiesService.getDMSHostUrl();
//         scope.tabsData = [];
//         scope.discharge = {
//             doa: '',
//             dod: '',
//             roomrent: '',
//             investigation: '',
//             consultation: '',
//             pharmacy: '',
//             pkgname: '',
//             pkgcost: '',
//             others: '',
//             total: '',
//             remarks:''
//         }
//         scope.user = UserService.getUserObj();
//         if (!scope.user) {
//             UserService.destroyUserObj();
//             $location.path('/');
//         }

//         scope.open2 = function () {
//             scope.popup2.opened = true;
//         };
//         scope.open1 = function () {
//             scope.popup1.opened = true;
//         };
//         scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
//         scope.format = scope.formats[0];
//         scope.altInputFormats = ['M!/d!/yyyy'];

//         scope.popup2 = {
//             opened: false
//         };
//         scope.popup1 = {
//             opened: false
//         };
//         scope.isCmsUser = false;
//         scope.currentStatusId = "";
//         scope.financeLogin = false;
//         scope.managerLogin = false;
//         scope.isInsurerAction = false;
//         scope.medibizProviderId = 158749;
//         scope.pharmaProviderId = 72326;

//         if (scope.user.rolesFeatures.roles.length == 1) {
//             angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
//                 if (v.roleId == 9205) {
//                     scope.financeLogin = true;
//                 } else if (v.roleId == 9204) {
//                     scope.managerLogin = true;
//                     scope.financeLogin = false;
//                     return;
//                 } else if (v.roleId == 9207 || v.roleId == 9211 || v.roleId == 9214 || v.roleId == 9217) {  //insurer admin -- insurer-agent -- insurer branch  -- insurer-ma-report
//                     scope.isInsurerAction = true;
//                 } else if (v.roleId === 9216) {
//                     scope.isCmsUser = true;
//                 }
//             })
//         }
//         scope.isInsurer = true;
//         angular.forEach(scope.user && scope.user.rolesFeatures.roles, function (v, i) {
//             if (v.roleId == 9207 || v.roleId == 9211 || v.roleId == 9214) {
//                 scope.isInsurer = false;
//             }
//         });
//         angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {

//         });
//         angular.forEach(scope.user && scope.user.rolesFeatures.roles, function (v, i) {
//             if (v.roleId == 9204) {
//                 scope.managerLogin = true;
//             }
//         });
//         scope.tabs = [{ title: scope.tabname, content: 0 }],
//         selected = null,
//         previous = null;
//         scope.selectedIndex = 0;
//         scope.selectedAppointmentsIndex = 0;
//         scope.user = UserService.getUserObj();
//         scope.user = { role: '' };
//         if (UserService.getUserObj()) {
//             scope.userRoles = UserService.getUserObj().rolesFeatures.roles;
//             if (scope.userRoles.length > 1) {
//                 angular.forEach(scope.userRoles, function (value, key) {
//                     if (value.roleName === 'cms') {
//                         scope.user.role = 'CMS';
//                     }
//                 });
//             } else {
//                 scope.user.role = scope.userRoles[0].roleName === 'cms' ? 'CMS' : '';
//             }
//         }
//         if (UserService.getUserObj()) {
//             scope.username = UserService.toTitleCase(UserService.getUserObj().userName ? UserService.getUserObj().userName : UserService.getUserObj().firstName);
//         }
//         scope.totalItems = scope.preauthfiltered == undefined ? 50 : scope.preauthfiltered.length;
//         scope.pagination = {
//             currentPage: 1
//         }
//         scope.currentPage = 1;
//         scope.pagination.currentPage = 1;
//         scope.itemsPerPage = 10;
//         scope.maxSize = 5;
//         scope.file = {};
//         scope.search = 'All';
//         scope.userRole = UserService.displayThis;
//         scope.getToUpperCase = UtilitiesService.getToUpperCase;
//         scope.getToLowerCase = UtilitiesService.getToLowerCase;
//         scope.getAge = UtilitiesService.getAge;
//         scope.contracts = PlusUtilitiesService.getContracts();

//         scope.$watch('preauthfiltered', function (current, old) {
//             if (current != old) {
//                 scope.preauthfilteredStatusFiltered = _.uniq(scope.preauthfiltered);
//                 scope.totalItems = scope.preauthfilteredStatusFiltered.length;
//             }
//         });

//         //Call controller function
//         scope.pageChanged = function (value, type) {
//             if (type === true) {

//                 scope.someCtrlFn({ arg: value });
//             } else if (type === false) {
//                 scope.currentPage = value;
//                 scope.pagination.currentPage = 1;
//             }
//         };

//         scope.calcDischargeTotal = function (term) {
//             scope.discharge.total = 0;
//             var inv = scope.discharge.investigation ? parseInt(scope.discharge.investigation) : 0;
//             var pharmacy = scope.discharge.pharmacy ? parseInt(scope.discharge.pharmacy) : 0;
//             var room = scope.discharge.roomrent ? parseInt(scope.discharge.roomrent) : 0;
//             var consult = scope.discharge.consultation ? parseInt(scope.discharge.consultation) : 0;
//             var others = scope.discharge.others ? parseInt(scope.discharge.others) : 0;
//             var pkgcost = scope.discharge.pkgcost ? parseInt(scope.discharge.pkgcost) : 0;

//             scope.discharge.total = inv + pharmacy + room + consult + others + pkgcost;
//         }

//         scope.changeIndex = function (index) {
//             scope.selectedIndex = index;
//         };
//         scope.$watch('selectedIndex', function (current, old) {
//             if (current !== old) {
//                 if (current === 0) {
//                     scope.tab1show = true;
//                 }
//                 else {
//                     scope.tab1show = false;
//                     //scope.addTab(scope.tabs[current].content, '', scope.tabs[current].title);
//                 }
//                 previous = selected;
//                 selected = scope.tabs[current];
//             } else {
//             }
//         });
//         scope.$watch('selectedAppointmentsIndex', function (current, old) {
//             if (current != old) {
//                 if (current == 0) {
//                     scope.tab1show = true;
//                 }
//                 else {
//                     scope.tab1show = false;
//                 }
//                 previous = selected;
//                 selected = scope.tabs[current];
//             } else {
//             }
//         });
//         scope.form = {};
//         scope.isFlag = {
//             btnSubmitflag: false
//         };
//         scope.fileUploadRelatedMethods = (function () {
//             scope.form = {}
//             scope.form.fileNames = [];
//             scope.form.fileUploadFolderPath = [];
//             return {
//                 uploadFiles: function (source, callback) {
//                     scope.form.fileNames = [];
//                     scope.form.fileUploadFolderPath = [];
//                     var fileBlobArray = [];
//                     var filesUploadingArray = [];
//                     Object.keys(scope.file).forEach(function (ele) {
//                         if (typeof (scope.file[ele].model) == "object") {
//                             filesUploadingArray.push(scope.file[ele].model);
//                         }
//                     });
//                     if (filesUploadingArray.length > 0) {
//                         fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
//                         scope.btnSubmitflag = true;
//                         scope.isFlag.btnSubmitflag = true;
//                     }
//                     else if (source === 'iRrelatedMethods' || source === 'dischargeRelatedMethods' || source === 'enhancementRelatedMethods') {
//                         scope.btnSubmitflag = false;
//                         scope.isFlag.btnSubmitflag = false;
//                         alert('Please attach atleast one document.');
//                         return false;
//                     }
//                     $q.all(fileBlobArray).then(function (result) {
//                         scope.form.finalFilesData = [];
//                         result.forEach(function (element) {
//                             if (element.data.isSuccess) {
//                                 angular.forEach(element.data.uploadResponseDetails, function (e, i) {
//                                     scope.form.finalFilesData.push({ fileName: e.fileName, docPath: e.downloadURL });
//                                     scope.form.fileNames.push(e.fileName);
//                                     scope.form.fileUploadFolderPath.push(e.downloadURL);
//                                 });
//                             }
//                             else {
//                                 scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
//                                 return false;
//                             }
//                             scope.file = [];
//                         });
//                         if (result && (filesUploadingArray.length == 0 || scope.form.fileNames.length == result[0].data.uploadResponseDetails.length))
//                             switch (source) {
//                                 case 'iRrelatedMethods':
//                                     callback.call(scope.iRrelatedMethods);
//                                     break;
//                                 case 'dischargeRelatedMethods':
//                                     callback.call(scope.dischargeRelatedMethods);
//                                     break;
//                                 case 'enhancementRelatedMethods':
//                                     callback.call(scope.enhancementRelatedMethods)
//                                     break;
//                             }
//                     },
//                     function (error) {
//                         scope.file = [];
//                         scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
//                     })
//                 },
//                 addFiles: function () {
//                     scope.fileCountObj.push({ "name": 'myfile' + (scope.fileCountObj.length + 1) });
//                 },
//                 removeFiles: function (index) {
//                     if (scope.fileCountObj.length > 1) {
//                         scope.fileCountObj.splice(index, 1)
//                     }

//                 }

//             }
//             function fileUploadSuccess(successData) {
//                 if (successData.data.isSuccess) {
//                     scope.form.fileNames.push(successData.data.uploadResponseDetails[0].fileName);
//                     scope.form.fileUploadFolderPath.push(successData.data.uploadResponseDetails[0].downloadURL)
//                     UtilitiesService.showAlertMessage('File uploaded successfully.');
//                 }
//             }
//             function fileUploadError(errordata) {
//                 aUtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
//             }
//         })();

//         scope.enhance = {
//             amount: '',
//             remarks: '',
//             comment: ''
//         }
//         scope.openIrModal = function () {
//             scope.isFlag.btnSubmitflag = false;
//             scope.enhance.comment = '';
//             angular.element("#submitMissing").modal('show');
//         };

//         scope.openEnhanceModal = function () {
//             scope.btnSubmitflag = false;
//             scope.enhance.amount = '';
//             scope.enhance.remarks = '';
//             angular.element("#enhanceModal").modal('show');
//         };
//         scope.openDischargeModal = function () {
//             scope.isFlag.btnSubmitflag = false;
//             angular.element("#dischargeModal").modal('show');
//         };
//         scope.file = [];
//         scope.addFileToUpload = function () {
//             var newItemNo = scope.file.length + 1;
//             scope.file.push({
//                 'model': ''
//             });
//         };
//         scope.removeFileToUpload = function () {
//             var lastItem = scope.file.length - 1;
//             scope.file.splice(lastItem);
//             scope.validLargeDoc = false;
//         };
//         //scope.addFileToUpload();

//         //scope.submitDischarge = function () {
//         //    scope.fileUploadRelatedMethods.uploadFiles("dischargeRelatedMethods", function () {
//         //        ClaimActionService.submitDischarge(this.relatedData()).then(dischargeSubmitSuccess, dischargeSubmitError)
//         //    });
//         //};

//         scope.submitIr = function () {
//             scope.fileUploadRelatedMethods.uploadFiles('iRrelatedMethods', function () {
//                 var ajxData = {
//                     parentId: scope.claimNoData.id,
//                     remarks: scope.enhance.comment,
//                     actionBy: UserService.getUserObj().userId,
//                     attachedFiles: scope.form.finalFilesData
//                 }
//                 UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tpa/infosubmit', ajxData, 'POST').then(function (response) {
//                     angular.element("#submitMissing").modal('hide');
//                     if (response.data.isSuccess) {
//                         UtilitiesService.showAlertMessage('Your documents submitted successfully.', true);
//                     } else {
//                         UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
//                     }
//                 }, function (error) {
//                     angular.element("#submitMissing").modal('hide');
//                     UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
//                 });
//             });

//         };

//         //POST Enhancement Request
//         scope.submitEnhance = function () {
//             scope.fileUploadRelatedMethods.uploadFiles('enhancementRelatedMethods', function () {
//                 var ajxData = {
//                     parentId: scope.claimNoData.id,
//                     claimAmount: scope.enhance.amount,
//                     remarks: scope.enhance.remarks,
//                     actionBy: UserService.getUserObj().userId,
//                     attachedFiles: scope.form.finalFilesData
//                 }
//                 UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tpa/enhancement', ajxData, 'POST').then(function (response) {
//                     angular.element("#enhanceModal").modal('hide');
//                     if (response.data.isSuccess) {
//                         UtilitiesService.showAlertMessage('Your enhancement request has been submitted successfully.', true);
//                     } else {
//                         UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
//                     }
//                 }, function (error) {
//                     angular.element("#enhanceModal").modal('hide');
//                     UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
//                 });
//             });
//         };

//         //POST Enhancement Request
//         scope.submitDischarge = function () {
//             scope.fileUploadRelatedMethods.uploadFiles('dischargeRelatedMethods', function () {
//                 var ajxData = {
//                     parentId: scope.claimNoData.id,
//                     dischargeNotes: scope.discharge.remarks,
//                     actionBy: UserService.getUserObj().userId,
//                     attachedFiles: scope.form.finalFilesData,
//                     doa: scope.discharge.doa,
//                     dod: scope.discharge.dod,
//                     roomRentCharges: scope.discharge.roomrent,
//                     diagnosticCharges: scope.discharge.investigation,
//                     professionalCharges: scope.discharge.consultation,
//                     pharmacyCharges: scope.discharge.pharmacy,
//                     otherCharges: scope.discharge.others,
//                     finalClaimedAmount: scope.discharge.total
//                 }
//                 UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tpa/dischargedocs', ajxData, 'POST').then(function (response) {
//                     angular.element("#dischargeModal").modal('hide');
//                     if (response.data.isSuccess) {
//                         UtilitiesService.showAlertMessage('Your discharge request has been submitted successfully.', true);
//                     } else {
//                         UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
//                     }
//                 }, function (error) {
//                     angular.element("#dischargeModal").modal('hide');
//                     UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
//                 });
//             });
//         };

//         //Add new tab
//         scope.addTab = function (claimNo, view, patientName, item) {
//             scope.claimNoData = item;
//             if (item.status !== 'New Admission' && item.status !== 'Denied') {
//                 UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/tpa/claimaudittrail/' + claimNo + '', '', 'GET').then(function (response) {
//                     if (response.data.isSuccess) {
//                         scope.claimSearhByClaimIdResults = response.data.claimAuditTrailData;
//                         var length = scope.claimSearhByClaimIdResults.length;
//                         scope.statusData = scope.claimSearhByClaimIdResults[length - 1];
//                         scope.documents = [];
//                         angular.forEach(scope.claimSearhByClaimIdResults, function (data, index) {
//                             if (data.documents && data.documents.length > 0) {
//                                 angular.forEach(data.documents, function (value, index1) {
//                                     scope.documents.push({ docPath: value.docPath, fileName: value.fileName });
//                                 })

//                             }
//                         });
//                         scope.tabsData.push(response.data.claimAuditTrailData);
//                         scope.openTab(patientName, view, false);
//                     } else {
//                         UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
//                     }
//                 }, function (error) {
//                     UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
//                 });
//             } else {
//                 if (item.status === 'Denied') {

//                 } else if (item.status === 'New Admission') {
//                     UtilitiesService.showAlertMessage('Dear customer,we have received your claim and have started processing it.\n\n You will see more details here shortly.', true);
//                 }
//             }
//         };


//         scope.openTab = function (title, view, showTab) {
//             scope.tab1show = showTab;
//             view = view || title + " Content View";
//             scope.tabs.push({ title: title, content: view });
//             scope.tabs[scope.tabs.length - 1].active = true;
//             scope.selectedIndex = scope.tabs.length - 1;
//         };

//         scope.removeTab = function (tab) {
//             if (tab > 0) {
//                 scope.tabs.splice(tab, 1);
//                 scope.tabsData.splice(tab - 1, 1);
//                 scope.selectedIndex = scope.selectedIndex > 0 ? scope.selectedIndex - 1 : scope.selectedIndex;
//                 scope.tabs[scope.selectedIndex].active = true;
//             }
//         };

//         scope.getPatientDetails = function () {
//             return details = {
//                 name: scope.name,
//                 requestId: scope.id,
//                 indexNo: scope.tabs.length - 1
//             }
//         }
//         scope.res = {};
//         scope.resId = "";
//         scope.showPostToPharma = false;
//     }]);



angular.module('mbplus')
.controller('apptPatientDetailCtrl', ['$rootScope', '$scope', 'UtilitiesService', 'FileUploadService', '$q', 'PlusUtilitiesService', 'UserService', function ($rootScope, scope, UtilitiesService, FileUploadService, $q, PlusUtilitiesService, UserService) {
    scope.patientDetails = scope.patientDetail;
    scope.apptDetails = scope.appointmentDetail;
    scope.pharmaDetails = scope.pharmaDetails;
    scope.visitType = scope.visitType;
    scope.statusHistory = scope.statusHistory;
    if (scope.visitType) {
        scope.isPharma = (scope.visitType.productType === 10307 || scope.visitType.productType === 10390) ? true : false;
        scope.isInfiniti = UtilitiesService.isReturnFlag([10386, 10389, 10401, 10845, 10846, 10847], scope.visitType.productType);
    }
    scope.disabledPostToPharma = false;
    if (scope.visitType) {
        scope.isVisitType = scope.visitType.visitType === 'Home_Visit' ? true : false;

    }
    if (scope.statusHistory && scope.statusHistory.length > 0) {
        scope.isPostToPharma = _.first(scope.statusHistory).statusId === 115 || _.first(scope.statusHistory).statusId === 22;
    }
    scope.isZivaRequest = false;
    if(scope.visitType && scope.visitType.productType === 9786){
        scope.isZivaRequest = true;
    }
    scope.getDateObj = function (inputDate) {
        if (!inputDate || inputDate === "/Date(-62135596800000-0000)/") 
            return '--'
        if (inputDate) {
            var d = new Date(parseInt(inputDate.replace("/Date(", "").replace(")/", ""), 10))
            return new Date(d);
        }
    },
      scope.formatCurr = UtilitiesService.formatCurrency;
    scope.isStatus115Or22 = false;
    scope.showPharmaPres = false;
    scope.file = [];
    scope.user = UserService.getUserObj();
    scope.dcLogin = false;
    scope.list = [];
    if (scope.user && scope.user.rolesFeatures) {
        angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
            scope.list.push(v.roleId);
            if (v.roleId == 5432) {
                scope.dcLogin = true;
            }
        });
    }

    scope.newlyUploadedDocs = [];
    if (scope.apptDetails && scope.apptDetails.statusHistory && scope.apptDetails.statusHistory.length > 0) {
        scope.isStatus115Or22 = scope.apptDetails.statusHistory.map(function (e) {
            if (e.statusId == 115 || e.statusId == 22)
                return true;
            else
                return false;
        });
        scope.isStatus115Or22 = scope.isStatus115Or22.indexOf(true) > -1 ? true : false;
    }
    if (scope.pharmaDetails && scope.pharmaDetails.PharmaOrderPrescriptionFiles) {
        scope.showPharmaPres = true;
    } else {
        scope.showPharmaPres = false;
    }

    if (scope.pharmaDetails && scope.pharmaDetails.PharmaOrderPrescriptionFiles) {
        scope.pharmaDetailsPrescriptions = JSON.parse(scope.pharmaDetails.PharmaOrderPrescriptionFiles);
        scope.PharmaPrescription = [];
        angular.forEach(scope.pharmaDetailsPrescriptions, function (val, i) {
            scope.PharmaPrescription.push({
                filePath: val,
                fileName: UtilitiesService.getFileNameFromPath(val)
            });
        });
    }
    scope.getIdForRelatedReq = function () {
        scope.$parent.appointmentMethods.addRelatedAppointmentsTab();
    }
    scope.openUploadPresModal = function () {
        scope.open = true;
        scope.fileUploadMethods.addFileToUpload();
    };
    scope.openVarifyPresModal = function () {
        scope.$parent.openVarifyPresModal(scope.PharmaPrescription);

    }

    scope.closeFileUpload = function (isShow) {
        scope.open = false;
        scope.uploadMethods.clearFileModels(isShow);
    };
    scope. showPatientDetailsAdditionals = function() {
        scope.$parent.appointmentMethods.patientDetailsAdditionals(scope.patientDetails.additionals);        
    }
    scope.saveUploadedUrl = function (urls) {
        scope.UrlList = urls;
        if (scope.UrlList) {
            scope.finalUrl = [];
            angular.forEach(urls, function (v, i) {
                var setUrl = v.filePath + "/" + v.fileName;
                scope.finalUrl.push(setUrl);
            })
            var data = {
                requestId: scope.patientDetails.requestId,
                updatePrescriptionURLs: scope.finalUrl
            }
            var url = UtilitiesService.getPlusUrlPrefix() + 'UploadPharmaCashlessPrescription/';
            UserService.makeRestCall(url, data, 'POST', UserService.getAccessToken()).then(function (response) {
                if (response.data) {
                    scope.uploadedIsSuccess = response.data
                    UtilitiesService.showAlertMessage('Files uploaded successfully.', true);
                }
            },
            function (error) {
                UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            })
        }
    };
    scope.postToPharma = function () {
        scope.disabledPostToPharma = true;
        if (scope.uploadedIsSuccess == true) {
            var data = {
                RequestId: scope.patientDetails.requestId
            }
            var url = UtilitiesService.getPlusUrlPrefix() + '/requestPharmaOrder';
            UserService.makeRestCall(url, data, 'POST', UserService.getAccessToken()).then(function (response) {
                if (response.data) {
                    UtilitiesService.showAlertMessage("Your order is placed to the partner.", true);
                    scope.getPatientDetail = scope.$parent.getPatientDetails();
                    scope.$parent.appointmentMethods.removeAppointmentTab(scope.getPatientDetail.indexNo);
                    scope.$parent.appointmentMethods.addAppointmentsTab(scope.getPatientDetail.name, scope.getPatientDetail.requestId, "");
                    //refresh tab
                } else {
                    UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                }
            },
            function (error) {
                UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            })
        }
        else {
            UtilitiesService.showAlertMessage('Please upload prescription.');
        }
    };
    scope.isUpload = false;
    scope.uploadMethods = (function () {
        return {
            upload: function () {
                scope.IsFileGrter = false;
                var fileBlobArray = [];
                var filesUploadingArray = [];
                scope.isUpload = true;
                Object.keys(scope.file).forEach(function (ele) {
                    if (typeof (scope.file[ele].model) == "object") {
                        filesUploadingArray.push(scope.file[ele].model);
                    }
                });
                angular.forEach(filesUploadingArray, function (v, i) {
                    var fileSize = v.size;
                    if (fileSize > 10485760) {
                        scope.IsFileGrter = true;
                    }
                })
                if (filesUploadingArray.length > 0) {
                    if (!scope.IsFileGrter) {
                        fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrlPrefix() + "/File"));
                    } else {
                        //UtilitiesService.showAlertMessage('File size is greater then 10 MB.');
                        alert('File size is greater then 10 MB.');
                        scope.isUpload = false;
                    }
                }
                else {
                    UtilitiesService.showAlertMessage('Please attach atleast one document.');
                    return false;
                }
                if (!scope.IsFileGrter) {
                    $q.all(fileBlobArray).then(function (result) {
                        if (typeof result == "object" && typeof result[0].data == "object") {
                            scope.isFileUploaded = true;
                            for (var property in result[0].data) {
                                if (result[0].data.hasOwnProperty(property) && property !== "00000000000000000000000000000000") {
                                    var obj = {};
                                    scope.isUpload = false;
                                    obj.fileName = result[0].data[property];
                                    obj.filePath = UtilitiesService.getDownloadURL() + property;
                                    scope.PharmaPrescription.push(obj);
                                    scope.newlyUploadedDocs.push(obj);

                                } else {
                                    scope.isFileUploaded = false;
                                }
                            }
                            if (scope.isFileUploaded) {
                                scope.saveUploadedUrl(scope.newlyUploadedDocs);
                                scope.disabledPostToPharma = false;
                                scope.closeFileUpload(true);
                            } else {
                                UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                                scope.closeFileUpload(true);
                            }
                        }
                        else {
                            UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                            return false;
                        }
                    },
                    function (error) {
                        UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
                    });
                }
            },
            clearFileModels: function (isShow) {
                if (!isShow)
                    scope.newlyUploadedDocs = [];
                scope.file = [];
                scope.fileUploadMethods.addFileToUpload();
            }
        };
    })();
    
    scope.getIdZivaReq = function(){
       scope.$parent.appointmentMethods.getIdZivaReq();
    };

    scope.redirectToIsecure = function (id) {
        // window.location.href = "https://partners.docsapp.in/#!login";
         window.open(
             'https://partners.docsapp.in/#!cases?applicationId='+id,
             '_blank' // <- This is what makes it open in a new window.
           );
     };

    scope.fileUploadMethods = (function () {
        return {
            addFileToUpload: function (flag) {
                var newItemNo = scope.file.length + 1;
                scope.file.push({
                    'model': ''
                });
            },
            removeFileToUpload: function (index) {
                scope.file.splice(index, 1);
            }
        };
    })();
}]);
angular.module('mbplus')
.controller('apptStatusHistoryCtrl', ['$scope', 'UtilitiesService', 'UserService', 'FileUploadService', '$q', 'filterFilter', function (scope, UtilitiesService, UserService, FileUploadService, q, filterFilter) {

    scope.compareDate = UtilitiesService.compareDate;
    scope.allChildren = UtilitiesService.getAllChildren();
    scope.formatTime = UtilitiesService.formatTime;
    scope.apptHistory = scope.appointmentHistory;
    var requestId = scope.reqId;
    if (scope.apptHistory && scope.apptHistory.additionals && scope.apptHistory.additionals.additionals) {
        scope.doctorQualification = scope.apptHistory.additionals.additionals.doctorQualification ? scope.apptHistory.additionals.additionals.doctorQualification : 'Not selected';
    }
    scope.user = UserService.getUserObj();
    scope.isCorresPondenceForDc = true;
    scope.showCalender = false;
    scope.shwView = true;
    scope.isClick = false;
    scope.isZiva = false;

    scope.zivaCordination = {
        sessionNote:'',
        recommendation: ''
    }

    scope.uicDetail = {
        uicNumber: ''
    }

    //date time
    scope.callDateTime = {
        prefDate: '',
        prefTime: ''
    }

    scope.popup6 = {
        opened: false
    };
    scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    scope.format = scope.formats[0];
    scope.altInputFormats = ['M!/d!/yyyy'];
    scope.open6 = function () {
        scope.popup6.opened = true;
    };
    scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 1
    };
    scope.mindate = new Date();
    scope.hstep = 1;
    scope.mstep = 1;
    //date time

    if (scope.user && scope.user.entityType == 'DC') {
        scope.isCorresPondenceForDc = false;
        if (scope.apptHistory && scope.apptHistory.statusHistory) {
            scope.apptHistory.statusHistory = filterFilter(scope.appointmentHistory.statusHistory, { 'providerId': scope.allChildren }, function (actual, expected) {
                return filterFilter(expected, { 'id': actual }).length > 0;
            });
        }
    }
    scope.isCheckRole = function () {
        var result = true;
        if (scope.user && scope.user.rolesFeatures.roles.length > 0) {
            angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
                if (v.roleId == 9207 || v.roleId == 9211 || v.roleId == 9214) {
                    return result = false;;
                }
            })
        }
        if (result) {
            return result;
        }
    }
    scope.isCommunication = true;
    if (scope.user && scope.user.entityType === 'Insurer') {
        scope.isCommunication = false;
    }
    scope.isShowUploadedReport = true;
    scope.isInsurerReportStatus = [];
    if (scope.apptHistory && scope.apptHistory.statusHistory) {
        scope.isInsurerReportStatus = filterFilter(scope.appointmentHistory.statusHistory, { statusId: 48 });
        if (scope.isInsurerReportStatus.length == 0 ) {
            scope.isInsurerReportStatus = filterFilter(scope.appointmentHistory.statusHistory, { statusId: 122 });
        }
    }
    if (scope.isCommunication) {
        scope.isShowUploadedReport = true;
    } else {
        if (scope.isInsurerReportStatus.length > 0) {
            scope.isShowUploadedReport = true;
        } else {
            scope.isShowUploadedReport = false;
        }
    }

    scope.downloadURL = UtilitiesService.getPlusUrl();
    scope.file = [];
    scope.newlyUploadedDocs = [];

    scope.action = {};
    scope.action.cortypeId = 71; // already hard coaded in allappointments 

    scope.pharmaDetails = scope.pharmaDetails;
    if (scope.pharmaDetails) {
        scope.pharmaDetailsMedicineRemarks = typeof scope.pharmaDetails.remarks == "string" ? scope.pharmaDetails.remarks : JSON.parse(scope.pharmaDetails.remarks);
        scope.PharmaMedicines = [];
        if (scope.pharmaDetailsMedicineRemarks !== '' && typeof scope.pharmaDetailsMedicineRemarks == 'string') {
            scope.pharmaDetailsMedicineRemarks = scope.pharmaDetailsMedicineRemarks.split(',');
            if (scope.pharmaDetailsMedicineRemarks.length > 1) {
                angular.forEach(scope.pharmaDetailsMedicineRemarks, function (v, i) {
                    scope.PharmaMedicines.push({
                        name: v.split('|')[0],
                        qty: v.split('|')[1]
                    });
                })
            } else {
                scope.pharmaDetailsMedicineRemarks = scope.pharmaDetailsMedicineRemarks[0].split('|')
                scope.PharmaMedicines.push({
                    name: scope.pharmaDetailsMedicineRemarks[0],
                    qty: scope.pharmaDetailsMedicineRemarks[1]
                });
            }
        }
    };
    scope.getDownloadLinks = function (collection, property) {
        var res = [];
        var downloadUrl = "https://www.medibuddy.in/WAPI/GetFile/"
        if (property)
            res.push({
                link: downloadUrl + property,
                name: collection[property]
            });
        else
            angular.forEach(Object.keys(collection), function (ele) {
                res.push({
                    link: downloadUrl + ele,
                    name: collection[ele]
                });
            });
        return res;
    };
    if (
        scope.apptHistory &&
        scope.apptHistory.statusHistory &&
        scope.apptHistory.statusHistory.length > 0
    ) {
        scope.apptHistory.statusHistory.map(function (e) {
            if (
                e.attachedFiles &&
                e.attachedFiles.bills &&
                Object.keys(e.attachedFiles.bills).length > 0
            ) {
                e.attachedFiles.attachmentsBill = [];
                e.attachedFiles.attachmentsReports = [];
                e.attachedFiles.correspondenceReports = [];
                if (typeof e.attachedFiles.bills == "object") {
                    if (Object.keys(e.attachedFiles.bills).length > 1) {
                        e.attachedFiles.attachmentsBill = scope.getDownloadLinks(
                            e.attachedFiles.bills
                        );
                    } else {
                        e.attachedFiles.attachmentsBill = scope.getDownloadLinks(
                            e.attachedFiles.bills,
                            Object.keys(e.attachedFiles.bills)[0]
                        );
                    }
                }
            }
            if (
                e.attachedFiles &&
                e.attachedFiles.reports &&
                Object.keys(e.attachedFiles.reports).length > 0
            ) {
                if (typeof e.attachedFiles.reports == "object") {
                    if (Object.keys(e.attachedFiles.reports).length > 1) {
                        e.attachedFiles.attachmentsReports = scope.getDownloadLinks(
                            e.attachedFiles.reports
                        );
                    } else {
                        e.attachedFiles.attachmentsReports = scope.getDownloadLinks(
                            e.attachedFiles.reports,
                            Object.keys(e.attachedFiles.reports)[0]
                        );
                    }
                }
            }
            if (e.correspondences && e.correspondences.length > 0) {
                angular.forEach(e.correspondences, function (v, i) {
                    if (typeof e.correspondences[i] == "object") {
                        if (
                            v.attachFiles.correspondencereports &&
                            Object.keys(v.attachFiles.correspondencereports).length > 0
                        ) {
                            e.attachedFiles.correspondenceReports = scope.getDownloadLinks(
                                v.attachFiles.correspondencereports
                            );
                        }
                    }
                });
            }
        });
    }
    scope.openModal = function (reqFlowId) {
        scope.action.rfid = reqFlowId;
        if (!scope.calltypes) {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'MediMarketLookUp/calltype', '', 'GET').then(function (response) {
                if (response.data.isSuccess) {
                    scope.calltypes = response.data.results;
                }
            });
        }
    };

    scope.getCallstatuses = function (id) {
        scope.action.rfid = id;
        if (!scope.callstatuses) {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'MediMarketLookUp/callstatus', '', 'GET').then(function (response) {
                if (response.data.isSuccess) {
                    scope.callstatuses = response.data.results;
                    scope.open = true;
                }
            });
        }
    };

    scope.downloadFromUrl = function (url, data) {
        UserService.viewFile(url, null, null, data).then(function (fileUrl) {
        }),function(err) {
            console.log(err)
        }
    }

    scope.addCorrespondence = function (reqFlowId) {
        var data = {
            requestId: requestId,
            requestFlowId: reqFlowId,
            comment: scope.action.corrremarks,
            callType: scope.action.calltype.key,
            callStatus: scope.action.callstatus.key,
            createdOn: Date.now(),
            correspondenceType: 71,
            attachFiles: {
                correspondencereports: scope.fileUploadData.files
            },
            additionalInfo: {
                callbackdate: scope.PrefcallDateTime,
                uicnumber: scope.uicDetail.uicNumber ? scope.uicDetail.uicNumber : '',
                zivaCordination : JSON.stringify(scope.zivaCordination)
            },
            createdBy: UserService.getUserObj().userId
        }
        data.additionalInfo.From = 'Active';
        UserService.makeRestCall(UtilitiesService.getProviderMediBuddyUrl() + 'v1/request/generic/addCorrespondenceToRequest', data, 'POST', UserService.getAccessToken()).then(function (response) {
            if (response.data.data.isSuccess) {
                UtilitiesService.showAlertMessage('Correspondence added successfully.', true);
                scope.open = false;
                scope.featureToShow('close', '', scope.isShowTable);
            }
            else {
                UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            }
        });
    };
    scope.addCorrespond = function (reqFlowId) {
        scope.addCorrespondence(reqFlowId);
    };
    scope.fileUploadData = {
        files : {}
    }
    scope.storeFiles =[];

    scope.downloadAttachment = function (obj) {
        if (obj) {
            window.open(
              UtilitiesService.getDownloadURL(true) + obj,
              '_blank'
            );
        }
    };

    scope.removeFiles = function(item){
        if(item){
            delete scope.fileUploadData.files[item.filePath];
            angular.forEach(scope.storeFiles, function(value, index){
                 if(value.fileName === item.fileName){
                    scope.storeFiles.splice(value, 1);
                }
            });
        }
    };

    scope.fileFn = function(data){
        if (data) {
            for (var key in data)
                scope.fileUploadData.files[key] = data[key];
            // angular.extend(scope.fileUploadData.files, data)
            angular.forEach(data, function(value, index){
                scope.storeFiles.push({ fileName: value, filePath: index});
            });
        }
    };

    scope.uploadMethods = (function () {
        return {
            upload: function (callback) {
                var fileBlobArray = [];
                var filesUploadingArray = [];
                Object.keys(scope.file).forEach(function (ele) {
                    if (typeof (scope.file[ele].model) == "object") {
                        filesUploadingArray.push(scope.file[ele].model);
                    }
                });
                if (filesUploadingArray.length > 0) {
                    fileBlobArray.push(FileUploadService.uploadImages(filesUploadingArray, UtilitiesService.getPlusUrlPrefix() + "/File.json"));
                }
                else {
                    callback.call(scope.addCorrespondence);
                    return false;
                }
                q.all(fileBlobArray).then(function (result) {
                    if (typeof result == "object" && typeof result[0].data == "object") {
                        for (var property in result[0].data) {
                            if (result[0].data.hasOwnProperty(property)) {
                                var obj = {};
                                obj.fileName = result[0].data[property];
                                obj.filePath = UtilitiesService.getDownloadURL(true) + property;
                                scope.newlyUploadedDocs.push(obj);
                            }
                        }
                        if (result && scope.newlyUploadedDocs && scope.newlyUploadedDocs.length > 0)
                            callback.call(scope.addCorrespondence, result[0].data);
                    }
                    else {
                        UtilitiesService.showAlertMessage('Upload fail.');
                        return false;
                    }
                });
            },
            clearFileModels: function (isShow) {
                if (!isShow)
                    scope.newlyUploadedDocs = [];
                scope.file = [];
                scope.fileUploadMethods.addFileToUpload();
            }
        };
    })();

    scope.featureToShow = function (value, id, index) {
        scope.fileUploadData.files = {};
        scope.storeFiles =[];
        scope.zivaCordination.sessionNote = '';
        scope.zivaCordination.recommendation = '';
        scope.uicDetail.uicNumber = '';
        scope.isShowTable = index;
        scope.showCalender = false;
        scope.action.calltype = '';
        scope.action.callstatus = '';
        scope.action.corrremarks = '';
        if (value === 'view') {
            scope.shwView = false;
            scope.isClick = true;
        } else if (value === 'add') {
            scope.shwView = false;
            scope.showCorrespondence = true;
            scope.openModal(id);
            scope.getCallstatuses(id);
        } else if ('close') {
            scope.showCorrespondence = false;
            scope.isClick = false;
            scope.shwView = true;
            if (scope.user && scope.user.entityType == 'Insurer') {
                scope.isView = false;
            }
        }
    };
    scope.isView = true;
    scope.isDownload = function(){
        var isDownloadReport = true;
        angular.forEach(scope.user && scope.user.rolesFeatures.roles, function (v, i) {
            if (v.roleId === 9211 || v.roleId === 9214) {
                isDownloadReport = false;
            }
        });
        return isDownloadReport;
    };

    if (scope.user && scope.user.entityType == 'Insurer') {
        scope.isCorresPondenceForDc = false;
    }
   
    scope.fileUploadMethods = (function () {
        return {
            addFileToUpload: function (flag) {
                var newItemNo = scope.file.length + 1;
                scope.file.push({
                    'model': ''
                });
            },
            removeFileToUpload: function (index) {
                scope.file.splice(index, 1);
            }
        };
    })();
    scope.getCommunication = function (requestFlowId) {
        scope.$parent.getCommunication(requestFlowId);
    }

    scope.getDateTime = function (date, time) {
        scope.PrefcallDateTime = UtilitiesService.mergeDateTimeObj(date, time);
    }


    scope.showDateTime = function (callstatus) {
        if (callstatus.key === '73' || callstatus.key === '74' || callstatus.key === '86' || callstatus.key === '96' || callstatus.key === '144' || callstatus.key === '187') {
            scope.showCalender = true;
            scope.isZiva = false;
        } else if( callstatus.key === '193'){
            scope.zivaCordination.recommendation = '';
            scope.zivaCordination.sessionNote = '';

            scope.isZiva = true;
            scope.showCalender = false;
        }else {
            scope.showCalender = false;
            scope.isZiva = false;
        }
        scope.callDateTime = {
            prefDate: '',
            prefTime: ''
        }
    }
}]);
angular.module('mbplus')
.controller('apptEssentialsCtrl', ['$rootScope', '$scope', 'UtilitiesService', 'FileUploadService', '$q', 'PlusUtilitiesService', 'UserService', 'filterFilter', function ($rootScope, scope, UtilitiesService, FileUploadService, $q, PlusUtilitiesService, UserService, filterFilter) {
    scope.patientEssentials = scope.apptEssentials;
    scope.apptHistoryDetails = scope.appointmentHistory;
    scope.apptDetails = scope.appointmentDetail;
    scope.visitTypeData = scope.visitType;
    scope.isFlag = {
        dnd: true,
        DNDCustomer: true
    }
    if (scope.patientEssentials && scope.patientEssentials.additionals) {
        scope.isFlag.dnd = scope.patientEssentials.additionals.DND === 'true' ? false : true;
        scope.patientEssentials.additionals.DND = !scope.isFlag.dnd;
        scope.isFlag.DNDCustomer = scope.patientEssentials.additionals.DNDCustomer === 'true' ? false : true;
        scope.patientEssentials.additionals.DNDCustomer = !scope.isFlag.DNDCustomer;
    }
    scope.user = UserService.getUserObj();
    if (scope.user && scope.user.entityId) {
        scope.isPriority = scope.user.entityId === 1000042 ? true : false;
    }
    scope.isPharma = false;
    scope.showSplitRequest = false;
    scope.actionColors = {
        "Create": "glyphicon glyphicon-plus",
        "MACancel": "glyphicon glyphicon-remove-sign",
        "UserCancel": "glyphicon glyphicon-minus-sign",
        "Confirm": "glyphicon glyphicon-ok",
        "Reschedule": "glyphicon glyphicon-calendar",
        "Cancel": "glyphicon glyphicon-remove",
        "Submit": "glyphicon glyphicon-paperclip",
        "Attended": "glyphicon glyphicon-ok",
        "NotAttended": "glyphicon glyphicon-remove",
        "Raise_IA": "glyphicon glyphicon-bullhorn",
        "Approve": "glyphicon glyphicon-ok",
        "notattended": "glyphicon glyphicon-glyphicon-off",
        "Fit": "glyphicon glyphicon-thumbs-up",
        "UnFit": "glyphicon glyphicon-thumbs-down",
        "SwitchDC": "glyphicon glyphicon-plus",
        "Reschedule": "glyphicon glyphicon-calendar",
        "UnApprovedNewAppointment": "glyphicon glyphicon-plus",
        "Raise_IA": "glyphicon glyphicon-bullhorn",
        "QCApprove": "glyphicon glyphicon-ok",
        "Split Request": "glyphicon glyphicon-scissors",
        "PartiallyAttended": "fa fa-hourglass-half",
        "PlaceWithPartner": "fa fa-cart-plus",
        "OutForDelivery": "fa fa-truck",
        "Delivered": "fa fa-paper-plane",
        "ConfirmByRetailer": "fa fa-check-square-o"
    };

    scope.statusTextColors = {
        22: "text-success",
        23: "text-success",
        24: "text-success",
        25: "text-success",
        26: "text-danger",
        27: "text-danger",
        28: "text-danger",
        29: "text-warning",
        30: "text-warning",
        31: "text-warning",
        32: "text-success",
        33: "text-warning",
        34: "text-success",
        35: "text-danger",
        36: "text-success",
        37: "text-success",
        38: "text-warning",
        39: "text-danger",
        40: "text-warning",
        41: "text-warning",
        42: "text-warning",
        43: "text-danger",
        49: "text-success",
        112: "text-warning",
        113: "text-danger",
        116: "text-warning",
        91: "text-warning",
        87: "text-success",
        88: "text-info",
        89: "text-success"
    }

    scope.checkIfDc = function () {
        var dcRole = null;
        var result = false;
        if (scope.user && scope.user.rolesFeatures && scope.user.rolesFeatures.roles) {
            dcRole = scope.user.rolesFeatures.roles.find(function (elem) {
                return ((elem.roleName.substring(0, 2)) == 'DC')
            })
            result = dcRole ? true : false;
            if (result && $rootScope.toggleMenuObj && $rootScope.toggleMenuObj.isMultiRole) {
                return ($rootScope.toggleMenuObj.isDcRoleActive ? true : false);
            }
            else {
                return result;
            }
        }
    }

    scope.priorityId = scope.patientEssentials ? (scope.patientEssentials.priorityId ? scope.patientEssentials.priorityId : "") : "";
    scope.user = UserService.getUserObj();
    scope.currentStatusId = scope.apptDetails ? (scope.apptDetails.statusHistory[0].statusId ? scope.apptDetails.statusHistory[0].statusId : "") : "";
    if (scope.patientEssentials && scope.patientEssentials.productType == PlusUtilitiesService.getDC_MA_PRE_EMP_ContractID()) {
        scope.showFitOptionByProduct = true;
    }
    scope.dcLogin = false;
    scope.insurerLogin = false;
    scope.rolesList = [];
    if (scope.user && scope.user.rolesFeatures.roles) {
        angular.forEach(scope.user.rolesFeatures.roles, function (v, i) {
            if (v.roleId == 5432 || v.roleId == 5433 || v.roleId == 5434) { //opt enable for dc login
                scope.dcLogin = true;
                scope.showWalletBalance = false
            }
            scope.rolesList.push(v.roleId);
        });
    }

    scope.RoleInsurer = [9207, 9211, 9214, 9217, 9209, 9203, 5445]; // only view access
    if (filterFilter(scope.RoleInsurer, scope.rolesList, true).length < 1) {
        scope.insurerLogin = true;
    }
    scope.RoleQcOps = [9208, 5445]; // Adding and view access
    if (filterFilter(scope.RoleInsurer, scope.RoleQcOps, true).length < 1) {
        scope.insurerLogin = false;
    }

    scope.showReportsOption = false;
    scope.digitalMEROption = false;
    if (scope.apptHistoryDetails) {
        angular.forEach(scope.apptHistoryDetails.statusHistory, function (v, i) {
            if (v.statusId === 32) {
                scope.showFitOption = true
            }
            if (v.statusId === 48) {
                scope.showReportsOption = true;
            }
            if (v.statusId === 23 || v.statusId === 24 || v.statusId === 25 || v.statusId === 40 || v.statusId === 32 || v.statusId === 37 || v.statusId === 48) {
                scope.digitalMEROption = true;
            }
            if (v.statusId == 22 || v.statusId == 23 || v.statusId == 24 || v.statusId == 40 || v.statusId == 116) {
                scope.showSplitRequest = true;
            }
        })
    }
    if ((scope.apptHistoryDetails) && (scope.apptHistoryDetails.productType == 10307 || scope.apptHistoryDetails.productType == 10390)) {
        scope.showWalletBalance = true
    }
    if (scope.patientEssentials && (scope.patientEssentials.previousID == 0) && PlusUtilitiesService.getAllowedSplitContracts().indexOf(scope.patientEssentials.productType.toString()) != -1) {
        scope.showSplitRequest = true;
    }
    if (scope.visitTypeData) {
        scope.isPharma = (scope.visitTypeData.productType === 10307 || scope.visitTypeData.productType === 10390) && (scope.apptHistoryDetails.statusHistory[0].statusId === 22 || scope.apptHistoryDetails.statusHistory[0].statusId === 115) ? true : false;
        scope.packageType = scope.visitTypeData.isPaid === true ? 'Paid' : 'Sponsored';
    }
    scope.custId = scope.patientEssentials ? (scope.patientEssentials.id ? scope.patientEssentials.id : "") : "";
    scope.openActionModal = function (getActionName, currentStatusId, actionStatusId, requestId, appointmentDate, secondAppointmentDate, orderItemProductId) {
        scope.$parent.openActionModal(getActionName, currentStatusId, actionStatusId, requestId, appointmentDate, secondAppointmentDate, orderItemProductId, scope.visitTypeData);
    };
    scope.openSplitRequestMethod = function (productId, id, providerId, providerName, appointmentDate, visitType) {
        scope.$parent.openSplitRequestMethod(productId, id, providerId, providerName, appointmentDate, visitType);
    };
    scope.markUrgentHni = function (marked) {
        var hniUrgentValue = "";
        hniUrgentValue = marked == 2 ? 2 : (marked == 1 ? 1 : (marked == 0 ? 0 : null));
        if (hniUrgentValue != null) {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "MarkPriorityForRequest/" + scope.patientEssentials.id + '/' + hniUrgentValue + ".json", "", "get", UserService.getAccessToken(), true).then(function (response) {
                if (response.data) {
                    var successMsz = (hniUrgentValue == 2 ? "HNI Marked" : (hniUrgentValue == 1 ? "Urgent Marked" : (hniUrgentValue == 0 ? "None Marked" : "")));
                    UtilitiesService.showAlertMessage(successMsz, true);
                }
            });
        }
    };

    scope.rescheduleJson = {
        reason: '',
        dndType: ''
    };

    scope.dnd = function (status, type) {
      var request = scope.apptEssentials;
      if (status === 'reOpen' || status === 'close' && request) {
          var data = {
              requestID: request.id,
              EsalesId : request.esalesId,
              dndInfo: {
                  DNDReason: status === 'reOpen' ? '' : scope.rescheduleJson.reason,
                  DND: type === 'DND' ? !request.additionals.DND : request.additionals.DND,
                  DNDCustomer: false
              }
          };
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'MarkDNDForRequest', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
            angular.element('#dndReason').modal('hide');
            scope.rescheduleJson.reason = '';
            if (response.data.isSuccess) {
                  if (scope.isFlag.dnd) {      
                      scope.isFlag.dnd = false;
                      UtilitiesService.showAlertMessage('DND service activated successfully.', true);
                  } else {
                      scope.isFlag.dnd = true;                    
                      UtilitiesService.showAlertMessage('DND service deactivated successfully.', true); 
                  }                
              } else {
                  UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
              }            
          }, function (error) {
              angular.element('#dndReason').modal('hide');
              scope.rescheduleJson.reason = '';
              UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          });
      } else if (status === 'open') {
          scope.rescheduleJson.reason = '';
          angular.element('#dndReason').appendTo('body');
          angular.element('#dndReason').modal('show');
      }
  };
 
  scope.dndCustomer = function (status, dndType) {
      var request = scope.apptEssentials;
      if (status === 'reOpen' || status === 'close' && request) {
          var data = {
              requestID: request.id,
              EsalesId : request.esalesId,
              dndInfo: {
                  DNDReason: status === 'reOpen' ? '' : scope.rescheduleJson.reason,
                  DND: false,
                  DNDCustomer: dndType === 'Customer' ? !request.additionals.DNDCustomer : request.additionals.DNDCustomer
              }
          };
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'MarkDNDForRequest', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
            angular.element('#dndReasonCustomer').modal('hide');
            scope.rescheduleJson.reason = '';
            if (response.data.isSuccess) {
                  if (scope.isFlag.DNDCustomer) {
                      scope.isFlag.DNDCustomer = false;
                      UtilitiesService.showAlertMessage('DND service activated successfully.', true);
                  } else {
                      scope.isFlag.DNDCustomer = true;
                      UtilitiesService.showAlertMessage('DND service deactivated successfully.', true);
                  }
              } else {
                  UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
              }
          }, function (error) {
              angular.element('#dndReasonCustomer').modal('hide');                
              scope.rescheduleJson.reason = '';
              UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
          });
      } else if (status === 'open') {
          scope.rescheduleJson.reason = '';
          angular.element('#dndReasonCustomer').appendTo('body');
          angular.element('#dndReasonCustomer').modal('show');
      }
  };

    scope.getPackageTestDetails = function () {
        var productId = scope.patientEssentials.productId ? scope.patientEssentials.productId : "";
        if (productId) {
            scope.$parent.getPackageTestDetails(productId);
        }
        else {
            UtilitiesService.showAlertMessage("Product Id unavailable.");
            scope.$parent.getPackageTestDetails(productId, 'noProductId');
        }
    };
    scope.getWalletBalance = function () {
        var maid = scope.patientEssentials ? (scope.patientEssentials.maid ? scope.patientEssentials.maid : "") : "";
        if (maid) {
            scope.walletBalance = "";
            var url = UtilitiesService.getPlusUrlPrefix() + "CheckWalletBalanceRequest/" + maid + ".json"
            UserService.makeRestCall(url, '', 'get', UserService.getAccessToken(), true).then(function (response) {
                if (response.data.status == true) {
                    scope.$parent.showWalletBalance(response.data.availableValue, true);
                }
                if (response.data.status == false) {
                    scope.$parent.showWalletBalance("Unable to get balance try after sometime.", false);
                }
            }, function (error) {
                scope.$parent.showWalletBalance("Unable to get balance try after sometime.", false);
                UtilitiesService.showAlertMessage('Oops! something went wrong, please try again later.');
            });
        }
        else {
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        }
    };

    scope.getCommunication = function (requestId, testId) {
        scope.$parent.getCommunication(requestId, testId);
    }
    scope.clearGrievanceModal = function () {
        scope.$parent.clearGrievanceModal(scope.apptHistoryDetails.additionals.additionals);
    }


}]);
angular.module('mbplus')
.controller('aarogyaFormNewCtrl', ['$scope', '$location', '$state', '$timeout', 'UserService', 'UtilitiesService', 'filterFilter', '$uibModal', 'FastrackService', 'GovernmentService', 'NewAdmissionFormService', 'FileUploadService', '$analytics', '$q', 'blockUI', function (scope, $location, state, timeout, UserService, UtilitiesService, filterFilter, $uibModal, FastrackService, GovernmentService, NewAdmissionFormService, FileUploadService, $analytics, $q, blockUI) {

    $analytics.pageTrack('/newAdmission/aarogya');
    //Variable
    scope.blockUIState = blockUI.state();
    scope.isEBill = UtilitiesService.checkEBillHospital(UserService.getHospitalObj().hospId);
    scope.form = {};
    scope.form.fileNames = [];
    scope.form.fileUploadFolderPath = [];
    scope.isECashLess = false;
    scope.eCashLessMessage = '';
    scope.doctorDetails = [];
    scope.roomsDetails = [];
    scope.file = [];

    scope.getRoomsDetails = function () {
        var ajaxData = { hospId: UserService.getHospitalObj().hospId, getDoctors: false, getRooms: true, getOpPackages: false, getContracts: false };
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/hospProfileDetails', ajaxData, 'POST').then(function (response) {
            if (response.data.isSuccess) {
                scope.roomsDetails = response.data.hospRoomDetails;
            }
        }, function (error) {
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
        });
    };

    scope.getDoctorDetails = function () {
        var ajaxData = { hospId: UserService.getHospitalObj().hospId, getDoctors: true, getRooms: true, getOpPackages: false, getContracts: false };
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/hospProfileDetails.json', ajaxData, 'POST').then(function (response) {
            if (response.data.isSuccess) {
                scope.doctorDetails = response.data.hospDoctorDetails;
                scope.getRoomsDetails();
            }
        }, function (error) {
            scope.doctorDetails = [];
            UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
            scope.getRoomsDetails();
        });
    };
    scope.getDoctorDetails();

    scope.fastrackPreauth = function (type) {
        angular.element('#myModal').modal('show');
        scope.fastrack = {};
        scope.fastrack.displaySubmit = true;
        if (type === 'aarogya') {
            scope.fastrack.title = "Aarogya Scheme";
            scope.aarogyachecked = true;
            scope.fastrack.showCorpName = false;
            scope.fastrack.employerSearchTitle = 'Family Number';
        }
        if (scope.aarogyachecked) {
            scope.fastrack.corporateName = 'Manipal';
        }
    };

    scope.getDetailsWithMaid = function (maid, benefName) {
        if (maid && benefName) {
            var data = { hospId: UserService.getHospitalObj().hospId, maid: maid, beneficiaryName: benefName }
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails', data, 'POST').
                then(function (response) {
                    if (response.data.isSuccess) {
                        scope.fastrack.displaySubmit = false;
                        scope.fastrack.error = false;
                        scope.fastrack.name = response.data.benefs.name;
                        scope.fastrack.relations = response.data.relations;
                        scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
                    }
                    else {
                        scope.fastrack.error = true;
                        scope.fastrack.errorMessage = response.data.errorMessage;
                    }
                }, function (error) {
                    scope.fastrack.error = true;
                    scope.fastrack.errorMessage = "No data found";
                });
        }
    };

    scope.getDetailsWithEmpId = function (empid, corpname, benefname) {
        if (empid && corpname && benefname) {
            var data = { hospId: UserService.getHospitalObj().hospId, employeeId: empid, corporateName: corpname, BeneficiaryName: benefname }
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails', data, 'POST').
                then(function (response) {
                    if (response.data.isSuccess) {
                        scope.fastrack.displaySubmit = false;
                        scope.fastrack.error = false;
                        scope.fastrack.name = response.data.benefs.benefName;
                        scope.fastrack.relations = response.data.relations;
                        scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
                    }
                    else {
                        scope.fastrack.error = true;
                        scope.fastrack.errorMessage = response.data.errorMessage;
                    }
                }, function (error) {
                    scope.fastrack.error = true;
                    scope.fastrack.errorMessage = "No data found";
                });
        }
    };

    scope.getDetailsWithPolicy = function (policyno, benefname) {
        if (policyno && benefname) {
            var data = {
                hospId: UserService.getHospitalObj().hospId,
                PolicyNo: policyno,
                BeneficiaryName: benefname
            }
            UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getEcardWithPolicyNo', data, 'POST').
                then(function (response) {
                    if (response.data.isSuccess) {
                        scope.fastrack.displaySubmit = false;
                        scope.fastrack.error = false;
                        scope.fastrack.name = response.data.benefs.benefName;
                        scope.fastrack.relations = response.data.relations;
                        scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
                    }
                    else {
                        scope.fastrack.error = true;
                        scope.fastrack.errorMessage = response.data.errorMessage;
                    }
                }, function (error) {
                    scope.fastrack.error = true;
                    scope.fastrack.errorMessage = "No data found";
                });
        }
    };

    scope.fastrackPopulateNewAdmission = function (maid, relationid, name, eCashLess) {
        if (eCashLess.eCashlessReqId === 0) {
            FastrackService.fastrackPopulateNewAdmission(maid, relationid, name).
                then(function (response) {
                    if (response.data.isSuccess) {
                        scope.$parent.tempData = response.data.benefs;
                        scope.form = {};
                        scope.form.fileNames = [];
                        scope.form.fileUploadFolderPath = [];
                        scope.form.fullname = response.data.benefs.benefName;   //generic
                        scope.form.roomtype = 'General ward';
                        scope.form.familyno = response.data.benefs.priBenefEmpCode;
                        scope.form.employer = response.data.benefs.benefPolHldrName;
                        scope.form.empid = response.data.benefs.priBenefEmpCode;
                        scope.form.maid = response.data.benefs.benefMediAssistID;
                        scope.form.policyno = scope.fastrack.PolicyNo;
                        scope.form.memberAge = response.data.benefs.benefAge;
                        scope.form.gender = response.data.benefs.benefSex;
                        angular.element("#myModal").modal('hide');
                        scope.form.PribenefRemainingBsi = response.data.benefs.pribenefRemainingBsi;
                    }
                    else {
                        scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network Error', 'Error', true);
                    }
                }, function (response) {
                    scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network Upload Error', 'Error', true);
                });
        } else {
            scope.isECashLess = true;
            scope.eCashLessMessage = 'There is already a pre-approved request that exists for the patient. Redirecting you to the request. Click yes to continue.';
            timeout(function () {
                scope.$apply(function () {
                    scope.isECashLess = false;
                    scope.eCashLessMessage = '';
                });
            }, 10000);
        }
    };

    scope.clearfastrack = function () {
        scope.fastrack = {};
        scope.fastrack.displaySubmit = true;
        scope.fastrack.title = 'Member Search';
        scope.aarogyachecked = false;
        scope.fastrack.showCorpName = true;
        scope.fastrack.employerSearchTitle = 'Employee ID';
    };

    scope.removeModal = function () {
        this.clearfastrack();
        angular.element("#myModal").modal('hide');
    };

    scope.reDirect = function (value) {
        if (value) {
            angular.element("#newPreauthModal").modal('hide');
            state.go(value, { reload: false });
        }
    };

    scope.onSelect = function ($item, $model, $label) {
        if ($item) {
            scope.form.packageName = $item.packageName;
            scope.form.packageAmount = $item.packageCost;
            scope.form.packageUniqueId = $item.packageId;
            scope.form.cappedAmount = $item.cappedAmount;
        }
    };

    scope.getGovtPackageListSuccess = function (resData) {
        if (resData && resData.data.isSuccess && resData.data.packages && resData.data.packages.length > 0) {
            scope.govtPackageList = resData.data.packages;
            UserService.setGovtPackageList(scope.govtPackageList);
        }
        else {
            if (resData.data.isSuccess === false) {
                scope.govtPackageList = [];
                UserService.setGovtPackageList(scope.govtPackageList);
            }
        }
    };

    scope.getGovtPackageListError = function (resData) {
        scope.govtPackageList = [];
    };

    scope.getGovtPackageList = function () {
        if (UserService.getGovtPackageList()) {
            scope.govtPackageList = UserService.getGovtPackageList();
            scope.showGovtPackages = true;
        }
        else {
            GovernmentService.getGovtPackageList().then(scope.getGovtPackageListSuccess, scope.getGovtPackageListError);
        }
    };
    scope.getGovtPackageList();

    scope.changePackageField = function () {
        scope.showAutoPackages = scope.form.reasonOnline === 'others' ? false : true;
    };

    scope.removePackageAarogya = function (id) {
        for (var i = id; i < scope.selectedPackages.length - 1; i++) {
            scope.selectedPackages[i] = scope.selectedPackages[i + 1];
            scope.selectedPackages[i].id--;
        }
        scope.selectedPackages.pop(scope.selectedPackages.length - 1);
        scope.packageCalcAmount = 0;
        for (var i = 0; i < scope.selectedPackages.length; i++) {
            scope.packageCalcAmount = scope.packageCalcAmount + scope.selectedPackages[i].amount;
        }
    };

    scope.addPackageButtonAarogya = function () {
        scope.showAutoPackages = true;
        scope.selectedPackages = [];
        if (scope.selectedPackages.length < 3) {
            if (scope.showAutoPackages) {
                if (scope.form.packageName && scope.form.packageName.length > 0) {
                    scope.selectedPackages.push({
                        id: scope.selectedPackages.length,
                        uniqueId: scope.form.packageUniqueId,
                        name: scope.form.packageName,
                        amount: scope.form.packageAmount,
                        cappedAmount: scope.form.cappedAmount
                    });
                    scope.form.packageName = '';
                }
                else {
                    UtilitiesService.showAlertMessage('Please select a package.');
                }
            }
            else {
                if (scope.form.mPackageName && scope.form.mPackageName.length > 0) {
                    scope.selectedPackages.push({
                        id: scope.selectedPackages.length,
                        uniqueId: 0,
                        name: scope.form.mPackageName,
                        amount: scope.form.mPackageAmount
                    });
                    scope.form.mPackageName = '';
                    scope.form.mPackageAmount = '';
                }
                else {
                    UtilitiesService.showAlertMessage('Please enter a package name manually.');
                }
            }
            scope.packageCalcAmount = 0;
            for (var i = 0; i < scope.selectedPackages.length; i++) {
                scope.packageCalcAmount = scope.packageCalcAmount + parseInt(scope.selectedPackages[i].amount);
            }
            $("#aarogyaPackageAmountHolder").val(scope.packageCalcAmount);
            scope.form.clmamount = scope.packageCalcAmount;
        }
        else {
            UtilitiesService.showAlertMessage('Maximum of 3 packages allowed.');
        }
    };

    scope.submitPreauthFormError = function (ErrorData) {
        UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
    };

    scope.submitPreauthFormSuccess = function (successData) {
        if (successData.data.isSuccess) {
            scope.form.preauthSuccess = true;
        }
        else {
            scope.form.preauthError = true;
        }
    };

    scope.closePreauthForm = function () {
        scope.form = {};
        //$location.path('/');
    };

    scope.getPreauthFormData = function (form) {
        scope.selectedPackages = scope.selectedPackages.map(function (item) {
            return {
                PackageName: item.name,
                PackageAmount: item.amount,
                PackageCappedAmount: item.cappedAmount,
                PackageId: item.uniqueId
            };
        });
        var data = {
            applicationName: 'Hospital Portal',
            packagesList: scope.selectedPackages,
            fileNames: form.fileNames,
            filePath: form.fileUploadFolderPath,
            fileUploadFolderPath: form.fileUploadFolderPath,
            plannedHospId: 0,
            patientFirstName: form.fullname,
            ContactNum: form.mobile,
            EmpId: form.empid,
            Employer: form.employer,
            Maid: form.maid,
            Doa: form.doa,
            ApproxClaimedAmnt: scope.packageCalcAmount,
            DocName: form.docname,
            Diagnosis: form.diagnosis,
            AdmissionType: form.admissiontype,
            RoomType: form.roomtype,
            TentativeDOD: form.dod,
            ipNumber: form.ipnumber,
            HospId: UserService.getHospitalObj().hospId,
            HospName: UserService.getHospitalObj().hospName,
            createdBy: UserService.getUserObj().userId,
            uiD_NO: form.uidno
        };
        return data;
    };

    scope.uploadFiles = function (callback) {
        scope.form.fileNames = [];
        scope.form.fileUploadFolderPath = [];
        if (scope.preAuthFile) {
            Object.keys(scope.preAuthFile).forEach(function (e) {
                if (typeof (scope.preAuthFile[e]) == 'object') {
                    scope.file.push({
                        'model': scope.preAuthFile[e]
                    });
                }
            });
        }
        var fileBlobArray = [];
        var filesUploadingArray = [];
        Object.keys(scope.file).forEach(function (ele) {
            if (typeof (scope.file[ele].model) == "object") {
                filesUploadingArray.push(scope.file[ele].model);
            }
        });
        if (filesUploadingArray.length > 0) {
            fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
        }
        else {
            UtilitiesService.showAlertMessage('Please attach atleast one document.');
            return false;
        }
        $q.all(fileBlobArray).then(function (result) {
            result.forEach(function (element) {
                if (element.data.isSuccess) {
                    angular.forEach(element.data.uploadResponseDetails, function (e, i) {
                        scope.form.fileNames.push(e.fileName);
                        scope.form.fileUploadFolderPath.push(e.downloadURL);
                    });
                }
                else {
                    scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                    return false;
                }
            });
            if (result && (filesUploadingArray.length == 0 || scope.form.fileNames.length == result[0].data.uploadResponseDetails.length))
                callback.call(scope.preauthFormAction);
        },
        function (error) {
            scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
        });
    };

    scope.submitPreauthForm = function () {
        this.uploadFiles(function () {
            NewAdmissionFormService.submitAarogyaPreauthForm(scope.getPreauthFormData(scope.form)).
                           then(scope.submitPreauthFormSuccess, scope.submitPreauthFormError);
        });
        window.scroll(0, 0);
    };

    scope.preauthFormAction = (function () {
        scope.username = UserService.getUserObj().userName;
        function fileUploadSuccess(successData) {
            if (successData.data.isSuccess) {
                scope.form.fileNames.push(successData.data.uploadResponseDetails[0].fileName);
                scope.form.fileUploadFolderPath.push(successData.data.uploadResponseDetails[0].downloadURL);
                scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Success', 'Success', true);
            }
        }
        function fileUploadError(errordata) {
            scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'FileUpload Error', 'Error', true);
        }
    })();

    scope.addFileToUpload = function (flag) {
        var newItemNo = scope.file.length + 1;
        scope.file.push({
            'model': ''
        });
    };
    scope.addFileToUpload();

    scope.removeFileToUpload = function () {
        var lastItem = scope.file.length - 1;
        scope.file.splice(lastItem);
        scope.validLargeDoc = false;
    };


}]);
angular.module("mbplus")
.controller('apptCreationMapController', ['$scope', function (scope) {
   
}]);
angular.module('mbplus')
.controller('aarogyaFormCtrl', ['$scope', '$location','$state', '$timeout', 'UserService', 'UtilitiesService', 'filterFilter', '$uibModal', 'FastrackService', 'GovernmentService', 'NewAdmissionFormService', 'FileUploadService', '$analytics', '$q', 'blockUI', function (scope, $location,state, timeout, UserService, UtilitiesService, filterFilter, $uibModal, FastrackService, GovernmentService, NewAdmissionFormService, FileUploadService, $analytics, $q, blockUI) {
    $analytics.pageTrack('/newAdmission/aarogya');
    scope.ctrlName = "aarogyaFormCtrl";
    scope.blockUIState = blockUI.state();
    scope.isEBill = UtilitiesService.checkEBillHospital(UserService.getHospitalObj().hospId);
    scope.form = {};
    scope.form.fileNames = [];
    scope.form.fileUploadFolderPath = [];
    scope.isECashLess = false;
    scope.eCashLessMessage = '';

    scope.doctorDetails = [];
    scope.roomsDetails = [];

    scope.getRoomsDetails = function () {
        var ajaxData = { hospId: UserService.getHospitalObj().hospId, getDoctors: false, getRooms: true, getOpPackages: false, getContracts: false };
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/hospProfileDetails.json', ajaxData, 'POST').then(function (response) {
            if (response.data.isSuccess) {
                scope.roomsDetails = response.data.hospRoomDetails;
            }
        }, function (error) {
            scope.roomsDetails = [];
        });
    };
    scope.getDoctorDetails = function () {
        var ajaxData = { hospId: UserService.getHospitalObj().hospId, getDoctors: true, getRooms: true, getOpPackages: false, getContracts: false };
        UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/hospProfileDetails.json', ajaxData, 'POST').then(function (response) {
            if (response.data.isSuccess) {
                scope.doctorDetails = response.data.hospDoctorDetails;
                scope.getRoomsDetails();
            }
        }, function (error) {
            scope.doctorDetails = [];
            scope.getRoomsDetails();
        });
    };
    scope.getDoctorDetails();
    scope.govtChecked = function () {
        scope.form.packageAmount = '';
    };

    scope.fastrackMethods = function () {
        return {
            fastrackPreauth: function (type) {
                angular.element("#myModal").modal("show");
                scope.fastrack = {};
                scope.fastrack.title =
                scope.fastrack.displaySubmit = true;
                switch (type) {
                    case 'aarogya':
                        scope.fastrack.title = "Aarogya Scheme";
                        scope.aarogyachecked = true;
                        scope.fastrack.showCorpName = false;
                        scope.fastrack.employerSearchTitle = "Family Number";
                        break;
                    case 'generic':
                        scope.fastrack.title = "Member Search";
                        scope.aarogyachecked = false;
                        scope.fastrack.showCorpName = true;
                        scope.fastrack.employerSearchTitle = "Employee ID";
                        break;
                }
                if (scope.aarogyachecked) {
                    scope.fastrack.corporateName = "Manipal";
                }
            },

            getDetailsWithMaid: function (maid, benefName) {
                if (maid && benefName) {
                    var data = { hospId: UserService.getHospitalObj().hospId, maid: maid, beneficiaryName: benefName }
                    UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails.json', data, 'POST').
                        then(function (response) {
                            if (response.data.isSuccess) {
                                scope.fastrack.displaySubmit = false;
                                scope.fastrack.error = false;
                                scope.fastrack.name = response.data.benefs.name;
                                scope.fastrack.relations = response.data.benefList;
                                scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
                            }
                            else {
                                scope.fastrack.error = true;
                                scope.fastrack.errorMessage = response.data.errorMessage;
                            }
                        }, function (error) {
                            scope.fastrack.error = true;
                            scope.fastrack.errorMessage = "No data found"
                        });
                }
            },
            getDetailsWithEmpId: function (empid, corpname, benefname) {
                if (empid && corpname && benefname) {
                    var data = { hospId: UserService.getHospitalObj().hospId, employeeId: empid, corporateName: corpname, BeneficiaryName: benefname }
                    UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails.json', data, 'POST').
                        then(function (response) {
                            if (response.data.isSuccess) {
                                scope.fastrack.displaySubmit = false;
                                scope.fastrack.error = false;
                                scope.fastrack.name = response.data.benefs.benefName;
                                scope.fastrack.relations = response.data.benefList;
                                scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
                            }
                            else {
                                scope.fastrack.error = true;
                                scope.fastrack.errorMessage = response.data.errorMessage;
                            }
                        }, function (error) {
                            scope.fastrack.error = true;
                            scope.fastrack.errorMessage = "No data found"
                        });
                }
            },
            getDetailsWithPolicy: function (policyno, benefname) {
                if (policyno && benefname) {
                    var data = {
                        hospId: UserService.getHospitalObj().hospId,
                        PolicyNo: policyno,
                        BeneficiaryName: benefname
                    }
                    UserService.makeRestCall(UtilitiesService.getUrlPrefix() + 'getEcardWithPolicyNo.json', data, 'POST').
                        then(function (response) {
                            if (response.data.isSuccess) {
                                scope.fastrack.displaySubmit = false;
                                scope.fastrack.error = false;
                                scope.fastrack.name = response.data.benefs.benefName;
                                scope.fastrack.relations = response.data.benefList;
                                scope.fastrack.empMaid = response.data.benefs.benefMediAssistID;
                            }
                            else {
                                scope.fastrack.error = true;
                                scope.fastrack.errorMessage = response.data.errorMessage;
                            }
                        }, function (error) {
                            scope.fastrack.error = true;
                            scope.fastrack.errorMessage = "No data found"
                        });
                }
            },
            fastrackPopulateNewAdmission: function (maid, relationid, name, eCashLess) {
                if (!eCashLess.eCashlessReqId) {
                    FastrackService.fastrackPopulateNewAdmission(maid, relationid, name).
                        then(function (response) {
                            if (response.data.isSuccess) {
                                scope.$parent.tempData = response.data.benefs;
                                scope.form = {};
                                scope.form.fileNames = [];
                                scope.form.fileUploadFolderPath = [];
                                scope.form.fullname = response.data.benefs.benefName;   //generic
                                scope.form.roomtype = "General ward";
                                scope.form.familyno = response.data.benefs.priBenefEmpCode;
                                scope.form.employer = response.data.benefs.benefPolHldrName;
                                scope.form.empid = response.data.benefs.priBenefEmpCode;
                                scope.form.maid = response.data.benefs.benefMediAssistID;
                                scope.form.policyno = scope.fastrack.PolicyNo;
                                scope.form.memberAge = response.data.benefs.benefAge;
                                scope.form.gender = response.data.benefs.benefSex;
                                angular.element("#myModal").modal("hide");
                                scope.form.PribenefRemainingBsi = response.data.benefs.pribenefRemainingBsi;
                            }
                            else {
                                scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network Error', 'Error', true);
                            }
                        }, function (response) {
                            scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network Upload Error', 'Error', true);
                        });
                } else {
                    scope.isECashLess = true;
                    scope.eCashLessMessage = 'There is already a pre-approved request that exists for the patient. Redirecting you to the request. Click yes to continue.';
                    timeout(function () {
                        scope.$apply(function () {
                            scope.isECashLess = false;
                            scope.eCashLessMessage = '';
                        });
                    }, 10000);
                }
            },
            clearfastrack: function () {
                scope.fastrack = {};
                scope.fastrack.displaySubmit = true;
                scope.fastrack.title = "Member Search";
                scope.aarogyachecked = false;
                scope.fastrack.showCorpName = true;
                scope.fastrack.employerSearchTitle = "Employee ID";
            },
            removeModal: function () {
                this.clearfastrack();
                angular.element("#myModal").modal("hide");
            }
        };
    }();

    scope.reDirect = function (value) {
        if (value) {
            angular.element("#newPreauthModal").modal("hide");
            state.go(value, { reload: false });
        }
    };

    scope.packageSelection = function () {
        scope.showAutoPackages = true;
        scope.selectedPackages = new Array();
        function getGovtPackageListSuccess(resData) {
            if (resData && resData.data.isSuccess && resData.data.packages && resData.data.packages.length > 0) {
                scope.govtPackageList = resData.data.packages;
                UserService.setGovtPackageList(scope.govtPackageList);
            }
            else {
                if (resData.data.isSuccess === false) {
                    scope.govtPackageList = [];
                    UserService.setGovtPackageList(scope.govtPackageList);
                }

            }
        }
        function getGovtPackageListError(resData) {
            scope.govtPackageList = [];
        }
        return {
            changePackageField: function () {
                if (scope.form.reasonOnline == "others") {
                    scope.showAutoPackages = false;
                }
                else {
                    scope.showAutoPackages = true;
                }
            },
            setAarogyaPackageId: function (packageObj) {
                scope.form.packageAmount = packageObj.packageCost;
                scope.form.packageName = packageObj.packageName;
                scope.form.packageUniqueId = packageObj.packageId;
                scope.form.cappedAmount = packageObj.cappedAmount;
            },
            getGovtPackageList: function () {
                var govtPackageList = UserService.getGovtPackageList();
                if (govtPackageList != undefined && govtPackageList != null) {
                    scope.govtPackageList = govtPackageList;
                    scope.showGovtPackages = true;
                }
                else {
                    GovernmentService.getGovtPackageList().then(getGovtPackageListSuccess, getGovtPackageListError);
                }
            },
            addPackageButtonAarogya: function () {
                if (scope.selectedPackages.length < 3) {
                    if (scope.showAutoPackages) {
                        if (scope.form.packageName && scope.form.packageName.length > 0) {
                            scope.selectedPackages.push({
                                "id": scope.selectedPackages.length,
                                "uniqueId": scope.form.packageUniqueId,
                                "name": scope.form.packageName,
                                "amount": scope.form.packageAmount,
                                "cappedAmount": scope.form.cappedAmount
                            });
                            $("#aarogyaPackageName").val($("#aarogyaPackageName").val() + ", " + scope.form.packageName);
                            $("#aaRogyaPackagesHolder").val($("#aaRogyaPackagesHolder").val() + ", " + scope.form.packageUniqueId);
                            $("#packageCappedAmountHolder").val($("#packageCappedAmountHolder").val() + ", " + scope.form.cappedAmount);
                            $("#packageIndividualAmount").val($("#packageIndividualAmount").val() + ", " + scope.form.packageAmount);
                        }
                        else {
                            UtilitiesService.showAlertMessage('Please select a package.');
                        }

                    }
                    else {
                        if (scope.form.mPackageName && scope.form.mPackageName.length > 0) {
                            scope.selectedPackages.push({
                                "id": scope.selectedPackages.length,
                                "uniqueId": 0,
                                "name": scope.form.mPackageName,
                                "amount": scope.form.mPackageAmount
                            });
                        }
                        else {
                            UtilitiesService.showAlertMessage("Please enter a package name manually.");
                        }

                        $("#aarogyaPackageName").val($("#aarogyaPackageName").val() + ", " + scope.form.mPackageName);
                        $("#aaRogyaPackagesHolder").val($("#aaRogyaPackagesHolder").val() + ", 0");
                        $("#packageCappedAmountHolder").val($("#packageCappedAmountHolder").val() + ",0");
                        $("#packageIndividualAmount").val($("#packageIndividualAmount").val() + ", " + scope.form.mPackageAmount);
                    }
                    scope.packageCalcAmount = 0;
                    for (var i = 0; i < scope.selectedPackages.length; i++) {
                        scope.packageCalcAmount = scope.packageCalcAmount + scope.selectedPackages[i].amount;
                    }
                    $("#aarogyaPackageAmountHolder").val(scope.packageCalcAmount);
                    scope.form.clmamount = scope.packageCalcAmount;
                }
                else {
                    UtilitiesService.showAlertMessage("Maximum of 3 packages allowed");
                }
            },
            removePackageAarogya: function (id) {
                $("#aarogyaPackageName").val($("#aarogyaPackageName").val().replace(", " + scope.selectedPackages[id].name, ""));
                $("#aaRogyaPackagesHolder").val($("#aaRogyaPackagesHolder").val().replace(", " + scope.selectedPackages[id].uniqueId, ""));
                $("#packageCappedAmountHolder").val($("#packageCappedAmountHolder").val().replace(", " + scope.selectedPackages[id].cappedAmount, ""));
                $("#packageIndividualAmount").val($("#packageIndividualAmount").val().replace(", " + scope.selectedPackages[id].amount, ""));
                for (var i = id; i < scope.selectedPackages.length - 1; i++) {
                    scope.selectedPackages[i] = scope.selectedPackages[i + 1];
                    scope.selectedPackages[i].id--;
                }
                scope.selectedPackages.pop(scope.selectedPackages.length - 1);
                scope.packageCalcAmount = 0;
                for (var i = 0; i < scope.selectedPackages.length; i++) {
                    scope.packageCalcAmount = scope.packageCalcAmount + scope.selectedPackages[i].amount;
                }
                $("#aarogyaPackageAmountHolder").val(scope.packageCalcAmount);
            },
        };
    }();
    scope.preauthFormAction = (function () {
        scope.username = UserService.getUserObj().userName;
        function submitPreauthFormSuccess(successData) {
            if (successData.data.isSuccess) {
                scope.form.preauthSuccess = true;
            }
            else {
                scope.form.preauthError = true;
            }
        }
        function submitPreauthFormError(ErrorData) {
            scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Network Error', 'Error', true);
        }
        function fileUploadSuccess(successData) {
            if (successData.data.isSuccess) {
                scope.form.fileNames.push(successData.data.uploadResponseDetails[0].fileName);
                scope.form.fileUploadFolderPath.push(successData.data.uploadResponseDetails[0].downloadURL);
                scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'Success', 'Success', true);
            }
        }
        function fileUploadError(errordata) {
            scope.msg = UtilitiesService.getMessasgeObj('#ff3300', 'FileUpload Error', 'Error', true);
        }
        return {
            validatePreauthForm: function () { },
            getPreauthFormData: function (form) {
                scope.selectedPackages = scope.selectedPackages.map(function (item) {
                    return {
                        "PackageName": item.name, "PackageAmount": item.amount, "PackageCappedAmount": item.cappedAmount, "PackageId": item.uniqueId
                    };
                });
                var data = {
                    "applicationName": "Hospital Portal",
                    "packagesList": scope.selectedPackages,
                    "fileNames": form.fileNames,
                    "filePath": form.fileUploadFolderPath,
                    "fileUploadFolderPath": form.fileUploadFolderPath,
                    "plannedHospId": 0,
                    "patientFirstName": form.fullname,
                    "ContactNum": form.mobile,
                    "EmpId": form.empid,
                    "Employer": form.employer,
                    "Maid": form.maid,
                    "Doa": form.doa,
                    "ApproxClaimedAmnt": scope.packageCalcAmount,
                    "DocName": form.docname,
                    "Diagnosis": form.diagnosis,
                    "AdmissionType": form.admissiontype,
                    "RoomType": form.roomtype,
                    "TentativeDOD": form.dod,
                    "ipNumber": form.ipnumber,
                    "HospId": UserService.getHospitalObj().hospId,
                    "HospName": UserService.getHospitalObj().hospName,
                    "createdBy": UserService.getUserObj().userId,
                    "uiD_NO": form.uidno
                };
                return data;
            },
            uploadFiles: function (callback) {
                scope.form.fileNames = [];
                scope.form.fileUploadFolderPath = [];
                if (scope.preAuthFile) {
                    Object.keys(scope.preAuthFile).forEach(function (e) {
                        if (typeof (scope.preAuthFile[e]) == 'object') {
                            scope.file.push({
                                'model': scope.preAuthFile[e]
                            });
                        }
                    });
                }
                var fileBlobArray = [];
                var filesUploadingArray = [];
                Object.keys(scope.file).forEach(function (ele) {
                    if (typeof (scope.file[ele].model) == "object") {
                        filesUploadingArray.push(scope.file[ele].model);
                    }
                });
                if (filesUploadingArray.length > 0) {
                    fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
                }
                else {
                     UtilitiesService.showAlertMessage('Please attach atleast one document.');
                    
                    
                    return false;
                }
                $q.all(fileBlobArray).then(function (result) {
                    result.forEach(function (element) {
                        if (element.data.isSuccess) {
                            angular.forEach(element.data.uploadResponseDetails, function (e, i) {
                                scope.form.fileNames.push(e.fileName);
                                scope.form.fileUploadFolderPath.push(e.downloadURL);
                            });
                        }
                        else {
                            scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                            return false;
                        }
                    });
                    if (result && (filesUploadingArray.length == 0 || scope.form.fileNames.length == result[0].data.uploadResponseDetails.length))
                        callback.call(scope.preauthFormAction);
                },
                function (error) {
                    scope.msg = UtilitiesService.getMessasgeObj('red', 'Fileupload issue', 'Error', true);
                });
            },
            submitPreauthForm: function () {
                this.uploadFiles(function () {
                    NewAdmissionFormService.submitAarogyaPreauthForm(this.getPreauthFormData(scope.form)).
                                   then(submitPreauthFormSuccess, submitPreauthFormError);
                });
                window.scroll(0, 0);
            },
            closePreauthForm: function () {
                scope.form = {};
                //$location.path('/');
            }
        };
    })();
    scope.packageSelection.getGovtPackageList();
    scope.file = [];
    scope.addFileToUpload = function (flag) {
        var newItemNo = scope.file.length + 1;
        scope.file.push({
            'model': ''
        });
    };
    scope.removeFileToUpload = function () {
        var lastItem = scope.file.length - 1;
        scope.file.splice(lastItem);
        scope.validLargeDoc = false;
    };
    scope.addFileToUpload();
}]);
'use strict';
angular.module('mbplus.userService', ['ngCookies']).value('version', '0.1')
  .service('UserService', ['$http', '$cookieStore', 'UtilitiesService', '$location', '$rootScope', 'filterFilter', '$cookies', function ($http, $cookieStore, UtilitiesService, $location, $rootScope, filterFilter, $cookies) {
    var userObj = {},
      adminId = 0,
      dateCollection = {},
      roles = [],
      hospitalObj = {},
      isUserType = true,
      menuItem = '',
      activeAppointmentsDummyData = [],
      activeAppointmentsDummyDataCollection = [],
      diagnosticCentresCollectionForSearch = [],
      dcUrl, IsRequestUpdate, serverSearch = {},
      diagnosticCentresCollection = [],
      investigationsDataCollection = [],
      diagnosticCentresData = [],
      saleQueueDataCollection = [];
    return {
      isPolicyBazar: false,
      setUserObj: function (obj) {
        localStorage.setItem('user', JSON.stringify(obj));
        // $cookieStore.put('user', obj);
        $cookieStore.put('loggedin', 'true');
      },
      getUserObj: function () {
        if ($cookieStore.get('loggedin') === 'true') {
          return JSON.parse(localStorage.getItem('user'));
        } else {
          return null;
        }
      },
      destroyUserObj: function () {
        localStorage.setItem('user', null);
        $cookieStore.put('mp_userProperties', null);
        $cookieStore.put('aarogya', null);
        $cookieStore.put('hospital', null);
        var cookies = $cookies.getAll();
        angular.forEach(cookies, function (v, k) {
          if (k != 'one_MediAssist') {
            $cookies.remove(k);
          }
        });
        localStorage.clear();
        sessionStorage.clear()
        this.destroyHospitalListObj();
        this.destroyAarogyaListObj();
        this.destroyGovtPackageListObj();
        $cookieStore.put('loggedin', 'false');
      },
      checkUserRole: function (name) {
        return filterFilter(this.getUserObj().rolesFeatures.roles, {
          'roleName': name
        }, true).length > 0;
      },
      setUserMenuToggle: function (toggleObj) {
        $cookieStore.put('userToggleValues', toggleObj);
      },
      getUserMenuToggle: function () {
        if ($cookieStore.get('loggedin') === 'true') {
          return $cookieStore.get('userToggleValues');
        } else {
          return null;
        }
      },
      setFetauresForPlus: function (allowedFeatureList) {
        localStorage.setItem('featureList', JSON.stringify(allowedFeatureList));
      },
      GetDcInvestigationMap: function (searchExpression) {
        var results = [];
        if (this.diagnosticCentresCollectionForSearch) {
          if (this.diagnosticCentresCollectionForSearch.length > 0) {
            var activeAppointmentsDummyDataCollection = this.diagnosticCentresCollectionForSearch;
            if (searchExpression && searchExpression.length > 0) {
              angular.forEach(searchExpression.split('^'), function (key) {
                var searchExp = key.split('=');
                if (searchExp.length > 0) {
                  results = filterFilter(activeAppointmentsDummyDataCollection, searchExpression);
                }
              });
            }

          }
        }
        return results;
      },
      GetDcInvestigation: function (searchExpression) {
        var results = [];
        if (this.investigationsDataCollection) {
          if (this.investigationsDataCollection.length > 0) {
            var activeAppointmentsDummyDataCollection = this.investigationsDataCollection;
            if (searchExpression && searchExpression.length > 0) {
              angular.forEach(searchExpression.split('^'), function (key) {
                var searchExp = key.split('=');
                if (searchExp.length > 0) {
                  results = filterFilter(activeAppointmentsDummyDataCollection, searchExpression);
                }
              });
            }

          }
        }
        return results;
      },
      GeteSaleQuebe: function (searchExpression) {
        var results = [];
        if (this.saleQueueDataCollection && this.saleQueueDataCollection.length > 0) {
          var activeAppointmentsDummyDataCollection = this.saleQueueDataCollection;
          if (searchExpression && searchExpression.length > 0) {
            angular.forEach(searchExpression.split('^'), function (key) {
              var searchExp = key.split('=');
              if (searchExp.length > 0) {
                results = filterFilter(activeAppointmentsDummyDataCollection, searchExpression);
              }
            });
          }
        }
        return results;
      },
      GetFilteredAppointment: function (searchExpression) {
        var activeAppointments = [];
        if (this.activeAppointmentsDummyDataCollection) {
          if (this.activeAppointmentsDummyDataCollection.length > 0) {
            var activeAppointmentsDummyDataCollection = this.activeAppointmentsDummyDataCollection;
            var activeAppointmentsDummy = this.activeAppointmentsDummyData;
            if (searchExpression && searchExpression.length > 0) {
              angular.forEach(searchExpression.split('^'), function (key) {
                var searchExp = key.split('=');
                if (searchExp.length > 0) {
                  switch (searchExp[0]) {
                    case 'n':
                      activeAppointmentsDummy.requests = filterFilter(activeAppointmentsDummyDataCollection, {
                        'additionalInformation': {
                          'patientName': searchExp[1]
                        }
                      });
                      activeAppointments = activeAppointmentsDummy;
                      break;
                    case 'c':
                      activeAppointmentsDummy.requests = filterFilter(activeAppointmentsDummyDataCollection, {
                        'additionalInformation': {
                          'primaryEntityName': searchExp[1]
                        }
                      });
                      activeAppointments = activeAppointmentsDummy;
                      break;
                    case 'p':
                      activeAppointmentsDummy.requests = filterFilter(activeAppointmentsDummyDataCollection, {
                        'additionalInformation': {
                          'productName': searchExp[1]
                        }
                      });
                      activeAppointments = activeAppointmentsDummy;
                      break;
                    default:
                      activeAppointmentsDummy.requests = filterFilter(activeAppointmentsDummyDataCollection, searchExpression);
                      activeAppointments = activeAppointmentsDummy;
                  }
                }
              });
            }
            return activeAppointments;
          }
        }
      },
      GetFilteredAppointmentUnapprovedNewAppointments: function (searchExpression) {
        var activeAppointments = [];
        if (this.activeAppointmentsDummyDataCollection) {
          if (this.activeAppointmentsDummyDataCollection.length > 0) {
            var activeAppointmentsDummyDataCollection = this.activeAppointmentsDummyDataCollection;
            var activeAppointmentsDummy = this.activeAppointmentsDummyData;
            activeAppointmentsDummy.requests = filterFilter(activeAppointmentsDummyDataCollection, searchExpression);
            activeAppointments = activeAppointmentsDummy.requests;
            return activeAppointments;
          }
        }
      },
      GetFilteredAppointmentQc: function (searchExpression) {
        var activeAppointments = [];
        if (this.activeAppointmentsDummyDataCollection) {
          if (this.activeAppointmentsDummyDataCollection.length > 0) {
            var activeAppointmentsDummyDataCollection = this.activeAppointmentsDummyDataCollection;
            var activeAppointmentsDummy = this.activeAppointmentsDummyData;
            activeAppointmentsDummy.data = filterFilter(activeAppointmentsDummyDataCollection, searchExpression);
            activeAppointments = activeAppointmentsDummy.data;
            return activeAppointments;
          }
        }
      },
      GetFilteredAppointmentUnConfirmedOrder: function (searchExpression) {
        var activeAppointments = [];
        if (this.activeAppointmentsDummyDataCollection) {
          if (this.activeAppointmentsDummyDataCollection.length > 0) {
            var activeAppointmentsDummyDataCollection = this.activeAppointmentsDummyDataCollection;
            var activeAppointmentsDummy = this.activeAppointmentsDummyData;
            activeAppointmentsDummy.cartOrders = filterFilter(activeAppointmentsDummyDataCollection, searchExpression);
            activeAppointments = activeAppointmentsDummy;
            return activeAppointments;
          }
        }
      },
      getHrefForFeature: function (featureId, menuItem) {
        return menuItem[featureId].href;
      },
      getAccessToken: function () {
        var accessToken = '';
        var user = this.getUserObj();
        if (user) {
          accessToken = user.accessToken;
        }
        return accessToken;
      },
      getUserDefaultRoute: function (menuItem) {


        var defaultRoute = '';
        var featureItem = null;
        var featureItemForDashBoard = null;
        var allowedFeatureList = [];
        var user = this.getUserObj();
        user.rolesFeatures.features.map(function (e) {
          if (e)
            allowedFeatureList.push(e.featureId);
        });
        allowedFeatureList.sort();
        var countForClaims = [];
        countForClaims = allowedFeatureList.filter(function (n) {
          return [9203, 9204, 9205, 9208, 9211].indexOf(n) != -1;
        });
        if (countForClaims.length > 1) {
          allowedFeatureList.push(19999);
          defaultRoute = '/claims';
        } else if (this.checkUserRole('insurer')) {
          defaultRoute = '/government';
        }
        allowedFeatureList.push(92070078);
        var notification = [];
        var notification = allowedFeatureList.filter(function (n) {
          return [9206, 9207, 9209, 9210, 9212, 9213, 9214, 9215, 9216, 9217, 9218, 9220, 9221].indexOf(n) != -1;
        });
        if (notification.length > 0 && !(notification.length === 1 && _.first(notification) === 9214)) {
          allowedFeatureList.push(10000000);
        };
        allowedFeatureList.sort();
        angular.forEach(allowedFeatureList, function (v, i) {
          if (v === 9201) {
            featureItem = v;
            return false;
          }
        });
        angular.forEach(allowedFeatureList, function (v, i) {
          if (v === 9224) {
            featureItemForDashBoard = v;
            return false;
          }
        });
        if (featureItem === null) {
          featureItem = allowedFeatureList[0];
        }
        //if (featureItemForDashBoard === null) {
        //    featureItem = allowedFeatureList[0];
        //}
        if (featureItem) {
          this.setFetauresForPlus(allowedFeatureList);
          if (featureItemForDashBoard === 9224) {
            defaultRoute = 'inDashboard';
          } else if (featureItem === 5436) {
            defaultRoute = 'payments';
          } else {
            if (menuItem && defaultRoute === '') {
              defaultRoute = this.getHrefForFeature(featureItem, menuItem);
            }
            console.log("user user >> ", user);
            if (user.isPasswordReset) {
              defaultRoute = '/changepwd';
            } else if (!user.isTermsAccepted) {
              defaultRoute = '/terms';
            } else if (user.entityType && user.entityType === 'DC') {
              defaultRoute = '/dcDashboard';
            }
          }

          if ($rootScope.toggleMenuObj && $rootScope.toggleMenuObj.isMultiRole) {
            if ($rootScope.toggleMenuObj.isDcRoleActive && ((defaultRoute != '/changepwd') || (defaultRoute != '/terms'))) {
              defaultRoute = '/dcDashboard';
            }
          }

          return defaultRoute;
        } else {
          UtilitiesService.showAlertMessage('Couldn' / 't find matching feature');
        }
      },
      fetchAllClaims: function (obj, hospitalId) {
        switch (hospitalId) {
          case '9999999':
            obj.entityId = 9999999;
            this.setUserObj(obj);
            break;
          default:
            obj.entityId = hospitalId;
            this.setUserObj(obj);
            break;
        }
      },
      getAdminId: function () {
        return adminId;
      },
      setAdminId: function (id) {
        adminId = id;
      },
      isAdmin: function () {
        var user = this.getUserObj();
        if (user && user.roleId === this.getAdminId()) {
          return true;
        } else {
          return false;
        }
      },
      setRoles: function (roleArray) {
        roles = roleArray;
      },
      getRoles: function () {
        return roles;
      },
      isRemedinetAssociated: function () {
        return getHospitalObj().isRemedinetAssociated;
      },
      getHospitalObj: function () {
        if ($cookieStore.get('loggedin') === 'true') {
          return $cookieStore.get('hospital');
        } else {
          return null;
        }
      },
      setHospitalObj: function (obj) {
        $cookieStore.put('hospital', obj);
      },
      getAarogyaObj: function () {
        if ($cookieStore.get('loggedin') === 'true') {
          return $cookieStore.get('aarogya');
        } else {
          return null;
        }
      },
      setAarogyaObj: function (obj) {
        if (obj !== undefined) {
          $cookieStore.put('aarogya', obj);
        }
      },
      getHospAarogyaChecked: function () {
        if (this.getHospitalObj()) {
          var hospId = this.getHospitalObj().hospId;
          var aarogyaObj = this.getAarogyaObj();
          if (aarogyaObj === undefined) {
            return false;
          }
          var aarogyaHosplist = $.map(aarogyaObj, function (index) {
            return index.relatedEntityId;
          })
          if (aarogyaHosplist.indexOf(hospId) !== -1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      viewFile: function (url, postData, responseType, data) {
        // debugger
        function responseToObject(data, headersGetter, status) {
          var type = headersGetter("Content-Type");
          if (!type.startsWith("application/json")) {
            return data;
          }
          else {
            var decoder = new TextDecoder("utf-8");
            var domString = decoder.decode(data);
            var json = JSON.parse(domString);
            return json;
          }
        };

        var config = {
          headers: {
            'AccessToken': this.getAccessToken()
          },
          responseType: 'arraybuffer',
          transformResponse: responseToObject,
        }
        if (!responseType) {
          responseType = "octet/stream";
        }

        if (!postData) {
          return new Promise(function (resolve, reject) {
            $http.get(url, config).then(function (response) {
              if (response.status == 200) {
                var blob = new Blob([response.data], { type: "octet/stream" })
                var fileURL = window.URL.createObjectURL(blob);
                var fileName = response.headers('fileName');
                var element = document.createElement('a');
                element.setAttribute('href', fileURL);
                if(!fileName){
                  if(data && data.name){
                    fileName = data.name
                  }
                };
                element.setAttribute('download', fileName);
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
                resolve(fileURL);
              }
              else {
                reject();
              }
            }).catch(function (error) {
              UtilitiesService.showAlertMessage(error.data.responseStatus.message)
            })
          })
        } else {
          return new Promise(function (resolve, reject) {
            $http.post(url, postData, config).then(function (response) {
              if (response.status == 200) {
                var blob = new Blob([response.data], { type: responseType })
                var fileURL = window.URL.createObjectURL(blob);
                var fileName = 'Report';
                var element = document.createElement('a');
                element.setAttribute('href', fileURL);
                element.setAttribute('download', fileName);
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
                resolve(fileURL);
              }
              else {
                reject();
              }
            }).catch(function (error) {
              UtilitiesService.showAlertMessage(error.data.responseStatus.message);
              reject();
            })
          })
        }
      },
      displayThis: function (feature, _role) {
        if (_role) {
          var role = _role.toLowerCase();
          switch (feature) {
            case 'switchHosp':
              if (role === 'cms' || role === 'insurer')
                return true;
              else
                return false;
              break;
            case 'newadmission':
              if (role === 'guest' || role === 'cms' || role === 'insurer')
                return false;
              else
                return true;
              break;
            case 'claimaction':
              if (role === 'guest' || role === 'cms' || role === 'hr')
                return false;
              else
                return true;
              break;
            case 'operations':
              if (role === 'operations' || role === 'admin' || role === 'cms' || role === 'hr')
                return true;
              else
                return false;
              break;
            case 'hospBasic':
              if (role !== 'cms')
                return true;
              else
                return false;
              break;
            case 'mediAssist':
              if (role === 'cms')
                return true;
              else
                return false;
              break;
            case 'finance':
              if (role === 'finance' || role === 'admin' || role === 'cms' || role === 'hr')
                return true;
              else
                return false;
              break;
            case 'activeclaims':
              if (role === 'insurer' || role === 'hr')
                return false;
              else
                return true;
              break;
            case 'approved':
              if (role === 'insurer' || role === 'hr')
                return false;
              else
                return true;
              break;
            case 'government':
              if (role === 'hr')
                return false;
              else
                return true;
              break;
            case 'denied':
              if (role === 'insurer' || role === 'hr')
                return false;
              else
                return true;
              break;
            case 'dashboard':
              if (role === 'insurer' || role === 'hr')
                return false;
              else
                return true;
              break;
            case 'planned':
              if (role === 'insurer' || role === 'hr')
                return false;
              else
                return true;
              break;
            case 'usermgmt':
              if (role === 'insurer' || role === 'hr')
                return false;
              else
                return true;
              break;
            case 'hospprofile':
              if (role === 'insurer' || role === 'hr')
                return false;
              else
                return true;
              break;
            case 'guidelines':
              if (role === 'insurer' || role === 'hr')
                return false;
              else
                return true;
              break;
            case 'faqs':
              if (role === 'insurer' || role === 'hr')
                return false;
              else
                return true;
              break;
            case 'contact':
              if (role === 'insurer' || role === 'hr')
                return false;
              else
                return true;
              break;
            case 'restrict':
              if (role === 'insurer')
                return false;
              else
                return true;
              break;

            default:
              return false;
              break;
          }
        } else {
          return false;
        }
      },
      isActive: function () {
        var user = this.getUserObj();
        if (user) {
          if ((user.accessToken || (user.isActive && user.isPasswordReset && user.isTermsAccepted))) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      getHospitalList: function () {
        if ($cookieStore.get('loggedin') === 'true') {
          return JSON.parse(window.sessionStorage.getItem('hospitalList'));
        } else {
          return null;
        }
      },
      setHospitalList: function (obj) {
        if (obj !== undefined) {
          window.sessionStorage.setItem('hospitalList', JSON.stringify(obj));
        }
      },
      destroyHospitalListObj: function () {
        window.sessionStorage.setItem('hospitalList', null);
      },
      getAaarogyaList: function () {
        if ($cookieStore.get('loggedin') === 'true') {
          return JSON.parse(window.sessionStorage.getItem('aarogyaList'));
        } else {
          return null;
        }
      },
      setAaarogyaList: function (obj) {
        if (obj !== undefined) {
          window.sessionStorage.setItem('aarogyaList', JSON.stringify(obj));
        }
      },
      destroyAarogyaListObj: function () {
        window.sessionStorage.setItem('aarogyaList', null);
      },
      getGovtPackageList: function () {
        if ($cookieStore.get('loggedin') === 'true') {
          return JSON.parse(window.sessionStorage.getItem('govtPackageList'));
        } else {
          return null;
        }
      },
      setGovtPackageList: function (obj) {
        if (obj !== undefined) {
          window.sessionStorage.setItem('govtPackageList', JSON.stringify(obj));
        }
      },
      destroyGovtPackageListObj: function () {
        window.sessionStorage.setItem('govtPackageList', null);
      },
      loadMasterByKeyName: function (keyName) {
        var data = {
          'lookUpName': keyName
        }
        var promise = this.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/getMasterLookUp.json', data, 'POST').then(function (response) {
          if (response.data.isSuccess) {
            data = response.data.lookUpResponse;
            var response = [];
            angular.forEach(data, function (e, i) {
              var temp = {
                id: i,
                value: e
              };
              response.push(temp);
            });
            return response;
          }
        });
        promise.catch(function (error) {
          if (error.status === 403 && error.statusText === 'Forbidden') {
            $cookieStore.put('user', null);
            $cookieStore.put('aarogya', null);
            $cookieStore.put('hospital', null);
            var cookies = $cookies.getAll();
            angular.forEach(cookies, function (v, k) {
              if (k != 'one_MediAssist') {
                $cookies.remove(k);
              }
            });
            localStorage.clear();
            sessionStorage.clear()
            window.sessionStorage.setItem('hospitalList', null);
            window.sessionStorage.setItem('aarogyaList', null);
            window.sessionStorage.setItem('govtPackageList', null);
            $cookieStore.put('loggedin', 'false');
            $location.path('/');
          }
        })
        return promise;
      },
      getAllHospitalList: function () {
        return $http.post(UtilitiesService.getUrlPrefix() + '/hosp/list.json');
      },
      getConfiguredTpa: function (hospId) {
        if (hospId) {
          // return $http.get(UtilitiesService.getUrlPrefix() + 'hosp/' + hospId + '/tpas');
        }
      },
      getAllGovtPackageList: function (hospId) {
        return 1;
        // $http.post(UtilitiesService.getUrlPrefix() + '/hosp/packagesbtnentities/list.json?priEntityId=' + hospId + '&secEntityName=Medi%20Assist');
      },
      getAllAarogyaList: function () {
        var url = UtilitiesService.getUrlPrefix() + '/hosp/entity/entitywithrelationInsurerWise.json';
        var data = {
          'entityId': 1000042,
          'relation': 'aarogya surkasha'
        };
        return $http.post(url, data);
      },
      makeRestCall: function (url, data, method, accessToken, isHeader,isBlob) {
        if (method.toLowerCase() === 'get') {
          if (isHeader)
            var promise = $http({
              method: 'GET',
              url: url,
              data: data,
              headers: {
                'AccessToken': accessToken
              }
            });
          else
            var promise = $http.get(url, data, accessToken);
        } else {
          var promise = $http({
            method: method,
            url: url,
            data: data,
            headers: {
              'AccessToken': accessToken
            },
               responseType: isBlob? 'blob' : undefined 
          });
        }
        promise.catch(function (error) {
          if (error.status === 403 && error.statusText === 'Forbidden') {
            $cookieStore.put('user', null);
            $cookieStore.put('aarogya', null);
            $cookieStore.put('hospital', null);
            var cookies = $cookies.getAll();
            angular.forEach(cookies, function (v, k) {
              if (k != 'one_MediAssist') {
                $cookies.remove(k);
              }
            });
            localStorage.clear();
            sessionStorage.clear()
            window.sessionStorage.setItem('hospitalList', null);
            window.sessionStorage.setItem('aarogyaList', null);
            window.sessionStorage.setItem('govtPackageList', null);
            $cookieStore.put('loggedin', 'false');
            $location.path('/');
          }
        })
        return promise;
      },
      toTitleCase: function (str) {
        if (str && str.length > 0)
          return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          });
        else
          return str;
      },
      checkForSession: function (value) {
        if (!this.isActive()) {
          this.destroyUserObj();
          $location.path('/');
          return false;
        }

      },
      checkForAdminUser: function () {
        var user = this.getUserObj(),
          isRoleAdmin;
        if (user && user.rolesFeatures && user.rolesFeatures.roles.length > 0) {
          var role = _.find(user.rolesFeatures.roles, function (num) {
            return num.roleId === 4671
          });
          isRoleAdmin = role ? ((role.roleId === 4671) === true) ? true : false : false;
        }
        return isRoleAdmin;
      }
    };
  }]);

'use strict';
angular.module('mbplus.sharedDataService', ['ngCookies']).value('version', '0.1')
  .service('sharedDataService', ['$cookieStore', function (cookieStore) {
    return {
      /*setDataObj: function (obj) {
          cookieStore.put('empdata', obj);
      },
      getDataObj: function () {
          return cookieStore.get('empdata');
      },
      destroyDataObj: function () {
          cookieStore.put('empdata', null);
      },*/
      setLocalStorageDataObj: function (obj) {
        localStorage.setItem('empdata', JSON.stringify(obj));
      },
      getLocalStorageDataObj: function () {
        return JSON.parse(localStorage.getItem('empdata'));
      },
      destroyLocalStorageDataObj: function () {
        localStorage.removeItem('empdata');
      }
    }
  }]);

'use strict';
angular.module('mbplus.utilitiesService', ['ngCookies']).value('version', '0.1')
  .service('UtilitiesService', ['$anchorScroll', '$location', '$http', '$cookieStore', 'filterFilter', '$uibModal', 'blockUI', '$timeout', function ($anchorScroll, $location, $http, $cookieStore, filterFilter, $uibModal, blockUI, $timeout) {
    if ($location.host().toLowerCase() === 'plus.medibuddy.in' || $location.host().toLowerCase() === 'cmht.medibuddy.in' || !0) {
      var hospitalServiceUrl = 'https://hospserviceab.medibuddy.in/';
      var fastrackUrl = 'https://track.medibuddy.in/api/';
      var signalR = 'https://plus.medibuddy.in/Notification/signalr';
      var plusServiceUrl = '<%= plus_service %>';
      var DMSUrl = 'http://document.medibuddy.in';
      var providerMediBuddyUrl = 'https://fuser.medibuddy.in/api/';
      var publicHealthUrl = 'https://publichealth.medibuddy.in/';
      var integrationPlusUrl = 'https://integration-plus-plus.medibuddy.in/PlusAPI/';
      var plusUrl = "https://plus-api-prod.medibuddy.in/"
      var providerCore = "https://providercore.medibuddy.in/";
      var dummyUserAcessToken = '70b47c92ce225c1c2fd54833ba646c218e0d3975b66ce88842dd11498c1cb415edf635144cea8e4a7d57edc5d8fe0a3f175cdfff8f79a0611ef5552246b5fff867e95a6a46178ae945575e9ed180cee74d83256c6f1daec623abd1dff7c9e7ba5f37f350269c13051f7b04e29601d812445cf5597c6de83f1954f65993404e3d1590414fdb71fa2f7629b714ec2587856d02ad4be14ed1d7c03249b1e86d3b62d7b80b35734d6acca4bd6373d1ee506204fc6d62ffe97d65f08ac45368b43a56169486e960a9e9559ea50e170b2588bd264a061bea8c6568938c88cf9e22cfa7d66c23edff9ac021a96def46038f4d14c595acf24fa195dbdf158395d4350a4c9c1093a3294ac2379db4721d22ecf6cc549325ac9d22b0e0fb7ad5fff7237249f649cf1753e4c0c15d3ae3aaa1838c9449d82b807661d255b8aa846f99f7576036f633197fcd60c88c45fed34bcb87fef072adc5e7a634cd84ace0a4f0fc6767f885789c7193b2adca1bbc3ef2bd932425bbab47feaf2531a77b55e5229ca642522bfa18c8ec2a484c106cd2496a3ba34928b0f06ef792cb6556f714d4528cb1822e41bc72169e22c84837e27057a60973b77eab7a34f9b132231f866fdce3a5';
      var providerCoreNode = 'https://providercore.medibuddy.in/';
    } else if ($location.host().toLowerCase() === 'trg-plus.medibuddy.in') {
      var hospitalServiceUrl = 'https://hospserviceab.medibuddy.in/';
      var fastrackUrl = 'https://track.medibuddy.in/api/';
      var signalR = 'https://plus.medibuddy.in/Notification/signalr';
      var plusServiceUrl = 'https://trg-api-plus.medibuddy.in/';
      var DMSUrl = 'http://document.medibuddy.in';
      var publicHealthUrl = 'https://publichealth.medibuddy.in/';
      var integrationPlusUrl = 'https://integration-plus-plus.medibuddy.in/PlusAPI/';
      var plusUrl = "https://plus-api-prod.medibuddy.in/"
      var dummyUserAcessToken = '70b47c92ce225c1c2fd54833ba646c218e0d3975b66ce88842dd11498c1cb415edf635144cea8e4a7d57edc5d8fe0a3f175cdfff8f79a0611ef5552246b5fff867e95a6a46178ae945575e9ed180cee74d83256c6f1daec623abd1dff7c9e7ba5f37f350269c13051f7b04e29601d812445cf5597c6de83f1954f65993404e3d1590414fdb71fa2f7629b714ec2587856d02ad4be14ed1d7c03249b1e86d3b62d7b80b35734d6acca4bd6373d1ee506204fc6d62ffe97d65f08ac45368b43a56169486e960a9e9559ea50e170b2588bd264a061bea8c6568938c88cf9e22cfa7d66c23edff9ac021a96def46038f4d14c595acf24fa195dbdf158395d4350a4c9c1093a3294ac2379db4721d22ecf6cc549325ac9d22b0e0fb7ad5fff7237249f649cf1753e4c0c15d3ae3aaa1838c9449d82b807661d255b8aa846f99f7576036f633197fcd60c88c45fed34bcb87fef072adc5e7a634cd84ace0a4f0fc6767f885789c7193b2adca1bbc3ef2bd932425bbab47feaf2531a77b55e5229ca642522bfa18c8ec2a484c106cd2496a3ba34928b0f06ef792cb6556f714d4528cb1822e41bc72169e22c84837e27057a60973b77eab7a34f9b132231f866fdce3a5';
    } else if (window.location.hostname === 'uat-plus.medibuddy.in') {
      var hospitalServiceUrl = 'https://uat-hospitalService.medibuddy.in/';
      var fastrackUrl = 'https://track.medibuddy.in/api/';
      var signalR = 'https://plus.medibuddy.in/Notification/signalr';
      var plusServiceUrl = 'https://uat-plusapi.medibuddy.in/';
      var DMSUrl = 'http://document.medibuddy.in';
      var publicHealthUrl = 'https://publichealth.medibuddy.in/';
      var integrationPlusUrl = 'https://integration-plus-plus.medibuddy.in/PlusAPI/';
      var plusUrl = "https://plus-api-prod.medibuddy.in/"
      var dummyUserAcessToken = '70b47c92ce225c1c2fd54833ba646c218e0d3975b66ce88842dd11498c1cb415edf635144cea8e4a7d57edc5d8fe0a3f175cdfff8f79a0611ef5552246b5fff867e95a6a46178ae945575e9ed180cee74d83256c6f1daec623abd1dff7c9e7ba5f37f350269c13051f7b04e29601d812445cf5597c6de83f1954f65993404e3d1590414fdb71fa2f7629b714ec2587856d02ad4be14ed1d7c03249b1e86d3b62d7b80b35734d6acca4bd6373d1ee506204fc6d62ffe97d65f08ac45368b43a56169486e960a9e9559ea50e170b2588bd264a061bea8c6568938c88cf9e22cfa7d66c23edff9ac021a96def46038f4d14c595acf24fa195dbdf158395d4350a4c9c1093a3294ac2379db4721d22ecf6cc549325ac9d22b0e0fb7ad5fff7237249f649cf1753e4c0c15d3ae3aaa1838c9449d82b807661d255b8aa846f99f7576036f633197fcd60c88c45fed34bcb87fef072adc5e7a634cd84ace0a4f0fc6767f885789c7193b2adca1bbc3ef2bd932425bbab47feaf2531a77b55e5229ca642522bfa18c8ec2a484c106cd2496a3ba34928b0f06ef792cb6556f714d4528cb1822e41bc72169e22c84837e27057a60973b77eab7a34f9b132231f866fdce3a5';
    } else if (window.location.hostname === 'demo-plus.medibuddy.in') {
      var hospitalServiceUrl = 'https://demo-hospService.medibuddy.in/';
      var fastrackUrl = 'https://track.medibuddy.in/api/';
      var signalR = 'https://plus.medibuddy.in/Notification/signalr';
      var plusServiceUrl = 'https://uat-plusapi.medibuddy.in/';
      var DMSUrl = 'http://document.medibuddy.in';
      var publicHealthUrl = 'https://publichealth.medibuddy.in/';
      var integrationPlusUrl = 'https://integration-plus-plus.medibuddy.in/PlusAPI/';
      var plusUrl = "https://plus-api-prod.medibuddy.in/"
      var dummyUserAcessToken = '70b47c92ce225c1c2fd54833ba646c218e0d3975b66ce88842dd11498c1cb415edf635144cea8e4a7d57edc5d8fe0a3f175cdfff8f79a0611ef5552246b5fff867e95a6a46178ae945575e9ed180cee74d83256c6f1daec623abd1dff7c9e7ba5f37f350269c13051f7b04e29601d812445cf5597c6de83f1954f65993404e3d1590414fdb71fa2f7629b714ec2587856d02ad4be14ed1d7c03249b1e86d3b62d7b80b35734d6acca4bd6373d1ee506204fc6d62ffe97d65f08ac45368b43a56169486e960a9e9559ea50e170b2588bd264a061bea8c6568938c88cf9e22cfa7d66c23edff9ac021a96def46038f4d14c595acf24fa195dbdf158395d4350a4c9c1093a3294ac2379db4721d22ecf6cc549325ac9d22b0e0fb7ad5fff7237249f649cf1753e4c0c15d3ae3aaa1838c9449d82b807661d255b8aa846f99f7576036f633197fcd60c88c45fed34bcb87fef072adc5e7a634cd84ace0a4f0fc6767f885789c7193b2adca1bbc3ef2bd932425bbab47feaf2531a77b55e5229ca642522bfa18c8ec2a484c106cd2496a3ba34928b0f06ef792cb6556f714d4528cb1822e41bc72169e22c84837e27057a60973b77eab7a34f9b132231f866fdce3a5';
    } else {
      //local url
      var hospitalServiceUrl = 'https://stg-demoapi.medibuddy.in/';
      var publicHealthUrl = 'https://stg-publichealth.medibuddy.in/';
      var integrationPlusUrl = 'https://integration-plus-plus.medibuddy.in/PlusAPI/';
      //var hospitalServiceUrl = 'http://localhost:58790/';
      // var hospitalServiceUrl = 'https://hospserviceab.medibuddy.in/';
      var signalR = 'https://plus.medibuddy.in/Notification/signalr';
      // var signalR ='http://stg-bo.mediassistindia.net/notification/signalr';
      var plusServiceUrl = 'https://stg-api-plus.medibuddy.in/';
      // var plusServiceUrl = 'https://api-plus.medibuddy.in/';
      // var plusServiceUrl = 'http://localhost:49612/';
      var DMSUrl = 'http://document.medibuddy.in';
      var plusUrl = 'https://plus-api-stg.medibuddy.in/';
      var dummyUserAcessToken = '70b47c92ce225c1c2fd54833ba646c218e0d3975b66ce88842dd11498c1cb415edf635144cea8e4a7d57edc5d8fe0a3f175cdfff8f79a0611ef5552246b5fff867e95a6a46178ae945575e9ed180cee74d83256c6f1daec623abd1dff7c9e7ba5f37f350269c13051f7b04e29601d812445cf5597c6de83f1954f65993404e3d1590414fdb71fa2f7629b714ec2587856d02ad4be14ed1d7c03249b1e86d3b62d7b80b35734d6acca4bd6373d1ee506204fc6d62ffe97d65f08ac45368b43a56169486e960a9e9559ea50e170b2588bd264a061bea8c6568938c88cf9e22cfa7d66c23edff9ac021a96def46038f4d14c595acf24fa195dbdf158395d4350a4c9c1093a3294ac2379db4721d22ecf6cc549325ac9d22b0e0fb7ad5fff7237249f649cf1753e4c0c15d3ae3aaa1838c9449d82b807661d255b8aa846f99f75760cfe73b235dc0395333a8ccf4aaec0d4e4094735270dd2c80a74541c6e135e70b35df5dcfb9edc43c24bddad0c8503da45e4d76163a07e3cda47cb7f1c9bd8136f7960f35ea67cae6b5a2d37441ab2789d2a38032b43606cb9580469ffc7b9c3ba7d4204e9cbc5aa7a7f23171c0a96518a4fb2654fb2d4700ac2d5cbec40a0ad1';
    }
    //configured for mode, will be replaced in prod build
    if(plusServiceUrl.indexOf('<%=') > -1){
      plusServiceUrl = 'https://api-plus.medibuddy.in/';
    }
    var IsPlannedCheck = '',
      availableBills = [],
      resetAccessToken = '',
      access_token = '',
      serachModel = '',
      hospitalNotification = [];
    var aarogyaPolicyNo = ['603805/50/16/10000229', '603805/46/15/8500000065_EX', '603805/46/15/8500000101_3', '603805/48/16/000000_4', '603805/46/15/8500000075_2', '603805/50/16/10000229_Ex', '603805501810000504', '603805501810000503 '],
      startDate, downloadURL = 'File/true/',
      uploadFileData = '',
      endDate, dateFlag = false,
      insuranceCompanyName = ['The New India Assurance Co. Ltd', 'Reliance General Insurance Co. Ltd.', 'Medi Assist', 'Oriental Insurance Co. Ltd.', 'United India Insurance Co. Ltd', 'National Insurance Co. Ltd.', 'ICICI Lombard General Insurance Co. Ltd.', 'Cholamandalam MS General Insurance Company Limited', 'Royal Sundaram General Insurance Company Limited', 'IFFCO-Tokio General Insurance Company Ltd', 'HDFC Ergo General Insurance Company Limited', 'LIC Of India', 'Apollo Munich Health Insurance Co. Ltd', 'Future Generali India Insurance Co. Ltd', 'Bharti AXA General Insurance Company Limited', 'Reliance Life Insurance Company Limited', 'Universal Sompo General Insurance Co. Ltd.', 'Star Health and Allied Insurance Company Limited', 'L&T General Insurance Company Limited', 'Religare Health Insurance Co. Ltd', 'IndiaFirst Life Insurance Company Limited', 'MaxBupa Health Insurance Co.Ltd', 'Bajaj Allianz General Insurance Co. Ltd.', 'SBI General Insurance Company Limited', 'Liberty Videocon General Insurance Co. Ltd.'],
      eBillHospital = [1000133, 1000134, 1000135, 1000136, 1000137, 1000138, 1000139, 1000140, 1000141, 1000142, 1000174, 1000862, 1000961, 1001047, 1001269, 1001510, 1002957, 1003876, 1003886, 1004065, 1004323, 1004436, 1004470, 1004480, 1004687, 1004695, 1004777, 1004792, 1005460, 1005490, 1007079, 1007344, 1007873, 1007874, 1008167, 1008491, 1008492, 1008493, 1008494, 1008495, 1008496, 1008509, 1008868, 1009069, 1009070, 1009777, 1010747, 1012268, 1012579, 1012912, 1015354, 1017162, 1017864, 1018545, 1019087, 1023879, 1024201, 1028834, 1028891, 1000398, 1005157, 1000495, 1001083, 1002437, 1002460, 1002896, 1003096, 1003512, 1024231],
      eCashlessReqId, trackCreateAppt, zivaRequestData = [],
      eCashlessReqData, maNotificationData = [],
      queueSearchData = {};
    return {
      setApptpath: function (value) {
        trackCreateAppt = value;
      },
      startLoading: function (message, element) {
        var myBlockUI = blockUI.instances.get(element);
        myBlockUI.start({
          message: message
        });
        blockUI.noOpen = true;
      },
      getZivaData: function () {
        return this.zivaRequestData;
      },
      setZivaData: function (data) {
        this.zivaRequestData = data;
      },
      stopLoading: function (element) {
        var myBlockUI = blockUI.instances.get(element);
        myBlockUI.stop();
      },
      getApptpath: function () {
        return trackCreateAppt;
      },
      setQueueSearchDetail: function (value) {
        queueSearchData = {
          fromDate: value.fromDate ? value.fromDate : '',
          toDate: value.toDate ? value.toDate : '',
          statusSearch: value.statusSearch ? value.statusSearch : '',
          contractType: value.contractType ? value.contractType : '',
          corporateId: value.corporateId ? value.corporateId : '',
          state: value.state ? value.start : ''
        }
      },
      getQueueSearchDetail: function () {
        return queueSearchData;
      },

      monthDiff: function (d1, d2) {
        var months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth() + 1;
        months += d2.getMonth();
        return months <= 0 ? 0 : months;
      },
      checkPPN: function () {
        var result = false;
        var data = $cookieStore.get('hospital');
        if (data) {
          result = data.isHospitalPPN;
        }
        return result;
      },
      getInvestigationByGroup: function (investigation) {
        angular.forEach(investigation, function (val, index) {
          if (val.groupName) {
            val.groupName = val.groupName.replace(/\s+/g, '');
          }
        });
        var groupObj = {};
        angular.forEach(investigation, function (v, i) {
          if (groupObj[v.groupName]) {
            groupObj[v.groupName].push(v);
          } else {
            groupObj[v.groupName] = new Array();
            groupObj[v.groupName].push(v);
          }
        })
        return groupObj;
      },
      reasonOfCancel: function () {
        var result = ['Attended elsewhere', 'DC ambience not preferred', 'Exhaustion of Domiciliary credit limit', 'Insufficient domiciliary credit limit', 'Your order value is lesser than the minimum order value', 'City/Town not covered', 'The medicines ordered are not available in the region/city', 'Unable to procure medicines', 'Wrong Medicines', 'OTC Products', 'No/Invalid Prescription', 'Cancelled by employee post processing', 'Cancelled by employee before processing', 'No longer need the medicine', 'Delivery is too late', 'Bought the medicine myself', 'Placed order by mistake', 'Employee/Client Requested For Cancellation', 'Duplicate Entry', 'Wrong Package Mapped', 'Appointment Slots Not Available at DC / Hospital', 'Policy Cancelled', 'Request by Insurer', 'Visit type to be changed as per Client / Insurer Request', 'Other'];
        return result;
      },
      getAllChildren: function () {
        return JSON.parse(localStorage.getItem('children'));
      },
      UniqueArrayby: function (collection, keyname) {
        var output = [],
          keys = [];
        angular.forEach(collection, function (item) {
          var key = item[keyname];
          if (keys.indexOf(key) === -1) {
            keys.push(key);
            output.push(item);
          }
        });
        return output;
      },
      isChildrenId: function (erId) {
        var children = JSON.parse(localStorage.getItem('children'));
        return filterFilter(children, {
          'id': erId
        }, true).length > 0;
      },
      isChildForContract: function (contract) {
        var children = JSON.parse(localStorage.getItem('children'));
        return filterFilter(children, {
          'erTypeId': contract
        }, true);
      },
      getChildForContract: function (contract) {
        var result = [];
        var children = JSON.parse(localStorage.getItem('children'));
        if (children) {
          angular.forEach(contract, function (key, value) {
            angular.forEach(children, function (childKey, childValue) {
              if (childKey.erTypeId == key.id) {
                result.push(children[childValue])
              }
            })
          })
        }
        return result;
      },

      resetTime: function () {
        var time = new Date();
        var first = new Date();
        var dd = new Date(first).getDate();
        var mm = new Date(first).getMonth() + 1;
        var yy = new Date(first).getFullYear();
        var hh = 8;
        var ms = 0;
        var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
        return time = new Date(x);
      },
      showAlertMessage: function (errorMsz, isSuccess, isNotification) {
        if (errorMsz) {
          var modalInstance = $uibModal.open({
            keyboard: false,
            backdrop: 'static',
            templateUrl: isNotification ? '/app/components/plusModals/plusAlertNotify.html?version=23' : '/app/components/plusModals/plusAlert.html?version=23',
            controller: ['$scope', '$uibModalInstance', function (scope, $uibModalInstance) {
              scope.errorMsz = '';
              scope.errorMsz = errorMsz;
              scope.isSuccess = isSuccess === true ? true : false;
              scope.closeModal = function () {
                $uibModalInstance.dismiss();
              };
            }],
          });
        }
      },
      dynamicSort: function (property) {
        var sortOrder = 1;
        if (property[0] === '-') {
          sortOrder = -1;
          property = property.substr(1);
        }
        return function (a, b) {
          var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
          return result * sortOrder;
        };
      },
      isReturnFlag: function (collection, id) {
        var results = false;
        angular.forEach(collection, function (key, item) {
          if (key === id) {
            results = true;
            return results;
          }
        });
        return results;
      },
      isReturnFlagForContact: function (collection, id) {
        var results = false;
        angular.forEach(collection, function (key, item) {
          if (key.roleId === id) {
            results = true;
            return results;
          }
        });
        return results;
      },
      groupBy: function (collection, property) {
        var i = 0,
          val, index,
          values = [],
          result = [];
        for (; i < collection.length; i++) {
          val = collection[i][property];
          index = values.indexOf(val);
          if (index > -1)
            result[index].push(collection[i]);
          else {
            values.push(val);
            result.push([collection[i]]);
          }
        }
        return result;
      },
      scrollTo: function (id) {
        $location.hash(id);
        $anchorScroll();
      },
      getPlusUrlPrefix: function (type) {
        switch (type) {
          case 'api':
            return plusServiceUrl;
            break;
          case 'app':
            return hospUrl;
            break;
          case 'maya':
            return mayaUrl;
            break;
          case 'auth':
            return authUrl;
            break;
          case 'hosp':
            return hospUrl;
            break;
          case 'integration-plus-plus':
            return 'https://integration-plus-plus.medibuddy.in/PlusAPI/';
            break;
          case 'integration':
            return 'https://ins-integration.medibuddy.in/';
            break;
          case 'medibuddy':
            return 'https://www.medibuddy.in';
            break;
          default:
            return plusServiceUrl;
            break;
        }
      },
      getIntegrationPlus : function() {
        return integrationPlusUrl;
      },
      getPublicHealthPortalUrl: function () {
        return publicHealthUrl;
      },
      getUrlPrefix: function () {
        return hospitalServiceUrl;
      },
      getPlusUrl: function () {
        return plusUrl;
      },
      getProviderCoreUrl: function() {
        return providerCore;
      },
      getProviderMediBuddyUrl:function(){
        return providerMediBuddyUrl;
      },
      getUrlPrefixForSignalR: function () {
        return signalR;
      },
      getPlusApi: function () {
        return plusServiceUrl;
      },
      getAarogyaPolicyNo: function () {
        return aarogyaPolicyNo;
      },
      getFastrackUrlPrefix: function () {
        return fastrackUrl;
      },
      getDMSHostUrl: function () {
        return DMSUrl;
      },
      getClaimAPIUrl: function () {
        return claimAPIURL;
      },
      getDummyAcessToken: function () {
        return dummyUserAcessToken;
      },
      getProviderCoreNode: function() {
        return providerCoreNode;
      },
      setContracts: function (obj) {
        if (obj) {
          localStorage.setItem('mp_contracts', JSON.stringify(obj));
        }
      },
      getContracts: function () {
        if (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))) {
          return JSON.parse(localStorage.getItem('mp_contracts'));
        } else {
          return null;
        }
      },
      setCorporates: function (obj) {
        if (obj) {
          localStorage.setItem('corporatesdata', obj);
        }
      },
      getCorporatesData: function () {
        return localStorage.getItem('corporatesdata') ? localStorage.getItem('corporatesdata') : null;
      },
      getMaTpaId: function () {
        return 1063871;
      },
      getMaTpaName: function () {
        return "Medi Assist Insurance TPA Pvt. Ltd.";
      },
      setUserProperties: function (obj) {
        if (obj) {
          localStorage.setItem('mp_userProperties', JSON.stringify(obj));
        }
      },
      deleteUserProperties: function () {
        $cookieStore.put('mp_userProperties', null);
      },
      getUserProperties: function (obj) {
        if (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))) {
          return JSON.parse(localStorage.getItem('mp_userProperties'));
        } else {
          return null;
        }
      },
      setConfiguredTpa: function (obj) {
        if (obj) {
          localStorage.setItem('configured_tpa', JSON.stringify(obj));
        }
      },
      deleteConfiguredTpa: function () {
        $cookieStore.put('configured_tpa', null);
      },
      getConfiguredTpa: function () {
        if (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))) {
          return JSON.parse(localStorage.getItem('configured_tpa'))
        } else {
          return [];
        }
      },
      setPayerExtensionFields: function (obj) {
        if (obj) {
          localStorage.setItem('payer_extensionFields', JSON.stringify(obj));
        }
      },
      deletePayerExtensionFields: function () {
        $cookieStore.put('payer_extensionFields', null);
      },
      getPayerExtensionFields: function () {
        if (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))) {
          return JSON.parse(localStorage.getItem('payer_extensionFields'))
        } else {
          return [];
        }
      },
      setProviderData: function (obj) {
        if (obj) {
          localStorage.setItem('mp_providerData', JSON.stringify(obj));
        }
      },
      getProviderData: function (obj) {
        if (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))) {
          return JSON.parse(localStorage.getItem('mp_providerData'));
        } else {
          return null;
        }
      },
      getCorporates: function (data) {
        var id = [];
        if (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')) && JSON.parse(localStorage.getItem('user')).properties && JSON.parse(localStorage.getItem('user')).properties['assigned Corporates']) {
          id.push(parseInt(JSON.parse(localStorage.getItem('user')).properties['assigned Corporates'].split(',')));
          data = filterFilter(data, {
            'id': id
          }, function (actual, expected) {
            return filterFilter(expected, actual).length > 0;
          });
        }
        return data;
      },
      mergeDateTimeObj: function (date, time) {
        var dd = new Date(date).getDate();
        var mm = new Date(date).getMonth();
        var yy = new Date(date).getFullYear();
        var hh = new Date(time).getHours();
        var ms = new Date(time).getMinutes();
        var finaldate = new Date(yy, mm, dd, hh, ms);
        return finaldate;
      },
      getSpecificContract: function (name) {
        var contracts = this.getContracts();
        var cid = [];
        $(contracts).each(function (i, v) {
          if (v.entityName.indexOf(name) != -1) {
            cid.push(v.id);
          }
        })
        return cid;
      },
      getEntitiesForContract: function (contractId) {
        var url = this.getPlusUrlPrefix('integration');
        if (contractId === this.getSpecificContract('E_SALES')) {
          url = url + '/contractlookup/' + contractId + '.json';
        } else {
          url = url + '/EntityRelation/Search/' + contractId + '.json';
        }
        var pr = $http.get(url);
        pr.error(function () { });
        return pr;
      },

      getDownloadURL: function (isCorrespondence) {
        if (isCorrespondence) {
          return (this.getPlusUrlPrefix() + downloadURL);
        } else {
          return (this.getPlusUrlPrefix() + downloadURL);
        }
      },
      showImg: function (status) {
        return status === '1' ? 'ok green' : 'remove red';
      },
      openNewTab: function (name, id, event, parent) {
        if ($('#' + id).length === 0) {
          if (!parent) {
            $('#myTab').append(
              $("<li>").html('<a href="/#tab' + id + '" id="' + id + '" role="tab" data-toggle="tab" class="customer-tab">' + name + '<i class="close">×</i></a>')
            );
          } else {
            $('#SettledTab').append(
              $("<li>").html('<a href="/#tab' + id + '" id="' + id + '" role="tab" data-toggle="tab" class="customer-tab">' + name + '<i class="close">×</i></a>')
            );
          }
          $('#' + id).css("width", $('#' + id).width() + 50 + "px");
        }
        if (!parent) {
          $('#myTab a#' + id).tab('show');
        } else {
          $('#SettledTab a#' + id).tab('show');
        }
      },
      formatCurrency: function (inputCurrency) {
        if (inputCurrency) {
          inputCurrency = inputCurrency.toString();
          var afterPoint = '';
          if (inputCurrency.indexOf('.') > 0)
            afterPoint = inputCurrency.substring(inputCurrency.indexOf('.'), inputCurrency.length);
          inputCurrency = Math.floor(inputCurrency);
          inputCurrency = inputCurrency.toString();
          var lastThree = inputCurrency.substring(inputCurrency.length - 3);
          var otherNumbers = inputCurrency.substring(0, inputCurrency.length - 3);
          if (otherNumbers != '')
            lastThree = ',' + lastThree;
          if (afterPoint.length > 0) {
            if (afterPoint.length === 2)
              afterPoint = afterPoint + '0';
          } else {
            afterPoint = '.00';
          }
          var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + afterPoint;
          return res;
        } else {
          return 0;
        }
      },
      getDDMMYYYY: function (inputDate) {
        function pad(s) {
          return (s < 10) ? '0' + s : s;
        }
        if (inputDate) {
          var d = inputDate
          return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('-');
        }
      },
      getDateObj: function (inputDate) {
        if (inputDate) {
          var d;
          if(inputDate.indexOf('/Date(') >= 0){
          d = new Date(parseInt(inputDate.replace('/Date(', '').replace(')/', ''), 10))
          }else{
            d=inputDate;
          }
          return new Date(d);
        }
      },
      getDateObjNew: function (inputDate) {
        if (inputDate && (inputDate instanceof Date) === false) {
          var d = new Date(parseInt(inputDate.replace('/Date(', '').replace(')/', ''), 10))
          return new Date(d);
        } else if ((inputDate instanceof Date) === true) {
          return inputDate;
        }
      },
      getAuditDate: function (inputDate) {
        if (inputDate) {
          inputDate = new Date(parseInt(inputDate.replace('/Date(', '').replace(')/', ''), 10))
          var dt = inputDate ? new Date(inputDate) : new Date();
          var now = new Date(Date.now());
          var dtString = dt.getDate() + ' ' + dt.getMonth() + ' ' + dt.getFullYear();
          var nowString = now.getDate() + ' ' + now.getMonth() + ' ' + now.getFullYear();
          var dispDate = dtString.split(' ');

          if (dtString === nowString) {
            return 'Today';
          } else if (dt.getFullYear() === now.getFullYear()) {
            return dispDate[1] + ' ' + dispDate[0];
          } else {
            return dispDate[1] + ' ' + dispDate[0] + ' ' + dispDate[2];
          }
        }
      },
      getAuditTime: function (inputDate) {
        inputDate = new Date(parseInt(inputDate.replace('/Date(', '').replace(')/', ''), 10))
        var dt = inputDate ? new Date(inputDate) : new Date();
        var now = new Date(Date.now());
        var dtString = dt.getDate() + ' ' + dt.getMonth() + ' ' + dt.getFullYear();
        var nowString = now.getDate() + ' ' + now.getMonth() + ' ' + now.getFullYear();
        var dispDate = dtString.split(' ');
        var mins = dt.getMinutes().length === 1 ? '0' + dt.getMinutes() : dt.getMinutes();
        var hrs = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours();
        mins = mins < 10 ? '0' + mins : mins;
        var time = hrs + ':' + mins;
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
        if (time.length > 1) { // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? ' am' : ' pm'; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join('');
      },
      formatTime: function (inputDate) {
        if (inputDate) {
          inputDate = new Date(parseInt(inputDate.replace('/Date(', '').replace(')/', ''), 10))
          var dt = inputDate ? new Date(inputDate) : new Date();
          var mins = dt.getMinutes().length === 1 ? '0' + dt.getMinutes() : dt.getMinutes();
          mins = mins < 10 ? '0' + mins : mins;
          var hrs = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours();
          var time = hrs + ':' + mins;
          time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
          if (time.length > 1) { // If time format correct
            time = time.slice(1); // Remove full string match value
            time[5] = +time[0] < 12 ? ' am' : ' pm'; // Set AM/PM
            time[0] = +time[0] % 12 || 12; // Adjust hours
          }
          return time.join('');
        }
      },
      formatTimeNew: function (inputDate) {
        var dt = (inputDate && (inputDate instanceof Date) === false) ? new Date(inputDate) : inputDate;
        return String(dt.getHours()).padStart(2, '0') + " " + String(dt.getMinutes()).padStart(2, '0');
      },
      formatDateNumber: function (inputDate) {
        if (inputDate) {
          inputDate = new Date(parseInt(inputDate.replace('/Date(', '').replace(')/', ''), 10))
          var dt = inputDate ? new Date(inputDate) : new Date();
          var mins = dt.getMinutes().length === 1 ? '0' + dt.getMinutes() : dt.getMinutes();
          var hrs = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours();
          return dt.getFullYear() + '/' + (dt.getMonth() + 1) + '/' + dt.getDate() + ' ' + hrs + ':' + mins;
        }
      },
      getInsuranceCompanyName: function () {
        return insuranceCompanyName;
      },
      compareDateNew: function (inputDate) {
        var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        if (inputDate && (inputDate instanceof Date) === false) {
          inputDate = new Date(parseInt(inputDate.replace('/Date(', '').replace(')/', ''), 10));
          var dt = inputDate ? new Date(inputDate) : new Date();
          var now = new Date(Date.now());
          var dtString = dt.getDate() + ' ' + monthNames[dt.getMonth()] + ' ' + dt.getFullYear();
          var nowString = now.getDate() + ' ' + monthNames[now.getMonth()] + ' ' + now.getFullYear();
          var dispDate = dtString.split(' ');
          if (dtString === nowString) {
            var mins = dt.getMinutes() === '0' ? '00' : dt.getMinutes();
            var time = dt.getHours() + ':' + mins;
            time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
            if (time.length > 1) { // If time format correct
              time = time.slice(1); // Remove full string match value
              time[5] = +time[0] < 12 ? ' am' : ' pm'; // Set AM/PM
              time[0] = +time[0] % 12 || 12; // Adjust hours
            }
            return 'Today';
          } else {
            return dispDate[0] + ' ' + dispDate[1] + ' ' + dispDate[2];
          }
        } else {
          var dt = inputDate;
          var now = new Date(Date.now());
          var dtString = dt.getDate() + ' ' + monthNames[dt.getMonth()] + ' ' + dt.getFullYear();
          var nowString = now.getDate() + ' ' + monthNames[now.getMonth()] + ' ' + now.getFullYear();
          var dispDate = dtString.split(' ');
          if (dtString === nowString) {
            var mins = dt.getMinutes() === '0' ? '00' : dt.getMinutes();
            var time = dt.getHours() + ':' + mins;
            time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
            if (time.length > 1) { // If time format correct
              time = time.slice(1); // Remove full string match value
              time[5] = +time[0] < 12 ? ' am' : ' pm'; // Set AM/PM
              time[0] = +time[0] % 12 || 12; // Adjust hours
            }
            return 'Today';
          } else {
            return dispDate[0] + ' ' + dispDate[1] + ' ' + dispDate[2];
          }
        }
      },
      compareDate: function (inputDate) {
        if (inputDate && inputDate.indexOf('/Date(') > -1) {
          var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          inputDate = new Date(parseInt(inputDate.replace('/Date(', '').replace(')/', ''), 10));
          var dt = inputDate ? new Date(inputDate) : new Date();
          var now = new Date(Date.now());
          var dtString = dt.getDate() + ' ' + monthNames[dt.getMonth()] + ' ' + dt.getFullYear();
          var nowString = now.getDate() + ' ' + monthNames[now.getMonth()] + ' ' + now.getFullYear();
          var dispDate = dtString.split(' ');
          if (dtString === nowString) {
            var mins = dt.getMinutes() === '0' ? '00' : dt.getMinutes();
            var time = dt.getHours() + ':' + mins;
            time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
            if (time.length > 1) { // If time format correct
              time = time.slice(1); // Remove full string match value
              time[5] = +time[0] < 12 ? ' am' : ' pm'; // Set AM/PM
              time[0] = +time[0] % 12 || 12; // Adjust hours
            }
            return 'Today';
          } else if (dt.getFullYear() === now.getFullYear()) {
            return dispDate[0] + ' ' + dispDate[1];
          } else {
            return dispDate[0] + ' ' + dispDate[1] + ' ' + dispDate[2];
          }
        } else {
          return inputDate;
        }
      },
      TATinClaim: function (tatDate, dod) {
        var tatDate = this.getDateObjNew(tatDate);
        var dod = this.getDateObjNew(dod);
        var final = Math.max(dod, tatDate);
        var final = new Date(final);
        var tat;
        tat = parseInt((this.getDateObjNew(new Date()) - final) / (1000 * 60 * 60 * 24));
        return tat
      },
      renderClaimsList: function (resData, type) {
        var claimsList = [];
        if (!resData.hospitalClaimSearchResults) {
          resData.hospitalClaimSearchResults = resData.claims;
        }
        if (!resData.hospitalClaimSearchResults) {
          resData.hospitalClaimSearchResults = resData.plannedHospClaims;
        }
        if (resData.isSuccess && resData.hospitalClaimSearchResults && resData.hospitalClaimSearchResults.length > 0) {
          for (var i = 0; i < resData.hospitalClaimSearchResults.length; i++) {
            var obj = {
              id: resData.hospitalClaimSearchResults[i].benefMAID ? resData.hospitalClaimSearchResults[i].benefMAID : resData.hospitalClaimSearchResults[i].uniqueId,
              tableId: resData.hospitalClaimSearchResults[i].otherTPAId,
              patientName: resData.hospitalClaimSearchResults[i].benefName ? resData.hospitalClaimSearchResults[i].benefName : resData.hospitalClaimSearchResults[i].name,
              isOtherTpa: resData.hospitalClaimSearchResults[i].isOtherTpa,
              conversationCount: 3,
              claimId: resData.hospitalClaimSearchResults[i].claimId,
              procedure: resData.hospitalClaimSearchResults[i].claimType,
              claimedAmount: resData.hospitalClaimSearchResults[i].clmAmount ? resData.hospitalClaimSearchResults[i].clmAmount : resData.hospitalClaimSearchResults[i].claimedAmnt,
              approvedAmount: resData.hospitalClaimSearchResults[i].clmApprovedAmt ? resData.hospitalClaimSearchResults[i].clmApprovedAmt : resData.hospitalClaimSearchResults[i].approvedAmnt,
              status: resData.hospitalClaimSearchResults[i].status,
              dateOfAdmission: this.compareDateNew(resData.hospitalClaimSearchResults[i].doa),
              dateOfDischarge: this.compareDateNew(resData.hospitalClaimSearchResults[i].dod),
              secClaimId: resData.hospitalClaimSearchResults[i].secClaimId,
              claimRefNo: resData.hospitalClaimSearchResults[i].claimRefNo,
              scheme: resData.hospitalClaimSearchResults[i].scheme,
              schemeName: resData.hospitalClaimSearchResults[i].schemeName,
              govScheme: resData.hospitalClaimSearchResults[i].govScheme,
              clmUTRNo: resData.hospitalClaimSearchResults[i].clmUTRNo,
              clmSettledAmount: resData.hospitalClaimSearchResults[i].clmSettledAmount,
              isHospPendingDocConcurrencePresent: resData.hospitalClaimSearchResults[i].isHospPendingDocConcurrencePresent,
              hosp_PendingDocIssue: resData.hospitalClaimSearchResults[i].hosp_PendingDocIssue,
              hosp_DocSubmissiondate: resData.hospitalClaimSearchResults[i].hosp_DocSubmissiondate,
              hosp_TrackingNumber: resData.hospitalClaimSearchResults[i].hosp_TrackingNumber,
              hosp_IssueResponse: resData.hospitalClaimSearchResults[i].hosp_IssueResponse,
              settleDate: this.compareDate(resData.hospitalClaimSearchResults[i].settleDate),
              isHospIssueConcurrencePresent: resData.hospitalClaimSearchResults[i].isHospIssueConcurrencePresent,
              hospIssueRemarks: resData.hospitalClaimSearchResults[i].hospIssueRemarks,
              isInfoAwaitedClaim: resData.hospitalClaimSearchResults[i].isInfoAwaitedClaim,
              isSettledClaim: resData.hospitalClaimSearchResults[i].isSettledClaim,
              hosp_PendingDocIssueRemarks: resData.hospitalClaimSearchResults[i].hosp_PendingDocIssueRemarks,
              dbType: resData.hospitalClaimSearchResults[i].dbType,
              TATinClaim: this.TATinClaim(resData.hospitalClaimSearchResults[i].lastDocumentReceivedDate, resData.hospitalClaimSearchResults[i].dod),
              isAnswerSubmitted: resData.hospitalClaimSearchResults[i].isAnswerSubmitted,
              patientAge: resData.hospitalClaimSearchResults[i].age,
              patientContactNo: resData.hospitalClaimSearchResults[i].claimContactNumber,
              tpaName: resData.hospitalClaimSearchResults[i].tpaName,
              otherTPAStatusId: resData.hospitalClaimSearchResults[i].otherTPAStatusId,
              extraFields: resData.hospitalClaimSearchResults[i].extraFields,
              isGovtScheme: resData.hospitalClaimSearchResults[i].isGovtScheme,
              tpaId: resData.hospitalClaimSearchResults[i].tpaId,
              diagnosis: resData.hospitalClaimSearchResults[i].diagnosis,
              roomType: resData.hospitalClaimSearchResults[i].roomType
              //lastDocumentReceivedDate //settleDate  //clmLastUpdate   //claimReceivedDate
            };
            if (type !== 'cashless') {
              obj['paApprovedAmount'] = resData.hospitalClaimSearchResults[i].paApprovedAmt;
            }
            if (type === 'govt') {
              obj['paApprovedAmount'] = resData.hospitalClaimSearchResults[i].approvedAmnt;
              obj.urn = resData.hospitalClaimSearchResults[i].urn;
              obj.tooltipDisplay = (resData.hospitalClaimSearchResults[i].hospitalName) +
                (resData.hospitalClaimSearchResults[i].createdOn ? ', Created on : ' + this.compareDate(resData.hospitalClaimSearchResults[i].createdOn) : '') +
                (resData.hospitalClaimSearchResults[i].lastUpdatedOn ? ', Last updated on : ' + this.compareDate(resData.hospitalClaimSearchResults[i].lastUpdatedOn) : '');
            }
            claimsList.push(obj);
          }
        } else { }
        return claimsList;
      },
      addpackage: function (value) {
        var data = []
        var item = {
          packageName: value.packagE_NAME,
          package_Name: value.packagE_NAME,
          packageId: value.packagE_ID,
          packageAmount: value.packagE_PRICE,
          packageCappedAmount: 0,
          cmS_CHARGE_TYPE_ID: 0,
          cmS_CHARGE_TYPE_DESC: '',
          cmS_SUBCHARGE_TYPE_ID: 0,
          cmS_SUBCHARGE_TYPE_DESC: '',
          hospitaL_CHARGE_HEAD: value.packagE_NAME,
          isReadOnly: true,
          isPackage: true,
          uniqueIds: 0
        }
        data.push(item);
        return data;
      },
      renderPlannedRequests: function (resData, type) {
        var claimsList = [];
        if (resData && resData.length > 0 && type === 'preauth') {
          for (var i = 0; i < resData.length; i++) {
            var obj = {
              plannedHospId: resData[i].id,
              id: resData[i].maid,
              patientName: resData[i].patienT_NAME,
              procedure: resData[i].procedure,
              dateOfAdmission: this.getDateObj(resData[i].doa),
              dateOfDischarge: this.getDateObj(resData[i].dod),
              mobileNumber: resData[i].mobilE_NUMBER,
              corporateName: resData[i].corporatE_NAME,
              employeeId: resData[i].employeE_ID,
              doctorName: resData[i].doctoR_NAME,
              actionBy: resData[i].actioN_BY,
              actionAt: this.compareDate(resData[i].actioN_AT),
              isConfirmed: resData[i].isconfirmed,
              roomType: resData[i].rooM_TYPE,
              gender: resData[i].gender,
              dob: this.compareDate(resData[i].dob),
              diagnosis: resData[i].diagnosis,
              source: resData[i].source,
              plannedHospPackage: resData[i].plannedHospPackage ? this.addpackage(resData[i].plannedHospPackage) : []
            };
            claimsList.push(obj);
          }
        }
        return claimsList;
      },
      getMessasgeObj: function (background, body, header, show) {
        return {
          'background': background,
          'body': body,
          'header': header,
          'show': show,
        }
      },
      checkEBillHospital: function (hospId) {
        if (eBillHospital.indexOf(hospId) > -1)
          return true;
        return false;
      },
      getToUpperCase: function (str) {
        if (str && str.length > 0) {
          return str.toString().toUpperCase();
        }
        return str;
      },
      getToLowerCase: function (str) {
        if (str && str.length > 0) {
          return str.toString().toLowerCase();
        }
        return str;
      },
      getAge: function (dateOfBirth) {
        if (!dateOfBirth || dateOfBirth === "/Date(-62135596800000-0000)/")
          return;
        else {
          var dob = new Date(parseInt(dateOfBirth.replace('/Date(', '').replace(')/', ''), 10))
          var today = new Date();
          var age = Math.floor((today - dob) / (365.25 * 24 * 60 * 60 * 1000));
          return age;
        }
      },
      getFileNameFromPath: function (path) {
        if (path && path.length > 0)
          return path.replace(/^.*[\\\/]/, '');
      }
    };
  }])

'use strict';
angular.module('mbplus.safeApply', ['ngCookies']).value('version', '0.1')
.factory('safeApply', [function () {
    return function ($scope, fn) {
        var phase = $scope.$root.$$phase;
        if (phase === '$apply' || phase === '$digest') {
            if (fn) {
                $scope.$eval(fn);
            }
        } else {
            if (fn) {
                $scope.$apply(fn);
            } else {
                $scope.$apply();
            }
        }
    }
}]);


'use strict';
angular.module('mbplus.profileService', ['ngCookies']).value('version', '0.1')
  .service('ProfileService', ['UtilitiesService', 'UserService', function (UtilitiesService, UserService) {
    var profileAPIs = {
      getProviderDetails : "/Provider/ProfileData",
      getProviderDoctorDetails : "/Provider/Profile/GetHospitalDoctorDetails",
      getProviderContracts : "/Provider/Profile/GetHospitalContractDetails",
      getProviderOpPackages : "/Provider/Profile/GetHospitalPackagesDetails",
      getProviderIpPackages : "/provider/Profile/GetHospitalIPPackagesDetails",
      getProviderDiscounts : "/Provider/Profile/GetHospitalDiscountDetails",
      getProviderMasterData : "/Provider/Master/GetMasterLookup",
      updateProfileDetails : "/Provider/Profile/AddUpdateProviderProfileDetails",
      updateContactDetails : "/Provider/Profile/AddUpdateHospitalContact",
      updateDoctorDetails : "/Provider/Profile/AddUpdateDoctorDetail",
      updateRoomDetails : "/Provider/Profile/AddUpdateRoom",
      updateContracts : "/Provider/Profile/AddUpdateHospitalContracts",
      updateProviderOpPackages : "/Provider/Profile/AddUpdatePackages",
      updateProviderIpPackages : "/provider/Profile/AddUpdateIPPackages"
    }
    return {
      instructions: [{
          instruction: 'Please report to the Health Check reception by time scheduled during Appointment.'
        },
        {
          instruction: 'For Fasting Blood Sugar & Lipid Profile tests a 12 hours fasting is required (only plain water is permitted).'
        },
        {
          instruction: 'Abstain from alcohol for at least 12 hours prior to the check-up.'
        },
        {
          instruction: 'Avoid exercise in the morning on the day of health check-up.'
        },
        {
          instruction: 'Bring all your earlier medical records (last 3 years) and medical accessories like glasses, hearing aid (if any) when you come for the Health check'
        },
        {
          instruction: 'If you are on regular medication, please continue to take it as before'
        },
        {
          instruction: 'If you are Diabetic or Hypertensive and taking medication, please take the scheduled medication on the day of the check up after giving fasting sample.'
        },
        {
          instruction: 'Pap smear & Urine test cannot be carried out for ladies during their menstrual period.'
        },
        {
          instruction: 'While undergoing pre-health check evaluation, please inform the Doctor in case you are pregnant or have any other pre-existing medical conditions. Some of the tests that form a part of the health check package may not be suitable for you. For example, pregnant women should not undergo an X-ray examination.'
        },
        {
          instruction: 'Please wear minimum jewellery, comfortable attire and footwear on the day of health check.'
        },
        {
          instruction: 'Please bring your morning stool and urine samples along with you on the date of the Health Check. You can collect the container from the Health Check Department in advance as per your convenience.'
        },
        {
          instruction: 'For Spirometry/ Pulmonary Function test intake of inhalers needs to be avoided for 24 hour, hence candidate should consult their prescribing physician'
        },
        {
          instruction: 'Do inform us in case of cancellation or postponement as the slot may be used by another person.'
        },
        {
          instruction: 'There will be optimal waiting time for each test as per your selected package.'
        },
      ],
      quoteData: [{
          dayOfWeek: 'Monday',
          quotaValue: null
        },
        {
          dayOfWeek: 'Tuesday',
          quotaValue: null
        },
        {
          dayOfWeek: 'Wednesday',
          quotaValue: null
        },
        {
          dayOfWeek: 'Thursday',
          quotaValue: null
        },
        {
          dayOfWeek: 'Friday',
          quotaValue: null
        },
        {
          dayOfWeek: 'Saturday',
          quotaValue: null
        },
        {
          dayOfWeek: 'Sunday',
          quotaValue: null
        }
      ],

      daysName: [{
          name: "Monday",
          checked: false
        }, {
          name: "Tuesday",
          checked: false
        }, {
          name: "Wednesday",
          checked: false
        },
        {
          name: "Thursday",
          checked: false
        }, {
          name: "Friday",
          checked: false
        }, {
          name: "Saturday",
          checked: false
        },
        {
          name: "Sunday",
          checked: false
        }
      ],

      educationList: [{
          label: 'MD',
          category: ["Aviation Medicine", "Aviation Medicine/Aerospace Medicine",
            "Dermatology, Venereology & Leprosy", "Dermatology", "Emergency Medicine", "Endocrinology", "Family Medicine",
            "General Medicine", "Geriatrics", "Immuno Haematology & Blood Transfusion", "Internal Medicine",
            "Maternity & Child Health", "Medical Genetics", "Nephrology", "Nuclear Medicine", "Obstetrtics & Gynaecology",
            "Ophthalmology", "Paediatrics", "Palliative Medicine", "Physical Medicine & Rehabilitation", "Psychiatry",
            "Pulmonary Medicine", "Radio Diagnosis", "Radio Diagnosis/Radiology", "Radiology", "Radiotherapy", "Rheumatology",
            "Skin & VD & Lepxsy", "Skin & VD", "Sports Medicine", "TB & Chest", "Thoracic Medicine", "Transfusion Medicine",
            "Tropical Medicine", "Tuberculosis & Respiratory Diseases / Pulmonary Medicine",
            "Tuberculosis & Respiratory Diseases/Medicine", "Venereology", "Cardiology"
          ]
        },
        {
          label: 'Diploma',
          category: ["Allergy & Clinical Immunology", "Aviation Medicine", "Cardiology", "Child Health",
            "Dermatology", "Dermatology, Venereology and Leprosy", "Diabetology", "Diplom V & D", "ENT", "Gastroenterology",
            "General Medicine", "General Surgery", "Genito Urinary Surgery", "Industrial Health", "Industrial Hygiene",
            "Internal Medicine", "Leprosy", "Marine Medicine", "Maternity & Child Welfare", "Medical Radio Electrology",
            "Medical RadioDiagnosis", "Medical Radiology and Electrology", "Medical Virology", "Nephrology", "Neurology",
            "Neuropathology", "Neurosurgery", "Nutrition", "Obstetrics & Gynaecology", "Occupational Health",
            "OLO RhinoLaryngology", "Ophthalmology", "Orthopaedics", "OtoRhinoLaryngology", "Paediatric Surgery", "Paediatrics",
            "Pathology & Bacteriology", "Peripheral Vascular Surgery", "Physical Medicine & Rehabilitation",
            "Plastic Surgery", "PSM", "Psychiatry", "Public Health", "Radiation Medicine", "Radio Therapy", "Radiological Physics",
            "Respiratory Medicine", "Rheumatology", "Sports Medicine", "Surgical Oncology", "Tropical Medicine Health",
            "Tuberculosis & Chest Diseases", "Urology", "Implantology", "Orthodontics"
          ]
        },
        {
          label: 'DM',
          category: ["Clinical Pharmacology", "Clinical Haematology", "Pulmonary Medicine", "Neuro Radiology",
            "Nephrology", "Neonatology", "Oncology", "Gastroenterology", "Cardiology", "Neurology", "Rheumatology", "Endocrinology",
            "Clinical Immunology", "Pul. Med. & Critical Care Med.", "Haematology Pathology/Hematopthology", "Medical Genetics",
            "Infectious Diseases", "Hepatology", "Immunology", "Child & Adolescent Psychiatry", "Pediatrics Gastroenterology",
            "Pediatrics Cardiology", "Paediatric Nephrology", "Reproductive Medicine", "Infectious Disease", "Virology",
            "Paediatric Oncology", "Geriatric Mental Health", "Paediatric Hepatology"
          ]
        },
        {
          label: 'DNB',
          category: ["Allergy & Clinical Immunology", "Aviation Medicine", "Cardiology", "Child Health",
            "Dermatology", "Dermatology, Venereology and Leprosy", "Diabetology", "Diplom V & D", "ENT", "Gastroenterology",
            "General Medicine", "General Surgery", "Genito Urinary Surgery", "Internal Medicine", "Leprosy", "Marine Medicine",
            "Maternity & Child Welfare", "Medical Radio Electrology", "Medical RadioDiagnosis",
            "Medical Radiology and Electrology", "Medical Virology", "Nephrology", "Neurology", "Neuropathology", "Neurosurgery",
            "Nutrition", "Obstetrics & Gynaecology", "Occupational Health", "OLO RhinoLaryngology", "Ophthalmology", "Orthopaedics",
            "OtoRhinoLaryngology", "Paediatric Surgery", "Paediatrics", "Peripheral Vascular Surgery",
            "Physical Medicine & Rehabilitation", "Plastic Surgery", "PSM", "Psychiatry", "Psychological Medicine",
            "Radiation Medicine", "Radio Therapy", "RadioDiagnosis", "Respiratory Medicine", "Rheumatology", "Sports Medicine",
            "Surgical Oncology", "Tropical Medicine Health", "Tuberculosis & Chest Diseases", "Urology", "Venereology",
            "Cardiac Surgery", "Family Medicine", "Laproscopic Surgery", "Medical Oncology", "Surgical Gastroenterology",
            "Cardio Thoracic and Vascular Surgery", "Cardiac Surgery", "Family Medicine", "Laparoscopic Surgery",
            "Medical Oncology"
          ]
        },
        {
          label: 'Mch',
          category: ["Hand Surgery", "Gynaecological Oncology", "Pediatric Cardio-Thoracic Vascular Surgery",
            "Plastic & Reconstructive Surgery", "Hepato Pancreato Biliary Surgery", "Urology/Genito-Urinary Surgery",
            "Hand & Micro Surgery", "Burns & Plastic Surgery", "Endocrine Surgery", "Oncology", "Vascular Surgery",
            "Cardio Thoracic Surgery", "Cardio Thoracic and Vascular Surgery", "Neuro Surgery", "Paediatric Surgery",
            "Plastic Surgery", "Surgical Gastroenterology/G.I. Surgery", "Surgical Oncology", "Thoracic Surgery",
            "Urology", "Orthopaedics"
          ]
        },
        {
          label: 'MDS',
          category: ["Prosthodontics", "Periodontics", "Orthodontics", "Oral & Maxillofacial Surgery",
            "Operative Dentistry", "Pedodontics & Preventive Dentistry", "Conservative, Endodontics & Aesthetic Dentistry",
            "Periodontology & Oral Implantology", "Oral Medicine & Radiology"
          ]
        },
        {
          label: 'MPT',
          category: ["Orthopedics", "Neurology", "Cardiopulmonary", "Sports& Paediatric Physiotherapy"]
        },
        {
          label: 'MS',
          category: ["ENT", "General Surgery", "Neuro Surgery", "Obstetrics & Gynaechology",
            "Ophthalmology", "Orthopaedics", "Traumatology & Surgery", "Oncology", "Urology"
          ]
        },
        {
          label: 'MSc',
          category: ["Food & Nutrition", "Psychology", "Applied Neuro Psychology", "Psychology"]
        },
        {
          label: 'MBBS',
          category: ["General Medicine", "Ophthalmology", "General Surgery", "Orthopaedics",
              "Paediatrics", "ENT", "Obstetrics & Gynaecology", "Psychiatry", "Dermatology", "Anaesthesiology"
          ]
        },
        {
          label: 'BDS',
          category: ["Dental"]
        },
        {
          label: 'BPT',
          category: ["Physiotherapy"]
        },
        {
          label: 'M.Phil',
          category: ["Psychology"]
        },
        {
          label: 'DGO',
          category: ["Gynecology"]
        },
        {
          label: 'MA',
          category: ["Psychology"]
        },
        {
          label: 'BA',
          category: ["Psychology"]
        },
        {
          label: 'FVRS',
          category: ["Retina Surgeon"]
        },
        {
          label: 'FIBD',
          category: ["Oncoplasty"]
        },
        {
          label: 'DVD',
          category: ["Dermatology"]
        },
        {
          label: 'Fellowship',
          category: ["Gastroenterology"]
        },
        {
          label: 'ACMDC',
          category: ["Diabetes & Cardiovascular Disease"]
        },
        {
          label: 'CCEBDM',
          category: ["Diabetology"]
        }
      ],

      languages: [{
        id: 1,
        label: 'English'
      }, {
        id: 2,
        label: 'Hindi'
      }, {
        id: 3,
        label: 'Bengali'
      }, {
        id: 4,
        label: 'Telugu'
      }, {
        id: 5,
        label: 'Marathi'
      }, {
        id: 6,
        label: 'Tamil'
      }, {
        id: 7,
        label: 'Urdu'
      }, {
        id: 8,
        label: 'Gujarati'
      }, {
        id: 9,
        label: 'Kannada'
      }, {
        id: 10,
        label: 'Malayalam'
      }, {
        id: 11,
        label: 'Odia'
      }, {
        id: 12,
        label: 'Punjabi'
      }, {
        id: 13,
        label: 'Assamese'
      }, {
        id: 14,
        label: 'Kashmiri'
      }, {
        id: 15,
        label: 'Konkani'
      }, {
        id: 16,
        label: 'Tulu'
      }],

      checkRole : function(id) {
        var user = UserService.getUserObj()
        var result = false;
        if (user && user.rolesFeatures && user.rolesFeatures.roles) {
          user.rolesFeatures.roles.forEach(function (elem) {
            if (elem.roleId == id) {
              result = true;
            }
          })
        }
        return result;
      },

      loadProviderProfileDataByKey: function (keyName, payload) {
        var getApi = profileAPIs.getProviderDetails;
        payload.getHospitalDetailsByHospitalIds = true;
        payload.hospitalIds = [UserService.getHospitalObj().hospId]
        var promise = UserService.makeRestCall(UtilitiesService.getPlusUrl() + getApi, payload, 'POST', UserService.getAccessToken()).then(function (response) {
          if (response.data.isSuccess) {
            if (keyName == 'doctor') return response.data.hospitals.hospitalsDoctorDetails;
            else if (keyName == 'room') return response.data.hospitals.hospitalsRoomDetails;
            else if (keyName == 'contact') return response.data.hospitals.hospitalsContactDetails;
            else if (keyName == 'document') return response.data.hospitals.hospitalsDocumentDetails;
            else if (keyName == 'package') return response.data.hospitals.hospitalPakageDetails;
            else if (keyName == 'discount') return response.data.hospitals.hospitalDiscountDetails;
            else if (keyName == 'profile') return response.data.hospitals;
          }
          else {
            return false;
          }
        });
        promise.catch(function (error) {
          UtilitiesService.showAlertMessage('Oops! Something went wrong, please try again later.');
        })

        return promise;
      },

      loadProviderDoctorData: function (payload) {
        var getApi = profileAPIs.getProviderDoctorDetails;
        payload.getHospitalDoctorDetailsByHospitalIds = true;
        payload.hospitalIds = [UserService.getHospitalObj().hospId]
        var promise = UserService.makeRestCall(UtilitiesService.getPlusUrl() + getApi, payload, 'POST', UserService.getAccessToken()).then(function (response) {
          if (response.data.isSuccess) {
            return response.data;
          }
          else {
            return false;
          }
        });
        promise.catch(function (error) {
          UtilitiesService.showAlertMessage('Oops! Something went wrong, please try again later.');
        })

        return promise;
      },

      loadProviderPackagesByKey: function (key,payload) {
        var getApi;
        if(key == 'OP') getApi = profileAPIs.getProviderOpPackages;
        else if(key == 'IP') getApi = profileAPIs.getProviderIpPackages;
        payload.getHospitalPackagesDetailsByHospitalIds = true;
        payload.hospitalIds = [UserService.getHospitalObj().hospId]
        var promise = UserService.makeRestCall(UtilitiesService.getPlusUrl() + getApi, payload, 'POST', UserService.getAccessToken()).then(function (response) {
          if (response.data.isSuccess) {
            return response.data;
          }
          else {
            return false;
          }
        });
        promise.catch(function (error) {
          UtilitiesService.showAlertMessage('Oops! Something went wrong, please try again later.');
        })

        return promise;
      },

      loadProviderMasterByKey : function (payload) {
        var getApi = profileAPIs.getProviderMasterData;
        payload.lookUpByColumnName = true;
        var promise = UserService.makeRestCall(UtilitiesService.getPlusUrl() + getApi, payload, 'POST', UserService.getAccessToken()).then(function (response) {
          if (response.data.isSuccess) {
            return response.data;
          }
          else {
            return false;
          }
        });
        promise.catch(function (error) {
          UtilitiesService.showAlertMessage('Oops! Something went wrong, please try again later.');
        })

        return promise;
      },

      loadProviderContracts: function (payload) {
        var getApi = profileAPIs.getProviderContracts;
        payload.getHospitalDocumentDetailsByHospitalIds = true;
        payload.hospitalIds = [UserService.getHospitalObj().hospId];
        var promise = UserService.makeRestCall(UtilitiesService.getPlusUrl() + getApi, payload, 'POST', UserService.getAccessToken()).then(function (response) {
          if (response.data.isSuccess) {
            return response.data;
          } 
          else {
            return false;
          }
        });
        promise.catch(function (error) {
          UtilitiesService.showAlertMessage('Oops! Something went wrong, please try again later.');
        })

        return promise;
      },

      loadProviderDiscounts: function(payload) {
        var getApi = profileAPIs.getProviderDiscounts;
        payload.getHospitalDiscountDetailsByHospitalIds = true;
        payload.hospitalIds = [UserService.getHospitalObj().hospId];
        var promise = UserService.makeRestCall(UtilitiesService.getPlusUrl() + getApi, payload, 'POST', UserService.getAccessToken()).then(function (response) {
          if (response.data.isSuccess) {
            return response.data;
          } 
          else {
            return false;
          }
        });
        promise.catch(function (error) {
          UtilitiesService.showAlertMessage('Oops! Something went wrong, please try again later.');
        })

        return promise;
      },

      updateProviderProfileDataByKey: function (keyName, payload) {
        var getApi;
        if(keyName == 'profile') getApi = profileAPIs.updateProfileDetails;
        else if(keyName == 'room') getApi = profileAPIs.updateRoomDetails;
        else if(keyName == 'contact') getApi = profileAPIs.updateContactDetails;
        else if(keyName == 'doctor') getApi = profileAPIs.updateDoctorDetails;
        else if(keyName == 'contract') getApi = profileAPIs.updateContracts;
        else if(keyName == 'opPackages') getApi = profileAPIs.updateProviderOpPackages;
        else if(keyName == 'ipPackages') getApi = profileAPIs.updateProviderIpPackages;

        var promise = UserService.makeRestCall(UtilitiesService.getPlusUrl() + getApi, payload, 'POST', UserService.getAccessToken()).then(function (response) {
          if (response.data.isSuccess) {
            return response.data;
          } 
          else {
            return false;
          }
        });
        promise.catch(function (error) {
          UtilitiesService.showAlertMessage('Oops! Something went wrong, please try again later.');
        })

        return promise;
      },
    }
  }])

'use strict';
angular.module('mbplus.plusUtilitiesService', ['ngCookies']).value('version', '0.1')
.service('PlusUtilitiesService', ['$anchorScroll', '$location', '$cookieStore', '$http', 'UserService', function ($anchorScroll, $location, $cookieStore, $http, UserService) {
    var DC_MA_ContractID = '5290';
    var DC_Inv_PmTypeId = '5292';
    var downloadURL = 'File/true/';
    return {
        getAccessToken: function () {
            var accessToken = '';
            var user = UserService.getUserObj();
            if (user) {
                accessToken = user.accessToken;
            }
            return accessToken;
        },
        getContracts: function () {
            if (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))) {
                return JSON.parse(localStorage.getItem('mp_contracts'));
            }
            else {
                return null;
            }
        },

        getSpecificContract: function (name) {
            var contracts = this.getContracts();
            var cid = [];
            $(contracts).each(function (i, v) {
                if (v.entityName.indexOf(name) != -1) {
                    cid.push(v.id);
                }
            })
            return cid;
        },
        getDC_MA_PRE_EMP_ContractID: function () {
            return this.getSpecificContract('Pre-Employment')[0];
        },
        getAllowedSplitContracts: function () {
            return this.getSpecificContract('Pre-Policy');
        },
        getDC_MA_ContractID: function () {
            return DC_MA_ContractID;
        },
        get_Drug_Test: function () {
            return this.getSpecificContract('Drug Test')[0];
        },
        getPharmaContract: function () {
            return this.getSpecificContract('PharmaContract')[0];
        },
        getDC_Inv_PmTypeId: function () {
            return DC_Inv_PmTypeId;
        },
        getUserRoles: function () {
            return (localStorage.getItem('user')? JSON.parse(localStorage.getItem('user')).rolesFeatures.roles : null);
        },
        getUserFeatures: function () {
            return (localStorage.getItem('user')? JSON.parse(localStorage.getItem('user')).rolesFeatures.features : null);
        },
        setFetauresForPlus: function (allowedFeatureList) {
            localStorage.setItem('featureList', JSON.stringify(allowedFeatureList));
        },
        getMenuDetails: function () {
            var menuItemList = {
                '5435': {
                    'id': 'appointments',
                    'href': '/appointments',
                    'analyticson': 'click',
                    'analyticsevent': 'Active',
                    'menuItem': 'Active',
                    'icon': 'fa fa-angle-right',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '9194': {
                    'id': 'allappointments',
                    'href': '/allappointments',
                    'analyticson': 'click',
                    'analyticsevent': 'All Appointments',
                    'menuItem': 'All',
                    'icon': 'fa fa-angle-right',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '9193': {
                    'id': 'unconfirmedorder',
                    'href': '/unconfirmedorder',
                    'analyticson': 'click',
                    'analyticsevent': 'Approved Cancellations',
                    'icon': 'fa fa-angle-right',
                    'menuItem': 'Unconfirmed Order ',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '9202': {
                    'id': 'appointmentSearch',
                    'href': '/appointmentSearch',
                    'analyticson': 'click',
                    'analyticsevent': 'Appointment Search',
                    'icon': 'fa fa-search',
                    'menuItem': 'Search',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '5436': {
                    'id': 'Finance',
                    'href': '',
                    'analyticson': 'click',
                    'analyticsevent': 'Payments Pending',
                    'menuItem': 'Finance',
                    'icon': 'fa fa-inr',
                    'applicationName': ['DCPortal'],
                    'profileMenu': [{
                        'name': 'Pending',
                        'href': '/payments',
                        'analyticsevent': 'Pending payments',
                        'icon': 'fa fa-angle-right',
                        'menuItem': 'Pending'
                    }, {
                        'name': 'Settled',
                        'href': '/paymentsSettled',
                        'analyticsevent': 'Settled payments',
                        'icon': 'fa fa-angle-right',
                        'menuItem': 'Settled'
                    }]
                },
                '5440': {
                    'id': 'profile',
                    'href': '/plusProfile',
                    'analyticson': 'click',
                    'analyticsevent': 'DC Profile',
                    'icon': 'fa fa-user',
                    'menuItem': 'Profile',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '9225': {
                    'id': 'CommunicationHistory',
                    'href': '/communication',
                    'icon': 'fa fa-wechat',
                    'analyticson': 'click',
                    'analyticsevent': 'CommunicationHistory',
                    'menuItem': 'Communication',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '9224': {
                    'id': 'InsurerDashboard',
                    'href': '/inDashboard',
                    'icon': 'fa fa-dashboard',
                    'analyticson': 'click',
                    'analyticsevent': 'insurerDashboard',
                    'menuItem': 'Dashboard',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '5443': {
                    'id': 'create',
                    'href': '/create',
                    'analyticson': 'click',
                    'analyticsevent': 'New Appointment',
                    'icon': 'fa fa-angle-right',
                    'menuItem': 'Create',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '9184': {
                    'id': 'dcInvestigations',
                    'href': '/dcInvestigations',
                    'analyticson': 'click',
                    'analyticsevent': 'Create Investigation',
                    'icon': 'fa fa-filter',
                    'menuItem': 'Create Investigation',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                // '9188': {
                //     'id': 'corpPackageMap',
                //     'href': '/corpPackageMap',
                //     'analyticson': 'click',
                //     'analyticsevent': 'Corporate Package',
                //     'icon': 'fa fa-map-signs',
                //     'menuItem': 'Corp-Package Mapping',
                //     'applicationName': ['DCPortal'],
                //     'profileMenu': []
                // },
                // '9189': {
                //     'id': 'dcInvestigationsMap',
                //     'href': '/dcInvestigationsMap',
                //     'analyticson': 'click',
                //     'analyticsevent': 'DC Investigation Mapping',
                //     'icon': 'fa fa-map-signs',
                //     'menuItem': 'DC Mapping',
                //     'applicationName': ['DCPortal'],
                //     'profileMenu': []
                // },
                '9190': {
                    'id': 'unapprovedcancel',
                    'href': '/unapprovedcancel',
                    'analyticson': 'click',
                    'analyticsevent': 'Un-approved Cancel',
                    'icon': 'fa fa-angle-right',
                    'menuItem': 'Un-approved Cancel',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '9191': {
                    'id': 'unapprovedna',
                    'href': '/unapprovedna',
                    'analyticson': 'click',
                    'analyticsevent': 'Un-approved New Appointment',
                    'icon': 'fa fa-angle-right',
                    'menuItem': 'Un-approved New',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '9192': {
                    'id': 'approvedcancel',
                    'href': '/approvedcancel',
                    'analyticson': 'click',
                    'analyticsevent': 'Approved Cancellations',
                    'icon': 'fa fa-angle-right',
                    'menuItem': 'Approved Cancellations',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '9195': {
                    'id': 'unapprovedpp',
                    'href': '/unapprovedpp',
                    'analyticson': 'click',
                    'analyticsevent': 'UnApproved QC',
                    'icon': 'fa fa-flag-o',
                    'menuItem': 'UnApproved QC',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '9199': {
                    'id': 'unapprovedqc',
                    'href': '/unapprovedqc',
                    'analyticson': 'click',
                    'analyticsevent': 'Pre Policy Orders',
                    'icon': 'fa fa-flag-o',
                    'menuItem': 'Pre Policy Orders',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '9201': {
                    'id': 'misreports',
                    'href': '/misreports',
                    'analyticson': 'click',
                    'analyticsevent': 'MIS Reports',
                    'icon': 'fa fa-bar-chart',
                    'menuItem': 'MIS Reports',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '9227': {
                    'id': 'allqueuesearch',
                    'href': '/allqueuesearch',
                    'analyticson': 'click',
                    'analyticsevent': 'All Queue Search',
                    'icon': 'fa fa-angle-right',
                    'menuItem': 'All Queue Search',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '9197': {
                    'id': 'queue',
                    'href': '/queue',
                    'analyticson': 'click',
                    'analyticsevent': 'eSales Queue',
                    'icon': 'fa fa-angle-right',
                    'menuItem': 'eSales Queue',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '1': {
                    'id': 'contact',
                    'href': '/contact',
                    'icon': 'fa fa-envelope',
                    'analyticson': 'click',
                    'analyticsevent': 'Contact',
                    'menuItem': 'Contact',
                    'applicationName': ['DCPortal'],
                    'profileMenu': []
                },
                '2': {
                    'id': 'Mailbox',
                    'href': '',
                    'icon': 'fa fa-envelope',
                    'analyticson': 'click',
                    'analyticsevent': 'Contact',
                    'menuItem': 'Inbox',
                    'applicationName': ['HospPortal'],
                    'profileMenu': [{
                        'name': 'Contact',
                        'href': '/contact',
                        'analyticsevent': 'Profile Settings',
                        'icone': 'fa fa-angle-right',
                        'menuItem': 'Profile Settings'
                    },
                    {
                        'name': 'Inbox',
                        'href': '/inbox',
                        'analyticsevent': 'MailBox',
                        'icone': 'fa fa-angle-right',
                        'menuItem': 'Profile Settings'
                    }]
                },
                '1000': {
                    'id': 'Notifications',
                    'href': '',
                    'analyticsevent': 'Notifications',
                    'menuItem': 'Notifications',
                    'applicationName': 'HospPortal',
                    'profileMenu': []
                },
                '700': {
                    'id': 'AdvanceSearch',
                    'href': '/advanceSearch',
                    'analyticsevent': 'AdvanceSearch',
                    'menuItem': 'Notifications',
                    'applicationName': 'HospPortal',
                    'profileMenu': []
                },
                '9207': {
                    'id': 'Dashboard',
                    'href': '/dashboard',
                    'priority': 3,
                    'analyticsevent': 'Dashboard',
                    'menuItem': 'Dashboard',
                    'icon': 'fa fa-dashboard',
                    'applicationName': 'HospPortal',
                    'profileMenu': []
                },
                '92070078': {
                    'id': 'Govt-Scheme Dashboard',
                    'href': '/dashboard',
                    'priority': 4,
                    'analyticsevent': 'Govt-Scheme Dashboard',
                    'menuItem': 'Govt-Scheme Dashboard',
                    'icon': 'fa fa-dashboard',
                    'applicationName': 'HospPortal',
                    'profileMenu': []
                },
                '19999': {
                    'id': 'Claims',
                    'href': '',
                    'analyticsevent': 'Claims',
                    'icon': 'fa fa-file-o',
                    'priority': 2,
                    'menuItem': 'Claims',
                    'applicationName': 'HospPortal',
                    'profileMenu': [{
                        'name': 'Active Claims',
                        'href': '/claims',
                        'analyticsevent': 'Profile Settings',
                        'icone': 'fa fa-angle-right',
                        'menuItem': 'Profile Settings'
                    },
                            {
                                'name': 'Document Pending',
                                'href': '/documentsAwaited',
                                'analyticsevent': 'Profile Settings',
                                'icone': 'fa fa-angle-right',
                                'menuItem': 'Profile Settings'
                            }, {
                                'name': 'Document Received',
                                'href': '/documentsReceived',
                                'analyticsevent': 'Profile Settings',
                                'icone': 'fa fa-angle-right',
                                'menuItem': 'Profile Settings'
                            }, {
                                'name': 'Settled Claims',
                                'href': '/approved',
                                'analyticsevent': 'Profile Settings',
                                'icone': 'fa fa-angle-right',
                                'menuItem': 'Profile Settings'
                            }, {
                                'name': 'Denied Claims',
                                'href': '/denied',
                                'analyticsevent': 'Profile Settings',
                                'icone': 'fa fa-angle-right',
                                'menuItem': 'Profile Settings'
                            }, {
                                'name': 'Government Scheme',
                                'href': '/government',
                                'analyticsevent': 'Profile Settings',
                                'icone': 'fa fa-angle-right',
                                'menuItem': 'Profile Settings'
                            }, {
                                'name': 'Aarogya Scheme',
                                'href': '/aarogya',
                                'analyticsevent': 'Profile Settings',
                                'icone': 'fa fa-angle-right',
                                'menuItem': 'Profile Settings'
                            }
                            , 
                            {
                                'name': 'Reimbursement Claims',
                                'href': '/reimbursement',
                                'analyticsevent': 'ReimbursementClaims',
                                'icone': 'fa fa-angle-right',
                                'menuItem': 'ReimbursementClaims'
                            }
                            ]
                },
                '9216': {
                    'id': 'Admission',
                    'href': '',
                    'analyticsevent': 'Admission',
                    'menuItem': 'Admission',
                    'priority': 1,
                    'icon': 'fa fa-plus',
                    'applicationName': 'HospPortal',
                    'profileMenu': [{
                        'name': 'Confirm eCashless',
                        'href': '/planned',
                        'analyticsevent': 'Profile settings',
                        'icone': 'fa fa-angle-right',
                        'menuItem': 'Profile Settings'
                    },
                            {
                                'name': 'New Admission',
                                'href': '/newAdmission',
                                'analyticsevent': 'Profile settings',
                                'icone': 'fa fa-angle-right',
                                'menuItem': 'Profile settings'
                            },
                            {
                                'name': 'Aarogya Scheme',
                                'href': '/newAdmission/aarogya',
                                'analyticsevent': 'Profile settings',
                                'icone': 'fa fa-angle-right',
                                'menuItem': 'Profile settings'
                            }]
                },
                '9214': {
                    'id': 'Profile settings',
                    'href': '',
                    'analyticsevent': 'Profile settings',
                    'menuItem': 'Profile Settings',
                    'icon': 'fa fa-hospital-o',
                    'applicationName': 'HospPortal',
                    'profileMenu': [{
                        'name': 'Provider Profile',
                        'href': '/provider-profile',
                        'analyticsevent': 'Provider Profile',
                        'icone': 'fa fa-angle-right',
                        'menuItem': 'Provider Profile'
                    },
                          {
                              'name': 'Health-check Packages',
                              'href': '/opPackages',
                              'analyticsevent': 'Health-check Packages',
                              'icone': 'fa fa-angle-right',
                              'menuItem': 'Health-check Packages'
                          },
                        //   {
                        //     'name': 'Lab-Test Packages',
                        //     'href': '/labTestPackages',
                        //     'analyticsevent': 'Lab-Test Packages',
                        //     'icone': 'fa fa-angle-right',
                        //     'menuItem': 'Lab-Test Packages'
                        // },
                          {
                              'name': 'Doctors Profile',
                              'href': '/doctors',
                              'analyticsevent': 'Profile settings',
                              'icone': 'fa fa-angle-right',
                              'menuItem': 'Profile settings'
                          },
                          {
                              'name': 'Rooms Details',
                              'href': '/rooms',
                              'analyticsevent': 'Rooms',
                              'icone': 'fa fa-angle-right',
                              'menuItem': 'Rooms'
                          },
                          {
                              'name': 'Contracts',
                              'href': '/contracts',
                              'analyticsevent': 'Contracts',
                              'icone': 'fa fa-angle-right',
                              'menuItem': 'Contracts'
                          }
                          // {
                          //     'name': 'Package List',
                          //     'href': '/package',
                          //     'analyticsevent': 'Package List',
                          //     'icone': 'fa fa-angle-right',
                          //     'menuItem': 'Package List'
                          // }
                          , {
                              'name': 'Payer Configuration',
                              'href': '/tpaConfig',
                              'analyticsevent': 'Payer Configuration',
                              'icone': 'fa fa-angle-right',
                              'menuItem': 'Payer Configuration'
                          }
                    ]
                },
                '9212': {
                    'id': 'Guidelines',
                    'href': '/guidelines',
                    'priority': 4,
                    'analyticsevent': 'Guidelines',
                    'menuItem': 'Guidelines',
                    'icon': 'fa fa-list-ol',
                    'applicationName': 'HospPortal',
                    'profileMenu': []
                },
                '9221': {
                    'id': 'User Account',
                    'href': '',
                    'analyticsevent': 'User Account',
                    'menuItem': 'User Account',
                    'icon': 'fa fa-users',
                    'applicationName': 'HospPortal',
                    'profileMenu': [{
                        'name': 'Change Password',
                        'href': '/changepwd',
                        'icone': 'fa fa-angle-right',
                        'menuItem': 'Change Password'
                    },
                          {
                              'name': 'User Management',
                              'href': '/usermgmt',
                              'icone': 'fa fa-angle-right',
                              'menuItem': 'User Management'
                          }]
                },
                '50000': {
                    'id': 'Package',
                    'href': '/package',
                    'analyticson': 'click',
                    'analyticsevent': 'Active',
                    'menuItem': 'Active',
                    'icon': 'fa fa-angle-right',
                    'applicationName': ['HospPortal'],
                    'profileMenu': []
                },
                '10000000': {
                    'id': 'Notifications',
                    'href': '',
                    'analyticsevent': 'Notifications',
                    'menuItem': 'Notifications',
                    'icon': 'fa fa-users',
                    'applicationName': 'HospPortal',
                    'profileMenu': [{
                        'name': 'Approved Claims',
                        'href': '#/notification/APPROVED',
                        'count': 'approvedNotificationCount',
                        'analyticsevent': 'Approved Claims',
                        'icone': 'fa fa-angle-right',
                        'menuItem': 'Approved Claims'
                    },
                          {
                              'name': 'Claims Under Process',
                              'href': '#/notification/IN_PROGRESS',
                              'count': 'inProgressNotificationCount',
                              'analyticsevent': 'Claims Under Process',
                              'icone': 'fa fa-angle-right',
                              'menuItem': 'Claims Under Process'
                          },
                          {
                              'name': 'Information Required',
                              'href': '#/notification/INFO_REQUIRED',
                              'count': 'infoRequiredNotificationCount',
                              'analyticsevent': 'Information Required',
                              'icone': 'fa fa-angle-right',
                              'menuItem': 'Information Required'
                          },
                          {
                              'name': 'Settled Claims',
                              'href': '#/notification/PAYMENT',
                              'count': 'paymentNotificationCount',
                              'analyticsevent': 'Settled Claims',
                              'icone': 'fa fa-angle-right',
                              'menuItem': 'Settled Claims'
                          },
                          {
                              'name': 'Cancelled Claims',
                              'href': '#/notification/CANCELLED',
                              'count': 'cancelledNotificationCount',
                              'analyticsevent': 'Cancelled Claims',
                              'icone': 'fa fa-angle-right',
                              'menuItem': 'Cancelled Claims'
                          },
                          {
                              'name': 'Denied Claims',
                              'href': '#/notification/DENIED',
                              'count': 'deniedNotificationCount',
                              'analyticsevent': 'Denied Claims',
                              'icone': 'fa fa-angle-right',
                              'menuItem': 'Denied Claims'
                          },
                          {
                              'name': 'eCashless Requests',
                              'href': '',
                              'count': '',
                              'analyticsevent': 'eCashless Requests',
                              'icone': 'fa fa-angle-right',
                              'menuItem': 'eCashless Requests'
                          }]
                }
            };
            return menuItemList;
        },
        getMenuItems: function (routes) {
            var menuItemsToLoad = [];
            var item = localStorage.getItem('featureList') ? JSON.parse(localStorage.getItem('featureList')) : [];
            // item.push(1);
            // item.sort(function(a, b){return a - b})
            angular.forEach(item, function (i, v) {
                if (routes[i]) {
                    routes[i].fId = i;
                    menuItemsToLoad.push(routes[i]);
                }
            });
            return menuItemsToLoad;
        },
        getHrefForFeature: function (featureId, menuItem) {
            return menuItem[featureId].href;
        }
    };
}]);


'use strict';
angular.module('mbplus.opdCashlessService', ['ngCookies']).value('version', '0.1')
    .service('OpdCashlessService', ['$http', 'UtilitiesService', function ($http, UtilitiesService) {
        return {
            userVerification: function (data) {
                return $http.post(UtilitiesService.getUrlPrefix() + '/Hospital/User/Verification/', data)
            },
            sendOtpRequest: function (data) {
                return $http.post(UtilitiesService.getUrlPrefix() + '/Provider/Infiniti/SendOtp', data)
            },
            verifyOtpRequest: function (data) {
                return $http.post(UtilitiesService.getUrlPrefix() + '/Provider/Infiniti/VerifyOtp', data)
            },
            providerAvailableServices: function (data) {
                return $http.post(UtilitiesService.getUrlPrefix() + '/Hospital/Services/', data)

            },
            packageDetail: function (data) {
                return $http.get(UtilitiesService.getUrlPrefix() + '/Provider/Infiniti/PackageDetails/' + data)
            },
            checkoutCall: function (data) {
                return $http.post(UtilitiesService.getUrlPrefix() + '/Provider/Infiniti/OrderCheckout/', data)
            },
            paymentCall : function (data) {
                return $http.post(UtilitiesService.getUrlPrefix() + '/Provider/Infiniti/OrderPaymentOption',data)
            },
            getTimeFormat: function (time) {
                var pad = function (str, max) {
                    var tempstr = str.toString();
                    return tempstr.length < max ? pad("0" + tempstr, max) : tempstr;
                };
                var data = '';
                if (time) {
                    var minutes = time % 60;
                    var ampm = '';
                    var hours = Math.floor(time / 60);
                    if (hours >= 12) {
                        if (hours === 12 && minutes > 0) {
                            ampm = 'PM';
                        } else {
                            ampm = 'PM';
                        }
                        if (hours === 12) {
                            hours = hours;
                        } else {
                            hours = hours - 12;
                        }
                    } else {
                        ampm = 'AM';
                    }
                    var data1 = pad(hours, '2') + ':' + pad(minutes, '2');
                    data = data1 + ' ' + ampm;
                }
                return data;
            },
            convertToSecs: function (t) {
                // t= HH:MM:SS AM/PM
                var timeArr = t.split(" ");
                var timeArr1 = timeArr[0].split(":");
                var hours = timeArr1[0];
                var minutes = timeArr1[1];
                var secs = timeArr1[2];
                var amPm = timeArr[1]
                if (hours == '12') {
                    hours = '00';
                }
                if (amPm == 'PM') {
                    hours = parseInt(hours, 10) + 12;
                }
                var result = ((hours * 60 * 60) + (minutes * 60) + parseInt(secs));
                return result;
            },
            getNextSevenDays: function () {
                var date = new Date();
                var dayCount = date.getDay();
                var dayString = date.toDateString();
                var ar = [];
                for (var i = 0; i < 7; i++) {
                    ar[i] = { 'isHoliday': false };
                    ar[i].fullDate = dayString;
                    var dateArr = dayString.split(" ");
                    ar[i].dayName = dateArr[0];
                    ar[i].date = dateArr[2] + ' ' + dateArr[1];
                    ar[i].dayCount = dayCount;
                    date.setDate(date.getDate() + 1);
                    date.toGMTString();
                    dayCount = date.getDay();
                    dayString = date.toDateString();
                }
                return ar;
            },
            //Convert to hh:mm a/p from hh:mm:ss a/p
            convertTimeFormat: function (value) {
                var timePassed = value;
                timePassed1 = timePassed.substring(0,5);
                timePassed2 = timePassed.substring(8,11);
                timePassed = timePassed1+timePassed2;
                return timePassed;
            },
            getAge: function (value) {
                var d1 = value;
                var d2 = new Date();
                var diff = d2.getTime() - d1.getTime();
                return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
            }
        }
    }])
'use strict';
angular.module('mbplus.newAdmissionFormService', ['ngCookies']).value('version', '0.1')
.service('NewAdmissionFormService', ['$http', 'UtilitiesService', 'UserService', function ($http, UtilitiesService, UserService) {
    return {
        submitPreauthForm: function (data) {
            var url = UtilitiesService.getUrlPrefix() + '/hosp/claim/newPreAuth';
            var data = data;
            return UserService.makeRestCall(url, data, 'POST')
        },
        submitPreauthFormForOther: function (data) {
            var url = UtilitiesService.getPlusUrl() + '/Claim/NewAdmission';
            var data = data;
            return UserService.makeRestCall(url, data, 'POST',UserService.getAccessToken())
        },
        submitCataractPreauthForm: function (data) {
            var url = UtilitiesService.getUrlPrefix() + '/hosp/claim/newPreAuthAutomation';
            var data = data;
            return UserService.makeRestCall(url, data, 'POST')
        },
        getTreatmentForAilment: function (data) {
            var url = UtilitiesService.getUrlPrefix() + '/hosp/claim/newPreAuthAutomation';
            var data = data;
            return UserService.makeRestCall(url, data, 'POST')
        },
        
        submitAarogyaPreauthForm: function (data) {
            var url = UtilitiesService.getUrlPrefix() + '/hosp/claim/newPreAuthForAarogya';
            var data = data;
            return UserService.makeRestCall(url, data, 'POST')
        },
        downloadPrefilledPreauthForm: function (source, PreauthFormDataObj, ecashlessData) {
            if (source != undefined && source === 'preauthform') {
                window.open(UtilitiesService.getUrlPrefix() + '/hosp/Claim/PrefilledPreauthForm/?PreauthFormData=' + JSON.stringify(PreauthFormDataObj));
            }
            else {
                window.open(UtilitiesService.getUrlPrefix() + '/hosp/Claim/PrefilledPreauthForm/' + ecashlessData.hospId + '/' + ecashlessData.claimId);
            }
        },
        getExtPlannedRequestDetail: function (data) {
            var url = UtilitiesService.getUrlPrefix() + '/plannedHosp.json';
            return UserService.makeRestCall(url, data, 'POST')
        },
        getPlannedHospAttachments: function (plannedHospId) {
            var url = UtilitiesService.getUrlPrefix() + '/Hosp/Claim/GetPlannedDocuments/?plannedHospId=' + plannedHospId;
            return UserService.makeRestCall(url, '', 'GET')
        },
        getPreauthDataByMARefNo: function (preauthNo) {
            var url = UtilitiesService.getUrlPrefix() + '/hosp/Claim/PreauthWithoutClaim.json?preauthNo=' + preauthNo;
            return $http.get(url);
        },
        submitPreClaimPreauthForm: function (data) {
            var url = UtilitiesService.getUrlPrefix() + '/hosp/claim/newPreAuthForIR';
            var data = data;
            return UserService.makeRestCall(url, data, 'POST')
        },

    }
}]);


'use strict';
angular.module('mbplus.MessagingService', ['ngCookies']).value('version', '0.1').service('MessagingService', [function () {
    var messages = [];
    return {
        setMessage: function (message) {
            messages.push(message);
        },
        getMessage: function () {
            return messages;
        },
        resetMessage: function () {
            messages = [];
        }
    }
}]);
'use strict';
angular.module('mbplus.governmentService', ['ngCookies']).value('version', '0.1')
.service('GovernmentService', ['$http', 'UtilitiesService', 'UserService', function ($http, UtilitiesService, UserService) {
    return {
        getGovtPackageList: function () {
            // if(UserService.getUserObj() && UserService.getUserObj().entityId){
            //     var url = UtilitiesService.getUrlPrefix() + '/hosp/packagesbtnentities/list.json?priEntityId=' + UserService.getUserObj().entityId + '&secEntityName=Medi%20Assist';
            //     var data = '';
            //     return UserService.makeRestCall(url, data, 'POST')
            // }

        },
        getGovtPackageListDummyCall: function (id) {
            var url = 'https://hospserviceab.medibuddy.in/' + '/hosp/packagesbtnentities/list.json?priEntityId=' + id + '&secEntityName=Medi%20Assist';
            var data = '';
            // return UserService.makeRestCall(url, data, 'POST')

        }
    }
}])


'use strict';
angular.module('mbplus.fileUploadService', ['ngCookies']).value('version', '0.1')
.service('FileUploadService', ['$http', 'UtilitiesService', 'UserService', function ($http, UtilitiesService, UserService) {
    this.uploadFileToUrl = function (file, callback) {
        var uploadUrl = UtilitiesService.getUrlPrefix() + '/hosp/file/DMS/upload'
        var fd = new FormData();
        angular.forEach(file, function (v, i) {
            fd.append('file', v);
        });
        return $http.post(uploadUrl, fd, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        })
    },
    this.uploadImages = function (dataToSend, uploadUrl, callback) {
        var fd = new FormData();
        angular.forEach(dataToSend, function (v, i) {
            fd.append('file', v);
        });
        return $http.post(uploadUrl, fd, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined, accessToken: UserService.getAccessToken() }
        })
    }
    this.getS3Url = function (dataToSend, uploadUrl, callback) {
        dataToSend['accessToken'] = UserService.getAccessToken();
        return $http.post(uploadUrl, dataToSend, {
            headers: { 'accept': 'application/json', accessToken: UserService.getAccessToken() }
        })
    }
    this.uploadFileToS3 = function (dataToSend, uploadUrl, callback) {
        return $http.put(uploadUrl, dataToSend, {
            headers: { 'Content-Type': dataToSend.type, accessToken: UserService.getAccessToken() }
        })
    }
    this.postFileData = function (dataToSend, uploadUrl, callback) {
        return $http.put(uploadUrl, dataToSend, {
            headers: { 'accept': 'application/json', accessToken: UserService.getAccessToken() }
        })
    }
}]);


'use strict';
angular.module('mbplus.fastrackService', ['ngCookies']).value('version', '0.1')
.service('FastrackService', ['$http', 'UtilitiesService', function ($http, UtilitiesService) {
    return {
        getDetailsWithMaid: function (maid, benefName) {
            var url = UtilitiesService.getFastrackUrlPrefix() + 'getEcardWithMAID.json';
            var data = { 'maid': maid, 'beneficiaryName': benefName }
            return $http.post(url, data)
        },
        getDetailsWithEmpId: function (empid, corpname, benefname) {
            var url = UtilitiesService.getUrlPrefix() + 'getMemberListWithEmpDetails.json';
            var data = { 'employeeId': empid, 'corporateName': corpname, 'BeneficiaryName': benefname }
            return $http.post(url, data)
        },
        getDetailsWithPolicy: function (policyno, benefname) {
            var url = UtilitiesService.getFastrackUrlPrefix() + 'getEcardWithPolicyNo.json';
            var data = { 'PolicyNo': policyno, 'BeneficiaryName': benefname }
            return $http.post(url, data)
        },
        fastrackPopulateNewAdmission: function (maid, relationid, name) {
            var url = UtilitiesService.getUrlPrefix() + 'getBenefDetailsForArogyaPolicy.json';
            var data = { 'maid': maid, 'beneficiaryName': name, 'relationId': relationid, 'policyNo': UtilitiesService.getAarogyaPolicyNo() }
            return $http.post(url, data)
        },
        getDetailsWithGov: function (data) {
            var url = UtilitiesService.getUrlPrefix() + 'hosp/govtclaim/searchbenef';
            var data = { URN: data.URN, MemberName: data.memberNameAPBY, SchemeType: data.schemeType, GovtSchemeType: data.govtSchemeType }
            return $http.post(url, data)
        }
    }
}]);


'use strict';
angular.module('mbplus.dateService', ['ngCookies']).value('version', '0.1')
  .service('DateService', ['UtilitiesService', 'UserService', function (UtilitiesService, UserService) {

    var today,tomorrow,minFirst,maxFirst,preferredDateTime;

    today = moment().toDate();
    tomorrow = moment().add(1, 'day').toDate();
    maxFirst = moment({hour:19, minute:30}).toDate();
    minFirst = moment({hour:9, minute:30}).toDate();
    
    return {
      today : today,
      tomorrow : tomorrow,
      maxFirst : maxFirst,
      minFirst : minFirst,

      validateToday : function () {
        if(moment().hour() >=  17) {
          preferredDateTime = {
            prefDate : tomorrow,
            prefTime : minFirst
          }
        }
        else {
          minFirst = moment().add(2, 'hour').toDate();
          preferredDateTime = {
            prefDate : today,
            prefTime : minFirst
          }
        }
        return preferredDateTime;
      },

      dateChanged : function (selectedDate) {
        var actualDayOfYear = moment().dayOfYear();
        var prefferedDayOfYear = moment(selectedDate).dayOfYear();

        if(actualDayOfYear == prefferedDayOfYear) {
          this.validateToday();
        }
        else {
          minFirst =  moment({hour:9, minute:30}).toDate();
          preferredDateTime = {
            prefDate : selectedDate,
            prefTime : minFirst
          }
        }
        return preferredDateTime;
      }
    }
  }])
'use strict';
angular.module('mbplus.dashBoardSearch', ['ngCookies']).value('version', '0.1')
.factory('dashBoardSearch', [, function () {
    var resultSet = [];
    return {
        dateRangeFilter: function (propertys, startDate, endDate) {
            var result = [];
            var s = (new Date(startDate) === 'Invalid Date') ? '' : new Date(startDate);
            var e = (new Date(endDate) === 'Invalid Date') ? '' : new Date(endDate);
            if (s) {
                var s = s.toISOString();
            } if (e) {
                var e = e.toISOString();
            }
            var resultSet = [];
            $.each(propertys, function (index, property) {
                var a = new Date(property.dateOfAdmission);
                var conversationDateOfAdmission = a.toISOString();
                var discharg = new Date(property.dateOfDischarge);
                var dateOfDischarge = discharg.toISOString();
                if (s && e) {
                    if (conversationDateOfAdmission >= s) {
                        resultSet.push(property);
                    }
                } else {
                    if (conversationDateOfAdmission >= s && s) {
                        result.push(property);
                    }
                    if (dateOfDischarge <= e && e) {
                        result.push(property);
                    }
                }
            });
            if (resultSet.length > 0) {
                $.each(resultSet, function (index, propertySet) {
                    var d = new Date(propertySet.dateOfDischarge);
                    var dateOfDischarges = d.toISOString();
                    if (dateOfDischarges <= e) {
                        result.push(propertySet);
                    }
                });
            }
            return result;
        },
        activeClaim: function (collection, searchItem) {
            return _.where(collection, { status: searchItem });
        }
    }
}]);


'use strict';
angular.module('mbplus.claimActionService', ['ngCookies']).value('version', '0.1')
.service('ClaimActionService', ['$http', 'UtilitiesService','$analytics', function ($http, UtilitiesService,$analytics) {
    return {
        submitEnhance: function (data) {
            $analytics.eventTrack('EnhancementSubmission', {
                category: 'Claim', label: 'Enhancement'
              });
            // ga('send', 'event', 'Enhancement', 'Click', 'EnhancementSubmission',0,data);
            return $http.post(UtilitiesService.getUrlPrefix() + '/hosp/claim/newAction', data)
        },
        submitDischarge: function (data) {
            //dischargeList
            $analytics.eventTrack('DischargeSubmission', {
                category: 'Claim', label: JSON.stringify(data.dischargeList)
              });
            //ga('send', 'event', 'Discharge', 'Click', 'DischargeSubmission',0,data);
            return $http.post(UtilitiesService.getUrlPrefix() + '/hosp/claim/newAction', data)
        },
        ClaimActionNewReq: function (data) {
            return $http.post(UtilitiesService.getUrlPrefix() + '/hosp/claim/NewActionReq', data)
        },
        submitIr: function (data) {
            return $http.post(UtilitiesService.getUrlPrefix() + '/hosp/claim/newAction', data)
        },
        govtClaimAction: function (data) {
            return $http.post(UtilitiesService.getUrlPrefix() + '/hosp/govtclaim/newaction.json', data)
        },
        govtClaimActionIr: function (data) {
            return $http.post(UtilitiesService.getUrlPrefix() + 'hosp/govtclaim/iasubmission.json', data)
        },
        govtClaimActionSc: function (data) {
            return $http.post(UtilitiesService.getUrlPrefix() + 'hosp/govtclaim/claimsubmission.json', data)
        },
        govtClaimActionEa: function (data) {
            return $http.post(UtilitiesService.getUrlPrefix() + 'hosp/govtclaim/enhancesubmission.json', data)
        },
        govtClaimActionEIA: function (data) {
            return $http.post(UtilitiesService.getUrlPrefix() + 'hosp/govtclaim/enhanceiasubmission.json', data)
        },
        UpdateDoaDod: function (data) {
            return $http.post(UtilitiesService.getUrlPrefix() + 'hosp/claim/newAction.json', data)
        },
        getBillsFromCsv:function (file,HospId,InsCompId,claimId) {
            var uploadUrl = UtilitiesService.getUrlPrefix() + '/hosp/claim/GetAggregatedBillfromCsv/'+HospId+'/'+InsCompId+'/'+claimId;
            var fd = new FormData();
            fd.append('file', file);
            fd.append('type', 'bills');
            return $http.post(uploadUrl, fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            })
        },
        getHospitalDiscount: function (data) {
            return $http.post(UtilitiesService.getUrlPrefix() + '/Hospital/Discount.json', data)
        },
        updateClaimInfo: function (data) {
            return $http.post(UtilitiesService.getUrlPrefix() + '/hosp/update/claimDetails.json', data)
        },
        getClaimAuditTrailDetails: function (id) {
            return $http.get(UtilitiesService.getUrlPrefix() + '/hosp/tpa/claimaudittrail/'+id+'.json')
        },
        claimSubmission:function(data){
            return $http.post(UtilitiesService.getUrlPrefix() + '/Hospital/ClaimSubmission.json', data)
        }
    }
}]);


(function () {
  'use strict';
  angular
    .module('mbplus')
    .config(routerConfig)
    .config(block)
    .config(['uiGmapGoogleMapApiProvider', function (uiGmapGoogleMapApiProvider) {
      uiGmapGoogleMapApiProvider.configure({
        key: 'my-api-key',
        v: '3.17',
        libraries: 'weather,geometry,visualization',
      })
    }])
  var date = new Date();
  date = date.getTime();
  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    // $locationProvider.html5Mode(true);        
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/modules/signin/signin.html?version=' + date,
        controller: 'signinCtrl',
      })
      .state('masterLogin', {
        url: '/masterLogin',
        templateUrl: 'app/modules/signin/masterLogin.html?version=' + date,
        controller: 'signinCtrl',
      })
      .state('dcDashboard', {
        url: '/dcDashboard',
        templateUrl: 'app/modules/dashboard/dcDashboard.html?version=' + date,
        controller: 'dcDashboardCtrl'
      })
      .state('allqueuesearch', {
        url: '/allqueuesearch',
        templateUrl: 'app/modules/appointments/allSearch.html?version=' + date,
        controller: 'allSearchController'
      })
      .state('medicalprocess', {
        url: '/medicalprocess',
        templateUrl: 'app/modules/medicalProcess/medicalProcess.html?version=' + date,
        controller: 'medicalProcessCtrl'
        // caseInsensitiveMatch: false
      })
      .state('walkInCashless',{
        url: '/walkInCashless',
        templateUrl: 'app/modules/walkInCashless/walkInCashless.html?version=' + date,
        controller: 'walkInCashlessCtrl'
      })
      .state('provideraction', {
        url: '/provideraction',
        templateUrl: 'app/modules/providerAction/providerAction.html?version=' + date,
        controller: 'providerActionCtrl'
        // caseInsensitiveMatch: false
      })
      .state('markAutoAttendence', {
        url: '/markAutoAttendence/:id',
        templateUrl: 'app/modules/markAutoAttendence/markAutoAttendence.html?version=' + date,
        controller: 'markAutoAttendenceCtrl'
      })
      .state('package', {
        url: '/package',
        templateUrl: 'app/modules/hospitalPackage/package.html?version=' + date,
        controller: 'hospPackageController',
      })
      .state('inbox', {
        url: '/inbox',
        templateUrl: 'app/modules/freshDesk/freshDesk.html?version=' + date,
        controller: 'freshdeskController',
      })
      .state('maNotifications', {
        url: '/maNotifications',
        templateUrl: 'app/modules/notification/maNotifications.html?version=' + date,
        controller: 'maNotificationCtrl',
      })
      .state('trackstatus', {
        url: '/trackstatus',
        templateUrl: 'app/modules/trackStatus/track.html?version=' + date,
        controller: 'trackCtrl',
        caseInsensitiveMatch: false
      })
      .state('faqs', {
        url: '/faqs',
        templateUrl: 'app/modules/faq/faqs.html?version=' + date,
        controller: 'faqsCtrl'
      })
      .state('terms', {
        url: '/terms',
        templateUrl: 'app/modules/shared/terms.html?version=' + date,
        //Code is in Shared controller
        controller: 'SharedCtrl'
      })
      .state('contact', {
        url: '/contact',
        templateUrl: 'app/modules/contact/contact.html?version=' + date,
        controller: 'contactCtrl'
      })
      .state('claims', {
        url: '/claims',
        templateUrl: 'app/modules/claims/claims.html?version=' + date,
        controller: 'claimsCtrl'
      })
      .state('reimbursement', {
        url: '/reimbursement',
        templateUrl: 'app/modules/reimbursement/reimbursement.html?version=' + date,
        controller: 'reimbursementClaimsCtrl'
      })
      .state('otherClaims', {
        url: '/otherClaims',
        templateUrl: 'app/modules/otherClaims/otherClaims.html?version=' + date,
        controller: 'otherClaimsCtrl'
      })
      .state('clinic_appointment', {
        url: '/clinic_appointment',
        templateUrl: 'app/modules/clinicAppointment/clinic_appointment.html?version=' + date,
        controller: 'clinicAppointmentCtrl'
      })
      .state('tpaConfig', {
        url: '/tpaConfig',
        templateUrl: 'app/modules/tpaConfiguration/tpaConfiguration.html?version=' + date,
        controller: 'tpaConfigurationCtrl'
      })
      .state('signin', {
        url: '/signin',
        templateUrl: 'app/modules/signin/signin.html?version=' + date,
        controller: 'signinCtrl'
      })
      .state('signup', {
        url: '/signup',
        templateUrl: 'app/modules/signup/singup.html?version=' + date,
        controller: 'signupCtrl'
      })
      .state('activehosp', {
        url: '/activehosp',
        templateUrl: 'app/modules/activeHosp/activehosp.html?version=' + date,
        controller: 'activeHospCtrl'
      })
      .state('approved', {
        url: '/approved',
        templateUrl: 'app/modules/approved/approved.html?version=' + date,
        controller: 'approvedCtrl'
      })
      .state('cancelled', {
        url: '/cancelled',
        templateUrl: 'app/modules/cancelled/cancelled.html?version=' + date,
        controller: 'cancelledCtrl'
      })
      .state('changepwd', {
        url: '/changepwd',
        templateUrl: 'app/modules/changePwd/changepwd.html?version=' + date,
        controller: 'changePwdCtrl'
      })
      .state('dashboard', {
        url: '/dashboard',
        templateUrl: 'app/modules/dashboard/dashboard.html?version=' + date,
        controller: 'dashboardCtrl'
      })
      .state('denied', {
        url: '/denied',
        templateUrl: 'app/modules/denied/denied.html?version=' + date,
        controller: 'deniedCtrl'
      })
      .state('government', {
        url: '/government',
        templateUrl: 'app/modules/governmentClaims/government.html?version=' + date,
        controller: 'governmentClaimsCtrl'
      })
      .state('aarogya', {
        url: '/aarogya',
        templateUrl: 'app/modules/aarogyaClaims/aarogya.html?version=' + date,
        controller: 'aarogyaClaimsCtrl'
      })
      .state('guidelines', {
        url: '/guidelines',
        templateUrl: 'app/modules/guidelines/guidelines.html?version=' + date,
        controller: 'guidelinesCtrl'
      })
    .state('provider-profile', {
        url: '/provider-profile',
        templateUrl: 'app/modules/hospitalProfile/hospital-profile.html?version=' + date,
        controller: 'hospitalProfileCtrl as hospitalProfileCtrl'
      })
      .state('usermgmt', {
        url: '/usermgmt',
        templateUrl: 'app/modules/userManage/userManage.html?version=' + date,
        controller: 'userManageCtrl'
      })
      .state('hospselect', {
        url: '/hospselect',
        templateUrl: 'app/modules/hospSelect/hospselect.html?version=' + date,
        controller: 'hospSelectCtrl'
      })
      .state('inforequired', {
        url: '/inforequired',
        templateUrl: 'app/modules/inforequired/inforequired.html?version=' + date,
        controller: 'inforequiredCtrl'
      })
      .state('planned', {
        url: '/planned',
        templateUrl: 'app/modules/planned/planned.html?version=' + date,
        controller: 'plannedCtrl'
      })
      .state('plannedCheck', {
        url: '/plannedCheck',
        templateUrl: 'app/modules/plannedCheck/plannedcheck.html?version=' + date,
        controller: 'plannedCheckCtrl'
      })
      .state('plannedCheckdetails', {
        url: '/plannedCheck/:referenceCode',
        templateUrl: 'app/modules/plannedCheck/plannedcheck.html?version=' + date,
        controller: 'plannedCheckCtrl'
      })
      .state('documentsAwaited', {
        url: '/documentsAwaited',
        templateUrl: 'app/modules/documentsAwaited/documentsAwaited.html?version=' + date,
        controller: 'documentsAwaitedCtrl'
      })
      .state('documentsAwaitedwithDays', {
        url: '/documentsAwaited/:noofdays',
        templateUrl: 'app/modules/documentsAwaited/documentsAwaited.html?version=' + date,
        controller: 'documentsAwaitedCtrl'
      })
      .state('documentsReceived', {
        url: '/documentsReceived',
        templateUrl: 'app/modules/documentsReceived/documentsReceived.html?version=' + date,
        controller: 'documentsReceivedCtrl'
      })
      .state('provider-documents', {
        url: '/provider-documents',
        templateUrl: 'app/modules/dcDocuments/dcDocuments.html?version=' + date,
        controller: 'dcDocumentsCtrl'
      })
      .state('advanceSearch', {
        url: '/advanceSearch',
        templateUrl: 'app/modules/advanceSearch/advanceSearch.html?version=' + date,
        controller: 'headerCtrl'
      })
      .state('newAdmission', {
        url: '/newAdmission/:scheme',
        templateUrl: 'app/modules/newAdmission/newAdmission.html?version=' + date,
        controller: 'newAdmissionCtrl'
      })
      .state('newAdmissionCataract', {
        url: '/newAdmissionCataract',
        templateUrl: 'app/modules/newAdmission/newAdmission_Cataract.html?version=' + date,
        controller: 'newAdmissionCtrlCataract'
      })
      .state('tpa', {
        url: '/tpa',
        templateUrl: 'app/modules/tpaNewAdmission/newAdmission.html?version=' + date,
        controller: 'tpaNewAdmissionCtrl'
      })
      .state('atalAmritAbhiyan', {
        url: '/atalAmritAbhiyanAdmission',
        templateUrl: 'app/modules/atalAmritAbhiyan/atalAmritAbhiyan.html?version=' + date,
        controller: 'atalAmritAbhiyanCtrl'
      })
      .state('newAdmissionUrl', {
        url: '/newAdmission/:scheme',
        templateUrl: 'app/modules/newAdmission/newAdmission.html?version=' + date,
        controller: 'newAdmissionCtrl'
      })
      .state('notification', {
        url: '/notification/:type',
        templateUrl: 'app/modules/notification/notification.html?version=' + date,
        controller: 'notificationCtrl'
      })
      .state('doctors', {
        url: '/doctors',
        templateUrl: 'app/modules/doctors/doctors.html?version=' + date,
        controller: 'doctorsCtrl'
      })
      .state('opPackages', {
        url: '/opPackages',
        templateUrl: 'app/modules/packagesOp/opPackages.html?version=' + date,
        controller: 'opPackagesCtrl'
      })
      // .state('labTestPackages', {
      //   url: '/labTestPackages',
      //   templateUrl: 'app/modules/packagesLab/labTestPackages.html?version=' + date,
      //   controller: 'labTestPackagesCtrl'
      // })
      .state('rescheduleAppointment', {
        url: '/rescheduleAppointment',
        templateUrl: 'app/modules/rescheduleAppointment/rescheduleAppointment.html?version=' + date,
        controller: 'rescheduleAppointmentController'
      })
      .state('ipPackages', {
        url: '/ipPackages',
        templateUrl: 'app/modules/packagesIp/ipPackages.html?version=' + date,
        controller: 'ipPackagesCtrl'
      })
      .state('contracts', {
        url: '/contracts',
        templateUrl: 'app/modules/contracts/contracts.html?version=' + date,
        controller: 'contractsHospCtrl'
      })
      .state('orderPunching', {
        url: '/orderPunching',
        templateUrl: 'app/modules/orderPunching/orderPunching.html?version=' + date,
        controller: 'orderPunchingCtrl'
      })
      .state('fuserUpsell', {
        url: '/fuserUpsell',
        templateUrl: 'app/modules/fuserUpsell/fuserUpsell.html?version=' + date,
        controller: 'fuserUpsellCtrl'
      })
      .state('rooms', {
        url: '/rooms',
        templateUrl: 'app/modules/rooms/rooms.html?version=' + date,
        controller: 'roomsCtrl'
      })
      .state('appointments', {
        url: '/appointments',
        templateUrl: 'app/modules/appointments/appointments.html?version=' + date,
        controller: 'appointmentsController'
      })
      .state('allappointments', {
        url: '/allappointments',
        templateUrl: 'app/modules/appointments/allappointments.html?version=' + date,
        controller: 'allAppointmentsController'
      })
      .state('allappointmentsSearchStatus', {
        url: '/allappointmentsSearchStatus/:statusId/:searchValue',
        templateUrl: 'app/modules/appointments/newAppointmentRequest.html?version=' + date,
        controller: 'newAppointmentRequestCtrl'
      })
      .state('allappointmentsSearchStatus/withDate', {
        url: '/allappointmentsSearchStatus/withDate/:statusId/:searchValue/:frmDate/:toDate',
        templateUrl: 'app/modules/appointments/newAppointmentRequest.html?version=' + date,
        controller: 'newAppointmentRequestCtrl'
      })
      .state('unapprovedcancel', {
        url: '/unapprovedcancel',
        templateUrl: 'app/modules/unapprovedcancel/unapprovedcancel.html?version=' + date,
        controller: 'UnapprovedCancelController'
      })
      .state('approvedcancel', {
        url: '/approvedcancel',
        templateUrl: 'app/modules/approvedcancel/approvedcancel.html?version=' + date,
        controller: 'approvedCancelController'
      })
      .state('unapprovedna', {
        url: '/unapprovedna',
        templateUrl: 'app/modules/unapprovedna/unapprovedna.html?version=' + date,
        controller: 'UnapprovedNewAdmissionController'
      })
      .state('unconfirmedorder', {
        url: '/unconfirmedorder',
        templateUrl: 'app/modules/unconfirmedorder/unconfirmedorder.html?version=' + date,
        controller: 'unconfirmedorderController'
      })
      .state('queue', {
        url: '/queue',
        templateUrl: 'app/modules/queue/queue.html?version=' + date,
        controller: 'queueController'
      })
      .state('misreports', {
        url: '/misreports',
        templateUrl: 'app/modules/misreports/misreports.html?version=' + date,
        controller: 'misreportsController'
      })
      .state('pharmacyDashboard', {
        url: '/pharmacyDashboard',
        templateUrl: 'app/modules/pharmacyDashboard/pharmacyDashboard.html?version=' + date,
        controller: 'pharmacyDashboardController'
      })
      .state('dcInvestigations', {
        url: '/dcInvestigations',
        templateUrl: 'app/modules/dcInvestigations/dcInvestigations.html?version=' + date,
        controller: 'dcInvestigationsController'
      })
      .state('corpPackageMap', {
        url: '/corpPackageMap',
        templateUrl: 'app/modules/corpPackageMap/corpPackageMap.html?version=' + date,
        controller: 'corpPackageMapController'
      })
      .state('dcInvestigationsMap', {
        url: '/dcInvestigationsMap',
        templateUrl: 'app/modules/dcInvestigationsMap/dcInvestigationsMap.html?version=' + date,
        controller: 'dcInvestigationsMapController'
      })
      .state('appointmentSearch', {
        url: '/appointmentSearch',
        templateUrl: 'app/modules/appointmentSearch/appointmentSearch.html?version=' + date,
        controller: 'appointmentSearchController'
      })
      .state('bookappointment', {
        url: '/bookappointment',
        templateUrl: 'app/modules/bookappointment/bookappointment.html?version=' + date,
        controller: 'bookappointmentController'
      })
      .state('plusContact', {
        url: '/plusContact',
        templateUrl: 'app/modules/plusContact/plusContact.html?version=' + date,
        controller: 'plusContactController'
      })
      .state('unapprovedqc', {
        url: '/unapprovedqc',
        templateUrl: 'app/modules/unapprovedqc/unapprovedqc.html?version=' + date,
        controller: 'unApprovedQCController'
      })
      .state('unapprovedpp', {
        url: '/unapprovedpp',
        templateUrl: 'app/modules/unapprovedpp/unapprovedpp.html?version=' + date,
        controller: 'unApprovedPPController'
      })
      .state('payments', {
        url: '/payments',
        templateUrl: 'app/modules/payments/payments.html?version=' + date,
        controller: 'paymentsController'
      })
      .state('paymentsSettled', {
        url: '/paymentsSettled',
        templateUrl: 'app/modules/payments/paymentSettled.html?version=' + date,
        controller: 'settlePaymentController'
      })
      .state('plusProfile', {
        url: '/plusProfile',
        templateUrl: 'app/modules/profile/profile.html?version=' + date,
        controller: 'plusProfileController'
      })

      .state('inDashboard', {
        url: '/inDashboard',
        templateUrl: 'app/modules/insurerDashboard/insurerDashboard.html?version=' + date,
        controller: 'insurerDashboardController'
      })
      .state('communication', {
        url: '/communication',
        templateUrl: 'app/modules/communicationHistory/communicationHistory.html?version=' + date,
        controller: 'communicationHistoryController'
      })
      .state('create', {
        url: '/create',
        templateUrl: 'app/modules/newappointment/main.html?version=' + date,
        controller: 'newAppointmentController'
      })
      .state('create.others', {
        url: '/others',
        templateUrl: 'app/modules/newappointment/others.html?version=' + date
      })
      .state('create.preemp', {
        url: '/preemp',
        templateUrl: 'app/modules/newappointment/preemp.html?version=' + date
      })
      .state('create.drugTest', {
        url: '/drugTest',
        templateUrl: 'app/modules/newappointment/drugTest.html?version=' + date
      })
      .state('create.prepolicy', {
        url: '/prepolicy',
        templateUrl: 'app/modules/newappointment/prepolicy.html?version=' + date
      })
      .state('create.esales', {
        url: '/esales',
        templateUrl: 'app/modules/newappointment/esales.html?version=' + date
      })
      .state('create.pharmacy', {
        url: '/pharmacy',
        templateUrl: 'app/modules/newappointment/Pharmacy.html?version=' + date
      })
      .state('header', {
        url: '/header',
        templateUrl: '',
        controller: 'headerCtrl'
      })
      .state('resetPassword', {
        url: '/resetpassword',
        templateUrl: 'app/modules/resetPassword/resetPassword.html?version=' + date,
        controller: 'resetPasswordCtrl'
      })
      .state('Modal', {
        views: {
          'modal': {
            templateUrl: 'app/components/modals/modal.html?version=' + date,
          }
        },
        abstract: true
      })
      .state('esales', {
        url: '/esales',
        templateUrl: 'app/modules/newappointment/Insurer_esales.html?version=' + date,
        controller: 'newAppointmentController'
      })
      .state('otherwise', {
        url: '*path',
        templateUrl: 'app/modules/signin/signin.html?version=' + date,
        controller: 'signinCtrl'
      })
      .state('updateClaimInfo', {
        url: '/updateClaimInfo',
        templateUrl: 'app/components/tpaConfiguration/updateClaimInfo.html?version=' + date,
        controller: 'updateClaimInfoCtrl'
      })
      .state('signInPopup', {
        url: '/signInPopup',
        templateUrl: 'app/module/signin/signInPopup.html?version=' + date,
        controller: 'signInPopupCtrl'
      });
    $urlRouterProvider.otherwise('/');
  }

  function block(blockUIConfig) {
    // blockUIConfig.template = '<div class="block-ui-overlay"></div><div class="block-ui-message-container"><div class="block-ui-message ng-binding" ng-class="$_blockUiMessageClass">Loading, please wait...</div></div>';
    blockUIConfig.autoBlock = false;
    blockUIConfig.autoInjectBodyBlock = false;
    blockUIConfig.delay = 0;
  }
})();

'use strict';
angular.module('mbplus.filters', [])
.filter('interpolate', ['version', function (version) {
    return function (text) {
        return String(text).replace(/\%VERSION\%/mg, version);
    }
}])
.filter('startFrom',[ function () {
    return function (input, start) {
        if (input) {
            start = +start; //parse to int
            return input.slice(start);
        }
        return [];
    }
}])
.filter('splitArrayFilter',[ function () {
    return function (arr, lengthofsublist) {
        if (!angular.isUndefined(arr) && arr.length > 0) {
            var arrayToReturn = [];
            var subArray = [];
            var pushed = true;
            for (var i = 0; i < arr.length; i++) {
                if ((i + 1) % lengthofsublist == 0) {
                    subArray.push(arr[i]);
                    arrayToReturn.push(subArray);
                    subArray = [];
                    pushed = true;
                } else {
                    subArray.push(arr[i]);
                    pushed = false;
                }
            }
            if (!pushed)
                arrayToReturn.push(subArray);

            // console.log(JSON.stringify(arrayToReturn));
            return arrayToReturn;
        }
    }
}]);
'use strict';
angular.module('mbplus.directives', [])
  .directive('appVersion', ['version', function (version) {
    return function (scope, elm, attrs) {
      elm.text(version);
    };
  }])
  .directive('billBreakup', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      replace: true,
      restrict: 'AE',
      templateUrl: '/app/components/templates/billBreakup.html?version=' + date,
      controller: 'billBreakupCtrl',
      scope: {
        billFileds: '=',
      },
    };
  }])
  .directive('dynamic', ['$compile', function ($compile) {
    return {
      restrict: 'A',
      replace: true,
      link: function (scope, ele, attrs) {
        return scope.$watch(attrs.dynamic, function (html) {
          ele.html(html);
          return $compile(ele.contents())(scope);
        });
      }
    };
  }])

  .directive('mbNotification', ['$timeout', '$window', '$rootScope', function (timeout, window, $rootScope) {
    var displayTime = 9000;
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'E',
      replace: true,
      scope: {
        message: '=',
        duration: '=',
        showClose: '=',
        onDismiss: '&',
        name: '@'
      },
      templateUrl: '/app/components/templates/mbNotification.html?version=21' + date,
      link: function (scope, ele, attrs, ctrl, transclude) {
        scope.notification = {};
        scope.open = true;
        scope.text = '';
        scope.mbClose = function () {
          scope.open = false;
          //$rootScope.$apply();
        }
        scope.$watch('other', function (oldValue, newValue) {
          if (oldValue !== newValue) {}
        }, true)
      }
    };
  }])
  .directive('medCompareText', ['version', function (version) {
    return {
      require: 'ngModel',
      link: function (scope, elem, attrs, model) {
        if (!attrs.medCompareText) {
          return;
        }
        scope.$watch(attrs.medCompareText, function (value) {
          model.$setValidity('medCompareText', value === model.$viewValue);
        });
        model.$parsers.push(function (value) {
          var isValid = value === scope.$eval(attrs.medCompareText);
          model.$setValidity('medCompareText', isValid);
          return isValid ? value : undefined;
        });
      }
    };
  }])
  .directive('numbersOnly', [function () {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, modelCtrl) {
        modelCtrl.$parsers.push(function (inputValue) {
          if (inputValue === undefined) {
            return '';
          }
          var input = inputValue.replace(/[^0-9]/g, '');
          if (input !== inputValue) {
            modelCtrl.$setViewValue(input);
            modelCtrl.$render();
          }
          return input;
        });
      }
    };
  }])
  .directive('textOnly', [function () {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, modelCtrl) {
        modelCtrl.$parsers.push(function (inputValue) {
          if (inputValue === undefined) {
            return '';
          }
          var input = inputValue.replace(/[^a-zA-Z]/g, '');
          if (input !== inputValue) {
            modelCtrl.$setViewValue(input);
            modelCtrl.$render();
          }
          return input;
        });
      }
    };
  }])
  .directive('ngEnter', [function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.ngEnter);
          });
          event.preventDefault();
        }
      });
    };
  }])
  .directive('customSort', [function () {
    return {
      restrict: 'A',
      transclude: true,
      scope: {
        order: '=',
        sort: '='
      },
      template: ' <a ng-click="sort_by(order)" style="color: #555555;">' +
        '    <span ng-transclude></span>' +
        '    <i ng-class="selectedCls(order)"></i>' +
        '</a>',
      link: function (scope) {
        // change sorting order
        scope.sort_by = function (newSortingOrder) {
          var sort = scope.sort;
          if (sort.sortingOrder == newSortingOrder) {
            sort.reverse = !sort.reverse;
          }
          sort.sortingOrder = newSortingOrder;
        };
        scope.selectedCls = function (column) {
          if (column == scope.sort.sortingOrder) {
            return ('icon-chevron-' + ((scope.sort.reverse) ? 'down' : 'up'));
          } else {
            return 'icon-sort'
          }
        };
      } // end link
    };
  }])
  .directive('openTab', [function () {
    return {
      restrict: 'E',
      controller: function ($scope) {},
      template: '<div class="panel-footer">' +
        '    <div class="row">' +
        '        <div class="col-md-2">' +
        '        </div>' +
        '        <div class="col-md-8">' +
        '        <p class="bg-info">' +
        '           <i class="glyphicon glyphicon-download-alt"></i>&nbsp;&nbsp;Download the standard discharge summary and bill format by <a href="images/standard_discharge_summary_and_bill_format.pdf" target="_blank">clicking this link </a>' +
        '        </p>' +
        '        </div>' +
        '        <div class="col-md-2">' +
        '        </div>' +
        '    </div>' +
        '    <div class="row">' +
        '        <div class="col-md-2">' +
        '        </div>' +
        '        <div class="col-md-8">' +
        '            <button class="btn btn-default" data-toggle="modal" data-target="#raiseEnhancement">' +
        '              Raise Enhancement' +
        '            </button>' +
        '            <button class="btn btn-default" data-toggle="modal" data-target="#finalDischarge">' +
        '              Submit Final Discharge' +
        '            </button>' +
        '            <button class="btn btn-danger pull-right" id="closeButton">' +
        '              Close Tab' +
        '            </button>' +
        '        </div>' +
        '        <div class="col-md-2">' +
        '            ' +
        '        </div>' +
        '    </div>' +
        '</div>',
    };
  }])
  .directive('popover', [function () {
    return function (scope, elem) {
      elem.popover();
    };
  }])
  .directive('customOnChange', [function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var onChangeFunc = scope.$eval(attrs.customOnChange);
        element.bind('change', onChangeFunc);
      }
    };
  }])
  .directive('myTemplate', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'E',
      controller: function ($scope) {},
      scope: {
        data: '=preauthdata',
      },
      templateUrl: '../Views/template.html' + date,
      link: function (scope, element, attrs) {
        scope.tempval = element;
        scope.$watch('data', function (newValue, oldValue) {});
      }
    };
  }])
  .directive('btstAccordion', [function () {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      scope: {},
      template: "<div class='accordion' ng-transclude></div>",
      link: function (scope, element, attrs) {

        // give this element a unique id
        var id = element.attr("id");
        if (!id) {
          id = "btst-acc" + scope.$id;
          element.attr("id", id);
        }
        // set data-parent on accordion-toggle elements
        var arr = element.find(".accordion-toggle");
        for (var i = 0; i < arr.length; i++) {
          $(arr[i]).attr("data-parent", "#" + id);
          $(arr[i]).attr("href", "#" + id + "collapse" + i);
        }
        arr = element.find(".accordion-body");
        $(arr[0]).addClass("in"); // expand first pane
        for (var i = 0; i < arr.length; i++) {
          $(arr[i]).attr("id", id + "collapse" + i);
        }
      },
      controller: function () {}
    };
  }])
  .directive('btstPane', [function () {
    return {
      require: '^btstAccordion',
      restrict: "E",
      transclude: true,
      replace: true,
      scope: {
        title: '@',
        category: '=',
        order: '='
      },
      template: "<div class='accordion-group' >" +
        "  <div class='accordion-heading'>" +
        "    <a class='accordion-toggle' data-toggle='collapse'> {{category.name}} - </a>" +

        "  </div>" +
        "<div class='accordion-body collapse'>" +
        "  <div class='accordion-inner' ng-transclude></div>" +
        "  </div>" +
        "</div>",
      link: function (scope, element, attrs) {
        scope.$watch('title', function () {
          // NOTE: this requires jQuery (jQLite won't do html)
          var hdr = element.find('.accordion-toggle');
          hdr.html(scope.title);
        });
      }
    };
  }])
  .directive('hospFooter', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      templateUrl: '/app/components/footer/footer.html' + date,
      controller: 'footerCtrl',
      link: function ($scope, elm, attr, ctrl) {}
    };
  }])
  .directive('hospHeader', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      templateUrl: '/app/components/header/header.html?version=21' + date,
      controller: 'headerCtrl',
      replace: true,
      link: function ($scope, elm, attr, ctrl) {}
    };
  }])
  .directive('leftMenu', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      templateUrl: '/app/components/leftMenu/leftMenu.html?version=21' + date,
      controller: 'leftMenuCtrl',
      replace: true,
      link: function ($scope, elm, attr, ctrl) {}
    };
  }])
  .directive('angularTab', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AE',
      templateUrl: '/app/components/tab/tab.html?version=21' + date,
      controller: 'tabCtrl',
      scope: {
        preauthfiltered: '=datalist',
        listingData: '=list',
        tabname: '=tabname',
        tabtype: '=tabtype',
        appointments: '=appointmentlist',
        seaarchDataText: '=search',
        someCtrlFn: '&callbackFn',
        callBackSecondFn: '&callbackSecondFn',
        noofdaysforpendingdoc: '=noofdaysforpendingdoc',
        currentPage: '=?'
      }
    };
  }])
  .directive('aarogyaForm', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      replace: true,
      restrict: 'AE',
      templateUrl: '/app/components/aarogyaForm/aarogyaForm.html?version=21' + date,
      controller: 'aarogyaFormCtrl',
      scope: {},
      link: function ($scope, elm, attr, ctrl) {}
    };
  }])
  .directive('newAdmission', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      replace: true,
      restrict: 'AE',
      templateUrl: '/app/components/newAdmissionForm/newAdmissionForm.html?version=21' + date,
      controller: 'newAdmissionFormCtrl',
      //replace:true,
      scope: {
        dataobj: "=",
        source: "="
      },
      link: function ($scope, elm, attr, ctrl) {}
    };
  }])

  .directive('newAdmissionCataract', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      replace: true,
      restrict: 'AE',
      templateUrl: '/app/components/newAdmissionForm/newAdmissionForm_Cataract.html?version=21' + date,
      controller: 'newAdmissionFormCtrlCataract',
      //replace:true,
      scope: {
        dataobj: "=",
        source: "="
      },
      link: function ($scope, elm, attr, ctrl) {}
    };
  }])
  .directive('tpaNewAdmission', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      replace: true,
      restrict: 'AE',
      templateUrl: '/app/components/tpaNewAdmission/newAdmissionForm.html?version=21' + date,
      controller: 'tpaNewAdmissionFormNewCtrl',
      //replace:true,
      scope: {
        dataobj: "=",
        source: "="
      },
      link: function ($scope, elm, attr, ctrl) {}
    };
  }])
  .directive('newAdmissions', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      replace: true,
      restrict: 'AE',
      templateUrl: '/app/components/newAdmissionForm_new/newAdmissionForm.html?version=21' + date,
      controller: 'newAdmissionFormNewCtrl',
      //replace:true,
      scope: {
        dataobj: "=",
        source: "="
      },
      link: function ($scope, elm, attr, ctrl) {}
    };
  }])
  .directive('aarogyaForms', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      replace: true,
      restrict: 'AE',
      templateUrl: '/app/components/aarogyaForm_new/aarogyaForm.html?version=21' + date,
      controller: 'aarogyaFormNewCtrl',
      scope: {},
      link: function ($scope, elm, attr, ctrl) {}
    };
  }])
  .directive('hospAction', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'E',
      templateUrl: '/app/components/hospAction/hospAction.html?version=21' + date,
      controller: 'hospActionCtrl',
      scope: {
        dataobj: "=",
        source: "="
      },
      link: function ($scope, elm, attr, ctrl) {}
    };
  }])
  .directive('modalDialog', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'E',
      scope: {
        show: '='
      },
      replace: true, // Replace with the template below
      transclude: true, // we want to insert custom content inside the directive
      link: function (scope, element, attrs) {
        scope.dialogStyle = {};
        if (attrs.width)
          scope.dialogStyle.width = attrs.width;
        if (attrs.height)
          scope.dialogStyle.height = attrs.height;
        scope.hideModal = function () {
          scope.show = false;
        };
      },
      templateUrl: '/app/components/modals/modal.html?version=21' + date
      //controller: 'SharedCtrl'
    };
  }])
  .directive('typeahead', ['$timeout', function ($timeout) {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AEC',
      scope: {
        items: '=',
        prompt: '@',
        title: '@',
        subtitle: '@',
        subtitle2: '@',
        itemId: '@',
        moduleFlag: '@'
      },
      controller: ['$rootScope', '$scope', 'UserService', 'UtilitiesService', '$state', function (rootScope, scope, UserService, UtilitiesService, state) {
        scope.typeaheadClick = function (item) {
          if (scope.moduleFlag && scope.moduleFlag === 'newadmission') {
            selectPackage(item);
          } else if (scope.moduleFlag && scope.moduleFlag === 'aarogya') {
            selectPackage(item);
          } else if (scope.moduleFlag && scope.moduleFlag === 'addHosp') {
            selectHosp(item);
          } else if (item.LoginType === 'plus') {
            activeAppointment(item);
          } else {
            changeHosp(item);
          }
        };

        function changeHosp(item) {
          UserService.makeRestCall(UtilitiesService.getUrlPrefix() + '/hosp/details.json', {
            hospId: item.entityId
          }, 'POST').then(function (response) {
            if (response.data.isSuccess && response.data.hospDetails) {
              UserService.setHospitalObj(response.data.hospDetails);
              scope.userObject = UserService.getUserObj();
              scope.userObject.entityId = response.data.hospDetails.hospId;
              UserService.setUserObj(scope.userObject);
              rootScope.$broadcast('hospChange', true);
              scope.model = '';
              angular.element('#changeHospModal').modal('hide');
              if (state.current.name === 'dashboard') {
                state.reload();
              } else {
                state.go('dashboard', {
                  'reload': true
                });
              }
              scope.$emit('utilazation', true);
            }
          });
        }

        function activeAppointment(item) {
          scope.user = UserService.getUserObj();
          if (!scope.user.original_eR_Id) {
            scope.user.original_eR_Id = scope.user.eR_Id;
            scope.user.original_entityId = scope.user.entityId;
          }
          scope.user.eR_Id = item.id;
          scope.user.entityId = item.entityId;
          UserService.setUserObj(scope.user);
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/provider/entity/details.json?entityId=' + UserService.getUserObj().entityId, '', 'GET').then(function (response) {
            if (response.data.isSuccess) {
              UserService.setHospitalObj(response.data.entity);
              state.go('appointments', {}, {
                reload: true
              });
              angular.element('#changeProvider').modal('hide');
            } else {
              angular.element('#changeProvider').modal('hide');
              UtilitiesService.showAlertMessage('Error while loading Provider.');
            }
          });
        }

        function selectPackage(item) {
          if (scope.moduleFlag === 'newadmission') {
            scope.$parent.govtSchemeMethods.setGovtPackageId(item)
          } else {
            scope.$parent.packageSelection.setAarogyaPackageId(item)
          }

          scope.model = item.packageName
          scope.selected = true;
        }

        function selectHosp(item) {
          if (item.isRemedinet) {
            UtilitiesService.showAlertMessage('This is a Remedinet associated hospital and adding users for them is prohibited at this point of time.');
          } else if (item.userExist) {
            UtilitiesService.showAlertMessage('This hospital is already enrolled. You cannot enrol once again.');
          } else {
            scope.$parent.hospitalName = item.entityName;
            scope.$parent.hospitalId = item.entityId;
            scope.$parent.openNextWizardTab();
          }
        }
      }],
      link: function (scope, elem, attrs) {
        scope.handleSelection = function (selectedItem) {
          scope.current = 0;
          scope.selected = true;
        };
        scope.current = 0;
        scope.selected = true;
        scope.isCurrent = function (index) {
          return scope.current == index;
        };
        scope.setCurrent = function (index) {
          scope.current = index;
        };
      },
      templateUrl: '/app/components/typeAhead/typeAhead.html?version=21' + date
    };
  }])
  .directive('fileModel', ['$parse', function ($parse) {
    return {
      restrict: 'AEC',
      link: function (scope, element, attrs) {
        var model = $parse(attrs.fileModel);
        var modelSetter = model.assign;
        element.bind('change', function () {
          scope.$apply(function () {
            modelSetter(scope, element[0].files[0]);
          });
          if (scope.$parent.tab) {
            scope.$parent.$parent.$parent.$parent.file = scope.file;
          }
        });
      }
    };
  }])
  .directive('googleMapAutocomplete',[function(){
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AE',
      templateUrl: '/app/components/templates/gMapAutocomplete.html?version=22' + date,
      scope: {
        mapElem: "=map",
        placeChange: '&callbackFn',
      },
      link : function(scope) {
        var autocompleteService, sessionToken, sessionTimer, placeService;
        scope.placelist = [{description:''}];
        scope.placeText = '';

        (function() {
          if(window.google.maps.places) {
            autocompleteService = new google.maps.places.AutocompleteService();
            placeService = new google.maps.places.PlacesService(scope.mapElem);
          }
        })();

        function getNewToken() {
          if (sessionTimer) {
            clearTimeout(sessionTimer);
            sessionTimer = null;
          }
          sessionToken = new google.maps.places.AutocompleteSessionToken();
          sessionTimer = setTimeout(function () {
            sessionToken = null;
          }, 150000)
        };

        scope.getMatchingPlaces = function(value) {
          if(value && value.length >= 4) {
            return new Promise(function(resolve, reject) {
              if(!sessionToken) {
                getNewToken();
              }
              autocompleteService.getPlacePredictions({
                input: value,
                componentRestrictions:{ country: 'in' },
                sessionToken: sessionToken
              },function (result, status) {
                if (status === 'OK') {
                  return resolve(result)
                }
                else return reject()
              })
            })
          }
          else return []
        };

        scope.getCoordinates = function (item) {
          if(item.place_id) {
            if(!sessionToken) {
              getNewToken();
            }
            var request = { 
              'placeId' : item.place_id,
              'fields' : ['geometry'],
              'sessionToken' : sessionToken
            };
            placeService.getDetails(request, function(place, status) {
              if(status == google.maps.places.PlacesServiceStatus.OK ) {
                var placeResponse = place
                var coordinates = place.geometry.location
                scope.placeChange({arg: placeResponse})
              }
            })
          }
        }
      }
    }
  }])
  .directive('mbFileUpload', ['FileUploadService', 'UtilitiesService', '$q', function (FileUploadService, UtilitiesService, $q) {
    return {
      scope: {
        attachmenttype: '=attachmenttype',
        returnObj: '&fileFn'
      },
      templateUrl: '/app/components/templates/mbFileUpload.html',
      link: function (scope, element) {
        scope.fileName = 'Choose multiple files';
        element.bind('change', function () {
          scope.$apply(function () {
            $('input[type=file]').click(function () {
              $(this).attr('value', '');
            })
          });
        });
        scope.uploadFile = function (value) {
          if (value[0].size < 25242880) {
            var filesUploadingArray = [],
              fileBlobArray = [];
            angular.forEach(value, function (key, value) {
              filesUploadingArray.push(key);
            });
            UtilitiesService.startLoading('uploading files...', 'UploadingFile');
            fileBlobArray.push(FileUploadService.uploadFileToUrl(filesUploadingArray));
            $q.all(fileBlobArray).then(function (result) {
                UtilitiesService.stopLoading('UploadingFile');
                result.forEach(function (element) {
                  if (element.data.isSuccess) {
                    var fileCollection = element.data.uploadResponseDetails;
                    scope.returnObj({
                      arg: fileCollection,
                      attachmenttype: scope.attachmenttype
                    });
                  } else {
                    scope.returnObj({
                      arg: ''
                    }, {
                      attachmenttype: scope.attachmenttype
                    });
                    UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to upload files.');
                  }
                });
              },
              function (error) {
                UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to upload files.');
              });
          } else {
            UtilitiesService.showAlertMessage("File size should be less then 25MB", false);
          }
        };
      }
    };
  }])
  .directive('mbPlusFileUpload', ['FileUploadService', 'UtilitiesService', '$q', function (FileUploadService, UtilitiesService, $q) {
    return {
      scope: {
        returnObj: '&fileFn',
        action: '=?'
      },
      templateUrl: '/app/components/templates/mbFileUpload.html',
      link: function (scope, element) {
        scope.fileName = 'Choose multiple files';

        element.bind('change', function (d, i) {
          scope.$apply(function () {
            $('input[type=file]').click(function () {
              $(this).attr('value', '');
            })
          });
        });
        scope.uploadFile = function (value) {
          if (value[0].size < 25242880) {
            var filesUploadingArray = [],
              fileDetailsArray = [];
            angular.forEach(value, function (key, value) {
              filesUploadingArray.push(key);
              var fileDetails = {
                type: key.type,
                fileName: key.name,
                signedURL: "",
                fileIdentifier: "",
                fileType: "Report",
                appId: 9203,
                // EntityRelationId:  scope.user.entityId,
                s3AccountType:  "MB",
                "contractType": scope.action.requestContractType
              }
              fileDetailsArray.push(fileDetails);
              UtilitiesService.startLoading('uploading files...', 'UploadingFile');
              FileUploadService.getS3Url(fileDetails, UtilitiesService.getProviderCoreNode() + 'provider/getS3SignedUrl').then(function (result) {
                if (result.data) {
                  FileUploadService.uploadFileToS3(key, result.data.signedURL).then(function() {
                    fileDetails.fileIdentifier = result.data.fileIdentifier;
                    fileDetails.signedURL = result.data.signedURL;
                    fileDetails.fileName = result.data.fileName;
                    FileUploadService.postFileData(fileDetails, UtilitiesService.getProviderCoreNode() + 'provider/saveFileDocument').then(function(res) {
                      if(res.data && res.status === 200 || res.data.success) {
                        UtilitiesService.stopLoading('UploadingFile');
                        var fileCollection = {};
                        fileCollection[result.data.fileIdentifier] = result.data && result.data.fileName;
                        scope.returnObj({
                          arg: fileCollection
                        });
                      }
                    })
                  })
                } else {
                  scope.returnObj({
                    arg: ''
                  });
                  UtilitiesService.stopLoading('UploadingFile');
                  UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to upload files.');
                }
              }),
              function (error) {
                UtilitiesService.stopLoading('UploadingFile');
                UtilitiesService.showAlertMessage('Due to some technical issue, you are unable to upload files.');
              }
            });

          } else {
            UtilitiesService.showAlertMessage("File size should be less then 25MB", false);
          }
        };
      }
    };
  }])
  .directive('fileUpload', ['$parse', function ($parse) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var model = $parse(attrs.fileUpload);
        var modelSetter = model.assign;
        element.bind('change', function () {
          scope.$apply(function () {
            var file = element[0].files[0];
            modelSetter(scope, element[0].files[0]);
          });
          scope.$parent.$parent.$parent.$parent.hospPackagemyFile = scope.file
          if (scope.$parent.tab) {
            scope.$parent.$parent.$parent.$parent.file = scope.file;
          }
        });
      }
    };
  }])
  .directive('fileModels', ['$parse', 'UtilitiesService', function ($parse, UtilitiesService) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var model = $parse(attrs.fileModels);
        var modelSetter = model.assign;
        element.bind('change', function () {
          UtilitiesService.uploadFileData = '';
          scope.$apply(function () {
            UtilitiesService.uploadFileData = modelSetter(scope, element[0].files[0]);
          });
        });
      }
    };
  }])
  .directive('govtHospaction', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'E',
      templateUrl: '/app/components/govtHospAction/govtHospAction.html?version=21' + date,
      controller: 'govtHospActionCtrl',
      scope: {
        dataobj: "=",
        source: "=",
        tabid: "="
      },
      link: function ($scope, elm, attr, ctrl) {}
    };
  }])
  .directive('message', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'E',
      templateUrl: '/app/components/modals/message.html?version=21' + date,
      scope: {
        background: '=background',
        body: '=',
        header: '=',
        show: '='
      },
      link: function ($scope, elm, attr, ctrl) {
        angular.element('#myModal').appendTo('body');
        $scope.$watch('show', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            angular.element('#myModal').modal({
              show: $scope.show
            });
          }
        }, true)
      }
    };
  }])
  .directive('focusOn', ['$timeout', function (timeout) {
    return {
      restrict: 'A',
      link: function ($scope, $element, $attr) {
        $scope.$watch($attr.focusOn, function (_focusVal) {
          timeout(function () {
            _focusVal ? $element.focus() :
              $element.blur();
          });
        });
      }
    };
  }])
  .directive('input', [function () {
    return {
      restrict: 'E',
      priority: -1,
      link: function (scope, element, attrs) {
        if (attrs && attrs.type && attrs.type == 'date') {
          $(element).updatePolyfill();
        }
      }
    };
  }])
  .directive('resize', ['$window', 'UserService', function ($window, UserService) {
    return function (scope, element) {
      function applyHeight() {
        scope.height = $window.innerHeight;
        if (UserService.isActive()) {
          $('.scrolable').removeAttr('style').css('height', scope.height - 45);
          $('.left-nav').css('height', scope.height);
        } else {
          $('.left-nav, .loginBox, .scrolable').css('height', scope.height);
        }
      }
      angular.element($window).bind('resize', function () {
        scope.$apply(function () {
          applyHeight();
        });
      });
      applyHeight();
    };
  }])
  .directive('myMaxlength', ['$compile', '$log', function ($compile, $log) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {
        attrs.$set("ngTrim", "false");
        var maxlength = parseInt(attrs.myMaxlength, 10);
        ctrl.$parsers.push(function (value) {
          $log.info("In parser function value = [" + value + "].");
          if (value.length > maxlength) {
            $log.info("The value [" + value + "] is too long!");
            value = value.substr(0, maxlength);
            ctrl.$setViewValue(value);
            ctrl.$render();
            $log.info("The value is now truncated as [" + value + "].");
          }
          return value;
        });
      }
    };
  }])
  .directive('nospecialchar', [function () {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, element, attrs, modelCtrl) {
        modelCtrl.$parsers.push(function (inputValue) {
          if (inputValue == null)
            return ''
          return "";
        });
      }
    }
  }])
  .directive('onlyDigits', [function () {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, element, attr, ctrl) {
        function inputValue(val) {
          if (val) {
            var digits = val.replace(/[^0-9]/g, '');

            if (digits !== val) {
              ctrl.$setViewValue(digits);
              ctrl.$render();
            }
            return parseInt(digits, 10);
          }
          return undefined;
        }
        ctrl.$parsers.push(inputValue);
      }
    };
  }])
  .directive("limitTo", [function () {
    return {
      restrict: "A",
      link: function (scope, elem, attrs) {
        var limit = parseInt(attrs.limitTo);
        angular.element(elem).on("keypress", function (e) {
          if (this.value.length == limit) e.preventDefault();
        });
      }
    }
  }])
  .directive('angRoundProgress', [function () {
    var compilationFunction = function (templateElement, templateAttributes, transclude) {
      if (templateElement.length === 1) {
        var node = templateElement[0];

        var width = node.getAttribute('data-round-progress-width') || '200';
        var height = node.getAttribute('data-round-progress-height') || '200';

        var canvas = document.createElement('canvas');
        canvas.setAttribute('width', width);
        canvas.setAttribute('height', height);
        canvas.setAttribute('data-round-progress-model', node.getAttribute('data-round-progress-model'));

        node.parentNode.replaceChild(canvas, node);

        var outerCircleWidth = node.getAttribute('data-round-progress-outer-circle-width') || '6';
        var innerCircleWidth = node.getAttribute('data-round-progress-inner-circle-width') || '4';

        var outerCircleBackgroundColor = node.getAttribute('data-round-progress-outer-circle-background-color') || '#505769';
        var outerCircleForegroundColor = node.getAttribute('data-round-progress-outer-circle-foreground-color') || '#12eeb9';
        var innerCircleColor = node.getAttribute('data-round-progress-inner-circle-color') || '#505769';
        var labelColor = node.getAttribute('data-round-progress-label-color') || '#12eeb9';

        var outerCircleRadius = node.getAttribute('data-round-progress-outer-circle-radius') || '10';
        var innerCircleRadius = node.getAttribute('data-round-progress-inner-circle-radius') || '7';

        var labelFont = node.getAttribute('data-round-progress-label-font') || '50pt Calibri';

        return {
          pre: function preLink(scope, instanceElement, instanceAttributes, controller) {
            var expression = canvas.getAttribute('data-round-progress-model');
            scope.$watch(expression, function (newValue, oldValue) {
              // Create the content of the canvas
              var ctx = canvas.getContext('2d');
              ctx.clearRect(0, 0, width, height);

              // The "background" circle
              var x = width / 2;
              var y = height / 2;
              ctx.beginPath();
              ctx.arc(x, y, parseInt(outerCircleRadius), 0, Math.PI * 2, false);
              ctx.lineWidth = parseInt(outerCircleWidth);
              ctx.strokeStyle = outerCircleBackgroundColor;
              ctx.stroke();

              // The inner circle
              ctx.beginPath();
              ctx.arc(x, y, parseInt(innerCircleRadius), 0, Math.PI * 2, false);
              ctx.lineWidth = parseInt(innerCircleWidth);
              ctx.strokeStyle = innerCircleColor;
              ctx.stroke();

              // The inner number
              ctx.font = labelFont;
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillStyle = labelColor;
              ctx.fillText(newValue.label, x, y);

              // The "foreground" circle
              var startAngle = -(Math.PI / 2);
              var endAngle = ((Math.PI * 2) * newValue.percentage) - (Math.PI / 2);
              var anticlockwise = false;
              ctx.beginPath();
              ctx.arc(x, y, parseInt(outerCircleRadius), startAngle, endAngle, anticlockwise);
              ctx.lineWidth = parseInt(outerCircleWidth);
              ctx.strokeStyle = outerCircleForegroundColor;
              ctx.stroke();
            }, true);
          },
          post: function postLink(scope, instanceElement, instanceAttributes, controller) {}
        };
      }
    };

    var roundProgress = {
      compile: compilationFunction,
      replace: true
    };
    return roundProgress;
  }])
  .directive('progressBar', [function () {
    return {
      restrict: 'E',
      scope: {
        curVal: '@',
        maxVal: '@'
      },
      template: "<div class='progress-bar'>" +
        "<div class='progress-bar-bar'>{{curVal}}%</div>" +
        "</div>",

      link: function ($scope, element, attrs) {

        function updateProgress() {
          var progress = 0;
          $scope.curVal = 40;
          $scope.maxVal = 100;

          if ($scope.maxVal) {
            progress = Math.min($scope.curVal, $scope.maxVal) / $scope.maxVal * element.find('.progress-bar').width();
          }

          element.find('.progress-bar-bar').css('width', progress);
        }

        $scope.$watch('curVal', updateProgress);
        $scope.$watch('maxVal', updateProgress);


      }
    };
  }])
  .directive('resizeElement', ['$window', function ($window) {
    return function (scope, element) {
      //var w = angular.element($window);
      var heightOffset = parseInt(element.attr('height-offset'));
      var widthOffset = parseInt(element.attr('width-offset'));
      var elementSelector = parseInt(element.attr('selector'));
      var w = angular.element(elementSelector);
      var changeHeight = function () {
        if (!isNaN(heightOffset) && w.height() - heightOffset > 0)
          element.css('height', (w.height() - heightOffset) + 'px');
        if (!isNaN(widthOffset) && w.width() - widthOffset > 0)
          element.css('width', (w.width() - widthOffset) + 'px');
      };
      w.bind('resize', function () {
        changeHeight();
      });
      changeHeight();
    }
  }])
  .directive('apptPatientDetail', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'E',
      templateUrl: '/app/components/apptPatientDetail/apptPatientDetail.html?version=21' + date,
      controller: 'apptPatientDetailCtrl',
      scope: {
        appointmentDetail: "=appointmentDetail",
        patientDetail: "=patientDetail",
        pharmaDetails: "=pharmaDetails",
        visitType: "=visitType",
        statusHistory: '=statusHistory'
      }
    };
  }])
  .directive('apptStatusHistory', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'E',
      templateUrl: '/app/components/apptStatusHistory/apptStatusHistory.html?version=21' + date,
      controller: 'apptStatusHistoryCtrl',
      scope: {
        appointmentHistory: "=appointmentHistory",
        pharmaDetails: "=pharmaDetails",
        reqId: "=reqId",
      }
    };
  }])
  .directive('apptEssentials', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'E',
      templateUrl: '/app/components/apptEssentials/apptEssentials.html?version=21' + date,
      controller: 'apptEssentialsCtrl',
      scope: {
        apptEssentials: "=apptEssentials",
        appointmentHistory: "=appointmentHistory",
        appointmentDetail: "=appointmentDetail",
        visitType: "=visitType"
      }
    };
  }])
  .directive('apptQcDetails', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'E',
      templateUrl: '/app/components/qcDetails/details.html?version=21' + date,
      controller: 'qcDetailsCtrl',
      scope: {
        appointmentDetail: "=appointmentDetail",
      }
    };
  }])
  .directive('dropdownMultiselect', ['$document', function ($document) {
    return {
      restrict: 'E',
      scope: {
        model: '=',
        options: '=',
        pre_selected: '=preSelected'
      },
      template: "<div class='btn-group' data-ng-class='{open: open}'>" +
        "<button class='btn btn-small'>Select</button>" +
        "<button class='btn btn-small dropdown-toggle' data-ng-click='openDropdown()'><span class='caret'></span></button>" +
        "<ul class='dropdown-menu' aria-labelledby='dropdownMenu'>" +
        "<li><a data-ng-click='selectAll()'><i class='glyphicon glyphicon-remove-sign'></i>  Check All</a></li>" +
        "<li><a data-ng-click='deselectAll();'><i class='glyphicon glyphicon-ok-sign'></i>  Uncheck All</a></li>" +
        "<li class='divider'></li>" +
        "<li data-ng-repeat='option in options'> <a data-ng-click='setSelectedItem()'>{{option.name}}<span data-ng-class='isChecked(option.id)'></span></a></li>" +
        "</ul>" +
        "</div>",
      controller: function ($scope) {

        $scope.openDropdown = function () {
          $scope.open = !$scope.open;
          $scope.selected_items = [];
          for (var i = 0; i < $scope.pre_selected.length; i++) {
            $scope.selected_items.push($scope.pre_selected[i].id);
          }
        };
        $scope.selectAll = function () {
          $scope.model = _.pluck($scope.options, 'id');
          // console.log($scope.model);
        };
        $scope.deselectAll = function () {
          $scope.model = [];
          // console.log($scope.model);
        };
        $scope.setSelectedItem = function () {
          var id = this.option.id;
          if (_.contains($scope.model, id)) {
            $scope.model = _.without($scope.model, id);
          } else {
            $scope.model.push(id);
          }
          // console.log($scope.model);
          return false;
        };

        $scope.isChecked = function (id) {
          if (_.contains($scope.model, id)) {
            return 'glyphicon glyphicon-ok pull-right';
          }
          return false;
        };
      }
    }
  }])
  .directive('reportModal', ['UtilitiesService', 'UserService', '$uibModal', function (UtilitiesService, UserService, $uibModal) {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AE',
      scope: {
        reqId: "=reqid",
        roleOfInsurer: "=roles"
      },
      link: function (scope, element, attr) {
        var getTestReport = element.on('click', function (event) {
          UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/InvestigationReport/View/' + scope.reqId + '.json', '', 'get').then(function (response) {
            if (response.data && response.data.investigations.length > 0) {
              var modalInstance = $uibModal.open({
                keyboard: false,
                backdrop: 'static',
                windowClass: 'large-Modal',
                templateUrl: '/app/components/plusTestReport/plusTestReport.html?version=22' + date,
                controller: ['$scope', '$rootScope', 'UtilitiesService', 'UserService', '$uibModalInstance',
                  function ($scope, $rootScope, UtilitiesService, UserService, $uibModalInstance) {
                    $scope.isInsurerRoles = scope.roleOfInsurer;
                    $scope.reportList = {
                      "investigations": [],
                      "isReportSubmitted": ''
                    }
                    $scope.reqId = scope.reqId;
                    $scope.reportList.investigations = response.data.investigations;
                    $scope.reportList.isReportSubmitted = response.data.isReportSubmitted;
                    $scope.saveTestReport = function (testObj) {
                      $scope.finalReportData = {};
                      $scope.finalReportData = {
                        "requestId": $scope.reqId,
                        "investigations": testObj
                      };
                      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/InvestigationReport.json', $scope.finalReportData, 'POST', UserService.getAccessToken()).then(function (response) {
                        if (response) {
                          $scope.closeModal();
                        }
                      });
                    }
                    $scope.closeModal = function () {
                      $uibModalInstance.dismiss();
                    };
                  }
                ],
                size: 'lg'
              });
            }
          })
        })
      },
    }
  }])
  .directive('apptCreationMap', ['UtilitiesService', 'UserService', '$uibModal', 'PlusUtilitiesService', '$parse', function (UtilitiesService, UserService, $uibModal, PlusUtilitiesService, $parse) {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AE',
      scope: {
        dcList: "=dclist",
        controllerFrom: "=controllerfrom",
        showMarkerInfoFunction: "&showmarkerinfofunction",
        controllerFunction: '&controllerfunction',
      },
      templateUrl: '/app/components/appointmentCreation/apptCreationMap.html?version=21' + date,
      link: function (scope, element, attr) {
        scope.$on('eventDcList', function (event, args) {
          scope.showMap = false;
          if (args && args.dcList && args.dcList.length > 0) {
            scope.showMap = true;
            scope.windowOptions = [];
            scope.diagnosticCentres = '';
            scope.diagnosticCentres = args.dcList;
            scope.markerArray = [];

            angular.forEach(scope.diagnosticCentres, function (key, value) {
              if (key && key.latitude && key.longitude) {
                scope.markerArray.push({
                  entityId: key.entityId,
                  pinCode: key.pinCode,
                  id: key.id,
                  coords: {
                    latitude: key.latitude,
                    longitude: key.longitude,
                  },
                  name: key.entityName,
                  showBookingBtn: scope.controllerFrom != 'dcInvestigationsMap' ? true : false
                });
              }
              scope.windowOptions[key.entityId] = {
                visible: false,
              }
            });
            scope.map = {
              center: {
                latitude: scope.markerArray[0].coords.latitude,
                longitude: scope.markerArray[0].coords.longitude
              },
              stroke: {
                color: '#08B21F',
                weight: 2,
                opacity: 1
              },
              fill: {
                color: '#08B21F',
                opacity: 0.5
              },
              radius: 8,
              zoom: 12
            }
          } else {
            scope.showMap = false;
          }
        });

        //Date Object
        scope.client = {};
        scope.userTime = {
          firstAppointmentTime: '',
          secondAppointmentTime: ''
        }
        scope.today = function () {
          scope.client.secondPrefTime = new Date();
          scope.client.firstPrefTime = new Date();
          scope.dt = new Date();
        };
        scope.today();

        scope.dateOptions = {
          dateDisabled: disabled,
          formatYear: 'yy',
          minDate: new Date(),
          startingDay: 1
        };


        // Disable weekend selection
        function disabled(data) {
          var date = data.date,
            mode = data.mode;
          return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        }

        scope.open1 = function () {
          scope.popup1.opened = true;
        };

        scope.open2 = function () {
          scope.popup2.opened = true;
        };
        //prePolicy
        scope.popup3 = {
          opened: ''
        }
        scope.open = function ($event) {
          $event.preventDefault();
          $event.stopPropagation();
          $scope.popup3.opened = true;
        };

        scope.formats = ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        scope.format = scope.formats[0];
        scope.altInputFormats = ['M!/d!/yyyy'];

        scope.popup1 = {
          opened: false
        };

        scope.popup2 = {
          opened: false
        };

        //Set Time Object
        var first = new Date();
        var dd = new Date(first).getDate();
        var mm = new Date(first).getMonth() + 1;
        var yy = new Date(first).getFullYear();
        var hh = 8;
        var ms = 0;
        var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
        scope.userTime.firstAppointmentTime = new Date(x);
        scope.userTime.secondAppointmentTime = new Date(x);

        scope.hstep = 1;
        scope.mstep = 30;

        scope.ismeridian = false;

        //First time limit
        var maxFirst = new Date();
        maxFirst.setHours(18);
        maxFirst.setMinutes(0);
        scope.maxFirst = maxFirst;

        var minFirst = new Date();
        minFirst.setHours(8);
        minFirst.setMinutes(0);
        scope.minFirst = minFirst;

        //Second time limit
        var maxSecond = new Date();
        maxSecond.setHours(18);
        maxSecond.setMinutes(0);
        scope.maxSecond = maxSecond;

        var minSecond = new Date();
        minSecond.setHours(8);
        minSecond.setMinutes(0);
        scope.minSecond = minSecond;
        scope.userTime.secondAppointmentTime = scope.minSecond;
      },
      controller: ['$scope', function (scope) {
        scope.showMarkerInfo1 = function (markerObj, $event) {
          scope.showMarkerInfoFunction({
            'markerObj': markerObj
          });
        };

        scope.controllerFunction1 = function (firstPrefTime, firstAppointmentDate, secondPrefTime, secondAppointmentDate) {
          scope.controllerFunction({
            'firstPrefTime': firstPrefTime,
            'firstAppointmentTime': firstAppointmentDate,
            'secondPrefTime': secondPrefTime,
            'secondAppointmentTime': secondAppointmentDate
          });
        };
      }]
    }
  }])
  .directive('resendEmailModal', ['UtilitiesService', 'UserService', '$uibModal', function (UtilitiesService, UserService, $uibModal) {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AE',
      scope: {
        reqId: "=reqid",
        isdc: "=isdc"
      },
      link: function (scope, element, attr) {
        var getTestReport = element.on('click', function (event) {
          var modalInstance = $uibModal.open({
            keyboard: false,
            backdrop: 'static',
            templateUrl: '/app/components/plusModals/resendEmailModals.html?version=22' + date,
            controller: ['$scope', '$rootScope', 'UtilitiesService', 'UserService', '$uibModalInstance', '$timeout',
              function ($scope, $rootScope, UtilitiesService, UserService, $uibModalInstance, $timeout) {
                $scope.reqId = scope.reqId;
                $scope.resendEmailDetails = {};
                $scope.isdc = scope.isdc === true ? true : false;
                $scope.ResendEmail = function () {
                  if ($scope.isdc) {
                    if (!$scope.resendEmailDetails.otp || $scope.resendEmailDetails.otp == '') {
                      alert('Enter OTP');
                      return;
                    }
                  }
                  var resendMailRequest = {
                    "requestID": $scope.reqId,
                    "statusID": $scope.resendEmailDetails.statusID,
                    "emailID": $scope.resendEmailDetails.emailID,
                    "otp": $scope.resendEmailDetails.otp
                  }
                  UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/resendEmailForAppointment.json', resendMailRequest, "post", UserService.getAccessToken()).then(function (response) {
                    if (response.data.isSuccess == true) {
                      $scope.successMsz = 'E-Mail sent';
                      $scope.resendEmailDetails = {};
                      $timeout(function () {
                        $scope.closeModal();
                      }, 1000);
                    } else {
                      if (scope.isdc) {
                        alert('Enter Correct OTP');
                      } else {
                        $scope.errorMsz = 'Unable to send mail try again after sometime !';
                      }
                    }
                  });
                }
                $scope.closeModal = function () {
                  $uibModalInstance.dismiss();
                };
              }
            ],
            size: 'md'
          });
        })
      },
    }
  }])
  .directive('packageTestDetailsModal', ['UtilitiesService', 'UserService', '$uibModal', function (UtilitiesService, UserService, $uibModal) {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AE',
      scope: {
        productId: "=productid"
      },
      link: function (scope, element, attr) {
        var getTestReport = element.on('click', function (event) {
          if (scope.productId) {
            UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/PackageEntityRelation/' + scope.productId, "", "GET", UserService.getAccessToken()).then(function (response) {
              if (response.data) {
                var modalInstance = $uibModal.open({
                  keyboard: false,
                  backdrop: 'static',
                  templateUrl: '/app/components/plusModals/packageTestDetailsModal.html?version=23' + date,
                  controller: ['$scope', '$rootScope', 'UtilitiesService', 'UserService', '$uibModalInstance', 'filterFilter',
                    function ($scope, $rootScope, UtilitiesService, UserService, $uibModalInstance, filterFilter) {
                      if (response.data && response.data.allowedInvestigations.length > 0) {
                        $scope.investigationList = [];
                        var investigation = response.data.allowedInvestigations;
                        var investigationGroup = [];
                        angular.forEach(investigation, function (v, i) {
                          investigationGroup.push(v.groupName);
                        })
                        var listOfUniqeInvestigations = investigationGroup.filter(function (val, index, allArr) {
                          return index == allArr.indexOf(val);
                        })
                        angular.forEach(listOfUniqeInvestigations, function (val, ind) {
                          var investigationWiseTests = filterFilter(investigation, val);
                          var testObj = investigationWiseTests;
                          $scope.testDetails = [];
                          angular.forEach(testObj, function (v, i) {
                            $scope.testDetails.push({
                              groupName: v.groupName,
                              testName: v.name,
                              testId: v.id,
                              groupId: v.groupId,
                              isActive: v.isActive,
                              duplicateCheck: v.duplicateCheck,
                              quantity: v.quantity
                            })
                          })
                          $scope.investigationList.push({
                            investigationName: val,
                            testDetails: $scope.testDetails
                          })
                        })
                      } else {
                        $scope.errorMsz = 'No investigation available for this request';
                        $scope.closeModal()
                      }
                      $scope.closeModal = function () {
                        $uibModalInstance.dismiss();
                      };
                    }
                  ],
                  size: 'lg'
                });
              }
            })
          } else {
            var modalInstance = $uibModal.open({
              keyboard: false,
              backdrop: 'static',
              templateUrl: "/app/components/plusModals/packageTestDetailsModal.html?version=22",
              controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                $scope.errorMsz = 'No investigation available for this request';
                $scope.closeModal = function () {
                  $uibModalInstance.dismiss();
                };
              }],
            });
          }
        })
      },
    }
  }])
  .directive('mbTypeahead', ['$timeout', '$compile', '$parse', '$document', function ($timeout, $compile, $parse, $document) {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AEC',
      require: ['ngModel', '^?ngModelOptions'],
      templateUrl: '/app/components/templates/mbtypeAhead.html?version=22' + date,
      scope: {
        items: '=',
        removeitem: '=',
        selecteditems: '=',
        prompt: '@',
        moduleFlag: '@',
        someCtrlFn: '&callbackFn',
        autofill: '='
      },
      link: function (scope, element, attrs, controller) {
        scope.itemsData = [];
        scope.selectedProcedure = [];
        scope.selectedProcedureManual = []
        scope.form = {
          name: '',
          amount: '',
        };
        scope.flag = {
          isShowTypeahead: false,
          isShowAddPackage: false,
          isSuccuess: false,
          isDuplicate: false
        };




        scope.resetTimeOut = function () {
          $timeout(function () {
            scope.$apply(function () {
              scope.flag.isSuccuess = false;
              scope.flag.isDuplicate = false;
            });
          }, 6000)
        }
        scope.$on('eventName', function (event, data) {
          //call directive function here
        })

        function finalResult() {
          scope.finalItems = [];
          angular.forEach(scope.selectedProcedureManual, function (data, index) {
            if (data.package_Name && data.general_Ward) {
              scope.finalItems.push(data);
            }
          });
          angular.forEach(scope.selectedProcedure, function (data, index) {
            if (data.package_Name) {
              scope.finalItems.push(data);
            }

          });
          angular.forEach(scope.finalItems, function (data, index) {
            scope.finalItems[index].uniqueIds = index + 1;
          });
          scope.someCtrlFn({
            arg: _.uniq(scope.finalItems)
          });
        };

        scope.resetObj = function (item) {
          if (item.packageId !== 0) {
            angular.forEach(scope.itemsDummy, function (data, index) {
              angular.forEach(data.newPriceObj, function (data1, index1) {
                if (item.packageId === data.packageId) {
                  angular.forEach(data.newPriceObj, function (data2, index2) {
                    scope.itemsDummy[index].newPriceObj[index1].isSelected = false;
                  });
                }
              });
            });
            angular.forEach(scope.itemsDataForSelection, function (data, index) {
              angular.forEach(data.newPriceObj, function (data1, index1) {
                if (item.packageId === data.packageId) {
                  angular.forEach(data.newPriceObj, function (data2, index2) {
                    scope.itemsDataForSelection[index].newPriceObj[index1].isSelected = false;
                  });
                }
              });
            });
          }
        };

        //Add to list
        function addtoBag(value) {
          scope.selectedProcedure = [];
          angular.forEach(scope.itemsDataForSelection, function (data, index) {
            angular.forEach(data.newPriceObj, function (data1, index1) {
              if (data1.isSelected) {
                var myObj = {
                  deluxe_Other: 0,
                  general_Ward: parseInt(data1.price),
                  general_Ward1: true,
                  packageId: data1.packageId,
                  package_Name: data.package_Name
                }
                scope.selectedProcedure.push(myObj);
              }
            });
          });
          scope.selectedProcedure = _.uniq(scope.selectedProcedure);
          finalResult();
        };

        //Remove item from List
        scope.removePackageFromList = function (item) {
          if (item) {
            angular.forEach(scope.selectedProcedure, function (data, index) {
              if ((item.uniqueIds === data.uniqueIds) && (item.packageId === data.packageId)) {
                scope.selectedProcedure.splice(index, 1);
              }
            });
            angular.forEach(scope.selectedProcedureManual, function (data, index) {
              if ((item.uniqueIds === data.uniqueIds) && (item.packageId === 0)) {
                scope.selectedProcedureManual.splice(index, 1);
              }
            });
            scope.resetObj(item);
            addtoBag();
          }
        };

        //Check radio button for selected item
        scope.checkService = function (value, price, $index) {
          if (value) {
            angular.forEach(scope.itemsDummy, function (data, index) {
              angular.forEach(value.newPriceObj, function (data1, index1) {
                if (value.packageId === data.packageId && $index === index1) {
                  angular.forEach(data.newPriceObj, function (data2, index2) {
                    if (value.packageId === data2.packageId && $index !== index2) {
                      scope.itemsDummy[index].newPriceObj[index2].isSelected = false;
                    }
                  });
                  scope.itemsDummy[index].newPriceObj[$index].isSelected = !scope.itemsDummy[index].newPriceObj[$index].isSelected;
                }
              });
            });
            angular.forEach(scope.itemsDataForSelection, function (data, index) {
              angular.forEach(value.newPriceObj, function (data1, index1) {
                if (value.packageId === data.packageId && $index === index1) {
                  angular.forEach(data.newPriceObj, function (data2, index2) {
                    if (value.packageId === data2.packageId && $index === index2) {
                      scope.itemsDataForSelection[index].newPriceObj[$index].isSelected = true;
                    }
                    if (value.packageId === data2.packageId && $index !== index2) {
                      scope.itemsDataForSelection[index].newPriceObj[index2].isSelected = false;
                    }
                  });
                }
              });
            });
            addtoBag();
          }
        };
        scope.focusFlag = {
          shouldBeOpen: false
        }
        //Search item in list
        scope.searchData = function (value) {
          var matches = [];
          scope.form.name = '';
          if (value) {
            scope.focusFlag.shouldBeOpen = false;
            angular.forEach(scope.itemsData, function (data, index) {
              if (!angular.isDefined(data.package_Name.toLowerCase()) || !angular.isDefined(value.toLowerCase())) {
                return false;
              }
              var nameMatch = false,
                numberMatch = false;
              if (angular.isDefined(data.package_Name.toLowerCase())) {
                nameMatch = nameMatch || data.package_Name.toLowerCase().indexOf(value.toLowerCase()) > -1;
              }
              if (nameMatch) {
                matches.push(data);
              }
              if (matches.length === 0) {
                scope.focusFlag.shouldBeOpen = true;
              } else {
                scope.focusFlag.shouldBeOpen = false;
              }
            });
          } else {
            matches = scope.itemsData;
            scope.focusFlag.shouldBeOpen = true;
          }
          if (scope.itemsData !== matches) {

          } else {}
          scope.itemsDummy = matches;
          if (scope.itemsDummy.length === 0) {
            scope.flag.isShowAddPackage = true;
            scope.flag.isShowTypeahead = false;
          } else {
            scope.flag.isShowTypeahead = true;
            scope.flag.isShowAddPackage = false;
          }
        };

        //Append Html to dom
        function triggerFunc(evt) {
          var el = angular.element();
          element.append(el);
          $compile(el)(scope);
        }

        //Open typahead on click in to inputbox
        scope.showHtml = function () {
          triggerFunc();
          scope.form.amount = '';
          scope.form.name = '';
          scope.flag.isSuccuess = false;
          scope.flag.isDuplicate = false;
          if (scope.itemsData) {
            scope.flag.isShowAddPackage = false;
            scope.flag.isShowTypeahead = true;
          } else {
            scope.flag.isShowAddPackage = true;
            scope.flag.isShowTypeahead = false;
          }
          var model = scope.model;
          scope.searchData(model);
        };

        //Add item using maula entry
        scope.AddProcedure = function (name, price) {
          var value = _.filter(scope.selectedProcedureManual, function (item) {
            return item.package_Name.toLowerCase() === name.toLowerCase()
          }).length;
          if (name && price) {
            var obj = {
              deluxe_Other: 0,
              general_Ward: parseInt(price),
              general_Ward1: true,
              packageId: 0,
              package_Name: name,
            }
            scope.flag.isSuccuess = true;
            scope.flag.isDuplicate = false;
            scope.selectedProcedureManual.push(obj);
            finalResult();
            scope.resetTimeOut();
            scope.form.amount = '';
            scope.form.name = '';
            scope.model = '';
          } else {
            if (value > 0) {
              scope.flag.isDuplicate = true;
              scope.flag.isSuccuess = false;
              scope.resetTimeOut();
            } else {
              scope.flag.isShowAddPackage = true;;
              scope.flag.isShowTypeahead = false;
              scope.flag.isDuplicate = false;
              scope.flag.isSuccuess = false;
              scope.form.amount = '';
              scope.form.name = '';
            }
          }
        };

        //element.bind('click', triggerFunc);
        $document.on('click', function (e) {
          if (element !== e.target && !element[0].contains(e.target)) {
            scope.$apply(function () {
              scope.flag.isShowAddPackage = false;;
              scope.flag.isShowTypeahead = false;
              scope.focusFlag.shouldBeOpen = false;
              scope.flag.isSuccuess = false;
              scope.model = '';
              scope.form.amount = '';
              scope.form.name = '';
              //scope.$eval(scope.clickOutside);
            });
          }
        });

        //Watch item list
        scope.$watch('items', function (oldValue, newValue) {
          if (oldValue !== newValue) {
            scope.itemsData = oldValue;
            scope.itemsDataForSelection = oldValue;
            scope.itemsDummy = oldValue;
          }
        });

        //Watch removed item from controller
        scope.$watch('removeitem', function (oldValue, newValue) {
          if (oldValue !== newValue) {
            scope.removePackageFromList(oldValue);
          }
        });

        //Watch auto fill item from controller
        scope.$watch('autofill', function (oldValue, newValue) {
          if (oldValue !== newValue) {
            scope.autofillValue = oldValue;
          }
        });

        //Watch current list of items present in controlller
        scope.$watch('selecteditems', function (oldValue, newValue) {
          if (oldValue !== newValue) {}
        });
      }
    };
  }])
  .directive('focusMe', function ($timeout) {
    return {
      scope: {
        trigger: '@focusMe'
      },
      link: function (scope, element) {
        scope.$watch('trigger', function (value) {
          if (value === 'true') {
            $timeout(function () {
              element[0].focus();
            });
          }
        });
      }
    };
  })

  .directive('packageTypeahead', ['$timeout', '$compile', '$parse', '$document', function ($timeout, $compile, $parse, $document) {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AEC',
      require: ['ngModel', '^?ngModelOptions'],
      templateUrl: '/app/components/templates/packageTypeAhead.html?version=22' + date,
      scope: {
        items: '=',
        removeitem: '=',
        selecteditems: '=',
        prompt: '@',
        moduleFlag: '@',
        someCtrlFn: '&callbackFn',
        nofilters: '=',
        getreason: '='
      },
      link: function (scope, element, attrs, controller) {
        scope.itemsData = [];
        scope.selectedProcedure = [];
        scope.selectedProcedureManual = []
        scope.form = {
          name: '',
          amount: '',
        };
        scope.flag = {
          isShowTypeahead: false,
          isShowAddPackage: false,
          isSuccuess: false
        };

        scope.setCustomObject = function () {

          angular.forEach(scope.items, function (data) {
            data.className = ''
            if (data && data.distinctPrices && data.distinctPrices.length > 0) {
              var obj = [];
              if (data.deluxe_Other > 0) {
                obj.push({
                  packageId: data.packageId,
                  packageName: data.package_Name,
                  roomName: 'Delux room',
                  price: data.deluxe_Other,
                  showName: data.deluxe_Other + '(Delux room)',
                  typeId: 4,
                  chargeTypeId: data.packageId > 0 ? 15 : data.cmS_CHARGE_TYPE_ID,
                  subChargeType: data.packageId > 0 ? 'Package' : data.cmS_SUBCHARGE_TYPE_DESC,
                  icdName:data.icD_Name
                })
              }
              if (data.general_Ward > 0) {
                obj.push({
                  packageId: data.packageId,
                  packageName: data.package_Name,
                  roomName: 'General room',
                  price: data.general_Ward,
                  showName: data.general_Ward + '(General room)',
                  typeId: 1,
                  chargeTypeId: data.packageId > 0 ? 15 : data.cmS_CHARGE_TYPE_ID,
                  subChargeType: data.packageId > 0 ? 'Package' : data.cmS_SUBCHARGE_TYPE_DESC,
                  icdName:data.icD_Name
                })
              }
              if (data.private_Ward > 0) {
                obj.push({
                  packageId: data.packageId,
                  packageName: data.package_Name,
                  roomName: 'Private room',
                  price: data.private_Ward,
                  showName: data.private_Ward + '(Private room)',
                  typeId: 3,
                  chargeTypeId: data.packageId > 0 ? 15 : data.cmS_CHARGE_TYPE_ID,
                  subChargeType: data.packageId > 0 ? 'Package' : data.cmS_SUBCHARGE_TYPE_DESC,
                  icdName:data.icD_Name
                })
              }
              if (data.semi_Private_Ward > 0) {
                obj.push({
                  packageId: data.packageId,
                  packageName: data.package_Name,
                  roomName: 'Semi private room',
                  price: data.semi_Private_Ward,
                  showName: data.semi_Private_Ward + '(Semi private room)',
                  typeId: 2,
                  chargeTypeId: data.packageId > 0 ? 15 : data.cmS_CHARGE_TYPE_ID,
                  subChargeType: data.packageId > 0 ? 'Package' : data.cmS_SUBCHARGE_TYPE_DESC,
                  icdName:data.icD_Name
                })
              }

              if (obj && obj.length > 0) {
                data.newPriceObj = obj;
              }
            }

          });

          //   angular.forEach(scope.items, function (data, index) {
          //     var testObje = [];
          //     angular.forEach(data.distinctPrices, function (data1, index1) {
          //       testObje.push({
          //         isSelected: false,
          //         price: data1,
          //         packageId: scope.items[index].packageId
          //       })
          //     });
          //     // scope.newPackageListData.push(testObje);
          //     scope.items[index].newPriceObj = testObje;
          //   });
          //   angular.forEach(scope.items, function (data, index) {
          //     scope.items[index].general_Ward1 = false;
          //     scope.items[index].private_Ward1 = false;
          //     scope.items[index].semi_Private_Ward1 = false;
          //   });
        }

        //scope.setCustomObject();

        scope.resetTimeOut = function () {
          $timeout(function () {
            scope.$apply(function () {
              scope.flag.isSuccuess = false;
            });
          }, 6000)
        }
        scope.$on('eventName', function (event, data) {
          //call directive function here
        })

        function finalResult() {
          scope.finalItems = [];
          angular.forEach(scope.selectedProcedureManual, function (data, index) {
            if (data.package_Name && data.general_Ward) {
              scope.finalItems.push(data);
            }
          });
          angular.forEach(scope.selectedProcedure, function (data, index) {
            if (data.package_Name) {
              scope.finalItems.push(data);
            }

          });
          angular.forEach(scope.finalItems, function (data, index) {
            scope.finalItems[index].uniqueIds = index + 1;
          });
          scope.someCtrlFn({
            arg: _.uniq(scope.finalItems)
          });
        };

        scope.resetObj = function (item) {
          if (item.packageId !== 0) {
            angular.forEach(scope.itemsDummy, function (data, index) {
              angular.forEach(data.newPriceObj, function (data1, index1) {
                if (item.packageId === data.packageId) {
                  angular.forEach(data.newPriceObj, function (data2, index2) {
                    scope.itemsDummy[index].newPriceObj[index1].isSelected = false;
                  });
                }
              });
            });
            angular.forEach(scope.itemsDataForSelection, function (data, index) {
              angular.forEach(data.newPriceObj, function (data1, index1) {
                if (item.packageId === data.packageId) {
                  angular.forEach(data.newPriceObj, function (data2, index2) {
                    scope.itemsDataForSelection[index].newPriceObj[index1].isSelected = false;
                  });
                }
              });
            });
          }
        };

        //Add to list
        function addtoBag(value) {
          scope.selectedProcedure = [];
          angular.forEach(scope.itemsDataForSelection, function (data, index) {
            angular.forEach(data.newPriceObj, function (data1, index1) {
              if (data1.isSelected) {
                var myObj = {
                  deluxe_Other: 0,
                  general_Ward: parseInt(data1.price),
                  general_Ward1: true,
                  packageId: data1.packageId,
                  package_Name: data.package_Name
                }
                scope.selectedProcedure.push(myObj);
              }
            });
          });
          scope.selectedProcedure = _.uniq(scope.selectedProcedure);
          finalResult();
        };

        //Remove item from List
        scope.removePackageFromList = function (item) {
          if (item) {
            angular.forEach(scope.selectedProcedure, function (data, index) {
              if ((item.uniqueIds === data.uniqueIds) && (item.packageId === data.packageId)) {
                scope.selectedProcedure.splice(index, 1);
              }
            });
            angular.forEach(scope.selectedProcedureManual, function (data, index) {
              if ((item.uniqueIds === data.uniqueIds) && (item.packageId === 0)) {
                scope.selectedProcedureManual.splice(index, 1);
              }
            });
            scope.resetObj(item);
            addtoBag();
          }
        };

        scope.addPackageToBag = function (data) {
          if (data) {
            scope.someCtrlFn({
              arg: data
            });
            scope.flag.isShowTypeahead = false;
            scope.flag.isShowAddPackage = false;
          }
        }

        scope.checkIfSamePackage = function() {
          var price = scope.form.amount.toString();
          var matchedPackages = [];
          if(scope.getreason) {
            scope.itemsData.forEach(function(e,i) {
              if(e.distinctPrices.includes(price)) {
                matchedPackages.push(e)
                e.className = 'highlight'
              }
              else {
                e.className = ''
              }
            })
            if(matchedPackages.length) {
              scope.itemsDummy =  matchedPackages;
              scope.showWarning = true;
              scope.flag.isShowTypeahead = true
            }
            else {
              scope.showWarning = false;
            }
          }
          else {
            scope.showWarning =  false;
          }
        }

        scope.addManualPackage = function (name, price,dataObj) {
          if (name && price) {
            var obj = {
              packageId: 0,
              packageName: name,
              roomName: null,
              price: price,
              showName: null,
              typeId: null,
              remarks: scope.form.reason || ''
              // chargeTypeId: dataObj.packageId > 0 ? 15 : dataObj.cmS_CHARGE_TYPE_ID,
              // subChargeType: dataObj.packageId > 0 ? 'Package' : dataObj.cmS_SUBCHARGE_TYPE_DESC
            }
            scope.someCtrlFn({
              arg: obj
            });
            scope.flag.isShowAddPackage = false;
            scope.flag.isShowTypeahead = false;
            scope.form.reason = ''
            scope.showWarning = false;
          }

        }

        scope.addManualChargeType = function (obj) {
            if (obj) {
            //   var obj = {
            //     packageId: 0,
            //     packageName: obj.cmS_SUBCHARGE_TYPE_DESC,
            //     roomName: null,
            //     price: price,
            //     showName: null,
            //     typeId: null
            //   }
            
            //   scope.someCtrlFn({
            //     arg: obj
            //   });
              scope.form.name=obj.packageName;
              scope.flag.isShowAddPackage = true;
              scope.flag.isShowTypeahead = false;
            }
  
          }

        //Check radio button for selected item
        scope.checkService = function (value, price, $index) {
          if (value) {
            angular.forEach(scope.itemsDummy, function (data, index) {
              angular.forEach(value.newPriceObj, function (data1, index1) {
                if (value.packageId === data.packageId && $index === index1) {
                  angular.forEach(data.newPriceObj, function (data2, index2) {
                    if (value.packageId === data2.packageId && $index !== index2) {
                      scope.itemsDummy[index].newPriceObj[index2].isSelected = false;
                    }
                  });
                  scope.itemsDummy[index].newPriceObj[$index].isSelected = !scope.itemsDummy[index].newPriceObj[$index].isSelected;
                }
              });
            });
            angular.forEach(scope.itemsDataForSelection, function (data, index) {
              angular.forEach(value.newPriceObj, function (data1, index1) {
                if (value.packageId === data.packageId && $index === index1) {
                  angular.forEach(data.newPriceObj, function (data2, index2) {
                    if (value.packageId === data2.packageId && $index === index2) {
                      scope.itemsDataForSelection[index].newPriceObj[$index].isSelected = true;
                    }
                    if (value.packageId === data2.packageId && $index !== index2) {
                      scope.itemsDataForSelection[index].newPriceObj[index2].isSelected = false;
                    }
                  });
                }
              });
            });
            addtoBag();
          }
        };

        scope.focusFlag = {
          shouldBeOpen: false
        }

        //Search item in list
        scope.searchData = function (value) {
          scope.form.name = '';
          if(!scope.nofilters && !scope.showWarning) {
            var matches = [];
            if (value) {
              scope.focusFlag.shouldBeOpen = false;
              angular.forEach(scope.itemsData, function (data, index) {
                if (!angular.isDefined(data.package_Name.toLowerCase()) || !angular.isDefined(value.toLowerCase())) {
                  return false;
                } else if (angular.isDefined(data.package_Name.toLowerCase())) {
                  var nameMatch = false;
                  nameMatch = nameMatch || data.package_Name.toLowerCase().indexOf(value.toLowerCase()) > -1;
                  if (nameMatch) {
                    data.showPackageName = null;
                    matches.push(data);
                  } else if (data.aliasName && data.aliasName.length > 0) {
                    var res = data.aliasName.find(function (x) {
                      return x.toLowerCase() == value.toLowerCase()
                    });
                    if (res) {
                      data.showPackageName = data.package_Name + "(" + value + ")"
                      matches.push(data);
                    } else {
                      data.showPackageName = '';
                    }
                  }
                }
                if (matches.length === 0) {
                  scope.focusFlag.shouldBeOpen = true;
                } else {
                  scope.focusFlag.shouldBeOpen = false;
                }
              });
            } else {
              matches = scope.itemsData;
            }
  
            scope.itemsDummy = matches;
            if (scope.itemsDummy.length === 0) {
              scope.flag.isShowAddPackage = true;
              scope.flag.isShowTypeahead = false;
              scope.form.name = value;
            } else {
              scope.flag.isShowTypeahead = true;
              scope.flag.isShowAddPackage = false;
            }
          }
          else {
            scope.flag.isShowAddPackage = true;
            scope.form.name = value || '';
          }
        };

        //Append Html to dom
        function triggerFunc(evt) {
          var el = angular.element();
          element.append(el);
          $compile(el)(scope);
        }

        //Open typahead on click in to inputbox
        scope.showHtml = function () {
          triggerFunc();
          scope.form.amount = '';
          scope.form.name = '';
          scope.flag.isSuccuess = false;
          if (scope.itemsData) {
            scope.flag.isShowAddPackage = false;
            scope.flag.isShowTypeahead = true;
          } else {
            scope.flag.isShowAddPackage = true;
            scope.flag.isShowTypeahead = false;
          }
          var model = scope.model;
          scope.setCustomObject();
          scope.searchData(model);
        };

        //Add item using maula entry
        scope.AddProcedure = function (name, price) {
          var value = _.filter(scope.selectedProcedureManual, function (item) {
            return item.package_Name.toLowerCase() === name.toLowerCase()
          }).length;
          if (name && price && value === 0) {
            var obj = {
              deluxe_Other: 0,
              general_Ward: parseInt(price),
              general_Ward1: true,
              packageId: 0,
              package_Name: name,
            }
            scope.flag.isSuccuess = true;
            scope.selectedProcedureManual.push(obj);
            finalResult();
            scope.resetTimeOut();
            scope.form.amount = '';
            scope.form.name = '';
            scope.model = '';
          } else {
            scope.flag.isShowAddPackage = false;;
            scope.flag.isShowTypeahead = false;
            scope.form.amount = '';
            scope.form.name = '';
          }
        };

        //element.bind('click', triggerFunc);
        scope.close= function () {
              scope.flag.isShowAddPackage = false;;
              scope.flag.isShowTypeahead = false;
              scope.flag.isSuccuess = false;
              scope.model = '';
              scope.form.amount = '';
              scope.form.name = '';
              //scope.$eval(scope.clickOutside);
              scope.showWarning = false;
        };

        //Watch item list
        scope.$watch('items', function (oldValue, newValue) {

          if (oldValue !== newValue || scope.itemsData.length == 0) {
            scope.itemsData = oldValue;
            scope.itemsDataForSelection = oldValue;
            scope.itemsDummy = oldValue;
          }
        });

        //Watch removed item from controller
        scope.$watch('removeitem', function (oldValue, newValue) {
          if (oldValue !== newValue) {
            scope.removePackageFromList(oldValue);
          }
        });

        //Watch current list of items present in controlller
        scope.$watch('selecteditems', function (oldValue, newValue) {
          if (oldValue !== newValue) {}
        });
      }
    };
  }])

  .directive('mbClaimTypeahead', ['$timeout', '$compile', '$parse', '$document', function ($timeout, $compile, $parse, $document) {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AEC',
      require: ['ngModel', '^?ngModelOptions'],
      templateUrl: '/app/components/templates/mbClaimTypeAhead.html?version=22' + date,
      scope: {
        items: '=',
        removeitem: '=',
        selecteditems: '=',
        prompt: '@',
        moduleFlag: '@',
        someCtrlFn: '&callbackFn'
      },
      link: function (scope, element, attrs, controller) {
        scope.itemsData = [];
        scope.selectedProcedure = [];
        scope.selectedProcedureManual = []
        scope.form = {
          name: '',
          amount: '',
        };
        scope.flag = {
          isShowTypeahead: false,
          isShowAddPackage: false,
          isSuccuess: false
        };

        scope.resetTimeOut = function () {
          $timeout(function () {
            scope.$apply(function () {
              scope.flag.isSuccuess = false;
            });
          }, 6000)
        }
        scope.$on('eventName', function (event, data) {
          //call directive function here
        })

        function finalResult() {
          scope.finalItems = [];
          angular.forEach(scope.selectedProcedureManual, function (data, index) {
            if (data.package_Name && data.general_Ward) {
              scope.finalItems.push(data);
            }
          });
          angular.forEach(scope.selectedProcedure, function (data, index) {
            if (data.package_Name) {
              scope.finalItems.push(data);
            }

          });
          angular.forEach(scope.finalItems, function (data, index) {
            scope.finalItems[index].uniqueIds = index + 1;
          });
          scope.someCtrlFn({
            arg: _.uniq(scope.finalItems)
          });
        };

        scope.resetObj = function (item) {
          if (item.packageId !== 0) {
            angular.forEach(scope.itemsDummy, function (data, index) {
              angular.forEach(data.newPriceObj, function (data1, index1) {
                if (item.packageId === data.packageId) {
                  angular.forEach(data.newPriceObj, function (data2, index2) {
                    scope.itemsDummy[index].newPriceObj[index1].isSelected = false;
                  });
                }
              });
            });
            angular.forEach(scope.itemsDataForSelection, function (data, index) {
              angular.forEach(data.newPriceObj, function (data1, index1) {
                if (item.packageId === data.packageId) {
                  angular.forEach(data.newPriceObj, function (data2, index2) {
                    scope.itemsDataForSelection[index].newPriceObj[index1].isSelected = false;
                  });
                }
              });
            });
          }
        };

        //Add to list
        function addtoBag(value) {
          scope.selectedProcedure = [];
          angular.forEach(scope.itemsDataForSelection, function (data, index) {
            angular.forEach(data.newPriceObj, function (data1, index1) {
              if (data1.isSelected) {
                var myObj = {
                  deluxe_Other: 0,
                  general_Ward: parseInt(data1.price),
                  general_Ward1: true,
                  packageId: data1.packageId,
                  package_Name: data.package_Name
                }
                scope.selectedProcedure.push(myObj);
              }
            });
          });
          scope.selectedProcedure = _.uniq(scope.selectedProcedure);
          finalResult();
        };

        //Remove item from List
        scope.removePackageFromList = function (item) {
          if (item) {
            angular.forEach(scope.selectedProcedure, function (data, index) {
              if ((item.uniqueIds === data.uniqueIds) && (item.packageId === data.packageId)) {
                scope.selectedProcedure.splice(index, 1);
              }
            });
            angular.forEach(scope.selectedProcedureManual, function (data, index) {
              if ((item.uniqueIds === data.uniqueIds) && (item.packageId === 0)) {
                scope.selectedProcedureManual.splice(index, 1);
              }
            });
            scope.resetObj(item);
            addtoBag();
          }
        };

        //Check radio button for selected item
        scope.checkService = function (value, price, $index) {
          if (value) {
            angular.forEach(scope.itemsDummy, function (data, index) {
              angular.forEach(value.newPriceObj, function (data1, index1) {
                if (value.packageId === data.packageId && $index === index1) {
                  angular.forEach(data.newPriceObj, function (data2, index2) {
                    if (value.packageId === data2.packageId && $index !== index2) {
                      scope.itemsDummy[index].newPriceObj[index2].isSelected = false;
                    }
                  });
                  scope.itemsDummy[index].newPriceObj[$index].isSelected = !scope.itemsDummy[index].newPriceObj[$index].isSelected;
                }
              });
            });
            angular.forEach(scope.itemsDataForSelection, function (data, index) {
              angular.forEach(value.newPriceObj, function (data1, index1) {
                if (value.packageId === data.packageId && $index === index1) {
                  angular.forEach(data.newPriceObj, function (data2, index2) {
                    if (value.packageId === data2.packageId && $index === index2) {
                      scope.itemsDataForSelection[index].newPriceObj[$index].isSelected = true;
                    }
                    if (value.packageId === data2.packageId && $index !== index2) {
                      scope.itemsDataForSelection[index].newPriceObj[index2].isSelected = false;
                    }
                  });
                }
              });
            });
            addtoBag();
          }
        };

        //Search item in list
        scope.searchData = function (value) {
          var matches = [];
          scope.form.name = '';
          if (value) {
            scope.focusFlag.shouldBeOpen = false;
            angular.forEach(scope.itemsData, function (data, index) {
              if (!angular.isDefined(data.package_Name.toLowerCase()) || !angular.isDefined(value.toLowerCase())) {
                return false;
              }
              var nameMatch = false,
                numberMatch = false;
              if (angular.isDefined(data.package_Name.toLowerCase())) {
                nameMatch = nameMatch || data.package_Name.toLowerCase().indexOf(value.toLowerCase()) > -1;
              }
              if (nameMatch) {
                matches.push(data);
              }
              if (matches.length === 0) {
                scope.focusFlag.shouldBeOpen = true;
              } else {
                scope.focusFlag.shouldBeOpen = false;
              }
            });
          } else {
            matches = scope.itemsData;
          }
          if (scope.itemsData !== matches) {

          } else {

          }
          scope.itemsDummy = matches;
          if (scope.itemsDummy.length === 0) {
            scope.flag.isShowAddPackage = false;
            scope.flag.isShowTypeahead = false;
          } else {
            scope.flag.isShowTypeahead = true;
            scope.flag.isShowAddPackage = false;
          }
        };

        //Append Html to dom
        function triggerFunc(evt) {
          var el = angular.element();
          element.append(el);
          $compile(el)(scope);
        }

        //Open typahead on click in to inputbox
        scope.showHtml = function () {
          triggerFunc();
          scope.form.amount = '';
          scope.form.name = '';
          scope.flag.isSuccuess = false;
          if (scope.itemsData) {
            scope.flag.isShowAddPackage = false;
            scope.flag.isShowTypeahead = true;
          } else {
            scope.flag.isShowAddPackage = true;
            scope.flag.isShowTypeahead = false;
          }
          var model = scope.model;
          scope.searchData(model);
        };

        //Add item using maula entry
        scope.AddProcedure = function (name, price) {
          var value = _.filter(scope.selectedProcedureManual, function (item) {
            return item.package_Name.toLowerCase() === name.toLowerCase()
          }).length;
          if (name && price && value === 0) {
            var obj = {
              deluxe_Other: 0,
              general_Ward: parseInt(price),
              general_Ward1: true,
              packageId: 0,
              package_Name: name,
            }
            scope.flag.isSuccuess = true;
            scope.selectedProcedureManual.push(obj);
            finalResult();
            scope.resetTimeOut();
            scope.form.amount = '';
            scope.form.name = '';
            scope.model = '';
          } else {
            scope.flag.isShowAddPackage = false;;
            scope.flag.isShowTypeahead = false;
            scope.form.amount = '';
            scope.form.name = '';
          }
        };

        //element.bind('click', triggerFunc);
        $document.on('click', function (e) {
          if (element !== e.target && !element[0].contains(e.target)) {
            scope.$apply(function () {
              scope.flag.isShowAddPackage = false;;
              scope.flag.isShowTypeahead = false;
              scope.flag.isSuccuess = false;
              scope.model = '';
              scope.form.amount = '';
              scope.form.name = '';
              //scope.$eval(scope.clickOutside);
            });
          }
        });

        //Watch item list
        scope.$watch('items', function (oldValue, newValue) {
          if (oldValue !== newValue) {
            scope.itemsData = oldValue;
            scope.itemsDataForSelection = oldValue;
            scope.itemsDummy = oldValue;
          }
        });

        //Watch removed item from controller
        scope.$watch('removeitem', function (oldValue, newValue) {
          if (oldValue !== newValue) {
            scope.removePackageFromList(oldValue);
          }
        });

        //Watch current list of items present in controlller
        scope.$watch('selecteditems', function (oldValue, newValue) {
          if (oldValue !== newValue) {}
        });
      }
    };
  }])
  .directive('angularTabs', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AE',
      templateUrl: '/app/components/otherPayer/angularTabs.html?version=21' + date,
      controller: 'angularTabsCtrl',
      scope: {
        preauthfiltered: '=datalist',
        tabname: '=tabname',
        tabtype: '=tabtype',
        appointments: '=appointmentlist',
        seaarchDataText: '=search',
        someCtrlFn: '&callbackFn',
        callBackSecondFn: '&callbackSecondFn',
        tpaid: '=tpaid'
      }
    };
  }])

  .directive('requestDndModal', ['UtilitiesService', 'UserService', '$uibModal', function (UtilitiesService, UserService, $uibModal) {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AE',
      scope: {
        requestData: "=requestdata",
        showDND: '=dnd',
        showDNDCustomer: '=dndcustomer',
        bell: '='
      },
      link: function (scope, element, attr) {
        var getTestReport = element.on('click', function (event) {
          var modalInstance = $uibModal.open({
            keyboard: false,
            backdrop: 'static',
            templateUrl: '/app/components/plusModals/requestDNDModal.html?version=22' + date,
            controller: ['$scope', '$rootScope', 'UtilitiesService', 'UserService', '$uibModalInstance', '$timeout',
              function ($scope, $rootScope, UtilitiesService, UserService, $uibModalInstance, $timeout) {
                $scope.reason = '';
                $scope.requestData = scope.requestData;
                $scope.showDND = scope.showDND;
                $scope.showDNDCustomer = scope.showDNDCustomer;
                $scope.closeModal = function () {
                  $uibModalInstance.dismiss();
                };
                $scope.markDnd = function () {
                  if ($scope.showDND) {
                    $scope.requestData.requestJSON.additionalInfo.DND = !$scope.requestData.requestJSON.additionalInfo.DND;
                  } else if ($scope.showDNDCustomer) {
                    $scope.requestData.requestJSON.additionalInfo.DNDCustomer = !$scope.requestData.requestJSON.additionalInfo.DNDCustomer
                  }
                  var data = {
                    requestID: 0,
                    dndInfo: {
                      DNDReason: $scope.reason,
                      DND: $scope.requestData.requestJSON.additionalInfo.DND,
                      DNDCustomer: $scope.requestData.requestJSON.additionalInfo.DNDCustomer
                    },
                    esalesId: $scope.requestData.id
                  };
                  $scope.changeFlagValue = function () {
                    scope.bell = !scope.bell;
                  }

                  UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'MarkDNDForRequest', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
                    $scope.closeModal();
                    $scope.reason = '';
                    if (response.data.isSuccess) {
                      if ($scope.showDND) {
                        $timeout($scope.changeFlagValue, 0);
                        if (!$scope.requestData.requestJSON.additionalInfo.DND) {
                          UtilitiesService.showAlertMessage('DND service deactivated successfully.', true);
                        } else {
                          UtilitiesService.showAlertMessage('DND service activated successfully.', true);
                        }
                      } else if ($scope.showDNDCustomer) {
                        $timeout($scope.changeFlagValue, 0);
                        if (!$scope.requestData.requestJSON.additionalInfo.DNDCustomer) {
                          UtilitiesService.showAlertMessage('DND Customer service deactivated successfully.', true);
                        } else {
                          UtilitiesService.showAlertMessage('DND Customer service activated successfully.', true);
                        }
                      }
                    } else {
                      UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
                    }
                  }, function (error) {
                    $scope.reason = '';
                    UtilitiesService.showAlertMessage('oops! something went wrong, please try again later.');
                  });
                }
              }
            ]
          });
        });
      }
    }
  }])

  .directive('confirmAppointmentModal', ['$uibModal', 'UtilitiesService', 'UserService', function ($uibModal, UtilitiesService, UserService) {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AE',
      scope: {
        request: "@request",
        refreshAppointments: '&refresh'
      },
      link: function (scope, element, attr) {
        var getTestReport = element.on('click', function (event) {
          var modalInstance = $uibModal.open({
            keyboard: false,
            backdrop: 'static',
            templateUrl: '/app/components/plusModals/confirmAppointmentModal.html?version=22' + date,
            controller: ['$scope', '$rootScope', 'UtilitiesService', 'UserService', '$uibModalInstance',
              function ($scope, $rootScope, UtilitiesService, UserService, $uibModalInstance) {
                $scope.remark = '';
                $scope.request = scope.request && scope.request.length > 0 ? JSON.parse(scope.request) : null;
                $scope.nextStatusID = null;
                $scope.formatTime = UtilitiesService.formatTime;
                $scope.compareDate = UtilitiesService.compareDate;
                $scope.action = {
                  visibleDate: null,
                  visibleTime: null
                };
                $scope.uploadedFileData = {
                  reports: {}
                };
                $scope.storeFiles = [];
                $scope.refreshAppointments = scope.refreshAppointments;

                // date conversion for displaying it inside input tag
                $scope.action.visibleDate = $scope.compareDate($scope.request.fullfillmentDate);
                $scope.action.visibleTime = $scope.action.visibleDate + " " + $scope.formatTime($scope.request.fullfillmentDate);

                // self invoked function for choosing next status id
                (function () {
                  if ($scope.request.statusId) {
                    switch ($scope.request.statusId) {
                      case 32:
                        $scope.nextStatusID = 37;
                        break;
                      case 22:
                        $scope.nextStatusID = 23;
                        break;
                      case 40:
                        $scope.nextStatusID = 32;
                    }
                  }
                })();

                // for closing modal with clearing the assigned data
                $scope.closeModal = function () {
                  $uibModalInstance.dismiss();
                  $scope.clearFilledData();
                };

                //file function for uploading files
                $scope.fileFn = function (data) {
                  if (data) {
                    for (var key in data) {
                      $scope.uploadedFileData.reports[key] = data[key];
                    }
                    angular.forEach(data, function (value, index) {
                      $scope.storeFiles.push({
                        fileName: value,
                        filePath: index
                      });
                    });
                  }
                };

                // removing uploded files from stored local files list
                $scope.removeFiles = function (item) {
                  if (item) {
                    delete $scope.uploadedFileData.reports[item.filePath];
                    angular.forEach($scope.storeFiles, function (value, index) {
                      if (value.fileName === item.fileName) {
                        $scope.storeFiles.splice(index, 1);
                      }
                    });
                  }
                };

                // for downloading attachments
                $scope.downloadAttachment = function (obj) {
                  if (obj) {
                    window.open(
                      UtilitiesService.getDownloadURL(true) + obj,
                      '_blank'
                    );
                  }
                };

                // data clearing function if any thing more is assigned then needs to be cleared here
                $scope.clearFilledData = function () {
                  $scope.remark = '';
                  $scope.uploadedFileData = {
                    reports: {}
                  };
                  $scope.storeFiles = [];
                }

                // confirm appointment API call with payload
                $scope.confirmAppointment = function (isNotAttended) {
                  if (isNotAttended) {
                    scope.nextStatusId = 39;
                  }
                  var data = {
                    request: {
                      requestId: $scope.request.requestId ? $scope.request.requestId : null,
                      currentStatusId: $scope.request.statusId ? $scope.request.statusId : null,
                      remarks: $scope.remark,
                      ScheduledAppointmentDate: $scope.request.fullfillmentDate ? $scope.request.fullfillmentDate : null,
                      requestedNextActionId: $scope.nextStatusID,
                      attachFiles: $scope.uploadedFileData,
                    },
                    requestAccessToken: UserService.getAccessToken()
                  }

                  // call /request to mark confirmation of appointment
                  UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/request', data, 'POST', UserService.getAccessToken(), true).then(function (response) {
                    if (response.data.isSuccess) {
                      //if success then clear the data with showing success alert and refresh list again
                      $scope.closeModal();
                      UtilitiesService.showAlertMessage('Request updated successfully', true);
                      $scope.clearFilledData();
                      $scope.refreshAppointments();
                    } else {
                      UtilitiesService.showAlertMessage('Something went wrong', false);
                    }
                  });
                }
              }
            ]
          });
        });
      }
    }
  }])

  .directive('rescheduleAppointmentModal', ['UtilitiesService', 'UserService', '$uibModal', function (UtilitiesService, UserService, $uibModal) {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AE',
      scope: {
        requestData: "=requestdata",
        refresh: '&refresh'
      },
      link: function (scope, element, attr) {
        var getTestReport = element.on('click', function (event) {
          var modalInstance = $uibModal.open({
            keyboard: false,
            backdrop: 'static',
            templateUrl: '/app/components/plusModals/rescheduleAppointmentModal.html?version=22' + date,
            controller: ['$scope', '$rootScope', 'UtilitiesService', 'UserService', '$uibModalInstance', '$timeout',
              function ($scope, $rootScope, UtilitiesService, UserService, $uibModalInstance, $timeout) {
                $scope.reschedule = {
                  opened: false
                }
                $scope.client = {
                  prefDate: null,
                  prefTime: null

                };
                $scope.showChkedOnDcLogin = false;
                $scope.testData = {
                  testStateId: '',
                  testCityId: '',
                  testLocalityId: '',
                  testSubLocalityId: '',
                  dcValue: ''
                };
                $scope.action = {
                  cancelComments: '',
                  statusId: '',
                  nextStatusId: '',
                  requestId: '',
                  spocname: '',
                  spocphone: '',
                  date: '',
                  remarks: '',
                  secondPreferredTime: '',
                  dcPrice: '',
                  visibleDate: '',
                  visibleTime: '',
                  partnerOrderId: '',
                  showdcselection: false,
                  productId: ''
                };
                $scope.homeVisit = {
                  addressLineOne: '',
                  addressLineTwo: ''
                }
                $scope.cities = [];
                $scope.locations = [];
                $scope.sublocations = [];
                $scope.diagnosticCentres = [];
                $scope.action.showdcselection = false;
                $scope.ERTypeId = 5290;
                $scope.serviceBrokerId = '1000042';
                $scope.showDcSelection = function (value, source) {
                  $scope.action.showdcselection = !!value;
                  $scope.testData.testStateId = '';
                  $scope.cities = [];
                  $scope.testData.testCityId = '';
                  $scope.locations = [];
                  $scope.testData.testLocalityId = '';
                  $scope.sublocations = [];
                  $scope.testData.testSubLocalityId = '';
                  $scope.diagnosticCentres = [];
                  $scope.testData.dcValue = '';
                  $scope.locationMethods.loadStates();
                  if (source === 'dcVisit') {
                    $scope.action.showHomeVisitSelection = false;
                    $scope.homeVisit = [];
                    if ($scope.action.showdcselection === false) {
                      $scope.testData.testStateId = '';
                      $scope.testData.testCityId = '';
                      $scope.testData.testLocalityId = '';
                      $scope.testData.testSubLocalityId = '';
                      $scope.testData.dcValue = '';
                      $scope.selectedDcs = [];
                    }
                  }
                  if (source === 'homeVisit') {
                    $scope.action.showdcselection = false;
                    $scope.testData.testStateId = '';
                  }
                };
                $scope.load = scope.refresh;
                var maxFirst = new Date();
                maxFirst.setHours(18);
                maxFirst.setMinutes(0);
                $scope.maxFirst = maxFirst;
                $scope.hstep = 1;
                $scope.mstep = 30;
                $scope.ismeridian = false;

                var minFirst = new Date();
                minFirst.setHours(8);
                minFirst.setMinutes(0);
                $scope.altInputFormats = ['M!/d!/yyyy'];
                $scope.dateOptionsReschedule = {
                  formatYear: 'yy',
                  minDate: new Date()
                };
                $scope.minFirst = minFirst;
                $scope.requestData = scope.requestData;
                $scope.reschedule = function () {
                  $scope.reschedule.opened = true;
                };
                $scope.formatTime = UtilitiesService.formatTime;
                $scope.compareDate = UtilitiesService.compareDate;
                $scope.appointmentDate = $scope.compareDate($scope.requestData.additionalInformation.appointmentDate);
                $scope.currentAppointmentDate = $scope.appointmentDate + ' ' + $scope.formatTime($scope.requestData.additionalInformation.appointmentDate);
                $scope.secondPreferredDateAndTime = $scope.requestData.additionalInformation.secondAppointmentDate;
                $scope.secondPreferredTime = $scope.compareDate($scope.secondPreferredDateAndTime) + " " + $scope.formatTime($scope.secondPreferredDateAndTime);
                $scope.yearInSecAppointmentDate = new Date($scope.secondPreferredTime).getFullYear();

                $scope.makeRequest = function () {
                  if ($scope.testData.dcValue) {
                    $scope.testData.dcValue = JSON.parse($scope.testData.dcValue);
                  }
                  var requestData = {
                    request: {
                      requestId: $scope.requestData.requestId,
                      currentStatusId: $scope.requestData.currentStatusId,
                      remarks: $scope.action.remarks,
                      ScheduledAppointmentDate: $scope.client.prefDate,
                      requestedNextActionId: $scope.requestData.nextPossibleActions[0].actionStatusId,
                      attachFiles: {},
                      providerId: $scope.testData.dcValue.entityId ? $scope.testData.dcValue.entityId : null,
                      providerName: $scope.testData.dcValue.entityName ? $scope.testData.dcValue.entityName : null,
                      spocName: $scope.action.spocname,
                      spocContactNo: $scope.action.spocphone,
                      additionalParameters: {},
                      addressLine1: $scope.homeVisit.addressLineOne ? $scope.homeVisit.addressLineOne : '',
                      addressLine2: $scope.homeVisit.addressLineTwo ? $scope.homeVisit.addressLineTwo : '',
                      //isHomeVisit: scope.action.showHomeVisitSelection === true ? true : (scope.visitTypeDcHome === 'Appointment' ? false : (scope.visitTypeDcHome === 'Home_Visit' ? true : false))
                    },
                    requestAccessToken: UserService.getAccessToken()
                  }
                  if ($scope.action.showHomeVisitSelection === true) {
                    requestData.request.isHomeVisit = true;
                    $scope.visitTypeDcHome = '';
                  } else if ($scope.action.showHomeVisitSelection === false) {
                    requestData.request.isHomeVisit = false
                    $scope.visitTypeDcHome = '';
                  } else if ($scope.visitTypeDcHome === 'Appointment') {
                    requestData.request.isHomeVisit = false
                  } else if ($scope.visitTypeDcHome === 'Home_Visit') {
                    requestData.request.isHomeVisit = true
                  }
                  UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/request', requestData, "post").then(function (response) {
                    var targetModal = event.target.parentNode;
                    $scope.currentAppointmentDate = '';
                    $scope.resetTime();
                    $scope.testData.testStateId = '';
                    $scope.testData.testCityId = '';
                    $scope.testData.testLocalityId = '';
                    $scope.testData.testSubLocalityId = '';
                    $scope.testData.dcValue = '';
                    $scope.homeVisit = {};
                    $scope.action = {};
                    scope.refresh();
                    $scope.closeModal();
                  });
                };
                $scope.resetTime = function () {
                  $scope.maxFirst = '';
                  $scope.minFirst = '';
                  $scope.client.prefTime = '';
                  var maxFirst = new Date();
                  maxFirst.setHours(18);
                  maxFirst.setMinutes(0);
                  $scope.maxFirst = maxFirst;
                  var minFirst = new Date();
                  minFirst.setHours(8);
                  minFirst.setMinutes(0);
                  $scope.minFirst = minFirst;
                  $scope.client.prefTime = minFirst;
                };

                $scope.loadLocationData = function (type, id) {
                  switch (type) {
                    case 'city':
                      $scope.locationMethods.loadCities(id);
                      break;
                    case 'locality':
                      $scope.locationMethods.loadLocations(id);
                      break;
                    case 'sublocality':
                      $scope.locationMethods.loadSubLocations(id);
                      break;
                    case 'dc':
                      $scope.locationMethods.loadDCForTests(id);
                      break;
                    default:
                      $scope.locationMethods.loadCities(id);
                      break;
                  }
                };

                $scope.locationMethods = (function () {
                  return {
                    loadStates: function () {
                      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix('integration') + '/masterdata/lookup/state.json', '', 'get').then(function (response) {
                        if (response.data.isSuccess) {
                          $scope.states = response.data.lookUpData;
                        }
                      });
                    },
                    loadCities: function (stateId) {
                      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/masterdata/lookup/district/' + stateId + '.json', '', 'get').then(function (response) {
                        if (response.data.isSuccess) {
                          $scope.cities = response.data.lookUpData;
                        }
                      });
                    },
                    loadLocations: function (cityId) {
                      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + "/masterdata/lookup/city/" + cityId + '.json', '', 'get').then(function (response) {
                        if (response.data.isSuccess) {
                          $scope.locations = response.data.lookUpData;
                        }
                      });
                    },
                    loadSubLocations: function (locationId) {
                      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/masterdata/lookup/location/' + locationId + '.json', '', 'get').then(function (response) {
                        if (response.data.isSuccess) {
                          $scope.sublocations = response.data.lookUpData;
                        }
                      });
                    },
                    loadDCForTests: function (id, obj) {
                      $scope.testData.testSubLocalityId = id;
                      UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + 'EntityRelation/Search/EntitySearch/' + $scope.ERTypeId + '/' + $scope.serviceBrokerId + '/' + 0 + '/' + $scope.testData.testStateId + '/' + $scope.testData.testCityId + '/' + $scope.testData.testLocalityId + '/' + $scope.testData.testSubLocalityId + '.json', '', 'get').then(function (response) {
                        if (response.statusText == 'OK') {
                          $scope.allDCs = response.data;
                          $scope.tempDiagnosticCentres = response.data;
                          $scope.loadFilteredDc();
                        }
                      });
                    }
                  }
                })();

                $scope.loadFilteredDc = function () {
                  var url = UtilitiesService.getPlusUrlPrefix() + "CorporatePackageProvider/" + $scope.requestData.additionalInformation.orderItemProductId + "/false.json";
                  UserService.makeRestCall(url, "", "get").then(function (response) {
                    if (response.data.length > 0) {
                      $scope.filteredDc = response.data;
                      var arr = [];
                      $scope.diagnosticCentres = [];
                      $($scope.tempDiagnosticCentres).each(function (i, v) {
                        if ($scope.filteredDc.indexOf(v.id) !== -1) {
                          arr.push(v);
                        }
                      });
                      $scope.diagnosticCentres = arr;
                    }
                  });
                };
                $scope.closeModal = function () {
                  $uibModalInstance.dismiss();
                };
              }
            ],
            size: 'md'
          });
        })
      },
    }
  }])

  .directive('calendar', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'E',
      templateUrl: 'app/components/templates/calendar.html' + date,
      scope: {
        selected: "="
      },
      link: function (scope) {
        scope.selected = _removeTime(scope.selected || moment());
        scope.month = scope.selected.clone();

        var start = scope.selected.clone();
        start.date(1);
        _removeTime(start.day(0));

        _buildMonth(scope, start, scope.month);

        scope.select = function (day) {
          scope.selected = day.date;
          scope.selectedDate = day.date._d
        };

        scope.next = function () {
          var next = scope.month.clone();
          _removeTime(next.month(next.month() + 1)).date(1);
          scope.month.month(scope.month.month() + 1);
          _buildMonth(scope, next, scope.month);
        };

        scope.previous = function () {
          var previous = scope.month.clone();
          _removeTime(previous.month(previous.month() - 1).date(1));
          scope.month.month(scope.month.month() - 1);
          _buildMonth(scope, previous, scope.month);
        };
      }
    };

    function _removeTime(date) {
      return date.day(0).hour(0).minute(0).second(0).millisecond(0);
    }

    function _buildMonth(scope, start, month) {
      scope.weeks = [];
      var done = false,
        date = start.clone(),
        monthIndex = date.month(),
        count = 0;
      while (!done) {
        scope.weeks.push({
          days: _buildWeek(date.clone(), month)
        });
        date.add(1, 'w');
        done = count++ > 2 && monthIndex !== date.month();
        monthIndex = date.month();
      }
    }

    function _buildWeek(date, month) {
      var days = [];
      for (var i = 0; i < 7; i++) {
        days.push({
          name: date.format('dd').substring(0, 1),
          number: date.date(),
          isCurrentMonth: date.month() === month.month(),
          isToday: date.isSame(new Date(), 'day'),
          date: date
        });
        date = date.clone();
        date.add(1, 'd');
      }
      return days;
    }
  }])
  .directive('communicationHistoryModal', ['UtilitiesService', 'UserService', '$uibModal', function (UtilitiesService, UserService, $uibModal) {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AE',
      scope: {
        requestFlowId: "=requestflowid",
        isFlowReqId: "=isflowreqid"
      },
      link: function (scope, element, attr) {
        var getCommunicationHistory = element.on('click', function (event) {
          if (scope.requestFlowId) {
            if (scope.isFlowReqId === 'reqId') {
              var url = UtilitiesService.getPlusUrlPrefix('integration') + '/Request/Communication/' + scope.requestFlowId;
            } else if (scope.isFlowReqId === 'eSlale') {
              var url = UtilitiesService.getPlusUrlPrefix('integration') + '/Request/CommunicationByModule/ESales/' + scope.requestFlowId;
            } else {
              var url = UtilitiesService.getPlusUrlPrefix('integration') + '/RequestFlow/Communication/' + scope.requestFlowId;
            }
            UserService.makeRestCall(url, '', 'GET', UserService.getAccessToken()).then(function (response) {
              if (response) {
                var modalInstance = $uibModal.open({
                  keyboard: false,
                  backdrop: 'static',
                  templateUrl: '/app/components/plusModals/communicationHistory.html?version=22' + date,
                  controller: ['$scope', 'UtilitiesService', 'UserService', '$uibModalInstance', function ($scope, UtilitiesService, UserService, $uibModalInstance) {
                    $scope.resendSMS = function (auditId) {
                      var url = UtilitiesService.getPlusUrlPrefix('integration') + 'resendTemplateFromAudit/' + auditId;
                      // console.log("inside resend", UserService.getAccessToken());
                      UserService.makeRestCall(url, '', 'GET', UserService.getAccessToken(), true).then(function (response) {
                        if (response.data.isSuccess) {
                          UtilitiesService.showAlertMessage("Communication re-triggered successfully", true);
                        } else UtilitiesService.showAlertMessage(response.data.errorMessage, false);
                      });
                    }
                    if (response.data) {
                      $scope.compareDate = function (sentTime) {
                        return UtilitiesService.compareDateNew(new Date(sentTime));
                      }
                      $scope.formatTime = function (sentTime) {
                        return UtilitiesService.formatTimeNew(new Date(sentTime));
                      }
                      $scope.communicationDetails = response.data;
                      $scope.downloadEmailBodyUrl = UtilitiesService.getProviderCoreUrl() + 'insurance/getDownloadEmail/v1?id=';
                      $scope.size = 'lg';
                    } else {
                      $scope.noCommunication = 'No communication available!';
                      $scope.size = 'sm';
                    }
                    scope.size = $scope.size;
                    $scope.closeModal = function () {
                      $uibModalInstance.dismiss();
                    };
                    $scope.isInsurerAgent =  false;
                    $scope.userObject = UserService.getUserObj();
                    if ($scope.userObject && $scope.userObject.rolesFeatures && $scope.userObject.rolesFeatures.roles){
                      for (var i=0, max= $scope.userObject.rolesFeatures.roles.length; i<max; i++){
                        if($scope.userObject.rolesFeatures.roles[i].roleName == 'Insurer_Agent') {
                          $scope.isInsurerAgent =  true;
                          break;
                        }
                      }
                    }
                  }],
                  size: 'lg'
                });
              }
            })
          }
        })
      },
    }
  }])
  .directive('dcNotes', ['UtilitiesService', 'UserService', '$uibModal', function (UtilitiesService, UserService, $uibModal) {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AE',
      scope: {
        id: "=id"
      },
      link: function (scope, element, attr) {
        var getCommunicationHistory = element.on('click', function (event) {
          if (scope.id) {
            var url = UtilitiesService.getPlusUrlPrefix() + '/EntityProperties/' + scope.id;
            UserService.makeRestCall(url, '', 'GET', UserService.getAccessToken()).then(function (response) {
              if (response) {
                var modalInstance = $uibModal.open({
                  keyboard: false,
                  backdrop: 'static',
                  templateUrl: '/app/components/plusModals/dcNotes.html?version=22' + date,
                  controller: ['$scope', 'UtilitiesService', 'UserService', '$uibModalInstance', function ($scope, UtilitiesService, UserService, $uibModalInstance) {
                    $scope.outSourcingDetail = '';
                    if (response.data) {
                      angular.forEach(response.data && response.data.entityProperties, function (v, i) {
                        if (v.propertyName == 'OutSourcing') {
                          $scope.outSourcingDetail = v.propertyValue;
                        }
                      });
                      $scope.size = 'lg';
                    }
                    scope.size = $scope.size;
                    $scope.closeModal = function () {
                      $uibModalInstance.dismiss();
                    };
                  }],
                  size: 'lg'
                });
              }
            })
          }
        })
      },
    }
  }])
  .directive('hdfcnewadmissionform', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      replace: true,
      restrict: 'AE',
      templateUrl: '/app/components/newAdmissionForm/hdfcErgo/hdfcNewAdmissionForm.html?version=' + date,
      scope: true
    };
  }])
  .directive('genericnewadmissionform', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      replace: true,
      restrict: 'AE',
      templateUrl: '/app/components/newAdmissionForm/genericNewAdmissionForm.html?version=' + date,
      scope: true
    };
  }])
  .directive('cataractform', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      replace: true,
      restrict: 'AE',
      templateUrl: '/app/components/newAdmissionForm/cataractDataForm.html?version=' + date,
      scope: true
    };
  }])
  .directive('maternityform', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      replace: true,
      restrict: 'AE',
      templateUrl: '/app/components/newAdmissionForm/maternityDataForm.html?version=' + date,
      scope: true
    };
  }])
  .directive('digitalMer', ['UtilitiesService', 'UserService', '$uibModal', function (UtilitiesService, UserService, $uibModal) {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'AE',
      scope: {
        requestId: "@reqid",
        roleOfInsurer: "@roles"
      },
      link: function (scope, element, attr) {
        var getTestReport = element.on('click', function (event) {
          var modalInstance = $uibModal.open({
            keyboard: false,
            backdrop: 'static',
            windowClass: 'digital-mer',
            templateUrl: '/app/components/plusDigitalMer/plusDigitalMer.html?version=22' + date,
            controller: ['$scope', '$rootScope', 'UtilitiesService', 'UserService', '$uibModalInstance',
              function ($scope, $rootScope, UtilitiesService, UserService, $uibModalInstance) {
                $scope.isInsurerRoles = scope.roleOfInsurer;
                $scope.reqId = scope.requestId;
                $scope.finalMerData = {};
                $scope.questions = [];

                (function () {
                  var url = UtilitiesService.getPlusUrlPrefix() + '/DigitalMERView/' + scope.requestId;
                  UserService.makeRestCall(url, '', 'get').then(function (response) {
                    if (response.data.isSuccess) {
                      $scope.questions = response.data;
                    } else {
                      UtilitiesService.showAlertMessage(response.data.errorMessage, false);
                    }
                  });
                })();

                $scope.closeModal = function () {
                  $uibModalInstance.dismiss();
                  $scope.finalMerData = {};
                };

                $scope.saveTestReport = function (testObj, header, footer) {
                  $scope.finalMerData = {};
                  $scope.finalMerData = {
                    "requestId": $scope.reqId,
                    "lstQuestions": testObj,
                    "headerQuestions": header,
                    "footerQuestions": footer,
                    erId: $scope.questions.ErId
                  };
                  UserService.makeRestCall(UtilitiesService.getPlusUrlPrefix() + '/DigitalMERSubmit', $scope.finalMerData, 'POST', UserService.getAccessToken()).then(function (response) {
                    if (response.data.isSuccess) {
                      $scope.closeModal();
                      UtilitiesService.showAlertMessage('Digital MER submitted successfully', true);
                    } else {
                      UtilitiesService.showAlertMessage(response.data.errorMessage, false);
                    }
                  });
                }
              }
            ],
            size: 'lg'
          });
        })
      },
    }
  }])
  .directive('listFilter', [function () {
    var date = new Date();
    date = date.getTime();
    return {
      restrict: 'E',
      templateUrl: '/app/components/templates/listFilter.html?version=' + date,
      scope: {
        pipeline: "=?",
        totalItems: "=?",
        statusList: "=?"
      },
      link: function (scope, element, attr) {
        console.log(scope.pipeline);
        scope.searchType = [
        {
          value: "requestId",
          name: "Request Id",
          shortName: "Request Id"
        },{
          value: "patientName",
          name: "Customer Name",
          shortName: "Customer"
        },{
          value: "primaryEntityName",
          name: "Corporate Name",
          shortName: "Corporate"
        }];
        scope.pipeline.searchText = {};
        scope.pipeline.reverse = false;
        scope.form = {
          searchType: scope.searchType[0],
          sortValue: 'default',
          status: 'default'
        };
        scope.onSelectChange = function(modal, value){
          if(value == 'default'){
            scope.pipeline[modal] = '';
            scope.pipeline.reverse = false;
          } else{
            scope.pipeline[modal] = value
          }
        };
        scope.onChangeSearch = function(){
          scope.pipeline.searchText = {};
          scope.pipeline.searchText[scope.form.searchType.value] = scope.form.searchText;
          console.log(scope.pipeline.searchText);
        };
      }
    };
  }]);

'use strict';
angular.module('mbplus.navConstantsSvc', [])
.constant('navConstantsSvc', {
    genderTitle: 'Title',
    dateFormate: ['dd-MMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'],
    erIDs: [1000123, 1000135, 1000136, 1000141, 1000144, 1000211, 1000217, 1000257, 1000319, 1000324, 1000389, 1000395, 1000437, 1000442, 1000521, 1000544, 1000615, 1000643, 1000673, 1000698, 1000751, 1000774, 1000801, 1000895, 1000911, 1000936, 1000945, 1000958, 1000976, 1001017, 1001029, 1001049, 1001076, 1001510, 1001732, 1001881, 1002085, 1002307, 1002592, 1002639, 1002800, 1003180, 1003414, 1003470, 1003702, 1003789, 1004071, 1004189, 1004201, 1004248, 1004251, 1004482, 1004620, 1004684, 1004790, 1024201, 1026488],
    mstep: 1,
    hstep: 1,
    admissionType:'',
    newDate: new Date(),
    altInputFormats: ['M!/d!/yyyy'],
    holidayList: ['10/2/2019','10/7/2019','10/8/2019','10/13/2019','10/27/2019','11/1/2019','11/10/2019','11/26/2019','12/25/2019'],
    distances: [{ id: 1, value: 2 },{ id: 2, value: 5 }, { id: 3, value: 10 }],
    adminStatusArray: [4670, 4671, 5113],
    contractId : {esales: 9782},
    actionColors: {
            'Create': 'glyphicon glyphicon-plus',
            'MACancel': 'glyphicon glyphicon-remove-sign',
            'UserCancel': 'glyphicon glyphicon-minus-sign',
            'Confirm': 'glyphicon glyphicon-ok',
            'Reschedule': 'glyphicon glyphicon-calendar',
            'Cancel': 'glyphicon glyphicon-remove',
            'Submit': 'glyphicon glyphicon-paperclip',
            'Attended': 'glyphicon glyphicon-ok',
            'NotAttended': 'glyphicon glyphicon-remove',
            'Raise_IA': 'glyphicon glyphicon-bullhorn',
            'Approve': 'glyphicon glyphicon-ok',
            'notattended': 'glyphicon glyphicon-glyphicon-off',
            'Fit': 'glyphicon glyphicon-thumbs-up',
            'UnFit': 'glyphicon glyphicon-thumbs-down',
            'SwitchDC': 'glyphicon glyphicon-plus',
            'UnApprovedNewAppointment':'glyphicon glyphicon-plus',
            'QCApprove': 'glyphicon glyphicon-ok',
            'Split Request': 'glyphicon glyphicon-scissors',
            'PartiallyAttended': "fa fa-hourglass-half",
            'PlaceWithPartner': 'fa fa-cart-plus',
            'OutForDelivery': 'fa fa-truck',
            'Delivered': 'fa fa-paper-plane',
            'ConfirmByRetailer': 'fa fa-check-square-o'
        },
        statusTextColors: {
            22: 'text-success',
            23: 'text-success',
            24: 'text-success',
            25: 'text-success',
            26: 'text-danger',
            27: 'text-danger',
            28: 'text-danger',
            29: 'text-warning',
            30: 'text-warning',
            31: 'text-warning',
            32: 'text-success',
            33: 'text-warning',
            34: 'text-success',
            35: 'text-danger',
            36: 'text-success',
            37: 'text-success',
            38: 'text-warning',
            39: 'text-danger',
            40: 'text-warning',
            41: 'text-warning',
            42: 'text-warning',
            43: 'text-danger',
            49: 'text-success',
            112: 'text-warning',
            113: 'text-danger',
            116: 'text-warning',
            91: 'text-warning',
            87: 'text-success',
            88: 'text-info',
            89: 'text-success'
        },
    tuesdayText:'Get the MediBuddy+ advantage today by completing your hospital profile.' + '<a class="" style=" margin-left: 5px; " href="#/provider-profile"> Configure Now</a>',
    wednesdayText:'Your profile gives you the power to be discovered, make the most of it.' + '<a class="" style=" margin-left: 5px; " href="#/provider-profile" > Configure Now</a>',
    thursdayText: 'Don\'t Remain an Option for your potential customers, become their choice!' + '<a class="" style=" margin-left: 5px; " href="#/provider-profile" > Configure Now</a>',
    fridayText:'Thrill your customers with all the information they seek.' + '<a class="" style=" margin-left: 5px; " href="#/provider-profile" > Configure Now</a>',
    saturdayText:'Leave no room for doubt, ensure that your customers choose you!' + '<a class="" style=" margin-left: 5px; " href="#/provider-profile" > Configure Now</a>',
    authorizedErrorCheck: 'You are not authorized.'

});

angular.module("mbplus").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/aarogyaForm/aarogyaForm.html","<div class=\"\" id=\"tabclaim-new\" style=\"height:1000px\"><div class=\"panel panel-default\" id=\"new-claim-success\" ng-show=\"form.preauthSuccess\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\"><h4 class=\"chat-status text-center\">Your claim has been created successfully! Details can be viewed from list of active claims.</h4></div></div><div class=\"col-md-2\"></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><button class=\"btn btn-default\" ng-click=\"preauthFormAction.closePreauthForm()\">Back to claims list</button></div><div class=\"col-md-2\"></div></div></div></div><div class=\"panel panel-default\" id=\"new-claim-fail\" ng-show=\"form.preauthError\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\"><h4 class=\"chat-status text-center\">Oops! There seems to be a problem and your claim is not created.</h4><div style=\"margin-left: 50px;\"><p>Possible reasons could be :</p><ol><li>Invalid details entered</li><li>Invalid file formats or more number of files uploaded</li></ol></div><h4 class=\"chat-status text-center\">Please check the details, required files and create it again. Thank you.</h4></div></div><div class=\"col-md-2\"></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><button class=\"btn btn-default\" ng-click=\"preauthFormAction.closePreauthForm()\">Back to claims list</button></div><div class=\"col-md-2\"></div></div></div></div><div class=\"panel panel-default\" id=\"new-claim-form\" ng-show=\"!form.preauthSuccess && !form.preauthError\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-10\"><div id=\"myTabContentInner\" class=\"tab-content\"><div class=\"tab-pane active\" id=\"aarogyaclaims\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"chat-content_wrap\"><h3 class=\"chat-status\" style=\"margin-left: -13px; font-size: x-large;\">Aarogya Form</h3><h5 class=\"chat-status\">Pre-auth initiating <span class=\"chat-user\">by <strong>{{username}}</strong></span></h5><div><div class=\"form-group\" style=\"background-color: #e55e6a; margin-top: -25px;\"><div style=\"font-size: large;\" class=\"bg-info mandatory text-center\">All fields marked with * are mandatory</div></div></div><p class=\"\" ng-show=\"PreAuthForIR\"><label class=\"label label-danger\">Remarks:</label> <label class=\"label label-danger\">{{PreAuthForIRRemarks}}</label></p><div class=\"chat-content\"><form id=\"myFormAarogya\" novalidate=\"\" name=\"signup_form_aarogya\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"familyno\">Family number*</label> <input id=\"aarogyaFamilyNo\" name=\"familyno\" type=\"text\" class=\"form-control\" placeholder=\"Click here to search for family number\" ng-model=\"form.familyno\" ng-click=\"fastrackMethods.fastrackPreauth(\'aarogya\')\" ng-keyup=\"fastrackMethods.fastrackPreauth(\'aarogya\')\" ng-required=\"true\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"PribenefRemainingBsi\">Remaining BSI</label> <input id=\"PribenefRemainingBsi\" name=\"PribenefRemainingBsi\" type=\"number\" class=\"form-control\" placeholder=\"\" ng-model=\"form.PribenefRemainingBsi\" readonly=\"readonly\"></div><div class=\"form-group\" hidden=\"\"><label for=\"aarogyaMaid\">MAID</label></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><input name=\"hospId\" id=\"formHospIdAarogya\" value=\"{{hospId}}\" type=\"hidden\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><input id=\"aarogyaFormCreatedBy\" name=\"createdBy\" value=\"{{user.userId}}\" type=\"hidden\"></div></div><input type=\"hidden\" name=\"packages\" id=\"aaRogyaPackagesHolder\"> <input type=\"hidden\" name=\"packageAmnt\" id=\"aarogyaPackageAmountHolder\"> <input type=\"hidden\" name=\"cappedAmount\" id=\"packageCappedAmountHolder\"> <input type=\"hidden\" name=\"packageIndividualAmount\" id=\"packageIndividualAmount\"> <input type=\"hidden\" name=\"aarogyaPackageName\" id=\"aarogyaPackageName\"> <input type=\"hidden\" name=\"aarogyaClaim\" value=\"new-submit\"> <input type=\"hidden\" name=\"hospName\" id=\"formHospName\"> <input id=\"aarogyaMaid\" name=\"maid\" type=\"hidden\" ng-model=\"form.maidBenef\"></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"patientFirstName\">Full name *</label> <input id=\"aarogyaFullName\" name=\"patientFirstName\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"form.fullname\" required=\"\"><div class=\"error\" ng-show=\"signup_form_aarogya.patientFirstName.$dirty && signup_form_aarogya.patientFirstName.$invalid\"><small class=\"error\" ng-show=\"signup_form_aarogya.patientFirstName.$error.required\">Your name is required.</small></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"contactNum\">Mobile number</label> <input name=\"contactNum\" type=\"number\" class=\"form-control\" placeholder=\"\" ng-model=\"form.mobile\" ng-minlength=\"10\" ng-maxlength=\"10\"><div class=\"error\" ng-show=\"signup_form_aarogya.contactNum.$dirty && signup_form_aarogya.contactNum.$invalid\"><small class=\"error\" ng-show=\"signup_form_aarogya.contactNum.$error.required\">Your mobile number is required.</small> <small class=\"error\" ng-show=\"signup_form_aarogya.contactNum.$error.number\">Your mobile number can contain only numbers</small> <small class=\"error\" ng-show=\"signup_form_aarogya.contactNum.$error.minlength\">Your mobile number is required to be at least 10 characters</small> <small class=\"error\" ng-show=\"signup_form_aarogya.contactNum.$error.maxlength\">Your mobile number cannot be longer than 10 characters</small></div></div></div></div><hr><div class=\"row\"><div class=\"row\"><div class=\"col-md-4 form-group\"><label for=\"reasonOnline\">Reason for online request</label><select ng-init=\"form.reasonOnline=\'chiperror\'\" name=\"reasonOnline\" ng-model=\"form.reasonOnline\" ng-change=\"packageSelection.changePackageField()\" class=\"form-control\"><option value=\"chiperror\" selected=\"\">Procedure</option><option value=\"others\">Non-procedure/Others</option></select></div></div><div class=\"row\"><div class=\"form-group col-md-12\" ng-show=\"showAutoPackages\"><label for=\"govtpackage\">Select procedure</label><typeahead items=\"govtPackageList\" prompt=\"Start typing package name (Enter minimum 3 characters)\" title=\"packageName\" subtitle=\"address\" subtitle2=\"packageCost\" module-flag=\"aarogya\"></typeahead></div><div class=\"col-md-4 form-group\" ng-if=\"false\"><label for=\"amount\">Selected package amount</label> <input name=\"packageAmount\" id=\"aarogyaautoPackageAmt\" class=\"form-control\" type=\"text\" ng-model=\"form.packageAmount\" readonly=\"\"></div></div><div id=\"packageSelection\" class=\"row form-group\"><div class=\"form-group col-md-6\" ng-show=\"!showAutoPackages\"><label for=\"govtpackage\">Enter treatment details</label> <input ng-model=\"form.mPackageName\" type=\"text\" class=\"form-control\" placeholder=\"Enter the package name\"></div><div class=\"col-md-4 form-group\" ng-show=\"!showAutoPackages\"><label for=\"amount\">Enter the amount</label> <input class=\"form-control\" type=\"number\" ng-model=\"form.mPackageAmount\"></div><br><div class=\"col-md-2 form-group pull-right\"><a id=\"packageAddBtn\" class=\"btn btn-success\" ng-click=\"packageSelection.addPackageButtonAarogya()\">Add</a></div></div></div><div class=\"row\" ng-show=\"selectedPackages.length>0\"><table class=\"table table-responsive\"><thead><th>Package name</th><th ng-show=\"false\">Package amount</th><th>Action</th></thead><tbody><tr ng-repeat=\"sel_package in selectedPackages\" ng-show=\"sel_package.id || sel_package.id==0\"><td>{{sel_package.name}}</td><td ng-show=\"false\">{{sel_package.amount}}</td><td><a ng-click=\"packageSelection.removePackageAarogya(sel_package.id)\" class=\"btn btn-danger btn-xs\">Remove</a></td></tr></tbody></table></div><hr><div class=\"row\"><div class=\"col-md-6 form-group\"><div class=\"form-group\"><label for=\"approxClaimedAmnt\">Estimated amount *</label> <input name=\"approxClaimedAmnt\" type=\"number\" class=\"form-control\" ng-model=\"packageCalcAmount\" placeholder=\"Enter Total Claimed Amount\" required=\"\"><div class=\"error\" ng-show=\"signup_form_aarogya.approxClaimedAmnt.$dirty && signup_form_aarogya.approxClaimedAmnt.$invalid\"><small class=\"error\" ng-show=\"signup_form_aarogya.approxClaimedAmnt.$error.required\">Claimed amount is required and can contain only numbers.</small> <small class=\"error\" ng-show=\"signup_form_aarogya.contactNum.$error.number\">Claimed amount can contain only numbers</small></div></div></div><div class=\"col-md-6 form-group\"><label for=\"memberAge\">Member age</label> <input id=\"aarogyaAge\" name=\"memberAge\" class=\"form-control\" type=\"number\" ng-model=\"form.memberAge\" readonly=\"readonly\"></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"doa\">Date of admission *</label> <input name=\"doa\" id=\"datetimepickerAarogya\" class=\"form-control datetimepicker\" type=\"date\" ng-model=\"form.doa\" required=\"\"><div class=\"error\" ng-show=\"signup_form_aarogya.doa.$dirty && signup_form_aarogya.doa.$invalid\"><small class=\"error\" ng-show=\"signup_form_aarogya.doa.$error.required\">Tentative date of admission is required.</small> <small class=\"error\" ng-show=\"signup_form_aarogya.doa.$error.datetimelocal\">Tentative date is invalid.</small></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"dod\">Date of discharge *</label> <input name=\"dod\" id=\"dischargetimepickerAarogya\" class=\"form-control datetimepicker\" type=\"date\" ng-model=\"form.dod\" required=\"\"><div class=\"error\" ng-show=\"signup_form_aarogya.dod.$dirty && signup_form_aarogya.dod.$invalid\"><small class=\"error\" ng-show=\"signup_form_aarogya.dod.$error.required\">Tentative date of discharge is required.</small></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnosis *</label> <textarea name=\"diagnosis\" class=\"form-control\" placeholder=\"Enter diagnosis details\" ng-model=\"form.diagnosis\" required=\"\"></textarea><div class=\"error\" ng-show=\"signup_form_aarogya.diagnosis.$dirty && signup_form_aarogya.diagnosis.$invalid\"><small class=\"error\" ng-show=\"signup_form_aarogya.diagnosis.$error.required\">Diagnosis details are required.</small></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">In patient number</label> <input name=\"inPatientNumber\" type=\"text\" class=\"form-control\" placeholder=\"In patient number\" ng-model=\"form.ipnumber\"><div class=\"error\" ng-show=\"form.ipnumber.$dirty && form.ipnumber.$invalid\"><small class=\"error\" ng-show=\"form.ipnumber.$error.number\">Inpatient number can contain only numbers</small></div></div></div><div class=\"col-md-6\" ng-hide=\"true\"><div class=\"form-group\"><label for=\"procedure\">Procedure *</label> <textarea id=\"aarogyaProcedure\" name=\"procedure\" class=\"form-control\" placeholder=\"Enter procedure details\" ng-model=\"form.procedure\"></textarea><div class=\"error\" ng-show=\"signup_form_aarogya.procedure.$dirty && signup_form_aarogya.procedure.$invalid\"><small class=\"error\" ng-show=\"signup_form_aarogya.procedure.$error.required\">Procedure details are required.</small></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"admissionType\">Admission Type *</label><select name=\"admissionType\" id=\"admissiontype\" class=\"form-control\" ng-model=\"form.admissiontype\" required=\"\"><option value=\"\">Select admission type</option><option value=\"emergency\">Emergency</option><option value=\"planned\">Planned</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"memberGender\">Member Gender</label><select id=\"memberGender\" name=\"memberGender\" ng-model=\"form.memberGender\" class=\"form-control\"><option value=\"\">---Please select---</option><option value=\"male\" ng-selected=\"genderselected\">Male</option><option value=\"female\" ng-selected=\"!genderselected\">Female</option></select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"docName\">Doctor Name *</label> <input name=\"docName\" focus-element=\"onFocus\" type=\"text\" maxlength=\"50000\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Type doctor name\" required=\"\" ng-click=\"getkeywords()\" ng-model=\"form.docname\" uib-typeahead=\"condition.doctorName for condition in doctorDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"><div class=\"error\" ng-show=\"signup_form_aarogya.docName.$dirty && signup_form_aarogya.docName.$invalid\"><small class=\"error\" ng-show=\"signup_form_aarogya.docName.$error.required\">Doctor name is required.</small></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"roomType\">Provided room type *</label> <input name=\"roomType\" focus-element=\"onFocus\" type=\"text\" maxlength=\"50000\" required=\"\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Type provided room type\" ng-click=\"getkeywords()\" ng-model=\"form.roomtype\" uib-typeahead=\"item.hospitalRoomType for item in roomsDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"><div class=\"error\" ng-show=\"signup_form_aarogya.roomType.$dirty && signup_form_aarogya.roomType.$invalid\"><small class=\"error\" ng-show=\"signup_form_aarogya.roomType.$error.required\">Room type has to be mentioned.</small></div></div></div></div><div class=\"row\" ng-if=\"isEBill\"><div class=\"col-md-6\"><div class=\"form-group\" ng-show=\"!form.isgovtscheme\"><label for=\"uidno\">Unique hospital id</label> <input name=\"uidno\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"form.uidno\"></div></div></div><div id=\"fileupload\"><p class=\"bg-danger\">Maximum file upload limit is 15 MB.<br><b>At least one of the documents listed below needs to be submitted.</b></p><br><div class=\"row\"><div class=\"col-md-4\">Initial pre authorization form</div><div class=\"col-md-5\"><input type=\"file\" name=\"preauth\" file-model=\"preAuthFile.myFile1\"></div></div><hr><div class=\"row\"><div class=\"col-md-4\">ID proof</div><div class=\"col-md-5\"><input type=\"file\" name=\"idproof\" file-model=\"preAuthFile.myFile2\"></div></div><hr><div class=\"row\"><div class=\"col-md-4\">Investigations</div><div class=\"col-md-5\" id=\"investigationdocs\"><input type=\"file\" name=\"aarogyaInvestigations\" file-model=\"preAuthFile.myFile3\"></div></div><hr><div class=\"row\"><div class=\"col-md-4\">Others</div><div class=\"col-md-5\" id=\"aarogyaOtherdocs\"><input type=\"file\" name=\"aarogyaOtherfiles\" file-model=\"preAuthFile.myFile4\"></div></div><hr><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></fieldset><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button></div><hr><button type=\"submit\" class=\"btn btn-primary start\" ng-disabled=\"signup_form_aarogya.$invalid && !PreAuthForIR && !form.isgovtscheme\" id=\"newAdmissionButtonAarogya\" ng-click=\"preauthFormAction.submitPreauthForm()\"><span>Submit new admission aarogya</span></button></div></form></div></div></div></div></div></div></div><div class=\"col-md-2\"></div></div></div></div><div class=\"modal fade\" id=\"myModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><h4>{{fastrack.title}}</h4></div><div class=\"modal-body\"><div class=\"center-block\"><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioMaid\" ng-change=\"clearfastrack()\">MAID</label></div><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioEmp\" ng-change=\"clearfastrack()\">{{fastrack.employerSearchTitle}}</label></div><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioPolicy\" ng-change=\"clearfastrack()\">Policy No</label></div></div><form name=\"formMaid\" ng-show=\"radioFastTrack==\'radioMaid\'?true:false\"><div class=\"row form-group\" ng-show=\"radioFastTrack==\'radioMaid\'?true:false\"><div class=\"col-md-6\"><input ng-model=\"fastrack.maid\" name=\"maid\" class=\"form-control\" type=\"text\" placeholder=\"MAID\" ng-required=\"true\"></div><div class=\"col-md-6\"><input name=\"benefName\" ng-model=\"fastrack.benefName\" class=\"form-control\" type=\"text\" placeholder=\"BenefName\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getDetailsWithMaid(fastrack.maid,fastrack.benefName) : \'\'\"></div></div><div class=\"row form-group\"><div class=\"col-md-6\"><button ng-show=\"fastrack.displaySubmit\" ng-disabled=\"(!formMaid.maid.$dirty || formMaid.maid.$invalid)||(!formMaid.benefName.$dirty || formMaid.benefName.$invalid)\" ng-click=\"fastrackMethods.getDetailsWithMaid(fastrack.maid,fastrack.benefName)\" type=\"button\" class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-search\"></i> Search</button></div><div class=\"col-md-6\"></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><div class=\"form-group\" ng-show=\"!fastrack.displaySubmit\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"relation in fastrack.relations\"><td>{{relation.benefName}}</td><td>{{relation.benefRelation}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackMethods.fastrackPopulateNewAdmission(relation.benefMediAssistID,relation.benefRelToPriID,relation.benefName,relation)\">Select</button></td></tr></tbody></table></div></div></form><form name=\"formEmp\" ng-show=\"radioFastTrack==\'radioEmp\'?true:false\"><div class=\"row form-group\" ng-show=\"radioFastTrack==\'radioEmp\'?true:false\"><div class=\"col-md-4\"><input ng-model=\"fastrack.employeeId\" name=\"empid\" class=\"form-control\" type=\"text\" placeholder=\"Employee/Family No.\" ng-required=\"true\"></div><div class=\"col-md-4\" ng-show=\"fastrack.showCorpName\"><input ng-model=\"fastrack.corporateName\" name=\"compname\" class=\"form-control\" type=\"text\" placeholder=\"Company Name\" ng-required=\"true\"></div><div class=\"col-md-4\"><input ng-model=\"fastrack.BeneficiaryName\" name=\"benefname\" class=\"form-control\" type=\"text\" placeholder=\"BenefName\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getDetailsWithEmpId(fastrack.employeeId,fastrack.corporateName,fastrack.BeneficiaryName): \'\'\"></div></div><div class=\"row form-group\"><div class=\"col-md-6\"><button ng-show=\"fastrack.displaySubmit\" ng-disabled=\"formEmp.$invalid\" ng-click=\"fastrackMethods.getDetailsWithEmpId(fastrack.employeeId,fastrack.corporateName,fastrack.BeneficiaryName)\" type=\"button\" class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-search\"></i> Search</button></div><div class=\"col-md-6\"></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><div class=\"form-group\" ng-show=\"!fastrack.displaySubmit\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"relation in fastrack.relations\"><td>{{relation.benefName}}</td><td>{{relation.benefRelation}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackMethods.fastrackPopulateNewAdmission(relation.benefMediAssistID,relation.benefRelToPriID,relation.benefName,relation)\">Select</button></td></tr></tbody></table></div></div></form><form name=\"formPolicy\" ng-show=\"radioFastTrack==\'radioPolicy\'?true:false\"><div class=\"row form-group\" ng-show=\"radioFastTrack==\'radioPolicy\'?true:false\"><div class=\"col-md-6\"><input ng-model=\"fastrack.PolicyNo\" class=\"form-control\" type=\"text\" placeholder=\"Policy No.\" ng-required=\"true\"></div><div class=\"col-md-6\"><input ng-model=\"fastrack.BeneficiaryName\" class=\"form-control\" type=\"text\" placeholder=\"BenefName\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getDetailsWithPolicy(fastrack.PolicyNo,fastrack.BeneficiaryName): \'\'\"></div></div><div class=\"row form-group\"><div class=\"col-md-6\"><button ng-click=\"fastrackMethods.getDetailsWithPolicy(fastrack.PolicyNo,fastrack.BeneficiaryName)\" ng-show=\"fastrack.displaySubmit\" ng-disabled=\"formPolicy.$invalid\" type=\"button\" class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-search\"></i> Search</button></div><div class=\"col-md-6\"></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><div class=\"form-group\" ng-show=\"!fastrack.displaySubmit\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"relation in fastrack.relations\"><td>{{relation.benefName}}</td><td>{{relation.benefRelation}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackMethods.fastrackPopulateNewAdmission(relation.benefMediAssistID,relation.benefRelToPriID,relation.benefName,relation)\">Select</button></td></tr></tbody></table></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn\" ng-click=\"fastrackMethods.clearfastrack()\" ng-show=\"radioFastTrack==\'radioMaid\'?true:false ||radioFastTrack==\'radioEmp\'?true:false||radioFastTrack==\'radioPolicy\'?true:false\"><i class=\"glyphicon glyphicon-trash\"></i> Clear</button> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"fastrackMethods.removeModal()\"><i class=\"glyphicon glyphicon-remove\"></i> Close</button></div></div></div></div></div>");
$templateCache.put("app/components/aarogyaForm_new/aarogyaForm.html","<div class=\"\" id=\"tabclaim-new\" style=\"height:1000px\"><div class=\"panel panel-default\" id=\"new-claim-success\" ng-show=\"form.preauthSuccess\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-8\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\"><h4 class=\"chat-status text-center\">Your claim has been created successfully! Details can be viewed from list of active claims.</h4></div></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><button class=\"btn btn-default\" ng-click=\"closePreauthForm()\">Back to claims list</button></div><div class=\"col-md-2\"></div></div></div></div><div class=\"panel panel-default\" id=\"new-claim-fail\" ng-show=\"form.preauthError\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\"><h4 class=\"chat-status text-center\">Oops! There seems to be a problem and your claim is not created.</h4><div style=\"margin-left: 50px;\"><p>Possible reasons could be :</p><ol><li>Invalid details entered</li><li>Invalid file formats or more number of files uploaded</li></ol></div><h4 class=\"chat-status text-center\">Please check the details, required files and create it again. Thank you.</h4></div></div><div class=\"col-md-2\"></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><button class=\"btn btn-default\" ng-click=\"closePreauthForm()\">Back to claims list</button></div><div class=\"col-md-2\"></div></div></div></div><div class=\"panel panel-default\" id=\"new-claim-form\" ng-show=\"!form.preauthSuccess && !form.preauthError\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-12\"><div id=\"myTabContentInner\" class=\"tab-content\"><div class=\"tab-pane active\" id=\"aarogyaclaims\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"chat-content_wrap\"><div><div class=\"form-group\" style=\"background-color: #e55e6a; margin-top: -50px;\"><div style=\"font-size: large;\" class=\"bg-info mandatory text-center\">All fields marked with * are mandatory</div></div></div><p class=\"\" ng-show=\"PreAuthForIR\"><label class=\"label label-danger\">Remarks:</label> <label class=\"label label-danger\">{{PreAuthForIRRemarks}}</label></p><div class=\"chat-content\"><form id=\"myFormAarogya\" novalidate=\"\" name=\"signup_form_aarogya\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"familyno\">Family Number*</label> <input id=\"aarogyaFamilyNo\" name=\"familyno\" type=\"text\" class=\"form-control\" placeholder=\"Click here to search for family number\" ng-model=\"form.familyno\" ng-click=\"fastrackPreauth(\'aarogya\')\" ng-keyup=\"fastrackPreauth(\'aarogya\')\" ng-required=\"true\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"patientFirstName\">Full Name *</label> <input id=\"aarogyaFullName\" text-only=\"\" name=\"patientFirstName\" type=\"text\" class=\"form-control\" placeholder=\"Enter full name\" ng-model=\"form.fullname\" required=\"\"><div class=\"error\" ng-show=\"signup_form_aarogya.patientFirstName.$dirty && signup_form_aarogya.patientFirstName.$invalid\"><small class=\"error\" ng-show=\"signup_form_aarogya.patientFirstName.$error.required\">Your name is required.</small></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"contactNum\">Mobile Number</label> <input name=\"contactNum\" type=\"text\" numbers-only=\"\" class=\"form-control\" placeholder=\"Enter mobile number\" ng-model=\"form.mobile\" ng-minlength=\"10\" ng-maxlength=\"10\"><div class=\"error\" ng-show=\"signup_form_aarogya.contactNum.$dirty && signup_form_aarogya.contactNum.$invalid\"><small class=\"error\" style=\"color: red;\" ng-show=\"signup_form_aarogya.contactNum.$error.required\">Your mobile number is required.</small> <small class=\"error\" style=\"color: red;\" ng-show=\"signup_form_aarogya.contactNum.$error.number\">Your mobile number can contain only numbers</small> <small class=\"error\" style=\"color: red;\" ng-show=\"signup_form_aarogya.contactNum.$error.minlength\">Your mobile number is required to be at least 10 characters</small> <small class=\"error\" style=\"color: red;\" ng-show=\"signup_form_aarogya.contactNum.$error.maxlength\">Your mobile number cannot be longer than 10 characters</small></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"PribenefRemainingBsi\">Remaining BSI</label> <input id=\"PribenefRemainingBsi\" name=\"PribenefRemainingBsi\" type=\"number\" class=\"form-control\" placeholder=\"Remaining BSI\" ng-model=\"form.PribenefRemainingBsi\" readonly=\"readonly\"></div><div class=\"form-group\" hidden=\"\"><label for=\"aarogyaMaid\">MAID</label></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><input name=\"hospId\" id=\"formHospIdAarogya\" value=\"{{hospId}}\" type=\"hidden\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><input id=\"aarogyaFormCreatedBy\" name=\"createdBy\" value=\"{{user.userId}}\" type=\"hidden\"></div></div><input type=\"hidden\" name=\"packages\" id=\"aaRogyaPackagesHolder\"> <input type=\"hidden\" name=\"packageAmnt\" id=\"aarogyaPackageAmountHolder\"> <input type=\"hidden\" name=\"cappedAmount\" id=\"packageCappedAmountHolder\"> <input type=\"hidden\" name=\"packageIndividualAmount\" id=\"packageIndividualAmount\"> <input type=\"hidden\" name=\"aarogyaPackageName\" id=\"aarogyaPackageName\"> <input type=\"hidden\" name=\"aarogyaClaim\" value=\"new-submit\"> <input type=\"hidden\" name=\"hospName\" id=\"formHospName\"> <input id=\"aarogyaMaid\" name=\"maid\" type=\"hidden\" ng-model=\"form.maidBenef\"></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"reasonOnline\">Reason For Online Request</label><select ng-init=\"form.reasonOnline=\'chiperror\'\" name=\"reasonOnline\" ng-model=\"form.reasonOnline\" ng-change=\"changePackageField()\" class=\"form-control\"><option value=\"chiperror\" selected=\"\">Procedure</option><option value=\"others\">Non-Procedure/Others</option></select></div><div class=\"col-md-4\" ng-if=\"!showAutoPackages\"><label for=\"govtpackage\">Enter Treatment Details</label> <input ng-model=\"form.mPackageName\" text-only=\"\" type=\"text\" class=\"form-control\" placeholder=\"Enter the package name\"></div><div class=\"col-md-2\" ng-if=\"!showAutoPackages\"><label for=\"amount\">Enter The Amount</label> <input class=\"form-control\" type=\"text\" numbers-only=\"\" placeholder=\"Enter amount\" ng-model=\"form.mPackageAmount\"></div><div class=\"col-md-6\" ng-if=\"showAutoPackages\"><label for=\"govtpackage\">Select Procedure</label> <input name=\"docName\" focus-element=\"onFocus\" type=\"text\" maxlength=\"50\" text-only=\"\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Enter procedure name\" required=\"\" autocomplete=\"off\" ng-click=\"getkeywords()\" ng-model=\"form.packageName\" uib-typeahead=\"package.packageName for package in govtPackageList | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"></div><div class=\"col-md-2\" ng-if=\"showAutoPackages\" style=\"margin-top: 21px;\"><button id=\"packageAddBtn\" class=\"btn btn-primary\" ng-disabled=\"!form.packageName\" ng-click=\"addPackageButtonAarogya()\">Add</button></div><div class=\"col-md-2\" ng-if=\"!showAutoPackages\" style=\"margin-top: 21px;\"><button id=\"packageAddBtn\" class=\"btn btn-primary\" ng-disabled=\"!form.mPackageAmount || !form.mPackageName\" ng-click=\"addPackageButtonAarogya()\">Add</button></div></div><div class=\"row\" ng-show=\"selectedPackages.length>0\"><div class=\"col-md-8\" style=\"margin-left: 100px; margin-top: 10px; margin-bottom:10px;\"><table class=\"table table-responsive\"><thead><th>Package Name</th><th>Package Amount</th><th>Action</th></thead><tbody><tr ng-repeat=\"sel_package in selectedPackages\" ng-show=\"sel_package.id || sel_package.id==0\"><td>{{sel_package.name}}</td><td>{{sel_package.amount}}</td><td><a ng-click=\"removePackageAarogya(sel_package.id)\" class=\"btn btn-danger btn-xs\">Remove</a></td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-md-3 form-group\"><div class=\"form-group\"><label for=\"approxClaimedAmnt\">Estimated Amount *</label> <input name=\"approxClaimedAmnt\" type=\"text\" numbers-only=\"\" class=\"form-control\" ng-model=\"packageCalcAmount\" placeholder=\"Enter Total Claimed Amount\" required=\"\"><div class=\"error\" ng-show=\"signup_form_aarogya.approxClaimedAmnt.$dirty && signup_form_aarogya.approxClaimedAmnt.$invalid\"><small class=\"error\" style=\"color: red;\" ng-show=\"signup_form_aarogya.approxClaimedAmnt.$error.required\">Claimed amount is required and can contain only numbers.</small> <small class=\"error\" style=\"color: red;\" ng-show=\"signup_form_aarogya.contactNum.$error.number\">Claimed amount can contain only numbers</small></div></div></div><div class=\"col-md-3 form-group\"><label for=\"memberAge\">Member Age</label> <input id=\"aarogyaAge\" placeholder=\"Member age\" name=\"memberAge\" class=\"form-control\" type=\"number\" ng-model=\"form.memberAge\" readonly=\"readonly\"></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"doa\">DOA *</label> <input name=\"doa\" id=\"datetimepickerAarogya\" class=\"form-control datetimepicker\" type=\"date\" ng-model=\"form.doa\" required=\"\"><div class=\"error\" ng-show=\"signup_form_aarogya.doa.$dirty && signup_form_aarogya.doa.$invalid\"><small class=\"error\" style=\"color: red;\" ng-show=\"signup_form_aarogya.doa.$error.required\">Tentative date of admission is required.</small> <small class=\"error\" style=\"color: red;\" ng-show=\"signup_form_aarogya.doa.$error.datetimelocal\">Tentative date is invalid.</small></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"dod\">DOD *</label> <input name=\"dod\" id=\"dischargetimepickerAarogya\" class=\"form-control datetimepicker\" type=\"date\" ng-model=\"form.dod\" required=\"\"><div class=\"error\" ng-show=\"signup_form_aarogya.dod.$dirty && signup_form_aarogya.dod.$invalid\"><small class=\"error\" style=\"color: red;\" ng-show=\"signup_form_aarogya.dod.$error.required\">Tentative date of discharge is required.</small></div></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnosis *</label> <textarea name=\"diagnosis\" class=\"form-control\" placeholder=\"Enter diagnosis details\" ng-model=\"form.diagnosis\" required=\"\"></textarea><div class=\"error\" ng-show=\"signup_form_aarogya.diagnosis.$dirty && signup_form_aarogya.diagnosis.$invalid\"><small class=\"error\" style=\"color: red;\" ng-show=\"signup_form_aarogya.diagnosis.$error.required\">Diagnosis details are required.</small></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">In Patient Number</label> <input name=\"inPatientNumber\" type=\"text\" class=\"form-control\" placeholder=\"In patient number\" ng-model=\"form.ipnumber\"><div class=\"error\" ng-show=\"form.ipnumber.$dirty && form.ipnumber.$invalid\"><small class=\"error\" style=\"color: red;\" ng-show=\"form.ipnumber.$error.number\">Inpatient number can contain only numbers</small></div></div></div><div class=\"col-md-6\" ng-hide=\"true\"><div class=\"form-group\"><label for=\"procedure\">Procedure *</label> <textarea id=\"aarogyaProcedure\" name=\"procedure\" class=\"form-control\" placeholder=\"Enter procedure details\" ng-model=\"form.procedure\"></textarea><div class=\"error\" ng-show=\"signup_form_aarogya.procedure.$dirty && signup_form_aarogya.procedure.$invalid\"><small class=\"error\" style=\"color: red;\" ng-show=\"signup_form_aarogya.procedure.$error.required\">Procedure details are required.</small></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"admissionType\">Admission Type *</label><select name=\"admissionType\" id=\"admissiontype\" class=\"form-control\" ng-model=\"form.admissiontype\" required=\"\"><option value=\"\">Select admission type</option><option value=\"emergency\">Emergency</option><option value=\"planned\">Planned</option></select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"memberGender\">Member Gender</label><select id=\"memberGender\" name=\"memberGender\" ng-model=\"form.memberGender\" class=\"form-control\"><option value=\"\">---Please select---</option><option value=\"male\" ng-selected=\"genderselected\">Male</option><option value=\"female\" ng-selected=\"!genderselected\">Female</option></select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"docName\">Doctor Name *</label> <input name=\"docName\" focus-element=\"onFocus\" type=\"text\" maxlength=\"500000\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Type doctor name\" autocomplete=\"off\" required=\"\" ng-click=\"getkeywords()\" ng-model=\"form.docname\" text-only=\"\" uib-typeahead=\"condition.doctorName for condition in doctorDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"><div class=\"error\" ng-show=\"signup_form_aarogya.docName.$dirty && signup_form_aarogya.docName.$invalid\"><small class=\"error\" style=\"color: red;\" ng-show=\"signup_form_aarogya.docName.$error.required\">Doctor name is required.</small></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"roomType\">Provided Room Type *</label> <input name=\"roomType\" focus-element=\"onFocus\" type=\"text\" maxlength=\"500000\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Type provided room type\" autocomplete=\"off\" required=\"\" ng-click=\"getkeywords()\" ng-model=\"form.roomtype\" text-only=\"\" uib-typeahead=\"item.hospitalRoomType for item in roomsDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"><div class=\"error\" ng-show=\"signup_form_aarogya.roomType.$dirty && signup_form_aarogya.roomType.$invalid\"><small class=\"error\" style=\"color: red;\" ng-show=\"signup_form_aarogya.roomType.$error.required\">Room type has to be mentioned.</small></div></div></div></div><div class=\"row\" ng-if=\"isEBill\"><div class=\"col-md-6\"><div class=\"form-group\" ng-show=\"!form.isgovtscheme\"><label for=\"uidno\">Unique Hospital Id</label> <input name=\"uidno\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"form.uidno\"></div></div></div><div id=\"fileupload\"><p class=\"bg-danger\">Maximum file upload limit is 15 MB.<br><b>At least one of the documents listed below needs to be submitted.</b></p><br><div class=\"row\"><div class=\"col-md-4\">Initial pre authorization form</div><div class=\"col-md-5\"><input type=\"file\" name=\"preauth\" file-model=\"preAuthFile.myFile1\"></div></div><hr><div class=\"row\"><div class=\"col-md-4\">ID Proof</div><div class=\"col-md-5\"><input type=\"file\" name=\"idproof\" file-model=\"preAuthFile.myFile2\"></div></div><hr><div class=\"row\"><div class=\"col-md-4\">Investigations</div><div class=\"col-md-5\" id=\"investigationdocs\"><input type=\"file\" name=\"aarogyaInvestigations\" file-model=\"preAuthFile.myFile3\"></div></div><hr><div class=\"row\"><div class=\"col-md-4\">Others</div><div class=\"col-md-5\" id=\"aarogyaOtherdocs\"><input type=\"file\" name=\"aarogyaOtherfiles\" file-model=\"preAuthFile.myFile4\"></div></div><hr><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></fieldset><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button></div><hr><button type=\"submit\" class=\"btn btn-primary pull-right start\" ng-disabled=\"signup_form_aarogya.$invalid && !PreAuthForIR && !form.isgovtscheme\" id=\"newAdmissionButtonAarogya\" ng-click=\"submitPreauthForm()\"><span>Submit new admission aarogya **</span></button></div></form></div></div></div></div></div></div></div><div class=\"col-md-2\"></div></div></div></div><div class=\"modal fade\" id=\"myModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><h4>{{fastrack.title}}</h4></div><div class=\"modal-body\"><div class=\"center-block\"><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioMaid\" ng-change=\"clearfastrack()\">MAID</label></div><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioEmp\" ng-change=\"clearfastrack()\">{{fastrack.employerSearchTitle}}</label></div><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioPolicy\" ng-change=\"clearfastrack()\">Policy No</label></div></div><form name=\"formMaid\" ng-show=\"radioFastTrack==\'radioMaid\'?true:false\"><div class=\"row form-group\" ng-show=\"radioFastTrack==\'radioMaid\'?true:false\"><div class=\"col-md-6\"><input ng-model=\"fastrack.maid\" name=\"maid\" class=\"form-control\" type=\"text\" placeholder=\"MAID\" ng-required=\"true\"></div><div class=\"col-md-6\"><input name=\"benefName\" ng-model=\"fastrack.benefName\" class=\"form-control\" type=\"text\" placeholder=\"BenefName\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getDetailsWithMaid(fastrack.maid,fastrack.benefName) : \'\'\"></div></div><div class=\"row form-group\"><div class=\"col-md-6\"><button ng-show=\"fastrack.displaySubmit\" ng-disabled=\"(!formMaid.maid.$dirty || formMaid.maid.$invalid)||(!formMaid.benefName.$dirty || formMaid.benefName.$invalid)\" ng-click=\"getDetailsWithMaid(fastrack.maid,fastrack.benefName)\" type=\"button\" class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-search\"></i> Search</button></div><div class=\"col-md-6\"></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><div class=\"form-group\" ng-show=\"!fastrack.displaySubmit\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"relation in fastrack.relations\"><td>{{relation.name}}</td><td>{{relation.relationName}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackPopulateNewAdmission(fastrack.empMaid,relation.relationId,relation.name, relation)\">Select</button></td></tr></tbody></table></div></div></form><form name=\"formEmp\" ng-show=\"radioFastTrack==\'radioEmp\'?true:false\"><div class=\"row form-group\" ng-show=\"radioFastTrack==\'radioEmp\'?true:false\"><div class=\"col-md-4\"><input ng-model=\"fastrack.employeeId\" name=\"empid\" class=\"form-control\" type=\"text\" placeholder=\"Employee/Family No.\" ng-required=\"true\"></div><div class=\"col-md-4\" ng-show=\"fastrack.showCorpName\"><input ng-model=\"fastrack.corporateName\" name=\"compname\" class=\"form-control\" type=\"text\" placeholder=\"Company Name\" ng-required=\"true\"></div><div class=\"col-md-4\"><input ng-model=\"fastrack.BeneficiaryName\" name=\"benefname\" class=\"form-control\" type=\"text\" placeholder=\"BenefName\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getDetailsWithEmpId(fastrack.employeeId,fastrack.corporateName,fastrack.BeneficiaryName): \'\'\"></div></div><div class=\"row form-group\"><div class=\"col-md-6\"><button ng-show=\"fastrack.displaySubmit\" ng-disabled=\"formEmp.$invalid\" ng-click=\"getDetailsWithEmpId(fastrack.employeeId,fastrack.corporateName,fastrack.BeneficiaryName)\" type=\"button\" class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-search\"></i> Search</button></div><div class=\"col-md-6\"></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><div class=\"form-group\" ng-show=\"!fastrack.displaySubmit\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"relation in fastrack.relations\"><td>{{relation.name}}</td><td>{{relation.relationName}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackPopulateNewAdmission(fastrack.empMaid,relation.relationId,relation.name, relation)\">Select</button></td></tr></tbody></table></div></div></form><form name=\"formPolicy\" ng-show=\"radioFastTrack==\'radioPolicy\'?true:false\"><div class=\"row form-group\" ng-show=\"radioFastTrack==\'radioPolicy\'?true:false\"><div class=\"col-md-6\"><input ng-model=\"fastrack.PolicyNo\" class=\"form-control\" type=\"text\" placeholder=\"Policy No.\" ng-required=\"true\"></div><div class=\"col-md-6\"><input ng-model=\"fastrack.BeneficiaryName\" class=\"form-control\" type=\"text\" placeholder=\"BenefName\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getDetailsWithPolicy(fastrack.PolicyNo,fastrack.BeneficiaryName): \'\'\"></div></div><div class=\"row form-group\"><div class=\"col-md-6\"><button ng-click=\"getDetailsWithPolicy(fastrack.PolicyNo,fastrack.BeneficiaryName)\" ng-show=\"fastrack.displaySubmit\" ng-disabled=\"formPolicy.$invalid\" type=\"button\" class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-search\"></i> Search</button></div><div class=\"col-md-6\"></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><div class=\"form-group\" ng-show=\"!fastrack.displaySubmit\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"relation in fastrack.relations\"><td>{{relation.name}}</td><td>{{relation.relationName}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackPopulateNewAdmission(fastrack.empMaid,relation.relationId,relation.name,relation)\">Select</button></td></tr></tbody></table></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn\" ng-click=\"clearfastrack()\" ng-show=\"radioFastTrack==\'radioMaid\'?true:false ||radioFastTrack==\'radioEmp\'?true:false||radioFastTrack==\'radioPolicy\'?true:false\"><i class=\"glyphicon glyphicon-trash\"></i> Clear</button> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"removeModal()\"><i class=\"glyphicon glyphicon-remove\"></i> Close</button></div></div></div></div></div>");
$templateCache.put("app/components/appointmentCreation/apptCreationMap.html","<style>\n    .angular-google-map,\n    .angular-google-map-container {\n        width: 96%;\n        /*height: 35%;*/\n        height: 620px;\n    }\n</style><div class=\"\" ng-if=\"showMap\"><ui-gmap-google-map center=\"map.center\" control=\"\" zoom=\"map.zoom\" bounds=\"map.bounds\" draggable=\"true\" options=\"map.options\"><ui-gmap-marker ng-repeat=\"marker in markerArray\" click=\"showMarkerInfo1(marker, $event)\" models=\"randomMarkers\" coords=\"marker.coords\" idkey=\"marker.id\"><ui-gmap-window options=\"windowOptions[marker.id]\" class=\"abc\" closeclick=\"closeClick(marker.id, $event)\"><div><h5>{{marker.name}}</h5><a ng-click=\"\" data-target=\"#BookAppointmentBlock\" data-toggle=\"modal\" ng-show=\"{{marker.showBookingBtn}}\">Book My appointment at {{marker.name}}</a></div></ui-gmap-window></ui-gmap-marker></ui-gmap-google-map></div><div class=\"modal fade table table-bordered\" id=\"BookAppointmentBlock\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog modal-dialog-custom modal-lg\" role=\"document\"><form name=\"formotherappointments\" novalidate=\"\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"text-center\">Book appointment</h4></div><div class=\"modal-body\"><div class=\"form-create card\"><div class=\"form-signin\"><strong>Preferred date and time</strong><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Date & time - first Preference *</label><p class=\"input-group\"><input placeholder=\"Date & Time - First Preference\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.firstPrefTime\" is-open=\"popup1.opened\" datepicker-options=\"{\'formatYear\': \'yy\', \'maxDate\': dateOptions.maxDate, \'minDate\': dateOptions.minDate}\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\" style=\"margin-top: -15px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-6\" style=\"margin-top: -12px;\"><div uib-timepicker=\"\" ng-model=\"userTime.firstAppointmentTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Date & time - second preference *</label><p class=\"input-group\"><input placeholder=\"Date & Time - Second Preference\" id=\"datetimeSecond\" type=\"text\" readonly=\"\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.secondPrefTime\" is-open=\"popup2.opened\" datepicker-options=\"{\'formatYear\': \'yy\', \'maxDate\': dateOptions.maxDate, \'minDate\': dateOptions.minDate}\" required=\"\" show-button-bar=\"false\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\" style=\"margin-top: -15px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-6\" style=\"margin-top: -12px;\"><div uib-timepicker=\"\" ng-model=\"userTime.secondAppointmentTime\" max=\"maxSecond\" min=\"minSecond\" ng-change=\"changedSecond()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div></div></div></div><div class=\"modal-footer\"><button ng-disabled=\"formotherappointments.$invalid\" class=\"btn btn-block btn-primary\" ng-click=\"controllerFunction1(client.firstPrefTime,userTime.firstAppointmentTime,client.secondPrefTime,userTime.secondAppointmentTime); form.$setPristine()\">Add to Cart</button></div></div></form></div></div>");
$templateCache.put("app/components/apptEssentials/apptEssentials.html","<div class=\"btn-group pull-right\" role=\"group\" aria-label=\"...\"><button class=\"btn\" ng-show=\"isPharma\" style=\"margin-right: 4px;\" ng-click=\"getWalletBalance()\" ng-disabled=\"isDisabled\" uib-tooltip=\"wallet balance\"><i class=\"fa fa-credit-card\"></i></button> <span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><communication-history-modal ng-if=\"!checkIfDc()\" requestflowid=\"patientEssentials.id\" isflowreqid=\"\'reqId\'\"><button uib-tooltip=\"communication history\" class=\"btn\"><i class=\"fa fa-comments\"></i></button></communication-history-modal><button class=\"btn\" uib-tooltip=\"activate DND\" ng-if=\"isFlag.dnd && !checkIfDc()\" ng-click=\"dnd(\'open\',\'DND\')\"><i class=\"fa fa-bell-slash\"></i></button> <button class=\"btn\" uib-tooltip=\"deactivate DND\" ng-if=\"!isFlag.dnd && !checkIfDc()\" ng-click=\"dnd(\'reOpen\',\'DND\')\"><i class=\"fa fa-bell\"></i></button> <button class=\"btn\" uib-tooltip=\"mark DND for customer\" ng-if=\"isFlag.DNDCustomer && !checkIfDc()\" ng-click=\"dndCustomer(\'open\',\'Customer\')\"><i class=\"fa fa-bell-slash\"></i></button> <button class=\"btn\" uib-tooltip=\"unmark DND for customer\" ng-if=\"!isFlag.DNDCustomer && !checkIfDc()\" ng-click=\"dndCustomer(\'reOpen\',\'Customer\')\"><i class=\"fa fa-bell\"></i></button> <button class=\"btn\" ng-show=\"!checkIfDc()\" uib-tooltip=\"action\" id=\"actions\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i> <span class=\"caret\"></span></button><ul style=\"background-color: #eeeeee;\" class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu=\"\" aria-labelledby=\"actions\"><li data-toggle=\"modal\" ng-if=\"patientEssentials.nextPosibleActions.length\" ng-repeat=\"actions in patientEssentials.nextPosibleActions\" data-productid=\"res.additionalInformation.orderItemProductId\" data-target=\"#{{actions.action}}Modal\" data-nextstatus=\"actions.actionStatusId\" data-status=\"actions.statusHistory[0].statusId\" data-request=\"resId\" data-date=\"actions.additionalInformation.appointmentDate\" data-seconddate=\"actions.additionalInformation.secondAppointmentDate\" ng-click=\"openActionModal(actions.action,currentStatusId,actions.actionStatusId,patientEssentials.id,apptDetails.appointmentDate, \'null\',apptDetails.orderItemProductId)\"><a><i class=\"{{actionColors[actions.action]}} {{statusTextColors[actions.actionStatusId]}}\"></i> {{actions.action}} Appointment</a></li><li ng-show=\"!checkIfDc()\"><a><i class=\"glyphicon glyphicon-inbox text-success\"></i><resend-email-modal reqid=\"patientEssentials.id\" isdc=\"dcLogin\">Resend email</resend-email-modal></a></li><li data-toggle=\"modal\" ng-show=\"showSplitRequest && !checkIfDc()\" data-target=\"#SplitRequestModal\" data-product=\"resData.requestHistory.additionalInformation.orderItemProductId\" data-request=\"id\" class=\"splitRequest link\" ng-click=\"openSplitRequestMethod(patientEssentials.productId,patientEssentials.id,visitTypeData.providerId,apptDetails.providerName,apptDetails.appointmentDate,visitTypeData.visitType)\"><a><i class=\"glyphicon glyphicon-scissors text-primary\"></i> Split request</a></li><li ng-show=\"showReportsOption && !checkIfDc()\" class=\"hasDirective\"><a><report-modal reqid=\"patientEssentials.id\" roles=\"insurerLogin\"><i class=\"fa fa-newspaper-o\"></i> Reports</report-modal></a></li><li ng-show=\"digitalMEROption && !checkIfDc()\" class=\"hasDirective\"><a><digital-mer reqid=\"{{patientEssentials.id}}\" roles=\"{{insurerLogin}}\"><i class=\"fa fa-newspaper-o\"></i> Digital MER</digital-mer></a></li><li data-toggle=\"modal\" data-target=\"#grievanceModal\" data-request=\"id\" ng-show=\"!checkIfDc()\" ng-click=\"clearGrievanceModal()\"><a><i class=\"fa fa-gavel text-danger\"></i> Grievance report</a></li></ul><button class=\"btn btn-xs btn-secondary\" style=\"margin-right: 5px;\" ng-if=\"checkIfDc()\" ng-repeat=\"actions in patientEssentials.nextPosibleActions\" ng-click=\"openActionModal(actions.action,currentStatusId,actions.actionStatusId,patientEssentials.id,apptDetails.appointmentDate, \'null\',apptDetails.orderItemProductId)\"><i class=\"{{actionColors[actions.action]}} {{statusTextColors[actions.actionStatusId]}}\"></i> {{actions.action}} Appointment</button></span> <span uib-dropdown=\"\" style=\"margin-right: 10px;\" on-toggle=\"toggled(open)\" uib-tooltip=\"priority\" ng-if=\"isPriority\"><button class=\"btn\" id=\"priority\" uib-dropdown-toggle=\"\"><i class=\"fa fa-rocket\"></i> <span uib-tooltip=\"HNI\" ng-if=\"patientEssentials.priorityId===2\"></span> <span uib-tooltip=\"Urgent\" ng-if=\"patientEssentials.priorityId===1\"></span> <span uib-tooltip=\"Priority\" ng-if=\"patientEssentials.priorityId===0\"></span> <span class=\"caret\"></span></button><ul style=\"background-color: #eeeeee; left: -141px; padding-left: 12px; width: 250px; padding-right: 14px;\" class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu=\"\" aria-labelledby=\"priority\"><li class=\"checkbox\"><label><input type=\"radio\" value=\"2\" name=\"priorityLevel\" ng-model=\"priorityId\" ng-value=\"2\" ng-checked=\"patientEssentials.priorityId == 2\">High net-worth individual</label></li><li class=\"checkbox\"><label><input type=\"radio\" value=\"1\" name=\"priorityLevel\" ng-model=\"priorityId\" ng-value=\"1\" ng-checked=\"patientEssentials.priorityId == 1\">Urgent</label></li><li class=\"checkbox\"><label><input type=\"radio\" value=\"0\" name=\"priorityLevel\" ng-model=\"priorityId\" ng-value=\"0\" ng-checked=\"patientEssentials.priorityId == 0\">None</label></li><li><button style=\"margin-left: 53px;max-width: 106px;\" class=\"btn btn-primary btn-sm btn-block\" ng-click=\"markUrgentHni(priorityId)\">Mark</button></li></ul></span></div><h4 style=\"font-size: 15px; margin-bottom: 20px;\"><span style=\"font-size: medium; color: #940b23; margin-top: 11px;\">Request id :</span><span style=\"color: #a7a7a7; font-size: small; text-decoration: initial; margin-left: 2px;\">{{custId}}</span> <span style=\"font-size: medium; color: #940b23; margin-top: 11px;\" ng-show=\"patientEssentials.providerOrderId\"><span style=\"color: #b3b3b3;\" ng-show=\"patientEssentials.providerOrderId\"></span> Partner order id :<span style=\"color: #a7a7a7; font-size: small; text-decoration: initial; margin-left: 2px;\">{{patientEssentials.providerOrderId}}</span></span> | <button class=\"btn btn-info btn-xs\" style=\"background-color: #dddddd;border-color: #dddddd;font-weight: 700;color: black;\">{{packageType}}</button> <span style=\"color: black;font-size: inherit;\">{{patientEssentials.visitType}}<span ng-if=\'patientEssentials.additionals && patientEssentials.additionals.isPickUpfromStore==\"true\"\'>(Store Pickup)</span></span> <span ng-show=\"patientEssentials.visitType.length>0 || packageType.length>0\" style=\"color: black;font-size: larger;\">of</span> <a style=\"color: #5a5af3;font-weight: 700;text-decoration: underline;cursor: pointer;\"><package-test-details-modal productid=\"patientEssentials.productId\">{{patientEssentials.productName.replace(\"_\",\" \")}}</package-test-details-modal></a> <span ng-show=\"patientEssentials.grade\">Grade - {{patientEssentials.grade}}</span></h4><div class=\"modal fade in\" id=\"dndReason\" tabindex=\"-2\" role=\"dialog\" aria-labelledby=\"ApproveLabel\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">DND</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"reason\">Reason *</label> <textarea style=\"resize: vertical;\" id=\"reason\" class=\"form-control\" placeholder=\"Enter reason fro DND\" ng-model=\"rescheduleJson.reason\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"!rescheduleJson.reason\" class=\"btn btn-primary\" ng-click=\"dnd(\'close\', \'DND\')\">Request DND</button></div></div></div></div><div class=\"modal fade\" id=\"dndReasonCustomer\" role=\"dialog\" aria-labelledby=\"ApproveLabel\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">DND</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"doa\">Reason *</label> <textarea name=\"diagnosis\" class=\"form-control\" placeholder=\"Enter reason fro DND\" ng-model=\"rescheduleJson.reason\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"!rescheduleJson.reason\" class=\"btn btn-primary\" ng-click=\"dndCustomer(\'close\',\'Customer\')\">Request DND</button></div></div></div></div>");
$templateCache.put("app/components/apptPatientDetail/apptPatientDetail.html","<style>\n    .claim-info {\n        padding: 15px;\n        line-height: 30px;\n    }\n\n    .fieldData {\n        font-size: small;\n        color: #940b23;\n    }\n\n    .headerDecoration {\n        color: #526e83;\n        font-size: x-large;\n        text-decoration: underline;\n    }\n\n    .headerDecorationType {\n        background-color: #d2d2d2;\n        padding-left: 5px;\n        margin-left: -4px;\n        margin-right: -13px;\n    }\n    .panel-heading-custome{\n        background-color: #dddddd;\n        border-color: #dddddd;\n        color: #040404;\n        font-size: medium;\n        padding: 8px;\n        border-radius: 0;\n        height: 36px;\n    }\n</style><div style=\"border: none;padding-bottom: 10px;text-align: center;\"><button class=\"btn btn-primary\" ng-click=\"redirectToIsecure(patientDetails.employeeID)\">Open Digi MER</button></div><div class=\"panel panel-hilight\" style=\"border-color: #dddddd;padding-bottom: 0px;margin-bottom: 0px;\"><div class=\"panel-heading-custome\">Customer Details <button style=\"float: right;\" uib-tooltip=\"Additional Information\"><i ng-click=\"showPatientDetailsAdditionals()\" ng-if=\"patientDetails.additionals\" class=\"fa fa-eye\"></i></button></div><div class=\"panel-body\"><div class=\"form-inline\"><div class=\"form-group\"><label for=\"Name\">Name :</label> <span class=\"fieldData\">{{patientDetails.patientName}}</span> <span class=\"fieldData\">({{patientDetails.relation}}, {{patientDetails.age}} <span ng-if=\"!patientDetails.age\">--</span>years <span ng-if=\"patientDetails.gender != undefined && patientDetails.gender != null\"><span ng-if=\"patientDetails.gender == \'M\'\">male</span><span ng-if=\"patientDetails.gender == \'F\'\">female</span></span>)</span></div><div class=\"form-group\"><label ng-if=\"(visitType.productType === 4625 || visitType.productType === 9782)\" for=\"EmployeeID\">Proposal Number :</label> <label ng-if=\"!(visitType.productType === 4625 || visitType.productType === 9782)\" for=\"EmployeeID\">Employee Id :</label> <span class=\"fieldData\">{{patientDetails.employeeID}}</span></div><div ng-if=\"visitType.productType === 4625 || visitType.productType === 9782\" class=\"form-group\"><label for=\"EmployeeID\">Member Id / MAID :</label> <span class=\"fieldData\">{{apptDetails.additionalInformation.maid}}</span></div><div class=\"form-group\" ng-if=\"!dcLogin\"><label for=\"Mail\">Mail Id :</label> <span class=\"fieldData\" ng-if=\"!dcLogin && patientDetails.employeeMailID != undefined && patientDetails.employeeMailID != null\">{{patientDetails.employeeMailID}}</span></div><div class=\"form-group\"><label for=\"contactNo\">contact number :</label> <span class=\"fieldData\" ng-if=\"patientDetails.contactNo != undefined && patientDetails.contactNo != null\">{{patientDetails.contactNo}}</span></div><div class=\"form-group\" ng-if=\"apptDetails.firstPreferredDate != null\"><label for=\"firstDate\">First Preferred Date :</label> <span class=\"fieldData\">{{getDateObj(apptDetails.firstPreferredDate) | date:\"yyyy-MM-dd \'at\' h:mm a\"}}</span></div><div class=\"form-group\" ng-if=\"apptDetails.secondPreferredDate != null\"><label for=\"secondDate\">Second Preferred Date :</label> <span class=\"fieldData\">{{getDateObj(apptDetails.secondPreferredDate) | date:\"yyyy-MM-dd \'at\' h:mm a\"}}</span></div><div><label for=\"secondDate\">HNI:</label> <span class=\"fieldData\" ng-if=\"apptDetails.isHNI\">Yes</span> <span class=\"fieldData\" ng-if=\"!apptDetails.isHNI\">No</span></div><div ng-if=\"apptDetails.isDND\"><label for=\"secondDate\">DND:</label> <span class=\"fieldData\">Yes</span></div><div ng-if=\"apptDetails.isDNDCustomer\"><label for=\"secondDate\">DND Customer:</label> <span class=\"fieldData\">Yes</span></div></div></div><div class=\"panel-heading-custome\" ng-if=\"!dcLogin\">Appointment Details <span ng-if=\"apptDetails.additionalInformation.additionals.IsDirectCase==\'true\'\" style=\"font-size: 13px;color: red;\">Direct case</span></div><div class=\"panel-body\" ng-if=\"!dcLogin\"><div class=\"form-inline\"><div class=\"form-group\"><label for=\"Date\">Date :</label> <span class=\"fieldData\">{{getDateObj(apptDetails.appointmentDate) | date:\"yyyy-MM-dd \'at\' h:mm a\"}}</span></div><div class=\"form-group\" ng-if=\"apptDetails.providerName != null && apptDetails.providerName != \'--\' && apptDetails.requestDCLocation !=\'--\' && apptDetails.requestDCLocation != null\"><label for=\"ProviderName\">Provider name/ address :</label> <span class=\"fieldData\">{{apptDetails.providerName}}, {{apptDetails.requestDCLocation}}</span></div><div class=\"form-group\" ng-if=\"apptDetails.additionalInformation && apptDetails.additionalInformation.providerId && apptDetails.additionalInformation.providerId != \'--\'\"><label for=\"ProviderID\">Provider ID :</label> <span class=\"fieldData\">{{apptDetails.additionalInformation.providerId}}</span></div><div class=\"form-group\" ng-if=\"apptDetails.dcMobileNo !=0 && apptDetails.dcMobileNo != null && apptDetails.dcMobileNo != \'--\'\"><label for=\"DCContact\">DC mobile number :</label> <span class=\"fieldData\">{{apptDetails.dcMobileNo}}</span></div><div class=\"form-group\" ng-if=\"apptDetails.primaryContactName != null && apptDetails.primaryContactName != \'--\'\"><label for=\"PrimarycontactName\">Primary contact name :</label> <span class=\"fieldData\">{{apptDetails.primaryContactName}}</span></div><div class=\"form-group\" ng-if=\"apptDetails.primaryContactNo !=0 && apptDetails.primaryContactNo != null && apptDetails.primaryContactNo != \'--\'\"><label for=\"PrimarycontactNo\">Primary contact number :</label> <span class=\"fieldData\">{{apptDetails.primaryContactNo}}</span></div><div class=\"form-group\" ng-if=\"apptDetails.dcLandlineNo != null && apptDetails.dcLandlineNo != \'--\' && apptDetails.dcLandlineNo != 0\"><label for=\"LandlineNo\">Landline number :</label> <span class=\"fieldData\">{{apptDetails.dcLandlineNo}}</span></div><div class=\"form-group\" ng-if=\"apptDetails.spoC_ContactNumber != null && apptDetails.spoC_ContactNumber != \'--\' && apptDetails.spoC_ContactNumber != 0\"><label for=\"SponsoredcontactNo\">Sponsored No :</label> <span class=\"fieldData\">{{apptDetails.spoC_ContactNumber}}</span></div><div class=\"form-group\" ng-if=\"apptDetails.primaryEmail != null && apptDetails.primaryEmail != \'--\' && apptDetails.primaryEmail != 0\"><label for=\"PrimaryMail\">Primary mail :</label> <span class=\"fieldData\">{{apptDetails.primaryEmail}}</span></div><div class=\"form-group\" ng-if=\"visitType.doctorName != null && visitType.doctorName != \'--\'\"><label for=\"PrimaryMail\">Doctor name :</label> <span class=\"fieldData\">{{visitType.doctorName}}</span></div><div><label for=\"PrimaryMail\">DC Grading :</label><div ng-if=\"apptDetails.additionalInformation.grade != null && apptDetails.additionalInformation.grade.length > 0\"><span class=\"fieldData\" ng-if=\"apptDetails.additionalInformation.grade.toLowerCase().includes(\'a\') || apptDetails.additionalInformation.grade.toLowerCase().includes(\'b\')\">Premium</span> <span class=\"fieldData\" ng-if=\"apptDetails.additionalInformation.grade.toLowerCase().includes(\'c\') || !apptDetails.additionalInformation.grade.toLowerCase().includes(\'d\')\">Non Premium</span></div></div></div></div><div class=\"panel-heading-custome\" ng-if=\"isVisitType\">Home Visit Details</div><div class=\"panel-body\" ng-if=\"isVisitType\"><div class=\"form-inline\"><div class=\"form-group\"><label for=\"Address\">Address :</label> <span class=\"fieldData\">{{visitType.addressLine1}}, {{visitType.addressLine2}}</span></div><div class=\"form-group\"><label ng-if=\"apptDetails.additionalInformation.additionals.PinCode\" for=\"PinCode\">Pincode :</label> <span ng-if=\"apptDetails.additionalInformation.additionals.PinCode\" class=\"fieldData\">{{apptDetails.additionalInformation.additionals.PinCode}}</span></div></div></div><div class=\"panel-heading-custome\" ng-if=\"!dcLogin && visitType.clientLocation != null && visitType.clientLocation != \'--\'\">Client Onsite Location</div><div class=\"panel-body\" ng-if=\"!dcLogin && visitType.clientLocation != null && visitType.clientLocation != \'--\'\"><div class=\"form-inline\"><div class=\"form-group\"><label for=\"Address\">Location :</label> <span class=\"fieldData\">{{visitType.clientLocation}}</span></div></div></div><div class=\"panel-heading-custome\" ng-if=\"visitType.productType === 4625\">Agent details</div><div class=\"panel-body\" ng-if=\"visitType.productType === 4625\"><div class=\"form-inline\"><div class=\"form-group\"><label for=\"Name\">Name :</label> <span class=\"fieldData\">{{visitType.agentName}}</span></div><div class=\"form-group\"><label for=\"Mobile\">Mobile :</label> <span class=\"fieldData\">{{visitType.agentMobileNumber}}</span></div><div class=\"form-group\"><label for=\"Agent\">Agent code :</label> <span class=\"fieldData\">{{visitType.agentCode}}</span></div><div class=\"form-group\"><label for=\"Insurer\">Insurer :</label> <span class=\"fieldData\">{{visitType.primaryEntityName}}</span></div></div></div><div class=\"panel-heading-custome\" ng-if=\"visittype.clientlocation != null && visittype.clientlocation != \'--\'\">Client Office Location</div><div class=\"panel-body\" ng-if=\"visittype.clientlocation != null && visittype.clientlocation != \'--\'\"><div class=\"form-inline\"><div class=\"form-group\"><label for=\"Name\">Address :</label> <span class=\"fieldData\">{{visitType.clientLocation}}</span></div></div></div><div class=\"panel-heading-custome\" ng-if=\"PharmaPrescription.length > 0\">Prescription</div><div class=\"panel-body\" ng-if=\"PharmaPrescription.length > 0\"><div class=\"form-inline\"><div class=\"form-group\" style=\"margin-left: 185px;\"><button class=\"btn btn-xs btn-info pull-left\" ng-click=\"openUploadPresModal()\"><i class=\"fa fa-upload\"></i> Upload</button> <button class=\"btn btn-xs btn-info pull-right\" ng-click=\"openVarifyPresModal()\" data-toggle=\"modal\" data-target=\"#openVarifyPres\" style=\"margin-left:2px;\"><i class=\"fa fa-eye\"></i> Preview</button></div><ul><li ng-repeat=\"pres in PharmaPrescription\"><a href=\"{{pres.filePath}}\" target=\"_blank\">{{pres.fileName}}</a></li></ul><button class=\"btn btn-primary\" ng-click=\"postToPharma();\" ng-disabled=\"disabledPostToPharma\" ng-show=\"isPostToPharma\">Post To Pharma</button></div></div><div class=\"panel-heading-custome\" ng-if=\"newlyUploadedDocs && newlyUploadedDocs.length > 0\">Newly uploaded files</div><div class=\"panel-body\" ng-if=\"newlyUploadedDocs && newlyUploadedDocs.length > 0\"><div class=\"form-inline\"><ul><li ng-repeat=\"doc in newlyUploadedDocs\"><a href=\"{{doc.filePath}}\" target=\"_blank\">{{doc.fileName}}</a></li></ul></div></div><div class=\"panel-heading-custome\" ng-if=\"isPharma\">Amount Details</div><div class=\"panel-body\" ng-if=\"isPharma\"><div class=\"form-inline\"><div class=\"form-group\"><label for=\"Name\">Cashless :</label> <span class=\"fieldData\">Rs. {{formatCurr(pharmaDetails.cashless)}}</span></div><br><div class=\"form-group\"><label for=\"Mobile\">Cash On Delivery :</label> <span class=\"fieldData\">Rs. {{formatCurr(pharmaDetails.cod)}}</span></div></div></div><div class=\"panel-heading-custome\" ng-if=\"isInfiniti\">Payment Details</div><div class=\"panel-body\" ng-if=\"isInfiniti\"><div class=\"form-inline\"><div class=\"form-group\"><label for=\"Name\">Amount :</label> <span class=\"fieldData\">Rs. {{formatCurr(visitType.lineAmount)}}</span></div><br><div class=\"form-group\" ng-if=\"visitType.walletDeductionInfo && visitType.walletDeductionInfo.length >0\"><label for=\"Name\">Other deduction info :</label><ul><li ng-repeat=\"item in visitType.walletDeductionInfo\"><b>Wallet name:</b> <span class=\"fieldData\">{{item.walletName}}</span><br><b>Payable amount:</b> <span class=\"fieldData\">{{item.payableAmount}}</span><br><b>Tracking number:</b> <span class=\"fieldData\">{{item.trackingNumber}}</span></li></ul></div></div></div><div class=\"panel-body\"><div class=\"form-inline\"><button ng-if=\"list.indexOf(5432) == -1\" ng-class=\"isZivaRequest === true ? \'col-md-6\' :\'col-md-12\'\" class=\"btn btn-sm btn-info\" id=\"details_{{id}}\" ng-click=\"getIdForRelatedReq()\">Show Related Requests</button><div lass=\"form-group col-md-6\" ng-if=\"isZivaRequest\"><button style=\"margin-left: 10px;\" class=\"btn btn-sm btn-primary\" ng-click=\"getIdZivaReq(patientDetails)\">Show Ziva Requests</button></div></div></div></div><div id=\"openModal\" ng-class=\"open ? \'modalDialog-cust\' : \'modalDialog\'\"><div><a title=\"Close\" ng-click=\"closeFileUpload(); open = false\" class=\"close fa fa-times\"></a><h4>Upload Prescription for Pharma Orders</h4><form name=\"frmCorrespondence\"><div class=\"row\"><div class=\"col-md-8\"><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"row\" style=\"opacity: 1;margin-left: 8px;\"><div style=\"height:20px\" class=\"col-md-10\"><input type=\"file\" name=\"preauth\" value=\"Choose File\" file-model=\"item.model\" style=\"opacity:1;\"></div><div class=\"col-md-2\"><button class=\"removeLargeDocument\" ng-click=\"fileUploadMethods.removeFileToUpload($index)\">-</button></div></div></fieldset><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"fileUploadMethods.addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add More Images</span></button></div></div></div><br><hr><div class=\"row\"><div class=\"col-md-6\"></div><div class=\"col-md-6\"><button type=\"button\" id=\"submit\" name=\"submit\" class=\"btn btn-primary btn-xs pull-right\" ng-click=\"uploadMethods.upload()\" ng-disabled=\"isUpload\">Upload Images</button> <button type=\"button\" class=\"btn btn-default btn-xs pull-left\" data-dismiss=\"modal\" ng-click=\"open = false; uploadMethods.clearFileModels()\">Close</button></div></div></form></div></div>");
$templateCache.put("app/components/apptStatusHistory/apptStatusHistory.html","<div class=\"chat-content_wrap\" ng-repeat=\"reqtHistory in apptHistory.statusHistory track by $index\"><span class=\"arrow\"></span><h5 class=\"chat-status\"><span ng-show=\"isCommunication\"><communication-history-modal requestflowid=\"reqtHistory.requestFlowId\" isflowreqid=\"\"><button uib-tooltip=\"communication history\" class=\"btn btn-sm corrBtn pull-right CorrespondenceButton\" style=\"margin-left: 5px;\"><i class=\"fa fa-envelope\"></i></button></communication-history-modal></span> <span ng-show=\"isCorresPondenceForDc\"><button uib-tooltip=\"view correspondence\" class=\"btn corrBtn pull-right btn-sm CorrespondenceButton\" ng-show=\"isView === false && isClick===false\" ng-click=\"featureToShow(\'view\', \'\',$index);\"><i class=\"fa fa-eye\"></i></button> <button uib-tooltip=\"add correspondence\" class=\"btn corrBtn pull-right btn-sm CorrespondenceButton\" ng-show=\"(!showCorrespondence && isView===true)\" ng-click=\"featureToShow(\'add\', reqtHistory.requestFlowId,$index);\"><i class=\"fa fa-plus\"></i></button> <button uib-tooltip=\"close correspondence\" btn-sm=\"\" class=\"btn btn-sm corrBtn pull-right CorrespondenceButton\" ng-show=\"!shwView && $index === isShowTable\" ng-click=\"featureToShow(\'close\',\'\',$index);\"><i class=\"fa fa-close\"></i></button></span> <span class=\"smTxt\">{{compareDate(reqtHistory.date)}} | {{formatTime(reqtHistory.date)}} <span class=\"text-danger\" ng-show=\"reqtHistory.correspondences.length==0\">| No correspondence recorded for this status</span></span> <strong>{{reqtHistory.status}}</strong> <span class=\"smTxt\">{{reqtHistory.requestCreatedBy}}</span> <span class=\"chat-user\"></span></h5><p ng-show=\"reqtHistory.remarks && isCheckRole()\" class=\"note\"><strong>Notes:</strong>{{reqtHistory.remarks}}<br><span ng-show=\"reqtHistory.statusId === 48\"><strong>Doctor qualification:</strong>{{doctorQualification}}</span></p><table class=\"table table-bordered table-condensed\" ng-show=\"PharmaMedicines.length>0 && (reqtHistory.statusId == 115 || reqtHistory.statusId == 22)\"><thead><tr><th>Medicine</th><th>Quantity</th></tr></thead><tbody ng-repeat=\"medi in PharmaMedicines\"><tr><td>{{medi.name}}</td><td>{{medi.qty}}</td></tr></tbody></table><div ng-show=\"(reqtHistory.statusId == 37 || reqtHistory.statusId == 121 || reqtHistory.statusId == 122) && reqtHistory.attachedFiles && reqtHistory.attachedFiles.attachmentsBill && reqtHistory.attachedFiles.attachmentsBill.length > 0\"><p><strong>Uploaded bills:</strong></p><ul><li ng-repeat=\"billData in reqtHistory.attachedFiles.attachmentsBill\"><a href=\"\" ng-click=\"downloadFromUrl(billData.link,billData)\"><i class=\"fa fa-download\"></i> {{billData.name}}</a></li></ul></div><div ng-show=\"isShowUploadedReport && reqtHistory.attachedFiles && reqtHistory.attachedFiles.attachmentsReports.length > 0\"><p ng-if=\"isDownload()\"><strong>Uploaded reports:</strong></p><ul ng-if=\"isDownload()\"><li ng-repeat=\"billData in reqtHistory.attachedFiles.attachmentsReports\"><a href=\"\" ng-click=\"downloadFromUrl(billData.link,billData)\"><i class=\"fa fa-download\"></i> {{billData.name}}</a></li></ul></div><div ng-show=\"reqtHistory.correspondences.length!==0 || !shwView\" style=\"margin-top:20px\"><table class=\"table table-condensed m-b-0\" ng-show=\"$index === isShowTable\"><tr><td><div class=\"clearfix\" ng-show=\"showCorrespondence\"><form name=\"frmCorrespondence\"><div class=\"row\"><div class=\"form-group col-md-3\"><label for=\"calltype\">Select a receiver *</label><select id=\"calltype\" class=\"form-control\" ng-options=\"calltypes as calltypes.value for calltypes in calltypes\" ng-model=\"action.calltype\" required=\"\"><option value=\"\">Select Receiver</option></select></div><div class=\"form-group col-md-4\"><label for=\"callstatus\">Select call status *</label><select id=\"callstatus\" class=\"form-control\" ng-options=\"callstatuses as callstatuses.value for callstatuses in callstatuses\" ng-model=\"action.callstatus\" ng-change=\"showDateTime(action.callstatus)\" required=\"\"><option value=\"\">Select Call Status</option></select></div><div class=\"form-group col-md-5\"><label for=\"correspondenceRemarks\">Add correspondence notes *</label> <textarea name=\"\" id=\"correspondenceRemarks\" cols=\"30\" rows=\"1\" class=\"form-control\" ng-model=\"action.corrremarks\" required=\"\"></textarea></div></div><div class=\"row\" ng-if=\"isZiva\"><div class=\"form-group col-md-6\"><label for=\"sessionNotes\">SessionNotes *</label> <textarea type=\"text\" ng-model=\"zivaCordination.sessionNote\" rows=\"2\" required=\"\" class=\"form-control\" id=\"sessionNotes\"></textarea></div><div class=\"form-group col-md-6\"><label for=\"recommendation\">Recommendation *</label> <textarea type=\"text\" ng-model=\"zivaCordination.recommendation\" rows=\"2\" required=\"\" class=\"form-control\" id=\"recommendation\"></textarea></div></div><div class=\"row\" ng-if=\"showCalender\"><div class=\"form-group col-md-4\"><label for=\"dateTime\" class=\"control-label required-field\">Select Date and time *</label><div class=\"input-group\"><input id=\"dateTime\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"callDateTime.prefDate\" is-open=\"popup6.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" min-date=\"mindate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"open6()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group col-md-2\" style=\"margin-top: -11px; padding-left: 0px;\"><div uib-timepicker=\"\" ng-model=\"callDateTime.prefTime\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\" ng-change=\"getDateTime(callDateTime.prefDate, callDateTime.prefTime)\"></div></div><div class=\"form-group col-md-6\"><label for=\"UICNumber\">UIC number</label> <input id=\"UICNumber\" type=\"text\" ng-model=\"uicDetail.uicNumber\" class=\"form-control\" placeholder=\"Enter UIC number\"></div></div><div class=\"row\"><div class=\"form-group col-md-6\"><mb-plus-file-upload action=\"action\" file-fn=\"fileFn(arg)\"></mb-plus-file-upload></div><div ng-if=\"storeFiles.length >0\" class=\"form-group col-md-6\" ng-repeat=\"item in storeFiles\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: #eeeeee;\"><a ng-click=\"downloadAttachment(item.filePath)\">{{item.fileName}}</a> <a ng-click=\"removeFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div><div class=\"form-group\"><button type=\"button\" class=\"btn btn-primary btn-sm pull-right\" ng-click=\"addCorrespond(reqtHistory.requestFlowId)\" ng-disabled=\"frmCorrespondence.$invalid\">Add Correspondence</button></div></form></div></td></tr></table><table class=\"table table-condensed m-b-0\" ng-show=\"reqtHistory.correspondences.length>0\"><tr ng-repeat=\"corres in reqtHistory.correspondences\"><td><strong>{{corres.correspondenceTypeValue}}</strong> to <strong>{{corres.callTypeValue}}</strong> | <strong>{{corres.callStatusValue}}</strong> | <span class=\"smTxt inline\">{{compareDate(corres.createdOn)}} {{formatTime(corres.createdOn)}}</span><br><span class=\"smTxt inline\">Remarks:</span> {{corres.comment}}<br><span class=\"smTxt inline\">Documents:</span><ul><li ng-repeat=\"corrsData in reqtHistory.attachedFiles.correspondenceReports\"><a href=\"{{corrsData.link}}\" target=\"_blank\"><i class=\"fa fa-download\"></i> {{corrsData.name}}</a></li></ul></td></tr></table></div></div>");
$templateCache.put("app/components/footer/footer.html","<div class=\"bg-danger footer\"><p>This is the footer. Coyrhing and all of that!</p></div>");
$templateCache.put("app/components/govtHospAction/govtHospAction.html","<style>\n    .error {\n        border-color: red;\n    }\n</style><script type=\"text/ng-template\" id=\"govCustomPopupTemplate1.html\"><div class=\"custom-popup-wrapper\" ng-style=\"{top: position().top+\'px\', left: position().left+\'px\'}\" style=\"display: block;\" ng-show=\"isOpen() && !moveInProgress\" aria-hidden=\"{{!isOpen()}}\"> <table class=\"table table-hover\"> <tr ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.id}}\">{{model}} <td width=\"200px\">{{match.model.packageName}}</td> </tr> </table> </div></script><div><div ng-if=\"user.role == \'CMS\'\"><h5 class=\"chatStatus\">Action</h5><button ng-if=\"user.role == \'CMS\'\" class=\"btn btn-success\" ng-click=\"modalRenderingMethods.openApproveGovtModal();\">Approve Request</button> <input type=\"button\" class=\"btn btn-danger\" value=\"Reject Request\" ng-click=\"modalRenderingMethods.openRejectGovtModal()\"> <input type=\"button\" class=\"btn btn-danger\" value=\"Raise IA\" ng-click=\"modalRenderingMethods.openSubmitIAModal()\"></div><div ng-if=\"user.role != \'CMS\'\"><h5 class=\"chatStatus\">Action</h5><input ng-show=\"(dataobj.status ==\'Approved\' || dataobj.status == \'Enhance Approved\') && !IsManipurScheme\" type=\"button\" class=\"btn btn-primary\" value=\"Raise Enhance\" ng-click=\"modalRenderingMethods.openEnhanceClaimModal()\"> <input ng-show=\"dataobj.status ==\'Approved\' || dataobj.status == \'Enhance Approved\' || UserService.getHospitalObj().entityRealtion[0].contractname==\'MSBYHospitals_Mediassist\'\" type=\"button\" class=\"btn btn-primary\" value=\"Claim submission\" ng-click=\"modalRenderingMethods.openSubmissionClaimModal()\"> <input type=\"button\" class=\"btn btn-primary\" value=\"Submit Missing Documents\" ng-click=\"modalRenderingMethods.openSubmitMissingModal()\"></div><div ng-if=\"user.role != \'CMS\' && dataobj.status ==\'Enhance Info-Awaited\'\"><h5 class=\"chatStatus\">Action</h5><input ng-show=\"dataobj.status ==\'Enhance Info-Awaited\'\" type=\"button\" class=\"btn btn-primary\" value=\"Submit Enhance Missing Documents\" ng-click=\"modalRenderingMethods.openEnhanceIAModal()\"></div></div><div class=\"modal fade\" id=\"submitMissing\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\" id=\"submitFormBody\" ng-show=\"!msubmitted\"><form><input type=\"hidden\" value=\"\" name=\"claimId\" id=\"aClaimId\"> <input type=\"hidden\" value=\"{{hospId}}\" name=\"hospId\"> <input type=\"hidden\" value=\"{{user.userId}}\" name=\"updatedBy\"> <input type=\"hidden\" value=\"govt\" name=\"GovernmentClaim\"> <label for=\"enhance-remarks\">Remarks on missing documents</label> <textarea name=\"enhance-remarks\" class=\"form-control\" id=\"enhance-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your comments regarding missing documents. Eg: Surgical details updated or Diagnosis details updated or Submitted missing scan bill etc.,\"></textarea><hr><h4>Attach missing documents</h4><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></fieldset><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button></div><hr><a ng-hide=\"btnSubmitflag\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"btnSubmitflag = true;submitMissingRelatedMethods.submitIr()\">Submit</a> <a ng-show=\"btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\">Cancel</button></form></div><div class=\"modal-body\" ng-show=\"msubmitted\"><p ng-show=\"msubsuccess\">Your missing documents have been submitted successfully.</p><p ng-show=\"!msubsuccess\">Something went wrong! Your missing documents are not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"msubmitted=false;modalRenderingMethods.close()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"submissionClaim\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\" id=\"submitFormBody\" ng-show=\"!msubmitted\"><form><h4>Attach missing documents</h4><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></fieldset><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button></div><hr><a ng-hide=\"btnSubmitflag\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"submitMissingRelatedMethods.submitSc()\">Submit</a> <a ng-show=\"btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\">Cancel</button></form></div><div class=\"modal-body\" ng-show=\"msubmitted\"><p ng-show=\"msubsuccess\">Your claim submitted successfully.</p><p ng-show=\"!msubsuccess\">Something went wrong! Your claim are not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"msubmitted=false;modalRenderingMethods.close()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"EnhanceClaim\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\" id=\"submitFormBody\" ng-show=\"!msubmitted\"><form name=\"govActionEnhanceClaimForm\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"enhance-remarks\">Enhance amount <span style=\"color: red;\">*</span> <span style=\"font-size: 11px; color: red;\" class=\"textErrorMsg\" ng-show=\"govActionEnhanceClaimForm.enhanceAmt.$dirty && govActionEnhanceClaimForm.enhanceAmt.$invalid || govActionEnhanceClaimForm.enhanceAmt.$error.number || govActionEnhanceClaimForm.enhanceAmt.$error.minlength || govActionEnhanceClaimForm.enhanceAmt.$error.maxlength\">Approved amount can\'t be more then 1Cr.</span></label> <input type=\"text\" name=\"enhanceAmt\" ng-model=\"newClmamount\" class=\"form-control\" numbers-only=\"\" ng-maxlength=\"7\" ng-minlength=\"1\" required=\"\" id=\"enhance-remarks\" placeholder=\"Enhance amount\" readonly=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Date Of Admission</label> <input name=\"doa\" id=\"datetimepickerDoa\" type=\"date\" class=\"form-control\" ng-model=\"enhance.doa\" required=\"\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Date Of Discharge</label> <input name=\"dod\" id=\"datetimepicker1\" type=\"date\" class=\"form-control\" ng-model=\"enhance.dod\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"docName\">Government package <span class=\"text-danger\">*</span></label> <input type=\"text\" name=\"GovPackage1\" ng-change=\"typeProcedureName()\" ng-model=\"govPackagename\" placeholder=\"Type package name...\" uib-typeahead=\"condition.packageName for condition in govtPackageList | filter:$viewValue | limitTo:5\" typeahead-on-select=\"selectGovePackage($item, $model)\" typeahead-popup-template-url=\"govCustomPopupTemplate1.html\" class=\"form-control\"></div></div><div class=\"col-md-4\" ng-if=\"!isSelectedGov\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label> <input name=\"procedureName\" placeholder=\"Enter price\" class=\"form-control\" autocomplete=\"off\" ng-model=\"govPackageManually.price\" type=\"text\" numbers-only=\"numbers-only\"></div></div><div class=\"col-md-4\" ng-if=\"isSelectedGov\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label><select ng-if=\"priceForGovPackage.length > 1\" name=\"procedurePrice\" class=\"form-control\" ng-model=\"govPackageManually.price\"><option value=\"\">--Select Price--</option><option value=\"{{obj.price}}\" ng-repeat=\"obj in priceForGovPackage | orderBy:\'obj\'\">{{obj.price}}</option></select><input ng-if=\"priceForGovPackage.length === 1\" readonly=\"true\" name=\"procedureName1\" placeholder=\"Enter price\" class=\"form-control\" autocomplete=\"off\" ng-model=\"govPackageManually.price\" type=\"text\"></div></div><div class=\"col-md-1\" style=\"margin-top: 22px;\"><div class=\"form-group\"><button ng-disabled=\"!(govPackageManually.price && govPackagename)\" class=\"btn btn-primary\" ng-click=\"addGovPackageManually( govPackagename, govPackageManually, isSelectedGov)\">Add</button></div></div></div><div class=\"row\" style=\"background-color: aliceblue; border-radius: 10px;\" ng-if=\"govPackageData.length >0\"><div class=\"col-md-12\"><table class=\"table table-hover table-link\"><thead><th class=\"patientName text-left\">Name</th><th class=\"patientName text-center\">Price</th><th class=\"patientName text-center\">Action</th></thead><tbody><tr tooltip-placement=\"top\" ng-repeat=\"sel_package in govPackageData\"><td class=\"text-left\">{{sel_package.packageName}}</td><td style=\"width: 15%\" class=\"text-center\">{{sel_package.packageCost}} <span ng-show=\"sel_package.isPerDayEligiblePrice === true\">* {{noOfDays}}</span></td><td style=\"width: 15%\" class=\"text-center\"><button class=\"btn btn-danger btn-xs\" ng-click=\"removeGovPackage(sel_package)\">Remove</button></td></tr><tr tooltip-placement=\"top\" ng-if=\"govPackageData.length >0\"><td class=\"text-left\" style=\"font-size: large;color: black;\">Total</td><td class=\"text-center\" style=\"font-size: large;color: black;\"><span class=\"text-center\">{{totalCalcAmount}}</span></td><td class=\"text-center\" style=\"font-size: large;color: black;\"></td></tr></tbody></table></div></div><hr><h4>Enhance documents</h4><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><label for=\"preauth\">Choose atleast one file <span class=\"text-danger\">*</span></label> <input type=\"file\" name=\"preauth\" file-model=\"item.model\" required=\"true\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></fieldset><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button></div><hr><button href=\"\" ng-hide=\"btnSubmitflag\" ng-disabled=\"file[0].model === \'\' || enhance.dod==null || enhance.doa==null\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"submitMissingRelatedMethods.submitEa()\">Submit</button> <a ng-show=\"btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\" ng-click=\"eraseData();\">Cancel</button></form></div><div class=\"modal-body\" ng-show=\"msubmitted\"><p ng-show=\"msubsuccess\">Raise Enhance have been submitted successfully.</p><p ng-show=\"!msubsuccess\">Something went wrong! Your Raise Enhance are not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"msubmitted=false;modalRenderingMethods.close()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"EnhanceIA\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\" id=\"submitFormBody\" ng-show=\"!msubmitted\"><form><label for=\"enhance-remarks\">Remarks on missing documents</label> <textarea name=\"enhance-remarks\" class=\"form-control\" id=\"enhance-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your comments regarding missing documents. Eg: Surgical details updated or Diagnosis details updated or Submitted missing scan bill etc.,\"></textarea><hr><hr><h4>Enhance documents</h4><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></fieldset><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button></div><hr><a ng-hide=\"btnSubmitflag\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"submitMissingRelatedMethods.submitEIA()\">Submit</a> <a href=\"\" ng-show=\"btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\">Cancel</button></form></div><div class=\"modal-body\" ng-show=\"msubmitted\"><p ng-show=\"msubsuccess\">Raise Enhance have been submitted successfully.</p><p ng-show=\"!msubsuccess\">Something went wrong! Your Raise Enhance are not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"msubmitted=false;modalRenderingMethods.close()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"submitIA\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\" id=\"submitFormBody\" ng-show=\"!iasubmitted\"><input type=\"hidden\" value=\"\" id=\"mClaimId\"> <label for=\"enhance-remarks\">Remarks on missing documents</label> <textarea ng-model=\"ia.comments\" class=\"form-control\" cols=\"30\" rows=\"5\" placeholder=\"Leave any comments regarding IA request\"></textarea><hr><label for=\"missingdocs\">Enter missing documents seperated by comma</label><div id=\"missingdocs\"><input type=\"text\" ng-model=\"ia.missingfiles\" placeholder=\"\" class=\"form-control\" id=\"\"></div><br><hr><a ng-hide=\"btnSubmitflag\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"btnSubmitflag = true;IARelatedMethods.submitIA()\">Submit IA Request</a> <a href=\"\" ng-show=\"btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\">Cancel</button></div><div class=\"modal-body\" ng-show=\"iasubmitted\"><p ng-show=\"iasubsuccess\">Your request for missing documents have been submitted successfully.</p><p ng-show=\"!iasubsuccess\">Something went wrong! Your missing documents are not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"iasubmitted=false;modalRenderingMethods.close()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"approveGovt\" tabindex=\"-1\" data-keyboard=\"false\" data-=\"\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\" id=\"approveGovtFormBody\" ng-show=\"!asubmitted\"><h4>Approval Form</h4><hr><form class=\"form-group\" name=\"govActionApproalForm\"><label for=\"approve-amount\">Enter the approval amount <span style=\"color: red;\">*</span> <span style=\"font-size: 11px; color: red;\" class=\"textErrorMsg\" ng-show=\"govActionApproalForm.approveAmt.$dirty && govActionApproalForm.approveAmt.$invalid || govActionApproalForm.approveAmt.$error.number || govActionApproalForm.approveAmt.$error.minlength || govActionApproalForm.approveAmt.$error.maxlength\">Approved amount can\'t be more then 1Cr.</span></label> <input ng-model=\"approve.approvedAmount\" type=\"text\" name=\"approveAmt\" class=\"form-control\" numbers-only=\"\" ng-maxlength=\"7\" ng-minlength=\"1\" required=\"\"><br><label for=\"approve-remarks\">Notes for approval <span style=\"color: red;\">*</span></label> <textarea ng-model=\"approve.comments\" name=\"approveCmt\" class=\"form-control\" id=\"approve-remarks\" cols=\"30\" rows=\"3\" required=\"\"></textarea> <label for=\"approve-amount\">Enter the BCP code <span style=\"color: red;\">*</span> <span style=\"font-size: 11px; color: red;\" class=\"textErrorMsg\" ng-show=\"govActionApproalForm.code.$dirty && govActionApproalForm.code.$invalid || govActionApproalForm.code.$error.minlength\">BCP Code should contain 10 letters/digits</span></label> <input ng-model=\"approve.BCPcode\" ng-minlength=\"10\" type=\"text\" name=\"code\" class=\"form-control\" required=\"\"><hr></form><button ng-hide=\"btnSubmitflag\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"btnSubmitflag = true; ApprovalRelatedMethods.submitApproval()\" ng-disabled=\"!approve.BCPcode || !approve.approvedAmount || !approve.comments\">Approve Request</button> <a ng-show=\"btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\" ng-click=\"ApprovalRelatedMethods.cancelApproval()\">Cancel</button></div><div class=\"modal-body\" ng-show=\"asubmitted\"><p ng-show=\"asubsuccess\">Claim has been approved successfully.</p><p ng-show=\"!asubsuccess\">Something went wrong! Approval for request is not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"asubmitted=false;modalRenderingMethods.close()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"rejectGovt\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\" id=\"rejectGovtFormBody\" ng-show=\"!rsubmitted\"><h4>Rejection remarks</h4><hr><input type=\"hidden\" value=\"\" id=\"rClaimId\"> <label for=\"reject-remarks\">Notes for Rejection</label> <textarea ng-model=\"reject.comments\" class=\"form-control\" id=\"reject-remarks\" cols=\"30\" rows=\"5\"></textarea><hr><a ng-hide=\"btnSubmitflag\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"btnSubmitflag = true;rejectRelatedMethods.submitRejectRequest()\">Reject Request</a> <a ng-show=\"btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\">Cancel</button></div><div class=\"modal-body\" ng-show=\"rsubmitted\"><p ng-show=\"rsubsuccess\">Claim has been rejected successfully.</p><p ng-show=\"!rsubsuccess\">Something went wrong! Rejection for request is not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"rsubmitted=false;modalRenderingMethods.close()\">Close</button></div></div></div></div><message background=\"msg.background\" body=\"msg.body\" header=\"msg.header\" show=\"msg.show\"></message>");
$templateCache.put("app/components/header/header.html","<header class=\"header\" ng-style=\"isRestLogin\" style=\"background: #526e83; background: #283e4a; max-height: 43px;\"><div class=\"col-md-6\"><div ng-show=\"isPlus\"><div class=\"row\"><div class=\"col-xs-3\"><div class=\"btn-group dropRight\"><select style=\"color: rgb(255, 255, 255);background-color: rgb(40, 62, 74);border: rgb(40, 62, 74);font-size: small;width: 85%;\" ng-change=\"changePage(searchby)\" ng-model=\"searchby\" class=\"form-control\"><option value=\"\">Search By</option><option value=\"ClaimNumber\">Claim No</option><option value=\"PatientName\">Patient Name</option><option value=\"IPNumber\">IP Number</option><option value=\"UTRNumber\">NEFT / UTR Number</option><option value=\"claimStatus\">Claim Status</option><option value=\"employeeId\">Employee Code</option></select></div></div><div ng-class=\"ischangePage?\'col-xs-9\':\'col-xs-9\'\"><form name=\"claimSearchForm\" style=\"margin-left: -70px;\"><div class=\"col-xs-4\" ng-show=\"searchby && configuredTpaList && configuredTpaList.length>0\"><div class=\"input-group\"><select style=\"color: rgb(255, 255, 255);background-color: rgb(40, 62, 74);border: rgb(40, 62, 74);font-size: small\" ng-options=\"item as item.value for item in configuredTpaList\" ng-model=\"tpaName\" class=\"form-control\" ng-change=\"changeTpa(this.tpaName)\"></select></div></div><div class=\"col-xs-8\"><div class=\"input-group\" ng-show=\"searchby === \'ClaimNumber\'\"><input type=\"text\" tooltip-placement=\"bottom\" tooltip-trigger=\"mouseenter\" uib-tooltip=\"Claim number\" id=\"claimSearchFormClaimNo\" name=\"claimNo\" class=\"form-control ng-pristine ng-untouched ng-valid ng-valid-min\" ng-model=\"claimSearch.claimNo\" placeholder=\"Enter claim no\" focus-on=\"searchby === \'Claim No\'\" required=\"\" ng-class=\"claimSearchForm.claimNo.$error.required ? \'errorhighlight\' : \'successhighlight\'\"> <span class=\"input-group-btn\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"searchClaims(claimSearch.claimNo, \'ClaimNumber\')\" ng-disabled=\"!claimSearch.claimNo\"><a style=\"color: white\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i></a></button> <button class=\"btn btn-danger\" type=\"button\" ng-click=\"searchby = null; claimSearch.claimNo = null; goBack()\"><a style=\"color: black\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a></button></span></div><div class=\"input-group\" ng-show=\"searchby === \'employeeId\'\"><input type=\"text\" tooltip-placement=\"bottom\" tooltip-trigger=\"mouseenter\" uib-tooltip=\"Employee id\" id=\"claimSearchFormmemberid\" name=\"employeeid\" class=\"form-control ng-pristine ng-untouched ng-valid ng-valid-min\" ng-model=\"claimSearch.employeeId\" placeholder=\"Enter employee id\" focus-on=\"searchby === \'employeeId\'\" required=\"\" ng-class=\"claimSearchForm.claimSearchFormmemberid.$error.required ? \'errorhighlight\' : \'successhighlight\'\"> <span class=\"input-group-btn\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"searchClaims(claimSearch.employeeId, \'employeeId\')\" ng-disabled=\"!claimSearch.employeeId\"><a style=\"color: white\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i></a></button> <button class=\"btn btn-danger\" type=\"button\" ng-click=\"claimSearch.employeeId = null;\"><a style=\"color: black\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a></button></span></div><div class=\"input-group\" ng-show=\"searchby === \'claimStatus\'\"><div class=\"form-control\" style=\"background-color: #283e4a; border-color: #283e4a; padding-top: 0px;\"><select style=\"color: rgb(255, 255, 255);background-color: rgb(40, 62, 74);border: rgb(40, 62, 74);font-size: small;width: 160px;\" ng-model=\"claimSearch.status\" class=\"form-control\"><option value=\"\">Select Status</option><option value=\"Approved\">Approved</option><option value=\"Denied\">Denied / Cancelled</option><option value=\"InProgress\">In Progress</option><option value=\"InformationAwaited\">Information Awaited</option><option value=\"Settled\">Settled</option></select><span class=\"input-group-btn\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"searchClaims(claimSearch.status, \'claimStatus\')\" ng-disabled=\"!claimSearch.status\"><a style=\"color: white\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i></a></button> <button class=\"btn btn-danger\" type=\"button\" ng-click=\"searchby = null; claimSearch.status = null; goBack()\"><a style=\"color: black\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a></button></span></div></div><div ng-show=\"searchby === \'PatientName\'\"><div class=\"row\"><div class=\"col-xs-4\"><input type=\"text\" tooltip-placement=\"bottom\" tooltip-trigger=\"mouseenter\" uib-tooltip=\"Patient name\" id=\"claimSearchFormPatientName\" name=\"patientName\" class=\"form-control ng-pristine ng-untouched ng-valid\" ng-model=\"claimSearch.patientName\" minlength=\"3\" placeholder=\"Enter patient full name\" focus-on=\"searchby === \'Patient Name\'\" required=\"\" ng-class=\"claimSearchForm.patientName.$error.required || claimSearchForm.patientName.$error.minlength ? \'errorhighlight\' : \'successhighlight\'\"></div><div class=\"col-xs-4\"><input tooltip-placement=\"bottom\" tooltip-trigger=\"mouseenter\" uib-tooltip=\"DOA\" ng-click=\"openDatePopup()\" placeholder=\"Click here from date\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"claimSearch.fromDate\" is-open=\"datePopup.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"></div><div class=\"col-xs-4 input-group\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"searchClaims(claimSearch.patientName,\'claimSearchFormPatientName\')\" ng-disabled=\"!claimSearch.patientName\"><a style=\"color: white\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i></a></button> <button class=\"btn btn-danger\" type=\"button\" ng-click=\"searchby = null; claimSearch.patientName = null; goBack()\"><a style=\"color: black\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a></button></div></div></div><div class=\"input-group\" ng-show=\"searchby === \'IPNumber\'\"><input type=\"text\" name=\"patientIPNumber\" tooltip-placement=\"bottom\" tooltip-trigger=\"mouseenter\" uib-tooltip=\"IP number\" class=\"form-control ng-pristine ng-untouched ng-valid\" ng-model=\"claimSearch.patientIPNumber\" placeholder=\"Enter IP Number\" minlength=\"1\" focus-on=\"searchby === \'IP Number\'\" required=\"\" ng-class=\"claimSearchForm.patientIPNumber.$error.required || claimSearchForm.patientIPNumber.$error.minlength ? \'errorhighlight\' : \'successhighlight\'\"> <span class=\"input-group-btn\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"searchClaims(claimSearch.patientIPNumber,\'patientIPNumber\')\" ng-disabled=\"!claimSearch.patientIPNumber\"><a style=\"color: white\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i></a></button> <button class=\"btn btn-danger\" type=\"button\" ng-click=\"searchby = null; claimSearch.patientIPNumber = null; goBack()\"><a style=\"color: black\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a></button></span></div><div class=\"input-group\" ng-show=\"searchby === \'UTRNumber\'\"><input type=\"text\" id=\"claimSearchFormNEFTUTRNumber\" tooltip-placement=\"bottom\" tooltip-trigger=\"mouseenter\" uib-tooltip=\"NEFT / UTR number\" name=\"NEFTUTRNumber\" class=\"form-control ng-pristine ng-untouched ng-valid\" ng-model=\"claimSearch.NEFTUTRNumber\" placeholder=\"Enter NEFT / UTR Number\" minlength=\"1\" focus-on=\"searchby === \'NEFT / UTR Number\'\" required=\"\" ng-class=\"claimSearchForm.NEFTUTRNumber.$error.required || claimSearchForm.NEFTUTRNumber.$error.minlength ? \'errorhighlight\' : \'successhighlight\'\"> <span class=\"input-group-btn\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"searchClaims(claimSearch.NEFTUTRNumber,\'NEFTUTRNumber\')\" ng-disabled=\"!claimSearch.NEFTUTRNumber\"><a style=\"color: white\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i></a></button> <button class=\"btn btn-danger\" type=\"button\" ng-click=\"searchby = null; claimSearch.NEFTUTRNumber = null; goBack()\"><a style=\"color: black\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a></button></span></div></div></form><form name=\"claimSearchForm\" ng-show=\"!ischangePage\"><div ng-class=\"className\" class=\"tickerPanel flipX\" ng-mouseenter=\"getText()\"><div style=\"height: 35px; padding-top: 9px;\" class=\"front\">MediBuddy plus adoption <strong>{{mediBuddyPlusUtilization}} %</strong></div><div class=\"back\"><span ng-bind-html=\"textData\"></span></div></div></form></div></div></div><div ng-show=\"!isPlus && headerFlag.plusSearch\" class=\"input-group\"><input type=\"text\" id=\"plusAppointmentsSearch\" class=\"form-control\" placeholder=\"Enter request id or customer name to search\" ng-model=\"plusAppointmentsSearch\" ng-enter=\"SearchAppointments()\"><div class=\"input-group-btn\"><input id=\"search-button\" type=\"button\" class=\"btn btn-primary\" value=\"Clear Search\" ng-click=\"plusAppointmentsSearch =\'\'\"></div></div><div ng-show=\"!isPlus && isDcInvestigationsMap\" class=\"input-group\"><input type=\"text\" id=\"dcInvestigationsMap\" class=\"form-control\" placeholder=\"Enter DC Name or DC Id to search\" ng-model=\"dcInvestigationsMap\" ng-enter=\"SearchAppointments()\"><div class=\"input-group-btn\"><input id=\"search-button\" type=\"button\" class=\"btn btn-primary\" value=\"Clear Search\" ng-click=\"dcInvestigationsMap =\'\'\"></div></div><div ng-show=\"!isPlus && isQueue\" class=\"row\"><div class=\"col-xs-4\"><div class=\"btn-group dropRight\"><select style=\"font-size: inherit;color: #ffffff;background-color: #283e4a;border: #283e4a;font-size: small;\" ng-model=\"eSaleQueue\" ng-change=\"eSalesFilter(eSaleQueue)\" class=\"form-control\"><option value=\"\">Select Search Option</option><option value=\"1\">Equote Id</option><option value=\"2\">Email Id</option><option value=\"3\">Contact no.</option><option value=\"4\">Name</option><option value=\"5\">Proposal Number</option></select></div></div><div class=\"col-xs-4 p-l-0 p-r-0\" ng-if=\"eSaleQueue && isSearchSelected\"><input type=\"text\" placeholder=\"{{placeHolderValue}}\" ng-model=\"search.searchData\" class=\"form-control\"></div><div class=\"col-xs-4 p-l-0\" ng-if=\"eSaleQueue && isSearchSelected\"><input step=\"margin-left: 5px;\" type=\"button\" value=\"Search\" class=\"btn btn-primary\" ng-click=\"eSalesAppointmentParticular()\"> <input type=\"button\" value=\"Clear\" class=\"btn btn-default\" ng-click=\"clearSearchData()\"></div></div><div ng-show=\"!isPlus && isDcInvestigations\" class=\"input-group\"><input type=\"text\" id=\"dcInvestigations\" class=\"form-control\" placeholder=\"Enter investigation id or name to search\" ng-model=\"dcInvestigations\" ng-enter=\"SearchAppointments()\"><div class=\"input-group-btn\"><input id=\"search-button\" type=\"button\" class=\"btn btn-primary\" value=\"Clear Search\" ng-click=\"dcInvestigations =\'\'\"></div></div><div ng-if=\"!isPlus && plusActiveAppointmentsSearch\"><div class=\"row\"><form name=\"frmOrder\"><div class=\"col-xs-3 p-r-0\"><select style=\"font-size: inherit;color: #ffffff;background-color: #283e4a;border: #283e4a;font-size: small;\" ng-model=\"data.singleSelect\" ng-change=\"statusFilter(data.singleSelect)\" class=\"form-control\"><option value=\"\">Select Search Option</option><option value=\"1\">Request Id</option><option ng-if=\"user.entityType === \'Insurer\'\" value=\"2\">Proposal No.</option><option ng-if=\"user.entityType !== \'Insurer\'\" value=\"2\">Employee Id</option><option value=\"3\">Email</option><option value=\"4\">Contact No.</option><option value=\"5\">Name</option><option ng-if=\"user.entityType !== \'Insurer\'\" value=\"6\">Partner Order Id</option><option ng-if=\"user.entityType === \'Insurer\'\" value=\"8\">Member Id</option><option ng-if=\"user.entityType !== \'Insurer\'\" value=\"8\">Member Id / MAID</option></select></div><div class=\"col-xs-4 p-l-0 p-r-0\" ng-if=\"(isSearchSelected) && data.singleSelect == 1\"><input numbers-only=\"numbers-only\" minlength=\"3\" placeholder=\"{{placeHolderValue}}\" ng-model=\"search.searchData\" required=\"\" class=\"form-control\"></div><div class=\"col-xs-4 p-l-0 p-r-0\" ng-if=\"(isSearchSelected) && (data.singleSelect == 2 || data.singleSelect == 5 || data.singleSelect == 6 || data.singleSelect == 8)\"><input type=\"text\" minlength=\"3\" placeholder=\"{{placeHolderValue}}\" ng-model=\"search.searchData\" required=\"\" class=\"form-control\"></div><div class=\"col-xs-4 p-l-0 p-r-0\" ng-if=\"isSearchSelected && data.singleSelect == 3\"><input type=\"Email\" placeholder=\"{{placeHolderValue}}\" ng-model=\"search.searchData\" required=\"\" class=\"form-control\"></div><div class=\"col-xs-4 p-l-0 p-r-0\" ng-if=\"isSearchSelected && data.singleSelect == 4\"><input numbers-only=\"numbers-only\" maxlength=\"10\" minlength=\"10\" type=\"text\" placeholder=\"{{placeHolderValue}}\" ng-model=\"search.searchData\" required=\"\" class=\"form-control\"></div><div class=\"col-xs-4 p-l-0\" ng-if=\"showTextBtn\"><button class=\"btn btn-primary\" step=\"margin-left: 5px;\" ng-click=\"searchAppointmentsParticular(search, true)\" ng-disabled=\"frmOrder.$invalid\"><a style=\"color: white\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i></a></button> <button class=\"btn btn-danger\" ng-click=\"clearSearchData()\" ng-disabled=\"frmOrder.$invalid\"><a style=\"color: black\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a></button></div></form></div></div><div ng-if=\"!isPlus && plusinsurerDashboardSearch\"><div class=\"row\"><form name=\"frmInsurerDash\"><div class=\"col-md-4 p-r-0\"><select style=\"font-size: inherit;color: #ffffff;background-color: #283e4a;border: #283e4a;font-size: small;\" ng-model=\"insurer.dsearchOption\" ng-change=\"showInsurerSearchDdl(insurer.dsearchOption)\" class=\"form-control\"><option value=\"\">Search category</option><option value=\"1\">WIP</option><option value=\"2\">All appointments</option><option value=\"3\">Application no</option></select></div><div class=\"col-md-2 p-l-0 p-r-0\" ng-if=\"showEsalesDdl\"><select style=\"font-size: inherit;color: #ffffff;background-color: #283e4a;border: #283e4a;font-size: small;\" ng-model=\"insurerDashSearchDdl.esalesDdl\" ng-change=\"insurerDashSearch(insurerDashSearchDdl.esalesDdl, \'esales\')\" class=\"form-control\"><option value=\"\">Select</option><option value=\"1\">Email</option><option value=\"2\">Contact</option><option value=\"3\">Name</option><option value=\"4\">EQuote</option><option value=\"5\">Application no.</option></select></div><div class=\"col-md-2 p-l-0 p-r-0\" ng-if=\"showAllApptDdl\"><select style=\"font-size: inherit;color: #ffffff;background-color: #283e4a;border: #283e4a;font-size: small;\" ng-model=\"insurerDashSearchDdl.allApptDdl\" ng-change=\"insurerDashSearch(insurerDashSearchDdl.allApptDdl, \'allAppt\')\" class=\"form-control\"><option value=\"\">Select</option><option value=\"1\">Request ID</option><option value=\"2\">Employee ID</option><option value=\"3\">Email</option><option value=\"4\">Contact</option><option value=\"5\">Name</option></select></div><div class=\"col-md-3 p-r-0 p-l-0\" ng-if=\"txtInsurerSearch\"><input type=\"text\" placeholder=\"{{placeHolderValue}}\" ng-model=\"insurerSearch.searchData\" required=\"\" class=\"form-control\"></div><div class=\"col-md-3 p-r-0 p-l-0\" ng-if=\"txtInsurerSearch && showEsalesDdl\"><input type=\"button\" value=\"Search\" class=\"btn btn-primary\" ng-click=\"searchAppointmentsParticular(insurerSearch, true, \'Esales\')\" ng-disabled=\"frmInsurerDash.$invalid\"> <input type=\"button\" value=\"X\" class=\"btn btn-default\" ng-click=\"clearSearchData()\" ng-disabled=\"frmInsurerDash.$invalid\"></div><div class=\"col-md-3 p-r-0 p-l-0\" ng-if=\"txtInsurerSearch && showAllApptDdl\"><input type=\"button\" value=\"Search\" class=\"btn btn-primary\" ng-click=\"searchAppointmentsParticular(insurerSearch, true, \'Allappt\')\" ng-disabled=\"frmInsurerDash.$invalid\"> <input type=\"button\" value=\"X\" class=\"btn btn-default\" ng-click=\"clearSearchData()\" ng-disabled=\"frmInsurerDash.$invalid\"></div><div class=\"col-md-3 p-r-0 p-l-0\" ng-if=\"txtInsurerSearch && bothContrSearch\"><input type=\"button\" value=\"Search\" class=\"btn btn-primary\" ng-click=\"searchAppointmentsParticular(insurerSearch, true, \'both\')\" ng-disabled=\"frmInsurerDash.$invalid\"> <input type=\"button\" value=\"X\" class=\"btn btn-default\" ng-click=\"clearSearchData()\" ng-disabled=\"frmInsurerDash.$invalid\"></div></form></div></div></div><div class=\"col-md-1 pull-left notification\" ng-show=\"checkMaFlag()\"><a popover-placement=\"bottom\" uib-popover-template=\"dynamicPopover.templateUrl\" popover-trigger=\"outsideClick\" popover-title=\"Notifications\" style=\"display:block; padding-top:5px;\"><i class=\"fa fa-bell-o fa-2x\" aria-hidden=\"true\" id=\"bellNotify1\" style=\"color: white; margin-top: -2px;\"><b class=\"bg-color0\"></b></i> <b style=\"display: inline-block;min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: bold;color: #fff;line-height: 1;vertical-align: middle;white-space: nowrap;text-align: center;background-color: #f79e00;border-radius: 10px;margin-top: -16px;\">{{notificationCount1}}</b></a></div><div class=\"col-md-3\"><style>\n            .switchMenu {\n                position: relative;\n                display: grid;\n                width: 60px;\n                height: 30px;\n                margin: auto;\n                margin-top: 2px;\n                    }\n            \n                        .switchMenu input {\n                            display: none;\n                        }\n            \n                    .sliderMenu {\n                        position: absolute;\n                        cursor: pointer;\n                        top: 0;\n                        left: 0;\n                        right: 0;\n                        bottom: 0;\n                        background-color: #ccc;\n                        -webkit-transition: .4s;\n                        transition: .4s;\n                    }\n            \n                        .sliderMenu:before {\n                            position: absolute;\n                            content: \"\";\n                            height: 26px;\n                            width: 26px;\n                            left: 4px;\n                            bottom: 2px;\n                            background-color: white;\n                            -webkit-transition: .4s;\n                            transition: .4s;\n                        }\n            \n                    input:checked + .sliderMenu {\n                        background-color: #2196F3;\n                    }\n            \n                    input:focus + .sliderMenu {\n                        box-shadow: 0 0 1px #2196F3;\n                    }\n            \n                    input:checked + .sliderMenu:before {\n                        -webkit-transform: translateX(26px);\n                        -ms-transform: translateX(26px);\n                        transform: translateX(26px);\n                    }\n                    .note {\n                        padding: 10px;\n                        margin: 10px 0;\n                        background: yellow;\n                        border-radius: 6px;\n                        color: #000;\n                    }\n                    /* Rounded sliders */\n                    .sliderMenu.round {\n                        border-radius: 34px;\n                    }\n            \n                        .sliderMenu.round:before {\n                            border-radius: 50%;\n                        }\n        </style><div ng-if=\"toggleMenuObj.isMultiRole\" style=\"position: relative;\"><span style=\"position: absolute;top:6px;left:0px; margin-left: 14px;color: white;\">In-Patient</span> <label class=\"switchMenu\"><input ng-click=\"toggleMenu()\" type=\"checkbox\" ng-checked=\"checkRoleFlag()\"><div class=\"sliderMenu round\"></div></label> <span style=\"margin-left: 0;position:absolute;top:6px;right:20px;color: white;\">Out-Patient</span></div></div><div ng-class=\"checkMaFlag() ?\'col-md-2\':\'col-md-3\'\" class=\"text-right\"><a ng-if=\"!userRole(\'mediAssist\', user.role) && userRole(\'restrict\', user.role)\" ng-click=\"redirectUrl(\'newAdmission\')\" class=\"btn btn-primary btn-sm\" ng-show=\"isPlus\">New Admission</a> <a ng-if=\"!userRole(\'mediAssist\', user.role) && userRole(\'restrict\', user.role) && hospErId\" ng-click=\"redirectUrl(\'walkInCashless\')\" class=\"btn btn-primary btn-sm\" ng-show=\"!isPlus\">OPD Cashless</a><span class=\"btn logout\" ng-click=\"logout()\">Sign Out<i style=\"margin-left: 8px;\" class=\"glyphicon glyphicon-log-out\"></i></span></div><div class=\"modal show\" tabindex=\"-1\" role=\"dialog\" ng-if=\"displayOldToNew\" style=\"padding: 30px; color: #0f0b54; text-align: center; width: 60vw; left: 20vw; background-color: rgba(255, 255, 255, 0); height: 55vh; line-height: 1; overflow: hidden;\"><div class=\"modal-dialog\" role=\"document\" style=\"margin: 30px auto 0 auto; height: 100%; width: 70%;\"><div class=\"modal-content\" style=\"height: 100%;\"><div class=\"modal-body border border-info\" style=\"height:100%\"><button type=\"button\" style=\"position: absolute; top:0; right: 0;\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"oldToNew(\'stay\')\"><span aria-hidden=\"true\">&times;</span></button><div class=\"\" style=\"align-items: center\"><div style=\"font-size: large; margin: 20px 0 30px 0\">Welcome, {{user.firstName}}</div><div><img src=\"/app/resources/images/Group 189567.png\"></div><div style=\"padding: 15px 0; font-size: x-large\">Switch to New Portal</div></div></div><div class=\"modal-footer\" style=\"text-align: center; position: absolute; bottom: 0; width: 100%;\"><div><button type=\"button\" class=\"btn\" style=\"border: 1px solid #3579ea; color: #3579ea; margin-right: 15px\" ng-click=\"oldToNew(\'stay\')\">Stay Here</button> <a href=\"https://provider-central.medibuddy.in/#/login\"><button type=\"button\" class=\"btn\" style=\"background-color: #3579ea; color: #ffffff\">Try New portal</button></a></div></div></div></div></div><script type=\"text/ng-template\" id=\"notificationPopover.html\"><div class=\"form-group\" ng-repeat=\"item in notificationAllData track by $index\"> <button ng-click=\"markAsComplet(item,$index)\" class=\"btn btn-success\"><i class=\"fa fa-check\"></i></button> <p style=\"margin-bottom: 0px; color: #199292\"> <strong>{{item.NotificationType}} </strong> to <strong>{{item.Receiver}}</strong> on <strong> {{compareDate(item.NotificationTime)}} </strong> at <strong> {{formatTime(item.NotificationTime)}} </strong> for requestId <strong> {{item.RequestID}} </strong> </p> <p style=\"font-size: small; color: #000000; margin-bottom: 0px; \">{{item.Reason}}</p> </div> <div ng-if=\"notificationAllData.length===0\" style=\" color: brown; font-size: medium; \"> No notification to show. </div></script></header>");
$templateCache.put("app/components/leftMenu/leftMenu.html","<aside class=\"left-nav nav-primary hidden-xs\" ng-style=\"isRestLogin\" style=\"padding: 0px 0px 0px 0px;\"><ul class=\"abc\"><li><a style=\"background-color: whitesmoke;\" class=\"brand\" ng-if=\"(applicationUserName ===\'cms\' || applicationUserName ===\'insurer\') || (plusAppointmentFeaturesToLoad.length >0)\"><span class=\"pull-right\"><i class=\"fa fa-angle-down text\" style=\"color: #333333;\"></i> <i class=\"fa fa-angle-up text-active\" style=\"color: #333333;\"></i></span> <img src=\"/app/resources/images/logo-mediBuddy.png\" alt=\"\"></a><ul class=\"nav lt\"><li class=\"subMenuText\" ng-if=\"applicationUserName ===\'cms\'\"><a href=\"#/activehosp\"><i class=\"fa fa-thumbs-up\"></i> <span class=\"leftMenuText\">Active Hospitals</span></a></li><li class=\"subMenuText\" ng-if=\"applicationUserName ===\'cms\'\"><a href=\"#/hospselect\" ng-click=\"\"><i class=\"fa fa-level-down\"></i> <span class=\"leftMenuText\">Enroll Hospital</span></a></li><li class=\"subMenuText\" ng-if=\"applicationUserName ===\'cms\' || applicationUserName ===\'insurer\'\"><a ng-click=\"anything();\"><i class=\"fa fa-retweet\"></i> <span class=\"leftMenuText\">Change Hospital</span></a></li><li class=\"subMenuText\" ng-if=\"plusAppointmentFeaturesToLoad.length >0\"><a ng-click=\"openSwitchDC()\"><i class=\"fa fa-retweet\"></i> <span class=\"leftMenuText\">Switch Diagnostic Centre</span></a></li><li class=\"subMenuText\" ng-if=\"applicationUserName ===\'cms\' || applicationUserName ===\'insurer\' ||plusAppointmentFeaturesToLoad.length >0\"><a href=\"#/changepwd\"><i class=\"fa fa-exchange\"></i> <span class=\"leftMenuText\">Change password</span></a></li><li class=\"subMenuText\" ng-if=\"applicationUserName ===\'cms\' || applicationUserName ===\'insurer\' ||plusAppointmentFeaturesToLoad.length >0\"><a ng-click=\"logout();\"><i class=\"fa fa-sign-out\"></i> <span class=\"leftMenuText\">Sign out</span></a></li></ul></li><li ng-if=\"(applicationUserName !==\'cms\' || applicationUserName ===\'insurer\') && hospFeatureNotificationToLoad.length > 0 && plusAppointmentFeaturesToLoad.length ===0\"><a href=\"#/claims\" class=\"brand\"><img src=\"/app/resources/images/logo-mediBuddy.png\" alt=\"\"></a></li><li ng-if=\"applicationUserName ===\'insurer\' && hospFeatureNotificationToLoad.length > 0\"><a href=\"#/government\" class=\"brand\"><img src=\"/app/resources/images/logo-mediBuddy.png\" alt=\"\"></a></li><li style=\"margin-left: -10px;\"><a class=\"hospital\" style=\"color: #fff;text-decoration: none;font-size: inherit;font-weight: 600;margin-left: 6px;\"><span>{{hospName}}</span> <em class=\"city text-xs\">{{hospCity}}, {{hospState}}</em> <em class=\"user\"><i class=\"fa fa-user\"></i> {{userName}}</em></a></li><li class=\"onmouseover plusMenuCor\" ng-if=\"checkMaFlag()\"><a ng-click=\"changePlusView(\'\\maNotifications\')\"><i class=\"fa fa-bell-o fa-2x\" aria-hidden=\"true\" id=\"bellNotifyRing\"><b class=\"bg-color0\"></b></i> <b style=\"color: #000000;\" ng-class=\"maNotificationCount > 0 ? \'badge bg-success pull-right\' : \'badge-zero bg-success pull-right\'\">{{maNotificationCount}}</b> <span id=\"bellNotifyRing\" class=\"leftMenuText\">MA Notifications</span></a></li><li class=\"onmouseover plusMenuCor\" ng-if=\"checkPlusAppointmentFeature()\"><a style=\"margin-left: 28px;\"><i class=\"fa fa-hotel\" style=\"margin-left: -42px;\"><b class=\"bg-color6\"></b></i> <span class=\"pull-right\" style=\"color: white;\"><i class=\"fa fa-angle-down text\" style=\"color: white;\"></i> <i class=\"fa fa-angle-up text-active\" style=\"color: white;\"></i></span> <span class=\"leftMenuText\">Appointments</span></a><ul class=\"nav lt\"><li ng-repeat=\"menu in plusAppointmentFeaturesToLoad track by $index\" ng-show=\"checkAppointmentOptions(menu) && checkIfPrePolicyValid(menu)\" class=\"subMenuText\"><a ng-click=\"changePlusView(menu.href)\"><i class=\"{{menu.icon}}\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">{{menu.menuItem}}</span></a></li><li class=\"subMenuText\" ng-show=\"checkIfDcDashboard()\"><a ng-click=\"gotoAppointments(\'allappointmentsSearchStatus\', \'newAppointments/22\')\"><i class=\"fa fa-angle-right\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">New Appointments</span></a></li><li class=\"subMenuText\" ng-show=\"checkIfDcDashboard()\"><a ng-click=\"gotoAppointments(\'allappointmentsSearchStatus\', \'attendanceConfirmation/23\')\"><i class=\"fa fa-angle-right\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">Attendance confirmation</span></a></li><li class=\"subMenuText\" ng-show=\"checkIfDcDashboard()\"><a ng-click=\"gotoAppointments(\'allappointmentsSearchStatus\', \'documentsPending/32\')\"><i class=\"fa fa-angle-right\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">Documents pending</span></a></li><li class=\"subMenuText\" ng-show=\"checkIfDcDashboard()\"><a ng-click=\"gotoAppointments(\'allappointmentsSearchStatus\', \'documentsReceived/37\')\"><i class=\"fa fa-angle-right\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">Documents received</span></a></li><li class=\"subMenuText\" ng-show=\"checkIfDcDashboard()\"><a ng-click=\"gotoAppointments(\'allappointmentsSearchStatus\', \'settled/48\')\"><i class=\"fa fa-angle-right\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">Settled</span></a></li><li class=\"subMenuText\" ng-show=\"checkIfDcDashboard()\"><a ng-click=\"gotoAppointments(\'allappointmentsSearchStatus\', \'cancelled/42\')\"><i class=\"fa fa-angle-right\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">Cancelled</span></a></li></ul></li><li class=\"onmouseover plusMenuCor\" ng-repeat=\"menu in hospFeaturesToLoad track by $index\" ng-if=\"checkHospFeatures()\"><a ng-click=\"changePlusView(menu.href)\"><i class=\"{{menu.icon}}\"><b class=\"bg-color6\"></b></i> <span class=\"pull-right\" ng-if=\"checkSubProfileMenu(menu.fId)\"><i class=\"fa fa-angle-down text\"></i> <i class=\"fa fa-angle-up text-active\"></i></span> <span class=\"leftMenuText\">{{menu.menuItem}}<span ng-if=\"menu.menuItem ===\'Claims\' && getCmsUserCheck() === false\"><b style=\"color: #000000;\" ng-class=\"notifyCount.approvedNotificationCount || notifyCount.infoRequiredNotificationCount || notifyCount.paymentNotificationCount || notifyCount.deniedNotificationCount > 0 ? \'badge bg-success pull-right\' : \'badge-zero bg-success pull-right\'\">{{notifyCount.deniedNotificationCount+ notifyCount.paymentNotificationCount + notifyCount.infoRequiredNotificationCount + notifyCount.approvedNotificationCount}}</b></span></span></a><ul class=\"nav lt\" ng-if=\"menu.fId ===19999\"><li class=\"subMenuText\" ng-repeat=\"subItem in menu.profileMenu track by $index\"><a ng-click=\"changeHospitalUrl(subItem.href)\" class=\"active\"><i class=\"{{subItem.icone}}\"><b class=\"bg-color6\"></b></i> <b ng-if=\"subItem.name ===\'Active Claims\'&& getCmsUserCheck() === false\" style=\"color: #000000;\" ng-class=\"notifyCount.approvedNotificationCount > 0 ? \'badge bg-success pull-right\' : \'badge-zero bg-success pull-right\'\">{{notifyCount.approvedNotificationCount}}</b> <b ng-if=\"subItem.name ===\'Document Pending\' && getCmsUserCheck() ===false\" style=\"color: #000000;\" ng-class=\"notifyCount.infoRequiredNotificationCount > 0 ? \'badge bg-success pull-right\' : \'badge-zero bg-success pull-right\'\">{{notifyCount.infoRequiredNotificationCount}}</b> <b ng-if=\"subItem.name ===\'Settled Claims\' && getCmsUserCheck() ===false\" style=\"color: #000000;\" ng-class=\"notifyCount.paymentNotificationCount > 0 ? \'badge bg-success pull-right\' : \'badge-zero bg-success pull-right\'\">{{notifyCount.paymentNotificationCount}}</b> <b ng-if=\"subItem.name ===\'Denied Claims\'&& getCmsUserCheck() ===false\" style=\"color: #000000;\" ng-class=\"notifyCount.deniedNotificationCount > 0 ? \'badge bg-success pull-right\' : \'badge-zero bg-success pull-right\'\">{{notifyCount.deniedNotificationCount}}</b> <span class=\"leftMenuText\">{{subItem.name}}</span></a></li></ul><ul class=\"nav lt\" ng-if=\"menu.fId === 9216\"><li class=\"subMenuText\" ng-repeat=\"subItem in menu.profileMenu track by $index\"><a ng-click=\"changeHospitalUrl(subItem.href)\" class=\"active\"><i class=\"{{subItem.icone}}\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">{{subItem.name}}</span></a></li></ul><ul class=\"nav lt\" ng-if=\"menu.fId === 9221\"><li class=\"subMenuText\" ng-repeat=\"subItem in menu.profileMenu track by $index\"><a ng-click=\"changeHospitalUrl(subItem.href)\" class=\"active\"><i class=\"{{subItem.icone}}\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">{{subItem.name}}</span></a></li></ul><ul class=\"nav lt\"><li class=\"subMenuText\" ng-repeat=\"subItem in menu.profileMenu track by $index\"><a ng-click=\"changeHospitalUrl(subItem.href)\" class=\"active\" ng-hide=\"subItem.name === \'Rooms Details\' && user.entityType && user.entityType === \'DC\' || subItem.name === \'Payer Configuration\' && user.entityType && user.entityType === \'DC\'\"><i class=\"{{subItem.icone}}\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">{{subItem.name}}</span></a></li></ul></li><li class=\"onmouseover plusMenuCor\" ng-if=\"checkPlusPaymentFeature() && !checkIfDcDashboard()\"><a style=\"margin-left: 28px;\"><i class=\"fa fa-inr\" style=\"margin-left: -42px;\"><b class=\"bg-color6\"></b></i> <span class=\"pull-right\" style=\"color: white;\"><i class=\"fa fa-angle-down text\" style=\"color: white;\"></i> <i class=\"fa fa-angle-up text-active\" style=\"color: white;\"></i></span> <span class=\"leftMenuText\">Finance</span></a><ul class=\"nav lt\"><li ng-repeat=\"menu in plusPaymentFeatureToLoad track by $index\" class=\"subMenuText\"><a ng-click=\"changePlusView(menu.href)\"><i class=\"{{menu.icon}}\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">{{menu.menuItem}}</span></a></li></ul></li><li class=\"onmouseover plusMenuCor\" ng-repeat=\"menu in plusFeaturesToLoad track by $index\"><a ng-click=\"changePlusView(menu.href)\"><i class=\"{{menu.icon}}\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">{{menu.menuItem}}</span></a></li><li class=\"onmouseover plusMenuCor\" ng-repeat=\"menu in networkFeaturesToLoad track by $index\"><a ng-click=\"changePlusView(menu.href)\"><i class=\"{{menu.icon}}\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">{{menu.menuItem}}</span></a></li><li class=\"onmouseover plusMenuCor\" ng-repeat=\"menu in hospFeatureNotificationToLoad1 track by $index\"><a ng-click=\"changePlusView(menu.href)\"><i class=\"{{menu.icon}}\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">{{menu.menuItem}}</span></a><ul class=\"nav lt\"><li class=\"subMenuText\" ng-repeat=\"subItem in menu.profileMenu track by $index\"><a ng-click=\"changeHospitalUrl(subItem.href)\" class=\"active\"><i class=\"{{subItem.icone}}\"></i> <span class=\"leftMenuText\">{{subItem.name}}</span></a></li></ul></li><li class=\"onmouseover plusMenuCor\"><a ng-click=\"changePlusView(\'/inbox\')\"><i class=\"fa fa-envelope\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">Mailbox</span></a></li><li class=\"onmouseover plusMenuCor\" ng-if=\"showOrderPunching\"><a ng-click=\"changePlusView(\'/orderPunching\')\"><i class=\"fa fa-plus\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">Create Order</span></a></li><li class=\"onmouseover plusMenuCor\" ng-if=\"checkForInsurerAdmin()\"><a ng-click=\"createAppointment()\"><i class=\"fa fa-plus\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">Create Appointment</span></a></li><li class=\"onmouseover plusMenuCor\" ng-if=\"checkForInsurerHead()\"><a ng-click=\"viewDcDocuments()\"><i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">Provider Documents</span></a></li><li class=\"onmouseover plusMenuCor\" ng-if=\"fuserUpsellEnabled\"><a ng-click=\"changePlusView(\'/fuserUpsell\')\"><i class=\"fa fa-flask\"><b class=\"bg-color6\"></b></i> <span class=\"leftMenuText\">Fuser Upsell</span></a></li></ul><div style=\"text-align: center;position: absolute; line-height: 1;bottom: 0; width: 100%;padding: 10px;\" ng-if=\"displayOldToNewLeftNav\"><div style=\"color: #fff;\"><p>We Have New Improved</p><p>Portal for Labs</p></div><div><a href=\"{{\'https://labwise-stage.medibuddy.in/#/login/V2/\' + user.accessToken + \'/\' + user.providerId + \'/\' + user.userName }}\" ng-click=\"oldToNewLeftNav\"><button type=\"button\" class=\"btn btn-light\" style=\"color: #2678f2; border-radius: 25px;\">Try New Portal</button></a></div></div><div class=\"redirect-panel\"><div class=\"redirect-content\"><p class=\"redirect-title\">🚀 Use the new portal for any actions</p><p class=\"redirect-subtitle\">Enhanced experience for Labs</p><a href=\"https://provider-central.medibuddy.in/#/login\" class=\"redirect-button\">Switch to New Portal <span class=\"icon-new\">→</span></a></div></div></aside>");
$templateCache.put("app/components/modals/message.html","<div class=\"modal fade\" id=\"myModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\" ng-style=\"{\'background-color\':background}\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"show=!show\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">{{header}}</h4></div><div class=\"modal-body\">{{body}}</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"show=!show\">Close</button></div></div></div></div>");
$templateCache.put("app/components/modals/modal.html","<div class=\"ng-modal\" ng-show=\"show\"><div><div class=\"ng-modal-overlay\" ng-click=\"hideModal()\"></div><div class=\"ng-modal-dialog\" ng-style=\"dialogStyle\"><div class=\"ng-modal-close\" ng-click=\"hideModal()\">X</div><div class=\"ng-modal-dialog-content\" ng-transclude=\"\"></div></div></div></div>");
$templateCache.put("app/components/hospAction/hospAction.html","<style type=\"text/css\">\n  .procedureBillTbl .form-control,\n  .procedureBillTbl .btn {\n    padding: 2px 10px;\n    height: 26px;\n    line-height: 21px;\n    font-size: 12px;\n  }\n\n</style><div><button class=\"btn btn-warning\" ng-show=\"dataobj.claimDetails.claimStatus == \'Information Awaited\'\" ng-click=\"modalRenderingMethods.openIrModal()\">Submit Missing Documents</button> <button ng-hide=\"dataobj.claimDetails.claimStatus==\'Raised enhancement\'||dataobj.claimDetails.claimStatus==\'Enhancement In Progress\'||dataobj.claimDetails.claimStatus == \'Pre-Auth Received\'||dataobj.claimDetails.claimStatus == \'Information Awaited\' || dataobj.claimDetails.claimstatusid == 37 || dataobj.claimDetails.claimstatusid == 47\" class=\"btn btn-warning\" ng-click=\"modalRenderingMethods.openEnhanceModal()\">Raise Enhancement</button><button type=\"button\" ng-if=\"dataobj.claimDetails.claimStatus!=\'Enhancement Denied\'\" class=\"btn btn-success\" ng-click=\"modalRenderingMethods.openDischargeModal()\">Submit Discharge Documents</button></div><div class=\"modal fade\" id=\"enhanceModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4>Raise Enhancement</h4></div><div class=\"modal-body\"><div class=\"modal-body\" id=\"enhanceFormBody\" ng-show=\"!esubmitted\"><form name=\"enhancementForm\" novalidate=\"\"><small id=\"ePaApproved\" class=\"pull-right\">{{dataobj.patientDetails.patientName}}</small><h4>Previously approved amount: Rs. <span id=\"ePaApproved\">{{dataobj.claimDetails.clmAmount}}</span>/-</h4><hr><input type=\"hidden\" value=\"\" name=\"claimId\" id=\"eClaimId\"> <input type=\"hidden\" value=\"{{hospId}}\" name=\"hospId\" id=\"eHospId\"> <input type=\"hidden\" value=\"{{user.userId}}\" name=\"updatedBy\" id=\"raiseUpdatedBy\"> <input type=\"hidden\" value=\"enhance\" name=\"ClaimAction\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Is death case ?</label><div class=\"btn-group\" data-toggle=\"buttons\" style=\"display:block\"><label ng-class=\"enhance.isDeathCase==\'true\'?\'btn btn-success disabled\':\'btn btn-success\'\"><input type=\"radio\" value=\"true\" checked=\"\" autocomplete=\"off\" name=\"rdopendingDoc\" ng-model=\"enhance.isDeathCase\"> Yes</label> <label ng-class=\"enhance.isDeathCase==\'false\'?\'btn btn-danger disabled\':\'btn btn-danger\'\"><input type=\"radio\" value=\"false\" checked=\"\" autocomplete=\"off\" name=\"rdopendingDoc\" ng-model=\"enhance.isDeathCase\"> No</label></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"enhance-amount\">Enter the enhancement amount *</label> <input type=\"number\" placeholder=\"Enter the enhancement amount\" name=\"enhance-amount\" class=\"form-control\" ng-model=\"enhance.amount\" id=\"enhancedAmount\" min=\"1\" required=\"\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"InPatient\" ng-if=\"isEBill\">In-Patient number *</label> <a ng-if=\"isEBill\" tooltip-placement=\"top\" uib-tooltip=\"Now we have direct integration with your hospital for electronic bills. Request you to enter IP number & UID of the patient which would assure faster discharge process as we can get other details electronically. In case there is an issue please route the call to head of operation in your hospital.\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input ng-if=\"isEBill\" type=\"text\" name=\"InPatient\" class=\"form-control\" ng-model=\"enhance.patientIPNumber\" ng-required=\"isEBill\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label ng-if=\"isEBill\" for=\"uhid\">Unique hospital id *</label> <a ng-if=\"isEBill\" tooltip-placement=\"top\" uib-tooltip=\"Now we have direct integration with your hospital for electronic bills. Request you to enter IP number & UID of the patient which would assure faster discharge process as we can get other details electronically. In case there is an issue please route the call to head of operation in your hospital.\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input ng-if=\"isEBill\" type=\"text\" placeholder=\"Enter Unique hospital id\" name=\"uhid\" class=\"form-control\" ng-model=\"enhance.uidno\" ng-required=\"isEBill\"></div></div><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"enhance-remarks\">Notes for enhancements</label> <textarea placeholder=\"Enter notes for enhancements\" name=\"enhance-remarks\" class=\"form-control\" id=\"enhance-remarks\" cols=\"30\" ng-model=\"enhance.remarks\" rows=\"5\"></textarea></div></div></div><hr><h4>Related attachments</h4><br><div style=\"margin-top: -20px;margin-bottom: 10px;\"><a ng-if=\"!isPPN()\" style=\"font-size: initial;\" ng-click=\"downloadPPNFile()\"><i class=\"fa fa-download\"></i> NETWORK HOSPITAL - DECLARATION BY PATIENT/PATIENT’S ATTENDANT</a> <a ng-if=\"isPPN()\" style=\"font-size: initial;\" ng-click=\"downloadNonPPNFile()\"><i class=\"fa fa-download\"></i> PPN NETWORK - DECLARATION BY PATIENT/PATIENT’S ATTENDANT</a></div><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></fieldset><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button></div><br><hr><a ng-hide=\"btnSubmitflag\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"btnSubmitflag = true;enhancementRelatedMethods.submitEnhance()\" ng-disabled=\"enhancementForm.$invalid\">Enhance</a> <a ng-show=\"btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\" ng-click=\"$parent.hideModal()\">Cancel</button></form></div><div class=\"modal-body\" ng-show=\"esubmitted\"><p ng-show=\"esubsuccess\">Your enhancement request has been submitted successfully.</p><p ng-show=\"!esubsuccess\">Something went wrong! Enhancement request is not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"esubmitted=false;modalRenderingMethods.close()\">Close</button></div></div></div></div></div><div class=\"modal fade\" id=\"claimbillhospdata\" tabindex=\"-1\" z-index=\"100000\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"modal-body\" ng-show=\"myData && myData.length>0\"><table class=\"table table-bordered\"><tr><th>Hosp Category</th><th>Bill No</th><th>Bill Amount</th></tr><tr ng-repeat=\"list in myData\"><td>{{list.hospChargeHead}}</td><td>{{list.billNo}}</td><td>{{list.billAmount}}</td></tr></table></div></div></div></div><script type=\"text/ng-template\" id=\"templateId\"><h4>Item Details</h4> <table class=\"table table-bordered\"> <tr> <th> Hosp Category </th> <th> Bill No </th> <th>Bill Amount</th> </tr> <tr ng-repeat=\"list in myData\"> <td>{{list.hospChargeHead}}</td> <td>{{list.billNo}}</td> <td>{{list.billAmount}}</td> </tr> </table></script><script type=\"text/ng-template\" id=\"DiscountRemarks\">{{csvBillDiscountRemarks}}</script><div class=\"modal fade\" id=\"dischargeModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" style=\"width:auto\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><div class=\"pull-right\"><a ng-if=\"!isPPN()\" style=\"font-size: initial;\" ng-click=\"downloadPPNFile()\"><i class=\"fa fa-download\"></i> Download network hospitals</a> <a ng-if=\"isPPN()\" style=\"font-size: initial;\" ng-click=\"downloadNonPPNFile()\"><i class=\"fa fa-download\"></i> Download PPN hospitals</a></div><h4>Submit Final Discharge</h4></div><div><div class=\"modal-body\" id=\"finalDischargeBody\" ng-show=\"!dsubmitted\"><form name=\"dischargeForm\" novalidate=\"\"><input type=\"hidden\" value=\"\" name=\"claimId\" id=\"dClaimId\"> <input type=\"hidden\" value=\"{{hospId}}\" name=\"hospId\"> <input type=\"hidden\" value=\"{{user.userId}}\" name=\"updatedBy\"> <input type=\"hidden\" value=\"discharge\" name=\"ClaimAction\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"radio-inline\"><input type=\"radio\" name=\"optr\" ng-model=\"optrDischarge\" value=\"packaged\" ng-click=\"dischargeRelatedMethods.clearDischargeTotal(\'packaged\')\"> Packaged</label> <label class=\"radio-inline\"><input ng-init=\"optrDischarge=\'nonpackaged\'\" type=\"radio\" name=\"optr\" ng-model=\"optrDischarge\" value=\"nonpackaged\" ng-click=\"dischargeRelatedMethods.clearDischargeTotal(\'nonpackaged\')\"> Non-Packaged</label></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label>Is death case ?</label><div class=\"btn-group\" data-toggle=\"buttons\" style=\"display:block\"><label ng-class=\"discharge.isDeathCase==\'true\'?\'btn btn-success disabled\':\'btn btn-success\'\"><input type=\"radio\" value=\"true\" checked=\"\" autocomplete=\"off\" name=\"rdopendingDoc\" ng-model=\"discharge.isDeathCase\"> Yes</label> <label ng-class=\"discharge.isDeathCase==\'false\'?\'btn btn-danger disabled\':\'btn btn-danger\'\"><input type=\"radio\" value=\"false\" checked=\"\" autocomplete=\"off\" name=\"rdopendingDoc\" ng-model=\"discharge.isDeathCase\"> No</label></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Date Of Admission</label> <input name=\"doa\" id=\"datetimepickerDoa\" type=\"date\" class=\"form-control\" ng-model=\"discharge.doa\" required=\"\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Date Of Discharge</label> <input name=\"dod\" id=\"datetimepicker1\" type=\"date\" class=\"form-control\" ng-model=\"discharge.dod\" required=\"\"></div></div></div><div class=\"row\" ng-if=\"optrDischarge ==\'nonpackaged\'\"><div class=\"col-md-3\"><div class=\"form-group\"><label>Room Rent Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Includes Room rent, ICU Charges, Nursing charges, Duty Doctor fee, Monitor charges\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"number\" ng-model=\"discharge.roomrent\" name=\"roomrent\" class=\"form-control\" placeholder=\"Enter Roomrent\" ng-required=\"true\" ng-keyup=\"dischargeRelatedMethods.calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.roomrent.$dirty && dischargeForm.roomrent.$error.required\">Required</span></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Diagnostic Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Includes charges from Bio Chemistry, Haematology, Microbiology, Neurology, Pathology, Radiology\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"number\" ng-model=\"discharge.investigation\" name=\"investigation\" class=\"form-control\" placeholder=\"Enter Investigation\" ng-required=\"true\" ng-keyup=\"dischargeRelatedMethods.calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.investigation.$dirty && dischargeForm.investigation.$error.required\">Required</span></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Professional Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Incudes Procedure charges, Surgeon charges, Anaesthetist charges, Visit charges, OT rent, OT equipment charges, OT Drugs & Consumables\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"number\" ng-model=\"discharge.consultation\" name=\"consultation\" class=\"form-control\" placeholder=\"Enter Consultation\" ng-required=\"true\" ng-keyup=\"dischargeRelatedMethods.calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.consultation.$dirty && dischargeForm.consultation.$error.required\">Required</span></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Pharmacy Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Includes Pharmacy charges and consumables\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"number\" ng-model=\"discharge.pharmacy\" name=\"pharmacy\" class=\"form-control\" placeholder=\"Enter Pharmacy\" ng-required=\"true\" ng-keyup=\"dischargeRelatedMethods.calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.pharmacy.$dirty && dischargeForm.pharmacy.$error.required\">Required</span></div></div></div><div class=\"row\"><div class=\"col-md-3\" ng-if=\"optrDischarge ==\'packaged\'\"><div class=\"form-group\"><label>Package Name</label> <input type=\"text\" ng-model=\"discharge.pkgname\" name=\"pkgname\" class=\"form-control\" placeholder=\"Enter Package Name\" ng-required=\"optrDischarge ==\'packaged\'\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.pkgname.$dirty && dischargeForm.pkgname.$error.required\">Required</span></div></div><div class=\"col-md-3\" ng-if=\"optrDischarge ==\'packaged\'\"><div class=\"form-group\"><label>Package Cost</label> <input type=\"number\" ng-model=\"discharge.pkgcost\" name=\"pkgcost\" class=\"form-control\" placeholder=\"Enter Package Cost\" ng-required=\"optrDischarge ==\'packaged\'\" ng-keyup=\"dischargeRelatedMethods.calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.pkgcost.$dirty && dischargeForm.pkgcost.$error.required\">Required</span></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Other Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Includes Implant charges, Non-Medical Expenses, other charges\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"number\" ng-model=\"discharge.others\" name=\"others\" class=\"form-control\" placeholder=\"Others\" ng-keyup=\"dischargeRelatedMethods.calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.pharmacy.$dirty && dischargeForm.pharmacy.$error.required\">Required</span></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Final Claimed Amount</label> <input ng-init=\"discharge.total=0\" ng-class=\"{\'border-warning\':(discharge.total <= 0 || discharge.total == null)}\" name=\"dischargeTotal\" class=\"form-control\" type=\"text\" ng-model=\"discharge.total\" readonly=\"\"> <span ng-show=\"(discharge.total <= 0 || discharge.total == null)\"><small><em>Final bill cannot be 0 . Please enter a value in any of above fields.</em></small></span></div></div><div class=\"col-md-3\" ng-show=\"optrDischarge ==\'nonpackaged\'\"><div class=\"form-group\"><label>Discount</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"dischargeBillDiscount\" placeholder=\"Discount\"></div></div></div><div class=\"col-md-3\" ng-show=\"optrDischarge ==\'nonpackaged\'\"><div class=\"form-group\"><label>Discount Remarks</label> <textarea name=\"discountRemarks\" class=\"form-control\" placeholder=\"Discount Remarks\" id=\"discountRemarks\" cols=\"20\" rows=\"2\" ng-model=\"dischargeBillDiscountRemarks\"></textarea></div></div></div></div></div><div class=\"row\"><div class=\"col-md-3\" ng-if=\"isEBill\"><div class=\"form-group\"><label ng-if=\"isEBill\">In-Patient number *</label> <a tooltip-placement=\"top\" uib-tooltip=\"Now we have direct integration with your hospital for electronic bills. Request you to enter IP number & UID of the patient which would assure faster discharge process as we can get other details electronically. In case there is an issue please route the call to head of operation in your hospital.\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input ng-if=\"isEBill\" type=\"text\" name=\"InPatient\" class=\"form-control\" ng-model=\"discharge.patientIPNumber\" ng-required=\"isEBill\"></div></div><div class=\"col-md-3\" ng-if=\"isEBill\"><div class=\"form-group\"><label ng-if=\"isEBill\">Unique hospital id *</label> <a tooltip-placement=\"top\" uib-tooltip=\"Now we have direct integration with your hospital for electronic bills. Request you to enter IP number & UID of the patient which would assure faster discharge process as we can get other details electronically. In case there is an issue please route the call to head of operation in your hospital.\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input ng-if=\"isEBill\" type=\"text\" name=\"uhid\" class=\"form-control\" ng-model=\"discharge.uidno\" ng-required=\"isEBill\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"enhance-remarks\">Notes for discharge (optional)</label> <textarea placeholder=\"Enter notes for discharge\" name=\"enhance-remarks\" ng-model=\"discharge.remarks\" class=\"form-control\" id=\"discharge-remarks\" cols=\"30\" rows=\"3\"></textarea></div></div><div class=\"col-md-3\"><div class=\"form-group\"><p><strong>Attach Final Bill & Discharge Summary</strong> <button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> Add more files</button></p><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"row\"><div class=\"col-sm-10\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-click=\"removeFileToUpload()\">-</button></div></div></fieldset></div></div></div><a ng-disabled=\"((isEBill && !discharge.patientIPNumber) || (isEBill && !discharge.uidno)) || (discharge.total <= 0 || discharge.total == null) || dischargeForm.$invalid || (!file || (file && file.length==0))\" ng-hide=\"btnSubmitflag\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"btnSubmitflag = true;dischargeRelatedMethods.submitDischarge()\">Submit</a> <a ng-show=\"btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\" ng-click=\"$parent.hideModal()\">Cancel</button></form></div><div class=\"modal-body\" ng-show=\"dsubmitted\"><p ng-show=\"dsubsuccess\">Your discharge documents have been submitted successfully.</p><p ng-show=\"!dsubsuccess\">Something went wrong! Your discharge summary is not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"dsubmitted=false;modalRenderingMethods.close()\">Close</button></div></div></div></div></div><div class=\"modal fade\" id=\"{{modelPopup.text}}\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" style=\"width:auto\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <button type=\"button\" style=\"margin-right:20px;\" class=\"btn btn-primary btn-xs pull-right\" ng-click=\"getPrefilledBills(dataobj.claimId)\">Get Prefilled Bills</button><h4>Raise Enhancement for {{dataobj.patientDetails.patientName}} on Previous claim amount Rs. <span id=\"ePaApproved\">{{dataobj.claimDetails.clmAmount}}</span>/-</h4><p style=\"margin-top:0; font-size:11px;\">Upload Final bill in .csv file for auto tabulation of bill categories.</p></div><div><div class=\"modal-body\"><form name=\"dischargeSub\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-8\"><div class=\"clearfix\"><label for=\"approxClaimedAmnt\">Update treatment details *</label><mb-claim-typeahead items=\"mappedpackages\" prompt=\"Start typing procedure name...\" ng-model=\"hospNewName\" removeitem=\"removeData\" selecteditems=\"selectedMappedpackages\" callback-fn=\"ctrlFn(arg)\"></mb-claim-typeahead></div><div class=\"row\" style=\"margin-bottom:15px;margin-top:15px;\"><div class=\"col-sm-3\"><label for=\"uploadCsvFile\">Upload Csv Bill :</label></div><div class=\"col-sm-9\"><input type=\"file\" name=\"uploadCsvFile\" file-model=\"billCsvFile\" custom-on-change=\"UploadCsvBill\"></div></div><table class=\"table table-condensed procedureBillTbl\" style=\"margin-top:15px;\"><tr><th class=\"claimId\" colspan=\"2\">Bill Categories <span style=\"color: red; font-size: small\">*</span></th><th class=\"claimedAmount\" style=\"width:150px;\">Price <span style=\"color: red; font-size: small\">*</span></th><th class=\"claimedAmount\" style=\"width:100px;\">Action</th></tr><tr ng-repeat=\"item in availableBills track by $index | orderBy : \'hospitalBillDesc\'\"><td><span style=\"margin-left:-10px\">{{$index+1}}</span> <input ng-if=\"!item.isReadOnly\" style=\"margin-left: 8px; margin-top: -20px;\" type=\"text\" ng-model=\"item.hospitalBillDesc\" placeholder=\"Enter categorie name\" class=\"form-control\"> <span ng-if=\"item.isReadOnly\">{{item.hospitalBillDesc}}</span></td><td><button ng-if=\"item.hospData && item.hospData.length>0\" type=\"button\" title=\"View Details\" class=\"btn btn-xs\" ng-click=\"modalRenderingMethods.openClaimBillHospDataModal(item.hospData)\"><i class=\"fa fa-eye\"></i></button></td><td><input ng-disabled=\"item.isPackage\" type=\"text\" numbers-only=\"numbers-only\" ng-model=\"item.CLAIMED_AMOUNT\" ng-change=\"calculateTotalAmount()\" placeholder=\"Enter price\" class=\"form-control\"></td><td><button class=\"btn btn-danger btn-sm\" ng-click=\"removeCategories(item)\">Remove</button></td></tr><tr ng-if=\"isNewCategories || !availableBills || availableBills.length==0\"><td ng-if=\"!isAddPackageName\"><input name=\"categoriesName\" autocomplete=\"off\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Enter name\" ng-click=\"getkeywords()\" ng-model=\"dynamicFields.name\" ng-model-options=\"modelOptions\" uib-typeahead=\"item.hospitalBillDesc for item in typaheadData | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" ng-change=\"onChangeFunction(dynamicFields.name)\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"><p ng-if=\"isDuplicate\" style=\"margin-left: 15px; color: red; font-size> small;\">Duplicate categories is not allowed.</p></td><td ng-if=\"isAddPackageName\"><input type=\"text\" placeholder=\"Enter package name\" ng-model=\"dynamicFields.addtionalNmae\" class=\"form-control\"><p ng-if=\"isDuplicate\" style=\"margin-left: 15px; color: red; font-size> small;\">Duplicate categories is not allowed.</p></td><td></td><td><input type=\"text\" numbers-only=\"numbers-only\" ng-maxlength=\"20\" placeholder=\"Enter price\" ng-model=\"dynamicFields.price\" class=\"form-control\"></td><td colspan=\"4\"><button ng-disabled=\"!dynamicFields.name ||!dynamicFields.price\" ng-click=\"addMoreCategories(true, dynamicFields, selectedObject)\" class=\"btn btn-primary\">Add</button> <button ng-click=\"closeButton()\" class=\"btn btn-danger\">X</button></td></tr><tr ng-if=\"!isNewCategories\"><td></td><td></td><td></td><td><button ng-click=\"AddNewBill()\" class=\"btn btn-primary\">Add Bill</button></td></tr><tr ng-if=\"availableBills.length >0\"><td class=\"text-right\" colspan=\"2\"><b>Total Bill :</b></td><td class=\"text-right\"><input type=\"number\" class=\"form-control\" placeholder=\"Enter total bill amount\" ng-model=\"totalAmountForVerification\"></td><td><span class=\"text-success\" ng-if=\"totalAmountForVerification>=CLAIMED_AMOUNT-5 && totalAmountForVerification=<CLAIMED_AMOUNT+5\"><i class=\"fa fa-check-circle\">Correct</i></span> <span class=\"text-danger\" ng-if=\"totalAmountForVerification<CLAIMED_AMOUNT-5 || totalAmountForVerification>CLAIMED_AMOUNT+5\"><i class=\"fa fa-times-circle\">Mismatch</i></span></td></tr><tr ng-show=\"availableBills.length >0\"><td class=\"text-right\" colspan=\"2\"><b>Discount:</b></td><td class=\"text-right\"><input type=\"number\" class=\"form-control\" ng-model=\"csvBillDiscount\"></td><td><button ng-if=\"csvBillDiscount>0\" type=\"button\" title=\"View Details\" class=\"btn btn-xs\" ng-click=\"modalRenderingMethods.openDiscounRemarks()\"><i class=\"fa fa-eye\"></i></button> <button ng-if=\"csvBillDiscount>0\" type=\"button\" title=\"View Details\" class=\"btn btn-xs\" ng-click=\"showDiscountEdit()\"><i class=\"fa fa-edit\"></i></button></td></tr><tr ng-show=\"availableBills.length > 0\"><td class=\"text-right\" colspan=\"2\"><b>Total :</b></td><td><span>{{CLAIMED_AMOUNT-csvBillDiscount}}</span></td><td></td></tr></table><div class=\"form-group\" ng-if=\"(item.hospitalDiscount>0 || csvBillDiscount>0) && editDiscount\"><label for=\"csvBillDiscountRemarks\">Discount remarks:</label> <textarea name=\"csvBillDiscountRemarks\" cols=\"10\" rows=\"2\" ng-model=\"csvBillDiscountRemarks\" class=\"form-control\"></textarea></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"InPatient\" ng-if=\"isEBill\">In-Patient number *</label> <a ng-if=\"isEBill\" tooltip-placement=\"top\" uib-tooltip=\"Now we have direct integration with your hospital for electronic bills. Request you to enter IP number & UID of the patient which would assure faster discharge process as we can get other details electronically. In case there is an issue please route the call to head of operation in your hospital.\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input ng-if=\"isEBill\" placeholder=\"Enter in-Patient number\" type=\"text\" name=\"InPatient\" class=\"form-control\" ng-model=\"enhance.patientIPNumber\" ng-required=\"isEBill\"></div><div class=\"form-group\"><label ng-if=\"isEBill\" for=\"uhid\">Unique hospital id *</label> <a ng-if=\"isEBill\" tooltip-placement=\"top\" uib-tooltip=\"Now we have direct integration with your hospital for electronic bills. Request you to enter IP number & UID of the patient which would assure faster discharge process as we can get other details electronically. In case there is an issue please route the call to head of operation in your hospital.\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input ng-if=\"isEBill\" type=\"text\" placeholder=\"Enter unique hospital id\" name=\"uhid\" class=\"form-control\" ng-model=\"enhance.uidno\" ng-required=\"isEBill\"></div><div class=\"form-group\"><label for=\"enhance-remarks\">Notes for enhancements</label> <textarea placeholder=\"Enter notes for enhancements\" name=\"enhance-remarks\" ng-model=\"enhance.remarks\" class=\"form-control\" id=\"discharge-remarks\" cols=\"30\" rows=\"4\"></textarea></div><h4 style=\"color: black;\"><button class=\"btn btn-xs btn-primary pull-right\" ng-click=\"addFileToUpload()\">Add</button> Related attachments</h4><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"row\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></div></fieldset></div></div><hr><div class=\"clearfix\"><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\" ng-click=\"$parent.hideModal(); closeModel()\">Cancel</button> <button id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"submitEnhanceDetails()\">Submit</button></div></form></div><div class=\"modal-body\" ng-show=\"dsubmitted\"><p ng-show=\"dsubsuccess\">Your discharge documents have been submitted successfully.</p><p ng-show=\"!dsubsuccess\">Something went wrong! Your discharge summary is not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"close()\">Close</button></div></div></div></div></div><div class=\"modal fade\" id=\"{{modelPopup.text1}}\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" style=\"width:auto\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><div class=\"pull-right\"><a ng-if=\"!isPPN()\" style=\"font-size: initial;\" ng-click=\"downloadPPNFile()\"><i class=\"fa fa-download\"></i> Download network hospitals</a> <a ng-if=\"isPPN()\" style=\"font-size: initial;\" ng-click=\"downloadNonPPNFile()\"><i class=\"fa fa-download\"></i> Download PPN hospitals</a> <button type=\"button\" style=\"margin-left:15px;\" class=\"btn btn-primary btn-xs pull-right\" ng-click=\"getPrefilledBills(dataobj.claimId)\">Get Prefilled Bills</button></div><h4>Submit Final Discharge</h4><p style=\"margin:0;\">Upload Final bill in .csv file for auto tabulation of bill categories.</p></div><div><div class=\"modal-body\"><form name=\"dischargeSub\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label for=\"approxClaimedAmnt\">Update treatment details *</label><mb-claim-typeahead items=\"mappedpackages\" prompt=\"Start typing procedure name...\" ng-model=\"hospNewName\" removeitem=\"removeData\" selecteditems=\"selectedMappedpackages\" callback-fn=\"ctrlFn(arg)\"></mb-claim-typeahead></div><div class=\"row\" style=\"margin-bottom:15px;margin-top:15px;\"><div class=\"col-sm-3\"><label for=\"uploadCsvFile\">Upload Csv Bill :</label></div><div class=\"col-sm-9\"><input type=\"file\" name=\"uploadCsvFile\" file-model=\"billCsvFile\" custom-on-change=\"UploadCsvBill\"></div></div><table class=\"table table-condensed procedureBillTbl\"><tr><th colspan=\"2\" class=\"claimId\">Bill Categories <span style=\"color: red; font-size: small\">*</span></th><th class=\"claimedAmount\" style=\"width:150px;\">Price <span style=\"color: red; font-size: small\">*</span></th><th class=\"claimedAmount\" style=\"width:100px;\">Action</th></tr><tr ng-repeat=\"item in availableBills track by $index | orderBy : \'hospitalBillDesc\'\"><td><span style=\"margin-left:-10px\">{{$index+1}}</span> <input ng-disabled=\"item.isReadOnly\" style=\"margin-left: 8px; margin-top: -20px;\" type=\"text\" ng-model=\"item.hospitalBillDesc\" placeholder=\"Enter categorie name\" class=\"form-control\"></td><td><button ng-if=\"item.hospData && item.hospData.length>0\" type=\"button\" title=\"View Details\" class=\"btn btn-xs\" ng-click=\"modalRenderingMethods.openClaimBillHospDataModal(item.hospData)\"><i class=\"fa fa-eye\"></i></button></td><td><input type=\"text\" ng-disabled=\"item.isPackage\" numbers-only=\"numbers-only\" ng-model=\"item.CLAIMED_AMOUNT\" ng-change=\"calculateTotalAmount()\" placeholder=\"Enter price\" class=\"form-control\"></td><td><button class=\"btn btn-danger btn-sm\" ng-click=\"removeCategories(item)\">Remove</button></td></tr><tr ng-if=\"isNewCategories || !availableBills || availableBills.length==0\"><td><input name=\"categoriesName\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" required=\"\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Enter name\" ng-click=\"getkeywords()\" ng-model=\"dynamicFields.name\" uib-typeahead=\"item.hospitalBillDesc for item in typaheadData | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" ng-change=\"onChangeFunction(dynamicFields.name)\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"> <input type=\"text\" placeholder=\"Enter package name\" ng-model=\"dynamicFields.addtionalNmae\" class=\"form-control\" ng-if=\"isAddPackageName\"><p ng-if=\"isDuplicate\" style=\"margin-left: 15px; color: red; font-size> small;\">Duplicate categories is not allowed.</p></td><td></td><td><input type=\"text\" numbers-only=\"numbers-only\" ng-maxlength=\"20\" placeholder=\"Enter price\" ng-model=\"dynamicFields.price\" class=\"form-control\"></td><td><button ng-disabled=\"!dynamicFields.name ||!dynamicFields.price\" ng-click=\"addMoreCategories(true, dynamicFields, selectedObject)\" class=\"btn btn-primary\">Add</button> <button ng-click=\"closeButton()\" class=\"btn btn-danger\">X</button></td></tr><tr ng-if=\"!isNewCategories\"><td></td><td></td><td></td><td><button ng-click=\"AddNewBill()\" class=\"btn btn-primary\">Add Bill</button></td></tr><tr ng-show=\"availableBills.length >0\"><td class=\"text-right\" colspan=\"2\"><b>Total Bill :</b></td><td class=\"text-right\"><input type=\"number\" class=\"form-control\" placeholder=\"Enter total bill amount\" ng-model=\"totalAmountForVerification\"></td><td><span class=\"text-success\" ng-if=\"totalAmountForVerification>=CLAIMED_AMOUNT-5 &&totalAmountForVerification<=CLAIMED_AMOUNT+5\"><i class=\"fa fa-check-circle\">Correct</i></span> <span class=\"text-danger\" ng-if=\"totalAmountForVerification<CLAIMED_AMOUNT-5 || totalAmountForVerification>CLAIMED_AMOUNT+5\"><i class=\"fa fa-times-circle\">Mismatch</i></span></td></tr><tr ng-show=\"availableBills.length >0\"><td class=\"text-right\" colspan=\"2\"><b>Discount:</b></td><td class=\"text-right\"><input type=\"number\" class=\"form-control\" ng-model=\"csvBillDiscount\"></td><td><button ng-if=\"csvBillDiscount>0\" type=\"button\" title=\"View Details\" class=\"btn btn-xs\" ng-click=\"modalRenderingMethods.openDiscounRemarks()\"><i class=\"fa fa-eye\"></i></button> <button ng-if=\"csvBillDiscount>0\" type=\"button\" title=\"View Details\" class=\"btn btn-xs\" ng-click=\"showDiscountEdit()\"><i class=\"fa fa-edit\"></i></button></td></tr><tr ng-show=\"availableBills.length > 0\"><td class=\"text-right\" colspan=\"2\"><b>Total :</b></td><td><span>{{CLAIMED_AMOUNT-csvBillDiscount}}</span></td><td></td></tr></table><div class=\"form-group\" ng-if=\"(item.hospitalDiscount>0 || csvBillDiscount>0) && editDiscount\"><label for=\"csvBillDiscountRemarks\">Discount remarks:</label> <textarea name=\"csvBillDiscountRemarks\" cols=\"10\" rows=\"2\" ng-model=\"csvBillDiscountRemarks\" class=\"form-control\"></textarea></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Date Of Admission</label><div class=\"input-group\"><input id=\"datetimeFirst\" required=\"\" placeholder=\"Select date from\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"discharge.doa\" is-open=\"datePickerPopup.doa\" datepicker-options=\"dateOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\" sty=\"\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDOAPopup()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label>Date Of Discharge</label><div class=\"input-group\"><input id=\"datetimeFirst\" required=\"\" placeholder=\"Select date from\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"discharge.dod\" is-open=\"datePickerPopup.dod\" datepicker-options=\"dateOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDODPopup()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\" ng-if=\"isEBill\"><label for=\"InPatient\">In-Patient number *</label> <a tooltip-placement=\"top\" uib-tooltip=\"Now we have direct integration with your hospital for electronic bills. Request you to enter IP number & UID of the patient which would assure faster discharge process as we can get other details electronically. In case there is an issue please route the call to head of operation in your hospital.\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input placeholder=\"Enter in-Patient number\" type=\"text\" name=\"InPatient\" class=\"form-control\" ng-model=\"discharge.patientIPNumber\" ng-required=\"uidno\"></div><div class=\"form-group\" ng-if=\"isEBill\"><label for=\"uhid\">Unique hospital id *</label> <a tooltip-placement=\"top\" uib-tooltip=\"Now we have direct integration with your hospital for electronic bills. Request you to enter IP number & UID of the patient which would assure faster discharge process as we can get other details electronically. In case there is an issue please route the call to head of operation in your hospital.\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" placeholder=\"Enter unique hospital id\" name=\"uhid\" class=\"form-control\" ng-model=\"discharge.uidno\" ng-required=\"isEBill\"></div><div class=\"form-group\"><p><strong>Attach Final Bill & Discharge Summary</strong> <button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> Add more files</button></p><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"row\"><div class=\"col-sm-10\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-click=\"removeFileToUpload()\">-</button></div></div></fieldset></div></div></div><div class=\"table-responsive\" style=\"overflow-x: hidden;overflow-y: hidden;height: 100%;\"><div class=\"table table-hover\"><div class=\"row\" style=\"margin-left:5px\"></div></div></div><hr><button style=\"margin-left: 83%;\" type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\" ng-click=\"$parent.hideModal(); closeModel()\">Cancel</button> <button id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"submitDischargeDetails()\">Submit</button></form></div><div class=\"modal-body\" ng-show=\"dsubmitted\"><p ng-show=\"dsubsuccess\">Your discharge documents have been submitted successfully.</p><p ng-show=\"!dsubsuccess\">Something went wrong! Your discharge summary is not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"close()\">Close</button></div></div></div></div></div><div class=\"modal fade\" id=\"submitMissing\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Submit Missing Documents</h4></div><div class=\"modal-body\" id=\"submitFormBody\" ng-show=\"!msubmitted\"><form id=\"missingForm\"><input type=\"hidden\" value=\"\" name=\"claimId\" id=\"mClaimId\"> <input type=\"hidden\" value=\"{{hospId}}\" name=\"hospId\"> <input type=\"hidden\" value=\"{{user.userId}}\" name=\"updatedBy\"> <input type=\"hidden\" value=\"reply\" name=\"ClaimAction\"> <label for=\"enhance-remarks\">Remarks on missing documents</label> <textarea ng-model=\"ir.remarks\" name=\"enhance-remarks\" class=\"form-control\" id=\"enhance-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your comments regarding missing documents. Eg: Surgical details updated or Diagnosis details updated or Submitted missing scan bill etc.,\"></textarea><hr><div style=\"margin-top: -15px;\"><a ng-if=\"!isPPN()\" style=\"font-size: initial;\" ng-click=\"downloadPPNFile()\"><i class=\"fa fa-download\"></i> NETWORK HOSPITAL - DECLARATION BY PATIENT/PATIENT’S ATTENDANT</a> <a ng-if=\"isPPN()\" style=\"font-size: initial;\" ng-click=\"downloadNonPPNFile()\"><i class=\"fa fa-download\"></i> PPN NETWORK - DECLARATION BY PATIENT/PATIENT’S ATTENDANT</a></div><h4>Attach missing documents</h4><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></fieldset><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button></div><hr><a ng-hide=\"btnSubmitflag\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"btnSubmitflag = true;iRrelatedMethods.submitIr()\">Submit</a> <a ng-show=\"btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\">Cancel</button></form></div><div class=\"modal-body\" ng-show=\"msubmitted\"><p ng-show=\"msubsuccess\">Your missing documents have been submitted successfully.</p><p ng-show=\"!msubsuccess\">Something went wrong! Your missing documents are not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"msubmitted=false;modalRenderingMethods.close()\">Close</button></div></div></div></div><message background=\"msg.background\" body=\"msg.body\" header=\"msg.header\" show=\"msg.show\"></message>");
$templateCache.put("app/components/newAdmissionForm/cataractDataForm.html","<div class=\"row\" ng-if=\"form.diagnosisOption==\'CATARACT\'\"><div class=\"col-md-4\"><div class=\"form-group\"><label style=\"display:block;\">Cataract Type <span class=\"text-danger\">*</span></label><label class=\"radio-inline\" ng-repeat=\"obj in cataractType\" ng-if=\"obj.ageStartLimit<=form.age && obj.ageEndLimit>=form.age\"><input type=\"radio\" name=\"rdoCataractType\" ng-change=\"getTreatmentTypeForCataract(form.cataractType)\" value=\"{{obj.id}}\" ng-model=\"form.cataractType\" required=\"\">{{obj.name}}</label></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Procedure <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-model=\"form.treatmentType\" ng-change=\"pushToProperties(\'treatmentId\',form.treatmentType)\" ng-options=\"item.id as item.name for item in cataractTreatmentType\" required=\"\"><option value=\"\">Select Procedure</option></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Lens Type <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-change=\"pushToProperties(\'lenseId\',form.cataractLenseType)\" ng-model=\"form.cataractLenseType\" ng-options=\"item.id as item.name for item in cataractLenseType\" required=\"\"><option value=\"\">Select Lens Type</option></select></div></div></div>");
$templateCache.put("app/components/newAdmissionForm/genericNewAdmissionForm.html","<div class=\"chat-content\"><h4 style=\"text-align:center\"><b>{{form.tpaName}}</b></h4><div style=\"margin-bottom: -20px;text-decoration: underline;\"><a ng-if=\"!isPPN()\" style=\"font-size: initial;\" ng-click=\"downloadPPNFile()\"><i class=\"fa fa-download\"></i> NETWORK HOSPITAL - DECLARATION BY PATIENT/PATIENT’S ATTENDANT</a> <a ng-if=\"isPPN()\" style=\"font-size: initial;\" ng-click=\"downloadNonPPNFile()\"><i class=\"fa fa-download\"></i> PPN NETWORK - DECLARATION BY PATIENT/PATIENT’S ATTENDANT</a></div><ng-form id=\"myForm\" novalidate=\"\" name=\"signup_form\"><h3><button class=\"btn btn-default pull-right\" ng-if=\"source !== \'preClaim\'\" ng-click=\"searchAgain()\" style=\"margin-top:-14px;background-color: #ccc;\">Search Again</button> <button type=\"submit\" style=\"margin-top:-14px;margin-right: 5px;\" class=\"btn btn-primary pull-right\" id=\"newAdmissionButton\" ng-click=\"source==\'preClaim\'?preClaimInfoRelatedMethods.submitPreClaimPreauthForm():preauthFormAction.submitPreauthForm()\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR) || (isdod ||isdoa) || isProcessing\">Submit New Admission</button> Customer details</h3><div class=\"row\"><div class=\"col-md-4\" ng-if=\"admissionFromSearchFlag.hideSomeFields\"><div class=\"form-group\"><label for=\"patientFirstName\">Full Name <span class=\"text-danger\">*</span> <span class=\"textErrorMsg\" ng-show=\"signup_form.patientFirstName.$dirty && signup_form.patientFirstName.$invalid\">Your name is required.</span></label> <input name=\"patientFirstName\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Patient full name\" ng-model=\"form.fullname\" ng-disabled=\"{{isDataPrefilled}}\" required=\"\"></div></div><div class=\"col-md-4\" ng-if=\"govReadonly()\"><div class=\"form-group\"><label for=\"patientFirstName\">Full Name <span class=\"text-danger\">*</span> <span class=\"textErrorMsg\" ng-show=\"signup_form.patientFirstName.$dirty && signup_form.patientFirstName.$invalid\">Your name is required.</span></label> <input name=\"patientFirstName\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Patient full name\" ng-model=\"form.fullname\" ng-disabled=\"{{isDataPrefilled}}\" required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"contactNum\">Mobile Number <span class=\"text-danger\">*</span> <span class=\"textErrorMsg\" ng-show=\"signup_form.contactNum.$error.pattern || (signup_form.contactNum.$dirty && signup_form.contactNum.$invalid) || signup_form.contactNum.$error.number || signup_form.contactNum.$error.minlength || signup_form.contactNum.$error.maxlength\">Enter valid mobile number</span></label> <input name=\"contactNum\" autocomplete=\"off\" type=\"text\" class=\"form-control\" ng-pattern=\"/^((7|8|9)).{9}$/\" ng-change=\"mobileValidation(form.mobile)\" numbers-only=\"numbers-only\" placeholder=\"Enter mobile number\" ng-model=\"form.mobile\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"emailId\">Email Id <span class=\"textErrorMsg\" ng-show=\"signup_form.EmailId.$error.pattern || (signup_form.EmailId.$dirty && signup_form.EmailId.$invalid)\">Enter valid email Id</span></label> <input name=\"EmailId\" autocomplete=\"off\" type=\"text\" class=\"form-control\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" placeholder=\"Enter Email-Id\" ng-model=\"form.emailId\"></div></div><div class=\"col-md-4\" ng-if=\"form.isgovtscheme\"><div class=\"form-group\"><label for=\"memberDist\">Member District</label> <input name=\"memberDist\" autocomplete=\"off\" placeholder=\"Enter member district\" class=\"form-control\" type=\"text\" uib-typeahead=\"district as district.value for district in govtSchemeDistricts | filter:$viewValue | limitTo:8\" ng-model=\"form.memberDist\"></div></div><div class=\"col-md-4\" ng-if=\"form.isgovtscheme\"><div class=\"form-group\" ng-if=\"!govReadonly()\"><label ng-if=\"form.govtSchemeName==\'MPKAY\'\" for=\"urnNUmber\">Sewarth No</label> <label ng-if=\"form.govtSchemeName!=\'MPKAY\'\" for=\"urnNUmber\">URN Number</label> <input name=\"urnNUmber\" autocomplete=\"off\" placeholder=\"Enter urn number\" class=\"form-control\" type=\"text\" ng-model=\"form.URNNum\"></div><div class=\"form-group\" ng-if=\"govReadonly()\"><label ng-if=\"form.govtSchemeName==\'MPKAY\'\" for=\"urnNUmber\">Sewarth No</label> <label ng-if=\"form.govtSchemeName!=\'MPKAY\'\" for=\"urnNUmber\">URN Number</label> <input name=\"urnNUmber\" autocomplete=\"off\" readonly=\"true\" placeholder=\"Enter urn number\" class=\"form-control\" type=\"text\" ng-model=\"form.URNNum\"></div></div><div class=\"col-md-4\" ng-if=\"form.isgovtscheme\"><div class=\"form-group\"><label for=\"memberGender\">Member Gender</label><select name=\"memberGender\" ng-model=\"form.memberGender\" class=\"form-control\"><option value=\"\">Select Gender</option><option value=\"male\">Male</option><option value=\"female\">Female</option></select></div></div><div class=\"col-md-4\" ng-if=\"form.isgovtscheme\"><div class=\"form-group\"><label for=\"memberAge\">Member Age</label> <input name=\"memberAge\" autocomplete=\"off\" placeholder=\"Enter member age\" class=\"form-control\" type=\"number\" ng-model=\"form.memberAge\"></div></div><div class=\"col-md-4\" ng-if=\"form.isgovtscheme\"><div class=\"form-group\"><label for=\"memberId\">Member Id <span class=\"text-danger\">*</span></label> <input name=\"memberId\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Enter your Member Id\" ng-model=\"form.memberId\"></div></div><div class=\"col-md-4\" ng-if=\"!form.isgovtscheme && admissionFromSearchFlag.hideSomeFields\"><div class=\"form-group\"><label for=\"policyno\">Policy Number <span ng-show=\"!(form.uniqueId.toString().length>0 || form.maid.toString().length>0||(form.employer.length>0 && form.empid.length>0))\"><span class=\"text-danger\">*</span></span></label> <input type=\"text\" id=\"policyno\" name=\"policynumber\" class=\"form-control\" placeholder=\"Enter policy number\" ng-model=\"form.policyno\" ng-disabled=\"{{isDataPrefilled}}\" ng-required=\"!(form.uniqueId.toString().length>0||form.maid.toString().length>0||(form.employer.length>0 && form.empid.length>0))\"></div></div><div class=\"col-md-4\" ng-if=\"!form.isgovtscheme && admissionFromSearchFlag.hideSomeFields &&(!tpaDetailsObj || (tpaDetailsObj && !tpaDetailsObj.isInsurer))\"><div class=\"form-group\"><label for=\"insurername\">Insurer Name</label><select name=\"insurername\" class=\"form-control\" ng-change=\"getPackagesListForInsurer(form.insurername)\" ng-model=\"form.insurername\" ng-disabled=\"{{isDataPrefilled}}\" ng-options=\"obj.insurerFullName as obj.insurerFullName for obj in insurerList | orderBy:\'insurerFullName\'\"><option value=\"\">--Select Insurer Name--</option></select></div></div><div class=\"col-md-4\" ng-if=\"!form.isgovtscheme && admissionFromSearchFlag.hideSomeFields\"><div class=\"form-group\"><label for=\"employer\">Corporate Name <span ng-show=\"!(form.uniqueId.toString().length>0 || form.maid.toString().length >0||form.policyno.length>0)\"><span class=\"text-danger\">*</span></span></label> <input name=\"employer\" autocomplete=\"off\" id=\"preauthemployer\" type=\"text\" class=\"form-control\" placeholder=\"Enter corporate name\" ng-model=\"form.employer\" ng-disabled=\"{{isDataPrefilled}}\" ng-required=\"!(form.uniqueId.toString().length>0 || form.maid.toString().length >0||form.policyno.length>0)\"></div></div><div class=\"col-md-4\" ng-if=\"!form.isgovtscheme && admissionFromSearchFlag.hideSomeFields\"><div class=\"form-group\"><label for=\"empid\">Employee Id <span ng-show=\"!(form.maid.toString().length >0||form.policyno.length>0 || form.patientUniqeId.toString().length>0)\"><span class=\"text-danger\">*</span></span></label> <input name=\"empid\" autocomplete=\"off\" id=\"preauthempid\" type=\"text\" class=\"form-control\" placeholder=\"Enter employee ID\" ng-model=\"form.empid\" ng-disabled=\"{{isDataPrefilled}}\" ng-required=\"!(form.maid.toString().length >0||form.policyno.length>0 || form.patientUniqeId.toString().length>0)\"></div></div><div class=\"col-md-4\" ng-if=\"!form.isgovtscheme && isShowMaid &&admissionFromSearchFlag.hideSomeFields\"><div class=\"form-group\"><label for=\"maid\">MAID <span ng-show=\"!(form.policyno.length>0||(form.employer.length>0 && form.empid.length>0))\"></span> <span class=\"textErrorMsg\" ng-show=\"signup_form.maid.$error.number\">MAID can contain only numbers</span></label><input name=\"maid\" numbers-only=\"numbers-only\" autocomplete=\"off\" id=\"preauthmaid\" type=\"text\" class=\"form-control\" placeholder=\"Enter MAID\" maxlength=\"10\" minlength=\"10\" ng-model=\"form.maid\" disabled=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"ipnumber\"><span ng-if=\"newAdmissionFormModel === \'RSBY\'\">Registration Invoice Number</span> <span ng-if=\"newAdmissionFormModel != \'RSBY\'\">Inpatient Number</span> <span ng-if=\"newAdmissionFormModel === \'RSBY\'\" class=\"text-danger\">*</span> <span ng-if=\"newAdmissionFormModel === \'RSBY\'\" class=\"textErrorMsg\" ng-show=\"(signup_form.ipnumber.$dirty && signup_form.ipnumber.$invalid) || signup_form.ipnumber.$error.number\">Inpatient number is required</span></label> <input ng-if=\"newAdmissionFormModel === \'RSBY\'\" name=\"ipnumber\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Enter IP no. for faster search and reconciliation\" ng-model=\"form.ipnumber\" required=\"\"> <input ng-if=\"newAdmissionFormModel != \'RSBY\'\" name=\"ipnumber\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Enter IP no. for faster search and reconciliation\" ng-model=\"form.ipnumber\"></div></div><div class=\"col-md-4\" ng-if=\"!form.isgovtscheme && !isShowMaid\"><div class=\"form-group\"><label for=\"patientUniqeId\">Member Id <span ng-show=\"!(form.policyno.length>0||(form.employer.length>0 && form.empid.length>0))\"><span class=\"text-danger\">*</span></span> <span class=\"textErrorMsg\" ng-show=\"(signup_form.patientUniqeId.$dirty && signup_form.patientUniqeId.$invalid) || signup_form.patientUniqeId.$error.number\">Enter valid Member Id</span></label> <input name=\"patientUniqeId\" autocomplete=\"off\" id=\"preauthmaid\" min=\"0\" class=\"form-control\" placeholder=\"Enter member Id\" ng-model=\"form.uniqueId\" ng-required=\"!(form.policyno.length>0||(form.employer.length>0 && form.empid.length>0))\"></div></div><div class=\"col-md-4\" ng-if=\"form.isgovtscheme\"><div class=\"form-group\"><label for=\"aadharNo\">Aadhaar Number</label> <input name=\"aadharNo\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Enter aadhaar number\" ng-model=\"form.aadharNo\"></div></div><div class=\"col-md-4\" ng-if=\"checkforConfiguration(\'Designation\')\"><div class=\"form-group\"><label>Designation <span class=\"text-danger\">*</span></label><select name=\"memberDesignation\" class=\"form-control\" ng-model=\"form.memberDesignation\" ng-change=\"pushToProperties(\'Designation\',form.memberDesignation.name);onDesignationSelection(form.memberDesignation)\" ng-options=\"item.name for item in govtSchemeDesignationMaster track by item.name\" ng-required=\"true\"><option value=\"\">Select Designation</option></select></div></div><div class=\"col-md-4\" ng-if=\"checkforConfiguration(\'Relation\')\"><div class=\"form-group\"><label>Relation <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-model=\"form.memberrelation\" ng-change=\"pushToProperties(\'relation\',form.memberrelation);copyPatientNametoEmployee(form.memberrelation);\" ng-options=\"item for item in relationMaster\" ng-required=\"true\"><option value=\"\">Select Relation</option></select></div></div><div class=\"col-md-4\" ng-if=\"checkforConfiguration(\'unitname\')\"><div class=\"form-group\"><label>Unit Name <span class=\"text-danger\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"form.memberunitName\" ng-blur=\"pushToProperties(\'unitname\',form.memberunitName)\" placeholder=\"Enter Unit Name\" ng-required=\"true\"></div></div><div class=\"col-md-4\" ng-if=\"checkforConfiguration(\'employeename\')\"><div class=\"form-group\"><label>Employee Name <span class=\"text-danger\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"form.employeeName\" ng-blur=\"pushToProperties(\'employeename\',form.employeeName)\" ng-required=\"true\" placeholder=\"Enter Employee Name\"></div></div><div class=\"col-md-4\" ng-if=\"checkforConfiguration(\'placeofposting\')\"><div class=\"form-group\"><label>Place of Posting <span class=\"text-danger\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"form.employeeplaceofposting\" ng-blur=\"pushToProperties(\'placeofposting\',form.employeeplaceofposting)\" placeholder=\"Enter Place of posting\" ng-required=\"true\"></div></div></div><h3>Treatment details</h3><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"doa\">Date of Admission <span class=\"text-danger\">*</span> <span class=\"textErrorMsg\" ng-show=\"(signup_form.doa.$dirty && signup_form.doa.$invalid) || signup_form.doa.$error.datetimelocal || isdoa\">Enter valid date of admission</span></label><div class=\"input-group\"><input name=\"doa\" id=\"datetimepicker\" placeholder=\"Select date of admission\" readonly=\"\" type=\"text\" class=\"form-control\" ng-change=\"dateOfAdmission(form.dod, \'doa\')\" uib-datepicker-popup=\"{{format}}\" ng-model=\"form.doa\" is-open=\"datePopup.doa\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDoa()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"dod\">Date of Discharge <span class=\"text-danger\">*</span> <span class=\"textErrorMsg\" ng-show=\"(signup_form.dod.$dirty && signup_form.dod.$invalid) || isdod\">Enter valid date of discharge</span></label><div class=\"input-group\"><input placeholder=\"Select date of discharge\" readonly=\"\" name=\"dod\" type=\"text\" id=\"dischargetimepicker\" class=\"form-control\" ng-change=\"dateOfAdmission(form.doa, \'dod\')\" uib-datepicker-popup=\"{{format}}\" ng-model=\"form.dod\" is-open=\"datePopup.dod\" datepicker-options=\"dateOptions1\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDod()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"docName\">Doctor name <span class=\"text-danger\">*</span></label> <input name=\"docName\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Type doctor name\" required=\"\" ng-click=\"getkeywords()\" ng-model=\"form.docname\" uib-typeahead=\"condition.doctorName for condition in doctorDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"diagnosis\">Doctor reg no</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.docregNo\" placeholder=\"Enter doctor reg no\"></div></div><div class=\"col-md-4\" ng-if=\"form.allowedDiagnosisType && form.allowedDiagnosisType.length>0\"><div class=\"form-group\"><label for=\"diagnosis\" style=\"display:block\">Diagnosis Type <span class=\"text-danger\">*</span></label> <label class=\"radio-inline\" ng-repeat=\"item in form.allowedDiagnosisType\"><input type=\"radio\" name=\"rdodiagnosis\" value=\"{{item}}\" ng-change=\"changeDiagnosisType()\" ng-model=\"form.diagnosisOption\">{{item}}</label></div></div><div class=\"col-md-4\" ng-if=\"form.diagnosisOption==\'OTHER\' || !form.allowedDiagnosisType\"><div class=\"form-group\"><label for=\"diagnosis\">Other Diagnosis <span class=\"text-danger\">*</span></label> <textarea name=\"diagnosis\" class=\"form-control\" placeholder=\"Enter diagnosis details\" ng-change=\"checkForAutomationDiagnosis(form.diagnosis)\" ng-model=\"form.diagnosis\" required=\"\" style=\"height:36px;\"></textarea></div></div><div class=\"col-md-4\" ng-if=\"form.diagnosisOptionRemarks\"><label>It looks like Cataract case <button class=\"btn btn-link\" ng-click=\"form.diagnosisOption = \'CATARACT\';form.diagnosisOptionRemarks=false\">click here</button> to enter details</label></div></div><h6 ng-if=\"form.diagnosisOption==\'MATERNITY\'\">Maternity</h6><maternityform></maternityform><h6 ng-if=\"form.diagnosisOption==\'CATARACT\'\">Cataract</h6><cataractform></cataractform><div class=\"row\" ng-if=\"form.isgovtscheme\"><div class=\"col-md-8\"><div class=\"form-group\"><label for=\"docName\">Government Package <span class=\"text-danger\">*</span></label> <input type=\"text\" name=\"GovPackage\" ng-change=\"typeProcedureName()\" ng-model=\"form.govPackagesname\" placeholder=\"Type package name...\" uib-typeahead=\"condition.govPackageName for condition in govtPackageList | filter:$viewValue | limitTo:5\" typeahead-on-select=\"selectGovePackage($item, $model)\" typeahead-popup-template-url=\"govCustomPopupTemplate.html\" class=\"form-control\"></div></div><div class=\"col-md-3\" ng-if=\"!isSelectedGov\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label> <input name=\"procedureName\" placeholder=\"Enter price\" class=\"form-control\" autocomplete=\"off\" ng-model=\"govPackageManually.price\" type=\"text\" numbers-only=\"numbers-only\"></div></div><div class=\"col-md-3\" ng-if=\"isSelectedGov\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label><select ng-if=\"priceForGovPackage.length > 1\" name=\"procedurePrice\" class=\"form-control\" ng-model=\"govPackageManually.price\"><option value=\"\">--Select Price--</option><option value=\"{{obj.price}}\" ng-repeat=\"obj in priceForGovPackage | orderBy:\'obj\'\">{{obj.price}}</option></select><input ng-if=\"priceForGovPackage.length === 1\" readonly=\"true\" name=\"procedureName1\" placeholder=\"Enter price\" class=\"form-control\" autocomplete=\"off\" ng-model=\"govPackageManually.price\" type=\"text\"></div></div><div class=\"col-md-1\" style=\"margin-top: 22px;\"><div class=\"form-group\"><button ng-disabled=\"!(govPackageManually.price && form.govPackagesname)\" class=\"btn btn-primary\" ng-click=\"addGovPackageManually( form.govPackagesname, govPackageManually, isSelectedGov)\">Add</button></div></div></div><div class=\"row\" style=\"background-color: aliceblue; border-radius: 10px;\" ng-if=\"form.isgovtscheme && govPackageData.length >0\"><div class=\"col-md-12\"><table class=\"table table-hover table-link\"><thead><th class=\"patientName text-left\">Name</th><th class=\"patientName text-center\">Price</th><th class=\"patientName text-center\">Action</th></thead><tbody><tr tooltip-placement=\"top\" ng-repeat=\"sel_package in govPackageData\"><td class=\"text-left\">{{sel_package.packageName}}</td><td style=\"width: 15%\" class=\"text-center\">{{sel_package.packageCost}} <span ng-show=\"sel_package.isPerDayEligiblePackage === true\">* {{noOfDays}} days</span></td><td style=\"width: 15%\" class=\"text-center\"><button class=\"btn btn-danger btn-xs\" ng-click=\"removeGovPackage(sel_package)\">Remove</button></td></tr><tr tooltip-placement=\"top\" ng-if=\"govPackageData.length >0\"><td class=\"text-left\" style=\"font-size: large;color: black;\">Total</td><td class=\"text-center\" style=\"font-size: large;color: black;\"><span class=\"text-center\">{{totalCalcAmount}}</span></td><td class=\"text-center\" style=\"font-size: large;color: black;\"></td></tr></tbody></table></div></div><div class=\"row\" ng-if=\"!form.isgovtscheme && form.PreAuthForIRRemarks ===\'\'\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"TreatmentDetails\">Package Details <span class=\"text-danger\">*</span></label><package-typeahead items=\"totalListOfPackage\" prompt=\"Start typing procedure name...\" ng-model=\"hospNewName\" removeitem=\"removeData\" callback-fn=\"addTypeAheadPackage(arg)\" nofilters=\"applyNoFilters\" getreason=\"getReason\"></package-typeahead></div></div></div><div class=\"row\" ng-if=\"false\"><div class=\"col-md-8\"><div class=\"form-group\"><label for=\"TreatmentDetails\" ng-if=\"form.diagnosisOption==\'OTHER\' || !form.diagnosisOption\">Treatment Details <span class=\"text-danger\">*</span></label> <input ng-if=\"form.diagnosisOption==\'OTHER\' || !form.diagnosisOption\" type=\"text\" ng-model=\"procedureManually.name\" ng-change=\"typeProcedureName()\" placeholder=\"Enter treatment details...\" uib-typeahead=\"condition.package_Name for condition in totalListOfPackage | filter:$viewValue | limitTo:5\" typeahead-on-select=\"selectPackageFromList($item, $model)\" typeahead-min-length=\"0\" typeahead-popup-template-url=\"customPopupTemplate.html\" class=\"form-control\"></div></div><div class=\"col-md-3\" ng-if=\"!isPriceDropDown\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label> <input name=\"procedureName\" placeholder=\"Enter price\" class=\"form-control\" autocomplete=\"off\" ng-model=\"procedureManually.price\" type=\"text\" numbers-only=\"numbers-only\"></div></div><div class=\"col-md-3\" ng-if=\"isPriceDropDown\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label><select name=\"procedurePrice\" class=\"form-control\" ng-change=\"selectRoomPrice(procedureManually.price)\" ng-model=\"procedureManually.price\" ng-options=\"obj as obj.showName for obj in priceForPackage | orderBy:\'obj\'\"><option value=\"\">--Select Price--</option></select></div></div><div class=\"col-md-1\" style=\"margin-top: 22px;\"><div class=\"form-group\"><button class=\"btn btn-primary\" ng-click=\"addManuallyProcedure(procedureManually, isPriceDropDown)\">Add</button></div></div></div><div class=\"row\" ng-if=\"!form.isgovtscheme && form.PreAuthForIRRemarks !=\'\'\"><p style=\"margin-left: 50px;\">Remark :- <strong>{{form.PreAuthForIRRemarks}};</strong></p><p style=\"margin-left: 115px;margin-top: -8px;\">and all other supporting documents for faster processing of a claim.</p></div><div style=\"background-color: aliceblue; border-radius: 10px;\" ng-if=\"selectedMappedpackages.length >0 && CLAIMED_AMOUNT\"><table class=\"table table-hover table-link\" ng-if=\"tabname != \'Planned Requests\'\"><thead><tr><th class=\"patientName text-left\">Name</th><th class=\"claimedAmount text-center\">Price</th><th class=\"claimedAmount text-center\">Action</th></tr></thead><tbody><tr tooltip-placement=\"top\" ng-repeat=\"item in selectedMappedpackages track by $index\"><td class=\"text-left\" ng-if=\"item.packageAmount > 0\">{{item.hospitaL_CHARGE_HEAD}}</td><td style=\"width: 15%\" class=\"text-center\" ng-if=\"item.packageAmount > 0\"><span class=\"text-center\">{{item.packageAmount}}</span></td><td style=\"width: 15%\" class=\"text-center\" ng-if=\"item.packageAmount > 0\"><button class=\"btn btn-danger btn-xs\" ng-click=\"removePackageFromList(item)\">Remove</button></td></tr><tr tooltip-placement=\"top\" ng-if=\"selectedMappedpackages.length >0\"><td class=\"text-left\" style=\"font-size: large;color: black;\">Total</td><td class=\"text-center\" style=\"font-size: large;color: black;\"><span class=\"text-center\">{{CLAIMED_AMOUNT}}</span></td><td class=\"text-center\" ng-if=\"CLAIMED_AMOUNT>0\"></td></tr></tbody></table></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"roomType\">Provided Room Type <span class=\"text-danger\">*</span></label> <input ng-if=\"!checkforConfiguration(\'roomtype\')\" name=\"roomType\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" required=\"\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Type provided room type\" ng-click=\"getkeywords()\" ng-model=\"form.roomtype\" uib-typeahead=\"item.hospitalRoomType for item in roomsDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"><select ng-if=\"checkforConfiguration(\'roomtype\')\" class=\"form-control\" ng-model=\"form.memberroomType\" ng-change=\"pushToProperties(\'roomtype\',form.memberroomType.id)\" ng-options=\"item.value for item in payerRoomCategories\" ng-required=\"true\"><option value=\"\">Select RoomType</option></select></div></div></div><h3>Upload Documents <small class=\"bg-danger\" style=\"font-size: 12px; display: inline-block; padding: 5px;\">Maximum file upload limit is 15 MB. <b>At least one of the documents listed below needs to be submitted.</b></small> <button class=\"btn btn-xs btn-primary\" ng-click=\"preauthFormAction.downloadPrefilledPreauthForm(\'preauthform\')\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR) || (isdod ||isdoa)\">Download Pre-filled form</button></h3><div id=\"fileupload\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Signed Pre authorization form</label><mb-file-upload action=\"action\" attachmenttype=\"\'9\'\" file-fn=\"fileFn(arg,attachmenttype)\"></mb-file-upload></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Id Proof <a tooltip-placement=\"top\" uib-tooltip=\"Driving License, Voter ID card, Corporate Employee ID, Pan car, Passport\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a></label><mb-file-upload action=\"action\" attachmenttype=\"\'4\'\" file-fn=\"fileFn(arg,attachmenttype)\"></mb-file-upload></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnostic Reports <a tooltip-placement=\"top\" uib-tooltip=\"Bio Chemistry reports, Haematology reports, Microbiology reports, Neurology reports, Pathology reports, Radiology reports\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a></label><mb-file-upload action=\"action\" attachmenttype=\"\'13\'\" file-fn=\"fileFn(arg,attachmenttype)\"></mb-file-upload></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Other Relevant Documents</label><mb-file-upload action=\"action\" attachmenttype=\"\" file-fn=\"fileFn(arg,attachmenttype)\"></mb-file-upload></div></div></div><div class=\"row\" ng-if=\"storeFiles.length >0\"><div class=\"col-md-12\"><div class=\"label label-info\" ng-repeat=\"item in storeFiles\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: #eeeeee;\"><a ng-click=\"downloadAttachment(item.downloadURL)\">{{item.fileName}}</a> <a ng-click=\"removeFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><button type=\"submit\" class=\"btn btn-primary start pull-right\" id=\"newAdmissionButton\" style=\"margin-bottom: 25px;\" ng-click=\"source==\'preClaim\'?preClaimInfoRelatedMethods.submitPreClaimPreauthForm():preauthFormAction.submitPreauthForm()\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR) || (isdod ||isdoa) || isProcessing\"><span>Submit New Admission</span></button></div></div></div></ng-form></div>");
$templateCache.put("app/components/newAdmissionForm/maternityDataForm.html","<div class=\"row\" ng-if=\"form.diagnosisOption==\'MATERNITY\'\"><div class=\"col-md-4\"><div class=\"form-group\"><label style=\"display:block;\">Delivery Type <span class=\"text-danger\">*</span></label> <label class=\"radio-inline\" ng-repeat=\"obj in maternityType\"><input type=\"radio\" name=\"rdoMaternityType\" value=\"{{obj.id}}\" ng-change=\"onChangeDeliveryType(form.maternityType)\" ng-model=\"form.maternityType\" required=\"\">{{obj.name}}</label></div></div><div class=\"col-md-6\"><div class=\"form-group\">G <input type=\"text\" class=\"form-control\" ng-change=\"pushToProperties(\'obstetricHistoryG\',form.obstetricHistoryG)\" style=\"width:30px;display:inline;padding: 6px 2px;\" ng-model=\"form.obstetricHistoryG\" required=\"\"> P <input type=\"text\" class=\"form-control\" ng-change=\"pushToProperties(\'obstetricHistoryP\',form.obstetricHistoryP)\" style=\"width:30px;display:inline;padding: 6px 2px;\" ng-model=\"form.obstetricHistoryP\" required=\"\"> L <input type=\"text\" class=\"form-control\" ng-change=\"pushToProperties(\'obstetricHistoryL\',form.obstetricHistoryL)\" style=\"width:30px;display:inline;padding: 6px 2px;\" ng-model=\"form.obstetricHistoryL\" required=\"\"> A <input type=\"text\" class=\"form-control\" ng-change=\"pushToProperties(\'obstetricHistoryA\',form.obstetricHistoryA)\" style=\"width:30px;display:inline;padding: 6px 2px;\" ng-model=\"form.obstetricHistoryA\" required=\"\"></div></div></div>");
$templateCache.put("app/components/newAdmissionForm/newAdmissionForm.html","<div id=\"tabclaim-new\" class=\"new-admission\"><div class=\"panel panel-default\" id=\"new-claim-success\" ng-show=\"form.preauthSuccess\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\" style=\"background-color: #4cc0c1;\"><h4 class=\"chat-status text-center\" ng-show=\"!form.hospTPAId\">Your claim has been created successfully! details can be viewed from list of \"Pending for Acknowledgement\".</h4><h4 ng-show=\"form.successMessage && form.hospTPAId\">{{form.successMessage}}</h4></div><table class=\"table table-bordered\" ng-show=\"form.patientDetails\"><tr><th>Patient Name :</th><td>{{form.patientDetails.patientName}}</td><th>Patient Contact No :</th><td>{{form.patientDetails.contactNum}}</td><th>Member Unique ID :</th><td>{{form.patientDetails.maid}}</td></tr><tr><th>Policy no :</th><td></td><th>Employee ID :</th><td>{{form.patientDetails.empId}}</td><th>Corporate Name :</th><td>{{form.patientDetails.employer}}</td></tr><tr><th>Date of Admission :</th><td>{{form.patientDetails.doa}}</td><th>Date of Discharge :</th><td>{{form.patientDetails.tentativeDOD}}</td><th>ClaimedAmount :</th><td>{{form.patientDetails.approxClaimedAmnt}}</td></tr><tr><th>Insurance company:</th><td></td></tr></table></div><div class=\"col-md-2\"></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2 pull-right\" style=\"margin-left: -40px;\"><button style=\"background-color: #e6e6e6;\" class=\"btn btn-default\" ng-click=\"preauthFormAction.closePreauthForm()\">Back to claims list</button></div><div class=\"col-md-2 pull-right\"><button class=\"btn btn-primary\" ng-click=\"redirectUrl()\">New Admission</button></div></div></div></div><div class=\"panel panel-default\" id=\"new-claim-fail\" ng-show=\"form.preauthError\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-1\"></div><div class=\"col-md-10\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\" style=\"background-color: #4cc0c1;\"><h4 class=\"chat-status text-left\">Oops! There seems to be a problem and your claim is not created.</h4><p>Possible reasons could be :</p><ol><li>Invalid details entered</li><li>Invalid file formats or more number of files uploaded</li></ol><h4 class=\"chat-status text-left\">Please check the details, required files and create it again. Thank you.</h4></div></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2 pull-right\" style=\"margin-left: -40px;\"><button style=\"background-color: #e6e6e6;\" class=\"btn btn-default\" ng-click=\"preauthFormAction.closePreauthForm()\">Back to claims list</button></div><div class=\"col-md-2 pull-right\"><button class=\"btn btn-primary\" ng-click=\"redirectUrl()\">New Admission</button></div></div></div></div><style>\n    .radioBtns {\n      font-weight: normal;\n      font-size: 18px;\n    }\n\n    .radioBtns label {\n      font-weight: normal;\n      margin-left: 20px;\n      display: inline-block !important;\n    }\n\n    .radioBtns label.sel {\n      color: #F05A1A;\n      font-weight: 400;\n    }\n\n    .radioBtns span.sel {\n      color: #F05A1A;\n      font-weight: 400;\n    }\n\n    .benefCard .bx.primary {\n      background: #4cc0c1;\n      padding: 20px;\n      color: #fff;\n      border-radius: 3px;\n    }\n\n    .benefCard .col-xs-4 {\n      padding: 0 10px;\n    }\n\n    .benefCard p {\n      margin: 0 0 15px 0;\n      font-size: 18px;\n      font-weight: normal;\n    }\n\n    .benefCard p span {\n      display: block;\n      font-size: 12px;\n      color: #024e4e;\n    }\n\n    .benefCard .bx {\n      font-size: 16px;\n      background: #efefef;\n      border-radius: 3px;\n      margin-bottom: 20px;\n      display: block;\n      padding: 15px;\n      text-decoration: none;\n    }\n\n    .benefCard .bx span {\n      display: block;\n      font-size: 12px;\n      color: #666;\n    }\n\n    .benefCard .bx:hover,\n    .benefCard .bx.sel {\n      background: #4d4d4d;\n      color: #fff;\n      text-decoration: none;\n    }\n\n    .benefCard .bx:hover span,\n    .benefCard .bx.sel span,\n    .benefCard .bx b {\n      color: #a9d7ff;\n    }\n\n    .textErrorMsg {\n      float: right;\n      font-size: 11px;\n      color: #f00;\n      font-weight: normal;\n    }\n\n    /* .new-admission label {\n      display: block;\n    } */\n\n    .new-admission h3 {\n      color: #14bcc8;\n      font-size: 22px;\n      border-bottom: 2px solid #14bcc8;\n      margin: 20px 0;\n      padding-bottom: 5px;\n    }\n\n    .new-admission h5 {\n      color: #14bcc8;\n      font-size: 16px;\n      border-bottom: 1px solid #14bcc8;\n      margin: 10px 0;\n      padding-bottom: 5px;\n    }\n\n    .new-admission h6 {\n      color: #14bcc8;\n      font-size: 14px;\n      border-bottom: 1px solid #14bcc8;\n      margin: 10px 0;\n      padding-bottom: 5px;\n    }\n\n    .form-control.danger {\n      border-color: #f00;\n    }\n\n    .form-control.success {\n      border-color: #5cb85c;\n    }\n\n    .new-admission input[type=\"radio\"],\n    .new-admission input[type=\"checkbox\"] {\n      margin: 2px 0 0 !important;\n    }\n\n    .new-admission .radio input[type=\"radio\"],\n    .new-admission .radio-inline input[type=\"radio\"],\n    .new-admission .checkbox input[type=\"checkbox\"],\n    .new-admission .checkbox-inline input[type=\"checkbox\"] {\n      margin-left: -15px !important;\n    }\n\n    .new-admission input[type=\"radio\"],\n    .new-admission input[type=\"checkbox\"] {\n      margin: 3px 0 0 !important;\n    }\n\n  </style><script type=\"text/ng-template\" id=\"govCustomPopupTemplate.html\"><div class=\"custom-popup-wrapper\" ng-style=\"{top: position().top+\'px\', left: position().left+\'px\'}\" style=\"display: block;\" ng-show=\"isOpen() && !moveInProgress\" aria-hidden=\"{{!isOpen()}}\"> <table class=\"table table-hover\"> <tr ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.id}}\"> <td width=\"200px\">{{match.model.govPackageName}}</td> </tr> </table> </div></script><script type=\"text/ng-template\" id=\"customPopupTemplate.html\"><div class=\"custom-popup-wrapper\" ng-style=\"{top: position().top+\'px\', left: position().left+\'px\'}\" style=\"display: block;\" ng-show=\"isOpen() && !moveInProgress\" aria-hidden=\"{{!isOpen()}}\"> <table class=\"table table-hover\"> <tr ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.id}}\"> <td width=\"200px\">{{match.model.package_Name}}</td> </tr> </table> </div></script><div></div><div ng-show=\"configuredTpaList && configuredTpaList.length && !admissionFromSearchFlag.openDetailsTab\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"\">Payer Name</label><select name=\"tpaName\" class=\"form-control\" ng-options=\"item.tpaName for item in configuredTpaList track by item.tpaId\" ng-change=\"changeTpa(tpaDetailsObj)\" ng-model=\"tpaDetailsObj\"></select></div></div></div></div><div ng-if=\"!admissionFromSearchFlag.openDetailsTab\"><h3 class=\"m-t-0\" style=\"border:0 none;\">Identify your customer <span class=\"m-t-0\" style=\"color: #000000;font-size: 14px;\">(Choose any of the following to auto-fill customer details. Use primary beneficiary ID to search other dependents.)</span></h3><h4 style=\"margin-top:10px;\" class=\"radioBtns\"><div class=\"row\"><div class=\"col-md-12\" ng-if=\"isShowMaid || isSearchButton\">I have <label ng-repeat=\"item in newAdmissionFormData\"><input type=\"radio\" name=\"pageSet\" ng-click=\"formSelection(item.name, item.selected)\" ng-model=\"newAdmissionFormModel\" ng-value=\"item\" ng-disabled=\"{{item.name === \'Email-Id\' || item.name === \'Contact Number\' ? \'true\':\'false\'}}\"> <span ng-class=\"{\'sel\' :item.selected}\">{{item.name}}</span></label></div></div></h4><form name=\"formMaid\" style=\"margin-top: -15px;\"><div class=\"row inputInline\" ng-if=\"admissionFromSearchFlag.maidOrDhsid || admissionFromSearchFlag.memberId\"><div class=\"col-md-5 p-r-0\" ng-if=\"form.tpaId==MaTPAId || !form.tpaId\"><label for=\"\">MemberId (MAId / MedicareId /Insurer MemberId)</label> <input autocomplete=\"off\" ng-model=\"newAdmissionSearch.maidOrDhsid\" name=\"maid\" class=\"form-control first\" type=\"text\" placeholder=\"Enter MemberId\" ng-required=\"true\"></div><div class=\"col-md-5 p-r-0\" ng-if=\"form.tpaId!=MaTPAId && form.tpaId\"><label for=\"\">Member Id</label> <input autocomplete=\"off\" ng-model=\"newAdmissionSearch.memberId\" name=\"searchMemberId\" class=\"form-control first\" type=\"text\" placeholder=\"Enter MemberId\" ng-required=\"true\"></div><div class=\"col-md-5 p-r-0 p-l-0\" ng-if=\"form.tpaId==MaTPAId || !form.tpaId\"><label for=\"\">Patient name</label> <input name=\"benefName\" autocomplete=\"off\" ng-model=\"newAdmissionSearch.benefName\" class=\"form-control\" type=\"text\" placeholder=\"Enter patient name\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getBenefDetails(newAdmissionSearch.maidOrDhsid,newAdmissionSearch.benefName,\'maid\'): \'\'\"></div><div class=\"col-md-2 p-l-0\"><button ng-if=\"form.tpaId==MaTPAId || !form.tpaId\" ng-disabled=\"!newAdmissionSearch.maidOrDhsid || !newAdmissionSearch.benefName\" ng-click=\"getBenefDetails(newAdmissionSearch.maidOrDhsid,newAdmissionSearch.benefName,\'maid\')\" type=\"button\" class=\"btn btn-primary last\">Search</button> <button ng-if=\"form.tpaId!=MaTPAId && form.tpaId\" ng-disabled=\"!newAdmissionSearch.memberId\" ng-click=\"getBenefDetailsForOtherPayer()\" type=\"button\" class=\"btn btn-primary last\">Search</button></div></div><div class=\"row inputInline\" ng-if=\"admissionFromSearchFlag.employeeId\"><div class=\"col-md-4 p-r-0\"><label for=\"\">Employee ID</label> <input ng-model=\"fastrack.employeeId\" name=\"empid\" class=\"form-control first\" type=\"text\" placeholder=\"Enter employee / family number\" ng-required=\"true\"></div><div class=\"col-md-3 p-l-0 p-r-0\"><label for=\"\">Company\'s name</label> <input ng-model=\"fastrack.corporateName\" name=\"compname\" class=\"form-control\" type=\"text\" placeholder=\"Enter company name\" ng-required=\"true\"></div><div class=\"col-md-3 p-l-0 p-r-0\" ng-if=\"form.tpaId==MaTPAId || !form.tpaId\"><label for=\"\">Patient Name</label> <input ng-model=\"fastrack.BeneficiaryName\" name=\"benefname\" class=\"form-control\" type=\"text\" placeholder=\"Enter patient name\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getBenefDetails({employeeId:fastrack.employeeId, corporateName:fastrack.corporateName},fastrack.BeneficiaryName,\'employeeID\'): \'\'\"></div><div class=\"col-md-2 p-l-0 p-r-0\"><button ng-if=\"form.tpaId==MaTPAId || !form.tpaId\" ng-disabled=\"!fastrack.BeneficiaryName || !fastrack.corporateName || !fastrack.employeeId\" ng-click=\"getBenefDetails({employeeId:fastrack.employeeId, corporateName:fastrack.corporateName},fastrack.BeneficiaryName,\'employeeID\')\" type=\"button\" class=\"btn btn-primary\">Search</button> <button ng-if=\"form.tpaId!=MaTPAId && form.tpaId\" ng-disabled=\"!fastrack.corporateName || !fastrack.employeeId\" ng-click=\"getBenefDetailsForOtherPayer()\" type=\"button\" class=\"btn btn-primary last\">Search</button></div></div><div class=\"row inputInline\" ng-if=\"admissionFromSearchFlag.policyno\"><div class=\"col-md-5 p-r-0\"><label for=\"\">Policy Number</label> <input ng-model=\"fastrack.PolicyNo\" class=\"form-control first\" type=\"text\" placeholder=\"Enter policy number\" ng-required=\"true\"></div><div class=\"col-md-5 p-l-0 p-r-0\" ng-if=\"form.tpaId==MaTPAId || !form.tpaId\"><label for=\"\">Patient Name</label> <input ng-model=\"fastrack.BeneficiaryName\" class=\"form-control\" type=\"text\" placeholder=\"Enter patient name\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getBenefDetails(fastrack.PolicyNo,fastrack.BeneficiaryName,\'policy\'): \'\'\"></div><div class=\"col-md-2 p-l-0\"><button ng-if=\"form.tpaId==MaTPAId || !form.tpaId\" ng-disabled=\"!fastrack.PolicyNo || !fastrack.BeneficiaryName\" ng-click=\"getBenefDetails(fastrack.PolicyNo,fastrack.BeneficiaryName,\'policy\')\" type=\"button\" class=\"btn btn-primary\">Search</button> <button ng-if=\"form.tpaId!=MaTPAId && form.tpaId\" ng-disabled=\"!fastrack.PolicyNo\" ng-click=\"getBenefDetailsForOtherPayer()\" type=\"button\" class=\"btn btn-primary last\">Search</button></div></div><div class=\"row inputInline\" ng-if=\"admissionFromSearchFlag.typeGovClaim\"><div class=\"col-md-7 p-r-0\"><div class=\"btn-group btn-group-justified\"><h4 style=\"margin-top:10px;\" class=\"radioBtns\">Select Scheme <span class=\"text-danger\">*</span> <label ng-repeat=\"item in govtSchemeType\"><input type=\"radio\" name=\"pageSet\" ng-click=\"formSchemeSelection(item.name, item.selected)\" ng-model=\"newAdmissionFormModel\" ng-value=\"item\"> <span ng-class=\"{\'sel\' :item.selected}\">{{item.name}}</span></label></h4></div></div></div><div class=\"row inputInline\" ng-if=\"admissionFromSearchFlag.urnNumberManipurScheme\"><div class=\"col-md-3 p-r-0\"><div class=\"form-group\"><label for=\"\">URN Number</label> <input ng-model=\"govSearchValueInModel.urn\" name=\"urn\" class=\"form-control\" type=\"text\" placeholder=\"Enter URN number\" ng-required=\"true\" ng-change=\"resetModel();\"></div></div><div class=\"col-md-2 p-l-0\"><button ng-disabled=\"!govSearchValueInModel.urn\" ng-click=\"getDetailsWithGov(govSearchValueInModel.urn,govSearchValueInModel.apbyname,\'manipur scheme\')\" type=\"button\" class=\"btn btn-primary\">Search</button></div></div><div class=\"row inputInline\" ng-if=\"form.govtSchemeName==\'MPKAY\' || form.govtSchemeName==\'MKSSKY\'\"><div class=\"col-md-3 p-r-0\"><div class=\"form-group\"><label for=\"\">Sewarth Number</label> <input ng-model=\"govSearchValueInModel.urn\" name=\"urn\" class=\"form-control\" type=\"text\" placeholder=\"Enter Swearth number\" ng-required=\"true\" ng-change=\"resetModel();\"></div></div><div class=\"col-md-2 p-l-0\"><button ng-disabled=\"!govSearchValueInModel.urn\" ng-click=\"getDetailsWithGov(govSearchValueInModel.urn,govSearchValueInModel.apbyname,\'manipur scheme\')\" type=\"button\" class=\"btn btn-primary\">Search</button></div></div><div class=\"row inputInline\" ng-if=\"admissionFromSearchFlag.urnNumber\"><div class=\"col-md-7 p-r-0\"><label for=\"patientFirstName\">Which error you are getting? <span class=\"text-danger\">*</span></label><div class=\"btn-group btn-group-justified\"><label class=\"btn btn-default first\" ng-model=\"checkboxErrorModel.error\" uib-btn-checkbox=\"\">Chip error</label> <label class=\"btn btn-default\" ng-model=\"checkboxErrorModel.fingerPrint\" uib-btn-checkbox=\"\">Finger print issue</label> <label class=\"btn btn-default\" ng-model=\"checkboxErrorModel.package\" uib-btn-checkbox=\"\">Package approval</label> <label class=\"btn btn-default last\" ng-model=\"checkboxErrorModel.other\" uib-btn-checkbox=\"\">Others</label></div></div><div class=\"col-md-3 p-r-0 p-l-0\"><div class=\"form-group\"><label for=\"\">URN Number</label> <input ng-model=\"govSearchValueInModel.urn\" name=\"urn\" class=\"form-control\" type=\"text\" placeholder=\"Enter URN number\" ng-required=\"true\" ng-change=\"resetModel();\"></div></div><div class=\"col-md-4 p-l-0 p-r-0\" ng-show=\"selectedSchemeForGov===\'APCMUHIS_Mediassist\'\"><div class=\"form-group\"><label for=\"\">Member Name</label> <input ng-model=\"govSearchValueInModel.apbyname\" name=\"MemberNameAPBY\" class=\"form-control\" type=\"text\" placeholder=\"Enter member name\" ng-required=\"true\"></div></div><div class=\"col-md-2 p-l-0\"><button ng-disabled=\"!govSearchValueInModel.urn || !(checkboxErrorModel.other || checkboxErrorModel.package || checkboxErrorModel.fingerPrint || checkboxErrorModel.error)\" ng-click=\"getDetailsWithGov(govSearchValueInModel.urn,govSearchValueInModel.apbyname)\" type=\"button\" class=\"btn btn-primary\">Search</button></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">\"{{govSearchValueInModel.urn}}\" <span ng-if=\"fastrack.errorMessage\" class=\"text-danger\">{{fastrack.errorMessage}}</span> <span ng-if=\"!fastrack.errorMessage\">Member data entered does not match, do you want</span> <a ng-if=\"!tpaDetailsObj || (tpaDetailsObj && !tpaDetailsObj.isClaimCreationBlockedWithoutBenef) && form.govtSchemeName!=\'CMHT\'\" ng-click=\"formSelection(\'Add Manually\', admissionFromSearchFlag.govClaim)\" style=\"color: blue;\">enter manually</a></p><p class=\"bg-danger\" ng-if=\"isECashLess\">{{eCashLessMessage}} <button class=\"btn btn-xs btn-primary\" ng-click=\"reDirect(\'planned\')\">yes</button></p></form></div><div class=\"row benefCard\" ng-show=\"govtBenefList.length >0\"><p class=\"bg-info\" style=\"font-size: initial;font-weight: 600;\">URN : \"{{govSearchValueInModel.urn}}\" is available in Post Enroll Data.<select class=\"form-control\" style=\"width: 30%; display: inline-block;\" ng-model=\"selectedIndex\" ng-options=\"item.displayName for item in govtBenefList\" ng-change=\"fastrackPopulateNewAdmissionGov(selectedIndex)\"><option value=\"\">--Select Beneficiary--</option></select></p></div><div class=\"row benefCard\" ng-show=\"otherPayerBenefList && otherPayerBenefList.length >0\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-4\" ng-repeat=\"relation in otherPayerBenefList\"><div class=\"bx\"><a ng-click=\"fastrackPopulateNewAdmissionForOtherPayer(relation);\" ng-class=\"relation.isSelected === true ? \'sel\' : \'\'\">{{relation.benefName}} <span>{{relation.memberId}} <i ng-if=\"relation.benefRelation\">|</i> {{relation.benefRelation}} <i ng-if=\"relation.memberId\">|</i> {{relation.memberId}} <i ng-if=\"relation.priBenefEmpCode\">|</i>{{relation.priBenefEmpCode}}</span> <span><b>Policy Holder :</b>{{relation.benefPolHldrName}}</span></a></div></div></div></div></div><div class=\"row benefCard\" ng-show=\"newAdmissionSearch.benefRelationList && newAdmissionSearch.benefRelationList.length >0\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-4\" ng-repeat=\"relation in newAdmissionSearch.benefRelationList\"><div class=\"bx\"><a ng-click=\"assignBeneficiaryDetails(relation);\" ng-class=\"relation.isSelected === true ? \'sel\' : \'\'\">{{relation.benefName}} <span>{{relation.benefMediAssistID}} <i ng-if=\"relation.benefRelation\">|</i> {{relation.benefRelation}} <i ng-if=\"relation.priBenefEmpCode\">|</i>{{relation.priBenefEmpCode}} <i ng-if=\"relation.benefSex\">|</i>{{relation.benefSex}}</span> <span><b>Policy Holder :</b>{{relation.benefPolHldrName}}</span> <span><b>Insurer :</b>{{relation.insuranceCompanyName}}</span></a></div></div></div></div></div><div ng-show=\"!form.preauthSuccess && !form.preauthError\"><div class=\"chat-content_wrap\"><div ng-if=\"admissionFromSearchFlag.addManually || admissionFromSearchFlag.openDetailsTab\"><div ng-if=\"!tpaDetailsObj || (tpaDetailsObj && tpaDetailsObj.tpaId!=1005310)\"><genericnewadmissionform></genericnewadmissionform></div><div ng-if=\"tpaDetailsObj && tpaDetailsObj.tpaId==1005310\"><hdfcnewadmissionform></hdfcnewadmissionform></div></div></div></div><div class=\"modal fade\" id=\"{{modelPopup.text}}\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"closeModal()\">Submit</button><h4>Bill Breakup</h4></div><div class=\"modal-body\"><form name=\"dischargeSub\" novalidate=\"\"><div class=\"table-responsive\" style=\"overflow-x: hidden;overflow-y: hidden;height: 100%;\"><div class=\"table table-hover\"><div class=\"row\" style=\"margin-left:5px\"><table class=\"table table-condensed\" style=\"margin:0;\" ng-if=\"selectedMappedpackages.length >0\"><tr><th class=\"claimId\" style=\"width:275px;\">Categories <span style=\"color: red; font-size: small\">*</span></th><th class=\"claimedAmount\" style=\"width:75px;\">Price <span style=\"color: red; font-size: small\">*</span></th><th class=\"claimedAmount\" style=\"width:15px;\">Action</th></tr><tr ng-repeat=\"item in selectedMappedpackages track by $index\"><td><span style=\"margin-left:-10px\">{{$index+1}}</span> <input ng-disabled=\"item.isReadOnly\" style=\"margin-left: 8px; margin-top: -20px;\" type=\"text\" ng-model=\"item.hospitaL_CHARGE_HEAD\" placeholder=\"Enter categorie name\" class=\"form-control\"></td><td><input ng-disabled=\"item.isPackage\" type=\"text\" numbers-only=\"numbers-only\" ng-model=\"item.packageAmount\" ng-change=\"totalClaimAmount()\" placeholder=\"Enter price\" class=\"form-control\"></td><td><button class=\"btn btn-danger btn-sm\" ng-click=\"removePackageFromList(item)\">Remove</button></td></tr></table><div class=\"col-md-12\" ng-if=\"CLAIMED_AMOUNT >0\"><div class=\"col-md-1\"></div><div class=\"col-md-5\"><label for=\"roomName\">Total</label></div><div class=\"col-md-6\" style=\"padding-left: 260px;\"><label for=\"roomCount\">{{CLAIMED_AMOUNT}}</label></div></div><div class=\"col-md-12\" ng-if=\"isNewCategories\"><p ng-if=\"isDuplicate\" style=\"margin-left: 15px; color: red; font-size: small;\">Duplicate categories is not allowed.</p><div class=\"col-md-5\"><label for=\"roomName\">Categories name</label> <input name=\"categoriesName\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" required=\"\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Enter name\" ng-click=\"getkeywords()\" ng-model=\"dynamicFields.name\" uib-typeahead=\"item.hospitalBillDesc for item in typaheadData | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"></div><div class=\"row\" style=\"background-color: aliceblue; border-radius: 10px;\" ng-if=\"form.isgovtscheme && govPackageData.length >0\"><div class=\"col-md-12\"><table class=\"table table-hover table-link\"><thead><th class=\"patientName text-left\">Name</th><th ng-show=\"isMandatoryDocumentView\" class=\"patientName text-left\">Required Documents</th><th class=\"patientName text-center\">Price</th><th class=\"patientName text-center\">Action</th></thead><tbody><tr tooltip-placement=\"top\" ng-repeat=\"sel_package in govPackageData\"><td class=\"text-left\">{{sel_package.packageName}}</td><td class=\"text-left\" ng-show=\"isMandatoryDocumentView\">{{sel_package.mandatoryDocuments}}</td><td style=\"width: 15%\" class=\"text-center\">{{sel_package.packageCost}} <span ng-show=\"sel_package.isPerDayEligiblePackage === true\">* {{noOfDays}} days</span></td><td style=\"width: 15%\" class=\"text-center\"><button class=\"btn btn-danger btn-xs\" ng-click=\"removeGovPackage(sel_package)\">Remove</button></td></tr><tr tooltip-placement=\"top\" ng-if=\"govPackageData.length >0\"><td class=\"text-left\" style=\"font-size: large;color: black;\">Total</td><td class=\"text-center\" style=\"font-size: large;color: black;\"><span class=\"text-center\">{{totalCalcAmount}}</span></td><td class=\"text-center\" style=\"font-size: large;color: black;\"></td></tr></tbody></table></div></div><div class=\"col-md-1\"><button ng-disabled=\"!dynamicFields.name ||!dynamicFields.price\" ng-click=\"addMoreCategories(true, dynamicFields, selectedObject)\" class=\"btn btn-primary\" style=\"margin-top: 23px;\"><span class=\"glyphicon glyphicon-plus-sign\"></span> Add</button></div><div class=\"col-md-1\"><button class=\"btn btn-default\" ng-click=\"closeButton()\" style=\"margin-top: 23px; margin-left: 10px;\">Close</button></div><div class=\"col-md-1\"></div></div></div></div></div><button type=\"button\" style=\"margin-top: -28px; margin-right: 50px;\" class=\"btn btn-primary pull-right\" ng-click=\"saveDetails()\">Submit</button></form></div></div></div></div><message background=\"msg.background\" body=\"msg.body\" header=\"msg.header\" show=\"msg.show\"></message></div>");
$templateCache.put("app/components/newAdmissionForm/newAdmissionForm_Cataract.html","<div id=\"tabclaim-new\" class=\"new-admission\"><div class=\"panel panel-default\" id=\"new-claim-success\" ng-show=\"form.preauthSuccess\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\" style=\"background-color: #4cc0c1;\"><h4 class=\"chat-status text-center\">Your claim has been created successfully! details can be viewed from list of \"Pending for Acknowledgement\".</h4></div></div><div class=\"col-md-2\"></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2 pull-right\" style=\"margin-left: -40px;\"><button style=\"background-color: #e6e6e6;\" class=\"btn btn-default\" ng-click=\"preauthFormAction.closePreauthForm()\">Back to claims list</button></div><div class=\"col-md-2 pull-right\"><button class=\"btn btn-primary\" ng-click=\"redirectUrl()\">New Admission</button></div></div></div></div><div class=\"panel panel-default\" id=\"new-claim-fail\" ng-show=\"form.preauthError\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-1\"></div><div class=\"col-md-10\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\" style=\"background-color: #4cc0c1;\"><h4 class=\"chat-status text-left\">Oops! There seems to be a problem and your claim is not created.</h4><p>Possible reasons could be :</p><ol><li>Invalid details entered</li><li>Invalid file formats or more number of files uploaded</li></ol><h4 class=\"chat-status text-left\">Please check the details, required files and create it again. Thank you.</h4></div></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2 pull-right\" style=\"margin-left: -40px;\"><button style=\"background-color: #e6e6e6;\" class=\"btn btn-default\" ng-click=\"preauthFormAction.closePreauthForm()\">Back to claims list</button></div><div class=\"col-md-2 pull-right\"><button class=\"btn btn-primary\" ng-click=\"redirectUrl()\">New Admission</button></div></div></div></div><style>\n        .radioBtns {\n            font-weight: normal;\n            font-size: 18px;\n        }\n        \n        .radioBtns label {\n            font-weight: normal;\n            margin-left: 20px;\n            display: inline-block!important;\n        }\n        \n        .radioBtns label.sel {\n            color: #F05A1A;\n            font-weight: 400;\n        }\n        \n        .radioBtns span.sel {\n            color: #F05A1A;\n            font-weight: 400;\n        }\n        \n        .inputInline {\n            padding: 20px 0;\n        }\n        \n        .inputInline input,\n        .inputInline button {\n            border-radius: 0!important;\n            border-radius: 0!important;\n        }\n        \n        .inputInline button {\n            margin-top: 23px;\n        }\n        \n        .inputInline input.first {\n            border-top-left-radius: 4px!important;\n            border-bottom-left-radius: 4px!important;\n        }\n        \n        .inputInline input.last,\n        .inputInline button {\n            border-top-right-radius: 4px!important;\n            border-bottom-right-radius: 4px!important;\n        }\n        \n        .inputInline .btn.last {\n            border-bottom-right-radius: 0!important;\n            border-top-right-radius: 0!important;\n        }\n        \n        .benefCard .bx.primary {\n            background: #4cc0c1;\n            padding: 20px;\n            color: #fff;\n            border-radius: 3px;\n        }\n        \n        .benefCard .col-xs-4 {\n            padding: 0 10px;\n        }\n        \n        .benefCard p {\n            margin: 0 0 15px 0;\n            font-size: 18px;\n            font-weight: normal;\n        }\n        \n        .benefCard p span {\n            display: block;\n            font-size: 12px;\n            color: #024e4e;\n        }\n        \n        .benefCard .bx {\n            font-size: 16px;\n            background: #efefef;\n            border-radius: 3px;\n            margin-bottom: 20px;\n            display: block;\n            padding: 15px;\n            text-decoration: none;\n        }\n        \n        .benefCard .bx span {\n            display: block;\n            font-size: 12px;\n            color: #666;\n        }\n        \n        .benefCard .bx:hover,\n        .benefCard .bx .sel {\n            background: #4d4d4d;\n            color: #fff;\n            text-decoration: none;\n        }\n        \n        .benefCard .bx:hover span,\n        .benefCard .bx .sel span,\n        .benefCard .bx b {\n            color: #a9d7ff;\n        }\n        \n        .textErrorMsg {\n            float: right;\n            font-size: 11px;\n            color: #f00;\n            font-weight: normal;\n        }\n        \n        .new-admission h3 {\n            color: #14bcc8;\n            font-size: 22px;\n            border-bottom: 2px solid #14bcc8;\n            margin: 20px 0;\n            padding-bottom: 5px;\n        }\n        \n        .form-control.danger {\n            border-color: #f00;\n        }\n        \n        .form-control.success {\n            border-color: #5cb85c;\n        }\n        \n        .new-admission input[type=\"radio\"],\n        .new-admission input[type=\"checkbox\"] {\n            margin: 2px 0 0 !important;\n        }\n        \n        .new-admission .radio input[type=\"radio\"],\n        .new-admission .radio-inline input[type=\"radio\"],\n        .new-admission .checkbox input[type=\"checkbox\"],\n        .new-admission .checkbox-inline input[type=\"checkbox\"] {\n            margin-left: -15px !important;\n        }\n        \n        .new-admission input[type=\"radio\"],\n        .new-admission input[type=\"checkbox\"] {\n            margin: 3px 0 0 !important;\n        }\n    </style><script type=\"text/ng-template\" id=\"govCustomPopupTemplate.html\"><div class=\"custom-popup-wrapper\" ng-style=\"{top: position().top+\'px\', left: position().left+\'px\'}\" style=\"display: block;\" ng-show=\"isOpen() && !moveInProgress\" aria-hidden=\"{{!isOpen()}}\"> <table class=\"table table-hover\"> <tr ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.id}}\"> <td width=\"200px\">{{match.model.govPackageName}}</td> </tr> </table> </div></script><script type=\"text/ng-template\" id=\"customPopupTemplate.html\"><div class=\"custom-popup-wrapper\" ng-style=\"{top: position().top+\'px\', left: position().left+\'px\'}\" style=\"display: block;\" ng-show=\"isOpen() && !moveInProgress\" aria-hidden=\"{{!isOpen()}}\"> <table class=\"table table-hover\"> <tr ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.id}}\"> <td width=\"200px\">{{match.model.package_Name}}</td> </tr> </table> </div></script><div ng-if=\"!admissionFromSearchFlag.openDetailsTab\"><h3 class=\"m-t-0\" style=\"border:0 none;\">Identify your customer <span class=\"m-t-0\" style=\"color: #000000;font-size: 14px;\">(Choose any of the following to auto-fill customer details. Use primary beneficiary ID to search other dependents.)</span></h3><h4 style=\"margin-top:10px;\" class=\"radioBtns\">I have <label ng-repeat=\"item in newAdmissionFormData\"><input type=\"radio\" name=\"pageSet\" ng-click=\"formSelection(item.name, item.selected)\" ng-model=\"newAdmissionFormModel\" ng-value=\"item\"> <span ng-class=\"{\'sel\' :item.selected}\">{{item.name}}</span></label></h4><a ng-click=\"formSelection(\'Add Manually\', admissionFromSearchFlag.urnNumber)\" style=\"color: blue;\">Click here to add manually</a><h4 ng-if=\"isCheckGovhosp()\" style=\"margin-top:10px;\" class=\"radioBtns\">I don\'t have details <a ng-click=\"formSelection(\'Add Manually\', admissionFromSearchFlag.urnNumber)\" style=\"color: blue;\">Click here to add manually</a></h4><form name=\"formMaid\" style=\"margin-top: -15px;\"><div class=\"row inputInline\" ng-if=\"admissionFromSearchFlag.maidOrDhsid\"><div class=\"col-md-5 p-r-0\"><label for=\"\">Medi Assist or DHSID</label> <input autocomplete=\"off\" ng-model=\"newAdmissionSearch.maidOrDhsid\" name=\"maid\" class=\"form-control first\" type=\"text\" placeholder=\"Enter MAID or DHSID\" ng-required=\"true\"></div><div class=\"col-md-5 p-r-0 p-l-0\"><label for=\"\">Beneficiary name</label> <input name=\"benefName\" autocomplete=\"off\" ng-model=\"newAdmissionSearch.benefName\" class=\"form-control\" type=\"text\" placeholder=\"Enter benef name\" ng-required=\"true\"></div><div class=\"col-md-2 p-l-0\"><button ng-disabled=\"!newAdmissionSearch.maidOrDhsid || !newAdmissionSearch.benefName\" ng-click=\"getDetailsWithMaid(newAdmissionSearch.maidOrDhsid,newAdmissionSearch.benefName)\" type=\"button\" class=\"btn btn-primary last\">Search</button></div></div><div class=\"row inputInline\" ng-if=\"admissionFromSearchFlag.employeeId\"><div class=\"col-md-4 p-r-0\"><label for=\"\">Employee ID</label> <input ng-model=\"fastrack.employeeId\" name=\"empid\" class=\"form-control first\" type=\"text\" placeholder=\"Enter employee / family number\" ng-required=\"true\"></div><div class=\"col-md-3 p-l-0 p-r-0\"><label for=\"\">Company\'s name</label> <input ng-model=\"fastrack.corporateName\" name=\"compname\" class=\"form-control\" type=\"text\" placeholder=\"Enter company name\" ng-required=\"true\"></div><div class=\"col-md-3 p-l-0 p-r-0\"><label for=\"\">Beneficiary name</label> <input ng-model=\"fastrack.BeneficiaryName\" name=\"benefname\" class=\"form-control\" type=\"text\" placeholder=\"Enter benef name\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getDetailsWithEmpId(fastrack.employeeId,fastrack.corporateName,fastrack.BeneficiaryName): \'\'\"></div><div class=\"col-md-2 p-l-0 p-r-0\"><button ng-disabled=\"!fastrack.BeneficiaryName || !fastrack.corporateName || !fastrack.employeeId\" ng-click=\"getDetailsWithEmpId(fastrack.employeeId,fastrack.corporateName,fastrack.BeneficiaryName)\" type=\"button\" class=\"btn btn-primary\">Search</button></div></div><div class=\"row inputInline\" ng-if=\"admissionFromSearchFlag.policyno\"><div class=\"col-md-5 p-r-0\"><label for=\"\">Policy number</label> <input ng-model=\"fastrack.PolicyNo\" class=\"form-control first\" type=\"text\" placeholder=\"Enter policy number\" ng-required=\"true\"></div><div class=\"col-md-5 p-l-0 p-r-0\"><label for=\"\">Beneficiary name</label> <input ng-model=\"fastrack.BeneficiaryName\" class=\"form-control\" type=\"text\" placeholder=\"Enter benef name\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getDetailsWithPolicy(fastrack.PolicyNo,fastrack.BeneficiaryName): \'\'\"></div><div class=\"col-md-2 p-l-0\"><button ng-disabled=\"!fastrack.PolicyNo || !fastrack.BeneficiaryName\" ng-click=\"getDetailsWithPolicy(fastrack.PolicyNo,fastrack.BeneficiaryName)\" type=\"button\" class=\"btn btn-primary\">Search</button></div></div><div class=\"row inputInline\" ng-if=\"admissionFromSearchFlag.typeGovClaim\"><div class=\"col-md-7 p-r-0\"><div class=\"btn-group btn-group-justified\"><h4 style=\"margin-top:10px;\" class=\"radioBtns\">Select scheme <span class=\"text-danger\">*</span> <label ng-repeat=\"item in govtSchemeType\"><input type=\"radio\" name=\"pageSet\" ng-click=\"formSchemeSelection(item.name, item.selected)\" ng-model=\"newAdmissionFormModel\" ng-value=\"item\"> <span ng-class=\"{\'sel\' :item.selected}\">{{item.name}}</span></label></h4></div></div></div><div class=\"row inputInline\" ng-if=\"admissionFromSearchFlag.urnNumberManipurScheme\"><div class=\"col-md-3 p-r-0\"><div class=\"form-group\"><label for=\"\">URN number</label> <input ng-model=\"govSearchValueInModel.urn\" name=\"urn\" class=\"form-control\" type=\"text\" placeholder=\"Enter URN number\" ng-required=\"true\" ng-change=\"resetModel();\"></div></div><div class=\"col-md-2 p-l-0\"><button ng-disabled=\"!govSearchValueInModel.urn\" ng-click=\"getDetailsWithGov(govSearchValueInModel.urn,govSearchValueInModel.apbyname,\'manipur scheme\')\" type=\"button\" class=\"btn btn-primary\">Search</button></div></div><div class=\"row inputInline\" ng-if=\"admissionFromSearchFlag.urnNumber\"><div class=\"col-md-7 p-r-0\"><label for=\"patientFirstName\">Which error you are getting? <span class=\"text-danger\">*</span></label><div class=\"btn-group btn-group-justified\"><label class=\"btn btn-default first\" ng-model=\"checkboxErrorModel.error\" uib-btn-checkbox=\"\">Chip error</label> <label class=\"btn btn-default\" ng-model=\"checkboxErrorModel.fingerPrint\" uib-btn-checkbox=\"\">Finger print issue</label> <label class=\"btn btn-default\" ng-model=\"checkboxErrorModel.package\" uib-btn-checkbox=\"\">Package approval</label> <label class=\"btn btn-default last\" ng-model=\"checkboxErrorModel.other\" uib-btn-checkbox=\"\">Others</label></div></div><div class=\"col-md-3 p-r-0 p-l-0\"><div class=\"form-group\"><label for=\"\">URN number</label> <input ng-model=\"govSearchValueInModel.urn\" name=\"urn\" class=\"form-control\" type=\"text\" placeholder=\"Enter URN number\" ng-required=\"true\" ng-change=\"resetModel();\"></div></div><div class=\"col-md-4 p-l-0 p-r-0\" ng-show=\"selectedSchemeForGov===\'APCMUHIS_Mediassist\'\"><div class=\"form-group\"><label for=\"\">Member name</label> <input ng-model=\"govSearchValueInModel.apbyname\" name=\"MemberNameAPBY\" class=\"form-control\" type=\"text\" placeholder=\"Enter member name\" ng-required=\"true\"></div></div><div class=\"col-md-2 p-l-0\"><button ng-disabled=\"!govSearchValueInModel.urn || !(checkboxErrorModel.other || checkboxErrorModel.package || checkboxErrorModel.fingerPrint || checkboxErrorModel.error)\" ng-click=\"getDetailsWithGov(govSearchValueInModel.urn,govSearchValueInModel.apbyname)\" type=\"button\" class=\"btn btn-primary\">Search</button></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">\"{{govSearchValueInModel.urn}}\" is not available in Post Enroll Data or <a ng-click=\"formSelection(\'Add Manually\', admissionFromSearchFlag.govClaim)\" style=\"color: blue;\">Click here to add manually</a></p><p class=\"bg-danger\" ng-if=\"isECashLess\">{{eCashLessMessage}}<button class=\"btn btn-xs btn-primary\" ng-click=\"reDirect(\'planned\')\">yes</button></p></form></div><div class=\"row benefCard\" ng-show=\"govtBenefList.length >0\"><p class=\"bg-info\" style=\"font-size: initial;font-weight: 600;\">URN : \"{{govSearchValueInModel.urn}}\" is available in Post Enroll Data.<select class=\"form-control\" style=\"width: 30%; display: inline-block;\" ng-model=\"selectedIndex\" ng-options=\"item.displayName for item in govtBenefList\" ng-change=\"fastrackPopulateNewAdmissionGov(selectedIndex)\"><option value=\"\">--Select beneficiary--</option></select></p></div><div class=\"row benefCard\" ng-show=\"newAdmissionSearch.benefRelationList.length >0\"><div class=\"col-xs-4\" style=\"padding:0 15px;\"><div class=\"bx primary\"><p><span>Name</span>{{benefRelationData.benefName}}</p><p><span>Corporate name</span>{{benefRelationData.benefPolHldrName}}</p></div></div><div class=\"col-xs-8\"><div class=\"row\"><div class=\"col-xs-4\" ng-repeat=\"relation in newAdmissionSearch.benefRelationList\"><div class=\"bx\"><a ng-click=\"fastrackPopulateNewAdmission(fastrack.empMaid, relation.relationId, relation.name, relation);\" ng-class=\"relation.isSelected === true ? \'sel\' : \'\'\">{{relation.name}} <span>{{relation.maId}} <i ng-if=\"relation.relationName\">|</i> {{relation.relationName}}<i ng-if=\"relation.benefMediAssistID\">|</i> {{relation.benefMediAssistID}} <i ng-if=\"relation.insurerShortName\">|</i>{{relation.insurerShortName}}</span></a></div></div></div></div></div><div ng-show=\"!form.preauthSuccess && !form.preauthError\"><div class=\"chat-content_wrap\"><div class=\"chat-content\" ng-if=\"admissionFromSearchFlag.addManually || admissionFromSearchFlag.openDetailsTab\"><div style=\"margin-bottom: -20px;text-decoration: underline;\"><a ng-if=\"!isPPN()\" style=\"font-size: initial;\" ng-click=\"downloadPPNFile()\"><i class=\"fa fa-download\"></i> NETWORK HOSPITAL - DECLARATION BY PATIENT/PATIENT’S ATTENDANT</a> <a ng-if=\"isPPN()\" style=\"font-size: initial;\" ng-click=\"downloadNonPPNFile()\"><i class=\"fa fa-download\"></i> PPN NETWORK - DECLARATION BY PATIENT/PATIENT’S ATTENDANT</a></div><ng-form id=\"myForm\" novalidate=\"\" name=\"signup_form\"><button class=\"btn btn-default pull-right\" ng-if=\"source !== \'preClaim\'\" ng-click=\"searchAgain()\" style=\"margin-top:-115px;background-color: #ccc;\">Search again</button> <button type=\"submit\" style=\"margin-top:-115px;margin-right: 5px;\" class=\"btn btn-primary pull-right\" id=\"newAdmissionButton\" ng-click=\"source==\'preClaim\'?preClaimInfoRelatedMethods.submitPreClaimPreauthForm():preauthFormAction.submitPreauthForm()\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR) || (isdod ||isdoa) || isProcessing\">Submit New Admission</button><h3>Customer details</h3><div class=\"row\"><div class=\"col-md-4\" ng-if=\"admissionFromSearchFlag.hideSomeFields\"><div class=\"form-group\"><label for=\"patientFirstName\">Full name <span class=\"text-danger\">*</span><span class=\"textErrorMsg\" ng-show=\"signup_form.patientFirstName.$dirty && signup_form.patientFirstName.$invalid\">Your name is required.</span></label> <input name=\"patientFirstName\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Patient full name\" ng-model=\"form.fullname\" required=\"\"></div></div><div class=\"col-md-4\" ng-if=\"govReadonly()\"><div class=\"form-group\"><label for=\"patientFirstName\">Full name <span class=\"text-danger\">*</span><span class=\"textErrorMsg\" ng-show=\"signup_form.patientFirstName.$dirty && signup_form.patientFirstName.$invalid\">Your name is required.</span></label> <input name=\"patientFirstName\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Patient full name\" ng-model=\"form.fullname\" required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"contactNum\">Mobile number <span class=\"text-danger\">*</span><span class=\"textErrorMsg\" ng-show=\"signup_form.contactNum.$error.pattern || (signup_form.contactNum.$dirty && signup_form.contactNum.$invalid) || signup_form.contactNum.$error.number || signup_form.contactNum.$error.minlength || signup_form.contactNum.$error.maxlength\">Enter valid mobile number</span></label> <input name=\"contactNum\" autocomplete=\"off\" type=\"text\" class=\"form-control\" ng-pattern=\"/^((7|8|9)).{9}$/\" ng-change=\"mobileValidation(form.mobile)\" numbers-only=\"numbers-only\" placeholder=\"Enter mobile number\" ng-model=\"form.mobile\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\"></div></div><div class=\"col-md-4\" ng-if=\"form.isgovtscheme\"><div class=\"form-group\"><label for=\"memberDist\">Member district</label> <input name=\"memberDist\" autocomplete=\"off\" placeholder=\"Enter member district\" class=\"form-control\" type=\"text\" ng-model=\"form.memberDist\"></div></div><div class=\"col-md-4\" ng-if=\"form.isgovtscheme\"><div class=\"form-group\" ng-if=\"!govReadonly()\"><label for=\"urnNUmber\">URN number</label> <input name=\"urnNUmber\" autocomplete=\"off\" placeholder=\"Enter urn number\" class=\"form-control\" type=\"text\" ng-model=\"form.URNNum\"></div><div class=\"form-group\" ng-if=\"govReadonly()\"><label for=\"urnNUmber\">URN number</label> <input name=\"urnNUmber\" autocomplete=\"off\" readonly=\"true\" placeholder=\"Enter urn number\" class=\"form-control\" type=\"text\" ng-model=\"form.URNNum\"></div></div><div class=\"col-md-4\" ng-if=\"form.isgovtscheme\"><div class=\"form-group\"><label for=\"memberGender\">Member gender</label><select name=\"memberGender\" ng-model=\"form.memberGender\" class=\"form-control\"><option value=\"\">Select Gender</option><option value=\"male\">Male</option><option value=\"female\">Female</option></select></div></div><div class=\"col-md-4\" ng-if=\"form.isgovtscheme\"><div class=\"form-group\"><label for=\"memberAge\">Member Age</label> <input name=\"memberAge\" autocomplete=\"off\" placeholder=\"Enter member age\" class=\"form-control\" type=\"number\" ng-model=\"form.memberAge\"></div></div><div class=\"col-md-4\" ng-if=\"form.isgovtscheme\"><div class=\"form-group\"><label for=\"memberId\">Member Id <span class=\"text-danger\">*</span></label> <input name=\"memberId\" autocomplete=\"off\" type=\"number\" class=\"form-control\" placeholder=\"Enter your Member Id\" ng-model=\"form.memberId\"></div></div><div class=\"col-md-4\" ng-if=\"!form.isgovtscheme && admissionFromSearchFlag.hideSomeFields\"><div class=\"form-group\"><label for=\"policyno\">Policy number <span ng-show=\"!(form.maid.toString().length>0||(form.employer.length>0 && form.empid.length>0))\"><span class=\"text-danger\">*</span></span></label> <input type=\"text\" id=\"policyno\" name=\"policynumber\" class=\"form-control\" placeholder=\"Enter policy number\" ng-model=\"form.policyno\" ng-required=\"!(form.maid.toString().length>0||(form.employer.length>0 && form.empid.length>0))\"></div></div><div class=\"col-md-4\" ng-if=\"!form.isgovtscheme && admissionFromSearchFlag.hideSomeFields\"><div class=\"form-group\"><label for=\"insurername\">Insurer name</label><select name=\"insurername\" class=\"form-control\" ng-change=\"getPackagesListForInsurer(form.insurername)\" ng-model=\"form.insurername\"><option value=\"\">--Select Insurer Name--</option><option ng-repeat=\"obj in insurerList | orderBy:\'insurerFullName\'\">{{obj.insurerFullName}}</option></select></div></div><div class=\"col-md-4\" ng-if=\"!form.isgovtscheme && admissionFromSearchFlag.hideSomeFields\"><div class=\"form-group\"><label for=\"employer\">Corporate name <span ng-show=\"!(form.maid.toString().length >0||form.policyno.length>0)\"><span class=\"text-danger\">*</span></span></label> <input name=\"employer\" autocomplete=\"off\" id=\"preauthemployer\" type=\"text\" class=\"form-control\" placeholder=\"Enter corporate name\" ng-model=\"form.employer\" ng-required=\"!(form.maid.toString().length >0||form.policyno.length>0)\"></div></div><div class=\"col-md-4\" ng-if=\"!form.isgovtscheme && admissionFromSearchFlag.hideSomeFields\"><div class=\"form-group\"><label for=\"empid\">Employee Id <span ng-show=\"!(form.maid.toString().length >0||form.policyno.length>0)\"><span class=\"text-danger\">*</span></span></label> <input name=\"empid\" autocomplete=\"off\" id=\"preauthempid\" type=\"text\" class=\"form-control\" placeholder=\"Enter employee ID\" ng-model=\"form.empid\" ng-required=\"!(form.maid.toString().length >0||form.policyno.length>0)\"></div></div><div class=\"col-md-4\" ng-if=\"!form.isgovtscheme && isShowMaid &&admissionFromSearchFlag.hideSomeFields\"><div class=\"form-group\"><label for=\"maid\">MAID <span ng-show=\"!(form.policyno.length>0||(form.employer.length>0 && form.empid.length>0))\"><span class=\"text-danger\">*</span></span><span class=\"textErrorMsg\" ng-show=\"signup_form.maid.$error.number\">MAID can contain only numbers</span></label> <input name=\"maid\" numbers-only=\"numbers-only\" autocomplete=\"off\" id=\"preauthmaid\" type=\"text\" class=\"form-control\" placeholder=\"Enter MAID\" ng-model=\"form.maid\" ng-required=\"!(form.policyno.length>0||(form.employer.length>0 && form.empid.length>0))\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"ipnumber\"><span ng-if=\"newAdmissionFormModel === \'RSBY\'\">Registration Invoice Number</span> <span ng-if=\"newAdmissionFormModel != \'RSBY\'\">In patient number</span><span ng-if=\"newAdmissionFormModel === \'RSBY\'\" class=\"text-danger\">*</span><span ng-if=\"newAdmissionFormModel === \'RSBY\'\" class=\"textErrorMsg\" ng-show=\"(signup_form.ipnumber.$dirty && signup_form.ipnumber.$invalid) || signup_form.ipnumber.$error.number\">Inpatient number is required</span></label> <input ng-if=\"newAdmissionFormModel === \'RSBY\'\" name=\"ipnumber\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Enter IP no. for faster search and reconciliation\" ng-model=\"form.ipnumber\" required=\"\"> <input ng-if=\"newAdmissionFormModel != \'RSBY\'\" name=\"ipnumber\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Enter IP no. for faster search and reconciliation\" ng-model=\"form.ipnumber\"></div></div><div class=\"col-md-4\" ng-if=\"!form.isgovtscheme && !isShowMaid\"><div class=\"form-group\"><label for=\"patientUniqeId\">Patient unique id <span ng-show=\"!(form.policyno.length>0||(form.employer.length>0 && form.patientUniqeId.length>0))\"><span class=\"text-danger\">*</span></span><span class=\"textErrorMsg\" ng-show=\"(signup_form.patientUniqeId.$dirty && signup_form.patientUniqeId.$invalid) || signup_form.patientUniqeId.$error.number\">Enter valid MAID</span></label> <input name=\"patientUniqeId\" autocomplete=\"off\" id=\"preauthmaid\" min=\"0\" class=\"form-control\" placeholder=\"Enter patient unique id\" ng-model=\"form.uniqueId\" ng-required=\"!(form.policyno.length>0||(form.employer.length>0 && form.patientUniqeId.length>0))\"></div></div><div class=\"col-md-4\" ng-if=\"form.isgovtscheme\"><div class=\"form-group\"><label for=\"aadharNo\">Aadhaar Number</label> <input name=\"aadharNo\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Enter aadhaar number\" ng-model=\"form.aadharNo\"></div></div></div><h3>Treatment details</h3><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"doa\">Date of admission <span class=\"text-danger\">*</span><span class=\"textErrorMsg\" ng-show=\"(signup_form.doa.$dirty && signup_form.doa.$invalid) || signup_form.doa.$error.datetimelocal || isdoa\">Enter valid date of admission</span></label><div class=\"input-group\"><input name=\"doa\" id=\"datetimepicker\" placeholder=\"Select date of admission\" readonly=\"\" type=\"text\" class=\"form-control\" ng-change=\"dateOfAdmission(form.dod, \'doa\')\" uib-datepicker-popup=\"{{format}}\" ng-model=\"form.doa\" is-open=\"datePopup.doa\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDoa()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"dod\">Date of discharge <span class=\"text-danger\">*</span><span class=\"textErrorMsg\" ng-show=\"(signup_form.dod.$dirty && signup_form.dod.$invalid) || isdod\">Enter valid date of discharge</span></label><div class=\"input-group\"><input placeholder=\"Select date of discharge\" readonly=\"\" name=\"dod\" type=\"text\" id=\"dischargetimepicker\" class=\"form-control\" ng-change=\"dateOfAdmission(form.doa, \'dod\')\" uib-datepicker-popup=\"{{format}}\" ng-model=\"form.dod\" is-open=\"datePopup.dod\" datepicker-options=\"dateOptions1\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDod()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnosis <span class=\"text-danger\">*</span></label> <textarea name=\"diagnosis\" class=\"form-control\" placeholder=\"Enter diagnosis details\" ng-model=\"form.diagnosis\" required=\"\" style=\"height:36px;\"></textarea></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"DiseaseName\">Disease name <span class=\"text-danger\">*</span></label> <input name=\"DiseaseName\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" placeholder=\"Type disease name\" required=\"\" ng-model=\"form.diseaseDetails\" uib-typeahead=\"ailment as ailment.AilmentName for ailment in ailmentDetails | filter:$viewValue\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" class=\"search-filter form-control src-health-need\"></div>{{form.diseaseDetails}}</div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"TreatmentName\">Treatment Name<span class=\"text-danger\">*</span></label> <input name=\"TreatmentName\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" placeholder=\"Type Treatment name\" required=\"\" ng-model=\"form.treatment\" uib-typeahead=\"treatment as treatment.treatmentName for treatment in treatmentForAilment | filter:$viewValue\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" class=\"search-filter form-control src-health-need\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"LenseType\">Lense Type<span class=\"text-danger\">*</span></label><select name=\"LenseType\" class=\"form-control\" ng-model=\"form.lenseType\"><option value=\"\">--Select Lense Type--</option><option value=\"{{obj.ID}}\" ng-repeat=\"obj in lenseMaster\">{{obj.LenseType}}</option></select></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"docName\">Doctor name <span class=\"text-danger\">*</span></label> <input name=\"docName\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Type doctor name\" required=\"\" ng-click=\"getkeywords()\" ng-model=\"form.docname\" uib-typeahead=\"condition.doctorName for condition in doctorDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"roomType\">Provided room type <span class=\"text-danger\">*</span></label> <input name=\"roomType\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" required=\"\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Type provided room type\" ng-click=\"getkeywords()\" ng-model=\"form.roomtype\" uib-typeahead=\"item.hospitalRoomType for item in roomsDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"></div></div></div><div class=\"row\" ng-if=\"form.isgovtscheme\"><div class=\"col-md-8\"><div class=\"form-group\"><label for=\"docName\">Government package <span class=\"text-danger\">*</span></label> <input type=\"text\" name=\"GovPackage\" ng-change=\"typeProcedureName()\" ng-model=\"form.govPackagesname\" placeholder=\"Type package name...\" uib-typeahead=\"condition.govPackageName for condition in govtPackageList | filter:$viewValue | limitTo:5\" typeahead-on-select=\"selectGovePackage($item, $model)\" typeahead-popup-template-url=\"govCustomPopupTemplate.html\" class=\"form-control\"></div></div><div class=\"col-md-3\" ng-if=\"!isSelectedGov\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label> <input name=\"procedureName\" placeholder=\"Enter price\" class=\"form-control\" autocomplete=\"off\" ng-model=\"govPackageManually.price\" type=\"text\" numbers-only=\"numbers-only\"></div></div><div class=\"col-md-3\" ng-if=\"isSelectedGov\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label><select name=\"procedurePrice\" class=\"form-control\" ng-model=\"govPackageManually.price\"><option value=\"\">--Select Price--</option><option value=\"{{obj.price}}\" ng-repeat=\"obj in priceForGovPackage | orderBy:\'obj\'\">{{obj.price}}</option></select></div></div><div class=\"col-md-1\" style=\"margin-top: 22px;\"><div class=\"form-group\"><button ng-disabled=\"!(govPackageManually.price && form.govPackagesname)\" class=\"btn btn-primary\" ng-click=\"addGovPackageManually( form.govPackagesname, govPackageManually, isSelectedGov)\">Add</button></div></div></div><div class=\"row\" style=\"background-color: aliceblue; border-radius: 10px;\" ng-if=\"form.isgovtscheme && govPackageData.length >0\"><div class=\"col-md-12\"><table class=\"table table-hover table-link\"><thead><th class=\"patientName text-left\">Name</th><th class=\"patientName text-center\">Price</th><th class=\"patientName text-center\">Action</th></thead><tbody><tr tooltip-placement=\"top\" ng-repeat=\"sel_package in govPackageData\"><td class=\"text-left\">{{sel_package.packageName}}</td><td style=\"width: 15%\" class=\"text-center\">{{sel_package.packageCost}}<span ng-show=\"sel_package.isPerDayEligiblePackage === true\">* {{noOfDays}} days</span></td><td style=\"width: 15%\" class=\"text-center\"><button class=\"btn btn-danger btn-xs\" ng-click=\"removeGovPackage(sel_package)\">Remove</button></td></tr><tr tooltip-placement=\"top\" ng-if=\"govPackageData.length >0\"><td class=\"text-left\" style=\"font-size: large;color: black;\">Total</td><td class=\"text-center\" style=\"font-size: large;color: black;\"><span class=\"text-center\">{{totalCalcAmount}}</span></td><td class=\"text-center\" style=\"font-size: large;color: black;\"></td></tr></tbody></table></div></div><div class=\"row\" ng-if=\"!form.isgovtscheme && form.PreAuthForIRRemarks ===\'\'\"><div class=\"col-md-8\"><div class=\"form-group\"><label for=\"TreatmentDetails\">Treatment details<span class=\"text-danger\">*</span></label> <input type=\"text\" ng-model=\"procedureManually.name\" ng-change=\"typeProcedureName()\" placeholder=\"Enter treatment details...\" uib-typeahead=\"condition.package_Name for condition in totalListOfPackage | filter:$viewValue | limitTo:5\" typeahead-on-select=\"selectPackageFromList($item, $model)\" typeahead-popup-template-url=\"customPopupTemplate.html\" class=\"form-control\"></div></div><div class=\"col-md-3\" ng-if=\"!isPriceDropDown\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label> <input name=\"procedureName\" placeholder=\"Enter price\" class=\"form-control\" autocomplete=\"off\" ng-model=\"procedureManually.price\" type=\"text\" numbers-only=\"numbers-only\"></div></div><div class=\"col-md-3\" ng-if=\"isPriceDropDown\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label><select name=\"procedurePrice\" class=\"form-control\" ng-model=\"procedureManually.price\"><option value=\"\">--Select Price--</option><option value=\"{{obj.price}}\" ng-repeat=\"obj in priceForPackage | orderBy:\'obj\'\">{{obj.price}} ({{obj.name}})</option></select></div></div><div class=\"col-md-1\" style=\"margin-top: 22px;\"><div class=\"form-group\"><button class=\"btn btn-primary\" ng-click=\"addManuallyProcedure(procedureManually, isPriceDropDown)\">Add</button></div></div></div><div class=\"row\" ng-if=\"!form.isgovtscheme && form.PreAuthForIRRemarks !=\'\'\"><p style=\"margin-left: 50px;\">Remark :- <strong>{{form.PreAuthForIRRemarks}};</strong></p><p style=\"margin-left: 115px;margin-top: -8px;\">and all other supporting documents for faster processing of a claim.</p></div><div style=\"background-color: aliceblue; border-radius: 10px;\" ng-if=\"selectedMappedpackages.length >0 && CLAIMED_AMOUNT\"><table class=\"table table-hover table-link\" ng-if=\"tabname != \'Planned Requests\'\"><thead><tr><th class=\"patientName text-left\">Name</th><th class=\"claimedAmount text-center\">Price</th><th class=\"claimedAmount text-center\">Action</th></tr></thead><tbody><tr tooltip-placement=\"top\" ng-repeat=\"item in selectedMappedpackages track by $index\"><td class=\"text-left\" ng-if=\"item.packageAmount > 0\">{{item.hospitaL_CHARGE_HEAD}}</td><td style=\"width: 15%\" class=\"text-center\" ng-if=\"item.packageAmount > 0\"><span class=\"text-center\">{{item.packageAmount}}</span></td><td style=\"width: 15%\" class=\"text-center\" ng-if=\"item.packageAmount > 0\"><button class=\"btn btn-danger btn-xs\" ng-click=\"removePackageFromList(item)\">Remove</button></td></tr><tr tooltip-placement=\"top\" ng-if=\"selectedMappedpackages.length >0\"><td class=\"text-left\" style=\"font-size: large;color: black;\">Total</td><td class=\"text-center\" style=\"font-size: large;color: black;\"><span class=\"text-center\">{{CLAIMED_AMOUNT}}</span></td><td class=\"text-center\" ng-if=\"CLAIMED_AMOUNT>0\"></td></tr></tbody></table></div><h3>Upload documents <small class=\"bg-danger\" style=\"font-size: 12px; display: inline-block; padding: 5px;\">Maximum file upload limit is 15 MB. <b>At least one of the documents listed below needs to be submitted.</b></small> <button class=\"btn btn-xs btn-primary\" ng-click=\"preauthFormAction.downloadPrefilledPreauthForm(\'preauthform\')\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR) || (isdod ||isdoa)\">Download Pre-filled form</button></h3><div id=\"fileupload\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Signed Pre authorization form</label><mb-file-upload action=\"action\" file-fn=\"fileFn(arg)\"></mb-file-upload></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Id proof<a tooltip-placement=\"top\" uib-tooltip=\"Driving License, Voter ID card, Corporate Employee ID, Pan car, Passport\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a></label><mb-file-upload action=\"action\" file-fn=\"fileFn(arg)\"></mb-file-upload></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnostic reports<a tooltip-placement=\"top\" uib-tooltip=\"Bio Chemistry reports, Haematology reports, Microbiology reports, Neurology reports, Pathology reports, Radiology reports\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a></label><mb-file-upload action=\"action\" file-fn=\"fileFn(arg)\"></mb-file-upload></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Other relevant documents</label><mb-file-upload action=\"action\" file-fn=\"fileFn(arg)\"></mb-file-upload></div></div></div><div class=\"row\" ng-if=\"storeFiles.length >0\"><div class=\"col-md-12\"><div class=\"label label-info\" ng-repeat=\"item in storeFiles\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: #eeeeee;\"><a ng-click=\"downloadAttachment(item.downloadURL)\">{{item.fileName}}</a> <a ng-click=\"removeFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><button type=\"submit\" class=\"btn btn-primary start pull-right\" id=\"newAdmissionButton\" style=\"margin-bottom: 25px;\" ng-click=\"source==\'preClaim\'?preClaimInfoRelatedMethods.submitPreClaimPreauthForm():preauthFormAction.submitPreauthForm()\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR) || (isdod ||isdoa) || isProcessing\"><span>Submit New Admission</span></button></div></div></div></ng-form></div></div></div><div class=\"modal fade\" id=\"{{modelPopup.text}}\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"closeModal()\">Submit</button><h4>Bill Breakup</h4></div><div class=\"modal-body\"><form name=\"dischargeSub\" novalidate=\"\"><div class=\"table-responsive\" style=\"overflow-x: hidden;overflow-y: hidden;height: 100%;\"><div class=\"table table-hover\"><div class=\"row\" style=\"margin-left:5px\"><table class=\"table table-condensed\" style=\"margin:0;\" ng-if=\"selectedMappedpackages.length >0\"><tr><th class=\"claimId\" style=\"width:275px;\">Categories <span style=\"color: red; font-size: small\">*</span></th><th class=\"claimedAmount\" style=\"width:75px;\">Price <span style=\"color: red; font-size: small\">*</span></th><th class=\"claimedAmount\" style=\"width:15px;\">Action</th></tr><tr ng-repeat=\"item in selectedMappedpackages track by $index\"><td><span style=\"margin-left:-10px\">{{$index+1}}</span> <input ng-disabled=\"item.isReadOnly\" style=\"margin-left: 8px; margin-top: -20px;\" type=\"text\" ng-model=\"item.hospitaL_CHARGE_HEAD\" placeholder=\"Enter categorie name\" class=\"form-control\"></td><td><input ng-disabled=\"item.isPackage\" type=\"text\" numbers-only=\"numbers-only\" ng-model=\"item.packageAmount\" ng-change=\"totalClaimAmount()\" placeholder=\"Enter price\" class=\"form-control\"></td><td><button class=\"btn btn-danger btn-sm\" ng-click=\"removePackageFromList(item)\">Remove</button></td></tr></table><div class=\"col-md-12\" ng-if=\"CLAIMED_AMOUNT >0\"><div class=\"col-md-1\"></div><div class=\"col-md-5\"><label for=\"roomName\">Total</label></div><div class=\"col-md-6\" style=\"padding-left: 260px;\"><label for=\"roomCount\">{{CLAIMED_AMOUNT}}</label></div></div><div class=\"col-md-12\" ng-if=\"isNewCategories\"><p ng-if=\"isDuplicate\" style=\"margin-left: 15px; color: red; font-size: small;\">Duplicate categories is not allowed.</p><div class=\"col-md-5\"><label for=\"roomName\">Categories name</label> <input name=\"categoriesName\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" required=\"\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Enter name\" ng-click=\"getkeywords()\" ng-model=\"dynamicFields.name\" uib-typeahead=\"item.hospitalBillDesc for item in typaheadData | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"></div><div class=\"col-md-4\"><label for=\"roomCount\">Price</label> <input type=\"text\" numbers-only=\"numbers-only\" ng-maxlength=\"20\" placeholder=\"Enter price\" ng-model=\"dynamicFields.price\" class=\"form-control\"></div><div class=\"col-md-1\"><button ng-disabled=\"!dynamicFields.name ||!dynamicFields.price\" ng-click=\"addMoreCategories(true, dynamicFields, selectedObject)\" class=\"btn btn-primary\" style=\"margin-top: 23px;\"><span class=\"glyphicon glyphicon-plus-sign\"></span> Add</button></div><div class=\"col-md-1\"><button class=\"btn btn-default\" ng-click=\"closeButton()\" style=\"margin-top: 23px; margin-left: 10px;\">Close</button></div><div class=\"col-md-1\"></div></div></div></div></div><button type=\"button\" style=\"margin-top: -28px; margin-right: 50px;\" class=\"btn btn-primary pull-right\" ng-click=\"saveDetails()\">Submit</button></form></div></div></div></div><message background=\"msg.background\" body=\"msg.body\" header=\"msg.header\" show=\"msg.show\"></message></div>");
$templateCache.put("app/components/newAdmissionForm_new/newAdmissionForm.html","<div id=\"tabclaim-new\"><style type=\"text/css\">\n        .common-background {\n            background-color: #f5f5f5;\n            padding: 0 15px 12px 15px;\n            margin: 1px 0;\n        }\n        \n        .error {\n            color: red;\n        }\n    </style><div class=\"panel panel-default\" id=\"new-claim-success\" ng-show=\"form.preauthSuccess\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\"><h4 class=\"chat-status text-center\">Your claim has been created successfully! details can be viewed from list of active claims.</h4></div></div><div class=\"col-md-2\"></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><button class=\"btn btn-default\" ng-click=\"preauthFormAction.closePreauthForm()\">Back to claims list</button></div><div class=\"col-md-2\"></div></div></div></div><div class=\"panel panel-default\" id=\"new-claim-fail\" ng-show=\"form.preauthError\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-1\"></div><div class=\"col-md-10\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\"><h4 class=\"chat-status text-center\">Oops! There seems to be a problem and your claim is not created.</h4><div style=\"margin-left: 50px;\"><p>Possible reasons could be :</p><ol><li>Invalid details entered</li><li>Invalid file formats or more number of files uploaded</li></ol></div><h4 class=\"chat-status text-center\">Please check the details, required files and create it again. Thank you.</h4></div></div><div class=\"col-md-1\"></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><button class=\"btn btn-default\" ng-click=\"preauthFormAction.closePreauthForm()\">Back to claims list</button></div><div class=\"col-md-2\"></div></div></div></div><div id=\"new-claim-form\" ng-show=\"!form.preauthSuccess && !form.preauthError\"><div class=\"panel panel-default\"><div class=\"row\" style=\"padding-left: 10px; padding-right: 10px;\"><div class=\"col-md-12\"><div id=\"myTabContentInner\"><div id=\"test1\"><div class=\"chat-content_wrap\"><span class=\"label label-danger\" ng-show=\"source==\'preClaim\'\">{{PreAuthForIRRemarks}}</span><hr><div class=\"row\"><div class=\"col-md-8 bg-info\" style=\"margin-top: -20px; left: 10px;\">Please enter one of the following: <span><b>or</b></span><b>MAID</b> <span><b>or</b></span> <b>Corporate name</b> and <b>Employee Id</b> <span><b>or</b></span> <b>Policy number</b> and <b>Insurer name</b></div><div class=\"col-md-4\"><div class=\"form-group\" style=\"background-color: #e55e6a; margin-top: -50px;\"><div style=\"font-size: larger;\" class=\"bg-info mandatory text-center\">All fields marked with * are mandatory</div></div></div></div><p ng-show=\"PreAuthForIR\"><label class=\"label label-danger\">Remarks:</label> <label class=\"label label-danger\">{{PreAuthForIRRemarks}}</label></p><div class=\"chat-content\"><ng-form id=\"myForm\" novalidate=\"\" name=\"signup_form\"><div class=\"row\" ng-if=\"showGovtPackages\"><div class=\"col-md-7\"><div class=\"checkbox form-group\"><label><input name=\"isGovtScheme\" type=\"checkbox\" ng-model=\"form.isgovtscheme\" ng-change=\"govtChecked()\"> Check this box if claim is an RSBY/MSBY</label></div><div class=\"checkbox form-group\"></div></div></div><div style=\"background-color: rgb(238, 238, 238); padding-left: 6px; padding-right: 4px; border-radius: 10px; padding-top: 5px; padding-bottom: 5px;\" ng-if=\"form.isgovtscheme\"><div class=\"row\" ng-if=\"form.isgovtscheme\"><div class=\"col-md-6\"><div><label>MSBY benef search</label><div class=\"col-md-12 input-group\"><input name=\"search\" type=\"text\" autocomplete=\"off\" class=\"form-control\" placeholder=\"click to search\" ng-model=\"form.MSBY\" readonly=\"\" ng-click=\"fastrackPreauthGovSeaarch(\'gov\')\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-md btn-primary\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Member search\" ng-click=\"fastrackPreauthGovSeaarch(\'gov\')\"><i class=\"test glyphicon glyphicon-search\"></i></button></span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"URNNum\">URN number</label> <input name=\"URNNum\" autocomplete=\"off\" numbers-only=\"numbers-only\" type=\"text\" class=\"form-control\" placeholder=\"Enter URN number\" ng-model=\"form.URNNum\" ng-minlength=\"17\" ng-maxlength=\"17\"></div><div class=\"error\" style=\"margin-top: -15px;\" ng-show=\"signup_form.URNNum.$invalid\"><small class=\"error\" ng-show=\"signup_form.URNNum.$invalid\">URN number should be minimum 17 digit.</small></div></div></div><div ng-if=\"isRsby\" class=\"row\" style=\"margin-top: 3px; margin-bottom: 6px;\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Select package type *</label></div></div><div class=\"col-md-3\"><div class=\"checkbox form-group\"><label><input id=\"basic\" type=\"radio\" name=\"title\" ng-model=\"govType\" value=\"B\" required=\"\" ng-click=\"changeGovtPolicyType(\'Basic\')\"> Basic</label></div><div class=\"checkbox form-group\"></div></div><div class=\"col-md-3\"><div class=\"checkbox form-group\"><label><input id=\"critical\" type=\"radio\" name=\"title\" ng-model=\"govType\" value=\"C\" required=\"\" ng-click=\"changeGovtPolicyType(\'Critical\')\"> Critical</label></div></div><small class=\"error\" ng-show=\"signup_form.title.$error.required\"></small></div><div class=\"row\" ng-if=\"form.isgovtscheme\"><div class=\"col-md-4 form-group\" ng-show=\"form.isgovtscheme\"><select name=\"reasonOnline\" ng-model=\"form.reasonOnline\" ng-change=\"govtSchemeMethods.changePackageField()\" class=\"form-control\" multiple=\"multiple\"><option value=\"chiperror\" selected=\"\">Chip Error</option><option value=\"fpnotmatching\">Finger print not matching</option><option value=\"approvalneeded\">Package needs approval</option><option value=\"others\">Unspecified/Others</option></select></div><div id=\"packageSelection\" class=\"col-md-8\"><div class=\"form-group col-md-6\" ng-if=\"showAutoPackages\"><label for=\"govtpackage\">Select a government package</label><typeahead items=\"govtPackageList\" prompt=\"Start typing package name (Enter minimum 3 characters)\" title=\"packageName\" subtitle=\"address\" subtitle2=\"packageCost\" module-flag=\"newadmission\"></typeahead></div><div class=\"col-md-4 form-group\" ng-show=\"showAutoPackages\"><label for=\"amount\">Package amount</label> <input name=\"packageAmount\" autocomplete=\"off\" id=\"autoPackageAmt\" class=\"form-control\" placeholder=\"Selected package amount\" type=\"text\" ng-model=\"form.packageAmount\" ng-disabled=\"true\" readonly=\"\"></div><div class=\"form-group col-md-6\" ng-show=\"!showAutoPackages\"><label for=\"govtpackage\">Enter the package name manually</label> <input ng-model=\"form.mPackageName\" type=\"text\" class=\"form-control\" placeholder=\"Enter the package name\"></div><div class=\"col-md-4 form-group\" ng-show=\"!showAutoPackages\"><label for=\"amount\">Enter the amount</label> <input class=\"form-control\" type=\"text\" ng-model=\"form.mPackageAmount\"></div><div class=\"col-md-2 form-group\"><br><br><button style=\"margin-top: -18px;\" id=\"packageAddBtn\" class=\"btn btn-success\" ng-click=\"govtSchemeMethods.addPackageButton()\">Add</button></div></div></div></div><div class=\"row\" ng-if=\"form.isgovtscheme && selectedPackages.length>0\"><table class=\"table table-responsive\"><thead><th>Package Name</th><th>Package Amount</th><th>Action</th></thead><tbody><tr ng-repeat=\"sel_package in selectedPackages\" ng-show=\"sel_package.id || sel_package.id==0\"><td>{{sel_package.name}}</td><td>{{sel_package.amount}}</td><td><a ng-click=\"govtSchemeMethods.removePackage(sel_package.id)\" class=\"btn btn-danger btn-xs\">{{sel_package.cappedAmount}}Remove</a></td></tr></tbody></table></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><input name=\"hospId\" id=\"formHospId\" type=\"hidden\"> <input type=\"hidden\" value=\"{{PreAuthForIR}}\" name=\"PreAuthForIR\" id=\"PreAuthForIR\"> <input type=\"hidden\" value=\"{{preAuthNo}}\" name=\"preAuthNo\" id=\"preAuthNo\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><input name=\"createdBy\" id=\"formCreatedBy\" type=\"hidden\"></div></div><input type=\"hidden\" name=\"packages\" id=\"packagesHolder\"> <input type=\"hidden\" name=\"packageAmnt\" id=\"packageAmountHolder\"> <input name=\"hospName\" id=\"formHospName\" type=\"hidden\"></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"patientFirstName\">Full name *</label><div><div class=\"col-md-12 input-group\"><input name=\"patientFirstName\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Search patient by MAID, Emp id or policy no\" ng-model=\"form.fullname\" required=\"\"> <span class=\"input-group-btn\" ng-if=\"isSearchButton\"><button type=\"button\" class=\"btn btn-md btn-primary\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Member search\" ng-click=\"fastrackPreauth(\'generic\')\"><i class=\"test glyphicon glyphicon-search\"></i></button></span></div></div><div class=\"error\" ng-show=\"signup_form.patientFirstName.$dirty && signup_form.patientFirstName.$invalid\"><small class=\"error\" ng-show=\"signup_form.patientFirstName.$error.required\">Your name is required.</small></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"contactNum\">Mobile number *</label> <input name=\"contactNum\" autocomplete=\"off\" type=\"text\" class=\"form-control\" ng-pattern=\"/^((7|8|9)).{9}$/\" ng-change=\"mobileValidation(form.mobile)\" numbers-only=\"numbers-only\" placeholder=\"Enter mobile number\" ng-model=\"form.mobile\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\"><div class=\"error\" ng-show=\"signup_form.contactNum.$error.pattern ||(signup_form.contactNum.$dirty && signup_form.contactNum.$invalid)\"><small class=\"error\" ng-show=\"signup_form.contactNum.$error.required\">Mobile number is required.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.pattern\">Mobile number is not valid.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.number\">Mobile number can contain only numbers.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.minlength\">Mobile number is required to be at least 10 characters.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.maxlength\">Mobile can\'t be longer than 10 characters.</small></div></div></div><div class=\"col-md-4\" ng-show=\"form.isgovtscheme\"><label for=\"memberDist\">Member district</label> <input name=\"memberDist\" autocomplete=\"off\" placeholder=\"Enter member district\" class=\"form-control\" type=\"text\" ng-model=\"form.memberDist\"></div></div><div class=\"row\" ng-show=\"form.isgovtscheme\"><div class=\"col-md-4 form-group\"><label for=\"memberGender\">Member gender</label><select name=\"memberGender\" ng-model=\"form.memberGender\" class=\"form-control\"><option value=\"\">Select Gender</option><option value=\"male\">Male</option><option value=\"female\">Female</option></select></div><div class=\"col-md-4 form-group\"><label for=\"memberAge\">Member Age</label> <input name=\"memberAge\" autocomplete=\"off\" placeholder=\"Enter member age\" class=\"form-control\" type=\"number\" ng-model=\"form.memberAge\"></div><div class=\"col-md-4 form-group\" ng-show=\"form.isgovtscheme\"><div class=\"form-group\"><label for=\"memberId\">Member Id *</label> <input name=\"memberId\" autocomplete=\"off\" type=\"number\" class=\"form-control\" placeholder=\"Enter your Member Id\" ng-model=\"form.memberId\"></div></div></div><div ng-show=\"!form.isgovtscheme\"><div class=\"form-group\"><div class=\"col-md-6 common-background\"><label for=\"policyno\">Policy number <span ng-show=\"!(form.maid.toString().length>0||(form.employer.length>0 && form.empid.length>0))\">*</span></label> <input type=\"text\" id=\"policyno\" name=\"policynumber\" class=\"form-control\" placeholder=\"Enter policy number\" ng-model=\"form.policyno\" ng-required=\"!(form.maid.toString().length>0||(form.employer.length>0 && form.empid.length>0))\"></div><div class=\"col-md-6 common-background\"><label for=\"insurername\">Insurer name</label><select name=\"insurername\" class=\"form-control\" ng-change=\"getPackagesListForInsurer(form.insurername)\" ng-model=\"form.insurername\"><option value=\"\">--Select Insurer Name--</option><option ng-repeat=\"obj in insurerList | orderBy:\'insurerFullName\'\">{{obj.insurerFullName}}</option></select></div></div></div><div ng-show=\"!form.isgovtscheme\"><div class=\"form-group col-md-4 common-background\"><div><label for=\"employer\">Corporate name <span ng-show=\"!(form.maid.toString().length >0||form.policyno.length>0)\">*</span></label> <input name=\"employer\" autocomplete=\"off\" id=\"preauthemployer\" type=\"text\" class=\"form-control\" placeholder=\"Enter corporate name\" ng-model=\"form.employer\" ng-required=\"!(form.maid.toString().length >0||form.policyno.length>0)\"><div class=\"error\" ng-show=\"signup_form.employer.$dirty && signup_form.employer.$invalid\"><small class=\"error\" ng-show=\"signup_form.employer.$error.required\">Employer name is required.</small></div></div></div><div class=\"col-md-4 common-background\"><div><label for=\"empid\">Employee Id <span ng-show=\"!(form.maid.toString().length >0||form.policyno.length>0)\">*</span></label> <input name=\"empid\" autocomplete=\"off\" id=\"preauthempid\" type=\"text\" class=\"form-control\" placeholder=\"Enter employee ID\" ng-model=\"form.empid\" ng-required=\"!(form.maid.toString().length >0||form.policyno.length>0)\"><div class=\"error\" ng-show=\"signup_form.empid.$dirty && signup_form.empid.$invalid\"><small class=\"error\" ng-show=\"signup_form.empid.$error.required\">Employee Id is required.</small></div></div></div></div><div><div class=\"form-group col-md-4 common-background\" ng-if=\"!form.isgovtscheme && isShowMaid\"><div><label for=\"maid\">MAID <span ng-show=\"!(form.policyno.length>0||(form.employer.length>0 && form.empid.length>0))\">*</span></label> <input name=\"maid\" numbers-only=\"numbers-only\" autocomplete=\"off\" id=\"preauthmaid\" type=\"number\" min=\"0\" class=\"form-control\" placeholder=\"Enter MAID\" ng-model=\"form.maid\" ng-required=\"!(form.policyno.length>0||(form.employer.length>0 && form.empid.length>0))\"><div class=\"error\" ng-show=\"signup_form.maid.$dirty && signup_form.maid.$invalid\"><small class=\"error\" ng-show=\"signup_form.maid.$error.required\">MAID is required and should contain only numbers.</small> <small class=\"error\" ng-show=\"signup_form.maid.$error.number\">MAID can contain only numbers</small></div></div></div><div class=\"form-group col-md-4 common-background\" ng-if=\"!form.isgovtscheme && !isShowMaid\"><div><label for=\"patientUniqeId\">Patient unique id <span ng-show=\"!(form.policyno.length>0||(form.employer.length>0 && form.patientUniqeId.length>0))\">*</span></label> <input name=\"patientUniqeId\" autocomplete=\"off\" id=\"preauthmaid\" min=\"0\" class=\"form-control\" placeholder=\"Enter patient unique id\" ng-model=\"form.uniqueId\" ng-required=\"!(form.policyno.length>0||(form.employer.length>0 && form.patientUniqeId.length>0))\"><div class=\"error\" ng-show=\"signup_form.patientUniqeId.$dirty && signup_form.patientUniqeId.$invalid\"><small class=\"error\" ng-show=\"signup_form.patientUniqeId.$error.required\">MAID is required and should contain only numbers.</small> <small class=\"error\" ng-show=\"signup_form.patientUniqeId.$error.number\">MAID can contain only numbers</small></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"ipnumber\">In patient number</label> <input name=\"ipnumber\" autocomplete=\"off\" numbers-only=\"\" type=\"text\" class=\"form-control\" placeholder=\"Enter IP no. for faster search and reconciliation\" ng-model=\"form.ipnumber\"><div class=\"error\" ng-show=\"signup_form.ipnumber.$dirty && signup_form.ipnumber.$invalid\"><small class=\"error\" ng-show=\"signup_form.ipnumber.$error.number\">Inpatient number can contain only numbers</small></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"doa\">Date of admission *</label> <input name=\"doa\" ng-change=\"dateOfAdmission(form.dod, \'doa\')\" id=\"datetimepicker\" class=\"form-control\" type=\"date\" ng-model=\"form.doa\" required=\"\"><div class=\"error\" ng-show=\"signup_form.doa.$dirty && signup_form.doa.$invalid\"><small class=\"error\" ng-show=\"signup_form.doa.$error.required\">Tentative date of admission is required.</small> <small class=\"error\" ng-show=\"signup_form.doa.$error.datetimelocal\">Tentative date is Invalid.</small></div><div class=\"error\"><small class=\"error\" ng-show=\"isdoa\">Tentative date of admission does\'t seems to be valid.</small></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"dod\">Date of discharge *</label> <input name=\"dod\" ng-change=\"dateOfAdmission(form.doa, \'dod\')\" id=\"dischargetimepicker\" class=\"form-control\" type=\"date\" ng-model=\"form.dod\" required=\"\"><div class=\"error\" ng-show=\"signup_form.dod.$dirty && signup_form.dod.$invalid\"><small class=\"error\" ng-show=\"signup_form.dod.$error.required\">Tentative date of discharge is required.</small></div><div class=\"error\"><small class=\"error\" ng-show=\"isdod\">Tentative date of discharge does\'t seems to be valid.</small></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnosis *</label> <textarea name=\"diagnosis\" class=\"form-control\" placeholder=\"Enter diagnosis details\" ng-model=\"form.diagnosis\" required=\"\"></textarea><div class=\"error\" ng-show=\"signup_form.diagnosis.$dirty && signup_form.diagnosis.$invalid\"><small class=\"error\" ng-show=\"signup_form.diagnosis.$error.required\">Diagnosis details are required.</small></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"admissionType\">Admission type *</label><select name=\"admissionType\" id=\"admissiontype\" class=\"form-control\" ng-model=\"form.admissiontype\" required=\"\"><option value=\"\">Select Admission Type</option><option value=\"emergency\">Emergency</option><option value=\"planned\">Planned</option></select></div></div><div class=\"col-md-4\" ng-if=\"isTPA\"><div class=\"form-group\" ng-show=\"!form.isgovtscheme\"><label for=\"procedure\">Procedure *</label> <textarea name=\"procedure\" class=\"form-control\" placeholder=\"Enter procedure details\" ng-model=\"form.procedure\" required=\"\"></textarea><div class=\"error\" ng-show=\"signup_form.procedure.$dirty && signup_form.procedure.$invalid\"><small class=\"error\" ng-show=\"signup_form.procedure.$error.required\">Procedure details are required.</small></div></div></div></div><div class=\"row\" ng-if=\"!form.isgovtscheme\" style=\"background-color: rgb(238, 238, 238); margin-left: -2px; margin-right: 1px; padding-top: 10px; margin-top: -10px; border-radius: 7px;\"><div class=\"col-md-8\" ng-if=\"isTPAAndProcedure ||isProcedure\"><label for=\"approxClaimedAmnt\">Select procedure *</label><mb-typeahead items=\"mappedpackages\" prompt=\"Start typing procedure name...\" ng-model=\"hospNewName\" removeitem=\"removeData\" selecteditems=\"selectedMappedpackages\" callback-fn=\"ctrlFn(arg)\"></mb-typeahead></div><div class=\"col-md-4\" ng-if=\"isTPAAndProcedure ||isProcedure\"><div class=\"form-group\"><label for=\"approxClaimedAmnt\">Estimated amount *</label> <input name=\"approxClaimedAmnt\" readonly=\"\" autocomplete=\"off\" type=\"number\" class=\"form-control\" placeholder=\"Enter estimated amount\" ng-model=\"form.clmamount\" required=\"\"><div class=\"error\" ng-show=\"signup_form.approxClaimedAmnt.$dirty && signup_form.approxClaimedAmnt.$invalid\"><small class=\"error\" ng-show=\"signup_form.approxClaimedAmnt.$error.required\">Claimed amount is required and can contain only numbers.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.number\">Claimed amount can contain only numbers</small></div></div></div></div><div ng-if=\"selectedMappedpackages.length >0\" style=\"padding-left: 20px; background-color: rgb(245, 245, 245); padding-right: 20px; margin-top: 0px; /* border-radius: 10px; */ padding-bottom: 5px; margin-bottom: 5px;\"><p>Selected procedure</p><table class=\"table table-hover table-link\" ng-if=\"tabname != \'Planned Requests\'\"><thead><tr><th class=\"patientName text-center\">Name</th><th class=\"claimedAmount text-center\">Price</th><th class=\"claimedAmount text-center\">Action</th></tr></thead><tbody><tr tooltip-placement=\"top\" ng-repeat=\"item in selectedMappedpackages track by $index\"><td class=\"text-left\">{{item.package_Name}}</td><td class=\"text-center\"><span class=\"text-center\">{{item.general_Ward}}</span> <span class=\"text-center\">{{item.private_Ward}}</span> <span class=\"text-center\">{{item.semi_Private_Ward}}</span></td><td class=\"text-center\"><button class=\"btn btn-danger btn-xs\" ng-click=\"removePackageFromList(item)\">Remove</button></td></tr></tbody></table></div><div class=\"row\" ng-if=\"!form.isgovtscheme\"><div ng-class=\"isTPA?\'col-md-4\': \'col-md-6\'\" ng-if=\"isTPA\"><div class=\"form-group\"><label for=\"approxClaimedAmnt\">Estimated amount *</label> <input name=\"approxClaimedAmnt\" type=\"number\" class=\"form-control\" placeholder=\"Enter estimated Amount\" ng-model=\"form.clmamount\" required=\"\"><div class=\"error\" ng-show=\"signup_form.approxClaimedAmnt.$dirty && signup_form.approxClaimedAmnt.$invalid\"><small class=\"error\" ng-show=\"signup_form.approxClaimedAmnt.$error.required\">Claimed amount is required and can contain only numbers.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.number\">Claimed amount can contain only numbers</small></div></div></div><div ng-class=\"isTPA?\'col-md-4\': \'col-md-6\'\" ng-if=\"isTPA\"><div class=\"form-group\"><label for=\"docName\">Doctor name *</label> <input name=\"docName\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Start typing doctor name\" required=\"\" ng-click=\"getkeywords()\" ng-model=\"form.docname\" uib-typeahead=\"condition.doctorName for condition in doctorDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"><div class=\"error\" ng-show=\"signup_form.docName.$dirty && signup_form.docName.$invalid\"><small class=\"error\" ng-show=\"signup_form.docName.$error.required\">Doctor name is required.</small></div></div></div><div ng-class=\"isTPA?\'col-md-4\': \'col-md-6\'\" ng-if=\"isTPA\"><div class=\"form-group\" ng-show=\"!form.isgovtscheme\"><label for=\"roomType\">Room type allocated *</label> <input name=\"roomType\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" required=\"\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Start typing room type allocated\" ng-click=\"getkeywords()\" ng-model=\"form.roomtype\" uib-typeahead=\"item.hospitalRoomType for item in roomsDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"><div class=\"error\" ng-show=\"signup_form.roomType.$dirty && signup_form.roomType.$invalid\"><small class=\"error\" ng-show=\"signup_form.roomType.$error.required\">Room type has to be mentioned.</small></div></div></div></div><div class=\"row\" ng-if=\"!form.isgovtscheme\"><div class=\"col-md-6\" ng-if=\"isProcedure||isTPAAndProcedure\"><div class=\"form-group\"><label for=\"docName\">Doctor name *</label> <input name=\"docName\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Type doctor name\" required=\"\" ng-click=\"getkeywords()\" ng-model=\"form.docname\" uib-typeahead=\"condition.doctorName for condition in doctorDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"><div class=\"error\" ng-show=\"signup_form.docName.$dirty && signup_form.docName.$invalid\"><small class=\"error\" ng-show=\"signup_form.docName.$error.required\">Doctor name is required.</small></div></div></div><div class=\"col-md-6\" ng-if=\"isProcedure ||isTPAAndProcedure\"><div class=\"form-group\" ng-show=\"!form.isgovtscheme\"><label for=\"roomType\">Provided room type *</label> <input name=\"roomType\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" required=\"\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Type provided room type\" ng-click=\"getkeywords()\" ng-model=\"form.roomtype\" uib-typeahead=\"item.hospitalRoomType for item in roomsDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"><div class=\"error\" ng-show=\"signup_form.roomType.$dirty && signup_form.roomType.$invalid\"><small class=\"error\" ng-show=\"signup_form.roomType.$error.required\">Room type has to be mentioned.</small></div></div></div></div><div class=\"row\" ng-if=\"isEBill\"><div class=\"col-md-6\"><div class=\"form-group\" ng-show=\"!form.isgovtscheme\"><label for=\"uidno\">Unique hospital Id</label> <input name=\"uidno\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"form.uidno\"></div></div></div><div id=\"fileupload\"><p class=\"bg-danger\">Maximum file upload limit is 15 MB. <button class=\"btn btn-xs btn-primary pull-right\" ng-click=\"preauthFormAction.downloadPrefilledPreauthForm(\'preauthform\')\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR && !form.isgovtscheme) || (isdod ||isdoa)\">Download Pre-filled pre authorization form</button> <b>At least one of the documents listed below needs to be submitted.</b></p><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">Signed Pre authorization form</label> <input type=\"file\" name=\"preauth\" file-model=\"preAuthFile.file1\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">Id proof<a tooltip-placement=\"top\" uib-tooltip=\"Driving License, Voter ID card, Corporate Employee ID, Pan car, Passport\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a></label> <input type=\"file\" name=\"idproof\" file-model=\"preAuthFile.file2\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnostic reports<a tooltip-placement=\"top\" uib-tooltip=\"Bio Chemistry reports, Haematology reports, Microbiology reports, Neurology reports, Pathology reports, Radiology reports\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a></label> <input type=\"file\" name=\"investigations\" file-model=\"preAuthFile.file3\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">Other relevant documents</label> <input type=\"file\" name=\"otherfiles\" file-model=\"preAuthFile.file4\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add More Files</span></button></div></div></div></div><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></fieldset><div class=\"row\"><div class=\"col-sm-12\"><button type=\"submit\" class=\"btn btn-primary start pull-right\" id=\"newAdmissionButton\" style=\"margin-bottom: 25px;\" ng-click=\"source==\'preClaim\'?preClaimInfoRelatedMethods.submitPreClaimPreauthForm():preauthFormAction.submitPreauthForm()\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR && !form.isgovtscheme) || (isdod ||isdoa) || isProcessing\"><span>Submit New Admission</span></button></div></div></div></ng-form></div></div></div></div></div></div></div></div><div class=\"modal fade\" id=\"addTPA\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><h4>TPA Configuration</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\" id=\"new-claim-msg\" ng-if=\"isSuccess\"><div class=\"chat-content_wrap bg-primary\" style=\"background-color: white;\"><h4 class=\"chat-status text-center\" style=\"background-color: #299429; padding-top: 5px; padding-bottom: 5px; border-radius: 16px;\">{{isSuccessMsg}}</h4></div></div><div class=\"col-md-8\" id=\"new-claim-msg\" ng-if=\"isError\"><div class=\"chat-content_wrap bg-primary\" style=\"background-color: white;\"><h4 class=\"chat-status text-center\" style=\"background-color: #ea5656; padding-top: 5px; padding-bottom: 5px; border-radius: 16px;\">{{tpaErrorMsg}}</h4></div></div><div class=\"col-md-2\"></div></div><form name=\"tpaForm\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>TPA name *</label><select name=\"insurername\" required=\"\" class=\"form-control\" ng-options=\"item as item.value for item in TPAListData track by item.id\" ng-model=\"tpaForm.name\"></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"TPAtpaHospId\">Hospital id related to TPA *</label> <input name=\"TPAtpaHospId\" type=\"text\" ng-maxlength=\"100\" required=\"\" class=\"form-control\" placeholder=\"Enter hospital id related to TPA\" ng-model=\"tpaForm.tpaHospId\"> <span ng-if=\"tpaForm.TPAName.$error.maxlength\" style=\"color: #f00\">Hospital id not morethen 100 characters.</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"TPAMailServerAddress\">InComing mail server address *</label> <input name=\"TPAMailServerAddress\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter InComing mail server address\" ng-model=\"tpaForm.mailServerAddress\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"TPAMailServerPort\">InComing server port *</label> <input name=\"TPAMailServerPort\" numbers-only=\"numbers-only\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter inComing server port\" ng-model=\"tpaForm.mailServerPort\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"TPAoutGoingServerAddress\">OutGoing mail server address *</label> <input name=\"TPAoutGoingServerAddress\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter outGoing mail server port\" ng-model=\"tpaForm.outGoingServerAddress\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"TPAOutGoingServerPort\">OutGoing server port *</label> <input name=\"TPAOutGoingServerPort\" numbers-only=\"numbers-only\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter outGoing server port\" ng-model=\"tpaForm.outGoingServerPort\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"TPAHospMailId\">Hospital mail address *</label> <input name=\"TPAHospMailId\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter hospital mail address\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" ng-model=\"tpaForm.hospMailId\"> <span ng-if=\"!tpaForm.TPAHospMailId.$valid && tpaForm.TPAHospMailId.$dirty\" style=\"color: #f00\">Hospital email address not seems to be valid.</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"TPAHospPassword\">Hospital mailbox password *</label> <input name=\"TPAHospPassword\" type=\"password\" required=\"\" autocomplete=\"new-password\" class=\"form-control\" placeholder=\"Enter hospital mailbox password\" ng-model=\"tpaForm.hospPassword\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"TPAtpaMailId\">TPA mail address *</label> <input name=\"TPAtpaMailId\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter TPA mail address\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" ng-model=\"tpaForm.tpaMailId\"> <span ng-if=\"!tpaForm.TPAtpaMailId.$valid && tpaForm.TPAtpaMailId.$dirty\" style=\"color: #f00\">TPA email address not seems to be valid.</span></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"tpaForm.$invalid\" ng-click=\"saveTpaDetails(tpaForm)\">Add</button> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"removeModal()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"newMSBYSearch\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"removeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4>Government URN search</h4></div><div class=\"modal-body\"><div class=\"center-block\" ng-if=\"isGov\"><div class=\"row form-group\"><div class=\"col-md-12\"><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioMaid\" ng-change=\"searchGov(\'URN\')\">URN</label></div></div></div></div><form name=\"formUrn\" ng-if=\"isURN\"><div class=\"row form-group\"><div class=\"col-md-6\"><input ng-model=\"govSearchValueInModel.urn\" name=\"urn\" class=\"form-control\" type=\"text\" placeholder=\"Enter URN number\" ng-required=\"true\" ng-change=\"resetModel();\"></div><div class=\"col-md-6\" ng-show=\"selectedSchemeForGov===\'APCMUHIS_Mediassist\'\"><input ng-model=\"govSearchValueInModel.apbyname\" name=\"MemberNameAPBY\" class=\"form-control\" type=\"text\" placeholder=\"Enter member name\" ng-required=\"true\"></div></div><div class=\"row form-group\"><div class=\"col-md-12\" ng-if=\"selectedSchemeForGov===\'APCMUHIS_Mediassist\'\"><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"removeModal()\">Close</button> <button style=\"background-color: darkgray;\" type=\"button\" class=\"btn btn-default\" ng-click=\"govSearchValueInModel.urn =\'\'\" ng-disabled=\"!govSearchValueInModel.urn\">Clear</button> <button ng-disabled=\"(!formUrn.urn.$dirty || formUrn.urn.$invalid || formUrn.MemberNameAPBY.$invalid)\" ng-click=\"getDetailsWithGov(govSearchValueInModel.urn,govSearchValueInModel.apbyname)\" type=\"button\" class=\"btn btn-primary\">Search</button></div><div class=\"col-md-12\" style=\"margin-left: 365px;\" ng-if=\"selectedSchemeForGov===\'RSBYHospitals_Mediassist\'\"><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"removeModal()\">Close</button> <button style=\"background-color: darkgray;\" type=\"button\" class=\"btn btn-default\" ng-click=\"govSearchValueInModel.urn =\'\'\" ng-disabled=\"!govSearchValueInModel.urn\">Clear</button> <button ng-disabled=\"(!formUrn.urn.$dirty || formUrn.urn.$invalid)\" ng-click=\"getDetailsWithGov(govSearchValueInModel.urn,govSearchValueInModel.apbyname)\" type=\"button\" class=\"btn btn-primary\">Search</button></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">URN : \"{{govSearchValueInModel.urn}}\" is not available in Post Enroll Data</p><p class=\"bg-info\" ng-if=\"govtBenefList.length >0\">URN : \"{{govSearchValueInModel.urn}}\" is available in Post Enroll Data</p><div class=\"form-group\" ng-show=\"govtBenefList.length >0\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"item in govtBenefList\"><td>{{item.memberName}}</td><td>{{item.relationValue}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackPopulateNewAdmissionGov(item)\">Select</button></td></tr></tbody></table></div></div></form><form name=\"formEpic\" ng-show=\"isEpic\"><div class=\"row form-group\"><div class=\"col-md-6\"><input ng-model=\"epic\" name=\"Epic\" class=\"form-control\" type=\"text\" placeholder=\"Epic number\" ng-required=\"true\"></div></div><div class=\"row form-group\"><div class=\"col-md-6\"><button ng-disabled=\"(!formEpic.Epic.$dirty || formEpic.Epic.$invalid)\" ng-click=\"getDetailsWithGov(epic,\'epic\')\" type=\"button\" class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-search\"></i> Search</button></div><div class=\"col-md-6\"></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><div class=\"form-group\" ng-show=\"govtBenefList.length >0\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"item in govtBenefList\"><td>{{item.memberName}}</td><td>{{item.relationValue}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackPopulateNewAdmissionGov(item)\">Select</button></td></tr></tbody></table></div></div></form></div></div></div></div><div class=\"modal fade\" id=\"newPreauthModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"removeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4>{{fastrack.title}}</h4></div><div class=\"modal-body\"><div class=\"row form-group\"><p style=\"margin-left: 18px;color: brown;\">You can also search DHS members using there DHSID.</p><div class=\"col-md-4\"><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioMaid\" ng-change=\"clearfastrack()\">MAID / DHSID</label></div></div><div class=\"col-md-4\"><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioEmp\" ng-change=\"clearfastrack()\">{{fastrack.employerSearchTitle}}</label></div></div><div class=\"col-md-4\"><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioPolicy\" ng-change=\"clearfastrack()\">Policy Number</label></div></div></div><form name=\"formMaid\" ng-show=\"radioFastTrack === \'radioMaid\' ? true : false\"><div class=\"row form-group\" ng-show=\"radioFastTrack === \'radioMaid\' ? true : false\"><div class=\"col-md-6\"><input ng-model=\"fastrack.maid\" name=\"maid\" class=\"form-control\" type=\"text\" placeholder=\"Enter MAID or DHSID\" ng-required=\"true\"></div><div class=\"col-md-6\"><input name=\"benefName\" autocomplete=\"off\" ng-model=\"fastrack.benefName\" class=\"form-control\" type=\"text\" placeholder=\"Enter benef name\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ? getDetailsWithMaid(fastrack.maid,fastrack.benefName) : \'\'\"></div></div><div class=\"row form-group\" style=\"margin-left: 650px;\"><div class=\"col-md-12\"><button type=\"button\" data-dismiss=\"modal\" class=\"btn btn-default\" ng-click=\"removeModal()\">Close</button> <button style=\"background-color: darkgray;\" type=\"button\" class=\"btn btn-default\" ng-click=\"clearfastrack()\" ng-disabled=\"!fastrack.benefName || !fastrack.maid\">Clear</button> <button ng-show=\"fastrack.displaySubmit\" ng-disabled=\"(!formMaid.maid.$dirty || formMaid.maid.$invalid)||(!formMaid.benefName.$dirty || formMaid.benefName.$invalid)\" ng-click=\"getDetailsWithMaid(fastrack.maid,fastrack.benefName)\" type=\"button\" class=\"btn btn-primary\">Search</button></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><p class=\"bg-danger\" ng-show=\"isECashLess\">{{eCashLessMessage}} <button class=\"btn-primary\" ng-click=\"reDirect(\'planned\')\">yes</button></p><div class=\"form-group\" ng-show=\"!fastrack.displaySubmit\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"relation in fastrack.relations\"><td>{{relation.name}}</td><td>{{relation.relationName}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackPopulateNewAdmission(fastrack.empMaid,relation.relationId,relation.name, relation)\">Select</button></td></tr></tbody></table></div></div></form><form name=\"formEmp\" ng-show=\"radioFastTrack === \'radioEmp\' ? true : false\"><div class=\"row form-group\" ng-show=\"radioFastTrack==\'radioEmp\'?true:false\"><div class=\"col-md-4\"><input ng-model=\"fastrack.employeeId\" name=\"empid\" class=\"form-control\" type=\"text\" placeholder=\"Enter employee / family number\" ng-required=\"true\"></div><div class=\"col-md-4\" ng-show=\"fastrack.showCorpName\"><input ng-model=\"fastrack.corporateName\" name=\"compname\" class=\"form-control\" type=\"text\" placeholder=\"Enter company name\" ng-required=\"true\"></div><div class=\"col-md-4\"><input ng-model=\"fastrack.BeneficiaryName\" name=\"benefname\" class=\"form-control\" type=\"text\" placeholder=\"Enter benef name\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getDetailsWithEmpId(fastrack.employeeId,fastrack.corporateName,fastrack.BeneficiaryName): \'\'\"></div></div><div class=\"row form-group\" style=\"margin-left: 650px;\"><div class=\"col-md-12\"><button type=\"button\" data-dismiss=\"modal\" class=\"btn btn-default\" ng-click=\"removeModal()\">Close</button> <button style=\"background-color: darkgray;\" type=\"button\" class=\"btn btn-default\" ng-click=\"clearfastrack()\" ng-disabled=\"!fastrack.BeneficiaryName || !fastrack.employeeId || !fastrack.showCorpName\">Clear</button> <button ng-show=\"fastrack.displaySubmit\" ng-disabled=\"formEmp.$invalid\" ng-click=\"getDetailsWithEmpId(fastrack.employeeId,fastrack.corporateName,fastrack.BeneficiaryName)\" type=\"button\" class=\"btn btn-primary\">Search</button></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><p class=\"bg-danger\" ng-show=\"isECashLess\">{{eCashLessMessage}} <button class=\"btn-primary\" ng-click=\"reDirect(\'planned\')\">yes</button></p><div class=\"form-group\" ng-show=\"!fastrack.displaySubmit\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"relation in fastrack.relations\"><td>{{relation.name}}</td><td>{{relation.relationName}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackPopulateNewAdmission(fastrack.empMaid,relation.relationId,relation.name, relation)\">Select</button></td></tr></tbody></table></div></div></form><form name=\"formPolicy\" ng-show=\"radioFastTrack === \'radioPolicy\' ? true : false\"><div class=\"row form-group\" ng-show=\"radioFastTrack==\'radioPolicy\'?true:false\"><div class=\"col-md-6\"><input ng-model=\"fastrack.PolicyNo\" class=\"form-control\" type=\"text\" placeholder=\"Enter policy number\" ng-required=\"true\"></div><div class=\"col-md-6\"><input ng-model=\"fastrack.BeneficiaryName\" class=\"form-control\" type=\"text\" placeholder=\"Enter benef name\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getDetailsWithPolicy(fastrack.PolicyNo,fastrack.BeneficiaryName): \'\'\"></div></div><div class=\"row form-group\" style=\"margin-left: 650px;\"><div class=\"col-md-12\"><button type=\"button\" data-dismiss=\"modal\" class=\"btn btn-default\" ng-click=\"removeModal()\">Close</button> <button style=\"background-color: darkgray;\" type=\"button\" class=\"btn btn-default\" ng-click=\"clearfastrack()\" ng-disabled=\"!fastrack.BeneficiaryName || !fastrack.PolicyNo\">Clear</button> <button ng-click=\"getDetailsWithPolicy(fastrack.PolicyNo,fastrack.BeneficiaryName)\" ng-show=\"fastrack.displaySubmit\" ng-disabled=\"formPolicy.$invalid\" type=\"button\" class=\"btn btn-primary\">Search</button></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><p class=\"bg-danger\" ng-show=\"isECashLess\">{{eCashLessMessage}} <button class=\"btn-primary\" ng-click=\"reDirect(\'planned\')\">yes</button></p><div class=\"form-group\" ng-show=\"!fastrack.displaySubmit\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"relation in fastrack.relations\"><td>{{relation.name}}</td><td>{{relation.relationName}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackPopulateNewAdmission(fastrack.empMaid,relation.relationId,relation.name, relation)\">Select</button></td></tr></tbody></table></div></div></form></div></div></div></div><message background=\"msg.background\" body=\"msg.body\" header=\"msg.header\" show=\"msg.show\"></message></div>");
$templateCache.put("app/components/otherPayer/angularTabs.html","<style>\n  .drop-box {\n    background: #F8F8F8;\n    border: 5px dashed #DDD;\n    width: 400px;\n    height: 90px;\n    text-align: center;\n    padding-top: 25px;\n    margin: 10px;\n    font-size: 11px;\n  }\n\n  .dragover {\n    border: 5px dashed blue;\n  }\n\n  form .progress {\n    line-height: 15px;\n  }\n\n  .progress {\n    display: inline-block;\n    width: 100px;\n    border: 3px groove #ccc;\n    overflow: initial;\n  }\n\n  .progress>div {\n    font-size: smaller;\n    background-color: blue;\n    width: 0%;\n  }\n</style><div ng-if=\"!tabtype\" style=\"height:100px\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"getActiveClaims(1,true);\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"removeTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><table class=\"table table-hover table-link\" ng-if=\"tabname != \'Planned Requests\'\"><thead><tr><th class=\"patientName\">Patient/Payer name</th><th class=\"claimId\">Claim No</th><th class=\"claimedAmount text-right\">Claimed amount</th><th class=\"approvedAmount text-center\">Status</th><th class=\"approvedAmount text-right\">Approved amount</th><th class=\"dateOfAdmission text-right\">Admission date</th><th class=\"dateOfDischarge text-right\">Discharge date</th><th class=\"text-right\">Action</th></tr></thead><tbody><tr ng-repeat=\"item in preauthfilteredStatusFiltered | limitTo:itemsPerPage\" ng-class=\"item.isFlagRed ? \'font-bold alert-warning\' : \'\'\"><td ng-click=\"addTab(item)\" class=\"name\">{{item.patientName}} <span class=\"smTxt\">{{item.tpaName}}</span></td><td ng-click=\"addTab(item)\">{{item.claimId}}</td><td ng-click=\"addTab(item)\" class=\"text-right\">{{formatCurrency(item.claimedAmount)}}</td><td ng-click=\"addTab(item)\" class=\"text-right\"><span class=\"label label-success\" ng-if=\"item.status===\'New Admission\'\">New Admission</span> <span class=\"label label-success\" ng-if=\"item.status===\'Claim Approved\'\">Claim Approved</span> <span class=\"label label-warning\" ng-if=\"item.status===\'Claim Information Required\'\">Claim Information Required</span> <span class=\"label label-danger\" ng-if=\"item.status===\'Denied\'\">Denied</span> <span class=\"label label-danger\" ng-if=\"item.status===\'Enhancement Denied\'\">Enhancement Denied</span> <span class=\"label label-default\" ng-if=\"item.status ===\'Enhancement Raised\'\">Enhancement Raised</span> <span class=\"label label-info\" ng-if=\"item.status ===\'Pre-Auth Approved\'\">Pre-Auth Approved</span> <span class=\"label label-warning\" ng-if=\"item.status ===\'Information Required\'\">Information Required</span> <span class=\"label label-success\" ng-if=\"item.status ===\'Information Submitted\'\">Information Submitted</span> <span class=\"label label-success\" ng-if=\"item.status ===\'Enhancement Approved\'\">Enhancement Approved</span> <span class=\"label label-success\" ng-if=\"item.status ===\'Documents Submitted\'\">Documents Submitted</span> <span class=\"label label-success\" ng-if=\"item.status ===\'Discharge Documents Submitted\'\">Discharge Documents Submitted</span> <span class=\"label label-success\" ng-if=\"item.status ===\'Documents Received\'\">Documents Received</span> <span class=\"label label-danger\" ng-if=\"item.status===\'Claim Denied\'\">Claim Denied</span> <span class=\"label label-warning\" ng-if=\"item.status===\'Claim Information Required\'\">Claim Information Required</span></td><td ng-click=\"addTab(item)\" class=\"text-right\">{{formatCurrency(item.approvedAmount)}}</td><td ng-click=\"addTab(item)\" class=\"text-right\">{{item.dateOfAdmission}}</td><td ng-click=\"addTab(item)\" class=\"text-right\">{{item.dateOfDischarge}}</td><td><button class=\"btn btn-primary btn-xs\" ng-click=\"updateOtherTpaClaimInfo(item);\"><i class=\"fa fa-edit\"></i></button></td></tr></tbody></table><div style=\"margin-left: 330px;\"><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" ng-change=\"pageChanged(currentPage, true)\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></div><div ng-show=\"!tab1show\"><div id=\"{{key.claimId}}\"><div class=\"claimBox\" ng-if=\"!tabPlanned && !preClaim\"><div id=\"toprow\" class=\"downloadPart\"><table class=\"table table-striped\" style=\"margin-top:20px; background:#fff;\"><tbody><tr><td><label>Customer :</label></td><td>{{claimNoData.patientName}}</td><td><label>Claim No :</label></td><td>{{claimNoData.claimId}}</td><td><label>Payer name :</label></td><td>{{claimNoData.tpaName}}</td></tr><tr><td><label>Claimed amount :</label></td><td>{{formatCurrency(claimNoData.claimedAmount)}}</td><td><label>Approved amount :</label></td><td>{{formatCurrency(claimNoData.approvedAmount)}}</td><td><label>DOA :</label></td><td>{{claimNoData.dateOfAdmission}}</td></tr><tr><td><label>DOD :</label></td><td>{{claimNoData.dateOfDischarge}}</td><td><label>Scheme :</label></td><td>{{claimNoData.schemeName}}</td><td><label>Contact No :</label></td><td>{{claimNoData.patientContactNo}}</td></tr><tr><td><label>Patient Age :</label></td><td>{{claimNoData.patientAge}}</td><td><label>Diagnosis :</label></td><td>{{claimNoData.diagnosis}}</td><td ng-repeat-start=\"claim in claimNoData.extraFields track by $index\" ng-if=\"$index<=0\"><label>{{claim.fieldName}} :</label></td><td ng-repeat-end=\"\" ng-if=\"$index<=0\">{{claim.fieldValue}}</td></tr><tr><td ng-repeat-start=\"claim in claimNoData.extraFields track by $index\" ng-if=\"$index>=1 && $index<=3\"><label>{{claim.fieldName}} :</label></td><td ng-repeat-end=\"\" ng-if=\"$index>=1 && $index<=3\">{{claim.fieldValue}}</td></tr><tr><td ng-repeat-start=\"claim in claimNoData.extraFields track by $index\" ng-if=\"$index>=4 && $index<=6\"><label>{{claim.fieldName}} :</label></td><td ng-repeat-end=\"\" ng-if=\"$index>=4 && $index<=6\">{{claim.fieldValue}}</td></tr><tr><td ng-repeat-start=\"claim in claimNoData.extraFields track by $index\" ng-if=\"$index>=7 && $index<=9\"><label>{{claim.fieldName}} :</label></td><td ng-repeat-end=\"\" ng-if=\"$index>=7 && $index<=9\">{{claim.fieldValue}}</td></tr></tbody></table></div><div id=\"auditDetails\" ng-if=\"claimSearhByClaimIdResults.length >0\"><div ng-repeat=\"item in claimSearhByClaimIdResults\"><div class=\"chatBox user\" ng-if=\"item.submittedBy ===\'HOSPITAL\' || item.submittedBy ===\'Hospital\'\"><div class=\"author\"><p class=\"dateTime\">{{compareDate(item.createdDate)}} <span>{{formatTime(item.createdDate)}}</span></p><h2>Hospital</h2><h6 style=\"color:green\" ng-show=\"item.isCommMailSent\">Intimated to Payer <i class=\"fa fa-bell\" ng-click=\"resendMail(item,true)\" placeholder=\"Send Reminder\"></i></h6><h6 style=\"color:#e13f4e\" ng-show=\"!item.isCommMailSent\">Not Intimated to Payer <a><i class=\"fa fa-repeat\" ng-click=\"resendMail(item)\"></i></a></h6></div><div class=\"chatContent\"><h5 class=\"chatStatus\">{{item.status }}</h5><p class=\"chat-content\">Claimed amount : {{formatCurrency(item.claimedAmount)}}</p><p ng-if=\"item.remarks\"><strong>Remark</strong> : {{item.remarks}}</p><div ng-if=\"(item.documents && item.documents.length !==0) || (item.letterDocuments && item.letterDocuments.length !==0)\"><span ng-repeat=\"item1 in item.documents\"><a href=\"{{item1.docPath}}\" target=\"_blank\">{{item1.fileName}}</a><br></span> <span ng-repeat=\"item2 in item.letterDocuments\"><a href=\"{{item2.docPath}}\" target=\"_blank\">{{item2.fileName}}</a><br></span></div></div></div><div class=\"chatBox\" ng-if=\"item.submittedBy ===\'TPA\'\"><div class=\"author\"><p class=\"dateTime\">{{compareDate(item.createdDate)}} <span>{{formatTime(item.createdDate)}}</span></p><h6 style=\"color: #3782c4;\">{{claimNoData.tpaName}}</h6></div><div class=\"chatContent\"><h5 class=\"chatStatus\">{{item.status }}</h5><p class=\"chat-content\">Approved amount : {{item.approvedAmount}}</p><p ng-if=\"item.remarks\"><strong>Remark</strong> : {{item.remarks}}</p><div ng-if=\"(item.documents && item.documents.length !==0) || (item.letterDocuments && item.letterDocuments.length !==0)\"><span ng-repeat=\"item1 in item.documents\"><a href=\"{{item1.docPath}}\" target=\"_blank\">{{item1.fileName}}</a><br></span> <span ng-repeat=\"item2 in item.letterDocuments\"><a href=\"{{item2.docPath}}\" target=\"_blank\">{{item2.fileName}}</a><br></span></div><a id=\"downloadLetter\" ng-show=\"item.letterUrl && item.letterUrl !==\'\'\" class=\"btn chat-content btn-primary btn-sm download\" href=\"{{item.letterUrl}}\">Click here to download Pre-Auth Approved letter</a></div></div></div><div class=\"chatBox noUser\" ng-if=\"user.role !== \'CMS\' && statusData.status !==\'Denied\'\" style=\"padding:10px\"><div class=\"chatcontent\"><h5 class=\"chatStatus\">Action</h5><div><button class=\"btn btn-warning\" ng-if=\"statusData.status===\'Information Required\'\" ng-click=\"openIrModal()\">Submit Missing Documents</button> <button type=\"button\" class=\"btn btn-info\" ng-if=\"(statusData.status == \'Enhancement Approved\' || statusData.status==\'Pre-Auth Approved\')\" ng-click=\"openEnhanceModal()\">Raise Enhancement</button><button type=\"button\" ng-if=\"(statusData.status == \'Enhance Approved\' || statusData.status==\'Pre-Auth Approved\') && claimNoData.isGovtScheme\" class=\"btn btn-info\" ng-click=\"openClaimSubmissionModal()\">Claim Submission</button><button type=\"button\" class=\"btn btn-success\" ng-if=\"!claimNoData.isGovtScheme && (statusData.status == \'Enhancement Approved\' || statusData.status==\'Pre-Auth Approved\')\" ng-click=\"openDischargeModal()\">Enhancement Discharge Documents</button></div></div></div></div></div></div></div></uib-tab><uib-tab ng-if=\"tabname === \'Active Claims\' || tabname === \'Documents Pending\'\" active=\"tab.active\" ng-click=\"getUnprocessedClaims()\" disable=\"tab.disabled\"><table class=\"table table-hover table-link\" ng-if=\"tabname != \'Planned Requests\'\"><thead><tr><th class=\"patientName\">Patient name</th><th class=\"claimId\">Claim id</th><th class=\"claimedAmount text-right\">Claimed amount</th><th class=\"claimedAmount text-right\">Approved amount</th><th class=\"statustext-right\">Status</th><th class=\"dateOfAdmission text-right\">Admission date</th><th class=\"dateOfAdmission text-right\">Discharge date</th></tr></thead><tbody ng-if=\"tabname === \'Active Claims\'\"><tr ng-repeat=\"item in preauthfilteredStatusFiltered | limitTo:itemsPerPage\" ng-class=\"item.isFlagRed ? \'font-bold alert-warning\' : \'\'\" ng-click=\"addTab(item.claimId,item, item.patientName)\"><td class=\"name\">{{item.patientName}} <a style=\"font-size:15px\" class=\"pull-right\" ng-show=\"item.isAarogya\"><span class=\"glyphicon glyphicon-font\" style=\"color: #43E441;\"></span></a></td><td>{{item.claimId}}</td><td class=\"text-right\">{{formatCurrency(item.claimedAmount)}}</td><td class=\"text-right\">{{formatCurrency(item.approvedAmount)}}</td><td class=\"text-right\"><span class=\"label label-info ng-binding\">{{item.status}}</span></td><td class=\"text-right\">{{item.dateOfAdmission}}</td><td class=\"text-right\">{{item.dateOfDischarge}}</td></tr></tbody></table><div><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" ng-change=\"pageChanged(currentPage, true)\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></uib-tab></uib-tabset><div class=\"modal fade\" id=\"otherenhanceModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\" style=\"width: 800px;\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4>Raise Enhancement for {{claimNoData.patientName}} <span ng-show=\"statusData.approvedAmount\">on previous approved amount : Rs. {{formatCurrency(statusData.approvedAmount)}} /-</span></h4></div><div class=\"modal-body\"><div class=\"modal-body\" id=\"enhanceFormBody\" ng-show=\"!esubmitted\"><form name=\"enhancementForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Claim No</label> <input type=\"text\" placeholder=\"Enter Claim No\" id=\"EnhancementClaimNo\" name=\"EnhancementClaimNo\" class=\"form-control\" ng-required=\"true\" ng-model=\"enhance.claimId\"></div><div class=\"col-md-4\"><label for=\"enhance-remarks\">Remark</label> <textarea ng-disabled=\"btnSubmitflag\" placeholder=\"Enter notes\" name=\"enhance-remarks\" class=\"form-control\" id=\"enhance-remarks\" cols=\"30\" ng-model=\"enhance.remarks\" rows=\"2\"></textarea></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Date Of Admission</label> <input name=\"doa\" id=\"datetimepickerDoa\" type=\"date\" class=\"form-control\" ng-model=\"enhance.doa\" required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Date Of Discharge</label> <input name=\"dod\" id=\"datetimepicker1\" type=\"date\" class=\"form-control\" ng-model=\"enhance.dod\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label for=\"docName\">Government Package <span class=\"text-danger\">*</span></label> <input type=\"text\" name=\"GovPackage\" ng-change=\"typeProcedureName()\" ng-model=\"form.govPackagesname\" placeholder=\"Type package name...\" uib-typeahead=\"condition.govPackageName for condition in govtPackageList | filter:$viewValue | limitTo:5\" typeahead-on-select=\"selectGovePackage($item, $model)\" typeahead-popup-template-url=\"govCustomPopupTemplate.html\" class=\"form-control\"></div></div><div class=\"col-md-3\" ng-if=\"!isSelectedGov\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label> <input name=\"procedureName\" placeholder=\"Enter price\" class=\"form-control\" autocomplete=\"off\" ng-model=\"govPackageManually.price\" type=\"text\" numbers-only=\"numbers-only\"></div></div><div class=\"col-md-3\" ng-if=\"isSelectedGov\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label><select ng-if=\"priceForGovPackage.length > 1\" name=\"procedurePrice\" class=\"form-control\" ng-model=\"govPackageManually.price\"><option value=\"\">--Select Price--</option><option value=\"{{obj.price}}\" ng-repeat=\"obj in priceForGovPackage | orderBy:\'obj\'\">{{obj.price}}</option></select><input ng-if=\"priceForGovPackage.length === 1\" readonly=\"true\" name=\"procedureName1\" placeholder=\"Enter price\" class=\"form-control\" autocomplete=\"off\" ng-model=\"govPackageManually.price\" type=\"text\"></div></div><div class=\"col-md-1\" style=\"margin-top: 22px;\"><div class=\"form-group\"><button ng-disabled=\"!(govPackageManually.price && form.govPackagesname)\" class=\"btn btn-primary\" ng-click=\"addGovPackageManually( form.govPackagesname, govPackageManually, isSelectedGov)\">Add</button></div></div><div class=\"row\" style=\"background-color: aliceblue; border-radius: 10px;\" ng-if=\"form.isgovtscheme && govPackageData.length >0\"><div class=\"col-md-12\"><table class=\"table table-hover table-link\"><thead><th class=\"patientName text-left\">Name</th><th class=\"patientName text-center\">Price</th><th class=\"patientName text-center\">Action</th></thead><tbody><tr tooltip-placement=\"top\" ng-repeat=\"sel_package in govPackageData\">{{sel_package}}<td class=\"text-left\">{{sel_package.packageName}}</td><td style=\"width: 15%\" class=\"text-center\">{{sel_package.packageCost}} <span ng-show=\"sel_package.isPerDayEligiblePackage === true\">* {{noOfDays}} days</span></td><td style=\"width: 15%\" class=\"text-center\"><button class=\"btn btn-danger btn-xs\" ng-click=\"removeGovPackage(sel_package)\">Remove</button></td></tr><tr tooltip-placement=\"top\" ng-if=\"govPackageData.length >0\"><td class=\"text-left\" style=\"font-size: large;color: black;\">Total</td><td class=\"text-center\" style=\"font-size: large;color: black;\"><span class=\"text-center\">{{totalCalcAmount}}</span></td><td class=\"text-center\" style=\"font-size: large;color: black;\"></td></tr></tbody></table></div></div></div><script type=\"text/ng-template\" id=\"govCustomPopupTemplate.html\"><div class=\"custom-popup-wrapper\" ng-style=\"{top: position().top+\'px\', left: position().left+\'px\'}\" style=\"display: block;\" ng-show=\"isOpen() && !moveInProgress\" aria-hidden=\"{{!isOpen()}}\"> <table class=\"table table-hover\"> <tr ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.id}}\"> <td width=\"200px\">{{match.model.govPackageName}}</td> </tr> </table> </div></script><script type=\"text/ng-template\" id=\"customPopupTemplate.html\"><div class=\"custom-popup-wrapper\" ng-style=\"{top: position().top+\'px\', left: position().left+\'px\'}\" style=\"display: block;\" ng-show=\"isOpen() && !moveInProgress\" aria-hidden=\"{{!isOpen()}}\"> <table class=\"table table-hover\"> <tr ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.id}}\"> <td width=\"200px\">{{match.model.package_Name}}</td> </tr> </table> </div></script><div class=\"row\"><div class=\"col-md-12\"><h4 style=\"color: black;\">Attachments *</h4><div ngf-drop=\"uploadAllFiles(this,\'ENHANCEMENT\')\" ngf-select=\"uploadAllFiles(this,\'ENHANCEMENT\')\" ng-model=\"files\" class=\"drop-box\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*,application/pdf\">Drop pdfs or images here or click to upload</div><div class=\"row\" ng-if=\"actionType==\'ENHANCEMENT\'\"><div class=\"col-md-12\"><ul class=\"tagsList\" style=\"font-size: small;\"><li class=\"closeBtn\" ng-repeat=\"fac in file track by $index\">{{fac.fileName}}<div id=\"{{fac.progressDivId}}\" class=\"progress\" ng-show=\"fac.progressBar >= 0 && fac.progressBar<100\"></div><a href=\"\" ng-show=\"fac.progressBar==100\" ng-click=\"RemoveEmail($index)\"><i class=\"fa fa-close\"></i></a></li></ul></div></div></div></div><hr><div class=\"row\"><div class=\"col-md-8\"></div><div class=\"col-md-4\"><a ng-hide=\"btnSubmitflag\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"submitEnhance()\" ng-disabled=\"enhancementForm.$invalid || !file || (file && file.length==0) || (file && file.length==1 && !file[0].docPath) || govPackageData.length == 0\">Enhance</a> <a ng-show=\"btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <a type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\" ng-click=\"$parent.hideModal()\">Cancel</a></div></div></form></div></div></div></div></div><div class=\"modal fade\" id=\"otherdischargeModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\" style=\"width: 800px;\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4>Submit Final Discharge</h4></div><div><div class=\"modal-body\" id=\"finalDischargeBody\" ng-show=\"!dsubmitted\"><form name=\"dischargeSub\" novalidate=\"\"><input type=\"hidden\" value=\"\" name=\"claimId\" id=\"dClaimId\"> <input type=\"hidden\" value=\"{{hospId}}\" name=\"hospId\"> <input type=\"hidden\" value=\"{{user.userId}}\" name=\"updatedBy\"> <input type=\"hidden\" value=\"discharge\" name=\"ClaimAction\"><p class=\"bg-info\">Components mentioned below are optional.Breakup will help us process your discharge case faster.</p><div class=\"table-responsive\"><div class=\"table table-hover\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"\">Claim No</label> <input type=\"text\" placeholder=\"Enter Claim No\" id=\"disChargeClaimNo\" name=\"disChargeClaimNo\" class=\"form-control\" ng-required=\"true\" ng-model=\"discharge.claimId\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Date Of Admission</label> <input name=\"doa\" id=\"datetimepickerDoa\" type=\"date\" class=\"form-control\" ng-model=\"discharge.doa\" required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Date Of Discharge</label> <input name=\"dod\" id=\"datetimepicker1\" type=\"date\" class=\"form-control\" ng-model=\"discharge.dod\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Room Rent Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Includes Room rent, ICU Charges, Nursing charges, Duty Doctor fee, Monitor charges\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.roomrent\" name=\"roomrent\" class=\"form-control\" placeholder=\"Enter Roomrent\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.roomrent.$dirty && dischargeForm.roomrent.$error.required\">Required</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Diagnostic Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Includes charges from Bio Chemistry, Haematology, Microbiology, Neurology, Pathology, Radiology\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.investigation\" name=\"investigation\" class=\"form-control\" placeholder=\"Enter Investigation\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.investigation.$dirty && dischargeForm.investigation.$error.required\">Required</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Professional Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Incudes Procedure charges, Surgeon charges, Anaesthetist charges, Visit charges, OT rent, OT equipment charges, OT Drugs & Consumables\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.consultation\" name=\"consultation\" class=\"form-control\" placeholder=\"Enter Consultation\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.consultation.$dirty && dischargeForm.consultation.$error.required\">Required</span></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Pharmacy Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Includes Pharmacy charges and consumables\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.pharmacy\" name=\"pharmacy\" class=\"form-control\" placeholder=\"Enter Pharmacy\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.pharmacy.$dirty && dischargeForm.pharmacy.$error.required\">Required</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Other Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Includes Implant charges, Non-Medical Expenses, other charges\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.others\" name=\"others\" class=\"form-control\" placeholder=\"Others\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.pharmacy.$dirty && dischargeForm.pharmacy.$error.required\">Required</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Final Claimed Amount</label> <input ng-init=\"discharge.total=0\" ng-class=\"{\'border-warning\':(discharge.total <= 0 || discharge.total == null)}\" name=\"dischargeTotal\" min=\"1\" ng-required=\"true\" class=\"form-control\" type=\"text\" ng-model=\"discharge.total\" readonly=\"\"> <span ng-show=\"(discharge.total <= 0 || discharge.total == null)\"><small><em>Final bill cannot be 0 . Please enter a value in any of above fields.</em></small></span></div></div></div></div></div><label for=\"enhance-remarks\">Notes for discharge (optional)</label> <textarea required=\"\" placeholder=\"Enter notes for discharge\" name=\"enhance-remarks\" ng-model=\"discharge.remarks\" class=\"form-control\" id=\"discharge-remarks\" cols=\"30\" rows=\"3\"></textarea><hr><div class=\"row\"><div class=\"col-md-12\"><h4 style=\"color: black;\">Attach Final Bill & Discharge Summary</h4><div ngf-drop=\"uploadAllFiles(this,\'DISCHARGE\')\" ngf-select=\"uploadAllFiles(this,\'DISCHARGE\')\" ng-model=\"files\" class=\"drop-box\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*,application/pdf\">Drop pdfs or images here or click to upload</div><div class=\"row\" ng-if=\"actionType==\'DISCHARGE\'\"><div class=\"col-md-12\"><ul class=\"tagsList\" style=\"font-size: small;\"><li class=\"closeBtn\" ng-repeat=\"fac in file track by $index\">{{fac.fileName}}<div id=\"{{fac.progressDivId}}\" class=\"progress\" ng-show=\"fac.progressBar >= 0 && fac.progressBar<100\"></div><a href=\"\" ng-show=\"fac.progressBar==100\" ng-click=\"RemoveEmail($index)\"><i class=\"fa fa-close\"></i></a></li></ul></div></div></div></div><hr><a ng-disabled=\"dischargeSub.$invalid || !file || (file && file.length==0) || (file && file.length==1 && !file[0].docPath)\" ng-hide=\"isFlag.btnSubmitflag\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"isFlag.btnSubmitflag = true;submitDischarge()\">Submit</a> <a ng-show=\"isFlag.btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"isFlag.btnSubmitflag\" ng-click=\"$parent.hideModal()\">Cancel</button></form></div><div class=\"modal-body\" ng-show=\"dsubmitted\"><p ng-show=\"dsubsuccess\">Your discharge documents have been submitted successfully.</p><p ng-show=\"!dsubsuccess\">Something went wrong! Your discharge summary is not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"dsubmitted=false;modalRenderingMethods.close()\">Close</button></div></div></div></div></div><div class=\"modal fade\" id=\"othersubmitMissing\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Submit Missing Documents</h4></div><div class=\"modal-body\" id=\"submitFormBody\" ng-show=\"!msubmitted\"><form id=\"missingForm\"><div class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><label for=\"\">Claim No</label> <input type=\"text\" placeholder=\"Enter Claim No\" id=\"missingSubmissionClaimNo\" name=\"missingSubmissionClaimNo\" class=\"form-control\" ng-required=\"true\" ng-model=\"IrSubmissionClaimNo\"></div></div><div class=\"col-md-7\"><div class=\"form-group\"><label for=\"enhance-remarks\">Remarks on missing documents</label> <textarea required=\"\" ng-model=\"enhance.comment\" name=\"enhance-remarks\" class=\"form-control\" id=\"enhance-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your comments regarding missing documents. Eg: Surgical details updated or Diagnosis details updated or Submitted missing scan bill etc.,\"></textarea></div></div></div><div class=\"row\"><div class=\"col-md-12\"><h4 style=\"color: black;\">Attach Missing Documents</h4><div ngf-drop=\"uploadAllFiles(this,\'IRSUBMISSION\')\" ngf-select=\"uploadAllFiles(this,\'IRSUBMISSION\')\" ng-model=\"files\" class=\"drop-box\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*,application/pdf\">Drop pdfs or images here or click to upload</div><div class=\"row\" ng-if=\"actionType==\'IRSUBMISSION\'\"><div class=\"col-md-12\"><ul class=\"tagsList\" style=\"font-size: small;\"><li class=\"closeBtn\" ng-repeat=\"fac in file track by $index\">{{fac.fileName}}<div id=\"{{fac.progressDivId}}\" class=\"progress\" ng-show=\"fac.progressBar >= 0 && fac.progressBar<100\"></div><a href=\"\" ng-show=\"fac.progressBar==100\" ng-click=\"RemoveEmail($index)\"><i class=\"fa fa-close\"></i></a></li></ul></div></div></div></div><hr><a ng-hide=\"isFlag.btnSubmitflag\" ng-disabled=\"!enhance.comment || !file || (file && file.length==0) || (file && file.length==1 && !file[0].docPath)\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"submitIr()\">Submit</a> <a ng-show=\"isFlag.btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"isFlag.btnSubmitflag\">Cancel</button></form></div><div class=\"modal-body\" ng-show=\"msubmitted\"><p ng-show=\"msubsuccess\">Your missing documents have been submitted successfully.</p><p ng-show=\"!msubsuccess\">Something went wrong! Your missing documents are not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"msubmitted=false;modalRenderingMethods.close()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"otherClaimSubmissionModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\" style=\"width: 800px;\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4>Claim Submission for {{claimNoData.patientName}} <span ng-show=\"statusData.approvedAmount\">on previous approved amount : Rs. {{formatCurrency(statusData.approvedAmount)}} /-</span></h4></div><div class=\"modal-body\"><div class=\"modal-body\" id=\"enhanceFormBody\" ng-show=\"!esubmitted\"><form name=\"ClaimSubmissionForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><label style=\"color: black;\">Attach Documents *</label><div ngf-drop=\"uploadAllFiles(this,\'CLAIMSUBMISSION\')\" ngf-select=\"uploadAllFiles(this,\'CLAIMSUBMISSION\')\" ng-model=\"files\" class=\"drop-box\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*,application/pdf\">Drop pdfs or images here or click to upload</div><div class=\"row\" ng-if=\"actionType==\'CLAIMSUBMISSION\'\"><div class=\"col-md-12\"><ul class=\"tagsList\" style=\"font-size: small;\"><li class=\"closeBtn\" ng-repeat=\"fac in file track by $index\">{{fac.fileName}}<div id=\"{{fac.progressDivId}}\" class=\"progress\" ng-show=\"fac.progressBar >= 0 && fac.progressBar<100\"></div><a href=\"\" ng-show=\"fac.progressBar==100\" ng-click=\"RemoveEmail($index)\"><i class=\"fa fa-close\"></i></a></li></ul></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"claimSubmission-remarks\">Comments</label> <textarea ng-disabled=\"btnSubmitflag\" placeholder=\"Enter notes\" name=\"claimSubmission-remarks\" class=\"form-control\" id=\"claimSubmission-remarks\" cols=\"30\" ng-model=\"claimSubmission.remarks\" rows=\"2\"></textarea></div></div><hr><div class=\"row\"><div class=\"col-md-8\"></div><div class=\"col-md-4\"><a ng-hide=\"btnSubmitflag\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"submitClaimSubmission()\" ng-disabled=\"ClaimSubmissionForm.$invalid || !file || (file && file.length==0) || (file && file.length==1 && !file[0].docPath)\">Submit</a> <a ng-show=\"btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <a type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\" ng-click=\"$parent.hideModal()\">Cancel</a></div></div></form></div></div></div></div></div></div>");
$templateCache.put("app/components/pagination/pagination.html","<div class=\"pagination\"><ul><li ng-class=\"{disabled: noPrevious()}\"><a ng-click=\"selectPrevious()\">Previous</a></li><li ng-repeat=\"page in pages\" ng-class=\"{active: isActive(page)}\"><a ng-click=\"selectPage(page)\">{{page}}</a></li><li ng-class=\"{disabled: noNext()}\"><a ng-click=\"selectNext()\">Next</a></li></ul></div>");
$templateCache.put("app/components/plusDigitalMer/plusDigitalMer.html","<style>\n    .digital-mer {width:100%; margin: 0 auto;}\n    .digital-mer .modal-dialog {\n        width:760px; \n        margin-top:0px;\n\n    }\n    .mer-form {border-bottom:1px solid #ddd; padding-bottom:15px; margin-bottom:15px;}\n    @media print {\n        .main-wrap {display:none;}\n        .modal-content {border:0;}\n        .modal-header .close {display:none;}\n        .modal-footer {display:none;}\n        .digital-mer {width:100%;}\n        .digital-mer .modal-dialog {\n            width:100%; \n            margin-top:0px;\n        }\n    }\n</style><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Digital MER</h4></div><div class=\"modal-body\"><div ng-repeat=\"ques in questions.headerQuestions\"><div class=\"row mer-form\"><div class=\"col-xs-{{item.gridColumn}}\" ng-repeat=\"item in ques.questionlineItems\"><div ng-if=\"item.gridColumn!=12 && item.type === \'text\'\">{{item.text}}</div><div ng-if=\"item.gridColumn==12 && item.type === \'text\'\"><strong>{{item.text}}</strong></div><div ng-if=\"item.type === \'radio\'\" class=\"checkbox\"><label for=\"{{radioBtns.inputId}}\" ng-repeat=\"radioBtns in item.listing\" class=\"radio-inline\"><input type=\"radio\" name=\"{{item.id}}\" id=\"{{radioBtns.inputId}}\" ng-model=\"item.val\" value=\"{{radioBtns.inputId}}\" ng-disabled=\"questions.isSubmitted\"> {{radioBtns.inputText}}</label></div><div ng-if=\"item.type === \'checkbox\'\"><label for=\"{{checkBoxItems.inputId}}\" ng-repeat=\"checkBoxItems in item.listing\" class=\"checkbox-inline\"><input type=\"checkbox\" name=\"{{item.id}}\" id=\"{{checkBoxItems.inputId}}\" ng-model=\"checkBoxItems.val\" ng-checked=\"checkBoxItems.val===\'true\'\" value=\"{{checkBoxItems.inputId}}\" ng-disabled=\"questions.isSubmitted\"> {{checkBoxItems.inputText}}</label></div><div ng-if=\"item.type === \'select\'\"><select name=\"{{item.id}}\" id=\"{{item.id}}\" ng-model=\"item.val\" class=\"form-control input-sm\" ng-disabled=\"questions.isSubmitted\"><option value=\"\" selected=\"selected\">Select</option><option value=\"{{option.inputId}}\" ng-repeat=\"option in item.listing\">{{option.inputText}}</option></select></div><div ng-if=\"item.type === \'textarea\'\"><textarea name=\"{{item.id}}\" id=\"{{item.id}}\" value=\"{{item.val}}\" ng-model=\"item.val\" class=\"form-control\" style=\"height:30px;\" ng-disabled=\"questions.isSubmitted\"></textarea></div><div ng-if=\"item.type === \'date\'\"><input type=\"date\" name=\"{{item.id}}\" id=\"{{item.id}}\" value=\"{{item.val}}\" ng-model=\"item.val\" class=\"form-control input-sm\" ng-disabled=\"questions.isSubmitted\"></div><div ng-if=\"item.type === \'textbox\'\"><input type=\"text\" name=\"{{item.id}}\" id=\"{{item.id}}\" value=\"{{item.val}}\" ng-model=\"item.val\" class=\"form-control input-sm\" ng-disabled=\"questions.isSubmitted\"></div></div></div></div><div ng-repeat=\"ques in questions.lstQuestions\"><div class=\"row mer-form\"><div class=\"col-xs-{{item.gridColumn}}\" ng-repeat=\"item in ques.questionlineItems\"><div ng-if=\"item.gridColumn!=12 && item.type === \'text\'\">{{item.text}}</div><div ng-if=\"item.gridColumn==12 && item.type === \'text\'\"><strong>{{item.text}}</strong></div><div ng-if=\"item.type === \'radio\'\" class=\"checkbox\"><label for=\"{{radioBtns.inputId}}\" ng-repeat=\"radioBtns in item.listing\" class=\"radio-inline\"><input type=\"radio\" name=\"{{item.id}}\" id=\"{{radioBtns.inputId}}\" ng-model=\"item.val\" value=\"{{radioBtns.inputId}}\" ng-disabled=\"questions.isSubmitted\"> {{radioBtns.inputText}}</label></div><div ng-if=\"item.type === \'checkbox\'\"><label for=\"{{checkBoxItems.inputId}}\" ng-repeat=\"checkBoxItems in item.listing\" class=\"checkbox-inline\"><input type=\"checkbox\" name=\"{{item.id}}\" id=\"{{checkBoxItems.inputId}}\" ng-model=\"checkBoxItems.val\" ng-checked=\"checkBoxItems.val===\'true\'\" value=\"{{checkBoxItems.inputId}}\" ng-disabled=\"questions.isSubmitted\"> {{checkBoxItems.inputText}}</label></div><div ng-if=\"item.type === \'select\'\"><select name=\"{{item.id}}\" id=\"{{item.id}}\" ng-model=\"item.val\" class=\"form-control input-sm\" ng-disabled=\"questions.isSubmitted\"><option value=\"\" selected=\"selected\">Select</option><option value=\"{{option.inputId}}\" ng-repeat=\"option in item.listing\">{{option.inputText}}</option></select></div><div ng-if=\"item.type === \'textarea\'\"><textarea name=\"{{item.id}}\" id=\"{{item.id}}\" value=\"{{item.val}}\" ng-model=\"item.val\" class=\"form-control\" style=\"height:30px;\" ng-disabled=\"questions.isSubmitted\"></textarea></div><div ng-if=\"item.type === \'date\'\"><input type=\"date\" name=\"{{item.id}}\" id=\"{{item.id}}\" value=\"{{item.val}}\" ng-model=\"item.val\" class=\"form-control input-sm\" ng-disabled=\"questions.isSubmitted\"></div><div ng-if=\"item.type === \'textbox\'\"><input type=\"text\" name=\"{{item.id}}\" id=\"{{item.id}}\" value=\"{{item.val}}\" ng-model=\"item.val\" class=\"form-control input-sm\" ng-disabled=\"questions.isSubmitted\"></div></div></div></div><div ng-repeat=\"ques in questions.footerQuestions\"><div class=\"row mer-form\"><div class=\"col-xs-{{item.gridColumn}}\" ng-repeat=\"item in ques.questionlineItems\"><div ng-if=\"item.gridColumn!=12 && item.type === \'text\'\">{{item.text}}</div><div ng-if=\"item.gridColumn==12 && item.type === \'text\'\"><strong>{{item.text}}</strong></div><div ng-if=\"item.type === \'radio\'\" class=\"checkbox\"><label for=\"{{radioBtns.inputId}}\" ng-repeat=\"radioBtns in item.listing\" class=\"radio-inline\"><input type=\"radio\" name=\"{{item.id}}\" id=\"{{radioBtns.inputId}}\" ng-model=\"item.val\" value=\"{{radioBtns.inputId}}\" ng-disabled=\"questions.isSubmitted\"> {{radioBtns.inputText}}</label></div><div ng-if=\"item.type === \'checkbox\'\"><label for=\"{{checkBoxItems.inputId}}\" ng-repeat=\"checkBoxItems in item.listing\" class=\"checkbox-inline\"><input type=\"checkbox\" name=\"{{item.id}}\" id=\"{{checkBoxItems.inputId}}\" ng-model=\"checkBoxItems.val\" ng-checked=\"checkBoxItems.val===\'true\'\" value=\"{{checkBoxItems.inputId}}\" ng-disabled=\"questions.isSubmitted\"> {{checkBoxItems.inputText}}</label></div><div ng-if=\"item.type === \'select\'\"><select name=\"{{item.id}}\" id=\"{{item.id}}\" ng-model=\"item.val\" class=\"form-control input-sm\" ng-disabled=\"questions.isSubmitted\"><option value=\"\" selected=\"selected\">Select</option><option value=\"{{option.inputId}}\" ng-repeat=\"option in item.listing\">{{option.inputText}}</option></select></div><div ng-if=\"item.type === \'textarea\'\"><textarea name=\"{{item.id}}\" id=\"{{item.id}}\" value=\"{{item.val}}\" ng-model=\"item.val\" class=\"form-control\" style=\"height:30px;\" ng-disabled=\"questions.isSubmitted\"></textarea></div><div ng-if=\"item.type === \'date\'\"><input type=\"date\" name=\"{{item.id}}\" id=\"{{item.id}}\" value=\"{{item.val}}\" ng-model=\"item.val\" class=\"form-control input-sm\" ng-disabled=\"questions.isSubmitted\"></div><div ng-if=\"item.type === \'textbox\'\"><input type=\"text\" name=\"{{item.id}}\" id=\"{{item.id}}\" value=\"{{item.val}}\" ng-model=\"item.val\" class=\"form-control input-sm\" ng-disabled=\"questions.isSubmitted\"></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"closeModal()\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-model=\"btnSave\" ng-disabled=\"{{questions.isSubmitted || isInsurerRoles}}\" ng-click=\"saveTestReport(questions.lstQuestions,questions.headerQuestions,questions.footerQuestions)\">Submit</button></div></div>");
$templateCache.put("app/components/plusModals/communicationHistory.html","<style>\n    .modal-body {\n        max-height: calc(100vh - 200px);\n        overflow-y: auto;\n    }\n</style><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Communication history</h4></div><div class=\"modal-body\"><div class=\"panel panel-default\" ng-repeat=\"comm in communicationDetails\" ng-show=\"communicationDetails.length>0\"><div class=\"panel-heading\"><b>{{comm.communicationTypeValue}}</b> To <b>{{comm.receiver}}</b> on <b>{{compareDate(comm.sentTime)}} | {{formatTime(comm.sentTime)}}</b> <span class=\"pull-right fa fa-check-circle-o fa-2x text-success\" ng-show=\"{{comm.isScuccess}}\" title=\"Mail/SMS Send Successfully\"></span> <i class=\"pull-right fa fa-send-o fa-2x text-success\" ng-click=\"resendSMS(comm.id)\" title=\"Re-trigger\"></i> <span class=\"pull-right fa fa-times-circle-o fa-2x text-danger\" ng-show=\"!{{comm.isScuccess}}\" title=\"Failed to send Mail/SMS\"></span></div><div class=\"panel-body\" ng-if=\"!isInsurerAgent\"><p ng-show=\"comm.body.length>0\">{{comm.body}}</p><p ng-show=\"comm.communicationTypeValue == \'Email\'\"><a href=\"{{downloadEmailBodyUrl + comm.messageId}}\" target=\"_blank\" class=\"btn btn-primary btn-sm\"><i class=\"fa fa-download\"></i> Download Email Content</a></p></div></div><div class=\"row\" ng-show=\"!communicationDetails.length>0\"><h6 style=\"color: red; margin-left: 20px;\">{{noCommunication}}</h6></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"closeModal()\" data-dismiss=\"modal\">Close</button></div></div>");
$templateCache.put("app/components/plusModals/confirmAppointmentModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\" ng-if=\"request.statusId === 40\">Confirm customer attendance</h4><h4 class=\"modal-title\" ng-if=\"request.statusId === 22\">Confirm the appointment</h4><h4 class=\"modal-title\" ng-if=\"request.statusId === 32\">Submit reports of this appointment</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"remark\">Remark *</label> <textarea style=\"resize: vertical;\" id=\"remark\" class=\"form-control\" placeholder=\"Enter remark\" ng-model=\"remark\" required=\"\"></textarea></div><div class=\"col-md-6\" style=\"margin-left: -20px\"><label for=\"doa\">Requested date of visit</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div><div class=\"col-md-6\" ng-show=\"request.statusId === 32\"><div class=\"form-group\"><label>Attach lab reports</label><mb-plus-file-upload action=\"action\" file-fn=\"fileFn(arg, \'report\')\"></mb-plus-file-upload></div><div class=\"form-group\"><div ng-if=\"storeFiles.length > 0\" class=\"form-group\" ng-repeat=\"item in storeFiles\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: rgb(238, 238, 238);font-size: 12px;\"><a ng-click=\"downloadAttachment(item.filePath)\" class=\"col-md-10\">{{item.fileName}}</a> <a ng-click=\"removeFiles(item)\" class=\"col-md-2\" style=\"color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModal()\">Close</button> <button type=\"button\" ng-disabled=\"!remark\" class=\"btn btn-primary\" ng-click=\"confirmAppointment(false)\" ng-if=\"request.statusId === 22\">Confirm</button> <button type=\"button\" ng-disabled=\"!remark\" class=\"btn btn-primary\" ng-click=\"confirmAppointment(false)\" ng-if=\"request.statusId === 40\">Attended</button> <button type=\"button\" ng-disabled=\"!remark\" class=\"btn btn-primary\" ng-click=\"confirmAppointment(true)\" ng-if=\"request.statusId === 40\">Not Attended</button> <button type=\"button\" ng-disabled=\"!remark || storeFiles.length === 0\" class=\"btn btn-primary\" ng-click=\"confirmAppointment(false)\" ng-if=\"request.statusId === 32\">Submit</button></div></div>");
$templateCache.put("app/components/plusModals/confirmBulkAppointmentModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\" ng-if=\"request.statusId === 22\">Confirm the selected appointments</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"remark\">Remark *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"remarks\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModal()\">Close</button> <button type=\"button\" ng-disabled=\"!remarks\" class=\"btn btn-primary\" ng-click=\"confirmBulkAppointments()\">Submit</button></div></div>");
$templateCache.put("app/components/plusModals/dcNotes.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: green\" class=\"modal-title\">DC Outsourcing Detail</h4></div><div class=\"modal-body\">{{outSourcingDetail ? outSourcingDetail : \'No data found.\' }}</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModal()\">Close</button></div></div>");
$templateCache.put("app/components/plusModals/packageTestDetailsModal.html","<style>\n    .modal-body {\n        max-height: calc(100vh - 200px);\n        overflow-y: auto;\n    }\n</style><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Test Details</h4></div><div class=\"modal-body\" ng-show=\"investigationList.length>0\"><div class=\"row\"><div class=\"col-md-12\" ng-repeat=\"tests in investigationList\"><div class=\"panel-default\"><h4 class=\"panel-header tex\" style=\"margin-left: 17px; padding-left: 7px;margin-top: 5px;color: cornflowerblue;\">{{tests.investigationName}}</h4><ol><li ng-repeat=\"tst in tests.testDetails\"><span>{{tst.testName}}</span></li></ol><hr style=\"margin-top: -2px; margin-bottom: 0px;\"></div></div></div></div><div class=\"modal-body\" ng-show=\"errorMsz.length>0\"><div class=\"row\"><strong style=\"font-size: 1em; margin-left: 100px;color:red\">{{errorMsz}}</strong></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModal()\">Close</button></div></div>");
$templateCache.put("app/components/plusModals/plusAlert.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #f00;\" class=\"modal-title\" ng-show=\"!isSuccess\">Error message</h4><h4 style=\"color: green\" class=\"modal-title\" ng-show=\"isSuccess\">Success message</h4></div><div class=\"modal-body\">{{errorMsz}}</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModal()\">Close</button></div></div>");
$templateCache.put("app/components/plusModals/plusAlertNotify.html","<div class=\"modal-content\"><div class=\"modal-header\"><h4 style=\"color: green\" class=\"modal-title\">Notification</h4></div><div class=\"modal-body\">{{errorMsz}}</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModal()\">Close</button></div></div>");
$templateCache.put("app/components/plusModals/requestDNDModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\" ng-if=\"showDND\">DND</h4><h4 class=\"modal-title\" ng-if=\"showDNDCustomer\">DND Customer</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"reason\">Reason *</label> <textarea style=\"resize: vertical;\" id=\"reason\" class=\"form-control\" placeholder=\"Enter reason for DND\" ng-model=\"reason\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModal()\">Close</button> <button type=\"button\" ng-disabled=\"!reason\" class=\"btn btn-primary\" ng-click=\"markDnd()\">Request DND</button></div></div>");
$templateCache.put("app/components/plusModals/rescheduleAppointmentModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title modalHeaderText\">Reschedule appointment</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"rescheduleForm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Current requested Date</label> <input name=\"doa\" id=\"originalDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{currentAppointmentDate}}\"></div></div><div class=\"col-md-5\"><label for=\"doa\">Select reschedule date</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"reschedule.opened\" datepicker-options=\"dateOptionsReschedule\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"reschedule()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><br><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"yearInSecAppointmentDate >= 2015\">Customer has provided {{secondPreferredTime}} as second preference. We would like you to consider this if possible.</div><span><input type=\"checkbox\" ng-click=\"showDcSelection(action.showdcselection, \'dcVisit\')\" ng-model=\"action.showdcselection\"> Check this to select a new diagnostic centre</span><br><span><input type=\"checkbox\" ng-click=\"showDcSelection(action.showHomeVisitSelection, \'homeVisit\')\" ng-model=\"action.showHomeVisitSelection\"> Check this to enter home address for home visit</span><hr><div><div ng-show=\"action.showHomeVisitSelection\"><label for=\"\">Enter home address to move this appointment</label><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-6 noPdngRt\"><input type=\"text\" class=\"form-control\" ng-model=\"homeVisit.addressLineOne\" placeholder=\"Enter Address line 1\"></div><div class=\"col-md-6 noPdngRt\"><input type=\"text\" class=\"form-control\" ng-model=\"homeVisit.addressLineTwo\" placeholder=\"Enter Address line 2\"></div></div></div><div><label ng-show=\"action.showdcselection\" for=\"doa\">Select a provider to move this appointment</label><div class=\"row\" style=\"margin-bottom:5px;\" ng-show=\"action.showdcselection || action.showHomeVisitSelection\"><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testStateId\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\" disabled=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\"><option value=\"\" disabled=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div><div class=\"col-md-4\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\"><option value=\"\" disabled=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div></div><div class=\"row\" ng-show=\"action.showdcselection || action.showHomeVisitSelection\"><div class=\"col-md-6 noPdngRt\"><select name=\"\" id=\"sublocalityId\" class=\"form-control\" ng-model=\"testData.testSubLocalityId\" ng-change=\"loadLocationData(\'dc\', testData.testSubLocalityId)\"><option value=\"\" disabled=\"\">Select a sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div><div class=\"col-md-6\"><select name=\"\" id=\"dcId\" ng-model=\"testData.dcValue\" class=\"form-control\"><option value=\"\" disabled=\"\">Select a diagnostic centre</option><option value=\"{{dc}}\" ng-repeat=\"dc in diagnosticCentres track by $index\">{{dc.entityName}}</option></select></div></div></div></div><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModal()\">Close</button> <button type=\"button\" ng-disabled=\"rescheduleForm.$invalid\" class=\"btn btn-primary\" ng-click=\"makeRequest()\">Request for reschedule</button></div></div>");
$templateCache.put("app/components/plusModals/resendEmailModals.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Resend email</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"emailErrorMsg\" style=\"display:none\">{{errorMsz}}</div><form name=\"frmResendEmail\" action=\"\" class=\"form\"><div class=\"row form-group\"><div class=\"col-md-6 noPdngRt\"><label for=\"status\">Email type</label><span class=\"redfont\">*</span><select name=\"\" id=\"emailType\" class=\"form-control\" ng-model=\"resendEmailDetails.statusID\"><option value=\"\">Select type</option><option value=\"24\">Appointment letter</option></select></div><div class=\"col-md-6\"><label for=\"email\">Email id</label><span class=\"redfont\">*</span> <input id=\"email\" class=\"form-control\" type=\"text\" ng-model=\"resendEmailDetails.emailID\" required=\"\"></div></div><div class=\"row form-group\" ng-if=\"isdc\"><div class=\"col-md-6 noPdngRt\"><label for=\"status\">OTP</label><span class=\"redfont\">*</span> <input id=\"otp\" class=\"form-control\" type=\"text\" ng-model=\"resendEmailDetails.otp\"></div></div></form><div class=\"alert alert-danger\" role=\"alert\" id=\"emailErrorMsg\" ng-show=\"errorMsz.length>0\">{{errorMsz}}</div><div class=\"alert alert-success\" role=\"alert\" id=\"emailErrorMsg\" ng-show=\"successMsz.length>0\">{{successMsz}}</div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModal()\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"frmResendEmail.$invalid\" ng-click=\"ResendEmail()\">Send</button></div></div>");
$templateCache.put("app/components/plusModals/signInModal.html","<style>\n    .otp-container {\n        display: flex;\n    }\n\n    .otp-input {\n        width: 34px;\n        height: 45px;\n        margin-right: 20px;\n        margin-top: 20px;\n        margin-bottom: 20px;\n        border-radius: 10px;\n        border: 1px solid #bbb;\n        font-size: 24px;\n        text-align: center;\n        outline: none;\n    }\n\n    .otp-input:focus {\n        border-color: #007bff;\n    }\n\n    .wrongOTP {\n        width: 34px;\n        height: 45px;\n        margin-right: 20px;\n        margin-top: 25px;\n        margin-bottom: 10px;\n        border-radius: 10px;\n        border: 1px solid #bbb;\n        font-size: 24px;\n        text-align: center;\n        outline: none;\n        animation: shake 0.5s ease-in-out;\n        /* box-shadow: 0 0 0.5em red; */\n        border-color: red\n    }\n\n    @keyframes shake {\n        0% {\n            transform: translateX(0);\n        }\n\n        10% {\n            transform: translateX(-5px);\n        }\n\n        20% {\n            transform: translateX(5px);\n        }\n\n        30% {\n            transform: translateX(-5px);\n        }\n\n        40% {\n            transform: translateX(5px);\n        }\n\n        50% {\n            transform: translateX(-5px);\n        }\n\n        60% {\n            transform: translateX(5px);\n        }\n\n        70% {\n            transform: translateX(-5px);\n        }\n\n        80% {\n            transform: translateX(5px);\n        }\n\n        90% {\n            transform: translateX(-5px);\n        }\n\n        100% {\n            transform: translateX(0);\n        }\n    }\n</style><div class=\"modal-content\" style=\"height: 300px; padding: 32px;\"><div claas=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button></div><div class=\"container\"><div style=\"display: flex; justify-content: space-between;\"><div><span style=\"color: #828282; font-size: medium; font-family: \'Nunito\'\">Enter:</span> <span style=\"font-weight: \'700\'; font-size: medium; font-family: \'Nunito\'\">5 digit OTP</span></div></div><div style=\"display: flex;\"><span style=\"color: #828282; font-size: medium; font-family: \'Nunito\'\">Sent on: &nbsp;</span> <span style=\"font-weight: \'700\'; font-size: medium; font-family: \'Nunito\'; white-space: break-spaces\">{{userEmail}}</span></div><div class=\"otp-container\"><div data-ng-repeat=\"value in otpValues track by $index\"><input id=\"{{otpBox$index}}\" type=\"text\" ng-model=\"otpValues[$index]\" name=\"\" maxlength=\"1\" oninput=\"this.value=this.value.replace(/[^0-9]/g,\'\');\" ng-class=\"{ \'wrongOTP\': isWrongOTP, \'otp-input\': !isWrongOTP }\" ng-keydown=\"handleKeydown($event, $index)\"></div></div><div><span style=\"font-size: medium; color: red; font-family: \'Nunito\';\">{{errorMessage.replaceAll(\"_\", \" \")}}</span></div><div style=\"display: flex; flex-direction: column; margin-top: 10px;\"><span style=\"color: #828282; font-size: 14px; font-family: Nunito\">The OTP has been shared on your Email ID.</span> <span style=\"color: #828282; font-size: 14px; font-family: Nunito\">Please enter the OTP to proceed.</span></div><button ng-style=\"{ \'width\': \'50%\', \'height\': \'48px\', \'margin-top\': \'20px\', \'border-radius\': \'16px\', \'background-color\': isButtonDisabled() ? \'#00000042\' : \'#1778f2\', \'color\': \'white\', \'cursor\': \'pointer\', \'outline\': \'none\', \'border\': \'none\', \'transition\': \'background-color 0.3s ease\', }\" ng-click=\"verifyOTP()\" ng-disabled=\"isButtonDisabled() || isWrongOTP || isSubmitting\">Verify OTP</button></div></div>");
$templateCache.put("app/components/plusModals/splitRequestModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Split this request</h4></div><div class=\"modal-body\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h1 class=\"panel-title\">Related test bucket</h1></div><div class=\"row panel-body\"><div class=\"col-md-6\" id=\"tempBucketId\" ng-repeat=\"test in relatedTests track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.addTestToTempBucket(test)\"> {{test.name}} <span ng-show=\"relatedTests.length == 0\"><label>No tests found!</label></span></div></div></div><div class=\"panel panel-default\" ng-show=\"tempBucket.length > 0\"><div class=\"panel-heading\"><a href=\"\"><span class=\"glyphicon glyphicon-question-sign pull-right\" title=\"Unckeck tests to remove\" data-toggle=\"tooltip\"></span></a><h1 class=\"panel-title\">Temporary bucket</h1></div><div class=\"row panel-body\" ng-show=\"tempBucket.length > 0\"><div class=\"col-md-6\" id=\"tempBucketId\" ng-repeat=\"test in tempBucket track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.removeFromBucket(test)\"> {{test.name}}</div></div><div class=\"panel-footer clearfix\"><button class=\"btn btn-primary btn pull-right\" ng-show=\"tempBucket.length > 0\" ng-click=\"medicalTestMethods.addTestToPermanentBucket($index)\">Create group</button></div></div><div class=\"panel panel-default\" ng-repeat=\"bucket in groups\" ng-show=\"bucket.length > 0\"><div class=\"panel-heading\"><button type=\"button\" class=\"close\" ng-click=\"medicalTestMethods.removeBucketFromGroup($index)\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button> <strong class=\"text-uppercase\">Bucket : {{$index}}</strong></div><div class=\"row panel-body\"><div class=\"col-md-12\" ng-repeat=\"test in bucket track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.removeFromGroups(test)\"> {{test.name}}</div><div class=\"row ddllocation\" ng-show=\"$index > 0\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-6\"><label for=\"\">Select a state</label><select name=\"newstateId\" ng-model=\"testData.testStateId\" class=\"form-control\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-6\"><label for=\"\">Select a city</label><select name=\"newcityId\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\" class=\"form-control\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-6\"><label for=\"\">Select a locality</label><select name=\"newlocalityId\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\" class=\"form-control\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div><div class=\"col-md-6\"><label for=\"\">Select sub locality</label><select name=\"newsublocalityId\" ng-model=\"testData.testSubLocalityId\" ng-change=\"loadLocationData(\'dc\',testData.testSubLocalityId)\" class=\"form-control\"><option value=\"\">Select sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div></div></div></div><div class=\"row ddllocation\" ng-show=\"$index > 0\"><div class=\"col-md-4\"><label for=\"\">Select a diagnostic centre</label><select id=\"dcid_{{$index}}\" name=\"pkgDCId\" class=\"form-control\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in allDCs\">{{dc.entityName}}</option></select></div><div class=\"col-md-4\"><label for=\"\">Preferred date & time</label> <input id=\"datetime_{{$index}}\" type=\"datetime-local\" class=\"form-control datetimepicker\"></div><div class=\"col-md-4\"><label for=\"\">Select a visit type</label><select id=\"visittype_{{$index}}\" name=\"visitType\" class=\"form-control\"><option value=\"\">Select a visit type</option><option value=\"22\">Appointment</option><option value=\"70\">Call</option><option value=\"71\">Home visit</option></select></div></div></div></div><div class=\"alert alert-danger\" role=\"alert\" id=\"emailErrorMsg\" ng-show=\"errorMsz.length>0\">{{errorMsz}}</div><div class=\"alert alert-success\" role=\"alert\" id=\"emailErrorMsg\" ng-show=\"successMsz.length>0\">{{successMsz}}</div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModal()\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"medicalTestMethods.splitRequests(groups)\" data-dismiss=\"modal\">Split</button></div></div>");
$templateCache.put("app/components/plusTestReport/plusTestReport.html","<style>\n    .large-Modal .modal-dialog {\n        width: 100%;\n        margin-top:0px;\n    }\n</style><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Reports</h4></div><div class=\"modal-body\"><div ng-repeat=\"tests in reportList.investigations\"><div ng-repeat=\"inv in tests.testDetails\"><div class=\"panel panel-default\" ng-repeat=\"param in inv.investigationParams\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-sm-5\"><span style=\"font-size:11px;\">{{tests.groupName}} | {{param.parameterName}}<span ng-show=\"param.units.length>0\">| Unit: {{param.units}}</span></span><br><b>{{inv.testName}}</b></div><div class=\"col-sm-3\" ng-show=\"!param.possibleValues.length>0\"><span style=\"font-size:11px;\">Enter value ({{param.minValue}} to {{param.maxValue}})</span><br><input type=\"number\" ng-model=\"param.testValue\" ng-disabled=\"reportList.isReportSubmitted || isInsurerRoles\" class=\"form-control\" placeholder=\"Enter value\"></div><div class=\"col-sm-3\" ng-show=\"param.possibleValues.length>0\"><span style=\"font-size:11px;\">Select value</span><br><select ng-model=\"param.testValue\" class=\"form-control\" ng-options=\"act.referenceNumber as act.value for act in param.possibleValues\" ng-disabled=\"reportList.isReportSubmitted\"><option value=\"\">Select group</option></select></div><div class=\"col-sm-4\"><span style=\"font-size:11px;\">Comment</span><br><textarea class=\"form-control ng-pristine ng-untouched ng-valid ng-valid-maxlength\" ng-model=\"param.impressions\" ng-disabled=\"reportList.isReportSubmitted || isInsurerRoles\" rows=\"2\" placeholder=\"Enter impressions(only 500 charecters)\" maxlength=\"500\"></textarea></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"closeModal()\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-model=\"btnSave\" ng-disabled=\"reportList.isReportSubmitted || isInsurerRoles\" ng-click=\"saveTestReport(reportList.investigations)\">Submit</button></div></div>");
$templateCache.put("app/components/qcDetails/details.html","<div ng-repeat=\"actions in apptDetails\" style=\"background-color: #e0dbdb;\"><div class=\"panel-heading\" style=\"margin-left: 162px; margin-top: 0px; font-size: large;\">{{actions.additionalInformation.productName}}</div><div class=\"panel-body\"><div class=\"form-inline\"><div class=\"form-group\" style=\"margin-left: 170px;\">{{actions.currentStatus}} | {{compareDate(actions.fulfillmentDate)}} | {{actions.additionalInformation.providerName}}</div><br><div class=\"form-group\" style=\"margin-left: 170px;\">{{actions.requestId}} | {{actions.additionalInformation.patientName}} | {{actions.additionalInformation.primaryEntityName}}</div><div class=\"form-group\" style=\"margin-left: 20px;\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a href=\"\" class=\"btn btn-primary btn-sm\" id=\"actions\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i> Action <span class=\"caret\"></span></a><ul style=\"background-color: #eeeeee;\" class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu=\"\" aria-labelledby=\"actions\"><li data-toggle=\"modal\" ng-repeat=\"action in actions.nextPossibleActions\" data-productid=\"res.additionalInformation.orderItemProductId\" data-target=\"#{{action.action}}Modal\" data-nextstatus=\"action.actionStatusId\" data-status=\"action.statusHistory[0].statusId\" data-request=\"resId\" data-date=\"action.additionalInformation.appointmentDate\" data-seconddate=\"action.additionalInformation.secondAppointmentDate\" ng-click=\"openActionModal(actions, action)\"><a><i class=\"glyphicon glyphicon-{{actionColors[action.action]}} {{statusTextColors[action.actionStatusId]}}\"></i> {{action.action}}</a></li></ul></span></div></div></div></div>");
$templateCache.put("app/components/tab/tab.html","<style>\n  .pagination-centered {\n    margin-left: 35%;\n  }\n\n  .popup-width {\n    width: 300px\n  }\n\n  .heighlightTable {\n    font-weight: bold;\n    color: black;\n  }\n\n  .font-bold {\n    color: #D05050;\n  }\n\n  .customeCss {\n    background-color: #ffb6b6;\n    padding-left: 10px;\n    border-radius: 3px;\n  }\n\n  .module {\n    width: 20px;\n    height: 20px;\n    background: #faeccd;\n    position: relative;\n    margin: 5px;\n    border: 1px solid black;\n  }\n\n  .customeCssForBar {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    display: block;\n    position: relative;\n    text-align: left;\n    width: 40%;\n    font-weight: normal;\n  }\n\n</style><div block-ui=\"calimDetailsUI\" ng-show=\"!tabtype\"><div ng-if=\"isSuccessFlag\"></div><script type=\"text/ng-template\" id=\"alert.html\"><div ng-transclude></div></script><div ng-if=\"isSuccessFlag\" uib-alert=\"\" template-url=\"alert.html\" style=\"background-color: #0eb10e; color: white; padding-top: 10px; padding-bottom: 10px; padding-left: 20px;\">Concurrence saved successfully.</div><div class=\"row\" ng-if=\"tabname ==\'Government Schemes\'\" style=\"margin-left: 2px;\"><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"status.isFirstOpen\"><uib-accordion-heading><a style=\"color: #168cc9;\">Government claim search <span style=\"color: green;\">&nbsp;(Select scheme* to get claims)</span></a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isFirstOpen, \'glyphicon-chevron-right\': !status.isFirstOpen}\"></i></uib-accordion-heading><ng-form name=\"govServerSearchForm\" class=\"form-horizontal\"><div class=\"form-group\"><div class=\"col-md-3 pull-left\"><input type=\"text\" placeholder=\"Enter claim id\" numbers-only=\"\" class=\"form-control\" ng-model=\"govServerSearch.claimId\"></div><div class=\"col-md-3 pull-left\"><input type=\"text\" placeholder=\"Enter patient name\" class=\"form-control\" ng-model=\"govServerSearch.patientName\"></div><div class=\"col-md-3 pull-left\"><input type=\"text\" placeholder=\"Enter urn number\" class=\"form-control\" ng-model=\"govServerSearch.urn\"></div><div class=\"col-md-3 pull-left\"><select ng-model=\"govServerSearch.status\" class=\"form-control\" ng-options=\"status for status in uniquePreauthStatus\"><option value=\"\">-- Select Status --</option></select></div></div><div class=\"form-group\"><div class=\"col-md-3 pull-left\" ng-if=\"getCmsUserCheck()\"><input type=\"text\" placeholder=\"Enter hospital name\" class=\"form-control\" ng-model=\"govServerSearch.hospitalName\"></div><div class=\"col-md-3 pull-left\" style=\"display: -webkit-inline-box;\"><select ng-model=\"govServerSearch.schemeName\" class=\"form-control\" ng-options=\"item for item in govtSchemeType\"><option value=\"\">-- Select scheme --</option></select><span class=\"text-danger\">*</span></div><div class=\"col-md-3 pull-left\"><button class=\"btn btn-primary\" ng-disabled=\"!govServerSearch.schemeName\" ng-click=\"getGovServerSearch(govServerSearch)\">Search</button> <button class=\"btn btn-default\" style=\"background-color: whitesmoke;\" ng-click=\"clearData();\">Clear</button></div></div></ng-form></div></uib-accordion></div><br><uib-tabset><uib-tab ng-click=\"activeClaim($index, tabname)\" ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"changeIndex($index, tabname)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"removeTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><div style=\"background-color: rgb(255, 159, 21);margin-left: 0px;margin-right: 0px;\" class=\"row\" ng-click=\"getNotificationList(\'IN_PROGRESS\')\" ng-show=\"tabname ===\'Active Claims\' && approvedNotificationCount > 0 && getCmsUserCheck() === false\"><div class=\"col-xs-6\" style=\"margin-top: 6px;\"><b style=\"color: #ffffff;margin-left: 10px;margin-right: 2px;\" ng-class=\"approvedNotificationCount > 0 ? \'badge bg-success pull-left\' : \'badge-zero bg-success pull-right\'\">{{approvedNotificationCount}}</b> <span style=\"margin-top: 5px;font-size: 15px;font-weight: bolder; margin-left: 10px;\">New Notification</span></div><div class=\"col-xs-6\"><button class=\"btn btn-primary btn-xs pull-right\" style=\"margin-top: 5px;margin-left: 5px;margin-right: 5px;margin-bottom: 5px;\"><i class=\"fa fa-refresh\"></i></button> <span class=\"pull-right\" style=\"margin-top: 5px; margin-top: 5px;font-size: 15px;font-weight: bolder;\">Reload View</span></div></div><div style=\"background-color: rgb(255, 159, 21);margin-left: 0px;margin-right: 0px;\" class=\"row\" ng-click=\"getNotificationList(\'INFO_REQUIRED\')\" ng-show=\"tabname ===\'Documents Pending\' && infoRequiredNotificationCount > 0 && getCmsUserCheck() === false\"><div class=\"col-xs-6\" style=\"margin-top: 6px;\"><b style=\"color: #ffffff;margin-left: 10px;margin-right: 2px;\" ng-class=\"infoRequiredNotificationCount > 0 ? \'badge bg-success pull-left\' : \'badge-zero bg-success pull-right\'\">{{infoRequiredNotificationCount}}</b> <span style=\"margin-top: 5px;font-size: 15px;font-weight: bolder; margin-left: 10px;\">New Notification</span></div><div class=\"col-xs-6\"><button class=\"btn btn-primary btn-xs pull-right\" style=\"margin-top: 5px;margin-left: 5px;margin-right: 5px;margin-bottom: 5px;\"><i class=\"fa fa-refresh\"></i></button> <span class=\"pull-right\" style=\"margin-top: 5px; margin-top: 5px;font-size: 15px;font-weight: bolder;\">Reload View</span></div></div><div style=\"background-color: rgb(255, 159, 21);margin-left: 0px;margin-right: 0px;\" class=\"row\" ng-click=\"getNotificationList(\'PAYMENT\')\" ng-show=\"tabname ===\'Settled Claims\' && paymentNotificationCount > 0 && getCmsUserCheck() === false\"><div class=\"col-xs-6\" style=\"margin-top: 6px;\"><b style=\"color: #ffffff;margin-left: 10px;margin-right: 2px;\" ng-class=\"paymentNotificationCount > 0 ? \'badge bg-success pull-left\' : \'badge-zero bg-success pull-right\'\">{{paymentNotificationCount}}</b> <span style=\"margin-top: 5px;font-size: 15px;font-weight: bolder; margin-left: 10px;\">New Notification</span></div><div class=\"col-xs-6\"><button class=\"btn btn-primary btn-xs pull-right\" style=\"margin-top: 5px;margin-left: 5px;margin-right: 5px;margin-bottom: 5px;\"><i class=\"fa fa-refresh\"></i></button> <span class=\"pull-right\" style=\"margin-top: 5px; margin-top: 5px;font-size: 15px;font-weight: bolder;\">Reload View</span></div></div><div style=\"background-color: rgb(255, 159, 21);margin-left: 0px;margin-right: 0px;\" class=\"row\" ng-click=\"getNotificationList(\'DENIED\')\" ng-show=\"tabname ===\'Denied Claims\' && deniedNotificationCount > 0 && getCmsUserCheck() === false\"><div class=\"col-xs-6\" style=\"margin-top: 6px;\"><b style=\"color: #ffffff;margin-left: 10px;margin-right: 2px;\" ng-class=\"deniedNotificationCount > 0 ? \'badge bg-success pull-left\' : \'badge-zero bg-success pull-right\'\">{{deniedNotificationCount}}</b> <span style=\"margin-top: 5px;font-size: 15px;font-weight: bolder; margin-left: 10px;\">New Notification</span></div><div class=\"col-xs-6\"><button class=\"btn btn-primary btn-xs pull-right\" style=\"margin-top: 5px;margin-left: 5px;margin-right: 5px;margin-bottom: 5px;\"><i class=\"fa fa-refresh\"></i></button> <span class=\"pull-right\" style=\"margin-top: 5px; margin-top: 5px;font-size: 15px;font-weight: bolder;\">Reload View</span></div></div><table class=\"table table-hover table-link\" ng-if=\"tabname != \'Planned Requests\'\"><thead><tr><th class=\"patientName\">Patient name</th><th class=\"claimId\">Claim id</th><th class=\"claimedAmount text-right\">Claimed amount</th><th ng-if=\"tabname !==\'Documents Pending\' && tabname !==\'Reimbursement Claims\' && tabname !== \'Documents Received\' && tabname!==\'Denied Claims\'\" class=\"approvedAmount text-right\"><span ng-if=\"tabname !==\'Settled Claims\' && tabname !== \'Documents Received\'&& tabname!==\'Denied Claims\'\">Approved amount</span> <span ng-if=\"tabname ===\'Settled Claims\'\">Settled amount</span></th><th class=\"status\" ng-if=\"tabname !==\'Documents Pending\' && tabname !==\'Denied Claims\'&& tabname !==\'Reimbursement Claims\' && tabname !==\'Settled Claims\'\">Status&nbsp;</th><th ng-if=\"tabname !==\'Settled Claims\'\" class=\"dateOfAdmission text-right\">Admission date</th><th ng-if=\"tabname !==\'Settled Claims\'\" class=\"dateOfDischarge text-right\">Discharge date</th><th ng-if=\"tabname ==\'Active Claims\'\" class=\"dateOfDischarge text-right\">Actions</th><th ng-if=\"tabname ===\'Documents Pending\'\" class=\"dateOfDischarge text-right\">Pendency TAT</th><th ng-if=\"tabname ===\'Settled Claims\'\" class=\"dateOfAdmission text-right\">Settled date</th><th ng-if=\"tabname ===\'Settled Claims\'\" class=\"dateOfDischarge text-right\">UTR number</th><th ng-if=\"(tabname ===\'Settled Claims\' || tabname ===\'Documents Pending\' ||tabname===\'Search Results\') && isCmsUser === false\" class=\"dateofdischarge text-right\">Action</th><th ng-if=\"isGov\" class=\"dateOfDischarge text-right\">Scheme</th><th ng-if=\"tabname ===\'Reimbursement Claims\'\" class=\"claimedAmount text-right\">Submit</th></tr></thead><tbody ng-if=\"tabname ===\'Other Claims\'\"><tr ng-repeat=\"item in preauthfilteredStatusFiltered1 | limitTo:itemsPerPage\" ng-class=\"item.isFlagRed ? \'font-bold alert-warning\' : \'\'\"><td class=\"name\">{{item.patientName}} <a style=\"font-size:15px\" class=\"pull-right\" ng-show=\"item.isAarogya\"><span class=\"glyphicon glyphicon-font\" style=\"color: #43E441;\"></span></a></td><td>{{item.claimId}}</td><td class=\"text-right\">{{formatCurrency(item.claimedAmount)}}</td><td ng-if=\"tabname !==\'Documents Pending\'&& tabname !== \'Documents Received\'&& tabname!==\'Denied Claims\'\" ng-show=\"item.paApprovedAmount!=0\" class=\"text-right\">{{formatCurrency(item.paApprovedAmount)}}</td><td ng-if=\"tabname !==\'Documents Pending\' && tabname!==\'Denied Claims\'\" ng-show=\"item.paApprovedAmount==0\" class=\"text-right\">{{formatCurrency(item.clmSettledAmount)}}</td><td ng-if=\"tabname ===\'Other Claims\'\"><span class=\"label label-success\" ng-show=\"item.status==\'Claim Approved\' || item.status==\'New Admission\'\">{{item.status}}</span> <span class=\"label label-info\" ng-show=\"item.status==\'Pre-Auth Approved\' || item.status==\'Cashless In Progress\' || item.status==\'Pre-Auth In Progress\'|| item.status==\'Claim In Progress\'\">{{item.status}}</span> <span class=\"label label-warning\" ng-show=\"item.status==\'Information Awaited\'\">{{item.status}}</span> <span class=\"label label-default\" ng-show=\"item.status == \'Pre Claim Info Required\'\">{{item.status}}</span> <span class=\"label label-danger\" ng-show=\"item.status==\'Cashless Denied\' || item.status==\'Enhancement Denied\'|| item.status==\'Claim Denied\'||item.status == \'Non Network\'\">{{item.status}}</span> <span class=\"label label-info\" ng-show=\"item.status!=\'Pre-Auth Approved\' && item.status!=\'Cashless In Progress\' && item.status!=\'Claim Approved\' && item.status!=\'New Admission\' && item.status!=\'Pre-Auth In Progress\' && item.status!=\'Information Awaited\' && item.status!=\'Enhancement Denied\' && item.status !== \'Pre Claim Info Required\' && item.status !== \'Non Network\' && item.status!==\'Claim Denied\' && item.status!==\'Claim In Progress\'\">{{item.status}}</span></td><td ng-if=\"tabname !==\'Settled Claims\'\" class=\"text-right\">{{item.dateOfAdmission}}</td><td ng-if=\"tabname !==\'Settled Claims\'\" class=\"text-right\">{{item.dateOfDischarge}}</td><td ng-if=\"tabname ===\'Settled Claims\'\" class=\"text-right\">{{item.settleDate}}</td><td ng-if=\"tabname ===\'Settled Claims\'\" class=\"text-right\">{{item.clmUTRNo}}</td><td ng-if=\"isGov\" class=\"text-right\">{{item.govScheme}}</td></tr></tbody><tbody ng-if=\"tabname !==\'Government Schemes\'\"><tr ng-repeat=\"item in preauthfilteredStatusFiltered | limitTo:itemsPerPage track by $index\" ng-class=\"item.isFlagRed ? \'font-bold alert-warning\' : item.isHighlighted ?\'heighlightTable\' : \'\'\"><td ng-click=\"addTab(item.claimId,item, item.patientName)\" class=\"name\">{{item.patientName}} <span class=\"smTxt\" ng-if=\"item.isOtherTpa\">{{item.tpaName}}</span> <a style=\"font-size:15px\" class=\"pull-right\" ng-show=\"item.isAarogya\"><span class=\"glyphicon glyphicon-font\" style=\"color: #43E441;\"></span></a></td><td ng-click=\"addTab(item.claimId,item, item.patientName)\">{{item.claimId}}</td><td ng-click=\"addTab(item.claimId,item, item.patientName)\" class=\"text-right\">{{formatCurrency(item.claimedAmount)}}</td><td ng-click=\"addTab(item.claimId,item, item.patientName)\" ng-if=\"tabname !==\'Documents Pending\'&& tabname !==\'Reimbursement Claims\' && tabname !== \'Documents Received\'&& tabname!==\'Denied Claims\'\" ng-show=\"item.paApprovedAmount!=0\" class=\"text-right\">{{formatCurrency(item.paApprovedAmount)}}</td><td ng-click=\"addTab(item.claimId,item, item.patientName)\" ng-if=\"tabname !==\'Documents Pending\' && tabname !==\'Reimbursement Claims\' && tabname!==\'Denied Claims\'\" ng-show=\"item.paApprovedAmount==0\" class=\"text-right\">{{formatCurrency(item.clmSettledAmount)}}</td><td ng-click=\"addTab(item.claimId,item, item.patientName)\" ng-if=\"tabname !==\'Documents Pending\'&& tabname !==\'Reimbursement Claims\' && tabname !==\'Denied Claims\' && tabname !==\'Settled Claims\'\"><span class=\"label label-success\" ng-show=\"item.status==\'Claim Approved\' || item.status==\'New Admission\'\">{{item.status}}</span> <span class=\"label label-info\" ng-show=\"item.status==\'Pre-Auth Approved\' || item.status==\'Cashless In Progress\' || item.status==\'Pre-Auth In Progress\'|| item.status==\'Claim In Progress\'\">{{item.status}}</span> <span class=\"label label-warning\" ng-show=\"item.status==\'Information Awaited\'\">{{item.status}}</span> <span class=\"label label-default\" ng-show=\"item.status == \'Pre Claim Info Required\'\">{{item.status}}</span> <span class=\"label label-danger\" ng-show=\"item.status==\'Cashless Denied\' || item.status==\'Enhancement Denied\'|| item.status==\'Claim Denied\'||item.status == \'Non Network\'\">{{item.status}}</span> <span class=\"label label-info\" ng-show=\"item.status!=\'Pre-Auth Approved\' && item.status!=\'Cashless In Progress\' && item.status!=\'Claim Approved\' && item.status!=\'New Admission\' && item.status!=\'Pre-Auth In Progress\' && item.status!=\'Information Awaited\' && item.status!=\'Enhancement Denied\' && item.status !== \'Pre Claim Info Required\' && item.status !== \'Non Network\' && item.status!==\'Claim Denied\' && item.status!==\'Claim In Progress\'\">{{item.status}}</span></td><td ng-click=\"addTab(item.claimId,item, item.patientName)\" ng-if=\"tabname !==\'Settled Claims\'\" class=\"text-right\">{{item.dateOfAdmission}}</td><td ng-click=\"addTab(item.claimId,item, item.patientName)\" ng-if=\"tabname !==\'Settled Claims\'\" class=\"text-right\">{{item.dateOfDischarge}}</td><td ng-if=\"tabname ==\'Active Claims\'\" class=\"text-right\"><button class=\"btn btn-xs btn-success\" ng-click=\"dischargeAction(item)\" ng-if=\"item.dateOfDischarge == \'Today\' && item.status==\'Pre-Auth Processed\'\" data-toggle=\"modal\" data-target=\"#dischargeData\">Quick discharge</button></td><td ng-if=\"tabname===\'Active Claims\' && item.isOtherTpa\"><button class=\"btn btn-primary btn-xs\" ng-click=\"updateOtherTpaClaimInfo(item);\"><i class=\"fa fa-edit\"></i></button></td><td ng-if=\"tabname ===\'Documents Pending\'\" class=\"text-right\">{{item.TATinClaim}} <span ng-if=\"item.TATinClaim ===1\">Day</span> <span ng-if=\"item.TATinClaim >1\">Days</span></td><td ng-click=\"addTab(item.claimId,item, item.patientName)\" ng-if=\"tabname ===\'Settled Claims\'\" class=\"text-right\">{{item.settleDate}}</td><td ng-click=\"addTab(item.claimId,item, item.patientName)\" ng-if=\"tabname ===\'Settled Claims\'\" class=\"text-right\">{{item.clmUTRNo}}</td><td ng-if=\"(tabname ===\'Settled Claims\' || tabname ===\'Documents Pending\' ||tabname===\'Search Results\') && isCmsUser ===false\" class=\"text-right\"><div ng-if=\"tabname ===\'Settled Claims\' && item.isHospIssueConcurrencePresent === true\"><button style=\"background-color:blue\" type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"getStatus(item, \'Report an issue\')\" data-toggle=\"modal\" data-target=\"#reportAnIssue\">Pending</button></div><div ng-if=\"tabname ===\'Search Results\' && item.status ===\'Claim Settled\' && item.isHospIssueConcurrencePresent === true\"><button style=\"background-color:blue\" type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"getStatus(item, \'Report an issue\')\" data-toggle=\"modal\" data-target=\"#reportAnIssue\">Pending</button></div><div ng-if=\"tabname ===\'Settled Claims\' && item.isHospIssueConcurrencePresent === false\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"getStatus(item, \'Report an issue\')\" data-toggle=\"modal\" data-target=\"#reportAnIssue\">Report</button></div><div ng-if=\"tabname ===\'Search Results\' && item.isSettledClaim ===true && item.isHospIssueConcurrencePresent === false\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"getStatus(item, \'Report an issue\')\" data-toggle=\"modal\" data-target=\"#reportAnIssue\">Report</button></div><div ng-if=\"tabname ===\'Documents Pending\' && item.isHospPendingDocConcurrencePresent ===true\"><button style=\"background-color:green\" type=\"button\" ng-click=\"getStatus(item,\'Add courier details\')\" class=\"btn btn-primary btn-xs\" data-toggle=\"modal\" data-target=\"#AddCourierDetails\">Updated</button></div><div ng-if=\"tabname ===\'Search Results\' && item.isInfoAwaitedClaim === true && item.isHospPendingDocConcurrencePresent ===true\"><button style=\"background-color:green\" type=\"button\" ng-click=\"getStatus(item,\'Add courier details\')\" class=\"btn btn-primary btn-xs\" data-toggle=\"modal\" data-target=\"#AddCourierDetails\">Updated</button></div><div ng-if=\"tabname ===\'Search Results\' && item.isInfoAwaitedClaim === true && item.isHospPendingDocConcurrencePresent ===false\"><button ng-class=\"item.isHospPendingDocConcurrencePresent\" type=\"button\" ng-click=\"getStatus(item,\'Add courier details\')\" class=\"btn btn-primary btn-xs\" data-toggle=\"modal\" data-target=\"#AddCourierDetails\">Action</button></div><div ng-if=\"tabname ===\'Documents Pending\' && item.isHospPendingDocConcurrencePresent ===false\"><button ng-class=\"item.isHospPendingDocConcurrencePresent\" type=\"button\" ng-click=\"getStatus(item,\'Add courier details\')\" class=\"btn btn-primary btn-xs\" data-toggle=\"modal\" data-target=\"#AddCourierDetails\">Action</button></div></td><td ng-click=\"addTab(item.claimId,item, item.patientName)\" ng-if=\"isGov\" class=\"text-right\">{{item.govScheme}}</td><td ng-if=\"!item.isAnswerSubmitted && tabname === \'Reimbursement Claims\'\" class=\"text-right\"><button ng-click=\"getQuestionData(item)\" class=\"btn btn-primary btn-xs\">Action</button></td><td ng-if=\"item.isAnswerSubmitted && tabname === \'Reimbursement Claims\'\" class=\"text-right\"><button ng-click=\"getUpdatedQuestionData(item)\" class=\"btn btn-success btn-xs\">Update</button></td></tr></tbody><tbody ng-if=\"tabname ==\'Government Schemes\'\"><tr tooltip-placement=\"top\" uib-tooltip=\"{{item.tooltipDisplay}}\" ng-repeat=\"item in preauthfilteredStatusFiltered | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\" ng-click=\"addTab(item.claimId,item, item.patientName)\" ng-class=\"item.isFlagRed ? \'font-bold alert-warning\' : \'\'\"><td class=\"name\">{{item.patientName}} <a style=\"font-size:15px\" class=\"pull-right\" ng-show=\"item.isAarogya\"><span class=\"glyphicon glyphicon-font\" style=\"color: #43E441;\"></span></a></td><td>{{item.claimId}}</td><td class=\"text-right\">{{formatCurrency(item.claimedAmount)}}</td><td ng-if=\"tabname !==\'Documents Pending\'\" ng-show=\"item.paApprovedAmount!=0\" class=\"text-right\">{{formatCurrency(item.paApprovedAmount)}}</td><td ng-if=\"tabname !==\'Documents Pending\'\" ng-show=\"item.paApprovedAmount==0\" class=\"text-right\">--</td><td ng-if=\"tabname !==\'Documents Pending\' && tabname !==\'Denied Claims\' && tabname !==\'Settled Claims\'\"><span class=\"label label-success\" ng-show=\"item.status==\'Claim Approved\' || item.status==\'New Admission\'\">{{item.status}}</span> <span class=\"label label-info\" ng-show=\"item.status==\'Pre-Auth Approved\' || item.status==\'Cashless In Progress\' || item.status==\'Pre-Auth In Progress\'|| item.status==\'Claim In Progress\'\">{{item.status}}</span> <span class=\"label label-warning\" ng-show=\"item.status==\'Information Awaited\'\">{{item.status}}</span> <span class=\"label label-default\" ng-show=\"item.status == \'Pre Claim Info Required\'\">{{item.status}}</span> <span class=\"label label-danger\" ng-show=\"item.status==\'Cashless Denied\' || item.status==\'Enhancement Denied\'|| item.status==\'Claim Denied\'||item.status == \'Non Network\'\">{{item.status}}</span> <span class=\"label label-info\" ng-show=\"item.status!=\'Pre-Auth Approved\' && item.status!=\'Cashless In Progress\' && item.status!=\'Claim Approved\' && item.status!=\'New Admission\' && item.status!=\'Pre-Auth In Progress\' && item.status!=\'Information Awaited\' && item.status!=\'Enhancement Denied\' && item.status !== \'Pre Claim Info Required\' && item.status !== \'Non Network\' && item.status!==\'Claim Denied\' && item.status!==\'Claim In Progress\'\">{{item.status}}</span></td><td class=\"text-right\">{{item.dateOfAdmission}}</td><td class=\"text-right\">{{item.dateOfDischarge}}</td><td ng-if=\"isGov\" class=\"text-right\">{{item.govScheme}}</td></tr></tbody></table><table class=\"table table-hover table-link\" ng-if=\"tabname == \'Planned Requests\'\"><thead><tr><th class=\"patientName\">Patient name</th><th class=\"claimId text-center\">MAID</th><th class=\"claimedAmount text-center\">Corporate name</th><th class=\"approvedAmount text-center\">Employee id</th><th class=\"claimId text-center\">Mobile number</th><th class=\"dateOfAdmission text-center\">Admission date</th><th class=\"dateOfDischarge text-center\">Tentative discharge date</th><th class=\"dateOfDischarge text-center\">Action</th></tr></thead><tbody><tr ng-repeat=\"item in preauthfiltered | startFrom:(currentPage-1)*entryLimit | limitTo:entryLimit\"><td class=\"text-left\">{{item.patientName}}</td><td class=\"text-center\">{{item.id}}</td><td class=\"text-center\">{{item.corporateName}}</td><td class=\"text-center\">{{item.employeeId}}</td><td class=\"text-center\">{{item.mobileNumber}}</td><td class=\"text-center\">{{getDDMMYYYY(item.dateOfAdmission)}}</td><td class=\"text-center\">{{getDDMMYYYY(item.dateOfDischarge)}}</td><td><button type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"addTab(item)\">Confirm</button></td></tr></tbody></table><div ng-if=\"tabname ==\'Government Schemes\'\"><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" ng-change=\"pageChanged(currentPage, true)\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div><div ng-if=\"tabname !==\'Government Schemes\'\"><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" ng-change=\"pageChanged(currentPage, true)\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></div><div ng-show=\"!tab1show\"><div id=\"{{key.claimId}}\"><div class=\"claimBox\" ng-if=\"!tabPlanned && !preClaim\"><input type=\"button\" class=\"btn btn-primary btn-xs pull-right\" value=\"DownloadSettled Report\" ng-if=\"tabname == \'Settled Claims\' ||claimSearhByClaimIdResults.claimDetails.claimStatus== \'Claim Settled\'\" ng-click=\"downloadSettledReport()\"> <input type=\"button\" class=\"btn btn-primary btn-xs pull-right\" value=\"Download Preauth Form\" ng-if=\"claimSearhByClaimIdResults.claimIntimationDetails\" ng-click=\"downloadMethods.downloadPrefilledPreauthForm(claimSearhByClaimIdResults)\"><div id=\"toprow\" class=\"downloadPart\" ng-if=\"tabname !==\'Government Schemes\' && tabname !==\'Settled Claims\' && tabname !==\'Denied Claims\' && claimSearhByClaimIdResults.claimDetails.claimStatus !== \'Claim Settled\'\"><table class=\"table table-striped\" style=\"margin-top:20px; background:#fff;\"><tbody><tr><td>Customer</td><td>Claim no.</td><td>Age</td><td>Contact no.</td><td>DOA</td><td>DOD</td><td ng-if=\"tabname ==\'Active Claims\' || tabname==\'Documents Pending\' || tabname == \'Search Results\'\">Update Date</td></tr><tr><td ng-if=\"!isOtherTpaClaimSearch\"><strong>{{claimSearhByClaimIdResults.patientDetails.patientName }}</strong></td><td ng-if=\"isOtherTpaClaimSearch\"><strong>{{claimSearhByClaimIdResults.patientName}}</strong></td><td ng-if=\"!isOtherTpaClaimSearch\"><strong>{{claimSearhByClaimIdResults.claimId }}</strong></td><td ng-if=\"isOtherTpaClaimSearch\"><strong>{{claimSearhByClaimIdResults.claimId }}</strong></td><td ng-if=\"!isOtherTpaClaimSearch\"><strong>{{claimSearhByClaimIdResults.patientDetails.patientAge}}</strong></td><td ng-if=\"isOtherTpaClaimSearch\"><strong>{{claimSearhByClaimIdResults.patientAge}}</strong></td><td ng-if=\"!isOtherTpaClaimSearch\"><strong>{{claimSearhByClaimIdResults.patientDetails.patientContactNumber}}</strong></td><td ng-if=\"isOtherTpaClaimSearch\"><strong>{{claimSearhByClaimIdResults.patientContactNo}}</strong></td><td ng-if=\"edit && !isOtherTpaClaimSearch\"><strong><input style=\"width: 110px;\" id=\"datetimeEnd\" readonly=\"\" placeholder=\"Select date to\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"newDatObj.clmDOA\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\" style=\"left: 109px; top: -34px;\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></strong></td><td ng-show=\"edit && !isOtherTpaClaimSearch\"><strong><input style=\"width: 110px;\" id=\"datetimeFirst\" placeholder=\"Select date from\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"newDatObj.clmDOD\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\" style=\"left: 109px; top: -34px;\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></strong></td><td ng-show=\"!edit && !isOtherTpaClaimSearch\">{{getDDMMYYYY(claimSearhByClaimIdResults.claimDetails.clmDOA)}}</td><td ng-show=\"!edit && !isOtherTpaClaimSearch\">{{getDDMMYYYY(claimSearhByClaimIdResults.claimDetails.clmDOD)}}</td><td ng-show=\"isOtherTpaClaimSearch\">{{claimSearhByClaimIdResults.dateOfAdmission}}</td><td ng-show=\"isOtherTpaClaimSearch\">{{claimSearhByClaimIdResults.dateOfDischarge}}</td><td ng-show=\"!edit &&(tabname ==\'Active Claims\' || tabname==\'Documents Pending\' || tabname == \'Search Results\')\" ng-click=\"editClaim(claimSearhByClaimIdResults.claimDetails)\"><button uib-tooltip=\"Edit\" class=\"btn\"><i class=\"fa fa-edit\"></i></button></td><td ng-show=\"edit\"><div class=\"btn-group\"><button uib-tooltip=\"save\" class=\"btn btn-primary\" ng-click=\"edit= !edit;UpdateDateRelatedMethods.openUpdateModal(newDatObj)\"><i class=\"fa fa-save\"></i></button> <button uib-tooltip=\"close\" class=\"btn\" ng-click=\"edit = !edit\"><i class=\"fa fa-close\"></i></button></div></td></tr></tbody></table></div><div id=\"auditDetails\" ng-if=\"tabname ===\'Documents Pending\' && claimDetailsValueData.isHospPendingDocConcurrencePresent ===true\"><div><div class=\"chatBox user\"><div class=\"chatContent\"><h5 class=\"chatStatus\">Hospital updated status of a claim</h5><p class=\"chat-content\" ng-if=\"claimDetailsValueData.hosp_PendingDocIssue\">Status: {{getTextData(claimDetailsValueData.hosp_PendingDocIssue)}}</p><p class=\"chat-content\" ng-if=\"claimDetailsValueData.hosp_TrackingNumber\">Tracking number: {{claimDetailsValueData.hosp_TrackingNumber}}</p><p class=\"chat-content\" ng-if=\"claimDetailsValueData.hosp_DocSubmissiondate\">Submitted date: {{getDateObj(claimDetailsValueData.hosp_DocSubmissiondate) | date:\"yyyy-MM-dd\"}}</p><p class=\"chat-content\" ng-if=\"claimDetailsValueData.hosp_PendingDocIssueRemarks\">Remarks: {{claimDetailsValueData.hosp_PendingDocIssueRemarks}}</p><p class=\"chat-content\" ng-if=\"claimDetailsValueData.claimedApprovedAmt\">Acknowledgement number: {{claimDetailsValueData.claimedApprovedAmt}}</p></div></div></div></div><div id=\"auditDetails\" ng-if=\"tabname ===\'Settled Claims\' && claimDetailsValueData.isHospIssueConcurrencePresent ===true\"><div><div class=\"chatBox user\"><div class=\"chatContent\"><h5 class=\"chatStatus\">Hospital reported issue on settlement</h5><p class=\"chat-content\" ng-if=\"claimDetailsValueData.hosp_IssueResponse\">Issue Type: {{getTextData(claimDetailsValueData.hosp_IssueResponse)}}</p><p class=\"chat-content\" ng-if=\"claimDetailsValueData.hospIssueRemarks\">Remarks: {{claimDetailsValueData.hospIssueRemarks}}</p></div></div></div></div><div id=\"govtScheme\" class=\"downloadPart\" ng-if=\"tabname ==\'Government Schemes\'\"><table class=\"table table-striped\" style=\"margin-top:20px; background:#fff;\"><tbody><tr><td><strong>Customer name</strong></td><td>{{claimSearhByClaimIdResults.patientName}}</td><td><strong>Claim no.</strong></td><td>{{claimSearhByClaimIdResults.claimId}}</td></tr><tr><td><strong>Member id</strong></td><td>{{claimSearhByClaimIdResults.memberId}}</td><td><strong>URN number</strong></td><td>{{claimSearhByClaimIdResults.urnNumber}}</td></tr><tr><td><strong>Packages applied</strong></td><td><span ng-repeat=\"item in claimSearhByClaimIdResults.packages\">{{item}},</span></td><td><strong>Online Reason</strong></td><td ng-show=\"claimSearhByClaimIdResults.reasonForChoosing !== \'String\'\">{{claimSearhByClaimIdResults.reasonForChoosing}}</td><td ng-show=\"claimSearhByClaimIdResults.reasonForChoosing === \'String\'\"></td></tr><tr><td><strong>Date of admission</strong></td><td>{{compareDate(claimSearhByClaimIdResults.doa)}}</td><td><strong>Tentative date of discharge</strong></td><td>{{compareDate(claimSearhByClaimIdResults.tentativeDOD)}}</td></tr><tr><td><strong>Claimed amount</strong></td><td>{{claimSearhByClaimIdResults.claimedAmnt}}</td><td><strong>Approved amount</strong></td><td>{{claimSearhByClaimIdResults.approvedAmnt}}</td></tr><tr><td><strong>Contact number</strong></td><td>{{claimSearhByClaimIdResults.contactNum}}</td><td><strong>Customer Age</strong></td><td>{{claimSearhByClaimIdResults.age}}</td></tr><tr><td><strong>Remarks</strong></td><td width=\"300px\">{{claimSearhByClaimIdResults.remarks}}</td><td><strong>BCP Code</strong></td><td width=\"300px\">{{claimSearhByClaimIdResults.gC_BCP_FP_Code}}</td></tr><tr><td><strong>RegNo</strong></td><td width=\"300px\">{{claimSearhByClaimIdResults.ipRegNo}}</td><td><strong>Aadhaar Number</strong></td><td width=\"300px\">{{claimSearhByClaimIdResults.gC_Aadhaar_Number}}</td></tr><tr><td><strong>Payment No</strong></td><td width=\"300px\">{{claimSearhByClaimIdResults.payment_No}}</td><td><strong>Payment Date</strong></td><td width=\"300px\">{{claimSearhByClaimIdResults.payment_Date}}</td></tr></tbody></table></div><div id=\"auditDetails\" ng-if=\"tabname ==\'Government Schemes\'\"><div ng-repeat=\"item in claimSearhByClaimIdResults.govClmAudit\" ng-switch=\"item.isFromHospital\"><div class=\"chatBox\" ng-switch-when=\"false\"><div class=\"author\"><p class=\"dateTime\">{{compareDate(item.auditdate)}}<br><span>{{formatTime(item.auditdate)}}</span></p><h2>Medi Assist</h2></div><div class=\"chatContent\"><h5 class=\"chatStatus\">{{item.auditStatus }}</h5><p class=\"chat-content\">Claimed amount :{{item.claimedAmt}}</p><p class=\"chat-content\" ng-show=\"item.claimedApprovedAmt>0\">Approved amount :{{item.claimedApprovedAmt}}</p><p class=\"chat-content\" ng-show=\"item.auditRemarks\">{{item.auditRemarks}}</p><div ng-switch=\"claimSearhByClaimIdResults.claimIntimationDetails != null && claimSearhByClaimIdResults.claimIntimationDetails.isOTPVerified == false && item.letterDownloadLink && item.letterDownloadLink !==\'\'\"><div ng-switch-when=\"false\"><a id=\"downloadLetter\" ng-show=\"item.letterDownloadLink && item.letterDownloadLink !==\'\'\" class=\"btn chat-content btn-primary btn-sm download\" data-letterdownloadlink=\"{{item.letterDownloadLink}}\" ng-click=\"downloadMethods.downloadLetter(item.letterDownloadLink)\">Click here to download {{item.auditStatus}} letter</a></div><div ng-switch-when=\"true\"><button class=\"btn btn-primary\" ng-click=\"downloadMethods.getOtpModal(item.letterDownloadLink,claimSearhByClaimIdResults.claimId)\">{{item.auditStatus}} letter</button></div></div><div class=\"form-group\" ng-show=\"item.auditStatus ===\'Information Awaited\' && claimSearhByClaimIdResults.claimDetails.missingDocuments.length > 0\" style=\"margin-top:2%\"><label class=\"bg-danger\"><em>Missing documents</em></label><ol><li ng-repeat=\"doc in claimSearhByClaimIdResults.claimDetails.missingDocuments\"><td>{{doc}}</td></li></ol></div></div></div><div class=\"chatBox user\" ng-switch-when=\"true\"><div class=\"author\"><p class=\"dateTime\">{{compareDate(item.auditdate)}}<br><span>{{formatTime(item.auditdate)}}</span></p><h2>Hospital</h2></div><div class=\"chatContent\"><h5 class=\"chatStatus\">{{item.auditStatus }}</h5><p class=\"chat-content\">Claimed amount :{{item.claimedAmt}}</p><p class=\"chat-content\" ng-show=\"item.claimedApprovedAmt>0\">Approved Amount :{{item.claimedApprovedAmt}}</p><a id=\"downloadLetter\" ng-show=\"item.letterDownloadLink && item.letterDownloadLink !==\'\'\" class=\"btn chat-content btn-primary btn-sm download\" data-letterdownloadlink=\"{{item.letterDownloadLink}}\" ng-click=\"downloadMethods.downloadLetter(item.letterDownloadLink)\">Click here to download Pre-Auth Approved letter</a></div></div></div></div><div id=\"settledData\" class=\"downloadPart\" ng-if=\"tabname ==\'Settled Claims\' || claimSearhByClaimIdResults.claimDetails.claimStatus== \'Claim Settled\'\"><table class=\"table table-striped\" style=\"margin-top:20px; background:#fff;\"><tbody><tr><td><strong>Customer name</strong></td><td>{{claimSearhByClaimIdResults.patientDetails.patientName}}</td><td><strong>Claim No.</strong></td><td>{{claimSearhByClaimIdResults.claimId}}</td></tr><tr><td><strong>Contact number</strong></td><td>{{claimSearhByClaimIdResults.patientDetails.patientContactNumber}}</td><td><strong>Customer Age</strong></td><td>{{claimSearhByClaimIdResults.patientDetails.patientAge}}</td></tr><tr><td><strong>Cheque/UTR number</strong></td><td>{{claimSearhByClaimIdResults.settlementDetails.clmChequeNumber}}</td><td><strong>settlement date</strong></td><td>{{compareDate(claimSearhByClaimIdResults.settlementDetails.settlementDate)}}</td></tr><tr><td><strong>Net pay amount</strong></td><td>{{claimSearhByClaimIdResults.settlementDetails.clmNetPayAmount}}</td><td><strong>Tax amount</strong></td><td>{{claimSearhByClaimIdResults.settlementDetails.clmTaxAmount}}</td></tr><tr><td><strong>Cheque amount:</strong></td><td>{{claimSearhByClaimIdResults.settlementDetails.clmChequeAmount}}</td><td><strong>Service tax amt.</strong></td><td>{{claimSearhByClaimIdResults.settlementDetails.clmServiceTaxAmt}}</td></tr><tr><td><strong>Admissible amt:</strong></td><td>{{claimSearhByClaimIdResults.settlementDetails.clmAdmissibleAmt}}</td></tr></tbody></table></div><div id=\"denialData\" class=\"downloadPart\" ng-if=\"tabname ==\'Denied Claims\'\"><table class=\"table table-striped\" style=\"margin-top:20px; background:#fff;\"><tbody><tr><td><strong>Customer name</strong></td><td>{{claimSearhByClaimIdResults.patientDetails.patientName}}</td><td><strong>Claim no.</strong></td><td>{{claimSearhByClaimIdResults.claimId}}</td></tr><tr><td><strong>Contact number</strong></td><td>{{claimSearhByClaimIdResults.patientDetails.patientContactNumber}}</td><td><strong>Customer Age</strong></td><td>{{claimSearhByClaimIdResults.patientDetails.patientAge}}</td></tr><tr><td><strong>Denial reason</strong></td><td>{{claimSearhByClaimIdResults.claimDetails.denialReasons}}</td></tr></tbody></table></div><div id=\"govt-ir\" ng-if=\"tabname ==\'Government Schemes\' && claimSearhByClaimIdResults.missingDocs && claimSearhByClaimIdResults.missingDocs.split(\',\').length>0\"><div><div class=\"chatBox noUser\"><div class=\"chatContent\"><h5 class=\"chatStatus\">Information awaited</h5><table class=\"table table-striped\"><thead><tr><td><strong>Missing documents list</strong></td></tr></thead><tbody><tr ng-repeat=\"item in claimSearhByClaimIdResults.missingDocs.split(\',\')\"><td>{{item}}</td></tr></tbody></table><p><strong>Remarks:</strong>{{claimSearhByClaimIdResults.remarks}}</p></div></div></div></div><div id=\"auditDetails\" ng-if=\"!isOtherTpaClaimSearch && tabname !==\'Settled Claims\'\"><div ng-repeat=\"item in claimSearhByClaimIdResults.claimAuditDetails\" ng-switch=\"item.isFromHospital\"><div class=\"chatBox\" ng-switch-when=\"false\"><div class=\"author\"><p class=\"dateTime\">{{compareDate(item.auditDate)}}<br><span>{{formatTime(item.auditDate)}}</span></p><h2>Medi Assist</h2></div><div class=\"chatContent\"><h5 class=\"chatStatus\">{{item.auditStatus }}</h5><p class=\"chat-content\">Claimed amount :{{item.claimedAmt}}</p><p class=\"chat-content\" ng-show=\"item.claimedApprovedAmt>0\">Approved amount :{{item.claimedApprovedAmt}}</p><div ng-switch=\"claimSearhByClaimIdResults.claimIntimationDetails != null && claimSearhByClaimIdResults.claimIntimationDetails.isOTPVerified == false && item.letterDownloadLink && item.letterDownloadLink !==\'\'\"><div ng-switch-when=\"false\"><a id=\"downloadLetter\" ng-show=\"item.letterDownloadLink && item.letterDownloadLink !==\'\'\" class=\"btn chat-content btn-primary btn-sm download\" data-letterdownloadlink=\"{{item.letterDownloadLink}}\" ng-click=\"downloadMethods.downloadLetter(item.letterDownloadLink)\">Click here to download {{item.auditStatus}} letter</a></div><div ng-switch-when=\"true\"><button class=\"btn btn-primary\" ng-click=\"downloadMethods.getOtpModal(item.letterDownloadLink,claimSearhByClaimIdResults.claimId)\">{{item.auditStatus}} letter</button></div></div><div class=\"form-group\" ng-show=\"item.auditStatus ===\'Information Awaited\' && claimSearhByClaimIdResults.claimDetails.missingDocuments.length > 0\" style=\"margin-top:2%\"><label class=\"bg-danger\"><em>Missing documents</em></label><ol><li ng-repeat=\"doc in claimSearhByClaimIdResults.claimDetails.missingDocuments\"><td>{{doc}}</td></li></ol></div></div></div><div class=\"chatBox user\" ng-switch-when=\"true\"><div class=\"author\"><p class=\"dateTime\">{{compareDate(item.auditDate)}}<br><span>{{formatTime(item.auditDate)}}</span></p><h2>Hospital</h2></div><div class=\"chatContent\"><h5 class=\"chatStatus\">{{item.auditStatus }}</h5><p class=\"chat-content\">Claimed amount :{{item.claimedAmt}}</p><p class=\"chat-content\" ng-show=\"item.claimedApprovedAmt>0\">Approved amount :{{item.claimedApprovedAmt}}</p><a id=\"downloadLetter\" ng-show=\"item.letterDownloadLink && item.letterDownloadLink !==\'\'\" class=\"btn chat-content btn-primary btn-sm download\" data-letterdownloadlink=\"{{item.letterDownloadLink}}\" ng-click=\"downloadMethods.downloadLetter(item.letterDownloadLink)\">Click here to download Pre-Auth Approved letter</a></div></div></div></div><div id=\"auditDetails\" ng-if=\"isOtherTpaClaimSearch && tabname !==\'Settled Claims\'\"><div ng-repeat=\"item in claimSearhByClaimIdResults.claimAuditDetails\" ng-switch=\"item.submittedBy==\'Hospital\'\"><div class=\"chatBox\" ng-switch-when=\"false\"><div class=\"author\"><p class=\"dateTime\">{{compareDate(item.createdDate)}}<br><span>{{formatTime(item.createdDate)}}</span></p><h6 style=\"color: #14bcc8;\">{{claimSearhByClaimIdResults.tpaName}}</h6></div><div class=\"chatContent\"><h5 class=\"chatStatus\">{{item.status }}</h5><p class=\"chat-content\">Claimed amount :{{item.claimedAmount}}</p><p class=\"chat-content\" ng-show=\"item.approvedAmount>0\">Approved amount :{{item.approvedAmount}}</p><p class=\"chat-content\"><span ng-repeat=\"document in item.letterDocuments\"><a ng-href=\"{{document.docPath}}\">{{document.fileName}}</a></span></p><div ng-switch=\"claimSearhByClaimIdResults.claimIntimationDetails != null && claimSearhByClaimIdResults.claimIntimationDetails.isOTPVerified == false && item.letterDownloadLink && item.letterDownloadLink !==\'\'\"><div ng-switch-when=\"false\"><a id=\"downloadLetter\" ng-show=\"item.letterDownloadLink && item.letterDownloadLink !==\'\'\" class=\"btn chat-content btn-primary btn-sm download\" data-letterdownloadlink=\"{{item.letterDownloadLink}}\" ng-click=\"downloadMethods.downloadLetter(item.letterDownloadLink)\">Click here to download {{item.status}} letter</a></div><div ng-switch-when=\"true\"><button class=\"btn btn-primary\" ng-click=\"downloadMethods.getOtpModal(item.letterDownloadLink,claimSearhByClaimIdResults.claimId)\">{{item.status}} letter</button></div></div><div class=\"form-group\" ng-show=\"item.auditStatus ===\'Information Awaited\' && claimSearhByClaimIdResults.claimDetails.missingDocuments.length > 0\" style=\"margin-top:2%\"><label class=\"bg-danger\"><em>Missing documents</em></label><ol><li ng-repeat=\"doc in claimSearhByClaimIdResults.claimDetails.missingDocuments\"><td>{{doc}}</td></li></ol></div></div></div><div class=\"chatBox user\" ng-switch-when=\"true\"><div class=\"author\"><p class=\"dateTime\">{{compareDate(item.createdDate)}}<br><span>{{formatTime(item.createdDate)}}</span></p><h6 style=\"color: #940b23\">Hospital</h6></div><div class=\"chatContent\"><h5 class=\"chatStatus\">{{item.status }}</h5><p class=\"chat-content\">Claimed amount :{{item.claimedAmount}}</p><p class=\"chat-content\" ng-show=\"item.approvedAmount>0\">Approved amount :{{item.approvedAmount}}</p><div class=\"chat-content\"><span ng-repeat=\"document in item.documents\"><a ng-href=\"{{document.docPath}}\">{{document.fileName}}</a><br></span></div><a id=\"downloadLetter\" ng-show=\"item.letterDownloadLink && item.letterDownloadLink !==\'\'\" class=\"btn chat-content btn-primary btn-sm download\" data-letterdownloadlink=\"{{item.letterDownloadLink}}\" ng-click=\"downloadMethods.downloadLetter(item.letterDownloadLink)\">Click here to download Pre-Auth Approved letter</a></div></div></div></div><div class=\"downloadPart\"><div ng-show=\"claimSearhByClaimIdResults.nmeDetails.length>0\"><div class=\"chatBox noUser\"><div class=\"chatContent\"><h5 class=\"chatStatus\">Non payable amount</h5><table class=\"table table-striped\"><thead><tr><td><strong>Non payable amount</strong></td><td><strong>Non payable reason</strong></td></tr></thead><tbody><tr ng-repeat=\"item in claimSearhByClaimIdResults.nmeDetails\"><td>{{item.nonPayableAmt}}</td><td>{{item.nonPayableReason}}</td></tr></tbody></table></div></div></div></div><div class=\"downloadPart\"><div ng-show=\"claimSearhByClaimIdResults.deductionDetails.length>0 && claimSearhByClaimIdResults.claimDetails.claimstatusid !== 3\"><div class=\"chatBox noUser\"><div class=\"chatContent\"><h5 class=\"chatStatus\">Deduction details</h5><table class=\"table table-striped\"><thead><tr><td><strong>Deduction amount</strong></td><td><strong>Deduction reason</strong></td></tr></thead><tbody><tr ng-repeat=\"item in claimSearhByClaimIdResults.deductionDetails\"><td>{{item.deductionAmount}}</td><td>{{item.deductionReason}}</td></tr></tbody></table></div></div></div></div><div class=\"chatBox noUser\" ng-show=\"claimSearhByClaimIdResults.attachments.length>0\"><div class=\"chatContent\"><h5 class=\"chatStatus\">Attachments</h5><table class=\"table table-striped\"><tbody><tr ng-repeat=\"item in claimSearhByClaimIdResults.attachments\"><td><a href=\"{{item.downloadURL}}\" target=\"_blank\">{{item.originalFileName}}</a></td></tr></tbody></table></div></div><div class=\"chatBox noUser\" ng-if=\"tabname ==\'Government Schemes\' && claimSearhByClaimIdResults.fileNames.length > 0\"><div class=\"chatContent\"><h5 class=\"chatStatus\">Attachments list</h5><table class=\"table table-striped\"><tbody><tr ng-repeat=\"item in claimSearhByClaimIdResults.fileNames\"><td><a ng-click=\"downloadGovtAttachment(item)\">Download {{item.fileName}}</a></td></tr></tbody></table></div></div><div class=\"chatBox noUser\" ng-if=\"(tabname ==\'Active Claims\' || tabname==\'Documents Pending\' || tabname ==\'Aarogya Scheme\' || tabname == \'Search Results\') && user.role != \'CMS\'\" style=\"padding:10px\"><div class=\"chatcontent\"><h5 class=\"chatStatus\">Action</h5><hosp-action ng-if=\"tabname !==\'Government Schemes\' && user.role != \'CMS\'\" dataobj=\"claimSearhByClaimIdResults\" source=\"tabname\"></hosp-action></div></div><div class=\"chatBox noUser\" ng-if=\"tabname ==\'Government Schemes\' && claimSearhByClaimIdResults.denialReasons\" style=\"padding:10px\"><div class=\"chatcontent\"><h5 class=\"chatStatus\">Denial reasons</h5><span>{{claimSearhByClaimIdResults.denialReasons}}</span></div></div><div class=\"chatBox noUser\" ng-if=\"tabname ==\'Government Schemes\'\" style=\"padding:10px\"><div class=\"chatcontent\"><govt-hospaction ng-if=\"tabname ==\'Government Schemes\'\" dataobj=\"claimSearhByClaimIdResults\" source=\"tabname\" tabid=\"selectedIndex\" clmamt=\"claimSearhByClaimIdResults.claimedAmnt\"></govt-hospaction></div></div></div><div ng-if=\"tabPlanned && !preClaim\"><div class=\"panel panel-default\" id=\"new-claim-success\" ng-show=\"form.preauthSuccess\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\"><h4 class=\"chat-status text-center\">Your claim has been created successfully! Details can be viewed from list of active claims.</h4></div></div><div class=\"col-md-2\"></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"></div><div class=\"col-md-2\"></div></div></div></div><div class=\"panel panel-default\" id=\"new-claim-fail\" ng-show=\"form.preauthError\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\"><h4 class=\"chat-status text-center\">Oops! There seems to be a problem and your claim is not created.</h4><div style=\"margin-left: 50px;\"><p>Possible reasons could be :</p><ol><li>Invalid details entered</li><li>Invalid file formats or more number of files uploaded</li></ol></div><h4 class=\"chat-status text-center\">Please check the details, required files and create it again. Thank you.</h4></div></div><div class=\"col-md-2\"></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"></div><div class=\"col-md-2\"></div></div></div></div><div ng-show=\"!form.preauthSuccess && !form.preauthError\"><div class=\"col-md-12\"><div id=\"myTabContentInner\"><div class=\"tab-pane active\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"chat-content_wrap\"><h5 class=\"chat-status\">Pre-auth initiating <span class=\"chat-user\">by <b>{{username}} <small class=\"bg-danger pull-right\" style=\"font-size: 12px; display: inline-block; padding: 5px;\">All fields marked with * are mandatory</small></b></span></h5><div class=\"chat-content\"><form id=\"myForm\" name=\"signup_form\" novalidate=\"\"><h3 style=\"color: #14bcc8;font-size: 22px;border-bottom: 2px solid #14bcc8;margin: 20px 0;\">Customer details</h3><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"patientFirstName\">Full name <span class=\"text-danger\">*</span></label> <input name=\"patientFirstName\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"form.fullname\" readonly=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"contactNum\">Mobile number <span class=\"text-danger\">*</span></label> <input name=\"contactNum\" type=\"number\" class=\"form-control\" placeholder=\"\" ng-model=\"form.mobile\" readonly=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"dob\">Date Of birth <span class=\"text-danger\">*</span></label> <input name=\"dob\" class=\"form-control\" placeholder=\"\" ng-model=\"form.dob\" readonly=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"gender\">Gender <span class=\"text-danger\">*</span></label> <input name=\"gender\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"form.gender\" readonly=\"\"></div></div><div class=\"col-md-4\" ng-show=\"!form.isgovtscheme\"><div class=\"form-group\"><label for=\"employer\">Corporate name <span class=\"text-danger\">*</span></label> <input name=\"employer\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"form.employer\" readonly=\"\"></div></div><div class=\"col-md-4\" ng-show=\"!form.isgovtscheme\"><div class=\"form-group\"><label for=\"empid\">Employee id <span class=\"text-danger\">*</span></label> <input name=\"empid\" type=\"text\" class=\"form-control\" ng-model=\"form.empid\" readonly=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-4\" ng-show=\"!form.isgovtscheme\"><div class=\"form-group\"><label for=\"maid\">MAID <span class=\"text-danger\">*</span></label> <input name=\"maid\" type=\"number\" class=\"form-control\" placeholder=\"Enter MAID\" ng-model=\"form.maid\" readonly=\"\"></div></div><div class=\"col-md-4\" ng-show=\"form.isgovtscheme\"><div class=\"form-group\"><label for=\"memberId\">Member id <span class=\"text-danger\">*</span></label> <input name=\"memberId\" type=\"number\" class=\"form-control\" placeholder=\"Enter your Member Id\" ng-model=\"form.memberId\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"ipnumber\">In patient number</label> <span ng-show=\"form.opnumber !== \'\'&& form.opnumber!= undefined\" class=\"label label-primary pull-right\">Out patient number - {{form.opnumber}}</span> <input name=\"ipnumber\" type=\"text\" class=\"form-control\" placeholder=\"Enter IP no. for faster search and reconciliation\" ng-model=\"form.ipnumber\"></div></div></div><h3 style=\"color: #14bcc8;font-size: 22px;border-bottom: 2px solid #14bcc8;margin: 20px 0;\">Treatment details</h3><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"doa\">Date of admission <span class=\"text-danger\">*</span> <span style=\"float: right;font-size: 11px; color: #f00;font-weight: normal;\" class=\"textErrorMsg\" ng-show=\"(signup_form.doa.$dirty && signup_form.doa.$invalid) || signup_form.doa.$error.datetimelocal || isdoa\">Enter valid date of admission</span></label><div class=\"input-group\"><input name=\"doa\" id=\"datetimepicker\" placeholder=\"Select date of admission\" readonly=\"\" type=\"text\" class=\"form-control\" ng-change=\"dateOfAdmission(form.dod, \'doa\')\" uib-datepicker-popup=\"{{format}}\" ng-model=\"form.doa\" is-open=\"datePopup.doa\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDoa()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"dod\">Date of discharge <span class=\"text-danger\">*</span> <span style=\"float: right;font-size: 11px; color: #f00;font-weight: normal;\" class=\"textErrorMsg\" ng-show=\"(signup_form.dod.$dirty && signup_form.dod.$invalid) || isdod\">Enter valid date of discharge</span></label><div class=\"input-group\"><input placeholder=\"Select date of discharge\" readonly=\"\" name=\"dod\" type=\"text\" id=\"dischargetimepicker\" class=\"form-control\" ng-change=\"dateOfAdmission(form.doa, \'dod\')\" uib-datepicker-popup=\"{{format}}\" ng-model=\"form.dod\" is-open=\"datePopup.dod\" datepicker-options=\"dateOptions1\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDod()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnosis <span class=\"text-danger\">*</span></label> <textarea name=\"diagnosis\" class=\"form-control\" placeholder=\"Enter diagnosis details\" ng-model=\"form.diagnosis\" required=\"\" style=\"height:36px;\"></textarea><div class=\"error\" ng-show=\"signup_form.diagnosis.$dirty && signup_form.diagnosis.$invalid\"><small class=\"error\" ng-show=\"signup_form.diagnosis.$error.required\">Diagnosis details are required.</small></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"docName\">Doctor name <span class=\"text-danger\">*</span></label> <input name=\"docName\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Type doctor name\" required=\"\" ng-click=\"getkeywords()\" ng-model=\"form.docname\" uib-typeahead=\"condition.doctorName for condition in doctorDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"roomType\">Provided room type <span class=\"text-danger\">*</span></label> <input name=\"roomType\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" required=\"\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Type provided room type\" ng-click=\"getkeywords()\" ng-model=\"form.roomtype\" uib-typeahead=\"item.hospitalRoomType for item in roomsDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"></div></div><div class=\"col-md-4\"><div class=\"form-group\" ng-show=\"!form.isgovtscheme\"><label for=\"procedure\">Procedure <span class=\"text-danger\">*</span></label> <textarea name=\"procedure\" class=\"form-control\" placeholder=\"Enter procedure details\" ng-model=\"form.procedure\" required=\"\" style=\"height:36px;\"></textarea><div class=\"error\" ng-show=\"signup_form.procedure.$dirty && signup_form.procedure.$invalid\"><small class=\"error\" ng-show=\"signup_form.procedure.$error.required\">Procedure details are required.</small></div></div></div></div><div class=\"row\" ng-if=\"CLAIMED_AMOUNT===0 && form.source == \'Infiniti\'\"><div class=\"col-md-8\"><div class=\"form-group\"><label for=\"TreatmentDetails\">Treatment details <span class=\"text-danger\">*</span></label> <input type=\"text\" ng-model=\"procedureManually.name\" ng-change=\"typeProcedureName()\" placeholder=\"Enter treatment details...\" uib-typeahead=\"condition.package_Name for condition in totalListOfPackage | filter:$viewValue | limitTo:5\" typeahead-on-select=\"selectPackageFromList($item, $model)\" typeahead-popup-template-url=\"customPopupTemplate.html\" class=\"form-control\"></div></div><div class=\"col-md-3\" ng-if=\"!isPriceDropDown\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label> <input name=\"procedureName\" placeholder=\"Enter price\" class=\"form-control\" autocomplete=\"off\" ng-model=\"procedureManually.price\" type=\"text\" numbers-only=\"numbers-only\"></div></div><div class=\"col-md-3\" ng-if=\"isPriceDropDown\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label><select name=\"procedurePrice\" class=\"form-control\" ng-model=\"procedureManually.price\"><option value=\"\">--Select Price--</option><option value=\"{{obj.price}}\" ng-repeat=\"obj in priceForPackage | orderBy:\'obj\'\">{{obj.price}} ({{obj.name}})</option></select></div></div><div class=\"col-md-1\" style=\"margin-top: 22px;\"><div class=\"form-group\"><button class=\"btn btn-primary\" ng-click=\"addManuallyProcedure(procedureManually, isPriceDropDown)\">Add</button></div></div></div><div class=\"row\" ng-if=\"form.source != \'Infiniti\'\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"docName\">Price <span class=\"text-danger\">*</span></label> <input name=\"procedureName\" placeholder=\"Enter price\" required=\"\" class=\"form-control\" autocomplete=\"off\" ng-minlength=\"2\" ng-maxlength=\"7\" ng-model=\"form.ApproxClaimedAmnt\" type=\"text\" numbers-only=\"numbers-only\"></div></div></div><div style=\"background-color: aliceblue; border-radius: 10px;\" ng-if=\"selectedMappedpackages.length >0 && CLAIMED_AMOUNT\"><table class=\"table table-hover table-link\"><thead><tr><th class=\"patientName text-left\">Name</th><th class=\"claimedAmount text-center\">Price</th><th class=\"claimedAmount text-center\">Action</th></tr></thead><tbody><tr tooltip-placement=\"top\" ng-repeat=\"item in selectedMappedpackages track by $index\"><td class=\"text-left\" ng-if=\"item.packageAmount > 0\">{{item.hospitaL_CHARGE_HEAD}}</td><td style=\"width: 15%\" class=\"text-center\" ng-if=\"item.packageAmount > 0\"><span class=\"text-center\">{{item.packageAmount}}</span></td><td style=\"width: 15%\" class=\"text-center\" ng-if=\"item.packageAmount > 0\"><button class=\"btn btn-primary btn-xs\" ng-click=\"editPackageFromList(item)\">Edit</button></td></tr><tr tooltip-placement=\"top\" ng-show=\"selectedMappedpackages.length >0\"><td class=\"text-left\" style=\"font-size: large;color: black;\">Total</td><td class=\"text-center\" style=\"font-size: large;color: black;\"><span class=\"text-center\">{{CLAIMED_AMOUNT}}</span></td><td class=\"text-center\" ng-if=\"CLAIMED_AMOUNT>0\"></td></tr></tbody></table></div><h3 style=\"color: #14bcc8;font-size: 22px; border-bottom: 2px solid #14bcc8; margin: 20px 0;\">Upload documents <small class=\"bg-danger\" style=\"font-size: 12px; display: inline-block; padding: 5px;\">Maximum file upload limit is 15 MB. <b>At least one of the documents listed below needs to be submitted.</b></small></h3><div id=\"fileupload\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Signed Pre authorization form</label><mb-file-upload action=\"action\" file-fn=\"fileFn(arg)\"></mb-file-upload></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Id proof <a tooltip-placement=\"top\" uib-tooltip=\"Driving License, Voter ID card, Corporate Employee ID, Pan car, Passport\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a></label><mb-file-upload action=\"action\" file-fn=\"fileFn(arg)\"></mb-file-upload></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnostic reports <a tooltip-placement=\"top\" uib-tooltip=\"Bio Chemistry reports, Haematology reports, Microbiology reports, Neurology reports, Pathology reports, Radiology reports\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a></label><mb-file-upload action=\"action\" file-fn=\"fileFn(arg)\"></mb-file-upload></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Other relevant documents</label><mb-file-upload action=\"action\" file-fn=\"fileFn(arg)\"></mb-file-upload></div></div></div><div class=\"row\" ng-if=\"storeFiles.length >0\"><div class=\"col-md-12\"><div class=\"label label-info\" ng-repeat=\"item in storeFiles\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: #eeeeee;\"><a ng-click=\"downloadAttachment(item.downloadURL)\">{{item.fileName}}</a> <a ng-click=\"removeFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div></div><div class=\"attachment\"><table><tr ng-repeat=\"item in plannedAttachment\"><td><a target=\"_blank\" href=\"{{DMSUrl}}{{item.planHospDMSAttachmentPath}}\">{{item.planHospDMSAttachFileName}}</a></td></tr></table></div><div class=\"row\"><div class=\"col-sm-12\"><button type=\"button\" class=\"btn btn-primary start pull-right\" ng-disabled=\"signup_form.$invalid\" ng-click=\"ecashlessMethods.submitPreauthForm()\"><span>Submit new admission</span></button></div></div></div></form></div></div></div></div></div></div></div></div></div><div ng-if=\"preClaim\"><new-admission ng-if=\"preClaim\" dataobj=\"claimSearhByClaimIdResults\" source=\"\'preClaim\'\"></new-admission></div></div></div></uib-tab><uib-tab ng-if=\"tabname === \'Active Claims\'\" active=\"tab.active\" ng-click=\"getUnprocessedClaims()\" disable=\"tab.disabled\"><uib-tab-heading class=\"tab-heading tab\">Pending for acknowledgement</uib-tab-heading><table class=\"table table-hover table-link\" ng-if=\"tabname != \'Planned Requests\'\"><thead><tr><th class=\"patientName\">Patient name</th><th class=\"claimId\">Claim id</th><th class=\"claimedAmount text-right\">Claimed amount</th><th class=\"claimedAmount text-right\">Approved amount</th><th class=\"statustext-right\">Status</th><th class=\"dateOfAdmission text-right\">Admission date</th><th class=\"dateOfAdmission text-right\">Discharge date</th></tr></thead><tbody ng-if=\"tabname === \'Active Claims\'\"><tr ng-repeat=\"item in preauthfilteredStatusFiltered | limitTo:itemsPerPage\" ng-class=\"item.isFlagRed ? \'font-bold alert-warning\' : \'\'\" ng-click=\"addTab(item.claimId,item, item.patientName)\"><td class=\"name\">{{item.patientName}} <a style=\"font-size:15px\" class=\"pull-right\" ng-show=\"item.isAarogya\"><span class=\"glyphicon glyphicon-font\" style=\"color: #43E441;\"></span></a></td><td>{{item.claimId}}</td><td class=\"text-right\">{{formatCurrency(item.claimedAmount)}}</td><td class=\"text-right\">{{formatCurrency(item.approvedAmount)}}</td><td class=\"text-right\"><span class=\"label label-info ng-binding\">{{item.status}}</span></td><td class=\"text-right\">{{item.dateOfAdmission}}</td><td class=\"text-right\">{{item.dateOfDischarge}}</td></tr></tbody></table><div><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" ng-change=\"pageChanged(currentPage, true)\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'plusActiveAppointments\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><list-filter ng-if=\"showFilters\" pipeline=\"pipeline\" total-items=\"totalItems\" status-list=\"statusList\"></list-filter><span style=\"margin-left: 13px;\" ng-if=\"!showFilters && totalItems\">Count: {{totalItems}}</span><table id=\"plusActiveAppointments\" class=\"table table-hover table-link table-bordered bordered table-condensed datatable\" data-page-length=\"25\"><thead><tr><th><input value=\"1\" id=\"select_all\" type=\"checkbox\" ng-click=\"onSelectAll()\"></th><th>Request id</th><th>Customer / Corporate name</th><th width=\"300px\">Appointment Details</th><th>MemberId</th><th>Status</th><th>Appointment Date-Time</th><th>Actions</th></tr></thead><tbody><tr ng-style=\"$changeColor(item)\" ng-repeat=\"item in appointmentsStatusFiltered | filter: { currentStatus: pipeline.status, requestId: pipeline.searchText.requestId} | filter: { $: { patientName: pipeline.searchText.patientName, primaryEntityName: pipeline.searchText.primaryEntityName} } | orderBy:pipeline.sortBy:pipeline.reverse\" ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId,item.mappingId1)\" ng-class=\"{0:\'\', 1:\'border-left border-success\', 2:\'border-left border-danger\'}[item.priorityId]\"><td></td><td id=\"request_id\">{{item.requestId}}</td><td><span>{{item.additionalInformation.patientName}} <span ng-if=\"item.priorityId ===2 || item.priorityId === 4\" style=\"color: red; font-size: larger;\">HNI</span></span> <span class=\"smTxt\" ng-if=\"item.additionalInformation.primaryEntityName\">{{item.additionalInformation.primaryEntityName}}</span></td><td><package-test-details-modal productid=\"item.additionalInformation.orderItemProductId\" ng-click=\"$event.stopPropagation()\"><span><a style=\"color: #666;font-weight: 500;\">{{item.additionalInformation.productName.replace(\"_\",\" \")}}</a></span></package-test-details-modal></td><td id=\"maid\">{{item.additionalInformation.maid}}</td><td><label style=\"background-color: #2496ce;color: white;font-size: smaller;\" class=\"label label-info status-name\">{{item.currentStatus}}</label><div class=\"dnd-active\" ng-if=\"item.additionalInformation.additionals.DNDCustomer || item.additionalInformation.additionals.DND\"><img style=\"height: 20px; margin-top: 5px;\" src=\"/app/resources/icons/dnd.svg\" alt=\"\"></div></td><td>{{getDateObj(item.additionalInformation.appointmentDate) | date:\"yyyy-MM-dd \'at\' h:mm a\"}} <span class=\"smTxt\" style=\"color: black;\">{{item.additionalInformation.providerName}}</span> <span class=\"smTxt\" style=\"color: black;\">{{item.city}}</span></td><td class=\"next-action\" ng-if=\"item.nextImmediateActions.length\"><span ng-click=\"$event.stopPropagation()\"><button class=\"btn btn-secondary btn-xs\" ng-repeat=\"btnType in item.nextImmediateActions\" title=\"{{btnType.action}} Appointment\" ng-click=\"openActionModal(btnType.action,item.currentStatusId,btnType.actionStatusId,item.requestId,item.additionalInformation.appointmentDate,item.additionalInformation.secondAppointmentDate,item.additionalInformation.orderItemProductId,item)\"><i class=\"{{actionColors[btnType.action]}} {{statusTextColors[btnType.actionStatusId]}}\"></i> {{btnType.action}} Appointment</button></span></td><td class=\"text-right\" ng-if=\"!item.nextImmediateActions.length\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\" ng-click=\"$event.stopPropagation()\"><a class=\"btn btn-primary\" id=\"actions\" uib-tooltip=\"Actions\" style=\"color: #101010;background-color: #dddddd;border-color: #dddddd;\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" style=\"background-color: #eeeeee;\" uib-dropdown-menu=\"\" aria-labelledby=\"actions\"><li ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId,item.mappingId1)\"><a><i class=\"fa fa-eye\"></i> View</a></li><li><a><i class=\"fa fa-commenting-o\"></i><communication-history-modal requestflowid=\"item.requestId\" isflowreqid=\"\'reqId\'\">Communication</communication-history-modal></a></li><li ng-repeat=\"btnType in item.nextPossibleActions\"><a data-toggle=\"modal\" data-target=\"#{{btnType.action}}Modal\" data-status=\"{{item.currentStatusId}}\" data-nextstatus=\"{{btnType.actionStatusId}}\" data-request=\"{{item.requestId}}\" data-date=\"{{item.additionalInformation.appointmentDate}}\" title=\"{{btnType.action}} Appointment\" data-seconddate=\"{{item.additionalInformation.secondAppointmentDate}}\" data-productid=\"{{item.additionalInformation.orderItemProductId}}\" data-showprice=\"{{item.requestContractType == mpConsultationContract}}\" ng-click=\"openActionModal(btnType.action,item.currentStatusId,btnType.actionStatusId,item.requestId,item.additionalInformation.appointmentDate,item.additionalInformation.secondAppointmentDate,item.additionalInformation.orderItemProductId,item)\"><i class=\"{{actionColors[btnType.action]}} {{statusTextColors[btnType.actionStatusId]}}\"></i> {{btnType.action}} Appointment</a></li></ul></span></td></tr></tbody></table><uib-pagination total-items=\"totalItems\" items-per-page=\"itemsPerPage\" ng-change=\"getDataForNextpage(currentPage)\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div><div block-ui=\"appointmentDetails\"><div ng-show=\"!tab1show\"><appt-essentials appt-essentials=\"apptEssentials\" visit-type=\"visitTypeData\" appointment-history=\"apptHistory\" appointment-detail=\"apptDetails\"></appt-essentials><hr><div class=\"row\" ng-show=\"resData.statusHistory && resData.statusHistory.length > 0\"><div class=\"col-md-4\" style=\"padding-right:0;\"><appt-patient-detail appointment-detail=\"apptDetails\" visit-type=\"visitTypeData\" status-history=\"statusHistory\" patient-detail=\"patientDetails\" pharma-details=\"pharmaDetails\"></appt-patient-detail></div><div class=\"col-md-8\"><appt-status-history appointment-history=\"apptHistory\" req-id=\"apptEssentials.id\" pharma-details=\"pharmaDetails\" class=\"chat\"></appt-status-history></div></div></div></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'allAppointments\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><table class=\"table table-hover table-link\"><thead><tr><th>Request id</th><th>Customer name / Corporate name</th><th width=\"300px\">Service particulars</th><th>Created on/ Appointment date &amp; time</th><th>Provider name</th><th>Actions</th></tr></thead><tbody><tr ng-style=\"$changeColor(item)\" ng-repeat=\"item in appointmentsStatusFiltered | startFrom:(currentPage-1)*itemsPerPage | orderBy: \'-priorityId\' | limitTo:itemsPerPage\" ng-class=\"{0:\'\', 1:\'border-left border-success\', 2:\'border-left border-danger\'}[item.priorityId]\"><td ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId,item.mappingId1)\">{{item.requestId}}</td><td ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId,item.mappingId1)\"><span>{{item.additionalInformation.patientName}} -- {{item.priorityId}} <span ng-if=\"item.priorityId === 2 || item.priorityId === 4\" style=\"color: red; font-size: larger;\">HNI</span></span> <span class=\"smTxt\">{{item.additionalInformation.primaryEntityName}}</span></td><td><label style=\"background-color: #2496ce;color: white;font-size: smaller;\" class=\"label label-info status-name\">{{item.currentStatus}}</label><package-test-details-modal productid=\"item.additionalInformation.orderItemProductId\"><span class=\"smTxt\"><a>{{item.additionalInformation.productName.replace(\"_\",\" \")}}</a></span></package-test-details-modal></td><td ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId,item.mappingId1)\" style=\"font-size:11px\"><span style=\"color: black;\">{{getDateObj(item.createdOn) | date:\"yyyy-MM-dd \'at\' h:mm a\"}}</span> <span class=\"smTxt\" style=\"color: black;\">{{getDateObj(item.additionalInformation.appointmentDate) | date:\"yyyy-MM-dd \'at\' h:mm a\"}}</span></td><td ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId,item.mappingId1)\" style=\"font-size:11px\">{{item.additionalInformation.providerName}}</td><td class=\"text-right\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a class=\"btn btn-primary\" id=\"actions\" uib-tooltip=\"Actions\" style=\"color: #101010;background-color: #dddddd;border-color: #dddddd;\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" style=\"background-color: #eeeeee;\" uib-dropdown-menu=\"\" aria-labelledby=\"actions\"><li ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId,item.mappingId1)\"><a><i class=\"fa fa-eye\"></i> View</a></li><li><a><i class=\"fa fa-commenting-o\"></i><communication-history-modal requestflowid=\"item.requestId\" isflowreqid=\"\'reqId\'\">Communication</communication-history-modal></a></li><li ng-repeat=\"btnType in item.nextPossibleActions\"><a data-toggle=\"modal\" data-target=\"#{{btnType.action}}Modal\" data-status=\"{{item.currentStatusId}}\" data-nextstatus=\"{{btnType.actionStatusId}}\" data-request=\"{{item.requestId}}\" data-date=\"{{item.additionalInformation.appointmentDate}}\" title=\"{{btnType.action}} Appointment\" data-seconddate=\"{{item.additionalInformation.secondAppointmentDate}}\" data-productid=\"{{item.additionalInformation.orderItemProductId}}\" data-showprice=\"{{item.requestContractType == mpConsultationContract}}\" ng-click=\"openActionModal(btnType.action,item.currentStatusId,btnType.actionStatusId,item.requestId,item.additionalInformation.appointmentDate,item.additionalInformation.secondAppointmentDate,item.additionalInformation.orderItemProductId,item)\"><i class=\"{{actionColors[btnType.action]}} {{statusTextColors[btnType.actionStatusId]}}\"></i> {{btnType.action}} Appointment</a></li></ul></span></td></tr></tbody></table><uib-pagination total-items=\"totalItems\" items-per-page=\"itemsPerPage\" ng-change=\"getDataForNextpage(currentPage)\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div><div block-ui=\"appointmentDetails\"><div ng-show=\"!tab1show\"><appt-essentials appt-essentials=\"apptEssentials\" visit-type=\"visitTypeData\" appointment-history=\"apptHistory\" appointment-detail=\"apptDetails\"></appt-essentials><hr><div class=\"row\" ng-show=\"resData.statusHistory && resData.statusHistory.length > 0\"><div class=\"col-md-4\" style=\"padding-right:0;\"><appt-patient-detail appointment-detail=\"apptDetails\" visit-type=\"visitTypeData\" status-history=\"statusHistory\" patient-detail=\"patientDetails\" pharma-details=\"pharmaDetails\"></appt-patient-detail></div><div class=\"col-md-8\"><appt-status-history appointment-history=\"apptHistory\" pharma-details=\"pharmaDetails\" class=\"chat\"></appt-status-history></div></div></div></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'appointmentSearch\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><table class=\"table table-hover table-link\"><thead><tr><th>Request id</th><th>Customer name / Corporate name</th><th>Service particulars / status</th><th>Date &amp; time</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"item in appointmentsStatusFiltered | startFrom:(currentPage-1)*itemsPerPage | orderBy: \'-priorityId\' | limitTo:itemsPerPage\" ng-class=\"{0:\'\', 1:\'border-left border-success\', 2:\'border-left border-danger\'}[item.priorityId]\"><td ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId,item.mappingId1)\">{{item.requestId}}</td><td ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId,item.mappingId1)\">{{item.additionalInformation.patientName}} <span class=\"smTxt\">{{item.additionalInformation.primaryEntityName}}</span></td><td><label style=\"background-color: #526e83; color: white; font-size: smaller;\" class=\"label label-info status-name\">{{item.currentStatus}}</label><div class=\"dnd-active\" ng-if=\"item.additionalInformation.additionals.DNDCustomer || item.additionalInformation.additionals.DND\"><img style=\"height: 20px; margin-top: 5px;\" src=\"/app/resources/icons/dnd.svg\" alt=\"\"></div><package-test-details-modal productid=\"item.additionalInformation.orderItemProductId\"><span class=\"smTxt\"><a>{{item.additionalInformation.productName.replace(\"_\",\" \")}}</a></span></package-test-details-modal></td><td ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId,item.mappingId1)\">{{compareDate(item.additionalInformation.appointmentDate)}} - {{formatTime(item.additionalInformation.appointmentDate)}}</td><td class=\"text-right\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a class=\"btn btn-primary\" id=\"actions\" uib-tooltip=\"Actions\" style=\"color: #101010;background-color: #dddddd;border-color: #dddddd;\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" style=\"background-color: #eeeeee;\" uib-dropdown-menu=\"\" aria-labelledby=\"actions\"><li ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId,item.mappingId1)\"><a><i class=\"fa fa-eye\"></i> View</a></li><li ng-repeat=\"btnType in item.nextPossibleActions\"><a ng-show=\"btnType.action\" data-toggle=\"modal\" data-target=\"#{{btnType.action}}Modal\" data-status=\"{{item.currentStatusId}}\" data-nextstatus=\"{{btnType.actionStatusId}}\" data-request=\"{{item.requestId}}\" data-date=\"{{item.additionalInformation.appointmentDate}}\" title=\"{{btnType.action}} Appointment\" data-seconddate=\"{{item.additionalInformation.secondAppointmentDate}}\" data-productid=\"{{item.additionalInformation.orderItemProductId}}\" data-showprice=\"{{item.requestContractType == mpConsultationContract}}\" ng-click=\"openActionModal(btnType.action,item.currentStatusId,btnType.actionStatusId,item.requestId,item.additionalInformation.appointmentDate,item.additionalInformation.secondAppointmentDate,item.additionalInformation.orderItemProductId, item)\"><i class=\"{{actionColors[btnType.action]}} {{statusTextColors[btnType.actionStatusId]}}\"></i> {{btnType.action}} Appointment</a></li></ul></span></td></tr></tbody></table><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div><div ng-show=\"!tab1show\"><appt-essentials appt-essentials=\"apptEssentials\" visit-type=\"visitTypeData\" appointment-history=\"apptHistory\" appointment-detail=\"apptDetails\"></appt-essentials><hr><div class=\"row\" ng-show=\"resData.statusHistory && resData.statusHistory.length > 0\"><div class=\"col-md-4\" style=\"padding-right:0;\"><appt-patient-detail appointment-detail=\"apptDetails\" visit-type=\"visitTypeData\" status-history=\"statusHistory\" patient-detail=\"patientDetails\" pharma-details=\"pharmaDetails\"></appt-patient-detail></div><div class=\"col-md-8\"><appt-status-history appointment-history=\"apptHistory\" pharma-details=\"pharmaDetails\" class=\"chat\"></appt-status-history></div></div></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'plusAllAppointments\' || tabtype == \'insurerDashboard\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><span style=\"margin-left: 13px;\">count : {{totalItems}}</span><table class=\"table table-hover\"><thead><tr><th>Request id/CaseId</th><th>Customer name</th><th>Email & Contact no.</th><th>Package</th><th>Status</th><th>Date & time</th><th>Actions</th></tr></thead><tr ng-repeat=\"item in appointmentsStatusFiltered | startFrom:(currentPage-1)*itemsPerPage | orderBy: \'-priorityId\' | limitTo:itemsPerPage\" ng-class=\"{0:\'\', 1:\'border-left border-success\', 2:\'border-left border-danger\'}[item.priorityId]\"><td ng-click=\"appointmentMethods.addAllAppointmentsTab(item.additionalInformation.patientName, item.requestId, item.currentStatusId)\"><span class=\"smTxt\">{{item.requestId}}/{{item.additionalInformation.employeeID}}</span></td><td ng-click=\"appointmentMethods.addAllAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId)\">{{item.additionalInformation.patientName}} <span class=\"smTxt\">{{item.additionalInformation.primaryEntityName}}</span></td><td ng-click=\"appointmentMethods.addAllAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId)\">{{item.additionalInformation.employeeMailID}}<br><span class=\"smTxt\">{{item.additionalInformation.contactNo}}</span></td><td ng-click=\"appointmentMethods.addAllAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId)\"><span class=\"smTxt\">{{item.additionalInformation.productName.replace(\"_\",\"\")}}</span></td><td ng-click=\"appointmentMethods.addAllAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId)\"><label style=\"background-color: #526e83; color: white; font-size: smaller;\" class=\"label label-info status-name\">{{item.currentStatus}}</label><div class=\"dnd-active\" ng-if=\"item.additionalInformation.additionals.DNDCustomer || item.additionalInformation.additionals.DND\"><img style=\"height: 20px; margin-top: 5px;\" src=\"/app/resources/icons/dnd.svg\" alt=\"\"></div></td><td ng-click=\"appointmentMethods.addAllAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId)\" style=\"width: 120px;\"><span class=\"smTxt\">{{compareDate(item.additionalInformation.appointmentDate)}}-{{formatTime(item.additionalInformation.appointmentDate)}}</span></td><td class=\"text-right\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a uib-tooltip=\"Actions\" style=\"color: #101010;background-color: #dddddd;border-color: #dddddd;\" class=\"btn btn-primary\" id=\"actions\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" style=\"background-color: #eeeeee;\" uib-dropdown-menu=\"\" aria-labelledby=\"actions\"><li ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId,item.mappingId1)\"><a><i class=\"fa fa-eye\"></i> View</a></li><li><a><i class=\"fa fa-commenting-o\"></i><communication-history-modal requestflowid=\"item.requestId\" isflowreqid=\"\'reqId\'\" class=\"ng-isolate-scope\">Communication</communication-history-modal></a></li><li ng-show=\"!mahsLogin\"><a><i class=\"glyphicon glyphicon-inbox text-success\"></i><resend-email-modal reqid=\"item.requestId\" isdc=\"dcLogin\">Resend email</resend-email-modal></a></li><li ng-repeat=\"action in item.nextPossibleActions\"><a ng-if=\"action.actionStatusId === 117\"><i class=\"fa fa-calendar\"></i><reschedule-appointment-modal requestdata=\"item\" refresh=\"reloadAppointments(\'rescheduleAppointment\')\">{{action.action}}</reschedule-appointment-modal></a></li></ul></span></td></tr></table><uib-pagination total-items=\"totalItems-1\" ng-model=\"pagination.currentPage\" ng-change=\"changePage(pagination.currentPage)\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div><div ng-show=\"!tab1show\"><div class=\"clearfix\"><h4 style=\"font-size:16px;\"><label ng-show=\"resData.fitUnfit == 1\" class=\"label label-info\">Fit</label> <label ng-show=\"resData.fitUnfit == 2\" class=\"label label-info\">UnFit</label> <span ng-if=\"resData.requestHistory.additionalInformation.isPaid\">Paid</span> <span ng-if=\"!resData.requestHistory.additionalInformation.isPaid\">Sponsored</span> <span style=\"color: black;font-size: inherit;\">| {{res.additionalInformation.visitType}}</span> | {{resData.additionalInformation.productName}} (ID: {{resId}})</h4></div><div class=\"row\" ng-show=\"resData.statusHistory && resData.statusHistory.length > 0\"><div class=\"col-md-4\"><appt-patient-detail appointment-detail=\"apptDetails\" visit-type=\"visitTypeData\" status-history=\"statusHistory\" patient-detail=\"patientDetails\"></appt-patient-detail></div><div class=\"col-md-8\"><appt-status-history appointment-history=\"apptHistory\" class=\"chat\"></appt-status-history></div></div></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'unApprovedCancelAppointments\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><table class=\"table table-hover table-link\"><thead><tr><th>Request id</th><th>Customer name / Corporate name</th><th>Package / Status</th><th>Date &amp; time</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"item in appointmentsStatusFiltered | startFrom:(currentPage-1)*itemsPerPage | orderBy: \'-priorityId\' | limitTo:itemsPerPage\" ng-class=\"{0:\'\', 1:\'border-left border-success\', 2:\'border-left border-danger\'}[item.priorityId]\"><td ng-click=\"appointmentMethods.addApprovedUnApprovedCancelTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId)\">{{item.requestId}}</td><td ng-click=\"appointmentMethods.addApprovedUnApprovedCancelTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId)\">{{item.additionalInformation.patientName}} <span class=\"smTxt\">{{item.additionalInformation.primaryEntityName}}</span></td><td><label style=\"background-color: #526e83; color: white; font-size: smaller;\" class=\"label label-info status-name\">{{item.currentStatus}}</label><div class=\"dnd-active\" ng-if=\"item.additionalInformation.additionals.DNDCustomer || item.additionalInformation.additionals.DND\"><img style=\"height: 20px; margin-top: 5px;\" src=\"/app/resources/icons/dnd.svg\" alt=\"\"></div><package-test-details-modal productid=\"item.additionalInformation.orderItemProductId\"><span class=\"smTxt\"><a>{{item.additionalInformation.productName.replace(\"_\",\" \")}}</a></span></package-test-details-modal></td><td ng-click=\"appointmentMethods.addApprovedUnApprovedCancelTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId)\">{{compareDate(item.additionalInformation.appointmentDate)}} - {{formatTime(item.additionalInformation.appointmentDate)}}</td><td class=\"text-right\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a class=\"btn btn-primary\" id=\"actions\" uib-tooltip=\"Actions\" style=\"color: #101010;background-color: #dddddd;border-color: #dddddd;\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" style=\"background-color: #eeeeee;\" uib-dropdown-menu=\"\" aria-labelledby=\"actions\"><li ng-click=\"appointmentMethods.addApprovedUnApprovedCancelTab(item.additionalInformation.patientName,item.requestId)\"><a><i class=\"fa fa-eye\"></i> View</a></li><li ng-repeat=\"btnType in item.nextPossibleActions\"><a ng-show=\"btnType.action\" data-toggle=\"modal\" data-target=\"#{{btnType.action}}Modal\" data-status=\"{{item.currentStatusId}}\" data-nextstatus=\"{{btnType.actionStatusId}}\" data-request=\"{{item.requestId}}\" data-date=\"{{item.additionalInformation.appointmentDate}}\" title=\"{{btnType.action}} Appointment\" data-seconddate=\"{{item.additionalInformation.secondAppointmentDate}}\" data-productid=\"{{item.additionalInformation.orderItemProductId}}\" data-showprice=\"{{item.requestContractType == mpConsultationContract}}\" ng-click=\"openActionModal(btnType.action,item.currentStatusId,btnType.actionStatusId,item.requestId,item.additionalInformation.appointmentDate,item.additionalInformation.secondAppointmentDate,item.additionalInformation.orderItemProductId, item)\"><i class=\"{{actionColors[btnType.action]}} {{statusTextColors[btnType.actionStatusId]}}\"></i> {{btnType.action}} Appointment</a></li></ul></span></td></tr></tbody></table><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div><div ng-show=\"!tab1show\"><appt-essentials appt-essentials=\"apptEssentials\" visit-type=\"visitTypeData\" appointment-history=\"apptHistory\" appointment-detail=\"apptDetails\"></appt-essentials><hr><div class=\"row\" ng-show=\"resData.statusHistory && resData.statusHistory.length > 0\"><div class=\"col-md-4\" style=\"padding-right:0;\"><appt-patient-detail appointment-detail=\"apptDetails\" visit-type=\"visitTypeData\" status-history=\"statusHistory\" patient-detail=\"patientDetails\" pharma-details=\"pharmaDetails\"></appt-patient-detail></div><div class=\"col-md-8\"><appt-status-history appointment-history=\"apptHistory\" pharma-details=\"pharmaDetails\" class=\"chat\"></appt-status-history></div></div></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'unapprovedNewAppointments\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><table class=\"table table-hover\"><thead><tr><th>Customer<br>(employee id)</th><th>UTR #</th><th>Service particulars (Paid/ Sponsored)</th><th>Provider venue</th><th class=\"text-right\" style=\"width:80px;\">Actions</th></tr></thead><tbody><tr ng-repeat=\"item in appointmentsNa | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\"><td>{{item.firstName}} <span class=\"smTxt\">{{getAge(item.dob)}} Yrs, <span ng-if=\"item.gender == \'F\'\">Female</span>. <span ng-if=\"item.gender == \'M\'\">Male</span> <span ng-if=\"item.employeeId\">({{item.employeeId}})</span></span></td><td ng-show=\"item.transactionId && item.transactionId!=\'\'\">{{item.transactionId}}</td><td ng-show=\"!item.transactionId || item.transactionId==\'\'\">--</td><td><span class=\"label\" ng-class=\"{\'label-primary\' : item.isPaid, \'label-warning\' : !item.isPaid}\">{{item.isPaid?\"Paid\":\"Sponsored\"}}</span> {{item.productName}}</td><td><span class=\"smTxt\">{{compareDate(item.preferredDC[0].firstPrefTime)}} - {{formatTime(item.preferredDC[0].firstPrefTime)}} | {{item.city}}</span> {{item.preferredDC[0].name}}</td><td class=\"text-right\"><div class=\"btn-group btn-group-xs\"><button class=\"btn btn-primary\" ng-click=\"setOrderItemIdParent(item.requestId)\" ng-show=\"(item.transactionId|uppercase) == \'EXCEPTION\'\" data-toggle=\"modal\" data-target=\"#exceptionModal\"><i class=\"glyphicon glyphicon-ok\"></i></button> <button class=\"btn btn-primary\" ng-click=\"approvedNaActionRequest(true, item.requestId)\" ng-show=\"(item.transactionId|uppercase) != \'EXCEPTION\'\"><i class=\"glyphicon glyphicon-ok\"></i></button> <button class=\"btn btn-danger\" ng-click=\"approvedNaActionRequest(false, item.requestId)\"><i class=\"glyphicon glyphicon-remove\"></i></button></div></td></tr></tbody></table><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div><div ng-show=\"!tab1show\"></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'unConfirmedOrder\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading class=\"tab-heading tab{{$index}}\">{{tab.title}} ({{totalItems}})</uib-tab-heading><table class=\"table table-condensed table-hover\"><thead><tr><th>Employee (ID)</th><th>Customer</th><th>Service particulars</th><th>Provider venue</th><th class=\"text-right\" style=\"width:65px;\">Actions</th></tr></thead><tbody><tr ng-repeat=\"item in appointmentsStatusFiltered | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\"><td>{{item.customerName}}<br><span class=\"smLable\">{{item.employeeId}}</span></td><td>{{item.orderItems[0].firstName}}<br><span class=\"smLable\">{{getToUpperCase(item.orderItems[0].gender)}}, {{getAge(item.orderItems[0].dob)}} Yrs, {{getToLowerCase(item.orderItems[0].relation)}}</span></td><td>{{item.orderItems[0].productName}}<br><span class=\"label\" ng-class=\"item.orderItems[0].isPaid?\'label-primary\':\'label-info\'\">{{item.orderItems[0].isPaid?\"Paid\":\"Sponsored\"}}</span></td><td>{{item.orderItems[0].preferredDC[0].name}}, {{item.orderItems[0].city}}<br><span class=\"smLable\">{{compareDate(item.orderItems[0].preferredDC[0].firstPrefTime)}}, {{formatTime(item.orderItems[0].preferredDC[0].firstPrefTime)}}</span></td><td class=\"text-right\"><div class=\"btn-group btn-group-xs\"><button class=\"btn btn-primary\" ng-hide=\"item.isApproved && item.isProcessed\" data-toggle=\"modal\" data-target=\"ApproveModal\" ng-click=\"unConfirmedOrderModal(item.cartId, true, \'ApproveModal\')\" title=\"Approve order\"><i class=\"glyphicon glyphicon-ok\"></i></button> <button class=\"btn btn-danger\" data-toggle=\"modal\" data-target=\"CancelModal\" ng-click=\"unConfirmedOrderModal(item.cartId, false, \'CancelModal\')\" title=\"Cancel order\"><i class=\"glyphicon glyphicon-remove\"></i></button></div></td></tr></tbody></table><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'dcInvestigation\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading class=\"tab-heading tab{{$index}}\">{{tab.title}} ({{totalItems}})</uib-tab-heading><table class=\"table table-hover\"><thead><tr><th>S. no</th><th>Investigation name / Group / Description</th></tr></thead><tbody><tr ng-repeat=\"item in dcInvestigation | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\"><td>{{item.id}}</td><td>{{item.name}} <span class=\"smLable\">{{item.shortName}} | {{item.groupName}}</span> <span class=\"label label-success\" ng-show=\"item.isActive\">Active</span> <span class=\"label label-warning\" ng-show=\"!item.isActive\">Inactive</span> <button type=\"button\" class=\"btn btn-xs btn-info\" data-toggle=\"modal\" data-target=\"#\" uib-tooltip=\"Edit\" ng-click=\"editDcInvestigation(item.id)\" style=\"padding:0 5px;\"><i class=\"glyphicon glyphicon-pencil\"></i></button> <span class=\"smTxt\">{{item.description}}</span></td></tr></tbody></table><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'approvedCancelAppointments\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><table class=\"table table-hover table-link\"><thead><tr><th>Request id</th><th>Customer name / Corporate name</th><th>Service particulars / Status</th><th>Date &map; time</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"item in appointmentsStatusFiltered | startFrom:(currentPage-1)*itemsPerPage | orderBy: \'-priorityId\' | limitTo:itemsPerPage\" ng-class=\"{0:\'\', 1:\'border-left border-success\', 2:\'border-left border-danger\'}[item.priorityId]\"><td ng-click=\"appointmentMethods.addApprovedUnApprovedCancelTab(item.additionalInformation.patientName,item.requestId, item.currentStatusId)\">{{item.requestId}}</td><td ng-click=\"appointmentMethods.addApprovedUnApprovedCancelTab(item.additionalInformation.patientName,item.requestId, item.currentStatusId)\">{{item.additionalInformation.patientName}} <span class=\"smTxt\">{{item.additionalInformation.primaryEntityName}}</span></td><td><label style=\"background-color: #526e83; color: white; font-size: smaller;\" class=\"label label-info status-name\">{{item.currentStatus}}</label><div class=\"dnd-active\" ng-if=\"item.additionalInformation.additionals.DNDCustomer || item.additionalInformation.additionals.DND\"><img style=\"height: 20px; margin-top: 5px;\" src=\"/app/resources/icons/dnd.svg\" alt=\"\"></div><package-test-details-modal productid=\"item.additionalInformation.orderItemProductId\"><span class=\"smTxt\"><a>{{item.additionalInformation.productName.replace(\"_\",\" \")}}</a></span></package-test-details-modal></td><td ng-click=\"appointmentMethods.addApprovedUnApprovedCancelTab(item.additionalInformation.patientName,item.requestId, item.currentStatusId)\">{{compareDate(item.additionalInformation.appointmentDate)}} - {{formatTime(item.additionalInformation.appointmentDate)}}</td><td class=\"text-right\" ng-click=\"appointmentMethods.addApprovedUnApprovedCancelTab(item.additionalInformation.patientName,item.requestId, item.currentStatusId)\"><a class=\"btn btn-xs btn-primary\"><i class=\"fa fa-eye\"></i> View</a></td></tr></tbody></table><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div><div ng-show=\"!tab1show\"><appt-essentials appt-essentials=\"apptEssentials\" visit-type=\"visitTypeData\" appointment-history=\"apptHistory\" appointment-detail=\"apptDetails\"></appt-essentials><hr><div class=\"row\" ng-show=\"resData.statusHistory && resData.statusHistory.length > 0\"><div class=\"col-md-4\" style=\"padding-right:0;\"><appt-patient-detail appointment-detail=\"apptDetails\" visit-type=\"visitTypeData\" patient-detail=\"patientDetails\" pharma-details=\"pharmaDetails\"></appt-patient-detail></div><div class=\"col-md-8\"><appt-status-history appointment-history=\"apptHistory\" pharma-details=\"pharmaDetails\" class=\"chat\"></appt-status-history></div></div></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'eSalesRequests\'\"><select ng-show=\"ContractAsSales\" class=\"pull-right form-control input-xs\" style=\"width:200px;\" ng-model=\"selectedSource\" ng-options=\"source.id as source.entityName for source in sources\" ng-change=\"filterQueue(selectedSource)\"><option value=\"\">All</option></select><div ng-if=\"eSalesRequestsQueue.length >0\"><input ng-if=\"isInsurer\" type=\"button\" class=\"btn btn-primary pull-right btn-xs\" filename=\"{{ filename }}.csv\" value=\"Download\" ng-csv=\"downloadESalesRequestsQueue\" csv-header=\"[\'corporateName\',\'dateTimeCreated\',\'eQuote\',\'name\',\'mobileNumber\',\'city\', \'state\',\'employeeId\',\'testName\']\"></div><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><span style=\"margin-left: 13px;\">Count: {{totalEsalesItems}}</span><div ng-show=\"tab1show\"><table class=\"table table-hover\"><thead><tr><th>eQuote</th><th>Customer details</th><th>Corporate name</th><th>City</th><th>State</th><th>Created on</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"item in eSalesRequestsQueue\"><td class=\"text-left\" ng-if=\"item.error ==\'closed by insurer\' && item.orderID == 0 && item.isActive == false\">{{item.eQuote}} - {{item.error}}</td><td class=\"text-left\" ng-if=\"item.error !=\'closed by insurer\' && item.orderID != 0 && item.isActive != false\">{{item.eQuote}}</td><td class=\"text-left\">{{item.name}} <span class=\"smTxt\">{{item.email}}</span> <span class=\"smTxt\">{{item.phoneNo}}</span></td><td class=\"text-left\">{{item.corporateName}}</td><td class=\"text-left\">{{item.city}}</td><td class=\"text-left\">{{item.state}}</td><td class=\"text-left\">{{compareDate(item.dateTimeCreated)}}</td><td><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a class=\"btn btn-primary\" id=\"actions\" uib-tooltip=\"Actions\" style=\"color: #101010;background-color: #dddddd;border-color: #dddddd;\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" style=\"background-color: #eeeeee;\" uib-dropdown-menu=\"\" aria-labelledby=\"actions\"><li ng-click=\"showDetailsParent(item)\"><a><i class=\"fa fa-hotel\"></i> Create Appointments</a></li><li ng-click=\"addCorrespondence(item, \'add\')\" data-toggle=\"modal\" data-target=\"#AddCorresponddenceModal\"><a><i class=\"fa fa-plus\"></i> Add Correspondence</a></li><li ng-click=\"addCorrespondence(item, \'show\')\" data-toggle=\"modal\" data-target=\"#ViewCorresponddenceModal\"><a><i class=\"fa fa-eye\"></i> Show Correspondence</a></li><li ng-click=\"deleteOrder(item)\" data-toggle=\"modal\" data-target=\"#deleteRequest\" ng-if=\"eSaleQueueFlag()\"><a><i class=\"fa fa-close\"></i> Delete Order</a></li><li ng-show=\"!isInsurerAction\"><a><i class=\"fa fa-commenting-o\"></i><communication-history-modal requestflowid=\"item.id\" isflowreqid=\"\'eSlale\'\">Communication</communication-history-modal></a></li></ul></span></td></tr></tbody></table><uib-pagination ng-if=\"appointments.pendingRequestQueueData\" total-items=\"totalEsalesItems\" ng-model=\"currentPage\" max-size=\"maxSize\" ng-change=\"getDataForNextpage(currentPage)\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'corporatePackagesNames\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"showAllAppointments\"><table class=\"table table-hover table-link\"><thead><tr><th>Serial no</th><th>Package name</th></tr></thead><tbody><tr ng-repeat=\"item in CorporatePackagesFiltered | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\"><td>{{$index + 1 }}</td><td ng-click=\"corpPackageMappingPackageName(item)\">{{item.pM_AliasName}}</td></tr></tbody></table><div style=\"margin-left: -120px;\"><uib-pagination total-items=\"packageNameLength\" ng-model=\"currentPage\" max-size=\"3\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'mappedDc\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}({{packageNameLength}})</uib-tab-heading><div ng-show=\"showAllAppointments\"><table class=\"table table-hover\"><thead><tr><th>DC name/DC address</th><th>DC rate</th><th>Corporate rate</th><th>Start date</th><th>End date</th><th>Map dc</th><th>Financial approval</th><th>Upload file</th><th colspan=\"4\">Quick actions</th></tr></thead><tbody><tr ng-repeat=\"item in mappedDcLists\"><td>{{item.entityName}}<br>{{item.locationName}}</td><td style=\"width:110px;\"><input type=\"text\" class=\"form-control\" ng-model=\"item.dcRate\" ng-disabled=\"item.isFinanceApproved || item.isFinance\"></td><td style=\"width:110px;\"><input type=\"text\" class=\"form-control\" ng-model=\"item.dcWiseCorporatePrice\" ng-disabled=\"item.isFinanceApproved ||item.isFinance\"></td><td><input type=\"date\" class=\"form-control\" ng-model=\"item.startDate\" ng-disabled=\"item.isFinanceApproved || item.isFinance\"></td><td><input type=\"date\" class=\"form-control\" ng-model=\"item.endDate\" ng-disabled=\"item.isFinanceApproved || item.isFinance\"></td><td><input ng-model=\"item.toBeSelected\" type=\"checkbox\" data-id=\"{{item.entityId}}\" data-isactive=\"{{item.toBeSelected}}\" ng-change=\"saveCheckedMapDCParent(item,item.toBeSelected, \'checkbox\')\" ng-disabled=\"item.isFinance\"></td><td><input ng-model=\"item.isFinanceApproved\" type=\"checkbox\" data-id=\"{{item.isFinanceApproved}}\" data-isactive=\"{{item.isFinanceApproved}}\" ng-disabled=\"!item.toBeSelected || !item.isFinance\"></td><td><button ng-show=\"item.toBeSelected && isFinanceFlag.financeLogin\" class=\"btn btn-info btn-xs\" ng-disabled=\"item.isFinance\"><i class=\"fa fa-upload\" aria-hidden=\"true\" data-toggle=\"modal\" data-target=\"#uploadDocModal\"></i></button></td><td><button ng-show=\"item.toBeSelected && managerLogin\" class=\"btn btn-info btn-xs\"><i class=\"fa fa-upload\" aria-hidden=\"true\" data-toggle=\"modal\" data-target=\"#uploadDocModal\"></i></button></td><td><button class=\"btn btn-xs btn btn-primary\" ng-disabled=\"!(item.toBeSelected) && !item.isFinance\" ng-click=\"saveCheckedMapDCParent(item, null, \'updateBtn\')\" title=\"Update DC Details\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></button></td><td><button class=\"btn btn-xs btn btn-primary\" ng-disabled=\"item.isFinance\" ng-click=\"mappedDcAllPackgParent(item, true)\" title=\"Map this DC to all package\"><i class=\"fa fa-plus\"></i></button></td><td><button class=\"btn btn-xs btn btn-danger\" ng-disabled=\"item.isFinance\" ng-click=\"mappedDcAllPackgParent(item, false)\" title=\"Removed Mapped DC from all package\"><i class=\"fa fa-minus\"></i></button></td></tr></tbody></table></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'misReports\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading class=\"tab-heading tab{{$index}}\">MIS Reports ({{reportOnStatusDetailsCount}})</uib-tab-heading><table class=\"table table-hover\"><thead><tr><th>Client name</th><th>Order id</th><th>Corporate name</th><th>Service particulars</th><th>Date</th></tr></thead><tbody><tr ng-repeat=\"item in reportOnStatusDetails | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\"><td>{{item.patientName}}</td><td>{{item.orderID}}</td><td>{{item.corporateName}}</td><td>{{item.packageName}}</td><td>{{item.appointmentDateAndTime}}</td></tr></tbody></table><uib-pagination total-items=\"reportOnStatusDetailsCount\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></uib-tab></uib-tabset></div><div ng-show=\"tabtype === \'dcDashboardPendingAppts\' && apptOnStatusDetailsCount > 0\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading class=\"tab-heading tab{{$index}}\">Pending Appointments ({{apptOnStatusDetailsCount}})</uib-tab-heading><table class=\"table table-hover\"><thead><tr><th>Request Id</th><th>Client name</th><th>Corporate name</th><th>Product Details</th><th>Appt Date</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in apptOnStatusDetails | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\"><td>{{item.requestId}}</td><td>{{item.patientName}}</td><td>{{item.corporateName}}</td><td>{{item.productName}}</td><td>{{getDateObj(item.fullfillmentDate) | date:\"yyyy-MM-dd \'at\' h:mm a\"}}</td><td><a><confirm-appointment-modal request=\"{{item}}\" refresh=\"reloadAppointments(\'dcDashboard\')\"><i class=\"fa fa-check\" style=\"font-size: 30px\"></i></confirm-appointment-modal></a></td></tr></tbody></table><uib-pagination total-items=\"apptOnStatusDetailsCount\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'qcAppointments\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><span style=\"margin-left: 13px;\">count : {{totalItems}}</span><table class=\"table table-hover table-link\"><thead><tr><th>Customer name</th><th>Order id</th><th>EQuote Id</th><th>Appointment date</th><th>Quick actions</th></tr></thead><tbody><tr ng-repeat=\"item in appointmentsForQc | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\" ng-click=\"appointmentMethods.addRelatedAppointmentsTabForQc(item)\"><td>{{item.o_FirstName}}</td><td>{{item.id}}</td><td>{{item.o_UserId}}</td><td>{{item.formatDate}}</td><td><button class=\"btn btn-primary\" data-order=\"{{item.id}}\" title=\"Download reports in zip file\" ng-click=\"openZipFile(item.id, $event)\"><span class=\"glyphicon glyphicon-save\"></span></button></td></tr></tbody></table><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div><div ng-show=\"!tab1show\"><appt-qc-details appointment-detail=\"resData\"></appt-qc-details></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'ppAppointments\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><span style=\"margin-left: 13px;\">count : {{totalItems}}</span><table class=\"table table-hover table-link\"><thead><tr><th>Appointment id</th><th>Customer name / corporate name</th><th>Service particulars / Status</th><th>Date &amp; time</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"item in appointmentsForPp\"><td ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId, item.currentStatusId ,item.mappingId1)\">{{item.requestId}}</td><td ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId, item.currentStatusId ,item.mappingId1)\">{{item.additionalInformation.patientName}} <span class=\"smTxt\">{{item.additionalInformation.primaryEntityName}}</span></td><td ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId, item.currentStatusId ,item.mappingId1)\"><label style=\"background-color: #526e83; color: white; font-size: smaller;\" class=\"label label-info status-name\">{{item.currentStatus}}</label><div class=\"dnd-active\" ng-if=\"item.additionalInformation.additionals.DNDCustomer || item.additionalInformation.additionals.DND\"><img style=\"height: 20px; margin-top: 5px;\" src=\"/app/resources/icons/dnd.svg\" alt=\"\"></div><package-test-details-modal productid=\"item.additionalInformation.orderItemProductId\"><span class=\"smTxt\">{{item.additionalInformation.productName.replace(\"_\",\" \")}}</span></package-test-details-modal></td><td ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId, item.currentStatusId,item.mappingId1)\">{{compareDate(item.additionalInformation.appointmentDate)}} - {{formatTime(item.additionalInformation.appointmentDate)}}</td><td class=\"text-right\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a class=\"btn btn-primary\" id=\"actions\" uib-tooltip=\"Actions\" style=\"color: #101010;background-color: #dddddd;border-color: #dddddd;\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" style=\"background-color: #eeeeee;\" uib-dropdown-menu=\"\" aria-labelledby=\"actions\"><li ng-click=\"appointmentMethods.addAppointmentsTab(item.additionalInformation.patientName,item.requestId, item.currentStatusId,item.mappingId1)\"><a><i class=\"fa fa-eye\"></i> View</a></li><li ng-click=\"unapprovedPP(item)\" data-toggle=\"modal\" data-target=\"#QCApproveModal\" data-request=\"\' + id + \'\" class=\"resendMailModal link\"><a><i class=\"glyphicon glyphicon-ok text-success\"></i> QC Approve</a></li><li data-toggle=\"modal\" ng-click=\"unapprovedPP(item)\" data-target=\"#Raise_IAModal\" data-product=\"resData.requestHistory.additionalInformation.orderItemProductId\" data-request=\"id\" class=\"splitRequest link\"><a><i class=\"glyphicon glyphicon-bullhorn text-warning\"></i> Raise IA</a></li></ul></span></td><li ng-repeat=\"btnType in item.nextPossibleActions\"><a ng-show=\"btnType.action\" data-status=\"{{item.currentStatusId}}\" data-nextstatus=\"{{btnType.actionStatusId}}\" data-request=\"{{item.requestId}}\" data-date=\"{{item.additionalInformation.appointmentDate}}\" title=\"{{btnType.action}} Appointment\" data-seconddate=\"{{item.additionalInformation.secondAppointmentDate}}\" data-productid=\"{{item.additionalInformation.orderItemProductId}}\" ng-click=\"openModalUnapprovedPP(btnType.action, item.currentStatusId, btnType.actionStatusId,item.requestId,item.additionalInformation.appointmentDate)\"><i class=\"{{actionColors[btnType.action]}} {{statusTextColors[btnType.actionStatusId]}}\"></i> {{btnType.action}} Appointment</a></li></tr></tbody></table><uib-pagination total-items=\"totalItems\" items-per-page=\"itemsPerPage\" ng-change=\"getDataForNextpage(currentPage)\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div><div ng-show=\"!tab1show\"><div class=\"btn-group pull-right\" role=\"group\" aria-label=\"...\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a class=\"btn btn-primary btn-sm\" uib-tooltip=\"Actions\" style=\"color: #101010;background-color: #dddddd;border-color: #dddddd;\" id=\"actions\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i> Actions <span class=\"caret\"></span></a><ul class=\"dropdown-menu dropdown-menu-right\" style=\"background-color: #eeeeee;\" uib-dropdown-menu=\"\" aria-labelledby=\"actions\"><li data-toggle=\"modal\" ng-repeat=\"actions in res.nextPossibleActions\" data-productid=\"res.additionalInformation.orderItemProductId\" data-target=\"#{{actions.action}}Modal\" data-nextstatus=\"actions.actionStatusId\" data-status=\"res.statusHistory[0].statusId\" data-request=\"resId\" data-date=\"res.additionalInformation.appointmentDate\" data-seconddate=\"res.additionalInformation.secondAppointmentDate\" ng-click=\"openActionModal(actions.action,actions.actionStatusId,actions.actionStatusId,resId,actions.additionalInformation.appointmentDate,actions.additionalInformation.secondAppointmentDate,actions.additionalInformation.orderItemProductId, item)\" class=\"actionRequestModal link\"><a ng-if=\"res.nextPossibleActions && res.nextPossibleActions.length != 0\"><i class=\"{{actionColors[actions.action]}} {{statusTextColors[actions.actionStatusId]}}\"></i> {{actions.action}}</a></li></ul></span> <a class=\"btn btn-danger btn-sm\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault()\">Close</a></div><h4 style=\"font-size: 15px; margin-bottom: 20px;\"><span style=\"font-size: medium; color: #940b23; margin-top: 11px;\">Request Id :</span> <span style=\"color: #a7a7a7; font-size: small; text-decoration: initial; margin-left: 2px;\">{{id}}</span> | <button class=\"btn btn-info btn-xs\" ng-if=\"visitTypeData.isPaid\">Paid</button> <button class=\"btn btn-info btn-xs\" ng-if=\"!visitTypeData.isPaid\">Sponsored</button> <span style=\"color: black;font-size: inherit;\">{{res.additionalInformation.visitType}}</span> <span style=\"color: black;font-size: larger;\">of</span><package-test-details-modal productid=\"item.additionalInformation.orderItemProductId\">{{item.additionalInformation.productName.replace(\"_\",\" \")}}</package-test-details-modal></h4><div class=\"row\" ng-show=\"resData.statusHistory && resData.statusHistory.length > 0\"><div class=\"col-md-4\" style=\"padding-right:0;\"><appt-patient-detail appointment-detail=\"apptDetails\" visit-type=\"visitTypeData\" status-history=\"statusHistory\" patient-detail=\"patientDetails\" pharma-details=\"pharmaDetails\"></appt-patient-detail></div><div class=\"col-md-8\"><appt-status-history appointment-history=\"apptHistory\" pharma-details=\"pharmaDetails\" class=\"chat\"></appt-status-history></div></div></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'dcInvestigationMap\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><table class=\"table table-hover table-link\"><thead><tr><th>Serial no</th><th>Dc id</th><th>Dc name</th></tr></thead><tbody><tr ng-repeat=\"item in appointmentsDcInvestMap | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\"><td>{{$index + serial}}</td><td ng-click=\"btnDcDetailsParent(item.entityId,item.id)\">{{item.id}}</td><td ng-click=\"btnDcDetailsParent(item.entityId,item.id)\">{{item.entityName}}</td></tr></tbody></table><uib-pagination total-items=\"totalItems\" ng-click=\"nextDcList(currentPage)\" style=\"margin-left:13px\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'pharmaDashboard\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><span style=\"margin-left: 13px;\">count : {{totalItems}}</span><table class=\"table table-hover table-link\"><thead><tr><th>Request id</th><th>Customer name / Corporate name</th><th>Package</th><th>Status</th><th>Date &amp; time</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"item in appointmentsStatusFiltered | startFrom:(currentPage-1)*itemsPerPage | orderBy: \'-priorityId\' | limitTo:itemsPerPage\" ng-class=\"{0:\'\', 1:\'border-left border-success\', 2:\'border-left border-danger\'}[item.priorityId]\" ng-click=\"appointmentMethods.addAllAppointmentsTab(item.additionalInformation.patientName,item.requestId,item.currentStatusId)\"><td>{{item.requestId}}</td><td>{{item.additionalInformation.patientName}} <span class=\"smTxt\">{{item.additionalInformation.primaryEntityName}}</span></td><td><span class=\"smTxt\">{{item.additionalInformation.productName.replace(\"_\",\"\")}}</span></td><td><label style=\"background-color: #526e83; color: white; font-size: smaller;\" class=\"label label-info status-name\">{{item.currentStatus}}</label><div class=\"dnd-active\" ng-if=\"item.additionalInformation.additionals.DNDCustomer || item.additionalInformation.additionals.DND\"><img style=\"height: 20px; margin-top: 5px;\" src=\"/app/resources/icons/dnd.svg\" alt=\"\"></div></td><td>{{compareDate(item.additionalInformation.appointmentDate)}} - {{formatTime(item.additionalInformation.appointmentDate)}}</td><td><a class=\"btn btn-primary\" id=\"actions\" uib-dropdown-toggle=\"\"><i class=\"fa fa-eye\"></i> View</a></td></tr></tbody></table><uib-pagination total-items=\"totalItems\" ng-model=\"pagination.currentPage\" ng-change=\"changePage(pagination.currentPage)\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div><div ng-show=\"!tab1show\"><div class=\"clearfix\"><h4 style=\"font-size:16px;\"><label ng-show=\"resData.fitUnfit == 1\" class=\"label label-info\">Fit</label> <label ng-show=\"resData.fitUnfit == 2\" class=\"label label-info\">UnFit</label> <span ng-if=\"resData.requestHistory.additionalInformation.isPaid\">Paid</span> <span ng-if=\"!resData.requestHistory.additionalInformation.isPaid\">Sponsored</span> | {{resData.additionalInformation.productName}} (ID: {{resId}})</h4></div><div class=\"row\" ng-show=\"resData.statusHistory && resData.statusHistory.length > 0\"><div class=\"col-md-4\"><appt-patient-detail appointment-detail=\"apptDetails\" visit-type=\"visitTypeData\" status-history=\"statusHistory\" patient-detail=\"patientDetails\"></appt-patient-detail></div><div class=\"col-md-8\"><appt-status-history appointment-history=\"apptHistory\" class=\"chat\"></appt-status-history></div></div></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'communicationHistory\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"appointmentMethods.changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"appointmentMethods.removeAppointmentTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><span style=\"margin-left: 13px;\">count : {{totalItems}}</span><table class=\"table\"><thead><tr><th>Customer name<br>Reciever</th><th>Current status</th><th>Request Id</th><th>ApplicationNo</th><th>SMS/Email content</th><th>Date & time</th><th>Delivered/not-delivered</th></tr></thead><tbody><tr ng-repeat=\"item in communicationHist | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\"><td>{{item.name}}<br><span class=\"smTxt\">{{item.reciever}}</span></td><td>{{item.currentStatus}}</td><td>{{item.requestId}}</td><td>{{item.applicationNo}}</td><td><span ng-show=\"item.body ===\'\'\"><a href=\"{{downloadEmailBodyUrl + item.id}}\" target=\"_blank\"><button ng-click=\"\" title=\"Download Email\" class=\"btn btn-primary btn-xs\">Download email content</button></a></span> <span ng-show=\"item.body !==\'\'\" class=\"smTxt\">{{item.body}}</span></td><td style=\"width: 180px;\">{{getDateObj(item.communicationSentDate) | date:\"yyyy-MM-dd \'at\' h:mm a\"}}</td><td><span class=\"fa fa-check fa-2x text-success\" ng-show=\"{{item.isDelivered}}\" title=\"Mail/SMS Send Successfully\"></span> <span class=\"fa fa-times fa-2x text-danger\" ng-show=\"!{{item.isDelivered}}\" title=\"Failed to send Mail/SMS\"></span></td></tr></tbody></table><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></uib-tab></uib-tabset></div><div ng-if=\"tabtype == \'hospitalPackage\'\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading class=\"tab-heading tab{{$index}}\">{{tab.title}} ({{totalItems}})</uib-tab-heading><table class=\"table table-hover\"><thead><tr style=\"\"><th rowspan=\"2\" class=\"text-left Custom-Header\" style=\"background-color: #dae7e8;color:#000;\">Name</th><th rowspan=\"2\" class=\"text-left Custom-Header\" style=\"background-color: #dae7e8;color:#000;\">Start Date</th><th rowspan=\"2\" class=\"text-left Custom-Header\" style=\"background-color: #dae7e8;color:#000;\">Expiry Date</th><th rowspan=\"2\" class=\"text-left Custom-Header\" style=\"background-color: #dae7e8;color:#000;\">Type</th><th colspan=\"4\" class=\"text-center Custom-Header\" style=\"background-color: #dae7e8;color:#000;\">Room price</th><th rowspan=\"2\" style=\"background-color: #dae7e8;color:#000;\">Action</th></tr><tr><th class=\"text-right Custom-Header\" style=\"background-color: #dae7e8;color:#000;\">General</th><th class=\"text-right Custom-Header\" style=\"background-color: #dae7e8;color:#000;\">Private</th><th class=\"text-right Custom-Header\" style=\"background-color: #dae7e8;color:#000;\">Semi private</th><th class=\"text-right Custom-Header\" style=\"background-color: #dae7e8;color:#000;\">Deluxe</th></tr></thead><tbody><tr ng-repeat=\"item in hospitalPackageData | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\" ng-click=\"openUpdatePopup(item, isRoleForPackageUpdation)\" style=\"cursor:pointer;\"><td>{{item.package_Name}}</td><td>{{compareDateNew(item.package_Start_date)}}</td><td>{{compareDateNew(item.package_Expiry_date)}}</td><td class=\"\">{{item.packageType}}</td><td class=\"text-right\">{{item.general_Ward}}</td><td class=\"text-right\">{{item.private_Ward}}</td><td class=\"text-right\">{{item.semi_Private_Ward}}</td><td class=\"text-right\">{{item.deluxe_Other}}</td><td ng-if=\"item.isPendingForApproval === false && isRoleForPackageUpdation ===\'hospital\'\" class=\"text-right\"><button class=\"btn btn-primary btn-xs\">Edit <i class=\"fa fa-pencil\"></i></button></td><td ng-if=\"isRoleForPackageUpdation ===\'cms\'\" class=\"text-right\"><button class=\"btn btn-primary btn-xs\">View <i class=\"fa fa-view\"></i></button></td><td ng-if=\"item.isPendingForApproval === true && isRoleForPackageUpdation ===\'hospital\'\" style=\"color: red;\">Pending</td></tr></tbody></table><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></uib-tab></uib-tabset></div><div class=\"modal fade\" id=\"updateHospPackageModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Edit Package : {{editHospPackage.package_Name}}</h4></div><div class=\"modal-body\"><form class=\"form-horizontal\"><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"Name\">Name:</label><div class=\"col-sm-8\"><input ng-disabled=\"isRoleForPackageUpdation ===\'cms\'\" type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"editHospPackage.package_Name\"> <span style=\"color: red; font-size: small;\" ng-if=\"hospitalPackagesExistingData.package_Name\">{{hospitalPackagesExistingData.package_Name}}</span></div></div><div class=\"form-group\"><label for=\"first-name\" class=\"control-label col-sm-3\">Start date</label><div class=\"col-sm-8\"><div class=\"input-group\"><input style=\"max-width: 190px;\" type=\"date\" placeholder=\"Enter date\" class=\"form-control\" ng-disabled=\"isRoleForPackageUpdation ===\'cms\'\" ng-model=\"editHospPackage.package_Start_date\"><div style=\"color: red; font-size: small;\" ng-if=\"hospitalPackagesExistingData.package_Start_date\">{{compareDateNew(hospitalPackagesExistingData.package_Start_date)}}</div></div></div></div><div class=\"form-group\"><label for=\"first-name\" class=\"control-label col-sm-3\">Expiry date</label><div class=\"col-sm-8\"><div class=\"input-group\"><input style=\"max-width: 190px;\" type=\"date\" placeholder=\"Enter date\" class=\"form-control\" ng-disabled=\"isRoleForPackageUpdation ===\'cms\'\" ng-model=\"editHospPackage.package_Expiry_date\"><div style=\"color: red; font-size: small;\" ng-if=\"hospitalPackagesExistingData.package_Expiry_date\">{{compareDateNew(hospitalPackagesExistingData.package_Expiry_date)}}</div></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"general_Ward\">General ward price:</label><div class=\"col-sm-8\"><input ng-disabled=\"isRoleForPackageUpdation ===\'cms\'\" type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"editHospPackage.general_Ward\"> <span style=\"color: red; font-size: small;\" ng-if=\"hospitalPackagesExistingData.general_Ward\">{{hospitalPackagesExistingData.general_Ward}}</span></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"semi_Private_Ward\">Semi private ward price:</label><div class=\"col-sm-8\"><input ng-disabled=\"isRoleForPackageUpdation ===\'cms\'\" type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"editHospPackage.semi_Private_Ward\"> <span style=\"color: red; font-size: small;\" ng-if=\"hospitalPackagesExistingData.semi_Private_Ward\">{{hospitalPackagesExistingData.semi_Private_Ward}}</span></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"private_Ward\">Private ward price:</label><div class=\"col-sm-8\"><input ng-disabled=\"isRoleForPackageUpdation ===\'cms\'\" type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"editHospPackage.private_Ward\"> <span style=\"color: red; font-size: small;\" ng-if=\"hospitalPackagesExistingData.private_Ward\">{{hospitalPackagesExistingData.private_Ward}}</span></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"deluxe_Other\">Deluxe other price:</label><div class=\"col-sm-8\"><input ng-disabled=\"isRoleForPackageUpdation ===\'cms\'\" type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"editHospPackage.deluxe_Other\"> <span style=\"color: red; font-size: small;\" ng-if=\"hospitalPackagesExistingData.deluxe_Other\">{{hospitalPackagesExistingData.deluxe_Other}}</span></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"deluxe_Other\"><span ng-if=\"isRoleForPackageUpdation ===\'cms\'\">Attached file:</span> <span ng-if=\"isRoleForPackageUpdation ===\'hospital\'\">Attach files:</span></label><div class=\"col-md-8\"><input ng-hide=\"isRoleForPackageUpdation ===\'cms\'\" type=\"file\" name=\"otherfiles\" multiple=\"\" onchange=\"angular.element(this).scope().uploadImage(this)\" class=\"form-control\"><div ng-if=\"fileCollection.length ===0\" class=\"progress\" ng-repeat=\"item in filesUploadingArray\"><div ng-style=\"{width: dynamicWidth}\" class=\"progress-bar progress-bar-info progress-bar-striped customeCssForBar\" role=\"progressbar\">{{item.name}}</div></div><div class=\"label label-info\" ng-repeat=\"item in fileCollection\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 3px;color: black;background-color: floralwhite;\"><a ng-click=\"downloadAttachment(item.downloadURL)\">{{item.fileName}}</a> <a ng-hide=\"isRoleForPackageUpdation ===\'cms\'\" ng-click=\"removeFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i class=\"fa fa-close\"></i></a></div><div ng-if=\"editHospPackage.uploadedFiles.length>0\" class=\"label label-info\" ng-repeat=\"item in editHospPackage.uploadedFiles\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 3px;color: black;background-color: floralwhite;\"><a href=\"{{item.docPath}}\" target=\"_blank\">{{item.fileName}}</a></div><div ng-if=\"editHospPackage.uploadedFiles.length ===0\">no files</div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"deluxe_Other\">Remark:</label><div class=\"col-sm-8\"><div class=\"input-group\"><textarea ng-disabled=\"isRoleForPackageUpdation ===\'cms\'\" id=\"RemarkForHospPackage\" class=\"form-control\" style=\"margin: 0px; width: 570px;height: 40px;z-index: 2;position: relative;line-height: 20px;font-size: 14px;transition-duration: initial;transition-timing-function: initial;transition-property: none;background: transparent !important;\" placeholder=\"Enter remark\" ng-model=\"editHospPackage.remarks\" required=\"\">\n              </textarea></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"resetHospPackageData()\">Cancel</button> <button ng-if=\"isRoleForPackageUpdation ===\'hospital\'\" type=\"button\" class=\"btn btn-primary\" ng-click=\"updateHospPackage(editHospPackage)\" ng-disabled=\"(!editHospPackage.package_Name || !editHospPackage.remarks) || isFileUploading ===true\">Save</button> <button ng-if=\"isRoleForPackageUpdation ===\'cms\'\" style=\"background-color: darkcyan;\" ng-click=\"hospPackageExistingDetails(editHospPackage)\" type=\"button\" class=\"btn btn-primary\">Existing Details</button> <button ng-if=\"isRoleForPackageUpdation ===\'cms\'\" ng-click=\"hospPackageChangesRequestAction(editHospPackage, true)\" type=\"button\" class=\"btn btn-primary\">Approved</button> <button ng-if=\"isRoleForPackageUpdation ===\'cms\'\" ng-click=\"hospPackageChangesRequestAction(editHospPackage, false)\" type=\"button\" class=\"btn btn-danger\" ng-disabled=\"!editHospPackage.package_Name || !editHospPackage.remarks\">Denied</button></div></div></div></div><div class=\"modal fade\" id=\"approveOtp\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\"><h4>Confirm</h4><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-6\"><input class=\"form-control\" type=\"text\" ng-model=\"selectedPlannedPreauth.Otp\" placeholder=\"Enter OTP\"></div><div class=\"col-md-2\"><button class=\"btn btn-primary\" ng-click=\"downloadMethods.getOtpConfirmed(claimSearhByClaimIdResults.claimId)\">Submit</button></div><div class=\"col-md-2\"><button class=\"btn btn-info\" style=\"margin-left: -24px;\" ng-click=\"resendOTP(claimSearhByClaimIdResults.claimId)\">Resend OTP</button></div></div></div><br><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-12\" style=\"margin-top:10px\"><span ng-show=\"selectedPlannedPreauth.showOtpRemarks\" ng-class=\"selectedPlannedPreauth.showOtpRemarks==\'OTP Matched\'?\'label label-success\':\'label label-danger\'\">{{selectedPlannedPreauth.OtpRemarks}}</span></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn\" ng-click=\"clearOTPModal()\">Clear</button> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"updateModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Update</h4></div><div class=\"modal-body\"><h4>Are you sure ?</h4></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"UpdateDateRelatedMethods.updateAdvanceSearchDoaDod(claimSearhByClaimIdResults)\">Yes, save changes</button></div></div></div></div><message background=\"msg.background\" body=\"msg.body\" header=\"msg.header\" show=\"msg.show\"></message><div class=\"row\" ng-show=\"tabname ==\'Documents Pending\' && tab1show\"><div class=\"module col-md-1\"></div><span class=\"col-md-10\" style=\"margin-top: 5px\"><small>Please send documents on priority basis</small></span></div><div class=\"modal fade\" id=\"relatedInfoModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Related information</h4></div><div class=\"modal-body\"><div class=\"row\" ng-repeat=\"rd in relatedrequests track by $index\"><div class=\"col-md-1\"></div><div class=\"col-md-12\"><span style=\"color: #d21924;\">{{$index +1}}.</span> <strong style=\"color: #2f0a0c;\">{{rd.additionalInformation.productName}}</strong><div class=\"row\"><ul><li style=\"color: #515054; margin-left: 35px; padding-top: 6px; max-width: 500px;\">{{rd.currentStatus}}|{{compareDate(rd.fulfillmentDate)}} <span ng-show=\"rd.additionalInformation.providerName.length>0\">|{{rd.additionalInformation.providerName}}</span>| Request id: {{rd.requestId}}</li></ul></div></div></div><div ng-if=\"relatedrequests.length ===0\"><p style=\"color: #d21924;\">No related information found.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"PatientDetailsAdditionals\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Patient Details Additionals</h4></div><div class=\"modal-body\"><div class=\"row\" ng-repeat=\"(key, value) in patientAdditionals track by $index\"><div class=\"col-md-12\"><span>{{key}}</span> : <span><b>{{value}}</b></span></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"zivaInfoModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button> <button style=\"margin-right:240px;\" class=\"btn btn-xs btn-primary pull-right\" ng-click=\"downloadAllFiles()\">Download All Files</button><h4 class=\"modal-title\">Ziva Related Information</h4></div><div class=\"modal-body\"><div class=\"row\" style=\"margin-bottom: 10px;\"><div class=\"col-md-12\"><input style=\"width: 550px;\" type=\"text\" name=\"serachZiva\" class=\"form-control\" ng-change=\"serachZivaRequest(zivaSerachData.data)\" ng-model=\"zivaSerachData.data\" placeholder=\"Serach for ziva package...\"></div></div><div style=\"margin-bottom: 7px;\"><span style=\"margin-left: 325px;padding-bottom: 6px;\"><i class=\"customeCss\" style=\"margin-right: 5px;\"></i> indicate <strong>back date appointments</strong></span></div><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"x in relatedRequest\" is-open=\"x.isOpen\"><uib-accordion-heading><a style=\"color: #168cc9;\">{{x.header}}</a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': x.isOpen, \'glyphicon-chevron-right\': !x.isOpen}\"></i></uib-accordion-heading><div class=\"row\" ng-repeat=\"rd in x.data track by $index\"><div class=\"col-md-1\"></div><div class=\"col-md-12\" ng-if=\"rd.requestID > 0\"><span style=\"color: #d21924;\">{{$index +1}}.</span> <strong style=\"color: #2f0a0c;\">{{rd.pakcageName}}</strong><div class=\"row\"><ul><li ng-class=\"rd.isApplicable ? \'\' : \'customeCss\'\" style=\"margin-left: 35px; padding-top: 6px; max-width: 500px;\">{{rd.statusName}} | {{compareDate(rd.appointDateTime)}} <span ng-if=\"rd.requestID\">| Request id: <a ng-click=\"appointmentMethods.addAppointmentsTab(name,rd.requestID,currentStatusId,mappingId1)\">{{rd.requestID}}</a></span></li></ul><div style=\"margin-left: 75px;\" ng-repeat=\"c in rd.zivaCorrespondance\"><span ng-if=\"c.correspondenceJson\"><strong>SessionNote</strong>: {{c.correspondenceJson.sessionNote}}</span> <span ng-if=\"c.correspondenceJson\">| <strong>Recommendation</strong>: {{c.correspondenceJson.recommendation}}</span><br><span ng-if=\"c.correspondenceJson\"><strong>Comment</strong>: {{c.comments}}</span></div><br><label ng-if=\"rd.filesData.length >0\" style=\"margin-left: 30px;\">Files :-</label><div style=\"margin-left: 60px;max-width: 510px;\" ng-repeat=\"f in rd.filesData\"><a ng-click=\"downloadAttachment(f.downloadPath)\"><i class=\"fa fa-download\"></i> {{f.fileNmae}}</a></div></div></div></div><div ng-if=\"x.data && x.data.length === 0\">No data found in <strong>{{x.header.toLowerCase()}}</strong>.</div></div></uib-accordion></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"reportAnIssue\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"resetData()\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Report an Issue</h4></div><div class=\"modal-body\"><ng-form name=\"reportAnissueForm\" class=\"form-horizontal\"><div id=\"user-profile\" class=\"row\"><div class=\"col-md-12\"><div ng-if=\"isRadioButton\" style=\"margin-left: 155px; margin-bottom: 20px;\"></div><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Issue due to</label><div class=\"col-sm-8\"><div class=\"input-group\"><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-change=\"selectedActionModel(serverSearch.contractType)\" ng-model=\"serverSearch.contractType\" ng-options=\"option.value for option in MasterLookUpOptions track by option.id\"><option value=\"\">---Please select---</option></select></div></div></div><div ng-show=\"isOptionSelected\" class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Remark <span>*</span></label><div class=\"col-sm-8\"><div class=\"input-group\"><textarea id=\"datetimeFirst\" class=\"form-control\" style=\"margin: 0px; width: 312px; height: 140px; z-index: 2; position: relative; line-height: 20px; font-size: 14px; transition-duration: initial; transition-timing-function: initial; transition-property: none; background: transparent !important;\" placeholder=\"Enter remark\" ng-model=\"courierData.PANotUtilized\" required=\"\">\n                  </textarea></div></div></div></div></div><div class=\"form-group\"><label for=\"city\" class=\"control-label required-field col-sm-4\"></label><div class=\"col-sm-8\" style=\"left: 190px;\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"resetData()\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"reportAnissueForm.$invalid || !(serverSearch.contractType && serverSearch.contractType.id> 0)\" ng-click=\"saveCourierDetails(courierData, serverSearch.contractType, true)\">Save</button></div></div></ng-form></div></div></div></div><div class=\"modal fade\" id=\"rmQuestionModel\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Status Update</h4></div><div class=\"modal-body\"><ng-form name=\"rmQuestion\" class=\"form-horizontal\"><div class=\"row\" ng-repeat=\"item in lstQuestions track by $index\"><div class=\"col-md-12\"><div class=\"form-group\" ng-if=\"item.quesAnsType === \'radio\'\"><label for=\"questionText\" class=\"control-label required-field col-sm-6\">{{item.questionText}} <span style=\"color: red;\">*</span></label><div class=\"radio col-sm-6\"><div ng-repeat=\"radius in item.answersEntity track by $index\" style=\"display: inline;\"><label><input type=\"radio\" name=\"radius\" ng-click=\"handleRadioClick(radius , $index, item)\" ng-model=\"radioButtonSelection\" ng-checked=\"radius.checked\" value=\"{{radius.answerContent}}\">{{radius.answerContent}}</label></div></div></div><div class=\"form-group\" ng-if=\"item.isRemarkOpen\"><label for=\"remarks\" class=\"control-label required-field col-sm-6\">{{item.isRemarkOpenText}} <span style=\"color: red;\">*</span></label><div class=\"col-sm-6\"><textarea class=\"form-control\" rows=\"2\" ng-required=\"true\" ng-model=\"item.userInput\"></textarea></div></div></div></div><div class=\"form-group\"><label for=\"city\" class=\"control-label required-field col-sm-8\"></label><div class=\"col-sm-4\"><button style=\"margin-left: 46px;\" type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button ng-disabled=\"isSelectedValue || rmQuestion.$invalid\" type=\"button\" class=\"btn btn-primary\" ng-click=\"savermQuestion(radioButtonSelection)\">Save</button></div></div></ng-form></div></div></div></div><div class=\"modal fade\" id=\"AddCourierDetails\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Update Status</h4></div><div class=\"modal-body\"><ng-form name=\"courierdetailsForm\" class=\"form-horizontal\"><div id=\"user-profile\" class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Select type</label><div class=\"col-sm-8\"><div class=\"input-group\"><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-change=\"getCorporatePackages(serverSearch.contractType)\" ng-model=\"serverSearch.contractType\" ng-options=\"option.value for option in MasterLookUpOptions track by option.id\"><option value=\"\">---Please select---</option></select></div></div></div><div class=\"form-group\" ng-if=\"isSubmittedThroughCourier\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Tracking Number</label><div class=\"col-sm-8\"><div class=\"input-group\"><input maxlength=\"20\" style=\"width: 229px;\" id=\"trackingNumber\" type=\"text\" class=\"form-control\" placeholder=\"Enter tracking number\" ng-model=\"courierData.trackingNumber\" required=\"\"></div></div></div><div class=\"form-group\" ng-if=\"isHandDelivered\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Acknowledgement number</label><div class=\"col-sm-8\"><div class=\"input-group\"><input style=\"width: 229px;\" id=\"datetimeFirst\" type=\"text\" class=\"form-control\" placeholder=\"Enter acknowledgement number\" ng-model=\"courierData.trackingNumber\" required=\"\"></div></div></div><div class=\"form-group\" ng-if=\"isDodOpen\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\"><span ng-if=\"isStillInHospital\">Discharge date</span> <span ng-if=\"!isStillInHospital\">Submitted date</span></label><div class=\"col-sm-8\"><div class=\"input-group\"><input style=\"max-width: 190px;\" id=\"datetimeEnd\" readonly=\"\" type=\"text\" placeholder=\"Enter date\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" max=\"maxEndDate\" ng-model=\"courierData.date\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions1\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\" style=\"right: 138px;\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group\" ng-if=\"isPANotUtilized\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Remark <span>*</span></label><div class=\"col-sm-8\"><div class=\"input-group\"><textarea id=\"datetimeFirst\" maxlength=\"500\" class=\"form-control\" style=\"margin: 0px; width: 226px; height: 170px; z-index: 2; position: relative; line-height: 20px; font-size: 14px; transition-duration: initial; transition-timing-function: initial; transition-property: none; background: transparent !important;\" placeholder=\"Enter remark\" ng-model=\"courierData.hosp_PendingDocIssueRemarks\" required=\"\">\n                  </textarea></div></div></div></div></div><div class=\"form-group\"><label for=\"city\" class=\"control-label required-field col-sm-4\"></label><div class=\"col-sm-8\" style=\"left: 106px;\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"courierdetailsForm.$invalid || isHosp_PendingDocIssue\" ng-click=\"saveCourierDetails(courierData, serverSearch.contractType, false)\">Save</button></div></div><div class=\"row\"><div class=\"col-md-12\"><label>Note :</label><ul><li>If you have already submitted the documents to Medi Assist, provide the acknowledgement details by selecting status <b>Submitted through Courier/ Hand Delivered</b></li><li>In case your patient has not utilised cashless facility, update the status as <b>Preauth not utilized</b></li><li>In case your patient is still undergoing treatment at your hospital, please update the details by selecting status <b>Patient is still in Hospital</b></li></ul></div></div></ng-form></div></div></div></div><div class=\"modal fade\" id=\"dischargeData\" role=\"dialog\"><div class=\"modal-dialog modal-dialog-centered modal-md\"><div class=\"modal-content\"><div class=\"modal-header\"><button class=\"btn-default btn-xs close\" data-dismiss=\"modal\"><i class=\"fa fa-close\"></i></button><h4 class=\"modal-title\" id=\"modal-title\" style=\"text-align: center\">Discharge of <label>{{dischargeObj.patientName}}</label></h4></div><div class=\"modal-body\"><table class=\"table table-hover table-striped table-bordered\"><thead><tr><th>Claim Id</th><th>Claimed Amount</th><th>Approved Amount</th><th>Admission Date</th><th>Discharge Date</th></tr></thead><tbody><tr><td><label>{{dischargeObj.claimId}}</label></td><td><label><i class=\"fa fa-rupee\"></i> {{dischargeObj.claimedAmount}}</label></td><td><label><i class=\"fa fa-rupee\"></i> {{dischargeObj.approvedAmount}}</label></td><td><div class=\"input-group\"><input id=\"datetimeFirst\" placeholder=\"Select date from\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"dischargeObj.admitDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td><td><div class=\"input-group\"><input id=\"datetimeEnd\" readonly=\"\" placeholder=\"Select date to\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"dischargeObj.dischargeDate\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td></tr></tbody></table><hr><div class=\"row\" style=\"margin-left: 15px;font-size: 15px;text-align: center;\"><label>Disclaimer:</label><span style=\"font-size: 13px;\">Treatment and the cost of care is same as previous request. Do you want to continue ?</span></div><hr><div class=\"row text-center\" ng-if=\"!isQuickDischarge\"><button class=\"btn btn-sm btn-primary\" ng-click=\"confirmDischarge(true)\">Yes</button> <button class=\"btn btn-sm btn-secondary\" ng-click=\"confirmDischarge(false)\">No</button></div><div class=\"row\" ng-if=\"isQuickDischarge\"><h4 style=\"color: black; text-align: center\">Attach Final Bill & Discharge Summary</h4><div ngf-drop=\"uploadAllFiles(this)\" ngf-select=\"uploadAllFiles(this)\" ng-model=\"files\" class=\"drop-box\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*,application/pdf\" style=\"margin-left:100px;cursor: pointer;\">Drop pdfs or images here or click to upload</div><div class=\"row\"><div class=\"col-md-12\"><ul class=\"tagsList\" style=\"font-size: small;\"><li class=\"closeBtn\" ng-repeat=\"fac in fileArr track by $index\">{{fac.fileName}}<div id=\"{{fac.progressDivId}}\" class=\"progress\" ng-show=\"fac.progressBar >= 0 && fac.progressBar<100\"></div><a href=\"\" ng-show=\"fac.progressBar==100\" ng-click=\"removeAttachment($index)\"><i class=\"fa fa-close\"></i></a></li></ul></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-sm btn-secondary\" data-dismiss=\"modal\">Cancel</button> <button class=\"btn btn-sm btn-primary pull-right\" data-dismiss=\"modal\" ng-if=\"isQuickDischarge\" ng-click=\"dischargePatient()\">Submit</button></div></div></div></div>");
$templateCache.put("app/components/tpaConfiguration/updateClaimInfo.html","<style>\n  h3 {\n    color: #14bcc8;\n    font-size: 22px;\n    border-bottom: 2px solid #14bcc8;\n    margin: 20px 0;\n  }\n\n  .drop-box {\n    background: #F8F8F8;\n    border: 5px dashed #DDD;\n    width: 400px;\n    height: 90px;\n    text-align: center;\n    padding-top: 25px;\n    margin: 10px;\n    font-size: 11px;\n  }\n\n  .dragover {\n    border: 5px dashed blue;\n  }\n\n  form .progress {\n    line-height: 15px;\n  }\n\n  .progress {\n    display: inline-block;\n    width: 100px;\n    border: 3px groove #ccc;\n    overflow: initial;\n  }\n\n  .progress>div {\n    font-size: smaller;\n    background-color: blue;\n    width: 0%;\n  }\n\n</style><form name=\"frmUpdateClaimInfo\"><h3>Update Claim Details</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Claim No <span class=\"text-danger\" ng-show=\"frmUpdateClaimInfo.claimNo.$dirty && frmUpdateClaimInfo.claimNo.$invalid\">Invalid !</span></label> <input type=\"text\" class=\"form-control\" name=\"claimNo\" placeholder=\"Claim No\" ng-model=\"updateClaimInfo.claimNo\" ng-required=\"true\" readonly=\"\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Claimed Amount <span class=\"text-danger\" ng-show=\"frmUpdateClaimInfo.claimedAmount.$dirty && frmUpdateClaimInfo.claimedAmount.$invalid\">Invalid !</span></label> <input type=\"number\" name=\"claimedAmount\" min=\"1\" class=\"form-control\" placeholder=\"claimed amount\" ng-model=\"updateClaimInfo.claimedAmount\" ng-required=\"true\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>DOA <span class=\"text-danger\" ng-show=\"frmUpdateClaimInfo.dateOfAdmission.$dirty && frmUpdateClaimInfo.dateOfAdmission.$invalid\">Invalid !</span></label><div class=\"input-group\"><input name=\"dateOfAdmission\" id=\"datetimepicker\" placeholder=\"Select date of admission\" readonly=\"\" type=\"text\" class=\"form-control\" ng-change=\"dateOfAdmission(updateClaimInfo.dod, \'doa\')\" uib-datepicker-popup=\"{{format}}\" ng-model=\"updateClaimInfo.doa\" is-open=\"datePopup.doa\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDoa()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>DOD <span class=\"text-danger\" ng-show=\"frmUpdateClaimInfo.claimedAmount.$dirty && frmUpdateClaimInfo.claimedAmount.$invalid\">Invalid !</span></label><div class=\"input-group\"><input placeholder=\"Select date of discharge\" readonly=\"\" name=\"dod\" type=\"text\" id=\"dischargetimepicker\" class=\"form-control\" ng-change=\"dateOfAdmission(updateClaimInfo.doa, \'dod\')\" uib-datepicker-popup=\"{{format}}\" ng-model=\"updateClaimInfo.dod\" is-open=\"datePopup.dod\" datepicker-options=\"dateOptions1\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDod()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Approved Amount <span class=\"text-danger\" ng-show=\"frmUpdateClaimInfo.approvedAmount.$dirty && frmUpdateClaimInfo.approvedAmount.$invalid\">Invalid !</span></label> <input type=\"number\" name=\"approvedAmount\" min=\"0\" max=\"{{updateClaimInfo.claimedAmount}}\" class=\"form-control\" placeholder=\"approved amount\" ng-model=\"updateClaimInfo.approvedamount\" ng-required=\"updateClaimInfo.statusId==\'2\' || updateClaimInfo.statusId==\'4\'\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Status</label><select class=\"form-control\" name=\"clmStatus\" ng-model=\"updateClaimInfo.statusId\"><option value=\"2\">Pre-Auth Approved</option><option value=\"4\">Enhancement Approved</option><option value=\"5\">Information Required</option><option value=\"9\">Enhancement Denied</option></select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label>Remarks</label> <textarea name=\"txtRemarks\" class=\"form-control\" id=\"txtRemarks\" cols=\"20\" rows=\"2\" ng-model=\"updateClaimInfo.remarks\"></textarea></div></div></div><div class=\"row\"><div class=\"col-md-12\"><h4 style=\"color: black;\">Related attachments</h4><div ngf-drop=\"uploadAllFiles(this)\" ngf-select=\"uploadAllFiles(this)\" ng-model=\"files\" class=\"drop-box\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*,application/pdf\">Drop pdfs or images here or click to upload</div><div class=\"row\"><div class=\"col-md-12\"><ul class=\"tagsList\" style=\"font-size: small;\"><li class=\"closeBtn\" ng-repeat=\"fac in file track by $index\">{{fac.fileName}}<div id=\"{{fac.progressDivId}}\" class=\"progress\" ng-show=\"fac.progressBar >= 0 && fac.progressBar<100\"></div><a href=\"\" ng-show=\"fac.progressBar==100\" ng-click=\"RemoveEmail($index)\"><i class=\"fa fa-close\"></i></a></li></ul></div></div></div></div><div class=\"row\"><div class=\"col-md-6 pull-left\"><button type=\"button\" class=\"btn btn-danger\">Cancel</button></div><div class=\"col-md-6\"><button type=\"button\" class=\"btn btn-success pull-right\" ng-disabled=\"frmUpdateClaimInfo.$invalid\" ng-click=\"uploadFiles();\">Submit</button></div></div></form>");
$templateCache.put("app/components/templates/angularTabs.html","<div ng-if=\"!tabtype\" style=\"height:100px\"><uib-tabset><uib-tab ng-repeat=\"tab in tabs\" active=\"tab.active\" disable=\"tab.disabled\"><uib-tab-heading ng-click=\"changeIndex($index)\" class=\"tab-heading tab{{$index}}\"><i class=\"fa fa-close pull-right\" ng-click=\"removeTab($index); $event.preventDefault();\"></i> {{tab.title}}</uib-tab-heading><div ng-show=\"tab1show\"><table class=\"table table-hover table-link\" ng-if=\"tabname != \'Planned Requests\'\"><thead><tr><th class=\"patientName\">Patient name</th><th class=\"claimId\">TPA name</th><th class=\"claimedAmount text-right\">Claimed amount</th><th class=\"approvedAmount text-center\">Status</th><th class=\"approvedAmount text-right\">Approved amount</th><th class=\"dateOfAdmission text-right\">Admission date</th><th class=\"dateOfDischarge text-right\">Discharge date</th></tr></thead><tbody ng-if=\"tabname ===\'Other Claims\'\"><tr ng-repeat=\"item in preauthfilteredStatusFiltered | limitTo:itemsPerPage\" ng-click=\"addTab(item.id, item.id, item.patientName,item)\" ng-class=\"item.isFlagRed ? \'font-bold alert-warning\' : \'\'\"><td class=\"name\">{{item.patientName}}</td><td>{{item.tpaName}}</td><td class=\"text-right\">{{formatCurrency(item.claimedAmount)}}</td><td class=\"text-right\"><span class=\"label label-success\" ng-if=\"item.status===\'New Admission\'\">New Admission</span> <span class=\"label label-danger\" ng-if=\"item.status===\'Denied\'\">Denied</span> <span class=\"label label-default\" ng-if=\"item.statusId ===3\">Enhancement Raised</span> <span class=\"label label-info\" ng-if=\"item.status ===\'Pre-Auth Approved\'\">Pre-Auth Approved</span> <span class=\"label label-warning\" ng-if=\"item.status ===\'Information Required\'\">Information Required</span> <span class=\"label label-success\" ng-if=\"item.status ===\'Information Submitted\'\">Information Submitted</span> <span class=\"label label-success\" ng-if=\"item.status ===\'Enhancement Approved\'\">Enhancement Approved</span> <span class=\"label label-success\" ng-if=\"item.status ===\'Discharge Documents Submitted\'\">Discharge Documents Submitted</span></td><td class=\"text-right\">{{formatCurrency(item.approvedAmount)}}</td><td class=\"text-right\">{{item.dateOfAdmission}}</td><td class=\"text-right\">{{item.dateOfDischarge}}</td></tr></tbody></table><div style=\"margin-left: 330px;\"><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" ng-change=\"pageChanged(currentPage, true)\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></div><div ng-show=\"!tab1show\"><div id=\"{{key.claimId}}\"><div class=\"claimBox\" ng-if=\"!tabPlanned && !preClaim\"><div id=\"toprow\" class=\"downloadPart\"><table class=\"table table-striped\" style=\"margin-top:20px; background:#fff;\"><tbody><tr><td>Customer</td><td>TPA name</td><td>Claimed amount</td><td>Approved amount</td><td>DOA</td><td>DOD</td></tr><tr><td>{{claimNoData.patientName}}</td><td>{{claimNoData.tpaName}}</td><td>{{formatCurrency(claimNoData.claimedAmount)}}</td><td>{{formatCurrency(claimNoData.approvedAmount)}}</td><td>{{claimNoData.dateOfAdmission}}</td><td>{{claimNoData.dateOfDischarge}}</td></tr></tbody></table></div><div id=\"auditDetails\" ng-if=\"claimSearhByClaimIdResults.length >0\"><div ng-repeat=\"item in claimSearhByClaimIdResults\"><div class=\"chatBox user\" ng-if=\"item.submittedBy ===\'Hospital\'\"><div class=\"author\"><p class=\"dateTime\">{{compareDate(claimNoData.actionAt)}}<br><span>{{formatTime(claimNoData.actionAt)}}</span></p><h2>Hospital</h2></div><div class=\"chatContent\"><h5 class=\"chatStatus\">{{item.status }}</h5><p class=\"chat-content\">Claimed amount : {{formatCurrency(item.claimedAmount)}}</p><p ng-if=\"item.remarks\"><strong>Remark</strong> : {{item.remarks}}</p><div ng-if=\"item.documents && item.documents.length !==0\"><table class=\"table table-striped\"><tbody><tr ng-repeat=\"item1 in item.documents\"><td><a href=\"{{item1.docPath}}\" target=\"_blank\">{{item1.fileName}}</a></td></tr></tbody></table></div></div></div><div class=\"chatBox\" ng-if=\"item.submittedBy ===\'TPA\'\"><div class=\"author\"><p class=\"dateTime\">{{compareDate(item.createdDate)}}<br><span>{{formatTime(item.createdDate)}}</span></p><h2>TPA</h2></div><div class=\"chatContent\"><h5 class=\"chatStatus\">{{item.status }}</h5><p class=\"chat-content\">Approved amount : {{item.approvedAmount}}</p><p ng-if=\"item.remarks\"><strong>Remark</strong> : {{item.remarks}}</p><div ng-if=\"item.documents && item.documents.length !==0\"><table class=\"table table-striped\"><tbody><tr ng-repeat=\"item1 in item.documents\"><td><a href=\"{{item1.docPath}}\" target=\"_blank\">{{item1.fileName}}</a></td></tr></tbody></table></div><a id=\"downloadLetter\" ng-show=\"item.letterUrl && item.letterUrl !==\'\'\" class=\"btn chat-content btn-primary btn-sm download\" href=\"{{item.letterUrl}}\">Click here to download Pre-Auth Approved letter</a></div></div></div><div class=\"chatBox noUser\" ng-if=\"user.role !== \'CMS\' && statusData.status !==\'Discharge Documents Submitted\' && statusData.status !==\'Denied\'\" style=\"padding:10px\"><div class=\"chatcontent\"><h5 class=\"chatStatus\">Action</h5><div><button class=\"btn btn-warning\" ng-if=\"statusData.status===\'Information Required\'\" ng-click=\"openIrModal()\">Submit Missing Documents</button> <button type=\"button\" ng-if=\"statusData.status===\'Enhancement Approved\'|| statusData.status===\'Pre-Auth Approved\' || statusData.status ===\'Information Submitted\'\" class=\"btn btn-info\" ng-click=\"openEnhanceModal()\">Raise Enhancement</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"openDischargeModal()\">Submit Discharge Documents</button></div></div></div></div></div></div></div></uib-tab></uib-tabset><div class=\"modal fade\" id=\"enhanceModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4>Raise Enhancement</h4></div><div class=\"modal-body\"><div class=\"modal-body\" id=\"enhanceFormBody\" ng-show=\"!esubmitted\"><form name=\"enhancementForm\" novalidate=\"\"><small id=\"ePaApproved\" class=\"pull-right\">{{claimNoData.patientName}}</small><h4 style=\"margin-top: -20px;\">Previously approved amount: Rs. <span id=\"ePaApproved\">{{formatCurrency(statusData.approvedAmount)}}</span>/-</h4><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"enhance-amount\">Enhancement amount *</label> <input ng-disabled=\"btnSubmitflag\" type=\"text\" placeholder=\"Enter amount\" numbers-only=\"\" name=\"enhance-amount\" class=\"form-control\" ng-model=\"enhance.amount\" id=\"enhancedAmount\" required=\"\"></div><div class=\"col-md-6\"><label for=\"enhance-remarks\">Remark</label> <textarea ng-disabled=\"btnSubmitflag\" placeholder=\"Enter notes\" name=\"enhance-remarks\" class=\"form-control\" id=\"enhance-remarks\" cols=\"30\" ng-model=\"enhance.remarks\" rows=\"2\"></textarea></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"enhance-remarks\">Attachments *</label><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></fieldset><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button></div></div></div><hr><div class=\"row\"><div class=\"col-md-8\"></div><div class=\"col-md-4\"><a ng-hide=\"btnSubmitflag\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"submitEnhance()\" ng-disabled=\"enhancementForm.$invalid\">Enhance</a> <a ng-show=\"btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <a type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"btnSubmitflag\" ng-click=\"$parent.hideModal()\">Cancel</a></div></div></form></div></div></div></div></div><div class=\"modal fade\" id=\"dischargeModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4>Submit Final Discharge</h4></div><div><div class=\"modal-body\" id=\"finalDischargeBody\" ng-show=\"!dsubmitted\"><form name=\"dischargeSub\" novalidate=\"\"><input type=\"hidden\" value=\"\" name=\"claimId\" id=\"dClaimId\"> <input type=\"hidden\" value=\"{{hospId}}\" name=\"hospId\"> <input type=\"hidden\" value=\"{{user.userId}}\" name=\"updatedBy\"> <input type=\"hidden\" value=\"discharge\" name=\"ClaimAction\"><p class=\"bg-info\">Components mentioned below are optional.Breakup will help us process your discharge case faster.</p><div class=\"table-responsive\"><div class=\"table table-hover\"><div class=\"form-group pull-in clearfix\"><div class=\"col-md-6\"><label>Date Of Admission</label> <input name=\"doa\" id=\"datetimepickerDoa\" type=\"date\" class=\"form-control\" ng-model=\"discharge.doa\" required=\"\"></div><div class=\"col-md-6 pull-right\"><label>Date Of Discharge</label> <input name=\"dod\" id=\"datetimepicker1\" type=\"date\" class=\"form-control\" ng-model=\"discharge.dod\" required=\"\"></div></div><div><div class=\"form-group pull-in clearfix\"><div class=\"col-md-6\"><label>Room Rent Charges</label><a tooltip-placement=\"top\" uib-tooltip=\"Includes Room rent, ICU Charges, Nursing charges, Duty Doctor fee, Monitor charges\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.roomrent\" name=\"roomrent\" class=\"form-control\" placeholder=\"Enter Roomrent\" ng-required=\"true\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.roomrent.$dirty && dischargeForm.roomrent.$error.required\">Required</span></div><div class=\"col-md-6 pull-right\"><label>Diagnostic Charges</label><a tooltip-placement=\"top\" uib-tooltip=\"Includes charges from Bio Chemistry, Haematology, Microbiology, Neurology, Pathology, Radiology\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.investigation\" name=\"investigation\" class=\"form-control\" placeholder=\"Enter Investigation\" ng-required=\"true\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.investigation.$dirty && dischargeForm.investigation.$error.required\">Required</span></div></div><div class=\"form-group pull-in clearfix\"><div class=\"col-md-6\"><label>Professional Charges</label><a tooltip-placement=\"top\" uib-tooltip=\"Incudes Procedure charges, Surgeon charges, Anaesthetist charges, Visit charges, OT rent, OT equipment charges, OT Drugs & Consumables\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.consultation\" name=\"consultation\" class=\"form-control\" placeholder=\"Enter Consultation\" ng-required=\"true\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.consultation.$dirty && dischargeForm.consultation.$error.required\">Required</span></div><div class=\"col-md-6 pull-right\"><label>Pharmacy Charges</label><a tooltip-placement=\"top\" uib-tooltip=\"Includes Pharmacy charges and consumables\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.pharmacy\" name=\"pharmacy\" class=\"form-control\" placeholder=\"Enter Pharmacy\" ng-required=\"true\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.pharmacy.$dirty && dischargeForm.pharmacy.$error.required\">Required</span></div></div></div><div class=\"form-group pull-in clearfix\"><div class=\"col-md-6\"><label>Other Charges</label><a tooltip-placement=\"top\" uib-tooltip=\"Includes Implant charges, Non-Medical Expenses, other charges\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.others\" name=\"others\" class=\"form-control\" placeholder=\"Others\" ng-required=\"true\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.pharmacy.$dirty && dischargeForm.pharmacy.$error.required\">Required</span></div><div class=\"col-md-6 pull-right\"><label>Final Claimed Amount</label> <input ng-init=\"discharge.total=0\" ng-class=\"{\'border-warning\':(discharge.total <= 0 || discharge.total == null)}\" name=\"dischargeTotal\" class=\"form-control\" type=\"text\" ng-model=\"discharge.total\" readonly=\"\"> <span ng-show=\"(discharge.total <= 0 || discharge.total == null)\"><small><em>Final bill cannot be 0 . Please enter a value in any of above fields.</em></small></span></div></div></div></div><label for=\"enhance-remarks\">Notes for discharge (optional)</label> <textarea required=\"\" placeholder=\"Enter notes for discharge\" name=\"enhance-remarks\" ng-model=\"discharge.remarks\" class=\"form-control\" id=\"discharge-remarks\" cols=\"30\" rows=\"3\"></textarea><hr><h4>Attach Final Bill & Discharge Summary</h4><span><small>At least one file needs to be attached</small></span><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></fieldset><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button></div><hr><a ng-disabled=\"dischargeSub.$invalid\" ng-hide=\"isFlag.btnSubmitflag\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"isFlag.btnSubmitflag = true;submitDischarge()\">Submit</a> <a ng-show=\"isFlag.btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"isFlag.btnSubmitflag\" ng-click=\"$parent.hideModal()\">Cancel</button></form></div><div class=\"modal-body\" ng-show=\"dsubmitted\"><p ng-show=\"dsubsuccess\">Your discharge documents have been submitted successfully.</p><p ng-show=\"!dsubsuccess\">Something went wrong! Your discharge summary is not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"dsubmitted=false;modalRenderingMethods.close()\">Close</button></div></div></div></div></div><div class=\"modal fade\" id=\"submitMissing\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Submit Missing Documents</h4></div><div class=\"modal-body\" id=\"submitFormBody\" ng-show=\"!msubmitted\"><form id=\"missingForm\"><label for=\"enhance-remarks\">Remarks on missing documents</label> <textarea required=\"\" ng-model=\"enhance.comment\" name=\"enhance-remarks\" class=\"form-control\" id=\"enhance-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your comments regarding missing documents. Eg: Surgical details updated or Diagnosis details updated or Submitted missing scan bill etc.,\"></textarea><hr><h4>Attach missing documents</h4><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></fieldset><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button></div><hr><a ng-hide=\"isFlag.btnSubmitflag\" ng-disabled=\"!enhance.comment\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"submitIr()\">Submit</a> <a ng-show=\"isFlag.btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"isFlag.btnSubmitflag\">Cancel</button></form></div><div class=\"modal-body\" ng-show=\"msubmitted\"><p ng-show=\"msubsuccess\">Your missing documents have been submitted successfully.</p><p ng-show=\"!msubsuccess\">Something went wrong! Your missing documents are not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"msubmitted=false;modalRenderingMethods.close()\">Close</button></div></div></div></div></div>");
$templateCache.put("app/components/templates/billBreakup.html","<div class=\"\"><div class=\"table-responsive\" style=\"overflow-x: hidden;\"><div class=\"table table-hover\"><div class=\"row\" style=\"margin-left:5px\"><table class=\"table table-condensed\" style=\"margin:0;\"><tr><th class=\"claimId\" style=\"width:275px;\">Categories <span style=\"color: red; font-size: small\">*</span></th><th class=\"claimedAmount\" style=\"width:75px;\">Price <span style=\"color: red; font-size: small\">*</span></th><th class=\"claimedAmount\" style=\"width:15px;\">Action</th></tr><tr ng-repeat=\"item in availableBills track by $index\"><td><span style=\"margin-left:-10px\">{{$index+1}}</span> <input ng-disabled=\"item.isReadOnly\" style=\"margin-left: 8px; margin-top: -20px;\" type=\"text\" ng-model=\"item.hospitalBillDesc\" placeholder=\"Enter categorie name\" class=\"form-control\"></td><td><input type=\"text\" numbers-only=\"numbers-only\" ng-model=\"item.CLAIMED_AMOUNT\" placeholder=\"Enter price\" class=\"form-control\"></td><td><button class=\"btn btn-danger btn-sm\" ng-click=\"removeCategories(item)\">Remove</button></td></tr><tr><td colspan=\"2\"><button class=\"btn btn-info btn-sm pull-right\" ng-click=\"addMoreCategories(false)\" style=\"margin-top:10px;\"><span class=\"glyphicon glyphicon-plus-sign\"></span> Add More</button></td></tr></table><div class=\"col-md-12\" ng-if=\"isNewCategories\"><p ng-if=\"isDuplicate\" style=\"margin-left: 15px; color: red; font-size> small;\">Duplicate categories is not allowed.</p><div class=\"col-md-5\"><label for=\"roomName\">Categories name</label> <input type=\"text\" ng-maxlength=\"200\" placeholder=\"Enter categories name\" ng-model=\"dynamicFields.name\" class=\"form-control\"></div><div class=\"col-md-4\"><label for=\"roomCount\">Price</label> <input type=\"text\" numbers-only=\"numbers-only\" ng-maxlength=\"20\" placeholder=\"Enter price\" ng-model=\"dynamicFields.price\" class=\"form-control\"></div><div class=\"col-md-1\"><button ng-disabled=\"!dynamicFields.name ||!dynamicFields.price\" ng-click=\"addMoreCategories(true, dynamicFields)\" class=\"btn btn-primary\" style=\"margin-top: 23px;\"><span class=\"glyphicon glyphicon-plus-sign\"></span> Add</button></div><div class=\"col-md-1\"><button class=\"btn btn-default\" ng-click=\"closeButton()\" style=\"margin-top: 23px;\">Close</button></div><div class=\"col-md-1\"></div></div></div></div></div></div>");
$templateCache.put("app/components/templates/calendar.html","<style>\n    .vertical-centre {\n        display: inline-block;\n        vertical-align: middle;\n    }\n\n    .border-box {\n        box-sizing: border-box;\n        -moz-box-sizing: border-box;\n    }\n\n\n    .calendar {\n        float: left;\n        display: block;\n        background: white;\n        width: 300px;\n        border: solid 1px;\n        margin-bottom: 10px;\n    }\n\n    #span {\n        float: left;\n        width: 100%;\n        font-weight: bold;\n        text-transform: uppercase;\n        padding-left: @icon-width+@spacing;\n        margin-left: @icon-width*-1;\n        text-align: center;\n        padding-right: @icon-width;\n        color: inherit;\n    }\n\n    .header {\n        float: left;\n        width: 100%;\n        background: #2875c7;\n        height: 40px;\n        color: white;\n    }\n\n    .day {\n        float: left;\n        width: 14.28571429%;\n        box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        border-left: solid 1px #cccccc;\n        font-size: 0.75em;\n        text-align: center;\n        height: 30px;\n        line-height: 30px !important;\n        display: inline-block;\n        vertical-align: middle;\n        background: white;\n        cursor: pointer;\n    }\n\n    .week {\n        float: left;\n        width: 100%;\n        border-top: solid 1px #cccccc;\n    }\n\n    .today {\n        background: #E3F2FF;\n    }\n\n    /*.different-month {\n        color: #C0C0C0;\n    }*/\n\n    .selected {\n        background: #2875c7;\n        color: white;\n    }\n\n    .names > span {\n        color: black;\n        font-weight: bold;\n    }\n\n    fa-angle-right1 {\n        text-align: right;\n        margin-left: -40px;\n    }\n\n    .iconeCss {\n        float: left;\n        width: 40px;\n        font-size: 1.125em;\n        font-weight: bold;\n        position: relative;\n        box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        padding: 0 10px;\n        cursor: pointer;\n    }\n\n    .headerText {\n        float: left;\n        width: 100%;\n        font-weight: bold;\n        text-transform: uppercase;\n        box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        padding-left: 50px;\n        margin-left: -40px;\n        text-align: center;\n        padding-right: 40px;\n        color: inherit;\n    }\n</style><div class=\"header\"><i class=\"iconeCss fa fa-angle-left\" style=\"text-align: left; margin-top: 7px;\" ng-click=\"previous()\"></i> <span style=\"margin-top: 7px;\" class=\"headerText\">{{month.format(\"MMMM, YYYY\")}}</span> <i class=\"iconeCss fa fa-angle-right\" style=\"text-align: right; margin-left: -40px; margin-top: 7px;\" ng-click=\"next()\"></i></div><div>{{selectedDate | date:\'medium\'}}</div><div class=\"week names\"><span class=\"day\">Sunday</span> <span class=\"day\">Monday</span> <span class=\"day\">Tuesday</span> <span class=\"day\">Wednesday</span> <span class=\"day\">Thusday</span> <span class=\"day\">Friday</span> <span class=\"day\">Satarday</span></div><div class=\"week\" ng-repeat=\"week in weeks\"><span class=\"day\" style=\"height: 100px;\" ng-class=\"{ today: day.isToday, \'different-month\': !day.isCurrentMonth, selected: day.date.isSame(selected) }\" ng-click=\"select(day)\" ng-repeat=\"day in week.days\">{{day.number}}</span></div>");
$templateCache.put("app/components/templates/customeTypeaheadTemplate.html","<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+\'px\', left: position().left+\'px\'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\"><li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\"><div uib-typeahead-match=\"\" index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div></li></ul>");
$templateCache.put("app/components/templates/gMapAutocomplete.html","<style>\n  .display-flex {\n    display: flex!important;\n    padding: 5px 10px!important;\n  }\n  ul.mb-autocomplete{\n    overflow: hidden;\n  }\n  ul.mb-autocomplete li {\n    border-bottom: 1px solid grey;\n  }\n  /* ul.mb-autocomplete li:hover {\n    background-color: grey!important;\n  }\n  .active {\n    background-color: grey!important;\n  } */\n</style><input type=\"text\" class=\"form-control\" name=\"locationList\" placeholder=\"Enter a location\" ng-model=\"placeText\" autocomplete=\"off\" role=\"combobox\" uib-typeahead=\"place.description for place in getMatchingPlaces($viewValue)\" typeahead-wait-ms=\"500\" ,typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" ,=\"\" typeahead-on-select=\"getCoordinates($item, $model, $label)\" aria-label=\"Place Name\" typeahead-popup-template-url=\"place_list_template.html\"><script type=\"text/ng-template\" id=\"place_list_template.html\"><ul class=\"dropdown-menu mb-autocomplete\" ng-show=\"isOpen() && !moveInProgress\" style=\"width: 77.5%\" ng-style=\"{top: position().top+\'px\', left: position().left+\'px\'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\"> <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\"> <a class=\"display-flex\"> <div class=\"col-md-12 p-l-0 p-r-0\"> <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i> <span>{{match.model.structured_formatting.main_text}}</span><span style=\"font-size: 11px;color: black;\"> {{match.model.structured_formatting.secondary_text}}</span> </div> </a> </li> <div style=\"float:right;padding-right:5px;\"> <img src=\"/app/resources/images/powered_by_google_on_white.png\" height=\"12\"> </div> </ul></script>");
$templateCache.put("app/components/templates/listFilter.html","<div class=\"filter-container col-md-12\" style=\"padding:10px 10px 0\"><div style=\"margin-top:7px\" class=\"col-md-2 p-l-0\">Total Records : <b>{{totalItems}}</b></div><div class=\"col-md-5 p-l-0\" ng-class=\"{\'col-md-offset-3\':!statusList.length}\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" tabindex=\"-1\">{{form.searchType.shortName}}</button> <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" tabindex=\"-1\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul class=\"dropdown-menu\" role=\"menu\"><li><a ng-click=\"form.searchType=item;form.searchText=\'\';onChangeSearch()\" ng-repeat=\"item in searchType\">{{item.name}}</a></li></ul></div><input type=\"text\" class=\"form-control\" placeholder=\"Type to start searching\" ng-model=\"form.searchText\" ng-change=\"onChangeSearch()\" ng-model-options=\"{debounce: 500, blur: 250}\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"form.searchText=\'\';onChangeSearch()\"><i class=\"fa fa-close\"></i></button></span></div></div><div class=\"col-md-3 p-l-0\" ng-if=\"statusList.length\"><div class=\"input-group\"><span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\"><i class=\"fa fa-filter\"></i></button></span><select ng-model=\"form.status\" ng-change=\"onSelectChange(\'status\', form.status)\" class=\"form-control\"><option value=\"default\">All</option><option ng-repeat=\"value in statusList\" value=\"{{value}}\">{{value}}</option></select></div></div><div class=\"col-md-2 p-l-0 p-r-0\"><div class=\"input-group\"><span class=\"input-group-btn\"><button class=\"btn btn-default dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\"><i class=\"fa m-r-5\" ng-class=\"{\'fa-sort-alpha-desc\':pipeline.reverse,\'fa-sort-alpha-asc\':!pipeline.reverse}\"></i><span class=\"caret\"></span></button><ul class=\"dropdown-menu\" role=\"menu\"><li><a ng-click=\"pipeline.reverse=false\">Ascending</a></li><li><a ng-click=\"pipeline.reverse=true\">Descending</a></li></ul></span><select ng-model=\"form.sortValue\" ng-change=\"onSelectChange(\'sortBy\',form.sortValue)\" class=\"form-control\"><option value=\"default\">None</option><option value=\"requestId\">Request Id</option><option value=\"appointmentDate\">Date</option></select></div></div></div>");
$templateCache.put("app/components/templates/mbClaimTypeAhead.html","<style>\n    li.dropdown.dropdow-newCss.open {\n        position: static;\n        margin: 5px;\n    }\n\n        li.dropdown.dropdow-newCss.open .dropdown-menu {\n            width: 100%;\n            text-align: center;\n            left: 0;\n            right: 0;\n        }\n\n    li.dropdown.dropdow-newCss .dropdown-menu {\n        cursor: pointer;\n        padding: 10px;\n    }\n\n        li.dropdown.dropdow-newCss .dropdown-menu > li {\n            margin: 0px 0;\n            padding: 5px;\n            border-radius: 3px;\n        }\n\n            li.dropdown.dropdow-newCss .dropdown-menu > li:hover {\n                color: #fff;\n                background: #939393;\n            }\n</style><div class=\"dropdown\"><div class=\"row\"><div class=\"col-md-12 open\" style=\"max-width: 98%;\"><input type=\"text\" class=\"form-control input-xlarge\" ng-click=\"showHtml()\" ng-change=\"searchData(model)\" ng-model=\"model\" placeholder=\"{{prompt}}\"><div class=\"dropdown-menu\" style=\"left:16px; width:97%;\" ng-show=\"flag.isShowTypeahead\"><table class=\"table table-hover\" style=\"margin-top:-6px;\"><tr ng-repeat=\"item in itemsDummy | limitTo: 10\"><td width=\"200px\">{{item.package_Name}}</td><td><span ng-repeat=\"newPrice in item.newPriceObj track by $index\" style=\"display:inline-block; padding:0 20px;\"><label class=\"radio\"><input type=\"radio\" ng-click=\"checkService(item, newPrice, $index)\" ng-checked=\"newPrice.isSelected\"> {{newPrice.price}}</label></span></td><td><span ng-repeat=\"items in item.newPriceObj track by $index\" style=\"display:inline-block; padding:0;\"><span ng-show=\"items.isSelected\" style=\"color: green; font-size: small; font-style: normal;\">Added successfully</span></span></td></tr></table></div><div class=\"row dropdown-menu item\" style=\"left: 15px; width: 97%; margin-top: 5px;\" ng-show=\"flag.isShowAddPackage\"><p ng-show=\"flag.isSuccuess\" style=\"color: green; font-size: small; font-style: normal; margin-left: 16px; margin-top: 8px;\">Package added successfully!</p><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"procedure\">Treatment details *</label> <input name=\"procedureTreatment\" type=\"text\" class=\"form-control\" placeholder=\"Enter treatment details\" ng-model=\"form.name\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"procedure\">Amount *</label> <input name=\"procedureAmount\" numbers-only=\"numbers-only\" type=\"text\" class=\"form-control\" placeholder=\"Enter amount\" ng-model=\"form.amount\"></div></div><div class=\"col-md-2\"><div class=\"form-group\" style=\"margin-top: 22px; margin-left: -10px;\"><button ng-disabled=\"!form.amount || !form.name\" class=\"btn btn-primary\" ng-click=\"AddProcedure(form.name, form.amount)\">Add</button></div></div></div></div></div></div>");
$templateCache.put("app/components/templates/mbFileUpload.html","<style type=\"text/css\">\n	input[type=\"file\"]{\n	    position: absolute;\n	    top: 0;\n	    left: 0;\n	    z-index: 2;\n	    width: 100%;\n	    height: 100%;\n	    opacity: 0;\n	    cursor: pointer;\n	} \n	.upload-field {\n	    position: relative;\n	    cursor: pointer;\n	    width: 100%;\n	    height: 100%;\n	    line-height: 0px;\n	    padding: 12px 10px;\n	    border: 1px solid #203F53;\n	    border-radius: 5px;\n	}\n	.uploadDivClass{\n		width: 100%;\n		padding-left: 6%;\n		margin-top: 1%;\n		position: relative;\n	    cursor: pointer;\n	}\n</style><div class=\"row uploadDivClass\"><div class=\"col-md-10 upload-field\">{{ fileName }} <input type=\"file\" multiple=\"\" id=\"uploadFileInput\" name=\"uploadFileInput\" onchange=\"angular.element(this).scope().uploadFile(this.files, action);this.value=null;return false;\"></div></div>");
$templateCache.put("app/components/templates/mbNotification.html","<div ng-show=\"open\" role=\"alert\" id=\"d\" style=\"position: absolute; z-index:2; width:100%;\" class=\"alert active alert-danger alert-dismissible alertIn alertOut\"><div type=\"btn button\" class=\"close\" ng-click=\"mbClose()\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></div><span dynamic=\"text\">dsdsw</span></div>");
$templateCache.put("app/components/templates/mbtypeAhead.html","<style>\n    li.dropdown.dropdow-newCss.open {\n        position: static;\n        margin: 5px;\n    }\n\n        li.dropdown.dropdow-newCss.open .dropdown-menu {\n            width: 100%;\n            text-align: center;\n            left: 0;\n            right: 0;\n        }\n\n    li.dropdown.dropdow-newCss .dropdown-menu {\n        cursor: pointer;\n        padding: 10px;\n    }\n\n        li.dropdown.dropdow-newCss .dropdown-menu > li {\n            margin: 0px 0;\n            padding: 5px;\n            border-radius: 3px;\n        }\n\n            li.dropdown.dropdow-newCss .dropdown-menu > li:hover {\n                color: #fff;\n                background: #939393;\n            }\n</style><div class=\"dropdown\"><div class=\"row\"><div class=\"col-md-12 open\" style=\"max-width: 98%;\"><input type=\"text\" class=\"form-control input-xlarge\" ng-click=\"showHtml()\" ng-change=\"searchData(model)\" ng-model=\"model\" placeholder=\"{{prompt}}\"><div class=\"dropdown-menu\" style=\"left:16px; width:97%;\" ng-show=\"flag.isShowTypeahead\"><table class=\"table table-hover\" style=\"margin-top:-6px;\"><tr ng-repeat=\"item in itemsDummy | limitTo: 10\"><td width=\"200px\">{{item.package_Name}}</td><td><span ng-repeat=\"newPrice in item.newPriceObj track by $index\" style=\"display:inline-block; padding:0 20px;\"><label class=\"radio\"><input type=\"radio\" ng-click=\"checkService(item, newPrice, $index)\" ng-checked=\"newPrice.isSelected\"> {{newPrice.price}}</label></span></td><td><span ng-repeat=\"items in item.newPriceObj track by $index\" style=\"display:inline-block; padding:0;\"><span ng-show=\"items.isSelected\" style=\"color: green; font-size: small; font-style: normal;\">Added successfully</span></span></td></tr></table></div><div class=\"row dropdown-menu item\" style=\"left: 15px; width: 97%; margin-top: 5px;\" ng-show=\"flag.isShowAddPackage\"><p ng-show=\"flag.isSuccuess\" style=\"color: green; font-size: small; font-style: normal; margin-left: 16px; margin-top: 8px;\">Package added successfully!</p><p ng-show=\"flag.isDuplicate\" style=\"color: red; font-size: small; font-style: normal; margin-left: 16px; margin-top: 8px;\">Duplicate value is not allowed.</p><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"procedure\">Treatment details *</label> <input focus-me=\"{{focusFlag.shouldBeOpen}}\" name=\"procedureName\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Enter treatment details\" ng-click=\"getkeywords()\" ng-model=\"form.name\" uib-typeahead=\"item.hospitaL_CHARGE_HEAD for item in autofillValue | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"procedure\">Amount *</label> <input name=\"procedureAmount\" numbers-only=\"numbers-only\" type=\"text\" class=\"form-control\" placeholder=\"Enter amount\" ng-model=\"form.amount\"></div></div><div class=\"col-md-2\"><div class=\"form-group\" style=\"margin-top: 22px; margin-left: -10px;\"><button ng-disabled=\"!form.amount || !form.name\" class=\"btn btn-primary\" ng-click=\"AddProcedure(form.name, form.amount)\">Add</button></div></div></div></div></div></div>");
$templateCache.put("app/components/templates/mbtypeAheadGov.html","<style>\n    li.dropdown.dropdow-newCss.open {\n        position: static;\n        margin: 5px;\n    }\n\n        li.dropdown.dropdow-newCss.open .dropdown-menu {\n            width: 100%;\n            text-align: center;\n            left: 0;\n            right: 0;\n        }\n\n    li.dropdown.dropdow-newCss .dropdown-menu {\n        cursor: pointer;\n        padding: 10px;\n    }\n\n        li.dropdown.dropdow-newCss .dropdown-menu > li {\n            margin: 0px 0;\n            padding: 5px;\n            border-radius: 3px;\n        }\n\n            li.dropdown.dropdow-newCss .dropdown-menu > li:hover {\n                color: #fff;\n                background: #939393;\n            }\n</style><div class=\"dropdown\"><div class=\"row\"><div class=\"col-md-12 open\" style=\"max-width: 98%;\"><input type=\"text\" class=\"form-control input-xlarge\" ng-click=\"showHtml()\" ng-change=\"searchData(model)\" ng-model=\"model\" placeholder=\"{{prompt}}\"><div class=\"dropdown-menu\" style=\"left:16px; width:97%;\">{{itemsDummy.length}}<table class=\"table table-hover\" style=\"margin-top:-6px;\"><tr ng-repeat=\"item in itemsDummy | limitTo: 10\"><td width=\"200px\">{{item.packageName}}</td><td><span style=\"display:inline-block; padding:0 20px;\"><label class=\"radio\"><input type=\"radio\" ng-click=\"checkService(item, newPrice, $index)\" ng-checked=\"newPrice.isSelected\"> {{item.packageCost}}</label></span></td><td><span ng-repeat=\"items in item.newPriceObj track by $index\" style=\"display:inline-block; padding:0;\"><span ng-show=\"items.isSelected\" style=\"color: green; font-size: small; font-style: normal;\">Added successfully</span></span></td></tr></table></div></div></div></div>");
$templateCache.put("app/components/templates/packageTypeAhead.html","<style>\n  .addPackage {\n    width: 100%;\n    margin: 0 auto;\n    position: sticky;\n    bottom: -5px;\n    background: #fff;\n    z-index: 2;\n    border-top: solid grey 1px;\n    padding: 5px;\n    margin-top: -6px;\n  }\n\n  .highlight {\n    background-color: lightgray;\n  }  \n\n  li.dropdown.dropdow-newCss.open {\n      position: static;\n      margin: 5px;\n  }\n\n      li.dropdown.dropdow-newCss.open .dropdown-menu {\n          width: 100%;\n          text-align: center;\n          left: 0;\n          right: 0;\n      }\n\n  li.dropdown.dropdow-newCss .dropdown-menu {\n      cursor: pointer;\n      padding: 10px;\n  }\n\n      li.dropdown.dropdow-newCss .dropdown-menu > li {\n          margin: 0px 0;\n          padding: 5px;\n          border-radius: 3px;\n      }\n\n          li.dropdown.dropdow-newCss .dropdown-menu > li:hover {\n              color: #fff;\n              background: #939393;\n          }\n</style><div class=\"dropdown\"><div class=\"row\"><div class=\"col-md-12 open\" style=\"max-width: 98%;\"><input type=\"text\" class=\"form-control input-xlarge\" ng-click=\"showHtml()\" ng-change=\"searchData(model)\" ng-model=\"model\" placeholder=\"{{prompt}}\"><div class=\"dropdown-menu\" ng-if=\"flag.isShowTypeahead || flag.isShowAddPackage\" style=\"width: 95%;left:15px\"><div class=\"\" style=\"left:16px; width:97%;\" ng-if=\"flag.isShowTypeahead\"><span class=\"fa fa-close pull-right\" ng-click=\"close()\"></span><table class=\"table table-hover\" style=\"margin-top:-6px;\"><tr class=\"{{item.className}}\" ng-repeat=\"item in itemsDummy | limitTo: 10\"><td width=\"200px\" ng-if=\"item.newPriceObj && item.newPriceObj.length>0\">{{item.showPackageName?item.showPackageName:item.package_Name}}</td><td width=\"200px\" ng-if=\"!item.newPriceObj || (item.newPriceObj && item.newPriceObj.length==0 )\"><span ng-click=\"addManualChargeType(item)\">{{item.showPackageName?item.showPackageName:item.package_Name}}</span></td><td><span ng-repeat=\"newPrice in item.newPriceObj track by $index\" style=\"display:inline-block; padding:0 20px;\"><label class=\"radio\"><input type=\"radio\" ng-click=\"addPackageToBag(newPrice)\" ng-checked=\"newPrice.isSelected\"> {{newPrice.showName}}</label></span></td><td><span ng-repeat=\"items in item.newPriceObj track by $index\" style=\"display:inline-block; padding:0;\"><span ng-show=\"items.isSelected\" style=\"color: green; font-size: small; font-style: normal;\">Added successfully</span></span></td></tr></table></div><div class=\"row item addPackage\" ng-if=\"flag.isShowAddPackage\"><p ng-show=\"flag.isSuccuess\" style=\"color: green; font-size: small; font-style: normal; margin-left: 16px; margin-top: 8px;\">Package added successfully!</p><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"procedure\">Treatment type *</label> <input name=\"procedureTreatment\" type=\"text\" class=\"form-control\" placeholder=\"Enter treatment details\" ng-model=\"form.name\"></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label for=\"procedure\">Amount *</label> <input name=\"procedureAmount\" numbers-only=\"numbers-only\" type=\"text\" class=\"form-control\" placeholder=\"Enter amount\" ng-model=\"form.amount\" ng-blur=\"checkIfSamePackage()\"></div></div><div class=\"col-md-4\" ng-if=\"showWarning\"><label for=\"procedure\">Reason for not choosing from list *</label><input type=\"text\" class=\"form-control\" ng-model=\"form.reason\"></div><div class=\"col-md-2\"><div class=\"form-group\" style=\"margin-top: 22px; margin-left: -10px;\"><button ng-disabled=\"!form.amount || !form.name\" ng-if=\"!showWarning\" class=\"btn btn-primary\" ng-click=\"addManualPackage(form.name, form.amount)\">Add</button> <button ng-disabled=\"!form.amount || !form.name || !form.reason\" ng-if=\"showWarning\" class=\"btn btn-primary\" ng-click=\"addManualPackage(form.name, form.amount)\">Add</button> <button class=\"btn btn-danger\" ng-click=\"close()\">Close</button></div></div><div class=\"row\" style=\"margin-left:20px;color: red\" ng-if=\"showWarning\"><label>*Same Price Package is already available. Please check the above highlighted.</label></div></div></div></div></div></div>");
$templateCache.put("app/components/templates/plusNotifications.html","<style>\n    li.dropdown.dropdow-newCss.open {\n        position: static;\n        margin: 5px;\n    }\n\n        li.dropdown.dropdow-newCss.open .dropdown-menu {\n            width: 100%;\n            text-align: center;\n            left: 0;\n            right: 0;\n        }\n\n    li.dropdown.dropdow-newCss .dropdown-menu {\n        cursor: pointer;\n        padding: 10px;\n    }\n\n        li.dropdown.dropdow-newCss .dropdown-menu > li {\n            margin: 0px 0;\n            padding: 5px;\n            border-radius: 3px;\n        }\n\n            li.dropdown.dropdow-newCss .dropdown-menu > li:hover {\n                color: #fff;\n                background: #939393;\n            }\n</style><div class=\"dropdown\"><div class=\"row\"><div class=\"col-md-12 open\"><input type=\"text\" class=\"form-control input-xlarge\" ng-click=\"showHtml()\" ng-change=\"searchData(model)\" ng-model=\"model\" placeholder=\"{{prompt}}\"><div class=\"dropdown-menu\" style=\"left:16px; width:97%;\" ng-show=\"flag.isShowTypeahead\"><p style=\"font-size: small; margin-left: 15px; color: #a20404;\">Click outside to complete your package selection.</p><table class=\"table table-hover\" style=\"margin-top:-6px;\"><tr ng-repeat=\"item in itemsDummy | limitTo: 10\"><td width=\"200px\">{{item.package_Name}}</td><td><span ng-repeat=\"newPrice in item.newPriceObj track by $index\" style=\"display:inline-block; padding:0 20px;\"><label class=\"radio\"><input type=\"radio\" ng-click=\"checkService(item, newPrice, $index)\" ng-checked=\"newPrice.isSelected\"> {{newPrice.price}}</label></span></td><td><span ng-repeat=\"items in item.newPriceObj track by $index\" style=\"display:inline-block; padding:0;\"><span ng-show=\"items.isSelected\" style=\"color: green; font-size: small; font-style: normal;\">Added successfully</span></span></td></tr></table></div><div class=\"row dropdown-menu item\" style=\"left: 15px; width: 97%; margin-top: 5px;\" ng-show=\"flag.isShowAddPackage\"><p style=\"font-size: small; margin-left: 15px; color: #a20404;\">Click outside to complete your package selection.</p><p ng-show=\"flag.isSuccuess\" style=\"color: green; font-size: small; font-style: normal; margin-left: 16px; margin-top: 8px;\">Package added successfully!</p><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"procedure\">Treatment details *</label> <input name=\"procedureTreatment\" type=\"text\" class=\"form-control\" placeholder=\"Enter treatment details\" ng-model=\"form.name\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"procedure\">Amount *</label> <input name=\"procedureAmount\" numbers-only=\"numbers-only\" type=\"text\" class=\"form-control\" placeholder=\"Enter amount\" ng-model=\"form.amount\"></div></div><div class=\"col-md-2\"><div class=\"form-group\" style=\"margin-top: 22px; margin-left: -10px;\"><button ng-disabled=\"!form.amount || !form.name\" class=\"btn btn-primary\" ng-click=\"AddProcedure(form.name, form.amount)\">Add</button></div></div></div></div></div></div>");
$templateCache.put("app/components/tpaNewAdmission/newAdmissionForm.html","<div id=\"tabclaim-new\"><style type=\"text/css\">\n        .common-background {\n            background-color: #f5f5f5;\n            padding: 0 15px 12px 15px;\n            margin: 1px 0;\n        }\n\n        .error {\n            color: red;\n        }\n    </style><div class=\"panel panel-default\" id=\"new-claim-success\" ng-show=\"form.preauthSuccess\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\"><h4 class=\"chat-status text-center\">Your claim has been created successfully! details can be viewed from list of others claims.</h4></div></div><div class=\"col-md-2\"></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><button class=\"btn btn-default\" ng-click=\"preauthFormAction.closePreauthForm()\">Back to claims list</button></div><div class=\"col-md-2\"></div></div></div></div><div class=\"panel panel-default\" id=\"new-claim-fail\" ng-show=\"form.preauthError\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-1\"></div><div class=\"col-md-10\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\"><h4 class=\"chat-status text-center\">Oops! There seems to be a problem and your claim is not created.</h4><div style=\"margin-left: 50px;\"><p>Possible reasons could be :</p><ol><li>Invalid details entered</li><li>Invalid file formats or more number of files uploaded</li></ol></div><h4 class=\"chat-status text-center\">Please check the details, required files and create it again. Thank you.</h4></div></div><div class=\"col-md-1\"></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><button class=\"btn btn-default\" ng-click=\"preauthFormAction.closePreauthForm()\">Back to claims list</button></div><div class=\"col-md-2\"></div></div></div></div><div id=\"new-claim-form\" ng-show=\"!form.preauthSuccess && !form.preauthError\"><div class=\"panel panel-default\"><div class=\"row\" style=\"padding-left: 10px; padding-right: 10px;\"><div class=\"col-md-12\"><div id=\"myTabContentInner\"><div id=\"test1\"><div class=\"chat-content_wrap\"><span class=\"label label-danger\" ng-show=\"source==\'preClaim\'\">{{PreAuthForIRRemarks}}</span><hr><div class=\"row\"><div class=\"col-md-8 bg-info\" style=\"margin-top: -20px; left: 10px;\">Please enter one of the following: <span><b>or</b></span><b>MAID</b> <span><b>or</b></span> <b>Corporate name</b> and <b>Employee Id</b> <span><b>or</b></span> <b>Policy number</b> and <b>Insurer name</b></div><div class=\"col-md-4\"><div class=\"form-group\" style=\"background-color: #e55e6a; margin-top: -50px;\"><div style=\"font-size: larger;\" class=\"bg-info mandatory text-center\">All fields marked with * are mandatory</div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"insurername\">TPA name</label><select name=\"insurername\" class=\"form-control\" ng-change=\"changeTpa(form.tpaName)\" ng-model=\"form.tpaName\"><option value=\"\">--Select TPA Name--</option><option ng-repeat=\"obj in tpaList\">{{obj.tpaName}}</option></select></div><div class=\"col-md-2\"><label for=\"insurername\">TPA Configuration</label> <button type=\"button\" class=\"btn btn-md btn-primary\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Member search\" ng-click=\"addTpa()\">TPA Configuration</button></div></div><p ng-show=\"PreAuthForIR\"><label class=\"label label-danger\">Remarks:</label> <label class=\"label label-danger\">{{PreAuthForIRRemarks}}</label></p><div class=\"chat-content\"><ng-form id=\"myForm\" novalidate=\"\" name=\"signup_form\"><div class=\"row\" ng-if=\"showGovtPackages\"><div class=\"col-md-7\"><div class=\"checkbox form-group\"><label><input name=\"isGovtScheme\" type=\"checkbox\" ng-model=\"form.isgovtscheme\" ng-change=\"govtChecked()\"> Check this box if claim is an RSBY/MSBY</label></div><div class=\"checkbox form-group\"></div></div></div><div style=\"background-color: rgb(238, 238, 238); padding-left: 6px; padding-right: 4px; border-radius: 10px; padding-top: 5px; padding-bottom: 5px;\" ng-if=\"form.isgovtscheme\"><div class=\"row\" ng-if=\"form.isgovtscheme\"><div class=\"col-md-6\"><div><label>MSBY benef search</label><div class=\"col-md-12 input-group\"><input name=\"search\" type=\"text\" autocomplete=\"off\" class=\"form-control\" placeholder=\"click to search\" ng-model=\"form.MSBY\" readonly=\"\" ng-click=\"fastrackPreauthGovSeaarch(\'gov\')\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-md btn-primary\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Member search\" ng-click=\"fastrackPreauthGovSeaarch(\'gov\')\"><i class=\"test glyphicon glyphicon-search\"></i></button></span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"URNNum\">URN number</label> <input name=\"URNNum\" autocomplete=\"off\" numbers-only=\"numbers-only\" type=\"text\" class=\"form-control\" placeholder=\"Enter URN number\" ng-model=\"form.URNNum\" ng-minlength=\"17\" ng-maxlength=\"17\"></div><div class=\"error\" style=\"margin-top: -15px;\" ng-show=\"signup_form.URNNum.$invalid\"><small class=\"error\" ng-show=\"signup_form.URNNum.$invalid\">URN number should be minimum 17 digit.</small></div></div></div><div ng-if=\"isRsby\" class=\"row\" style=\"margin-top: 3px; margin-bottom: 6px;\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Select package type *</label></div></div><div class=\"col-md-3\"><div class=\"checkbox form-group\"><label><input id=\"basic\" type=\"radio\" name=\"title\" ng-model=\"govType\" value=\"B\" required=\"\" ng-click=\"changeGovtPolicyType(\'Basic\')\"> Basic</label></div><div class=\"checkbox form-group\"></div></div><div class=\"col-md-3\"><div class=\"checkbox form-group\"><label><input id=\"critical\" type=\"radio\" name=\"title\" ng-model=\"govType\" value=\"C\" required=\"\" ng-click=\"changeGovtPolicyType(\'Critical\')\"> Critical</label></div></div><small class=\"error\" ng-show=\"signup_form.title.$error.required\"></small></div><div class=\"row\" ng-if=\"form.isgovtscheme\"><div class=\"col-md-4 form-group\" ng-show=\"form.isgovtscheme\"><select name=\"reasonOnline\" ng-model=\"form.reasonOnline\" ng-change=\"govtSchemeMethods.changePackageField()\" class=\"form-control\" multiple=\"multiple\"><option value=\"chiperror\" selected=\"\">Chip Error</option><option value=\"fpnotmatching\">Finger print not matching</option><option value=\"approvalneeded\">Package needs approval</option><option value=\"others\">Unspecified/Others</option></select></div><div id=\"packageSelection\" class=\"col-md-8\"><div class=\"form-group col-md-6\" ng-if=\"showAutoPackages\"><label for=\"govtpackage\">Select a government package</label><typeahead items=\"govtPackageList\" prompt=\"Start typing package name (Enter minimum 3 characters)\" title=\"packageName\" subtitle=\"address\" subtitle2=\"packageCost\" module-flag=\"newadmission\"></typeahead></div><div class=\"col-md-4 form-group\" ng-show=\"showAutoPackages\"><label for=\"amount\">Package amount</label> <input name=\"packageAmount\" autocomplete=\"off\" id=\"autoPackageAmt\" class=\"form-control\" placeholder=\"Selected package amount\" type=\"text\" ng-model=\"form.packageAmount\" readonly=\"\"></div><div class=\"form-group col-md-6\" ng-show=\"!showAutoPackages\"><label for=\"govtpackage\">Enter the package name manually</label> <input ng-model=\"form.mPackageName\" type=\"text\" class=\"form-control\" placeholder=\"Enter the package name\"></div><div class=\"col-md-4 form-group\" ng-show=\"!showAutoPackages\"><label for=\"amount\">Enter the amount</label> <input class=\"form-control\" type=\"text\" ng-model=\"form.mPackageAmount\"></div><div class=\"col-md-2 form-group\"><br><br><button style=\"margin-top: -18px;\" id=\"packageAddBtn\" class=\"btn btn-success\" ng-click=\"govtSchemeMethods.addPackageButton()\">Add</button></div></div></div></div><div class=\"row\" ng-if=\"form.isgovtscheme && selectedPackages.length>0\"><table class=\"table table-responsive\"><thead><th>Package Name</th><th>Package Amount</th><th>Action</th></thead><tbody><tr ng-repeat=\"sel_package in selectedPackages\" ng-show=\"sel_package.id || sel_package.id==0\"><td>{{sel_package.name}}</td><td>{{sel_package.amount}}</td><td><a ng-click=\"govtSchemeMethods.removePackage(sel_package.id)\" class=\"btn btn-danger btn-xs\">{{sel_package.cappedAmount}}Remove</a></td></tr></tbody></table></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><input name=\"hospId\" id=\"formHospId\" type=\"hidden\"> <input type=\"hidden\" value=\"{{PreAuthForIR}}\" name=\"PreAuthForIR\" id=\"PreAuthForIR\"> <input type=\"hidden\" value=\"{{preAuthNo}}\" name=\"preAuthNo\" id=\"preAuthNo\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><input name=\"createdBy\" id=\"formCreatedBy\" type=\"hidden\"></div></div><input type=\"hidden\" name=\"packages\" id=\"packagesHolder\"> <input type=\"hidden\" name=\"packageAmnt\" id=\"packageAmountHolder\"> <input name=\"hospName\" id=\"formHospName\" type=\"hidden\"></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"patientFirstName\">Full name *</label><div><div class=\"col-md-12 input-group\"><input name=\"patientFirstName\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Search patient by MAID, Emp id or policy no\" ng-model=\"form.fullname\" required=\"\"> <span class=\"input-group-btn\" ng-if=\"isSearchButton\"><button type=\"button\" class=\"btn btn-md btn-primary\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Member search\" ng-click=\"fastrackPreauth(\'generic\')\"><i class=\"test glyphicon glyphicon-search\"></i></button></span></div></div><div class=\"error\" ng-show=\"signup_form.patientFirstName.$dirty && signup_form.patientFirstName.$invalid\"><small class=\"error\" ng-show=\"signup_form.patientFirstName.$error.required\">Your name is required.</small></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"contactNum\">Mobile number *</label> <input name=\"contactNum\" autocomplete=\"off\" type=\"text\" class=\"form-control\" ng-pattern=\"/^((7|8|9)).{9}$/\" ng-change=\"mobileValidation(form.mobile)\" numbers-only=\"numbers-only\" placeholder=\"Enter mobile number\" ng-model=\"form.mobile\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\"><div class=\"error\" ng-show=\"signup_form.contactNum.$error.pattern ||(signup_form.contactNum.$dirty && signup_form.contactNum.$invalid)\"><small class=\"error\" ng-show=\"signup_form.contactNum.$error.required\">Mobile number is required.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.pattern\">Mobile number is not valid.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.number\">Mobile number can contain only numbers.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.minlength\">Mobile number is required to be at least 10 characters.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.maxlength\">Mobile can\'t be longer than 10 characters.</small></div></div></div><div class=\"col-md-4\" ng-show=\"form.isgovtscheme\"><label for=\"memberDist\">Member district</label> <input name=\"memberDist\" autocomplete=\"off\" placeholder=\"Enter member district\" class=\"form-control\" type=\"text\" ng-model=\"form.memberDist\"></div></div><div class=\"row\" ng-show=\"form.isgovtscheme\"><div class=\"col-md-4 form-group\"><label for=\"memberGender\">Member gender</label><select name=\"memberGender\" ng-model=\"form.memberGender\" class=\"form-control\"><option value=\"\">Select Gender</option><option value=\"male\">Male</option><option value=\"female\">Female</option></select></div><div class=\"col-md-4 form-group\"><label for=\"memberAge\">Member Age</label> <input name=\"memberAge\" autocomplete=\"off\" placeholder=\"Enter member age\" class=\"form-control\" type=\"number\" ng-model=\"form.memberAge\"></div><div class=\"col-md-4 form-group\" ng-show=\"form.isgovtscheme\"><div class=\"form-group\"><label for=\"memberId\">Member Id *</label> <input name=\"memberId\" autocomplete=\"off\" type=\"number\" class=\"form-control\" placeholder=\"Enter your Member Id\" ng-model=\"form.memberId\"></div></div></div><div ng-show=\"!form.isgovtscheme\"><div class=\"form-group\"><div class=\"col-md-6 common-background\"><label for=\"policyno\">Policy number <span ng-show=\"!(form.maid.toString().length>0||(form.employer.length>0 && form.empid.length>0))\">*</span></label> <input type=\"text\" id=\"policyno\" name=\"policynumber\" class=\"form-control\" placeholder=\"Enter policy number\" ng-model=\"form.policyno\" ng-required=\"!(form.maid.toString().length>0||(form.employer.length>0 && form.empid.length>0))\"></div><div class=\"col-md-6 common-background\"><label for=\"insurername\">Insurer name</label><select name=\"insurername\" class=\"form-control\" ng-model=\"form.insurername\"><option value=\"\">--Select Insurer Name--</option><option ng-repeat=\"obj in insurerList | orderBy:\'insurerFullName\'\">{{obj.insurerFullName}}</option></select></div></div></div><div ng-show=\"!form.isgovtscheme\"><div class=\"form-group col-md-4 common-background\"><div><label for=\"employer\">Corporate name <span ng-show=\"!(form.maid.toString().length >0||form.policyno.length>0)\">*</span></label> <input name=\"employer\" autocomplete=\"off\" id=\"preauthemployer\" type=\"text\" class=\"form-control\" placeholder=\"Enter corporate name\" ng-model=\"form.employer\" ng-required=\"!(form.maid.toString().length >0||form.policyno.length>0)\"><div class=\"error\" ng-show=\"signup_form.employer.$dirty && signup_form.employer.$invalid\"><small class=\"error\" ng-show=\"signup_form.employer.$error.required\">Employer name is required.</small></div></div></div><div class=\"col-md-4 common-background\"><div><label for=\"empid\">Employee Id <span ng-show=\"!(form.maid.toString().length >0||form.policyno.length>0)\">*</span></label> <input name=\"empid\" autocomplete=\"off\" id=\"preauthempid\" type=\"text\" class=\"form-control\" placeholder=\"Enter employee ID\" ng-model=\"form.empid\" ng-required=\"!(form.maid.toString().length >0||form.policyno.length>0)\"><div class=\"error\" ng-show=\"signup_form.empid.$dirty && signup_form.empid.$invalid\"><small class=\"error\" ng-show=\"signup_form.empid.$error.required\">Employee Id is required.</small></div></div></div></div><div><div class=\"form-group col-md-4 common-background\" ng-if=\"!form.isgovtscheme && isShowMaid\"><div><label for=\"maid\">MAID <span ng-show=\"!(form.policyno.length>0||(form.employer.length>0 && form.empid.length>0))\">*</span></label> <input name=\"maid\" numbers-only=\"numbers-only\" autocomplete=\"off\" id=\"preauthmaid\" type=\"number\" min=\"0\" class=\"form-control\" placeholder=\"Enter MAID\" ng-model=\"form.maid\" ng-required=\"!(form.policyno.length>0||(form.employer.length>0 && form.empid.length>0))\"><div class=\"error\" ng-show=\"signup_form.maid.$dirty && signup_form.maid.$invalid\"><small class=\"error\" ng-show=\"signup_form.maid.$error.required\">MAID is required and should contain only numbers.</small> <small class=\"error\" ng-show=\"signup_form.maid.$error.number\">MAID can contain only numbers</small></div></div></div><div class=\"form-group col-md-4 common-background\" ng-if=\"!form.isgovtscheme && !isShowMaid\"><div><label for=\"patientUniqeId\">Patient unique id <span ng-show=\"!(form.policyno.length>0||(form.employer.length>0 && form.patientUniqeId.length>0))\">*</span></label> <input name=\"patientUniqeId\" autocomplete=\"off\" id=\"preauthmaid\" min=\"0\" class=\"form-control\" placeholder=\"Enter patient unique id\" ng-model=\"form.uniqueId\" ng-required=\"!(form.policyno.length>0||(form.employer.length>0 && form.patientUniqeId.length>0))\"><div class=\"error\" ng-show=\"signup_form.patientUniqeId.$dirty && signup_form.patientUniqeId.$invalid\"><small class=\"error\" ng-show=\"signup_form.patientUniqeId.$error.required\">MAID is required and should contain only numbers.</small> <small class=\"error\" ng-show=\"signup_form.patientUniqeId.$error.number\">MAID can contain only numbers</small></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"ipnumber\">In patient number</label> <input name=\"ipnumber\" autocomplete=\"off\" numbers-only=\"\" type=\"text\" class=\"form-control\" placeholder=\"Enter IP no. for faster search and reconciliation\" ng-model=\"form.ipnumber\"><div class=\"error\" ng-show=\"signup_form.ipnumber.$dirty && signup_form.ipnumber.$invalid\"><small class=\"error\" ng-show=\"signup_form.ipnumber.$error.number\">Inpatient number can contain only numbers</small></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"doa\">Date of admission *</label> <input name=\"doa\" ng-change=\"dateOfAdmission(form.dod, \'doa\')\" id=\"datetimepicker\" class=\"form-control\" type=\"date\" ng-model=\"form.doa\" required=\"\"><div class=\"error\" ng-show=\"signup_form.doa.$dirty && signup_form.doa.$invalid\"><small class=\"error\" ng-show=\"signup_form.doa.$error.required\">Tentative date of admission is required.</small> <small class=\"error\" ng-show=\"signup_form.doa.$error.datetimelocal\">Tentative date is Invalid.</small></div><div class=\"error\"><small class=\"error\" ng-show=\"isdoa\">Tentative date of admission does\'t seems to be valid.</small></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"dod\">Date of discharge *</label> <input name=\"dod\" ng-change=\"dateOfAdmission(form.doa, \'dod\')\" id=\"dischargetimepicker\" class=\"form-control\" type=\"date\" ng-model=\"form.dod\" required=\"\"><div class=\"error\" ng-show=\"signup_form.dod.$dirty && signup_form.dod.$invalid\"><small class=\"error\" ng-show=\"signup_form.dod.$error.required\">Tentative date of discharge is required.</small></div><div class=\"error\"><small class=\"error\" ng-show=\"isdod\">Tentative date of discharge does\'t seems to be valid.</small></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnosis *</label> <textarea name=\"diagnosis\" class=\"form-control\" placeholder=\"Enter diagnosis details\" ng-model=\"form.diagnosis\" required=\"\"></textarea><div class=\"error\" ng-show=\"signup_form.diagnosis.$dirty && signup_form.diagnosis.$invalid\"><small class=\"error\" ng-show=\"signup_form.diagnosis.$error.required\">Diagnosis details are required.</small></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"admissionType\">Admission type *</label><select name=\"admissionType\" id=\"admissiontype\" class=\"form-control\" ng-model=\"form.admissiontype\" required=\"\"><option value=\"\">Select Admission Type</option><option value=\"emergency\">Emergency</option><option value=\"planned\">Planned</option></select></div></div><div class=\"col-md-4\" ng-if=\"isTPA\"><div class=\"form-group\" ng-show=\"!form.isgovtscheme\"><label for=\"procedure\">Procedure *</label> <textarea name=\"procedure\" class=\"form-control\" placeholder=\"Enter procedure details\" ng-model=\"form.procedure\" required=\"\"></textarea><div class=\"error\" ng-show=\"signup_form.procedure.$dirty && signup_form.procedure.$invalid\"><small class=\"error\" ng-show=\"signup_form.procedure.$error.required\">Procedure details are required.</small></div></div></div></div><div class=\"row\" style=\"background-color: rgb(238, 238, 238); margin-left: -2px; margin-right: 1px; padding-top: 10px; margin-top: -10px; border-radius: 7px;\"><div class=\"col-md-8\"><label for=\"approxClaimedAmnt\">Select procedure *</label><mb-typeahead items=\"mappedpackages\" prompt=\"Start typing procedure name...\" ng-model=\"hospNewName\" removeitem=\"removeData\" selecteditems=\"selectedMappedpackages\" callback-fn=\"ctrlFn(arg)\"></mb-typeahead></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"approxClaimedAmnt\">Estimated amount *</label> <input name=\"approxClaimedAmnt\" readonly=\"\" autocomplete=\"off\" type=\"number\" class=\"form-control\" placeholder=\"Enter estimated amount\" ng-model=\"form.clmamount\" required=\"\"><div class=\"error\" ng-show=\"signup_form.approxClaimedAmnt.$dirty && signup_form.approxClaimedAmnt.$invalid\"><small class=\"error\" ng-show=\"signup_form.approxClaimedAmnt.$error.required\">Claimed amount is required and can contain only numbers.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.number\">Claimed amount can contain only numbers</small></div></div></div></div><div ng-if=\"selectedMappedpackages.length >0\" style=\"padding-left: 20px; background-color: rgb(245, 245, 245); padding-right: 20px; margin-top: 0px; /* border-radius: 10px; */ padding-bottom: 5px; margin-bottom: 5px;\"><p>Selected procedure</p><table class=\"table table-hover table-link\" ng-if=\"tabname != \'Planned Requests\'\"><thead><tr><th class=\"patientName text-center\">Name</th><th class=\"claimedAmount text-center\">Price</th><th class=\"claimedAmount text-center\">Action</th></tr></thead><tbody><tr tooltip-placement=\"top\" ng-repeat=\"item in selectedMappedpackages track by $index\"><td class=\"text-left\">{{item.package_Name}}</td><td class=\"text-center\"><span class=\"text-center\">{{item.general_Ward}}</span> <span class=\"text-center\">{{item.private_Ward}}</span> <span class=\"text-center\">{{item.semi_Private_Ward}}</span></td><td class=\"text-center\"><button class=\"btn btn-danger btn-xs\" ng-click=\"removePackageFromList(item)\">Remove</button></td></tr></tbody></table></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"docName\">Doctor name *</label> <input name=\"docName\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Start typing doctor namee\" required=\"\" ng-click=\"getkeywords()\" ng-model=\"form.docname\" uib-typeahead=\"condition.doctorName for condition in doctorDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"><div class=\"error\" ng-show=\"signup_form.docName.$dirty && signup_form.docName.$invalid\"><small class=\"error\" ng-show=\"signup_form.docName.$error.required\">Doctor name is required.</small></div></div></div><div class=\"col-md-6\"><div class=\"form-group\" ng-show=\"!form.isgovtscheme\"><label for=\"roomType\">Room type allocated *</label> <input name=\"roomType\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" required=\"\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Start typing room type allocated\" ng-click=\"getkeywords()\" ng-model=\"form.roomtype\" uib-typeahead=\"item.hospitalRoomType for item in roomsDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"><div class=\"error\" ng-show=\"signup_form.roomType.$dirty && signup_form.roomType.$invalid\"><small class=\"error\" ng-show=\"signup_form.roomType.$error.required\">Room type has to be mentioned.</small></div></div></div></div><div class=\"row\" ng-if=\"isEBill\"><div class=\"col-md-6\"><div class=\"form-group\" ng-show=\"!form.isgovtscheme\"><label for=\"uidno\">Unique hospital Id</label> <input name=\"uidno\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"form.uidno\"></div></div></div><div id=\"fileupload\"><p class=\"bg-danger\">Maximum file upload limit is 15 MB. <button class=\"btn btn-xs btn-primary pull-right\" ng-click=\"preauthFormAction.downloadPrefilledPreauthForm(\'preauthform\')\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR && !form.isgovtscheme) || (isdod ||isdoa)\">Download Pre-filled pre authorization form</button> <b>At least one of the documents listed below needs to be submitted.</b></p><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">Signed Pre authorization form</label> <input type=\"file\" name=\"preauth\" file-model=\"preAuthFile.file1\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">Id proof<a tooltip-placement=\"top\" uib-tooltip=\"Driving License, Voter ID card, Corporate Employee ID, Pan car, Passport\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a></label> <input type=\"file\" name=\"idproof\" file-model=\"preAuthFile.file2\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnostic reports<a tooltip-placement=\"top\" uib-tooltip=\"Bio Chemistry reports, Haematology reports, Microbiology reports, Neurology reports, Pathology reports, Radiology reports\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a></label> <input type=\"file\" name=\"investigations\" file-model=\"preAuthFile.file3\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">Other relevant documents</label> <input type=\"file\" name=\"otherfiles\" file-model=\"preAuthFile.file4\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add More Files</span></button></div></div></div></div><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></fieldset><div class=\"row\"><div class=\"col-sm-12\"><button type=\"submit\" class=\"btn btn-primary start pull-right\" id=\"newAdmissionButton\" style=\"margin-bottom: 25px;\" ng-click=\"source==\'preClaim\'?preClaimInfoRelatedMethods.submitPreClaimPreauthForm():preauthFormAction.submitPreauthForm()\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR && !form.isgovtscheme) || (isdod ||isdoa) || isProcessing\"><span>Submit New Admission</span></button></div></div></div></ng-form></div></div></div></div></div></div></div></div><div class=\"modal fade\" id=\"addTPA\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"removeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4>TPA Configuration</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\" id=\"new-claim-msg\" ng-if=\"isSuccess\"><div class=\"chat-content_wrap bg-primary\" style=\"background-color: white;\"><h4 class=\"chat-status text-center\" style=\"background-color: #299429; padding-top: 5px; padding-bottom: 5px; border-radius: 16px;\">{{isSuccessMsg}}</h4></div></div><div class=\"col-md-8\" id=\"new-claim-msg\" ng-if=\"isError\"><div class=\"chat-content_wrap bg-primary\" style=\"background-color: white;\"><h4 class=\"chat-status text-center\" style=\"background-color: #ea5656; padding-top: 5px; padding-bottom: 5px; border-radius: 16px;\">{{tpaErrorMsg}}</h4></div></div><div class=\"col-md-2\"></div></div><form name=\"tpaForm\" style=\"margin-top:-10px\"><p style=\"margin-bottom: -10px;\" class=\"pull-right\"><span style=\"color: red; font-size: small;\">*</span> <span style=\"font-size: 20px;\">Indicate required</span></p><h5 style=\"font-weight: bold;\">TPA DETAILS</h5><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label style=\"font-weight: 400;\">Name <span style=\"color: red; font-size: small;\">*</span></label><select name=\"insurername\" required=\"\" class=\"form-control\" ng-options=\"item as item.value for item in TPAListData track by item.id\" ng-model=\"tpaForm.name\"></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"TPAtpaHospId\" style=\"font-weight: 400;\">Hospital id related to TPA <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAtpaHospId\" type=\"text\" ng-maxlength=\"100\" required=\"\" class=\"form-control\" placeholder=\"Enter hospital id related to TPA\" ng-model=\"tpaForm.tpaHospId\"> <span ng-if=\"tpaForm.TPAName.$error.maxlength\" style=\"color: #f00\">Hospital id not morethen 100 characters.</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"TPAtpaMailId\" style=\"font-weight: 400;\">Email <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAtpaMailId\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter TPA mail address\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" ng-model=\"tpaForm.tpaMailId\"> <span ng-if=\"!tpaForm.TPAtpaMailId.$valid && tpaForm.TPAtpaMailId.$dirty\" style=\"color: #f00\">TPA email address not seems to be valid.</span></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><input name=\"TPAtpaHospId\" type=\"text\" readonly=\"\" class=\"form-control\" placeholder=\"TPA mail address\" ng-model=\"tpaForm.additionMails\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><input name=\"TPAmailIds\" type=\"text\" class=\"form-control\" placeholder=\"Enter mail id related to TPA\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" ng-model=\"tpaForm.tpamailsIds\"> <span ng-if=\"!tpaForm.TPAmailIds.$valid && tpaForm.TPAmailIds.$dirty\" style=\"color: #f00\">Email address not seems to be valid.</span></div></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!tpaForm.tpamailsIds || !tpaForm.TPAmailIds.$valid\" ng-click=\"addTpaMails(tpaForm.tpamailsIds)\">Add more emails</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"clearAll()\">Remove mails</button></div></div><hr style=\"margin-top: 0px; margin-bottom: 0px;\"><h5 style=\"font-weight: bold;\">HOSPITAL DETAILS</h5><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"TPAHospMailId\" style=\"font-weight: 400;\">Email <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAHospMailId\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter hospital mail address\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" ng-model=\"tpaForm.hospMailId\"> <span ng-if=\"!tpaForm.TPAHospMailId.$valid && tpaForm.TPAHospMailId.$dirty\" style=\"color: #f00\">Hospital email address not seems to be valid.</span></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"TPAHospPassword\" style=\"font-weight: 400;\">Password <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAHospPassword\" type=\"password\" required=\"\" autocomplete=\"new-password\" class=\"form-control\" placeholder=\"Enter hospital mailbox password\" ng-model=\"tpaForm.hospPassword\"></div></div></div><hr style=\"margin-top: 0px; margin-bottom: 0px;\"><h5 style=\"font-weight: bold;\">INCOMING MAIL SERVER</h5><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"TPAMailServerAddress\" style=\"font-weight: 400;\">Host name <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAMailServerAddress\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter InComing mail server address\" ng-model=\"tpaForm.mailServerAddress\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"TPAMailServerPort\" style=\"font-weight: 400;\">Port <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAMailServerPort\" numbers-only=\"numbers-only\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter inComing server port\" ng-model=\"tpaForm.mailServerPort\"></div></div></div><hr style=\"margin-top: 0px; margin-bottom: 0px;\"><h5 style=\"font-weight: bold;\">OUTGOING MAIL SERVER</h5><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"TPAoutGoingServerAddress\" style=\"font-weight: 400;\">Host name <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAoutGoingServerAddress\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter outGoing mail server port\" ng-model=\"tpaForm.outGoingServerAddress\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"TPAOutGoingServerPort\" style=\"font-weight: 400;\">Port <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAOutGoingServerPort\" numbers-only=\"numbers-only\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter outGoing server port\" ng-model=\"tpaForm.outGoingServerPort\"></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"tpaForm.$invalid\" ng-click=\"saveTpaDetails(tpaForm)\">Add</button> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"removeModal()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"newMSBYSearch\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><h4>{{fastrack.title}}</h4></div><div class=\"modal-body\"><div class=\"center-block\" ng-if=\"isGov\"><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioMaid\" ng-change=\"searchGov(\'URN\')\">URN</label></div><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioPolicy\" ng-change=\"searchGov(\'Epic\')\">Epic</label></div></div><form name=\"formUrn\" ng-show=\"isURN\"><div class=\"row form-group\"><div class=\"col-md-6\"><input ng-model=\"urn\" name=\"urn\" class=\"form-control\" type=\"text\" placeholder=\"URN number\" ng-required=\"true\"></div></div><div class=\"row form-group\"><div class=\"col-md-6\"><button ng-disabled=\"(!formUrn.urn.$dirty || formUrn.urn.$invalid)\" ng-click=\"getDetailsWithGov(urn,\'urn\')\" type=\"button\" class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-search\"></i> Search</button></div><div class=\"col-md-6\"></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><div class=\"form-group\" ng-show=\"govtBenefList.length >0\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"item in govtBenefList\"><td>{{item.memberName}}</td><td>{{item.relationValue}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackPopulateNewAdmissionGov(item)\">Select</button></td></tr></tbody></table></div></div></form><form name=\"formEpic\" ng-show=\"isEpic\"><div class=\"row form-group\"><div class=\"col-md-6\"><input ng-model=\"epic\" name=\"Epic\" class=\"form-control\" type=\"text\" placeholder=\"Epic number\" ng-required=\"true\"></div></div><div class=\"row form-group\"><div class=\"col-md-6\"><button ng-disabled=\"(!formEpic.Epic.$dirty || formEpic.Epic.$invalid)\" ng-click=\"getDetailsWithGov(epic,\'epic\')\" type=\"button\" class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-search\"></i> Search</button></div><div class=\"col-md-6\"></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><div class=\"form-group\" ng-show=\"govtBenefList.length >0\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"item in govtBenefList\"><td>{{item.memberName}}</td><td>{{item.relationValue}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackPopulateNewAdmissionGov(item)\">Select</button></td></tr></tbody></table></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn\" ng-click=\"clearfastrack()\" ng-show=\"radioFastTrack==\'radioMaid\'?true:false ||radioFastTrack==\'radioEmp\'?true:false||radioFastTrack==\'radioPolicy\'?true:false\"><i class=\"glyphicon glyphicon-trash\"></i> Clear</button> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"removeModal()\"><i class=\"glyphicon glyphicon-remove\"></i> Close</button></div></div></div></div><div class=\"modal fade\" id=\"newPreauthModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><h4>{{fastrack.title}}</h4></div><div class=\"modal-body\"><div class=\"center-block\"><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioMaid\" ng-change=\"clearfastrack()\">MAID</label></div><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioEmp\" ng-change=\"clearfastrack()\">{{fastrack.employerSearchTitle}}</label></div><div class=\"radio-inline\"><label><input ng-model=\"radioFastTrack\" type=\"radio\" name=\"optradio\" value=\"radioPolicy\" ng-change=\"clearfastrack()\">Policy No</label></div></div><form name=\"formMaid\" ng-show=\"radioFastTrack==\'radioMaid\'?true:false\"><div class=\"row form-group\" ng-show=\"radioFastTrack==\'radioMaid\'?true:false\"><div class=\"col-md-6\"><input ng-model=\"fastrack.maid\" name=\"maid\" class=\"form-control\" type=\"text\" placeholder=\"MAID\" ng-required=\"true\"></div><div class=\"col-md-6\"><input name=\"benefName\" autocomplete=\"off\" ng-model=\"fastrack.benefName\" class=\"form-control\" type=\"text\" placeholder=\"BenefName\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getDetailsWithMaid(fastrack.maid,fastrack.benefName) : \'\'\"></div></div><div class=\"row form-group\"><div class=\"col-md-6\"><button ng-show=\"fastrack.displaySubmit\" ng-disabled=\"(!formMaid.maid.$dirty || formMaid.maid.$invalid)||(!formMaid.benefName.$dirty || formMaid.benefName.$invalid)\" ng-click=\"getDetailsWithMaid(fastrack.maid,fastrack.benefName)\" type=\"button\" class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-search\"></i> Search</button></div><div class=\"col-md-6\"></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><p class=\"bg-danger\" ng-show=\"isECashLess\">{{eCashLessMessage}} <button class=\"btn-primary\" ng-click=\"reDirect(\'planned\')\">yes</button></p><div class=\"form-group\" ng-show=\"!fastrack.displaySubmit\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"relation in fastrack.relations\"><td>{{relation.name}}</td><td>{{relation.relationName}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackPopulateNewAdmission(fastrack.empMaid,relation.relationId,relation.name, relation)\">Select</button></td></tr></tbody></table></div></div></form><form name=\"formEmp\" ng-show=\"radioFastTrack==\'radioEmp\'?true:false\"><div class=\"row form-group\" ng-show=\"radioFastTrack==\'radioEmp\'?true:false\"><div class=\"col-md-4\"><input ng-model=\"fastrack.employeeId\" name=\"empid\" class=\"form-control\" type=\"text\" placeholder=\"Employee/Family No.\" ng-required=\"true\"></div><div class=\"col-md-4\" ng-show=\"fastrack.showCorpName\"><input ng-model=\"fastrack.corporateName\" name=\"compname\" class=\"form-control\" type=\"text\" placeholder=\"Company Name\" ng-required=\"true\"></div><div class=\"col-md-4\"><input ng-model=\"fastrack.BeneficiaryName\" name=\"benefname\" class=\"form-control\" type=\"text\" placeholder=\"BenefName\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getDetailsWithEmpId(fastrack.employeeId,fastrack.corporateName,fastrack.BeneficiaryName): \'\'\"></div></div><div class=\"row form-group\"><div class=\"col-md-6\"><button ng-show=\"fastrack.displaySubmit\" ng-disabled=\"formEmp.$invalid\" ng-click=\"getDetailsWithEmpId(fastrack.employeeId,fastrack.corporateName,fastrack.BeneficiaryName)\" type=\"button\" class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-search\"></i> Search</button></div><div class=\"col-md-6\"></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><p class=\"bg-danger\" ng-show=\"isECashLess\">{{eCashLessMessage}} <button class=\"btn-primary\" ng-click=\"reDirect(\'planned\')\">yes</button></p><div class=\"form-group\" ng-show=\"!fastrack.displaySubmit\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"relation in fastrack.relations\"><td>{{relation.name}}</td><td>{{relation.relationName}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackPopulateNewAdmission(fastrack.empMaid,relation.relationId,relation.name, relation)\">Select</button></td></tr></tbody></table></div></div></form><form name=\"formPolicy\" ng-show=\"radioFastTrack==\'radioPolicy\'?true:false\"><div class=\"row form-group\" ng-show=\"radioFastTrack==\'radioPolicy\'?true:false\"><div class=\"col-md-6\"><input ng-model=\"fastrack.PolicyNo\" class=\"form-control\" type=\"text\" placeholder=\"Policy No.\" ng-required=\"true\"></div><div class=\"col-md-6\"><input ng-model=\"fastrack.BeneficiaryName\" class=\"form-control\" type=\"text\" placeholder=\"BenefName\" ng-required=\"true\" ng-keyup=\"$event.keyCode == 13 ?getDetailsWithPolicy(fastrack.PolicyNo,fastrack.BeneficiaryName): \'\'\"></div></div><div class=\"row form-group\"><div class=\"col-md-6\"><button ng-click=\"getDetailsWithPolicy(fastrack.PolicyNo,fastrack.BeneficiaryName)\" ng-show=\"fastrack.displaySubmit\" ng-disabled=\"formPolicy.$invalid\" type=\"button\" class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-search\"></i> Search</button></div><div class=\"col-md-6\"></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><p class=\"bg-danger\" ng-show=\"isECashLess\">{{eCashLessMessage}} <button class=\"btn-primary\" ng-click=\"reDirect(\'planned\')\">yes</button></p><div class=\"form-group\" ng-show=\"!fastrack.displaySubmit\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"relation in fastrack.relations\"><td>{{relation.name}}</td><td>{{relation.relationName}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackPopulateNewAdmission(fastrack.empMaid,relation.relationId,relation.name, relation)\">Select</button></td></tr></tbody></table></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn\" ng-click=\"clearfastrack()\" ng-show=\"radioFastTrack==\'radioMaid\'?true:false ||radioFastTrack==\'radioEmp\'?true:false||radioFastTrack==\'radioPolicy\'?true:false\"><i class=\"glyphicon glyphicon-trash\"></i> Clear</button> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"removeModal()\"><i class=\"glyphicon glyphicon-remove\"></i> Close</button></div></div></div></div><message background=\"msg.background\" body=\"msg.body\" header=\"msg.header\" show=\"msg.show\"></message></div>");
$templateCache.put("app/components/typeAhead/typeAhead.html","<style>\n    li.dropdown.dropdow-newCss.open {\n        position: static;\n        margin: 5px;\n    }\n\n        li.dropdown.dropdow-newCss.open .dropdown-menu {\n            width: 100%;\n            text-align: center;\n            left: 0;\n            right: 0;\n        }\n\n    li.dropdown.dropdow-newCss .dropdown-menu {\n        cursor: pointer;\n        padding: 10px;\n    }\n\n        li.dropdown.dropdow-newCss .dropdown-menu > li {\n            margin: 0px 0;\n            padding: 5px;\n            border-radius: 3px;\n        }\n\n            li.dropdown.dropdow-newCss .dropdown-menu > li:hover {\n                color: #fff;\n                background: #939393;\n            }\n</style><div class=\"dropdown dropdow-newCss\"><input type=\"text\" class=\"form-control input-xlarge dropdown-toggle\" ng-model=\"model\" placeholder=\"{{prompt}}\" ng-keydown=\"selected=false\" data-toggle=\"dropdown\"><ul ng-hide=\"!model.length || selected\" class=\"dropdown-menu item\" style=\"cursor:pointer\" ng-class=\"{active:isCurrent($index)}\" ng-mouseenter=\"setCurrent($index)\"><li class=\"title\" ng-repeat=\"item in items | filter:model | limitTo: 10\" ng-click=\"typeaheadClick(item)\"><a>{{item[title]}}<span ng-if=\"item[subtitle]\">,</span> {{item[subtitle]}} <span ng-if=\"item[subtitle2]\">,</span> {{item[subtitle2]}} <span ng-if=\"item[itemId]\">-</span> {{item[itemId]}}</a></li></ul></div>");
$templateCache.put("app/modules/aarogyaClaims/aarogya.html","<div><div ng-show=\"aarogyaClaims && aarogyaClaims.length > 0\"><angular-tab datalist=\"aarogyaClaims\" tabname=\"\'Aarogya Scheme\'\"></angular-tab></div><div class=\"no-settled-claims\" ng-hide=\"aarogyaClaims && aarogyaClaims.length > 0\"><div class=\"bs-callout bs-callout-info\" style=\"color: #e03f4e;\"><h4>No Aarogya claims found.</h4><p ng-show=\"!searchResults\">This hospital doesn\'t seem to have any Aarogya claims.</p><p ng-show=\"searchResults\">We couldn\'t find a claim matching your search criteria. Could you please try with other search criteria</p></div></div></div>");
$templateCache.put("app/modules/activeHosp/activehosp.html","<style>\n    /*tr.Active{\n        background-color: lightgreen;\n    }*/\n    .table-responsive{\n        overflow: auto;\n        height: 800px;\n    }\n	i.red{\n      color: red;\n	  margin-left: 10px;\n    }\n    i.green{\n      color: green;\n	  margin-left: 10px;\n    }\n	input.hosp_notusing{\n		margin-top: 20px;\n		margin-left: 5px;\n	}\n	.checklabel{\n		font-size: 15px;\n	}\n	#branchfilter, #watchfilter{\n		margin-top: 35px;\n	}\n	.panel-heading{\n		height: 120px;\n	}\n    .round-box{\n        width: 200px;\n        height: 200px;\n        border-radius: 50%;\n        line-height: 200px;\n        background-color: rgb(100, 188, 223);\n        font-size: 65px;\n        font-family: fantasy;\n        margin: 0 auto;\n        color: white;\n    }\n\n    /* Custom Colored Panels */\n    .fa-5x{\n      font-size: 70px;\n    }\n    .huge {\n        font-size: 40px;\n    }\n    .panel-green {\n        border-color: #5cb85c;\n    }\n\n    .panel-green .panel-heading {\n        border-color: #5cb85c;\n        color: #fff;\n        background-color: #5cb85c;\n    }\n\n    .panel-green a {\n        color: #5cb85c;\n    }\n\n    .panel-green a:hover {\n        color: #3d8b3d;\n    }\n	.panel-green a {\n        color: #5cb85c;\n    }\n\n    .panel-green a:hover {\n        color: #3d8b3d;\n    }\n    .panel-red {\n        border-color: #d9534f;\n    }\n\n    .panel-red .panel-heading {\n        border-color: #d9534f;\n        color: #fff;\n        background-color: #d9534f;\n    }\n\n    .panel-red a {\n        color: #d9534f;\n    }\n\n    .panel-red a:hover {\n        color: #b52b27;\n    }\n</style><div class=\"row claims\" style=\"overflow-x: scroll\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"panel panel-primary\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-xs-3\"><i class=\"glyphicon glyphicon-tasks fa-5x\"></i><div><a class=\"btn btn-xs btn-info\" data-toggle=\"modal\" data-target=\"#searchHospModal\"><i class=\"fa fa-search fa-2x\"></i></a></div></div><div class=\"col-xs-9 text-right\"><div class=\"huge\">{{totalEnrolledHospitals}}</div><div>Total hospitals enrolled across India.</div></div></div></div></div></div><div class=\"col-md-3\"><div class=\"panel panel-red\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-xs-3\"><i class=\"glyphicon glyphicon-filter fa-5x\"></i></div><div class=\"col-xs-9\"><div class=\"huge\"><select name=\"watchfilter\" id=\"watchfilter\" class=\"form-control\" ng-model=\"stateSelected\" ng-change=\"getActiveHospReport(this.currentPage, \'\', stateSelected.id)\" ng-disabled=\"servicingTPABranch\" ng-options=\"modeOfReceipt.stateName for modeOfReceipt in states\"><option value=\"\">All states</option></select></div></div></div></div></div></div><div class=\"col-md-3\"><div class=\"panel panel-red\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-xs-3\"><i class=\"glyphicon glyphicon-filter fa-5x\"></i></div><div class=\"col-xs-9\"><div class=\"huge\"><select name=\"branchfilter\" id=\"branchfilter\" class=\"form-control\" ng-model=\"servicingTPABranch\" ng-change=\"getActiveHospReport(this.currentPage, servicingTPABranch)\" ng-disabled=\"stateSelected\"><option value=\"\">All branches</option><option value=\"Ahmedabad\">Ahmedabad</option><option value=\"Bangalore\">Bangalore</option><option value=\"Chennai\">Chennai</option><option value=\"Cochin\">Cochin</option><option value=\"Coimbatore\">Coimbatore</option><option value=\"Hyderabad\">Hyderabad</option><option value=\"Jamshedpur\">Jamshedpur</option><option value=\"Kolkata\">Kolkata</option><option value=\"Mumbai\">Mumbai</option><option value=\"Noida\">Noida</option><option value=\"Pune\">Pune</option></select></div></div></div></div></div></div><div class=\"col-md-3\" ng-hide=\"filteredHospitals == totalEnrolledHospitals\"><div class=\"panel panel-green\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-xs-3\"><i class=\"glyphicon glyphicon-ok fa-5x\"></i><div><a class=\"btn btn-xs btn-warning\" data-toggle=\"modal\" data-target=\"#searchHospModalSpecific\"><i class=\"fa fa-search fa-2x\"></i></a></div></div><div class=\"col-xs-9 text-right\"><div class=\"huge\">{{filteredHospitals}}</div><div>Total hospitals enrolled across {{servicingTPABranch || stateSelected.stateName}}.</div></div></div></div></div></div></div><pre ng-show=\"totalPgs > 0\" class=\"text-center\">Page: {{currentPage}} / {{totalPgs}}</pre><table class=\"table table-hover\"><thead><tr><th class=\"hid\">HID&nbsp;</th><th class=\"hname\">Hospital name&nbsp;</th><th class=\"haddress\">Hospital address</th><th class=\"user\">Hospital portal user info</th><th class=\"hphone\">Contact</th><th class=\"hcontacts\">Contact details</th></tr></thead><tbody><tr ng-repeat=\"hospital in createdHospitals\" class=\"{{hospital.hospStatus}}\"><td>{{hospital.hospId}}</td><td>{{hospital.hospName}}</td><td>{{hospital.hospAddress}}, {{hospital.cityName}}, {{hospital.districtName}}, {{hospital.stateName}}, {{hospital.pinCode}}</td><td><p><strong>User name:</strong>{{hospital.userName}}</p><p><strong>User id:</strong>{{hospital.loginName}}</p><p><strong>User email:</strong>{{hospital.userEmail}}</p><p><strong>Loggedin once:</strong><i class=\"glyphicon glyphicon-{{showImg(hospital.hospLoggedIn)}}\"></i></p></td><td><p><strong>Phone:</strong>{{hospital.landLineNumber}}</p><p><strong>Fax:</strong>{{hospital.faxNumber}}</p><p><strong>Email:</strong>{{hospital.emailAddress}}</p></td><td><p><strong>Primary contact:</strong>{{hospital.primaryContact}}</p><p><strong>Contact number:</strong>{{hospital.primaryContactNumber}}</p><p><strong>Contact email:</strong>{{hospital.primaryContactEmail}}</p></td><td><p><strong>Secondary contact:</strong>{{hospital.secondaryContact}}</p><p><strong>Contact number:</strong>{{hospital.secondaryContactNumber}}</p><p><strong>Contact email:</strong>{{hospital.secondaryContactEmail}}</p></td></tr></tbody></table></div><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\" ng-change=\"getActiveHospReport(this.currentPage, servicingTPABranch, stateSelected.id)\" style=\"margin-left: 35%\"></uib-pagination><div class=\"modal fade\" id=\"searchHospModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\" style=\"padding:0 15px;\"><a ng-click=\"destroySearchData()\"><span class=\"pull-right\" data-dismiss=\"modal\"><b>X</b></span></a><h4>Search hospital across India<span ng-show=\"hospSearchResults\">: Results {{hospSearchResultsCount}}</span></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-10\"><div class=\"col-md-3\" style=\"padding-left:0\"><input type=\"text\" class=\"form-control\" placeholder=\"HID\" ng-model=\"hospSearchID\"></div><div class=\"col-md-1\">OR</div><div class=\"col-md-8\"><input type=\"text\" class=\"form-control\" placeholder=\"Hospital Name\" ng-model=\"hospSearchName\"></div></div><div class=\"col-md-2\"><input type=\"button\" class=\"form-control btn btn-xs btn-primary\" value=\"Search\" ng-disabled=\"!hospSearchID && !hospSearchName\" ng-click=\"searchHosp()\"></div></div><div class=\"form-group\" style=\"margin-top: 20px\"><div ng-show=\"hospSearchResults.length > 0\" style=\"overflow: scroll; height: 350px\"><table class=\"table table-hover\"><thead><tr><th class=\"hid\">HID&nbsp;</th><th class=\"hname\">Hospital name&nbsp;</th><th class=\"haddress\">Hospital address</th><th class=\"user\">Hospital portal user info</th><th class=\"hphone\">Contact</th><th class=\"hcontacts\">Contact details</th></tr></thead><tbody><tr ng-repeat=\"hospital in hospSearchResults\" class=\"{{hospital.hospStatus}}\"><td>{{hospital.hospId}}</td><td>{{hospital.hospName}}</td><td>{{hospital.hospAddress}}, {{hospital.cityName}}, {{hospital.districtName}}, {{hospital.stateName}}, {{hospital.pinCode}}</td><td><p><strong>User Name:</strong>{{hospital.userName}}</p><p><strong>User id:</strong>{{hospital.loginName}}</p><p><strong>User email:</strong>{{hospital.userEmail}}</p><p><strong>Loggedin once:</strong><i class=\"glyphicon glyphicon-{{showImg(hospital.hospLoggedIn)}}\"></i></p></td><td><p><strong>Phone:</strong>{{hospital.landLineNumber}}</p><p><strong>Fax:</strong>{{hospital.faxNumber}}</p><p><strong>Email:</strong>{{hospital.emailAddress}}</p></td><td><p><strong>Primary contact:</strong>{{hospital.primaryContact}}</p><p><strong>Contact number:</strong>{{hospital.primaryContactNumber}}</p><p><strong>Contact email:</strong>{{hospital.primaryContactEmail}}</p></td><td><p><strong>Secondary contact:</strong>{{hospital.secondaryContact}}</p><p><strong>Contact number:</strong>{{hospital.secondaryContactNumber}}</p><p><strong>Contact email:</strong>{{hospital.secondaryContactEmail}}</p></td></tr></tbody></table></div><div ng-show=\"hospSearchResults.length == 0\"><label class=\"alert-danger form-control\">No hospital with {{hospSearchID}} {{hospSearchName}}</label></div></div></div><div class=\"modal-footer\"><a href=\"\" class=\"btn btn-sm btn-default\" ng-click=\"destroySearchData()\"><span class=\"pull-right\">Clear</span></a> <a href=\"\" class=\"btn btn-sm btn-danger\" data-dismiss=\"modal\" ng-click=\"destroySearchData()\"><span class=\"pull-right\">Close</span></a></div></div></div></div><div class=\"modal fade\" id=\"searchHospModalSpecific\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\" style=\"padding:0 15px;\"><a href=\"\" ng-click=\"destroySearchData()\"><span class=\"pull-right\" data-dismiss=\"modal\"><b>X</b></span></a><h4>Search hospital in {{servicingTPABranch || stateSelected.stateName}}<span ng-show=\"hospSearchResults\">: Results {{hospSearchResultsCount}}</span></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-10\"><div class=\"col-md-3\" style=\"padding-left:0\"><input type=\"text\" class=\"form-control\" placeholder=\"HID\" ng-model=\"hospSearchID\"></div><div class=\"col-md-1\">OR</div><div class=\"col-md-8\"><input type=\"text\" class=\"form-control\" placeholder=\"Hospital Name\" ng-model=\"hospSearchName\"></div></div><div class=\"col-md-2\"><input type=\"button\" class=\"form-control btn btn-xs btn-primary\" value=\"Search\" ng-disabled=\"!hospSearchID && !hospSearchName\" ng-click=\"searchHosp(servicingTPABranch, stateSelected.id)\"></div></div><div class=\"form-group\" style=\"margin-top: 20px\"><div ng-show=\"hospSearchResults.length > 0\" style=\"overflow: scroll; height: 350px\"><table class=\"table table-hover\"><thead><tr><th class=\"hid\">HID&nbsp;</th><th class=\"hname\">Hospital Name&nbsp;</th><th class=\"haddress\">Hospital address</th><th class=\"user\">Hospital portal user info</th><th class=\"hphone\">Contact</th><th class=\"hcontacts\">Contact details</th></tr></thead><tbody><tr ng-repeat=\"hospital in hospSearchResults\" class=\"{{hospital.hospStatus}}\"><td>{{hospital.hospId}}</td><td>{{hospital.hospName}}</td><td>{{hospital.hospAddress}}, {{hospital.cityName}}, {{hospital.districtName}}, {{hospital.stateName}}, {{hospital.pinCode}}</td><td><p><strong>User name:</strong>{{hospital.userName}}</p><p><strong>User id:</strong>{{hospital.loginName}}</p><p><strong>User email:</strong>{{hospital.userEmail}}</p><p><strong>Loggedin once:</strong><i class=\"glyphicon glyphicon-{{showImg(hospital.hospLoggedIn)}}\"></i></p></td><td><p><strong>Phone:</strong>{{hospital.landLineNumber}}</p><p><strong>Fax:</strong>{{hospital.faxNumber}}</p><p><strong>Email:</strong>{{hospital.emailAddress}}</p></td><td><p><strong>Primary contact:</strong>{{hospital.primaryContact}}</p><p><strong>Contact number:</strong>{{hospital.primaryContactNumber}}</p><p><strong>Contact email:</strong>{{hospital.primaryContactEmail}}</p></td><td><p><strong>Secondary contact:</strong>{{hospital.secondaryContact}}</p><p><strong>Contact number:</strong>{{hospital.secondaryContactNumber}}</p><p><strong>Contact email:</strong>{{hospital.secondaryContactEmail}}</p></td></tr></tbody></table></div><div ng-show=\"hospSearchResults.length == 0\"><label class=\"alert-danger form-control\">No hospital with {{hospSearchID}} {{hospSearchName}}</label></div></div></div><div class=\"modal-footer\"><a href=\"\" class=\"btn btn-sm btn-default\" ng-click=\"destroySearchData()\"><span class=\"pull-right\">Clear</span></a> <a href=\"\" class=\"btn btn-sm btn-danger\" data-dismiss=\"modal\" ng-click=\"destroySearchData()\"><span class=\"pull-right\">Close</span></a></div></div></div></div>");
$templateCache.put("app/modules/advanceSearch/advanceSearch.html","<div class=\"tab-pane\"><p ng-show=\"searchby === \'PatientName\'\"></p><div ng-show=\"claimSearchResults.length > 0\"><div ng-show=\"(tpaName && tpaName.id==MaTPAId) || !tpaName\"><angular-tab list=\"alternativeData\" datalist=\"claimSearchResults\" tabname=\"\'Search Results\'\"></angular-tab></div><div ng-show=\"tpaName && tpaName.id!=MaTPAId\"><angular-tabs list=\"alternativeData\" datalist=\"claimSearchResults\" tabname=\"\'Active Claims\'\"></angular-tabs></div></div><div ng-show=\"!claimSearchResults.length && searchBegin\" class=\"text-center\" style=\"font-weight: 600;\">No details found</div></div>");
$templateCache.put("app/modules/appointmentSearch/appointmentSearch.html","<div><style>\n        .btn-reload {\n            float: right;\n            margin-top: -33px;\n            margin-left: 1px;\n        }\n\n        .input-xs {\n            height: 22px;\n            line-height: 22px;\n            padding: 0 5px;\n        }\n    </style><div class=\"row\" style=\"margin-bottom:10px\"><div class=\"col-md-3 p-r-0\"><div class=\"dropdown\"><button class=\"dropdown btn btn-primary btn-block dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" id=\"search-button\">{{dispayInDdl}}<span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a href=\"\" ng-model=\"reqId\" ng-click=\"getOrderType(\'reqId\')\">Request id</a></li><li><a href=\"\" ng-model=\"empId\" ng-click=\"getOrderType(\'empId\')\">Employee id</a></li><li><a href=\"\" ng-model=\"emailId\" ng-click=\"getOrderType(\'email\')\">Email</a></li><li><a href=\"\" ng-model=\"contactNo\" ng-click=\"getOrderType(\'contact\')\">Contact no.</a></li><li><a href=\"\" ng-model=\"name\" ng-click=\"getOrderType(\'name\')\">Name</a></li></ul></div></div><div class=\"col-md-4 p-l-0\"><form name=\"frmOrder\" action=\"\" class=\"form\" ng-show=\"selectedOrderType.length>0\"><div class=\"input-group\"><input type=\"date\" class=\"form-control datepicker\" placeholder=\"Enter Date\" ng-model=\"orderSearch\" ng-enter=\"\" ng-show=\"selectedOrderType == \'date\'\"> <input type=\"text\" ng-show=\"selectedOrderType != \'date\'\" class=\"form-control force-form-control\" placeholder=\"Enter {{dispayInDdl}}\" ng-model=\"searchSource\" ng-enter=\"searchAppointments(searchSource)\" required=\"\"> <span class=\"input-group-btn\"><input id=\"search-button\" type=\"button\" class=\"btn btn-primary\" value=\"Search\" ng-click=\"searchAppointments(searchSource)\" ng-disabled=\"frmOrder.$invalid\"></span></div></form></div></div><angular-tab appointmentlist=\"activeAppointments\" tabname=\"\'Active Appointments\'\" tabtype=\"\'appointmentSearch\'\"></angular-tab><div ng-hide=\"activeAppointments && activeAppointments.requests.length > 0\"><div class=\"bs-callout bs-callout-info\"><h4>No active appointments found.</h4><span class=\"label label-pill label-info\">Search to get appointments</span></div></div><div class=\"modal fade\" id=\"{{actionName}}Modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 98\">Fit appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 97\">Unfit appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 30\">Reschedule Appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 24\">Confirm the appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 27\">Reject an appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 37\">Submit reports of this appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 34\">Approve appointment for payment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 32\">Confirm customer attendance</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 39\">Confirm customer attendance</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 33\">Request for more information</h4><h4 class=\"modal-title\" ng-show=\"actionName == \'Create\'\">Place with partner</h4></div><div class=\"modal-body\" ng-show=\"actionId === 97 || actionId === 98\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"frmFit\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks</label><span ng-show=\"frmFit.remarks.$invalid\" class=\"redfont\">*</span> <textarea name=\"remarks\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks.fit\" required=\"\"></textarea></div></div><br><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Blood group</label><span ng-show=\"frmFit.bloodGrp.$invalid\" class=\"redfont\">*</span><select class=\"form-control\" ng-model=\"selectedBloodGrp\" required=\"\"><option value=\"\">Select blood group</option><option value=\"O+\">O+</option><option value=\"O-\">O-</option><option value=\"A+\">A+</option><option value=\"A-\">A-</option><option value=\"B+\">B+</option><option value=\"B-\">B-</option><option value=\"AB+\">AB+</option><option value=\"AB-\">AB-</option></select></div>{{selectedBloodGrp}}</div></form></div><div class=\"modal-body\" ng-show=\"actionId === 30\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"rescheduleForm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-6 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Requested date of admission *</label> <input name=\"doa\" id=\"originalDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"doa\">Modified date of admission *</label> <input name=\"doa\" class=\"form-control datetimepicker\" type=\"date\" ng-model=\"form.dod\" required=\"\"></div></div></div><br><div class=\"alert alert-danger\" role=\"alert\"><button class=\"btn btn-xs btn-primary pull-right\" ng-click=\"useSecondPref()\" style=\"margin-left:10px;\">Use This</button> Customer has provided {{secondPreferredVTime}} as second preference. We would like you to consider this if possible.</div><span ng-show=\"showChkedOnDcLogin\"><input type=\"checkbox\" ng-model=\"showdcselection\"> Check this to select a new Diagnostic Centre</span><div class=\"showdcselection\" ng-show=\"showdcselection\"><label for=\"doa\">Select a provider to move this appointment</label><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testStateId\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div><div class=\"col-md-4\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div></div><div class=\"row\"><div class=\"col-md-6 noPdngRt\"><select name=\"\" id=\"sublocalityId\" class=\"form-control\"><option value=\"\">Select a sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div><div class=\"col-md-6\"><select name=\"\" id=\"dcId\" class=\"form-control\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in diagnosticCentres\">{{dc.entityName}}</option></select></div></div></div><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></form></div><div class=\"modal-body\" ng-show=\"actionId === 24\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"frmConfirm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"doa\">Requested date of visit</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"row\" style=\"margin-top:10px; margin-bottom:10px;\" ng-if=\"action.showPrice\"><div class=\"col-md-6 noPdngRt\"><label for=\"doa\">DC price</label><span class=\"redfont\">*</span> <input name=\"date\" id=\"dcPrice\" class=\"form-control\" type=\"number\" ng-model=\"action.dcPrice\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks</label><span ng-show=\"frmConfirm.remarks.$invalid\" class=\"redfont\">*</span> <textarea name=\"remarks\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 27\"><form name=\"rejectForm\"><label for=\"enhance-remarks\">Reasons for rejecting appointment: *</label> <textarea name=\"reject-remarks\" ng-model=\"cancelComments\" class=\"form-control\" id=\"reject-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your reason to reject the appointment\" required=\"\"></textarea> <span>Appointment that has been rejected won\'t be completely removed from the queue. It has to be accepted by MAHS Operations person in order to permanently cancel it*</span></form></div><div class=\"modal-body\" ng-show=\"actionId === 34\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Appointment date *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"date\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 32\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"attendedForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label>Actual date of visit *</label> <input name=\"adate\" ng-model=\"actualDate\" ng-change=\"updateRemarks(actualDate)\" class=\"form-control\" type=\"date\"><br><div class=\"row col-md-12 col-sm-12 col-sm-12\"><label for=\"enhance-remarks\">Feedback*</label><select class=\"form-control\" ng-model=\"action.feedback\" required=\"\"><option value=\"\">select your feedback</option><option value=\"{{feedback}}\" ng-repeat=\"feedback in feedbackList\">{{feedback}}</option></select><br></div><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 39\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"notAttendedForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"> <label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 33\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"Raise_IAModalForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"remarks\">Details about requested information *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 37\"><form name=\"submitForm\" action=\"\" class=\"form\"><div class=\"alert alert-danger\" role=\"alert\">Please upload bills and reports appropriately to avoid delay in processing as well as repeated requests for more information</div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label>Attach lab reports</label><br><button class=\"btn btn-xs btn-primary\" ng-click=\"fileUploadMethods.addFileToUpload(\'reports\')\" style=\"margin-bottom:15px;\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button><br><fieldset class=\"form-group\" data-ng-repeat=\"item in reports\"><div class=\"row\"><div class=\"col-sm-9\"><input type=\"file\" file-model=\"item.model\"></div><div class=\"col-sm-2\"><button class=\"removeLargeDocument\" ng-click=\"fileUploadMethods.removeFileToUpload($index, \'reports\')\">-</button></div></div></fieldset></div><button class=\"btn btn-success pull-right\" ng-show=\"reports.length > 0\" ng-click=\"uploadMethods.upload(\'reports\')\">upload Reports</button></div></div></div><hr></div><br><div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label>Attach bills</label><br><button class=\"btn btn-xs btn-primary\" ng-click=\"fileUploadMethods.addFileToUpload(\'bills\')\" style=\"margin-bottom:15px;\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button><br><fieldset class=\"form-group\" data-ng-repeat=\"item in bills\"><div class=\"row\"><div class=\"col-sm-9\"><input type=\"file\" file-model=\"item.model\"></div><div class=\"col-sm-2\"><button class=\"removeLargeDocument\" ng-click=\"fileUploadMethods.removeFileToUpload($index, \'bills\')\">-</button></div></div></fieldset></div><button class=\"btn btn-success pull-right\" ng-show=\"bills.length > 0\" ng-click=\"uploadMethods.upload(\'bills\')\">upload bills</button></div></div></div><hr></div><hr><label for=\"\">Reports</label><div ng-repeat=\"reports in newlyUploadedReports\" class=\"uploaded\"><a href=\"{{reports.filePath}}\" class=\"badge badge-info\">{{reports.fileName}}</a></div><br><label for=\"\">Bills</label><div ng-repeat=\"bills in newlyUploadedBills\" class=\"uploaded\"><a href=\"{{bills.filePath}}\" class=\"badge badge-info\">{{bills.fileName}}</a></div><br><label for=\"\">Remarks</label> <textarea name=\"\" id=\"\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\"></textarea></form></div><div class=\"modal-body\" ng-show=\"actionName == \'Create\'\"><form name=\"frmPlacePartner\"><div class=\"row\"><div class=\"col-md-12\"><input type=\"text\" ng-model=\"action.partnerOrderId\" class=\"form-control\" placeholder=\"Partner Order ID\" required=\"\"></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionOnRequestMethods.actionRequest(\'Fit\',$event)\" ng-show=\"actionId === 98\">Fit appointment</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionOnRequestMethods.actionRequest(\'UnFit\',$event)\" ng-show=\"actionId === 97\">Unfit appointment</button> <button type=\"button\" ng-disabled=\"rescheduleForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionOnRequestMethods.actionRequest(\'Reschedule\',$event)\" ng-show=\"actionId === 30\">Request for reschedule</button> <button type=\"button\" ng-disabled=\"frmConfirm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionOnRequestMethods.actionRequest(\'Confirm\',$event)\" ng-show=\"actionId === 24\">Confirm appointment</button> <button type=\"button\" ng-disabled=\"rejectForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionOnRequestMethods.actionRequest(\'Cancel\',$event)\" ng-show=\"actionId === 27\">Submit</button> <button type=\"button\" ng-disabled=\"submitForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionOnRequestMethods.actionRequest(\'Submit\',$event)\" id=\"fileUploadBtn\" ng-show=\"actionId === 37\">Submit</button> <button type=\"button\" ng-disabled=\"approveForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionOnRequestMethods.actionRequest(\'Approve\',$event)\" ng-show=\"actionId === 34\">Approve for payment</button> <button type=\"button\" ng-disabled=\"attendedForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionOnRequestMethods.actionRequest(\'Attended\',$event)\" ng-show=\"actionId === 32\">Confirm attendance</button> <button type=\"button\" ng-disabled=\"notAttendedForm.$invalid\" class=\"btn btn-danger\" ng-click=\"actionOnRequestMethods.actionRequest(\'NotAttended\',$event)\" ng-show=\"actionId === 39\">Not attended</button> <button type=\"button\" ng-disabled=\"Raise_IAModalForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionOnRequestMethods.actionRequest(\'Raise_IA\',$event)\" ng-show=\"actionId === 33\">Request</button> <button type=\"button\" ng-disabled=\"frmPlacePartner.$invalid\" class=\"btn btn-primary\" ng-click=\"placeWithPartner()\" ng-show=\"actionName == \'Create\'\">Place order</button></div></div></div></div><div class=\"modal fade\" id=\"SplitRequestModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Split this request</h4></div><div class=\"modal-body\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h1 class=\"panel-title\">Related test bucket</h1></div><div class=\"panel-body\"><div class=\"col-md-6\" id=\"tempBucketId\" ng-repeat=\"test in relatedTests track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.addTestToTempBucket(test)\"> {{test.name}}</div></div></div><div class=\"panel panel-default\" ng-show=\"tempBucket.length > 0\"><div class=\"panel-heading\"><a href=\"\"><span class=\"glyphicon glyphicon-question-sign pull-right\" title=\"Unckeck tests to remove\" data-toggle=\"tooltip\"></span></a><h1 class=\"panel-title\">Temporary bucket</h1></div><div class=\"panel-body\" ng-show=\"tempBucket.length > 0\"><div class=\"col-md-6\" id=\"tempBucketId\" ng-repeat=\"test in tempBucket track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.removeFromBucket(test)\"> {{test.name}}</div></div><div class=\"panel-footer clearfix\"><button class=\"btn btn-success btn pull-right\" ng-show=\"tempBucket.length > 0\" ng-click=\"medicalTestMethods.addTestToPermanentBucket($index)\">Create group</button></div></div><div class=\"panel panel-default\" ng-repeat=\"bucket in groups\" ng-show=\"bucket.length > 0\"><div class=\"panel-heading\"><button type=\"button\" class=\"close\" ng-click=\"medicalTestMethods.removeBucketFromGroup($index)\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button> <strong class=\"text-uppercase\">Bucket : {{$index}}</strong></div><div class=\"panel-body\"><div class=\"col-md-12\" ng-repeat=\"test in bucket track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.removeFromGroups(test)\"> {{test.name}}</div><div class=\"row ddllocation\" ng-show=\"$index > 0\"><div class=\"col-md-3\"><label for=\"\">Select a state</label><select name=\"newstateId\" ng-model=\"testData.testStateId\" class=\"form-control\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a city</label><select name=\"newcityId\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\" class=\"form-control\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a locality</label><select name=\"newlocalityId\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\" class=\"form-control\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div><div class=\"col-md-3\"><label for=\"\">Select sub locality</label><select name=\"newsublocalityId\" ng-model=\"testData.testSubLocalityId\" ng-change=\"loadLocationData(\'dc\')\" class=\"form-control\"><option value=\"\">Select sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div></div><div class=\"row ddllocation\" ng-show=\"$index > 0\"><div class=\"col-md-4\"><label for=\"\">Select a diagnostic centre</label><select id=\"dcid_{{$index}}\" name=\"pkgDCId\" class=\"form-control\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in allDCs\">{{dc.entityName}}</option></select></div><div class=\"col-md-4\"><label for=\"\">Preferred date & time *</label> <input id=\"datetime_{{$index}}\" type=\"datetime-local\" class=\"form-control datetimepicker\"></div><div class=\"col-md-4\"><label for=\"\">Select a visit type</label><select id=\"visittype_{{$index}}\" name=\"visitType\" class=\"form-control\"><option value=\"\">Select a visit type</option><option value=\"22\">Appointment</option><option value=\"70\">Call</option><option value=\"71\">Home visit</option></select></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"medicalTestMethods.splitRequests()\" data-dismiss=\"modal\">Split</button></div></div></div></div><div class=\"modal fade\" id=\"RelatedRequestModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Related requests</h4></div><div class=\"modal-body\"><div class=\"row related {{request.isCurrent}}\" ng-repeat=\"request in relatedrequests\"><div class=\"col-md-1\" text-center=\"\"><i class=\"glyphicon glyphicon-{{request.iconName}} circle\"></i></div><div class=\"col-md-11\"><strong>{{request.additionalInformation.productName}}</strong><br><span class=\"small\">{{request.currentStatus}} | {{getAuditDate(request.fulfillmentDate)}} | {{request.additionalInformation.providerName}}</span></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"uploadPrescription\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Upload Priscritpion for Pharma</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6\"><input type=\"file\" name=\"pharmaPrescritpion\" id=\"pharmaPrescritpion\" required=\"\"> <span id=\"uploadingMsz\">Uploading...</span></div></div><br><div class=\"row\" ng-show=\"displayUploadedFiles.length>0\"><div class=\"col-md-6\"><b>Your uploaded files</b><br><span ng-repeat=\"fle in displayUploadedFiles track by $index\">{{$index + 1}}. {{fle}} <a><span style=\"color:red\" class=\"glyphicon glyphicon-remove\" ng-click=\"removeUploadedPres(fle)\"></span></a><br></span></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"saveUploadedUrl()\" ng-disabled=\"btnDisablePramaPres\">Save uploaded files</button></div></div></div></div></div>");
$templateCache.put("app/modules/appointments/allSearch.html","<div><style>\n        .btn-reload {\n            float: right;\n            margin-top: -33px;\n            margin-left: 1px;\n        }\n\n        .input-xs {\n            height: 22px;\n            line-height: 22px;\n            padding: 0 5px;\n        }\n\n        .investigationName {\n            background: #8bf2eb;\n        }\n\n        .popover {\n            position: absolute;\n            z-index: 100;\n        }\n\n        .modalHeaderText {\n            color: #005da2;\n        }\n            form.add-user {\n        width: 400px;\n        margin: 0 auto;\n    }\n\n    .brand img {\n        width: 190px;\n    }\n    .ngDrobdown {\n        pointer-events:none;\n        opacity: 0.5;\n    }\n    .table .label.status-name {\n        width: 160px;\n    }\n\n    strong.strong {\n        margin-top: 5px;\n        font-size: 15px;\n        display: block;\n    }\n\n    form.add-user {\n        width: 400px;\n        margin: 0 auto;\n    }\n\n    .package-item {\n        font-weight: bold;\n        font-size: 12px;\n    }\n\n    .benef-item {\n        font-weight: normal;\n        font-size: 12px;\n        color: #AAA;\n    }\n\n    .brand img {\n        width: 190px;\n    }\n\n    .form-create {\n        width: 100%;\n        /*padding: 40px 40px;*/\n    }\n\n    .card {\n        background-color: #F7F7F7;\n        /* just in case there no content*/\n        padding: 20px 25px 30px;\n        /*margin: 0 auto 25px;*/\n        /*margin-top: 50px;*/\n        /* shadows and rounded borders */\n        -moz-border-radius: 2px;\n        -webkit-border-radius: 2px;\n        border-radius: 2px;\n        -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n        -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n    }\n\n    .form-create.card {\n        margin-top: 0px;\n        margin-bottom: 10px;\n    }\n\n    .submit-buttons.card {\n        background-color: transparent;\n        -moz-border-radius: 0px;\n        -webkit-border-radius: 0px;\n        border-radius: 0px;\n        -moz-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n        -webkit-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n        box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n    }\n\n    .form-create-first.card {\n        margin-top: 30px;\n    }\n\n    .card-container.card {\n        width: 350px;\n        padding: 40px 40px;\n    }\n\n    .form-signin .form-control {\n        margin-bottom: 35px;\n        height: 45px;\n    }\n\n    .form-create .form-control {\n        margin-bottom: 15px;\n        height: 35px;\n    }\n\n    .firstScreen.card {\n        margin: 0 auto 25px;\n        margin-top: 50px;\n    }\n\n    .required {\n        border: 1px solid red;\n    }\n\n    .strong {\n        font-weight: bold;\n    }\n\n    .cart hr {\n        margin: 5px 0;\n    }\n\n    .active-appointments, .settled-appointments, .pending-appointments, .no-active-appointments {\n        padding-top: 20px;\n    }\n\n    .btn-reload {\n        float: right;\n    }\n\n    #searchQuery {\n        margin-top: -100px;\n    }\n\n    #map {\n        height: 100%;\n    }\n    /* Optional: Makes the sample page fill the window. */\n    html, body {\n        height: 100%;\n        margin: 0;\n        padding: 0;\n    }\n\n    #description {\n        font-family: Roboto;\n        font-size: 15px;\n        font-weight: 300;\n    }\n\n    #infowindow-content .title {\n        font-weight: bold;\n    }\n\n    #infowindow-content {\n        display: none;\n    }\n\n    #map #infowindow-content {\n        display: inline;\n    }\n\n    .pac-card {\n        margin: 10px 10px 0 0;\n        border-radius: 2px 0 0 2px;\n        box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        outline: none;\n        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n        background-color: #fff;\n        font-family: Roboto;\n    }\n\n    #pac-container {\n        padding-bottom: 12px;\n        margin-right: 12px;\n    }\n\n    .pac-controls {\n        display: inline-block;\n        padding: 5px 11px;\n    }\n\n        .pac-controls label {\n            font-family: Roboto;\n            font-size: 13px;\n            font-weight: 300;\n        }\n\n    #pac-input {\n        background-color: #fff;\n        font-family: Roboto;\n        font-size: 15px;\n        font-weight: 300;\n        margin-left: 12px;\n        padding: 0 11px 0 13px;\n        text-overflow: ellipsis;\n        width: 400px;\n    }\n\n        #pac-input:focus {\n            border-color: #4d90fe;\n        }\n\n    #title {\n        color: #fff;\n        background-color: #4d90fe;\n        font-size: 25px;\n        font-weight: 500;\n        padding: 6px 12px;\n    }\n\n    #target {\n        width: 345px;\n    }\n\n    .slideBox {\n        position: fixed;\n        top: 0;\n        right: 0;\n        width: 0;\n        opacity: 0;\n        visibility: hidden;\n        height: 100%;\n        z-index: 9999;\n        background: rgba(0,0,0,.5);\n    }\n\n        .slideBox .slideContent {\n            position: fixed !important;\n            overflow: auto;\n            background: #fff;\n            right: 0;\n            top: 0 !important;\n            bottom: 0 !important;\n            margin: 0 !important;\n            height: 100%;\n            max-width: 640px;\n            width: 80% !important;\n        }\n\n        .slideBox.in {\n            visibility: visible;\n            opacity: 1;\n            width: 100%;\n            transition: all .3s ease;\n        }\n\n    .multiSelectJustified .multiselect-parent {\n        width: 100%;\n    }\n\n    .multiSelectJustified .btn {\n        width: 100%;\n        text-align: left;\n    }\n\n        .multiSelectJustified .btn .caret {\n            float: right;\n            margin-top: 8px;\n        }\n    </style><script type=\"text/ng-template\" id=\"customPopupTemplate.html\"><div class=\"custom-popup-wrapper\" ng-style=\"{top: 0+\'px\', left: 0+\'px\'}\" style=\"display: block; position: relative\" ng-show=\"isOpen() && !moveInProgress\" aria-hidden=\"{{!isOpen()}}\"> <p class=\"message\">select from drop down.</p> <ul class=\"dropdown-menu\" role=\"listbox\" style=\"display: block; position: relative; margin-top: -12px;\"> <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.entityName}}\"> <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div> </li> </ul> </div></script><div><ng-form block-ui=\"searchAppointmentsData\" name=\"allSearch\"><div id=\"user-profile\" class=\"row form-horizontal\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"\" class=\"control-label required-field col-sm-4\">Request ID</label><div class=\"col-sm-8\"><input type=\"text\" ng-minlength=\"3\" placeholder=\"Enter request id\" class=\"form-control\" ng-model=\"serverSearch.requestID\" name=\"requestID\"></div></div><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Employee ID</label><div class=\"col-sm-8\"><input type=\"text\" ng-minlength=\"3\" placeholder=\"Enter employee id\" class=\"form-control\" ng-model=\"serverSearch.employeeID\" name=\"employeeID\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Mobile Number</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-minlength=\"10\" ng-maxlength=\"10\" placeholder=\"Enter mobile number\" ng-model=\"serverSearch.number\" type=\"text\" numbers-only=\"\" name=\"mobileNumber\"></div></div><div class=\"form-group\"><div class=\"col-sm-8 pull-right\"><button class=\"btn btn-default\" ng-click=\"clearAll()\">Clear</button> <button class=\"btn btn-primary\" ng-click=\"getAllResult()\" ng-disabled=\"!serverSearch.number && !serverSearch.employeeID && !serverSearch.requestID\">Search</button><div></div></div></div></div></div></ng-form></div><div class=\"claims\" ng-show=\"!showDetailView\" block-ui=\"allSearchDataResult\"><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"status.isFirstOpen\"><uib-accordion-heading><a style=\"color: #168cc9;\">Active result ({{activeAppointments.requests.length ? activeAppointments.requests.length: 0}})</a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isFirstOpen, \'glyphicon-chevron-right\': !status.isFirstOpen}\"></i></uib-accordion-heading><div class=\"claims\" block-ui=\"allSearchData\"><angular-tab appointmentlist=\"activeAppointments\" tabname=\"\'Active Appointments\'\" tabtype=\"\'plusActiveAppointments\'\"></angular-tab></div></div></uib-accordion><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"status.isSecondOpen\"><uib-accordion-heading><a style=\"color: #168cc9;\">E-Sales result ({{eSalesQueueRequests.length ? eSalesQueueRequests.length: 0}})</a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isSecondOpen, \'glyphicon-chevron-right\': !status.isSecondOpen}\"></i></uib-accordion-heading><div class=\"claims\" block-ui=\"allSearchData\"><div><angular-tab appointmentlist=\"eSalesQueueRequests\" tabname=\"\'E-Sales Request\'\" tabtype=\"\'eSalesRequests\'\"></angular-tab></div></div></div></uib-accordion></div><div class=\"active-appointments\" ng-show=\"showDetailView && !readOnlyView\"><div class=\"row\"><div class=\"col-md-12\"><div id=\"testsPerformed\" style=\"margin-top: -50px;\"><div class=\"form-create form-create-first card\"><div class=\"form-signin\"><strong>Customer details</strong> <button class=\"btn btn-danger btn-xs pull-right\" ng-click=\"showFirst()\">Back</button> <a class=\"btn btn-info btn-xs pull-right\" ng-model=\"collapse\" ng-show=\"displayTestDetails\" ng-click=\"isCostomerDetails=!isCostomerDetails\" style=\"margin-right:10px;\"><i class=\"glyphicon glyphicon-question-sign\"></i>Help</a><div class=\"pull-right\" style=\"margin-right: 10px; font-size: 20px;\"><a ng-show=\"showDndBell\"><request-dnd-modal requestdata=\"requestDataForDND\" dndcustomer=\"false\" dnd=\"true\" bell=\"showDndBell\"><i class=\"fa fa-bell\" uib-tooltip=\"DND\"></i></request-dnd-modal></a> <a ng-show=\"!showDndBell\"><request-dnd-modal requestdata=\"requestDataForDND\" dndcustomer=\"false\" dnd=\"true\" bell=\"showDndBell\"><i class=\"fa fa-bell-slash\" uib-tooltip=\"DND\"></i></request-dnd-modal></a> <a ng-show=\"showDndCustomerBell\"><request-dnd-modal requestdata=\"requestDataForDND\" dndcustomer=\"true\" dnd=\"false\" bell=\"showDndCustomerBell\"><i class=\"fa fa-bell\" uib-tooltip=\"DND Customer\"></i></request-dnd-modal></a> <a ng-show=\"!showDndCustomerBell\"><request-dnd-modal requestdata=\"requestDataForDND\" dndcustomer=\"true\" dnd=\"false\" bell=\"showDndCustomerBell\"><i class=\"fa fa-bell-slash\" uib-tooltip=\"DND Customer\"></i></request-dnd-modal></a></div><hr><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Customer name</label> <input type=\"text\" id=\"employeeName\" class=\"form-control\" ng-model=\"showData.name\"></div><div class=\"col-md-4\"><label for=\"\">Customer unique id</label> <input type=\"text\" id=\"employeeId\" class=\"form-control\" ng-model=\"showData.employeeId\"></div><div class=\"col-md-4\"><label for=\"\">Annual premium</label> <input placeholder=\"Enter annual premium\" name=\"annualPremium\" type=\"number\" id=\"annualPremium\" class=\"form-control\" ng-model=\"annualPremium\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Email address</label> <input type=\"text\" id=\"emailid\" class=\"form-control\" ng-model=\"showData.emailId\"></div><div class=\"col-md-4\"><label for=\"\">Mobile number</label> <input type=\"text\" id=\"mobilenumber\" class=\"form-control\" ng-model=\"showData.mobileNumber\"></div><div class=\"col-md-4\"><label for=\"\">Customer address</label><p>{{showData.addressLine1}}, {{showData.city}}, {{showData.state}}</p></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Sum assured</label> <input placeholder=\"Enter sum assured\" type=\"text\" id=\"sumAssured\" class=\"form-control\" ng-model=\"sumassuredetail.sumAssured\"></div><div class=\"col-md-4\"><label for=\"\">Select gender</label><select class=\"form-control\" ng-model=\"genderList.gender\"><option value=\"NA\">Choose gender</option><option value=\"M\">Male</option><option value=\"F\">Female</option></select></div><div class=\"col-md-4\"><label for=\"\">Paid/Sponsored</label><select ng-model=\"sumassuredetail.paidSpons\" class=\"form-control\"><option value=\"sponsored\">Sponsored</option><option value=\"paid\">Paid</option></select></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Group/Individual</label><select ng-model=\"sumassuredetail.grpIndv\" class=\"form-control\"><option value=\"individual\">Individual</option><option value=\"group\">Group</option></select></div></div></div></div><div class=\"form-create card\" ng-show=\"genderList.gender !== \'NA\'\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-3\"><label for=\"\">Select insurer</label><select class=\"form-control\" name=\"\" id=\"\" ng-model=\"client.selectedInsurer\" ng-options=\"insurer as insurer.entityName for insurer in selectedInsurers\" ng-change=\"setSource(client.selectedInsurer)\"><option value=\"\">Select Insurer</option></select></div><div class=\"col-md-3\"><label for=\"\">Select appropriate package</label><div ng-class=\"{\'ngDrobdown\' : isSelectedpackage === true }\"><div ng-dropdown-multiselect=\"\" options=\"packages\" extra-settings=\"example2settings\" selected-model=\"selectedPackageForAdvance\" translation-texts=\"example5customTexts\" checkboxes=\"true\" style=\"margin-bottom:15px;\" class=\"multiSelectJustified\"></div></div></div><div class=\"col-md-3\" ng-show=\"selectedPackageForAdvance.length>0\"><label for=\"\">View packages</label> <button class=\"btn btn-info btn-block\" data-toggle=\"modal\" data-target=\"#selectedPacakgesList\">View Details</button></div><div class=\"col-md-2\"><label for=\"\">Select visit type</label><select class=\"form-control\" ng-model=\"client.visitType\" ng-change=\"visitTypeChange(client.visitType)\" required=\"\"><option value=\"\">Select visit type</option><option value=\"Appointment\">Centre Visit</option><option value=\"Home_Visit\">Home Visit</option></select></div><dc-notes ng-if=\"isShowDcNote\" id=\"selectedDcFromDavanceSearch.id\"><button style=\"margin-top: 24px;\" class=\"btn fa fa-info\"></button></dc-notes></div><p ng-if=\"notMappedTest.length >0\" style=\"margin-bottom: 2px; margin-left: 4px;\">Un-mapped test :- <span ng-repeat=\"item in notMappedTest track by $index\" style=\"display: inline; padding: 0px 2px; font-size: small; color: red;\">{{item.testName}},</span></p></div></div><div class=\"form-create card\" ng-if=\"client.visitType===\'Home_Visit\'\" style=\"padding-bottom:10px;\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-12\"><div ng-show=\"client.visitType===\'Home_Visit\'\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Address line 1</label> <input placeholder=\"Enter address line 1..\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline1\" ng-required=\"client.visitType===\'Home_Visit\'\"></div><div class=\"col-md-6\"><label for=\"\">Address line 2</label> <input placeholder=\"Enter address line 2..\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline2\" ng-required=\"client.visitType===\'Home_Visit\'\"></div></div></div></div></div></div></div><div class=\"form-create card\" ng-show=\"selectedPackageForAdvance.length >0\" style=\"padding-bottom:10px;\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"btn-group btn-group-justified\" style=\"margin-bottom:15px;\"><label class=\"btn btn-primary\" ng-model=\"radioModel\" uib-btn-radio=\"\'Left\'\" ng-click=\"DCSelection(\'advance\')\">Advance DC selection</label> <label class=\"btn btn-primary\" ng-model=\"radioModel\" uib-btn-radio=\"\'Middle\'\" ng-click=\"DCSelection(\'manula\')\">Manual DC selection</label> <label ng-if=\"isFlage.autoDcSelection\" class=\"btn btn-primary\" ng-model=\"radioModel\" uib-btn-radio=\"\'Middle\'\" ng-click=\"autoDCSelection(\'Auto\')\">Auto DC selection</label></div></div><div class=\"col-md-2\" ng-show=\"isPackageSelectionAdvance\"><select name=\"\" class=\"form-control\" ng-options=\"distance as distance.value for distance in distances\" ng-model=\"distance\" ng-change=\"changeDistance(distance)\"><option value=\"\">Select radius</option></select></div><div class=\"col-md-3\" ng-show=\"isPackageSelectionAdvance\"><input type=\"text\" class=\"form-control\" gm-places-autocomplete=\"\" ng-model=\"locationName.autocomplete\"></div><div class=\"col-md-3\"><input ng-model=\"dndCustomer\" type=\"checkbox\"> DND Customer</div></div><div class=\"row\" ng-if=\"isPackageSelectionManual || isPackageSelectionAdvance\" style=\"margin-top: 10px;\"><div class=\"col-md-6\"><div class=\"row\">{{firstDate}} {{secondDate}}<div class=\"col-xs-8 dateBox\"><label for=\"\">First preference</label> <input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"manual.firstDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" style=\"width: 140px;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\" style=\"margin-left: 138px; margin-top: -83px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"col-xs-4 p-l-0 timeBox\" style=\"margin-left: 210px; margin-top: -102px;\"><div uib-timepicker=\"\" ng-model=\"manual.firstTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div></div></div><div class=\"row\" ng-if=\"isPackageSelectionManual\" style=\"margin-top: 10px; margin-bottom: 60PX;\"><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"current.newStateId\" ng-change=\"loadCitiesNew(current.newStateId)\"><option value=\"\">Select state</option></select></div><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"newCityId\" ng-change=\"loadLocationsNew(newCityId)\"><option value=\"\">Select city</option></select></div><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"newSubLocationId\" ng-change=\"loadDcForAllPackages(newSubLocationId)\"><option value=\"\">Select locality</option></select></div><div class=\"col-md-3\"><select name=\"preferreddc1\" id=\"firstDCIdPreEmp\" ng-model=\"client.preferredDC1\" class=\"form-control\" ng-options=\"dc as dc.entityName for dc in diagnosticCentres\" ng-change=\"selectedDcFromMap(client.preferredDC1)\"><option value=\"\">Select diagnostic centre</option></select></div></div><div class=\"row\" ng-if=\"isPackageSelectionManual\" style=\"margin-top: 10px; margin-bottom: 30PX;\"><div class=\"col-md-12\"><button ng-disabled=\"!manual.firstDate || !client.preferredDC1 || !client.visitType\" ng-click=\"bookAppointmentDate(manual.firstDate, manual.secondDate, manual.firstTime, manual.secondTime)\" class=\"btn btn-primary pull-right\">Add to cart</button></div></div></div></div><div class=\"row\" ng-if=\"markerArray.length >0 && isPackageSelectionAdvance\"><div class=\"col-md-12\"><ui-gmap-google-map center=\"map.center\" control=\"\" zoom=\"map.zoom\" bounds=\"map.bounds\" draggable=\"true\" options=\"map.options\"><ui-gmap-circle center=\"map.center\" stroke=\"map.stroke\" fill=\"map.fill\" radius=\"map.radius\" visible=\"map.visible\" geodesic=\"c.geodesic\" editable=\"c.editable\" draggable=\"map.draggable\" clickable=\"map.clickable\"><ui-gmap-marker models=\"randomMarkers1\" coords=\"map.center\" idkey=\"\"><i class=\"fa fa-user\"></i></ui-gmap-marker><ui-gmap-marker ng-repeat=\"marker in markerArray\" click=\"selectedDcFromMap(marker, $event)\" models=\"randomMarkers\" events=\"map.markersEvents\" coords=\"marker.coords\" idkey=\"marker.id\"><ui-gmap-window options=\"windowOpt\" closeclick=\"map.window.closeClick(marker)\" show=\"marker.visible\" templateurl=\"\'/app/modules/newappointment/windowContent.html\'\" templateparameter=\"windowParams\"></ui-gmap-window></ui-gmap-marker></ui-gmap-circle></ui-gmap-google-map></div></div><div class=\"row\" ng-if=\"markerArray.length ===0 && isMarkerArray && selectedPackageForAdvance.length !== 0\"><div class=\"col-md-12\"><div class=\"text-center\" style=\"margin-bottom: 30px; padding-top: 20px; background-color: #e0dede; padding-bottom: 18px;\">No Diagnostic Centre found.</div></div></div></div></div></div><div class=\"active-appointments\" ng-show=\"showDetailView && readOnlyView\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"testsPerformed\"><div class=\"form-create form-create-first card\"><div class=\"form-signin\"><strong>Customer details</strong> <button class=\"btn btn-danger btn-sm pull-right\" ng-click=\"showFirst(\'create\')\">Back</button><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Customer name</label> <input type=\"text\" id=\"employeeName\" class=\"form-control\" ng-model=\"showData.name\"></div><div class=\"col-md-6\"><label for=\"\">Customer unique id</label> <input type=\"text\" id=\"employeeId\" class=\"form-control\" ng-model=\"showData.employeeId\"></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Email address</label> <input type=\"text\" id=\"emailid\" class=\"form-control\" ng-model=\"showData.emailId\"></div><div class=\"col-md-6\"><label for=\"\">Mobile number</label> <input type=\"text\" id=\"mobilenumber\" class=\"form-control\" ng-model=\"showData.mobileNumber\"></div></div></div></div><div class=\"form-create card\"><div class=\"form-signin\"><table class=\"table table-hover\" ng-show=\"showData.testDetails.length>0\"><thead><th>Test name</th><th>Appointment date & time</th></thead><tbody><tr ng-repeat=\"test in showData.testDetails\"><td>{{test.testName}}</td><td>{{compareDate(test.appointmentDate)}} | {{test.appointmentTime}}</td></tr></tbody></table><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Select insurer</label><select class=\"form-control\" name=\"\" id=\"\" ng-model=\"client.selectedInsurer\" ng-options=\"insurer as insurer.entityName for insurer in selectedInsurers\" ng-change=\"setSource(client.selectedInsurer)\"><option value=\"\">Select an insurer</option></select></div><div class=\"col-md-6\"><label for=\"\">Select appropriate package</label><select name=\"\" id=\"packageId\" class=\"form-control\" ng-model=\"pkgSelected\" ng-options=\"package.peR_Id as package.packageName for package in packages\" ng-change=\"changePackage(pkgSelected)\"><option value=\"\">Select a Package</option></select></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Preferred date & time *</label><p class=\"input-group\"><input id=\"datetimeSecond\" type=\"text\" readonly=\"\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.secondPrefTime\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\" style=\"margin-top: -15px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-6\" style=\"margin-top: -12px;\"><div uib-timepicker=\"\" ng-model=\"userTime.secondAppointmentTime\" max=\"maxSecond\" min=\"minSecond\" ng-change=\"changedSecond()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><strong>Please choose the diagnostic centre</strong><hr style=\"margin:5px 0\"><div class=\"row\"><div class=\"col-md-3\"><label for=\"\">Select a state</label><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"newStateId\" ng-change=\"loadCities(newStateId)\"><option value=\"\">Select a state</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a city</label><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"newCityId\" ng-change=\"loadLocations(newCityId)\"><option value=\"\">Select a city</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a locality</label><select name=\"\" class=\"form-control\" ng-options=\"location as location.lookUpValue for location in locations\" ng-model=\"newLocationId\" ng-change=\"loadSubLocations(newLocationId)\"><option value=\"\">Select a locality</option></select></div><div class=\"col-md-3\"><label for=\"\">Select sub locality</label><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"newSubLocationId\" ng-change=\"loadDCs(newSubLocationId)\"><option value=\"\">Select sub locality</option></select></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"\">Select a diagnostic centre</label><select name=\"pkgDCId\" ng-change=\"selectDc(pkgDcId)\" class=\"form-control\" ng-model=\"pkgDcId\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in diagnosticCentres\">{{dc.entityName}}</option></select></div></div><div class=\"row\"><div class=\"col-md-3\"></div><div class=\"col-md-3\"></div><div class=\"col-md-3\"></div><div class=\"col-md-3\"><button class=\"btn btn-block btn-primary\" ng-click=\"addToCart(\'package\', pkgSelected)\">Update Cart</button></div></div></div></div><div class=\"form-create card\" ng-show=\"showAddTestBox\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"\">Select an individual test *</label><select ng-change=\"changePackage(testPeRId)\" class=\"form-control\" ng-model=\"testPeRId\"><option value=\"\">Select a test</option><option value=\"{{test.peR_Id}}\" ng-repeat=\"test in tests\">{{test.packageName}}</option></select></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Preferred date & time *</label><p class=\"input-group\"><input id=\"datetimeSecond\" type=\"text\" readonly=\"\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.TestPrefTime\" is-open=\"popup4.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open4()\" style=\"margin-top: -15px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-6\" style=\"margin-top: -12px;\"><div uib-timepicker=\"\" ng-model=\"userTime.testAppointmentTime\" max=\"maxSecond\" min=\"minSecond\" ng-change=\"changedSecond()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><strong>Please choose the diagnostic centre</strong><hr style=\"margin:5px 0\"><div class=\"row\"><div class=\"col-md-3\"><label for=\"\">Select a state</label><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"newStateId\" ng-change=\"loadCities(newStateId)\"><option value=\"\">Select a state</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a city</label><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"newCityId\" ng-change=\"loadLocations(newCityId)\"><option value=\"\">Select a city</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a locality</label><select name=\"\" class=\"form-control\" ng-options=\"location as location.lookUpValue for location in locations\" ng-model=\"newLocationId\" ng-change=\"loadSubLocations(newLocationId)\"><option value=\"\">Select a locality</option></select></div><div class=\"col-md-3\"><label for=\"\">Select sub locality</label><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"newSubLocationId\" ng-change=\"loadDCs(newSubLocationId)\"><option value=\"\">Select sub locality</option></select></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"\">Select a diagnostic centre</label><select name=\"testDCId\" ng-change=\"selectDcIdFortest(testDcId)\" class=\"form-control\" ng-model=\"testDcId\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in diagnosticCentres\">{{dc.entityName}}</option></select></div></div><div class=\"row\"><div class=\"col-md-3\"></div><div class=\"col-md-3\"></div><div class=\"col-md-3\"></div><div class=\"col-md-3\"><button class=\"btn btn-block btn-primary\" ng-click=\"addToCart(\'test\', testPeRId)\">Add to cart</button></div></div></div></div></div><hr><div class=\"form-create card submit-buttons\"><div class=\"form-signin\"><div class=\"col-md-8\"></div><div class=\"col-md-4\"><button class=\"btn btn-block btn-primary\" ng-click=\"showAddTestBox = true\" ng-show=\"!showAddTestBox\">Add Test</button></div></div></div></div><div class=\"col-md-4\"><div class=\"form-create form-create-first card cart\"><div class=\"form-signin\"><h4>Your Cart</h4><hr><div class=\"cartEmpty\" ng-show=\"cartEmpty\"><div class=\"empty text-center\">Cart is empty</div></div><div id=\"cartItems\" ng-show=\"!cartEmpty\"><div ng-repeat=\"item in orderObj.orderItems\"><div class=\"row package-item\"><span class=\"col-md-8\">{{item.productName}}</span> <span class=\"col-md-4\">Rs.{{item.amount}}/-</span></div><div class=\"row benef-item\"><span class=\"col-md-8\">{{item.firstName}}</span> <span class=\"col-md-4\">{{item.cityName}}</span></div><div class=\"row\"><div class=\"col-md-8\"></div><div class=\"col-md-3\"><button class=\"btn btn-xs btn-block btn-danger delete\" value=\"\" id=\"{{item.productId}}\" ng-click=\"removeOrderItem(item, event)\">delete</button></div></div><hr></div></div><div class=\"row package-item\" ng-show=\"!cartEmpty\"><div class=\"col-md-8\">Grand total</div><div class=\"col-md-4\">Rs.{{totalPrice}}/-</div></div><hr></div></div><div class=\"form-create card\" ng-show=\"showPaid\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"paid\">Paid</label> <input type=\"radio\" id=\"paid\" name=\"optradio\" checked=\"checked\" value=\"\" ng-click=\"paid=true\"></div><div class=\"col-md-6\"><label for=\"unpaid\">Unpaid</label> <input type=\"radio\" id=\"unpaid\" name=\"optradio\" value=\"\" ng-click=\"paid=false\"></div></div><strong>Transaction details</strong><hr><div class=\"alert alert-danger\" ng-show=\"showPaid && paid\" role=\"alert\">Since this is a paid package, You need to fill the following <span class=\"strong\">Transaction details</span></div><div class=\"alert alert-danger\" ng-show=\"showPaid && !paid\" role=\"alert\">Unpaid orders will be collected in \"UnConfirmed Orders\" bucket. Once their availability is confirmed with DC, they will be approved and payment link will be sent to the user. These orders moves to active appointments, only after user makes the payment</div><div ng-show=\"showPaid && paid\"><label for=\"\">UTR number *</label> <input id=\"txnNumber\" class=\"form-control\" ng-model=\"txn.txnNumber\"></div></div></div><button class=\"btn btn-primary btn-block\" ng-click=\"checkDuplicacy()\" ng-show=\"!cartEmpty\">Create Appointment</button></div></div></div></div><div class=\"modal fade\" id=\"{{actionName}}Modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 98\">Fit appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 119\">Cancelled by Insurer</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 120\">Closed by Insurer</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 97\">Unfit appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 30 || actionId ===29\">Reschedule appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 48\">Approve appointment by QC</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 24 || actionId ===23\">Confirm the appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 27 || actionId === 42\">Reject an appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 37\">Submit reports of this appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 34\">Approve appointment for payment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 32\">Confirm customer attendance</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 39\">Confirm customer attendance</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 33\">Request for more information</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 91\">Place with partner</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 87\">Delivered</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 88\">Out for delivery</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 89\">Confirmation by retailer</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 116\">Partially attended</h4></div><div class=\"modal-body\" ng-show=\"actionId === 48\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"doa\">Appointment date *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div><div class=\"col-md-6\"><label for=\"doa\">Actual Appointment Date</label><div class=\"input-group\"><input placeholder=\"Select from date\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"popupQc.actualDate\" is-open=\"popupQc.opened\" datepicker-options=\"dateOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openQcDate()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-6\"><label for=\"doa\">Doctor Qualification *</label><select required=\"\" ng-model=\"doctorQualificatio\" style=\"padding: 6px 12px; color: #555; background-color: #fff; background-image: none; border-radius: 4px;\"><option value=\"\">Select Qualification</option><option value=\"MMBS\">MMBS</option><option value=\"MD\">MD</option><option value=\"NonMBBS\">Non MBBS</option></select></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Photograph available</label><br><input type=\"radio\" ng-model=\"isPhotoAvailble.value\" value=\"true\">Yes <input type=\"radio\" ng-model=\"isPhotoAvailble.value\" value=\"false\">No</div></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 98 || actionId === 97\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"frmFit\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks</label><span ng-show=\"frmFit.remarks.$invalid\" class=\"redfont\">*</span> <textarea name=\"remarks\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks.fit\" required=\"\"></textarea></div></div><br><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Blood group</label><span ng-show=\"frmFit.bloodGrp.$invalid\" class=\"redfont\">*</span><select class=\"form-control\" ng-model=\"bloodGrp.selectedBloodGrp\" required=\"\"><option value=\"\">Select blood group</option><option value=\"O+\">O+</option><option value=\"O-\">O-</option><option value=\"A+\">A+</option><option value=\"A-\">A-</option><option value=\"B+\">B+</option><option value=\"B-\">B-</option><option value=\"AB+\">AB+</option><option value=\"AB-\">AB-</option><option value=\"NA\">N/A</option></select></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 119 || actionId === 120\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"InsurerAction\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"remarks\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div><br></form></div><div class=\"modal-body\" ng-show=\"actionId === 30 || actionId ===29\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"rescheduleForm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Current requested Date</label> <input name=\"doa\" id=\"originalDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-5\"><label for=\"doa\">Select reschedule date</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"reschedule.opened\" datepicker-options=\"dateOptionsReschedule\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"reschedule()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\" ng-if=\"actionId === 30 || actionId ===29\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><br><div class=\"alert alert-danger\" role=\"alert\">Customer has provided {{secondPreferredVTime}} as second preference. We would like you to consider this if possible.</div><span ng-show=\"showChkedOnDcLogin\"><input type=\"checkbox\" ng-click=\"showDcSelection(action.showdcselection, \'dcVisit\')\" ng-model=\"action.showdcselection\"> Check this to select a new diagnostic centre</span><br><span ng-show=\"showChkedOnDcLogin\"><input type=\"checkbox\" ng-click=\"showDcSelection(action.showHomeVisitSelection, \'homeVisit\')\" ng-model=\"action.showHomeVisitSelection\"> Check this to enter home address for home visit</span><hr><div class=\"\" ng-show=\"action.showHomeVisitSelection\"><label for=\"\">Enter home address to move this appointment</label><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-6 noPdngRt\"><input type=\"text\" class=\"form-control\" ng-model=\"homeVisit.addressLineOne\" placeholder=\"Enter Address line 1\"></div><div class=\"col-md-6 noPdngRt\"><input type=\"text\" class=\"form-control\" ng-model=\"homeVisit.addressLinTwo\" placeholder=\"Enter Address line 2\"></div></div><div class=\"\"><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testStateId\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div><div class=\"col-md-4\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div></div><div class=\"row\"><div class=\"col-md-6 noPdngRt\"><select name=\"\" id=\"sublocalityId\" class=\"form-control\" ng-model=\"testData.testSubLocalityId\" ng-change=\"loadLocationData(\'dc\', testData.testSubLocalityId)\"><option value=\"\">Select a sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div><div class=\"col-md-6\"><select name=\"\" id=\"dcId\" ng-model=\"testData.dcValue\" class=\"form-control\" ng-change=\"changeDc(testData.dcValue)\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in diagnosticCentres track by $index\">{{dc.entityName}}</option></select></div></div></div></div><div class=\"\" ng-show=\"action.showdcselection\"><label for=\"doa\">Select a provider to move this appointment</label><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testStateId\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div><div class=\"col-md-4\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div></div><div class=\"row\"><div class=\"col-md-6 noPdngRt\"><select name=\"\" id=\"sublocalityId\" class=\"form-control\" ng-model=\"testData.testSubLocalityId\" ng-change=\"loadLocationData(\'dc\', testData.testSubLocalityId)\"><option value=\"\">Select a sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div><div class=\"col-md-6\"><select name=\"\" id=\"dcId\" ng-model=\"testData.dcValue\" class=\"form-control\" ng-change=\"changeDc(testData.dcValue)\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in diagnosticCentres track by $index\">{{dc.entityName}}</option></select></div></div></div><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></form></div><div class=\"modal-body\" ng-show=\"actionId === 24 || actionId ===23\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"frmConfirm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"doa\">Requested date of visit</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"row\" style=\"margin-top:10px; margin-bottom:10px;\" ng-if=\"action.showPrice\"><div class=\"col-md-6 noPdngRt\"><label for=\"doa\">Dc price</label><span class=\"redfont\">*</span> <input name=\"date\" id=\"dcPrice\" class=\"form-control\" type=\"number\" ng-model=\"action.dcPrice\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks</label><span ng-show=\"frmConfirm.remarks.$invalid\" class=\"redfont\">*</span> <textarea name=\"remarks\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 27\"><form name=\"rejectForm\"><label for=\"enhance-remarks\">Reasons for rejecting appointment: *</label><select class=\"form-control\" ng-model=\"action.cancelReason\" ng-change=\"resetDependencies(action.cancelReason)\" required=\"\"><option value=\"\">select cancellation reason</option><option value=\"{{f}}\" ng-repeat=\"f in reasonOfCancel\">{{f}}</option></select><br><textarea ng-if=\"action.cancelReason==\'Other\'\" name=\"reject-remarks\" ng-model=\"action.cancelComments\" class=\"form-control\" id=\"reject-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your reason to reject the appointment\" required=\"\"></textarea> <span>Appointment that has been rejected won\'t be completely removed from the queue. It has to be accepted by MAHS operations person in order to permanently cancel it*</span></form></div><div class=\"modal-body\" ng-show=\"actionId === 42\"><form name=\"rejectForm\"><label for=\"enhance-remarks\">Reasons for rejecting appointment: *</label><select class=\"form-control\" ng-model=\"action.cancelReason\" ng-change=\"resetDependencies(action.cancelReason)\" required=\"\"><option value=\"\">select cancellation reason</option><option value=\"{{f}}\" ng-repeat=\"f in reasonOfCancel\">{{f}}</option></select><br><textarea ng-if=\"action.cancelReason==\'Other\'\" name=\"reject-remarks\" ng-model=\"action.cancelComments\" class=\"form-control\" id=\"reject-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your reason to reject the appointment\" required=\"\"></textarea> <span>Appointment that has been rejected won\'t be completely removed from the queue. It has to be accepted by MAHS operations person in order to permanently cancel it*</span></form></div><div class=\"modal-body\" ng-show=\"actionId === 34\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Appointment date *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"date\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 32\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"attendedForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label>Actual date of visit *</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"attended.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"attended()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"col-md-2\" ng-if=\"actionId === 32\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div><div class=\"row col-md-12 col-sm-12 col-sm-12\"><label for=\"enhance-remarks\">Feedback*</label><select class=\"form-control\" ng-model=\"action.feedback\" required=\"\"><option value=\"\">select your feedback</option><option value=\"{{feedback}}\" ng-repeat=\"feedback in feedbackList\">{{feedback}}</option></select><br></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 39\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"notAttendedForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"> <label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 33\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"Raise_IAModalForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"remarks\">Details about requested information *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 37\"><form name=\"submitForm\" action=\"\" class=\"form\"><div class=\"alert alert-danger\" role=\"alert\">Please upload bills and reports appropriately to avoid delay in processing as well as repeated requests for more information</div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Attach lab reports *</label><mb-plus-file-upload action=\"action\" file-fn=\"fileFn(arg, \'report\')\"></mb-plus-file-upload></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Attach bills</label><mb-plus-file-upload action=\"action\" file-fn=\"fileFn(arg, \'bill\')\"></mb-plus-file-upload></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ng-if=\"storeFiles.length >0\" class=\"form-group col-md-6\" ng-repeat=\"item in storeFiles\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: rgb(238, 238, 238);font-size: 12px;\"><a ng-click=\"downloadAttachment(item.filePath)\">{{item.fileName}}</a> <a ng-click=\"removeFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div><div class=\"col-md-6\"><div ng-if=\"storedBill.length >0\" class=\"form-group col-md-6\" ng-repeat=\"item in storedBill\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: rgb(238, 238, 238);font-size: 12px;\"><a ng-click=\"downloadAttachment(item.filePath)\">{{item.fileName}}</a> <a ng-click=\"removeBillFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div></div><label for=\"\">Remarks</label> <textarea name=\"Remarks\" id=\"Remarks\" cols=\"30\" rows=\"3\" class=\"form-control\" ng-model=\"action.remarks\"></textarea></form></div><div class=\"modal-body\" ng-show=\"actionId === 91\"><form name=\"frmPlacePartner\"><div class=\"row\"><div class=\"col-md-12\"><input type=\"text\" ng-model=\"action.partnerOrderId\" class=\"form-control\" placeholder=\"Partner Order ID\" required=\"\"></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 87\"><form name=\"frmDelivered\"><div class=\"row\"><div class=\"col-md-6\"><input type=\"number\" ng-model=\"pharmaData.cashlessAmt\" class=\"form-control\" placeholder=\"Cashless Amount\" required=\"\"></div><div class=\"col-md-6\"><input type=\"number\" ng-model=\"pharmaData.CODAmt\" class=\"form-control\" placeholder=\"Cash On Delivery Amount\" required=\"\"></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 88\"><div class=\"row\"><div class=\"col-md-12\"><h4 style=\"margin-left: 145px;color: #a94442;\">Item is out for delivery</h4></div></div></div><div class=\"modal-body\" ng-show=\"actionId === 89\"><div class=\"row\"><div class=\"col-md-12\"><h4 style=\"margin-left: 145px;color: #a94442;\">Waiting for retailer confirmation</h4></div></div></div><div class=\"modal-body\" ng-show=\"actionId === 116\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"attendedPartiallyForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label>Actual date of visit *</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"attended.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"attended()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"col-md-2\" ng-if=\"actionId === 116\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Fit\',$event)\" ng-show=\"actionId === 98\">Fit appointment</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'UnFit\',$event)\" ng-show=\"actionId === 97\">Unfit appointment</button> <button type=\"button\" ng-disabled=\"rescheduleForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Reschedule\',$event)\" ng-show=\"actionId === 30|| actionId ===29\">Request for reschedule</button> <button type=\"button\" ng-disabled=\"InsurerAction.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'InsurerAction\',$event)\" ng-show=\"actionId === 119|| actionId ===120\">Insurer Update</button> <button type=\"button\" ng-disabled=\"frmConfirm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Confirm\',$event)\" ng-show=\"actionId === 24 || actionId ===23\">Confirm appointment</button> <button type=\"button\" ng-disabled=\"rejectForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Cancel\',$event)\" ng-show=\"actionId === 27 || actionId === 42\">Submit</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Submit\',$event)\" id=\"fileUploadBtn\" ng-show=\"actionId === 37\" ng-disabled=\"!storeFiles.length\">Submit</button> <button type=\"button\" ng-disabled=\"approveForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Approve\',$event)\" ng-show=\"actionId === 34\">Approve for payment</button> <button type=\"button\" ng-disabled=\"attendedForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Attended\',$event)\" ng-show=\"actionId === 32\">Confirm attendance</button> <button type=\"button\" ng-disabled=\"notAttendedForm.$invalid\" class=\"btn btn-danger\" ng-click=\"actionRequest(\'NotAttended\',$event)\" ng-show=\"actionId === 39\">Not attended</button> <button type=\"button\" ng-disabled=\"Raise_IAModalForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Raise_IA\',$event)\" ng-show=\"actionId === 33\">Request</button> <button type=\"button\" ng-disabled=\"approveForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'QCApprove\',$event)\" ng-show=\"actionId === 48\">Qc approved</button> <button type=\"button\" ng-disabled=\"frmPlacePartner.$invalid\" class=\"btn btn-primary\" ng-click=\"placeWithPartner()\" ng-show=\"actionId === 91\">Place order</button> <button type=\"button\" ng-disabled=\"frmDelivered.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Delivered\',$event)\" ng-show=\"actionId === 87\">Confirm</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'OutForDelivery\',$event)\" ng-show=\"actionId === 88\">Out for delivery</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'ConfirmByRetailer\',$event)\" ng-show=\"actionId === 89\">Confirm</button> <button type=\"button\" ng-disabled=\"attendedpartiallyformclass.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'PartiallyAttended\',$event)\" ng-show=\"actionId === 116\">Confirm partially attended</button></div></div></div></div><div class=\"modal fade\" id=\"SplitRequestModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Split this request</h4></div><div class=\"modal-body\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h1 class=\"panel-title\">Related test bucket</h1></div><div class=\"row panel-body\"><div class=\"col-md-6\" id=\"tempBucketId\" ng-repeat=\"test in relatedTests track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.addTestToTempBucket(test)\"> {{test.name}} <span ng-show=\"relatedTests.length == 0\"><label>No tests found!</label></span></div></div></div><div class=\"panel panel-default\" ng-show=\"tempBucket.length > 0\"><div class=\"panel-heading\"><a href=\"\"><span class=\"glyphicon glyphicon-question-sign pull-right\" title=\"Unckeck tests to remove\" data-toggle=\"tooltip\"></span></a><h1 class=\"panel-title\">Temporary bucket</h1></div><div class=\"row panel-body\" ng-show=\"tempBucket.length > 0\"><div class=\"col-md-6\" id=\"tempBucketId\" ng-repeat=\"test in tempBucket track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.removeFromBucket(test)\"> {{test.name}}</div></div><div class=\"panel-footer clearfix\"><button class=\"btn btn-primary btn pull-right\" ng-show=\"tempBucket.length > 0\" ng-click=\"medicalTestMethods.addTestToPermanentBucket($index)\">Create group</button></div></div><div class=\"panel panel-default\" ng-repeat=\"bucket in groups\" ng-show=\"bucket.length > 0\"><div class=\"panel-heading\"><button type=\"button\" class=\"close\" ng-click=\"medicalTestMethods.removeBucketFromGroup($index)\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button> <strong class=\"text-uppercase\">Bucket : {{$index}}</strong></div><div class=\"row panel-body\"><div class=\"col-md-12\" ng-repeat=\"test in bucket track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.removeFromGroups(test)\"> {{test.name}}</div><div class=\"row ddllocation\" ng-show=\"$index > 0\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-6\"><label for=\"\">Select a state</label><select name=\"newstateId\" ng-model=\"testData.testStateId\" class=\"form-control\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-6\"><label for=\"\">Select a city</label><select name=\"newcityId\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\" class=\"form-control\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-6\"><label for=\"\">Select a locality</label><select name=\"newlocalityId\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\" class=\"form-control\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div><div class=\"col-md-6\"><label for=\"\">Select sub locality</label><select name=\"newsublocalityId\" ng-model=\"testData.testSubLocalityId\" ng-change=\"loadLocationData(\'dc\',testData.testSubLocalityId)\" class=\"form-control\"><option value=\"\">Select sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div></div></div></div><div class=\"row ddllocation\" ng-show=\"$index > 0\"><div class=\"col-md-4\"><label for=\"\">Select a diagnostic centre</label><select id=\"dcid_{{$index}}\" name=\"pkgDCId\" class=\"form-control\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in allDCs\">{{dc.entityName}}</option></select></div><div class=\"col-md-4\"><label for=\"\">Preferred date & time</label> <input id=\"datetime_{{$index}}\" type=\"datetime-local\" class=\"form-control datetimepicker\"></div><div class=\"col-md-4\"><label for=\"\">Select a visit type</label><select id=\"visittype_{{$index}}\" name=\"visitType\" class=\"form-control\"><option value=\"\">Select a visit type</option><option value=\"22\">Appointment</option><option value=\"70\">Call</option><option value=\"71\">Home visit</option></select></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"medicalTestMethods.splitRequests(groups)\" data-dismiss=\"modal\">Split</button></div></div></div></div><div class=\"modal fade\" id=\"UTC\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Telly Underwriting {{tuModel}}</h4></div><div class=\"modal-body\"><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"doa\">Upload File *</label><mb-plus-file-upload action=\"action\" file-fn=\"fileFn(arg, \'report\')\"></mb-plus-file-upload></div><div class=\"col-md-6\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"2\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div><div class=\"row\"><div class=\"col-sm-1\"></div><div class=\"col-md-10\"><div ng-if=\"storeFiles.length >0\" class=\"form-group col-md-6\" ng-repeat=\"item in storeFiles\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: #eeeeee;\"><a ng-click=\"downloadAttachment(item.filePath)\">{{item.fileName}}</a> <a ng-click=\"removeFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div><div class=\"col-sm-1\"></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" ng-disabled=\"storeFiles.length ===0 || !action.remarks\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'UTC\',$event)\" data-dismiss=\"modal\">Submit</button></div></div></div></div><div class=\"modal fade\" id=\"UTCAwaited\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Telly Underwriting {{tuModel}}</h4></div><div class=\"modal-body\"><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"2\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" ng-disabled=\"!action.remarks\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'UTCAwaited\',$event)\" data-dismiss=\"modal\">Submit</button></div></div></div></div><div class=\"modal fade\" id=\"RelatedRequestModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Related Requests</h4></div><div class=\"modal-body\"><div class=\"row related {{request.isCurrent}}\" ng-repeat=\"request in relatedrequests\"><div class=\"col-md-1 text-center\"><i class=\"glyphicon glyphicon-{{request.iconName}} circle\"></i></div><div class=\"col-md-11\"><strong>{{request.additionalInformation.productName}}</strong><br><span class=\"small\">{{request.currentStatus}} | {{getAuditDate(request.fulfillmentDate)}} | {{request.additionalInformation.providerName}}</span></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><script type=\"text/ng-template\" id=\"walletModal.html\"><div class=\"modal-content\"> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button> <h4 style=\"color: #005da2;\" class=\"modal-title\">Wallet balance</h4> </div> <div class=\"modal-body\"> <div class=\"col-md-12\"> <div class=\"row\" ng-show=\"isSuccess\"> <div class=\"col-md-4\"></div> <div class=\"col-md-4\"> <strong style=\"color:red;font-size:2em;\">{{showWalletBalanceMsz}}</strong> </div> <div class=\"col-md-4\"></div> </div> <div class=\"row\" ng-show=\"!isSuccess\"> <br /> <div class=\"col-md-1\"></div> <div class=\"col-md-10\" style=\"text-align:center;\"> <strong style=\"color: red; font-size: 1em;\">{{showWalletBalanceMsz}}</strong> </div> <div class=\"col-md-1\"></div> </div> </div> </div><br /><br /><br /> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"closeModal()\">Close</button> </div> </div></script><div class=\"modal fade\" id=\"openVarifyPres\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Verify prescriptions</h4></div><div class=\"modal-body\"><ul><li ng-repeat=\"pres in PharmaPrescriptionList\"><a href=\"{{pres.filePath}}\" target=\"_blank\">{{pres.fileName}}</a> <button class=\"removeLargeDocument\" ng-click=\"removePrescriptions($index)\">x</button></li></ul></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"verifyPrescription(PharmaPrescriptionList)\" ng-if=\"PharmaPrescriptionList.length>0\">Update</button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"openVarifyPresModal(\'\',\'reload\')\" ng-if=\"!PharmaPrescriptionList.length>0\">Reload prescription</button> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"grievanceModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\" data-keyboard=\"false\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Grievance Reports</h4><hr><div class=\"row\"><div class=\"form-group col-md-12\"><div class=\"form-group\"><label for=\"\">Comment</label> <input type=\"text\" class=\"form-control\" ng-model=\"grive.griveComment\"></div><label>Upload files <button style=\"margin-left: 10px;\" class=\"btn btn-primary btn-sm corrBtn pull-right CorrespondenceButton\" ng-click=\"fileUploadMethods.addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add More Files</span></button></label><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"row\"><div class=\"col-sm-9\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\"><button class=\"removeLargeDocument\" ng-click=\"fileUploadMethods.removeFileToUpload($index)\">-</button></div></div></fieldset></div></div></div><div class=\"modal-body\" style=\"height: 330px;overflow-y: auto;\" ng-show=\"previousGrievancesComments\"><div class=\"row\"><div class=\"col-md-11\" style=\"border:1px solid; margin-left:35px;\"><h4 style=\"color: #2196F3; margin-left: 10px;\">Previous grievance</h4><br><div class=\"panel panel-default\" ng-repeat=\"grev in previousGrievancesComments\"><div class=\"panel-heading panel-primary\"><b>{{$index+1}} - Grievance <span ng-show=\"grev.grievDate\">raised on {{grev.grievDate}}</span></b></div><div class=\"panel-body\"><div style=\"border: 1px solid; padding: 4px; background: rgba(221, 221, 221, 0.35);\"><b>Reason:</b> {{grev.grievanceComment}}</div><br><ul><li ng-repeat=\"(key, name) in grev.grievanceReport\"><a href=\"{{key}}\" target=\"_blank\" style=\"color: #5bc0de; font-weight:600; text-anchor: initial; line-height: inherit;\">{{name}}</a></li></ul></div></div></div><div class=\"col-md-1\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"addGrive()\">Submit</button></div></div></div></div><div class=\"slideBox\" ng-class=\"isCostomerDetails ? \'in\': \'\'\"><div class=\"slideContent\"><div class=\"modal-header\"><a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"isCostomerDetails=!isCostomerDetails\"><span aria-hidden=\"true\">&times;</span></a><h4 class=\"modal-title\">Customer additional details</h4></div><div class=\"modal-body\"><h4>Few details for your reference</h4><table><tr><td style=\"width: 140px;\">Name:</td><td><b>{{displayTestDetails.name}}</b></td></tr><tr><td>Address:</td><td><b>{{displayTestDetails.addressLine1}}</b></td></tr><tr><td>City:</td><td><b>{{displayTestDetails.city}}</b></td></tr><tr><td>State:</td><td><b>{{displayTestDetails.state}}</b></td></tr><tr><td>Mobile no.:</td><td><b>{{displayTestDetails.mobileNumber}}</b></td></tr></table><h4 style=\"margin-top: 30px;\" ng-if=\"showData.testDetails.length >0\">Test details for your reference</h4><table class=\"table table-hover\" ng-show=\"showData.testDetails.length>0\"><thead><th>Test name</th><th ng-if=\"showData.erid !==177887\">Appointment date & time</th><th ng-if=\"showData.erid ===177887\">Appointment date</th><th ng-if=\"showData.erid ===177887\">Appointment time</th><th>Visit type</th></thead><tbody><tr ng-repeat=\"test in showData.testDetails\"><td>{{test.testName}}</td><td ng-if=\"showData.erid !==177887\">{{compareDate(test.appointmentDate)}} | {{formatTime(test.appointmentDate)}}</td><td ng-if=\"showData.erid ===177887\">{{getDateObj(test.appointmentDate) |date:\'dd-MMM-yyyy\'}}</td><td ng-if=\"showData.erid ===177887\">{{test.appointmentTime}}</td><td>{{test.visitType}}</td></tr></tbody></table><hr><h4 style=\"margin-top: 30px;\" ng-if=\"newAdditionalInfo.length >0\">Additional Information</h4><div class=\"row\"><div class=\"col-md-4\"><label for=\"additional\"><select class=\"form-control\" id=\"additional\" name=\"additional\" ng-model=\"field.fieldName\"><option disabled=\"\" value=\"\">Select</option><option ng-repeat=\"item in additionalFieldList\" value=\"{{item}}\">{{item}}</option></select></label></div><div class=\"col-md-4\"><label for=\"fieldValue\"><input class=\"form-control\" ng-disabled=\"!field.fieldName\" name=\"fieldValue\" id=\"fieldValue\" ng-model=\"field.fieldValue\" placeholder=\"Enter {{field.fieldName}}\" style=\"border-radius: 0;\"></label></div><div class=\"col-md-2\"><span><button class=\"btn btn-primary\" ng-disabled=\"!field.fieldValue\" ng-click=\"addToAdditionDetails()\" style=\"margin:0;\">Add</button></span></div></div><p ng-repeat=\"(key, value) in additionalInfo track by $index\" style=\"margin-top: 10px;\"><span style=\"font-size: larger; font-weight: 500;\">{{key}}</span> : {{value}}</p></div></div></div><div class=\"slideBox\" ng-class=\"isCart ? \'in\': \'\'\"><div class=\"slideContent\"><div class=\"modal-header\"><a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"closeCart()\"><span aria-hidden=\"true\">&times;</span></a><h4 class=\"modal-title\">You are booking packages for <span style=\"color:#4d90fe;\">{{displayTestDetails.name}}</span><br><span style=\"font-size:14px;\">at <b><span ng-if=\"selectedDcFromDavanceSearch.name\">{{selectedDcFromDavanceSearch.name}}</span> <span ng-if=\"selectedDcName\">{{selectedDcName}}</span> <span ng-if=\"selectedTime\">{{selectedTime | date:\'dd-MMM-yyyy @ h:mma\'}}</span></b> <span ng-if=\"selectedDcFromDavanceSearch.entityAddress\">, {{selectedDcFromDavanceSearch.entityAddress}}</span></span></h4></div><div class=\"modal-body\"><div class=\"cartEmpty\" ng-show=\"cartEmpty\"><div class=\"empty text-center\">Cart is empty</div></div><div id=\"cartItems\" ng-show=\"!cartEmpty\"><div>Ap</div><div ng-repeat=\"item in orderObj.orderItems\"><div class=\"row package-item\"><div class=\"col-md-7\">{{item.productName}}</div><div class=\"col-md-3 text-right\">Rs.{{item.amount}}/-</div><div class=\"col-md-2 text-right\"><button class=\"btn btn-xs btn-block btn-danger delete\" value=\"\" id=\"{{item.productId}}\" ng-click=\"removeOrderItem(item, event)\">Remove</button></div></div><hr></div></div><div class=\"row package-item\" ng-if=\"!cartEmpty && orderObj.orderItems.length >0\" style=\"margin-bottom: 10px;\"><div class=\"col-md-7\">Grand total</div><div class=\"col-md-3 text-right\">Rs.{{totalPrice}}/-</div><div class=\"col-md-2\"></div></div><div class=\"form-create card\" ng-show=\"showPaid\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"paid\">Paid</label> <input type=\"radio\" id=\"paid\" name=\"optradio\" checked=\"checked\" value=\"\" ng-click=\"paid=true\"></div><div class=\"col-md-6\"><label for=\"unpaid\">Unpaid</label> <input type=\"radio\" id=\"unpaid\" name=\"optradio\" value=\"\" ng-click=\"paid=false\"></div></div><strong>Transaction details</strong><hr><div class=\"alert alert-danger\" ng-show=\"showPaid && paid\" role=\"alert\">Since this is a paid package, You need to fill the following <span class=\"strong\">Transaction details</span></div><div class=\"alert alert-danger\" ng-show=\"showPaid && !paid\" role=\"alert\">Unpaid orders will be collected in \"UnConfirmed Orders\" bucket. Once their availability is confirmed with DC, they will be approved and payment link will be sent to the user. These orders moves to active appointments, only after user makes the payment</div><div ng-show=\"showPaid && paid\"><label for=\"\">UTR number *</label> <input id=\"txnNumberPreEmp\" class=\"form-control\" ng-model=\"txn.txnNumber\"></div></div></div><button class=\"btn btn-primary btn-block\" ng-click=\"checkDuplicacy()\" ng-show=\"!cartEmpty && orderObj.orderItems.length >0\">Create Appointment</button></div></div></div><div class=\"modal fade\" id=\"selectedPacakgesList\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\" style=\"padding:0 15px;\"><a href=\"\"><span class=\"pull-right\" data-dismiss=\"modal\"><b>X</b></span></a><h4>Selected packages</h4></div><div class=\"modal-body\" id=\"chooseDCBody\"><ul><li ng-repeat=\"item in selectedPackageForAdvance\">{{item.packageName}}<br></li></ul></div></div></div></div><div class=\"modal fade\" id=\"ViewCorresponddenceModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Communication history</h4></div><div class=\"modal-body\"><div ng-repeat=\"corres in correspondencData track by $index\" ng-if=\"correspondencData.length>0\"><h4>Communication {{$index + 1}}</h4><ul><li>Customer status : <b>{{corres.callStatusValue}}</b></li><li>Comment: <b>{{corres.comment}}</b></li><li>Created on: <b>{{compareDate(corres.createdOn)}}</b></li></ul><hr></div><div ng-if=\"!correspondencData.length>0\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><h4 style=\"color:red\">{{correspondencError}}</h4></div><div class=\"col-md-2\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"deleteRequest\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button ng-click=\"cancelPopup()\" type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Delete Confirmation</h4></div><div class=\"modal-body\"><p class=\"text-center\">Are you sure you want to delete the order?</p><button type=\"button\" style=\"margin-left: 222px;\" class=\"btn btn-default\" ng-click=\"cancelPopup()\" data-dismiss=\"modal\">No</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"deleteOrderEueue(true, orderDetails)\">Yes</button></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"cancelPopup()\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"AddCorresponddenceModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Add correspondence</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label for=\"calltype\">Select a receiver</label><select class=\"form-control\" name=\"calltype\" id=\"calltype\" ng-model=\"corres.calltype\"><option value=\"{{calltype.key}}\" ng-repeat=\"calltype in calltypes\">{{calltype.value}}</option></select><br><label for=\"callstatus\">Select appropriate call status</label><select class=\"form-control\" name=\"callstatus\" id=\"callstatus\" ng-change=\"callStatusTemplate(corres.callstatus)\" ng-model=\"corres.callstatus\"><option value=\"{{callstatus.key}}\" ng-repeat=\"callstatus in callstatuses\">{{callstatus.value}}</option></select><br><label for=\"work\">Select type of status</label><select class=\"form-control\" name=\"work\" id=\"work\" ng-model=\"corres.workStatus\"><option value=\"workable\">Workable</option><option value=\"nonWorkable\">Non Workable</option></select><br><div ng-if=\"showCalender\"><div class=\"form-group col-md-6\"><label for=\"first-name\" class=\"control-label required-field\">Select Date and time</label><div class=\"input-group\" style=\"margin-top:11px;\"><input id=\"\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"callDateTime.prefDate\" is-open=\"popup6.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" min-date=\"mindate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open6()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group col-md-6\"><div uib-timepicker=\"\" ng-model=\"callDateTime.prefTime\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\" ng-change=\"getDateTime(callDateTime.prefDate, callDateTime.prefTime)\"></div></div></div><br><div><label for=\"\">UIC number</label> <input type=\"text\" ng-model=\"uicDetail.uicNumber\" class=\"form-control\" placeholder=\"Enter UIC number\"></div><br><div ng-show=\"getCallStatus == \'79\' || getCallStatus == \'82\'\"><label for=\"sms\">Send template as<span style=\"color:red;\" ng-show=\"putInsurer.length>0\"><strong>({{putInsurer}})</strong></span></label> <textarea name=\"\" id=\"sms\" cols=\"30\" rows=\"3\" class=\"form-control\" ng-model=\"mailTemplate\" required=\"\"></textarea></div><div ng-show=\"getCallStatus == \'124\'\"><label for=\"sms\">Send template as</label> <textarea name=\"\" id=\"sms\" cols=\"30\" rows=\"7\" class=\"form-control\" ng-model=\"apolloMailTemplate\" readonly=\"true\"></textarea></div><label for=\"remarks\">Add correspondence notes *</label> <textarea name=\"\" id=\"correspondenceremarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"corres.corrremarks\" required=\"\"></textarea></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" id=\"btnAddCorrespondence\" ng-click=\"addCorrespond()\">Add correspondence</button> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div></div>");
$templateCache.put("app/modules/appointments/allappointments.html","<div><div><button class=\"btn btn-info btn-sm pull-right\" uib-tooltip=\"reload appointments\" ng-click=\"reloadAppointments()\" style=\"margin-left:10px;color: #060606;background-color: #dddddd;border-color: #dddddd;\">Reload appointments</button></div><div class=\"claims\"><angular-tab appointmentlist=\"allAppointments\" tabname=\"\'All Appointments\'\" tabtype=\"\'plusAllAppointments\'\" callback-fn=\"ctrlFn(arg)\"></angular-tab></div></div>");
$templateCache.put("app/modules/appointments/appointments.html","<div><style>\n        .btn-reload {\n            float: right;\n            margin-top: -33px;\n            margin-left: 1px;\n        }\n\n        .input-xs {\n            height: 22px;\n            line-height: 22px;\n            padding: 0 5px;\n        }\n\n        .investigationName {\n            background: #8bf2eb;\n        }\n\n        .popover {\n            position: absolute;\n            z-index: 100;\n        }\n\n        .modalHeaderText {\n            color: #005da2;\n        }\n    </style><script type=\"text/ng-template\" id=\"customPopupTemplate.html\"><div class=\"custom-popup-wrapper\" ng-style=\"{top: 0+\'px\', left: 0+\'px\'}\" style=\"display: block; position: relative\" ng-show=\"isOpen() && !moveInProgress\" aria-hidden=\"{{!isOpen()}}\"> <p class=\"message\">select from drop down.</p> <ul class=\"dropdown-menu\" role=\"listbox\" style=\"display: block; position: relative; margin-top: -12px;\"> <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.entityName}}\"> <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div> </li> </ul> </div></script><uib-accordion close-others=\"oneAtATime\" ng-if=\"isOpenAccordian\"><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"status.isFirstOpen\"><uib-accordion-heading><a style=\"color: #168cc9;\">Search panel</a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isFirstOpen, \'glyphicon-chevron-right\': !status.isFirstOpen}\"></i></uib-accordion-heading><ng-form block-ui=\"searchAppointmentsData\" name=\"userProfileForm\" class=\"form-horizontal\"><div id=\"user-profile\" class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"\" class=\"control-label required-field col-sm-4\">Date type</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"serverSearch.dateWiseSearch\"><option value=\"apptdate\">Appointment date</option><option value=\"createddate\">Creation date</option></select></div></div><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Status</label><div class=\"col-sm-8\"><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-options=\"option.name for option in activeStatusesData track by option.id\" ng-model=\"serverSearch.statusSearch\"></select></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Date from</label><div class=\"col-sm-8\"><div class=\"input-group\"><input placeholder=\"Select from date\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"serverSearch.fromDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group\" ng-if=\"isSearchToShow\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Appointment type</label><div class=\"col-sm-8\"><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-change=\"getCorporatePackages(serverSearch.contractType.id)\" ng-options=\"option.entityName for option in contracts track by option.id\" ng-model=\"serverSearch.contractType\"></select></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Date to</label><div class=\"col-sm-8\"><div class=\"input-group\"><input id=\"datetimeEnd\" placeholder=\"Select to date\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"serverSearch.toDate\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group\" ng-if=\"isSearchToShow\"><label for=\"last-name\" class=\"control-label col-sm-4 required-field\">Corporate</label><div class=\"col-sm-8\"><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-options=\"option.entityName for option in contractsData track by option.id\" ng-model=\"serverSearch.corporateId\"></select></div></div><div class=\"form-group\"><label for=\"city\" class=\"control-label required-field col-sm-4\"></label><div class=\"col-sm-8\"><button class=\"btn btn-primary\" ng-model=\"search\" ng-click=\"searchAppointmentsGroup(serverSearch.statusSearch, serverSearch.contractType, serverSearch.corporateId,serverSearch.fromDate, serverSearch.toDate);\">Search</button> <button class=\"btn primary\" ng-click=\"clearSearch()\">Clear</button></div></div></div></div></ng-form></div></uib-accordion><script type=\"text/ng-template\" id=\"myPopoverTemplate.html\"><div class=\"\"> <h3>A guide to the types of search filter and how to use them</h3> </div></script><i ng-if=\"false\" style=\"margin-top: 5px; margin-left: -540px;\" class=\"fa fa-info\" aria-hidden=\"true\" uib-popover-template=\"dynamicPopover.templateUrl\" popover-placement=\"bottom\" popover-trigger=\"\'mouseenter\'\" type=\"button\">Info</i><hr><div ng-if=\"isOpenAccordian\" class=\"pull-right form-inline text-right\" style=\"margin-top: 0px; width: 400px;\"><button class=\"btn btn-info btn-sm pull-right\" uib-tooltip=\"reload appointments\" ng-click=\"reloadAppointments()\" style=\"margin-left:10px;color: #060606;background-color: #dddddd;border-color: #dddddd;\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"claims\" block-ui=\"appointmentsData\"><angular-tab appointmentlist=\"activeAppointments\" tabname=\"\'Active Appointments\'\" tabtype=\"\'plusActiveAppointments\'\"></angular-tab></div><div class=\"modal fade\" id=\"{{actionName}}Modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 126\">Fit with Recommendation</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 127\">Fitness on hold</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 128\">Temporary unfit</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 98\">Fit appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 119\">Cancelled by Insurer</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 120\">Closed by Insurer</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 97\">Unfit appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 30 || actionId ===29\">Reschedule appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 48\">Approve appointment by QC</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 24 || actionId ===23\">Confirm the appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 27 || actionId === 42\">Reject an appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 37\">Submit reports of this appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 34\">Approve appointment for payment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 32\">Confirm customer attendance</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 39\">Confirm customer attendance</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 33\">Request for more information</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 91\">Place with partner</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 87\">Delivered</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 88\">Out for delivery</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 89\">Confirmation by retailer</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 116\">Partially attended</h4></div><div class=\"modal-body\" ng-show=\"actionId === 48\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-4\"><label for=\"doa\">Appointment date *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div><div class=\"col-md-4\"><label for=\"doa\">Actual Appointment Date</label><div class=\"input-group\"><input placeholder=\"Select from date\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"popupQc.actualDate\" is-open=\"popupQc.opened\" datepicker-options=\"dateOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openQcDate()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-4\"><label for=\"doa\">Doctor Qualification *</label><select required=\"\" ng-model=\"doctorQualificatio\" style=\"padding: 6px 12px; color: #555; background-color: #fff; background-image: none; border-radius: 4px;\"><option value=\"\">Select Qualification</option><option value=\"MMBS\">MMBS</option><option value=\"MD\">MD</option><option value=\"NonMBBS\">Non MBBS</option></select></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Photograph available</label><br><input type=\"radio\" ng-model=\"isPhotoAvailble.value\" value=\"true\">Yes <input type=\"radio\" ng-model=\"isPhotoAvailble.value\" value=\"false\">No</div></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 98 || actionId === 97 || actionId === 126 || actionId === 127 || actionId === 128\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"frmFit\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks</label><span ng-show=\"frmFit.remarks.$invalid\" class=\"redfont\">*</span> <textarea name=\"remarks\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks.fit\" required=\"\"></textarea></div></div><br><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Blood group</label><span ng-show=\"frmFit.bloodGrp.$invalid\" class=\"redfont\">*</span><select class=\"form-control\" ng-model=\"bloodGrp.selectedBloodGrp\" required=\"\"><option value=\"\">Select blood group</option><option value=\"O+\">O+</option><option value=\"O-\">O-</option><option value=\"A+\">A+</option><option value=\"A-\">A-</option><option value=\"B+\">B+</option><option value=\"B-\">B-</option><option value=\"AB+\">AB+</option><option value=\"AB-\">AB-</option><option value=\"NA\">N/A</option></select></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 119 || actionId === 120\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"InsurerAction\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"remarks\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div><br></form></div><div class=\"modal-body\" ng-show=\"actionId === 30 || actionId ===29\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"rescheduleForm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Current requested Date</label> <input name=\"doa\" id=\"originalDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-5\"><label for=\"doa\">Select reschedule date</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"reschedule.opened\" datepicker-options=\"dateOptionsReschedule\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"reschedule()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\" ng-if=\"actionId === 30 || actionId ===29\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><br><div class=\"alert alert-danger\" role=\"alert\">Customer has provided {{secondPreferredVTime}} as second preference. We would like you to consider this if possible.</div><span ng-show=\"showChkedOnDcLogin\"><input type=\"checkbox\" ng-click=\"showDcSelection(action.showdcselection, \'dcVisit\')\" ng-model=\"action.showdcselection\"> Check this to select a new diagnostic centre</span><br><span ng-show=\"showChkedOnDcLogin\"><input type=\"checkbox\" ng-click=\"showDcSelection(action.showHomeVisitSelection, \'homeVisit\')\" ng-model=\"action.showHomeVisitSelection\"> Check this to enter home address for home visit</span><hr><div class=\"\" ng-show=\"action.showHomeVisitSelection\"><label for=\"\">Enter home address to move this appointment</label><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-6 noPdngRt\"><input type=\"text\" class=\"form-control\" ng-model=\"homeVisit.addressLineOne\" placeholder=\"Enter Address line 1\"></div><div class=\"col-md-6 noPdngRt\"><input type=\"text\" class=\"form-control\" ng-model=\"homeVisit.addressLinTwo\" placeholder=\"Enter Address line 2\"></div></div><div class=\"\"><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testStateId\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div><div class=\"col-md-4\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div></div><div class=\"row\"><div class=\"col-md-6 noPdngRt\"><select name=\"\" id=\"sublocalityId\" class=\"form-control\" ng-model=\"testData.testSubLocalityId\" ng-change=\"loadLocationData(\'dc\', testData.testSubLocalityId)\"><option value=\"\">Select a sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div><div class=\"col-md-6\"><select name=\"\" id=\"dcId\" ng-model=\"testData.dcValue\" class=\"form-control\" ng-change=\"changeDc(testData.dcValue)\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in diagnosticCentres track by $index\">{{dc.entityName}}</option></select></div></div></div></div><div class=\"\" ng-show=\"action.showdcselection\"><label for=\"doa\">Select a provider to move this appointment</label><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testStateId\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div><div class=\"col-md-4\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div></div><div class=\"row\"><div class=\"col-md-6 noPdngRt\"><select name=\"\" id=\"sublocalityId\" class=\"form-control\" ng-model=\"testData.testSubLocalityId\" ng-change=\"loadLocationData(\'dc\', testData.testSubLocalityId)\"><option value=\"\">Select a sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div><div class=\"col-md-6\"><select name=\"\" id=\"dcId\" ng-model=\"testData.dcValue\" class=\"form-control\" ng-change=\"changeDc(testData.dcValue)\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in diagnosticCentres track by $index\">{{dc.entityName}}</option></select></div></div></div><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></form></div><div class=\"modal-body\" ng-show=\"actionId === 24 || actionId ===23\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"frmConfirm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"doa\">Requested date of visit</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"row\" style=\"margin-top:10px; margin-bottom:10px;\" ng-if=\"action.showPrice\"><div class=\"col-md-6 noPdngRt\"><label for=\"doa\">Dc price</label><span class=\"redfont\">*</span> <input name=\"date\" id=\"dcPrice\" class=\"form-control\" type=\"number\" ng-model=\"action.dcPrice\" required=\"\"></div></div><ng-container ng-if=\"homeVisitCheck\"><label for=\"type\" style=\"margin-top:25px; margin-bottom:15px;\">Home Visit By</label><div class=\"row\"><div ng-repeat=\"visitType in homeVisitTypeArray\" class=\"col-md-6\"><label style=\"font-weight:normal\"><input type=\"checkbox\" value=\"visitType.id\" ng-click=\"toggleHomeVisitType(visitType)\" style=\"float:left; margin-right:5px;\"> {{visitType.name}}</label></div></div></ng-container><div class=\"row\" style=\"margin-top:15px;\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks</label><span ng-show=\"frmConfirm.remarks.$invalid\" class=\"redfont\">*</span> <textarea name=\"remarks\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 27\"><form name=\"rejectForm\"><label for=\"enhance-remarks\">Reasons for rejecting appointment: *</label><select class=\"form-control\" ng-model=\"action.cancelReason\" ng-change=\"resetDependencies(action.cancelReason)\" required=\"\"><option value=\"\">select cancellation reason</option><option value=\"{{f}}\" ng-repeat=\"f in reasonOfCancel\">{{f}}</option></select><br><textarea ng-if=\"action.cancelReason==\'Other\'\" name=\"reject-remarks\" ng-model=\"action.cancelComments\" class=\"form-control\" id=\"reject-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your reason to reject the appointment\" required=\"\"></textarea> <span>Appointment that has been rejected won\'t be completely removed from the queue. It has to be accepted by MAHS operations person in order to permanently cancel it*</span></form></div><div class=\"modal-body\" ng-show=\"actionId === 42\"><form name=\"rejectForm\"><label for=\"enhance-remarks\">Reasons for rejecting appointment: *</label><select class=\"form-control\" ng-model=\"action.cancelReason\" ng-change=\"resetDependencies(action.cancelReason)\" required=\"\"><option value=\"\">select cancellation reason</option><option value=\"{{f}}\" ng-repeat=\"f in reasonOfCancel\">{{f}}</option></select><br><textarea ng-if=\"action.cancelReason==\'Other\'\" name=\"reject-remarks\" ng-model=\"action.cancelComments\" class=\"form-control\" id=\"reject-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your reason to reject the appointment\" required=\"\"></textarea> <span>Appointment that has been rejected won\'t be completely removed from the queue. It has to be accepted by MAHS operations person in order to permanently cancel it*</span></form></div><div class=\"modal-body\" ng-show=\"actionId === 34\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Appointment date *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"date\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 32\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"attendedForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label>Actual date of visit *</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"attended.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"attended()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"col-md-2\" ng-if=\"actionId === 32\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div><div class=\"row col-md-12 col-sm-12 col-sm-12\"><label for=\"enhance-remarks\">Feedback*</label><select class=\"form-control\" ng-model=\"action.feedback\" required=\"\"><option value=\"\">select your feedback</option><option value=\"{{feedback}}\" ng-repeat=\"feedback in feedbackList\">{{feedback}}</option></select><br></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 39\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"notAttendedForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"> <label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 33\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"Raise_IAModalForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"remarks\">Details about requested information *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 37\"><form name=\"submitForm\" action=\"\" class=\"form\"><div class=\"alert alert-danger\" role=\"alert\">Please upload bills and reports appropriately to avoid delay in processing as well as repeated requests for more information</div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Attach lab reports *</label><mb-plus-file-upload action=\"action\" file-fn=\"fileFn(arg, \'report\')\"></mb-plus-file-upload></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Attach bills</label><mb-plus-file-upload action=\"action\" file-fn=\"fileFn(arg, \'bill\')\"></mb-plus-file-upload></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ng-if=\"storeFiles.length >0\" class=\"form-group col-md-6\" ng-repeat=\"item in storeFiles\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: rgb(238, 238, 238);font-size: 12px;\"><a ng-click=\"downloadAttachment(item.filePath)\">{{item.fileName}}</a> <a ng-click=\"removeFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div><div class=\"col-md-6\"><div ng-if=\"storedBill.length >0\" class=\"form-group col-md-6\" ng-repeat=\"item in storedBill\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: rgb(238, 238, 238);font-size: 12px;\"><a ng-click=\"downloadAttachment(item.filePath)\">{{item.fileName}}</a> <a ng-click=\"removeBillFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div></div><label for=\"\">Remarks</label> <textarea name=\"Remarks\" id=\"Remarks\" cols=\"30\" rows=\"3\" class=\"form-control\" ng-model=\"action.remarks\"></textarea></form></div><div class=\"modal-body\" ng-show=\"actionId === 91\"><form name=\"frmPlacePartner\"><div class=\"row\"><div class=\"col-md-12\"><input type=\"text\" ng-model=\"action.partnerOrderId\" class=\"form-control\" placeholder=\"Partner Order ID\" required=\"\"></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 87\"><form name=\"frmDelivered\"><div class=\"row\"><div class=\"col-md-6\"><input type=\"number\" ng-model=\"pharmaData.cashlessAmt\" class=\"form-control\" placeholder=\"Cashless Amount\" required=\"\"></div><div class=\"col-md-6\"><input type=\"number\" ng-model=\"pharmaData.CODAmt\" class=\"form-control\" placeholder=\"Cash On Delivery Amount\" required=\"\"></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 88\"><div class=\"row\"><div class=\"col-md-12\"><h4 style=\"margin-left: 145px;color: #a94442;\">Item is out for delivery</h4></div></div></div><div class=\"modal-body\" ng-show=\"actionId === 89\"><div class=\"row\"><div class=\"col-md-12\"><h4 style=\"margin-left: 145px;color: #a94442;\">Waiting for retailer confirmation</h4></div></div></div><div class=\"modal-body\" ng-show=\"actionId === 116\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"attendedPartiallyForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label>Actual date of visit *</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"attended.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"attended()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"col-md-2\" ng-if=\"actionId === 116\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea style=\"resize: vertical;\" name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Fit\',$event)\" ng-show=\"actionId === 98\">Fit appointment</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'UnFit\',$event)\" ng-show=\"actionId === 97\">Unfit appointment</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'FitWithRecommendation\',$event)\" ng-show=\"actionId === 126\">Fit with recommendation appointment</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'FitnessOnHold\',$event)\" ng-show=\"actionId === 127\">Fitness on hold appointment</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'TemporaryUnfit\',$event)\" ng-show=\"actionId === 128\">Temporary unfit appointment</button> <button type=\"button\" ng-disabled=\"rescheduleForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Reschedule\',$event)\" ng-show=\"actionId === 30|| actionId ===29\">Request for reschedule</button> <button type=\"button\" ng-disabled=\"InsurerAction.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'InsurerAction\',$event)\" ng-show=\"actionId === 119|| actionId ===120\">Insurer Update</button> <button type=\"button\" ng-disabled=\"frmConfirm.$invalid || (homeVisitCheck && action && action.homeVisitType && action.homeVisitType.length < 1)\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Confirm\',$event)\" ng-show=\"actionId === 24 || actionId ===23\">Confirm appointment</button> <button type=\"button\" ng-disabled=\"rejectForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Cancel\',$event)\" ng-show=\"actionId === 27 || actionId === 42\">Submit</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Submit\',$event)\" id=\"fileUploadBtn\" ng-show=\"actionId === 37\" ng-disabled=\"!storeFiles.length\">Submit</button> <button type=\"button\" ng-disabled=\"approveForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Approve\',$event)\" ng-show=\"actionId === 34\">Approve for payment</button> <button type=\"button\" ng-disabled=\"attendedForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Attended\',$event)\" ng-show=\"actionId === 32\">Confirm attendance</button> <button type=\"button\" ng-disabled=\"notAttendedForm.$invalid\" class=\"btn btn-danger\" ng-click=\"actionRequest(\'NotAttended\',$event)\" ng-show=\"actionId === 39\">Not attended</button> <button type=\"button\" ng-disabled=\"Raise_IAModalForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Raise_IA\',$event)\" ng-show=\"actionId === 33\">Request</button> <button type=\"button\" ng-disabled=\"approveForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'QCApprove\',$event)\" ng-show=\"actionId === 48\">Qc approved</button> <button type=\"button\" ng-disabled=\"frmPlacePartner.$invalid\" class=\"btn btn-primary\" ng-click=\"placeWithPartner()\" ng-show=\"actionId === 91\">Place order</button> <button type=\"button\" ng-disabled=\"frmDelivered.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Delivered\',$event)\" ng-show=\"actionId === 87\">Confirm</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'OutForDelivery\',$event)\" ng-show=\"actionId === 88\">Out for delivery</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'ConfirmByRetailer\',$event)\" ng-show=\"actionId === 89\">Confirm</button> <button type=\"button\" ng-disabled=\"attendedpartiallyformclass.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'PartiallyAttended\',$event)\" ng-show=\"actionId === 116\">Confirm partially attended</button></div></div></div></div><div class=\"modal fade\" id=\"SplitRequestModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Split this request</h4></div><div class=\"modal-body\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h1 class=\"panel-title\">Related test bucket</h1></div><div class=\"row panel-body\"><div class=\"col-md-6\" id=\"tempBucketId\" ng-repeat=\"test in relatedTests track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.addTestToTempBucket(test)\"> {{test.name}} <span ng-show=\"relatedTests.length == 0\"><label>No tests found!</label></span></div></div></div><div class=\"panel panel-default\" ng-show=\"tempBucket.length > 0\"><div class=\"panel-heading\"><a href=\"\"><span class=\"glyphicon glyphicon-question-sign pull-right\" title=\"Unckeck tests to remove\" data-toggle=\"tooltip\"></span></a><h1 class=\"panel-title\">Temporary bucket</h1></div><div class=\"row panel-body\" ng-show=\"tempBucket.length > 0\"><div class=\"col-md-6\" id=\"tempBucketId\" ng-repeat=\"test in tempBucket track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.removeFromBucket(test)\"> {{test.name}}</div></div><div class=\"panel-footer clearfix\"><button class=\"btn btn-primary btn pull-right\" ng-show=\"tempBucket.length > 0\" ng-click=\"medicalTestMethods.addTestToPermanentBucket($index)\">Create group</button></div></div><div class=\"panel panel-default\" ng-repeat=\"bucket in groups\" ng-show=\"bucket.length > 0\"><div class=\"panel-heading\"><button type=\"button\" class=\"close\" ng-click=\"medicalTestMethods.removeBucketFromGroup($index)\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button> <strong class=\"text-uppercase\">Bucket : {{$index}}</strong></div><div class=\"row panel-body\"><div class=\"col-md-12\" ng-repeat=\"test in bucket track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.removeFromGroups(test)\"> {{test.name}}</div><div class=\"row ddllocation\" ng-show=\"$index > 0\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-6\"><label for=\"\">Select a state</label><select name=\"newstateId\" ng-model=\"testData.testStateId\" class=\"form-control\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-6\"><label for=\"\">Select a city</label><select name=\"newcityId\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\" class=\"form-control\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-6\"><label for=\"\">Select a locality</label><select name=\"newlocalityId\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\" class=\"form-control\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div><div class=\"col-md-6\"><label for=\"\">Select sub locality</label><select name=\"newsublocalityId\" ng-model=\"testData.testSubLocalityId\" ng-change=\"loadLocationData(\'dc\',testData.testSubLocalityId)\" class=\"form-control\"><option value=\"\">Select sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div></div></div></div><div class=\"row ddllocation\" ng-show=\"$index > 0\"><div class=\"col-md-4\"><label for=\"\">Select a diagnostic centre</label><select id=\"dcid_{{$index}}\" name=\"pkgDCId\" class=\"form-control\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in allDCs\">{{dc.entityName}}</option></select></div><div class=\"col-md-4\"><label for=\"\">Preferred date & time</label> <input id=\"datetime_{{$index}}\" type=\"datetime-local\" class=\"form-control datetimepicker\"></div><div class=\"col-md-4\"><label for=\"\">Select a visit type</label><select id=\"visittype_{{$index}}\" name=\"visitType\" class=\"form-control\"><option value=\"\">Select a visit type</option><option value=\"22\">Appointment</option><option value=\"70\">Call</option><option value=\"71\">Home visit</option></select></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"medicalTestMethods.splitRequests(groups)\" data-dismiss=\"modal\">Split</button></div></div></div></div><div class=\"modal fade\" id=\"UTC\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Telly Underwriting {{tuModel}}</h4></div><div class=\"modal-body\"><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"doa\">Upload File *</label><mb-plus-file-upload action=\"action\" file-fn=\"fileFn(arg, \'report\')\"></mb-plus-file-upload></div><div class=\"col-md-6\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"2\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div><div class=\"row\"><div class=\"col-sm-1\"></div><div class=\"col-md-10\"><div ng-if=\"storeFiles.length >0\" class=\"form-group col-md-6\" ng-repeat=\"item in storeFiles\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: #eeeeee;\"><a ng-click=\"downloadAttachment(item.filePath)\">{{item.fileName}}</a> <a ng-click=\"removeFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div><div class=\"col-sm-1\"></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" ng-disabled=\"storeFiles.length ===0 || !action.remarks\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'UTC\',$event)\" data-dismiss=\"modal\">Submit</button></div></div></div></div><div class=\"modal fade\" id=\"UTCAwaited\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Telly Underwriting {{tuModel}}</h4></div><div class=\"modal-body\"><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"2\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" ng-disabled=\"!action.remarks\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'UTCAwaited\',$event)\" data-dismiss=\"modal\">Submit</button></div></div></div></div><div class=\"modal fade\" id=\"RelatedRequestModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Related Requests</h4></div><div class=\"modal-body\"><div class=\"row related {{request.isCurrent}}\" ng-repeat=\"request in relatedrequests\"><div class=\"col-md-1 text-center\"><i class=\"glyphicon glyphicon-{{request.iconName}} circle\"></i></div><div class=\"col-md-11\"><strong>{{request.additionalInformation.productName}}</strong><br><span class=\"small\">{{request.currentStatus}} | {{getAuditDate(request.fulfillmentDate)}} | {{request.additionalInformation.providerName}}</span></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><script type=\"text/ng-template\" id=\"walletModal.html\"><div class=\"modal-content\"> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button> <h4 style=\"color: #005da2;\" class=\"modal-title\">Wallet balance</h4> </div> <div class=\"modal-body\"> <div class=\"col-md-12\"> <div class=\"row\" ng-show=\"isSuccess\"> <div class=\"col-md-4\"></div> <div class=\"col-md-4\"> <strong style=\"color:red;font-size:2em;\">{{showWalletBalanceMsz}}</strong> </div> <div class=\"col-md-4\"></div> </div> <div class=\"row\" ng-show=\"!isSuccess\"> <br /> <div class=\"col-md-1\"></div> <div class=\"col-md-10\" style=\"text-align:center;\"> <strong style=\"color: red; font-size: 1em;\">{{showWalletBalanceMsz}}</strong> </div> <div class=\"col-md-1\"></div> </div> </div> </div><br /><br /><br /> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"closeModal()\">Close</button> </div> </div></script><div class=\"modal fade\" id=\"openVarifyPres\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Verify prescriptions</h4></div><div class=\"modal-body\"><ul><li ng-repeat=\"pres in PharmaPrescriptionList\"><a href=\"{{pres.filePath}}\" target=\"_blank\">{{pres.fileName}}</a> <button class=\"removeLargeDocument\" ng-click=\"removePrescriptions($index)\">x</button></li></ul></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"verifyPrescription(PharmaPrescriptionList)\" ng-if=\"PharmaPrescriptionList.length>0\">Update</button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"openVarifyPresModal(\'\',\'reload\')\" ng-if=\"!PharmaPrescriptionList.length>0\">Reload prescription</button> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"grievanceModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\" data-keyboard=\"false\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Grievance Reports</h4><hr><div class=\"row\"><div class=\"form-group col-md-12\"><div class=\"form-group\"><label for=\"\">Comment</label> <input type=\"text\" class=\"form-control\" ng-model=\"grive.griveComment\"></div><label>Upload files <button style=\"margin-left: 10px;\" class=\"btn btn-primary btn-sm corrBtn pull-right CorrespondenceButton\" ng-click=\"fileUploadMethods.addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add More Files</span></button></label><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"row\"><div class=\"col-sm-9\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\"><button class=\"removeLargeDocument\" ng-click=\"fileUploadMethods.removeFileToUpload($index)\">-</button></div></div></fieldset></div></div></div><div class=\"modal-body\" style=\"height: 330px;overflow-y: auto;\" ng-show=\"previousGrievancesComments\"><div class=\"row\"><div class=\"col-md-11\" style=\"border:1px solid; margin-left:35px;\"><h4 style=\"color: #2196F3; margin-left: 10px;\">Previous grievance</h4><br><div class=\"panel panel-default\" ng-repeat=\"grev in previousGrievancesComments\"><div class=\"panel-heading panel-primary\"><b>{{$index+1}} - Grievance <span ng-show=\"grev.grievDate\">raised on {{grev.grievDate}}</span></b></div><div class=\"panel-body\"><div style=\"border: 1px solid; padding: 4px; background: rgba(221, 221, 221, 0.35);\"><b>Reason:</b> {{grev.grievanceComment}}</div><br><ul><li ng-repeat=\"(key, name) in grev.grievanceReport\"><a href=\"{{key}}\" target=\"_blank\" style=\"color: #5bc0de; font-weight:600; text-anchor: initial; line-height: inherit;\">{{name}}</a></li></ul></div></div></div><div class=\"col-md-1\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"addGrive()\">Submit</button></div></div></div></div></div>");
$templateCache.put("app/modules/appointments/newAppointmentRequest.html","<div><div class=\"row\"><h4 style=\"margin-left: 15px;margin-top: 0px;font-weight: 400;\">Appointment Filter</h4><div class=\"col-md-4\"><div class=\"form-group\"><div class=\"input-group\"><input id=\"datetimeFirst\" placeholder=\"Start Date\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"filtere.fromDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" ng-change=\"filtere.toDate=null\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><div class=\"input-group\"><input id=\"datetimeEnd\" readonly=\"\" placeholder=\"End Date\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"filtere.toDate\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" min-date=\"filtere.fromDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><button class=\"btn btn-primary\" ng-model=\"search\" ng-click=\"loadPageData()\">Search</button> <button class=\"btn primary\" ng-disabled=\"filtere.toDate ===\'\' && filtere.fromDate ===\'\'\" ng-click=\"resetDateValues()\">Clear</button> <button class=\"btn btn-default pull-right\" ng-if=\"totalRows\" ng-click=\"downloadDashBoardReport()\">Export <i class=\"glyphicon glyphicon-download-alt\"></i></button></div></div></div><div class=\"claims\" block-ui=\"appointmentsData\" ng-if=\"refreshData\"><angular-tab appointmentlist=\"activeAppointments\" tabname=\"tabHeading\" tabtype=\"\'plusActiveAppointments\'\" callback-fn=\"ctrlFn(arg)\" current-page=\"currentPage\"></angular-tab></div></div><div class=\"modal fade\" id=\"{{actionName}}Modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 126\">Fit with Recommendation</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 127\">Fitness on hold</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 128\">Temporary unfit</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 98\">Fit appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 119\">Cancelled by Insurer</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 120\">Closed by Insurer</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 97\">Unfit appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 30 || actionId ===29\">Reschedule appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 48\">Approve appointment by QC</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 24 || actionId ===23\">Confirm the appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 27 || actionId === 42\">Reject an appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 37\">Submit reports of this appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 34\">Approve appointment for payment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 32\">Confirm customer attendance</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 39\">Confirm customer attendance</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 33\">Request for more information</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 91\">Place with partner</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 87\">Delivered</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 88\">Out for delivery</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 89\">Confirmation by retailer</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 116\">Partially attended</h4></div><div class=\"modal-body\" ng-show=\"actionId === 48\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-4\"><label for=\"doa\">Appointment date *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div><div class=\"col-md-4\"><label for=\"doa\">Actual Appointment Date</label><div class=\"input-group\"><input placeholder=\"Select from date\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"popupQc.actualDate\" is-open=\"popupQc.opened\" datepicker-options=\"dateOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openQcDate()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-4\"><label for=\"doa\">Doctor Qualification *</label><select required=\"\" ng-model=\"doctorQualificatio\" style=\"padding: 6px 12px; color: #555; background-color: #fff; background-image: none; border-radius: 4px;\"><option value=\"\">Select Qualification</option><option value=\"MMBS\">MMBS</option><option value=\"MD\">MD</option><option value=\"NonMBBS\">Non MBBS</option></select></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Photograph available</label><br><input type=\"radio\" ng-model=\"isPhotoAvailble.value\" value=\"true\">Yes <input type=\"radio\" ng-model=\"isPhotoAvailble.value\" value=\"false\">No</div></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 98 || actionId === 97 || actionId === 126 || actionId === 127 || actionId === 128\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"frmFit\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks</label><span ng-show=\"frmFit.remarks.$invalid\" class=\"redfont\">*</span> <textarea name=\"remarks\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks.fit\" required=\"\"></textarea></div></div><br><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Blood group</label><span ng-show=\"frmFit.bloodGrp.$invalid\" class=\"redfont\">*</span><select class=\"form-control\" ng-model=\"bloodGrp.selectedBloodGrp\" required=\"\"><option value=\"\">Select blood group</option><option value=\"O+\">O+</option><option value=\"O-\">O-</option><option value=\"A+\">A+</option><option value=\"A-\">A-</option><option value=\"B+\">B+</option><option value=\"B-\">B-</option><option value=\"AB+\">AB+</option><option value=\"AB-\">AB-</option><option value=\"NA\">N/A</option></select></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 119 || actionId === 120\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"InsurerAction\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"remarks\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div><br></form></div><div class=\"modal-body\" ng-show=\"actionId === 30 || actionId ===29\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"rescheduleForm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Current requested Date</label> <input name=\"doa\" id=\"originalDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-5\"><label for=\"doa\">Select reschedule date</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"reschedule.opened\" datepicker-options=\"dateOptionsReschedule\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"reschedule()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\" ng-if=\"actionId === 30 || actionId ===29\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><br><div class=\"alert alert-danger\" role=\"alert\">Customer has provided {{secondPreferredVTime}} as second preference. We would like you to consider this if possible.</div><span ng-show=\"showChkedOnDcLogin\"><input type=\"checkbox\" ng-click=\"showDcSelection(action.showdcselection, \'dcVisit\')\" ng-model=\"action.showdcselection\"> Check this to select a new diagnostic centre</span><br><span ng-show=\"showChkedOnDcLogin\"><input type=\"checkbox\" ng-click=\"showDcSelection(action.showHomeVisitSelection, \'homeVisit\')\" ng-model=\"action.showHomeVisitSelection\"> Check this to enter home address for home visit</span><hr><div class=\"\" ng-show=\"action.showHomeVisitSelection\"><label for=\"\">Enter home address to move this appointment</label><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-6 noPdngRt\"><input type=\"text\" class=\"form-control\" ng-model=\"homeVisit.addressLineOne\" placeholder=\"Enter Address line 1\"></div><div class=\"col-md-6 noPdngRt\"><input type=\"text\" class=\"form-control\" ng-model=\"homeVisit.addressLinTwo\" placeholder=\"Enter Address line 2\"></div></div><div class=\"\"><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testStateId\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div><div class=\"col-md-4\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div></div><div class=\"row\"><div class=\"col-md-6 noPdngRt\"><select name=\"\" id=\"sublocalityId\" class=\"form-control\" ng-model=\"testData.testSubLocalityId\" ng-change=\"loadLocationData(\'dc\', testData.testSubLocalityId)\"><option value=\"\">Select a sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div><div class=\"col-md-6\"><select name=\"\" id=\"dcId\" ng-model=\"testData.dcValue\" class=\"form-control\" ng-change=\"changeDc(testData.dcValue)\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in diagnosticCentres track by $index\">{{dc.entityName}}</option></select></div></div></div></div><div class=\"\" ng-show=\"action.showdcselection\"><label for=\"doa\">Select a provider to move this appointment</label><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testStateId\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div><div class=\"col-md-4\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div></div><div class=\"row\"><div class=\"col-md-6 noPdngRt\"><select name=\"\" id=\"sublocalityId\" class=\"form-control\" ng-model=\"testData.testSubLocalityId\" ng-change=\"loadLocationData(\'dc\', testData.testSubLocalityId)\"><option value=\"\">Select a sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div><div class=\"col-md-6\"><select name=\"\" id=\"dcId\" ng-model=\"testData.dcValue\" class=\"form-control\" ng-change=\"changeDc(testData.dcValue)\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in diagnosticCentres track by $index\">{{dc.entityName}}</option></select></div></div></div><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></form></div><div class=\"modal-body\" ng-show=\"actionId === 24 || actionId ===23\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"frmConfirm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"doa\">Requested date of visit</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"row\" style=\"margin-top:10px; margin-bottom:10px;\" ng-if=\"action.showPrice\"><div class=\"col-md-6 noPdngRt\"><label for=\"doa\">Dc price</label><span class=\"redfont\">*</span> <input name=\"date\" id=\"dcPrice\" class=\"form-control\" type=\"number\" ng-model=\"action.dcPrice\" required=\"\"></div></div><ng-container ng-if=\"homeVisitCheck\"><label for=\"type\" style=\"margin-top:25px; margin-bottom:15px;\">Home Visit By <span class=\"redfont\">*</span></label><div class=\"row\"><div ng-repeat=\"visitType in homeVisitTypeArray\" class=\"col-md-6\"><label style=\"font-weight:normal\"><input type=\"checkbox\" value=\"visitType.id\" ng-click=\"homeVisitBy(visitType,$event)\" style=\"float:left; margin-right:5px;\"> {{visitType.name}}</label></div></div></ng-container><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks <span class=\"redfont\">*</span></label> <textarea name=\"remarks\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 27\"><form name=\"rejectForm\"><label for=\"enhance-remarks\">Reasons for rejecting appointment: *</label><select class=\"form-control\" ng-model=\"action.cancelReason\" ng-change=\"resetDependencies(action.cancelReason)\" required=\"\"><option value=\"\">select cancellation reason</option><option value=\"{{f}}\" ng-repeat=\"f in reasonOfCancel\">{{f}}</option></select><br><textarea ng-if=\"action.cancelReason==\'Other\'\" name=\"reject-remarks\" ng-model=\"action.cancelComments\" class=\"form-control\" id=\"reject-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your reason to reject the appointment\" required=\"\"></textarea> <span>Appointment that has been rejected won\'t be completely removed from the queue. It has to be accepted by MAHS operations person in order to permanently cancel it*</span></form></div><div class=\"modal-body\" ng-show=\"actionId === 42\"><form name=\"rejectForm\"><label for=\"enhance-remarks\">Reasons for rejecting appointment: *</label><select class=\"form-control\" ng-model=\"action.cancelReason\" ng-change=\"resetDependencies(action.cancelReason)\" required=\"\"><option value=\"\">select cancellation reason</option><option value=\"{{f}}\" ng-repeat=\"f in reasonOfCancel\">{{f}}</option></select><br><textarea ng-if=\"action.cancelReason==\'Other\'\" name=\"reject-remarks\" ng-model=\"action.cancelComments\" class=\"form-control\" id=\"reject-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your reason to reject the appointment\" required=\"\"></textarea> <span>Appointment that has been rejected won\'t be completely removed from the queue. It has to be accepted by MAHS operations person in order to permanently cancel it*</span></form></div><div class=\"modal-body\" ng-show=\"actionId === 34\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Appointment date *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"date\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 32\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"attendedForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label>Actual date of visit *</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"attended.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"attended()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"col-md-2\" ng-if=\"actionId === 32\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div><div class=\"row col-md-12 col-sm-12 col-sm-12\"><label for=\"enhance-remarks\">Feedback*</label><select class=\"form-control\" ng-model=\"action.feedback\" required=\"\"><option value=\"\">select your feedback</option><option value=\"{{feedback}}\" ng-repeat=\"feedback in feedbackList\">{{feedback}}</option></select><br></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 39\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"notAttendedForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"> <label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 33\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"Raise_IAModalForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"remarks\">Details about requested information *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 37\"><form name=\"submitForm\" action=\"\" class=\"form\"><div class=\"alert alert-danger\" role=\"alert\">Please upload bills and reports appropriately to avoid delay in processing as well as repeated requests for more information</div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Attach lab reports *</label><mb-plus-file-upload action=\"action\" file-fn=\"fileFn(arg, \'report\')\"></mb-plus-file-upload></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Attach bills</label><mb-plus-file-upload action=\"action\" file-fn=\"fileFn(arg, \'bill\')\"></mb-plus-file-upload></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ng-if=\"storeFiles.length >0\" class=\"form-group col-md-6\" ng-repeat=\"item in storeFiles\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: rgb(238, 238, 238);font-size: 12px;\"><a ng-click=\"downloadAttachment(item.filePath)\">{{item.fileName}}</a> <a ng-click=\"removeFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;top: 0%\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div><div class=\"col-md-6\"><div ng-if=\"storedBill.length >0\" class=\"form-group col-md-6\" ng-repeat=\"item in storedBill\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: rgb(238, 238, 238);font-size: 12px;\"><a ng-click=\"downloadAttachment(item.filePath)\">{{item.fileName}}</a> <a ng-click=\"removeBillFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;top: 0%\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div></div><label for=\"\">Remarks</label> <textarea name=\"Remarks\" id=\"Remarks\" cols=\"30\" rows=\"3\" class=\"form-control\" ng-model=\"action.remarks\"></textarea></form></div><div class=\"modal-body\" ng-show=\"actionId === 91\"><form name=\"frmPlacePartner\"><div class=\"row\"><div class=\"col-md-12\"><input type=\"text\" ng-model=\"action.partnerOrderId\" class=\"form-control\" placeholder=\"Partner Order ID\" required=\"\"></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 87\"><form name=\"frmDelivered\"><div class=\"row\"><div class=\"col-md-6\"><input type=\"number\" ng-model=\"pharmaData.cashlessAmt\" class=\"form-control\" placeholder=\"Cashless Amount\" required=\"\"></div><div class=\"col-md-6\"><input type=\"number\" ng-model=\"pharmaData.CODAmt\" class=\"form-control\" placeholder=\"Cash On Delivery Amount\" required=\"\"></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 88\"><div class=\"row\"><div class=\"col-md-12\"><h4 style=\"margin-left: 145px;color: #a94442;\">Item is out for delivery</h4></div></div></div><div class=\"modal-body\" ng-show=\"actionId === 89\"><div class=\"row\"><div class=\"col-md-12\"><h4 style=\"margin-left: 145px;color: #a94442;\">Waiting for retailer confirmation</h4></div></div></div><div class=\"modal-body\" ng-show=\"actionId === 116\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"attendedPartiallyForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label>Actual date of visit *</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"attended.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"attended()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"col-md-2\" ng-if=\"actionId === 116\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea style=\"resize: vertical;\" name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Fit\',$event)\" ng-show=\"actionId === 98\">Fit appointment</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'UnFit\',$event)\" ng-show=\"actionId === 97\">Unfit appointment</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'FitWithRecommendation\',$event)\" ng-show=\"actionId === 126\">Fit with recommendation appointment</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'FitnessOnHold\',$event)\" ng-show=\"actionId === 127\">Fitness on hold appointment</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'TemporaryUnfit\',$event)\" ng-show=\"actionId === 128\">Temporary unfit appointment</button> <button type=\"button\" ng-disabled=\"rescheduleForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Reschedule\',$event)\" ng-show=\"actionId === 30|| actionId ===29\">Request for reschedule</button> <button type=\"button\" ng-disabled=\"InsurerAction.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'InsurerAction\',$event)\" ng-show=\"actionId === 119|| actionId ===120\">Insurer Update</button> <button type=\"button\" ng-disabled=\"!(frmConfirm.$valid)\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Confirm\',$event)\" ng-show=\"actionId === 24 || actionId ===23\">Confirm appointment</button> <button type=\"button\" ng-disabled=\"rejectForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Cancel\',$event)\" ng-show=\"actionId === 27 || actionId === 42\">Submit</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Submit\',$event)\" id=\"fileUploadBtn\" ng-show=\"actionId === 37\" ng-disabled=\"!storeFiles.length\">Submit</button> <button type=\"button\" ng-disabled=\"approveForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Approve\',$event)\" ng-show=\"actionId === 34\">Approve for payment</button> <button type=\"button\" ng-disabled=\"attendedForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Attended\',$event)\" ng-show=\"actionId === 32\">Confirm attendance</button> <button type=\"button\" ng-disabled=\"notAttendedForm.$invalid\" class=\"btn btn-danger\" ng-click=\"actionRequest(\'NotAttended\',$event)\" ng-show=\"actionId === 39\">Not attended</button> <button type=\"button\" ng-disabled=\"Raise_IAModalForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Raise_IA\',$event)\" ng-show=\"actionId === 33\">Request</button> <button type=\"button\" ng-disabled=\"approveForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'QCApprove\',$event)\" ng-show=\"actionId === 48\">Qc approved</button> <button type=\"button\" ng-disabled=\"frmPlacePartner.$invalid\" class=\"btn btn-primary\" ng-click=\"placeWithPartner()\" ng-show=\"actionId === 91\">Place order</button> <button type=\"button\" ng-disabled=\"frmDelivered.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Delivered\',$event)\" ng-show=\"actionId === 87\">Confirm</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'OutForDelivery\',$event)\" ng-show=\"actionId === 88\">Out for delivery</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'ConfirmByRetailer\',$event)\" ng-show=\"actionId === 89\">Confirm</button> <button type=\"button\" ng-disabled=\"attendedpartiallyformclass.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'PartiallyAttended\',$event)\" ng-show=\"actionId === 116\">Confirm partially attended</button></div></div></div></div><div class=\"modal fade\" id=\"SplitRequestModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Split this request</h4></div><div class=\"modal-body\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h1 class=\"panel-title\">Related test bucket</h1></div><div class=\"row panel-body\"><div class=\"col-md-6\" id=\"tempBucketId\" ng-repeat=\"test in relatedTests track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.addTestToTempBucket(test)\"> {{test.name}} <span ng-show=\"relatedTests.length == 0\"><label>No tests found!</label></span></div></div></div><div class=\"panel panel-default\" ng-show=\"tempBucket.length > 0\"><div class=\"panel-heading\"><a href=\"\"><span class=\"glyphicon glyphicon-question-sign pull-right\" title=\"Unckeck tests to remove\" data-toggle=\"tooltip\"></span></a><h1 class=\"panel-title\">Temporary bucket</h1></div><div class=\"row panel-body\" ng-show=\"tempBucket.length > 0\"><div class=\"col-md-6\" id=\"tempBucketId\" ng-repeat=\"test in tempBucket track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.removeFromBucket(test)\"> {{test.name}}</div></div><div class=\"panel-footer clearfix\"><button class=\"btn btn-primary btn pull-right\" ng-show=\"tempBucket.length > 0\" ng-click=\"medicalTestMethods.addTestToPermanentBucket($index)\">Create group</button></div></div><div class=\"panel panel-default\" ng-repeat=\"bucket in groups\" ng-show=\"bucket.length > 0\"><div class=\"panel-heading\"><button type=\"button\" class=\"close\" ng-click=\"medicalTestMethods.removeBucketFromGroup($index)\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button> <strong class=\"text-uppercase\">Bucket : {{$index}}</strong></div><div class=\"row panel-body\"><div class=\"col-md-12\" ng-repeat=\"test in bucket track by test.id\"><input type=\"checkbox\" value=\"{{test.name}}\" id=\"{{test.id}}\" ng-model=\"test.checkTest\" ng-click=\"medicalTestMethods.removeFromGroups(test)\"> {{test.name}}</div><div class=\"row ddllocation\" ng-show=\"$index > 0\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-6\"><label for=\"\">Select a state</label><select name=\"newstateId\" ng-model=\"testData.testStateId\" class=\"form-control\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-6\"><label for=\"\">Select a city</label><select name=\"newcityId\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\" class=\"form-control\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-6\"><label for=\"\">Select a locality</label><select name=\"newlocalityId\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\" class=\"form-control\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div><div class=\"col-md-6\"><label for=\"\">Select sub locality</label><select name=\"newsublocalityId\" ng-model=\"testData.testSubLocalityId\" ng-change=\"loadLocationData(\'dc\',testData.testSubLocalityId)\" class=\"form-control\"><option value=\"\">Select sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div></div></div></div><div class=\"row ddllocation\" ng-show=\"$index > 0\"><div class=\"col-md-4\"><label for=\"\">Select a diagnostic centre</label><select id=\"dcid_{{$index}}\" name=\"pkgDCId\" class=\"form-control\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in allDCs\">{{dc.entityName}}</option></select></div><div class=\"col-md-4\"><label for=\"\">Preferred date & time</label> <input id=\"datetime_{{$index}}\" type=\"datetime-local\" class=\"form-control datetimepicker\"></div><div class=\"col-md-4\"><label for=\"\">Select a visit type</label><select id=\"visittype_{{$index}}\" name=\"visitType\" class=\"form-control\"><option value=\"\">Select a visit type</option><option value=\"22\">Appointment</option><option value=\"70\">Call</option><option value=\"71\">Home visit</option></select></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"medicalTestMethods.splitRequests(groups)\" data-dismiss=\"modal\">Split</button></div></div></div></div><div class=\"modal fade\" id=\"grievanceModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\" data-keyboard=\"false\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Grievance Reports</h4><hr><div class=\"row\"><div class=\"form-group col-md-12\"><div class=\"form-group\"><label for=\"\">Comment</label> <input type=\"text\" class=\"form-control\" ng-model=\"grive.griveComment\"></div><label>Upload files <button style=\"margin-left: 10px;\" class=\"btn btn-primary btn-sm corrBtn pull-right CorrespondenceButton\" ng-click=\"fileUploadMethods.addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add More Files</span></button></label><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"row\"><div class=\"col-sm-9\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\"><button class=\"removeLargeDocument\" ng-click=\"fileUploadMethods.removeFileToUpload($index)\">-</button></div></div></fieldset></div></div></div><div class=\"modal-body\" style=\"height: 330px;overflow-y: auto;\" ng-show=\"previousGrievancesComments\"><div class=\"row\"><div class=\"col-md-11\" style=\"border:1px solid; margin-left:35px;\"><h4 style=\"color: #2196F3; margin-left: 10px;\">Previous grievance</h4><br><div class=\"panel panel-default\" ng-repeat=\"grev in previousGrievancesComments\"><div class=\"panel-heading panel-primary\"><b>{{$index+1}} - Grievance <span ng-show=\"grev.grievDate\">raised on {{grev.grievDate}}</span></b></div><div class=\"panel-body\"><div style=\"border: 1px solid; padding: 4px; background: rgba(221, 221, 221, 0.35);\"><b>Reason:</b> {{grev.grievanceComment}}</div><br><ul><li ng-repeat=\"(key, name) in grev.grievanceReport\"><a href=\"{{key}}\" target=\"_blank\" style=\"color: #5bc0de; font-weight:600; text-anchor: initial; line-height: inherit;\">{{name}}</a></li></ul></div></div></div><div class=\"col-md-1\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"addGrive()\">Submit</button></div></div></div></div>");
$templateCache.put("app/modules/appointments/relatedRequests.html","<div class=\"tab-pane fade active in\"><div class=\"panel panel-default\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><div class=\"claim-info\"><div class=\"row related {{request.isCurrent}}\" ng-repeat=\"request in relatedrequests\"><div class=\"col-md-1\" text-center=\"\"><i class=\"glyphicon glyphicon-{{request.iconName}} circle\"></i></div><div class=\"col-md-11\"><strong>{{request.additionalInformation.productName}}</strong><br><span class=\"small\">{{request.currentStatus}} | {{getAuditDate(request.fulfillmentDate)}} | {{request.additionalInformation.providerName}}</span></div></div></div><div class=\"col-md-2\"></div></div><div class=\"col-md-2\"></div></div></div></div></div>");
$templateCache.put("app/modules/approvalQueue/approvalQueue.html","<div><section class=\"hbox\"><section id=\"content\"><section class=\"vbox\"><section class=\"panel\"><div class=\"panel-body\"><form class=\"form\" role=\"form\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><div class=\"form-group col-md-10\"><input type=\"text\" class=\"form-control\" id=\"searchWorkItems\" placeholder=\"Search requests\" ng-model=\"searchItems\"></div><a class=\"btn btn-default col-md-2\" ng-click=\"searchItems = \'\'\">Clear</a></div><div class=\"col-md-2\"></div></div></form></div></section><section class=\"scrollable wrapper\"><div class=\"row\"><div class=\"col-md-12\"><section class=\"panel\"><header class=\"panel-heading bg-info lt no-border\"><ul class=\"nav nav-tabs nav-left\" id=\"myTabs\"><li class=\"active\"><a href=\"#activeWorkItemsPan\" data-toggle=\"tab\" ng-click=\"SetWorkitemType(\'active\')\">Active Work Items</a></li><li><a href=\"#OtherWorkItems\" data-toggle=\"tab\" ng-click=\"SetWorkitemType(\'inactive\')\">Other Work Items</a></li><li class=\"pull-right\" style=\"margin-top:3px;margin-right:3px\"><div><select id=\"queueType\" name=\"queueType\" class=\"form-control\" style=\"height:31px;padding-top:4px\" ng-model=\"corpId\" ng-change=\"getQueueForCorporate(workitemtype)\"><option value=\"0\">All corporates</option><option ng-repeat=\"qt in corporateList\" value=\"{{qt}}\">{{qt.corporateName}}</option></select></div></li></ul></header><a href=\"\" id=\"goTop\" style=\"margin-right:-5px\"><i class=\"fa fa-arrow-up\"></i></a><div class=\"panel-body claim-details-content\"><div id=\"scrDiv\" style=\"height:{{scrHei}}; overflow-y:scroll; margin:0 -10px;padding-right:5px\"><div class=\"tab-content\"><div class=\"tab-pane active\" id=\"activeWorkItemsPan\"><div ng-hide=\"activeWI.length == 0\"><table class=\"table table-hover table-bordered table-condensed tblSmallFont\"><thead><tr><th>Claim ref no</th><th>Received on</th><th>Benef MAID</th><th>Benef name</th><th>Pri benef name</th><th>Policy holder</th><th>Emp id</th><th>Claim type</th><th>Locked by</th><th id=\"top-scroll\">View</th></tr></thead><tbody class=\"container\"><tr ng-repeat=\"entry in requestsFiltered | startFrom:0 | limitTo:entryLimit\" scroll-on-click=\"\" style=\"border-bottom: 1px solid #f1f1f1\"><td style=\"vertical-align: bottom;\">{{entry.sourceSystemIdentifier}}</td><td style=\"vertical-align: bottom;\" ng-show=\"entry.sourceRecDate!=undefined\">{{formatDate(entry.sourceRecDate)}} {{formatTime(entry.sourceRecDate)}}</td><td style=\"vertical-align: bottom;\" ng-show=\"entry.sourceRecDate==undefined\">{{entry.workItemCreationTime}}</td><td style=\"vertical-align: bottom;\">{{entry.benefMediAssistId}}</td><td style=\"vertical-align: bottom;\">{{entry.benefName}}</td><td style=\"vertical-align: bottom;\">{{entry.priBenefName}}</td><td style=\"vertical-align: bottom;\">{{entry.policyHolder}}</td><td style=\"vertical-align: bottom;\">{{entry.employeeId}}</td><td style=\"vertical-align: bottom;\">{{entry.claimType}}</td><td style=\"vertical-align: bottom;\">{{entry.lockedByUser}}</td><td style=\"vertical-align: bottom;\"><button id=\"domidetails\" ng-click=\"broadcastEvent(entry)\" ng-if=\"entry.claimType == \'Domiciliary\'\" ng-disabled=\"(entry.isLocked == true) && (entry.lockedByUser != user.loginName)\" ng-show=\"displayThis(\'UPDATE\',\'CLAIM QUEUE\')\" class=\"btn btn-default btn-xs\" data-target=\"#attachDetailsDomiModal\" data-toggle=\"modal\" model=\"{{entry}}\">Details</button> <button id=\"activedetails\" ng-click=\"broadcastEvent(entry)\" ng-if=\"entry.claimType != \'Domiciliary\'\" ng-disabled=\"(entry.isLocked == true) && (entry.lockedByUser != user.loginName)\" ng-show=\"displayThis(\'UPDATE\',\'CLAIM QUEUE\')\" class=\"btn btn-default btn-xs\" data-target=\"#attachDetailsModal\" data-toggle=\"modal\" model=\"{{entry}}\">Details</button></td></tr></tbody></table><pagination data-boundary-links=\"true\" data-num-pages=\"noOfPages\" data-current-page=\"currentPage\" max-size=\"maxSize\" class=\"pagination-small pagination-centered\" data-previous-text=\"&laquo;\" data-next-text=\"&raquo;\" on-select-page=\"pageChanged(page)\"></pagination></div><div class=\"col-md-12\" ng-show=\"activeWI.length == 0\" style=\"padding:0\"><section class=\"panel\"><header class=\"panel-heading bg-danger lt no-border\"><span class=\"text-white package-name\">Error</span></header><div class=\"panel-body\"><form role=\"form\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8 text-center\"><p>We could not find any work items.</p></div><div class=\"col-md-2\"></div></div></form></div></section></div><footer class=\"footer bg-white b-t\"><div class=\"row text-center-xs\"><div class=\"col-md-12 hidden-sm\" style=\"padding:0;\"><p class=\"text-muted m-t col-md-5\" style=\"padding:0;\" ng-hide=\"activeWorkItems.length == 0\">Showing {{pageStartRecord}} - {{pageEndRecord}} of {{totalCount}} in Page {{currentPage}}</p></div></div></footer></div><div class=\"tab-pane active\" id=\"OtherWorkItems\"><div ng-hide=\"OtherWI.length == 0\"><table class=\"table table-hover table-bordered table-condensed tblSmallFont\"><thead><tr><th>Claim ref no</th><th>Received on</th><th>Benef MAID</th><th>Benef name</th><th>Pri benef name</th><th>Policy holder</th><th>Emp id</th><th>Claim type</th><th>Status</th><th>Locked by</th><th id=\"top-scroll\">View</th></tr></thead><tbody class=\"container\"><tr ng-repeat=\"entry in requestsFiltered | startFrom:0 | limitTo:entryLimit\" scroll-on-click=\"\" style=\"border-bottom: 1px solid #f1f1f1\"><td style=\"vertical-align: bottom;\">{{entry.sourceSystemIdentifier}}</td><td style=\"vertical-align: bottom;\" ng-show=\"entry.sourceRecDate!=undefined\">{{formatDate(entry.sourceRecDate)}} {{formatTime(entry.sourceRecDate)}}</td><td style=\"vertical-align: bottom;\" ng-show=\"entry.sourceRecDate==undefined\">{{entry.workItemCreationTime}}</td><td style=\"vertical-align: bottom;\">{{entry.benefMediAssistId}}</td><td style=\"vertical-align: bottom;\">{{entry.benefName}}</td><td style=\"vertical-align: bottom;\">{{entry.priBenefName}}</td><td style=\"vertical-align: bottom;\">{{entry.policyHolder}}</td><td style=\"vertical-align: bottom;\">{{entry.employeeId}}</td><td style=\"vertical-align: bottom;\">{{entry.claimType}}</td><td style=\"vertical-align: bottom;\">{{entry.queueWorkItemStatusDesc}}</td><td style=\"vertical-align: bottom;\">{{entry.lockedByUser}}</td><td style=\"vertical-align: bottom;\"><button id=\"otherdetails\" ng-click=\"broadcastEvent(entry)\" ng-disabled=\"((entry.isLocked == true) && (entry.lockedByUser != user.loginName))||entry.queueWorkItemStatusId==3\" ng-show=\"displayThis(\'UPDATE\',\'CLAIM QUEUE\')\" class=\"btn btn-default btn-xs\" data-target=\"#attachDetailsModal\" data-toggle=\"modal\" model=\"{{entry}}\">Details</button></td></tr></tbody></table><pagination data-boundary-links=\"true\" data-num-pages=\"noOfPages\" data-current-page=\"currentPage\" max-size=\"maxSize\" class=\"pagination-small pagination-centered\" data-previous-text=\"&laquo;\" data-next-text=\"&raquo;\" on-select-page=\"pageChanged(page)\"></pagination></div><div class=\"col-md-12\" ng-show=\"OtherWI.length == 0 && workitemtype==\'inactive\'\" style=\"padding:0\"><section class=\"panel\"><header class=\"panel-heading bg-danger lt no-border\"><span class=\"text-white package-name\">Error</span></header><div class=\"panel-body\"><form role=\"form\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8 text-center\"><p>We could not find any work items.</p></div><div class=\"col-md-2\"></div></div></form></div></section></div><footer class=\"footer bg-white b-t\"><div class=\"row text-center-xs\"><div class=\"col-md-12 hidden-sm\" style=\"padding:0;\"><p class=\"text-muted m-t col-md-5\" style=\"padding:0;\" ng-hide=\"OtherWI.length == 0 && workitemtype==\'active\'\">Showing {{pageStartRecord}} - {{pageEndRecord}} of {{totalCount}} in Page {{currentPage}}</p></div></div></footer></div></div></div></div></section></div></div></section></section><a href=\"#\" class=\"hide nav-off-screen-block\" data-toggle=\"class:nav-off-screen\" data-target=\"#nav\"></a></section></section></div><div class=\"modal fade\" id=\"hospitalMap\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-dialog-custom modal-lg\" role=\"document\"><div class=\"modal-content modal-content-custom\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"unLockItem()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Action</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer footer\"><div class=\"form-group\"><div class=\"col-md-2 pull-right\"><button type=\"button\" data-dismiss=\"modal\" class=\"form-control btn-default pull-right\" ng-click=\"unLockItem()\">Close</button></div><div class=\"col-md-2\"><button type=\"button\" class=\"form-control btn btn-success\" data-dismiss=\"modal\">Approve</button></div><div class=\"col-md-2\"><button type=\"button\" class=\"form-control btn btn-danger\" data-dismiss=\"modal\">Reject</button></div></div></div></div></div></div>");
$templateCache.put("app/modules/approved/approved.html","<div block-ui=\"approvedClaimsData\"><div><angular-tab datalist=\"approvedClaims\" tabname=\"\'Settled Claims\'\" callback-fn=\"ctrlFn(arg)\"></angular-tab></div></div>");
$templateCache.put("app/modules/approvedcancel/approvedcancel.html","<div><angular-tab appointmentlist=\"unApprrovedCancelAppointments\" tabname=\"\'Approved Cancel Appointments\'\" tabtype=\"\'approvedCancelAppointments\'\"></angular-tab></div>");
$templateCache.put("app/modules/atalAmritAbhiyan/atalAmritAbhiyan.html","<div id=\"tabclaim-new\"><style type=\"text/css\">\n        .common-background {\n            background-color: #f5f5f5;\n            padding: 0 15px 12px 15px;\n            margin: 1px 0;\n        }\n\n        .error {\n            color: red;\n        }\n    </style><div class=\"panel panel-default\" id=\"new-claim-success\" ng-show=\"!isCalimCreated\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\"><h4 class=\"chat-status text-center\">Your AAAY claim has been created successfully!.</h4></div></div><div class=\"col-md-2\"></div></div></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><button class=\"btn btn-default\" ng-click=\"preauthFormAction.closePreauthForm()\">Back to claims list</button></div><div class=\"col-md-2\"></div></div></div></div><div id=\"new-claim-form\" ng-show=\"isCalimCreated\"><div class=\"row\" style=\"padding-left: 10px; padding-right: 10px;\"><p class=\"pull-right\"><span style=\"color: red;\">*</span> Indicate required</p><div class=\"col-md-12\"><div id=\"test1\"><div class=\"chat-content_wrap\"><div class=\"chat-content\"><ng-form id=\"myForm\" novalidate=\"\" name=\"signup_form\"><div class=\"row\"><div class=\"col-md-4\"><div><label>URN number search</label><div class=\"col-md-12 input-group\"><input name=\"search\" type=\"text\" autocomplete=\"off\" class=\"form-control\" placeholder=\"click to search\" ng-model=\"form.URNNum\" readonly=\"\" ng-click=\"fastrackPreauthGovSeaarch(\'gov\')\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-md btn-primary\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Member search\" ng-click=\"fastrackPreauthGovSeaarch(\'gov\')\"><i class=\"test glyphicon glyphicon-search\"></i></button></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"patientFirstName\">Full name <span style=\"color: red;\">*</span></label> <input name=\"patientFirstName\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Full name\" ng-model=\"form.fullname\" required=\"\"><div class=\"error\" ng-show=\"signup_form.patientFirstName.$dirty && signup_form.patientFirstName.$invalid\"><small class=\"error\" ng-show=\"signup_form.patientFirstName.$error.required\">Your name is required.</small></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"contactNum\">Mobile number <span style=\"color: red;\">*</span></label> <input name=\"contactNum\" autocomplete=\"off\" type=\"text\" class=\"form-control\" ng-pattern=\"/^((7|8|9)).{9}$/\" ng-change=\"mobileValidation(form.mobile)\" numbers-only=\"numbers-only\" placeholder=\"Mobile number\" ng-model=\"form.mobile\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\"><div class=\"error\" ng-show=\"signup_form.contactNum.$error.pattern ||(signup_form.contactNum.$dirty && signup_form.contactNum.$invalid)\"><small class=\"error\" ng-show=\"signup_form.contactNum.$error.required\">Mobile number is required.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.pattern\">Mobile number is not valid.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.number\">Mobile number can contain only numbers.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.minlength\">Mobile number is required to be at least 10 characters.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.maxlength\">Mobile can\'t be longer than 10 characters.</small></div></div></div></div><div class=\"row\"><div class=\"col-md-4 form-group\"><label for=\"memberGender\">Member gender</label><select name=\"memberGender\" ng-model=\"form.memberGender\" class=\"form-control\"><option value=\"\">Select Gender</option><option value=\"male\">Male</option><option value=\"female\">Female</option></select></div><div class=\"col-md-4 form-group\"><label for=\"memberDist\">Member district</label> <input name=\"memberDist\" autocomplete=\"off\" placeholder=\"District\" class=\"form-control\" type=\"text\" ng-model=\"form.memberDist\"></div><div class=\"col-md-4 form-group\"><div class=\"form-group\"><label for=\"memberId\">Member Id <span style=\"color: red;\">*</span></label> <input name=\"memberId\" autocomplete=\"off\" type=\"number\" class=\"form-control\" placeholder=\"Member Id\" ng-model=\"form.memberId\" required=\"\"><div class=\"error\" ng-show=\"signup_form.memberId.$dirty && signup_form.memberId.$invalid\"><small class=\"error\" ng-show=\"signup_form.memberId.$error.required\">MemberId id is required.</small></div></div></div></div><div class=\"row\"><div class=\"col-md-4 form-group\"><label for=\"memberAge\">Member age</label> <input name=\"memberAge\" autocomplete=\"off\" placeholder=\"Age\" class=\"form-control\" type=\"number\" ng-model=\"form.memberAge\"></div><div class=\"col-md-4 form-group\"><div class=\"form-group\"><label for=\"ipnumber\">In patient number</label> <input name=\"ipnumber\" autocomplete=\"off\" numbers-only=\"\" type=\"text\" class=\"form-control\" placeholder=\"InPatient number\" ng-model=\"form.ipnumber\"><div class=\"error\" ng-show=\"signup_form.ipnumber.$dirty && signup_form.ipnumber.$invalid\"><small class=\"error\" ng-show=\"signup_form.ipnumber.$error.number\">Inpatient number can contain only numbers</small></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnosis <span style=\"color: red;\">*</span></label> <textarea name=\"diagnosis\" class=\"form-control\" placeholder=\"Enter diagnosis details\" ng-model=\"form.diagnosis\" required=\"\"></textarea><div class=\"error\" ng-show=\"signup_form.diagnosis.$dirty && signup_form.diagnosis.$invalid\"><small class=\"error\" ng-show=\"signup_form.diagnosis.$error.required\">Diagnosis details are required.</small></div></div></div></div><div class=\"row\"><div id=\"packageSelection\" class=\"col-md-8\"><div class=\"form-group col-md-6\"><label for=\"govtpackage\">Select package</label><typeahead items=\"govtPackageList\" prompt=\"Start typing package name (Enter minimum 3 characters)\" title=\"packageName\" subtitle=\"address\" subtitle2=\"packageCost\" module-flag=\"newadmission\"></typeahead></div><div class=\"col-md-4 form-group\"><label for=\"amount\">Package amount</label> <input name=\"packageAmount\" id=\"autoPackageAmt\" class=\"form-control\" placeholder=\"Selected package amount\" type=\"text\" ng-model=\"form.packageAmount\" readonly=\"\"></div><div class=\"col-md-2 form-group\"><br><br><button style=\"margin-top: -18px;\" id=\"packageAddBtn\" class=\"btn btn-success\" ng-click=\"govtSchemeMethods.addPackageButton()\">Add</button></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"approxClaimedAmnt\">Estimated amount *</label> <input name=\"approxClaimedAmnt\" readonly=\"\" autocomplete=\"off\" type=\"number\" class=\"form-control\" placeholder=\"Enter estimated Amount\" ng-model=\"form.clmamount\" required=\"\"><div class=\"error\" ng-show=\"signup_form.approxClaimedAmnt.$dirty && signup_form.approxClaimedAmnt.$invalid\"><small class=\"error\" ng-show=\"signup_form.approxClaimedAmnt.$error.required\">Claimed amount is required and can contain only numbers.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.number\">Claimed amount can contain only numbers</small></div></div></div></div><div class=\"row\"><div ng-if=\"selectedPackages.length >0\" style=\"padding-left: 20px; background-color: rgb(245, 245, 245);padding-right: 20px; margin-top: 0px; padding-bottom: 5px; margin-bottom: 5px;\"><p style=\"font-size: medium; margin-top: -5px;\">Selected procedure</p><table style=\"margin-top: -20px;\" class=\"table table-hover table-link\"><thead><tr><th class=\"patientName text-center\">Name</th><th class=\"claimedAmount text-center\">Price</th><th class=\"claimedAmount text-center\">Action</th></tr></thead><tbody><tr tooltip-placement=\"top\" ng-repeat=\"sel_package in selectedPackages track by $index\"><td>{{sel_package.name}}</td><td>{{sel_package.amount}}</td><td><a ng-click=\"govtSchemeMethods.removePackage(sel_package.id)\" class=\"btn btn-danger btn-xs\">{{sel_package.cappedAmount}}Remove</a></td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-md-4 form-group\"><div class=\"form-group\"><label for=\"doa\">Date of admission <span style=\"color: red;\">*</span></label> <input name=\"doa\" ng-change=\"dateOfAdmission(form.dod, \'doa\')\" id=\"datetimepicker\" class=\"form-control\" type=\"date\" ng-model=\"form.doa\" required=\"\"><div class=\"error\" ng-show=\"signup_form.doa.$dirty && signup_form.doa.$invalid\"><small class=\"error\" ng-show=\"signup_form.doa.$error.required\">Tentative date of admission is required.</small> <small class=\"error\" ng-show=\"signup_form.doa.$error.datetimelocal\">Tentative date is Invalid.</small></div><div class=\"error\"><small class=\"error\" ng-show=\"isdoa\">Tentative date of admission does\'t seems to be valid.</small></div></div></div><div class=\"col-md-4 form-group\"><div class=\"form-group\"><label for=\"dod\">Date of discharge <span style=\"color: red;\">*</span></label> <input name=\"dod\" ng-change=\"dateOfAdmission(form.doa, \'dod\')\" id=\"dischargetimepicker\" class=\"form-control\" type=\"date\" ng-model=\"form.dod\" required=\"\"><div class=\"error\" ng-show=\"signup_form.dod.$dirty && signup_form.dod.$invalid\"><small class=\"error\" ng-show=\"signup_form.dod.$error.required\">Tentative date of discharge is required.</small></div><div class=\"error\"><small class=\"error\" ng-show=\"isdod\">Tentative date of discharge does\'t seems to be valid.</small></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"docName\">Doctor name <span style=\"color: red;\">*</span></label> <input name=\"docName\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Type doctor name\" required=\"\" ng-click=\"getkeywords()\" ng-model=\"form.docname\" uib-typeahead=\"condition.doctorName for condition in doctorDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"search-filter form-control src-health-need\"><div class=\"error\" ng-show=\"signup_form.docName.$dirty && signup_form.docName.$invalid\"><small class=\"error\" ng-show=\"signup_form.docName.$error.required\">Doctor name is required.</small></div></div></div></div><div class=\"row\" ng-if=\"isEBill\"><div class=\"col-md-6\"><div class=\"form-group\" ng-show=\"!form.isgovtscheme\"><label for=\"uidno\">Unique hospital Id</label> <input name=\"uidno\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"form.uidno\"></div></div></div><div id=\"fileupload\"><p class=\"bg-danger\">Maximum file upload limit is 15 MB. <button class=\"btn btn-xs btn-primary pull-right\" ng-click=\"preauthFormAction.downloadPrefilledPreauthForm(\'preauthform\')\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR && !form.isgovtscheme) || (isdod ||isdoa)\">Download Pre-filled pre authorization form</button> <b>At least one of the documents listed below needs to be submitted.</b></p><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">Signed Pre authorization form</label> <input type=\"file\" name=\"preauth\" file-model=\"preAuthFile.file1\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">Id proof<a tooltip-placement=\"top\" uib-tooltip=\"Driving License, Voter ID card, Corporate Employee ID, Pan car, Passport\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a></label> <input type=\"file\" name=\"idproof\" file-model=\"preAuthFile.file2\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnostic reports<a tooltip-placement=\"top\" uib-tooltip=\"Bio Chemistry reports, Haematology reports, Microbiology reports, Neurology reports, Pathology reports, Radiology reports\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a></label> <input type=\"file\" name=\"investigations\" file-model=\"preAuthFile.file3\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">Other relevant documents</label> <input type=\"file\" name=\"otherfiles\" file-model=\"preAuthFile.file4\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add More Files</span></button></div></div></div></div><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-show=\"$last\" ng-click=\"removeFileToUpload()\">-</button></div></fieldset><div class=\"row\"><div class=\"col-sm-12\"><button type=\"submit\" class=\"btn btn-primary start pull-right\" id=\"newAdmissionButton\" style=\"margin-bottom: 25px;\" ng-click=\"preClaimInfoRelatedMethods.submitPreClaimPreauthForm()\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR && !form.isgovtscheme) || (isdod ||isdoa) || isProcessing\">Submit New Admission</button></div></div></div></ng-form></div></div></div></div></div></div><div class=\"modal fade\" id=\"newMSBYSearch\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><h4>URN number serach</h4></div><div class=\"modal-body\"><form name=\"formUrn\"><div class=\"row\"><div class=\"col-md-6 form-group\"><input ng-model=\"urn\" name=\"urn\" class=\"form-control\" type=\"text\" placeholder=\"URN number\" ng-required=\"true\"></div><div class=\"col-md-6 form-group\"><button ng-disabled=\"(!formUrn.urn.$dirty || formUrn.urn.$invalid)\" ng-click=\"getDetailsWithGov(urn,\'urn\')\" type=\"button\" class=\"btn btn-primary\"><i class=\"glyphicon glyphicon-search\"></i> Search</button></div></div><p class=\"bg-danger\" ng-show=\"fastrack.error\">{{fastrack.errorMessage}}</p><div class=\"form-group\" ng-show=\"govtBenefList.length >0\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"active\"><th>Name</th><th>RelationType</th><th>Select</th></tr></thead><tbody><tr ng-repeat=\"item in govtBenefList\"><td>{{item.name}}</td><td>{{item.relationName}}</td><td><button class=\"btn btn-xs btn-success\" ng-click=\"fastrackPopulateNewAdmissionGov(item)\">Select</button></td></tr></tbody></table></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"removeModal()\">Close</button></div></div></div></div></div>");
$templateCache.put("app/modules/bookappointment/bookappointment.html","<style>\n    .left-nav {\n        display: none;\n    }\n\n    .content-wrap {\n        padding: 0;\n    }\n\n    .scrolable {\n        height: 100% !important;\n        padding: 0;\n    }\n\n    .customerDetail {\n        display: inline-block;\n        width: 80px;\n    }\n</style><div class=\"dc-searchDC\" ng-show=\"dcSearchDC\"><div class=\"bx\"><form name=\"frmDist\"><div ng-show=\"!distError && !alreadyBookMsz\"><img src=\"/app/resources/images/medibuddy-plus-small-logo.png\" alt=\"\" style=\"margin:10px auto 20px auto; display:block;\"><h3 class=\"text-center\" ng-show=\"!showHomeVisitElem\">Search providers</h3><h3 class=\"text-center\" ng-show=\"showHomeVisitElem\">Home visit</h3><p class=\"text-center\" ng-show=\"!showHomeVisitElem\">Enter the location where you want to get your tests done and we will help you to identify the providers nearby. Click on suggested result and schedule the appointment at your convenience!!</p><div class=\"form-group\" ng-show=\"dcDetails.isVisitType\"><select class=\"form-control\" ng-model=\"homeDcVisit\" ng-change=\"getHomeDcVisit(homeDcVisit)\"><option value=\"\">Select</option><option value=\"homeVisit\">Home visit</option><option value=\"dcVisit\">DC visit</option></select><hr ng-show=\"isHomeDcVisit\"></div><div class=\"form-group\" ng-show=\"!showHomeVisitElem\"><input id=\"searchInput\" type=\"text\" autocomplete=\"off\" class=\"form-control\" placeholder=\"Search provider or location\" ng-model=\"myScopeVar\" options=\"autocompleteOptions\" g-places-autocomplete=\"\" force-selection=\"true\"></div><div class=\"row\" ng-show=\"showHomeVisitElem\"><div style=\"margin: 0 10px 0 25px;\"><span class=\"text-center\" style=\"color: brown; font-size: large; font-size: 0.9em;\">Home visit will be made available subject to availability, else we will connect and schedule for centre visit.</span></div><br><div class=\"form-group col-sm-12\" style=\"border-style:ridge\"><b class=\"text-left\">Customer detail</b><hr><div class=\"col-sm-6\"><div class=\"col-sm-12 text-left\"><h5>{{customer.name}}</h5><p>Customer unique id: {{employeeid}}</p><p>Email: {{customer.email}}</p><p>Ph: {{customer.phoneNo}}</p></div></div><div class=\"panel-body col-sm-6\"><ol><li ng-repeat=\"test in testnames\"><a ng-click=\"getTestDetails(test);\">{{test.testName}}</a><div ng-repeat=\"tests in investigationList\"><h4 style=\"color: cornflowerblue;\">{{tests.investigationName}}</h4><ol class=\"m-b-0\"><li ng-repeat=\"tst in tests.testDetails\">{{tst.testName}}</li></ol><p ng-show=\"investigationList.length == 0\" style=\"font-size: 12px; color:red\"><strong>No investigation available for this request</strong></p></div></li></ol></div></div><div class=\"col-md-12 form-group\"><label>Enter Address line 1</label> <input type=\"text\" ng-model=\"addressLineOne\" class=\"form-control\"></div><div class=\"col-md-12 form-group\"><label>Enter Address line 2</label> <input type=\"text\" ng-model=\"addressLineTwo\" class=\"form-control\"></div><div class=\"col-md-12 form-group\"><div class=\"col-xs-8 dateBox\"><label for=\"\">First preference</label><div class=\"input-group\"><input readonly=\"\" placeholder=\"Select first prefered date\" type=\"text\" id=\"firstDate\" ng-model=\"firstDate\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" min-date=\"mindate\" date-disabled=\"disabled(date, mode)\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"col-xs-4 p-l-0 timeBox\" style=\"margin-top: -12px;\"><div uib-timepicker=\"\" ng-model=\"firstTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><div class=\"col-md-12 form-group\"><div class=\"col-xs-8 dateBox\"><label for=\"\">Second preference</label><p class=\"input-group\"><input readonly=\"\" placeholder=\"Select second prefered date\" type=\"text\" id=\"secondDate\" ng-model=\"secondDate\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" min-date=\"mindate\" date-disabled=\"disabled(date, mode)\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"fa fa-calendar\"></i></button></span></p></div><div class=\"col-xs-4 p-l-0 timeBox\" style=\"margin-top: -12px;\"><div uib-timepicker=\"\" ng-model=\"secondTime\" max=\"maxFirst\" min=\"minFirst\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><div class=\"col-md-12 form-group\"><button class=\"btn btn-success\" ng-click=\"bookAppointment(true)\" ng-disabled=\"btnClicked\">Create appointment</button></div></div><div ng-show=\"!showHomeVisitElem\"><div class=\"text-center\" style=\"font-size: 16px;\" ng-show=\"!showHomeVisitElem\">-or-</div><button class=\"btn btn-primary btn-block m-t-10\" ng-click=\"loadCurrentLocation(\'close\')\" ng-show=\"isAllowCurrentLoc\"><i class=\"fa fa-crosshairs\"></i> <span class=\"hidden-xs\">Search near to my current location</span></button></div></div></form></div></div><div class=\"dc-searchDC\" ng-show=\"requestUpdate\"><div class=\"bx\" style=\"max-width: 600px; margin-left: -300px;\"><form name=\"frmDist\"><div><img src=\"/app/resources/images/medibuddy-plus-small-logo.png\" alt=\"\" style=\"margin:10px auto 20px auto; display:block;\"><h3 class=\"text-center\" style=\"line-height:28px; margin-bottom:40px;\">You have booked {{customerDetails.productName}} <span style=\"color:#666; display:block; font-size:14px;\">at <b>{{customerDetails.providerName}},</b>{{customerDetails.location}}, {{customerDetails.city}},{{customerDetails.state}}.</span></h3><div class=\"row\"><div class=\"col-sm-6\"><p><span class=\"customerDetail\">Booked for:</span> <b>{{customerDetails.patientName}}</b></p><p><span class=\"customerDetail\">Employee id:</span> <b>{{customerDetails.employeeId}}</b></p><p><span class=\"customerDetail\">Relation:</span> <b>{{customerDetails.relation}}</b></p><p><span class=\"customerDetail\">Email:</span> <b>{{customerDetails.emailId}}</b></p><p><span class=\"customerDetail\">Contact:</span> <b>{{customerDetails.mobileNo}}</b></p></div><div class=\"col-sm-6\"><div style=\"padding:20px 10px; text-align:center; box-shadow:0 0 10px #333;\">Appointment date and time: <span style=\"display:block; font-size:16px; font-weight:bold;\">{{getDateObj(customerDetails.appointmentDate) | date:\"yyyy-MM-dd \'at\' h:mm a\"}}</span></div></div></div><div class=\"col-md-12 form-group\" style=\"margin-top: 15px;height:80px\"><div class=\"col-xs-8 dateBox\"><label for=\"\">First preference</label><div class=\"input-group\"><input readonly=\"\" placeholder=\"Select first prefered date\" type=\"text\" id=\"firstDate\" ng-model=\"firstDate\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" min-date=\"mindate\" date-disabled=\"disabled(date, mode)\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"col-xs-4 p-l-0 timeBox\" style=\"margin-top: -12px;\"><div uib-timepicker=\"\" ng-model=\"firstTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><div class=\"col-md-12 form-group\"><button class=\"btn btn-success\" ng-click=\"bookAppointment()\">Update appointment</button></div><div class=\"row\" ng-show=\"!customerDetails.isHomeVisit\"><div class=\"col-md-12\"><input name=\"\" id=\"\" type=\"checkbox\" ng-model=\"dcCheck\" ng-change=\"changeDc(dcCheck)\"> <label for=\"\">Change dc</label></div></div></div></form></div></div><div class=\"errorBox\" ng-if=\"noUrlData\"><div class=\"bx\"><div ng-if=\"!distError\"><img src=\"/app/resources/images/medibuddy-plus-small-logo.png\" alt=\"\" style=\"margin:10px auto 20px auto; display:block;\"><h3 class=\"text-danger text-center\"><span style=\"color: red; font-size: large;\">Something went wrong!</span><br><span style=\"color: brown; font-size: large;\">Please click the url from the mail/sms or call us on 080-67617571 for assistant!</span></h3></div></div></div><div class=\"errorBox\" ng-if=\"alreadyBookMsz\"><div class=\"bx text-danger text-center\"><img src=\"/app/resources/images/medibuddy-plus-small-logo.png\" alt=\"\" style=\"margin:10px auto 20px auto; display:block;\"><h3 class=\"text-center\" style=\"color:brown\">Your appointment is already booked.</h3></div></div><div class=\"errorBox\" ng-if=\"successMessage\" id=\"message\"><div class=\"bx text-success text-center\"><img src=\"/app/resources/images/medibuddy-plus-small-logo.png\" alt=\"\" style=\"margin:10px auto 20px auto; display:block;\"><h3 class=\"text-center\" style=\"color:brown\" ng-show=\"!isRequestUpdate\">your request has been submitted and we are working on it, once confirm will update you through SMS.</h3><h3 class=\"text-center\" style=\"color:brown\" ng-show=\"isRequestUpdate\">Your appointment has been successfully rescheduled. You can contact us @ 080-67617571 for assistant.</h3><div style=\"padding: 20px 10px; text-align: center; box-shadow: 0 0 10px #333; margin:30px 30px 20px 30px;\">Your Request ID: <span style=\"display:block; font-size:16px; font-weight:bold;\">{{apptId}}</span></div></div></div><div class=\"errorBox\" ng-if=\"failedMessage\"><div class=\"bx\"><h3 class=\"text-danger text-center\"><i class=\"fa fa-frown-o\" style=\"font-size: 47px; margin-bottom: 10px;\"></i><br><span style=\"font-size: large;\">Failed to updated appointment. Please re-try by clicking on the link in your mail/SMS box or call us on 080-67617571 for assistant.</span></h3></div></div><div class=\"dc-header\" ng-if=\"selectDist && apptId ===\'\' && !alreadyBookMsz\"><img src=\"/app/resources/images/medibuddy-plus-small-logo.png\" alt=\"\" class=\"pull-left\" style=\"width:30px\"><div class=\"row\" style=\"padding-left:55px\"><div class=\"col-xs-7 col-sm-6 p-r-0 searchBox\"><div class=\"input-group\"><input id=\"searchInput\" type=\"text\" class=\"form-control\" autocomplete=\"off\" placeholder=\"Search preferred location\" ng-model=\"myScopeVar\" options=\"autocompleteOptions\" g-places-autocomplete=\"\" force-selection=\"true\"> <span class=\"input-group-btn\"><button class=\"form-control btn-primary\" ng-click=\"searchMap(myScopeVar)\">Go</button></span></div></div><div class=\"col-xs-3 p-r-0 radius\"><select name=\"locationSearch\" id=\"locationSearch\" class=\"form-control\" ng-change=\"getMap(dist)\" ng-options=\"option.Value for option in distanceData track by option.id\" ng-model=\"dist.data\" style=\"width:100px\"></select></div><div class=\"col-xs-2 col-sm-3 helpBtn text-right\"><a href=\"\" ng-show=\"!collapsed\" ng-model=\"collapse\" ng-click=\"collapsed=!collapsed\" style=\"line-height: 33px; padding: 18px;\">Help</a> <a href=\"\" ng-show=\"collapsed\" ng-click=\"collapsed=!collapsed\" style=\"line-height: 33px; background: #ddd; padding: 18px;\">Close</a></div></div><div class=\"clearfix helpBox\" ng-show=\"collapsed\"><ul><li>In case you want to change the location where you want to get your tests done, please type the address of location and we will help you to identify the providers nearby. Click on suggested result and schedule the appointment at your convenience.</li><li>If you want to book your appointment for tommorow kindly booked it before 2 Pm otherwise you will get appointment after two working days !!</li></ul></div></div><div ng-show=\"isMap\"><ui-gmap-google-map center=\"map.center\" control=\"\" zoom=\"map.zoom\" bounds=\"map.bounds\" draggable=\"true\" options=\"map.options\"><ui-gmap-circle center=\"map.center\" stroke=\"map.stroke\" fill=\"map.fill\" radius=\"map.radius\" visible=\"map.visible\" geodesic=\"c.geodesic\" editable=\"c.editable\" draggable=\"map.draggable\" clickable=\"map.clickable\"><ui-gmap-marker models=\"randomMarkers1\" coords=\"map.center\" idkey=\"\"><i class=\"fa fa-user\"></i></ui-gmap-marker><ui-gmap-marker ng-repeat=\"marker in markerArray\" click=\"showMarkerInfo(marker, $event)\" models=\"randomMarkers\" coords=\"marker.coords\" idkey=\"marker.id\" options=\"marker.options\"><ui-gmap-window options=\"windowOptions[marker.id]\" class=\"abc\" closeclick=\"closeClick(marker.id, $event)\"><div><h3>{{marker.name}}</h3><p>{{marker.entityAddress}} - {{marker.pinCode}}</p><p>Prefered timings:<br><span ng-show=\"bookToday\"><strong>You can <span ng-show=\"!isRequestUpdate\">book</span> <span ng-show=\"isRequestUpdate\">reschedule</span> appointment for tommorow</strong></span> <span ng-show=\"!bookToday\"><strong>Next available slot for appointment is on/after <span style=\"color:red\">{{displayMinDate}}</span></strong></span></p><span ng-show=\"{{!IsRequestUpdate}}\"><button data-target=\"#BookAppointmentBlock\" data-toggle=\"modal\" class=\"btn btn-success center-block bookApp BookAppointmentBlock\" data-name=\"{{marker.name}}\">Create appointment</button></span> <span ng-show=\"{{IsRequestUpdate}}\"><button data-target=\"#BookAppointmentBlock\" data-toggle=\"modal\" class=\"btn btn-success center-block bookApp BookAppointmentBlock\" data-name=\"{{marker.name}}\">Reschedule appointment</button></span></div></ui-gmap-window></ui-gmap-marker></ui-gmap-circle></ui-gmap-google-map></div><div class=\"modal fade table table-bordered\" id=\"BookAppointmentBlock\" block-ui=\"BookAppointmentTab\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog modal-dialog-custom modal-lg\" role=\"document\"><form name=\"formotherappointments\" novalidate=\"\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"text-center\">Raise appointment</h4><div class=\"row\"><div class=\"col-sm-6 text-center\"><h5 ng-show=\"customer.name.length>0\">{{customer.name}}</h5><h5 ng-show=\"customerDetails.name.length>0\">{{customerDetails.patientName}}</h5><p ng-show=\"employeeid.length>0\">Customer unique id: {{employeeid}}</p><p ng-show=\"customerDetails.employeeId.length>0\">Customer Unique Id: {{customerDetails.employeeId}}</p><p ng-show=\"customer.email.length>0\">Email: {{customer.email}}</p><p ng-show=\"customerDetails.email.length>0\">Email: {{customerDetails.emailId}}</p><p ng-show=\"customer.phoneNo.length>0\">Ph: {{customer.phoneNo}}</p><p ng-show=\"customerDetails.mobileNo.length>0\">Ph: {{customerDetails.mobileNo}}</p></div><div class=\"col-sm-6 text-center\"><h5>{{dcName}}</h5><p>{{dcAddressPin}}</p></div></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-5\" ng-show=\"testnames.length>0\"><h4 class=\"hdng\">Test<span ng-if=\"testnames.length > 1\">s</span> covered</h4><div class=\"panel panel-default\"><div class=\"panel-body\"><ol><li ng-repeat=\"test in testnames\"><a ng-click=\"getTestDetails(test);\">{{test.testName}}</a><div ng-repeat=\"tests in investigationList\"><div ng-show=\"investigationList.length>0\"><h4 style=\"color: cornflowerblue;\">{{tests.investigationName}}</h4><ol class=\"m-b-0\"><li ng-repeat=\"tst in tests.testDetails\">{{tst.testName}}</li></ol></div><p ng-show=\"investigationList.length == 0\" style=\"font-size: 12px; color:red\"><strong>No investigation available for this request</strong></p></div></li></ol></div></div></div><div class=\"col-sm-7\" style=\"margin-top: -10px;\"><h4 class=\"hdng\">Select date and timings <span style=\"margin-left: 3px;font-size: small;color: brown;text-decoration: underline; display:inline-block\"><span ng-show=\"bookToday\">(You can book appointment for tommorow)</span> <span ng-show=\"!bookToday\">(Next available slot for appointment is on/after <span style=\"color:red\">{{displayMinDate}}</span>)</span></span></h4><div class=\"row\"><div class=\"col-xs-8 dateBox\"><label for=\"\">First preference</label><div class=\"input-group\"><input readonly=\"\" placeholder=\"Select first prefered date\" type=\"text\" id=\"firstDate\" ng-model=\"firstDate\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" min-date=\"mindate\" date-disabled=\"disabled(date, mode)\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"col-xs-4 p-l-0 timeBox\" style=\"margin-top: -12px;\"><div uib-timepicker=\"\" ng-model=\"firstTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><div class=\"row m-t-10\"><div class=\"col-xs-8 dateBox\"><label for=\"\">Second preference</label><p class=\"input-group\"><input readonly=\"\" placeholder=\"Select second prefered date\" type=\"text\" id=\"secondDate\" ng-model=\"secondDate\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" min-date=\"mindate\" date-disabled=\"disabled(date, mode)\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"fa fa-calendar\"></i></button></span></p></div><div class=\"col-xs-4 p-l-0 timeBox\" style=\"margin-top: -12px;\"><div uib-timepicker=\"\" ng-model=\"secondTime\" max=\"maxFirst\" min=\"minFirst\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger pull-left\" data-dismiss=\"modal\">Close</button> <span ng-show=\"{{!IsRequestUpdate}}\"><button ng-disabled=\"formotherappointments.$invalid || btnClicked\" class=\"btn btn-primary\" ng-click=\"bookAppointment(false,firstDate,firstTime)\" data-dismiss=\"modal\">Raise appointment</button></span> <span ng-show=\"{{IsRequestUpdate}}\"><button ng-disabled=\"formotherappointments.$invalid || btnClicked\" class=\"btn btn-primary\" ng-click=\"bookAppointment(false,firstDate,firstTime)\" data-dismiss=\"modal\">Reschedule appointment</button></span></div></div></form></div></div><div class=\"modal fade\" id=\"\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Test details</h4></div><div class=\"modal-body\"><div class=\"row\" ng-show=\"investigationList.length>0\"><div class=\"col-md-12\" ng-repeat=\"tests in investigationList\"><div class=\"panel panel-default\"><h4 class=\"panel-header\" style=\"margin-left: 17px; padding-left: 7px;margin-top: 5px;color: cornflowerblue;\"><span>{{tests.investigationName}}</span></h4><ul><li ng-repeat=\"tst in tests.testDetails\"><span>{{tst.testName}}</span><br></li></ul></div></div></div><div class=\"row\" ng-show=\"investigationList.length == 0\"><strong style=\"font-size: 1em; margin-left: 100px;color:red\">No investigation available for this request</strong></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div>");
$templateCache.put("app/modules/cancelled/cancelled.html","<style>\n    	#homepageSearch{\n            display: none;\n        }\n        .bs-callout{\n        	padding: 20px;\n			margin: 20px 0;\n			border: 1px solid #eee;\n			border-left-width: 5px;\n			border-radius: 3px;\n        }\n        .bs-callout+.bs-callout {\n			margin-top: -5px;\n		}\n		.bs-callout-info {\n			border-left-color: #5bc0de;\n		}\n		.bs-callout a{\n			color: #5bc0de;\n		}\n        .tabsdemoDynamicTabs md-content {\n            background-color: transparent !important;\n        }\n\n            .tabsdemoDynamicTabs md-content md-tabs {\n                border: 1px solid #e1e1e1;\n            }\n\n                .tabsdemoDynamicTabs md-content md-tabs md-tab-content {\n                    background: #f6f6f6;\n                }\n\n                .tabsdemoDynamicTabs md-content md-tabs md-tabs-wrapper {\n                    background: white;\n                }\n\n            .tabsdemoDynamicTabs md-content h1:first-child {\n                margin-top: 0;\n            }\n\n        .tabsdemoDynamicTabs md-input-container {\n            padding-bottom: 0;\n        }\n\n        .tabsdemoDynamicTabs .remove-tab {\n            margin-bottom: 40px;\n        }\n\n        .tabsdemoDynamicTabs .demo-tab > div > div {\n            padding: 25px;\n            box-sizing: border-box;\n        }\n\n        .tabsdemoDynamicTabs .edit-form input {\n            width: 100%;\n        }\n\n        .tabsdemoDynamicTabs md-tabs {\n            border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n        }\n\n        .tabsdemoDynamicTabs md-tab[disabled] {\n            opacity: 0.5;\n        }\n\n        .tabsdemoDynamicTabs label {\n            text-align: left;\n        }\n\n        .tabsdemoDynamicTabs .long > input {\n            width: 264px;\n        }\n\n        .tabsdemoDynamicTabs .md-button.add-tab {\n            transform: translateY(5px);\n        }\n\n        .chat-date, .chat-date_time {\n            display: block;\n            text-align: right;\n        }\n\n        .chat-ma .chat-date, .chat-ma .chat-date_time {\n            display: block;\n            text-align: left;\n        }\n\n        .chat-date {\n            margin-top: 10px;\n        }\n\n        .chat-date_time {\n            color: #999;\n        }\n\n        .chat-content_wrap {\n            background-color: #fff;\n            padding: 10px 20px;\n            margin-bottom: 20px;\n        }\n\n        .chat-user {\n            color: #d2d2d2;\n        }\n    </style><div class=\"\"><angular-tab datalist=\"preauthfiltered\"></angular-tab></div>");
$templateCache.put("app/modules/changePwd/changepwd.html","<!doctype html><html class=\"no-js\"><div class=\"row\"><div class=\"col-md-4\"></div><div class=\"col-md-4\"><img src=\"/app/resources/images/logo-mediBuddy.png\" style=\"max-width: 300px; margin-bottom: 35px; max-width: 300px; margin-bottom: 50px;\" alt=\"\" class=\"logo\"></div><div class=\"col-md-4\"></div></div><div class=\"row\" ng-show=\"changepwdsuccess\"><div class=\"col-md-4\"></div><div class=\"col-md-4 changesuccess text-center\"><p>Password changed successfully</p><a class=\"btn btn-primary btn-block\" ng-click=\"gotoClaims()\">Go to home page</a></div><div class=\"col-md-4\"></div></div><div class=\"row\" ng-show=\"!changepwdsuccess\"><div class=\"col-md-12\"><form name=\"changePasswordForm\" novalidate=\"\" class=\"form-horizontal\"><div class=\"alert alert-danger\" role=\"alert\" id=\"pwdMessage\" style=\"display:none\"></div><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"id_pass\">Old password<span style=\"color: red;\">*</span></label><div class=\"col-sm-5\"><input type=\"password\" class=\"form-control\" required=\"\" name=\"oldpassword\" id=\"oldpassword\" ng-model=\"user.oldpassword\" placeholder=\"Enter old password\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"id_pass\">New password<span style=\"color: red;\">*</span></label><div class=\"col-sm-5\"><input type=\"password\" ng-minlength=\"3\" required=\"\" name=\"confirmpassword\" class=\"form-control\" id=\"newpassword\" ng-model=\"user.newpassword\" placeholder=\"Enter new password\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"id_pass\">Confirm new password<span style=\"color: red;\">*</span></label><div class=\"col-sm-5\"><input type=\"password\" ng-minlength=\"3\" required=\"\" name=\"confirmpassword\" class=\"form-control\" id=\"confirmpassword\" ng-model=\"user.confirmpassword\" placeholder=\"Confirm new password\"></div></div><div class=\"checkbox\"><button type=\"submit\" ng-disabled=\"changePasswordForm.$invalid\" class=\"btn text-center btn-primary pull-right\" ng-click=\"changePassword()\">Change password</button></div></form></div></div></html>");
$templateCache.put("app/modules/claims/claims.html","<div><div class=\"claims\" block-ui=\"activeClaims\"><div class=\"row\" ng-show=\"configuredTpaList && configuredTpaList.length>0\"><div class=\"col-md-4\"><div class=\"form-group\"><label style=\"font-weight: 400;\">Payer Name <span style=\"color: red; font-size: small;\">*</span></label><select name=\"insurername\" required=\"\" class=\"form-control\" ng-options=\"item as item.value for item in configuredTpaList track by item.value\" ng-model=\"tpaName\" ng-change=\"getPreAuthClaimsList(this.tpaName);\"></select></div></div></div><div class=\"claims\" ng-show=\"(tpaName && tpaName.id==MaTPAId && !tpaName.isGovtScheme)\"><angular-tab datalist=\"preauthClaims\" tabname=\"\'Active Claims\'\" callback-second-fn=\"callbackSecond(arg, flag, page)\" callback-fn=\"ctrlFn(arg)\"></angular-tab></div><div class=\"claims\" ng-show=\"preauthClaims && preauthClaims.length > 0 && (tpaName && tpaName.id==MaTPAId && tpaName.isGovtScheme) || (tpaName && tpaName.id!=MaTPAId)\"><angular-tabs datalist=\"preauthClaims\" tabname=\"\'Active Claims\'\" callback-fn=\"ctrlFn(arg)\" callback-second-fn=\"callbackSecond(arg, flag, page, tpaId)\" tpaid=\"tpaName\"></angular-tabs></div></div></div>");
$templateCache.put("app/modules/clinicAppointment/clinic_appointment.html","<style>\n\n\n</style><div class=\"row\" style=\"margin-top: 40px;\"><div class=\"col-md-12\"><div class=\"well\" style=\"margin-top: -40px;\"><div class=\"row-fluid\"><div class=\"span8\"><tabset><tab select=\"renderCalender(\'myCalendar1\');\"><div class=\"alert-success calAlert\" ng-show=\"alertMessage != undefined && alertMessage != \'\'\"><h4>{{alertMessage}}</h4></div><div class=\"btn-toolbar\"><p class=\"pull-right lead\">Appointment calendar view</p><div class=\"btn-group\"><button class=\"btn btn-primary\" ng-click=\"changeView(\'agendaDay\', \'myCalendar1\')\">AgendaDay</button> <button class=\"btn btn-primary\" ng-click=\"changeView(\'agendaWeek\', \'myCalendar1\')\">AgendaWeek</button> <button class=\"btn btn-primary\" ng-click=\"changeView(\'month\', \'myCalendar1\')\">Month</button></div></div><div class=\"calendar\" ng-model=\"eventSources\" calendar=\"myCalendar1\" ui-calendar=\"uiConfig.calendar\"></div></tab></tabset></div></div></div></div></div><div class=\"modal fade\" id=\"addSlot\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"InvoiceLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Add Event</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"addEvent()\">Add Event</button></div></div></div></div><div class=\"modal fade\" id=\"updateSlot\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"InvoiceLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Update Event</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"updateEvent()\">Update Event</button></div></div></div></div>");
$templateCache.put("app/modules/communicationHistory/communicationHistory.html","<uib-accordion close-others=\"oneAtATime\" ng-if=\"isOpenAccordian\"><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"status.isFirstOpen\"><uib-accordion-heading><a style=\"color: #168cc9;\">Communication history panel</a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isFirstOpen, \'glyphicon-chevron-right\': !status.isFirstOpen}\"></i></uib-accordion-heading><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"filter\">From date</label><div class=\"input-group\"><input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"dateFilterDate.fromDateFilter\" is-open=\"popup1.opened\" datepicker-options=\"dateDefautOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" ng-change=\"setMinDate(dateFilterDate.fromDateFilter)\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"filter\">To date</label><div class=\"input-group\"><input id=\"\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"dateFilterDate.toDateFilter\" is-open=\"popup2.opened\" datepicker-options=\"dateDefautOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" min-date=\"mindate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"filter\">Communication type</label><select class=\"form-control\" ng-model=\"ddlCommunicationType\"><option value=\"All\">Both Email-SMS</option><option value=\"Email\">Email</option><option value=\"SMS ALERT\">SMS</option></select></div></div></div><br><div class=\"row\"><div class=\"col-md-8\"></div><div class=\"col-md-4\"><button title=\"search communication\" class=\"form-control btn-info\" ng-click=\"loadCommunicationHistory(dateFilterDate.fromDateFilter,dateFilterDate.toDateFilter, ddlCommunicationType, communicationFilter.statusSearch)\"><i class=\"fa fa-commenting-o\"></i> search</button></div></div></div></uib-accordion><div class=\"col-md-1 pull-right\" ng-show=\"downloadCommunicationData.length>0\"><button title=\"download communication\" class=\"form-control btn-success\" filename=\"{{ filename }}.csv\" ng-csv=\"downloadCommunicationData\" csv-header=\"[\'Name\',\'Request_Id\',\'ApplicationNo\',\'Reciever\',\'Current_Status\',\'Date\',\'Time\',\'Delivered_not_delivered\']\"><i class=\"fa fa-download\"></i></button></div><div class=\"row\" ng-show=\"dataMsz1.length>0 && dataMsz2.length>0\"><div class=\"alert alert-success text-center pull-right\"><b>{{dataMsz1}}<span ng-show=\"stsMsz.length>0\">{{statusMsz}}</span> {{dataMsz2}}</b></div></div><div class=\"claims\" ng-show=\"communicationHistoryList.length>0\"><angular-tab appointmentlist=\"communicationHistoryList\" tabname=\"\'Communication history\'\" tabtype=\"\'communicationHistory\'\"></angular-tab></div>");
$templateCache.put("app/modules/contact/contact.html","<h3 style=\"margin:0 0 20px 0\"><a href=\"\" class=\"btn btn-sm btn-danger pull-right\" ng-click=\"clearAllCookies()\"><i class=\"fa fa-gear fa-1x\"></i> Reset</a> <span>Get In Touch</span></h3><div class=\"row\"><div class=\"col-sm-6 col-md-4\" ng-show=\"address\"><h3>Submit your claims to</h3><p><strong>{{address.entityName.replace(\'Mediassist\',\'Medi Assist\')}}</strong><br>{{address.primaryAddress}}, {{address.city}}, {{address.state}} - {{address.pinCode}}</p></div><div class=\"col-sm-6 col-md-4\" ng-hide=\"address\"></div><div class=\"col-sm-6 col-md-4\"><h3>Contact</h3><p><b>Dedicated number:</b> 080-22068666<br><div ng-if=\"false\"><b>Phone:</b> {{address.landLineNumber}}<br><b>Fax:</b> {{address.fax}}</div></p></div><div class=\"col-sm-6 col-md-4\"><h3>Corporate Office</h3><p><strong>Medi Assist Healthcare Services</strong><br>Tower D, 4th Floor, IBC Knowledge Park, 4/1 Bannerghatta Road, Bhavani Nagar, Bengaluru<br>Karnataka - 560029.</p><p><strong>Phone</strong> 1800-425-9449</p></div></div><hr style=\"margin:10px 0;\"><div class=\"row\"><div class=\"col-sm-12\"><h4>Write an email to Medi Assist</h4><p class=\"bg-warning error\" style=\"padding:10px; display:none;\">Please select subject of the form</p><p id=\"success-message\" class=\"bg-info error\" style=\"padding:10px; display:none;\">Your request has been submitted. One of our executive will get in touch with you. Have a great day!</p><div id=\"contact-form\"><form name=\"contact\" role=\"form\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"from-email\">Provider email</label> <input type=\"email\" placeholder=\"Enter provider email\" name=\"fromEmail\" id=\"fromEmail\" class=\"form-control\" ng-model=\"fromEmail\" required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"subject\">Subject</label><select name=\"subject\" required=\"\" id=\"subject\" class=\"form-control\" ng-model=\"test.subject\"><option value=\"\">Select Subject</option><option value=\"General query\">General query</option><option value=\"Claims related query\">Claims related query</option><option value=\"Hospital-profile change request\">Hospital-profile change request</option><option value=\"Payment related query\">Payment related query</option><option value=\"In-Patient package\">In-Patient package</option><option value=\"Out-Patient package\">Out-Patient package</option><option value=\"Feedback\">Feedback</option></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"message\">Message</label> <textarea placeholder=\"Type your message...\" required=\"\" ng-model=\"message\" name=\"message\" id=\"message\" rows=\"3\" style=\"width:100%;\" class=\"form-control\"></textarea></div></div><div class=\"col-md-1\"><div class=\"form-group\"><button style=\"margin-top: 20px;\" ng-disabled=\"contact.$invalid\" type=\"submit\" class=\"btn btn-primary pull-right\" ng-click=\"sendMessage()\" ng-show=\"getUserRole()!=\'guest\'\">Submit</button></div></div></div></form></div></div></div>");
$templateCache.put("app/modules/contracts/contracts.html","<div><div class=\"documents clearfix\"><div class=\"row\" style=\"margin-bottom: -15px;\"><div class=\"col-md-1\" style=\"margin-right: -35px\"><i class=\"fa fa-copyright fa-2x\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></div><div class=\"col-md-2\" style=\"margin-top: -18px\"><h3>Contracts</h3></div><div class=\"col-md-2 pull-right\" ng-if=\"isDocumentsOpen\"><button class=\"btn btn-xs btn-default\" data-toggle=\"modal\" data-target=\"#documentDetails\" ng-click=\"imagesMethods.clearFileModels(); contractMethods.openDocumentModal()\" uib-tooltip=\"Add New Contract\" tooltip-placement=\"left\" style=\"border: hidden\"><i class=\"fa fa-plus-square fa-2x\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></button></div><div class=\"col-md-2 pull-right\" ng-if=\"isPackagesOpen\"><button class=\"btn btn-xs btn-default\" data-toggle=\"modal\" data-target=\"#updateIpPackage\" ng-click=\"ipPackageMethods.updatePackageDetails()\" uib-tooltip=\"Add New Packages\" tooltip-placement=\"left\" style=\"border: hidden\"><i class=\"fa fa-plus-square fa-2x\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></button></div><div class=\"col-md-2 pull-right\" ng-if=\"isDiscountsOpen\"><button class=\"btn btn-xs btn-default\" data-toggle=\"modal\" data-target=\"#documentDetails\" ng-click=\"imagesMethods.clearFileModels(); contractMethods.openDocumentModal()\" uib-tooltip=\"Add New Discounts\" tooltip-placement=\"left\" style=\"border: hidden\"><i class=\"fa fa-plus-square fa-2x\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></button></div></div><hr><uib-tabset><uib-tab heading=\"Documents\" ng-init=\"switchTabs(\'documents\')\" ng-click=\"switchTabs(\'documents\')\"><table class=\"table table-hover table-striped table-bordered\"><thead><tr><th>S no.</th><th>Document</th><th>Type</th><th>From</th><th>To</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"entry in documents track by $index\"><td>{{$index + 1}}</td><td><label>{{entry.documentDescription}}</label></td><td>{{entry.documentType}}</td><td>{{entry.documentStartDate}}</td><td>{{entry.documentEndDate}}</td><td><a href=\"{{entry.downloadLink}}\" target=\"_blank\" class=\"btn btn-xs btn-success\" ng-if=\"entry.downloadLink\"><i class=\"fa fa-download\"></i> Download</a> <a ng-if=\"!entry.isDelete\" href=\"\" class=\"btn btn-xs btn-primary\" data-toggle=\"modal\" data-target=\"#documentDetails\" ng-click=\"contractMethods.openDocumentModal(entry, true)\"><i class=\"fa fa-gear\"></i> Edit</a> <a ng-if=\"!entry.isDelete\" href=\"\" class=\"btn btn-xs btn-danger\" data-toggle=\"modal\" data-target=\"#deleteContract\" ng-click=\"contractMethods.openDocumentModal(entry, true)\"><i class=\"fa fa-close\"></i> Remove</a> <span ng-if=\"entry.isDelete\" class=\"alert-danger deletion\">Pending deletion as per your request</span></td></tr></tbody></table></uib-tab><uib-tab heading=\"Packages : In-Patient\" ng-click=\"switchTabs(\'packages\')\"><table class=\"table table-hover table-striped table-bordered\" ng-if=\"ipPackageList.length\"><thead><tr><th>Name</th><th>Price</th><th>Age Range</th><th>Package Details</th><th>Room Type</th><th>Stay Duration</th><th>From</th><th>To</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"pack in ipPackageList track by $index\"><td><label>{{pack.packageName}}</label></td><td><span class=\"price\" style=\"color:#4c96f3\"><span style=\"color: black;\"><strike><i class=\"fa fa-rupee\"></i>{{pack.packagePrice}}</strike></span> <i class=\"fa fa-rupee\" style=\"margin-right:3px;\"></i>{{pack.packageMAPrice}}</span></td><td>{{pack.packageAges[0].minAge}} - {{pack.packageAges[0].maxAge}}</td><td>{{pack.description.substring(0,70)}}{{pack.description.length > 70 ? \'.....\' : \'\' }} <button class=\"btn btn-sm btn-default pull-right\" ng-click=\"ipPackageMethods.openPkgDetailsModal(pack)\" uib-tooltip=\"View\" style=\"border: hidden\" data-toggle=\"modal\" data-target=\"#packageDetailsModal\"><i class=\"fa fa-eye fa-4\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></button></td><td>{{pack.packageRoomType}}</td><td>{{pack.packageLOS}}</td><td>{{pack.fromDate}}</td><td>{{pack.toDate}}</td><td><button class=\"btn btn-primary btn-sm\" data-toggle=\"modal\" data-target=\"#updateIpPackage\" ng-click=\"ipPackageMethods.updatePackageDetails(pack)\"><i class=\"fa fa-pencil-square-o fa-3\" aria-hidden=\"true\"></i></button></td></tr></tbody></table><div class=\"text-center\" ng-if=\"!ipPackageList.length\" style=\"font-weight:bold; font-size:15px\">No details found</div></uib-tab></uib-tabset></div><div class=\"modal fade\" id=\"documentDetails\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" ng-click=\"contractMethods.clearFileModels()\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\" ng-show=\"!addDocument\">Edit <b>{{document.docDescription}}</b> Details</h4><h4 class=\"modal-title\" ng-show=\"addDocument\">Add new document</h4></div><div class=\"modal-body\"><div class=\"form form-horizontal\"><form name=\"docForm\"><div ng-if=\"addDocument\" class=\"form-group\"><label for=\"upload\" class=\"col-sm-3\">Upload</label><div class=\"col-md-9\"><fieldset data-ng-repeat=\"item in file\"><div class=\"input-group\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\" class=\"form-control\"> <span class=\"input-group-btn\"><button class=\"btn removeLargeDocument\" ng-click=\"fileUploadMethods.removeFileToUpload($index)\"><i class=\"fa fa-close\"></i></button></span></div></fieldset></div></div><div class=\"form-group\"><label for=\"docDesc\" class=\"col-sm-3\">Description</label><div class=\"col-md-9\"><input type=\"text\" name=\"\" id=\"docDesc\" class=\"form-control\" ng-model=\"document.docDescription\" required=\"\"></div></div><div class=\"form-group\"><label for=\"docType\" class=\"col-sm-3\">Type</label><div class=\"col-md-9\"><select class=\"form-control\" ng-model=\"document.docType\" ng-options=\"docType.masterLookUpID as docType.masterLookUpColumnValue for docType in documentTypes\" required=\"\"><option value=\"\">Select</option></select></div></div><div class=\"form-group\"><label for=\"docStart\" class=\"col-sm-3\">Start date</label><div class=\"col-md-9\"><input type=\"date\" name=\"\" id=\"docStart\" class=\"form-control\" ng-model=\"document.docStartDate\" required=\"\"></div></div><div class=\"form-group\"><label for=\"docEnd\" class=\"col-sm-3\">End date</label><div class=\"col-md-9\"><input type=\"date\" name=\"\" id=\"docEnd\" class=\"form-control\" ng-disabled=\"!document.docStartDate\" min=\"{{document.docStartDate}}\" ng-model=\"document.docEndDate\" required=\"\"></div></div><div ng-if=\"!addDocument\" class=\"form-group\"><label for=\"link\" class=\"col-sm-3\">Document</label><div class=\"col-md-9\"><a name=\"link\" href=\"{{document.downloadLink}}\" target=\"_blank\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-download\"></i> Download</a></div></div></form></div></div><div class=\"modal-footer\"><button type=\"button\" id=\"submit\" name=\"submit\" class=\"btn btn-sm btn-success\" data-dismiss=\"modal\" ng-click=\"addDocument ? contractMethods.addDocuments() : contractMethods.updateDocuments()\" ng-disabled=\"docForm.$invalid\">Submit</button> <button type=\"button\" class=\"btn btn-default btn-sm pull-left\" data-dismiss=\"modal\" ng-click=\"contractMethods.clearFileModels()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"uploadDocument\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"imagesMethods.clearFileModels()\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Add new document</h4></div><div class=\"modal-body\"><div role=\"tabpanel\" class=\"tab-pane\"><div style=\"margin-top:20px\"><fieldset class=\"form-group\" data-ng-repeat=\"item in file\">Upload file<input type=\"file\" name=\"preauth\" file-model=\"item.model\"> Document type<select class=\"form-control\" ng-model=\"newDoc.documentType\" ng-options=\"docType.masterLookUpID as docType.masterLookUpColumnValue for docType in documentTypes\"><option value=\"\">Select</option></select>Description<input type=\"text\" class=\"form-control\" ng-model=\"newDoc.description\"> Start date<input type=\"date\" class=\"form-control\" ng-model=\"newDoc.startDate\"> End date<input type=\"date\" class=\"form-control\" ng-model=\"newDoc.endDate\"></fieldset></div><div class=\"row\"><div class=\"col-md-6\"></div><div class=\"col-md-6\"><button type=\"button\" id=\"submit\" name=\"submit\" class=\"btn btn-success pull-right\" ng-click=\"documentsMethods.uploadDocument()\">Upload</button> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"imagesMethods.clearFileModels()\">Close</button></div></div></div></div></div></div></div><div class=\"modal fade\" id=\"deleteContract\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Are you sure you want to remove <strong>{{document.docDescription}}</strong> contract ?</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\">Document link : <a href=\"{{document.downloadLink}}\" target=\"_blank\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-download\"></i> Download</a></div><br><br></div><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">No</button> <button type=\"button\" class=\"btn btn-danger pull-right\" data-dismiss=\"modal\" ng-click=\"contractMethods.updateDocuments(true)\">Yes</button></div></div></div></div><div class=\"clearfix modal fade\" id=\"packageDetailsModal\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button class=\"btn-default btn-xs close\" data-dismiss=\"modal\"><i class=\"fa fa-close\"></i></button><h4 class=\"modal-title\" id=\"modal-title\" style=\"font-weight: bold;text-align: center\">{{ indvidualPackage.packageName }}</h4></div><div class=\"modal-body\">{{indvidualPackage.description}}</div><div class=\"modal-footer\"><button class=\"btn btn-primary\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"updateIpPackage\" role=\"dialog\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button class=\"btn-default btn-xs close\" data-dismiss=\"modal\"><i class=\"fa fa-close\"></i></button><h4 class=\"modal-title\" id=\"modal-title\" ng-if=\"!editPackage\">Add New Package</h4><h4 class=\"modal-title\" id=\"modal-title\" ng-if=\"editPackage\">Edit Package</h4></div><div class=\"modal-body\"><form role=\"form\" name=\"ipPackageForm\"><div class=\"row\"><div class=\"col-md-6\"><label>Package Name <span style=\"color:red;\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"selectedPackage.packageName\" placeholder=\"Enter Package Name\" required=\"\"></div><div class=\"col-md-6\"><div class=\"col-md-6 p-l-0\"><label><i class=\"fa fa-rupee\"></i> Package price <span style=\"color:red;\">*</span></label> <input type=\"text\" class=\"form-control\" numbers-only=\"numbers-only\" ng-model=\"selectedPackage.packagePrice\" placeholder=\"Enter Package Price\" required=\"\"></div><div class=\"col-md-6 p-r-0\"><label><i class=\"fa fa-rupee\"></i> Medi Assist price <span style=\"color:red;\">*</span></label> <input type=\"text\" class=\"form-control\" numbers-only=\"numbers-only\" ng-model=\"selectedPackage.packageMAPrice\" placeholder=\"Enter Package Price\" required=\"\"></div></div></div><div class=\"row\" style=\"margin-top: 20px\"><div class=\"col-md-6\"><label>Age Limit <span style=\"color:red;\">*</span></label><div class=\"row\"><div class=\"col-md-5\" style=\"width: 205px;\"><input type=\"text\" class=\"form-control\" numbers-only=\"numbers-only\" ng-model=\"selectedPackage.packageAges[0].minAge\" placeholder=\"Enter min age\" required=\"\"></div><div class=\"col-md-1\" style=\"margin-top: 8px\">to</div><div class=\"col-md-5\" style=\"width: 205px;\"><input type=\"text\" class=\"form-control\" numbers-only=\"numbers-only\" ng-model=\"selectedPackage.packageAges[0].maxAge\" placeholder=\"Enter max age\" required=\"\"></div></div></div><div class=\"col-md-6\"><label>Add description</label> <textarea class=\"form-control\" ng-model=\"selectedPackage.description\"></textarea></div></div><div class=\"row\" style=\"margin-top: 20px\"><div class=\"col-md-6\"><label>Room Type <span style=\"color:red;\">*</span></label><select class=\"form-control\" ng-model=\"selectedPackage.roomType\" ng-options=\"room.masterLookUpID as room.masterLookUpColumnValue for room in roomTypeMaster\" required=\"\"><option value=\"\">Select Room Type</option></select></div><div class=\"col-md-6\"><label>Stay Duration <span style=\"color:red;\">*</span></label> <input type=\"text\" class=\"form-control\" numbers-only=\"numbers-only\" ng-model=\"selectedPackage.packageLOS\" placeholder=\"Enter Stay Duration\" required=\"\"></div></div><div class=\"row\" style=\"margin-top: 20px\"><div class=\"col-md-6\"><label>Start date</label> <input type=\"date\" class=\"form-control\" ng-model=\"selectedPackage.startDate\" required=\"\"></div><div class=\"col-md-6\"><label for=\"docEnd\">End date</label> <input type=\"date\" class=\"form-control\" ng-disabled=\"!selectedPackage.startDate\" min=\"{{selectedPackage.startDate}}\" ng-model=\"selectedPackage.endDate\" required=\"\"></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-secondary btn-sm\" data-dismiss=\"modal\">Close</button> <button class=\"btn btn-primary btn-sm pull-right\" ng-disabled=\"ipPackageForm.$invalid\" ng-click=\"ipPackageMethods.savePackageDetails()\">Save</button></div></div></div></div></div>");
$templateCache.put("app/modules/corpPackageMap/corpPackageMap.html","<style>\n    .investigationName {\n        background: #8bf2eb;\n    }\n\n    .setWidthForTestDetails {\n        max-height: calc(100vh - 200px);\n        overflow-y: auto;\n    }\n</style><div class=\"corpPackageMapping\"><script type=\"text/ng-template\" id=\"customPopupTemplate.html\"><div class=\"custom-popup-wrapper\" ng-style=\"{top: 0+\'px\', left: 0+\'px\'}\" style=\"display: block; position: relative\" ng-show=\"isOpen() && !moveInProgress\" aria-hidden=\"{{!isOpen()}}\"> <p class=\"message\">Select from drop down.</p> <ul class=\"dropdown-menu\" role=\"listbox\" style=\"display: block; position: relative; margin-top: -12px;\"> <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.entityName}}\"> <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div> </li> </ul> </div></script><div class=\"row\"><ng-form name=\"addNewDC\" class=\"form-horizontal\"><div><div class=\"col-md-8\" style=\"margin-top: -25px;\"><h3>Corp package mapping</h3><button class=\"btn btn-success\" style=\"margin-left: 275px; margin-top: -56px;\" data-toggle=\"modal\" data-target=\"#addNewPackage\"><i class=\"fa fa-plus\"></i> Add new package</button></div></div></ng-form></div><div id=\"addUserMessage\" ng-show=\"isMessageFlag\" ng-class=\"addClass\" role=\"alert\" ng-click=\"isMessageFlag=false\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span> <span class=\"glyphicon glyphicon-remove pull-right\"></span> <span ng-bind-template=\"{{usermessage}}\"></span></div><div id=\"addUserMessage\" style=\"margin-bottom:10px;\" ng-show=\"showDCMapUserMessage\" ng-class=\"addClass\" role=\"alert\" ng-click=\"showDCMapUserMessage=false\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span> <span class=\"glyphicon glyphicon-remove pull-right\"></span> <span ng-bind-template=\"{{usermessage}}\"></span></div><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"status.isFirstOpen\"><uib-accordion-heading><a style=\"color: #168cc9;\">Search panel</a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isFirstOpen, \'glyphicon-chevron-right\': !status.isFirstOpen}\"></i></uib-accordion-heading><ng-form name=\"searchDC\" class=\"form-horizontal\"><div id=\"search-DC\" class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Select corporate type</label><div class=\"col-sm-8\"><select id=\"corpTypeSelect\" class=\"form-control\" ng-model=\"search.entityRelationSelected\" ng-options=\"opt as opt.entityName for opt in contracts\" ng-change=\"getCorporate(search.entityRelationSelected)\"><option value=\"\">Select corporate type</option></select></div></div><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Corporate name</label><div class=\"col-sm-8\"><input type=\"text\" ng-model=\"search.CorporateSelected\" placeholder=\"Type corporate name to search\" uib-typeahead=\"state as state.entityName for state in Corporate | filter:{entityName:$viewValue}\" typeahead-popup-template-url=\"customPopupTemplate.html\" typeahead-on-select=\"corporateChange($item.id)\" class=\"form-control\"></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"city\" class=\"control-label required-field col-sm-4\"></label><div class=\"col-sm-8\" style=\"margin-top: 50px;\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!search.entityRelationSelected || !search.CorporateSelected\" ng-click=\"getCorporatePackages(search.CorporateSelected)\">Search</button> <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"!search.entityRelationSelected && !search.CorporateSelected\" ng-click=\"clearSearch()\">Clear</button></div></div></div></div></ng-form></div></uib-accordion><ul class=\"nav nav-tabs\" role=\"tablist\" id=\"myTab\"><li ng-show=\"isCorpData\" class=\"active\"><a data-target=\"#corporate\" role=\"tab\" data-toggle=\"tab\">Corporate</a></li><li ng-show=\"addPackageTab\"><a data-target=\"#addpackage\" data-toggle=\"tab\" ng-click=\"tabAddPackage()\">{{tabName}}</a></li><li ng-show=\"dcmappingTab\"><a data-target=\"#dcmapping\" data-toggle=\"tab\" ng-click=\"dcMappingTabMethod.tabMapDC()\">DC mapping</a></li></ul><div class=\"tab-content thumbnail\" style=\"background: white;\"><div role=\"tabpanel\" class=\"tab-pane active\" id=\"corporate\"><div class=\"packageDetailsPanel row\"><div class=\"row\"><div class=\"col-md-6\"><div ng-show=\"CorporatePackages && CorporatePackages.length>0\"><angular-tab appointmentlist=\"CorporatePackages\" tabname=\"\'Packages\'\" tabtype=\"\'corporatePackagesNames\'\"></angular-tab></div></div><div class=\"col-md-6\" ng-show=\"packageDetailsPanel\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"pkgId\">Package alias name</label> <span ng-show=\"updateform.pkgName.$invalid\" class=\"redfont\">*</span> <input name=\"pkgName\" id=\"pkgName\" class=\"form-control\" placeholder=\"Enter package alias name\" type=\"text\" ng-model=\"selectedCorpPackage.pM_AliasName\" ng-disabled=\"true\" required=\"\"> <span ng-show=\"updateform.pkgName.$dirty && updateform.pkgName.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group\"><label class=\"col-md-12 align-left\" for=\"pkgMinAge\">Minimum age</label><div class=\"align-left\"><input name=\"pkgMinAge\" id=\"pkgMinAge\" placeholder=\"Enter minimum age\" class=\"form-control\" type=\"text\" ng-model=\"selectedCorpPackage.minAge\" ng-disabled=\"true\"></div></div><div class=\"form-group\"><label class=\"col-md-12 align-left\" for=\"pkgManAge\">Maximum age</label><div class=\"align-right\"><input name=\"pkgMaxAge\" id=\"pkgMaxAge\" placeholder=\"Enter maximum age\" class=\"form-control\" type=\"text\" ng-model=\"selectedCorpPackage.maxAge\" ng-disabled=\"true\"></div></div><div class=\"form-group\"><label class=\"col-md-12 align-left\" for=\"pkgMinService\">Minimum service</label><div class=\"align-left\"><input name=\"pkgMinService\" id=\"pkgMinService\" placeholder=\"Enter minimum service\" class=\"form-control\" type=\"text\" ng-model=\"selectedCorpPackage.minService\" ng-disabled=\"true\"></div></div><div class=\"form-group\"><label class=\"col-md-12 align-left\" for=\"pkgMaxService\">Maximum service</label><div class=\"align-right\"><input name=\"pkgMaxService\" id=\"pkgMaxService\" placeholder=\"Enter maximum service\" class=\"form-control\" type=\"text\" ng-model=\"selectedCorpPackage.maxService\" ng-disabled=\"true\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group align-left\"><label for=\"pkgGender\">Gender</label>{{selectedCorpPackage.gender}}<select ng-disabled=\"true\" class=\"form-control\" ng-selected=\"selectedCorpPackage.gender\" ng-model=\"selectedCorpPackage.gender\"><option value=\"\">Select gender</option><option value=\"M\">Male</option><option value=\"F\">Female</option></select></div><div class=\"form-group align-left\"><label for=\"pkgYears\">Years</label> <input name=\"pkgYears\" id=\"pkgYears\" type=\"text\" placeholder=\"Enter years\" class=\"form-control\" ng-model=\"selectedCorpPackage.years\" ng-maxlength=\"10\" ng-disabled=\"true\"></div><div class=\"form-group align-right\"><label for=\"pkgrate\">Corporate rate</label> <span ng-show=\"updateform.pkgrate.$invalid\" class=\"redfont\">*</span> <input name=\"pkgrate\" type=\"text\" placeholder=\"Enter corporate rate\" class=\"form-control\" ng-model=\"selectedCorpPackage.corporateRate\" ng-disabled=\"true\" ng-maxlength=\"10\" required=\"\"> <span ng-show=\"updateform.pkgrate.$dirty && updateform.pkgrate.$error.required\" class=\"redSmallFont\">Required</span> <span ng-show=\"updateform.pkgrate.$error.maxlength\" class=\"redSmallFont\">Only digits allowed</span></div><div class=\"form-group align-left\"><label for=\"pkgisActive\">IGST tax(%)</label> <input readonly=\"\" name=\"pkgisActive\" type=\"text\" class=\"form-control\" ng-model=\"selectedCorpPackage.serviceTax\" placeholder=\"Enter IGST tax(%)\" ng-disabled=\"true\"></div><div class=\"form-group align-left\"><label for=\"pkgisActive\">Swachh bharat tax(%)</label> <input readonly=\"\" placeholder=\"Enter swachh bharat tax(%)\" name=\"pkgisActive\" type=\"text\" class=\"form-control\" ng-model=\"selectedCorpPackage.swachhBharatCess\" ng-disabled=\"true\"></div><div class=\"form-group align-left\"><label for=\"pkgisActive\">Krishi kalyan tax(%)</label> <input readonly=\"\" placeholder=\"Enter krishi kalyan tax(%)\" name=\"pkgisActive\" type=\"text\" class=\"form-control\" ng-model=\"selectedCorpPackage.krishiKalyanCess\" ng-disabled=\"true\"></div><div class=\"form-group align-right\"><label for=\"pkgInstruction\">Remarks</label> <span ng-show=\"updateform.remark.$invalid\" class=\"redfont\">*</span> <textarea name=\"remark\" id=\"remark\" required=\"\" class=\"form-control\" ng-maxlength=\"100\" ng-model=\"selectedCorpPackage.instruction\" placeholder=\"Enter remark\'s...\" ng-disabled=\"true\"></textarea></div><div class=\"form-group align-right\"><div class=\"col-md-12\"><input name=\"pkgisSponsored\" id=\"pkgisSponsored\" type=\"checkbox\" ng-model=\"selectedCorpPackage.isSponsered\" ng-disabled=\"true\"> <label for=\"pkgisSponsored\">Sponsored</label></div></div><div class=\"form-group align-right\"><div class=\"col-md-12\"><input name=\"pkgisActive\" id=\"pkgisActive\" type=\"checkbox\" ng-model=\"selectedCorpPackage.isActive\" ng-disabled=\"true\"> <label for=\"pkgisActive\">Active</label></div><div class=\"col-md-12\"><input name=\"\" id=\"\" type=\"checkbox\" ng-model=\"selectedCorpPackage.isFinanceApproved\" ng-disabled=\"!isFinance\"> <label for=\"pkgisActive\">Financial approval</label></div></div><div class=\"form-group align-left\"><button type=\"button\" class=\"btn btn-block btn-primary\" ng-click=\"editPackageTabMethod.saveNewCorpPackage()\"><span class=\"glyphicon glyphicon-upload\"></span> Save</button></div></div></div></div></div></div><div role=\"tabpanel\" class=\"tab-pane\" id=\"addpackage\"><div class=\"container-fluid\" ng-show=\"emptyPackagePanel\"><form name=\"updateform\" class=\"form\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\" style=\"margin-left: -175px; margin-top: -45px;\"><button class=\"btn btn-success pull-right\" ng-click=\"editInvestigation()\">Add investigation</button> <button class=\"btn btn-primary pull-right\" style=\"margin-right: 3px;\" ng-click=\"getAllPackages()\">Import investigations</button></div></div><div class=\"col-md-6\"><div class=\"newCorpPackage row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"pkgId\">Package alias name</label> <span ng-show=\"updateform.pkgName.$invalid\" class=\"redfont\">*</span> <input name=\"pkgName\" placeholder=\"Enter package alias name\" id=\"pkgName\" class=\"form-control\" type=\"text\" ng-model=\"newCorpPackage.pM_AliasName\" required=\"\"> <span ng-show=\"updateform.pkgName.$dirty && updateform.pkgName.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group\"><label class=\"align-left\" for=\"pkgMinAge\">Minimum age</label><div class=\"align-left\"><input name=\"pkgMinAge\" id=\"pkgMinAge\" placeholder=\"Enter minimum age\" class=\"form-control\" type=\"text\" ng-model=\"newCorpPackage.minAge\"></div></div><div class=\"form-group\"><label class=\"align-left\" for=\"pkgManAge\">Maximum age</label><div class=\"align-right\"><input name=\"pkgMaxAge\" id=\"pkgMaxAge\" placeholder=\"Enter maximum age\" class=\"form-control\" type=\"text\" ng-model=\"newCorpPackage.maxAge\"></div></div><div class=\"form-group\"><label class=\"align-left\" for=\"pkgMinService\">Minimum service</label><div class=\"align-left\"><input name=\"pkgMinService\" id=\"pkgMinService\" placeholder=\"Enter minimum service\" class=\"form-control\" type=\"text\" ng-model=\"newCorpPackage.minService\"></div></div><div class=\"form-group\"><label class=\"align-left\" for=\"pkgMaxService\">Maximum service</label><div class=\"align-right\"><input name=\"pkgMaxService\" id=\"pkgMaxService\" placeholder=\"Enter maximum service\" class=\"form-control\" type=\"text\" ng-model=\"newCorpPackage.maxService\"></div></div><div class=\"form-group\"><label class=\"align-left\" for=\"pkgPrimaryCessTax\">Krishi kalyan tax(%)</label><div class=\"align-right\"><input readonly=\"\" name=\"pkgPrimaryCessTax\" id=\"pkgPrimaryCessTax\" placeholder=\"Enter krishi kalyan tax(%)\" class=\"form-control\" type=\"text\" ng-model=\"newCorpPackage.krishiKalyanCess\"></div></div><div class=\"form-group align-right\" ng-show=\"isMahsDC\"><label for=\"mahsRate\">MAHS rate</label> <input name=\"mahsRate\" id=\"\" placeholder=\"00.00\" class=\"form-control\" type=\"text\" ng-model=\"newCorpPackage.mahsRate\"></div><div class=\"form-group align-right\"><label for=\"pkgisActive\">Remarks</label> <span ng-show=\"updateform.remark.$invalid\" class=\"redfont\">*</span> <textarea name=\"remark\" id=\"remark\" required=\"\" class=\"form-control\" placeholder=\"Enter remark\'s...\" ng-model=\"newCorpPackage.instruction\"></textarea></div><div class=\"form-group align-left\"><button type=\"button\" class=\"btn btn-block btn-primary\" ng-disabled=\"updateform.$invalid\" ng-click=\"editPackageTabMethod.saveNewCorpPackage()\"><span class=\"glyphicon glyphicon-upload\"></span> Save</button></div></div><div class=\"col-md-6\"><div class=\"form-group align-left\"><label for=\"pkgGender\">Gender</label><select class=\"form-control\" ng-selected=\"newCorpPackage.gender\" ng-model=\"newCorpPackage.gender\"><option value=\"\">Select gender</option><option value=\"M\">Male</option><option value=\"F\">Female</option></select></div><div class=\"form-group align-left\"><label for=\"pkgYears\">Years</label> <input name=\"pkgYears\" placeholder=\"Enter years\" id=\"pkgYears\" type=\"text\" class=\"form-control\" ng-model=\"newCorpPackage.years\"></div><div class=\"form-group align-right\"><label for=\"pkgrate\">Corporate rate</label> <span ng-show=\"updateform.pkgrate.$invalid\" class=\"redfont\">*</span> <input name=\"pkgrate\" type=\"text\" placeholder=\"Enter corporate rate\" class=\"form-control\" ng-pattern=\"onlyNumbers\" ng-model=\"newCorpPackage.corporateRate\" ng-maxlength=\"10\" required=\"\"> <span ng-show=\"updateform.pkgrate.$dirty && updateform.pkgrate.$error.required\" class=\"redSmallFont\">Required</span> <span ng-show=\"updateform.pkgrate.$error.maxlength\" class=\"redSmallFont\">Only digits allowed</span> <span ng-show=\"updateform.pkgrate.$dirty && updateform.pkgrate.$error.pattern\" class=\"redSmallFont\">Not a valid number</span></div><div class=\"form-group align-left\"><label for=\"pkgisActive\">IGST tax(%)</label> <input readonly=\"\" name=\"pkgisActive\" placeholder=\"Enter IGST tax(%)\" type=\"text\" class=\"form-control\" ng-model=\"newCorpPackage.serviceTax\"></div><div class=\"form-group\"><label class=\"align-left\" for=\"pkgSecondaryCessTax\">Swachh bharat tax(%)</label><div class=\"align-right\"><input readonly=\"\" name=\"pkgSecondaryCessTax\" id=\"pkgSecondaryCessTax\" placeholder=\"Enter swachh bharat tax(%)\" class=\"form-control\" type=\"text\" ng-model=\"newCorpPackage.swachhBharatCess\"></div></div><div class=\"form-group\"><label class=\"align-left\" for=\"mahsCoOrdinationCharges\">Coordination charge</label><div class=\"align-right\"><input name=\"mahsCoOrdinationCharges\" id=\"mahsCoOrdinationCharges\" placeholder=\"Enter coordination charge\" class=\"form-control\" type=\"text\" ng-model=\"newCorpPackage.mahsCoOrdinationCharges\"></div></div><div class=\"form-group align-right\" ng-show=\"isMahsDC\"><label for=\"imgLink\">Image link</label> <input name=\"imgLink\" id=\"\" placeholder=\"Image Link\" class=\"form-control\" type=\"text\" ng-model=\"newCorpPackage.imgLink\"></div><div class=\"form-group align-right\"><div class=\"input-group col-md-12\"><span class=\"class= input-group-addon\"><input name=\"pkgisActive\" id=\"pkgisActive\" type=\"checkbox\" ng-model=\"newCorpPackage.isActive\"></span> <label for=\"pkgisActive\" class=\"form-control\">Active</label></div></div><div class=\"form-group align-right\"><div class=\"input-group col-md-12\"><span class=\"class= input-group-addon\"><input name=\"pkgIsSponsored\" id=\"pkgIsSponsored\" type=\"checkbox\" ng-model=\"newCorpPackage.isSponsered\"></span> <label for=\"pkgIsSponsored\" class=\"form-control\">Sponsored</label></div></div></div></div></div><div class=\"col-md-6\"><div ng-show=\"emptyPackagePanel\"><label style=\"color: chocolate; margin-left: 17px;\">Import investigations from already created package</label><div class=\"form-group col-md-12\"><select id=\"corpTypeSelect\" class=\"form-control\" ng-model=\"selectedFrmAllPackage\" ng-options=\"opt as opt.name for opt in allPackages\" ng-change=\"loadAllInvestigations(selectedFrmAllPackage)\"><option value=\"\">Select package</option></select></div></div><div class=\"form-group panel-group\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\" ng-show=\"showEditInvestigation\"><div ng-repeat=\"key in keys\" style=\"\"><div class=\"panel panel-default selectedinvestigations\"><div class=\"panel-heading\"><span class=\"badge pull-right\">{{selectedItems[key]}}/{{allInvestigationsGrouped[key].length}}</span> <a ng-click=\"selectAll(key, true)\" ng-show=\"selectedItems[key] !== allInvestigationsGrouped[key].length\">Select all</a> <a ng-click=\"selectAll(key, false)\" ng-show=\"selectedItems[key] === allInvestigationsGrouped[key].length\">Clear all</a><div ng-click=\"isCollapsedHorizontal = !isCollapsedHorizontal\" class=\"padLeft\" data-toggle=\"collapse\" data-target=\"#{{key}}\" style=\"margin-top: -30px; margin-left: 18%; color: brown;\">{{key}}</div></div><div><div uib-collapse=\"isCollapsedHorizontal\"><div class=\"\" ng-repeat=\"inv in allInvestigationsGrouped[key]\"><div><ul><div class=\"col-md-8 input-group\"><span class=\"input-group-addon\"><input name=\"checkAll\" class=\"{{key}}\" type=\"checkbox\" ng-model=\"inv.selected\" ng-change=\"editPackageTabMethod.countChecked(allInvestigationsGrouped)\" data-id=\"{{inv.id}}\" data-value=\"{{inv.name}}\" data-description=\"{{inv.description}}\" data-isactive=\"{{inv.isActive}}\" data-quantity=\"{{inv.quantity}}\"></span> <label class=\"form-control\">{{inv.name}}</label><br></div></ul></div></div></div></div></div></div></div></div></form></div><div class=\"packageDetailsPanel row thumbnail well\" ng-show=\"packageDetailsPanel\"><div class=\"row\"><div class=\"col-md-12\"><button class=\"btn btn-info pull-right\" data-toggle=\"modal\" data-target=\"#packageTestDetailsModal\" ng-click=\"setEditInvestigation()\" style=\"margin-left: 3px; margin-right: 15px;\">Show mapped investigation</button> <button class=\"btn btn-success pull-right\" ng-click=\"editInvestigation()\">Edit investigation</button></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"pkgId\">Package alias name</label> <span ng-show=\"updateform.pkgName.$invalid\" class=\"redfont\">*</span> <input name=\"pkgName\" id=\"pkgName\" class=\"form-control\" type=\"text\" ng-model=\"selectedCorpPackage.pM_AliasName\" placeholder=\"Enter package alias name\" ng-disabled=\"isFinance\" required=\"\"> <span ng-show=\"updateform.pkgName.$dirty && updateform.pkgName.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group\"><label class=\"col-md-12 align-left\" for=\"pkgMinAge\">Minimum age</label><div class=\"align-left\"><input name=\"pkgMinAge\" id=\"pkgMinAge\" placeholder=\"Enter minimum age\" class=\"form-control\" type=\"text\" ng-model=\"selectedCorpPackage.minAge\" ng-disabled=\"isFinance\"></div></div><div class=\"form-group\"><label class=\"col-md-12 align-left\" for=\"pkgManAge\">Maximum age</label><div class=\"align-right\"><input name=\"pkgMaxAge\" id=\"pkgMaxAge\" placeholder=\"Enter maximum age\" class=\"form-control\" type=\"text\" ng-model=\"selectedCorpPackage.maxAge\" ng-disabled=\"isFinance\"></div></div><div class=\"form-group align-left\"><label for=\"pkgisActive\">Swachh bharat tax(%)</label> <input readonly=\"\" placeholder=\"Enter swachh bharat tax(%)\" name=\"pkgisActive\" type=\"text\" class=\"form-control\" ng-model=\"selectedCorpPackage.swachhBharatCess\"></div><div class=\"form-group align-left\"><label for=\"pkgisActive\">Krishi kalyan tax(%)</label> <input readonly=\"\" placeholder=\"Enter krishi kalyan tax(%)\" name=\"pkgisActive\" type=\"text\" class=\"form-control\" ng-model=\"selectedCorpPackage.krishiKalyanCess\"></div><div class=\"form-group\"><label class=\"col-md-12 align-left\" for=\"pkgMinService\">Minimum service</label><div class=\"align-left\"><input name=\"pkgMinService\" id=\"pkgMinService\" placeholder=\"Enter minimum service\" class=\"form-control\" type=\"text\" ng-model=\"selectedCorpPackage.minService\" ng-disabled=\"isFinance\"></div></div><div class=\"form-group\"><label class=\"col-md-12 align-left\" for=\"pkgMaxService\">Maximum service</label><div class=\"align-right\"><input name=\"pkgMaxService\" id=\"pkgMaxService\" placeholder=\"Enter maximum service\" class=\"form-control\" type=\"text\" ng-model=\"selectedCorpPackage.maxService\" ng-disabled=\"isFinance\"></div></div><div class=\"form-group align-left\"><label for=\"pkgGender\">Gender</label><select ng-disabled=\"isFinance\" class=\"form-control\" ng-selected=\"selectedCorpPackage.gender\" ng-model=\"selectedCorpPackage.gender\"><option value=\"\">Select gender</option><option value=\"M\">Male</option><option value=\"F\">Female</option></select></div><div class=\"form-group align-left\"><label for=\"pkgYears\">Years</label> <input name=\"pkgYears\" placeholder=\"Enter year\" id=\"pkgYears\" type=\"text\" class=\"form-control\" ng-model=\"selectedCorpPackage.years\" ng-disabled=\"isFinance\"></div></div><div class=\"col-md-6\"><div class=\"form-group align-right\"><label for=\"pkgrate\">Corporate rate</label><span ng-show=\"updateform.pkgrate.$invalid\" class=\"redfont\">*</span> <input name=\"pkgrate\" type=\"text\" class=\"form-control\" ng-model=\"selectedCorpPackage.corporateRate\" placeholder=\"Enter corporate rate\" ng-maxlength=\"10\" ng-disabled=\"selectedCorpPackage.isFinanceApproved || isFinance\" required=\"\"> <span ng-show=\"updateform.pkgrate.$dirty && updateform.pkgrate.$error.required\" class=\"redSmallFont\">Required</span> <span ng-show=\"updateform.pkgrate.$error.maxlength\" class=\"redSmallFont\">Only digits allowed</span></div><div class=\"form-group align-left\"><label for=\"pkgisActive\">IGST tax(%)</label> <input readonly=\"\" name=\"pkgisActive\" type=\"text\" class=\"form-control\" ng-model=\"selectedCorpPackage.serviceTax\" placeholder=\"Enter IGST tax(%)\" ng-disabled=\"selectedCorpPackage.isFinanceApproved || isFinance\"></div><div class=\"form-group\"><label class=\"align-left\" for=\"mahsCoOrdinationCharges\">Coordination charge</label><div class=\"align-right\"><input name=\"mahsCoOrdinationCharges\" ng-disabled=\"selectedCorpPackage.isFinanceApproved || isFinance\" id=\"mahsCoOrdinationCharges\" placeholder=\"Enter coordination charge\" class=\"form-control\" type=\"text\" ng-model=\"selectedCorpPackage.mahsCoOrdinationCharges\"></div></div><div class=\"form-group align-right\"><label for=\"pkgInstruction\">Remarks</label> <span ng-show=\"updateform.remark.$invalid\" class=\"redfont\">*</span> <textarea name=\"remark\" id=\"remark\" required=\"\" class=\"form-control\" ng-model=\"selectedCorpPackage.instruction\" placeholder=\"Enter remark\'s...\" ng-disabled=\"isFinance\"></textarea></div><div class=\"form-group align-right\"><div class=\"col-md-12\"><input name=\"pkgisSponsored\" id=\"pkgisSponsored\" type=\"checkbox\" ng-model=\"selectedCorpPackage.isSponsered\" ng-disabled=\"isFinance\"> <label for=\"pkgisSponsored\">Sponsored</label></div></div><div class=\"form-group align-right\"><div class=\"col-md-12\"><input name=\"pkgisActive\" id=\"pkgisActive\" type=\"checkbox\" ng-model=\"selectedCorpPackage.isActive\" ng-disabled=\"isFinance\"> <label for=\"pkgisActive\">Active</label></div></div><div class=\"form-group align-right\"><div class=\"col-md-12\"><input name=\"\" id=\"\" type=\"checkbox\" ng-model=\"selectedCorpPackage.isFinanceApproved\" ng-disabled=\"!isFinance\"> <label for=\"pkgisActive\">Financial approval</label></div></div><div class=\"form-group align-left\"><button type=\"button\" class=\"btn btn-block btn-primary\" ng-click=\"editPackageTabMethod.saveNewCorpPackage()\"><span class=\"glyphicon glyphicon-upload\"></span> Save</button></div></div></div><div class=\"col-md-6\"><div ng-show=\"PackageDropDownShow\"><label>Import investigations from already created package</label><div class=\"form-group col-md-12\"><select id=\"corpTypeSelect\" class=\"form-control\" ng-model=\"selectedFrmAllPackage\" ng-options=\"opt as opt.name for opt in allPackages\" ng-change=\"loadAllInvestigations(selectedFrmAllPackage)\"><option value=\"\">Select package</option></select></div></div><div class=\"row setWidthForTestDetails\" ng-show=\"!showEditInvestigation\"><h3 style=\"color: currentColor;\">Test details</h3><div class=\"row\" ng-show=\"investigationList.length>0\"><ul style=\"margin-bottom: -16px;\" class=\"col-md-12\" ng-repeat=\"tests in investigationList\"><div class=\"panel panel-default\"><h5 class=\"panel-header\" style=\"margin-left: 1px; padding-left: 7px;margin-top: 5px;color: cornflowerblue;\"><span>{{tests.investigationName}}</span></h5><ul><li ng-repeat=\"tst in tests.testDetails\"><span>{{tst.testName}}</span><br></li></ul></div></ul></div><div class=\"row\" ng-show=\"!investigationList.length>0\"><strong style=\"font-size: 1em; margin-left: 20px;color:red\">{{errorMsz}}</strong></div></div><div class=\"form-group panel-group\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\" ng-show=\"showEditInvestigation\"><div ng-repeat=\"key in keys\" style=\"\"><div class=\"panel panel-default selectedinvestigations\"><div class=\"panel-heading\"><span class=\"badge pull-right\">{{selectedItems[key]}}/{{allInvestigationsGrouped[key].length}}</span> <a ng-click=\"selectAll(key, true)\" ng-show=\"selectedItems[key] !== allInvestigationsGrouped[key].length\">Select all</a> <a ng-click=\"selectAll(key, false)\" ng-show=\"selectedItems[key] === allInvestigationsGrouped[key].length\">Clear all</a><div class=\"padLeft\" data-toggle=\"collapse\" ng-click=\"isCollapsedHorizontal = !isCollapsedHorizontal\" style=\"margin-top: -21px; margin-left: 18%; color: brown;\">{{key}}</div></div><div><div uib-collapse=\"isCollapsedHorizontal\"><div class=\"\" ng-repeat=\"inv in allInvestigationsGrouped[key]\"><div><ul><div class=\"col-md-8 input-group\"><span class=\"input-group-addon\"><input name=\"checkAll\" class=\"{{key}}\" type=\"checkbox\" ng-model=\"inv.selected\" ng-change=\"editPackageTabMethod.countChecked(allInvestigationsGrouped)\" data-id=\"{{inv.id}}\" data-value=\"{{inv.name}}\" data-description=\"{{inv.description}}\" data-isactive=\"{{inv.isActive}}\" data-quantity=\"{{inv.quantity}}\"></span> <label class=\"form-control\">{{inv.name}}</label><br></div></ul></div></div></div></div></div></div></div></div></div></div></div><div role=\"tabpanel\" class=\"tab-pane\" id=\"dcmapping\"><div ng-show=\"showDropdown && dcmappingTab\" class=\"Dropdowns\"><div><div class=\"form-group\"><button ng-click=\"copyPasteToggle(toggle = !toggle)\" style=\"margin-left: 3px;\" class=\"btn btn-primary pull-right\" ng-model=\"toggle\" ng-show=\"roleCheck\">{{toggleText}}</button> <button style=\"margin-left: 3px;\" class=\"btn btn-primary pull pull-right btn-reload\" ng-click=\"downloadExcel()\"><i class=\"glyphicon glyphicon-cloud-download\"></i> Download</button> <button class=\"btn btn-primary pull pull-right btn-reload\" ng-click=\"reload()\"><i class=\"glyphicon glyphicon-refresh\"></i> Reload</button> <b><span class=\"text-center\">DC maping for - {{selectedCorpPackage.pM_Name}}</span></b></div><div class=\"row\"><div class=\"form-group col-md-3\"><select id=\"state\" class=\"form-control\" ng-model=\"dcSearch.stateSelected\" ng-change=\"dcMappingTabMethod.loadCities(dcSearch.stateSelected.lookUpId)\" ng-options=\"opt as opt.lookUpValue for opt in states\"><option value=\"\">Select state</option></select></div><div class=\"form-group col-md-3\"><select id=\"city\" class=\"form-control\" ng-model=\"dcSearch.citySelected\" ng-options=\"opt as opt.lookUpValue for opt in cities\" ng-change=\"dcMappingTabMethod.loadLocations(dcSearch.citySelected.lookUpId)\"><option value=\"\">Select city</option></select></div><div class=\"form-group col-md-3\"><select id=\"location\" class=\"form-control\" ng-model=\"dcSearch.locationSelected\" ng-options=\"opt as opt.lookUpValue for opt in locations\" ng-change=\"dcMappingTabMethod.loadDcByLoction(dcSearch.locationSelected.lookUpId)\"><option value=\"\">Select location</option></select></div><div class=\"form-group col-md-3\" ng-show=\"searchDc\"><input type=\"text\" ng-change=\"filterDc(txtSearchDc)\" ng-model=\"txtSearchDc\" class=\"form-control\" placeholder=\"Type to search Dc\"></div></div></div><div ng-show=\"diagnosticCentres && diagnosticCentres.length>0\"><angular-tab appointmentlist=\"diagnosticCentres\" tabname=\"\'Mapped Dc\'\" tabtype=\"\'mappedDc\'\"></angular-tab></div></div></div></div><div class=\"modal fade\" id=\"docterDetailsModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Edit doctor\'s timing</h4></div><div class=\"modal-body\"><div ng-repeat=\"item in docCollection track by $index\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><div class=\"padLeft\" data-toggle=\"collapse\" data-target=\"#{{item.docName}}\"><span><h4 class=\"text-center\">{{item.docName | uppercase}}</h4></span></div></div><div class=\"panel-body\"><div id=\"{{item.docName}}\" class=\"accordion-body collapse\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"\">Timings</label><div class=\"schedule\"><table class=\"table table-condensed table-bordered\"><tr><td colspan=\"2\">Copy<select style=\"display:inline-block\" ng-model=\"selectedDay\" ng-options=\"day for day in daysOfWeek\"><option value=\"\">Select</option></select>time to all weekdays <button class=\"btn btn-xs btn-success\" ng-model=\"abc\" ng-click=\"doctorsMethods.copyTime(selectedDay,item)\" ng-disabled=\"!selectedDay\">OK</button> <button class=\"btn btn-xs btn-success\" ng-model=\"abc\" ng-click=\"doctorsMethods.clearTime()\">Clear all</button></td></tr><tr ng-repeat=\"tim in item.timmingsOfWeek track by $index\"><td class=\"dayBx\">{{tim.dayName}}</td><td><div class=\"timeBx\" ng-repeat=\"timeing in tim.timeSlots track by $index\">{{timeing.startTimeHrs}}:{{timeing.startTimeMins}} <span>-</span>{{timeing.endTimeHrs}}:{{timeing.endTimeMins}} <a href=\"\" ng-click=\"doctorsMethods.removeTime(tim.dayName, $index, item)\"><i class=\"fa fa-close\"></i></a></div><div class=\"addTime\"><a href=\"\" class=\"btn btn-default addTimeBtn\" ng-click=\"showTimeAdd = true\"><i class=\"fa fa-plus\"></i> Add timings</a><div class=\"popover bottom\" ng-show=\"showTimeAdd\"><div class=\"arrow\"></div><h3 class=\"popover-title\">Select timings</h3><div class=\"popover-content\"><div class=\"row\"><div class=\"col-xs-6\">From</div><div class=\"col-xs-6\">To</div></div><div class=\"row\"><fieldset name=\"frmMon\"><div class=\"col-xs-3 p-r-0\"><select class=\"form-control\" ng-model=\"timeSlot.startTimeHrs\" ng-options=\"time for time in InOutTime\" ng-required=\"showTimeAdd\"><option value=\"\">hh</option></select></div><div class=\"col-xs-3 p-l-0\"><select class=\"form-control\" ng-model=\"timeSlot.startTimeMins\" ng-options=\"time for time in InOutTimeQuater\" ng-required=\"showTimeAdd\"><option value=\"\">mm</option></select></div><div class=\"col-xs-3 p-r-0\"><select class=\"form-control\" ng-model=\"timeSlot.endTimeHrs\" ng-options=\"time for time in InOutTime\" ng-required=\"showTimeAdd\"><option value=\"\">hh</option></select></div><div class=\"col-xs-3 p-l-0\"><select class=\"form-control\" ng-model=\"timeSlot.endTimeMins\" ng-options=\"time for time in InOutTimeQuater\" ng-required=\"showTimeAdd\"><option value=\"\">mm</option></select></div></fieldset></div><div class=\"row btns\"><div class=\"col-xs-6\"><a href=\"\" class=\"btn btn-sm btn-default\" ng-click=\"showTimeAdd = false\">Close</a></div><div class=\"col-xs-6 text-right\"><a href=\"\" class=\"btn btn-sm btn-primary\" ng-disabled=\"!timeSlot.startTimeHrs || !timeSlot.startTimeMins || !timeSlot.endTimeHrs || !timeSlot.endTimeMins\" ng-click=\"doctorsMethods.addTime(tim.dayName, timeSlot.startTimeHrs, timeSlot.startTimeMins, timeSlot.endTimeHrs, timeSlot.endTimeMins, item); showTimeAdd = false;\">Add</a></div></div></div></div></div></td></tr></table></div></div></div></div></div></div></div></div><div class=\"modal-footer footer\"><button type=\"button\" class=\"btn btn-sm btn-default pull-left\" data-dismiss=\"modal\">Close</button> <button type=\"button\" id=\"submit\" name=\"submit\" class=\"btn btn-sm btn-success\" ng-click=\"doctorsMethods.saveDayTimeOfDoctor()\" ng-disabled=\"doctorEditForm.$invalid || checkTim\">Submit</button></div></div></div></div><div class=\"modal fade\" id=\"uploadDocModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Upload required Doc</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label>Upload files <button class=\"btn btn-xs btn-primary\" ng-click=\"addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button></label><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"row\"><div class=\"col-sm-9\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\"><button class=\"removeLargeDocument\" ng-click=\"removeFileToUpload($index)\">-</button></div></div></fieldset></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-success\" ng-model=\"uploadDoc\" ng-click=\"upload()\">Upload</button> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"addNewPackage\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" ng-click=\"clearData()\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Add new package</h4></div><div class=\"modal-body\"><ng-form name=\"searchDC\" class=\"form-horizontal\"><div id=\"search-DC\" class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Select corporate type</label><div class=\"col-sm-8\"><select id=\"corpTypeSelect\" class=\"form-control\" ng-model=\"addNewPackage.entityRelationSelected\" ng-options=\"opt as opt.entityName for opt in contracts\" ng-change=\"getCorporate(addNewPackage.entityRelationSelected)\"><option value=\"\">Select corporate type</option></select></div></div><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Corporate name</label><div class=\"col-sm-8\"><input type=\"text\" ng-model=\"addNewPackage.CorporateSelected\" placeholder=\"Type corporate name to search\" uib-typeahead=\"state as state.entityName for state in Corporate | filter:{entityName:$viewValue}\" typeahead-popup-template-url=\"customPopupTemplate.html\" typeahead-on-select=\"corporateChange($item.id)\" class=\"form-control\"></div></div></div></div></ng-form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"clearData()\" data-dismiss=\"modal\">Close</button> <button class=\"btn btn-primary\" ng-disabled=\"!addNewPackage.entityRelationSelected || !addNewPackage.CorporateSelected\" ng-model=\"uploadDoc\" ng-click=\"btnAddNewPAckage(addNewPackage)\">Add package</button></div></div></div></div></div>");
$templateCache.put("app/modules/dashboard/dashboard.html","<div class=\"block-ui-main\"><div class=\"dashboard\" ng-if=\"dashboardType==\'MA\'\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label>Date From</label><div class=\"input-group\"><input id=\"datetimeFirst\" placeholder=\"Select date from\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"filtere.fromDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Date To</label><div class=\"input-group\"><input id=\"datetimeEnd\" readonly=\"\" placeholder=\"Select date to\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"filtere.toDate\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Payer</label><select ng-change=\"changeDashboard(this.tpaType.dashboardType)\" ng-model=\"tpaType.dashboardType\" class=\"form-control\" ng-options=\"item as item.value for item in configuredTpaList track by item.value\"></select></div></div><div class=\"col-md-2\"><div class=\"form-group\" style=\"padding-top:24px\"><button ng-disabled=\"userProfileForm.$invalid\" class=\"btn btn-primary\" ng-model=\"search\" ng-click=\"getAllCounts(tpaType.dashboardType.id)\">Search</button> <button class=\"btn primary\" ng-disabled=\"filtere.toDate ===\'\' && filtere.fromDate ===\'\'\" ng-click=\"resetDateValues()\">Clear</button></div></div><div class=\"col-md-1\" ng-if=\"isCmsUser\"><button uib-tooltip=\"Customize\" tooltip-placement=\"left\" style=\"margin-top: 24px; margin-left:0px;color: #101010;background-color: #dddddd;border-color: #dddddd;\" data-toggle=\"modal\" data-target=\"#customizeDashboard\" class=\"btn pull-right btn-sm btn-primary\"><i class=\"fa fa-gear fa-1x\"></i></button></div></div><span class=\"text-danger\" style=\"font-size:small\">* Dashboard shows the data for the current financial year only, please select the start date and end date to view the details for the select period.</span><style>\n        .dashboardBx .bx {\n          background: green;\n          border: 1px solid #ddd;\n          text-align: center;\n          position: relative;\n          padding: 20px;\n          color: #fff;\n          height: 150px;\n          margin-bottom: 15px;\n        }\n  \n        .dashboardBx .bx .huge {\n          font-weight: 200;\n          font-size: 40px;\n          padding: 20px;\n        }\n  \n        .dashboardBx .bx span {\n          display: block;\n        }\n  \n        .dashboardBx .bx .topBx {\n          position: absolute;\n          top: 0;\n          right: 0;\n          background: rgba(0, 0, 0, .5);\n          padding: 8px 15px;\n          text-align: right;\n        }\n  \n        .dashboardBx .bx .btn-group {\n          position: absolute;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          background: rgba(0, 0, 0, .5);\n          padding: 0;\n          height: 0;\n          overflow: hidden;\n          display: none;\n        }\n  \n        .dashboardBx .bx.has-link:hover .btn-group {\n          height: auto;\n          padding: 8px;\n          display: table;\n          transition: all 1s ease;\n        }\n  \n        .dashboardBx .bx.has-link:hover .huge {\n          padding: 0 20px;\n          transition: all .5s ease;\n        }\n  \n        .dashboardBx .bx .progress {\n          height: 5px;\n          margin: 0;\n          background: #d46e4e;\n          margin-top: -5px;\n        }\n  \n        .dashboardBx .bx .progress .progress-bar-warning {\n          background: #fff;\n        }\n  \n        .dashboardBx .bx.bg1 {\n          background: #d32f2f;\n          background: -moz-linear-gradient(45deg, #d32f2f 0%, #ef9a9a 100%);\n          background: -webkit-gradient(left bottom, right top, color-stop(0%, #d32f2f), color-stop(100%, #ef9a9a));\n          background: -webkit-linear-gradient(45deg, #d32f2f 0%, #ef9a9a 100%);\n          background: -o-linear-gradient(45deg, #d32f2f 0%, #ef9a9a 100%);\n          background: -ms-linear-gradient(45deg, #d32f2f 0%, #ef9a9a 100%);\n          background: linear-gradient(45deg, #d32f2f 0%, #ef9a9a 100%);\n          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#d32f2f\', endColorstr=\'#ef9a9a\', GradientType=1);\n        }\n  \n        .dashboardBx .bx.bg2 {\n          background: #c2185c;\n          background: -moz-linear-gradient(45deg, #c2185c 0%, #f48fb0 100%);\n          background: -webkit-gradient(left bottom, right top, color-stop(0%, #c2185c), color-stop(100%, #f48fb0));\n          background: -webkit-linear-gradient(45deg, #c2185c 0%, #f48fb0 100%);\n          background: -o-linear-gradient(45deg, #c2185c 0%, #f48fb0 100%);\n          background: -ms-linear-gradient(45deg, #c2185c 0%, #f48fb0 100%);\n          background: linear-gradient(45deg, #c2185c 0%, #f48fb0 100%);\n          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#c2185c\', endColorstr=\'#f48fb0\', GradientType=1);\n        }\n  \n        .dashboardBx .bx.bg3 {\n          background: #7b1fa2;\n          background: -moz-linear-gradient(45deg, #7b1fa2 0%, #ce93d8 100%);\n          background: -webkit-gradient(left bottom, right top, color-stop(0%, #7b1fa2), color-stop(100%, #ce93d8));\n          background: -webkit-linear-gradient(45deg, #7b1fa2 0%, #ce93d8 100%);\n          background: -o-linear-gradient(45deg, #7b1fa2 0%, #ce93d8 100%);\n          background: -ms-linear-gradient(45deg, #7b1fa2 0%, #ce93d8 100%);\n          background: linear-gradient(45deg, #7b1fa2 0%, #ce93d8 100%);\n          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#7b1fa2\', endColorstr=\'#ce93d8\', GradientType=1);\n        }\n  \n        .dashboardBx .bx.bg4 {\n          background: #522da8;\n          background: -moz-linear-gradient(45deg, #522da8 0%, #b39ddb 100%);\n          background: -webkit-gradient(left bottom, right top, color-stop(0%, #522da8), color-stop(100%, #b39ddb));\n          background: -webkit-linear-gradient(45deg, #522da8 0%, #b39ddb 100%);\n          background: -o-linear-gradient(45deg, #522da8 0%, #b39ddb 100%);\n          background: -ms-linear-gradient(45deg, #522da8 0%, #b39ddb 100%);\n          background: linear-gradient(45deg, #522da8 0%, #b39ddb 100%);\n          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#522da8\', endColorstr=\'#b39ddb\', GradientType=1);\n        }\n  \n        .dashboardBx .bx.bg5 {\n          background: #303f9f;\n          background: -moz-linear-gradient(45deg, #303f9f 0%, #9fa8da 100%);\n          background: -webkit-gradient(left bottom, right top, color-stop(0%, #303f9f), color-stop(100%, #9fa8da));\n          background: -webkit-linear-gradient(45deg, #303f9f 0%, #9fa8da 100%);\n          background: -o-linear-gradient(45deg, #303f9f 0%, #9fa8da 100%);\n          background: -ms-linear-gradient(45deg, #303f9f 0%, #9fa8da 100%);\n          background: linear-gradient(45deg, #303f9f 0%, #9fa8da 100%);\n          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#303f9f\', endColorstr=\'#9fa8da\', GradientType=1);\n        }\n  \n        .dashboardBx .bx.bg6 {\n          background: #0288D1;\n          background: -moz-linear-gradient(45deg, #0288D1 0%, #81D4FA 100%);\n          background: -webkit-gradient(left bottom, right top, color-stop(0%, #0288D1), color-stop(100%, #81D4FA));\n          background: -webkit-linear-gradient(45deg, #0288D1 0%, #81D4FA 100%);\n          background: -o-linear-gradient(45deg, #0288D1 0%, #81D4FA 100%);\n          background: -ms-linear-gradient(45deg, #0288D1 0%, #81D4FA 100%);\n          background: linear-gradient(45deg, #0288D1 0%, #81D4FA 100%);\n          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#0288D1\', endColorstr=\'#81D4FA\', GradientType=1);\n        }\n  \n        .dashboardBx .bx.bg7 {\n          background: #388E3C;\n          background: -moz-linear-gradient(45deg, #388E3C 0%, #A5D6A7 100%);\n          background: -webkit-gradient(left bottom, right top, color-stop(0%, #388E3C), color-stop(100%, #A5D6A7));\n          background: -webkit-linear-gradient(45deg, #388E3C 0%, #A5D6A7 100%);\n          background: -o-linear-gradient(45deg, #388E3C 0%, #A5D6A7 100%);\n          background: -ms-linear-gradient(45deg, #388E3C 0%, #A5D6A7 100%);\n          background: linear-gradient(45deg, #388E3C 0%, #A5D6A7 100%);\n          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#388E3C\', endColorstr=\'#A5D6A7\', GradientType=1);\n        }\n  \n        .dashboardBx .bx.bg8 {\n          background: #AFB42B;\n          background: -moz-linear-gradient(45deg, #AFB42B 0%, #E6EE9C 100%);\n          background: -webkit-gradient(left bottom, right top, color-stop(0%, #AFB42B), color-stop(100%, #E6EE9C));\n          background: -webkit-linear-gradient(45deg, #AFB42B 0%, #E6EE9C 100%);\n          background: -o-linear-gradient(45deg, #AFB42B 0%, #E6EE9C 100%);\n          background: -ms-linear-gradient(45deg, #AFB42B 0%, #E6EE9C 100%);\n          background: linear-gradient(45deg, #AFB42B 0%, #E6EE9C 100%);\n          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#AFB42B\', endColorstr=\'#E6EE9C\', GradientType=1);\n        }\n  \n        .dashboardBx .bx.bg9 {\n          background: #FBC02D;\n          background: -moz-linear-gradient(45deg, #FBC02D 0%, #FFF59D 100%);\n          background: -webkit-gradient(left bottom, right top, color-stop(0%, #FBC02D), color-stop(100%, #FFF59D));\n          background: -webkit-linear-gradient(45deg, #FBC02D 0%, #FFF59D 100%);\n          background: -o-linear-gradient(45deg, #FBC02D 0%, #FFF59D 100%);\n          background: -ms-linear-gradient(45deg, #FBC02D 0%, #FFF59D 100%);\n          background: linear-gradient(45deg, #FBC02D 0%, #FFF59D 100%);\n          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#FBC02D\', endColorstr=\'#FFF59D\', GradientType=1);\n        }\n  \n        .dashboardBx .bx.bg10 {\n          background: #F57C00;\n          background: -moz-linear-gradient(45deg, #F57C00 0%, #FFCC80 100%);\n          background: -webkit-gradient(left bottom, right top, color-stop(0%, #F57C00), color-stop(100%, #FFCC80));\n          background: -webkit-linear-gradient(45deg, #F57C00 0%, #FFCC80 100%);\n          background: -o-linear-gradient(45deg, #F57C00 0%, #FFCC80 100%);\n          background: -ms-linear-gradient(45deg, #F57C00 0%, #FFCC80 100%);\n          background: linear-gradient(45deg, #F57C00 0%, #FFCC80 100%);\n          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#F57C00\', endColorstr=\'#FFCC80\', GradientType=1);\n        }\n  \n        .dashboardBx .bx.bg11 {\n          background: #5D4037;\n          background: -moz-linear-gradient(45deg, #5D4037 0%, #BCAAA4 100%);\n          background: -webkit-gradient(left bottom, right top, color-stop(0%, #5D4037), color-stop(100%, #BCAAA4));\n          background: -webkit-linear-gradient(45deg, #5D4037 0%, #BCAAA4 100%);\n          background: -o-linear-gradient(45deg, #5D4037 0%, #BCAAA4 100%);\n          background: -ms-linear-gradient(45deg, #5D4037 0%, #BCAAA4 100%);\n          background: linear-gradient(45deg, #5D4037 0%, #BCAAA4 100%);\n          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#5D4037\', endColorstr=\'#BCAAA4\', GradientType=1);\n        }\n  \n        .dashboardBx .bx.bg12 {\n          background: #9E9E9E;\n          background: -moz-linear-gradient(45deg, #9E9E9E 0%, #EEEEEE 100%);\n          background: -webkit-gradient(left bottom, right top, color-stop(0%, #9E9E9E), color-stop(100%, #EEEEEE));\n          background: -webkit-linear-gradient(45deg, #9E9E9E 0%, #EEEEEE 100%);\n          background: -o-linear-gradient(45deg, #9E9E9E 0%, #EEEEEE 100%);\n          background: -ms-linear-gradient(45deg, #9E9E9E 0%, #EEEEEE 100%);\n          background: linear-gradient(45deg, #9E9E9E 0%, #EEEEEE 100%);\n          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#9E9E9E\', endColorstr=\'#EEEEEE\', GradientType=1);\n        }\n  \n        .dashboardBx .bx.bg13 {\n          background: #455A64;\n          background: -moz-linear-gradient(45deg, #455A64 0%, #B0BEC5 100%);\n          background: -webkit-gradient(left bottom, right top, color-stop(0%, #455A64), color-stop(100%, #B0BEC5));\n          background: -webkit-linear-gradient(45deg, #455A64 0%, #B0BEC5 100%);\n          background: -o-linear-gradient(45deg, #455A64 0%, #B0BEC5 100%);\n          background: -ms-linear-gradient(45deg, #455A64 0%, #B0BEC5 100%);\n          background: linear-gradient(45deg, #455A64 0%, #B0BEC5 100%);\n          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#455A64\', endColorstr=\'#B0BEC5\', GradientType=1);\n        }\n  \n        .dashboardBx .bx.bg14 {\n          background: #FF7043;\n          background: -moz-linear-gradient(45deg, #FF7043 0%, #FFAB91 100%);\n          background: -webkit-gradient(left bottom, right top, color-stop(0%, #FF7043), color-stop(100%, #FFAB91));\n          background: -webkit-linear-gradient(45deg, #FF7043 0%, #FFAB91 100%);\n          background: -o-linear-gradient(45deg, #FF7043 0%, #FFAB91 100%);\n          background: -ms-linear-gradient(45deg, #FF7043 0%, #FFAB91 100%);\n          background: linear-gradient(45deg, #FF7043 0%, #FFAB91 100%);\n          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#FF7043\', endColorstr=\'#FFAB91\', GradientType=1);\n        }\n  \n      </style><div class=\"row dashboardBx\" block-ui=\"dashboardUI\" ng-if=\"tpaType.dashboardType && tpaType.dashboardType.id!=9999\"><div class=\"col-lg-3 col-md-4 p-r-0\" ng-if=\"item.isSelected\" ng-repeat=\"item in UiImplimentation track by $index\"><div class=\"bx has-link bg1\" ng-if=\"item.name === \'Upcoming\'\"><span class=\"huge\">{{data.upcomingHospitalizationCount}}</span> <span>Planned hospitalization/eCashless</span><div class=\"btn-group btn-group-justified\"><a class=\"btn btn-default btn-sm\" ng-click=\"getUpcomingHospitalization()\" data-toggle=\"modal\" data-target=\"#UpcomingHospitalization\">View Details</a></div></div><div class=\"bx has-link bg2\" ng-if=\"item.name === \'Active\'\"><span class=\"huge\">{{data.activeClaimsCount}}</span> <span>Active claims</span><div class=\"btn-group btn-group-justified\"><a class=\"btn btn-default btn-sm\" ng-click=\"redirect(\'claimsOperations\')\">View details</a></div></div><div class=\"bx has-link bg8\" ng-if=\"item.name === \'Denied\'\"><span class=\"huge\">{{data.deniedClaimsCount}}</span> <span>Denied claims</span><div class=\"btn-group btn-group-justified\"><a data-toggle=\"modal\" data-target=\"#downloadData\" class=\"btn btn-default btn-sm\" ng-click=\"setModelData(\'Denied Claims\')\">Request report</a> <a class=\"btn btn-default btn-sm\" ng-click=\"redirect(\'claimsDenied\')\">View details</a></div></div><div class=\"bx has-link bg4\" ng-if=\"item.name === \'Discharge\'\"><span class=\"huge\">{{data.dueDischarges}}</span> <span>Awaiting Discharge Today</span><div class=\"btn-group btn-group-justified\"><a class=\"btn btn-default btn-sm\" ng-click=\"redirect(\'discharge\')\">View details</a></div></div><div class=\"bx has-link bg3\" ng-if=\"item.name === \'Totalos\'\"><span class=\"topBx\">Rs.{{formatCurrency(data.pendingPaymentsAmount)}}</span> <span class=\"huge\">{{data.pendingPaymentClaimCount}}</span> <span>Outstanding cashless claims</span><div class=\"btn-group btn-group-justified\"><a class=\"btn btn-default btn-sm\" data-toggle=\"modal\" data-target=\"#downloadData\" ng-click=\"setModelData(\'Total outstanding amount\')\">Request report</a> <a class=\"btn btn-default btn-sm\" ng-click=\"redirect(\'claimsPayments\')\">View details</a></div></div><div class=\"bx has-link bg5\" ng-if=\"item.name === \'Clsettled\'\"><span class=\"topBx\">Rs.{{formatCurrency(data.settledClaimsAmount)}}</span> <span class=\"huge\">{{data.settledClaimsCount}}</span> <span>Cashless claims settled</span><div class=\"btn-group btn-group-justified\"><a class=\"btn btn-default btn-sm\" data-toggle=\"modal\" data-target=\"#downloadData\" ng-click=\"setModelData(\'Cashless Settled Claims\')\">Request report</a> <a class=\"btn btn-default btn-sm\" ng-click=\"redirect(\'claimsApproved\')\">View details</a></div></div><div class=\"bx has-link bg7\" ng-if=\"item.name === \'Risettled\'\"><span class=\"topBx\">Rs.{{formatCurrency(data.reimbursementAppAmount)}}</span> <span class=\"huge\">{{data.reimbursementClaimCount}}</span> <span>Reimbursement claims settled</span><div ng-click=\"goState(\'/reimbursement\')\" class=\"btn-group btn-group-justified\"><a class=\"btn btn-default btn-sm\" ng-click=\"\">View details</a></div></div><div class=\"bx bg6\" ng-if=\"item.name === \'Totalsettled\'\"><span class=\"topBx\">Rs.{{formatCurrency(data.reimbursementAppAmount + data.settledClaimsAmount)}}</span> <span class=\"huge\">{{data.settledClaimsCount +data.reimbursementClaimCount}}</span> <span>Total claims settled</span></div><div class=\"bx has-link bg14\" ng-if=\"item.name === \'Profile\'\"><uib-progressbar uib-tooltip=\"{{(rating/totalRating)*100| number:0}}%\" class=\"progress-striped\" value=\"totalPercentage\" type=\"warning\"></uib-progressbar><span class=\"huge\">{{(rating/totalRating)*100| number:0}}%</span> <span>Profile completion</span><div ng-click=\"goState(\'/provider-profile\')\" class=\"btn-group btn-group-justified\"><a class=\"btn btn-default btn-sm\" ng-click=\"\">View details</a></div></div><div class=\"bx has-link bg10\" ng-if=\"item.name === \'Users\'\"><span class=\"huge\">{{userDetails.hospitalUserCount}}</span> <span>Users</span><div ng-click=\"goState(\'/usermgmt\')\" class=\"btn-group btn-group-justified\"><a class=\"btn btn-default btn-sm\">View details</a></div></div><div class=\"bx has-link bg11\" ng-if=\"item.name === \'Cda\'\"><span class=\"huge\">{{data.pendingHardcopyDocs}}</span> <span>Claims pending document submission</span><div class=\"btn-group btn-group-justified\"><a class=\"btn btn-default btn-sm\" ng-click=\"redirect(\'documents\')\">View details</a></div></div><div class=\"bx has-link bg13\" ng-if=\"item.name === \'Query\'\"><span class=\"huge\">{{data.cashlessIACount}}</span> <span>Claims pending query response</span><div ng-click=\"redirect(\'cashResponse\')\" class=\"btn-group btn-group-justified\"><a class=\"btn btn-default btn-sm\">View details</a></div></div></div></div><div class=\"dashboard\" ng-if=\"tpaType.dashboardType && tpaType.dashboardType.id==9999 && dashboardURL\"><iframe src=\"{{dashboardURL}}\" id=\"themeframe\" width=\"100%\" style=\"height:700px;border:0\"></iframe></div></div></div><div class=\"modal fade\" id=\"customizeDashboard\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"resetMailData()\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Customize Dashboard</h4></div><div class=\"modal-body\"><p ng-if=\"isDisable\" style=\"margin-left: 20px; color: #701f27;\">Dashboard count shoud be more then three.</p><div class=\"col-md-4\" ng-repeat=\"item in totalDashboardPresent track by $index\"><div class=\"checkbox\"><label><input ng-model=\"item.isSelected\" ng-click=\"validateCount()\" type=\"checkbox\"> {{item.fullName}}</label></div></div></div><div class=\"\" style=\"padding: 15px; text-align: right;\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"isDisable\" ng-click=\"saveDashboard()\">Save Dashbooard</button> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"downloadData\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"resetMailData()\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Download {{modelValue}}</h4></div><div class=\"modal-body\" style=\"margin-top: -16px;\"><div style=\"MARGIN-TOP: 26PX;\"><div ng-if=\"!isSent\" style=\"margin-left: 218PX;\">You will receive mail on <strong>{{dateObj | date :\'dd-MMM-yyyy\'}}</strong> before <strong>10:00 AM.</strong></div><ng-form ng-if=\"isSent\" name=\"report\" class=\"form-inline\" style=\"margin-left: 140px;\"><div class=\"form-group\"><label for=\"email\">Email address* :</label><div class=\"input-group\"><input placeholder=\"Enter mail address\" type=\"text\" class=\"form-control\" ng-model=\"report.mailId\" ng-pattern=\"emailchk\"></div></div><div class=\"form-group\"><button ng-disabled=\"!report.mailId || report.$invalid\" ng-show=\"isCashless\" class=\"btn btn-primary\" ng-model=\"search\" ng-click=\"downloadReport(\'downloadSettlementReport\', report.mailId)\">Send report</button> <button ng-disabled=\"!report.mailId || report.$invalid\" ng-show=\"isClaimsDenied\" class=\"btn btn-primary\" ng-model=\"search\" ng-click=\"downloadReport(\'downloadDeniedReport\', report.mailId)\">Send report</button> <button ng-disabled=\"!report.mailId || report.$invalid\" ng-show=\"isOutstanding\" class=\"btn btn-primary\" ng-model=\"search\" ng-click=\"downloadReport(\'downloadOutstandingReport\',report.mailId)\">Send report</button></div></ng-form></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"UpcomingHospitalization\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Upcoming hospitalizations</h4></div><div class=\"modal-body\" style=\"margin-top: -16px;\"><div ng-show=\"hospitalClaimSearchResults.length> 0\"><table class=\"table table-hover\" style=\"margin-left: 5px;\"><tr style=\"color: #000000;\"><th>Patient name</th><th>Claim id</th><th>Claimed amount</th><th>Approved amount</th><th>Status</th><th>Admission date</th></tr><tr class=\"italic\" ng-class=\"{\'\': hover}\" ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\" ng-repeat=\"pack in hospitalClaimSearchResults | limitTo:itemsPerPage\"><td>{{ pack.benefName }}</td><td>{{ pack.claimId }}</td><td>{{ pack.clmAmount }}</td><td>{{ pack.clmApprovedAmt }}</td><td style=\"font-size: smaller;\">{{ pack.latestPreAuthStatus }}</td><td>{{getDateObj(pack.doa) | date:\"yyyy-MM-dd\"}}</td></tr></table><div style=\"margin-left: 300px;\"><uib-pagination total-items=\"totalItem\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" ng-change=\"ctrlFn(currentPage)\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></div><div style=\"MARGIN-TOP: 26PX;\" ng-show=\"hospitalClaimSearchResults.length === 0 && isResult=== true\"><span style=\"margin-left: 300px; margin-top: 10px; font-size: larger; font-style: normal;\">No result found</span></div></div></div></div></div>");
$templateCache.put("app/modules/dashboard/dcDashboard.html","<div class=\"block-ui-main\"><style>\n    .dashboardBx .bx {\n      background: green;\n      border: 1px solid #ddd;\n      text-align: center;\n      position: relative;\n      padding: 20px;\n      color: #fff;\n      height: 150px;\n      margin-bottom: 15px;\n    }\n\n    .dashboardBx .bx .huge {\n      font-weight: 200;\n      font-size: 40px;\n      padding: 20px;\n    }\n\n    .dashboardBx .bx span {\n      display: block;\n    }\n\n    .dashboardBx .bx .topBx {\n      position: absolute;\n      top: 0;\n      right: 0;\n      background: rgba(0, 0, 0, .5);\n      padding: 8px 15px;\n      text-align: right;\n    }\n\n    .dashboardBx .bx .btn-group {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      background: rgba(0, 0, 0, .5);\n      padding: 0;\n      height: 0;\n      display: none;\n    }\n\n    .count-box .count-btn {\n      display: none !important;\n      transition: all .2s ease !important;\n    }\n\n    .count-box:hover .count-btn {\n      display: block !important;\n    }\n\n    .dashboardBx .bx.has-link:hover .btn-group {\n      padding: 8px;\n      display: table;\n      transition: all .2s ease;\n    }\n\n    /* .dashboardBx .bx.has-link:hover .huge {\n      padding: 0 20px;\n      transition: all .2s ease;\n    } */\n\n    .dashboardBx .bx .progress {\n      height: 5px;\n      margin: 0;\n      background: #d46e4e;\n      margin-top: -5px;\n    }\n\n    .dashboardBx .bx .progress .progress-bar-warning {\n      background: #fff;\n    }\n\n    .dashboardBx .bx.bg1 {\n      background: #d32f2f;\n      background: -moz-linear-gradient(45deg, #d32f2f 0%, #ef9a9a 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #d32f2f), color-stop(100%, #ef9a9a));\n      background: -webkit-linear-gradient(45deg, #d32f2f 0%, #ef9a9a 100%);\n      background: -o-linear-gradient(45deg, #d32f2f 0%, #ef9a9a 100%);\n      background: -ms-linear-gradient(45deg, #d32f2f 0%, #ef9a9a 100%);\n      background: linear-gradient(45deg, #d32f2f 0%, #ef9a9a 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#d32f2f\', endColorstr=\'#ef9a9a\', GradientType=1);\n    }\n\n    .dashboardBx .bx.bg2 {\n      background: #c2185c;\n      background: -moz-linear-gradient(45deg, #c2185c 0%, #f48fb0 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #c2185c), color-stop(100%, #f48fb0));\n      background: -webkit-linear-gradient(45deg, #c2185c 0%, #f48fb0 100%);\n      background: -o-linear-gradient(45deg, #c2185c 0%, #f48fb0 100%);\n      background: -ms-linear-gradient(45deg, #c2185c 0%, #f48fb0 100%);\n      background: linear-gradient(45deg, #c2185c 0%, #f48fb0 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#c2185c\', endColorstr=\'#f48fb0\', GradientType=1);\n    }\n\n    .dashboardBx .bx.bg3 {\n      background: #7b1fa2;\n      background: -moz-linear-gradient(45deg, #7b1fa2 0%, #ce93d8 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #7b1fa2), color-stop(100%, #ce93d8));\n      background: -webkit-linear-gradient(45deg, #7b1fa2 0%, #ce93d8 100%);\n      background: -o-linear-gradient(45deg, #7b1fa2 0%, #ce93d8 100%);\n      background: -ms-linear-gradient(45deg, #7b1fa2 0%, #ce93d8 100%);\n      background: linear-gradient(45deg, #7b1fa2 0%, #ce93d8 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#7b1fa2\', endColorstr=\'#ce93d8\', GradientType=1);\n    }\n\n    .dashboardBx .bx.bg4 {\n      background: #522da8;\n      background: -moz-linear-gradient(45deg, #522da8 0%, #b39ddb 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #522da8), color-stop(100%, #b39ddb));\n      background: -webkit-linear-gradient(45deg, #522da8 0%, #b39ddb 100%);\n      background: -o-linear-gradient(45deg, #522da8 0%, #b39ddb 100%);\n      background: -ms-linear-gradient(45deg, #522da8 0%, #b39ddb 100%);\n      background: linear-gradient(45deg, #522da8 0%, #b39ddb 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#522da8\', endColorstr=\'#b39ddb\', GradientType=1);\n    }\n\n    .dashboardBx .bx.bg5 {\n      background: #303f9f;\n      background: -moz-linear-gradient(45deg, #303f9f 0%, #9fa8da 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #303f9f), color-stop(100%, #9fa8da));\n      background: -webkit-linear-gradient(45deg, #303f9f 0%, #9fa8da 100%);\n      background: -o-linear-gradient(45deg, #303f9f 0%, #9fa8da 100%);\n      background: -ms-linear-gradient(45deg, #303f9f 0%, #9fa8da 100%);\n      background: linear-gradient(45deg, #303f9f 0%, #9fa8da 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#303f9f\', endColorstr=\'#9fa8da\', GradientType=1);\n    }\n\n    .dashboardBx .bx.bg6 {\n      background: #0288D1;\n      background: -moz-linear-gradient(45deg, #0288D1 0%, #81D4FA 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #0288D1), color-stop(100%, #81D4FA));\n      background: -webkit-linear-gradient(45deg, #0288D1 0%, #81D4FA 100%);\n      background: -o-linear-gradient(45deg, #0288D1 0%, #81D4FA 100%);\n      background: -ms-linear-gradient(45deg, #0288D1 0%, #81D4FA 100%);\n      background: linear-gradient(45deg, #0288D1 0%, #81D4FA 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#0288D1\', endColorstr=\'#81D4FA\', GradientType=1);\n    }\n\n    .dashboardBx .bx.bg7 {\n      background: #388E3C;\n      background: -moz-linear-gradient(45deg, #388E3C 0%, #A5D6A7 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #388E3C), color-stop(100%, #A5D6A7));\n      background: -webkit-linear-gradient(45deg, #388E3C 0%, #A5D6A7 100%);\n      background: -o-linear-gradient(45deg, #388E3C 0%, #A5D6A7 100%);\n      background: -ms-linear-gradient(45deg, #388E3C 0%, #A5D6A7 100%);\n      background: linear-gradient(45deg, #388E3C 0%, #A5D6A7 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#388E3C\', endColorstr=\'#A5D6A7\', GradientType=1);\n    }\n\n    .dashboardBx .bx.bg8 {\n      background: #AFB42B;\n      background: -moz-linear-gradient(45deg, #AFB42B 0%, #E6EE9C 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #AFB42B), color-stop(100%, #E6EE9C));\n      background: -webkit-linear-gradient(45deg, #AFB42B 0%, #E6EE9C 100%);\n      background: -o-linear-gradient(45deg, #AFB42B 0%, #E6EE9C 100%);\n      background: -ms-linear-gradient(45deg, #AFB42B 0%, #E6EE9C 100%);\n      background: linear-gradient(45deg, #AFB42B 0%, #E6EE9C 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#AFB42B\', endColorstr=\'#E6EE9C\', GradientType=1);\n    }\n\n    .dashboardBx .bx.bg9 {\n      background: #FBC02D;\n      background: -moz-linear-gradient(45deg, #FBC02D 0%, #FFF59D 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #FBC02D), color-stop(100%, #FFF59D));\n      background: -webkit-linear-gradient(45deg, #FBC02D 0%, #FFF59D 100%);\n      background: -o-linear-gradient(45deg, #FBC02D 0%, #FFF59D 100%);\n      background: -ms-linear-gradient(45deg, #FBC02D 0%, #FFF59D 100%);\n      background: linear-gradient(45deg, #FBC02D 0%, #FFF59D 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#FBC02D\', endColorstr=\'#FFF59D\', GradientType=1);\n    }\n\n    .dashboardBx .bx.bg10 {\n      background: #F57C00;\n      background: -moz-linear-gradient(45deg, #F57C00 0%, #FFCC80 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #F57C00), color-stop(100%, #FFCC80));\n      background: -webkit-linear-gradient(45deg, #F57C00 0%, #FFCC80 100%);\n      background: -o-linear-gradient(45deg, #F57C00 0%, #FFCC80 100%);\n      background: -ms-linear-gradient(45deg, #F57C00 0%, #FFCC80 100%);\n      background: linear-gradient(45deg, #F57C00 0%, #FFCC80 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#F57C00\', endColorstr=\'#FFCC80\', GradientType=1);\n    }\n\n    .dashboardBx .bx.bg11 {\n      background: #5D4037;\n      background: -moz-linear-gradient(45deg, #5D4037 0%, #BCAAA4 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #5D4037), color-stop(100%, #BCAAA4));\n      background: -webkit-linear-gradient(45deg, #5D4037 0%, #BCAAA4 100%);\n      background: -o-linear-gradient(45deg, #5D4037 0%, #BCAAA4 100%);\n      background: -ms-linear-gradient(45deg, #5D4037 0%, #BCAAA4 100%);\n      background: linear-gradient(45deg, #5D4037 0%, #BCAAA4 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#5D4037\', endColorstr=\'#BCAAA4\', GradientType=1);\n    }\n\n    .dashboardBx .bx.bg12 {\n      background: #9E9E9E;\n      background: -moz-linear-gradient(45deg, #9E9E9E 0%, #EEEEEE 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #9E9E9E), color-stop(100%, #EEEEEE));\n      background: -webkit-linear-gradient(45deg, #9E9E9E 0%, #EEEEEE 100%);\n      background: -o-linear-gradient(45deg, #9E9E9E 0%, #EEEEEE 100%);\n      background: -ms-linear-gradient(45deg, #9E9E9E 0%, #EEEEEE 100%);\n      background: linear-gradient(45deg, #9E9E9E 0%, #EEEEEE 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#9E9E9E\', endColorstr=\'#EEEEEE\', GradientType=1);\n    }\n\n    .dashboardBx .bx.bg13 {\n      background: #455A64;\n      background: -moz-linear-gradient(45deg, #455A64 0%, #B0BEC5 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #455A64), color-stop(100%, #B0BEC5));\n      background: -webkit-linear-gradient(45deg, #455A64 0%, #B0BEC5 100%);\n      background: -o-linear-gradient(45deg, #455A64 0%, #B0BEC5 100%);\n      background: -ms-linear-gradient(45deg, #455A64 0%, #B0BEC5 100%);\n      background: linear-gradient(45deg, #455A64 0%, #B0BEC5 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#455A64\', endColorstr=\'#B0BEC5\', GradientType=1);\n    }\n\n    .dashboardBx .bx.bg14 {\n      background: #FF7043;\n      background: -moz-linear-gradient(45deg, #FF7043 0%, #FFAB91 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #FF7043), color-stop(100%, #FFAB91));\n      background: -webkit-linear-gradient(45deg, #FF7043 0%, #FFAB91 100%);\n      background: -o-linear-gradient(45deg, #FF7043 0%, #FFAB91 100%);\n      background: -ms-linear-gradient(45deg, #FF7043 0%, #FFAB91 100%);\n      background: linear-gradient(45deg, #FF7043 0%, #FFAB91 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#FF7043\', endColorstr=\'#FFAB91\', GradientType=1);\n    }\n\n    .count-btn .popover-title {\n      color: #000000 !important;\n    }\n\n    .linkDisabled {\n      cursor: not-allowed !important;\n      pointer-events: none !important;\n      color: grey;\n    }\n  </style><div block-ui=\"dcDashboardUI\"><div class=\"row\"><h4 style=\"margin-left: 15px;margin-top: 0px;font-weight: 400;\">Appointment Filter</h4><div class=\"col-md-4\"><div class=\"form-group\"><div class=\"input-group\"><input id=\"datetimeFirst\" placeholder=\"Start Date\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"filtere.fromDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><div class=\"input-group\"><input id=\"datetimeEnd\" readonly=\"\" placeholder=\"End Date\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"filtere.toDate\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><button ng-disabled=\"userProfileForm.$invalid\" class=\"btn btn-primary\" ng-model=\"search\" ng-click=\"getDashboardItems()\">Search</button> <button class=\"btn primary\" ng-disabled=\"filtere.toDate ===\'\' && filtere.fromDate ===\'\'\" ng-click=\"resetDateValues()\">Clear</button></div></div></div><span class=\"text-danger\" style=\"font-size:small\">* Dashboard shows the data for the current financial year only, please select the start date and end date to view the details for the select period.</span><div class=\"row dashboardBx\"><div class=\"col-lg-3 col-md-4 p-r-0\" ng-show=\"impStatus.length > 0\" ng-repeat=\"status in impStatus track by $index\"><div class=\"bx has-link bg{{ $index + 1 }} count-box\"><span class=\"topBx\" ng-if=\"status.statusId==36 || status.statusId==37\">Rs.{{formatCurrency(status.amount)}}</span> <span class=\"huge\">{{status.apptCount}}</span> <span>{{status.statusName}}</span><div class=\"count-btn\"><a popover-placement=\"top\" uib-popover-template=\"reportRequestPopOverHandler.templateUrl\" popover-trigger=\"outsideClick\" popover-title=\"Select Month\" style=\"padding-top:5px;\" ng-if=\"status.statusId==36 || status.statusId==37\" class=\"btn btn-default btn-sm\">Request Report</a> <a class=\"btn btn-default btn-sm\" ng-click=\"viewDetailsTab(\'allappointmentsSearchStatus\', status.statusName , status.statusId, status.fromDate, status.toDate)\" ng-class=\"{ linkDisabled : status.apptCount == 0 ? true:false }\" ng-disabled=\"{{status.apptCount == 0 ? \'true\':\'false\'}}\">View details</a></div></div></div><div class=\"col-lg-3 col-md-4 p-r-0\" ng-show=\"providerProfileState\"><div class=\"bx has-link bg12 count-box\"><uib-progressbar uib-tooltip=\"{{(rating/totalRating)*100| number:0}}%\" class=\"progress-striped\" value=\"totalPercentage\" type=\"warning\" style=\"margin-right:20px;display: block;\"></uib-progressbar><span class=\"huge\">{{(rating/totalRating)*100| number:0}}%</span> <span>Profile completion</span><div ng-click=\"viewDetailsTab(\'provider-profile\')\" class=\"count-btn\"><a class=\"btn btn-default btn-sm\">View details</a></div></div></div><div class=\"col-lg-3 col-md-4 p-r-0\" ng-if=\"userDetails.hospitalUserCount\"><div class=\"bx has-link bg10 count-box\"><span class=\"huge\">{{userDetails.hospitalUserCount}}</span> <span>Users</span><div ng-click=\"viewDetailsTab(\'usermgmt\')\" class=\"count-btn\"><a class=\"btn btn-default btn-sm\">View details</a></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"reportDownloadPopover.html\"><div class=\"input-group\" style=\"width: 100%;\"> <input id=\"reportDownloadPopOverInput\" placeholder=\"Select date from\" readonly type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MMM/yyyy\" ng-model=\"reportDownloadPopOver.selectedDate\" is-open=\"reportDownloadPopOver.opened\" datepicker-options=\"{minMode: \'month\',minDate: \'Oct/2019\'}\" required show-button-bar=\"false\" style=\"width: 60%;\"/> <span class=\"input-group-btn\" style=\"width: 25%;float: left;\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"openReportDownloadPopOver()\"> <i class=\"glyphicon glyphicon-calendar\"></i> </button> </span> <i class=\"glyphicon glyphicon-download-alt\" style=\"color: #000; font-size: 18px; margin-top: 8px; cursor: pointer;\" ng-click=\"downloadDashBoardReport(status.statusId)\"></i> <!-- <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"downloadDashBoardReport(status.statusId)\" style=\"margin-top: 5px;\"> --> Download</button> </div></script>");
$templateCache.put("app/modules/dcDocuments/dcDocuments.html","<div class=\"container\" block-ui=\"documentsLoading\"><h2 class=\"text-center\" style=\"margin-top: -10px;margin-bottom: 15px;\">Documents <a><i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i></a></h2><hr><uib-accordion style=\"margin-top: 50px\" block-ui=\"documentsLoading\"><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"status.open\"><uib-accordion-heading style=\"color: grey;\">Search Panel <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}\"></i></uib-accordion-heading><div class=\"row\" style=\"margin-right: 0px\"><div class=\"col-sm-3\"><input type=\"text\" placeholder=\"Search State\" style=\"width:250px\" ng-model=\"state\" typeahead-min-length=\"0\" uib-typeahead=\"state.lookUpValue for state in stateList | filter:$viewValue\" typeahead-editable=\"false\" typeahead-focus-first=\"true\" typeahead-on-select=\"loadListByKey(\'state\',$item)\" class=\"form-control\" required=\"\"></div><div class=\"col-sm-3\"><input type=\"text\" placeholder=\"Search City\" style=\"width:250px\" ng-model=\"city\" typeahead-min-length=\"0\" uib-typeahead=\"city.lookUpValue for city in cityList | filter:$viewValue\" typeahead-editable=\"false\" typeahead-focus-first=\"true\" typeahead-is-open=\"true\" typeahead-on-select=\"loadListByKey(\'city\',$item)\" class=\"form-control\" ng-disabled=\"!state\" required=\"\"></div><div class=\"col-sm-3\"><input type=\"text\" placeholder=\"Search Location\" style=\"width:250px\" ng-model=\"location\" typeahead-min-length=\"0\" uib-typeahead=\"location.lookUpValue for location in locationList | filter:$viewValue\" typeahead-editable=\"false\" typeahead-focus-first=\"true\" typeahead-on-select=\"loadListByKey(\'location\',$item)\" class=\"form-control\" ng-disabled=\"!city\" required=\"\"></div><div class=\"col-sm-3\"><input type=\"text\" placeholder=\"Search DC\" style=\"width:250px\" ng-model=\"selectedDc\" typeahead-min-length=\"0\" uib-typeahead=\"dc.entityName for dc in dcList | filter:$viewValue\" typeahead-editable=\"false\" typeahead-focus-first=\"true\" typeahead-on-select=\"onDcSelection($item)\" class=\"form-control\" ng-disabled=\"!location\" required=\"\"></div></div></div></uib-accordion><div class=\"text-center\" ng-if=\"isDcSearch && noData\" style=\"font-size: 15px;font-weight: bold;margin-top: 50px;\">No Documents Found for {{selectedDcName}}</div><table class=\"table table-striped table-hover table-bordered table-condensed\" ng-if=\"isDcSearch && !noData\" style=\"margin-top: 50px;\"><tr><th style=\"width: 60px;\">Sl. No.</th><th>Document Name</th><th>Type</th></tr><tr style=\"cursor:pointer\" ng-repeat=\"doc in docs track by $index\"><td>{{ $index + 1 }}</td><td><a href=\"{{doc.link}}\" target=\"_blank\">{{ doc.docName }}</a></td><td>{{ doc.propName }}</td></tr></table></div>");
$templateCache.put("app/modules/dcInvestigations/dcInvestigations.html","<div><angular-tab appointmentlist=\"investigations\" tabname=\"\'DC Investigation\'\" tabtype=\"\'dcInvestigation\'\"></angular-tab></div><div class=\"modal fade\" id=\"dcInvestigationAddEdit\" tabindex=\"-1\" data-keyboard=\"false\" role=\"dialog\" aria-labelledby=\"RescheduleLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\" ng-show=\"!isEdit\">Add investigation</h4><h4 class=\"modal-title\" ng-show=\"isEdit\">Edit investigation <strong>{{editInvestigationName}}</strong></h4></div><div class=\"modal-body\"><form name=\"addUserForm\" id=\"addUserForm\" class=\"form\"><div class=\"form-group\"><div class=\"form-group\" style=\"display:none\"><label for=\"invstId\">Investigation id</label> <input name=\"invstId\" id=\"invstId\" class=\"form-control\" type=\"text\" ng-model=\"dcInvestigation.id\"></div><div class=\"row\"><div class=\"form-group col-xs-4\"><label for=\"invstGroup\">Investigation group</label> <span class=\"redfont\">*</span><select id=\"invstGroup\" ng-model=\"dcInvestigation\" class=\"form-control\" ng-options=\"opt.lookUpValue for opt in investigationGroup.lookUpData track by opt.lookUpId\" ng-change=\"changeGroup(update)\" value=\"update.groupName.lookUpValue\" required=\"\"><option value=\"\">Select group</option></select></div><div class=\"form-group col-xs-4 p-r-0\"><label for=\"invstName\">Investigation name</label> <span class=\"redfont\">*</span> <input name=\"invstName\" id=\"invstName\" class=\"form-control\" type=\"text\" ng-model=\"dcInvestigation.name\" required=\"\"> <span ng-show=\"addUserForm.invstName.$dirty && addUserForm.invstName.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group col-xs-4\"><label for=\"invstSn\">Investigation short name</label> <input name=\"invstSn\" id=\"invstSn\" class=\"form-control\" type=\"text\" ng-model=\"dcInvestigation.shortName\"></div></div><div class=\"form-group\"><label for=\"invstSc\">Investigation description</label> <textarea rows=\"5\" name=\"invstSc\" id=\"invstSc\" class=\"form-control\" ng-model=\"dcInvestigation.description\"></textarea></div><div class=\"checkbox\"><label><input name=\"invstActive\" id=\"invstId\" type=\"checkbox\" ng-model=\"dcInvestigation.isActive\"> Is active</label></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"addUserForm.$invalid\" ng-click=\"createUpdateInvestigations()\">Submit</button></div></div></div></div>");
$templateCache.put("app/modules/dcInvestigationsMap/dcInvestigationsMap.html","<div class=\"dashboard\"><div id=\"addUserMessage\" ng-show=\"submitUserMessage\" ng-class=\"addClass\" role=\"alert\" ng-click=\"submitUserMessage=false\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span> <span class=\"glyphicon glyphicon-remove pull-right\"></span> <span ng-bind-template=\"{{usermessage}}\"></span></div><div class=\"row\"><ng-form name=\"addNewDC\" class=\"form-horizontal\"><div id=\"search-DC\" class=\"row\"><div class=\"col-md-8\" style=\"margin-left: 20px; margin-bottom: 8px;\"><div class=\"pull-right addBtn\" style=\"margin-top: 18px; margin-right: 285px;\"><button class=\"btn btn-success\" ng-show=\"btnAddNewDcShow\" ng-click=\"btnAddNewDc()\"><i class=\"fa fa-plus\"></i> Add new dc</button></div><h3>Diagnostic center mapping</h3></div></div></ng-form></div><div class=\"DCs thumbnail\" ng-show=\"showDcList && showUserMessage\"><div id=\"addUserMessage\" ng-class=\"addClass\" role=\"alert\" ng-click=\"showUserMessage=false\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span> <span class=\"glyphicon glyphicon-remove pull-right\"></span> <span ng-bind-template=\"{{usermessage}}\"></span></div></div><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"status.isFirstOpen\"><uib-accordion-heading><a style=\"color: #168cc9;\">Search panel</a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isFirstOpen, \'glyphicon-chevron-right\': !status.isFirstOpen}\"></i></uib-accordion-heading><ng-form name=\"searchDC\" class=\"form-horizontal\"><div id=\"search-DC\" class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">State</label><div class=\"col-sm-8\"><select id=\"state\" class=\"form-control\" ng-model=\"search.stateSelected\" ng-change=\"loadCities(search.stateSelected.lookUpId, true);\" ng-options=\"opt as opt.lookUpValue for opt in states\"><option value=\"\">Select state</option></select></div></div><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Location</label><div class=\"col-sm-8\"><select id=\"location\" class=\"form-control\" ng-model=\"search.locationSelected\" ng-options=\"opt as opt.lookUpValue for opt in locations\" ng-change=\"loadMinorLocations(search.locationSelected.lookUpId, true);\"><option value=\"\">Select location</option></select></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">City</label><div class=\"col-sm-8\"><select id=\"city\" class=\"form-control\" ng-model=\"search.citySelected\" ng-options=\"opt as opt.lookUpValue for opt in cities\" ng-change=\"loadLocations(search.citySelected.lookUpId, true);\"><option value=\"\">Select city</option></select></div></div><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Sub location</label><div class=\"col-sm-8\"><select id=\"minorLocation\" class=\"form-control\" ng-model=\"search.minorLocationSelected\" ng-change=\"minorLocationChange();internalDDnFlag=1\" ng-options=\"opt as opt.lookUpValue for opt in minorLocations\"><option value=\"\">Select sub location</option></select></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"city\" class=\"control-label required-field col-sm-4\"></label><div class=\"col-sm-8\" style=\"margin-top: 50px;\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"!search.stateSelected.lookUpId && !search.citySelected.lookUpId && !search.locationSelected.lookUpId && !search.minorLocationSelected.lookUpId\" ng-click=\"clearSearch()\">Clear</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!search.stateSelected.lookUpId || !search.citySelected.lookUpId || !search.locationSelected.lookUpId\" ng-click=\"loadDCs(search.stateSelected.lookUpId, search.citySelected.lookUpId, search.locationSelected.lookUpId, search.minorLocationSelected.lookUpId)\">Search</button></div></div></div></div></ng-form></div></uib-accordion><div class=\"row\"><div class=\"col-md-12\" ng-show=\"diagnosticCentres.length>0\"><div class=\"col-md-6\"><angular-tab appointmentlist=\"diagnosticCentres\" tabname=\"\'DC Investigation Map\'\" tabtype=\"\'dcInvestigationMap\'\" callback-fn=\"ctrlFn(arg, value)\"></angular-tab></div></div></div><div class=\"row\"><div id=\"parentDCDetailsPanel\" class=\"col-md-12\"><ul class=\"nav nav-tabs\" id=\"myTab\"><li class=\"active tab-heading\"><a data-target=\"#dcDetails\" data-toggle=\"tab\" ng-show=\"btnDcDetailsShow\" ng-click=\"btnDcDetails(selectedDc,selectedDcErId)\">DC details</a></li><li class=\"tab-heading\"><a data-target=\"#mappedInvestigations\" data-toggle=\"tab\" ng-show=\"btnMappedInvestigationsShow\" ng-click=\"loadMappedDcInvestigations()\">Mapped investigations</a></li></ul><div class=\"tab-content\"><div class=\"tab-pane active\" id=\"dcDetails\" style=\"margin-left: 5px; margin-top: -2px;\"><div class=\"DCDetails row thumbnail\" ng-show=\"DcDetailsPanel\" style=\"background: white;\"><form name=\"dcForm\" class=\"form\" novalidate=\"\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"dcName\">Diagnostic center</label> <span ng-show=\"dcForm.dcName.$invalid\" class=\"redfont\">*</span> <input name=\"dcName\" id=\"dcName\" class=\"form-control\" type=\"text\" placeholder=\"Enter DC Name\" ng-model=\"updateDc.fullName\" required=\"\"> <span ng-show=\"dcForm.dcName.$dirty && dcForm.dcName.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group\"><label for=\"serviceTaxRegNo\">Service tax reg number</label> <input name=\"serviceTaxRegNo\" id=\"serviceTaxRegNo\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.serviceTaxRegNo\" placeholder=\"Enter service tax RegNo\"></div><div class=\"form-group\"><label for=\"primaryAddress\">Primary address</label><span ng-show=\"dcForm.primaryAddress.$invalid\" class=\"redfont\">*</span> <textarea name=\"primaryAddress\" id=\"primaryAddress\" class=\"form-control\" placeholder=\"Enter primary address\" ng-model=\"updateDc.primaryAddress\" required=\"\">\n                                    <span ng-show=\"dcForm.primaryAddress.$dirty && dcForm.primaryAddress.$error.required\" class=\"redSmallFont\">Required</span>\n                                </textarea></div><div class=\"form-group\"><label for=\"stateId\">State</label><span ng-show=\"dcForm.stateId.$invalid\" class=\"redfont\">*</span><select name=\"stateId\" id=\"stateId\" class=\"form-control\" required=\"\"><option value=\"null\">Select state</option></select></div><div class=\"form-group\"><label for=\"districtId\">District</label><span ng-show=\"dcForm.districtId.$invalid\" class=\"redfont\">*</span><select name=\"districtId\" id=\"districtId\" class=\"form-control\" required=\"\"><option value=\"\">Select district</option></select></div><div class=\"form-group\"><label for=\"cityId\">City</label><span ng-show=\"dcForm.cityId.$invalid\" class=\"redfont\">*</span><select name=\"cityId\" id=\"cityId\" class=\"form-control\" required=\"\"><option value=\"\">Select city</option></select></div><div class=\"form-group\"><label for=\"locationId\">Location</label><select name=\"locationId\" id=\"locationId\" class=\"form-control\"><option value=\"\">Select location</option></select></div><div class=\"form-group\"><label for=\"dcLocation\">Landmark</label> <input name=\"dcLocation\" placeholder=\"Enter landMark\" id=\"dcLocation\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.landmark\"></div><div class=\"form-group\"><label for=\"pinCode\">Pincode</label><span ng-show=\"dcForm.pinCode.$invalid\" class=\"redfont\">*</span> <input name=\"pinCode\" placeholder=\"Enter pincode\" class=\"form-control\" type=\"text\" ng-pattern=\"onlyNumbers\" ng-model=\"updateDc.pinCode\" required=\"\"> <span ng-show=\"dcForm.pinCode.$dirty && dcForm.pinCode.$error.required\" class=\"redSmallFont\">Required</span> <span ng-show=\"dcForm.pinCode.$dirty && dcForm.pinCode.$error.pattern\" class=\"redSmallFont\">Not a valid number</span></div><div class=\"form-group\"><label for=\"primaryLocationLatitude\">Latitude</label> <input name=\"primaryLocationLatitude\" placeholder=\"Select location from map\" readonly=\"\" id=\"primaryLocationLatitude\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.primaryLocationLatitude\"></div><div class=\"form-group\"><label for=\"primaryLocationLongitude\">Longitude</label> <input name=\"primaryLocationLongitude\" placeholder=\"Select location from map\" readonly=\"\" id=\"primaryLocationLongitude\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.primaryLocationLongitude\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"dcLandLine1\">Landline number</label> <input name=\"dcLandLine1\" placeholder=\"Enter landline number\" id=\"dcLandLine1\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.landlineNumber\"></div><div class=\"form-group\"><label for=\"dcLandLine1\">Email address</label> <input name=\"dcLandLine1\" placeholder=\"Enter email address\" id=\"dcLandLine1\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.emailAddress\"></div><div class=\"form-group\"><label for=\"dcContactPerson\">Primary contact person</label><span ng-show=\"dcForm.dcContactPerson.$invalid\" class=\"redfont\">*</span> <input name=\"dcContactPerson\" placeholder=\"Enter primary contact person name\" id=\"dcContactPerson\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.primaryContactName\" required=\"\"> <span ng-show=\"dcForm.dcContactPerson.$dirty && addUserForm.dcContactPerson.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group\"><label for=\"dcContactPersonMobile1\">Mobile</label> <input name=\"dcContactPersonMobile1\" id=\"dcContactPersonMobile1\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.primaryContactNumber\" placeholder=\"Enter primary mobile Number\"></div><div class=\"form-group\"><label for=\"dcContactPersonEmailId\">Secondary email</label> <input name=\"dcContactPersonEmailId\" id=\"dcContactPersonEmailId\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.primaryContactEmail\" placeholder=\"Enter primary email address\"></div><div class=\"form-group\"><label for=\"secondaryContactName\">Secondary contact person</label> <input name=\"secondaryContactName\" placeholder=\"Enter secondary contact person name\" id=\"secondaryContactName\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.secondaryContactName\"></div><div class=\"form-group\"><label for=\"secondaryContactNumber\">Secondary contact number</label> <input name=\"secondaryContactNumber\" placeholder=\"Enter secondary contact number\" id=\"secondaryContactNumber\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.secondaryContactNumber\"></div><div class=\"form-group\"><label for=\"dcAgreementStartDate\">Agreement start date</label> <input name=\"dcAgreementStartDate\" placeholder=\"Enter agreement start date\" id=\"dcAgreementStartDate\" class=\"form-control dateTimePicker\" type=\"text\" ng-model=\"updateDc.startDate\"></div><div class=\"form-group\"><label for=\"dcEffectiveEndDate\">Agreement end date</label> <input name=\"dcEffectiveEndDate\" placeholder=\"Enter agreement end date\" id=\"dcEffectiveEndDate\" class=\"form-control dateTimePicker\" type=\"text\" ng-model=\"updateDc.endDate\"></div><div class=\"form-group\"><label for=\"tds\">TDS</label> <input name=\"tds\" placeholder=\"Enter TDS number\" id=\"tds\" class=\"form-control\" type=\"text\" ng-model=\"TDS.tds\"></div><div class=\"form-group\"><label for=\"primaryLocationoutSourcingDetail\">Test Outsourcing Detail</label> <textarea name=\"primaryLocationoutSourcingDetail\" row=\"2\" placeholder=\"Select location from map\" id=\"primaryLocationoutSourcingDetail\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.primaryLocationoutSourcingDetail\"></textarea></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"website\">DC webSite name</label> <input name=\"website\" placeholder=\"Enter website name\" id=\"dcEffectiveEndDate\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.website\"></div><div class=\"form-group\"><label for=\"accountNumber\">Account number</label><span ng-show=\"dcForm.accountNumber.$invalid\" class=\"redfont\">*</span> <input name=\"accountNumber\" placeholder=\"Enter account number\" id=\"accountNumber\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.accountNumber\" required=\"\"> <span ng-show=\"dcForm.accountNumber.$dirty && dcForm.accountNumber.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group\"><label for=\"accountHolderName\">Account holder name</label><span ng-show=\"dcForm.accountHolderName.$invalid\" class=\"redfont\">*</span> <input name=\"accountHolderName\" id=\"accountHolderName\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.accountHolderName\" placeholder=\"Enter account holder\'s name\" required=\"\"> <span ng-show=\"dcForm.accountHolderName.$dirty && dcForm.accountHolderName.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group\"><label for=\"bankName\">Bank name</label><span ng-show=\"dcForm.bankName.$invalid\" class=\"redfont\">*</span> <input name=\"bankName\" placeholder=\"Enter bank name\" id=\"bankName\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.bankName\" required=\"\"> <span ng-show=\"dcForm.bankName.$dirty && dcForm.bankName.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group\"><label for=\"branchCode\">Branch code</label><span ng-show=\"dcForm.branchCode.$invalid\" class=\"redfont\">*</span> <input name=\"branchCode\" placeholder=\"Enter branch name\" id=\"branchCode\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.branchCode\" required=\"\"> <span ng-show=\"dcForm.branchCode.$dirty && dcForm.branchCode.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group\"><label for=\"ifscCode\">IFSC code</label><span ng-show=\"dcForm.ifscCode.$invalid\" class=\"redfont\">*</span> <input name=\"ifscCode\" placeholder=\"Enter IFSC code\" id=\"ifscCode\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.ifscCode\" required=\"\"> <span ng-show=\"dcForm.ifscCode.$dirty && dcForm.ifscCode.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group\"><label for=\"branchAddress\">Branch address</label><span ng-show=\"dcForm.branchAddress.$invalid\" class=\"redfont\">*</span> <input name=\"branchAddress\" placeholder=\"Enter branch address\" id=\"branchAddress\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.branchAddress\" required=\"\"> <span ng-show=\"dcForm.branchAddress.$dirty && dcForm.branchAddress.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group\"><label for=\"micrCode\">MICR code</label><span ng-show=\"dcForm.micrCode.$invalid\" class=\"redfont\">*</span> <input name=\"micrCode\" placeholder=\"Enter MICR code\" id=\"micrCode\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.micrCode\" required=\"\"> <span ng-show=\"dcForm.micrCode.$dirty && dcForm.micrCode.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group\"><label for=\"pan\">PAN number</label><span ng-show=\"dcForm.pan.$invalid\" class=\"redfont\">*</span> <input name=\"pan\" placeholder=\"Enter PAN number\" id=\"pan\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.pan\" required=\"\"> <span ng-show=\"dcForm.pan.$dirty && dcForm.pan.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group\"><label for=\"panHolderName\">PAN holder name</label><span ng-show=\"dcForm.panHolderName.$invalid\" class=\"redfont\">*</span> <input name=\"panHolderName\" placeholder=\"Enter PAN holder name\" id=\"panHolderName\" class=\"form-control\" type=\"text\" ng-model=\"updateDc.panHolderName\" required=\"\"> <span ng-show=\"dcForm.panHolderName.$dirty && dcForm.panHolderName.$error.required\" class=\"redSmallFont\">Required</span></div><div class=\"form-group\"><label for=\"reports\">Attached docs-only PDF</label> <span class=\"glyphicon glyphicon-paperclip\"></span> <span class=\"redfont\">*</span> <input type=\"file\" name=\"reports\" id=\"reports\" accept=\"application/pdf,application/vnd.ms-excel\" ng-model=\"updateDc.attachDocIds\" multiple=\"\"><div style=\"height: 40px; overflow-y: scroll; overflow-x:hidden\"><div ng-repeat=\"doc in updateDc.attachDocIds track by $index\"><a href=\"{{urlPrefix}}/WAPI/GetFile/{{doc}}.json\">Doc {{$index+1}}</a></div></div></div><div class=\"form-group input-group\" style=\"padding-top:10px\"><span class=\"input-group-addon\"><input name=\"dcActive\" id=\"dcActive\" type=\"checkbox\" ng-model=\"updateDc.isactive\" class=\"pull-right\"></span> <label for=\"dcActive\" class=\"pull-right form-control\">Active</label></div><button id=\"btnChooseFile\" type=\"button\" class=\"btn btn-primary dcUpdateModal\" ng-disabled=\"dcForm.$invalid\" ng-click=\"updateDcSubmit()\"><i class=\"glyphicon glyphicon-upload\"></i> Submit</button></div></form><div class=\"panel panel-default\"><div class=\"panel-body\"><p style=\"padding:5px;\">Please type in the hospital name, city name to find the hospital. Click on suggested results and check if the location is correct.Else, you can also type the location name and search for hospital nearby. Clicking on map will place a marker there and update Latitude and Longitude fields of the form.</p><google-map-autocomplete ng-if=\"map.isInitialised\" map=\"map.value\" callback-fn=\"placeChanged(arg)\" style=\"position: absolute;z-index: 1;width: 50%;bottom: 310px;left: 22%;\"></google-map-autocomplete><div id=\"map-canvas\"></div></div></div></div></div><div class=\"tab-pane\" id=\"mappedInvestigations\"><div class=\"MappedInvestigations row thumbnail\" ng-show=\"mappedInvestigationPanel\" style=\"background: white;\"><div class=\"panel-group\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\"><div ng-repeat=\"key in keys\"><div class=\"panel panel-default selectedinvestigations\"><div class=\"panel-heading\"><span class=\"pull-right\">Total cost: {{mappedInvestigations[key].cost}}</span> <span class=\"badge pull-right\">{{selectedItems[key]}}/{{mappedInvestigations[key].length}}</span> <a ng-click=\"selectAll(key, true)\" ng-show=\"selectedItems[key] !== mappedInvestigations[key].length\">Select all</a> <a ng-click=\"selectAll(key, false)\" ng-show=\"selectedItems[key] === mappedInvestigations[key].length\">Clear all</a><div style=\"margin-left: 77px; margin-top: -20px; color: brown;\" class=\"padLeft\" ng-click=\"isCollapsedHorizontal = !isCollapsedHorizontal\" data-toggle=\"collapse\" data-target=\"#{{key}}\">{{key}}</div></div><div><div uib-collapse=\"isCollapsedHorizontal\"><div ng-repeat=\"inv in mappedInvestigations[key]\"><div><ul><div class=\"col-md-6 input-group\" style=\"margin-top: 9px;\"><span class=\"input-group-addon\"><input name=\"checkAll\" class=\"{{key}}\" type=\"checkbox\" ng-model=\"inv.selected\" ng-click=\"countChecked(mappedInvestigations,inv)\" data-perid=\"{{inv.perId}}\" data-id=\"{{inv.id}}\" data-description=\"{{inv.description}}\" data-productname=\"{{inv.name}}\" data-isactive=\"{{inv.isActive}}\" data-quantity=\"{{inv.quantity}}\" data-dcrate=\"{{inv.dcRate}}\"></span> <label class=\"form-control\">{{inv.name}}</label></div><div class=\"col-md-4 pull-right\"><input style=\"margin-top: -35px;\" type=\"number\" class=\"form-control\" id=\"cost_{{inv.id}}\" ng-model=\"inv.dcRate\" min=\"0\" ng-change=\"calculateTotalCost([key])\"></div></ul></div></div></div></div></div></div></div><button type=\"button\" class=\"btn btn-primary\" ng-click=\"saveMappedInvestigations()\">Save</button></div></div></div></div></div></div>");
$templateCache.put("app/modules/denied/denied.html","<div block-ui=\"deniedClaims\"><div><angular-tab datalist=\"deniedClaims\" tabname=\"\'Denied Claims\'\" callback-fn=\"ctrlFn(arg)\"></angular-tab></div><div class=\"no-settled-claims\" ng-if=\"isSuccess && deniedClaims && deniedClaims.length === 0\"><div class=\"bs-callout bs-callout-info\"><h4>No denied claims found.</h4><p>This hospital doesn\'t seem to have any denied claims.</p></div></div></div>");
$templateCache.put("app/modules/doctors/doctors.html","<div><style>\n    .switch {\n      position: relative;\n      display: inline-block;\n      width: 60px;\n      height: 34px;\n    }\n\n    .switch input {\n      display: none;\n    }\n\n    .slider {\n      position: absolute;\n      cursor: pointer;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-color: #ccc;\n      -webkit-transition: .4s;\n      transition: .4s;\n    }\n\n    .slider:before {\n      position: absolute;\n      content: \"\";\n      height: 26px;\n      width: 26px;\n      left: 4px;\n      bottom: 4px;\n      background-color: white;\n      -webkit-transition: .4s;\n      transition: .4s;\n    }\n\n    input:checked+.slider {\n      background-color: #2196F3;\n    }\n\n    input:focus+.slider {\n      box-shadow: 0 0 1px #2196F3;\n    }\n\n    input:checked+.slider:before {\n      -webkit-transform: translateX(26px);\n      -ms-transform: translateX(26px);\n      transform: translateX(26px);\n    }\n\n    .note {\n      padding: 10px;\n      margin: 10px 0;\n      background: yellow;\n      border-radius: 6px;\n      color: #000;\n    }\n\n    /* Rounded sliders */\n    .slider.round {\n      border-radius: 34px;\n    }\n\n    .slider.round:before {\n      border-radius: 50%;\n    }\n\n  </style><div class=\"specialist-list clearfix\" id=\"specialist\" ng-hide=\"addDoc || editDoctor\"><div class=\"row\" style=\"margin-bottom: -15px;\"><div class=\"col-md-1\" style=\"margin-right: -35px\"><i class=\"fa fa-user-md fa-2x\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></div><div class=\"col-md-2\" style=\"margin-top:-18px;\"><h3>Doctors</h3></div><div class=\"col-md-3 pull-right mainActionBar\"><div class=\"col-md-4\" ng-if=\"showSync\"><button class=\"btn btn-xs btn-default\" style=\"border: hidden;\" ng-click=\"doctorsMethods.loadDoctors()\" uib-tooltip=\"View Full List\" tooltip-placement=\"left\"><i class=\"fa fa-list-alt fa-2x\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></button></div><div class=\"col-md-4\" ng-if=\"showSync\"><button class=\"btn btn-xs btn-default\" style=\"border: hidden;\" ng-click=\"doctorsMethods.showSyncPending()\" uib-tooltip=\"View Sync Pending\" tooltip-placement=\"left\"><i class=\"fa fa-refresh fa-spin fa-2x\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></button></div><div class=\"col-md-4\"><button class=\"btn btn-xs btn-default\" ng-click=\"doctorsMethods.openAddDoctor()\" uib-tooltip=\"Add New Doctor\" tooltip-placement=\"left\" style=\"border: hidden\"><i class=\"fa fa-plus-square fa-2x\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></button></div></div></div><hr><form class=\"form\"><div class=\"row\"><div class=\"col-md-5\"><label for=\"registrationFee\">Hospital registration fee</label> <input type=\"text\" numbers-only=\"numbers-only\" placeholder=\"Enter registration fees\" ng-maxlength=\"4\" name=\"registrationAmount\" id=\"registrationAmount\" class=\"form-control\" ng-model=\"profile.hospRegtFee\"> <span ng-if=\"frmRooms.registrationAmount.$error.maxlength\" style=\"color: #f00\">Registration fees not seems to be valid.</span></div><div class=\"col-md-5\" tooltip-placement=\"{{placement.selected}}\" uib-tooltip=\"Enter the number of days for which follow-up consultation fees would not be charged\"><label for=\"waivedOff\">Follow-up consultation fee waiver</label><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-options=\"option.Value for option in wavedOffDaysOuter track by option.id\" ng-model=\"addEditHospContact.wavedoffDays\"></select></div><div class=\"col-md-2\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"updateHospitalProfileDetails()\" style=\"margin-top:23px;\">Save</button> <a tooltip-placement=\"bottom\" uib-tooltip=\"Add information about doctors available for consultation; Medi Assist members see this information on MediBuddy Infiniti, our curated platform for outpatient services, to choose, select and schedule appointments for doctor consultations at your hospital/medical centre.\"><i class=\"fa fa-question-circle\"></i></a></div></div></form><div ng-show=\"!isChangeView\"><table ng-if=\"doctors.length >0\" class=\"table table-hover table-condensed table-striped table-bordered\" style=\"margin-top:15px;\"><tr style=\"color: #000000;\"><th colspan=\"2\">Name</th><th>Department</th><th style=\"width: 80px;\">Fees</th><th style=\"width: 160px;\">Working days</th><th style=\"width: 150px;\">Last updated date</th><th>Action</th></tr><tr ng-repeat=\"doc in doctors\"><td style=\"width:32px\"><img ng-src=\"{{doc.docImageToShow}}\" align=\"{{doc.docName}}\" class=\"profileImgTbl\"></td><td><strong>{{ doc.docName }}</strong><br><span class=\"smTxt\">{{doc.docType}} doctor</span></td><td><strong>{{ doc.docDep }}</strong><span class=\"smTxt\" style=\"max-width: 30rem;word-wrap: break-word;\">{{doc.docQualification}}, {{doc.docExper}} experience</span></td><td><i class=\"fa fa-rupee\" style=\"margin-right:3px;\"></i>{{ doc.docFees }}</td><td class=\"avalibality\"><span ng-class=\"doc.docDays[0] ? \'\' : \'notavail\'\">M</span> <span ng-class=\"doc.docDays[1] ? \'\' : \'notavail\'\">T</span> <span ng-class=\"doc.docDays[2] ? \'\' : \'notavail\'\">W</span> <span ng-class=\"doc.docDays[3] ? \'\' : \'notavail\'\">T</span> <span ng-class=\"doc.docDays[4] ? \'\' : \'notavail\'\">F</span> <span ng-class=\"doc.docDays[5] ? \'\' : \'notavail\'\">S</span> <span ng-class=\"doc.docDays[6] ? \'\' : \'notavail\'\">S</span></td><td>{{ doc.modifiedOn | date:\'dd-MMM-yyyy\' }}</td><td><button class=\"btn btn-primary btn-sm\" uib-tooltip=\"Edit\" style=\"cursor: pointer\" ng-click=\"doctorsMethods.openDoctorDetails(doc)\" ng-if=\"!doc.isDelete\"><i class=\"fa fa-pencil-square-o fa-3\" aria-hidden=\"true\"></i></button> <button ng-if=\"showSync && doctorsMethods.isSyncValid(doc)\" class=\"btn btn-sm btn-primary\" uib-tooltip=\"Sync\" style=\"cursor: pointer\" ng-click=\"doctorsMethods.syncDocData(doc)\"><i class=\"fa fa-refresh fa-3\" aria-hidden=\"true\"></i></button></td></tr></table><div style=\"margin-left: 370px;\" ng-show=\"doctors.length >0\"><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" ng-click=\"pageChange(currentPage)\" items-per-page=\"itemsPerPage\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></div></div></div><div id=\"openDoctor\" ng-show=\"addDoc || editDoctor\"><div class=\"row docHead\"><div class=\"profile-photo\"><a href=\"\" class=\"editBtn btn btn-sm btn-primary\" data-target=\"#doctorImage\" data-toggle=\"modal\"><i class=\"fa fa-gear\"></i> Change photo</a> <img ng-show=\"editDoc.docImageToShow\" ng-src=\"{{editDoc.docImageToShow}}\"> <img ng-show=\"!editDoc.docImageToShow\" src=\"/app/resources/images/doc.png\" alt=\"Upload doctor photo\"><h3 style=\"margin-right: 90px;\" ng-show=\"editDoctor\"><span ng-if=\"doctorsMethods.checkDr(editDocName)\">Dr.</span> {{editDocName}}</h3></div></div><form role=\"form\" name=\"doctor\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"docName\">Full name <span class=\"text-danger\">*</span><span style=\"margin-left: 100px;\"><input type=\"checkbox\" ng-model=\"editDoc.isHod\">Is HOD</span></label> <input type=\"text\" id=\"docName\" placeholder=\"Enter doctor name\" name=\"docname\" class=\"form-control\" ng-model=\"editDoc.docName\" required=\"\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"\">Education <span class=\"text-danger\">*</span></label><div class=\"row\"><div class=\"col-md-6\" uib-dropdown=\"\" is-open=\"qualificationDropdownOpen\"><button id=\"qualification\" class=\"btn btn-default\" uib-dropdown-toggle=\"\">Qualification <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"qualification\" style=\"max-height: 200px;overflow-y:scroll;\"><li role=\"menuitem\" ng-repeat=\"edu in educationList track by $index\" ng-click=\"qualificationSelected(edu.label,$index)\"><a href=\"\">{{edu.label}}</a></li></ul></div><div class=\"col-md-6\" uib-dropdown=\"\" is-open=\"categoryDropdownOpen\"><button id=\"category\" class=\"btn btn-default\" uib-dropdown-toggle=\"\">Category <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"category\" style=\"max-height: 200px;overflow-y:scroll;\"><li role=\"menuitem\" ng-if=\"isDegreeSelected\" ng-repeat=\"cat in selectedDegreeCategory track by $index\" ng-click=\"categorySelected(cat)\"><a href=\"\">{{cat}}</a></li></ul></div></div><small ng-model=\"editDoc.docQualification\" required=\"\">{{editDoc.docQualification}}</small> <button class=\"btn btn-primary btn-xs\" style=\"margin-top:2px\" ng-if=\"qualificationNameArray.length\" data-toggle=\"modal\" data-target=\"#doctorEducationModal\"><i class=\"fa fa-pencil\"></i></button></div></div><div class=\"col-md-3\"><label for=\"\">Gender<span class=\"text-danger\">*</span></label><div class=\"form-group\"><label class=\"btn btn-info\" ng-model=\"editDoc.gender\" uib-btn-radio=\"\'MALE\'\" ng-click=\"setGender(\'MALE\')\">Male</label> <label class=\"btn btn-info\" ng-model=\"editDoc.gender\" uib-btn-radio=\"\'FEMALE\'\" ng-click=\"setGender(\'FEMALE\')\">Female</label></div></div><div class=\"col-md-3\"><label for=\"\">Speaks</label><div class=\"form-group\"><div ng-dropdown-multiselect=\"\" options=\"languages\" selected-model=\"editDoc.languages\"></div></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"\">Registration no.<span class=\"text-danger\">*</span></label> <input type=\"text\" class=\"form-control\" placeholder=\"Enter registration number\" ng-model=\"editDoc.docRegNo\" required=\"\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"\">Practice started <span class=\"text-danger\">*</span>({{editDoc.docExper}} experience)</label><div class=\"row\"><div class=\"col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon\">Since</span><select class=\"form-control\" ng-model=\"editDoc.practicingSinceMonth\" ng-change=\"doctorsMethods.getDocExperience()\" style=\"width:50%\" required=\"\"><option value=\"1\">JAN</option><option value=\"2\">FEB</option><option value=\"3\">MAR</option><option value=\"4\">APR</option><option value=\"5\">MAY</option><option value=\"6\">JUN</option><option value=\"7\">JUL</option><option value=\"8\">AUG</option><option value=\"9\">SEP</option><option value=\"10\">OCT</option><option value=\"11\">NOV</option><option value=\"12\">DEC</option></select><input placeholder=\"Click here to select year\" type=\"text\" numbers-only=\"numbers-only\" ng-minlength=\"4\" ng-maxlength=\"4\" min=\"1940\" class=\"form-control\" ng-focus=\"showYearAdd = true;\" ng-click=\"showYearAdd = true;editDoc.practicingSince=undefined;editDoc.docExper=undefined\" ng-model=\"editDoc.practicingSince\" style=\"width:50%\"><div class=\"cal-year popover bottom\" ng-hide=\"!showYearAdd || editDoc.practicingSince\" required=\"\"><div class=\"arrow\"></div><div class=\"popover-content\"><a href=\"\" class=\"btn btn-default btn-xs\" ng-repeat=\"i in doctorsMethods.getNumber(number) track by $index\" ng-click=\"doctorsMethods.setYear($index+1950);\">{{$index+1950}}</a></div></div></div></div></div></div></div><div class=\"col-md-3\"><div class=\"form-group tagsList\"><label for=\"\">Specializations or Department <span class=\"text-danger\">*</span></label> <input type=\"text\" ng-model=\"specializedIn\" uib-typeahead=\"dpt.departmentName for dpt in departmentTypes | filter:$viewValue | limitTo:8\" typeahead-editable=\"false\" typeahead-focus-first=\"true\" typeahead-on-select=\"onSpecializationSelect($item)\" class=\"form-control\" required=\"\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"\">Awards and recognitions</label><ol class=\"addList\" style=\"margin-left: -40px;\"><li ng-repeat=\"award in awards track by $index\" ng-init=\"award.reco ? hideEdit = true : hideEdit = false\"><div class=\"input-group\"><p ng-show=\"hideEdit\">{{award.reco}}</p><textarea ng-show=\"!hideEdit\" rows=\"1\" class=\"form-control\" ng-model=\"award.reco\" data-id=\"awards[$index]\"></textarea> <span class=\"input-group-btn\"><button ng-show=\"hideEdit\" class=\"btn btn-primary btn-xs\" type=\"button\" ng-click=\"hideEdit = false\"><i class=\"fa fa-pencil\"></i></button> <button ng-show=\"!hideEdit\" class=\"btn btn-success\" type=\"button\" ng-disabled=\"!award.reco\" ng-click=\"hideEdit = true\"><i class=\"fa fa-check\"></i></button> <button ng-show=\"!hideEdit\" class=\"btn btn-danger\" type=\"button\" ng-click=\"doctorsMethods.removeAward($index)\"><i class=\"fa fa-close\"></i></button></span></div></li><li class=\"last\"><a href=\"\" class=\"btn btn-sm btn-info\" ng-click=\"doctorsMethods.addNewAward()\"><i class=\"fa fa-plus\"></i> Add Award or Recognitions</a></li></ol></div></div></div><hr><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"\">Consultation type</label><select class=\"form-control\" ng-model=\"editDoc.docType\" ng-options=\"dt.doctorTypeId as dt.doctorType for dt in doctorTypes\"><option value=\"\">Select</option></select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"\">Consultation fees <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rs.</span> <input name=\"consultationFees\" placeholder=\"Enter consultation fees\" type=\"text\" numbers-only=\"numbers-only\" max=\"4000\" class=\"form-control\" ng-model=\"editDoc.docFees\" required=\"\"></div><span ng-show=\"doctor.consultationFees.$error.max\" style=\"color: #f00\">Consultation fees not seems to be valid.</span></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label for=\"\">Discounted fees <span class=\"text-danger\">*</span></label><div class=\"input-group\"><span class=\"input-group-addon\">Rs.</span> <input name=\"discountedFees\" placeholder=\"Enter discounted fees\" type=\"text\" numbers-only=\"numbers-only\" max=\"4000\" class=\"form-control\" ng-model=\"editDoc.discountedFees\" required=\"\"></div><span ng-show=\"doctor.discountedFees.$error.max\" style=\"color: #f00\">Discounted fees not seems to be valid.</span></div></div><div class=\"col-md-4\"><div class=\"form-group\" tooltip-placement=\"{{placement.selected}}\" uib-tooltip=\"Enter the number of days for which follow-up consultation fees would not be charged\"><label for=\"\">Follow-up consultation fee waiver</label><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-options=\"option.Value for option in wavedOffDays track by option.id\" ng-model=\"editDoc.wavedoffDays\"></select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"\">Timings <span class=\"text-danger\">*</span></label><div class=\"schedule\"><table class=\"table table-condensed table-bordered\"><tr><td colspan=\"2\">Copy<select style=\"display:inline-block\" ng-model=\"selectedDay\" ng-options=\"day.name for day in daysOfWeek\" ng-change=\"doctorsMethods.captureSelectedDay(selectedDay.name)\"><option value=\"\">Select</option></select>time to all weekdays <button class=\"btn btn-xs btn-success\" ng-model=\"abc\" ng-click=\"doctorsMethods.copyTime(selectedDay.name)\" ng-disabled=\"!selectedDay.name\">OK</button> <button class=\"btn btn-xs btn-success\" ng-model=\"abc\" ng-click=\"doctorsMethods.clearTime()\">Clear All</button></td></tr><tr ng-repeat=\"tim in timmingsOfWeek track by $index\"><td class=\"dayBx\">{{tim.dayName}}</td><td><div class=\"timeBx\" ng-repeat=\"timeing in tim.timeSlots track by $index\">{{timeing.startTimeHrs}}:{{timeing.startTimeMins}}<span>-</span>{{timeing.endTimeHrs}}:{{timeing.endTimeMins}} <a href=\"\" ng-click=\"doctorsMethods.removeTime(tim.dayName, $index, $parent.$index)\"><i class=\"fa fa-close\"></i></a></div><div class=\"addTime\"><a href=\"\" class=\"btn btn-default addTimeBtn\" ng-click=\"showTimeAdd = true; timeSlot.startAM = true;timeSlot.endAM = true\" ng-hide=\"tim.timeSlots.length > 3\"><i class=\"fa fa-plus\"></i> Add timings</a><div class=\"popover bottom\" ng-show=\"showTimeAdd\"><div class=\"arrow\"></div><h3 class=\"popover-title\">Select timings</h3><div class=\"popover-content\"><div class=\"row\"><div class=\"col-xs-6\">From</div><div class=\"col-xs-6\">To</div></div><div class=\"row\"><fieldset name=\"frmMon\"><div class=\"col-xs-3 p-r-0\"><select class=\"form-control\" ng-model=\"timeSlot.startTimeHrs\" ng-options=\"time for time in InOutTime\" ng-required=\"showTimeAdd\"><option value=\"\">hh</option></select></div><div class=\"col-xs-3 p-l-0\"><select class=\"form-control\" ng-model=\"timeSlot.startTimeMins\" ng-options=\"time for time in InOutTimeQuater\" ng-required=\"showTimeAdd\"><option value=\"\">mm</option></select></div><div class=\"col-xs-3 p-r-0\"><select class=\"form-control\" ng-model=\"timeSlot.endTimeHrs\" ng-options=\"time for time in InOutTime\" ng-required=\"showTimeAdd\"><option value=\"\">hh</option></select></div><div class=\"col-xs-3 p-l-0\"><select class=\"form-control\" ng-model=\"timeSlot.endTimeMins\" ng-options=\"time for time in InOutTimeQuater\" ng-required=\"showTimeAdd\"><option value=\"\">mm</option></select></div><div class=\"col-xs-3 p-r-0\"></div><div class=\"col-xs-3 p-l-0\"><input type=\"button\" class=\"btn btn-default btn-xs pull-right\" ng-show=\"!timeSlot.startPM\" ng-model=\"timeSlot.startAM\" ng-click=\"timeSlot.startPM = true;timeSlot.startAM=false\" value=\"AM\"> <input type=\"button\" class=\"btn btn-default btn-xs pull-right\" ng-show=\"!timeSlot.startAM\" ng-model=\"timeSlot.startPM\" ng-click=\"timeSlot.startPM = false;timeSlot.startAM=true\" value=\"PM\"></div><div class=\"col-xs-3 p-r-0\"></div><div class=\"col-xs-3 p-l-0\"><input type=\"button\" class=\"btn btn-default btn-xs pull-right\" ng-show=\"!timeSlot.endPM\" ng-model=\"timeSlot.endAM\" ng-click=\"timeSlot.endPM = true;timeSlot.endAM=false\" value=\"AM\"> <input type=\"button\" class=\"btn btn-default btn-xs pull-right\" ng-show=\"!timeSlot.endAM\" ng-model=\"timeSlot.endPM\" ng-click=\"timeSlot.endPM = false;timeSlot.endAM=true\" value=\"PM\"></div></fieldset></div><div class=\"row btns\"><div class=\"col-xs-6\"><a href=\"\" class=\"btn btn-sm btn-default\" ng-click=\"showTimeAdd = false\">Close</a></div><div class=\"col-xs-6 text-right\"><button href=\"\" class=\"btn btn-sm btn-primary\" ng-disabled=\"!timeSlot.startTimeHrs || !timeSlot.startTimeMins || !timeSlot.endTimeHrs || !timeSlot.endTimeMins\" ng-click=\"doctorsMethods.addTime(tim.dayName, timeSlot.startTimeHrs, timeSlot.startTimeMins, timeSlot.endTimeHrs, timeSlot.endTimeMins, timeSlot.startPM, timeSlot.endPM, timeSlot); showTimeAdd = false;\">Add</button></div></div></div></div></div></td></tr></table></div></div></div><div class=\"clearfix\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"doctorsMethods.closeDoctor()\">Close</button> <button ng-if=\"!addDoc\" type=\"button\" class=\"btn btn-danger\" data-target=\"#deleteDoctor\" data-toggle=\"modal\" ng-disabled=\"doctor.$invalid\">Delete</button> <button ng-if=\"addDoc\" type=\"button\" class=\"btn btn-success pull-right\" ng-click=\"doctorsMethods.addNewDoctor()\" ng-disabled=\"doctor.$invalid || !isRequired || !doctorsMethods.timeSlotAdded()\">Add</button> <button ng-if=\"!addDoc\" type=\"button\" class=\"btn btn-success pull-right\" ng-click=\"doctorsMethods.addNewDoctor(true, false)\" ng-disabled=\"doctor.$invalid || departmentTypes.length ===0 || !doctorsMethods.timeSlotAdded() || !editDoc.docFees || editDoc.docFees == 0 || !editDoc.gender || editDoc.gender == \'\'\">Update</button></div></form></div><div class=\"modal fade\" id=\"doctorEducationModal\" role=\"dialog\"><div class=\"modal-dialog modal-sm\" style=\"width:400px\"><div class=\"modal-content\"><div class=\"modal-header\"><button class=\"btn-default btn-xs close\" data-dismiss=\"modal\" ng-click=\"closeQualificationModal()\"><i class=\"fa fa-close\"></i></button><h4 class=\"modal-title\" id=\"modal-title\">Education List</h4></div><div class=\"modal-body\"><ul><li ng-repeat=\"education in qualificationNameArray track by $index\">{{education}}<i class=\"fa fa-times-rectangle-o pull-right\" style=\"cursor: pointer;color: #ff00009c\" ng-click=\"qualificationUpdate($index)\" aria-hidden=\"true\"></i></li></ul></div><div class=\"modal-footer\"><button class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"saveQualification()\">Save</button> <button class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"closeQualificationModal()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"doctorImage\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"fileUploadMethods.clearFileModels()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Add doctor image</h4></div><div class=\"modal-body\"><div id=\"addHospImages\" role=\"tabpanel\" class=\"tab-pane\"><div style=\"margin-top:20px\"><fieldset data-ng-repeat=\"item in file\"><div class=\"input-group\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\" class=\"form-control\"> <span class=\"input-group-btn\"><button class=\"btn removeLargeDocument\" ng-click=\"fileUploadMethods.removeFileToUpload($index)\"><i class=\"fa fa-close\"></i></button></span></div></fieldset></div></div></div><div class=\"modal-footer\"><button type=\"button\" id=\"submit\" name=\"submit\" class=\"btn btn-sm btn-success\" data-dismiss=\"modal\" ng-click=\"doctorsMethods.uploadDoctorImage()\">Submit</button> <button type=\"button\" class=\"btn btn-default btn-sm pull-left\" data-dismiss=\"modal\" ng-click=\"fileUploadMethods.clearFileModels()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"deleteDoctor\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Are you sure you want to remove <strong>Dr. {{editDocName}}</strong> ?</h4></div><div class=\"modal-body\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">No</button> <button type=\"button\" class=\"btn btn-danger pull-right\" data-dismiss=\"modal\" ng-click=\"doctorsMethods.addNewDoctor(true, true)\">Yes</button></div></div></div></div>");
$templateCache.put("app/modules/documentsAwaited/documentsAwaited.html","<div block-ui=\"documentPending\"><div class=\"row\" ng-show=\"configuredTpaList && configuredTpaList.length>0\"><div class=\"col-md-4\"><div class=\"form-group\"><label style=\"font-weight: 400;\">Payer Name <span style=\"color: red; font-size: small;\">*</span></label><select name=\"insurername\" required=\"\" class=\"form-control\" ng-options=\"item as item.value for item in configuredTpaList track by item.value\" ng-model=\"tpaName\" ng-change=\"getPDAClaimsList(null,tpaName);\"></select></div></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"isDataCheck && pdaClaims && pdaClaims.length === 0\"><div class=\"no-settled-claims\"><div class=\"bs-callout bs-callout-info\"><h4>No physical documents pending claims found.</h4><p>This hospital doesn\'t seem to have any physical documents pending claims.</p></div></div></div></div><div><div ng-show=\"pdaClaims && pdaClaims.length > 0\"><button class=\"btn btn-warning btn-sm\" uib-tooltip=\"Remind me\" style=\"color: #101010;background-color: #dddddd;border-color: #dddddd; margin-left: 89%\" ng-click=\"remindMe(false,\'\')\"><i class=\"fa fa-inbox\"></i> Remind me</button></div><div class=\"claims\" ng-show=\"(tpaName && tpaName.id==MaTPAId && !tpaName.isGovtScheme)\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"btn-group\" data-toggle=\"buttons\" style=\"margin-top:23px\"><label ng-class=\"pendingDoc==\'all\'?\'btn btn-danger disabled\':\'btn btn-danger\'\"><input type=\"radio\" value=\"all\" checked=\"\" autocomplete=\"off\" name=\"rdopendingDoc\" ng-model=\"pendingDoc\" ng-click=\"getPDAClaimsList(this.pendingDoc)\"> All</label> <label ng-class=\"pendingDoc==\'pending\'?\'btn btn-warning disabled\':\'btn btn-warning\'\"><input type=\"radio\" autocomplete=\"off\" value=\"pending\" name=\"rdopendingDoc\" ng-model=\"pendingDoc\" ng-click=\"getPDAClaimsList(this.pendingDoc)\">Pending</label> <label ng-class=\"pendingDoc==\'updated\'?\'btn btn-success disabled\':\'btn btn-success\'\"><input type=\"radio\" autocomplete=\"off\" value=\"updated\" name=\"rdopendingDoc\" ng-model=\"pendingDoc\" ng-click=\"getPDAClaimsList(this.pendingDoc)\"> Updated</label></div></div><div class=\"col-md-3\"><div ng-show=\"pendingDoc==\'pending\'\"><label>Pending :</label><select id=\"pendingFrom\" class=\"form-control\" name=\"pendingFrom\" ng-model=\"pendingFromNoOfDays\" ng-change=\"getPDAClaimsList(this.pendingFromNoOfDays)\"><option value=\"0\">All Pending</option><option value=\"1-7\">0-7 days</option><option value=\"7-30\">7-30 days</option><option value=\"30-0\">> 30 days</option></select></div></div><div class=\"col-md-6\"><span style=\"margin-top:30px\" class=\"text-danger pull-right\">* Claims which are pending for more than 30 days for document submission will be marked as \"PA not utilized\" (canceled).</span></div></div><div class=\"tab-pane\" ng-show=\"isLoading\"></div><angular-tab datalist=\"pdaClaims\" tabname=\"\'Documents Pending\'\" noofdaysforpendingdoc=\"pendingFromNoOfDays\" callback-fn=\"ctrlFn(arg)\"></angular-tab></div><div class=\"claims\" ng-show=\"pdaClaims && pdaClaims.length > 0 && (tpaName && tpaName.id==MaTPAId && tpaName.isGovtScheme) || (tpaName && tpaName.id!=MaTPAId)\"><angular-tabs datalist=\"pdaClaims\" tabname=\"\'Documents Pending\'\" callback-fn=\"ctrlFn(arg)\" callback-second-fn=\"callbackSecond(arg, flag, page, tpaId)\" tpaid=\"tpaName\"></angular-tabs></div></div><div class=\"modal fade\" id=\"remindMe\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><h4>Reminder Request</h4></div><div class=\"modal-body\"><ng-form name=\"report\" class=\"form-inline\"><div class=\"form-group\"><p>Please send me a reminder for pending submissions of claims documents to</p><input style=\"width: 100%\" placeholder=\"Enter mail address\" type=\"text\" class=\"form-control\" ng-model=\"mailID\" ng-pattern=\"emailchk\"></div><div class=\"form-group\" style=\"margin-top: 8px; margin-left: 355px;\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" ng-disabled=\"!mailID ||report.$invalid\" class=\"btn btn-primary\" ng-click=\"remindMe(true,mailID)\">Request</button></div></ng-form></div></div></div></div></div>");
$templateCache.put("app/modules/documentsReceived/documentsReceived.html","<div><div class=\"claims\" block-ui=\"documentReceivedClaims\"><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"isSuccess && pdrClaims && pdrClaims.length === 0\"><div class=\"no-settled-claims\"><div class=\"bs-callout bs-callout-info\"><h4>No claims are pending settlement after receipt of physical documents.</h4><p>This hospital doesn\'t seem to have any physical documents received claims.</p></div></div></div></div><div class=\"row\" ng-show=\"configuredTpaList && configuredTpaList.length>0\"><div class=\"col-md-4\"><div class=\"form-group\"><label style=\"font-weight: 400;\">Payer Name <span style=\"color: red; font-size: small;\">*</span></label><select name=\"insurername\" required=\"\" class=\"form-control\" ng-options=\"item as item.value for item in configuredTpaList track by item.value\" ng-model=\"tpaName\" ng-change=\"getPDRClaimsList(this.tpaName);\"></select></div></div></div><div class=\"claims\" ng-show=\"(tpaName && tpaName.id==MaTPAId && !tpaName.isGovtScheme)\"><angular-tab datalist=\"pdrClaims\" tabname=\"\'Documents Received\'\" callback-fn=\"ctrlFn(arg)\"></angular-tab></div><div class=\"claims\" ng-show=\"pdrClaims && pdrClaims.length > 0 && (tpaName && tpaName.id==MaTPAId && tpaName.isGovtScheme) || (tpaName && tpaName.id!=MaTPAId)\"><angular-tabs datalist=\"pdrClaims\" tabname=\"\'Documents Received\'\" callback-fn=\"ctrlFn(arg)\" tpaid=\"tpaName\"></angular-tabs></div></div></div>");
$templateCache.put("app/modules/error/error.html","<h1>Error 404</h1>");
$templateCache.put("app/modules/faq/faqs.html","<style>\n	.clickable{\n		cursor: pointer;\n	}\n	.points{\n		padding: 25px;\n		line-height: 30px;\n	}\n	.nav.nav-tabs>li>a {\n		padding: 5px;\n	}\n</style><h2>Do\'s and Don\'ts</h2><uib-tabset active=\"activeForm\"><uib-tab index=\"0\" heading=\"Do\'s\"><div class=\"panel panel-default points\"><ol><li>In emergency cases, cashless request should be forwarded to respective TPA within 24 hours after hospitalization.</li><li>In planned cases, cashless request should be forwarded to respective TPA, at least 48 hours prior to hospitalization in the prescribed format. Obtain approval, 24 hours prior to admission.</li><li>Claim documents should reach TPA within 7 working days from the date of the discharge.</li><li>Always collect photocopy of ID card along with photo ID proof. Check the member identification before extended cashless treatment.</li><li>Collect duly fill and signed claim from the insured and submit along with claim from.</li><li>Send all original documents to TPA for processing.</li><li>Specify the discount details in the final bill to avoid excess deductions at the time claim process.</li><li>Along with claim documents, original pre-authorization request, cashless approval copy should be enclosed</li><li>Retain photocopies of claim documents, which ever has been sent to TPA.</li><li>Discharge summary should have present complaints, diagnosis, past history, investigation done, Treatment during hospitalization, OT notes, discharge advice, indications for.</li><li>Pre-authorization from is to be signed by the treating doctor / consultant only.</li><li>Ensure that, pre-authorization is obtained by the hospital within 24 hours from admission.</li><li>Inform insured on receipt of approval / query / rejection from respective TPA.</li><li>In case of any query, revert within 2 hours and contact respective TPA</li><li>Inform concerned TPA, in case of any enhancement required at least 24 hours prior to discharge.</li><li>Extend cashless facility for approved ailment as specified In the cashless approval.</li><li>Collect the expenses related to non-payable items / over and above approval amount / ailment expenses which ever not payable under policy coverage from the insured directly prior to the discharge.</li><li>For early settlement, please submit NEFT declarations to Medi Assist</li></ol></div></uib-tab><uib-tab index=\"1\" heading=\"Don\'ts\"><div class=\"panel panel-default points\"><ol><li>Don’t insist upon admission for investigation or evaluations or health check-ups.</li><li>Don’t give any original bills / documents to the insured for cashless admissions.</li><li>Don’t forget to take insured signature on pre-auth request, cashless approval, final bill and discharge summary.</li><li>Cashless services can be denied, in case of insufficient information / vague symptoms / where medical team of TPA is not sure of eligibility under policy coverage, don’t insist for cashless approvals in such scenarios.</li><li>Don’t send photocopies of the document for claim processing.</li><li>Don’t send the bills without proper prescriptions and investigation reports.</li><li>Don’t hide any relevant information related to the past history duration and treatment line of the insured.</li><li>Don’t extend cashless for unapproved ailments / non-payable items.</li><li>Don’t demand any advance deposit from the insured.</li><li>Don’t suggest instant admissions for planned cases.</li><li>Don’t insist for the authorization letter for emergency cases at the time of admission.</li></ol></div></uib-tab></uib-tabset>");
$templateCache.put("app/modules/freshDesk/freshdesk.html","<style>\n    .chatBx{\n        background-color: aliceblue;\n        margin-left:110px;\n        padding:10px; border-bottom:2px solid #ddd; margin-bottom:5px;\n        position: relative;\n        background:#fff;\n    }\n    .chatBx h2 {position:absolute; width:100px; margin:0 0 0 -100px; padding:5px; font-size:14px; font-weight:normal; top:0; left:0; background:#14bcc8; color:#fff;}\n    .chatBx h2 i {display:inline-block;}\n    .chatBx h2 .date {display:block; font-size:11px;}\n    .chatUser{margin:0 110px 5px 0;}\n    .chatUser h2 {position:absolute; width:100px; right:0; left:auto; margin:0 -100px 0 0;}\n</style><div class=\"row\"><div class=\"col-sm-12\"><h4>Write an email to Medi Assist</h4><p class=\"bg-warning error\" style=\"padding:10px; display:none;\">Please select subject of the form</p><p id=\"success-message\" class=\"bg-info error\" style=\"padding:10px; display:none;\">Your request has been submitted. One of our executive will get in touch with you. Have a great day!</p><div block-ui=\"freshDesksendMail\" id=\"contact-form\"><form name=\"contact\" role=\"form\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"subject\">Categories</label><select name=\"subject\" required=\"\" id=\"subject\" class=\"form-control\" ng-model=\"test.subject\"><option value=\"\">Select Categories</option><option value=\"General query\">General query</option><option value=\"Claims related query\">Claims related query</option><option value=\"Hospital-profile change request\">Hospital-profile change request</option><option value=\"Payment related query\">Payment related query</option><option value=\"In-Patient package\">In-Patient package</option><option value=\"Out-Patient package\">Out-Patient package</option><option value=\"Feedback\">Feedback</option></select></div></div><div class=\"col-md-8\"><div class=\"form-group\"><label for=\"message\">Message</label> <textarea placeholder=\"Type your message...\" required=\"\" ng-model=\"message\" name=\"message\" id=\"message\" rows=\"2\" style=\"width:100%;\" class=\"form-control\"></textarea></div></div><div class=\"col-md-1\"><div class=\"form-group\"><button style=\"margin-top: 20px;\" ng-disabled=\"contact.$invalid\" type=\"submit\" class=\"btn btn-primary pull-right\" ng-click=\"newMailRequest(test.subject,message)\" ng-show=\"getUserRole()!=\'guest\'\">Submit</button></div></div></div></form></div></div></div><div class=\"row\" ng-if=\"isPlus\"><div class=\"col-md-8\" style=\"padding-right: 0px;margin-top: 5px;\"><p class=\"pull-right\" ng-click=\"reloadAppointments()\" style=\"\">Search ticket for other users :</p></div><div class=\"col-md-4\" ng-if=\"isPlus\"><select style=\"\" ng-change=\"userbasedOnTicket(selectedUser)\" name=\"subject\" id=\"userSelection\" class=\"form-control\" ng-model=\"selectedUser\"><option value=\"\">Select User</option><option value=\"{{item.userEmail}}\" ng-repeat=\"item in usersData\">{{item.userEmail}}</option></select></div></div><div block-ui=\"freshDesk\" ng-if=\"tickets.currentPageNumber === 0 && tickets.nextPageNumber === 0 && tickets.previousPageNumber === 0 && isCall ===false && isPlus\"><p style=\"margin-left: 8px;background-color: #43bcc9;height: 40px;padding-top: 10px;margin-top: 10px; padding: 10px;\">No data found for <strong>\"{{userInMailBox}}\"</strong></p></div><div block-ui=\"freshDesk\" class=\"tab-pane\" style=\"\" ng-if=\"tickets.allTickets.length >0 && isPlus\"><uib-tabset><uib-tab><uib-tab-heading class=\"tab-heading tab\">Mailbox ({{tickets.allTickets.length}})</uib-tab-heading><table class=\"table table-hover\"><thead><tr style=\"\"><th rowspan=\"2\" class=\"text-left Custom-Header\" style=\"background-color: #dae7e8;color:#000;\">Subject</th><th rowspan=\"2\" class=\"text-left Custom-Header\" style=\"background-color: #dae7e8;color:#000;\">Status</th><th rowspan=\"2\" class=\"text-left Custom-Header\" style=\"background-color: #dae7e8;color:#000;\">Created Date</th><th rowspan=\"2\" class=\"text-left Custom-Header\" style=\"background-color: #dae7e8;color:#000;\">Updated Date</th></tr></thead><tbody><tr ng-repeat-start=\"item in tickets.allTickets\" ng-click=\"getMailDetails(item, show$index);\" style=\"cursor:pointer;\"><td>{{item.subject}}</td><td>{{item.status_name}}</td><td>{{compareDateNew(item.created_at)}}</td><td>{{compareDateNew(item.updated_at)}}</td></tr><tr ng-show=\"item.id === ticketDetails.id\" ng-repeat-end=\"\"><td colspan=\"4\" style=\"background-color:#f2f2f2;\"><div ng-show=\"ticketDetails.description_html\" class=\"clearfix text-right\" style=\"margin-bottom:5px;\"><button class=\"btn btn-danger btn-sm\" ng-click=\"ticketDetails.id = 0\">Close</button> <button class=\"btn btn-primary btn-sm\" ng-click=\"mailReply(item)\">Reply</button></div><div class=\"chatBx\" ng-repeat=\"item in ticketDetails.notes\" ng-class=\"item.note.isuser === true ? \'chatUser\' : \'chatClient\'\" style=\"\"><h2><i class=\"fa fa-user\"></i> {{item.note.user_name}} <span class=\"date\">{{compareDateNew(item.note.created_at)}}</span></h2><div ng-bind-html=\"item.note.body_html\"></div><p><a ng-repeat=\"file in item.note.attachments track by $index\" href=\"{{file.attachment_url}}\" target=\"_blank\" class=\"btn btn-xs btn-primary\" style=\"margin-right:5px;\">Attachment {{$index+1}}</a></p></div><div class=\"chatBx chatUser\" ng-if=\"ticketDetails.description_html\"><h2><i class=\"fa fa-user\"></i>{{ticketDetails.requester_name}} <span class=\"date\">{{compareDateNew(ticketDetails.created_at)}}</span></h2><div ng-bind-html=\"ticketDetails.description_html\"></div><p><a ng-repeat=\"item in ticketDetails.attachments track by $index\" href=\"{{item.attachment_url}}\" target=\"_blank\" class=\"btn btn-xs btn-danger\" style=\"margin-right:5px;\">Attachment {{$index+1}}</a></p></div><div ng-show=\"ticketDetails.description_html\" class=\"clearfix text-right\" style=\"margin-top:5px;\"></div></td></tr></tbody></table><div style=\"margin-left: 400px\"><button class=\"btn btn-primary\" style=\"width: 100px;\" ng-disabled=\"currentPage ===1\" ng-click=\"getInbox(currentPage - 1)\">Previous</button> <button class=\"btn btn-primary\" style=\"width: 100px\" ng-disabled=\"nextPageNumber ===0\" ng-click=\"getInbox(nextPageNumber)\">Next</button></div></uib-tab></uib-tabset></div><div class=\"row\" style=\"margin-left: 5px;margin-top: 10px;\"><div class=\"col-sm-6 col-md-4\" ng-show=\"address\"><h3>Submit your claims to</h3><p><strong>{{address.entityName.replace(\'Mediassist\',\'Medi Assist\')}}</strong><br>{{address.primaryAddress}}, {{address.city}}, {{address.state}} - {{address.pinCode}}</p></div><div class=\"col-sm-6 col-md-4\" ng-hide=\"address\"></div><div class=\"col-sm-6 col-md-4\"><h3>Contact</h3><p><b>Dedicated number:</b> 080-22068666<br><div ng-if=\"false\"><b>Phone:</b> {{address.landLineNumber}}<br><b>Fax:</b> {{address.fax}}</div></p></div><div class=\"col-sm-6 col-md-4\"><h3>Corporate Office</h3><p><strong>Medi Assist Healthcare Services</strong><br>Tower D, 4th Floor, IBC Knowledge Park, 4/1 Bannerghatta Road, Bhavani Nagar, Bengaluru<br>Karnataka - 560029.</p><p><strong>Phone</strong> 1800-425-9449</p></div></div><div class=\"modal fade\" id=\"NewMail\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">New Ticket</h4></div><div class=\"modal-body\"><ng-form name=\"courierdetailsForm\" class=\"form-horizontal\"><div id=\"user-profile\" class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-3\">Subject <span>* :</span></label><div class=\"col-sm-8\"><div class=\"input-group\"><input style=\"width: 366px;\" class=\"form-control\" type=\"text\" name=\"subject\" placeholder=\"Type Subject\" ng-model=\"subject\" id=\"subject\" maxlength=\"500\" required=\"\"></div></div></div><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-3\">Add note <span>* :</span></label><div class=\"col-sm-8\"><div class=\"input-group\"><textarea id=\"datetimeFirst\" maxlength=\"500\" class=\"form-control\" style=\"margin: 0px; width: 366px; height: 170px; z-index: 2; position: relative; line-height: 20px; font-size: 14px; transition-duration: initial; transition-timing-function: initial; transition-property: none; background: transparent !important;\" placeholder=\"Type message...\" ng-model=\"replyMessageByUser\" required=\"\">\n                                    </textarea></div></div></div></div></div></ng-form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!subject || !replyMessageByUser || isFileUploading === true\" ng-click=\"newMailRequest(subject,replyMessageByUser)\">Send</button></div></div></div><div class=\"modal fade\" id=\"mailReplyModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Reply</h4></div><div class=\"modal-body\"><ng-form name=\"courierdetailsForm\" class=\"form-horizontal\"><div id=\"user-profile\" class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-3\">Add note <span>* :</span></label><div class=\"col-sm-8\"><div class=\"input-group\"><textarea id=\"datetimeFirst\" maxlength=\"500\" class=\"form-control\" style=\"margin: 0px; width: 366px; height: 170px; z-index: 2; position: relative; line-height: 20px; font-size: 14px; transition-duration: initial; transition-timing-function: initial; transition-property: none; background: transparent !important;\" placeholder=\"Type message...\" ng-model=\"replyMessageByUser\" required=\"\">\n                                    </textarea></div></div></div></div></div></ng-form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!reply || isFileUploading === true\" ng-click=\"reply(replyMessageByUser)\">Reply</button></div></div></div></div><div class=\"tab-pane\" style=\"margin-top: 30px;color: red;font-size: medium;padding-left: 25px;\" ng-if=\"isCall ===false && tickets.allTickets.length ===0\"><p>No data found!</p><div class=\"tab-pane\" style=\"margin-top: 30px;color: red;font-size: medium;padding-left: 25px;\" ng-if=\"isCall === true\"><p>fetching packages data...</p></div></div></div>");
$templateCache.put("app/modules/fuserUpsell/fuserUpsell.html","<div><span>{{fuserUpsell}}</span><iframe ng-src=\"{{fuserURL}}\" style=\"width:100%; height: 8in\"></iframe></div>");
$templateCache.put("app/modules/governmentClaims/government.html","<div><button ng-show=\"getCmsUserCheck()\" style=\"margin-left: 836px; margin-bottom: 5px;\" class=\"btn-xs btn-primary\" ng-click=\"getGovtClaimsList(1000042)\">Show all Government claims</button><div block-ui=\"governmentClaims\"><angular-tab datalist=\"govtClaims\" tabname=\"\'Government Schemes\'\" callback-second-fn=\"callbackSecond(arg, flag, page)\" callback-fn=\"ctrlFn(arg)\"></angular-tab></div></div>");
$templateCache.put("app/modules/guidelines/guidelines.html","<style type=\"text/css\">\n    .bigger {\n        font-family: monospace;\n        background-color: aliceblue;\n    }\n</style><h3 style=\"margin:0 0 20px 0\">Guidelines</h3><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a href=\"http://blogs.medibuddy.in/highlight-healthcare-services-for-your-customers-with-medibuddy/\" target=\"_blank\">MediBuddy+ Tutorial</a></h4></div></div><div class=\"panel panel-default\" ng-click=\"showPanel(8)\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a href=\"\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#collapseEight\">MB+ Profile configurations</a></h4></div><div id=\"collapseEight\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><h4>About<br></h4><h5><span>Enter a brief introduction to your medical facility. Members see this information when they want to know more about your facility.</span></h5><h4>Images<br></h4><h5><span>Add images of your medical facility to help members choose your services. For best experience please upload images of 650px width and 350px height.</span></h5><h4>Facilities<br></h4><h5><span>Choose and add facilities available at your hospital / medical centre.</span></h5><h4>Team contact<br></h4><h5><span>Members at your organization who would receive department-specific announcements / alerts from Medi Assist. Operational SPOCs would receive requests for booking health checks, doctor consults, and more.</span></h5><h4>Health-check packages (out-patient)<br></h4><h5><span>Add information about the various health check packages offered by you. Medi Assist members see, choose and book these packages on MediBuddy Infiniti, the curated platform for outpatient services.</span></h5><h4>Doctors<br></h4><h5><span>Add information about doctors available for consultation; Medi Assist members see this information on MediBuddy Infiniti, our curated platform for outpatient services, to choose, select and schedule appointments for doctor consultations at your hospital / medical centre.</span></h5><h4>Rooms<br></h4><h5><span>Enter detailed information about each room type available at your premises, along with photos. Medi Assist members see this information during a network hospital; and choose and book their preferred room for inpatient care while opting for an eCashless hospitalisation.<br>For best experience please upload images of 650px width and 350px height.</span></h5></div></div></div><div class=\"panel panel-default\" ng-click=\"showPanel(9)\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a href=\"\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#collapseNine\">eCashless Process</a></h4></div><div id=\"collapseNine\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><h4>eCashless,<br></h4><h5><span>the fastest new way of getting your patients secure and hassle-free preauthorization is here! Here’s how it works:</span></h5><ol><li>Your patient initiates an eCashless request ahead of their planned hospitalization.</li><li>Medi Assist forwards the request to you for provisional preauthorization.</li><li>If you are a:<ol type=\"I\"><li>MediBuddy+ user, you see this request in your regular queue for planned hospitalizations. Click Confirm to proceed with the request.</li><li>Not on MediBuddy+ yet, you receive an email with a link to the online form.</li></ol></li><li>You review the patient’s details, preferred room type, the ailment and suggested treatment, the treating doctor at your hospital,</li><li>You enter the estimated cost of treatment and submit the provisional request online.</li><li>Medi Assist validates your submission and sends you a secure pass-code protected provisional letter of approval. This document can be opened only upon presentation of a pass-code that is sent securely to the patient.</li><li>The provisional pre-authorization letter from Medi Assist becomes a formal letter of approval only when:<ol type=\"I\"><li>The patient walks into your hospital for admission and submits the secure pass-code at the insurance desk, and</li><li>You unlock the provisional confirmation letter using the secure pass-code, and</li><li>You obtain a valid photo ID proof and all necessary signatures from the patient on the pre-authorization request form. The form is already filled and availablefor you to download instantly</li></ol></li><li>No waiting at the insurance desk! You delight your patient with the fastest pre-authorization ever!</li></ol></div></div></div><div class=\"panel panel-default\" ng-click=\"showPanel(7)\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a href=\"\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#collapseSeven\">Reset Web Browser For Better Experience</a></h4></div><div id=\"collapseSeven\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><h4>Chrome</h4><ol><li>In the browser bar, enter:<ul><li><span class=\"bigger\">chrome://settings/clearBrowserData</span></li></ul></li><li>Select the following:<ul><li><span class=\"bigger\">Browsing history</span></li><li><span class=\"bigger\">Download history</span></li><li><span class=\"bigger\">Cookies and other site and plug-in data</span></li><li><span class=\"bigger\">Cached images and files</span></li>From the <span class=\"bigger\">Obliterate the following items from:</span> drop-down menu, you can choose the period of time for which you want to clear cached information. To clear your entire cache, select <span class=\"bigger\">the beginning of time</span>.</ul></li><li>Click <span class=\"bigger\">Clear browsing data</span>.</li><li>Exit/quit all browser windows and re-open the browser.</li></ol><h4>Firefox</h4><ol><li>From the <span class=\"bigger\">History</span> menu, select <span class=\"bigger\">Clear recent history</span>.<ul><li>If the menu bar is hidden, press <span class=\"bigger\" style=\"color: #FF163F\">Alt</span> to make it visible.</li></ul></li><li>From the <span class=\"bigger\">Time range to clear:</span> drop-down menu, select the desired range; to clear your entire cache, select <span class=\"bigger\">Everything</span>.</li><li>Expenses for irrelevant investigations/ diagnostic test will be deducted. Please collect the same from the patient.</li><li>Next to \"Details\", click the down arrow to choose which elements of the history to clear; to clear your entire cache, select all items.</li><li>Click <span class=\"bigger\">Clear Now</span>.</li><li>Exit/quit all browser windows and re-open the browser.</li></ol><h4>Internet Explorer 9 and higher</h4><ol><li>Select <span class=\"bigger\">Tools</span> (via the Gear Icon) > <span class=\"bigger\">Safety</span> > <span class=\"bigger\">Delete browsing history...</span>.<ul><li>If the menu bar is hidden, press <span class=\"bigger\" style=\"color: #FF163F\">Alt</span> to make it visible.</li></ul></li><li>Deselect <span class=\"bigger\">Preserve Favorites website data</span>, and select:<ul><li><span class=\"bigger\">Temporary Internet files</span> or <span class=\"bigger\">Temporary Internet files and website files</span></li><li><span class=\"bigger\">Cookies</span> or <span class=\"bigger\">Cookies and website data</span></li><li><span class=\"bigger\">History</span></li></ul></li><li>Click <span class=\"bigger\">Delete</span>. You will see a confirmation at the bottom of the window when the process is complete.</li><li>Exit/quit all browser windows and re-open the browser.</li></ol><h4>Safari</h4><ol><li>From the <span class=\"bigger\">Safari</span> menu, select <span class=\"bigger\">Clear History and Website Data...</span>.</li><li>Select the desired time range, and then click <span class=\"bigger\">Clear History</span>.</li><li>Go to <span class=\"bigger\">Safari</span> > <span class=\"bigger\">Quit safari</span> or press <span class=\"bigger\" style=\"color: #FF163F\">Command-Q</span> to exit the browser completely.</li></ol></div></div></div><div class=\"panel panel-default\" ng-click=\"showPanel(1)\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a href=\"\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#collapseOne\">Cashless process</a></h4></div><div id=\"collapseOne\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><h4>Process of cashless hospitalization</h4><ol><li>After doctor has recommended admission, collect the insurance card ( Medi assist card or insurance company ID card ) . The Insurance Card can only be used for inpatient admission which exceeds a minimum of 24 hours. It cannot be used for outpatient consultation / investigations. For some policies the card can also be used for day care procedures listed in the policy document modified.</li><li>The Medi Assist Pre-authorization form needs to be duly filled by your doctor and claimant and the same needs to be forwarded to Medi Assist.<wbr>Your pre-authorization will have two sections:-<ul><li>General details on the health insurance policy – to be filled in by claimant.</li><li>Treatments details pertain to the treatment recommended – needs to be filled in and duly signed by the doctor who is treating the patient.</li></ul></li><li>Form will then to be mailed /uploaded in portal by the hospital. The decision on the pre-authorization request will be decided by Medi Assist / insurance company as per the policy terms and conditions.</li><li>In case of enhancement request, the interim/final bill along with case/discharge summary needs to be faxed to Medi Assist TPA. The decision on the same will be conveyed to the hospital.</li><li>In some instances, more information may be required to take a decision on the pre-authorization request and the same will be conveyed to the hospital via fax/ email. The hospital would need to revert to Medi Assist, who would then give the final decision after evaluating the pre-authorization request.</li></ol><h4>Note :</h4><ol><li>Medi Assist/ Insurer will not be liable for payment in case if it is found that the material facts were suppressed/ misrepresented/ not disclosed.</li><li>Authorization is valid for the proposed line of treatment. Any change in the line of treatment must be informed immediately, failing which the authorization stands cancelled.</li><li>Expenses for irrelevant investigations/ diagnostic test will be deducted. Please collect the same from the patient.</li><li>Expenses of medicines/drugs for chronic ailments such as diabetics, hypertension, and hyperthyroidism etc., which the patient has been taking, will be deducted.</li><li>Authorization invalid if admitted later than 15/09/2014 23:59 hrs. (For dialysis and radiotherapy - the period mentioned in the PA request).</li><li>Please collect the non-medical expenses/surcharges/service charges/luxury taxes, etc., and co-pay as mentioned above (visit www.mediassistindia.com for non-medical list).</li><li>The copy of the receipt for having collected the amount from the patient should be sent along with other documents failing which, double the co-pay indicated above will be deducted while settling the cashless claim.</li><li>Patients/representative\'s signature on the final bill is mandatory; please get the signature on the final bill.</li><li>Please send us the relevant documents with in a maximum of 7 days after the patient is discharged.</li><li>Provide self-attested copy of photo ID card of the patient (MANDATORY); any one of these: (a) Driving Licence (b) PAN Card (c) Voter ID card (d) School/College ID card (e) Passport (f) ID card issued by employer (g) Any other suitable photo identification.</li><li>If the bill amount exceeds INR 1 lakh, please collect copy of address proof of the primary beneficiary (Applicable to Individual Mediclaim policies) such as (a) Driving Licence (b) Passport (c) Voter ID card (d) Aadhar Card, etc.</li></ol></div></div></div><div class=\"panel panel-default\" ng-click=\"showPanel(2)\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a href=\"\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#collapseTwo\">Documents checklist</a></h4></div><div id=\"collapseTwo\" class=\"panel-collapse collapse\"><div class=\"panel-body points\"><ol><li>Duly filled and signed claim form by insured.</li><li>Copy of claim intimation, if any.</li><li>Original authorization request and cashless approval copy.</li><li>Photocopy of ID card / current year policy copy along with any other photo ID card. Eg: driving license, voter ID card, corporate employee ID, Pan Card, passport, etc.</li><li>Original discharge summary (format contents enclosed in the welcome guide book).</li><li>Medical advise for hospitalization or previous consultation documents.</li><li>Original hospital final bill (format contents enclosed in the welcome guide book).</li><li>Final bill breakups including room rent, ICU, OT charges, doctor fee, nursing charges, medicines & consumables, professional fees, investigations charges, ambulance, package charges, miscellaneous expenses (provider to specify the details of miscellaneous to avoid deductions),etc.</li><li>Copy of patient paid receipt.</li><li>Original pharmacy bills and receipts with corresponding prescriptions/investigations.</li><li>Doctor’s request for investigations.</li><li>All investigation reports (including X-ray/CT/MRI/USG/HPE).</li><li>Original receipts and bill / invoices for implants (IOL/mesh/stents etc.)</li><li>All medicines purchased from outside the hospital at any point of time to be supported by original prescription, bill and invoices.</li><li>Copy of FIR / MLC copy and treating doctor certificate in influence of alcohol / substance abuse. And, lab investigation reports conducted to establish this.</li><li>Original death summary from hospital where applicable.</li><li>Any other document, relevant to the treatment of the insured.</li></ol></div></div></div><div class=\"panel panel-default\" ng-click=\"showPanel(3)\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a href=\"\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#collapseThree\">Non-Admissible Expenses</a></h4></div><div id=\"collapseThree\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div><h4 style=\"text-align:center;\">ANNEXURE IV<br>List of expenses generally excluded (\' Non-admissible Expenses \') in Hospitalisation Policy<br>GUIDELINES ON STANDARDISATION IN HEALTH INSURANCE - IRDA CIRCULAR No IRDA/HLT/CIR/036/02/2013 DATED 20.02.2013</h4><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th><p>S. No.</p></th><th><p>Items</p></th><th><p>Suggestions</p></th></tr></thead><tr class=\"bg-warning\"><td colspan=\"3\" style=\"padding-left:50px;\"><p><strong>A. Toiletries/ Cosmetics/ Personal Comfort or Convenience Items</strong></p></td></tr><tr><td><p>1</p></td><td><p>Hair removing cream</p></td><td><p>Not payable</p></td></tr><tr><td><p>2</p></td><td><p>Baby charges (unless speciﬁed/indicated)</p></td><td><p>Not payable</p></td></tr><tr><td><p>3</p></td><td><p>Baby food</p></td><td><p>Not payable</p></td></tr><tr><td><p>4</p></td><td><p>Baby Utlites charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>5</p></td><td><p>Baby set</p></td><td><p>Not payable</p></td></tr><tr><td><p>6</p></td><td><p>Baby bottles</p></td><td><p>Not payable</p></td></tr><tr><td><p>7</p></td><td><p>Brush</p></td><td><p>Not payable</p></td></tr><tr><td><p>8</p></td><td><p>Cosy towel</p></td><td><p>Not payable</p></td></tr><tr><td><p>9</p></td><td><p>Hand wash</p></td><td><p>Not payable</p></td></tr><tr><td><p>10</p></td><td><p>Moisturiser paste brush</p></td><td><p>Not payable</p></td></tr><tr><td><p>11</p></td><td><p>Powder</p></td><td><p>Not payable</p></td></tr><tr><td><p>12</p></td><td><p>Razor</p></td><td bgcolor=\"#F8F8F8\"><p>Payable</p></td></tr><tr><td><p>13</p></td><td><p>Shoe cover</p></td><td><p>Not payable</p></td></tr><tr><td><p>14</p></td><td><p>Beauty services</p></td><td><p>Not payable</p></td></tr><tr><td><p>15</p></td><td><p>Belts/ Braces</p></td><td bgcolor=\"#DFDFDF\"><p>Essental and should be Paid at least speciﬁcally for cases who have undergone surgery of Thoracic or Lumbar Spine.</p></td></tr><tr><td><p>16</p></td><td><p>Buds</p></td><td><p>Not payable</p></td></tr><tr><td><p>17</p></td><td><p>Barber charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>18</p></td><td><p>Caps</p></td><td><p>Not payable</p></td></tr><tr><td><p>19</p></td><td><p>Cold pack/Hot pack</p></td><td><p>Not payable</p></td></tr><tr><td><p>20</p></td><td><p>Carry bags</p></td><td><p>Not payable</p></td></tr><tr><td><p>21</p></td><td><p>Cradle charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>22</p></td><td><p>Comb</p></td><td><p>Not payable</p></td></tr><tr><td><p>23</p></td><td><p>Disposable razor charges ( For site preparations)</p></td><td bgcolor=\"#DFDFDF\"><p>Payable</p></td></tr><tr><td><p>24</p></td><td><p>Eau-De-Cologne / Room freshners</p></td><td><p>Not payable</p></td></tr><tr><td><p>25</p></td><td><p>Eye pad</p></td><td><p>Not payable</p></td></tr><tr><td><p>26</p></td><td><p>Eye sheild</p></td><td><p>Not payable</p></td></tr><tr><td><p>27</p></td><td><p>Email / Internet charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>28</p></td><td><p>Food charges (other than Patient&#39;s Diet provided by hospital)</p></td><td><p>Not payable</p></td></tr><tr><td><p>29</p></td><td><p>Foot cover</p></td><td><p>Not payable</p></td></tr><tr><td><p>30</p></td><td><p>Gown</p></td><td><p>Not payable</p></td></tr><tr><td><p>31</p></td><td><p>Leggings</p></td><td bgcolor=\"#DFDFDF\"><p>Essential in Bariatric and Varicose Vein Surgery and may be considered for at least these conditions where surgery itself is payable.</p></td></tr><tr><td><p>32</p></td><td><p>Laundry charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>33</p></td><td><p>Mineral water</p></td><td><p>Not payable</p></td></tr><tr><td><p>34</p></td><td><p>Oil charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>35</p></td><td><p>Sanitary pad</p></td><td><p>Not payable</p></td></tr><tr><td><p>36</p></td><td><p>Slippers</p></td><td><p>Not payable</p></td></tr><tr><td><p>37</p></td><td><p>Telephone charges</p></td><td><p>Not Payable</p></td></tr><tr><td><p>38</p></td><td><p>Tissue paper</p></td><td><p>Not payable</p></td></tr><tr><td><p>39</p></td><td><p>Tooth paste</p></td><td><p>Not payable</p></td></tr><tr><td><p>40</p></td><td><p>Tooth brush</p></td><td><p>Not payable</p></td></tr><tr><td><p>41</p></td><td><p>Guest services</p></td><td><p>Not payable</p></td></tr><tr><td><p>42</p></td><td><p>Bed pan</p></td><td><p>Not payable</p></td></tr><tr><td><p>43</p></td><td><p>Bed under pad charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>44</p></td><td><p>Camera cover</p></td><td><p>Not payable</p></td></tr><tr><td><p>45</p></td><td><p>Cliniplast</p></td><td><p>Not payable</p></td></tr><tr><td><p>46</p></td><td><p>Crepe bandage</p></td><td><p>Not Payable/ Payable by the patient</p></td></tr><tr><td><p>47</p></td><td><p>Curapore</p></td><td><p>Not payable</p></td></tr><tr><td><p>48</p></td><td><p>Diaper Of any type</p></td><td><p>Not payable</p></td></tr><tr><td><p>49</p></td><td><p>DVD, CD charges</p></td><td><p>Not payable ( However if CD is speciﬁcally sought by Insurer/TPA then Payable)</p></td></tr><tr><td><p>50</p></td><td><p>Eyelet collar</p></td><td><p>Not payable</p></td></tr><tr><td><p>51</p></td><td><p>Face mask</p></td><td><p>Not payable</p></td></tr><tr><td><p>52</p></td><td><p>Flexi mask</p></td><td><p>Not payable</p></td></tr><tr><td><p>53</p></td><td><p>Gause soft</p></td><td><p>Not payable</p></td></tr><tr><td><p>54</p></td><td><p>Gauze</p></td><td><p>Not payable</p></td></tr><tr><td><p>55</p></td><td><p>Hand holder</p></td><td><p>Not payable</p></td></tr><tr><td><p>56</p></td><td><p>Hansaplast/ Adhesive bandages</p></td><td><p>Not payable</p></td></tr><tr><td><p>57</p></td><td><p>Infant food</p></td><td><p>Not payable</p></td></tr><tr><td><p>58</p></td><td><p>Slings</p></td><td bgcolor=\"#DFDFDF\"><p>Reasonable costs for one sling in case of upper arm fractures may be considered</p></td></tr><tr><td><p>B</p></td><td><p>Items specifically excluded in policies</p></td></tr><tr><td><p>59</p></td><td><p>Weight control programs/ Supplies/ Services</p></td><td><p>Exclusion in policy unless otherwise speciﬁed</p></td></tr><tr><td><p>60</p></td><td><p>Cost Of spectacles/ Contact lenses/ Hearing aids Etc.,</p></td><td><p>Exclusion in Policy unless otherwise speciﬁed</p></td></tr><tr><td><p>61</p></td><td><p>Dental Treatment Expenses that do not require hospitalisation</p></td><td><p>Exclusion in Policy unless otherwise speciﬁed</p></td></tr><tr><td><p>62</p></td><td><p>Hormone Replacement therapy</p></td><td><p>Exclusion in Policy unless otherwise speciﬁed</p></td></tr><tr><td><p>63</p></td><td><p>Home Visit Charges</p></td><td><p>Exclusion in Policy unless otherwise speciﬁed</p></td></tr><tr><td><p>64</p></td><td><p>Infertility/ Subfertility/ Assisted conception procedure</p></td><td><p>Exclusion in policy unless otherwise speciﬁed</p></td></tr><tr><td><p>65</p></td><td><p>Obesity (including Morbid Obesity) treatment if excluded in policy</p></td><td><p>Exclusion in policy unless otherwise speciﬁed</p></td></tr><tr><td><p>66</p></td><td><p>Psychiatric &amp; Psychosomatic disorders</p></td><td><p>Exclusion in Policy unless otherwise speciﬁed</p></td></tr><tr><td><p>67</p></td><td><p>Corrective surgery for refractive error</p></td><td><p>Exclusion in policy unless otherwise speciﬁed</p></td></tr><tr><td><p>68</p></td><td><p>Treatment of sexually transmitted diseases</p></td><td><p>Exclusion in policy unless otherwise speciﬁed</p></td></tr><tr><td><p>69</p></td><td><p>Donor screening charges</p></td><td><p>Exclusion in policy unless otherwise speciﬁed</p></td></tr><tr><td><p>70</p></td><td><p>Admission/Registration charges</p></td><td><p>Exclusion in policy unless otherwise speciﬁed</p></td></tr><tr><td><p>71</p></td><td><p>Hospitalisation for evaluation/ Diagnostic purpose</p></td><td><p>Exclusion in Policy unless otherwise specified</p></td></tr><tr><td><p>72</p></td><td><p>Expenses for investigation/ Treatment irrelevant to the disease for which admitted or diagnosed</p></td><td><p>Exclusion in Policy not payable unless otherwise specified</p></td></tr><tr><td><p>73</p></td><td><p>Any Expenses when the Patient is diagnosed with Retro Virus + or suffering from /HIV/ Aids etc is detected/ directly or indirectly</p></td><td><p>Not Payable as per HIV/ AIDS exclusion</p></td></tr><tr><td><p>74</p></td><td><p>Stem Cell implantation/ Surgery &amp; Storage</p></td><td><p>Not payable except Bone Marrow Transplantation where covered by Policy</p></td></tr><tr class=\"bg-warning\"><td colspan=\"3\" style=\"padding-left:50px;\"><p><strong>C. Items Which form Part of hospital services where Separate Consumables are not Payable but the Service is</strong></p></td></tr><tr><td><p>75</p></td><td><p>Ward and theatre booking charges</p></td><td><p>Payable under OT charges, Not payable separately</p></td></tr><tr><td><p>76</p></td><td><p>Arthroscopy &amp; Endoscopy instruments</p></td><td><p>Rental charged by the hospital payable. Purchase of instruments not payable.</p></td></tr><tr><td><p>77</p></td><td><p>Microscope cover</p></td><td><p>Payable Under OT charges, not payable separately</p></td></tr><tr><td><p>78</p></td><td><p>Surgical blades,Harmonic scalpel, Shaver</p></td><td><p>Payable under OT charges, Not payable separately</p></td></tr><tr><td><p>79</p></td><td><p>Surgical drill</p></td><td><p>Payable under OT charges, Not payable separately</p></td></tr><tr><td><p>80</p></td><td><p>Eye kit</p></td><td><p>Payable under OT charges, Not payable separately</p></td></tr><tr><td><p>81</p></td><td><p>Eye Drape</p></td><td><p>Payable under OT charges, Not payable separately</p></td></tr><tr><td><p>82</p></td><td><p>X-Ray Film</p></td><td><p>Payable Under Radiology Charges, Not as Consumable</p></td></tr><tr><td><p>83</p></td><td><p>Sputum cup</p></td><td><p>Payable under investigation charges, Not as consumable</p></td></tr><tr><td><p>84</p></td><td><p>Boyles apparatus charges</p></td><td><p>Part Of Ot charges, Not seperately</p></td></tr><tr><td><p>85</p></td><td><p>Blood grouping and cross matching of donors samples</p></td><td><p>Part of cost of blood, not payable</p></td></tr><tr><td><p>86</p></td><td><p>Antiseptic &amp; Disinfectant lotions</p></td><td><p>Not payable-part of dressing charges</p></td></tr><tr><td><p>87</p></td><td><p>Band aids, Bandages, Sterile injections, Needles, Syringes</p></td><td><p>Not payable - Part of dressing charges</p></td></tr><tr><td><p>88</p></td><td><p>Cotton</p></td><td><p>Not payable-part of dressing charges</p></td></tr><tr><td><p>89</p></td><td><p>Cotton bandage</p></td><td><p>Not payable-part of dressing charges</p></td></tr><tr><td><p>90</p></td><td><p>Micropore/ Surgical tape</p></td><td><p>Not Payable-payable by the patient when prescribed, otherwise included as dressing charges</p></td></tr><tr><td><p>91</p></td><td><p>Blade</p></td><td><p>Not payable</p></td></tr><tr><td><p>92</p></td><td><p>Apron</p></td><td><p>Not Payable -Part of hospital services/disposable linen to be part of OT/ ICU charges</p></td></tr><tr><td><p>93</p></td><td><p>Torniquet</p></td><td><p>Not Payable (service is charged by hospitals, consumables cannot be separately charged)</p></td></tr><tr><td><p>94</p></td><td><p>Orthobundle, Gynaec bundle</p></td><td><p>Part of dressing charges</p></td></tr><tr><td><p>95</p></td><td><p>Urine container</p></td><td><p>Not payable</p></td></tr><tr class=\"bg-warning\"><td colspan=\"3\" style=\"padding-left:50px;\"><p><strong>D. Elements of room charge</strong></p></td></tr><tr><td><p>96</p></td><td><p>Luxury tax</p></td><td><p>Policy exclusion - Not payable. <span class=\"s5\">If there is no policy exclusion, then actual tax levied by</span></p><p>government is payable - part of room charge for sub limits</p></td></tr><tr><td><p>97</p></td><td><p>HVAC</p></td><td><p>Part of room charge not payable separately</p></td></tr><tr><td><p>98</p></td><td><p>House keeping charges</p></td><td><p>Part of room charge not payable separately</p></td></tr><tr><td><p>99</p></td><td><p>Service charges where nursing charge also charged</p></td><td><p>Part of room charge not payable separately</p></td></tr><tr><td><p>100</p></td><td><p>Television &amp; Air conditioner charges</p></td><td><p>Payable under room charges not if separately levied</p></td></tr><tr><td><p>101</p></td><td><p>Surcharges</p></td><td><p>Part of room charge not payable separately</p></td></tr><tr><td><p>102</p></td><td><p>Attendant charges</p></td><td><p>Not payable - Part of room charges</p></td></tr><tr><td><p>103</p></td><td><p>IM/ IV injection charges</p></td><td><p>Part of nursing charges, Not payable</p></td></tr><tr><td><p>104</p></td><td><p>Clean sheet</p></td><td><p>Part of laundry/housekeeping not payable separately</p></td></tr><tr><td><p>105</p></td><td><p>Extra diet of patient(other than that which forms part of bed charge)</p></td><td><p>Not payable. Patient diet provided by hospital is payable</p></td></tr><tr><td><p>106</p></td><td><p>Blanket/Warmer blanket</p></td><td><p>Not payable- Part of room charges</p></td></tr><tr class=\"bg-warning\"><td colspan=\"3\" style=\"padding-left:50px;\"><p><strong>E. Administrative or non-medical charges</strong></p></td></tr><tr><td><p>107</p></td><td><p>Admission kit</p></td><td><p>Not payable</p></td></tr><tr><td><p>108</p></td><td><p>Birth certiﬁcate</p></td><td><p>Not payable</p></td></tr><tr><td><p>109</p></td><td><p>Blood reservation charges and ante natal booking charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>110</p></td><td><p>Certiﬁcate charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>111</p></td><td><p>Courier charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>112</p></td><td><p>Convenyance charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>113</p></td><td><p>Diabetic chart charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>114</p></td><td><p>Documentation charges / Administrative expenses</p></td><td><p>Not payable</p></td></tr><tr><td><p>115</p></td><td><p>Discharge procedure charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>116</p></td><td><p>Daily chart charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>117</p></td><td><p>Entrance pass / Visitors pass charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>118</p></td><td><p>Expenses related to prescription on discharge</p></td><td><p>To be claimed by patient under post -hospitalisation where admissible</p></td></tr><tr><td><p>119</p></td><td><p>File Opening charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>120</p></td><td><p>Incidental expenses / Misc. charges (not explained)</p></td><td><p>Not payable</p></td></tr><tr><td><p>121</p></td><td><p>Medical certiﬁcate</p></td><td><p>Not payable</p></td></tr><tr><td><p>122</p></td><td><p>Maintainance charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>123</p></td><td><p>Medical records</p></td><td><p>Not payable</p></td></tr><tr><td><p>124</p></td><td><p>Preparation charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>125</p></td><td><p>Photocopies charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>126</p></td><td><p>Patient identiﬁcation band / Name tag</p></td><td><p>Not payable</p></td></tr><tr><td><p>127</p></td><td><p>Washing charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>128</p></td><td><p>Medicine box</p></td><td><p>Not payable</p></td></tr><tr><td><p>129</p></td><td><p>Mortuary charges</p></td><td bgcolor=\"#DFDFDF\"><p>Payable upto 24 Hrs, Shifting charges not payable</p></td></tr><tr><td><p>130</p></td><td><p>Medico legal case charges (MLC charges)</p></td><td><p>Not payable</p></td></tr><tr class=\"bg-warning\"><td colspan=\"3\" style=\"padding-left:50px;\"><p><strong>F. External Durable Devices</strong></p></td></tr><tr><td><p>131</p></td><td><p>Walking aids charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>132</p></td><td><p>Bipap machine</p></td><td><p>Not payable</p></td></tr><tr><td><p>133</p></td><td><p>Commode</p></td><td><p>Not payable</p></td></tr><tr><td><p>134</p></td><td><p>CPAP/ CPAD equipments device</p></td><td><p>Not payable</p></td></tr><tr><td><p>135</p></td><td><p>Infusion pump - cost</p></td><td><p>Not payable</p></td></tr><tr><td><p>136</p></td><td><p>Oxygen cylinder (for usage outside the hospital)</p></td><td><p>Not payable</p></td></tr><tr><td><p>137</p></td><td><p>Pulseoxymeter charges device</p></td><td><p>Not payable</p></td></tr><tr><td><p>138</p></td><td><p>Spacer</p></td><td><p>Not payable</p></td></tr><tr><td><p>139</p></td><td><p>Spirometre</p></td><td><p>Not payable</p></td></tr><tr><td><p>140</p></td><td><p>SPO2 probe</p></td><td><p>Not payable</p></td></tr><tr><td><p>141</p></td><td><p>Nebulizer kit</p></td><td><p>Not payable</p></td></tr><tr><td><p>142</p></td><td><p>Steam inhaler</p></td><td><p>Not payable</p></td></tr><tr><td><p>143</p></td><td><p>Armsling</p></td><td><p>Not payable</p></td></tr><tr><td><p>144</p></td><td><p>Thermometer</p></td><td><p>Not payable (paid by patient)</p></td></tr><tr><td><p>145</p></td><td><p>Cervical collar</p></td><td><p>Not payable</p></td></tr><tr><td><p>146</p></td><td><p>Splint</p></td><td><p>Not payable</p></td></tr><tr><td><p>147</p></td><td><p>Diabetic foot wear</p></td><td><p>Not payable</p></td></tr><tr><td><p>148</p></td><td><p>Knee braces ( Long/ Short/ Hinged)</p></td><td><p>Not payable</p></td></tr><tr><td><p>149</p></td><td><p>Knee immobilizer/Shoulder immobilizer</p></td><td><p>Not payable</p></td></tr><tr><td><p>150</p></td><td><p>Lumbo sacral belt</p></td><td><p>Essential and should be paid at least speciﬁcally for cases who have undergone surgery of Lumbar Spine</p></td></tr><tr><td><p>151</p></td><td><p>Nimbus bed or water or air bed charges</p></td><td><p>Payable for any ICU patient requiring more than 3 Days in ICU; All patients with Paraplegia/ Quadriplegia for any reason and at reasonable cost of approximately Rs 200/Day</p></td></tr><tr><td><p>152</p></td><td><p>Ambulance collar</p></td><td><p>Not payable</p></td></tr><tr><td><p>153</p></td><td><p>Ambulance equipment</p></td><td><p>Not payable</p></td></tr><tr><td><p>154</p></td><td><p>Microsheild</p></td><td><p>Not payable</p></td></tr><tr><td><p>155</p></td><td><p>Abdominal binder</p></td><td><p>Essential and should be Paid at least in post surgery patients of major abdominal surgery including TAH, LSCS, Incisional Hernia Repair, Exploratory Laparotomy for Intestinal Obstruction, Liver Transplant Etc.</p></td></tr><tr class=\"bg-warning\"><td colspan=\"3\" style=\"padding-left:50px;\"><p><strong>G. Items payable if supported by a prescription</strong></p></td></tr><tr><td><p>156</p></td><td><p>Betadine \\ Hydrogen Peroxide\\spirit\\ Disinfectants Etc</p></td><td><p>May be payable when prescribed for patient, Not payable for hospital use in OT or Ward or</p><p>for dressings ward or for dressings</p></td></tr><tr><td><p>157</p></td><td><p>Private nurses charges- Special nursing charges</p></td><td><p>Post Hospitalization Nursing charges not payable</p></td></tr><tr><td><p>158</p></td><td><p>Nutrition planning charges - Dietician charges- Diet charges</p></td><td><p>Patient diet provided by hospital is payable</p></td></tr><tr><td><p>159</p></td><td><p>Sugar Free Tablets</p></td><td bgcolor=\"#DFDFDF\"><p>Payable -sugar Free variants of admissable medicines are not excluded</p></td></tr><tr><td><p>160</p></td><td><p>Cream powder lotion (Toileteries are Not payable, only prescribed medical pharmaceuticals payable)</p></td><td><p>Payable when prescribed</p></td></tr><tr><td><p>161</p></td><td><p>Digene gel</p></td><td><p>Payable when prescribed</p></td></tr><tr><td><p>162</p></td><td><p>ECG electrodes</p></td><td><p>Upto 5 electrodes are required for every case visiting OT or ICU. For longer stay in ICU, may require a change and at least one set every second day must be payable.</p></td></tr><tr><td><p>163</p></td><td><p>Gloves</p></td><td><p>Sterilized gloves payable / Unsterilized gloves not payable</p></td></tr><tr><td><p>164</p></td><td><p>HIV kit</p></td><td><p>Payable - Pre-operative screening</p></td></tr><tr><td><p>165</p></td><td><p>Listerine/ Antiseptic mouthwash</p></td><td><p>Payable when prescribed</p></td></tr><tr><td><p>166</p></td><td><p>Lozenges</p></td><td><p>Payable when prescribed</p></td></tr><tr><td><p>167</p></td><td><p>Mouth paint</p></td><td><p>Payable when prescribed</p></td></tr><tr><td><p>168</p></td><td><p>Nebulisation</p></td><td><p>If used during hospitalization is payable reasonably</p></td></tr><tr><td><p>169</p></td><td><p>Novarapid</p></td><td><p>Payable when prescribed</p></td></tr><tr><td><p>170</p></td><td><p>Volini gel/ Analgesic gel</p></td><td><p>Payable when prescribed</p></td></tr><tr><td><p>171</p></td><td><p>Zytee gel</p></td><td><p>Payable when prescribed</p></td></tr><tr><td><p>172</p></td><td><p>Vaccination Charges</p></td><td><p>Routine vaccination not payable / Post bite vaccination payable</p></td></tr><tr><td><p>H</p></td><td><p>Part of hospital&#39;s own costs and not payable</p></td></tr><tr><td><p>173</p></td><td><p>AHD</p></td><td><p>Not Payable - Part of hospital&#39;s Internal cost</p></td></tr><tr><td><p>174</p></td><td><p>Alcohol swabes</p></td><td><p>Not payable - Part of hospital&#39;s Internal cost</p></td></tr><tr><td><p>175</p></td><td><p>Scrub solution/ Sterillium</p></td><td><p>Not payable - Part of hospital&#39;s Internal cost</p></td></tr><tr class=\"bg-warning\"><td colspan=\"3\" style=\"padding-left:50px;\"><p><strong>I. OTHERS</strong></p></td></tr><tr><td><p>176</p></td><td><p>Vaccine charges for baby</p></td><td><p>Not payable</p></td></tr><tr><td><p>177</p></td><td><p>Aesthetic treatment / Surgery</p></td><td><p>Not payable</p></td></tr><tr><td><p>178</p></td><td><p>TPA charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>179</p></td><td><p>Visco belt charges</p></td><td><p>Not payable</p></td></tr><tr><td><p>180</p></td><td><p>Any kit with no details mentioned [Delivery kit, Orthokit, Recovery kit, Etc]</p></td><td><p>Not payable</p></td></tr><tr><td><p>181</p></td><td><p>Examination gloves</p></td><td><p>Not payable</p></td></tr><tr><td><p>182</p></td><td><p>Kidney tray</p></td><td><p>Not payable</p></td></tr><tr><td><p>183</p></td><td><p>Mask</p></td><td><p>Not payable</p></td></tr><tr><td><p>184</p></td><td><p>Ounce glass</p></td><td><p>Not payable</p></td></tr><tr><td><p>185</p></td><td><p>Outstation consultant&#39;s/ Surgeon&#39;s fees</p></td><td><p>Not payable, except for telemedicine consultations where covered by policy</p></td></tr><tr><td><p>186</p></td><td><p>Oxygen mask</p></td><td><p>Not payable</p></td></tr><tr><td><p>187</p></td><td><p>Paper gloves</p></td><td><p>Not payable</p></td></tr><tr><td><p>188</p></td><td><p>Pelvic traction belt</p></td><td><p>Should be payable in case of PIVD requiring traction as this is generally not reused</p></td></tr><tr><td><p>189</p></td><td><p>Referal doctor&#39;s fees</p></td><td><p>Not payable</p></td></tr><tr><td><p>190</p></td><td><p>Accu check ( Glucometery/ Strips)</p></td><td><p>Not payable. Pre-hospitilasation or Post-hospitalisation / Reports and charts required/ Device not payable</p></td></tr><tr><td><p>191</p></td><td><p>Pan can</p></td><td><p>Not payable</p></td></tr><tr><td><p>192</p></td><td><p>Sofnet</p></td><td><p>Not payable</p></td></tr><tr><td><p>193</p></td><td><p>Trolly cover</p></td><td><p>Not payable</p></td></tr><tr><td><p>194</p></td><td><p>Urometer, Urine Jug</p></td><td><p>Not Payable</p></td></tr><tr><td><p>195</p></td><td><p>Ambulance</p></td><td><p>Payable - Ambulance from home to hospital or inter-hospital shifts is payable/ RTA - As speciﬁc requirement for critical injury is payable)</p></td></tr><tr><td><p>196</p></td><td><p>Tegaderm / Vasoﬁx safety</p></td><td><p>Payable - Maximum of 3 in 48 Hrs and then 1 in 24 Hrs</p></td></tr><tr><td><p>197</p></td><td><p>Urine bag</p></td><td><p>Payable where medicaly necessary till a reasonable cost - maximum 1 Per 24 Hrs</p></td></tr><tr><td><p>198</p></td><td><p>Softovac</p></td><td><p>Not payable</p></td></tr><tr><td><p>199</p></td><td><p>Stockings</p></td><td><p>Essential for case like CABG etc. where it should be paid.</p></td></tr></table></div></div></div></div><div class=\"panel panel-default\" ng-click=\"showPanel(4)\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a href=\"\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#collapseFou\">Standard discharge summary and bill format</a></h4></div><div id=\"collapseFour\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><a href=\"app/resources/images/discharge-summary.jpg\" target=\"_blank\"><img class=\"text-center\" style=\"width:100%;\" src=\"app/resources/images/discharge-summary.jpg\" alt=\"\"></a> <a href=\"app/resources/images/discharge-summary1.jpg\" target=\"_blank\"><img class=\"text-center\" style=\"width:100%;\" src=\"app/resources/images/discharge-summary1.jpg\" alt=\"\"></a> <a href=\"app/resources/images/bill-format.jpg\" target=\"_blank\"><img class=\"text-center\" style=\"width:100%;\" src=\"app/resources/images/bill-format.jpg\" alt=\"\"></a> <a href=\"app/resources/images/bill-format1.jpg\" target=\"_blank\"><img class=\"text-center\" style=\"width:100%;\" src=\"app/resources/images/bill-format1.jpg\" alt=\"\"></a></div></div></div><div class=\"panel panel-default\" ng-click=\"showPanel(5)\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a href=\"\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#collapseFou\">Best practices</a></h4></div><div id=\"collapseFive\" class=\"panel-collapse collapse\"><div class=\"panel-body points\"><ol><li>In emergency cases, cashless request should be forwarded to respective TPA within 24 hours after hospitalization.</li><li>In planned cases, cashless request should be forwarded to respective TPA, at least 48 hours prior to hospitalization in the prescribed format. Obtain approval, 24 hours prior to admission.</li><li>Claim documents should reach TPA within 7 working days from the date of the discharge.</li><li>Always collect photocopy of ID card along with photo ID proof. Check the member identification before extended cashless treatment.</li><li>Collect duly filled and signed claim from the insured and submit along with claim from.</li><li>Send all original documents to TPA for processing.</li><li>Specify the discount details in the final bill to avoid excess deductions at the time claim process.</li><li>Along with claim documents, original pre-authorization request, cashless approval copy should be enclosed.</li><li>Retain photocopies of claim documents, which ever has been sent to TPA.</li><li>Discharge summary should have present complaints, diagnosis, past history, investigation done, treatment during hospitalization, OT notes, discharge advice, indications for.</li><li>Pre-authorization from is to be signed by the treating doctor / consultant only.</li><li>Ensure that, pre-authorization is obtained by the hospital within 24 hours from admission.</li><li>Inform insured on receipt of approval / query / rejection from respective TPA.</li><li>In case of any query, revert within 2 hours and contact respective TPA.</li><li>Inform concerned TPA, in case of any enhancement required at least 24 hours prior to discharge.</li><li>Extend cashless facility for approved ailment as specified In the cashless approval.</li><li>Collect the expenses related to non-payable items / over and above approval amount / ailment expenses which ever not payable under policy coverage from the insured directly prior to the discharge.</li><li>For early settlement, please submit NEFT declarations to Medi Assist.</li></ol></div></div></div><div class=\"panel panel-default\" ng-click=\"showPanel(6)\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a href=\"\" data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#collapseFou\">What should be avoided</a></h4></div><div id=\"collapseSix\" class=\"panel-collapse collapse\"><div class=\"panel-body points\"><ol><li>Don’t insist upon admission for investigation or evaluations or health check-ups.</li><li>Don’t give any original bills / documents to the insured for cashless admissions.</li><li>Don’t forget to take insured signature on pre-auth request, cashless approval, final bill and discharge summary.</li><li>Cashless services can be denied, in case of insufficient information / vague symptoms / where medical team of TPA is not sure of eligibility under policy coverage, don’t insist for cashless approvals in such scenarios.</li><li>Don’t send photocopies of the document for claim processing.</li><li>Don’t send the bills without proper prescriptions and investigation reports.</li><li>Don’t hide any relevant information related to the past history duration and treatment line of the insured.</li><li>Don’t extend cashless for unapproved ailments / non-payable items.</li><li>Don’t demand any advance deposit from the insured.</li><li>Don’t suggest instant admissions for planned cases.</li><li>Don’t insist for the authorization letter for emergency cases at the time of admission.</li></ol></div></div></div></div>");
$templateCache.put("app/modules/hospSelect/hospselect.html","<style>\n  .bg-danger{\n    padding: 10px;\n    text-align: center;\n  }\n  #hospSearchBox{\n      margin-bottom: 10px; \n      width: 99%;\n      display: inline;            \n  }\n  .header form .glyphicon-search{\n      position: relative;\n      top: 2px;\n      right: 0px;\n      margin-left: -30px;\n  }\n  .address{\n      font-style: italic;\n      display: block;\n      font-size: 11px;\n  }\n  #hospitalList li.btn-info{\n      display: block;\n      text-align: left;\n      border:0px; \n      color: #000;\n      background: #fff;\n      border-color: #269abc;\n  }\n  #hospitalList li.btn-info:hover{\n    color: #fff;\n    background: #269abc;\n    border-color: #fff;\n  }\n  #hospitalList{\n      height: 400px;\n      overflow: auto;\n  }\n  .hospital-list-item{\n      /*list-style-type: none;*/\n      margin: 5px 0px 0px -35px;\n      width: 480px;\n      white-space: pre-wrap;\n      /*cursor: pointer;*/\n  } \n</style><div class=\"row dashboard\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#collapseOne\" href=\"\">Hospital Selection</a></h4></div><div id=\"collapseOne\" class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div class=\"modal-body\" id=\"chooseHospitalBody\"><typeahead items=\"hospitalList\" prompt=\"Start typing hospital name ...\" title=\"entityName\" subtitle=\"address\" subtitle2=\"city\" item-id=\"cmsHospitalID\" ng-model=\"hospNewName\" module-flag=\"addHosp\"></typeahead></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#collapseTwo\" href=\"\">Enter User Details</a></h4></div><div id=\"collapseTwo\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><h4>Selected Hospital: {{hospitalName}}</h4><h4>Selected Hospital Id: {{hospitalId}}</h4><br><h3>User and Additional Hospital Details</h3><hr><form action=\"\" role=\"form\" name=\"hospitalForm\"><div class=\"form-group\"><label for=\"hospemail\">Hospital Primary Emailid (All future correspondence will happen through this emailid)</label> <input type=\"text\" id=\"hospemail\" name=\"hospemail\" class=\"form-control\" placeholder=\"Eg: name@domain.com\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" ng-model=\"user.hospemail\"> <span ng-show=\"hospitalForm.hospemail.$error.pattern && hospitalForm.hospemail.$dirty\" style=\"color: #f00\">email address not seems to be valid.</span></div><hr><div class=\"form-group\"><label for=\"firstname\">Salutation</label><select class=\"form-control\"><option value=\"Dr\">Dr.</option><option value=\"Mr\">Mr.</option><option value=\"Mrs\">Mrs.</option><option value=\"Miss\">Ms.</option></select></div><div class=\"form-group\"><label for=\"firstname\">First Name</label> <input type=\"text\" id=\"firstname\" class=\"form-control\" placeholder=\"Eg: Abhishek\" ng-model=\"user.firstname\"></div><div class=\"form-group\"><label for=\"lastname\">Last Name</label> <input type=\"text\" id=\"lastname\" class=\"form-control\" placeholder=\"Eg: Saini\" ng-model=\"user.lastname\"></div><div class=\"form-group\"><label for=\"emailid\">Email id (Login credentials will be sent to this mail)</label> <input type=\"text\" name=\"emailid\" id=\"emailid\" class=\"form-control\" placeholder=\"Eg: name@domain.com\" ng-model=\"user.email\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\"> <span ng-show=\"hospitalForm.emailid.$error.pattern && hospitalForm.emailid.$dirty\" style=\"color: #f00\">email address not seems to be valid.</span></div><div class=\"form-group\"><label for=\"telephone\">Telephone</label> <input type=\"text\" id=\"telephone\" class=\"form-control\" placeholder=\"Eg: 080 - 32145634\" ng-model=\"user.telephone\"></div><hr><h4>Insurance coordinator details</h4><div class=\"form-group\"><label for=\"icname\">Name</label> <input type=\"text\" id=\"icname\" class=\"form-control\" placeholder=\"Eg: Vinod\" ng-model=\"user.icname\"></div><div class=\"form-group\"><label for=\"icemailid\">Email</label> <input type=\"text\" id=\"icemailid\" class=\"form-control\" placeholder=\"Eg: name@domain.com\" ng-model=\"user.icemailid\"></div><div class=\"form-group\"><label for=\"icphone\">Phone</label> <input type=\"text\" id=\"icphone\" class=\"form-control\" placeholder=\"Eg: 80505686925 or 080-23332121\" ng-model=\"user.icphone\"></div><hr><h4>Finance coordinator details</h4><div class=\"form-group\"><label for=\"fcname\">Name</label> <input type=\"text\" id=\"fcname\" class=\"form-control\" placeholder=\"Eg: Sharma\" ng-model=\"user.fcname\"></div><div class=\"form-group\"><label for=\"fcemailid\">Email</label> <input type=\"text\" id=\"fcemailid\" class=\"form-control\" placeholder=\"Eg: name@domain.com\" ng-model=\"user.fcemailid\"></div><div class=\"form-group\"><label for=\"fcphone\">Phone</label> <input type=\"text\" id=\"fcphone\" class=\"form-control\" placeholder=\"Eg: 80505686925 or 080-23332121\" ng-model=\"user.fcphone\"></div></form><a type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"captureUserInfo()\">Submit</a></div><div class=\"col-md-2\"></div></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a data-toggle=\"collapse\" data-parent=\"#accordion\" data-target=\"#collapseThree\" href=\"\">Confirm and Submit</a></h4></div><div id=\"collapseThree\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><div class=\"bg-danger\" id=\"addUserErrorMessage\" style=\"display:none;\"></div><h3>Confirm user and hospital details</h3><hr><div class=\"form-group\"><label for=\"\">Generated user name: {{user.username}}</label><br><label for=\"\">Hospital primary email id: {{user.hospemail}}</label><hr><label for=\"\">First name: {{user.firstname}}</label><br><label for=\"\">Last name: {{user.lastname}}</label><br><label for=\"\">Primary email id: {{user.email}}</label><br><label for=\"\">Primary telephone: {{user.telephone}}</label><br><hr><h4>Insurance coordinator details</h4><label for=\"\">Name: {{user.icname}}</label><br><label for=\"\">Email id: {{user.icemailid}}</label><br><label for=\"\">Telephone: {{user.icphone}}</label><br><hr><h4>Finance coordinator details</h4><label for=\"\">Name: {{user.fcname}}</label><br><label for=\"\">Email id: {{user.fcemailid}}</label><br><label for=\"\">Telephone: {{user.fcphone}}</label><br></div><a href=\"\" class=\"btn btn-primary pull-right\" ng-click=\"addNewUser()\">Submit</a></div><div class=\"col-md-2\"></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/hospitalPackage/package.html","<div style=\"height:100px\"></div><div class=\"tab-pane\" style=\"margin-top: -115px;\" ng-if=\"hospitalPackages.length >0\"><angular-tab appointmentlist=\"hospitalPackages\" tabname=\"\'Hospital Packages\'\" tabtype=\"\'hospitalPackage\'\" callback-fn=\"ctrlFn(arg)\" callback-second-fn=\"ctrlFn2(arg, flag)\"></angular-tab></div><div class=\"tab-pane\" style=\"margin-top: 30px;color: red;font-size: medium;padding-left: 25px;\" ng-if=\"isCall ===false && hospitalPackages.length ===0\"><p>No data found!</p><div class=\"tab-pane\" style=\"margin-top: 30px;color: red;font-size: medium;padding-left: 25px;\" ng-if=\"isCall === true\"><p>fetching packages data...</p></div></div>");
$templateCache.put("app/modules/hospitalProfile/hospital-profile.html","<style>\n    .note {\n        padding: 10px;\n        border-radius: 6px;\n        color: #000;\n    }\n</style><div><div ng-if=\"!editContact\"><div class=\"row hospHdr\" id=\"hospHeader\"><div class=\"col-xs-4 ltBx\"><h2>{{hospitalName | uppercase}}</h2><p>{{hospitalAddress}}<span ng-if=\"hospitalLandmark\">, {{hospitalLandmark}}</span><span ng-if=\"hospitalCity\">, {{hospitalCity}}</span><span ng-if=\"hospitalDistrict\">, {{hospitalDistrict}}</span><span ng-if=\"hospitalState\">, {{hospitalState}}</span><span ng-if=\"hospitalPin\">- {{hospitalPin}}</span></p><hr style=\"margin-bottom:8px\"><p ng-if=\"accre.accrediationName\"><span ng-repeat=\"accre in hospDispAccrediations\"><span ng-if=\"!$first && hospAccrediations.length > 1 && accre.isAccrediationAvailable\">,</span><span ng-if=\"accre.isAccrediationAvailable\">{{accre.accrediationName}}</span></span></p><hr><div class=\"address text-left\"><p ng-if=\"hospitalEmail\"><i class=\"fa fa-envelope fa-1x\"></i> {{hospitalEmail}}</p><p ng-if=\"hospitalSTDCode\"><i class=\"fa fa-phone fa-1x\"></i> {{hospitalSTDCode}} - {{hospitalLandLine}}</p><p ng-if=\"hospitalFaxNumber\"><i class=\"fa fa-fax fa-1x\"></i> {{hospitalFaxNumber}}</p><p ng-if=\"hospitalMobile\"><i class=\"fa fa-mobile fa-1x\" style=\"font-size:16px;\"></i> {{hospitalMobile}}</p><p ng-if=\"hospitalWebsite\"><i class=\"fa fa-globe fa-1x\"></i> <a ng-href=\"{{\'http://\' + hospitalWebsite}}\" target=\"_blank\">{{hospitalWebsite}}</a></p></div><div class=\"pull-right\"><a href=\"http://demo.medibuddy.in/hospitalsearchnew.aspx?HospEntityid={{viewCorporate}}\" target=\"_blank\" uib-tooltip=\"Profile preview\" tooltip-placement=\"left\" style=\"margin-right: 115px; color: #101010;background-color: #dddddd;border-color: #dddddd;\" class=\"editBtn btn btn-sm bnt-primary\" ng-click=\"corporateView()\"><i class=\"fa fa-eye\"></i></a> <a href=\"\" class=\"editBtn btn btn-sm btn-primary\" style=\"color: #101010;background-color: #dddddd;border-color: #dddddd;\" uib-tooltip=\"Edit address\" tooltip-placement=\"left\" data-toggle=\"modal\" ng-click=\"addressMethods.editHospitalContact()\"><i class=\"fa fa-edit\"></i></a></div><img ng-if=\"hospLogo\" ng-src=\"{{hospLogo}}\" class=\"imgProperties pull-left\" alt=\"logo\"></div><div class=\"col-xs-8 p-l-0 p-r-0 mapBx\"><a href=\"\" class=\"editBtn btn btn-sm btn-primary\" style=\"color: #101010;background-color: #4583c6;border-color: #4583c6;\" uib-tooltip=\"Edit location on the map\" tooltip-placement=\"left\" data-toggle=\"modal\" data-target=\"#hospitalMap\" ng-click=\"mapMethods.getEditMap()\"><i class=\"fa fa-edit\"></i></a><div id=\"map-canvas\" resize-element=\"\" height-offset=\"0\" width-offset=\"0\" selector=\"\'.hospHdr\'\"></div></div></div><div class=\"row hospSubHdr\"><a ng-click=\"addressMethods.editHospitalContact()\"><strong>{{hospProfile.hospDetails.rohiniID}}</strong> Rohini Id</a><span>-</span> <a><strong>{{hospProfile.hospDetails.hospRegtFee}}</strong> Registration fees</a> <span>-</span> <a><strong>{{hospProfile.hospDetails.wavedoffDays}}</strong> waived off Days</a><span>-</span> <a href=\"#/doctors\" ng-click=\"profileMethods.scrollTo(\'specialist\')\"><strong>{{hospProfile.hospDoctorDetails.length}}</strong> Doctors</a> <span>-</span> <a href=\"#/rooms\" ng-click=\"profileMethods.scrollTo(\'rooms\')\"><strong>{{hospProfile.hospRoomDetails.length}}</strong> Room types</a> <span>-</span> <a href=\"#/opPackages\" ng-click=\"profileMethods.scrollTo(\'packages\')\"><strong>{{hospProfile.hospPackages.length}}</strong> Health packages</a> <span>-</span> <a href=\"\" ng-click=\"profileMethods.scrollTo(\'facilities\')\"><strong>{{AllFacCount}}</strong> Facilities</a></div><div class=\"dashboard\"><h4 uib-tooltip=\"Here you can describe your hospital.\" tooltip-placement=\"top\" style=\"border-bottom:2px #606b70 solid;\">About<span><button ng-if=\"!isAbout.edit\" style=\"margin-bottom: 5px;font-size: 13px;margin-left: 10px;\" class=\"btn btn-primary\" type=\"button\" ng-click=\"editAbout(\'Edit\')\"><i class=\"fa fa-pencil\"></i></button> <button ng-if=\"isAbout.edit\" style=\"margin-bottom: 5px;font-size: 13px;margin-left: 10px;\" class=\"btn btn-xs btn-success\" type=\"button\" ng-disabled=\"!abc.hospDesc\" ng-click=\"editAbout(\'close\'); addressMethods.updateHospitalDescription()\"><i class=\"fa fa-check\"></i></button> <button ng-if=\"isAbout.edit\" style=\"margin-bottom: 5px;font-size: 13px;margin-left: 10px;\" class=\"btn btn-xs btn-danger\" type=\"button\" ng-click=\"editAbout(\'close\');\"><i class=\"fa fa-close\"></i></button></span></h4><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><div class=\"input-group\"><p ng-if=\"!isAbout.edit\">{{abc.hospDesc}}</p><textarea id=\"aboutTypeText\" style=\"margin: 0px;width: 1079px;height: 53px;z-index: 2;position: relative;line-height: 20px;font-size: 14px;transition-duration: initial;transition-timing-function: initial;transition-property: none;background: transparent !important;\" name=\"aboutType\" rows=\"3\" class=\"form-control\" ng-if=\"isAbout.edit\" ng-model=\"abc.hospDesc\"></textarea></div></div></div></div><h4 uib-tooltip=\"Add images of your medical facility to help members choose your services. For best experience please upload images of 650px width and 350px height.\" tooltip-placement=\"top\" style=\"border-bottom: 2px #606b70 solid;\">Images<button class=\"btn btn-default\" style=\"border-color: #fefefe;margin-bottom: 5px;\"><ul class=\"tagsList\" style=\"font-size: 13px;\"><li class=\"closeBtn add\" data-toggle=\"modal\" data-target=\"#hospitalImages\">Add Images <a href=\"\"><i class=\"fa fa-plus\"></i></a></li></ul></button></h4><ng-gallery images=\"imgs\" thumbs-num=\"20\"></ng-gallery><div class=\"facility clearfix\" id=\"facilities\"><h4 uib-tooltip=\"Choose and add facilities available at your hospital/medical centre.\" style=\"border-bottom: 2px #606b70 solid;\">Facilities<button class=\"btn btn-default\" style=\"border-color: #fefefe;margin-bottom: 5px;\"><ul class=\"tagsList\" style=\"font-size: 13px;\"><li class=\"closeBtn add\" data-toggle=\"modal\" data-target=\"#openHospFacilities\" ng-click=\"facilitiesMethods.openModalHospFacity()\">Add facility <a href=\"\"><i class=\"fa fa-plus\"></i></a></li></ul></button></h4><ul class=\"tagsList\" style=\"font-size: 13px;\"><li class=\"closeBtn\" ng-repeat=\"fac in facilities track by $index\" ng-if=\"fac.isFacilityAvailable\">{{fac.facilityName}} <a href=\"\" ng-click=\"facilitiesMethods.removeFacFromDisplay($index)\"><i class=\"fa fa-close\"></i></a></li><li class=\"closeBtn\" ng-repeat=\"oFac in otherFacilities track by $index\">{{oFac}} <a href=\"\" ng-click=\"facilitiesMethods.removeOtherFacFromDisplay($index)\"><i class=\"fa fa-close\"></i></a></li></ul></div><div class=\"contact row\"><div class=\"col-xs-12\"><h4 uib-tooltip=\"Members at your organization who would receive department-specific announcements/alerts from Medi Assist. Operational SPOCs would receive requests for booking health checks, doctor consults, and more.\" style=\"border-bottom: 2px #606b70 solid;margin-bottom: 5px;color: #333333;\">Team contact<button class=\"btn btn-default\" style=\"border-color: #fefefe;\"><ul class=\"tagsList\" style=\"font-size: 13px;\"><li class=\"closeBtn add\" data-toggle=\"modal\" data-target=\"#hospitalContact\" ng-click=\"addContactPerson()\">Add Contact <a href=\"\"><i class=\"fa fa-plus\"></i></a></li></ul></button></h4></div><div class=\"col-sm-3 p-r-0 text-center\" ng-repeat=\"item in hospProfile.hospContactDetails\"><div class=\"bx\" ng-if=\"mgmtContact\"><span class=\"label\" style=\"width: 120px;\">{{item.hospitalContactDetailContactPersonDepartment}}</span><h4 style=\"margin-top: 1px;\">{{item.hospitalContactDetailContactPersonName}} <span>{{item.hospitalContactDetailContactPersonDesignation}}</span></h4><p>{{item.hospitalContactDetailContactPersonEmail}}<br>{{item.hospitalContactDetailContactPersonMobileNo}}</p><p ng-if=\"!item.isDelete\"><a href=\"\" class=\"btn btn-xs\" style=\"color: #101010;background-color: #dddddd;border-color: #dddddd;\" uib-tooltip=\"Edit\" data-toggle=\"modal\" ng-click=\"isAdd = false; editContactPerson(item)\" data-target=\"#hospitalContact\"><i class=\"fa fa-edit\"></i></a> <a href=\"\" class=\"btn btn-xs\" style=\"color: #101010;background-color: #dddddd;border-color: #dddddd;\" uib-tooltip=\"Delete\" data-toggle=\"modal\" ng-click=\"isAdd = false; deleteContactPerson(item)\" data-target=\"#deleteContact\"><i class=\"fa fa-trash\"></i></a> <span class=\"label pull-right\" ng-if=\"item.isDelete\">Pending deletion</span></p><p class=\"deletion\" ng-if=\"item.isDelete\">Pending deletion</p></div></div></div></div></div><div ng-if=\"editContact\"><h3 class=\"m-t-0\">Edit Contact Details</h3><form name=\"frmRooms\"><div class=\"form form-horizontal\"><div class=\"form-group\"><label for=\"hospName\" class=\"col-sm-3\">Name</label><div class=\"col-sm-9\"><input type=\"text\" name=\"name\" ng-maxlength=\"100\" placeholder=\"Enter hospital name\" id=\"\" class=\"form-control\" ng-model=\"addEditHospContact.hospitalName\"> <span ng-if=\"frmRooms.name.$error.maxlength\" style=\"color: #f00\">name not seems to be valid.</span></div></div><div class=\"form-group\"><label for=\"hospAddress\" class=\"col-sm-3\">Address</label><div class=\"col-sm-9\"><input type=\"text\" ng-maxlength=\"200\" placeholder=\"Enter address\" name=\"address\" id=\"hospAddress\" class=\"form-control\" ng-model=\"addEditHospContact.hospitalAddress\"> <span ng-if=\"frmRooms.address.$error.maxlength\" style=\"color: #f00\">address not seems to be valid.</span></div></div><div class=\"form-group\"><label for=\"hospLandmark\" class=\"col-sm-3\">Landmark</label><div class=\"col-sm-9\"><input type=\"text\" ng-maxlength=\"100\" name=\"landmark\" placeholder=\"Enter landmark\" id=\"hospLandmark\" class=\"form-control\" ng-model=\"addEditHospContact.hospitalLandmark\"> <span ng-if=\"frmRooms.landmark.$error.maxlength\" style=\"color: #f00\">landmark not seems to be valid.</span></div></div><div class=\"form-group\"><label for=\"hospPincode\" class=\"col-sm-3\">Pincode</label><div class=\"col-sm-9\"><div class=\"input-group\"><input type=\"number\" maxlength=\"6\" name=\"pinCode\" id=\"hospPincode\" class=\"form-control\" ng-model=\"addEditHospContact.hospitalPin\" placeholder=\"Enter pincode\"> <span class=\"input-group-addon\">City: {{addEditHospContact.hospitalCity}} | District: {{addEditHospContact.hospitalDistrict}} | State: {{addEditHospContact.hospitalState}}</span></div><span ng-if=\"frmRooms.pinCode.$error.maxlength\" style=\"color: #f00\">Pincode not seems to be valid.</span></div></div><div class=\"form-group\"><label for=\"accrediations\" class=\"col-sm-3\">Accreditations</label><div class=\"col-sm-9 checkbox custom\"><label id=\"accrediations\" class=\"checkbox-inline\" ng-repeat=\"accre in hospAccrediations\"><input name=\"accre.accrediationName\" type=\"checkbox\" ng-model=\"accre.isAccrediationAvailable\" data-id=\"{{accre.accrediationID}}\"> <i ng-class=\"accre.isAccrediationAvailable ? \'fa fa-check-square-o\' : \'fa fa-square-o\'\"></i> {{accre.accrediationName}}</label></div></div><div ng-repeat=\"accre in hospAccrediations\" class=\"form-group\"><div ng-if=\"accre.accrediationID === 10434 && accre.isAccrediationAvailable || accre.accrediationID === 13393 && accre.isAccrediationAvailable\"><label class=\"col-sm-3\" style=\"margin-top: 30px;\">{{accre.accrediationName}}</label><table class=\"col-sm-9\"><tr><td class=\"col-sm-3\">Registration number</td><td class=\"col-sm-3\">Start date</td><td class=\"col-sm-3\">End date</td></tr><tr ng-if=\"accre.accrediationID === 10434\"><td class=\"col-sm-3\"><input name=\"regNumberNABH\" type=\"text\" ng-model=\"accre.certNumber\" placeholder=\"Enter registration number\" class=\"form-control\"></td><td class=\"col-sm-3\"><input name=\"startDateNABH\" type=\"date\" ng-model=\"accre.startDate\" class=\"form-control\"></td><td class=\"col-sm-3\"><input name=\"endDateNABH\" type=\"date\" ng-model=\"accre.endDate\" class=\"form-control\"></td></tr><tr ng-if=\"accre.accrediationID === 13393\"><td class=\"col-sm-3\"><input name=\"regNumberMCI\" type=\"text\" ng-model=\"accre.certNumber\" placeholder=\"Enter registration number\" class=\"form-control\"></td><td class=\"col-sm-3\"><input name=\"startDateMCI\" type=\"date\" ng-model=\"accre.startDate\" class=\"form-control\"></td><td class=\"col-sm-3\"><input name=\"endDateMCI\" type=\"date\" ng-model=\"accre.endDate\" class=\"form-control\"></td></tr></table></div></div><div class=\"form-group\"><label for=\"hospEmail\" class=\"col-sm-3\">Email id</label><div class=\"col-sm-9\"><input type=\"email\" placeholder=\"Enter emial address\" name=\"email\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" id=\"hospEmail\" class=\"form-control\" ng-model=\"addEditHospContact.hospitalEmail\"> <span ng-if=\"!frmRooms.email.$valid\" style=\"color: #f00\">Email address not seems to be valid.</span></div></div><div class=\"form-group\"><label for=\"hospMob\" class=\"col-sm-3\">Contact number</label><div class=\"col-sm-3\"><div class=\"input-group\"><span class=\"input-group-addon\">+91</span> <input type=\"number\" name=\"newNumber\" placeholder=\"Enter contact number with STD code\" ng-minlength=\"10\" ng-maxlength=\"10\" class=\"form-control\" ng-model=\"addNew.contactNumber\"></div><span ng-if=\"frmRooms.newNumber.$error.maxlength || frmRooms.newNumber.$error.minlength\" style=\"color: #f00\">Contact No. not seems to be valid.</span></div><div class=\"col-sm-1\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!addNew.contactNumber\" ng-click=\"addNewChoiceContact(addNew.contactNumber)\">Add</button></div><div class=\"row\"><div class=\"col-sm-4\"><input uib-popover=\"{{addEditHospContact.hospitalLandLine}}\" popover-title=\"Contact No.\" popover-trigger=\"mouseenter\" type=\"text\" name=\"\" id=\"hospPhone\" class=\"form-control\" ng-readonly=\"edithospitalLandLineValue\" ng-model=\"addEditHospContact.hospitalLandLine\"></div><button id=\"hospitalLandLine\" ng-click=\"edithospitalLandLine()\" class=\"fa fa-edit col\"></button></div></div><div class=\"form-group\"><label for=\"hospMob\" class=\"col-sm-3\">Fax number</label><div class=\"col-sm-9\"><div class=\"input-group\"><span class=\"input-group-addon\">+91</span> <input type=\"number\" placeholder=\"Enter fax number\" ng-maxlength=\"10\" name=\"fax\" id=\"hospFax\" class=\"form-control\" ng-model=\"addEditHospContact.hospitalFaxNumber\"></div><span ng-if=\"frmRooms.fax.$error.maxlength\" style=\"color: #f00\">Fax number not seems to be valid.</span></div></div><div class=\"form-group\"><label for=\"hospMob\" class=\"col-sm-3\">Customer support number</label><div class=\"col-sm-9\"><div class=\"input-group\"><span class=\"input-group-addon\">+91</span> <input type=\"number\" placeholder=\"Enter customer support number\" name=\"phoneNumber\" ng-maxlength=\"10\" id=\"hospMob\" class=\"form-control\" ng-model=\"addEditHospContact.hospitalMobile\"></div><span ng-if=\"frmRooms.phoneNumber.$error.maxlength\" style=\"color: #f00\">Customer support No. not seems to be valid.</span></div></div><div class=\"form-group\"><label for=\"hospFax\" class=\"col-sm-3\">Rohini Id</label><div class=\"col-sm-9\"><input type=\"text\" placeholder=\"Enter rohini id\" ng-maxlength=\"15\" name=\"rohiniId\" id=\"hospFax\" class=\"form-control\" ng-model=\"addEditHospContact.rohiniID\"> <span ng-if=\"frmRooms.rohiniId.$error.maxlength\" style=\"color: #f00\">Rohini Id not seems to be valid.</span></div></div><div class=\"form-group\"><label for=\"hospWeb\" class=\"col-sm-3\">Website</label><div class=\"col-sm-9\"><input type=\"text\" placeholder=\"Enter website URL\" name=\"website\" id=\"hospWeb\" class=\"form-control\" ng-model=\"addEditHospContact.hospitalWebsite\"></div></div><div class=\"form-group\"><label class=\"col-sm-3\" style=\"margin-top: 20px;\">Sunday open</label> <input type=\"checkbox\" name=\"sunday\" id=\"sunday\" ng-model=\"hospitalProfileCtrl.isSundayOpen\" style=\"width: 25px; height: 30px; margin-left: 20px;\"></div><div class=\"form-group\"><label for=\"hospWeb\" class=\"col-sm-3\" style=\"margin-top: 40px;\">Center timing</label><div class=\"col-sm-9\"><div class=\"pull-left\"><div class=\"form-group\"><div uib-timepicker=\"\" ng-model=\"profile.firstTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" readonly-input=\"true\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><div class=\"pull-left\"><div style=\"margin-top: 21px; padding: 20px;\"><span>To</span></div></div><div class=\"pull-left\"><div class=\"form-group\"><div uib-timepicker=\"\" ng-model=\"profile.secondTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" readonly-input=\"true\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div></div></div><div class=\"form-group\"><label for=\"hospWeb\" class=\"col-sm-3\">Logo</label><div class=\"col-sm-9\"><img ng-if=\"hospLogo\" ng-src=\"{{hospLogo}}\" class=\"imgProperties pull-left\" alt=\"logo\"> <a href=\"\" class=\"btn btn-sm btn-primary\" data-toggle=\"modal\" data-target=\"#hospitalLogo\" style=\"margin-left:10px\"><i class=\"fa fa-plus\"></i> Add Logo</a></div></div></div><hr><div class=\"clearfix\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"addressMethods.updateHospitalDetails()\" ng-disabled=\"frmRooms.$invalid\">Update Details</button> <button type=\"button\" style=\"margin-right: 5px;\" class=\"btn btn-default pull-right\" ng-click=\"addressMethods.closeEditContact()\">Close</button></div></form></div><div class=\"modal fade\" id=\"hospitalMap\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog modal-dialog-custom modal-lg\" role=\"document\"><div class=\"modal-content modal-content-custom\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Mark your hospital on the map below</h4></div><div class=\"modal-body\"><div class=\"row\" style=\"margin:0;\"><div class=\"col-md-6\" style=\"position: absolute;top: 7%;z-index: 1;left: 15%;\"><google-map-autocomplete ng-if=\"map.isInitialised\" map=\"map.value\" callback-fn=\"mapMethods.placeChanged(arg)\"></google-map-autocomplete></div></div><div id=\"map\" style=\"height:400px\"></div></div><div class=\"modal-footer\"><button type=\"button\" id=\"submit\" name=\"submit\" class=\"btn btn-sm btn-success\" ng-click=\"mapMethods.updateLocation()\">Submit Location</button> <button type=\"button\" class=\"btn btn-sm btn-default pull-left\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"hospitalImages\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"imagesMethods.clearFileModels()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Add Hospital Images</h4></div><div class=\"modal-body\"><div id=\"addHospImages\" role=\"tabpanel\" class=\"tab-pane\"><div style=\"margin-top:20px\" ng-hide=\"!newlyUploadedImages || newlyUploadedImages.length <= 0\"><div class=\"form-group\"><div ng-repeat=\"hospImg in newlyUploadedImages\" style=\"margin-top:2%\" class=\"row\"><div ng-class=\"hospImg.isDelete ? \'gray image-custom col-md-4\' :\'col-md-4\'\" data-content=\"Set to Delete\"><img ng-src=\"{{hospImg.downloadLink}}\" class=\"imgProperties\"></div><div class=\"col-md-6\"><div class=\"form-group\"><div class=\"col-md-9\"><select class=\"form-control\" ng-model=\"hospImg.imageDescription\" ng-options=\"docType as docType.masterLookUpColumnValue for docType in imageTypes | filter:{ value : \'!Room Image\' }\" required=\"\"><option value=\"\">Select</option></select></div></div></div><div class=\"col-md-2\"><input type=\"button\" tabindex=\"-1\" class=\"btn btn-xs btn-danger\" ng-click=\"hospImg.isDelete = true\" ng-hide=\"hospImg.isDelete\" value=\"Remove\"> <input type=\"button\" tabindex=\"-1\" class=\"btn btn-xs btn-default\" ng-click=\"hospImg.isDelete = false\" ng-hide=\"!hospImg.isDelete\" value=\"Cancel Delete\"></div></div></div></div><div style=\"margin-top:20px\" ng-if=\"!newlyUploadedImages || newlyUploadedImages.length <= 0\"><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-click=\"fileUploadMethods.removeFileToUpload($index)\">-</button></div></fieldset><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"fileUploadMethods.addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add More Images</span></button></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" id=\"submit\" name=\"submit\" class=\"btn btn-success\" ng-if=\"!newlyUploadedImages || newlyUploadedImages.length <= 0\" ng-click=\"imagesMethods.uploadNewHospImages()\">Upload Images</button> <button type=\"button\" id=\"submit\" name=\"submit\" class=\"btn btn-success\" ng-hide=\"!newlyUploadedImages || newlyUploadedImages.length <= 0\" ng-click=\"imagesMethods.saveNewHospImages()\">Save Images</button> <button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"imagesMethods.clearFileModels()\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"hospitalContact\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\"><span ng-if=\"!isAdd\">Edit</span><span ng-if=\"isAdd\">Add</span> Contact Details <span ng-if=\"addEditHospContact.contactType\">For {{addEditHospContact.contactType}}</span> {{}}</h4></div><div class=\"modal-body\"><div class=\"form form-horizontal\"><div class=\"form-group\"><label for=\"name\" class=\"col-sm-3\">Contact type</label><div class=\"col-md-9\"><select ng-disabled=\"isAdd=== false\" class=\"form-control\" ng-model=\"addEditHospContact.contactType\"><option value=\"\">Select Contact Type</option><option value=\"consultationsspoc\">Consultation coordinator contact</option><option value=\"finance\">Finance coordinator contact</option><option value=\"healthcheckspoc\">Health check coordinator contact</option><option value=\"insurance\">Insurance coordinator contact</option><option value=\"management\">Management coordinator contact</option><option value=\"marketing\">Marketing coordinator contact</option><option value=\"reception\">Reception coordinator contact</option></select></div></div><div class=\"form-group\"><label for=\"name\" class=\"col-sm-3\">Name</label><div class=\"col-md-9\"><input type=\"text\" placeholder=\"Enter name\" name=\"name\" id=\"name\" class=\"form-control col-sm-9\" ng-model=\"addEditHospContact.hospitalContactDetailContactPersonName\"></div></div><div class=\"form-group\"><label for=\"designation\" class=\"col-sm-3\">Designation</label><div class=\"col-md-9\"><input type=\"text\" placeholder=\"Enter designation\" name=\"designation\" id=\"designation\" class=\"form-control col-sm-9\" ng-model=\"addEditHospContact.hospitalContactDetailContactPersonDesignation\"></div></div><div class=\"form-group\"><label for=\"emailID\" class=\"col-sm-3\">Email</label><div class=\"col-md-9\"><input type=\"text\" placeholder=\"Enter mail ID\" name=\"emailID\" id=\"emailID\" class=\"form-control col-sm-9\" ng-model=\"addEditHospContact.hospitalContactDetailContactPersonEmail\"></div></div><div class=\"form-group\"><label for=\"mobile\" class=\"col-sm-3\">Mobile</label><div class=\"col-md-9\"><input type=\"text\" numbers-only=\"numbers-only\" placeholder=\"Enter mobile number\" name=\"mobile\" id=\"mobile\" class=\"form-control col-sm-9\" ng-model=\"addEditHospContact.hospitalContactDetailContactPersonMobileNo\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-sm btn-default\" data-dismiss=\"modal\">Close</button> <button ng-if=\"isDeleteValue\" type=\"button\" class=\"btn btn-sm btn-danger\" data-dismiss=\"modal\">Delete</button> <button type=\"button\" id=\"submit\" name=\"submit\" class=\"btn btn-sm btn-primary\" ng-if=\"!isAdd\" ng-click=\"updateHospitalContact()\">Update</button> <button type=\"button\" ng-disabled=\"!addEditHospContact.contactType\" id=\"submit\" name=\"submit\" class=\"btn btn-sm btn-primary\" ng-if=\"isAdd\" ng-click=\"addHospitalContact()\">Add</button></div></div></div></div><div class=\"modal fade\" id=\"openHospFacilities\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Hospital Facilities</h4></div><div class=\"modal-body\"><div class=\"form-group\"><h4>Medical facilities</h4><div class=\"row\"><div class=\"checkbox col-md-4\" ng-repeat=\"fac in listOfMedicalFacilities\"><label><input type=\"checkbox\" ng-model=\"fac.isFacilityAvailable\" data-id=\"{{fac.facilityID}}\"> {{fac.facilityName}}</label></div></div><h4>General facilities</h4><div class=\"row\"><div class=\"checkbox col-md-4\" ng-repeat=\"fac in listOfGeneralFacilities\"><label><input type=\"checkbox\" ng-model=\"fac.isFacilityAvailable\" data-id=\"{{fac.facilityID}}\"> {{fac.facilityName}}</label></div></div><h4>Other facilities</h4><div class=\"row\"><div class=\"checkbox col-md-4\" ng-repeat=\"otherFac in displayOtherFacilitiesModal\"><label><input type=\"checkbox\" ng-model=\"otherFac.isFacilityAvailable\" data-id=\"{{otherFac.facilityID}}\"> {{otherFac.facilityName}}</label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><strong>Not finding what you are looking?</strong> <button class=\"btn btn-primary\" ng-click=\"facilitiesMethods.addNewChoice()\"><i class=\"fa fa-plus\"></i> Add facility</button><div class=\"input-group col-md-8\" ng-repeat=\"otherFac in listOfOtherFacilitiesText track by $index\"><input type=\"text\" class=\"form-control\" ng-model=\"listOfOtherFacilitiesText[$index]\"><div class=\"input-group-btn\"><button class=\"fa fa-minus-square btn btn-danger\" ng-click=\"facilitiesMethods.removeChoice($index)\"></button></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" id=\"submit\" name=\"submit\" class=\"btn btn-sm btn-success\" ng-click=\"facilitiesMethods.updateHospitalFacility()\">Update Facilities</button> <button type=\"button\" class=\"btn btn-sm btn btn-default pull-left\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"deleteContact\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4>Confirmation model</h4></div><div class=\"modal-body\"><h5 class=\"modal-title\">Are you sure you want to remove <strong>{{addEditHospContact.hospitalContactDetailContactPersonName}}</strong> ({{addEditHospContact.hospitalContactDetailContactPersonDesignation}}) as <strong>{{hospContactSource}}</strong> contact ?</h5></div><div class=\"modal-footer\"><button style=\"margin-left: 5px;\" type=\"button\" class=\"btn btn-danger pull-right\" data-dismiss=\"modal\" ng-click=\"updateHospitalContact(true)\">Yes</button> <button type=\"button\" class=\"btn btn-default pull-right\" data-dismiss=\"modal\">No</button></div></div></div></div><div class=\"modal fade\" id=\"hospitalLogo\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"imagesMethods.clearFileModels()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Add Hospital Logo</h4></div><div class=\"modal-body\"><div id=\"addHospImages\" role=\"tabpanel\" class=\"tab-pane\"><div style=\"margin-top:20px\" ng-hide=\"!newlyUploadedImages || newlyUploadedImages.length <= 0\"><div class=\"form-group\"><div ng-repeat=\"hospImg in newlyUploadedImages\" style=\"margin-top:2%\" class=\"row\"><div class=\"col-md-4\"></div><div ng-class=\"hospImg.isDelete ? \'gray image-custom col-md-4\' :\'col-md-4\'\"><img ng-src=\"{{hospLogo}}\" class=\"imgProperties\"></div><div class=\"col-md-4\"></div></div></div></div><div style=\"margin-top:20px\" ng-if=\"!newlyUploadedImages || newlyUploadedImages.length <= 0\"><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-click=\"fileUploadMethods.removeFileToUpload($index)\">-</button></div></fieldset></div></div></div><div class=\"modal-footer\"><button type=\"button\" id=\"submit\" name=\"submit\" class=\"btn btn-success\" ng-if=\"!newlyUploadedImages || newlyUploadedImages.length <= 0\" ng-click=\"imagesMethods.uploadHospLogo()\">Upload Logo</button> <button type=\"button\" id=\"submit\" name=\"submit\" class=\"btn btn-success\" ng-hide=\"!newlyUploadedImages || newlyUploadedImages.length <= 0\" ng-click=\"imagesMethods.updateHospLogo()\">Save Logo</button> <button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"imagesMethods.clearFileModels()\">Close</button></div></div></div></div><a id=\"scroll\" href=\"\" class=\"pull-right\" ng-click=\"profileMethods.scrollTo(\'hospHeader\')\"><i class=\"fa fa-chevron-up\"></i></a></div>");
$templateCache.put("app/modules/inforequired/inforequired.html","<div class=\"header ng-scope login\" ng-if=\"!layout\"><ul class=\"nav nav-pills pull-right ng-scope\"><li ng-show=\"displayThis(\'switchHosp\', getUserRole())\" class=\"ng-hide\"><button id=\"showAll\" class=\"btn btn-info ng-hide\" ng-click=\"showAllHospitals()\" ng-show=\"showAll\">All Claims</button> <button class=\"btn btn-info\" data-toggle=\"modal\" data-target=\"#chooseHospital\" ng-click=\"fetchHospitals()\" id=\"changeHospitalBtn\">Suguna Hospital - Change Hospital</button></li><div class=\"modal fade\" id=\"chooseHospital\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\" id=\"chooseHospitalBody\"><form action=\"\" ng-show=\"hospitalsFetched\" class=\"ng-pristine ng-valid ng-hide\"><label for=\"hospitalName\">Enter Hospital name to search</label><div class=\"hospSearchBox\"><span class=\"twitter-typeahead\" style=\"position: relative; display: inline-block; direction: ltr;\"><input type=\"text\" class=\"form-control tt-hint\" readonly=\"\" autocomplete=\"off\" spellcheck=\"false\" tabindex=\"-1\" style=\"position: absolute; top: 0px; left: 0px; border-color: transparent; box-shadow: none; opacity: 1; background: none 0px 0px / auto repeat scroll padding-box border-box rgb(242, 242, 242);\"><span class=\"twitter-typeahead\" style=\"position: relative; display: inline-block; direction: ltr;\"><input type=\"text\" class=\"form-control tt-input tt-hint\" autocomplete=\"off\" spellcheck=\"false\" dir=\"auto\" style=\"position: absolute; vertical-align: top; top: 0px; left: 0px; border-color: transparent; box-shadow: none; opacity: 1; background: none 0px 0px / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0);\" readonly=\"\" tabindex=\"-1\"><pre aria-hidden=\"true\" style=\"position: absolute; visibility: hidden; white-space: pre; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 13px; font-style: normal; font-variant: normal; font-weight: 400; word-spacing: 0px; letter-spacing: 0px; text-indent: 0px; text-rendering: auto; text-transform: none;\"></pre><span class=\"twitter-typeahead\" style=\"position: relative; display: inline-block; direction: ltr;\"><input type=\"text\" class=\"form-control tt-input tt-hint\" autocomplete=\"off\" spellcheck=\"false\" dir=\"auto\" style=\"position: absolute; vertical-align: top; top: 0px; left: 0px; border-color: transparent; box-shadow: none; opacity: 1; background: none 0px 0px / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0);\" readonly=\"\" tabindex=\"-1\"><pre aria-hidden=\"true\" style=\"position: absolute; visibility: hidden; white-space: pre; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 13px; font-style: normal; font-variant: normal; font-weight: 400; word-spacing: 0px; letter-spacing: 0px; text-indent: 0px; text-rendering: auto; text-transform: none;\"></pre><input type=\"text\" id=\"hospSearchBox\" class=\"form-control tt-input\" placeholder=\"Start typing Hospital name (Enter minimum 3 characters)\" autocomplete=\"off\" spellcheck=\"false\" dir=\"auto\" style=\"position: relative; vertical-align: top; background-color: transparent;\"><pre aria-hidden=\"true\" style=\"position: absolute; visibility: hidden; white-space: pre; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 13px; font-style: normal; font-variant: normal; font-weight: 400; word-spacing: 0px; letter-spacing: 0px; text-indent: 0px; text-rendering: auto; text-transform: none;\"></pre><span class=\"tt-dropdown-menu\" style=\"position: absolute; top: 100%; left: 0px; z-index: 100; display: none; right: auto;\"><div class=\"tt-dataset-hospitalnames\"></div></span></span><pre aria-hidden=\"true\" style=\"position: absolute; visibility: hidden; white-space: pre; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 13px; font-style: normal; font-variant: normal; font-weight: 400; word-spacing: 0px; letter-spacing: 0px; text-indent: 0px; text-rendering: auto; text-transform: none;\"></pre><span class=\"tt-dropdown-menu\" style=\"position: absolute; top: 100%; left: 0px; z-index: 100; display: none; right: auto;\"><div class=\"tt-dataset-hospitalnames\"></div></span></span><pre aria-hidden=\"true\" style=\"position: absolute; visibility: hidden; white-space: pre; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 13px; font-style: normal; font-variant: normal; font-weight: 400; word-spacing: 0px; letter-spacing: 0px; text-indent: 0px; text-rendering: auto; text-transform: none;\"></pre><span class=\"tt-dropdown-menu\" style=\"position: absolute; top: 100%; left: 0px; z-index: 100; display: none; right: auto;\"><div class=\"tt-dataset-hospitalnames\"></div></span></span></div></form><p ng-show=\"!hospitalsFetched\" class=\"\">Fetching hospitals. Please wait...</p></div><div class=\"modal-body ng-hide\" ng-show=\"esubmitted\"><p>Your enhancement request has been submitted successfully.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"esubmitted=false\">Close</button></div></div></div></div></ul><ul class=\"nav nav-pills pull-right ng-scope\"></ul><div class=\"brand-wrap pull-left ng-scope\"><h3 class=\"brand text-muted pull-left\"><img src=\"/images/logo-mediassist.png\" alt=\"\"></h3></div></div><div class=\"container-fluid ng-scope\"><div id=\"sidebar\" class=\"collapse navbar-collapse\"><ul class=\"nav nav-pills nav-stacked login\"><li id=\"approved\"><a analytics-on=\"click\" analytics-event=\"Settled Claims\" class=\"ng-scope\"><i class=\"glyphicon glyphicon-check\"></i> <span>Information Required</span></a></li></ul></div><style>\n        .mandatory{\n            text-align: center;\n            margin-top: 30px;\n            background-color: transparent;\n        }\n        .bs-callout{\n            padding: 20px;\n            margin: 20px 0;\n            border: 1px solid #eee;\n            border-left-width: 5px;\n            border-radius: 3px;\n        }\n        .bs-callout+.bs-callout {\n            margin-top: -5px;\n        }\n        .bs-callout-info {\n            border-left-color: #5bc0de;\n        }\n        .bg-danger, .bg-info{\n            padding: 10px;\n        }\n        .bg-danger a{\n            color: #2a6496;\n        }\n        a{\n            color: #428bca\n        }\n        .container-fluid{\n            padding: 0px;\n        }\n    </style><div class=\"active-claims claims\"><ul id=\"myTab\" class=\"nav nav-tabs\" role=\"tablist\"></ul><div id=\"myTabContent\" class=\"tab-content\"><div class=\"tab-pane fade\" id=\"tab123\"><div class=\"panel panel-default\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-5 panel\"><b>Unable to fetch claim details</b><br>Please try again.</div></div><button class=\"btn btn-danger pull-right\" id=\"closeButton\">Close</button></div></div></div><div class=\"modal fade\" id=\"submitMissing\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\" id=\"submitFormBody\" ng-show=\"!msubmitted\"><form action=\"../../FileUpload.ashx\" id=\"missingForm\" method=\"POST\" enctype=\"multipart/form-data\" class=\"ng-pristine ng-valid\"><input type=\"hidden\" value=\"\" name=\"claimId\" id=\"mClaimId\"> <input type=\"hidden\" value=\"{{hospId}}\" name=\"hospId\"> <input type=\"hidden\" value=\"45\" name=\"updatedBy\"> <input type=\"hidden\" value=\"reply\" name=\"ClaimAction\"> <label for=\"enhance-remarks\">Remarks on missing documents</label> <textarea name=\"enhance-remarks\" class=\"form-control\" id=\"enhance-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your comments regarding missing documents. Eg: Surgical details updated or Diagnosis details updated or Submitted missing scan bill etc.,\"></textarea><hr><h4>Attach missing documents</h4><div id=\"missingdocs\"><input type=\"file\" name=\"enhance-files\" id=\"\"></div><br><a ng-click=\"addFileInput(\'missingdocs\')\" class=\"btn btn-primary btn-xs\">Add more files</a><hr><input id=\"missingbutton\" type=\"submit\" class=\"btn btn-primary pull-right\" value=\"Submit\"> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\">Cancel</button></form></div><div class=\"modal-body ng-hide\" ng-show=\"msubmitted\"><p ng-show=\"msubsuccess\" class=\"ng-hide\">Your missing documents have been submitted successfully.</p><p ng-show=\"!msubsuccess\" class=\"\">Something went wrong! Your missing documents are not submitted. Please try again.</p><button class=\"finalMessage\" type=\"button\" data-dismiss=\"modal\" ng-click=\"msubmitted=false\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"finalDischarge\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\" id=\"finalDischargeBody\" ng-show=\"!dsubmitted\"><form action=\"FileUpload.ashx\" id=\"dischargeForm\" method=\"POST\" enctype=\"multipart/form-data\" class=\"ng-pristine ng-valid\"><input type=\"hidden\" value=\"\" name=\"claimId\" id=\"dClaimId\"> <input type=\"hidden\" value=\"1001539\" name=\"hospId\"> <input type=\"hidden\" value=\"45\" name=\"updatedBy\"> <input type=\"hidden\" value=\"discharge\" name=\"ClaimAction\"><h4>Submit discharge documents</h4><hr><label for=\"enhance-remarks\">Notes for discharge (optional)</label> <textarea name=\"enhance-remarks\" class=\"form-control\" id=\"discharge-remarks\" cols=\"30\" rows=\"5\"></textarea><hr><h4>Discharge attachments</h4><div id=\"dischargedocs\"><input type=\"file\" name=\"enhance-files\" id=\"\"></div><br><a ng-click=\"addFileInput(\'dischargedocs\')\" class=\"btn btn-primary btn-xs\">Add more files</a><hr><input id=\"dischargebutton\" type=\"submit\" class=\"btn btn-primary pull-right\" value=\"Submit Discharge Documents\"> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\">Cancel</button></form></div><div class=\"modal-body ng-hide\" ng-show=\"dsubmitted\"><p ng-show=\"dsubsuccess\" class=\"ng-hide\">Your discharge documents have been submitted successfully.</p><p ng-show=\"!dsubsuccess\" class=\"\">Something went wrong! Your discharge summary is not submitted. Please try again.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"dsubmitted=false\">Close</button></div></div></div></div></div></div></div><div class=\"footer login\"><span>Designed and Developed by <a href=\"http://mahs.in\">Medi Assist Healthcare Services</a></span></div>");
$templateCache.put("app/modules/insurerDashboard/insurerDashboard.html","<style type=\"text/css\">\n    .nvd3.nv-pie path {\n        stroke-opacity: 0;\n    }\n\n    .fontawesome-select {\n        font-family: \'FontAwesome\', \'Helvetica\';\n    }\n</style><div class=\"panel panel-default\"><div class=\"panel-heading\" ng-click=\"showCard ? showCard = false : showCard = true\"><a style=\"color: #168cc9;\"><i class=\"fa fa-pie-chart pull-left\"></i> View Chart</a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': showCard, \'glyphicon-chevron-right\': !showCard}\"></i></div><div class=\"panel-body\" ng-show=\"showCard\"><div class=\"row\"><div class=\"col-md-3 p-l-1 p-r-0\"><div class=\"input-group\"><input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"dateFilterDate.fromDateFilter\" is-open=\"popup5.opened\" datepicker-options=\"dateDefautOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" ng-change=\"setMinDate(dateFilterDate.fromDateFilter)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open5()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-3 p-l-1 p-r-0\"><div class=\"input-group\"><input id=\"\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"dateFilterDate.toDateFilter\" is-open=\"popup6.opened\" datepicker-options=\"dateDefautOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" min-date=\"mindate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open6()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-1 p-l-1 p-r-0\"><button class=\"form-control btn-info\" ng-click=\"loadMasterChart(dateFilterDate.fromDateFilter,dateFilterDate.toDateFilter, \'\', \'fromFilter\')\" title=\"Filter Chart\"><i class=\"fa fa-filter\"></i></button></div><div class=\"col-md-1 p-l-1 p-r-0\"><button class=\"form-control btn-success\" ng-click=\"reload()\" title=\"Refresh\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"col-md-1 p-l-1 p-r-0\"><button class=\"form-control btn-warning pull-right\" ng-click=\"\" title=\"Download/Upload template\" data-toggle=\"modal\" data-target=\"#ViewTemplateModal\"><i class=\"fa fa-upload\"></i>&nbsp;<i class=\"fa fa-download\"></i></button></div><div class=\"col-md-3 p-l-1 p-r-1 pull-right\"><select class=\"form-control xs fontawesome-select\" ng-model=\"chartType.type\" ng-change=\"changeChart(chartType.type)\"><option value=\"pie\" class=\"text-warning\">&#xf200; Pie chart</option><option value=\"donut\" class=\"text-warning\">&#xf192; Donut chart</option><option value=\"discrete\" class=\"text-warning\">&#xf080; Discrete bar chart</option></select></div></div><hr><div class=\"row\"><div class=\"col-md-6\" ng-if=\"masterData.length>0 || masterData.values.length>0\"><div style=\"box-shadow:0 0 16px #ddd; padding-top:20px;\"><nvd3 options=\"masterOptions\" data=\"masterData\"></nvd3><div class=\"alert alert-info text-center\"><b>{{totalMasterStatusRecord}}</b></div></div></div><div class=\"col-md-6\" ng-if=\"(masterData.length == 0 || masterData.values.length == 0) && dataError.length>0\"><div class=\"alert alert-danger text-center\"><b>{{dataError}}</b></div></div><div class=\"col-md-6\" ng-if=\"childData.length>0 || childData.values.length>0\"><div style=\"box-shadow: 0 0 16px #ddd; padding-top: 20px;\"><nvd3 options=\"childOptions\" data=\"childData\"></nvd3><div class=\"alert alert-info text-center\"><b>{{totalChildStatusRecord}}</b></div></div></div><div class=\"col-md-6\" ng-if=\"(childData.length == 0 || childData.values.length == 0) && dataError.length>0\"><div class=\"alert alert-danger text-center\"><b>{{dataError}}</b></div></div></div></div></div><div class=\"row\"><div class=\"alert alert-success text-center pull-right\" ng-show=\"childParticularStatusData.length>0 && !showHashDetails\"><b>{{childParticularStatusData}}</b></div><div class=\"alert alert-success text-center pull-right\" ng-show=\"showHashDetails\"><b><span>{{hashDetails}}</span></b></div></div><div ng-show=\"tabtype === \'insurerDashboard\'\"><angular-tab appointmentlist=\"allAppointments\" tabname=\"\'Insurer All Appointment\'\" tabtype=\"tabtype\" callback-fn=\"ctrlFn(arg)\"></angular-tab></div><div ng-show=\"tabtype === \'eSalesRequests\'\"><angular-tab appointmentlist=\"pbqueue\" tabname=\"\'Insurer E-Sales Request\'\" tabtype=\"tabtype\"></angular-tab></div><div class=\"modal fade\" id=\"ViewCorresponddenceModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Communication history</h4></div><div class=\"modal-body\"><div ng-repeat=\"corres in correspondencData track by $index\" ng-if=\"correspondencData.length>0\"><h4>Communication {{$index + 1}}</h4><ul><li>Customer status : <b>{{corres.callStatusValue}}</b></li><li>Comment: <b>{{corres.comment}}</b></li><li>Created on: <b>{{compareDate(corres.createdOn)}}</b></li></ul><hr></div><div ng-if=\"!correspondencData.length>0\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><h4 style=\"color:red\">{{correspondencError}}</h4></div><div class=\"col-md-2\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"ViewTemplateModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Upload/Download Templates</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><form class=\"form-inline\" ng-if=\"contractList.length > 1 && isDdlVisible\"><div class=\"form-group\"><label for=\"filter\">Filter contract:</label><select name=\"selectFilter\" id=\"selectFilter\" class=\"form-control\" ng-options=\"option.entityName for option in contractList track by option.id\" style=\"margin-right: 5px;\" ng-model=\"selectFilter\" ng-change=\"getSelectedErId(selectFilter)\"><option value=\"\">Select Contract</option></select></div></form></div><div class=\"col-md-12\" ng-if=\"isDownload\"><a class=\"btn btn-primary btn-xs\" style=\"margin-top: 2px; margin-left: 14px; margin-right: 14px; background-color: #3ec13e;\" target=\"_blank\" href=\"{{templateUrl}}\"><i class=\"glyphicon glyphicon-cloud-download\"></i>Download Template</a><div class=\"fileUpload btn btn-default btn btn-primary btn-xs\" style=\"position: relative; background-color: #3782c4; max-width: 318px; margin-top: 0px; padding-top: 0px; padding-bottom: 0; width: 134px;\"><input type=\"file\" id=\"uploadTemplates\" ng-model=\"fileUpload\" onchange=\"angular.element(this).scope().setFilesUpload(this)\" style=\"background-color: black; border-color: black; visibility:hidden;\"> <label for=\"uploadTemplates\" style=\"font-weight:normal; color: white; position:absolute; top:0; right:0; bottom:0; left:0; cursor:pointer;\"><i class=\"glyphicon glyphicon-cloud-upload\"></i>Upload Excel File</label></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div>");
$templateCache.put("app/modules/markAutoAttendence/markAutoAttendence.html","<div class=\"container col-md-12 col-sm-12 col-xs-12 status-box\"><form #markautoattendenceform=\"\" class=\"contentPart status-form\" ng-show=\"!showThankYou\"><h1>Please update your health check status</h1><div class=\"attendance-options\"><label><input name=\"otp\" id=\"otp\" type=\"radio\" ng-model=\"selectedChoice\" ng-click=\"attendenceYesClicked()\" required=\"\" value=\"yes\">Medical attended</label> <label><input name=\"otp\" id=\"otp\" type=\"radio\" ng-model=\"selectedChoice\" ng-click=\"attendenceNoClicked()\" required=\"\" value=\"no\">Medical not attended</label></div><div class=\"feedback\"><div id=\"rating\"><span>Rating:</span> <span data-value=\"1\" class=\"star not-rated\">&#9733;</span> <span data-value=\"2\" class=\"star not-rated\">&#9733;</span> <span data-value=\"3\" class=\"star not-rated\">&#9733;</span> <span data-value=\"4\" class=\"star not-rated\">&#9733;</span> <span data-value=\"5\" class=\"star not-rated\">&#9733;</span></div><label>Please provide your valuable feedback: <textarea id=\"feedback\" name=\"feedback\" ng-model=\"feedback\" maxlength=\"300\" rows=\"50\" cols=\"50\" wrap=\"hard\">\n\n            </textarea></label></div><button class=\"btn btn-primary submit-button\" ng-click=\"submitAutoAttendenceData()\" ng-disabled=\"!selectedChoice\">Submit</button><div ng-show=\"showThankYou\" class=\"contentPart\" style=\"font-size: 30px;text-align: center; color: black;height:35px;\">Thank you for updating health check status</div></form></div><style>\n    .container {\n        padding: 20px;\n    }\n\n    .feedback {\n        margin-top: 50px;\n        margin-bottom: 30px;\n    }\n\n    #feedback {\n        margin: auto;\n        height: 100px;\n        resize: none;\n        font-family: \'Times New Roman\', Times, serif;\n        font-weight: 300;\n        padding: 10px;\n        width: 100%;\n        margin-top: 20px;\n    }\n\n    .attendance-options {\n        text-align: center;\n        margin: 20px;\n    }\n\n    .status-box {\n        margin-top: 40px;\n        text-align: center;\n        background-color: white;\n        border: 3px solid black;\n    }\n\n    .status-form {\n        margin: auto;\n        margin-top: 30px;\n        margin-bottom: 30px;\n        padding: 10px;\n        text-align: center;\n    }\n\n    label {\n        height: 40px;\n        font-size: 20px;\n    }\n\n    input {\n        width: 50px;\n        height: 20px;\n    }\n\n    button {\n        max-width: 400px;\n    }\n\n    #rating {\n        margin: 10px;\n        cursor: pointer;\n    }\n\n    #rating>span {\n        width: 1.1em;\n        margin: 5px;\n        font-size: x-large;\n    }\n\n    span.rated {\n        color: orange;\n    }\n\n    .not-rated {\n        color: lightgrey;\n    }\n\n    @media only screen and (max-width: 400px) {\n        #feedback {\n            width: 100%;\n            margin-top: 20px;\n        }\n\n        .container * {\n            font-size: medium;\n            padding: 0px;\n        }\n\n        #rating>span {\n            width: 1.1em;\n            margin: 3px;\n            font-size: large;\n        }\n\n        .status-box {\n            padding: 20px;\n        }\n\n        .status-form {\n            margin-top: 0px;\n            margin-bottom: 0px;\n        }\n\n        .submit-button {\n            padding: 5px;\n        }\n\n    }\n</style>");
$templateCache.put("app/modules/misreports/misreports.html","<style>\n    .modal-body {\n        max-height: calc(100vh - 300px);\n        overflow-y: auto;\n    }\n</style><div><ul class=\"nav nav-tabs\" role=\"tablist\" ng-init=\"tab1 = true; tab2 = false\"><li role=\"presentation\" class=\"active\" ng-click=\"openTab1();tab1 = true; tab2 = false; showTimeAdd = false;\"><a href=\"\" data-target=\"#myTabContent\" role=\"tab\" data-toggle=\"tab\" style=\"padding:5px 10px\">Status wise filter</a></li><li role=\"presentation\" ng-click=\"openTab2();tab1 = false; tab2 = true;showTimeAdd = false;\"><a href=\"\" data-target=\"#corpDateStatus\" role=\"tab\" data-toggle=\"tab\" style=\"padding:5px 10px\">Corporate MIS & Date Wise Filter</a></li></ul><div id=\"myTabContent\" class=\"tab-content\" ng-show=\"tab1\"><div id=\"statusCount\" class=\"tab-pane fade active in\"><div class=\"form-create card form-create-first\" id=\"\"><div class=\"row m-t-10\"><div class=\"form-group col-md-4\"><label class=\"control-label required-field col-sm-4\" for=\"contractId\">Select contract</label><div class=\"col-sm-8\"><select name=\"\" id=\"contractId\" class=\"form-control\" ng-model=\"tab1Data.statusContracts\" ng-options=\"contract as contract.entityName for contract in contracts\" ng-change=\"changeContract(tab1Data.statusContracts, \'forStatus\');\" ng-click=\"loadContracts()\"><option value=\"\">Select a contract</option></select></div></div><div class=\"form-group col-md-4\" ng-show=\"tab1Data.statusContracts && selectedResult && !isInsurer\"><label for=\"\" class=\"control-label required-field col-sm-4\">Select corporates</label><div class=\"addTime col-sm-8\"><a href=\"\" class=\"btn btn-default btn-block addTimeBtn\" ng-click=\"showTimeAdd ? showTimeAdd = false : showTimeAdd = true\" style=\"text-align:left;\"><i class=\"fa fa-plus\"></i> <span ng-hide=\"getCount() > 0\">Select Corporates</span><span ng-show=\"getCount() > 0\">{{getCount()}} Selected</span></a><div class=\"select-corp\" ng-show=\"showTimeAdd\"><div class=\"arrow\"></div><h3 class=\"popover-title\"><span><a href=\"\" ng-click=\"selectAll(true)\" class=\"btn btn-xs btn-default\">Check all</a> <a href=\"\" ng-click=\"selectAll(false)\" class=\"btn btn-xs btn-default\">Uncheck all</a> <a href=\"\" ng-hide=\"getCount() == 0\" ng-click=\"showTimeAdd = false\" class=\"alert-primary pull-right btn btn-xs btn-default\"><i class=\"fa fa-check\"></i> Done</a> <a href=\"\" ng-show=\"getCount() == 0\" ng-click=\"showTimeAdd = false\" class=\"alert-danger pull-right btn btn-xs btn-default\"><i class=\"fa fa-times\"></i></a> <em class=\"pull-right em-custom\">{{getCount()}} Selected</em></span> <input type=\"text\" class=\"form-control m-t-5\" ng-model=\"searchCorporates\" placeholder=\"Search Corporates\"></h3><div class=\"popover-content\"><div class=\"corp-content\"><div class=\"item\" ng-repeat=\"corp in corporatesForStatus | filter:searchCorporates\" ng-class=\"corp.isSelected ? \'checked\': \'\'\"><span ng-click=\"corp.isSelected = !corp.isSelected\"><input type=\"checkbox\" ng-model=\"corp.isSelected\" class=\"hide\"> <a href=\"\" ng-show=\"corp.isSelected\"><i class=\"fa fa-check-square-o\"></i></a> <a href=\"\" ng-show=\"!corp.isSelected\"><i class=\"fa fa-square-o\"></i></a> {{corp.entityName}}</span></div></div></div></div></div></div><div class=\"form-group col-md-4\"><label for=\"dateType\" class=\"control-label required-field col-sm-4\">Date type</label><div class=\"col-sm-8\"><select id=\"dateType\" class=\"form-control\" ng-model=\"tab2Data.dateType\"><option disabled=\"true\" value=\"\">Select a type</option><option value=\"apptdate\">Appointment date</option><option value=\"createddate\">Creation date</option></select></div></div></div><div class=\"row p-r-0\"><div class=\"form-group col-md-4\" ng-show=\"tab2Data.dateType\"><label for=\"fromDate\" class=\"control-label required-field col-sm-4\">From date</label><div class=\"input-group col-sm-8\"><input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" placeholder=\"Start Date\" uib-datepicker-popup=\"{{format}}\" ng-model=\"tab1Data.statusStartDate\" is-open=\"open11.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1Tab1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group col-md-4\" ng-show=\"tab1Data.statusStartDate\"><label for=\"toDate\" class=\"control-label required-field col-sm-4\">To date</label><div class=\"input-group col-sm-8\"><input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" placeholder=\"To Date\" uib-datepicker-popup=\"{{format}}\" ng-model=\"tab1Data.statusEndDate\" is-open=\"open22.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2Tab1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group col-md-4\" ng-show=\"tab1Data.statusContracts\" style=\"text-align:right;float:right\"><button class=\"btn btn-primary\" ng-click=\"showTimeAdd = false;getMis()\"><i class=\"fa fa-search\"></i> Search</button> <button class=\"btn btn-info\" ng-click=\"showTimeAdd = false;refreshMIS()\"><i class=\"fa fa-refresh\"></i> Refresh</button></div></div><div ng-if=\"totalCountStatus >0\" class=\"alert alert-default text-center\" style=\"border-bottom:1px solid #ddd; border-top:1px solid #ddd; margin-top:20px\"><span style=\"font-size:26px;\">{{totalCountStatus}}</span><br>Total {{contractName}} Appointments</div><div class=\"clearfix\"><ul class=\"selectList\" ng-show=\"impStatus.length > 0\"><li ng-model=\"selectedStatus\" ng-repeat=\"d in impStatus\" ng-click=\"getStatusDetails(d)\"><a style=\"border-radius: 30px\" class=\"selected\"><span style=\"border-radius: 10px;\" class=\"left bg-primary\">{{d.apptCount}}</span> {{d.statusName}}</a></li></ul><ul class=\"selectList\" ng-show=\"otherStatus.length > 0\"><li ng-model=\"selectedStatus\" ng-repeat=\"other in otherStatus\" ng-click=\"getStatusDetails(other)\"><a style=\"background-color: rgba(158, 158, 158, 0.33);color: black;\"><span class=\"left\">{{other.apptCount}}</span> {{other.statusName}}</a></li></ul><div style=\"margin-top: 80px;\" class=\"alert alert-danger text-center\" ng-if=\"totalCountStatus === 0\">No Status available!</div></div><hr><div class=\"row m-t-10 tab2-cust\" ng-show=\"statusDetails && statusDetails.length>0\"><button class=\"btn btn-primary pull-right\" data-toggle=\"modal\" data-target=\"#downloadReports\" ng-click=\"checkAllRecords(false)\">Download</button><div class=\"alert alert-info pull-right\" style=\"padding:7px\">You are looking for <strong>{{statusName}}</strong> in <strong><span ng-show=\"contractName\">{{contractName}}</span><span ng-show=\"!contractName\">all contracts</span></strong></div><angular-tab appointmentlist=\"statusDetails\" tabname=\"\'misReports\'\" tabtype=\"\'misReports\'\"></angular-tab></div></div></div></div><div id=\"corpDateStatus\" class=\"tab-content\" ng-show=\"tab2\"><div class=\"row m-t-10\"><div class=\"col-md-3 p-r-0\"><label for=\"contractId\">Select contract</label><select name=\"\" id=\"contractId\" class=\"form-control\" ng-model=\"tab2Data.dateWiseContracts\" ng-options=\"contract as contract.entityName for contract in contracts\" ng-change=\"changeContract(tab2Data.dateWiseContracts, \'forStatus\');\" ng-click=\"loadContractData();\"><option value=\"\">Select a contract</option></select></div><div class=\"col-md-3 p-r-0\" ng-show=\"tab2Data.dateWiseContracts && selectedResult && !isInsurer\"><label for=\"\">Select corporates</label><div class=\"addTime\"><a href=\"\" class=\"btn btn-default btn-block addTimeBtn\" ng-click=\"showTimeAdd ? showTimeAdd = false : showTimeAdd = true\" style=\"text-align:left;\"><i class=\"fa fa-plus\"></i> <span ng-hide=\"getCount() > 0\">Select Corporates</span><span ng-show=\"getCount() > 0\">{{getCount()}} Selected</span></a><div class=\"select-corp\" ng-show=\"showTimeAdd\"><div class=\"arrow\"></div><h3 class=\"popover-title\"><span><a href=\"\" ng-click=\"selectAll(true)\" class=\"btn btn-xs btn-default\">Select all</a> <a href=\"\" ng-click=\"selectAll(false)\" class=\"btn btn-xs btn-default\">Remove all</a> <a href=\"\" ng-hide=\"getCount() == 0\" ng-click=\"showTimeAdd = false\" class=\"alert-primary pull-right btn btn-xs btn-default\"><i class=\"fa fa-check\"></i> Done</a> <a href=\"\" ng-show=\"getCount() == 0\" ng-click=\"showTimeAdd = false\" class=\"alert-danger pull-right btn btn-xs btn-default\"><i class=\"fa fa-times\"></i></a> <em class=\"pull-right em-custom\">{{getCount()}} Selected</em></span> <input type=\"text\" class=\"form-control\" ng-model=\"searchCorporates\" placeholder=\"Search Corporates\"></h3><div class=\"popover-content\"><div class=\"corp-content\"><div class=\"item\" ng-repeat=\"corp in corporatesForStatus | filter:searchCorporates\" ng-class=\"corp.isSelected ? \'checked\': \'\'\"><span ng-click=\"corp.isSelected = !corp.isSelected\"><input type=\"checkbox\" ng-model=\"corp.isSelected\" class=\"hide\"> <a href=\"\" ng-show=\"corp.isSelected\"><i class=\"fa fa-check-square-o\"></i></a> <a href=\"\" ng-show=\"!corp.isSelected\"><i class=\"fa fa-square-o\"></i></a> {{corp.entityName}}</span></div></div></div></div></div></div><div class=\"col-md-3 p-r-0\" ng-show=\"tab2Data.dateWiseContracts\"><label for=\"fromDate\">From status</label><select name=\"\" ng-model=\"tab2Data.ms\" id=\"tab2Data.changesource\" class=\"form-control\"><option value=\"\">Select status</option><option value=\"{{ms.id}}\" ng-repeat=\"ms in statusList\">{{ms.entityName}}</option></select></div><div class=\"col-md-3 p-r-0\"><label for=\"dateType\">Date type</label><select id=\"dateType\" class=\"form-control\" ng-model=\"tab2Data.dateType\"><option disabled=\"true\" value=\"\">Select a type</option><option value=\"apptdate\">Appointment date</option><option value=\"createddate\">Creation date</option></select></div><div class=\"col-md-3 p-r-0 m-t-10\" ng-show=\"tab2Data.dateWiseContracts && tab2Data.dateType\"><label for=\"fromDate\">From date</label><div class=\"input-group\"><input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" placeholder=\"Start Date\" uib-datepicker-popup=\"{{format}}\" ng-model=\"tab2Data.misstartdate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-3 p-r-0 m-t-10\" ng-show=\"tab2Data.dateWiseContracts && tab2Data.dateType\"><label for=\"fromDate\">To date</label><div class=\"input-group\"><input id=\"datetimeEnd\" readonly=\"\" type=\"text\" class=\"form-control\" placeholder=\"End Date\" uib-datepicker-popup=\"{{format}}\" ng-model=\"tab2Data.misenddate\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-9 p-r-0 m-t-10\" ng-show=\"tab2Data.dateWiseContracts && tab2Data.dateType\"><span style=\"color: red;\">Note: Select a date range of up to 3 months to download the MIS. Longer ranges will display no data.</span></div><div class=\"col-md-3 p-r-0 m-t-10\" ng-show=\"tab2Data.dateWiseContracts\" style=\"float:right\"><button class=\"btn btn-primary btn-sm btn-block\" ng-click=\"corporateStatusDetails()\">Load MIS</button></div></div><div class=\"row m-t-10 tab2-cust\" ng-show=\"statusDetails && statusDetails.length>0\"><button class=\"btn btn-primary pull-right\" data-toggle=\"modal\" data-target=\"#downloadReports\" ng-click=\"checkAllRecords(false)\">Download</button><angular-tab appointmentlist=\"statusDetails\" tabname=\"\'misReports\'\" tabtype=\"\'misReports\'\"></angular-tab></div></div></div><div class=\"modal fade\" id=\"downloadReports\" tabindex=\"-1\" data-keyboard=\"false\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog modal-sm\" style=\"width: 450px;\" ng-if=\"!showDownloadWithProfile\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"resetData()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\" style=\"color: #005da2;\">Select fields to download</h4><hr><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12\"><span ng-click=\"maincheck.isCheckbox = !maincheck.isCheckbox; checkAllRecords(maincheck.isCheckbox)\"><input type=\"checkbox\" ng-model=\"maincheck.isCheckbox\" class=\"hide\"> <a href=\"\" ng-show=\"maincheck.isCheckbox\"><i class=\"fa fa-check-square-o\"></i></a> <a href=\"\" ng-show=\"!maincheck.isCheckbox\"><i class=\"fa fa-square-o\"></i></a> <b>{{isCheckAll}}</b></span> <button class=\"btn btn-success pull-right btn-xs\" filename=\"{{ filename }}.csv\" value=\"Download\" ng-csv=\"downloadselected\" csv-header=\"feildsTitles\" ng-show=\"isDownload\" title=\"Download\">Download</button> <button class=\"btn btn-primary pull-right btn-xs\" ng-click=\"downloadFinalReports()\" ng-show=\"count>0 && showDone\">Done</button> <b class=\"badge pull-right\" style=\"margin-right:2px;\">Record selected {{count}}/{{totalRecords}}</b><div class=\"input-group\" style=\"margin-top:10px;\"><input type=\"text\" ng-model=\"maincheck.searchRecord\" class=\"form-control\" placeholder=\"start typing...\"> <span class=\"input-group-btn\"><button class=\"btn btn-secondary\" ng-click=\"clearSearchRecord()\">x</button></span></div></div></div></div></div><div class=\"modal-body\"><div class=\"row\" ng-repeat=\"rep in listToDownload | filter:maincheck.searchRecord\"><div class=\"col-md-12\"><div class=\"col-md-12\" style=\"margin-top:10px;\"><span ng-click=\"rep.selectedRecord = !rep.selectedRecord; checkAIndvRecords(rep)\"><input type=\"checkbox\" ng-model=\"rep.selectedRecord\" class=\"hide\"> <a href=\"\" ng-show=\"rep.selectedRecord\"><i class=\"fa fa-check-square-o\"></i></a> <a href=\"\" ng-show=\"!rep.selectedRecord\"><i class=\"fa fa-square-o\"></i></a> {{rep.name}}<br></span></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div><div class=\"modal-dialog modal-sm\" style=\"width: 450px;\" ng-if=\"showDownloadWithProfile\"><div class=\"container\"><div class=\"modal-content\"><div class=\"modal-header\" style=\"border-bottom: none\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"resetData()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\" style=\"color: #005da2;\">Select fields to download</h4><hr><div class=\"row\"><div class=\"col-md-12\"><ul class=\"nav nav-tabs\" style=\"margin-bottom: 10px;\" ng-init=\"downloadOptionSelected(\'manual\')\"><li class=\"active\"><a data-toggle=\"tab\" href=\"#manualOptions\" ng-click=\"downloadOptionSelected(\'manual\')\">Manual Selection</a></li><li><a data-toggle=\"tab\" href=\"#profileOptions\" ng-click=\"downloadOptionSelected(\'configured\')\">Pre-Configured Profile</a></li></ul></div></div><div class=\"row\" ng-show=\"manualSelectCheck\"><div class=\"col-md-12\"><div class=\"col-md-12\"><span ng-click=\"maincheck.isCheckbox = !maincheck.isCheckbox; checkAllRecords(maincheck.isCheckbox)\"><input type=\"checkbox\" ng-model=\"maincheck.isCheckbox\" class=\"hide\"> <a href=\"\" ng-show=\"maincheck.isCheckbox\"><i class=\"fa fa-check-square-o\"></i></a> <a href=\"\" ng-show=\"!maincheck.isCheckbox\"><i class=\"fa fa-square-o\"></i></a> <b>{{isCheckAll}}</b></span> <button class=\"btn btn-success pull-right btn-xs\" filename=\"{{ filename }}.csv\" value=\"Download\" ng-csv=\"downloadselected\" csv-header=\"feildsTitles\" ng-show=\"isDownload\" title=\"Download\">Download</button> <button class=\"btn btn-primary pull-right btn-xs\" ng-click=\"downloadFinalReports()\" ng-show=\"count>0 && showDone\">Done</button> <b class=\"badge pull-right\" style=\"margin-right:2px;\">Record selected {{count}}/{{totalRecords}}</b><div class=\"input-group\" style=\"margin-top:10px;\"><input type=\"text\" ng-model=\"maincheck.searchRecord\" class=\"form-control\" placeholder=\"start typing...\"> <span class=\"input-group-btn\"><button class=\"btn btn-secondary\" ng-click=\"clearSearchRecord()\">x</button></span></div></div></div></div><div class=\"row\" ng-show=\"preConfigPofilecheck\"><div class=\"col-md-12\" style=\"text-align: center;\" ng-show=\"!preConfigProfile.length\"><a class=\"\" ng-click=\"createEditProfile()\" style=\"cursor:pointer;\">Configure your profile</a></div><div class=\"col-md-12\" ng-show=\"preConfigProfile.length && !createProfile && !editProfile\"><span class=\"pull-right\" ng-show=\"!selectedProfile.selectedRecord\"><button class=\"btn btn-primary btn-xs\" ng-click=\"createEditProfile()\">Create Profile</button></span> <span class=\"pull-right\" ng-show=\"selectedProfile.selectedRecord\"><button class=\"btn btn-primary btn-xs\" filename=\"{{ filename }}.csv\" value=\"Download\" ng-csv=\"downloadselectedFrmProfile\" csv-header=\"feildsTitlesFrmProfile\" title=\"Download\">Download Report</button> <button class=\"btn btn-primary btn-xs\" ng-click=\"createEditProfile()\">Edit Profile</button> <button class=\"btn btn-primary btn-xs\" ng-click=\"deleteProfile()\">Delete Profile</button></span></div><div class=\"col-md-12\" ng-show=\"editProfile\"><span><b>{{editProfileObj.profilename}}</b></span> <span class=\"pull-right\"><button class=\"btn btn-primary btn-xs\" ng-click=\"updateDownloadProfile()\">Save</button> <button class=\"btn btn-default btn-xs\" ng-click=\"cancelUpdateProfile()\">Cancel</button></span></div><div class=\"col-md-12\" ng-show=\"createProfile\" style=\"display: flex;flex-direction: row;\"><span><input class=\"form-control\" type=\"text\" style=\"width: 250px;\" placeholder=\"Enter Unique Profile name\" ng-model=\"createProfileObj.profilename\"></span> <span class=\"pull-right\" style=\"margin-top: 5px;margin-left: 40px;\"><button class=\"btn btn-primary btn-xs\" ng-click=\"updateDownloadProfile()\">Save</button> <button class=\"btn btn-default btn-xs\" ng-click=\"cancelUpdateProfile()\">Cancel</button></span></div><div class=\"col-md-12\" ng-show=\"profileUpdateErrMsg && (createProfile || editProfile)\"><span class=\"text-danger\" style=\"font-size:12px;\"><b>{{profileUpdateErrMsg}}</b></span></div></div></div><div class=\"modal-body tab-content\"><div class=\"row tab-pane fade in active\" id=\"manualOptions\"><div class=\"col-md-12\" ng-repeat=\"rep in listToDownload | filter:maincheck.searchRecord\"><div class=\"col-md-12\" style=\"margin-top:10px;\"><span ng-click=\"rep.selectedRecord = !rep.selectedRecord; checkAIndvRecords(rep)\"><input type=\"checkbox\" ng-model=\"rep.selectedRecord\" class=\"hide\"> <a href=\"\" ng-show=\"rep.selectedRecord\"><i class=\"fa fa-check-square-o\"></i></a> <a href=\"\" ng-show=\"!rep.selectedRecord\"><i class=\"fa fa-square-o\"></i></a> {{rep.name}}<br></span></div></div></div><div class=\"row tab-pane fade in\" id=\"profileOptions\"><div class=\"col-md-12\" ng-show=\"!editProfile && !createProfile && preConfigProfile.length\"><span style=\"font-size:12px;color:grey\">Please select from below to download,edit or delete a profile</span><div class=\"col-md-12\" style=\"margin-top:10px;\" ng-repeat=\"profile in preConfigProfile\"><span ng-click=\"profileSelected(profile)\"><a href=\"\" ng-show=\"profile.selectedRecord\"><i class=\"fa fa-check-square-o\"></i></a> <a href=\"\" ng-show=\"!profile.selectedRecord\"><i class=\"fa fa-square-o\"></i></a> {{profile.profilename}}<br></span><div class=\"col-md-12\" ng-show=\"profile.optArr.length && profile.selectedRecord\"><div class=\"col-md-12\" style=\"margin-top:10px;\" ng-repeat=\"opt in profile.optArr\"><span><a href=\"\" ng-disabled=\"true\"><i class=\"fa fa-check-square-o\"></i></a> {{opt.name}}<br></span></div></div></div></div><div class=\"col-md-12\" ng-show=\"createProfile || editProfile\"><span style=\"font-size:12px;color:grey\">Please manage your selection and then save</span><div class=\"col-md-12\" style=\"margin-top:10px;\" ng-repeat=\"allOpt in editProfileObj.allOptArr\" ng-show=\"editProfile\"><span ng-click=\"allOpt.selectedRecord = !allOpt.selectedRecord\"><input type=\"checkbox\" ng-model=\"allOpt.selectedRecord\" class=\"hide\"> <a href=\"\" ng-show=\"allOpt.selectedRecord\"><i class=\"fa fa-check-square-o\"></i></a> <a href=\"\" ng-show=\"!allOpt.selectedRecord\"><i class=\"fa fa-square-o\"></i></a> {{allOpt.name}}<br></span></div><div class=\"col-md-12\" style=\"margin-top:10px;\" ng-repeat=\"allOpt in createProfileObj.allOptArr\" ng-show=\"createProfile\"><span ng-click=\"allOpt.selectedRecord = !allOpt.selectedRecord\"><input type=\"checkbox\" ng-model=\"allOpt.selectedRecord\" class=\"hide\"> <a href=\"\" ng-show=\"allOpt.selectedRecord\"><i class=\"fa fa-check-square-o\"></i></a> <a href=\"\" ng-show=\"!allOpt.selectedRecord\"><i class=\"fa fa-square-o\"></i></a> {{allOpt.name}}<br></span></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div></div>");
$templateCache.put("app/modules/medicalProcess/medicalProcess.html","<div class=\"container medicalProcess col-md-12 col-sm-12 col-xs-12\"><form #medicalprocessform=\"\" class=\"contentPart\"><h1>Enter OTP</h1><input class=\"col-md-9 col-sm-9 col-xs-12 input-box\" name=\"otp\" id=\"otp\" type=\"text\" placeholder=\"Enter OTP\" ng-model=\"OTP\" required=\"\"> <button class=\"col-md-2 col-sm-2 col-xs-4 btn btn-lg btn-primary submit-button\" ng-click=\"submitOTPData()\">Submit</button></form></div>");
$templateCache.put("app/modules/newAdmission/newAdmission.html","<div><div><aarogya-form ng-if=\"showAarogya\"></aarogya-form></div></div><div><div><new-admission ng-if=\"newadmission\" dataobj=\"\" source=\"\'newAdmission\'\"></new-admission></div></div>");
$templateCache.put("app/modules/newAdmission/newAdmission_Cataract.html","<div><div><aarogya-form ng-if=\"showAarogya\"></aarogya-form></div></div><div><div><new-admission-cataract ng-if=\"newadmission\" dataobj=\"\" source=\"\'newAdmission\'\"></new-admission-cataract></div></div>");
$templateCache.put("app/modules/newappointment/Insurer_esales.html","<style>\n  .form-create .form-control {\n    margin-bottom: 15px;\n    height: 35px;\n  }\n\n  #map {\n    height: 100%;\n  }\n\n  /* Optional: Makes the sample page fill the window. */\n  html,\n  body {\n    height: 100%;\n    margin: 0;\n    padding: 0;\n  }\n\n  #description {\n    font-family: Roboto;\n    font-size: 15px;\n    font-weight: 300;\n  }\n\n  #infowindow-content .title {\n    font-weight: bold;\n  }\n\n  #infowindow-content {\n    display: none;\n  }\n\n  #map #infowindow-content {\n    display: inline;\n  }\n\n  .pac-card {\n    margin: 10px 10px 0 0;\n    border-radius: 2px 0 0 2px;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    outline: none;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n    background-color: #fff;\n    font-family: Roboto;\n  }\n\n  #pac-container {\n    padding-bottom: 12px;\n    margin-right: 12px;\n  }\n\n  .pac-controls {\n    display: inline-block;\n    padding: 5px 11px;\n  }\n\n  .pac-controls label {\n    font-family: Roboto;\n    font-size: 13px;\n    font-weight: 300;\n  }\n\n  #pac-input {\n    background-color: #fff;\n    font-family: Roboto;\n    font-size: 15px;\n    font-weight: 300;\n    margin-left: 12px;\n    padding: 0 11px 0 13px;\n    text-overflow: ellipsis;\n    width: 400px;\n  }\n\n  #pac-input:focus {\n    border-color: #4d90fe;\n  }\n\n  #title {\n    color: #fff;\n    background-color: #4d90fe;\n    font-size: 25px;\n    font-weight: 500;\n    padding: 6px 12px;\n  }\n\n  #target {\n    width: 345px;\n  }\n\n  .slideBox {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 0;\n    opacity: 0;\n    visibility: hidden;\n    height: 100%;\n    z-index: 9999;\n    background: rgba(0, 0, 0, .5);\n  }\n\n  .slideBox .slideContent {\n    position: fixed !important;\n    overflow: auto;\n    background: #fff;\n    right: 0;\n    top: 0 !important;\n    bottom: 0 !important;\n    margin: 0 !important;\n    height: 100%;\n    max-width: 640px;\n    width: 80% !important;\n  }\n\n  .slideBox.in {\n    visibility: visible;\n    opacity: 1;\n    width: 100%;\n    transition: all .3s ease;\n  }\n\n  .multiSelectJustified .multiselect-parent {\n    width: 100%;\n  }\n\n  .multiSelectJustified .btn {\n    width: 100%;\n    text-align: left;\n  }\n\n  .multiSelectJustified .btn .caret {\n    float: right;\n    margin-top: 8px;\n  }\n</style><div class=\"row active-appointments\"><div class=\"col-md-12\"><div id=\"testsPerformed\"><div class=\"form-create form-create-first card\" style=\"background-color: #F7F7F6;padding: 16px 20px 30px;box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\"><div class=\"form-signin\"><div class=\"row\" ng-if=\"isInsurer_CallCentre\"><div class=\"col pull-right\" style=\"word-spacing: 25px;\"><span ng-show=\"!customersDND\" ng-click=\"markingDND(\'customer\',true)\"><a><i class=\"fa fa-bell\" uib-tooltip=\"DND Customer\"></i></a></span> <span ng-show=\"customersDND\" ng-click=\"markingDND(\'customer\',false)\"><a><i class=\"fa fa-bell-slash\" uib-tooltip=\"DND Customer activated\"></i></a></span> <span ng-show=\"!agentCustomersDND\" style=\"margin-right: 50px;\" ng-click=\"markingDND(\'both\',true)\"><a><i class=\"fa fa-bell\" uib-tooltip=\"DND\"></i></a></span> <span ng-show=\"agentCustomersDND\" style=\"margin-right: 50px;\" ng-click=\"markingDND(\'both\',false)\"><a><i class=\"fa fa-bell-slash\" uib-tooltip=\"DND activated\"></i></a></span></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Customer name <span class=\"text-danger\">*</span></label> <input pattern=\"[a-zA-Z\\s]+\" placeholder=\"Customer Name\" type=\"text\" id=\"employeeName\" class=\"form-control\" ng-model=\"employee.name\"></div><div class=\"col-md-4\"><label for=\"\">Application No <span class=\"text-danger\">*</span></label> <input placeholder=\"Application No\" type=\"text\" id=\"employeeId\" class=\"form-control\" ng-model=\"client.clientCode\"></div><div class=\"col-md-4\"><label for=\"\">Annual premium</label> <input placeholder=\"Enter annual premium\" name=\"annualPremium\" type=\"number\" id=\"annualPremium\" class=\"form-control\" ng-model=\"employee.annualPremium\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Email address</label> <input placeholder=\"Email id\" type=\"email\" id=\"emailid\" class=\"form-control\" ng-model=\"employee.email\"></div><div class=\"col-md-4\"><label for=\"\">Gender</label><select ng-model=\"employee.gender\" id=\"gender\" class=\"form-control\"><option value=\"\" selected=\"\">Select Gender</option><option value=\"Male\">Male</option><option value=\"Female\">Female</option></select></div><div class=\"col-md-4\"><label for=\"\">Primary mobile number</label> <input placeholder=\"Mobile number\" type=\"text\" id=\"mobilenumber\" class=\"form-control\" ng-model=\"employee.mobileNumber\"></div><div class=\"col-md-4\"><label for=\"\">Alternate mobile number</label> <input placeholder=\"Enter alternate mobile no\" type=\"text\" id=\"sumAssured\" class=\"form-control\" ng-model=\"altMobile\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Group/Individual</label><select ng-model=\"sumassuredetail.grpIndv\" class=\"form-control\"><option value=\"individual\">Individual</option><option value=\"group\">Group</option></select></div><div class=\"col-md-4\"><label for=\"\">Sum assured</label> <input placeholder=\"Enter sum assured\" type=\"text\" id=\"sumAssured\" class=\"form-control\" ng-model=\"sumassuredetail.sumAssured\"></div><div style=\"float: right; margin-right: 20px;\"><button type=\"button\" style=\"margin-top: 25px;\" class=\"btn btn-info btn-md\" data-toggle=\"modal\" data-target=\"#additionalInfoModal\"><i class=\"fa fa-plus\"></i></button></div></div><div class=\"row\"><div class=\"col-md-6\" ng-show=\"selectedSource.id==\'1024195\'\"><label for=\"\">Paid by</label><br><input placeholder=\"Paid by\" type=\"checkbox\" name=\"\" id=\"\" ng-model=\"notpaidByCoverFox\" ng-click=\"changePaidOption($event)\"> Same as Insurer selected (else Coverfox will be asked to pay)</div></div></div></div><div class=\"form-create card\" style=\"background-color: #F7F7F6;padding: 16px 20px 30px;margin-bottom: 10px;padding-top: 20px;margin-top: 20px;box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\"><div class=\"form-signin\"><table class=\"table table-hover\" ng-show=\"showData.TestDetails.length>0\"><thead><th>Test name</th><th>Appointment date & time</th><th>Provider</th></thead><tbody><tr ng-repeat=\"test in showData.TestDetails\"><td>{{test.TestName}}</td><td>{{compareDate(test.AppointmentDate)}} | {{test.AppointmentTime}}</td><td>{{test.LabAddress}}</td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Select appropriate package</label><div ng-dropdown-multiselect=\"\" options=\"packages\" extra-settings=\"example2settings\" selected-model=\"selectedPackageForAdvance\" translation-texts=\"example5customTexts\" checkboxes=\"true\" style=\"margin-bottom:15px;\" class=\"multiSelectJustified\"></div></div><div class=\"col-md-3\" ng-show=\"selectedPackageForAdvance.length>0\"><label for=\"\">View packages</label> <button class=\"btn btn-info btn-block\" data-toggle=\"modal\" data-target=\"#selectedPacakgesList\">View Details</button></div><div class=\"col-md-3\"><label for=\"\">Select visit type</label><select class=\"form-control\" ng-model=\"client.visitType\" ng-change=\"visitTypeChange(client.visitType)\" required=\"\"><option value=\"\">Select visit type</option><option value=\"Appointment\">Centre visit</option><option value=\"Home_Visit\">Home visit</option></select></div></div><div class=\"form-create card\" ng-if=\"client.visitType===\'Home_Visit\'\" style=\"padding-bottom:10px;\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-12\"><div ng-show=\"client.visitType===\'Home_Visit\'\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Address line 1</label> <input placeholder=\"Enter address line 1..\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline1\" ng-required=\"client.visitType===\'Home_Visit\'\"></div><div class=\"col-md-6\"><label for=\"\">Address line 2</label> <input placeholder=\"Enter address line 2..\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline2\" ng-required=\"client.visitType===\'Home_Visit\'\"></div><div class=\"col-md-6\"><label for=\"\">Pin Code</label> <input placeholder=\"Enter Pincode\" type=\"number\" class=\"form-control\" ng-model=\"client.clientPincode\" ng-required=\"client.visitType===\'Home_Visit\'\"></div></div></div></div></div></div></div><div class=\"form-create card\" ng-show=\"selectedPackageForAdvance.length > 0\" style=\"padding-bottom:10px;\"><div class=\"form-signin\"><div class=\"row\" ng-if=\"client.visitType !==\'Home_Visit\' && client.visitType\"><div class=\"col-md-4\"><div class=\"btn-group btn-group-justified\" style=\"margin-bottom:15px;\"><label class=\"btn btn-primary\" ng-model=\"radioModel\" uib-btn-radio=\"\'Left\'\" ng-click=\"DCSelection(\'advance\')\">Advance DC selection</label> <label class=\"btn btn-primary\" ng-model=\"radioModel\" uib-btn-radio=\"\'Middle\'\" ng-click=\"DCSelection(\'manula\')\">Manual DC selection</label></div></div><div class=\"col-md-4\" ng-show=\"isPackageSelectionAdvance\"><select name=\"\" class=\"form-control\" ng-options=\"distance as distance.value for distance in distances\" ng-model=\"distance\" ng-change=\"changeDistance(distance)\"><option value=\"\">Select radius</option></select></div><div class=\"col-md-4\" ng-show=\"isPackageSelectionAdvance\"><input type=\"text\" class=\"form-control\" gm-places-autocomplete=\"\" ng-model=\"locationName.autocomplete\"></div></div><div class=\"row\" ng-if=\"isPackageSelectionManual || isPackageSelectionAdvance || client.visitType ===\'Home_Visit\' || client.visitType ===\'Appointment\'\" style=\"margin-top: 10px; margin-left: 4px;\"><div class=\"row\"><div class=\"col\"><div class=\"col-sm-4 dateBox\"><label for=\"\">First preference</label> <input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"manual.firstDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" style=\"width: 140px;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\" style=\"margin-left: 138px; margin-top: -83px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"col-sm-4 dateBox\"><label for=\"\">Second preference</label> <input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"manual.secondDate\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" style=\"width: 140px;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\" style=\"margin-left: 138px; margin-top: -83px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"col-sm-2 p-l-0 timeBox\" style=\"margin-left: 210px; margin-top: -102px;\"><div uib-timepicker=\"\" ng-model=\"manual.firstTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div><div class=\"col-sm-2 p-l-0 timeBox\" style=\"margin-left: 210px; margin-top: -102px;\"><div uib-timepicker=\"\" ng-model=\"manual.secondTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div></div></div><div class=\"row\" ng-if=\"isPackageSelectionManual && client.visitType !==\'Home_Visit\'\" style=\"margin-top: 10px; margin-bottom: 60PX;\"><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"current.newStateId\" ng-change=\"loadCitiesNew(current.newStateId)\"><option value=\"\">Select state</option></select></div><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"newCityId\" ng-change=\"loadLocationsNew(newCityId)\"><option value=\"\">Select city</option></select></div><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"newSubLocationId\" ng-change=\"loadDcForAllPackages(newSubLocationId)\"><option value=\"\">Select locality</option></select></div><div class=\"col-md-3\"><select name=\"preferreddc1\" id=\"firstDCIdPreEmp\" ng-model=\"client.preferredDC1\" class=\"form-control\" ng-options=\"dc as dc.entityName for dc in diagnosticCentres\" ng-change=\"selectedDcFromMap(client.preferredDC1)\"><option value=\"\">Select diagnostic centre</option></select></div></div><div class=\"row\" ng-if=\"isPackageSelectionManual && client.visitType !== \'Home_Visit\'\" style=\"margin-top: 10px; margin-bottom: 30PX;\"><div class=\"col-md-12\"><button ng-disabled=\"!manual.firstDate || !client.preferredDC1 || !client.visitType || !client.clientCode || !employee.mobileNumber || !employee.name || !employee.email\" ng-click=\"bookAppointmentDate(manual.firstDate, manual.secondDate, manual.firstTime, manual.secondTime)\" class=\"btn btn-primary pull-right\">Add to cart</button></div></div></div><div class=\"row\" ng-if=\"client.visitType === \'Home_Visit\'\" style=\"margin-top: 10px; margin-bottom: 30PX;\"><div class=\"col-md-12\"><button ng-disabled=\"!manual.firstDate || !client.addressline1 || !client.addressline2 || !client.visitType || !client.clientCode || !employee.mobileNumber || !employee.name || !employee.email\" ng-click=\"bookAppointmentDate(manual.firstDate, manual.secondDate, manual.firstTime, manual.secondTime)\" class=\"btn btn-primary pull-right\">Add to cart</button></div></div></div><div class=\"row\" ng-if=\"markerArray.length >0 && isPackageSelectionAdvance\"><div class=\"col-md-12\"><ui-gmap-google-map center=\"map.center\" control=\"\" zoom=\"map.zoom\" bounds=\"map.bounds\" draggable=\"true\" options=\"map.options\"><ui-gmap-circle center=\"map.center\" stroke=\"map.stroke\" fill=\"map.fill\" radius=\"map.radius\" visible=\"map.visible\" geodesic=\"c.geodesic\" editable=\"c.editable\" draggable=\"map.draggable\" clickable=\"map.clickable\"><ui-gmap-marker models=\"randomMarkers1\" coords=\"map.center\" idkey=\"\"><i class=\"fa fa-user\"></i></ui-gmap-marker><ui-gmap-marker ng-repeat=\"marker in markerArray\" click=\"selectedDcFromMap(marker, $event)\" models=\"randomMarkers\" events=\"map.markersEvents\" coords=\"marker.coords\" idkey=\"marker.id\"><ui-gmap-window options=\"windowOpt\" closeclick=\"map.window.closeClick(marker)\" show=\"marker.visible\" templateurl=\"\'/app/modules/newappointment/windowContent.html\'\" templateparameter=\"windowParams\"></ui-gmap-window></ui-gmap-marker></ui-gmap-circle></ui-gmap-google-map></div></div><div class=\"row\" ng-if=\"markerArray.length ===0 && isMarkerArray && selectedPackageForAdvance.length !== 0\"><div class=\"col-md-12\"><div class=\"text-center\" style=\"margin-bottom: 30px; padding-top: 20px; background-color: #e0dede; padding-bottom: 18px;\">No Diagnostic Centre found.</div></div></div></div></div><div class=\"form-create card\" ng-show=\"showAddTestBox\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Select visit type</label><select class=\"form-control\" ng-model=\"client.visitType\" ng-change=\"visitTypeChange(client.visitType)\" required=\"\"><option value=\"\">Select visit type</option><option value=\"Appointment\">Centre visit</option><option value=\"Home_Visit\">Home visit</option></select></div><div class=\"col-md-6\"><label for=\"\">Select an individual test *</label><select class=\"form-control\" ng-model=\"testSelected\" ng-options=\"test as test.packageName for test in tests\" ng-change=\"selectTest(testSelected)\"><option value=\"\">Select a test</option></select></div></div><hr><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Date & time - first preference *</label><p class=\"input-group\"><input placeholder=\"Date & Time - First Preference\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.firstPrefTime\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\" style=\"margin-top: -15px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-4\"><label for=\"\">Date & time - first preference *</label><p class=\"input-group\"><input placeholder=\"Date & Time - First Preference\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.firstPrefTime\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\" style=\"margin-top: -15px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-4\"><div uib-timepicker=\"\" ng-model=\"userTime.firstAppointmentTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><strong>Please choose the diagnostic centre</strong><hr style=\"margin:5px 0\"><div class=\"row\"><div class=\"col-md-3\"><label for=\"\">Select a state</label><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"current.newStateId\" ng-change=\"loadCities(current.newStateId)\"><option value=\"\">Select a state</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a city</label><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"newCityId\" ng-change=\"loadLocations(newCityId)\"><option value=\"\">Select a state</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a locality</label><select name=\"\" class=\"form-control\" ng-options=\"location as location.lookUpValue for location in locations\" ng-model=\"newLocationId\" ng-change=\"loadSubLocations(newLocationId)\"><option value=\"\">Select a state</option></select></div><div class=\"col-md-3\"><label for=\"\">Select sub locality</label><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"newSubLocationId\" ng-change=\"loadDCs(newSubLocationId)\"><option value=\"\">Select a state</option></select></div></div><div ng-show=\"client.visitType==\'Home_Visit\'\"><strong>Address for home visit</strong><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Address line 1</label> <input placeholder=\"Address Line 1\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline1\" ng-required=\"client.visitType==\'Home_Visit\'\"></div><div class=\"col-md-6\"><label for=\"\">Address line 2</label> <input placeholder=\"Address Line 2\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline2\" ng-required=\"client.visitType==\'Home_Visit\'\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"\">Select a diagnostic centre</label><select name=\"preferreddc1\" id=\"firstDCIdPreEmp\" ng-model=\"client.preferredDC1\" class=\"form-control\" ng-options=\"dc as dc.entityName for dc in diagnosticCentres\" ng-change=\"changeDC(client.preferredDC1, 1)\"><option value=\"\">Select a diagnostic centre</option></select></div></div><div class=\"row\"><div class=\"col-md-3\"></div><div class=\"col-md-3\"></div><div class=\"col-md-3\"></div><div class=\"col-md-3\"><button class=\"btn btn-block btn-primary\" ng-click=\"addToCart()\">Add to cart</button></div></div></div></div></div></div><div class=\"slideBox\" ng-class=\"isCostomerDetails ? \'in\': \'\'\"><div class=\"slideContent\"><div class=\"modal-header\"><a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"isCostomerDetails=!isCostomerDetails\"><span aria-hidden=\"true\">&times;</span></a><h4 class=\"modal-title\">Customer additonal details</h4></div><div class=\"modal-body\"><h4>Few details for your refrence</h4><table><tr><td style=\"width: 140px;\">Name:</td><td><b>{{getDetailsHelp.name}}</b></td></tr><tr><td>Address:</td><td><b>{{getDetailsHelp.addressLine1}}</b></td></tr><tr><td>City:</td><td><b>{{getDetailsHelp.city}}</b></td></tr><tr><td>State:</td><td><b>{{getDetailsHelp.state}}</b></td></tr><tr><td>Mobile number:</td><td><b>{{getDetailsHelp.mobileNumber}}</b></td></tr></table><h4 style=\"margin-top: 30px;\" ng-if=\"getDetailsHelpTestDetails.length >0\">Test details for your refrence</h4><table ng-repeat=\"details in getDetailsHelpTestDetails\"><tr><td style=\"width: 140px;\">Name:</td><td><b>{{details.testName}}</b></td></tr><tr><td>Description:</td><td><b>{{details.testDesc}}</b></td></tr><tr><td>Visit type:</td><td><b>{{details.visitType}}</b></td></tr><tr ng-if=\"details.appointmentDate\"><td>Appointment date:</td><td><b>{{compareDate(details.appointmentDate)}}</b></td></tr></table></div></div></div><div class=\"slideBox\" ng-class=\"isCart ? \'in\': \'\'\"><div class=\"slideContent\"><div class=\"modal-header\"><a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"closeCart()\"><span aria-hidden=\"true\">&times;</span></a><h4 class=\"modal-title\">You are booking packages for <span style=\"color:#4d90fe;\">{{employee.name}}</span><br><span style=\"font-size:14px;\">at <b>{{selectedDcFromDavanceSearch.name}}</b>, {{selectedDcFromDavanceSearch.entityAddress}}</span></h4></div><div class=\"modal-body\"><div class=\"cartEmpty\" ng-show=\"cartEmpty\"><div class=\"empty text-center\">Cart is empty</div></div><div id=\"cartItems\" ng-show=\"!cartEmpty\"><div ng-repeat=\"item in orderObj.orderItems\"><div class=\"row package-item\"><div class=\"col-md-10\">{{item.productName}}</div><div class=\"col-md-2 text-right\"><button class=\"btn btn-xs btn-block btn-danger delete\" value=\"\" id=\"{{item.productId}}\" ng-click=\"removeOrderItem(item, event)\">Remove</button></div></div><hr></div></div><div class=\"form-create card\" ng-show=\"showPaid\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"paid\">Paid</label> <input type=\"radio\" id=\"paid\" name=\"optradio\" checked=\"checked\" value=\"\" ng-click=\"paid=true\"></div><div class=\"col-md-6\"><label for=\"unpaid\">Unpaid</label> <input type=\"radio\" id=\"unpaid\" name=\"optradio\" value=\"\" ng-click=\"paid=false\"></div></div><strong>Transaction details</strong><hr><div class=\"alert alert-danger\" ng-show=\"showPaid && paid\" role=\"alert\">Since this is a paid package, You need to fill the following <span class=\"strong\">Transaction details</span></div><div class=\"alert alert-danger\" ng-show=\"showPaid && !paid\" role=\"alert\">Unpaid orders will be collected in \"UnConfirmed Orders\" bucket. Once their availability is confirmed with DC, they will be approved and payment link will be sent to the user. These orders moves to active appointments, only after user makes the payment</div><div ng-show=\"showPaid && paid\"><label for=\"\">UTR number *</label> <input id=\"txnNumberPreEmp\" class=\"form-control\" ng-model=\"txn.txnNumber\"></div></div></div><button class=\"btn btn-primary btn-block\" ng-click=\"checkDuplicacy()\" ng-show=\"!cartEmpty && orderObj.orderItems.length >0\">Create Appointment</button></div></div></div><div class=\"modal fade\" id=\"selectedPacakgesList\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\" style=\"padding:0 15px;\"><a href=\"\"><span class=\"pull-right\" data-dismiss=\"modal\"><b>X</b></span></a><h4>Selected Packages</h4></div><div class=\"modal-body\" id=\"chooseDCBody\"><ul><li ng-repeat=\"item in selectedPackageForAdvance\">{{item.packageName}}<br></li></ul></div></div></div></div><div class=\"modal fade\" id=\"additionalInfoModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Add Additional Details</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-5\"><label for=\"additional\"><select style=\"width: 135%\" class=\"form-control\" id=\"additional\" name=\"additional\" ng-model=\"field.fieldName\"><option disabled=\"true\" value=\"\">Select</option><option ng-repeat=\"item in additionalFieldList\" value=\"{{item}}\">{{item}}</option></select></label></div><div class=\"col-md-5\"><label for=\"fieldValue\"><input style=\"width: 120%\" class=\"form-control\" ng-disabled=\"!field.fieldName\" name=\"fieldValue\" id=\"fieldValue\" ng-model=\"field.fieldValue\" placeholder=\"Enter {{field.fieldName}}\"></label></div><div class=\"col-md-2\" style=\"float: right\"><button class=\"btn btn-primary btn-md\" ng-disabled=\"!field.fieldValue\" ng-click=\"addToAdditionDetails()\" style=\"margin:0;\">Add</button></div></div><div style=\"margin: 20px; margin-left: -38px;\"><ul style=\"list-style: none;\"><li ng-repeat=\"(key , value) in additionalinfo\"><b>{{key}}: {{value}}</b></li></ul></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div></div></div>");
$templateCache.put("app/modules/newappointment/Pharmacy.html","<div class=\"active-appointments\"><div class=\"row\"><div class=\"col-md-8\"><form name=\"pharmEasyform\" novalidate=\"\"><div class=\"form-create form-create-first card\"><div class=\"form-signin\"><strong>Pharm easy page</strong> <button class=\"btn btn-danger btn-sm pull-right\" ng-click=\"showFirst()\">Back</button><hr><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Enter your Pin</label> <input placeholder=\"Enter your Pin\" type=\"text\" id=\"clientPin\" class=\"form-control\" ng-model=\"employee.pin\" ng-keypress=\"acceptOnlyNumbers($event)\" maxlength=\"6\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\" ng-model=\"checkAvailability\">{{checkAvailability}}</label> <button class=\"btn btn-primary form-control\" ng-click=\"checkPinAvailability(employee.pin)\">Check Availability</button></div><div class=\"col-md-4\"><label for=\"\">Select a Provider</label><select name=\"\" id=\"providerId\" class=\"form-control\" ng-model=\"selectedDiog\" ng-options=\"dc as dc.entityName for dc in diagnosticCentres\" ng-change=\"changeDC(selectedDiog, 1)\" ng-disabled=\"checkAvailability != \'Available\'\"><option value=\"\">Select a Provider</option></select></div></div><hr><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Upload Prescription</label> <button class=\"btn btn-success\" ngf-select=\"uploadPrescriptions($files, $invalidFiles)\" multiple=\"\" ngf-pattern=\".jpg\" ngf-max-height=\"1000\" ngf-max-size=\"1MB\">Select Files</button><div style=\"font:smaller\" ng-repeat=\"img in FileDetails\">{{img.name}} <button id=\"\" name=\"\" ng-click=\"removePres($index)\">Remove</button></div></div></div></div></div><div class=\"form-create card\"><div class=\"form-signin\"><strong>Customer details</strong><hr><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Customer name</label> <input placeholder=\"Customer Name\" name=\"clientName\" type=\"text\" id=\"clientName\" class=\"form-control\" ng-model=\"employee.name\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Gender</label> <input placeholder=\"Gender\" type=\"text\" id=\"clientgender\" class=\"form-control\" ng-model=\"employee.gender\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Date Of birth</label> <input placeholder=\"Date Of Birth\" id=\"dateOfBirth\" type=\"date\" ng-change=\"getTotalAge(employee.dob)\" class=\"form-control datepicker\" required=\"\" ng-model=\"employee.dob\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Age</label> <input placeholder=\"Age\" type=\"text\" id=\"clientage\" readonly=\"true\" class=\"form-control\" ng-model=\"employee.age\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Email address</label> <input placeholder=\"Email id\" type=\"text\" id=\"emailidPreEmp\" class=\"form-control\" ng-model=\"employee.email\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Mobile number</label> <input placeholder=\"Mobile number\" type=\"text\" id=\"mobilenumberPreEmp\" class=\"form-control\" ng-model=\"employee.mobileNumber\" required=\"\"></div></div></div></div><div class=\"form-create card\"><div class=\"form-signin\"><strong>Preferred Date and Time</strong><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Select visit type</label><select class=\"form-control\" ng-model=\"client.visitType\" ng-change=\"visitTypeChange(client.visitType)\" required=\"\"><option value=\"\">Select visit type</option><option value=\"Home_Visit\">Home Visit</option></select></div><div class=\"col-md-6\"></div></div><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Date & time - first preference *</label><p class=\"input-group\"><input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.firstPrefTime\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\" style=\"margin-top: -15px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-6\"><div uib-timepicker=\"\" ng-model=\"userTime.firstAppointmentTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><div ng-show=\"client.visitType==\'Home_Visit\'\"><strong>Address for home visit</strong><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Address line 1</label> <input type=\"text\" class=\"form-control\" ng-model=\"client.addressline1\" ng-required=\"client.visitType==\'Home_Visit\'\"></div><div class=\"col-md-6\"><label for=\"\">Address line 2</label> <input type=\"text\" class=\"form-control\" ng-model=\"client.addressline2\" ng-required=\"client.visitType==\'Home_Visit\'\"></div></div></div></div></div><div class=\"form-create card submit-buttons\"><div class=\"form-signin\"><div class=\"col-md-4\"></div><div class=\"col-md-4\"><button class=\"btn btn-block btn-primary\" ng-click=\"addToCart()\" ng-disabled=\"pharmEasyform.$invalid\">Add to Cart</button></div></div></div></form></div><div class=\"col-md-4\"><div class=\"form-create form-create-first card cart\"><div class=\"form-signin\"><h4>Your cart</h4><hr><div class=\"cartEmpty\" ng-show=\"cartEmpty\"><div class=\"empty text-center\">Cart is empty</div></div><div id=\"cartItems\" ng-show=\"!cartEmpty\"><div ng-repeat=\"item in orderObj.orderItems\"><div class=\"row package-item\"><span class=\"col-md-8\">{{item.productName}}</span> <span class=\"col-md-4\">Rs.{{item.amount}}/-</span></div><div class=\"row benef-item\"><span class=\"col-md-8\">{{item.firstName}}</span> <span class=\"col-md-4\">{{item.cityName}}</span></div><div class=\"row\"><div class=\"col-md-8\"></div><div class=\"col-md-3\"><button class=\"btn btn-xs btn-block btn-danger delete\" value=\"\" id=\"{{item.productId}}\" ng-click=\"removeOrderItem(item, event)\">delete</button></div></div><hr></div></div><button class=\"btn btn-primary btn-block\" ng-click=\"createAppointment()\" ng-show=\"!cartEmpty\">Create appointment</button><hr></div></div></div></div></div>");
$templateCache.put("app/modules/newappointment/drugTest.html","<div class=\"active-appointments\"><div class=\"row\"><div class=\"col-md-8\"><form name=\"drugTestform\" novalidate=\"\"><div class=\"form-create form-create-first card\"><div class=\"form-signin\"><strong>Employee Details</strong> <button class=\"btn btn-danger btn-sm pull-right\" ng-click=\"showFirst()\">Back</button><hr><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Employee Name</label> <input placeholder=\"Employee Name\" type=\"text\" id=\"clientName\" class=\"form-control\" ng-model=\"employee.name\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Employee gender</label> <input placeholder=\"Gender(Male or Female)\" type=\"text\" id=\"clientgender\" class=\"form-control\" ng-model=\"employee.gender\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Date of birth</label> <input placeholder=\"Date Of Birth\" id=\"dateOfBirth\" type=\"text\" class=\"form-control datepicker\" ng-model=\"employee.dob\" ng-change=\"getTotalAge(employee.dob)\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Age</label> <input placeholder=\"Age\" type=\"text\" id=\"clientage\" class=\"form-control\" ng-model=\"employee.age\" readonly=\"\"></div><div class=\"col-md-4\"><label for=\"\">Email address</label> <input placeholder=\"Email id\" type=\"text\" id=\"emailidPreEmp\" class=\"form-control\" ng-model=\"employee.email\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Mobile number</label> <input placeholder=\"Mobile number\" type=\"text\" id=\"mobilenumberPreEmp\" class=\"form-control\" ng-model=\"employee.mobileNumber\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Alternate mobile number</label> <input placeholder=\"Alternate mobile number\" type=\"text\" id=\"altmobilenumber\" class=\"form-control\" ng-model=\"employee.alternateMobileNumber\"></div><div class=\"col-md-4\"><label for=\"\">Alternate email address</label> <input placeholder=\"Alternate Email id\" type=\"text\" id=\"altemailid\" class=\"form-control\" ng-model=\"employee.altemailid\"></div><div class=\"col-md-4\"><label for=\"\">Offer id</label> <input placeholder=\"Offer id\" type=\"text\" id=\"offerId\" class=\"form-control\" ng-model=\"client.clientCode\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Client location</label> <input placeholder=\"Client Location\" type=\"text\" id=\"clientLoc\" class=\"form-control\" ng-model=\"employee.clientLocation\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Division</label> <input placeholder=\"Division\" type=\"text\" id=\"division\" class=\"form-control\" ng-model=\"employee.division\"></div><div class=\"col-md-4\"><label for=\"\">HR name</label> <input placeholder=\"HR name\" type=\"text\" id=\"hrname\" class=\"form-control\" ng-model=\"employee.hrName\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Remarks</label> <input placeholder=\"Remarks\" type=\"text\" id=\"remarks\" class=\"form-control\" ng-model=\"employee.remarks\"></div></div></div></div><div class=\"form-create card\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Select a package</label><select name=\"\" id=\"packageId\" class=\"form-control\" ng-model=\"client.selectedPackage\" ng-options=\"package as package.pM_Name for package in packages\" ng-change=\"changePackage(client.selectedPackage)\" required=\"\"><option value=\"\">Select a package</option></select></div><div class=\"col-md-6\"><label for=\"\">Select visit type</label><select class=\"form-control\" ng-model=\"client.visitType\" ng-change=\"visitTypeChange(client.visitType)\" required=\"\"><option value=\"\">Select visit type</option><option value=\"Appointment\">Centre Visit</option><option value=\"Home_Visit\">Home visit</option></select></div></div></div></div><div class=\"form-create card\" ng-show=\"client.visitType==\'Home_Visit\'\"><div class=\"form-signin\"><strong>Address for home visit</strong><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Address line 1</label> <input placeholder=\"Address Line 1\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline1\" ng-required=\"client.visitType==\'Home_Visit\'\"></div><div class=\"col-md-6\"><label for=\"\">Address line 2</label> <input placeholder=\"Address Line 2\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline2\" ng-required=\"client.visitType==\'Home_Visit\'\"></div></div></div></div><div class=\"form-create card\"><div class=\"form-signin\"><strong>Preferred diagnostic centers</strong><hr><div class=\"row\"><div class=\"col-md-3\"><label for=\"\">Select a state</label><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"current.newStateId\" ng-change=\"loadCities(current.newStateId)\"><option value=\"\">Select a state</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a city</label><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"newCityId\" ng-change=\"loadLocations(newCityId)\"><option value=\"\">Select a city</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a locality</label><select name=\"\" class=\"form-control\" ng-options=\"location as location.lookUpValue for location in locations\" ng-model=\"newLocationId\" ng-change=\"loadSubLocations(newLocationId)\"><option value=\"\">Select a locality</option></select></div><div class=\"col-md-3\"><label for=\"\">Select sub locality</label><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"newSubLocationId\" ng-change=\"loadDCs(newSubLocationId)\"><option value=\"\">Select sub locality</option></select></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Diagnostic centre - first preference</label><select name=\"preferreddc1\" id=\"firstDCIdPreEmp\" ng-model=\"client.preferredDC1\" class=\"form-control\" ng-options=\"dc as dc.entityName for dc in diagnosticCentres\" ng-change=\"changeDC(client.preferredDC1, 1)\"><option value=\"\">Select a diagnostic centre</option></select></div><div class=\"col-md-4\"><label for=\"\">Diagnostic centre - second preference</label><select name=\"preferreddc2\" id=\"secondDCIdPreEmp\" ng-model=\"client.preferredDC2\" class=\"form-control\" ng-options=\"dc as dc.entityName for dc in diagnosticCentres\" ng-change=\"changeDC(client.preferredDC2, 2)\"><option value=\"\">Select a diagnostic centre</option></select></div><div class=\"col-md-4\"><label for=\"\">Diagnostic centre - third preference</label><select name=\"preferreddc3\" id=\"thirdDCIdPreEmp\" ng-model=\"client.preferredDC3\" class=\"form-control\" ng-options=\"dc as dc.entityName for dc in diagnosticCentres\" ng-change=\"changeDC(client.preferredDC3, 3)\"><option value=\"\">Select a diagnostic centre</option></select></div></div></div></div><div class=\"form-create card\"><div class=\"form-signin\"><strong>Preferred date and time</strong><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Date & time - first preference *</label><p class=\"input-group\"><input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.firstPrefTime\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\" style=\"margin-top: -15px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-6\" style=\"margin-top: -12px;\"><div uib-timepicker=\"\" ng-model=\"userTime.firstAppointmentTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Date & time - second preference *</label><p class=\"input-group\"><input id=\"datetimeSecond\" type=\"text\" readonly=\"\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.secondPrefTime\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\" style=\"margin-top: -15px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-6\" style=\"margin-top: -12px;\"><div uib-timepicker=\"\" ng-model=\"userTime.secondAppointmentTime\" max=\"maxSecond\" min=\"minSecond\" ng-change=\"changedSecond()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div></div></div><hr><div class=\"form-create card submit-buttons\"><div class=\"form-signin\"><div class=\"col-md-4\"></div><div class=\"col-md-4\"></div><div class=\"col-md-4\"><button class=\"btn btn-block btn-primary\" ng-click=\"addToCart()\" ng-disabled=\"drugTestform.$invalid\">Add to Cart</button></div></div></div></form></div><div class=\"col-md-4\"><div class=\"form-create form-create-first card cart\"><div class=\"form-signin\"><h4>Your cart</h4><hr><div class=\"cartEmpty\" ng-show=\"cartEmpty\"><div class=\"empty text-center\">Cart is empty</div></div><div id=\"cartItems\" ng-show=\"!cartEmpty\"><div ng-repeat=\"item in orderObj.orderItems\"><div class=\"row package-item\"><span class=\"col-md-8\">{{item.productName}}</span> <span class=\"col-md-4\">Rs.{{item.amount}}/-</span></div><div class=\"row benef-item\"><span class=\"col-md-8\">{{item.firstName}}</span> <span class=\"col-md-4\">{{item.cityName}}</span></div><div class=\"row\"><div class=\"col-md-8\"></div><div class=\"col-md-3\"><button class=\"btn btn-xs btn-block btn-danger delete\" value=\"\" id=\"{{item.productId}}\" ng-click=\"removeOrderItem(item, event)\">delete</button></div></div><hr></div></div><div class=\"row package-item\" ng-show=\"!cartEmpty\"><div class=\"col-md-8\">Grand Total</div><div class=\"col-md-4\">Rs.{{totalPrice}}/-</div></div><hr></div></div><div class=\"form-create card\" ng-show=\"showPaid\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"paid\">Paid</label> <input type=\"radio\" id=\"paid\" name=\"optradio\" checked=\"checked\" value=\"\" ng-click=\"paid=true\"></div><div class=\"col-md-6\"><label for=\"unpaid\">Unpaid</label> <input type=\"radio\" id=\"unpaid\" name=\"optradio\" value=\"\" ng-click=\"paid=false\"></div></div><strong>Transaction Details</strong><hr><div class=\"alert alert-danger\" ng-show=\"showPaid && paid\" role=\"alert\">Since this is a paid package, You need to fill the following <span class=\"strong\">Transaction details</span></div><div class=\"alert alert-danger\" ng-show=\"showPaid && !paid\" role=\"alert\">Unpaid orders will be collected in \"UnConfirmed Orders\" bucket. Once their availability is confirmed with DC, they will be approved and payment link will be sent to the user. These orders moves to active appointments, only after user makes the payment</div><div ng-show=\"showPaid && paid\"><label for=\"\">UTR number *</label> <input id=\"txnNumberPreEmp\" class=\"form-control\" ng-model=\"txn.txnNumber\"></div></div></div><button class=\"btn btn-primary btn-block\" ng-click=\"createAppointment()\" ng-show=\"!cartEmpty\">Create Appointment</button></div></div></div>");
$templateCache.put("app/modules/newappointment/esales.html","<div class=\"active-appointments\"><style>\n        #map {\n            height: 100%;\n        }\n        /* Optional: Makes the sample page fill the window. */\n        html, body {\n            height: 100%;\n            margin: 0;\n            padding: 0;\n        }\n\n        #description {\n            font-family: Roboto;\n            font-size: 15px;\n            font-weight: 300;\n        }\n\n        #infowindow-content .title {\n            font-weight: bold;\n        }\n\n        #infowindow-content {\n            display: none;\n        }\n\n        #map #infowindow-content {\n            display: inline;\n        }\n\n        .pac-card {\n            margin: 10px 10px 0 0;\n            border-radius: 2px 0 0 2px;\n            box-sizing: border-box;\n            -moz-box-sizing: border-box;\n            outline: none;\n            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n            background-color: #fff;\n            font-family: Roboto;\n        }\n\n        #pac-container {\n            padding-bottom: 12px;\n            margin-right: 12px;\n        }\n\n        .pac-controls {\n            display: inline-block;\n            padding: 5px 11px;\n        }\n\n            .pac-controls label {\n                font-family: Roboto;\n                font-size: 13px;\n                font-weight: 300;\n            }\n\n        #pac-input {\n            background-color: #fff;\n            font-family: Roboto;\n            font-size: 15px;\n            font-weight: 300;\n            margin-left: 12px;\n            padding: 0 11px 0 13px;\n            text-overflow: ellipsis;\n            width: 400px;\n        }\n\n            #pac-input:focus {\n                border-color: #4d90fe;\n            }\n\n        #title {\n            color: #fff;\n            background-color: #4d90fe;\n            font-size: 25px;\n            font-weight: 500;\n            padding: 6px 12px;\n        }\n\n        #target {\n            width: 345px;\n        }\n\n        .slideBox {\n            position: absolute;\n            top: 0;\n            right: 0;\n            width: 0;\n            opacity: 0;\n            visibility: hidden;\n            height: 100%;\n            z-index: 9999;\n            background: rgba(0,0,0,.5);\n        }\n\n            .slideBox .slideContent {\n                position: fixed !important;\n                overflow: auto;\n                background: #fff;\n                right: 0;\n                top: 0 !important;\n                bottom: 0 !important;\n                margin: 0 !important;\n                height: 100%;\n                max-width: 640px;\n                width: 80% !important;\n            }\n\n            .slideBox.in {\n                visibility: visible;\n                opacity: 1;\n                width: 100%;\n                transition: all .3s ease;\n            }\n\n        .multiSelectJustified .multiselect-parent {\n            width: 100%;\n        }\n\n        .multiSelectJustified .btn {\n            width: 100%;\n            text-align: left;\n        }\n\n            .multiSelectJustified .btn .caret {\n                float: right;\n                margin-top: 8px;\n            }\n    </style><div class=\"row\"><div class=\"col-md-12\"><div id=\"testsPerformed\" style=\"margin-top: -46px;\"><button class=\"btn btn-danger btn-sm pull-right\" ng-click=\"showFirst()\">Back</button><div class=\"form-create form-create-first card\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Customer name</label> <input placeholder=\"Customer Name\" type=\"text\" id=\"employeeName\" class=\"form-control\" ng-model=\"employee.name\"></div><div class=\"col-md-4\"><label for=\"\">Customer unique id</label> <input placeholder=\"Customer Unique Id\" type=\"text\" id=\"employeeId\" class=\"form-control\" ng-model=\"client.clientCode\"></div><div class=\"col-md-4\" style=\"margin-top: -12px;\"><label for=\"\">Annual premium</label> <input placeholder=\"Enter annual premium\" name=\"annualPremium\" type=\"number\" id=\"annualPremium\" class=\"form-control\" ng-model=\"employee.annualPremium\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Email address</label> <input placeholder=\"Email id\" type=\"text\" id=\"emailid\" class=\"form-control\" ng-model=\"employee.email\"></div><div class=\"col-md-4\"><label for=\"\">Mobile number</label> <input placeholder=\"Mobile number\" type=\"text\" id=\"mobilenumber\" class=\"form-control\" ng-model=\"employee.mobileNumber\"></div><div class=\"col-md-4\"><label for=\"\">Select insurer</label><select class=\"form-control\" name=\"\" id=\"\" ng-model=\"client.selectedInsurer\" ng-options=\"insurer as insurer.entityName for insurer in selectedInsurers\" ng-change=\"setSource(client.selectedInsurer)\"><option value=\"\">Select insurer</option></select></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Sum assured</label> <input placeholder=\"Enter sum assured\" type=\"text\" id=\"sumAssured\" class=\"form-control\" ng-model=\"sumassuredetail.sumAssured\"></div><div class=\"col-md-4\"><label for=\"\">Paid/Sponsored</label><select ng-model=\"sumassuredetail.paidSpons\" class=\"form-control\"><option value=\"sponsored\">Sponsored</option><option value=\"paid\">Paid</option></select></div><div class=\"col-md-4\"><label for=\"\">Group/Individual</label><select ng-model=\"sumassuredetail.grpIndv\" class=\"form-control\"><option value=\"individual\">Individual</option><option value=\"group\">Group</option></select></div></div><div class=\"row\"><div class=\"col-md-6\" ng-show=\"selectedSource.id==\'1024195\'\"><label for=\"\">Paid by</label><br><input placeholder=\"Paid by\" type=\"checkbox\" name=\"\" id=\"\" ng-model=\"notpaidByCoverFox\" ng-click=\"changePaidOption($event)\"> Same as Insurer selected (else Coverfox will be asked to pay)</div></div></div></div><div class=\"form-create card\"><div class=\"form-signin\"><table class=\"table table-hover\" ng-show=\"showData.TestDetails.length>0\"><thead><th>Test name</th><th>Appointment date & time</th><th>Provider</th></thead><tbody><tr ng-repeat=\"test in showData.TestDetails\"><td>{{test.TestName}}</td><td>{{compareDate(test.AppointmentDate)}} | {{test.AppointmentTime}}</td><td>{{test.LabAddress}}</td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Select appropriate package</label><div ng-dropdown-multiselect=\"\" options=\"packages\" extra-settings=\"example2settings\" selected-model=\"selectedPackageForAdvance\" translation-texts=\"example5customTexts\" checkboxes=\"true\" style=\"margin-bottom:15px;\" class=\"multiSelectJustified\"></div></div><div class=\"col-md-3\" ng-show=\"selectedPackageForAdvance.length>0\"><label for=\"\">View packages</label> <button class=\"btn btn-info btn-block\" data-toggle=\"modal\" data-target=\"#selectedPacakgesList\">View Details</button></div><div class=\"col-md-3\"><label for=\"\">Select visit type</label><select class=\"form-control\" ng-model=\"client.visitType\" ng-change=\"visitTypeChange(client.visitType)\" required=\"\"><option value=\"\">Select visit type</option><option value=\"Appointment\">Centre visit</option><option value=\"Home_Visit\">Home visit</option></select></div></div><div class=\"form-create card\" ng-if=\"client.visitType===\'Home_Visit\'\" style=\"padding-bottom:10px;\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-12\"><div ng-show=\"client.visitType===\'Home_Visit\'\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Address line 1</label> <input placeholder=\"Enter address line 1..\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline1\" ng-required=\"client.visitType===\'Home_Visit\'\"></div><div class=\"col-md-6\"><label for=\"\">Address line 2</label> <input placeholder=\"Enter address line 2..\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline2\" ng-required=\"client.visitType===\'Home_Visit\'\"></div></div></div></div></div></div></div><div class=\"form-create card\" ng-show=\"selectedPackageForAdvance.length >0\" style=\"padding-bottom:10px;\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"btn-group btn-group-justified\" style=\"margin-bottom:15px;\"><label class=\"btn btn-primary\" ng-model=\"radioModel\" uib-btn-radio=\"\'Left\'\" ng-click=\"DCSelection(\'advance\')\">Advance DC selection</label> <label class=\"btn btn-primary\" ng-model=\"radioModel\" uib-btn-radio=\"\'Middle\'\" ng-click=\"DCSelection(\'manula\')\">Manual DC selection</label></div></div><div class=\"col-md-4\" ng-show=\"isPackageSelectionAdvance\"><select name=\"\" class=\"form-control\" ng-options=\"distance as distance.value for distance in distances\" ng-model=\"distance\" ng-change=\"changeDistance(distance)\"><option value=\"\">Select radius</option></select></div><div class=\"col-md-4\" ng-show=\"isPackageSelectionAdvance\"><input type=\"text\" class=\"form-control\" gm-places-autocomplete=\"\" ng-model=\"locationName.autocomplete\"></div></div><div class=\"row\" ng-if=\"isPackageSelectionManual || isPackageSelectionAdvance\" style=\"margin-top: 10px;\"><div class=\"row\"><div class=\"col\"><div class=\"col-xs-4 dateBox\"><label for=\"\">First preference</label> <input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"manual.firstDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" style=\"width: 140px;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\" style=\"margin-left: 138px; margin-top: -83px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"col-xs-4 dateBox\"><label for=\"\">Second preference</label> <input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"manual.secondDate\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" style=\"width: 140px;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\" style=\"margin-left: 138px; margin-top: -83px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"col-xs-2 p-l-0 timeBox\" style=\"margin-left: 210px; margin-top: -102px;\"><div uib-timepicker=\"\" ng-model=\"manual.firstTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div><div class=\"col-xs-2 p-l-0 timeBox\" style=\"margin-left: 210px; margin-top: -102px;\"><div uib-timepicker=\"\" ng-model=\"manual.secondTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div><div class=\"col-md-2\"><dc-notes id=\"selectedDcFromDavanceSearch.id\"><button style=\"margin-top:-128px;\" class=\"btn f\">Outsourcing Details</button></dc-notes></div></div></div></div><div class=\"row\" ng-if=\"isPackageSelectionManual\" style=\"margin-top: 10px; margin-bottom: 60PX;\"><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"current.newStateId\" ng-change=\"loadCitiesNew(current.newStateId)\"><option value=\"\">Select state</option></select></div><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"newCityId\" ng-change=\"loadLocationsNew(newCityId)\"><option value=\"\">Select city</option></select></div><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"newSubLocationId\" ng-change=\"loadDcForAllPackages(newSubLocationId)\"><option value=\"\">Select locality</option></select></div><div class=\"col-md-3\"><select name=\"preferreddc1\" id=\"firstDCIdPreEmp\" ng-model=\"client.preferredDC1\" class=\"form-control\" ng-options=\"dc as dc.entityName for dc in diagnosticCentres\" ng-change=\"selectedDcFromMap(client.preferredDC1)\"><option value=\"\">Select diagnostic centre</option></select></div></div><div class=\"row\" ng-if=\"isPackageSelectionManual\" style=\"margin-top: 10px; margin-bottom: 30PX;\"><div class=\"col-md-12\"><button ng-disabled=\"!manual.firstDate || !client.preferredDC1 || !client.visitType\" ng-click=\"bookAppointmentDate(manual.firstDate, manual.secondDate, manual.firstTime, manual.secondTime)\" class=\"btn btn-primary pull-right\">Add to cart</button></div></div></div></div><div class=\"row\" ng-if=\"markerArray.length >0 && isPackageSelectionAdvance\"><div class=\"col-md-12\"><ui-gmap-google-map center=\"map.center\" control=\"\" zoom=\"map.zoom\" bounds=\"map.bounds\" draggable=\"true\" options=\"map.options\"><ui-gmap-circle center=\"map.center\" stroke=\"map.stroke\" fill=\"map.fill\" radius=\"map.radius\" visible=\"map.visible\" geodesic=\"c.geodesic\" editable=\"c.editable\" draggable=\"map.draggable\" clickable=\"map.clickable\"><ui-gmap-marker models=\"randomMarkers1\" coords=\"map.center\" idkey=\"\"><i class=\"fa fa-user\"></i></ui-gmap-marker><ui-gmap-marker ng-repeat=\"marker in markerArray\" click=\"selectedDcFromMap(marker, $event)\" models=\"randomMarkers\" events=\"map.markersEvents\" coords=\"marker.coords\" idkey=\"marker.id\"><ui-gmap-window options=\"windowOpt\" closeclick=\"map.window.closeClick(marker)\" show=\"marker.visible\" templateurl=\"\'/app/modules/newappointment/windowContent.html\'\" templateparameter=\"windowParams\"></ui-gmap-window></ui-gmap-marker></ui-gmap-circle></ui-gmap-google-map></div></div><div class=\"row\" ng-if=\"markerArray.length ===0 && isMarkerArray && selectedPackageForAdvance.length !== 0\"><div class=\"col-md-12\"><div class=\"text-center\" style=\"margin-bottom: 30px; padding-top: 20px; background-color: #e0dede; padding-bottom: 18px;\">No Diagnostic Centre found.</div></div></div></div></div><div class=\"form-create card\" ng-show=\"showAddTestBox\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Select visit type</label><select class=\"form-control\" ng-model=\"client.visitType\" ng-change=\"visitTypeChange(client.visitType)\" required=\"\"><option value=\"\">Select visit type</option><option value=\"Appointment\">Centre visit</option><option value=\"Home_Visit\">Home visit</option></select></div><div class=\"col-md-6\"><label for=\"\">Select an individual test *</label><select class=\"form-control\" ng-model=\"testSelected\" ng-options=\"test as test.packageName for test in tests\" ng-change=\"selectTest(testSelected)\"><option value=\"\">Select a test</option></select></div></div><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Date & time - first preference *</label><p class=\"input-group\"><input placeholder=\"Date & Time - First Preference\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.firstPrefTime\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\" style=\"margin-top: -15px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-6\"><div uib-timepicker=\"\" ng-model=\"userTime.firstAppointmentTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><strong>Please choose the diagnostic centre</strong><hr style=\"margin:5px 0\"><div class=\"row\"><div class=\"col-md-3\"><label for=\"\">Select a state</label><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"current.newStateId\" ng-change=\"loadCities(current.newStateId)\"><option value=\"\">Select a state</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a city</label><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"newCityId\" ng-change=\"loadLocations(newCityId)\"><option value=\"\">Select a state</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a locality</label><select name=\"\" class=\"form-control\" ng-options=\"location as location.lookUpValue for location in locations\" ng-model=\"newLocationId\" ng-change=\"loadSubLocations(newLocationId)\"><option value=\"\">Select a state</option></select></div><div class=\"col-md-3\"><label for=\"\">Select sub locality</label><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"newSubLocationId\" ng-change=\"loadDCs(newSubLocationId)\"><option value=\"\">Select a state</option></select></div></div><div ng-show=\"client.visitType==\'Home_Visit\'\"><strong>Address for home visit</strong><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Address line 1</label> <input placeholder=\"Address Line 1\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline1\" ng-required=\"client.visitType==\'Home_Visit\'\"></div><div class=\"col-md-6\"><label for=\"\">Address line 2</label> <input placeholder=\"Address Line 2\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline2\" ng-required=\"client.visitType==\'Home_Visit\'\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"\">Select a diagnostic centre</label><select name=\"preferreddc1\" id=\"firstDCIdPreEmp\" ng-model=\"client.preferredDC1\" class=\"form-control\" ng-options=\"dc as dc.entityName for dc in diagnosticCentres\" ng-change=\"changeDC(client.preferredDC1, 1)\"><option value=\"\">Select a diagnostic centre</option></select></div></div><div class=\"row\"><div class=\"col-md-3\"></div><div class=\"col-md-3\"></div><div class=\"col-md-3\"></div><div class=\"col-md-3\"><button class=\"btn btn-block btn-primary\" ng-click=\"addToCart()\">Add to cart</button></div></div></div></div></div></div><div class=\"slideBox\" ng-class=\"isCostomerDetails ? \'in\': \'\'\"><div class=\"slideContent\"><div class=\"modal-header\"><a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"isCostomerDetails=!isCostomerDetails\"><span aria-hidden=\"true\">&times;</span></a><h4 class=\"modal-title\">Customer additonal details</h4></div><div class=\"modal-body\"><h4>Few details for your refrence</h4><table><tr><td style=\"width: 140px;\">Name:</td><td><b>{{getDetailsHelp.name}}</b></td></tr><tr><td>Address:</td><td><b>{{getDetailsHelp.addressLine1}}</b></td></tr><tr><td>City:</td><td><b>{{getDetailsHelp.city}}</b></td></tr><tr><td>State:</td><td><b>{{getDetailsHelp.state}}</b></td></tr><tr><td>Mobile number:</td><td><b>{{getDetailsHelp.mobileNumber}}</b></td></tr></table><h4 style=\"margin-top: 30px;\" ng-if=\"getDetailsHelpTestDetails.length >0\">Test details for your refrence</h4><table ng-repeat=\"details in getDetailsHelpTestDetails\"><tr><td style=\"width: 140px;\">Name:</td><td><b>{{details.testName}}</b></td></tr><tr><td>Description:</td><td><b>{{details.testDesc}}</b></td></tr><tr><td>Visit type:</td><td><b>{{details.visitType}}</b></td></tr><tr ng-if=\"details.appointmentDate\"><td>Appointment date:</td><td><b>{{compareDate(details.appointmentDate)}}</b></td></tr></table></div></div></div><div class=\"slideBox\" ng-class=\"isCart ? \'in\': \'\'\"><div class=\"slideContent\"><div class=\"modal-header\"><a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"closeCart()\"><span aria-hidden=\"true\">&times;</span></a><h4 class=\"modal-title\">You are booking packages for <span style=\"color:#4d90fe;\">{{employee.name}}</span><br><span style=\"font-size:14px;\">at <b>{{selectedDcFromDavanceSearch.name}}</b>, {{selectedDcFromDavanceSearch.entityAddress}}</span></h4></div><div class=\"modal-body\"><div class=\"cartEmpty\" ng-show=\"cartEmpty\"><div class=\"empty text-center\">Cart is empty</div></div><div id=\"cartItems\" ng-show=\"!cartEmpty\"><div>Ap</div><div ng-repeat=\"item in orderObj.orderItems\"><div class=\"row package-item\"><div class=\"col-md-7\">{{item.productName}}</div><div class=\"col-md-3 text-right\">Rs.{{item.amount}}/-</div><div class=\"col-md-2 text-right\"><button class=\"btn btn-xs btn-block btn-danger delete\" value=\"\" id=\"{{item.productId}}\" ng-click=\"removeOrderItem(item, event)\">Remove</button></div></div><hr></div></div><div class=\"row package-item\" ng-if=\"!cartEmpty && orderObj.orderItems.length >0\" style=\"margin-bottom: 10px;\"><div class=\"col-md-7\">Grand total</div><div class=\"col-md-3 text-right\">Rs.{{totalPrice}}/-</div><div class=\"col-md-2\"></div></div><div class=\"form-create card\" ng-show=\"showPaid\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"paid\">Paid</label> <input type=\"radio\" id=\"paid\" name=\"optradio\" checked=\"checked\" value=\"\" ng-click=\"paid=true\"></div><div class=\"col-md-6\"><label for=\"unpaid\">Unpaid</label> <input type=\"radio\" id=\"unpaid\" name=\"optradio\" value=\"\" ng-click=\"paid=false\"></div></div><strong>Transaction details</strong><hr><div class=\"alert alert-danger\" ng-show=\"showPaid && paid\" role=\"alert\">Since this is a paid package, You need to fill the following <span class=\"strong\">Transaction details</span></div><div class=\"alert alert-danger\" ng-show=\"showPaid && !paid\" role=\"alert\">Unpaid orders will be collected in \"UnConfirmed Orders\" bucket. Once their availability is confirmed with DC, they will be approved and payment link will be sent to the user. These orders moves to active appointments, only after user makes the payment</div><div ng-show=\"showPaid && paid\"><label for=\"\">UTR number *</label> <input id=\"txnNumberPreEmp\" class=\"form-control\" ng-model=\"txn.txnNumber\"></div></div></div><button class=\"btn btn-primary btn-block\" ng-click=\"checkDuplicacy()\" ng-show=\"!cartEmpty && orderObj.orderItems.length >0\">Create Appointment</button></div></div></div><div class=\"modal fade\" id=\"selectedPacakgesList\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\" style=\"padding:0 15px;\"><a href=\"\"><span class=\"pull-right\" data-dismiss=\"modal\"><b>X</b></span></a><h4>Selected Packages</h4></div><div class=\"modal-body\" id=\"chooseDCBody\"><ul><li ng-repeat=\"item in selectedPackageForAdvance\">{{item.packageName}}<br></li></ul></div></div></div></div></div></div>");
$templateCache.put("app/modules/newappointment/main.html","<style>\n    form.add-user {\n        width: 400px;\n        margin: 0 auto;\n    }\n\n    .package-item {\n        font-weight: bold;\n        font-size: 12px;\n    }\n\n    .benef-item {\n        font-weight: normal;\n        font-size: 12px;\n        color: #AAA;\n    }\n\n    .brand img {\n        width: 190px;\n    }\n\n    .form-create {\n        width: 100%;\n        /*padding: 40px 40px;*/\n    }\n\n    .card {\n        background-color: #F7F7F7;\n        padding: 20px 25px 30px;\n        -moz-border-radius: 2px;\n        -webkit-border-radius: 2px;\n        border-radius: 2px;\n        -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n        -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n    }\n\n    .form-create.card {\n        margin-top: 0px;\n        margin-bottom: 10px;\n    }\n\n    .submit-buttons.card {\n        background-color: transparent;\n        -moz-border-radius: 0px;\n        -webkit-border-radius: 0px;\n        border-radius: 0px;\n        -moz-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n        -webkit-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n        box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n    }\n\n    .form-create-first.card {\n        margin-top: 30px;\n    }\n\n    .card-container.card {\n        width: 350px;\n        padding: 40px 40px;\n    }\n\n    .form-signin .form-control {\n        margin-bottom: 15px;\n    }\n\n    .form-create .form-control {\n        margin-bottom: 15px;\n        height: 35px;\n    }\n\n    .firstScreen.card {\n        margin: 0 auto 25px;\n        margin-top: 50px;\n    }\n\n    .required {\n        border: 1px solid red;\n    }\n\n    .strong {\n        font-weight: bold;\n    }\n\n    .cart hr {\n        margin: 5px 0;\n    }\n\n    .line-dashed {\n        border-bottom: 1px dashed black;\n        margin-bottom: 15px;\n    }\n\n    .search-agent {\n        text-align: center;\n        color: blue;\n        cursor: pointer;\n    }\n    .show {\n        float: right;\n    }\n    .noEmployee { \n        color: red;\n        text-align: center;\n\n    }\n</style><script type=\"text/ng-template\" id=\"customPopupTemplate.html\"><div class=\"custom-popup-wrapper\" ng-style=\"{top: 0+\'px\', left: 0+\'px\'}\" style=\"display: block; position: relative\" ng-show=\"isOpen() && !moveInProgress\" aria-hidden=\"{{!isOpen()}}\"> <p class=\"message\" style=\"margin-top: -14px;\">select from drop down.</p> <ul class=\"dropdown-menu\" role=\"listbox\" style=\"display: block; position: relative; padding-top: 0px; margin-top: -10px;\"> <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.entityName}}\"> <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div> </li> </ul> </div></script><div class=\"row active-appointments\" ng-show=\"showFirstScreen && !createresult\"><div class=\"col-md-12 card\" style=\"margin: 1% 0% 0% 1%;width: 98%;\"><div class=\"form-signin\"><label for=\"\">Select a contract type</label><select ng-change=\"changeContracts();\" name=\"\" id=\"contractId\" class=\"form-control\" ng-model=\"selectedContract\" ng-options=\"contract.id as contract.entityName for contract in contracts\"><option value=\"\">Select a contract</option><option value=\"{{contract.id}}\" ng-repeat=\"contract in contracts\">{{contract.entityName}}</option></select><div ng-show=\"!isContractPrePolicy() && !isContractEsales() && !isContractPharmacy()\"><div ng-show=\"!isContractPrePolicy() && !isContractEsales() && !isContractPharmacy() && !isContractPreEmployment() && !isContractDrugTest()\"><label for=\"\">Select corporates</label><div class=\"addTime\"><a href=\"\" class=\"btn btn-default btn-block addTimeBtn\" ng-click=\"showTimeAdd ? showTimeAdd = false : showTimeAdd = true\" style=\"text-align:left;\"><i class=\"fa fa-plus\"></i> <span ng-hide=\"choosedCorporates.length > 0\">Select Corporates</span><span ng-show=\"choosedCorporates.length > 0\">{{choosedCorporates.length}} Selected</span></a><div class=\"select-corp\" ng-show=\"showTimeAdd\"><div class=\"arrow\"></div><h3 class=\"popover-title\"><span><a href=\"\" ng-click=\"selectAll(true)\" class=\"btn btn-xs btn-default\">Select all</a> <a href=\"\" ng-click=\"selectAll(false)\" class=\"btn btn-xs btn-default\">Remove all</a> <a href=\"\" ng-hide=\"choosedCorporates.length == 0\" ng-click=\"showTimeAdd = false;\" class=\"alert-primary pull-right btn btn-xs btn-default\"><i class=\"fa fa-check\"></i> Done</a> <a href=\"\" ng-show=\"choosedCorporates.length == 0\" ng-click=\"showTimeAdd = false\" class=\"alert-danger pull-right btn btn-xs btn-default\"><i class=\"fa fa-times\"></i></a> <em class=\"pull-right em-custom\">{{choosedCorporates.length}} Selected</em></span> <input type=\"text\" class=\"form-control\" ng-model=\"chosenCorporate\" placeholder=\"Search Corporates\" ng-change=\"fetchContractData();\"></h3><div class=\"popover-content\"><div class=\"corp-content\"><div class=\"item\" ng-repeat=\"corp in corporates | filter:state.entityName\" ng-class=\"corp.isSelected ? \'checked\': \'\'\"><span ng-click=\"corp.isSelected = !corp.isSelected;filterchoosedCorporates(corp);\"><input type=\"checkbox\" ng-model=\"corp.isSelected\" class=\"hide\"> <a href=\"\" ng-show=\"corp.isSelected\"><i class=\"fa fa-check-square-o\"></i></a> <a href=\"\" ng-show=\"!corp.isSelected\"><i class=\"fa fa-square-o\"></i></a> {{corp.entityName}}</span></div></div></div></div></div></div><div ng-show=\"isContractPreEmployment() || isContractDrugTest()\"><label for=\"\">Select a corporate name</label> <input ng-change=\"fetchContractData();\" type=\"text\" ng-model=\"chosenCorporate\" placeholder=\"Type corporate name to search\" isteven-multi-select=\"\" uib-typeahead=\"state as state.entityName for state in corporates | filter:{entityName:$viewValue}\" typeahead-popup-template-url=\"customPopupTemplate.html\" typeahead-on-select=\"changeCorporate(chosenCorporate)\" class=\"form-control\"></div><div style=\"margin-top:15px;\"><label for=\"\" ng-show=\"!isContractPreEmployment() && !isContractDrugTest()\">Enter the employee code</label> <input type=\"text\" ng-model=\"client.clientCode\" id=\"empId\" class=\"form-control\" placeholder=\"Employee code\" required=\"\" autofocus=\"\" ng-show=\"!isContractPreEmployment() && !isContractDrugTest()\"></div><button class=\"btn btn-primary btn-block btn-signin\" type=\"submit\" ng-click=\"showNextStep(\'others\')\" ng-show=\"!isContractPreEmployment() && !isContractDrugTest()\" ng-disabled=\"!client.clientCode\">Create Appointment</button> <button class=\"btn btn-primary btn-block btn-signin\" type=\"submit\" ng-click=\"showNextStep(\'preemp\')\" ng-disabled=\"!chosenCorporate\" ng-show=\"isContractPreEmployment()\">Create Appointment</button> <button class=\"btn btn-primary btn-block btn-signin\" type=\"submit\" ng-click=\"showNextStep(\'drugTest\')\" ng-disabled=\"!chosenCorporate\" ng-show=\"isContractDrugTest()\">Create Appointment</button></div><div ng-show=\"employeeFound\" class=\"noEmployee\"><h5>Either employee not found or beneficiaries are not present for provided employee-id.</h5></div><div ng-show=\"isContractEsales()\"><label for=\"\">Select a source</label> <input ng-change=\"fetchContractData()\" type=\"text\" ng-model=\"selectedSource\" placeholder=\"select a source\" uib-typeahead=\"source as source.entityName for source in corporates\" typeahead-popup-template-url=\"customPopupTemplate.html\" typeahead-on-select=\"changeSource(selectedSource)\" class=\"form-control\"> <button ng-click=\"showNextStep(\'esales\')\" ng-disabled=\"isSelectedInsurers\" class=\"btn btn-primary btn-block btn-signin\">Create eSales appointment</button></div><div ng-show=\"isContractPrePolicy()\"><div class=\"line line-dashed\"></div><div class=\"form-group\" ng-show=\"agentDetails.search\"><label for=\"\">Enter the agent code</label> <input ng-change=\"fetchPrePolicyDataCall()\" placeholder=\"Enter the agent code\" type=\"text\" class=\"form-control\" ng-model=\"agentCode\"> <button class=\"btn btn-primary btn-block\" ng-click=\"fetchAgent()\" ng-disabled=\"!agentCode\">Fetch Agent</button></div><div ng-show=\"!agentDetails.search\"><div class=\"form-group\" ng-show=\"agentDetails.agentFound\"><label for=\"\">Agent name:</label><span>{{agentDetails.agentName}}</span><br><label for=\"\">Agent code:</label><span>{{agentDetails.agentCode}}</span><br><label for=\"\">Mobile number:</label><span>{{agentDetails.agentMobileNo}}</span><br><label for=\"\">Agent address:</label><span>{{agentDetails.agentAddress}}</span><br><label for=\"\">Insurance company:</label> {{agentDetails.insuranceCompanyName}}<br><button ng-click=\"showNextStep(\'prepolicy\')\" class=\"btn btn-primary btn-block btn-signin\" type=\"submit\">Create Appointment</button></div><div class=\"form-group\" ng-show=\"!agentDetails.agentFound\"><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"!agentDetails.created && !agentDetails.failed\">Agent not found. Create agent using form below</div><div class=\"alert alert-success\" role=\"alert\" ng-show=\"agentDetails.created\">Agent created successfully!</div><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"agentDetails.failed\">Agent creation failed!</div><label for=\"\">Agent name</label> <input placeholder=\"Agent Name\" type=\"text\" class=\"form-control\" ng-model=\"agentDetails.agentName\"> <label for=\"\">Agent code</label> <input placeholder=\"Agent Code\" type=\"text\" class=\"form-control\" ng-model=\"agentDetails.agentCode\"> <label for=\"\">Mobile number</label> <input placeholder=\"Mobile Number\" type=\"text\" class=\"form-control\" ng-model=\"agentDetails.agentMobileNo\"> <label for=\"\">Agent address</label> <input placeholder=\"Agent Address\" type=\"text\" class=\"form-control\" ng-model=\"agentDetails.agentAddress\"> <label for=\"\">Insurance company</label><select class=\"form-control\" name=\"\" id=\"\" ng-model=\"agentDetails.insuranceCompanyId\"><option value=\"\">Select an insurer</option><option value=\"{{insurer.entityId}}\" ng-repeat=\"insurer in corporates\">{{insurer.entityName}}</option></select><button class=\"btn btn-block btn-primary\" ng-click=\"createAgent()\">Create agent</button></div><div><a ng-click=\"agentDetails={};agentDetails.search=true;\" class=\"search-agent\">Search another agent</a></div></div></div><div ng-show=\"isContractPharmacy()\"><button class=\"btn btn-primary btn-block btn-signin\" type=\"submit\" ng-click=\"showNextStep(\'Pharmacy\')\" ng-show=\"isContractPharmacy()\">Create Appointment</button></div></div></div></div><div ui-view=\"\" ng-show=\"!showFirstScreen && !createresult\"></div><div class=\"active-appointments\" ng-show=\"createresult\"><div class=\"card card-container firstScreen\"><div class=\"form-signin\"><label>Order created Successfully</label><h4>Order id: {{orderData.orderId}}</h4><button class=\"btn btn-primary btn-block btn-signin\" type=\"submit\" ng-show=\"corporates.length!=0\" ng-click=\"createresult=false;showFirstScreen=true;\">Create Another Appointment</button></div></div></div>");
$templateCache.put("app/modules/newappointment/others.html","<div style=\"margin-top:25px;\" class=\"active-appointments\"><div class=\"row\"><div class=\"col-md-8\"><form name=\"formotherappointments\" novalidate=\"\"><div class=\"form-create form-create-first card\" style=\"margin-top: -12px;\"><div class=\"form-signin\"><strong>Employee details</strong> <b>(Grade: {{dispGrade}})</b> <button class=\"btn btn-danger btn-sm pull-right\" ng-click=\"showFirst()\">Back</button><hr><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Employee name</label> <input placeholder=\"Employee Name\" type=\"text\" id=\"employeeName\" class=\"form-control\" readonly=\"\" ng-model=\"employee.name\"></div><div class=\"col-md-4\"><label for=\"\">Employee id</label> <input placeholder=\"Employee Id\" type=\"text\" id=\"employeeId\" class=\"form-control\" readonly=\"\" ng-model=\"employee.id\"></div><div class=\"col-md-4\"><label for=\"\">Employee gender</label> <input placeholder=\"Gender\" type=\"text\" id=\"gender\" class=\"form-control\" readonly=\"\" ng-model=\"employee.gender\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Age</label> <input placeholder=\"Age\" type=\"text\" id=\"age\" class=\"form-control\" readonly=\"\" ng-model=\"employee.age\"></div><div class=\"col-md-4\"><label for=\"\">Email address</label> <input placeholder=\"Email id\" type=\"text\" id=\"emailid\" class=\"form-control\" readonly=\"\" ng-model=\"employee.email\"></div><div class=\"col-md-4\"><label for=\"\">Mobile number</label> <input placeholder=\"Mobile number\" type=\"text\" id=\"mobilenumber\" class=\"form-control\" ng-model=\"employee.mobileNumber\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Alternate mobile number</label> <input placeholder=\"Alternate mobile number\" type=\"text\" id=\"altmobilenumber\" class=\"form-control\" ng-model=\"employee.alternateMobileNumber\"></div><div class=\"col-md-4\"><label for=\"\">Alternate email address</label> <input placeholder=\"Alternate Email address\" type=\"text\" id=\"altemailid\" ng-model=\"employee.alternateEmail\" class=\"form-control\"></div></div></div></div><div class=\"form-create card\"><div class=\"form-signin\"><strong>Beneficiary details</strong> <a href=\"\"><span class=\"glyphicon glyphicon-question-sign\" title=\"click to check beneficiary detail\" data-toggle=\"tooltip\" ng-click=\"showBenifDetails = !showBenifDetails\" ng-show=\"benifDetail\"></span></a><div ng-show=\"showBenifDetails && benifDetail\" style=\"margin-top:-18px;margin-left:155px; height: 30px;border: 2px solid; padding: 4px;background: #dddddd; border-top-left-radius :2em; border-top-right-radius :2em; border-bottom-left-radius :2em; border-bottom-right-radius: 2em;\"><p>Gender:<b>{{selectedBeneficiary.gender}}</b>, Relation name:<b>{{selectedBeneficiary.relationName}}</b>, Age:<b>{{benifAge}}</b></p></div><hr><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Select beneficiary to book appointment*</label><select name=\"\" id=\"benefId\" class=\"form-control\" ng-model=\"client.beneficiary\" ng-options=\"beneficiary as beneficiary.name for beneficiary in beneficiaries\" ng-change=\"selectBeneficiary(client.beneficiary)\" required=\"\"><option value=\"\">Select a beneficiary</option></select></div><div class=\"col-md-4\"><label for=\"\">Select a package for allowed list of packages</label><select name=\"\" id=\"packageId\" class=\"form-control\" ng-model=\"client.selectedPackage\" ng-options=\"package as package.packageName for package in packages\" ng-change=\"changePackage(client.selectedPackage)\" required=\"\"><option value=\"\">Select a package</option></select><label for=\"\" ng-show=\"priceToShowFlag\">Paid Package -- Rs. {{formatCurrency(priceToShow)}}</label></div><div class=\"col-md-4\"><label for=\"\">Select the mode in which this request was made</label><select name=\"\" id=\"requestMode\" class=\"form-control\" ng-model=\"client.requestMode\"><option value=\"\">Online</option><option value=\"\">Phone call</option><option value=\"\">Email</option></select></div></div></div></div><div class=\"form-create card\"><div class=\"form-signin\"><strong>Preferred diagnostic centers</strong><hr><div class=\"row\"><div class=\"col-md-3\"><label for=\"\">Select a state</label><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"current.newStateId\" ng-change=\"loadCities(current.newStateId)\"><option value=\"\">Select a state</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a city</label><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"newCityId\" ng-change=\"loadLocations(newCityId)\"><option value=\"\">Select a city</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a locality</label><select name=\"\" class=\"form-control\" ng-options=\"location as location.lookUpValue for location in locations\" ng-model=\"newLocationId\" ng-change=\"loadSubLocations(newLocationId)\"><option value=\"\">Select a locality</option></select></div><div class=\"col-md-3\"><label for=\"\">Select sub locality</label><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"newSubLocationId\" ng-change=\"loadDCs(newSubLocationId)\"><option value=\"\">Select sub locality</option></select></div></div></div></div><div ng-show=\"isGoogleMap\"><appt-creation-map dclist=\"diagnosticCentres\" controllerfrom=\"ctrlName\" controllerfunction=\"addToCart(firstPrefTime, firstAppointmentTime, secondPrefTime, secondAppointmentTime)\" showmarkerinfofunction=\"showMarkerInfo(markerObj)\"></appt-creation-map></div><div class=\"form-create card\" ng-show=\"isMappedDc\"><div class=\"form-signin\"><b style=\"color:red\">No DC mapped in this location.</b></div></div><hr></form></div><div class=\"col-md-4\" ng-show=\"orderObj.orderItems.length >0\"><div class=\"form-create form-create-first card cart\" style=\"margin-top: -12px;\"><div class=\"form-signin\"><h4>Your Cart</h4><hr><div class=\"cartEmpty\" ng-show=\"cartEmpty\"><div class=\"empty text-center\">Cart is empty</div></div><div id=\"cartItems\" ng-show=\"!cartEmpty\"><div ng-repeat=\"item in orderObj.orderItems\"><div class=\"row package-item\"><span class=\"col-md-8\">{{item.productName}}</span> <span class=\"col-md-4\">Rs.{{item.amount}}/-</span></div><div class=\"row benef-item\"><span class=\"col-md-8\">{{item.firstName}}</span> <span class=\"col-md-4\">{{item.isPaid?\"Paid\":\"Sponsored\"}}</span></div><div class=\"row\"><div class=\"col-md-8\"></div><div class=\"col-md-3\"><button class=\"btn btn-xs btn-block btn-danger delete\" value=\"\" id=\"{{item.productId}}\" ng-click=\"removeOrderItem(item, event)\">delete</button></div></div><hr></div></div><div class=\"row package-item\" ng-show=\"!cartEmpty\"><div class=\"col-md-8\">Grand total</div><div class=\"col-md-4\">Rs.{{totalPrice}}/-</div></div><hr></div></div><div class=\"form-create card\" ng-show=\"showPaid\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"paid\">Paid</label> <input type=\"radio\" id=\"paid\" name=\"optradio\" checked=\"checked\" value=\"\" ng-click=\"paid=true\"></div><div class=\"col-md-6\"><label for=\"unpaid\">Unpaid</label> <input type=\"radio\" id=\"unpaid\" name=\"optradio\" value=\"\" ng-click=\"paid=false\"></div></div><strong>Transaction details</strong><hr><div class=\"alert alert-danger\" ng-show=\"showPaid && paid\" role=\"alert\">Since this is a paid package, You need to fill the following <span class=\"strong\">Transaction details</span></div><div class=\"alert alert-danger\" ng-show=\"showPaid && !paid\" role=\"alert\">Unpaid orders will be collected in \"UnConfirmed Orders\" bucket. Once their availability is confirmed with DC, they will be approved and payment link will be sent to the user. These orders moves to active appointments, only after user makes the payment</div><div ng-show=\"showPaid && paid\"><label for=\"\">UTR number *</label> <input id=\"txnNumber\" class=\"form-control\" ng-model=\"txn.txnNumber\"></div></div></div><button class=\"btn btn-primary btn-block\" ng-click=\"createAppointment()\" ng-show=\"!cartEmpty\">Create appointment</button></div></div></div><div class=\"active-appointments\" ng-show=\"createresult\"><div class=\"card card-container firstScreen\"><div class=\"form-signin\"><label>Order created successfully</label><h4>Order id: {{orderData.orderId}}</h4><button class=\"btn btn-primary btn-block btn-signin\" type=\"submit\" ng-show=\"corporates.length!=0\" ng-click=\"showFirst()\" ng-disabled=\"\">Create Another Appointment</button></div></div></div>");
$templateCache.put("app/modules/newappointment/preemp.html","<div class=\"active-appointments\"><div class=\"row\"><div class=\"col-md-8\"><form name=\"preemploymentform\" novalidate=\"\"><div class=\"form-create form-create-first card\"><div class=\"form-signin\"><strong>Employee details</strong> <button class=\"btn btn-danger btn-sm pull-right\" ng-click=\"showFirst()\">Back</button><hr><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Employee name</label><span class=\"redfont\">*</span> <input placeholder=\"Employee Name\" type=\"text\" id=\"clientName\" class=\"form-control\" ng-model=\"employee.name\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Employee gender</label><span class=\"redfont\">*</span> <input placeholder=\"Gender\" type=\"text\" id=\"clientgender\" class=\"form-control\" ng-model=\"employee.gender\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Date of birth</label><span class=\"redfont\">*</span> <input placeholder=\"Date Of Birth\" id=\"dateOfBirth\" type=\"date\" class=\"form-control datepicker\" ng-model=\"employee.dob\" ng-change=\"getTotalAge(employee.dob)\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Age</label><span class=\"redfont\">*</span> <input placeholder=\"Age\" type=\"text\" id=\"clientage\" class=\"form-control\" ng-model=\"employee.age\" readonly=\"\"></div><div class=\"col-md-4\"><label for=\"\">Email address</label><span class=\"redfont\">*</span> <input placeholder=\"Email id\" type=\"text\" id=\"emailidPreEmp\" class=\"form-control\" ng-model=\"employee.email\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Mobile number</label><span class=\"redfont\">*</span> <input placeholder=\"Mobile number\" type=\"text\" id=\"mobilenumberPreEmp\" class=\"form-control\" ng-model=\"employee.mobileNumber\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Alternate mobile number</label> <input placeholder=\"Alternate mobile number\" type=\"text\" id=\"altmobilenumber\" class=\"form-control\" ng-model=\"employee.alternateMobileNumber\"></div><div class=\"col-md-4\"><label for=\"\">HR Email address</label><span class=\"redfont\">*</span> <input placeholder=\"HR Email id\" type=\"text\" id=\"altemailid\" class=\"form-control\" ng-model=\"employee.altemailid\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Offer id</label> <input placeholder=\"Offer ID\" type=\"text\" id=\"offerId\" class=\"form-control\" ng-model=\"client.clientCode\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Work location</label> <input placeholder=\"Work Location\" type=\"text\" id=\"clientLoc\" class=\"form-control\" ng-model=\"employee.city\"></div><div class=\"col-md-4\"><label for=\"\">Division/Entity</label> <input placeholder=\"Division/Entity\" type=\"text\" id=\"division\" class=\"form-control\" ng-model=\"employee.division\"></div><div class=\"col-md-4\"><label for=\"\">HR name</label><span class=\"redfont\">*</span> <input placeholder=\"HR name\" type=\"text\" id=\"hrname\" class=\"form-control\" ng-model=\"employee.hrName\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"\">Remarks</label> <input placeholder=\"Remarks\" type=\"text\" id=\"remarks\" class=\"form-control\" ng-model=\"employee.remarks\"></div></div></div></div><div class=\"form-create card\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">HR location</label><span class=\"redfont\">*</span> <input placeholder=\"HR Location\" type=\"text\" class=\"form-control\" ng-model=\"employee.hrLocation\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Package/Grade</label> <input placeholder=\"Package/Grade\" type=\"text\" class=\"form-control\" ng-model=\"employee.packageOrGrade\"></div><div class=\"col-md-4\"><label for=\"\">HR mobile no.</label><span class=\"redfont\">*</span> <input placeholder=\"HR Mobile no.\" type=\"text\" class=\"form-control\" ng-model=\"employee.hrMobileNumber\" required=\"\"></div></div></div></div><div class=\"form-create card\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Select a package</label><span class=\"redfont\">*</span><select name=\"\" id=\"packageId\" class=\"form-control\" ng-model=\"client.selectedPackage\" ng-options=\"package as package.pM_Name for package in packages\" ng-change=\"changePackage(client.selectedPackage)\" required=\"\"><option value=\"\">Select a package</option></select></div><div class=\"col-md-6\"><label for=\"\">Select visit type</label><span class=\"redfont\">*</span><select class=\"form-control\" ng-model=\"client.visitType\" ng-change=\"visitTypeChange(client.visitType)\" required=\"\"><option value=\"\">Select visit type</option><option value=\"Appointment\">Centre visit</option><option value=\"Home_Visit\">Home visit</option></select></div></div></div></div><div class=\"form-create card\" ng-show=\"client.visitType==\'Home_Visit\'\"><div class=\"form-signin\"><strong>Address for home visit</strong><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Address line 1</label> <input placeholder=\"Address Line 1\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline1\" ng-required=\"client.visitType==\'Home_Visit\'\"></div><div class=\"col-md-6\"><label for=\"\">Address line 2</label> <input placeholder=\"Address Line 2\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline2\" ng-required=\"client.visitType==\'Home_Visit\'\"></div></div></div></div><div class=\"form-create card\"><div class=\"form-signin\"><strong>Preferred diagnostic centers</strong><hr><div class=\"row\"><div class=\"col-md-3\"><label for=\"\">Select a state</label><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"current.newStateId\" ng-change=\"loadCities(current.newStateId)\"><option value=\"\">Select a state</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a city</label><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"newCityId\" ng-change=\"loadLocations(newCityId)\"><option value=\"\">Select a city</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a locality</label><select name=\"\" class=\"form-control\" ng-options=\"location as location.lookUpValue for location in locations\" ng-model=\"newLocationId\" ng-change=\"loadSubLocations(newLocationId)\"><option value=\"\">Select a locality</option></select></div><div class=\"col-md-3\"><label for=\"\">Select sub locality</label><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"newSubLocationId\" ng-change=\"loadDCs(newSubLocationId)\"><option value=\"\">Select sub locality</option></select></div></div></div></div><appt-creation-map dclist=\"diagnosticCentres\" controllerfrom=\"ctrlName\" showmarkerinfofunction=\"showMarkerInfo(markerObj, events)\" controllerfunction=\"addToCart(firstPrefTime, firstAppointmentTime, secondPrefTime, secondAppointmentTime)\"></appt-creation-map><div class=\"form-create card\" ng-show=\"isMappedDc\"><div class=\"form-signin\"><b style=\"color:red\">No DC mapped in this location.</b></div></div><hr></form></div><div class=\"col-md-4\"><div class=\"form-create form-create-first card cart\"><div class=\"form-signin\"><h4>Your cart</h4><hr><div class=\"cartEmpty\" ng-show=\"cartEmpty\"><div class=\"empty text-center\">Cart is empty</div></div><div id=\"cartItems\" ng-show=\"!cartEmpty\"><div ng-repeat=\"item in orderObj.orderItems\"><div class=\"row package-item\"><span class=\"col-md-8\">{{item.productName}}</span> <span class=\"col-md-4\">Rs.{{item.amount}}/-</span></div><div class=\"row benef-item\"><span class=\"col-md-8\">{{item.firstName}}</span> <span class=\"col-md-4\">{{item.cityName}}</span></div><div class=\"row\"><div class=\"col-md-8\"></div><div class=\"col-md-3\"><button class=\"btn btn-xs btn-block btn-danger delete\" value=\"\" id=\"{{item.productId}}\" ng-click=\"removeOrderItem(item, event)\">delete</button></div></div><hr></div></div><div class=\"row package-item\" ng-show=\"!cartEmpty\"><div class=\"col-md-8\">Grand total</div><div class=\"col-md-4\">Rs.{{totalPrice}}/-</div></div><hr></div></div><div class=\"form-create card\" ng-show=\"showPaid\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"paid\">Paid</label> <input type=\"radio\" id=\"paid\" name=\"optradio\" checked=\"checked\" value=\"\" ng-click=\"paid=true\"></div><div class=\"col-md-6\"><label for=\"unpaid\">Unpaid</label> <input type=\"radio\" id=\"unpaid\" name=\"optradio\" value=\"\" ng-click=\"paid=false\"></div></div><strong>Transaction details</strong><hr><div class=\"alert alert-danger\" ng-show=\"showPaid && paid\" role=\"alert\">Since this is a paid package, You need to fill the following <span class=\"strong\">Transaction details</span></div><div class=\"alert alert-danger\" ng-show=\"showPaid && !paid\" role=\"alert\">Unpaid orders will be collected in \"UnConfirmed Orders\" bucket. Once their availability is confirmed with DC, they will be approved and payment link will be sent to the user. These orders moves to active appointments, only after user makes the payment</div><div ng-show=\"showPaid && paid\"><label for=\"\">UTR Number *</label> <input id=\"txnNumberPreEmp\" class=\"form-control\" ng-model=\"txn.txnNumber\"></div></div></div><button class=\"btn btn-primary btn-block\" ng-click=\"createAppointment()\" ng-show=\"!cartEmpty\">Create Appointment</button></div></div></div>");
$templateCache.put("app/modules/newappointment/prepolicy.html","<div class=\"active-appointments\"><style>\n        #map {\n            height: 100%;\n        }\n        /* Optional: Makes the sample page fill the window. */\n        html, body {\n            height: 100%;\n            margin: 0;\n            padding: 0;\n        }\n\n        #description {\n            font-family: Roboto;\n            font-size: 15px;\n            font-weight: 300;\n        }\n\n        #infowindow-content .title {\n            font-weight: bold;\n        }\n\n        #infowindow-content {\n            display: none;\n        }\n\n        #map #infowindow-content {\n            display: inline;\n        }\n\n        .pac-card {\n            margin: 10px 10px 0 0;\n            border-radius: 2px 0 0 2px;\n            box-sizing: border-box;\n            -moz-box-sizing: border-box;\n            outline: none;\n            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n            background-color: #fff;\n            font-family: Roboto;\n        }\n\n        #pac-container {\n            padding-bottom: 12px;\n            margin-right: 12px;\n        }\n\n        .pac-controls {\n            display: inline-block;\n            padding: 5px 11px;\n        }\n\n            .pac-controls label {\n                font-family: Roboto;\n                font-size: 13px;\n                font-weight: 300;\n            }\n\n        #pac-input {\n            background-color: #fff;\n            font-family: Roboto;\n            font-size: 15px;\n            font-weight: 300;\n            margin-left: 12px;\n            padding: 0 11px 0 13px;\n            text-overflow: ellipsis;\n            width: 400px;\n        }\n\n            #pac-input:focus {\n                border-color: #4d90fe;\n            }\n\n        #title {\n            color: #fff;\n            background-color: #4d90fe;\n            font-size: 25px;\n            font-weight: 500;\n            padding: 6px 12px;\n        }\n\n        #target {\n            width: 345px;\n        }\n\n        .slideBox {\n            position: absolute;\n            top: 0;\n            right: 0;\n            width: 0;\n            opacity: 0;\n            visibility: hidden;\n            height: 100%;\n            z-index: 9999;\n            background: rgba(0,0,0,.5);\n        }\n\n            .slideBox .slideContent {\n                position: fixed !important;\n                overflow: auto;\n                background: #fff;\n                right: 0;\n                top: 0 !important;\n                bottom: 0 !important;\n                margin: 0 !important;\n                height: 100%;\n                max-width: 640px;\n                width: 80% !important;\n            }\n\n            .slideBox.in {\n                visibility: visible;\n                opacity: 1;\n                width: 100%;\n                transition: all .3s ease;\n            }\n\n        .multiSelectJustified .multiselect-parent {\n            width: 100%;\n        }\n\n        .multiSelectJustified .btn {\n            width: 100%;\n            text-align: left;\n        }\n\n            .multiSelectJustified .btn .caret {\n                float: right;\n                margin-top: 8px;\n            }\n    </style><form name=\"prepolicyform\" novalidate=\"\"><div class=\"form-create card\" style=\"padding-bottom:10px;\"><div class=\"form-signin\"><strong>Customer details</strong> <button class=\"btn btn-danger btn-xs pull-right\" ng-click=\"showFirst()\">Back</button> <a class=\"btn btn-info btn-xs pull-right\" ng-model=\"collapse\" ng-show=\"getDetailsHelp\" ng-click=\"isCostomerDetails=!isCostomerDetails\" style=\"margin-right:10px;\"><i class=\"glyphicon glyphicon-question-sign\"></i> Help</a><div ng-if=\"showDndDiv\" class=\"pull-right\" style=\"margin-right: 10px; font-size: 20px;\"><a ng-show=\"showDndBell\"><request-dnd-modal requestdata=\"requestDataForDND\" dndcustomer=\"false\" dnd=\"true\" bell=\"showDndBell\"><i class=\"fa fa-bell\" uib-tooltip=\"DND\"></i></request-dnd-modal></a> <a ng-show=\"!showDndBell\"><request-dnd-modal requestdata=\"requestDataForDND\" dndcustomer=\"false\" dnd=\"true\" bell=\"showDndBell\"><i class=\"fa fa-bell-slash\" uib-tooltip=\"DND\"></i></request-dnd-modal></a> <a ng-show=\"showDndCustomerBell\"><request-dnd-modal requestdata=\"requestDataForDND\" dndcustomer=\"true\" dnd=\"false\" bell=\"showDndCustomerBell\"><i class=\"fa fa-bell\" uib-tooltip=\"DND Customer\"></i></request-dnd-modal></a> <a ng-show=\"!showDndCustomerBell\"><request-dnd-modal requestdata=\"requestDataForDND\" dndcustomer=\"true\" dnd=\"false\" bell=\"showDndCustomerBell\"><i class=\"fa fa-bell-slash\" uib-tooltip=\"DND Customer\"></i></request-dnd-modal></a></div><hr><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Customer name</label> <input placeholder=\"Enter customer name\" name=\"clientName\" type=\"text\" id=\"clientName\" class=\"form-control\" ng-model=\"employee.name\" required=\"\"></div><div class=\"col-md-2\"><label for=\"\">Gender</label><select class=\"form-control\" ng-model=\"employee.gender\"><option value=\"\">Select gender</option><option value=\"Male\">Male</option><option value=\"Female\">Female</option></select></div><div class=\"col-md-2\"><label for=\"\">Age</label> <input placeholder=\"Enter age\" type=\"number\" id=\"clientage\" class=\"form-control\" ng-model=\"employee.age\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Annual premium</label> <input placeholder=\"Enter annual premium\" name=\"annualPremium\" type=\"number\" id=\"annualPremium\" class=\"form-control\" ng-model=\"employee.annualPremium\"></div><div class=\"col-md-4\"><label for=\"\">Email address</label> <input placeholder=\"Enter email address\" type=\"text\" id=\"emailidPreEmp\" class=\"form-control\" ng-model=\"employee.email\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Mobile number</label> <input placeholder=\"Enter Mobile number\" type=\"text\" id=\"mobilenumberPreEmp\" class=\"form-control\" ng-model=\"employee.mobileNumber\" required=\"\"></div><div class=\"col-md-4\"><label for=\"\">Application / Policy number</label> <input placeholder=\"Enter application / policy number\" type=\"text\" id=\"applicationNumber\" class=\"form-control\" ng-model=\"client.clientCode\"></div><div class=\"col-md-4\"><label for=\"\">Life number</label> <input placeholder=\"Enter life NO.\" type=\"text\" id=\"lifeNo\" class=\"form-control\" ng-model=\"employee.lifeno\"></div><div class=\"col-md-4\"><label for=\"\">Remarks</label> <input placeholder=\"Enter remarks..\" type=\"text\" id=\"remarks\" class=\"form-control\" ng-model=\"employee.remarks\"></div><div class=\"col-md-4\"><label for=\"\">Agent Email address</label> <input ng-pattern=\"emailchk\" placeholder=\"Enter agent email address\" type=\"email\" id=\"AgentEmailAddress\" class=\"form-control\" name=\"emailAddress\" ng-model=\"employee.agentEmailAddress\"><p class=\"errorClass\" ng-show=\"prepolicyform.emailAddress.$error.pattern\">Invalid email address.</p></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Insurance name</label> <input placeholder=\"Enter insurance name\" type=\"text\" id=\"insurername\" class=\"form-control\" ng-model=\"agentDetails.insuranceCompanyName\" readonly=\"\"></div><div class=\"col-md-4\"><label for=\"\">Agent name</label> <input placeholder=\"Enter agent name\" type=\"text\" id=\"AgentName\" class=\"form-control\" ng-model=\"agentDetails.agentName\" readonly=\"\"></div><div class=\"col-md-4\"><label for=\"\">Agent code</label> <input placeholder=\"Enter agent code\" type=\"text\" id=\"agentCode\" class=\"form-control\" ng-model=\"agentDetails.agentCode\" readonly=\"\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Agent mobile number</label> <input placeholder=\"Enter agent mobile number\" type=\"text\" id=\"agentMobileNumber\" class=\"form-control\" ng-model=\"agentDetails.agentMobileNo\" readonly=\"\"></div><div class=\"col-md-4\"><label for=\"\">Sum assured</label> <input placeholder=\"Enter sum assured\" type=\"text\" id=\"sumAssured\" class=\"form-control\" ng-model=\"sumassuredetail.sumAssured\"></div><div class=\"col-md-4\"><label for=\"\">Paid/Sponsored</label><select ng-model=\"sumassuredetail.paidSpons\" class=\"form-control\"><option value=\"sponsored\">Sponsored</option><option value=\"paid\">Paid</option></select></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Group/Individual</label><select ng-model=\"sumassuredetail.grpIndv\" class=\"form-control\"><option value=\"individual\">Individual</option><option value=\"group\">Group</option></select></div></div></div></div><div class=\"form-create card\" style=\"padding-bottom:10px;\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"packageSelection\">Select appropriate package</label><div ng-dropdown-multiselect=\"\" options=\"packages\" extra-settings=\"example2settings\" selected-model=\"selectedPackageForAdvance\" translation-texts=\"example5customTexts\" checkboxes=\"true\" style=\"margin-bottom:15px;\" class=\"multiSelectJustified\"></div></div><div class=\"col-md-3\" ng-show=\"selectedPackageForAdvance.length >0\"><label for=\"\">View packages</label> <button class=\"btn btn-info btn-block\" data-toggle=\"modal\" data-target=\"#selectedPacakgesList\">View Details</button></div><div class=\"col-md-3\" ng-show=\"selectedPackageForAdvance.length >0\"><label for=\"\">Select visit type</label><select class=\"form-control\" ng-model=\"client.visitType\" ng-change=\"visitTypeChange(client.visitType)\" required=\"\"><option value=\"\">Select Visit type</option><option value=\"Appointment\">Centre visit</option><option value=\"Home_Visit\">Home visit</option></select></div></div></div></div><div class=\"form-create card\" ng-if=\"client.visitType===\'Home_Visit\'\" style=\"padding-bottom:10px;\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-12\"><div ng-show=\"client.visitType===\'Home_Visit\'\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Address line 1</label> <input placeholder=\"Enter address line 1..\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline1\" ng-required=\"client.visitType===\'Home_Visit\'\"></div><div class=\"col-md-6\"><label for=\"\">Address line 2</label> <input placeholder=\"Enter address line 2..\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline2\" ng-required=\"client.visitType===\'Home_Visit\'\"></div></div></div></div></div></div></div><div class=\"form-create card\" ng-show=\"selectedPackageForAdvance.length >0\" style=\"padding-bottom:10px;\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"btn-group btn-group-justified\" style=\"margin-bottom:15px;\"><label class=\"btn btn-primary\" ng-model=\"radioModel\" uib-btn-radio=\"\'Left\'\" ng-click=\"DCSelection(\'advance\')\">Advance DC selection</label> <label class=\"btn btn-primary\" ng-model=\"radioModel\" uib-btn-radio=\"\'Middle\'\" ng-click=\"DCSelection(\'manula\')\">Manual DC selection</label></div></div><div class=\"col-md-4\" ng-show=\"isPackageSelectionAdvance\"><select name=\"\" class=\"form-control\" ng-options=\"distance as distance.value for distance in distances\" ng-model=\"distance\" ng-change=\"changeDistance(distance)\"><option value=\"\">Select radius</option></select></div><div class=\"col-md-4\" ng-show=\"isPackageSelectionAdvance\"><input type=\"text\" class=\"form-control\" gm-places-autocomplete=\"\" ng-model=\"locationName.autocomplete\"></div></div><div class=\"row\" ng-if=\"isPackageSelectionManual || isPackageSelectionAdvance\" style=\"margin-top: 10px;\"><div class=\"col-md-6\"><div class=\"row\">{{firstDate}} {{secondDate}}<div class=\"col-xs-8 dateBox\"><label for=\"\">First preference</label> <input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"manual.firstDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" style=\"width: 140px;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\" style=\"margin-left: 138px; margin-top: -83px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"col-xs-4 p-l-0 timeBox\" style=\"margin-left: 210px; margin-top: -102px;\"><div uib-timepicker=\"\" ng-model=\"manual.firstTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div></div><div class=\"col-md-2\"><dc-notes id=\"selectedDcFromDavanceSearch.id\"><button style=\"margin-top: 22px;\" class=\"btn f\">Outsourcing Details</button></dc-notes></div><div class=\"col-md-4\"></div></div><div class=\"row\" ng-if=\"isPackageSelectionManual\" style=\"margin-top: 10px; margin-bottom: 60PX;\"><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"current.newStateId\" ng-change=\"loadCitiesNew(current.newStateId)\"><option value=\"\">Select state</option></select></div><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"newCityId\" ng-change=\"loadLocationsNew(newCityId)\"><option value=\"\">Select city</option></select></div><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"newSubLocationId\" ng-change=\"loadDcForAllPackages(newSubLocationId)\"><option value=\"\">Select locality</option></select></div><div class=\"col-md-3\"><select name=\"preferreddc1\" id=\"firstDCIdPreEmp\" ng-model=\"client.preferredDC1\" class=\"form-control\" ng-options=\"dc as dc.entityName for dc in diagnosticCentres\" ng-change=\"selectedDcFromMap(client.preferredDC1)\"><option value=\"\">Select diagnostic centre</option></select></div></div><div class=\"row\" ng-if=\"isPackageSelectionManual\" style=\"margin-top: 10px; margin-bottom: 30PX;\"><div class=\"col-md-12\"><button ng-disabled=\"!manual.firstDate || !client.preferredDC1 || !client.visitType\" ng-click=\"bookAppointmentDate(manual.firstDate, manual.secondDate, manual.firstTime, manual.secondTime)\" class=\"btn btn-primary pull-right\">Add to cart</button></div></div></div></div><div class=\"row\" ng-if=\"markerArray.length >0 && isPackageSelectionAdvance\"><div class=\"col-md-12\"><ui-gmap-google-map center=\"map.center\" control=\"\" zoom=\"map.zoom\" bounds=\"map.bounds\" draggable=\"true\" options=\"map.options\"><ui-gmap-circle center=\"map.center\" stroke=\"map.stroke\" fill=\"map.fill\" radius=\"map.radius\" visible=\"map.visible\" geodesic=\"c.geodesic\" editable=\"c.editable\" draggable=\"map.draggable\" clickable=\"map.clickable\"><ui-gmap-marker models=\"randomMarkers1\" coords=\"map.center\" idkey=\"\"><i class=\"fa fa-user\"></i></ui-gmap-marker><ui-gmap-marker ng-repeat=\"marker in markerArray\" click=\"selectedDcFromMap(marker, $event)\" models=\"randomMarkers\" events=\"map.markersEvents\" coords=\"marker.coords\" idkey=\"marker.id\"><ui-gmap-window options=\"windowOpt\" closeclick=\"map.window.closeClick(marker)\" show=\"marker.visible\" templateurl=\"\'/app/modules/newappointment/windowContent.html\'\" templateparameter=\"windowParams\"></ui-gmap-window></ui-gmap-marker></ui-gmap-circle></ui-gmap-google-map></div></div><div class=\"row\" ng-if=\"markerArray.length ===0 && isMarkerArray\"><div class=\"col-md-12\"><div class=\"text-center\" style=\"margin-bottom: 30px; padding-top: 20px; background-color: #e0dede; padding-bottom: 18px;\">No diagnostic centre found.</div></div></div></form><div class=\"slideBox\" ng-class=\"isCostomerDetails ? \'in\': \'\'\"><div class=\"slideContent\"><div class=\"modal-header\"><a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"isCostomerDetails=!isCostomerDetails\"><span aria-hidden=\"true\">&times;</span></a><h4 class=\"modal-title\">Customer additonal details</h4></div><div class=\"modal-body\"><h4>Few details for your refrence</h4><table><tr><td style=\"width: 140px;\">Name:</td><td><b>{{getDetailsHelp.name}}</b></td></tr><tr><td>Address:</td><td><b>{{getDetailsHelp.addressLine1}}</b></td></tr><tr><td>City:</td><td><b>{{getDetailsHelp.city}}</b></td></tr><tr><td>State:</td><td><b>{{getDetailsHelp.state}}</b></td></tr><tr><td>Mobile number:</td><td><b>{{getDetailsHelp.mobileNumber}}</b></td></tr><tr><td>Preferred DC name:</td><td><b>{{getDetailsHelp.preferredDCName}}</b></td></tr><tr><td>DC state:</td><td><b>{{getDetailsHelp.state}}</b></td></tr><tr><td>DC city:</td><td><b>{{getDetailsHelp.dcCity}}</b></td></tr></table><h4 style=\"margin-top: 30px;\" ng-if=\"getDetailsHelpTestDetails.length >0\">Test details for your refrence</h4><table ng-repeat=\"details in getDetailsHelpTestDetails\"><tr><td style=\"width: 140px;\">Name:</td><td><b>{{details.testName}}</b></td></tr><tr><td>Description:</td><td><b>{{details.testDesc}}</b></td></tr><tr><td>Visit type:</td><td><b>{{details.visitType}}</b></td></tr><tr ng-if=\"details.appointmentTime\"><td>Appointment time:</td><td><b>{{details.appointmentTime}}</b></td></tr><tr ng-if=\"details.appointmentDate\"><td>Appointment date:</td><td><b>{{compareDate(details.appointmentDate)}}</b></td></tr></table><h4 style=\"margin-top: 30px;\">Add additional information</h4><div class=\"row\"><div class=\"col-md-4\"><label for=\"additional\"><select class=\"form-control\" id=\"additional\" name=\"additional\" ng-model=\"field.fieldName\"><option disabled=\"\" value=\"\">Select</option><option ng-repeat=\"item in additionalFieldList\" value=\"{{item}}\">{{item}}</option></select></label></div><div class=\"col-md-4\"><label for=\"fieldValue\"><input class=\"form-control\" ng-disabled=\"!field.fieldName\" name=\"fieldValue\" id=\"fieldValue\" ng-model=\"field.fieldValue\" placeholder=\"Enter {{field.fieldName}}\" style=\"border-radius: 0;\"></label></div><div class=\"col-md-2\"><span><button class=\"btn btn-primary\" ng-disabled=\"!field.fieldValue\" ng-click=\"addToAdditionDetails()\" style=\"margin:0;\">Add</button></span></div></div><p ng-repeat=\"(key, value) in additionalinfo\" style=\"margin-top: 10px;\"><span style=\"font-size: larger; font-weight: 500;\">{{key}}</span> : {{value}}</p></div></div></div></div><div class=\"slideBox\" ng-class=\"isCart ? \'in\': \'\'\"><div class=\"slideContent\"><div class=\"modal-header\"><a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"closeCart()\"><span aria-hidden=\"true\">&times;</span></a><h4 class=\"modal-title\">You are booking packages for <span style=\"color:#4d90fe;\">{{employee.name}}</span><br><span style=\"font-size:14px;\">at <b>{{selectedDcFromDavanceSearch.name}}</b>, {{selectedDcFromDavanceSearch.entityAddress}}</span></h4></div><div class=\"modal-body\"><div class=\"cartEmpty\" ng-show=\"cartEmpty\"><div class=\"empty text-center\">Cart is empty</div></div><div id=\"cartItems\" ng-show=\"!cartEmpty\"><div>Ap</div><div ng-repeat=\"item in orderObj.orderItems\"><div class=\"row package-item\"><div class=\"col-md-7\">{{item.productName}}</div><div class=\"col-md-3 text-right\">Rs.{{item.amount}}/-</div><div class=\"col-md-2 text-right\"><button class=\"btn btn-xs btn-block btn-danger delete\" value=\"\" id=\"{{item.productId}}\" ng-click=\"removeOrderItem(item, event)\">Remove</button></div></div><hr></div></div><div class=\"row package-item\" ng-if=\"!cartEmpty && orderObj.orderItems.length >0\" style=\"margin-bottom: 10px;\"><div class=\"col-md-7\">Grand total</div><div class=\"col-md-3 text-right\">Rs.{{totalPrice}}/-</div><div class=\"col-md-2\"></div></div><div class=\"form-create card\" ng-show=\"showPaid\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"paid\">Paid</label> <input type=\"radio\" id=\"paid\" name=\"optradio\" checked=\"checked\" value=\"\" ng-click=\"paid=true\"></div><div class=\"col-md-6\"><label for=\"unpaid\">Unpaid</label> <input type=\"radio\" id=\"unpaid\" name=\"optradio\" value=\"\" ng-click=\"paid=false\"></div></div><strong>Transaction details</strong><hr><div class=\"alert alert-danger\" ng-show=\"showPaid && paid\" role=\"alert\">Since this is a paid package, You need to fill the following <span class=\"strong\">Transaction details</span></div><div class=\"alert alert-danger\" ng-show=\"showPaid && !paid\" role=\"alert\">Unpaid orders will be collected in \"UnConfirmed Orders\" bucket. Once their availability is confirmed with DC, they will be approved and payment link will be sent to the user. These orders moves to active appointments, only after user makes the payment</div><div ng-show=\"showPaid && paid\"><label for=\"\">UTR number *</label> <input id=\"txnNumberPreEmp\" class=\"form-control\" ng-model=\"txn.txnNumber\"></div></div></div><button class=\"btn btn-primary btn-block\" ng-click=\"checkDuplicacy()\" ng-show=\"!cartEmpty && orderObj.orderItems.length >0\">Create Appointment</button></div></div></div><div class=\"modal fade\" id=\"selectedPacakgesList\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\" style=\"padding:0 15px;\"><a href=\"\"><span class=\"pull-right\" data-dismiss=\"modal\"><b>X</b></span></a><h4>Selected packages</h4></div><div class=\"modal-body\" id=\"chooseDCBody\"><ul><li ng-repeat=\"item in selectedPackageForAdvance\">{{item.packageName}}<br></li></ul></div></div></div></div><div class=\"modal fade\" id=\"BookAppointmentAdvance\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-dialog-custom modal-lg\" role=\"document\"><form name=\"advanceAppointment\" novalidate=\"\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"text-center\" ng-click=\"bookAppointmentDate(firstDate, secondDate, firstTime, secondTime)\">Book appointment</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-5\"><h4 class=\"hdng\" style=\"margin-top: 13px; padding-bottom: 25px; margin-left: 5px;\">DC details</h4><div class=\"row\" style=\"margin-left: 20px;\"><div class=\"col-xs-8 dateBox\" style=\"margin-bottom: 2px;\"><label for=\"\">Name :</label>{{selectedDcFromDavanceSearch.name}}</div><div class=\"col-xs-8 dateBox\" style=\"margin-bottom: 2px;\"><label for=\"\">Address :</label>{{selectedDcFromDavanceSearch.entityAddress}}</div><div class=\"col-xs-8 dateBox\" style=\"margin-bottom: 2px;\"><label for=\"\">PinCode :</label> {{selectedDcFromDavanceSearch.pinCode}}</div></div></div><div class=\"col-sm-7\"><h4 class=\"hdng\" style=\"margin-top: 13px; padding-bottom: 25px;\">Select date and time</h4><div class=\"row\"><div class=\"col-xs-8 dateBox\"><label for=\"\">First preference</label> <input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"firstDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" style=\"width: 140px;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\" style=\"margin-left: 138px; margin-top: -52px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"col-xs-4 p-l-0 timeBox\" style=\"margin-left: 210px; margin-top: -86px;\"><div uib-timepicker=\"\" ng-model=\"firstTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><div class=\"row m-t-10\"><div class=\"col-xs-8 dateBox\"><label for=\"\">Second preference</label> <input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"secondDate\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" style=\"width: 140px;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\" style=\"margin-left: 138px; margin-top: -52px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"col-xs-4 p-l-0 timeBox\" style=\"margin-left: 210px; margin-top: -86px;\"><div uib-timepicker=\"\" ng-model=\"secondTime\" max=\"maxFirst\" min=\"minFirst\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div></div></div></div><div class=\"modal-footer\"><button ng-disabled=\"advanceAppointment.$invalid || !secondTime || !firstTime || !client.visitType\" class=\"btn btn-primary\" ng-click=\"bookAppointmentDate(firstDate, secondDate, firstTime, secondTime)\" data-dismiss=\"modal\">Add to cart</button> <button type=\"button\" class=\"btn btn-danger pull-right\" data-dismiss=\"modal\">Close</button></div></div></form></div></div>");
$templateCache.put("app/modules/newappointment/windowContent.html","<div>{{windowParams}}<h3>{{parameter.list.entityName}}</h3><p>{{parameter.list.entityAddress}} - {{parameter.list.pinCode}}</p><span><button ng-click=\"parameter.doIt(selectedDcFromDavanceSearch)\" class=\"btn btn-primary center-block bookApp BookAppointmentBlock\" data-name=\"{{parameter.list.name}}\">Schedule appointment</button></span></div>");
$templateCache.put("app/modules/orderPunching/orderPunching.html","<style>\n    table {\n      font-family: arial, sans-serif;\n      border-collapse: collapse;\n      width: 100%;\n    }\n    \n    td, th {\n      border: 1px solid #dddddd;\n      text-align: left;\n      padding: 8px;\n    }\n    \n    tr:nth-child(even) {\n      background-color: #dddddd;\n    }\n</style><h3 style=\"margin:0 0 20px 0\"><span>Order Punching</span></h3><hr style=\"margin:10px 0;\"><div class=\"row\"><div class=\"col-sm-12\"><form role=\"form\" name=\"verifyDetails\" ng-submit=\"verifyUser(verifyDetails.$valid)\"><div class=\"col-md-6 m-b-10\"><label>Mobile Number</label> <input type=\"text\" class=\"form-control\" numbers-only=\"numbers-only\" ng-class=\"{\'has-error\':verifyDetails.$submitted && !verifyDetails.phone.$valid}\" ng-model=\"userInfo.Phone\" name=\"phone\" ng-pattern=\"/^((6|7|8|9)).{9}$/\" placeholder=\"Enter Mobile\" id=\"phone\" required=\"\"></div><div class=\"col-md-6 m-b-10 p-r-0\"><label>Email</label> <input type=\"email\" name=\"email\" ng-disabled=\"userInfo.Check\" ng-class=\"{\'has-error\':verifyDetails.$submitted && !verifyDetails.email.$valid}\" class=\"form-control\" ng-model=\"userInfo.Email\" placeholder=\"Enter Email\" id=\"email\"></div><div class=\"col-md-6 m-b-10 p-r-0 m-t-20\" style=\"float:right\"><input type=\"checkbox\" id=\"check\" name=\"check\" ng-model=\"userInfo.Check\"> <label>Tick if the above email id is not of user</label><br></div><div class=\"col-md-12 m-b-10 text-center\"><button class=\"btn m-t-10 btn-primary\">Verify</button></div></form></div></div><div ng-if=\"showMessage\" class=\"text-center\" style=\"padding-top:20px; font-size: x-large;\"><b>User Already Present</b></div><div ng-if=\"!verified\" style=\"margin-top:50px\"><div class=\"row\"><div class=\"col-sm-12\"><form role=\"form\" name=\"userOderForm\" novalidate=\"\"><div class=\"col-md-6 m-b-10\"><label>Name</label> <input type=\"text\" class=\"form-control\" ng-model=\"userInfo.firstName\" ng-class=\"{\'has-error\':userOderForm.$submitted && !userOderForm.name.$valid}\" placeholder=\"Enter Name\" id=\"name\" name=\"name\" required=\"\"></div><div class=\"col-md-6 m-b-10 p-r-0\"><label>Email</label> <input type=\"email\" name=\"email\" ng-disabled=\"userInfo.Check\" ng-class=\"{\'has-error\':userOderForm.$submitted && !userOderForm.email.$valid}\" class=\"form-control\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" ng-model=\"userInfo.Email\" placeholder=\"Enter Email\" id=\"email\" required=\"\"></div><div class=\"col-md-6 m-b-10\"><label>Mobile Number</label> <input type=\"text\" class=\"form-control\" numbers-only=\"numbers-only\" ng-class=\"{\'has-error\':userOderForm.$submitted && !userOderForm.phone.$valid}\" ng-model=\"userInfo.Phone\" name=\"phone\" ng-pattern=\"/^((6|7|8|9)).{9}$/\" placeholder=\"Enter Mobile\" id=\"phone\" required=\"\"></div><div class=\"col-md-6 m-b-10 p-r-0\"><label>Select Gender</label><select class=\"form-control\" ng-model=\"userInfo.gender\" id=\"gender\" ng-class=\"{\'has-error\':userOderForm.$submitted && !userOderForm.gender.$valid}\" required=\"\" ng-options=\"gender.value as gender.title for gender in genderList\" name=\"gender\" placeholder=\"Select Gender\"></select></div><div class=\"col-md-6 m-b-10\"><label>Date of Birth</label> <input type=\"date\" id=\"dob\" class=\"form-control\" ng-model=\"userInfo.DateOfBirth\" ng-class=\"{\'has-error\':userOderForm.$submitted && !userOderForm.dob.$valid}\" max=\"{{today}}\" required=\"\" name=\"dob\"></div><div class=\"col-md-6 m-b-10 p-r-0\"><label for=\"prefdate\">Preferred date and time</label> <input type=\"datetime-local\" class=\"form-control\" ng-class=\"{\'has-error\':userOderForm.$submitted && !userOderForm.prefDate.$valid}\" id=\"prefdate\" name=\"prefDate\" ng-model=\"userInfo.PrefDateTime\" required=\"\"></div><div class=\"col-md-6 m-b-10\"><label>Address</label> <textarea class=\"form-control\" id=\"address\" ng-model=\"userInfo.AddressLine1\" name=\"address\" rows=\"3\" required=\"\" ng-class=\"{\'has-error\':userOderForm.$submitted && !userOderForm.address.$valid}\"></textarea></div><div class=\"col-md-6 m-b-10 text-right m-t-20\"><button ng-click=\"displayOrderForm = userOderForm.$valid ? true:false\" class=\"btn m-t-10 btn-primary\">Select Packages</button></div></form></div></div><div ng-if=\"displayOrderForm && userOderForm.$valid\" class=\"row\"><div class=\"col-sm-12\"><h5 style=\"font-size: 20px; padding-top: 50px;\">Create order</h5><hr style=\"margin:10px 0;\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"from-email\">Contracts</label><select name=\"contracts\" required=\"\" id=\"contracts\" class=\"form-control\" ng-model=\"filter.contractId\" ng-options=\"contract.categoryItemTypeId as contract.value for contract in eligibleContracts\" ng-change=\"onContractSelect()\" ng-disabled=\"productsArray.length\"></select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"from-email\">City</label><select name=\"city\" required=\"\" id=\"city\" class=\"form-control\" ng-model=\"filter.city\" ng-options=\"city as city for city in cities\" ng-change=\"onSelectCity()\" ng-disabled=\"!filter.citylist || productsArray.length\"></select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"from-email\">Select Package</label><select name=\"packages\" required=\"\" id=\"packages\" class=\"form-control\" ng-model=\"filter.packageId\" ng-change=\"onSelectPackage()\" ng-disabled=\"!filter.contract\"><option ng-repeat=\"item in packageList\" ng-if=\"!item.isAdded\" value=\"{{item.packageId}}\">{{item.packageName}}</option></select></div></div><div class=\"col-md-2 checkbox form-group\"><label></label><div class=\"text-left\"><label style=\"font-weight: 700;\"><input id=\"critical\" type=\"checkbox\" name=\"past\" ng-model=\"filter.IsPastBooking\"> Is Past Order</label></div></div><div class=\"col-md-12 m-b-10 text-center m-t-20\"><button class=\"btn btn-primary\" ng-disabled=\"!filter.packageId\" ng-click=\"addProducts()\">{{updateIdx > -1 ? \'Update\' : \'Add\'}}</button></div></div></div><div ng-if=\"productsArray.length\"><hr style=\"margin:15px 0; padding-top: 50px;\"><h6 style=\"font-size: 20px;\">Order details</h6><table><thead><tr><td colspan=\"4\" style=\"font-weight: bold;\">City : {{ filter.city }}</td></tr></thead><tr><th>Category</th><th>Package</th><th>Past Order</th><th>Edit</th></tr><tr ng-repeat=\"obj in productsArray track by $index\"><td>{{obj.categoryItemTypeId == eligibleContracts[0].categoryItemTypeId ? eligibleContracts[0].value : eligibleContracts[1].value}}</td><td>{{obj.packageDetail.packageName}}</td><td>{{obj.packageDetail.IsPastBooking ? \"Yes\" : \"No\"}}</td><td><button ng-click=\"updateDetails($index)\" ng-disabled=\"editing\" class=\"btn btn-info\">Edit</button> <button ng-click=\"deleteDetails(obj)\" ng-disabled=\"editing\" class=\"btn btn-danger\">Delete</button></td></tr></table><div class=\"col-md-6 m-b-10 text-right m-t-20\"><button class=\"btn btn-primary\" ng-click=\"createOrder()\" ng-disabled=\"waiting\">Submit</button></div><div id=\"page-down\"></div></div></div>");
$templateCache.put("app/modules/notification/maNotifications.html","<h3 style=\"margin-top: -5px; font-size: xx-large;\">Notification</h3><div ng-if=\"notificationData.length===0\" style=\"color: brown; font-size: initial;\">No pending notification to show.</div><div ng-if=\"notificationData.length > 0\"><table class=\"table table-striped\" style=\"margin-top:20px; background:#fff;\"><tbody><tr><td>Sno.</td><td><strong>RequestId</strong></td><td><strong>Correspondence type</strong></td><td><strong>Receiver</strong></td><td><strong>Type</strong></td><td><strong>NotificationTime</strong></td><td><strong>Reason</strong></td><td><strong>Created on</strong></td><td><strong>Mark completed</strong></td></tr><tr ng-repeat=\"item in notificationData track by $index\"><td>{{$index+1}}</td><td>{{item.RequestID}}</td><td>{{item.CorrespondenceType}}</td><td>{{item.Receiver}}</td><td><strong>{{item.NotificationType}}</strong></td><td><strong>{{compareDate(item.NotificationTime)}} at {{formatTime(item.NotificationTime)}}</strong></td><td>{{item.Reason}}</td><td>{{compareDate(item.CreatedOn)}} at {{formatTime(item.CreatedOn)}}</td><td><button ng-click=\"markAsComplet(item,$index)\" class=\"btn btn-success\"><i class=\"fa fa-check\"></i></button></td></tr></tbody></table></div>");
$templateCache.put("app/modules/notification/notification.html","<style type=\"text/css\">\n    .thick{\n        font-weight: bold;\n    }\n    .pagination-centered {\n        margin-left:35%\n    }\n    .highselected{\n        border: 2px solid rosybrown;\n        border-radius: 5px;\n    }\n</style><div><h3 style=\"margin:0 0 20px 0\">Notifications : {{notificationType}}</h3><button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"markAsRead(true)\" ng-show=\"user.role != \'CMS\'\" style=\"margin-bottom: 5px\">Mark all <strong>{{notificationType}}</strong> as Read !</button><div class=\"row chat\"><div ng-class=\"notify ? \'col-sm-4\' : \'col-sm-12\'\"><div class=\"notfy\"><ul ng-show=\"notify\" style=\"padding-left: 0; margin: 0\"><hr style=\"margin:0; padding: 0\"><li class=\"nav nav-tabs nav-stacked\" ng-repeat=\"notification in hospitalNotifcations\" ng-if=\"!notification.isRead\" style=\"line-height: 18px\"><a href=\"\" ng-click=\"notification.isHighlighted = false; showDetail(notification)\"><span ng-class=\"notification.isHighlighted ? \'row\' : \'row alert-warning\'\"><span class=\"col-sm-6\"><b>{{notification.notificationData.PatientName}}</b><br><span class=\"lable\">Claim ID:</span> {{notification.notificationData.ClaimId}}</span> <span class=\"col-sm-6\"><span class=\"lable\">Admission:</span> {{compareDate(notification.notificationData.ClmDOA)}}<br><span class=\"lable\">Discharge:</span> {{compareDate(notification.notificationData.ClmDOD)}}</span></span></a></li></ul></div><ul ng-show=\"!notify\" style=\"padding-left: 0; margin: 0\"><hr style=\"margin:0; padding: 0\"><li class=\"nav nav-tabs nav-stacked\" ng-repeat=\"notification in hospitalNotifcations\" ng-if=\"!notification.isRead\" style=\"line-height: 12px\"><a href=\"\" ng-click=\"notification.isHighlighted = false; showDetail(notification)\"><span ng-class=\"notification.isHighlighted ? \'row\' : \'row alert-warning\'\"><span class=\"col-sm-3\"><b>{{notification.notificationData.PatientName}}</b></span> <span class=\"col-sm-3\"><span class=\"lable\">Claim ID:</span> {{notification.notificationData.ClaimId}}</span> <span class=\"col-sm-3\"><span class=\"lable\">Admission:</span> {{compareDate(notification.notificationData.ClmDOA)}}</span> <span class=\"col-sm-3\"><span class=\"lable\">Discharge:</span> {{compareDate(notification.notificationData.ClmDOD)}}</span></span></a></li></ul></div><div class=\"col-sm-8\" ng-show=\"notify\"><div class=\"claimBox\"><span class=\"pull-right alert-danger\" ng-click=\"notify = undefined\" style=\"padding: 2px;\"><a href=\"\"><b>X</b></a></span><div ng-show=\"!claimSearhByClaimIdResults || claimSearhByClaimIdResults == {}\"><table class=\"table table-striped\" style=\"margin-top:20px; background:#fff;\"><tbody><tr><td>Customer</td><td>Claim No.</td><td>MAID</td><td>Contact Number</td></tr><tr><td><strong>{{notify.notificationData.PatientName}}</strong></td><td><strong><a href=\"\" ng-click=\"getClaimDetails(notify.notificationData.ClaimId)\" class=\"btn btn-xs btn-primary\">{{notify.notificationData.ClaimId}}</a></strong></td><td><strong>{{notify.notificationData.PatientMAID}}</strong></td><td><strong>{{notify.notificationData.PatientContactNumber}}</strong></td></tr></tbody></table><div class=\"chatBox\"><div class=\"author\"><p class=\"dateTime\">{{compareDate(notify.actionTime)}} <span>{{formatTime(notify.actionTime)}}</span></p><h2>Medi Assist</h2></div><div class=\"chatContent\" style=\"padding-bottom: 18px\"><h5 class=\"chatStatus\"><label class=\"bg-danger\">{{notify.claimAction.replace(\'_\',\' \')}}</label></h5><p>{{notify.actionMessage}}</p></div></div><div class=\"chatBox noUser\"><div class=\"chatContent\"><h5 class=\"chatStatus\">Claim Details</h5><table class=\"table table-striped\"><thead><tr><td>Date of Admission</td><td>Date of Discharge</td><td>Claim Status</td></tr></thead><tbody><tr><td><strong>{{compareDate(notify.notificationData.ClmDOA)}}</strong></td><td><strong>{{compareDate(notify.notificationData.ClmDOD)}}</strong></td><td><strong>{{notify.notificationData.ClaimStatus}}</strong></td></tr></tbody></table></div></div><div class=\"chatBox noUser\"><div class=\"chatContent\"><h5 class=\"chatStatus\">Insured Details</h5><table class=\"table table-striped\"><thead><tr><td>Policy Holder</td><td>Employee Code</td><td>Insured By</td></tr></thead><tbody><tr><td><strong>{{notify.notificationData.PolicyHolderName}}</strong></td><td><strong>{{notify.notificationData.EmployeeCode}}</strong></td><td><strong>{{notify.notificationData.InsuranceCompany}}</strong></td></tr></tbody></table></div></div></div><div ng-show=\"claimSearhByClaimIdResults\"><div class=\"downloadPart\" ng-if=\"claimSearhByClaimIdResults.claimDetails.claimStatus !== \'Claim Settled\'\"><table class=\"table table-striped\" style=\"margin-top:20px; background:#fff;\"><tbody><tr><td>Customer</td><td>Claim No.</td><td>Age</td><td>Contact No.</td><td>DOA</td><td>DOD</td></tr><tr><td><strong>{{claimSearhByClaimIdResults.patientDetails.patientName }}</strong></td><td><strong>{{claimSearhByClaimIdResults.claimId }}</strong></td><td><strong>{{claimSearhByClaimIdResults.patientDetails.patientAge}}</strong></td><td><strong>{{claimSearhByClaimIdResults.patientDetails.patientContactNumber}}</strong></td><td><strong>{{compareDate(claimSearhByClaimIdResults.claimDetails.clmDOA)}}</strong></td><td><strong>{{compareDate(claimSearhByClaimIdResults.claimDetails.clmDOD)}}</strong></td></tr></tbody></table></div><div id=\"settledData\" class=\"downloadPart\" ng-if=\"claimSearhByClaimIdResults.claimDetails.claimStatus== \'Claim Settled\'\"><table class=\"table table-striped\" style=\"margin-top:20px; background:#fff;\"><tbody><tr><td><strong>Customer Name</strong></td><td>{{claimSearhByClaimIdResults.patientDetails.patientName}}</td><td><strong>Claim No.</strong></td><td>{{claimSearhByClaimIdResults.claimId}}</td></tr><tr><td><strong>Contact Number</strong></td><td>{{claimSearhByClaimIdResults.patientDetails.patientContactNumber}}</td><td><strong>Customer Age</strong></td><td>{{claimSearhByClaimIdResults.patientDetails.patientAge}}</td></tr><tr><td><strong>Cheque/UTR Number</strong></td><td>{{claimSearhByClaimIdResults.settlementDetails.clmChequeNumber}}</td><td><strong>settlement Date</strong></td><td>{{compareDate(claimSearhByClaimIdResults.settlementDetails.settlementDate)}}</td></tr><tr><td><strong>Net Pay Amount</strong></td><td>{{claimSearhByClaimIdResults.settlementDetails.clmNetPayAmount}}</td><td><strong>Tax Amount</strong></td><td>{{claimSearhByClaimIdResults.settlementDetails.clmTaxAmount}}</td></tr><tr><td><strong>Cheque Amount:</strong></td><td>{{claimSearhByClaimIdResults.settlementDetails.clmChequeAmount}}</td><td><strong>Service Tax Amt</strong></td><td>{{claimSearhByClaimIdResults.settlementDetails.clmServiceTaxAmt}}</td></tr><tr><td><strong>Admissible Amt:</strong></td><td>{{claimSearhByClaimIdResults.settlementDetails.clmAdmissibleAmt}}</td></tr></tbody></table></div><div ng-repeat=\"item in claimSearhByClaimIdResults.claimAuditDetails\" ng-switch=\"item.isFromHospital\"><div class=\"chatBox\" ng-switch-when=\"false\"><div class=\"author\"><p class=\"dateTime\">{{compareDate(item.auditDate)}} <span>{{formatTime(item.auditDate)}}</span></p><h2>Medi Assist</h2></div><div class=\"chatContent\"><h5 class=\"chatStatus\">{{item.auditStatus }}</h5><p class=\"chat-content\">Claimed Amount :{{item.claimedAmt}}</p><p class=\"chat-content\" ng-show=\"item.claimedApprovedAmt>0\">Approved Amount :{{item.claimedApprovedAmt}}</p><a id=\"downloadLetter\" ng-show=\"item.letterDownloadLink && item.letterDownloadLink !==\'\'\" class=\"btn chat-content btn-primary btn-sm download\" data-letterdownloadlink=\"{{item.letterDownloadLink}}\" href=\"{{item.letterDownloadLink}}\" target=\"_blank\">Click here to download {{item.auditStatus}} letter</a></div></div><div class=\"chatBox user\" ng-switch-when=\"true\"><div class=\"author\"><p class=\"dateTime\">{{compareDate(item.auditDate)}} <span>{{formatTime(item.auditDate)}}</span></p><h2>Hospital</h2></div><div class=\"chatContent\"><h5 class=\"chatStatus\">{{item.auditStatus }}</h5><p class=\"chat-content\">Claimed Amount :{{item.claimedAmt}}</p><p class=\"chat-content\" ng-show=\"item.claimedApprovedAmt>0\">Approved Amount :{{item.claimedApprovedAmt}}</p><a id=\"downloadLetter\" ng-show=\"item.letterDownloadLink && item.letterDownloadLink !==\'\'\" class=\"btn chat-content btn-primary btn-sm download\" data-letterdownloadlink=\"{{item.letterDownloadLink}}\" href=\"{{item.letterDownloadLink}}\" target=\"_blank\">Click here to download {{item.auditStatus}} letter</a></div></div></div><div class=\"downloadPart\"><div ng-show=\"claimSearhByClaimIdResults.nmeDetails.length>0\"><div class=\"chatBox noUser\"><div class=\"chatContent\"><h5 class=\"chatStatus\">Non payable amount</h5><table class=\"table table-striped\"><thead><tr><td><strong>Non payable amount</strong></td><td><strong>Non payable reason</strong></td></tr></thead><tbody><tr ng-repeat=\"item in claimSearhByClaimIdResults.nmeDetails\"><td>{{item.nonPayableAmt}}</td><td>{{item.nonPayableReason}}</td></tr></tbody></table></div></div></div></div><div class=\"downloadPart\"><div ng-show=\"claimSearhByClaimIdResults.deductionDetails.length>0\"><div class=\"chatBox noUser\"><div class=\"chatContent\"><h5 class=\"chatStatus\">Deduction Details</h5><table class=\"table table-striped\"><thead><tr><td><strong>Deduction amount</strong></td><td><strong>Deduction reason</strong></td></tr></thead><tbody><tr ng-repeat=\"item in claimSearhByClaimIdResults.deductionDetails\"><td>{{item.deductionAmount}}</td><td>{{item.deductionReason}}</td></tr></tbody></table></div></div></div></div><div class=\"chatBox noUser\" ng-show=\"claimSearhByClaimIdResults.attachments.length>0\"><div class=\"chatContent\"><h5 class=\"chatStatus\">Attachments</h5><table class=\"table table-striped\"><thead><tr><td><strong>Attachments list</strong></td></tr></thead><tbody><tr ng-repeat=\"item in claimSearhByClaimIdResults.attachments\"><td><a href=\"{{item.downloadURL}}\" target=\"_blank\">Download {{item.originalFileName}}</a></td></tr></tbody></table></div></div><div class=\"chatBox noUser\" ng-show=\"user.role != \'CMS\'&& claimSearhByClaimIdResults.claimDetails.claimStatus== \'Claim Settled\'\"><div class=\"chatContent\"><h5 class=\"chatStatus\">Action</h5><hosp-action ng-if=\"user.role != \'CMS\'\" dataobj=\"claimSearhByClaimIdResults\" source=\"\'notification Ctrl\'\"></hosp-action></div></div></div></div></div></div><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\" ng-change=\"notify = undefined;getNotificationList(param, this.currentPage, itemsPerPage)\"></uib-pagination></div>");
$templateCache.put("app/modules/otherClaims/otherClaims.html","<div><div class=\"claims\" ng-show=\"preauthClaims && preauthClaims.length > 0\"><angular-tabs datalist=\"preauthClaims\" tabname=\"\'Other Claims\'\" callback-fn=\"ctrlFn(arg)\"></angular-tabs></div><div class=\"no-settled-claims\" ng-hide=\"preauthClaims && preauthClaims.length > 0\"><div class=\"bs-callout bs-callout-info\"><h4>No other claims found.</h4><p ng-show=\"!searchResults\">This hospital doesn\'t seem to have any other claims.</p></div></div></div>");
$templateCache.put("app/modules/packagesIp/ipPackages.html","<div><div class=\"alert alert-warning\"><p><b>Want to publish your in-patient packges with Medi Assist, please contact us</b></p><p>Need some content. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore doloremque cupiditate veritatis blanditiis debitis aut, iusto soluta rerum maiores nisi animi, at, excepturi libero similique modi unde assumenda nulla facere!</p><p><a href=\"/contact#inPatientPackage\" class=\"btn btn-primary\">Send email</a></p></div><div class=\"packages clearfix\" id=\"packages\"><h3>Packages - Inpatient</h3><div class=\"row\"><div ng-repeat=\"pack in packages\" ng-class=\"((($index + 1) % 3 == 0) && ($index != 0)) ? \'row\' : \'\'\"><div class=\"bx col-sm-4\" data-toggle=\"modal\" data-target=\"#openPackageDetails\" ng-click=\"packagesMethods.openPackageDetails(pack)\"><a href=\"\"><h4 style=\"margin-top:0\">{{pack.packageName}}<span ng-if=\"pack.isVerified\" class=\"smTxt\"><em class=\"text-success\">Verified & available on Medi Market</em></span><span ng-if=\"!pack.isVerified\" class=\"smTxt\"><em class=\"text-danger\">Under verification</em></span><span class=\"smTxt\">Price: <strong><i class=\"fa fa-rupee\"></i> {{pack.packagePrice}}</strong> <span class=\"devider\">-</span> Medi Assist Discount: <strong>{{pack.packageMADiscount}}% (<i class=\"fa fa-rupee\"></i>{{pack.packageMAPrice}})</strong></span></h4><span class=\"listing\" ng-repeat=\"incl in pack.packageContents\">{{incl.name}}<span ng-if=\"incl.shortName && incl.name != incl.shortName\">[{{incl.shortName}}]</span></span></a></div></div><div class=\"col-sm-4 addBtn\" data-toggle=\"modal\" data-target=\"#addPackage\" ng-click=\"packagesMethods.openAddPackageModal()\"><a href=\"\" class=\"btn btn-block\"><i class=\"fa fa-plus\"></i> Add package</a></div></div></div><div class=\"modal fade\" id=\"openPackageDetails\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\" ng-show=\"!addPackage\">Edit Package Details</h4><h4 class=\"modal-title\" ng-show=\"addPackage\">Add New Package</h4></div><div class=\"modal-body\"><div class=\"row\" style=\"margin:0;\"><div class=\"col-md-12\"><div class=\"col-md-12 form-group\"><form role=\"form\" name=\"packageAddForm\"><div class=\"col-md-6\"><label class=\"label\">Name <span style=\"color:red;\">*</span></label> <input type=\"text\" ng-class=\"packageAddForm.packName.$error.required ? \'form-control errorHighlight\' : \'form-control\'\" id=\"packName\" name=\"packName\" ng-model=\"editPack.packageName\" placeholder=\"Enter package name\" required=\"\"></div><div class=\"col-md-6\"><label class=\"label\"><i class=\"fa fa-rupee\"></i> Package Price <span style=\"color:red;\">*</span></label> <input type=\"text\" ng-class=\"packageAddForm.price.$error.required ? \'form-control errorHighlight\' : \'form-control\'\" id=\"price\" name=\"price\" ng-model=\"editPack.price\" placeholder=\"Enter package price\" ng-change=\"packagesMethods.calculateDiscount()\" required=\"\"></div><div class=\"col-md-6\"><label class=\"label\">% Discount <span style=\"color:red;\">*</span></label> <input type=\"text\" ng-class=\"packageAddForm.discount.$error.required ? \'form-control errorHighlight\' : \'form-control\'\" id=\"discount\" name=\"discount\" ng-model=\"editPack.discount\" placeholder=\"Enter discount\" ng-change=\"packagesMethods.calculateDiscount()\" required=\"\"></div><div class=\"col-md-6\"><label class=\"label\"><i class=\"fa fa-rupee\"></i> Medi Assist Price <span style=\"color:red;\">*</span></label> <input type=\"text\" ng-class=\"packageAddForm.maPrice.$error.required ? \'form-control errorHighlight\' : \'form-control\'\" id=\"maPrice\" name=\"maPrice\" ng-model=\"editPack.maPrice\" disabled=\"\"></div><div class=\"col-md-6\"><label class=\"label\">Description or any other comments</label> <textarea class=\"form-control\" ng-model=\"editPack.description\"></textarea></div><div class=\"col-md-12\"><label class=\"h5\">Package Contents</label><br><div class=\"col-md-12\"><fieldset ng-repeat=\"inv in investigations track by $index\"><div class=\"row\"><strong>{{inv[0].groupName}}</strong> <button type=\"button\" class=\"btn btn-sm btn-danger btn-xs\" ng-click=\"packagesMethods.editTestItem(inv)\"><i class=\"fa fa-gear\"></i> Edit</button><ul><li ng-repeat=\"i in inv\">{{i.name}}</li></ul></div></fieldset></div><button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"packagesMethods.addNewTestProfile()\"><i class=\"fa fa-plus\"></i> Add New Test Profile</button></div></form></div></div></div></div><div class=\"modal-footer footer\"><div class=\"form-group\"><div class=\"col-md-2 pull-right\"><button type=\"button\" class=\"form-control btn-success pull-right\" ng-click=\"packagesMethods.updateHospPackage()\" ng-disabled=\"packageAddForm.$invalid\">Submit</button></div><div class=\"col-md-2 pull-right\"><button type=\"button\" class=\"form-control btn btn-default pull-right\" data-dismiss=\"modal\">Close</button></div></div></div></div></div></div><div class=\"modal fade\" id=\"addPackage\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Add New Package</h4></div><div class=\"modal-body\"><div class=\"row\"><form role=\"form\" name=\"packageAddForm\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"label\">Name <span style=\"color:red;\">*</span></label> <input type=\"text\" ng-class=\"packageAddForm.packName.$error.required ? \'form-control errorHighlight\' : \'form-control\'\" id=\"packName\" name=\"packName\" ng-model=\"editPack.packageName\" placeholder=\"Enter package name\" required=\"\"></div></div><div class=\"col-md-6\"><div class=\"row\"><div class=\"col-md-6 p-r-0\"><div class=\"form-group\"><label class=\"label\"><i class=\"fa fa-rupee\"></i> Package Price <span style=\"color:red;\">*</span></label> <input type=\"text\" ng-class=\"packageAddForm.price.$error.required ? \'form-control errorHighlight\' : \'form-control\'\" id=\"price\" name=\"price\" ng-model=\"editPack.price\" placeholder=\"Price\" ng-change=\"packagesMethods.calculateDiscount()\" required=\"\"></div></div><div class=\"col-md-6 p-l-0\"><div class=\"form-group\"><label class=\"label\">Medi Assist discount <span style=\"color:red;\">*</span></label><div class=\"input-group\"><input type=\"text\" ng-class=\"packageAddForm.discount.$error.required ? \'form-control errorHighlight\' : \'form-control\'\" id=\"discount\" name=\"discount\" ng-model=\"editPack.discount\" ng-change=\"packagesMethods.calculateDiscount()\" required=\"\" placeholder=\"0\" value=\"0\"> <span class=\"input-group-addon\">%</span> <span class=\"input-group-addon\"><i class=\"fa fa-rupee\"></i>{{editPack.maPrice}}</span></div></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"label\" style=\"display:block; text-align:left\">Choose gender</label><div class=\"btn-group\"><label class=\"btn btn-success active\" ng-model=\"radioModel\" uib-btn-radio=\"\'BOTH\'\" ng-click=\"packagesMethods.setGender(\'BOTH\')\">Both</label> <label class=\"btn btn-success\" ng-model=\"radioModel\" uib-btn-radio=\"\'MALE\'\" ng-click=\"packagesMethods.setGender(\'MALE\')\">Male</label> <label class=\"btn btn-success\" ng-model=\"radioModel\" uib-btn-radio=\"\'FEMALE\'\" ng-click=\"packagesMethods.setGender(\'FEMALE\')\">Female</label></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"label\" style=\"display:block; text-align:left\">Select age limit</label><div class=\"btn-group\"><label class=\"btn btn-success\" ng-model=\"checkModel.ageZeroToThirty\" uib-btn-checkbox=\"\">0 - 30</label> <label class=\"btn btn-success\" ng-model=\"checkModel.ageThirtyOneToFortyFive\" uib-btn-checkbox=\"\">31 - 45</label> <label class=\"btn btn-success\" ng-model=\"checkModel.ageFortySixToFiftyFive\" uib-btn-checkbox=\"\">46 - 55</label> <label class=\"btn btn-success\" ng-model=\"checkModel.ageFiftySixToSixtyFive\" uib-btn-checkbox=\"\">56 - 65</label> <label class=\"btn btn-success\" ng-model=\"checkModel.ageSixtySixToHundred\" uib-btn-checkbox=\"\">66 - 100</label></div></div></div><div class=\"col-md-12\"><h5>Choose package contents</h5><ul class=\"selectList\"><li ng-repeat=\"testPr in testProfilesArray[0] track by $index\" ng-click=\"packagesMethods.getInvestigationsForProfile($index, testPr.profileName)\"><a href=\"\">{{testPr.profileName}}<span ng-if=\"investigations[$index] && investigations[$index].count\" class=\"bg-success\">- {{investigations[$index].count}} tests</span></a></li></ul><div class=\"testBx\" ng-show=\"somThingSom.length > 0\"><h4>{{somThingSom.name}} <span ng-if=\"investigations[$index] && investigations[$index].count\" class=\"bg-success\">- {{investigations[$index].count}} tests</span></h4><div class=\"clearfix\"><div class=\"checkbox\" ng-repeat=\"inv in somThingSom track by $index\"><label><input type=\"checkbox\" ng-model=\"inv.isTestIncluded\" data-id=\"{{inv.id}}\"> {{inv.name}}</label></div></div><div class=\"clearfix\"><a href=\"\" class=\"btn btn-success\" ng-click=\"packagesMethods.cancelSomThingSom()\">Close</a></div></div></div><div class=\"col-md-6\"><label class=\"label\">Add description</label> <textarea class=\"form-control\" ng-model=\"editPack.description\"></textarea></div><div class=\"col-md-6\"><label class=\"label\">Instructions</label><ol class=\"instructions\"><li ng-repeat=\"instr in instructions track by $index\"><div class=\"input-group\"><textarea rows=\"1\" class=\"form-control\" ng-model=\"instr.instruction\" data-id=\"instructions[$index]\"></textarea> <span class=\"input-group-btn\"><button class=\"btn btn-danger\" type=\"button\" ng-click=\"packagesMethods.removeInstruction($index)\"><i class=\"fa fa-close\"></i></button></span></div></li><li class=\"last\"><a href=\"\" class=\"btn btn-sm btn-info\" ng-click=\"packagesMethods.addNewInstruction()\"><i class=\"fa fa-plus\"></i> Add instruction</a></li></ol></div></form></div></div><div class=\"modal-footer footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"packagesMethods.addNewPackage()\" ng-disabled=\"packageAddForm.$invalid\">Submit</button></div></div></div></div></div>");
$templateCache.put("app/modules/packagesOp/opPackages.html","<div><style>\n    .scrolable {\n      overflow-x: scroll;\n    }\n\n    .errormessage {\n      border: 1px solid #f00;\n    }\n\n    .switch {\n      position: relative;\n      display: inline-block;\n      width: 60px;\n      height: 34px;\n    }\n\n    .switch input {\n      display: none;\n    }\n\n    .slider {\n      position: absolute;\n      cursor: pointer;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-color: #ccc;\n      -webkit-transition: .4s;\n      transition: .4s;\n    }\n\n    .slider:before {\n      position: absolute;\n      content: \"\";\n      height: 26px;\n      width: 26px;\n      left: 4px;\n      bottom: 4px;\n      background-color: white;\n      -webkit-transition: .4s;\n      transition: .4s;\n    }\n\n    input:checked+.slider {\n      background-color: #2196F3;\n    }\n\n    input:focus+.slider {\n      box-shadow: 0 0 1px #2196F3;\n    }\n\n    input:checked+.slider:before {\n      -webkit-transform: translateX(26px);\n      -ms-transform: translateX(26px);\n      transform: translateX(26px);\n    }\n\n    .red {}\n\n    .italic {}\n\n    /* Rounded sliders */\n    .slider.round {\n      border-radius: 34px;\n    }\n\n    .slider.round:before {\n      border-radius: 50%;\n    }\n\n    .note {\n      padding: 10px;\n      margin: 10px 0;\n      background: yellow;\n      border-radius: 6px;\n      color: #000;\n    }\n\n  </style><div class=\"packages clearfix\" id=\"packages\" ng-if=\"!addPackage && !editPackage\"><div class=\"row\" style=\"margin-bottom: -15px;\"><div class=\"col-md-1\" style=\"margin-right: -35px;\"><i class=\"fa fa-heartbeat fa-2x\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></div><div class=\"col-md-6\" style=\"margin-top: -18px;\"><h3>Health-check packages: OP</h3></div><div class=\"col-md-4 pull-right mainActionBar\"><div class=\"col-md-3\" ng-if=\"showSync\"><button class=\"btn btn-xs btn-default\" style=\"border: hidden;\" ng-click=\"packagesMethods.loadPackages()\" uib-tooltip=\"View Full List\" tooltip-placement=\"left\"><i class=\"fa fa-list-alt fa-2x\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></button></div><div class=\"col-md-3\" ng-if=\"showSync\"><button class=\"btn btn-xs btn-default\" style=\"border: hidden;\" ng-click=\"packagesMethods.showSyncPending()\" uib-tooltip=\"View Sync Pending\" tooltip-placement=\"left\"><i class=\"fa fa-refresh fa-spin fa-2x\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></button></div><div class=\"col-md-3\"><button class=\"btn btn-xs btn-default\" style=\"border: hidden;\" data-toggle=\"modal\" data-target=\"#myModal\" uib-tooltip=\"Update Auto Confirm Quota\" tooltip-placement=\"left\"><i class=\"fa fa-cog fa-spin fa-2x\" style=\"color:#4182c4;\"></i></button></div><div class=\"col-md-3\"><button class=\"btn btn-xs btn-default\" ng-click=\"packagesMethods.openAddPackageModal()\" uib-tooltip=\"Configure New Packages\" tooltip-placement=\"left\" style=\"border: hidden\"><i class=\"fa fa-plus-square fa-2x\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></button></div></div></div><hr><div ng-if=\"!isChangeView\"><table class=\"table table-hover table-striped table-bordered packageTbl\" style=\"font-size: 13px;\" ng-if=\"packages.length >0\"><tr style=\"color: #000000;\"><th>Name</th><th>Price</th><th>Age range</th><th>Package Details</th><th>Last updated date</th><th>Action</th></tr><tr class=\"italic\" ng-class=\"{\'\': hover}\" ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\" ng-repeat=\"pack in packages\"><td style=\"max-width: 35rem;\">{{ pack.packageName }}</td><td style=\"width: 100px\"><span class=\"price\" style=\"color:#4c96f3\"><span style=\"color: black;\"><strike><i class=\"fa fa-rupee\"></i>{{pack.packagePrice}}</strike></span> <i class=\"fa fa-rupee\" style=\"margin-right:3px;\"></i>{{pack.packageMAPrice}}</span></td><td>{{ pack.minAge }} - {{ pack.maxAge }}</td><td>{{pack.description.substring(0,70)}}{{pack.description.length > 70 ? \'.....\' : \'\' }} <button class=\"btn btn-sm btn-default pull-right\" ng-click=\"packagesMethods.openPkgDetailsModal(pack)\" uib-tooltip=\"View\" style=\"border: hidden\" data-toggle=\"modal\" data-target=\"#packageDetailsModal\"><i class=\"fa fa-eye fa-4\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></button></td><td>{{ pack.packageLastUpdated | date:\'dd-MMM-yyyy\'}}</td><td style=\"display: flex;flex-direction:row;border: hidden;\"><button class=\"btn btn-primary btn-sm\" ng-click=\"packagesMethods.openPackageDetails(pack)\"><i class=\"fa fa-pencil-square-o fa-3\" aria-hidden=\"true\"></i></button> <button ng-if=\"showSync && packagesMethods.isSyncValid(pack)\" class=\"btn btn-sm btn-primary\" uib-tooltip=\"Sync\" style=\"cursor: pointer;margin-left: 3px;\" ng-click=\"packagesMethods.syncHealthChkData(pack)\"><i class=\"fa fa-refresh fa-3\" aria-hidden=\"true\"></i></button></td></tr></table><div style=\"margin-left: 370px;\" ng-show=\"packages.length >0\"><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" ng-click=\"pageChange(currentPage)\" items-per-page=\"itemsPerPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></div><div class=\"clearfix modal fade\" id=\"packageDetailsModal\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button class=\"btn-default btn-xs close\" data-dismiss=\"modal\"><i class=\"fa fa-close\"></i></button><h4 class=\"modal-title\" id=\"modal-title\" style=\"font-weight: bold;text-align: center\">{{ indvidualPackage.packageName }}</h4></div><div class=\"modal-body\">{{indvidualPackage.description}}</div><div class=\"modal-footer\"><button class=\"btn btn-primary\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"clearfix modal fade\" id=\"myModal\" style=\"background: white;width: 50%;text-align: center;left: 25%;bottom: 100px;top: 15px;\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button><h4 class=\"modal-title\">Update Auto Quota List</h4></div><div class=\"modal-body\"><div class=\"pull-left\" style=\"width:380px\"><div class=\"form-group\" style=\"margin-left: 4px;\"><label style=\"display:block; text-align:left; font-size:18px\">Select available days</label><div class=\"clearfix\" style=\"margin-top:20px;\"><label ng-repeat=\"keyword in daysName\" style=\"display:inline-block;float:left;width:40px;font-weight: 400;\"><input style=\"display: inline-block;\" ng-model=\"keyword.checked\" type=\"checkbox\">{{keyword.name.substring(0,3)}}</label></div></div></div><div class=\"pull-left\"><label style=\"display: block; text-align: left; font-size: 18px; width:100%;\">Health check timings</label><div class=\"pull-left\"><div class=\"form-group\"><div uib-timepicker=\"\" ng-model=\"profile.firstTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" readonly-input=\"true\" minute-step=\"mstep\" show-meridian=\"ismeridian\" ng-change=\"checkTimeLimit(firstTime)\"></div></div></div><div class=\"pull-left\"><div class=\"form-group\" style=\"margin-top: 21px; padding: 20px;\"><span>To</span></div></div><div class=\"pull-left\"><div class=\"form-group\"><div uib-timepicker=\"\" ng-model=\"profile.secondTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" readonly-input=\"true\" minute-step=\"mstep\" show-meridian=\"ismeridian\" ng-change=\"checkTimeLimit(firstTime)\"></div></div></div></div><div class=\"col-sm-12\"><label style=\"display:block; text-align:left; font-size:18px\">Number of MA appointments to auto confirm</label><div class=\"clearfix\" style=\"margin-top: 20px;\"><label style=\"margin: 5px;\" ng-repeat=\"day in quoteData track by $index\"><span>{{day.dayOfWeek}}:</span> <input style=\"display: inline-block;width: 20%;\" class=\"form-control\" ng-model=\"day.quotaValue\" ng-disabled=\"!daysName[$index].checked\" type=\"number\"></label></div></div></div><div class=\"pull-left modal-footer\"><div class=\"form-group\" style=\"margin-top: 20px; margin-left: 20px;\"><div class=\"btn-group\"><button class=\"btn btn-primary\" ng-click=\"updateHospitalProfileDetails()\">Save</button></div><a tooltip-placement=\"top\" uib-tooltip=\"Add information about the various health check packages offered by you. Medi Assist members see, choose and book these packages on MediBuddy Infiniti, the curated platform for outpatient services.\"><i class=\"fa fa-question-circle\"></i></a></div></div></div></div></div><div id=\"openPackageDetails\" ng-show=\"addPackage || editPackage\"><h3 ng-if=\"addPackage\" style=\"margin-top: -5px\">Add New Package</h3><h3 ng-if=\"editPackage\" style=\"margin-top: -5px\">Edit <strong>{{editPack.packageName}}</strong> Package Details</h3><hr><form role=\"form\" name=\"packageAddForm\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Package name <span style=\"color:red;\">*</span></label> <input type=\"text\" class=\"form-control\" id=\"packName\" name=\"packName\" ng-model=\"editPack.packageName\" placeholder=\"Enter package name\" required=\"\"></div></div><div class=\"col-md-6\"><div class=\"row\"><div class=\"col-md-6 p-r-0\"><div class=\"form-group\"><label><i class=\"fa fa-rupee\"></i> Package price <span style=\"color:red;\">*</span></label> <input type=\"number\" min=\"0\" max=\"40000\" class=\"form-control\" ng-class=\"packageAddForm.price.$error.max === true? \'form-control errorHighlight errormessage\': \'form-control\'\" id=\"price\" name=\"price\" ng-model=\"editPack.price\" placeholder=\"Price\" ng-change=\"packagesMethods.calculateDiscount()\" required=\"\"> <span ng-show=\"packageAddForm.price.$error.max === true\" style=\"color: #f00\">Package price not more then 40K</span></div></div><div class=\"col-md-6 p-l-0\"><div class=\"form-group\"><label><i class=\"fa fa-rupee\"></i> Medi Assist price <span style=\"color:red;\">*</span></label><div class=\"input-group\"><input type=\"number\" min=\"0\" class=\"form-control\" id=\"discount\" name=\"discount\" ng-model=\"editPack.maPrice\" ng-change=\"packagesMethods.calculateDiscount()\" required=\"\" placeholder=\"0\" value=\"0\"> <span class=\"input-group-addon\">{{editPack.discount}}%</span></div></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label style=\"display:block; text-align:left\">Choose gender <span style=\"color:red;\">*</span></label><div class=\"btn-group\"><label class=\"btn btn-info active\" ng-model=\"radioModel\" uib-btn-radio=\"\'BOTH\'\" ng-click=\"packagesMethods.setGender(\'BOTH\')\">Both</label> <label class=\"btn btn-info\" ng-model=\"radioModel\" uib-btn-radio=\"\'MALE\'\" ng-click=\"packagesMethods.setGender(\'MALE\')\">Male</label> <label class=\"btn btn-info\" ng-model=\"radioModel\" uib-btn-radio=\"\'FEMALE\'\" ng-click=\"packagesMethods.setGender(\'FEMALE\')\">Female</label></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label style=\"display:block; text-align:left\">Select age limit <span style=\"color:red;\">*</span></label><div class=\"col-md-5\" style=\"margin-left: -15px;\"><div class=\"form-group\"><input required=\"\" placeholder=\"Enter min age\" ng-change=\"ageCalculater(age.min, \'min\', packageAddForm.minAge.$viewValue)\" type=\"number\" maxlength=\"2\" class=\"form-control\" name=\"minAge\" ng-model=\"editPack.minAge\"></div></div><div class=\"col-md-1\"><div class=\"form-group\" style=\"margin-top: 6px;\">to</div></div><div class=\"col-md-5\"><div class=\"form-group\"><input required=\"\" placeholder=\"Enter max age\" ng-change=\"ageCalculater(age.max, \'max\', packageAddForm.maxAge.$viewValue)\" type=\"number\" maxlength=\"3\" class=\"form-control\" name=\"maxAge\" ng-model=\"editPack.maxAge\"></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label style=\"display:block; text-align:left\">Select test/consultation <span style=\"color:red;\">*</span></label><div ng-dropdown-multiselect=\"\" checkboxes=\"true\" search-filter=\"customFilter\" options=\"example15data\" selected-model=\"example15model\" extra-settings=\"example15settings\"></div></div><div ng-show=\"selectedTestToShow.length >0\"><table class=\"table table-hover table-striped table-bordered\" style=\"margin-left: 5px;\"><tr style=\"color: #000000;\"><th>GroupName</th><th>Test name</th></tr><tr class=\"italic\" ng-class=\"{\'\': hover}\" ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\" ng-repeat=\"pack in selectedTestToShow | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\"><td>{{ pack.groupName }}</td><td>{{ pack.name }}</td></tr></table><div style=\"margin-left: 100px;\"><uib-pagination total-items=\"totalItem\" ng-model=\"currentPage\" max-size=\"maxSize\" ng-click=\"pageChange(currentPage)\" items-per-page=\"itemsPerPage\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></div><div ng-show=\"selectedTestToShow.length ===0\"><span style=\"margin-left: 170px; font-size: larger; font-style: normal;\">Test not selected</span></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Add description</label> <textarea class=\"form-control\" ng-model=\"editPack.description\"></textarea></div><div class=\"form-group\"><label>Instructions</label><ol class=\"instructions clearfix addList\" style=\"position: relative; margin-top: 10px;\"><li ng-repeat=\"instr in instructions track by $index\" ng-init=\"instr.instruction ? hideEdit = true : hideEdit = false\"><div class=\"input-group\"><p ng-show=\"hideEdit\">{{instr.instruction}}</p><textarea ng-show=\"!hideEdit\" rows=\"2\" class=\"form-control\" ng-model=\"instr.instruction\" data-id=\"instructions[$index]\"></textarea> <span class=\"input-group-btn\"><button ng-show=\"hideEdit\" class=\"btn btn-primary btn-xs\" type=\"button\" ng-click=\"hideEdit = false\"><i class=\"fa fa-pencil\"></i></button> <button ng-show=\"!hideEdit\" class=\"btn btn-success\" type=\"button\" ng-disabled=\"!instr.instruction\" ng-click=\"hideEdit = true\"><i class=\"fa fa-check\"></i></button> <button ng-show=\"!hideEdit\" class=\"btn btn-danger\" type=\"button\" ng-click=\"packagesMethods.removeInstruction($index)\"><i class=\"fa fa-close\"></i></button></span></div></li><li class=\"last\"><a href=\"\" class=\"btn btn-sm btn-info\" ng-click=\"packagesMethods.addNewInstruction()\"><i class=\"fa fa-plus\"></i> Add instruction</a></li></ol></div></div></div><hr><div class=\"clearfix\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"packagesMethods.closeEditPackageModal()\">Close</button> <button ng-if=\"!addPackage\" type=\"button\" class=\"btn btn-success pull-right\" ng-click=\"packagesMethods.addNewPackage(true)\" ng-disabled=\"packageAddForm.$invalid || example15model.length===0 || !radioModel\">Update</button> <button ng-if=\"addPackage\" type=\"button\" class=\"btn btn-success pull-right\" ng-click=\"packagesMethods.addNewPackage()\" ng-disabled=\"packageAddForm.$invalid || example15model.length===0 || !radioModel\">Add</button></div></form></div><div class=\"modal fade\" id=\"chooseTest\" tabindex=\"-1\" data-keyboard=\"false\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-dialog-custom modal-lg\" role=\"document\"><div class=\"modal-content modal-content-custom\"><div class=\"modal-header\" style=\"padding:0 15px;\"><a href=\"\" ng-click=\"packagesMethods.restoreOriginal()\"><span class=\"pull-right\" data-dismiss=\"modal\"><b>X</b></span></a><h4>Choose Tests in <strong>{{profileName}}</strong></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"checkbox col-md-4\" ng-repeat=\"item in categories[indexOfTests]\"><label uib-popover-html=\"item.descriptionHTML\" popover-trigger=\"mouseenter\" popover-placement=\"auto bottom\"><input type=\"checkbox\" ng-model=\"item.isIncluded\" data-id=\"{{item.id}}\"> {{item.name}}</label></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger pull-left\" data-dismiss=\"modal\" ng-click=\"packagesMethods.closeSelectTests()\">Cancel all selection</button> <button type=\"button\" class=\"btn btn-success\" data-dismiss=\"modal\" ng-click=\"packagesMethods.selectTests()\">Select</button><div class=\"row\"><em class=\"text-danger pull-left\" style=\"margin-left:2%\">this will remove the tests selected, if any</em></div></div></div></div></div>");
$templateCache.put("app/modules/payments/paymentSettled.html","<style>\n    .invoice-title h2, .invoice-title h3 {\n        display: inline-block;\n    }\n\n    .table > tbody > tr > .no-line {\n        border-top: none;\n    }\n\n    .table > thead > tr > .no-line {\n        border-bottom: none;\n    }\n\n    .table > tbody > tr > .thick-line {\n        border-top: 2px solid;\n    }\n\n    form.add-user {\n        width: 400px;\n        margin: 0 auto;\n    }\n\n    .amount {\n        font-size: 30px;\n    }\n\n    .package-item {\n        font-weight: bold;\n        font-size: 12px;\n    }\n\n    .benef-item {\n        font-weight: normal;\n        font-size: 12px;\n        color: #AAA;\n    }\n\n    .brand img {\n        width: 190px;\n    }\n\n    .form-create {\n        width: 100%;\n    }\n\n    .card {\n        background-color: #F7F7F7;\n        padding: 20px 25px 30px;\n        margin: 0 auto 25px;\n        -moz-border-radius: 2px;\n        -webkit-border-radius: 2px;\n        border-radius: 2px;\n        -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n        -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n    }\n\n    .form-create.card {\n        margin-top: 0px;\n        margin-bottom: 10px;\n    }\n\n    .submit-buttons.card {\n        background-color: transparent;\n        -moz-border-radius: 0px;\n        -webkit-border-radius: 0px;\n        border-radius: 0px;\n        -moz-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n        -webkit-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n        box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n    }\n\n    .form-create-first.card {\n        margin-top: 30px;\n    }\n\n    .card-container.card {\n        width: 350px;\n        padding: 40px 40px;\n    }\n\n    #corp-search {\n        margin-bottom: 0px;\n    }\n\n    .firstScreen.card {\n        margin: 0 auto 25px;\n        margin-top: 50px;\n    }\n\n    .required {\n        border: 1px solid red;\n    }\n\n    .strong {\n        font-weight: bold;\n    }\n\n    .cart hr {\n        margin: 5px 0;\n    }\n</style><div class=\"active-appointments\"><script type=\"text/ng-template\" id=\"customPopupTemplate.html\"><div class=\"custom-popup-wrapper\" ng-style=\"{top: 0+\'px\', left: 0+\'px\'}\" style=\"display: block; position: relative\" ng-show=\"isOpen() && !moveInProgress\" aria-hidden=\"{{!isOpen()}}\"> <p class=\"message\">select from drop down.</p> <ul class=\"dropdown-menu\" role=\"listbox\" style=\"display: block;\"> <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.entityName}}\"> <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div> </li> </ul> </div></script><script type=\"text/ng-template\" id=\"alert.html\"><div ng-transclude></div></script><div ng-show=\"isSuccessMsg\" uib-alert=\"\" template-url=\"alert.html\" style=\"background-color: #0eb10e; color: white; padding-top: 10px; padding-bottom: 10px; padding-left: 20px; margin-bottom: 10px;\">Invoice \"{{paymentSetteledData.invoiceNumber}}\" has been generated successfully.</div><div id=\"fetchdc\" ng-show=\"opsuser || isGroupLogin\"><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"status.isFirstOpen\"><uib-accordion-heading><a style=\"color: #168cc9;\">Finance search panel</a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isFirstOpen, \'glyphicon-chevron-right\': !status.isFirstOpen}\"></i></uib-accordion-heading><ng-form name=\"userProfileForm\" class=\"form-horizontal\"><div class=\"row\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-4\"><div class=\"col-md-11\"><div class=\"form-group\"><label>Date From:</label><div class=\"input-group\"><input placeholder=\"Select from date\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"serverSearch.fromDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-1\"></div></div><div class=\"col-md-4\"><div class=\"col-md-11\"><div class=\"form-group\"><label>Date to:</label><div class=\"input-group\"><input id=\"datetimeEnd\" placeholder=\"Select to date\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"serverSearch.toDate\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-1\"></div></div><div class=\"col-md-4\"><div class=\"col-md-11\"><div class=\"form-group\"><label>Finance type:</label><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-change=\"changeType(search.type)\" ng-options=\"option.name for option in financialType track by option.id\" ng-model=\"search.type\"></select></div></div><div class=\"col-md-1\"></div></div></div></div></div><div ng-show=\"clientFilterType ===\'corp\'\" class=\"row\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-4\"><div class=\"col-md-11\"><div class=\"form-group\"><label for=\"\">Select contract:</label><select name=\"statusSearch\" id=\"statusSearch\" ng-change=\"getCorporate(search.entityRelationSelected)\" class=\"form-control\" ng-options=\"option.entityName for option in EntityRelation track by option.id\" ng-model=\"search.entityRelationSelected\"></select></div></div><div class=\"col-md-1\"></div></div><div class=\"col-md-4\"><div class=\"col-md-11\"><div class=\"form-group\"><label for=\"\">Start typing corporate name:</label> <input type=\"text\" ng-model=\"search.entityId\" placeholder=\"Type corporate name to search\" uib-typeahead=\"state as state.entityName for state in corporates | filter:{entityName:$viewValue}\" typeahead-popup-template-url=\"customPopupTemplate.html\" class=\"form-control\"></div></div><div class=\"col-md-1\"></div></div></div></div></div><div class=\"row\" ng-show=\"clientFilterType ===\'dc\'\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-4\"><div class=\"col-md-11\"><div class=\"form-group\"><label for=\"\">Select a state:</label><select name=\"newstateId\" ng-model=\"testData.testStateId\" class=\"form-control\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in statesList\">{{state.lookUpValue}}</option></select></div></div><div class=\"col-md-1\"></div></div><div class=\"col-md-4\"><div class=\"col-md-11\"><div class=\"form-group\"><label for=\"\">Select a city:</label><select name=\"newcityId\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\" class=\"form-control\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in citiesList\">{{city.lookUpValue}}</option></select></div></div><div class=\"col-md-1\"></div></div><div class=\"col-md-4\"><div class=\"col-md-11\"><div class=\"form-group\"><label for=\"\">Select a locality:</label><select name=\"newlocalityId\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\" class=\"form-control\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locationsList\">{{location.lookUpValue}}</option></select></div></div><div class=\"col-md-1\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-4\"><div class=\"col-md-11\"><div class=\"form-group\"><label for=\"\">Select a sub locality:</label><select name=\"\" id=\"sublocalityId\" class=\"form-control\" ng-model=\"testData.testSubLocalityId\" ng-change=\"loadLocationData(\'dc\', testData.testSubLocalityId)\"><option value=\"\">Select a sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocationsList\">{{sublocation.lookUpValue}}</option></select></div></div><div class=\"col-md-1\"></div></div><div class=\"col-md-4\"><div class=\"col-md-11\"><div class=\"form-group\"><label for=\"\">Select DC:</label><select style=\"width:290px; padding-left: 10px;\" name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-options=\"option.entityName for option in diagnosticCentresList track by option.entityId\" ng-model=\"address.dc\"><option value=\"\">Select DC</option></select></div></div><div class=\"col-md-1\"></div></div><div class=\"col-md-4\"></div></div></div></div><button class=\"btn primary pull-right\" ng-click=\"clearSearch()\" style=\"margin-right: 27px;\">Clear</button> <button class=\"btn btn-primary pull-right\" ng-model=\"search\" style=\"margin-right: 5px;\" ng-click=\"settlePaymentMethod(\'corporate\',search.entityId)\" ng-show=\"clientFilterType ===\'corp\'\">Search</button> <button class=\"btn btn-primary pull-right\" ng-model=\"search\" style=\"margin-right: 5px;\" ng-click=\"settlePaymentMethod(\'dc\',address.dc)\" ng-show=\"clientFilterType ===\'dc\'\">Search</button></ng-form></div></uib-accordion></div></div><div class=\"row\" style=\"background-color: white;\"><div class=\"col-md-12\" ng-if=\"transactions.length>0\"><div class=\"form-signin\"><h4 class=\"strong text-center\" style=\"font-size: large; font-style: normal; color: cadetblue;\">Settled Invoices</h4><div class=\"table-responsive\" ng-show=\"transactions.length>0\"><p>Count: {{transactions.length}}</p><table class=\"table table-bordered\" style=\"table-layout: fixed; width: 1050px; background-color: white;\"><thead><tr><th style=\"color: cornflowerblue; table-layout: fixed; width: 370px;\">Invoice #</th><th style=\"color: cornflowerblue; table-layout: fixed; width: 250px;\">Amount</th><th style=\"color: cornflowerblue; table-layout: fixed; width: 250px;\">Date | Time</th><th style=\"color: cornflowerblue;\">PDF</th><th style=\"color: cornflowerblue;\">DL</th><th style=\"color: cornflowerblue;\">UL</th></tr></thead><tbody class=\"table-hover\"><tr ng-repeat=\"transaction in transactions | startFrom:(currentPage1-1)*entryLimit1 | limitTo:entryLimit1\"><td>{{transaction.invoiceNumber}}</td><td>{{transaction.amount}}</td><td>{{getAuditDate(transaction.invoiceDate)}} | {{UtilitiesService.getAuditTime(transaction.invoiceDate)}}</td><td><a href=\"{{downloadPrefix}}/WAPI/GetFile/{{transaction.dmsDocId}}\" target=\"_blank\"><i class=\"text-primary glyphicon glyphicon-download-alt\"></i></a></td><td ng-click=\"downloadSettledOrder(transaction.invoiceNumber)\"><a href=\"\"><i class=\"text-danger glyphicon glyphicon glyphicon-floppy-save\"></i></a></td><td data-toggle=\"modal\" data-target=\"#SubmitModal\" data-invid=\"{{transaction.invoiceNumber}}\" class=\"showUploadModal\"><a href=\"\"><i class=\"text-success glyphicon glyphicon glyphicon-floppy-open\"></i></a></td></tr></tbody></table><div style=\"margin-left: 380px;\"><uib-pagination total-items=\"noOfPages1\" ng-model=\"currentPage1\" max-size=\"maxSize1\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></div></div><div style=\"margin-left: 190px; margin-top: 30px; font-size: small; color: black;\" class=\"form-signin\" ng-show=\"transactions.length ===0\">No Transactions available!</div></div></div><div class=\"modal fade\" id=\"SubmitModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ReportsLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Upload updated excel sheet</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><div class=\"alert alert-danger\" role=\"alert\">Please upload appropriate transactions against of each transaction to avoid any discrepencies.</div><div class=\"row\"><div class=\"col-md-6\"><span class=\"strong pull-right\">Upload excel</span></div><div class=\"col-md-6\"><input type=\"file\" name=\"reports\" id=\"reports\"></div></div><label for=\"\">Uploaded file</label><div ng-repeat=\"reports in attachFiles.reports\" class=\"uploaded\">{{reports}}</div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div>");
$templateCache.put("app/modules/payments/payments.html","<style>\n    .invoice-title h2, .invoice-title h3 {\n        display: inline-block;\n    }\n\n    .table > tbody > tr > .no-line {\n        border-top: none;\n    }\n\n    .table > thead > tr > .no-line {\n        border-bottom: none;\n    }\n\n    .table > tbody > tr > .thick-line {\n        border-top: 2px solid;\n    }\n\n    form.add-user {\n        width: 400px;\n        margin: 0 auto;\n    }\n\n    .amount {\n        font-size: 30px;\n    }\n\n    .package-item {\n        font-weight: bold;\n        font-size: 12px;\n    }\n\n    .benef-item {\n        font-weight: normal;\n        font-size: 12px;\n        color: #AAA;\n    }\n\n    .brand img {\n        width: 190px;\n    }\n\n    .form-create {\n        width: 100%;\n    }\n\n    .card {\n        background-color: #F7F7F7;\n        padding: 20px 25px 30px;\n        margin: 0 auto 25px;\n        -moz-border-radius: 2px;\n        -webkit-border-radius: 2px;\n        border-radius: 2px;\n        -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n        -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n    }\n\n    .form-create.card {\n        margin-top: 0px;\n        margin-bottom: 10px;\n    }\n\n    .submit-buttons.card {\n        background-color: transparent;\n        -moz-border-radius: 0px;\n        -webkit-border-radius: 0px;\n        border-radius: 0px;\n        -moz-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n        -webkit-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n        box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n    }\n\n    .form-create-first.card {\n        margin-top: 30px;\n    }\n\n    .card-container.card {\n        width: 350px;\n        padding: 40px 40px;\n    }\n\n    #corp-search {\n        margin-bottom: 0px;\n    }\n\n    .firstScreen.card {\n        margin: 0 auto 25px;\n        margin-top: 50px;\n    }\n\n    .required {\n        border: 1px solid red;\n    }\n\n    .strong {\n        font-weight: bold;\n    }\n\n    .cart hr {\n        margin: 5px 0;\n    }\n</style><div ng-show=\"isOther\"><div class=\"active-appointments\"><script type=\"text/ng-template\" id=\"customPopupTemplate.html\"><div class=\"custom-popup-wrapper\" ng-style=\"{top: 0+\'px\', left: 0+\'px\'}\" style=\"display: block; position: relative\" ng-show=\"isOpen() && !moveInProgress\" aria-hidden=\"{{!isOpen()}}\"> <p class=\"message\">select from drop down.</p> <ul class=\"dropdown-menu\" role=\"listbox\" style=\"display: block;\"> <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.entityName}}\"> <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div> </li> </ul> </div></script><div id=\"fetchdc\" ng-show=\"opsuser || isGroupLogin\"><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"status.isFirstOpen\"><uib-accordion-heading><a style=\"color: #168cc9;\">Finance search panel</a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isFirstOpen, \'glyphicon-chevron-right\': !status.isFirstOpen}\"></i></uib-accordion-heading><ng-form name=\"userProfileForm\" class=\"form-horizontal\"><div id=\"user-profile\" class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Date from:</label><div class=\"col-sm-8\"><div class=\"input-group\"><input placeholder=\"Select from date\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"serverSearch.fromDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Finance type:</label><div class=\"col-sm-8\"><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-change=\"changeType(search.type)\" ng-options=\"option.name for option in financialType track by option.id\" ng-model=\"search.type\"></select></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Date to:</label><div class=\"col-sm-8\"><div class=\"input-group\"><input id=\"datetimeEnd\" placeholder=\"Select to date\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"serverSearch.toDate\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group\" ng-show=\"isSponsered\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Payment type:</label><div class=\"col-sm-8\"><select ng-change=\"filterFroSponsered(search.sponsered)\" name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-options=\"option.name for option in invoiceType track by option.id\" ng-model=\"search.sponsered\"></select></div></div><div class=\"form-group pull-right\" ng-hide=\"isSelectedPaid\"><div class=\"col-sm-12\"><button ng-if=\"!isOffline\" ng-click=\"getOfflineInvoiceNumber()\" class=\"btn btn-primary btn-sm\" data-toggle=\"modal\" data-target=\"#offlineInvoice\" style=\"margin-right: 5px;\">Offline</button> <button class=\"btn btn-primary btn-sm\" ng-disabled=\"!(serverSearch.fromDate&& serverSearch.toDate&&search.type.value)\" ng-model=\"search\" ng-click=\"searchFinanceDetails(serverSearch.fromDate, serverSearch.toDate,search.type.value,search.sponsered)\">Search</button> <button ng-if=\"isSAPDownload\" class=\"btn btn-info btn-sm\" ng-disabled=\"!(serverSearch.fromDate&& serverSearch.toDate&&search.type.value)\" ng-click=\"downloadSAPFile(serverSearch.fromDate, serverSearch.toDate,search.type.value,search.sponsered)\">SAP Download</button> <button class=\"btn primary btn-sm\" ng-disabled=\"!(serverSearch.fromDate || serverSearch.toDate || search.type.value)\" ng-click=\"clearSearch()\">Clear</button></div></div></div><div id=\"user-profile\" ng-show=\"isSelectedPaid\" class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Corporate type:</label><div class=\"col-sm-8\"><select style=\"margin-left: 12px; width: 273px;\" id=\"statusSearch\" ng-change=\"getCorporate(search.entityRelationSelectedSearch)\" class=\"form-control\" ng-options=\"option.entityName for option in EntityRelation track by option.id\" ng-model=\"search.entityRelationSelectedSearch\"></select></div></div><div class=\"form-group pull-right\"><div class=\"col-sm-12\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Corporate name:</label><div class=\"col-sm-8\"><input type=\"text\" ng-model=\"search.entityIdSearch\" placeholder=\"Type corporate name to search\" uib-typeahead=\"state as state.entityName for state in corporates | filter:{entityName:$viewValue}\" typeahead-popup-template-url=\"customPopupTemplate.html\" class=\"form-control\"></div></div><div class=\"form-group pull-right\"><div class=\"col-sm-12\"><button ng-click=\"getOfflineInvoiceNumber()\" class=\"btn btn-primary btn-sm\" data-toggle=\"modal\" data-target=\"#offlineInvoice\" style=\"margin-right: 5px;\">Offline</button> <button class=\"btn btn-primary btn-sm\" ng-disabled=\"!(search.entityRelationSelectedSearch && serverSearch.fromDate && serverSearch.toDate&&search.type.value)\" ng-model=\"search\" ng-click=\"searchFinanceDetails(serverSearch.fromDate, serverSearch.toDate,search.type.value,search.sponsered,search.entityIdSearch, search.entityIdSearch)\">Search</button> <button class=\"btn btn-info btn-sm\" ng-disabled=\"!(serverSearch.fromDate&& serverSearch.toDate&&search.type.value)\" ng-click=\"downloadSAPFile(serverSearch.fromDate, serverSearch.toDate,search.type.value,search.sponsered)\">SAP Download</button> <button class=\"btn primary btn-sm\" ng-click=\"clearSearch()\">Clear</button></div></div></div></div></div></ng-form></div></uib-accordion></div><ng-form name=\"userProfileForm\" ng-show=\"clientFilterType ===\'dc\'\" class=\"form-horizontal\"><div id=\"user-profile\" class=\"row\" style=\"background-color: #5f9ea0; padding-top: 15px; margin-top: -14px; padding-bottom: 7px; margin-bottom: 9px; margin-left: 2px; margin-right: 2px; border-radius: 5px;\"><div class=\"col-md-2\" style=\"width: 260px; margin-right: -4px; margin-left: -6px;\"><div class=\"form-group\"><div class=\"col-sm-11\"><div class=\"input-group\"><select ng-change=\"selectState(address.state)\" style=\"width: 193px; padding-left: 10px;\" name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-options=\"option.lookUpValue for option in states track by option.lookUpId\" ng-model=\"address.state\"></select></div></div></div></div><div class=\"col-md-2\" style=\"margin-left: -43px;width: 246px;\"><div class=\"form-group\"><div class=\"col-sm-11\"><select ng-change=\"selectCity(address.city)\" style=\"width: 193px; padding-left: 10px;\" name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-options=\"option.cityName for option in cities track by option.cityId\" ng-model=\"address.city\"></select></div></div></div><div class=\"col-md-3\" style=\"margin-left: -27px; width: 300px; padding-right: 35px;\"><div class=\"form-group\"><div class=\"col-sm-11\"><select ng-change=\"selectSubLocation(address.location)\" style=\"width: 193px; padding-left: 10px;\" name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-options=\"option.locationName for option in sublocations track by option.locationId\" ng-model=\"address.location\"></select></div></div></div><div class=\"col-md-3\" style=\"margin-left: -50px; width: 320px;\"><div class=\"form-group\"><div class=\"col-sm-12\"><select ng-change=\"clientSiteFilterForFinance(address.dc, \'dc\')\" style=\"width: 193px; padding-left: 10px;\" name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-options=\"option.entityName for option in diagnosticCentres track by option.entityId\" ng-model=\"address.dc\"></select></div></div></div><button class=\"btn primary\" ng-click=\"clearSearchClientFilter()\">Clear</button></div></ng-form></div><div class=\"modal fade\" id=\"offlineInvoice\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ReportsLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Offline Invoice</h4></div><div class=\"modal-body\"><p class=\"alert-danger\" ng-if=\"isFileError\">{{isFileErrormsg}}</p><form class=\"row form-inline\"><div class=\"form-group col-md-6\"><label for=\"diagnosis\">Upload Files</label><mb-plus-file-upload action=\"action\" file-fn=\"fileFn(arg)\"></mb-plus-file-upload></div><div class=\"form-group col-md-6\"><label for=\"diagnosis\">You are going to generate below invoice number *</label><br><div style=\"display: initial;\" ng-repeat=\"i in offlineInvoiceNumber\"><input ng-model=\"offlineInvoiceDTO.invoiceNumber\" name=\"gender\" value=\"{{i.invNumber}}\" type=\"radio\"> {{i.invNumber}}</div></div><div style=\"padding-top: 10px;\" class=\"form-group col-md-12\"><div class=\"label label-info\" ng-repeat=\"item in fileUploadDataObj\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: #eeeeee;\"><a ng-click=\"downloadAttachment(item.filePath)\">{{item.fileName}}</a> <a ng-click=\"removeFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div><div style=\"padding-top: 10px;\" class=\"form-group col-md-12\"><label for=\"diagnosis\">Remark *</label><br><textarea style=\"width: 97%;\" ng-model=\"offlineInvoiceDTO.remarks\" rows=\"4\" type=\"text\" name=\"Remark\"></textarea></div></form></div><div class=\"modal-footer\"><button type=\"button\" ng-disabled=\"offlineInvoiceDTO.remarks === \'\' || offlineInvoiceDTO.invoiceNumber ===\'\'\" class=\"btn btn-primary\" ng-click=\"postOffline(offlineInvoiceDTO)\">Submit</button> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><div ng-show=\"detailsfetched && !isEmployeePaid && outstanding!=0\" style=\"padding-bottom: 10px;\"><span style=\"font-size: 18px; padding-right: 4px; font-style: normal; font-weight: 600; color: cadetblue;\">Outstanding</span><span><span style=\"color: #afafaf; margin-RIght: 5PX;\">|</span><i class=\"fa fa-inr\"></i></span> <span style=\"color: #e03f4e; font-size: medium;\" ng-bind=\"formatCurrency(outstanding)\"></span></div><div class=\"row pull-right\" ng-if=\"fulfilledtransactionsDummyObj.length>0\" style=\"width: 50%;\"><div class=\"col-md-12\"><input class=\"form-control\" type=\"text\" name=\"search\" ng-model=\"searchInTable\" ng-change=\"searchResult(searchInTable)\" placeholder=\"type here for search...\"></div></div><div class=\"row\" style=\"background-color: white;\" ng-show=\"isFinanceData\"><div class=\"col-md-12\" style=\"background-color: white\"><div class=\"form-signin\"><h4 class=\"strong text-center\" style=\"font-size: large; font-style: normal; color: cadetblue;\">Pending Payments</h4><div class=\"table-responsive\" ng-show=\"fulfilledtransactions.length>0\"><p>Count: {{fulfilledtransactions.length}}</p><table style=\"table-layout: fixed; background-color: white\" class=\"table table-bordered\" id=\"waitingSettled\"><thead><tr><th style=\"color: cornflowerblue; table-layout: fixed; width: 26px;\" ng-show=\"opsuser\"><input ng-model=\"checkboxModel.isSelected\" ng-click=\"selectPendingInvoice()\" type=\"checkbox\" id=\"includeall\"></th><th ng-if=\"user.entityId === 1000042\" style=\"color: cornflowerblue;width: 65px;table-layout: fixed;\">Employee Id</th><th ng-if=\"user.entityId === 1000042\" style=\"color: cornflowerblue;width: 180px;table-layout: fixed;\">Entity Name</th><th style=\"color: cornflowerblue;width: 200px;table-layout: fixed;\">Package Name</th><th style=\"color: cornflowerblue; table-layout: fixed; width: 150px;\">Date | Time</th><th style=\"color: cornflowerblue; table-layout: fixed; width: 65px;\">Cost in Rs.</th></tr></thead><tbody class=\"table-hover\"><tr ng-repeat=\"transaction in fulfilledtransactions | startFrom:(currentPage-1)*entryLimit | limitTo:entryLimit\"><td ng-show=\"opsuser\"><input type=\"checkbox\" ng-click=\"selectParticularOrder(transaction.isIncluded)\" name=\"\" id=\"\" ng-model=\"transaction.isIncluded\"></td><td ng-if=\"user.entityId === 1000042\">{{transaction.employeeId}}</td><td ng-if=\"user.entityId === 1000042\">{{transaction.entityName}}</td><td>{{transaction.productName}}</td><td>{{transaction.appointmentDate | date:\'MMM d, y\'}} | {{transaction.appointmentDate | date:\'h:mm a\'}}</td><td class=\"text-right\">{{transaction.price}}</td></tr></tbody></table><div style=\"margin-left: 380px;\"><uib-pagination total-items=\"noOfPages\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div></div></div><button ng-show=\"fulfilledtransactions.length>0 && opsuser\" class=\"btn btn-primary\" ng-click=\"downloadOrders(false, clientFilterType)\">Download Orders</button> <button ng-show=\"fulfilledtransactions.length>0 && opsuser\" ng-disabled=\"isSelectedOrder\" class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"openconfrm(true, clientFilterType)\">Generate Invoice</button> <button ng-show=\"fulfilledtransactions.length>0 && opsuser\" ng-disabled=\"isSelectedOrder\" class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"openGSTPopup(true, clientFilterType)\">Edit Invoice</button> <button ng-show=\"fulfilledtransactions.length>0 && opsuser\" ng-disabled=\"isSelectedOrder\" class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"previewInvoice(clientFilterType,\'\')\">Preview</button><div style=\"margin-left: 190px; margin-top: 30px; font-size: small; color: black;\" class=\"form-signin\" ng-show=\"fulfilledtransactions.length===0\">No orders available!</div></div></div></div><div ng-show=\"!isOther\"><p><a style=\"margin-right: 6px;\" ng-repeat=\"item in previewInvoiceData track by $index\" ng-click=\"htmlOutput(item)\" ng-class=\"item.isOpen ? \'btn-warning\' : \'\'\" class=\"btn btn-primary btn-xs\">{{item.name}} {{item.id}}</a></p><div ng-show=\"isShowPDF\"><button class=\"btn btn-default pull-right\" ng-click=\"closePdf(isOpenEditGstPdf)\" style=\"margin-left: 2px; margin-right: 30px; margin-bottom: 5px\">close</button> <button class=\"btn btn-default pull-right\" style=\"margin-bottom: :5PX\" ng-click=\"print(\'result1\');\"><i class=\"fa fa-print\" aria-hidden=\"true\"></i></button><iframe id=\"result1\" name=\"result1\" src=\"javascript:\'\';\" class=\"resultIframe\" style=\"width: 1030px;height: 1150px;border: double;background-color: whitesmoke;overflow-y: hidden;overflow-x: hidden;\"></iframe></div></div><div class=\"modal fade\" id=\"openGSTModel\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><h4 ng-if=\"isGst\">Edit invoice</h4><h4 ng-if=\"!isGst\">Confirmation modal</h4></div><div class=\"modal-body\"><div ng-if=\"isGst\"><form name=\"formUrn\"><div class=\"row form-group\"><div class=\"col-md-6\"><label for=\"CGST\">GSTIN Number:</label> <input type=\"text\" ng-model=\"gst.gstNumber\" placeholder=\"Enter GSTIN number\" class=\"form-control\" id=\"gstNumber\"></div><div class=\"col-md-6\"><label for=\"SGST\">State:</label><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-options=\"option.StateName for option in gstState track by option.StateId\" ng-model=\"gst.state\"></select></div></div><div class=\"row form-group\"><div class=\"col-md-6\"><label for=\"pwd\">Address:</label> <textarea rows=\"3\" type=\"text\" ng-model=\"gst.mail\" placeholder=\"Enter address\" class=\"form-control\" id=\"mailAddress\">\n                                    </textarea></div></div></form></div><div ng-if=\"!isGst\"><p>Are you sure want to generate invoice? You can see preview before generating invoice.</p></div></div><div class=\"modal-footer\"><div ng-if=\"isGst\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button ng-disabled=\"!gst.mail || !gst.gstNumber || gst.state.StateId <= 0\" class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"previewInvoice(clientFilterType, gst)\">Preview</button> <button type=\"button\" ng-disabled=\"!gst.mail || !gst.gstNumber || gst.state.StateId <= 0\" class=\"btn btn-primary\" ng-click=\"settleInvoiceWithGST(gst,clientFilterType)\">Generate Invoice</button></div><div ng-if=\"!isGst\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">No</button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"downloadSelectedOrders(flagStatus,invoiceGenrationType, invoiceGstData)\">Yes</button></div></div></div></div></div><div class=\"modal fade\" id=\"InvoiceModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"InvoiceLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Settle Invoice</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\">Please enter the transaction details carefully</div><div class=\"form-group\"><input type=\"radio\" name=\"txntype\" value=\"neft\" checked=\"checked\" ng-click=\"neft=true;cheque=false\">NEFT &nbsp;&nbsp; <input type=\"radio\" name=\"txntype\" value=\"cheque\" ng-click=\"neft=false;cheque=true\">CHEQUE</div><div class=\"form-group\" ng-show=\"neft\"><label for=\"\">UTR number *</label> <input id=\"txnNumber\" class=\"form-control\" ng-model=\"txn.txnNumber\"></div><div class=\"form-group\" ng-show=\"cheque\"><label for=\"\">Cheque number *</label> <input id=\"txnNumber\" class=\"form-control\" ng-model=\"txn.txnNumber\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"settleInvoice()\">Settle invoice</button></div></div></div></div><div class=\"modal fade\" id=\"SubmitModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ReportsLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Upload updated excel sheet</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><div class=\"alert alert-danger\" role=\"alert\">Please upload appropriate transactions against of each transaction to avoid any discrepencies.</div><div class=\"row\"><div class=\"col-md-6\"><span class=\"strong pull-right\">Upload Excel</span></div><div class=\"col-md-6\"><input type=\"file\" name=\"reports\" id=\"reports\"></div></div><hr><label for=\"\">Uploaded file</label><div ng-repeat=\"reports in attachFiles.reports\" class=\"uploaded\">{{reports}}</div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"SAPfile\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"InvoiceLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Download SAP file</h4></div><div class=\"modal-body\"><div style=\"margin-top: 21px; margin-bottom: 82px;\"><label for=\"first-name\" style=\"margin-top: 9px;margin-right: -90px;\" class=\"control-label required-field col-sm-4\">Select date:</label><div class=\"col-sm-8\"><p ng-if=\"!isSapFileDownload\" class=\"ng-scope\" style=\"margin-top: -28px; color: red;\">Please select at least one order to download SAP file.</p><div class=\"input-group\"><input placeholder=\"Select from date\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"downloadDate.sap\" is-open=\"popup3.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open3()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!isSapFileDownload\" ng-click=\"downloadSAPFile()\">Download</button></div></div></div></div><div class=\"modal fade\" id=\"previewPdfModel\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><h4>Edit invoice</h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div><div class=\"modal fade\" id=\"confirmationModelPopupfinance\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><h4></h4></div><div class=\"modal-body\"></div><div class=\"modal-footer\"></div></div></div></div></div>");
$templateCache.put("app/modules/pharmacyDashboard/pharmacyDashboard.html","<style type=\"text/css\">\n    .nvd3.nv-pie path {\n        stroke-opacity: 0;\n    }\n\n    .fontawesome-select {\n        font-family: \'FontAwesome\', \'Helvetica\';\n    }\n</style><div class=\"panel panel-default\"><div class=\"panel-heading\" ng-click=\"showCard ? showCard = false : showCard = true\"><a style=\"color: #168cc9;\"><i class=\"fa fa-pie-chart pull-left\"></i> View Chart</a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': showCard, \'glyphicon-chevron-right\': !showCard}\"></i></div><div class=\"panel-body\" ng-show=\"showCard\"><div class=\"row\"><div class=\"col-md-3 p-l-1 p-r-0\"><div class=\"input-group\"><input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"dateFilterDate.fromDateFilter\" is-open=\"popup5.opened\" datepicker-options=\"dateDefautOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" ng-change=\"setMinDate(dateFilterDate.fromDateFilter)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open5()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-3 p-l-1 p-r-0\"><div class=\"input-group\"><input id=\"\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"dateFilterDate.toDateFilter\" is-open=\"popup6.opened\" datepicker-options=\"dateDefautOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" min-date=\"mindate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open6()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-3 p-l-1 p-r-1\"><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-options=\"option.entityName for option in contracts track by option.id\" ng-model=\"dashboardSearch.contractType\"><option value=\"\">Select contract</option></select></div><div class=\"col-md-1 p-l-1 p-r-0\"><button class=\"form-control btn-info\" ng-click=\"loadMasterChart(dateFilterDate.fromDateFilter,dateFilterDate.toDateFilter, \'\', \'fromFilter\')\" title=\"Filter Chart\"><i class=\"fa fa-filter\"></i></button></div><div class=\"col-md-2 p-l-1 p-r-1\"><button class=\"form-control btn-success\" ng-click=\"reload()\" title=\"Refresh\"><i class=\"fa fa-refresh\"></i></button></div></div><br><div class=\"row\" style=\"margin-top: -10px;\"><div class=\"col-md-7 p-l-1 p-r-0\"></div><div class=\"col-md-3 p-l-1 p-r-1 pull-right\" ng-show=\"masterData.length>0 || childData.length>0\"><select class=\"form-control xs fontawesome-select\" ng-model=\"chartType.type\" ng-change=\"changeChart(chartType.type)\"><option value=\"pie\" class=\"text-warning\">&#xf200; Pie chart</option><option value=\"donut\" class=\"text-warning\">&#xf192; Donut chart</option><option value=\"discrete\" class=\"text-warning\">&#xf080; Discrete bar chart</option></select></div></div><hr><div class=\"row\"><div class=\"col-md-4\" ng-if=\"masterData.length>0 || masterData.values.length>0\"><div style=\"box-shadow:0 0 16px #ddd; padding-top:20px;\"><nvd3 options=\"masterOptions\" data=\"masterData\"></nvd3><div class=\"alert alert-info text-center\"><b>{{totalMasterStatusRecord}}</b></div></div></div><div class=\"col-md-4\" ng-if=\"(masterData.length == 0 || masterData.values.length == 0) && dataError.length>0\"><div class=\"alert alert-danger text-center\"><b>{{dataError}}</b></div></div><div class=\"col-md-8\" ng-if=\"childData.length>0 || childData.values.length>0\"><div style=\"box-shadow: 0 0 16px #ddd; padding-top: 20px; height: 440px;\"><nvd3 options=\"childOptions\" data=\"childData\"></nvd3><div class=\"alert alert-info text-center\" style=\"margin-top: 20px;\"><b>{{totalChildStatusRecord}}</b></div></div></div><div class=\"col-md-8\" ng-if=\"(childData.length == 0 || childData.values.length == 0) && dataError.length>0\"><div class=\"alert alert-danger text-center\"><b>{{dataError}}</b></div></div></div></div></div><div class=\"row\"><div class=\"alert alert-success text-center pull-right\" ng-show=\"childParticularStatusData.length>0 && !showHashDetails\"><b>{{childParticularStatusData}}</b></div><div class=\"alert alert-success text-center pull-right\" ng-show=\"showHashDetails\"><b><span>{{hashDetails}}</span></b></div></div><div class=\"claims\" ng-show=\"tabtype === \'Active Appointments\'\"><angular-tab appointmentlist=\"activeAppointments\" tabname=\"\'Active Appointments\'\" tabtype=\"\'plusActiveAppointments\'\"></angular-tab></div><div class=\"modal fade\" id=\"openVarifyPres\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Verify prescriptions</h4></div><div class=\"modal-body\"><ul><li ng-repeat=\"pres in PharmaPrescriptionList\"><a href=\"{{pres.filePath}}\" target=\"_blank\">{{pres.fileName}}</a> <button class=\"removeLargeDocument\" ng-click=\"removePrescriptions($index)\">x</button></li></ul></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"verifyPrescription(PharmaPrescriptionList)\" ng-if=\"PharmaPrescriptionList.length>0\">Update</button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"openVarifyPresModal(\'\',\'reload\')\" ng-if=\"!PharmaPrescriptionList.length>0\">Reload prescription</button> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"{{actionName}}Modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 98\">Fit appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 97\">Unfit appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 30 || actionId ===29\">Reschedule appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 48\">Approve Appointment for payment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 24 || actionId ===23\">Confirm the appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 27 || actionId === 42\">Reject an appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 37\">Submit reports of this appointment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 34\">Approve appointment for payment</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 32\">Confirm customer attendance</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 39\">Confirm customer attendance</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 33\">Request for more information</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 91\">Place with partner</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 87\">Delivered</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 88\">Out for delivery</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 89\">Confirmation by retailer</h4><h4 class=\"modal-title modalHeaderText\" ng-show=\"actionId === 116\">Partially attended</h4></div><div class=\"modal-body\" ng-show=\"actionId === 48\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Appointment date *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 98 || actionId === 97\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"frmFit\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks</label><span ng-show=\"frmFit.remarks.$invalid\" class=\"redfont\">*</span> <textarea name=\"remarks\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks.fit\" required=\"\"></textarea></div></div><br><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Blood group</label><span ng-show=\"frmFit.bloodGrp.$invalid\" class=\"redfont\">*</span><select class=\"form-control\" ng-model=\"selectedBloodGrp\" required=\"\"><option value=\"\">Select blood group</option><option value=\"O+\">O+</option><option value=\"O-\">O-</option><option value=\"A+\">A+</option><option value=\"A-\">A-</option><option value=\"B+\">B+</option><option value=\"B-\">B-</option><option value=\"AB+\">AB+</option><option value=\"AB-\">AB-</option><option value=\"NA\">N/A</option></select></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 30 || actionId ===29\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"rescheduleForm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Current requested Date</label> <input name=\"doa\" id=\"originalDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-5\"><label for=\"doa\">Select reschedule date</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"reschedule.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"reschedule()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\" ng-if=\"actionId === 30 || actionId ===29\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><br><div class=\"alert alert-danger\" role=\"alert\"><button class=\"btn btn-xs btn-primary pull-right\" ng-click=\"useSecondPref()\" style=\"margin-left:10px;\">Use this</button> Customer has provided {{secondPreferredVTime}} as second preference. We would like you to consider this if possible.</div><span ng-show=\"showChkedOnDcLogin\"><input type=\"checkbox\" ng-click=\"showDcSelection(action.showdcselection, \'dcVisit\')\" ng-model=\"action.showdcselection\"> Check this to select a new diagnostic centre</span><br><span ng-show=\"showChkedOnDcLogin\"><input type=\"checkbox\" ng-click=\"showDcSelection(action.showHomeVisitSelection, \'homeVisit\')\" ng-model=\"action.showHomeVisitSelection\"> Check this to enter home address for home visit</span><hr><div class=\"\" ng-show=\"action.showHomeVisitSelection\"><label for=\"\">Enter home address to move this appointment</label><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-6 noPdngRt\"><input type=\"text\" class=\"form-control\" ng-model=\"homeVisit.addressLineOne\" placeholder=\"Enter Address line 1\"></div><div class=\"col-md-6 noPdngRt\"><input type=\"text\" class=\"form-control\" ng-model=\"homeVisit.addressLinTwo\" placeholder=\"Enter Address line 2\"></div></div></div><div class=\"\" ng-show=\"action.showdcselection\"><label for=\"doa\">Select a provider to move this appointment</label><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testStateId\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div><div class=\"col-md-4\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div></div><div class=\"row\"><div class=\"col-md-6 noPdngRt\"><select name=\"\" id=\"sublocalityId\" class=\"form-control\" ng-model=\"testData.testSubLocalityId\" ng-change=\"loadLocationData(\'dc\', testData.testSubLocalityId)\"><option value=\"\">Select a sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div><div class=\"col-md-6\"><select name=\"\" id=\"dcId\" ng-model=\"testData.dcValue\" class=\"form-control\" ng-change=\"changeDc(testData.dcValue)\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in diagnosticCentres track by $index\">{{dc.entityName}}</option></select></div></div></div><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></form></div><div class=\"modal-body\" ng-show=\"actionId === 24 || actionId ===23\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"frmConfirm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"doa\">Requested date of visit</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"row\" style=\"margin-top:10px; margin-bottom:10px;\" ng-if=\"action.showPrice\"><div class=\"col-md-6 noPdngRt\"><label for=\"doa\">Dc price</label><span class=\"redfont\">*</span> <input name=\"date\" id=\"dcPrice\" class=\"form-control\" type=\"number\" ng-model=\"action.dcPrice\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks</label><span ng-show=\"frmConfirm.remarks.$invalid\" class=\"redfont\">*</span> <textarea name=\"remarks\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 27\"><form name=\"rejectForm\"><label for=\"enhance-remarks\">Reasons for rejecting appointment: *</label><select class=\"form-control\" ng-model=\"action.cancelReason\" ng-change=\"resetDependencies(action.cancelReason)\" required=\"\"><option value=\"\">select cancellation reason</option><option value=\"{{f}}\" ng-repeat=\"f in reasonOfCancel\">{{f}}</option></select><br><textarea ng-if=\"action.cancelReason==\'Other\'\" name=\"reject-remarks\" ng-model=\"action.cancelComments\" class=\"form-control\" id=\"reject-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your reason to reject the appointment\" required=\"\"></textarea> <span>Appointment that has been rejected won\'t be completely removed from the queue. It has to be accepted by MAHS operations person in order to permanently cancel it*</span></form></div><div class=\"modal-body\" ng-show=\"actionId === 42\"><form name=\"rejectForm\"><label for=\"enhance-remarks\">Reasons for rejecting appointment: *</label><select class=\"form-control\" ng-model=\"action.cancelReason\" ng-change=\"resetDependencies(action.cancelReason)\" required=\"\"><option value=\"\">select cancellation reason</option><option value=\"{{f}}\" ng-repeat=\"f in reasonOfCancel\">{{f}}</option></select><br><textarea ng-if=\"action.cancelReason==\'Other\'\" name=\"reject-remarks\" ng-model=\"action.cancelComments\" class=\"form-control\" id=\"reject-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your reason to reject the appointment\" required=\"\"></textarea> <span>Appointment that has been rejected won\'t be completely removed from the queue. It has to be accepted by MAHS operations person in order to permanently cancel it*</span></form></div><div class=\"modal-body\" ng-show=\"actionId === 34\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Appointment date *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"date\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 32\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"attendedForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label>Actual date of visit *</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"attended.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"attended()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"col-md-2\" ng-if=\"actionId === 32\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div><div class=\"row col-md-12 col-sm-12 col-sm-12\"><label for=\"enhance-remarks\">Feedback*</label><select class=\"form-control\" ng-model=\"action.feedback\" required=\"\"><option value=\"\">select your feedback</option><option value=\"{{feedback}}\" ng-repeat=\"feedback in feedbackList\">{{feedback}}</option></select><br></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 39\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"notAttendedForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"> <label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 33\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"Raise_IAModalForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"remarks\">Details about requested information *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 37\"><form name=\"submitForm\" action=\"\" class=\"form\"><div class=\"alert alert-danger\" role=\"alert\">Please upload bills and reports appropriately to avoid delay in processing as well as repeated requests for more information</div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label>Attach lab reports *</label><br><div class=\"btn btn-sm btn-primary\" ng-click=\"addFileToUpload(\'reports\')\" style=\"margin-bottom:15px;\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></div><br><fieldset class=\"form-group\" data-ng-repeat=\"item in reports\"><div class=\"row\"><div class=\"col-sm-9\"><input type=\"file\" file-model=\"item.model\"></div><div class=\"col-sm-2\"><button class=\"removeLargeDocument\" ng-click=\"removeFileToUpload($index, \'reports\')\">-</button></div></div></fieldset></div><button class=\"btn btn-primary pull-right\" ng-show=\"reports.length > 0\" ng-click=\"uploadMethodFile(\'reports\')\">Upload reports</button></div></div></div><hr></div><br><div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label>Attach bills</label><br><button class=\"btn btn-sm btn-primary\" ng-click=\"addFileToUpload(\'bills\')\" style=\"margin-bottom:15px;\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add more files</span></button><br><fieldset class=\"form-group\" data-ng-repeat=\"item in bills\"><div class=\"row\"><div class=\"col-sm-9\"><input type=\"file\" file-model=\"item.model\"></div><div class=\"col-sm-2\"><button class=\"removeLargeDocument\" ng-click=\"removeFileToUpload($index, \'bills\')\">-</button></div></div></fieldset></div><button class=\"btn btn-primary pull-right\" ng-show=\"bills.length > 0\" ng-click=\"uploadMethodFile(\'bills\')\">Upload bills</button></div></div></div><hr></div><hr><label for=\"Reports\" ng-if=\"newlyUploadedReports.length > 0\">Reports</label><div ng-repeat=\"reports in newlyUploadedReports\" class=\"uploaded\"><a href=\"{{reports.filePath}}\" class=\"badge badge-info\">{{reports.fileName}}</a> <i class=\"fa fa-times\" ng-click=\"removeReports($index, \'report\')\"></i></div><br><label for=\"Bills\" ng-if=\"newlyUploadedBills.length > 0\">Bills</label><div ng-repeat=\"bills in newlyUploadedBills\" class=\"uploaded\"><a href=\"{{bills.filePath}}\" class=\"badge badge-info\">{{bills.fileName}}</a> <i class=\"fa fa-times\" ng-click=\"removeReports($index, \'bills\')\"></i></div><br><label for=\"\">Remarks</label> <textarea name=\"\" id=\"\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\"></textarea></form></div><div class=\"modal-body\" ng-show=\"actionId === 91\"><form name=\"frmPlacePartner\"><div class=\"row\"><div class=\"col-md-12\"><input type=\"text\" ng-model=\"action.partnerOrderId\" class=\"form-control\" placeholder=\"Partner Order ID\" required=\"\"></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 87\"><form name=\"frmDelivered\"><div class=\"row\"><div class=\"col-md-6\"><input type=\"number\" ng-model=\"pharmaData.cashlessAmt\" class=\"form-control\" placeholder=\"Cashless Amount\" required=\"\"></div><div class=\"col-md-6\"><input type=\"number\" ng-model=\"pharmaData.CODAmt\" class=\"form-control\" placeholder=\"Cash On Delivery Amount\" required=\"\"></div></div></form></div><div class=\"modal-body\" ng-show=\"actionId === 88\"><div class=\"row\"><div class=\"col-md-12\"><h4 style=\"margin-left: 145px;color: #a94442;\">Item is out for delivery</h4></div></div></div><div class=\"modal-body\" ng-show=\"actionId === 89\"><div class=\"row\"><div class=\"col-md-12\"><h4 style=\"margin-left: 145px;color: #a94442;\">Waiting for retailer confirmation</h4></div></div></div><div class=\"modal-body\" ng-show=\"actionId === 116\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"attendedPartiallyForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label>Actual date of visit *</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"attended.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"attended()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"col-md-2\" ng-if=\"actionId === 116\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Fit\',$event)\" ng-show=\"actionId === 98\">Fit appointment</button> <button type=\"button\" ng-disabled=\"frmFit.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'UnFit\',$event)\" ng-show=\"actionId === 97\">Unfit appointment</button> <button type=\"button\" ng-disabled=\"rescheduleForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Reschedule\',$event)\" ng-show=\"actionId === 30|| actionId ===29\">Request for reschedule</button> <button type=\"button\" ng-disabled=\"frmConfirm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Confirm\',$event)\" ng-show=\"actionId === 24 || actionId ===23\">Confirm appointment</button> <button type=\"button\" ng-disabled=\"rejectForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Cancel\',$event)\" ng-show=\"actionId === 27 || actionId === 42\">Submit</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Submit\',$event)\" id=\"fileUploadBtn\" ng-show=\"actionId === 37\" ng-disabled=\"!reports.length\">Submit</button> <button type=\"button\" ng-disabled=\"approveForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Approve\',$event)\" ng-show=\"actionId === 34\">Approve for payment</button> <button type=\"button\" ng-disabled=\"attendedForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Attended\',$event)\" ng-show=\"actionId === 32\">Confirm attendance</button> <button type=\"button\" ng-disabled=\"notAttendedForm.$invalid\" class=\"btn btn-danger\" ng-click=\"actionRequest(\'NotAttended\',$event)\" ng-show=\"actionId === 39\">Not attended</button> <button type=\"button\" ng-disabled=\"Raise_IAModalForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Raise_IA\',$event)\" ng-show=\"actionId === 33\">Request</button> <button type=\"button\" ng-disabled=\"approveForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'QCApprove\',$event)\" ng-show=\"actionId === 48\">Qc approved</button> <button type=\"button\" ng-disabled=\"frmPlacePartner.$invalid\" class=\"btn btn-primary\" ng-click=\"placeWithPartner()\" ng-show=\"actionId === 91\">Place order</button> <button type=\"button\" ng-disabled=\"frmDelivered.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Delivered\',$event)\" ng-show=\"actionId === 87\">Confirm</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'OutForDelivery\',$event)\" ng-show=\"actionId === 88\">Out for delivery</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'ConfirmByRetailer\',$event)\" ng-show=\"actionId === 89\">Confirm</button> <button type=\"button\" ng-disabled=\"attendedpartiallyformclass.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'PartiallyAttended\',$event)\" ng-show=\"actionId === 116\">Confirm partially attended</button></div></div></div></div><script type=\"text/ng-template\" id=\"walletModal.html\"><div class=\"modal-content\"> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"closeModal()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button> <h4 style=\"color: #005da2;\" class=\"modal-title\">Wallet balance</h4> </div> <div class=\"modal-body\"> <div class=\"col-md-12\"> <div class=\"row\" ng-show=\"isSuccess\"> <div class=\"col-md-4\"></div> <div class=\"col-md-4\"> <strong style=\"color:red;font-size:2em;\">{{showWalletBalanceMsz}}</strong> </div> <div class=\"col-md-4\"></div> </div> <div class=\"row\" ng-show=\"!isSuccess\"> <br /> <div class=\"col-md-1\"></div> <div class=\"col-md-10\" style=\"text-align:center;\"> <strong style=\"color: red; font-size: 1em;\">{{showWalletBalanceMsz}}</strong> </div> <div class=\"col-md-1\"></div> </div> </div> </div><br /><br /><br /> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"closeModal()\">Close</button> </div> </div></script>");
$templateCache.put("app/modules/pharmaDashboard/pharmaDashboard.html","<div><div class=\"row\"><div class=\"col-md-2\"><div class=\"container\"><div class=\"dropdown\"><button class=\"dropdown btn btn-primary dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" id=\"search-button\" style=\"margin-right: 3px;width: 150px;margin-left: -32px;border-top-right-radius: 0px;border-bottom-right-radius: 0px;\">{{dispayInDdl}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" style=\"margin-left: -32px;\"><li><a href=\"\" ng-model=\"orderId\" ng-click=\"getOrderType(\'1\')\">Order ID</a></li><li><a href=\"\" ng-model=\"contactNo\" ng-click=\"getOrderType(\'2\')\">Contact no.</a></li><li><a href=\"\" ng-model=\"name\" ng-click=\"getOrderType(\'3\')\">Name</a></li></ul></div></div></div><div class=\"col-md-8\"><form name=\"frmOrder\" action=\"\" class=\"form\" ng-show=\"selectedOrderType.length>0\" style=\"margin-left: -54px;\"><input type=\"text\" class=\"form-control\" placeholder=\"Enter search value\" ng-model=\"orderSearch\" ng-enter=\"\" style=\"height: 34px;\" required=\"\"> <input id=\"search-button\" type=\"button\" class=\"btn btn-primary\" style=\"border-top-left-radius: 0px; border-bottom-left-radius: 0px; margin-left: -3px; margin-top: -2px;\" value=\"Search\" ng-click=\"searchOrders()\" ng-disabled=\"frmOrder.$invalid\"></form></div><div class=\"col-md-2\"><button class=\"btn btn-success pull-right\" ng-click=\"refreshAll()\"><i class=\"glyphicon glyphicon-refresh\"></i> Reload</button><br><br></div></div><hr><div class=\"form-create card form-create-first\"><div class=\"row\"><div class=\"col-md-12\"><label>Orders</label></div><hr><div class=\"col-md-4\"><div class=\"panel panel-primary\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-md-3\"><i class=\"glyphicon glyphicon-tasks fa-5x\"></i></div><div class=\"col-md-9\"><div class=\"huge text-right\">{{newOrderDetails.count}}</div><b class=\"text-right\"><a href=\"\" style=\"color:white;\"><span ng-click=\"splitOrders(\'newOrders\')\">{{newOrderDetails.statusGroupName}}</span></a></b></div></div></div></div></div><div class=\"col-md-4\"><div class=\"panel panel-green\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-md-3\"><i class=\"fa fa-folder-open fa-5x\"></i></div><div class=\"col-md-9\"><div class=\"huge text-right\">{{openOrderDetails.count}}</div><b><a href=\"\" style=\"color:white;\"><span class=\"text-right\" ng-click=\"splitOrders(\'openOrders\')\">{{openOrderDetails.statusGroupName}}</span></a></b></div></div></div></div></div><div class=\"col-md-4\"><div class=\"panel panel-red\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-md-3\"><i class=\"fa fa-book fa-5x\"></i></div><div class=\"col-md-9\"><div class=\"huge text-right\">{{closeOrderDetails.count}}</div><b><a href=\"\" style=\"color:white;\"><span class=\"text-right\" ng-click=\"splitOrders(\'closeOrders\')\">{{closeOrderDetails.statusGroupName}}</span></a></b></div></div></div></div></div></div></div><div class=\"row\" ng-show=\"cityNameCountPE.length>0 || cityNameCountMB.length>0\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-primary form-control col-md-12\" style=\"padding-top:0!important;\" data-toggle=\"collapse\" data-target=\"#demo\">{{displayStatusName}}<i class=\"glyphicon glyphicon-chevron-down pull-right\" style=\"padding-top:7px;\"></i></button><br><div class=\"panel panel-default\"><div class=\"panel-header\"></div><div class=\"panel-body\"><div id=\"demo\"><div class=\"col-md-6\" style=\"margin-top:7px;\"><div class=\"form-create card transactions\"><div class=\"form-signin\"><h4 class=\"strong text-center\">Pharmeasy Order</h4><hr><div class=\"row\"><div class=\"col-md-6\"><table class=\"table table-bordered\"><thead><tr><th>Order by city</th></tr></thead><tbody><tr ng-repeat=\"cityname in cityNameCountPE\"><td><button class=\"btn btn-success btn-lg\" id=\"btnCity\" ng-model=\"cityname\" ng-click=\"getOrderDetails(\'Pharmeasy\', \'city\', cityname)\" style=\"width:124px; margin-top:3px;font-size: 11px; margin-left:40px;\">{{cityname.cityName}}<br>{{cityname.cityCount}}</button></td></tr><tr><td ng-show=\"cityNameCountPE.length==0\">No Orders!</td></tr></tbody></table></div><div class=\"col-md-6\"><table class=\"table table-bordered\"><thead><tr><th>Pending Order</th></tr></thead><tbody><tr><td><button class=\"btn btn-success btn-lg\" ng-model=\"selectedDays\" ng-click=\"getOrderDetails(\'Pharmeasy\', \'age1day\', ageing.age)\" style=\"width:124px; margin-top:3px;font-size: 11px; margin-left:40px;\">1 Day Old<br>{{countOnDayPE}}</button></td></tr><tr><td><button class=\"btn btn-primary btn-lg\" ng-model=\"selectedDays\" ng-click=\"getOrderDetails(\'Pharmeasy\', \'age2day\', ageing.age)\" style=\"width:124px; margin-top:3px;font-size: 11px; margin-left:40px;\">2 Day Old<br>{{countOnTwoPE}}</button></td></tr><tr><td><button class=\"btn btn-danger btn-lg\" ng-model=\"selectedDays\" ng-click=\"getOrderDetails(\'Pharmeasy\', \'age3day\', ageing.age)\" style=\"width:124px; margin-top:3px;font-size: 11px; margin-left:40px;\">3 Day Old<br>{{countOnThreePE}}</button></td></tr></tbody></table></div></div></div></div></div><div class=\"col-md-6\" style=\"margin-top:7px;\"><div class=\"form-create card transactions\"><div class=\"form-signin\"><h4 class=\"strong text-center\">Medybiz Order</h4><hr><div class=\"row\"><div class=\"col-md-6\"><table class=\"table table-bordered\"><thead><tr><th>Order by city</th></tr></thead><tbody><tr ng-repeat=\"cityname in cityNameCountMB\"><td><button class=\"btn btn-success btn-lg\" ng-model=\"selectedStatus\" ng-click=\"getOrderDetails(\'medibiz\', \'city\', cityname)\" style=\"width:124px; margin-top:3px;font-size: 11px; margin-left:40px;\">{{cityname.cityName}}<br>{{cityname.cityCount}}</button></td></tr><tr><td ng-show=\"cityNameCountMB.length==0\">No orders!</td></tr></tbody></table></div><div class=\"col-md-6\"><table class=\"table table-bordered\"><thead><tr><th>Pending Order</th></tr></thead><tbody><tr><td><button class=\"btn btn-success btn-lg\" ng-model=\"selectedStatus\" ng-click=\"getOrderDetails(\'medibiz\', \'age1day\', ageing.age)\" style=\"width:124px; margin-top:3px;font-size: 11px; margin-left:40px;\">1 Day Old<br>{{countOnDayMB}}</button></td></tr><tr><td><button class=\"btn btn-primary btn-lg\" ng-model=\"selectedStatus\" ng-click=\"getOrderDetails(\'medibiz\', \'age2day\', ageing.age)\" style=\"width:124px; margin-top:3px;font-size: 11px; margin-left:40px;\">2 Day Old<br>{{countOnTwoMB}}</button></td></tr><tr><td><button class=\"btn btn-danger btn-lg\" ng-model=\"selectedStatus\" ng-click=\"getOrderDetails(\'medibiz\', \'age3day\', ageing.age)\" style=\"width:124px; margin-top:3px;font-size: 11px; margin-left:40px;\">3 Day Old<br>{{countOnThreeMB}}</button></td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div><div ng-show=\"OrderDetails.length>0\"><angular-tab appointmentlist=\"OrderDetails\" tabname=\"\'Pharma Dashboard\'\" tabtype=\"\'pharmaDashboard\'\"></angular-tab></div><div class=\"modal fade\" id=\"AddMedicines\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Add Medicines</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-create card transactions\"><div class=\"form-signin\"><h4 class=\"strong text-center\">Add Medicines</h4><hr><div class=\"row\"><div class=\"col-md-10\"><div class=\"row\"><form name=\"frmAddMedicine\"><div class=\"col-md-8\"><input type=\"text\" ng-model=\"mediname\" placeholder=\"Start typing to search medicine..\" uib-typeahead=\"medi.medicine for medi in getMatchedMedicines($viewValue)\" typeahead-on-select=\"onSelect($item, $model, $label)\" class=\"form-control\" style=\"\" required=\"\"></div><div class=\"col-md-4\"><input type=\"number\" class=\"form-control\" id=\"\" ng-model=\"noOfMedicine\" style=\"width:97px;\" placeholder=\"No. of packs\" required=\"\"> <label for=\"\" id=\"quan\">Quantity:<span ng-bind=\"mediquantity\"></span></label></div></form></div></div><div class=\"col-md-2\"><button class=\"btn btn-primary btn-sm\" style=\"margin-left:-10px;\" ng-click=\"addMedicines()\" ng-disabled=\"frmAddMedicine.$invalid\">Add</button></div></div><br><hr><div class=\"row\"><div class=\"col-md-12\"><table class=\"table table-condensed table-hover table table-bordered\"><thead><tr><th>Slno.</th><th>Medicine name</th><th>No. of packet</th><th>Delete</th></tr></thead><tbody><tr ng-repeat=\"med in collectedMedicines\"><td>{{$index+1}}</td><td>{{med.nameOfMedicine}}</td><td>{{med.quantityOfMedicine}}</td><td><button class=\"btn btn-danger fa fa-trash-o\" ng-model=\"btnDelt\" ng-click=\"removeMedicine($index)\"></button></td></tr></tbody></table></div></div></div></div></div><div class=\"col-md-6\"><div class=\"form-create card transactions\"><div class=\"form-signin\"><h4 class=\"strong text-center\">Prescription</h4><hr><div class=\"row\" ng-repeat=\"img in allImages track by $index\"><div class=\"zoomWrap\" style=\"position:relative;overflow: auto; height: 300px; width: 97%; margin-left:7px;border: 1px solid #dddddd;\"><img ng-src=\"{{img}}\" ng-init=\"zoomWidth = 400;imgStyle = {width:\'400px\'}\" ng-style=\"imgStyle\" ng-mouse-wheel-up=\"zoomWidth = zoomWidth + 20; imgStyle.width = zoomWidth +\'px\';\" ng-mouse-wheel-down=\"zoomWidth = zoomWidth - 20;imgStyle.width = zoomWidth +\'px\';\"></div><hr><span style=\"padding-left:15px;\">Download prescription file</span> <a class=\"btn btn-primary glyphicon glyphicon-cloud-download\" style=\"margin-left:10px;width:45px;\" href=\"{{img}}\"></a><hr></div><div class=\"row\" ng-repeat=\"pdf in allPdfs\"><hr><span style=\"padding-left:15px;\">Download prescription file(pdf)</span> <a class=\"btn btn-primary glyphicon glyphicon-cloud-download\" style=\"margin-left:10px;width:45px;\" href=\"{{pdf}}\"></a><hr></div><div class=\"row\" ng-repeat=\"fils in filesWithoutExtentions\"><span style=\"padding-left:15px;\">Download prescription file</span> <a class=\"btn btn-primary glyphicon glyphicon-cloud-download\" style=\"margin-left:10px;width:45px;\" href=\"{{fils}}\"></a><hr></div></div></div></div></div><div class=\"alert alert-danger\" id=\"addMediMessage\" ng-show=\"showMediMessage\" ng-class=\"addClass\" role=\"alert\" ng-click=\"showMediMessage=false\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span> <span class=\"glyphicon glyphicon-remove pull-right\"></span> <span ng-bind-template=\"{{mediFailmessage}}\"></span></div><div class=\"alert alert-success\" id=\"\" ng-show=\"showSuccessMediMessage\" ng-class=\"addClass\" role=\"alert\" ng-click=\"showSuccessMediMessage=false\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span> <span class=\"glyphicon glyphicon-remove pull-right\"></span> <span ng-bind-template=\"{{mediSuccessmessage}}\"></span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"createMedicineOrder()\" ng-disabled=\"\" disabled=\"disabled\">Place Order</button> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"clearMedicineData()\">Close</button></div></div></div></div></div>");
$templateCache.put("app/modules/planned/planned.html","<div class=\"tab-pane\" ng-show=\"plannedRequests && plannedRequests.length > 0\"><angular-tab datalist=\"plannedRequests\" tabname=\"\'Planned Requests\'\"></angular-tab></div><div class=\"callout\" ng-hide=\"plannedRequests && plannedRequests.length > 0\"><div class=\"bs-callout bs-callout-info\"><h4>No eCashless requests found.</h4><p ng-show=\"!searchResults\">This hospital doesn\'t seem to have any Planned requests.</p><p ng-show=\"searchResults\">We couldn\'t find any request matching your search criteria. Could you please try with other search criteria</p></div></div><message background=\"msg.background\" body=\"msg.body\" header=\"msg.header\" show=\"msg.show\"></message>");
$templateCache.put("app/modules/plannedCheck/plannedCheck.html","<style>\n    .bs-callout {\n        padding: 20px;\n        margin: 20px 0;\n        border: 1px solid #eee;\n        border-left-width: 5px;\n        border-radius: 3px;\n    }\n\n        .bs-callout + .bs-callout {\n            margin-top: -5px;\n        }\n\n    .bs-callout-info {\n        border-left-color: #5bc0de;\n        background-color: cadetblue;\n    }\n\n    a {\n        color: #5bc0de;\n    }\n\n    #new-claim-msg .chat-content_wrap {\n        background-color: #428bca;\n    }\n\n    .body {\n        overflow: scroll;\n        height: 656px;\n    }\n</style><div class=\"row dashboard\" style=\"height:656px;overflow:scroll\"><div class=\"callout\"><div class=\"bs-callout bs-callout-info\" ng-show=\"loading\"><h4>Loading hospitalization details...</h4><p>Please wait while we fetch the details of intimated claim by the patient.</p><p ng-show=\"errorMessage\" class=\"\"><label class=\"label label-danger\">{{errorMessage}}</label></p></div></div><div class=\"main-body\" ng-show=\"validPage && !loading\"><div class=\"bs-callout bs-callout-info\"><h4>Planned Hospitalization request for {{request.id}}</h4></div><div><div class=\"panel panel-default\" id=\"new-claim-success\" ng-show=\"msubsuccess\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\" id=\"new-claim-msg\"><div class=\"chat-content_wrap bg-primary\"><h4 class=\"chat-status text-center\">Hospitalization details has been updated successfully! You can now close the window.</h4></div></div><div class=\"col-md-2\"></div></div></div></div><div class=\"panel panel-default\" id=\"new-claim-form\" ng-show=\"!msubsuccess\"><div class=\"panel-body chat\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"chat-content_wrap\"><div class=\"chat-content\"><form id=\"plannedHospForm\" novalidate=\"\" name=\"signup_form\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><input type=\"hidden\" name=\"aarogyaClaim\" value=\"planned-Hospitlization\"> <input name=\"hospId\" id=\"formHospId\" type=\"hidden\"> <input name=\"hospName\" id=\"formHospName\" type=\"hidden\"> <input name=\"plannedHospId\" id=\"plannedHospId\" ng-model=\"request.id\" type=\"hidden\"> <input name=\"externalAppCheck\" value=\"noLoginPlanned\" type=\"hidden\"> <input name=\"createdBy\" id=\"formCreatedBy\" type=\"hidden\"></div></div><div class=\"col-md-6\"></div><input type=\"hidden\" name=\"packages\" id=\"packagesHolder\"> <input type=\"hidden\" name=\"packageAmnt\" id=\"packageAmountHolder\"></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"patientFirstName\">Full Name *</label> <input name=\"patientFirstName\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"request.patientName\" required=\"\" readonly=\"\"><div class=\"error\" ng-show=\"signup_form.patientFirstName.$dirty && signup_form.patientFirstName.$invalid\"><small class=\"error\" ng-show=\"signup_form.patientFirstName.$error.required\">Your name is required.</small></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"contactNum\">Mobile Number *</label> <input name=\"contactNum\" type=\"number\" class=\"form-control\" placeholder=\"\" ng-model=\"request.mobileNumber\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\" readonly=\"\"><div class=\"error\" ng-show=\"signup_form.contactNum.$dirty && signup_form.contactNum.$invalid\"><small class=\"error\" ng-show=\"signup_form.contactNum.$error.required\">Your mobile number is required.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.number\">Your mobile number can contain only numbers</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.minlength\">Your name is required to be at least 10 characters</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.maxlength\">Your name cannot be longer than 10 characters</small></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"employer\">Corporate Name *</label> <input name=\"employer\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"request.corporateName\" required=\"\" readonly=\"\"><div class=\"error\" ng-show=\"signup_form.employer.$dirty && signup_form.employer.$invalid\"><small class=\"error\" ng-show=\"signup_form.employer.$error.required\">Employer name is required.</small></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"empid\">Employee ID *</label> <input name=\"empid\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"request.employeeId\" ng-required=\"!signup_form.maid.$valid\" readonly=\"\"><div class=\"error\" ng-show=\"signup_form.empid.$dirty && signup_form.empid.$invalid\"><small class=\"error\" ng-show=\"signup_form.empid.$error.required\">Employee ID is required.</small></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"maid\">MAID *</label> <input name=\"maid\" type=\"number\" class=\"form-control\" placeholder=\"\" ng-model=\"request.maid\" ng-required=\"!signup_form.empid.$valid\" readonly=\"\"><div class=\"error\" ng-show=\"signup_form.maid.$dirty && signup_form.maid.$invalid\"><small class=\"error\" ng-show=\"signup_form.maid.$error.required\">MAID is required and should contain only numbers.</small> <small class=\"error\" ng-show=\"signup_form.maid.$error.number\">MAID can contain only numbers</small></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"admissionType\">Admission Type</label> <input type=\"text\" class=\"form-control\" value=\"Planned\" readonly=\"readonly\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"doa\">Date of admission *</label> <input name=\"doa\" id=\"datetimepicker\" class=\"form-control\" type=\"text\" ng-model=\"request.doa\" required=\"\" readonly=\"\"><div class=\"error\" ng-show=\"signup_form.doa.$dirty && signup_form.doa.$invalid\"><small class=\"error\" ng-show=\"signup_form.doa.$error.required\">Tentative date of admission is required.</small> <small class=\"error\" ng-show=\"signup_form.doa.$error.datetimelocal\">Tentative date is Invalid.</small></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"dod\">Date of discharge *</label> <input name=\"dod\" id=\"dischargetimepicker\" class=\"form-control\" type=\"text\" ng-model=\"request.dod\" required=\"\" readonly=\"\"><div class=\"error\" ng-show=\"signup_form.dod.$dirty && signup_form.dod.$invalid\"><small class=\"error\" ng-show=\"signup_form.dod.$error.required\">Tentative date of discharge is required.</small></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnosis *</label> <textarea name=\"diagnosis\" class=\"form-control\" placeholder=\"Enter diagnosis details\" ng-model=\"request.diagnosis\" required=\"\"></textarea><div class=\"error\" ng-show=\"signup_form.diagnosis.$dirty && signup_form.diagnosis.$invalid\"><small class=\"error\" ng-show=\"signup_form.diagnosis.$error.required\">Diagnosis details are required.</small></div></div></div><div class=\"col-md-6\"><div class=\"form-group\" ng-show=\"!form.isgovtscheme\"><label for=\"procedure\">Procedure *</label> <textarea name=\"procedure\" class=\"form-control\" placeholder=\"Enter procedure details\" ng-model=\"request.procedure\" required=\"\"></textarea><div class=\"error\" ng-show=\"signup_form.procedure.$dirty && signup_form.procedure.$invalid\"><small class=\"error\" ng-show=\"signup_form.procedure.$error.required\">Procedure details are required.</small></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"ipnumber\">In patient number <span ng-show=\"request.opnumber !== \'\'&& request.opnumber!= undefined\" class=\"label-primary pull-right\" style=\"font-size: smaller; margin-left: 5px; color: white;\">Out patient number - {{request.opnumber}}</span></label> <input name=\"ipnumber\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"request.ipnumber\"><div class=\"error\" ng-show=\"signup_form.ipnumber.$dirty && signup_form.ipnumber.$invalid\"><small class=\"error\" ng-show=\"signup_form.ipnumber.$error.number\">Inpatient number can contain only numbers</small></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"approxClaimedAmnt\">Estimated Amount *</label> <input name=\"approxClaimedAmnt\" type=\"number\" class=\"form-control\" placeholder=\"\" ng-model=\"request.clmamount\" required=\"\"><div class=\"error\" ng-show=\"signup_form.approxClaimedAmnt.$dirty && signup_form.approxClaimedAmnt.$invalid\"><small class=\"error\" ng-show=\"signup_form.approxClaimedAmnt.$error.required\">Claimed amount is required and can contain only numbers.</small> <small class=\"error\" ng-show=\"signup_form.contactNum.$error.number\">Claimed amount can contain only numbers</small></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"docName\">Doctor Name *</label> <input name=\"docName\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"request.doctorName\" required=\"\"><div class=\"error\" ng-show=\"signup_form.docName.$dirty && signup_form.docName.$invalid\"><small class=\"error\" ng-show=\"signup_form.docName.$error.required\">Doctor name is required.</small></div></div></div><div class=\"col-md-6\"><div class=\"form-group\" ng-show=\"!form.isgovtscheme\"><label for=\"roomType\">Provided room type *</label><select name=\"roomType\" id=\"roomType\" class=\"form-control\" ng-model=\"request.roomtype\" required=\"\"><option value=\"GeneralWard\">General Ward</option><option value=\"TwinSharingWard\">Twin Sharing Ward</option><option value=\"SinglePrivateWard\">Single Private Ward</option></select></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"bg-info mandatory text-center\">All fields marked with * are mandatory</div></div></div><label ng-show=\"plannedAttachment\">Attachmets</label><div class=\"attachment\"><table><tr ng-repeat=\"item in plannedAttachment\"><td><a target=\"_blank\" href=\"{{DMSUrl}}{{item.planHospDMSAttachmentPath}}\">{{item.planHospDMSAttachFileName}}</a></td></tr></table></div><div id=\"fileupload\"><hr><p class=\"bg-danger\">Maximum file upload limit is 15 MB.</p><br><div class=\"row\"><div class=\"col-md-4\">Initial pre authorization form</div><div class=\"col-md-5\"><input type=\"file\" name=\"preauth\" file-model=\"file.myFile1\"></div></div><hr><div class=\"row\"><div class=\"col-md-4\">Investigations</div><div class=\"col-md-5\" id=\"investigationdocs\"><input type=\"file\" name=\"investigations\" file-model=\"file.myFile2\"></div></div><hr><div class=\"row\"><div class=\"col-md-4\">Others</div><div class=\"col-md-5\" id=\"otherdocs\"><input type=\"file\" name=\"otherfiles\" file-model=\"file.myFile3\"></div></div><hr><button type=\"button\" class=\"btn btn-primary start\" ng-disabled=\"signup_form.$invalid\" id=\"nabutton\" ng-click=\"submissionRelatedMethods.submitPlannedHosp()\"><span>Submit New Admission</span></button></div></form></div></div></div></div></div><div class=\"col-md-2\"></div></div></div></div><div class=\"modal fade\" id=\"confirmedPreauthAction\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-body\"><h4>Confirm</h4><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-6\"><input class=\"form-control\" type=\"text\" ng-model=\"selectedPreauth.Otp\" placeholder=\"Enter OTP\"></div><div class=\"col-md-6\"><button class=\"btn btn-success\" ng-click=\"getOtpConfirmed(selectedPreauth.claimId)\">Submit</button></div></div></div><br><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-12\"><button ng-disabled=\"selectedPreauth.disabledPreauthForm\" class=\"btn btn-primary btn-xs\" ng-click=\"getPreAuthForm(selectedPreauth)\">Pre-Auth Form</button></div><div class=\"col-md-12\" style=\"margin-top:10px\"><button ng-disabled=\"selectedPreauth.disabledSettlementLatter\" class=\"btn btn-primary btn-xs\" ng-click=\"getSettlementLetter(selectedPreauth)\">Approval Letter</button> <a ng-show=\"selectedPreauth.letterDownloadLink==\'Pre-Auth Approved\'\" href=\"selectedPreauth.letterDownloadLink\">Download Link</a> <span ng-show=\"selectedPreauth.letterDownloadLink==false\" class=\"label label-danger\">Letter Not Generated</span> <span ng-show=\"selectedPreauth.showOtpRemarks\" class=\"label label-danger\">{{selectedPreauth.OtpRemarks}}</span></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"moveToActiveQueue(selectedPreauth.claimRefNo)\">Move To Active Queue</button> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"template\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-body\"><h4>Confirm</h4></div><div class=\"modal-footer\"><button type=\"button\" data-dismiss=\"modal\" class=\"btn\">Close</button></div></div></div></div></div></div><div class=\"callout\"><div class=\"bs-callout bs-callout-info\" ng-show=\"!validPage\"><h4>Oops! Something\'s not right!</h4><p>If you are an existing user of Medibuddy+ - <a href=\"http://plus.medibuddy.in\">Click here</a> to go home. Otherwise, you can request a membership to use Medibuddy+ for free by sending an email to <a href=\"mailto:hospital.medibuddy@mediassistindia.com\">hospital.medibuddy@mediassistindia.com</a></p></div></div></div>");
$templateCache.put("app/modules/plusContact/plusContact.html","<div class=\"row dashboard\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>Contact Us</strong> <strong class=\"pull-right\">Call us on. 1860 425 0025</strong></div><div class=\"panel-body\" style=\"padding:10px 20px;\"><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><p ng-show=\"showErrorMessage\" class=\"bg-warning error\" style=\"padding:10px;\">Unable to subbmit request</p><p ng-show=\"showSuccessMessage\" class=\"bg-info success\" style=\"padding:10px;\">Your request has been submitted. One of our executive will get in touch with you. Have a great day!</p><div id=\"contact-form\"><form name=\"frmContact\"><div class=\"form-group\"><label for=\"from-email\">Diagnostic centre email</label> <input type=\"text\" name=\"from-email\" id=\"from-email\" class=\"form-control\" ng-model=\"fromEmail\" ng-disabled=\"true\"></div><div class=\"form-group\"><label for=\"subject\">Subject*</label><select name=\"subject\" id=\"subject\" class=\"form-control\" ng-model=\"subject\" required=\"\"><option value=\"General query\">General query</option><option value=\"Claims related query\">Appointments related query</option><option value=\"Hospital-profile change request\">Profile change request</option><option value=\"Payment related query\">Payment related query</option><option value=\"Feedback\">Feedback</option></select></div><div class=\"form-group\"><label for=\"message\">Message*</label> <textarea ng-model=\"message\" name=\"message\" id=\"message\" rows=\"5\" style=\"width:100%;\" class=\"form-control\" required=\"\"></textarea></div><button type=\"submit\" class=\"btn btn-success\" ng-click=\"sendMessage()\" ng-show=\"getUserRole()!=\'guest\'\" ng-disabled=\"frmContact.$invalid\">Submit</button></form></div></div></div></div></div></div>");
$templateCache.put("app/modules/profile/profile.html","<style>\n    .row {\n        line-height: 25px;\n    }\n\n    .panel-heading h4 {\n        display: inline;\n    }\n\n    .bg-danger {\n        padding: 10px;\n    }\n</style><div class=\"dashboard\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h4>Diagnostic Centre Details</h4></div><div class=\"panel-body\" style=\"padding:10px 20px;\" ng-show=\"dcDetails.id!=undefined\"><div class=\"row\"><div class=\"col-md-4 col-xs-4\">Diagnostic Centre Name</div><div class=\"col-md-8 col-xs-8\"><strong>{{dcDetails.fullName}}</strong></div></div><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><hr style=\"margin:0;\"></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-4\">Address</div><div class=\"col-md-8 col-xs-8\"><strong>{{dcDetails.primaryAddress}}</strong></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-4\">Pincode</div><div class=\"col-md-8 col-xs-8\"><strong>{{dcDetails.pinCode}}</strong></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-4\">City</div><div class=\"col-md-8 col-xs-8\"><strong>{{dcDetails.city}}</strong></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-4\">State</div><div class=\"col-md-8 col-xs-8\"><strong>{{dcDetails.state}}</strong></div></div><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><hr style=\"margin:0;\"></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-4\">E-mail</div><div class=\"col-md-8 col-xs-8\"><strong>{{dcDetails.emailAddress}}</strong></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-4\">Phone No.</div><div class=\"col-md-8 col-xs-8\"><strong>{{dcDetails.landlineNumber}}</strong></div></div><div class=\"row\" ng-show=\"dcDetails.contactPersonName\"><div class=\"col-md-4 col-xs-4\">Contact Person</div><div class=\"col-md-8 col-xs-8\"><strong>{{dcDetails.primaryContactName}}</strong></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-4\">Mobile No.</div><div class=\"col-md-8 col-xs-8\"><strong>+91</strong><strong>{{dcDetails.mobileNumber}}</strong></div></div></div><p class=\"bg-danger\">If you feel anything has to be changed in your profile, please use the contact form with subject as \'Profile change request\'. One of our representative will get in touch with you soon.</p></div></div>");
$templateCache.put("app/modules/providerAction/providerAction.html","<div class=\"form-group\" ng-show=\"show.message\"><div class=\"container providerAction col-md-12 col-sm-12 col-xs-12\"><form #provideractionfrom=\"\" class=\"contentPart\"><h1 id=\"messageContent\" style=\"text-align: center;\">{{displayMessage}}</h1></form></div></div><div ng-show=\"show.contactDetails\" class=\"form-group\"><div class=\"container providerAction col-md-12 col-sm-12 col-xs-12\"><form #provideractionfrom=\"\" class=\"contentPart\"><h1>Enter provider contact details</h1><input class=\"col-md-9 col-sm-9 col-xs-12 input-box\" name=\"contact\" id=\"contact\" type=\"tel\" placeholder=\"Please enter provider contact number\" ng-model=\"contactNumber\" required=\"\" style=\"margin-top: 30px\"> <button class=\"col-md-2 col-sm-2 col-xs-4 btn btn-lg btn-primary submit-button\" ng-click=\"makeRequestCall()\" style=\"margin-top: 30px\" ng-disabled=\"!contactNumber\">Submit</button></form></div></div><div class=\"form-group\" ng-show=\"show.upload\"><div class=\"container col-md-12 col-sm-12 col-xs-12\"><form #provideractionuploadfrom=\"\" class=\"contentPart\"><h1>Attach lab reports</h1><mb-plus-file-upload action=\"action\" file-fn=\"fileFn(arg, \'report\')\" class=\"col-md-8 col-sm-12 col-xs-12\" style=\"margin-left: -30px;margin-top: 30px;\"></mb-plus-file-upload><button class=\"col-md-2 col-sm-2 col-xs-4 btn btn-sm btn-primary submit-button\" ng-click=\"makeRequestCall()\" style=\"margin-top: 32px\" ng-disabled=\"storeFiles.length === 0\">Submit</button></form></div><div class=\"form-group container col-sm-6\"><div ng-if=\"storeFiles.length > 0\" class=\"form-group contentPart\" ng-repeat=\"item in storeFiles\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: rgb(238, 238, 238);font-size: 12px;\"><a ng-click=\"downloadAttachment(item.filePath)\" class=\"col-md-10\">{{item.fileName}}</a> <a ng-click=\"removeFiles(item)\" class=\"col-md-2\" style=\"color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div></div>");
$templateCache.put("app/modules/queue/queue.html","<style>\n    form.add-user {\n        width: 400px;\n        margin: 0 auto;\n    }\n\n    .brand img {\n        width: 190px;\n    }\n    .ngDrobdown {\n        pointer-events:none;\n        opacity: 0.5;\n    }\n    .table .label.status-name {\n        width: 160px;\n    }\n\n    strong.strong {\n        margin-top: 5px;\n        font-size: 15px;\n        display: block;\n    }\n\n    form.add-user {\n        width: 400px;\n        margin: 0 auto;\n    }\n\n    .package-item {\n        font-weight: bold;\n        font-size: 12px;\n    }\n\n    .benef-item {\n        font-weight: normal;\n        font-size: 12px;\n        color: #AAA;\n    }\n\n    .brand img {\n        width: 190px;\n    }\n\n    .form-create {\n        width: 100%;\n        /*padding: 40px 40px;*/\n    }\n\n    .card {\n        background-color: #F7F7F7;\n        /* just in case there no content*/\n        padding: 20px 25px 30px;\n        /*margin: 0 auto 25px;*/\n        /*margin-top: 50px;*/\n        /* shadows and rounded borders */\n        -moz-border-radius: 2px;\n        -webkit-border-radius: 2px;\n        border-radius: 2px;\n        -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n        -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n    }\n\n    .form-create.card {\n        margin-top: 0px;\n        margin-bottom: 10px;\n    }\n\n    .submit-buttons.card {\n        background-color: transparent;\n        -moz-border-radius: 0px;\n        -webkit-border-radius: 0px;\n        border-radius: 0px;\n        -moz-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n        -webkit-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n        box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n    }\n\n    .form-create-first.card {\n        margin-top: 30px;\n    }\n\n    .card-container.card {\n        width: 350px;\n        padding: 40px 40px;\n    }\n\n    .form-signin .form-control {\n        margin-bottom: 35px;\n        height: 45px;\n    }\n\n    .form-create .form-control {\n        margin-bottom: 15px;\n        height: 35px;\n    }\n\n    .firstScreen.card {\n        margin: 0 auto 25px;\n        margin-top: 50px;\n    }\n\n    .required {\n        border: 1px solid red;\n    }\n\n    .strong {\n        font-weight: bold;\n    }\n\n    .cart hr {\n        margin: 5px 0;\n    }\n\n    .active-appointments, .settled-appointments, .pending-appointments, .no-active-appointments {\n        padding-top: 20px;\n    }\n\n    .btn-reload {\n        float: right;\n    }\n\n    #searchQuery {\n        margin-top: -100px;\n    }\n\n    #map {\n        height: 100%;\n    }\n    /* Optional: Makes the sample page fill the window. */\n    html, body {\n        height: 100%;\n        margin: 0;\n        padding: 0;\n    }\n\n    #description {\n        font-family: Roboto;\n        font-size: 15px;\n        font-weight: 300;\n    }\n\n    #infowindow-content .title {\n        font-weight: bold;\n    }\n\n    #infowindow-content {\n        display: none;\n    }\n\n    #map #infowindow-content {\n        display: inline;\n    }\n\n    .pac-card {\n        margin: 10px 10px 0 0;\n        border-radius: 2px 0 0 2px;\n        box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        outline: none;\n        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n        background-color: #fff;\n        font-family: Roboto;\n    }\n\n    #pac-container {\n        padding-bottom: 12px;\n        margin-right: 12px;\n    }\n\n    .pac-controls {\n        display: inline-block;\n        padding: 5px 11px;\n    }\n\n        .pac-controls label {\n            font-family: Roboto;\n            font-size: 13px;\n            font-weight: 300;\n        }\n\n    #pac-input {\n        background-color: #fff;\n        font-family: Roboto;\n        font-size: 15px;\n        font-weight: 300;\n        margin-left: 12px;\n        padding: 0 11px 0 13px;\n        text-overflow: ellipsis;\n        width: 400px;\n    }\n\n        #pac-input:focus {\n            border-color: #4d90fe;\n        }\n\n    #title {\n        color: #fff;\n        background-color: #4d90fe;\n        font-size: 25px;\n        font-weight: 500;\n        padding: 6px 12px;\n    }\n\n    #target {\n        width: 345px;\n    }\n\n    .slideBox {\n        position: fixed;\n        top: 0;\n        right: 0;\n        width: 0;\n        opacity: 0;\n        visibility: hidden;\n        height: 100%;\n        z-index: 9999;\n        background: rgba(0,0,0,.5);\n    }\n\n        .slideBox .slideContent {\n            position: fixed !important;\n            overflow: auto;\n            background: #fff;\n            right: 0;\n            top: 0 !important;\n            bottom: 0 !important;\n            margin: 0 !important;\n            height: 100%;\n            max-width: 640px;\n            width: 80% !important;\n        }\n\n        .slideBox.in {\n            visibility: visible;\n            opacity: 1;\n            width: 100%;\n            transition: all .3s ease;\n        }\n\n    .multiSelectJustified .multiselect-parent {\n        width: 100%;\n    }\n\n    .multiSelectJustified .btn {\n        width: 100%;\n        text-align: left;\n    }\n\n        .multiSelectJustified .btn .caret {\n            float: right;\n            margin-top: 8px;\n        }\n</style><p class=\"alert-success\" ng-show=\"isDone\" style=\"max-width: 324px; height: 25px; padding-top: 4px; border-radius: 6px; margin-left: 350px; padding-left: 12px;\"><span class=\"alert-danger\" style=\"font-size: 14px;\">{{orderIdNumber}}</span> Order deleted successfully</p><p class=\"alert-success\" ng-if=\"isOrderCreated\" style=\"max-width: 324px; height: 25px; padding-top: 4px; border-radius: 6px; margin-left: 350px; padding-left: 12px;\"><span class=\"alert-success\" style=\"font-size: 14px;\">OrderId: <strong>{{orderData.orderId}}</strong></span> Order created successfully.</p><div class=\"form-inline\" style=\"margin-bottom:10px;\" ng-if=\"contractList.length >1\"><div class=\"form-group pull-right\"><label for=\"filter\">Filter contract:</label><select name=\"selectFilter\" id=\"selectFilter\" class=\"form-control\" ng-options=\"option.entityName for option in contractList track by option.id\" style=\"margin-right: 5px;\" ng-model=\"selectFilter\" ng-change=\"getSelectedErId(selectFilter)\"><option value=\"\">Select Contract</option></select></div></div><div class=\"clearfix\" style=\"margin-bottom:10px;\"><div class=\"btn-group pull-right\" role=\"group\" aria-label=\"Download Buttons\" style=\"margin-top: -10px;\" ng-show=\"user.role==\'Insurer_Admin\' || user.entityType==\'Corporate\' || user.entityType==\'HR\'\"><div ng-if=\"isFlage.isDownload\"><a class=\"btn btn-primary btn-xs\" style=\"margin-top: 2px; margin-left: 14px; margin-right: 14px; background-color: #3ec13e;\" target=\"_blank\" href=\"{{templateUrl}}\"><i class=\"glyphicon glyphicon-cloud-download\"></i>Download Template</a><div class=\"fileUpload btn btn-default btn btn-primary btn-xs\" style=\"position: relative; background-color: #3782c4; max-width: 318px; margin-top: 0px; padding-top: 0px; padding-bottom: 0; width: 134px;\"><input type=\"file\" id=\"uploadTemplates\" ng-model=\"fileUpload\" onchange=\"angular.element(this).scope().setFilesUpload(this)\" style=\"background-color: black; border-color: black; visibility:hidden;\"> <label for=\"uploadTemplates\" style=\"font-weight:normal; color: white; position:absolute; top:0; right:0; bottom:0; left:0; cursor:pointer;\"><i class=\"glyphicon glyphicon-cloud-upload\"></i>Upload Excel File</label></div><div class=\"btn form-group clearfix\" ng-if=\"contract.id == 12719\"><div class=\"btn-group\" uib-dropdown=\"\" style=\"display: block;\"><button id=\"split-button\" uib-dropdown-toggle=\"\" class=\"btn btn-default\" ng-if=\"packageSelected.packageAliasName\" style=\"padding: 0px 10px;\">{{packageSelected.packageAliasName}}</button> <button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle=\"\" style=\"padding: 0px 10px;\"><span class=\"caret\"></span> Select Package</button><ul uib-dropdown-toggle=\"\" class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\" style=\"max-height: 150px;overflow-y: scroll; padding: 0px;min-width: auto;width: 180px;\"><li role=\"menuitem\" ng-repeat=\"package in packageList\" ng-click=\"setPackageSelected(package)\" style=\"cursor: pointer;\"><a>{{package.packageAliasName}}</a></li></ul></div></div><div class=\"btn form-group clearfix\" ng-if=\"contract.id == 9782\"><div class=\"btn-group\" uib-dropdown=\"\" style=\"display: block;\"><button id=\"split-button\" uib-dropdown-toggle=\"\" class=\"btn btn-default\" ng-if=\"selectedBrokerObj.value\" style=\"padding: 0px 10px;\">{{selectedBrokerObj.name}}</button> <button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle=\"\" style=\"padding: 0px 10px;\"><span class=\"caret\"></span> Select Source</button><ul uib-dropdown-toggle=\"\" class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\" style=\"max-height: 150px;overflow-y: scroll; padding: 0px;min-width: auto;width: 180px;\"><li role=\"menuitem\" ng-repeat=\"broker in brokers\" ng-click=\"brokerSelected(broker)\" style=\"cursor: pointer;\"><a>{{broker.name}}</a></li></ul></div></div></div></div><div class=\"btn-group pull-right\" role=\"group\" aria-label=\"Download Buttons\" ng-show=\"user.entityType!=\'Insurance_Broker\' && user.entityType!=\'Insurer\' && user.entityType!=\'Corporate\' && user.entityType!=\'HR\' && serverSearch.contractType==9717 && serverSearch.corporateId\"><div ng-if=\"isFlage.isDownload\"><a class=\"btn btn-primary btn-xs\" style=\"margin-top: 2px; margin-left: 14px; margin-right: 14px; background-color: #3ec13e;\" target=\"_blank\" href=\"{{templateUrlPreEmp}}\"><i class=\"glyphicon glyphicon-cloud-download\"></i>Download Template</a><div class=\"fileUpload btn btn-default btn btn-primary btn-xs\" style=\"position: relative; background-color: #3782c4; max-width: 318px; margin-top: 0px; padding-top: 0px; padding-bottom: 0; width: 134px;\"><input type=\"file\" id=\"uploadTemplatesPreEmp\" ng-model=\"fileUploadPreEmp\" onchange=\"angular.element(this).scope().setPreEmpFilesUpload(this)\" style=\"background-color: black; border-color: black; visibility:hidden;\"> <label for=\"uploadTemplatesPreEmp\" style=\"font-weight:normal; color: white; position:absolute; top:0; right:0; bottom:0; left:0; cursor:pointer;\"><i class=\"glyphicon glyphicon-cloud-upload\"></i>Upload Excel File</label></div></div></div></div><div><uib-accordion close-others=\"oneAtATime\" ng-if=\"defaultSet\"><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"status.isFirstOpen\"><uib-accordion-heading><a style=\"color: #168cc9;\">Search panel</a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isFirstOpen, \'glyphicon-chevron-right\': !status.isFirstOpen}\"></i></uib-accordion-heading><ng-form name=\"userProfileForm\" class=\"form-horizontal\"><div id=\"user-profile\" class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Date from</label><div class=\"col-sm-8\"><div class=\"input-group\"><input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"serverSearch.fromDate\" is-open=\"popup5.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open5()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group\" ng-if=\"isInsurer && isHrLogin\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Contract type</label><div class=\"col-sm-8\"><select name=\"\" id=\"contractId\" class=\"pull-right form-control input-xs\" ng-model=\"serverSearch.contractType\" ng-options=\"contract.id as contract.entityName for contract in contracts\" ng-change=\"getCorporatePackages(serverSearch.contractType)\"><option disabled=\"true\" value=\"\">Select contract</option></select></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Date to</label><div class=\"col-sm-8\"><div class=\"input-group\"><input id=\"datetimeEnd\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"serverSearch.toDate\" is-open=\"popup6.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open6()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group\" ng-if=\"isInsurer && isHrLogin\"><label for=\"last-name\" class=\"control-label col-sm-4 required-field\">Corporate</label><div class=\"col-sm-8\"><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-options=\"option.entityName for option in contractsData track by option.id\" ng-model=\"serverSearch.corporateId\"><option disabled=\"true\" value=\"\">Select Corporate</option></select></div></div></div><div class=\"col-md-4\"><div class=\"form-group\" ng-if=\"isInsurer && isHrLogin\"><label for=\"stateSearch\" class=\"control-label col-sm-4 required-field\">State</label><div class=\"col-sm-8\"><select name=\"stateSearch\" id=\"stateSearch\" class=\"form-control\" ng-options=\"state for state in rajasthanStateList\" ng-model=\"serverSearch.state\"><option disabled=\"true\" value=\"\">Select state</option></select></div></div><div class=\"form-group\"><label for=\"city\" class=\"control-label required-field col-sm-4\"></label><div class=\"col-sm-8\"><button ng-if=\"isInsurer\" ng-disabled=\"serverSearch.contractType === \'\'\" class=\"btn btn-primary\" ng-model=\"search\" ng-click=\"getXMLRequests(serverSearch.fromDate, serverSearch.toDate,serverSearch, serverSearch.state);\">Search</button> <button ng-if=\"!isInsurer\" ng-disabled=\"!serverSearch.fromDate || !serverSearch.toDate\" class=\"btn btn-primary\" ng-model=\"search\" ng-click=\"getXMLRequests(serverSearch.fromDate, serverSearch.toDate,serverSearch, serverSearch.state);\">Search</button> <button class=\"btn primary\" ng-click=\"clearSearch()\">Clear</button></div></div></div></div></ng-form></div></uib-accordion><b ng-if=\"isDownload\">Download communication history</b><div class=\"row\" ng-if=\"isDownload\"><div class=\"col-md-3\"><div class=\"input-group\"><input id=\"datetimeFrom\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"formDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-3\"><div class=\"input-group\"><input id=\"datetimeTo\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"toDate\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-3\" ng-show=\"finalInsurerList.length>0\"><select name=\"\" class=\"form-control\" ng-model=\"insurerId\" ng-options=\"insurer.eRID as insurer.corporateName for insurer in finalInsurerList track by insurer.eRID\" ng-change=\"downloadQueue(formDate,toDate,insurerId)\"><option value=\"\">Select insurer</option></select></div><div class=\"col-md-3\" ng-show=\"downloadUrl.length>0\"><button class=\"btn btn-info\"><a target=\"_blank\" href=\"{{downloadUrl}}\" style=\"color:white\">Communication history<i class=\"fa fa-cloud-download\"></i></a></button></div></div><hr></div><div ng-show=\"showList\"><angular-tab appointmentlist=\"pbqueue\" tabname=\"\'E-Sales Request\'\" tabtype=\"\'eSalesRequests\'\"></angular-tab></div><div class=\"active-appointments\" ng-show=\"showDetailView && !readOnlyView\"><div class=\"row\"><div class=\"col-md-12\"><div id=\"testsPerformed\" style=\"margin-top: -50px;\"><div class=\"form-create form-create-first card\"><div class=\"form-signin\"><strong>Customer details</strong> <button class=\"btn btn-danger btn-xs pull-right\" ng-click=\"showFirst(\'create\')\">Back</button> <a class=\"btn btn-info btn-xs pull-right\" ng-model=\"collapse\" ng-show=\"displayTestDetails\" ng-click=\"isCostomerDetails=!isCostomerDetails\" style=\"margin-right:10px;\"><i class=\"glyphicon glyphicon-question-sign\"></i>Help</a><div class=\"pull-right\" style=\"margin-right: 10px; font-size: 20px;\"><a ng-show=\"showDndBell\"><request-dnd-modal requestdata=\"requestDataForDND\" dndcustomer=\"false\" dnd=\"true\" bell=\"showDndBell\"><i class=\"fa fa-bell\" uib-tooltip=\"DND\"></i></request-dnd-modal></a> <a ng-show=\"!showDndBell\"><request-dnd-modal requestdata=\"requestDataForDND\" dndcustomer=\"false\" dnd=\"true\" bell=\"showDndBell\"><i class=\"fa fa-bell-slash\" uib-tooltip=\"DND\"></i></request-dnd-modal></a> <a ng-show=\"showDndCustomerBell\"><request-dnd-modal requestdata=\"requestDataForDND\" dndcustomer=\"true\" dnd=\"false\" bell=\"showDndCustomerBell\"><i class=\"fa fa-bell\" uib-tooltip=\"DND Customer\"></i></request-dnd-modal></a> <a ng-show=\"!showDndCustomerBell\"><request-dnd-modal requestdata=\"requestDataForDND\" dndcustomer=\"true\" dnd=\"false\" bell=\"showDndCustomerBell\"><i class=\"fa fa-bell-slash\" uib-tooltip=\"DND Customer\"></i></request-dnd-modal></a></div><hr><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Customer name</label> <input type=\"text\" id=\"employeeName\" class=\"form-control\" ng-model=\"showData.name\"></div><div class=\"col-md-4\"><label for=\"\">Customer unique id</label> <input type=\"text\" id=\"employeeId\" class=\"form-control\" ng-model=\"showData.employeeId\"></div><div class=\"col-md-4\"><label for=\"\">Annual premium</label> <input placeholder=\"Enter annual premium\" name=\"annualPremium\" type=\"number\" id=\"annualPremium\" class=\"form-control\" ng-model=\"annualPremium\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Email address</label> <input type=\"text\" id=\"emailid\" class=\"form-control\" ng-model=\"showData.emailId\"></div><div class=\"col-md-4\"><label for=\"\">Mobile number</label> <input type=\"text\" id=\"mobilenumber\" class=\"form-control\" ng-model=\"showData.mobileNumber\"></div><div class=\"col-md-4\"><label for=\"\">Customer address</label><p>{{showData.addressLine1}}, {{showData.city}}, {{showData.state}}</p></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Sum assured</label> <input placeholder=\"Enter sum assured\" type=\"text\" id=\"sumAssured\" class=\"form-control\" ng-model=\"sumassuredetail.sumAssured\"></div><div class=\"col-md-4\"><label for=\"\">Select gender</label><select class=\"form-control\" ng-model=\"genderList.gender\"><option value=\"NA\">Choose gender</option><option value=\"M\">Male</option><option value=\"F\">Female</option></select></div><div class=\"col-md-4\"><label for=\"\">Paid/Sponsored</label><select ng-model=\"sumassuredetail.paidSpons\" class=\"form-control\"><option value=\"sponsored\">Sponsored</option><option value=\"paid\">Paid</option></select></div></div><div class=\"row\"><div class=\"col-md-4\"><label for=\"\">Group/Individual</label><select ng-model=\"sumassuredetail.grpIndv\" class=\"form-control\"><option value=\"individual\">Individual</option><option value=\"group\">Group</option></select></div></div></div></div><div class=\"form-create card\" ng-show=\"genderList.gender !== \'NA\'\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-3\"><label for=\"\">Select insurer</label><select class=\"form-control\" name=\"\" id=\"\" ng-model=\"client.selectedInsurer\" ng-options=\"insurer as insurer.entityName for insurer in selectedInsurers\" ng-change=\"setSource(client.selectedInsurer)\"><option value=\"\">Select Insurer</option></select></div><div class=\"col-md-3\"><label for=\"\">Select appropriate package</label><div ng-class=\"{\'ngDrobdown\' : isSelectedpackage === true }\"><div ng-dropdown-multiselect=\"\" options=\"packages\" extra-settings=\"example2settings\" selected-model=\"selectedPackageForAdvance\" translation-texts=\"example5customTexts\" checkboxes=\"true\" style=\"margin-bottom:15px;\" class=\"multiSelectJustified\"></div></div></div><div class=\"col-md-3\" ng-show=\"selectedPackageForAdvance.length>0\"><label for=\"\">View packages</label> <button class=\"btn btn-info btn-block\" data-toggle=\"modal\" data-target=\"#selectedPacakgesList\">View Details</button></div><div class=\"col-md-2\"><label for=\"\">Select visit type</label><select class=\"form-control\" ng-model=\"client.visitType\" ng-change=\"visitTypeChange(client.visitType)\" required=\"\"><option value=\"\">Select visit type</option><option value=\"Appointment\">Centre Visit</option><option value=\"Home_Visit\">Home Visit</option></select></div></div><p ng-if=\"notMappedTest.length >0\" style=\"margin-bottom: 2px; margin-left: 4px;\">Un-mapped test :- <span ng-repeat=\"item in notMappedTest track by $index\" style=\"display: inline; padding: 0px 2px; font-size: small; color: red;\">{{item.testName}},</span></p></div></div><div class=\"form-create card\" ng-if=\"client.visitType===\'Home_Visit\'\" style=\"padding-bottom:10px;\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-12\"><div ng-show=\"client.visitType===\'Home_Visit\'\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Address line 1</label> <input placeholder=\"Enter address line 1..\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline1\" ng-required=\"client.visitType===\'Home_Visit\'\"></div><div class=\"col-md-6\"><label for=\"\">Address line 2</label> <input placeholder=\"Enter address line 2..\" type=\"text\" class=\"form-control\" ng-model=\"client.addressline2\" ng-required=\"client.visitType===\'Home_Visit\'\"></div></div></div></div></div></div></div><div class=\"form-create card\" ng-show=\"selectedPackageForAdvance.length >0\" style=\"padding-bottom:10px;\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"btn-group btn-group-justified\" style=\"margin-bottom:15px;\"><label class=\"btn btn-primary\" ng-model=\"radioModel\" uib-btn-radio=\"\'Left\'\" ng-click=\"DCSelection(\'advance\')\">Advance DC selection</label> <label class=\"btn btn-primary\" ng-model=\"radioModel\" uib-btn-radio=\"\'Middle\'\" ng-click=\"DCSelection(\'manula\')\">Manual DC selection</label> <label ng-if=\"isFlage.autoDcSelection\" class=\"btn btn-primary\" ng-model=\"radioModel\" uib-btn-radio=\"\'Middle\'\" ng-click=\"autoDCSelection(\'Auto\')\">Auto DC selection</label></div></div><div class=\"col-md-2\" ng-show=\"isPackageSelectionAdvance\"><select name=\"\" class=\"form-control\" ng-options=\"distance as distance.value for distance in distances\" ng-model=\"distance\" ng-change=\"changeDistance(distance)\"><option value=\"\">Select radius</option></select></div><div class=\"col-md-3\" ng-show=\"isPackageSelectionAdvance\"><input type=\"text\" class=\"form-control\" gm-places-autocomplete=\"\" ng-model=\"locationName.autocomplete\"></div><div class=\"col-md-3\"><input ng-model=\"dndCustomer\" type=\"checkbox\"> DND Customer</div></div><div class=\"row\" ng-if=\"isPackageSelectionManual || isPackageSelectionAdvance\" style=\"margin-top: 10px;\"><div class=\"col\"><div class=\"col-sm-4 dateBox\"><label for=\"\">First preference ***</label> <input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"manual.firstDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOption\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" style=\"width: 140px;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\" style=\"margin-left: 138px; margin-top: -83px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"col-sm-4 dateBox\"><label for=\"\">Second preference ***</label> <input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"manual.secondDate\" is-open=\"popup2.opened\" datepicker-options=\"dateOption\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" style=\"width: 140px;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\" style=\"margin-left: 138px; margin-top: -83px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"col-sm-2 timeBox\" style=\"margin-left: 210px; margin-top: -102px;\"><div uib-timepicker=\"\" ng-model=\"manual.firstTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div><div class=\"col-sm-2 timeBox\" style=\"margin-left: 210px; margin-top: -102px;\"><div uib-timepicker=\"\" ng-model=\"manual.secondTime\" max=\"maxFirstValue\" min=\"minFirstValue\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div><div class=\"col-sm-2\"><dc-notes id=\"selectedDcFromDavanceSearch.id\"><button style=\"margin-top: -128px;\" class=\"btn f\">Outsourcing Details</button></dc-notes></div></div></div><div class=\"row\" ng-if=\"isPackageSelectionManual\" style=\"margin-top: 10px; margin-bottom: 60PX;\"><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"current.newStateId\" ng-change=\"loadCitiesNew(current.newStateId)\"><option value=\"\">Select state</option></select></div><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"newCityId\" ng-change=\"loadLocationsNew(newCityId)\"><option value=\"\">Select city</option></select></div><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"newSubLocationId\" ng-change=\"loadDcForAllPackages(newSubLocationId)\"><option value=\"\">Select locality</option></select></div><div class=\"col-md-3\"><select name=\"preferreddc1\" id=\"firstDCIdPreEmp\" ng-model=\"client.preferredDC1\" class=\"form-control\" ng-options=\"dc as dc.entityName for dc in diagnosticCentres\" ng-change=\"selectedDcFromMap(client.preferredDC1)\"><option value=\"\">Select diagnostic centre</option></select></div></div><div class=\"row\" ng-if=\"isPackageSelectionManual\" style=\"margin-top: 10px; margin-bottom: 30PX;\"><div class=\"col-md-12\"><button ng-disabled=\"!manual.firstDate || !client.preferredDC1 || !client.visitType\" ng-click=\"bookAppointmentDate(manual.firstDate, manual.secondDate, manual.firstTime, manual.secondTime)\" class=\"btn btn-primary pull-right\">Add to cart</button></div></div></div></div><div class=\"row\" ng-if=\"markerArray.length >0 && isPackageSelectionAdvance\"><div class=\"col-md-12\"><ui-gmap-google-map center=\"map.center\" control=\"\" zoom=\"map.zoom\" bounds=\"map.bounds\" draggable=\"true\" options=\"map.options\"><ui-gmap-circle center=\"map.center\" stroke=\"map.stroke\" fill=\"map.fill\" radius=\"map.radius\" visible=\"map.visible\" geodesic=\"c.geodesic\" editable=\"c.editable\" draggable=\"map.draggable\" clickable=\"map.clickable\"><ui-gmap-marker models=\"randomMarkers1\" coords=\"map.center\" idkey=\"\"><i class=\"fa fa-user\"></i></ui-gmap-marker><ui-gmap-marker ng-repeat=\"marker in markerArray\" click=\"selectedDcFromMap(marker, $event)\" models=\"randomMarkers\" events=\"map.markersEvents\" coords=\"marker.coords\" idkey=\"marker.id\"><ui-gmap-window options=\"windowOpt\" closeclick=\"map.window.closeClick(marker)\" show=\"marker.visible\" templateurl=\"\'/app/modules/newappointment/windowContent.html\'\" templateparameter=\"windowParams\"></ui-gmap-window></ui-gmap-marker></ui-gmap-circle></ui-gmap-google-map></div></div><div class=\"row\" ng-if=\"markerArray.length ===0 && isMarkerArray && selectedPackageForAdvance.length !== 0\"><div class=\"col-md-12\"><div class=\"text-center\" style=\"margin-bottom: 30px; padding-top: 20px; background-color: #e0dede; padding-bottom: 18px;\">No Diagnostic Centre found.</div></div></div></div></div></div><div class=\"active-appointments\" ng-show=\"showDetailView && readOnlyView\"><div class=\"row\"><div class=\"col-md-8\"><div id=\"testsPerformed\"><div class=\"form-create form-create-first card\"><div class=\"form-signin\"><strong>Customer details</strong> <button class=\"btn btn-danger btn-sm pull-right\" ng-click=\"showFirst(\'create\')\">Back</button><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Customer name</label> <input type=\"text\" id=\"employeeName\" class=\"form-control\" ng-model=\"showData.name\"></div><div class=\"col-md-6\"><label for=\"\">Customer unique id</label> <input type=\"text\" id=\"employeeId\" class=\"form-control\" ng-model=\"showData.employeeId\"></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Email address</label> <input type=\"text\" id=\"emailid\" class=\"form-control\" ng-model=\"showData.emailId\"></div><div class=\"col-md-6\"><label for=\"\">Mobile number</label> <input type=\"text\" id=\"mobilenumber\" class=\"form-control\" ng-model=\"showData.mobileNumber\"></div></div></div></div><div class=\"form-create card\"><div class=\"form-signin\"><table class=\"table table-hover\" ng-show=\"showData.testDetails.length>0\"><thead><th>Test name</th><th>Appointment date & time</th></thead><tbody><tr ng-repeat=\"test in showData.testDetails\"><td>{{test.testName}}</td><td>{{compareDate(test.appointmentDate)}} | {{test.appointmentTime}}</td></tr></tbody></table><hr><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Select insurer</label><select class=\"form-control\" name=\"\" id=\"\" ng-model=\"client.selectedInsurer\" ng-options=\"insurer as insurer.entityName for insurer in selectedInsurers\" ng-change=\"setSource(client.selectedInsurer)\"><option value=\"\">Select an insurer</option></select></div><div class=\"col-md-6\"><label for=\"\">Select appropriate package</label><select name=\"\" id=\"packageId\" class=\"form-control\" ng-model=\"pkgSelected\" ng-options=\"package.peR_Id as package.packageName for package in packages\" ng-change=\"changePackage(pkgSelected)\"><option value=\"\">Select a Package</option></select></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Preferred date & time *</label><p class=\"input-group\"><input id=\"datetimeSecond\" type=\"text\" readonly=\"\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.secondPrefTime\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\" style=\"margin-top: -15px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-6\" style=\"margin-top: -12px;\"><div uib-timepicker=\"\" ng-model=\"userTime.secondAppointmentTime\" max=\"maxSecond\" min=\"minSecond\" ng-change=\"changedSecond()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><strong>Please choose the diagnostic centre</strong><hr style=\"margin:5px 0\"><div class=\"row\"><div class=\"col-md-3\"><label for=\"\">Select a state</label><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"newStateId\" ng-change=\"loadCities(newStateId)\"><option value=\"\">Select a state</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a city</label><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"newCityId\" ng-change=\"loadLocations(newCityId)\"><option value=\"\">Select a city</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a locality</label><select name=\"\" class=\"form-control\" ng-options=\"location as location.lookUpValue for location in locations\" ng-model=\"newLocationId\" ng-change=\"loadSubLocations(newLocationId)\"><option value=\"\">Select a locality</option></select></div><div class=\"col-md-3\"><label for=\"\">Select sub locality</label><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"newSubLocationId\" ng-change=\"loadDCs(newSubLocationId)\"><option value=\"\">Select sub locality</option></select></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"\">Select a diagnostic centre</label><select name=\"pkgDCId\" ng-change=\"selectDc(pkgDcId)\" class=\"form-control\" ng-model=\"pkgDcId\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in diagnosticCentres\">{{dc.entityName}}</option></select></div></div><div class=\"row\"><div class=\"col-md-3\"></div><div class=\"col-md-3\"></div><div class=\"col-md-3\"></div><div class=\"col-md-3\"><button class=\"btn btn-block btn-primary\" ng-click=\"addToCart(\'package\', pkgSelected)\">Update Cart</button></div></div></div></div><div class=\"form-create card\" ng-show=\"showAddTestBox\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"\">Select an individual test *</label><select ng-change=\"changePackage(testPeRId)\" class=\"form-control\" ng-model=\"testPeRId\"><option value=\"\">Select a test</option><option value=\"{{test.peR_Id}}\" ng-repeat=\"test in tests\">{{test.packageName}}</option></select></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Preferred date & time *</label><p class=\"input-group\"><input id=\"datetimeSecond\" type=\"text\" readonly=\"\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.TestPrefTime\" is-open=\"popup4.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open4()\" style=\"margin-top: -15px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-6\" style=\"margin-top: -12px;\"><div uib-timepicker=\"\" ng-model=\"userTime.testAppointmentTime\" max=\"maxSecond\" min=\"minSecond\" ng-change=\"changedSecond()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><strong>Please choose the diagnostic centre</strong><hr style=\"margin:5px 0\"><div class=\"row\"><div class=\"col-md-3\"><label for=\"\">Select a state</label><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"newStateId\" ng-change=\"loadCities(newStateId)\"><option value=\"\">Select a state</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a city</label><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"newCityId\" ng-change=\"loadLocations(newCityId)\"><option value=\"\">Select a city</option></select></div><div class=\"col-md-3\"><label for=\"\">Select a locality</label><select name=\"\" class=\"form-control\" ng-options=\"location as location.lookUpValue for location in locations\" ng-model=\"newLocationId\" ng-change=\"loadSubLocations(newLocationId)\"><option value=\"\">Select a locality</option></select></div><div class=\"col-md-3\"><label for=\"\">Select sub locality</label><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"newSubLocationId\" ng-change=\"loadDCs(newSubLocationId)\"><option value=\"\">Select sub locality</option></select></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"\">Select a diagnostic centre</label><select name=\"testDCId\" ng-change=\"selectDcIdFortest(testDcId)\" class=\"form-control\" ng-model=\"testDcId\"><option value=\"\">Select a diagnostic centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in diagnosticCentres\">{{dc.entityName}}</option></select></div></div><div class=\"row\"><div class=\"col-md-3\"></div><div class=\"col-md-3\"></div><div class=\"col-md-3\"></div><div class=\"col-md-3\"><button class=\"btn btn-block btn-primary\" ng-click=\"addToCart(\'test\', testPeRId)\">Add to cart</button></div></div></div></div></div><hr><div class=\"form-create card submit-buttons\"><div class=\"form-signin\"><div class=\"col-md-8\"></div><div class=\"col-md-4\"><button class=\"btn btn-block btn-primary\" ng-click=\"showAddTestBox = true\" ng-show=\"!showAddTestBox\">Add Test</button></div></div></div></div><div class=\"col-md-4\"><div class=\"form-create form-create-first card cart\"><div class=\"form-signin\"><h4>Your Cart</h4><hr><div class=\"cartEmpty\" ng-show=\"cartEmpty\"><div class=\"empty text-center\">Cart is empty</div></div><div id=\"cartItems\" ng-show=\"!cartEmpty\"><div ng-repeat=\"item in orderObj.orderItems\"><div class=\"row package-item\"><span class=\"col-md-8\">{{item.productName}}</span> <span class=\"col-md-4\">Rs.{{item.amount}}/-</span></div><div class=\"row benef-item\"><span class=\"col-md-8\">{{item.firstName}}</span> <span class=\"col-md-4\">{{item.cityName}}</span></div><div class=\"row\"><div class=\"col-md-8\"></div><div class=\"col-md-3\"><button class=\"btn btn-xs btn-block btn-danger delete\" value=\"\" id=\"{{item.productId}}\" ng-click=\"removeOrderItem(item, event)\">delete</button></div></div><hr></div></div><div class=\"row package-item\" ng-show=\"!cartEmpty\"><div class=\"col-md-8\">Grand total</div><div class=\"col-md-4\">Rs.{{totalPrice}}/-</div></div><hr></div></div><div class=\"form-create card\" ng-show=\"showPaid\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"paid\">Paid</label> <input type=\"radio\" id=\"paid\" name=\"optradio\" checked=\"checked\" value=\"\" ng-click=\"paid=true\"></div><div class=\"col-md-6\"><label for=\"unpaid\">Unpaid</label> <input type=\"radio\" id=\"unpaid\" name=\"optradio\" value=\"\" ng-click=\"paid=false\"></div></div><strong>Transaction details</strong><hr><div class=\"alert alert-danger\" ng-show=\"showPaid && paid\" role=\"alert\">Since this is a paid package, You need to fill the following <span class=\"strong\">Transaction details</span></div><div class=\"alert alert-danger\" ng-show=\"showPaid && !paid\" role=\"alert\">Unpaid orders will be collected in \"UnConfirmed Orders\" bucket. Once their availability is confirmed with DC, they will be approved and payment link will be sent to the user. These orders moves to active appointments, only after user makes the payment</div><div ng-show=\"showPaid && paid\"><label for=\"\">UTR number *</label> <input id=\"txnNumber\" class=\"form-control\" ng-model=\"txn.txnNumber\"></div></div></div><button class=\"btn btn-primary btn-block\" ng-click=\"checkDuplicacy()\" ng-show=\"!cartEmpty\">Create Appointment</button></div></div></div></div><div class=\"slideBox\" ng-class=\"isCostomerDetails ? \'in\': \'\'\"><div class=\"slideContent\"><div class=\"modal-header\"><a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"isCostomerDetails=!isCostomerDetails\"><span aria-hidden=\"true\">&times;</span></a><h4 class=\"modal-title\">Customer additional details</h4></div><div class=\"modal-body\"><h4>Few details for your reference</h4><table><tr><td style=\"width: 140px;\">Name:</td><td><b>{{displayTestDetails.name}}</b></td></tr><tr><td>Address:</td><td><b>{{displayTestDetails.addressLine1}}</b></td></tr><tr><td>City:</td><td><b>{{displayTestDetails.city}}</b></td></tr><tr><td>State:</td><td><b>{{displayTestDetails.state}}</b></td></tr><tr><td>Mobile no.:</td><td><b>{{displayTestDetails.mobileNumber}}</b></td></tr></table><h4 style=\"margin-top: 30px;\" ng-if=\"showData.testDetails.length >0\">Test details for your reference</h4><table class=\"table table-hover\" ng-show=\"showData.testDetails.length>0\"><thead><th>Test name</th><th ng-if=\"showData.erid !==177887\">Appointment date & time</th><th ng-if=\"showData.erid ===177887\">Appointment date</th><th ng-if=\"showData.erid ===177887\">Appointment time</th><th>Visit type</th></thead><tbody><tr ng-repeat=\"test in showData.testDetails\"><td>{{test.testName}}</td><td ng-if=\"showData.erid !==177887\">{{compareDate(test.appointmentDate)}} | {{formatTime(test.appointmentDate)}}</td><td ng-if=\"showData.erid ===177887\">{{getDateObj(test.appointmentDate) |date:\'dd-MMM-yyyy\'}}</td><td ng-if=\"showData.erid ===177887\">{{test.appointmentTime}}</td><td>{{test.visitType}}</td></tr></tbody></table><hr><h4 style=\"margin-top: 30px;\" ng-if=\"newAdditionalInfo.length >0\">Additional Information</h4><div class=\"row\"><div class=\"col-md-4\"><label for=\"additional\"><select class=\"form-control\" id=\"additional\" name=\"additional\" ng-model=\"field.fieldName\"><option disabled=\"\" value=\"\">Select</option><option ng-repeat=\"item in additionalFieldList\" value=\"{{item}}\">{{item}}</option></select></label></div><div class=\"col-md-4\"><label for=\"fieldValue\"><input class=\"form-control\" ng-disabled=\"!field.fieldName\" name=\"fieldValue\" id=\"fieldValue\" ng-model=\"field.fieldValue\" placeholder=\"Enter {{field.fieldName}}\" style=\"border-radius: 0;\"></label></div><div class=\"col-md-2\"><span><button class=\"btn btn-primary\" ng-disabled=\"!field.fieldValue\" ng-click=\"addToAdditionDetails()\" style=\"margin:0;\">Add</button></span></div></div><p ng-repeat=\"(key, value) in additionalInfo track by $index\" style=\"margin-top: 10px;\"><span style=\"font-size: larger; font-weight: 500;\">{{key}}</span> : {{value}}</p></div></div></div><div class=\"slideBox\" ng-class=\"isCart ? \'in\': \'\'\" ng-if=\"manual.firstDate\"><div class=\"slideContent\"><div class=\"modal-header\"><a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"closeCart()\"><span aria-hidden=\"true\">&times;</span></a><h4 class=\"modal-title\">You are booking packages for <span style=\"color:#4d90fe;\">{{displayTestDetails.name}}</span><br><span style=\"font-size:14px;\">at <b><span ng-if=\"selectedDcFromDavanceSearch.name\">{{selectedDcFromDavanceSearch.name}}</span> <span ng-if=\"selectedDcName\">{{selectedDcName}}</span> <span ng-if=\"selectedTime\">{{selectedTime | date:\'dd-MMM-yyyy @ h:mma\'}}</span></b> <span ng-if=\"selectedDcFromDavanceSearch.entityAddress\">, {{selectedDcFromDavanceSearch.entityAddress}}</span></span></h4></div><div class=\"modal-body\"><div class=\"cartEmpty\" ng-show=\"cartEmpty\"><div class=\"empty text-center\">Cart is empty</div></div><div id=\"cartItems\" ng-show=\"!cartEmpty\"><div>Ap</div><div ng-repeat=\"item in orderObj.orderItems\"><div class=\"row package-item\"><div class=\"col-md-7\">{{item.productName}}</div><div class=\"col-md-3 text-right\">Rs.{{item.amount}}/-</div><div class=\"col-md-2 text-right\"><button class=\"btn btn-xs btn-block btn-danger delete\" value=\"\" id=\"{{item.productId}}\" ng-click=\"removeOrderItem(item, event)\">Remove</button></div></div><hr></div></div><div class=\"row package-item\" ng-if=\"!cartEmpty && orderObj.orderItems.length >0\" style=\"margin-bottom: 10px;\"><div class=\"col-md-7\">Grand total</div><div class=\"col-md-3 text-right\">Rs.{{totalPrice}}/-</div><div class=\"col-md-2\"></div></div><div class=\"form-create card\" ng-show=\"showPaid\"><div class=\"form-signin\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"paid\">Paid</label> <input type=\"radio\" id=\"paid\" name=\"optradio\" checked=\"checked\" value=\"\" ng-click=\"paid=true\"></div><div class=\"col-md-6\"><label for=\"unpaid\">Unpaid</label> <input type=\"radio\" id=\"unpaid\" name=\"optradio\" value=\"\" ng-click=\"paid=false\"></div></div><strong>Transaction details</strong><hr><div class=\"alert alert-danger\" ng-show=\"showPaid && paid\" role=\"alert\">Since this is a paid package, You need to fill the following <span class=\"strong\">Transaction details</span></div><div class=\"alert alert-danger\" ng-show=\"showPaid && !paid\" role=\"alert\">Unpaid orders will be collected in \"UnConfirmed Orders\" bucket. Once their availability is confirmed with DC, they will be approved and payment link will be sent to the user. These orders moves to active appointments, only after user makes the payment</div><div ng-show=\"showPaid && paid\"><label for=\"\">UTR number *</label> <input id=\"txnNumberPreEmp\" class=\"form-control\" ng-model=\"txn.txnNumber\"></div></div></div><button class=\"btn btn-primary btn-block\" ng-click=\"checkDuplicacy()\" ng-show=\"!cartEmpty && orderObj.orderItems.length >0\">Create Appointment</button></div></div></div><div class=\"modal fade\" id=\"selectedPacakgesList\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\" style=\"padding:0 15px;\"><a href=\"\"><span class=\"pull-right\" data-dismiss=\"modal\"><b>X</b></span></a><h4>Selected packages</h4></div><div class=\"modal-body\" id=\"chooseDCBody\"><ul><li ng-repeat=\"item in selectedPackageForAdvance\">{{item.packageName}}<br></li></ul></div></div></div></div><div class=\"modal fade\" id=\"ViewCorresponddenceModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Communication history</h4></div><div class=\"modal-body\"><div ng-repeat=\"corres in correspondencData track by $index\" ng-if=\"correspondencData.length>0\"><h4>Communication {{$index + 1}}</h4><ul><li>Customer status : <b>{{corres.callStatusValue}}</b></li><li>Comment: <b>{{corres.comment}}</b></li><li>Created on: <b>{{compareDate(corres.createdOn)}}</b></li></ul><hr></div><div ng-if=\"!correspondencData.length>0\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><h4 style=\"color:red\">{{correspondencError}}</h4></div><div class=\"col-md-2\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"deleteRequest\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button ng-click=\"cancelPopup()\" type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Delete Confirmation</h4></div><div class=\"modal-body\"><p class=\"text-center\">Are you sure you want to delete the order?</p><button type=\"button\" style=\"margin-left: 222px;\" class=\"btn btn-default\" ng-click=\"cancelPopup()\" data-dismiss=\"modal\">No</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"deleteOrderEueue(true, orderDetails)\">Yes</button></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"cancelPopup()\" data-dismiss=\"modal\">Close</button></div></div></div></div><div class=\"modal fade\" id=\"AddCorresponddenceModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Add correspondence</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label for=\"calltype\">Select a receiver</label><select class=\"form-control\" name=\"calltype\" id=\"calltype\" ng-model=\"corres.calltype\"><option disabled=\"true\" value=\"\">select receiver</option><option value=\"{{calltype.key}}\" ng-repeat=\"calltype in calltypes\">{{calltype.value}}</option></select><br><label for=\"callstatus\">Select appropriate call status</label><select class=\"form-control\" name=\"callstatus\" id=\"callstatus\" ng-change=\"callStatusTemplate(corres.callstatus)\" ng-model=\"corres.callstatus\"><option disabled=\"true\" value=\"\">select call status</option><option value=\"{{callstatus.key}}\" ng-repeat=\"callstatus in callstatuses\">{{callstatus.value}}</option></select><br><label for=\"work\">Select type of status</label><select class=\"form-control\" name=\"work\" id=\"work\" ng-model=\"corres.workStatus\"><option value=\"workable\">Workable</option><option value=\"nonWorkable\">Non Workable</option></select><br><div ng-if=\"showCalender\"><div class=\"form-group col-md-6\"><label for=\"first-name\" class=\"control-label required-field\">Select Date and time</label><div class=\"input-group\" style=\"margin-top:11px;\"><input id=\"\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"callDateTime.prefDate\" is-open=\"popup6.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" min-date=\"mindate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open6()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group col-md-6\"><div uib-timepicker=\"\" ng-model=\"callDateTime.prefTime\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\" ng-change=\"getDateTime(callDateTime.prefDate, callDateTime.prefTime)\"></div></div></div><br><div><label for=\"\">UIC number</label> <input type=\"text\" ng-model=\"uicDetail.uicNumber\" class=\"form-control\" placeholder=\"Enter UIC number\"></div><br><div ng-show=\"getCallStatus == \'79\' || getCallStatus == \'82\'\"><label for=\"sms\">Send template as<span style=\"color:red;\" ng-show=\"putInsurer.length>0\"><strong>({{putInsurer}})</strong></span></label> <textarea name=\"\" id=\"sms\" cols=\"30\" rows=\"3\" class=\"form-control\" ng-model=\"mailTemplate\" required=\"\"></textarea></div><div ng-show=\"getCallStatus == \'124\'\"><label for=\"sms\">Send template as</label> <textarea name=\"\" id=\"sms\" cols=\"30\" rows=\"7\" class=\"form-control\" ng-model=\"apolloMailTemplate\" readonly=\"true\"></textarea></div><label for=\"remarks\">Add correspondence notes *</label> <textarea name=\"\" id=\"correspondenceremarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"corres.corrremarks\" required=\"\"></textarea></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" id=\"btnAddCorrespondence\" ng-click=\"addCorrespond()\">Add correspondence</button> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div>");
$templateCache.put("app/modules/reimbursement/reimbursement.html","<div><div class=\"claims\" block-ui=\"ReimbursementClaims\"><angular-tab datalist=\"preauthClaims\" tabname=\"\'Reimbursement Claims\'\" callback-second-fn=\"callbackSecond(arg, flag, page)\" callback-fn=\"ctrlFn(arg)\"></angular-tab></div></div>");
$templateCache.put("app/modules/rescheduleAppointment/rescheduleAppointment.html","<section class=\"reschedule-appointment\" block-ui=\"scheduleAppointmentForm\"><a href=\"#\"><img src=\"/app/resources/images/MB-logo.png\" alt=\"MediBuddy\"></a><div class=\"container\" ng-if=\"fetchDecryptedData && appointmentData && !isSubmitCalled\"><div class=\"row\"><div class=\"col-sm-6 col-xs-6 app-reschedule-text\"><h1 style=\"color: #A6A6A6;font-size: 20px;margin-bottom: 25px;margin-top: 0;\">Tele Medicals: #{{appointmentData.equote}}<br><small>(Contact: {{appointmentData.mobileNo}} | {{appointmentData.email}})</small></h1><p>Hi, {{appointmentData.name}},</p><div ng-if=\"allow\"><h1 style=\"color: #4065F0;margin: 10px auto;font-size: 20px;\">Our doctor is waiting to call you</h1><p>Share your convenient date/time along with your preferred language for Tele Medicals appointment with our doctor</p><div class=\"row\"><div class=\"col-xs-7\"><div class=\"form-group\" style=\"margin-top: 20px;position: relative;margin-bottom: 0;\"><label for=\"\">Choose date and time</label> <input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" date-disabled=\"disabled(date, mode)\" ng-change=\"dateChange()\" ng-model=\"preferredDateTime.prefDate\" is-open=\"datePicker.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\" style=\"position: absolute;top: 23px;right: 37px;\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"reschedule()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-xs-5\"><div class=\"form-group\" style=\"margin-bottom: 0;margin-top: 10px;\"><input readonly-input=\"true\" uib-timepicker=\"\" ng-model=\"preferredDateTime.prefTime\" hour-step=\"hstep\" max=\"maxFirst\" min=\"minFirst\" minute-step=\"mstep\" show-meridian=\"false\"></div></div></div><div class=\"form-group clearfix\" style=\"margin-bottom: 20px;\"><label>Choose preferred language</label><div class=\"btn-group\" uib-dropdown=\"\" style=\"display: block;\"><button id=\"split-button\" uib-dropdown-toggle=\"\" class=\"btn btn-default\" style=\"min-width: 180px;\" ng-if=\"!prefLang\">Choose</button> <button id=\"split-button\" uib-dropdown-toggle=\"\" class=\"btn btn-default\" style=\"min-width: 100px;\" ng-if=\"prefLang\">{{prefLang}}</button> <button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span></button><ul uib-dropdown-toggle=\"\" class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\" style=\"max-height: 150px;overflow-y: scroll;\"><li role=\"menuitem\" ng-repeat=\"lang in languages\" ng-click=\"langSelected(lang)\" style=\"cursor: pointer;\"><a>{{lang}}</a></li></ul></div></div><button class=\"btn btn-primary\" ng-click=\"submitData()\">Submit</button></div><div ng-if=\"!allow\" class=\"text-center\" style=\"font-weight: bold\">The link is already used once. You are not allowed to reschedule it again.</div></div><div class=\"col-sm-6 col-xs-6 app-reschedule-img\"><img src=\"/app/resources/images/appointment-reschedule.png\" alt=\"appointment reschedule\" style=\"max-width: 100%;\"></div></div></div><div class=\"errMsg text-center\" style=\"padding-top:150px;\" ng-if=\"fetchDecryptedData && ((!appointmentData && !isSubmitCalled) || (!appointmentBooked && isSubmitCalled))\"><h2 style=\"color:red;\">Something went wrong!</h2><p>Please click the url from the mail/sms or call us on <strong>080-67617571</strong> for assistant!</p></div><div class=\"successMsg text-center\" style=\"padding-top:150px;\" ng-if=\"appointmentBooked && isSubmitCalled\"><h2 style=\"color:green;\">The appointment details has been successfully updated.</h2><p style=\"font-size: 15px\">Preferred Time: <b>{{prefferedTime}}</b></p><p style=\"font-size: 15px\">Preferred Language: <b>{{prefLang}}</b></p></div></section>");
$templateCache.put("app/modules/resetPassword/resetPassword.html","<div class=\"row text-center\" style=\"padding-right: 220px;\"><div class=\"col-md-12\"><img src=\"/app/resources/images/logo-mediBuddy.png\" style=\"max-width: 300px; margin-bottom: 50px; max-width: 300px; margin-bottom: 50px;\" alt=\"\" class=\"logo\"></div></div><div class=\"row\"><p class=\"danger\" ng-if=\"isError\" style=\"margin-left: 186px;color: red;\">Something went wrong, please try again or click on<strong>Reset Password</strong>link.</p><div class=\"col-md-12\"><form name=\"changePasswordForm\" novalidate=\"\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"id_pass\">New password <span style=\"color: red;\">*</span></label><div class=\"col-sm-4\"><input type=\"password\" name=\"password\" class=\"form-control\" ng-minlength=\"3\" id=\"id_pass\" placeholder=\"Password\" ng-model=\"user.password\" required=\"\"></div></div><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"id_pass_conf\">Confirm password <span style=\"color: red;\">*</span></label><div class=\"col-sm-4\"><input type=\"password\" name=\"confirmPassword\" class=\"form-control\" id=\"id_pass_conf\" placeholder=\"Confirm Password\" ng-minlength=\"3\" ng-model=\"confirmPassword\" required=\"\" med-compare-text=\"user.password\"><p style=\"color: red;\" class=\"help-block\" ng-show=\"changePasswordForm.confirmPassword.$error.medCompareText && (user.confirmPassword !== \'\') && (user.password !== \'\') && changePasswordForm.confirmPassword.$invalid && !changePasswordForm.confirmPassword.$pristine\">Passwords do not match!</p></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-10\"><button ng-hide=\"passwordChanged\" type=\"submit\" ng-disabled=\"changePasswordForm.$invalid\" ng-click=\"resetPassword()\" class=\"btn btn-sm btn-primary\">Reset password</button></div></div></form></div></div>");
$templateCache.put("app/modules/rooms/rooms.html","<div><style>\n    .errormessage {\n      border: 1px solid #f00;\n    }\n\n    .note {\n      padding: 10px;\n      margin: 10px;\n      background: yellow;\n      border-radius: 6px;\n      color: #000;\n      margin-top: -15px;\n    }\n\n  </style><div class=\"rooms-list new clearfix\" id=\"rooms\" ng-hide=\"addRoom || editRoom\"><div class=\"row\" style=\"margin-top: -10px;margin-bottom: -15px;\"><div class=\"col-md-1\" style=\"margin-right: -35px\"><i class=\"fa fa-bed fa-2x\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></div><div class=\"col-md-3\"><h3 class=\"m-t-0\">Rooms</h3></div><div class=\"col-md-1 mainAction pull-right\"><div class=\"col\"><button class=\"btn btn-xs btn-default\" ng-click=\"roomsMethods.openHospRoomModal()\" uib-tooltip=\"Add New Room\" tooltip-placement=\"left\" style=\"border: hidden\"><i class=\"fa fa-plus-square fa-2x\" aria-hidden=\"true\" style=\"color:#4182c4;\"></i></button></div></div></div><hr><div class=\"row\"><div class=\"columns\" ng-repeat=\"room in rooms\"><div ng-class=\"room.isDelete ? \'deleted bx col-sm-3\':\'bx col-sm-3\'\" ng-click=\"room.isDelete ? \'\' : roomsMethods.editHospRoomModal(room)\"><a href=\"\"><span ng-if=\"room.isDelete\" class=\"alert\">Pending deletion <span>as per your request</span></span><h4 style=\"margin-top:0\">{{room.hospitalRoomType}} <span class=\"price\">Rs. <span>{{room.roomChargesPerDay}}</span> per day</span></h4><ng-gallery class=\"block\" images=\"room.roomImages\" thumbs-num=\"11\" is-gallery=\"true\" gallery-count=\"1\"></ng-gallery><div class=\"row roomDisc\"><span class=\"col-xs-4 p-r-0\"><span>{{room.noOfTotalRooms}}</span> rooms</span> <span class=\"col-xs-4 p-l-0 p-r-0\"><span>{{room.noOfBedsPerRoom}}</span> beds per room</span> <span class=\"col-xs-4 p-l-0\"><span>{{room.roomFacilities.length}}</span> Amenities</span></div></a></div></div></div><div class=\"note\"><strong>Note 1:-</strong> <span class=\"smTxt\" style=\"display:inline\">Enter detailed information about each room type available at your premises, along with photos. Medi Assist members see this information during a network hospital; and choose and book their preferred room for inpatient care while opting for an eCashless hospitalisation.</span><br><strong>Note 2:-</strong> <span class=\"smTxt\" style=\"display:inline\">For best experience please upload images of 650px width and 350px height.</span></div></div><div id=\"addEditHospitalRooms\" ng-show=\"addRoom || editRoom\"><h3 class=\"m-t-0\" ng-if=\"addRoom\">Add New Room</h3><h3 class=\"m-t-0\" ng-if=\"editRoom\">Edit {{roomDetails.roomType}} Room</h3><form name=\"frmRooms\"><h4>Room Details</h4><div class=\"row\"><div class=\"col-sm-6 col-md-4 p-r-0\"><div class=\"form-group\"><label for=\"roomType\">Room type/name</label> <input type=\"text\" name=\"roomType\" id=\"roomType\" class=\"form-control\" ng-model=\"roomDetails.roomType\" placeholder=\"Enter room name or type\" required=\"\"></div></div><div class=\"col-sm-6 col-md-2 p-r-0\"><div class=\"form-group\"><label for=\"totalRooms\">No. of rooms</label> <input type=\"number\" min=\"0\" max=\"1000\" name=\"totalRooms\" ng-class=\"frmRooms.totalRooms.$error.max === true ?\'errormessage\' :\'\'\" id=\"totalRooms\" class=\"form-control\" ng-model=\"roomDetails.noOfTotalRooms\" required=\"\"> <span ng-if=\"frmRooms.totalRooms.$error.max\" style=\"color: #f00\">No. of rooms not seems to be valid.</span></div></div><div class=\"col-sm-6 col-md-2 p-r-0\"><div class=\"form-group\"><label for=\"totalBeds\">No. of beds per room</label> <input type=\"number\" min=\"0\" max=\"20\" ng-class=\"frmRooms.totalBeds.$error.max === true ?\'errormessage\' :\'\'\" name=\"totalBeds\" id=\"totalBeds\" class=\"form-control\" ng-model=\"roomDetails.noOfBedsPerRoom\" required=\"\"> <span ng-if=\"frmRooms.totalBeds.$error.max\" style=\"color: #f00\">No. of beds per room not seems to be valid.</span></div></div><div class=\"col-sm-6 col-md-4 p-r-0\"><div class=\"form-group\"><label for=\"roomPrice\">Room rent & nursing charges/Day</label><div class=\"input-group\"><input type=\"number\" min=\"0\" max=\"30000\" ng-class=\"frmRooms.roomPrice.$error.max === true ?\'errormessage\' :\'\'\" name=\"roomPrice\" id=\"roomPrice\" class=\"form-control\" ng-model=\"roomDetails.roomChargesPerDay\" required=\"\"> <span ng-if=\"frmRooms.roomPrice.$error.max\" style=\"color: #f00\">Room rent not seems to be valid.</span></div></div></div></div><h4>Room Photos <span class=\"smTxt\">(for best experience please upload images of 650px width and 350px height)</span><ul class=\"tagsList\" style=\"font-size: small;\"><li class=\"closeBtn add\" data-toggle=\"modal\" data-target=\"#hospitalImages\">Add room Images <a href=\"\"><i class=\"fa fa-plus\"></i></a></li></ul></h4><ng-gallery images=\"roomDetails.roomImages\" thumbs-num=\"11\" ng-if=\"roomDetails.roomImages\"></ng-gallery><h4>Room amenities</h4><div class=\"row\"><div class=\"checkbox custom col-md-4\" ng-repeat=\"fac in addListOfFacility\"><label><input type=\"checkbox\" ng-model=\"fac.isFacilityAvailable\" data-id=\"{{fac.facilityID}}\"> <i ng-class=\"fac.isFacilityAvailable ? \'fa fa-check-square-o\' : \'fa fa-square-o\'\"></i> {{fac.facilityName}}</label></div></div><hr><div class=\"clearfix\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"roomsMethods.closeEditWindow();roomsMethods.loadRooms()\">Close</button> <button type=\"button\" class=\"btn btn-danger\" ng-if=\"editRoom\" data-target=\"#deleteRoom\" data-toggle=\"modal\">Delete Room</button> <button type=\"button\" class=\"btn btn-success pull-right\" ng-click=\"addRoom ? roomsMethods.addNewRoom() : roomsMethods.updateRoom()\" ng-disabled=\"frmRooms.$invalid\">Save Room</button></div></form></div><div class=\"modal fade\" id=\"hospitalImages\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"imagesMethods.clearFileModels()\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Add Room Images</h4></div><div class=\"modal-body\"><div id=\"addHospImages\" role=\"tabpanel\" class=\"tab-pane\"><div style=\"margin-top:20px\" ng-hide=\"!newlyUploadedImages || newlyUploadedImages.length <= 0\"><div class=\"form-group\"><div ng-repeat=\"hospImg in newlyUploadedImages\" style=\"margin-top:2%\" class=\"row\"><div ng-class=\"hospImg.isDelete ? \'gray image-custom col-md-4\' :\'col-md-4\'\" data-content=\"Set to Delete\"><img ng-src=\"{{hospImg.downloadLink}}\" class=\"imgProperties\"></div><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" ng-model=\"hospImg.imageDescription\"></div><div class=\"col-md-2\"><input type=\"button\" tabindex=\"-1\" class=\"btn btn-xs btn-danger\" ng-click=\"hospImg.isDelete = true\" ng-hide=\"hospImg.isDelete\" value=\"Remove\"> <input type=\"button\" tabindex=\"-1\" class=\"btn btn-xs btn-default\" ng-click=\"hospImg.isDelete = false\" ng-hide=\"!hospImg.isDelete\" value=\"Cancel Delete\"></div></div></div></div><div style=\"margin-top:20px\" ng-show=\"!newlyUploadedImages || newlyUploadedImages.length <= 0\"><fieldset class=\"form-group\" data-ng-repeat=\"item in file\"><div class=\"col-sm-7\"><input type=\"file\" accept=\"image/*\" name=\"preauth\" file-model=\"item.model\"></div><div class=\"col-sm-2\" ng-if=\"!$first\"><button class=\"removeLargeDocument\" ng-click=\"fileUploadMethods.removeFileToUpload($index)\">-</button></div></fieldset><div class=\"col-sm-offset-1\" style=\"margin-left: 3%\"><button class=\"btn btn-xs btn-primary\" ng-click=\"fileUploadMethods.addFileToUpload()\"><i class=\"fa fa-plus text\"></i> <span class=\"text\">Add More Images</span></button></div></div><div class=\"row\"><div class=\"col-md-6\"></div><div class=\"col-md-6\"><button type=\"button\" id=\"submit\" name=\"submit\" class=\"btn btn-success pull-right\" ng-show=\"!newlyUploadedImages || newlyUploadedImages.length <= 0\" ng-click=\"imagesMethods.uploadNewHospImages()\">Upload Images</button> <button type=\"button\" id=\"submit\" name=\"submit\" class=\"btn btn-success pull-right\" ng-hide=\"!newlyUploadedImages || newlyUploadedImages.length <= 0\" data-dismiss=\"modal\" ng-click=\"editRoom ? imagesMethods.saveNewHospImages() : imagesMethods.setImages()\">Done</button> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"imagesMethods.clearFileModels()\">Close</button></div></div></div></div></div></div></div><div class=\"modal fade\" id=\"deleteRoom\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"imagesMethods.clearFileModels()\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Are you sure you want to remove the <strong>{{roomDetails.roomType}}</strong> room ?</h4></div><div class=\"modal-body\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">No</button> <button type=\"button\" class=\"btn btn-danger pull-right\" data-dismiss=\"modal\" ng-click=\"roomsMethods.deleteRoom()\">Yes</button></div></div></div></div></div>");
$templateCache.put("app/modules/sent/sent.html","<h1>Sent</h1>");
$templateCache.put("app/modules/shared/faqs.html","<style>\n	.clickable{\n		cursor: pointer;\n	}\n	.points{\n		padding: 25px;\n		line-height: 30px;\n	}\n	.nav.nav-tabs>li>a {\n		padding: 5px;\n	}\n</style><h2>Do\'s and Don\'ts</h2><uib-tabset active=\"activeForm\"><uib-tab index=\"0\" heading=\"Do\'s\"><div class=\"panel panel-default points\"><ol><li>In emergency cases, cashless request should be forwarded to respective TPA within 24 hours after hospitalization.</li><li>In planned cases, cashless request should be forwarded to respective TPA, at least 48 hours prior to hospitalization in the prescribed format. Obtain approval, 24 hours prior to admission.</li><li>Claim documents should reach TPA within 7 working days from the date of the discharge.</li><li>Always collect photocopy of ID card along with photo ID proof. Check the member identification before extended cashless treatment.</li><li>Collect duly fill and signed claim from the insured and submit along with claim from.</li><li>Send all original documents to TPA for processing.</li><li>Specify the discount details in the final bill to avoid excess deductions at the time claim process.</li><li>Along with claim documents, original pre-authorization request, cashless approval copy should be enclosed</li><li>Retain photocopies of claim documents, which ever has been sent to TPA.</li><li>Discharge summary should have present complaints, diagnosis, past history, investigation done, Treatment during hospitalization, OT notes, discharge advice, indications for.</li><li>Pre-authorization from is to be signed by the treating doctor / consultant only.</li><li>Ensure that, pre-authorization is obtained by the hospital within 24 hours from admission.</li><li>Inform insured on receipt of approval / query / rejection from respective TPA.</li><li>In case of any query, revert within 2 hours and contact respective TPA</li><li>Inform concerned TPA, in case of any enhancement required at least 24 hours prior to discharge.</li><li>Extend cashless facility for approved ailment as specified In the cashless approval.</li><li>Collect the expenses related to non-payable items / over and above approval amount / ailment expenses which ever not payable under policy coverage from the insured directly prior to the discharge.</li><li>For early settlement, please submit NEFT declarations to Medi Assist</li></ol></div></uib-tab><uib-tab index=\"1\" heading=\"Don\'ts\"><div class=\"panel panel-default points\"><ol><li>Don’t insist upon admission for investigation or evaluations or health check-ups.</li><li>Don’t give any original bills / documents to the insured for cashless admissions.</li><li>Don’t forget to take insured signature on pre-auth request, cashless approval, final bill and discharge summary.</li><li>Cashless services can be denied, in case of insufficient information / vague symptoms / where medical team of TPA is not sure of eligibility under policy coverage, don’t insist for cashless approvals in such scenarios.</li><li>Don’t send photocopies of the document for claim processing.</li><li>Don’t send the bills without proper prescriptions and investigation reports.</li><li>Don’t hide any relevant information related to the past history duration and treatment line of the insured.</li><li>Don’t extend cashless for unapproved ailments / non-payable items.</li><li>Don’t demand any advance deposit from the insured.</li><li>Don’t suggest instant admissions for planned cases.</li><li>Don’t insist for the authorization letter for emergency cases at the time of admission.</li></ol></div></uib-tab></uib-tabset>");
$templateCache.put("app/modules/shared/terms.html","<div class=\"terms\"><h4>Please go through the terms and conditions and you can continue to plus portal once you agree.</h4><h5>Conditions of Use</h5><p>Welcome to our online store! Mediassist India TPA Pvt ltd. and its associates provide their services to you subject to the following conditions. If you visit or shop within this website, you accept these conditions. Please read them carefully.</p><h5>PRIVACY</h5><div class=\"btn btn-primary btn-block\" ng-click=\"agreeTerms()\"><strong>I Agree to the terms and conditions</strong></div></div>");
$templateCache.put("app/modules/signin/masterLogin.html","<div class=\"loginBox\" ng-show=\"!signInshow\"><h1 class=\"text-center m-t-0\"><div style=\"width:80px; height:80px; background:#fff; margin:0 auto; border-radius:50%; padding:12px 10px 10px 10px;\"><img src=\"app/resources/images/medibuddy-plus-small-logo.png\" alt=\"MediBuddy+\" style=\"width:100%;\"></div></h1><p class=\"text-center logTxt\" style=\"color:#fff;\">MediBuddy+ a healthy relationship between you and your patient!</p><h3 style=\"color:#fff\">Sign in</h3><div class=\"alert alert-danger\" role=\"alert\" id=\"loginMessage\" ng-show=\"isErorMessageLogin\">{{errorMessage}}</div><div ng-show=\"flagStatus.isUserCheck\"><label style=\"color: black;margin-bottom: 20px;margin-top: 15px;\" id=\"ErrorMsg\">This functionality has been disabled for medibuddy user. Please <a href=\"https://one.mediassistindia.com/adfs/ls/idpinitiatedsignon?loginToRp=https://plus.medibuddy.in\">Click here</a>to login through your corporate portal to access MediBuddy.</label></div><form role=\"form\" class=\"form\"><div class=\"form-group\"><i class=\"icon user\"></i> <input type=\"text\" class=\"form-control master-user-name\" ng-model=\"user.masterUsername\" placeholder=\"Master Username or Email\"></div><div class=\"form-group\" ng-show=\"!flagStatus.isUserCheck\"><i class=\"icon pass\"></i> <input type=\"password\" class=\"form-control password\" id=\"exampleMasterPassword1\" ng-model=\"user.masterPassword\" placeholder=\"Master Password\"></div><div class=\"form-group\"><i class=\"icon user\"></i> <input type=\"text\" class=\"form-control user-name\" ng-model=\"user.username\" placeholder=\"Username or Email\"></div><div class=\"form-group\" ng-show=\"!flagStatus.isUserCheck\"><i class=\"icon pass\"></i> <input type=\"password\" class=\"form-control password\" id=\"exampleInputPassword1\" ng-model=\"user.password\" placeholder=\"Password\"> <a data-toggle=\"modal\" data-target=\"#forgotPwd\" ng-click=\"resetData()\">Forgot password?</a></div><div class=\"row\" ng-show=\"!flagStatus.isUserCheck\"><div class=\"col-md-12 form-group\"><button type=\"submit\" style=\"width: 125px;\" class=\"btn btn-primary\" ng-click=\"signin()\">Sign In</button> <button type=\"submit\" style=\"width: 125px;\" class=\"btn btn-primary\" ng-click=\"signup()\">Sign Up</button></div></div></form><a class=\"btn btn-default btn-xs hide\" style=\"margin-top:10px; color:#808080; display:inline-block\" ng-click=\"!showEcashless ? showEcashless=true : showEcashless=false\">eCashless Authentication</a><div class=\"form-group ecashlessAuth\" ng-show=\"showEcashless\"><div class=\"thumbnail\"><form name=\"plannedHospAuth\"><input type=\"text\" class=\"form-control\" placeholder=\"Enter ClaimID\" ng-model=\"planned.claimid\" required=\"\"> <input type=\"text\" class=\"form-control\" placeholder=\"Enter Hospital ID\" ng-model=\"planned.hospid\" required=\"\"> <input type=\"text\" class=\"form-control\" placeholder=\"OTP\" ng-model=\"planned.otp\" required=\"\"><div style=\"width:100%; overflow:hidden\"><button type=\"button\" class=\"btn btn-default pull-left\" style=\"margin-top:10px\" ng-click=\"showEcashless=false\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" style=\"margin-top:10px\" ng-click=\"getOtpConfirmed()\" ng-disabled=\"plannedHospAuth.$invalid\">Submit</button></div><span class=\"label label-danger\" ng-show=\"planned.OtpRemarks\">{{planned.OtpRemarks}}</span></form></div></div><div class=\"contact\"><a href=\"mailto:hospital.medibuddy@mediassistindia.com\" title=\"hospital.medibuddy@mediassistindia.com\"><i class=\"fa fa-envelope\"></i> Email us</a> <a href=\"tel:08022068666\"><i class=\"fa fa-phone\"></i> 080-22068666</a></div></div><div style=\"z-index: 111111\" class=\"modal fade\" id=\"mediAssistAlert\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\" style=\"color:#283e4a\">Any Payer One Platform - MediBuddy 2.0 is LIVE.</h4></div><div class=\"modal-body\"><p style=\"color: black;\">Now use your MediBuddy to submit and manage claims of any payer (TPA / Insurer) @ Zero Cost. Here\'s how:</p><div><ul><li>Configure your mailbox.</li><li>Configure payers and their mail IDs.</li><li>Follow the usual process to record new admission, track claim and manage documents right here on MediBuddy.</li></ul></div><div>Configure Mailbox Now <a href=\"#/tpaConfig\">click here</a></div></div></div></div></div><div class=\"modal fade\" id=\"forgotPwd\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"forgotpasswordlabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h3 style=\"color:black\" class=\"modal-title\">Reset Password</h3></div><div class=\"modal-body\" id=\"forgotpwdbody\" ng-show=\"!esubmitted && !resetFail\"><form><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><div class=\"radio\" ng-init=\"resetKeyName = \'userName\'\"><label style=\"font-weight: 600;\"><input type=\"radio\" name=\"passwordKey\" ng-model=\"resetKeyName\" value=\"userName\">Username</label> <label style=\"margin-left: 10px;font-weight: 600;\"><input type=\"radio\" name=\"passwordKey\" ng-model=\"resetKeyName\" value=\"emailId\">Email-Id</label><p class=\"pull-right\" ng-show=\"!hospitalsFetched\" style=\"color: #00000059;font-weight: bold;\">You will recieve a mail on your registered email-id</p></div><input type=\"text\" placeholder=\"{{resetKeyName == \'userName\' ? \'Enter your registered username\' : \'Enter your registered email-id\'}}\" class=\"form-control\" ng-model=\"reset.userid\"></div><button ng-disabled=\"!reset.userid || reset.userid.length < 4\" class=\"btn btn-primary btn-sm\" ng-click=\"resetPassword()\">Reset Password</button></div></div></form></div><div class=\"modal-body\" ng-if=\"esubmitted\"><p>Dear <strong>{{reset.userFirstName}}</strong>,</p><br><p>Password reset link has been sent to <strong>\"{{reset.userEmail}}\"</strong> email id.</p><br><p style=\"margin-top: -21px;\">Please click on the link to reset your password.</p><br><p style=\"background-color: yellow; PADDING: 8PX 5PX 6PX 11PX; border-radius: 6px; margin-top: -20px;\"><span><strong>Note</strong> :</span> Link is valid for 24 hours.</p><br><p>Thank you,</p><p>Mediassist Team</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"esubmitted=false\">Close</button></div><div class=\"modal-body\" ng-show=\"resetFail\"><p>Your request for password reset has been failed with following reason.</p><p>{{errorMessage}} , Please try again later.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"resetFail=false\">Close</button></div></div></div></div><style>\n    .ngdialog-theme-custom {\n        padding-bottom: 160px;\n        padding-top: 160px;\n    }\n</style>");
$templateCache.put("app/modules/signin/payerPopup.html","<div class=\"row\"><div class=\"col-md-12\"><p class=\"alert alert-danger\">Payer Setting Invalid!</p></div><div class=\"col-md-12\"><button type=\"button\" ng-click=\"openTpaPayer()\" class=\"btn btn-info\">Setup Now</button> <button type=\"button\" class=\"btn btn-danger pull-right\" ng-click=\"closeThisDialog()\">Close</button></div></div>");
$templateCache.put("app/modules/signin/signInPopup.html","<style>\n  body {\n    font-size: 14px;\n    font-family: \'Open Sans\', sans-serif;\n    line-height: 1.66rem;\n  }\n\n  .container {\n    max-width: 768px;\n    margin: 0 auto;\n  }\n\n</style><section class=\"container\"><p style=\"margin-bottom: 5px;\">Dear Provider,</p><h5 style=\"margin-top: 0;\">We are happy to inform you that more than 85% of our Network Providers are experiencing faster turnaround time for the pre authorizations submitted on our Online Portal, MediBuddy+<br>Similarly to provide faster turnaround for the cashless claims submitted, an exclusive “Cashless Processing Center” has started functioning at Bangalore.</h5><p style=\"margin-bottom: 5px;\">With immediate effect, please courier the physical Cashless documents directly to the following address :</p><address style=\"color: #9a9a9a;\">Medi Assist Insurance TPA Pvt Ltd<br>Cashless Processing Centre<br>No. 252/2. Kodichikkanahalli Main Road<br>Opposite Kailash Building<br>Bommanahalli<br>Bangalore – 560 068</address></section><div class=\"row\"><div class=\"col-md-4\"></div><div class=\"col-md-4\"></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-danger pull-right\" ng-click=\"closeThisDialog()\">Close</button></div></div>");
$templateCache.put("app/modules/signin/signin.html","<div class=\"loginBox\" ng-show=\"!signInshow\"><h1 class=\"text-center m-t-0\"><div style=\"width:80px; height:80px; background:#fff; margin:0 auto; border-radius:50%; padding:12px 10px 10px 10px;\"><img src=\"app/resources/images/medibuddy-plus-small-logo.png\" alt=\"MediBuddy+\" style=\"width:100%;\"></div></h1><p class=\"text-center logTxt\" style=\"color:#fff;\">MediBuddy+ a healthy relationship between you and your patient!</p><h3 style=\"color:#fff\">Sign in</h3><div class=\"alert alert-danger\" role=\"alert\" id=\"loginMessage\" ng-show=\"isErorMessageLogin\">{{errorMessage}}</div><div ng-show=\"flagStatus.isUserCheck\"><label style=\"color: black;margin-bottom: 20px;margin-top: 15px;\" id=\"ErrorMsg\">This functionality has been disabled for medibuddy user. Please <a href=\"https://one.mediassistindia.com/adfs/ls/idpinitiatedsignon?loginToRp=https://plus.medibuddy.in\">Click here</a>to login through your corporate portal to access MediBuddy.</label></div><form role=\"form\" class=\"form\"><div class=\"form-group\"><i class=\"icon user\"></i> <input type=\"text\" class=\"form-control user-name\" ng-model=\"user.username\" placeholder=\"Username or Email\"></div><div class=\"form-group\" ng-show=\"!flagStatus.isUserCheck\"><i class=\"icon pass\"></i> <input type=\"password\" class=\"form-control password\" id=\"exampleInputPassword1\" ng-model=\"user.password\" placeholder=\"Password\"> <a data-toggle=\"modal\" data-target=\"#forgotPwd\" ng-click=\"resetData()\">Forgot password?</a></div><div class=\"row\" ng-show=\"!flagStatus.isUserCheck\"><div class=\"col-md-12 form-group\"><button type=\"submit\" style=\"width: 125px;\" class=\"btn btn-primary\" ng-click=\"signin()\">Sign In</button> <button type=\"submit\" style=\"width: 125px;\" class=\"btn btn-primary\" ng-click=\"signup()\">Sign Up</button></div></div></form><a class=\"btn btn-default btn-xs hide\" style=\"margin-top:10px; color:#808080; display:inline-block\" ng-click=\"!showEcashless ? showEcashless=true : showEcashless=false\">eCashless Authentication</a><div class=\"form-group ecashlessAuth\" ng-show=\"showEcashless\"><div class=\"thumbnail\"><form name=\"plannedHospAuth\"><input type=\"text\" class=\"form-control\" placeholder=\"Enter ClaimID\" ng-model=\"planned.claimid\" required=\"\"> <input type=\"text\" class=\"form-control\" placeholder=\"Enter Hospital ID\" ng-model=\"planned.hospid\" required=\"\"> <input type=\"text\" class=\"form-control\" placeholder=\"OTP\" ng-model=\"planned.otp\" required=\"\"><div style=\"width:100%; overflow:hidden\"><button type=\"button\" class=\"btn btn-default pull-left\" style=\"margin-top:10px\" ng-click=\"showEcashless=false\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" style=\"margin-top:10px\" ng-click=\"getOtpConfirmed()\" ng-disabled=\"plannedHospAuth.$invalid\">Submit</button></div><span class=\"label label-danger\" ng-show=\"planned.OtpRemarks\">{{planned.OtpRemarks}}</span></form></div></div><div class=\"contact\"><a href=\"mailto:hospital.medibuddy@mediassistindia.com\" title=\"hospital.medibuddy@mediassistindia.com\"><i class=\"fa fa-envelope\"></i> Email us</a> <a href=\"tel:08022068666\"><i class=\"fa fa-phone\"></i> 080-22068666</a></div></div><div style=\"z-index: 111111\" class=\"modal fade\" id=\"mediAssistAlert\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\" style=\"color:#283e4a\">Any Payer One Platform - MediBuddy 2.0 is LIVE.</h4></div><div class=\"modal-body\"><p style=\"color: black;\">Now use your MediBuddy to submit and manage claims of any payer (TPA / Insurer) @ Zero Cost. Here\'s how:</p><div><ul><li>Configure your mailbox.</li><li>Configure payers and their mail IDs.</li><li>Follow the usual process to record new admission, track claim and manage documents right here on MediBuddy.</li></ul></div><div>Configure Mailbox Now <a href=\"#/tpaConfig\">click here</a></div></div></div></div></div><div class=\"modal fade\" id=\"forgotPwd\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"forgotpasswordlabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h3 style=\"color:black\" class=\"modal-title\">Reset Password</h3></div><div class=\"modal-body\" id=\"forgotpwdbody\" ng-show=\"!esubmitted && !resetFail\"><form><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><div class=\"radio\" ng-init=\"resetKeyName = \'userName\'\"><label style=\"font-weight: 600;\"><input type=\"radio\" name=\"passwordKey\" ng-model=\"resetKeyName\" value=\"userName\">Username</label> <label style=\"margin-left: 10px;font-weight: 600;\"><input type=\"radio\" name=\"passwordKey\" ng-model=\"resetKeyName\" value=\"emailId\">Email-Id</label><p class=\"pull-right\" ng-show=\"!hospitalsFetched\" style=\"color: #00000059;font-weight: bold;\">You will recieve a mail on your registered email-id</p></div><input type=\"text\" placeholder=\"{{resetKeyName == \'userName\' ? \'Enter your registered username\' : \'Enter your registered email-id\'}}\" class=\"form-control\" ng-model=\"reset.userid\"></div><button ng-disabled=\"!reset.userid || reset.userid.length < 4\" class=\"btn btn-primary btn-sm\" ng-click=\"resetPassword()\">Reset Password</button></div></div></form></div><div class=\"modal-body\" ng-if=\"esubmitted\"><p>Dear <strong>{{reset.userFirstName}}</strong>,</p><br><p>Password reset link has been sent to <strong>\"{{reset.userEmail}}\"</strong> email id.</p><br><p style=\"margin-top: -21px;\">Please click on the link to reset your password.</p><br><p style=\"background-color: yellow; PADDING: 8PX 5PX 6PX 11PX; border-radius: 6px; margin-top: -20px;\"><span><strong>Note</strong> :</span> Link is valid for 24 hours.</p><br><p>Thank you,</p><p>Mediassist Team</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"esubmitted=false\">Close</button></div><div class=\"modal-body\" ng-show=\"resetFail\"><p>Your request for password reset has been failed with following reason.</p><p>{{errorMessage}} , Please try again later.</p><button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"resetFail=false\">Close</button></div></div></div></div><style>\n  .ngdialog-theme-custom {\n    padding-bottom: 160px;\n    padding-top: 160px;\n  }\n\n</style>");
$templateCache.put("app/modules/signup/singup.html","<div class=\"container\" style=\"overflow-y: auto; max-height: 100%;\"><header class=\"text-center clearfix\" style=\"max-width:760px;margin:0 auto;text-align: center;\"><a href=\"\" ng-click=\"goMain()\"><img src=\"/app/resources/images/logo-mediBuddy.png\" alt=\"MediBuddy+\" style=\"width:210px;margin: 20px 0px 0 40px;\" class=\"pull-left\"></a><h2 style=\"color:#0e8dca; font-size:20px;\">Create your account for <span style=\"font-size:14px; display:block; color:#11100b;\">a healthy relationship between you and your patient!</span></h2></header><div class=\"receiving\" style=\"max-width:760px;\"><ul class=\"nav nav-tabs\" role=\"tablist\"><li ng-click=\"tabValidation(item)\" class=\"{{item.classType}}\" ng-repeat=\"item in signupTab\"><a href=\"{{item.href}}\" role=\"tab\" data-toggle=\"tab\">{{item.name}} <span class=\"glyphicon {{item.icon}}\"></span></a></li></ul><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"tab.isFirstTab ? \'active\' :\'\'\" ng-show=\"tab.isFirstTab\"><div class=\"panel-body\"><form name=\"information\" role=\"form\"><h4 style=\"margin-top:0;\">Basic Information</h4><div class=\"row\"><div class=\"col-md-6\"><label for=\"providerType\">Provider type *</label><select name=\"providerType\" id=\"providerType\" ng-model=\"signupForm.basicInformation.providerType\" class=\"form-control\"><option value=\"\">Please Select</option><option value=\"Hospital\">Hospital</option><option value=\"Nursing Home\">Nursing home</option><option value=\"Diagnostic Centre\">Diagnostic centre</option><option value=\"Clinic\">Clinic</option></select></div><div class=\"col-md-6\"><label for=\"servicesOffered\">Services offered *</label><select required=\"true\" name=\"servicesOffered\" id=\"servicesOffered\" ng-model=\"signupForm.basicInformation.servicesOffered\" class=\"form-control\"><option value=\"\">Please Select</option><option value=\"In-patient Services\">In-patient Services</option><option value=\"Out-Patient Services\">Out-Patient Services</option><option value=\"Both\">Both</option></select></div><div class=\"col-md-12\"><label for=\"ProviderTypeName\"><strong>{{signupForm.basicInformation.providerType}}</strong> Name *</label> <input type=\"text\" required=\"true\" placeholder=\"Enter providerType name\" name=\"ProviderTypeName\" ng-maxlength=\"100\" id=\"ProviderTypeName\" ng-model=\"signupForm.basicInformation.ProviderTypeName\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"information.ProviderTypeName.$error.maxlength\">Provider name can\'t be more then 50 character.</p></div><div class=\"col-md-6\"><label for=\"ownership\">Ownership *</label><select required=\"true\" name=\"ownership\" id=\"ownership\" ng-model=\"signupForm.basicInformation.ownership\" class=\"form-control\"><option value=\"\">Please Select</option><option value=\"Individual\">Individual</option><option value=\"partnership\">Partnership</option><option value=\"Charity/Trust\">Charity/Trust</option><option value=\"Corporate\">Corporate</option><option value=\"Others\">Others</option></select></div><div class=\"col-md-6\"><label for=\"otherOwnership\">Other ownership? specify</label> <input type=\"text\" text-only=\"text-only\" placeholder=\"Enter other ownership? specify name\" name=\"otherOwnership\" id=\"otherOwnership\" ng-model=\"signupForm.basicInformation.otherOwnership\" class=\"form-control\"></div><div class=\"col-md-6\"><label for=\"registrationNumber\">Registration number *</label> <input required=\"true\" type=\"text\" placeholder=\"Enter registration No\" name=\"registrationNumber\" ng-maxlength=\"20\" id=\"registrationNumber\" ng-model=\"signupForm.basicInformation.registrationNumber\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"information.registrationNumber.$error.maxlength\">Registration number can\'t be more then 20 character.</p></div><div class=\"col-md-6\"><label for=\"rohiniID\">Rohini ID</label> <input type=\"text\" placeholder=\"Enter rohini ID\" name=\"rohiniID\" id=\"rohiniID\" ng-model=\"signupForm.basicInformation.rohiniID\" class=\"form-control\"></div><div class=\"col-md-6\"><label for=\"PANNumber\">PAN number</label> <input type=\"text\" placeholder=\"Enter PAN number\" name=\"PANNumber\" id=\"PANNumber\" ng-model=\"signupForm.basicInformation.PANNumber\" class=\"form-control\"></div></div><h4>Accreditations/Certification</h4><div class=\"row\"><div class=\"col-md-4\" ng-repeat=\"item in certificationData track by $index\"><div class=\"checkbox\"><label><input ng-model=\"item.isSelected\" type=\"checkbox\"> {{item.name}}</label></div></div><div class=\"col-md-4\"><button ng-click=\"addNewCertification(false)\" class=\"btn btn-info btn-xs\" style=\"margin-top: 5px; margin-bottom: 10px;\"><span class=\"glyphicon glyphicon-plus-sign\"></span> Add More</button></div><div class=\"col-md-12\" ng-show=\"isNewCertificationName\"><hr><div class=\"col-md-8\"><label for=\"newCertificationName\">Name</label> <input type=\"text\" ng-maxlength=\"20\" placeholder=\"Enter Accreditations/Certification name\" ng-model=\"dynamicFields.newCertificationName\" class=\"form-control\"></div><div class=\"col-md-2\"><button ng-disabled=\"!dynamicFields.newCertificationName\" ng-click=\"addNewCertification(true, dynamicFields.newCertificationName)\" class=\"btn btn-primary\" style=\"margin-top: 17px;\"><span class=\"glyphicon glyphicon-plus-sign\"></span> Add</button></div><div class=\"col-md-2\"><button class=\"btn btn-default\" ng-click=\"closeButton()\" style=\"margin-top: 17px;\">Close</button></div></div></div></form></div><div class=\"panel-footer\"><div class=\"form--action\"><p class=\"pull-left\" style=\"font-size:12px\">Have an account? <a href=\"\" ng-click=\"goMain()\">Sign in</a></p><button ng-disabled=\"!information.$valid\" class=\"btn btn-info pull-right btnNext\" ng-click=\"goNext(\'Contact Details\')\">Save And Continue</button></div></div></div><div class=\"tab-pane\" ng-class=\"tab.isSecondTab ? \'active\' :\'\'\" ng-show=\"tab.isSecondTab\"><div class=\"panel-body\"><form name=\"address\"><h4>Address</h4><div class=\"row\"><div class=\"col-md-6\"><label for=\"building\">Building *</label> <input name=\"building\" required=\"true\" ng-maxlength=\"50\" type=\"text\" placeholder=\"Enter building name\" ng-model=\"signupForm.contact.address.Building\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.building.$error.maxlength\">Building name not more then 50 characters.</p></div><div class=\"col-md-6\"><label for=\"\">Street / Area *</label> <input name=\"streetArea\" required=\"true\" ng-maxlength=\"50\" type=\"text\" placeholder=\"Enter street/area name\" ng-model=\"signupForm.contact.address.streetOrArea\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.streetArea.$error.maxlength\">Street/area name not more then 50 characters.</p></div><div class=\"col-md-6\"><label for=\"\">Location *</label> <input name=\"location\" required=\"true\" ng-maxlength=\"50\" type=\"text\" text-only=\"text-only\" placeholder=\"Enter location\" ng-model=\"signupForm.contact.address.location\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.location.$error.maxlength\">Location not more then 50 characters.</p></div><div class=\"col-md-6\"><label for=\"\">City *</label> <input name=\"city\" required=\"true\" text-only=\"text-only\" ng-maxlength=\"20\" type=\"text\" placeholder=\"Enter city\" ng-model=\"signupForm.contact.address.city\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.city.$error.maxlength\">City name not more then 20 characters.</p></div><div class=\"col-md-6\"><label for=\"\">State *</label> <input name=\"state\" required=\"true\" ng-maxlength=\"20\" text-only=\"text-only\" type=\"text\" placeholder=\"Enter state\" ng-model=\"signupForm.contact.address.state\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.state.$error.maxlength\">State name not more then 20 characters.</p></div><div class=\"col-md-6\"><label for=\"\">Pincode *</label> <input name=\"pincode\" required=\"true\" ng-minlength=\"6\" ng-maxlength=\"6\" type=\"text\" numbers-only=\"numbers-only\" placeholder=\"Enter pincode\" ng-model=\"signupForm.contact.address.pincode\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.pincode.$error.maxlength || address.pincode.$error.minlength\">Invalid pincode.</p></div></div><h4><strong>{{signupForm.basicInformation.providerType}}</strong> Contact Details</h4><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Landline number *</label> <input name=\"landLineNumber\" required=\"true\" ng-minlength=\"10\" ng-maxlength=\"13\" numbers-only=\"numbers-only\" type=\"text\" placeholder=\"Enter landline number\" ng-model=\"signupForm.contact.contactDetails.landlineNumber\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.landLineNumber.$error.maxlength || address.landLineNumber.$error.minlength\">Invalid landline number.</p></div><div class=\"col-md-6\"><label for=\"\">Email address *</label> <input type=\"email\" required=\"true\" name=\"emailAddress\" placeholder=\"Enter mail address\" ng-pattern=\"emailchk\" ng-model=\"signupForm.contact.contactDetails.emailAddress\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.emailAddress.$error.pattern\">Invalid email address.</p></div><div class=\"col-md-12\"><label for=\"\">Website</label> <input type=\"text\" placeholder=\"Enter website name\" ng-model=\"signupForm.contact.contactDetails.websiteName\" class=\"form-control\"></div></div><h4>Chief Executive of Centre</h4><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Name *</label> <input required=\"true\" name=\"chiefExecutiveName\" text-only=\"text-only\" ng-maxlength=\"30\" type=\"text\" placeholder=\"Enter name\" ng-model=\"signupForm.contact.chiefExecutive.name\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.chiefExecutiveName.$error.maxlength\">Name not more then 30 characters.</p></div><div class=\"col-md-6\"><label for=\"\">Mobile number *</label> <input required=\"true\" name=\"chiefExecutiveMobileNumber\" ng-minlength=\"10\" ng-maxlength=\"10\" numbers-only=\"numbers-only\" type=\"text\" placeholder=\"Enter mobile number\" ng-model=\"signupForm.contact.chiefExecutive.mobileNumber\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.chiefExecutiveMobileNumber.$error.maxlength ||address.chiefExecutiveMobileNumber.$error.minlength\">Invalid mobile number.</p></div><div class=\"col-md-12\"><label for=\"\">Email address *</label> <input required=\"true\" name=\"chiefExecutiveEmailAddress\" type=\"email\" placeholder=\"Enter mail address\" ng-pattern=\"emailchk\" ng-model=\"signupForm.contact.chiefExecutive.emailAddress\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.chiefExecutiveEmailAddress.$error.pattern\">Invalid email address.</p></div></div><h4>Operations Contact</h4><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Name *</label> <input required=\"true\" name=\"operationContactName\" text-only=\"text-only\" ng-maxlength=\"30\" type=\"text\" placeholder=\"Enter name\" ng-model=\"signupForm.contact.operations.name\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.operationContactName.$error.maxlength\">Name not more then 30 characters.</p></div><div class=\"col-md-6\"><label for=\"\">Mobile number *</label> <input name=\"operationContactmobileNumber\" required=\"true\" ng-minlength=\"10\" ng-maxlength=\"10\" type=\"text\" numbers-only=\"numbers-only\" placeholder=\"Enter mobile number\" ng-model=\"signupForm.contact.operations.mobileNumber\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.operationContactmobileNumber.$error.maxlength || address.operationContactmobileNumber.$error.minlength\">Invalid mobile number.</p></div><div class=\"col-md-12\"><label for=\"\">Email ID *</label> <input required=\"true\" name=\"operationContactEmailAddress\" type=\"email\" placeholder=\"Enter mail address\" ng-pattern=\"emailchk\" ng-model=\"signupForm.contact.operations.emailAddress\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.operationContactEmailAddress.$error.pattern\">Invalid email address.</p></div></div><h4>Finance Contact</h4><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Name *</label> <input required=\"true\" name=\"financeContaactName\" text-only=\"text-only\" ng-maxlength=\"30\" type=\"text\" placeholder=\"Enter name\" ng-model=\"signupForm.contact.finance.name\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.financeContaactName.$error.maxlength\">Name not more then 30 characters.</p></div><div class=\"col-md-6\"><label for=\"\">Mobile number *</label> <input required=\"true\" name=\"financeContaactMobileNumber\" ng-minlength=\"10\" ng-maxlength=\"10\" numbers-only=\"numbers-only\" type=\"text\" placeholder=\"Enter mobile number\" ng-model=\"signupForm.contact.finance.mobileNumber\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.financeContaactMobileNumber.$error.maxlength || address.financeContaactMobileNumber.$error.minlength\">Invalid mobile number.</p></div><div class=\"col-md-12\"><label for=\"\">Email ID *</label> <input required=\"true\" name=\"financeContaactEmailAddress\" type=\"email\" placeholder=\"Enter mail address\" ng-pattern=\"emailchk\" ng-model=\"signupForm.contact.finance.emailAddress\" class=\"form-control\"><p class=\"errorClass\" ng-show=\"address.financeContaactEmailAddress.$error.pattern\">Invalid email address.</p></div></div></form></div><div class=\"panel-footer\"><div class=\"form--action\"><button class=\"btn btn-info\" ng-click=\"goBack(\'Basic Information\')\">Back</button> <button ng-disabled=\"!address.$valid\" class=\"btn btn-info pull-right btnNext\" ng-click=\"goNext(\'Services\')\">Save And Continue</button></div></div></div><div class=\"tab-pane\" ng-class=\"tab.isThirdTab ? \'active\' :\'\'\" ng-show=\"tab.isThirdTab\"><div class=\"panel-body\"><form role=\"form\"><h4 style=\"margin-top:0;\">Clinical Services</h4><div class=\"row\" style=\"margin:0; padding:0;\"><table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" class=\"table table-condensed\" style=\"margin:0;\"><tbody><tr ng-repeat=\"item in clinicalServicesData track by $index\"><td>{{item.name}}</td><td class=\"text-right\"><div class=\"btn-group\" ng-repeat=\"servicename in item.servicename track by $index\"><input type=\"radio\" ng-model=\"item.selectedService\" ng-click=\"checkService(item,\'Clinical Services\')\" value=\"{{servicename.name}}\"> <span style=\"margin-left: 3px;\">{{servicename.name}}</span></div></td></tr></tbody></table></div><h4>Emergency Services:</h4><div class=\"row\"><div class=\"col-md-6\"><label for=\"\">Number of ambulances</label> <input type=\"text\" numbers-only=\"numbers-only\" placeholder=\"Enter No of ambulances\" ng-model=\"signupForm.services.emergency.ambulancesCount\" class=\"form-control\"></div><div class=\"col-md-6\"><label for=\"\">Number of emergency room / casualty</label> <input type=\"text\" numbers-only=\"numbers-only\" placeholder=\"Enter No of emergency room/casualty\" ng-model=\"signupForm.services.emergency.emergencyRooms\" class=\"form-control\"></div></div><h4>Radiology Services:</h4><div class=\"row\" style=\"margin:0; padding:0;\"><table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" class=\"table table-condensed\" style=\"margin:0;\"><tbody><tr ng-repeat=\"item in radiologyServices track by $index\"><td>{{item.name}}</td><td class=\"text-right\"><div class=\"btn-group\" ng-repeat=\"servicename in item.servicename track by $index\"><input type=\"radio\" ng-model=\"item.selectedRadiologyService\" ng-click=\"checkService(item,\'Radiology services\')\" value=\"{{servicename.name}}\"> <span style=\"margin-left: 3px;\">{{servicename.name}}</span></div></td></tr></tbody></table></div><h4>Laboratory and Blood Bank Services:</h4><div class=\"row\" style=\"margin:0; padding:0;\"><table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" class=\"table table-condensed\" style=\"margin:0;\"><tbody><tr ng-repeat=\"item in laboratoryServices track by $index\"><td>{{item.name}}</td><td class=\"text-right\"><div class=\"btn-group\" ng-repeat=\"servicename in item.servicename track by $index\"><input type=\"radio\" ng-model=\"item.selectedLaboratoryService\" ng-click=\"checkService(item,\'Laboratory and blood bank services\')\" value=\"{{servicename.name}}\"> <span style=\"margin-left: 3px;\">{{servicename.name}}</span></div></td></tr></tbody></table></div></form></div><div class=\"panel-footer\"><div class=\"form--action\"><button class=\"btn btn-info\" ng-click=\"goBack(\'Contact Details\')\">Back</button> <button class=\"btn btn-info pull-right btnNext\" ng-click=\"goNext(\'Rooms\')\">Save And Continue</button></div></div></div><div class=\"tab-pane\" ng-class=\"tab.isFourthTab ? \'active\' :\'\'\" ng-show=\"tab.isFourthTab\"><div class=\"panel-body\"><form role=\"form\"><div class=\"row\"><table class=\"table table-condensed\" style=\"margin:0;\"><tr><th class=\"patientName\">Room type / name</th><th class=\"claimId\" style=\"width:150px;\">No of rooms</th><th class=\"claimedAmount text-right\" style=\"width:150px;\">Beds per room</th></tr><tr ng-repeat=\"item in roomsData track by $index\"><td>{{item.name}}</td><td><input type=\"text\" numbers-only=\"numbers-only\" ng-model=\"item.noOfRooms\" placeholder=\"Enter number\" class=\"form-control\"></td><td><input type=\"text\" numbers-only=\"numbers-only\" ng-model=\"item.bedsPerRoom\" placeholder=\"Enter number\" class=\"form-control\"></td></tr><tr><td colspan=\"3\"><button class=\"btn btn-info btn-sm pull-right\" ng-click=\"addMoreRooms(false)\" style=\"margin-top:10px;\"><span class=\"glyphicon glyphicon-plus-sign\"></span> Add More</button></td></tr></table><div class=\"col-md-12\" ng-show=\"isNewRooms\"><div class=\"col-md-4\"><label for=\"roomName\">Room type</label> <input type=\"text\" ng-maxlength=\"20\" placeholder=\"Enter room name\" ng-model=\"dynamicFields.rooms.name\" class=\"form-control\"></div><div class=\"col-md-3\"><label for=\"roomCount\">Rooms count</label> <input type=\"text\" numbers-only=\"numbers-only\" ng-maxlength=\"20\" placeholder=\"Enter room count\" ng-model=\"dynamicFields.rooms.noOfRooms\" class=\"form-control\"></div><div class=\"col-md-3\"><label for=\"bedsCount\">Beds count</label> <input type=\"text\" numbers-only=\"numbers-only\" ng-maxlength=\"20\" placeholder=\"Enter beds count\" ng-model=\"dynamicFields.rooms.bedsPerRooms\" class=\"form-control\"></div><div class=\"col-md-1\"><button ng-disabled=\"!dynamicFields.rooms.name ||!dynamicFields.rooms.noOfRooms || !dynamicFields.rooms.bedsPerRooms\" ng-click=\"addMoreRooms(true, dynamicFields.rooms)\" class=\"btn btn-primary\" style=\"margin-top: 20px;width: 60px;margin-left: -28px;\"><span class=\"glyphicon glyphicon-plus-sign\"></span> Add</button></div><div class=\"col-md-1\"><button class=\"btn btn-default\" ng-click=\"closeButton()\" style=\"margin-top: 20px; margin-left: -8px; width: 54px;\">Close</button></div></div></div></form></div><div class=\"panel-footer\"><div class=\"form--action\"><button class=\"btn btn-info\" ng-click=\"goBack(\'Services\')\">Back</button> <button class=\"btn btn-info pull-right btnNext\" ng-click=\"goNext(\'Documents\')\">Save And Continue</button></div></div></div><div class=\"tab-pane\" ng-class=\"tab.isFifthTab ? \'active\' :\'\'\" ng-show=\"tab.isFifthTab\"><div class=\"panel-body\"><form role=\"form\"><h4>In-Patient Documents</h4><div class=\"row\" style=\"margin:20px 0; padding:0;\"><table class=\"table table-condensed\" style=\"margin:0;\"><tbody><tr ng-repeat=\"item in inPatientDocuments track by $index\"><td>{{item.name}}</td><td><div class=\"form-group\"><div class=\"form-group\" style=\"margin-bottom: -24px;\"><div class=\"row\"><div class=\"col-sm-6\"><input type=\"file\" file-models=\"{{\'myFile\' + $index}}\"></div><div class=\"col-sm-6\"><button class=\"btn btn-sm btn-primary\" style=\"margin-top: -12px;\" ng-click=\"uploadFileMethod(item, \'inPatientDocs\')\">Upload File</button></div></div></div></div></td></tr></tbody></table></div><h4>Out-Patient Documents</h4><div class=\"row\" style=\"margin:20px 0; padding:0;\"><table class=\"table table-condensed\" style=\"margin:0;\"><tbody><tr ng-repeat=\"item in outPatientDocuments track by $index\"><td>{{item.name}}</td><td><div class=\"form-group\"><div class=\"form-group\" style=\"margin-bottom: -24px;\"><div class=\"row\"><div class=\"col-sm-6\"><input type=\"file\" file-models=\"{{\'myFile\' + $index}}\"></div><div class=\"col-sm-6\"><button class=\"btn btn-sm btn-primary\" style=\"margin-top: -12px;\" ng-click=\"uploadFileMethod(item, \'outPatientDocs\')\">Upload File</button></div></div></div></div></td></tr></tbody></table></div></form></div><div class=\"panel-footer\"><button class=\"btn btn-primary pull-right\" ng-click=\"goSingup()\">Submit</button></div></div></div></div></div>");
$templateCache.put("app/modules/tpaConfiguration/tpaConfiguration.html","<style>\n\n\n</style><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-6\"><div class=\"pull-right addBtn\"><a href=\"\" class=\"btn btn-block\" data-toggle=\"tooltip\" ng-click=\"addTpa()\" style=\"padding: 10px; width:auto; display:inline-block;\"><i class=\"fa fa-plus\"></i> Add Payer</a></div><h4>Payer Configuration</h4></div></div></div><div class=\"row\"><div class=\"col-md-12\" style=\"margin-top: 11px;\"><table class=\"table table-hover packageTbl\" style=\"margin-left: 5px;\"><tr style=\"color: #000000;\"><th>Name</th><th>Payer Mail server address</th><th>Payer mail id</th><th>Hospital mail id</th><th>Hospital server address</th><th>Action</th></tr><tr class=\"italic\" ng-class=\"{\'\': hover}\" ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\" ng-repeat=\"pack in tpaList | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\" ng-click=\"editTPA(pack)\"><td>{{pack.tpaName }}</td><td>{{pack.mailServerAddress}}</td><th>{{pack.tpaMailIdCSV}}</th><th>{{pack.hospMailId}}</th><td>{{pack.outGoingServerAddress}}</td><td><button class=\"btn btn-primary btn-sm\" ng-click=\"EditTPA(pack)\">Edit</button></td></tr></table><div style=\"margin-left: 370px;\"><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div><div style=\"text-align:center\"><h5>Need Assistance in configuration? Write to <a href=\"mailto:medibuddysupport@mahs.in\">medibuddysupport@mahs.in</a></h5></div></div></div><div class=\"modal fade\" id=\"addAndUpdateTPA\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"removeModal()\"><span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span></button><h4>Payer Configuration</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\" id=\"new-claim-msg\" ng-if=\"isSuccess\"><div class=\"chat-content_wrap bg-primary\" style=\"background-color: white;\"><h4 class=\"chat-status text-center\" style=\"background-color: #299429; padding-top: 5px; padding-bottom: 5px; border-radius: 16px;\">{{isSuccessMsg}}</h4></div></div><div class=\"col-md-8\" id=\"new-claim-msg\" ng-if=\"isError\"><div class=\"chat-content_wrap bg-primary\" style=\"background-color: white;\"><h4 class=\"chat-status text-center\" style=\"background-color: #ea5656; padding-top: 5px; padding-bottom: 5px; border-radius: 16px;\">{{tpaErrorMsg}}</h4></div></div><div class=\"col-md-2\"></div></div><form name=\"tpaForm1\" style=\"margin-top:-10px\"><p style=\"margin-bottom: -10px;\" class=\"pull-right\"><span style=\"color: red; font-size: small;\">*</span> <span style=\"font-size: 20px;\">Indicate required</span></p><h5 style=\"font-weight: bold;\">Payer DETAILS</h5><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label style=\"font-weight: 400;\">Name <span style=\"color: red; font-size: small;\">*</span></label><select name=\"insurername\" required=\"\" class=\"form-control\" ng-options=\"item as item.value for item in TPAListData track by item.id\" ng-model=\"tpaForm.name\"></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"TPAtpaHospId\" style=\"font-weight: 400;\">Hospital id related to Payer <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAtpaHospId\" type=\"text\" ng-maxlength=\"100\" required=\"\" class=\"form-control\" placeholder=\"Enter hospital id related to Payer\" ng-model=\"tpaForm.tpaHospId\"> <span ng-if=\"tpaForm1.TPAName.$error.maxlength\" style=\"color: #f00\">Hospital id not morethen 100 characters.</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"TPAtpaMailId\" style=\"font-weight: 400;\">Payer Email Id <span style=\"color: red; font-size: small;\">*</span></label><div class=\"input-group\"><input name=\"TPAtpaMailId\" type=\"text\" class=\"form-control\" placeholder=\"Enter Payer mail address\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" ng-model=\"tpaForm.tpaMailId\"> <span class=\"input-group-btn\"><button class=\"btn btn-success\" ng-disabled=\"!tpaForm.tpaMailId\" ng-click=\"addTpaMails(tpaForm.tpaMailId)\">Add</button></span></div><span ng-if=\"!tpaForm1.TPAtpaMailId.$valid && tpaForm1.TPAtpaMailId.$dirty\" style=\"color: #f00\">Payer email address not seems to be valid.</span></div></div></div><div class=\"row\"><div class=\"col-md-12\"><ul class=\"tagsList\" style=\"font-size: small;\"><li class=\"closeBtn\" ng-repeat=\"fac in additionMailsCollection track by $index\">{{fac}} <a href=\"\" ng-click=\"RemoveEmail($index)\"><i class=\"fa fa-close\"></i></a></li></ul></div></div><hr style=\"margin-top: 0px; margin-bottom: 0px;\"><h5 style=\"font-weight: bold;\">HOSPITAL DETAILS</h5><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"TPAHospMailId\" style=\"font-weight: 400;\">Hospital Email Id <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAHospMailId\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter hospital mail address\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" ng-model=\"tpaForm.hospMailId\"> <span ng-if=\"!tpaForm1.TPAHospMailId.$valid && tpaForm1.TPAHospMailId.$dirty\" style=\"color: #f00\">Hospital email address not seems to be valid.</span></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"TPAHospPassword\" style=\"font-weight: 400;\">Password <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAHospPassword\" type=\"password\" required=\"\" autocomplete=\"new-password\" class=\"form-control\" placeholder=\"Enter hospital mailbox password\" ng-model=\"tpaForm.hospPassword\"></div></div></div><hr style=\"margin-top: 0px; margin-bottom: 0px;\"><h5 style=\"font-weight: bold;\">INCOMING MAIL SERVER <span class=\"pull-right\"><img src=\"app/resources/images/gmail.png\" ng-click=\"getMailConfiguration(\'GMAIL\')\"> <img src=\"app/resources/images/yahoo.png\" ng-click=\"getMailConfiguration(\'YAHOO\')\"> <img src=\"app/resources/images/outlook.png\" ng-click=\"getMailConfiguration(\'HOTMAIL\')\"></span></h5><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"TPAMailServerAddress\" style=\"font-weight: 400;\">Host name <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAMailServerAddress\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter InComing mail server address\" ng-model=\"tpaForm.mailServerAddress\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"TPAMailServerPort\" style=\"font-weight: 400;\">Port <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAMailServerPort\" numbers-only=\"numbers-only\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter inComing server port\" ng-model=\"tpaForm.mailServerPort\"></div></div></div><hr style=\"margin-top: 0px; margin-bottom: 0px;\"><h5 style=\"font-weight: bold;\">OUTGOING MAIL SERVER</h5><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"TPAoutGoingServerAddress\" style=\"font-weight: 400;\">Host name <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAoutGoingServerAddress\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter outGoing mail server port\" ng-model=\"tpaForm.outGoingServerAddress\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"TPAOutGoingServerPort\" style=\"font-weight: 400;\">Port <span style=\"color: red; font-size: small;\">*</span></label> <input name=\"TPAOutGoingServerPort\" numbers-only=\"numbers-only\" type=\"text\" required=\"\" class=\"form-control\" placeholder=\"Enter outGoing server port\" ng-model=\"tpaForm.outGoingServerPort\"></div></div></div></form></div><div class=\"modal-footer\"><span class=\"text-danger\" ng-if=\"isEmailConfigFailed\">Please verify Host Name & Port numbers, please contact your IT team or write to <a href=\"mailto:MediBuddysupport@mahs.in\"></a></span> <button class=\"btn btn-primary\" ng-disabled=\"tpaForm1.$invalid || (additionMailsCollection && additionMailsCollection.length==0) || !additionMailsCollection || (tpaForm.name && tpaForm.name.id==0)\" ng-show=\"!isEmailConfigSuccess\" ng-click=\"enableAddTpa()\">Verify Configuration</button> <span ng-show=\"isEmailConfigSuccess\">Verified<i class=\"fa fa-check\"></i></span> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"tpaForm1.$invalid || (additionMailsCollection && additionMailsCollection.length==0) || !additionMailsCollection || (tpaForm.name && tpaForm.name.id==0) || !isEmailConfigSuccess\" ng-click=\"saveTpaDetails(tpaForm)\">Add</button> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-click=\"removeModal()\">Close</button></div></div></div></div>");
$templateCache.put("app/modules/terms/terms.html","<div class=\"terms\"><h4>Please go through the terms and conditions and you can continue to plus portal once you agree.</h4><h5>Conditions of Use</h5><p>Welcome to our online store! Mediassist India TPA Pvt ltd. and its associates provide their services to you subject to the following conditions. If you visit or shop within this website, you accept these conditions. Please read them carefully.</p><h5>PRIVACY</h5><p>Please review our Privacy Notice, which also governs your visit to our website, to understand our practices.</p><h5>ELECTRONIC COMMUNICATIONS</h5><p>When you visit Mediassist India TPA Pvt ltd. or send e-mails to us, you are communicating with us electronically. You consent to receive communications from us electronically. We will communicate with you by e-mail or by posting notices on this site. You agree that all agreements, notices, disclosures and other communications that we provide to you electronically satisfy any legal requirement that such communications be in writing.</p><h5>COPYRIGHT</h5><p>All content included on this site, such as text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations, and software, is the property of Mediassist India TPA Pvt ltd. or its content suppliers and protected by international copyright laws. The compilation of all content on this site is the exclusive property of Mediassist India TPA Pvt ltd., with copyright authorship for this collection by Mediassist India TPA Pvt ltd., and protected by international copyright laws.</p><h5>TRADE MARKS</h5><p>Mediassist India TPA Pvt ltd.s trademarks and trade dress may not be used in connection with any product or service that is not Mediassist India TPA Pvt ltd.s, in any manner that is likely to cause confusion among customers, or in any manner that disparages or discredits Mediassist India TPA Pvt ltd.. All other trademarks not owned by Mediassist India TPA Pvt ltd. or its subsidiaries that appear on this site are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by Mediassist India TPA Pvt ltd. or its subsidiaries.</p><h5>LICENSE AND SITE ACCESS</h5><p>Mediassist India TPA Pvt ltd. grants you a limited license to access and make personal use of this site and not to download (other than page caching) or modify it, or any portion of it, except with express written consent of Mediassist India TPA Pvt ltd.. This license does not include any resale or commercial use of this site or its contents: any collection and use of any product listings, descriptions, or prices: any derivative use of this site or its contents: any downloading or copying of account information for the benefit of another merchant: or any use of data mining, robots, or similar data gathering and extraction tools. This site or any portion of this site may not be reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose without express written consent of Mediassist India TPA Pvt ltd.. You may not frame or utilize framing techniques to enclose any trademark, logo, or other proprietary information (including images, text, page layout, or form) of Mediassist India TPA Pvt ltd. and our associates without express written consent. You may not use any meta tags or any other \"hidden text\" utilizing Mediassist India TPA Pvt ltd.s name or trademarks without the express written consent of Mediassist India TPA Pvt ltd.. Any unauthorized use terminates the permission or license granted by Mediassist India TPA Pvt ltd.. You are granted a limited, revocable, and nonexclusive right to create a hyperlink to the home page of Mediassist India TPA Pvt ltd. so long as the link does not portray Mediassist India TPA Pvt ltd., its associates, or their products or services in a false, misleading, derogatory, or otherwise offensive matter. You may not use any Mediassist India TPA Pvt ltd. logo or other proprietary graphic or trademark as part of the link without express written permission.</p><h5>YOUR MEMBERSHIP ACCOUNT</h5><p>If you use this site, you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and you agree to accept responsibility for all activities that occur under your account or password. If you are under 18, you may use our website only with involvement of a parent or guardian. Mediassist India TPA Pvt ltd. and its associates reserve the right to refuse service, terminate accounts, remove or edit content, or cancel orders in their sole discretion.</p><h5>REVIEWS, COMMENTS, EMAILS, AND OTHER CONTENT</h5><p>Visitors may post reviews, comments, and other content: and submit suggestions, ideas, comments, questions, or other information, so long as the content is not illegal, obscene, threatening, defamatory, invasive of privacy, infringing of intellectual property rights, or otherwise injurious to third parties or objectionable and does not consist of or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings, or any form of \"spam.\" You may not use a false e-mail address, impersonate any person or entity, or otherwise mislead as to the origin of a card or other content. Mediassist India TPA Pvt ltd. reserves the right (but not the obligation) to remove or edit such content, but does not regularly review posted content. If you do post content or submit material, and unless we indicate otherwise, you grant Mediassist India TPA Pvt ltd. and its associates a nonexclusive, royalty-free, perpetual, irrevocable, and fully sublicensable right to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, and display such content throughout the world in any media. You grant Mediassist India TPA Pvt ltd. and its associates and sublicensees the right to use the name that you submit in connection with such content, if they choose. You represent and warrant that you own or otherwise control all of the rights to the content that you post: that the content is accurate: that use of the content you supply does not violate this policy and will not cause injury to any person or entity: and that you will indemnify Mediassist India TPA Pvt ltd. or its associates for all claims resulting from content you supply. Mediassist India TPA Pvt ltd. has the right but not the obligation to monitor and edit or remove any activity or content. Mediassist India TPA Pvt ltd. takes no responsibility and assumes no liability for any content posted by you or any third party.</p><h5>RISK OF LOSS</h5><p>All items purchased from Mediassist India TPA Pvt ltd. are made pursuant to a shipment contract. This basically means that the risk of loss and title for such items pass to you upon our delivery to the carrier.</p><h5>PRODUCT DESCRIPTIONS</h5><p>Mediassist India TPA Pvt ltd. and its associates attempt to be as accurate as possible. However, Mediassist India TPA Pvt ltd. does not warrant that product descriptions or other content of this site is accurate, complete, reliable, current, or error-free. If a product offered by Mediassist India TPA Pvt ltd. itself is not as described, your sole remedy is to return it in unused condition.</p><p>DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY THIS SITE IS PROVIDED BY Mediassist India TPA Pvt ltd. ON AN \"AS IS\" AND \"AS AVAILABLE\" BASIS. Mediassist India TPA Pvt ltd. MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THIS SITE OR THE INFORMATION, CONTENT, MATERIALS, OR PRODUCTS INCLUDED ON THIS SITE. YOU EXPRESSLY AGREE THAT YOUR USE OF THIS SITE IS AT YOUR SOLE RISK. TO THE FULL EXTENT PERMISSIBLE BY APPLICABLE LAW, Mediassist India TPA Pvt ltd. DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. Mediassist India TPA Pvt ltd. DOES NOT WARRANT THAT THIS SITE, ITS SERVERS, OR E-MAIL SENT FROM Mediassist India TPA Pvt ltd. ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. Mediassist India TPA Pvt ltd. WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THIS SITE, INCLUDING, BUT NOT LIMITED TO DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, AND CONSEQUENTIAL DAMAGES. CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS, EXCLUSIONS, OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MIGHT HAVE ADDITIONAL RIGHTS.</p><h5>APPLICABLE LAW</h5><p>By visiting Mediassist India TPA Pvt ltd., you agree that the laws of the state of DEFINE_STATE, DEFINE_COUNTRY, without regard to principles of conflict of laws, will govern these Conditions of Use and any dispute of any sort that might arise between you and Mediassist India TPA Pvt ltd. or its associates.</p><h5>DISPUTES</h5><p>Any dispute relating in any way to your visit to Mediassist India TPA Pvt ltd. or to products you purchase through Mediassist India TPA Pvt ltd. shall be submitted to confidential arbitration in DEFINE_STATE, DEFINE_COUNTRY, except that, to the extent you have in any manner violated or threatened to violate Mediassist India TPA Pvt ltd.s intellectual property rights, Mediassist India TPA Pvt ltd. may seek injunctive or other appropriate relief in any state or federal court in the state of DEFINE_STATE, DEFINE_COUNTRY, and you consent to exclusive jurisdiction and venue in such courts. Arbitration under this agreement shall be conducted under the rules then prevailing of the American Arbitration Association. The arbitrators award shall be binding and may be entered as a judgment in any court of competent jurisdiction. To the fullest extent permitted by applicable law, no arbitration under this Agreement shall be joined to an arbitration involving any other party subject to this Agreement, whether through class arbitration proceedings or otherwise.</p><h5>SITE POLICIES, MODIFICATION, AND SEVERABILITY</h5><p>Please review our other policies, such as our Shipping and Returns policy, posted on this site. These policies also govern your visit to Mediassist India TPA Pvt ltd.. We reserve the right to make changes to our site, policies, and these Conditions of Use at any time. If any of these conditions shall be deemed invalid, void, or for any reason unenforceable, that condition shall be deemed severable and shall not affect the validity and enforceability of any remaining condition.</p><h5>QUESTIONS:</h5><p>Questions regarding our Conditions of Usage, Privacy Policy, or other policy related material can be directed to our support staff by clicking on the \"Contact Us\" link in the side menu. Or you can email us at: info@mediassistindia.com</p><hr><div class=\"btn btn-primary btn-block\" ng-click=\"agreeTerms()\"><strong>I Agree to the terms and conditions</strong></div></div>");
$templateCache.put("app/modules/trackStatus/reScheduleAppointment.html","<div><h3>{{parameter.list.entityName}}</h3><p>{{parameter.list.entityAddress}} - {{parameter.list.pinCode}}</p><span><button ng-click=\"parameter.doIt(parameter.list,\'schedule\');\" class=\"btn btn-primary center-block bookApp BookAppointmentBlock\" data-name=\"{{parameter.list.name}}\">Select Provider</button></span></div>");
$templateCache.put("app/modules/trackStatus/track.html","<div class=\"container apptTrack\"><div class=\"contentPart\"><header class=\"text-center clearfix\"><a href=\"\" ng-click=\"goMain()\" class=\"logo\"><img src=\"/app/resources/images/logo-mediBuddy.png\" alt=\"MediBuddy+\"></a><h2 style=\"color:#0e8dca; font-size:20px;\">Track Your Appointment <span style=\"font-size:14px; display:block; color:#11100b;\">You can track or reschedule the appointment here</span></h2></header><form name=\"statusSearch\" novalidate=\"\" class=\"form\"><h3 style=\"margin-top:30px;\" class=\"radioBtns text-center\" ng-class=\"isParentSel ? \'sel\': \'\'\">I have <span><label for=\"radio_policyno\" ng-click=\"changeType(\'requestId\');\" ng-class=\"isFlag.requestId ? \'sel\': \'\'\"><input type=\"radio\" name=\"searchby\" id=\"radio_policyno\" style=\"margin-left:20px\"> Request ID</label></span> <span><label for=\"radio_empid\" ng-click=\"changeType(\'radio_empid\')\" ng-class=\"isFlag.radio_empid ? \'sel\': \'\'\"><input type=\"radio\" name=\"searchby\" id=\"radio_empid\" style=\"margin-left:20px\"> Application number</label></span> <span><label for=\"radio_MobileNo\" ng-click=\"changeType(\'radio_MobileNo\')\" ng-class=\"isFlag.mobileNumber ? \'sel\': \'\'\"><input type=\"radio\" name=\"searchby\" id=\"radio_MobileNo\" style=\"margin-left:20px\"> Phone Number</label></span></h3><div class=\"formSection\"><div class=\"inputfields\"><div class=\"row\" id=\"requestId\" ng-if=\"isFlag.requestId\"><div class=\"form-group col-xs-8 col-sm-10 p-r-0\"><label for=\"requestNo\">Request ID</label> <input type=\"text\" id=\"requestNo\" ng-model=\"search.requestId\" numbers-only=\"\" placeholder=\"Enter request ID\" class=\"form-control first\" required=\"\" value=\"82956\"></div><div class=\"col-xs-4 col-sm-2\"><button ng-click=\"searchStatus(\'requestId\')\" ng-disabled=\"!search.requestId\" style=\"margin-top: 23px;\" class=\"btn btn-primary btn-block\">Track</button></div></div><div class=\"row appNo\" id=\"radio_empid\" ng-if=\"isFlag.radio_empid\"><div class=\"form-group col-xs-5 col-sm-5 p-r-0\"><label for=\"appNunber\">ApplicationNumber/ProposalNumber</label> <input type=\"text\" id=\"appNunber\" ng-model=\"search.radio_empid\" placeholder=\"Enter application no.\" class=\"form-control first\" required=\"\"></div><div class=\"form-group col-xs-12 col-sm-2\" ng-if=\"isFlag.radio_empid\"><button ng-click=\"searchStatus(\'radio_empid\')\" class=\"btn btn-primary btn-block\" ng-disabled=\"!search.radio_empid\">Track</button></div></div><div class=\"row appNo\" id=\"radio_MobileNo\" ng-if=\"isFlag.mobileNumber\"><div class=\"form-group col-xs-3 col-sm-3 p-r-0\"><label for=\"mobNo\">Phone Number</label> <input type=\"text\" id=\"mobNo\" ng-pattern=\"^(\\+91[\\-\\s]?)?[0]?(91)?[6789]\\d{9}$\" ng-model=\"search.mobileNumber\" ng-maxlength=\"15\" ng-minlength=\"10\" numbers-only=\"\" placeholder=\"Enter mobile number\" class=\"form-control first\" required=\"\"></div><div class=\"form-group col-xs-12 col-sm-2\" ng-if=\"isFlag.mobileNumber\"><button ng-click=\"searchStatus(\'radio_MobileNo\')\" class=\"btn btn-primary btn-block\" ng-disabled=\"!search.mobileNumber\">Track</button></div></div></div></div><div class=\"panel\" ng-if=\"isData\"><div class=\"panel-body\" ng-repeat=\"resItem in statusDetails.trackAppointmentResponseItems\"><h3 class=\"text-center\">{{resItem.name}} <em>Application number: {{resItem.empCode}} | Mobile number: {{resItem.mobileNo}} | Email ID: {{resItem.emailID}}</em></h3><div ng-if=\"isData\" ng-repeat=\"item in resItem.trackAppointments\" class=\"box\"><h4 ng-if=\"item.requestId !== 0\">Request ID : {{item.requestId}}<p ng-if=\"item.contractId !== 12719\">Appointment date time : {{getDateObj(item.appointmentDate) | date : \'medium\'}}</p><p>Visit Type : {{item.currentStatusId == 0 ? \"Appointment Not Scheduled\" : item.isHomeVisit ? \"Home Visit\" : \"Center Visit\"}}</p><span style=\"margin-top: 5px;\">Provider: <strong>{{item.providerName}}</strong>, {{item.providerAddress}}</span></h4><ul class=\"timeLine1 clearfix\"><li ng-repeat=\"i in item.timeLine | orderBy:\'tid\'\" ng-style=\"{{widthCalculation(item.timeLine.length)}}\" ng-class=\"{\'active\': i.isCompleted, \'first\': $first, \'last\': $last, \'noHistory\': i.timeLineHistory.length === 0}\"><div class=\"arrow\"></div><div class=\"statusName\" ng-if=\"i.statusName === \'New Appointment\'\">New</div><div class=\"statusName\" ng-if=\"i.statusName != \'New Appointment\'\">{{i.statusName}}</div><div class=\"hideShow\"><h5 ng-if=\"i.createdDate\">{{i.statusName}} <span>{{compareDate(i.createdDate)}} | {{formatTime(i.createdDate)}}</span></h5><h5 ng-if=\"!i.createdDate\"><span>Yet to {{i.statusName}}</span></h5><ul><li ng-repeat=\"i1 in i.timeLineHistory\" ng-class=\"{\'hide\': $first}\"><strong>{{i1.statusName}}</strong> <span>{{compareDate(i1.historyCreatedDate)}} {{formatTime(i1.historyCreatedDate)}}</span></li></ul></div></li></ul><div class=\"actionBtns text-center\"><button ng-if=\"item.isDNDCustomerMarked ===false && !item.encreptedDetail\" ng-click=\"dnd(\'open\',item, \'Customer\')\" type=\"button\" class=\"btn btn-sm btn-danger\">Mark DND For Customer</button> <button ng-if=\"item.isDNDCustomerMarked ===true && !item.encreptedDetail\" ng-click=\"dnd(\'open\',item, \'Customer\')\" style=\"background-color: lightseagreen;\" type=\"button\" class=\"btn btn-sm btn-success\">Unmark DND For Customer</button> <button ng-if=\"item.isDNDMarked ===false && !item.encreptedDetail\" ng-click=\"dnd(\'open\',item, \'All\')\" type=\"button\" class=\"btn btn-sm btn-danger\">Activate DND</button> <button ng-if=\"item.isDNDMarked ===true\" style=\"background-color: lightseagreen;\" ng-click=\"dnd(\'open\',item, \'All\')\" type=\"button\" class=\"btn btn-sm btn-success\">Deactivate DND</button> <button ng-if=\"item.pacakgeIDs.length>0\" style=\"margin-right: 5px;\" ng-click=\"rescheduleAppointment(\'open\',item)\" type=\"button\" class=\"btn btn-sm btn-primary\">Reschedule</button><button ng-click=\"rescheduleAppointmentFromSAL(item)\" type=\"button\" style=\"margin-right: 5px;\" class=\"btn btn-sm btn-primary\">{{item.requestId ? \'ReSchedule\' : \'Schedule\'}}</button> <button ng-if=\"item.isNotAttendedApplicable\" ng-click=\"openNotAttended(item)\" style=\"margin-right: 5px;\" type=\"button\" class=\"btn btn-sm btn-primary\">Not Attended</button> <button ng-if=\"item.currentStatusId ===40\" ng-click=\"reportPickedup(item,\'open\')\" style=\"margin-right: 5px;\" type=\"button\" class=\"btn btn-sm btn-primary\">Report pickedup</button> <span ng-if=\"item.requestId\"><communication-history-modal requestflowid=\"item.requestId\" isflowreqid=\"\'reqId\'\"><button uib-tooltip=\"communication history\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-comments\"></i></button></communication-history-modal></span> <span ng-if=\"item.esalesId\"><communication-history-modal requestflowid=\"item.esalesId\" isflowreqid=\"\'eSlale\'\"><button uib-tooltip=\"communication history\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-comments\"></i></button></communication-history-modal></span> <span><button ng-click=\"getCorrespondenceData(item)\" data-toggle=\"modal\" data-target=\"#ViewCorresponddenceModal\" uib-tooltip=\"show correspondence\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-eye\"></i></button></span></div></div></div></div><div class=\"panel\" ng-if=\"isMessage\"><div class=\"panel-body\" style=\"color: red;\">No data found.</div></div></form><div class=\"modal fade in\" id=\"notAttended\" tabindex=\"-2\" role=\"dialog\" aria-labelledby=\"ApproveLabel\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: black;\" class=\"modal-title\">Not Attended Applicable</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"notAttendedForm\" action=\"\" class=\"form\"><div class=\"row\"><div ng-class=\"rescheduleJson.reason !== \'Other\' ? \'col-md-12\' : \'col-md-6\'\"><div class=\"form-group\"><label for=\"reason\">Reason *</label><select name=\"Reason\" ng-model=\"rescheduleJson.reason\" class=\"form-control\"><option value=\"\">Select Reason for Not Attended</option><option value=\"Client left abroad, cannot undergo medicals\">Client left abroad, cannot undergo medicals</option><option value=\"Client needs medical in aborad\">Client needs medical in aborad</option><option value=\"Client has under gone medical for prev.policy\">Client has under gone medical for prev.policy</option><option value=\"Client not willing for medicals\">Client not willing for medicals</option><option value=\"Client want to cancel the proposal\">Client want to cancel the proposal</option><option value=\"Client want to cancel the proposal and relogin\">Client want to cancel the proposal and relogin</option><option value=\"Client partly completed medicals\">Client partly completed medicals</option><option value=\"Other\">Other</option></select></div></div><div ng-class=\"rescheduleJson.reason === \'Other\' ? \'col-md-6\' : \'\'\" ng-if=\"rescheduleJson.reason === \'Other\'\"><div class=\"form-group\"><label for=\"reason\">Remark *</label> <textarea id=\"reason\" class=\"form-control\" placeholder=\"Enter remark fro not attended\" ng-model=\"rescheduleJson.notAttendedReason\" required=\"\"></textarea></div></div></div><div class=\"row\"><h3 style=\"margin-left: 2%; color: black;\">Sales/Agent Details</h3><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"reason\">Name *</label> <input id=\"AdditionalName\" class=\"form-control\" type=\"text\" ng-model=\"rescheduleJson.AdditionalName\" name=\"AdditionalName\" placeholder=\"Enter name\" required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"reason\">Phone Number *</label> <input id=\"AdditionalPhoneNumber\" numbers-only=\"numbers-only\" ng-pattern=\"/^((6|7|8|9)).{9}$/\" class=\"form-control\" type=\"text\" ng-model=\"rescheduleJson.AdditionalPhoneNumber\" name=\"AdditionalPhoneNumber\" placeholder=\"Enter phone number\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\"> <span ng-if=\"!notAttendedForm.AdditionalPhoneNumber.$valid && notAttendedForm.AdditionalPhoneNumber.$dirty\" style=\"color: #f00\">moblie number not seems to be valid.</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"reason\">Mail Address *</label> <input id=\"AdditionalMailAddress\" class=\"form-control\" type=\"text\" ng-model=\"rescheduleJson.AdditionalMailAddress\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" name=\"AdditionalMailAddress\" placeholder=\"Enter mail id\" required=\"\"> <span ng-if=\"!notAttendedForm.AdditionalMailAddress.$valid && notAttendedForm.AdditionalMailAddress.$dirty\" style=\"color: #f00\">email address not seems to be valid.</span></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"!rescheduleJson.reason || !rescheduleJson.AdditionalMailAddress ||!rescheduleJson.AdditionalPhoneNumber || !rescheduleJson.AdditionalName\" class=\"btn btn-primary\" ng-click=\"postNotattended(notAttendedRequest)\">Submit</button></div></div></div></div><div class=\"modal fade in\" id=\"dndReason\" tabindex=\"-2\" role=\"dialog\" aria-labelledby=\"ApproveLabel\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Do Not Disturb</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"reason\">Reason *</label> <textarea style=\"resize: vertical;\" id=\"reason\" class=\"form-control\" placeholder=\"Enter reason fro DND\" ng-model=\"rescheduleJson.reason\" required=\"\"></textarea></div><div class=\"form-group\"><label for=\"reason\">Employee ID *</label> <textarea style=\"resize: vertical;\" id=\"reason\" class=\"form-control\" placeholder=\"Enter employeeId\" ng-model=\"rescheduleJson.employeeId\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"!rescheduleJson.reason || !rescheduleJson.employeeId\" class=\"btn btn-primary\" ng-click=\"dnd(\'close\', dndRequest)\">Request DND</button></div></div></div></div><div class=\"modal fade\" id=\"rescheduleAppointment\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Reschedule Appointment</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"rescheduleAppointmentForm\" class=\"form\"><div class=\"row timePickerBox\"><div class=\"col-xs-6\"><label for=\"doa\">Select reschedule date and time</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" date-disabled=\"disabled(date, mode)\" ng-model=\"client.prefDate\" is-open=\"reschedule.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"reschedule()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-2\" style=\"margin-top: -13px;\"><input readonly-input=\"true\" uib-timepicker=\"\" ng-model=\"client.prefTime\" hour-step=\"hstep\" max=\"maxFirst\" min=\"minFirst\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div><div class=\"col-xs-4\" style=\"display: flex; flex-direction: column;\" ng-show=\"isTU\"><label>Preferred Language</label><div class=\"btn-group\" uib-dropdown=\"\" is-open=\"languageDropdownMenu\"><button id=\"split-button\" class=\"btn btn-default\" style=\"min-width: 100px;\" ng-if=\"!prefLang\">Choose</button> <button id=\"split-button\" class=\"btn btn-default\" style=\"min-width: 100px;\" ng-if=\"prefLang\">{{prefLang}}</button> <button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\" style=\"max-height: 150px;overflow-y: scroll;\"><li role=\"menuitem\" ng-repeat=\"lang in languages\" ng-click=\"langSelected(lang)\" style=\"cursor: pointer;\"><a>{{lang}}</a></li></ul></div></div></div><div class=\"row\" ng-if=\"!isTU\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"reason\">Reason *</label> <textarea style=\"resize: vertical;\" id=\"reason\" class=\"form-control\" placeholder=\"Enter reason for reschedule appointment...\" ng-model=\"rescheduleJson.reason\" required=\"\"></textarea></div></div></div><div class=\"row\" ng-if=\"!isTU\"><h3 style=\"margin-left: 2%; color: black;\">Sales/Agent Details</h3><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"reason\">Name *</label> <input id=\"AdditionalName\" class=\"form-control\" type=\"text\" ng-model=\"rescheduleJson.AdditionalName\" name=\"AdditionalName\" placeholder=\"Enter name\" required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"reason\">Phone Number *</label> <input id=\"AdditionalPhoneNumber\" ng-pattern=\"/^((6|7|8|9)).{9}$/\" class=\"form-control\" type=\"text\" ng-model=\"rescheduleJson.AdditionalPhoneNumber\" name=\"AdditionalPhoneNumber\" placeholder=\"Enter phone number\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\"> <span ng-if=\"!rescheduleAppointmentForm.AdditionalPhoneNumber.$valid && rescheduleAppointmentForm.AdditionalPhoneNumber.$dirty\" style=\"color: #f00\">moblie number not seems to be valid.</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"reason\">Mail Address *</label> <input id=\"AdditionalMailAddress\" class=\"form-control\" type=\"text\" ng-model=\"rescheduleJson.AdditionalMailAddress\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" name=\"AdditionalMailAddress\" placeholder=\"Enter mail id\" required=\"\"> <span ng-if=\"!rescheduleAppointmentForm.AdditionalMailAddress.$valid && rescheduleAppointmentForm.AdditionalMailAddress.$dirty\" style=\"color: #f00\">email address not seems to be valid.</span></div></div></div><div class=\"row\" ng-if=\"!isTU\"><div class=\"clearfix\" style=\"margin-bottom: 15px;margin-left:15px;\"><label style=\"display:inline-block; padding-right: 15px;\"><input type=\"checkbox\" ng-model=\"rescheduleJson.visitTypeDC\" ng-change=\"changeVisitType(\'dc\',\'rescheduleAppointment\')\"> Diagnostic centre visit</label> <label style=\"display:inline-block; padding-right: 15px;\"><input type=\"checkbox\" ng-model=\"rescheduleJson.visitTypeHome\" ng-change=\"changeVisitType(\'home\',\'rescheduleAppointment\')\"> Home visit</label></div><div class=\"btn-group col-md-6\" ng-show=\"rescheduleJson.visitTypeDC\"><a class=\"btn btn-sm btn-default\" ng-click=\"DCSelection(\'advance\')\">ADV</a> <a class=\"btn btn-sm btn-primary active\" ng-click=\"DCSelection(\'manual\')\">MAN</a></div><div><h3 style=\"font-size: 15px; font-weight:normal; color:black; margin:6px 0 10px 0; padding-left:17px;\" ng-if=\"client.preferredDC1 && rescheduleJson.visitTypeDC\"><strong>{{client.preferredDC1.entityName}}</strong>,<br><em style=\"font-size:13px;\">{{client.preferredDC1.entityAddress}} - {{client.preferredDC1.pinCode}}</em></h3></div><div class=\"row col-md-12\" style=\"margin-top: 10px; margin-bottom: 10px;\" ng-show=\"rescheduleJson.visitTypeDC && flags.manual\"><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"manualSelectedDC.newStateId\" ng-change=\"loadCitiesNew(manualSelectedDC.newStateId)\"><option value=\"\">Select state</option></select></div><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"manualSelectedDC.newCityId\" ng-change=\"loadLocationsNew(manualSelectedDC.newCityId)\"><option value=\"\">Select city</option></select></div><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"manualSelectedDC.newSubLocationId\" ng-change=\"loadDcForAllPackages(manualSelectedDC.newSubLocationId)\"><option value=\"\">Select locality</option></select></div><div class=\"col-md-3\"><select name=\"preferreddc1\" id=\"firstDCIdPreEmp\" ng-model=\"client.preferredDC1\" class=\"form-control\" ng-options=\"dc as dc.entityName for dc in diagnosticCentres\" ng-change=\"selectedDcFromDropdown(client.preferredDC1)\"><option value=\"\">Select diagnostic centre</option></select></div></div><div class=\"row col-md-12\" ng-if=\"rescheduleJson.visitTypeDC && !markerDetails\" ng-show=\"flags.advance\" style=\"margin-top: 10px; margin-bottom: 30PX;\"><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control\" gm-places-autocomplete=\"\" ng-model=\"locationName.autocomplete\"></div><div class=\"col-sm-6\"><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-change=\"changeDistance(distanceJsonObj.distance,\'Reschedule\')\" ng-options=\"option.value for option in distances track by option.id\" ng-model=\"distanceJsonObj.distance\"><option value=\"\">Select radius</option></select></div></div><h3 style=\"font-size: 15px; font-weight:normal; color:black; margin:6px 0 10px 0; padding-left:17px;\" ng-if=\"markerDetails\"><strong>{{markerDetails.entityName}}</strong>,<br><em style=\"font-size:13px;\">{{markerDetails.entityAddress}} - {{markerDetails.pinCode}}</em></h3><p ng-if=\"markerDetails\" ng-click=\"changeDC()\" style=\"padding-left:17px;\"><a href=\"\" class=\"btn btn-xs btn-primary\">Change</a></p></div><div class=\"row\" ng-if=\"rescheduleJson.visitTypeHome\"><div class=\"col-sm-3\"><label for=\"addressline1\">Home address line 1</label> <input id=\"addressline1\" ng-change=\"setFlagForValidation()\" type=\"text\" class=\"form-control\" ng-model=\"rescheduleJson.addressline1\" placeholder=\"Enter address line 1\"></div><div class=\"col-sm-3\"><label for=\"addressline2\">Home address line 2</label> <input ng-change=\"setFlagForValidation()\" id=\"addressline2\" type=\"text\" class=\"form-control\" ng-model=\"rescheduleJson.addressline2\" placeholder=\"Enter address line 2\"></div><div class=\"col-sm-3\"><label for=\"addressline1\">State</label> <input id=\"addressline1\" ng-change=\"setFlagForValidation()\" type=\"text\" class=\"form-control\" ng-model=\"rescheduleJson.state\" placeholder=\"Enter state\"></div><div class=\"col-sm-3\"><label for=\"addressline1\">City</label> <input id=\"addressline1\" ng-change=\"setFlagForValidation()\" type=\"text\" class=\"form-control\" ng-model=\"rescheduleJson.city\" placeholder=\"Enter city\"></div></div><div class=\"row\" ng-if=\"rescheduleJson.visitTypeHome === false && flags.advance\" style=\"margin-top: 15px; border-radius: 2px; border-color: black;\"><div class=\"col-md-12\"><ui-gmap-google-map center=\"map.center\" control=\"\" zoom=\"map.zoom\" bounds=\"map.bounds\" draggable=\"true\" options=\"map.options\"><ui-gmap-circle center=\"map.center\" stroke=\"map.stroke\" fill=\"map.fill\" radius=\"map.radius\" visible=\"map.visible\" geodesic=\"c.geodesic\" editable=\"c.editable\" draggable=\"map.draggable\" clickable=\"map.clickable\"><ui-gmap-marker models=\"randomMarkers1\" coords=\"map.center\" idkey=\"\"><i class=\"fa fa-user\"></i></ui-gmap-marker><ui-gmap-marker ng-repeat=\"marker in markerArray\" click=\"selectedDcFromMap(marker, $event)\" models=\"randomMarkers\" events=\"map.markersEvents\" coords=\"marker.coords\" idkey=\"marker.id\"><ui-gmap-window options=\"windowOpt\" closeclick=\"map.window.closeClick(marker)\" show=\"marker.visible\" templateurl=\"\'/app/modules/trackStatus/windowContent.html\'\" templateparameter=\"windowParams\"></ui-gmap-window></ui-gmap-marker></ui-gmap-circle></ui-gmap-google-map></div></div><div class=\"row\" ng-if=\"isMarkerArray\"><div class=\"col-md-12 text-center\" style=\"margin-top: 15px; color: red; font-size: 15px;\">{{errorMessage}}</div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-if=\"!isTU\" ng-disabled=\"!rescheduleJson.reason || rescheduleJson.isDisable || !rescheduleJson.AdditionalMailAddress || !rescheduleJson.AdditionalPhoneNumber || !rescheduleJson.AdditionalName\" class=\"btn btn-primary\" ng-click=\"rescheduleAppointment(\'close\',rescheduleAppointmentRequest, markerDetails)\">Reschedule Appointment</button> <button type=\"button\" ng-if=\"isTU\" ng-disabled=\"!client.prefDate || !client.prefTime || !prefLang\" class=\"btn btn-primary\" ng-click=\"rescheduleAppointment(\'close\',rescheduleAppointmentRequest, markerDetails)\">Reschedule Appointment</button></div></div></div></div><div class=\"modal fade\" id=\"reportPickedup\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\" style=\"color: black;\">Report pickedup</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"rescheduleAppointmentForm\" action=\"\" class=\"form\"><div class=\"row timePickerBox\"><div class=\"col-xs-6\"><label for=\"doa\">Attented date and time</label><p class=\"input-group\" style=\"width: 100%;\"><input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" date-disabled=\"disabled(date, mode)\" ng-model=\"actualDate\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"></p></div><div class=\"col-xs-6\"><label for=\"doa\">Actual attended date and time</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" date-disabled=\"disabled(date, mode)\" ng-model=\"client.reportDate\" is-open=\"reschedule.opened\" datepicker-options=\"dateOptionsForPickup\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"reschedule()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"row\"><h3 style=\"margin-left: 2%; color: black;\">Sales/Agent Details</h3><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"reason\">Name *</label> <input id=\"AdditionalName\" class=\"form-control\" type=\"text\" ng-model=\"rescheduleJson.AdditionalName\" name=\"AdditionalName\" placeholder=\"Enter name\" required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"reason\">Phone Number *</label> <input id=\"AdditionalPhoneNumber\" numbers-only=\"numbers-only\" ng-pattern=\"/^((6|7|8|9)).{9}$/\" class=\"form-control\" type=\"text\" ng-model=\"rescheduleJson.AdditionalPhoneNumber\" name=\"AdditionalPhoneNumber\" placeholder=\"Enter phone number\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\"> <span ng-if=\"!notAttendedForm.AdditionalPhoneNumber.$valid && notAttendedForm.AdditionalPhoneNumber.$dirty\" style=\"color: #f00\">moblie number not seems to be valid.</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"reason\">Mail Address *</label> <input id=\"AdditionalMailAddress\" class=\"form-control\" type=\"text\" ng-model=\"rescheduleJson.AdditionalMailAddress\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" name=\"AdditionalMailAddress\" placeholder=\"Enter mail id\" required=\"\"> <span ng-if=\"!notAttendedForm.AdditionalMailAddress.$valid && notAttendedForm.AdditionalMailAddress.$dirty\" style=\"color: #f00\">email address not seems to be valid.</span></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"!rescheduleJson.AdditionalMailAddress ||!rescheduleJson.AdditionalPhoneNumber || !rescheduleJson.AdditionalName\" class=\"btn btn-primary\" ng-click=\"reportPickedup(reportPickedupDetails, \'close\')\">Update</button></div></div></div></div><div class=\"modal fade\" id=\"scheduleAppointment\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\" style=\"color:black\">Schedule Appointment</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"scheduleAppointmentForm\" action=\"\" class=\"form\"><div class=\"row timePickerBox\"><div class=\"col-xs-4\"><label for=\"doa\">Select reschedule date and time</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" date-disabled=\"disabled(date, mode)\" ng-model=\"client.prefDate\" is-open=\"reschedule.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"reschedule()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-4\" style=\"margin-top: -13px;\"><input readonly-input=\"true\" uib-timepicker=\"\" ng-model=\"client.prefTime\" hour-step=\"hstep\" max=\"maxFirst\" min=\"minFirst\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div><div class=\"col-xs-4\" style=\"margin-top: 25px;\"><input ng-model=\"dndCustomer\" type=\"checkbox\"> DND Customer</div></div><div class=\"row\"><h3 style=\"margin-left: 2%; color: black;\">Sales/Agent Details</h3><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"reason\">Name *</label> <input id=\"AdditionalName\" class=\"form-control\" type=\"text\" ng-model=\"rescheduleJson.AdditionalName\" name=\"AdditionalName\" placeholder=\"Enter name\" required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"reason\">Phone Number *</label> <input id=\"AdditionalPhoneNumber\" ng-pattern=\"/^((6|7|8|9)).{9}$/\" class=\"form-control\" type=\"text\" ng-model=\"rescheduleJson.AdditionalPhoneNumber\" name=\"AdditionalPhoneNumber\" placeholder=\"Enter phone number\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\"> <span ng-if=\"!scheduleAppointmentForm.AdditionalPhoneNumber.$valid && scheduleAppointmentForm.AdditionalPhoneNumber.$dirty\" style=\"color: #f00\">moblie number not seems to be valid.</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"reason\">Mail Address *</label> <input id=\"AdditionalMailAddress\" class=\"form-control\" type=\"text\" ng-model=\"rescheduleJson.AdditionalMailAddress\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" name=\"AdditionalMailAddress\" placeholder=\"Enter mail id\" required=\"\"> <span ng-if=\"!scheduleAppointmentForm.AdditionalMailAddress.$valid && scheduleAppointmentForm.AdditionalMailAddress.$dirty\" style=\"color: #f00\">email address not seems to be valid.</span></div></div></div><div class=\"row timePickerBox\" ng-if=\"testnames.length> 0\"><div class=\"col-xs-12\"><label>Test details</label><ol><li ng-repeat=\"test in testnames\"><span>{{test.testName}}<div ng-repeat=\"tests in investigationList\"><h4 style=\"color: cornflowerblue; font-size: 16px;\">{{tests.investigationName}}</h4><ol class=\"m-b-0\"><li ng-repeat=\"tst in tests.testDetails\">{{tst.testName}}</li></ol><p ng-show=\"investigationList.length == 0\" style=\"font-size: 12px; color:red\"><strong>No investigation available for this request</strong></p></div></span></li></ol></div></div><div class=\"clearfix\" style=\"margin-bottom: 15px;\"><label style=\"display:inline-block; padding-right: 15px;\"><input type=\"checkbox\" ng-model=\"rescheduleJson.visitTypeDC\" ng-change=\"changeVisitType(\'dc\',\'scheduleAppointment\')\"> Diagnostic centre visit</label> <label style=\"display:inline-block; padding-right: 15px;\"><input type=\"checkbox\" ng-model=\"rescheduleJson.visitTypeHome\" ng-change=\"changeVisitType(\'home\',\'scheduleAppointment\')\"> Home visit</label></div><h3 style=\"font-size: 15px; font-weight: normal; color: black; margin: 6px 0 10px 0; padding-left:17px;\" ng-if=\"markerDetails\"><strong>{{markerDetails.entityName}}</strong>,<br><em style=\"font-size:13px;\">{{markerDetails.entityAddress}} - {{markerDetails.pinCode}}</em></h3><div><h3 style=\"font-size: 15px; font-weight:normal; color:black; margin:6px 0 10px 0; padding-left:17px;\" ng-if=\"client.preferredDC1 && rescheduleJson.visitTypeDC\"><strong>{{client.preferredDC1.entityName}}</strong>,<br><em style=\"font-size:13px;\">{{client.preferredDC1.entityAddress}} - {{client.preferredDC1.pinCode}}</em></h3></div><p style=\"padding-left:17px;\" ng-if=\"markerDetails\" ng-click=\"changeDC()\"><a href=\"\" class=\"btn btn-xs btn-primary\">Change</a></p><div class=\"row col-md-12\" style=\"margin-top: 30px; margin-bottom: 15px;\" ng-show=\"rescheduleJson.visitTypeDC && flags.manual\"><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"state as state.lookUpValue for state in states\" ng-model=\"manualSelectedDC.newStateId\" ng-change=\"loadCitiesNew(manualSelectedDC.newStateId)\"><option value=\"\">Select state</option></select></div><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"city as city.lookUpValue for city in cities\" ng-model=\"manualSelectedDC.newCityId\" ng-change=\"loadLocationsNew(manualSelectedDC.newCityId)\"><option value=\"\">Select city</option></select></div><div class=\"col-md-3\"><select name=\"\" class=\"form-control\" ng-options=\"sublocation.lookUpId as sublocation.lookUpValue for sublocation in sublocations\" ng-model=\"manualSelectedDC.newSubLocationId\" ng-change=\"loadDcForAllPackages(manualSelectedDC.newSubLocationId)\"><option value=\"\">Select locality</option></select></div><div class=\"col-md-3\"><select name=\"preferreddc1\" id=\"firstDCIdPreEmp\" ng-model=\"client.preferredDC1\" class=\"form-control\" ng-options=\"dc as dc.entityName for dc in diagnosticCentres\" ng-change=\"selectedDcFromDropdown(client.preferredDC1)\"><option value=\"\">Select diagnostic centre</option></select></div></div><div class=\"row\" ng-if=\"rescheduleJson.visitTypeHome\"><div class=\"col-sm-3\"><label for=\"addressline1\">Home address line 1</label> <input id=\"addressline1\" ng-change=\"setFlagForValidation()\" type=\"text\" class=\"form-control\" ng-model=\"rescheduleJson.addressline1\" placeholder=\"Enter address line 1\"></div><div class=\"col-sm-3\"><label for=\"addressline2\">Home address line 2:</label> <input ng-change=\"setFlagForValidation()\" id=\"addressline2\" type=\"text\" class=\"form-control\" ng-model=\"rescheduleJson.addressline2\" placeholder=\"Enter address line 2\"></div><div class=\"col-sm-3\"><label for=\"addressline1\">State</label> <input id=\"addressline1\" ng-change=\"setFlagForValidation()\" type=\"text\" class=\"form-control\" ng-model=\"rescheduleJson.state\" placeholder=\"Enter state\"></div><div class=\"col-sm-3\"><label for=\"addressline1\">City</label> <input id=\"addressline1\" ng-change=\"setFlagForValidation()\" type=\"text\" class=\"form-control\" ng-model=\"rescheduleJson.city\" placeholder=\"Enter city\"></div></div><div class=\"row\" ng-if=\"markerArrayData.length >0\" style=\"margin-top: 15px; border-radius: 2px; border-color: black;\"><div class=\"col-md-12\"><ui-gmap-google-map center=\"map.center\" control=\"\" zoom=\"map.zoom\" bounds=\"map.bounds\" draggable=\"true\" options=\"map.options\"><ui-gmap-circle center=\"map.center\" stroke=\"map.stroke\" fill=\"map.fill\" radius=\"map.radius\" visible=\"map.visible\" geodesic=\"c.geodesic\" editable=\"c.editable\" draggable=\"map.draggable\" clickable=\"map.clickable\"><ui-gmap-marker models=\"randomMarkers1\" coords=\"map.center\" idkey=\"\"><i class=\"fa fa-user\"></i></ui-gmap-marker><ui-gmap-marker ng-repeat=\"marker in markerArrayData\" click=\"selectedDcFromMap(marker, $event)\" models=\"randomMarkers\" events=\"map.markersEvents\" coords=\"marker.coords\" idkey=\"marker.id\"><ui-gmap-window options=\"windowOpt\" closeclick=\"map.window.closeClick(marker)\" show=\"marker.visible\" templateurl=\"\'/app/modules/trackStatus/reScheduleAppointment.html\'\" templateparameter=\"windowParams\"></ui-gmap-window></ui-gmap-marker></ui-gmap-circle></ui-gmap-google-map></div></div><div class=\"row\" ng-if=\"isMarkerArray\"><div class=\"col-md-12 text-center\" style=\"margin-top: 15px; color: red; font-size: 15px;\">{{errorMessage}}</div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!markerDetails && rescheduleJson.isDisable || !rescheduleJson.AdditionalMailAddress ||!rescheduleJson.AdditionalPhoneNumber || !rescheduleJson.AdditionalName\" ng-click=\"scheduleAppointment(\'close\',scheduleAppointmentRequest, markerDetails)\">Schedule Appointment</button></div></div></div></div><div class=\"modal fade\" id=\"ViewCorresponddenceModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Correspondence history</h4></div><div class=\"modal-body\"><div ng-repeat=\"corres in correspondencData track by $index\" ng-if=\"correspondencData.length > 0\"><h4 style=\"text-align: left; margin-left: 20px;\">Correspondence {{$index + 1}}</h4><ul><li>Customer status : <b>{{corres.callStatusValue}}</b></li><li>Comment: <b>{{corres.comment}}</b></li><li>Created on: <b>{{compareDate(corres.createdOn)}}</b></li></ul><hr></div><div ng-if=\"!correspondencData.length>0\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><h4 style=\"color:red\">{{correspondencError}}</h4></div><div class=\"col-md-2\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div></div></div>");
$templateCache.put("app/modules/trackStatus/windowContent.html","<div><h3>{{parameter.list.entityName}}</h3><p>{{parameter.list.entityAddress}} - {{parameter.list.pinCode}}</p><span><button ng-click=\"parameter.doIt(parameter.list,\'reschedule\')\" class=\"btn btn-primary center-block bookApp BookAppointmentBlock\" data-name=\"{{parameter.list.name}}\">Select Provider</button></span></div>");
$templateCache.put("app/modules/unapprovedAppointments/unapprovedcancel.html","<div><angular-tab appointmentlist=\"activeAppointments\" tabname=\"\'Un-approved Cancel Appointments\'\" tabtype=\"\'unApprovedCancelAppointments\'\" callback-fn=\"ctrlFn(getActionName, currentStatusId, actionStatusId, requestId, appointmentDate, secondAppointmentDate, orderItemProductId, item)\"></angular-tab></div><div class=\"modal fade\" id=\"{{actionName}}Modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\" ng-show=\"actionId === 30\">Reschedule this appointment</h4><h4 style=\"color: #005da2;\" class=\"modal-title\" ng-show=\"actionId === 43\">Reject an appointment</h4><h4 style=\"color: #005da2;\" class=\"modal-title\" ng-show=\"actionId === 42\">Reject an appointment</h4></div><div class=\"modal-body\" ng-show=\"actionId === 30\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"rescheduleForm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Current requested Date</label> <input name=\"doa\" id=\"originalDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-5\"><label>Select reschedule Date</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><br><div class=\"alert alert-danger\" role=\"alert\"><button class=\"btn btn-xs btn-primary pull-right\" ng-click=\"useSecondPref(secondPreferredVTime)\" style=\"margin-left:10px;\">Use This</button> Customer has provided {{secondPreferredVTime}} as second preference. We would like you to consider this if possible.</div><span ng-show=\"showChkedOnDcLogin\"><input type=\"checkbox\" ng-model=\"action.showdcselection\"> Check this to select a new Diagnostic Centre</span><div class=\"showdcselection\" ng-show=\"action.showdcselection\"><label for=\"doa\">Select a provider to move this appointment</label><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testStateId\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div><div class=\"col-md-4\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div></div><div class=\"row\"><div class=\"col-md-6 noPdngRt\"><select name=\"\" id=\"sublocalityId\" class=\"form-control\"><option value=\"\">Select a sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div><div class=\"col-md-6\"><select name=\"\" id=\"dcId\" ng-model=\"dcValue\" class=\"form-control\" ng-change=\"changeDc(dcValue)\"><option value=\"\">Select a Diagnostic Centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in diagnosticCentres\">{{dc.entityName}}</option></select></div></div></div><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></form></div><div class=\"modal-body\" ng-show=\"actionId === 43 || actionId === 42\"><form name=\"rejectForm\"><label for=\"enhance-remarks\">Reasons for rejecting appointment: *</label><select class=\"form-control\" ng-model=\"action.cancelReason\" ng-change=\"resetDependencies(action.cancelReason)\" required=\"\"><option value=\"\">select cancellation reason</option><option value=\"{{f}}\" ng-repeat=\"f in reasonOfCancel\">{{f}}</option></select><br><textarea ng-if=\"action.cancelReason==\'Other\'\" name=\"reject-remarks\" ng-model=\"action.cancelComments\" class=\"form-control\" id=\"reject-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your reason to reject the appointment\" required=\"\"></textarea> <span>Appointment that has been rejected won\'t be completely removed from the queue. It has to be accepted by MAHS Operations person in order to permanently cancel it*</span></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"rescheduleForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequestData(\'Reschedule\',$event)\" ng-show=\"actionId === 30\">Request for reschedule</button> <button type=\"button\" ng-disabled=\"rejectForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequestData(\'Cancel\',$event)\" ng-show=\"actionId === 43\">Submit</button> <button type=\"button\" ng-disabled=\"rejectForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequestData(\'MACancel\',$event)\" ng-show=\"actionId === 42\">Submit</button></div></div></div></div>");
$templateCache.put("app/modules/unapprovedAppointments/unapprovedna.html","<div><angular-tab appointmentlist=\"activeAppointments\" tabname=\"\'Unapproved New Appointment\'\" tabtype=\"\'unapprovedNewAppointments\'\"></angular-tab></div><div class=\"modal fade\" id=\"exceptionModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Exception comments</h4></div><div class=\"modal-body\"><div class=\"row\"><form name=\"mgrCmtForm\" action=\"\" class=\"form\"><div class=\"col-md-3\"><label for=\"managerCmnt\">Manager\'s Comment *</label></div><div class=\"col-md-9\"><input name=\"\" class=\"form-control\" type=\"text\" ng-model=\"managerComnt\" required=\"\"></div></form></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"unApprovedActionRequest(true, null, managerComnt)\" ng-disabled=\"mgrCmtForm.$invalid\">Confirm</button> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div>");
$templateCache.put("app/modules/unapprovedAppointments/unapprovedpp.html","<div class=\"claims\"><angular-tab appointmentlist=\"appointmentsData\" tabname=\"\'Active Appointments\'\" tabtype=\"\'ppAppointments\'\"></angular-tab></div><div class=\"modal fade\" id=\"QCApproveModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Approve appointment for payment</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"doa\">Appointment Date *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" readonly=\"\" ng-model=\"visibleDate\" value=\"{{visibleTime}}\"></div><div class=\"col-md-6\"><label for=\"doa\">Doctor Qualification *</label><select required=\"\" ng-model=\"doctorQualificatio\" style=\"padding: 6px 12px; color: #555; background-color: #fff; background-image: none; border-radius: 4px;\"><option value=\"\">Select Qualification</option><option value=\"MMBS\">MBBS</option><option value=\"MD\">MD</option><option value=\"NonMBBS\">Non MBBS</option><option value=\"NonMBBS\">Not applicable</option></select></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"remarks\" required=\"\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"closeModel()\" data-dismiss=\"modal\">Close</button> <button type=\"button\" ng-disabled=\"approveForm.$invalid\" class=\"btn btn-primary\" ng-click=\"unapprovedRequestAction(\'QCApprove\')\">QC Approved</button></div></div></div></div><div class=\"modal fade\" id=\"Raise_IAModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"RaiseIALabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"closeModel()\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Request for more information</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"Raise_IAModalForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" ng-model=\"visibleDate\" value=\"{{visibleTime}}\"><br><label for=\"remarks\">Details about requested information *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"Raise_IAModalForm.$invalid\" class=\"btn btn-primary\" ng-click=\"unapprovedRequestAction(\'Raise_IA\')\">Request</button></div></div></div></div>");
$templateCache.put("app/modules/unapprovedAppointments/unapprovedqc.html","<div class=\"claims\"><div class=\"btn-group pull-right\" role=\"group\" aria-label=\"Download Buttons\" ng-show=\"user.entityType==\'Insurance_Broker\' || user.entityType==\'Insurer\'\"><button data-toggle=\"modal\" data-target=\"#downloadModal\" class=\"btn btn-sm btn-success btn-reload\" ng-click=\"clrModel()\"><i class=\"glyphicon glyphicon-cloud-download\"></i> Download Reports</button></div><form class=\"form-inline\" ng-if=\"contractList.length > 1\"><div class=\"form-group pull-right\" ng-if=\"availableContracts.length> 1\"><label for=\"filter\">Filter contract:</label><select name=\"selectFilter\" id=\"selectFilter\" class=\"form-control\" ng-options=\"option.entityName for option in availableContracts track by option.id\" style=\"margin-right: 5px;\" ng-model=\"selectFilter\" ng-change=\"getQcFilterData(selectFilter)\"></select></div></form><angular-tab appointmentlist=\"qcAppointments\" tabname=\"\'Active Appointments\'\" tabtype=\"\'qcAppointments\'\"></angular-tab><div class=\"modal fade\" id=\"InsurerApproveModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Approve appointment for payment</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Appointment date *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"approveForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'InsurerApprove\',$event)\">Approve for payment</button></div></div></div></div><div class=\"modal fade\" id=\"Raise_IAModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"RaiseIALabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Request for more information</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"Raise_IAModalForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"remarks\">Details about requested information *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"Raise_IAModalForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Raise_IA\',$event)\">Request</button></div></div>UploadExcelPrePolicyOrders</div></div><div class=\"modal fade\" id=\"SubmitModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ReportsLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Bulk upload of requests</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><div class=\"alert alert-danger\" role=\"alert\">Please upload bills and reports appropriately to avoid delay in processing as well as repeated requests for more information</div><form method=\"POST\" action=\"https://api-plus.medibuddy.in/UploadExcelPrePolicyOrders.json\" enctype=\"multipart/form-data\"><div class=\"row\"><div class=\"col-md-6\"><span class=\"strong pull-right\">Attach File</span></div><div class=\"col-md-6\"><input type=\"file\" name=\"filename\" id=\"bills\"></div></div><hr><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <input type=\"submit\" class=\"btn btn-primary\" id=\"fileUploadBtn\"></form></div></div></div></div><div class=\"modal fade\" id=\"downloadModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ReportsLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Bulk download of reports</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"showWarning\"><p>{{warningMsz}}</p></div><div class=\"alert alert-info\" role=\"alert\" ng-if=\"!showWarning\"><p>You can download the reports of specific customers between a given date range.</p></div><div class=\"row\" ng-show=\"localStorageChildren.length > 1\"><div class=\"col-md-12\"><select name=\"\" class=\"form-control\" ng-model=\"contractType\" ng-options=\"contract.entityName for contract in availableContracts\" ng-change=\"changeContract(contractType)\"><option value=\"\">Select Contract</option></select></div></div><br><div class=\"row\"><div class=\"col-md-6\"><div class=\"row\"><div class=\"col-md-7\"><div class=\"input-group\"><input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.startdate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" ng-change=\"getdateLimit(client.startdate)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-5\" style=\"margin-top: -34px; margin-left: -25px;\"><div uib-timepicker=\"\" ng-model=\"times.startPrefTime\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\" ng-change=\"getDateTime(client.startdate, times.startPrefTime, \'start\')\"></div></div></div></div><div class=\"col-md-6\"><div class=\"row\"><div class=\"col-md-7\"><div class=\"input-group\"><input id=\"datetimeSecond\" type=\"text\" readonly=\"\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.enddate\" is-open=\"popup2.opened\" min-date=\"dateOptions.minDate\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\" style=\"margin-top: 0px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-5\" style=\"margin-top: -34px; margin-left: -25px;\"><div uib-timepicker=\"\" ng-model=\"times.endPrefTime\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\" ng-change=\"getDateTime(client.enddate, times.endPrefTime, \'end\')\"></div></div></div></div></div><div class=\"row\"><div class=\"col-md-10\"></div><div class=\"col-md-2\"><button class=\"btn btn-success btn-xs pull-right\" ng-click=\"downloadBulkReports()\">Download</button></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/unapprovedAppointments/unconfirmedorder.html","<div><angular-tab appointmentlist=\"activeAppointments\" tabname=\"\'Un-Confirmed Appointments\'\" tabtype=\"\'unConfirmedOrder\'\"></angular-tab></div><div class=\"modal fade\" id=\"ApproveModal\" tabindex=\"-1\" data-keyboard=\"false\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Confirm an Order</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"confirmForm\" action=\"\" class=\"form\"><div class=\"form-group\"><p>Please click confirm only when,</p><ul><li>Availability is confirmed with the provider.</li><li>Payment link will be sent to the customer as soon as you confirm this order.</li><li>You can still see this order on this page after confirmation with <b>Cancel Order</b> option enabled.</li></ul></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequestModal(true,\'ApproveModal\')\">Confirm</button></div></div></div></div><div class=\"modal fade\" id=\"CancelModal\" tabindex=\"-1\" data-keyboard=\"false\" role=\"dialog\" aria-labelledby=\"BillLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Reject an Order</h4></div><div class=\"modal-body\"><form name=\"rejectForm\">PLease click reject only when,<ul><li>The requested appointment slot is not available in preferred diagnostic centre.</li><li>The patient has requested to cancel his appointment.</li><li>The patient has failed to make a payment even after confirmation.</li></ul></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequestModal(false,\'CancelModal\')\">Reject</button></div></div></div></div>");
$templateCache.put("app/modules/tpaNewAdmission/newAdmission.html","<div><tpa-new-admission dataobj=\"\" source=\"\'newAdmission\'\"></tpa-new-admission></div>");
$templateCache.put("app/modules/unapprovedcancel/unapprovedcancel.html","<div><angular-tab appointmentlist=\"activeAppointments\" tabname=\"\'Un-approved Cancel Appointments\'\" tabtype=\"\'unApprovedCancelAppointments\'\"></angular-tab></div><div class=\"modal fade\" id=\"{{actionName}}Modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\" ng-show=\"actionId === 30\">Reschedule this appointment</h4><h4 style=\"color: #005da2;\" class=\"modal-title\" ng-show=\"actionId === 43\">Reject an appointment</h4><h4 style=\"color: #005da2;\" class=\"modal-title\" ng-show=\"actionId === 42\">Reject an appointment</h4></div><div class=\"modal-body\" ng-show=\"actionId === 30\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"rescheduleForm\" action=\"\" class=\"form\"><div class=\"row\"><div class=\"col-md-5 noPdngRt\"><div class=\"form-group\"><label for=\"doa\">Current requested Date</label> <input name=\"doa\" id=\"originalDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"></div></div><div class=\"col-md-5\"><label>Select reschedule Date</label><p style=\"margin-top: 37px;\" class=\"input-group\"><input style=\"margin-top: -38px;\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.prefDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\" style=\"margin-top: -61px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><div style=\"margin-top: -13px; margin-left: -28px;\" uib-timepicker=\"\" ng-model=\"client.prefTime\" max=\"maxFirst\" min=\"minFirst\" ng-change=\"changedFirst()\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\"></div></div></div><br><div class=\"alert alert-danger\" role=\"alert\"><button class=\"btn btn-xs btn-primary pull-right\" ng-click=\"useSecondPref(secondPreferredVTime)\" style=\"margin-left:10px;\">Use This</button> Customer has provided {{secondPreferredVTime}} as second preference. We would like you to consider this if possible.</div><span ng-show=\"showChkedOnDcLogin\"><input type=\"checkbox\" ng-model=\"action.showdcselection\"> Check this to select a new Diagnostic Centre</span><div class=\"showdcselection\" ng-show=\"action.showdcselection\"><label for=\"doa\">Select a provider to move this appointment</label><div class=\"row\" style=\"margin-bottom:5px;\"><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testStateId\" ng-change=\"loadLocationData(\'city\',testData.testStateId)\"><option value=\"\">Select a state</option><option value=\"{{state.lookUpId}}\" ng-repeat=\"state in states\">{{state.lookUpValue}}</option></select></div><div class=\"col-md-4 noPdngRt\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testCityId\" ng-change=\"loadLocationData(\'locality\',testData.testCityId)\"><option value=\"\">Select a city</option><option value=\"{{city.lookUpId}}\" ng-repeat=\"city in cities\">{{city.lookUpValue}}</option></select></div><div class=\"col-md-4\"><select name=\"\" class=\"form-control\" ng-model=\"testData.testLocalityId\" ng-change=\"loadLocationData(\'sublocality\',testData.testLocalityId)\"><option value=\"\">Select a locality</option><option value=\"{{location.lookUpId}}\" ng-repeat=\"location in locations\">{{location.lookUpValue}}</option></select></div></div><div class=\"row\"><div class=\"col-md-6 noPdngRt\"><select name=\"\" id=\"sublocalityId\" class=\"form-control\"><option value=\"\">Select a sub locality</option><option value=\"{{sublocation.lookUpId}}\" ng-repeat=\"sublocation in sublocations\">{{sublocation.lookUpValue}}</option></select></div><div class=\"col-md-6\"><select name=\"\" id=\"dcId\" ng-model=\"dcValue\" class=\"form-control\" ng-change=\"changeDc(dcValue)\"><option value=\"\">Select a Diagnostic Centre</option><option value=\"{{dc.id}}\" ng-repeat=\"dc in diagnosticCentres\">{{dc.entityName}}</option></select></div></div></div><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></form></div><div class=\"modal-body\" ng-show=\"actionId === 43 || actionId === 42\"><form name=\"rejectForm\"><label for=\"enhance-remarks\">Reasons for rejecting appointment: *</label><select class=\"form-control\" ng-model=\"action.cancelReason\" ng-change=\"resetDependencies(action.cancelReason)\" required=\"\"><option value=\"\">select cancellation reason</option><option value=\"{{f}}\" ng-repeat=\"f in reasonOfCancel\">{{f}}</option></select><br><textarea ng-if=\"action.cancelReason==\'Other\'\" name=\"reject-remarks\" ng-model=\"action.cancelComments\" class=\"form-control\" id=\"reject-remarks\" cols=\"30\" rows=\"5\" placeholder=\"Please enter your reason to reject the appointment\" required=\"\"></textarea> <span>Appointment that has been rejected won\'t be completely removed from the queue. It has to be accepted by MAHS Operations person in order to permanently cancel it*</span></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"rescheduleForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionOnRequestMethods.actionRequest(\'Reschedule\',$event)\" ng-show=\"actionId === 30\">Request for reschedule</button> <button type=\"button\" ng-disabled=\"rejectForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionOnRequestMethods.actionRequest(\'Cancel\',$event)\" ng-show=\"actionId === 43\">Submit</button> <button type=\"button\" ng-disabled=\"rejectForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionOnRequestMethods.actionRequest(\'MACancel\',$event)\" ng-show=\"actionId === 42\">Submit</button></div></div></div></div>");
$templateCache.put("app/modules/unapprovedna/unapprovedna.html","<div><angular-tab appointmentlist=\"activeAppointments\" tabname=\"\'Unapproved New Appointment\'\" tabtype=\"\'unapprovedNewAppointments\'\"></angular-tab></div><div class=\"modal fade\" id=\"exceptionModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Exception comments</h4></div><div class=\"modal-body\"><div class=\"row\"><form name=\"mgrCmtForm\" action=\"\" class=\"form\"><div class=\"col-md-3\"><label for=\"managerCmnt\">Manager\'s Comment *</label></div><div class=\"col-md-9\"><input name=\"\" class=\"form-control\" type=\"text\" ng-model=\"managerComnt\" required=\"\"></div></form></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"unApprovedActionRequest(true, null, managerComnt)\" ng-disabled=\"mgrCmtForm.$invalid\">Confirm</button> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div>");
$templateCache.put("app/modules/unapprovedpp/unapprovedpp.html","<div class=\"claims\"><div><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"status.isFirstOpen\"><uib-accordion-heading><a style=\"color: #168cc9;\">Search panel</a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isFirstOpen, \'glyphicon-chevron-right\': !status.isFirstOpen}\"></i></uib-accordion-heading><ng-form block-ui=\"searchAppointmentsData\" name=\"userProfileForm\" class=\"form-horizontal\"><div id=\"user-profile\" class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"\" class=\"control-label required-field col-sm-4\">Date type</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"serverSearch.sortBy\"><option value=\"\">Select sort order</option><option value=\"attendeddate\">Attended date</option><option value=\"reportuploaddate\">Report upload date</option></select></div></div><div class=\"form-group\"><label for=\"\" class=\"control-label required-field col-sm-4\">Branch</label><div class=\"col-sm-8\"><select class=\"form-control\" ng-model=\"serverSearch.branch\"><option value=\"\">Select branch</option><option value=\"1\">Ahmedabad</option><option value=\"3\">Indore</option><option value=\"4\">Bhubaneshwar</option><option value=\"5\">Chandigarh</option><option value=\"6\">Chennai</option><option value=\"7\">Cochin</option><option value=\"8\">Delhi</option><option value=\"9\">Guwahati</option><option value=\"10\">Hyderabad</option><option value=\"11\">Jaipur</option><option value=\"12\">Kolkata</option><option value=\"13\">Lucknow</option><option value=\"14\">Mumbai</option><option value=\"15\">Patna</option><option value=\"17\">Jamshedpur</option><option value=\"19\">Pune</option><option value=\"20\">Bangalore</option></select></div></div><div class=\"form-group\"><label for=\"\" class=\"control-label required-field col-sm-4\">Appointment type</label><div class=\"col-sm-8\"><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-change=\"getCorporatePackages(serverSearch.contractType.id)\" ng-options=\"option.entityName for option in contracts track by option.id\" ng-model=\"serverSearch.contractType\"></select></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"\" class=\"control-label required-field col-sm-4\">Employee id</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" name=\"employeeId\" placeholder=\"Enter employee id\" ng-model=\"serverSearch.employeeId\"></div></div><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Date from</label><div class=\"col-sm-8\"><div class=\"input-group\"><input id=\"datetimeEnd\" placeholder=\"Select to date\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"serverSearch.fromDate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group\"><label for=\"\" class=\"control-label required-field col-sm-4\">Corporate</label><div class=\"col-sm-8\"><select name=\"statusSearch\" id=\"statusSearch\" class=\"form-control\" ng-options=\"option.entityName for option in contractsData track by option.id\" ng-model=\"serverSearch.corporateId\"></select></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"\" class=\"control-label required-field col-sm-4\">Request id</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" name=\"requestId\" placeholder=\"Enter request id\" ng-model=\"serverSearch.requestId\"></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"first-name\" class=\"control-label required-field col-sm-4\">Date to</label><div class=\"col-sm-8\"><div class=\"input-group\"><input id=\"datetimeEnd\" placeholder=\"Select to date\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"serverSearch.toDate\" is-open=\"popup2.opened\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group\"><label for=\"city\" class=\"control-label required-field col-sm-4\"></label><div class=\"col-sm-8\"><button class=\"btn btn-primary\" ng-model=\"search\" ng-click=\"loadAppointments();\">Search</button> <button class=\"btn primary\" ng-click=\"clearSearch()\">Clear</button></div></div></div></div></ng-form></div></uib-accordion></div><angular-tab appointmentlist=\"appointmentsData\" tabname=\"\'Active Appointments\'\" tabtype=\"\'ppAppointments\'\"></angular-tab></div><div class=\"modal fade\" id=\"QCApproveModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Approve appointment by QC</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"doa\">Appointment Date *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" readonly=\"\" ng-model=\"visibleDate\" value=\"{{visibleTime}}\"></div><div class=\"col-md-6\"><label for=\"doa\">Actual Appointment Date</label><div class=\"input-group\"><input placeholder=\"Select from date\" id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"popupQc.actualDate\" is-open=\"popupQc.opened\" datepicker-options=\"dateOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openQcDate()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-6\"><label for=\"doa\">Doctor Qualification *</label><select required=\"\" ng-model=\"doctorQualificatio\" style=\"padding: 6px 12px; color: #555; background-color: #fff; background-image: none; border-radius: 4px;\"><option value=\"\">Select Qualification</option><option value=\"MMBS\">MBBS</option><option value=\"MD\">MD</option><option value=\"NonMBBS\">Non MBBS</option><option value=\"NonMBBS\">Not applicable</option></select></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"remarks\" required=\"\"></textarea></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"remarks\">Photograph available</label><br><input type=\"radio\" ng-model=\"isPhotoAvailble.value\" value=\"true\">Yes <input type=\"radio\" ng-model=\"isPhotoAvailble.value\" value=\"false\">No</div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"closeModel()\" data-dismiss=\"modal\">Close</button> <button type=\"button\" ng-disabled=\"approveForm.$invalid\" class=\"btn btn-primary\" ng-click=\"unapprovedRequestAction(\'QCApprove\')\">QC Approved</button></div></div></div></div><div class=\"modal fade\" id=\"Raise_IAModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"RaiseIALabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"closeModel()\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Request for more information</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"Raise_IAModalForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" ng-model=\"visibleDate\" value=\"{{visibleTime}}\"><br><label for=\"remarks\">Details about requested information *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"Raise_IAModalForm.$invalid\" class=\"btn btn-primary\" ng-click=\"unapprovedRequestAction(\'Raise_IA\')\">Request</button></div></div></div></div>");
$templateCache.put("app/modules/unapprovedqc/unapprovedqc.html","<div ng-if=\"!isPolicyBazar\"><div class=\"panel panel-default\"><div class=\"panel-heading\" ng-click=\"showCard ? showCard = false : showCard = true\"><a style=\"color: #168cc9;\"><i class=\"fa fa-filter pull-left\"></i> Date Filter</a> <i style=\"color: #168cc9;\" class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': showCard, \'glyphicon-chevron-right\': !showCard}\"></i></div><div class=\"panel-body\" ng-show=\"showCard\"><div class=\"row\"><div class=\"col-md-3 p-l-1 p-r-0\"><div class=\"input-group\"><input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"dateSearch.fromDate\" is-open=\"popup5.opened\" datepicker-options=\"dateDefautOptions\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" ng-change=\"setMinDate(dateSearch.fromDate)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open5()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-3 p-l-1 p-r-0\"><div class=\"input-group\"><input id=\"\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"dateSearch.toDate\" is-open=\"popup6.opened\" datepicker-options=\"dateDefautOptions\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" min-date=\"mindate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open6()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-3 p-l-1 p-r-1\"><select class=\"form-control\" ng-model=\"dateSearch.dateWiseSearch\"><option value=\"apptdate\">Appointment date</option><option value=\"createddate\">Creation date</option></select></div><div class=\"col-md-3 p-l-1 p-r-1\"><button class=\"btn btn-success\" ng-click=\"loadUnapprovedQCRequests(\'\', \'\', dateSearch)\">Search</button></div></div></div></div><div class=\"claims\"><div class=\"btn-group pull-right\" role=\"group\" aria-label=\"Download Buttons\" ng-show=\"user.entityType==\'Insurance_Broker\' || user.entityType==\'Insurer\'\"><button data-toggle=\"modal\" data-target=\"#downloadModal\" class=\"btn btn-sm btn-success btn-reload\" ng-click=\"clrModel()\"><i class=\"glyphicon glyphicon-cloud-download\"></i> Download Reports</button></div><form class=\"form-inline\" ng-if=\"contractList.length > 1\"><div class=\"form-group pull-right\" ng-if=\"availableContracts.length> 1\"><label for=\"filter\">Filter contract:</label><select name=\"selectFilter\" id=\"selectFilter\" class=\"form-control\" ng-options=\"option.entityName for option in availableContracts track by option.id\" style=\"margin-right: 5px;\" ng-model=\"selectFilter\" ng-change=\"getQcFilterData(selectFilter)\"></select></div></form><angular-tab appointmentlist=\"qcAppointments\" tabname=\"\'Active Appointments\'\" tabtype=\"\'qcAppointments\'\"></angular-tab><div class=\"modal fade\" id=\"InsurerApproveModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Approve appointment for payment</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"approveForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Appointment date *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"remarks\">Remarks *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"approveForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'InsurerApprove\',$event)\">Approve for payment</button></div></div></div></div><div class=\"modal fade\" id=\"Raise_IAModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"RaiseIALabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"closeModel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Request for more information</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"Raise_IAModalForm\" action=\"\" class=\"form\"><div class=\"form-group\"><label for=\"doa\">Requested date of visit *</label> <input name=\"date\" id=\"confirmDate\" class=\"form-control\" type=\"text\" readonly=\"\" value=\"{{action.visibleTime}}\"><br><label for=\"\">Category of rejection</label><select class=\"form-control\" ng-model=\"action.cancelCategory\"><option value=\"\">select rejection category</option><option value=\"scanning issue\">Scanning issue</option><option value=\"missing report\">Missing report</option><option value=\"missout in MER\">Missout in MER</option><option value=\"parameters missing\">Parameters missing</option><option value=\"DC clearification\">DC clearification</option><option value=\"FOI missing\">FOI missing</option><option value=\"others\">Others</option></select><label for=\"remarks\">Details about requested information *</label> <textarea name=\"\" id=\"remarks\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"action.remarks\" required=\"\"></textarea></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"closeModel()\">Close</button> <button type=\"button\" ng-disabled=\"Raise_IAModalForm.$invalid\" class=\"btn btn-primary\" ng-click=\"actionRequest(\'Raise_IA\',$event)\">Request</button></div></div>UploadExcelPrePolicyOrders</div></div><div class=\"modal fade\" id=\"SubmitModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ReportsLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Bulk upload of requests</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><div class=\"alert alert-danger\" role=\"alert\">Please upload bills and reports appropriately to avoid delay in processing as well as repeated requests for more information</div><form method=\"POST\" action=\"https://api-plus.medibuddy.in/UploadExcelPrePolicyOrders.json\" enctype=\"multipart/form-data\"><div class=\"row\"><div class=\"col-md-6\"><span class=\"strong pull-right\">Attach File</span></div><div class=\"col-md-6\"><input type=\"file\" name=\"filename\" id=\"bills\"></div></div><hr><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <input type=\"submit\" class=\"btn btn-primary\" id=\"fileUploadBtn\"></form></div></div></div></div><div class=\"modal fade\" id=\"downloadModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ReportsLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Bulk download of reports</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"showWarning\"><p>{{warningMsz}}</p></div><div class=\"alert alert-info\" role=\"alert\" ng-if=\"!showWarning\"><p>You can download the reports of specific customers between a given date range.</p><p>For time range select date first</p></div><div class=\"row\" ng-show=\"localStorageChildren.length > 1\"><div class=\"col-md-12\"><select name=\"\" class=\"form-control\" ng-model=\"contractType\" ng-options=\"contract.entityName for contract in availableContracts\" ng-change=\"changeContract(contractType)\"><option value=\"\">Select Contract</option></select></div></div><br><div class=\"row\"><div class=\"col-md-6\"><div class=\"row\"><div class=\"col-md-7\"><div class=\"input-group\"><input id=\"datetimeFirst\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.startdate\" is-open=\"popup1.opened\" datepicker-options=\"dateOptionsSt\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" ng-change=\"getdateLimit(client.startdate)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-5\" style=\"margin-top: -34px; margin-left: -25px;\"><div uib-timepicker=\"\" ng-model=\"times.startPrefTime\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\" ng-disabled=\"!client.startdate\"></div></div></div></div><div class=\"col-md-6\"><div class=\"row\"><div class=\"col-md-7\"><div class=\"input-group\"><input id=\"datetimeSecond\" type=\"text\" readonly=\"\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"client.enddate\" is-open=\"popup2.opened\" min-date=\"dateOptions.minDate\" datepicker-options=\"dateOptions\" required=\"\" show-button-bar=\"false\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open2()\" style=\"margin-top: 0px;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-5\" style=\"margin-top: -34px; margin-left: -25px;\"><div uib-timepicker=\"\" ng-model=\"times.endPrefTime\" hour-step=\"hstep\" minute-step=\"mstep\" show-meridian=\"ismeridian\" ng-disabled=\"!client.enddate\"></div></div></div></div></div><div class=\"row\"><div class=\"col-md-10\"></div><div class=\"col-md-2\"><button class=\"btn btn-success btn-xs pull-right\" ng-click=\"downloadBulkReports()\">Download</button></div></div></div></div></div></div></div></div><div class=\"text-center\" ng-if=\"isPolicyBazar\">You are not authorised to view this page.</div>");
$templateCache.put("app/modules/userManage/usermanage.html","<style>\n    form.add-user {\n        width: 400px;\n        margin: 0 auto;\n    }\n</style><div class=\"usermanagement\"><div class=\"row\"><div class=\"col-md-3\"><h3 style=\"margin:0 0 20px 0\">Registered Users ({{userCount}})</h3></div><div class=\"col-md-9\"><button data-toggle=\"modal\" data-target=\"#addUserModal\" class=\"btn btn-primary\" ng-if=\"isAddUser\"><span class=\"glyphicon glyphicon-plus\"></span> Create User</button></div></div><div id=\"myTabContent\" class=\"tab-content\"><div class=\"tab-pane fade in active\" id=\"users\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div><table class=\"table table-hover table-link\"><thead><tr><th class=\"patientName text-left\">Login id</th><th class=\"patientName text-left\">Full name</th><th class=\"patientName text-left\">Email</th><th class=\"patientName text-left\">Role</th><th class=\"patientName text-left\">Status</th><th class=\"text-right\" ng-show=\"isAddUser\">Actions</th></tr></thead><tbody><tr ng-repeat=\"userRow in data.users | orderBy:\'userId\'\"><td>{{userRow.userName}}</td><td>{{userRow.firstName}} {{userRow.lastName}}</td><td ng-if=\"!userRow.editing\"><span ng-show=\"userRow.userEmail\">{{userRow.userEmail}}</span> <span ng-show=\"!userRow.userEmail\">No EmailID</span></td><td ng-if=\"!userRow.editing\">{{userRow.role}}</td><td ng-if=\"!userRow.editing\">{{userRow.isActive?\"Active\":\"InActive\"}}</td><td ng-if=\"userRow.editing\"><input type=\"text\" ng-model=\"update.userEmail\" class=\"form-control\" value=\"{{userRow.userEmail}}\"></td><td ng-if=\"userRow.role !== \'Admin\' || numberOfAdmin.length > 1\" ng-show=\"userRow.editing\"><div ng-dropdown-multiselect=\"\" options=\"newRoles\" selected-model=\"userRow.userRoles\"></div></td><td style=\"width: 15%\" ng-if=\"userRow.editing\"><select class=\"form-control\" name=\"update-status\" id=\"update-status\" ng-model=\"update.updateStatus\"><option value=\"\">Select</option><option value=\"true\">Active</option><option value=\"false\">Inactive</option></select></td><td style=\"width: 15%\" class=\"text-right\" ng-show=\"isAddUser\"><div class=\"btn-group\" ng-if=\"userRow.editing\"><button style=\"margin-left: -14px;\" type=\"button\" class=\"btn btn-success\" ng-if=\"userRow.editing\" ng-disabled=\"userRow.userRoles.length === 0\" ng-click=\"updateUser(userRow, $event)\"><span class=\"glyphicon glyphicon-edit\"></span> update</button> <button type=\"button\" class=\"btn btn-warning\" ng-click=\"closeEdit(userRow,$index)\"><span class=\"glyphicon glyphicon-remove\"></span> cancel</button></div><div class=\"btn-group\" ng-if=\"!userRow.editing\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"editUser(userRow,$index)\"><span class=\"glyphicon glyphicon-edit\"></span> edit</button></div></td></tr></tbody></table></div></div></div><div class=\"modal fade\" id=\"addUserModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 class=\"modal-title\">Create User</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"isError\">{{errorText}}</div><form name=\"addUserForm\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"emailid\">Email id</label> <input type=\"email\" name=\"userMailIds\" ng-maxlength=\"100\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" class=\"form-control\" id=\"userMailIds\" ng-model=\"newuser.emailid\" required=\"\" placeholder=\"Enter your email\"></div><span ng-if=\"!addUserForm.userMailIds.$valid && addUserForm.userMailIds.$dirty\" style=\"color: rgb(255, 0, 0);font-size: small;\">Email address not seems to be valid.</span></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"username\"></label>(<span style=\"color:green\"><small>Your email id will be your login id</small></span>) <input style=\"margin-top: 5px;\" name=\"username\" type=\"text\" class=\"form-control\" id=\"username\" ng-model=\"newuser.emailid\" placeholder=\"Your login id\" readonly=\"\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"firstname\">First name</label> <input type=\"text\" name=\"firstname\" class=\"form-control\" id=\"firstname\" ng-model=\"newuser.firstname\" placeholder=\"Enter first name\" required=\"\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"lastname\">Last name</label> <input type=\"text\" name=\"lastname\" class=\"form-control\" id=\"lastname\" ng-model=\"newuser.lastname\" placeholder=\"Enter last name\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"password\">Password</label> <input type=\"password\" name=\"newPassword\" class=\"form-control\" id=\"newPassword\" ng-model=\"newuser.password\" placeholder=\"Enter new password\" required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"confirm-password\">Confirm password</label> <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" id=\"confirmPassword\" ng-model=\"newuser.confirmpassword\" placeholder=\"Confirm new password\" required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"role\">Select role</label><div ng-dropdown-multiselect=\"\" options=\"newRoles\" selected-model=\"selectedRolesForAdd\"></div></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!(selectedRolesForAdd.length > 0) || addUserForm.$invalid\" ng-click=\"addUser()\">Create</button></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/unconfirmedorder/unconfirmedorder.html","<div><angular-tab appointmentlist=\"activeAppointments\" tabname=\"\'Un-Confirmed Appointments\'\" tabtype=\"\'unConfirmedOrder\'\"></angular-tab></div><div class=\"modal fade\" id=\"ApproveModal\" tabindex=\"-1\" data-keyboard=\"false\" role=\"dialog\" aria-labelledby=\"ApproveLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Confirm an Order</h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" role=\"alert\" id=\"addUserMessage\" style=\"display:none\"></div><form name=\"confirmForm\" action=\"\" class=\"form\"><div class=\"form-group\"><p>Please click confirm only when,</p><ul><li>Availability is confirmed with the provider.</li><li>Payment link will be sent to the customer as soon as you confirm this order.</li><li>You can still see this order on this page after confirmation with <b>Cancel Order</b> option enabled.</li></ul></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequestModal(true,\'ApproveModal\')\">Confirm</button></div></div></div></div><div class=\"modal fade\" id=\"CancelModal\" tabindex=\"-1\" data-keyboard=\"false\" role=\"dialog\" aria-labelledby=\"BillLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h4 style=\"color: #005da2;\" class=\"modal-title\">Reject an Order</h4></div><div class=\"modal-body\"><form name=\"rejectForm\">PLease click reject only when,<ul><li>The requested appointment slot is not available in preferred diagnostic centre.</li><li>The patient has requested to cancel his appointment.</li><li>The patient has failed to make a payment even after confirmation.</li></ul></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"actionRequestModal(false,\'CancelModal\')\">Reject</button></div></div></div></div>");
$templateCache.put("app/modules/walkInCashless/walkInCashless.html","<style>\n	.show-print {\n		display: none;\n	}\n\n	@media print {\n		body {\n			overflow: auto;\n		}\n\n		.show-print {\n			display: block;\n		}\n\n		.left-nav,\n		.header,\n		.print-hide {\n			display: none;\n		}\n\n		.content-wrap {\n			padding: 0;\n		}\n\n		.scrolable {\n			overflow: auto;\n			height: auto !important\n		}\n	}\n</style><div block-ui=\"walkInCashlessService\"><div class=\"walkin-cashless\" ng-if=\"(hospDetails.availableServices.healthChecks == true || hospDetails.availableServices.consultation == true || hospDetails.availableServices.labTest == true) && serviceCallFinish\"><div class=\"wc-header clearfix\" ng-if=\"choosePacakageSelected && !isOrderCreated && (serviceSelected == (\'health_check\') || (\'consultation\') || (\'labTest\'))\"><label class=\"package selected {{((customerDetailsObj.otpSent)? \'disabled\' : \'\')}}\" ng-if=\"choosePacakageSelected && serviceSelected == \'health_check\'\"><input type=\"radio\" name=\"product\" class=\"card-input-element\" ng-disabled=\"customerDetailsObj.otpSent\"><div class=\"sel-label\">Selected Package</div>{{packageSelected.packageValue.packageName}} <small>Tests: {{packageSelected.packageValue.packageTestCount}}, Consultation: {{packageSelected.packageValue.packageConsultationCount}} | Rs.{{packageSelected.packageValue.price}}</small> <i ng-if=\"!customerDetailsObj.otpSent\" ng-click=\"selectedPackageClickedAgain()\">Change Package</i></label> <label class=\"doctor selected {{((customerDetailsObj.otpSent) ? \'disabled\' : \'\')}}\" ng-if=\"choosePacakageSelected && serviceSelected == \'consultation\'\"><input type=\"radio\" name=\"product\" class=\"card-input-element\" ng-disabled=\"customerDetailsObj.otpSent\"><div class=\"sel-label\">Selected Doctor</div>Dr. {{packageSelected.packageValue.doctorName}} <small>{{packageSelected.packageValue.doctorSpecialization}} | Rs. {{packageSelected.packageValue.price}}</small> <i ng-if=\"!customerDetailsObj.otpSent\" ng-click=\"selectedPackageClickedAgain()\">Change Doctor</i></label> <label class=\"labTest selected {{((customerDetailsObj.otpSent) ? \'disabled\' : \'\')}}\" ng-if=\"choosePacakageSelected && serviceSelected == \'labTest\'\"><input type=\"radio\" name=\"product\" class=\"card-input-element\" ng-disabled=\"customerDetailsObj.otpSent\"><div class=\"sel-label\">Selected Lab Test - {{selectedLabTestPackages.length}}</div><div class=\"elipse-width\"><span ng-repeat=\"investigationPack in selectedLabTestPackages track by $index\">{{investigationPack.packageName}},</span> <small>Rs.{{totalAmount}}</small></div><i ng-if=\"!customerDetailsObj.otpSent\" ng-click=\"selectedPackageClickedAgain()\">Change Package</i></label> <label class=\"time selected\" ng-if=\"choosePacakageSelected && timeSelectedShow\"><div class=\"sel-label\">Preferred Time</div>{{packageSelected.time}}, {{packageSelected.date}}<small></small> <i ng-if=\"!checkoutCalled\" ng-click=\"appointmentCardClicked()\">Change Timings</i></label> <label class=\"benef selected\" ng-if=\"verified.patientSelected && checkoutCalled\"><div class=\"sel-label\">Selected Patient</div>{{patientDetails.patientName}} <small ng-if=\"patientDetails.relation\">{{patientDetails.relation}},</small> <small ng-if=\"patientDetails.age\">{{patientDetails.age}} Yrs</small> <small ng-if=\"patientDetails.gender\">{{patientDetails.gender==\'M\'?\'Male\':patientDetails.gender==\'F\'?\'Female\':\'\'}},</small> <small ng-if=\"patientDetails.maid\">Member ID: {{patientDetails.maid}}</small></label></div><div class=\"bookpackage-step-two\" ng-if=\"!checkoutCalled && !isOrderCreated\"><div ng-if=\"!choosePacakageSelected && providerServicesCalled\"><div class=\"service-tabs\"><h4 style=\"font-size:30px; margin: 0 0 15px 0;\">Book cashless services</h4><h4 style=\"font-size:22px; margin: 30px 0 15px 0;\">Choose service</h4><a class=\"{{((serviceSelected == \'health_check\') ? \'selected\' : \'\')}}\" ng-if=\"hospDetails.availableServices.healthChecks\" ng-click=\"selectService(\'health_check\')\"><div class=\"icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"716 -421 32 32\"><g transform=\"translate(715.994 -421)\"><path class=\"c1\" d=\"M2.75,18.715H6.4l2.838-6.72a.587.587,0,0,1,1.1.027L13.5,20.443l2.39-4.624a.592.592,0,0,1,.533-.331.581.581,0,0,1,.533.315l1.014,1.829L20.054,6.965a.6.6,0,0,1,.6-.533.619.619,0,0,1,.576.533L22.95,18.7h6.316a15.753,15.753,0,0,0,2.416-5.552,10.558,10.558,0,0,0,.272-3.627C31.475,4.011,27.853,0,23.3,0a8.444,8.444,0,0,0-7,3.963.427.427,0,0,1-.752,0A8.076,8.076,0,0,0,8.708,0C4.158,0,.536,4.011.056,9.536a10.569,10.569,0,0,0,.272,3.621A15.8,15.8,0,0,0,2.75,18.715Z\" transform=\"translate(0)\"></path><path class=\"c2\" d=\"M25.67,29.339a.613.613,0,0,1-.592-.533L23.792,20l-1.734,8.853a.624.624,0,0,1-.491.507.587.587,0,0,1-.608-.293l-1.264-2.3L17.2,31.589a.6.6,0,0,1-.533.331h-.037a.608.608,0,0,1-.533-.405l-3.062-8.277L10.622,28.96a.6.6,0,0,1-.533.379H7c.325.384.661.757,1.024,1.109L19.173,41.333,30.513,30.448c.363-.352.7-.725,1.024-1.109Z\" transform=\"translate(-3.263 -9.333)\"></path></g></svg></div><h2>Health check</h2></a> <a class=\"{{((serviceSelected == \'consultation\') ? \'selected\' : \'\')}}\" ng-if=\"hospDetails.availableServices.consultation\" ng-click=\"selectService(\'consultation\')\"><div class=\"icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"824 -421 32 32\"><g transform=\"translate(824 -421)\"><path class=\"c1\" d=\"M8.285,0A2.635,2.635,0,0,0,6.265.977,6.664,6.664,0,0,0,2.123,2.624,6.136,6.136,0,0,0,0,7.768a27.3,27.3,0,0,0,.828,6.379l.1.514,3-.823-.155-.463a25.252,25.252,0,0,1-.828-5.608,3.163,3.163,0,0,1,1.139-2.83l.052-.051a4.3,4.3,0,0,1,2.278-.926,2.083,2.083,0,0,0,1.812.875,2.3,2.3,0,0,0,2.434-2.418A2.236,2.236,0,0,0,8.285,0Z\"></path><path class=\"c1\" d=\"M32.4,2.924a6.973,6.973,0,0,0-4.142-1.646A2.558,2.558,0,0,0,26.234.3,2.42,2.42,0,0,0,23.8,2.718a2.3,2.3,0,0,0,2.434,2.418A2.15,2.15,0,0,0,28.1,4.21a4.277,4.277,0,0,1,2.278,1.029,3.163,3.163,0,0,1,1.139,2.83,21.6,21.6,0,0,1-.673,5.4l-.1.514,2.9.617.1-.463a24,24,0,0,0,.777-6.019A6.632,6.632,0,0,0,32.4,2.924Z\" transform=\"translate(-11.476 -0.146)\"></path><path class=\"c2\" d=\"M28.867,35.757H28.66c-.57-2.212-1.864-3.447-3.676-3.447-3.521,0-4.142,3.293-4.35,5.762-.207,3.807-1.346,5.3-4.194,5.3a2.75,2.75,0,0,1-1.761-.72c-.828-.669-.932-2.881-.88-3.961,4.091-.154,7.819-3.961,9.113-9.363l.052-.257-3.21-.669-.052.309C19.391,29.841,17.63,35.4,13.54,35.4H11.624c-4.091,0-5.851-5.556-6.162-6.688l-.052-.257-3.21.926.052.257c1.294,5.248,5.023,8.952,9.113,9.106,0,.977.052,4.27,1.45,5.453a5.668,5.668,0,0,0,3.676,1.595q6.369,0,6.835-7.1c.362-3.961,1.294-3.961,1.812-3.961h.052c1.036,0,1.45.463,1.5,1.7a4.081,4.081,0,1,0,6.369,3.4A4.177,4.177,0,0,0,28.867,35.757Zm1.709,4.219a1.66,1.66,0,0,1-1.657,1.646,1.544,1.544,0,0,1-1.657-1.646,1.571,1.571,0,0,1,1.657-1.646A1.545,1.545,0,0,1,30.575,39.976Z\" transform=\"translate(-1.061 -13.789)\"></path></g></svg></div><h2>Consultation</h2></a> <a class=\"{{((serviceSelected == \'labTest\') ? \'selected\' : \'\')}}\" ng-if=\"hospDetails.availableServices.labTest\" ng-click=\"selectService(\'labTest\')\"><div class=\"icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"938 -421 32 32\"><g transform=\"translate(937.979 -421)\"><path class=\"c1\" d=\"M31.18,23.078,23.159,10.349V5.472h1.3a3.012,3.012,0,0,0,3.2-2.736A3.012,3.012,0,0,0,24.463,0H7.442A2.926,2.926,0,0,0,4.377,2.736,2.97,2.97,0,0,0,7.442,5.472H8.877V10.29L.855,23.078a5.323,5.323,0,0,0,.2,6.007A7.521,7.521,0,0,0,7.116,32H24.985a7.521,7.521,0,0,0,6.065-2.914A5.436,5.436,0,0,0,31.18,23.078Zm-11.021-11.9,8.347,13.2a3.081,3.081,0,0,1-.065,3.331h0a4.238,4.238,0,0,1-3.456,1.665H7.051a4.238,4.238,0,0,1-3.456-1.665,2.956,2.956,0,0,1-.065-3.331l8.282-13.2a.5.5,0,0,0,.065-.3V5.532h8.217v5.353A2.378,2.378,0,0,1,20.159,11.182Z\" transform=\"translate(0)\"></path><path class=\"c2\" d=\"M23.334,22.746a1.475,1.475,0,0,0,1.239-1.9,1.96,1.96,0,0,0-2.283-1.071,1.475,1.475,0,0,0-1.239,1.9A1.932,1.932,0,0,0,23.334,22.746Z\" transform=\"translate(-7.284 -7.995)\"></path><path class=\"c2\" d=\"M25.551,15.454a1.428,1.428,0,0,0,1.174-1.784,1.755,1.755,0,0,0-2.087-1.011,1.428,1.428,0,0,0-1.174,1.784A1.669,1.669,0,0,0,25.551,15.454Z\" transform=\"translate(-8.131 -5.104)\"></path><path class=\"c2\" d=\"M8.934,35.627A1.847,1.847,0,0,0,9,37.768a2.71,2.71,0,0,0,2.217,1.071H26.868a2.71,2.71,0,0,0,2.217-1.071,1.964,1.964,0,0,0,.065-2.141L23.933,27.3H14.151ZM21.912,29.8a2.921,2.921,0,0,1,3.522,1.665A2.434,2.434,0,0,1,23.477,34.5a2.921,2.921,0,0,1-3.522-1.665A2.434,2.434,0,0,1,21.912,29.8Z\" transform=\"translate(-2.992 -11.062)\"></path></g></svg></div><h2>Lab Test</h2></a></div></div><table style=\"width:100%;\" ng-show=\"(serviceSelected == \'health_check\') && (!choosePacakageSelected)\"><tr><td style=\"width:780px; padding:15px;\"><table class=\"table table-hover package-listing\" style=\"width:100%\" ng-show=\"(serviceSelected == \'health_check\') && (!choosePacakageSelected)\"><thead><tr><th>Package <input type=\"text\" autocomplete=\"off\" placeholder=\"Search package\" class=\"form-control\" autofocus=\"\" ng-model=\"searchTextHealth\" style=\"width:100%\"></th><th>Gender<select style=\"width:100%;\" class=\"form-control\" ng-model=\"hcPackGender\" ng-change=\"searchCardsHealth(hcPackGender)\"><option value=\"N\">None</option><option value=\"M\">Male</option><option value=\"F\">Female</option></select></th><th class=\"text-center\">Tests</th><th class=\"text-center\">Consultation</th><th class=\"text-right\">Price</th><th></th></tr></thead><tbody><tr ng-repeat=\"category in hospDetails.hcPackages.displayCards | filter:searchTextHealth\" class=\"{{(category.packageId == details.selectedCard.packageId && viewPackDetails == true)?\'selected\':\'\'}}\"><td>{{category.packageName}}</td><td style=\"width: 16%;\">{{category.gender ==\'M\'?\'Male\':\'\'}}{{category.gender ==\'F\'?\'Female\':\'\'}}{{((category.gender !=\'M\') && (category.gender !=\'F\'))?\'Male & Female\':\'\'}}</td><td class=\"text-center\">{{category.packageTestCount}}</td><td class=\"text-center\">{{category.packageConsultationCount}}</td><td class=\"text-right\" style=\"width: 11%;\">Rs. {{category.price}}</td><td style=\"display:flex;\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"detailsClicked(category);\" style=\"margin-right: 5px;\">Details</button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"packageClicked(category)\">Choose</button></td></tr></tbody></table></td><td class=\"{{viewPackDetails ? \'test-list\':\'\'}}\" valign=\"top\"><div ng-if=\"((serviceSelected == \'health_check\') && viewPackDetails && !choosePacakageSelected)\"><ul><li><h4 tooltip-placement=\"left\" tooltip-trigger=\"mouseenter\" uib-tooltip-template=\"\'myTooltipConsult.html\'\">Consultation <span>{{details.selectedCard.packageConsultationCount}}</span></h4></li></ul><script type=\"text/ng-template\" id=\"myTooltipConsult.html\"><ol><li ng-repeat=\"subListConsult in details.consults[0].packageTestDetails\">{{subListConsult.testName}}</li></ol></script><hr><ul><li><h4>Tests <span>{{details.selectedCard.packageTestCount}}</span></h4></li><li ng-repeat=\"test in details.tests\" tooltip-placement=\"left\" tooltip-trigger=\"mouseenter\" uib-tooltip-template=\"\'myTooltip.html\'\">{{test.name}} <span>{{test.count}}</span></li></ul><script type=\"text/ng-template\" id=\"myTooltip.html\"><ol><li ng-repeat=\"sublist in test.packageTestDetails\">{{sublist.testName}}</li></ol></script><div style=\"padding: 15px;\"><button class=\"btn btn-default btn-sm\" ng-click=\"detailsClicked(details.selectedCard);\">Back</button></div></div></td></tr></table><table class=\"table table-hover\" style=\"max-width:800px; margin-top:15px;\" ng-if=\"(serviceSelected == \'consultation\') && (!choosePacakageSelected)\"><thead><tr><th>Doctor <input type=\"text\" autocomplete=\"off\" placeholder=\"Search doctor\" class=\"form-control\" autofocus=\"\" ng-show=\"(serviceSelected == \'consultation\') && (!choosePacakageSelected)\" ng-model=\"searchTextConsult\" style=\"width:100%\"></th><th>Expertise<select style=\"width:100%;\" class=\"form-control\" ng-model=\"selectedConsultationCategory\" ng-options=\"item for item in hospDetails.consultPackages.distinctTypes\" ng-change=\"searchCardsConsultation(selectedConsultationCategory)\"></select></th><th class=\"text-right\">Price</th><th></th></tr></thead><tbody><tr ng-repeat=\"speciality in hospDetails.consultPackages.displayCards | filter:searchTextConsult\"><td>Dr. {{speciality.doctorName}}</td><td>{{speciality.doctorSpecialization}}</td><td class=\"text-right\" style=\"width: 11%;\">Rs. {{speciality.price}}</td><td><button class=\"btn btn-primary btn-sm\" ng-click=\"packageClicked(speciality)\">Choose</button></td></tr></tbody></table><table style=\"width:100%;\" ng-show=\"(serviceSelected == \'labTest\') && (!choosePacakageSelected)\"><tr><td style=\"width:780px; padding:15px;\"><table class=\"table table-hover\" style=\"max-width:800px;\" ng-show=\"(serviceSelected == \'labTest\') && (!choosePacakageSelected)\"><thead><tr><th>Package <input type=\"text\" autocomplete=\"off\" placeholder=\"Search lab test package\" class=\"form-control\" autofocus=\"\" ng-model=\"searchTextLabTest\" style=\"width:100%\"></th><th class=\"text-right\">Price</th><th></th></tr></thead><tbody><tr ng-repeat=\"investigations in hospDetails.labTestPackages.displayCards | filter:searchTextLabTest | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage track by $index\"><td>{{investigations.packageName}}</td><td class=\"text-right\" style=\"width: 11%;\">Rs. {{investigations.price}}</td><td><button class=\"btn btn-primary btn-sm\" ng-click=\"labTestPackageClicked(investigations,$index)\" ng-disabled=\"investigations.selected\">Add +</button></td></tr></tbody></table></td><td class=\"test-list\" valign=\"top\" ng-if=\"selectedLabTestPackages.length\"><div ng-if=\"((serviceSelected == \'labTest\') && !choosePacakageSelected)\"><ul><li><h4>Selected Lab Test Packages<span>{{selectedLabTestPackages.length}}</span></h4></li><li ng-repeat=\"investigationPack in selectedLabTestPackages track by $index\">{{investigationPack.packageName}} <span>Rs.{{investigationPack.price}} <b style=\"cursor: pointer;margin-left: 15px;\" ng-click=\"removeLabTestPack($index)\">x</b></span></li></ul><div style=\"padding: 15px;\" ng-if=\"selectedLabTestPackages.length\"><button class=\"btn btn-primary btn-sm\" ng-click=\"packageClicked(selectedLabTestPackages[0]);\">Confirm</button> <button class=\"btn btn-default btn-sm\" ng-click=\"labTestPackageClear();\">Clear</button></div></div></td></tr></table><div style=\"margin-left: 370px;\" ng-if=\"(serviceSelected == \'labTest\') && (!choosePacakageSelected)\"><uib-pagination total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"maxSize\" ng-click=\"pageChange(currentPage)\" items-per-page=\"itemsPerPage\" class=\"pagination-sm pagination-centered\" boundary-links=\"true\" force-ellipses=\"true\"></uib-pagination></div><div class=\"book-timeslot\" ng-if=\"choosePacakageSelected && openDateTime\" style=\"margin-top:30px;\"><h3 class=\"\">Choose date and time</h3><div class=\"days-slot\"><ul><li class=\"{{ (packageSelected.availableSlots[dt.dayCount].slots).length ? \'\' : \'disabled\' }} {{dt.fullDate == packageSelected.date? \'selected\':\'\'}}\" ng-repeat=\"dt in nextSevenDays\" ng-click=\"daySlotClicked(packageSelected.availableSlots[dt.dayCount],dt.fullDate)\"><a href=\"\">{{dt.dayName}}<b>{{dt.date}}</b></a></li></ul></div><div class=\"time-slot\" ng-if=\"daySelected\"><ul><li class=\"{{slots == packageSelected.time && $index == timeSelectedIndex? \'selected\':\'\'}}\" ng-repeat=\"slots in packageSelected.dayTimeSlotArr track by $index\" ng-click=\"timeSlotClicked(slots,$index)\" ng-if=\"packageSelected.dayTimeSlotArr.length\"><a href=\"\">{{slots}}</a></li><li ng-if=\"!packageSelected.dayTimeSlotArr.length\"><a href=\"\" style=\"width:76rem; cursor:default;\" class=\"disabled\">No more slots available for the day.</a></li></ul></div></div></div><div class=\"search-step-one\" ng-if=\"!checkoutCalled && !isOrderCreated\"><fieldset ng-disabled=\"userValidated\" ng-if=\"!userValidated && timeSelectedShow\"><div class=\"row\"><form name=\"userDetails\"><div class=\"col-sm-12\"><h3 style=\"margin-top:50px; margin-bottom:0; border:0 none; color: #000000;\">Identify your patient using:</h3><h4 class=\"radioBtns\" style=\"margin:20px 0 0 0;\"><label for=\"phone\" style=\"margin-left:0;\"><input type=\"radio\" name=\"selection\" value=\"phone\" id=\"phone\" ng-model=\"identity\" checked=\"checked\" ng-change=\"radioBtnClicked()\"> <span class=\"{{identity==\'phone\' ? \'sel\':\'\'}}\">Contact No.</span></label> <label for=\"mail-id\"><input type=\"radio\" name=\"selection\" value=\"mail-id\" id=\"mail-id\" ng-model=\"identity\" ng-change=\"radioBtnClicked()\"> <span class=\"{{identity==\'mail-id\' ? \'sel\':\'\'}}\">Mail ID</span></label> <label for=\"employee-id\"><input type=\"radio\" name=\"selection\" value=\"employee-id\" id=\"employee-id\" ng-model=\"identity\" ng-change=\"radioBtnClicked()\" ng-disabled=\"true\"> <span class=\"{{identity==\'employee-id\' ? \'sel\':\'\'}}\">Employee ID</span></label></h4><div class=\"row inputInline\" ng-if=\"identity==\'phone\'\"><div class=\"form-group col-sm-3 p-r-0\"><label for=\"usr\">Mobile No:</label> <input type=\"text\" required=\"\" numbers-only=\"numbers-only\" autocomplete=\"off\" placeholder=\"Enter mobile No\" autofocus=\"\" class=\"form-control first\" maxlength=\"10\" name=\"number\" id=\"usr\" ng-model=\"customerDetailsObj.mobileNo\" ng-pattern=\"numberCheck\" ng-init=\"phoneFocus=true\" ng-focus=\"phoneFocus=true\" ng-blur=\"phoneFocus=false\" ng-change=\"inputValidate()\"><p style=\"color:red; margin-top:5px;\" ng-if=\"userDetails.number.$error.pattern && !phoneFocus\">Invalid number</p></div><div class=\"form-group col-sm-3 p-r-0 p-l-0\"><label for=\"usr\">Beneficiary Name:</label> <input type=\"text\" required=\"\" autocomplete=\"off\" placeholder=\"Enter member\'s name\" class=\"form-control\" id=\"usr\" ng-model=\"customerDetailsObj.name\" ng-change=\"inputValidate()\"></div><button type=\"submit\" class=\"btn btn-primary last\" ng-click=\"userValidate()\" ng-disabled=\"!customerDetailsObj.search_btn\" style=\"margin-top: 23px;\">Send OTP</button></div><div class=\"row inputInline\" ng-if=\"identity==\'mail-id\'\"><div class=\"form-group col-sm-3 p-r-0\"><label for=\"usr\">Email-Id:</label> <input type=\"text\" autocomplete=\"off\" placeholder=\"Enter email-id\" autofocus=\"\" class=\"form-control radius-right\" name=\"mail\" id=\"usr\" ng-model=\"customerDetailsObj.emailId\" ng-pattern=\"emailCheck\" ng-init=\"mailFocus=true\" ng-focus=\"mailFocus=true\" ng-blur=\"mailFocus=false\" ng-change=\"inputValidate()\"><p class=\"errorClass\" ng-if=\"userDetails.mail.$error.pattern && !mailFocus\">Invalid mail format. Please enter a correct mail-id.</p></div><div class=\"form-group col-sm-3 p-r-0 p-l-0\"><label for=\"usr\">Beneficiary Name:</label> <input type=\"text\" required=\"\" autocomplete=\"off\" placeholder=\"Enter member\'s name\" class=\"form-control\" id=\"usr\" ng-model=\"customerDetailsObj.name\" ng-change=\"inputValidate()\"></div><button type=\"submit\" class=\"btn btn-primary last\" ng-click=\"userValidate()\" ng-disabled=\"!customerDetailsObj.search_btn\" style=\"margin-top: 23px;\">Send OTP</button></div><div class=\"row inputInline\" ng-if=\"identity==\'employee-id\'\" ng-disabled=\"true\"><div class=\"form-group col-sm-3 p-r-0\"><label for=\"usr\">Employee ID:</label> <input type=\"text\" required=\"\" autocomplete=\"off\" placeholder=\"Enter member\'s employee ID\" autofocus=\"\" class=\"form-control first\" id=\"usr\" ng-model=\"customerDetailsObj.employeeCode\" ng-change=\"inputValidate()\"></div><div class=\"form-group col-sm-4 p-r-0 p-l-0\"><label for=\"usr\">Company Name:</label> <input type=\"text\" required=\"\" autocomplete=\"off\" placeholder=\"Enter member\'s organisation name\" class=\"form-control\" id=\"usr\" ng-model=\"customerDetailsObj.corporateName\" ng-change=\"inputValidate()\"></div><div class=\"form-group col-sm-3 p-r-0 p-l-0\"><label for=\"usr\">Date Of Birth:</label> <input type=\"date\" required=\"\" autocomplete=\"off\" class=\"form-control\" id=\"usr\" ng-model=\"customerDetailsObj.dob\" ng-change=\"inputValidate()\"></div><button type=\"submit\" class=\"btn btn-primary last\" ng-click=\"userValidate()\" ng-disabled=\"!customerDetailsObj.search_btn\">Send OTP</button></div><div ng-if=\"showSearchAgain\"><p class=\"m-b-0\" style=\"color: red;\">User not found / Wrong details entered. Please re-try with employee ID</p></div><div ng-if=\"customerDetailsObj.sendingOtpError\"><p>Error while sending otp please try sending it again</p></div></div></form></div></fieldset><div ng-if=\"customerDetailsObj.otpSent && !customerDetailsObj.otpVerified\"><h4 style=\"font-size:18px;\">Sent OTP to {{verified.userDetail.maskedMobileNo}} and {{verified.userDetail.maskedEmailId}}</h4><div class=\"form-group inputInline\"><label for=\"usr\">Enter the OTP:</label> <input type=\"text\" required=\"\" autocomplete=\"off\" numbers-only=\"numbers-only\" id=\"otpTextBox\" autofocus=\"\" placeholder=\"Six-Digit OTP\" class=\"form-control first\" minlength=\"6\" maxlength=\"6\" ng-model=\"customerDetailsObj.enteredOtp\" style=\"width:150px;display: inline-block;\"> <button type=\"submit\" class=\"btn btn-primary last\" ng-click=\"verifyOtp()\" ng-disabled=\"!customerDetailsObj.enteredOtp\" style=\"margin-top: -5px; margin-right:15px; margin-left: -5px;\">Verify OTP</button> <a ng-click=\"sendOtp()\" href=\"\">Resend OTP</a><p ng-if=\"customerDetailsObj.otpError\" style=\"margin-top: 15px; color: red;\">Please enter the correct OTP.</p></div></div><div ng-if=\"customerDetailsObj.otpVerified\"><h4 style=\"margin: 30px 0 0 0;\">Choose your patient</h4><div class=\"clearfix beneficiary-card\"><label class=\"{{((benef.patientName == patientDetails.patientName) ? \'selected\' : \'\')}} {{((packageSelected.packageValue.gender == \'M\' && benef.gender == \'F\') || (packageSelected.packageValue.gender == \'F\' && benef.gender == \'M\') ? \'disabled\':\'\')}}\" ng-repeat=\"benef in verified.benefDetails\"><input type=\"radio\" name=\"product\" value=\"{{benef.patientName}}\" class=\"card-input-element\" ng-click=\"updatePatientObj(benef,\'registered\')\" ng-disabled=\"{{((packageSelected.packageValue.gender == \'M\' && benef.gender == \'F\') || (packageSelected.packageValue.gender == \'F\' && benef.gender == \'M\') ? \'true\':\'false\')}}\"> {{benef.patientName}} <small ng-if=\"benef.relation\">{{benef.relation}},</small> <small ng-if=\"benef.age\">{{benef.age}} Yrs</small> <small ng-if=\"benef.gender\">{{benef.gender==\'M\'?\'Male\':benef.gender==\'F\'?\'Female\':\'\'}}</small><br><small ng-if=\"benef.maid\">Member ID:{{benef.maid}}</small> <span class=\"alert\" ng-if=\"(packageSelected.packageValue.gender == \'F\' && benef.gender == \'M\')\">Female specific package</span> <span class=\"alert\" ng-if=\"(packageSelected.packageValue.gender == \'M\' && benef.gender == \'F\')\">Male specific package</span></label> <label ng-if=\"!otherPatientClickedBool\"><input type=\"radio\" name=\"product\" class=\"card-input-element\" ng-click=\"otherCardClicked()\"> Others <small>Select to enter patient<br>details manually</small></label></div><div class=\"row inputInline\" ng-if=\"otherPatientClickedBool && !verified.patientSelected\"><div class=\"form-group col-sm-3 p-r-0\"><label for=\"usr\">Patient Name:</label> <input type=\"text\" autocomplete=\"off\" placeholder=\"Enter patient name\" class=\"form-control first\" autofocus=\"\" ng-model=\"otherPatient.patientName\" ng-change=\"othersInputValidate()\"></div><div class=\"form-group col-sm-3 p-l-0 p-r-0\"><label for=\"usr\">Gender:</label><select name=\"gender\" class=\"form-control radius-right\" ng-model=\"otherPatient.gender\" ng-change=\"othersInputValidate()\"><option value=\"\" selected=\"\">Choose</option><option value=\"M\" ng-disabled=\"(packageSelected.packageValue.gender == \'F\')\">Male</option><option value=\"F\" ng-disabled=\"(packageSelected.packageValue.gender == \'M\')\">Female</option></select></div><div class=\"form-group col-sm-3 p-l-0 p-r-0\"><label for=\"usr\">Date Of Birth:</label> <input type=\"date\" required=\"\" autocomplete=\"off\" class=\"form-control border-0\" ng-model=\"otherPatient.dob\" ng-change=\"othersInputValidate()\"></div><div class=\"form-group col-sm-3 p-r-0 p-l-0\"><label for=\"usr\">Relation:</label> <input type=\"text\" autocomplete=\"off\" placeholder=\"Enter relation\" class=\"form-control first\" ng-model=\"otherPatient.relation\" ng-change=\"othersInputValidate()\"></div><button type=\"submit\" class=\"btn btn-primary last\" ng-click=\"addPatientManual()\" ng-disabled=\"!otherPatient.submitBtn\" style=\"margin-top: 23px; margin-left:10px\">Update Patient</button></div><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"checkout()\" ng-disabled=\"!choosePacakageSelected && !verified.patientSelected && !timeSelected\" ng-if=\"verified.patientSelected\" style=\"margin-top:25px\">Confirm beneficiary</button></div></div><div class=\"bookpackage-step-three\" ng-if=\"checkoutCalled && !isOrderCreated\"><div class=\"payment-summary clearfix\" ng-if=\"checkoutCalled && !isOrderCreated\"><h3>Payment summary</h3><table class=\"table\" style=\"width:400px;\"><tr><td ng-if=\"serviceSelected == \'health_check\'\">Package price</td><td ng-if=\"serviceSelected == \'consultation\'\">Consultation Charges</td><td ng-if=\"serviceSelected == \'labTest\'\">Lab Test Charges</td><td class=\"text-right\">{{paymentObj.totalAmt}}</td></tr><tr><td style=\"font-size:12px; padding-top:20px;\"><span style=\"font-weight:bold;\">Deductions (-)</span></td><td></td></tr><tr><td>Medical Benefits</td><td class=\"text-right\">- {{paymentObj.walletAmt}}</td></tr><tr class=\"hilight\"><td>Final Amount Payable</td><td class=\"text-right\">Rs. {{paymentObj.customerPayableAmt}}</td></tr></table><a href=\"\" class=\"btn btn-primary\" style=\"margin-top: 15px;\" ng-click=\"paymentCalled()\" ng-if=\"paymentObj.customerPayableAmt\">Send payment link to customer</a> <a href=\"\" class=\"btn btn-primary\" style=\"margin-top: 15px;\" ng-click=\"paymentCalled()\" ng-if=\"!paymentObj.customerPayableAmt\">Confirm</a></div></div><div class=\"order-summary clearfix\" ng-if=\"isOrderCreated\"><div class=\"text-center show-print\"><img src=\"/app/resources/images/logo-mediBuddy.png\" alt=\"\" style=\"width:180px; margin-bottom:30px;\"></div><h2 style=\"margin-bottom:0;\">Your order placed successfully</h2><p class=\"text-center\" style=\"margin-bottom:30px\">Appointment ID: {{createdOrder.orderNumber}}</p><p></p><p class=\"text-center\" style=\"font-size:18px;\">Dear <b>{{verified.userDetail.userName}}</b></p><hr><div class=\"email-box clearfix\" style=\"margin-bottom:30px;\"><p><small>Patient details</small><b>{{patientDetails.patientName}}</b><br><span style=\"font-size:13px;\"><span ng-if=\"patientDetails.relation\">{{patientDetails.relation}},</span> <span ng-if=\"patientDetails.gender\">{{patientDetails.gender==\'M\'?\'Male\':patientDetails.gender==\'F\'?\'Female\':\'\'}},</span> <span ng-if=\"patientDetails.age\">{{patientDetails.age}} Years</span></span></p><hr><p><small>Hospital details</small> <b>{{hospDetails.hospName}}</b><br><span style=\"font-size:13px;\">{{hospDetails.hospAddress}},{{hospDetails.hospCity}} - {{hospDetails.pincode}}</span></p><hr><p style=\"margin-bottom:0;\"><small>Appointment Date &amp; Time</small> <b>{{paymentObject.serviceName}}</b><br><span style=\"font-size:13px;\">{{paymentObject.appointmentDatetime}}</span></p></div><hr><h3>{{paymentObj.customerPayableAmt?\'Awaiting Payment\' : \'Payment summary\'}}</h3><table class=\"table\" style=\"width:100%;font-size:13px;\"><tr><td ng-if=\"serviceSelected == \'health_check\'\">Package price :</td><td ng-if=\"serviceSelected == \'consultation\'\">Consultation charges :</td><td ng-if=\"serviceSelected == \'labTest\'\">Lab Test charges :</td><td class=\"text-right\">{{paymentObj.totalAmt}}</td></tr><tr><td style=\"font-size:12px; padding-top:20px;\"><span style=\"font-weight:bold;\">Deductions (-)</span></td><td></td></tr><tr><td>Medical Benefits</td><td class=\"text-right\">- {{paymentObj.walletAmt}}</td></tr><tr class=\"hilight\"><td>Amount to be Paid</td><td class=\"text-right\">Rs. {{paymentObj.customerPayableAmt}}</td></tr></table><p class=\"print-hide\" style=\"font-size:13px;\" ng-if=\"isOrderCreated && paymentObj.customerPayableAmt\">Payment link sent to {{verified.userDetail.maskedMobileNo}} and {{verified.userDetail.maskedEmailId}} <a href=\"\" class=\"btn btn-default\" ng-if=\"false\">Resend</a></p><a href=\"\" class=\"btn btn-primary print-hide\" style=\"margin-top: 15px;\" ng-click=\"print()\">Print</a></div></div><div class=\"walkin-cashless\" ng-if=\"(!hospDetails.availableServices.healthChecks && !hospDetails.availableServices.consultation && !hospDetails.availableServices.labTest) && serviceCallFinish\" style=\"font-size: 13px;font-weight: 600;text-align: center;\">Configure your profile today to enable OPD Cashless feature<br><span style=\"font-weight: 500;\">Need assistance in configuring your hospital profile? Write to <a href=\"mailto:medibuddysupport@mahs.in\">medibuddysupport@mahs.in</a></span></div></div>");
$templateCache.put("app/components/newAdmissionForm/hdfcErgo/hdfcNewAdmissionForm.html","<div class=\"chat-content\"><ng-form id=\"myForm\" novalidate=\"\" name=\"signup_form\"><h3><button class=\"btn btn-default pull-right\" ng-if=\"source !== \'preClaim\'\" ng-click=\"searchAgain()\" style=\"margin-top:-14px;background-color: #ccc;\">Search Again</button> <button type=\"submit\" style=\"margin-top:-14px;margin-right: 5px;\" class=\"btn btn-primary pull-right\" id=\"newAdmissionButton\" ng-click=\"source==\'preClaim\'?preClaimInfoRelatedMethods.submitPreClaimPreauthForm():preauthFormAction.submitPreauthForm()\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR) || (isdod ||isdoa) || isProcessing\">Submit New Admission</button> Customer details</h3><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"patientFirstName\">Full name <span class=\"text-danger\">*</span> <span class=\"textErrorMsg\" ng-show=\"signup_form.patientFirstName.$dirty && signup_form.patientFirstName.$invalid\">Your name is required.</span></label> <input name=\"patientFirstName\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Patient full name\" ng-model=\"form.fullname\" required=\"\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"contactNum\">Mobile No. <span class=\"text-danger\">*</span> <span class=\"textErrorMsg\" ng-show=\"signup_form.contactNum.$error.pattern || (signup_form.contactNum.$dirty && signup_form.contactNum.$invalid) || signup_form.contactNum.$error.number || signup_form.contactNum.$error.minlength || signup_form.contactNum.$error.maxlength\">Enter valid mobile number</span></label> <input name=\"contactNum\" autocomplete=\"off\" type=\"text\" class=\"form-control\" ng-pattern=\"/^((7|8|9)).{9}$/\" ng-change=\"mobileValidation(form.mobile)\" numbers-only=\"numbers-only\" placeholder=\"Enter mobile number\" ng-model=\"form.mobile\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"emailId\">Email ID <span class=\"textErrorMsg\" ng-show=\"signup_form.EmailId.$error.pattern || (signup_form.EmailId.$dirty && signup_form.EmailId.$invalid)\">Enter valid email ID</span></label> <input name=\"EmailId\" autocomplete=\"off\" type=\"text\" class=\"form-control\" ng-pattern=\"/^(([^<>()[\\]\\\\.,;:\\s@\\\']+(\\.[^<>()[\\]\\\\.,;:\\s@\\\']+)*)|(\\\'.+\\\'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\" placeholder=\"Enter EmailId\" ng-model=\"form.emailId\" ng-change=\"pushToProperties(\'emailId\',form.emailId)\"></div></div><div class=\"col-md-3\" ng-if=\"!form.isgovtscheme && admissionFromSearchFlag.hideSomeFields\"><div class=\"form-group\"><label for=\"policyno\">Policy No. <span ng-show=\"!(form.uniqueId.toString().length>0 || form.maid.toString().length>0||(form.employer.length>0 && form.empid.length>0))\"><span class=\"text-danger\">*</span></span></label> <input type=\"text\" id=\"policyno\" name=\"policynumber\" class=\"form-control\" placeholder=\"Enter policy number\" ng-model=\"form.policyno\" ng-required=\"!(form.uniqueId.toString().length>0||form.maid.toString().length>0||(form.employer.length>0 && form.empid.length>0))\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"employer\">Corporate name <span ng-show=\"!(form.uniqueId.toString().length>0 || form.maid.toString().length >0||form.policyno.length>0)\"><span class=\"text-danger\">*</span></span></label> <input name=\"employer\" autocomplete=\"off\" id=\"preauthemployer\" type=\"text\" class=\"form-control\" placeholder=\"Enter corporate name\" ng-model=\"form.employer\" ng-required=\"!(form.uniqueId.toString().length>0 || form.maid.toString().length >0||form.policyno.length>0)\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"empid\">Employee ID <span ng-show=\"!(form.maid.toString().length >0||form.policyno.length>0 || form.patientUniqeId.toString().length>0)\"><span class=\"text-danger\">*</span></span></label> <input name=\"empid\" autocomplete=\"off\" id=\"preauthempid\" type=\"text\" class=\"form-control\" placeholder=\"Enter employee ID\" ng-model=\"form.empid\" ng-required=\"!(form.maid.toString().length >0||form.policyno.length>0 || form.patientUniqeId.toString().length>0)\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"ipnumber\"><span>Inpatient No.</span></label> <input name=\"ipnumber\" autocomplete=\"off\" type=\"text\" class=\"form-control\" placeholder=\"Enter IP no. for faster search and reconciliation\" ng-model=\"form.ipnumber\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"patientUniqeId\">Member ID <span ng-show=\"!(form.policyno.length>0||(form.employer.length>0 && form.empid.length>0))\"><span class=\"text-danger\">*</span></span> <span class=\"textErrorMsg\" ng-show=\"(signup_form.patientUniqeId.$dirty && signup_form.patientUniqeId.$invalid) || signup_form.patientUniqeId.$error.number\">Enter valid Member Id</span></label> <input name=\"patientUniqeId\" autocomplete=\"off\" id=\"preauthmaid\" min=\"0\" class=\"form-control\" placeholder=\"Enter member Id\" ng-model=\"form.uniqueId\" ng-required=\"!(form.policyno.length>0||(form.employer.length>0 && form.empid.length>0))\"></div></div></div><h3>Hospitalization details</h3><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"docName\">Doctor name <span class=\"text-danger\">*</span></label> <input name=\"docName\" autocomplete=\"off\" focus-element=\"onFocus\" type=\"text\" maxlength=\"5000\" ng-keyup=\"$event.keyCode == 13 &amp;&amp; showExplorePage(keyWords)\" placeholder=\"Type doctor name\" required=\"\" ng-click=\"getkeywords()\" ng-model=\"form.docname\" uib-typeahead=\"condition.doctorName for condition in doctorDetails | filter:$viewValue | limitTo:8\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelectDoctor($item, $model, $label)\" ng-change=\"pushToProperties(\'docName\',form.docname)\" class=\"search-filter form-control src-health-need\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Registration No. <span class=\"text-danger\">*</span></label> <input type=\"text\" ng-model=\"form.docRegNo\" name=\"docRegNo\" class=\"form-control\" ng-change=\"pushToProperties(\'docRegNo\',form.docRegNo)\" required=\"\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Qualification <span class=\"text-danger\">*</span></label> <input type=\"text\" ng-model=\"form.docQualification\" name=\"docQualification\" class=\"form-control\" ng-change=\"pushToProperties(\'docQualification\',form.docQualification)\" required=\"\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Doctor mobile No.</label> <input type=\"text\" name=\"docMobileNo\" ng-model=\"form.docMobileNo\" class=\"form-control\" ng-change=\"pushToProperties(\'docMobileNo\',form.docMobileNo)\"></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group admision-type\"><label style=\"display:block;\">Admission Type :</label> <label class=\"radio-inline\" style=\"margin-left: 5px;\"><input type=\"radio\" name=\"rdoAdmissionType\" ng-model=\"form.admissionType\" value=\"1\" ng-change=\"pushToProperties(\'AdmissionType\',form.admissionType)\"> Emergency</label> <label class=\"radio-inline\" style=\"margin-left: 5px;\"><input type=\"radio\" name=\"rdoAdmissionType\" ng-model=\"form.admissionType\" value=\"5\" ng-change=\"pushToProperties(\'AdmissionType\',form.AdmissionType)\"> Planned</label> <label class=\"radio-inline\" style=\"margin-left: 5px;\"><input type=\"radio\" name=\"rdoAdmissionType\" ng-model=\"form.admissionType\" value=\"4\" ng-change=\"pushToProperties(\'AdmissionType\',form.AdmissionType)\"> Death</label></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"doa\">Date of admission <span class=\"text-danger\">*</span> <span class=\"textErrorMsg\" ng-show=\"(signup_form.doa.$dirty && signup_form.doa.$invalid) || signup_form.doa.$error.datetimelocal || isdoa\">Enter valid date of admission</span></label><div class=\"input-group\"><input name=\"doa\" id=\"datetimepicker\" placeholder=\"Select date of admission\" readonly=\"\" type=\"text\" class=\"form-control\" ng-change=\"dateOfAdmission(form.dod, \'doa\')\" uib-datepicker-popup=\"{{format}}\" ng-model=\"form.doa\" is-open=\"datePopup.doa\" datepicker-options=\"dateOptions2\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDoa()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"dod\">Date of discharge <span class=\"text-danger\">*</span> <span class=\"textErrorMsg\" ng-show=\"(signup_form.dod.$dirty && signup_form.dod.$invalid) || isdod\">Enter valid date of discharge</span></label><div class=\"input-group\"><input placeholder=\"Select date of discharge\" readonly=\"\" name=\"dod\" type=\"text\" id=\"dischargetimepicker\" class=\"form-control\" ng-change=\"dateOfAdmission(form.doa, \'dod\')\" uib-datepicker-popup=\"{{format}}\" ng-model=\"form.dod\" is-open=\"datePopup.dod\" datepicker-options=\"dateOptions1\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDod()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Date of first diagnosis <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input placeholder=\"Select date of Diagnosis\" readonly=\"\" name=\"HdfcfirstDiagnosisDate\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"form.firstDiagnosisDate\" is-open=\"datePopup.dateofDiagnosis\" datepicker-options=\"dateOptions2\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" ng-change=\"pushToProperties(\'dateOfFirstDiagnosis\',convertDate(form.firstDiagnosisDate))\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDateOfDiagnosis()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label>Ailment as per user <span class=\"text-danger\">*</span></label> <input type=\"text\" name=\"txtAilmentName\" class=\"form-control\" ng-model=\"form.ailmentAsPerUser\" ng-change=\"pushToProperties(\'AilmentAsPerUser\',form.ailmentAsPerUser)\" required=\"\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Differential diagnosis</label> <input type=\"text\" class=\"form-control\" name=\"txtDifferentialDiagnosis\" ng-model=\"form.diffDiagnosis\" ng-change=\"pushToProperties(\'DiffDiagnosis\',form.diffDiagnosis)\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"roomType\">Provided room type <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-model=\"form.memberroomType\" ng-change=\"pushToProperties(\'roomtype\',form.memberroomType.id)\" ng-options=\"item.value for item in payerRoomCategories\" ng-required=\"true\"><option value=\"\">Select room type</option></select></div></div></div><h5 style=\"font-weight: 700;\">Past history</h5><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"radio-inline\"><input type=\"radio\" name=\"rdoPastHistoryApplicable\" ng-model=\"form.isPastHistoryApplicable\" value=\"true\">Applicable</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"rdoPastHistoryApplicable\" ng-model=\"form.isPastHistoryApplicable\" value=\"false\">Not applicable</label></div></div><div class=\"col-md-3\" ng-if=\"form.isPastHistoryApplicable==\'true\'\"><div class=\"form-group\"><label>Ailment Category</label><select name=\"selAilmentCategory\" class=\"form-control\" ng-options=\"item.value for item in hdfcPastAilmentCategory\" ng-model=\"form.pastAilmentCategory\" ng-change=\"pushToProperties(\'pastAilmentCategory\',form.pastAilmentCategory.id)\"><option value=\"\">Select Ailment</option></select></div></div><div class=\"col-md-3\" ng-if=\"form.isPastHistoryApplicable==\'true\'\"><div class=\"form-group\"><label>Since Date</label><div class=\"input-group\"><input placeholder=\"Select date of past Ailment\" readonly=\"\" name=\"hdfcPastAilmentDate\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"form.pastAilmentDate\" is-open=\"datePopup.pastAilmentDate\" datepicker-options=\"dateOptions2\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" ng-change=\"pushToProperties(\'pastAilmentDate\',convertDate(form.pastAilmentDate))\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDateOfPastAilment()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-3\" ng-if=\"form.isPastHistoryApplicable==\'true\'\"><div class=\"form-group\"><label>Remarks</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.pastHistoryRemarks\" ng-change=\"pushToProperties(\'pastHistoryRemarks\',form.pastHistoryRemarks)\"></div></div></div><h5 style=\"font-weight: 700;\">Hospitalization due to</h5><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"checkbox-inline\" ng-repeat=\"obj in hdfcIllnessdueTo | orderBy : \'value\'\"><input type=\"checkbox\" ng-model=\"obj.isSelected\" ng-change=\"addHdfcIllnessDueTo(this)\">{{obj.value}}</label></div></div></div><h6 ng-if=\"findSelectedvalueInobject(\'Maternity\',hdfcIllnessdueTo)\">Maternity</h6><div ng-if=\"findSelectedvalueInobject(\'Maternity\',hdfcIllnessdueTo)\" class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"LMP\">LMP <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input placeholder=\"Select LMP\" readonly=\"\" name=\"hdfcLMP\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"form.maternityLMP\" is-open=\"datePopup.maternityLMP\" datepicker-options=\"dateOptions1\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" ng-change=\"pushToProperties(\'MaternityLMP\',convertDate(form.maternityLMP))\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openMaternityLMP()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"EDD\">EDD <span class=\"text-danger\">*</span></label><div class=\"input-group\"><input placeholder=\"Select EDD\" readonly=\"\" name=\"hdfcMaternityEDD\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"form.maternityEDD\" is-open=\"datePopup.maternityEDD\" datepicker-options=\"dateOptions1\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\" ng-change=\"pushToProperties(\'MaternityEDD\',convertDate(form.maternityEDD))\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openMaternityEDD()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label style=\"display:block;\">Type</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"rdoMaternityType\" value=\"normal\" ng-change=\"pushToProperties(\'MaternityType\',form.maternityType)\" ng-model=\"form.maternityType\">Normal Delivery</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"rdoMaternityType\" ng-change=\"pushToProperties(\'MaternityType\',form.maternityType)\" value=\"LSCS\" ng-model=\"form.maternityType\">LSCS</label></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label style=\"display:block;\">Obstetric History</label> G <input type=\"text\" class=\"form-control\" style=\"width:30px;display:inline;padding: 6px 2px;\" ng-change=\"pushToProperties(\'MaternityGravida\',form.obstetricHistoryG)\" ng-model=\"form.obstetricHistoryG\"> P <input type=\"text\" class=\"form-control\" style=\"width:30px;display:inline;padding: 6px 2px;\" ng-change=\"pushToProperties(\'MaternityPara\',form.obstetricHistoryP)\" ng-model=\"form.obstetricHistoryP\"> L <input type=\"text\" class=\"form-control\" style=\"width:30px;display:inline;padding: 6px 2px;\" ng-change=\"pushToProperties(\'MaternityLivingChildren\',form.obstetricHistoryL)\" ng-model=\"form.obstetricHistoryL\"> A <input type=\"text\" class=\"form-control\" style=\"width:30px;display:inline;padding: 6px 2px;\" ng-change=\"pushToProperties(\'MaternityAbortus\',form.obstetricHistoryA)\" ng-model=\"form.obstetricHistoryA\"></div></div></div><h6 ng-if=\"findSelectedvalueInobject(\'Accident\',hdfcIllnessdueTo)\">Accident</h6><div ng-if=\"findSelectedvalueInobject(\'Accident\',hdfcIllnessdueTo)\" class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label>Alcohal During Accident</label> <input type=\"checkbox\" ng-model=\"form.isAlcohalDuringAccident\" ng-change=\"pushToProperties(\'IsAlcohalDuringAccident\',form.isAlcohalDuringAccident)\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>MLC / FIR</label> <input type=\"checkbox\" ng-model=\"form.isMLCOrFIR\" ng-change=\"pushToProperties(\'isMLCOrFIR\',form.isMLCOrFIR)\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>MLC /FIR No</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.MLCorFIRNo\" ng-change=\"pushToProperties(\'MLCorFIRNo\',form.MLCorFIRNo)\"></div></div></div><h5 style=\"font-weight: 700;\">Anaesthesia</h5><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"checkbox-inline\" ng-repeat=\"obj in hdfcAnaesthesia\"><input type=\"checkbox\" ng-model=\"obj.isSelected\" ng-change=\"addHdfcAnaesthesia(this)\">{{obj.value}}</label></div></div></div><h5 style=\"font-weight: 700;\">Proposed line of treatment</h5><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"form.isConservative\" ng-change=\"pushToProperties(\'IsConservative\',form.isConservative)\"> Conservative management</label></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"form.isSurgical\" ng-change=\"pushToProperties(\'IsSurgical\',form.isSurgical);getPayerSurgeryMaster(form.isSurgical)\"> Surgical management</label></div></div></div><h6 ng-if=\"form.isConservative\">Conservative management</h6><div ng-if=\"form.isConservative\" class=\"row\"><div class=\"col-md-6\" ng-repeat=\"obj in hdfcConservativeManagement\"><div class=\"row\" ng-if=\"obj.name!=\'other\'\" style=\"padding-top: 5px;\"><div class=\"col-md-4\">{{obj.name}}</div><div class=\"col-md-4\"><div class=\"btn-group\"><label class=\"btn btn-info btn-sm\" value=\"inject\" ng-model=\"obj.value\" ng-change=\"addHdfcConservativeManagement(this)\" uib-btn-radio=\"\'inject\'\" style=\"padding: 2px 6px;\">inject</label> <label class=\"btn btn-info btn-sm\" value=\"oral\" ng-model=\"obj.value\" ng-change=\"addHdfcConservativeManagement(this)\" uib-btn-radio=\"\'Oral\'\" style=\"padding: 2px 6px;\">Oral</label></div></div><div ng-if=\"obj.name==\'other\'\" style=\"padding-top: 15px;\"><div class=\"col-md-4\">{{obj.name}}</div><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" ng-model=\"obj.value\"></div></div></div></div></div><h6 ng-if=\"form.isSurgical\">Surgical management</h6><div ng-if=\"form.isSurgical\" class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label>Surgery type</label><select class=\"form-control\" ng-model=\"form.surgeryType\" ng-change=\"getPayerSurgeryMaster(true,form.surgeryType.parentValue)\" ng-options=\"item.value for item in surgeryTypeMaster\"><option value=\"\">Select surgery type</option></select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Surgery name</label><select class=\"form-control\" ng-model=\"form.surgeryName\" ng-change=\"getPayerSurgeryMaster(true,form.surgeryName.parentValue)\" ng-options=\"item.value for item in surgeryNameMaster\"><option value=\"\">Select surgery name</option></select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Specific surgery</label><select class=\"form-control\" ng-model=\"form.specificSurgery\" ng-change=\"pushToProperties(\'SpecificSurgery\',form.specificSurgery.value)\" ng-options=\"item.value for item in specificSurgeryMaster\"><option value=\"\">Select specific surgery</option></select></div></div><div class=\"col-md-3\"><label>Surgery Date</label><div class=\"input-group\"><input name=\"surgeryDate\" id=\"datetimepicker\" placeholder=\"Select date of Surgery\" readonly=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"form.surgeryDate\" is-open=\"datePopup.surgeryDate\" datepicker-options=\"dateOptions2\" ng-change=\"pushToProperties(\'SurgeryDate\',convertDate(form.surgeryDate))\" required=\"\" show-button-bar=\"false\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDateOfSurgery()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><h5 style=\"font-weight:700;\">Expenses estimation</h5><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Expense type</label><select class=\"form-control\" ng-model=\"form.hdfcExpenseType\" ng-options=\"item.value for item in hdfcExpenses\"><option value=\"\">Select expense type</option></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Estimated amount</label> <input type=\"number\" class=\"form-control\" ng-model=\"form.estimateExpenseAmount\"></div></div><div class=\"col-md-4\"><div class=\"form-group\" style=\"margin-top:22px;\"><button class=\"btn btn-primary btn-sm\" ng-click=\"addHdfcExpense(form.hdfcExpenseType,form.estimateExpenseAmount)\">Add Expense</button></div></div></div><div class=\"row\" ng-if=\"form.hdfcExpensesList && form.hdfcExpensesList.length>0\"><div class=\"col-md-8\"><table class=\"table table-bordered\"><tr><th>Expense type</th><th>Amount</th><th>Action</th></tr><tr ng-repeat=\"item in form.hdfcExpensesList\"><td>{{item.name}}</td><td>{{item.amount}}</td><td><button class=\"btn btn-danger btn-xs\" ng-click=\"removehdfcBillExpenses($index)\">Remove</button></td></tr></table></div></div><h5 style=\"font-weight:700;\">Upload documents <small style=\"font-weight:normal;font-size: 12px; display: inline-block; padding: 5px;color: #db5e5e;\">Maximum file upload limit is 15 MB. At least one document need to submit.</small> <button class=\"btn btn-xs btn-default\" ng-click=\"preauthFormAction.downloadPrefilledPreauthForm(\'preauthform\')\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR) || (isdod ||isdoa)\">Download Pre-filled form</button></h5><div id=\"fileupload\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Signed pre authorization form</label><mb-file-upload action=\"action\" attachmenttype=\"\'9\'\" file-fn=\"fileFn(arg,attachmenttype)\"></mb-file-upload></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">ID Proof <a tooltip-placement=\"top\" uib-tooltip=\"Driving License, Voter ID card, Corporate Employee ID, Pan car, Passport\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a></label><mb-file-upload action=\"action\" attachmenttype=\"\'4\'\" file-fn=\"fileFn(arg,attachmenttype)\"></mb-file-upload></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Diagnostic reports <a tooltip-placement=\"top\" uib-tooltip=\"Bio Chemistry reports, Haematology reports, Microbiology reports, Neurology reports, Pathology reports, Radiology reports\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a></label><mb-file-upload action=\"action\" attachmenttype=\"\'13\'\" file-fn=\"fileFn(arg,attachmenttype)\"></mb-file-upload></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"diagnosis\">Other relevant documents</label><mb-file-upload action=\"action\" attachmenttype=\"\" file-fn=\"fileFn(arg,attachmenttype)\"></mb-file-upload></div></div></div><div class=\"row\" ng-if=\"storeFiles.length >0\"><div class=\"col-md-12\"><div class=\"label label-info\" ng-repeat=\"item in storeFiles\" style=\"text-overflow: ellipsis;overflow: hidden;display: block;padding: 8px 20px 8px 6px;position: relative;text-align: left;width: 100%;font-weight: normal;margin-bottom: 3px;margin-top: 6px;color: black;background-color: #eeeeee;\"><a ng-click=\"downloadAttachment(item.downloadURL)\">{{item.fileName}}</a> <a ng-click=\"removeFiles(item)\" style=\"position:absolute;right: 6px; color:#1f1c1c; text-decoration:none; cursor:pointer;\"><i style=\"color: red;\" class=\"fa fa-close\"></i></a></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><button type=\"submit\" class=\"btn btn-primary start pull-right\" id=\"newAdmissionButton\" style=\"margin-bottom: 25px;margin-top: 20px;\" ng-click=\"source==\'preClaim\'?preClaimInfoRelatedMethods.submitPreClaimPreauthForm():HdfcFormAction.submitPreauthForm()\" ng-disabled=\"(signup_form.$invalid && !PreAuthForIR) || (isdod ||isdoa) || isProcessing\"><span>Submit New Admission</span></button></div></div></div></ng-form></div>");
$templateCache.put("app/components/otherPayer/otherDischarge/otherDischarge.html","<form name=\"dischargeSub\" novalidate=\"\"><p class=\"bg-info\">Components mentioned below are optional.Breakup will help us process your discharge case faster.</p><div class=\"table-responsive\"><div class=\"table table-hover\"><div class=\"form-group pull-in clearfix\"><div class=\"col-md-6\"><label>Date Of Admission</label> <input name=\"doa\" id=\"datetimepickerDoa\" type=\"date\" class=\"form-control\" ng-model=\"discharge.doa\" required=\"\"></div><div class=\"col-md-6 pull-right\"><label>Date Of Discharge</label> <input name=\"dod\" id=\"datetimepicker1\" type=\"date\" class=\"form-control\" ng-model=\"discharge.dod\" required=\"\"></div></div><div><div class=\"form-group pull-in clearfix\"><div class=\"col-md-6\"><label>Room Rent Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Includes Room rent, ICU Charges, Nursing charges, Duty Doctor fee, Monitor charges\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.roomrent\" name=\"roomrent\" class=\"form-control\" placeholder=\"Enter Roomrent\" ng-required=\"true\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.roomrent.$dirty && dischargeForm.roomrent.$error.required\">Required</span></div><div class=\"col-md-6 pull-right\"><label>Diagnostic Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Includes charges from Bio Chemistry, Haematology, Microbiology, Neurology, Pathology, Radiology\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.investigation\" name=\"investigation\" class=\"form-control\" placeholder=\"Enter Investigation\" ng-required=\"true\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.investigation.$dirty && dischargeForm.investigation.$error.required\">Required</span></div></div><div class=\"form-group pull-in clearfix\"><div class=\"col-md-6\"><label>Professional Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Incudes Procedure charges, Surgeon charges, Anaesthetist charges, Visit charges, OT rent, OT equipment charges, OT Drugs & Consumables\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.consultation\" name=\"consultation\" class=\"form-control\" placeholder=\"Enter Consultation\" ng-required=\"true\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.consultation.$dirty && dischargeForm.consultation.$error.required\">Required</span></div><div class=\"col-md-6 pull-right\"><label>Pharmacy Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Includes Pharmacy charges and consumables\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.pharmacy\" name=\"pharmacy\" class=\"form-control\" placeholder=\"Enter Pharmacy\" ng-required=\"true\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.pharmacy.$dirty && dischargeForm.pharmacy.$error.required\">Required</span></div></div></div><div class=\"form-group pull-in clearfix\"><div class=\"col-md-6\"><label>Other Charges</label> <a tooltip-placement=\"top\" uib-tooltip=\"Includes Implant charges, Non-Medical Expenses, other charges\" style=\"margin-left:10px\"><i class=\"fa fa-question-circle\"></i></a> <input type=\"text\" numbers-only=\"\" ng-model=\"discharge.others\" name=\"others\" class=\"form-control\" placeholder=\"Others\" ng-required=\"true\" ng-keyup=\"calcDischargeTotal()\"> <span class=\"mandatory red\" ng-show=\"dischargeForm.pharmacy.$dirty && dischargeForm.pharmacy.$error.required\">Required</span></div><div class=\"col-md-6 pull-right\"><label>Final Claimed Amount</label> <input ng-init=\"discharge.total=0\" ng-class=\"{\'border-warning\':(discharge.total <= 0 || discharge.total == null)}\" name=\"dischargeTotal\" class=\"form-control\" type=\"text\" ng-model=\"discharge.total\" readonly=\"\"> <span ng-show=\"(discharge.total <= 0 || discharge.total == null)\"><small><em>Final bill cannot be 0 . Please enter a value in any of above fields.</em></small></span></div></div></div></div><label for=\"enhance-remarks\">Notes for discharge (optional)</label> <textarea required=\"\" placeholder=\"Enter notes for discharge\" name=\"enhance-remarks\" ng-model=\"discharge.remarks\" class=\"form-control\" id=\"discharge-remarks\" cols=\"30\" rows=\"3\"></textarea><hr><div class=\"row\"><div class=\"col-md-12\"><h4 style=\"color: black;\">Attach Final Bill & Discharge Summary</h4><div ngf-drop=\"uploadAllFiles(this)\" ngf-select=\"uploadAllFiles(this)\" ng-model=\"files\" class=\"drop-box\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*,application/pdf\">Drop pdfs or images here or click to upload</div><div class=\"row\" ng-if=\"file && file.length>0\"><div class=\"col-md-12\"><ul class=\"tagsList\" style=\"font-size: small;\"><li class=\"closeBtn\" ng-repeat=\"fac in file track by $index\">{{fac.fileName}}<div id=\"{{fac.progressDivId}}\" class=\"progress\" ng-show=\"fac.progressBar >= 0 && fac.progressBar<100\"></div><a href=\"\" ng-show=\"fac.progressBar==100\" ng-click=\"RemoveEmail($index)\"><i class=\"fa fa-close\"></i></a></li></ul></div></div></div></div><hr><a ng-disabled=\"dischargeSub.$invalid || !file || (file && file.length==0) || (file && file.length==1 && !file[0].model)\" ng-hide=\"isFlag.btnSubmitflag\" id=\"missingbutton\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"isFlag.btnSubmitflag = true;submitDischarge()\">Submit</a> <a ng-show=\"isFlag.btnSubmitflag\" class=\"btn btn-success pull-right\" ng-disabled=\"true\"><i class=\"fa fa-refresh fa-spin slow-spin\"></i> Submitting...</a> <button type=\"button\" data-dismiss=\"modal\" class=\"btn\" ng-disabled=\"isFlag.btnSubmitflag\" ng-click=\"$parent.hideModal()\">Cancel</button></form>");
$templateCache.put("app/components/pagination/typeAhead/typeAhead.html","<style>\n\nli.dropdown.dropdow-newCss.open {\n    position: static;\n    margin:5px;\n}\nli.dropdown.dropdow-newCss.open .dropdown-menu {\n     width: 100%; text-align: center; left:0; right:0;\n}\nli.dropdown.dropdow-newCss .dropdown-menu {\n    cursor: pointer;\n    padding: 10px;   \n}\nli.dropdown.dropdow-newCss .dropdown-menu>li {\n	margin:0px 0;\n	padding:5px;\n	border-radius:3px;\n}\nli.dropdown.dropdow-newCss .dropdown-menu>li:hover {\n	color: #fff;\n    background: #939393;\n}\n</style><div class=\"dropdown dropdow-newCss\"><input type=\"text\" class=\"form-control input-xlarge dropdown-toggle\" ng-model=\"model\" placeholder=\"{{prompt}}\" ng-keydown=\"selected=false\" data-toggle=\"dropdown\"><ul ng-hide=\"!model.length || selected\" class=\"item dropdown-menu\" style=\"cursor:pointer\" ng-class=\"{active:isCurrent($index)}\" ng-mouseenter=\"setCurrent($index)\"><li class=\"title\" ng-repeat=\"item in items | filter:model | limitTo: 10\" ng-click=\"typeaheadClick(item)\">{{item[title]}}<span ng-if=\"item[subtitle]\">,</span> {{item[subtitle]}}<span ng-if=\"item[subtitle2]\">,</span> {{item[subtitle2]}} <span ng-if=\"item[itemId]\">-</span> {{item[itemId]}}</li></ul></div>");}]);